"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "react-dom"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.FileViewer = t(require("react"), require("react-dom")) : e.FileViewer = t(e.React, e.ReactDOM);
}(this, function (e, t) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var i = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.i = function (e) {
      return e;
    }, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 162);
  }([function (e, t, r) {
    "use strict";

    (function (t, n) {
      function i() {
        try {
          var e = I;
          return I = null, e.apply(this, arguments);
        } catch (e) {
          return R.e = e, R;
        }
      }
      function a(e) {
        return I = e, i;
      }
      function o(e) {
        return null == e || !0 === e || !1 === e || "string" == typeof e || "number" == typeof e;
      }
      function s(e) {
        return "function" == typeof e || "object" == _typeof(e) && null !== e;
      }
      function l(e) {
        return o(e) ? new Error(v(e)) : e;
      }
      function c(e, t) {
        var r,
          n = e.length,
          i = new Array(n + 1);
        for (r = 0; r < n; ++r) i[r] = e[r];
        return i[r] = t, i;
      }
      function u(e, t, r) {
        if (!T.isES5) return {}.hasOwnProperty.call(e, t) ? e[t] : void 0;
        var n = Object.getOwnPropertyDescriptor(e, t);
        return null != n ? null == n.get && null == n.set ? n.value : r : void 0;
      }
      function h(e, t, r) {
        if (o(e)) return e;
        var n = {
          value: r,
          configurable: !0,
          enumerable: !1,
          writable: !0
        };
        return T.defineProperty(e, t, n), e;
      }
      function f(e) {
        throw e;
      }
      function d(e) {
        try {
          if ("function" == typeof e) {
            var t = T.names(e.prototype),
              r = T.isES5 && t.length > 1,
              n = t.length > 0 && !(1 === t.length && "constructor" === t[0]),
              i = B.test(e + "") && T.names(e).length > 0;
            if (r || n || i) return !0;
          }
          return !1;
        } catch (e) {
          return !1;
        }
      }
      function p(e) {
        function t() {}
        t.prototype = e;
        for (var r = 8; r--;) new t();
        return e;
      }
      function m(e) {
        return D.test(e);
      }
      function g(e, t, r) {
        for (var n = new Array(e), i = 0; i < e; ++i) n[i] = t + i + r;
        return n;
      }
      function v(e) {
        try {
          return e + "";
        } catch (e) {
          return "[no string representation]";
        }
      }
      function b(e) {
        return null !== e && "object" == _typeof(e) && "string" == typeof e.message && "string" == typeof e.name;
      }
      function y(e) {
        try {
          h(e, "isOperational", !0);
        } catch (e) {}
      }
      function w(e) {
        return null != e && (e instanceof Error.__BluebirdErrorTypes__.OperationalError || !0 === e.isOperational);
      }
      function x(e) {
        return b(e) && T.propertyIsWritable(e, "stack");
      }
      function _(e) {
        return {}.toString.call(e);
      }
      function S(e, t, r) {
        for (var n = T.names(e), i = 0; i < n.length; ++i) {
          var a = n[i];
          if (r(a)) try {
            T.defineProperty(t, a, T.getDescriptor(e, a));
          } catch (e) {}
        }
      }
      function C(e) {
        return j ? n.env[e] : void 0;
      }
      function E() {
        if ("function" == typeof Promise) try {
          var e = new Promise(function () {});
          if ("[object Promise]" === {}.toString.call(e)) return Promise;
        } catch (e) {}
      }
      function A(e, t) {
        return e.bind(t);
      }
      var T = r(36),
        k = "undefined" == typeof navigator,
        R = {
          e: {}
        },
        I,
        M = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== t ? t : void 0 !== this ? this : null,
        O = function O(e, t) {
          function r() {
            this.constructor = e, this.constructor$ = t;
            for (var r in t.prototype) n.call(t.prototype, r) && "$" !== r.charAt(r.length - 1) && (this[r + "$"] = t.prototype[r]);
          }
          var n = {}.hasOwnProperty;
          return r.prototype = t.prototype, e.prototype = new r(), e.prototype;
        },
        P = function () {
          var e = [Array.prototype, Object.prototype, Function.prototype],
            t = function t(_t2) {
              for (var r = 0; r < e.length; ++r) if (e[r] === _t2) return !0;
              return !1;
            };
          if (T.isES5) {
            var r = Object.getOwnPropertyNames;
            return function (e) {
              for (var n = [], i = Object.create(null); null != e && !t(e);) {
                var a;
                try {
                  a = r(e);
                } catch (e) {
                  return n;
                }
                for (var o = 0; o < a.length; ++o) {
                  var s = a[o];
                  if (!i[s]) {
                    i[s] = !0;
                    var l = Object.getOwnPropertyDescriptor(e, s);
                    null != l && null == l.get && null == l.set && n.push(s);
                  }
                }
                e = T.getPrototypeOf(e);
              }
              return n;
            };
          }
          var n = {}.hasOwnProperty;
          return function (r) {
            if (t(r)) return [];
            var i = [];
            e: for (var a in r) if (n.call(r, a)) i.push(a);else {
              for (var o = 0; o < e.length; ++o) if (n.call(e[o], a)) continue e;
              i.push(a);
            }
            return i;
          };
        }(),
        B = /this\s*\.\s*\S+\s*=/,
        D = /^[a-z$_][a-z$_0-9]*$/i,
        L = function () {
          return "stack" in new Error() ? function (e) {
            return x(e) ? e : new Error(v(e));
          } : function (e) {
            if (x(e)) return e;
            try {
              throw new Error(v(e));
            } catch (e) {
              return e;
            }
          };
        }(),
        F = function F(e) {
          return T.isArray(e) ? e : null;
        };
      if ("undefined" != typeof Symbol && Symbol.iterator) {
        var N = "function" == typeof Array.from ? function (e) {
          return Array.from(e);
        } : function (e) {
          for (var t, r = [], n = e[Symbol.iterator](); !(t = n.next()).done;) r.push(t.value);
          return r;
        };
        F = function F(e) {
          return T.isArray(e) ? e : null != e && "function" == typeof e[Symbol.iterator] ? N(e) : null;
        };
      }
      var U = void 0 !== n && "[object process]" === _(n).toLowerCase(),
        j = void 0 !== n && void 0 !== n.env,
        z = {
          isClass: d,
          isIdentifier: m,
          inheritedDataKeys: P,
          getDataPropertyOrDefault: u,
          thrower: f,
          isArray: T.isArray,
          asArray: F,
          notEnumerableProp: h,
          isPrimitive: o,
          isObject: s,
          isError: b,
          canEvaluate: k,
          errorObj: R,
          tryCatch: a,
          inherits: O,
          withAppended: c,
          maybeWrapAsError: l,
          toFastProperties: p,
          filledRange: g,
          toString: v,
          canAttachTrace: x,
          ensureErrorObject: L,
          originatesFromRejection: w,
          markAsOriginatingFromRejection: y,
          classString: _,
          copyDescriptors: S,
          hasDevTools: "undefined" != typeof chrome && chrome && "function" == typeof chrome.loadTimes,
          isNode: U,
          hasEnvVariables: j,
          env: C,
          global: M,
          getNativePromise: E,
          domainBind: A
        };
      z.isRecentNode = z.isNode && function () {
        var e = n.versions.node.split(".").map(Number);
        return 0 === e[0] && e[1] > 10 || e[0] > 0;
      }(), z.isNode && z.toFastProperties(n);
      try {
        throw new Error();
      } catch (e) {
        z.lastLineError = e;
      }
      e.exports = z;
    }).call(t, r(13), r(5));
  }, function (e, t, r) {
    var n, i;
    (function () {
      var r = this,
        a = r._,
        o = {},
        s = Array.prototype,
        l = Object.prototype,
        c = Function.prototype,
        u = s.push,
        h = s.slice,
        f = s.concat,
        d = l.toString,
        p = l.hasOwnProperty,
        m = s.forEach,
        g = s.map,
        v = s.reduce,
        b = s.reduceRight,
        y = s.filter,
        w = s.every,
        x = s.some,
        _ = s.indexOf,
        S = s.lastIndexOf,
        C = Array.isArray,
        E = Object.keys,
        A = c.bind,
        _T = function T(e) {
          return e instanceof _T ? e : this instanceof _T ? void (this._wrapped = e) : new _T(e);
        };
      void 0 !== e && e.exports && (t = e.exports = _T), t._ = _T, _T.VERSION = "1.6.0";
      var k = _T.each = _T.forEach = function (e, t, r) {
        if (null == e) return e;
        if (m && e.forEach === m) e.forEach(t, r);else if (e.length === +e.length) {
          for (var n = 0, i = e.length; n < i; n++) if (t.call(r, e[n], n, e) === o) return;
        } else for (var a = _T.keys(e), n = 0, i = a.length; n < i; n++) if (t.call(r, e[a[n]], a[n], e) === o) return;
        return e;
      };
      _T.map = _T.collect = function (e, t, r) {
        var n = [];
        return null == e ? n : g && e.map === g ? e.map(t, r) : (k(e, function (e, i, a) {
          n.push(t.call(r, e, i, a));
        }), n);
      };
      var R = "Reduce of empty array with no initial value";
      _T.reduce = _T.foldl = _T.inject = function (e, t, r, n) {
        var i = arguments.length > 2;
        if (null == e && (e = []), v && e.reduce === v) return n && (t = _T.bind(t, n)), i ? e.reduce(t, r) : e.reduce(t);
        if (k(e, function (e, a, o) {
          i ? r = t.call(n, r, e, a, o) : (r = e, i = !0);
        }), !i) throw new TypeError(R);
        return r;
      }, _T.reduceRight = _T.foldr = function (e, t, r, n) {
        var i = arguments.length > 2;
        if (null == e && (e = []), b && e.reduceRight === b) return n && (t = _T.bind(t, n)), i ? e.reduceRight(t, r) : e.reduceRight(t);
        var a = e.length;
        if (a !== +a) {
          var o = _T.keys(e);
          a = o.length;
        }
        if (k(e, function (s, l, c) {
          l = o ? o[--a] : --a, i ? r = t.call(n, r, e[l], l, c) : (r = e[l], i = !0);
        }), !i) throw new TypeError(R);
        return r;
      }, _T.find = _T.detect = function (e, t, r) {
        var n;
        return I(e, function (e, i, a) {
          if (t.call(r, e, i, a)) return n = e, !0;
        }), n;
      }, _T.filter = _T.select = function (e, t, r) {
        var n = [];
        return null == e ? n : y && e.filter === y ? e.filter(t, r) : (k(e, function (e, i, a) {
          t.call(r, e, i, a) && n.push(e);
        }), n);
      }, _T.reject = function (e, t, r) {
        return _T.filter(e, function (e, n, i) {
          return !t.call(r, e, n, i);
        }, r);
      }, _T.every = _T.all = function (e, t, r) {
        t || (t = _T.identity);
        var n = !0;
        return null == e ? n : w && e.every === w ? e.every(t, r) : (k(e, function (e, i, a) {
          if (!(n = n && t.call(r, e, i, a))) return o;
        }), !!n);
      };
      var I = _T.some = _T.any = function (e, t, r) {
        t || (t = _T.identity);
        var n = !1;
        return null == e ? n : x && e.some === x ? e.some(t, r) : (k(e, function (e, i, a) {
          if (n || (n = t.call(r, e, i, a))) return o;
        }), !!n);
      };
      _T.contains = _T.include = function (e, t) {
        return null != e && (_ && e.indexOf === _ ? -1 != e.indexOf(t) : I(e, function (e) {
          return e === t;
        }));
      }, _T.invoke = function (e, t) {
        var r = h.call(arguments, 2),
          n = _T.isFunction(t);
        return _T.map(e, function (e) {
          return (n ? t : e[t]).apply(e, r);
        });
      }, _T.pluck = function (e, t) {
        return _T.map(e, _T.property(t));
      }, _T.where = function (e, t) {
        return _T.filter(e, _T.matches(t));
      }, _T.findWhere = function (e, t) {
        return _T.find(e, _T.matches(t));
      }, _T.max = function (e, t, r) {
        if (!t && _T.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.max.apply(Math, e);
        var n = -1 / 0,
          i = -1 / 0;
        return k(e, function (e, a, o) {
          var s = t ? t.call(r, e, a, o) : e;
          s > i && (n = e, i = s);
        }), n;
      }, _T.min = function (e, t, r) {
        if (!t && _T.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.min.apply(Math, e);
        var n = 1 / 0,
          i = 1 / 0;
        return k(e, function (e, a, o) {
          var s = t ? t.call(r, e, a, o) : e;
          s < i && (n = e, i = s);
        }), n;
      }, _T.shuffle = function (e) {
        var t,
          r = 0,
          n = [];
        return k(e, function (e) {
          t = _T.random(r++), n[r - 1] = n[t], n[t] = e;
        }), n;
      }, _T.sample = function (e, t, r) {
        return null == t || r ? (e.length !== +e.length && (e = _T.values(e)), e[_T.random(e.length - 1)]) : _T.shuffle(e).slice(0, Math.max(0, t));
      };
      var M = function M(e) {
        return null == e ? _T.identity : _T.isFunction(e) ? e : _T.property(e);
      };
      _T.sortBy = function (e, t, r) {
        return t = M(t), _T.pluck(_T.map(e, function (e, n, i) {
          return {
            value: e,
            index: n,
            criteria: t.call(r, e, n, i)
          };
        }).sort(function (e, t) {
          var r = e.criteria,
            n = t.criteria;
          if (r !== n) {
            if (r > n || void 0 === r) return 1;
            if (r < n || void 0 === n) return -1;
          }
          return e.index - t.index;
        }), "value");
      };
      var O = function O(e) {
        return function (t, r, n) {
          var i = {};
          return r = M(r), k(t, function (a, o) {
            var s = r.call(n, a, o, t);
            e(i, s, a);
          }), i;
        };
      };
      _T.groupBy = O(function (e, t, r) {
        _T.has(e, t) ? e[t].push(r) : e[t] = [r];
      }), _T.indexBy = O(function (e, t, r) {
        e[t] = r;
      }), _T.countBy = O(function (e, t) {
        _T.has(e, t) ? e[t]++ : e[t] = 1;
      }), _T.sortedIndex = function (e, t, r, n) {
        r = M(r);
        for (var i = r.call(n, t), a = 0, o = e.length; a < o;) {
          var s = a + o >>> 1;
          r.call(n, e[s]) < i ? a = s + 1 : o = s;
        }
        return a;
      }, _T.toArray = function (e) {
        return e ? _T.isArray(e) ? h.call(e) : e.length === +e.length ? _T.map(e, _T.identity) : _T.values(e) : [];
      }, _T.size = function (e) {
        return null == e ? 0 : e.length === +e.length ? e.length : _T.keys(e).length;
      }, _T.first = _T.head = _T.take = function (e, t, r) {
        if (null != e) return null == t || r ? e[0] : t < 0 ? [] : h.call(e, 0, t);
      }, _T.initial = function (e, t, r) {
        return h.call(e, 0, e.length - (null == t || r ? 1 : t));
      }, _T.last = function (e, t, r) {
        if (null != e) return null == t || r ? e[e.length - 1] : h.call(e, Math.max(e.length - t, 0));
      }, _T.rest = _T.tail = _T.drop = function (e, t, r) {
        return h.call(e, null == t || r ? 1 : t);
      }, _T.compact = function (e) {
        return _T.filter(e, _T.identity);
      };
      var _P = function P(e, t, r) {
        return t && _T.every(e, _T.isArray) ? f.apply(r, e) : (k(e, function (e) {
          _T.isArray(e) || _T.isArguments(e) ? t ? u.apply(r, e) : _P(e, t, r) : r.push(e);
        }), r);
      };
      _T.flatten = function (e, t) {
        return _P(e, t, []);
      }, _T.without = function (e) {
        return _T.difference(e, h.call(arguments, 1));
      }, _T.partition = function (e, t) {
        var r = [],
          n = [];
        return k(e, function (e) {
          (t(e) ? r : n).push(e);
        }), [r, n];
      }, _T.uniq = _T.unique = function (e, t, r, n) {
        _T.isFunction(t) && (n = r, r = t, t = !1);
        var i = r ? _T.map(e, r, n) : e,
          a = [],
          o = [];
        return k(i, function (r, n) {
          (t ? n && o[o.length - 1] === r : _T.contains(o, r)) || (o.push(r), a.push(e[n]));
        }), a;
      }, _T.union = function () {
        return _T.uniq(_T.flatten(arguments, !0));
      }, _T.intersection = function (e) {
        var t = h.call(arguments, 1);
        return _T.filter(_T.uniq(e), function (e) {
          return _T.every(t, function (t) {
            return _T.contains(t, e);
          });
        });
      }, _T.difference = function (e) {
        var t = f.apply(s, h.call(arguments, 1));
        return _T.filter(e, function (e) {
          return !_T.contains(t, e);
        });
      }, _T.zip = function () {
        for (var e = _T.max(_T.pluck(arguments, "length").concat(0)), t = new Array(e), r = 0; r < e; r++) t[r] = _T.pluck(arguments, "" + r);
        return t;
      }, _T.object = function (e, t) {
        if (null == e) return {};
        for (var r = {}, n = 0, i = e.length; n < i; n++) t ? r[e[n]] = t[n] : r[e[n][0]] = e[n][1];
        return r;
      }, _T.indexOf = function (e, t, r) {
        if (null == e) return -1;
        var n = 0,
          i = e.length;
        if (r) {
          if ("number" != typeof r) return n = _T.sortedIndex(e, t), e[n] === t ? n : -1;
          n = r < 0 ? Math.max(0, i + r) : r;
        }
        if (_ && e.indexOf === _) return e.indexOf(t, r);
        for (; n < i; n++) if (e[n] === t) return n;
        return -1;
      }, _T.lastIndexOf = function (e, t, r) {
        if (null == e) return -1;
        var n = null != r;
        if (S && e.lastIndexOf === S) return n ? e.lastIndexOf(t, r) : e.lastIndexOf(t);
        for (var i = n ? r : e.length; i--;) if (e[i] === t) return i;
        return -1;
      }, _T.range = function (e, t, r) {
        arguments.length <= 1 && (t = e || 0, e = 0), r = arguments[2] || 1;
        for (var n = Math.max(Math.ceil((t - e) / r), 0), i = 0, a = new Array(n); i < n;) a[i++] = e, e += r;
        return a;
      };
      var B = function B() {};
      _T.bind = function (e, t) {
        var r, _n2;
        if (A && e.bind === A) return A.apply(e, h.call(arguments, 1));
        if (!_T.isFunction(e)) throw new TypeError();
        return r = h.call(arguments, 2), _n2 = function n() {
          if (!(this instanceof _n2)) return e.apply(t, r.concat(h.call(arguments)));
          B.prototype = e.prototype;
          var i = new B();
          B.prototype = null;
          var a = e.apply(i, r.concat(h.call(arguments)));
          return Object(a) === a ? a : i;
        };
      }, _T.partial = function (e) {
        var t = h.call(arguments, 1);
        return function () {
          for (var r = 0, n = t.slice(), i = 0, a = n.length; i < a; i++) n[i] === _T && (n[i] = arguments[r++]);
          for (; r < arguments.length;) n.push(arguments[r++]);
          return e.apply(this, n);
        };
      }, _T.bindAll = function (e) {
        var t = h.call(arguments, 1);
        if (0 === t.length) throw new Error("bindAll must be passed function names");
        return k(t, function (t) {
          e[t] = _T.bind(e[t], e);
        }), e;
      }, _T.memoize = function (e, t) {
        var r = {};
        return t || (t = _T.identity), function () {
          var n = t.apply(this, arguments);
          return _T.has(r, n) ? r[n] : r[n] = e.apply(this, arguments);
        };
      }, _T.delay = function (e, t) {
        var r = h.call(arguments, 2);
        return setTimeout(function () {
          return e.apply(null, r);
        }, t);
      }, _T.defer = function (e) {
        return _T.delay.apply(_T, [e, 1].concat(h.call(arguments, 1)));
      }, _T.throttle = function (e, t, r) {
        var n,
          i,
          a,
          o = null,
          s = 0;
        r || (r = {});
        var l = function l() {
          s = !1 === r.leading ? 0 : _T.now(), o = null, a = e.apply(n, i), n = i = null;
        };
        return function () {
          var c = _T.now();
          s || !1 !== r.leading || (s = c);
          var u = t - (c - s);
          return n = this, i = arguments, u <= 0 ? (clearTimeout(o), o = null, s = c, a = e.apply(n, i), n = i = null) : o || !1 === r.trailing || (o = setTimeout(l, u)), a;
        };
      }, _T.debounce = function (e, t, r) {
        var n,
          i,
          a,
          o,
          s,
          _l2 = function l() {
            var c = _T.now() - o;
            c < t ? n = setTimeout(_l2, t - c) : (n = null, r || (s = e.apply(a, i), a = i = null));
          };
        return function () {
          a = this, i = arguments, o = _T.now();
          var c = r && !n;
          return n || (n = setTimeout(_l2, t)), c && (s = e.apply(a, i), a = i = null), s;
        };
      }, _T.once = function (e) {
        var t,
          r = !1;
        return function () {
          return r ? t : (r = !0, t = e.apply(this, arguments), e = null, t);
        };
      }, _T.wrap = function (e, t) {
        return _T.partial(t, e);
      }, _T.compose = function () {
        var e = arguments;
        return function () {
          for (var t = arguments, r = e.length - 1; r >= 0; r--) t = [e[r].apply(this, t)];
          return t[0];
        };
      }, _T.after = function (e, t) {
        return function () {
          if (--e < 1) return t.apply(this, arguments);
        };
      }, _T.keys = function (e) {
        if (!_T.isObject(e)) return [];
        if (E) return E(e);
        var t = [];
        for (var r in e) _T.has(e, r) && t.push(r);
        return t;
      }, _T.values = function (e) {
        for (var t = _T.keys(e), r = t.length, n = new Array(r), i = 0; i < r; i++) n[i] = e[t[i]];
        return n;
      }, _T.pairs = function (e) {
        for (var t = _T.keys(e), r = t.length, n = new Array(r), i = 0; i < r; i++) n[i] = [t[i], e[t[i]]];
        return n;
      }, _T.invert = function (e) {
        for (var t = {}, r = _T.keys(e), n = 0, i = r.length; n < i; n++) t[e[r[n]]] = r[n];
        return t;
      }, _T.functions = _T.methods = function (e) {
        var t = [];
        for (var r in e) _T.isFunction(e[r]) && t.push(r);
        return t.sort();
      }, _T.extend = function (e) {
        return k(h.call(arguments, 1), function (t) {
          if (t) for (var r in t) e[r] = t[r];
        }), e;
      }, _T.pick = function (e) {
        var t = {},
          r = f.apply(s, h.call(arguments, 1));
        return k(r, function (r) {
          r in e && (t[r] = e[r]);
        }), t;
      }, _T.omit = function (e) {
        var t = {},
          r = f.apply(s, h.call(arguments, 1));
        for (var n in e) _T.contains(r, n) || (t[n] = e[n]);
        return t;
      }, _T.defaults = function (e) {
        return k(h.call(arguments, 1), function (t) {
          if (t) for (var r in t) void 0 === e[r] && (e[r] = t[r]);
        }), e;
      }, _T.clone = function (e) {
        return _T.isObject(e) ? _T.isArray(e) ? e.slice() : _T.extend({}, e) : e;
      }, _T.tap = function (e, t) {
        return t(e), e;
      };
      var _D = function D(e, t, r, n) {
        if (e === t) return 0 !== e || 1 / e == 1 / t;
        if (null == e || null == t) return e === t;
        e instanceof _T && (e = e._wrapped), t instanceof _T && (t = t._wrapped);
        var i = d.call(e);
        if (i != d.call(t)) return !1;
        switch (i) {
          case "[object String]":
            return e == String(t);
          case "[object Number]":
            return e != +e ? t != +t : 0 == e ? 1 / e == 1 / t : e == +t;
          case "[object Date]":
          case "[object Boolean]":
            return +e == +t;
          case "[object RegExp]":
            return e.source == t.source && e.global == t.global && e.multiline == t.multiline && e.ignoreCase == t.ignoreCase;
        }
        if ("object" != _typeof(e) || "object" != _typeof(t)) return !1;
        for (var a = r.length; a--;) if (r[a] == e) return n[a] == t;
        var o = e.constructor,
          s = t.constructor;
        if (o !== s && !(_T.isFunction(o) && o instanceof o && _T.isFunction(s) && s instanceof s) && "constructor" in e && "constructor" in t) return !1;
        r.push(e), n.push(t);
        var l = 0,
          c = !0;
        if ("[object Array]" == i) {
          if (l = e.length, c = l == t.length) for (; l-- && (c = _D(e[l], t[l], r, n)););
        } else {
          for (var u in e) if (_T.has(e, u) && (l++, !(c = _T.has(t, u) && _D(e[u], t[u], r, n)))) break;
          if (c) {
            for (u in t) if (_T.has(t, u) && !l--) break;
            c = !l;
          }
        }
        return r.pop(), n.pop(), c;
      };
      _T.isEqual = function (e, t) {
        return _D(e, t, [], []);
      }, _T.isEmpty = function (e) {
        if (null == e) return !0;
        if (_T.isArray(e) || _T.isString(e)) return 0 === e.length;
        for (var t in e) if (_T.has(e, t)) return !1;
        return !0;
      }, _T.isElement = function (e) {
        return !(!e || 1 !== e.nodeType);
      }, _T.isArray = C || function (e) {
        return "[object Array]" == d.call(e);
      }, _T.isObject = function (e) {
        return e === Object(e);
      }, k(["Arguments", "Function", "String", "Number", "Date", "RegExp"], function (e) {
        _T["is" + e] = function (t) {
          return d.call(t) == "[object " + e + "]";
        };
      }), _T.isArguments(arguments) || (_T.isArguments = function (e) {
        return !(!e || !_T.has(e, "callee"));
      }), _T.isFunction = function (e) {
        return "function" == typeof e;
      }, _T.isFinite = function (e) {
        return isFinite(e) && !isNaN(parseFloat(e));
      }, _T.isNaN = function (e) {
        return _T.isNumber(e) && e != +e;
      }, _T.isBoolean = function (e) {
        return !0 === e || !1 === e || "[object Boolean]" == d.call(e);
      }, _T.isNull = function (e) {
        return null === e;
      }, _T.isUndefined = function (e) {
        return void 0 === e;
      }, _T.has = function (e, t) {
        return p.call(e, t);
      }, _T.noConflict = function () {
        return r._ = a, this;
      }, _T.identity = function (e) {
        return e;
      }, _T.constant = function (e) {
        return function () {
          return e;
        };
      }, _T.property = function (e) {
        return function (t) {
          return t[e];
        };
      }, _T.matches = function (e) {
        return function (t) {
          if (t === e) return !0;
          for (var r in e) if (e[r] !== t[r]) return !1;
          return !0;
        };
      }, _T.times = function (e, t, r) {
        for (var n = Array(Math.max(0, e)), i = 0; i < e; i++) n[i] = t.call(r, i);
        return n;
      }, _T.random = function (e, t) {
        return null == t && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1));
      }, _T.now = Date.now || function () {
        return new Date().getTime();
      };
      var L = {
        escape: {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;"
        }
      };
      L.unescape = _T.invert(L.escape);
      var F = {
        escape: new RegExp("[" + _T.keys(L.escape).join("") + "]", "g"),
        unescape: new RegExp("(" + _T.keys(L.unescape).join("|") + ")", "g")
      };
      _T.each(["escape", "unescape"], function (e) {
        _T[e] = function (t) {
          return null == t ? "" : ("" + t).replace(F[e], function (t) {
            return L[e][t];
          });
        };
      }), _T.result = function (e, t) {
        if (null != e) {
          var r = e[t];
          return _T.isFunction(r) ? r.call(e) : r;
        }
      }, _T.mixin = function (e) {
        k(_T.functions(e), function (t) {
          var r = _T[t] = e[t];
          _T.prototype[t] = function () {
            var e = [this._wrapped];
            return u.apply(e, arguments), H.call(this, r.apply(_T, e));
          };
        });
      };
      var N = 0;
      _T.uniqueId = function (e) {
        var t = ++N + "";
        return e ? e + t : t;
      }, _T.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };
      var U = /(.)^/,
        j = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\t": "t",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        z = /\\|'|\r|\n|\t|\u2028|\u2029/g;
      _T.template = function (e, t, r) {
        var n;
        r = _T.defaults({}, r, _T.templateSettings);
        var i = new RegExp([(r.escape || U).source, (r.interpolate || U).source, (r.evaluate || U).source].join("|") + "|$", "g"),
          a = 0,
          o = "__p+='";
        e.replace(i, function (t, r, n, i, s) {
          return o += e.slice(a, s).replace(z, function (e) {
            return "\\" + j[e];
          }), r && (o += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'"), n && (o += "'+\n((__t=(" + n + "))==null?'':__t)+\n'"), i && (o += "';\n" + i + "\n__p+='"), a = s + t.length, t;
        }), o += "';\n", r.variable || (o = "with(obj||{}){\n" + o + "}\n"), o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
        try {
          n = new Function(r.variable || "obj", "_", o);
        } catch (e) {
          throw e.source = o, e;
        }
        if (t) return n(t, _T);
        var s = function s(e) {
          return n.call(this, e, _T);
        };
        return s.source = "function(" + (r.variable || "obj") + "){\n" + o + "}", s;
      }, _T.chain = function (e) {
        return _T(e).chain();
      };
      var H = function H(e) {
        return this._chain ? _T(e).chain() : e;
      };
      _T.mixin(_T), k(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (e) {
        var t = s[e];
        _T.prototype[e] = function () {
          var r = this._wrapped;
          return t.apply(r, arguments), "shift" != e && "splice" != e || 0 !== r.length || delete r[0], H.call(this, r);
        };
      }), k(["concat", "join", "slice"], function (e) {
        var t = s[e];
        _T.prototype[e] = function () {
          return H.call(this, t.apply(this._wrapped, arguments));
        };
      }), _T.extend(_T.prototype, {
        chain: function chain() {
          return this._chain = !0, this;
        },
        value: function value() {
          return this._wrapped;
        }
      }), n = [], void 0 !== (i = function () {
        return _T;
      }.apply(t, n)) && (e.exports = i);
    }).call(this);
  }, function (t, r) {
    t.exports = e;
  }, function (e, t) {
    function r(e) {
      var t = _typeof(e);
      return !!e && ("object" == t || "function" == t);
    }
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r) {
      var n = a(e);
      return r && o(e, t, r) && (t = void 0), t ? i(n, t) : n;
    }
    var i = r(110),
      a = r(271),
      o = r(78);
    e.exports = n;
  }, function (e, t) {
    function r() {
      throw new Error("setTimeout has not been defined");
    }
    function n() {
      throw new Error("clearTimeout has not been defined");
    }
    function i(e) {
      if (u === setTimeout) return setTimeout(e, 0);
      if ((u === r || !u) && setTimeout) return u = setTimeout, setTimeout(e, 0);
      try {
        return u(e, 0);
      } catch (t) {
        try {
          return u.call(null, e, 0);
        } catch (t) {
          return u.call(this, e, 0);
        }
      }
    }
    function a(e) {
      if (h === clearTimeout) return clearTimeout(e);
      if ((h === n || !h) && clearTimeout) return h = clearTimeout, clearTimeout(e);
      try {
        return h(e);
      } catch (t) {
        try {
          return h.call(null, e);
        } catch (t) {
          return h.call(this, e);
        }
      }
    }
    function o() {
      m && d && (m = !1, d.length ? p = d.concat(p) : g = -1, p.length && s());
    }
    function s() {
      if (!m) {
        var e = i(o);
        m = !0;
        for (var t = p.length; t;) {
          for (d = p, p = []; ++g < t;) d && d[g].run();
          g = -1, t = p.length;
        }
        d = null, m = !1, a(e);
      }
    }
    function l(e, t) {
      this.fun = e, this.array = t;
    }
    function c() {}
    var u,
      h,
      f = e.exports = {};
    !function () {
      try {
        u = "function" == typeof setTimeout ? setTimeout : r;
      } catch (e) {
        u = r;
      }
      try {
        h = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (e) {
        h = n;
      }
    }();
    var d,
      p = [],
      m = !1,
      g = -1;
    f.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      p.push(new l(e, t)), 1 !== p.length || m || i(s);
    }, l.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = c, f.addListener = c, f.once = c, f.off = c, f.removeListener = c, f.removeAllListeners = c, f.emit = c, f.prependListener = c, f.prependOnceListener = c, f.listeners = function (e) {
      return [];
    }, f.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, f.cwd = function () {
      return "/";
    }, f.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, f.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(175),
      __esModule: !0
    };
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0, t.default = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0;
    var n = r(89),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = function () {
      function e(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), (0, i.default)(e, n.key, n);
        }
      }
      return function (t, r, n) {
        return r && e(t.prototype, r), n && e(t, n), t;
      };
    }();
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    t.__esModule = !0;
    var i = r(167),
      a = n(i),
      o = r(165),
      s = n(o),
      l = r(59),
      c = n(l);
    t.default = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === t ? "undefined" : (0, c.default)(t)));
      e.prototype = (0, s.default)(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (a.default ? (0, a.default)(e, t) : e.__proto__ = t);
    };
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0;
    var n = r(59),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== (void 0 === t ? "undefined" : (0, i.default)(t)) && "function" != typeof t ? e : t;
    };
  }, function (e, t) {
    var r = e.exports = {
      version: "2.6.1"
    };
    "number" == typeof __e && (__e = r);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e;
    }
    function i(e, t) {
      for (var r = 0; r < e.length; ++r) t[r] = 255 & e.charCodeAt(r);
      return t;
    }
    function a(e) {
      var r = 65536,
        n = [],
        i = e.length,
        a = t.getTypeOf(e),
        o = 0,
        s = !0;
      try {
        switch (a) {
          case "uint8array":
            String.fromCharCode.apply(null, new Uint8Array(0));
            break;
          case "nodebuffer":
            String.fromCharCode.apply(null, c(0));
        }
      } catch (e) {
        s = !1;
      }
      if (!s) {
        for (var l = "", u = 0; u < e.length; u++) l += String.fromCharCode(e[u]);
        return l;
      }
      for (; o < i && r > 1;) try {
        "array" === a || "nodebuffer" === a ? n.push(String.fromCharCode.apply(null, e.slice(o, Math.min(o + r, i)))) : n.push(String.fromCharCode.apply(null, e.subarray(o, Math.min(o + r, i)))), o += r;
      } catch (e) {
        r = Math.floor(r / 2);
      }
      return n.join("");
    }
    function o(e, t) {
      for (var r = 0; r < e.length; r++) t[r] = e[r];
      return t;
    }
    var s = r(45),
      l = r(74),
      c = r(75);
    t.string2binary = function (e) {
      for (var t = "", r = 0; r < e.length; r++) t += String.fromCharCode(255 & e.charCodeAt(r));
      return t;
    }, t.arrayBuffer2Blob = function (e, r) {
      t.checkSupport("blob"), r = r || "application/zip";
      try {
        return new Blob([e], {
          type: r
        });
      } catch (t) {
        try {
          var n = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
            i = new n();
          return i.append(e), i.getBlob(r);
        } catch (e) {
          throw new Error("Bug : can't construct the Blob.");
        }
      }
    }, t.applyFromCharCode = a;
    var u = {};
    u.string = {
      string: n,
      array: function array(e) {
        return i(e, new Array(e.length));
      },
      arraybuffer: function arraybuffer(e) {
        return u.string.uint8array(e).buffer;
      },
      uint8array: function uint8array(e) {
        return i(e, new Uint8Array(e.length));
      },
      nodebuffer: function nodebuffer(e) {
        return i(e, c(e.length));
      }
    }, u.array = {
      string: a,
      array: n,
      arraybuffer: function arraybuffer(e) {
        return new Uint8Array(e).buffer;
      },
      uint8array: function uint8array(e) {
        return new Uint8Array(e);
      },
      nodebuffer: function nodebuffer(e) {
        return c(e);
      }
    }, u.arraybuffer = {
      string: function string(e) {
        return a(new Uint8Array(e));
      },
      array: function array(e) {
        return o(new Uint8Array(e), new Array(e.byteLength));
      },
      arraybuffer: n,
      uint8array: function uint8array(e) {
        return new Uint8Array(e);
      },
      nodebuffer: function nodebuffer(e) {
        return c(new Uint8Array(e));
      }
    }, u.uint8array = {
      string: a,
      array: function array(e) {
        return o(e, new Array(e.length));
      },
      arraybuffer: function arraybuffer(e) {
        return e.buffer;
      },
      uint8array: n,
      nodebuffer: function nodebuffer(e) {
        return c(e);
      }
    }, u.nodebuffer = {
      string: a,
      array: function array(e) {
        return o(e, new Array(e.length));
      },
      arraybuffer: function arraybuffer(e) {
        return u.nodebuffer.uint8array(e).buffer;
      },
      uint8array: function uint8array(e) {
        return o(e, new Uint8Array(e.length));
      },
      nodebuffer: n
    }, t.transformTo = function (e, r) {
      if (r || (r = ""), !e) return r;
      t.checkSupport(e);
      var n = t.getTypeOf(r);
      return u[n][e](r);
    }, t.getTypeOf = function (e) {
      return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : s.nodebuffer && c.test(e) ? "nodebuffer" : s.uint8array && e instanceof Uint8Array ? "uint8array" : s.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
    }, t.checkSupport = function (e) {
      if (!s[e.toLowerCase()]) throw new Error(e + " is not supported by this browser");
    }, t.MAX_VALUE_16BITS = 65535, t.MAX_VALUE_32BITS = -1, t.pretty = function (e) {
      var t,
        r,
        n = "";
      for (r = 0; r < (e || "").length; r++) t = e.charCodeAt(r), n += "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
      return n;
    }, t.findCompression = function (e) {
      for (var t in l) if (l.hasOwnProperty(t) && l[t].magic === e) return l[t];
      return null;
    }, t.isRegExp = function (e) {
      return "[object RegExp]" === Object.prototype.toString.call(e);
    };
  }, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      function n() {
        return a.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }
      function i(e, t) {
        if (n() < t) throw new RangeError("Invalid typed array length");
        return a.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = a.prototype) : (null === e && (e = new a(t)), e.length = t), e;
      }
      function a(e, t, r) {
        if (!(a.TYPED_ARRAY_SUPPORT || this instanceof a)) return new a(e, t, r);
        if ("number" == typeof e) {
          if ("string" == typeof t) throw new Error("If encoding is specified then the first argument must be a string");
          return c(this, e);
        }
        return o(this, e, t, r);
      }
      function o(e, t, r, n) {
        if ("number" == typeof t) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && t instanceof ArrayBuffer ? f(e, t, r, n) : "string" == typeof t ? u(e, t, r) : d(e, t);
      }
      function s(e) {
        if ("number" != typeof e) throw new TypeError('"size" argument must be a number');
        if (e < 0) throw new RangeError('"size" argument must not be negative');
      }
      function l(e, t, r, n) {
        return s(t), t <= 0 ? i(e, t) : void 0 !== r ? "string" == typeof n ? i(e, t).fill(r, n) : i(e, t).fill(r) : i(e, t);
      }
      function c(e, t) {
        if (s(t), e = i(e, t < 0 ? 0 : 0 | p(t)), !a.TYPED_ARRAY_SUPPORT) for (var r = 0; r < t; ++r) e[r] = 0;
        return e;
      }
      function u(e, t, r) {
        if ("string" == typeof r && "" !== r || (r = "utf8"), !a.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
        var n = 0 | g(t, r);
        e = i(e, n);
        var o = e.write(t, r);
        return o !== n && (e = e.slice(0, o)), e;
      }
      function h(e, t) {
        var r = t.length < 0 ? 0 : 0 | p(t.length);
        e = i(e, r);
        for (var n = 0; n < r; n += 1) e[n] = 255 & t[n];
        return e;
      }
      function f(e, t, r, n) {
        if (t.byteLength, r < 0 || t.byteLength < r) throw new RangeError("'offset' is out of bounds");
        if (t.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
        return t = void 0 === r && void 0 === n ? new Uint8Array(t) : void 0 === n ? new Uint8Array(t, r) : new Uint8Array(t, r, n), a.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = a.prototype) : e = h(e, t), e;
      }
      function d(e, t) {
        if (a.isBuffer(t)) {
          var r = 0 | p(t.length);
          return e = i(e, r), 0 === e.length ? e : (t.copy(e, 0, 0, r), e);
        }
        if (t) {
          if ("undefined" != typeof ArrayBuffer && t.buffer instanceof ArrayBuffer || "length" in t) return "number" != typeof t.length || K(t.length) ? i(e, 0) : h(e, t);
          if ("Buffer" === t.type && Q(t.data)) return h(e, t.data);
        }
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }
      function p(e) {
        if (e >= n()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n().toString(16) + " bytes");
        return 0 | e;
      }
      function m(e) {
        return +e != e && (e = 0), a.alloc(+e);
      }
      function g(e, t) {
        if (a.isBuffer(e)) return e.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
        "string" != typeof e && (e = "" + e);
        var r = e.length;
        if (0 === r) return 0;
        for (var n = !1;;) switch (t) {
          case "ascii":
          case "latin1":
          case "binary":
            return r;
          case "utf8":
          case "utf-8":
          case void 0:
            return V(e).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * r;
          case "hex":
            return r >>> 1;
          case "base64":
            return X(e).length;
          default:
            if (n) return V(e).length;
            t = ("" + t).toLowerCase(), n = !0;
        }
      }
      function v(e, t, r) {
        var n = !1;
        if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if (r >>>= 0, t >>>= 0, r <= t) return "";
        for (e || (e = "utf8");;) switch (e) {
          case "hex":
            return O(this, t, r);
          case "utf8":
          case "utf-8":
            return k(this, t, r);
          case "ascii":
            return I(this, t, r);
          case "latin1":
          case "binary":
            return M(this, t, r);
          case "base64":
            return T(this, t, r);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return P(this, t, r);
          default:
            if (n) throw new TypeError("Unknown encoding: " + e);
            e = (e + "").toLowerCase(), n = !0;
        }
      }
      function b(e, t, r) {
        var n = e[t];
        e[t] = e[r], e[r] = n;
      }
      function y(e, t, r, n, i) {
        if (0 === e.length) return -1;
        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
          if (i) return -1;
          r = e.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }
        if ("string" == typeof t && (t = a.from(t, n)), a.isBuffer(t)) return 0 === t.length ? -1 : w(e, t, r, n, i);
        if ("number" == typeof t) return t &= 255, a.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : w(e, [t], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }
      function w(e, t, r, n, i) {
        function a(e, t) {
          return 1 === o ? e[t] : e.readUInt16BE(t * o);
        }
        var o = 1,
          s = e.length,
          l = t.length;
        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (e.length < 2 || t.length < 2) return -1;
          o = 2, s /= 2, l /= 2, r /= 2;
        }
        var c;
        if (i) {
          var u = -1;
          for (c = r; c < s; c++) if (a(e, c) === a(t, -1 === u ? 0 : c - u)) {
            if (-1 === u && (u = c), c - u + 1 === l) return u * o;
          } else -1 !== u && (c -= c - u), u = -1;
        } else for (r + l > s && (r = s - l), c = r; c >= 0; c--) {
          for (var h = !0, f = 0; f < l; f++) if (a(e, c + f) !== a(t, f)) {
            h = !1;
            break;
          }
          if (h) return c;
        }
        return -1;
      }
      function x(e, t, r, n) {
        r = Number(r) || 0;
        var i = e.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var a = t.length;
        if (a % 2 != 0) throw new TypeError("Invalid hex string");
        n > a / 2 && (n = a / 2);
        for (var o = 0; o < n; ++o) {
          var s = parseInt(t.substr(2 * o, 2), 16);
          if (isNaN(s)) return o;
          e[r + o] = s;
        }
        return o;
      }
      function _(e, t, r, n) {
        return Y(V(t, e.length - r), e, r, n);
      }
      function S(e, t, r, n) {
        return Y(q(t), e, r, n);
      }
      function C(e, t, r, n) {
        return S(e, t, r, n);
      }
      function E(e, t, r, n) {
        return Y(X(t), e, r, n);
      }
      function A(e, t, r, n) {
        return Y(W(t, e.length - r), e, r, n);
      }
      function T(e, t, r) {
        return 0 === t && r === e.length ? Z.fromByteArray(e) : Z.fromByteArray(e.slice(t, r));
      }
      function k(e, t, r) {
        r = Math.min(e.length, r);
        for (var n = [], i = t; i < r;) {
          var a = e[i],
            o = null,
            s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
          if (i + s <= r) {
            var l, c, u, h;
            switch (s) {
              case 1:
                a < 128 && (o = a);
                break;
              case 2:
                l = e[i + 1], 128 == (192 & l) && (h = (31 & a) << 6 | 63 & l) > 127 && (o = h);
                break;
              case 3:
                l = e[i + 1], c = e[i + 2], 128 == (192 & l) && 128 == (192 & c) && (h = (15 & a) << 12 | (63 & l) << 6 | 63 & c) > 2047 && (h < 55296 || h > 57343) && (o = h);
                break;
              case 4:
                l = e[i + 1], c = e[i + 2], u = e[i + 3], 128 == (192 & l) && 128 == (192 & c) && 128 == (192 & u) && (h = (15 & a) << 18 | (63 & l) << 12 | (63 & c) << 6 | 63 & u) > 65535 && h < 1114112 && (o = h);
            }
          }
          null === o ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | 1023 & o), n.push(o), i += s;
        }
        return R(n);
      }
      function R(e) {
        var t = e.length;
        if (t <= $) return String.fromCharCode.apply(String, e);
        for (var r = "", n = 0; n < t;) r += String.fromCharCode.apply(String, e.slice(n, n += $));
        return r;
      }
      function I(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);
        for (var i = t; i < r; ++i) n += String.fromCharCode(127 & e[i]);
        return n;
      }
      function M(e, t, r) {
        var n = "";
        r = Math.min(e.length, r);
        for (var i = t; i < r; ++i) n += String.fromCharCode(e[i]);
        return n;
      }
      function O(e, t, r) {
        var n = e.length;
        (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
        for (var i = "", a = t; a < r; ++a) i += G(e[a]);
        return i;
      }
      function P(e, t, r) {
        for (var n = e.slice(t, r), i = "", a = 0; a < n.length; a += 2) i += String.fromCharCode(n[a] + 256 * n[a + 1]);
        return i;
      }
      function B(e, t, r) {
        if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
        if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
      }
      function D(e, t, r, n, i, o) {
        if (!a.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > e.length) throw new RangeError("Index out of range");
      }
      function L(e, t, r, n) {
        t < 0 && (t = 65535 + t + 1);
        for (var i = 0, a = Math.min(e.length - r, 2); i < a; ++i) e[r + i] = (t & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
      }
      function F(e, t, r, n) {
        t < 0 && (t = 4294967295 + t + 1);
        for (var i = 0, a = Math.min(e.length - r, 4); i < a; ++i) e[r + i] = t >>> 8 * (n ? i : 3 - i) & 255;
      }
      function N(e, t, r, n, i, a) {
        if (r + n > e.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }
      function U(e, t, r, n, i) {
        return i || N(e, t, r, 4, 3.4028234663852886e38, -3.4028234663852886e38), J.write(e, t, r, n, 23, 4), r + 4;
      }
      function j(e, t, r, n, i) {
        return i || N(e, t, r, 8, 1.7976931348623157e308, -1.7976931348623157e308), J.write(e, t, r, n, 52, 8), r + 8;
      }
      function z(e) {
        if (e = H(e).replace(ee, ""), e.length < 2) return "";
        for (; e.length % 4 != 0;) e += "=";
        return e;
      }
      function H(e) {
        return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
      }
      function G(e) {
        return e < 16 ? "0" + e.toString(16) : e.toString(16);
      }
      function V(e, t) {
        t = t || 1 / 0;
        for (var r, n = e.length, i = null, a = [], o = 0; o < n; ++o) {
          if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (t -= 3) > -1 && a.push(239, 191, 189);
                continue;
              }
              if (o + 1 === n) {
                (t -= 3) > -1 && a.push(239, 191, 189);
                continue;
              }
              i = r;
              continue;
            }
            if (r < 56320) {
              (t -= 3) > -1 && a.push(239, 191, 189), i = r;
              continue;
            }
            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (t -= 3) > -1 && a.push(239, 191, 189);
          if (i = null, r < 128) {
            if ((t -= 1) < 0) break;
            a.push(r);
          } else if (r < 2048) {
            if ((t -= 2) < 0) break;
            a.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((t -= 3) < 0) break;
            a.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((t -= 4) < 0) break;
            a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }
        return a;
      }
      function q(e) {
        for (var t = [], r = 0; r < e.length; ++r) t.push(255 & e.charCodeAt(r));
        return t;
      }
      function W(e, t) {
        for (var r, n, i, a = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) r = e.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
        return a;
      }
      function X(e) {
        return Z.toByteArray(z(e));
      }
      function Y(e, t, r, n) {
        for (var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i) t[i + r] = e[i];
        return i;
      }
      function K(e) {
        return e !== e;
      } /*!
        * The buffer module from node.js, for the browser.
        *
        * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
        * @license  MIT
        */
      var Z = r(209),
        J = r(251),
        Q = r(103);
      t.Buffer = a, t.SlowBuffer = m, t.INSPECT_MAX_BYTES = 50, a.TYPED_ARRAY_SUPPORT = void 0 !== e.TYPED_ARRAY_SUPPORT ? e.TYPED_ARRAY_SUPPORT : function () {
        try {
          var e = new Uint8Array(1);
          return e.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === e.foo() && "function" == typeof e.subarray && 0 === e.subarray(1, 1).byteLength;
        } catch (e) {
          return !1;
        }
      }(), t.kMaxLength = n(), a.poolSize = 8192, a._augment = function (e) {
        return e.__proto__ = a.prototype, e;
      }, a.from = function (e, t, r) {
        return o(null, e, t, r);
      }, a.TYPED_ARRAY_SUPPORT && (a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
        value: null,
        configurable: !0
      })), a.alloc = function (e, t, r) {
        return l(null, e, t, r);
      }, a.allocUnsafe = function (e) {
        return c(null, e);
      }, a.allocUnsafeSlow = function (e) {
        return c(null, e);
      }, a.isBuffer = function (e) {
        return !(null == e || !e._isBuffer);
      }, a.compare = function (e, t) {
        if (!a.isBuffer(e) || !a.isBuffer(t)) throw new TypeError("Arguments must be Buffers");
        if (e === t) return 0;
        for (var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i) if (e[i] !== t[i]) {
          r = e[i], n = t[i];
          break;
        }
        return r < n ? -1 : n < r ? 1 : 0;
      }, a.isEncoding = function (e) {
        switch (String(e).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1;
        }
      }, a.concat = function (e, t) {
        if (!Q(e)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === e.length) return a.alloc(0);
        var r;
        if (void 0 === t) for (t = 0, r = 0; r < e.length; ++r) t += e[r].length;
        var n = a.allocUnsafe(t),
          i = 0;
        for (r = 0; r < e.length; ++r) {
          var o = e[r];
          if (!a.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
          o.copy(n, i), i += o.length;
        }
        return n;
      }, a.byteLength = g, a.prototype._isBuffer = !0, a.prototype.swap16 = function () {
        var e = this.length;
        if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (var t = 0; t < e; t += 2) b(this, t, t + 1);
        return this;
      }, a.prototype.swap32 = function () {
        var e = this.length;
        if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (var t = 0; t < e; t += 4) b(this, t, t + 3), b(this, t + 1, t + 2);
        return this;
      }, a.prototype.swap64 = function () {
        var e = this.length;
        if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (var t = 0; t < e; t += 8) b(this, t, t + 7), b(this, t + 1, t + 6), b(this, t + 2, t + 5), b(this, t + 3, t + 4);
        return this;
      }, a.prototype.toString = function () {
        var e = 0 | this.length;
        return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : v.apply(this, arguments);
      }, a.prototype.equals = function (e) {
        if (!a.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        return this === e || 0 === a.compare(this, e);
      }, a.prototype.inspect = function () {
        var e = "",
          r = t.INSPECT_MAX_BYTES;
        return this.length > 0 && (e = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (e += " ... ")), "<Buffer " + e + ">";
      }, a.prototype.compare = function (e, t, r, n, i) {
        if (!a.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && t >= r) return 0;
        if (n >= i) return -1;
        if (t >= r) return 1;
        if (t >>>= 0, r >>>= 0, n >>>= 0, i >>>= 0, this === e) return 0;
        for (var o = i - n, s = r - t, l = Math.min(o, s), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h) if (c[h] !== u[h]) {
          o = c[h], s = u[h];
          break;
        }
        return o < s ? -1 : s < o ? 1 : 0;
      }, a.prototype.includes = function (e, t, r) {
        return -1 !== this.indexOf(e, t, r);
      }, a.prototype.indexOf = function (e, t, r) {
        return y(this, e, t, r, !0);
      }, a.prototype.lastIndexOf = function (e, t, r) {
        return y(this, e, t, r, !1);
      }, a.prototype.write = function (e, t, r, n) {
        if (void 0 === t) n = "utf8", r = this.length, t = 0;else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;else {
          if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          t |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - t;
        if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");
        for (var a = !1;;) switch (n) {
          case "hex":
            return x(this, e, t, r);
          case "utf8":
          case "utf-8":
            return _(this, e, t, r);
          case "ascii":
            return S(this, e, t, r);
          case "latin1":
          case "binary":
            return C(this, e, t, r);
          case "base64":
            return E(this, e, t, r);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return A(this, e, t, r);
          default:
            if (a) throw new TypeError("Unknown encoding: " + n);
            n = ("" + n).toLowerCase(), a = !0;
        }
      }, a.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var $ = 4096;
      a.prototype.slice = function (e, t) {
        var r = this.length;
        e = ~~e, t = void 0 === t ? r : ~~t, e < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), t < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
        var n;
        if (a.TYPED_ARRAY_SUPPORT) n = this.subarray(e, t), n.__proto__ = a.prototype;else {
          var i = t - e;
          n = new a(i, void 0);
          for (var o = 0; o < i; ++o) n[o] = this[o + e];
        }
        return n;
      }, a.prototype.readUIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || B(e, t, this.length);
        for (var n = this[e], i = 1, a = 0; ++a < t && (i *= 256);) n += this[e + a] * i;
        return n;
      }, a.prototype.readUIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || B(e, t, this.length);
        for (var n = this[e + --t], i = 1; t > 0 && (i *= 256);) n += this[e + --t] * i;
        return n;
      }, a.prototype.readUInt8 = function (e, t) {
        return t || B(e, 1, this.length), this[e];
      }, a.prototype.readUInt16LE = function (e, t) {
        return t || B(e, 2, this.length), this[e] | this[e + 1] << 8;
      }, a.prototype.readUInt16BE = function (e, t) {
        return t || B(e, 2, this.length), this[e] << 8 | this[e + 1];
      }, a.prototype.readUInt32LE = function (e, t) {
        return t || B(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
      }, a.prototype.readUInt32BE = function (e, t) {
        return t || B(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
      }, a.prototype.readIntLE = function (e, t, r) {
        e |= 0, t |= 0, r || B(e, t, this.length);
        for (var n = this[e], i = 1, a = 0; ++a < t && (i *= 256);) n += this[e + a] * i;
        return i *= 128, n >= i && (n -= Math.pow(2, 8 * t)), n;
      }, a.prototype.readIntBE = function (e, t, r) {
        e |= 0, t |= 0, r || B(e, t, this.length);
        for (var n = t, i = 1, a = this[e + --n]; n > 0 && (i *= 256);) a += this[e + --n] * i;
        return i *= 128, a >= i && (a -= Math.pow(2, 8 * t)), a;
      }, a.prototype.readInt8 = function (e, t) {
        return t || B(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
      }, a.prototype.readInt16LE = function (e, t) {
        t || B(e, 2, this.length);
        var r = this[e] | this[e + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, a.prototype.readInt16BE = function (e, t) {
        t || B(e, 2, this.length);
        var r = this[e + 1] | this[e] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, a.prototype.readInt32LE = function (e, t) {
        return t || B(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
      }, a.prototype.readInt32BE = function (e, t) {
        return t || B(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
      }, a.prototype.readFloatLE = function (e, t) {
        return t || B(e, 4, this.length), J.read(this, e, !0, 23, 4);
      }, a.prototype.readFloatBE = function (e, t) {
        return t || B(e, 4, this.length), J.read(this, e, !1, 23, 4);
      }, a.prototype.readDoubleLE = function (e, t) {
        return t || B(e, 8, this.length), J.read(this, e, !0, 52, 8);
      }, a.prototype.readDoubleBE = function (e, t) {
        return t || B(e, 8, this.length), J.read(this, e, !1, 52, 8);
      }, a.prototype.writeUIntLE = function (e, t, r, n) {
        if (e = +e, t |= 0, r |= 0, !n) {
          D(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        }
        var i = 1,
          a = 0;
        for (this[t] = 255 & e; ++a < r && (i *= 256);) this[t + a] = e / i & 255;
        return t + r;
      }, a.prototype.writeUIntBE = function (e, t, r, n) {
        if (e = +e, t |= 0, r |= 0, !n) {
          D(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
        }
        var i = r - 1,
          a = 1;
        for (this[t + i] = 255 & e; --i >= 0 && (a *= 256);) this[t + i] = e / a & 255;
        return t + r;
      }, a.prototype.writeUInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 1, 255, 0), a.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = 255 & e, t + 1;
      }, a.prototype.writeUInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : L(this, e, t, !0), t + 2;
      }, a.prototype.writeUInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : L(this, e, t, !1), t + 2;
      }, a.prototype.writeUInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e) : F(this, e, t, !0), t + 4;
      }, a.prototype.writeUInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : F(this, e, t, !1), t + 4;
      }, a.prototype.writeIntLE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          D(this, e, t, r, i - 1, -i);
        }
        var a = 0,
          o = 1,
          s = 0;
        for (this[t] = 255 & e; ++a < r && (o *= 256);) e < 0 && 0 === s && 0 !== this[t + a - 1] && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
        return t + r;
      }, a.prototype.writeIntBE = function (e, t, r, n) {
        if (e = +e, t |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          D(this, e, t, r, i - 1, -i);
        }
        var a = r - 1,
          o = 1,
          s = 0;
        for (this[t + a] = 255 & e; --a >= 0 && (o *= 256);) e < 0 && 0 === s && 0 !== this[t + a + 1] && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
        return t + r;
      }, a.prototype.writeInt8 = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 1, 127, -128), a.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
      }, a.prototype.writeInt16LE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8) : L(this, e, t, !0), t + 2;
      }, a.prototype.writeInt16BE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = 255 & e) : L(this, e, t, !1), t + 2;
      }, a.prototype.writeInt32LE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 4, 2147483647, -2147483648), a.TYPED_ARRAY_SUPPORT ? (this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : F(this, e, t, !0), t + 4;
      }, a.prototype.writeInt32BE = function (e, t, r) {
        return e = +e, t |= 0, r || D(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), a.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e) : F(this, e, t, !1), t + 4;
      }, a.prototype.writeFloatLE = function (e, t, r) {
        return U(this, e, t, !0, r);
      }, a.prototype.writeFloatBE = function (e, t, r) {
        return U(this, e, t, !1, r);
      }, a.prototype.writeDoubleLE = function (e, t, r) {
        return j(this, e, t, !0, r);
      }, a.prototype.writeDoubleBE = function (e, t, r) {
        return j(this, e, t, !1, r);
      }, a.prototype.copy = function (e, t, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === e.length || 0 === this.length) return 0;
        if (t < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
        var i,
          o = n - r;
        if (this === e && r < t && t < n) for (i = o - 1; i >= 0; --i) e[i + t] = this[i + r];else if (o < 1e3 || !a.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) e[i + t] = this[i + r];else Uint8Array.prototype.set.call(e, this.subarray(r, r + o), t);
        return o;
      }, a.prototype.fill = function (e, t, r, n) {
        if ("string" == typeof e) {
          if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === e.length) {
            var i = e.charCodeAt(0);
            i < 256 && (e = i);
          }
          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !a.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof e && (e &= 255);
        if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
        if (r <= t) return this;
        t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0);
        var o;
        if ("number" == typeof e) for (o = t; o < r; ++o) this[o] = e;else {
          var s = a.isBuffer(e) ? e : V(new a(e, n).toString()),
            l = s.length;
          for (o = 0; o < r - t; ++o) this[o + t] = s[o % l];
        }
        return this;
      };
      var ee = /[^+\/0-9A-Za-z-_]/g;
    }).call(t, r(13));
  }, function (e, t, r) {
    function n() {
      var e,
        t,
        r = new a.Promise(function (r, n) {
          e = r, t = n;
        });
      return {
        resolve: e,
        reject: t,
        promise: r
      };
    }
    var i = r(1),
      a = r(227)();
    t.defer = n, t.when = a.resolve, t.resolve = a.resolve, t.all = a.all, t.props = a.props, t.reject = a.reject, t.promisify = a.promisify, t.mapSeries = a.mapSeries, t.attempt = a.attempt, t.nfcall = function (e) {
      var t = Array.prototype.slice.call(arguments, 1);
      return a.promisify(e).apply(null, t);
    }, a.prototype.fail = a.prototype.caught, a.prototype.also = function (e) {
      return this.then(function (t) {
        var r = i.extend({}, t, e(t));
        return a.props(r);
      });
    };
  }, function (e, t, r) {
    function n(e, t) {
      this.value = e, this.messages = t || [];
    }
    function i(e) {
      return new n(e, []);
    }
    function a(e) {
      return {
        type: "warning",
        message: e
      };
    }
    function o(e) {
      return {
        type: "error",
        message: e.message,
        error: e
      };
    }
    function s(e) {
      var t = [];
      return u.flatten(u.pluck(e, "messages"), !0).forEach(function (e) {
        l(t, e) || t.push(e);
      }), t;
    }
    function l(e, t) {
      return void 0 !== u.find(e, c.bind(null, t));
    }
    function c(e, t) {
      return e.type === t.type && e.message === t.message;
    }
    var u = r(1);
    t.Result = n, t.success = i, t.warning = a, t.error = o, n.prototype.map = function (e) {
      return new n(e(this.value), this.messages);
    }, n.prototype.flatMap = function (e) {
      var t = e(this.value);
      return new n(t.value, s([this, t]));
    }, n.prototype.flatMapThen = function (e) {
      var t = this;
      return e(this.value).then(function (e) {
        return new n(e.value, s([t, e]));
      });
    }, n.combine = function (e) {
      return new n(u.flatten(u.pluck(e, "value")), s(e));
    };
  }, function (e, t) {
    var r = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = r);
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      function r(n) {
        if (!(this instanceof r)) return new r(n);
        h(this, "message", "string" == typeof n ? n : t), h(this, "name", e), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
      }
      return u(r, Error), r;
    }
    function i(e) {
      if (!(this instanceof i)) return new i(e);
      h(this, "name", "OperationalError"), h(this, "message", e), this.cause = e, this.isOperational = !0, e instanceof Error ? (h(this, "message", e.message), h(this, "stack", e.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    }
    var a,
      o,
      s = r(36),
      l = s.freeze,
      c = r(0),
      u = c.inherits,
      h = c.notEnumerableProp,
      f = n("Warning", "warning"),
      d = n("CancellationError", "cancellation error"),
      p = n("TimeoutError", "timeout error"),
      m = n("AggregateError", "aggregate error");
    try {
      a = TypeError, o = RangeError;
    } catch (e) {
      a = n("TypeError", "type error"), o = n("RangeError", "range error");
    }
    for (var g = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), v = 0; v < g.length; ++v) "function" == typeof Array.prototype[g[v]] && (m.prototype[g[v]] = Array.prototype[g[v]]);
    s.defineProperty(m.prototype, "length", {
      value: 0,
      configurable: !1,
      writable: !0,
      enumerable: !0
    }), m.prototype.isOperational = !0;
    var b = 0;
    m.prototype.toString = function () {
      var e = Array(4 * b + 1).join(" "),
        t = "\n" + e + "AggregateError of:\n";
      b++, e = Array(4 * b + 1).join(" ");
      for (var r = 0; r < this.length; ++r) {
        for (var n = this[r] === this ? "[Circular AggregateError]" : this[r] + "", i = n.split("\n"), a = 0; a < i.length; ++a) i[a] = e + i[a];
        n = i.join("\n"), t += n + "\n";
      }
      return b--, t;
    }, u(i, Error);
    var y = Error.__BluebirdErrorTypes__;
    y || (y = l({
      CancellationError: d,
      TimeoutError: p,
      OperationalError: i,
      RejectionError: i,
      AggregateError: m
    }), s.defineProperty(Error, "__BluebirdErrorTypes__", {
      value: y,
      writable: !1,
      enumerable: !1,
      configurable: !1
    })), e.exports = {
      Error: Error,
      TypeError: a,
      RangeError: o,
      CancellationError: y.CancellationError,
      OperationalError: y.OperationalError,
      TimeoutError: y.TimeoutError,
      AggregateError: y.AggregateError,
      Warning: f
    };
  }, function (e, t) {
    function r(e, t) {
      var r = e[1] || "",
        i = e[3];
      if (!i) return r;
      if (t && "function" == typeof btoa) {
        var a = n(i);
        return [r].concat(i.sources.map(function (e) {
          return "/*# sourceURL=" + i.sourceRoot + e + " */";
        })).concat([a]).join("\n");
      }
      return [r].join("\n");
    }
    function n(e) {
      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
    }
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = r(t, e);
          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, r) {
        "string" == typeof e && (e = [[null, e, ""]]);
        for (var n = {}, i = 0; i < this.length; i++) {
          var a = this[i][0];
          "number" == typeof a && (n[a] = !0);
        }
        for (i = 0; i < e.length; i++) {
          var o = e[i];
          "number" == typeof o[0] && n[o[0]] || (r && !o[2] ? o[2] = r : r && (o[2] = "(" + o[2] + ") and (" + r + ")"), t.push(o));
        }
      }, t;
    };
  }, function (e, t, r) {
    function n(e) {
      return i(e) ? e : Object(e);
    }
    var i = r(3);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(116),
      i = r(37),
      a = r(29),
      o = Object.prototype,
      s = o.toString,
      l = n(Array, "isArray"),
      c = l || function (e) {
        return a(e) && i(e.length) && "[object Array]" == s.call(e);
      };
    e.exports = c;
  }, function (e, t, r) {
    "use strict";

    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
    t.assign = function (e) {
      for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
        var r = t.shift();
        if (r) {
          if ("object" != _typeof(r)) throw new TypeError(r + "must be non-object");
          for (var n in r) r.hasOwnProperty(n) && (e[n] = r[n]);
        }
      }
      return e;
    }, t.shrinkBuf = function (e, t) {
      return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
    };
    var i = {
        arraySet: function arraySet(e, t, r, n, i) {
          if (t.subarray && e.subarray) return void e.set(t.subarray(r, r + n), i);
          for (var a = 0; a < n; a++) e[i + a] = t[r + a];
        },
        flattenChunks: function flattenChunks(e) {
          var t, r, n, i, a, o;
          for (n = 0, t = 0, r = e.length; t < r; t++) n += e[t].length;
          for (o = new Uint8Array(n), i = 0, t = 0, r = e.length; t < r; t++) a = e[t], o.set(a, i), i += a.length;
          return o;
        }
      },
      a = {
        arraySet: function arraySet(e, t, r, n, i) {
          for (var a = 0; a < n; a++) e[i + a] = t[r + a];
        },
        flattenChunks: function flattenChunks(e) {
          return [].concat.apply([], e);
        }
      };
    t.setTyped = function (e) {
      e ? (t.Buf8 = Uint8Array, t.Buf16 = Uint16Array, t.Buf32 = Int32Array, t.assign(t, i)) : (t.Buf8 = Array, t.Buf16 = Array, t.Buf32 = Array, t.assign(t, a));
    }, t.setTyped(n);
  }, function (e, t, r) {
    function n(e, t) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r],
          i = p[n.id];
        if (i) {
          i.refs++;
          for (var a = 0; a < i.parts.length; a++) i.parts[a](n.parts[a]);
          for (; a < n.parts.length; a++) i.parts.push(u(n.parts[a], t));
        } else {
          for (var o = [], a = 0; a < n.parts.length; a++) o.push(u(n.parts[a], t));
          p[n.id] = {
            id: n.id,
            refs: 1,
            parts: o
          };
        }
      }
    }
    function i(e, t) {
      for (var r = [], n = {}, i = 0; i < e.length; i++) {
        var a = e[i],
          o = t.base ? a[0] + t.base : a[0],
          s = a[1],
          l = a[2],
          c = a[3],
          u = {
            css: s,
            media: l,
            sourceMap: c
          };
        n[o] ? n[o].parts.push(u) : r.push(n[o] = {
          id: o,
          parts: [u]
        });
      }
      return r;
    }
    function a(e, t) {
      var r = g(e.insertInto);
      if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var n = y[y.length - 1];
      if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), y.push(t);else {
        if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
        r.appendChild(t);
      }
    }
    function o(e) {
      e.parentNode.removeChild(e);
      var t = y.indexOf(e);
      t >= 0 && y.splice(t, 1);
    }
    function s(e) {
      var t = document.createElement("style");
      return e.attrs.type = "text/css", c(t, e.attrs), a(e, t), t;
    }
    function l(e) {
      var t = document.createElement("link");
      return e.attrs.type = "text/css", e.attrs.rel = "stylesheet", c(t, e.attrs), a(e, t), t;
    }
    function c(e, t) {
      Object.keys(t).forEach(function (r) {
        e.setAttribute(r, t[r]);
      });
    }
    function u(e, t) {
      var r, n, i, a;
      if (t.transform && e.css) {
        if (!(a = t.transform(e.css))) return function () {};
        e.css = a;
      }
      if (t.singleton) {
        var c = b++;
        r = v || (v = s(t)), n = h.bind(null, r, c, !1), i = h.bind(null, r, c, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = l(t), n = d.bind(null, r, t), i = function i() {
        o(r), r.href && URL.revokeObjectURL(r.href);
      }) : (r = s(t), n = f.bind(null, r), i = function i() {
        o(r);
      });
      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else i();
      };
    }
    function h(e, t, r, n) {
      var i = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = x(t, i);else {
        var a = document.createTextNode(i),
          o = e.childNodes;
        o[t] && e.removeChild(o[t]), o.length ? e.insertBefore(a, o[t]) : e.appendChild(a);
      }
    }
    function f(e, t) {
      var r = t.css,
        n = t.media;
      if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = r;else {
        for (; e.firstChild;) e.removeChild(e.firstChild);
        e.appendChild(document.createTextNode(r));
      }
    }
    function d(e, t, r) {
      var n = r.css,
        i = r.sourceMap,
        a = void 0 === t.convertToAbsoluteUrls && i;
      (t.convertToAbsoluteUrls || a) && (n = w(n)), i && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
      var o = new Blob([n], {
          type: "text/css"
        }),
        s = e.href;
      e.href = URL.createObjectURL(o), s && URL.revokeObjectURL(s);
    }
    var p = {},
      m = function (e) {
        var t;
        return function () {
          return void 0 === t && (t = e.apply(this, arguments)), t;
        };
      }(function () {
        return window && document && document.all && !window.atob;
      }),
      g = function (e) {
        var t = {};
        return function (r) {
          return void 0 === t[r] && (t[r] = e.call(this, r)), t[r];
        };
      }(function (e) {
        return document.querySelector(e);
      }),
      v = null,
      b = 0,
      y = [],
      w = r(362);
    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      t = t || {}, t.attrs = "object" == _typeof(t.attrs) ? t.attrs : {}, void 0 === t.singleton && (t.singleton = m()), void 0 === t.insertInto && (t.insertInto = "head"), void 0 === t.insertAt && (t.insertAt = "bottom");
      var r = i(e, t);
      return n(r, t), function (e) {
        for (var a = [], o = 0; o < r.length; o++) {
          var s = r[o],
            l = p[s.id];
          l.refs--, a.push(l);
        }
        if (e) {
          n(i(e, t), t);
        }
        for (var o = 0; o < a.length; o++) {
          var l = a[o];
          if (0 === l.refs) {
            for (var c = 0; c < l.parts.length; c++) l.parts[c]();
            delete p[l.id];
          }
        }
      };
    };
    var x = function () {
      var e = [];
      return function (t, r) {
        return e[t] = r, e.filter(Boolean).join("\n");
      };
    }();
  }, function (e, t, r) {
    e.exports = !r(31)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, r) {
    var n = r(17),
      i = r(11),
      a = r(91),
      o = r(32),
      s = r(26),
      _l3 = function l(e, t, r) {
        var c,
          u,
          h,
          f = e & _l3.F,
          d = e & _l3.G,
          p = e & _l3.S,
          m = e & _l3.P,
          g = e & _l3.B,
          v = e & _l3.W,
          b = d ? i : i[t] || (i[t] = {}),
          y = b.prototype,
          w = d ? n : p ? n[t] : (n[t] || {}).prototype;
        d && (r = t);
        for (c in r) (u = !f && w && void 0 !== w[c]) && s(b, c) || (h = u ? w[c] : r[c], b[c] = d && "function" != typeof w[c] ? r[c] : g && u ? a(h, n) : v && w[c] == h ? function (e) {
          var t = function t(_t3, r, n) {
            if (this instanceof e) {
              switch (arguments.length) {
                case 0:
                  return new e();
                case 1:
                  return new e(_t3);
                case 2:
                  return new e(_t3, r);
              }
              return new e(_t3, r, n);
            }
            return e.apply(this, arguments);
          };
          return t.prototype = e.prototype, t;
        }(h) : m && "function" == typeof h ? a(Function.call, h) : h, m && ((b.virtual || (b.virtual = {}))[c] = h, e & _l3.R && y && !y[c] && o(y, c, h)));
      };
    _l3.F = 1, _l3.G = 2, _l3.S = 4, _l3.P = 8, _l3.B = 16, _l3.W = 32, _l3.U = 64, _l3.R = 128, e.exports = _l3;
  }, function (e, t) {
    var r = {}.hasOwnProperty;
    e.exports = function (e, t) {
      return r.call(e, t);
    };
  }, function (e, t, r) {
    var n = r(42),
      i = r(93),
      a = r(69),
      o = Object.defineProperty;
    t.f = r(24) ? Object.defineProperty : function (e, t, r) {
      if (n(e), t = a(t, !0), n(r), i) try {
        return o(e, t, r);
      } catch (e) {}
      if ("get" in r || "set" in r) throw TypeError("Accessors not supported!");
      return "value" in r && (e[t] = r.value), e;
    };
  }, function (e, t) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;
      var r = function r() {};
      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }, function (e, t) {
    function r(e) {
      return !!e && "object" == _typeof(e);
    }
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!(this instanceof n)) return new n(e);
      c.call(this, e), u.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", i);
    }
    function i() {
      this.allowHalfOpen || this._writableState.ended || o.nextTick(a, this);
    }
    function a(e) {
      e.end();
    }
    var o = r(56),
      s = Object.keys || function (e) {
        var t = [];
        for (var r in e) t.push(r);
        return t;
      };
    e.exports = n;
    var l = r(44);
    l.inherits = r(28);
    var c = r(135),
      u = r(82);
    l.inherits(n, c);
    for (var h = s(u.prototype), f = 0; f < h.length; f++) {
      var d = h[f];
      n.prototype[d] || (n.prototype[d] = u.prototype[d]);
    }
    Object.defineProperty(n.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(n.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(e) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
      }
    }), n.prototype._destroy = function (e, t) {
      this.push(null), this.end(), o.nextTick(t, e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      try {
        return !!e();
      } catch (e) {
        return !0;
      }
    };
  }, function (e, t, r) {
    var n = r(27),
      i = r(49);
    e.exports = r(24) ? function (e, t, r) {
      return n.f(e, t, i(1, r));
    } : function (e, t, r) {
      return e[t] = r, e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "object" == _typeof(e) ? null !== e : "function" == typeof e;
    };
  }, function (e, t, r) {
    var n = r(94),
      i = r(60);
    e.exports = function (e) {
      return n(i(e));
    };
  }, function (e, t, r) {
    var n = r(67)("wks"),
      i = r(51),
      a = r(17).Symbol,
      o = "function" == typeof a;
    (e.exports = function (e) {
      return n[e] || (n[e] = o && a[e] || (o ? a : i)("Symbol." + e));
    }).store = n;
  }, function (e, t) {
    var r = function () {
      "use strict";

      return void 0 === this;
    }();
    if (r) e.exports = {
      freeze: Object.freeze,
      defineProperty: Object.defineProperty,
      getDescriptor: Object.getOwnPropertyDescriptor,
      keys: Object.keys,
      names: Object.getOwnPropertyNames,
      getPrototypeOf: Object.getPrototypeOf,
      isArray: Array.isArray,
      isES5: r,
      propertyIsWritable: function propertyIsWritable(e, t) {
        var r = Object.getOwnPropertyDescriptor(e, t);
        return !(r && !r.writable && !r.set);
      }
    };else {
      var n = {}.hasOwnProperty,
        i = {}.toString,
        a = {}.constructor.prototype,
        o = function o(e) {
          var t = [];
          for (var r in e) n.call(e, r) && t.push(r);
          return t;
        },
        s = function s(e, t) {
          return {
            value: e[t]
          };
        },
        l = function l(e, t, r) {
          return e[t] = r.value, e;
        },
        c = function c(e) {
          return e;
        },
        u = function u(e) {
          try {
            return Object(e).constructor.prototype;
          } catch (e) {
            return a;
          }
        },
        h = function h(e) {
          try {
            return "[object Array]" === i.call(e);
          } catch (e) {
            return !1;
          }
        };
      e.exports = {
        isArray: h,
        keys: o,
        names: o,
        defineProperty: l,
        getDescriptor: s,
        freeze: c,
        getPrototypeOf: u,
        isES5: r,
        propertyIsWritable: function propertyIsWritable() {
          return !0;
        }
      };
    }
  }, function (e, t) {
    function r(e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
    }
    var n = 9007199254740991;
    e.exports = r;
  }, function (e, t, r) {
    var n = r(116),
      i = r(52),
      a = r(3),
      o = r(290),
      s = n(Object, "keys"),
      l = s ? function (e) {
        var t = null == e ? void 0 : e.constructor;
        return "function" == typeof t && t.prototype === e || "function" != typeof e && i(e) ? o(e) : a(e) ? s(e) : [];
      } : o;
    e.exports = l;
  }, function (e, t, r) {
    function n(e, t) {
      return t = t || {}, {
        type: _.document,
        children: e,
        notes: t.notes || new u({}),
        comments: t.comments || []
      };
    }
    function i(e, t) {
      return t = t || {}, {
        type: _.paragraph,
        children: e,
        styleId: t.styleId || null,
        styleName: t.styleName || null,
        numbering: t.numbering || null,
        alignment: t.alignment || null
      };
    }
    function a(e, t) {
      return t = t || {}, {
        type: _.run,
        children: e,
        styleId: t.styleId || null,
        styleName: t.styleName || null,
        isBold: t.isBold,
        isUnderline: t.isUnderline,
        isItalic: t.isItalic,
        isStrikethrough: t.isStrikethrough,
        verticalAlignment: t.verticalAlignment || S.baseline,
        font: t.font || null
      };
    }
    function o(e) {
      return {
        type: _.text,
        value: e
      };
    }
    function s() {
      return {
        type: _.tab
      };
    }
    function l(e, t) {
      return {
        type: _.hyperlink,
        children: e,
        href: t.href,
        anchor: t.anchor
      };
    }
    function c(e) {
      return {
        type: _.noteReference,
        noteType: e.noteType,
        noteId: e.noteId
      };
    }
    function u(e) {
      this._notes = x.indexBy(e, function (e) {
        return p(e.noteType, e.noteId);
      });
    }
    function h(e) {
      return {
        type: _.note,
        noteType: e.noteType,
        noteId: e.noteId,
        body: e.body
      };
    }
    function f(e) {
      return {
        type: _.commentReference,
        commentId: e.commentId
      };
    }
    function d(e) {
      return {
        type: _.comment,
        commentId: e.commentId,
        body: e.body,
        authorName: e.authorName,
        authorInitials: e.authorInitials
      };
    }
    function p(e, t) {
      return e + "-" + t;
    }
    function m(e) {
      return {
        type: _.image,
        read: e.readImage,
        altText: e.altText,
        contentType: e.contentType
      };
    }
    function g(e) {
      return {
        type: _.table,
        children: e
      };
    }
    function v(e) {
      return {
        type: _.tableRow,
        children: e
      };
    }
    function b(e, t) {
      return t = t || {}, {
        type: _.tableCell,
        children: e,
        colSpan: null == t.colSpan ? 1 : t.colSpan,
        rowSpan: null == t.rowSpan ? 1 : t.rowSpan
      };
    }
    function y(e) {
      return {
        type: _.break,
        breakType: e
      };
    }
    function w(e) {
      return {
        type: _.bookmarkStart,
        name: e.name
      };
    }
    var x = r(1),
      _ = t.types = {
        document: "document",
        paragraph: "paragraph",
        run: "run",
        text: "text",
        tab: "tab",
        hyperlink: "hyperlink",
        noteReference: "noteReference",
        image: "image",
        note: "note",
        commentReference: "commentReference",
        comment: "comment",
        table: "table",
        tableRow: "tableRow",
        tableCell: "tableCell",
        break: "break",
        bookmarkStart: "bookmarkStart"
      },
      S = {
        baseline: "baseline",
        superscript: "superscript",
        subscript: "subscript"
      };
    u.prototype.resolve = function (e) {
      return this.findNoteByKey(p(e.noteType, e.noteId));
    }, u.prototype.findNoteByKey = function (e) {
      return this._notes[e] || null;
    }, t.document = t.Document = n, t.paragraph = t.Paragraph = i, t.run = t.Run = a, t.Text = o, t.tab = t.Tab = s, t.Hyperlink = l, t.noteReference = t.NoteReference = c, t.Notes = u, t.Note = h, t.commentReference = f, t.comment = d, t.Image = m, t.Table = g, t.TableRow = v, t.TableCell = b, t.lineBreak = y("line"), t.pageBreak = y("page"), t.columnBreak = y("column"), t.BookmarkStart = w, t.verticalAlignment = S;
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i,
        a,
        o,
        s,
        l,
        c,
        u,
        h,
        f = {}.hasOwnProperty;
      h = r(3), u = r(53), c = r(291), o = null, t = null, n = null, i = null, a = null, s = null, l = null, e.exports = function () {
        function e(e) {
          this.parent = e, this.options = this.parent.options, this.stringify = this.parent.stringify, null === o && (o = r(147), t = r(143), n = r(144), i = r(145), a = r(146), s = r(382), l = r(384));
        }
        return e.prototype.clone = function () {
          throw new Error("Cannot clone generic XMLNode");
        }, e.prototype.element = function (e, t, r) {
          var n, i, a, o, s, l, d;
          if (o = null, null == t && (t = {}), t = t.valueOf(), h(t) || (l = [t, r], r = l[0], t = l[1]), null != e && (e = e.valueOf()), Array.isArray(e)) for (i = 0, s = e.length; i < s; i++) n = e[i], o = this.element(n);else if (u(e)) o = this.element(e.apply());else if (h(e)) for (a in e) f.call(e, a) && (d = e[a], u(d) && (d = d.apply()), h(d) && c(d) && (d = null), !this.options.ignoreDecorators && this.stringify.convertAttKey && 0 === a.indexOf(this.stringify.convertAttKey) ? o = this.attribute(a.substr(this.stringify.convertAttKey.length), d) : !this.options.ignoreDecorators && this.stringify.convertPIKey && 0 === a.indexOf(this.stringify.convertPIKey) ? o = this.instruction(a.substr(this.stringify.convertPIKey.length), d) : h(d) ? !this.options.ignoreDecorators && this.stringify.convertListKey && 0 === a.indexOf(this.stringify.convertListKey) && Array.isArray(d) ? o = this.element(d) : (o = this.element(a), o.element(d)) : o = this.element(a, d));else o = !this.options.ignoreDecorators && this.stringify.convertTextKey && 0 === e.indexOf(this.stringify.convertTextKey) ? this.text(r) : !this.options.ignoreDecorators && this.stringify.convertCDataKey && 0 === e.indexOf(this.stringify.convertCDataKey) ? this.cdata(r) : !this.options.ignoreDecorators && this.stringify.convertCommentKey && 0 === e.indexOf(this.stringify.convertCommentKey) ? this.comment(r) : !this.options.ignoreDecorators && this.stringify.convertRawKey && 0 === e.indexOf(this.stringify.convertRawKey) ? this.raw(r) : this.node(e, t, r);
          if (null == o) throw new Error("Could not create any elements with: " + e);
          return o;
        }, e.prototype.insertBefore = function (e, t, r) {
          var n, i, a;
          if (this.isRoot) throw new Error("Cannot insert elements at root level");
          return i = this.parent.children.indexOf(this), a = this.parent.children.splice(i), n = this.parent.element(e, t, r), Array.prototype.push.apply(this.parent.children, a), n;
        }, e.prototype.insertAfter = function (e, t, r) {
          var n, i, a;
          if (this.isRoot) throw new Error("Cannot insert elements at root level");
          return i = this.parent.children.indexOf(this), a = this.parent.children.splice(i + 1), n = this.parent.element(e, t, r), Array.prototype.push.apply(this.parent.children, a), n;
        }, e.prototype.remove = function () {
          var e;
          if (this.isRoot) throw new Error("Cannot remove the root element");
          return e = this.parent.children.indexOf(this), [].splice.apply(this.parent.children, [e, e - e + 1].concat([])), this.parent;
        }, e.prototype.node = function (e, t, r) {
          var n, i;
          return null != e && (e = e.valueOf()), null == t && (t = {}), t = t.valueOf(), h(t) || (i = [t, r], r = i[0], t = i[1]), n = new o(this, e, t), null != r && n.text(r), this.children.push(n), n;
        }, e.prototype.text = function (e) {
          var t;
          return t = new l(this, e), this.children.push(t), this;
        }, e.prototype.cdata = function (e) {
          var r;
          return r = new t(this, e), this.children.push(r), this;
        }, e.prototype.comment = function (e) {
          var t;
          return t = new n(this, e), this.children.push(t), this;
        }, e.prototype.raw = function (e) {
          var t;
          return t = new s(this, e), this.children.push(t), this;
        }, e.prototype.declaration = function (e, t, r) {
          var n, a;
          return n = this.document(), a = new i(n, e, t, r), n.xmldec = a, n.root();
        }, e.prototype.doctype = function (e, t) {
          var r, n;
          return r = this.document(), n = new a(r, e, t), r.doctype = n, n;
        }, e.prototype.up = function () {
          if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
          return this.parent;
        }, e.prototype.root = function () {
          var e;
          if (this.isRoot) return this;
          for (e = this.parent; !e.isRoot;) e = e.parent;
          return e;
        }, e.prototype.document = function () {
          return this.root().documentObject;
        }, e.prototype.end = function (e) {
          return this.document().toString(e);
        }, e.prototype.prev = function () {
          var e;
          if (this.isRoot) throw new Error("Root node has no siblings");
          if ((e = this.parent.children.indexOf(this)) < 1) throw new Error("Already at the first node");
          return this.parent.children[e - 1];
        }, e.prototype.next = function () {
          var e;
          if (this.isRoot) throw new Error("Root node has no siblings");
          if (-1 === (e = this.parent.children.indexOf(this)) || e === this.parent.children.length - 1) throw new Error("Already at the last node");
          return this.parent.children[e + 1];
        }, e.prototype.importXMLBuilder = function (e) {
          var t;
          return t = e.root().clone(), t.parent = this, t.isRoot = !1, this.children.push(t), this;
        }, e.prototype.ele = function (e, t, r) {
          return this.element(e, t, r);
        }, e.prototype.nod = function (e, t, r) {
          return this.node(e, t, r);
        }, e.prototype.txt = function (e) {
          return this.text(e);
        }, e.prototype.dat = function (e) {
          return this.cdata(e);
        }, e.prototype.com = function (e) {
          return this.comment(e);
        }, e.prototype.doc = function () {
          return this.document();
        }, e.prototype.dec = function (e, t, r) {
          return this.declaration(e, t, r);
        }, e.prototype.dtd = function (e, t) {
          return this.doctype(e, t);
        }, e.prototype.e = function (e, t, r) {
          return this.element(e, t, r);
        }, e.prototype.n = function (e, t, r) {
          return this.node(e, t, r);
        }, e.prototype.t = function (e) {
          return this.text(e);
        }, e.prototype.d = function (e) {
          return this.cdata(e);
        }, e.prototype.c = function (e) {
          return this.comment(e);
        }, e.prototype.r = function (e) {
          return this.raw(e);
        }, e.prototype.u = function () {
          return this.up();
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(2),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    r(365);
    var a = function a() {
      return i.default.createElement("div", {
        className: "loading-container"
      }, i.default.createElement("span", {
        className: "loading"
      }));
    };
    t.default = a;
  }, function (e, t, r) {
    var n = r(33);
    e.exports = function (e) {
      if (!n(e)) throw TypeError(e + " is not an object!");
      return e;
    };
  }, function (e, t, r) {
    var n = r(99),
      i = r(61);
    e.exports = Object.keys || function (e) {
      return n(e, i);
    };
  }, function (e, t, r) {
    (function (e) {
      function r(e) {
        return Array.isArray ? Array.isArray(e) : "[object Array]" === g(e);
      }
      function n(e) {
        return "boolean" == typeof e;
      }
      function i(e) {
        return null === e;
      }
      function a(e) {
        return null == e;
      }
      function o(e) {
        return "number" == typeof e;
      }
      function s(e) {
        return "string" == typeof e;
      }
      function l(e) {
        return "symbol" == _typeof(e);
      }
      function c(e) {
        return void 0 === e;
      }
      function u(e) {
        return "[object RegExp]" === g(e);
      }
      function h(e) {
        return "object" == _typeof(e) && null !== e;
      }
      function f(e) {
        return "[object Date]" === g(e);
      }
      function d(e) {
        return "[object Error]" === g(e) || e instanceof Error;
      }
      function p(e) {
        return "function" == typeof e;
      }
      function m(e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == _typeof(e) || void 0 === e;
      }
      function g(e) {
        return Object.prototype.toString.call(e);
      }
      t.isArray = r, t.isBoolean = n, t.isNull = i, t.isNullOrUndefined = a, t.isNumber = o, t.isString = s, t.isSymbol = l, t.isUndefined = c, t.isRegExp = u, t.isObject = h, t.isDate = f, t.isError = d, t.isFunction = p, t.isPrimitive = m, t.isBuffer = e.isBuffer;
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      if (t.base64 = !0, t.array = !0, t.string = !0, t.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, t.nodebuffer = void 0 !== e, t.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) t.blob = !1;else {
        var r = new ArrayBuffer(0);
        try {
          t.blob = 0 === new Blob([r], {
            type: "application/zip"
          }).size;
        } catch (e) {
          try {
            var n = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
              i = new n();
            i.append(r), t.blob = 0 === i.getBlob("application/zip").size;
          } catch (e) {
            t.blob = !1;
          }
        }
      }
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0;
    var n = r(58),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = i.default || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    };
  }, function (e, t) {
    e.exports = !0;
  }, function (e, t) {
    t.f = {}.propertyIsEnumerable;
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        enumerable: !(1 & e),
        configurable: !(2 & e),
        writable: !(4 & e),
        value: t
      };
    };
  }, function (e, t, r) {
    var n = r(60);
    e.exports = function (e) {
      return Object(n(e));
    };
  }, function (e, t) {
    var r = 0,
      n = Math.random();
    e.exports = function (e) {
      return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++r + n).toString(36));
    };
  }, function (e, t, r) {
    function n(e) {
      return null != e && a(i(e));
    }
    var i = r(115),
      a = r(37);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return i(e) && s.call(e) == a;
    }
    var i = r(3),
      a = "[object Function]",
      o = Object.prototype,
      s = o.toString;
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      t.forEach(function (t) {
        i(e, t);
      });
    }
    function i(e, t) {
      l[t.type](e, t);
    }
    function a(e, t) {
      s.isVoidElement(t) ? e.selfClosing(t.tag.tagName, t.tag.attributes) : (e.open(t.tag.tagName, t.tag.attributes), n(e, t.children), e.close(t.tag.tagName));
    }
    function o(e, t) {
      e.text(t.value);
    }
    var s = r(126);
    t.freshElement = s.freshElement, t.nonFreshElement = s.nonFreshElement, t.elementWithTag = s.elementWithTag, t.text = s.text, t.forceWrite = s.forceWrite, t.simplify = r(320);
    var l = {
      element: a,
      text: o,
      forceWrite: function forceWrite() {}
    };
    t.write = n;
  }, function (e, t, r) {
    function n(e, t) {
      return i([o(e, t, {
        fresh: !0
      })]);
    }
    function i(e) {
      return new a(e.map(function (e) {
        return l.isString(e) ? o(e) : e;
      }));
    }
    function a(e) {
      this._elements = e;
    }
    function o(e, t, r) {
      return r = r || {}, new s(e, t, r);
    }
    function s(e, t, r) {
      var n = {};
      l.isArray(e) ? (e.forEach(function (e) {
        n[e] = !0;
      }), e = e[0]) : n[e] = !0, this.tagName = e, this.tagNames = n, this.attributes = t || {}, this.fresh = r.fresh, this.separator = r.separator;
    }
    var l = r(1),
      c = r(54);
    t.topLevelElement = n, t.elements = i, t.element = o, a.prototype.wrap = function (e) {
      for (var t = e(), r = this._elements.length - 1; r >= 0; r--) t = this._elements[r].wrapNodes(t);
      return t;
    }, s.prototype.matchesElement = function (e) {
      return this.tagNames[e.tagName] && l.isEqual(this.attributes || {}, e.attributes || {});
    }, s.prototype.wrap = function (e) {
      return this.wrapNodes(e());
    }, s.prototype.wrapNodes = function (e) {
      return [c.elementWithTag(this, e)];
    }, t.empty = i([]), t.ignore = {
      wrap: function wrap() {
        return [];
      }
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      function r(e, r, n, i) {
        if ("function" != typeof e) throw new TypeError('"callback" argument must be a function');
        var a,
          o,
          s = arguments.length;
        switch (s) {
          case 0:
          case 1:
            return t.nextTick(e);
          case 2:
            return t.nextTick(function () {
              e.call(null, r);
            });
          case 3:
            return t.nextTick(function () {
              e.call(null, r, n);
            });
          case 4:
            return t.nextTick(function () {
              e.call(null, r, n, i);
            });
          default:
            for (a = new Array(s - 1), o = 0; o < a.length;) a[o++] = arguments[o];
            return t.nextTick(function () {
              e.apply(null, a);
            });
        }
      }
      !t.version || 0 === t.version.indexOf("v0.") || 0 === t.version.indexOf("v1.") && 0 !== t.version.indexOf("v1.8.") ? e.exports = {
        nextTick: r
      } : e.exports = t;
    }).call(t, r(5));
  }, function (e, t, r) {
    function n(e, t) {
      for (var r in e) t[r] = e[r];
    }
    function i(e, t, r) {
      return o(e, t, r);
    }
    var a = r(14),
      o = a.Buffer;
    o.from && o.alloc && o.allocUnsafe && o.allocUnsafeSlow ? e.exports = a : (n(a, t), t.Buffer = i), n(o, i), i.from = function (e, t, r) {
      if ("number" == typeof e) throw new TypeError("Argument must not be a number");
      return o(e, t, r);
    }, i.alloc = function (e, t, r) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      var n = o(e);
      return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
    }, i.allocUnsafe = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return o(e);
    }, i.allocUnsafeSlow = function (e) {
      if ("number" != typeof e) throw new TypeError("Argument must be a number");
      return a.SlowBuffer(e);
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(172),
      __esModule: !0
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    t.__esModule = !0;
    var i = r(169),
      a = n(i),
      o = r(168),
      s = n(o),
      l = "function" == typeof s.default && "symbol" == _typeof(a.default) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : _typeof(e);
      };
    t.default = "function" == typeof s.default && "symbol" === l(a.default) ? function (e) {
      return void 0 === e ? "undefined" : l(e);
    } : function (e) {
      return e && "function" == typeof s.default && e.constructor === s.default && e !== s.default.prototype ? "symbol" : void 0 === e ? "undefined" : l(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 == e) throw TypeError("Can't call method on  " + e);
      return e;
    };
  }, function (e, t) {
    e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (e, t) {
    e.exports = {};
  }, function (e, t, r) {
    var n = r(42),
      i = r(190),
      a = r(61),
      o = r(66)("IE_PROTO"),
      s = function s() {},
      _l4 = function l() {
        var e,
          t = r(92)("iframe"),
          n = a.length;
        for (t.style.display = "none", r(184).appendChild(t), t.src = "javascript:", e = t.contentWindow.document, e.open(), e.write("<script>document.F=Object<\/script>"), e.close(), _l4 = e.F; n--;) delete _l4.prototype[a[n]];
        return _l4();
      };
    e.exports = Object.create || function (e, t) {
      var r;
      return null !== e ? (s.prototype = n(e), r = new s(), s.prototype = null, r[o] = e) : r = _l4(), void 0 === t ? r : i(r, t);
    };
  }, function (e, t) {
    t.f = Object.getOwnPropertySymbols;
  }, function (e, t, r) {
    var n = r(27).f,
      i = r(26),
      a = r(35)("toStringTag");
    e.exports = function (e, t, r) {
      e && !i(e = r ? e : e.prototype, a) && n(e, a, {
        configurable: !0,
        value: t
      });
    };
  }, function (e, t, r) {
    var n = r(67)("keys"),
      i = r(51);
    e.exports = function (e) {
      return n[e] || (n[e] = i(e));
    };
  }, function (e, t, r) {
    var n = r(11),
      i = r(17),
      a = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
    (e.exports = function (e, t) {
      return a[e] || (a[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: n.version,
      mode: r(47) ? "pure" : "global",
      copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
    });
  }, function (e, t) {
    var r = Math.ceil,
      n = Math.floor;
    e.exports = function (e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? n : r)(e);
    };
  }, function (e, t, r) {
    var n = r(33);
    e.exports = function (e, t) {
      if (!n(e)) return e;
      var r, i;
      if (t && "function" == typeof (r = e.toString) && !n(i = r.call(e))) return i;
      if ("function" == typeof (r = e.valueOf) && !n(i = r.call(e))) return i;
      if (!t && "function" == typeof (r = e.toString) && !n(i = r.call(e))) return i;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (e, t, r) {
    var n = r(17),
      i = r(11),
      a = r(47),
      o = r(71),
      s = r(27).f;
    e.exports = function (e) {
      var t = i.Symbol || (i.Symbol = a ? {} : n.Symbol || {});
      "_" == e.charAt(0) || e in t || s(t, e, {
        value: o.f(e)
      });
    };
  }, function (e, t, r) {
    t.f = r(35);
  }, function (e, t) {
    function r() {
      this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
    }
    function n(e) {
      return "function" == typeof e;
    }
    function i(e) {
      return "number" == typeof e;
    }
    function a(e) {
      return "object" == _typeof(e) && null !== e;
    }
    function o(e) {
      return void 0 === e;
    }
    e.exports = r, r.EventEmitter = r, r.prototype._events = void 0, r.prototype._maxListeners = void 0, r.defaultMaxListeners = 10, r.prototype.setMaxListeners = function (e) {
      if (!i(e) || e < 0 || isNaN(e)) throw TypeError("n must be a positive number");
      return this._maxListeners = e, this;
    }, r.prototype.emit = function (e) {
      var t, r, i, s, l, c;
      if (this._events || (this._events = {}), "error" === e && (!this._events.error || a(this._events.error) && !this._events.error.length)) {
        if ((t = arguments[1]) instanceof Error) throw t;
        var u = new Error('Uncaught, unspecified "error" event. (' + t + ")");
        throw u.context = t, u;
      }
      if (r = this._events[e], o(r)) return !1;
      if (n(r)) switch (arguments.length) {
        case 1:
          r.call(this);
          break;
        case 2:
          r.call(this, arguments[1]);
          break;
        case 3:
          r.call(this, arguments[1], arguments[2]);
          break;
        default:
          s = Array.prototype.slice.call(arguments, 1), r.apply(this, s);
      } else if (a(r)) for (s = Array.prototype.slice.call(arguments, 1), c = r.slice(), i = c.length, l = 0; l < i; l++) c[l].apply(this, s);
      return !0;
    }, r.prototype.addListener = function (e, t) {
      var i;
      if (!n(t)) throw TypeError("listener must be a function");
      return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e, n(t.listener) ? t.listener : t), this._events[e] ? a(this._events[e]) ? this._events[e].push(t) : this._events[e] = [this._events[e], t] : this._events[e] = t, a(this._events[e]) && !this._events[e].warned && (i = o(this._maxListeners) ? r.defaultMaxListeners : this._maxListeners) && i > 0 && this._events[e].length > i && (this._events[e].warned = !0, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e].length), "function" == typeof console.trace && console.trace()), this;
    }, r.prototype.on = r.prototype.addListener, r.prototype.once = function (e, t) {
      function r() {
        this.removeListener(e, r), i || (i = !0, t.apply(this, arguments));
      }
      if (!n(t)) throw TypeError("listener must be a function");
      var i = !1;
      return r.listener = t, this.on(e, r), this;
    }, r.prototype.removeListener = function (e, t) {
      var r, i, o, s;
      if (!n(t)) throw TypeError("listener must be a function");
      if (!this._events || !this._events[e]) return this;
      if (r = this._events[e], o = r.length, i = -1, r === t || n(r.listener) && r.listener === t) delete this._events[e], this._events.removeListener && this.emit("removeListener", e, t);else if (a(r)) {
        for (s = o; s-- > 0;) if (r[s] === t || r[s].listener && r[s].listener === t) {
          i = s;
          break;
        }
        if (i < 0) return this;
        1 === r.length ? (r.length = 0, delete this._events[e]) : r.splice(i, 1), this._events.removeListener && this.emit("removeListener", e, t);
      }
      return this;
    }, r.prototype.removeAllListeners = function (e) {
      var t, r;
      if (!this._events) return this;
      if (!this._events.removeListener) return 0 === arguments.length ? this._events = {} : this._events[e] && delete this._events[e], this;
      if (0 === arguments.length) {
        for (t in this._events) "removeListener" !== t && this.removeAllListeners(t);
        return this.removeAllListeners("removeListener"), this._events = {}, this;
      }
      if (r = this._events[e], n(r)) this.removeListener(e, r);else if (r) for (; r.length;) this.removeListener(e, r[r.length - 1]);
      return delete this._events[e], this;
    }, r.prototype.listeners = function (e) {
      return this._events && this._events[e] ? n(this._events[e]) ? [this._events[e]] : this._events[e].slice() : [];
    }, r.prototype.listenerCount = function (e) {
      if (this._events) {
        var t = this._events[e];
        if (n(t)) return 1;
        if (t) return t.length;
      }
      return 0;
    }, r.listenerCount = function (e, t) {
      return e.listenerCount(t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    t.encode = function (e, t) {
      for (var r, i, a, o, s, l, c, u = "", h = 0; h < e.length;) r = e.charCodeAt(h++), i = e.charCodeAt(h++), a = e.charCodeAt(h++), o = r >> 2, s = (3 & r) << 4 | i >> 4, l = (15 & i) << 2 | a >> 6, c = 63 & a, isNaN(i) ? l = c = 64 : isNaN(a) && (c = 64), u = u + n.charAt(o) + n.charAt(s) + n.charAt(l) + n.charAt(c);
      return u;
    }, t.decode = function (e, t) {
      var r,
        i,
        a,
        o,
        s,
        l,
        c,
        u = "",
        h = 0;
      for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); h < e.length;) o = n.indexOf(e.charAt(h++)), s = n.indexOf(e.charAt(h++)), l = n.indexOf(e.charAt(h++)), c = n.indexOf(e.charAt(h++)), r = o << 2 | s >> 4, i = (15 & s) << 4 | l >> 2, a = (3 & l) << 6 | c, u += String.fromCharCode(r), 64 != l && (u += String.fromCharCode(i)), 64 != c && (u += String.fromCharCode(a));
      return u;
    };
  }, function (e, t, r) {
    "use strict";

    t.STORE = {
      magic: "\0\0",
      compress: function compress(e, t) {
        return e;
      },
      uncompress: function uncompress(e) {
        return e;
      },
      compressInputType: null,
      uncompressInputType: null
    }, t.DEFLATE = r(254);
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      e.exports = function (e, r) {
        return new t(e, r);
      }, e.exports.test = function (e) {
        return t.isBuffer(e);
      };
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    "use strict";

    var n = r(45),
      i = r(12),
      a = r(252),
      o = r(107),
      s = r(106),
      l = r(73),
      c = r(74),
      u = r(104),
      h = r(75),
      f = r(260),
      d = r(258),
      p = r(259),
      m = function m(e) {
        if (e._data instanceof u && (e._data = e._data.getContent(), e.options.binary = !0, e.options.base64 = !1, "uint8array" === i.getTypeOf(e._data))) {
          var t = e._data;
          e._data = new Uint8Array(t.length), 0 !== t.length && e._data.set(t, 0);
        }
        return e._data;
      },
      g = function g(e) {
        var t = m(e);
        return "string" === i.getTypeOf(t) ? !e.options.binary && n.nodebuffer ? h(t, "utf-8") : e.asBinary() : t;
      },
      v = function v(e) {
        var t = m(this);
        return null === t || void 0 === t ? "" : (this.options.base64 && (t = l.decode(t)), t = e && this.options.binary ? I.utf8decode(t) : i.transformTo("string", t), e || this.options.binary || (t = i.transformTo("string", I.utf8encode(t))), t);
      },
      b = function b(e, t, r) {
        this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this.options = r, this._initialMetadata = {
          dir: r.dir,
          date: r.date
        };
      };
    b.prototype = {
      asText: function asText() {
        return v.call(this, !0);
      },
      asBinary: function asBinary() {
        return v.call(this, !1);
      },
      asNodeBuffer: function asNodeBuffer() {
        var e = g(this);
        return i.transformTo("nodebuffer", e);
      },
      asUint8Array: function asUint8Array() {
        var e = g(this);
        return i.transformTo("uint8array", e);
      },
      asArrayBuffer: function asArrayBuffer() {
        return this.asUint8Array().buffer;
      }
    };
    var y = function y(e, t) {
        var r,
          n = "";
        for (r = 0; r < t; r++) n += String.fromCharCode(255 & e), e >>>= 8;
        return n;
      },
      w = function w() {
        var e,
          t,
          r = {};
        for (e = 0; e < arguments.length; e++) for (t in arguments[e]) arguments[e].hasOwnProperty(t) && void 0 === r[t] && (r[t] = arguments[e][t]);
        return r;
      },
      x = function x(e) {
        return e = e || {}, !0 !== e.base64 || null !== e.binary && void 0 !== e.binary || (e.binary = !0), e = w(e, s), e.date = e.date || new Date(), null !== e.compression && (e.compression = e.compression.toUpperCase()), e;
      },
      _ = function _(e, t, r) {
        var n,
          a = i.getTypeOf(t);
        if (r = x(r), "string" == typeof r.unixPermissions && (r.unixPermissions = parseInt(r.unixPermissions, 8)), r.unixPermissions && 16384 & r.unixPermissions && (r.dir = !0), r.dosPermissions && 16 & r.dosPermissions && (r.dir = !0), r.dir && (e = C(e)), r.createFolders && (n = S(e)) && E.call(this, n, !0), r.dir || null === t || void 0 === t) r.base64 = !1, r.binary = !1, t = null, a = null;else if ("string" === a) r.binary && !r.base64 && !0 !== r.optimizedBinaryString && (t = i.string2binary(t));else {
          if (r.base64 = !1, r.binary = !0, !(a || t instanceof u)) throw new Error("The data of '" + e + "' is in an unsupported format !");
          "arraybuffer" === a && (t = i.transformTo("uint8array", t));
        }
        var o = new b(e, t, r);
        return this.files[e] = o, o;
      },
      S = function S(e) {
        "/" == e.slice(-1) && (e = e.substring(0, e.length - 1));
        var t = e.lastIndexOf("/");
        return t > 0 ? e.substring(0, t) : "";
      },
      C = function C(e) {
        return "/" != e.slice(-1) && (e += "/"), e;
      },
      E = function E(e, t) {
        return t = void 0 !== t && t, e = C(e), this.files[e] || _.call(this, e, null, {
          dir: !0,
          createFolders: t
        }), this.files[e];
      },
      A = function A(e, t, r) {
        var n,
          o = new u();
        return e._data instanceof u ? (o.uncompressedSize = e._data.uncompressedSize, o.crc32 = e._data.crc32, 0 === o.uncompressedSize || e.dir ? (t = c.STORE, o.compressedContent = "", o.crc32 = 0) : e._data.compressionMethod === t.magic ? o.compressedContent = e._data.getCompressedContent() : (n = e._data.getContent(), o.compressedContent = t.compress(i.transformTo(t.compressInputType, n), r))) : (n = g(e), n && 0 !== n.length && !e.dir || (t = c.STORE, n = ""), o.uncompressedSize = n.length, o.crc32 = a(n), o.compressedContent = t.compress(i.transformTo(t.compressInputType, n), r)), o.compressedSize = o.compressedContent.length, o.compressionMethod = t.magic, o;
      },
      T = function T(e, t) {
        var r = e;
        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
      },
      k = function k(e, t) {
        return 63 & (e || 0);
      },
      R = function R(e, t, r, n, s) {
        var l,
          c,
          u,
          h,
          d = (r.compressedContent, i.transformTo("string", f.utf8encode(t.name))),
          p = t.comment || "",
          m = i.transformTo("string", f.utf8encode(p)),
          g = d.length !== t.name.length,
          v = m.length !== p.length,
          b = t.options,
          w = "",
          x = "",
          _ = "";
        u = t._initialMetadata.dir !== t.dir ? t.dir : b.dir, h = t._initialMetadata.date !== t.date ? t.date : b.date;
        var S = 0,
          C = 0;
        u && (S |= 16), "UNIX" === s ? (C = 798, S |= T(t.unixPermissions, u)) : (C = 20, S |= k(t.dosPermissions)), l = h.getHours(), l <<= 6, l |= h.getMinutes(), l <<= 5, l |= h.getSeconds() / 2, c = h.getFullYear() - 1980, c <<= 4, c |= h.getMonth() + 1, c <<= 5, c |= h.getDate(), g && (x = y(1, 1) + y(a(d), 4) + d, w += "up" + y(x.length, 2) + x), v && (_ = y(1, 1) + y(this.crc32(m), 4) + m, w += "uc" + y(_.length, 2) + _);
        var E = "";
        return E += "\n\0", E += g || v ? "\0\b" : "\0\0", E += r.compressionMethod, E += y(l, 2), E += y(c, 2), E += y(r.crc32, 4), E += y(r.compressedSize, 4), E += y(r.uncompressedSize, 4), E += y(d.length, 2), E += y(w.length, 2), {
          fileRecord: o.LOCAL_FILE_HEADER + E + d + w,
          dirRecord: o.CENTRAL_FILE_HEADER + y(C, 2) + E + y(m.length, 2) + "\0\0\0\0" + y(S, 4) + y(n, 4) + d + w + m,
          compressedObject: r
        };
      },
      I = {
        load: function load(e, t) {
          throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
        },
        filter: function filter(e) {
          var t,
            r,
            n,
            i,
            a = [];
          for (t in this.files) this.files.hasOwnProperty(t) && (n = this.files[t], i = new b(n.name, n._data, w(n.options)), r = t.slice(this.root.length, t.length), t.slice(0, this.root.length) === this.root && e(r, i) && a.push(i));
          return a;
        },
        file: function file(e, t, r) {
          if (1 === arguments.length) {
            if (i.isRegExp(e)) {
              var n = e;
              return this.filter(function (e, t) {
                return !t.dir && n.test(e);
              });
            }
            return this.filter(function (t, r) {
              return !r.dir && t === e;
            })[0] || null;
          }
          return e = this.root + e, _.call(this, e, t, r), this;
        },
        folder: function folder(e) {
          if (!e) return this;
          if (i.isRegExp(e)) return this.filter(function (t, r) {
            return r.dir && e.test(t);
          });
          var t = this.root + e,
            r = E.call(this, t),
            n = this.clone();
          return n.root = r.name, n;
        },
        remove: function remove(e) {
          e = this.root + e;
          var t = this.files[e];
          if (t || ("/" != e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];else for (var r = this.filter(function (t, r) {
              return r.name.slice(0, e.length) === e;
            }), n = 0; n < r.length; n++) delete this.files[r[n].name];
          return this;
        },
        generate: function generate(e) {
          e = w(e || {}, {
            base64: !0,
            compression: "STORE",
            compressionOptions: null,
            type: "base64",
            platform: "DOS",
            comment: null,
            mimeType: "application/zip"
          }), i.checkSupport(e.type), "darwin" !== e.platform && "freebsd" !== e.platform && "linux" !== e.platform && "sunos" !== e.platform || (e.platform = "UNIX"), "win32" === e.platform && (e.platform = "DOS");
          var t,
            r,
            n = [],
            a = 0,
            s = 0,
            u = i.transformTo("string", this.utf8encode(e.comment || this.comment || ""));
          for (var h in this.files) if (this.files.hasOwnProperty(h)) {
            var f = this.files[h],
              m = f.options.compression || e.compression.toUpperCase(),
              g = c[m];
            if (!g) throw new Error(m + " is not a valid compression method !");
            var v = f.options.compressionOptions || e.compressionOptions || {},
              b = A.call(this, f, g, v),
              x = R.call(this, h, f, b, a, e.platform);
            a += x.fileRecord.length + b.compressedSize, s += x.dirRecord.length, n.push(x);
          }
          var _ = "";
          _ = o.CENTRAL_DIRECTORY_END + "\0\0\0\0" + y(n.length, 2) + y(n.length, 2) + y(s, 4) + y(a, 4) + y(u.length, 2) + u;
          var S = e.type.toLowerCase();
          for (t = "uint8array" === S || "arraybuffer" === S || "blob" === S || "nodebuffer" === S ? new p(a + s + _.length) : new d(a + s + _.length), r = 0; r < n.length; r++) t.append(n[r].fileRecord), t.append(n[r].compressedObject.compressedContent);
          for (r = 0; r < n.length; r++) t.append(n[r].dirRecord);
          t.append(_);
          var C = t.finalize();
          switch (e.type.toLowerCase()) {
            case "uint8array":
            case "arraybuffer":
            case "nodebuffer":
              return i.transformTo(e.type.toLowerCase(), C);
            case "blob":
              return i.arrayBuffer2Blob(i.transformTo("arraybuffer", C), e.mimeType);
            case "base64":
              return e.base64 ? l.encode(C) : C;
            default:
              return C;
          }
        },
        crc32: function crc32(e, t) {
          return a(e, t);
        },
        utf8encode: function utf8encode(e) {
          return i.transformTo("string", f.utf8encode(e));
        },
        utf8decode: function utf8decode(e) {
          return f.utf8decode(e);
        }
      };
    e.exports = I;
  }, function (e, t) {
    function r(e, t) {
      return e = "number" == typeof e || n.test(e) ? +e : -1, t = null == t ? i : t, e > -1 && e % 1 == 0 && e < t;
    }
    var n = /^\d+$/,
      i = 9007199254740991;
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r) {
      if (!o(r)) return !1;
      var n = _typeof(t);
      if ("number" == n ? i(r) && a(t, r.length) : "string" == n && t in r) {
        var s = r[t];
        return e === e ? e === s : s !== s;
      }
      return !1;
    }
    var i = r(52),
      a = r(77),
      o = r(3);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return a(e) && i(e) && s.call(e, "callee") && !l.call(e, "callee");
    }
    var i = r(52),
      a = r(29),
      o = Object.prototype,
      s = o.hasOwnProperty,
      l = o.propertyIsEnumerable;
    e.exports = n;
  }, function (e, t) {
    e.exports = {
      failure: function failure(e, t) {
        if (e.length < 1) throw new Error("Failure must have errors");
        return new r({
          status: "failure",
          remaining: t,
          errors: e
        });
      },
      error: function error(e, t) {
        if (e.length < 1) throw new Error("Failure must have errors");
        return new r({
          status: "error",
          remaining: t,
          errors: e
        });
      },
      success: function success(e, t, n) {
        return new r({
          status: "success",
          value: e,
          source: n,
          remaining: t,
          errors: []
        });
      },
      cut: function cut(e) {
        return new r({
          status: "cut",
          remaining: e,
          errors: []
        });
      }
    };
    var r = function r(e) {
      this._value = e.value, this._status = e.status, this._hasValue = void 0 !== e.value, this._remaining = e.remaining, this._source = e.source, this._errors = e.errors;
    };
    r.prototype.map = function (e) {
      return this._hasValue ? new r({
        value: e(this._value, this._source),
        status: this._status,
        remaining: this._remaining,
        source: this._source,
        errors: this._errors
      }) : this;
    }, r.prototype.changeRemaining = function (e) {
      return new r({
        value: this._value,
        status: this._status,
        remaining: e,
        source: this._source,
        errors: this._errors
      });
    }, r.prototype.isSuccess = function () {
      return "success" === this._status || "cut" === this._status;
    }, r.prototype.isFailure = function () {
      return "failure" === this._status;
    }, r.prototype.isError = function () {
      return "error" === this._status;
    }, r.prototype.isCut = function () {
      return "cut" === this._status;
    }, r.prototype.value = function () {
      return this._value;
    }, r.prototype.remaining = function () {
      return this._remaining;
    }, r.prototype.source = function () {
      return this._source;
    }, r.prototype.errors = function () {
      return this._errors;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    };
  }, function (e, t, r) {
    "use strict";

    (function (t, n, i) {
      function a(e) {
        var t = this;
        this.next = null, this.entry = null, this.finish = function () {
          T(t, e);
        };
      }
      function o(e) {
        return B.from(e);
      }
      function s(e) {
        return B.isBuffer(e) || e instanceof D;
      }
      function l() {}
      function c(e, t) {
        R = R || r(30), e = e || {};
        var n = t instanceof R;
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.writableObjectMode);
        var i = e.highWaterMark,
          o = e.writableHighWaterMark,
          s = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : s, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var l = !1 === e.decodeStrings;
        this.decodeStrings = !l, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (e) {
          b(t, e);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
      }
      function u(e) {
        if (R = R || r(30), !(F.call(u, this) || this instanceof R)) return new u(e);
        this._writableState = new c(e, this), this.writable = !0, e && ("function" == typeof e.write && (this._write = e.write), "function" == typeof e.writev && (this._writev = e.writev), "function" == typeof e.destroy && (this._destroy = e.destroy), "function" == typeof e.final && (this._final = e.final)), P.call(this);
      }
      function h(e, t) {
        var r = new Error("write after end");
        e.emit("error", r), k.nextTick(t, r);
      }
      function f(e, t, r, n) {
        var i = !0,
          a = !1;
        return null === r ? a = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (e.emit("error", a), k.nextTick(n, a), i = !1), i;
      }
      function d(e, t, r) {
        return e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = B.from(t, r)), t;
      }
      function p(e, t, r, n, i, a) {
        if (!r) {
          var o = d(t, n, i);
          n !== o && (r = !0, i = "buffer", n = o);
        }
        var s = t.objectMode ? 1 : n.length;
        t.length += s;
        var l = t.length < t.highWaterMark;
        if (l || (t.needDrain = !0), t.writing || t.corked) {
          var c = t.lastBufferedRequest;
          t.lastBufferedRequest = {
            chunk: n,
            encoding: i,
            isBuf: r,
            callback: a,
            next: null
          }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
        } else m(e, t, !1, s, n, i, a);
        return l;
      }
      function m(e, t, r, n, i, a, o) {
        t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, a, t.onwrite), t.sync = !1;
      }
      function g(e, t, r, n, i) {
        --t.pendingcb, r ? (k.nextTick(i, n), k.nextTick(E, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), E(e, t));
      }
      function v(e) {
        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
      }
      function b(e, t) {
        var r = e._writableState,
          n = r.sync,
          i = r.writecb;
        if (v(r), t) g(e, r, n, t, i);else {
          var a = _(r);
          a || r.corked || r.bufferProcessing || !r.bufferedRequest || x(e, r), n ? I(y, e, r, a, i) : y(e, r, a, i);
        }
      }
      function y(e, t, r, n) {
        r || w(e, t), t.pendingcb--, n(), E(e, t);
      }
      function w(e, t) {
        0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
      }
      function x(e, t) {
        t.bufferProcessing = !0;
        var r = t.bufferedRequest;
        if (e._writev && r && r.next) {
          var n = t.bufferedRequestCount,
            i = new Array(n),
            o = t.corkedRequestsFree;
          o.entry = r;
          for (var s = 0, l = !0; r;) i[s] = r, r.isBuf || (l = !1), r = r.next, s += 1;
          i.allBuffers = l, m(e, t, !0, t.length, i, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new a(t), t.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var c = r.chunk,
              u = r.encoding,
              h = r.callback;
            if (m(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
          }
          null === r && (t.lastBufferedRequest = null);
        }
        t.bufferedRequest = r, t.bufferProcessing = !1;
      }
      function _(e) {
        return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
      }
      function S(e, t) {
        e._final(function (r) {
          t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), E(e, t);
        });
      }
      function C(e, t) {
        t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, k.nextTick(S, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
      }
      function E(e, t) {
        var r = _(t);
        return r && (C(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
      }
      function A(e, t, r) {
        t.ending = !0, E(e, t), r && (t.finished ? k.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
      }
      function T(e, t, r) {
        var n = e.entry;
        for (e.entry = null; n;) {
          var i = n.callback;
          t.pendingcb--, i(r), n = n.next;
        }
        t.corkedRequestsFree ? t.corkedRequestsFree.next = e : t.corkedRequestsFree = e;
      }
      var k = r(56);
      e.exports = u;
      var R,
        I = !t.browser && ["v0.10", "v0.9."].indexOf(t.version.slice(0, 5)) > -1 ? n : k.nextTick;
      u.WritableState = c;
      var M = r(44);
      M.inherits = r(28);
      var O = {
          deprecate: r(371)
        },
        P = r(138),
        B = r(57).Buffer,
        D = i.Uint8Array || function () {},
        L = r(137);
      M.inherits(u, P), c.prototype.getBuffer = function () {
        for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
        return t;
      }, function () {
        try {
          Object.defineProperty(c.prototype, "buffer", {
            get: O.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (e) {}
      }();
      var F;
      "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (F = Function.prototype[Symbol.hasInstance], Object.defineProperty(u, Symbol.hasInstance, {
        value: function value(e) {
          return !!F.call(this, e) || this === u && e && e._writableState instanceof c;
        }
      })) : F = function F(e) {
        return e instanceof this;
      }, u.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, u.prototype.write = function (e, t, r) {
        var n = this._writableState,
          i = !1,
          a = !n.objectMode && s(e);
        return a && !B.isBuffer(e) && (e = o(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = n.defaultEncoding), "function" != typeof r && (r = l), n.ended ? h(this, r) : (a || f(this, n, e, r)) && (n.pendingcb++, i = p(this, n, a, e, t, r)), i;
      }, u.prototype.cork = function () {
        this._writableState.corked++;
      }, u.prototype.uncork = function () {
        var e = this._writableState;
        e.corked && (e.corked--, e.writing || e.corked || e.finished || e.bufferProcessing || !e.bufferedRequest || x(this, e));
      }, u.prototype.setDefaultEncoding = function (e) {
        if ("string" == typeof e && (e = e.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
        return this._writableState.defaultEncoding = e, this;
      }, Object.defineProperty(u.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), u.prototype._write = function (e, t, r) {
        r(new Error("_write() is not implemented"));
      }, u.prototype._writev = null, u.prototype.end = function (e, t, r) {
        var n = this._writableState;
        "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null !== e && void 0 !== e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || A(this, n, r);
      }, Object.defineProperty(u.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(e) {
          this._writableState && (this._writableState.destroyed = e);
        }
      }), u.prototype.destroy = L.destroy, u.prototype._undestroy = L.undestroy, u.prototype._destroy = function (e, t) {
        this.end(), t(e);
      };
    }).call(t, r(5), r(141).setImmediate, r(13));
  }, function (e, t, r) {
    t = e.exports = r(135), t.Stream = t, t.Readable = t, t.Writable = r(82), t.Duplex = r(30), t.Transform = r(136), t.PassThrough = r(357);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!e) return "utf8";
      for (var t;;) switch (e) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return e;
        default:
          if (t) return;
          e = ("" + e).toLowerCase(), t = !0;
      }
    }
    function i(e) {
      var t = n(e);
      if ("string" != typeof t && (b.isEncoding === y || !y(e))) throw new Error("Unknown encoding: " + e);
      return t || e;
    }
    function a(e) {
      this.encoding = i(e);
      var t;
      switch (this.encoding) {
        case "utf16le":
          this.text = f, this.end = d, t = 4;
          break;
        case "utf8":
          this.fillLast = c, t = 4;
          break;
        case "base64":
          this.text = p, this.end = m, t = 3;
          break;
        default:
          return this.write = g, void (this.end = v);
      }
      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = b.allocUnsafe(t);
    }
    function o(e) {
      return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
    }
    function s(e, t, r) {
      var n = t.length - 1;
      if (n < r) return 0;
      var i = o(t[n]);
      return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --n < r || -2 === i ? 0 : (i = o(t[n])) >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --n < r || -2 === i ? 0 : (i = o(t[n]), i >= 0 ? (i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i) : 0);
    }
    function l(e, t, r) {
      if (128 != (192 & t[0])) return e.lastNeed = 0, "�";
      if (e.lastNeed > 1 && t.length > 1) {
        if (128 != (192 & t[1])) return e.lastNeed = 1, "�";
        if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "�";
      }
    }
    function c(e) {
      var t = this.lastTotal - this.lastNeed,
        r = l(this, e, t);
      return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
    }
    function u(e, t) {
      var r = s(this, e, t);
      if (!this.lastNeed) return e.toString("utf8", t);
      this.lastTotal = r;
      var n = e.length - (r - this.lastNeed);
      return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
    }
    function h(e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + "�" : t;
    }
    function f(e, t) {
      if ((e.length - t) % 2 == 0) {
        var r = e.toString("utf16le", t);
        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
        }
        return r;
      }
      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
    }
    function d(e) {
      var t = e && e.length ? this.write(e) : "";
      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return t + this.lastChar.toString("utf16le", 0, r);
      }
      return t;
    }
    function p(e, t) {
      var r = (e.length - t) % 3;
      return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
    }
    function m(e) {
      var t = e && e.length ? this.write(e) : "";
      return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
    }
    function g(e) {
      return e.toString(this.encoding);
    }
    function v(e) {
      return e && e.length ? this.write(e) : "";
    }
    var b = r(57).Buffer,
      y = b.isEncoding || function (e) {
        switch ((e = "" + e) && e.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
    t.StringDecoder = a, a.prototype.write = function (e) {
      if (0 === e.length) return "";
      var t, r;
      if (this.lastNeed) {
        if (void 0 === (t = this.fillLast(e))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;
      return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
    }, a.prototype.end = h, a.prototype.text = u, a.prototype.fillLast = function (e) {
      if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(10),
      c = n(l),
      u = r(8),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p),
      g = r(351),
      v = n(g),
      b = r(241),
      y = n(b),
      w = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var r = (0, c.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
          return r.state = t.parse(e.data), r;
        }
        return (0, d.default)(t, e), (0, h.default)(t, null, [{
          key: "parse",
          value: function value(e) {
            var t = [],
              r = [];
            return new y.default(e).forEach(function (e) {
              if (r.length < 1) e.forEach(function (e, t) {
                r.push({
                  key: "key-" + t,
                  name: e,
                  resizable: !0,
                  sortable: !0,
                  filterable: !0
                });
              });else {
                var n = {};
                e.forEach(function (e, t) {
                  n["key-" + t] = e;
                }), t.push(n);
              }
            }), {
              rows: t,
              columns: r
            };
          }
        }]), (0, h.default)(t, [{
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.setState(t.parse(e.data));
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.state,
              t = e.rows,
              r = e.columns;
            return m.default.createElement(v.default, {
              columns: r,
              rowsCount: t.length,
              rowGetter: function rowGetter(e) {
                return t[e];
              },
              minHeight: this.props.height || 650
            });
          }
        }]), t;
      }(p.Component);
    t.default = w;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p);
    r(367);
    var g = function (e) {
      function t() {
        return (0, s.default)(this, t), (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).apply(this, arguments));
      }
      return (0, d.default)(t, e), (0, c.default)(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
            t = e.originalWidth,
            r = e.originalHeight,
            n = this.getImageDimensions.call(this, t, r);
          this.props.texture.image.style.width = n.width + "px", this.props.texture.image.style.height = n.height + "px", this.props.texture.image.setAttribute("class", "photo"), document.getElementById("pg-photo-container").appendChild(this.props.texture.image);
        }
      }, {
        key: "getImageDimensions",
        value: function value(e, t) {
          var r = void 0,
            n = void 0,
            i = this.props,
            a = i.height,
            o = i.width;
          if (t <= a && e <= o) n = e, r = t;else {
            var s = a / t,
              l = o / e;
            s < l ? (r = t * s, n = e * s) : (r = t * l, n = e * l);
          }
          return {
            height: r,
            width: n
          };
        }
      }, {
        key: "render",
        value: function value() {
          var e = {
            width: this.props.width + "px",
            height: this.props.height + "px"
          };
          return m.default.createElement("div", {
            style: e,
            className: "photo-viewer-container",
            id: "pg-photo-container"
          });
        }
      }]), t;
    }(p.Component);
    t.default = g;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p),
      g = r(140),
      v = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t.default = e, t;
      }(g);
    r(368);
    var b = function (e) {
      function t(e) {
        (0, s.default)(this, t);
        var r = (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
        return r.onMouseDown = r.onMouseDown.bind(r), r.onMouseMove = r.onMouseMove.bind(r), r.onMouseUp = r.onMouseUp.bind(r), r.state = {
          manualControl: !1,
          longitude: 0,
          latitude: 0,
          savedX: void 0,
          savedY: void 0,
          savedLongitude: void 0,
          savedLatitude: void 0
        }, r;
      }
      return (0, d.default)(t, e), (0, c.default)(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = document.getElementById("360-photo"),
            t = e.getBoundingClientRect(),
            r = t.height,
            n = t.width;
          this.renderer = new v.WebGLRenderer(), this.renderer.setSize(n, r), e.appendChild(this.renderer.domElement), this.scene = new v.Scene(), this.camera = new v.PerspectiveCamera(75, n / r, 1, 1e3), this.camera.target = new v.Vector3(0, 0, 0), this.sphere = new v.SphereGeometry(100, 100, 40), this.sphere.applyMatrix(new v.Matrix4().makeScale(-1, 1, 1)), this.sphereMaterial = new v.MeshBasicMaterial(), this.sphereMaterial.map = this.props.texture;
          var i = new v.Mesh(this.sphere, this.sphereMaterial);
          this.scene.add(i), this.updateView();
        }
      }, {
        key: "componentWillUpdate",
        value: function value() {
          this.updateView();
        }
      }, {
        key: "onMouseMove",
        value: function value(e) {
          var t = this.state,
            r = t.savedX,
            n = t.savedY,
            i = t.savedLongitude,
            a = t.savedLatitude;
          if (this.state.manualControl) {
            var o = .1 * (r - e.clientX) + i,
              s = .1 * (e.clientY - n) + a;
            this.setState({
              longitude: o,
              latitude: s
            });
          }
        }
      }, {
        key: "onMouseUp",
        value: function value() {
          this.setState({
            manualControl: !1
          });
        }
      }, {
        key: "onMouseDown",
        value: function value(e) {
          e.preventDefault(), this.setState({
            savedLongitude: this.state.longitude,
            savedLatitude: this.state.latitude,
            savedX: e.clientX,
            savedY: e.clientY,
            manualControl: !0
          });
        }
      }, {
        key: "updateView",
        value: function value() {
          var e = Math.max(-85, Math.min(85, this.state.latitude));
          this.camera.target.x = 500 * Math.sin(v.Math.degToRad(90 - e)) * Math.cos(v.Math.degToRad(this.state.longitude)), this.camera.target.y = 500 * Math.cos(v.Math.degToRad(90 - e)), this.camera.target.z = 500 * Math.sin(v.Math.degToRad(90 - e)) * Math.sin(v.Math.degToRad(this.state.longitude)), this.camera.lookAt(this.camera.target), this.renderer.render(this.scene, this.camera);
        }
      }, {
        key: "render",
        value: function value() {
          return m.default.createElement("div", {
            id: "360-photo",
            className: "photo360",
            onMouseDown: this.onMouseDown,
            onMouseMove: this.onMouseMove,
            onMouseUp: this.onMouseUp
          });
        }
      }]), t;
    }(p.Component);
    t.default = b;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(2),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    r(364);
    var a = function a(e) {
      return i.default.createElement("div", {
        className: "error-message"
      }, e.errorComponent ? i.default.createElement(e.errorComponent, e) : i.default.createElement("p", {
        className: "alert"
      }, "Unable to preview file"));
    };
    t.default = a;
  }, function (e, t, r) {
    e.exports = {
      default: r(174),
      __esModule: !0
    };
  }, function (e, t) {
    var r = {}.toString;
    e.exports = function (e) {
      return r.call(e).slice(8, -1);
    };
  }, function (e, t, r) {
    var n = r(180);
    e.exports = function (e, t, r) {
      if (n(e), void 0 === t) return e;
      switch (r) {
        case 1:
          return function (r) {
            return e.call(t, r);
          };
        case 2:
          return function (r, n) {
            return e.call(t, r, n);
          };
        case 3:
          return function (r, n, i) {
            return e.call(t, r, n, i);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    };
  }, function (e, t, r) {
    var n = r(33),
      i = r(17).document,
      a = n(i) && n(i.createElement);
    e.exports = function (e) {
      return a ? i.createElement(e) : {};
    };
  }, function (e, t, r) {
    e.exports = !r(24) && !r(31)(function () {
      return 7 != Object.defineProperty(r(92)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (e, t, r) {
    var n = r(90);
    e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
      return "String" == n(e) ? e.split("") : Object(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(47),
      i = r(25),
      a = r(101),
      o = r(32),
      s = r(62),
      l = r(186),
      c = r(65),
      u = r(98),
      h = r(35)("iterator"),
      f = !([].keys && "next" in [].keys()),
      d = function d() {
        return this;
      };
    e.exports = function (e, t, r, p, m, g, v) {
      l(r, t, p);
      var b,
        y,
        w,
        x = function x(e) {
          if (!f && e in E) return E[e];
          switch (e) {
            case "keys":
            case "values":
              return function () {
                return new r(this, e);
              };
          }
          return function () {
            return new r(this, e);
          };
        },
        _ = t + " Iterator",
        S = "values" == m,
        C = !1,
        E = e.prototype,
        A = E[h] || E["@@iterator"] || m && E[m],
        T = A || x(m),
        k = m ? S ? x("entries") : T : void 0,
        R = "Array" == t ? E.entries || A : A;
      if (R && (w = u(R.call(new e()))) !== Object.prototype && w.next && (c(w, _, !0), n || "function" == typeof w[h] || o(w, h, d)), S && A && "values" !== A.name && (C = !0, T = function T() {
        return A.call(this);
      }), n && !v || !f && !C && E[h] || o(E, h, T), s[t] = T, s[_] = d, m) if (b = {
        values: S ? T : x("values"),
        keys: g ? T : x("keys"),
        entries: k
      }, v) for (y in b) y in E || a(E, y, b[y]);else i(i.P + i.F * (f || C), t, b);
      return b;
    };
  }, function (e, t, r) {
    var n = r(48),
      i = r(49),
      a = r(34),
      o = r(69),
      s = r(26),
      l = r(93),
      c = Object.getOwnPropertyDescriptor;
    t.f = r(24) ? c : function (e, t) {
      if (e = a(e), t = o(t, !0), l) try {
        return c(e, t);
      } catch (e) {}
      if (s(e, t)) return i(!n.f.call(e, t), e[t]);
    };
  }, function (e, t, r) {
    var n = r(99),
      i = r(61).concat("length", "prototype");
    t.f = Object.getOwnPropertyNames || function (e) {
      return n(e, i);
    };
  }, function (e, t, r) {
    var n = r(26),
      i = r(50),
      a = r(66)("IE_PROTO"),
      o = Object.prototype;
    e.exports = Object.getPrototypeOf || function (e) {
      return e = i(e), n(e, a) ? e[a] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? o : null;
    };
  }, function (e, t, r) {
    var n = r(26),
      i = r(34),
      a = r(182)(!1),
      o = r(66)("IE_PROTO");
    e.exports = function (e, t) {
      var r,
        s = i(e),
        l = 0,
        c = [];
      for (r in s) r != o && n(s, r) && c.push(r);
      for (; t.length > l;) n(s, r = t[l++]) && (~a(c, r) || c.push(r));
      return c;
    };
  }, function (e, t, r) {
    var n = r(25),
      i = r(11),
      a = r(31);
    e.exports = function (e, t) {
      var r = (i.Object || {})[e] || Object[e],
        o = {};
      o[e] = t(r), n(n.S + n.F * a(function () {
        r(1);
      }), "Object", o);
    };
  }, function (e, t, r) {
    e.exports = r(32);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e instanceof Error && u.getPrototypeOf(e) === Error.prototype;
    }
    function i(e) {
      var t;
      if (n(e)) {
        t = new c(e), t.name = e.name, t.message = e.message, t.stack = e.stack;
        for (var r = u.keys(e), i = 0; i < r.length; ++i) {
          var a = r[i];
          h.test(a) || (t[a] = e[a]);
        }
        return t;
      }
      return o.markAsOriginatingFromRejection(e), e;
    }
    function a(e, t) {
      return function (r, n) {
        if (null !== e) {
          if (r) {
            var a = i(s(r));
            e._attachExtraTrace(a), e._reject(a);
          } else if (t) {
            for (var o = arguments.length, l = new Array(Math.max(o - 1, 0)), c = 1; c < o; ++c) l[c - 1] = arguments[c];
            e._fulfill(l);
          } else e._fulfill(n);
          e = null;
        }
      };
    }
    var o = r(0),
      s = o.maybeWrapAsError,
      l = r(18),
      c = l.OperationalError,
      u = r(36),
      h = /^(?:name|message|stack|cause)$/;
    e.exports = a;
  }, function (e, t) {
    var r = {}.toString;
    e.exports = Array.isArray || function (e) {
      return "[object Array]" == r.call(e);
    };
  }, function (e, t, r) {
    "use strict";

    function n() {
      this.compressedSize = 0, this.uncompressedSize = 0, this.crc32 = 0, this.compressionMethod = null, this.compressedContent = null;
    }
    n.prototype = {
      getContent: function getContent() {
        return null;
      },
      getCompressedContent: function getCompressedContent() {
        return null;
      }
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      this.data = null, this.length = 0, this.index = 0;
    }
    var i = r(12);
    n.prototype = {
      checkOffset: function checkOffset(e) {
        this.checkIndex(this.index + e);
      },
      checkIndex: function checkIndex(e) {
        if (this.length < e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
      },
      setIndex: function setIndex(e) {
        this.checkIndex(e), this.index = e;
      },
      skip: function skip(e) {
        this.setIndex(this.index + e);
      },
      byteAt: function byteAt(e) {},
      readInt: function readInt(e) {
        var t,
          r = 0;
        for (this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--) r = (r << 8) + this.byteAt(t);
        return this.index += e, r;
      },
      readString: function readString(e) {
        return i.transformTo("string", this.readData(e));
      },
      readData: function readData(e) {},
      lastIndexOfSignature: function lastIndexOfSignature(e) {},
      readDate: function readDate() {
        var e = this.readInt(4);
        return new Date(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1);
      }
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    t.base64 = !1, t.binary = !1, t.dir = !1, t.createFolders = !1, t.date = null, t.compression = null, t.compressionOptions = null, t.comment = null, t.unixPermissions = null, t.dosPermissions = null;
  }, function (e, t, r) {
    "use strict";

    t.LOCAL_FILE_HEADER = "PK", t.CENTRAL_FILE_HEADER = "PK", t.CENTRAL_DIRECTORY_END = "PK", t.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", t.ZIP64_CENTRAL_DIRECTORY_END = "PK", t.DATA_DESCRIPTOR = "PK\b";
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      this.data = e, t || (this.data = a.string2binary(this.data)), this.length = this.data.length, this.index = 0;
    }
    var i = r(105),
      a = r(12);
    n.prototype = new i(), n.prototype.byteAt = function (e) {
      return this.data.charCodeAt(e);
    }, n.prototype.lastIndexOfSignature = function (e) {
      return this.data.lastIndexOf(e);
    }, n.prototype.readData = function (e) {
      this.checkOffset(e);
      var t = this.data.slice(this.index, this.index + e);
      return this.index += e, t;
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      e && (this.data = e, this.length = this.data.length, this.index = 0);
    }
    var i = r(105);
    n.prototype = new i(), n.prototype.byteAt = function (e) {
      return this.data[e];
    }, n.prototype.lastIndexOfSignature = function (e) {
      for (var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), a = this.length - 4; a >= 0; --a) if (this.data[a] === t && this.data[a + 1] === r && this.data[a + 2] === n && this.data[a + 3] === i) return a;
      return -1;
    }, n.prototype.readData = function (e) {
      if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
      var t = this.data.subarray(this.index, this.index + e);
      return this.index += e, t;
    }, e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      return null == t ? e : i(t, a(t), e);
    }
    var i = r(270),
      a = r(38);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r) {
      if (null != e) {
        void 0 !== r && r in i(e) && (t = [r]);
        for (var n = 0, a = t.length; null != e && n < a;) e = e[t[n++]];
        return n && n == a ? e : void 0;
      }
    }
    var i = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r, s, l, c) {
      return e === t || (null == e || null == t || !a(e) && !o(t) ? e !== e && t !== t : i(e, t, n, r, s, l, c));
    }
    var i = r(276),
      a = r(3),
      o = r(29);
    e.exports = n;
  }, function (e, t) {
    function r(e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    }
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r) {
      if ("function" != typeof e) return i;
      if (void 0 === t) return e;
      switch (r) {
        case 1:
          return function (r) {
            return e.call(t, r);
          };
        case 3:
          return function (r, n, i) {
            return e.call(t, r, n, i);
          };
        case 4:
          return function (r, n, i, a) {
            return e.call(t, r, n, i, a);
          };
        case 5:
          return function (r, n, i, a, o) {
            return e.call(t, r, n, i, a, o);
          };
      }
      return function () {
        return e.apply(t, arguments);
      };
    }
    var i = r(120);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(113),
      i = n("length");
    e.exports = i;
  }, function (e, t, r) {
    function n(e, t) {
      var r = null == e ? void 0 : e[t];
      return i(r) ? r : void 0;
    }
    var i = r(292);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      var r = _typeof(e);
      return !!("string" == r && s.test(e) || "number" == r) || !i(e) && (!o.test(e) || null != t && e in a(t));
    }
    var i = r(21),
      a = r(20),
      o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      s = /^\w*$/;
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return e === e && !i(e);
    }
    var i = r(3);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      if (a(e)) return e;
      var t = [];
      return i(e).replace(o, function (e, r, n, i) {
        t.push(n ? i.replace(s, "$1") : r || e);
      }), t;
    }
    var i = r(282),
      a = r(21),
      o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g,
      s = /\\(\\)?/g;
    e.exports = n;
  }, function (e, t) {
    function r(e) {
      return e;
    }
    e.exports = r;
  }, function (e, t, r) {
    t.Parser = r(302).Parser, t.rules = r(125), t.errors = r(124), t.results = r(80), t.StringSource = r(122), t.Token = r(123), t.bottomUp = r(300), t.RegexTokeniser = r(303).RegexTokeniser, t.rule = function (e) {
      var t;
      return function (r) {
        return t || (t = e()), t(r);
      };
    };
  }, function (e, t, r) {
    var n = r(142),
      i = (e.exports = function (e, t) {
        return {
          asString: function asString() {
            return e;
          },
          range: function range(r, n) {
            return new i(e, t, r, n);
          }
        };
      }, function (e, t, r, n) {
        this._string = e, this._description = t, this._startIndex = r, this._endIndex = n;
      });
    i.prototype.to = function (e) {
      return new i(this._string, this._description, this._startIndex, e._endIndex);
    }, i.prototype.describe = function () {
      var e = this._position(),
        t = this._description ? this._description + "\n" : "";
      return n.format("%sLine number: %s\nCharacter number: %s", t, e.lineNumber, e.characterNumber);
    }, i.prototype.lineNumber = function () {
      return this._position().lineNumber;
    }, i.prototype.characterNumber = function () {
      return this._position().characterNumber;
    }, i.prototype._position = function () {
      for (var e = this, t = 0, r = function r() {
          return e._string.indexOf("\n", t);
        }, n = 1; -1 !== r() && r() < this._startIndex;) t = r() + 1, n += 1;
      return {
        lineNumber: n,
        characterNumber: this._startIndex - t + 1
      };
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      this.name = e, this.value = t, r && (this.source = r);
    };
  }, function (e, t) {
    t.error = function (e) {
      return new r(e);
    };
    var r = function r(e) {
      this.expected = e.expected, this.actual = e.actual, this._location = e.location;
    };
    r.prototype.describe = function () {
      return (this._location ? this._location.describe() + ":\n" : "") + "Expected " + this.expected + "\nbut got " + this.actual;
    }, r.prototype.lineNumber = function () {
      return this._location.lineNumber();
    }, r.prototype.characterNumber = function () {
      return this._location.characterNumber();
    };
  }, function (e, t, r) {
    function n(e) {
      return s.success(null, e);
    }
    function i(e, t) {
      var r,
        n = e.head();
      return r = n ? l.error({
        expected: t,
        actual: d(n),
        location: n.source
      }) : l.error({
        expected: t,
        actual: "end of tokens"
      }), s.failure([r], e);
    }
    var a = r(304),
      o = r(334),
      s = r(80),
      l = r(124),
      c = r(301);
    t.token = function (e, t) {
      var r = void 0 !== t;
      return function (n) {
        var a = n.head();
        if (!a || a.name !== e || r && a.value !== t) {
          return i(n, d({
            name: e,
            value: t
          }));
        }
        return s.success(a.value, n.tail(), a.source);
      };
    }, t.tokenOfType = function (e) {
      return t.token(e);
    }, t.firstOf = function (e, t) {
      return a.isArray(t) || (t = Array.prototype.slice.call(arguments, 1)), function (r) {
        return c.fromArray(t).map(function (e) {
          return e(r);
        }).filter(function (e) {
          return e.isSuccess() || e.isError();
        }).first() || i(r, e);
      };
    }, t.then = function (e, t) {
      return function (r) {
        var n = e(r);
        return n.map || console.log(n), n.map(t);
      };
    }, t.sequence = function () {
      function e(e) {
        return e.isCaptured;
      }
      var r = Array.prototype.slice.call(arguments, 0),
        n = function n(e) {
          var n = a.foldl(r, function (t, r) {
              var n = t.result,
                i = t.hasCut;
              if (!n.isSuccess()) return {
                result: n,
                hasCut: i
              };
              var a = r(n.remaining());
              if (a.isCut()) return {
                result: n,
                hasCut: !0
              };
              if (a.isSuccess()) {
                var o;
                o = r.isCaptured ? n.value().withValue(r, a.value()) : n.value();
                var l = a.remaining(),
                  c = e.to(l);
                return {
                  result: s.success(o, l, c),
                  hasCut: i
                };
              }
              return i ? {
                result: s.error(a.errors(), a.remaining()),
                hasCut: i
              } : {
                result: a,
                hasCut: i
              };
            }, {
              result: s.success(new u(), e),
              hasCut: !1
            }).result,
            i = e.to(n.remaining());
          return n.map(function (e) {
            return e.withValue(t.sequence.source, i);
          });
        };
      return n.head = function () {
        var i = a.find(r, e);
        return t.then(n, t.sequence.extract(i));
      }, n.map = function (e) {
        return t.then(n, function (t) {
          return e.apply(this, t.toArray());
        });
      }, n;
    };
    var u = function u(e, t) {
      this._values = e || {}, this._valuesArray = t || [];
    };
    u.prototype.withValue = function (e, t) {
      if (e.captureName && e.captureName in this._values) throw new Error('Cannot add second value for capture "' + e.captureName + '"');
      var r = a.clone(this._values);
      r[e.captureName] = t;
      var n = this._valuesArray.concat([t]);
      return new u(r, n);
    }, u.prototype.get = function (e) {
      if (e.captureName in this._values) return this._values[e.captureName];
      throw new Error('No value for capture "' + e.captureName + '"');
    }, u.prototype.toArray = function () {
      return this._valuesArray;
    }, t.sequence.capture = function (e, t) {
      var r = function r() {
        return e.apply(this, arguments);
      };
      return r.captureName = t, r.isCaptured = !0, r;
    }, t.sequence.extract = function (e) {
      return function (t) {
        return t.get(e);
      };
    }, t.sequence.applyValues = function (e) {
      var t = Array.prototype.slice.call(arguments, 1);
      return function (r) {
        var n = t.map(function (e) {
          return r.get(e);
        });
        return e.apply(this, n);
      };
    }, t.sequence.source = {
      captureName: "☃source☃"
    }, t.sequence.cut = function () {
      return function (e) {
        return s.cut(e);
      };
    }, t.optional = function (e) {
      return function (t) {
        var r = e(t);
        return r.isSuccess() ? r.map(o.some) : r.isFailure() ? s.success(o.none, t) : r;
      };
    }, t.zeroOrMoreWithSeparator = function (e, t) {
      return f(e, t, !1);
    }, t.oneOrMoreWithSeparator = function (e, t) {
      return f(e, t, !0);
    };
    var h = t.zeroOrMore = function (e) {
      return function (t) {
        for (var r, n = []; (r = e(t)) && r.isSuccess();) t = r.remaining(), n.push(r.value());
        return r.isError() ? r : s.success(n, t);
      };
    };
    t.oneOrMore = function (e) {
      return t.oneOrMoreWithSeparator(e, n);
    };
    var f = function f(e, r, n) {
      return function (i) {
        var a = e(i);
        if (a.isSuccess()) {
          var o = t.sequence.capture(e, "main"),
            l = h(t.then(t.sequence(r, o), t.sequence.extract(o))),
            c = l(a.remaining());
          return s.success([a.value()].concat(c.value()), c.remaining());
        }
        return n || a.isError() ? a : s.success([], i);
      };
    };
    t.leftAssociative = function (e, r, n) {
      var i;
      i = n ? [{
        func: n,
        rule: r
      }] : r, i = i.map(function (e) {
        return t.then(e.rule, function (t) {
          return function (r, n) {
            return e.func(r, t, n);
          };
        });
      });
      var a = t.firstOf.apply(null, ["rules"].concat(i));
      return function (t) {
        var r = t,
          n = e(t);
        if (!n.isSuccess()) return n;
        for (var i = a(n.remaining()); i.isSuccess();) {
          var o = i.remaining(),
            l = r.to(i.remaining()),
            c = i.value();
          n = s.success(c(n.value(), l), o, l), i = a(n.remaining());
        }
        return i.isError() ? i : n;
      };
    }, t.leftAssociative.firstOf = function () {
      return Array.prototype.slice.call(arguments, 0);
    }, t.nonConsuming = function (e) {
      return function (t) {
        return e(t).changeRemaining(t);
      };
    };
    var d = function d(e) {
      return e.value ? e.name + ' "' + e.value + '"' : e.name;
    };
  }, function (e, t, r) {
    function n(e, t, r) {
      return a(l.element(e, t, {
        fresh: !1
      }), r);
    }
    function i(e, t, r) {
      return a(l.element(e, t, {
        fresh: !0
      }), r);
    }
    function a(e, t) {
      return {
        type: "element",
        tag: e,
        children: t || []
      };
    }
    function o(e) {
      return {
        type: "text",
        value: e
      };
    }
    function s(e) {
      return 0 === e.children.length && u[e.tag.tagName];
    }
    var l = r(55),
      c = {
        type: "forceWrite"
      };
    t.freshElement = i, t.nonFreshElement = n, t.elementWithTag = a, t.text = o, t.forceWrite = c;
    var u = {
      br: !0,
      hr: !0,
      img: !0
    };
    t.isVoidElement = s;
  }, function (e, t, r) {
    var n = r(1),
      i = r(15),
      a = r(54);
    t.imgElement = function (e) {
      return function (t, r) {
        return i.when(e(t)).then(function (e) {
          var r = n.clone(e);
          return t.altText && (r.alt = t.altText), [a.freshElement("img", r)];
        });
      };
    }, t.inline = t.imgElement;
  }, function (e, t, r) {
    var n = r(129);
    t.Element = n.Element, t.element = n.element, t.text = n.text, t.readString = r(331).readString, t.writeString = r(332).writeString;
  }, function (e, t, r) {
    function n(e, t, r) {
      this.type = "element", this.name = e, this.attributes = t || {}, this.children = r || [];
    }
    function i(e) {
      return a.extend(e, s);
    }
    var a = r(1);
    t.Element = n, t.element = function (e, t, r) {
      return new n(e, t, r);
    }, t.text = function (e) {
      return {
        type: "text",
        value: e
      };
    };
    var o = {
      first: function first() {
        return null;
      },
      firstOrEmpty: function firstOrEmpty() {
        return o;
      },
      attributes: {}
    };
    n.prototype.first = function (e) {
      return a.find(this.children, function (t) {
        return t.name === e;
      });
    }, n.prototype.firstOrEmpty = function (e) {
      return this.first(e) || o;
    }, n.prototype.getElementsByTagName = function (e) {
      return i(a.filter(this.children, function (t) {
        return t.name === e;
      }));
    }, n.prototype.text = function () {
      if (0 === this.children.length) return "";
      if (1 !== this.children.length || "text" !== this.children[0].type) throw new Error("Not implemented");
      return this.children[0].value;
    };
    var s = {
      getElementsByTagName: function getElementsByTagName(e) {
        return i(a.flatten(this.map(function (t) {
          return t.getElementsByTagName(e);
        }, !0)));
      }
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (t < 65537 && (e.subarray && o || !e.subarray && a)) return String.fromCharCode.apply(null, i.shrinkBuf(e, t));
      for (var r = "", n = 0; n < t; n++) r += String.fromCharCode(e[n]);
      return r;
    }
    var i = r(22),
      a = !0,
      o = !0;
    try {
      String.fromCharCode.apply(null, [0]);
    } catch (e) {
      a = !1;
    }
    try {
      String.fromCharCode.apply(null, new Uint8Array(1));
    } catch (e) {
      o = !1;
    }
    for (var s = new i.Buf8(256), l = 0; l < 256; l++) s[l] = l >= 252 ? 6 : l >= 248 ? 5 : l >= 240 ? 4 : l >= 224 ? 3 : l >= 192 ? 2 : 1;
    s[254] = s[254] = 1, t.string2buf = function (e) {
      var t,
        r,
        n,
        a,
        o,
        s = e.length,
        l = 0;
      for (a = 0; a < s; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
      for (t = new i.Buf8(l), o = 0, a = 0; o < l; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), r < 128 ? t[o++] = r : r < 2048 ? (t[o++] = 192 | r >>> 6, t[o++] = 128 | 63 & r) : r < 65536 ? (t[o++] = 224 | r >>> 12, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r) : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r);
      return t;
    }, t.buf2binstring = function (e) {
      return n(e, e.length);
    }, t.binstring2buf = function (e) {
      for (var t = new i.Buf8(e.length), r = 0, n = t.length; r < n; r++) t[r] = e.charCodeAt(r);
      return t;
    }, t.buf2string = function (e, t) {
      var r,
        i,
        a,
        o,
        l = t || e.length,
        c = new Array(2 * l);
      for (i = 0, r = 0; r < l;) if ((a = e[r++]) < 128) c[i++] = a;else if ((o = s[a]) > 4) c[i++] = 65533, r += o - 1;else {
        for (a &= 2 === o ? 31 : 3 === o ? 15 : 7; o > 1 && r < l;) a = a << 6 | 63 & e[r++], o--;
        o > 1 ? c[i++] = 65533 : a < 65536 ? c[i++] = a : (a -= 65536, c[i++] = 55296 | a >> 10 & 1023, c[i++] = 56320 | 1023 & a);
      }
      return n(c, i);
    }, t.utf8border = function (e, t) {
      var r;
      for (t = t || e.length, t > e.length && (t = e.length), r = t - 1; r >= 0 && 128 == (192 & e[r]);) r--;
      return r < 0 ? t : 0 === r ? t : r + s[e[r]] > t ? r : t;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r, n) {
      for (var i = 65535 & e | 0, a = e >>> 16 & 65535 | 0, o = 0; 0 !== r;) {
        o = r > 2e3 ? 2e3 : r, r -= o;
        do {
          i = i + t[n++] | 0, a = a + i | 0;
        } while (--o);
        i %= 65521, a %= 65521;
      }
      return i | a << 16 | 0;
    }
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = {
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_BUF_ERROR: -5,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,
      Z_BINARY: 0,
      Z_TEXT: 1,
      Z_UNKNOWN: 2,
      Z_DEFLATED: 8
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r, n) {
      var a = i,
        o = n + r;
      e ^= -1;
      for (var s = n; s < o; s++) e = e >>> 8 ^ a[255 & (e ^ t[s])];
      return -1 ^ e;
    }
    var i = function () {
      for (var e, t = [], r = 0; r < 256; r++) {
        e = r;
        for (var n = 0; n < 8; n++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
        t[r] = e;
      }
      return t;
    }();
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    function n() {
      this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
    }
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    (function (t, n) {
      function i(e) {
        return F.from(e);
      }
      function a(e) {
        return F.isBuffer(e) || e instanceof N;
      }
      function o(e, t, r) {
        if ("function" == typeof e.prependListener) return e.prependListener(t, r);
        e._events && e._events[t] ? B(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [r, e._events[t]] : e.on(t, r);
      }
      function s(e, t) {
        P = P || r(30), e = e || {};
        var n = t instanceof P;
        this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode);
        var i = e.highWaterMark,
          a = e.readableHighWaterMark,
          o = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (a || 0 === a) ? a : o, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new G(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (H || (H = r(84).StringDecoder), this.decoder = new H(e.encoding), this.encoding = e.encoding);
      }
      function l(e) {
        if (P = P || r(30), !(this instanceof l)) return new l(e);
        this._readableState = new s(e, this), this.readable = !0, e && ("function" == typeof e.read && (this._read = e.read), "function" == typeof e.destroy && (this._destroy = e.destroy)), L.call(this);
      }
      function c(e, t, r, n, a) {
        var o = e._readableState;
        if (null === t) o.reading = !1, m(e, o);else {
          var s;
          a || (s = h(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === F.prototype || (t = i(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : u(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? u(e, o, t, !1) : b(e, o)) : u(e, o, t, !1))) : n || (o.reading = !1);
        }
        return f(o);
      }
      function u(e, t, r, n) {
        t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && g(e)), b(e, t);
      }
      function h(e, t) {
        var r;
        return a(t) || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk")), r;
      }
      function f(e) {
        return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
      }
      function d(e) {
        return e >= W ? e = W : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
      }
      function p(e, t) {
        return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e !== e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = d(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
      }
      function m(e, t) {
        if (!t.ended) {
          if (t.decoder) {
            var r = t.decoder.end();
            r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
          }
          t.ended = !0, g(e);
        }
      }
      function g(e) {
        var t = e._readableState;
        t.needReadable = !1, t.emittedReadable || (z("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? O.nextTick(v, e) : v(e));
      }
      function v(e) {
        z("emit readable"), e.emit("readable"), C(e);
      }
      function b(e, t) {
        t.readingMore || (t.readingMore = !0, O.nextTick(y, e, t));
      }
      function y(e, t) {
        for (var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (z("maybeReadMore read 0"), e.read(0), r !== t.length);) r = t.length;
        t.readingMore = !1;
      }
      function w(e) {
        return function () {
          var t = e._readableState;
          z("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && D(e, "data") && (t.flowing = !0, C(e));
        };
      }
      function x(e) {
        z("readable nexttick read 0"), e.read(0);
      }
      function _(e, t) {
        t.resumeScheduled || (t.resumeScheduled = !0, O.nextTick(S, e, t));
      }
      function S(e, t) {
        t.reading || (z("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), C(e), t.flowing && !t.reading && e.read(0);
      }
      function C(e) {
        var t = e._readableState;
        for (z("flow", t.flowing); t.flowing && null !== e.read(););
      }
      function E(e, t) {
        if (0 === t.length) return null;
        var r;
        return t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = A(e, t.buffer, t.decoder), r;
      }
      function A(e, t, r) {
        var n;
        return e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? T(e, t) : k(e, t), n;
      }
      function T(e, t) {
        var r = t.head,
          n = 1,
          i = r.data;
        for (e -= i.length; r = r.next;) {
          var a = r.data,
            o = e > a.length ? a.length : e;
          if (o === a.length ? i += a : i += a.slice(0, e), 0 === (e -= o)) {
            o === a.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = a.slice(o));
            break;
          }
          ++n;
        }
        return t.length -= n, i;
      }
      function k(e, t) {
        var r = F.allocUnsafe(e),
          n = t.head,
          i = 1;
        for (n.data.copy(r), e -= n.data.length; n = n.next;) {
          var a = n.data,
            o = e > a.length ? a.length : e;
          if (a.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
            o === a.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = a.slice(o));
            break;
          }
          ++i;
        }
        return t.length -= i, r;
      }
      function R(e) {
        var t = e._readableState;
        if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        t.endEmitted || (t.ended = !0, O.nextTick(I, t, e));
      }
      function I(e, t) {
        e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
      }
      function M(e, t) {
        for (var r = 0, n = e.length; r < n; r++) if (e[r] === t) return r;
        return -1;
      }
      var O = r(56);
      e.exports = l;
      var P,
        B = r(103);
      l.ReadableState = s;
      var D = (r(72).EventEmitter, function (e, t) {
          return e.listeners(t).length;
        }),
        L = r(138),
        F = r(57).Buffer,
        N = t.Uint8Array || function () {},
        U = r(44);
      U.inherits = r(28);
      var j = r(386),
        z = void 0;
      z = j && j.debuglog ? j.debuglog("stream") : function () {};
      var H,
        G = r(358),
        V = r(137);
      U.inherits(l, L);
      var q = ["error", "close", "destroy", "pause", "resume"];
      Object.defineProperty(l.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(e) {
          this._readableState && (this._readableState.destroyed = e);
        }
      }), l.prototype.destroy = V.destroy, l.prototype._undestroy = V.undestroy, l.prototype._destroy = function (e, t) {
        this.push(null), t(e);
      }, l.prototype.push = function (e, t) {
        var r,
          n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof e && (t = t || n.defaultEncoding, t !== n.encoding && (e = F.from(e, t), t = ""), r = !0), c(this, e, t, !1, r);
      }, l.prototype.unshift = function (e) {
        return c(this, e, null, !0, !1);
      }, l.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, l.prototype.setEncoding = function (e) {
        return H || (H = r(84).StringDecoder), this._readableState.decoder = new H(e), this._readableState.encoding = e, this;
      };
      var W = 8388608;
      l.prototype.read = function (e) {
        z("read", e), e = parseInt(e, 10);
        var t = this._readableState,
          r = e;
        if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return z("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? R(this) : g(this), null;
        if (0 === (e = p(e, t)) && t.ended) return 0 === t.length && R(this), null;
        var n = t.needReadable;
        z("need readable", n), (0 === t.length || t.length - e < t.highWaterMark) && (n = !0, z("length less than watermark", n)), t.ended || t.reading ? (n = !1, z("reading or ended", n)) : n && (z("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = p(r, t)));
        var i;
        return i = e > 0 ? E(e, t) : null, null === i ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && R(this)), null !== i && this.emit("data", i), i;
      }, l.prototype._read = function (e) {
        this.emit("error", new Error("_read() is not implemented"));
      }, l.prototype.pipe = function (e, t) {
        function r(e, t) {
          z("onunpipe"), e === f && t && !1 === t.hasUnpiped && (t.hasUnpiped = !0, a());
        }
        function i() {
          z("onend"), e.end();
        }
        function a() {
          z("cleanup"), e.removeListener("close", c), e.removeListener("finish", u), e.removeListener("drain", g), e.removeListener("error", l), e.removeListener("unpipe", r), f.removeListener("end", i), f.removeListener("end", h), f.removeListener("data", s), v = !0, !d.awaitDrain || e._writableState && !e._writableState.needDrain || g();
        }
        function s(t) {
          z("ondata"), b = !1, !1 !== e.write(t) || b || ((1 === d.pipesCount && d.pipes === e || d.pipesCount > 1 && -1 !== M(d.pipes, e)) && !v && (z("false write response, pause", f._readableState.awaitDrain), f._readableState.awaitDrain++, b = !0), f.pause());
        }
        function l(t) {
          z("onerror", t), h(), e.removeListener("error", l), 0 === D(e, "error") && e.emit("error", t);
        }
        function c() {
          e.removeListener("finish", u), h();
        }
        function u() {
          z("onfinish"), e.removeListener("close", c), h();
        }
        function h() {
          z("unpipe"), f.unpipe(e);
        }
        var f = this,
          d = this._readableState;
        switch (d.pipesCount) {
          case 0:
            d.pipes = e;
            break;
          case 1:
            d.pipes = [d.pipes, e];
            break;
          default:
            d.pipes.push(e);
        }
        d.pipesCount += 1, z("pipe count=%d opts=%j", d.pipesCount, t);
        var p = (!t || !1 !== t.end) && e !== n.stdout && e !== n.stderr,
          m = p ? i : h;
        d.endEmitted ? O.nextTick(m) : f.once("end", m), e.on("unpipe", r);
        var g = w(f);
        e.on("drain", g);
        var v = !1,
          b = !1;
        return f.on("data", s), o(e, "error", l), e.once("close", c), e.once("finish", u), e.emit("pipe", f), d.flowing || (z("pipe resume"), f.resume()), e;
      }, l.prototype.unpipe = function (e) {
        var t = this._readableState,
          r = {
            hasUnpiped: !1
          };
        if (0 === t.pipesCount) return this;
        if (1 === t.pipesCount) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r), this);
        if (!e) {
          var n = t.pipes,
            i = t.pipesCount;
          t.pipes = null, t.pipesCount = 0, t.flowing = !1;
          for (var a = 0; a < i; a++) n[a].emit("unpipe", this, r);
          return this;
        }
        var o = M(t.pipes, e);
        return -1 === o ? this : (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r), this);
      }, l.prototype.on = function (e, t) {
        var r = L.prototype.on.call(this, e, t);
        if ("data" === e) !1 !== this._readableState.flowing && this.resume();else if ("readable" === e) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && g(this) : O.nextTick(x, this));
        }
        return r;
      }, l.prototype.addListener = l.prototype.on, l.prototype.resume = function () {
        var e = this._readableState;
        return e.flowing || (z("resume"), e.flowing = !0, _(this, e)), this;
      }, l.prototype.pause = function () {
        return z("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (z("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, l.prototype.wrap = function (e) {
        var t = this,
          r = this._readableState,
          n = !1;
        e.on("end", function () {
          if (z("wrapped end"), r.decoder && !r.ended) {
            var e = r.decoder.end();
            e && e.length && t.push(e);
          }
          t.push(null);
        }), e.on("data", function (i) {
          if (z("wrapped data"), r.decoder && (i = r.decoder.write(i)), (!r.objectMode || null !== i && void 0 !== i) && (r.objectMode || i && i.length)) {
            t.push(i) || (n = !0, e.pause());
          }
        });
        for (var i in e) void 0 === this[i] && "function" == typeof e[i] && (this[i] = function (t) {
          return function () {
            return e[t].apply(e, arguments);
          };
        }(i));
        for (var a = 0; a < q.length; a++) e.on(q[a], this.emit.bind(this, q[a]));
        return this._read = function (t) {
          z("wrapped _read", t), n && (n = !1, e.resume());
        }, this;
      }, Object.defineProperty(l.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), l._fromList = E;
    }).call(t, r(13), r(5));
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }
    function i(e) {
      if (!(this instanceof i)) return new i(e);
      s.call(this, e), this._transformState = {
        afterTransform: n.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
    }
    function a() {
      var e = this;
      "function" == typeof this._flush ? this._flush(function (t, r) {
        o(e, t, r);
      }) : o(this, null, null);
    }
    function o(e, t, r) {
      if (t) return e.emit("error", t);
      if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return e.push(null);
    }
    e.exports = i;
    var s = r(30),
      l = r(44);
    l.inherits = r(28), l.inherits(i, s), i.prototype.push = function (e, t) {
      return this._transformState.needTransform = !1, s.prototype.push.call(this, e, t);
    }, i.prototype._transform = function (e, t, r) {
      throw new Error("_transform() is not implemented");
    }, i.prototype._write = function (e, t, r) {
      var n = this._transformState;
      if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, i.prototype._read = function (e) {
      var t = this._transformState;
      null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
    }, i.prototype._destroy = function (e, t) {
      var r = this;
      s.prototype._destroy.call(this, e, function (e) {
        t(e), r.emit("close");
      });
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      var r = this,
        n = this._readableState && this._readableState.destroyed,
        i = this._writableState && this._writableState.destroyed;
      return n || i ? (t ? t(e) : !e || this._writableState && this._writableState.errorEmitted || o.nextTick(a, this, e), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function (e) {
        !t && e ? (o.nextTick(a, r, e), r._writableState && (r._writableState.errorEmitted = !0)) : t && t(e);
      }), this);
    }
    function i() {
      this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
    }
    function a(e, t) {
      e.emit("error", t);
    }
    var o = r(56);
    e.exports = {
      destroy: n,
      undestroy: i
    };
  }, function (e, t, r) {
    e.exports = r(72).EventEmitter;
  }, function (e, t, r) {
    var n = r(249);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    "use strict";

    function n() {}
    function i(e, t) {
      this.x = e || 0, this.y = t || 0;
    }
    function a(e, t, r, n, o, s, l, c, u, h) {
      Object.defineProperty(this, "id", {
        value: Cs++
      }), this.uuid = Ss.generateUUID(), this.name = "", this.image = void 0 !== e ? e : a.DEFAULT_IMAGE, this.mipmaps = [], this.mapping = void 0 !== t ? t : a.DEFAULT_MAPPING, this.wrapS = void 0 !== r ? r : bo, this.wrapT = void 0 !== n ? n : bo, this.magFilter = void 0 !== o ? o : So, this.minFilter = void 0 !== s ? s : Eo, this.anisotropy = void 0 !== u ? u : 1, this.format = void 0 !== l ? l : jo, this.type = void 0 !== c ? c : Ao, this.offset = new i(0, 0), this.repeat = new i(1, 1), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = void 0 !== h ? h : ds, this.version = 0, this.onUpdate = null;
    }
    function o(e, t, r, n) {
      this.x = e || 0, this.y = t || 0, this.z = r || 0, this.w = void 0 !== n ? n : 1;
    }
    function s(e, t, r) {
      this.uuid = Ss.generateUUID(), this.width = e, this.height = t, this.scissor = new o(0, 0, e, t), this.scissorTest = !1, this.viewport = new o(0, 0, e, t), r = r || {}, void 0 === r.minFilter && (r.minFilter = So), this.texture = new a(void 0, void 0, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.encoding), this.depthBuffer = void 0 === r.depthBuffer || r.depthBuffer, this.stencilBuffer = void 0 === r.stencilBuffer || r.stencilBuffer, this.depthTexture = void 0 !== r.depthTexture ? r.depthTexture : null;
    }
    function l(e, t, r) {
      s.call(this, e, t, r), this.activeCubeFace = 0, this.activeMipMapLevel = 0;
    }
    function c(e, t, r, n) {
      this._x = e || 0, this._y = t || 0, this._z = r || 0, this._w = void 0 !== n ? n : 1;
    }
    function u(e, t, r) {
      this.x = e || 0, this.y = t || 0, this.z = r || 0;
    }
    function h() {
      this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
    function f(e, t, r, n, i, o, s, l, c, u, h, f) {
      a.call(this, null, o, s, l, c, u, n, i, h, f), this.image = {
        data: e,
        width: t,
        height: r
      }, this.magFilter = void 0 !== c ? c : wo, this.minFilter = void 0 !== u ? u : wo, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
    function d(e, t, r, n, i, o, s, l, c, u) {
      e = void 0 !== e ? e : [], t = void 0 !== t ? t : co, a.call(this, e, t, r, n, i, o, s, l, c, u), this.flipY = !1;
    }
    function p() {
      this.seq = [], this.map = {};
    }
    function m(e, t, r) {
      var n = e[0];
      if (n <= 0 || n > 0) return e;
      var i = t * r,
        a = Ts[i];
      if (void 0 === a && (a = new Float32Array(i), Ts[i] = a), 0 !== t) {
        n.toArray(a, 0);
        for (var o = 1, s = 0; o !== t; ++o) s += r, e[o].toArray(a, s);
      }
      return a;
    }
    function g(e, t) {
      var r = ks[t];
      void 0 === r && (r = new Int32Array(t), ks[t] = r);
      for (var n = 0; n !== t; ++n) r[n] = e.allocTextureUnit();
      return r;
    }
    function v(e, t) {
      e.uniform1f(this.addr, t);
    }
    function b(e, t) {
      e.uniform1i(this.addr, t);
    }
    function y(e, t) {
      void 0 === t.x ? e.uniform2fv(this.addr, t) : e.uniform2f(this.addr, t.x, t.y);
    }
    function w(e, t) {
      void 0 !== t.x ? e.uniform3f(this.addr, t.x, t.y, t.z) : void 0 !== t.r ? e.uniform3f(this.addr, t.r, t.g, t.b) : e.uniform3fv(this.addr, t);
    }
    function x(e, t) {
      void 0 === t.x ? e.uniform4fv(this.addr, t) : e.uniform4f(this.addr, t.x, t.y, t.z, t.w);
    }
    function _(e, t) {
      e.uniformMatrix2fv(this.addr, !1, t.elements || t);
    }
    function S(e, t) {
      void 0 === t.elements ? e.uniformMatrix3fv(this.addr, !1, t) : (Is.set(t.elements), e.uniformMatrix3fv(this.addr, !1, Is));
    }
    function C(e, t) {
      void 0 === t.elements ? e.uniformMatrix4fv(this.addr, !1, t) : (Rs.set(t.elements), e.uniformMatrix4fv(this.addr, !1, Rs));
    }
    function E(e, t, r) {
      var n = r.allocTextureUnit();
      e.uniform1i(this.addr, n), r.setTexture2D(t || Es, n);
    }
    function A(e, t, r) {
      var n = r.allocTextureUnit();
      e.uniform1i(this.addr, n), r.setTextureCube(t || As, n);
    }
    function T(e, t) {
      e.uniform2iv(this.addr, t);
    }
    function k(e, t) {
      e.uniform3iv(this.addr, t);
    }
    function R(e, t) {
      e.uniform4iv(this.addr, t);
    }
    function I(e) {
      switch (e) {
        case 5126:
          return v;
        case 35664:
          return y;
        case 35665:
          return w;
        case 35666:
          return x;
        case 35674:
          return _;
        case 35675:
          return S;
        case 35676:
          return C;
        case 35678:
          return E;
        case 35680:
          return A;
        case 5124:
        case 35670:
          return b;
        case 35667:
        case 35671:
          return T;
        case 35668:
        case 35672:
          return k;
        case 35669:
        case 35673:
          return R;
      }
    }
    function M(e, t) {
      e.uniform1fv(this.addr, t);
    }
    function O(e, t) {
      e.uniform1iv(this.addr, t);
    }
    function P(e, t) {
      e.uniform2fv(this.addr, m(t, this.size, 2));
    }
    function B(e, t) {
      e.uniform3fv(this.addr, m(t, this.size, 3));
    }
    function D(e, t) {
      e.uniform4fv(this.addr, m(t, this.size, 4));
    }
    function L(e, t) {
      e.uniformMatrix2fv(this.addr, !1, m(t, this.size, 4));
    }
    function F(e, t) {
      e.uniformMatrix3fv(this.addr, !1, m(t, this.size, 9));
    }
    function N(e, t) {
      e.uniformMatrix4fv(this.addr, !1, m(t, this.size, 16));
    }
    function U(e, t, r) {
      var n = t.length,
        i = g(r, n);
      e.uniform1iv(this.addr, i);
      for (var a = 0; a !== n; ++a) r.setTexture2D(t[a] || Es, i[a]);
    }
    function j(e, t, r) {
      var n = t.length,
        i = g(r, n);
      e.uniform1iv(this.addr, i);
      for (var a = 0; a !== n; ++a) r.setTextureCube(t[a] || As, i[a]);
    }
    function z(e) {
      switch (e) {
        case 5126:
          return M;
        case 35664:
          return P;
        case 35665:
          return B;
        case 35666:
          return D;
        case 35674:
          return L;
        case 35675:
          return F;
        case 35676:
          return N;
        case 35678:
          return U;
        case 35680:
          return j;
        case 5124:
        case 35670:
          return O;
        case 35667:
        case 35671:
          return T;
        case 35668:
        case 35672:
          return k;
        case 35669:
        case 35673:
          return R;
      }
    }
    function H(e, t, r) {
      this.id = e, this.addr = r, this.setValue = I(t.type);
    }
    function G(e, t, r) {
      this.id = e, this.addr = r, this.size = t.size, this.setValue = z(t.type);
    }
    function V(e) {
      this.id = e, p.call(this);
    }
    function q(e, t) {
      e.seq.push(t), e.map[t.id] = t;
    }
    function W(e, t, r) {
      var n = e.name,
        i = n.length;
      for (Ms.lastIndex = 0;;) {
        var a = Ms.exec(n),
          o = Ms.lastIndex,
          s = a[1],
          l = "]" === a[2],
          c = a[3];
        if (l && (s |= 0), void 0 === c || "[" === c && o + 2 === i) {
          q(r, void 0 === c ? new H(s, e, t) : new G(s, e, t));
          break;
        }
        var u = r.map,
          h = u[s];
        void 0 === h && (h = new V(s), q(r, h)), r = h;
      }
    }
    function X(e, t, r) {
      p.call(this), this.renderer = r;
      for (var n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS), i = 0; i < n; ++i) {
        var a = e.getActiveUniform(t, i),
          o = a.name;
        W(a, e.getUniformLocation(t, o), this);
      }
    }
    function Y(e, t, r) {
      return void 0 === t && void 0 === r ? this.set(e) : this.setRGB(e, t, r);
    }
    function K(e, t) {
      this.min = void 0 !== e ? e : new i(1 / 0, 1 / 0), this.max = void 0 !== t ? t : new i(-1 / 0, -1 / 0);
    }
    function Z(e, t) {
      function r() {
        var e = new Float32Array([-1, -1, 0, 0, 1, -1, 1, 0, 1, 1, 1, 1, -1, 1, 0, 1]),
          t = new Uint16Array([0, 1, 2, 0, 2, 3]);
        a = p.createBuffer(), o = p.createBuffer(), p.bindBuffer(p.ARRAY_BUFFER, a), p.bufferData(p.ARRAY_BUFFER, e, p.STATIC_DRAW), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, o), p.bufferData(p.ELEMENT_ARRAY_BUFFER, t, p.STATIC_DRAW), f = p.createTexture(), d = p.createTexture(), m.bindTexture(p.TEXTURE_2D, f), p.texImage2D(p.TEXTURE_2D, 0, p.RGB, 16, 16, 0, p.RGB, p.UNSIGNED_BYTE, null), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_S, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_T, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MAG_FILTER, p.NEAREST), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MIN_FILTER, p.NEAREST), m.bindTexture(p.TEXTURE_2D, d), p.texImage2D(p.TEXTURE_2D, 0, p.RGBA, 16, 16, 0, p.RGBA, p.UNSIGNED_BYTE, null), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_S, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_WRAP_T, p.CLAMP_TO_EDGE), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MAG_FILTER, p.NEAREST), p.texParameteri(p.TEXTURE_2D, p.TEXTURE_MIN_FILTER, p.NEAREST), s = {
          vertexShader: ["uniform lowp int renderType;", "uniform vec3 screenPosition;", "uniform vec2 scale;", "uniform float rotation;", "uniform sampler2D occlusionMap;", "attribute vec2 position;", "attribute vec2 uv;", "varying vec2 vUV;", "varying float vVisibility;", "void main() {", "vUV = uv;", "vec2 pos = position;", "if ( renderType == 2 ) {", "vec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );", "visibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );", "visibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );", "visibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );", "vVisibility =        visibility.r / 9.0;", "vVisibility *= 1.0 - visibility.g / 9.0;", "vVisibility *=       visibility.b / 9.0;", "vVisibility *= 1.0 - visibility.a / 9.0;", "pos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;", "pos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;", "}", "gl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );", "}"].join("\n"),
          fragmentShader: ["uniform lowp int renderType;", "uniform sampler2D map;", "uniform float opacity;", "uniform vec3 color;", "varying vec2 vUV;", "varying float vVisibility;", "void main() {", "if ( renderType == 0 ) {", "gl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );", "} else if ( renderType == 1 ) {", "gl_FragColor = texture2D( map, vUV );", "} else {", "vec4 texture = texture2D( map, vUV );", "texture.a *= opacity * vVisibility;", "gl_FragColor = texture;", "gl_FragColor.rgb *= color;", "}", "}"].join("\n")
        }, l = n(s), c = {
          vertex: p.getAttribLocation(l, "position"),
          uv: p.getAttribLocation(l, "uv")
        }, h = {
          renderType: p.getUniformLocation(l, "renderType"),
          map: p.getUniformLocation(l, "map"),
          occlusionMap: p.getUniformLocation(l, "occlusionMap"),
          opacity: p.getUniformLocation(l, "opacity"),
          color: p.getUniformLocation(l, "color"),
          scale: p.getUniformLocation(l, "scale"),
          rotation: p.getUniformLocation(l, "rotation"),
          screenPosition: p.getUniformLocation(l, "screenPosition")
        };
      }
      function n(t) {
        var r = p.createProgram(),
          n = p.createShader(p.FRAGMENT_SHADER),
          i = p.createShader(p.VERTEX_SHADER),
          a = "precision " + e.getPrecision() + " float;\n";
        return p.shaderSource(n, a + t.fragmentShader), p.shaderSource(i, a + t.vertexShader), p.compileShader(n), p.compileShader(i), p.attachShader(r, n), p.attachShader(r, i), p.linkProgram(r), r;
      }
      var a,
        o,
        s,
        l,
        c,
        h,
        f,
        d,
        p = e.context,
        m = e.state;
      this.render = function (n, s, g) {
        if (0 !== t.length) {
          var v = new u(),
            b = g.w / g.z,
            y = .5 * g.z,
            w = .5 * g.w,
            x = 16 / g.w,
            _ = new i(x * b, x),
            S = new u(1, 1, 0),
            C = new i(1, 1),
            E = new K();
          E.min.set(g.x, g.y), E.max.set(g.x + (g.z - 16), g.y + (g.w - 16)), void 0 === l && r(), p.useProgram(l), m.initAttributes(), m.enableAttribute(c.vertex), m.enableAttribute(c.uv), m.disableUnusedAttributes(), p.uniform1i(h.occlusionMap, 0), p.uniform1i(h.map, 1), p.bindBuffer(p.ARRAY_BUFFER, a), p.vertexAttribPointer(c.vertex, 2, p.FLOAT, !1, 16, 0), p.vertexAttribPointer(c.uv, 2, p.FLOAT, !1, 16, 8), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, o), m.disable(p.CULL_FACE), m.buffers.depth.setMask(!1);
          for (var A = 0, T = t.length; A < T; A++) {
            x = 16 / g.w, _.set(x * b, x);
            var k = t[A];
            if (v.set(k.matrixWorld.elements[12], k.matrixWorld.elements[13], k.matrixWorld.elements[14]), v.applyMatrix4(s.matrixWorldInverse), v.applyMatrix4(s.projectionMatrix), S.copy(v), C.x = g.x + S.x * y + y - 8, C.y = g.y + S.y * w + w - 8, !0 === E.containsPoint(C)) {
              m.activeTexture(p.TEXTURE0), m.bindTexture(p.TEXTURE_2D, null), m.activeTexture(p.TEXTURE1), m.bindTexture(p.TEXTURE_2D, f), p.copyTexImage2D(p.TEXTURE_2D, 0, p.RGB, C.x, C.y, 16, 16, 0), p.uniform1i(h.renderType, 0), p.uniform2f(h.scale, _.x, _.y), p.uniform3f(h.screenPosition, S.x, S.y, S.z), m.disable(p.BLEND), m.enable(p.DEPTH_TEST), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0), m.activeTexture(p.TEXTURE0), m.bindTexture(p.TEXTURE_2D, d), p.copyTexImage2D(p.TEXTURE_2D, 0, p.RGBA, C.x, C.y, 16, 16, 0), p.uniform1i(h.renderType, 1), m.disable(p.DEPTH_TEST), m.activeTexture(p.TEXTURE1), m.bindTexture(p.TEXTURE_2D, f), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0), k.positionScreen.copy(S), k.customUpdateCallback ? k.customUpdateCallback(k) : k.updateLensFlares(), p.uniform1i(h.renderType, 2), m.enable(p.BLEND);
              for (var R = 0, I = k.lensFlares.length; R < I; R++) {
                var M = k.lensFlares[R];
                M.opacity > .001 && M.scale > .001 && (S.x = M.x, S.y = M.y, S.z = M.z, x = M.size * M.scale / g.w, _.x = x * b, _.y = x, p.uniform3f(h.screenPosition, S.x, S.y, S.z), p.uniform2f(h.scale, _.x, _.y), p.uniform1f(h.rotation, M.rotation), p.uniform1f(h.opacity, M.opacity), p.uniform3f(h.color, M.color.r, M.color.g, M.color.b), m.setBlending(M.blending, M.blendEquation, M.blendSrc, M.blendDst), e.setTexture2D(M.texture, 1), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0));
              }
            }
          }
          m.enable(p.CULL_FACE), m.enable(p.DEPTH_TEST), m.buffers.depth.setMask(!0), e.resetGLState();
        }
      };
    }
    function J(e, t) {
      function r() {
        var e = new Float32Array([-.5, -.5, 0, 0, .5, -.5, 1, 0, .5, .5, 1, 1, -.5, .5, 0, 1]),
          t = new Uint16Array([0, 1, 2, 0, 2, 3]);
        o = p.createBuffer(), s = p.createBuffer(), p.bindBuffer(p.ARRAY_BUFFER, o), p.bufferData(p.ARRAY_BUFFER, e, p.STATIC_DRAW), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, s), p.bufferData(p.ELEMENT_ARRAY_BUFFER, t, p.STATIC_DRAW), l = n(), h = {
          position: p.getAttribLocation(l, "position"),
          uv: p.getAttribLocation(l, "uv")
        }, f = {
          uvOffset: p.getUniformLocation(l, "uvOffset"),
          uvScale: p.getUniformLocation(l, "uvScale"),
          rotation: p.getUniformLocation(l, "rotation"),
          scale: p.getUniformLocation(l, "scale"),
          color: p.getUniformLocation(l, "color"),
          map: p.getUniformLocation(l, "map"),
          opacity: p.getUniformLocation(l, "opacity"),
          modelViewMatrix: p.getUniformLocation(l, "modelViewMatrix"),
          projectionMatrix: p.getUniformLocation(l, "projectionMatrix"),
          fogType: p.getUniformLocation(l, "fogType"),
          fogDensity: p.getUniformLocation(l, "fogDensity"),
          fogNear: p.getUniformLocation(l, "fogNear"),
          fogFar: p.getUniformLocation(l, "fogFar"),
          fogColor: p.getUniformLocation(l, "fogColor"),
          alphaTest: p.getUniformLocation(l, "alphaTest")
        };
        var r = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
        r.width = 8, r.height = 8;
        var i = r.getContext("2d");
        i.fillStyle = "white", i.fillRect(0, 0, 8, 8), d = new a(r), d.needsUpdate = !0;
      }
      function n() {
        var t = p.createProgram(),
          r = p.createShader(p.VERTEX_SHADER),
          n = p.createShader(p.FRAGMENT_SHADER);
        return p.shaderSource(r, ["precision " + e.getPrecision() + " float;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform float rotation;", "uniform vec2 scale;", "uniform vec2 uvOffset;", "uniform vec2 uvScale;", "attribute vec2 position;", "attribute vec2 uv;", "varying vec2 vUV;", "void main() {", "vUV = uvOffset + uv * uvScale;", "vec2 alignedPosition = position * scale;", "vec2 rotatedPosition;", "rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;", "rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;", "vec4 finalPosition;", "finalPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );", "finalPosition.xy += rotatedPosition;", "finalPosition = projectionMatrix * finalPosition;", "gl_Position = finalPosition;", "}"].join("\n")), p.shaderSource(n, ["precision " + e.getPrecision() + " float;", "uniform vec3 color;", "uniform sampler2D map;", "uniform float opacity;", "uniform int fogType;", "uniform vec3 fogColor;", "uniform float fogDensity;", "uniform float fogNear;", "uniform float fogFar;", "uniform float alphaTest;", "varying vec2 vUV;", "void main() {", "vec4 texture = texture2D( map, vUV );", "if ( texture.a < alphaTest ) discard;", "gl_FragColor = vec4( color * texture.xyz, texture.a * opacity );", "if ( fogType > 0 ) {", "float depth = gl_FragCoord.z / gl_FragCoord.w;", "float fogFactor = 0.0;", "if ( fogType == 1 ) {", "fogFactor = smoothstep( fogNear, fogFar, depth );", "} else {", "const float LOG2 = 1.442695;", "fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );", "fogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );", "}", "gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );", "}", "}"].join("\n")), p.compileShader(r), p.compileShader(n), p.attachShader(t, r), p.attachShader(t, n), p.linkProgram(t), t;
      }
      function i(e, t) {
        return e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : t.id - e.id;
      }
      var o,
        s,
        l,
        h,
        f,
        d,
        p = e.context,
        m = e.state,
        g = new u(),
        v = new c(),
        b = new u();
      this.render = function (n, a) {
        if (0 !== t.length) {
          void 0 === l && r(), p.useProgram(l), m.initAttributes(), m.enableAttribute(h.position), m.enableAttribute(h.uv), m.disableUnusedAttributes(), m.disable(p.CULL_FACE), m.enable(p.BLEND), p.bindBuffer(p.ARRAY_BUFFER, o), p.vertexAttribPointer(h.position, 2, p.FLOAT, !1, 16, 0), p.vertexAttribPointer(h.uv, 2, p.FLOAT, !1, 16, 8), p.bindBuffer(p.ELEMENT_ARRAY_BUFFER, s), p.uniformMatrix4fv(f.projectionMatrix, !1, a.projectionMatrix.elements), m.activeTexture(p.TEXTURE0), p.uniform1i(f.map, 0);
          var c = 0,
            u = 0,
            y = n.fog;
          y ? (p.uniform3f(f.fogColor, y.color.r, y.color.g, y.color.b), y.isFog ? (p.uniform1f(f.fogNear, y.near), p.uniform1f(f.fogFar, y.far), p.uniform1i(f.fogType, 1), c = 1, u = 1) : y.isFogExp2 && (p.uniform1f(f.fogDensity, y.density), p.uniform1i(f.fogType, 2), c = 2, u = 2)) : (p.uniform1i(f.fogType, 0), c = 0, u = 0);
          for (var w = 0, x = t.length; w < x; w++) {
            var _ = t[w];
            _.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, _.matrixWorld), _.z = -_.modelViewMatrix.elements[14];
          }
          t.sort(i);
          for (var S = [], w = 0, x = t.length; w < x; w++) {
            var _ = t[w],
              C = _.material;
            if (!1 !== C.visible) {
              p.uniform1f(f.alphaTest, C.alphaTest), p.uniformMatrix4fv(f.modelViewMatrix, !1, _.modelViewMatrix.elements), _.matrixWorld.decompose(g, v, b), S[0] = b.x, S[1] = b.y;
              var E = 0;
              n.fog && C.fog && (E = u), c !== E && (p.uniform1i(f.fogType, E), c = E), null !== C.map ? (p.uniform2f(f.uvOffset, C.map.offset.x, C.map.offset.y), p.uniform2f(f.uvScale, C.map.repeat.x, C.map.repeat.y)) : (p.uniform2f(f.uvOffset, 0, 0), p.uniform2f(f.uvScale, 1, 1)), p.uniform1f(f.opacity, C.opacity), p.uniform3f(f.color, C.color.r, C.color.g, C.color.b), p.uniform1f(f.rotation, C.rotation), p.uniform2fv(f.scale, S), m.setBlending(C.blending, C.blendEquation, C.blendSrc, C.blendDst), m.buffers.depth.setTest(C.depthTest), m.buffers.depth.setMask(C.depthWrite), C.map ? e.setTexture2D(C.map, 0) : e.setTexture2D(d, 0), p.drawElements(p.TRIANGLES, 6, p.UNSIGNED_SHORT, 0);
            }
          }
          m.enable(p.CULL_FACE), e.resetGLState();
        }
      };
    }
    function Q() {
      Object.defineProperty(this, "id", {
        value: Fs++
      }), this.uuid = Ss.generateUUID(), this.name = "", this.type = "Material", this.fog = !0, this.lights = !0, this.blending = Ea, this.side = ga, this.shading = wa, this.vertexColors = xa, this.opacity = 1, this.transparent = !1, this.blendSrc = Ua, this.blendDst = ja, this.blendEquation = Ia, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = Ka, this.depthTest = !0, this.depthWrite = !0, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaTest = 0, this.premultipliedAlpha = !1, this.overdraw = 0, this.visible = !0, this.needsUpdate = !0;
    }
    function $(e) {
      Q.call(this), this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.extensions = {
        derivatives: !1,
        fragDepth: !1,
        drawBuffers: !1,
        shaderTextureLOD: !1
      }, this.defaultAttributeValues = {
        color: [1, 1, 1],
        uv: [0, 0],
        uv2: [0, 0]
      }, this.index0AttributeName = void 0, void 0 !== e && (void 0 !== e.attributes && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(e));
    }
    function ee(e) {
      Q.call(this), this.type = "MeshDepthMaterial", this.depthPacking = xs, this.skinning = !1, this.morphTargets = !1, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.setValues(e);
    }
    function te(e, t) {
      this.min = void 0 !== e ? e : new u(1 / 0, 1 / 0, 1 / 0), this.max = void 0 !== t ? t : new u(-1 / 0, -1 / 0, -1 / 0);
    }
    function re(e, t) {
      this.center = void 0 !== e ? e : new u(), this.radius = void 0 !== t ? t : 0;
    }
    function ne() {
      this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
    function ie(e, t) {
      this.normal = void 0 !== e ? e : new u(1, 0, 0), this.constant = void 0 !== t ? t : 0;
    }
    function ae(e, t, r, n, i, a) {
      this.planes = [void 0 !== e ? e : new ie(), void 0 !== t ? t : new ie(), void 0 !== r ? r : new ie(), void 0 !== n ? n : new ie(), void 0 !== i ? i : new ie(), void 0 !== a ? a : new ie()];
    }
    function oe(e, t, r, n) {
      function a(t, r, n, i) {
        var a = t.geometry,
          o = null,
          s = S,
          l = t.customDepthMaterial;
        if (n && (s = C, l = t.customDistanceMaterial), l) o = l;else {
          var c = !1;
          r.morphTargets && (a && a.isBufferGeometry ? c = a.morphAttributes && a.morphAttributes.position && a.morphAttributes.position.length > 0 : a && a.isGeometry && (c = a.morphTargets && a.morphTargets.length > 0)), t.isSkinnedMesh && !1 === r.skinning && console.warn("THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:", t);
          var u = t.isSkinnedMesh && r.skinning,
            h = 0;
          c && (h |= w), u && (h |= x), o = s[h];
        }
        if (e.localClippingEnabled && !0 === r.clipShadows && 0 !== r.clippingPlanes.length) {
          var f = o.uuid,
            d = r.uuid,
            p = E[f];
          void 0 === p && (p = {}, E[f] = p);
          var m = p[d];
          void 0 === m && (m = o.clone(), p[d] = m), o = m;
        }
        o.visible = r.visible, o.wireframe = r.wireframe;
        var g = r.side;
        return F.renderSingleSided && g == ba && (g = ga), F.renderReverseSided && (g === ga ? g = va : g === va && (g = ga)), o.side = g, o.clipShadows = r.clipShadows, o.clippingPlanes = r.clippingPlanes, o.wireframeLinewidth = r.wireframeLinewidth, o.linewidth = r.linewidth, n && void 0 !== o.uniforms.lightPos && o.uniforms.lightPos.value.copy(i), o;
      }
      function l(t, n, i, o) {
        if (!1 !== t.visible) {
          if (t.layers.test(n.layers) && (t.isMesh || t.isLine || t.isPoints) && t.castShadow && (!t.frustumCulled || d.intersectsObject(t))) {
            t.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, t.matrixWorld);
            var s = r.update(t),
              c = t.material;
            if (Array.isArray(c)) for (var u = s.groups, h = 0, f = u.length; h < f; h++) {
              var p = u[h],
                m = c[p.materialIndex];
              if (m && m.visible) {
                var g = a(t, m, o, y);
                e.renderBufferDirect(i, null, s, g, t, p);
              }
            } else if (c.visible) {
              var g = a(t, c, o, y);
              e.renderBufferDirect(i, null, s, g, t, null);
            }
          }
          for (var v = t.children, b = 0, w = v.length; b < w; b++) l(v[b], n, i, o);
        }
      }
      var c = e.context,
        f = e.state,
        d = new ae(),
        p = new h(),
        m = t.shadows,
        g = new i(),
        v = new i(n.maxTextureSize, n.maxTextureSize),
        b = new u(),
        y = new u(),
        w = 1,
        x = 2,
        _ = 1 + (w | x),
        S = new Array(_),
        C = new Array(_),
        E = {},
        A = [new u(1, 0, 0), new u(-1, 0, 0), new u(0, 0, 1), new u(0, 0, -1), new u(0, 1, 0), new u(0, -1, 0)],
        T = [new u(0, 1, 0), new u(0, 1, 0), new u(0, 1, 0), new u(0, 1, 0), new u(0, 0, 1), new u(0, 0, -1)],
        k = [new o(), new o(), new o(), new o(), new o(), new o()],
        R = new ee();
      R.depthPacking = _s, R.clipping = !0;
      for (var I = Ls.distanceRGBA, M = Bs.clone(I.uniforms), O = 0; O !== _; ++O) {
        var P = 0 != (O & w),
          B = 0 != (O & x),
          D = R.clone();
        D.morphTargets = P, D.skinning = B, S[O] = D;
        var L = new $({
          defines: {
            USE_SHADOWMAP: ""
          },
          uniforms: M,
          vertexShader: I.vertexShader,
          fragmentShader: I.fragmentShader,
          morphTargets: P,
          skinning: B,
          clipping: !0
        });
        C[O] = L;
      }
      var F = this;
      this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = pa, this.renderReverseSided = !0, this.renderSingleSided = !0, this.render = function (t, r) {
        if (!1 !== F.enabled && (!1 !== F.autoUpdate || !1 !== F.needsUpdate) && 0 !== m.length) {
          f.disable(c.BLEND), f.buffers.color.setClear(1, 1, 1, 1), f.buffers.depth.setTest(!0), f.setScissorTest(!1);
          for (var n, i, a = 0, o = m.length; a < o; a++) {
            var u = m[a],
              h = u.shadow;
            if (void 0 !== h) {
              var w = h.camera,
                x = h.matrix;
              if (y.setFromMatrixPosition(u.matrixWorld), w.position.copy(y), g.copy(h.mapSize), g.min(v), u && u.isPointLight) {
                n = 6, i = !0;
                var _ = g.x,
                  S = g.y;
                k[0].set(2 * _, S, _, S), k[1].set(0, S, _, S), k[2].set(3 * _, S, _, S), k[3].set(_, S, _, S), k[4].set(3 * _, 0, _, S), k[5].set(_, 0, _, S), g.x *= 4, g.y *= 2, x.makeTranslation(-y.x, -y.y, -y.z);
              } else n = 1, i = !1, b.setFromMatrixPosition(u.target.matrixWorld), w.lookAt(b), w.updateMatrixWorld(), w.matrixWorldInverse.getInverse(w.matrixWorld), x.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), x.multiply(w.projectionMatrix), x.multiply(w.matrixWorldInverse);
              if (null === h.map) {
                var C = {
                  minFilter: wo,
                  magFilter: wo,
                  format: jo
                };
                h.map = new s(g.x, g.y, C), h.map.texture.name = u.name + ".shadowMap", w.updateProjectionMatrix();
              }
              h.isSpotLightShadow && h.update(u);
              var E = h.map;
              e.setRenderTarget(E), e.clear();
              for (var R = 0; R < n; R++) {
                if (i) {
                  b.copy(w.position), b.add(A[R]), w.up.copy(T[R]), w.lookAt(b), w.updateMatrixWorld(), w.matrixWorldInverse.getInverse(w.matrixWorld);
                  var I = k[R];
                  f.viewport(I);
                }
                p.multiplyMatrices(w.projectionMatrix, w.matrixWorldInverse), d.setFromMatrix(p), l(t, r, w, i);
              }
            } else console.warn("THREE.WebGLShadowMap:", u, "has no shadow.");
          }
          var M = e.getClearColor(),
            O = e.getClearAlpha();
          e.setClearColor(M, O), F.needsUpdate = !1;
        }
      };
    }
    function se(e, t) {
      this.origin = void 0 !== e ? e : new u(), this.direction = void 0 !== t ? t : new u();
    }
    function le(e, t, r, n) {
      this._x = e || 0, this._y = t || 0, this._z = r || 0, this._order = n || le.DefaultOrder;
    }
    function ce() {
      this.mask = 1;
    }
    function ue() {
      function e() {
        i.setFromEuler(n, !1);
      }
      function t() {
        n.setFromQuaternion(i, void 0, !1);
      }
      Object.defineProperty(this, "id", {
        value: Ns++
      }), this.uuid = Ss.generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = ue.DefaultUp.clone();
      var r = new u(),
        n = new le(),
        i = new c(),
        a = new u(1, 1, 1);
      n.onChange(e), i.onChange(t), Object.defineProperties(this, {
        position: {
          enumerable: !0,
          value: r
        },
        rotation: {
          enumerable: !0,
          value: n
        },
        quaternion: {
          enumerable: !0,
          value: i
        },
        scale: {
          enumerable: !0,
          value: a
        },
        modelViewMatrix: {
          value: new h()
        },
        normalMatrix: {
          value: new ne()
        }
      }), this.matrix = new h(), this.matrixWorld = new h(), this.matrixAutoUpdate = ue.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.layers = new ce(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.userData = {}, this.onBeforeRender = function () {}, this.onAfterRender = function () {};
    }
    function he(e, t) {
      this.start = void 0 !== e ? e : new u(), this.end = void 0 !== t ? t : new u();
    }
    function fe(e, t, r) {
      this.a = void 0 !== e ? e : new u(), this.b = void 0 !== t ? t : new u(), this.c = void 0 !== r ? r : new u();
    }
    function de(e, t, r, n, i, a) {
      this.a = e, this.b = t, this.c = r, this.normal = n && n.isVector3 ? n : new u(), this.vertexNormals = Array.isArray(n) ? n : [], this.color = i && i.isColor ? i : new Y(), this.vertexColors = Array.isArray(i) ? i : [], this.materialIndex = void 0 !== a ? a : 0;
    }
    function pe(e) {
      Q.call(this), this.type = "MeshBasicMaterial", this.color = new Y(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = eo, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.lights = !1, this.setValues(e);
    }
    function me(e, t, r) {
      if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
      this.uuid = Ss.generateUUID(), this.array = e, this.itemSize = t, this.count = void 0 !== e ? e.length / t : 0, this.normalized = !0 === r, this.dynamic = !1, this.updateRange = {
        offset: 0,
        count: -1
      }, this.onUploadCallback = function () {}, this.version = 0;
    }
    function ge(e, t) {
      me.call(this, new Int8Array(e), t);
    }
    function ve(e, t) {
      me.call(this, new Uint8Array(e), t);
    }
    function be(e, t) {
      me.call(this, new Uint8ClampedArray(e), t);
    }
    function ye(e, t) {
      me.call(this, new Int16Array(e), t);
    }
    function we(e, t) {
      me.call(this, new Uint16Array(e), t);
    }
    function xe(e, t) {
      me.call(this, new Int32Array(e), t);
    }
    function _e(e, t) {
      me.call(this, new Uint32Array(e), t);
    }
    function Se(e, t) {
      me.call(this, new Float32Array(e), t);
    }
    function Ce(e, t) {
      me.call(this, new Float64Array(e), t);
    }
    function Ee() {
      this.indices = [], this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    function Ae(e) {
      if (0 === e.length) return -1 / 0;
      for (var t = e[0], r = 1, n = e.length; r < n; ++r) e[r] > t && (t = e[r]);
      return t;
    }
    function Te() {
      return Us++;
    }
    function ke() {
      Object.defineProperty(this, "id", {
        value: Te()
      }), this.uuid = Ss.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    function Re() {
      Object.defineProperty(this, "id", {
        value: Te()
      }), this.uuid = Ss.generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
        start: 0,
        count: 1 / 0
      };
    }
    function Ie(e, t) {
      ue.call(this), this.type = "Mesh", this.geometry = void 0 !== e ? e : new Re(), this.material = void 0 !== t ? t : new pe({
        color: 16777215 * Math.random()
      }), this.drawMode = us, this.updateMorphTargets();
    }
    function Me(e, t, r, n, i, a) {
      ke.call(this), this.type = "BoxGeometry", this.parameters = {
        width: e,
        height: t,
        depth: r,
        widthSegments: n,
        heightSegments: i,
        depthSegments: a
      }, this.fromBufferGeometry(new Oe(e, t, r, n, i, a)), this.mergeVertices();
    }
    function Oe(e, t, r, n, i, a) {
      function o(e, t, r, n, i, a, o, m, g, v, b) {
        var y,
          w,
          x = a / g,
          _ = o / v,
          S = a / 2,
          C = o / 2,
          E = m / 2,
          A = g + 1,
          T = v + 1,
          k = 0,
          R = 0,
          I = new u();
        for (w = 0; w < T; w++) {
          var M = w * _ - C;
          for (y = 0; y < A; y++) {
            var O = y * x - S;
            I[e] = O * n, I[t] = M * i, I[r] = E, c.push(I.x, I.y, I.z), I[e] = 0, I[t] = 0, I[r] = m > 0 ? 1 : -1, h.push(I.x, I.y, I.z), f.push(y / g), f.push(1 - w / v), k += 1;
          }
        }
        for (w = 0; w < v; w++) for (y = 0; y < g; y++) {
          var P = d + y + A * w,
            B = d + y + A * (w + 1),
            D = d + (y + 1) + A * (w + 1),
            L = d + (y + 1) + A * w;
          l.push(P, B, L), l.push(B, D, L), R += 6;
        }
        s.addGroup(p, R, b), p += R, d += k;
      }
      Re.call(this), this.type = "BoxBufferGeometry", this.parameters = {
        width: e,
        height: t,
        depth: r,
        widthSegments: n,
        heightSegments: i,
        depthSegments: a
      };
      var s = this;
      n = Math.floor(n) || 1, i = Math.floor(i) || 1, a = Math.floor(a) || 1;
      var l = [],
        c = [],
        h = [],
        f = [],
        d = 0,
        p = 0;
      o("z", "y", "x", -1, -1, r, t, e, a, i, 0), o("z", "y", "x", 1, -1, r, t, -e, a, i, 1), o("x", "z", "y", 1, 1, e, r, t, n, a, 2), o("x", "z", "y", 1, -1, e, r, -t, n, a, 3), o("x", "y", "z", 1, -1, e, t, r, n, i, 4), o("x", "y", "z", -1, -1, e, t, -r, n, i, 5), this.setIndex(l), this.addAttribute("position", new Se(c, 3)), this.addAttribute("normal", new Se(h, 3)), this.addAttribute("uv", new Se(f, 2));
    }
    function Pe(e, t, r, n) {
      ke.call(this), this.type = "PlaneGeometry", this.parameters = {
        width: e,
        height: t,
        widthSegments: r,
        heightSegments: n
      }, this.fromBufferGeometry(new Be(e, t, r, n)), this.mergeVertices();
    }
    function Be(e, t, r, n) {
      Re.call(this), this.type = "PlaneBufferGeometry", this.parameters = {
        width: e,
        height: t,
        widthSegments: r,
        heightSegments: n
      };
      var i,
        a,
        o = e / 2,
        s = t / 2,
        l = Math.floor(r) || 1,
        c = Math.floor(n) || 1,
        u = l + 1,
        h = c + 1,
        f = e / l,
        d = t / c,
        p = [],
        m = [],
        g = [],
        v = [];
      for (a = 0; a < h; a++) {
        var b = a * d - s;
        for (i = 0; i < u; i++) {
          var y = i * f - o;
          m.push(y, -b, 0), g.push(0, 0, 1), v.push(i / l), v.push(1 - a / c);
        }
      }
      for (a = 0; a < c; a++) for (i = 0; i < l; i++) {
        var w = i + u * a,
          x = i + u * (a + 1),
          _ = i + 1 + u * (a + 1),
          S = i + 1 + u * a;
        p.push(w, x, S), p.push(x, _, S);
      }
      this.setIndex(p), this.addAttribute("position", new Se(m, 3)), this.addAttribute("normal", new Se(g, 3)), this.addAttribute("uv", new Se(v, 2));
    }
    function De() {
      ue.call(this), this.type = "Camera", this.matrixWorldInverse = new h(), this.projectionMatrix = new h();
    }
    function Le(e, t, r, n) {
      De.call(this), this.type = "PerspectiveCamera", this.fov = void 0 !== e ? e : 50, this.zoom = 1, this.near = void 0 !== r ? r : .1, this.far = void 0 !== n ? n : 2e3, this.focus = 10, this.aspect = void 0 !== t ? t : 1, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    function Fe(e, t, r, n, i, a) {
      De.call(this), this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = r, this.bottom = n, this.near = void 0 !== i ? i : .1, this.far = void 0 !== a ? a : 2e3, this.updateProjectionMatrix();
    }
    function Ne(e) {
      function t(t, r) {
        var n = t.array,
          i = t.dynamic ? e.DYNAMIC_DRAW : e.STATIC_DRAW,
          a = e.createBuffer();
        e.bindBuffer(r, a), e.bufferData(r, n, i), t.onUploadCallback();
        var o = e.FLOAT;
        return n instanceof Float32Array ? o = e.FLOAT : n instanceof Float64Array ? console.warn("Unsupported data buffer format: Float64Array") : n instanceof Uint16Array ? o = e.UNSIGNED_SHORT : n instanceof Int16Array ? o = e.SHORT : n instanceof Uint32Array ? o = e.UNSIGNED_INT : n instanceof Int32Array ? o = e.INT : n instanceof Int8Array ? o = e.BYTE : n instanceof Uint8Array && (o = e.UNSIGNED_BYTE), {
          buffer: a,
          type: o,
          bytesPerElement: n.BYTES_PER_ELEMENT,
          version: t.version
        };
      }
      function r(t, r, n) {
        var i = r.array,
          a = r.updateRange;
        e.bindBuffer(n, t), !1 === r.dynamic ? e.bufferData(n, i, e.STATIC_DRAW) : -1 === a.count ? e.bufferSubData(n, 0, i) : 0 === a.count ? console.error("THREE.WebGLObjects.updateBuffer: dynamic THREE.BufferAttribute marked as needsUpdate but updateRange.count is 0, ensure you are using set methods or updating manually.") : (e.bufferSubData(n, a.offset * i.BYTES_PER_ELEMENT, i.subarray(a.offset, a.offset + a.count)), a.count = 0);
      }
      function n(e) {
        return e.isInterleavedBufferAttribute && (e = e.data), o[e.uuid];
      }
      function i(t) {
        var r = o[t.uuid];
        r && (e.deleteBuffer(r.buffer), delete o[t.uuid]);
      }
      function a(e, n) {
        e.isInterleavedBufferAttribute && (e = e.data);
        var i = o[e.uuid];
        void 0 === i ? o[e.uuid] = t(e, n) : i.version < e.version && (r(i.buffer, e, n), i.version = e.version);
      }
      var o = {};
      return {
        get: n,
        remove: i,
        update: a
      };
    }
    function Ue(e, t) {
      return e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.program && t.program && e.program !== t.program ? e.program.id - t.program.id : e.material.id !== t.material.id ? e.material.id - t.material.id : e.z !== t.z ? e.z - t.z : e.id - t.id;
    }
    function je(e, t) {
      return e.renderOrder !== t.renderOrder ? e.renderOrder - t.renderOrder : e.z !== t.z ? t.z - e.z : e.id - t.id;
    }
    function ze() {
      function e() {
        a = -1, s = -1;
      }
      function t(e, t, r, n, l) {
        var c, u;
        r.transparent ? (c = o, u = ++s) : (c = i, u = ++a);
        var h = c[u];
        h ? (h.id = e.id, h.object = e, h.geometry = t, h.material = r, h.program = r.program, h.renderOrder = e.renderOrder, h.z = n, h.group = l) : (h = {
          id: e.id,
          object: e,
          geometry: t,
          material: r,
          program: r.program,
          renderOrder: e.renderOrder,
          z: n,
          group: l
        }, c.push(h));
      }
      function r() {
        i.length = a + 1, o.length = s + 1;
      }
      function n() {
        i.sort(Ue), o.sort(je);
      }
      var i = [],
        a = -1,
        o = [],
        s = -1;
      return {
        opaque: i,
        transparent: o,
        init: e,
        push: t,
        finish: r,
        sort: n
      };
    }
    function He() {
      function e(e, t) {
        var n = e.id + "," + t.id,
          i = r[n];
        return void 0 === i && (i = new ze(), r[n] = i), i;
      }
      function t() {
        r = {};
      }
      var r = {};
      return {
        get: e,
        dispose: t
      };
    }
    function Ge(e, t, r) {
      function n(e) {
        s = e;
      }
      function i(r) {
        r.array instanceof Uint32Array && t.get("OES_element_index_uint") ? (l = e.UNSIGNED_INT, c = 4) : r.array instanceof Uint16Array ? (l = e.UNSIGNED_SHORT, c = 2) : (l = e.UNSIGNED_BYTE, c = 1);
      }
      function a(t, n) {
        e.drawElements(s, n, l, t * c), r.calls++, r.vertices += n, s === e.TRIANGLES && (r.faces += n / 3);
      }
      function o(n, i, a) {
        var o = t.get("ANGLE_instanced_arrays");
        if (null === o) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        o.drawElementsInstancedANGLE(s, a, l, i * c, n.maxInstancedCount), r.calls++, r.vertices += a * n.maxInstancedCount, s === e.TRIANGLES && (r.faces += n.maxInstancedCount * a / 3);
      }
      var s, l, c;
      this.setMode = n, this.setIndex = i, this.render = a, this.renderInstances = o;
    }
    function Ve(e, t, r) {
      function n(e) {
        o = e;
      }
      function i(t, n) {
        e.drawArrays(o, t, n), r.calls++, r.vertices += n, o === e.TRIANGLES && (r.faces += n / 3);
      }
      function a(n, i, a) {
        var s = t.get("ANGLE_instanced_arrays");
        if (null === s) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        var l = n.attributes.position;
        l.isInterleavedBufferAttribute ? (a = l.data.count, s.drawArraysInstancedANGLE(o, 0, a, n.maxInstancedCount)) : s.drawArraysInstancedANGLE(o, i, a, n.maxInstancedCount), r.calls++, r.vertices += a * n.maxInstancedCount, o === e.TRIANGLES && (r.faces += n.maxInstancedCount * a / 3);
      }
      var o;
      this.setMode = n, this.render = i, this.renderInstances = a;
    }
    function qe(e, t, r) {
      function n(e) {
        var i = e.target,
          a = s[i.id];
        null !== a.index && t.remove(a.index);
        for (var o in a.attributes) t.remove(a.attributes[o]);
        i.removeEventListener("dispose", n), delete s[i.id];
        var c = l[i.id];
        c && (t.remove(c), delete l[i.id]), c = l[a.id], c && (t.remove(c), delete l[a.id]), r.geometries--;
      }
      function i(e, t) {
        var i = s[t.id];
        return i || (t.addEventListener("dispose", n), t.isBufferGeometry ? i = t : t.isGeometry && (void 0 === t._bufferGeometry && (t._bufferGeometry = new Re().setFromObject(e)), i = t._bufferGeometry), s[t.id] = i, r.geometries++, i);
      }
      function a(r) {
        var n = r.index,
          i = r.attributes;
        null !== n && t.update(n, e.ELEMENT_ARRAY_BUFFER);
        for (var a in i) t.update(i[a], e.ARRAY_BUFFER);
        var o = r.morphAttributes;
        for (var a in o) for (var s = o[a], l = 0, c = s.length; l < c; l++) t.update(s[l], e.ARRAY_BUFFER);
      }
      function o(r) {
        var n = l[r.id];
        if (n) return n;
        var i = [],
          a = r.index,
          o = r.attributes;
        if (null !== a) for (var s = a.array, c = 0, u = s.length; c < u; c += 3) {
          var h = s[c + 0],
            f = s[c + 1],
            d = s[c + 2];
          i.push(h, f, f, d, d, h);
        } else for (var s = o.position.array, c = 0, u = s.length / 3 - 1; c < u; c += 3) {
          var h = c + 0,
            f = c + 1,
            d = c + 2;
          i.push(h, f, f, d, d, h);
        }
        return n = new (Ae(i) > 65535 ? _e : we)(i, 1), t.update(n, e.ELEMENT_ARRAY_BUFFER), l[r.id] = n, n;
      }
      var s = {},
        l = {};
      return {
        get: i,
        update: a,
        getWireframeAttribute: o
      };
    }
    function We() {
      var e = {};
      return {
        get: function get(t) {
          if (void 0 !== e[t.id]) return e[t.id];
          var r;
          switch (t.type) {
            case "DirectionalLight":
              r = {
                direction: new u(),
                color: new Y(),
                shadow: !1,
                shadowBias: 0,
                shadowRadius: 1,
                shadowMapSize: new i()
              };
              break;
            case "SpotLight":
              r = {
                position: new u(),
                direction: new u(),
                color: new Y(),
                distance: 0,
                coneCos: 0,
                penumbraCos: 0,
                decay: 0,
                shadow: !1,
                shadowBias: 0,
                shadowRadius: 1,
                shadowMapSize: new i()
              };
              break;
            case "PointLight":
              r = {
                position: new u(),
                color: new Y(),
                distance: 0,
                decay: 0,
                shadow: !1,
                shadowBias: 0,
                shadowRadius: 1,
                shadowMapSize: new i()
              };
              break;
            case "HemisphereLight":
              r = {
                direction: new u(),
                skyColor: new Y(),
                groundColor: new Y()
              };
              break;
            case "RectAreaLight":
              r = {
                color: new Y(),
                position: new u(),
                halfWidth: new u(),
                halfHeight: new u()
              };
          }
          return e[t.id] = r, r;
        }
      };
    }
    function Xe(e, t, r) {
      function n(e) {
        var n = r.frame,
          i = e.geometry,
          o = t.get(e, i);
        return a[o.id] !== n && (i.isGeometry && o.updateFromObject(e), t.update(o), a[o.id] = n), o;
      }
      function i() {
        a = {};
      }
      var a = {};
      return {
        update: n,
        clear: i
      };
    }
    function Ye(e) {
      for (var t = e.split("\n"), r = 0; r < t.length; r++) t[r] = r + 1 + ": " + t[r];
      return t.join("\n");
    }
    function Ke(e, t, r) {
      var n = e.createShader(t);
      return e.shaderSource(n, r), e.compileShader(n), !1 === e.getShaderParameter(n, e.COMPILE_STATUS) && console.error("THREE.WebGLShader: Shader couldn't compile."), "" !== e.getShaderInfoLog(n) && console.warn("THREE.WebGLShader: gl.getShaderInfoLog()", t === e.VERTEX_SHADER ? "vertex" : "fragment", e.getShaderInfoLog(n), Ye(r)), n;
    }
    function Ze(e) {
      switch (e) {
        case ds:
          return ["Linear", "( value )"];
        case ps:
          return ["sRGB", "( value )"];
        case gs:
          return ["RGBE", "( value )"];
        case bs:
          return ["RGBM", "( value, 7.0 )"];
        case ys:
          return ["RGBM", "( value, 16.0 )"];
        case ws:
          return ["RGBD", "( value, 256.0 )"];
        case ms:
          return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
        default:
          throw new Error("unsupported encoding: " + e);
      }
    }
    function Je(e, t) {
      var r = Ze(t);
      return "vec4 " + e + "( vec4 value ) { return " + r[0] + "ToLinear" + r[1] + "; }";
    }
    function Qe(e, t) {
      var r = Ze(t);
      return "vec4 " + e + "( vec4 value ) { return LinearTo" + r[0] + r[1] + "; }";
    }
    function $e(e, t) {
      var r;
      switch (t) {
        case io:
          r = "Linear";
          break;
        case ao:
          r = "Reinhard";
          break;
        case oo:
          r = "Uncharted2";
          break;
        case so:
          r = "OptimizedCineon";
          break;
        default:
          throw new Error("unsupported toneMapping: " + t);
      }
      return "vec3 " + e + "( vec3 color ) { return " + r + "ToneMapping( color ); }";
    }
    function et(e, t, r) {
      return e = e || {}, [e.derivatives || t.envMapCubeUV || t.bumpMap || t.normalMap || t.flatShading ? "#extension GL_OES_standard_derivatives : enable" : "", (e.fragDepth || t.logarithmicDepthBuffer) && r.get("EXT_frag_depth") ? "#extension GL_EXT_frag_depth : enable" : "", e.drawBuffers && r.get("WEBGL_draw_buffers") ? "#extension GL_EXT_draw_buffers : require" : "", (e.shaderTextureLOD || t.envMap) && r.get("EXT_shader_texture_lod") ? "#extension GL_EXT_shader_texture_lod : enable" : ""].filter(nt).join("\n");
    }
    function tt(e) {
      var t = [];
      for (var r in e) {
        var n = e[r];
        !1 !== n && t.push("#define " + r + " " + n);
      }
      return t.join("\n");
    }
    function rt(e, t, r) {
      for (var n = {}, i = e.getProgramParameter(t, e.ACTIVE_ATTRIBUTES), a = 0; a < i; a++) {
        var o = e.getActiveAttrib(t, a),
          s = o.name;
        n[s] = e.getAttribLocation(t, s);
      }
      return n;
    }
    function nt(e) {
      return "" !== e;
    }
    function it(e, t) {
      return e.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights);
    }
    function at(e) {
      function t(e, t) {
        var r = Ds[t];
        if (void 0 === r) throw new Error("Can not resolve #include <" + t + ">");
        return at(r);
      }
      var r = /^[ \t]*#include +<([\w\d.]+)>/gm;
      return e.replace(r, t);
    }
    function ot(e) {
      function t(e, t, r, n) {
        for (var i = "", a = parseInt(t); a < parseInt(r); a++) i += n.replace(/\[ i \]/g, "[ " + a + " ]");
        return i;
      }
      var r = /for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
      return e.replace(r, t);
    }
    function st(e, t, r, n) {
      var i = e.context,
        a = r.extensions,
        o = r.defines,
        s = r.__webglShader.vertexShader,
        l = r.__webglShader.fragmentShader,
        c = "SHADOWMAP_TYPE_BASIC";
      n.shadowMapType === pa ? c = "SHADOWMAP_TYPE_PCF" : n.shadowMapType === ma && (c = "SHADOWMAP_TYPE_PCF_SOFT");
      var u = "ENVMAP_TYPE_CUBE",
        h = "ENVMAP_MODE_REFLECTION",
        f = "ENVMAP_BLENDING_MULTIPLY";
      if (n.envMap) {
        switch (r.envMap.mapping) {
          case co:
          case uo:
            u = "ENVMAP_TYPE_CUBE";
            break;
          case mo:
          case go:
            u = "ENVMAP_TYPE_CUBE_UV";
            break;
          case ho:
          case fo:
            u = "ENVMAP_TYPE_EQUIREC";
            break;
          case po:
            u = "ENVMAP_TYPE_SPHERE";
        }
        switch (r.envMap.mapping) {
          case uo:
          case fo:
            h = "ENVMAP_MODE_REFRACTION";
        }
        switch (r.combine) {
          case eo:
            f = "ENVMAP_BLENDING_MULTIPLY";
            break;
          case to:
            f = "ENVMAP_BLENDING_MIX";
            break;
          case ro:
            f = "ENVMAP_BLENDING_ADD";
        }
      }
      var d,
        p,
        m = e.gammaFactor > 0 ? e.gammaFactor : 1,
        g = et(a, n, e.extensions),
        v = tt(o),
        b = i.createProgram();
      r.isRawShaderMaterial ? (d = [v, "\n"].filter(nt).join("\n"), p = [g, v, "\n"].filter(nt).join("\n")) : (d = ["precision " + n.precision + " float;", "precision " + n.precision + " int;", "#define SHADER_NAME " + r.__webglShader.name, v, n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "", "#define GAMMA_FACTOR " + m, "#define MAX_BONES " + n.maxBones, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + h : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.displacementMap && n.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.vertexColors ? "#define USE_COLOR" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.skinning ? "#define USE_SKINNING" : "", n.useVertexTexture ? "#define BONE_TEXTURE" : "", n.morphTargets ? "#define USE_MORPHTARGETS" : "", n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", "#define NUM_CLIPPING_PLANES " + n.numClippingPlanes, n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + c : "", n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && e.extensions.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", "uniform mat4 modelMatrix;", "uniform mat4 modelViewMatrix;", "uniform mat4 projectionMatrix;", "uniform mat4 viewMatrix;", "uniform mat3 normalMatrix;", "uniform vec3 cameraPosition;", "attribute vec3 position;", "attribute vec3 normal;", "attribute vec2 uv;", "#ifdef USE_COLOR", "\tattribute vec3 color;", "#endif", "#ifdef USE_MORPHTARGETS", "\tattribute vec3 morphTarget0;", "\tattribute vec3 morphTarget1;", "\tattribute vec3 morphTarget2;", "\tattribute vec3 morphTarget3;", "\t#ifdef USE_MORPHNORMALS", "\t\tattribute vec3 morphNormal0;", "\t\tattribute vec3 morphNormal1;", "\t\tattribute vec3 morphNormal2;", "\t\tattribute vec3 morphNormal3;", "\t#else", "\t\tattribute vec3 morphTarget4;", "\t\tattribute vec3 morphTarget5;", "\t\tattribute vec3 morphTarget6;", "\t\tattribute vec3 morphTarget7;", "\t#endif", "#endif", "#ifdef USE_SKINNING", "\tattribute vec4 skinIndex;", "\tattribute vec4 skinWeight;", "#endif", "\n"].filter(nt).join("\n"), p = [g, "precision " + n.precision + " float;", "precision " + n.precision + " int;", "#define SHADER_NAME " + r.__webglShader.name, v, n.alphaTest ? "#define ALPHATEST " + n.alphaTest : "", "#define GAMMA_FACTOR " + m, n.useFog && n.fog ? "#define USE_FOG" : "", n.useFog && n.fogExp ? "#define FOG_EXP2" : "", n.map ? "#define USE_MAP" : "", n.envMap ? "#define USE_ENVMAP" : "", n.envMap ? "#define " + u : "", n.envMap ? "#define " + h : "", n.envMap ? "#define " + f : "", n.lightMap ? "#define USE_LIGHTMAP" : "", n.aoMap ? "#define USE_AOMAP" : "", n.emissiveMap ? "#define USE_EMISSIVEMAP" : "", n.bumpMap ? "#define USE_BUMPMAP" : "", n.normalMap ? "#define USE_NORMALMAP" : "", n.specularMap ? "#define USE_SPECULARMAP" : "", n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "", n.metalnessMap ? "#define USE_METALNESSMAP" : "", n.alphaMap ? "#define USE_ALPHAMAP" : "", n.vertexColors ? "#define USE_COLOR" : "", n.gradientMap ? "#define USE_GRADIENTMAP" : "", n.flatShading ? "#define FLAT_SHADED" : "", n.doubleSided ? "#define DOUBLE_SIDED" : "", n.flipSided ? "#define FLIP_SIDED" : "", "#define NUM_CLIPPING_PLANES " + n.numClippingPlanes, "#define UNION_CLIPPING_PLANES " + (n.numClippingPlanes - n.numClipIntersection), n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "", n.shadowMapEnabled ? "#define " + c : "", n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "", n.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "", n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "", n.logarithmicDepthBuffer && e.extensions.get("EXT_frag_depth") ? "#define USE_LOGDEPTHBUF_EXT" : "", n.envMap && e.extensions.get("EXT_shader_texture_lod") ? "#define TEXTURE_LOD_EXT" : "", "uniform mat4 viewMatrix;", "uniform vec3 cameraPosition;", n.toneMapping !== no ? "#define TONE_MAPPING" : "", n.toneMapping !== no ? Ds.tonemapping_pars_fragment : "", n.toneMapping !== no ? $e("toneMapping", n.toneMapping) : "", n.dithering ? "#define DITHERING" : "", n.outputEncoding || n.mapEncoding || n.envMapEncoding || n.emissiveMapEncoding ? Ds.encodings_pars_fragment : "", n.mapEncoding ? Je("mapTexelToLinear", n.mapEncoding) : "", n.envMapEncoding ? Je("envMapTexelToLinear", n.envMapEncoding) : "", n.emissiveMapEncoding ? Je("emissiveMapTexelToLinear", n.emissiveMapEncoding) : "", n.outputEncoding ? Qe("linearToOutputTexel", n.outputEncoding) : "", n.depthPacking ? "#define DEPTH_PACKING " + r.depthPacking : "", "\n"].filter(nt).join("\n")), s = at(s, n), s = it(s, n), l = at(l, n), l = it(l, n), r.isShaderMaterial || (s = ot(s), l = ot(l));
      var y = d + s,
        w = p + l,
        x = Ke(i, i.VERTEX_SHADER, y),
        _ = Ke(i, i.FRAGMENT_SHADER, w);
      i.attachShader(b, x), i.attachShader(b, _), void 0 !== r.index0AttributeName ? i.bindAttribLocation(b, 0, r.index0AttributeName) : !0 === n.morphTargets && i.bindAttribLocation(b, 0, "position"), i.linkProgram(b);
      var S = i.getProgramInfoLog(b),
        C = i.getShaderInfoLog(x),
        E = i.getShaderInfoLog(_),
        A = !0,
        T = !0;
      !1 === i.getProgramParameter(b, i.LINK_STATUS) ? (A = !1, console.error("THREE.WebGLProgram: shader error: ", i.getError(), "gl.VALIDATE_STATUS", i.getProgramParameter(b, i.VALIDATE_STATUS), "gl.getProgramInfoLog", S, C, E)) : "" !== S ? console.warn("THREE.WebGLProgram: gl.getProgramInfoLog()", S) : "" !== C && "" !== E || (T = !1), T && (this.diagnostics = {
        runnable: A,
        material: r,
        programLog: S,
        vertexShader: {
          log: C,
          prefix: d
        },
        fragmentShader: {
          log: E,
          prefix: p
        }
      }), i.deleteShader(x), i.deleteShader(_);
      var k;
      this.getUniforms = function () {
        return void 0 === k && (k = new X(i, b, e)), k;
      };
      var R;
      return this.getAttributes = function () {
        return void 0 === R && (R = rt(i, b)), R;
      }, this.destroy = function () {
        i.deleteProgram(b), this.program = void 0;
      }, Object.defineProperties(this, {
        uniforms: {
          get: function get() {
            return console.warn("THREE.WebGLProgram: .uniforms is now .getUniforms()."), this.getUniforms();
          }
        },
        attributes: {
          get: function get() {
            return console.warn("THREE.WebGLProgram: .attributes is now .getAttributes()."), this.getAttributes();
          }
        }
      }), this.id = js++, this.code = t, this.usedTimes = 1, this.program = b, this.vertexShader = x, this.fragmentShader = _, this;
    }
    function lt(e, t) {
      function r(e) {
        var r = e.skeleton,
          n = r.bones;
        if (t.floatVertexTextures) return 1024;
        var i = t.maxVertexUniforms,
          a = Math.floor((i - 20) / 4),
          o = Math.min(a, n.length);
        return o < n.length ? (console.warn("THREE.WebGLRenderer: Skeleton has " + n.length + " bones. This GPU supports " + o + "."), 0) : o;
      }
      function n(e, t) {
        var r;
        return e ? e.isTexture ? r = e.encoding : e.isWebGLRenderTarget && (console.warn("THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."), r = e.texture.encoding) : r = ds, r === ds && t && (r = ms), r;
      }
      var i = [],
        a = {
          MeshDepthMaterial: "depth",
          MeshNormalMaterial: "normal",
          MeshBasicMaterial: "basic",
          MeshLambertMaterial: "lambert",
          MeshPhongMaterial: "phong",
          MeshToonMaterial: "phong",
          MeshStandardMaterial: "physical",
          MeshPhysicalMaterial: "physical",
          LineBasicMaterial: "basic",
          LineDashedMaterial: "dashed",
          PointsMaterial: "points"
        },
        o = ["precision", "supportsVertexTextures", "map", "mapEncoding", "envMap", "envMapMode", "envMapEncoding", "lightMap", "aoMap", "emissiveMap", "emissiveMapEncoding", "bumpMap", "normalMap", "displacementMap", "specularMap", "roughnessMap", "metalnessMap", "gradientMap", "alphaMap", "combine", "vertexColors", "fog", "useFog", "fogExp", "flatShading", "sizeAttenuation", "logarithmicDepthBuffer", "skinning", "maxBones", "useVertexTexture", "morphTargets", "morphNormals", "maxMorphTargets", "maxMorphNormals", "premultipliedAlpha", "numDirLights", "numPointLights", "numSpotLights", "numHemiLights", "numRectAreaLights", "shadowMapEnabled", "shadowMapType", "toneMapping", "physicallyCorrectLights", "alphaTest", "doubleSided", "flipSided", "numClippingPlanes", "numClipIntersection", "depthPacking", "dithering"];
      this.getParameters = function (i, o, s, l, c, u) {
        var h = a[i.type],
          f = u.isSkinnedMesh ? r(u) : 0,
          d = e.getPrecision();
        null !== i.precision && (d = t.getMaxPrecision(i.precision)) !== i.precision && console.warn("THREE.WebGLProgram.getParameters:", i.precision, "not supported, using", d, "instead.");
        var p = e.getRenderTarget();
        return {
          shaderID: h,
          precision: d,
          supportsVertexTextures: t.vertexTextures,
          outputEncoding: n(p ? p.texture : null, e.gammaOutput),
          map: !!i.map,
          mapEncoding: n(i.map, e.gammaInput),
          envMap: !!i.envMap,
          envMapMode: i.envMap && i.envMap.mapping,
          envMapEncoding: n(i.envMap, e.gammaInput),
          envMapCubeUV: !!i.envMap && (i.envMap.mapping === mo || i.envMap.mapping === go),
          lightMap: !!i.lightMap,
          aoMap: !!i.aoMap,
          emissiveMap: !!i.emissiveMap,
          emissiveMapEncoding: n(i.emissiveMap, e.gammaInput),
          bumpMap: !!i.bumpMap,
          normalMap: !!i.normalMap,
          displacementMap: !!i.displacementMap,
          roughnessMap: !!i.roughnessMap,
          metalnessMap: !!i.metalnessMap,
          specularMap: !!i.specularMap,
          alphaMap: !!i.alphaMap,
          gradientMap: !!i.gradientMap,
          combine: i.combine,
          vertexColors: i.vertexColors,
          fog: !!s,
          useFog: i.fog,
          fogExp: s && s.isFogExp2,
          flatShading: i.shading === ya,
          sizeAttenuation: i.sizeAttenuation,
          logarithmicDepthBuffer: t.logarithmicDepthBuffer,
          skinning: i.skinning && f > 0,
          maxBones: f,
          useVertexTexture: t.floatVertexTextures,
          morphTargets: i.morphTargets,
          morphNormals: i.morphNormals,
          maxMorphTargets: e.maxMorphTargets,
          maxMorphNormals: e.maxMorphNormals,
          numDirLights: o.directional.length,
          numPointLights: o.point.length,
          numSpotLights: o.spot.length,
          numRectAreaLights: o.rectArea.length,
          numHemiLights: o.hemi.length,
          numClippingPlanes: l,
          numClipIntersection: c,
          dithering: i.dithering,
          shadowMapEnabled: e.shadowMap.enabled && u.receiveShadow && o.shadows.length > 0,
          shadowMapType: e.shadowMap.type,
          toneMapping: e.toneMapping,
          physicallyCorrectLights: e.physicallyCorrectLights,
          premultipliedAlpha: i.premultipliedAlpha,
          alphaTest: i.alphaTest,
          doubleSided: i.side === ba,
          flipSided: i.side === va,
          depthPacking: void 0 !== i.depthPacking && i.depthPacking
        };
      }, this.getProgramCode = function (e, t) {
        var r = [];
        if (t.shaderID ? r.push(t.shaderID) : (r.push(e.fragmentShader), r.push(e.vertexShader)), void 0 !== e.defines) for (var n in e.defines) r.push(n), r.push(e.defines[n]);
        for (var i = 0; i < o.length; i++) r.push(t[o[i]]);
        return r.join();
      }, this.acquireProgram = function (t, r, n) {
        for (var a, o = 0, s = i.length; o < s; o++) {
          var l = i[o];
          if (l.code === n) {
            a = l, ++a.usedTimes;
            break;
          }
        }
        return void 0 === a && (a = new st(e, n, t, r), i.push(a)), a;
      }, this.releaseProgram = function (e) {
        if (0 == --e.usedTimes) {
          var t = i.indexOf(e);
          i[t] = i[i.length - 1], i.pop(), e.destroy();
        }
      }, this.programs = i;
    }
    function ct(e, t, r, n, i, a, o) {
      function s(e, t) {
        if (e.width > t || e.height > t) {
          var r = t / Math.max(e.width, e.height),
            n = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
          n.width = Math.floor(e.width * r), n.height = Math.floor(e.height * r);
          return n.getContext("2d").drawImage(e, 0, 0, e.width, e.height, 0, 0, n.width, n.height), console.warn("THREE.WebGLRenderer: image is too big (" + e.width + "x" + e.height + "). Resized to " + n.width + "x" + n.height, e), n;
        }
        return e;
      }
      function l(e) {
        return Ss.isPowerOfTwo(e.width) && Ss.isPowerOfTwo(e.height);
      }
      function c(e) {
        if (e instanceof HTMLImageElement || e instanceof HTMLCanvasElement) {
          var t = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas");
          t.width = Ss.nearestPowerOfTwo(e.width), t.height = Ss.nearestPowerOfTwo(e.height);
          return t.getContext("2d").drawImage(e, 0, 0, t.width, t.height), console.warn("THREE.WebGLRenderer: image is not power of two (" + e.width + "x" + e.height + "). Resized to " + t.width + "x" + t.height, e), t;
        }
        return e;
      }
      function u(e) {
        return e.wrapS !== bo || e.wrapT !== bo || e.minFilter !== wo && e.minFilter !== So;
      }
      function h(t) {
        return t === wo || t === xo || t === _o ? e.NEAREST : e.LINEAR;
      }
      function f(e) {
        var t = e.target;
        t.removeEventListener("dispose", f), p(t), o.textures--;
      }
      function d(e) {
        var t = e.target;
        t.removeEventListener("dispose", d), m(t), o.textures--;
      }
      function p(t) {
        var r = n.get(t);
        if (t.image && r.__image__webglTextureCube) e.deleteTexture(r.__image__webglTextureCube);else {
          if (void 0 === r.__webglInit) return;
          e.deleteTexture(r.__webglTexture);
        }
        n.remove(t);
      }
      function m(t) {
        var r = n.get(t),
          i = n.get(t.texture);
        if (t) {
          if (void 0 !== i.__webglTexture && e.deleteTexture(i.__webglTexture), t.depthTexture && t.depthTexture.dispose(), t.isWebGLRenderTargetCube) for (var a = 0; a < 6; a++) e.deleteFramebuffer(r.__webglFramebuffer[a]), r.__webglDepthbuffer && e.deleteRenderbuffer(r.__webglDepthbuffer[a]);else e.deleteFramebuffer(r.__webglFramebuffer), r.__webglDepthbuffer && e.deleteRenderbuffer(r.__webglDepthbuffer);
          n.remove(t.texture), n.remove(t);
        }
      }
      function g(t, i) {
        var a = n.get(t);
        if (t.version > 0 && a.__version !== t.version) {
          var o = t.image;
          if (void 0 === o) console.warn("THREE.WebGLRenderer: Texture marked for update but image is undefined", t);else {
            if (!1 !== o.complete) return void w(a, t, i);
            console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete", t);
          }
        }
        r.activeTexture(e.TEXTURE0 + i), r.bindTexture(e.TEXTURE_2D, a.__webglTexture);
      }
      function v(t, c) {
        var u = n.get(t);
        if (6 === t.image.length) if (t.version > 0 && u.__version !== t.version) {
          u.__image__webglTextureCube || (t.addEventListener("dispose", f), u.__image__webglTextureCube = e.createTexture(), o.textures++), r.activeTexture(e.TEXTURE0 + c), r.bindTexture(e.TEXTURE_CUBE_MAP, u.__image__webglTextureCube), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, t.flipY);
          for (var h = t && t.isCompressedTexture, d = t.image[0] && t.image[0].isDataTexture, p = [], m = 0; m < 6; m++) p[m] = h || d ? d ? t.image[m].image : t.image[m] : s(t.image[m], i.maxCubemapSize);
          var g = p[0],
            v = l(g),
            b = a(t.format),
            w = a(t.type);
          y(e.TEXTURE_CUBE_MAP, t, v);
          for (var m = 0; m < 6; m++) if (h) for (var x, _ = p[m].mipmaps, S = 0, C = _.length; S < C; S++) x = _[S], t.format !== jo && t.format !== Uo ? r.getCompressedTextureFormats().indexOf(b) > -1 ? r.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + m, S, b, x.width, x.height, 0, x.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : r.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + m, S, b, x.width, x.height, 0, b, w, x.data);else d ? r.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + m, 0, b, p[m].width, p[m].height, 0, b, w, p[m].data) : r.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X + m, 0, b, b, w, p[m]);
          t.generateMipmaps && v && e.generateMipmap(e.TEXTURE_CUBE_MAP), u.__version = t.version, t.onUpdate && t.onUpdate(t);
        } else r.activeTexture(e.TEXTURE0 + c), r.bindTexture(e.TEXTURE_CUBE_MAP, u.__image__webglTextureCube);
      }
      function b(t, i) {
        r.activeTexture(e.TEXTURE0 + i), r.bindTexture(e.TEXTURE_CUBE_MAP, n.get(t).__webglTexture);
      }
      function y(r, o, s) {
        var l;
        if (s ? (e.texParameteri(r, e.TEXTURE_WRAP_S, a(o.wrapS)), e.texParameteri(r, e.TEXTURE_WRAP_T, a(o.wrapT)), e.texParameteri(r, e.TEXTURE_MAG_FILTER, a(o.magFilter)), e.texParameteri(r, e.TEXTURE_MIN_FILTER, a(o.minFilter))) : (e.texParameteri(r, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(r, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), o.wrapS === bo && o.wrapT === bo || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.", o), e.texParameteri(r, e.TEXTURE_MAG_FILTER, h(o.magFilter)), e.texParameteri(r, e.TEXTURE_MIN_FILTER, h(o.minFilter)), o.minFilter !== wo && o.minFilter !== So && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.", o)), l = t.get("EXT_texture_filter_anisotropic")) {
          if (o.type === Oo && null === t.get("OES_texture_float_linear")) return;
          if (o.type === Po && null === t.get("OES_texture_half_float_linear")) return;
          (o.anisotropy > 1 || n.get(o).__currentAnisotropy) && (e.texParameterf(r, l.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(o.anisotropy, i.getMaxAnisotropy())), n.get(o).__currentAnisotropy = o.anisotropy);
        }
      }
      function w(t, n, h) {
        void 0 === t.__webglInit && (t.__webglInit = !0, n.addEventListener("dispose", f), t.__webglTexture = e.createTexture(), o.textures++), r.activeTexture(e.TEXTURE0 + h), r.bindTexture(e.TEXTURE_2D, t.__webglTexture), e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL, n.flipY), e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), e.pixelStorei(e.UNPACK_ALIGNMENT, n.unpackAlignment);
        var d = s(n.image, i.maxTextureSize);
        u(n) && !1 === l(d) && (d = c(d));
        var p = l(d),
          m = a(n.format),
          g = a(n.type);
        y(e.TEXTURE_2D, n, p);
        var v,
          b = n.mipmaps;
        if (n.isDepthTexture) {
          var w = e.DEPTH_COMPONENT;
          if (n.type === Oo) {
            if (!T) throw new Error("Float Depth Texture only supported in WebGL2.0");
            w = e.DEPTH_COMPONENT32F;
          } else T && (w = e.DEPTH_COMPONENT16);
          n.format === Vo && w === e.DEPTH_COMPONENT && n.type !== Ro && n.type !== Mo && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), n.type = Ro, g = a(n.type)), n.format === qo && (w = e.DEPTH_STENCIL, n.type !== Fo && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), n.type = Fo, g = a(n.type))), r.texImage2D(e.TEXTURE_2D, 0, w, d.width, d.height, 0, m, g, null);
        } else if (n.isDataTexture) {
          if (b.length > 0 && p) {
            for (var x = 0, _ = b.length; x < _; x++) v = b[x], r.texImage2D(e.TEXTURE_2D, x, m, v.width, v.height, 0, m, g, v.data);
            n.generateMipmaps = !1;
          } else r.texImage2D(e.TEXTURE_2D, 0, m, d.width, d.height, 0, m, g, d.data);
        } else if (n.isCompressedTexture) for (var x = 0, _ = b.length; x < _; x++) v = b[x], n.format !== jo && n.format !== Uo ? r.getCompressedTextureFormats().indexOf(m) > -1 ? r.compressedTexImage2D(e.TEXTURE_2D, x, m, v.width, v.height, 0, v.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : r.texImage2D(e.TEXTURE_2D, x, m, v.width, v.height, 0, m, g, v.data);else if (b.length > 0 && p) {
          for (var x = 0, _ = b.length; x < _; x++) v = b[x], r.texImage2D(e.TEXTURE_2D, x, m, m, g, v);
          n.generateMipmaps = !1;
        } else r.texImage2D(e.TEXTURE_2D, 0, m, m, g, d);
        n.generateMipmaps && p && e.generateMipmap(e.TEXTURE_2D), t.__version = n.version, n.onUpdate && n.onUpdate(n);
      }
      function x(t, i, o, s) {
        var l = a(i.texture.format),
          c = a(i.texture.type);
        r.texImage2D(s, 0, l, i.width, i.height, 0, l, c, null), e.bindFramebuffer(e.FRAMEBUFFER, t), e.framebufferTexture2D(e.FRAMEBUFFER, o, s, n.get(i.texture).__webglTexture, 0), e.bindFramebuffer(e.FRAMEBUFFER, null);
      }
      function _(t, r) {
        e.bindRenderbuffer(e.RENDERBUFFER, t), r.depthBuffer && !r.stencilBuffer ? (e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_COMPONENT16, r.width, r.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.RENDERBUFFER, t)) : r.depthBuffer && r.stencilBuffer ? (e.renderbufferStorage(e.RENDERBUFFER, e.DEPTH_STENCIL, r.width, r.height), e.framebufferRenderbuffer(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.RENDERBUFFER, t)) : e.renderbufferStorage(e.RENDERBUFFER, e.RGBA4, r.width, r.height), e.bindRenderbuffer(e.RENDERBUFFER, null);
      }
      function S(t, r) {
        if (r && r.isWebGLRenderTargetCube) throw new Error("Depth Texture with cube render targets is not supported!");
        if (e.bindFramebuffer(e.FRAMEBUFFER, t), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        n.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), g(r.depthTexture, 0);
        var i = n.get(r.depthTexture).__webglTexture;
        if (r.depthTexture.format === Vo) e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_ATTACHMENT, e.TEXTURE_2D, i, 0);else {
          if (r.depthTexture.format !== qo) throw new Error("Unknown depthTexture format");
          e.framebufferTexture2D(e.FRAMEBUFFER, e.DEPTH_STENCIL_ATTACHMENT, e.TEXTURE_2D, i, 0);
        }
      }
      function C(t) {
        var r = n.get(t),
          i = !0 === t.isWebGLRenderTargetCube;
        if (t.depthTexture) {
          if (i) throw new Error("target.depthTexture not supported in Cube render targets");
          S(r.__webglFramebuffer, t);
        } else if (i) {
          r.__webglDepthbuffer = [];
          for (var a = 0; a < 6; a++) e.bindFramebuffer(e.FRAMEBUFFER, r.__webglFramebuffer[a]), r.__webglDepthbuffer[a] = e.createRenderbuffer(), _(r.__webglDepthbuffer[a], t);
        } else e.bindFramebuffer(e.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = e.createRenderbuffer(), _(r.__webglDepthbuffer, t);
        e.bindFramebuffer(e.FRAMEBUFFER, null);
      }
      function E(t) {
        var i = n.get(t),
          a = n.get(t.texture);
        t.addEventListener("dispose", d), a.__webglTexture = e.createTexture(), o.textures++;
        var s = !0 === t.isWebGLRenderTargetCube,
          c = l(t);
        if (s) {
          i.__webglFramebuffer = [];
          for (var u = 0; u < 6; u++) i.__webglFramebuffer[u] = e.createFramebuffer();
        } else i.__webglFramebuffer = e.createFramebuffer();
        if (s) {
          r.bindTexture(e.TEXTURE_CUBE_MAP, a.__webglTexture), y(e.TEXTURE_CUBE_MAP, t.texture, c);
          for (var u = 0; u < 6; u++) x(i.__webglFramebuffer[u], t, e.COLOR_ATTACHMENT0, e.TEXTURE_CUBE_MAP_POSITIVE_X + u);
          t.texture.generateMipmaps && c && e.generateMipmap(e.TEXTURE_CUBE_MAP), r.bindTexture(e.TEXTURE_CUBE_MAP, null);
        } else r.bindTexture(e.TEXTURE_2D, a.__webglTexture), y(e.TEXTURE_2D, t.texture, c), x(i.__webglFramebuffer, t, e.COLOR_ATTACHMENT0, e.TEXTURE_2D), t.texture.generateMipmaps && c && e.generateMipmap(e.TEXTURE_2D), r.bindTexture(e.TEXTURE_2D, null);
        t.depthBuffer && C(t);
      }
      function A(t) {
        var i = t.texture;
        if (i.generateMipmaps && l(t) && i.minFilter !== wo && i.minFilter !== So) {
          var a = t && t.isWebGLRenderTargetCube ? e.TEXTURE_CUBE_MAP : e.TEXTURE_2D,
            o = n.get(i).__webglTexture;
          r.bindTexture(a, o), e.generateMipmap(a), r.bindTexture(a, null);
        }
      }
      var T = "undefined" != typeof WebGL2RenderingContext && e instanceof WebGL2RenderingContext;
      this.setTexture2D = g, this.setTextureCube = v, this.setTextureCubeDynamic = b, this.setupRenderTarget = E, this.updateRenderTargetMipmap = A;
    }
    function ut() {
      function e(e) {
        var t = e.uuid,
          r = n[t];
        return void 0 === r && (r = {}, n[t] = r), r;
      }
      function t(e) {
        delete n[e.uuid];
      }
      function r() {
        n = {};
      }
      var n = {};
      return {
        get: e,
        remove: t,
        clear: r
      };
    }
    function ht(e, t, r) {
      function n() {
        var t = !1,
          r = new o(),
          n = null,
          i = new o();
        return {
          setMask: function setMask(r) {
            n === r || t || (e.colorMask(r, r, r, r), n = r);
          },
          setLocked: function setLocked(e) {
            t = e;
          },
          setClear: function setClear(t, n, a, o, s) {
            !0 === s && (t *= o, n *= o, a *= o), r.set(t, n, a, o), !1 === i.equals(r) && (e.clearColor(t, n, a, o), i.copy(r));
          },
          reset: function reset() {
            t = !1, n = null, i.set(0, 0, 0, 1);
          }
        };
      }
      function i() {
        var t = !1,
          r = null,
          n = null,
          i = null;
        return {
          setTest: function setTest(t) {
            t ? d(e.DEPTH_TEST) : p(e.DEPTH_TEST);
          },
          setMask: function setMask(n) {
            r === n || t || (e.depthMask(n), r = n);
          },
          setFunc: function setFunc(t) {
            if (n !== t) {
              if (t) switch (t) {
                case Wa:
                  e.depthFunc(e.NEVER);
                  break;
                case Xa:
                  e.depthFunc(e.ALWAYS);
                  break;
                case Ya:
                  e.depthFunc(e.LESS);
                  break;
                case Ka:
                  e.depthFunc(e.LEQUAL);
                  break;
                case Za:
                  e.depthFunc(e.EQUAL);
                  break;
                case Ja:
                  e.depthFunc(e.GEQUAL);
                  break;
                case Qa:
                  e.depthFunc(e.GREATER);
                  break;
                case $a:
                  e.depthFunc(e.NOTEQUAL);
                  break;
                default:
                  e.depthFunc(e.LEQUAL);
              } else e.depthFunc(e.LEQUAL);
              n = t;
            }
          },
          setLocked: function setLocked(e) {
            t = e;
          },
          setClear: function setClear(t) {
            i !== t && (e.clearDepth(t), i = t);
          },
          reset: function reset() {
            t = !1, r = null, n = null, i = null;
          }
        };
      }
      function a() {
        var t = !1,
          r = null,
          n = null,
          i = null,
          a = null,
          o = null,
          s = null,
          l = null,
          c = null;
        return {
          setTest: function setTest(t) {
            t ? d(e.STENCIL_TEST) : p(e.STENCIL_TEST);
          },
          setMask: function setMask(n) {
            r === n || t || (e.stencilMask(n), r = n);
          },
          setFunc: function setFunc(t, r, o) {
            n === t && i === r && a === o || (e.stencilFunc(t, r, o), n = t, i = r, a = o);
          },
          setOp: function setOp(t, r, n) {
            o === t && s === r && l === n || (e.stencilOp(t, r, n), o = t, s = r, l = n);
          },
          setLocked: function setLocked(e) {
            t = e;
          },
          setClear: function setClear(t) {
            c !== t && (e.clearStencil(t), c = t);
          },
          reset: function reset() {
            t = !1, r = null, n = null, i = null, a = null, o = null, s = null, l = null, c = null;
          }
        };
      }
      function s(t, r, n) {
        var i = new Uint8Array(4),
          a = e.createTexture();
        e.bindTexture(t, a), e.texParameteri(t, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(t, e.TEXTURE_MAG_FILTER, e.NEAREST);
        for (var o = 0; o < n; o++) e.texImage2D(r + o, 0, e.RGBA, 1, 1, 0, e.RGBA, e.UNSIGNED_BYTE, i);
        return a;
      }
      function l() {
        M.setClear(0, 0, 0, 1), O.setClear(1), P.setClear(0), d(e.DEPTH_TEST), O.setFunc(Ka), b(!1), y(la), d(e.CULL_FACE), d(e.BLEND), g(Ea);
      }
      function c() {
        for (var e = 0, t = D.length; e < t; e++) D[e] = 0;
      }
      function u(r) {
        if (D[r] = 1, 0 === L[r] && (e.enableVertexAttribArray(r), L[r] = 1), 0 !== F[r]) {
          t.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(r, 0), F[r] = 0;
        }
      }
      function h(r, n) {
        if (D[r] = 1, 0 === L[r] && (e.enableVertexAttribArray(r), L[r] = 1), F[r] !== n) {
          t.get("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(r, n), F[r] = n;
        }
      }
      function f() {
        for (var t = 0, r = L.length; t !== r; ++t) L[t] !== D[t] && (e.disableVertexAttribArray(t), L[t] = 0);
      }
      function d(t) {
        !0 !== N[t] && (e.enable(t), N[t] = !0);
      }
      function p(t) {
        !1 !== N[t] && (e.disable(t), N[t] = !1);
      }
      function m() {
        if (null === U && (U = [], t.get("WEBGL_compressed_texture_pvrtc") || t.get("WEBGL_compressed_texture_s3tc") || t.get("WEBGL_compressed_texture_etc1"))) for (var r = e.getParameter(e.COMPRESSED_TEXTURE_FORMATS), n = 0; n < r.length; n++) U.push(r[n]);
        return U;
      }
      function g(t, n, i, a, o, s, l, c) {
        t !== Ca ? d(e.BLEND) : p(e.BLEND), t === j && c === X || (t === Aa ? c ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ONE, e.ONE, e.ONE, e.ONE)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.SRC_ALPHA, e.ONE)) : t === Ta ? c ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ZERO, e.ZERO, e.ONE_MINUS_SRC_COLOR, e.ONE_MINUS_SRC_ALPHA)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ZERO, e.ONE_MINUS_SRC_COLOR)) : t === ka ? c ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ZERO, e.SRC_COLOR, e.ZERO, e.SRC_ALPHA)) : (e.blendEquation(e.FUNC_ADD), e.blendFunc(e.ZERO, e.SRC_COLOR)) : c ? (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.ONE, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA)) : (e.blendEquationSeparate(e.FUNC_ADD, e.FUNC_ADD), e.blendFuncSeparate(e.SRC_ALPHA, e.ONE_MINUS_SRC_ALPHA, e.ONE, e.ONE_MINUS_SRC_ALPHA)), j = t, X = c), t === Ra ? (o = o || n, s = s || i, l = l || a, n === z && o === V || (e.blendEquationSeparate(r(n), r(o)), z = n, V = o), i === H && a === G && s === q && l === W || (e.blendFuncSeparate(r(i), r(a), r(s), r(l)), H = i, G = a, q = s, W = l)) : (z = null, H = null, G = null, V = null, q = null, W = null);
      }
      function v(t) {
        t.side === ba ? p(e.CULL_FACE) : d(e.CULL_FACE), b(t.side === va), !0 === t.transparent ? g(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.premultipliedAlpha) : g(Ca), O.setFunc(t.depthFunc), O.setTest(t.depthTest), O.setMask(t.depthWrite), M.setMask(t.colorWrite), x(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits);
      }
      function b(t) {
        Y !== t && (t ? e.frontFace(e.CW) : e.frontFace(e.CCW), Y = t);
      }
      function y(t) {
        t !== sa ? (d(e.CULL_FACE), t !== K && (t === la ? e.cullFace(e.BACK) : t === ca ? e.cullFace(e.FRONT) : e.cullFace(e.FRONT_AND_BACK))) : p(e.CULL_FACE), K = t;
      }
      function w(t) {
        t !== Z && (re && e.lineWidth(t), Z = t);
      }
      function x(t, r, n) {
        t ? (d(e.POLYGON_OFFSET_FILL), J === r && Q === n || (e.polygonOffset(r, n), J = r, Q = n)) : p(e.POLYGON_OFFSET_FILL);
      }
      function _() {
        return $;
      }
      function S(t) {
        $ = t, t ? d(e.SCISSOR_TEST) : p(e.SCISSOR_TEST);
      }
      function C(t) {
        void 0 === t && (t = e.TEXTURE0 + ee - 1), ne !== t && (e.activeTexture(t), ne = t);
      }
      function E(t, r) {
        null === ne && C();
        var n = ie[ne];
        void 0 === n && (n = {
          type: void 0,
          texture: void 0
        }, ie[ne] = n), n.type === t && n.texture === r || (e.bindTexture(t, r || se[t]), n.type = t, n.texture = r);
      }
      function A() {
        try {
          e.compressedTexImage2D.apply(e, arguments);
        } catch (e) {
          console.error(e);
        }
      }
      function T() {
        try {
          e.texImage2D.apply(e, arguments);
        } catch (e) {
          console.error(e);
        }
      }
      function k(t) {
        !1 === ae.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), ae.copy(t));
      }
      function R(t) {
        !1 === oe.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), oe.copy(t));
      }
      function I() {
        for (var t = 0; t < L.length; t++) 1 === L[t] && (e.disableVertexAttribArray(t), L[t] = 0);
        N = {}, U = null, ne = null, ie = {}, j = null, Y = null, K = null, M.reset(), O.reset(), P.reset();
      }
      var M = new n(),
        O = new i(),
        P = new a(),
        B = e.getParameter(e.MAX_VERTEX_ATTRIBS),
        D = new Uint8Array(B),
        L = new Uint8Array(B),
        F = new Uint8Array(B),
        N = {},
        U = null,
        j = null,
        z = null,
        H = null,
        G = null,
        V = null,
        q = null,
        W = null,
        X = !1,
        Y = null,
        K = null,
        Z = null,
        J = null,
        Q = null,
        $ = null,
        ee = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
        te = parseFloat(/^WebGL\ ([0-9])/.exec(e.getParameter(e.VERSION))[1]),
        re = parseFloat(te) >= 1,
        ne = null,
        ie = {},
        ae = new o(),
        oe = new o(),
        se = {};
      return se[e.TEXTURE_2D] = s(e.TEXTURE_2D, e.TEXTURE_2D, 1), se[e.TEXTURE_CUBE_MAP] = s(e.TEXTURE_CUBE_MAP, e.TEXTURE_CUBE_MAP_POSITIVE_X, 6), {
        buffers: {
          color: M,
          depth: O,
          stencil: P
        },
        init: l,
        initAttributes: c,
        enableAttribute: u,
        enableAttributeAndDivisor: h,
        disableUnusedAttributes: f,
        enable: d,
        disable: p,
        getCompressedTextureFormats: m,
        setBlending: g,
        setMaterial: v,
        setFlipSided: b,
        setCullFace: y,
        setLineWidth: w,
        setPolygonOffset: x,
        getScissorTest: _,
        setScissorTest: S,
        activeTexture: C,
        bindTexture: E,
        compressedTexImage2D: A,
        texImage2D: T,
        scissor: k,
        viewport: R,
        reset: I
      };
    }
    function ft(e, t, r) {
      function n() {
        if (void 0 !== a) return a;
        var r = t.get("EXT_texture_filter_anisotropic");
        return a = null !== r ? e.getParameter(r.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
      }
      function i(t) {
        if ("highp" === t) {
          if (e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.HIGH_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.HIGH_FLOAT).precision > 0) return "highp";
          t = "mediump";
        }
        return "mediump" === t && e.getShaderPrecisionFormat(e.VERTEX_SHADER, e.MEDIUM_FLOAT).precision > 0 && e.getShaderPrecisionFormat(e.FRAGMENT_SHADER, e.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
      }
      var a,
        o = void 0 !== r.precision ? r.precision : "highp",
        s = i(o);
      s !== o && (console.warn("THREE.WebGLRenderer:", o, "not supported, using", s, "instead."), o = s);
      var l = !0 === r.logarithmicDepthBuffer && !!t.get("EXT_frag_depth"),
        c = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),
        u = e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        h = e.getParameter(e.MAX_TEXTURE_SIZE),
        f = e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),
        d = e.getParameter(e.MAX_VERTEX_ATTRIBS),
        p = e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),
        m = e.getParameter(e.MAX_VARYING_VECTORS),
        g = e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),
        v = u > 0,
        b = !!t.get("OES_texture_float");
      return {
        getMaxAnisotropy: n,
        getMaxPrecision: i,
        precision: o,
        logarithmicDepthBuffer: l,
        maxTextures: c,
        maxVertexTextures: u,
        maxTextureSize: h,
        maxCubemapSize: f,
        maxAttributes: d,
        maxVertexUniforms: p,
        maxVaryings: m,
        maxFragmentUniforms: g,
        vertexTextures: v,
        floatFragmentTextures: b,
        floatVertexTextures: v && b
      };
    }
    function dt(e) {
      var t = {};
      return {
        get: function get(r) {
          if (void 0 !== t[r]) return t[r];
          var n;
          switch (r) {
            case "WEBGL_depth_texture":
              n = e.getExtension("WEBGL_depth_texture") || e.getExtension("MOZ_WEBGL_depth_texture") || e.getExtension("WEBKIT_WEBGL_depth_texture");
              break;
            case "EXT_texture_filter_anisotropic":
              n = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
              break;
            case "WEBGL_compressed_texture_s3tc":
              n = e.getExtension("WEBGL_compressed_texture_s3tc") || e.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
              break;
            case "WEBGL_compressed_texture_pvrtc":
              n = e.getExtension("WEBGL_compressed_texture_pvrtc") || e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
              break;
            case "WEBGL_compressed_texture_etc1":
              n = e.getExtension("WEBGL_compressed_texture_etc1");
              break;
            default:
              n = e.getExtension(r);
          }
          return null === n && console.warn("THREE.WebGLRenderer: " + r + " extension not supported."), t[r] = n, n;
        }
      };
    }
    function pt() {
      function e() {
        c.value !== n && (c.value = n, c.needsUpdate = i > 0), r.numPlanes = i, r.numIntersection = 0;
      }
      function t(e, t, n, i) {
        var a = null !== e ? e.length : 0,
          o = null;
        if (0 !== a) {
          if (o = c.value, !0 !== i || null === o) {
            var u = n + 4 * a,
              h = t.matrixWorldInverse;
            l.getNormalMatrix(h), (null === o || o.length < u) && (o = new Float32Array(u));
            for (var f = 0, d = n; f !== a; ++f, d += 4) s.copy(e[f]).applyMatrix4(h, l), s.normal.toArray(o, d), o[d + 3] = s.constant;
          }
          c.value = o, c.needsUpdate = !0;
        }
        return r.numPlanes = a, o;
      }
      var r = this,
        n = null,
        i = 0,
        a = !1,
        o = !1,
        s = new ie(),
        l = new ne(),
        c = {
          value: null,
          needsUpdate: !1
        };
      this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function (e, r, o) {
        var s = 0 !== e.length || r || 0 !== i || a;
        return a = r, n = t(e, o, 0), i = e.length, s;
      }, this.beginShadows = function () {
        o = !0, t(null);
      }, this.endShadows = function () {
        o = !1, e();
      }, this.setState = function (r, s, l, u, h, f) {
        if (!a || null === r || 0 === r.length || o && !l) o ? t(null) : e();else {
          var d = o ? 0 : i,
            p = 4 * d,
            m = h.clippingState || null;
          c.value = m, m = t(r, u, p, f);
          for (var g = 0; g !== p; ++g) m[g] = n[g];
          h.clippingState = m, this.numIntersection = s ? this.numPlanes : 0, this.numPlanes += d;
        }
      };
    }
    function mt(e) {
      function t() {
        return null === re ? be : 1;
      }
      function r() {
        Ze.init(), Ze.scissor(ce.copy(ye).multiplyScalar(be)), Ze.viewport(he.copy(xe).multiplyScalar(be)), Ze.buffers.color.setClear(de.r, de.g, de.b, me, H);
      }
      function n() {
        te = null, le = null, se = "", ie = -1, Ze.reset();
      }
      function i(e) {
        e.preventDefault(), n(), r(), Je.clear(), tt.clear();
      }
      function a(e) {
        var t = e.target;
        t.removeEventListener("dispose", a), s(t);
      }
      function s(e) {
        l(e), Je.remove(e);
      }
      function l(e) {
        var t = Je.get(e).program;
        e.program = void 0, void 0 !== t && rt.releaseProgram(t);
      }
      function c(e, t, r) {
        e.render(function (e) {
          ee.renderBufferImmediate(e, t, r);
        });
      }
      function d(e, t) {
        return Math.abs(t[0]) - Math.abs(e[0]);
      }
      function p(e, t, r, n) {
        if (r && r.isInstancedBufferGeometry && null === Ye.get("ANGLE_instanced_arrays")) return void console.error("THREE.WebGLRenderer.setupVertexAttributes: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        void 0 === n && (n = 0), Ze.initAttributes();
        var i = r.attributes,
          a = t.getAttributes(),
          o = e.defaultAttributeValues;
        for (var s in a) {
          var l = a[s];
          if (l >= 0) {
            var c = i[s];
            if (void 0 !== c) {
              var u = c.normalized,
                h = c.itemSize,
                f = $e.get(c),
                d = f.buffer,
                p = f.type,
                m = f.bytesPerElement;
              if (c.isInterleavedBufferAttribute) {
                var g = c.data,
                  v = g.stride,
                  b = c.offset;
                g && g.isInstancedInterleavedBuffer ? (Ze.enableAttributeAndDivisor(l, g.meshPerAttribute), void 0 === r.maxInstancedCount && (r.maxInstancedCount = g.meshPerAttribute * g.count)) : Ze.enableAttribute(l), je.bindBuffer(je.ARRAY_BUFFER, d), je.vertexAttribPointer(l, h, p, u, v * m, (n * v + b) * m);
              } else c.isInstancedBufferAttribute ? (Ze.enableAttributeAndDivisor(l, c.meshPerAttribute), void 0 === r.maxInstancedCount && (r.maxInstancedCount = c.meshPerAttribute * c.count)) : Ze.enableAttribute(l), je.bindBuffer(je.ARRAY_BUFFER, d), je.vertexAttribPointer(l, h, p, u, 0, n * h * m);
            } else if (void 0 !== o) {
              var y = o[s];
              if (void 0 !== y) switch (y.length) {
                case 2:
                  je.vertexAttrib2fv(l, y);
                  break;
                case 3:
                  je.vertexAttrib3fv(l, y);
                  break;
                case 4:
                  je.vertexAttrib4fv(l, y);
                  break;
                default:
                  je.vertexAttrib1fv(l, y);
              }
            }
          }
        }
        Ze.disableUnusedAttributes();
      }
      function m(e, t, r) {
        if (e.visible) {
          if (e.layers.test(t.layers)) if (e.isLight) V.push(e);else if (e.isSprite) e.frustumCulled && !_e.intersectsSprite(e) || K.push(e);else if (e.isLensFlare) Q.push(e);else if (e.isImmediateRenderObject) r && Te.setFromMatrixPosition(e.matrixWorld).applyMatrix4(Ae), q.push(e, null, e.material, Te.z, null);else if ((e.isMesh || e.isLine || e.isPoints) && (e.isSkinnedMesh && e.skeleton.update(), !e.frustumCulled || _e.intersectsObject(e))) {
            r && Te.setFromMatrixPosition(e.matrixWorld).applyMatrix4(Ae);
            var n = tt.update(e),
              i = e.material;
            if (Array.isArray(i)) for (var a = n.groups, o = 0, s = a.length; o < s; o++) {
              var l = a[o],
                c = i[l.materialIndex];
              c && c.visible && q.push(e, n, c, Te.z, l);
            } else i.visible && q.push(e, n, i, Te.z, null);
          }
          for (var u = e.children, o = 0, s = u.length; o < s; o++) m(u[o], t, r);
        }
      }
      function g(e, t, r, n) {
        for (var i = 0, a = e.length; i < a; i++) {
          var o = e[i],
            s = o.object,
            l = o.geometry,
            c = void 0 === n ? o.material : n,
            u = o.group;
          if (s.onBeforeRender(ee, t, r, l, c, u), r.isArrayCamera && r.enabled) for (var h = r.cameras, f = 0, d = h.length; f < d; f++) {
            var p = h[f],
              m = p.bounds;
            ee.setViewport(m.x * ge * be, m.y * ve * be, m.z * ge * be, m.w * ve * be), ee.setScissor(m.x * ge * be, m.y * ve * be, m.z * ge * be, m.w * ve * be), ee.setScissorTest(!0), v(s, t, p, l, c, u);
          } else v(s, t, r, l, c, u);
          s.onAfterRender(ee, t, r, l, c, u);
        }
      }
      function v(e, t, r, n, i, a) {
        if (e.modelViewMatrix.multiplyMatrices(r.matrixWorldInverse, e.matrixWorld), e.normalMatrix.getNormalMatrix(e.modelViewMatrix), e.isImmediateRenderObject) {
          Ze.setMaterial(i);
          var o = y(r, t.fog, i, e);
          se = "", c(e, o, i);
        } else ee.renderBufferDirect(r, t.fog, n, i, e, a);
      }
      function b(e, t, r) {
        var n = Je.get(e),
          i = rt.getParameters(e, Pe, t, Se.numPlanes, Se.numIntersection, r),
          o = rt.getProgramCode(e, i),
          s = n.program,
          c = !0;
        if (void 0 === s) e.addEventListener("dispose", a);else if (s.code !== o) l(e);else {
          if (void 0 !== i.shaderID) return;
          c = !1;
        }
        if (c) {
          if (i.shaderID) {
            var u = Ls[i.shaderID];
            n.__webglShader = {
              name: e.type,
              uniforms: Bs.clone(u.uniforms),
              vertexShader: u.vertexShader,
              fragmentShader: u.fragmentShader
            };
          } else n.__webglShader = {
            name: e.type,
            uniforms: e.uniforms,
            vertexShader: e.vertexShader,
            fragmentShader: e.fragmentShader
          };
          e.__webglShader = n.__webglShader, s = rt.acquireProgram(e, i, o), n.program = s, e.program = s;
        }
        var h = s.getAttributes();
        if (e.morphTargets) {
          e.numSupportedMorphTargets = 0;
          for (var f = 0; f < ee.maxMorphTargets; f++) h["morphTarget" + f] >= 0 && e.numSupportedMorphTargets++;
        }
        if (e.morphNormals) {
          e.numSupportedMorphNormals = 0;
          for (var f = 0; f < ee.maxMorphNormals; f++) h["morphNormal" + f] >= 0 && e.numSupportedMorphNormals++;
        }
        var d = n.__webglShader.uniforms;
        (e.isShaderMaterial || e.isRawShaderMaterial) && !0 !== e.clipping || (n.numClippingPlanes = Se.numPlanes, n.numIntersection = Se.numIntersection, d.clippingPlanes = Se.uniform), n.fog = t, n.lightsHash = Pe.hash, e.lights && (d.ambientLightColor.value = Pe.ambient, d.directionalLights.value = Pe.directional, d.spotLights.value = Pe.spot, d.rectAreaLights.value = Pe.rectArea, d.pointLights.value = Pe.point, d.hemisphereLights.value = Pe.hemi, d.directionalShadowMap.value = Pe.directionalShadowMap, d.directionalShadowMatrix.value = Pe.directionalShadowMatrix, d.spotShadowMap.value = Pe.spotShadowMap, d.spotShadowMatrix.value = Pe.spotShadowMatrix, d.pointShadowMap.value = Pe.pointShadowMap, d.pointShadowMatrix.value = Pe.pointShadowMatrix);
        var p = n.program.getUniforms(),
          m = X.seqWithValue(p.seq, d);
        n.uniformsList = m;
      }
      function y(e, t, r, n) {
        fe = 0;
        var i = Je.get(r);
        if (Ce && (Ee || e !== le)) {
          var a = e === le && r.id === ie;
          Se.setState(r.clippingPlanes, r.clipIntersection, r.clipShadows, e, i, a);
        }
        !1 === r.needsUpdate && (void 0 === i.program ? r.needsUpdate = !0 : r.fog && i.fog !== t ? r.needsUpdate = !0 : r.lights && i.lightsHash !== Pe.hash ? r.needsUpdate = !0 : void 0 === i.numClippingPlanes || i.numClippingPlanes === Se.numPlanes && i.numIntersection === Se.numIntersection || (r.needsUpdate = !0)), r.needsUpdate && (b(r, t, n), r.needsUpdate = !1);
        var o = !1,
          s = !1,
          l = !1,
          c = i.program,
          u = c.getUniforms(),
          h = i.__webglShader.uniforms;
        if (c.id !== te && (je.useProgram(c.program), te = c.id, o = !0, s = !0, l = !0), r.id !== ie && (ie = r.id, s = !0), o || e !== le) {
          if (u.setValue(je, "projectionMatrix", e.projectionMatrix), Ke.logarithmicDepthBuffer && u.setValue(je, "logDepthBufFC", 2 / (Math.log(e.far + 1) / Math.LN2)), e !== le && (le = e, s = !0, l = !0), r.isShaderMaterial || r.isMeshPhongMaterial || r.isMeshStandardMaterial || r.envMap) {
            var d = u.map.cameraPosition;
            void 0 !== d && d.setValue(je, Te.setFromMatrixPosition(e.matrixWorld));
          }
          (r.isMeshPhongMaterial || r.isMeshLambertMaterial || r.isMeshBasicMaterial || r.isMeshStandardMaterial || r.isShaderMaterial || r.skinning) && u.setValue(je, "viewMatrix", e.matrixWorldInverse), u.setValue(je, "toneMappingExposure", ee.toneMappingExposure), u.setValue(je, "toneMappingWhitePoint", ee.toneMappingWhitePoint);
        }
        if (r.skinning) {
          u.setOptional(je, n, "bindMatrix"), u.setOptional(je, n, "bindMatrixInverse");
          var p = n.skeleton;
          if (p) {
            var m = p.bones;
            if (Ke.floatVertexTextures) {
              if (void 0 === p.boneTexture) {
                var g = Math.sqrt(4 * m.length);
                g = Ss.nextPowerOfTwo(Math.ceil(g)), g = Math.max(g, 4);
                var v = new Float32Array(g * g * 4);
                v.set(p.boneMatrices);
                var y = new f(v, g, g, jo, Oo);
                p.boneMatrices = v, p.boneTexture = y, p.boneTextureSize = g;
              }
              u.setValue(je, "boneTexture", p.boneTexture), u.setValue(je, "boneTextureSize", p.boneTextureSize);
            } else u.setOptional(je, p, "boneMatrices");
          }
        }
        return s && (r.lights && M(h, l), t && r.fog && C(h, t), (r.isMeshBasicMaterial || r.isMeshLambertMaterial || r.isMeshPhongMaterial || r.isMeshStandardMaterial || r.isMeshNormalMaterial || r.isMeshDepthMaterial) && w(h, r), r.isLineBasicMaterial ? x(h, r) : r.isLineDashedMaterial ? (x(h, r), _(h, r)) : r.isPointsMaterial ? S(h, r) : r.isMeshLambertMaterial ? E(h, r) : r.isMeshToonMaterial ? T(h, r) : r.isMeshPhongMaterial ? A(h, r) : r.isMeshPhysicalMaterial ? R(h, r) : r.isMeshStandardMaterial ? k(h, r) : r.isMeshDepthMaterial ? r.displacementMap && (h.displacementMap.value = r.displacementMap, h.displacementScale.value = r.displacementScale, h.displacementBias.value = r.displacementBias) : r.isMeshNormalMaterial && I(h, r), void 0 !== h.ltcMat && (h.ltcMat.value = Ps.LTC_MAT_TEXTURE), void 0 !== h.ltcMag && (h.ltcMag.value = Ps.LTC_MAG_TEXTURE), X.upload(je, i.uniformsList, h, ee)), u.setValue(je, "modelViewMatrix", n.modelViewMatrix), u.setValue(je, "normalMatrix", n.normalMatrix), u.setValue(je, "modelMatrix", n.matrixWorld), c;
      }
      function w(e, t) {
        e.opacity.value = t.opacity, e.diffuse.value = t.color, t.emissive && e.emissive.value.copy(t.emissive).multiplyScalar(t.emissiveIntensity), e.map.value = t.map, e.specularMap.value = t.specularMap, e.alphaMap.value = t.alphaMap, t.lightMap && (e.lightMap.value = t.lightMap, e.lightMapIntensity.value = t.lightMapIntensity), t.aoMap && (e.aoMap.value = t.aoMap, e.aoMapIntensity.value = t.aoMapIntensity);
        var r;
        if (t.map ? r = t.map : t.specularMap ? r = t.specularMap : t.displacementMap ? r = t.displacementMap : t.normalMap ? r = t.normalMap : t.bumpMap ? r = t.bumpMap : t.roughnessMap ? r = t.roughnessMap : t.metalnessMap ? r = t.metalnessMap : t.alphaMap ? r = t.alphaMap : t.emissiveMap && (r = t.emissiveMap), void 0 !== r) {
          r.isWebGLRenderTarget && (r = r.texture);
          var n = r.offset,
            i = r.repeat;
          e.offsetRepeat.value.set(n.x, n.y, i.x, i.y);
        }
        e.envMap.value = t.envMap, e.flipEnvMap.value = t.envMap && t.envMap.isCubeTexture ? -1 : 1, e.reflectivity.value = t.reflectivity, e.refractionRatio.value = t.refractionRatio;
      }
      function x(e, t) {
        e.diffuse.value = t.color, e.opacity.value = t.opacity;
      }
      function _(e, t) {
        e.dashSize.value = t.dashSize, e.totalSize.value = t.dashSize + t.gapSize, e.scale.value = t.scale;
      }
      function S(e, t) {
        if (e.diffuse.value = t.color, e.opacity.value = t.opacity, e.size.value = t.size * be, e.scale.value = .5 * ve, e.map.value = t.map, null !== t.map) {
          var r = t.map.offset,
            n = t.map.repeat;
          e.offsetRepeat.value.set(r.x, r.y, n.x, n.y);
        }
      }
      function C(e, t) {
        e.fogColor.value = t.color, t.isFog ? (e.fogNear.value = t.near, e.fogFar.value = t.far) : t.isFogExp2 && (e.fogDensity.value = t.density);
      }
      function E(e, t) {
        t.emissiveMap && (e.emissiveMap.value = t.emissiveMap);
      }
      function A(e, t) {
        e.specular.value = t.specular, e.shininess.value = Math.max(t.shininess, 1e-4), t.emissiveMap && (e.emissiveMap.value = t.emissiveMap), t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale)), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias);
      }
      function T(e, t) {
        A(e, t), t.gradientMap && (e.gradientMap.value = t.gradientMap);
      }
      function k(e, t) {
        e.roughness.value = t.roughness, e.metalness.value = t.metalness, t.roughnessMap && (e.roughnessMap.value = t.roughnessMap), t.metalnessMap && (e.metalnessMap.value = t.metalnessMap), t.emissiveMap && (e.emissiveMap.value = t.emissiveMap), t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale)), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias), t.envMap && (e.envMapIntensity.value = t.envMapIntensity);
      }
      function R(e, t) {
        e.clearCoat.value = t.clearCoat, e.clearCoatRoughness.value = t.clearCoatRoughness, k(e, t);
      }
      function I(e, t) {
        t.bumpMap && (e.bumpMap.value = t.bumpMap, e.bumpScale.value = t.bumpScale), t.normalMap && (e.normalMap.value = t.normalMap, e.normalScale.value.copy(t.normalScale)), t.displacementMap && (e.displacementMap.value = t.displacementMap, e.displacementScale.value = t.displacementScale, e.displacementBias.value = t.displacementBias);
      }
      function M(e, t) {
        e.ambientLightColor.needsUpdate = t, e.directionalLights.needsUpdate = t, e.pointLights.needsUpdate = t, e.spotLights.needsUpdate = t, e.rectAreaLights.needsUpdate = t, e.hemisphereLights.needsUpdate = t;
      }
      function O(e) {
        for (var t = 0, r = 0, n = e.length; r < n; r++) {
          var i = e[r];
          i.castShadow && (Pe.shadows[t] = i, t++);
        }
        Pe.shadows.length = t;
      }
      function P(e, t) {
        var r,
          n,
          i,
          a,
          o,
          s,
          l,
          c,
          u = 0,
          h = 0,
          f = 0,
          d = t.matrixWorldInverse,
          p = 0,
          m = 0,
          g = 0,
          v = 0,
          b = 0;
        for (r = 0, n = e.length; r < n; r++) if (i = e[r], o = i.color, s = i.intensity, l = i.distance, c = i.shadow && i.shadow.map ? i.shadow.map.texture : null, i.isAmbientLight) u += o.r * s, h += o.g * s, f += o.b * s;else if (i.isDirectionalLight) {
          var y = nt.get(i);
          y.color.copy(i.color).multiplyScalar(i.intensity), y.direction.setFromMatrixPosition(i.matrixWorld), Te.setFromMatrixPosition(i.target.matrixWorld), y.direction.sub(Te), y.direction.transformDirection(d), y.shadow = i.castShadow, i.castShadow && (a = i.shadow, y.shadowBias = a.bias, y.shadowRadius = a.radius, y.shadowMapSize = a.mapSize), Pe.directionalShadowMap[p] = c, Pe.directionalShadowMatrix[p] = i.shadow.matrix, Pe.directional[p] = y, p++;
        } else if (i.isSpotLight) {
          var y = nt.get(i);
          y.position.setFromMatrixPosition(i.matrixWorld), y.position.applyMatrix4(d), y.color.copy(o).multiplyScalar(s), y.distance = l, y.direction.setFromMatrixPosition(i.matrixWorld), Te.setFromMatrixPosition(i.target.matrixWorld), y.direction.sub(Te), y.direction.transformDirection(d), y.coneCos = Math.cos(i.angle), y.penumbraCos = Math.cos(i.angle * (1 - i.penumbra)), y.decay = 0 === i.distance ? 0 : i.decay, y.shadow = i.castShadow, i.castShadow && (a = i.shadow, y.shadowBias = a.bias, y.shadowRadius = a.radius, y.shadowMapSize = a.mapSize), Pe.spotShadowMap[g] = c, Pe.spotShadowMatrix[g] = i.shadow.matrix, Pe.spot[g] = y, g++;
        } else if (i.isRectAreaLight) {
          var y = nt.get(i);
          y.color.copy(o).multiplyScalar(s / (i.width * i.height)), y.position.setFromMatrixPosition(i.matrixWorld), y.position.applyMatrix4(d), Me.identity(), ke.copy(i.matrixWorld), ke.premultiply(d), Me.extractRotation(ke), y.halfWidth.set(.5 * i.width, 0, 0), y.halfHeight.set(0, .5 * i.height, 0), y.halfWidth.applyMatrix4(Me), y.halfHeight.applyMatrix4(Me), Pe.rectArea[v] = y, v++;
        } else if (i.isPointLight) {
          var y = nt.get(i);
          y.position.setFromMatrixPosition(i.matrixWorld), y.position.applyMatrix4(d), y.color.copy(i.color).multiplyScalar(i.intensity), y.distance = i.distance, y.decay = 0 === i.distance ? 0 : i.decay, y.shadow = i.castShadow, i.castShadow && (a = i.shadow, y.shadowBias = a.bias, y.shadowRadius = a.radius, y.shadowMapSize = a.mapSize), Pe.pointShadowMap[m] = c, Pe.pointShadowMatrix[m] = i.shadow.matrix, Pe.point[m] = y, m++;
        } else if (i.isHemisphereLight) {
          var y = nt.get(i);
          y.direction.setFromMatrixPosition(i.matrixWorld), y.direction.transformDirection(d), y.direction.normalize(), y.skyColor.copy(i.color).multiplyScalar(s), y.groundColor.copy(i.groundColor).multiplyScalar(s), Pe.hemi[b] = y, b++;
        }
        Pe.ambient[0] = u, Pe.ambient[1] = h, Pe.ambient[2] = f, Pe.directional.length = p, Pe.spot.length = g, Pe.rectArea.length = v, Pe.point.length = m, Pe.hemi.length = b, Pe.hash = p + "," + m + "," + g + "," + v + "," + b + "," + Pe.shadows.length;
      }
      function B() {
        var e = fe;
        return e >= Ke.maxTextures && console.warn("WebGLRenderer: trying to use " + e + " texture units while this GPU supports only " + Ke.maxTextures), fe += 1, e;
      }
      function D(e) {
        var t;
        if (e === vo) return je.REPEAT;
        if (e === bo) return je.CLAMP_TO_EDGE;
        if (e === yo) return je.MIRRORED_REPEAT;
        if (e === wo) return je.NEAREST;
        if (e === xo) return je.NEAREST_MIPMAP_NEAREST;
        if (e === _o) return je.NEAREST_MIPMAP_LINEAR;
        if (e === So) return je.LINEAR;
        if (e === Co) return je.LINEAR_MIPMAP_NEAREST;
        if (e === Eo) return je.LINEAR_MIPMAP_LINEAR;
        if (e === Ao) return je.UNSIGNED_BYTE;
        if (e === Bo) return je.UNSIGNED_SHORT_4_4_4_4;
        if (e === Do) return je.UNSIGNED_SHORT_5_5_5_1;
        if (e === Lo) return je.UNSIGNED_SHORT_5_6_5;
        if (e === To) return je.BYTE;
        if (e === ko) return je.SHORT;
        if (e === Ro) return je.UNSIGNED_SHORT;
        if (e === Io) return je.INT;
        if (e === Mo) return je.UNSIGNED_INT;
        if (e === Oo) return je.FLOAT;
        if (e === Po && null !== (t = Ye.get("OES_texture_half_float"))) return t.HALF_FLOAT_OES;
        if (e === No) return je.ALPHA;
        if (e === Uo) return je.RGB;
        if (e === jo) return je.RGBA;
        if (e === zo) return je.LUMINANCE;
        if (e === Ho) return je.LUMINANCE_ALPHA;
        if (e === Vo) return je.DEPTH_COMPONENT;
        if (e === qo) return je.DEPTH_STENCIL;
        if (e === Ia) return je.FUNC_ADD;
        if (e === Ma) return je.FUNC_SUBTRACT;
        if (e === Oa) return je.FUNC_REVERSE_SUBTRACT;
        if (e === Da) return je.ZERO;
        if (e === La) return je.ONE;
        if (e === Fa) return je.SRC_COLOR;
        if (e === Na) return je.ONE_MINUS_SRC_COLOR;
        if (e === Ua) return je.SRC_ALPHA;
        if (e === ja) return je.ONE_MINUS_SRC_ALPHA;
        if (e === za) return je.DST_ALPHA;
        if (e === Ha) return je.ONE_MINUS_DST_ALPHA;
        if (e === Ga) return je.DST_COLOR;
        if (e === Va) return je.ONE_MINUS_DST_COLOR;
        if (e === qa) return je.SRC_ALPHA_SATURATE;
        if ((e === Wo || e === Xo || e === Yo || e === Ko) && null !== (t = Ye.get("WEBGL_compressed_texture_s3tc"))) {
          if (e === Wo) return t.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (e === Xo) return t.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (e === Yo) return t.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (e === Ko) return t.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        }
        if ((e === Zo || e === Jo || e === Qo || e === $o) && null !== (t = Ye.get("WEBGL_compressed_texture_pvrtc"))) {
          if (e === Zo) return t.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
          if (e === Jo) return t.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
          if (e === Qo) return t.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
          if (e === $o) return t.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        }
        if (e === es && null !== (t = Ye.get("WEBGL_compressed_texture_etc1"))) return t.COMPRESSED_RGB_ETC1_WEBGL;
        if ((e === Pa || e === Ba) && null !== (t = Ye.get("EXT_blend_minmax"))) {
          if (e === Pa) return t.MIN_EXT;
          if (e === Ba) return t.MAX_EXT;
        }
        return e === Fo && null !== (t = Ye.get("WEBGL_depth_texture")) ? t.UNSIGNED_INT_24_8_WEBGL : 0;
      }
      console.log("THREE.WebGLRenderer", aa), e = e || {};
      var L = void 0 !== e.canvas ? e.canvas : document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"),
        F = void 0 !== e.context ? e.context : null,
        N = void 0 !== e.alpha && e.alpha,
        U = void 0 === e.depth || e.depth,
        j = void 0 === e.stencil || e.stencil,
        z = void 0 !== e.antialias && e.antialias,
        H = void 0 === e.premultipliedAlpha || e.premultipliedAlpha,
        G = void 0 !== e.preserveDrawingBuffer && e.preserveDrawingBuffer,
        V = [],
        q = null,
        W = new Float32Array(8),
        K = [],
        Q = [];
      this.domElement = L, this.context = null, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.gammaFactor = 2, this.gammaInput = !1, this.gammaOutput = !1, this.physicallyCorrectLights = !1, this.toneMapping = io, this.toneMappingExposure = 1, this.toneMappingWhitePoint = 1, this.maxMorphTargets = 8, this.maxMorphNormals = 4;
      var ee = this,
        te = null,
        re = null,
        ne = null,
        ie = -1,
        se = "",
        le = null,
        ce = new o(),
        ue = null,
        he = new o(),
        fe = 0,
        de = new Y(0),
        me = 0,
        ge = L.width,
        ve = L.height,
        be = 1,
        ye = new o(0, 0, ge, ve),
        we = !1,
        xe = new o(0, 0, ge, ve),
        _e = new ae(),
        Se = new pt(),
        Ce = !1,
        Ee = !1,
        Ae = new h(),
        Te = new u(),
        ke = new h(),
        Me = new h(),
        Pe = {
          hash: "",
          ambient: [0, 0, 0],
          directional: [],
          directionalShadowMap: [],
          directionalShadowMatrix: [],
          spot: [],
          spotShadowMap: [],
          spotShadowMatrix: [],
          rectArea: [],
          point: [],
          pointShadowMap: [],
          pointShadowMatrix: [],
          hemi: [],
          shadows: []
        },
        De = {
          geometries: 0,
          textures: 0
        },
        Ue = {
          frame: 0,
          calls: 0,
          vertices: 0,
          faces: 0,
          points: 0
        };
      this.info = {
        render: Ue,
        memory: De,
        programs: null
      };
      var je;
      try {
        var ze = {
          alpha: N,
          depth: U,
          stencil: j,
          antialias: z,
          premultipliedAlpha: H,
          preserveDrawingBuffer: G
        };
        if (null === (je = F || L.getContext("webgl", ze) || L.getContext("experimental-webgl", ze))) throw null !== L.getContext("webgl") ? "Error creating WebGL context with your selected attributes." : "Error creating WebGL context.";
        void 0 === je.getShaderPrecisionFormat && (je.getShaderPrecisionFormat = function () {
          return {
            rangeMin: 1,
            rangeMax: 1,
            precision: 1
          };
        }), L.addEventListener("webglcontextlost", i, !1);
      } catch (e) {
        console.error("THREE.WebGLRenderer: " + e);
      }
      var Ye = new dt(je);
      Ye.get("WEBGL_depth_texture"), Ye.get("OES_texture_float"), Ye.get("OES_texture_float_linear"), Ye.get("OES_texture_half_float"), Ye.get("OES_texture_half_float_linear"), Ye.get("OES_standard_derivatives"), Ye.get("ANGLE_instanced_arrays"), Ye.get("OES_element_index_uint") && (Re.MaxIndex = 4294967296);
      var Ke = new ft(je, Ye, e),
        Ze = new ht(je, Ye, D),
        Je = new ut(),
        Qe = new ct(je, Ye, Ze, Je, Ke, D, De),
        $e = new Ne(je),
        et = new qe(je, $e, De),
        tt = new Xe(je, et, Ue),
        rt = new lt(this, Ke),
        nt = new We(),
        it = new He();
      this.info.programs = rt.programs;
      var at,
        ot,
        st,
        mt,
        gt = new Ve(je, Ye, Ue),
        vt = new Ge(je, Ye, Ue);
      r(), this.context = je, this.capabilities = Ke, this.extensions = Ye, this.properties = Je, this.state = Ze;
      var bt = new oe(this, Pe, tt, Ke);
      this.shadowMap = bt;
      var yt = new J(this, K),
        wt = new Z(this, Q);
      this.getContext = function () {
        return je;
      }, this.getContextAttributes = function () {
        return je.getContextAttributes();
      }, this.forceContextLoss = function () {
        var e = Ye.get("WEBGL_lose_context");
        e && e.loseContext();
      }, this.getMaxAnisotropy = function () {
        return Ke.getMaxAnisotropy();
      }, this.getPrecision = function () {
        return Ke.precision;
      }, this.getPixelRatio = function () {
        return be;
      }, this.setPixelRatio = function (e) {
        void 0 !== e && (be = e, this.setSize(xe.z, xe.w, !1));
      }, this.getSize = function () {
        return {
          width: ge,
          height: ve
        };
      }, this.setSize = function (e, t, r) {
        ge = e, ve = t, L.width = e * be, L.height = t * be, !1 !== r && (L.style.width = e + "px", L.style.height = t + "px"), this.setViewport(0, 0, e, t);
      }, this.setViewport = function (e, t, r, n) {
        Ze.viewport(xe.set(e, t, r, n));
      }, this.setScissor = function (e, t, r, n) {
        Ze.scissor(ye.set(e, t, r, n));
      }, this.setScissorTest = function (e) {
        Ze.setScissorTest(we = e);
      }, this.getClearColor = function () {
        return de;
      }, this.setClearColor = function (e, t) {
        de.set(e), me = void 0 !== t ? t : 1, Ze.buffers.color.setClear(de.r, de.g, de.b, me, H);
      }, this.getClearAlpha = function () {
        return me;
      }, this.setClearAlpha = function (e) {
        me = e, Ze.buffers.color.setClear(de.r, de.g, de.b, me, H);
      }, this.clear = function (e, t, r) {
        var n = 0;
        (void 0 === e || e) && (n |= je.COLOR_BUFFER_BIT), (void 0 === t || t) && (n |= je.DEPTH_BUFFER_BIT), (void 0 === r || r) && (n |= je.STENCIL_BUFFER_BIT), je.clear(n);
      }, this.clearColor = function () {
        this.clear(!0, !1, !1);
      }, this.clearDepth = function () {
        this.clear(!1, !0, !1);
      }, this.clearStencil = function () {
        this.clear(!1, !1, !0);
      }, this.clearTarget = function (e, t, r, n) {
        this.setRenderTarget(e), this.clear(t, r, n);
      }, this.resetGLState = n, this.dispose = function () {
        L.removeEventListener("webglcontextlost", i, !1), it.dispose();
      }, this.renderBufferImmediate = function (e, t, r) {
        Ze.initAttributes();
        var n = Je.get(e);
        e.hasPositions && !n.position && (n.position = je.createBuffer()), e.hasNormals && !n.normal && (n.normal = je.createBuffer()), e.hasUvs && !n.uv && (n.uv = je.createBuffer()), e.hasColors && !n.color && (n.color = je.createBuffer());
        var i = t.getAttributes();
        if (e.hasPositions && (je.bindBuffer(je.ARRAY_BUFFER, n.position), je.bufferData(je.ARRAY_BUFFER, e.positionArray, je.DYNAMIC_DRAW), Ze.enableAttribute(i.position), je.vertexAttribPointer(i.position, 3, je.FLOAT, !1, 0, 0)), e.hasNormals) {
          if (je.bindBuffer(je.ARRAY_BUFFER, n.normal), !r.isMeshPhongMaterial && !r.isMeshStandardMaterial && !r.isMeshNormalMaterial && r.shading === ya) for (var a = 0, o = 3 * e.count; a < o; a += 9) {
            var s = e.normalArray,
              l = (s[a + 0] + s[a + 3] + s[a + 6]) / 3,
              c = (s[a + 1] + s[a + 4] + s[a + 7]) / 3,
              u = (s[a + 2] + s[a + 5] + s[a + 8]) / 3;
            s[a + 0] = l, s[a + 1] = c, s[a + 2] = u, s[a + 3] = l, s[a + 4] = c, s[a + 5] = u, s[a + 6] = l, s[a + 7] = c, s[a + 8] = u;
          }
          je.bufferData(je.ARRAY_BUFFER, e.normalArray, je.DYNAMIC_DRAW), Ze.enableAttribute(i.normal), je.vertexAttribPointer(i.normal, 3, je.FLOAT, !1, 0, 0);
        }
        e.hasUvs && r.map && (je.bindBuffer(je.ARRAY_BUFFER, n.uv), je.bufferData(je.ARRAY_BUFFER, e.uvArray, je.DYNAMIC_DRAW), Ze.enableAttribute(i.uv), je.vertexAttribPointer($e.uv, 2, je.FLOAT, !1, 0, 0)), e.hasColors && r.vertexColors !== xa && (je.bindBuffer(je.ARRAY_BUFFER, n.color), je.bufferData(je.ARRAY_BUFFER, e.colorArray, je.DYNAMIC_DRAW), Ze.enableAttribute(i.color), je.vertexAttribPointer(i.color, 3, je.FLOAT, !1, 0, 0)), Ze.disableUnusedAttributes(), je.drawArrays(je.TRIANGLES, 0, e.count), e.count = 0;
      }, this.renderBufferDirect = function (e, r, n, i, a, o) {
        Ze.setMaterial(i);
        var s = y(e, r, i, a),
          l = n.id + "_" + s.id + "_" + (!0 === i.wireframe),
          c = !1;
        l !== se && (se = l, c = !0);
        var u = a.morphTargetInfluences;
        if (void 0 !== u) {
          for (var h = [], f = 0, m = u.length; f < m; f++) {
            var g = u[f];
            h.push([g, f]);
          }
          h.sort(d), h.length > 8 && (h.length = 8);
          for (var v = n.morphAttributes, f = 0, m = h.length; f < m; f++) {
            var g = h[f];
            if (W[f] = g[0], 0 !== g[0]) {
              var b = g[1];
              !0 === i.morphTargets && v.position && n.addAttribute("morphTarget" + f, v.position[b]), !0 === i.morphNormals && v.normal && n.addAttribute("morphNormal" + f, v.normal[b]);
            } else !0 === i.morphTargets && n.removeAttribute("morphTarget" + f), !0 === i.morphNormals && n.removeAttribute("morphNormal" + f);
          }
          for (var f = h.length, w = W.length; f < w; f++) W[f] = 0;
          s.getUniforms().setValue(je, "morphTargetInfluences", W), c = !0;
        }
        var b = n.index,
          x = n.attributes.position,
          _ = 1;
        !0 === i.wireframe && (b = et.getWireframeAttribute(n), _ = 2);
        var S = gt;
        null !== b && (S = vt, S.setIndex(b)), c && (p(i, s, n), null !== b && je.bindBuffer(je.ELEMENT_ARRAY_BUFFER, $e.get(b).buffer));
        var C = 0;
        null !== b ? C = b.count : void 0 !== x && (C = x.count);
        var E = n.drawRange.start * _,
          A = n.drawRange.count * _,
          T = null !== o ? o.start * _ : 0,
          k = null !== o ? o.count * _ : 1 / 0,
          R = Math.max(E, T),
          I = Math.min(C, E + A, T + k) - 1,
          M = Math.max(0, I - R + 1);
        if (0 !== M) {
          if (a.isMesh) {
            if (!0 === i.wireframe) Ze.setLineWidth(i.wireframeLinewidth * t()), S.setMode(je.LINES);else switch (a.drawMode) {
              case us:
                S.setMode(je.TRIANGLES);
                break;
              case hs:
                S.setMode(je.TRIANGLE_STRIP);
                break;
              case fs:
                S.setMode(je.TRIANGLE_FAN);
            }
          } else if (a.isLine) {
            var O = i.linewidth;
            void 0 === O && (O = 1), Ze.setLineWidth(O * t()), a.isLineSegments ? S.setMode(je.LINES) : a.isLineLoop ? S.setMode(je.LINE_LOOP) : S.setMode(je.LINE_STRIP);
          } else a.isPoints && S.setMode(je.POINTS);
          n && n.isInstancedBufferGeometry ? n.maxInstancedCount > 0 && S.renderInstances(n, R, M) : S.render(R, M);
        }
      }, this.compile = function (e, t) {
        V = [], e.traverse(function (e) {
          e.isLight && V.push(e);
        }), P(V, t), e.traverse(function (t) {
          if (t.material) if (Array.isArray(t.material)) for (var r = 0; r < t.material.length; r++) b(t.material[r], e.fog, t);else b(t.material, e.fog, t);
        });
      }, this.render = function (e, t, r, n) {
        if (void 0 !== t && !0 !== t.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
        se = "", ie = -1, le = null, !0 === e.autoUpdate && e.updateMatrixWorld(), t.onBeforeRender(ee), null === t.parent && t.updateMatrixWorld(), t.matrixWorldInverse.getInverse(t.matrixWorld), Ae.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), _e.setFromMatrix(Ae), V.length = 0, K.length = 0, Q.length = 0, Ee = this.localClippingEnabled, Ce = Se.init(this.clippingPlanes, Ee, t), q = it.get(e, t), q.init(), m(e, t, ee.sortObjects), q.finish(), !0 === ee.sortObjects && q.sort(), Ce && Se.beginShadows(), O(V), bt.render(e, t), P(V, t), Ce && Se.endShadows(), Ue.frame++, Ue.calls = 0, Ue.vertices = 0, Ue.faces = 0, Ue.points = 0, void 0 === r && (r = null), this.setRenderTarget(r);
        var i = e.background;
        null === i ? Ze.buffers.color.setClear(de.r, de.g, de.b, me, H) : i && i.isColor && (Ze.buffers.color.setClear(i.r, i.g, i.b, 1, H), n = !0), (this.autoClear || n) && this.clear(this.autoClearColor, this.autoClearDepth, this.autoClearStencil), i && i.isCubeTexture ? (void 0 === st && (st = new Le(), mt = new Ie(new Oe(5, 5, 5), new $({
          uniforms: Ls.cube.uniforms,
          vertexShader: Ls.cube.vertexShader,
          fragmentShader: Ls.cube.fragmentShader,
          side: va,
          depthTest: !1,
          depthWrite: !1,
          fog: !1
        }))), st.projectionMatrix.copy(t.projectionMatrix), st.matrixWorld.extractRotation(t.matrixWorld), st.matrixWorldInverse.getInverse(st.matrixWorld), mt.material.uniforms.tCube.value = i, mt.modelViewMatrix.multiplyMatrices(st.matrixWorldInverse, mt.matrixWorld), tt.update(mt), ee.renderBufferDirect(st, null, mt.geometry, mt.material, mt, null)) : i && i.isTexture && (void 0 === at && (at = new Fe(-1, 1, 1, -1, 0, 1), ot = new Ie(new Be(2, 2), new pe({
          depthTest: !1,
          depthWrite: !1,
          fog: !1
        }))), ot.material.map = i, tt.update(ot), ee.renderBufferDirect(at, null, ot.geometry, ot.material, ot, null));
        var a = q.opaque,
          o = q.transparent;
        if (e.overrideMaterial) {
          var s = e.overrideMaterial;
          a.length && g(a, e, t, s), o.length && g(o, e, t, s);
        } else a.length && g(a, e, t), o.length && g(o, e, t);
        yt.render(e, t), wt.render(e, t, he), r && Qe.updateRenderTargetMipmap(r), Ze.buffers.depth.setTest(!0), Ze.buffers.depth.setMask(!0), Ze.buffers.color.setMask(!0), t.isArrayCamera && t.enabled && ee.setScissorTest(!1), t.onAfterRender(ee);
      }, this.setFaceCulling = function (e, t) {
        Ze.setCullFace(e), Ze.setFlipSided(t === ha);
      }, this.allocTextureUnit = B, this.setTexture2D = function () {
        var e = !1;
        return function (t, r) {
          t && t.isWebGLRenderTarget && (e || (console.warn("THREE.WebGLRenderer.setTexture2D: don't use render targets as textures. Use their .texture property instead."), e = !0), t = t.texture), Qe.setTexture2D(t, r);
        };
      }(), this.setTexture = function () {
        var e = !1;
        return function (t, r) {
          e || (console.warn("THREE.WebGLRenderer: .setTexture is deprecated, use setTexture2D instead."), e = !0), Qe.setTexture2D(t, r);
        };
      }(), this.setTextureCube = function () {
        var e = !1;
        return function (t, r) {
          t && t.isWebGLRenderTargetCube && (e || (console.warn("THREE.WebGLRenderer.setTextureCube: don't use cube render targets as textures. Use their .texture property instead."), e = !0), t = t.texture), t && t.isCubeTexture || Array.isArray(t.image) && 6 === t.image.length ? Qe.setTextureCube(t, r) : Qe.setTextureCubeDynamic(t, r);
        };
      }(), this.getRenderTarget = function () {
        return re;
      }, this.setRenderTarget = function (e) {
        re = e, e && void 0 === Je.get(e).__webglFramebuffer && Qe.setupRenderTarget(e);
        var t,
          r = e && e.isWebGLRenderTargetCube;
        if (e) {
          var n = Je.get(e);
          t = r ? n.__webglFramebuffer[e.activeCubeFace] : n.__webglFramebuffer, ce.copy(e.scissor), ue = e.scissorTest, he.copy(e.viewport);
        } else t = null, ce.copy(ye).multiplyScalar(be), ue = we, he.copy(xe).multiplyScalar(be);
        if (ne !== t && (je.bindFramebuffer(je.FRAMEBUFFER, t), ne = t), Ze.scissor(ce), Ze.setScissorTest(ue), Ze.viewport(he), r) {
          var i = Je.get(e.texture);
          je.framebufferTexture2D(je.FRAMEBUFFER, je.COLOR_ATTACHMENT0, je.TEXTURE_CUBE_MAP_POSITIVE_X + e.activeCubeFace, i.__webglTexture, e.activeMipMapLevel);
        }
      }, this.readRenderTargetPixels = function (e, t, r, n, i, a) {
        if (!1 === (e && e.isWebGLRenderTarget)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
        var o = Je.get(e).__webglFramebuffer;
        if (o) {
          var s = !1;
          o !== ne && (je.bindFramebuffer(je.FRAMEBUFFER, o), s = !0);
          try {
            var l = e.texture,
              c = l.format,
              u = l.type;
            if (c !== jo && D(c) !== je.getParameter(je.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
            if (!(u === Ao || D(u) === je.getParameter(je.IMPLEMENTATION_COLOR_READ_TYPE) || u === Oo && (Ye.get("OES_texture_float") || Ye.get("WEBGL_color_buffer_float")) || u === Po && Ye.get("EXT_color_buffer_half_float"))) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
            je.checkFramebufferStatus(je.FRAMEBUFFER) === je.FRAMEBUFFER_COMPLETE ? t >= 0 && t <= e.width - n && r >= 0 && r <= e.height - i && je.readPixels(t, r, n, i, D(c), D(u), a) : console.error("THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.");
          } finally {
            s && je.bindFramebuffer(je.FRAMEBUFFER, ne);
          }
        }
      };
    }
    function gt(e, t) {
      this.name = "", this.color = new Y(e), this.density = void 0 !== t ? t : 25e-5;
    }
    function vt(e, t, r) {
      this.name = "", this.color = new Y(e), this.near = void 0 !== t ? t : 1, this.far = void 0 !== r ? r : 1e3;
    }
    function bt() {
      ue.call(this), this.type = "Scene", this.background = null, this.fog = null, this.overrideMaterial = null, this.autoUpdate = !0;
    }
    function yt(e, t, r, n, i) {
      ue.call(this), this.lensFlares = [], this.positionScreen = new u(), this.customUpdateCallback = void 0, void 0 !== e && this.add(e, t, r, n, i);
    }
    function wt(e) {
      Q.call(this), this.type = "SpriteMaterial", this.color = new Y(16777215), this.map = null, this.rotation = 0, this.fog = !1, this.lights = !1, this.setValues(e);
    }
    function xt(e) {
      ue.call(this), this.type = "Sprite", this.material = void 0 !== e ? e : new wt();
    }
    function _t() {
      ue.call(this), this.type = "LOD", Object.defineProperties(this, {
        levels: {
          enumerable: !0,
          value: []
        }
      });
    }
    function St(e, t) {
      if (e = e || [], this.bones = e.slice(0), this.boneMatrices = new Float32Array(16 * this.bones.length), void 0 === t) this.calculateInverses();else if (this.bones.length === t.length) this.boneInverses = t.slice(0);else {
        console.warn("THREE.Skeleton boneInverses is the wrong length."), this.boneInverses = [];
        for (var r = 0, n = this.bones.length; r < n; r++) this.boneInverses.push(new h());
      }
    }
    function Ct() {
      ue.call(this), this.type = "Bone";
    }
    function Et(e, t) {
      Ie.call(this, e, t), this.type = "SkinnedMesh", this.bindMode = "attached", this.bindMatrix = new h(), this.bindMatrixInverse = new h();
      var r = this.initBones(),
        n = new St(r);
      this.bind(n, this.matrixWorld), this.normalizeSkinWeights();
    }
    function At(e) {
      Q.call(this), this.type = "LineBasicMaterial", this.color = new Y(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.lights = !1, this.setValues(e);
    }
    function Tt(e, t, r) {
      if (1 === r) return console.warn("THREE.Line: parameter THREE.LinePieces no longer supported. Created THREE.LineSegments instead."), new kt(e, t);
      ue.call(this), this.type = "Line", this.geometry = void 0 !== e ? e : new Re(), this.material = void 0 !== t ? t : new At({
        color: 16777215 * Math.random()
      });
    }
    function kt(e, t) {
      Tt.call(this, e, t), this.type = "LineSegments";
    }
    function Rt(e, t) {
      Tt.call(this, e, t), this.type = "LineLoop";
    }
    function It(e) {
      Q.call(this), this.type = "PointsMaterial", this.color = new Y(16777215), this.map = null, this.size = 1, this.sizeAttenuation = !0, this.lights = !1, this.setValues(e);
    }
    function Mt(e, t) {
      ue.call(this), this.type = "Points", this.geometry = void 0 !== e ? e : new Re(), this.material = void 0 !== t ? t : new It({
        color: 16777215 * Math.random()
      });
    }
    function Ot() {
      ue.call(this), this.type = "Group";
    }
    function Pt(e, t, r, n, i, o, s, l, c) {
      function u() {
        requestAnimationFrame(u), e.readyState >= e.HAVE_CURRENT_DATA && (h.needsUpdate = !0);
      }
      a.call(this, e, t, r, n, i, o, s, l, c), this.generateMipmaps = !1;
      var h = this;
      u();
    }
    function Bt(e, t, r, n, i, o, s, l, c, u, h, f) {
      a.call(this, null, o, s, l, c, u, n, i, h, f), this.image = {
        width: t,
        height: r
      }, this.mipmaps = e, this.flipY = !1, this.generateMipmaps = !1;
    }
    function Dt(e, t, r, n, i, o, s, l, c) {
      a.call(this, e, t, r, n, i, o, s, l, c), this.needsUpdate = !0;
    }
    function Lt(e, t, r, n, i, o, s, l, c, u) {
      if ((u = void 0 !== u ? u : Vo) !== Vo && u !== qo) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
      void 0 === r && u === Vo && (r = Ro), void 0 === r && u === qo && (r = Fo), a.call(this, null, n, i, o, s, l, u, r, c), this.image = {
        width: e,
        height: t
      }, this.magFilter = void 0 !== s ? s : wo, this.minFilter = void 0 !== l ? l : wo, this.flipY = !1, this.generateMipmaps = !1;
    }
    function Ft(e) {
      Re.call(this), this.type = "WireframeGeometry";
      var t,
        r,
        n,
        i,
        a,
        o,
        s,
        l,
        c,
        h,
        f = [],
        d = [0, 0],
        p = {},
        m = ["a", "b", "c"];
      if (e && e.isGeometry) {
        var g = e.faces;
        for (t = 0, n = g.length; t < n; t++) {
          var v = g[t];
          for (r = 0; r < 3; r++) s = v[m[r]], l = v[m[(r + 1) % 3]], d[0] = Math.min(s, l), d[1] = Math.max(s, l), c = d[0] + "," + d[1], void 0 === p[c] && (p[c] = {
            index1: d[0],
            index2: d[1]
          });
        }
        for (c in p) o = p[c], h = e.vertices[o.index1], f.push(h.x, h.y, h.z), h = e.vertices[o.index2], f.push(h.x, h.y, h.z);
      } else if (e && e.isBufferGeometry) {
        var b, y, w, x, _, S, C, E;
        if (h = new u(), null !== e.index) {
          for (b = e.attributes.position, y = e.index, w = e.groups, 0 === w.length && (w = [{
            start: 0,
            count: y.count,
            materialIndex: 0
          }]), i = 0, a = w.length; i < a; ++i) for (x = w[i], _ = x.start, S = x.count, t = _, n = _ + S; t < n; t += 3) for (r = 0; r < 3; r++) s = y.getX(t + r), l = y.getX(t + (r + 1) % 3), d[0] = Math.min(s, l), d[1] = Math.max(s, l), c = d[0] + "," + d[1], void 0 === p[c] && (p[c] = {
            index1: d[0],
            index2: d[1]
          });
          for (c in p) o = p[c], h.fromBufferAttribute(b, o.index1), f.push(h.x, h.y, h.z), h.fromBufferAttribute(b, o.index2), f.push(h.x, h.y, h.z);
        } else for (b = e.attributes.position, t = 0, n = b.count / 3; t < n; t++) for (r = 0; r < 3; r++) C = 3 * t + r, h.fromBufferAttribute(b, C), f.push(h.x, h.y, h.z), E = 3 * t + (r + 1) % 3, h.fromBufferAttribute(b, E), f.push(h.x, h.y, h.z);
      }
      this.addAttribute("position", new Se(f, 3));
    }
    function Nt(e, t, r) {
      ke.call(this), this.type = "ParametricGeometry", this.parameters = {
        func: e,
        slices: t,
        stacks: r
      }, this.fromBufferGeometry(new Ut(e, t, r)), this.mergeVertices();
    }
    function Ut(e, t, r) {
      Re.call(this), this.type = "ParametricBufferGeometry", this.parameters = {
        func: e,
        slices: t,
        stacks: r
      };
      var n,
        i,
        a = [],
        o = [],
        s = [],
        l = [],
        c = new u(),
        h = new u(),
        f = new u(),
        d = new u(),
        p = new u(),
        m = t + 1;
      for (n = 0; n <= r; n++) {
        var g = n / r;
        for (i = 0; i <= t; i++) {
          var v = i / t;
          h = e(v, g, h), o.push(h.x, h.y, h.z), v - 1e-5 >= 0 ? (f = e(v - 1e-5, g, f), d.subVectors(h, f)) : (f = e(v + 1e-5, g, f), d.subVectors(f, h)), g - 1e-5 >= 0 ? (f = e(v, g - 1e-5, f), p.subVectors(h, f)) : (f = e(v, g + 1e-5, f), p.subVectors(f, h)), c.crossVectors(d, p).normalize(), s.push(c.x, c.y, c.z), l.push(v, g);
        }
      }
      for (n = 0; n < r; n++) for (i = 0; i < t; i++) {
        var b = n * m + i,
          y = n * m + i + 1,
          w = (n + 1) * m + i + 1,
          x = (n + 1) * m + i;
        a.push(b, y, x), a.push(y, w, x);
      }
      this.setIndex(a), this.addAttribute("position", new Se(o, 3)), this.addAttribute("normal", new Se(s, 3)), this.addAttribute("uv", new Se(l, 2));
    }
    function jt(e, t, r, n) {
      ke.call(this), this.type = "PolyhedronGeometry", this.parameters = {
        vertices: e,
        indices: t,
        radius: r,
        detail: n
      }, this.fromBufferGeometry(new zt(e, t, r, n)), this.mergeVertices();
    }
    function zt(e, t, r, n) {
      function a(e, t, r, n) {
        var i,
          a,
          o = Math.pow(2, n),
          l = [];
        for (i = 0; i <= o; i++) {
          l[i] = [];
          var c = e.clone().lerp(r, i / o),
            u = t.clone().lerp(r, i / o),
            h = o - i;
          for (a = 0; a <= h; a++) l[i][a] = 0 === a && i === o ? c : c.clone().lerp(u, a / h);
        }
        for (i = 0; i < o; i++) for (a = 0; a < 2 * (o - i) - 1; a++) {
          var f = Math.floor(a / 2);
          a % 2 == 0 ? (s(l[i][f + 1]), s(l[i + 1][f]), s(l[i][f])) : (s(l[i][f + 1]), s(l[i + 1][f + 1]), s(l[i + 1][f]));
        }
      }
      function o() {
        for (var e = 0; e < m.length; e += 6) {
          var t = m[e + 0],
            r = m[e + 2],
            n = m[e + 4],
            i = Math.max(t, r, n),
            a = Math.min(t, r, n);
          i > .9 && a < .1 && (t < .2 && (m[e + 0] += 1), r < .2 && (m[e + 2] += 1), n < .2 && (m[e + 4] += 1));
        }
      }
      function s(e) {
        p.push(e.x, e.y, e.z);
      }
      function l(t, r) {
        var n = 3 * t;
        r.x = e[n + 0], r.y = e[n + 1], r.z = e[n + 2];
      }
      function c() {
        for (var e = new u(), t = new u(), r = new u(), n = new u(), a = new i(), o = new i(), s = new i(), l = 0, c = 0; l < p.length; l += 9, c += 6) {
          e.set(p[l + 0], p[l + 1], p[l + 2]), t.set(p[l + 3], p[l + 4], p[l + 5]), r.set(p[l + 6], p[l + 7], p[l + 8]), a.set(m[c + 0], m[c + 1]), o.set(m[c + 2], m[c + 3]), s.set(m[c + 4], m[c + 5]), n.copy(e).add(t).add(r).divideScalar(3);
          var d = f(n);
          h(a, c + 0, e, d), h(o, c + 2, t, d), h(s, c + 4, r, d);
        }
      }
      function h(e, t, r, n) {
        n < 0 && 1 === e.x && (m[t] = e.x - 1), 0 === r.x && 0 === r.z && (m[t] = n / 2 / Math.PI + .5);
      }
      function f(e) {
        return Math.atan2(e.z, -e.x);
      }
      function d(e) {
        return Math.atan2(-e.y, Math.sqrt(e.x * e.x + e.z * e.z));
      }
      Re.call(this), this.type = "PolyhedronBufferGeometry", this.parameters = {
        vertices: e,
        indices: t,
        radius: r,
        detail: n
      }, r = r || 1, n = n || 0;
      var p = [],
        m = [];
      !function (e) {
        for (var r = new u(), n = new u(), i = new u(), o = 0; o < t.length; o += 3) l(t[o + 0], r), l(t[o + 1], n), l(t[o + 2], i), a(r, n, i, e);
      }(n), function (e) {
        for (var t = new u(), r = 0; r < p.length; r += 3) t.x = p[r + 0], t.y = p[r + 1], t.z = p[r + 2], t.normalize().multiplyScalar(e), p[r + 0] = t.x, p[r + 1] = t.y, p[r + 2] = t.z;
      }(r), function () {
        for (var e = new u(), t = 0; t < p.length; t += 3) {
          e.x = p[t + 0], e.y = p[t + 1], e.z = p[t + 2];
          var r = f(e) / 2 / Math.PI + .5,
            n = d(e) / Math.PI + .5;
          m.push(r, 1 - n);
        }
        c(), o();
      }(), this.addAttribute("position", new Se(p, 3)), this.addAttribute("normal", new Se(p.slice(), 3)), this.addAttribute("uv", new Se(m, 2)), this.normalizeNormals();
    }
    function Ht(e, t) {
      ke.call(this), this.type = "TetrahedronGeometry", this.parameters = {
        radius: e,
        detail: t
      }, this.fromBufferGeometry(new Gt(e, t)), this.mergeVertices();
    }
    function Gt(e, t) {
      var r = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1],
        n = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1];
      zt.call(this, r, n, e, t), this.type = "TetrahedronBufferGeometry", this.parameters = {
        radius: e,
        detail: t
      };
    }
    function Vt(e, t) {
      ke.call(this), this.type = "OctahedronGeometry", this.parameters = {
        radius: e,
        detail: t
      }, this.fromBufferGeometry(new qt(e, t)), this.mergeVertices();
    }
    function qt(e, t) {
      var r = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1],
        n = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2];
      zt.call(this, r, n, e, t), this.type = "OctahedronBufferGeometry", this.parameters = {
        radius: e,
        detail: t
      };
    }
    function Wt(e, t) {
      ke.call(this), this.type = "IcosahedronGeometry", this.parameters = {
        radius: e,
        detail: t
      }, this.fromBufferGeometry(new Xt(e, t)), this.mergeVertices();
    }
    function Xt(e, t) {
      var r = (1 + Math.sqrt(5)) / 2,
        n = [-1, r, 0, 1, r, 0, -1, -r, 0, 1, -r, 0, 0, -1, r, 0, 1, r, 0, -1, -r, 0, 1, -r, r, 0, -1, r, 0, 1, -r, 0, -1, -r, 0, 1],
        i = [0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2, 10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4, 11, 6, 2, 10, 8, 6, 7, 9, 8, 1];
      zt.call(this, n, i, e, t), this.type = "IcosahedronBufferGeometry", this.parameters = {
        radius: e,
        detail: t
      };
    }
    function Yt(e, t) {
      ke.call(this), this.type = "DodecahedronGeometry", this.parameters = {
        radius: e,
        detail: t
      }, this.fromBufferGeometry(new Kt(e, t)), this.mergeVertices();
    }
    function Kt(e, t) {
      var r = (1 + Math.sqrt(5)) / 2,
        n = 1 / r,
        i = [-1, -1, -1, -1, -1, 1, -1, 1, -1, -1, 1, 1, 1, -1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1, 0, -n, -r, 0, -n, r, 0, n, -r, 0, n, r, -n, -r, 0, -n, r, 0, n, -r, 0, n, r, 0, -r, 0, -n, r, 0, -n, -r, 0, n, r, 0, n],
        a = [3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8, 10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6, 10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11, 18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5, 14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9];
      zt.call(this, i, a, e, t), this.type = "DodecahedronBufferGeometry", this.parameters = {
        radius: e,
        detail: t
      };
    }
    function Zt(e, t, r, n, i, a) {
      ke.call(this), this.type = "TubeGeometry", this.parameters = {
        path: e,
        tubularSegments: t,
        radius: r,
        radialSegments: n,
        closed: i
      }, void 0 !== a && console.warn("THREE.TubeGeometry: taper has been removed.");
      var o = new Jt(e, t, r, n, i);
      this.tangents = o.tangents, this.normals = o.normals, this.binormals = o.binormals, this.fromBufferGeometry(o), this.mergeVertices();
    }
    function Jt(e, t, r, n, a) {
      function o(i) {
        var a = e.getPointAt(i / t),
          o = c.normals[i],
          s = c.binormals[i];
        for (f = 0; f <= n; f++) {
          var l = f / n * Math.PI * 2,
            u = Math.sin(l),
            h = -Math.cos(l);
          p.x = h * o.x + u * s.x, p.y = h * o.y + u * s.y, p.z = h * o.z + u * s.z, p.normalize(), v.push(p.x, p.y, p.z), d.x = a.x + r * p.x, d.y = a.y + r * p.y, d.z = a.z + r * p.z, g.push(d.x, d.y, d.z);
        }
      }
      function s() {
        for (f = 1; f <= t; f++) for (h = 1; h <= n; h++) {
          var e = (n + 1) * (f - 1) + (h - 1),
            r = (n + 1) * f + (h - 1),
            i = (n + 1) * f + h,
            a = (n + 1) * (f - 1) + h;
          y.push(e, r, a), y.push(r, i, a);
        }
      }
      function l() {
        for (h = 0; h <= t; h++) for (f = 0; f <= n; f++) m.x = h / t, m.y = f / n, b.push(m.x, m.y);
      }
      Re.call(this), this.type = "TubeBufferGeometry", this.parameters = {
        path: e,
        tubularSegments: t,
        radius: r,
        radialSegments: n,
        closed: a
      }, t = t || 64, r = r || 1, n = n || 8, a = a || !1;
      var c = e.computeFrenetFrames(t, a);
      this.tangents = c.tangents, this.normals = c.normals, this.binormals = c.binormals;
      var h,
        f,
        d = new u(),
        p = new u(),
        m = new i(),
        g = [],
        v = [],
        b = [],
        y = [];
      !function () {
        for (h = 0; h < t; h++) o(h);
        o(!1 === a ? t : 0), l(), s();
      }(), this.setIndex(y), this.addAttribute("position", new Se(g, 3)), this.addAttribute("normal", new Se(v, 3)), this.addAttribute("uv", new Se(b, 2));
    }
    function Qt(e, t, r, n, i, a, o) {
      ke.call(this), this.type = "TorusKnotGeometry", this.parameters = {
        radius: e,
        tube: t,
        tubularSegments: r,
        radialSegments: n,
        p: i,
        q: a
      }, void 0 !== o && console.warn("THREE.TorusKnotGeometry: heightScale has been deprecated. Use .scale( x, y, z ) instead."), this.fromBufferGeometry(new $t(e, t, r, n, i, a)), this.mergeVertices();
    }
    function $t(e, t, r, n, i, a) {
      function o(e, t, r, n, i) {
        var a = Math.cos(e),
          o = Math.sin(e),
          s = r / t * e,
          l = Math.cos(s);
        i.x = n * (2 + l) * .5 * a, i.y = n * (2 + l) * o * .5, i.z = n * Math.sin(s) * .5;
      }
      Re.call(this), this.type = "TorusKnotBufferGeometry", this.parameters = {
        radius: e,
        tube: t,
        tubularSegments: r,
        radialSegments: n,
        p: i,
        q: a
      }, e = e || 100, t = t || 40, r = Math.floor(r) || 64, n = Math.floor(n) || 8, i = i || 2, a = a || 3;
      var s,
        l,
        c = [],
        h = [],
        f = [],
        d = [],
        p = new u(),
        m = new u(),
        g = new u(),
        v = new u(),
        b = new u(),
        y = new u(),
        w = new u();
      for (s = 0; s <= r; ++s) {
        var x = s / r * i * Math.PI * 2;
        for (o(x, i, a, e, g), o(x + .01, i, a, e, v), y.subVectors(v, g), w.addVectors(v, g), b.crossVectors(y, w), w.crossVectors(b, y), b.normalize(), w.normalize(), l = 0; l <= n; ++l) {
          var _ = l / n * Math.PI * 2,
            S = -t * Math.cos(_),
            C = t * Math.sin(_);
          p.x = g.x + (S * w.x + C * b.x), p.y = g.y + (S * w.y + C * b.y), p.z = g.z + (S * w.z + C * b.z), h.push(p.x, p.y, p.z), m.subVectors(p, g).normalize(), f.push(m.x, m.y, m.z), d.push(s / r), d.push(l / n);
        }
      }
      for (l = 1; l <= r; l++) for (s = 1; s <= n; s++) {
        var E = (n + 1) * (l - 1) + (s - 1),
          A = (n + 1) * l + (s - 1),
          T = (n + 1) * l + s,
          k = (n + 1) * (l - 1) + s;
        c.push(E, A, k), c.push(A, T, k);
      }
      this.setIndex(c), this.addAttribute("position", new Se(h, 3)), this.addAttribute("normal", new Se(f, 3)), this.addAttribute("uv", new Se(d, 2));
    }
    function er(e, t, r, n, i) {
      ke.call(this), this.type = "TorusGeometry", this.parameters = {
        radius: e,
        tube: t,
        radialSegments: r,
        tubularSegments: n,
        arc: i
      }, this.fromBufferGeometry(new tr(e, t, r, n, i)), this.mergeVertices();
    }
    function tr(e, t, r, n, i) {
      Re.call(this), this.type = "TorusBufferGeometry", this.parameters = {
        radius: e,
        tube: t,
        radialSegments: r,
        tubularSegments: n,
        arc: i
      }, e = e || 100, t = t || 40, r = Math.floor(r) || 8, n = Math.floor(n) || 6, i = i || 2 * Math.PI;
      var a,
        o,
        s = [],
        l = [],
        c = [],
        h = [],
        f = new u(),
        d = new u(),
        p = new u();
      for (a = 0; a <= r; a++) for (o = 0; o <= n; o++) {
        var m = o / n * i,
          g = a / r * Math.PI * 2;
        d.x = (e + t * Math.cos(g)) * Math.cos(m), d.y = (e + t * Math.cos(g)) * Math.sin(m), d.z = t * Math.sin(g), l.push(d.x, d.y, d.z), f.x = e * Math.cos(m), f.y = e * Math.sin(m), p.subVectors(d, f).normalize(), c.push(p.x, p.y, p.z), h.push(o / n), h.push(a / r);
      }
      for (a = 1; a <= r; a++) for (o = 1; o <= n; o++) {
        var v = (n + 1) * a + o - 1,
          b = (n + 1) * (a - 1) + o - 1,
          y = (n + 1) * (a - 1) + o,
          w = (n + 1) * a + o;
        s.push(v, b, w), s.push(b, y, w);
      }
      this.setIndex(s), this.addAttribute("position", new Se(l, 3)), this.addAttribute("normal", new Se(c, 3)), this.addAttribute("uv", new Se(h, 2));
    }
    function rr(e, t) {
      ke.call(this), this.type = "ExtrudeGeometry", this.parameters = {
        shapes: e,
        options: t
      }, this.fromBufferGeometry(new nr(e, t)), this.mergeVertices();
    }
    function nr(e, t) {
      if (void 0 === e) return void (e = []);
      Re.call(this), this.type = "ExtrudeBufferGeometry", e = Array.isArray(e) ? e : [e], this.addShapeList(e, t), this.computeVertexNormals();
    }
    function ir(e, t) {
      ke.call(this), this.type = "TextGeometry", this.parameters = {
        text: e,
        parameters: t
      }, this.fromBufferGeometry(new ar(e, t)), this.mergeVertices();
    }
    function ar(e, t) {
      t = t || {};
      var r = t.font;
      if (!1 === (r && r.isFont)) return console.error("THREE.TextGeometry: font parameter is not an instance of THREE.Font."), new ke();
      var n = r.generateShapes(e, t.size, t.curveSegments);
      t.amount = void 0 !== t.height ? t.height : 50, void 0 === t.bevelThickness && (t.bevelThickness = 10), void 0 === t.bevelSize && (t.bevelSize = 8), void 0 === t.bevelEnabled && (t.bevelEnabled = !1), nr.call(this, n, t), this.type = "TextBufferGeometry";
    }
    function or(e, t, r, n, i, a, o) {
      ke.call(this), this.type = "SphereGeometry", this.parameters = {
        radius: e,
        widthSegments: t,
        heightSegments: r,
        phiStart: n,
        phiLength: i,
        thetaStart: a,
        thetaLength: o
      }, this.fromBufferGeometry(new sr(e, t, r, n, i, a, o)), this.mergeVertices();
    }
    function sr(e, t, r, n, i, a, o) {
      Re.call(this), this.type = "SphereBufferGeometry", this.parameters = {
        radius: e,
        widthSegments: t,
        heightSegments: r,
        phiStart: n,
        phiLength: i,
        thetaStart: a,
        thetaLength: o
      }, e = e || 50, t = Math.max(3, Math.floor(t) || 8), r = Math.max(2, Math.floor(r) || 6), n = void 0 !== n ? n : 0, i = void 0 !== i ? i : 2 * Math.PI, a = void 0 !== a ? a : 0, o = void 0 !== o ? o : Math.PI;
      var s,
        l,
        c = a + o,
        h = 0,
        f = [],
        d = new u(),
        p = new u(),
        m = [],
        g = [],
        v = [],
        b = [];
      for (l = 0; l <= r; l++) {
        var y = [],
          w = l / r;
        for (s = 0; s <= t; s++) {
          var x = s / t;
          d.x = -e * Math.cos(n + x * i) * Math.sin(a + w * o), d.y = e * Math.cos(a + w * o), d.z = e * Math.sin(n + x * i) * Math.sin(a + w * o), g.push(d.x, d.y, d.z), p.set(d.x, d.y, d.z).normalize(), v.push(p.x, p.y, p.z), b.push(x, 1 - w), y.push(h++);
        }
        f.push(y);
      }
      for (l = 0; l < r; l++) for (s = 0; s < t; s++) {
        var _ = f[l][s + 1],
          S = f[l][s],
          C = f[l + 1][s],
          E = f[l + 1][s + 1];
        (0 !== l || a > 0) && m.push(_, S, E), (l !== r - 1 || c < Math.PI) && m.push(S, C, E);
      }
      this.setIndex(m), this.addAttribute("position", new Se(g, 3)), this.addAttribute("normal", new Se(v, 3)), this.addAttribute("uv", new Se(b, 2));
    }
    function lr(e, t, r, n, i, a) {
      ke.call(this), this.type = "RingGeometry", this.parameters = {
        innerRadius: e,
        outerRadius: t,
        thetaSegments: r,
        phiSegments: n,
        thetaStart: i,
        thetaLength: a
      }, this.fromBufferGeometry(new cr(e, t, r, n, i, a)), this.mergeVertices();
    }
    function cr(e, t, r, n, a, o) {
      Re.call(this), this.type = "RingBufferGeometry", this.parameters = {
        innerRadius: e,
        outerRadius: t,
        thetaSegments: r,
        phiSegments: n,
        thetaStart: a,
        thetaLength: o
      }, e = e || 20, t = t || 50, a = void 0 !== a ? a : 0, o = void 0 !== o ? o : 2 * Math.PI, r = void 0 !== r ? Math.max(3, r) : 8, n = void 0 !== n ? Math.max(1, n) : 1;
      var s,
        l,
        c,
        h = [],
        f = [],
        d = [],
        p = [],
        m = e,
        g = (t - e) / n,
        v = new u(),
        b = new i();
      for (l = 0; l <= n; l++) {
        for (c = 0; c <= r; c++) s = a + c / r * o, v.x = m * Math.cos(s), v.y = m * Math.sin(s), f.push(v.x, v.y, v.z), d.push(0, 0, 1), b.x = (v.x / t + 1) / 2, b.y = (v.y / t + 1) / 2, p.push(b.x, b.y);
        m += g;
      }
      for (l = 0; l < n; l++) {
        var y = l * (r + 1);
        for (c = 0; c < r; c++) {
          s = c + y;
          var w = s,
            x = s + r + 1,
            _ = s + r + 2,
            S = s + 1;
          h.push(w, x, S), h.push(x, _, S);
        }
      }
      this.setIndex(h), this.addAttribute("position", new Se(f, 3)), this.addAttribute("normal", new Se(d, 3)), this.addAttribute("uv", new Se(p, 2));
    }
    function ur(e, t, r, n) {
      ke.call(this), this.type = "LatheGeometry", this.parameters = {
        points: e,
        segments: t,
        phiStart: r,
        phiLength: n
      }, this.fromBufferGeometry(new hr(e, t, r, n)), this.mergeVertices();
    }
    function hr(e, t, r, n) {
      Re.call(this), this.type = "LatheBufferGeometry", this.parameters = {
        points: e,
        segments: t,
        phiStart: r,
        phiLength: n
      }, t = Math.floor(t) || 12, r = r || 0, n = n || 2 * Math.PI, n = Ss.clamp(n, 0, 2 * Math.PI);
      var a,
        o,
        s,
        l = [],
        c = [],
        h = [],
        f = 1 / t,
        d = new u(),
        p = new i();
      for (o = 0; o <= t; o++) {
        var m = r + o * f * n,
          g = Math.sin(m),
          v = Math.cos(m);
        for (s = 0; s <= e.length - 1; s++) d.x = e[s].x * g, d.y = e[s].y, d.z = e[s].x * v, c.push(d.x, d.y, d.z), p.x = o / t, p.y = s / (e.length - 1), h.push(p.x, p.y);
      }
      for (o = 0; o < t; o++) for (s = 0; s < e.length - 1; s++) {
        a = s + o * e.length;
        var b = a,
          y = a + e.length,
          w = a + e.length + 1,
          x = a + 1;
        l.push(b, y, x), l.push(y, w, x);
      }
      if (this.setIndex(l), this.addAttribute("position", new Se(c, 3)), this.addAttribute("uv", new Se(h, 2)), this.computeVertexNormals(), n === 2 * Math.PI) {
        var _ = this.attributes.normal.array,
          S = new u(),
          C = new u(),
          E = new u();
        for (a = t * e.length * 3, o = 0, s = 0; o < e.length; o++, s += 3) S.x = _[s + 0], S.y = _[s + 1], S.z = _[s + 2], C.x = _[a + s + 0], C.y = _[a + s + 1], C.z = _[a + s + 2], E.addVectors(S, C).normalize(), _[s + 0] = _[a + s + 0] = E.x, _[s + 1] = _[a + s + 1] = E.y, _[s + 2] = _[a + s + 2] = E.z;
      }
    }
    function fr(e, t) {
      ke.call(this), this.type = "ShapeGeometry", "object" == _typeof(t) && (console.warn("THREE.ShapeGeometry: Options parameter has been removed."), t = t.curveSegments), this.parameters = {
        shapes: e,
        curveSegments: t
      }, this.fromBufferGeometry(new dr(e, t)), this.mergeVertices();
    }
    function dr(e, t) {
      function r(e) {
        var r,
          s,
          c,
          u = i.length / 3,
          h = e.extractPoints(t),
          f = h.shape,
          d = h.holes;
        if (!1 === zs.isClockWise(f)) for (f = f.reverse(), r = 0, s = d.length; r < s; r++) c = d[r], !0 === zs.isClockWise(c) && (d[r] = c.reverse());
        var p = zs.triangulateShape(f, d);
        for (r = 0, s = d.length; r < s; r++) c = d[r], f = f.concat(c);
        for (r = 0, s = f.length; r < s; r++) {
          var m = f[r];
          i.push(m.x, m.y, 0), a.push(0, 0, 1), o.push(m.x, m.y);
        }
        for (r = 0, s = p.length; r < s; r++) {
          var g = p[r],
            v = g[0] + u,
            b = g[1] + u,
            y = g[2] + u;
          n.push(v, b, y), l += 3;
        }
      }
      Re.call(this), this.type = "ShapeBufferGeometry", this.parameters = {
        shapes: e,
        curveSegments: t
      }, t = t || 12;
      var n = [],
        i = [],
        a = [],
        o = [],
        s = 0,
        l = 0;
      if (!1 === Array.isArray(e)) r(e);else for (var c = 0; c < e.length; c++) r(e[c]), this.addGroup(s, l, c), s += l, l = 0;
      this.setIndex(n), this.addAttribute("position", new Se(i, 3)), this.addAttribute("normal", new Se(a, 3)), this.addAttribute("uv", new Se(o, 2));
    }
    function pr(e, t) {
      Re.call(this), this.type = "EdgesGeometry", this.parameters = {
        thresholdAngle: t
      }, t = void 0 !== t ? t : 1;
      var r,
        n,
        i,
        a,
        o = [],
        s = Math.cos(Ss.DEG2RAD * t),
        l = [0, 0],
        c = {},
        u = ["a", "b", "c"];
      e.isBufferGeometry ? (a = new ke(), a.fromBufferGeometry(e)) : a = e.clone(), a.mergeVertices(), a.computeFaceNormals();
      for (var h = a.vertices, f = a.faces, d = 0, p = f.length; d < p; d++) for (var m = f[d], g = 0; g < 3; g++) r = m[u[g]], n = m[u[(g + 1) % 3]], l[0] = Math.min(r, n), l[1] = Math.max(r, n), i = l[0] + "," + l[1], void 0 === c[i] ? c[i] = {
        index1: l[0],
        index2: l[1],
        face1: d,
        face2: void 0
      } : c[i].face2 = d;
      for (i in c) {
        var v = c[i];
        if (void 0 === v.face2 || f[v.face1].normal.dot(f[v.face2].normal) <= s) {
          var b = h[v.index1];
          o.push(b.x, b.y, b.z), b = h[v.index2], o.push(b.x, b.y, b.z);
        }
      }
      this.addAttribute("position", new Se(o, 3));
    }
    function mr(e, t, r, n, i, a, o, s) {
      ke.call(this), this.type = "CylinderGeometry", this.parameters = {
        radiusTop: e,
        radiusBottom: t,
        height: r,
        radialSegments: n,
        heightSegments: i,
        openEnded: a,
        thetaStart: o,
        thetaLength: s
      }, this.fromBufferGeometry(new gr(e, t, r, n, i, a, o, s)), this.mergeVertices();
    }
    function gr(e, t, r, n, a, o, s, l) {
      function c(r) {
        var a,
          o,
          c,
          v = new i(),
          w = new u(),
          x = 0,
          _ = !0 === r ? e : t,
          S = !0 === r ? 1 : -1;
        for (o = g, a = 1; a <= n; a++) d.push(0, b * S, 0), p.push(0, S, 0), m.push(.5, .5), g++;
        for (c = g, a = 0; a <= n; a++) {
          var C = a / n,
            E = C * l + s,
            A = Math.cos(E),
            T = Math.sin(E);
          w.x = _ * T, w.y = b * S, w.z = _ * A, d.push(w.x, w.y, w.z), p.push(0, S, 0), v.x = .5 * A + .5, v.y = .5 * T * S + .5, m.push(v.x, v.y), g++;
        }
        for (a = 0; a < n; a++) {
          var k = o + a,
            R = c + a;
          !0 === r ? f.push(R, R + 1, k) : f.push(R + 1, R, k), x += 3;
        }
        h.addGroup(y, x, !0 === r ? 1 : 2), y += x;
      }
      Re.call(this), this.type = "CylinderBufferGeometry", this.parameters = {
        radiusTop: e,
        radiusBottom: t,
        height: r,
        radialSegments: n,
        heightSegments: a,
        openEnded: o,
        thetaStart: s,
        thetaLength: l
      };
      var h = this;
      e = void 0 !== e ? e : 20, t = void 0 !== t ? t : 20, r = void 0 !== r ? r : 100, n = Math.floor(n) || 8, a = Math.floor(a) || 1, o = void 0 !== o && o, s = void 0 !== s ? s : 0, l = void 0 !== l ? l : 2 * Math.PI;
      var f = [],
        d = [],
        p = [],
        m = [],
        g = 0,
        v = [],
        b = r / 2,
        y = 0;
      !function () {
        var i,
          o,
          c = new u(),
          w = new u(),
          x = 0,
          _ = (t - e) / r;
        for (o = 0; o <= a; o++) {
          var S = [],
            C = o / a,
            E = C * (t - e) + e;
          for (i = 0; i <= n; i++) {
            var A = i / n,
              T = A * l + s,
              k = Math.sin(T),
              R = Math.cos(T);
            w.x = E * k, w.y = -C * r + b, w.z = E * R, d.push(w.x, w.y, w.z), c.set(k, _, R).normalize(), p.push(c.x, c.y, c.z), m.push(A, 1 - C), S.push(g++);
          }
          v.push(S);
        }
        for (i = 0; i < n; i++) for (o = 0; o < a; o++) {
          var I = v[o][i],
            M = v[o + 1][i],
            O = v[o + 1][i + 1],
            P = v[o][i + 1];
          f.push(I, M, P), f.push(M, O, P), x += 6;
        }
        h.addGroup(y, x, 0), y += x;
      }(), !1 === o && (e > 0 && c(!0), t > 0 && c(!1)), this.setIndex(f), this.addAttribute("position", new Se(d, 3)), this.addAttribute("normal", new Se(p, 3)), this.addAttribute("uv", new Se(m, 2));
    }
    function vr(e, t, r, n, i, a, o) {
      mr.call(this, 0, e, t, r, n, i, a, o), this.type = "ConeGeometry", this.parameters = {
        radius: e,
        height: t,
        radialSegments: r,
        heightSegments: n,
        openEnded: i,
        thetaStart: a,
        thetaLength: o
      };
    }
    function br(e, t, r, n, i, a, o) {
      gr.call(this, 0, e, t, r, n, i, a, o), this.type = "ConeBufferGeometry", this.parameters = {
        radius: e,
        height: t,
        radialSegments: r,
        heightSegments: n,
        openEnded: i,
        thetaStart: a,
        thetaLength: o
      };
    }
    function yr(e, t, r, n) {
      ke.call(this), this.type = "CircleGeometry", this.parameters = {
        radius: e,
        segments: t,
        thetaStart: r,
        thetaLength: n
      }, this.fromBufferGeometry(new wr(e, t, r, n)), this.mergeVertices();
    }
    function wr(e, t, r, n) {
      Re.call(this), this.type = "CircleBufferGeometry", this.parameters = {
        radius: e,
        segments: t,
        thetaStart: r,
        thetaLength: n
      }, e = e || 50, t = void 0 !== t ? Math.max(3, t) : 8, r = void 0 !== r ? r : 0, n = void 0 !== n ? n : 2 * Math.PI;
      var a,
        o,
        s = [],
        l = [],
        c = [],
        h = [],
        f = new u(),
        d = new i();
      for (l.push(0, 0, 0), c.push(0, 0, 1), h.push(.5, .5), o = 0, a = 3; o <= t; o++, a += 3) {
        var p = r + o / t * n;
        f.x = e * Math.cos(p), f.y = e * Math.sin(p), l.push(f.x, f.y, f.z), c.push(0, 0, 1), d.x = (l[a] / e + 1) / 2, d.y = (l[a + 1] / e + 1) / 2, h.push(d.x, d.y);
      }
      for (a = 1; a <= t; a++) s.push(a, a + 1, 0);
      this.setIndex(s), this.addAttribute("position", new Se(l, 3)), this.addAttribute("normal", new Se(c, 3)), this.addAttribute("uv", new Se(h, 2));
    }
    function xr(e) {
      $.call(this, {
        uniforms: Bs.merge([Ps.lights, {
          opacity: {
            value: 1
          }
        }]),
        vertexShader: Ds.shadow_vert,
        fragmentShader: Ds.shadow_frag
      }), this.lights = !0, this.transparent = !0, Object.defineProperties(this, {
        opacity: {
          enumerable: !0,
          get: function get() {
            return this.uniforms.opacity.value;
          },
          set: function set(e) {
            this.uniforms.opacity.value = e;
          }
        }
      }), this.setValues(e);
    }
    function _r(e) {
      $.call(this, e), this.type = "RawShaderMaterial";
    }
    function Sr(e) {
      Q.call(this), this.defines = {
        STANDARD: ""
      }, this.type = "MeshStandardMaterial", this.color = new Y(16777215), this.roughness = .5, this.metalness = .5, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Y(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalScale = new i(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
    }
    function Cr(e) {
      Sr.call(this), this.defines = {
        PHYSICAL: ""
      }, this.type = "MeshPhysicalMaterial", this.reflectivity = .5, this.clearCoat = 0, this.clearCoatRoughness = 0, this.setValues(e);
    }
    function Er(e) {
      Q.call(this), this.type = "MeshPhongMaterial", this.color = new Y(16777215), this.specular = new Y(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Y(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalScale = new i(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = eo, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
    }
    function Ar(e) {
      Er.call(this), this.defines = {
        TOON: ""
      }, this.type = "MeshToonMaterial", this.gradientMap = null, this.setValues(e);
    }
    function Tr(e) {
      Q.call(this, e), this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalScale = new i(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
    }
    function kr(e) {
      Q.call(this), this.type = "MeshLambertMaterial", this.color = new Y(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Y(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = eo, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.skinning = !1, this.morphTargets = !1, this.morphNormals = !1, this.setValues(e);
    }
    function Rr(e) {
      Q.call(this), this.type = "LineDashedMaterial", this.color = new Y(16777215), this.linewidth = 1, this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.lights = !1, this.setValues(e);
    }
    function Ir(e, t, r) {
      var n = this,
        i = !1,
        a = 0,
        o = 0;
      this.onStart = void 0, this.onLoad = e, this.onProgress = t, this.onError = r, this.itemStart = function (e) {
        o++, !1 === i && void 0 !== n.onStart && n.onStart(e, a, o), i = !0;
      }, this.itemEnd = function (e) {
        a++, void 0 !== n.onProgress && n.onProgress(e, a, o), a === o && (i = !1, void 0 !== n.onLoad && n.onLoad());
      }, this.itemError = function (e) {
        void 0 !== n.onError && n.onError(e);
      };
    }
    function Mr(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Or(e) {
      this.manager = void 0 !== e ? e : qs, this._parser = null;
    }
    function Pr(e) {
      this.manager = void 0 !== e ? e : qs, this._parser = null;
    }
    function Br(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Dr(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Lr(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Fr(e, t) {
      ue.call(this), this.type = "Light", this.color = new Y(e), this.intensity = void 0 !== t ? t : 1, this.receiveShadow = void 0;
    }
    function Nr(e, t, r) {
      Fr.call(this, e, r), this.type = "HemisphereLight", this.castShadow = void 0, this.position.copy(ue.DefaultUp), this.updateMatrix(), this.groundColor = new Y(t);
    }
    function Ur(e) {
      this.camera = e, this.bias = 0, this.radius = 1, this.mapSize = new i(512, 512), this.map = null, this.matrix = new h();
    }
    function jr() {
      Ur.call(this, new Le(50, 1, .5, 500));
    }
    function zr(e, t, r, n, i, a) {
      Fr.call(this, e, t), this.type = "SpotLight", this.position.copy(ue.DefaultUp), this.updateMatrix(), this.target = new ue(), Object.defineProperty(this, "power", {
        get: function get() {
          return this.intensity * Math.PI;
        },
        set: function set(e) {
          this.intensity = e / Math.PI;
        }
      }), this.distance = void 0 !== r ? r : 0, this.angle = void 0 !== n ? n : Math.PI / 3, this.penumbra = void 0 !== i ? i : 0, this.decay = void 0 !== a ? a : 1, this.shadow = new jr();
    }
    function Hr(e, t, r, n) {
      Fr.call(this, e, t), this.type = "PointLight", Object.defineProperty(this, "power", {
        get: function get() {
          return 4 * this.intensity * Math.PI;
        },
        set: function set(e) {
          this.intensity = e / (4 * Math.PI);
        }
      }), this.distance = void 0 !== r ? r : 0, this.decay = void 0 !== n ? n : 1, this.shadow = new Ur(new Le(90, 1, .5, 500));
    }
    function Gr() {
      Ur.call(this, new Fe(-5, 5, 5, -5, .5, 500));
    }
    function Vr(e, t) {
      Fr.call(this, e, t), this.type = "DirectionalLight", this.position.copy(ue.DefaultUp), this.updateMatrix(), this.target = new ue(), this.shadow = new Gr();
    }
    function qr(e, t) {
      Fr.call(this, e, t), this.type = "AmbientLight", this.castShadow = void 0;
    }
    function Wr(e, t, r, n) {
      Fr.call(this, e, t), this.type = "RectAreaLight", this.position.set(0, 1, 0), this.updateMatrix(), this.width = void 0 !== r ? r : 10, this.height = void 0 !== n ? n : 10;
    }
    function Xr(e, t, r, n) {
      this.parameterPositions = e, this._cachedIndex = 0, this.resultBuffer = void 0 !== n ? n : new t.constructor(r), this.sampleValues = t, this.valueSize = r;
    }
    function Yr(e, t, r, n) {
      Xr.call(this, e, t, r, n), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0;
    }
    function Kr(e, t, r, n) {
      Xr.call(this, e, t, r, n);
    }
    function Zr(e, t, r, n) {
      Xr.call(this, e, t, r, n);
    }
    function Jr(e, t, r, n) {
      if (void 0 === e) throw new Error("track name is undefined");
      if (void 0 === t || 0 === t.length) throw new Error("no keyframes in track named " + e);
      this.name = e, this.times = Ws.convertArray(t, this.TimeBufferType), this.values = Ws.convertArray(r, this.ValueBufferType), this.setInterpolation(n || this.DefaultInterpolation), this.validate(), this.optimize();
    }
    function Qr(e, t, r, n) {
      Jr.call(this, e, t, r, n);
    }
    function $r(e, t, r, n) {
      Xr.call(this, e, t, r, n);
    }
    function en(e, t, r, n) {
      Jr.call(this, e, t, r, n);
    }
    function tn(e, t, r, n) {
      Jr.call(this, e, t, r, n);
    }
    function rn(e, t, r, n) {
      Jr.call(this, e, t, r, n);
    }
    function nn(e, t, r) {
      Jr.call(this, e, t, r);
    }
    function an(e, t, r, n) {
      Jr.call(this, e, t, r, n);
    }
    function on(e, t, r, n) {
      Jr.apply(this, arguments);
    }
    function sn(e, t, r) {
      this.name = e, this.tracks = r, this.duration = void 0 !== t ? t : -1, this.uuid = Ss.generateUUID(), this.duration < 0 && this.resetDuration(), this.optimize();
    }
    function ln(e) {
      this.manager = void 0 !== e ? e : qs, this.textures = {};
    }
    function cn(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function un() {
      this.onLoadStart = function () {}, this.onLoadProgress = function () {}, this.onLoadComplete = function () {};
    }
    function hn(e) {
      "boolean" == typeof e && (console.warn("THREE.JSONLoader: showStatus parameter has been removed from constructor."), e = void 0), this.manager = void 0 !== e ? e : qs, this.withCredentials = !1;
    }
    function fn(e) {
      this.manager = void 0 !== e ? e : qs, this.texturePath = "";
    }
    function dn(e, t, r, n, i) {
      var a = .5 * (n - t),
        o = .5 * (i - r),
        s = e * e;
      return (2 * r - 2 * n + a + o) * (e * s) + (-3 * r + 3 * n - 2 * a - o) * s + a * e + r;
    }
    function pn(e, t) {
      var r = 1 - e;
      return r * r * t;
    }
    function mn(e, t) {
      return 2 * (1 - e) * e * t;
    }
    function gn(e, t) {
      return e * e * t;
    }
    function vn(e, t, r, n) {
      return pn(e, t) + mn(e, r) + gn(e, n);
    }
    function bn(e, t) {
      var r = 1 - e;
      return r * r * r * t;
    }
    function yn(e, t) {
      var r = 1 - e;
      return 3 * r * r * e * t;
    }
    function wn(e, t) {
      return 3 * (1 - e) * e * e * t;
    }
    function xn(e, t) {
      return e * e * e * t;
    }
    function _n(e, t, r, n, i) {
      return bn(e, t) + yn(e, r) + wn(e, n) + xn(e, i);
    }
    function Sn() {
      this.arcLengthDivisions = 200;
    }
    function Cn(e, t) {
      Sn.call(this), this.v1 = e, this.v2 = t;
    }
    function En() {
      Sn.call(this), this.curves = [], this.autoClose = !1;
    }
    function An(e, t, r, n, i, a, o, s) {
      Sn.call(this), this.aX = e, this.aY = t, this.xRadius = r, this.yRadius = n, this.aStartAngle = i, this.aEndAngle = a, this.aClockwise = o, this.aRotation = s || 0;
    }
    function Tn(e) {
      Sn.call(this), this.points = void 0 === e ? [] : e;
    }
    function kn(e, t, r, n) {
      Sn.call(this), this.v0 = e, this.v1 = t, this.v2 = r, this.v3 = n;
    }
    function Rn(e, t, r) {
      Sn.call(this), this.v0 = e, this.v1 = t, this.v2 = r;
    }
    function In(e) {
      En.call(this), this.currentPoint = new i(), e && this.fromPoints(e);
    }
    function Mn() {
      In.apply(this, arguments), this.holes = [];
    }
    function On() {
      this.subPaths = [], this.currentPath = null;
    }
    function Pn(e) {
      this.data = e;
    }
    function Bn(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Dn(e) {
      this.manager = void 0 !== e ? e : qs;
    }
    function Ln() {
      this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new Le(), this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new Le(), this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1;
    }
    function Fn(e, t, r) {
      ue.call(this), this.type = "CubeCamera";
      var n = new Le(90, 1, e, t);
      n.up.set(0, -1, 0), n.lookAt(new u(1, 0, 0)), this.add(n);
      var i = new Le(90, 1, e, t);
      i.up.set(0, -1, 0), i.lookAt(new u(-1, 0, 0)), this.add(i);
      var a = new Le(90, 1, e, t);
      a.up.set(0, 0, 1), a.lookAt(new u(0, 1, 0)), this.add(a);
      var o = new Le(90, 1, e, t);
      o.up.set(0, 0, -1), o.lookAt(new u(0, -1, 0)), this.add(o);
      var s = new Le(90, 1, e, t);
      s.up.set(0, -1, 0), s.lookAt(new u(0, 0, 1)), this.add(s);
      var c = new Le(90, 1, e, t);
      c.up.set(0, -1, 0), c.lookAt(new u(0, 0, -1)), this.add(c);
      var h = {
        format: Uo,
        magFilter: So,
        minFilter: So
      };
      this.renderTarget = new l(r, r, h), this.renderTarget.texture.name = "CubeCamera", this.updateCubeMap = function (e, t) {
        null === this.parent && this.updateMatrixWorld();
        var r = this.renderTarget,
          l = r.texture.generateMipmaps;
        r.texture.generateMipmaps = !1, r.activeCubeFace = 0, e.render(t, n, r), r.activeCubeFace = 1, e.render(t, i, r), r.activeCubeFace = 2, e.render(t, a, r), r.activeCubeFace = 3, e.render(t, o, r), r.activeCubeFace = 4, e.render(t, s, r), r.texture.generateMipmaps = l, r.activeCubeFace = 5, e.render(t, c, r), e.setRenderTarget(null);
      };
    }
    function Nn(e) {
      Le.call(this), this.enabled = !1, this.cameras = e || [];
    }
    function Un() {
      ue.call(this), this.type = "AudioListener", this.context = el.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null;
    }
    function jn(e) {
      ue.call(this), this.type = "Audio", this.context = e.context, this.gain = this.context.createGain(), this.gain.connect(e.getInput()), this.autoplay = !1, this.buffer = null, this.loop = !1, this.startTime = 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.sourceType = "empty", this.filters = [];
    }
    function zn(e) {
      jn.call(this, e), this.panner = this.context.createPanner(), this.panner.connect(this.gain);
    }
    function Hn(e, t) {
      this.analyser = e.context.createAnalyser(), this.analyser.fftSize = void 0 !== t ? t : 2048, this.data = new Uint8Array(this.analyser.frequencyBinCount), e.getOutput().connect(this.analyser);
    }
    function Gn(e, t, r) {
      this.binding = e, this.valueSize = r;
      var n,
        i = Float64Array;
      switch (t) {
        case "quaternion":
          n = this._slerp;
          break;
        case "string":
        case "bool":
          i = Array, n = this._select;
          break;
        default:
          n = this._lerp;
      }
      this.buffer = new i(4 * r), this._mixBufferRegion = n, this.cumulativeWeight = 0, this.useCount = 0, this.referenceCount = 0;
    }
    function Vn(e, t, r) {
      var n = r || qn.parseTrackName(t);
      this._targetGroup = e, this._bindings = e.subscribe_(t, n);
    }
    function qn(e, t, r) {
      this.path = t, this.parsedPath = r || qn.parseTrackName(t), this.node = qn.findNode(e, this.parsedPath.nodeName) || e, this.rootNode = e;
    }
    function Wn(e) {
      this.uuid = Ss.generateUUID(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
      var t = {};
      this._indicesByUUID = t;
      for (var r = 0, n = arguments.length; r !== n; ++r) t[arguments[r].uuid] = r;
      this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
      var i = this;
      this.stats = {
        objects: {
          get total() {
            return i._objects.length;
          },
          get inUse() {
            return this.total - i.nCachedObjects_;
          }
        },
        get bindingsPerObject() {
          return i._bindings.length;
        }
      };
    }
    function Xn(e, t, r) {
      this._mixer = e, this._clip = t, this._localRoot = r || null;
      for (var n = t.tracks, i = n.length, a = new Array(i), o = {
          endingStart: ss,
          endingEnd: ss
        }, s = 0; s !== i; ++s) {
        var l = n[s].createInterpolant(null);
        a[s] = l, l.settings = o;
      }
      this._interpolantSettings = o, this._interpolants = a, this._propertyBindings = new Array(i), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = rs, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
    }
    function Yn(e) {
      this._root = e, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
    }
    function Kn(e) {
      "string" == typeof e && (console.warn("THREE.Uniform: Type parameter is no longer needed."), e = arguments[1]), this.value = e;
    }
    function Zn() {
      Re.call(this), this.type = "InstancedBufferGeometry", this.maxInstancedCount = void 0;
    }
    function Jn(e, t, r, n) {
      this.uuid = Ss.generateUUID(), this.data = e, this.itemSize = t, this.offset = r, this.normalized = !0 === n;
    }
    function Qn(e, t) {
      this.uuid = Ss.generateUUID(), this.array = e, this.stride = t, this.count = void 0 !== e ? e.length / t : 0, this.dynamic = !1, this.updateRange = {
        offset: 0,
        count: -1
      }, this.onUploadCallback = function () {}, this.version = 0;
    }
    function $n(e, t, r) {
      Qn.call(this, e, t), this.meshPerAttribute = r || 1;
    }
    function ei(e, t, r) {
      me.call(this, e, t), this.meshPerAttribute = r || 1;
    }
    function ti(e, t, r, n) {
      this.ray = new se(e, t), this.near = r || 0, this.far = n || 1 / 0, this.params = {
        Mesh: {},
        Line: {},
        LOD: {},
        Points: {
          threshold: 1
        },
        Sprite: {}
      }, Object.defineProperties(this.params, {
        PointCloud: {
          get: function get() {
            return console.warn("THREE.Raycaster: params.PointCloud has been renamed to params.Points."), this.Points;
          }
        }
      });
    }
    function ri(e, t) {
      return e.distance - t.distance;
    }
    function ni(e, t, r, n) {
      if (!1 !== e.visible && (e.raycast(t, r), !0 === n)) for (var i = e.children, a = 0, o = i.length; a < o; a++) ni(i[a], t, r, !0);
    }
    function ii(e) {
      this.autoStart = void 0 === e || e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    function ai(e, t, r) {
      return this.radius = void 0 !== e ? e : 1, this.phi = void 0 !== t ? t : 0, this.theta = void 0 !== r ? r : 0, this;
    }
    function oi(e, t, r) {
      return this.radius = void 0 !== e ? e : 1, this.theta = void 0 !== t ? t : 0, this.y = void 0 !== r ? r : 0, this;
    }
    function si(e, t) {
      Ie.call(this, e, t), this.animationsMap = {}, this.animationsList = [];
      var r = this.geometry.morphTargets.length,
        n = r - 1,
        i = r / 1;
      this.createAnimation("__default", 0, n, i), this.setAnimationWeight("__default", 1);
    }
    function li(e) {
      ue.call(this), this.material = e, this.render = function (e) {};
    }
    function ci(e, t, r, n) {
      this.object = e, this.size = void 0 !== t ? t : 1;
      var i = void 0 !== r ? r : 16711680,
        a = void 0 !== n ? n : 1,
        o = 0,
        s = this.object.geometry;
      s && s.isGeometry ? o = 3 * s.faces.length : s && s.isBufferGeometry && (o = s.attributes.normal.count);
      var l = new Re(),
        c = new Se(2 * o * 3, 3);
      l.addAttribute("position", c), kt.call(this, l, new At({
        color: i,
        linewidth: a
      })), this.matrixAutoUpdate = !1, this.update();
    }
    function ui(e) {
      ue.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
      for (var t = new Re(), r = [0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, -1, 1], n = 0, i = 1; n < 32; n++, i++) {
        var a = n / 32 * Math.PI * 2,
          o = i / 32 * Math.PI * 2;
        r.push(Math.cos(a), Math.sin(a), 1, Math.cos(o), Math.sin(o), 1);
      }
      t.addAttribute("position", new Se(r, 3));
      var s = new At({
        fog: !1
      });
      this.cone = new kt(t, s), this.add(this.cone), this.update();
    }
    function hi(e) {
      this.bones = this.getBoneList(e);
      for (var t = new Re(), r = [], n = [], i = new Y(0, 0, 1), a = new Y(0, 1, 0), o = 0; o < this.bones.length; o++) {
        var s = this.bones[o];
        s.parent && s.parent.isBone && (r.push(0, 0, 0), r.push(0, 0, 0), n.push(i.r, i.g, i.b), n.push(a.r, a.g, a.b));
      }
      t.addAttribute("position", new Se(r, 3)), t.addAttribute("color", new Se(n, 3));
      var l = new At({
        vertexColors: Sa,
        depthTest: !1,
        depthWrite: !1,
        transparent: !0
      });
      kt.call(this, t, l), this.root = e, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    function fi(e, t) {
      this.light = e, this.light.updateMatrixWorld();
      var r = new sr(t, 4, 2),
        n = new pe({
          wireframe: !0,
          fog: !1
        });
      n.color.copy(this.light.color), Ie.call(this, r, n), this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1;
    }
    function di(e) {
      ue.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
      var t = new At({
          color: e.color
        }),
        r = new Re();
      r.addAttribute("position", new me(new Float32Array(15), 3)), this.add(new Tt(r, t)), this.update();
    }
    function pi(e, t) {
      ue.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
      var r = new qt(t);
      r.rotateY(.5 * Math.PI);
      var n = new pe({
          vertexColors: Sa,
          wireframe: !0
        }),
        i = r.getAttribute("position"),
        a = new Float32Array(3 * i.count);
      r.addAttribute("color", new me(a, 3)), this.add(new Ie(r, n)), this.update();
    }
    function mi(e, t, r, n) {
      e = e || 10, t = t || 10, r = new Y(void 0 !== r ? r : 4473924), n = new Y(void 0 !== n ? n : 8947848);
      for (var i = t / 2, a = e / t, o = e / 2, s = [], l = [], c = 0, u = 0, h = -o; c <= t; c++, h += a) {
        s.push(-o, 0, h, o, 0, h), s.push(h, 0, -o, h, 0, o);
        var f = c === i ? r : n;
        f.toArray(l, u), u += 3, f.toArray(l, u), u += 3, f.toArray(l, u), u += 3, f.toArray(l, u), u += 3;
      }
      var d = new Re();
      d.addAttribute("position", new Se(s, 3)), d.addAttribute("color", new Se(l, 3));
      var p = new At({
        vertexColors: Sa
      });
      kt.call(this, d, p);
    }
    function gi(e, t, r, n, i, a) {
      e = e || 10, t = t || 16, r = r || 8, n = n || 64, i = new Y(void 0 !== i ? i : 4473924), a = new Y(void 0 !== a ? a : 8947848);
      var o,
        s,
        l,
        c,
        u,
        h,
        f,
        d = [],
        p = [];
      for (c = 0; c <= t; c++) l = c / t * (2 * Math.PI), o = Math.sin(l) * e, s = Math.cos(l) * e, d.push(0, 0, 0), d.push(o, 0, s), f = 1 & c ? i : a, p.push(f.r, f.g, f.b), p.push(f.r, f.g, f.b);
      for (c = 0; c <= r; c++) for (f = 1 & c ? i : a, h = e - e / r * c, u = 0; u < n; u++) l = u / n * (2 * Math.PI), o = Math.sin(l) * h, s = Math.cos(l) * h, d.push(o, 0, s), p.push(f.r, f.g, f.b), l = (u + 1) / n * (2 * Math.PI), o = Math.sin(l) * h, s = Math.cos(l) * h, d.push(o, 0, s), p.push(f.r, f.g, f.b);
      var m = new Re();
      m.addAttribute("position", new Se(d, 3)), m.addAttribute("color", new Se(p, 3));
      var g = new At({
        vertexColors: Sa
      });
      kt.call(this, m, g);
    }
    function vi(e, t, r, n) {
      this.object = e, this.size = void 0 !== t ? t : 1;
      var i = void 0 !== r ? r : 16776960,
        a = void 0 !== n ? n : 1,
        o = 0,
        s = this.object.geometry;
      s && s.isGeometry ? o = s.faces.length : console.warn("THREE.FaceNormalsHelper: only THREE.Geometry is supported. Use THREE.VertexNormalsHelper, instead.");
      var l = new Re(),
        c = new Se(2 * o * 3, 3);
      l.addAttribute("position", c), kt.call(this, l, new At({
        color: i,
        linewidth: a
      })), this.matrixAutoUpdate = !1, this.update();
    }
    function bi(e, t) {
      ue.call(this), this.light = e, this.light.updateMatrixWorld(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, void 0 === t && (t = 1);
      var r = new Re();
      r.addAttribute("position", new Se([-t, t, 0, t, t, 0, t, -t, 0, -t, -t, 0, -t, t, 0], 3));
      var n = new At({
        fog: !1
      });
      this.add(new Tt(r, n)), r = new Re(), r.addAttribute("position", new Se([0, 0, 0, 0, 0, 1], 3)), this.add(new Tt(r, n)), this.update();
    }
    function yi(e) {
      function t(e, t, n) {
        r(e, n), r(t, n);
      }
      function r(e, t) {
        a.push(0, 0, 0), o.push(t.r, t.g, t.b), void 0 === s[e] && (s[e] = []), s[e].push(a.length / 3 - 1);
      }
      var n = new Re(),
        i = new At({
          color: 16777215,
          vertexColors: _a
        }),
        a = [],
        o = [],
        s = {},
        l = new Y(16755200),
        c = new Y(16711680),
        u = new Y(43775),
        h = new Y(16777215),
        f = new Y(3355443);
      t("n1", "n2", l), t("n2", "n4", l), t("n4", "n3", l), t("n3", "n1", l), t("f1", "f2", l), t("f2", "f4", l), t("f4", "f3", l), t("f3", "f1", l), t("n1", "f1", l), t("n2", "f2", l), t("n3", "f3", l), t("n4", "f4", l), t("p", "n1", c), t("p", "n2", c), t("p", "n3", c), t("p", "n4", c), t("u1", "u2", u), t("u2", "u3", u), t("u3", "u1", u), t("c", "t", h), t("p", "c", f), t("cn1", "cn2", f), t("cn3", "cn4", f), t("cf1", "cf2", f), t("cf3", "cf4", f), n.addAttribute("position", new Se(a, 3)), n.addAttribute("color", new Se(o, 3)), kt.call(this, n, i), this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = s, this.update();
    }
    function wi(e, t) {
      this.object = e, void 0 === t && (t = 16776960);
      var r = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]),
        n = new Float32Array(24),
        i = new Re();
      i.setIndex(new me(r, 1)), i.addAttribute("position", new me(n, 3)), kt.call(this, i, new At({
        color: t
      })), this.matrixAutoUpdate = !1, this.update();
    }
    function xi(e, t, r, n, i, a) {
      ue.call(this), void 0 === n && (n = 16776960), void 0 === r && (r = 1), void 0 === i && (i = .2 * r), void 0 === a && (a = .2 * i), void 0 === tl && (tl = new Re(), tl.addAttribute("position", new Se([0, 0, 0, 0, 1, 0], 3)), rl = new gr(0, .5, 1, 5, 1), rl.translate(0, -.5, 0)), this.position.copy(t), this.line = new Tt(tl, new At({
        color: n
      })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Ie(rl, new pe({
        color: n
      })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(e), this.setLength(r, i, a);
    }
    function _i(e) {
      e = e || 1;
      var t = [0, 0, 0, e, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 0, 0, e],
        r = [1, 0, 0, 1, .6, 0, 0, 1, 0, .6, 1, 0, 0, 0, 1, 0, .6, 1],
        n = new Re();
      n.addAttribute("position", new Se(t, 3)), n.addAttribute("color", new Se(r, 3));
      var i = new At({
        vertexColors: Sa
      });
      kt.call(this, n, i);
    }
    function Si() {
      function e(e, a, o, s) {
        t = e, r = o, n = -3 * e + 3 * a - 2 * o - s, i = 2 * e - 2 * a + o + s;
      }
      var t = 0,
        r = 0,
        n = 0,
        i = 0;
      return {
        initCatmullRom: function initCatmullRom(t, r, n, i, a) {
          e(r, n, a * (n - t), a * (i - r));
        },
        initNonuniformCatmullRom: function initNonuniformCatmullRom(t, r, n, i, a, o, s) {
          var l = (r - t) / a - (n - t) / (a + o) + (n - r) / o,
            c = (n - r) / o - (i - r) / (o + s) + (i - n) / s;
          l *= o, c *= o, e(r, n, l, c);
        },
        calc: function calc(e) {
          var a = e * e;
          return t + r * e + n * a + i * (a * e);
        }
      };
    }
    function Ci(e) {
      Sn.call(this), this.points = e || [], this.closed = !1;
    }
    function Ei(e, t, r, n) {
      Sn.call(this), this.v0 = e, this.v1 = t, this.v2 = r, this.v3 = n;
    }
    function Ai(e, t, r) {
      Sn.call(this), this.v0 = e, this.v1 = t, this.v2 = r;
    }
    function Ti(e, t) {
      Sn.call(this), this.v1 = e, this.v2 = t;
    }
    function ki(e, t, r, n, i, a) {
      An.call(this, e, t, r, r, n, i, a);
    }
    function Ri(e, t, r, n, i, a, o) {
      return console.warn("THREE.Face4 has been removed. A THREE.Face3 will be created instead."), new de(e, t, r, i, a, o);
    }
    function Ii(e) {
      return console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead."), e;
    }
    function Mi(e) {
      return void 0 === e && (e = []), console.warn("THREE.MultiMaterial has been removed. Use an Array instead."), e.isMultiMaterial = !0, e.materials = e, e.clone = function () {
        return e.slice();
      }, e;
    }
    function Oi(e, t) {
      return console.warn("THREE.PointCloud has been renamed to THREE.Points."), new Mt(e, t);
    }
    function Pi(e) {
      return console.warn("THREE.Particle has been renamed to THREE.Sprite."), new xt(e);
    }
    function Bi(e, t) {
      return console.warn("THREE.ParticleSystem has been renamed to THREE.Points."), new Mt(e, t);
    }
    function Di(e) {
      return console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial."), new It(e);
    }
    function Li(e) {
      return console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial."), new It(e);
    }
    function Fi(e) {
      return console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial."), new It(e);
    }
    function Ni(e, t, r) {
      return console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead."), new u(e, t, r);
    }
    function Ui(e, t) {
      return console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setDynamic( true ) instead."), new me(e, t).setDynamic(!0);
    }
    function ji(e, t) {
      return console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead."), new ge(e, t);
    }
    function zi(e, t) {
      return console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead."), new ve(e, t);
    }
    function Hi(e, t) {
      return console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead."), new be(e, t);
    }
    function Gi(e, t) {
      return console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead."), new ye(e, t);
    }
    function Vi(e, t) {
      return console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead."), new we(e, t);
    }
    function qi(e, t) {
      return console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead."), new xe(e, t);
    }
    function Wi(e, t) {
      return console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead."), new _e(e, t);
    }
    function Xi(e, t) {
      return console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead."), new Se(e, t);
    }
    function Yi(e, t) {
      return console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead."), new Ce(e, t);
    }
    function Ki(e) {
      console.warn("THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead."), Ci.call(this, e), this.type = "catmullrom", this.closed = !0;
    }
    function Zi(e) {
      console.warn("THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead."), Ci.call(this, e), this.type = "catmullrom";
    }
    function Ji(e) {
      console.warn("THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead."), Ci.call(this, e), this.type = "catmullrom";
    }
    function Qi(e, t) {
      return console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead."), new wi(e, t);
    }
    function $i(e, t) {
      return console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead."), new kt(new pr(e.geometry), new At({
        color: void 0 !== t ? t : 16777215
      }));
    }
    function ea(e, t) {
      return console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead."), new kt(new Ft(e.geometry), new At({
        color: void 0 !== t ? t : 16777215
      }));
    }
    function ta(e) {
      return console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader."), new Mr(e);
    }
    function ra(e) {
      return console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader."), new Pr(e);
    }
    function na() {
      console.error("THREE.Projector has been moved to /examples/js/renderers/Projector.js."), this.projectVector = function (e, t) {
        console.warn("THREE.Projector: .projectVector() is now vector.project()."), e.project(t);
      }, this.unprojectVector = function (e, t) {
        console.warn("THREE.Projector: .unprojectVector() is now vector.unproject()."), e.unproject(t);
      }, this.pickingRay = function () {
        console.error("THREE.Projector: .pickingRay() is now raycaster.setFromCamera().");
      };
    }
    function ia() {
      console.error("THREE.CanvasRenderer has been moved to /examples/js/renderers/CanvasRenderer.js"), this.domElement = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"), this.clear = function () {}, this.render = function () {}, this.setClearColor = function () {}, this.setSize = function () {};
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r.d(t, "WebGLRenderTargetCube", function () {
      return l;
    }), r.d(t, "WebGLRenderTarget", function () {
      return s;
    }), r.d(t, "WebGLRenderer", function () {
      return mt;
    }), r.d(t, "ShaderLib", function () {
      return Ls;
    }), r.d(t, "UniformsLib", function () {
      return Ps;
    }), r.d(t, "UniformsUtils", function () {
      return Bs;
    }), r.d(t, "ShaderChunk", function () {
      return Ds;
    }), r.d(t, "FogExp2", function () {
      return gt;
    }), r.d(t, "Fog", function () {
      return vt;
    }), r.d(t, "Scene", function () {
      return bt;
    }), r.d(t, "LensFlare", function () {
      return yt;
    }), r.d(t, "Sprite", function () {
      return xt;
    }), r.d(t, "LOD", function () {
      return _t;
    }), r.d(t, "SkinnedMesh", function () {
      return Et;
    }), r.d(t, "Skeleton", function () {
      return St;
    }), r.d(t, "Bone", function () {
      return Ct;
    }), r.d(t, "Mesh", function () {
      return Ie;
    }), r.d(t, "LineSegments", function () {
      return kt;
    }), r.d(t, "LineLoop", function () {
      return Rt;
    }), r.d(t, "Line", function () {
      return Tt;
    }), r.d(t, "Points", function () {
      return Mt;
    }), r.d(t, "Group", function () {
      return Ot;
    }), r.d(t, "VideoTexture", function () {
      return Pt;
    }), r.d(t, "DataTexture", function () {
      return f;
    }), r.d(t, "CompressedTexture", function () {
      return Bt;
    }), r.d(t, "CubeTexture", function () {
      return d;
    }), r.d(t, "CanvasTexture", function () {
      return Dt;
    }), r.d(t, "DepthTexture", function () {
      return Lt;
    }), r.d(t, "Texture", function () {
      return a;
    }), r.d(t, "CompressedTextureLoader", function () {
      return Or;
    }), r.d(t, "DataTextureLoader", function () {
      return Pr;
    }), r.d(t, "CubeTextureLoader", function () {
      return Dr;
    }), r.d(t, "TextureLoader", function () {
      return Lr;
    }), r.d(t, "ObjectLoader", function () {
      return fn;
    }), r.d(t, "MaterialLoader", function () {
      return ln;
    }), r.d(t, "BufferGeometryLoader", function () {
      return cn;
    }), r.d(t, "DefaultLoadingManager", function () {
      return qs;
    }), r.d(t, "LoadingManager", function () {
      return Ir;
    }), r.d(t, "JSONLoader", function () {
      return hn;
    }), r.d(t, "ImageLoader", function () {
      return Br;
    }), r.d(t, "FontLoader", function () {
      return Bn;
    }), r.d(t, "FileLoader", function () {
      return Mr;
    }), r.d(t, "Loader", function () {
      return un;
    }), r.d(t, "Cache", function () {
      return Vs;
    }), r.d(t, "AudioLoader", function () {
      return Dn;
    }), r.d(t, "SpotLightShadow", function () {
      return jr;
    }), r.d(t, "SpotLight", function () {
      return zr;
    }), r.d(t, "PointLight", function () {
      return Hr;
    }), r.d(t, "RectAreaLight", function () {
      return Wr;
    }), r.d(t, "HemisphereLight", function () {
      return Nr;
    }), r.d(t, "DirectionalLightShadow", function () {
      return Gr;
    }), r.d(t, "DirectionalLight", function () {
      return Vr;
    }), r.d(t, "AmbientLight", function () {
      return qr;
    }), r.d(t, "LightShadow", function () {
      return Ur;
    }), r.d(t, "Light", function () {
      return Fr;
    }), r.d(t, "StereoCamera", function () {
      return Ln;
    }), r.d(t, "PerspectiveCamera", function () {
      return Le;
    }), r.d(t, "OrthographicCamera", function () {
      return Fe;
    }), r.d(t, "CubeCamera", function () {
      return Fn;
    }), r.d(t, "ArrayCamera", function () {
      return Nn;
    }), r.d(t, "Camera", function () {
      return De;
    }), r.d(t, "AudioListener", function () {
      return Un;
    }), r.d(t, "PositionalAudio", function () {
      return zn;
    }), r.d(t, "AudioContext", function () {
      return el;
    }), r.d(t, "AudioAnalyser", function () {
      return Hn;
    }), r.d(t, "Audio", function () {
      return jn;
    }), r.d(t, "VectorKeyframeTrack", function () {
      return Qr;
    }), r.d(t, "StringKeyframeTrack", function () {
      return rn;
    }), r.d(t, "QuaternionKeyframeTrack", function () {
      return en;
    }), r.d(t, "NumberKeyframeTrack", function () {
      return tn;
    }), r.d(t, "ColorKeyframeTrack", function () {
      return an;
    }), r.d(t, "BooleanKeyframeTrack", function () {
      return nn;
    }), r.d(t, "PropertyMixer", function () {
      return Gn;
    }), r.d(t, "PropertyBinding", function () {
      return qn;
    }), r.d(t, "KeyframeTrack", function () {
      return on;
    }), r.d(t, "AnimationUtils", function () {
      return Ws;
    }), r.d(t, "AnimationObjectGroup", function () {
      return Wn;
    }), r.d(t, "AnimationMixer", function () {
      return Yn;
    }), r.d(t, "AnimationClip", function () {
      return sn;
    }), r.d(t, "Uniform", function () {
      return Kn;
    }), r.d(t, "InstancedBufferGeometry", function () {
      return Zn;
    }), r.d(t, "BufferGeometry", function () {
      return Re;
    }), r.d(t, "GeometryIdCount", function () {
      return Te;
    }), r.d(t, "Geometry", function () {
      return ke;
    }), r.d(t, "InterleavedBufferAttribute", function () {
      return Jn;
    }), r.d(t, "InstancedInterleavedBuffer", function () {
      return $n;
    }), r.d(t, "InterleavedBuffer", function () {
      return Qn;
    }), r.d(t, "InstancedBufferAttribute", function () {
      return ei;
    }), r.d(t, "Face3", function () {
      return de;
    }), r.d(t, "Object3D", function () {
      return ue;
    }), r.d(t, "Raycaster", function () {
      return ti;
    }), r.d(t, "Layers", function () {
      return ce;
    }), r.d(t, "EventDispatcher", function () {
      return n;
    }), r.d(t, "Clock", function () {
      return ii;
    }), r.d(t, "QuaternionLinearInterpolant", function () {
      return $r;
    }), r.d(t, "LinearInterpolant", function () {
      return Kr;
    }), r.d(t, "DiscreteInterpolant", function () {
      return Zr;
    }), r.d(t, "CubicInterpolant", function () {
      return Yr;
    }), r.d(t, "Interpolant", function () {
      return Xr;
    }), r.d(t, "Triangle", function () {
      return fe;
    }), r.d(t, "Math", function () {
      return Ss;
    }), r.d(t, "Spherical", function () {
      return ai;
    }), r.d(t, "Cylindrical", function () {
      return oi;
    }), r.d(t, "Plane", function () {
      return ie;
    }), r.d(t, "Frustum", function () {
      return ae;
    }), r.d(t, "Sphere", function () {
      return re;
    }), r.d(t, "Ray", function () {
      return se;
    }), r.d(t, "Matrix4", function () {
      return h;
    }), r.d(t, "Matrix3", function () {
      return ne;
    }), r.d(t, "Box3", function () {
      return te;
    }), r.d(t, "Box2", function () {
      return K;
    }), r.d(t, "Line3", function () {
      return he;
    }), r.d(t, "Euler", function () {
      return le;
    }), r.d(t, "Vector4", function () {
      return o;
    }), r.d(t, "Vector3", function () {
      return u;
    }), r.d(t, "Vector2", function () {
      return i;
    }), r.d(t, "Quaternion", function () {
      return c;
    }), r.d(t, "Color", function () {
      return Y;
    }), r.d(t, "MorphBlendMesh", function () {
      return si;
    }), r.d(t, "ImmediateRenderObject", function () {
      return li;
    }), r.d(t, "VertexNormalsHelper", function () {
      return ci;
    }), r.d(t, "SpotLightHelper", function () {
      return ui;
    }), r.d(t, "SkeletonHelper", function () {
      return hi;
    }), r.d(t, "PointLightHelper", function () {
      return fi;
    }), r.d(t, "RectAreaLightHelper", function () {
      return di;
    }), r.d(t, "HemisphereLightHelper", function () {
      return pi;
    }), r.d(t, "GridHelper", function () {
      return mi;
    }), r.d(t, "PolarGridHelper", function () {
      return gi;
    }), r.d(t, "FaceNormalsHelper", function () {
      return vi;
    }), r.d(t, "DirectionalLightHelper", function () {
      return bi;
    }), r.d(t, "CameraHelper", function () {
      return yi;
    }), r.d(t, "BoxHelper", function () {
      return wi;
    }), r.d(t, "ArrowHelper", function () {
      return xi;
    }), r.d(t, "AxisHelper", function () {
      return _i;
    }), r.d(t, "CatmullRomCurve3", function () {
      return Ci;
    }), r.d(t, "CubicBezierCurve3", function () {
      return Ei;
    }), r.d(t, "QuadraticBezierCurve3", function () {
      return Ai;
    }), r.d(t, "LineCurve3", function () {
      return Ti;
    }), r.d(t, "ArcCurve", function () {
      return ki;
    }), r.d(t, "EllipseCurve", function () {
      return An;
    }), r.d(t, "SplineCurve", function () {
      return Tn;
    }), r.d(t, "CubicBezierCurve", function () {
      return kn;
    }), r.d(t, "QuadraticBezierCurve", function () {
      return Rn;
    }), r.d(t, "LineCurve", function () {
      return Cn;
    }), r.d(t, "Shape", function () {
      return Mn;
    }), r.d(t, "Path", function () {
      return In;
    }), r.d(t, "ShapePath", function () {
      return On;
    }), r.d(t, "Font", function () {
      return Pn;
    }), r.d(t, "CurvePath", function () {
      return En;
    }), r.d(t, "Curve", function () {
      return Sn;
    }), r.d(t, "ShapeUtils", function () {
      return zs;
    }), r.d(t, "SceneUtils", function () {
      return sl;
    }), r.d(t, "WireframeGeometry", function () {
      return Ft;
    }), r.d(t, "ParametricGeometry", function () {
      return Nt;
    }), r.d(t, "ParametricBufferGeometry", function () {
      return Ut;
    }), r.d(t, "TetrahedronGeometry", function () {
      return Ht;
    }), r.d(t, "TetrahedronBufferGeometry", function () {
      return Gt;
    }), r.d(t, "OctahedronGeometry", function () {
      return Vt;
    }), r.d(t, "OctahedronBufferGeometry", function () {
      return qt;
    }), r.d(t, "IcosahedronGeometry", function () {
      return Wt;
    }), r.d(t, "IcosahedronBufferGeometry", function () {
      return Xt;
    }), r.d(t, "DodecahedronGeometry", function () {
      return Yt;
    }), r.d(t, "DodecahedronBufferGeometry", function () {
      return Kt;
    }), r.d(t, "PolyhedronGeometry", function () {
      return jt;
    }), r.d(t, "PolyhedronBufferGeometry", function () {
      return zt;
    }), r.d(t, "TubeGeometry", function () {
      return Zt;
    }), r.d(t, "TubeBufferGeometry", function () {
      return Jt;
    }), r.d(t, "TorusKnotGeometry", function () {
      return Qt;
    }), r.d(t, "TorusKnotBufferGeometry", function () {
      return $t;
    }), r.d(t, "TorusGeometry", function () {
      return er;
    }), r.d(t, "TorusBufferGeometry", function () {
      return tr;
    }), r.d(t, "TextGeometry", function () {
      return ir;
    }), r.d(t, "TextBufferGeometry", function () {
      return ar;
    }), r.d(t, "SphereGeometry", function () {
      return or;
    }), r.d(t, "SphereBufferGeometry", function () {
      return sr;
    }), r.d(t, "RingGeometry", function () {
      return lr;
    }), r.d(t, "RingBufferGeometry", function () {
      return cr;
    }), r.d(t, "PlaneGeometry", function () {
      return Pe;
    }), r.d(t, "PlaneBufferGeometry", function () {
      return Be;
    }), r.d(t, "LatheGeometry", function () {
      return ur;
    }), r.d(t, "LatheBufferGeometry", function () {
      return hr;
    }), r.d(t, "ShapeGeometry", function () {
      return fr;
    }), r.d(t, "ShapeBufferGeometry", function () {
      return dr;
    }), r.d(t, "ExtrudeGeometry", function () {
      return rr;
    }), r.d(t, "ExtrudeBufferGeometry", function () {
      return nr;
    }), r.d(t, "EdgesGeometry", function () {
      return pr;
    }), r.d(t, "ConeGeometry", function () {
      return vr;
    }), r.d(t, "ConeBufferGeometry", function () {
      return br;
    }), r.d(t, "CylinderGeometry", function () {
      return mr;
    }), r.d(t, "CylinderBufferGeometry", function () {
      return gr;
    }), r.d(t, "CircleGeometry", function () {
      return yr;
    }), r.d(t, "CircleBufferGeometry", function () {
      return wr;
    }), r.d(t, "BoxGeometry", function () {
      return Me;
    }), r.d(t, "BoxBufferGeometry", function () {
      return Oe;
    }), r.d(t, "ShadowMaterial", function () {
      return xr;
    }), r.d(t, "SpriteMaterial", function () {
      return wt;
    }), r.d(t, "RawShaderMaterial", function () {
      return _r;
    }), r.d(t, "ShaderMaterial", function () {
      return $;
    }), r.d(t, "PointsMaterial", function () {
      return It;
    });
    r.d(t, "MeshPhysicalMaterial", function () {
      return Cr;
    }), r.d(t, "MeshStandardMaterial", function () {
      return Sr;
    }), r.d(t, "MeshPhongMaterial", function () {
      return Er;
    }), r.d(t, "MeshToonMaterial", function () {
      return Ar;
    }), r.d(t, "MeshNormalMaterial", function () {
      return Tr;
    }), r.d(t, "MeshLambertMaterial", function () {
      return kr;
    }), r.d(t, "MeshDepthMaterial", function () {
      return ee;
    }), r.d(t, "MeshBasicMaterial", function () {
      return pe;
    }), r.d(t, "LineDashedMaterial", function () {
      return Rr;
    }), r.d(t, "LineBasicMaterial", function () {
      return At;
    }), r.d(t, "Material", function () {
      return Q;
    }), r.d(t, "Float64BufferAttribute", function () {
      return Ce;
    }), r.d(t, "Float32BufferAttribute", function () {
      return Se;
    }), r.d(t, "Uint32BufferAttribute", function () {
      return _e;
    }), r.d(t, "Int32BufferAttribute", function () {
      return xe;
    }), r.d(t, "Uint16BufferAttribute", function () {
      return we;
    }), r.d(t, "Int16BufferAttribute", function () {
      return ye;
    }), r.d(t, "Uint8ClampedBufferAttribute", function () {
      return be;
    }), r.d(t, "Uint8BufferAttribute", function () {
      return ve;
    }), r.d(t, "Int8BufferAttribute", function () {
      return ge;
    }), r.d(t, "BufferAttribute", function () {
      return me;
    }), r.d(t, "REVISION", function () {
      return aa;
    }), r.d(t, "MOUSE", function () {
      return oa;
    }), r.d(t, "CullFaceNone", function () {
      return sa;
    }), r.d(t, "CullFaceBack", function () {
      return la;
    }), r.d(t, "CullFaceFront", function () {
      return ca;
    }), r.d(t, "CullFaceFrontBack", function () {
      return ua;
    }), r.d(t, "FrontFaceDirectionCW", function () {
      return ha;
    }), r.d(t, "FrontFaceDirectionCCW", function () {
      return fa;
    }), r.d(t, "BasicShadowMap", function () {
      return da;
    }), r.d(t, "PCFShadowMap", function () {
      return pa;
    }), r.d(t, "PCFSoftShadowMap", function () {
      return ma;
    }), r.d(t, "FrontSide", function () {
      return ga;
    }), r.d(t, "BackSide", function () {
      return va;
    }), r.d(t, "DoubleSide", function () {
      return ba;
    }), r.d(t, "FlatShading", function () {
      return ya;
    }), r.d(t, "SmoothShading", function () {
      return wa;
    }), r.d(t, "NoColors", function () {
      return xa;
    }), r.d(t, "FaceColors", function () {
      return _a;
    }), r.d(t, "VertexColors", function () {
      return Sa;
    }), r.d(t, "NoBlending", function () {
      return Ca;
    }), r.d(t, "NormalBlending", function () {
      return Ea;
    }), r.d(t, "AdditiveBlending", function () {
      return Aa;
    }), r.d(t, "SubtractiveBlending", function () {
      return Ta;
    }), r.d(t, "MultiplyBlending", function () {
      return ka;
    }), r.d(t, "CustomBlending", function () {
      return Ra;
    }), r.d(t, "AddEquation", function () {
      return Ia;
    }), r.d(t, "SubtractEquation", function () {
      return Ma;
    }), r.d(t, "ReverseSubtractEquation", function () {
      return Oa;
    }), r.d(t, "MinEquation", function () {
      return Pa;
    }), r.d(t, "MaxEquation", function () {
      return Ba;
    }), r.d(t, "ZeroFactor", function () {
      return Da;
    }), r.d(t, "OneFactor", function () {
      return La;
    }), r.d(t, "SrcColorFactor", function () {
      return Fa;
    }), r.d(t, "OneMinusSrcColorFactor", function () {
      return Na;
    }), r.d(t, "SrcAlphaFactor", function () {
      return Ua;
    }), r.d(t, "OneMinusSrcAlphaFactor", function () {
      return ja;
    }), r.d(t, "DstAlphaFactor", function () {
      return za;
    }), r.d(t, "OneMinusDstAlphaFactor", function () {
      return Ha;
    }), r.d(t, "DstColorFactor", function () {
      return Ga;
    }), r.d(t, "OneMinusDstColorFactor", function () {
      return Va;
    }), r.d(t, "SrcAlphaSaturateFactor", function () {
      return qa;
    }), r.d(t, "NeverDepth", function () {
      return Wa;
    }), r.d(t, "AlwaysDepth", function () {
      return Xa;
    }), r.d(t, "LessDepth", function () {
      return Ya;
    }), r.d(t, "LessEqualDepth", function () {
      return Ka;
    }), r.d(t, "EqualDepth", function () {
      return Za;
    }), r.d(t, "GreaterEqualDepth", function () {
      return Ja;
    }), r.d(t, "GreaterDepth", function () {
      return Qa;
    }), r.d(t, "NotEqualDepth", function () {
      return $a;
    }), r.d(t, "MultiplyOperation", function () {
      return eo;
    }), r.d(t, "MixOperation", function () {
      return to;
    }), r.d(t, "AddOperation", function () {
      return ro;
    }), r.d(t, "NoToneMapping", function () {
      return no;
    }), r.d(t, "LinearToneMapping", function () {
      return io;
    }), r.d(t, "ReinhardToneMapping", function () {
      return ao;
    }), r.d(t, "Uncharted2ToneMapping", function () {
      return oo;
    }), r.d(t, "CineonToneMapping", function () {
      return so;
    }), r.d(t, "UVMapping", function () {
      return lo;
    }), r.d(t, "CubeReflectionMapping", function () {
      return co;
    }), r.d(t, "CubeRefractionMapping", function () {
      return uo;
    }), r.d(t, "EquirectangularReflectionMapping", function () {
      return ho;
    }), r.d(t, "EquirectangularRefractionMapping", function () {
      return fo;
    }), r.d(t, "SphericalReflectionMapping", function () {
      return po;
    }), r.d(t, "CubeUVReflectionMapping", function () {
      return mo;
    }), r.d(t, "CubeUVRefractionMapping", function () {
      return go;
    }), r.d(t, "RepeatWrapping", function () {
      return vo;
    }), r.d(t, "ClampToEdgeWrapping", function () {
      return bo;
    }), r.d(t, "MirroredRepeatWrapping", function () {
      return yo;
    }), r.d(t, "NearestFilter", function () {
      return wo;
    }), r.d(t, "NearestMipMapNearestFilter", function () {
      return xo;
    }), r.d(t, "NearestMipMapLinearFilter", function () {
      return _o;
    }), r.d(t, "LinearFilter", function () {
      return So;
    }), r.d(t, "LinearMipMapNearestFilter", function () {
      return Co;
    }), r.d(t, "LinearMipMapLinearFilter", function () {
      return Eo;
    }), r.d(t, "UnsignedByteType", function () {
      return Ao;
    }), r.d(t, "ByteType", function () {
      return To;
    }), r.d(t, "ShortType", function () {
      return ko;
    }), r.d(t, "UnsignedShortType", function () {
      return Ro;
    }), r.d(t, "IntType", function () {
      return Io;
    }), r.d(t, "UnsignedIntType", function () {
      return Mo;
    }), r.d(t, "FloatType", function () {
      return Oo;
    }), r.d(t, "HalfFloatType", function () {
      return Po;
    }), r.d(t, "UnsignedShort4444Type", function () {
      return Bo;
    }), r.d(t, "UnsignedShort5551Type", function () {
      return Do;
    }), r.d(t, "UnsignedShort565Type", function () {
      return Lo;
    }), r.d(t, "UnsignedInt248Type", function () {
      return Fo;
    }), r.d(t, "AlphaFormat", function () {
      return No;
    }), r.d(t, "RGBFormat", function () {
      return Uo;
    }), r.d(t, "RGBAFormat", function () {
      return jo;
    }), r.d(t, "LuminanceFormat", function () {
      return zo;
    }), r.d(t, "LuminanceAlphaFormat", function () {
      return Ho;
    }), r.d(t, "RGBEFormat", function () {
      return Go;
    }), r.d(t, "DepthFormat", function () {
      return Vo;
    }), r.d(t, "DepthStencilFormat", function () {
      return qo;
    }), r.d(t, "RGB_S3TC_DXT1_Format", function () {
      return Wo;
    }), r.d(t, "RGBA_S3TC_DXT1_Format", function () {
      return Xo;
    }), r.d(t, "RGBA_S3TC_DXT3_Format", function () {
      return Yo;
    }), r.d(t, "RGBA_S3TC_DXT5_Format", function () {
      return Ko;
    }), r.d(t, "RGB_PVRTC_4BPPV1_Format", function () {
      return Zo;
    }), r.d(t, "RGB_PVRTC_2BPPV1_Format", function () {
      return Jo;
    }), r.d(t, "RGBA_PVRTC_4BPPV1_Format", function () {
      return Qo;
    }), r.d(t, "RGBA_PVRTC_2BPPV1_Format", function () {
      return $o;
    }), r.d(t, "RGB_ETC1_Format", function () {
      return es;
    }), r.d(t, "LoopOnce", function () {
      return ts;
    }), r.d(t, "LoopRepeat", function () {
      return rs;
    }), r.d(t, "LoopPingPong", function () {
      return ns;
    }), r.d(t, "InterpolateDiscrete", function () {
      return is;
    }), r.d(t, "InterpolateLinear", function () {
      return as;
    }), r.d(t, "InterpolateSmooth", function () {
      return os;
    }), r.d(t, "ZeroCurvatureEnding", function () {
      return ss;
    }), r.d(t, "ZeroSlopeEnding", function () {
      return ls;
    }), r.d(t, "WrapAroundEnding", function () {
      return cs;
    }), r.d(t, "TrianglesDrawMode", function () {
      return us;
    }), r.d(t, "TriangleStripDrawMode", function () {
      return hs;
    }), r.d(t, "TriangleFanDrawMode", function () {
      return fs;
    }), r.d(t, "LinearEncoding", function () {
      return ds;
    }), r.d(t, "sRGBEncoding", function () {
      return ps;
    }), r.d(t, "GammaEncoding", function () {
      return ms;
    }), r.d(t, "RGBEEncoding", function () {
      return gs;
    }), r.d(t, "LogLuvEncoding", function () {
      return vs;
    }), r.d(t, "RGBM7Encoding", function () {
      return bs;
    }), r.d(t, "RGBM16Encoding", function () {
      return ys;
    }), r.d(t, "RGBDEncoding", function () {
      return ws;
    }), r.d(t, "BasicDepthPacking", function () {
      return xs;
    }), r.d(t, "RGBADepthPacking", function () {
      return _s;
    }), r.d(t, "CubeGeometry", function () {
      return Me;
    }), r.d(t, "Face4", function () {
      return Ri;
    }), r.d(t, "LineStrip", function () {
      return ll;
    }), r.d(t, "LinePieces", function () {
      return cl;
    }), r.d(t, "MeshFaceMaterial", function () {
      return Ii;
    }), r.d(t, "MultiMaterial", function () {
      return Mi;
    }), r.d(t, "PointCloud", function () {
      return Oi;
    }), r.d(t, "Particle", function () {
      return Pi;
    }), r.d(t, "ParticleSystem", function () {
      return Bi;
    }), r.d(t, "PointCloudMaterial", function () {
      return Di;
    }), r.d(t, "ParticleBasicMaterial", function () {
      return Li;
    }), r.d(t, "ParticleSystemMaterial", function () {
      return Fi;
    }), r.d(t, "Vertex", function () {
      return Ni;
    }), r.d(t, "DynamicBufferAttribute", function () {
      return Ui;
    }), r.d(t, "Int8Attribute", function () {
      return ji;
    }), r.d(t, "Uint8Attribute", function () {
      return zi;
    }), r.d(t, "Uint8ClampedAttribute", function () {
      return Hi;
    }), r.d(t, "Int16Attribute", function () {
      return Gi;
    }), r.d(t, "Uint16Attribute", function () {
      return Vi;
    }), r.d(t, "Int32Attribute", function () {
      return qi;
    }), r.d(t, "Uint32Attribute", function () {
      return Wi;
    }), r.d(t, "Float32Attribute", function () {
      return Xi;
    }), r.d(t, "Float64Attribute", function () {
      return Yi;
    }), r.d(t, "ClosedSplineCurve3", function () {
      return Ki;
    }), r.d(t, "SplineCurve3", function () {
      return Zi;
    }), r.d(t, "Spline", function () {
      return Ji;
    }), r.d(t, "BoundingBoxHelper", function () {
      return Qi;
    }), r.d(t, "EdgesHelper", function () {
      return $i;
    }), r.d(t, "WireframeHelper", function () {
      return ea;
    }), r.d(t, "XHRLoader", function () {
      return ta;
    }), r.d(t, "BinaryTextureLoader", function () {
      return ra;
    }), r.d(t, "GeometryUtils", function () {
      return ul;
    }), r.d(t, "ImageUtils", function () {
      return hl;
    }), r.d(t, "Projector", function () {
      return na;
    }), r.d(t, "CanvasRenderer", function () {
      return ia;
    }), void 0 === Number.EPSILON && (Number.EPSILON = Math.pow(2, -52)), void 0 === Number.isInteger && (Number.isInteger = function (e) {
      return "number" == typeof e && isFinite(e) && Math.floor(e) === e;
    }), void 0 === Math.sign && (Math.sign = function (e) {
      return e < 0 ? -1 : e > 0 ? 1 : +e;
    }), void 0 === Function.prototype.name && Object.defineProperty(Function.prototype, "name", {
      get: function get() {
        return this.toString().match(/^\s*function\s*([^\(\s]*)/)[1];
      }
    }), void 0 === Object.assign && function () {
      Object.assign = function (e) {
        if (void 0 === e || null === e) throw new TypeError("Cannot convert undefined or null to object");
        for (var t = Object(e), r = 1; r < arguments.length; r++) {
          var n = arguments[r];
          if (void 0 !== n && null !== n) for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
        }
        return t;
      };
    }(), Object.assign(n.prototype, {
      addEventListener: function addEventListener(e, t) {
        void 0 === this._listeners && (this._listeners = {});
        var r = this._listeners;
        void 0 === r[e] && (r[e] = []), -1 === r[e].indexOf(t) && r[e].push(t);
      },
      hasEventListener: function hasEventListener(e, t) {
        if (void 0 === this._listeners) return !1;
        var r = this._listeners;
        return void 0 !== r[e] && -1 !== r[e].indexOf(t);
      },
      removeEventListener: function removeEventListener(e, t) {
        if (void 0 !== this._listeners) {
          var r = this._listeners,
            n = r[e];
          if (void 0 !== n) {
            var i = n.indexOf(t);
            -1 !== i && n.splice(i, 1);
          }
        }
      },
      dispatchEvent: function dispatchEvent(e) {
        if (void 0 !== this._listeners) {
          var t = this._listeners,
            r = t[e.type];
          if (void 0 !== r) {
            e.target = this;
            var n = [],
              i = 0,
              a = r.length;
            for (i = 0; i < a; i++) n[i] = r[i];
            for (i = 0; i < a; i++) n[i].call(this, e);
          }
        }
      }
    });
    var aa = "85",
      oa = {
        LEFT: 0,
        MIDDLE: 1,
        RIGHT: 2
      },
      sa = 0,
      la = 1,
      ca = 2,
      ua = 3,
      ha = 0,
      fa = 1,
      da = 0,
      pa = 1,
      ma = 2,
      ga = 0,
      va = 1,
      ba = 2,
      ya = 1,
      wa = 2,
      xa = 0,
      _a = 1,
      Sa = 2,
      Ca = 0,
      Ea = 1,
      Aa = 2,
      Ta = 3,
      ka = 4,
      Ra = 5,
      Ia = 100,
      Ma = 101,
      Oa = 102,
      Pa = 103,
      Ba = 104,
      Da = 200,
      La = 201,
      Fa = 202,
      Na = 203,
      Ua = 204,
      ja = 205,
      za = 206,
      Ha = 207,
      Ga = 208,
      Va = 209,
      qa = 210,
      Wa = 0,
      Xa = 1,
      Ya = 2,
      Ka = 3,
      Za = 4,
      Ja = 5,
      Qa = 6,
      $a = 7,
      eo = 0,
      to = 1,
      ro = 2,
      no = 0,
      io = 1,
      ao = 2,
      oo = 3,
      so = 4,
      lo = 300,
      co = 301,
      uo = 302,
      ho = 303,
      fo = 304,
      po = 305,
      mo = 306,
      go = 307,
      vo = 1e3,
      bo = 1001,
      yo = 1002,
      wo = 1003,
      xo = 1004,
      _o = 1005,
      So = 1006,
      Co = 1007,
      Eo = 1008,
      Ao = 1009,
      To = 1010,
      ko = 1011,
      Ro = 1012,
      Io = 1013,
      Mo = 1014,
      Oo = 1015,
      Po = 1016,
      Bo = 1017,
      Do = 1018,
      Lo = 1019,
      Fo = 1020,
      No = 1021,
      Uo = 1022,
      jo = 1023,
      zo = 1024,
      Ho = 1025,
      Go = jo,
      Vo = 1026,
      qo = 1027,
      Wo = 2001,
      Xo = 2002,
      Yo = 2003,
      Ko = 2004,
      Zo = 2100,
      Jo = 2101,
      Qo = 2102,
      $o = 2103,
      es = 2151,
      ts = 2200,
      rs = 2201,
      ns = 2202,
      is = 2300,
      as = 2301,
      os = 2302,
      ss = 2400,
      ls = 2401,
      cs = 2402,
      us = 0,
      hs = 1,
      fs = 2,
      ds = 3e3,
      ps = 3001,
      ms = 3007,
      gs = 3002,
      vs = 3003,
      bs = 3004,
      ys = 3005,
      ws = 3006,
      xs = 3200,
      _s = 3201,
      Ss = {
        DEG2RAD: Math.PI / 180,
        RAD2DEG: 180 / Math.PI,
        generateUUID: function () {
          var e,
            t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(""),
            r = new Array(36),
            n = 0;
          return function () {
            for (var i = 0; i < 36; i++) 8 === i || 13 === i || 18 === i || 23 === i ? r[i] = "-" : 14 === i ? r[i] = "4" : (n <= 2 && (n = 33554432 + 16777216 * Math.random() | 0), e = 15 & n, n >>= 4, r[i] = t[19 === i ? 3 & e | 8 : e]);
            return r.join("");
          };
        }(),
        clamp: function clamp(e, t, r) {
          return Math.max(t, Math.min(r, e));
        },
        euclideanModulo: function euclideanModulo(e, t) {
          return (e % t + t) % t;
        },
        mapLinear: function mapLinear(e, t, r, n, i) {
          return n + (e - t) * (i - n) / (r - t);
        },
        lerp: function lerp(e, t, r) {
          return (1 - r) * e + r * t;
        },
        smoothstep: function smoothstep(e, t, r) {
          return e <= t ? 0 : e >= r ? 1 : (e = (e - t) / (r - t)) * e * (3 - 2 * e);
        },
        smootherstep: function smootherstep(e, t, r) {
          return e <= t ? 0 : e >= r ? 1 : (e = (e - t) / (r - t)) * e * e * (e * (6 * e - 15) + 10);
        },
        randInt: function randInt(e, t) {
          return e + Math.floor(Math.random() * (t - e + 1));
        },
        randFloat: function randFloat(e, t) {
          return e + Math.random() * (t - e);
        },
        randFloatSpread: function randFloatSpread(e) {
          return e * (.5 - Math.random());
        },
        degToRad: function degToRad(e) {
          return e * Ss.DEG2RAD;
        },
        radToDeg: function radToDeg(e) {
          return e * Ss.RAD2DEG;
        },
        isPowerOfTwo: function isPowerOfTwo(e) {
          return 0 == (e & e - 1) && 0 !== e;
        },
        nearestPowerOfTwo: function nearestPowerOfTwo(e) {
          return Math.pow(2, Math.round(Math.log(e) / Math.LN2));
        },
        nextPowerOfTwo: function nextPowerOfTwo(e) {
          return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, ++e;
        }
      };
    Object.defineProperties(i.prototype, {
      width: {
        get: function get() {
          return this.x;
        },
        set: function set(e) {
          this.x = e;
        }
      },
      height: {
        get: function get() {
          return this.y;
        },
        set: function set(e) {
          this.y = e;
        }
      }
    }), Object.assign(i.prototype, {
      isVector2: !0,
      set: function set(e, t) {
        return this.x = e, this.y = t, this;
      },
      setScalar: function setScalar(e) {
        return this.x = e, this.y = e, this;
      },
      setX: function setX(e) {
        return this.x = e, this;
      },
      setY: function setY(e) {
        return this.y = e, this;
      },
      setComponent: function setComponent(e, t) {
        switch (e) {
          case 0:
            this.x = t;
            break;
          case 1:
            this.y = t;
            break;
          default:
            throw new Error("index is out of range: " + e);
        }
        return this;
      },
      getComponent: function getComponent(e) {
        switch (e) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          default:
            throw new Error("index is out of range: " + e);
        }
      },
      clone: function clone() {
        return new this.constructor(this.x, this.y);
      },
      copy: function copy(e) {
        return this.x = e.x, this.y = e.y, this;
      },
      add: function add(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this);
      },
      addScalar: function addScalar(e) {
        return this.x += e, this.y += e, this;
      },
      addVectors: function addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this;
      },
      addScaledVector: function addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this;
      },
      sub: function sub(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this);
      },
      subScalar: function subScalar(e) {
        return this.x -= e, this.y -= e, this;
      },
      subVectors: function subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this;
      },
      multiply: function multiply(e) {
        return this.x *= e.x, this.y *= e.y, this;
      },
      multiplyScalar: function multiplyScalar(e) {
        return this.x *= e, this.y *= e, this;
      },
      divide: function divide(e) {
        return this.x /= e.x, this.y /= e.y, this;
      },
      divideScalar: function divideScalar(e) {
        return this.multiplyScalar(1 / e);
      },
      min: function min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
      },
      max: function max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
      },
      clamp: function clamp(e, t) {
        return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this;
      },
      clampScalar: function () {
        var e = new i(),
          t = new i();
        return function (r, n) {
          return e.set(r, r), t.set(n, n), this.clamp(e, t);
        };
      }(),
      clampLength: function clampLength(e, t) {
        var r = this.length();
        return this.multiplyScalar(Math.max(e, Math.min(t, r)) / r);
      },
      floor: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
      },
      ceil: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
      },
      round: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
      },
      roundToZero: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
      },
      negate: function negate() {
        return this.x = -this.x, this.y = -this.y, this;
      },
      dot: function dot(e) {
        return this.x * e.x + this.y * e.y;
      },
      lengthSq: function lengthSq() {
        return this.x * this.x + this.y * this.y;
      },
      length: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      lengthManhattan: function lengthManhattan() {
        return Math.abs(this.x) + Math.abs(this.y);
      },
      normalize: function normalize() {
        return this.divideScalar(this.length());
      },
      angle: function angle() {
        var e = Math.atan2(this.y, this.x);
        return e < 0 && (e += 2 * Math.PI), e;
      },
      distanceTo: function distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
      },
      distanceToSquared: function distanceToSquared(e) {
        var t = this.x - e.x,
          r = this.y - e.y;
        return t * t + r * r;
      },
      distanceToManhattan: function distanceToManhattan(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
      },
      setLength: function setLength(e) {
        return this.multiplyScalar(e / this.length());
      },
      lerp: function lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
      },
      lerpVectors: function lerpVectors(e, t, r) {
        return this.subVectors(t, e).multiplyScalar(r).add(e);
      },
      equals: function equals(e) {
        return e.x === this.x && e.y === this.y;
      },
      fromArray: function fromArray(e, t) {
        return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e;
      },
      fromBufferAttribute: function fromBufferAttribute(e, t, r) {
        return void 0 !== r && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this;
      },
      rotateAround: function rotateAround(e, t) {
        var r = Math.cos(t),
          n = Math.sin(t),
          i = this.x - e.x,
          a = this.y - e.y;
        return this.x = i * r - a * n + e.x, this.y = i * n + a * r + e.y, this;
      }
    });
    var Cs = 0;
    a.DEFAULT_IMAGE = void 0, a.DEFAULT_MAPPING = lo, Object.defineProperty(a.prototype, "needsUpdate", {
      set: function set(e) {
        !0 === e && this.version++;
      }
    }), Object.assign(a.prototype, n.prototype, {
      constructor: a,
      isTexture: !0,
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.name = e.name, this.image = e.image, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.encoding = e.encoding, this;
      },
      toJSON: function toJSON(e) {
        if (void 0 !== e.textures[this.uuid]) return e.textures[this.uuid];
        var t = {
          metadata: {
            version: 4.5,
            type: "Texture",
            generator: "Texture.toJSON"
          },
          uuid: this.uuid,
          name: this.name,
          mapping: this.mapping,
          repeat: [this.repeat.x, this.repeat.y],
          offset: [this.offset.x, this.offset.y],
          wrap: [this.wrapS, this.wrapT],
          minFilter: this.minFilter,
          magFilter: this.magFilter,
          anisotropy: this.anisotropy,
          flipY: this.flipY
        };
        if (void 0 !== this.image) {
          var r = this.image;
          void 0 === r.uuid && (r.uuid = Ss.generateUUID()), void 0 === e.images[r.uuid] && (e.images[r.uuid] = {
            uuid: r.uuid,
            url: function (e) {
              var t;
              return void 0 !== e.toDataURL ? t = e : (t = document.createElementNS("http://www.w3.org/1999/xhtml", "canvas"), t.width = e.width, t.height = e.height, t.getContext("2d").drawImage(e, 0, 0, e.width, e.height)), t.width > 2048 || t.height > 2048 ? t.toDataURL("image/jpeg", .6) : t.toDataURL("image/png");
            }(r)
          }), t.image = r.uuid;
        }
        return e.textures[this.uuid] = t, t;
      },
      dispose: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      },
      transformUv: function transformUv(e) {
        if (this.mapping === lo) {
          if (e.multiply(this.repeat), e.add(this.offset), e.x < 0 || e.x > 1) switch (this.wrapS) {
            case vo:
              e.x = e.x - Math.floor(e.x);
              break;
            case bo:
              e.x = e.x < 0 ? 0 : 1;
              break;
            case yo:
              1 === Math.abs(Math.floor(e.x) % 2) ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          }
          if (e.y < 0 || e.y > 1) switch (this.wrapT) {
            case vo:
              e.y = e.y - Math.floor(e.y);
              break;
            case bo:
              e.y = e.y < 0 ? 0 : 1;
              break;
            case yo:
              1 === Math.abs(Math.floor(e.y) % 2) ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          }
          this.flipY && (e.y = 1 - e.y);
        }
      }
    }), Object.assign(o.prototype, {
      isVector4: !0,
      set: function set(e, t, r, n) {
        return this.x = e, this.y = t, this.z = r, this.w = n, this;
      },
      setScalar: function setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this.w = e, this;
      },
      setX: function setX(e) {
        return this.x = e, this;
      },
      setY: function setY(e) {
        return this.y = e, this;
      },
      setZ: function setZ(e) {
        return this.z = e, this;
      },
      setW: function setW(e) {
        return this.w = e, this;
      },
      setComponent: function setComponent(e, t) {
        switch (e) {
          case 0:
            this.x = t;
            break;
          case 1:
            this.y = t;
            break;
          case 2:
            this.z = t;
            break;
          case 3:
            this.w = t;
            break;
          default:
            throw new Error("index is out of range: " + e);
        }
        return this;
      },
      getComponent: function getComponent(e) {
        switch (e) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          case 2:
            return this.z;
          case 3:
            return this.w;
          default:
            throw new Error("index is out of range: " + e);
        }
      },
      clone: function clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
      },
      copy: function copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this.w = void 0 !== e.w ? e.w : 1, this;
      },
      add: function add(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this);
      },
      addScalar: function addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this.w += e, this;
      },
      addVectors: function addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
      },
      addScaledVector: function addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
      },
      sub: function sub(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this);
      },
      subScalar: function subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
      },
      subVectors: function subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
      },
      multiplyScalar: function multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
      },
      applyMatrix4: function applyMatrix4(e) {
        var t = this.x,
          r = this.y,
          n = this.z,
          i = this.w,
          a = e.elements;
        return this.x = a[0] * t + a[4] * r + a[8] * n + a[12] * i, this.y = a[1] * t + a[5] * r + a[9] * n + a[13] * i, this.z = a[2] * t + a[6] * r + a[10] * n + a[14] * i, this.w = a[3] * t + a[7] * r + a[11] * n + a[15] * i, this;
      },
      divideScalar: function divideScalar(e) {
        return this.multiplyScalar(1 / e);
      },
      setAxisAngleFromQuaternion: function setAxisAngleFromQuaternion(e) {
        this.w = 2 * Math.acos(e.w);
        var t = Math.sqrt(1 - e.w * e.w);
        return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
      },
      setAxisAngleFromRotationMatrix: function setAxisAngleFromRotationMatrix(e) {
        var t,
          r,
          n,
          i,
          a = e.elements,
          o = a[0],
          s = a[4],
          l = a[8],
          c = a[1],
          u = a[5],
          h = a[9],
          f = a[2],
          d = a[6],
          p = a[10];
        if (Math.abs(s - c) < .01 && Math.abs(l - f) < .01 && Math.abs(h - d) < .01) {
          if (Math.abs(s + c) < .1 && Math.abs(l + f) < .1 && Math.abs(h + d) < .1 && Math.abs(o + u + p - 3) < .1) return this.set(1, 0, 0, 0), this;
          t = Math.PI;
          var m = (o + 1) / 2,
            g = (u + 1) / 2,
            v = (p + 1) / 2,
            b = (s + c) / 4,
            y = (l + f) / 4,
            w = (h + d) / 4;
          return m > g && m > v ? m < .01 ? (r = 0, n = .707106781, i = .707106781) : (r = Math.sqrt(m), n = b / r, i = y / r) : g > v ? g < .01 ? (r = .707106781, n = 0, i = .707106781) : (n = Math.sqrt(g), r = b / n, i = w / n) : v < .01 ? (r = .707106781, n = .707106781, i = 0) : (i = Math.sqrt(v), r = y / i, n = w / i), this.set(r, n, i, t), this;
        }
        var x = Math.sqrt((d - h) * (d - h) + (l - f) * (l - f) + (c - s) * (c - s));
        return Math.abs(x) < .001 && (x = 1), this.x = (d - h) / x, this.y = (l - f) / x, this.z = (c - s) / x, this.w = Math.acos((o + u + p - 1) / 2), this;
      },
      min: function min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
      },
      max: function max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
      },
      clamp: function clamp(e, t) {
        return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this.w = Math.max(e.w, Math.min(t.w, this.w)), this;
      },
      clampScalar: function () {
        var e = new o(),
          t = new o();
        return function (r, n) {
          return e.set(r, r, r, r), t.set(n, n, n, n), this.clamp(e, t);
        };
      }(),
      floor: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
      },
      ceil: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
      },
      round: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
      },
      roundToZero: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
      },
      negate: function negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
      },
      dot: function dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
      },
      lengthSq: function lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
      },
      length: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
      },
      lengthManhattan: function lengthManhattan() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
      },
      normalize: function normalize() {
        return this.divideScalar(this.length());
      },
      setLength: function setLength(e) {
        return this.multiplyScalar(e / this.length());
      },
      lerp: function lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
      },
      lerpVectors: function lerpVectors(e, t, r) {
        return this.subVectors(t, e).multiplyScalar(r).add(e);
      },
      equals: function equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
      },
      fromArray: function fromArray(e, t) {
        return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
      },
      fromBufferAttribute: function fromBufferAttribute(e, t, r) {
        return void 0 !== r && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
      }
    }), Object.assign(s.prototype, n.prototype, {
      isWebGLRenderTarget: !0,
      setSize: function setSize(e, t) {
        this.width === e && this.height === t || (this.width = e, this.height = t, this.dispose()), this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.width = e.width, this.height = e.height, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, this.depthTexture = e.depthTexture, this;
      },
      dispose: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }), l.prototype = Object.create(s.prototype), l.prototype.constructor = l, l.prototype.isWebGLRenderTargetCube = !0, Object.assign(c, {
      slerp: function slerp(e, t, r, n) {
        return r.copy(e).slerp(t, n);
      },
      slerpFlat: function slerpFlat(e, t, r, n, i, a, o) {
        var s = r[n + 0],
          l = r[n + 1],
          c = r[n + 2],
          u = r[n + 3],
          h = i[a + 0],
          f = i[a + 1],
          d = i[a + 2],
          p = i[a + 3];
        if (u !== p || s !== h || l !== f || c !== d) {
          var m = 1 - o,
            g = s * h + l * f + c * d + u * p,
            v = g >= 0 ? 1 : -1,
            b = 1 - g * g;
          if (b > Number.EPSILON) {
            var y = Math.sqrt(b),
              w = Math.atan2(y, g * v);
            m = Math.sin(m * w) / y, o = Math.sin(o * w) / y;
          }
          var x = o * v;
          if (s = s * m + h * x, l = l * m + f * x, c = c * m + d * x, u = u * m + p * x, m === 1 - o) {
            var _ = 1 / Math.sqrt(s * s + l * l + c * c + u * u);
            s *= _, l *= _, c *= _, u *= _;
          }
        }
        e[t] = s, e[t + 1] = l, e[t + 2] = c, e[t + 3] = u;
      }
    }), Object.defineProperties(c.prototype, {
      x: {
        get: function get() {
          return this._x;
        },
        set: function set(e) {
          this._x = e, this.onChangeCallback();
        }
      },
      y: {
        get: function get() {
          return this._y;
        },
        set: function set(e) {
          this._y = e, this.onChangeCallback();
        }
      },
      z: {
        get: function get() {
          return this._z;
        },
        set: function set(e) {
          this._z = e, this.onChangeCallback();
        }
      },
      w: {
        get: function get() {
          return this._w;
        },
        set: function set(e) {
          this._w = e, this.onChangeCallback();
        }
      }
    }), Object.assign(c.prototype, {
      set: function set(e, t, r, n) {
        return this._x = e, this._y = t, this._z = r, this._w = n, this.onChangeCallback(), this;
      },
      clone: function clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
      },
      copy: function copy(e) {
        return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this.onChangeCallback(), this;
      },
      setFromEuler: function setFromEuler(e, t) {
        if (!1 === (e && e.isEuler)) throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
        var r = e._x,
          n = e._y,
          i = e._z,
          a = e.order,
          o = Math.cos,
          s = Math.sin,
          l = o(r / 2),
          c = o(n / 2),
          u = o(i / 2),
          h = s(r / 2),
          f = s(n / 2),
          d = s(i / 2);
        return "XYZ" === a ? (this._x = h * c * u + l * f * d, this._y = l * f * u - h * c * d, this._z = l * c * d + h * f * u, this._w = l * c * u - h * f * d) : "YXZ" === a ? (this._x = h * c * u + l * f * d, this._y = l * f * u - h * c * d, this._z = l * c * d - h * f * u, this._w = l * c * u + h * f * d) : "ZXY" === a ? (this._x = h * c * u - l * f * d, this._y = l * f * u + h * c * d, this._z = l * c * d + h * f * u, this._w = l * c * u - h * f * d) : "ZYX" === a ? (this._x = h * c * u - l * f * d, this._y = l * f * u + h * c * d, this._z = l * c * d - h * f * u, this._w = l * c * u + h * f * d) : "YZX" === a ? (this._x = h * c * u + l * f * d, this._y = l * f * u + h * c * d, this._z = l * c * d - h * f * u, this._w = l * c * u - h * f * d) : "XZY" === a && (this._x = h * c * u - l * f * d, this._y = l * f * u - h * c * d, this._z = l * c * d + h * f * u, this._w = l * c * u + h * f * d), !1 !== t && this.onChangeCallback(), this;
      },
      setFromAxisAngle: function setFromAxisAngle(e, t) {
        var r = t / 2,
          n = Math.sin(r);
        return this._x = e.x * n, this._y = e.y * n, this._z = e.z * n, this._w = Math.cos(r), this.onChangeCallback(), this;
      },
      setFromRotationMatrix: function setFromRotationMatrix(e) {
        var t,
          r = e.elements,
          n = r[0],
          i = r[4],
          a = r[8],
          o = r[1],
          s = r[5],
          l = r[9],
          c = r[2],
          u = r[6],
          h = r[10],
          f = n + s + h;
        return f > 0 ? (t = .5 / Math.sqrt(f + 1), this._w = .25 / t, this._x = (u - l) * t, this._y = (a - c) * t, this._z = (o - i) * t) : n > s && n > h ? (t = 2 * Math.sqrt(1 + n - s - h), this._w = (u - l) / t, this._x = .25 * t, this._y = (i + o) / t, this._z = (a + c) / t) : s > h ? (t = 2 * Math.sqrt(1 + s - n - h), this._w = (a - c) / t, this._x = (i + o) / t, this._y = .25 * t, this._z = (l + u) / t) : (t = 2 * Math.sqrt(1 + h - n - s), this._w = (o - i) / t, this._x = (a + c) / t, this._y = (l + u) / t, this._z = .25 * t), this.onChangeCallback(), this;
      },
      setFromUnitVectors: function () {
        var e,
          t = new u();
        return function (r, n) {
          return void 0 === t && (t = new u()), e = r.dot(n) + 1, e < 1e-6 ? (e = 0, Math.abs(r.x) > Math.abs(r.z) ? t.set(-r.y, r.x, 0) : t.set(0, -r.z, r.y)) : t.crossVectors(r, n), this._x = t.x, this._y = t.y, this._z = t.z, this._w = e, this.normalize();
        };
      }(),
      inverse: function inverse() {
        return this.conjugate().normalize();
      },
      conjugate: function conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this.onChangeCallback(), this;
      },
      dot: function dot(e) {
        return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
      },
      lengthSq: function lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
      },
      length: function length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
      },
      normalize: function normalize() {
        var e = this.length();
        return 0 === e ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this.onChangeCallback(), this;
      },
      multiply: function multiply(e, t) {
        return void 0 !== t ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(e, t)) : this.multiplyQuaternions(this, e);
      },
      premultiply: function premultiply(e) {
        return this.multiplyQuaternions(e, this);
      },
      multiplyQuaternions: function multiplyQuaternions(e, t) {
        var r = e._x,
          n = e._y,
          i = e._z,
          a = e._w,
          o = t._x,
          s = t._y,
          l = t._z,
          c = t._w;
        return this._x = r * c + a * o + n * l - i * s, this._y = n * c + a * s + i * o - r * l, this._z = i * c + a * l + r * s - n * o, this._w = a * c - r * o - n * s - i * l, this.onChangeCallback(), this;
      },
      slerp: function slerp(e, t) {
        if (0 === t) return this;
        if (1 === t) return this.copy(e);
        var r = this._x,
          n = this._y,
          i = this._z,
          a = this._w,
          o = a * e._w + r * e._x + n * e._y + i * e._z;
        if (o < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, o = -o) : this.copy(e), o >= 1) return this._w = a, this._x = r, this._y = n, this._z = i, this;
        var s = Math.sqrt(1 - o * o);
        if (Math.abs(s) < .001) return this._w = .5 * (a + this._w), this._x = .5 * (r + this._x), this._y = .5 * (n + this._y), this._z = .5 * (i + this._z), this;
        var l = Math.atan2(s, o),
          c = Math.sin((1 - t) * l) / s,
          u = Math.sin(t * l) / s;
        return this._w = a * c + this._w * u, this._x = r * c + this._x * u, this._y = n * c + this._y * u, this._z = i * c + this._z * u, this.onChangeCallback(), this;
      },
      equals: function equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
      },
      fromArray: function fromArray(e, t) {
        return void 0 === t && (t = 0), this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this.onChangeCallback(), this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
      },
      onChange: function onChange(e) {
        return this.onChangeCallback = e, this;
      },
      onChangeCallback: function onChangeCallback() {}
    }), Object.assign(u.prototype, {
      isVector3: !0,
      set: function set(e, t, r) {
        return this.x = e, this.y = t, this.z = r, this;
      },
      setScalar: function setScalar(e) {
        return this.x = e, this.y = e, this.z = e, this;
      },
      setX: function setX(e) {
        return this.x = e, this;
      },
      setY: function setY(e) {
        return this.y = e, this;
      },
      setZ: function setZ(e) {
        return this.z = e, this;
      },
      setComponent: function setComponent(e, t) {
        switch (e) {
          case 0:
            this.x = t;
            break;
          case 1:
            this.y = t;
            break;
          case 2:
            this.z = t;
            break;
          default:
            throw new Error("index is out of range: " + e);
        }
        return this;
      },
      getComponent: function getComponent(e) {
        switch (e) {
          case 0:
            return this.x;
          case 1:
            return this.y;
          case 2:
            return this.z;
          default:
            throw new Error("index is out of range: " + e);
        }
      },
      clone: function clone() {
        return new this.constructor(this.x, this.y, this.z);
      },
      copy: function copy(e) {
        return this.x = e.x, this.y = e.y, this.z = e.z, this;
      },
      add: function add(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this);
      },
      addScalar: function addScalar(e) {
        return this.x += e, this.y += e, this.z += e, this;
      },
      addVectors: function addVectors(e, t) {
        return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
      },
      addScaledVector: function addScaledVector(e, t) {
        return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
      },
      sub: function sub(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this);
      },
      subScalar: function subScalar(e) {
        return this.x -= e, this.y -= e, this.z -= e, this;
      },
      subVectors: function subVectors(e, t) {
        return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
      },
      multiply: function multiply(e, t) {
        return void 0 !== t ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(e, t)) : (this.x *= e.x, this.y *= e.y, this.z *= e.z, this);
      },
      multiplyScalar: function multiplyScalar(e) {
        return this.x *= e, this.y *= e, this.z *= e, this;
      },
      multiplyVectors: function multiplyVectors(e, t) {
        return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
      },
      applyEuler: function () {
        var e = new c();
        return function (t) {
          return !1 === (t && t.isEuler) && console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(e.setFromEuler(t));
        };
      }(),
      applyAxisAngle: function () {
        var e = new c();
        return function (t, r) {
          return this.applyQuaternion(e.setFromAxisAngle(t, r));
        };
      }(),
      applyMatrix3: function applyMatrix3(e) {
        var t = this.x,
          r = this.y,
          n = this.z,
          i = e.elements;
        return this.x = i[0] * t + i[3] * r + i[6] * n, this.y = i[1] * t + i[4] * r + i[7] * n, this.z = i[2] * t + i[5] * r + i[8] * n, this;
      },
      applyMatrix4: function applyMatrix4(e) {
        var t = this.x,
          r = this.y,
          n = this.z,
          i = e.elements;
        this.x = i[0] * t + i[4] * r + i[8] * n + i[12], this.y = i[1] * t + i[5] * r + i[9] * n + i[13], this.z = i[2] * t + i[6] * r + i[10] * n + i[14];
        var a = i[3] * t + i[7] * r + i[11] * n + i[15];
        return this.divideScalar(a);
      },
      applyQuaternion: function applyQuaternion(e) {
        var t = this.x,
          r = this.y,
          n = this.z,
          i = e.x,
          a = e.y,
          o = e.z,
          s = e.w,
          l = s * t + a * n - o * r,
          c = s * r + o * t - i * n,
          u = s * n + i * r - a * t,
          h = -i * t - a * r - o * n;
        return this.x = l * s + h * -i + c * -o - u * -a, this.y = c * s + h * -a + u * -i - l * -o, this.z = u * s + h * -o + l * -a - c * -i, this;
      },
      project: function () {
        var e = new h();
        return function (t) {
          return e.multiplyMatrices(t.projectionMatrix, e.getInverse(t.matrixWorld)), this.applyMatrix4(e);
        };
      }(),
      unproject: function () {
        var e = new h();
        return function (t) {
          return e.multiplyMatrices(t.matrixWorld, e.getInverse(t.projectionMatrix)), this.applyMatrix4(e);
        };
      }(),
      transformDirection: function transformDirection(e) {
        var t = this.x,
          r = this.y,
          n = this.z,
          i = e.elements;
        return this.x = i[0] * t + i[4] * r + i[8] * n, this.y = i[1] * t + i[5] * r + i[9] * n, this.z = i[2] * t + i[6] * r + i[10] * n, this.normalize();
      },
      divide: function divide(e) {
        return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
      },
      divideScalar: function divideScalar(e) {
        return this.multiplyScalar(1 / e);
      },
      min: function min(e) {
        return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
      },
      max: function max(e) {
        return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
      },
      clamp: function clamp(e, t) {
        return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this;
      },
      clampScalar: function () {
        var e = new u(),
          t = new u();
        return function (r, n) {
          return e.set(r, r, r), t.set(n, n, n), this.clamp(e, t);
        };
      }(),
      clampLength: function clampLength(e, t) {
        var r = this.length();
        return this.multiplyScalar(Math.max(e, Math.min(t, r)) / r);
      },
      floor: function floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
      },
      ceil: function ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
      },
      round: function round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
      },
      roundToZero: function roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
      },
      negate: function negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
      },
      dot: function dot(e) {
        return this.x * e.x + this.y * e.y + this.z * e.z;
      },
      lengthSq: function lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      },
      length: function length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
      },
      lengthManhattan: function lengthManhattan() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
      },
      normalize: function normalize() {
        return this.divideScalar(this.length());
      },
      setLength: function setLength(e) {
        return this.multiplyScalar(e / this.length());
      },
      lerp: function lerp(e, t) {
        return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
      },
      lerpVectors: function lerpVectors(e, t, r) {
        return this.subVectors(t, e).multiplyScalar(r).add(e);
      },
      cross: function cross(e, t) {
        if (void 0 !== t) return console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(e, t);
        var r = this.x,
          n = this.y,
          i = this.z;
        return this.x = n * e.z - i * e.y, this.y = i * e.x - r * e.z, this.z = r * e.y - n * e.x, this;
      },
      crossVectors: function crossVectors(e, t) {
        var r = e.x,
          n = e.y,
          i = e.z,
          a = t.x,
          o = t.y,
          s = t.z;
        return this.x = n * s - i * o, this.y = i * a - r * s, this.z = r * o - n * a, this;
      },
      projectOnVector: function projectOnVector(e) {
        var t = e.dot(this) / e.lengthSq();
        return this.copy(e).multiplyScalar(t);
      },
      projectOnPlane: function () {
        var e = new u();
        return function (t) {
          return e.copy(this).projectOnVector(t), this.sub(e);
        };
      }(),
      reflect: function () {
        var e = new u();
        return function (t) {
          return this.sub(e.copy(t).multiplyScalar(2 * this.dot(t)));
        };
      }(),
      angleTo: function angleTo(e) {
        var t = this.dot(e) / Math.sqrt(this.lengthSq() * e.lengthSq());
        return Math.acos(Ss.clamp(t, -1, 1));
      },
      distanceTo: function distanceTo(e) {
        return Math.sqrt(this.distanceToSquared(e));
      },
      distanceToSquared: function distanceToSquared(e) {
        var t = this.x - e.x,
          r = this.y - e.y,
          n = this.z - e.z;
        return t * t + r * r + n * n;
      },
      distanceToManhattan: function distanceToManhattan(e) {
        return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
      },
      setFromSpherical: function setFromSpherical(e) {
        var t = Math.sin(e.phi) * e.radius;
        return this.x = t * Math.sin(e.theta), this.y = Math.cos(e.phi) * e.radius, this.z = t * Math.cos(e.theta), this;
      },
      setFromCylindrical: function setFromCylindrical(e) {
        return this.x = e.radius * Math.sin(e.theta), this.y = e.y, this.z = e.radius * Math.cos(e.theta), this;
      },
      setFromMatrixPosition: function setFromMatrixPosition(e) {
        return this.setFromMatrixColumn(e, 3);
      },
      setFromMatrixScale: function setFromMatrixScale(e) {
        var t = this.setFromMatrixColumn(e, 0).length(),
          r = this.setFromMatrixColumn(e, 1).length(),
          n = this.setFromMatrixColumn(e, 2).length();
        return this.x = t, this.y = r, this.z = n, this;
      },
      setFromMatrixColumn: function setFromMatrixColumn(e, t) {
        return this.fromArray(e.elements, 4 * t);
      },
      equals: function equals(e) {
        return e.x === this.x && e.y === this.y && e.z === this.z;
      },
      fromArray: function fromArray(e, t) {
        return void 0 === t && (t = 0), this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
      },
      fromBufferAttribute: function fromBufferAttribute(e, t, r) {
        return void 0 !== r && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
      }
    }), Object.assign(h.prototype, {
      isMatrix4: !0,
      set: function set(e, t, r, n, i, a, o, s, l, c, u, h, f, d, p, m) {
        var g = this.elements;
        return g[0] = e, g[4] = t, g[8] = r, g[12] = n, g[1] = i, g[5] = a, g[9] = o, g[13] = s, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = f, g[7] = d, g[11] = p, g[15] = m, this;
      },
      identity: function identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
      },
      clone: function clone() {
        return new h().fromArray(this.elements);
      },
      copy: function copy(e) {
        var t = this.elements,
          r = e.elements;
        return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4], t[5] = r[5], t[6] = r[6], t[7] = r[7], t[8] = r[8], t[9] = r[9], t[10] = r[10], t[11] = r[11], t[12] = r[12], t[13] = r[13], t[14] = r[14], t[15] = r[15], this;
      },
      copyPosition: function copyPosition(e) {
        var t = this.elements,
          r = e.elements;
        return t[12] = r[12], t[13] = r[13], t[14] = r[14], this;
      },
      extractBasis: function extractBasis(e, t, r) {
        return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
      },
      makeBasis: function makeBasis(e, t, r) {
        return this.set(e.x, t.x, r.x, 0, e.y, t.y, r.y, 0, e.z, t.z, r.z, 0, 0, 0, 0, 1), this;
      },
      extractRotation: function () {
        var e = new u();
        return function (t) {
          var r = this.elements,
            n = t.elements,
            i = 1 / e.setFromMatrixColumn(t, 0).length(),
            a = 1 / e.setFromMatrixColumn(t, 1).length(),
            o = 1 / e.setFromMatrixColumn(t, 2).length();
          return r[0] = n[0] * i, r[1] = n[1] * i, r[2] = n[2] * i, r[4] = n[4] * a, r[5] = n[5] * a, r[6] = n[6] * a, r[8] = n[8] * o, r[9] = n[9] * o, r[10] = n[10] * o, this;
        };
      }(),
      makeRotationFromEuler: function makeRotationFromEuler(e) {
        !1 === (e && e.isEuler) && console.error("THREE.Matrix: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
        var t = this.elements,
          r = e.x,
          n = e.y,
          i = e.z,
          a = Math.cos(r),
          o = Math.sin(r),
          s = Math.cos(n),
          l = Math.sin(n),
          c = Math.cos(i),
          u = Math.sin(i);
        if ("XYZ" === e.order) {
          var h = a * c,
            f = a * u,
            d = o * c,
            p = o * u;
          t[0] = s * c, t[4] = -s * u, t[8] = l, t[1] = f + d * l, t[5] = h - p * l, t[9] = -o * s, t[2] = p - h * l, t[6] = d + f * l, t[10] = a * s;
        } else if ("YXZ" === e.order) {
          var m = s * c,
            g = s * u,
            v = l * c,
            b = l * u;
          t[0] = m + b * o, t[4] = v * o - g, t[8] = a * l, t[1] = a * u, t[5] = a * c, t[9] = -o, t[2] = g * o - v, t[6] = b + m * o, t[10] = a * s;
        } else if ("ZXY" === e.order) {
          var m = s * c,
            g = s * u,
            v = l * c,
            b = l * u;
          t[0] = m - b * o, t[4] = -a * u, t[8] = v + g * o, t[1] = g + v * o, t[5] = a * c, t[9] = b - m * o, t[2] = -a * l, t[6] = o, t[10] = a * s;
        } else if ("ZYX" === e.order) {
          var h = a * c,
            f = a * u,
            d = o * c,
            p = o * u;
          t[0] = s * c, t[4] = d * l - f, t[8] = h * l + p, t[1] = s * u, t[5] = p * l + h, t[9] = f * l - d, t[2] = -l, t[6] = o * s, t[10] = a * s;
        } else if ("YZX" === e.order) {
          var y = a * s,
            w = a * l,
            x = o * s,
            _ = o * l;
          t[0] = s * c, t[4] = _ - y * u, t[8] = x * u + w, t[1] = u, t[5] = a * c, t[9] = -o * c, t[2] = -l * c, t[6] = w * u + x, t[10] = y - _ * u;
        } else if ("XZY" === e.order) {
          var y = a * s,
            w = a * l,
            x = o * s,
            _ = o * l;
          t[0] = s * c, t[4] = -u, t[8] = l * c, t[1] = y * u + _, t[5] = a * c, t[9] = w * u - x, t[2] = x * u - w, t[6] = o * c, t[10] = _ * u + y;
        }
        return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
      },
      makeRotationFromQuaternion: function makeRotationFromQuaternion(e) {
        var t = this.elements,
          r = e._x,
          n = e._y,
          i = e._z,
          a = e._w,
          o = r + r,
          s = n + n,
          l = i + i,
          c = r * o,
          u = r * s,
          h = r * l,
          f = n * s,
          d = n * l,
          p = i * l,
          m = a * o,
          g = a * s,
          v = a * l;
        return t[0] = 1 - (f + p), t[4] = u - v, t[8] = h + g, t[1] = u + v, t[5] = 1 - (c + p), t[9] = d - m, t[2] = h - g, t[6] = d + m, t[10] = 1 - (c + f), t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
      },
      lookAt: function () {
        var e = new u(),
          t = new u(),
          r = new u();
        return function (n, i, a) {
          var o = this.elements;
          return r.subVectors(n, i), 0 === r.lengthSq() && (r.z = 1), r.normalize(), e.crossVectors(a, r), 0 === e.lengthSq() && (r.z += 1e-4, e.crossVectors(a, r)), e.normalize(), t.crossVectors(r, e), o[0] = e.x, o[4] = t.x, o[8] = r.x, o[1] = e.y, o[5] = t.y, o[9] = r.y, o[2] = e.z, o[6] = t.z, o[10] = r.z, this;
        };
      }(),
      multiply: function multiply(e, t) {
        return void 0 !== t ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(e, t)) : this.multiplyMatrices(this, e);
      },
      premultiply: function premultiply(e) {
        return this.multiplyMatrices(e, this);
      },
      multiplyMatrices: function multiplyMatrices(e, t) {
        var r = e.elements,
          n = t.elements,
          i = this.elements,
          a = r[0],
          o = r[4],
          s = r[8],
          l = r[12],
          c = r[1],
          u = r[5],
          h = r[9],
          f = r[13],
          d = r[2],
          p = r[6],
          m = r[10],
          g = r[14],
          v = r[3],
          b = r[7],
          y = r[11],
          w = r[15],
          x = n[0],
          _ = n[4],
          S = n[8],
          C = n[12],
          E = n[1],
          A = n[5],
          T = n[9],
          k = n[13],
          R = n[2],
          I = n[6],
          M = n[10],
          O = n[14],
          P = n[3],
          B = n[7],
          D = n[11],
          L = n[15];
        return i[0] = a * x + o * E + s * R + l * P, i[4] = a * _ + o * A + s * I + l * B, i[8] = a * S + o * T + s * M + l * D, i[12] = a * C + o * k + s * O + l * L, i[1] = c * x + u * E + h * R + f * P, i[5] = c * _ + u * A + h * I + f * B, i[9] = c * S + u * T + h * M + f * D, i[13] = c * C + u * k + h * O + f * L, i[2] = d * x + p * E + m * R + g * P, i[6] = d * _ + p * A + m * I + g * B, i[10] = d * S + p * T + m * M + g * D, i[14] = d * C + p * k + m * O + g * L, i[3] = v * x + b * E + y * R + w * P, i[7] = v * _ + b * A + y * I + w * B, i[11] = v * S + b * T + y * M + w * D, i[15] = v * C + b * k + y * O + w * L, this;
      },
      multiplyScalar: function multiplyScalar(e) {
        var t = this.elements;
        return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
      },
      applyToBufferAttribute: function () {
        var e = new u();
        return function (t) {
          for (var r = 0, n = t.count; r < n; r++) e.x = t.getX(r), e.y = t.getY(r), e.z = t.getZ(r), e.applyMatrix4(this), t.setXYZ(r, e.x, e.y, e.z);
          return t;
        };
      }(),
      determinant: function determinant() {
        var e = this.elements,
          t = e[0],
          r = e[4],
          n = e[8],
          i = e[12],
          a = e[1],
          o = e[5],
          s = e[9],
          l = e[13],
          c = e[2],
          u = e[6],
          h = e[10],
          f = e[14];
        return e[3] * (+i * s * u - n * l * u - i * o * h + r * l * h + n * o * f - r * s * f) + e[7] * (+t * s * f - t * l * h + i * a * h - n * a * f + n * l * c - i * s * c) + e[11] * (+t * l * u - t * o * f - i * a * u + r * a * f + i * o * c - r * l * c) + e[15] * (-n * o * c - t * s * u + t * o * h + n * a * u - r * a * h + r * s * c);
      },
      transpose: function transpose() {
        var e,
          t = this.elements;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
      },
      setPosition: function setPosition(e) {
        var t = this.elements;
        return t[12] = e.x, t[13] = e.y, t[14] = e.z, this;
      },
      getInverse: function getInverse(e, t) {
        var r = this.elements,
          n = e.elements,
          i = n[0],
          a = n[1],
          o = n[2],
          s = n[3],
          l = n[4],
          c = n[5],
          u = n[6],
          h = n[7],
          f = n[8],
          d = n[9],
          p = n[10],
          m = n[11],
          g = n[12],
          v = n[13],
          b = n[14],
          y = n[15],
          w = d * b * h - v * p * h + v * u * m - c * b * m - d * u * y + c * p * y,
          x = g * p * h - f * b * h - g * u * m + l * b * m + f * u * y - l * p * y,
          _ = f * v * h - g * d * h + g * c * m - l * v * m - f * c * y + l * d * y,
          S = g * d * u - f * v * u - g * c * p + l * v * p + f * c * b - l * d * b,
          C = i * w + a * x + o * _ + s * S;
        if (0 === C) {
          var E = "THREE.Matrix4.getInverse(): can't invert matrix, determinant is 0";
          if (!0 === t) throw new Error(E);
          return console.warn(E), this.identity();
        }
        var A = 1 / C;
        return r[0] = w * A, r[1] = (v * p * s - d * b * s - v * o * m + a * b * m + d * o * y - a * p * y) * A, r[2] = (c * b * s - v * u * s + v * o * h - a * b * h - c * o * y + a * u * y) * A, r[3] = (d * u * s - c * p * s - d * o * h + a * p * h + c * o * m - a * u * m) * A, r[4] = x * A, r[5] = (f * b * s - g * p * s + g * o * m - i * b * m - f * o * y + i * p * y) * A, r[6] = (g * u * s - l * b * s - g * o * h + i * b * h + l * o * y - i * u * y) * A, r[7] = (l * p * s - f * u * s + f * o * h - i * p * h - l * o * m + i * u * m) * A, r[8] = _ * A, r[9] = (g * d * s - f * v * s - g * a * m + i * v * m + f * a * y - i * d * y) * A, r[10] = (l * v * s - g * c * s + g * a * h - i * v * h - l * a * y + i * c * y) * A, r[11] = (f * c * s - l * d * s - f * a * h + i * d * h + l * a * m - i * c * m) * A, r[12] = S * A, r[13] = (f * v * o - g * d * o + g * a * p - i * v * p - f * a * b + i * d * b) * A, r[14] = (g * c * o - l * v * o - g * a * u + i * v * u + l * a * b - i * c * b) * A, r[15] = (l * d * o - f * c * o + f * a * u - i * d * u - l * a * p + i * c * p) * A, this;
      },
      scale: function scale(e) {
        var t = this.elements,
          r = e.x,
          n = e.y,
          i = e.z;
        return t[0] *= r, t[4] *= n, t[8] *= i, t[1] *= r, t[5] *= n, t[9] *= i, t[2] *= r, t[6] *= n, t[10] *= i, t[3] *= r, t[7] *= n, t[11] *= i, this;
      },
      getMaxScaleOnAxis: function getMaxScaleOnAxis() {
        var e = this.elements,
          t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
          r = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
          n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
        return Math.sqrt(Math.max(t, r, n));
      },
      makeTranslation: function makeTranslation(e, t, r) {
        return this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, r, 0, 0, 0, 1), this;
      },
      makeRotationX: function makeRotationX(e) {
        var t = Math.cos(e),
          r = Math.sin(e);
        return this.set(1, 0, 0, 0, 0, t, -r, 0, 0, r, t, 0, 0, 0, 0, 1), this;
      },
      makeRotationY: function makeRotationY(e) {
        var t = Math.cos(e),
          r = Math.sin(e);
        return this.set(t, 0, r, 0, 0, 1, 0, 0, -r, 0, t, 0, 0, 0, 0, 1), this;
      },
      makeRotationZ: function makeRotationZ(e) {
        var t = Math.cos(e),
          r = Math.sin(e);
        return this.set(t, -r, 0, 0, r, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
      },
      makeRotationAxis: function makeRotationAxis(e, t) {
        var r = Math.cos(t),
          n = Math.sin(t),
          i = 1 - r,
          a = e.x,
          o = e.y,
          s = e.z,
          l = i * a,
          c = i * o;
        return this.set(l * a + r, l * o - n * s, l * s + n * o, 0, l * o + n * s, c * o + r, c * s - n * a, 0, l * s - n * o, c * s + n * a, i * s * s + r, 0, 0, 0, 0, 1), this;
      },
      makeScale: function makeScale(e, t, r) {
        return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, r, 0, 0, 0, 0, 1), this;
      },
      makeShear: function makeShear(e, t, r) {
        return this.set(1, t, r, 0, e, 1, r, 0, e, t, 1, 0, 0, 0, 0, 1), this;
      },
      compose: function compose(e, t, r) {
        return this.makeRotationFromQuaternion(t), this.scale(r), this.setPosition(e), this;
      },
      decompose: function () {
        var e = new u(),
          t = new h();
        return function (r, n, i) {
          var a = this.elements,
            o = e.set(a[0], a[1], a[2]).length(),
            s = e.set(a[4], a[5], a[6]).length(),
            l = e.set(a[8], a[9], a[10]).length();
          this.determinant() < 0 && (o = -o), r.x = a[12], r.y = a[13], r.z = a[14], t.copy(this);
          var c = 1 / o,
            u = 1 / s,
            h = 1 / l;
          return t.elements[0] *= c, t.elements[1] *= c, t.elements[2] *= c, t.elements[4] *= u, t.elements[5] *= u, t.elements[6] *= u, t.elements[8] *= h, t.elements[9] *= h, t.elements[10] *= h, n.setFromRotationMatrix(t), i.x = o, i.y = s, i.z = l, this;
        };
      }(),
      makePerspective: function makePerspective(e, t, r, n, i, a) {
        void 0 === a && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
        var o = this.elements,
          s = 2 * i / (t - e),
          l = 2 * i / (r - n),
          c = (t + e) / (t - e),
          u = (r + n) / (r - n),
          h = -(a + i) / (a - i),
          f = -2 * a * i / (a - i);
        return o[0] = s, o[4] = 0, o[8] = c, o[12] = 0, o[1] = 0, o[5] = l, o[9] = u, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = h, o[14] = f, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
      },
      makeOrthographic: function makeOrthographic(e, t, r, n, i, a) {
        var o = this.elements,
          s = 1 / (t - e),
          l = 1 / (r - n),
          c = 1 / (a - i),
          u = (t + e) * s,
          h = (r + n) * l,
          f = (a + i) * c;
        return o[0] = 2 * s, o[4] = 0, o[8] = 0, o[12] = -u, o[1] = 0, o[5] = 2 * l, o[9] = 0, o[13] = -h, o[2] = 0, o[6] = 0, o[10] = -2 * c, o[14] = -f, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
      },
      equals: function equals(e) {
        for (var t = this.elements, r = e.elements, n = 0; n < 16; n++) if (t[n] !== r[n]) return !1;
        return !0;
      },
      fromArray: function fromArray(e, t) {
        void 0 === t && (t = 0);
        for (var r = 0; r < 16; r++) this.elements[r] = e[r + t];
        return this;
      },
      toArray: function toArray(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = 0);
        var r = this.elements;
        return e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = r[3], e[t + 4] = r[4], e[t + 5] = r[5], e[t + 6] = r[6], e[t + 7] = r[7], e[t + 8] = r[8], e[t + 9] = r[9], e[t + 10] = r[10], e[t + 11] = r[11], e[t + 12] = r[12], e[t + 13] = r[13], e[t + 14] = r[14], e[t + 15] = r[15], e;
      }
    }), f.prototype = Object.create(a.prototype), f.prototype.constructor = f, f.prototype.isDataTexture = !0, d.prototype = Object.create(a.prototype), d.prototype.constructor = d, d.prototype.isCubeTexture = !0, Object.defineProperty(d.prototype, "images", {
      get: function get() {
        return this.image;
      },
      set: function set(e) {
        this.image = e;
      }
    });
    var Es = new a(),
      As = new d(),
      Ts = [],
      ks = [],
      Rs = new Float32Array(16),
      Is = new Float32Array(9);
    V.prototype.setValue = function (e, t) {
      for (var r = this.seq, n = 0, i = r.length; n !== i; ++n) {
        var a = r[n];
        a.setValue(e, t[a.id]);
      }
    };
    var Ms = /([\w\d_]+)(\])?(\[|\.)?/g;
    X.prototype.setValue = function (e, t, r) {
      var n = this.map[t];
      void 0 !== n && n.setValue(e, r, this.renderer);
    }, X.prototype.setOptional = function (e, t, r) {
      var n = t[r];
      void 0 !== n && this.setValue(e, r, n);
    }, X.upload = function (e, t, r, n) {
      for (var i = 0, a = t.length; i !== a; ++i) {
        var o = t[i],
          s = r[o.id];
        !1 !== s.needsUpdate && o.setValue(e, s.value, n);
      }
    }, X.seqWithValue = function (e, t) {
      for (var r = [], n = 0, i = e.length; n !== i; ++n) {
        var a = e[n];
        a.id in t && r.push(a);
      }
      return r;
    };
    var Os = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    };
    Object.assign(Y.prototype, {
      isColor: !0,
      r: 1,
      g: 1,
      b: 1,
      set: function set(e) {
        return e && e.isColor ? this.copy(e) : "number" == typeof e ? this.setHex(e) : "string" == typeof e && this.setStyle(e), this;
      },
      setScalar: function setScalar(e) {
        return this.r = e, this.g = e, this.b = e, this;
      },
      setHex: function setHex(e) {
        return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (255 & e) / 255, this;
      },
      setRGB: function setRGB(e, t, r) {
        return this.r = e, this.g = t, this.b = r, this;
      },
      setHSL: function () {
        function e(e, t, r) {
          return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? e + 6 * (t - e) * r : r < .5 ? t : r < 2 / 3 ? e + 6 * (t - e) * (2 / 3 - r) : e;
        }
        return function (t, r, n) {
          if (t = Ss.euclideanModulo(t, 1), r = Ss.clamp(r, 0, 1), n = Ss.clamp(n, 0, 1), 0 === r) this.r = this.g = this.b = n;else {
            var i = n <= .5 ? n * (1 + r) : n + r - n * r,
              a = 2 * n - i;
            this.r = e(a, i, t + 1 / 3), this.g = e(a, i, t), this.b = e(a, i, t - 1 / 3);
          }
          return this;
        };
      }(),
      setStyle: function setStyle(e) {
        function t(t) {
          void 0 !== t && parseFloat(t) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
        }
        var r;
        if (r = /^((?:rgb|hsl)a?)\(\s*([^\)]*)\)/.exec(e)) {
          var n,
            i = r[1],
            a = r[2];
          switch (i) {
            case "rgb":
            case "rgba":
              if (n = /^(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(n[1], 10)) / 255, this.g = Math.min(255, parseInt(n[2], 10)) / 255, this.b = Math.min(255, parseInt(n[3], 10)) / 255, t(n[5]), this;
              if (n = /^(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(n[1], 10)) / 100, this.g = Math.min(100, parseInt(n[2], 10)) / 100, this.b = Math.min(100, parseInt(n[3], 10)) / 100, t(n[5]), this;
              break;
            case "hsl":
            case "hsla":
              if (n = /^([0-9]*\.?[0-9]+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(,\s*([0-9]*\.?[0-9]+)\s*)?$/.exec(a)) {
                var o = parseFloat(n[1]) / 360,
                  s = parseInt(n[2], 10) / 100,
                  l = parseInt(n[3], 10) / 100;
                return t(n[5]), this.setHSL(o, s, l);
              }
          }
        } else if (r = /^\#([A-Fa-f0-9]+)$/.exec(e)) {
          var c = r[1],
            u = c.length;
          if (3 === u) return this.r = parseInt(c.charAt(0) + c.charAt(0), 16) / 255, this.g = parseInt(c.charAt(1) + c.charAt(1), 16) / 255, this.b = parseInt(c.charAt(2) + c.charAt(2), 16) / 255, this;
          if (6 === u) return this.r = parseInt(c.charAt(0) + c.charAt(1), 16) / 255, this.g = parseInt(c.charAt(2) + c.charAt(3), 16) / 255, this.b = parseInt(c.charAt(4) + c.charAt(5), 16) / 255, this;
        }
        if (e && e.length > 0) {
          var c = Os[e];
          void 0 !== c ? this.setHex(c) : console.warn("THREE.Color: Unknown color " + e);
        }
        return this;
      },
      clone: function clone() {
        return new this.constructor(this.r, this.g, this.b);
      },
      copy: function copy(e) {
        return this.r = e.r, this.g = e.g, this.b = e.b, this;
      },
      copyGammaToLinear: function copyGammaToLinear(e, t) {
        return void 0 === t && (t = 2), this.r = Math.pow(e.r, t), this.g = Math.pow(e.g, t), this.b = Math.pow(e.b, t), this;
      },
      copyLinearToGamma: function copyLinearToGamma(e, t) {
        void 0 === t && (t = 2);
        var r = t > 0 ? 1 / t : 1;
        return this.r = Math.pow(e.r, r), this.g = Math.pow(e.g, r), this.b = Math.pow(e.b, r), this;
      },
      convertGammaToLinear: function convertGammaToLinear() {
        var e = this.r,
          t = this.g,
          r = this.b;
        return this.r = e * e, this.g = t * t, this.b = r * r, this;
      },
      convertLinearToGamma: function convertLinearToGamma() {
        return this.r = Math.sqrt(this.r), this.g = Math.sqrt(this.g), this.b = Math.sqrt(this.b), this;
      },
      getHex: function getHex() {
        return 255 * this.r << 16 ^ 255 * this.g << 8 ^ 255 * this.b << 0;
      },
      getHexString: function getHexString() {
        return ("000000" + this.getHex().toString(16)).slice(-6);
      },
      getHSL: function getHSL(e) {
        var t,
          r,
          n = e || {
            h: 0,
            s: 0,
            l: 0
          },
          i = this.r,
          a = this.g,
          o = this.b,
          s = Math.max(i, a, o),
          l = Math.min(i, a, o),
          c = (l + s) / 2;
        if (l === s) t = 0, r = 0;else {
          var u = s - l;
          switch (r = c <= .5 ? u / (s + l) : u / (2 - s - l), s) {
            case i:
              t = (a - o) / u + (a < o ? 6 : 0);
              break;
            case a:
              t = (o - i) / u + 2;
              break;
            case o:
              t = (i - a) / u + 4;
          }
          t /= 6;
        }
        return n.h = t, n.s = r, n.l = c, n;
      },
      getStyle: function getStyle() {
        return "rgb(" + (255 * this.r | 0) + "," + (255 * this.g | 0) + "," + (255 * this.b | 0) + ")";
      },
      offsetHSL: function offsetHSL(e, t, r) {
        var n = this.getHSL();
        return n.h += e, n.s += t, n.l += r, this.setHSL(n.h, n.s, n.l), this;
      },
      add: function add(e) {
        return this.r += e.r, this.g += e.g, this.b += e.b, this;
      },
      addColors: function addColors(e, t) {
        return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
      },
      addScalar: function addScalar(e) {
        return this.r += e, this.g += e, this.b += e, this;
      },
      sub: function sub(e) {
        return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
      },
      multiply: function multiply(e) {
        return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
      },
      multiplyScalar: function multiplyScalar(e) {
        return this.r *= e, this.g *= e, this.b *= e, this;
      },
      lerp: function lerp(e, t) {
        return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
      },
      equals: function equals(e) {
        return e.r === this.r && e.g === this.g && e.b === this.b;
      },
      fromArray: function fromArray(e, t) {
        return void 0 === t && (t = 0), this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
      },
      toJSON: function toJSON() {
        return this.getHex();
      }
    });
    var Ps = {
        common: {
          diffuse: {
            value: new Y(15658734)
          },
          opacity: {
            value: 1
          },
          map: {
            value: null
          },
          offsetRepeat: {
            value: new o(0, 0, 1, 1)
          },
          specularMap: {
            value: null
          },
          alphaMap: {
            value: null
          },
          envMap: {
            value: null
          },
          flipEnvMap: {
            value: -1
          },
          reflectivity: {
            value: 1
          },
          refractionRatio: {
            value: .98
          }
        },
        aomap: {
          aoMap: {
            value: null
          },
          aoMapIntensity: {
            value: 1
          }
        },
        lightmap: {
          lightMap: {
            value: null
          },
          lightMapIntensity: {
            value: 1
          }
        },
        emissivemap: {
          emissiveMap: {
            value: null
          }
        },
        bumpmap: {
          bumpMap: {
            value: null
          },
          bumpScale: {
            value: 1
          }
        },
        normalmap: {
          normalMap: {
            value: null
          },
          normalScale: {
            value: new i(1, 1)
          }
        },
        displacementmap: {
          displacementMap: {
            value: null
          },
          displacementScale: {
            value: 1
          },
          displacementBias: {
            value: 0
          }
        },
        roughnessmap: {
          roughnessMap: {
            value: null
          }
        },
        metalnessmap: {
          metalnessMap: {
            value: null
          }
        },
        gradientmap: {
          gradientMap: {
            value: null
          }
        },
        fog: {
          fogDensity: {
            value: 25e-5
          },
          fogNear: {
            value: 1
          },
          fogFar: {
            value: 2e3
          },
          fogColor: {
            value: new Y(16777215)
          }
        },
        lights: {
          ambientLightColor: {
            value: []
          },
          directionalLights: {
            value: [],
            properties: {
              direction: {},
              color: {},
              shadow: {},
              shadowBias: {},
              shadowRadius: {},
              shadowMapSize: {}
            }
          },
          directionalShadowMap: {
            value: []
          },
          directionalShadowMatrix: {
            value: []
          },
          spotLights: {
            value: [],
            properties: {
              color: {},
              position: {},
              direction: {},
              distance: {},
              coneCos: {},
              penumbraCos: {},
              decay: {},
              shadow: {},
              shadowBias: {},
              shadowRadius: {},
              shadowMapSize: {}
            }
          },
          spotShadowMap: {
            value: []
          },
          spotShadowMatrix: {
            value: []
          },
          pointLights: {
            value: [],
            properties: {
              color: {},
              position: {},
              decay: {},
              distance: {},
              shadow: {},
              shadowBias: {},
              shadowRadius: {},
              shadowMapSize: {}
            }
          },
          pointShadowMap: {
            value: []
          },
          pointShadowMatrix: {
            value: []
          },
          hemisphereLights: {
            value: [],
            properties: {
              direction: {},
              skyColor: {},
              groundColor: {}
            }
          },
          rectAreaLights: {
            value: [],
            properties: {
              color: {},
              position: {},
              width: {},
              height: {}
            }
          }
        },
        points: {
          diffuse: {
            value: new Y(15658734)
          },
          opacity: {
            value: 1
          },
          size: {
            value: 1
          },
          scale: {
            value: 1
          },
          map: {
            value: null
          },
          offsetRepeat: {
            value: new o(0, 0, 1, 1)
          }
        }
      },
      Bs = {
        merge: function merge(e) {
          for (var t = {}, r = 0; r < e.length; r++) {
            var n = this.clone(e[r]);
            for (var i in n) t[i] = n[i];
          }
          return t;
        },
        clone: function clone(e) {
          var t = {};
          for (var r in e) {
            t[r] = {};
            for (var n in e[r]) {
              var i = e[r][n];
              i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture) ? t[r][n] = i.clone() : Array.isArray(i) ? t[r][n] = i.slice() : t[r][n] = i;
            }
          }
          return t;
        }
      },
      Ds = {
        alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif\n",
        alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif\n",
        alphatest_fragment: "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif\n",
        aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif\n",
        aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
        begin_vertex: "\nvec3 transformed = vec3( position );\n",
        beginnormal_vertex: "\nvec3 objectNormal = vec3( normal );\n",
        bsdfs: "float punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tif( decayExponent > 0.0 ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tfloat maxDistanceCutoffFactor = pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\treturn distanceFalloff * maxDistanceCutoffFactor;\n#else\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n#endif\n\t}\n\treturn 1.0;\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNL = saturate( dot( geometry.normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE  = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS  = 0.5 / LUT_SIZE;\n\tfloat theta = acos( dot( N, V ) );\n\tvec2 uv = vec2(\n\t\tsqrt( saturate( roughness ) ),\n\t\tsaturate( theta / ( 0.5 * PI ) ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.86267 + (0.49788 + 0.01436 * y ) * y;\n\tfloat b = 3.45068 + (4.18814 + y) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = (x > 0.0) ? v : 0.5 * inversesqrt( 1.0 - x * x ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tvec3 result = vec3( LTC_ClippedSphereFormFactor( vectorFormFactor ) );\n\treturn result;\n}\nvec3 BRDF_Specular_GGX_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 AB = vec2( -1.04, 1.04 ) * a004 + r.zw;\n\treturn specularColor * AB.x + AB.y;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n",
        bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos );\n\t\tvec3 vSigmaY = dFdy( surf_pos );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif\n",
        clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; ++ i ) {\n\t\tvec4 plane = clippingPlanes[ i ];\n\t\tif ( dot( vViewPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t\t\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; ++ i ) {\n\t\t\tvec4 plane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vViewPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\tif ( clipped ) discard;\n\t\n\t#endif\n#endif\n",
        clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\t#if ! defined( PHYSICAL ) && ! defined( PHONG )\n\t\tvarying vec3 vViewPosition;\n\t#endif\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif\n",
        clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvarying vec3 vViewPosition;\n#endif\n",
        clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0 && ! defined( PHYSICAL ) && ! defined( PHONG )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n",
        color_fragment: "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif",
        color_pars_fragment: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif\n",
        color_pars_vertex: "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif",
        color_vertex: "#ifdef USE_COLOR\n\tvColor.xyz = color.xyz;\n#endif",
        common: "#define PI 3.14159265359\n#define PI2 6.28318530718\n#define PI_HALF 1.5707963267949\n#define RECIPROCAL_PI 0.31830988618\n#define RECIPROCAL_PI2 0.15915494\n#define LOG2 1.442695\n#define EPSILON 1e-6\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#define whiteCompliment(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transpose( const in mat3 v ) {\n\tmat3 tmp;\n\ttmp[0] = vec3(v[0].x, v[1].x, v[2].x);\n\ttmp[1] = vec3(v[0].y, v[1].y, v[2].y);\n\ttmp[2] = vec3(v[0].z, v[1].z, v[2].z);\n\treturn tmp;\n}\n",
        cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n#define cubeUV_textureSize (1024.0)\nint getFaceFromDirection(vec3 direction) {\n\tvec3 absDirection = abs(direction);\n\tint face = -1;\n\tif( absDirection.x > absDirection.z ) {\n\t\tif(absDirection.x > absDirection.y )\n\t\t\tface = direction.x > 0.0 ? 0 : 3;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\telse {\n\t\tif(absDirection.z > absDirection.y )\n\t\t\tface = direction.z > 0.0 ? 2 : 5;\n\t\telse\n\t\t\tface = direction.y > 0.0 ? 1 : 4;\n\t}\n\treturn face;\n}\n#define cubeUV_maxLods1  (log2(cubeUV_textureSize*0.25) - 1.0)\n#define cubeUV_rangeClamp (exp2((6.0 - 1.0) * 2.0))\nvec2 MipLevelInfo( vec3 vec, float roughnessLevel, float roughness ) {\n\tfloat scale = exp2(cubeUV_maxLods1 - roughnessLevel);\n\tfloat dxRoughness = dFdx(roughness);\n\tfloat dyRoughness = dFdy(roughness);\n\tvec3 dx = dFdx( vec * scale * dxRoughness );\n\tvec3 dy = dFdy( vec * scale * dyRoughness );\n\tfloat d = max( dot( dx, dx ), dot( dy, dy ) );\n\td = clamp(d, 1.0, cubeUV_rangeClamp);\n\tfloat mipLevel = 0.5 * log2(d);\n\treturn vec2(floor(mipLevel), fract(mipLevel));\n}\n#define cubeUV_maxLods2 (log2(cubeUV_textureSize*0.25) - 2.0)\n#define cubeUV_rcpTextureSize (1.0 / cubeUV_textureSize)\nvec2 getCubeUV(vec3 direction, float roughnessLevel, float mipLevel) {\n\tmipLevel = roughnessLevel > cubeUV_maxLods2 - 3.0 ? 0.0 : mipLevel;\n\tfloat a = 16.0 * cubeUV_rcpTextureSize;\n\tvec2 exp2_packed = exp2( vec2( roughnessLevel, mipLevel ) );\n\tvec2 rcp_exp2_packed = vec2( 1.0 ) / exp2_packed;\n\tfloat powScale = exp2_packed.x * exp2_packed.y;\n\tfloat scale = rcp_exp2_packed.x * rcp_exp2_packed.y * 0.25;\n\tfloat mipOffset = 0.75*(1.0 - rcp_exp2_packed.y) * rcp_exp2_packed.x;\n\tbool bRes = mipLevel == 0.0;\n\tscale =  bRes && (scale < a) ? a : scale;\n\tvec3 r;\n\tvec2 offset;\n\tint face = getFaceFromDirection(direction);\n\tfloat rcpPowScale = 1.0 / powScale;\n\tif( face == 0) {\n\t\tr = vec3(direction.x, -direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 1) {\n\t\tr = vec3(direction.y, direction.x, direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 2) {\n\t\tr = vec3(direction.z, direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.75 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? a : offset.y;\n\t}\n\telse if( face == 3) {\n\t\tr = vec3(direction.x, direction.z, direction.y);\n\t\toffset = vec2(0.0+mipOffset,0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse if( face == 4) {\n\t\tr = vec3(direction.y, direction.x, -direction.z);\n\t\toffset = vec2(scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\telse {\n\t\tr = vec3(direction.z, -direction.x, direction.y);\n\t\toffset = vec2(2.0*scale+mipOffset, 0.5 * rcpPowScale);\n\t\toffset.y = bRes && (offset.y < 2.0*a) ? 0.0 : offset.y;\n\t}\n\tr = normalize(r);\n\tfloat texelOffset = 0.5 * cubeUV_rcpTextureSize;\n\tvec2 s = ( r.yz / abs( r.x ) + vec2( 1.0 ) ) * 0.5;\n\tvec2 base = offset + vec2( texelOffset );\n\treturn base + s * ( scale - 2.0 * texelOffset );\n}\n#define cubeUV_maxLods3 (log2(cubeUV_textureSize*0.25) - 3.0)\nvec4 textureCubeUV(vec3 reflectedDirection, float roughness ) {\n\tfloat roughnessVal = roughness* cubeUV_maxLods3;\n\tfloat r1 = floor(roughnessVal);\n\tfloat r2 = r1 + 1.0;\n\tfloat t = fract(roughnessVal);\n\tvec2 mipInfo = MipLevelInfo(reflectedDirection, r1, roughness);\n\tfloat s = mipInfo.y;\n\tfloat level0 = mipInfo.x;\n\tfloat level1 = level0 + 1.0;\n\tlevel1 = level1 > 5.0 ? 5.0 : level1;\n\tlevel0 += min( floor( s + 0.5 ), 5.0 );\n\tvec2 uv_10 = getCubeUV(reflectedDirection, r1, level0);\n\tvec4 color10 = envMapTexelToLinear(texture2D(envMap, uv_10));\n\tvec2 uv_20 = getCubeUV(reflectedDirection, r2, level0);\n\tvec4 color20 = envMapTexelToLinear(texture2D(envMap, uv_20));\n\tvec4 result = mix(color10, color20, t);\n\treturn vec4(result.rgb, 1.0);\n}\n#endif\n",
        defaultnormal_vertex: "#ifdef FLIP_SIDED\n\tobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;\n",
        displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif\n",
        displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normal * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n#endif\n",
        emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif\n",
        emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif\n",
        encodings_fragment: "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n",
        encodings_pars_fragment: "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( gammaFactor ) ), value.w );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.xyz, vec3( 1.0 / gammaFactor ) ), value.w );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.xyz * value.w * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat M      = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM            = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.x, max( value.g, value.b ) );\n\tfloat D      = max( maxRange / maxRGB, 1.0 );\n\tD            = min( floor( D ) / 255.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value )  {\n\tvec3 Xp_Y_XYZp = value.rgb * cLogLuvM;\n\tXp_Y_XYZp = max(Xp_Y_XYZp, vec3(1e-6, 1e-6, 1e-6));\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract(Le);\n\tvResult.z = (Le - (floor(vResult.w*255.0))/255.0)/255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = Xp_Y_XYZp.rgb * cLogLuvInverseM;\n\treturn vec4( max(vRGB, 0.0), 1.0 );\n}\n",
        envmap_fragment: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\tvec2 sampleUV;\n\t\tsampleUV.y = saturate( flipNormal * reflectVec.y * 0.5 + 0.5 );\n\t\tsampleUV.x = atan( flipNormal * reflectVec.z, flipNormal * reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\tvec4 envColor = texture2D( envMap, sampleUV );\n\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\tvec3 reflectView = flipNormal * normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) );\n\t\tvec4 envColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\tenvColor = envMapTexelToLinear( envColor );\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif\n",
        envmap_pars_fragment: "#if defined( USE_ENVMAP ) || defined( PHYSICAL )\n\tuniform float reflectivity;\n\tuniform float envMapIntensity;\n#endif\n#ifdef USE_ENVMAP\n\t#if ! defined( PHYSICAL ) && ( defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) )\n\t\tvarying vec3 vWorldPosition;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\tuniform float flipEnvMap;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( PHYSICAL )\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif\n",
        envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif\n",
        envmap_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif\n",
        fog_vertex: "\n#ifdef USE_FOG\nfogDepth = -mvPosition.z;\n#endif",
        fog_pars_vertex: "#ifdef USE_FOG\n  varying float fogDepth;\n#endif\n",
        fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = whiteCompliment( exp2( - fogDensity * fogDensity * fogDepth * fogDepth * LOG2 ) );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif\n",
        fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif\n",
        gradientmap_pars_fragment: "#ifdef TOON\n\tuniform sampler2D gradientMap;\n\tvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\t\tfloat dotNL = dot( normal, lightDirection );\n\t\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t\t#ifdef USE_GRADIENTMAP\n\t\t\treturn texture2D( gradientMap, coord ).rgb;\n\t\t#else\n\t\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t\t#endif\n\t}\n#endif\n",
        lightmap_fragment: "#ifdef USE_LIGHTMAP\n\treflectedLight.indirectDiffuse += PI * texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n#endif\n",
        lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
        lights_lambert_vertex: "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\n#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvLightFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n#endif\n",
        lights_pars: "uniform vec3 ambientLightColor;\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t\tint shadow;\n\t\tfloat shadowBias;\n\t\tfloat shadowRadius;\n\t\tvec2 shadowMapSize;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight  ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltcMat;\tuniform sampler2D ltcMag;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif\n#if defined( USE_ENVMAP ) && defined( PHYSICAL )\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\tvec4 envMapColor = textureCubeUV( queryVec, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar - 0.79248 - 0.5 * log2( pow2( blinnShininessExponent ) + 1.0 );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in GeometricContext geometry, const in float blinnShininessExponent, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -geometry.viewDir, geometry.normal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -geometry.viewDir, geometry.normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( blinnShininessExponent, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\tvec4 envMapColor = textureCubeUV(queryReflectVec, BlinnExponentToGGXRoughness(blinnShininessExponent));\n\t\t#elif defined( ENVMAP_TYPE_EQUIREC )\n\t\t\tvec2 sampleUV;\n\t\t\tsampleUV.y = saturate( reflectVec.y * 0.5 + 0.5 );\n\t\t\tsampleUV.x = atan( reflectVec.z, reflectVec.x ) * RECIPROCAL_PI2 + 0.5;\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, sampleUV, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, sampleUV, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_SPHERE )\n\t\t\tvec3 reflectView = normalize( ( viewMatrix * vec4( reflectVec, 0.0 ) ).xyz + vec3( 0.0,0.0,1.0 ) );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = texture2DLodEXT( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = texture2D( envMap, reflectView.xy * 0.5 + 0.5, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif\n",
        lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;\n",
        lights_phong_pars_fragment: "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3\tdiffuseColor;\n\tvec3\tspecularColor;\n\tfloat\tspecularShininess;\n\tfloat\tspecularStrength;\n};\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_BlinnPhong( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = BlinnExponentToGGXRoughness( material.specularShininess );\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifdef TOON\n\t\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#else\n\t\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\t\tvec3 irradiance = dotNL * directLight.color;\n\t#endif\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)\n",
        lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.specularRoughness = clamp( roughnessFactor, 0.04, 1.0 );\n#ifdef STANDARD\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.clearCoat = saturate( clearCoat );\tmaterial.clearCoatRoughness = clamp( clearCoatRoughness, 0.04, 1.0 );\n#endif\n",
        lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3\tdiffuseColor;\n\tfloat\tspecularRoughness;\n\tvec3\tspecularColor;\n\t#ifndef STANDARD\n\t\tfloat clearCoat;\n\t\tfloat clearCoatRoughness;\n\t#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearCoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos - halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos + halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos + halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos - halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tfloat norm = texture2D( ltcMag, uv ).a;\n\t\tvec4 t = texture2D( ltcMat, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3(   1,   0, t.y ),\n\t\t\tvec3(   0, t.z,   0 ),\n\t\t\tvec3( t.w,   0, t.x )\n\t\t);\n\t\treflectedLight.directSpecular += lightColor * material.specularColor * norm * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifndef STANDARD\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.directSpecular += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry, material.specularColor, material.specularRoughness );\n\treflectedLight.directDiffuse += ( 1.0 - clearCoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\t#ifndef STANDARD\n\t\treflectedLight.directSpecular += irradiance * material.clearCoat * BRDF_Specular_GGX( directLight, geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 clearCoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t#ifndef STANDARD\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\tfloat dotNL = dotNV;\n\t\tfloat clearCoatDHR = material.clearCoat * clearCoatDHRApprox( material.clearCoatRoughness, dotNL );\n\t#else\n\t\tfloat clearCoatDHR = 0.0;\n\t#endif\n\treflectedLight.indirectSpecular += ( 1.0 - clearCoatDHR ) * radiance * BRDF_Specular_GGX_Environment( geometry, material.specularColor, material.specularRoughness );\n\t#ifndef STANDARD\n\t\treflectedLight.indirectSpecular += clearCoatRadiance * material.clearCoat * BRDF_Specular_GGX_Environment( geometry, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearCoatRoughness );\n\t#endif\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\n#define Material_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.specularRoughness )\n#define Material_ClearCoat_BlinnShininessExponent( material )   GGXRoughnessToBlinnExponent( material.clearCoatRoughness )\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}\n",
        lights_template: "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = normalize( vViewPosition );\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( pointLight.shadow, directLight.visible ) ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( spotLight.shadow, directLight.visible ) ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#ifdef USE_SHADOWMAP\n\t\tdirectLight.color *= all( bvec2( directionalLight.shadow, directLight.visible ) ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#ifdef USE_LIGHTMAP\n\t\tvec3 lightMapIrradiance = texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( PHYSICAL ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tirradiance += getLightProbeIndirectIrradiance( geometry, 8 );\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tvec3 radiance = getLightProbeIndirectRadiance( geometry, Material_BlinnShininessExponent( material ), 8 );\n\t#ifndef STANDARD\n\t\tvec3 clearCoatRadiance = getLightProbeIndirectRadiance( geometry, Material_ClearCoat_BlinnShininessExponent( material ), 8 );\n\t#else\n\t\tvec3 clearCoatRadiance = vec3( 0.0 );\n\t#endif\n\tRE_IndirectSpecular( radiance, clearCoatRadiance, geometry, material, reflectedLight );\n#endif\n",
        logdepthbuf_fragment: "#if defined(USE_LOGDEPTHBUF) && defined(USE_LOGDEPTHBUF_EXT)\n\tgl_FragDepthEXT = log2(vFragDepth) * logDepthBufFC * 0.5;\n#endif",
        logdepthbuf_pars_fragment: "#ifdef USE_LOGDEPTHBUF\n\tuniform float logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n#endif\n",
        logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t#endif\n\tuniform float logDepthBufFC;\n#endif",
        logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\tgl_Position.z = log2(max( EPSILON, gl_Position.w + 1.0 )) * logDepthBufFC;\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t#else\n\t\tgl_Position.z = (gl_Position.z - 1.0) * gl_Position.w;\n\t#endif\n#endif\n",
        map_fragment: "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif\n",
        map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n",
        map_particle_fragment: "#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) * offsetRepeat.zw + offsetRepeat.xy );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n",
        map_particle_pars_fragment: "#ifdef USE_MAP\n\tuniform vec4 offsetRepeat;\n\tuniform sampler2D map;\n#endif\n",
        metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif\n",
        metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
        morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal += ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\n\tobjectNormal += ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\n\tobjectNormal += ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\n\tobjectNormal += ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\n#endif\n",
        morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_MORPHNORMALS\n\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif",
        morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\n\ttransformed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\n\ttransformed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\n\ttransformed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\ttransformed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\n\ttransformed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\n\ttransformed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\n\ttransformed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n\t#endif\n#endif\n",
        normal_flip: "#ifdef DOUBLE_SIDED\n\tfloat flipNormal = ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n#else\n\tfloat flipNormal = 1.0;\n#endif\n",
        normal_fragment: "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal ) * flipNormal;\n#endif\n#ifdef USE_NORMALMAP\n\tnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n",
        normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 S = normalize( q0 * st1.t - q1 * st0.t );\n\t\tvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\n\t\tvec3 N = normalize( surf_norm );\n\t\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t\tmapN.xy = normalScale * mapN.xy;\n\t\tmat3 tsn = mat3( S, T, N );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif\n",
        packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 1.0 - 2.0 * rgb.xyz;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256.,  256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}\n",
        premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif\n",
        project_vertex: "#ifdef USE_SKINNING\n\tvec4 mvPosition = modelViewMatrix * skinned;\n#else\n\tvec4 mvPosition = modelViewMatrix * vec4( transformed, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;\n",
        dithering_fragment: "#if defined( DITHERING )\n  gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif\n",
        dithering_pars_fragment: "#if defined( DITHERING )\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif\n",
        roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif\n",
        roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
        shadowmap_pars_fragment: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tfloat texture2DShadowLerp( sampler2D depths, vec2 size, vec2 uv, float compare ) {\n\t\tconst vec2 offset = vec2( 0.0, 1.0 );\n\t\tvec2 texelSize = vec2( 1.0 ) / size;\n\t\tvec2 centroidUV = floor( uv * size + 0.5 ) / size;\n\t\tfloat lb = texture2DCompare( depths, centroidUV + texelSize * offset.xx, compare );\n\t\tfloat lt = texture2DCompare( depths, centroidUV + texelSize * offset.xy, compare );\n\t\tfloat rb = texture2DCompare( depths, centroidUV + texelSize * offset.yx, compare );\n\t\tfloat rt = texture2DCompare( depths, centroidUV + texelSize * offset.yy, compare );\n\t\tvec2 f = fract( uv * size + 0.5 );\n\t\tfloat a = mix( lb, lt, f.y );\n\t\tfloat b = mix( rb, rt, f.y );\n\t\tfloat c = mix( a, b, f.x );\n\t\treturn c;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\treturn (\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DShadowLerp( shadowMap, shadowMapSize, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn 1.0;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tfloat dp = ( length( lightToPosition ) - shadowBias ) / 1000.0;\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif\n",
        shadowmap_pars_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHTS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHTS ];\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHTS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHTS ];\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHTS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHTS ];\n\t#endif\n#endif\n",
        shadowmap_vertex: "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * worldPosition;\n\t}\n\t#endif\n#endif\n",
        shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHTS > 0\n\tDirectionalLight directionalLight;\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tshadow *= bool( directionalLight.shadow ) ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_SPOT_LIGHTS > 0\n\tSpotLight spotLight;\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tshadow *= bool( spotLight.shadow ) ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#if NUM_POINT_LIGHTS > 0\n\tPointLight pointLight;\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tshadow *= bool( pointLight.shadow ) ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ] ) : 1.0;\n\t}\n\t#endif\n\t#endif\n\treturn shadow;\n}\n",
        skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
        skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif\n",
        skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\tskinned  = bindMatrixInverse * skinned;\n#endif\n",
        skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n#endif\n",
        specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
        specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
        tonemapping_fragment: "#if defined( TONE_MAPPING )\n  gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif\n",
        tonemapping_pars_fragment: "#define saturate(a) clamp( a, 0.0, 1.0 )\nuniform float toneMappingExposure;\nuniform float toneMappingWhitePoint;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\n#define Uncharted2Helper( x ) max( ( ( x * ( 0.15 * x + 0.10 * 0.50 ) + 0.20 * 0.02 ) / ( x * ( 0.15 * x + 0.50 ) + 0.20 * 0.30 ) ) - 0.02 / 0.30, vec3( 0.0 ) )\nvec3 Uncharted2ToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( Uncharted2Helper( color ) / Uncharted2Helper( vec3( toneMappingWhitePoint ) ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\n",
        uv_pars_fragment: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n#endif",
        uv_pars_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvarying vec2 vUv;\n\tuniform vec4 offsetRepeat;\n#endif\n",
        uv_vertex: "#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP ) || defined( USE_ALPHAMAP ) || defined( USE_EMISSIVEMAP ) || defined( USE_ROUGHNESSMAP ) || defined( USE_METALNESSMAP )\n\tvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif",
        uv2_pars_fragment: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
        uv2_pars_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n#endif",
        uv2_vertex: "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = uv2;\n#endif",
        worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( PHYSICAL ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n\t#ifdef USE_SKINNING\n\t\tvec4 worldPosition = modelMatrix * skinned;\n\t#else\n\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t#endif\n#endif\n",
        cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n\tgl_FragColor.a *= opacity;\n}\n",
        cube_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n",
        depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( gl_FragCoord.z ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( gl_FragCoord.z );\n\t#endif\n}\n",
        depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n}\n",
        distanceRGBA_frag: "uniform vec3 lightPos;\nvarying vec4 vWorldPosition;\n#include <common>\n#include <packing>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tgl_FragColor = packDepthToRGBA( length( vWorldPosition.xyz - lightPos.xyz ) / 1000.0 );\n}\n",
        distanceRGBA_vert: "varying vec4 vWorldPosition;\n#include <common>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <skinbase_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition;\n}\n",
        equirect_frag: "uniform sampler2D tEquirect;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldPosition );\n\tvec2 sampleUV;\n\tsampleUV.y = saturate( tFlip * direction.y * -0.5 + 0.5 );\n\tsampleUV.x = atan( direction.z, direction.x ) * RECIPROCAL_PI2 + 0.5;\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n}\n",
        equirect_vert: "varying vec3 vWorldPosition;\n#include <common>\nvoid main() {\n\tvWorldPosition = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}\n",
        linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
        linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\tvLineDistance = scale * lineDistance;\n\tvec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}\n",
        meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\treflectedLight.indirectDiffuse += texture2D( lightMap, vUv2 ).xyz * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
        meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}\n",
        meshlambert_frag: "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\treflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <normal_flip>\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
        meshlambert_vert: "#define LAMBERT\nvarying vec3 vLightFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
        meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
        meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
        meshphysical_frag: "#define PHYSICAL\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifndef STANDARD\n\tuniform float clearCoat;\n\tuniform float clearCoatRoughness;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <lights_pars>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_template>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}\n",
        meshphysical_vert: "#define PHYSICAL\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
        normal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\t#include <normal_flip>\n\t#include <normal_fragment>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}\n",
        normal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <displacementmap_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}\n",
        points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <premultiplied_alpha_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}\n",
        points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#ifdef USE_SIZEATTENUATION\n\t\tgl_PointSize = size * ( scale / - mvPosition.z );\n\t#else\n\t\tgl_PointSize = size;\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}\n",
        shadow_frag: "uniform float opacity;\n#include <common>\n#include <packing>\n#include <bsdfs>\n#include <lights_pars>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( 0.0, 0.0, 0.0, opacity * ( 1.0 - getShadowMask() ) );\n}\n",
        shadow_vert: "#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n}\n"
      },
      Ls = {
        basic: {
          uniforms: Bs.merge([Ps.common, Ps.aomap, Ps.lightmap, Ps.fog]),
          vertexShader: Ds.meshbasic_vert,
          fragmentShader: Ds.meshbasic_frag
        },
        lambert: {
          uniforms: Bs.merge([Ps.common, Ps.aomap, Ps.lightmap, Ps.emissivemap, Ps.fog, Ps.lights, {
            emissive: {
              value: new Y(0)
            }
          }]),
          vertexShader: Ds.meshlambert_vert,
          fragmentShader: Ds.meshlambert_frag
        },
        phong: {
          uniforms: Bs.merge([Ps.common, Ps.aomap, Ps.lightmap, Ps.emissivemap, Ps.bumpmap, Ps.normalmap, Ps.displacementmap, Ps.gradientmap, Ps.fog, Ps.lights, {
            emissive: {
              value: new Y(0)
            },
            specular: {
              value: new Y(1118481)
            },
            shininess: {
              value: 30
            }
          }]),
          vertexShader: Ds.meshphong_vert,
          fragmentShader: Ds.meshphong_frag
        },
        standard: {
          uniforms: Bs.merge([Ps.common, Ps.aomap, Ps.lightmap, Ps.emissivemap, Ps.bumpmap, Ps.normalmap, Ps.displacementmap, Ps.roughnessmap, Ps.metalnessmap, Ps.fog, Ps.lights, {
            emissive: {
              value: new Y(0)
            },
            roughness: {
              value: .5
            },
            metalness: {
              value: .5
            },
            envMapIntensity: {
              value: 1
            }
          }]),
          vertexShader: Ds.meshphysical_vert,
          fragmentShader: Ds.meshphysical_frag
        },
        points: {
          uniforms: Bs.merge([Ps.points, Ps.fog]),
          vertexShader: Ds.points_vert,
          fragmentShader: Ds.points_frag
        },
        dashed: {
          uniforms: Bs.merge([Ps.common, Ps.fog, {
            scale: {
              value: 1
            },
            dashSize: {
              value: 1
            },
            totalSize: {
              value: 2
            }
          }]),
          vertexShader: Ds.linedashed_vert,
          fragmentShader: Ds.linedashed_frag
        },
        depth: {
          uniforms: Bs.merge([Ps.common, Ps.displacementmap]),
          vertexShader: Ds.depth_vert,
          fragmentShader: Ds.depth_frag
        },
        normal: {
          uniforms: Bs.merge([Ps.common, Ps.bumpmap, Ps.normalmap, Ps.displacementmap, {
            opacity: {
              value: 1
            }
          }]),
          vertexShader: Ds.normal_vert,
          fragmentShader: Ds.normal_frag
        },
        cube: {
          uniforms: {
            tCube: {
              value: null
            },
            tFlip: {
              value: -1
            },
            opacity: {
              value: 1
            }
          },
          vertexShader: Ds.cube_vert,
          fragmentShader: Ds.cube_frag
        },
        equirect: {
          uniforms: {
            tEquirect: {
              value: null
            },
            tFlip: {
              value: -1
            }
          },
          vertexShader: Ds.equirect_vert,
          fragmentShader: Ds.equirect_frag
        },
        distanceRGBA: {
          uniforms: {
            lightPos: {
              value: new u()
            }
          },
          vertexShader: Ds.distanceRGBA_vert,
          fragmentShader: Ds.distanceRGBA_frag
        }
      };
    Ls.physical = {
      uniforms: Bs.merge([Ls.standard.uniforms, {
        clearCoat: {
          value: 0
        },
        clearCoatRoughness: {
          value: 0
        }
      }]),
      vertexShader: Ds.meshphysical_vert,
      fragmentShader: Ds.meshphysical_frag
    }, Object.assign(K.prototype, {
      set: function set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
      },
      setFromPoints: function setFromPoints(e) {
        this.makeEmpty();
        for (var t = 0, r = e.length; t < r; t++) this.expandByPoint(e[t]);
        return this;
      },
      setFromCenterAndSize: function () {
        var e = new i();
        return function (t, r) {
          var n = e.copy(r).multiplyScalar(.5);
          return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
        };
      }(),
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
      },
      makeEmpty: function makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
      },
      isEmpty: function isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
      },
      getCenter: function getCenter(e) {
        var t = e || new i();
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
      },
      getSize: function getSize(e) {
        var t = e || new i();
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
      },
      expandByPoint: function expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
      },
      expandByVector: function expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
      },
      expandByScalar: function expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
      },
      containsPoint: function containsPoint(e) {
        return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y);
      },
      containsBox: function containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y;
      },
      getParameter: function getParameter(e, t) {
        return (t || new i()).set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y));
      },
      intersectsBox: function intersectsBox(e) {
        return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y);
      },
      clampPoint: function clampPoint(e, t) {
        return (t || new i()).copy(e).clamp(this.min, this.max);
      },
      distanceToPoint: function () {
        var e = new i();
        return function (t) {
          return e.copy(t).clamp(this.min, this.max).sub(t).length();
        };
      }(),
      intersect: function intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this;
      },
      union: function union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
      },
      translate: function translate(e) {
        return this.min.add(e), this.max.add(e), this;
      },
      equals: function equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
      }
    });
    var Fs = 0;
    Object.assign(Q.prototype, n.prototype, {
      isMaterial: !0,
      setValues: function setValues(e) {
        if (void 0 !== e) for (var t in e) {
          var r = e[t];
          if (void 0 !== r) {
            var n = this[t];
            void 0 !== n ? n && n.isColor ? n.set(r) : n && n.isVector3 && r && r.isVector3 ? n.copy(r) : this[t] = "overdraw" === t ? Number(r) : r : console.warn("THREE." + this.type + ": '" + t + "' is not a property of this material.");
          } else console.warn("THREE.Material: '" + t + "' parameter is undefined.");
        }
      },
      toJSON: function toJSON(e) {
        function t(e) {
          var t = [];
          for (var r in e) {
            var n = e[r];
            delete n.metadata, t.push(n);
          }
          return t;
        }
        var r = void 0 === e;
        r && (e = {
          textures: {},
          images: {}
        });
        var n = {
          metadata: {
            version: 4.5,
            type: "Material",
            generator: "Material.toJSON"
          }
        };
        if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearCoat && (n.clearCoat = this.clearCoat), void 0 !== this.clearCoatRoughness && (n.clearCoatRoughness = this.clearCoatRoughness), this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e).uuid), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e).uuid, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e).uuid, n.reflectivity = this.reflectivity), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid), void 0 !== this.size && (n.size = this.size), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== Ea && (n.blending = this.blending), this.shading !== wa && (n.shading = this.shading), this.side !== ga && (n.side = this.side), this.vertexColors !== xa && (n.vertexColors = this.vertexColors), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = this.premultipliedAlpha), !0 === this.wireframe && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), n.skinning = this.skinning, n.morphTargets = this.morphTargets, n.dithering = this.dithering, r) {
          var i = t(e.textures),
            a = t(e.images);
          i.length > 0 && (n.textures = i), a.length > 0 && (n.images = a);
        }
        return n;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        this.name = e.name, this.fog = e.fog, this.lights = e.lights, this.blending = e.blending, this.side = e.side, this.shading = e.shading, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.premultipliedAlpha = e.premultipliedAlpha, this.overdraw = e.overdraw, this.visible = e.visible, this.clipShadows = e.clipShadows, this.clipIntersection = e.clipIntersection;
        var t = e.clippingPlanes,
          r = null;
        if (null !== t) {
          var n = t.length;
          r = new Array(n);
          for (var i = 0; i !== n; ++i) r[i] = t[i].clone();
        }
        return this.clippingPlanes = r, this;
      },
      dispose: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }), $.prototype = Object.create(Q.prototype), $.prototype.constructor = $, $.prototype.isShaderMaterial = !0, $.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = Bs.clone(e.uniforms), this.defines = e.defines, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.lights = e.lights, this.clipping = e.clipping, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this.extensions = e.extensions, this;
    }, $.prototype.toJSON = function (e) {
      var t = Q.prototype.toJSON.call(this, e);
      return t.uniforms = this.uniforms, t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t;
    }, ee.prototype = Object.create(Q.prototype), ee.prototype.constructor = ee, ee.prototype.isMeshDepthMaterial = !0, ee.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.depthPacking = e.depthPacking, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
    }, Object.assign(te.prototype, {
      isBox3: !0,
      set: function set(e, t) {
        return this.min.copy(e), this.max.copy(t), this;
      },
      setFromArray: function setFromArray(e) {
        for (var t = 1 / 0, r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = e.length; s < l; s += 3) {
          var c = e[s],
            u = e[s + 1],
            h = e[s + 2];
          c < t && (t = c), u < r && (r = u), h < n && (n = h), c > i && (i = c), u > a && (a = u), h > o && (o = h);
        }
        return this.min.set(t, r, n), this.max.set(i, a, o), this;
      },
      setFromBufferAttribute: function setFromBufferAttribute(e) {
        for (var t = 1 / 0, r = 1 / 0, n = 1 / 0, i = -1 / 0, a = -1 / 0, o = -1 / 0, s = 0, l = e.count; s < l; s++) {
          var c = e.getX(s),
            u = e.getY(s),
            h = e.getZ(s);
          c < t && (t = c), u < r && (r = u), h < n && (n = h), c > i && (i = c), u > a && (a = u), h > o && (o = h);
        }
        return this.min.set(t, r, n), this.max.set(i, a, o), this;
      },
      setFromPoints: function setFromPoints(e) {
        this.makeEmpty();
        for (var t = 0, r = e.length; t < r; t++) this.expandByPoint(e[t]);
        return this;
      },
      setFromCenterAndSize: function () {
        var e = new u();
        return function (t, r) {
          var n = e.copy(r).multiplyScalar(.5);
          return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
        };
      }(),
      setFromObject: function setFromObject(e) {
        return this.makeEmpty(), this.expandByObject(e);
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.min.copy(e.min), this.max.copy(e.max), this;
      },
      makeEmpty: function makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
      },
      isEmpty: function isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
      },
      getCenter: function getCenter(e) {
        var t = e || new u();
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
      },
      getSize: function getSize(e) {
        var t = e || new u();
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
      },
      expandByPoint: function expandByPoint(e) {
        return this.min.min(e), this.max.max(e), this;
      },
      expandByVector: function expandByVector(e) {
        return this.min.sub(e), this.max.add(e), this;
      },
      expandByScalar: function expandByScalar(e) {
        return this.min.addScalar(-e), this.max.addScalar(e), this;
      },
      expandByObject: function () {
        var e = new u();
        return function (t) {
          var r = this;
          return t.updateMatrixWorld(!0), t.traverse(function (t) {
            var n,
              i,
              a = t.geometry;
            if (void 0 !== a) if (a.isGeometry) {
              var o = a.vertices;
              for (n = 0, i = o.length; n < i; n++) e.copy(o[n]), e.applyMatrix4(t.matrixWorld), r.expandByPoint(e);
            } else if (a.isBufferGeometry) {
              var s = a.attributes.position;
              if (void 0 !== s) for (n = 0, i = s.count; n < i; n++) e.fromBufferAttribute(s, n).applyMatrix4(t.matrixWorld), r.expandByPoint(e);
            }
          }), this;
        };
      }(),
      containsPoint: function containsPoint(e) {
        return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
      },
      containsBox: function containsBox(e) {
        return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
      },
      getParameter: function getParameter(e, t) {
        return (t || new u()).set((e.x - this.min.x) / (this.max.x - this.min.x), (e.y - this.min.y) / (this.max.y - this.min.y), (e.z - this.min.z) / (this.max.z - this.min.z));
      },
      intersectsBox: function intersectsBox(e) {
        return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
      },
      intersectsSphere: function () {
        var e = new u();
        return function (t) {
          return this.clampPoint(t.center, e), e.distanceToSquared(t.center) <= t.radius * t.radius;
        };
      }(),
      intersectsPlane: function intersectsPlane(e) {
        var t, r;
        return e.normal.x > 0 ? (t = e.normal.x * this.min.x, r = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, r = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, r += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, r += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, r += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, r += e.normal.z * this.min.z), t <= e.constant && r >= e.constant;
      },
      clampPoint: function clampPoint(e, t) {
        return (t || new u()).copy(e).clamp(this.min, this.max);
      },
      distanceToPoint: function () {
        var e = new u();
        return function (t) {
          return e.copy(t).clamp(this.min, this.max).sub(t).length();
        };
      }(),
      getBoundingSphere: function () {
        var e = new u();
        return function (t) {
          var r = t || new re();
          return this.getCenter(r.center), r.radius = .5 * this.getSize(e).length(), r;
        };
      }(),
      intersect: function intersect(e) {
        return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
      },
      union: function union(e) {
        return this.min.min(e.min), this.max.max(e.max), this;
      },
      applyMatrix4: function () {
        var e = [new u(), new u(), new u(), new u(), new u(), new u(), new u(), new u()];
        return function (t) {
          return this.isEmpty() ? this : (e[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), e[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), e[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), e[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), e[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), e[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), e[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), e[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(e), this);
        };
      }(),
      translate: function translate(e) {
        return this.min.add(e), this.max.add(e), this;
      },
      equals: function equals(e) {
        return e.min.equals(this.min) && e.max.equals(this.max);
      }
    }), Object.assign(re.prototype, {
      set: function set(e, t) {
        return this.center.copy(e), this.radius = t, this;
      },
      setFromPoints: function () {
        var e = new te();
        return function (t, r) {
          var n = this.center;
          void 0 !== r ? n.copy(r) : e.setFromPoints(t).getCenter(n);
          for (var i = 0, a = 0, o = t.length; a < o; a++) i = Math.max(i, n.distanceToSquared(t[a]));
          return this.radius = Math.sqrt(i), this;
        };
      }(),
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.center.copy(e.center), this.radius = e.radius, this;
      },
      empty: function empty() {
        return this.radius <= 0;
      },
      containsPoint: function containsPoint(e) {
        return e.distanceToSquared(this.center) <= this.radius * this.radius;
      },
      distanceToPoint: function distanceToPoint(e) {
        return e.distanceTo(this.center) - this.radius;
      },
      intersectsSphere: function intersectsSphere(e) {
        var t = this.radius + e.radius;
        return e.center.distanceToSquared(this.center) <= t * t;
      },
      intersectsBox: function intersectsBox(e) {
        return e.intersectsSphere(this);
      },
      intersectsPlane: function intersectsPlane(e) {
        return Math.abs(this.center.dot(e.normal) - e.constant) <= this.radius;
      },
      clampPoint: function clampPoint(e, t) {
        var r = this.center.distanceToSquared(e),
          n = t || new u();
        return n.copy(e), r > this.radius * this.radius && (n.sub(this.center).normalize(), n.multiplyScalar(this.radius).add(this.center)), n;
      },
      getBoundingBox: function getBoundingBox(e) {
        var t = e || new te();
        return t.set(this.center, this.center), t.expandByScalar(this.radius), t;
      },
      applyMatrix4: function applyMatrix4(e) {
        return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
      },
      translate: function translate(e) {
        return this.center.add(e), this;
      },
      equals: function equals(e) {
        return e.center.equals(this.center) && e.radius === this.radius;
      }
    }), Object.assign(ne.prototype, {
      isMatrix3: !0,
      set: function set(e, t, r, n, i, a, o, s, l) {
        var c = this.elements;
        return c[0] = e, c[1] = n, c[2] = o, c[3] = t, c[4] = i, c[5] = s, c[6] = r, c[7] = a, c[8] = l, this;
      },
      identity: function identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
      },
      clone: function clone() {
        return new this.constructor().fromArray(this.elements);
      },
      copy: function copy(e) {
        var t = this.elements,
          r = e.elements;
        return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4], t[5] = r[5], t[6] = r[6], t[7] = r[7], t[8] = r[8], this;
      },
      setFromMatrix4: function setFromMatrix4(e) {
        var t = e.elements;
        return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
      },
      applyToBufferAttribute: function () {
        var e = new u();
        return function (t) {
          for (var r = 0, n = t.count; r < n; r++) e.x = t.getX(r), e.y = t.getY(r), e.z = t.getZ(r), e.applyMatrix3(this), t.setXYZ(r, e.x, e.y, e.z);
          return t;
        };
      }(),
      multiply: function multiply(e) {
        return this.multiplyMatrices(this, e);
      },
      premultiply: function premultiply(e) {
        return this.multiplyMatrices(e, this);
      },
      multiplyMatrices: function multiplyMatrices(e, t) {
        var r = e.elements,
          n = t.elements,
          i = this.elements,
          a = r[0],
          o = r[3],
          s = r[6],
          l = r[1],
          c = r[4],
          u = r[7],
          h = r[2],
          f = r[5],
          d = r[8],
          p = n[0],
          m = n[3],
          g = n[6],
          v = n[1],
          b = n[4],
          y = n[7],
          w = n[2],
          x = n[5],
          _ = n[8];
        return i[0] = a * p + o * v + s * w, i[3] = a * m + o * b + s * x, i[6] = a * g + o * y + s * _, i[1] = l * p + c * v + u * w, i[4] = l * m + c * b + u * x, i[7] = l * g + c * y + u * _, i[2] = h * p + f * v + d * w, i[5] = h * m + f * b + d * x, i[8] = h * g + f * y + d * _, this;
      },
      multiplyScalar: function multiplyScalar(e) {
        var t = this.elements;
        return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
      },
      determinant: function determinant() {
        var e = this.elements,
          t = e[0],
          r = e[1],
          n = e[2],
          i = e[3],
          a = e[4],
          o = e[5],
          s = e[6],
          l = e[7],
          c = e[8];
        return t * a * c - t * o * l - r * i * c + r * o * s + n * i * l - n * a * s;
      },
      getInverse: function getInverse(e, t) {
        e && e.isMatrix4 && console.error("THREE.Matrix3.getInverse no longer takes a Matrix4 argument.");
        var r = e.elements,
          n = this.elements,
          i = r[0],
          a = r[1],
          o = r[2],
          s = r[3],
          l = r[4],
          c = r[5],
          u = r[6],
          h = r[7],
          f = r[8],
          d = f * l - c * h,
          p = c * u - f * s,
          m = h * s - l * u,
          g = i * d + a * p + o * m;
        if (0 === g) {
          var v = "THREE.Matrix3.getInverse(): can't invert matrix, determinant is 0";
          if (!0 === t) throw new Error(v);
          return console.warn(v), this.identity();
        }
        var b = 1 / g;
        return n[0] = d * b, n[1] = (o * h - f * a) * b, n[2] = (c * a - o * l) * b, n[3] = p * b, n[4] = (f * i - o * u) * b, n[5] = (o * s - c * i) * b, n[6] = m * b, n[7] = (a * u - h * i) * b, n[8] = (l * i - a * s) * b, this;
      },
      transpose: function transpose() {
        var e,
          t = this.elements;
        return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
      },
      getNormalMatrix: function getNormalMatrix(e) {
        return this.setFromMatrix4(e).getInverse(this).transpose();
      },
      transposeIntoArray: function transposeIntoArray(e) {
        var t = this.elements;
        return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
      },
      equals: function equals(e) {
        for (var t = this.elements, r = e.elements, n = 0; n < 9; n++) if (t[n] !== r[n]) return !1;
        return !0;
      },
      fromArray: function fromArray(e, t) {
        void 0 === t && (t = 0);
        for (var r = 0; r < 9; r++) this.elements[r] = e[r + t];
        return this;
      },
      toArray: function toArray(e, t) {
        void 0 === e && (e = []), void 0 === t && (t = 0);
        var r = this.elements;
        return e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = r[3], e[t + 4] = r[4], e[t + 5] = r[5], e[t + 6] = r[6], e[t + 7] = r[7], e[t + 8] = r[8], e;
      }
    }), Object.assign(ie.prototype, {
      set: function set(e, t) {
        return this.normal.copy(e), this.constant = t, this;
      },
      setComponents: function setComponents(e, t, r, n) {
        return this.normal.set(e, t, r), this.constant = n, this;
      },
      setFromNormalAndCoplanarPoint: function setFromNormalAndCoplanarPoint(e, t) {
        return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
      },
      setFromCoplanarPoints: function () {
        var e = new u(),
          t = new u();
        return function (r, n, i) {
          var a = e.subVectors(i, n).cross(t.subVectors(r, n)).normalize();
          return this.setFromNormalAndCoplanarPoint(a, r), this;
        };
      }(),
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.normal.copy(e.normal), this.constant = e.constant, this;
      },
      normalize: function normalize() {
        var e = 1 / this.normal.length();
        return this.normal.multiplyScalar(e), this.constant *= e, this;
      },
      negate: function negate() {
        return this.constant *= -1, this.normal.negate(), this;
      },
      distanceToPoint: function distanceToPoint(e) {
        return this.normal.dot(e) + this.constant;
      },
      distanceToSphere: function distanceToSphere(e) {
        return this.distanceToPoint(e.center) - e.radius;
      },
      projectPoint: function projectPoint(e, t) {
        return this.orthoPoint(e, t).sub(e).negate();
      },
      orthoPoint: function orthoPoint(e, t) {
        var r = this.distanceToPoint(e);
        return (t || new u()).copy(this.normal).multiplyScalar(r);
      },
      intersectLine: function () {
        var e = new u();
        return function (t, r) {
          var n = r || new u(),
            i = t.delta(e),
            a = this.normal.dot(i);
          if (0 !== a) {
            var o = -(t.start.dot(this.normal) + this.constant) / a;
            if (!(o < 0 || o > 1)) return n.copy(i).multiplyScalar(o).add(t.start);
          } else if (0 === this.distanceToPoint(t.start)) return n.copy(t.start);
        };
      }(),
      intersectsLine: function intersectsLine(e) {
        var t = this.distanceToPoint(e.start),
          r = this.distanceToPoint(e.end);
        return t < 0 && r > 0 || r < 0 && t > 0;
      },
      intersectsBox: function intersectsBox(e) {
        return e.intersectsPlane(this);
      },
      intersectsSphere: function intersectsSphere(e) {
        return e.intersectsPlane(this);
      },
      coplanarPoint: function coplanarPoint(e) {
        return (e || new u()).copy(this.normal).multiplyScalar(-this.constant);
      },
      applyMatrix4: function () {
        var e = new u(),
          t = new ne();
        return function (r, n) {
          var i = this.coplanarPoint(e).applyMatrix4(r),
            a = n || t.getNormalMatrix(r),
            o = this.normal.applyMatrix3(a).normalize();
          return this.constant = -i.dot(o), this;
        };
      }(),
      translate: function translate(e) {
        return this.constant = this.constant - e.dot(this.normal), this;
      },
      equals: function equals(e) {
        return e.normal.equals(this.normal) && e.constant === this.constant;
      }
    }), Object.assign(ae.prototype, {
      set: function set(e, t, r, n, i, a) {
        var o = this.planes;
        return o[0].copy(e), o[1].copy(t), o[2].copy(r), o[3].copy(n), o[4].copy(i), o[5].copy(a), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        for (var t = this.planes, r = 0; r < 6; r++) t[r].copy(e.planes[r]);
        return this;
      },
      setFromMatrix: function setFromMatrix(e) {
        var t = this.planes,
          r = e.elements,
          n = r[0],
          i = r[1],
          a = r[2],
          o = r[3],
          s = r[4],
          l = r[5],
          c = r[6],
          u = r[7],
          h = r[8],
          f = r[9],
          d = r[10],
          p = r[11],
          m = r[12],
          g = r[13],
          v = r[14],
          b = r[15];
        return t[0].setComponents(o - n, u - s, p - h, b - m).normalize(), t[1].setComponents(o + n, u + s, p + h, b + m).normalize(), t[2].setComponents(o + i, u + l, p + f, b + g).normalize(), t[3].setComponents(o - i, u - l, p - f, b - g).normalize(), t[4].setComponents(o - a, u - c, p - d, b - v).normalize(), t[5].setComponents(o + a, u + c, p + d, b + v).normalize(), this;
      },
      intersectsObject: function () {
        var e = new re();
        return function (t) {
          var r = t.geometry;
          return null === r.boundingSphere && r.computeBoundingSphere(), e.copy(r.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(e);
        };
      }(),
      intersectsSprite: function () {
        var e = new re();
        return function (t) {
          return e.center.set(0, 0, 0), e.radius = .7071067811865476, e.applyMatrix4(t.matrixWorld), this.intersectsSphere(e);
        };
      }(),
      intersectsSphere: function intersectsSphere(e) {
        for (var t = this.planes, r = e.center, n = -e.radius, i = 0; i < 6; i++) {
          if (t[i].distanceToPoint(r) < n) return !1;
        }
        return !0;
      },
      intersectsBox: function () {
        var e = new u(),
          t = new u();
        return function (r) {
          for (var n = this.planes, i = 0; i < 6; i++) {
            var a = n[i];
            e.x = a.normal.x > 0 ? r.min.x : r.max.x, t.x = a.normal.x > 0 ? r.max.x : r.min.x, e.y = a.normal.y > 0 ? r.min.y : r.max.y, t.y = a.normal.y > 0 ? r.max.y : r.min.y, e.z = a.normal.z > 0 ? r.min.z : r.max.z, t.z = a.normal.z > 0 ? r.max.z : r.min.z;
            var o = a.distanceToPoint(e),
              s = a.distanceToPoint(t);
            if (o < 0 && s < 0) return !1;
          }
          return !0;
        };
      }(),
      containsPoint: function containsPoint(e) {
        for (var t = this.planes, r = 0; r < 6; r++) if (t[r].distanceToPoint(e) < 0) return !1;
        return !0;
      }
    }), Object.assign(se.prototype, {
      set: function set(e, t) {
        return this.origin.copy(e), this.direction.copy(t), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
      },
      at: function at(e, t) {
        return (t || new u()).copy(this.direction).multiplyScalar(e).add(this.origin);
      },
      lookAt: function lookAt(e) {
        return this.direction.copy(e).sub(this.origin).normalize(), this;
      },
      recast: function () {
        var e = new u();
        return function (t) {
          return this.origin.copy(this.at(t, e)), this;
        };
      }(),
      closestPointToPoint: function closestPointToPoint(e, t) {
        var r = t || new u();
        r.subVectors(e, this.origin);
        var n = r.dot(this.direction);
        return n < 0 ? r.copy(this.origin) : r.copy(this.direction).multiplyScalar(n).add(this.origin);
      },
      distanceToPoint: function distanceToPoint(e) {
        return Math.sqrt(this.distanceSqToPoint(e));
      },
      distanceSqToPoint: function () {
        var e = new u();
        return function (t) {
          var r = e.subVectors(t, this.origin).dot(this.direction);
          return r < 0 ? this.origin.distanceToSquared(t) : (e.copy(this.direction).multiplyScalar(r).add(this.origin), e.distanceToSquared(t));
        };
      }(),
      distanceSqToSegment: function () {
        var e = new u(),
          t = new u(),
          r = new u();
        return function (n, i, a, o) {
          e.copy(n).add(i).multiplyScalar(.5), t.copy(i).sub(n).normalize(), r.copy(this.origin).sub(e);
          var s,
            l,
            c,
            u,
            h = .5 * n.distanceTo(i),
            f = -this.direction.dot(t),
            d = r.dot(this.direction),
            p = -r.dot(t),
            m = r.lengthSq(),
            g = Math.abs(1 - f * f);
          if (g > 0) {
            if (s = f * p - d, l = f * d - p, u = h * g, s >= 0) {
              if (l >= -u) {
                if (l <= u) {
                  var v = 1 / g;
                  s *= v, l *= v, c = s * (s + f * l + 2 * d) + l * (f * s + l + 2 * p) + m;
                } else l = h, s = Math.max(0, -(f * l + d)), c = -s * s + l * (l + 2 * p) + m;
              } else l = -h, s = Math.max(0, -(f * l + d)), c = -s * s + l * (l + 2 * p) + m;
            } else l <= -u ? (s = Math.max(0, -(-f * h + d)), l = s > 0 ? -h : Math.min(Math.max(-h, -p), h), c = -s * s + l * (l + 2 * p) + m) : l <= u ? (s = 0, l = Math.min(Math.max(-h, -p), h), c = l * (l + 2 * p) + m) : (s = Math.max(0, -(f * h + d)), l = s > 0 ? h : Math.min(Math.max(-h, -p), h), c = -s * s + l * (l + 2 * p) + m);
          } else l = f > 0 ? -h : h, s = Math.max(0, -(f * l + d)), c = -s * s + l * (l + 2 * p) + m;
          return a && a.copy(this.direction).multiplyScalar(s).add(this.origin), o && o.copy(t).multiplyScalar(l).add(e), c;
        };
      }(),
      intersectSphere: function () {
        var e = new u();
        return function (t, r) {
          e.subVectors(t.center, this.origin);
          var n = e.dot(this.direction),
            i = e.dot(e) - n * n,
            a = t.radius * t.radius;
          if (i > a) return null;
          var o = Math.sqrt(a - i),
            s = n - o,
            l = n + o;
          return s < 0 && l < 0 ? null : s < 0 ? this.at(l, r) : this.at(s, r);
        };
      }(),
      intersectsSphere: function intersectsSphere(e) {
        return this.distanceToPoint(e.center) <= e.radius;
      },
      distanceToPlane: function distanceToPlane(e) {
        var t = e.normal.dot(this.direction);
        if (0 === t) return 0 === e.distanceToPoint(this.origin) ? 0 : null;
        var r = -(this.origin.dot(e.normal) + e.constant) / t;
        return r >= 0 ? r : null;
      },
      intersectPlane: function intersectPlane(e, t) {
        var r = this.distanceToPlane(e);
        return null === r ? null : this.at(r, t);
      },
      intersectsPlane: function intersectsPlane(e) {
        var t = e.distanceToPoint(this.origin);
        return 0 === t || e.normal.dot(this.direction) * t < 0;
      },
      intersectBox: function intersectBox(e, t) {
        var r,
          n,
          i,
          a,
          o,
          s,
          l = 1 / this.direction.x,
          c = 1 / this.direction.y,
          u = 1 / this.direction.z,
          h = this.origin;
        return l >= 0 ? (r = (e.min.x - h.x) * l, n = (e.max.x - h.x) * l) : (r = (e.max.x - h.x) * l, n = (e.min.x - h.x) * l), c >= 0 ? (i = (e.min.y - h.y) * c, a = (e.max.y - h.y) * c) : (i = (e.max.y - h.y) * c, a = (e.min.y - h.y) * c), r > a || i > n ? null : ((i > r || r !== r) && (r = i), (a < n || n !== n) && (n = a), u >= 0 ? (o = (e.min.z - h.z) * u, s = (e.max.z - h.z) * u) : (o = (e.max.z - h.z) * u, s = (e.min.z - h.z) * u), r > s || o > n ? null : ((o > r || r !== r) && (r = o), (s < n || n !== n) && (n = s), n < 0 ? null : this.at(r >= 0 ? r : n, t)));
      },
      intersectsBox: function () {
        var e = new u();
        return function (t) {
          return null !== this.intersectBox(t, e);
        };
      }(),
      intersectTriangle: function () {
        var e = new u(),
          t = new u(),
          r = new u(),
          n = new u();
        return function (i, a, o, s, l) {
          t.subVectors(a, i), r.subVectors(o, i), n.crossVectors(t, r);
          var c,
            u = this.direction.dot(n);
          if (u > 0) {
            if (s) return null;
            c = 1;
          } else {
            if (!(u < 0)) return null;
            c = -1, u = -u;
          }
          e.subVectors(this.origin, i);
          var h = c * this.direction.dot(r.crossVectors(e, r));
          if (h < 0) return null;
          var f = c * this.direction.dot(t.cross(e));
          if (f < 0) return null;
          if (h + f > u) return null;
          var d = -c * e.dot(n);
          return d < 0 ? null : this.at(d / u, l);
        };
      }(),
      applyMatrix4: function applyMatrix4(e) {
        return this.direction.add(this.origin).applyMatrix4(e), this.origin.applyMatrix4(e), this.direction.sub(this.origin), this.direction.normalize(), this;
      },
      equals: function equals(e) {
        return e.origin.equals(this.origin) && e.direction.equals(this.direction);
      }
    }), le.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"], le.DefaultOrder = "XYZ", Object.defineProperties(le.prototype, {
      x: {
        get: function get() {
          return this._x;
        },
        set: function set(e) {
          this._x = e, this.onChangeCallback();
        }
      },
      y: {
        get: function get() {
          return this._y;
        },
        set: function set(e) {
          this._y = e, this.onChangeCallback();
        }
      },
      z: {
        get: function get() {
          return this._z;
        },
        set: function set(e) {
          this._z = e, this.onChangeCallback();
        }
      },
      order: {
        get: function get() {
          return this._order;
        },
        set: function set(e) {
          this._order = e, this.onChangeCallback();
        }
      }
    }), Object.assign(le.prototype, {
      isEuler: !0,
      set: function set(e, t, r, n) {
        return this._x = e, this._y = t, this._z = r, this._order = n || this._order, this.onChangeCallback(), this;
      },
      clone: function clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
      },
      copy: function copy(e) {
        return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this.onChangeCallback(), this;
      },
      setFromRotationMatrix: function setFromRotationMatrix(e, t, r) {
        var n = Ss.clamp,
          i = e.elements,
          a = i[0],
          o = i[4],
          s = i[8],
          l = i[1],
          c = i[5],
          u = i[9],
          h = i[2],
          f = i[6],
          d = i[10];
        return t = t || this._order, "XYZ" === t ? (this._y = Math.asin(n(s, -1, 1)), Math.abs(s) < .99999 ? (this._x = Math.atan2(-u, d), this._z = Math.atan2(-o, a)) : (this._x = Math.atan2(f, c), this._z = 0)) : "YXZ" === t ? (this._x = Math.asin(-n(u, -1, 1)), Math.abs(u) < .99999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(l, c)) : (this._y = Math.atan2(-h, a), this._z = 0)) : "ZXY" === t ? (this._x = Math.asin(n(f, -1, 1)), Math.abs(f) < .99999 ? (this._y = Math.atan2(-h, d), this._z = Math.atan2(-o, c)) : (this._y = 0, this._z = Math.atan2(l, a))) : "ZYX" === t ? (this._y = Math.asin(-n(h, -1, 1)), Math.abs(h) < .99999 ? (this._x = Math.atan2(f, d), this._z = Math.atan2(l, a)) : (this._x = 0, this._z = Math.atan2(-o, c))) : "YZX" === t ? (this._z = Math.asin(n(l, -1, 1)), Math.abs(l) < .99999 ? (this._x = Math.atan2(-u, c), this._y = Math.atan2(-h, a)) : (this._x = 0, this._y = Math.atan2(s, d))) : "XZY" === t ? (this._z = Math.asin(-n(o, -1, 1)), Math.abs(o) < .99999 ? (this._x = Math.atan2(f, c), this._y = Math.atan2(s, a)) : (this._x = Math.atan2(-u, d), this._y = 0)) : console.warn("THREE.Euler: .setFromRotationMatrix() given unsupported order: " + t), this._order = t, !1 !== r && this.onChangeCallback(), this;
      },
      setFromQuaternion: function () {
        var e = new h();
        return function (t, r, n) {
          return e.makeRotationFromQuaternion(t), this.setFromRotationMatrix(e, r, n);
        };
      }(),
      setFromVector3: function setFromVector3(e, t) {
        return this.set(e.x, e.y, e.z, t || this._order);
      },
      reorder: function () {
        var e = new c();
        return function (t) {
          return e.setFromEuler(this), this.setFromQuaternion(e, t);
        };
      }(),
      equals: function equals(e) {
        return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
      },
      fromArray: function fromArray(e) {
        return this._x = e[0], this._y = e[1], this._z = e[2], void 0 !== e[3] && (this._order = e[3]), this.onChangeCallback(), this;
      },
      toArray: function toArray(e, t) {
        return void 0 === e && (e = []), void 0 === t && (t = 0), e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
      },
      toVector3: function toVector3(e) {
        return e ? e.set(this._x, this._y, this._z) : new u(this._x, this._y, this._z);
      },
      onChange: function onChange(e) {
        return this.onChangeCallback = e, this;
      },
      onChangeCallback: function onChangeCallback() {}
    }), Object.assign(ce.prototype, {
      set: function set(e) {
        this.mask = 1 << e | 0;
      },
      enable: function enable(e) {
        this.mask |= 1 << e | 0;
      },
      toggle: function toggle(e) {
        this.mask ^= 1 << e | 0;
      },
      disable: function disable(e) {
        this.mask &= ~(1 << e | 0);
      },
      test: function test(e) {
        return 0 != (this.mask & e.mask);
      }
    });
    var Ns = 0;
    ue.DefaultUp = new u(0, 1, 0), ue.DefaultMatrixAutoUpdate = !0, Object.assign(ue.prototype, n.prototype, {
      isObject3D: !0,
      applyMatrix: function applyMatrix(e) {
        this.matrix.multiplyMatrices(e, this.matrix), this.matrix.decompose(this.position, this.quaternion, this.scale);
      },
      setRotationFromAxisAngle: function setRotationFromAxisAngle(e, t) {
        this.quaternion.setFromAxisAngle(e, t);
      },
      setRotationFromEuler: function setRotationFromEuler(e) {
        this.quaternion.setFromEuler(e, !0);
      },
      setRotationFromMatrix: function setRotationFromMatrix(e) {
        this.quaternion.setFromRotationMatrix(e);
      },
      setRotationFromQuaternion: function setRotationFromQuaternion(e) {
        this.quaternion.copy(e);
      },
      rotateOnAxis: function () {
        var e = new c();
        return function (t, r) {
          return e.setFromAxisAngle(t, r), this.quaternion.multiply(e), this;
        };
      }(),
      rotateX: function () {
        var e = new u(1, 0, 0);
        return function (t) {
          return this.rotateOnAxis(e, t);
        };
      }(),
      rotateY: function () {
        var e = new u(0, 1, 0);
        return function (t) {
          return this.rotateOnAxis(e, t);
        };
      }(),
      rotateZ: function () {
        var e = new u(0, 0, 1);
        return function (t) {
          return this.rotateOnAxis(e, t);
        };
      }(),
      translateOnAxis: function () {
        var e = new u();
        return function (t, r) {
          return e.copy(t).applyQuaternion(this.quaternion), this.position.add(e.multiplyScalar(r)), this;
        };
      }(),
      translateX: function () {
        var e = new u(1, 0, 0);
        return function (t) {
          return this.translateOnAxis(e, t);
        };
      }(),
      translateY: function () {
        var e = new u(0, 1, 0);
        return function (t) {
          return this.translateOnAxis(e, t);
        };
      }(),
      translateZ: function () {
        var e = new u(0, 0, 1);
        return function (t) {
          return this.translateOnAxis(e, t);
        };
      }(),
      localToWorld: function localToWorld(e) {
        return e.applyMatrix4(this.matrixWorld);
      },
      worldToLocal: function () {
        var e = new h();
        return function (t) {
          return t.applyMatrix4(e.getInverse(this.matrixWorld));
        };
      }(),
      lookAt: function () {
        var e = new h();
        return function (t) {
          this.isCamera ? e.lookAt(this.position, t, this.up) : e.lookAt(t, this.position, this.up), this.quaternion.setFromRotationMatrix(e);
        };
      }(),
      add: function add(e) {
        if (arguments.length > 1) {
          for (var t = 0; t < arguments.length; t++) this.add(arguments[t]);
          return this;
        }
        return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (null !== e.parent && e.parent.remove(e), e.parent = this, e.dispatchEvent({
          type: "added"
        }), this.children.push(e)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
      },
      remove: function remove(e) {
        if (arguments.length > 1) for (var t = 0; t < arguments.length; t++) this.remove(arguments[t]);
        var r = this.children.indexOf(e);
        -1 !== r && (e.parent = null, e.dispatchEvent({
          type: "removed"
        }), this.children.splice(r, 1));
      },
      getObjectById: function getObjectById(e) {
        return this.getObjectByProperty("id", e);
      },
      getObjectByName: function getObjectByName(e) {
        return this.getObjectByProperty("name", e);
      },
      getObjectByProperty: function getObjectByProperty(e, t) {
        if (this[e] === t) return this;
        for (var r = 0, n = this.children.length; r < n; r++) {
          var i = this.children[r],
            a = i.getObjectByProperty(e, t);
          if (void 0 !== a) return a;
        }
      },
      getWorldPosition: function getWorldPosition(e) {
        var t = e || new u();
        return this.updateMatrixWorld(!0), t.setFromMatrixPosition(this.matrixWorld);
      },
      getWorldQuaternion: function () {
        var e = new u(),
          t = new u();
        return function (r) {
          var n = r || new c();
          return this.updateMatrixWorld(!0), this.matrixWorld.decompose(e, n, t), n;
        };
      }(),
      getWorldRotation: function () {
        var e = new c();
        return function (t) {
          var r = t || new le();
          return this.getWorldQuaternion(e), r.setFromQuaternion(e, this.rotation.order, !1);
        };
      }(),
      getWorldScale: function () {
        var e = new u(),
          t = new c();
        return function (r) {
          var n = r || new u();
          return this.updateMatrixWorld(!0), this.matrixWorld.decompose(e, t, n), n;
        };
      }(),
      getWorldDirection: function () {
        var e = new c();
        return function (t) {
          var r = t || new u();
          return this.getWorldQuaternion(e), r.set(0, 0, 1).applyQuaternion(e);
        };
      }(),
      raycast: function raycast() {},
      traverse: function traverse(e) {
        e(this);
        for (var t = this.children, r = 0, n = t.length; r < n; r++) t[r].traverse(e);
      },
      traverseVisible: function traverseVisible(e) {
        if (!1 !== this.visible) {
          e(this);
          for (var t = this.children, r = 0, n = t.length; r < n; r++) t[r].traverseVisible(e);
        }
      },
      traverseAncestors: function traverseAncestors(e) {
        var t = this.parent;
        null !== t && (e(t), t.traverseAncestors(e));
      },
      updateMatrix: function updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
      },
      updateMatrixWorld: function updateMatrixWorld(e) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e = !0);
        for (var t = this.children, r = 0, n = t.length; r < n; r++) t[r].updateMatrixWorld(e);
      },
      toJSON: function toJSON(e) {
        function t(t, r) {
          return void 0 === t[r.uuid] && (t[r.uuid] = r.toJSON(e)), r.uuid;
        }
        function r(e) {
          var t = [];
          for (var r in e) {
            var n = e[r];
            delete n.metadata, t.push(n);
          }
          return t;
        }
        var n = void 0 === e || "" === e,
          i = {};
        n && (e = {
          geometries: {},
          materials: {},
          textures: {},
          images: {}
        }, i.metadata = {
          version: 4.5,
          type: "Object",
          generator: "Object3D.toJSON"
        });
        var a = {};
        if (a.uuid = this.uuid, a.type = this.type, "" !== this.name && (a.name = this.name), "{}" !== JSON.stringify(this.userData) && (a.userData = this.userData), !0 === this.castShadow && (a.castShadow = !0), !0 === this.receiveShadow && (a.receiveShadow = !0), !1 === this.visible && (a.visible = !1), a.matrix = this.matrix.toArray(), void 0 !== this.geometry && (a.geometry = t(e.geometries, this.geometry)), void 0 !== this.material) if (Array.isArray(this.material)) {
          for (var o = [], s = 0, l = this.material.length; s < l; s++) o.push(t(e.materials, this.material[s]));
          a.material = o;
        } else a.material = t(e.materials, this.material);
        if (this.children.length > 0) {
          a.children = [];
          for (var s = 0; s < this.children.length; s++) a.children.push(this.children[s].toJSON(e).object);
        }
        if (n) {
          var c = r(e.geometries),
            u = r(e.materials),
            h = r(e.textures),
            f = r(e.images);
          c.length > 0 && (i.geometries = c), u.length > 0 && (i.materials = u), h.length > 0 && (i.textures = h), f.length > 0 && (i.images = f);
        }
        return i.object = a, i;
      },
      clone: function clone(e) {
        return new this.constructor().copy(this, e);
      },
      copy: function copy(e, t) {
        if (void 0 === t && (t = !0), this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.userData = JSON.parse(JSON.stringify(e.userData)), !0 === t) for (var r = 0; r < e.children.length; r++) {
          var n = e.children[r];
          this.add(n.clone());
        }
        return this;
      }
    }), Object.assign(he.prototype, {
      set: function set(e, t) {
        return this.start.copy(e), this.end.copy(t), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.start.copy(e.start), this.end.copy(e.end), this;
      },
      getCenter: function getCenter(e) {
        return (e || new u()).addVectors(this.start, this.end).multiplyScalar(.5);
      },
      delta: function delta(e) {
        return (e || new u()).subVectors(this.end, this.start);
      },
      distanceSq: function distanceSq() {
        return this.start.distanceToSquared(this.end);
      },
      distance: function distance() {
        return this.start.distanceTo(this.end);
      },
      at: function at(e, t) {
        var r = t || new u();
        return this.delta(r).multiplyScalar(e).add(this.start);
      },
      closestPointToPointParameter: function () {
        var e = new u(),
          t = new u();
        return function (r, n) {
          e.subVectors(r, this.start), t.subVectors(this.end, this.start);
          var i = t.dot(t),
            a = t.dot(e),
            o = a / i;
          return n && (o = Ss.clamp(o, 0, 1)), o;
        };
      }(),
      closestPointToPoint: function closestPointToPoint(e, t, r) {
        var n = this.closestPointToPointParameter(e, t),
          i = r || new u();
        return this.delta(i).multiplyScalar(n).add(this.start);
      },
      applyMatrix4: function applyMatrix4(e) {
        return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this;
      },
      equals: function equals(e) {
        return e.start.equals(this.start) && e.end.equals(this.end);
      }
    }), Object.assign(fe, {
      normal: function () {
        var e = new u();
        return function (t, r, n, i) {
          var a = i || new u();
          a.subVectors(n, r), e.subVectors(t, r), a.cross(e);
          var o = a.lengthSq();
          return o > 0 ? a.multiplyScalar(1 / Math.sqrt(o)) : a.set(0, 0, 0);
        };
      }(),
      barycoordFromPoint: function () {
        var e = new u(),
          t = new u(),
          r = new u();
        return function (n, i, a, o, s) {
          e.subVectors(o, i), t.subVectors(a, i), r.subVectors(n, i);
          var l = e.dot(e),
            c = e.dot(t),
            h = e.dot(r),
            f = t.dot(t),
            d = t.dot(r),
            p = l * f - c * c,
            m = s || new u();
          if (0 === p) return m.set(-2, -1, -1);
          var g = 1 / p,
            v = (f * h - c * d) * g,
            b = (l * d - c * h) * g;
          return m.set(1 - v - b, b, v);
        };
      }(),
      containsPoint: function () {
        var e = new u();
        return function (t, r, n, i) {
          var a = fe.barycoordFromPoint(t, r, n, i, e);
          return a.x >= 0 && a.y >= 0 && a.x + a.y <= 1;
        };
      }()
    }), Object.assign(fe.prototype, {
      set: function set(e, t, r) {
        return this.a.copy(e), this.b.copy(t), this.c.copy(r), this;
      },
      setFromPointsAndIndices: function setFromPointsAndIndices(e, t, r, n) {
        return this.a.copy(e[t]), this.b.copy(e[r]), this.c.copy(e[n]), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
      },
      area: function () {
        var e = new u(),
          t = new u();
        return function () {
          return e.subVectors(this.c, this.b), t.subVectors(this.a, this.b), .5 * e.cross(t).length();
        };
      }(),
      midpoint: function midpoint(e) {
        return (e || new u()).addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
      },
      normal: function normal(e) {
        return fe.normal(this.a, this.b, this.c, e);
      },
      plane: function plane(e) {
        return (e || new ie()).setFromCoplanarPoints(this.a, this.b, this.c);
      },
      barycoordFromPoint: function barycoordFromPoint(e, t) {
        return fe.barycoordFromPoint(e, this.a, this.b, this.c, t);
      },
      containsPoint: function containsPoint(e) {
        return fe.containsPoint(e, this.a, this.b, this.c);
      },
      closestPointToPoint: function () {
        var e = new ie(),
          t = [new he(), new he(), new he()],
          r = new u(),
          n = new u();
        return function (i, a) {
          var o = a || new u(),
            s = 1 / 0;
          if (e.setFromCoplanarPoints(this.a, this.b, this.c), e.projectPoint(i, r), !0 === this.containsPoint(r)) o.copy(r);else {
            t[0].set(this.a, this.b), t[1].set(this.b, this.c), t[2].set(this.c, this.a);
            for (var l = 0; l < t.length; l++) {
              t[l].closestPointToPoint(r, !0, n);
              var c = r.distanceToSquared(n);
              c < s && (s = c, o.copy(n));
            }
          }
          return o;
        };
      }(),
      equals: function equals(e) {
        return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
      }
    }), Object.assign(de.prototype, {
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        this.a = e.a, this.b = e.b, this.c = e.c, this.normal.copy(e.normal), this.color.copy(e.color), this.materialIndex = e.materialIndex;
        for (var t = 0, r = e.vertexNormals.length; t < r; t++) this.vertexNormals[t] = e.vertexNormals[t].clone();
        for (var t = 0, r = e.vertexColors.length; t < r; t++) this.vertexColors[t] = e.vertexColors[t].clone();
        return this;
      }
    }), pe.prototype = Object.create(Q.prototype), pe.prototype.constructor = pe, pe.prototype.isMeshBasicMaterial = !0, pe.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this;
    }, Object.defineProperty(me.prototype, "needsUpdate", {
      set: function set(e) {
        !0 === e && this.version++;
      }
    }), Object.assign(me.prototype, {
      isBufferAttribute: !0,
      setArray: function setArray(e) {
        if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.count = void 0 !== e ? e.length / this.itemSize : 0, this.array = e;
      },
      setDynamic: function setDynamic(e) {
        return this.dynamic = e, this;
      },
      copy: function copy(e) {
        return this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.dynamic = e.dynamic, this;
      },
      copyAt: function copyAt(e, t, r) {
        e *= this.itemSize, r *= t.itemSize;
        for (var n = 0, i = this.itemSize; n < i; n++) this.array[e + n] = t.array[r + n];
        return this;
      },
      copyArray: function copyArray(e) {
        return this.array.set(e), this;
      },
      copyColorsArray: function copyColorsArray(e) {
        for (var t = this.array, r = 0, n = 0, i = e.length; n < i; n++) {
          var a = e[n];
          void 0 === a && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", n), a = new Y()), t[r++] = a.r, t[r++] = a.g, t[r++] = a.b;
        }
        return this;
      },
      copyIndicesArray: function copyIndicesArray(e) {
        for (var t = this.array, r = 0, n = 0, i = e.length; n < i; n++) {
          var a = e[n];
          t[r++] = a.a, t[r++] = a.b, t[r++] = a.c;
        }
        return this;
      },
      copyVector2sArray: function copyVector2sArray(e) {
        for (var t = this.array, r = 0, n = 0, a = e.length; n < a; n++) {
          var o = e[n];
          void 0 === o && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", n), o = new i()), t[r++] = o.x, t[r++] = o.y;
        }
        return this;
      },
      copyVector3sArray: function copyVector3sArray(e) {
        for (var t = this.array, r = 0, n = 0, i = e.length; n < i; n++) {
          var a = e[n];
          void 0 === a && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", n), a = new u()), t[r++] = a.x, t[r++] = a.y, t[r++] = a.z;
        }
        return this;
      },
      copyVector4sArray: function copyVector4sArray(e) {
        for (var t = this.array, r = 0, n = 0, i = e.length; n < i; n++) {
          var a = e[n];
          void 0 === a && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", n), a = new o()), t[r++] = a.x, t[r++] = a.y, t[r++] = a.z, t[r++] = a.w;
        }
        return this;
      },
      set: function set(e, t) {
        return void 0 === t && (t = 0), this.array.set(e, t), this;
      },
      getX: function getX(e) {
        return this.array[e * this.itemSize];
      },
      setX: function setX(e, t) {
        return this.array[e * this.itemSize] = t, this;
      },
      getY: function getY(e) {
        return this.array[e * this.itemSize + 1];
      },
      setY: function setY(e, t) {
        return this.array[e * this.itemSize + 1] = t, this;
      },
      getZ: function getZ(e) {
        return this.array[e * this.itemSize + 2];
      },
      setZ: function setZ(e, t) {
        return this.array[e * this.itemSize + 2] = t, this;
      },
      getW: function getW(e) {
        return this.array[e * this.itemSize + 3];
      },
      setW: function setW(e, t) {
        return this.array[e * this.itemSize + 3] = t, this;
      },
      setXY: function setXY(e, t, r) {
        return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this;
      },
      setXYZ: function setXYZ(e, t, r, n) {
        return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this.array[e + 2] = n, this;
      },
      setXYZW: function setXYZW(e, t, r, n, i) {
        return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this.array[e + 2] = n, this.array[e + 3] = i, this;
      },
      onUpload: function onUpload(e) {
        return this.onUploadCallback = e, this;
      },
      clone: function clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
      }
    }), ge.prototype = Object.create(me.prototype), ge.prototype.constructor = ge, ve.prototype = Object.create(me.prototype), ve.prototype.constructor = ve, be.prototype = Object.create(me.prototype), be.prototype.constructor = be, ye.prototype = Object.create(me.prototype), ye.prototype.constructor = ye, we.prototype = Object.create(me.prototype), we.prototype.constructor = we, xe.prototype = Object.create(me.prototype), xe.prototype.constructor = xe, _e.prototype = Object.create(me.prototype), _e.prototype.constructor = _e, Se.prototype = Object.create(me.prototype), Se.prototype.constructor = Se, Ce.prototype = Object.create(me.prototype), Ce.prototype.constructor = Ce, Object.assign(Ee.prototype, {
      computeGroups: function computeGroups(e) {
        for (var t, r = [], n = void 0, i = e.faces, a = 0; a < i.length; a++) {
          var o = i[a];
          o.materialIndex !== n && (n = o.materialIndex, void 0 !== t && (t.count = 3 * a - t.start, r.push(t)), t = {
            start: 3 * a,
            materialIndex: n
          });
        }
        void 0 !== t && (t.count = 3 * a - t.start, r.push(t)), this.groups = r;
      },
      fromGeometry: function fromGeometry(e) {
        var t,
          r = e.faces,
          n = e.vertices,
          a = e.faceVertexUvs,
          o = a[0] && a[0].length > 0,
          s = a[1] && a[1].length > 0,
          l = e.morphTargets,
          c = l.length;
        if (c > 0) {
          t = [];
          for (var u = 0; u < c; u++) t[u] = [];
          this.morphTargets.position = t;
        }
        var h,
          f = e.morphNormals,
          d = f.length;
        if (d > 0) {
          h = [];
          for (var u = 0; u < d; u++) h[u] = [];
          this.morphTargets.normal = h;
        }
        for (var p = e.skinIndices, m = e.skinWeights, g = p.length === n.length, v = m.length === n.length, u = 0; u < r.length; u++) {
          var b = r[u];
          this.vertices.push(n[b.a], n[b.b], n[b.c]);
          var y = b.vertexNormals;
          if (3 === y.length) this.normals.push(y[0], y[1], y[2]);else {
            var w = b.normal;
            this.normals.push(w, w, w);
          }
          var x = b.vertexColors;
          if (3 === x.length) this.colors.push(x[0], x[1], x[2]);else {
            var _ = b.color;
            this.colors.push(_, _, _);
          }
          if (!0 === o) {
            var S = a[0][u];
            void 0 !== S ? this.uvs.push(S[0], S[1], S[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", u), this.uvs.push(new i(), new i(), new i()));
          }
          if (!0 === s) {
            var S = a[1][u];
            void 0 !== S ? this.uvs2.push(S[0], S[1], S[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", u), this.uvs2.push(new i(), new i(), new i()));
          }
          for (var C = 0; C < c; C++) {
            var E = l[C].vertices;
            t[C].push(E[b.a], E[b.b], E[b.c]);
          }
          for (var C = 0; C < d; C++) {
            var A = f[C].vertexNormals[u];
            h[C].push(A.a, A.b, A.c);
          }
          g && this.skinIndices.push(p[b.a], p[b.b], p[b.c]), v && this.skinWeights.push(m[b.a], m[b.b], m[b.c]);
        }
        return this.computeGroups(e), this.verticesNeedUpdate = e.verticesNeedUpdate, this.normalsNeedUpdate = e.normalsNeedUpdate, this.colorsNeedUpdate = e.colorsNeedUpdate, this.uvsNeedUpdate = e.uvsNeedUpdate, this.groupsNeedUpdate = e.groupsNeedUpdate, this;
      }
    });
    var Us = 0;
    Object.assign(ke.prototype, n.prototype, {
      isGeometry: !0,
      applyMatrix: function applyMatrix(e) {
        for (var t = new ne().getNormalMatrix(e), r = 0, n = this.vertices.length; r < n; r++) {
          this.vertices[r].applyMatrix4(e);
        }
        for (var r = 0, n = this.faces.length; r < n; r++) {
          var i = this.faces[r];
          i.normal.applyMatrix3(t).normalize();
          for (var a = 0, o = i.vertexNormals.length; a < o; a++) i.vertexNormals[a].applyMatrix3(t).normalize();
        }
        return null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
      },
      rotateX: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationX(t), this.applyMatrix(e), this;
        };
      }(),
      rotateY: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationY(t), this.applyMatrix(e), this;
        };
      }(),
      rotateZ: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationZ(t), this.applyMatrix(e), this;
        };
      }(),
      translate: function () {
        var e = new h();
        return function (t, r, n) {
          return e.makeTranslation(t, r, n), this.applyMatrix(e), this;
        };
      }(),
      scale: function () {
        var e = new h();
        return function (t, r, n) {
          return e.makeScale(t, r, n), this.applyMatrix(e), this;
        };
      }(),
      lookAt: function () {
        var e = new ue();
        return function (t) {
          e.lookAt(t), e.updateMatrix(), this.applyMatrix(e.matrix);
        };
      }(),
      fromBufferGeometry: function fromBufferGeometry(e) {
        function t(e, t, n, i) {
          var a = void 0 !== s ? [f[e].clone(), f[t].clone(), f[n].clone()] : [],
            o = void 0 !== l ? [r.colors[e].clone(), r.colors[t].clone(), r.colors[n].clone()] : [],
            u = new de(e, t, n, a, o, i);
          r.faces.push(u), void 0 !== c && r.faceVertexUvs[0].push([d[e].clone(), d[t].clone(), d[n].clone()]), void 0 !== h && r.faceVertexUvs[1].push([p[e].clone(), p[t].clone(), p[n].clone()]);
        }
        var r = this,
          n = null !== e.index ? e.index.array : void 0,
          a = e.attributes,
          o = a.position.array,
          s = void 0 !== a.normal ? a.normal.array : void 0,
          l = void 0 !== a.color ? a.color.array : void 0,
          c = void 0 !== a.uv ? a.uv.array : void 0,
          h = void 0 !== a.uv2 ? a.uv2.array : void 0;
        void 0 !== h && (this.faceVertexUvs[1] = []);
        for (var f = [], d = [], p = [], m = 0, g = 0; m < o.length; m += 3, g += 2) r.vertices.push(new u(o[m], o[m + 1], o[m + 2])), void 0 !== s && f.push(new u(s[m], s[m + 1], s[m + 2])), void 0 !== l && r.colors.push(new Y(l[m], l[m + 1], l[m + 2])), void 0 !== c && d.push(new i(c[g], c[g + 1])), void 0 !== h && p.push(new i(h[g], h[g + 1]));
        var v = e.groups;
        if (v.length > 0) for (var m = 0; m < v.length; m++) for (var b = v[m], y = b.start, w = b.count, g = y, x = y + w; g < x; g += 3) void 0 !== n ? t(n[g], n[g + 1], n[g + 2], b.materialIndex) : t(g, g + 1, g + 2, b.materialIndex);else if (void 0 !== n) for (var m = 0; m < n.length; m += 3) t(n[m], n[m + 1], n[m + 2]);else for (var m = 0; m < o.length / 3; m += 3) t(m, m + 1, m + 2);
        return this.computeFaceNormals(), null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone()), null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone()), this;
      },
      center: function center() {
        this.computeBoundingBox();
        var e = this.boundingBox.getCenter().negate();
        return this.translate(e.x, e.y, e.z), e;
      },
      normalize: function normalize() {
        this.computeBoundingSphere();
        var e = this.boundingSphere.center,
          t = this.boundingSphere.radius,
          r = 0 === t ? 1 : 1 / t,
          n = new h();
        return n.set(r, 0, 0, -r * e.x, 0, r, 0, -r * e.y, 0, 0, r, -r * e.z, 0, 0, 0, 1), this.applyMatrix(n), this;
      },
      computeFaceNormals: function computeFaceNormals() {
        for (var e = new u(), t = new u(), r = 0, n = this.faces.length; r < n; r++) {
          var i = this.faces[r],
            a = this.vertices[i.a],
            o = this.vertices[i.b],
            s = this.vertices[i.c];
          e.subVectors(s, o), t.subVectors(a, o), e.cross(t), e.normalize(), i.normal.copy(e);
        }
      },
      computeVertexNormals: function computeVertexNormals(e) {
        void 0 === e && (e = !0);
        var t, r, n, i, a, o;
        for (o = new Array(this.vertices.length), t = 0, r = this.vertices.length; t < r; t++) o[t] = new u();
        if (e) {
          var s,
            l,
            c,
            h = new u(),
            f = new u();
          for (n = 0, i = this.faces.length; n < i; n++) a = this.faces[n], s = this.vertices[a.a], l = this.vertices[a.b], c = this.vertices[a.c], h.subVectors(c, l), f.subVectors(s, l), h.cross(f), o[a.a].add(h), o[a.b].add(h), o[a.c].add(h);
        } else for (this.computeFaceNormals(), n = 0, i = this.faces.length; n < i; n++) a = this.faces[n], o[a.a].add(a.normal), o[a.b].add(a.normal), o[a.c].add(a.normal);
        for (t = 0, r = this.vertices.length; t < r; t++) o[t].normalize();
        for (n = 0, i = this.faces.length; n < i; n++) {
          a = this.faces[n];
          var d = a.vertexNormals;
          3 === d.length ? (d[0].copy(o[a.a]), d[1].copy(o[a.b]), d[2].copy(o[a.c])) : (d[0] = o[a.a].clone(), d[1] = o[a.b].clone(), d[2] = o[a.c].clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
      },
      computeFlatVertexNormals: function computeFlatVertexNormals() {
        var e, t, r;
        for (this.computeFaceNormals(), e = 0, t = this.faces.length; e < t; e++) {
          r = this.faces[e];
          var n = r.vertexNormals;
          3 === n.length ? (n[0].copy(r.normal), n[1].copy(r.normal), n[2].copy(r.normal)) : (n[0] = r.normal.clone(), n[1] = r.normal.clone(), n[2] = r.normal.clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
      },
      computeMorphNormals: function computeMorphNormals() {
        var e, t, r, n, i;
        for (r = 0, n = this.faces.length; r < n; r++) for (i = this.faces[r], i.__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []), e = 0, t = i.vertexNormals.length; e < t; e++) i.__originalVertexNormals[e] ? i.__originalVertexNormals[e].copy(i.vertexNormals[e]) : i.__originalVertexNormals[e] = i.vertexNormals[e].clone();
        var a = new ke();
        for (a.faces = this.faces, e = 0, t = this.morphTargets.length; e < t; e++) {
          if (!this.morphNormals[e]) {
            this.morphNormals[e] = {}, this.morphNormals[e].faceNormals = [], this.morphNormals[e].vertexNormals = [];
            var o,
              s,
              l = this.morphNormals[e].faceNormals,
              c = this.morphNormals[e].vertexNormals;
            for (r = 0, n = this.faces.length; r < n; r++) o = new u(), s = {
              a: new u(),
              b: new u(),
              c: new u()
            }, l.push(o), c.push(s);
          }
          var h = this.morphNormals[e];
          a.vertices = this.morphTargets[e].vertices, a.computeFaceNormals(), a.computeVertexNormals();
          var o, s;
          for (r = 0, n = this.faces.length; r < n; r++) i = this.faces[r], o = h.faceNormals[r], s = h.vertexNormals[r], o.copy(i.normal), s.a.copy(i.vertexNormals[0]), s.b.copy(i.vertexNormals[1]), s.c.copy(i.vertexNormals[2]);
        }
        for (r = 0, n = this.faces.length; r < n; r++) i = this.faces[r], i.normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
      },
      computeLineDistances: function computeLineDistances() {
        for (var e = 0, t = this.vertices, r = 0, n = t.length; r < n; r++) r > 0 && (e += t[r].distanceTo(t[r - 1])), this.lineDistances[r] = e;
      },
      computeBoundingBox: function computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new te()), this.boundingBox.setFromPoints(this.vertices);
      },
      computeBoundingSphere: function computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new re()), this.boundingSphere.setFromPoints(this.vertices);
      },
      merge: function merge(e, t, r) {
        if (!1 === (e && e.isGeometry)) return void console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", e);
        var n,
          i = this.vertices.length,
          a = this.vertices,
          o = e.vertices,
          s = this.faces,
          l = e.faces,
          c = this.faceVertexUvs[0],
          u = e.faceVertexUvs[0],
          h = this.colors,
          f = e.colors;
        void 0 === r && (r = 0), void 0 !== t && (n = new ne().getNormalMatrix(t));
        for (var d = 0, p = o.length; d < p; d++) {
          var m = o[d],
            g = m.clone();
          void 0 !== t && g.applyMatrix4(t), a.push(g);
        }
        for (var d = 0, p = f.length; d < p; d++) h.push(f[d].clone());
        for (d = 0, p = l.length; d < p; d++) {
          var v,
            b,
            y,
            w = l[d],
            x = w.vertexNormals,
            _ = w.vertexColors;
          v = new de(w.a + i, w.b + i, w.c + i), v.normal.copy(w.normal), void 0 !== n && v.normal.applyMatrix3(n).normalize();
          for (var S = 0, C = x.length; S < C; S++) b = x[S].clone(), void 0 !== n && b.applyMatrix3(n).normalize(), v.vertexNormals.push(b);
          v.color.copy(w.color);
          for (var S = 0, C = _.length; S < C; S++) y = _[S], v.vertexColors.push(y.clone());
          v.materialIndex = w.materialIndex + r, s.push(v);
        }
        for (d = 0, p = u.length; d < p; d++) {
          var E = u[d],
            A = [];
          if (void 0 !== E) {
            for (var S = 0, C = E.length; S < C; S++) A.push(E[S].clone());
            c.push(A);
          }
        }
      },
      mergeMesh: function mergeMesh(e) {
        if (!1 === (e && e.isMesh)) return void console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", e);
        e.matrixAutoUpdate && e.updateMatrix(), this.merge(e.geometry, e.matrix);
      },
      mergeVertices: function mergeVertices() {
        var e,
          t,
          r,
          n,
          i,
          a,
          o,
          s,
          l = {},
          c = [],
          u = [],
          h = Math.pow(10, 4);
        for (r = 0, n = this.vertices.length; r < n; r++) e = this.vertices[r], t = Math.round(e.x * h) + "_" + Math.round(e.y * h) + "_" + Math.round(e.z * h), void 0 === l[t] ? (l[t] = r, c.push(this.vertices[r]), u[r] = c.length - 1) : u[r] = u[l[t]];
        var f = [];
        for (r = 0, n = this.faces.length; r < n; r++) {
          i = this.faces[r], i.a = u[i.a], i.b = u[i.b], i.c = u[i.c], a = [i.a, i.b, i.c];
          for (var d = 0; d < 3; d++) if (a[d] === a[(d + 1) % 3]) {
            f.push(r);
            break;
          }
        }
        for (r = f.length - 1; r >= 0; r--) {
          var p = f[r];
          for (this.faces.splice(p, 1), o = 0, s = this.faceVertexUvs.length; o < s; o++) this.faceVertexUvs[o].splice(p, 1);
        }
        var m = this.vertices.length - c.length;
        return this.vertices = c, m;
      },
      sortFacesByMaterialIndex: function sortFacesByMaterialIndex() {
        function e(e, t) {
          return e.materialIndex - t.materialIndex;
        }
        for (var t = this.faces, r = t.length, n = 0; n < r; n++) t[n]._id = n;
        t.sort(e);
        var i,
          a,
          o = this.faceVertexUvs[0],
          s = this.faceVertexUvs[1];
        o && o.length === r && (i = []), s && s.length === r && (a = []);
        for (var n = 0; n < r; n++) {
          var l = t[n]._id;
          i && i.push(o[l]), a && a.push(s[l]);
        }
        i && (this.faceVertexUvs[0] = i), a && (this.faceVertexUvs[1] = a);
      },
      toJSON: function toJSON() {
        function e(e, t, r) {
          return r ? e | 1 << t : e & ~(1 << t);
        }
        function t(e) {
          var t = e.x.toString() + e.y.toString() + e.z.toString();
          return void 0 !== f[t] ? f[t] : (f[t] = h.length / 3, h.push(e.x, e.y, e.z), f[t]);
        }
        function r(e) {
          var t = e.r.toString() + e.g.toString() + e.b.toString();
          return void 0 !== p[t] ? p[t] : (p[t] = d.length, d.push(e.getHex()), p[t]);
        }
        function n(e) {
          var t = e.x.toString() + e.y.toString();
          return void 0 !== g[t] ? g[t] : (g[t] = m.length / 2, m.push(e.x, e.y), g[t]);
        }
        var i = {
          metadata: {
            version: 4.5,
            type: "Geometry",
            generator: "Geometry.toJSON"
          }
        };
        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), void 0 !== this.parameters) {
          var a = this.parameters;
          for (var o in a) void 0 !== a[o] && (i[o] = a[o]);
          return i;
        }
        for (var s = [], l = 0; l < this.vertices.length; l++) {
          var c = this.vertices[l];
          s.push(c.x, c.y, c.z);
        }
        for (var u = [], h = [], f = {}, d = [], p = {}, m = [], g = {}, l = 0; l < this.faces.length; l++) {
          var v = this.faces[l],
            b = void 0 !== this.faceVertexUvs[0][l],
            y = v.normal.length() > 0,
            w = v.vertexNormals.length > 0,
            x = 1 !== v.color.r || 1 !== v.color.g || 1 !== v.color.b,
            _ = v.vertexColors.length > 0,
            S = 0;
          if (S = e(S, 0, 0), S = e(S, 1, !0), S = e(S, 2, !1), S = e(S, 3, b), S = e(S, 4, y), S = e(S, 5, w), S = e(S, 6, x), S = e(S, 7, _), u.push(S), u.push(v.a, v.b, v.c), u.push(v.materialIndex), b) {
            var C = this.faceVertexUvs[0][l];
            u.push(n(C[0]), n(C[1]), n(C[2]));
          }
          if (y && u.push(t(v.normal)), w) {
            var E = v.vertexNormals;
            u.push(t(E[0]), t(E[1]), t(E[2]));
          }
          if (x && u.push(r(v.color)), _) {
            var A = v.vertexColors;
            u.push(r(A[0]), r(A[1]), r(A[2]));
          }
        }
        return i.data = {}, i.data.vertices = s, i.data.normals = h, d.length > 0 && (i.data.colors = d), m.length > 0 && (i.data.uvs = [m]), i.data.faces = u, i;
      },
      clone: function clone() {
        return new ke().copy(this);
      },
      copy: function copy(e) {
        var t, r, n, i, a, o;
        this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [[]], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = e.name;
        var s = e.vertices;
        for (t = 0, r = s.length; t < r; t++) this.vertices.push(s[t].clone());
        var l = e.colors;
        for (t = 0, r = l.length; t < r; t++) this.colors.push(l[t].clone());
        var c = e.faces;
        for (t = 0, r = c.length; t < r; t++) this.faces.push(c[t].clone());
        for (t = 0, r = e.faceVertexUvs.length; t < r; t++) {
          var u = e.faceVertexUvs[t];
          for (void 0 === this.faceVertexUvs[t] && (this.faceVertexUvs[t] = []), n = 0, i = u.length; n < i; n++) {
            var h = u[n],
              f = [];
            for (a = 0, o = h.length; a < o; a++) {
              var d = h[a];
              f.push(d.clone());
            }
            this.faceVertexUvs[t].push(f);
          }
        }
        var p = e.morphTargets;
        for (t = 0, r = p.length; t < r; t++) {
          var m = {};
          if (m.name = p[t].name, void 0 !== p[t].vertices) for (m.vertices = [], n = 0, i = p[t].vertices.length; n < i; n++) m.vertices.push(p[t].vertices[n].clone());
          if (void 0 !== p[t].normals) for (m.normals = [], n = 0, i = p[t].normals.length; n < i; n++) m.normals.push(p[t].normals[n].clone());
          this.morphTargets.push(m);
        }
        var g = e.morphNormals;
        for (t = 0, r = g.length; t < r; t++) {
          var v = {};
          if (void 0 !== g[t].vertexNormals) for (v.vertexNormals = [], n = 0, i = g[t].vertexNormals.length; n < i; n++) {
            var b = g[t].vertexNormals[n],
              y = {};
            y.a = b.a.clone(), y.b = b.b.clone(), y.c = b.c.clone(), v.vertexNormals.push(y);
          }
          if (void 0 !== g[t].faceNormals) for (v.faceNormals = [], n = 0, i = g[t].faceNormals.length; n < i; n++) v.faceNormals.push(g[t].faceNormals[n].clone());
          this.morphNormals.push(v);
        }
        var w = e.skinWeights;
        for (t = 0, r = w.length; t < r; t++) this.skinWeights.push(w[t].clone());
        var x = e.skinIndices;
        for (t = 0, r = x.length; t < r; t++) this.skinIndices.push(x[t].clone());
        var _ = e.lineDistances;
        for (t = 0, r = _.length; t < r; t++) this.lineDistances.push(_[t]);
        var S = e.boundingBox;
        null !== S && (this.boundingBox = S.clone());
        var C = e.boundingSphere;
        return null !== C && (this.boundingSphere = C.clone()), this.elementsNeedUpdate = e.elementsNeedUpdate, this.verticesNeedUpdate = e.verticesNeedUpdate, this.uvsNeedUpdate = e.uvsNeedUpdate, this.normalsNeedUpdate = e.normalsNeedUpdate, this.colorsNeedUpdate = e.colorsNeedUpdate, this.lineDistancesNeedUpdate = e.lineDistancesNeedUpdate, this.groupsNeedUpdate = e.groupsNeedUpdate, this;
      },
      dispose: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }), Re.MaxIndex = 65535, Object.assign(Re.prototype, n.prototype, {
      isBufferGeometry: !0,
      getIndex: function getIndex() {
        return this.index;
      },
      setIndex: function setIndex(e) {
        Array.isArray(e) ? this.index = new (Ae(e) > 65535 ? _e : we)(e, 1) : this.index = e;
      },
      addAttribute: function addAttribute(e, t) {
        return !1 === (t && t.isBufferAttribute) && !1 === (t && t.isInterleavedBufferAttribute) ? (console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."), void this.addAttribute(e, new me(arguments[1], arguments[2]))) : "index" === e ? (console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."), void this.setIndex(t)) : (this.attributes[e] = t, this);
      },
      getAttribute: function getAttribute(e) {
        return this.attributes[e];
      },
      removeAttribute: function removeAttribute(e) {
        return delete this.attributes[e], this;
      },
      addGroup: function addGroup(e, t, r) {
        this.groups.push({
          start: e,
          count: t,
          materialIndex: void 0 !== r ? r : 0
        });
      },
      clearGroups: function clearGroups() {
        this.groups = [];
      },
      setDrawRange: function setDrawRange(e, t) {
        this.drawRange.start = e, this.drawRange.count = t;
      },
      applyMatrix: function applyMatrix(e) {
        var t = this.attributes.position;
        void 0 !== t && (e.applyToBufferAttribute(t), t.needsUpdate = !0);
        var r = this.attributes.normal;
        if (void 0 !== r) {
          new ne().getNormalMatrix(e).applyToBufferAttribute(r), r.needsUpdate = !0;
        }
        return null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
      },
      rotateX: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationX(t), this.applyMatrix(e), this;
        };
      }(),
      rotateY: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationY(t), this.applyMatrix(e), this;
        };
      }(),
      rotateZ: function () {
        var e = new h();
        return function (t) {
          return e.makeRotationZ(t), this.applyMatrix(e), this;
        };
      }(),
      translate: function () {
        var e = new h();
        return function (t, r, n) {
          return e.makeTranslation(t, r, n), this.applyMatrix(e), this;
        };
      }(),
      scale: function () {
        var e = new h();
        return function (t, r, n) {
          return e.makeScale(t, r, n), this.applyMatrix(e), this;
        };
      }(),
      lookAt: function () {
        var e = new ue();
        return function (t) {
          e.lookAt(t), e.updateMatrix(), this.applyMatrix(e.matrix);
        };
      }(),
      center: function center() {
        this.computeBoundingBox();
        var e = this.boundingBox.getCenter().negate();
        return this.translate(e.x, e.y, e.z), e;
      },
      setFromObject: function setFromObject(e) {
        var t = e.geometry;
        if (e.isPoints || e.isLine) {
          var r = new Se(3 * t.vertices.length, 3),
            n = new Se(3 * t.colors.length, 3);
          if (this.addAttribute("position", r.copyVector3sArray(t.vertices)), this.addAttribute("color", n.copyColorsArray(t.colors)), t.lineDistances && t.lineDistances.length === t.vertices.length) {
            var i = new Se(t.lineDistances.length, 1);
            this.addAttribute("lineDistance", i.copyArray(t.lineDistances));
          }
          null !== t.boundingSphere && (this.boundingSphere = t.boundingSphere.clone()), null !== t.boundingBox && (this.boundingBox = t.boundingBox.clone());
        } else e.isMesh && t && t.isGeometry && this.fromGeometry(t);
        return this;
      },
      updateFromObject: function updateFromObject(e) {
        var t = e.geometry;
        if (e.isMesh) {
          var r = t.__directGeometry;
          if (!0 === t.elementsNeedUpdate && (r = void 0, t.elementsNeedUpdate = !1), void 0 === r) return this.fromGeometry(t);
          r.verticesNeedUpdate = t.verticesNeedUpdate, r.normalsNeedUpdate = t.normalsNeedUpdate, r.colorsNeedUpdate = t.colorsNeedUpdate, r.uvsNeedUpdate = t.uvsNeedUpdate, r.groupsNeedUpdate = t.groupsNeedUpdate, t.verticesNeedUpdate = !1, t.normalsNeedUpdate = !1, t.colorsNeedUpdate = !1, t.uvsNeedUpdate = !1, t.groupsNeedUpdate = !1, t = r;
        }
        var n;
        return !0 === t.verticesNeedUpdate && (n = this.attributes.position, void 0 !== n && (n.copyVector3sArray(t.vertices), n.needsUpdate = !0), t.verticesNeedUpdate = !1), !0 === t.normalsNeedUpdate && (n = this.attributes.normal, void 0 !== n && (n.copyVector3sArray(t.normals), n.needsUpdate = !0), t.normalsNeedUpdate = !1), !0 === t.colorsNeedUpdate && (n = this.attributes.color, void 0 !== n && (n.copyColorsArray(t.colors), n.needsUpdate = !0), t.colorsNeedUpdate = !1), t.uvsNeedUpdate && (n = this.attributes.uv, void 0 !== n && (n.copyVector2sArray(t.uvs), n.needsUpdate = !0), t.uvsNeedUpdate = !1), t.lineDistancesNeedUpdate && (n = this.attributes.lineDistance, void 0 !== n && (n.copyArray(t.lineDistances), n.needsUpdate = !0), t.lineDistancesNeedUpdate = !1), t.groupsNeedUpdate && (t.computeGroups(e.geometry), this.groups = t.groups, t.groupsNeedUpdate = !1), this;
      },
      fromGeometry: function fromGeometry(e) {
        return e.__directGeometry = new Ee().fromGeometry(e), this.fromDirectGeometry(e.__directGeometry);
      },
      fromDirectGeometry: function fromDirectGeometry(e) {
        var t = new Float32Array(3 * e.vertices.length);
        if (this.addAttribute("position", new me(t, 3).copyVector3sArray(e.vertices)), e.normals.length > 0) {
          var r = new Float32Array(3 * e.normals.length);
          this.addAttribute("normal", new me(r, 3).copyVector3sArray(e.normals));
        }
        if (e.colors.length > 0) {
          var n = new Float32Array(3 * e.colors.length);
          this.addAttribute("color", new me(n, 3).copyColorsArray(e.colors));
        }
        if (e.uvs.length > 0) {
          var i = new Float32Array(2 * e.uvs.length);
          this.addAttribute("uv", new me(i, 2).copyVector2sArray(e.uvs));
        }
        if (e.uvs2.length > 0) {
          var a = new Float32Array(2 * e.uvs2.length);
          this.addAttribute("uv2", new me(a, 2).copyVector2sArray(e.uvs2));
        }
        if (e.indices.length > 0) {
          var o = Ae(e.indices) > 65535 ? Uint32Array : Uint16Array,
            s = new o(3 * e.indices.length);
          this.setIndex(new me(s, 1).copyIndicesArray(e.indices));
        }
        this.groups = e.groups;
        for (var l in e.morphTargets) {
          for (var c = [], u = e.morphTargets[l], h = 0, f = u.length; h < f; h++) {
            var d = u[h],
              p = new Se(3 * d.length, 3);
            c.push(p.copyVector3sArray(d));
          }
          this.morphAttributes[l] = c;
        }
        if (e.skinIndices.length > 0) {
          var m = new Se(4 * e.skinIndices.length, 4);
          this.addAttribute("skinIndex", m.copyVector4sArray(e.skinIndices));
        }
        if (e.skinWeights.length > 0) {
          var g = new Se(4 * e.skinWeights.length, 4);
          this.addAttribute("skinWeight", g.copyVector4sArray(e.skinWeights));
        }
        return null !== e.boundingSphere && (this.boundingSphere = e.boundingSphere.clone()), null !== e.boundingBox && (this.boundingBox = e.boundingBox.clone()), this;
      },
      computeBoundingBox: function computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new te());
        var e = this.attributes.position;
        void 0 !== e ? this.boundingBox.setFromBufferAttribute(e) : this.boundingBox.makeEmpty(), (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox: Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
      },
      computeBoundingSphere: function () {
        var e = new te(),
          t = new u();
        return function () {
          null === this.boundingSphere && (this.boundingSphere = new re());
          var r = this.attributes.position;
          if (r) {
            var n = this.boundingSphere.center;
            e.setFromBufferAttribute(r), e.getCenter(n);
            for (var i = 0, a = 0, o = r.count; a < o; a++) t.x = r.getX(a), t.y = r.getY(a), t.z = r.getZ(a), i = Math.max(i, n.distanceToSquared(t));
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
          }
        };
      }(),
      computeFaceNormals: function computeFaceNormals() {},
      computeVertexNormals: function computeVertexNormals() {
        var e = this.index,
          t = this.attributes,
          r = this.groups;
        if (t.position) {
          var n = t.position.array;
          if (void 0 === t.normal) this.addAttribute("normal", new me(new Float32Array(n.length), 3));else for (var i = t.normal.array, a = 0, o = i.length; a < o; a++) i[a] = 0;
          var s,
            l,
            c,
            h = t.normal.array,
            f = new u(),
            d = new u(),
            p = new u(),
            m = new u(),
            g = new u();
          if (e) {
            var v = e.array;
            0 === r.length && this.addGroup(0, v.length);
            for (var b = 0, y = r.length; b < y; ++b) for (var w = r[b], x = w.start, _ = w.count, a = x, o = x + _; a < o; a += 3) s = 3 * v[a + 0], l = 3 * v[a + 1], c = 3 * v[a + 2], f.fromArray(n, s), d.fromArray(n, l), p.fromArray(n, c), m.subVectors(p, d), g.subVectors(f, d), m.cross(g), h[s] += m.x, h[s + 1] += m.y, h[s + 2] += m.z, h[l] += m.x, h[l + 1] += m.y, h[l + 2] += m.z, h[c] += m.x, h[c + 1] += m.y, h[c + 2] += m.z;
          } else for (var a = 0, o = n.length; a < o; a += 9) f.fromArray(n, a), d.fromArray(n, a + 3), p.fromArray(n, a + 6), m.subVectors(p, d), g.subVectors(f, d), m.cross(g), h[a] = m.x, h[a + 1] = m.y, h[a + 2] = m.z, h[a + 3] = m.x, h[a + 4] = m.y, h[a + 5] = m.z, h[a + 6] = m.x, h[a + 7] = m.y, h[a + 8] = m.z;
          this.normalizeNormals(), t.normal.needsUpdate = !0;
        }
      },
      merge: function merge(e, t) {
        if (!1 === (e && e.isBufferGeometry)) return void console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", e);
        void 0 === t && (t = 0);
        var r = this.attributes;
        for (var n in r) if (void 0 !== e.attributes[n]) for (var i = r[n], a = i.array, o = e.attributes[n], s = o.array, l = o.itemSize, c = 0, u = l * t; c < s.length; c++, u++) a[u] = s[c];
        return this;
      },
      normalizeNormals: function normalizeNormals() {
        for (var e, t, r, n, i = this.attributes.normal, a = 0, o = i.count; a < o; a++) e = i.getX(a), t = i.getY(a), r = i.getZ(a), n = 1 / Math.sqrt(e * e + t * t + r * r), i.setXYZ(a, e * n, t * n, r * n);
      },
      toNonIndexed: function toNonIndexed() {
        if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): Geometry is already non-indexed."), this;
        var e = new Re(),
          t = this.index.array,
          r = this.attributes;
        for (var n in r) {
          for (var i = r[n], a = i.array, o = i.itemSize, s = new a.constructor(t.length * o), l = 0, c = 0, u = 0, h = t.length; u < h; u++) {
            l = t[u] * o;
            for (var f = 0; f < o; f++) s[c++] = a[l++];
          }
          e.addAttribute(n, new me(s, o));
        }
        return e;
      },
      toJSON: function toJSON() {
        var e = {
          metadata: {
            version: 4.5,
            type: "BufferGeometry",
            generator: "BufferGeometry.toJSON"
          }
        };
        if (e.uuid = this.uuid, e.type = this.type, "" !== this.name && (e.name = this.name), void 0 !== this.parameters) {
          var t = this.parameters;
          for (var r in t) void 0 !== t[r] && (e[r] = t[r]);
          return e;
        }
        e.data = {
          attributes: {}
        };
        var n = this.index;
        if (null !== n) {
          var i = Array.prototype.slice.call(n.array);
          e.data.index = {
            type: n.array.constructor.name,
            array: i
          };
        }
        var a = this.attributes;
        for (var r in a) {
          var o = a[r],
            i = Array.prototype.slice.call(o.array);
          e.data.attributes[r] = {
            itemSize: o.itemSize,
            type: o.array.constructor.name,
            array: i,
            normalized: o.normalized
          };
        }
        var s = this.groups;
        s.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(s)));
        var l = this.boundingSphere;
        return null !== l && (e.data.boundingSphere = {
          center: l.center.toArray(),
          radius: l.radius
        }), e;
      },
      clone: function clone() {
        return new Re().copy(this);
      },
      copy: function copy(e) {
        var t, r, n;
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.name = e.name;
        var i = e.index;
        null !== i && this.setIndex(i.clone());
        var a = e.attributes;
        for (t in a) {
          var o = a[t];
          this.addAttribute(t, o.clone());
        }
        var s = e.morphAttributes;
        for (t in s) {
          var l = [],
            c = s[t];
          for (r = 0, n = c.length; r < n; r++) l.push(c[r].clone());
          this.morphAttributes[t] = l;
        }
        var u = e.groups;
        for (r = 0, n = u.length; r < n; r++) {
          var h = u[r];
          this.addGroup(h.start, h.count, h.materialIndex);
        }
        var f = e.boundingBox;
        null !== f && (this.boundingBox = f.clone());
        var d = e.boundingSphere;
        return null !== d && (this.boundingSphere = d.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this;
      },
      dispose: function dispose() {
        this.dispatchEvent({
          type: "dispose"
        });
      }
    }), Ie.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Ie,
      isMesh: !0,
      setDrawMode: function setDrawMode(e) {
        this.drawMode = e;
      },
      copy: function copy(e) {
        return ue.prototype.copy.call(this, e), this.drawMode = e.drawMode, this;
      },
      updateMorphTargets: function updateMorphTargets() {
        var e = this.geometry.morphTargets;
        if (void 0 !== e && e.length > 0) {
          this.morphTargetInfluences = [], this.morphTargetDictionary = {};
          for (var t = 0, r = e.length; t < r; t++) this.morphTargetInfluences.push(0), this.morphTargetDictionary[e[t].name] = t;
        }
      },
      raycast: function () {
        function e(e, t, r, n, i, a, o) {
          return fe.barycoordFromPoint(e, t, r, n, b), i.multiplyScalar(b.x), a.multiplyScalar(b.y), o.multiplyScalar(b.z), i.add(a).add(o), i.clone();
        }
        function t(e, t, r, n, i, a, o) {
          var s = e.material;
          if (null === (s.side === va ? r.intersectTriangle(a, i, n, !0, o) : r.intersectTriangle(n, i, a, s.side !== ba, o))) return null;
          w.copy(o), w.applyMatrix4(e.matrixWorld);
          var l = t.ray.origin.distanceTo(w);
          return l < t.near || l > t.far ? null : {
            distance: l,
            point: w.clone(),
            object: e
          };
        }
        function r(r, n, i, a, o, u, h, f) {
          s.fromBufferAttribute(a, u), l.fromBufferAttribute(a, h), c.fromBufferAttribute(a, f);
          var d = t(r, n, i, s, l, c, y);
          return d && (o && (m.fromBufferAttribute(o, u), g.fromBufferAttribute(o, h), v.fromBufferAttribute(o, f), d.uv = e(y, s, l, c, m, g, v)), d.face = new de(u, h, f, fe.normal(s, l, c)), d.faceIndex = u), d;
        }
        var n = new h(),
          a = new se(),
          o = new re(),
          s = new u(),
          l = new u(),
          c = new u(),
          f = new u(),
          d = new u(),
          p = new u(),
          m = new i(),
          g = new i(),
          v = new i(),
          b = new u(),
          y = new u(),
          w = new u();
        return function (i, u) {
          var h = this.geometry,
            b = this.material,
            w = this.matrixWorld;
          if (void 0 !== b && (null === h.boundingSphere && h.computeBoundingSphere(), o.copy(h.boundingSphere), o.applyMatrix4(w), !1 !== i.ray.intersectsSphere(o) && (n.getInverse(w), a.copy(i.ray).applyMatrix4(n), null === h.boundingBox || !1 !== a.intersectsBox(h.boundingBox)))) {
            var x;
            if (h.isBufferGeometry) {
              var _,
                S,
                C,
                E,
                A,
                T = h.index,
                k = h.attributes.position,
                R = h.attributes.uv;
              if (null !== T) for (E = 0, A = T.count; E < A; E += 3) _ = T.getX(E), S = T.getX(E + 1), C = T.getX(E + 2), (x = r(this, i, a, k, R, _, S, C)) && (x.faceIndex = Math.floor(E / 3), u.push(x));else for (E = 0, A = k.count; E < A; E += 3) _ = E, S = E + 1, C = E + 2, (x = r(this, i, a, k, R, _, S, C)) && (x.index = _, u.push(x));
            } else if (h.isGeometry) {
              var I,
                M,
                O,
                P,
                B = Array.isArray(b),
                D = h.vertices,
                L = h.faces,
                F = h.faceVertexUvs[0];
              F.length > 0 && (P = F);
              for (var N = 0, U = L.length; N < U; N++) {
                var j = L[N],
                  z = B ? b[j.materialIndex] : b;
                if (void 0 !== z) {
                  if (I = D[j.a], M = D[j.b], O = D[j.c], !0 === z.morphTargets) {
                    var H = h.morphTargets,
                      G = this.morphTargetInfluences;
                    s.set(0, 0, 0), l.set(0, 0, 0), c.set(0, 0, 0);
                    for (var V = 0, q = H.length; V < q; V++) {
                      var W = G[V];
                      if (0 !== W) {
                        var X = H[V].vertices;
                        s.addScaledVector(f.subVectors(X[j.a], I), W), l.addScaledVector(d.subVectors(X[j.b], M), W), c.addScaledVector(p.subVectors(X[j.c], O), W);
                      }
                    }
                    s.add(I), l.add(M), c.add(O), I = s, M = l, O = c;
                  }
                  if (x = t(this, i, a, I, M, O, y)) {
                    if (P && P[N]) {
                      var Y = P[N];
                      m.copy(Y[0]), g.copy(Y[1]), v.copy(Y[2]), x.uv = e(y, I, M, O, m, g, v);
                    }
                    x.face = j, x.faceIndex = N, u.push(x);
                  }
                }
              }
            }
          }
        };
      }(),
      clone: function clone() {
        return new this.constructor(this.geometry, this.material).copy(this);
      }
    }), Me.prototype = Object.create(ke.prototype), Me.prototype.constructor = Me, Oe.prototype = Object.create(Re.prototype), Oe.prototype.constructor = Oe, Pe.prototype = Object.create(ke.prototype), Pe.prototype.constructor = Pe, Be.prototype = Object.create(Re.prototype), Be.prototype.constructor = Be, De.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: De,
      isCamera: !0,
      copy: function copy(e) {
        return ue.prototype.copy.call(this, e), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this;
      },
      getWorldDirection: function () {
        var e = new c();
        return function (t) {
          var r = t || new u();
          return this.getWorldQuaternion(e), r.set(0, 0, -1).applyQuaternion(e);
        };
      }(),
      clone: function clone() {
        return new this.constructor().copy(this);
      }
    }), Le.prototype = Object.assign(Object.create(De.prototype), {
      constructor: Le,
      isPerspectiveCamera: !0,
      copy: function copy(e) {
        return De.prototype.copy.call(this, e), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = null === e.view ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
      },
      setFocalLength: function setFocalLength(e) {
        var t = .5 * this.getFilmHeight() / e;
        this.fov = 2 * Ss.RAD2DEG * Math.atan(t), this.updateProjectionMatrix();
      },
      getFocalLength: function getFocalLength() {
        var e = Math.tan(.5 * Ss.DEG2RAD * this.fov);
        return .5 * this.getFilmHeight() / e;
      },
      getEffectiveFOV: function getEffectiveFOV() {
        return 2 * Ss.RAD2DEG * Math.atan(Math.tan(.5 * Ss.DEG2RAD * this.fov) / this.zoom);
      },
      getFilmWidth: function getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
      },
      getFilmHeight: function getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
      },
      setViewOffset: function setViewOffset(e, t, r, n, i, a) {
        this.aspect = e / t, this.view = {
          fullWidth: e,
          fullHeight: t,
          offsetX: r,
          offsetY: n,
          width: i,
          height: a
        }, this.updateProjectionMatrix();
      },
      clearViewOffset: function clearViewOffset() {
        this.view = null, this.updateProjectionMatrix();
      },
      updateProjectionMatrix: function updateProjectionMatrix() {
        var e = this.near,
          t = e * Math.tan(.5 * Ss.DEG2RAD * this.fov) / this.zoom,
          r = 2 * t,
          n = this.aspect * r,
          i = -.5 * n,
          a = this.view;
        if (null !== a) {
          var o = a.fullWidth,
            s = a.fullHeight;
          i += a.offsetX * n / o, t -= a.offsetY * r / s, n *= a.width / o, r *= a.height / s;
        }
        var l = this.filmOffset;
        0 !== l && (i += e * l / this.getFilmWidth()), this.projectionMatrix.makePerspective(i, i + n, t, t - r, e, this.far);
      },
      toJSON: function toJSON(e) {
        var t = ue.prototype.toJSON.call(this, e);
        return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
      }
    }), Fe.prototype = Object.assign(Object.create(De.prototype), {
      constructor: Fe,
      isOrthographicCamera: !0,
      copy: function copy(e) {
        return De.prototype.copy.call(this, e), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = null === e.view ? null : Object.assign({}, e.view), this;
      },
      setViewOffset: function setViewOffset(e, t, r, n, i, a) {
        this.view = {
          fullWidth: e,
          fullHeight: t,
          offsetX: r,
          offsetY: n,
          width: i,
          height: a
        }, this.updateProjectionMatrix();
      },
      clearViewOffset: function clearViewOffset() {
        this.view = null, this.updateProjectionMatrix();
      },
      updateProjectionMatrix: function updateProjectionMatrix() {
        var e = (this.right - this.left) / (2 * this.zoom),
          t = (this.top - this.bottom) / (2 * this.zoom),
          r = (this.right + this.left) / 2,
          n = (this.top + this.bottom) / 2,
          i = r - e,
          a = r + e,
          o = n + t,
          s = n - t;
        if (null !== this.view) {
          var l = this.zoom / (this.view.width / this.view.fullWidth),
            c = this.zoom / (this.view.height / this.view.fullHeight),
            u = (this.right - this.left) / this.view.width,
            h = (this.top - this.bottom) / this.view.height;
          i += u * (this.view.offsetX / l), a = i + u * (this.view.width / l), o -= h * (this.view.offsetY / c), s = o - h * (this.view.height / c);
        }
        this.projectionMatrix.makeOrthographic(i, a, o, s, this.near, this.far);
      },
      toJSON: function toJSON(e) {
        var t = ue.prototype.toJSON.call(this, e);
        return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
      }
    });
    var js = 0;
    gt.prototype.isFogExp2 = !0, gt.prototype.clone = function () {
      return new gt(this.color.getHex(), this.density);
    }, gt.prototype.toJSON = function (e) {
      return {
        type: "FogExp2",
        color: this.color.getHex(),
        density: this.density
      };
    }, vt.prototype.isFog = !0, vt.prototype.clone = function () {
      return new vt(this.color.getHex(), this.near, this.far);
    }, vt.prototype.toJSON = function (e) {
      return {
        type: "Fog",
        color: this.color.getHex(),
        near: this.near,
        far: this.far
      };
    }, bt.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: bt,
      copy: function copy(e, t) {
        return ue.prototype.copy.call(this, e, t), null !== e.background && (this.background = e.background.clone()), null !== e.fog && (this.fog = e.fog.clone()), null !== e.overrideMaterial && (this.overrideMaterial = e.overrideMaterial.clone()), this.autoUpdate = e.autoUpdate, this.matrixAutoUpdate = e.matrixAutoUpdate, this;
      },
      toJSON: function toJSON(e) {
        var t = ue.prototype.toJSON.call(this, e);
        return null !== this.background && (t.object.background = this.background.toJSON(e)), null !== this.fog && (t.object.fog = this.fog.toJSON()), t;
      }
    }), yt.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: yt,
      isLensFlare: !0,
      copy: function copy(e) {
        ue.prototype.copy.call(this, e), this.positionScreen.copy(e.positionScreen), this.customUpdateCallback = e.customUpdateCallback;
        for (var t = 0, r = e.lensFlares.length; t < r; t++) this.lensFlares.push(e.lensFlares[t]);
        return this;
      },
      add: function add(e, t, r, n, i, a) {
        void 0 === t && (t = -1), void 0 === r && (r = 0), void 0 === a && (a = 1), void 0 === i && (i = new Y(16777215)), void 0 === n && (n = Ea), r = Math.min(r, Math.max(0, r)), this.lensFlares.push({
          texture: e,
          size: t,
          distance: r,
          x: 0,
          y: 0,
          z: 0,
          scale: 1,
          rotation: 0,
          opacity: a,
          color: i,
          blending: n
        });
      },
      updateLensFlares: function updateLensFlares() {
        var e,
          t,
          r = this.lensFlares.length,
          n = 2 * -this.positionScreen.x,
          i = 2 * -this.positionScreen.y;
        for (e = 0; e < r; e++) t = this.lensFlares[e], t.x = this.positionScreen.x + n * t.distance, t.y = this.positionScreen.y + i * t.distance, t.wantedRotation = t.x * Math.PI * .25, t.rotation += .25 * (t.wantedRotation - t.rotation);
      }
    }), wt.prototype = Object.create(Q.prototype), wt.prototype.constructor = wt, wt.prototype.isSpriteMaterial = !0, wt.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.rotation = e.rotation, this;
    }, xt.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: xt,
      isSprite: !0,
      raycast: function () {
        var e = new u(),
          t = new u(),
          r = new u();
        return function (n, i) {
          t.setFromMatrixPosition(this.matrixWorld), n.ray.closestPointToPoint(t, e), r.setFromMatrixScale(this.matrixWorld);
          var a = r.x * r.y / 4;
          if (!(t.distanceToSquared(e) > a)) {
            var o = n.ray.origin.distanceTo(e);
            o < n.near || o > n.far || i.push({
              distance: o,
              point: e.clone(),
              face: null,
              object: this
            });
          }
        };
      }(),
      clone: function clone() {
        return new this.constructor(this.material).copy(this);
      }
    }), _t.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: _t,
      copy: function copy(e) {
        ue.prototype.copy.call(this, e, !1);
        for (var t = e.levels, r = 0, n = t.length; r < n; r++) {
          var i = t[r];
          this.addLevel(i.object.clone(), i.distance);
        }
        return this;
      },
      addLevel: function addLevel(e, t) {
        void 0 === t && (t = 0), t = Math.abs(t);
        for (var r = this.levels, n = 0; n < r.length && !(t < r[n].distance); n++);
        r.splice(n, 0, {
          distance: t,
          object: e
        }), this.add(e);
      },
      getObjectForDistance: function getObjectForDistance(e) {
        for (var t = this.levels, r = 1, n = t.length; r < n && !(e < t[r].distance); r++);
        return t[r - 1].object;
      },
      raycast: function () {
        var e = new u();
        return function (t, r) {
          e.setFromMatrixPosition(this.matrixWorld);
          var n = t.ray.origin.distanceTo(e);
          this.getObjectForDistance(n).raycast(t, r);
        };
      }(),
      update: function () {
        var e = new u(),
          t = new u();
        return function (r) {
          var n = this.levels;
          if (n.length > 1) {
            e.setFromMatrixPosition(r.matrixWorld), t.setFromMatrixPosition(this.matrixWorld);
            var i = e.distanceTo(t);
            n[0].object.visible = !0;
            for (var a = 1, o = n.length; a < o && i >= n[a].distance; a++) n[a - 1].object.visible = !1, n[a].object.visible = !0;
            for (; a < o; a++) n[a].object.visible = !1;
          }
        };
      }(),
      toJSON: function toJSON(e) {
        var t = ue.prototype.toJSON.call(this, e);
        t.object.levels = [];
        for (var r = this.levels, n = 0, i = r.length; n < i; n++) {
          var a = r[n];
          t.object.levels.push({
            object: a.object.uuid,
            distance: a.distance
          });
        }
        return t;
      }
    }), Object.assign(St.prototype, {
      calculateInverses: function calculateInverses() {
        this.boneInverses = [];
        for (var e = 0, t = this.bones.length; e < t; e++) {
          var r = new h();
          this.bones[e] && r.getInverse(this.bones[e].matrixWorld), this.boneInverses.push(r);
        }
      },
      pose: function pose() {
        var e, t, r;
        for (t = 0, r = this.bones.length; t < r; t++) (e = this.bones[t]) && e.matrixWorld.getInverse(this.boneInverses[t]);
        for (t = 0, r = this.bones.length; t < r; t++) (e = this.bones[t]) && (e.parent && e.parent.isBone ? (e.matrix.getInverse(e.parent.matrixWorld), e.matrix.multiply(e.matrixWorld)) : e.matrix.copy(e.matrixWorld), e.matrix.decompose(e.position, e.quaternion, e.scale));
      },
      update: function () {
        var e = new h(),
          t = new h();
        return function () {
          for (var r = this.bones, n = this.boneInverses, i = this.boneMatrices, a = this.boneTexture, o = 0, s = r.length; o < s; o++) {
            var l = r[o] ? r[o].matrixWorld : t;
            e.multiplyMatrices(l, n[o]), e.toArray(i, 16 * o);
          }
          void 0 !== a && (a.needsUpdate = !0);
        };
      }(),
      clone: function clone() {
        return new St(this.bones, this.boneInverses);
      }
    }), Ct.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Ct,
      isBone: !0
    }), Et.prototype = Object.assign(Object.create(Ie.prototype), {
      constructor: Et,
      isSkinnedMesh: !0,
      initBones: function initBones() {
        var e,
          t,
          r,
          n,
          i = [];
        if (this.geometry && void 0 !== this.geometry.bones) {
          for (r = 0, n = this.geometry.bones.length; r < n; r++) t = this.geometry.bones[r], e = new Ct(), i.push(e), e.name = t.name, e.position.fromArray(t.pos), e.quaternion.fromArray(t.rotq), void 0 !== t.scl && e.scale.fromArray(t.scl);
          for (r = 0, n = this.geometry.bones.length; r < n; r++) t = this.geometry.bones[r], -1 !== t.parent && null !== t.parent && void 0 !== i[t.parent] ? i[t.parent].add(i[r]) : this.add(i[r]);
        }
        return this.updateMatrixWorld(!0), i;
      },
      bind: function bind(e, t) {
        this.skeleton = e, void 0 === t && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.getInverse(t);
      },
      pose: function pose() {
        this.skeleton.pose();
      },
      normalizeSkinWeights: function normalizeSkinWeights() {
        var e, t;
        if (this.geometry && this.geometry.isGeometry) for (t = 0; t < this.geometry.skinWeights.length; t++) {
          var r = this.geometry.skinWeights[t];
          e = 1 / r.lengthManhattan(), e !== 1 / 0 ? r.multiplyScalar(e) : r.set(1, 0, 0, 0);
        } else if (this.geometry && this.geometry.isBufferGeometry) {
          var n = new o(),
            i = this.geometry.attributes.skinWeight;
          for (t = 0; t < i.count; t++) n.x = i.getX(t), n.y = i.getY(t), n.z = i.getZ(t), n.w = i.getW(t), e = 1 / n.lengthManhattan(), e !== 1 / 0 ? n.multiplyScalar(e) : n.set(1, 0, 0, 0), i.setXYZW(t, n.x, n.y, n.z, n.w);
        }
      },
      updateMatrixWorld: function updateMatrixWorld(e) {
        Ie.prototype.updateMatrixWorld.call(this, e), "attached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.matrixWorld) : "detached" === this.bindMode ? this.bindMatrixInverse.getInverse(this.bindMatrix) : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
      },
      clone: function clone() {
        return new this.constructor(this.geometry, this.material).copy(this);
      }
    }), At.prototype = Object.create(Q.prototype), At.prototype.constructor = At, At.prototype.isLineBasicMaterial = !0, At.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this;
    }, Tt.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Tt,
      isLine: !0,
      raycast: function () {
        var e = new h(),
          t = new se(),
          r = new re();
        return function (n, i) {
          var a = n.linePrecision,
            o = a * a,
            s = this.geometry,
            l = this.matrixWorld;
          if (null === s.boundingSphere && s.computeBoundingSphere(), r.copy(s.boundingSphere), r.applyMatrix4(l), !1 !== n.ray.intersectsSphere(r)) {
            e.getInverse(l), t.copy(n.ray).applyMatrix4(e);
            var c = new u(),
              h = new u(),
              f = new u(),
              d = new u(),
              p = this && this.isLineSegments ? 2 : 1;
            if (s.isBufferGeometry) {
              var m = s.index,
                g = s.attributes,
                v = g.position.array;
              if (null !== m) for (var b = m.array, y = 0, w = b.length - 1; y < w; y += p) {
                var x = b[y],
                  _ = b[y + 1];
                c.fromArray(v, 3 * x), h.fromArray(v, 3 * _);
                var S = t.distanceSqToSegment(c, h, d, f);
                if (!(S > o)) {
                  d.applyMatrix4(this.matrixWorld);
                  var C = n.ray.origin.distanceTo(d);
                  C < n.near || C > n.far || i.push({
                    distance: C,
                    point: f.clone().applyMatrix4(this.matrixWorld),
                    index: y,
                    face: null,
                    faceIndex: null,
                    object: this
                  });
                }
              } else for (var y = 0, w = v.length / 3 - 1; y < w; y += p) {
                c.fromArray(v, 3 * y), h.fromArray(v, 3 * y + 3);
                var S = t.distanceSqToSegment(c, h, d, f);
                if (!(S > o)) {
                  d.applyMatrix4(this.matrixWorld);
                  var C = n.ray.origin.distanceTo(d);
                  C < n.near || C > n.far || i.push({
                    distance: C,
                    point: f.clone().applyMatrix4(this.matrixWorld),
                    index: y,
                    face: null,
                    faceIndex: null,
                    object: this
                  });
                }
              }
            } else if (s.isGeometry) for (var E = s.vertices, A = E.length, y = 0; y < A - 1; y += p) {
              var S = t.distanceSqToSegment(E[y], E[y + 1], d, f);
              if (!(S > o)) {
                d.applyMatrix4(this.matrixWorld);
                var C = n.ray.origin.distanceTo(d);
                C < n.near || C > n.far || i.push({
                  distance: C,
                  point: f.clone().applyMatrix4(this.matrixWorld),
                  index: y,
                  face: null,
                  faceIndex: null,
                  object: this
                });
              }
            }
          }
        };
      }(),
      clone: function clone() {
        return new this.constructor(this.geometry, this.material).copy(this);
      }
    }), kt.prototype = Object.assign(Object.create(Tt.prototype), {
      constructor: kt,
      isLineSegments: !0
    }), Rt.prototype = Object.assign(Object.create(Tt.prototype), {
      constructor: Rt,
      isLineLoop: !0
    }), It.prototype = Object.create(Q.prototype), It.prototype.constructor = It, It.prototype.isPointsMaterial = !0, It.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this;
    }, Mt.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Mt,
      isPoints: !0,
      raycast: function () {
        var e = new h(),
          t = new se(),
          r = new re();
        return function (n, i) {
          function a(e, r) {
            var a = t.distanceSqToPoint(e);
            if (a < f) {
              var s = t.closestPointToPoint(e);
              s.applyMatrix4(l);
              var c = n.ray.origin.distanceTo(s);
              if (c < n.near || c > n.far) return;
              i.push({
                distance: c,
                distanceToRay: Math.sqrt(a),
                point: s.clone(),
                index: r,
                face: null,
                object: o
              });
            }
          }
          var o = this,
            s = this.geometry,
            l = this.matrixWorld,
            c = n.params.Points.threshold;
          if (null === s.boundingSphere && s.computeBoundingSphere(), r.copy(s.boundingSphere), r.applyMatrix4(l), r.radius += c, !1 !== n.ray.intersectsSphere(r)) {
            e.getInverse(l), t.copy(n.ray).applyMatrix4(e);
            var h = c / ((this.scale.x + this.scale.y + this.scale.z) / 3),
              f = h * h,
              d = new u();
            if (s.isBufferGeometry) {
              var p = s.index,
                m = s.attributes,
                g = m.position.array;
              if (null !== p) for (var v = p.array, b = 0, y = v.length; b < y; b++) {
                var w = v[b];
                d.fromArray(g, 3 * w), a(d, w);
              } else for (var b = 0, x = g.length / 3; b < x; b++) d.fromArray(g, 3 * b), a(d, b);
            } else for (var _ = s.vertices, b = 0, x = _.length; b < x; b++) a(_[b], b);
          }
        };
      }(),
      clone: function clone() {
        return new this.constructor(this.geometry, this.material).copy(this);
      }
    }), Ot.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Ot
    }), Pt.prototype = Object.create(a.prototype), Pt.prototype.constructor = Pt, Bt.prototype = Object.create(a.prototype), Bt.prototype.constructor = Bt, Bt.prototype.isCompressedTexture = !0, Dt.prototype = Object.create(a.prototype), Dt.prototype.constructor = Dt, Lt.prototype = Object.create(a.prototype), Lt.prototype.constructor = Lt, Lt.prototype.isDepthTexture = !0, Ft.prototype = Object.create(Re.prototype), Ft.prototype.constructor = Ft, Nt.prototype = Object.create(ke.prototype), Nt.prototype.constructor = Nt, Ut.prototype = Object.create(Re.prototype), Ut.prototype.constructor = Ut, jt.prototype = Object.create(ke.prototype), jt.prototype.constructor = jt, zt.prototype = Object.create(Re.prototype), zt.prototype.constructor = zt, Ht.prototype = Object.create(ke.prototype), Ht.prototype.constructor = Ht, Gt.prototype = Object.create(zt.prototype), Gt.prototype.constructor = Gt, Vt.prototype = Object.create(ke.prototype), Vt.prototype.constructor = Vt, qt.prototype = Object.create(zt.prototype), qt.prototype.constructor = qt, Wt.prototype = Object.create(ke.prototype), Wt.prototype.constructor = Wt, Xt.prototype = Object.create(zt.prototype), Xt.prototype.constructor = Xt, Yt.prototype = Object.create(ke.prototype), Yt.prototype.constructor = Yt, Kt.prototype = Object.create(zt.prototype), Kt.prototype.constructor = Kt, Zt.prototype = Object.create(ke.prototype), Zt.prototype.constructor = Zt, Jt.prototype = Object.create(Re.prototype), Jt.prototype.constructor = Jt, Qt.prototype = Object.create(ke.prototype), Qt.prototype.constructor = Qt, $t.prototype = Object.create(Re.prototype), $t.prototype.constructor = $t, er.prototype = Object.create(ke.prototype), er.prototype.constructor = er, tr.prototype = Object.create(Re.prototype), tr.prototype.constructor = tr;
    var zs = {
      area: function area(e) {
        for (var t = e.length, r = 0, n = t - 1, i = 0; i < t; n = i++) r += e[n].x * e[i].y - e[i].x * e[n].y;
        return .5 * r;
      },
      triangulate: function () {
        function e(e, t, r, n, i, a) {
          var o, s, l, c, u, h, f, d, p;
          if (s = e[a[t]].x, l = e[a[t]].y, c = e[a[r]].x, u = e[a[r]].y, h = e[a[n]].x, f = e[a[n]].y, (c - s) * (f - l) - (u - l) * (h - s) <= 0) return !1;
          var m, g, v, b, y, w, x, _, S, C, E, A, T, k, R;
          for (m = h - c, g = f - u, v = s - h, b = l - f, y = c - s, w = u - l, o = 0; o < i; o++) if (d = e[a[o]].x, p = e[a[o]].y, !(d === s && p === l || d === c && p === u || d === h && p === f) && (x = d - s, _ = p - l, S = d - c, C = p - u, E = d - h, A = p - f, R = m * C - g * S, T = y * _ - w * x, k = v * A - b * E, R >= -Number.EPSILON && k >= -Number.EPSILON && T >= -Number.EPSILON)) return !1;
          return !0;
        }
        return function (t, r) {
          var n = t.length;
          if (n < 3) return null;
          var i,
            a,
            o,
            s = [],
            l = [],
            c = [];
          if (zs.area(t) > 0) for (a = 0; a < n; a++) l[a] = a;else for (a = 0; a < n; a++) l[a] = n - 1 - a;
          var u = n,
            h = 2 * u;
          for (a = u - 1; u > 2;) {
            if (h-- <= 0) return console.warn("THREE.ShapeUtils: Unable to triangulate polygon! in triangulate()"), r ? c : s;
            if (i = a, u <= i && (i = 0), a = i + 1, u <= a && (a = 0), o = a + 1, u <= o && (o = 0), e(t, i, a, o, u, l)) {
              var f, d, p, m, g;
              for (f = l[i], d = l[a], p = l[o], s.push([t[f], t[d], t[p]]), c.push([l[i], l[a], l[o]]), m = a, g = a + 1; g < u; m++, g++) l[m] = l[g];
              u--, h = 2 * u;
            }
          }
          return r ? c : s;
        };
      }(),
      triangulateShape: function triangulateShape(e, t) {
        function r(e) {
          var t = e.length;
          t > 2 && e[t - 1].equals(e[0]) && e.pop();
        }
        function n(e, t, r) {
          return e.x !== t.x ? e.x < t.x ? e.x <= r.x && r.x <= t.x : t.x <= r.x && r.x <= e.x : e.y < t.y ? e.y <= r.y && r.y <= t.y : t.y <= r.y && r.y <= e.y;
        }
        function i(e, t, r, i, a) {
          var o = t.x - e.x,
            s = t.y - e.y,
            l = i.x - r.x,
            c = i.y - r.y,
            u = e.x - r.x,
            h = e.y - r.y,
            f = s * l - o * c,
            d = s * u - o * h;
          if (Math.abs(f) > Number.EPSILON) {
            var p;
            if (f > 0) {
              if (d < 0 || d > f) return [];
              if ((p = c * u - l * h) < 0 || p > f) return [];
            } else {
              if (d > 0 || d < f) return [];
              if ((p = c * u - l * h) > 0 || p < f) return [];
            }
            if (0 === p) return !a || 0 !== d && d !== f ? [e] : [];
            if (p === f) return !a || 0 !== d && d !== f ? [t] : [];
            if (0 === d) return [r];
            if (d === f) return [i];
            var m = p / f;
            return [{
              x: e.x + m * o,
              y: e.y + m * s
            }];
          }
          if (0 !== d || c * u != l * h) return [];
          var g = 0 === o && 0 === s,
            v = 0 === l && 0 === c;
          if (g && v) return e.x !== r.x || e.y !== r.y ? [] : [e];
          if (g) return n(r, i, e) ? [e] : [];
          if (v) return n(e, t, r) ? [r] : [];
          var b, y, w, x, _, S, C, E;
          return 0 !== o ? (e.x < t.x ? (b = e, w = e.x, y = t, x = t.x) : (b = t, w = t.x, y = e, x = e.x), r.x < i.x ? (_ = r, C = r.x, S = i, E = i.x) : (_ = i, C = i.x, S = r, E = r.x)) : (e.y < t.y ? (b = e, w = e.y, y = t, x = t.y) : (b = t, w = t.y, y = e, x = e.y), r.y < i.y ? (_ = r, C = r.y, S = i, E = i.y) : (_ = i, C = i.y, S = r, E = r.y)), w <= C ? x < C ? [] : x === C ? a ? [] : [_] : x <= E ? [_, y] : [_, S] : w > E ? [] : w === E ? a ? [] : [b] : x <= E ? [b, y] : [b, S];
        }
        function a(e, t, r, n) {
          var i = t.x - e.x,
            a = t.y - e.y,
            o = r.x - e.x,
            s = r.y - e.y,
            l = n.x - e.x,
            c = n.y - e.y,
            u = i * s - a * o,
            h = i * c - a * l;
          if (Math.abs(u) > Number.EPSILON) {
            var f = l * s - c * o;
            return u > 0 ? h >= 0 && f >= 0 : h >= 0 || f >= 0;
          }
          return h > 0;
        }
        r(e), t.forEach(r);
        for (var o, s, l, c, u, h, f = {}, d = e.concat(), p = 0, m = t.length; p < m; p++) Array.prototype.push.apply(d, t[p]);
        for (o = 0, s = d.length; o < s; o++) u = d[o].x + ":" + d[o].y, void 0 !== f[u] && console.warn("THREE.ShapeUtils: Duplicate point", u, o), f[u] = o;
        var g = function (e, t) {
            for (var r, n, o, s, l, c, u, h, f, d, p, m = e.concat(), g = [], v = [], b = 0, y = t.length; b < y; b++) g.push(b);
            for (var w = 0, x = 2 * g.length; g.length > 0;) {
              if (--x < 0) {
                console.log("Infinite Loop! Holes left:" + g.length + ", Probably Hole outside Shape!");
                break;
              }
              for (o = w; o < m.length; o++) {
                s = m[o], n = -1;
                for (var b = 0; b < g.length; b++) if (c = g[b], u = s.x + ":" + s.y + ":" + c, void 0 === v[u]) {
                  r = t[c];
                  for (var _ = 0; _ < r.length; _++) if (l = r[_], function (e, t) {
                    var n = m.length - 1,
                      i = e - 1;
                    i < 0 && (i = n);
                    var o = e + 1;
                    o > n && (o = 0);
                    var s = a(m[e], m[i], m[o], r[t]);
                    if (!s) return !1;
                    var l = r.length - 1,
                      c = t - 1;
                    c < 0 && (c = l);
                    var u = t + 1;
                    return u > l && (u = 0), !!(s = a(r[t], r[c], r[u], m[e]));
                  }(o, _) && !function (e, t) {
                    var r, n, a;
                    for (r = 0; r < m.length; r++) if (n = r + 1, n %= m.length, a = i(e, t, m[r], m[n], !0), a.length > 0) return !0;
                    return !1;
                  }(s, l) && !function (e, r) {
                    var n, a, o, s, l;
                    for (n = 0; n < g.length; n++) for (a = t[g[n]], o = 0; o < a.length; o++) if (s = o + 1, s %= a.length, l = i(e, r, a[o], a[s], !0), l.length > 0) return !0;
                    return !1;
                  }(s, l)) {
                    n = _, g.splice(b, 1), h = m.slice(0, o + 1), f = m.slice(o), d = r.slice(n), p = r.slice(0, n + 1), m = h.concat(d).concat(p).concat(f), w = o;
                    break;
                  }
                  if (n >= 0) break;
                  v[u] = !0;
                }
                if (n >= 0) break;
              }
            }
            return m;
          }(e, t),
          v = zs.triangulate(g, !1);
        for (o = 0, s = v.length; o < s; o++) for (c = v[o], l = 0; l < 3; l++) u = c[l].x + ":" + c[l].y, void 0 !== (h = f[u]) && (c[l] = h);
        return v.concat();
      },
      isClockWise: function isClockWise(e) {
        return zs.area(e) < 0;
      }
    };
    rr.prototype = Object.create(ke.prototype), rr.prototype.constructor = rr, nr.prototype = Object.create(Re.prototype), nr.prototype.constructor = nr, nr.prototype.getArrays = function () {
      var e = this.getAttribute("position"),
        t = e ? Array.prototype.slice.call(e.array) : [],
        r = this.getAttribute("uv"),
        n = r ? Array.prototype.slice.call(r.array) : [],
        i = this.index;
      return {
        position: t,
        uv: n,
        index: i ? Array.prototype.slice.call(i.array) : []
      };
    }, nr.prototype.addShapeList = function (e, t) {
      var r = e.length;
      t.arrays = this.getArrays();
      for (var n = 0; n < r; n++) {
        var i = e[n];
        this.addShape(i, t);
      }
      this.setIndex(t.arrays.index), this.addAttribute("position", new Se(t.arrays.position, 3)), this.addAttribute("uv", new Se(t.arrays.uv, 2));
    }, nr.prototype.addShape = function (e, t) {
      function r(e, t, r) {
        return t || console.error("THREE.ExtrudeGeometry: vec does not exist"), t.clone().multiplyScalar(r).add(e);
      }
      function n(e, t, r) {
        var n,
          a,
          o = 1,
          s = e.x - t.x,
          l = e.y - t.y,
          c = r.x - e.x,
          u = r.y - e.y,
          h = s * s + l * l,
          f = s * u - l * c;
        if (Math.abs(f) > Number.EPSILON) {
          var d = Math.sqrt(h),
            p = Math.sqrt(c * c + u * u),
            m = t.x - l / d,
            g = t.y + s / d,
            v = r.x - u / p,
            b = r.y + c / p,
            y = ((v - m) * u - (b - g) * c) / (s * u - l * c);
          n = m + s * y - e.x, a = g + l * y - e.y;
          var w = n * n + a * a;
          if (w <= 2) return new i(n, a);
          o = Math.sqrt(w / 2);
        } else {
          var x = !1;
          s > Number.EPSILON ? c > Number.EPSILON && (x = !0) : s < -Number.EPSILON ? c < -Number.EPSILON && (x = !0) : Math.sign(l) === Math.sign(u) && (x = !0), x ? (n = -l, a = s, o = Math.sqrt(h)) : (n = s, a = l, o = Math.sqrt(h / 2));
        }
        return new i(n / o, a / o);
      }
      function a(e, t) {
        var r, n;
        for (J = e.length; --J >= 0;) {
          r = J, n = J - 1, n < 0 && (n = e.length - 1);
          var i = 0,
            a = k + 2 * E;
          for (i = 0; i < a; i++) {
            var o = Y * i,
              s = Y * (i + 1);
            l(t + r + o, t + n + o, t + n + s, t + r + s, e, i, a, r, n);
          }
        }
      }
      function o(e, t, r) {
        x.push(e), x.push(t), x.push(r);
      }
      function s(e, t, r) {
        c(e), c(t), c(r);
        var n = b.length / 3,
          i = M.generateTopUV(D, b, n - 3, n - 2, n - 1);
        h(i[0]), h(i[1]), h(i[2]);
      }
      function l(e, t, r, n, i, a, o, s, l) {
        c(e), c(t), c(n), c(t), c(r), c(n);
        var u = b.length / 3,
          f = M.generateSideWallUV(D, b, u - 6, u - 3, u - 2, u - 1);
        h(f[0]), h(f[1]), h(f[3]), h(f[1]), h(f[2]), h(f[3]);
      }
      function c(e) {
        y.push(b.length / 3), b.push(x[3 * e + 0]), b.push(x[3 * e + 1]), b.push(x[3 * e + 2]);
      }
      function h(e) {
        w.push(e.x), w.push(e.y);
      }
      var f,
        d,
        p,
        m,
        g,
        v = t.arrays ? t.arrays : this.getArrays(),
        b = v.position,
        y = v.index,
        w = v.uv,
        x = [],
        _ = void 0 !== t.amount ? t.amount : 100,
        S = void 0 !== t.bevelThickness ? t.bevelThickness : 6,
        C = void 0 !== t.bevelSize ? t.bevelSize : S - 2,
        E = void 0 !== t.bevelSegments ? t.bevelSegments : 3,
        A = void 0 === t.bevelEnabled || t.bevelEnabled,
        T = void 0 !== t.curveSegments ? t.curveSegments : 12,
        k = void 0 !== t.steps ? t.steps : 1,
        R = t.extrudePath,
        I = !1,
        M = void 0 !== t.UVGenerator ? t.UVGenerator : rr.WorldUVGenerator;
      R && (f = R.getSpacedPoints(k), I = !0, A = !1, d = void 0 !== t.frames ? t.frames : R.computeFrenetFrames(k, !1), p = new u(), m = new u(), g = new u()), A || (E = 0, S = 0, C = 0);
      var O,
        P,
        B,
        D = this,
        L = e.extractPoints(T),
        F = L.shape,
        N = L.holes,
        U = !zs.isClockWise(F);
      if (U) {
        for (F = F.reverse(), P = 0, B = N.length; P < B; P++) O = N[P], zs.isClockWise(O) && (N[P] = O.reverse());
        U = !1;
      }
      var j = zs.triangulateShape(F, N),
        z = F;
      for (P = 0, B = N.length; P < B; P++) O = N[P], F = F.concat(O);
      for (var H, G, V, q, W, X, Y = F.length, K = j.length, Z = [], J = 0, Q = z.length, $ = Q - 1, ee = J + 1; J < Q; J++, $++, ee++) $ === Q && ($ = 0), ee === Q && (ee = 0), Z[J] = n(z[J], z[$], z[ee]);
      var te,
        re = [],
        ne = Z.concat();
      for (P = 0, B = N.length; P < B; P++) {
        for (O = N[P], te = [], J = 0, Q = O.length, $ = Q - 1, ee = J + 1; J < Q; J++, $++, ee++) $ === Q && ($ = 0), ee === Q && (ee = 0), te[J] = n(O[J], O[$], O[ee]);
        re.push(te), ne = ne.concat(te);
      }
      for (H = 0; H < E; H++) {
        for (V = H / E, q = S * Math.cos(V * Math.PI / 2), G = C * Math.sin(V * Math.PI / 2), J = 0, Q = z.length; J < Q; J++) W = r(z[J], Z[J], G), o(W.x, W.y, -q);
        for (P = 0, B = N.length; P < B; P++) for (O = N[P], te = re[P], J = 0, Q = O.length; J < Q; J++) W = r(O[J], te[J], G), o(W.x, W.y, -q);
      }
      for (G = C, J = 0; J < Y; J++) W = A ? r(F[J], ne[J], G) : F[J], I ? (m.copy(d.normals[0]).multiplyScalar(W.x), p.copy(d.binormals[0]).multiplyScalar(W.y), g.copy(f[0]).add(m).add(p), o(g.x, g.y, g.z)) : o(W.x, W.y, 0);
      var ie;
      for (ie = 1; ie <= k; ie++) for (J = 0; J < Y; J++) W = A ? r(F[J], ne[J], G) : F[J], I ? (m.copy(d.normals[ie]).multiplyScalar(W.x), p.copy(d.binormals[ie]).multiplyScalar(W.y), g.copy(f[ie]).add(m).add(p), o(g.x, g.y, g.z)) : o(W.x, W.y, _ / k * ie);
      for (H = E - 1; H >= 0; H--) {
        for (V = H / E, q = S * Math.cos(V * Math.PI / 2), G = C * Math.sin(V * Math.PI / 2), J = 0, Q = z.length; J < Q; J++) W = r(z[J], Z[J], G), o(W.x, W.y, _ + q);
        for (P = 0, B = N.length; P < B; P++) for (O = N[P], te = re[P], J = 0, Q = O.length; J < Q; J++) W = r(O[J], te[J], G), I ? o(W.x, W.y + f[k - 1].y, f[k - 1].x + q) : o(W.x, W.y, _ + q);
      }
      !function () {
        var e = b.length / 3;
        if (A) {
          var r = 0,
            n = Y * r;
          for (J = 0; J < K; J++) X = j[J], s(X[2] + n, X[1] + n, X[0] + n);
          for (r = k + 2 * E, n = Y * r, J = 0; J < K; J++) X = j[J], s(X[0] + n, X[1] + n, X[2] + n);
        } else {
          for (J = 0; J < K; J++) X = j[J], s(X[2], X[1], X[0]);
          for (J = 0; J < K; J++) X = j[J], s(X[0] + Y * k, X[1] + Y * k, X[2] + Y * k);
        }
        D.addGroup(e, b.length / 3 - e, void 0 !== t.material ? t.material : 0);
      }(), function () {
        var e = b.length / 3,
          r = 0;
        for (a(z, r), r += z.length, P = 0, B = N.length; P < B; P++) O = N[P], a(O, r), r += O.length;
        D.addGroup(e, b.length / 3 - e, void 0 !== t.extrudeMaterial ? t.extrudeMaterial : 1);
      }(), t.arrays || (this.setIndex(y), this.addAttribute("position", new Se(b, 3)), this.addAttribute("uv", new Se(t.arrays.uv, 2)));
    }, rr.WorldUVGenerator = {
      generateTopUV: function generateTopUV(e, t, r, n, a) {
        var o = t[3 * r],
          s = t[3 * r + 1],
          l = t[3 * n],
          c = t[3 * n + 1],
          u = t[3 * a],
          h = t[3 * a + 1];
        return [new i(o, s), new i(l, c), new i(u, h)];
      },
      generateSideWallUV: function generateSideWallUV(e, t, r, n, a, o) {
        var s = t[3 * r],
          l = t[3 * r + 1],
          c = t[3 * r + 2],
          u = t[3 * n],
          h = t[3 * n + 1],
          f = t[3 * n + 2],
          d = t[3 * a],
          p = t[3 * a + 1],
          m = t[3 * a + 2],
          g = t[3 * o],
          v = t[3 * o + 1],
          b = t[3 * o + 2];
        return Math.abs(l - h) < .01 ? [new i(s, 1 - c), new i(u, 1 - f), new i(d, 1 - m), new i(g, 1 - b)] : [new i(l, 1 - c), new i(h, 1 - f), new i(p, 1 - m), new i(v, 1 - b)];
      }
    }, ir.prototype = Object.create(ke.prototype), ir.prototype.constructor = ir, ar.prototype = Object.create(nr.prototype), ar.prototype.constructor = ar, or.prototype = Object.create(ke.prototype), or.prototype.constructor = or, sr.prototype = Object.create(Re.prototype), sr.prototype.constructor = sr, lr.prototype = Object.create(ke.prototype), lr.prototype.constructor = lr, cr.prototype = Object.create(Re.prototype), cr.prototype.constructor = cr, ur.prototype = Object.create(ke.prototype), ur.prototype.constructor = ur, hr.prototype = Object.create(Re.prototype), hr.prototype.constructor = hr, fr.prototype = Object.create(ke.prototype), fr.prototype.constructor = fr, dr.prototype = Object.create(Re.prototype), dr.prototype.constructor = dr, pr.prototype = Object.create(Re.prototype), pr.prototype.constructor = pr, mr.prototype = Object.create(ke.prototype), mr.prototype.constructor = mr, gr.prototype = Object.create(Re.prototype), gr.prototype.constructor = gr, vr.prototype = Object.create(mr.prototype), vr.prototype.constructor = vr, br.prototype = Object.create(gr.prototype), br.prototype.constructor = br, yr.prototype = Object.create(ke.prototype), yr.prototype.constructor = yr, wr.prototype = Object.create(Re.prototype), wr.prototype.constructor = wr;
    var Hs = Object.freeze({
      WireframeGeometry: Ft,
      ParametricGeometry: Nt,
      ParametricBufferGeometry: Ut,
      TetrahedronGeometry: Ht,
      TetrahedronBufferGeometry: Gt,
      OctahedronGeometry: Vt,
      OctahedronBufferGeometry: qt,
      IcosahedronGeometry: Wt,
      IcosahedronBufferGeometry: Xt,
      DodecahedronGeometry: Yt,
      DodecahedronBufferGeometry: Kt,
      PolyhedronGeometry: jt,
      PolyhedronBufferGeometry: zt,
      TubeGeometry: Zt,
      TubeBufferGeometry: Jt,
      TorusKnotGeometry: Qt,
      TorusKnotBufferGeometry: $t,
      TorusGeometry: er,
      TorusBufferGeometry: tr,
      TextGeometry: ir,
      TextBufferGeometry: ar,
      SphereGeometry: or,
      SphereBufferGeometry: sr,
      RingGeometry: lr,
      RingBufferGeometry: cr,
      PlaneGeometry: Pe,
      PlaneBufferGeometry: Be,
      LatheGeometry: ur,
      LatheBufferGeometry: hr,
      ShapeGeometry: fr,
      ShapeBufferGeometry: dr,
      ExtrudeGeometry: rr,
      ExtrudeBufferGeometry: nr,
      EdgesGeometry: pr,
      ConeGeometry: vr,
      ConeBufferGeometry: br,
      CylinderGeometry: mr,
      CylinderBufferGeometry: gr,
      CircleGeometry: yr,
      CircleBufferGeometry: wr,
      BoxGeometry: Me,
      BoxBufferGeometry: Oe
    });
    xr.prototype = Object.create($.prototype), xr.prototype.constructor = xr, xr.prototype.isShadowMaterial = !0, _r.prototype = Object.create($.prototype), _r.prototype.constructor = _r, _r.prototype.isRawShaderMaterial = !0, Sr.prototype = Object.create(Q.prototype), Sr.prototype.constructor = Sr, Sr.prototype.isMeshStandardMaterial = !0, Sr.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.defines = {
        STANDARD: ""
      }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapIntensity = e.envMapIntensity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
    }, Cr.prototype = Object.create(Sr.prototype), Cr.prototype.constructor = Cr, Cr.prototype.isMeshPhysicalMaterial = !0, Cr.prototype.copy = function (e) {
      return Sr.prototype.copy.call(this, e), this.defines = {
        PHYSICAL: ""
      }, this.reflectivity = e.reflectivity, this.clearCoat = e.clearCoat, this.clearCoatRoughness = e.clearCoatRoughness, this;
    }, Er.prototype = Object.create(Q.prototype), Er.prototype.constructor = Er, Er.prototype.isMeshPhongMaterial = !0, Er.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
    }, Ar.prototype = Object.create(Er.prototype), Ar.prototype.constructor = Ar, Ar.prototype.isMeshToonMaterial = !0, Ar.prototype.copy = function (e) {
      return Er.prototype.copy.call(this, e), this.gradientMap = e.gradientMap, this;
    }, Tr.prototype = Object.create(Q.prototype), Tr.prototype.constructor = Tr, Tr.prototype.isMeshNormalMaterial = !0, Tr.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
    }, kr.prototype = Object.create(Q.prototype), kr.prototype.constructor = kr, kr.prototype.isMeshLambertMaterial = !0, kr.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.skinning = e.skinning, this.morphTargets = e.morphTargets, this.morphNormals = e.morphNormals, this;
    }, Rr.prototype = Object.create(Q.prototype), Rr.prototype.constructor = Rr, Rr.prototype.isLineDashedMaterial = !0, Rr.prototype.copy = function (e) {
      return Q.prototype.copy.call(this, e), this.color.copy(e.color), this.linewidth = e.linewidth, this.scale = e.scale, this.dashSize = e.dashSize, this.gapSize = e.gapSize, this;
    };
    var Gs = Object.freeze({
        ShadowMaterial: xr,
        SpriteMaterial: wt,
        RawShaderMaterial: _r,
        ShaderMaterial: $,
        PointsMaterial: It,
        MeshPhysicalMaterial: Cr,
        MeshStandardMaterial: Sr,
        MeshPhongMaterial: Er,
        MeshToonMaterial: Ar,
        MeshNormalMaterial: Tr,
        MeshLambertMaterial: kr,
        MeshDepthMaterial: ee,
        MeshBasicMaterial: pe,
        LineDashedMaterial: Rr,
        LineBasicMaterial: At,
        Material: Q
      }),
      Vs = {
        enabled: !1,
        files: {},
        add: function add(e, t) {
          !1 !== this.enabled && (this.files[e] = t);
        },
        get: function get(e) {
          if (!1 !== this.enabled) return this.files[e];
        },
        remove: function remove(e) {
          delete this.files[e];
        },
        clear: function clear() {
          this.files = {};
        }
      },
      qs = new Ir();
    Object.assign(Mr.prototype, {
      load: function load(e, t, r, n) {
        void 0 === e && (e = ""), void 0 !== this.path && (e = this.path + e);
        var i = this,
          a = Vs.get(e);
        if (void 0 !== a) return i.manager.itemStart(e), setTimeout(function () {
          t && t(a), i.manager.itemEnd(e);
        }, 0), a;
        var o = /^data:(.*?)(;base64)?,(.*)$/,
          s = e.match(o);
        if (s) {
          var l = s[1],
            c = !!s[2],
            u = s[3];
          u = window.decodeURIComponent(u), c && (u = window.atob(u));
          try {
            var h,
              f = (this.responseType || "").toLowerCase();
            switch (f) {
              case "arraybuffer":
              case "blob":
                h = new ArrayBuffer(u.length);
                for (var d = new Uint8Array(h), p = 0; p < u.length; p++) d[p] = u.charCodeAt(p);
                "blob" === f && (h = new Blob([h], {
                  type: l
                }));
                break;
              case "document":
                var m = new DOMParser();
                h = m.parseFromString(u, l);
                break;
              case "json":
                h = JSON.parse(u);
                break;
              default:
                h = u;
            }
            window.setTimeout(function () {
              t && t(h), i.manager.itemEnd(e);
            }, 0);
          } catch (t) {
            window.setTimeout(function () {
              n && n(t), i.manager.itemEnd(e), i.manager.itemError(e);
            }, 0);
          }
        } else {
          var g = new XMLHttpRequest();
          g.open("GET", e, !0), g.addEventListener("load", function (r) {
            var a = r.target.response;
            Vs.add(e, a), 200 === this.status ? (t && t(a), i.manager.itemEnd(e)) : 0 === this.status ? (console.warn("THREE.FileLoader: HTTP Status 0 received."), t && t(a), i.manager.itemEnd(e)) : (n && n(r), i.manager.itemEnd(e), i.manager.itemError(e));
          }, !1), void 0 !== r && g.addEventListener("progress", function (e) {
            r(e);
          }, !1), g.addEventListener("error", function (t) {
            n && n(t), i.manager.itemEnd(e), i.manager.itemError(e);
          }, !1), void 0 !== this.responseType && (g.responseType = this.responseType), void 0 !== this.withCredentials && (g.withCredentials = this.withCredentials), g.overrideMimeType && g.overrideMimeType(void 0 !== this.mimeType ? this.mimeType : "text/plain");
          for (var v in this.requestHeader) g.setRequestHeader(v, this.requestHeader[v]);
          g.send(null);
        }
        return i.manager.itemStart(e), g;
      },
      setPath: function setPath(e) {
        return this.path = e, this;
      },
      setResponseType: function setResponseType(e) {
        return this.responseType = e, this;
      },
      setWithCredentials: function setWithCredentials(e) {
        return this.withCredentials = e, this;
      },
      setMimeType: function setMimeType(e) {
        return this.mimeType = e, this;
      },
      setRequestHeader: function setRequestHeader(e) {
        return this.requestHeader = e, this;
      }
    }), Object.assign(Or.prototype, {
      load: function load(e, t, r, n) {
        var i = this,
          a = [],
          o = new Bt();
        o.image = a;
        var s = new Mr(this.manager);
        if (s.setPath(this.path), s.setResponseType("arraybuffer"), Array.isArray(e)) for (var l = 0, c = 0, u = e.length; c < u; ++c) !function (c) {
          s.load(e[c], function (e) {
            var r = i._parser(e, !0);
            a[c] = {
              width: r.width,
              height: r.height,
              format: r.format,
              mipmaps: r.mipmaps
            }, 6 === (l += 1) && (1 === r.mipmapCount && (o.minFilter = So), o.format = r.format, o.needsUpdate = !0, t && t(o));
          }, r, n);
        }(c);else s.load(e, function (e) {
          var r = i._parser(e, !0);
          if (r.isCubemap) for (var n = r.mipmaps.length / r.mipmapCount, s = 0; s < n; s++) {
            a[s] = {
              mipmaps: []
            };
            for (var l = 0; l < r.mipmapCount; l++) a[s].mipmaps.push(r.mipmaps[s * r.mipmapCount + l]), a[s].format = r.format, a[s].width = r.width, a[s].height = r.height;
          } else o.image.width = r.width, o.image.height = r.height, o.mipmaps = r.mipmaps;
          1 === r.mipmapCount && (o.minFilter = So), o.format = r.format, o.needsUpdate = !0, t && t(o);
        }, r, n);
        return o;
      },
      setPath: function setPath(e) {
        return this.path = e, this;
      }
    }), Object.assign(Pr.prototype, {
      load: function load(e, t, r, n) {
        var i = this,
          a = new f(),
          o = new Mr(this.manager);
        return o.setResponseType("arraybuffer"), o.load(e, function (e) {
          var r = i._parser(e);
          r && (void 0 !== r.image ? a.image = r.image : void 0 !== r.data && (a.image.width = r.width, a.image.height = r.height, a.image.data = r.data), a.wrapS = void 0 !== r.wrapS ? r.wrapS : bo, a.wrapT = void 0 !== r.wrapT ? r.wrapT : bo, a.magFilter = void 0 !== r.magFilter ? r.magFilter : So, a.minFilter = void 0 !== r.minFilter ? r.minFilter : Eo, a.anisotropy = void 0 !== r.anisotropy ? r.anisotropy : 1, void 0 !== r.format && (a.format = r.format), void 0 !== r.type && (a.type = r.type), void 0 !== r.mipmaps && (a.mipmaps = r.mipmaps), 1 === r.mipmapCount && (a.minFilter = So), a.needsUpdate = !0, t && t(a, r));
        }, r, n), a;
      }
    }), Object.assign(Br.prototype, {
      load: function load(e, t, r, n) {
        void 0 === e && (e = ""), void 0 !== this.path && (e = this.path + e);
        var i = this,
          a = Vs.get(e);
        if (void 0 !== a) return i.manager.itemStart(e), setTimeout(function () {
          t && t(a), i.manager.itemEnd(e);
        }, 0), a;
        var o = document.createElementNS("http://www.w3.org/1999/xhtml", "img");
        return o.addEventListener("load", function () {
          Vs.add(e, this), t && t(this), i.manager.itemEnd(e);
        }, !1), o.addEventListener("error", function (t) {
          n && n(t), i.manager.itemEnd(e), i.manager.itemError(e);
        }, !1), "data:" !== e.substr(0, 5) && void 0 !== this.crossOrigin && (o.crossOrigin = this.crossOrigin), i.manager.itemStart(e), o.src = e, o;
      },
      setCrossOrigin: function setCrossOrigin(e) {
        return this.crossOrigin = e, this;
      },
      setPath: function setPath(e) {
        return this.path = e, this;
      }
    }), Object.assign(Dr.prototype, {
      load: function load(e, t, r, n) {
        var i = new d(),
          a = new Br(this.manager);
        a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
        for (var o = 0, s = 0; s < e.length; ++s) !function (r) {
          a.load(e[r], function (e) {
            i.images[r] = e, 6 == ++o && (i.needsUpdate = !0, t && t(i));
          }, void 0, n);
        }(s);
        return i;
      },
      setCrossOrigin: function setCrossOrigin(e) {
        return this.crossOrigin = e, this;
      },
      setPath: function setPath(e) {
        return this.path = e, this;
      }
    }), Object.assign(Lr.prototype, {
      load: function load(e, t, r, n) {
        var i = new Br(this.manager);
        i.setCrossOrigin(this.crossOrigin), i.setPath(this.path);
        var o = new a();
        return o.image = i.load(e, function () {
          var r = e.search(/\.(jpg|jpeg)$/) > 0 || 0 === e.search(/^data\:image\/jpeg/);
          o.format = r ? Uo : jo, o.needsUpdate = !0, void 0 !== t && t(o);
        }, r, n), o;
      },
      setCrossOrigin: function setCrossOrigin(e) {
        return this.crossOrigin = e, this;
      },
      setPath: function setPath(e) {
        return this.path = e, this;
      }
    }), Fr.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Fr,
      isLight: !0,
      copy: function copy(e) {
        return ue.prototype.copy.call(this, e), this.color.copy(e.color), this.intensity = e.intensity, this;
      },
      toJSON: function toJSON(e) {
        var t = ue.prototype.toJSON.call(this, e);
        return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, void 0 !== this.groundColor && (t.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (t.object.distance = this.distance), void 0 !== this.angle && (t.object.angle = this.angle), void 0 !== this.decay && (t.object.decay = this.decay), void 0 !== this.penumbra && (t.object.penumbra = this.penumbra), void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()), t;
      }
    }), Nr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: Nr,
      isHemisphereLight: !0,
      copy: function copy(e) {
        return Fr.prototype.copy.call(this, e), this.groundColor.copy(e.groundColor), this;
      }
    }), Object.assign(Ur.prototype, {
      copy: function copy(e) {
        return this.camera = e.camera.clone(), this.bias = e.bias, this.radius = e.radius, this.mapSize.copy(e.mapSize), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      toJSON: function toJSON() {
        var e = {};
        return 0 !== this.bias && (e.bias = this.bias), 1 !== this.radius && (e.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (e.mapSize = this.mapSize.toArray()), e.camera = this.camera.toJSON(!1).object, delete e.camera.matrix, e;
      }
    }), jr.prototype = Object.assign(Object.create(Ur.prototype), {
      constructor: jr,
      isSpotLightShadow: !0,
      update: function update(e) {
        var t = this.camera,
          r = 2 * Ss.RAD2DEG * e.angle,
          n = this.mapSize.width / this.mapSize.height,
          i = e.distance || t.far;
        r === t.fov && n === t.aspect && i === t.far || (t.fov = r, t.aspect = n, t.far = i, t.updateProjectionMatrix());
      }
    }), zr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: zr,
      isSpotLight: !0,
      copy: function copy(e) {
        return Fr.prototype.copy.call(this, e), this.distance = e.distance, this.angle = e.angle, this.penumbra = e.penumbra, this.decay = e.decay, this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
      }
    }), Hr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: Hr,
      isPointLight: !0,
      copy: function copy(e) {
        return Fr.prototype.copy.call(this, e), this.distance = e.distance, this.decay = e.decay, this.shadow = e.shadow.clone(), this;
      }
    }), Gr.prototype = Object.assign(Object.create(Ur.prototype), {
      constructor: Gr
    }), Vr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: Vr,
      isDirectionalLight: !0,
      copy: function copy(e) {
        return Fr.prototype.copy.call(this, e), this.target = e.target.clone(), this.shadow = e.shadow.clone(), this;
      }
    }), qr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: qr,
      isAmbientLight: !0
    }), Wr.prototype = Object.assign(Object.create(Fr.prototype), {
      constructor: Wr,
      isRectAreaLight: !0,
      copy: function copy(e) {
        return Fr.prototype.copy.call(this, e), this.width = e.width, this.height = e.height, this;
      },
      toJSON: function toJSON(e) {
        var t = Fr.prototype.toJSON.call(this, e);
        return t.object.width = this.width, t.object.height = this.height, t;
      }
    });
    var Ws = {
      arraySlice: function arraySlice(e, t, r) {
        return Ws.isTypedArray(e) ? new e.constructor(e.subarray(t, void 0 !== r ? r : e.length)) : e.slice(t, r);
      },
      convertArray: function convertArray(e, t, r) {
        return !e || !r && e.constructor === t ? e : "number" == typeof t.BYTES_PER_ELEMENT ? new t(e) : Array.prototype.slice.call(e);
      },
      isTypedArray: function isTypedArray(e) {
        return ArrayBuffer.isView(e) && !(e instanceof DataView);
      },
      getKeyframeOrder: function getKeyframeOrder(e) {
        function t(t, r) {
          return e[t] - e[r];
        }
        for (var r = e.length, n = new Array(r), i = 0; i !== r; ++i) n[i] = i;
        return n.sort(t), n;
      },
      sortedArray: function sortedArray(e, t, r) {
        for (var n = e.length, i = new e.constructor(n), a = 0, o = 0; o !== n; ++a) for (var s = r[a] * t, l = 0; l !== t; ++l) i[o++] = e[s + l];
        return i;
      },
      flattenJSON: function flattenJSON(e, t, r, n) {
        for (var i = 1, a = e[0]; void 0 !== a && void 0 === a[n];) a = e[i++];
        if (void 0 !== a) {
          var o = a[n];
          if (void 0 !== o) if (Array.isArray(o)) do {
            o = a[n], void 0 !== o && (t.push(a.time), r.push.apply(r, o)), a = e[i++];
          } while (void 0 !== a);else if (void 0 !== o.toArray) do {
            o = a[n], void 0 !== o && (t.push(a.time), o.toArray(r, r.length)), a = e[i++];
          } while (void 0 !== a);else do {
            o = a[n], void 0 !== o && (t.push(a.time), r.push(o)), a = e[i++];
          } while (void 0 !== a);
        }
      }
    };
    Object.assign(Xr.prototype, {
      evaluate: function evaluate(e) {
        var t = this.parameterPositions,
          r = this._cachedIndex,
          n = t[r],
          i = t[r - 1];
        e: {
          t: {
            var a;
            r: {
              n: if (!(e < n)) {
                for (var o = r + 2;;) {
                  if (void 0 === n) {
                    if (e < i) break n;
                    return r = t.length, this._cachedIndex = r, this.afterEnd_(r - 1, e, i);
                  }
                  if (r === o) break;
                  if (i = n, n = t[++r], e < n) break t;
                }
                a = t.length;
                break r;
              }
              {
                if (e >= i) break e;
                var s = t[1];
                e < s && (r = 2, i = s);
                for (var o = r - 2;;) {
                  if (void 0 === i) return this._cachedIndex = 0, this.beforeStart_(0, e, n);
                  if (r === o) break;
                  if (n = i, i = t[--r - 1], e >= i) break t;
                }
                a = r, r = 0;
              }
            }
            for (; r < a;) {
              var l = r + a >>> 1;
              e < t[l] ? a = l : r = l + 1;
            }
            if (n = t[r], void 0 === (i = t[r - 1])) return this._cachedIndex = 0, this.beforeStart_(0, e, n);
            if (void 0 === n) return r = t.length, this._cachedIndex = r, this.afterEnd_(r - 1, i, e);
          }
          this._cachedIndex = r, this.intervalChanged_(r, i, n);
        }
        return this.interpolate_(r, i, e, n);
      },
      settings: null,
      DefaultSettings_: {},
      getSettings_: function getSettings_() {
        return this.settings || this.DefaultSettings_;
      },
      copySampleValue_: function copySampleValue_(e) {
        for (var t = this.resultBuffer, r = this.sampleValues, n = this.valueSize, i = e * n, a = 0; a !== n; ++a) t[a] = r[i + a];
        return t;
      },
      interpolate_: function interpolate_(e, t, r, n) {
        throw new Error("call to abstract method");
      },
      intervalChanged_: function intervalChanged_(e, t, r) {}
    }),
    //!\ DECLARE ALIAS AFTER assign prototype !
    Object.assign(Xr.prototype, {
      beforeStart_: Xr.prototype.copySampleValue_,
      afterEnd_: Xr.prototype.copySampleValue_
    }), Yr.prototype = Object.assign(Object.create(Xr.prototype), {
      constructor: Yr,
      DefaultSettings_: {
        endingStart: ss,
        endingEnd: ss
      },
      intervalChanged_: function intervalChanged_(e, t, r) {
        var n = this.parameterPositions,
          i = e - 2,
          a = e + 1,
          o = n[i],
          s = n[a];
        if (void 0 === o) switch (this.getSettings_().endingStart) {
          case ls:
            i = e, o = 2 * t - r;
            break;
          case cs:
            i = n.length - 2, o = t + n[i] - n[i + 1];
            break;
          default:
            i = e, o = r;
        }
        if (void 0 === s) switch (this.getSettings_().endingEnd) {
          case ls:
            a = e, s = 2 * r - t;
            break;
          case cs:
            a = 1, s = r + n[1] - n[0];
            break;
          default:
            a = e - 1, s = t;
        }
        var l = .5 * (r - t),
          c = this.valueSize;
        this._weightPrev = l / (t - o), this._weightNext = l / (s - r), this._offsetPrev = i * c, this._offsetNext = a * c;
      },
      interpolate_: function interpolate_(e, t, r, n) {
        for (var i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, l = s - o, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, f = this._weightNext, d = (r - t) / (n - t), p = d * d, m = p * d, g = -h * m + 2 * h * p - h * d, v = (1 + h) * m + (-1.5 - 2 * h) * p + (-.5 + h) * d + 1, b = (-1 - f) * m + (1.5 + f) * p + .5 * d, y = f * m - f * p, w = 0; w !== o; ++w) i[w] = g * a[c + w] + v * a[l + w] + b * a[s + w] + y * a[u + w];
        return i;
      }
    }), Kr.prototype = Object.assign(Object.create(Xr.prototype), {
      constructor: Kr,
      interpolate_: function interpolate_(e, t, r, n) {
        for (var i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, l = s - o, c = (r - t) / (n - t), u = 1 - c, h = 0; h !== o; ++h) i[h] = a[l + h] * u + a[s + h] * c;
        return i;
      }
    }), Zr.prototype = Object.assign(Object.create(Xr.prototype), {
      constructor: Zr,
      interpolate_: function interpolate_(e, t, r, n) {
        return this.copySampleValue_(e - 1);
      }
    });
    var Xs;
    Xs = {
      TimeBufferType: Float32Array,
      ValueBufferType: Float32Array,
      DefaultInterpolation: as,
      InterpolantFactoryMethodDiscrete: function InterpolantFactoryMethodDiscrete(e) {
        return new Zr(this.times, this.values, this.getValueSize(), e);
      },
      InterpolantFactoryMethodLinear: function InterpolantFactoryMethodLinear(e) {
        return new Kr(this.times, this.values, this.getValueSize(), e);
      },
      InterpolantFactoryMethodSmooth: function InterpolantFactoryMethodSmooth(e) {
        return new Yr(this.times, this.values, this.getValueSize(), e);
      },
      setInterpolation: function setInterpolation(e) {
        var t;
        switch (e) {
          case is:
            t = this.InterpolantFactoryMethodDiscrete;
            break;
          case as:
            t = this.InterpolantFactoryMethodLinear;
            break;
          case os:
            t = this.InterpolantFactoryMethodSmooth;
        }
        if (void 0 === t) {
          var r = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
          if (void 0 === this.createInterpolant) {
            if (e === this.DefaultInterpolation) throw new Error(r);
            this.setInterpolation(this.DefaultInterpolation);
          }
          return void console.warn(r);
        }
        this.createInterpolant = t;
      },
      getInterpolation: function getInterpolation() {
        switch (this.createInterpolant) {
          case this.InterpolantFactoryMethodDiscrete:
            return is;
          case this.InterpolantFactoryMethodLinear:
            return as;
          case this.InterpolantFactoryMethodSmooth:
            return os;
        }
      },
      getValueSize: function getValueSize() {
        return this.values.length / this.times.length;
      },
      shift: function shift(e) {
        if (0 !== e) for (var t = this.times, r = 0, n = t.length; r !== n; ++r) t[r] += e;
        return this;
      },
      scale: function scale(e) {
        if (1 !== e) for (var t = this.times, r = 0, n = t.length; r !== n; ++r) t[r] *= e;
        return this;
      },
      trim: function trim(e, t) {
        for (var r = this.times, n = r.length, i = 0, a = n - 1; i !== n && r[i] < e;) ++i;
        for (; -1 !== a && r[a] > t;) --a;
        if (++a, 0 !== i || a !== n) {
          i >= a && (a = Math.max(a, 1), i = a - 1);
          var o = this.getValueSize();
          this.times = Ws.arraySlice(r, i, a), this.values = Ws.arraySlice(this.values, i * o, a * o);
        }
        return this;
      },
      validate: function validate() {
        var e = !0,
          t = this.getValueSize();
        t - Math.floor(t) != 0 && (console.error("invalid value size in track", this), e = !1);
        var r = this.times,
          n = this.values,
          i = r.length;
        0 === i && (console.error("track is empty", this), e = !1);
        for (var a = null, o = 0; o !== i; o++) {
          var s = r[o];
          if ("number" == typeof s && isNaN(s)) {
            console.error("time is not a valid number", this, o, s), e = !1;
            break;
          }
          if (null !== a && a > s) {
            console.error("out of order keys", this, o, s, a), e = !1;
            break;
          }
          a = s;
        }
        if (void 0 !== n && Ws.isTypedArray(n)) for (var o = 0, l = n.length; o !== l; ++o) {
          var c = n[o];
          if (isNaN(c)) {
            console.error("value is not a valid number", this, o, c), e = !1;
            break;
          }
        }
        return e;
      },
      optimize: function optimize() {
        for (var e = this.times, t = this.values, r = this.getValueSize(), n = this.getInterpolation() === os, i = 1, a = e.length - 1, o = 1; o < a; ++o) {
          var s = !1,
            l = e[o];
          if (l !== e[o + 1] && (1 !== o || l !== l[0])) if (n) s = !0;else for (var c = o * r, u = c - r, h = c + r, f = 0; f !== r; ++f) {
            var d = t[c + f];
            if (d !== t[u + f] || d !== t[h + f]) {
              s = !0;
              break;
            }
          }
          if (s) {
            if (o !== i) {
              e[i] = e[o];
              for (var p = o * r, m = i * r, f = 0; f !== r; ++f) t[m + f] = t[p + f];
            }
            ++i;
          }
        }
        if (a > 0) {
          e[i] = e[a];
          for (var p = a * r, m = i * r, f = 0; f !== r; ++f) t[m + f] = t[p + f];
          ++i;
        }
        return i !== e.length && (this.times = Ws.arraySlice(e, 0, i), this.values = Ws.arraySlice(t, 0, i * r)), this;
      }
    }, Qr.prototype = Object.assign(Object.create(Xs), {
      constructor: Qr,
      ValueTypeName: "vector"
    }), $r.prototype = Object.assign(Object.create(Xr.prototype), {
      constructor: $r,
      interpolate_: function interpolate_(e, t, r, n) {
        for (var i = this.resultBuffer, a = this.sampleValues, o = this.valueSize, s = e * o, l = (r - t) / (n - t), u = s + o; s !== u; s += 4) c.slerpFlat(i, 0, a, s - o, a, s, l);
        return i;
      }
    }), en.prototype = Object.assign(Object.create(Xs), {
      constructor: en,
      ValueTypeName: "quaternion",
      DefaultInterpolation: as,
      InterpolantFactoryMethodLinear: function InterpolantFactoryMethodLinear(e) {
        return new $r(this.times, this.values, this.getValueSize(), e);
      },
      InterpolantFactoryMethodSmooth: void 0
    }), tn.prototype = Object.assign(Object.create(Xs), {
      constructor: tn,
      ValueTypeName: "number"
    }), rn.prototype = Object.assign(Object.create(Xs), {
      constructor: rn,
      ValueTypeName: "string",
      ValueBufferType: Array,
      DefaultInterpolation: is,
      InterpolantFactoryMethodLinear: void 0,
      InterpolantFactoryMethodSmooth: void 0
    }), nn.prototype = Object.assign(Object.create(Xs), {
      constructor: nn,
      ValueTypeName: "bool",
      ValueBufferType: Array,
      DefaultInterpolation: is,
      InterpolantFactoryMethodLinear: void 0,
      InterpolantFactoryMethodSmooth: void 0
    }), an.prototype = Object.assign(Object.create(Xs), {
      constructor: an,
      ValueTypeName: "color"
    }), on.prototype = Xs, Xs.constructor = on, Object.assign(on, {
      parse: function parse(e) {
        if (void 0 === e.type) throw new Error("track type undefined, can not parse");
        var t = on._getTrackTypeForValueTypeName(e.type);
        if (void 0 === e.times) {
          var r = [],
            n = [];
          Ws.flattenJSON(e.keys, r, n, "value"), e.times = r, e.values = n;
        }
        return void 0 !== t.parse ? t.parse(e) : new t(e.name, e.times, e.values, e.interpolation);
      },
      toJSON: function toJSON(e) {
        var t,
          r = e.constructor;
        if (void 0 !== r.toJSON) t = r.toJSON(e);else {
          t = {
            name: e.name,
            times: Ws.convertArray(e.times, Array),
            values: Ws.convertArray(e.values, Array)
          };
          var n = e.getInterpolation();
          n !== e.DefaultInterpolation && (t.interpolation = n);
        }
        return t.type = e.ValueTypeName, t;
      },
      _getTrackTypeForValueTypeName: function _getTrackTypeForValueTypeName(e) {
        switch (e.toLowerCase()) {
          case "scalar":
          case "double":
          case "float":
          case "number":
          case "integer":
            return tn;
          case "vector":
          case "vector2":
          case "vector3":
          case "vector4":
            return Qr;
          case "color":
            return an;
          case "quaternion":
            return en;
          case "bool":
          case "boolean":
            return nn;
          case "string":
            return rn;
        }
        throw new Error("Unsupported typeName: " + e);
      }
    }), Object.assign(sn, {
      parse: function parse(e) {
        for (var t = [], r = e.tracks, n = 1 / (e.fps || 1), i = 0, a = r.length; i !== a; ++i) t.push(on.parse(r[i]).scale(n));
        return new sn(e.name, e.duration, t);
      },
      toJSON: function toJSON(e) {
        for (var t = [], r = e.tracks, n = {
            name: e.name,
            duration: e.duration,
            tracks: t
          }, i = 0, a = r.length; i !== a; ++i) t.push(on.toJSON(r[i]));
        return n;
      },
      CreateFromMorphTargetSequence: function CreateFromMorphTargetSequence(e, t, r, n) {
        for (var i = t.length, a = [], o = 0; o < i; o++) {
          var s = [],
            l = [];
          s.push((o + i - 1) % i, o, (o + 1) % i), l.push(0, 1, 0);
          var c = Ws.getKeyframeOrder(s);
          s = Ws.sortedArray(s, 1, c), l = Ws.sortedArray(l, 1, c), n || 0 !== s[0] || (s.push(i), l.push(l[0])), a.push(new tn(".morphTargetInfluences[" + t[o].name + "]", s, l).scale(1 / r));
        }
        return new sn(e, -1, a);
      },
      findByName: function findByName(e, t) {
        var r = e;
        if (!Array.isArray(e)) {
          var n = e;
          r = n.geometry && n.geometry.animations || n.animations;
        }
        for (var i = 0; i < r.length; i++) if (r[i].name === t) return r[i];
        return null;
      },
      CreateClipsFromMorphTargetSequences: function CreateClipsFromMorphTargetSequences(e, t, r) {
        for (var n = {}, i = /^([\w-]*?)([\d]+)$/, a = 0, o = e.length; a < o; a++) {
          var s = e[a],
            l = s.name.match(i);
          if (l && l.length > 1) {
            var c = l[1],
              u = n[c];
            u || (n[c] = u = []), u.push(s);
          }
        }
        var h = [];
        for (var c in n) h.push(sn.CreateFromMorphTargetSequence(c, n[c], t, r));
        return h;
      },
      parseAnimation: function parseAnimation(e, t) {
        if (!e) return console.error("  no animation in JSONLoader data"), null;
        for (var r = function r(e, t, _r2, n, i) {
            if (0 !== _r2.length) {
              var a = [],
                o = [];
              Ws.flattenJSON(_r2, a, o, n), 0 !== a.length && i.push(new e(t, a, o));
            }
          }, n = [], i = e.name || "default", a = e.length || -1, o = e.fps || 30, s = e.hierarchy || [], l = 0; l < s.length; l++) {
          var c = s[l].keys;
          if (c && 0 !== c.length) if (c[0].morphTargets) {
            for (var u = {}, h = 0; h < c.length; h++) if (c[h].morphTargets) for (var f = 0; f < c[h].morphTargets.length; f++) u[c[h].morphTargets[f]] = -1;
            for (var d in u) {
              for (var p = [], m = [], f = 0; f !== c[h].morphTargets.length; ++f) {
                var g = c[h];
                p.push(g.time), m.push(g.morphTarget === d ? 1 : 0);
              }
              n.push(new tn(".morphTargetInfluence[" + d + "]", p, m));
            }
            a = u.length * (o || 1);
          } else {
            var v = ".bones[" + t[l].name + "]";
            r(Qr, v + ".position", c, "pos", n), r(en, v + ".quaternion", c, "rot", n), r(Qr, v + ".scale", c, "scl", n);
          }
        }
        return 0 === n.length ? null : new sn(i, a, n);
      }
    }), Object.assign(sn.prototype, {
      resetDuration: function resetDuration() {
        for (var e = this.tracks, t = 0, r = 0, n = e.length; r !== n; ++r) {
          var i = this.tracks[r];
          t = Math.max(t, i.times[i.times.length - 1]);
        }
        this.duration = t;
      },
      trim: function trim() {
        for (var e = 0; e < this.tracks.length; e++) this.tracks[e].trim(0, this.duration);
        return this;
      },
      optimize: function optimize() {
        for (var e = 0; e < this.tracks.length; e++) this.tracks[e].optimize();
        return this;
      }
    }), Object.assign(ln.prototype, {
      load: function load(e, t, r, n) {
        var i = this,
          a = new Mr(i.manager);
        a.setResponseType("json"), a.load(e, function (e) {
          t(i.parse(e));
        }, r, n);
      },
      setTextures: function setTextures(e) {
        this.textures = e;
      },
      parse: function parse(e) {
        function t(e) {
          return void 0 === r[e] && console.warn("THREE.MaterialLoader: Undefined texture", e), r[e];
        }
        var r = this.textures,
          n = new Gs[e.type]();
        if (void 0 !== e.uuid && (n.uuid = e.uuid), void 0 !== e.name && (n.name = e.name), void 0 !== e.color && n.color.setHex(e.color), void 0 !== e.roughness && (n.roughness = e.roughness), void 0 !== e.metalness && (n.metalness = e.metalness), void 0 !== e.emissive && n.emissive.setHex(e.emissive), void 0 !== e.specular && n.specular.setHex(e.specular), void 0 !== e.shininess && (n.shininess = e.shininess), void 0 !== e.clearCoat && (n.clearCoat = e.clearCoat), void 0 !== e.clearCoatRoughness && (n.clearCoatRoughness = e.clearCoatRoughness), void 0 !== e.uniforms && (n.uniforms = e.uniforms), void 0 !== e.vertexShader && (n.vertexShader = e.vertexShader), void 0 !== e.fragmentShader && (n.fragmentShader = e.fragmentShader), void 0 !== e.vertexColors && (n.vertexColors = e.vertexColors), void 0 !== e.fog && (n.fog = e.fog), void 0 !== e.shading && (n.shading = e.shading), void 0 !== e.blending && (n.blending = e.blending), void 0 !== e.side && (n.side = e.side), void 0 !== e.opacity && (n.opacity = e.opacity), void 0 !== e.transparent && (n.transparent = e.transparent), void 0 !== e.alphaTest && (n.alphaTest = e.alphaTest), void 0 !== e.depthTest && (n.depthTest = e.depthTest), void 0 !== e.depthWrite && (n.depthWrite = e.depthWrite), void 0 !== e.colorWrite && (n.colorWrite = e.colorWrite), void 0 !== e.wireframe && (n.wireframe = e.wireframe), void 0 !== e.wireframeLinewidth && (n.wireframeLinewidth = e.wireframeLinewidth), void 0 !== e.wireframeLinecap && (n.wireframeLinecap = e.wireframeLinecap), void 0 !== e.wireframeLinejoin && (n.wireframeLinejoin = e.wireframeLinejoin), void 0 !== e.skinning && (n.skinning = e.skinning), void 0 !== e.morphTargets && (n.morphTargets = e.morphTargets), void 0 !== e.size && (n.size = e.size), void 0 !== e.sizeAttenuation && (n.sizeAttenuation = e.sizeAttenuation), void 0 !== e.map && (n.map = t(e.map)), void 0 !== e.alphaMap && (n.alphaMap = t(e.alphaMap), n.transparent = !0), void 0 !== e.bumpMap && (n.bumpMap = t(e.bumpMap)), void 0 !== e.bumpScale && (n.bumpScale = e.bumpScale), void 0 !== e.normalMap && (n.normalMap = t(e.normalMap)), void 0 !== e.normalScale) {
          var a = e.normalScale;
          !1 === Array.isArray(a) && (a = [a, a]), n.normalScale = new i().fromArray(a);
        }
        return void 0 !== e.displacementMap && (n.displacementMap = t(e.displacementMap)), void 0 !== e.displacementScale && (n.displacementScale = e.displacementScale), void 0 !== e.displacementBias && (n.displacementBias = e.displacementBias), void 0 !== e.roughnessMap && (n.roughnessMap = t(e.roughnessMap)), void 0 !== e.metalnessMap && (n.metalnessMap = t(e.metalnessMap)), void 0 !== e.emissiveMap && (n.emissiveMap = t(e.emissiveMap)), void 0 !== e.emissiveIntensity && (n.emissiveIntensity = e.emissiveIntensity), void 0 !== e.specularMap && (n.specularMap = t(e.specularMap)), void 0 !== e.envMap && (n.envMap = t(e.envMap)), void 0 !== e.reflectivity && (n.reflectivity = e.reflectivity), void 0 !== e.lightMap && (n.lightMap = t(e.lightMap)), void 0 !== e.lightMapIntensity && (n.lightMapIntensity = e.lightMapIntensity), void 0 !== e.aoMap && (n.aoMap = t(e.aoMap)), void 0 !== e.aoMapIntensity && (n.aoMapIntensity = e.aoMapIntensity), void 0 !== e.gradientMap && (n.gradientMap = t(e.gradientMap)), n;
      }
    }), Object.assign(cn.prototype, {
      load: function load(e, t, r, n) {
        var i = this,
          a = new Mr(i.manager);
        a.setResponseType("json"), a.load(e, function (e) {
          t(i.parse(e));
        }, r, n);
      },
      parse: function parse(e) {
        var t = new Re(),
          r = e.data.index;
        if (void 0 !== r) {
          var n = new Ys[r.type](r.array);
          t.setIndex(new me(n, 1));
        }
        var i = e.data.attributes;
        for (var a in i) {
          var o = i[a],
            n = new Ys[o.type](o.array);
          t.addAttribute(a, new me(n, o.itemSize, o.normalized));
        }
        var s = e.data.groups || e.data.drawcalls || e.data.offsets;
        if (void 0 !== s) for (var l = 0, c = s.length; l !== c; ++l) {
          var h = s[l];
          t.addGroup(h.start, h.count, h.materialIndex);
        }
        var f = e.data.boundingSphere;
        if (void 0 !== f) {
          var d = new u();
          void 0 !== f.center && d.fromArray(f.center), t.boundingSphere = new re(d, f.radius);
        }
        return t;
      }
    });
    var Ys = {
      Int8Array: Int8Array,
      Uint8Array: Uint8Array,
      Uint8ClampedArray: Uint8ClampedArray,
      Int16Array: Int16Array,
      Uint16Array: Uint16Array,
      Int32Array: Int32Array,
      Uint32Array: Uint32Array,
      Float32Array: Float32Array,
      Float64Array: Float64Array
    };
    un.Handlers = {
      handlers: [],
      add: function add(e, t) {
        this.handlers.push(e, t);
      },
      get: function get(e) {
        for (var t = this.handlers, r = 0, n = t.length; r < n; r += 2) {
          var i = t[r],
            a = t[r + 1];
          if (i.test(e)) return a;
        }
        return null;
      }
    }, Object.assign(un.prototype, {
      crossOrigin: void 0,
      extractUrlBase: function extractUrlBase(e) {
        var t = e.split("/");
        return 1 === t.length ? "./" : (t.pop(), t.join("/") + "/");
      },
      initMaterials: function initMaterials(e, t, r) {
        for (var n = [], i = 0; i < e.length; ++i) n[i] = this.createMaterial(e[i], t, r);
        return n;
      },
      createMaterial: function () {
        var e = {
            NoBlending: Ca,
            NormalBlending: Ea,
            AdditiveBlending: Aa,
            SubtractiveBlending: Ta,
            MultiplyBlending: ka,
            CustomBlending: Ra
          },
          t = new Y(),
          r = new Lr(),
          n = new ln();
        return function (i, a, o) {
          function s(e, t, n, i, s) {
            var c,
              u = a + e,
              h = un.Handlers.get(u);
            null !== h ? c = h.load(u) : (r.setCrossOrigin(o), c = r.load(u)), void 0 !== t && (c.repeat.fromArray(t), 1 !== t[0] && (c.wrapS = vo), 1 !== t[1] && (c.wrapT = vo)), void 0 !== n && c.offset.fromArray(n), void 0 !== i && ("repeat" === i[0] && (c.wrapS = vo), "mirror" === i[0] && (c.wrapS = yo), "repeat" === i[1] && (c.wrapT = vo), "mirror" === i[1] && (c.wrapT = yo)), void 0 !== s && (c.anisotropy = s);
            var f = Ss.generateUUID();
            return l[f] = c, f;
          }
          var l = {},
            c = {
              uuid: Ss.generateUUID(),
              type: "MeshLambertMaterial"
            };
          for (var u in i) {
            var h = i[u];
            switch (u) {
              case "DbgColor":
              case "DbgIndex":
              case "opticalDensity":
              case "illumination":
                break;
              case "DbgName":
                c.name = h;
                break;
              case "blending":
                c.blending = e[h];
                break;
              case "colorAmbient":
              case "mapAmbient":
                console.warn("THREE.Loader.createMaterial:", u, "is no longer supported.");
                break;
              case "colorDiffuse":
                c.color = t.fromArray(h).getHex();
                break;
              case "colorSpecular":
                c.specular = t.fromArray(h).getHex();
                break;
              case "colorEmissive":
                c.emissive = t.fromArray(h).getHex();
                break;
              case "specularCoef":
                c.shininess = h;
                break;
              case "shading":
                "basic" === h.toLowerCase() && (c.type = "MeshBasicMaterial"), "phong" === h.toLowerCase() && (c.type = "MeshPhongMaterial"), "standard" === h.toLowerCase() && (c.type = "MeshStandardMaterial");
                break;
              case "mapDiffuse":
                c.map = s(h, i.mapDiffuseRepeat, i.mapDiffuseOffset, i.mapDiffuseWrap, i.mapDiffuseAnisotropy);
                break;
              case "mapDiffuseRepeat":
              case "mapDiffuseOffset":
              case "mapDiffuseWrap":
              case "mapDiffuseAnisotropy":
                break;
              case "mapEmissive":
                c.emissiveMap = s(h, i.mapEmissiveRepeat, i.mapEmissiveOffset, i.mapEmissiveWrap, i.mapEmissiveAnisotropy);
                break;
              case "mapEmissiveRepeat":
              case "mapEmissiveOffset":
              case "mapEmissiveWrap":
              case "mapEmissiveAnisotropy":
                break;
              case "mapLight":
                c.lightMap = s(h, i.mapLightRepeat, i.mapLightOffset, i.mapLightWrap, i.mapLightAnisotropy);
                break;
              case "mapLightRepeat":
              case "mapLightOffset":
              case "mapLightWrap":
              case "mapLightAnisotropy":
                break;
              case "mapAO":
                c.aoMap = s(h, i.mapAORepeat, i.mapAOOffset, i.mapAOWrap, i.mapAOAnisotropy);
                break;
              case "mapAORepeat":
              case "mapAOOffset":
              case "mapAOWrap":
              case "mapAOAnisotropy":
                break;
              case "mapBump":
                c.bumpMap = s(h, i.mapBumpRepeat, i.mapBumpOffset, i.mapBumpWrap, i.mapBumpAnisotropy);
                break;
              case "mapBumpScale":
                c.bumpScale = h;
                break;
              case "mapBumpRepeat":
              case "mapBumpOffset":
              case "mapBumpWrap":
              case "mapBumpAnisotropy":
                break;
              case "mapNormal":
                c.normalMap = s(h, i.mapNormalRepeat, i.mapNormalOffset, i.mapNormalWrap, i.mapNormalAnisotropy);
                break;
              case "mapNormalFactor":
                c.normalScale = [h, h];
                break;
              case "mapNormalRepeat":
              case "mapNormalOffset":
              case "mapNormalWrap":
              case "mapNormalAnisotropy":
                break;
              case "mapSpecular":
                c.specularMap = s(h, i.mapSpecularRepeat, i.mapSpecularOffset, i.mapSpecularWrap, i.mapSpecularAnisotropy);
                break;
              case "mapSpecularRepeat":
              case "mapSpecularOffset":
              case "mapSpecularWrap":
              case "mapSpecularAnisotropy":
                break;
              case "mapMetalness":
                c.metalnessMap = s(h, i.mapMetalnessRepeat, i.mapMetalnessOffset, i.mapMetalnessWrap, i.mapMetalnessAnisotropy);
                break;
              case "mapMetalnessRepeat":
              case "mapMetalnessOffset":
              case "mapMetalnessWrap":
              case "mapMetalnessAnisotropy":
                break;
              case "mapRoughness":
                c.roughnessMap = s(h, i.mapRoughnessRepeat, i.mapRoughnessOffset, i.mapRoughnessWrap, i.mapRoughnessAnisotropy);
                break;
              case "mapRoughnessRepeat":
              case "mapRoughnessOffset":
              case "mapRoughnessWrap":
              case "mapRoughnessAnisotropy":
                break;
              case "mapAlpha":
                c.alphaMap = s(h, i.mapAlphaRepeat, i.mapAlphaOffset, i.mapAlphaWrap, i.mapAlphaAnisotropy);
                break;
              case "mapAlphaRepeat":
              case "mapAlphaOffset":
              case "mapAlphaWrap":
              case "mapAlphaAnisotropy":
                break;
              case "flipSided":
                c.side = va;
                break;
              case "doubleSided":
                c.side = ba;
                break;
              case "transparency":
                console.warn("THREE.Loader.createMaterial: transparency has been renamed to opacity"), c.opacity = h;
                break;
              case "depthTest":
              case "depthWrite":
              case "colorWrite":
              case "opacity":
              case "reflectivity":
              case "transparent":
              case "visible":
              case "wireframe":
                c[u] = h;
                break;
              case "vertexColors":
                !0 === h && (c.vertexColors = Sa), "face" === h && (c.vertexColors = _a);
                break;
              default:
                console.error("THREE.Loader.createMaterial: Unsupported", u, h);
            }
          }
          return "MeshBasicMaterial" === c.type && delete c.emissive, "MeshPhongMaterial" !== c.type && delete c.specular, c.opacity < 1 && (c.transparent = !0), n.setTextures(l), n.parse(c);
        };
      }()
    }), Object.assign(hn.prototype, {
      load: function load(e, t, r, n) {
        var i = this,
          a = this.texturePath && "string" == typeof this.texturePath ? this.texturePath : un.prototype.extractUrlBase(e),
          o = new Mr(this.manager);
        o.setResponseType("json"), o.setWithCredentials(this.withCredentials), o.load(e, function (r) {
          var n = r.metadata;
          if (void 0 !== n) {
            var o = n.type;
            if (void 0 !== o) {
              if ("object" === o.toLowerCase()) return void console.error("THREE.JSONLoader: " + e + " should be loaded with THREE.ObjectLoader instead.");
              if ("scene" === o.toLowerCase()) return void console.error("THREE.JSONLoader: " + e + " should be loaded with THREE.SceneLoader instead.");
            }
          }
          var s = i.parse(r, a);
          t(s.geometry, s.materials);
        }, r, n);
      },
      setTexturePath: function setTexturePath(e) {
        this.texturePath = e;
      },
      parse: function () {
        function e(e, t) {
          function r(e, t) {
            return e & 1 << t;
          }
          var n,
            a,
            o,
            s,
            l,
            c,
            h,
            f,
            d,
            p,
            m,
            g,
            v,
            b,
            y,
            w,
            x,
            _,
            S,
            C,
            E,
            A,
            T,
            k,
            R,
            I,
            M,
            O = e.faces,
            P = e.vertices,
            B = e.normals,
            D = e.colors,
            L = e.scale,
            F = 0;
          if (void 0 !== e.uvs) {
            for (n = 0; n < e.uvs.length; n++) e.uvs[n].length && F++;
            for (n = 0; n < F; n++) t.faceVertexUvs[n] = [];
          }
          for (s = 0, l = P.length; s < l;) _ = new u(), _.x = P[s++] * L, _.y = P[s++] * L, _.z = P[s++] * L, t.vertices.push(_);
          for (s = 0, l = O.length; s < l;) if (p = O[s++], m = r(p, 0), g = r(p, 1), v = r(p, 3), b = r(p, 4), y = r(p, 5), w = r(p, 6), x = r(p, 7), m) {
            if (C = new de(), C.a = O[s], C.b = O[s + 1], C.c = O[s + 3], E = new de(), E.a = O[s + 1], E.b = O[s + 2], E.c = O[s + 3], s += 4, g && (d = O[s++], C.materialIndex = d, E.materialIndex = d), o = t.faces.length, v) for (n = 0; n < F; n++) for (k = e.uvs[n], t.faceVertexUvs[n][o] = [], t.faceVertexUvs[n][o + 1] = [], a = 0; a < 4; a++) f = O[s++], I = k[2 * f], M = k[2 * f + 1], R = new i(I, M), 2 !== a && t.faceVertexUvs[n][o].push(R), 0 !== a && t.faceVertexUvs[n][o + 1].push(R);
            if (b && (h = 3 * O[s++], C.normal.set(B[h++], B[h++], B[h]), E.normal.copy(C.normal)), y) for (n = 0; n < 4; n++) h = 3 * O[s++], T = new u(B[h++], B[h++], B[h]), 2 !== n && C.vertexNormals.push(T), 0 !== n && E.vertexNormals.push(T);
            if (w && (c = O[s++], A = D[c], C.color.setHex(A), E.color.setHex(A)), x) for (n = 0; n < 4; n++) c = O[s++], A = D[c], 2 !== n && C.vertexColors.push(new Y(A)), 0 !== n && E.vertexColors.push(new Y(A));
            t.faces.push(C), t.faces.push(E);
          } else {
            if (S = new de(), S.a = O[s++], S.b = O[s++], S.c = O[s++], g && (d = O[s++], S.materialIndex = d), o = t.faces.length, v) for (n = 0; n < F; n++) for (k = e.uvs[n], t.faceVertexUvs[n][o] = [], a = 0; a < 3; a++) f = O[s++], I = k[2 * f], M = k[2 * f + 1], R = new i(I, M), t.faceVertexUvs[n][o].push(R);
            if (b && (h = 3 * O[s++], S.normal.set(B[h++], B[h++], B[h])), y) for (n = 0; n < 3; n++) h = 3 * O[s++], T = new u(B[h++], B[h++], B[h]), S.vertexNormals.push(T);
            if (w && (c = O[s++], S.color.setHex(D[c])), x) for (n = 0; n < 3; n++) c = O[s++], S.vertexColors.push(new Y(D[c]));
            t.faces.push(S);
          }
        }
        function t(e, t) {
          var r = void 0 !== e.influencesPerVertex ? e.influencesPerVertex : 2;
          if (e.skinWeights) for (var n = 0, i = e.skinWeights.length; n < i; n += r) {
            var a = e.skinWeights[n],
              s = r > 1 ? e.skinWeights[n + 1] : 0,
              l = r > 2 ? e.skinWeights[n + 2] : 0,
              c = r > 3 ? e.skinWeights[n + 3] : 0;
            t.skinWeights.push(new o(a, s, l, c));
          }
          if (e.skinIndices) for (var n = 0, i = e.skinIndices.length; n < i; n += r) {
            var u = e.skinIndices[n],
              h = r > 1 ? e.skinIndices[n + 1] : 0,
              f = r > 2 ? e.skinIndices[n + 2] : 0,
              d = r > 3 ? e.skinIndices[n + 3] : 0;
            t.skinIndices.push(new o(u, h, f, d));
          }
          t.bones = e.bones, t.bones && t.bones.length > 0 && (t.skinWeights.length !== t.skinIndices.length || t.skinIndices.length !== t.vertices.length) && console.warn("When skinning, number of vertices (" + t.vertices.length + "), skinIndices (" + t.skinIndices.length + "), and skinWeights (" + t.skinWeights.length + ") should match.");
        }
        function r(e, t) {
          var r = e.scale;
          if (void 0 !== e.morphTargets) for (var n = 0, i = e.morphTargets.length; n < i; n++) {
            t.morphTargets[n] = {}, t.morphTargets[n].name = e.morphTargets[n].name, t.morphTargets[n].vertices = [];
            for (var a = t.morphTargets[n].vertices, o = e.morphTargets[n].vertices, s = 0, l = o.length; s < l; s += 3) {
              var c = new u();
              c.x = o[s] * r, c.y = o[s + 1] * r, c.z = o[s + 2] * r, a.push(c);
            }
          }
          if (void 0 !== e.morphColors && e.morphColors.length > 0) {
            console.warn('THREE.JSONLoader: "morphColors" no longer supported. Using them as face colors.');
            for (var h = t.faces, f = e.morphColors[0].colors, n = 0, i = h.length; n < i; n++) h[n].color.fromArray(f, 3 * n);
          }
        }
        function n(e, t) {
          var r = [],
            n = [];
          void 0 !== e.animation && n.push(e.animation), void 0 !== e.animations && (e.animations.length ? n = n.concat(e.animations) : n.push(e.animations));
          for (var i = 0; i < n.length; i++) {
            var a = sn.parseAnimation(n[i], t.bones);
            a && r.push(a);
          }
          if (t.morphTargets) {
            var o = sn.CreateClipsFromMorphTargetSequences(t.morphTargets, 10);
            r = r.concat(o);
          }
          r.length > 0 && (t.animations = r);
        }
        return function (i, a) {
          void 0 !== i.data && (i = i.data), void 0 !== i.scale ? i.scale = 1 / i.scale : i.scale = 1;
          var o = new ke();
          return e(i, o), t(i, o), r(i, o), n(i, o), o.computeFaceNormals(), o.computeBoundingSphere(), void 0 === i.materials || 0 === i.materials.length ? {
            geometry: o
          } : {
            geometry: o,
            materials: un.prototype.initMaterials(i.materials, a, this.crossOrigin)
          };
        };
      }()
    }), Object.assign(fn.prototype, {
      load: function load(e, t, r, n) {
        "" === this.texturePath && (this.texturePath = e.substring(0, e.lastIndexOf("/") + 1));
        var i = this;
        new Mr(i.manager).load(e, function (r) {
          var a = null;
          try {
            a = JSON.parse(r);
          } catch (t) {
            return void 0 !== n && n(t), void console.error("THREE:ObjectLoader: Can't parse " + e + ".", t.message);
          }
          var o = a.metadata;
          if (void 0 === o || void 0 === o.type || "geometry" === o.type.toLowerCase()) return void console.error("THREE.ObjectLoader: Can't load " + e + ". Use THREE.JSONLoader instead.");
          i.parse(a, t);
        }, r, n);
      },
      setTexturePath: function setTexturePath(e) {
        this.texturePath = e;
      },
      setCrossOrigin: function setCrossOrigin(e) {
        this.crossOrigin = e;
      },
      parse: function parse(e, t) {
        var r = this.parseGeometries(e.geometries),
          n = this.parseImages(e.images, function () {
            void 0 !== t && t(o);
          }),
          i = this.parseTextures(e.textures, n),
          a = this.parseMaterials(e.materials, i),
          o = this.parseObject(e.object, r, a);
        return e.animations && (o.animations = this.parseAnimations(e.animations)), void 0 !== e.images && 0 !== e.images.length || void 0 !== t && t(o), o;
      },
      parseGeometries: function parseGeometries(e) {
        var t = {};
        if (void 0 !== e) for (var r = new hn(), n = new cn(), i = 0, a = e.length; i < a; i++) {
          var o,
            s = e[i];
          switch (s.type) {
            case "PlaneGeometry":
            case "PlaneBufferGeometry":
              o = new Hs[s.type](s.width, s.height, s.widthSegments, s.heightSegments);
              break;
            case "BoxGeometry":
            case "BoxBufferGeometry":
            case "CubeGeometry":
              o = new Hs[s.type](s.width, s.height, s.depth, s.widthSegments, s.heightSegments, s.depthSegments);
              break;
            case "CircleGeometry":
            case "CircleBufferGeometry":
              o = new Hs[s.type](s.radius, s.segments, s.thetaStart, s.thetaLength);
              break;
            case "CylinderGeometry":
            case "CylinderBufferGeometry":
              o = new Hs[s.type](s.radiusTop, s.radiusBottom, s.height, s.radialSegments, s.heightSegments, s.openEnded, s.thetaStart, s.thetaLength);
              break;
            case "ConeGeometry":
            case "ConeBufferGeometry":
              o = new Hs[s.type](s.radius, s.height, s.radialSegments, s.heightSegments, s.openEnded, s.thetaStart, s.thetaLength);
              break;
            case "SphereGeometry":
            case "SphereBufferGeometry":
              o = new Hs[s.type](s.radius, s.widthSegments, s.heightSegments, s.phiStart, s.phiLength, s.thetaStart, s.thetaLength);
              break;
            case "DodecahedronGeometry":
            case "IcosahedronGeometry":
            case "OctahedronGeometry":
            case "TetrahedronGeometry":
              o = new Hs[s.type](s.radius, s.detail);
              break;
            case "RingGeometry":
            case "RingBufferGeometry":
              o = new Hs[s.type](s.innerRadius, s.outerRadius, s.thetaSegments, s.phiSegments, s.thetaStart, s.thetaLength);
              break;
            case "TorusGeometry":
            case "TorusBufferGeometry":
              o = new Hs[s.type](s.radius, s.tube, s.radialSegments, s.tubularSegments, s.arc);
              break;
            case "TorusKnotGeometry":
            case "TorusKnotBufferGeometry":
              o = new Hs[s.type](s.radius, s.tube, s.tubularSegments, s.radialSegments, s.p, s.q);
              break;
            case "LatheGeometry":
            case "LatheBufferGeometry":
              o = new Hs[s.type](s.points, s.segments, s.phiStart, s.phiLength);
              break;
            case "BufferGeometry":
              o = n.parse(s);
              break;
            case "Geometry":
              o = r.parse(s, this.texturePath).geometry;
              break;
            default:
              console.warn('THREE.ObjectLoader: Unsupported geometry type "' + s.type + '"');
              continue;
          }
          o.uuid = s.uuid, void 0 !== s.name && (o.name = s.name), t[s.uuid] = o;
        }
        return t;
      },
      parseMaterials: function parseMaterials(e, t) {
        var r = {};
        if (void 0 !== e) {
          var n = new ln();
          n.setTextures(t);
          for (var i = 0, a = e.length; i < a; i++) {
            var o = e[i];
            if ("MultiMaterial" === o.type) {
              for (var s = [], l = 0; l < o.materials.length; l++) s.push(n.parse(o.materials[l]));
              r[o.uuid] = s;
            } else r[o.uuid] = n.parse(o);
          }
        }
        return r;
      },
      parseAnimations: function parseAnimations(e) {
        for (var t = [], r = 0; r < e.length; r++) {
          var n = sn.parse(e[r]);
          t.push(n);
        }
        return t;
      },
      parseImages: function parseImages(e, t) {
        var r = this,
          n = {};
        if (void 0 !== e && e.length > 0) {
          var i = new Ir(t),
            a = new Br(i);
          a.setCrossOrigin(this.crossOrigin);
          for (var o = 0, s = e.length; o < s; o++) {
            var l = e[o],
              c = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(l.url) ? l.url : r.texturePath + l.url;
            n[l.uuid] = function (e) {
              return r.manager.itemStart(e), a.load(e, function () {
                r.manager.itemEnd(e);
              }, void 0, function () {
                r.manager.itemEnd(e), r.manager.itemError(e);
              });
            }(c);
          }
        }
        return n;
      },
      parseTextures: function parseTextures(e, t) {
        function r(e, t) {
          return "number" == typeof e ? e : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", e), t[e]);
        }
        var n = {};
        if (void 0 !== e) for (var i = 0, o = e.length; i < o; i++) {
          var s = e[i];
          void 0 === s.image && console.warn('THREE.ObjectLoader: No "image" specified for', s.uuid), void 0 === t[s.image] && console.warn("THREE.ObjectLoader: Undefined image", s.image);
          var l = new a(t[s.image]);
          l.needsUpdate = !0, l.uuid = s.uuid, void 0 !== s.name && (l.name = s.name), void 0 !== s.mapping && (l.mapping = r(s.mapping, Ks)), void 0 !== s.offset && l.offset.fromArray(s.offset), void 0 !== s.repeat && l.repeat.fromArray(s.repeat), void 0 !== s.wrap && (l.wrapS = r(s.wrap[0], Zs), l.wrapT = r(s.wrap[1], Zs)), void 0 !== s.minFilter && (l.minFilter = r(s.minFilter, Js)), void 0 !== s.magFilter && (l.magFilter = r(s.magFilter, Js)), void 0 !== s.anisotropy && (l.anisotropy = s.anisotropy), void 0 !== s.flipY && (l.flipY = s.flipY), n[s.uuid] = l;
        }
        return n;
      },
      parseObject: function () {
        var e = new h();
        return function (t, r, n) {
          function i(e) {
            return void 0 === r[e] && console.warn("THREE.ObjectLoader: Undefined geometry", e), r[e];
          }
          function a(e) {
            if (void 0 !== e) {
              if (Array.isArray(e)) {
                for (var t = [], r = 0, i = e.length; r < i; r++) {
                  var a = e[r];
                  void 0 === n[a] && console.warn("THREE.ObjectLoader: Undefined material", a), t.push(n[a]);
                }
                return t;
              }
              return void 0 === n[e] && console.warn("THREE.ObjectLoader: Undefined material", e), n[e];
            }
          }
          var o;
          switch (t.type) {
            case "Scene":
              o = new bt(), void 0 !== t.background && Number.isInteger(t.background) && (o.background = new Y(t.background)), void 0 !== t.fog && ("Fog" === t.fog.type ? o.fog = new vt(t.fog.color, t.fog.near, t.fog.far) : "FogExp2" === t.fog.type && (o.fog = new gt(t.fog.color, t.fog.density)));
              break;
            case "PerspectiveCamera":
              o = new Le(t.fov, t.aspect, t.near, t.far), void 0 !== t.focus && (o.focus = t.focus), void 0 !== t.zoom && (o.zoom = t.zoom), void 0 !== t.filmGauge && (o.filmGauge = t.filmGauge), void 0 !== t.filmOffset && (o.filmOffset = t.filmOffset), void 0 !== t.view && (o.view = Object.assign({}, t.view));
              break;
            case "OrthographicCamera":
              o = new Fe(t.left, t.right, t.top, t.bottom, t.near, t.far);
              break;
            case "AmbientLight":
              o = new qr(t.color, t.intensity);
              break;
            case "DirectionalLight":
              o = new Vr(t.color, t.intensity);
              break;
            case "PointLight":
              o = new Hr(t.color, t.intensity, t.distance, t.decay);
              break;
            case "RectAreaLight":
              o = new Wr(t.color, t.intensity, t.width, t.height);
              break;
            case "SpotLight":
              o = new zr(t.color, t.intensity, t.distance, t.angle, t.penumbra, t.decay);
              break;
            case "HemisphereLight":
              o = new Nr(t.color, t.groundColor, t.intensity);
              break;
            case "SkinnedMesh":
              console.warn("THREE.ObjectLoader.parseObject() does not support SkinnedMesh yet.");
            case "Mesh":
              var s = i(t.geometry),
                l = a(t.material);
              o = s.bones && s.bones.length > 0 ? new Et(s, l) : new Ie(s, l);
              break;
            case "LOD":
              o = new _t();
              break;
            case "Line":
              o = new Tt(i(t.geometry), a(t.material), t.mode);
              break;
            case "LineLoop":
              o = new Rt(i(t.geometry), a(t.material));
              break;
            case "LineSegments":
              o = new kt(i(t.geometry), a(t.material));
              break;
            case "PointCloud":
            case "Points":
              o = new Mt(i(t.geometry), a(t.material));
              break;
            case "Sprite":
              o = new xt(a(t.material));
              break;
            case "Group":
              o = new Ot();
              break;
            default:
              o = new ue();
          }
          if (o.uuid = t.uuid, void 0 !== t.name && (o.name = t.name), void 0 !== t.matrix ? (e.fromArray(t.matrix), e.decompose(o.position, o.quaternion, o.scale)) : (void 0 !== t.position && o.position.fromArray(t.position), void 0 !== t.rotation && o.rotation.fromArray(t.rotation), void 0 !== t.quaternion && o.quaternion.fromArray(t.quaternion), void 0 !== t.scale && o.scale.fromArray(t.scale)), void 0 !== t.castShadow && (o.castShadow = t.castShadow), void 0 !== t.receiveShadow && (o.receiveShadow = t.receiveShadow), t.shadow && (void 0 !== t.shadow.bias && (o.shadow.bias = t.shadow.bias), void 0 !== t.shadow.radius && (o.shadow.radius = t.shadow.radius), void 0 !== t.shadow.mapSize && o.shadow.mapSize.fromArray(t.shadow.mapSize), void 0 !== t.shadow.camera && (o.shadow.camera = this.parseObject(t.shadow.camera))), void 0 !== t.visible && (o.visible = t.visible), void 0 !== t.userData && (o.userData = t.userData), void 0 !== t.children) for (var c in t.children) o.add(this.parseObject(t.children[c], r, n));
          if ("LOD" === t.type) for (var u = t.levels, h = 0; h < u.length; h++) {
            var f = u[h],
              c = o.getObjectByProperty("uuid", f.object);
            void 0 !== c && o.addLevel(c, f.distance);
          }
          return o;
        };
      }()
    });
    var Ks = {
        UVMapping: lo,
        CubeReflectionMapping: co,
        CubeRefractionMapping: uo,
        EquirectangularReflectionMapping: ho,
        EquirectangularRefractionMapping: fo,
        SphericalReflectionMapping: po,
        CubeUVReflectionMapping: mo,
        CubeUVRefractionMapping: go
      },
      Zs = {
        RepeatWrapping: vo,
        ClampToEdgeWrapping: bo,
        MirroredRepeatWrapping: yo
      },
      Js = {
        NearestFilter: wo,
        NearestMipMapNearestFilter: xo,
        NearestMipMapLinearFilter: _o,
        LinearFilter: So,
        LinearMipMapNearestFilter: Co,
        LinearMipMapLinearFilter: Eo
      };
    Object.assign(Sn.prototype, {
      getPoint: function getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
      },
      getPointAt: function getPointAt(e) {
        var t = this.getUtoTmapping(e);
        return this.getPoint(t);
      },
      getPoints: function getPoints(e) {
        void 0 === e && (e = 5);
        for (var t = [], r = 0; r <= e; r++) t.push(this.getPoint(r / e));
        return t;
      },
      getSpacedPoints: function getSpacedPoints(e) {
        void 0 === e && (e = 5);
        for (var t = [], r = 0; r <= e; r++) t.push(this.getPointAt(r / e));
        return t;
      },
      getLength: function getLength() {
        var e = this.getLengths();
        return e[e.length - 1];
      },
      getLengths: function getLengths(e) {
        if (void 0 === e && (e = this.arcLengthDivisions), this.cacheArcLengths && this.cacheArcLengths.length === e + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        var t,
          r,
          n = [],
          i = this.getPoint(0),
          a = 0;
        for (n.push(0), r = 1; r <= e; r++) t = this.getPoint(r / e), a += t.distanceTo(i), n.push(a), i = t;
        return this.cacheArcLengths = n, n;
      },
      updateArcLengths: function updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
      },
      getUtoTmapping: function getUtoTmapping(e, t) {
        var r,
          n = this.getLengths(),
          i = 0,
          a = n.length;
        r = t || e * n[a - 1];
        for (var o, s = 0, l = a - 1; s <= l;) if (i = Math.floor(s + (l - s) / 2), (o = n[i] - r) < 0) s = i + 1;else {
          if (!(o > 0)) {
            l = i;
            break;
          }
          l = i - 1;
        }
        if (i = l, n[i] === r) return i / (a - 1);
        var c = n[i];
        return (i + (r - c) / (n[i + 1] - c)) / (a - 1);
      },
      getTangent: function getTangent(e) {
        var t = e - 1e-4,
          r = e + 1e-4;
        t < 0 && (t = 0), r > 1 && (r = 1);
        var n = this.getPoint(t);
        return this.getPoint(r).clone().sub(n).normalize();
      },
      getTangentAt: function getTangentAt(e) {
        var t = this.getUtoTmapping(e);
        return this.getTangent(t);
      },
      computeFrenetFrames: function computeFrenetFrames(e, t) {
        var r,
          n,
          i,
          a = new u(),
          o = [],
          s = [],
          l = [],
          c = new u(),
          f = new h();
        for (r = 0; r <= e; r++) n = r / e, o[r] = this.getTangentAt(n), o[r].normalize();
        s[0] = new u(), l[0] = new u();
        var d = Number.MAX_VALUE,
          p = Math.abs(o[0].x),
          m = Math.abs(o[0].y),
          g = Math.abs(o[0].z);
        for (p <= d && (d = p, a.set(1, 0, 0)), m <= d && (d = m, a.set(0, 1, 0)), g <= d && a.set(0, 0, 1), c.crossVectors(o[0], a).normalize(), s[0].crossVectors(o[0], c), l[0].crossVectors(o[0], s[0]), r = 1; r <= e; r++) s[r] = s[r - 1].clone(), l[r] = l[r - 1].clone(), c.crossVectors(o[r - 1], o[r]), c.length() > Number.EPSILON && (c.normalize(), i = Math.acos(Ss.clamp(o[r - 1].dot(o[r]), -1, 1)), s[r].applyMatrix4(f.makeRotationAxis(c, i))), l[r].crossVectors(o[r], s[r]);
        if (!0 === t) for (i = Math.acos(Ss.clamp(s[0].dot(s[e]), -1, 1)), i /= e, o[0].dot(c.crossVectors(s[0], s[e])) > 0 && (i = -i), r = 1; r <= e; r++) s[r].applyMatrix4(f.makeRotationAxis(o[r], i * r)), l[r].crossVectors(o[r], s[r]);
        return {
          tangents: o,
          normals: s,
          binormals: l
        };
      }
    }), Cn.prototype = Object.create(Sn.prototype), Cn.prototype.constructor = Cn, Cn.prototype.isLineCurve = !0, Cn.prototype.getPoint = function (e) {
      if (1 === e) return this.v2.clone();
      var t = this.v2.clone().sub(this.v1);
      return t.multiplyScalar(e).add(this.v1), t;
    }, Cn.prototype.getPointAt = function (e) {
      return this.getPoint(e);
    }, Cn.prototype.getTangent = function (e) {
      return this.v2.clone().sub(this.v1).normalize();
    }, En.prototype = Object.assign(Object.create(Sn.prototype), {
      constructor: En,
      add: function add(e) {
        this.curves.push(e);
      },
      closePath: function closePath() {
        var e = this.curves[0].getPoint(0),
          t = this.curves[this.curves.length - 1].getPoint(1);
        e.equals(t) || this.curves.push(new Cn(t, e));
      },
      getPoint: function getPoint(e) {
        for (var t = e * this.getLength(), r = this.getCurveLengths(), n = 0; n < r.length;) {
          if (r[n] >= t) {
            var i = r[n] - t,
              a = this.curves[n],
              o = a.getLength(),
              s = 0 === o ? 0 : 1 - i / o;
            return a.getPointAt(s);
          }
          n++;
        }
        return null;
      },
      getLength: function getLength() {
        var e = this.getCurveLengths();
        return e[e.length - 1];
      },
      updateArcLengths: function updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
      },
      getCurveLengths: function getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        for (var e = [], t = 0, r = 0, n = this.curves.length; r < n; r++) t += this.curves[r].getLength(), e.push(t);
        return this.cacheLengths = e, e;
      },
      getSpacedPoints: function getSpacedPoints(e) {
        void 0 === e && (e = 40);
        for (var t = [], r = 0; r <= e; r++) t.push(this.getPoint(r / e));
        return this.autoClose && t.push(t[0]), t;
      },
      getPoints: function getPoints(e) {
        e = e || 12;
        for (var t, r = [], n = 0, i = this.curves; n < i.length; n++) for (var a = i[n], o = a && a.isEllipseCurve ? 2 * e : a && a.isLineCurve ? 1 : a && a.isSplineCurve ? e * a.points.length : e, s = a.getPoints(o), l = 0; l < s.length; l++) {
          var c = s[l];
          t && t.equals(c) || (r.push(c), t = c);
        }
        return this.autoClose && r.length > 1 && !r[r.length - 1].equals(r[0]) && r.push(r[0]), r;
      },
      createPointsGeometry: function createPointsGeometry(e) {
        var t = this.getPoints(e);
        return this.createGeometry(t);
      },
      createSpacedPointsGeometry: function createSpacedPointsGeometry(e) {
        var t = this.getSpacedPoints(e);
        return this.createGeometry(t);
      },
      createGeometry: function createGeometry(e) {
        for (var t = new ke(), r = 0, n = e.length; r < n; r++) {
          var i = e[r];
          t.vertices.push(new u(i.x, i.y, i.z || 0));
        }
        return t;
      }
    }), An.prototype = Object.create(Sn.prototype), An.prototype.constructor = An, An.prototype.isEllipseCurve = !0, An.prototype.getPoint = function (e) {
      for (var t = 2 * Math.PI, r = this.aEndAngle - this.aStartAngle, n = Math.abs(r) < Number.EPSILON; r < 0;) r += t;
      for (; r > t;) r -= t;
      r < Number.EPSILON && (r = n ? 0 : t), !0 !== this.aClockwise || n || (r === t ? r = -t : r -= t);
      var a = this.aStartAngle + e * r,
        o = this.aX + this.xRadius * Math.cos(a),
        s = this.aY + this.yRadius * Math.sin(a);
      if (0 !== this.aRotation) {
        var l = Math.cos(this.aRotation),
          c = Math.sin(this.aRotation),
          u = o - this.aX,
          h = s - this.aY;
        o = u * l - h * c + this.aX, s = u * c + h * l + this.aY;
      }
      return new i(o, s);
    }, Tn.prototype = Object.create(Sn.prototype), Tn.prototype.constructor = Tn, Tn.prototype.isSplineCurve = !0, Tn.prototype.getPoint = function (e) {
      var t = this.points,
        r = (t.length - 1) * e,
        n = Math.floor(r),
        a = r - n,
        o = t[0 === n ? n : n - 1],
        s = t[n],
        l = t[n > t.length - 2 ? t.length - 1 : n + 1],
        c = t[n > t.length - 3 ? t.length - 1 : n + 2];
      return new i(dn(a, o.x, s.x, l.x, c.x), dn(a, o.y, s.y, l.y, c.y));
    }, kn.prototype = Object.create(Sn.prototype), kn.prototype.constructor = kn, kn.prototype.getPoint = function (e) {
      var t = this.v0,
        r = this.v1,
        n = this.v2,
        a = this.v3;
      return new i(_n(e, t.x, r.x, n.x, a.x), _n(e, t.y, r.y, n.y, a.y));
    }, Rn.prototype = Object.create(Sn.prototype), Rn.prototype.constructor = Rn, Rn.prototype.getPoint = function (e) {
      var t = this.v0,
        r = this.v1,
        n = this.v2;
      return new i(vn(e, t.x, r.x, n.x), vn(e, t.y, r.y, n.y));
    };
    var Qs = Object.assign(Object.create(En.prototype), {
      fromPoints: function fromPoints(e) {
        this.moveTo(e[0].x, e[0].y);
        for (var t = 1, r = e.length; t < r; t++) this.lineTo(e[t].x, e[t].y);
      },
      moveTo: function moveTo(e, t) {
        this.currentPoint.set(e, t);
      },
      lineTo: function lineTo(e, t) {
        var r = new Cn(this.currentPoint.clone(), new i(e, t));
        this.curves.push(r), this.currentPoint.set(e, t);
      },
      quadraticCurveTo: function quadraticCurveTo(e, t, r, n) {
        var a = new Rn(this.currentPoint.clone(), new i(e, t), new i(r, n));
        this.curves.push(a), this.currentPoint.set(r, n);
      },
      bezierCurveTo: function bezierCurveTo(e, t, r, n, a, o) {
        var s = new kn(this.currentPoint.clone(), new i(e, t), new i(r, n), new i(a, o));
        this.curves.push(s), this.currentPoint.set(a, o);
      },
      splineThru: function splineThru(e) {
        var t = [this.currentPoint.clone()].concat(e),
          r = new Tn(t);
        this.curves.push(r), this.currentPoint.copy(e[e.length - 1]);
      },
      arc: function arc(e, t, r, n, i, a) {
        var o = this.currentPoint.x,
          s = this.currentPoint.y;
        this.absarc(e + o, t + s, r, n, i, a);
      },
      absarc: function absarc(e, t, r, n, i, a) {
        this.absellipse(e, t, r, r, n, i, a);
      },
      ellipse: function ellipse(e, t, r, n, i, a, o, s) {
        var l = this.currentPoint.x,
          c = this.currentPoint.y;
        this.absellipse(e + l, t + c, r, n, i, a, o, s);
      },
      absellipse: function absellipse(e, t, r, n, i, a, o, s) {
        var l = new An(e, t, r, n, i, a, o, s);
        if (this.curves.length > 0) {
          var c = l.getPoint(0);
          c.equals(this.currentPoint) || this.lineTo(c.x, c.y);
        }
        this.curves.push(l);
        var u = l.getPoint(1);
        this.currentPoint.copy(u);
      }
    });
    In.prototype = Qs, Qs.constructor = In, Mn.prototype = Object.assign(Object.create(Qs), {
      constructor: Mn,
      getPointsHoles: function getPointsHoles(e) {
        for (var t = [], r = 0, n = this.holes.length; r < n; r++) t[r] = this.holes[r].getPoints(e);
        return t;
      },
      extractAllPoints: function extractAllPoints(e) {
        return {
          shape: this.getPoints(e),
          holes: this.getPointsHoles(e)
        };
      },
      extractPoints: function extractPoints(e) {
        return this.extractAllPoints(e);
      }
    }), Object.assign(On.prototype, {
      moveTo: function moveTo(e, t) {
        this.currentPath = new In(), this.subPaths.push(this.currentPath), this.currentPath.moveTo(e, t);
      },
      lineTo: function lineTo(e, t) {
        this.currentPath.lineTo(e, t);
      },
      quadraticCurveTo: function quadraticCurveTo(e, t, r, n) {
        this.currentPath.quadraticCurveTo(e, t, r, n);
      },
      bezierCurveTo: function bezierCurveTo(e, t, r, n, i, a) {
        this.currentPath.bezierCurveTo(e, t, r, n, i, a);
      },
      splineThru: function splineThru(e) {
        this.currentPath.splineThru(e);
      },
      toShapes: function toShapes(e, t) {
        function r(e) {
          for (var t = [], r = 0, n = e.length; r < n; r++) {
            var i = e[r],
              a = new Mn();
            a.curves = i.curves, t.push(a);
          }
          return t;
        }
        var n = zs.isClockWise,
          i = this.subPaths;
        if (0 === i.length) return [];
        if (!0 === t) return r(i);
        var a,
          o,
          s,
          l = [];
        if (1 === i.length) return o = i[0], s = new Mn(), s.curves = o.curves, l.push(s), l;
        var c = !n(i[0].getPoints());
        c = e ? !c : c;
        var u,
          h = [],
          f = [],
          d = [],
          p = 0;
        f[p] = void 0, d[p] = [];
        for (var m = 0, g = i.length; m < g; m++) o = i[m], u = o.getPoints(), a = n(u), a = e ? !a : a, a ? (!c && f[p] && p++, f[p] = {
          s: new Mn(),
          p: u
        }, f[p].s.curves = o.curves, c && p++, d[p] = []) : d[p].push({
          h: o,
          p: u[0]
        });
        if (!f[0]) return r(i);
        if (f.length > 1) {
          for (var v = !1, b = [], y = 0, w = f.length; y < w; y++) h[y] = [];
          for (var y = 0, w = f.length; y < w; y++) for (var x = d[y], _ = 0; _ < x.length; _++) {
            for (var S = x[_], C = !0, E = 0; E < f.length; E++) (function (e, t) {
              for (var r = t.length, n = !1, i = r - 1, a = 0; a < r; i = a++) {
                var o = t[i],
                  s = t[a],
                  l = s.x - o.x,
                  c = s.y - o.y;
                if (Math.abs(c) > Number.EPSILON) {
                  if (c < 0 && (o = t[a], l = -l, s = t[i], c = -c), e.y < o.y || e.y > s.y) continue;
                  if (e.y === o.y) {
                    if (e.x === o.x) return !0;
                  } else {
                    var u = c * (e.x - o.x) - l * (e.y - o.y);
                    if (0 === u) return !0;
                    if (u < 0) continue;
                    n = !n;
                  }
                } else {
                  if (e.y !== o.y) continue;
                  if (s.x <= e.x && e.x <= o.x || o.x <= e.x && e.x <= s.x) return !0;
                }
              }
              return n;
            })(S.p, f[E].p) && (y !== E && b.push({
              froms: y,
              tos: E,
              hole: _
            }), C ? (C = !1, h[E].push(S)) : v = !0);
            C && h[y].push(S);
          }
          b.length > 0 && (v || (d = h));
        }
        for (var A, m = 0, T = f.length; m < T; m++) {
          s = f[m].s, l.push(s), A = d[m];
          for (var k = 0, R = A.length; k < R; k++) s.holes.push(A[k].h);
        }
        return l;
      }
    }), Object.assign(Pn.prototype, {
      isFont: !0,
      generateShapes: function generateShapes(e, t, r) {
        function n(e, t, n, a) {
          var o = i.glyphs[e] || i.glyphs["?"];
          if (o) {
            var s,
              l,
              c,
              u,
              h,
              f,
              d,
              p,
              m,
              g,
              v,
              b = new On(),
              y = [];
            if (o.o) for (var w = o._cachedOutline || (o._cachedOutline = o.o.split(" ")), x = 0, _ = w.length; x < _;) {
              var S = w[x++];
              switch (S) {
                case "m":
                  s = w[x++] * t + n, l = w[x++] * t + a, b.moveTo(s, l);
                  break;
                case "l":
                  s = w[x++] * t + n, l = w[x++] * t + a, b.lineTo(s, l);
                  break;
                case "q":
                  if (c = w[x++] * t + n, u = w[x++] * t + a, d = w[x++] * t + n, p = w[x++] * t + a, b.quadraticCurveTo(d, p, c, u), v = y[y.length - 1]) {
                    h = v.x, f = v.y;
                    for (var C = 1; C <= r; C++) {
                      var E = C / r;
                      vn(E, h, d, c), vn(E, f, p, u);
                    }
                  }
                  break;
                case "b":
                  if (c = w[x++] * t + n, u = w[x++] * t + a, d = w[x++] * t + n, p = w[x++] * t + a, m = w[x++] * t + n, g = w[x++] * t + a, b.bezierCurveTo(d, p, m, g, c, u), v = y[y.length - 1]) {
                    h = v.x, f = v.y;
                    for (var C = 1; C <= r; C++) {
                      var E = C / r;
                      _n(E, h, d, m, c), _n(E, f, p, g, u);
                    }
                  }
              }
            }
            return {
              offsetX: o.ha * t,
              path: b
            };
          }
        }
        void 0 === t && (t = 100), void 0 === r && (r = 4);
        for (var i = this.data, a = function (e) {
            for (var r = String(e).split(""), a = t / i.resolution, o = (i.boundingBox.yMax - i.boundingBox.yMin + i.underlineThickness) * a, s = 0, l = 0, c = [], u = 0; u < r.length; u++) {
              var h = r[u];
              if ("\n" === h) s = 0, l -= o;else {
                var f = n(h, a, s, l);
                s += f.offsetX, c.push(f.path);
              }
            }
            return c;
          }(e), o = [], s = 0, l = a.length; s < l; s++) Array.prototype.push.apply(o, a[s].toShapes());
        return o;
      }
    }), Object.assign(Bn.prototype, {
      load: function load(e, t, r, n) {
        var i = this;
        new Mr(this.manager).load(e, function (e) {
          var r;
          try {
            r = JSON.parse(e);
          } catch (t) {
            console.warn("THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead."), r = JSON.parse(e.substring(65, e.length - 2));
          }
          var n = i.parse(r);
          t && t(n);
        }, r, n);
      },
      parse: function parse(e) {
        return new Pn(e);
      }
    });
    var $s,
      el = {
        getContext: function getContext() {
          return void 0 === $s && ($s = new (window.AudioContext || window.webkitAudioContext)()), $s;
        },
        setContext: function setContext(e) {
          $s = e;
        }
      };
    Object.assign(Dn.prototype, {
      load: function load(e, t, r, n) {
        var i = new Mr(this.manager);
        i.setResponseType("arraybuffer"), i.load(e, function (e) {
          el.getContext().decodeAudioData(e, function (e) {
            t(e);
          });
        }, r, n);
      }
    }), Object.assign(Ln.prototype, {
      update: function () {
        var e,
          t,
          r,
          n,
          i,
          a,
          o,
          s,
          l = new h(),
          c = new h();
        return function (u) {
          if (e !== this || t !== u.focus || r !== u.fov || n !== u.aspect * this.aspect || i !== u.near || a !== u.far || o !== u.zoom || s !== this.eyeSep) {
            e = this, t = u.focus, r = u.fov, n = u.aspect * this.aspect, i = u.near, a = u.far, o = u.zoom;
            var h = u.projectionMatrix.clone();
            s = this.eyeSep / 2;
            var f,
              d,
              p = s * i / t,
              m = i * Math.tan(Ss.DEG2RAD * r * .5) / o;
            c.elements[12] = -s, l.elements[12] = s, f = -m * n + p, d = m * n + p, h.elements[0] = 2 * i / (d - f), h.elements[8] = (d + f) / (d - f), this.cameraL.projectionMatrix.copy(h), f = -m * n - p, d = m * n - p, h.elements[0] = 2 * i / (d - f), h.elements[8] = (d + f) / (d - f), this.cameraR.projectionMatrix.copy(h);
          }
          this.cameraL.matrixWorld.copy(u.matrixWorld).multiply(c), this.cameraR.matrixWorld.copy(u.matrixWorld).multiply(l);
        };
      }()
    }), Fn.prototype = Object.create(ue.prototype), Fn.prototype.constructor = Fn, Nn.prototype = Object.assign(Object.create(Le.prototype), {
      constructor: Nn,
      isArrayCamera: !0
    }), Un.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: Un,
      getInput: function getInput() {
        return this.gain;
      },
      removeFilter: function removeFilter() {
        null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null);
      },
      getFilter: function getFilter() {
        return this.filter;
      },
      setFilter: function setFilter(e) {
        null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = e, this.gain.connect(this.filter), this.filter.connect(this.context.destination);
      },
      getMasterVolume: function getMasterVolume() {
        return this.gain.gain.value;
      },
      setMasterVolume: function setMasterVolume(e) {
        this.gain.gain.value = e;
      },
      updateMatrixWorld: function () {
        var e = new u(),
          t = new c(),
          r = new u(),
          n = new u();
        return function (i) {
          ue.prototype.updateMatrixWorld.call(this, i);
          var a = this.context.listener,
            o = this.up;
          this.matrixWorld.decompose(e, t, r), n.set(0, 0, -1).applyQuaternion(t), a.positionX ? (a.positionX.setValueAtTime(e.x, this.context.currentTime), a.positionY.setValueAtTime(e.y, this.context.currentTime), a.positionZ.setValueAtTime(e.z, this.context.currentTime), a.forwardX.setValueAtTime(n.x, this.context.currentTime), a.forwardY.setValueAtTime(n.y, this.context.currentTime), a.forwardZ.setValueAtTime(n.z, this.context.currentTime), a.upX.setValueAtTime(o.x, this.context.currentTime), a.upY.setValueAtTime(o.y, this.context.currentTime), a.upZ.setValueAtTime(o.z, this.context.currentTime)) : (a.setPosition(e.x, e.y, e.z), a.setOrientation(n.x, n.y, n.z, o.x, o.y, o.z));
        };
      }()
    }), jn.prototype = Object.assign(Object.create(ue.prototype), {
      constructor: jn,
      getOutput: function getOutput() {
        return this.gain;
      },
      setNodeSource: function setNodeSource(e) {
        return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = e, this.connect(), this;
      },
      setBuffer: function setBuffer(e) {
        return this.buffer = e, this.sourceType = "buffer", this.autoplay && this.play(), this;
      },
      play: function play() {
        if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
        if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
        var e = this.context.createBufferSource();
        return e.buffer = this.buffer, e.loop = this.loop, e.onended = this.onEnded.bind(this), e.playbackRate.setValueAtTime(this.playbackRate, this.startTime), e.start(0, this.startTime), this.isPlaying = !0, this.source = e, this.connect();
      },
      pause: function pause() {
        return !1 === this.hasPlaybackControl ? void console.warn("THREE.Audio: this Audio has no playback control.") : (this.source.stop(), this.startTime = this.context.currentTime, this.isPlaying = !1, this);
      },
      stop: function stop() {
        return !1 === this.hasPlaybackControl ? void console.warn("THREE.Audio: this Audio has no playback control.") : (this.source.stop(), this.startTime = 0, this.isPlaying = !1, this);
      },
      connect: function connect() {
        if (this.filters.length > 0) {
          this.source.connect(this.filters[0]);
          for (var e = 1, t = this.filters.length; e < t; e++) this.filters[e - 1].connect(this.filters[e]);
          this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        return this;
      },
      disconnect: function disconnect() {
        if (this.filters.length > 0) {
          this.source.disconnect(this.filters[0]);
          for (var e = 1, t = this.filters.length; e < t; e++) this.filters[e - 1].disconnect(this.filters[e]);
          this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        return this;
      },
      getFilters: function getFilters() {
        return this.filters;
      },
      setFilters: function setFilters(e) {
        return e || (e = []), !0 === this.isPlaying ? (this.disconnect(), this.filters = e, this.connect()) : this.filters = e, this;
      },
      getFilter: function getFilter() {
        return this.getFilters()[0];
      },
      setFilter: function setFilter(e) {
        return this.setFilters(e ? [e] : []);
      },
      setPlaybackRate: function setPlaybackRate(e) {
        return !1 === this.hasPlaybackControl ? void console.warn("THREE.Audio: this Audio has no playback control.") : (this.playbackRate = e, !0 === this.isPlaying && this.source.playbackRate.setValueAtTime(this.playbackRate, this.context.currentTime), this);
      },
      getPlaybackRate: function getPlaybackRate() {
        return this.playbackRate;
      },
      onEnded: function onEnded() {
        this.isPlaying = !1;
      },
      getLoop: function getLoop() {
        return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
      },
      setLoop: function setLoop(e) {
        return !1 === this.hasPlaybackControl ? void console.warn("THREE.Audio: this Audio has no playback control.") : (this.loop = e, !0 === this.isPlaying && (this.source.loop = this.loop), this);
      },
      getVolume: function getVolume() {
        return this.gain.gain.value;
      },
      setVolume: function setVolume(e) {
        return this.gain.gain.value = e, this;
      }
    }), zn.prototype = Object.assign(Object.create(jn.prototype), {
      constructor: zn,
      getOutput: function getOutput() {
        return this.panner;
      },
      getRefDistance: function getRefDistance() {
        return this.panner.refDistance;
      },
      setRefDistance: function setRefDistance(e) {
        this.panner.refDistance = e;
      },
      getRolloffFactor: function getRolloffFactor() {
        return this.panner.rolloffFactor;
      },
      setRolloffFactor: function setRolloffFactor(e) {
        this.panner.rolloffFactor = e;
      },
      getDistanceModel: function getDistanceModel() {
        return this.panner.distanceModel;
      },
      setDistanceModel: function setDistanceModel(e) {
        this.panner.distanceModel = e;
      },
      getMaxDistance: function getMaxDistance() {
        return this.panner.maxDistance;
      },
      setMaxDistance: function setMaxDistance(e) {
        this.panner.maxDistance = e;
      },
      updateMatrixWorld: function () {
        var e = new u();
        return function (t) {
          ue.prototype.updateMatrixWorld.call(this, t), e.setFromMatrixPosition(this.matrixWorld), this.panner.setPosition(e.x, e.y, e.z);
        };
      }()
    }), Object.assign(Hn.prototype, {
      getFrequencyData: function getFrequencyData() {
        return this.analyser.getByteFrequencyData(this.data), this.data;
      },
      getAverageFrequency: function getAverageFrequency() {
        for (var e = 0, t = this.getFrequencyData(), r = 0; r < t.length; r++) e += t[r];
        return e / t.length;
      }
    }), Object.assign(Gn.prototype, {
      accumulate: function accumulate(e, t) {
        var r = this.buffer,
          n = this.valueSize,
          i = e * n + n,
          a = this.cumulativeWeight;
        if (0 === a) {
          for (var o = 0; o !== n; ++o) r[i + o] = r[o];
          a = t;
        } else {
          a += t;
          var s = t / a;
          this._mixBufferRegion(r, i, 0, s, n);
        }
        this.cumulativeWeight = a;
      },
      apply: function apply(e) {
        var t = this.valueSize,
          r = this.buffer,
          n = e * t + t,
          i = this.cumulativeWeight,
          a = this.binding;
        if (this.cumulativeWeight = 0, i < 1) {
          var o = 3 * t;
          this._mixBufferRegion(r, n, o, 1 - i, t);
        }
        for (var s = t, l = t + t; s !== l; ++s) if (r[s] !== r[s + t]) {
          a.setValue(r, n);
          break;
        }
      },
      saveOriginalState: function saveOriginalState() {
        var e = this.binding,
          t = this.buffer,
          r = this.valueSize,
          n = 3 * r;
        e.getValue(t, n);
        for (var i = r, a = n; i !== a; ++i) t[i] = t[n + i % r];
        this.cumulativeWeight = 0;
      },
      restoreOriginalState: function restoreOriginalState() {
        var e = 3 * this.valueSize;
        this.binding.setValue(this.buffer, e);
      },
      _select: function _select(e, t, r, n, i) {
        if (n >= .5) for (var a = 0; a !== i; ++a) e[t + a] = e[r + a];
      },
      _slerp: function _slerp(e, t, r, n) {
        c.slerpFlat(e, t, e, t, e, r, n);
      },
      _lerp: function _lerp(e, t, r, n, i) {
        for (var a = 1 - n, o = 0; o !== i; ++o) {
          var s = t + o;
          e[s] = e[s] * a + e[r + o] * n;
        }
      }
    }), Object.assign(Vn.prototype, {
      getValue: function getValue(e, t) {
        this.bind();
        var r = this._targetGroup.nCachedObjects_,
          n = this._bindings[r];
        void 0 !== n && n.getValue(e, t);
      },
      setValue: function setValue(e, t) {
        for (var r = this._bindings, n = this._targetGroup.nCachedObjects_, i = r.length; n !== i; ++n) r[n].setValue(e, t);
      },
      bind: function bind() {
        for (var e = this._bindings, t = this._targetGroup.nCachedObjects_, r = e.length; t !== r; ++t) e[t].bind();
      },
      unbind: function unbind() {
        for (var e = this._bindings, t = this._targetGroup.nCachedObjects_, r = e.length; t !== r; ++t) e[t].unbind();
      }
    }), Object.assign(qn, {
      Composite: Vn,
      create: function create(e, t, r) {
        return e && e.isAnimationObjectGroup ? new qn.Composite(e, t, r) : new qn(e, t, r);
      },
      parseTrackName: function () {
        var e = /((?:[\w-]+[\/:])*)/,
          t = /([\w-\.]+)?/,
          r = /(?:\.([\w-]+)(?:\[(.+)\])?)?/,
          n = /\.([\w-]+)(?:\[(.+)\])?/,
          i = new RegExp("^" + e.source + t.source + r.source + n.source + "$"),
          a = ["material", "materials", "bones"];
        return function (e) {
          var t = i.exec(e);
          if (!t) throw new Error("PropertyBinding: Cannot parse trackName: " + e);
          var r = {
              nodeName: t[2],
              objectName: t[3],
              objectIndex: t[4],
              propertyName: t[5],
              propertyIndex: t[6]
            },
            n = r.nodeName && r.nodeName.lastIndexOf(".");
          if (void 0 !== n && -1 !== n) {
            var o = r.nodeName.substring(n + 1);
            -1 !== a.indexOf(o) && (r.nodeName = r.nodeName.substring(0, n), r.objectName = o);
          }
          if (null === r.propertyName || 0 === r.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e);
          return r;
        };
      }(),
      findNode: function findNode(e, t) {
        if (!t || "" === t || "root" === t || "." === t || -1 === t || t === e.name || t === e.uuid) return e;
        if (e.skeleton) {
          var r = function (e) {
            for (var r = 0; r < e.bones.length; r++) {
              var n = e.bones[r];
              if (n.name === t) return n;
            }
            return null;
          }(e.skeleton);
          if (r) return r;
        }
        if (e.children) {
          var _n3 = function n(e) {
              for (var r = 0; r < e.length; r++) {
                var i = e[r];
                if (i.name === t || i.uuid === t) return i;
                var a = _n3(i.children);
                if (a) return a;
              }
              return null;
            },
            i = _n3(e.children);
          if (i) return i;
        }
        return null;
      }
    }), Object.assign(qn.prototype, {
      _getValue_unavailable: function _getValue_unavailable() {},
      _setValue_unavailable: function _setValue_unavailable() {},
      BindingType: {
        Direct: 0,
        EntireArray: 1,
        ArrayElement: 2,
        HasFromToArray: 3
      },
      Versioning: {
        None: 0,
        NeedsUpdate: 1,
        MatrixWorldNeedsUpdate: 2
      },
      GetterByBindingType: [function (e, t) {
        e[t] = this.node[this.propertyName];
      }, function (e, t) {
        for (var r = this.resolvedProperty, n = 0, i = r.length; n !== i; ++n) e[t++] = r[n];
      }, function (e, t) {
        e[t] = this.resolvedProperty[this.propertyIndex];
      }, function (e, t) {
        this.resolvedProperty.toArray(e, t);
      }],
      SetterByBindingTypeAndVersioning: [[function (e, t) {
        this.node[this.propertyName] = e[t];
      }, function (e, t) {
        this.node[this.propertyName] = e[t], this.targetObject.needsUpdate = !0;
      }, function (e, t) {
        this.node[this.propertyName] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
      }], [function (e, t) {
        for (var r = this.resolvedProperty, n = 0, i = r.length; n !== i; ++n) r[n] = e[t++];
      }, function (e, t) {
        for (var r = this.resolvedProperty, n = 0, i = r.length; n !== i; ++n) r[n] = e[t++];
        this.targetObject.needsUpdate = !0;
      }, function (e, t) {
        for (var r = this.resolvedProperty, n = 0, i = r.length; n !== i; ++n) r[n] = e[t++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
      }], [function (e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t];
      }, function (e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.needsUpdate = !0;
      }, function (e, t) {
        this.resolvedProperty[this.propertyIndex] = e[t], this.targetObject.matrixWorldNeedsUpdate = !0;
      }], [function (e, t) {
        this.resolvedProperty.fromArray(e, t);
      }, function (e, t) {
        this.resolvedProperty.fromArray(e, t), this.targetObject.needsUpdate = !0;
      }, function (e, t) {
        this.resolvedProperty.fromArray(e, t), this.targetObject.matrixWorldNeedsUpdate = !0;
      }]],
      getValue: function getValue(e, t) {
        this.bind(), this.getValue(e, t);
      },
      setValue: function setValue(e, t) {
        this.bind(), this.setValue(e, t);
      },
      bind: function bind() {
        var e = this.node,
          t = this.parsedPath,
          r = t.objectName,
          n = t.propertyName,
          i = t.propertyIndex;
        if (e || (e = qn.findNode(this.rootNode, t.nodeName) || this.rootNode, this.node = e), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e) return void console.error("  trying to update node for track: " + this.path + " but it wasn't found.");
        if (r) {
          var a = t.objectIndex;
          switch (r) {
            case "materials":
              if (!e.material) return void console.error("  can not bind to material as node does not have a material", this);
              if (!e.material.materials) return void console.error("  can not bind to material.materials as node.material does not have a materials array", this);
              e = e.material.materials;
              break;
            case "bones":
              if (!e.skeleton) return void console.error("  can not bind to bones as node does not have a skeleton", this);
              e = e.skeleton.bones;
              for (var o = 0; o < e.length; o++) if (e[o].name === a) {
                a = o;
                break;
              }
              break;
            default:
              if (void 0 === e[r]) return void console.error("  can not bind to objectName of node, undefined", this);
              e = e[r];
          }
          if (void 0 !== a) {
            if (void 0 === e[a]) return void console.error("  trying to bind to objectIndex of objectName, but is undefined:", this, e);
            e = e[a];
          }
        }
        var s = e[n];
        if (void 0 === s) {
          var l = t.nodeName;
          return void console.error("  trying to update property for track: " + l + "." + n + " but it wasn't found.", e);
        }
        var c = this.Versioning.None;
        void 0 !== e.needsUpdate ? (c = this.Versioning.NeedsUpdate, this.targetObject = e) : void 0 !== e.matrixWorldNeedsUpdate && (c = this.Versioning.MatrixWorldNeedsUpdate, this.targetObject = e);
        var u = this.BindingType.Direct;
        if (void 0 !== i) {
          if ("morphTargetInfluences" === n) {
            if (!e.geometry) return void console.error("  can not bind to morphTargetInfluences becasuse node does not have a geometry", this);
            if (!e.geometry.morphTargets) return void console.error("  can not bind to morphTargetInfluences becasuse node does not have a geometry.morphTargets", this);
            for (var o = 0; o < this.node.geometry.morphTargets.length; o++) if (e.geometry.morphTargets[o].name === i) {
              i = o;
              break;
            }
          }
          u = this.BindingType.ArrayElement, this.resolvedProperty = s, this.propertyIndex = i;
        } else void 0 !== s.fromArray && void 0 !== s.toArray ? (u = this.BindingType.HasFromToArray, this.resolvedProperty = s) : Array.isArray(s) ? (u = this.BindingType.EntireArray, this.resolvedProperty = s) : this.propertyName = n;
        this.getValue = this.GetterByBindingType[u], this.setValue = this.SetterByBindingTypeAndVersioning[u][c];
      },
      unbind: function unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
      }
    }),
    //!\ DECLARE ALIAS AFTER assign prototype !
    Object.assign(qn.prototype, {
      _getValue_unbound: qn.prototype.getValue,
      _setValue_unbound: qn.prototype.setValue
    }), Object.assign(Wn.prototype, {
      isAnimationObjectGroup: !0,
      add: function add(e) {
        for (var t = this._objects, r = t.length, n = this.nCachedObjects_, i = this._indicesByUUID, a = this._paths, o = this._parsedPaths, s = this._bindings, l = s.length, c = 0, u = arguments.length; c !== u; ++c) {
          var h = arguments[c],
            f = h.uuid,
            d = i[f],
            p = void 0;
          if (void 0 === d) {
            d = r++, i[f] = d, t.push(h);
            for (var m = 0, g = l; m !== g; ++m) s[m].push(new qn(h, a[m], o[m]));
          } else if (d < n) {
            p = t[d];
            var v = --n,
              b = t[v];
            i[b.uuid] = d, t[d] = b, i[f] = v, t[v] = h;
            for (var m = 0, g = l; m !== g; ++m) {
              var y = s[m],
                w = y[v],
                x = y[d];
              y[d] = w, void 0 === x && (x = new qn(h, a[m], o[m])), y[v] = x;
            }
          } else t[d] !== p && console.error("Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes...");
        }
        this.nCachedObjects_ = n;
      },
      remove: function remove(e) {
        for (var t = this._objects, r = this.nCachedObjects_, n = this._indicesByUUID, i = this._bindings, a = i.length, o = 0, s = arguments.length; o !== s; ++o) {
          var l = arguments[o],
            c = l.uuid,
            u = n[c];
          if (void 0 !== u && u >= r) {
            var h = r++,
              f = t[h];
            n[f.uuid] = u, t[u] = f, n[c] = h, t[h] = l;
            for (var d = 0, p = a; d !== p; ++d) {
              var m = i[d],
                g = m[h],
                v = m[u];
              m[u] = g, m[h] = v;
            }
          }
        }
        this.nCachedObjects_ = r;
      },
      uncache: function uncache(e) {
        for (var t = this._objects, r = t.length, n = this.nCachedObjects_, i = this._indicesByUUID, a = this._bindings, o = a.length, s = 0, l = arguments.length; s !== l; ++s) {
          var c = arguments[s],
            u = c.uuid,
            h = i[u];
          if (void 0 !== h) if (delete i[u], h < n) {
            var f = --n,
              d = t[f],
              p = --r,
              m = t[p];
            i[d.uuid] = h, t[h] = d, i[m.uuid] = f, t[f] = m, t.pop();
            for (var g = 0, v = o; g !== v; ++g) {
              var b = a[g],
                y = b[f],
                w = b[p];
              b[h] = y, b[f] = w, b.pop();
            }
          } else {
            var p = --r,
              m = t[p];
            i[m.uuid] = h, t[h] = m, t.pop();
            for (var g = 0, v = o; g !== v; ++g) {
              var b = a[g];
              b[h] = b[p], b.pop();
            }
          }
        }
        this.nCachedObjects_ = n;
      },
      subscribe_: function subscribe_(e, t) {
        var r = this._bindingsIndicesByPath,
          n = r[e],
          i = this._bindings;
        if (void 0 !== n) return i[n];
        var a = this._paths,
          o = this._parsedPaths,
          s = this._objects,
          l = s.length,
          c = this.nCachedObjects_,
          u = new Array(l);
        n = i.length, r[e] = n, a.push(e), o.push(t), i.push(u);
        for (var h = c, f = s.length; h !== f; ++h) {
          var d = s[h];
          u[h] = new qn(d, e, t);
        }
        return u;
      },
      unsubscribe_: function unsubscribe_(e) {
        var t = this._bindingsIndicesByPath,
          r = t[e];
        if (void 0 !== r) {
          var n = this._paths,
            i = this._parsedPaths,
            a = this._bindings,
            o = a.length - 1,
            s = a[o];
          t[e[o]] = r, a[r] = s, a.pop(), i[r] = i[o], i.pop(), n[r] = n[o], n.pop();
        }
      }
    }), Object.assign(Xn.prototype, {
      play: function play() {
        return this._mixer._activateAction(this), this;
      },
      stop: function stop() {
        return this._mixer._deactivateAction(this), this.reset();
      },
      reset: function reset() {
        return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
      },
      isRunning: function isRunning() {
        return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
      },
      isScheduled: function isScheduled() {
        return this._mixer._isActiveAction(this);
      },
      startAt: function startAt(e) {
        return this._startTime = e, this;
      },
      setLoop: function setLoop(e, t) {
        return this.loop = e, this.repetitions = t, this;
      },
      setEffectiveWeight: function setEffectiveWeight(e) {
        return this.weight = e, this._effectiveWeight = this.enabled ? e : 0, this.stopFading();
      },
      getEffectiveWeight: function getEffectiveWeight() {
        return this._effectiveWeight;
      },
      fadeIn: function fadeIn(e) {
        return this._scheduleFading(e, 0, 1);
      },
      fadeOut: function fadeOut(e) {
        return this._scheduleFading(e, 1, 0);
      },
      crossFadeFrom: function crossFadeFrom(e, t, r) {
        if (e.fadeOut(t), this.fadeIn(t), r) {
          var n = this._clip.duration,
            i = e._clip.duration,
            a = i / n,
            o = n / i;
          e.warp(1, a, t), this.warp(o, 1, t);
        }
        return this;
      },
      crossFadeTo: function crossFadeTo(e, t, r) {
        return e.crossFadeFrom(this, t, r);
      },
      stopFading: function stopFading() {
        var e = this._weightInterpolant;
        return null !== e && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
      },
      setEffectiveTimeScale: function setEffectiveTimeScale(e) {
        return this.timeScale = e, this._effectiveTimeScale = this.paused ? 0 : e, this.stopWarping();
      },
      getEffectiveTimeScale: function getEffectiveTimeScale() {
        return this._effectiveTimeScale;
      },
      setDuration: function setDuration(e) {
        return this.timeScale = this._clip.duration / e, this.stopWarping();
      },
      syncWith: function syncWith(e) {
        return this.time = e.time, this.timeScale = e.timeScale, this.stopWarping();
      },
      halt: function halt(e) {
        return this.warp(this._effectiveTimeScale, 0, e);
      },
      warp: function warp(e, t, r) {
        var n = this._mixer,
          i = n.time,
          a = this._timeScaleInterpolant,
          o = this.timeScale;
        null === a && (a = n._lendControlInterpolant(), this._timeScaleInterpolant = a);
        var s = a.parameterPositions,
          l = a.sampleValues;
        return s[0] = i, s[1] = i + r, l[0] = e / o, l[1] = t / o, this;
      },
      stopWarping: function stopWarping() {
        var e = this._timeScaleInterpolant;
        return null !== e && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e)), this;
      },
      getMixer: function getMixer() {
        return this._mixer;
      },
      getClip: function getClip() {
        return this._clip;
      },
      getRoot: function getRoot() {
        return this._localRoot || this._mixer._root;
      },
      _update: function _update(e, t, r, n) {
        if (!this.enabled) return void this._updateWeight(e);
        var i = this._startTime;
        if (null !== i) {
          var a = (e - i) * r;
          if (a < 0 || 0 === r) return;
          this._startTime = null, t = r * a;
        }
        t *= this._updateTimeScale(e);
        var o = this._updateTime(t),
          s = this._updateWeight(e);
        if (s > 0) for (var l = this._interpolants, c = this._propertyBindings, u = 0, h = l.length; u !== h; ++u) l[u].evaluate(o), c[u].accumulate(n, s);
      },
      _updateWeight: function _updateWeight(e) {
        var t = 0;
        if (this.enabled) {
          t = this.weight;
          var r = this._weightInterpolant;
          if (null !== r) {
            var n = r.evaluate(e)[0];
            t *= n, e > r.parameterPositions[1] && (this.stopFading(), 0 === n && (this.enabled = !1));
          }
        }
        return this._effectiveWeight = t, t;
      },
      _updateTimeScale: function _updateTimeScale(e) {
        var t = 0;
        if (!this.paused) {
          t = this.timeScale;
          var r = this._timeScaleInterpolant;
          if (null !== r) {
            t *= r.evaluate(e)[0], e > r.parameterPositions[1] && (this.stopWarping(), 0 === t ? this.paused = !0 : this.timeScale = t);
          }
        }
        return this._effectiveTimeScale = t, t;
      },
      _updateTime: function _updateTime(e) {
        var t = this.time + e;
        if (0 === e) return t;
        var r = this._clip.duration,
          n = this.loop,
          i = this._loopCount;
        if (n === ts) {
          -1 === i && (this._loopCount = 0, this._setEndings(!0, !0, !1));
          e: {
            if (t >= r) t = r;else {
              if (!(t < 0)) break e;
              t = 0;
            }
            this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: e < 0 ? -1 : 1
            });
          }
        } else {
          var a = n === ns;
          if (-1 === i && (e >= 0 ? (i = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), t >= r || t < 0) {
            var o = Math.floor(t / r);
            t -= r * o, i += Math.abs(o);
            var s = this.repetitions - i;
            if (s < 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, t = e > 0 ? r : 0, this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: e > 0 ? 1 : -1
            });else {
              if (0 === s) {
                var l = e < 0;
                this._setEndings(l, !l, a);
              } else this._setEndings(!1, !1, a);
              this._loopCount = i, this._mixer.dispatchEvent({
                type: "loop",
                action: this,
                loopDelta: o
              });
            }
          }
          if (a && 1 == (1 & i)) return this.time = t, r - t;
        }
        return this.time = t, t;
      },
      _setEndings: function _setEndings(e, t, r) {
        var n = this._interpolantSettings;
        r ? (n.endingStart = ls, n.endingEnd = ls) : (n.endingStart = e ? this.zeroSlopeAtStart ? ls : ss : cs, n.endingEnd = t ? this.zeroSlopeAtEnd ? ls : ss : cs);
      },
      _scheduleFading: function _scheduleFading(e, t, r) {
        var n = this._mixer,
          i = n.time,
          a = this._weightInterpolant;
        null === a && (a = n._lendControlInterpolant(), this._weightInterpolant = a);
        var o = a.parameterPositions,
          s = a.sampleValues;
        return o[0] = i, s[0] = t, o[1] = i + e, s[1] = r, this;
      }
    }), Object.assign(Yn.prototype, n.prototype, {
      _bindAction: function _bindAction(e, t) {
        var r = e._localRoot || this._root,
          n = e._clip.tracks,
          i = n.length,
          a = e._propertyBindings,
          o = e._interpolants,
          s = r.uuid,
          l = this._bindingsByRootAndName,
          c = l[s];
        void 0 === c && (c = {}, l[s] = c);
        for (var u = 0; u !== i; ++u) {
          var h = n[u],
            f = h.name,
            d = c[f];
          if (void 0 !== d) a[u] = d;else {
            if (void 0 !== (d = a[u])) {
              null === d._cacheIndex && (++d.referenceCount, this._addInactiveBinding(d, s, f));
              continue;
            }
            var p = t && t._propertyBindings[u].binding.parsedPath;
            d = new Gn(qn.create(r, f, p), h.ValueTypeName, h.getValueSize()), ++d.referenceCount, this._addInactiveBinding(d, s, f), a[u] = d;
          }
          o[u].resultBuffer = d.buffer;
        }
      },
      _activateAction: function _activateAction(e) {
        if (!this._isActiveAction(e)) {
          if (null === e._cacheIndex) {
            var t = (e._localRoot || this._root).uuid,
              r = e._clip.uuid,
              n = this._actionsByClip[r];
            this._bindAction(e, n && n.knownActions[0]), this._addInactiveAction(e, r, t);
          }
          for (var i = e._propertyBindings, a = 0, o = i.length; a !== o; ++a) {
            var s = i[a];
            0 == s.useCount++ && (this._lendBinding(s), s.saveOriginalState());
          }
          this._lendAction(e);
        }
      },
      _deactivateAction: function _deactivateAction(e) {
        if (this._isActiveAction(e)) {
          for (var t = e._propertyBindings, r = 0, n = t.length; r !== n; ++r) {
            var i = t[r];
            0 == --i.useCount && (i.restoreOriginalState(), this._takeBackBinding(i));
          }
          this._takeBackAction(e);
        }
      },
      _initMemoryManager: function _initMemoryManager() {
        this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
        var e = this;
        this.stats = {
          actions: {
            get total() {
              return e._actions.length;
            },
            get inUse() {
              return e._nActiveActions;
            }
          },
          bindings: {
            get total() {
              return e._bindings.length;
            },
            get inUse() {
              return e._nActiveBindings;
            }
          },
          controlInterpolants: {
            get total() {
              return e._controlInterpolants.length;
            },
            get inUse() {
              return e._nActiveControlInterpolants;
            }
          }
        };
      },
      _isActiveAction: function _isActiveAction(e) {
        var t = e._cacheIndex;
        return null !== t && t < this._nActiveActions;
      },
      _addInactiveAction: function _addInactiveAction(e, t, r) {
        var n = this._actions,
          i = this._actionsByClip,
          a = i[t];
        if (void 0 === a) a = {
          knownActions: [e],
          actionByRoot: {}
        }, e._byClipCacheIndex = 0, i[t] = a;else {
          var o = a.knownActions;
          e._byClipCacheIndex = o.length, o.push(e);
        }
        e._cacheIndex = n.length, n.push(e), a.actionByRoot[r] = e;
      },
      _removeInactiveAction: function _removeInactiveAction(e) {
        var t = this._actions,
          r = t[t.length - 1],
          n = e._cacheIndex;
        r._cacheIndex = n, t[n] = r, t.pop(), e._cacheIndex = null;
        var i = e._clip.uuid,
          a = this._actionsByClip,
          o = a[i],
          s = o.knownActions,
          l = s[s.length - 1],
          c = e._byClipCacheIndex;
        l._byClipCacheIndex = c, s[c] = l, s.pop(), e._byClipCacheIndex = null, delete o.actionByRoot[(e._localRoot || this._root).uuid], 0 === s.length && delete a[i], this._removeInactiveBindingsForAction(e);
      },
      _removeInactiveBindingsForAction: function _removeInactiveBindingsForAction(e) {
        for (var t = e._propertyBindings, r = 0, n = t.length; r !== n; ++r) {
          var i = t[r];
          0 == --i.referenceCount && this._removeInactiveBinding(i);
        }
      },
      _lendAction: function _lendAction(e) {
        var t = this._actions,
          r = e._cacheIndex,
          n = this._nActiveActions++,
          i = t[n];
        e._cacheIndex = n, t[n] = e, i._cacheIndex = r, t[r] = i;
      },
      _takeBackAction: function _takeBackAction(e) {
        var t = this._actions,
          r = e._cacheIndex,
          n = --this._nActiveActions,
          i = t[n];
        e._cacheIndex = n, t[n] = e, i._cacheIndex = r, t[r] = i;
      },
      _addInactiveBinding: function _addInactiveBinding(e, t, r) {
        var n = this._bindingsByRootAndName,
          i = n[t],
          a = this._bindings;
        void 0 === i && (i = {}, n[t] = i), i[r] = e, e._cacheIndex = a.length, a.push(e);
      },
      _removeInactiveBinding: function _removeInactiveBinding(e) {
        var t = this._bindings,
          r = e.binding,
          n = r.rootNode.uuid,
          i = r.path,
          a = this._bindingsByRootAndName,
          o = a[n],
          s = t[t.length - 1],
          l = e._cacheIndex;
        s._cacheIndex = l, t[l] = s, t.pop(), delete o[i];
        e: {
          for (var c in o) break e;
          delete a[n];
        }
      },
      _lendBinding: function _lendBinding(e) {
        var t = this._bindings,
          r = e._cacheIndex,
          n = this._nActiveBindings++,
          i = t[n];
        e._cacheIndex = n, t[n] = e, i._cacheIndex = r, t[r] = i;
      },
      _takeBackBinding: function _takeBackBinding(e) {
        var t = this._bindings,
          r = e._cacheIndex,
          n = --this._nActiveBindings,
          i = t[n];
        e._cacheIndex = n, t[n] = e, i._cacheIndex = r, t[r] = i;
      },
      _lendControlInterpolant: function _lendControlInterpolant() {
        var e = this._controlInterpolants,
          t = this._nActiveControlInterpolants++,
          r = e[t];
        return void 0 === r && (r = new Kr(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer), r.__cacheIndex = t, e[t] = r), r;
      },
      _takeBackControlInterpolant: function _takeBackControlInterpolant(e) {
        var t = this._controlInterpolants,
          r = e.__cacheIndex,
          n = --this._nActiveControlInterpolants,
          i = t[n];
        e.__cacheIndex = n, t[n] = e, i.__cacheIndex = r, t[r] = i;
      },
      _controlInterpolantsResultBuffer: new Float32Array(1),
      clipAction: function clipAction(e, t) {
        var r = t || this._root,
          n = r.uuid,
          i = "string" == typeof e ? sn.findByName(r, e) : e,
          a = null !== i ? i.uuid : e,
          o = this._actionsByClip[a],
          s = null;
        if (void 0 !== o) {
          var l = o.actionByRoot[n];
          if (void 0 !== l) return l;
          s = o.knownActions[0], null === i && (i = s._clip);
        }
        if (null === i) return null;
        var c = new Xn(this, i, t);
        return this._bindAction(c, s), this._addInactiveAction(c, a, n), c;
      },
      existingAction: function existingAction(e, t) {
        var r = t || this._root,
          n = r.uuid,
          i = "string" == typeof e ? sn.findByName(r, e) : e,
          a = i ? i.uuid : e,
          o = this._actionsByClip[a];
        return void 0 !== o ? o.actionByRoot[n] || null : null;
      },
      stopAllAction: function stopAllAction() {
        var e = this._actions,
          t = this._nActiveActions,
          r = this._bindings,
          n = this._nActiveBindings;
        this._nActiveActions = 0, this._nActiveBindings = 0;
        for (var i = 0; i !== t; ++i) e[i].reset();
        for (var i = 0; i !== n; ++i) r[i].useCount = 0;
        return this;
      },
      update: function update(e) {
        e *= this.timeScale;
        for (var t = this._actions, r = this._nActiveActions, n = this.time += e, i = Math.sign(e), a = this._accuIndex ^= 1, o = 0; o !== r; ++o) {
          t[o]._update(n, e, i, a);
        }
        for (var s = this._bindings, l = this._nActiveBindings, o = 0; o !== l; ++o) s[o].apply(a);
        return this;
      },
      getRoot: function getRoot() {
        return this._root;
      },
      uncacheClip: function uncacheClip(e) {
        var t = this._actions,
          r = e.uuid,
          n = this._actionsByClip,
          i = n[r];
        if (void 0 !== i) {
          for (var a = i.knownActions, o = 0, s = a.length; o !== s; ++o) {
            var l = a[o];
            this._deactivateAction(l);
            var c = l._cacheIndex,
              u = t[t.length - 1];
            l._cacheIndex = null, l._byClipCacheIndex = null, u._cacheIndex = c, t[c] = u, t.pop(), this._removeInactiveBindingsForAction(l);
          }
          delete n[r];
        }
      },
      uncacheRoot: function uncacheRoot(e) {
        var t = e.uuid,
          r = this._actionsByClip;
        for (var n in r) {
          var i = r[n].actionByRoot,
            a = i[t];
          void 0 !== a && (this._deactivateAction(a), this._removeInactiveAction(a));
        }
        var o = this._bindingsByRootAndName,
          s = o[t];
        if (void 0 !== s) for (var l in s) {
          var c = s[l];
          c.restoreOriginalState(), this._removeInactiveBinding(c);
        }
      },
      uncacheAction: function uncacheAction(e, t) {
        var r = this.existingAction(e, t);
        null !== r && (this._deactivateAction(r), this._removeInactiveAction(r));
      }
    }), Kn.prototype.clone = function () {
      return new Kn(void 0 === this.value.clone ? this.value : this.value.clone());
    }, Zn.prototype = Object.assign(Object.create(Re.prototype), {
      constructor: Zn,
      isInstancedBufferGeometry: !0,
      addGroup: function addGroup(e, t, r) {
        this.groups.push({
          start: e,
          count: t,
          materialIndex: r
        });
      },
      copy: function copy(e) {
        var t = e.index;
        null !== t && this.setIndex(t.clone());
        var r = e.attributes;
        for (var n in r) {
          var i = r[n];
          this.addAttribute(n, i.clone());
        }
        for (var a = e.groups, o = 0, s = a.length; o < s; o++) {
          var l = a[o];
          this.addGroup(l.start, l.count, l.materialIndex);
        }
        return this;
      }
    }), Object.defineProperties(Jn.prototype, {
      count: {
        get: function get() {
          return this.data.count;
        }
      },
      array: {
        get: function get() {
          return this.data.array;
        }
      }
    }), Object.assign(Jn.prototype, {
      isInterleavedBufferAttribute: !0,
      setX: function setX(e, t) {
        return this.data.array[e * this.data.stride + this.offset] = t, this;
      },
      setY: function setY(e, t) {
        return this.data.array[e * this.data.stride + this.offset + 1] = t, this;
      },
      setZ: function setZ(e, t) {
        return this.data.array[e * this.data.stride + this.offset + 2] = t, this;
      },
      setW: function setW(e, t) {
        return this.data.array[e * this.data.stride + this.offset + 3] = t, this;
      },
      getX: function getX(e) {
        return this.data.array[e * this.data.stride + this.offset];
      },
      getY: function getY(e) {
        return this.data.array[e * this.data.stride + this.offset + 1];
      },
      getZ: function getZ(e) {
        return this.data.array[e * this.data.stride + this.offset + 2];
      },
      getW: function getW(e) {
        return this.data.array[e * this.data.stride + this.offset + 3];
      },
      setXY: function setXY(e, t, r) {
        return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = r, this;
      },
      setXYZ: function setXYZ(e, t, r, n) {
        return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = r, this.data.array[e + 2] = n, this;
      },
      setXYZW: function setXYZW(e, t, r, n, i) {
        return e = e * this.data.stride + this.offset, this.data.array[e + 0] = t, this.data.array[e + 1] = r, this.data.array[e + 2] = n, this.data.array[e + 3] = i, this;
      }
    }), Object.defineProperty(Qn.prototype, "needsUpdate", {
      set: function set(e) {
        !0 === e && this.version++;
      }
    }), Object.assign(Qn.prototype, {
      isInterleavedBuffer: !0,
      setArray: function setArray(e) {
        if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.count = void 0 !== e ? e.length / this.stride : 0, this.array = e;
      },
      setDynamic: function setDynamic(e) {
        return this.dynamic = e, this;
      },
      copy: function copy(e) {
        return this.array = new e.array.constructor(e.array), this.count = e.count, this.stride = e.stride, this.dynamic = e.dynamic, this;
      },
      copyAt: function copyAt(e, t, r) {
        e *= this.stride, r *= t.stride;
        for (var n = 0, i = this.stride; n < i; n++) this.array[e + n] = t.array[r + n];
        return this;
      },
      set: function set(e, t) {
        return void 0 === t && (t = 0), this.array.set(e, t), this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      onUpload: function onUpload(e) {
        return this.onUploadCallback = e, this;
      }
    }), $n.prototype = Object.assign(Object.create(Qn.prototype), {
      constructor: $n,
      isInstancedInterleavedBuffer: !0,
      copy: function copy(e) {
        return Qn.prototype.copy.call(this, e), this.meshPerAttribute = e.meshPerAttribute, this;
      }
    }), ei.prototype = Object.assign(Object.create(me.prototype), {
      constructor: ei,
      isInstancedBufferAttribute: !0,
      copy: function copy(e) {
        return me.prototype.copy.call(this, e), this.meshPerAttribute = e.meshPerAttribute, this;
      }
    }), Object.assign(ti.prototype, {
      linePrecision: 1,
      set: function set(e, t) {
        this.ray.set(e, t);
      },
      setFromCamera: function setFromCamera(e, t) {
        t && t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e.x, e.y, .5).unproject(t).sub(this.ray.origin).normalize()) : t && t.isOrthographicCamera ? (this.ray.origin.set(e.x, e.y, (t.near + t.far) / (t.near - t.far)).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld)) : console.error("THREE.Raycaster: Unsupported camera type.");
      },
      intersectObject: function intersectObject(e, t) {
        var r = [];
        return ni(e, this, r, t), r.sort(ri), r;
      },
      intersectObjects: function intersectObjects(e, t) {
        var r = [];
        if (!1 === Array.isArray(e)) return console.warn("THREE.Raycaster.intersectObjects: objects is not an Array."), r;
        for (var n = 0, i = e.length; n < i; n++) ni(e[n], this, r, t);
        return r.sort(ri), r;
      }
    }), Object.assign(ii.prototype, {
      start: function start() {
        this.startTime = ("undefined" == typeof performance ? Date : performance).now(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
      },
      stop: function stop() {
        this.getElapsedTime(), this.running = !1;
      },
      getElapsedTime: function getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
      },
      getDelta: function getDelta() {
        var e = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
          var t = ("undefined" == typeof performance ? Date : performance).now();
          e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
        }
        return e;
      }
    }), Object.assign(ai.prototype, {
      set: function set(e, t, r) {
        return this.radius = e, this.phi = t, this.theta = r, this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.radius = e.radius, this.phi = e.phi, this.theta = e.theta, this;
      },
      makeSafe: function makeSafe() {
        return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
      },
      setFromVector3: function setFromVector3(e) {
        return this.radius = e.length(), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e.x, e.z), this.phi = Math.acos(Ss.clamp(e.y / this.radius, -1, 1))), this;
      }
    }), Object.assign(oi.prototype, {
      set: function set(e, t, r) {
        return this.radius = e, this.theta = t, this.y = r, this;
      },
      clone: function clone() {
        return new this.constructor().copy(this);
      },
      copy: function copy(e) {
        return this.radius = e.radius, this.theta = e.theta, this.y = e.y, this;
      },
      setFromVector3: function setFromVector3(e) {
        return this.radius = Math.sqrt(e.x * e.x + e.z * e.z), this.theta = Math.atan2(e.x, e.z), this.y = e.y, this;
      }
    }), si.prototype = Object.create(Ie.prototype), si.prototype.constructor = si, si.prototype.createAnimation = function (e, t, r, n) {
      var i = {
        start: t,
        end: r,
        length: r - t + 1,
        fps: n,
        duration: (r - t) / n,
        lastFrame: 0,
        currentFrame: 0,
        active: !1,
        time: 0,
        direction: 1,
        weight: 1,
        directionBackwards: !1,
        mirroredLoop: !1
      };
      this.animationsMap[e] = i, this.animationsList.push(i);
    }, si.prototype.autoCreateAnimations = function (e) {
      for (var t, r = /([a-z]+)_?(\d+)/i, n = {}, i = this.geometry, a = 0, o = i.morphTargets.length; a < o; a++) {
        var s = i.morphTargets[a],
          l = s.name.match(r);
        if (l && l.length > 1) {
          var c = l[1];
          n[c] || (n[c] = {
            start: 1 / 0,
            end: -1 / 0
          });
          var u = n[c];
          a < u.start && (u.start = a), a > u.end && (u.end = a), t || (t = c);
        }
      }
      for (var c in n) {
        var u = n[c];
        this.createAnimation(c, u.start, u.end, e);
      }
      this.firstAnimation = t;
    }, si.prototype.setAnimationDirectionForward = function (e) {
      var t = this.animationsMap[e];
      t && (t.direction = 1, t.directionBackwards = !1);
    }, si.prototype.setAnimationDirectionBackward = function (e) {
      var t = this.animationsMap[e];
      t && (t.direction = -1, t.directionBackwards = !0);
    }, si.prototype.setAnimationFPS = function (e, t) {
      var r = this.animationsMap[e];
      r && (r.fps = t, r.duration = (r.end - r.start) / r.fps);
    }, si.prototype.setAnimationDuration = function (e, t) {
      var r = this.animationsMap[e];
      r && (r.duration = t, r.fps = (r.end - r.start) / r.duration);
    }, si.prototype.setAnimationWeight = function (e, t) {
      var r = this.animationsMap[e];
      r && (r.weight = t);
    }, si.prototype.setAnimationTime = function (e, t) {
      var r = this.animationsMap[e];
      r && (r.time = t);
    }, si.prototype.getAnimationTime = function (e) {
      var t = 0,
        r = this.animationsMap[e];
      return r && (t = r.time), t;
    }, si.prototype.getAnimationDuration = function (e) {
      var t = -1,
        r = this.animationsMap[e];
      return r && (t = r.duration), t;
    }, si.prototype.playAnimation = function (e) {
      var t = this.animationsMap[e];
      t ? (t.time = 0, t.active = !0) : console.warn("THREE.MorphBlendMesh: animation[" + e + "] undefined in .playAnimation()");
    }, si.prototype.stopAnimation = function (e) {
      var t = this.animationsMap[e];
      t && (t.active = !1);
    }, si.prototype.update = function (e) {
      for (var t = 0, r = this.animationsList.length; t < r; t++) {
        var n = this.animationsList[t];
        if (n.active) {
          var i = n.duration / n.length;
          n.time += n.direction * e, n.mirroredLoop ? (n.time > n.duration || n.time < 0) && (n.direction *= -1, n.time > n.duration && (n.time = n.duration, n.directionBackwards = !0), n.time < 0 && (n.time = 0, n.directionBackwards = !1)) : (n.time = n.time % n.duration, n.time < 0 && (n.time += n.duration));
          var a = n.start + Ss.clamp(Math.floor(n.time / i), 0, n.length - 1),
            o = n.weight;
          a !== n.currentFrame && (this.morphTargetInfluences[n.lastFrame] = 0, this.morphTargetInfluences[n.currentFrame] = 1 * o, this.morphTargetInfluences[a] = 0, n.lastFrame = n.currentFrame, n.currentFrame = a);
          var s = n.time % i / i;
          n.directionBackwards && (s = 1 - s), n.currentFrame !== n.lastFrame ? (this.morphTargetInfluences[n.currentFrame] = s * o, this.morphTargetInfluences[n.lastFrame] = (1 - s) * o) : this.morphTargetInfluences[n.currentFrame] = o;
        }
      }
    }, li.prototype = Object.create(ue.prototype), li.prototype.constructor = li, li.prototype.isImmediateRenderObject = !0, ci.prototype = Object.create(kt.prototype), ci.prototype.constructor = ci, ci.prototype.update = function () {
      var e = new u(),
        t = new u(),
        r = new ne();
      return function () {
        var n = ["a", "b", "c"];
        this.object.updateMatrixWorld(!0), r.getNormalMatrix(this.object.matrixWorld);
        var i = this.object.matrixWorld,
          a = this.geometry.attributes.position,
          o = this.object.geometry;
        if (o && o.isGeometry) for (var s = o.vertices, l = o.faces, c = 0, u = 0, h = l.length; u < h; u++) for (var f = l[u], d = 0, p = f.vertexNormals.length; d < p; d++) {
          var m = s[f[n[d]]],
            g = f.vertexNormals[d];
          e.copy(m).applyMatrix4(i), t.copy(g).applyMatrix3(r).normalize().multiplyScalar(this.size).add(e), a.setXYZ(c, e.x, e.y, e.z), c += 1, a.setXYZ(c, t.x, t.y, t.z), c += 1;
        } else if (o && o.isBufferGeometry) for (var v = o.attributes.position, b = o.attributes.normal, c = 0, d = 0, p = v.count; d < p; d++) e.set(v.getX(d), v.getY(d), v.getZ(d)).applyMatrix4(i), t.set(b.getX(d), b.getY(d), b.getZ(d)), t.applyMatrix3(r).normalize().multiplyScalar(this.size).add(e), a.setXYZ(c, e.x, e.y, e.z), c += 1, a.setXYZ(c, t.x, t.y, t.z), c += 1;
        a.needsUpdate = !0;
      };
    }(), ui.prototype = Object.create(ue.prototype), ui.prototype.constructor = ui, ui.prototype.dispose = function () {
      this.cone.geometry.dispose(), this.cone.material.dispose();
    }, ui.prototype.update = function () {
      var e = new u(),
        t = new u();
      return function () {
        var r = this.light.distance ? this.light.distance : 1e3,
          n = r * Math.tan(this.light.angle);
        this.cone.scale.set(n, n, r), e.setFromMatrixPosition(this.light.matrixWorld), t.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(t.sub(e)), this.cone.material.color.copy(this.light.color);
      };
    }(), hi.prototype = Object.create(kt.prototype), hi.prototype.constructor = hi, hi.prototype.getBoneList = function (e) {
      var t = [];
      e && e.isBone && t.push(e);
      for (var r = 0; r < e.children.length; r++) t.push.apply(t, this.getBoneList(e.children[r]));
      return t;
    }, hi.prototype.update = function () {
      var e = new u(),
        t = new h(),
        r = new h();
      return function () {
        var n = this.geometry,
          i = n.getAttribute("position");
        r.getInverse(this.root.matrixWorld);
        for (var a = 0, o = 0; a < this.bones.length; a++) {
          var s = this.bones[a];
          s.parent && s.parent.isBone && (t.multiplyMatrices(r, s.matrixWorld), e.setFromMatrixPosition(t), i.setXYZ(o, e.x, e.y, e.z), t.multiplyMatrices(r, s.parent.matrixWorld), e.setFromMatrixPosition(t), i.setXYZ(o + 1, e.x, e.y, e.z), o += 2);
        }
        n.getAttribute("position").needsUpdate = !0;
      };
    }(), fi.prototype = Object.create(Ie.prototype), fi.prototype.constructor = fi, fi.prototype.dispose = function () {
      this.geometry.dispose(), this.material.dispose();
    }, fi.prototype.update = function () {
      this.material.color.copy(this.light.color);
    }, di.prototype = Object.create(ue.prototype), di.prototype.constructor = di, di.prototype.dispose = function () {
      this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }, di.prototype.update = function () {
      var e = this.children[0];
      e.material.color.copy(this.light.color);
      var t = .5 * this.light.width,
        r = .5 * this.light.height,
        n = e.geometry.attributes.position,
        i = n.array;
      i[0] = t, i[1] = -r, i[2] = 0, i[3] = t, i[4] = r, i[5] = 0, i[6] = -t, i[7] = r, i[8] = 0, i[9] = -t, i[10] = -r, i[11] = 0, i[12] = t, i[13] = -r, i[14] = 0, n.needsUpdate = !0;
    }, pi.prototype = Object.create(ue.prototype), pi.prototype.constructor = pi, pi.prototype.dispose = function () {
      this.children[0].geometry.dispose(), this.children[0].material.dispose();
    }, pi.prototype.update = function () {
      var e = new u(),
        t = new Y(),
        r = new Y();
      return function () {
        var n = this.children[0],
          i = n.geometry.getAttribute("color");
        t.copy(this.light.color), r.copy(this.light.groundColor);
        for (var a = 0, o = i.count; a < o; a++) {
          var s = a < o / 2 ? t : r;
          i.setXYZ(a, s.r, s.g, s.b);
        }
        n.lookAt(e.setFromMatrixPosition(this.light.matrixWorld).negate()), i.needsUpdate = !0;
      };
    }(), mi.prototype = Object.create(kt.prototype), mi.prototype.constructor = mi, gi.prototype = Object.create(kt.prototype), gi.prototype.constructor = gi, vi.prototype = Object.create(kt.prototype), vi.prototype.constructor = vi, vi.prototype.update = function () {
      var e = new u(),
        t = new u(),
        r = new ne();
      return function () {
        this.object.updateMatrixWorld(!0), r.getNormalMatrix(this.object.matrixWorld);
        for (var n = this.object.matrixWorld, i = this.geometry.attributes.position, a = this.object.geometry, o = a.vertices, s = a.faces, l = 0, c = 0, u = s.length; c < u; c++) {
          var h = s[c],
            f = h.normal;
          e.copy(o[h.a]).add(o[h.b]).add(o[h.c]).divideScalar(3).applyMatrix4(n), t.copy(f).applyMatrix3(r).normalize().multiplyScalar(this.size).add(e), i.setXYZ(l, e.x, e.y, e.z), l += 1, i.setXYZ(l, t.x, t.y, t.z), l += 1;
        }
        i.needsUpdate = !0;
      };
    }(), bi.prototype = Object.create(ue.prototype), bi.prototype.constructor = bi, bi.prototype.dispose = function () {
      var e = this.children[0],
        t = this.children[1];
      e.geometry.dispose(), e.material.dispose(), t.geometry.dispose(), t.material.dispose();
    }, bi.prototype.update = function () {
      var e = new u(),
        t = new u(),
        r = new u();
      return function () {
        e.setFromMatrixPosition(this.light.matrixWorld), t.setFromMatrixPosition(this.light.target.matrixWorld), r.subVectors(t, e);
        var n = this.children[0],
          i = this.children[1];
        n.lookAt(r), n.material.color.copy(this.light.color), i.lookAt(r), i.scale.z = r.length();
      };
    }(), yi.prototype = Object.create(kt.prototype), yi.prototype.constructor = yi, yi.prototype.update = function () {
      function e(e, a, o, s) {
        n.set(a, o, s).unproject(i);
        var l = r[e];
        if (void 0 !== l) for (var c = t.getAttribute("position"), u = 0, h = l.length; u < h; u++) c.setXYZ(l[u], n.x, n.y, n.z);
      }
      var t,
        r,
        n = new u(),
        i = new De();
      return function () {
        t = this.geometry, r = this.pointMap;
        i.projectionMatrix.copy(this.camera.projectionMatrix), e("c", 0, 0, -1), e("t", 0, 0, 1), e("n1", -1, -1, -1), e("n2", 1, -1, -1), e("n3", -1, 1, -1), e("n4", 1, 1, -1), e("f1", -1, -1, 1), e("f2", 1, -1, 1), e("f3", -1, 1, 1), e("f4", 1, 1, 1), e("u1", .7, 1.1, -1), e("u2", -.7, 1.1, -1), e("u3", 0, 2, -1), e("cf1", -1, 0, 1), e("cf2", 1, 0, 1), e("cf3", 0, -1, 1), e("cf4", 0, 1, 1), e("cn1", -1, 0, -1), e("cn2", 1, 0, -1), e("cn3", 0, -1, -1), e("cn4", 0, 1, -1), t.getAttribute("position").needsUpdate = !0;
      };
    }(), wi.prototype = Object.create(kt.prototype), wi.prototype.constructor = wi, wi.prototype.update = function () {
      var e = new te();
      return function (t) {
        if (void 0 !== t && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && e.setFromObject(this.object), !e.isEmpty()) {
          var r = e.min,
            n = e.max,
            i = this.geometry.attributes.position,
            a = i.array;
          a[0] = n.x, a[1] = n.y, a[2] = n.z, a[3] = r.x, a[4] = n.y, a[5] = n.z, a[6] = r.x, a[7] = r.y, a[8] = n.z, a[9] = n.x, a[10] = r.y, a[11] = n.z, a[12] = n.x, a[13] = n.y, a[14] = r.z, a[15] = r.x, a[16] = n.y, a[17] = r.z, a[18] = r.x, a[19] = r.y, a[20] = r.z, a[21] = n.x, a[22] = r.y, a[23] = r.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
        }
      };
    }(), wi.prototype.setFromObject = function (e) {
      return this.object = e, this.update(), this;
    };
    var tl, rl;
    xi.prototype = Object.create(ue.prototype), xi.prototype.constructor = xi, xi.prototype.setDirection = function () {
      var e,
        t = new u();
      return function (r) {
        r.y > .99999 ? this.quaternion.set(0, 0, 0, 1) : r.y < -.99999 ? this.quaternion.set(1, 0, 0, 0) : (t.set(r.z, 0, -r.x).normalize(), e = Math.acos(r.y), this.quaternion.setFromAxisAngle(t, e));
      };
    }(), xi.prototype.setLength = function (e, t, r) {
      void 0 === t && (t = .2 * e), void 0 === r && (r = .2 * t), this.line.scale.set(1, Math.max(0, e - t), 1), this.line.updateMatrix(), this.cone.scale.set(r, t, r), this.cone.position.y = e, this.cone.updateMatrix();
    }, xi.prototype.setColor = function (e) {
      this.line.material.color.copy(e), this.cone.material.color.copy(e);
    }, _i.prototype = Object.create(kt.prototype), _i.prototype.constructor = _i;
    var nl = new u(),
      il = new Si(),
      al = new Si(),
      ol = new Si();
    Ci.prototype = Object.create(Sn.prototype), Ci.prototype.constructor = Ci, Ci.prototype.getPoint = function (e) {
      var t = this.points,
        r = t.length;
      r < 2 && console.log("duh, you need at least 2 points");
      var n = (r - (this.closed ? 0 : 1)) * e,
        i = Math.floor(n),
        a = n - i;
      this.closed ? i += i > 0 ? 0 : (Math.floor(Math.abs(i) / t.length) + 1) * t.length : 0 === a && i === r - 1 && (i = r - 2, a = 1);
      var o, s, l, c;
      if (this.closed || i > 0 ? o = t[(i - 1) % r] : (nl.subVectors(t[0], t[1]).add(t[0]), o = nl), s = t[i % r], l = t[(i + 1) % r], this.closed || i + 2 < r ? c = t[(i + 2) % r] : (nl.subVectors(t[r - 1], t[r - 2]).add(t[r - 1]), c = nl), void 0 === this.type || "centripetal" === this.type || "chordal" === this.type) {
        var h = "chordal" === this.type ? .5 : .25,
          f = Math.pow(o.distanceToSquared(s), h),
          d = Math.pow(s.distanceToSquared(l), h),
          p = Math.pow(l.distanceToSquared(c), h);
        d < 1e-4 && (d = 1), f < 1e-4 && (f = d), p < 1e-4 && (p = d), il.initNonuniformCatmullRom(o.x, s.x, l.x, c.x, f, d, p), al.initNonuniformCatmullRom(o.y, s.y, l.y, c.y, f, d, p), ol.initNonuniformCatmullRom(o.z, s.z, l.z, c.z, f, d, p);
      } else if ("catmullrom" === this.type) {
        var m = void 0 !== this.tension ? this.tension : .5;
        il.initCatmullRom(o.x, s.x, l.x, c.x, m), al.initCatmullRom(o.y, s.y, l.y, c.y, m), ol.initCatmullRom(o.z, s.z, l.z, c.z, m);
      }
      return new u(il.calc(a), al.calc(a), ol.calc(a));
    }, Ei.prototype = Object.create(Sn.prototype), Ei.prototype.constructor = Ei, Ei.prototype.getPoint = function (e) {
      var t = this.v0,
        r = this.v1,
        n = this.v2,
        i = this.v3;
      return new u(_n(e, t.x, r.x, n.x, i.x), _n(e, t.y, r.y, n.y, i.y), _n(e, t.z, r.z, n.z, i.z));
    }, Ai.prototype = Object.create(Sn.prototype), Ai.prototype.constructor = Ai, Ai.prototype.getPoint = function (e) {
      var t = this.v0,
        r = this.v1,
        n = this.v2;
      return new u(vn(e, t.x, r.x, n.x), vn(e, t.y, r.y, n.y), vn(e, t.z, r.z, n.z));
    }, Ti.prototype = Object.create(Sn.prototype), Ti.prototype.constructor = Ti, Ti.prototype.getPoint = function (e) {
      if (1 === e) return this.v2.clone();
      var t = new u();
      return t.subVectors(this.v2, this.v1), t.multiplyScalar(e), t.add(this.v1), t;
    }, ki.prototype = Object.create(An.prototype), ki.prototype.constructor = ki;
    var sl = {
        createMultiMaterialObject: function createMultiMaterialObject(e, t) {
          for (var r = new Ot(), n = 0, i = t.length; n < i; n++) r.add(new Ie(e, t[n]));
          return r;
        },
        detach: function detach(e, t, r) {
          e.applyMatrix(t.matrixWorld), t.remove(e), r.add(e);
        },
        attach: function attach(e, t, r) {
          var n = new h();
          n.getInverse(r.matrixWorld), e.applyMatrix(n), t.remove(e), r.add(e);
        }
      },
      ll = 0,
      cl = 1;
    Sn.create = function (e, t) {
      return console.log("THREE.Curve.create() has been deprecated"), e.prototype = Object.create(Sn.prototype), e.prototype.constructor = e, e.prototype.getPoint = t, e;
    }, Ki.prototype = Object.create(Ci.prototype), Zi.prototype = Object.create(Ci.prototype), Ji.prototype = Object.create(Ci.prototype), Object.assign(Ji.prototype, {
      initFromArray: function initFromArray(e) {
        console.error("THREE.Spline: .initFromArray() has been removed.");
      },
      getControlPointsArray: function getControlPointsArray(e) {
        console.error("THREE.Spline: .getControlPointsArray() has been removed.");
      },
      reparametrizeByArcLength: function reparametrizeByArcLength(e) {
        console.error("THREE.Spline: .reparametrizeByArcLength() has been removed.");
      }
    }), mi.prototype.setColors = function () {
      console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
    }, Object.assign(K.prototype, {
      center: function center(e) {
        return console.warn("THREE.Box2: .center() has been renamed to .getCenter()."), this.getCenter(e);
      },
      empty: function empty() {
        return console.warn("THREE.Box2: .empty() has been renamed to .isEmpty()."), this.isEmpty();
      },
      isIntersectionBox: function isIntersectionBox(e) {
        return console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
      },
      size: function size(e) {
        return console.warn("THREE.Box2: .size() has been renamed to .getSize()."), this.getSize(e);
      }
    }), Object.assign(te.prototype, {
      center: function center(e) {
        return console.warn("THREE.Box3: .center() has been renamed to .getCenter()."), this.getCenter(e);
      },
      empty: function empty() {
        return console.warn("THREE.Box3: .empty() has been renamed to .isEmpty()."), this.isEmpty();
      },
      isIntersectionBox: function isIntersectionBox(e) {
        return console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
      },
      isIntersectionSphere: function isIntersectionSphere(e) {
        return console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(e);
      },
      size: function size(e) {
        return console.warn("THREE.Box3: .size() has been renamed to .getSize()."), this.getSize(e);
      }
    }), he.prototype.center = function (e) {
      return console.warn("THREE.Line3: .center() has been renamed to .getCenter()."), this.getCenter(e);
    }, Ss.random16 = function () {
      return console.warn("THREE.Math.random16() has been deprecated. Use Math.random() instead."), Math.random();
    }, Object.assign(ne.prototype, {
      flattenToArrayOffset: function flattenToArrayOffset(e, t) {
        return console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(e, t);
      },
      multiplyVector3: function multiplyVector3(e) {
        return console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."), e.applyMatrix3(this);
      },
      multiplyVector3Array: function multiplyVector3Array(e) {
        return console.warn("THREE.Matrix3: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead."), this.applyToVector3Array(e);
      },
      applyToBuffer: function applyToBuffer(e, t, r) {
        return console.warn("THREE.Matrix3: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead."), this.applyToBufferAttribute(e);
      },
      applyToVector3Array: function applyToVector3Array(e, t, r) {
        console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
      }
    }), Object.assign(h.prototype, {
      extractPosition: function extractPosition(e) {
        return console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."), this.copyPosition(e);
      },
      flattenToArrayOffset: function flattenToArrayOffset(e, t) {
        return console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."), this.toArray(e, t);
      },
      getPosition: function () {
        var e;
        return function () {
          return void 0 === e && (e = new u()), console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."), e.setFromMatrixColumn(this, 3);
        };
      }(),
      setRotationFromQuaternion: function setRotationFromQuaternion(e) {
        return console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."), this.makeRotationFromQuaternion(e);
      },
      multiplyToArray: function multiplyToArray() {
        console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
      },
      multiplyVector3: function multiplyVector3(e) {
        return console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
      },
      multiplyVector4: function multiplyVector4(e) {
        return console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
      },
      multiplyVector3Array: function multiplyVector3Array(e) {
        return console.warn("THREE.Matrix4: .multiplyVector3Array() has been renamed. Use matrix.applyToVector3Array( array ) instead."), this.applyToVector3Array(e);
      },
      rotateAxis: function rotateAxis(e) {
        console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."), e.transformDirection(this);
      },
      crossVector: function crossVector(e) {
        return console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."), e.applyMatrix4(this);
      },
      translate: function translate() {
        console.error("THREE.Matrix4: .translate() has been removed.");
      },
      rotateX: function rotateX() {
        console.error("THREE.Matrix4: .rotateX() has been removed.");
      },
      rotateY: function rotateY() {
        console.error("THREE.Matrix4: .rotateY() has been removed.");
      },
      rotateZ: function rotateZ() {
        console.error("THREE.Matrix4: .rotateZ() has been removed.");
      },
      rotateByAxis: function rotateByAxis() {
        console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
      },
      applyToBuffer: function applyToBuffer(e, t, r) {
        return console.warn("THREE.Matrix4: .applyToBuffer() has been removed. Use matrix.applyToBufferAttribute( attribute ) instead."), this.applyToBufferAttribute(e);
      },
      applyToVector3Array: function applyToVector3Array(e, t, r) {
        console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
      },
      makeFrustum: function makeFrustum(e, t, r, n, i, a) {
        return console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."), this.makePerspective(e, t, n, r, i, a);
      }
    }), ie.prototype.isIntersectionLine = function (e) {
      return console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."), this.intersectsLine(e);
    }, c.prototype.multiplyVector3 = function (e) {
      return console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."), e.applyQuaternion(this);
    }, Object.assign(se.prototype, {
      isIntersectionBox: function isIntersectionBox(e) {
        return console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."), this.intersectsBox(e);
      },
      isIntersectionPlane: function isIntersectionPlane(e) {
        return console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."), this.intersectsPlane(e);
      },
      isIntersectionSphere: function isIntersectionSphere(e) {
        return console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."), this.intersectsSphere(e);
      }
    }), Object.assign(Mn.prototype, {
      extrude: function extrude(e) {
        return console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."), new rr(this, e);
      },
      makeGeometry: function makeGeometry(e) {
        return console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."), new fr(this, e);
      }
    }), Object.assign(i.prototype, {
      fromAttribute: function fromAttribute(e, t, r) {
        return console.error("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, r);
      }
    }), Object.assign(u.prototype, {
      setEulerFromRotationMatrix: function setEulerFromRotationMatrix() {
        console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
      },
      setEulerFromQuaternion: function setEulerFromQuaternion() {
        console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
      },
      getPositionFromMatrix: function getPositionFromMatrix(e) {
        return console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."), this.setFromMatrixPosition(e);
      },
      getScaleFromMatrix: function getScaleFromMatrix(e) {
        return console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."), this.setFromMatrixScale(e);
      },
      getColumnFromMatrix: function getColumnFromMatrix(e, t) {
        return console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."), this.setFromMatrixColumn(t, e);
      },
      applyProjection: function applyProjection(e) {
        return console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."), this.applyMatrix4(e);
      },
      fromAttribute: function fromAttribute(e, t, r) {
        return console.error("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, r);
      }
    }), Object.assign(o.prototype, {
      fromAttribute: function fromAttribute(e, t, r) {
        return console.error("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."), this.fromBufferAttribute(e, t, r);
      }
    }), ke.prototype.computeTangents = function () {
      console.warn("THREE.Geometry: .computeTangents() has been removed.");
    }, Object.assign(ue.prototype, {
      getChildByName: function getChildByName(e) {
        return console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."), this.getObjectByName(e);
      },
      renderDepth: function renderDepth() {
        console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
      },
      translate: function translate(e, t) {
        return console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."), this.translateOnAxis(t, e);
      }
    }), Object.defineProperties(ue.prototype, {
      eulerOrder: {
        get: function get() {
          return console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order;
        },
        set: function set(e) {
          console.warn("THREE.Object3D: .eulerOrder is now .rotation.order."), this.rotation.order = e;
        }
      },
      useQuaternion: {
        get: function get() {
          console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        },
        set: function set() {
          console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
        }
      }
    }), Object.defineProperties(_t.prototype, {
      objects: {
        get: function get() {
          return console.warn("THREE.LOD: .objects has been renamed to .levels."), this.levels;
        }
      }
    }), Object.defineProperty(St.prototype, "useVertexTexture", {
      get: function get() {
        console.warn("THREE.Skeleton: useVertexTexture has been removed.");
      },
      set: function set() {
        console.warn("THREE.Skeleton: useVertexTexture has been removed.");
      }
    }), Object.defineProperty(Sn.prototype, "__arcLengthDivisions", {
      get: function get() {
        return console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions."), this.arcLengthDivisions;
      },
      set: function set(e) {
        console.warn("THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions."), this.arcLengthDivisions = e;
      }
    }), Le.prototype.setLens = function (e, t) {
      console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."), void 0 !== t && (this.filmGauge = t), this.setFocalLength(e);
    }, Object.defineProperties(Fr.prototype, {
      onlyShadow: {
        set: function set() {
          console.warn("THREE.Light: .onlyShadow has been removed.");
        }
      },
      shadowCameraFov: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov."), this.shadow.camera.fov = e;
        }
      },
      shadowCameraLeft: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left."), this.shadow.camera.left = e;
        }
      },
      shadowCameraRight: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right."), this.shadow.camera.right = e;
        }
      },
      shadowCameraTop: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top."), this.shadow.camera.top = e;
        }
      },
      shadowCameraBottom: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."), this.shadow.camera.bottom = e;
        }
      },
      shadowCameraNear: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near."), this.shadow.camera.near = e;
        }
      },
      shadowCameraFar: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far."), this.shadow.camera.far = e;
        }
      },
      shadowCameraVisible: {
        set: function set() {
          console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
        }
      },
      shadowBias: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowBias is now .shadow.bias."), this.shadow.bias = e;
        }
      },
      shadowDarkness: {
        set: function set() {
          console.warn("THREE.Light: .shadowDarkness has been removed.");
        }
      },
      shadowMapWidth: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."), this.shadow.mapSize.width = e;
        }
      },
      shadowMapHeight: {
        set: function set(e) {
          console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."), this.shadow.mapSize.height = e;
        }
      }
    }), Object.defineProperties(me.prototype, {
      length: {
        get: function get() {
          return console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead."), this.array.length;
        }
      }
    }), Object.assign(Re.prototype, {
      addIndex: function addIndex(e) {
        console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."), this.setIndex(e);
      },
      addDrawCall: function addDrawCall(e, t, r) {
        void 0 !== r && console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."), console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup()."), this.addGroup(e, t);
      },
      clearDrawCalls: function clearDrawCalls() {
        console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."), this.clearGroups();
      },
      computeTangents: function computeTangents() {
        console.warn("THREE.BufferGeometry: .computeTangents() has been removed.");
      },
      computeOffsets: function computeOffsets() {
        console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
      }
    }), Object.defineProperties(Re.prototype, {
      drawcalls: {
        get: function get() {
          return console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups."), this.groups;
        }
      },
      offsets: {
        get: function get() {
          return console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups."), this.groups;
        }
      }
    }), Object.defineProperties(Kn.prototype, {
      dynamic: {
        set: function set() {
          console.warn("THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.");
        }
      },
      onUpdate: {
        value: function value() {
          return console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead."), this;
        }
      }
    }), Object.defineProperties(Q.prototype, {
      wrapAround: {
        get: function get() {
          console.warn("THREE.Material: .wrapAround has been removed.");
        },
        set: function set() {
          console.warn("THREE.Material: .wrapAround has been removed.");
        }
      },
      wrapRGB: {
        get: function get() {
          return console.warn("THREE.Material: .wrapRGB has been removed."), new Y();
        }
      }
    }), Object.defineProperties(Er.prototype, {
      metal: {
        get: function get() {
          return console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead."), !1;
        },
        set: function set() {
          console.warn("THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead");
        }
      }
    }), Object.defineProperties($.prototype, {
      derivatives: {
        get: function get() {
          return console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives;
        },
        set: function set(e) {
          console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."), this.extensions.derivatives = e;
        }
      }
    }), Object.assign(mt.prototype, {
      getCurrentRenderTarget: function getCurrentRenderTarget() {
        return console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."), this.getRenderTarget();
      },
      supportsFloatTextures: function supportsFloatTextures() {
        return console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."), this.extensions.get("OES_texture_float");
      },
      supportsHalfFloatTextures: function supportsHalfFloatTextures() {
        return console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."), this.extensions.get("OES_texture_half_float");
      },
      supportsStandardDerivatives: function supportsStandardDerivatives() {
        return console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."), this.extensions.get("OES_standard_derivatives");
      },
      supportsCompressedTextureS3TC: function supportsCompressedTextureS3TC() {
        return console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."), this.extensions.get("WEBGL_compressed_texture_s3tc");
      },
      supportsCompressedTexturePVRTC: function supportsCompressedTexturePVRTC() {
        return console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."), this.extensions.get("WEBGL_compressed_texture_pvrtc");
      },
      supportsBlendMinMax: function supportsBlendMinMax() {
        return console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."), this.extensions.get("EXT_blend_minmax");
      },
      supportsVertexTextures: function supportsVertexTextures() {
        return console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."), this.capabilities.vertexTextures;
      },
      supportsInstancedArrays: function supportsInstancedArrays() {
        return console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."), this.extensions.get("ANGLE_instanced_arrays");
      },
      enableScissorTest: function enableScissorTest(e) {
        console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."), this.setScissorTest(e);
      },
      initMaterial: function initMaterial() {
        console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
      },
      addPrePlugin: function addPrePlugin() {
        console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
      },
      addPostPlugin: function addPostPlugin() {
        console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
      },
      updateShadowMap: function updateShadowMap() {
        console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
      }
    }), Object.defineProperties(mt.prototype, {
      shadowMapEnabled: {
        get: function get() {
          return this.shadowMap.enabled;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."), this.shadowMap.enabled = e;
        }
      },
      shadowMapType: {
        get: function get() {
          return this.shadowMap.type;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."), this.shadowMap.type = e;
        }
      },
      shadowMapCullFace: {
        get: function get() {
          return this.shadowMap.cullFace;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderer: .shadowMapCullFace is now .shadowMap.cullFace."), this.shadowMap.cullFace = e;
        }
      }
    }), Object.defineProperties(oe.prototype, {
      cullFace: {
        get: function get() {
          return this.renderReverseSided ? ca : la;
        },
        set: function set(e) {
          var t = e !== la;
          console.warn("WebGLRenderer: .shadowMap.cullFace is deprecated. Set .shadowMap.renderReverseSided to " + t + "."), this.renderReverseSided = t;
        }
      }
    }), Object.defineProperties(s.prototype, {
      wrapS: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."), this.texture.wrapS = e;
        }
      },
      wrapT: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."), this.texture.wrapT = e;
        }
      },
      magFilter: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."), this.texture.magFilter = e;
        }
      },
      minFilter: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."), this.texture.minFilter = e;
        }
      },
      anisotropy: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."), this.texture.anisotropy = e;
        }
      },
      offset: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset."), this.texture.offset = e;
        }
      },
      repeat: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat."), this.texture.repeat = e;
        }
      },
      format: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .format is now .texture.format."), this.texture.format = e;
        }
      },
      type: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .type is now .texture.type."), this.texture.type = e;
        }
      },
      generateMipmaps: {
        get: function get() {
          return console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps;
        },
        set: function set(e) {
          console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."), this.texture.generateMipmaps = e;
        }
      }
    }), jn.prototype.load = function (e) {
      console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
      var t = this;
      return new Dn().load(e, function (e) {
        t.setBuffer(e);
      }), this;
    }, Hn.prototype.getData = function () {
      return console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData()."), this.getFrequencyData();
    };
    var ul = {
        merge: function merge(e, t, r) {
          console.warn("THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.");
          var n;
          t.isMesh && (t.matrixAutoUpdate && t.updateMatrix(), n = t.matrix, t = t.geometry), e.merge(t, n, r);
        },
        center: function center(e) {
          return console.warn("THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead."), e.center();
        }
      },
      hl = {
        crossOrigin: void 0,
        loadTexture: function loadTexture(e, t, r, n) {
          console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
          var i = new Lr();
          i.setCrossOrigin(this.crossOrigin);
          var a = i.load(e, r, void 0, n);
          return t && (a.mapping = t), a;
        },
        loadTextureCube: function loadTextureCube(e, t, r, n) {
          console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
          var i = new Dr();
          i.setCrossOrigin(this.crossOrigin);
          var a = i.load(e, r, void 0, n);
          return t && (a.mapping = t), a;
        },
        loadCompressedTexture: function loadCompressedTexture() {
          console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
        },
        loadCompressedTextureCube: function loadCompressedTextureCube() {
          console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
        }
      };
  }, function (e, t, r) {
    (function (e) {
      function n(e, t) {
        this._id = e, this._clearFn = t;
      }
      var i = void 0 !== e && e || "undefined" != typeof self && self || window,
        a = Function.prototype.apply;
      t.setTimeout = function () {
        return new n(a.call(setTimeout, i, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new n(a.call(setInterval, i, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, n.prototype.unref = n.prototype.ref = function () {}, n.prototype.close = function () {
        this._clearFn.call(i, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, r(354), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(t, r(13));
  }, function (e, t, r) {
    (function (e, n) {
      function i(e, r) {
        var n = {
          seen: [],
          stylize: o
        };
        return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), m(r) ? n.showHidden = r : r && t._extend(n, r), x(n.showHidden) && (n.showHidden = !1), x(n.depth) && (n.depth = 2), x(n.colors) && (n.colors = !1), x(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = a), l(n, e, n.depth);
      }
      function a(e, t) {
        var r = i.styles[t];
        return r ? "[" + i.colors[r][0] + "m" + e + "[" + i.colors[r][1] + "m" : e;
      }
      function o(e, t) {
        return e;
      }
      function s(e) {
        var t = {};
        return e.forEach(function (e, r) {
          t[e] = !0;
        }), t;
      }
      function l(e, r, n) {
        if (e.customInspect && r && A(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
          var i = r.inspect(n, e);
          return y(i) || (i = l(e, i, n)), i;
        }
        var a = c(e, r);
        if (a) return a;
        var o = Object.keys(r),
          m = s(o);
        if (e.showHidden && (o = Object.getOwnPropertyNames(r)), E(r) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return u(r);
        if (0 === o.length) {
          if (A(r)) {
            var g = r.name ? ": " + r.name : "";
            return e.stylize("[Function" + g + "]", "special");
          }
          if (_(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
          if (C(r)) return e.stylize(Date.prototype.toString.call(r), "date");
          if (E(r)) return u(r);
        }
        var v = "",
          b = !1,
          w = ["{", "}"];
        if (p(r) && (b = !0, w = ["[", "]"]), A(r)) {
          v = " [Function" + (r.name ? ": " + r.name : "") + "]";
        }
        if (_(r) && (v = " " + RegExp.prototype.toString.call(r)), C(r) && (v = " " + Date.prototype.toUTCString.call(r)), E(r) && (v = " " + u(r)), 0 === o.length && (!b || 0 == r.length)) return w[0] + v + w[1];
        if (n < 0) return _(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special");
        e.seen.push(r);
        var x;
        return x = b ? h(e, r, n, m, o) : o.map(function (t) {
          return f(e, r, n, m, t, b);
        }), e.seen.pop(), d(x, v, w);
      }
      function c(e, t) {
        if (x(t)) return e.stylize("undefined", "undefined");
        if (y(t)) {
          var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(r, "string");
        }
        return b(t) ? e.stylize("" + t, "number") : m(t) ? e.stylize("" + t, "boolean") : g(t) ? e.stylize("null", "null") : void 0;
      }
      function u(e) {
        return "[" + Error.prototype.toString.call(e) + "]";
      }
      function h(e, t, r, n, i) {
        for (var a = [], o = 0, s = t.length; o < s; ++o) M(t, String(o)) ? a.push(f(e, t, r, n, String(o), !0)) : a.push("");
        return i.forEach(function (i) {
          i.match(/^\d+$/) || a.push(f(e, t, r, n, i, !0));
        }), a;
      }
      function f(e, t, r, n, i, a) {
        var o, s, c;
        if (c = Object.getOwnPropertyDescriptor(t, i) || {
          value: t[i]
        }, c.get ? s = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), M(n, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(c.value) < 0 ? (s = g(r) ? l(e, c.value, null) : l(e, c.value, r - 1), s.indexOf("\n") > -1 && (s = a ? s.split("\n").map(function (e) {
          return "  " + e;
        }).join("\n").substr(2) : "\n" + s.split("\n").map(function (e) {
          return "   " + e;
        }).join("\n"))) : s = e.stylize("[Circular]", "special")), x(o)) {
          if (a && i.match(/^\d+$/)) return s;
          o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
        }
        return o + ": " + s;
      }
      function d(e, t, r) {
        var n = 0;
        return e.reduce(function (e, t) {
          return n++, t.indexOf("\n") >= 0 && n++, e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60 ? r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
      }
      function p(e) {
        return Array.isArray(e);
      }
      function m(e) {
        return "boolean" == typeof e;
      }
      function g(e) {
        return null === e;
      }
      function v(e) {
        return null == e;
      }
      function b(e) {
        return "number" == typeof e;
      }
      function y(e) {
        return "string" == typeof e;
      }
      function w(e) {
        return "symbol" == _typeof(e);
      }
      function x(e) {
        return void 0 === e;
      }
      function _(e) {
        return S(e) && "[object RegExp]" === k(e);
      }
      function S(e) {
        return "object" == _typeof(e) && null !== e;
      }
      function C(e) {
        return S(e) && "[object Date]" === k(e);
      }
      function E(e) {
        return S(e) && ("[object Error]" === k(e) || e instanceof Error);
      }
      function A(e) {
        return "function" == typeof e;
      }
      function T(e) {
        return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == _typeof(e) || void 0 === e;
      }
      function k(e) {
        return Object.prototype.toString.call(e);
      }
      function R(e) {
        return e < 10 ? "0" + e.toString(10) : e.toString(10);
      }
      function I() {
        var e = new Date(),
          t = [R(e.getHours()), R(e.getMinutes()), R(e.getSeconds())].join(":");
        return [e.getDate(), D[e.getMonth()], t].join(" ");
      }
      function M(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      var O = /%[sdj%]/g;
      t.format = function (e) {
        if (!y(e)) {
          for (var t = [], r = 0; r < arguments.length; r++) t.push(i(arguments[r]));
          return t.join(" ");
        }
        for (var r = 1, n = arguments, a = n.length, o = String(e).replace(O, function (e) {
            if ("%%" === e) return "%";
            if (r >= a) return e;
            switch (e) {
              case "%s":
                return String(n[r++]);
              case "%d":
                return Number(n[r++]);
              case "%j":
                try {
                  return JSON.stringify(n[r++]);
                } catch (e) {
                  return "[Circular]";
                }
              default:
                return e;
            }
          }), s = n[r]; r < a; s = n[++r]) g(s) || !S(s) ? o += " " + s : o += " " + i(s);
        return o;
      }, t.deprecate = function (r, i) {
        function a() {
          if (!o) {
            if (n.throwDeprecation) throw new Error(i);
            n.traceDeprecation ? console.trace(i) : console.error(i), o = !0;
          }
          return r.apply(this, arguments);
        }
        if (x(e.process)) return function () {
          return t.deprecate(r, i).apply(this, arguments);
        };
        if (!0 === n.noDeprecation) return r;
        var o = !1;
        return a;
      };
      var P,
        B = {};
      t.debuglog = function (e) {
        if (x(P) && (P = n.env.NODE_DEBUG || ""), e = e.toUpperCase(), !B[e]) if (new RegExp("\\b" + e + "\\b", "i").test(P)) {
          var r = n.pid;
          B[e] = function () {
            var n = t.format.apply(t, arguments);
            console.error("%s %d: %s", e, r, n);
          };
        } else B[e] = function () {};
        return B[e];
      }, t.inspect = i, i.colors = {
        bold: [1, 22],
        italic: [3, 23],
        underline: [4, 24],
        inverse: [7, 27],
        white: [37, 39],
        grey: [90, 39],
        black: [30, 39],
        blue: [34, 39],
        cyan: [36, 39],
        green: [32, 39],
        magenta: [35, 39],
        red: [31, 39],
        yellow: [33, 39]
      }, i.styles = {
        special: "cyan",
        number: "yellow",
        boolean: "yellow",
        undefined: "grey",
        null: "bold",
        string: "green",
        date: "magenta",
        regexp: "red"
      }, t.isArray = p, t.isBoolean = m, t.isNull = g, t.isNullOrUndefined = v, t.isNumber = b, t.isString = y, t.isSymbol = w, t.isUndefined = x, t.isRegExp = _, t.isObject = S, t.isDate = C, t.isError = E, t.isFunction = A, t.isPrimitive = T, t.isBuffer = r(372);
      var D = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      t.log = function () {
        console.log("%s - %s", I(), t.format.apply(t, arguments));
      }, t.inherits = r(28), t._extend = function (e, t) {
        if (!t || !S(t)) return e;
        for (var r = Object.keys(t), n = r.length; n--;) e[r[n]] = t[r[n]];
        return e;
      };
    }).call(t, r(13), r(5));
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i = function i(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) a.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        a = {}.hasOwnProperty;
      n = r(4), t = r(40), e.exports = function (e) {
        function t(e, r) {
          if (t.__super__.constructor.call(this, e), null == r) throw new Error("Missing CDATA text");
          this.text = this.stringify.cdata(r);
        }
        return i(t, e), t.prototype.clone = function () {
          return n(t.prototype, this);
        }, t.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<![CDATA[" + this.text + "]]>", a && (o += n), o;
        }, t;
      }(t);
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i = function i(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) a.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        a = {}.hasOwnProperty;
      n = r(4), t = r(40), e.exports = function (e) {
        function t(e, r) {
          if (t.__super__.constructor.call(this, e), null == r) throw new Error("Missing comment text");
          this.text = this.stringify.comment(r);
        }
        return i(t, e), t.prototype.clone = function () {
          return n(t.prototype, this);
        }, t.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "\x3c!-- " + this.text + " --\x3e", a && (o += n), o;
        }, t;
      }(t);
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i,
        a = function a(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) o.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        o = {}.hasOwnProperty;
      n = r(4), i = r(3), t = r(40), e.exports = function (e) {
        function t(e, r, n, a) {
          var o;
          t.__super__.constructor.call(this, e), i(r) && (o = r, r = o.version, n = o.encoding, a = o.standalone), r || (r = "1.0"), null != r && (this.version = this.stringify.xmlVersion(r)), null != n && (this.encoding = this.stringify.xmlEncoding(n)), null != a && (this.standalone = this.stringify.xmlStandalone(a));
        }
        return a(t, e), t.prototype.clone = function () {
          return n(t.prototype, this);
        }, t.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<?xml", null != this.version && (o += ' version="' + this.version + '"'), null != this.encoding && (o += ' encoding="' + this.encoding + '"'), null != this.standalone && (o += ' standalone="' + this.standalone + '"'), o += "?>", a && (o += n), o;
        }, t;
      }(t);
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t, n, i, a, o, s, l, c, u;
      c = r(4), u = r(3), t = r(143), n = r(144), i = r(378), o = r(380), a = r(379), s = r(381), l = r(148), e.exports = function () {
        function e(e, t, r) {
          var n, i;
          this.documentObject = e, this.stringify = this.documentObject.stringify, this.children = [], u(t) && (n = t, t = n.pubID, r = n.sysID), null == r && (i = [t, r], r = i[0], t = i[1]), null != t && (this.pubID = this.stringify.dtdPubID(t)), null != r && (this.sysID = this.stringify.dtdSysID(r));
        }
        return e.prototype.clone = function () {
          return c(e.prototype, this);
        }, e.prototype.element = function (e, t) {
          var r;
          return r = new a(this, e, t), this.children.push(r), this;
        }, e.prototype.attList = function (e, t, r, n, a) {
          var o;
          return o = new i(this, e, t, r, n, a), this.children.push(o), this;
        }, e.prototype.entity = function (e, t) {
          var r;
          return r = new o(this, !1, e, t), this.children.push(r), this;
        }, e.prototype.pEntity = function (e, t) {
          var r;
          return r = new o(this, !0, e, t), this.children.push(r), this;
        }, e.prototype.notation = function (e, t) {
          var r;
          return r = new s(this, e, t), this.children.push(r), this;
        }, e.prototype.cdata = function (e) {
          var r;
          return r = new t(this, e), this.children.push(r), this;
        }, e.prototype.comment = function (e) {
          var t;
          return t = new n(this, e), this.children.push(t), this;
        }, e.prototype.instruction = function (e, t) {
          var r;
          return r = new l(this, e, t), this.children.push(r), this;
        }, e.prototype.root = function () {
          return this.documentObject.root();
        }, e.prototype.document = function () {
          return this.documentObject;
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u, h, f, d, p;
          if (l = (null != e ? e.pretty : void 0) || !1, i = null != (u = null != e ? e.indent : void 0) ? u : "  ", s = null != (h = null != e ? e.offset : void 0) ? h : 0, o = null != (f = null != e ? e.newline : void 0) ? f : "\n", t || (t = 0), p = new Array(t + s + 1).join(i), c = "", l && (c += p), c += "<!DOCTYPE " + this.root().name, this.pubID && this.sysID ? c += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"' : this.sysID && (c += ' SYSTEM "' + this.sysID + '"'), this.children.length > 0) {
            for (c += " [", l && (c += o), d = this.children, n = 0, a = d.length; n < a; n++) r = d[n], c += r.toString(e, t + 1);
            c += "]";
          }
          return c += ">", l && (c += o), c;
        }, e.prototype.ele = function (e, t) {
          return this.element(e, t);
        }, e.prototype.att = function (e, t, r, n, i) {
          return this.attList(e, t, r, n, i);
        }, e.prototype.ent = function (e, t) {
          return this.entity(e, t);
        }, e.prototype.pent = function (e, t) {
          return this.pEntity(e, t);
        }, e.prototype.not = function (e, t) {
          return this.notation(e, t);
        }, e.prototype.dat = function (e) {
          return this.cdata(e);
        }, e.prototype.com = function (e) {
          return this.comment(e);
        }, e.prototype.ins = function (e, t) {
          return this.instruction(e, t);
        }, e.prototype.up = function () {
          return this.root();
        }, e.prototype.doc = function () {
          return this.document();
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i,
        a,
        o,
        s,
        l,
        c = function c(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) u.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        u = {}.hasOwnProperty;
      a = r(4), l = r(3), s = r(53), o = r(264), n = r(40), t = r(376), i = r(148), e.exports = function (e) {
        function r(e, t, n) {
          if (r.__super__.constructor.call(this, e), null == t) throw new Error("Missing element name");
          this.name = this.stringify.eleName(t), this.children = [], this.instructions = [], this.attributes = {}, null != n && this.attribute(n);
        }
        return c(r, e), r.prototype.clone = function () {
          var e, t, n, i, o, s, l, c;
          n = a(r.prototype, this), n.isRoot && (n.documentObject = null), n.attributes = {}, l = this.attributes;
          for (t in l) u.call(l, t) && (e = l[t], n.attributes[t] = e.clone());
          for (n.instructions = [], c = this.instructions, i = 0, o = c.length; i < o; i++) s = c[i], n.instructions.push(s.clone());
          return n.children = [], this.children.forEach(function (e) {
            var t;
            return t = e.clone(), t.parent = n, n.children.push(t);
          }), n;
        }, r.prototype.attribute = function (e, r) {
          var n, i;
          if (null != e && (e = e.valueOf()), l(e)) for (n in e) u.call(e, n) && (i = e[n], this.attribute(n, i));else s(r) && (r = r.apply()), this.options.skipNullAttributes && null == r || (this.attributes[e] = new t(this, e, r));
          return this;
        }, r.prototype.removeAttribute = function (e) {
          var t, r, n;
          if (null == e) throw new Error("Missing attribute name");
          if (e = e.valueOf(), Array.isArray(e)) for (r = 0, n = e.length; r < n; r++) t = e[r], delete this.attributes[t];else delete this.attributes[e];
          return this;
        }, r.prototype.instruction = function (e, t) {
          var r, n, a, o, c;
          if (null != e && (e = e.valueOf()), null != t && (t = t.valueOf()), Array.isArray(e)) for (r = 0, c = e.length; r < c; r++) n = e[r], this.instruction(n);else if (l(e)) for (n in e) u.call(e, n) && (a = e[n], this.instruction(n, a));else s(t) && (t = t.apply()), o = new i(this, e, t), this.instructions.push(o);
          return this;
        }, r.prototype.toString = function (e, t) {
          var r, n, i, a, s, l, c, h, f, d, p, m, g, v, b, y, w, x, _, S;
          for (m = (null != e ? e.pretty : void 0) || !1, a = null != (v = null != e ? e.indent : void 0) ? v : "  ", p = null != (b = null != e ? e.offset : void 0) ? b : 0, d = null != (y = null != e ? e.newline : void 0) ? y : "\n", t || (t = 0), S = new Array(t + p + 1).join(a), g = "", w = this.instructions, i = 0, c = w.length; i < c; i++) s = w[i], g += s.toString(e, t);
          m && (g += S), g += "<" + this.name, x = this.attributes;
          for (f in x) u.call(x, f) && (r = x[f], g += r.toString(e));
          if (0 === this.children.length || o(this.children, function (e) {
            return "" === e.value;
          })) g += "/>", m && (g += d);else if (m && 1 === this.children.length && null != this.children[0].value) g += ">", g += this.children[0].value, g += "</" + this.name + ">", g += d;else {
            for (g += ">", m && (g += d), _ = this.children, l = 0, h = _.length; l < h; l++) n = _[l], g += n.toString(e, t + 1);
            m && (g += S), g += "</" + this.name + ">", m && (g += d);
          }
          return g;
        }, r.prototype.att = function (e, t) {
          return this.attribute(e, t);
        }, r.prototype.ins = function (e, t) {
          return this.instruction(e, t);
        }, r.prototype.a = function (e, t) {
          return this.attribute(e, t);
        }, r.prototype.i = function (e, t) {
          return this.instruction(e, t);
        }, r;
      }(n);
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t;
      t = r(4), e.exports = function () {
        function e(e, t, r) {
          if (this.stringify = e.stringify, null == t) throw new Error("Missing instruction target");
          this.target = this.stringify.insTarget(t), r && (this.value = this.stringify.insValue(r));
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<?", o += this.target, this.value && (o += " " + this.value), o += "?>", a && (o += n), o;
        }, e;
      }();
    }).call(this);
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(46),
      a = n(i),
      o = r(58),
      s = n(o),
      l = r(6),
      c = n(l),
      u = r(7),
      h = n(u),
      f = r(8),
      d = n(f),
      p = r(10),
      m = n(p),
      g = r(9),
      v = n(g),
      b = r(2),
      y = n(b),
      w = r(348),
      x = n(w);
    r(366);
    var _ = r(161),
      S = n(_),
      C = r(154),
      E = function (e) {
        function t(e) {
          (0, h.default)(this, t);
          var r = (0, m.default)(this, (t.__proto__ || (0, c.default)(t)).call(this, e));
          return r.state = {
            loading: !0
          }, r;
        }
        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = document.getElementById("pg-viewer"),
              t = e ? e.clientHeight : 0,
              r = e ? e.clientWidth : 0;
            this.setState({
              height: t,
              width: r
            });
          }
        }, {
          key: "getDriver",
          value: function value() {
            switch (this.props.fileType) {
              case "csv":
                return (0, S.default)(C.CsvViewer, this.props);
              case "xlsx":
                var e = (0, s.default)({}, this.props, {
                  responseType: "arraybuffer"
                });
                return (0, S.default)(C.XlsxViewer, e);
              case "jpg":
              case "jpeg":
              case "gif":
              case "bmp":
              case "png":
                return C.PhotoViewerWrapper;
              case "pdf":
                return C.PDFViewer;
              case "docx":
                return C.DocxViewer;
              case "mp3":
                return C.AudioViewer;
              case "webm":
              case "mp4":
                return C.VideoViewer;
              case "wexbim":
                return C.XBimViewer;
              default:
                return C.UnsupportedViewer;
            }
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.getDriver(this.props);
            return y.default.createElement("div", {
              className: "pg-viewer-wrapper"
            }, y.default.createElement("div", {
              className: "pg-viewer",
              id: "pg-viewer"
            }, y.default.createElement(e, (0, a.default)({}, this.props, {
              width: this.state.width,
              height: this.state.height
            }))));
          }
        }]), t;
      }(b.Component);
    E.propTypes = {
      fileType: x.default.string.isRequired,
      filePath: x.default.string.isRequired,
      onError: x.default.func,
      errorComponent: x.default.element,
      unsupportedComponent: x.default.element
    }, E.defaultProps = {
      onError: function onError() {
        return null;
      },
      errorComponent: null,
      unsupportedComponent: null
    }, t.default = E, e.exports = E;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p);
    r(139);
    var g = r(41),
      v = n(g),
      b = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var r = (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
          return r.state = {
            loading: !0
          }, r;
        }
        return (0, d.default)(t, e), (0, c.default)(t, [{
          key: "onCanPlay",
          value: function value() {
            this.setState({
              loading: !1
            });
          }
        }, {
          key: "renderLoading",
          value: function value() {
            return this.state.loading ? m.default.createElement(v.default, null) : null;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.state.loading ? "hidden" : "visible";
            return m.default.createElement("div", {
              className: "pg-driver-view"
            }, m.default.createElement("div", {
              className: "video-container"
            }, this.renderLoading(), m.default.createElement("audio", {
              style: {
                visibility: t
              },
              controls: !0,
              onCanPlay: function onCanPlay(t) {
                return e.onCanPlay(t);
              },
              src: this.props.filePath
            }, "Video playback is not supported by your browser.")));
          }
        }]), t;
      }(p.Component);
    t.default = b;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p),
      g = r(321),
      v = n(g);
    r(363);
    var b = r(41),
      y = n(b),
      w = function (e) {
        function t() {
          return (0, s.default)(this, t), (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).apply(this, arguments));
        }
        return (0, d.default)(t, e), (0, c.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = new XMLHttpRequest();
            e.open("GET", this.props.filePath, !0), e.send(), e.responseType = "arraybuffer", e.onreadystatechange = function () {
              4 === e.readyState && 200 === e.status && v.default.convertToHtml({
                arrayBuffer: e.response
              }, {
                includeDefaultStyleMap: !0
              }).then(function (e) {
                var t = document.createElement("div");
                t.className = "document-container", t.innerHTML = e.value, document.getElementById("docx").innerHTML = t.outerHTML;
              }).catch(function (e) {
                console.log("alexei: something went wrong", e);
              }).done();
            };
          }
        }, {
          key: "render",
          value: function value() {
            return m.default.createElement("div", {
              id: "docx"
            }, m.default.createElement(y.default, null));
          }
        }]), t;
      }(p.Component);
    t.default = w;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(85);
    Object.defineProperty(t, "CsvViewer", {
      enumerable: !0,
      get: function get() {
        return n(i).default;
      }
    });
    var a = r(87);
    Object.defineProperty(t, "Photo360Viewer", {
      enumerable: !0,
      get: function get() {
        return n(a).default;
      }
    });
    var o = r(155);
    Object.defineProperty(t, "PDFViewer", {
      enumerable: !0,
      get: function get() {
        return n(o).default;
      }
    });
    var s = r(153);
    Object.defineProperty(t, "DocxViewer", {
      enumerable: !0,
      get: function get() {
        return n(s).default;
      }
    });
    var l = r(158);
    Object.defineProperty(t, "VideoViewer", {
      enumerable: !0,
      get: function get() {
        return n(l).default;
      }
    });
    var c = r(160);
    Object.defineProperty(t, "XlsxViewer", {
      enumerable: !0,
      get: function get() {
        return n(c).default;
      }
    });
    var u = r(159);
    Object.defineProperty(t, "XBimViewer", {
      enumerable: !0,
      get: function get() {
        return n(u).default;
      }
    });
    var h = r(157);
    Object.defineProperty(t, "UnsupportedViewer", {
      enumerable: !0,
      get: function get() {
        return n(h).default;
      }
    });
    var f = r(86);
    Object.defineProperty(t, "PhotoViewer", {
      enumerable: !0,
      get: function get() {
        return n(f).default;
      }
    });
    var d = r(156);
    Object.defineProperty(t, "PhotoViewerWrapper", {
      enumerable: !0,
      get: function get() {
        return n(d).default;
      }
    });
    var p = r(152);
    Object.defineProperty(t, "AudioViewer", {
      enumerable: !0,
      get: function get() {
        return n(p).default;
      }
    });
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PDFPage = void 0;
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p),
      g = r(352),
      v = n(g),
      b = r(345);
    r(346), b.PDFJS.disableWorker = !0;
    var y = t.PDFPage = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var r = (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
          return r.state = {}, r.onChange = r.onChange.bind(r), r;
        }
        return (0, d.default)(t, e), (0, c.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            this.props.disableVisibilityCheck && this.fetchAndRenderPage();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e, t) {
            if (this.props.disableVisibilityCheck) return void (e.zoom !== this.props.zoom && this.fetchAndRenderPage());
            t.isVisible === this.state.isVisible && e.zoom === this.props.zoom || this.state.isVisible && this.fetchAndRenderPage();
          }
        }, {
          key: "onChange",
          value: function value(e) {
            e && this.setState({
              isVisible: e
            });
          }
        }, {
          key: "fetchAndRenderPage",
          value: function value() {
            var e = this.props,
              t = e.pdf,
              r = e.index;
            t.getPage(r).then(this.renderPage.bind(this));
          }
        }, {
          key: "renderPage",
          value: function value(e) {
            var t = this.props,
              r = t.containerWidth,
              n = t.zoom,
              i = r / e.getViewport(1.1).width,
              a = i > 1.1 ? 1.1 : i,
              o = e.getViewport(a + n),
              s = o.width,
              l = o.height,
              c = this.canvas.getContext("2d");
            this.canvas.width = s, this.canvas.height = l, e.render({
              canvasContext: c,
              viewport: o
            });
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props.index;
            return m.default.createElement("div", {
              key: "page-" + t,
              className: "pdf-canvas"
            }, this.props.disableVisibilityCheck ? m.default.createElement("canvas", {
              ref: function ref(t) {
                return e.canvas = t;
              },
              width: "670",
              height: "870"
            }) : m.default.createElement(v.default, {
              onChange: this.onChange,
              partialVisibility: !0
            }, m.default.createElement("canvas", {
              ref: function ref(t) {
                return e.canvas = t;
              },
              width: "670",
              height: "870"
            })));
          }
        }]), t;
      }(m.default.Component),
      w = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var r = (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
          return r.state = {
            pdf: null,
            zoom: 0,
            percent: 0
          }, r.increaseZoom = r.increaseZoom.bind(r), r.reduceZoom = r.reduceZoom.bind(r), r.resetZoom = r.resetZoom.bind(r), r;
        }
        return (0, d.default)(t, e), (0, c.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this,
              t = this.props.filePath,
              r = this.container.offsetWidth;
            b.PDFJS.getDocument(t, null, null, this.progressCallback.bind(this)).then(function (t) {
              e.setState({
                pdf: t,
                containerWidth: r
              });
            });
          }
        }, {
          key: "setZoom",
          value: function value(e) {
            this.setState({
              zoom: e
            });
          }
        }, {
          key: "progressCallback",
          value: function value(e) {
            var t = (e.loaded / e.total * 100).toFixed();
            this.setState({
              percent: t
            });
          }
        }, {
          key: "reduceZoom",
          value: function value() {
            0 !== this.state.zoom && this.setZoom(this.state.zoom - 1);
          }
        }, {
          key: "increaseZoom",
          value: function value() {
            this.setZoom(this.state.zoom + 1);
          }
        }, {
          key: "resetZoom",
          value: function value() {
            this.setZoom(0);
          }
        }, {
          key: "renderPages",
          value: function value() {
            var e = this,
              t = this.state,
              r = t.pdf,
              n = t.containerWidth,
              i = t.zoom;
            return r ? Array.apply(null, {
              length: r.numPages
            }).map(function (t, a) {
              return m.default.createElement(y, {
                index: a + 1,
                pdf: r,
                containerWidth: n,
                zoom: .2 * i,
                disableVisibilityCheck: e.props.disableVisibilityCheck
              });
            }) : null;
          }
        }, {
          key: "renderLoading",
          value: function value() {
            return this.state.pdf ? null : m.default.createElement("div", {
              className: "pdf-loading"
            }, "LOADING (", this.state.percent, "%)");
          }
        }, {
          key: "render",
          value: function value() {
            var e = this;
            return m.default.createElement("div", {
              className: "pdf-viewer-container"
            }, m.default.createElement("div", {
              className: "pdf-viewer",
              ref: function ref(t) {
                return e.container = t;
              }
            }, m.default.createElement("div", {
              className: "pdf-controlls-container"
            }, m.default.createElement("div", {
              className: "view-control",
              onClick: this.increaseZoom
            }, m.default.createElement("i", {
              className: "zoom-in"
            })), m.default.createElement("div", {
              className: "view-control",
              onClick: this.resetZoom
            }, m.default.createElement("i", {
              className: "zoom-reset"
            })), m.default.createElement("div", {
              className: "view-control",
              onClick: this.reduceZoom
            }, m.default.createElement("i", {
              className: "zoom-out"
            }))), this.renderLoading(), this.renderPages()));
          }
        }]), t;
      }(m.default.Component);
    t.default = w, w.defaultProps = {
      disableVisibilityCheck: !1
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t, r) {
      return "jpg" === r && window.Math.abs(e / t - 2) <= .01 ? C.default : _.default;
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = r(46),
      o = n(a),
      s = r(6),
      l = n(s),
      c = r(7),
      u = n(c),
      h = r(8),
      f = n(h),
      d = r(10),
      p = n(d),
      m = r(9),
      g = n(m),
      v = r(2),
      b = n(v),
      y = r(140),
      w = function (e) {
        if (e && e.__esModule) return e;
        var t = {};
        if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t.default = e, t;
      }(y),
      x = r(86),
      _ = n(x),
      S = r(87),
      C = n(S),
      E = r(41),
      A = n(E),
      T = function (e) {
        function t(e) {
          (0, u.default)(this, t);
          var r = (0, p.default)(this, (t.__proto__ || (0, l.default)(t)).call(this, e));
          return r.state = {
            originalWidth: 0,
            originalHeight: 0,
            imageLoaded: !1
          }, r;
        }
        return (0, g.default)(t, e), (0, f.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            var e = this,
              t = new w.TextureLoader();
            t.crossOrigin = "", t.load(this.props.filePath, function (t) {
              e.setState({
                originalWidth: t.image.width,
                originalHeight: t.image.height,
                imageLoaded: !0,
                texture: t
              });
            }, function (e) {
              console.log(e.loaded / e.total * 100 + "% loaded");
            }, function (e) {
              console.log("An error happened", e);
            });
          }
        }, {
          key: "render",
          value: function value() {
            if (!this.state.imageLoaded) return b.default.createElement(A.default, null);
            var e = this.state,
              t = e.originalWidth,
              r = e.originalHeight,
              n = i(t, r, this.props.fileType);
            return b.default.createElement(n, (0, o.default)({}, this.state, this.props));
          }
        }]), t;
      }(v.Component);
    t.default = T;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(2),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    r(369);
    var a = function a(e) {
      return i.default.createElement("div", {
        className: "pg-driver-view"
      }, i.default.createElement("div", {
        className: "unsupported-message"
      }, e.unsupportedComponent ? i.default.createElement(e.unsupportedComponent, e) : i.default.createElement("p", {
        className: "alert"
      }, i.default.createElement("b", null, "." + e.fileType), " is not supported.")));
    };
    t.default = a;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(6),
      a = n(i),
      o = r(7),
      s = n(o),
      l = r(8),
      c = n(l),
      u = r(10),
      h = n(u),
      f = r(9),
      d = n(f),
      p = r(2),
      m = n(p);
    r(139);
    var g = r(41),
      v = n(g),
      b = function (e) {
        function t(e) {
          (0, s.default)(this, t);
          var r = (0, h.default)(this, (t.__proto__ || (0, a.default)(t)).call(this, e));
          return r.state = {
            loading: !0
          }, r;
        }
        return (0, d.default)(t, e), (0, c.default)(t, [{
          key: "onCanPlay",
          value: function value() {
            this.setState({
              loading: !1
            });
          }
        }, {
          key: "renderLoading",
          value: function value() {
            return this.state.loading ? m.default.createElement(v.default, null) : null;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.state.loading ? "hidden" : "visible";
            return m.default.createElement("div", {
              className: "pg-driver-view"
            }, m.default.createElement("div", {
              className: "video-container"
            }, this.renderLoading(), m.default.createElement("video", {
              style: {
                visibility: t
              },
              controls: !0,
              type: "video/" + this.props.fileType,
              onCanPlay: function onCanPlay(t) {
                return e.onCanPlay(t);
              },
              src: this.props.filePath
            }, "Video playback is not supported by your browser.")));
          }
        }]), t;
      }(p.Component);
    t.default = b;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(46),
      a = n(i),
      o = r(6),
      s = n(o),
      l = r(7),
      c = n(l),
      u = r(8),
      h = n(u),
      f = r(10),
      d = n(f),
      p = r(9),
      m = n(p),
      g = r(2),
      v = n(g),
      b = r(163),
      y = n(b),
      w = r(88),
      x = n(w),
      _ = function (e) {
        function t(e) {
          (0, c.default)(this, t);
          var r = (0, d.default)(this, (t.__proto__ || (0, s.default)(t)).call(this, e));
          return r.state = {
            error: !1
          }, r;
        }
        return (0, m.default)(t, e), (0, h.default)(t, [{
          key: "componentDidMount",
          value: function value() {
            try {
              var e = new y.default("xbim-viewer");
              e.load(this.props.filePath), e.start();
            } catch (e) {
              this.props.onError && this.props.onError(e), this.setState({
                error: e
              });
            }
          }
        }, {
          key: "render",
          value: function value() {
            return this.state.error ? v.default.createElement(x.default, (0, a.default)({}, this.props, {
              error: this.state.error
            })) : v.default.createElement("div", {
              className: "pg-driver-view"
            }, v.default.createElement("canvas", {
              id: "xbim-viewer"
            }));
          }
        }]), t;
      }(g.Component);
    t.default = _;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(58),
      a = n(i),
      o = r(166),
      s = n(o),
      l = r(6),
      c = n(l),
      u = r(7),
      h = n(u),
      f = r(8),
      d = n(f),
      p = r(10),
      m = n(p),
      g = r(9),
      v = n(g),
      b = r(2),
      y = n(b),
      w = r(375),
      x = n(w),
      _ = r(85),
      S = n(_),
      C = function (e) {
        function t(e) {
          (0, h.default)(this, t);
          var r = (0, m.default)(this, (t.__proto__ || (0, c.default)(t)).call(this, e));
          return r.state = r.parse(), r;
        }
        return (0, v.default)(t, e), (0, d.default)(t, [{
          key: "parse",
          value: function value() {
            for (var e = new Uint8Array(this.props.data), t = [], r = 0; r !== e.length; r += 1) t.push(String.fromCharCode(e[r]));
            var n = x.default.read(t.join(""), {
                type: "binary"
              }),
              i = (0, s.default)(n.Sheets);
            return {
              sheets: i.map(function (e) {
                return x.default.utils.sheet_to_csv(n.Sheets[e]);
              }),
              names: i,
              curSheetIndex: 0
            };
          }
        }, {
          key: "renderSheetNames",
          value: function value(e) {
            var t = this,
              r = e.map(function (e, r) {
                return y.default.createElement("input", {
                  key: e,
                  type: "button",
                  value: e,
                  onClick: function onClick() {
                    t.setState({
                      curSheetIndex: r
                    });
                  }
                });
              });
            return y.default.createElement("div", {
              className: "sheet-names"
            }, r);
          }
        }, {
          key: "renderSheetData",
          value: function value(e) {
            var t = (0, a.default)({}, this.props, {
              data: e
            });
            return y.default.createElement(S.default, t);
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.state,
              t = e.sheets,
              r = e.names,
              n = e.curSheetIndex;
            return y.default.createElement("div", {
              className: "spreadsheet-viewer"
            }, this.renderSheetNames(r), this.renderSheetData(t[n || 0]));
          }
        }]), t;
      }(b.Component);
    t.default = C;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i(e, t) {
      return function (r) {
        function n(e) {
          (0, u.default)(this, n);
          var t = (0, p.default)(this, (n.__proto__ || (0, l.default)(n)).call(this, e));
          return t.state = {}, t.xhr = t.createRequest(e.filePath), t;
        }
        return (0, g.default)(n, r), (0, f.default)(n, [{
          key: "componentDidMount",
          value: function value() {
            try {
              this.fetch();
            } catch (e) {
              this.props.onError && this.props.onError(e), this.setState({
                error: "fetch error"
              });
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.abort();
          }
        }, {
          key: "createRequest",
          value: function value(e) {
            var r = this,
              n = new XMLHttpRequest();
            if ("withCredentials" in n) n.open("GET", e, !0);else {
              if ("undefined" == typeof XDomainRequest) return n = null, null;
              n = new XDomainRequest(), n.open("GET", e);
            }
            return t.responseType && (n.responseType = t.responseType), n.onload = function () {
              if (n.status >= 400) return void r.setState({
                error: "fetch error with status " + n.status
              });
              var e = t.responseType ? n.response : n.responseText;
              r.setState({
                data: e
              });
            }, n;
          }
        }, {
          key: "fetch",
          value: function value() {
            this.xhr.send();
          }
        }, {
          key: "abort",
          value: function value() {
            this.xhr && this.xhr.abort();
          }
        }, {
          key: "render",
          value: function value() {
            return this.xhr ? this.state.error ? b.default.createElement(w.default, (0, o.default)({}, this.props, {
              error: this.state.error
            })) : this.state.data ? b.default.createElement(e, (0, o.default)({
              data: this.state.data
            }, this.props)) : b.default.createElement(_.default, null) : b.default.createElement("h1", null, "CORS not supported..");
          }
        }]), n;
      }(v.Component);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = r(46),
      o = n(a),
      s = r(6),
      l = n(s),
      c = r(7),
      u = n(c),
      h = r(8),
      f = n(h),
      d = r(10),
      p = n(d),
      m = r(9),
      g = n(m),
      v = r(2),
      b = n(v),
      y = r(88),
      w = n(y),
      x = r(41),
      _ = n(x);
    t.default = i;
  }, function (e, t, r) {
    "use strict";

    e.exports = r(151);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function i() {
      this._buffer = null, this._position = 0;
    }
    function a() {
      this.normals = [], this.indices = [], this.products = [], this.transformations = [], this.styleIndices = [], this.states = [], this.vertices = [], this.matrices = [], this.styles = [], this.meter = 1e3, this.productMap = {};
    }
    function o(e, t, r) {
      if (void 0 === e || void 0 === t || void 0 === r) throw "WebGL context and geometry model must be specified";
      this._gl = e, this._model = t, this._fpt = r, this.id = o._instancesNum++, this.stopped = !1, this.count = t.indices.length, this.vertexTexture = e.createTexture(), this.matrixTexture = e.createTexture(), this.styleTexture = e.createTexture(), this.stateStyleTexture = e.createTexture(), this.vertexTextureSize = 0, this.matrixTextureSize = 0, this.styleTextureSize = 0, this.normalBuffer = e.createBuffer(), this.indexBuffer = e.createBuffer(), this.productBuffer = e.createBuffer(), this.styleBuffer = e.createBuffer(), this.stateBuffer = e.createBuffer(), this.transformationBuffer = e.createBuffer(), this.stateStyle = new Uint8Array(900), this._feedCompleted = !1, this.region = t.regions[0], t.regions.forEach(function (e) {
        e.population > this.region.population && (this.region = e);
      }, this), void 0 === this.region && (this.region = {
        population: 1,
        centre: [0, 0, 0],
        bbox: [0, 0, 0, 10 * t.meter, 10 * t.meter, 10 * t.meter]
      });
    }
    function s() {}
    function l(e) {
      if (void 0 === e) throw "Canvas has to be defined";
      if (this._canvas = null, void 0 !== e.nodeName && "CANVAS" == e.nodeName && (this._canvas = e), "string" == typeof e && (this._canvas = document.getElementById(e)), null == this._canvas) throw "You have to specify canvas either as an ID of HTML element or the element itself";
      this.perspectiveCamera = {
        fov: 45,
        near: 0,
        far: 0
      }, this.orthogonalCamera = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        near: 0,
        far: 0
      }, this.camera = "perspective", this.background = [230, 230, 230, 255], this.highlightingColour = [255, 173, 33, 255], this.lightA = [0, 1e6, 2e5, .8], this.lightB = [0, -5e5, 5e4, .2], this.navigationMode = "orbit", this.renderingMode = "normal", this.clippingPlane = [0, 0, 0, 0], this._lastClippingPoint = [0, 0, 0];
      var t = v.setupWebGL(this._canvas);
      t && (this._gl = t, this._fpt = t.getExtension("OES_texture_float") || t.getExtension("MOZ_OES_texture_float") || t.getExtension("WEBKIT_OES_texture_float"), t.enable(t.DEPTH_TEST), t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA), t.enable(t.BLEND), this._width = this._canvas.width = this._canvas.offsetWidth, this._height = this._canvas.height = this._canvas.offsetHeight, this._geometryLoaded = !1, this._numberOfActiveModels = 0, this._lastStates = {}, this._visualStateAttributes = ["perspectiveCamera", "orthogonalCamera", "camera", "background", "lightA", "lightB", "renderingMode", "clippingPlane", "_mvMatrix", "_pMatrix", "_distance", "_origin", "highlightingColour", "_numberOfActiveModels"], this._stylingChanged = !0, this._userAction = !0, this._events = {}, this._plugins = [], this._mvMatrixUniformPointer = null, this._pMatrixUniformPointer = null, this._lightAUniformPointer = null, this._lightBUniformPointer = null, this._colorCodingUniformPointer = null, this._clippingPlaneUniformPointer = null, this._meterUniformPointer = null, this._renderingModeUniformPointer = null, this._highlightingColourUniformPointer = null, this._mvMatrix = mat4.create(), this._pMatrix = mat4.create(), this._origin = [0, 0, 0], this._distance = 0, this._shaderProgram = null, this._handles = [], this._stateStyles = new Uint8Array(900), this._isRunning = !0, this._initShaders(), this._initAttributesAndUniforms(), this._initMouseEvents());
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var c,
      u = r(59),
      h = (n(u), r(164)),
      f = n(h),
      d = r(170),
      p = n(d);
    i.prototype.onloaded = function () {}, i.prototype.onerror = function () {}, i.prototype.load = function (e) {
      this._position = 0;
      var t = this;
      if (void 0 === e || null == e) throw "Source must be defined";
      if ("string" == typeof e) {
        var r;
        r = new XMLHttpRequest(), r.open("GET", e, !0), r.onreadystatechange = function () {
          if (4 == r.readyState && 200 == r.status) {
            var e = new FileReader();
            e.onloadend = function () {
              e.result && (t._buffer = e.result, t.onloaded && t.onloaded());
            }, e.readAsArrayBuffer(r.response);
          }
          if (4 == r.readyState && 200 != r.status) {
            var n = "Failed to fetch binary data from server. Server code: " + r.status + ". This might be due to CORS policy of your browser if you run this as a local file.";
            throw t.onerror && t.onerror(n), n;
          }
        }, r.responseType = "blob", r.send();
      } else if (e instanceof Blob || e instanceof File) {
        var n = new FileReader();
        n.onloadend = function () {
          n.result && (t._buffer = n.result, t.onloaded && t.onloaded());
        }, n.readAsArrayBuffer(e);
      } else e instanceof ArrayBuffer && (this._buffer = e);
    }, i.prototype.getIsEOF = function (e, t) {
      if (void 0 === this._position) throw "Position is not defined";
      return this._position == this._buffer.byteLength;
    }, i.prototype.read = function (e, t, r) {
      void 0 === t && (t = 1);
      var n = e * t,
        i = this._position;
      this._position += n;
      return 1 === t ? new r(this._buffer.slice(i, i + n))[0] : new r(this._buffer.slice(i, i + n));
    }, i.prototype.readByte = function (e) {
      return this.read(1, e, Uint8Array);
    }, i.prototype.readUint8 = function (e) {
      return this.read(1, e, Uint8Array);
    }, i.prototype.readInt16 = function (e) {
      return this.read(2, e, Int16Array);
    }, i.prototype.readUint16 = function (e) {
      return this.read(2, e, Uint16Array);
    }, i.prototype.readInt32 = function (e) {
      return this.read(4, e, Int32Array);
    }, i.prototype.readUint32 = function (e) {
      return this.read(4, e, Uint32Array);
    }, i.prototype.readFloat32 = function (e) {
      return this.read(4, e, Float32Array);
    }, i.prototype.readFloat64 = function (e) {
      return this.read(8, e, Float64Array);
    }, i.prototype.readChar = function (e) {
      void 0 === e && (e = 1);
      var t = this.readByte(e),
        r = new Array(e);
      for (var n in t) r[n] = String.fromCharCode(t[n]);
      return 1 === e ? r[0] : r;
    }, i.prototype.readPoint = function (e) {
      void 0 === e && (e = 1);
      for (var t = this.readFloat32(3 * e), r = new Array(e), n = 0; n < e; n++) {
        var i = 3 * n * 4,
          a = new Float32Array(t.buffer, i, 3);
        r[n] = a;
      }
      return 1 === e ? r[0] : r;
    }, i.prototype.readRgba = function (e) {
      void 0 === e && (e = 1);
      for (var t = this.readByte(4 * e), r = new Array(e), n = 0; n < e; n++) {
        var i = 4 * n,
          a = new Uint8Array(t.buffer, i, 4);
        r[n] = a;
      }
      return 1 === e ? r[0] : r;
    }, i.prototype.readPackedNormal = function (e) {
      void 0 === e && (e = 1);
      for (var t = this.readUint8(2 * e), r = new Array(e), n = 0; n < e; n++) {
        var i = new Uint8Array(t.buffer, 2 * n, 2);
        r[n] = i;
      }
      return 1 === e ? r[0] : r;
    }, i.prototype.readMatrix4x4 = function (e) {
      void 0 === e && (e = 1);
      for (var t = this.readFloat32(16 * e), r = new Array(e), n = 0; n < e; n++) {
        var i = 16 * n * 4,
          a = new Float32Array(t.buffer, i, 16);
        r[n] = a;
      }
      return 1 === e ? r[0] : r;
    }, i.prototype.readMatrix4x4_64 = function (e) {
      void 0 === e && (e = 1);
      for (var t = this.readFloat64(16 * e), r = new Array(e), n = 0; n < e; n++) {
        var i = 16 * n * 8,
          a = new Float64Array(t.buffer, i, 16);
        r[n] = a;
      }
      return 1 === e ? r[0] : r;
    }, a.prototype.parse = function (e) {
      var t = e;
      if (94132117 != t.readInt32()) throw "Magic number mismatch.";
      var r = t.readByte(),
        n = t.readInt32(),
        i = t.readInt32(),
        a = t.readInt32(),
        o = t.readInt32(),
        l = t.readInt32(),
        c = t.readInt32();
      this.meter = t.readFloat32();
      var u = t.readInt16(),
        h = function h(e, t) {
          if (void 0 === e || void 0 === t) throw "Wrong arguments";
          if (0 == t) return 0;
          for (var r = t * e, n = Math.ceil(Math.sqrt(r / 4)); 4 * n % e != 0;) n++;
          return n * n * 4 / e;
        };
      this.vertices = new Float32Array(h(4, 3 * i)), this.normals = new Uint8Array(6 * a), this.indices = new Float32Array(3 * a), this.styleIndices = new Uint16Array(3 * a), this.styles = new Uint8Array(h(1, 4 * (c + 1))), this.products = new Float32Array(3 * a), this.states = new Uint8Array(3 * a * 2), this.transformations = new Float32Array(3 * a), this.matrices = new Float32Array(h(4, 16 * o)), this.productMap = {}, this.regions = new Array(u);
      for (var f = 0, d = 0, p = 3 * a, v = 0, b = 0, y = g, w = m, x = 0; x < u; x++) this.regions[x] = {
        population: t.readInt32(),
        centre: t.readFloat32(3),
        bbox: t.readFloat32(6)
      };
      var _ = [];
      _.getStyle = function (e) {
        for (var t = 0; t < this.length; t++) {
          var r = this[t];
          if (r.id == e) return r;
        }
        return null;
      };
      var S = 0;
      for (S; S < c; S++) {
        var C = t.readInt32(),
          E = 255 * t.readFloat32(),
          A = 255 * t.readFloat32(),
          T = 255 * t.readFloat32(),
          k = 255 * t.readFloat32();
        this.styles.set([E, A, T, k], 4 * S), _.push({
          id: C,
          index: S,
          transparent: k < 254
        });
      }
      this.styles.set([255, 255, 255, 255], 4 * S);
      var R = {
        id: -1,
        index: S,
        transparent: k < 254
      };
      _.push(R);
      for (var x = 0; x < l; x++) {
        var I = t.readInt32(),
          M = t.readInt16(),
          O = t.readFloat32(6),
          P = {
            productID: I,
            type: M,
            bBox: O,
            spans: []
          };
        this.productMap[I] = P;
      }
      for (var B = 0; B < n; B++) {
        for (var D = t.readInt32(), L = [], F = 0; F < D; F++) {
          var N = t.readInt32(),
            U = (t.readInt16(), t.readInt32()),
            C = t.readInt32(),
            j = null;
          D > 1 && (j = 1 === r ? t.readFloat32(16) : t.readFloat64(16), this.matrices.set(j, b), b += 16);
          var z = _.getStyle(C);
          null === z && (z = R), L.push({
            pLabel: N,
            iLabel: U,
            style: z.index,
            transparent: z.transparent,
            transform: null != j ? v++ : 65535
          });
        }
        var H = new s();
        H.parse(t), L.forEach(function (e) {
          var t = 0;
          t = e.transparent ? p - H.indices.length : d;
          var r = t,
            n = this.productMap[e.pLabel];
          void 0 === n && (n = {
            productID: 0,
            type: w.IFCOPENINGELEMENT,
            bBox: new Float32Array(6),
            spans: []
          }, this.productMap[e.pLabel] = n), this.normals.set(H.normals, 2 * t);
          for (var i = n.type == w.IFCSPACE || n.type == w.IFCOPENINGELEMENT ? y.HIDDEN : 255, a = 0; a < H.indices.length; a++) this.indices[t] = H.indices[a] + f / 3, this.products[t] = e.pLabel, this.styleIndices[t] = e.style, this.transformations[t] = e.transform, this.states[2 * t] = i, this.states[2 * t + 1] = 255, t++;
          var o = t;
          n.spans.push(new Int32Array([r, o])), e.transparent ? p -= H.indices.length : d += H.indices.length;
        }, this), this.vertices.set(H.vertices, f), f += H.vertices.length, H = null;
      }
      t.getIsEOF(), this.transparentIndex = d;
    }, a.prototype.load = function (e) {
      var t = new i(),
        r = this;
      t.onloaded = function () {
        r.parse(t), r.onloaded && r.onloaded();
      }, t.onerror = function (e) {
        r.onerror && r.onerror(e);
      }, t.load(e);
    }, a.prototype.onloaded = function () {}, a.prototype.onerror = function () {}, o._instancesNum = 0, o.prototype.setActive = function (e) {
      if (!this.stopped) {
        var t = this._gl;
        this.vertexTextureSize > 0 && (t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, this.vertexTexture)), this.matrixTextureSize > 0 && (t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, this.matrixTexture)), this.styleTextureSize > 0 && (t.activeTexture(t.TEXTURE3), t.bindTexture(t.TEXTURE_2D, this.styleTexture)), t.activeTexture(t.TEXTURE4), t.bindTexture(t.TEXTURE_2D, this.stateStyleTexture), t.bindBuffer(t.ARRAY_BUFFER, this.normalBuffer), t.vertexAttribPointer(e.normalAttrPointer, 2, t.UNSIGNED_BYTE, !1, 0, 0), t.bindBuffer(t.ARRAY_BUFFER, this.indexBuffer), t.vertexAttribPointer(e.indexlAttrPointer, 1, t.FLOAT, !1, 0, 0), t.bindBuffer(t.ARRAY_BUFFER, this.productBuffer), t.vertexAttribPointer(e.productAttrPointer, 1, t.FLOAT, !1, 0, 0), t.bindBuffer(t.ARRAY_BUFFER, this.stateBuffer), t.vertexAttribPointer(e.stateAttrPointer, 2, t.UNSIGNED_BYTE, !1, 0, 0), t.bindBuffer(t.ARRAY_BUFFER, this.styleBuffer), t.vertexAttribPointer(e.styleAttrPointer, 1, t.UNSIGNED_SHORT, !1, 0, 0), t.bindBuffer(t.ARRAY_BUFFER, this.transformationBuffer), t.vertexAttribPointer(e.transformationAttrPointer, 1, t.FLOAT, !1, 0, 0), t.uniform1i(e.vertexSamplerUniform, 1), t.uniform1i(e.matrixSamplerUniform, 2), t.uniform1i(e.styleSamplerUniform, 3), t.uniform1i(e.stateStyleSamplerUniform, 4), t.uniform1i(e.vertexTextureSizeUniform, this.vertexTextureSize), t.uniform1i(e.matrixTextureSizeUniform, this.matrixTextureSize), t.uniform1i(e.styleTextureSizeUniform, this.styleTextureSize);
      }
    }, o.prototype.draw = function (e) {
      if (!this.stopped) {
        var t = this._gl;
        return void 0 === e ? void t.drawArrays(t.TRIANGLES, 0, this.count) : "solid" === e ? void t.drawArrays(t.TRIANGLES, 0, this._model.transparentIndex) : "transparent" === e ? void t.drawArrays(t.TRIANGLES, this._model.transparentIndex, this.count - this._model.transparentIndex) : void 0;
      }
    }, o.prototype.drawProduct = function (e) {
      if (!this.stopped) {
        var t = this._gl,
          r = this.getProductMap(e);
        null != r && r.spans.forEach(function (e) {
          t.drawArrays(t.TRIANGLES, e[0], e[1] - e[0]);
        }, this);
      }
    }, o.prototype.getProductMap = function (e) {
      var t = this._model.productMap[e];
      return void 0 !== t ? t : null;
    }, o.prototype.unload = function () {
      var e = this._gl;
      e.deleteTexture(this.vertexTexture), e.deleteTexture(this.matrixTexture), e.deleteTexture(this.styleTexture), e.deleteTexture(this.stateStyleTexture), e.deleteBuffer(this.normalBuffer), e.deleteBuffer(this.indexBuffer), e.deleteBuffer(this.productBuffer), e.deleteBuffer(this.styleBuffer), e.deleteBuffer(this.stateBuffer), e.deleteBuffer(this.transformationBuffer);
    }, o.prototype.feedGPU = function () {
      if (this._feedCompleted) throw "GPU can bee fed only once. It discards unnecessary data which cannot be restored again.";
      var e = (this._gl, this._model);
      this._bufferData(this.normalBuffer, e.normals), this._bufferData(this.indexBuffer, e.indices), this._bufferData(this.productBuffer, e.products), this._bufferData(this.stateBuffer, e.states), this._bufferData(this.transformationBuffer, e.transformations), this._bufferData(this.styleBuffer, e.styleIndices), this.vertexTextureSize = this._bufferTexture(this.vertexTexture, e.vertices, 3), this.matrixTextureSize = this._bufferTexture(this.matrixTexture, e.matrices, 4), this.styleTextureSize = this._bufferTexture(this.styleTexture, e.styles), this._bufferTexture(this.stateStyleTexture, this.stateStyle), e.normals = null, e.indices = null, e.products = null, e.transformations = null, e.styleIndices = null, e.vertices = null, e.matrices = null, this._feedCompleted = !0;
    }, o.prototype.refreshStyles = function () {
      this._bufferTexture(this.stateStyleTexture, this.stateStyle);
    }, o.prototype._bufferData = function (e, t) {
      var r = this._gl;
      r.bindBuffer(r.ARRAY_BUFFER, e), r.bufferData(r.ARRAY_BUFFER, t, r.STATIC_DRAW);
    }, o.prototype._bufferTexture = function (e, t, r) {
      var n = this._gl;
      if (0 == t.length) return 0;
      var i = this._fpt && t instanceof Float32Array,
        a = 0,
        o = n.getParameter(n.MAX_TEXTURE_SIZE);
      if (i) a = Math.ceil(Math.sqrt(Math.ceil(t.length / r))) + 1;else {
        var s = Math.sqrt(t.byteLength / 4);
        a = Math.ceil(s);
      }
      if (0 == a) return 0;
      if (a > o) throw "Too much data! It cannot fit into the texture.";
      if (n.bindTexture(n.TEXTURE_2D, e), n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, !1), n.pixelStorei(n.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), n.pixelStorei(n.UNPACK_COLORSPACE_CONVERSION_WEBGL, 0), i) {
        var l = null;
        a * a * r != t.length ? (l = new Float32Array(a * a * r), l.set(t)) : l = t;
        var c = null;
        switch (r) {
          case 1:
            c = n.ALPHA;
            break;
          case 3:
            c = n.RGB;
            break;
          case 4:
            c = n.RGBA;
        }
        n.texImage2D(n.TEXTURE_2D, 0, c, a, a, 0, c, n.FLOAT, l);
      } else n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, a, a, 0, n.RGBA, n.UNSIGNED_BYTE, new Uint8Array(t.buffer));
      return n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.NEAREST), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.NEAREST), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), a;
    }, o.prototype.getState = function (e) {
      if (void 0 === e) throw "id must be defined";
      var t = this.getProductMap(e);
      if (null === t) return null;
      var r = t.spans[0];
      return void 0 === r ? null : this._model.states[2 * r[0]];
    }, o.prototype.getStyle = function (e) {
      if (void 0 === e) throw "id must be defined";
      var t = this.getProductMap(e);
      if (null === t) return null;
      var r = t.spans[0];
      return void 0 === r ? null : this._model.states[2 * r[0] + 1];
    }, o.prototype.setState = function (e, t) {
      if ("number" != typeof e && e < 0 && e > 255) throw "You have to specify state as an ID of state or index in style pallete.";
      if (void 0 === t) throw "You have to specify products as an array of product IDs or as a product type ID";
      var r = [];
      if ("number" == typeof t) for (var n in this._model.productMap) {
        var i = this._model.productMap[n];
        i.type == t && r.push(i);
      } else for (var a = 0; a < t.length; a++) {
        var o = t[a],
          i = this.getProductMap(o);
        null != i && r.push(i);
      }
      var s = e <= 225 ? 1 : 0;
      r.forEach(function (t) {
        t.spans.forEach(function (t) {
          for (var r = t[0]; r < t[1]; r++) this._model.states[2 * r + s] = e;
        }, this);
      }, this), this._bufferData(this.stateBuffer, this._model.states);
    }, o.prototype.resetStates = function () {
      for (var e = 0; e < this._model.states.length; e += 2) this._model.states[e] = g.UNDEFINED;
      this._bufferData(this.stateBuffer, this._model.states);
    }, o.prototype.resetStyles = function () {
      for (var e = 0; e < this._model.states.length; e += 2) this._model.states[e + 1] = g.UNSTYLED;
      this._bufferData(this.stateBuffer, this._model.states);
    }, o.prototype.getModelState = function () {
      var e = [],
        t = this._model.productMap;
      for (var r in t) if (t.hasOwnProperty(r)) {
        var n = t[r],
          i = n.spans[0];
        if (void 0 !== i) {
          var a = this._model.states[2 * i[0]],
            o = this._model.states[2 * i[0] + 1];
          e.push([n.productID, a + (o << 8)]);
        }
      }
      return e;
    }, o.prototype.restoreModelState = function (e) {
      e.forEach(function (e) {
        var t = e[0],
          r = e[1] >> 8,
          n = e[1] - (r << 8),
          i = this.getProductMap(t);
        null != i && i.spans.forEach(function (e) {
          for (var t = e[0]; t < e[1]; t++) this._model.states[2 * t] = n, this._model.states[2 * t + 1] = r;
        }, this);
      }, this), this._bufferData(this.stateBuffer, this._model.states);
    };
    var m = (c = {
      IFCDISTRIBUTIONELEMENT: 44,
      IFCDISTRIBUTIONFLOWELEMENT: 45,
      IFCDISTRIBUTIONCHAMBERELEMENT: 180,
      IFCENERGYCONVERSIONDEVICE: 175,
      IFCAIRTOAIRHEATRECOVERY: 1097,
      IFCBOILER: 1105,
      IFCBURNER: 1109,
      IFCCHILLER: 1119,
      IFCCOIL: 1124,
      IFCCONDENSER: 1132,
      IFCCOOLEDBEAM: 1141,
      IFCCOOLINGTOWER: 1142,
      IFCENGINE: 1164,
      IFCEVAPORATIVECOOLER: 1166,
      IFCEVAPORATOR: 1167,
      IFCHEATEXCHANGER: 1187,
      IFCHUMIDIFIER: 1188,
      IFCTUBEBUNDLE: 1305,
      IFCUNITARYEQUIPMENT: 1310,
      IFCELECTRICGENERATOR: 1160,
      IFCELECTRICMOTOR: 1161,
      IFCMOTORCONNECTION: 1216,
      IFCSOLARDEVICE: 1270,
      IFCTRANSFORMER: 1303,
      IFCFLOWCONTROLLER: 121,
      IFCELECTRICDISTRIBUTIONPOINT: 242,
      IFCAIRTERMINALBOX: 1096,
      IFCDAMPER: 1148,
      IFCFLOWMETER: 1182,
      IFCVALVE: 1311,
      IFCELECTRICDISTRIBUTIONBOARD: 1157,
      IFCELECTRICTIMECONTROL: 1162,
      IFCPROTECTIVEDEVICE: 1235,
      IFCSWITCHINGDEVICE: 1290,
      IFCFLOWFITTING: 467,
      IFCDUCTFITTING: 1153,
      IFCPIPEFITTING: 1222,
      IFCCABLECARRIERFITTING: 1111,
      IFCCABLEFITTING: 1113,
      IFCJUNCTIONBOX: 1195,
      IFCFLOWMOVINGDEVICE: 502,
      IFCCOMPRESSOR: 1131,
      IFCFAN: 1177,
      IFCPUMP: 1238,
      IFCFLOWSEGMENT: 574,
      IFCDUCTSEGMENT: 1154,
      IFCPIPESEGMENT: 1223,
      IFCCABLECARRIERSEGMENT: 1112,
      IFCCABLESEGMENT: 1115,
      IFCFLOWSTORAGEDEVICE: 371,
      IFCTANK: 1293,
      IFCELECTRICFLOWSTORAGEDEVICE: 1159,
      IFCFLOWTERMINAL: 46,
      IFCFIRESUPPRESSIONTERMINAL: 1179,
      IFCSANITARYTERMINAL: 1262,
      IFCSTACKTERMINAL: 1277,
      IFCWASTETERMINAL: 1315,
      IFCAIRTERMINAL: 1095,
      IFCMEDICALDEVICE: 1212,
      IFCSPACEHEATER: 1272,
      IFCAUDIOVISUALAPPLIANCE: 1099,
      IFCCOMMUNICATIONSAPPLIANCE: 1127,
      IFCELECTRICAPPLIANCE: 1156,
      IFCLAMP: 1198,
      IFCLIGHTFIXTURE: 1199,
      IFCOUTLET: 1219,
      IFCFLOWTREATMENTDEVICE: 425,
      IFCINTERCEPTOR: 1193,
      IFCDUCTSILENCER: 1155,
      IFCFILTER: 1178,
      IFCDISTRIBUTIONCONTROLELEMENT: 468,
      IFCPROTECTIVEDEVICETRIPPINGUNIT: 1236,
      IFCACTUATOR: 1091,
      IFCALARM: 1098,
      IFCCONTROLLER: 1139,
      IFCFLOWINSTRUMENT: 1181,
      IFCSENSOR: 1264,
      IFCUNITARYCONTROLELEMENT: 1308,
      IFCDISCRETEACCESSORY: 423,
      IFCFASTENER: 535,
      IFCMECHANICALFASTENER: 536,
      IFCREINFORCINGBAR: 571,
      IFCREINFORCINGMESH: 531,
      IFCTENDON: 261,
      IFCTENDONANCHOR: 675,
      IFCBUILDINGELEMENTPART: 220
    }, (0, p.default)(c, "IFCMECHANICALFASTENER", 536), (0, p.default)(c, "IFCVIBRATIONISOLATOR", 1312), (0, p.default)(c, "IFCCHAMFEREDGEFEATURE", 765), (0, p.default)(c, "IFCROUNDEDEDGEFEATURE", 766), (0, p.default)(c, "IFCOPENINGELEMENT", 498), (0, p.default)(c, "IFCOPENINGSTANDARDCASE", 1217), (0, p.default)(c, "IFCVOIDINGFEATURE", 1313), (0, p.default)(c, "IFCPROJECTIONELEMENT", 384), (0, p.default)(c, "IFCSURFACEFEATURE", 1287), (0, p.default)(c, "IFCBUILDINGELEMENTPART", 220), (0, p.default)(c, "IFCREINFORCINGBAR", 571), (0, p.default)(c, "IFCREINFORCINGMESH", 531), (0, p.default)(c, "IFCTENDON", 261), (0, p.default)(c, "IFCTENDONANCHOR", 675), (0, p.default)(c, "IFCFOOTING", 120), (0, p.default)(c, "IFCPILE", 572), (0, p.default)(c, "IFCBEAM", 171), (0, p.default)(c, "IFCBEAMSTANDARDCASE", 1104), (0, p.default)(c, "IFCCOLUMN", 383), (0, p.default)(c, "IFCCOLUMNSTANDARDCASE", 1126), (0, p.default)(c, "IFCCURTAINWALL", 456), (0, p.default)(c, "IFCDOOR", 213), (0, p.default)(c, "IFCDOORSTANDARDCASE", 1151), (0, p.default)(c, "IFCMEMBER", 310), (0, p.default)(c, "IFCMEMBERSTANDARDCASE", 1214), (0, p.default)(c, "IFCPLATE", 351), (0, p.default)(c, "IFCPLATESTANDARDCASE", 1224), (0, p.default)(c, "IFCRAILING", 350), (0, p.default)(c, "IFCRAMP", 414), (0, p.default)(c, "IFCRAMPFLIGHT", 348), (0, p.default)(c, "IFCROOF", 347), (0, p.default)(c, "IFCSLAB", 99), (0, p.default)(c, "IFCSLABELEMENTEDCASE", 1268), (0, p.default)(c, "IFCSLABSTANDARDCASE", 1269), (0, p.default)(c, "IFCSTAIR", 346), (0, p.default)(c, "IFCSTAIRFLIGHT", 25), (0, p.default)(c, "IFCWALL", 452), (0, p.default)(c, "IFCWALLSTANDARDCASE", 453), (0, p.default)(c, "IFCWALLELEMENTEDCASE", 1314), (0, p.default)(c, "IFCWINDOW", 667), (0, p.default)(c, "IFCWINDOWSTANDARDCASE", 1316), (0, p.default)(c, "IFCBUILDINGELEMENTPROXY", 560), (0, p.default)(c, "IFCCOVERING", 382), (0, p.default)(c, "IFCCHIMNEY", 1120), (0, p.default)(c, "IFCSHADINGDEVICE", 1265), (0, p.default)(c, "IFCELEMENTASSEMBLY", 18), (0, p.default)(c, "IFCFURNISHINGELEMENT", 253), (0, p.default)(c, "IFCFURNITURE", 1184), (0, p.default)(c, "IFCSYSTEMFURNITUREELEMENT", 1291), (0, p.default)(c, "IFCTRANSPORTELEMENT", 416), (0, p.default)(c, "IFCVIRTUALELEMENT", 168), (0, p.default)(c, "IFCELECTRICALELEMENT", 23), (0, p.default)(c, "IFCEQUIPMENTELEMENT", 212), (0, p.default)(c, "IFCCIVILELEMENT", 1122), (0, p.default)(c, "IFCGEOGRAPHICELEMENT", 1185), (0, p.default)(c, "IFCDISTRIBUTIONPORT", 178), (0, p.default)(c, "IFCPROXY", 447), (0, p.default)(c, "IFCSTRUCTURALLINEARACTION", 463), (0, p.default)(c, "IFCSTRUCTURALLINEARACTIONVARYING", 464), (0, p.default)(c, "IFCSTRUCTURALPLANARACTION", 39), (0, p.default)(c, "IFCSTRUCTURALPLANARACTIONVARYING", 357), (0, p.default)(c, "IFCSTRUCTURALPOINTACTION", 356), (0, p.default)(c, "IFCSTRUCTURALCURVEACTION", 1279), (0, p.default)(c, "IFCSTRUCTURALLINEARACTION", 463), (0, p.default)(c, "IFCSTRUCTURALSURFACEACTION", 1284), (0, p.default)(c, "IFCSTRUCTURALPLANARACTION", 39), (0, p.default)(c, "IFCSTRUCTURALPOINTREACTION", 354), (0, p.default)(c, "IFCSTRUCTURALCURVEREACTION", 1280), (0, p.default)(c, "IFCSTRUCTURALSURFACEREACTION", 1285), (0, p.default)(c, "IFCSTRUCTURALCURVECONNECTION", 534), (0, p.default)(c, "IFCSTRUCTURALPOINTCONNECTION", 533), (0, p.default)(c, "IFCSTRUCTURALSURFACECONNECTION", 264), (0, p.default)(c, "IFCSTRUCTURALCURVEMEMBER", 224), (0, p.default)(c, "IFCSTRUCTURALCURVEMEMBERVARYING", 227), (0, p.default)(c, "IFCSTRUCTURALSURFACEMEMBER", 420), (0, p.default)(c, "IFCSTRUCTURALSURFACEMEMBERVARYING", 421), (0, p.default)(c, "IFCANNOTATION", 634), (0, p.default)(c, "IFCBUILDING", 169), (0, p.default)(c, "IFCBUILDINGSTOREY", 459), (0, p.default)(c, "IFCSITE", 349), (0, p.default)(c, "IFCSPACE", 454), (0, p.default)(c, "IFCGRID", 564), (0, p.default)(c, "IFCBUILDING", 169), (0, p.default)(c, "IFCBUILDINGSTOREY", 459), (0, p.default)(c, "IFCSITE", 349), (0, p.default)(c, "IFCSPACE", 454), (0, p.default)(c, "IFCEXTERNALSPATIALELEMENT", 1174), (0, p.default)(c, "IFCSPATIALZONE", 1275), c);
    window.xShaders || (window.xShaders = {}), xShaders.fragment_shader = " precision mediump float; uniform vec4 uClippingPlane; varying vec4 vFrontColor; varying vec4 vBackColor; varying vec3 vPosition; varying float vDiscard; void main(void) { if ( vDiscard > 0.001) discard; if (length(uClippingPlane) > 0.001) { vec4 p = uClippingPlane; vec3 x = vPosition; float distance = (dot(p.xyz, x) + p.w) / length(p.xyz); if (distance < 0.0){ discard; } } gl_FragColor = gl_FrontFacing ? vFrontColor : vBackColor; }", xShaders.vertex_shader = " attribute highp float aVertexIndex; attribute highp float aTransformationIndex; attribute highp float aStyleIndex; attribute highp float aProduct; attribute highp vec2 aState; attribute highp vec2 aNormal; uniform mat4 uMVMatrix; uniform mat4 uPMatrix; uniform vec4 ulightA; uniform vec4 ulightB; uniform vec4 uHighlightColour; uniform float uMeter; uniform bool uColorCoding; uniform int uRenderingMode; uniform highp sampler2D uVertexSampler; uniform int uVertexTextureSize; uniform highp sampler2D uMatrixSampler; uniform int uMatrixTextureSize; uniform highp sampler2D uStyleSampler; uniform int uStyleTextureSize; uniform highp sampler2D uStateStyleSampler; varying vec4 vFrontColor; varying vec4 vBackColor; varying vec3 vPosition; varying float vDiscard; vec3 getNormal(){ float U = aNormal[0]; float V = aNormal[1]; float PI = 3.1415926535897932384626433832795; float lon = U / 252.0 * 2.0 * PI; float lat = V / 252.0 * PI; float x = sin(lon) * sin(lat); float z = cos(lon) * sin(lat); float y = cos(lat); return normalize(vec3(x, y, z)); } vec4 getIdColor(){ float product = floor(aProduct + 0.5); float B = floor (product/(256.0*256.0)); float G = floor((product  - B * 256.0*256.0)/256.0); float R = mod(product, 256.0); return vec4(R/255.0, G/255.0, B/255.0, 1.0); } vec2 getTextureCoordinates(int index, int size) { float x = float(index - (index / size) * size); float y = float(index / size); float pixelSize = 1.0 / float(size); return vec2((x + 0.5) * pixelSize, (y + 0.5) * pixelSize); } vec4 getColor(){ int restyle = int(floor(aState[1] + 0.5)); if (restyle > 224){ int index = int (floor(aStyleIndex + 0.5)); vec2 coords = getTextureCoordinates(index, uStyleTextureSize); return texture2D(uStyleSampler, coords); } vec2 coords = getTextureCoordinates(restyle, 15); return texture2D(uStateStyleSampler, coords); } vec3 getVertexPosition(){ int index = int (floor(aVertexIndex +0.5)); vec2 coords = getTextureCoordinates(index, uVertexTextureSize); vec3 point = vec3(texture2D(uVertexSampler, coords)); int tIndex = int(floor(aTransformationIndex + 0.5)); if (tIndex != 65535) { tIndex *=4; mat4 transform = mat4( texture2D(uMatrixSampler, getTextureCoordinates(tIndex, uMatrixTextureSize)), texture2D(uMatrixSampler, getTextureCoordinates(tIndex+1, uMatrixTextureSize)), texture2D(uMatrixSampler, getTextureCoordinates(tIndex+2, uMatrixTextureSize)), texture2D(uMatrixSampler, getTextureCoordinates(tIndex+3, uMatrixTextureSize)) ); return vec3(transform * vec4(point, 1.0)); } return point; } void main(void) { int state = int(floor(aState[0] + 0.5)); vDiscard = 0.0; if (state == 254) { vDiscard = 1.0; vFrontColor = vec4(0.0, 0.0, 0.0, 0.0); vBackColor = vec4(0.0, 0.0, 0.0, 0.0); vPosition = vec3(0.0, 0.0, 0.0); gl_Position = vec4(0.0, 0.0, 0.0, 1.0); return; } vec3 vertex = getVertexPosition(); vec3 normal = getNormal(); vec3 backNormal = normal * -1.0; if (uColorCoding){ vec4 idColor = getIdColor(); vFrontColor = idColor; vBackColor = idColor; } else{ float lightAIntensity = ulightA[3]; vec3 lightADirection = normalize(ulightA.xyz - vertex); float lightBIntensity = ulightB[3]; vec3 lightBDirection = normalize(ulightB.xyz - vertex); float lightWeightA = max(dot(normal, lightADirection ) * lightAIntensity, 0.0); float lightWeightB = max(dot(normal, lightBDirection ) * lightBIntensity, 0.0); float backLightWeightA = max(dot(backNormal, lightADirection) * lightAIntensity, 0.0); float backLightWeightB = max(dot(backNormal, lightBDirection) * lightBIntensity, 0.0); float lightWeighting = lightWeightA + lightWeightB + 0.4; float backLightWeighting = backLightWeightA + backLightWeightB + 0.4; vec4 baseColor = vec4(1.0, 1.0, 1.0, 1.0); if (uRenderingMode == 2){ if (state == 252){ baseColor = getColor(); } else{ baseColor = vec4(0.0, 0.0, 0.3, 0.5); } } if (state == 253) { baseColor = uHighlightColour; } if (uRenderingMode != 2 && state != 253){ baseColor = getColor(); } if (baseColor.a < 0.98 && uRenderingMode == 0) { vec3 trans = -0.002 * uMeter * normalize(normal); vertex = vertex + trans; } vFrontColor = vec4(baseColor.rgb * lightWeighting, baseColor.a); vBackColor = vec4(baseColor.rgb * backLightWeighting, baseColor.a); } vPosition = vertex; gl_Position = uPMatrix * uMVMatrix * vec4(vertex, 1.0); }", xShaders.vertex_shader_noFPT = " attribute highp float aVertexIndex; attribute highp float aTransformationIndex; attribute highp float aStyleIndex; attribute highp float aProduct; attribute highp float aState; attribute highp vec2 aNormal; uniform mat4 uMVMatrix; uniform mat4 uPMatrix; uniform vec4 ulightA; uniform vec4 ulightB; uniform bool uColorCoding; uniform bool uFloatingPoint; uniform highp sampler2D uVertexSampler; uniform int uVertexTextureSize; uniform highp sampler2D uMatrixSampler; uniform int uMatrixTextureSize; uniform highp sampler2D uStyleSampler; uniform int uStyleTextureSize; uniform highp sampler2D uStateStyleSampler; int stateStyleTextureSize = 15; varying vec4 vColor; varying vec3 vPosition; vec3 getNormal(){ float U = aNormal[0]; float V = aNormal[1]; float PI = 3.1415926535897932384626433832795; float u = ((U / 252.0) * (2.0 * PI)) - PI; float v = ((V / 252.0) * (2.0 * PI)) - PI; float x = sin(v) * cos(u); float y = sin(v) * sin(u); float z = cos(v); return normalize(vec3(x, y, z)); } vec4 getIdColor(){ float R = mod(aProduct, 256.0) / 255.0; float G = floor(aProduct/256.0) / 255.0; float B = floor (aProduct/(256.0*256.0)) / 255.0; return vec4(R, G, B, 1.0); } vec2 getVertexTextureCoordinates(int index, int size) { float x = float(index - (index / size) * size); float y = float(index / size); float pixelSize = 1.0 / float(size); return vec2((x + 0.5) * pixelSize, (y + 0.5) * pixelSize); } int getByteFromScale(float base) { float result = base * 255.0; int correction = fract(result) >= 0.5 ? 1 : 0; return int(result) + correction; } ivec4 getPixel(int index, sampler2D sampler, int size) { vec2 coords = getVertexTextureCoordinates(index, size); vec4 pixel = texture2D(sampler, coords); return ivec4( getByteFromScale(pixel.r), getByteFromScale(pixel.g), getByteFromScale(pixel.b), getByteFromScale(pixel.a) ); } void getBits(ivec4 pixel, out int result[32]) { for (int i = 0; i < 4; i++) { int actualByte = pixel[i]; for (int j = 0; j < 8; j++) { result[31 - (j + i * 8)] =  actualByte - (actualByte / 2) * 2; actualByte /= 2; } } } float getFloatFromPixel(ivec4 pixel) { int bits[32]; getBits(pixel, bits); float sign =  bits[0] == 0 ? 1.0 : -1.0; highp float fraction = 1.0; highp float exponent = 0.0; for (int i = 1; i < 9; i++) { exponent += float(bits[9 - i]) * exp2(float (i - 1)); } exponent -= 127.0; for (int i = 9; i < 32; i++) { fraction += float(bits[i]) * exp2(float((-1)*(i-8))); } return sign * fraction * exp2(exponent); } float getFloatFromPixel(int index, sampler2D sampler, int size) { ivec4 pixel = getPixel(index, sampler, size); return getFloatFromPixel(pixel); } vec4 getColor(){ if (floor(aState + 0.5) == 0.0){ int index = int (floor(aStyleIndex + 0.5)); vec2 coords = getVertexTextureCoordinates(index, uStyleTextureSize); return texture2D(uStyleSampler, coords); } else{ return vec4(1.0,1.0,1.0,1.0); } } vec3 getVertexPosition(){ int index = int (floor(aVertexIndex +0.5))* 3; vec3 position = vec3( getFloatFromPixel(index, uVertexSampler, uVertexTextureSize), getFloatFromPixel(index + 1, uVertexSampler, uVertexTextureSize), getFloatFromPixel(index + 2, uVertexSampler, uVertexTextureSize) ); int tIndex = int(floor(aTransformationIndex + 0.5)); if (tIndex != 65535) { tIndex *= 16; mat4 transform = mat4( getFloatFromPixel(tIndex + 0, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 1, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 2, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 3, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 4, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 5, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 6, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 7, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 8, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 9, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 10, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 11, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 12, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 13, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 14, uMatrixSampler, uMatrixTextureSize), getFloatFromPixel(tIndex + 15, uMatrixSampler, uMatrixTextureSize) ); vec4 transformedPosition = transform * vec4(position, 1.0); return vec3(transformedPosition); } return position; } void main(void) { vec3 vertex = getVertexPosition(); vPosition = vertex; gl_Position = uPMatrix * uMVMatrix * vec4(vertex, 1.0); if (uColorCoding){ vColor = getIdColor(); } else{ vec3 normal = getNormal(); float lightAIntensity = ulightA[3]; vec3 lightADirection = normalize(ulightA.xyz - vPosition); float lightBIntensity = ulightB[3]; vec3 lightBDirection = normalize(ulightB.xyz - vPosition); float lightWeightA = max(dot(normal, lightADirection ) * lightAIntensity, 0.0); float lightWeightB = max(dot(normal, lightBDirection ) * lightBIntensity, 0.0); float lightWeighting = lightWeightA + lightWeightB + 0.4; vec4 baseColor = getColor(); vColor = vec4(baseColor.rgb * lightWeighting, baseColor.a); } }";
    var g = {
      UNDEFINED: 255,
      HIDDEN: 254,
      HIGHLIGHTED: 253,
      XRAYVISIBLE: 252,
      UNSTYLED: 225
    };
    s.prototype.parse = function (e) {
      var t = this,
        r = (e.readByte(), e.readInt32()),
        n = e.readInt32();
      t.vertices = e.readFloat32(3 * r), t.indices = new Uint32Array(3 * n), t.normals = new Uint8Array(6 * n);
      var i,
        a = 0;
      i = r <= 255 ? function (t) {
        return e.readByte(t);
      } : r <= 65535 ? function (t) {
        return e.readUint16(t);
      } : function (t) {
        return e.readInt32(t);
      };
      var o = e.readInt32();
      if (0 !== r && 0 !== n) for (var s = 0; s < o; s++) {
        var l = e.readInt32();
        if (0 != l) {
          var c = l > 0;
          if (l = Math.abs(l), c) {
            var u = e.readByte(2),
              h = i(3 * l);
            t.indices.set(h, a);
            for (var f = 0; f < 3 * l; f++) t.normals[2 * a] = u[0], t.normals[2 * a + 1] = u[1], a++;
          } else for (var f = 0; f < l; f++) t.indices[a] = i(), t.normals.set(e.readByte(2), 2 * a), a++, t.indices[a] = i(), t.normals.set(e.readByte(2), 2 * a), a++, t.indices[a] = i(), t.normals.set(e.readByte(2), 2 * a), a++;
        }
      }
    }, s.prototype.load = function (e) {
      var t = new i(),
        r = this;
      t.onloaded = function () {
        r.parse(t), r.onloaded && r.onloaded();
      }, t.load(e);
    }, s.prototype.vertices = [], s.prototype.indices = [], s.prototype.normals = [], s.prototype.onloaded = function () {}, l.check = function () {
      var e = {
          warnings: [],
          errors: [],
          noErrors: !1,
          noWarnings: !1
        },
        t = document.createElement("canvas");
      if (t) {
        var r = v.setupWebGL(t);
        if (null == r) e.errors.push("Browser doesn't support WebGL. This is critical.");else {
          r.getExtension("OES_texture_float") || r.getExtension("MOZ_OES_texture_float") || r.getExtension("WEBKIT_OES_texture_float") || e.warnings.push("Floating point texture extension is not supported. Performance of the viewer will be very bad. But it should work.");
          var n = r.getParameter(r.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
          n < 4 && e.errors.push("Browser supports only " + n + " vertex texture image units but minimal requirement for the viewer is 4.");
        }
      } else e.errors.push("Browser doesn't have support for HTMLCanvasElement. This is critical.");
      return window.File && window.FileReader && window.Blob || e.errors.push("Browser doesn't support 'File', 'FileReader' or 'Blob' objects."), window.Int32Array && window.Float32Array || e.errors.push("Browser doesn't support TypedArrays. These are crucial for binary parsing and for comunication with GPU."), document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") || e.warnings.push("Browser doesn't support SVG. This is used for user interaction like interactive clipping. Functions using SVG shouldn't crash but they won't work as expected."), 0 == e.errors.length && (e.noErrors = !0), 0 == e.warnings.length && (e.noWarnings = !0), e;
    }, l.prototype.addPlugin = function (e) {
      this._plugins.push(e), e.init && e.init(this);
    }, l.prototype.removePlugin = function (e) {
      var t = this._plugins.indexOf(e, 0);
      t < 0 || this._plugins.splice(t, 1);
    }, l.prototype.defineStyle = function (e, t) {
      if (void 0 === e || e < 0 && e > 224) throw "Style index has to be defined as a number 0-224";
      if (void 0 === t || "undefined" == t.length || 4 != t.length) throw "Colour must be defined as an array of 4 bytes";
      this._stylingChanged = !0;
      var r = new Uint8Array(t);
      this._stateStyles.set(r, 4 * e), this._handles.forEach(function (e) {
        e.stateStyle = this._stateStyles, e.refreshStyles();
      }, this);
    }, l.prototype.setState = function (e, t) {
      if (void 0 === e || !(e >= 225 && e <= 255)) throw "State has to be defined as 225 - 255. Use xState enum.";
      this._handles.forEach(function (r) {
        r.setState(e, t);
      }, this), this._stylingChanged = !0;
    }, l.prototype.getState = function (e) {
      var t = null;
      return this._handles.forEach(function (r) {
        t = r.getState(e);
      }, this), t;
    }, l.prototype.resetStates = function (e) {
      this._handles.forEach(function (e) {
        e.resetStates();
      }, this), e = void 0 === e || e, e && this._handles.forEach(function (e) {
        e.setState(g.HIDDEN, m.IFCSPACE);
      }, this), this._stylingChanged = !0;
    }, l.prototype.getModelState = function (e) {
      var t = this._handles[e];
      if (void 0 === t) throw "Model doesn't exist";
      return t.getModelState();
    }, l.prototype.restoreModelState = function (e, t) {
      var r = this._handles[e];
      if (void 0 === r) throw "Model doesn't exist";
      r.restoreModelState(t), this._stylingChanged = !0;
    }, l.prototype.setStyle = function (e, t) {
      if (void 0 === e || !(e >= 0 && e <= 225)) throw "Style has to be defined as 0 - 225 where 225 is for default style.";
      var r = [this._stateStyles[4 * e], this._stateStyles[4 * e + 1], this._stateStyles[4 * e + 2], this._stateStyles[4 * e + 3]];
      0 == r[0] && 0 == r[1] && 0 == r[2] && 0 == r[3] && console && console.warn && console.warn("You have used undefined colour for restyling. Elements with this style will have transparent black colour and hence will be invisible."), this._handles.forEach(function (r) {
        r.setState(e, t);
      }, this), this._stylingChanged = !0;
    }, l.prototype.getStyle = function (e) {
      return this._handles.forEach(function (t) {
        var r = t.getStyle(e);
        if (null !== r) return r;
      }, this), null;
    }, l.prototype.resetStyles = function () {
      this._handles.forEach(function (e) {
        e.resetStyles();
      }, this), this._stylingChanged = !0;
    }, l.prototype.getProductType = function (e) {
      var t = null;
      return this._handles.forEach(function (r) {
        var n = r.getProductMap(e);
        n && (t = n.type);
      }, this), t;
    }, l.prototype.setCameraPosition = function (e) {
      if (void 0 === e) throw "Parameter coordinates must be defined";
      mat4.lookAt(this._mvMatrix, e, this._origin, [0, 0, 1]);
    }, l.prototype.setCameraTarget = function (e) {
      var t = this,
        r = function r(e) {
          var r = Math.max(e[3], e[4], e[5]),
            n = Math.max(t._width, t._height) / Math.min(t._width, t._height);
          t._distance = r / Math.tan(t.perspectiveCamera.fov * Math.PI / 180) * n * 1;
        };
      if (void 0 !== e && null != e) {
        var n = null;
        return this._handles.every(function (t) {
          var r = t.getProductMap(e);
          return !r || (n = r.bBox, !1);
        }), !!n && (this._origin = [n[0] + n[3] / 2, n[1] + n[4] / 2, n[2] + n[5] / 2], r(n), !0);
      }
      var i = this._handles[0];
      if (i) {
        var a = i.region;
        a && (this._origin = [a.centre[0], a.centre[1], a.centre[2]], r(a.bbox));
      }
      return !0;
    }, l.prototype.set = function (e) {
      for (key in e) this[key] = e[key];
    }, l.prototype.load = function (e, t) {
      if (void 0 === e) throw "You have to specify model to load.";
      if (!("string" == typeof e || e instanceof Blob || e instanceof File)) throw "Model has to be specified either as a URL to wexBIM file or Blob object representing the wexBIM file.";
      var r = this,
        n = new a();
      n.onloaded = function () {
        r._addHandle(n, t);
      }, n.onerror = function (e) {
        r._error(e);
      }, n.load(e);
    }, l.prototype._addHandle = function (e, t) {
      var r = this,
        n = this._gl,
        i = new o(r._gl, e, null != r._fpt);
      r._handles.push(i), i.stateStyle = r._stateStyles, i.feedGPU();
      var a = i._model.meter;
      if (n.uniform1f(r._meterUniformPointer, a), 1 === r._handles.length) {
        r.setCameraTarget();
        var s = i.region,
          l = Math.max(s.bbox[3], s.bbox[4], s.bbox[5]);
        r.perspectiveCamera.far = 50 * l, r.perspectiveCamera.near = a / 10, r.orthogonalCamera.far = r.perspectiveCamera.far, r.orthogonalCamera.near = r.perspectiveCamera.near;
        r.orthogonalCamera.top = l / 1.8, r.orthogonalCamera.bottom = l / 1.8 * -1, r.orthogonalCamera.left = l / 1.8 * -1 * r._width / r._height, r.orthogonalCamera.right = l / 1.8 * r._width / r._height, r.setCameraTarget();
        var c = Math.sqrt(r._distance * r._distance / 3);
        r.setCameraPosition([s.centre[0] + -1 * c, s.centre[1] + -1 * c, s.centre[2] + c]);
      }
      r._fire("loaded", {
        id: i.id,
        tag: t
      }), r._geometryLoaded = !0;
    }, l.prototype.unload = function (e) {
      var t = this._handles.filter(function (t) {
        return t.id === e;
      }).pop();
      if (void 0 === t) throw "Model with id: " + e + " doesn't exist or was unloaded already.";
      t.stopped = !0;
      var r = this._handles.indexOf(t);
      this._handles.splice(r, 1), this._numberOfActiveModels = this._handles.length, t.unload(), t = void 0;
    }, l.prototype._initShaders = function () {
      var e = this._gl,
        t = this,
        r = function r(_r3, n) {
          if (e.shaderSource(_r3, n), e.compileShader(_r3), !e.getShaderParameter(_r3, e.COMPILE_STATUS)) return t._error(e.getShaderInfoLog(_r3)), null;
        },
        n = e.createShader(e.FRAGMENT_SHADER);
      r(n, xShaders.fragment_shader);
      var i = e.createShader(e.VERTEX_SHADER);
      null != this._fpt ? r(i, xShaders.vertex_shader) : r(i, xShaders.vertex_shader_noFPT), this._shaderProgram = e.createProgram(), e.attachShader(this._shaderProgram, i), e.attachShader(this._shaderProgram, n), e.linkProgram(this._shaderProgram), e.getProgramParameter(this._shaderProgram, e.LINK_STATUS) || this._error("Could not initialise shaders "), e.useProgram(this._shaderProgram);
    }, l.prototype._initAttributesAndUniforms = function () {
      var e = this._gl;
      this._pMatrixUniformPointer = e.getUniformLocation(this._shaderProgram, "uPMatrix"), this._mvMatrixUniformPointer = e.getUniformLocation(this._shaderProgram, "uMVMatrix"), this._lightAUniformPointer = e.getUniformLocation(this._shaderProgram, "ulightA"), this._lightBUniformPointer = e.getUniformLocation(this._shaderProgram, "ulightB"), this._colorCodingUniformPointer = e.getUniformLocation(this._shaderProgram, "uColorCoding"), this._clippingPlaneUniformPointer = e.getUniformLocation(this._shaderProgram, "uClippingPlane"), this._meterUniformPointer = e.getUniformLocation(this._shaderProgram, "uMeter"), this._renderingModeUniformPointer = e.getUniformLocation(this._shaderProgram, "uRenderingMode"), this._highlightingColourUniformPointer = e.getUniformLocation(this._shaderProgram, "uHighlightColour"), this._pointers = {
        normalAttrPointer: e.getAttribLocation(this._shaderProgram, "aNormal"),
        indexlAttrPointer: e.getAttribLocation(this._shaderProgram, "aVertexIndex"),
        productAttrPointer: e.getAttribLocation(this._shaderProgram, "aProduct"),
        stateAttrPointer: e.getAttribLocation(this._shaderProgram, "aState"),
        styleAttrPointer: e.getAttribLocation(this._shaderProgram, "aStyleIndex"),
        transformationAttrPointer: e.getAttribLocation(this._shaderProgram, "aTransformationIndex"),
        vertexSamplerUniform: e.getUniformLocation(this._shaderProgram, "uVertexSampler"),
        matrixSamplerUniform: e.getUniformLocation(this._shaderProgram, "uMatrixSampler"),
        styleSamplerUniform: e.getUniformLocation(this._shaderProgram, "uStyleSampler"),
        stateStyleSamplerUniform: e.getUniformLocation(this._shaderProgram, "uStateStyleSampler"),
        vertexTextureSizeUniform: e.getUniformLocation(this._shaderProgram, "uVertexTextureSize"),
        matrixTextureSizeUniform: e.getUniformLocation(this._shaderProgram, "uMatrixTextureSize"),
        styleTextureSizeUniform: e.getUniformLocation(this._shaderProgram, "uStyleTextureSize")
      }, e.enableVertexAttribArray(this._pointers.normalAttrPointer), e.enableVertexAttribArray(this._pointers.indexlAttrPointer), e.enableVertexAttribArray(this._pointers.productAttrPointer), e.enableVertexAttribArray(this._pointers.stateAttrPointer), e.enableVertexAttribArray(this._pointers.styleAttrPointer), e.enableVertexAttribArray(this._pointers.transformationAttrPointer);
    }, l.prototype._initMouseEvents = function () {
      function e(e) {
        o = !0, s = e.clientX, l = e.clientY, c = e.clientX, u = e.clientY;
        var t = a._canvas.getBoundingClientRect(),
          r = c - t.left,
          n = a._height - (u - t.top);
        switch (f = a._getID(r, n), a._fire("mouseDown", {
          id: f
        }), e.button) {
          case 0:
            h = "left";
            break;
          case 1:
            h = "middle";
            break;
          case 2:
            h = "right";
            break;
          default:
            h = "left";
        }
        a._disableTextSelection();
      }
      function t(e) {
        o = !1;
        var t = e.clientX,
          r = e.clientY,
          n = Math.abs(t - c),
          i = Math.abs(r - u);
        if (n < 3 && i < 3 && "left" == h) {
          var s = !1;
          a._plugins.forEach(function (e) {
            e.onBeforePick && (s = s || e.onBeforePick(f));
          }, this), s || a._fire("pick", {
            id: f
          });
        }
        a._enableTextSelection();
      }
      function r(e) {
        if (o && "none" != a.navigationMode) {
          var t = e.clientX,
            r = e.clientY,
            n = t - s,
            c = r - l;
          if (s = t, l = r, "left" == h) switch (a.navigationMode) {
            case "free-orbit":
              i("free-orbit", n, c);
              break;
            case "fixed-orbit":
            case "orbit":
              i("orbit", n, c);
              break;
            case "pan":
              i("pan", n, c);
              break;
            case "zoom":
              i("zoom", n, c);
          }
          "middle" == h && i("pan", n, c);
        }
      }
      function n(e) {
        function t(e) {
          return e = +e, 0 === e || isNaN(e) ? e : e > 0 ? 1 : -1;
        }
        "none" != a.navigationMode && (e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault(), i("zoom", -1 * t(e.deltaX), -1 * t(e.deltaY)));
      }
      function i(e, t, r) {
        function n(e) {
          return e * Math.PI / 180;
        }
        if (a._handles && a._handles[0]) {
          var i = a._origin,
            o = a.getCameraPosition(),
            s = vec3.transformMat4(vec3.create(), i, a._mvMatrix),
            l = vec3.subtract(vec3.create(), i, o),
            c = Math.max(vec3.length(l), a._handles[0]._model.meter),
            u = mat4.translate(mat4.create(), mat4.create(), s);
          switch (e) {
            case "free-orbit":
              u = mat4.rotate(mat4.create(), u, n(r / 4), [1, 0, 0]), u = mat4.rotate(mat4.create(), u, n(t / 4), [0, 1, 0]);
              break;
            case "fixed-orbit":
            case "orbit":
              mat4.rotate(u, u, n(r / 4), [1, 0, 0]);
              var h = vec3.transformMat3(vec3.create(), [0, 0, 1], mat3.fromMat4(mat3.create(), a._mvMatrix));
              h = vec3.normalize(vec3.create(), h), u = mat4.rotate(mat4.create(), u, n(t / 4), h);
              break;
            case "pan":
              mat4.translate(u, u, [t * c / 150, 0, 0]), mat4.translate(u, u, [0, -1 * r * c / 150, 0]);
              break;
            case "zoom":
              mat4.translate(u, u, [0, 0, t * c / 20]), mat4.translate(u, u, [0, 0, r * c / 20]);
          }
          var f = vec3.negate(vec3.create(), s);
          u = mat4.translate(mat4.create(), u, f), a._mvMatrix = mat4.multiply(mat4.create(), u, a._mvMatrix);
        }
      }
      var a = this,
        o = !1,
        s = null,
        l = null,
        c = null,
        u = null,
        h = "L",
        f = -1,
        d = a.height,
        p = a.width;
      setInterval(function () {
        a._canvas.offsetHeight === d && a._canvas.offsetWidth === p || (d = a._height = a._canvas.height = a._canvas.offsetHeight, p = a._width = a._canvas.width = a._canvas.offsetWidth);
      }, 500), this._canvas.addEventListener("mousedown", e, !0), this._canvas.addEventListener("wheel", n, !0), window.addEventListener("mouseup", t, !0), window.addEventListener("mousemove", r, !0), this._canvas.addEventListener("mousemove", function () {
        a._userAction = !0;
      }, !0), this._canvas.addEventListener("dblclick", function () {
        a._fire("dblclick", {
          id: f
        });
      }, !0);
    }, l.prototype.draw = function () {
      if (this._geometryLoaded && 0 != this._handles.length && (this._stylingChanged || this._isChanged()) || this._userAction) {
        this._userAction = !1, this._plugins.forEach(function (e) {
          e.onBeforeDraw && e.onBeforeDraw();
        }, this), this._stylingChanged = !1;
        var e = this._gl,
          t = this._width,
          r = this._height;
        switch (e.useProgram(this._shaderProgram), e.viewport(0, 0, t, r), e.clearColor(this.background[0] / 255, this.background[1] / 255, this.background[2] / 255, this.background[3] / 255), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT), this.camera) {
          case "perspective":
            mat4.perspective(this._pMatrix, this.perspectiveCamera.fov * Math.PI / 180, this._width / this._height, this.perspectiveCamera.near, this.perspectiveCamera.far);
            break;
          case "orthogonal":
            mat4.ortho(this._pMatrix, this.orthogonalCamera.left, this.orthogonalCamera.right, this.orthogonalCamera.bottom, this.orthogonalCamera.top, this.orthogonalCamera.near, this.orthogonalCamera.far);
            break;
          default:
            mat4.perspective(this._pMatrix, this.perspectiveCamera.fov * Math.PI / 180, this._width / this._height, this.perspectiveCamera.near, this.perspectiveCamera.far);
        }
        e.uniformMatrix4fv(this._pMatrixUniformPointer, !1, this._pMatrix), e.uniformMatrix4fv(this._mvMatrixUniformPointer, !1, this._mvMatrix), e.uniform4fv(this._lightAUniformPointer, new Float32Array(this.lightA)), e.uniform4fv(this._lightBUniformPointer, new Float32Array(this.lightB)), e.uniform4fv(this._clippingPlaneUniformPointer, new Float32Array(this.clippingPlane)), e.uniform1i(this._colorCodingUniformPointer, 0), e.uniform4fv(this._highlightingColourUniformPointer, new Float32Array([this.highlightingColour[0] / 255, this.highlightingColour[1] / 255, this.highlightingColour[2] / 255, this.highlightingColour[3] / 255])), "x-ray" == this.renderingMode ? (e.uniform1i(this._renderingModeUniformPointer, 2), e.disable(e.CULL_FACE), this._handles.forEach(function (e) {
          e.stopped || (e.setActive(this._pointers), e.draw("solid"));
        }, this), e.uniform1i(this._renderingModeUniformPointer, 2), e.enable(e.CULL_FACE), this._handles.forEach(function (e) {
          e.stopped || (e.setActive(this._pointers), e.draw("transparent"));
        }, this), e.uniform1i(this._renderingModeUniformPointer, 0)) : (e.uniform1i(this._renderingModeUniformPointer, 0), e.disable(e.CULL_FACE), this._handles.forEach(function (e) {
          e.stopped || (e.setActive(this._pointers), e.draw("solid"));
        }, this), this._handles.forEach(function (e) {
          e.stopped || (e.setActive(this._pointers), e.draw("transparent"));
        }, this)), this._plugins.forEach(function (e) {
          e.onAfterDraw && e.onAfterDraw();
        }, this), this._fire("frame", {});
      }
    }, l.prototype._isChanged = function () {
      var e = !0;
      return this._visualStateAttributes.forEach(function (t) {
        var r = (0, f.default)(this[t]),
          n = this._lastStates[t];
        this._lastStates[t] = r, e = e && r === n;
      }, this), !e;
    }, l.prototype.getCameraPosition = function () {
      var e = mat4.create();
      mat4.multiply(e, this._pMatrix, this._mvMatrix);
      var t = mat4.create();
      mat4.invert(t, e);
      var r = vec3.create();
      return vec3.transformMat4(r, vec3.create(), t), r;
    }, l.prototype.zoomTo = function (e) {
      if (!this.setCameraTarget(e)) return !1;
      var t = this.getCameraPosition(),
        r = vec3.create();
      vec3.subtract(r, t, this._origin), r = vec3.normalize(vec3.create(), r);
      var n = vec3.create();
      return vec3.scale(n, r, this._distance), vec3.add(t, n, this._origin), mat4.lookAt(this._mvMatrix, t, this._origin, [0, 0, 1]), !0;
    }, l.prototype.show = function (e) {
      var t = this._origin,
        r = this._distance,
        n = [0, 0, 0],
        i = [0, 0, 1];
      switch (e) {
        case "top":
          return void mat4.translate(this._mvMatrix, mat4.create(), [-1 * t[0], -1 * t[1], -1 * (r + t[2])]);
        case "bottom":
          var a = mat4.translate(mat4.create(), mat4.create(), [-1 * t[0], 1 * t[1], -1 * (t[2] + r)]),
            o = mat4.rotateY(mat4.create(), a, Math.PI),
            s = mat4.rotateZ(mat4.create(), o, Math.PI);
          return void (this._mvMatrix = s);
        case "front":
          n = [t[0], t[1] - r, t[2]];
          break;
        case "back":
          n = [t[0], t[1] + r, t[2]];
          break;
        case "left":
          n = [t[0] - r, t[1], t[2]];
          break;
        case "right":
          n = [t[0] + r, t[1], t[2]];
      }
      mat4.lookAt(this._mvMatrix, n, t, i);
    }, l.prototype._error = function (e) {
      this._fire("error", {
        message: e
      });
    }, l.prototype._getID = function (e, t) {
      this._plugins.forEach(function (e) {
        e.onBeforeDrawId && e.onBeforeDrawId();
      }, this);
      var r = this._gl,
        n = this._width / 2,
        i = this._height / 2;
      e /= 2, t /= 2;
      var a = r.createFramebuffer();
      r.bindFramebuffer(r.FRAMEBUFFER, a);
      var o = r.createRenderbuffer();
      r.bindRenderbuffer(r.RENDERBUFFER, o), r.renderbufferStorage(r.RENDERBUFFER, r.DEPTH_COMPONENT16, n, i);
      var s = r.createTexture();
      if (r.activeTexture(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, s), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, n, i, 0, r.RGBA, r.UNSIGNED_BYTE, null), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, r.NEAREST), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, r.NEAREST), r.framebufferRenderbuffer(r.FRAMEBUFFER, r.DEPTH_ATTACHMENT, r.RENDERBUFFER, o), r.framebufferTexture2D(r.FRAMEBUFFER, r.COLOR_ATTACHMENT0, r.TEXTURE_2D, s, 0), r.checkFramebufferStatus(r.FRAMEBUFFER) != r.FRAMEBUFFER_COMPLETE) return this._error("this combination of attachments does not work"), null;
      r.bindFramebuffer(r.FRAMEBUFFER, a), r.viewport(0, 0, n, i), r.enable(r.DEPTH_TEST), r.disable(r.BLEND), r.clearColor(0, 0, 0, 0), r.clear(r.COLOR_BUFFER_BIT | r.DEPTH_BUFFER_BIT), r.uniform1i(this._colorCodingUniformPointer, 1), this._handles.forEach(function (e) {
        e.stopped || (e.setActive(this._pointers), e.draw());
      }, this), this._plugins.forEach(function (e) {
        e.onAfterDrawId && e.onAfterDrawId();
      }, this);
      var l = new Uint8Array(4);
      if (r.readPixels(e, t, 1, 1, r.RGBA, r.UNSIGNED_BYTE, l), r.bindFramebuffer(r.FRAMEBUFFER, null), r.deleteTexture(s), r.deleteRenderbuffer(o), r.deleteFramebuffer(a), r.blendFunc(r.SRC_ALPHA, r.ONE_MINUS_SRC_ALPHA), r.enable(r.BLEND), 0 != l[3]) {
        var c = l[0] + 256 * l[1] + 256 * l[2] * 256,
          u = !1;
        return this._plugins.forEach(function (e) {
          e.onBeforeGetId && (u = u || e.onBeforeGetId(c));
        }, this), u ? null : c;
      }
      return null;
    }, l.prototype.start = function (e) {
      function t() {
        if (30 == ++a) {
          a = 0;
          var e = new Date(),
            r = e.getTime() - i.getTime();
          i = e;
          var o = 1e3 / r * 30;
          n._fire("fps", Math.floor(o));
        }
        n._isRunning && (window.requestAnimFrame(t), n.draw());
      }
      if (void 0 !== e) {
        var r = this._handles.filter(function (t) {
          return t.id === e;
        }).pop();
        if (void 0 === r) throw "Model doesn't exist.";
        return r.stopped = !1, void this._numberOfActiveModels++;
      }
      this._isRunning = !0;
      var n = this,
        i = new Date(),
        a = 0;
      t();
    }, l.prototype.stop = function (e) {
      if (void 0 === e) return void (this._isRunning = !1);
      var t = this._handles.filter(function (t) {
        return t.id === e;
      }).pop();
      if (void 0 === t) throw "Model doesn't exist.";
      t.stopped = !0, this._numberOfActiveModels--;
    }, l.prototype.on = function (e, t) {
      var r = this._events;
      r[e] || (r[e] = []), r[e].push(t);
    }, l.prototype.off = function (e, t) {
      var r = this._events,
        n = r[e];
      if (n) {
        var i = n.indexOf(t);
        i >= 0 && n.splice(i, 1);
      }
    }, l.prototype._fire = function (e, t) {
      var r = this._events[e];
      r && r.forEach(function (e) {
        e(t);
      }, this);
    }, l.prototype._disableTextSelection = function () {
      document.documentElement.style["-webkit-touch-callout"] = "none", document.documentElement.style["-webkit-user-select"] = "none", document.documentElement.style["-khtml-user-select"] = "none", document.documentElement.style["-moz-user-select"] = "none", document.documentElement.style["-ms-user-select"] = "none", document.documentElement.style["user-select"] = "none";
    }, l.prototype._enableTextSelection = function () {
      document.documentElement.style["-webkit-touch-callout"] = "text", document.documentElement.style["-webkit-user-select"] = "text", document.documentElement.style["-khtml-user-select"] = "text", document.documentElement.style["-moz-user-select"] = "text", document.documentElement.style["-ms-user-select"] = "text", document.documentElement.style["user-select"] = "text";
    }, l.prototype._getSVGOverlay = function () {
      if (!document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1")) return !1;
      var e = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
        t = function (e) {
          var t = e.getBoundingClientRect(),
            r = document.body,
            n = document.documentElement,
            i = window.pageYOffset || n.scrollTop || r.scrollTop,
            a = window.pageXOffset || n.scrollLeft || r.scrollLeft,
            o = n.clientTop || r.clientTop || 0,
            s = n.clientLeft || r.clientLeft || 0,
            l = n.clientBottom || r.clientBottom || 0,
            c = n.clientRight || r.clientRight || 0,
            u = Math.round(t.top + i - o),
            h = Math.round(t.left + a - s),
            f = Math.round(t.top + i - l);
          return {
            top: u,
            left: h,
            width: Math.round(t.left + a - c) - h,
            height: f - u
          };
        }(this._canvas);
      return e.style.position = "absolute", e.style.top = t.top + "px", e.style.left = t.left + "px", e.style["z-index"] = 100, e.setAttribute("width", this._width), e.setAttribute("height", this._height), e;
    }, l.prototype.getClip = function () {
      var e = this.clippingPlane;
      if (e.every(function (e) {
        return 0 === e;
      })) return [[0, 0, 0], [0, 0, 0]];
      var t = vec3.normalize([0, 0, 0], [e[0], e[1], e[2]]),
        r = this._lastClippingPoint,
        n = r[0] * e[0] + r[1] * e[1] + r[2] * e[2] + e[3];
      return Math.abs(n) < 1e-5 ? [r, t] : [[0 !== e[0] ? -1 * e[3] / e[0] : 0, 0 !== e[1] ? -1 * e[3] / e[1] : 0, 0 !== e[2] ? -1 * e[3] / e[2] : 0], t];
    }, l.prototype.clip = function (e, t) {
      if (void 0 !== e && void 0 !== t) {
        this._lastClippingPoint = e;
        var r = 0 - t[0] * e[0] - t[1] * e[1] - t[2] * e[2];
        return this.clippingPlane = [t[0], t[1], t[2], r], void this._fire("clipped", {});
      }
      var n = "http://www.w3.org/2000/svg",
        i = this._getSVGOverlay(),
        a = this,
        o = {},
        s = !1,
        l = {},
        c = function c(e) {
          if (!s) {
            s = !0, a._disableTextSelection();
            var t = i.getBoundingClientRect();
            o.x = e.clientX - t.left, o.y = e.clientY - t.top, o.angle = 0, l = document.createElementNS(n, "g"), l.setAttribute("id", "section"), i.appendChild(l);
            var r = document.createElementNS(n, "line");
            l.appendChild(r), r.setAttribute("style", "stroke:rgb(255,0,0);stroke-width:2"), r.setAttribute("x1", o.x), r.setAttribute("y1", 99999), r.setAttribute("x2", o.x), r.setAttribute("y2", -99999);
          }
        },
        u = function e(t) {
          if (s) {
            var r = i.getBoundingClientRect();
            if (o.x != t.clientX - r.left || o.y != t.clientY - r.top) {
              s = !1, a._enableTextSelection();
              var n = mat4.create();
              mat4.multiply(n, a._pMatrix, a._mvMatrix);
              var l = mat4.create();
              mat4.invert(l, n);
              var u = o.x / (a._width / 2) - 1,
                f = 1 - o.y / (a._height / 2),
                d = vec3.create();
              vec3.transformMat4(d, [u, f, -1], l);
              var p = vec3.create();
              vec3.transformMat4(p, [u, f, 1], l);
              var m = o.angle * Math.PI / 180,
                g = u + Math.cos(m),
                v = f + Math.sin(m),
                b = vec3.create();
              vec3.transformMat4(b, [g, v, 1], l);
              var y = vec3.subtract(vec3.create(), d, p),
                w = vec3.subtract(vec3.create(), b, p),
                x = vec3.cross(vec3.create(), y, w);
              a.clip(p, x), i.parentNode.removeChild(i), i.removeEventListener("mousedown", c, !0), window.removeEventListener("mouseup", e, !0), window.removeEventListener("mousemove", h, !0);
            }
          }
        },
        h = function h(e) {
          if (s) {
            var t = i.getBoundingClientRect(),
              r = e.clientX - t.left,
              n = e.clientY - t.top,
              a = r - o.x,
              c = n - o.y,
              u = -180 * Math.atan2(a, c) / Math.PI + 90;
            u = 5 * Math.round(u / 5), o.angle = 360 - u + 90, l.setAttribute("transform", "rotate(" + u + " " + o.x + " " + o.y + ")");
          }
        };
      document.documentElement.appendChild(i), i.addEventListener("mousedown", c, !0), window.addEventListener("mouseup", u, !0), window.addEventListener("mousemove", h, !0), this.stopClipping = function () {
        i.parentNode.removeChild(i), i.removeEventListener("mousedown", c, !0), window.removeEventListener("mouseup", u, !0), window.removeEventListener("mousemove", h, !0), a.stopClipping = function () {};
      };
    }, l.prototype.stopClipping = function () {}, l.prototype.unclip = function () {
      this.clippingPlane = [0, 0, 0, 0], this._fire("unclipped", {});
    };
    var v = function () {
      var e = function e(_e2) {
          return '<table style="background-color: #8CE; width: 100%; height: 100%;"><tr><td align="center"><div style="display: table-cell; vertical-align: middle;"><div style="">' + _e2 + "</div></div></td></tr></table>";
        },
        t = 'This page requires a browser that supports WebGL.<br/><a href="http://get.webgl.org">Click here to upgrade your browser.</a>',
        r = 'It doesn\'t appear your computer can support WebGL.<br/><a href="http://get.webgl.org/troubleshooting/">Click here for more information.</a>',
        n = function n(_n4, a, o) {
          function s(i) {
            var a = _n4.parentNode;
            if (a) {
              var o = window.WebGLRenderingContext ? r : t;
              i && (o += "<br/><br/>Status: " + i), a.innerHTML = e(o);
            }
          }
          o = o || s, _n4.addEventListener && _n4.addEventListener("webglcontextcreationerror", function (e) {
            o(e.statusMessage);
          }, !1);
          var l = i(_n4, a);
          return l || window.WebGLRenderingContext || o(""), l;
        },
        i = function i(e, t) {
          for (var r = ["webgl", "experimental-webgl", "webkit-3d", "moz-webgl"], n = null, i = 0; i < r.length; ++i) {
            try {
              n = e.getContext(r[i], t);
            } catch (e) {}
            if (n) break;
          }
          return n;
        };
      return {
        create3DContext: i,
        setupWebGL: n
      };
    }();
    window.requestAnimFrame = function () {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e, t) {
        window.setTimeout(e, 1e3 / 60);
      };
    }(), function (e) {
      var r = {};
      r.exports = t, function (t) {
        if (!r) var r = 1e-6;
        if (!n) var n = "undefined" != typeof Float32Array ? Float32Array : Array;
        if (!i) var i = Math.random;
        var a = {};
        a.setMatrixArrayType = function (e) {
          n = e;
        }, void 0 !== t && (t.glMatrix = a);
        var o = Math.PI / 180;
        a.toRadian = function (e) {
          return e * o;
        };
        var s = {};
        s.create = function () {
          var e = new n(2);
          return e[0] = 0, e[1] = 0, e;
        }, s.clone = function (e) {
          var t = new n(2);
          return t[0] = e[0], t[1] = e[1], t;
        }, s.fromValues = function (e, t) {
          var r = new n(2);
          return r[0] = e, r[1] = t, r;
        }, s.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e;
        }, s.set = function (e, t, r) {
          return e[0] = t, e[1] = r, e;
        }, s.add = function (e, t, r) {
          return e[0] = t[0] + r[0], e[1] = t[1] + r[1], e;
        }, s.subtract = function (e, t, r) {
          return e[0] = t[0] - r[0], e[1] = t[1] - r[1], e;
        }, s.sub = s.subtract, s.multiply = function (e, t, r) {
          return e[0] = t[0] * r[0], e[1] = t[1] * r[1], e;
        }, s.mul = s.multiply, s.divide = function (e, t, r) {
          return e[0] = t[0] / r[0], e[1] = t[1] / r[1], e;
        }, s.div = s.divide, s.min = function (e, t, r) {
          return e[0] = Math.min(t[0], r[0]), e[1] = Math.min(t[1], r[1]), e;
        }, s.max = function (e, t, r) {
          return e[0] = Math.max(t[0], r[0]), e[1] = Math.max(t[1], r[1]), e;
        }, s.scale = function (e, t, r) {
          return e[0] = t[0] * r, e[1] = t[1] * r, e;
        }, s.scaleAndAdd = function (e, t, r, n) {
          return e[0] = t[0] + r[0] * n, e[1] = t[1] + r[1] * n, e;
        }, s.distance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1];
          return Math.sqrt(r * r + n * n);
        }, s.dist = s.distance, s.squaredDistance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1];
          return r * r + n * n;
        }, s.sqrDist = s.squaredDistance, s.length = function (e) {
          var t = e[0],
            r = e[1];
          return Math.sqrt(t * t + r * r);
        }, s.len = s.length, s.squaredLength = function (e) {
          var t = e[0],
            r = e[1];
          return t * t + r * r;
        }, s.sqrLen = s.squaredLength, s.negate = function (e, t) {
          return e[0] = -t[0], e[1] = -t[1], e;
        }, s.inverse = function (e, t) {
          return e[0] = 1 / t[0], e[1] = 1 / t[1], e;
        }, s.normalize = function (e, t) {
          var r = t[0],
            n = t[1],
            i = r * r + n * n;
          return i > 0 && (i = 1 / Math.sqrt(i), e[0] = t[0] * i, e[1] = t[1] * i), e;
        }, s.dot = function (e, t) {
          return e[0] * t[0] + e[1] * t[1];
        }, s.cross = function (e, t, r) {
          var n = t[0] * r[1] - t[1] * r[0];
          return e[0] = e[1] = 0, e[2] = n, e;
        }, s.lerp = function (e, t, r, n) {
          var i = t[0],
            a = t[1];
          return e[0] = i + n * (r[0] - i), e[1] = a + n * (r[1] - a), e;
        }, s.random = function (e, t) {
          t = t || 1;
          var r = 2 * i() * Math.PI;
          return e[0] = Math.cos(r) * t, e[1] = Math.sin(r) * t, e;
        }, s.transformMat2 = function (e, t, r) {
          var n = t[0],
            i = t[1];
          return e[0] = r[0] * n + r[2] * i, e[1] = r[1] * n + r[3] * i, e;
        }, s.transformMat2d = function (e, t, r) {
          var n = t[0],
            i = t[1];
          return e[0] = r[0] * n + r[2] * i + r[4], e[1] = r[1] * n + r[3] * i + r[5], e;
        }, s.transformMat3 = function (e, t, r) {
          var n = t[0],
            i = t[1];
          return e[0] = r[0] * n + r[3] * i + r[6], e[1] = r[1] * n + r[4] * i + r[7], e;
        }, s.transformMat4 = function (e, t, r) {
          var n = t[0],
            i = t[1];
          return e[0] = r[0] * n + r[4] * i + r[12], e[1] = r[1] * n + r[5] * i + r[13], e;
        }, s.forEach = function () {
          var e = s.create();
          return function (t, r, n, i, a, o) {
            var s, l;
            for (r || (r = 2), n || (n = 0), l = i ? Math.min(i * r + n, t.length) : t.length, s = n; s < l; s += r) e[0] = t[s], e[1] = t[s + 1], a(e, e, o), t[s] = e[0], t[s + 1] = e[1];
            return t;
          };
        }(), s.str = function (e) {
          return "vec2(" + e[0] + ", " + e[1] + ")";
        }, void 0 !== t && (t.vec2 = s), e.vec3 = {}, vec3.create = function () {
          var e = new n(3);
          return e[0] = 0, e[1] = 0, e[2] = 0, e;
        }, vec3.clone = function (e) {
          var t = new n(3);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t;
        }, vec3.fromValues = function (e, t, r) {
          var i = new n(3);
          return i[0] = e, i[1] = t, i[2] = r, i;
        }, vec3.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e;
        }, vec3.set = function (e, t, r, n) {
          return e[0] = t, e[1] = r, e[2] = n, e;
        }, vec3.add = function (e, t, r) {
          return e[0] = t[0] + r[0], e[1] = t[1] + r[1], e[2] = t[2] + r[2], e;
        }, vec3.subtract = function (e, t, r) {
          return e[0] = t[0] - r[0], e[1] = t[1] - r[1], e[2] = t[2] - r[2], e;
        }, vec3.sub = vec3.subtract, vec3.multiply = function (e, t, r) {
          return e[0] = t[0] * r[0], e[1] = t[1] * r[1], e[2] = t[2] * r[2], e;
        }, vec3.mul = vec3.multiply, vec3.divide = function (e, t, r) {
          return e[0] = t[0] / r[0], e[1] = t[1] / r[1], e[2] = t[2] / r[2], e;
        }, vec3.div = vec3.divide, vec3.min = function (e, t, r) {
          return e[0] = Math.min(t[0], r[0]), e[1] = Math.min(t[1], r[1]), e[2] = Math.min(t[2], r[2]), e;
        }, vec3.max = function (e, t, r) {
          return e[0] = Math.max(t[0], r[0]), e[1] = Math.max(t[1], r[1]), e[2] = Math.max(t[2], r[2]), e;
        }, vec3.scale = function (e, t, r) {
          return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e;
        }, vec3.scaleAndAdd = function (e, t, r, n) {
          return e[0] = t[0] + r[0] * n, e[1] = t[1] + r[1] * n, e[2] = t[2] + r[2] * n, e;
        }, vec3.distance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1],
            i = t[2] - e[2];
          return Math.sqrt(r * r + n * n + i * i);
        }, vec3.dist = vec3.distance, vec3.squaredDistance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1],
            i = t[2] - e[2];
          return r * r + n * n + i * i;
        }, vec3.sqrDist = vec3.squaredDistance, vec3.length = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2];
          return Math.sqrt(t * t + r * r + n * n);
        }, vec3.len = vec3.length, vec3.squaredLength = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2];
          return t * t + r * r + n * n;
        }, vec3.sqrLen = vec3.squaredLength, vec3.negate = function (e, t) {
          return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e;
        }, vec3.inverse = function (e, t) {
          return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e;
        }, vec3.normalize = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = r * r + n * n + i * i;
          return a > 0 && (a = 1 / Math.sqrt(a), e[0] = t[0] * a, e[1] = t[1] * a, e[2] = t[2] * a), e;
        }, vec3.dot = function (e, t) {
          return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
        }, vec3.cross = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = r[0],
            s = r[1],
            l = r[2];
          return e[0] = i * l - a * s, e[1] = a * o - n * l, e[2] = n * s - i * o, e;
        }, vec3.lerp = function (e, t, r, n) {
          var i = t[0],
            a = t[1],
            o = t[2];
          return e[0] = i + n * (r[0] - i), e[1] = a + n * (r[1] - a), e[2] = o + n * (r[2] - o), e;
        }, vec3.random = function (e, t) {
          t = t || 1;
          var r = 2 * i() * Math.PI,
            n = 2 * i() - 1,
            a = Math.sqrt(1 - n * n) * t;
          return e[0] = Math.cos(r) * a, e[1] = Math.sin(r) * a, e[2] = n * t, e;
        }, vec3.transformMat4 = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = r[3] * n + r[7] * i + r[11] * a + r[15];
          return o = o || 1, e[0] = (r[0] * n + r[4] * i + r[8] * a + r[12]) / o, e[1] = (r[1] * n + r[5] * i + r[9] * a + r[13]) / o, e[2] = (r[2] * n + r[6] * i + r[10] * a + r[14]) / o, e;
        }, vec3.transformMat3 = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2];
          return e[0] = n * r[0] + i * r[3] + a * r[6], e[1] = n * r[1] + i * r[4] + a * r[7], e[2] = n * r[2] + i * r[5] + a * r[8], e;
        }, vec3.transformQuat = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = r[0],
            s = r[1],
            l = r[2],
            c = r[3],
            u = c * n + s * a - l * i,
            h = c * i + l * n - o * a,
            f = c * a + o * i - s * n,
            d = -o * n - s * i - l * a;
          return e[0] = u * c + d * -o + h * -l - f * -s, e[1] = h * c + d * -s + f * -o - u * -l, e[2] = f * c + d * -l + u * -s - h * -o, e;
        }, vec3.rotateX = function (e, t, r, n) {
          var i = [],
            a = [];
          return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], a[0] = i[0], a[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), a[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), e[0] = a[0] + r[0], e[1] = a[1] + r[1], e[2] = a[2] + r[2], e;
        }, vec3.rotateY = function (e, t, r, n) {
          var i = [],
            a = [];
          return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], a[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), a[1] = i[1], a[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), e[0] = a[0] + r[0], e[1] = a[1] + r[1], e[2] = a[2] + r[2], e;
        }, vec3.rotateZ = function (e, t, r, n) {
          var i = [],
            a = [];
          return i[0] = t[0] - r[0], i[1] = t[1] - r[1], i[2] = t[2] - r[2], a[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), a[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), a[2] = i[2], e[0] = a[0] + r[0], e[1] = a[1] + r[1], e[2] = a[2] + r[2], e;
        }, vec3.forEach = function () {
          var e = vec3.create();
          return function (t, r, n, i, a, o) {
            var s, l;
            for (r || (r = 3), n || (n = 0), l = i ? Math.min(i * r + n, t.length) : t.length, s = n; s < l; s += r) e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2];
            return t;
          };
        }(), vec3.str = function (e) {
          return "vec3(" + e[0] + ", " + e[1] + ", " + e[2] + ")";
        }, void 0 !== t && (t.vec3 = vec3);
        var l = {};
        l.create = function () {
          var e = new n(4);
          return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0, e;
        }, l.clone = function (e) {
          var t = new n(4);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
        }, l.fromValues = function (e, t, r, i) {
          var a = new n(4);
          return a[0] = e, a[1] = t, a[2] = r, a[3] = i, a;
        }, l.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
        }, l.set = function (e, t, r, n, i) {
          return e[0] = t, e[1] = r, e[2] = n, e[3] = i, e;
        }, l.add = function (e, t, r) {
          return e[0] = t[0] + r[0], e[1] = t[1] + r[1], e[2] = t[2] + r[2], e[3] = t[3] + r[3], e;
        }, l.subtract = function (e, t, r) {
          return e[0] = t[0] - r[0], e[1] = t[1] - r[1], e[2] = t[2] - r[2], e[3] = t[3] - r[3], e;
        }, l.sub = l.subtract, l.multiply = function (e, t, r) {
          return e[0] = t[0] * r[0], e[1] = t[1] * r[1], e[2] = t[2] * r[2], e[3] = t[3] * r[3], e;
        }, l.mul = l.multiply, l.divide = function (e, t, r) {
          return e[0] = t[0] / r[0], e[1] = t[1] / r[1], e[2] = t[2] / r[2], e[3] = t[3] / r[3], e;
        }, l.div = l.divide, l.min = function (e, t, r) {
          return e[0] = Math.min(t[0], r[0]), e[1] = Math.min(t[1], r[1]), e[2] = Math.min(t[2], r[2]), e[3] = Math.min(t[3], r[3]), e;
        }, l.max = function (e, t, r) {
          return e[0] = Math.max(t[0], r[0]), e[1] = Math.max(t[1], r[1]), e[2] = Math.max(t[2], r[2]), e[3] = Math.max(t[3], r[3]), e;
        }, l.scale = function (e, t, r) {
          return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e;
        }, l.scaleAndAdd = function (e, t, r, n) {
          return e[0] = t[0] + r[0] * n, e[1] = t[1] + r[1] * n, e[2] = t[2] + r[2] * n, e[3] = t[3] + r[3] * n, e;
        }, l.distance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1],
            i = t[2] - e[2],
            a = t[3] - e[3];
          return Math.sqrt(r * r + n * n + i * i + a * a);
        }, l.dist = l.distance, l.squaredDistance = function (e, t) {
          var r = t[0] - e[0],
            n = t[1] - e[1],
            i = t[2] - e[2],
            a = t[3] - e[3];
          return r * r + n * n + i * i + a * a;
        }, l.sqrDist = l.squaredDistance, l.length = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2],
            i = e[3];
          return Math.sqrt(t * t + r * r + n * n + i * i);
        }, l.len = l.length, l.squaredLength = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2],
            i = e[3];
          return t * t + r * r + n * n + i * i;
        }, l.sqrLen = l.squaredLength, l.negate = function (e, t) {
          return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = -t[3], e;
        }, l.inverse = function (e, t) {
          return e[0] = 1 / t[0], e[1] = 1 / t[1], e[2] = 1 / t[2], e[3] = 1 / t[3], e;
        }, l.normalize = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = r * r + n * n + i * i + a * a;
          return o > 0 && (o = 1 / Math.sqrt(o), e[0] = t[0] * o, e[1] = t[1] * o, e[2] = t[2] * o, e[3] = t[3] * o), e;
        }, l.dot = function (e, t) {
          return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
        }, l.lerp = function (e, t, r, n) {
          var i = t[0],
            a = t[1],
            o = t[2],
            s = t[3];
          return e[0] = i + n * (r[0] - i), e[1] = a + n * (r[1] - a), e[2] = o + n * (r[2] - o), e[3] = s + n * (r[3] - s), e;
        }, l.random = function (e, t) {
          return t = t || 1, e[0] = i(), e[1] = i(), e[2] = i(), e[3] = i(), l.normalize(e, e), l.scale(e, e, t), e;
        }, l.transformMat4 = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3];
          return e[0] = r[0] * n + r[4] * i + r[8] * a + r[12] * o, e[1] = r[1] * n + r[5] * i + r[9] * a + r[13] * o, e[2] = r[2] * n + r[6] * i + r[10] * a + r[14] * o, e[3] = r[3] * n + r[7] * i + r[11] * a + r[15] * o, e;
        }, l.transformQuat = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = r[0],
            s = r[1],
            l = r[2],
            c = r[3],
            u = c * n + s * a - l * i,
            h = c * i + l * n - o * a,
            f = c * a + o * i - s * n,
            d = -o * n - s * i - l * a;
          return e[0] = u * c + d * -o + h * -l - f * -s, e[1] = h * c + d * -s + f * -o - u * -l, e[2] = f * c + d * -l + u * -s - h * -o, e;
        }, l.forEach = function () {
          var e = l.create();
          return function (t, r, n, i, a, o) {
            var s, l;
            for (r || (r = 4), n || (n = 0), l = i ? Math.min(i * r + n, t.length) : t.length, s = n; s < l; s += r) e[0] = t[s], e[1] = t[s + 1], e[2] = t[s + 2], e[3] = t[s + 3], a(e, e, o), t[s] = e[0], t[s + 1] = e[1], t[s + 2] = e[2], t[s + 3] = e[3];
            return t;
          };
        }(), l.str = function (e) {
          return "vec4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
        }, void 0 !== t && (t.vec4 = l);
        var c = {};
        c.create = function () {
          var e = new n(4);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e;
        }, c.clone = function (e) {
          var t = new n(4);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t;
        }, c.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e;
        }, c.identity = function (e) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e;
        }, c.transpose = function (e, t) {
          if (e === t) {
            var r = t[1];
            e[1] = t[2], e[2] = r;
          } else e[0] = t[0], e[1] = t[2], e[2] = t[1], e[3] = t[3];
          return e;
        }, c.invert = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = r * a - i * n;
          return o ? (o = 1 / o, e[0] = a * o, e[1] = -n * o, e[2] = -i * o, e[3] = r * o, e) : null;
        }, c.adjoint = function (e, t) {
          var r = t[0];
          return e[0] = t[3], e[1] = -t[1], e[2] = -t[2], e[3] = r, e;
        }, c.determinant = function (e) {
          return e[0] * e[3] - e[2] * e[1];
        }, c.multiply = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = r[0],
            l = r[1],
            c = r[2],
            u = r[3];
          return e[0] = n * s + a * l, e[1] = i * s + o * l, e[2] = n * c + a * u, e[3] = i * c + o * u, e;
        }, c.mul = c.multiply, c.rotate = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = Math.sin(r),
            l = Math.cos(r);
          return e[0] = n * l + a * s, e[1] = i * l + o * s, e[2] = n * -s + a * l, e[3] = i * -s + o * l, e;
        }, c.scale = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = r[0],
            l = r[1];
          return e[0] = n * s, e[1] = i * s, e[2] = a * l, e[3] = o * l, e;
        }, c.str = function (e) {
          return "mat2(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
        }, c.frob = function (e) {
          return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2) + Math.pow(e[2], 2) + Math.pow(e[3], 2));
        }, c.LDU = function (e, t, r, n) {
          return e[2] = n[2] / n[0], r[0] = n[0], r[1] = n[1], r[3] = n[3] - e[2] * r[1], [e, t, r];
        }, void 0 !== t && (t.mat2 = c);
        var u = {};
        u.create = function () {
          var e = new n(6);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = 0, e[5] = 0, e;
        }, u.clone = function (e) {
          var t = new n(6);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t;
        }, u.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e;
        }, u.identity = function (e) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 1, e[4] = 0, e[5] = 0, e;
        }, u.invert = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = r * a - n * i;
          return l ? (l = 1 / l, e[0] = a * l, e[1] = -n * l, e[2] = -i * l, e[3] = r * l, e[4] = (i * s - a * o) * l, e[5] = (n * o - r * s) * l, e) : null;
        }, u.determinant = function (e) {
          return e[0] * e[3] - e[1] * e[2];
        }, u.multiply = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = r[0],
            u = r[1],
            h = r[2],
            f = r[3],
            d = r[4],
            p = r[5];
          return e[0] = n * c + a * u, e[1] = i * c + o * u, e[2] = n * h + a * f, e[3] = i * h + o * f, e[4] = n * d + a * p + s, e[5] = i * d + o * p + l, e;
        }, u.mul = u.multiply, u.rotate = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = Math.sin(r),
            u = Math.cos(r);
          return e[0] = n * u + a * c, e[1] = i * u + o * c, e[2] = n * -c + a * u, e[3] = i * -c + o * u, e[4] = s, e[5] = l, e;
        }, u.scale = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = r[0],
            u = r[1];
          return e[0] = n * c, e[1] = i * c, e[2] = a * u, e[3] = o * u, e[4] = s, e[5] = l, e;
        }, u.translate = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = r[0],
            u = r[1];
          return e[0] = n, e[1] = i, e[2] = a, e[3] = o, e[4] = n * c + a * u + s, e[5] = i * c + o * u + l, e;
        }, u.str = function (e) {
          return "mat2d(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ")";
        }, u.frob = function (e) {
          return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2) + Math.pow(e[2], 2) + Math.pow(e[3], 2) + Math.pow(e[4], 2) + Math.pow(e[5], 2) + 1);
        }, void 0 !== t && (t.mat2d = u), e.mat3 = {}, mat3.create = function () {
          var e = new n(9);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 1, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
        }, mat3.fromMat4 = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[4], e[4] = t[5], e[5] = t[6], e[6] = t[8], e[7] = t[9], e[8] = t[10], e;
        }, mat3.clone = function (e) {
          var t = new n(9);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t;
        }, mat3.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
        }, mat3.identity = function (e) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 1, e[5] = 0, e[6] = 0, e[7] = 0, e[8] = 1, e;
        }, mat3.transpose = function (e, t) {
          if (e === t) {
            var r = t[1],
              n = t[2],
              i = t[5];
            e[1] = t[3], e[2] = t[6], e[3] = r, e[5] = t[7], e[6] = n, e[7] = i;
          } else e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8];
          return e;
        }, mat3.invert = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = t[6],
            c = t[7],
            u = t[8],
            h = u * o - s * c,
            f = -u * a + s * l,
            d = c * a - o * l,
            p = r * h + n * f + i * d;
          return p ? (p = 1 / p, e[0] = h * p, e[1] = (-u * n + i * c) * p, e[2] = (s * n - i * o) * p, e[3] = f * p, e[4] = (u * r - i * l) * p, e[5] = (-s * r + i * a) * p, e[6] = d * p, e[7] = (-c * r + n * l) * p, e[8] = (o * r - n * a) * p, e) : null;
        }, mat3.adjoint = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = t[6],
            c = t[7],
            u = t[8];
          return e[0] = o * u - s * c, e[1] = i * c - n * u, e[2] = n * s - i * o, e[3] = s * l - a * u, e[4] = r * u - i * l, e[5] = i * a - r * s, e[6] = a * c - o * l, e[7] = n * l - r * c, e[8] = r * o - n * a, e;
        }, mat3.determinant = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2],
            i = e[3],
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8];
          return t * (c * a - o * l) + r * (-c * i + o * s) + n * (l * i - a * s);
        }, mat3.multiply = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = t[6],
            u = t[7],
            h = t[8],
            f = r[0],
            d = r[1],
            p = r[2],
            m = r[3],
            g = r[4],
            v = r[5],
            b = r[6],
            y = r[7],
            w = r[8];
          return e[0] = f * n + d * o + p * c, e[1] = f * i + d * s + p * u, e[2] = f * a + d * l + p * h, e[3] = m * n + g * o + v * c, e[4] = m * i + g * s + v * u, e[5] = m * a + g * l + v * h, e[6] = b * n + y * o + w * c, e[7] = b * i + y * s + w * u, e[8] = b * a + y * l + w * h, e;
        }, mat3.mul = mat3.multiply, mat3.translate = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = t[6],
            u = t[7],
            h = t[8],
            f = r[0],
            d = r[1];
          return e[0] = n, e[1] = i, e[2] = a, e[3] = o, e[4] = s, e[5] = l, e[6] = f * n + d * o + c, e[7] = f * i + d * s + u, e[8] = f * a + d * l + h, e;
        }, mat3.rotate = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = t[6],
            u = t[7],
            h = t[8],
            f = Math.sin(r),
            d = Math.cos(r);
          return e[0] = d * n + f * o, e[1] = d * i + f * s, e[2] = d * a + f * l, e[3] = d * o - f * n, e[4] = d * s - f * i, e[5] = d * l - f * a, e[6] = c, e[7] = u, e[8] = h, e;
        }, mat3.scale = function (e, t, r) {
          var n = r[0],
            i = r[1];
          return e[0] = n * t[0], e[1] = n * t[1], e[2] = n * t[2], e[3] = i * t[3], e[4] = i * t[4], e[5] = i * t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
        }, mat3.fromMat2d = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = 0, e[3] = t[2], e[4] = t[3], e[5] = 0, e[6] = t[4], e[7] = t[5], e[8] = 1, e;
        }, mat3.fromQuat = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = r + r,
            s = n + n,
            l = i + i,
            c = r * o,
            u = n * o,
            h = n * s,
            f = i * o,
            d = i * s,
            p = i * l,
            m = a * o,
            g = a * s,
            v = a * l;
          return e[0] = 1 - h - p, e[3] = u - v, e[6] = f + g, e[1] = u + v, e[4] = 1 - c - p, e[7] = d - m, e[2] = f - g, e[5] = d + m, e[8] = 1 - c - h, e;
        }, mat3.normalFromMat4 = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = t[6],
            c = t[7],
            u = t[8],
            h = t[9],
            f = t[10],
            d = t[11],
            p = t[12],
            m = t[13],
            g = t[14],
            v = t[15],
            b = r * s - n * o,
            y = r * l - i * o,
            w = r * c - a * o,
            x = n * l - i * s,
            _ = n * c - a * s,
            S = i * c - a * l,
            C = u * m - h * p,
            E = u * g - f * p,
            A = u * v - d * p,
            T = h * g - f * m,
            k = h * v - d * m,
            R = f * v - d * g,
            I = b * R - y * k + w * T + x * A - _ * E + S * C;
          return I ? (I = 1 / I, e[0] = (s * R - l * k + c * T) * I, e[1] = (l * A - o * R - c * E) * I, e[2] = (o * k - s * A + c * C) * I, e[3] = (i * k - n * R - a * T) * I, e[4] = (r * R - i * A + a * E) * I, e[5] = (n * A - r * k - a * C) * I, e[6] = (m * S - g * _ + v * x) * I, e[7] = (g * w - p * S - v * y) * I, e[8] = (p * _ - m * w + v * b) * I, e) : null;
        }, mat3.str = function (e) {
          return "mat3(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ")";
        }, mat3.frob = function (e) {
          return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2) + Math.pow(e[2], 2) + Math.pow(e[3], 2) + Math.pow(e[4], 2) + Math.pow(e[5], 2) + Math.pow(e[6], 2) + Math.pow(e[7], 2) + Math.pow(e[8], 2));
        }, void 0 !== t && (t.mat3 = mat3), e.mat4 = {}, mat4.create = function () {
          var e = new n(16);
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }, mat4.clone = function (e) {
          var t = new n(16);
          return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
        }, mat4.copy = function (e, t) {
          return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, mat4.identity = function (e) {
          return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }, mat4.transpose = function (e, t) {
          if (e === t) {
            var r = t[1],
              n = t[2],
              i = t[3],
              a = t[6],
              o = t[7],
              s = t[11];
            e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = r, e[6] = t[9], e[7] = t[13], e[8] = n, e[9] = a, e[11] = t[14], e[12] = i, e[13] = o, e[14] = s;
          } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
          return e;
        }, mat4.invert = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = t[6],
            c = t[7],
            u = t[8],
            h = t[9],
            f = t[10],
            d = t[11],
            p = t[12],
            m = t[13],
            g = t[14],
            v = t[15],
            b = r * s - n * o,
            y = r * l - i * o,
            w = r * c - a * o,
            x = n * l - i * s,
            _ = n * c - a * s,
            S = i * c - a * l,
            C = u * m - h * p,
            E = u * g - f * p,
            A = u * v - d * p,
            T = h * g - f * m,
            k = h * v - d * m,
            R = f * v - d * g,
            I = b * R - y * k + w * T + x * A - _ * E + S * C;
          return I ? (I = 1 / I, e[0] = (s * R - l * k + c * T) * I, e[1] = (i * k - n * R - a * T) * I, e[2] = (m * S - g * _ + v * x) * I, e[3] = (f * _ - h * S - d * x) * I, e[4] = (l * A - o * R - c * E) * I, e[5] = (r * R - i * A + a * E) * I, e[6] = (g * w - p * S - v * y) * I, e[7] = (u * S - f * w + d * y) * I, e[8] = (o * k - s * A + c * C) * I, e[9] = (n * A - r * k - a * C) * I, e[10] = (p * _ - m * w + v * b) * I, e[11] = (h * w - u * _ - d * b) * I, e[12] = (s * E - o * T - l * C) * I, e[13] = (r * T - n * E + i * C) * I, e[14] = (m * y - p * x - g * b) * I, e[15] = (u * x - h * y + f * b) * I, e) : null;
        }, mat4.adjoint = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = t[4],
            s = t[5],
            l = t[6],
            c = t[7],
            u = t[8],
            h = t[9],
            f = t[10],
            d = t[11],
            p = t[12],
            m = t[13],
            g = t[14],
            v = t[15];
          return e[0] = s * (f * v - d * g) - h * (l * v - c * g) + m * (l * d - c * f), e[1] = -(n * (f * v - d * g) - h * (i * v - a * g) + m * (i * d - a * f)), e[2] = n * (l * v - c * g) - s * (i * v - a * g) + m * (i * c - a * l), e[3] = -(n * (l * d - c * f) - s * (i * d - a * f) + h * (i * c - a * l)), e[4] = -(o * (f * v - d * g) - u * (l * v - c * g) + p * (l * d - c * f)), e[5] = r * (f * v - d * g) - u * (i * v - a * g) + p * (i * d - a * f), e[6] = -(r * (l * v - c * g) - o * (i * v - a * g) + p * (i * c - a * l)), e[7] = r * (l * d - c * f) - o * (i * d - a * f) + u * (i * c - a * l), e[8] = o * (h * v - d * m) - u * (s * v - c * m) + p * (s * d - c * h), e[9] = -(r * (h * v - d * m) - u * (n * v - a * m) + p * (n * d - a * h)), e[10] = r * (s * v - c * m) - o * (n * v - a * m) + p * (n * c - a * s), e[11] = -(r * (s * d - c * h) - o * (n * d - a * h) + u * (n * c - a * s)), e[12] = -(o * (h * g - f * m) - u * (s * g - l * m) + p * (s * f - l * h)), e[13] = r * (h * g - f * m) - u * (n * g - i * m) + p * (n * f - i * h), e[14] = -(r * (s * g - l * m) - o * (n * g - i * m) + p * (n * l - i * s)), e[15] = r * (s * f - l * h) - o * (n * f - i * h) + u * (n * l - i * s), e;
        }, mat4.determinant = function (e) {
          var t = e[0],
            r = e[1],
            n = e[2],
            i = e[3],
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8],
            u = e[9],
            h = e[10],
            f = e[11],
            d = e[12],
            p = e[13],
            m = e[14],
            g = e[15];
          return (t * o - r * a) * (h * g - f * m) - (t * s - n * a) * (u * g - f * p) + (t * l - i * a) * (u * m - h * p) + (r * s - n * o) * (c * g - f * d) - (r * l - i * o) * (c * m - h * d) + (n * l - i * s) * (c * p - u * d);
        }, mat4.multiply = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = t[4],
            l = t[5],
            c = t[6],
            u = t[7],
            h = t[8],
            f = t[9],
            d = t[10],
            p = t[11],
            m = t[12],
            g = t[13],
            v = t[14],
            b = t[15],
            y = r[0],
            w = r[1],
            x = r[2],
            _ = r[3];
          return e[0] = y * n + w * s + x * h + _ * m, e[1] = y * i + w * l + x * f + _ * g, e[2] = y * a + w * c + x * d + _ * v, e[3] = y * o + w * u + x * p + _ * b, y = r[4], w = r[5], x = r[6], _ = r[7], e[4] = y * n + w * s + x * h + _ * m, e[5] = y * i + w * l + x * f + _ * g, e[6] = y * a + w * c + x * d + _ * v, e[7] = y * o + w * u + x * p + _ * b, y = r[8], w = r[9], x = r[10], _ = r[11], e[8] = y * n + w * s + x * h + _ * m, e[9] = y * i + w * l + x * f + _ * g, e[10] = y * a + w * c + x * d + _ * v, e[11] = y * o + w * u + x * p + _ * b, y = r[12], w = r[13], x = r[14], _ = r[15], e[12] = y * n + w * s + x * h + _ * m, e[13] = y * i + w * l + x * f + _ * g, e[14] = y * a + w * c + x * d + _ * v, e[15] = y * o + w * u + x * p + _ * b, e;
        }, mat4.mul = mat4.multiply, mat4.translate = function (e, t, r) {
          var n,
            i,
            a,
            o,
            s,
            l,
            c,
            u,
            h,
            f,
            d,
            p,
            m = r[0],
            g = r[1],
            v = r[2];
          return t === e ? (e[12] = t[0] * m + t[4] * g + t[8] * v + t[12], e[13] = t[1] * m + t[5] * g + t[9] * v + t[13], e[14] = t[2] * m + t[6] * g + t[10] * v + t[14], e[15] = t[3] * m + t[7] * g + t[11] * v + t[15]) : (n = t[0], i = t[1], a = t[2], o = t[3], s = t[4], l = t[5], c = t[6], u = t[7], h = t[8], f = t[9], d = t[10], p = t[11], e[0] = n, e[1] = i, e[2] = a, e[3] = o, e[4] = s, e[5] = l, e[6] = c, e[7] = u, e[8] = h, e[9] = f, e[10] = d, e[11] = p, e[12] = n * m + s * g + h * v + t[12], e[13] = i * m + l * g + f * v + t[13], e[14] = a * m + c * g + d * v + t[14], e[15] = o * m + u * g + p * v + t[15]), e;
        }, mat4.scale = function (e, t, r) {
          var n = r[0],
            i = r[1],
            a = r[2];
          return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * i, e[5] = t[5] * i, e[6] = t[6] * i, e[7] = t[7] * i, e[8] = t[8] * a, e[9] = t[9] * a, e[10] = t[10] * a, e[11] = t[11] * a, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
        }, mat4.rotate = function (e, t, n, i) {
          var a,
            o,
            s,
            l,
            c,
            u,
            h,
            f,
            d,
            p,
            m,
            g,
            v,
            b,
            y,
            w,
            x,
            _,
            S,
            C,
            E,
            A,
            T,
            k,
            R = i[0],
            I = i[1],
            M = i[2],
            O = Math.sqrt(R * R + I * I + M * M);
          return Math.abs(O) < r ? null : (O = 1 / O, R *= O, I *= O, M *= O, a = Math.sin(n), o = Math.cos(n), s = 1 - o, l = t[0], c = t[1], u = t[2], h = t[3], f = t[4], d = t[5], p = t[6], m = t[7], g = t[8], v = t[9], b = t[10], y = t[11], w = R * R * s + o, x = I * R * s + M * a, _ = M * R * s - I * a, S = R * I * s - M * a, C = I * I * s + o, E = M * I * s + R * a, A = R * M * s + I * a, T = I * M * s - R * a, k = M * M * s + o, e[0] = l * w + f * x + g * _, e[1] = c * w + d * x + v * _, e[2] = u * w + p * x + b * _, e[3] = h * w + m * x + y * _, e[4] = l * S + f * C + g * E, e[5] = c * S + d * C + v * E, e[6] = u * S + p * C + b * E, e[7] = h * S + m * C + y * E, e[8] = l * A + f * T + g * k, e[9] = c * A + d * T + v * k, e[10] = u * A + p * T + b * k, e[11] = h * A + m * T + y * k, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
        }, mat4.rotateX = function (e, t, r) {
          var n = Math.sin(r),
            i = Math.cos(r),
            a = t[4],
            o = t[5],
            s = t[6],
            l = t[7],
            c = t[8],
            u = t[9],
            h = t[10],
            f = t[11];
          return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = a * i + c * n, e[5] = o * i + u * n, e[6] = s * i + h * n, e[7] = l * i + f * n, e[8] = c * i - a * n, e[9] = u * i - o * n, e[10] = h * i - s * n, e[11] = f * i - l * n, e;
        }, mat4.rotateY = function (e, t, r) {
          var n = Math.sin(r),
            i = Math.cos(r),
            a = t[0],
            o = t[1],
            s = t[2],
            l = t[3],
            c = t[8],
            u = t[9],
            h = t[10],
            f = t[11];
          return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i - c * n, e[1] = o * i - u * n, e[2] = s * i - h * n, e[3] = l * i - f * n, e[8] = a * n + c * i, e[9] = o * n + u * i, e[10] = s * n + h * i, e[11] = l * n + f * i, e;
        }, mat4.rotateZ = function (e, t, r) {
          var n = Math.sin(r),
            i = Math.cos(r),
            a = t[0],
            o = t[1],
            s = t[2],
            l = t[3],
            c = t[4],
            u = t[5],
            h = t[6],
            f = t[7];
          return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i + c * n, e[1] = o * i + u * n, e[2] = s * i + h * n, e[3] = l * i + f * n, e[4] = c * i - a * n, e[5] = u * i - o * n, e[6] = h * i - s * n, e[7] = f * i - l * n, e;
        }, mat4.fromRotationTranslation = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = n + n,
            l = i + i,
            c = a + a,
            u = n * s,
            h = n * l,
            f = n * c,
            d = i * l,
            p = i * c,
            m = a * c,
            g = o * s,
            v = o * l,
            b = o * c;
          return e[0] = 1 - (d + m), e[1] = h + b, e[2] = f - v, e[3] = 0, e[4] = h - b, e[5] = 1 - (u + m), e[6] = p + g, e[7] = 0, e[8] = f + v, e[9] = p - g, e[10] = 1 - (u + d), e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
        }, mat4.fromQuat = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = r + r,
            s = n + n,
            l = i + i,
            c = r * o,
            u = n * o,
            h = n * s,
            f = i * o,
            d = i * s,
            p = i * l,
            m = a * o,
            g = a * s,
            v = a * l;
          return e[0] = 1 - h - p, e[1] = u + v, e[2] = f - g, e[3] = 0, e[4] = u - v, e[5] = 1 - c - p, e[6] = d + m, e[7] = 0, e[8] = f + g, e[9] = d - m, e[10] = 1 - c - h, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
        }, mat4.frustum = function (e, t, r, n, i, a, o) {
          var s = 1 / (r - t),
            l = 1 / (i - n),
            c = 1 / (a - o);
          return e[0] = 2 * a * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 2 * a * l, e[6] = 0, e[7] = 0, e[8] = (r + t) * s, e[9] = (i + n) * l, e[10] = (o + a) * c, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * a * 2 * c, e[15] = 0, e;
        }, mat4.perspective = function (e, t, r, n, i) {
          var a = 1 / Math.tan(t / 2),
            o = 1 / (n - i);
          return e[0] = a / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (i + n) * o, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * i * n * o, e[15] = 0, e;
        }, mat4.ortho = function (e, t, r, n, i, a, o) {
          var s = 1 / (t - r),
            l = 1 / (n - i),
            c = 1 / (a - o);
          return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * l, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * c, e[11] = 0, e[12] = (t + r) * s, e[13] = (i + n) * l, e[14] = (o + a) * c, e[15] = 1, e;
        }, mat4.lookAt = function (e, t, n, i) {
          var a,
            o,
            s,
            l,
            c,
            u,
            h,
            f,
            d,
            p,
            m = t[0],
            g = t[1],
            v = t[2],
            b = i[0],
            y = i[1],
            w = i[2],
            x = n[0],
            _ = n[1],
            S = n[2];
          return Math.abs(m - x) < r && Math.abs(g - _) < r && Math.abs(v - S) < r ? mat4.identity(e) : (h = m - x, f = g - _, d = v - S, p = 1 / Math.sqrt(h * h + f * f + d * d), h *= p, f *= p, d *= p, a = y * d - w * f, o = w * h - b * d, s = b * f - y * h, p = Math.sqrt(a * a + o * o + s * s), p ? (p = 1 / p, a *= p, o *= p, s *= p) : (a = 0, o = 0, s = 0), l = f * s - d * o, c = d * a - h * s, u = h * o - f * a, p = Math.sqrt(l * l + c * c + u * u), p ? (p = 1 / p, l *= p, c *= p, u *= p) : (l = 0, c = 0, u = 0), e[0] = a, e[1] = l, e[2] = h, e[3] = 0, e[4] = o, e[5] = c, e[6] = f, e[7] = 0, e[8] = s, e[9] = u, e[10] = d, e[11] = 0, e[12] = -(a * m + o * g + s * v), e[13] = -(l * m + c * g + u * v), e[14] = -(h * m + f * g + d * v), e[15] = 1, e);
        }, mat4.str = function (e) {
          return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
        }, mat4.frob = function (e) {
          return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2) + Math.pow(e[2], 2) + Math.pow(e[3], 2) + Math.pow(e[4], 2) + Math.pow(e[5], 2) + Math.pow(e[6], 2) + Math.pow(e[7], 2) + Math.pow(e[8], 2) + Math.pow(e[9], 2) + Math.pow(e[10], 2) + Math.pow(e[11], 2) + Math.pow(e[12], 2) + Math.pow(e[13], 2) + Math.pow(e[14], 2) + Math.pow(e[15], 2));
        }, void 0 !== t && (t.mat4 = mat4);
        var h = {};
        h.create = function () {
          var e = new n(4);
          return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e;
        }, h.rotationTo = function () {
          var e = vec3.create(),
            t = vec3.fromValues(1, 0, 0),
            r = vec3.fromValues(0, 1, 0);
          return function (n, i, a) {
            var o = vec3.dot(i, a);
            return o < -.999999 ? (vec3.cross(e, t, i), vec3.length(e) < 1e-6 && vec3.cross(e, r, i), vec3.normalize(e, e), h.setAxisAngle(n, e, Math.PI), n) : o > .999999 ? (n[0] = 0, n[1] = 0, n[2] = 0, n[3] = 1, n) : (vec3.cross(e, i, a), n[0] = e[0], n[1] = e[1], n[2] = e[2], n[3] = 1 + o, h.normalize(n, n));
          };
        }(), h.setAxes = function () {
          var e = mat3.create();
          return function (t, r, n, i) {
            return e[0] = n[0], e[3] = n[1], e[6] = n[2], e[1] = i[0], e[4] = i[1], e[7] = i[2], e[2] = -r[0], e[5] = -r[1], e[8] = -r[2], h.normalize(t, h.fromMat3(t, e));
          };
        }(), h.clone = l.clone, h.fromValues = l.fromValues, h.copy = l.copy, h.set = l.set, h.identity = function (e) {
          return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e;
        }, h.setAxisAngle = function (e, t, r) {
          r *= .5;
          var n = Math.sin(r);
          return e[0] = n * t[0], e[1] = n * t[1], e[2] = n * t[2], e[3] = Math.cos(r), e;
        }, h.add = l.add, h.multiply = function (e, t, r) {
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = r[0],
            l = r[1],
            c = r[2],
            u = r[3];
          return e[0] = n * u + o * s + i * c - a * l, e[1] = i * u + o * l + a * s - n * c, e[2] = a * u + o * c + n * l - i * s, e[3] = o * u - n * s - i * l - a * c, e;
        }, h.mul = h.multiply, h.scale = l.scale, h.rotateX = function (e, t, r) {
          r *= .5;
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = Math.sin(r),
            l = Math.cos(r);
          return e[0] = n * l + o * s, e[1] = i * l + a * s, e[2] = a * l - i * s, e[3] = o * l - n * s, e;
        }, h.rotateY = function (e, t, r) {
          r *= .5;
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = Math.sin(r),
            l = Math.cos(r);
          return e[0] = n * l - a * s, e[1] = i * l + o * s, e[2] = a * l + n * s, e[3] = o * l - i * s, e;
        }, h.rotateZ = function (e, t, r) {
          r *= .5;
          var n = t[0],
            i = t[1],
            a = t[2],
            o = t[3],
            s = Math.sin(r),
            l = Math.cos(r);
          return e[0] = n * l + i * s, e[1] = i * l - n * s, e[2] = a * l + o * s, e[3] = o * l - a * s, e;
        }, h.calculateW = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2];
          return e[0] = r, e[1] = n, e[2] = i, e[3] = Math.sqrt(Math.abs(1 - r * r - n * n - i * i)), e;
        }, h.dot = l.dot, h.lerp = l.lerp, h.slerp = function (e, t, r, n) {
          var i,
            a,
            o,
            s,
            l,
            c = t[0],
            u = t[1],
            h = t[2],
            f = t[3],
            d = r[0],
            p = r[1],
            m = r[2],
            g = r[3];
          return a = c * d + u * p + h * m + f * g, a < 0 && (a = -a, d = -d, p = -p, m = -m, g = -g), 1 - a > 1e-6 ? (i = Math.acos(a), o = Math.sin(i), s = Math.sin((1 - n) * i) / o, l = Math.sin(n * i) / o) : (s = 1 - n, l = n), e[0] = s * c + l * d, e[1] = s * u + l * p, e[2] = s * h + l * m, e[3] = s * f + l * g, e;
        }, h.invert = function (e, t) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3],
            o = r * r + n * n + i * i + a * a,
            s = o ? 1 / o : 0;
          return e[0] = -r * s, e[1] = -n * s, e[2] = -i * s, e[3] = a * s, e;
        }, h.conjugate = function (e, t) {
          return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = t[3], e;
        }, h.length = l.length, h.len = h.length, h.squaredLength = l.squaredLength, h.sqrLen = h.squaredLength, h.normalize = l.normalize, h.fromMat3 = function (e, t) {
          var r,
            n = t[0] + t[4] + t[8];
          if (n > 0) r = Math.sqrt(n + 1), e[3] = .5 * r, r = .5 / r, e[0] = (t[5] - t[7]) * r, e[1] = (t[6] - t[2]) * r, e[2] = (t[1] - t[3]) * r;else {
            var i = 0;
            t[4] > t[0] && (i = 1), t[8] > t[3 * i + i] && (i = 2);
            var a = (i + 1) % 3,
              o = (i + 2) % 3;
            r = Math.sqrt(t[3 * i + i] - t[3 * a + a] - t[3 * o + o] + 1), e[i] = .5 * r, r = .5 / r, e[3] = (t[3 * a + o] - t[3 * o + a]) * r, e[a] = (t[3 * a + i] + t[3 * i + a]) * r, e[o] = (t[3 * o + i] + t[3 * i + o]) * r;
          }
          return e;
        }, h.str = function (e) {
          return "quat(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ")";
        }, void 0 !== t && (t.quat = h);
      }(r.exports);
    }(window), t.default = l;
  }, function (e, t, r) {
    e.exports = {
      default: r(171),
      __esModule: !0
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(173),
      __esModule: !0
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(176),
      __esModule: !0
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(177),
      __esModule: !0
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(178),
      __esModule: !0
    };
  }, function (e, t, r) {
    e.exports = {
      default: r(179),
      __esModule: !0
    };
  }, function (e, t, r) {
    "use strict";

    t.__esModule = !0;
    var n = r(89),
      i = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(n);
    t.default = function (e, t, r) {
      return t in e ? (0, i.default)(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t, r) {
    var n = r(11),
      i = n.JSON || (n.JSON = {
        stringify: JSON.stringify
      });
    e.exports = function (e) {
      return i.stringify.apply(i, arguments);
    };
  }, function (e, t, r) {
    r(197), e.exports = r(11).Object.assign;
  }, function (e, t, r) {
    r(198);
    var n = r(11).Object;
    e.exports = function (e, t) {
      return n.create(e, t);
    };
  }, function (e, t, r) {
    r(199);
    var n = r(11).Object;
    e.exports = function (e, t, r) {
      return n.defineProperty(e, t, r);
    };
  }, function (e, t, r) {
    r(200), e.exports = r(11).Object.getPrototypeOf;
  }, function (e, t, r) {
    r(201), e.exports = r(11).Object.keys;
  }, function (e, t, r) {
    r(202), e.exports = r(11).Object.setPrototypeOf;
  }, function (e, t, r) {
    r(205), r(203), r(206), r(207), e.exports = r(11).Symbol;
  }, function (e, t, r) {
    r(204), r(208), e.exports = r(71).f("iterator");
  }, function (e, t) {
    e.exports = function (e) {
      if ("function" != typeof e) throw TypeError(e + " is not a function!");
      return e;
    };
  }, function (e, t) {
    e.exports = function () {};
  }, function (e, t, r) {
    var n = r(34),
      i = r(195),
      a = r(194);
    e.exports = function (e) {
      return function (t, r, o) {
        var s,
          l = n(t),
          c = i(l.length),
          u = a(o, c);
        if (e && r != r) {
          for (; c > u;) if ((s = l[u++]) != s) return !0;
        } else for (; c > u; u++) if ((e || u in l) && l[u] === r) return e || u || 0;
        return !e && -1;
      };
    };
  }, function (e, t, r) {
    var n = r(43),
      i = r(64),
      a = r(48);
    e.exports = function (e) {
      var t = n(e),
        r = i.f;
      if (r) for (var o, s = r(e), l = a.f, c = 0; s.length > c;) l.call(e, o = s[c++]) && t.push(o);
      return t;
    };
  }, function (e, t, r) {
    var n = r(17).document;
    e.exports = n && n.documentElement;
  }, function (e, t, r) {
    var n = r(90);
    e.exports = Array.isArray || function (e) {
      return "Array" == n(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(63),
      i = r(49),
      a = r(65),
      o = {};
    r(32)(o, r(35)("iterator"), function () {
      return this;
    }), e.exports = function (e, t, r) {
      e.prototype = n(o, {
        next: i(1, r)
      }), a(e, t + " Iterator");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return {
        value: t,
        done: !!e
      };
    };
  }, function (e, t, r) {
    var n = r(51)("meta"),
      i = r(33),
      a = r(26),
      o = r(27).f,
      s = 0,
      l = Object.isExtensible || function () {
        return !0;
      },
      c = !r(31)(function () {
        return l(Object.preventExtensions({}));
      }),
      u = function u(e) {
        o(e, n, {
          value: {
            i: "O" + ++s,
            w: {}
          }
        });
      },
      h = function h(e, t) {
        if (!i(e)) return "symbol" == _typeof(e) ? e : ("string" == typeof e ? "S" : "P") + e;
        if (!a(e, n)) {
          if (!l(e)) return "F";
          if (!t) return "E";
          u(e);
        }
        return e[n].i;
      },
      f = function f(e, t) {
        if (!a(e, n)) {
          if (!l(e)) return !0;
          if (!t) return !1;
          u(e);
        }
        return e[n].w;
      },
      d = function d(e) {
        return c && p.NEED && l(e) && !a(e, n) && u(e), e;
      },
      p = e.exports = {
        KEY: n,
        NEED: !1,
        fastKey: h,
        getWeak: f,
        onFreeze: d
      };
  }, function (e, t, r) {
    "use strict";

    var n = r(43),
      i = r(64),
      a = r(48),
      o = r(50),
      s = r(94),
      l = Object.assign;
    e.exports = !l || r(31)(function () {
      var e = {},
        t = {},
        r = Symbol(),
        n = "abcdefghijklmnopqrst";
      return e[r] = 7, n.split("").forEach(function (e) {
        t[e] = e;
      }), 7 != l({}, e)[r] || Object.keys(l({}, t)).join("") != n;
    }) ? function (e, t) {
      for (var r = o(e), l = arguments.length, c = 1, u = i.f, h = a.f; l > c;) for (var f, d = s(arguments[c++]), p = u ? n(d).concat(u(d)) : n(d), m = p.length, g = 0; m > g;) h.call(d, f = p[g++]) && (r[f] = d[f]);
      return r;
    } : l;
  }, function (e, t, r) {
    var n = r(27),
      i = r(42),
      a = r(43);
    e.exports = r(24) ? Object.defineProperties : function (e, t) {
      i(e);
      for (var r, o = a(t), s = o.length, l = 0; s > l;) n.f(e, r = o[l++], t[r]);
      return e;
    };
  }, function (e, t, r) {
    var n = r(34),
      i = r(97).f,
      a = {}.toString,
      o = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
      s = function s(e) {
        try {
          return i(e);
        } catch (e) {
          return o.slice();
        }
      };
    e.exports.f = function (e) {
      return o && "[object Window]" == a.call(e) ? s(e) : i(n(e));
    };
  }, function (e, t, r) {
    var n = r(33),
      i = r(42),
      a = function a(e, t) {
        if (i(e), !n(t) && null !== t) throw TypeError(t + ": can't set as prototype!");
      };
    e.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (e, t, n) {
        try {
          n = r(91)(Function.call, r(96).f(Object.prototype, "__proto__").set, 2), n(e, []), t = !(e instanceof Array);
        } catch (e) {
          t = !0;
        }
        return function (e, r) {
          return a(e, r), t ? e.__proto__ = r : n(e, r), e;
        };
      }({}, !1) : void 0),
      check: a
    };
  }, function (e, t, r) {
    var n = r(68),
      i = r(60);
    e.exports = function (e) {
      return function (t, r) {
        var a,
          o,
          s = String(i(t)),
          l = n(r),
          c = s.length;
        return l < 0 || l >= c ? e ? "" : void 0 : (a = s.charCodeAt(l), a < 55296 || a > 56319 || l + 1 === c || (o = s.charCodeAt(l + 1)) < 56320 || o > 57343 ? e ? s.charAt(l) : a : e ? s.slice(l, l + 2) : o - 56320 + (a - 55296 << 10) + 65536);
      };
    };
  }, function (e, t, r) {
    var n = r(68),
      i = Math.max,
      a = Math.min;
    e.exports = function (e, t) {
      return e = n(e), e < 0 ? i(e + t, 0) : a(e, t);
    };
  }, function (e, t, r) {
    var n = r(68),
      i = Math.min;
    e.exports = function (e) {
      return e > 0 ? i(n(e), 9007199254740991) : 0;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(181),
      i = r(187),
      a = r(62),
      o = r(34);
    e.exports = r(95)(Array, "Array", function (e, t) {
      this._t = o(e), this._i = 0, this._k = t;
    }, function () {
      var e = this._t,
        t = this._k,
        r = this._i++;
      return !e || r >= e.length ? (this._t = void 0, i(1)) : "keys" == t ? i(0, r) : "values" == t ? i(0, e[r]) : i(0, [r, e[r]]);
    }, "values"), a.Arguments = a.Array, n("keys"), n("values"), n("entries");
  }, function (e, t, r) {
    var n = r(25);
    n(n.S + n.F, "Object", {
      assign: r(189)
    });
  }, function (e, t, r) {
    var n = r(25);
    n(n.S, "Object", {
      create: r(63)
    });
  }, function (e, t, r) {
    var n = r(25);
    n(n.S + n.F * !r(24), "Object", {
      defineProperty: r(27).f
    });
  }, function (e, t, r) {
    var n = r(50),
      i = r(98);
    r(100)("getPrototypeOf", function () {
      return function (e) {
        return i(n(e));
      };
    });
  }, function (e, t, r) {
    var n = r(50),
      i = r(43);
    r(100)("keys", function () {
      return function (e) {
        return i(n(e));
      };
    });
  }, function (e, t, r) {
    var n = r(25);
    n(n.S, "Object", {
      setPrototypeOf: r(192).set
    });
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    var n = r(193)(!0);
    r(95)(String, "String", function (e) {
      this._t = String(e), this._i = 0;
    }, function () {
      var e,
        t = this._t,
        r = this._i;
      return r >= t.length ? {
        value: void 0,
        done: !0
      } : (e = n(t, r), this._i += e.length, {
        value: e,
        done: !1
      });
    });
  }, function (e, t, r) {
    "use strict";

    var n = r(17),
      i = r(26),
      a = r(24),
      o = r(25),
      s = r(101),
      l = r(188).KEY,
      c = r(31),
      u = r(67),
      h = r(65),
      f = r(51),
      d = r(35),
      p = r(71),
      m = r(70),
      g = r(183),
      v = r(185),
      b = r(42),
      y = r(33),
      w = r(34),
      x = r(69),
      _ = r(49),
      S = r(63),
      C = r(191),
      E = r(96),
      A = r(27),
      T = r(43),
      k = E.f,
      R = A.f,
      I = C.f,
      _M = n.Symbol,
      O = n.JSON,
      P = O && O.stringify,
      B = d("_hidden"),
      D = d("toPrimitive"),
      L = {}.propertyIsEnumerable,
      F = u("symbol-registry"),
      N = u("symbols"),
      U = u("op-symbols"),
      j = Object.prototype,
      z = "function" == typeof _M,
      H = n.QObject,
      G = !H || !H.prototype || !H.prototype.findChild,
      V = a && c(function () {
        return 7 != S(R({}, "a", {
          get: function get() {
            return R(this, "a", {
              value: 7
            }).a;
          }
        })).a;
      }) ? function (e, t, r) {
        var n = k(j, t);
        n && delete j[t], R(e, t, r), n && e !== j && R(j, t, n);
      } : R,
      q = function q(e) {
        var t = N[e] = S(_M.prototype);
        return t._k = e, t;
      },
      W = z && "symbol" == _typeof(_M.iterator) ? function (e) {
        return "symbol" == _typeof(e);
      } : function (e) {
        return e instanceof _M;
      },
      _X = function X(e, t, r) {
        return e === j && _X(U, t, r), b(e), t = x(t, !0), b(r), i(N, t) ? (r.enumerable ? (i(e, B) && e[B][t] && (e[B][t] = !1), r = S(r, {
          enumerable: _(0, !1)
        })) : (i(e, B) || R(e, B, _(1, {})), e[B][t] = !0), V(e, t, r)) : R(e, t, r);
      },
      Y = function Y(e, t) {
        b(e);
        for (var r, n = g(t = w(t)), i = 0, a = n.length; a > i;) _X(e, r = n[i++], t[r]);
        return e;
      },
      K = function K(e, t) {
        return void 0 === t ? S(e) : Y(S(e), t);
      },
      Z = function Z(e) {
        var t = L.call(this, e = x(e, !0));
        return !(this === j && i(N, e) && !i(U, e)) && (!(t || !i(this, e) || !i(N, e) || i(this, B) && this[B][e]) || t);
      },
      J = function J(e, t) {
        if (e = w(e), t = x(t, !0), e !== j || !i(N, t) || i(U, t)) {
          var r = k(e, t);
          return !r || !i(N, t) || i(e, B) && e[B][t] || (r.enumerable = !0), r;
        }
      },
      Q = function Q(e) {
        for (var t, r = I(w(e)), n = [], a = 0; r.length > a;) i(N, t = r[a++]) || t == B || t == l || n.push(t);
        return n;
      },
      $ = function $(e) {
        for (var t, r = e === j, n = I(r ? U : w(e)), a = [], o = 0; n.length > o;) !i(N, t = n[o++]) || r && !i(j, t) || a.push(N[t]);
        return a;
      };
    z || (_M = function M() {
      if (this instanceof _M) throw TypeError("Symbol is not a constructor!");
      var e = f(arguments.length > 0 ? arguments[0] : void 0),
        _t4 = function t(r) {
          this === j && _t4.call(U, r), i(this, B) && i(this[B], e) && (this[B][e] = !1), V(this, e, _(1, r));
        };
      return a && G && V(j, e, {
        configurable: !0,
        set: _t4
      }), q(e);
    }, s(_M.prototype, "toString", function () {
      return this._k;
    }), E.f = J, A.f = _X, r(97).f = C.f = Q, r(48).f = Z, r(64).f = $, a && !r(47) && s(j, "propertyIsEnumerable", Z, !0), p.f = function (e) {
      return q(d(e));
    }), o(o.G + o.W + o.F * !z, {
      Symbol: _M
    });
    for (var ee = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), te = 0; ee.length > te;) d(ee[te++]);
    for (var re = T(d.store), ne = 0; re.length > ne;) m(re[ne++]);
    o(o.S + o.F * !z, "Symbol", {
      for: function _for(e) {
        return i(F, e += "") ? F[e] : F[e] = _M(e);
      },
      keyFor: function keyFor(e) {
        if (!W(e)) throw TypeError(e + " is not a symbol!");
        for (var t in F) if (F[t] === e) return t;
      },
      useSetter: function useSetter() {
        G = !0;
      },
      useSimple: function useSimple() {
        G = !1;
      }
    }), o(o.S + o.F * !z, "Object", {
      create: K,
      defineProperty: _X,
      defineProperties: Y,
      getOwnPropertyDescriptor: J,
      getOwnPropertyNames: Q,
      getOwnPropertySymbols: $
    }), O && o(o.S + o.F * (!z || c(function () {
      var e = _M();
      return "[null]" != P([e]) || "{}" != P({
        a: e
      }) || "{}" != P(Object(e));
    })), "JSON", {
      stringify: function stringify(e) {
        for (var t, r, n = [e], i = 1; arguments.length > i;) n.push(arguments[i++]);
        if (r = t = n[1], (y(t) || void 0 !== e) && !W(e)) return v(t) || (t = function t(e, _t5) {
          if ("function" == typeof r && (_t5 = r.call(this, e, _t5)), !W(_t5)) return _t5;
        }), n[1] = t, P.apply(O, n);
      }
    }), _M.prototype[D] || r(32)(_M.prototype, D, _M.prototype.valueOf), h(_M, "Symbol"), h(Math, "Math", !0), h(n.JSON, "JSON", !0);
  }, function (e, t, r) {
    r(70)("asyncIterator");
  }, function (e, t, r) {
    r(70)("observable");
  }, function (e, t, r) {
    r(196);
    for (var n = r(17), i = r(32), a = r(62), o = r(35)("toStringTag"), s = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), l = 0; l < s.length; l++) {
      var c = s[l],
        u = n[c],
        h = u && u.prototype;
      h && !h[o] && i(h, o, c), a[c] = a.Array;
    }
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = e.indexOf("=");
      return -1 === r && (r = t), [r, r === t ? 0 : 4 - r % 4];
    }
    function i(e) {
      var t = n(e),
        r = t[0],
        i = t[1];
      return 3 * (r + i) / 4 - i;
    }
    function a(e, t, r) {
      return 3 * (t + r) / 4 - r;
    }
    function o(e) {
      for (var t, r = n(e), i = r[0], o = r[1], s = new f(a(e, i, o)), l = 0, c = o > 0 ? i - 4 : i, u = 0; u < c; u += 4) t = h[e.charCodeAt(u)] << 18 | h[e.charCodeAt(u + 1)] << 12 | h[e.charCodeAt(u + 2)] << 6 | h[e.charCodeAt(u + 3)], s[l++] = t >> 16 & 255, s[l++] = t >> 8 & 255, s[l++] = 255 & t;
      return 2 === o && (t = h[e.charCodeAt(u)] << 2 | h[e.charCodeAt(u + 1)] >> 4, s[l++] = 255 & t), 1 === o && (t = h[e.charCodeAt(u)] << 10 | h[e.charCodeAt(u + 1)] << 4 | h[e.charCodeAt(u + 2)] >> 2, s[l++] = t >> 8 & 255, s[l++] = 255 & t), s;
    }
    function s(e) {
      return u[e >> 18 & 63] + u[e >> 12 & 63] + u[e >> 6 & 63] + u[63 & e];
    }
    function l(e, t, r) {
      for (var n, i = [], a = t; a < r; a += 3) n = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(s(n));
      return i.join("");
    }
    function c(e) {
      for (var t, r = e.length, n = r % 3, i = [], a = 0, o = r - n; a < o; a += 16383) i.push(l(e, a, a + 16383 > o ? o : a + 16383));
      return 1 === n ? (t = e[r - 1], i.push(u[t >> 2] + u[t << 4 & 63] + "==")) : 2 === n && (t = (e[r - 2] << 8) + e[r - 1], i.push(u[t >> 10] + u[t >> 4 & 63] + u[t << 2 & 63] + "=")), i.join("");
    }
    t.byteLength = i, t.toByteArray = o, t.fromByteArray = c;
    for (var u = [], h = [], f = "undefined" != typeof Uint8Array ? Uint8Array : Array, d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0, m = d.length; p < m; ++p) u[p] = d[p], h[d.charCodeAt(p)] = p;
    h["-".charCodeAt(0)] = 62, h["_".charCodeAt(0)] = 63;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t(e) {
        var t = new r(e),
          n = t.promise();
        return t.setHowMany(1), t.setUnwrap(), t.init(), n;
      }
      var r = e._SomePromiseArray;
      e.any = function (e) {
        return t(e);
      }, e.prototype.any = function () {
        return t(this);
      };
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      function n() {
        this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new c(16), this._normalQueue = new c(16), this._haveDrainedQueues = !1, this._trampolineEnabled = !0;
        var e = this;
        this.drainQueues = function () {
          e._drainQueues();
        }, this._schedule = l;
      }
      function i(e, t, r) {
        this._lateQueue.push(e, t, r), this._queueTick();
      }
      function a(e, t, r) {
        this._normalQueue.push(e, t, r), this._queueTick();
      }
      function o(e) {
        this._normalQueue._pushOne(e), this._queueTick();
      }
      var s;
      try {
        throw new Error();
      } catch (e) {
        s = e;
      }
      var l = r(234),
        c = r(231),
        u = r(0);
      n.prototype.setScheduler = function (e) {
        var t = this._schedule;
        return this._schedule = e, this._customScheduler = !0, t;
      }, n.prototype.hasCustomScheduler = function () {
        return this._customScheduler;
      }, n.prototype.enableTrampoline = function () {
        this._trampolineEnabled = !0;
      }, n.prototype.disableTrampolineIfNecessary = function () {
        u.hasDevTools && (this._trampolineEnabled = !1);
      }, n.prototype.haveItemsQueued = function () {
        return this._isTickUsed || this._haveDrainedQueues;
      }, n.prototype.fatalError = function (e, r) {
        r ? (t.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n"), t.exit(2)) : this.throwLater(e);
      }, n.prototype.throwLater = function (e, t) {
        if (1 === arguments.length && (t = e, e = function e() {
          throw t;
        }), "undefined" != typeof setTimeout) setTimeout(function () {
          e(t);
        }, 0);else try {
          this._schedule(function () {
            e(t);
          });
        } catch (e) {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
        }
      }, u.hasDevTools ? (n.prototype.invokeLater = function (e, t, r) {
        this._trampolineEnabled ? i.call(this, e, t, r) : this._schedule(function () {
          setTimeout(function () {
            e.call(t, r);
          }, 100);
        });
      }, n.prototype.invoke = function (e, t, r) {
        this._trampolineEnabled ? a.call(this, e, t, r) : this._schedule(function () {
          e.call(t, r);
        });
      }, n.prototype.settlePromises = function (e) {
        this._trampolineEnabled ? o.call(this, e) : this._schedule(function () {
          e._settlePromises();
        });
      }) : (n.prototype.invokeLater = i, n.prototype.invoke = a, n.prototype.settlePromises = o), n.prototype._drainQueue = function (e) {
        for (; e.length() > 0;) {
          var t = e.shift();
          if ("function" == typeof t) {
            var r = e.shift(),
              n = e.shift();
            t.call(r, n);
          } else t._settlePromises();
        }
      }, n.prototype._drainQueues = function () {
        this._drainQueue(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, this._drainQueue(this._lateQueue);
      }, n.prototype._queueTick = function () {
        this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues));
      }, n.prototype._reset = function () {
        this._isTickUsed = !1;
      }, e.exports = n, e.exports.firstLineError = s;
    }).call(t, r(5));
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n) {
      var i = !1,
        a = function a(e, t) {
          this._reject(t);
        },
        o = function o(e, t) {
          t.promiseRejectionQueued = !0, t.bindingPromise._then(a, a, null, this, e);
        },
        s = function s(e, t) {
          0 == (50397184 & this._bitField) && this._resolveCallback(t.target);
        },
        l = function l(e, t) {
          t.promiseRejectionQueued || this._reject(e);
        };
      e.prototype.bind = function (a) {
        i || (i = !0, e.prototype._propagateFrom = n.propagateFromFunction(), e.prototype._boundValue = n.boundValueFunction());
        var c = r(a),
          u = new e(t);
        u._propagateFrom(this, 1);
        var h = this._target();
        if (u._setBoundTo(c), c instanceof e) {
          var f = {
            promiseRejectionQueued: !1,
            promise: u,
            target: h,
            bindingPromise: c
          };
          h._then(t, o, void 0, u, f), c._then(s, l, void 0, u, f), u._setOnCancel(c);
        } else u._resolveCallback(h);
        return u;
      }, e.prototype._setBoundTo = function (e) {
        void 0 !== e ? (this._bitField = 2097152 | this._bitField, this._boundTo = e) : this._bitField = -2097153 & this._bitField;
      }, e.prototype._isBound = function () {
        return 2097152 == (2097152 & this._bitField);
      }, e.bind = function (t, r) {
        return e.resolve(r).bind(t);
      };
    };
  }, function (e, t, r) {
    "use strict";

    var n = Object.create;
    if (n) {
      var i = n(null),
        a = n(null);
      i[" size"] = a[" size"] = 0;
    }
    e.exports = function (e) {
      function t(t, r) {
        var n;
        if (null != t && (n = t[r]), "function" != typeof n) {
          var i = "Object " + u.classString(t) + " has no method '" + u.toString(r) + "'";
          throw new e.TypeError(i);
        }
        return n;
      }
      function n(e) {
        return t(e, this.pop()).apply(e, this);
      }
      function o(e) {
        return e[this];
      }
      function s(e) {
        var t = +this;
        return t < 0 && (t = Math.max(0, t + e.length)), e[t];
      }
      var l,
        c,
        u = r(0),
        h = u.canEvaluate,
        f = u.isIdentifier,
        d = function d(e) {
          return new Function("ensureMethod", "                                    \n        return function(obj) {                                               \n            'use strict'                                                     \n            var len = this.length;                                           \n            ensureMethod(obj, 'methodName');                                 \n            switch(len) {                                                    \n                case 1: return obj.methodName(this[0]);                      \n                case 2: return obj.methodName(this[0], this[1]);             \n                case 3: return obj.methodName(this[0], this[1], this[2]);    \n                case 0: return obj.methodName();                             \n                default:                                                     \n                    return obj.methodName.apply(obj, this);                  \n            }                                                                \n        };                                                                   \n        ".replace(/methodName/g, e))(t);
        },
        p = function p(e) {
          return new Function("obj", "                                             \n        'use strict';                                                        \n        return obj.propertyName;                                             \n        ".replace("propertyName", e));
        },
        m = function m(e, t, r) {
          var n = r[e];
          if ("function" != typeof n) {
            if (!f(e)) return null;
            if (n = t(e), r[e] = n, ++r[" size"] > 512) {
              for (var i = Object.keys(r), a = 0; a < 256; ++a) delete r[i[a]];
              r[" size"] = i.length - 256;
            }
          }
          return n;
        };
      l = function l(e) {
        return m(e, d, i);
      }, c = function c(e) {
        return m(e, p, a);
      }, e.prototype.call = function (e) {
        for (var t = arguments.length, r = new Array(Math.max(t - 1, 0)), i = 1; i < t; ++i) r[i - 1] = arguments[i];
        if (h) {
          var a = l(e);
          if (null !== a) return this._then(a, void 0, void 0, r, void 0);
        }
        return r.push(e), this._then(n, void 0, void 0, r, void 0);
      }, e.prototype.get = function (e) {
        var t,
          r = "number" == typeof e;
        if (r) t = s;else if (h) {
          var n = c(e);
          t = null !== n ? n : o;
        } else t = o;
        return this._then(t, void 0, void 0, e, void 0);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i) {
      var a = r(0),
        o = a.tryCatch,
        s = a.errorObj,
        l = e._async;
      e.prototype.break = e.prototype.cancel = function () {
        if (!i.cancellation()) return this._warn("cancellation is disabled");
        for (var e = this, t = e; e._isCancellable();) {
          if (!e._cancelBy(t)) {
            t._isFollowing() ? t._followee().cancel() : t._cancelBranched();
            break;
          }
          var r = e._cancellationParent;
          if (null == r || !r._isCancellable()) {
            e._isFollowing() ? e._followee().cancel() : e._cancelBranched();
            break;
          }
          e._isFollowing() && e._followee().cancel(), e._setWillBeCancelled(), t = e, e = r;
        }
      }, e.prototype._branchHasCancelled = function () {
        this._branchesRemainingToCancel--;
      }, e.prototype._enoughBranchesHaveCancelled = function () {
        return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0;
      }, e.prototype._cancelBy = function (e) {
        return e === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), !0));
      }, e.prototype._cancelBranched = function () {
        this._enoughBranchesHaveCancelled() && this._cancel();
      }, e.prototype._cancel = function () {
        this._isCancellable() && (this._setCancelled(), l.invoke(this._cancelPromises, this, void 0));
      }, e.prototype._cancelPromises = function () {
        this._length() > 0 && this._settlePromises();
      }, e.prototype._unsetOnCancel = function () {
        this._onCancelField = void 0;
      }, e.prototype._isCancellable = function () {
        return this.isPending() && !this._isCancelled();
      }, e.prototype.isCancellable = function () {
        return this.isPending() && !this.isCancelled();
      }, e.prototype._doInvokeOnCancel = function (e, t) {
        if (a.isArray(e)) for (var r = 0; r < e.length; ++r) this._doInvokeOnCancel(e[r], t);else if (void 0 !== e) if ("function" == typeof e) {
          if (!t) {
            var n = o(e).call(this._boundValue());
            n === s && (this._attachExtraTrace(n.e), l.throwLater(n.e));
          }
        } else e._resultCancelled(this);
      }, e.prototype._invokeOnCancel = function () {
        var e = this._onCancel();
        this._unsetOnCancel(), l.invoke(this._doInvokeOnCancel, this, e);
      }, e.prototype._invokeInternalOnCancel = function () {
        this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel());
      }, e.prototype._resultCancelled = function () {
        this.cancel();
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t(t, r, s) {
        return function (l) {
          var c = s._boundValue();
          e: for (var u = 0; u < t.length; ++u) {
            var h = t[u];
            if (h === Error || null != h && h.prototype instanceof Error) {
              if (l instanceof h) return a(r).call(c, l);
            } else if ("function" == typeof h) {
              var f = a(h).call(c, l);
              if (f === o) return f;
              if (f) return a(r).call(c, l);
            } else if (n.isObject(l)) {
              for (var d = i(h), p = 0; p < d.length; ++p) {
                var m = d[p];
                if (h[m] != l[m]) continue e;
              }
              return a(r).call(c, l);
            }
          }
          return e;
        };
      }
      var n = r(0),
        i = r(36).keys,
        a = n.tryCatch,
        o = n.errorObj;
      return t;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t() {
        this._trace = new t.CapturedTrace(n());
      }
      function r() {
        if (i) return new t();
      }
      function n() {
        var e = a.length - 1;
        if (e >= 0) return a[e];
      }
      var i = !1,
        a = [];
      return e.prototype._promiseCreated = function () {}, e.prototype._pushContext = function () {}, e.prototype._popContext = function () {
        return null;
      }, e._peekContext = e.prototype._peekContext = function () {}, t.prototype._pushContext = function () {
        void 0 !== this._trace && (this._trace._promiseCreated = null, a.push(this._trace));
      }, t.prototype._popContext = function () {
        if (void 0 !== this._trace) {
          var e = a.pop(),
            t = e._promiseCreated;
          return e._promiseCreated = null, t;
        }
        return null;
      }, t.CapturedTrace = null, t.create = r, t.deactivateLongStackTraces = function () {}, t.activateLongStackTraces = function () {
        var r = e.prototype._pushContext,
          a = e.prototype._popContext,
          o = e._peekContext,
          s = e.prototype._peekContext,
          l = e.prototype._promiseCreated;
        t.deactivateLongStackTraces = function () {
          e.prototype._pushContext = r, e.prototype._popContext = a, e._peekContext = o, e.prototype._peekContext = s, e.prototype._promiseCreated = l, i = !1;
        }, i = !0, e.prototype._pushContext = t.prototype._pushContext, e.prototype._popContext = t.prototype._popContext, e._peekContext = e.prototype._peekContext = n, e.prototype._promiseCreated = function () {
          var e = this._peekContext();
          e && null == e._promiseCreated && (e._promiseCreated = this);
        };
      }, t;
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      e.exports = function (e, n) {
        function i(e, t) {
          return {
            promise: t
          };
        }
        function a() {
          return !1;
        }
        function o(e, t, r) {
          var n = this;
          try {
            e(t, r, function (e) {
              if ("function" != typeof e) throw new TypeError("onCancel must be a function, got: " + U.toString(e));
              n._attachCancellationCallback(e);
            });
          } catch (e) {
            return e;
          }
        }
        function s(e) {
          if (!this._isCancellable()) return this;
          var t = this._onCancel();
          void 0 !== t ? U.isArray(t) ? t.push(e) : this._setOnCancel([t, e]) : this._setOnCancel(e);
        }
        function l() {
          return this._onCancelField;
        }
        function c(e) {
          this._onCancelField = e;
        }
        function u() {
          this._cancellationParent = void 0, this._onCancelField = void 0;
        }
        function h(e, t) {
          if (0 != (1 & t)) {
            this._cancellationParent = e;
            var r = e._branchesRemainingToCancel;
            void 0 === r && (r = 0), e._branchesRemainingToCancel = r + 1;
          }
          0 != (2 & t) && e._isBound() && this._setBoundTo(e._boundTo);
        }
        function f(e, t) {
          0 != (2 & t) && e._isBound() && this._setBoundTo(e._boundTo);
        }
        function d() {
          var t = this._boundTo;
          return void 0 !== t && t instanceof e ? t.isFulfilled() ? t.value() : void 0 : t;
        }
        function p() {
          this._trace = new O(this._peekContext());
        }
        function m(e, t) {
          if (j(e)) {
            var r = this._trace;
            if (void 0 !== r && t && (r = r._parent), void 0 !== r) r.attachExtraTrace(e);else if (!e.__stackCleaned__) {
              var n = C(e);
              U.notEnumerableProp(e, "stack", n.message + "\n" + n.stack.join("\n")), U.notEnumerableProp(e, "__stackCleaned__", !0);
            }
          }
        }
        function g(e, t, r, n, i) {
          if (void 0 === e && null !== t && Z) {
            if (void 0 !== i && i._returnedNonUndefined()) return;
            if (0 == (65535 & n._bitField)) return;
            r && (r += " ");
            var a = "",
              o = "";
            if (t._trace) {
              for (var s = t._trace.stack.split("\n"), l = _(s), c = l.length - 1; c >= 0; --c) {
                var u = l[c];
                if (!H.test(u)) {
                  var h = u.match(G);
                  h && (a = "at " + h[1] + ":" + h[2] + ":" + h[3] + " ");
                  break;
                }
              }
              if (l.length > 0) for (var f = l[0], c = 0; c < s.length; ++c) if (s[c] === f) {
                c > 0 && (o = "\n" + s[c - 1]);
                break;
              }
            }
            var d = "a promise was created in a " + r + "handler " + a + "but was not returned from it, see http://goo.gl/rRqMUw" + o;
            n._warn(d, !0, t);
          }
        }
        function v(e, t) {
          var r = e + " is deprecated and will be removed in a future version.";
          return t && (r += " Use " + t + " instead."), b(r);
        }
        function b(t, r, n) {
          if (oe.warnings) {
            var i,
              a = new N(t);
            if (r) n._attachExtraTrace(a);else if (oe.longStackTraces && (i = e._peekContext())) i.attachExtraTrace(a);else {
              var o = C(a);
              a.stack = o.message + "\n" + o.stack.join("\n");
            }
            te("warning", a) || E(a, "", !0);
          }
        }
        function y(e, t) {
          for (var r = 0; r < t.length - 1; ++r) t[r].push("From previous event:"), t[r] = t[r].join("\n");
          return r < t.length && (t[r] = t[r].join("\n")), e + "\n" + t.join("\n");
        }
        function w(e) {
          for (var t = 0; t < e.length; ++t) (0 === e[t].length || t + 1 < e.length && e[t][0] === e[t + 1][0]) && (e.splice(t, 1), t--);
        }
        function x(e) {
          for (var t = e[0], r = 1; r < e.length; ++r) {
            for (var n = e[r], i = t.length - 1, a = t[i], o = -1, s = n.length - 1; s >= 0; --s) if (n[s] === a) {
              o = s;
              break;
            }
            for (var s = o; s >= 0; --s) {
              var l = n[s];
              if (t[i] !== l) break;
              t.pop(), i--;
            }
            t = n;
          }
        }
        function _(e) {
          for (var t = [], r = 0; r < e.length; ++r) {
            var n = e[r],
              i = "    (No stack trace)" === n || V.test(n),
              a = i && ne(n);
            i && !a && (W && " " !== n.charAt(0) && (n = "    " + n), t.push(n));
          }
          return t;
        }
        function S(e) {
          for (var t = e.stack.replace(/\s+$/g, "").split("\n"), r = 0; r < t.length; ++r) {
            var n = t[r];
            if ("    (No stack trace)" === n || V.test(n)) break;
          }
          return r > 0 && "SyntaxError" != e.name && (t = t.slice(r)), t;
        }
        function C(e) {
          var t = e.stack,
            r = e.toString();
          return t = "string" == typeof t && t.length > 0 ? S(e) : ["    (No stack trace)"], {
            message: r,
            stack: "SyntaxError" == e.name ? t : _(t)
          };
        }
        function E(e, t, r) {
          if ("undefined" != typeof console) {
            var n;
            if (U.isObject(e)) {
              var i = e.stack;
              n = t + q(i, e);
            } else n = t + String(e);
            "function" == typeof D ? D(n, r) : "function" != typeof console.log && "object" != _typeof(console.log) || console.log(n);
          }
        }
        function A(e, t, r, n) {
          var i = !1;
          try {
            "function" == typeof t && (i = !0, "rejectionHandled" === e ? t(n) : t(r, n));
          } catch (e) {
            F.throwLater(e);
          }
          "unhandledRejection" === e ? te(e, r, n) || i || E(r, "Unhandled rejection ") : te(e, n);
        }
        function T(e) {
          var t;
          if ("function" == typeof e) t = "[function " + (e.name || "anonymous") + "]";else {
            t = e && "function" == typeof e.toString ? e.toString() : U.toString(e);
            if (/\[object [a-zA-Z0-9$_]+\]/.test(t)) try {
              t = JSON.stringify(e);
            } catch (e) {}
            0 === t.length && (t = "(empty array)");
          }
          return "(<" + k(t) + ">, no stack trace)";
        }
        function k(e) {
          return e.length < 41 ? e : e.substr(0, 38) + "...";
        }
        function R() {
          return "function" == typeof ae;
        }
        function I(e) {
          var t = e.match(ie);
          if (t) return {
            fileName: t[1],
            line: parseInt(t[2], 10)
          };
        }
        function M(e, t) {
          if (R()) {
            for (var r, n, i = e.stack.split("\n"), a = t.stack.split("\n"), o = -1, s = -1, l = 0; l < i.length; ++l) {
              var c = I(i[l]);
              if (c) {
                r = c.fileName, o = c.line;
                break;
              }
            }
            for (var l = 0; l < a.length; ++l) {
              var c = I(a[l]);
              if (c) {
                n = c.fileName, s = c.line;
                break;
              }
            }
            o < 0 || s < 0 || !r || !n || r !== n || o >= s || (ne = function ne(e) {
              if (z.test(e)) return !0;
              var t = I(e);
              return !!(t && t.fileName === r && o <= t.line && t.line <= s);
            });
          }
        }
        function O(e) {
          this._parent = e, this._promisesCreated = 0;
          var t = this._length = 1 + (void 0 === e ? 0 : e._length);
          ae(this, O), t > 32 && this.uncycle();
        }
        var P,
          B,
          D,
          L = e._getDomain,
          F = e._async,
          N = r(18).Warning,
          U = r(0),
          j = U.canAttachTrace,
          z = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
          H = /\((?:timers\.js):\d+:\d+\)/,
          G = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
          V = null,
          q = null,
          W = !1,
          X = !(0 == U.env("BLUEBIRD_DEBUG") || !U.env("BLUEBIRD_DEBUG") && "development" !== U.env("NODE_ENV")),
          Y = !(0 == U.env("BLUEBIRD_WARNINGS") || !X && !U.env("BLUEBIRD_WARNINGS")),
          K = !(0 == U.env("BLUEBIRD_LONG_STACK_TRACES") || !X && !U.env("BLUEBIRD_LONG_STACK_TRACES")),
          Z = 0 != U.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (Y || !!U.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
        e.prototype.suppressUnhandledRejections = function () {
          var e = this._target();
          e._bitField = -1048577 & e._bitField | 524288;
        }, e.prototype._ensurePossibleRejectionHandled = function () {
          0 == (524288 & this._bitField) && (this._setRejectionIsUnhandled(), F.invokeLater(this._notifyUnhandledRejection, this, void 0));
        }, e.prototype._notifyUnhandledRejectionIsHandled = function () {
          A("rejectionHandled", P, void 0, this);
        }, e.prototype._setReturnedNonUndefined = function () {
          this._bitField = 268435456 | this._bitField;
        }, e.prototype._returnedNonUndefined = function () {
          return 0 != (268435456 & this._bitField);
        }, e.prototype._notifyUnhandledRejection = function () {
          if (this._isRejectionUnhandled()) {
            var e = this._settledValue();
            this._setUnhandledRejectionIsNotified(), A("unhandledRejection", B, e, this);
          }
        }, e.prototype._setUnhandledRejectionIsNotified = function () {
          this._bitField = 262144 | this._bitField;
        }, e.prototype._unsetUnhandledRejectionIsNotified = function () {
          this._bitField = -262145 & this._bitField;
        }, e.prototype._isUnhandledRejectionNotified = function () {
          return (262144 & this._bitField) > 0;
        }, e.prototype._setRejectionIsUnhandled = function () {
          this._bitField = 1048576 | this._bitField;
        }, e.prototype._unsetRejectionIsUnhandled = function () {
          this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
        }, e.prototype._isRejectionUnhandled = function () {
          return (1048576 & this._bitField) > 0;
        }, e.prototype._warn = function (e, t, r) {
          return b(e, t, r || this);
        }, e.onPossiblyUnhandledRejection = function (e) {
          var t = L();
          B = "function" == typeof e ? null === t ? e : U.domainBind(t, e) : void 0;
        }, e.onUnhandledRejectionHandled = function (e) {
          var t = L();
          P = "function" == typeof e ? null === t ? e : U.domainBind(t, e) : void 0;
        };
        var J = function J() {};
        e.longStackTraces = function () {
          if (F.haveItemsQueued() && !oe.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
          if (!oe.longStackTraces && R()) {
            var t = e.prototype._captureStackTrace,
              r = e.prototype._attachExtraTrace;
            oe.longStackTraces = !0, J = function J() {
              if (F.haveItemsQueued() && !oe.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
              e.prototype._captureStackTrace = t, e.prototype._attachExtraTrace = r, n.deactivateLongStackTraces(), F.enableTrampoline(), oe.longStackTraces = !1;
            }, e.prototype._captureStackTrace = p, e.prototype._attachExtraTrace = m, n.activateLongStackTraces(), F.disableTrampolineIfNecessary();
          }
        }, e.hasLongStackTraces = function () {
          return oe.longStackTraces && R();
        };
        var Q = function () {
            try {
              if ("function" == typeof CustomEvent) {
                var e = new CustomEvent("CustomEvent");
                return U.global.dispatchEvent(e), function (e, t) {
                  var r = new CustomEvent(e.toLowerCase(), {
                    detail: t,
                    cancelable: !0
                  });
                  return !U.global.dispatchEvent(r);
                };
              }
              if ("function" == typeof Event) {
                var e = new Event("CustomEvent");
                return U.global.dispatchEvent(e), function (e, t) {
                  var r = new Event(e.toLowerCase(), {
                    cancelable: !0
                  });
                  return r.detail = t, !U.global.dispatchEvent(r);
                };
              }
              var e = document.createEvent("CustomEvent");
              return e.initCustomEvent("testingtheevent", !1, !0, {}), U.global.dispatchEvent(e), function (e, t) {
                var r = document.createEvent("CustomEvent");
                return r.initCustomEvent(e.toLowerCase(), !1, !0, t), !U.global.dispatchEvent(r);
              };
            } catch (e) {}
            return function () {
              return !1;
            };
          }(),
          $ = function () {
            return U.isNode ? function () {
              return t.emit.apply(t, arguments);
            } : U.global ? function (e) {
              var t = "on" + e.toLowerCase(),
                r = U.global[t];
              return !!r && (r.apply(U.global, [].slice.call(arguments, 1)), !0);
            } : function () {
              return !1;
            };
          }(),
          ee = {
            promiseCreated: i,
            promiseFulfilled: i,
            promiseRejected: i,
            promiseResolved: i,
            promiseCancelled: i,
            promiseChained: function promiseChained(e, t, r) {
              return {
                promise: t,
                child: r
              };
            },
            warning: function warning(e, t) {
              return {
                warning: t
              };
            },
            unhandledRejection: function unhandledRejection(e, t, r) {
              return {
                reason: t,
                promise: r
              };
            },
            rejectionHandled: i
          },
          te = function te(e) {
            var t = !1;
            try {
              t = $.apply(null, arguments);
            } catch (e) {
              F.throwLater(e), t = !0;
            }
            var r = !1;
            try {
              r = Q(e, ee[e].apply(null, arguments));
            } catch (e) {
              F.throwLater(e), r = !0;
            }
            return r || t;
          };
        e.config = function (t) {
          if (t = Object(t), "longStackTraces" in t && (t.longStackTraces ? e.longStackTraces() : !t.longStackTraces && e.hasLongStackTraces() && J()), "warnings" in t) {
            var r = t.warnings;
            oe.warnings = !!r, Z = oe.warnings, U.isObject(r) && "wForgottenReturn" in r && (Z = !!r.wForgottenReturn);
          }
          if ("cancellation" in t && t.cancellation && !oe.cancellation) {
            if (F.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
            e.prototype._clearCancellationData = u, e.prototype._propagateFrom = h, e.prototype._onCancel = l, e.prototype._setOnCancel = c, e.prototype._attachCancellationCallback = s, e.prototype._execute = o, re = h, oe.cancellation = !0;
          }
          return "monitoring" in t && (t.monitoring && !oe.monitoring ? (oe.monitoring = !0, e.prototype._fireEvent = te) : !t.monitoring && oe.monitoring && (oe.monitoring = !1, e.prototype._fireEvent = a)), e;
        }, e.prototype._fireEvent = a, e.prototype._execute = function (e, t, r) {
          try {
            e(t, r);
          } catch (e) {
            return e;
          }
        }, e.prototype._onCancel = function () {}, e.prototype._setOnCancel = function (e) {}, e.prototype._attachCancellationCallback = function (e) {}, e.prototype._captureStackTrace = function () {}, e.prototype._attachExtraTrace = function () {}, e.prototype._clearCancellationData = function () {}, e.prototype._propagateFrom = function (e, t) {};
        var re = f,
          ne = function ne() {
            return !1;
          },
          ie = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
        U.inherits(O, Error), n.CapturedTrace = O, O.prototype.uncycle = function () {
          var e = this._length;
          if (!(e < 2)) {
            for (var t = [], r = {}, n = 0, i = this; void 0 !== i; ++n) t.push(i), i = i._parent;
            e = this._length = n;
            for (var n = e - 1; n >= 0; --n) {
              var a = t[n].stack;
              void 0 === r[a] && (r[a] = n);
            }
            for (var n = 0; n < e; ++n) {
              var o = t[n].stack,
                s = r[o];
              if (void 0 !== s && s !== n) {
                s > 0 && (t[s - 1]._parent = void 0, t[s - 1]._length = 1), t[n]._parent = void 0, t[n]._length = 1;
                var l = n > 0 ? t[n - 1] : this;
                s < e - 1 ? (l._parent = t[s + 1], l._parent.uncycle(), l._length = l._parent._length + 1) : (l._parent = void 0, l._length = 1);
                for (var c = l._length + 1, u = n - 2; u >= 0; --u) t[u]._length = c, c++;
                return;
              }
            }
          }
        }, O.prototype.attachExtraTrace = function (e) {
          if (!e.__stackCleaned__) {
            this.uncycle();
            for (var t = C(e), r = t.message, n = [t.stack], i = this; void 0 !== i;) n.push(_(i.stack.split("\n"))), i = i._parent;
            x(n), w(n), U.notEnumerableProp(e, "stack", y(r, n)), U.notEnumerableProp(e, "__stackCleaned__", !0);
          }
        };
        var ae = function () {
          var e = /^\s*at\s*/,
            t = function t(e, _t6) {
              return "string" == typeof e ? e : void 0 !== _t6.name && void 0 !== _t6.message ? _t6.toString() : T(_t6);
            };
          if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
            Error.stackTraceLimit += 6, V = e, q = t;
            var r = Error.captureStackTrace;
            return ne = function ne(e) {
              return z.test(e);
            }, function (e, t) {
              Error.stackTraceLimit += 6, r(e, t), Error.stackTraceLimit -= 6;
            };
          }
          var n = new Error();
          if ("string" == typeof n.stack && n.stack.split("\n")[0].indexOf("stackDetection@") >= 0) return V = /@/, q = t, W = !0, function (e) {
            e.stack = new Error().stack;
          };
          var i;
          try {
            throw new Error();
          } catch (e) {
            i = "stack" in e;
          }
          return "stack" in n || !i || "number" != typeof Error.stackTraceLimit ? (q = function q(e, t) {
            return "string" == typeof e ? e : "object" != _typeof(t) && "function" != typeof t || void 0 === t.name || void 0 === t.message ? T(t) : t.toString();
          }, null) : (V = e, q = t, function (e) {
            Error.stackTraceLimit += 6;
            try {
              throw new Error();
            } catch (t) {
              e.stack = t.stack;
            }
            Error.stackTraceLimit -= 6;
          });
        }();
        "undefined" != typeof console && void 0 !== console.warn && (D = function D(e) {
          console.warn(e);
        }, U.isNode && t.stderr.isTTY ? D = function D(e, t) {
          var r = t ? "[33m" : "[31m";
          console.warn(r + e + "[0m\n");
        } : U.isNode || "string" != typeof new Error().stack || (D = function D(e, t) {
          console.warn("%c" + e, t ? "color: darkorange" : "color: red");
        }));
        var oe = {
          warnings: Y,
          longStackTraces: !1,
          cancellation: !1,
          monitoring: !1
        };
        return K && e.longStackTraces(), {
          longStackTraces: function longStackTraces() {
            return oe.longStackTraces;
          },
          warnings: function warnings() {
            return oe.warnings;
          },
          cancellation: function cancellation() {
            return oe.cancellation;
          },
          monitoring: function monitoring() {
            return oe.monitoring;
          },
          propagateFromFunction: function propagateFromFunction() {
            return re;
          },
          boundValueFunction: function boundValueFunction() {
            return d;
          },
          checkForgottenReturns: g,
          setBounds: M,
          warn: b,
          deprecated: v,
          CapturedTrace: O,
          fireDomEvent: Q,
          fireGlobalEvent: $
        };
      };
    }).call(t, r(5));
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t() {
        return this.value;
      }
      function r() {
        throw this.reason;
      }
      e.prototype.return = e.prototype.thenReturn = function (r) {
        return r instanceof e && r.suppressUnhandledRejections(), this._then(t, void 0, void 0, {
          value: r
        }, void 0);
      }, e.prototype.throw = e.prototype.thenThrow = function (e) {
        return this._then(r, void 0, void 0, {
          reason: e
        }, void 0);
      }, e.prototype.catchThrow = function (e) {
        if (arguments.length <= 1) return this._then(void 0, r, void 0, {
          reason: e
        }, void 0);
        var t = arguments[1],
          n = function n() {
            throw t;
          };
        return this.caught(e, n);
      }, e.prototype.catchReturn = function (r) {
        if (arguments.length <= 1) return r instanceof e && r.suppressUnhandledRejections(), this._then(void 0, t, void 0, {
          value: r
        }, void 0);
        var n = arguments[1];
        n instanceof e && n.suppressUnhandledRejections();
        var i = function i() {
          return n;
        };
        return this.caught(r, i);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      function r() {
        return a(this);
      }
      function n(e, r) {
        return i(e, r, t, t);
      }
      var i = e.reduce,
        a = e.all;
      e.prototype.each = function (e) {
        return i(this, e, t, 0)._then(r, void 0, void 0, this, void 0);
      }, e.prototype.mapSeries = function (e) {
        return i(this, e, t, t);
      }, e.each = function (e, n) {
        return i(e, n, t, 0)._then(r, void 0, void 0, e, void 0);
      }, e.mapSeries = n;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      var r = e.map;
      e.prototype.filter = function (e, n) {
        return r(this, e, n, t);
      }, e.filter = function (e, n, i) {
        return r(e, n, i, t);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      function n(e, t, r) {
        this.promise = e, this.type = t, this.handler = r, this.called = !1, this.cancelPromise = null;
      }
      function i(e) {
        this.finallyHandler = e;
      }
      function a(e, t) {
        return null != e.cancelPromise && (arguments.length > 1 ? e.cancelPromise._reject(t) : e.cancelPromise._cancel(), e.cancelPromise = null, !0);
      }
      function o() {
        return l.call(this, this.promise._target()._settledValue());
      }
      function s(e) {
        if (!a(this, e)) return h.e = e, h;
      }
      function l(r) {
        var n = this.promise,
          l = this.handler;
        if (!this.called) {
          this.called = !0;
          var c = this.isFinallyHandler() ? l.call(n._boundValue()) : l.call(n._boundValue(), r);
          if (void 0 !== c) {
            n._setReturnedNonUndefined();
            var f = t(c, n);
            if (f instanceof e) {
              if (null != this.cancelPromise) {
                if (f._isCancelled()) {
                  var d = new u("late cancellation observer");
                  return n._attachExtraTrace(d), h.e = d, h;
                }
                f.isPending() && f._attachCancellationCallback(new i(this));
              }
              return f._then(o, s, void 0, this, void 0);
            }
          }
        }
        return n.isRejected() ? (a(this), h.e = r, h) : (a(this), r);
      }
      var c = r(0),
        u = e.CancellationError,
        h = c.errorObj;
      return n.prototype.isFinallyHandler = function () {
        return 0 === this.type;
      }, i.prototype._resultCancelled = function () {
        a(this.finallyHandler);
      }, e.prototype._passThrough = function (e, t, r, i) {
        return "function" != typeof e ? this.then() : this._then(r, i, void 0, new n(this, t, e), void 0);
      }, e.prototype.lastly = e.prototype.finally = function (e) {
        return this._passThrough(e, 0, l, l);
      }, e.prototype.tap = function (e) {
        return this._passThrough(e, 1, l);
      }, n;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a, o) {
      function s(t, r, n) {
        for (var a = 0; a < r.length; ++a) {
          n._pushContext();
          var o = d(r[a])(t);
          if (n._popContext(), o === f) {
            n._pushContext();
            var s = e.reject(f.e);
            return n._popContext(), s;
          }
          var l = i(o, n);
          if (l instanceof e) return l;
        }
        return null;
      }
      function l(t, r, i, a) {
        if (o.cancellation()) {
          var s = new e(n),
            l = this._finallyPromise = new e(n);
          this._promise = s.lastly(function () {
            return l;
          }), s._captureStackTrace(), s._setOnCancel(this);
        } else {
          (this._promise = new e(n))._captureStackTrace();
        }
        this._stack = a, this._generatorFunction = t, this._receiver = r, this._generator = void 0, this._yieldHandlers = "function" == typeof i ? [i].concat(p) : p, this._yieldedPromise = null, this._cancellationPhase = !1;
      }
      var c = r(18),
        u = c.TypeError,
        h = r(0),
        f = h.errorObj,
        d = h.tryCatch,
        p = [];
      h.inherits(l, a), l.prototype._isResolved = function () {
        return null === this._promise;
      }, l.prototype._cleanup = function () {
        this._promise = this._generator = null, o.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null);
      }, l.prototype._promiseCancelled = function () {
        if (!this._isResolved()) {
          var t,
            r = void 0 !== this._generator.return;
          if (r) this._promise._pushContext(), t = d(this._generator.return).call(this._generator, void 0), this._promise._popContext();else {
            var n = new e.CancellationError("generator .return() sentinel");
            e.coroutine.returnSentinel = n, this._promise._attachExtraTrace(n), this._promise._pushContext(), t = d(this._generator.throw).call(this._generator, n), this._promise._popContext();
          }
          this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(t);
        }
      }, l.prototype._promiseFulfilled = function (e) {
        this._yieldedPromise = null, this._promise._pushContext();
        var t = d(this._generator.next).call(this._generator, e);
        this._promise._popContext(), this._continue(t);
      }, l.prototype._promiseRejected = function (e) {
        this._yieldedPromise = null, this._promise._attachExtraTrace(e), this._promise._pushContext();
        var t = d(this._generator.throw).call(this._generator, e);
        this._promise._popContext(), this._continue(t);
      }, l.prototype._resultCancelled = function () {
        if (this._yieldedPromise instanceof e) {
          var t = this._yieldedPromise;
          this._yieldedPromise = null, t.cancel();
        }
      }, l.prototype.promise = function () {
        return this._promise;
      }, l.prototype._run = function () {
        this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
      }, l.prototype._continue = function (t) {
        var r = this._promise;
        if (t === f) return this._cleanup(), this._cancellationPhase ? r.cancel() : r._rejectCallback(t.e, !1);
        var n = t.value;
        if (!0 === t.done) return this._cleanup(), this._cancellationPhase ? r.cancel() : r._resolveCallback(n);
        var a = i(n, this._promise);
        if (!(a instanceof e) && null === (a = s(a, this._yieldHandlers, this._promise))) return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", n) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
        a = a._target();
        var o = a._bitField;
        0 == (50397184 & o) ? (this._yieldedPromise = a, a._proxy(this, null)) : 0 != (33554432 & o) ? e._async.invoke(this._promiseFulfilled, this, a._value()) : 0 != (16777216 & o) ? e._async.invoke(this._promiseRejected, this, a._reason()) : this._promiseCancelled();
      }, e.coroutine = function (e, t) {
        if ("function" != typeof e) throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
        var r = Object(t).yieldHandler,
          n = l,
          i = new Error().stack;
        return function () {
          var t = e.apply(this, arguments),
            a = new n(void 0, void 0, r, i),
            o = a.promise();
          return a._generator = t, a._promiseFulfilled(void 0), o;
        };
      }, e.coroutine.addYieldHandler = function (e) {
        if ("function" != typeof e) throw new u("expecting a function but got " + h.classString(e));
        p.push(e);
      }, e.spawn = function (r) {
        if (o.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof r) return t("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
        var n = new l(r, this),
          i = n.promise();
        return n._run(e.spawn), i;
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a, o) {
      var s,
        l = r(0),
        c = l.canEvaluate,
        u = l.tryCatch,
        h = l.errorObj;
      if (c) {
        for (var f = [], d = [], p = [], m = 0; m < 8; ++m) f.push(function (t) {
          for (var r = new Array(t), n = 0; n < r.length; ++n) r[n] = "this.p" + (n + 1);
          var i = r.join(" = ") + " = null;",
            o = "var promise;\n" + r.map(function (e) {
              return "                                                         \n                promise = " + e + ";                                      \n                if (promise instanceof Promise) {                            \n                    promise.cancel();                                        \n                }                                                            \n            ";
            }).join("\n"),
            s = r.join(", "),
            l = "Holder$" + t,
            c = "return function(tryCatch, errorObj, Promise, async) {    \n            'use strict';                                                    \n            function [TheName](fn) {                                         \n                [TheProperties]                                              \n                this.fn = fn;                                                \n                this.asyncNeeded = true;                                     \n                this.now = 0;                                                \n            }                                                                \n                                                                             \n            [TheName].prototype._callFunction = function(promise) {          \n                promise._pushContext();                                      \n                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n                promise._popContext();                                       \n                if (ret === errorObj) {                                      \n                    promise._rejectCallback(ret.e, false);                   \n                } else {                                                     \n                    promise._resolveCallback(ret);                           \n                }                                                            \n            };                                                               \n                                                                             \n            [TheName].prototype.checkFulfillment = function(promise) {       \n                var now = ++this.now;                                        \n                if (now === [TheTotal]) {                                    \n                    if (this.asyncNeeded) {                                  \n                        async.invoke(this._callFunction, this, promise);     \n                    } else {                                                 \n                        this._callFunction(promise);                         \n                    }                                                        \n                                                                             \n                }                                                            \n            };                                                               \n                                                                             \n            [TheName].prototype._resultCancelled = function() {              \n                [CancellationCode]                                           \n            };                                                               \n                                                                             \n            return [TheName];                                                \n        }(tryCatch, errorObj, Promise, async);                               \n        ";
          return c = c.replace(/\[TheName\]/g, l).replace(/\[TheTotal\]/g, t).replace(/\[ThePassedArguments\]/g, s).replace(/\[TheProperties\]/g, i).replace(/\[CancellationCode\]/g, o), new Function("tryCatch", "errorObj", "Promise", "async", c)(u, h, e, a);
        }(m + 1)), d.push(function (e) {
          return new Function("value", "holder", "                             \n            'use strict';                                                    \n            holder.pIndex = value;                                           \n            holder.checkFulfillment(this);                                   \n            ".replace(/Index/g, e));
        }(m + 1)), p.push(function (e) {
          return new Function("promise", "holder", "                           \n            'use strict';                                                    \n            holder.pIndex = promise;                                         \n            ".replace(/Index/g, e));
        }(m + 1));
        s = function s(e) {
          this._reject(e);
        };
      }
      e.join = function () {
        var r,
          a = arguments.length - 1;
        if (a > 0 && "function" == typeof arguments[a] && (r = arguments[a], a <= 8 && c)) {
          var u = new e(i);
          u._captureStackTrace();
          for (var h = f[a - 1], m = new h(r), g = d, v = 0; v < a; ++v) {
            var b = n(arguments[v], u);
            if (b instanceof e) {
              b = b._target();
              var y = b._bitField;
              0 == (50397184 & y) ? (b._then(g[v], s, void 0, u, m), p[v](b, m), m.asyncNeeded = !1) : 0 != (33554432 & y) ? g[v].call(u, b._value(), m) : 0 != (16777216 & y) ? u._reject(b._reason()) : u._cancel();
            } else g[v].call(u, b, m);
          }
          if (!u._isFateSealed()) {
            if (m.asyncNeeded) {
              var w = o();
              null !== w && (m.fn = l.domainBind(w, m.fn));
            }
            u._setAsyncGuaranteed(), u._setOnCancel(m);
          }
          return u;
        }
        for (var x = arguments.length, _ = new Array(x), S = 0; S < x; ++S) _[S] = arguments[S];
        r && _.pop();
        var u = new t(_).promise();
        return void 0 !== r ? u.spread(r) : u;
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a, o) {
      function s(e, t, r, n) {
        this.constructor$(e), this._promise._captureStackTrace();
        var i = c();
        this._callback = null === i ? t : u.domainBind(i, t), this._preservedValues = n === a ? new Array(this.length()) : null, this._limit = r, this._inFlight = 0, this._queue = [], d.invoke(this._asyncInit, this, void 0);
      }
      function l(t, r, i, a) {
        if ("function" != typeof r) return n("expecting a function but got " + u.classString(r));
        var o = 0;
        if (void 0 !== i) {
          if ("object" != _typeof(i) || null === i) return e.reject(new TypeError("options argument must be an object but it is " + u.classString(i)));
          if ("number" != typeof i.concurrency) return e.reject(new TypeError("'concurrency' must be a number but it is " + u.classString(i.concurrency)));
          o = i.concurrency;
        }
        return o = "number" == typeof o && isFinite(o) && o >= 1 ? o : 0, new s(t, r, o, a).promise();
      }
      var c = e._getDomain,
        u = r(0),
        h = u.tryCatch,
        f = u.errorObj,
        d = e._async;
      u.inherits(s, t), s.prototype._asyncInit = function () {
        this._init$(void 0, -2);
      }, s.prototype._init = function () {}, s.prototype._promiseFulfilled = function (t, r) {
        var n = this._values,
          a = this.length(),
          s = this._preservedValues,
          l = this._limit;
        if (r < 0) {
          if (r = -1 * r - 1, n[r] = t, l >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) return !0;
        } else {
          if (l >= 1 && this._inFlight >= l) return n[r] = t, this._queue.push(r), !1;
          null !== s && (s[r] = t);
          var c = this._promise,
            u = this._callback,
            d = c._boundValue();
          c._pushContext();
          var p = h(u).call(d, t, r, a),
            m = c._popContext();
          if (o.checkForgottenReturns(p, m, null !== s ? "Promise.filter" : "Promise.map", c), p === f) return this._reject(p.e), !0;
          var g = i(p, this._promise);
          if (g instanceof e) {
            g = g._target();
            var v = g._bitField;
            if (0 == (50397184 & v)) return l >= 1 && this._inFlight++, n[r] = g, g._proxy(this, -1 * (r + 1)), !1;
            if (0 == (33554432 & v)) return 0 != (16777216 & v) ? (this._reject(g._reason()), !0) : (this._cancel(), !0);
            p = g._value();
          }
          n[r] = p;
        }
        return ++this._totalResolved >= a && (null !== s ? this._filter(n, s) : this._resolve(n), !0);
      }, s.prototype._drainQueue = function () {
        for (var e = this._queue, t = this._limit, r = this._values; e.length > 0 && this._inFlight < t;) {
          if (this._isResolved()) return;
          var n = e.pop();
          this._promiseFulfilled(r[n], n);
        }
      }, s.prototype._filter = function (e, t) {
        for (var r = t.length, n = new Array(r), i = 0, a = 0; a < r; ++a) e[a] && (n[i++] = t[a]);
        n.length = i, this._resolve(n);
      }, s.prototype.preservedValues = function () {
        return this._preservedValues;
      }, e.prototype.map = function (e, t) {
        return l(this, e, t, null);
      }, e.map = function (e, t, r, n) {
        return l(e, t, r, n);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a) {
      var o = r(0),
        s = o.tryCatch;
      e.method = function (r) {
        if ("function" != typeof r) throw new e.TypeError("expecting a function but got " + o.classString(r));
        return function () {
          var n = new e(t);
          n._captureStackTrace(), n._pushContext();
          var i = s(r).apply(this, arguments),
            o = n._popContext();
          return a.checkForgottenReturns(i, o, "Promise.method", n), n._resolveFromSyncValue(i), n;
        };
      }, e.attempt = e.try = function (r) {
        if ("function" != typeof r) return i("expecting a function but got " + o.classString(r));
        var n = new e(t);
        n._captureStackTrace(), n._pushContext();
        var l;
        if (arguments.length > 1) {
          a.deprecated("calling Promise.try with more than 1 argument");
          var c = arguments[1],
            u = arguments[2];
          l = o.isArray(c) ? s(r).apply(u, c) : s(r).call(u, c);
        } else l = s(r)();
        var h = n._popContext();
        return a.checkForgottenReturns(l, h, "Promise.try", n), n._resolveFromSyncValue(l), n;
      }, e.prototype._resolveFromSyncValue = function (e) {
        e === o.errorObj ? this._rejectCallback(e.e, !1) : this._resolveCallback(e, !0);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t(e, t) {
        var r = this;
        if (!a.isArray(e)) return n.call(r, e, t);
        var i = s(t).apply(r._boundValue(), [null].concat(e));
        i === l && o.throwLater(i.e);
      }
      function n(e, t) {
        var r = this,
          n = r._boundValue(),
          i = void 0 === e ? s(t).call(n, null) : s(t).call(n, null, e);
        i === l && o.throwLater(i.e);
      }
      function i(e, t) {
        var r = this;
        if (!e) {
          var n = new Error(e + "");
          n.cause = e, e = n;
        }
        var i = s(t).call(r._boundValue(), e);
        i === l && o.throwLater(i.e);
      }
      var a = r(0),
        o = e._async,
        s = a.tryCatch,
        l = a.errorObj;
      e.prototype.asCallback = e.prototype.nodeify = function (e, r) {
        if ("function" == typeof e) {
          var a = n;
          void 0 !== r && Object(r).spread && (a = t), this._then(a, i, void 0, this, e);
        }
        return this;
      };
    };
  }, function (e, t, r) {
    "use strict";

    (function (t) {
      e.exports = function () {
        function n() {}
        function i(e, t) {
          if ("function" != typeof t) throw new y("expecting a function but got " + p.classString(t));
          if (e.constructor !== a) throw new y("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
        }
        function a(e) {
          this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, e !== x && (i(this, e), this._resolveFromExecutor(e)), this._promiseCreated(), this._fireEvent("promiseCreated", this);
        }
        function o(e) {
          this.promise._resolveCallback(e);
        }
        function s(e) {
          this.promise._rejectCallback(e, !1);
        }
        function l(e) {
          var t = new a(x);
          t._fulfillmentHandler0 = e, t._rejectionHandler0 = e, t._promise0 = e, t._receiver0 = e;
        }
        var c,
          u = function u() {
            return new y("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
          },
          h = function h() {
            return new a.PromiseInspection(this._target());
          },
          f = function f(e) {
            return a.reject(new y(e));
          },
          d = {},
          p = r(0);
        c = p.isNode ? function () {
          var e = t.domain;
          return void 0 === e && (e = null), e;
        } : function () {
          return null;
        }, p.notEnumerableProp(a, "_getDomain", c);
        var m = r(36),
          g = r(211),
          v = new g();
        m.defineProperty(a, "_async", {
          value: v
        });
        var b = r(18),
          y = a.TypeError = b.TypeError;
        a.RangeError = b.RangeError;
        var w = a.CancellationError = b.CancellationError;
        a.TimeoutError = b.TimeoutError, a.OperationalError = b.OperationalError, a.RejectionError = b.OperationalError, a.AggregateError = b.AggregateError;
        var x = function x() {},
          _ = {},
          S = {},
          C = r(238)(a, x),
          E = r(228)(a, x, C, f, n),
          A = r(216)(a),
          T = A.create,
          k = r(217)(a, A),
          R = (k.CapturedTrace, r(221)(a, C)),
          I = r(215)(S),
          M = r(102),
          O = p.errorObj,
          P = p.tryCatch;
        return a.prototype.toString = function () {
          return "[object Promise]";
        }, a.prototype.caught = a.prototype.catch = function (e) {
          var t = arguments.length;
          if (t > 1) {
            var r,
              n = new Array(t - 1),
              i = 0;
            for (r = 0; r < t - 1; ++r) {
              var a = arguments[r];
              if (!p.isObject(a)) return f("expecting an object but got A catch statement predicate " + p.classString(a));
              n[i++] = a;
            }
            return n.length = i, e = arguments[r], this.then(void 0, I(n, e, this));
          }
          return this.then(void 0, e);
        }, a.prototype.reflect = function () {
          return this._then(h, h, void 0, this, void 0);
        }, a.prototype.then = function (e, t) {
          if (k.warnings() && arguments.length > 0 && "function" != typeof e && "function" != typeof t) {
            var r = ".then() only accepts functions but was passed: " + p.classString(e);
            arguments.length > 1 && (r += ", " + p.classString(t)), this._warn(r);
          }
          return this._then(e, t, void 0, void 0, void 0);
        }, a.prototype.done = function (e, t) {
          this._then(e, t, void 0, void 0, void 0)._setIsFinal();
        }, a.prototype.spread = function (e) {
          return "function" != typeof e ? f("expecting a function but got " + p.classString(e)) : this.all()._then(e, void 0, void 0, _, void 0);
        }, a.prototype.toJSON = function () {
          var e = {
            isFulfilled: !1,
            isRejected: !1,
            fulfillmentValue: void 0,
            rejectionReason: void 0
          };
          return this.isFulfilled() ? (e.fulfillmentValue = this.value(), e.isFulfilled = !0) : this.isRejected() && (e.rejectionReason = this.reason(), e.isRejected = !0), e;
        }, a.prototype.all = function () {
          return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new E(this).promise();
        }, a.prototype.error = function (e) {
          return this.caught(p.originatesFromRejection, e);
        }, a.getNewLibraryCopy = e.exports, a.is = function (e) {
          return e instanceof a;
        }, a.fromNode = a.fromCallback = function (e) {
          var t = new a(x);
          t._captureStackTrace();
          var r = arguments.length > 1 && !!Object(arguments[1]).multiArgs,
            n = P(e)(M(t, r));
          return n === O && t._rejectCallback(n.e, !0), t._isFateSealed() || t._setAsyncGuaranteed(), t;
        }, a.all = function (e) {
          return new E(e).promise();
        }, a.cast = function (e) {
          var t = C(e);
          return t instanceof a || (t = new a(x), t._captureStackTrace(), t._setFulfilled(), t._rejectionHandler0 = e), t;
        }, a.resolve = a.fulfilled = a.cast, a.reject = a.rejected = function (e) {
          var t = new a(x);
          return t._captureStackTrace(), t._rejectCallback(e, !0), t;
        }, a.setScheduler = function (e) {
          if ("function" != typeof e) throw new y("expecting a function but got " + p.classString(e));
          return v.setScheduler(e);
        }, a.prototype._then = function (e, t, r, n, i) {
          var o = void 0 !== i,
            s = o ? i : new a(x),
            l = this._target(),
            u = l._bitField;
          o || (s._propagateFrom(this, 3), s._captureStackTrace(), void 0 === n && 0 != (2097152 & this._bitField) && (n = 0 != (50397184 & u) ? this._boundValue() : l === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, s));
          var h = c();
          if (0 != (50397184 & u)) {
            var f,
              d,
              m = l._settlePromiseCtx;
            0 != (33554432 & u) ? (d = l._rejectionHandler0, f = e) : 0 != (16777216 & u) ? (d = l._fulfillmentHandler0, f = t, l._unsetRejectionIsUnhandled()) : (m = l._settlePromiseLateCancellationObserver, d = new w("late cancellation observer"), l._attachExtraTrace(d), f = t), v.invoke(m, l, {
              handler: null === h ? f : "function" == typeof f && p.domainBind(h, f),
              promise: s,
              receiver: n,
              value: d
            });
          } else l._addCallbacks(e, t, s, n, h);
          return s;
        }, a.prototype._length = function () {
          return 65535 & this._bitField;
        }, a.prototype._isFateSealed = function () {
          return 0 != (117506048 & this._bitField);
        }, a.prototype._isFollowing = function () {
          return 67108864 == (67108864 & this._bitField);
        }, a.prototype._setLength = function (e) {
          this._bitField = -65536 & this._bitField | 65535 & e;
        }, a.prototype._setFulfilled = function () {
          this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this);
        }, a.prototype._setRejected = function () {
          this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this);
        }, a.prototype._setFollowing = function () {
          this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this);
        }, a.prototype._setIsFinal = function () {
          this._bitField = 4194304 | this._bitField;
        }, a.prototype._isFinal = function () {
          return (4194304 & this._bitField) > 0;
        }, a.prototype._unsetCancelled = function () {
          this._bitField = -65537 & this._bitField;
        }, a.prototype._setCancelled = function () {
          this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this);
        }, a.prototype._setWillBeCancelled = function () {
          this._bitField = 8388608 | this._bitField;
        }, a.prototype._setAsyncGuaranteed = function () {
          v.hasCustomScheduler() || (this._bitField = 134217728 | this._bitField);
        }, a.prototype._receiverAt = function (e) {
          var t = 0 === e ? this._receiver0 : this[4 * e - 4 + 3];
          if (t !== d) return void 0 === t && this._isBound() ? this._boundValue() : t;
        }, a.prototype._promiseAt = function (e) {
          return this[4 * e - 4 + 2];
        }, a.prototype._fulfillmentHandlerAt = function (e) {
          return this[4 * e - 4 + 0];
        }, a.prototype._rejectionHandlerAt = function (e) {
          return this[4 * e - 4 + 1];
        }, a.prototype._boundValue = function () {}, a.prototype._migrateCallback0 = function (e) {
          var t = (e._bitField, e._fulfillmentHandler0),
            r = e._rejectionHandler0,
            n = e._promise0,
            i = e._receiverAt(0);
          void 0 === i && (i = d), this._addCallbacks(t, r, n, i, null);
        }, a.prototype._migrateCallbackAt = function (e, t) {
          var r = e._fulfillmentHandlerAt(t),
            n = e._rejectionHandlerAt(t),
            i = e._promiseAt(t),
            a = e._receiverAt(t);
          void 0 === a && (a = d), this._addCallbacks(r, n, i, a, null);
        }, a.prototype._addCallbacks = function (e, t, r, n, i) {
          var a = this._length();
          if (a >= 65531 && (a = 0, this._setLength(0)), 0 === a) this._promise0 = r, this._receiver0 = n, "function" == typeof e && (this._fulfillmentHandler0 = null === i ? e : p.domainBind(i, e)), "function" == typeof t && (this._rejectionHandler0 = null === i ? t : p.domainBind(i, t));else {
            var o = 4 * a - 4;
            this[o + 2] = r, this[o + 3] = n, "function" == typeof e && (this[o + 0] = null === i ? e : p.domainBind(i, e)), "function" == typeof t && (this[o + 1] = null === i ? t : p.domainBind(i, t));
          }
          return this._setLength(a + 1), a;
        }, a.prototype._proxy = function (e, t) {
          this._addCallbacks(void 0, void 0, t, e, null);
        }, a.prototype._resolveCallback = function (e, t) {
          if (0 == (117506048 & this._bitField)) {
            if (e === this) return this._rejectCallback(u(), !1);
            var r = C(e, this);
            if (!(r instanceof a)) return this._fulfill(e);
            t && this._propagateFrom(r, 2);
            var n = r._target();
            if (n === this) return void this._reject(u());
            var i = n._bitField;
            if (0 == (50397184 & i)) {
              var o = this._length();
              o > 0 && n._migrateCallback0(this);
              for (var s = 1; s < o; ++s) n._migrateCallbackAt(this, s);
              this._setFollowing(), this._setLength(0), this._setFollowee(n);
            } else if (0 != (33554432 & i)) this._fulfill(n._value());else if (0 != (16777216 & i)) this._reject(n._reason());else {
              var l = new w("late cancellation observer");
              n._attachExtraTrace(l), this._reject(l);
            }
          }
        }, a.prototype._rejectCallback = function (e, t, r) {
          var n = p.ensureErrorObject(e),
            i = n === e;
          if (!i && !r && k.warnings()) {
            var a = "a promise was rejected with a non-error: " + p.classString(e);
            this._warn(a, !0);
          }
          this._attachExtraTrace(n, !!t && i), this._reject(e);
        }, a.prototype._resolveFromExecutor = function (e) {
          var t = this;
          this._captureStackTrace(), this._pushContext();
          var r = !0,
            n = this._execute(e, function (e) {
              t._resolveCallback(e);
            }, function (e) {
              t._rejectCallback(e, r);
            });
          r = !1, this._popContext(), void 0 !== n && t._rejectCallback(n, !0);
        }, a.prototype._settlePromiseFromHandler = function (e, t, r, n) {
          var i = n._bitField;
          if (0 == (65536 & i)) {
            n._pushContext();
            var a;
            t === _ ? r && "number" == typeof r.length ? a = P(e).apply(this._boundValue(), r) : (a = O, a.e = new y("cannot .spread() a non-array: " + p.classString(r))) : a = P(e).call(t, r);
            var o = n._popContext();
            i = n._bitField, 0 == (65536 & i) && (a === S ? n._reject(r) : a === O ? n._rejectCallback(a.e, !1) : (k.checkForgottenReturns(a, o, "", n, this), n._resolveCallback(a)));
          }
        }, a.prototype._target = function () {
          for (var e = this; e._isFollowing();) e = e._followee();
          return e;
        }, a.prototype._followee = function () {
          return this._rejectionHandler0;
        }, a.prototype._setFollowee = function (e) {
          this._rejectionHandler0 = e;
        }, a.prototype._settlePromise = function (e, t, r, i) {
          var o = e instanceof a,
            s = this._bitField,
            l = 0 != (134217728 & s);
          0 != (65536 & s) ? (o && e._invokeInternalOnCancel(), r instanceof R && r.isFinallyHandler() ? (r.cancelPromise = e, P(t).call(r, i) === O && e._reject(O.e)) : t === h ? e._fulfill(h.call(r)) : r instanceof n ? r._promiseCancelled(e) : o || e instanceof E ? e._cancel() : r.cancel()) : "function" == typeof t ? o ? (l && e._setAsyncGuaranteed(), this._settlePromiseFromHandler(t, r, i, e)) : t.call(r, i, e) : r instanceof n ? r._isResolved() || (0 != (33554432 & s) ? r._promiseFulfilled(i, e) : r._promiseRejected(i, e)) : o && (l && e._setAsyncGuaranteed(), 0 != (33554432 & s) ? e._fulfill(i) : e._reject(i));
        }, a.prototype._settlePromiseLateCancellationObserver = function (e) {
          var t = e.handler,
            r = e.promise,
            n = e.receiver,
            i = e.value;
          "function" == typeof t ? r instanceof a ? this._settlePromiseFromHandler(t, n, i, r) : t.call(n, i, r) : r instanceof a && r._reject(i);
        }, a.prototype._settlePromiseCtx = function (e) {
          this._settlePromise(e.promise, e.handler, e.receiver, e.value);
        }, a.prototype._settlePromise0 = function (e, t, r) {
          var n = this._promise0,
            i = this._receiverAt(0);
          this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(n, e, i, t);
        }, a.prototype._clearCallbackDataAtIndex = function (e) {
          var t = 4 * e - 4;
          this[t + 2] = this[t + 3] = this[t + 0] = this[t + 1] = void 0;
        }, a.prototype._fulfill = function (e) {
          var t = this._bitField;
          if (!((117506048 & t) >>> 16)) {
            if (e === this) {
              var r = u();
              return this._attachExtraTrace(r), this._reject(r);
            }
            this._setFulfilled(), this._rejectionHandler0 = e, (65535 & t) > 0 && (0 != (134217728 & t) ? this._settlePromises() : v.settlePromises(this));
          }
        }, a.prototype._reject = function (e) {
          var t = this._bitField;
          if (!((117506048 & t) >>> 16)) {
            if (this._setRejected(), this._fulfillmentHandler0 = e, this._isFinal()) return v.fatalError(e, p.isNode);
            (65535 & t) > 0 ? v.settlePromises(this) : this._ensurePossibleRejectionHandled();
          }
        }, a.prototype._fulfillPromises = function (e, t) {
          for (var r = 1; r < e; r++) {
            var n = this._fulfillmentHandlerAt(r),
              i = this._promiseAt(r),
              a = this._receiverAt(r);
            this._clearCallbackDataAtIndex(r), this._settlePromise(i, n, a, t);
          }
        }, a.prototype._rejectPromises = function (e, t) {
          for (var r = 1; r < e; r++) {
            var n = this._rejectionHandlerAt(r),
              i = this._promiseAt(r),
              a = this._receiverAt(r);
            this._clearCallbackDataAtIndex(r), this._settlePromise(i, n, a, t);
          }
        }, a.prototype._settlePromises = function () {
          var e = this._bitField,
            t = 65535 & e;
          if (t > 0) {
            if (0 != (16842752 & e)) {
              var r = this._fulfillmentHandler0;
              this._settlePromise0(this._rejectionHandler0, r, e), this._rejectPromises(t, r);
            } else {
              var n = this._rejectionHandler0;
              this._settlePromise0(this._fulfillmentHandler0, n, e), this._fulfillPromises(t, n);
            }
            this._setLength(0);
          }
          this._clearCancellationData();
        }, a.prototype._settledValue = function () {
          var e = this._bitField;
          return 0 != (33554432 & e) ? this._rejectionHandler0 : 0 != (16777216 & e) ? this._fulfillmentHandler0 : void 0;
        }, a.defer = a.pending = function () {
          return k.deprecated("Promise.defer", "new Promise"), {
            promise: new a(x),
            resolve: o,
            reject: s
          };
        }, p.notEnumerableProp(a, "_makeSelfResolutionError", u), r(225)(a, x, C, f, k), r(212)(a, x, C, k), r(214)(a, E, f, k), r(218)(a), r(237)(a), r(223)(a, E, C, x, v, c), a.Promise = a, a.version = "3.4.7", r(224)(a, E, f, C, x, k), r(213)(a), r(240)(a, f, C, T, x, k), r(239)(a, x, k), r(222)(a, f, x, C, n, k), r(226)(a), r(229)(a, x), r(230)(a, E, C, f), r(232)(a, x, C, f), r(233)(a, E, f, C, x, k), r(235)(a, E, k), r(236)(a, E, f), r(220)(a, x), r(219)(a, x), r(210)(a), p.toFastProperties(a), p.toFastProperties(a.prototype), l({
          a: 1
        }), l({
          b: 2
        }), l({
          c: 3
        }), l(1), l(function () {}), l(void 0), l(!1), l(new a(x)), k.setBounds(g.firstLineError, p.lastLineError), a;
      };
    }).call(t, r(5));
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a) {
      function o(e) {
        switch (e) {
          case -2:
            return [];
          case -3:
            return {};
        }
      }
      function s(r) {
        var n = this._promise = new e(t);
        r instanceof e && n._propagateFrom(r, 3), n._setOnCancel(this), this._values = r, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
      }
      var l = r(0);
      l.isArray;
      return l.inherits(s, a), s.prototype.length = function () {
        return this._length;
      }, s.prototype.promise = function () {
        return this._promise;
      }, s.prototype._init = function t(r, a) {
        var s = n(this._values, this._promise);
        if (s instanceof e) {
          s = s._target();
          var c = s._bitField;
          if (this._values = s, 0 == (50397184 & c)) return this._promise._setAsyncGuaranteed(), s._then(t, this._reject, void 0, this, a);
          if (0 == (33554432 & c)) return 0 != (16777216 & c) ? this._reject(s._reason()) : this._cancel();
          s = s._value();
        }
        if (null === (s = l.asArray(s))) {
          var u = i("expecting an array or an iterable object but got " + l.classString(s)).reason();
          return void this._promise._rejectCallback(u, !1);
        }
        if (0 === s.length) return void (-5 === a ? this._resolveEmptyArray() : this._resolve(o(a)));
        this._iterate(s);
      }, s.prototype._iterate = function (t) {
        var r = this.getActualLength(t.length);
        this._length = r, this._values = this.shouldCopyValues() ? new Array(r) : this._values;
        for (var i = this._promise, a = !1, o = null, s = 0; s < r; ++s) {
          var l = n(t[s], i);
          l instanceof e ? (l = l._target(), o = l._bitField) : o = null, a ? null !== o && l.suppressUnhandledRejections() : null !== o ? 0 == (50397184 & o) ? (l._proxy(this, s), this._values[s] = l) : a = 0 != (33554432 & o) ? this._promiseFulfilled(l._value(), s) : 0 != (16777216 & o) ? this._promiseRejected(l._reason(), s) : this._promiseCancelled(s) : a = this._promiseFulfilled(l, s);
        }
        a || i._setAsyncGuaranteed();
      }, s.prototype._isResolved = function () {
        return null === this._values;
      }, s.prototype._resolve = function (e) {
        this._values = null, this._promise._fulfill(e);
      }, s.prototype._cancel = function () {
        !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel());
      }, s.prototype._reject = function (e) {
        this._values = null, this._promise._rejectCallback(e, !1);
      }, s.prototype._promiseFulfilled = function (e, t) {
        return this._values[t] = e, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
      }, s.prototype._promiseCancelled = function () {
        return this._cancel(), !0;
      }, s.prototype._promiseRejected = function (e) {
        return this._totalResolved++, this._reject(e), !0;
      }, s.prototype._resultCancelled = function () {
        if (!this._isResolved()) {
          var t = this._values;
          if (this._cancel(), t instanceof e) t.cancel();else for (var r = 0; r < t.length; ++r) t[r] instanceof e && t[r].cancel();
        }
      }, s.prototype.shouldCopyValues = function () {
        return !0;
      }, s.prototype.getActualLength = function (e) {
        return e;
      }, s;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      function n(e) {
        return !x.test(e);
      }
      function i(e) {
        try {
          return !0 === e.__isPromisified__;
        } catch (e) {
          return !1;
        }
      }
      function a(e, t, r) {
        var n = d.getDataPropertyOrDefault(e, t + r, y);
        return !!n && i(n);
      }
      function o(e, t, r) {
        for (var n = 0; n < e.length; n += 2) {
          var i = e[n];
          if (r.test(i)) for (var a = i.replace(r, ""), o = 0; o < e.length; o += 2) if (e[o] === a) throw new b("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", t));
        }
      }
      function s(e, t, r, n) {
        for (var s = d.inheritedDataKeys(e), l = [], c = 0; c < s.length; ++c) {
          var u = s[c],
            h = e[u],
            f = n === _ || _(u, h, e);
          "function" != typeof h || i(h) || a(e, u, t) || !n(u, h, e, f) || l.push(u, h);
        }
        return o(l, t, r), l;
      }
      function l(r, n, i, a, o, s) {
        function l() {
          var i = n;
          n === f && (i = this);
          var a = new e(t);
          a._captureStackTrace();
          var o = "string" == typeof u && this !== c ? this[u] : r,
            l = p(a, s);
          try {
            o.apply(i, m(arguments, l));
          } catch (e) {
            a._rejectCallback(g(e), !0, !0);
          }
          return a._isFateSealed() || a._setAsyncGuaranteed(), a;
        }
        var c = function () {
            return this;
          }(),
          u = r;
        return "string" == typeof u && (r = a), d.notEnumerableProp(l, "__isPromisified__", !0), l;
      }
      function c(e, t, r, n, i) {
        for (var a = new RegExp(S(t) + "$"), o = s(e, t, a, r), l = 0, c = o.length; l < c; l += 2) {
          var u = o[l],
            h = o[l + 1],
            p = u + t;
          if (n === k) e[p] = k(u, f, u, h, t, i);else {
            var m = n(h, function () {
              return k(u, f, u, h, t, i);
            });
            d.notEnumerableProp(m, "__isPromisified__", !0), e[p] = m;
          }
        }
        return d.toFastProperties(e), e;
      }
      function u(e, t, r) {
        return k(e, t, void 0, e, null, r);
      }
      var h,
        f = {},
        d = r(0),
        p = r(102),
        m = d.withAppended,
        g = d.maybeWrapAsError,
        v = d.canEvaluate,
        b = r(18).TypeError,
        y = {
          __isPromisified__: !0
        },
        w = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"],
        x = new RegExp("^(?:" + w.join("|") + ")$"),
        _ = function _(e) {
          return d.isIdentifier(e) && "_" !== e.charAt(0) && "constructor" !== e;
        },
        S = function S(e) {
          return e.replace(/([$])/, "\\$");
        },
        C = function C(e) {
          for (var t = [e], r = Math.max(0, e - 1 - 3), n = e - 1; n >= r; --n) t.push(n);
          for (var n = e + 1; n <= 3; ++n) t.push(n);
          return t;
        },
        E = function E(e) {
          return d.filledRange(e, "_arg", "");
        },
        A = function A(e) {
          return d.filledRange(Math.max(e, 3), "_arg", "");
        },
        T = function T(e) {
          return "number" == typeof e.length ? Math.max(Math.min(e.length, 1024), 0) : 0;
        };
      h = function h(r, n, i, a, o, s) {
        function l(e) {
          var t,
            r = E(e).join(", "),
            i = e > 0 ? ", " : "";
          return t = h ? "ret = callback.call(this, {{args}}, nodeback); break;\n" : void 0 === n ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n", t.replace("{{args}}", r).replace(", ", i);
        }
        var c = Math.max(0, T(a) - 1),
          u = C(c),
          h = "string" == typeof r || n === f,
          v = "string" == typeof r ? "this != null ? this['" + r + "'] : fn" : "fn",
          b = "'use strict';                                                \n        var ret = function (Parameters) {                                    \n            'use strict';                                                    \n            var len = arguments.length;                                      \n            var promise = new Promise(INTERNAL);                             \n            promise._captureStackTrace();                                    \n            var nodeback = nodebackForPromise(promise, " + s + ");   \n            var ret;                                                         \n            var callback = tryCatch([GetFunctionCode]);                      \n            switch(len) {                                                    \n                [CodeForSwitchCase]                                          \n            }                                                                \n            if (ret === errorObj) {                                          \n                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n            }                                                                \n            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n            return promise;                                                  \n        };                                                                   \n        notEnumerableProp(ret, '__isPromisified__', true);                   \n        return ret;                                                          \n    ".replace("[CodeForSwitchCase]", function () {
            for (var e = "", t = 0; t < u.length; ++t) e += "case " + u[t] + ":" + l(u[t]);
            return e += "                                                             \n        default:                                                             \n            var args = new Array(len + 1);                                   \n            var i = 0;                                                       \n            for (var i = 0; i < len; ++i) {                                  \n               args[i] = arguments[i];                                       \n            }                                                                \n            args[i] = nodeback;                                              \n            [CodeForCall]                                                    \n            break;                                                           \n        ".replace("[CodeForCall]", h ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
          }()).replace("[GetFunctionCode]", v);
        return b = b.replace("Parameters", A(c)), new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", b)(e, a, n, m, g, p, d.tryCatch, d.errorObj, d.notEnumerableProp, t);
      };
      var k = v ? h : l;
      e.promisify = function (e, t) {
        if ("function" != typeof e) throw new b("expecting a function but got " + d.classString(e));
        if (i(e)) return e;
        t = Object(t);
        var r = void 0 === t.context ? f : t.context,
          a = !!t.multiArgs,
          o = u(e, r, a);
        return d.copyDescriptors(e, o, n), o;
      }, e.promisifyAll = function (e, t) {
        if ("function" != typeof e && "object" != _typeof(e)) throw new b("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
        t = Object(t);
        var r = !!t.multiArgs,
          n = t.suffix;
        "string" != typeof n && (n = "Async");
        var i = t.filter;
        "function" != typeof i && (i = _);
        var a = t.promisifier;
        if ("function" != typeof a && (a = k), !d.isIdentifier(n)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
        for (var o = d.inheritedDataKeys(e), s = 0; s < o.length; ++s) {
          var l = e[o[s]];
          "constructor" !== o[s] && d.isClass(l) && (c(l.prototype, n, i, a, r), c(l, n, i, a, r));
        }
        return c(e, n, i, a, r);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i) {
      function a(e) {
        var t,
          r = !1;
        if (void 0 !== s && e instanceof s) t = h(e), r = !0;else {
          var n = u.keys(e),
            i = n.length;
          t = new Array(2 * i);
          for (var a = 0; a < i; ++a) {
            var o = n[a];
            t[a] = e[o], t[a + i] = o;
          }
        }
        this.constructor$(t), this._isMap = r, this._init$(void 0, -3);
      }
      function o(t) {
        var r,
          o = n(t);
        return c(o) ? (r = o instanceof e ? o._then(e.props, void 0, void 0, void 0, void 0) : new a(o).promise(), o instanceof e && r._propagateFrom(o, 2), r) : i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
      }
      var s,
        l = r(0),
        c = l.isObject,
        u = r(36);
      "function" == typeof Map && (s = Map);
      var h = function () {
          function e(e, n) {
            this[t] = e, this[t + r] = n, t++;
          }
          var t = 0,
            r = 0;
          return function (n) {
            r = n.size, t = 0;
            var i = new Array(2 * n.size);
            return n.forEach(e, i), i;
          };
        }(),
        f = function f(e) {
          for (var t = new s(), r = e.length / 2 | 0, n = 0; n < r; ++n) {
            var i = e[r + n],
              a = e[n];
            t.set(i, a);
          }
          return t;
        };
      l.inherits(a, t), a.prototype._init = function () {}, a.prototype._promiseFulfilled = function (e, t) {
        if (this._values[t] = e, ++this._totalResolved >= this._length) {
          var r;
          if (this._isMap) r = f(this._values);else {
            r = {};
            for (var n = this.length(), i = 0, a = this.length(); i < a; ++i) r[this._values[i + n]] = this._values[i];
          }
          return this._resolve(r), !0;
        }
        return !1;
      }, a.prototype.shouldCopyValues = function () {
        return !1;
      }, a.prototype.getActualLength = function (e) {
        return e >> 1;
      }, e.prototype.props = function () {
        return o(this);
      }, e.props = function (e) {
        return o(e);
      };
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r, n, i) {
      for (var a = 0; a < i; ++a) r[a + n] = e[a + t], e[a + t] = void 0;
    }
    function i(e) {
      this._capacity = e, this._length = 0, this._front = 0;
    }
    i.prototype._willBeOverCapacity = function (e) {
      return this._capacity < e;
    }, i.prototype._pushOne = function (e) {
      var t = this.length();
      this._checkCapacity(t + 1), this[this._front + t & this._capacity - 1] = e, this._length = t + 1;
    }, i.prototype.push = function (e, t, r) {
      var n = this.length() + 3;
      if (this._willBeOverCapacity(n)) return this._pushOne(e), this._pushOne(t), void this._pushOne(r);
      var i = this._front + n - 3;
      this._checkCapacity(n);
      var a = this._capacity - 1;
      this[i + 0 & a] = e, this[i + 1 & a] = t, this[i + 2 & a] = r, this._length = n;
    }, i.prototype.shift = function () {
      var e = this._front,
        t = this[e];
      return this[e] = void 0, this._front = e + 1 & this._capacity - 1, this._length--, t;
    }, i.prototype.length = function () {
      return this._length;
    }, i.prototype._checkCapacity = function (e) {
      this._capacity < e && this._resizeTo(this._capacity << 1);
    }, i.prototype._resizeTo = function (e) {
      var t = this._capacity;
      this._capacity = e, n(this, 0, this, t, this._front + this._length & t - 1);
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i) {
      function a(r, a) {
        var l = n(r);
        if (l instanceof e) return s(l);
        if (null === (r = o.asArray(r))) return i("expecting an array or an iterable object but got " + o.classString(r));
        var c = new e(t);
        void 0 !== a && c._propagateFrom(a, 3);
        for (var u = c._fulfill, h = c._reject, f = 0, d = r.length; f < d; ++f) {
          var p = r[f];
          (void 0 !== p || f in r) && e.cast(p)._then(u, h, void 0, c, null);
        }
        return c;
      }
      var o = r(0),
        s = function s(e) {
          return e.then(function (t) {
            return a(t, e);
          });
        };
      e.race = function (e) {
        return a(e, void 0);
      }, e.prototype.race = function () {
        return a(this, void 0);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a, o) {
      function s(t, r, n, i) {
        this.constructor$(t);
        var o = f();
        this._fn = null === o ? r : d.domainBind(o, r), void 0 !== n && (n = e.resolve(n), n._attachCancellationCallback(this)), this._initialValue = n, this._currentCancellable = null, this._eachValues = i === a ? Array(this._length) : 0 === i ? null : void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
      }
      function l(e, t) {
        this.isFulfilled() ? t._resolve(e) : t._reject(e);
      }
      function c(e, t, r, i) {
        return "function" != typeof t ? n("expecting a function but got " + d.classString(t)) : new s(e, t, r, i).promise();
      }
      function u(t) {
        this.accum = t, this.array._gotAccum(t);
        var r = i(this.value, this.array._promise);
        return r instanceof e ? (this.array._currentCancellable = r, r._then(h, void 0, void 0, this, void 0)) : h.call(this, r);
      }
      function h(t) {
        var r = this.array,
          n = r._promise,
          i = p(r._fn);
        n._pushContext();
        var a;
        (a = void 0 !== r._eachValues ? i.call(n._boundValue(), t, this.index, this.length) : i.call(n._boundValue(), this.accum, t, this.index, this.length)) instanceof e && (r._currentCancellable = a);
        var s = n._popContext();
        return o.checkForgottenReturns(a, s, void 0 !== r._eachValues ? "Promise.each" : "Promise.reduce", n), a;
      }
      var f = e._getDomain,
        d = r(0),
        p = d.tryCatch;
      d.inherits(s, t), s.prototype._gotAccum = function (e) {
        void 0 !== this._eachValues && null !== this._eachValues && e !== a && this._eachValues.push(e);
      }, s.prototype._eachComplete = function (e) {
        return null !== this._eachValues && this._eachValues.push(e), this._eachValues;
      }, s.prototype._init = function () {}, s.prototype._resolveEmptyArray = function () {
        this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue);
      }, s.prototype.shouldCopyValues = function () {
        return !1;
      }, s.prototype._resolve = function (e) {
        this._promise._resolveCallback(e), this._values = null;
      }, s.prototype._resultCancelled = function (t) {
        if (t === this._initialValue) return this._cancel();
        this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e && this._currentCancellable.cancel(), this._initialValue instanceof e && this._initialValue.cancel());
      }, s.prototype._iterate = function (t) {
        this._values = t;
        var r,
          n,
          i = t.length;
        if (void 0 !== this._initialValue ? (r = this._initialValue, n = 0) : (r = e.resolve(t[0]), n = 1), this._currentCancellable = r, !r.isRejected()) for (; n < i; ++n) {
          var a = {
            accum: null,
            value: t[n],
            index: n,
            length: i,
            array: this
          };
          r = r._then(u, void 0, void 0, a, void 0);
        }
        void 0 !== this._eachValues && (r = r._then(this._eachComplete, void 0, void 0, this, void 0)), r._then(l, l, void 0, r, this);
      }, e.prototype.reduce = function (e, t) {
        return c(this, e, t, null);
      }, e.reduce = function (e, t, r, n) {
        return c(e, t, r, n);
      };
    };
  }, function (e, t, r) {
    "use strict";

    (function (t, n, i) {
      var a,
        o = r(0),
        s = function s() {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
        },
        l = o.getNativePromise();
      if (o.isNode && "undefined" == typeof MutationObserver) {
        var c = t.setImmediate,
          u = n.nextTick;
        a = o.isRecentNode ? function (e) {
          c.call(t, e);
        } : function (e) {
          u.call(n, e);
        };
      } else if ("function" == typeof l && "function" == typeof l.resolve) {
        var h = l.resolve();
        a = function a(e) {
          h.then(e);
        };
      } else a = "undefined" == typeof MutationObserver || "undefined" != typeof window && window.navigator && (window.navigator.standalone || window.cordova) ? void 0 !== i ? function (e) {
        i(e);
      } : "undefined" != typeof setTimeout ? function (e) {
        setTimeout(e, 0);
      } : s : function () {
        var e = document.createElement("div"),
          t = {
            attributes: !0
          },
          r = !1,
          n = document.createElement("div");
        new MutationObserver(function () {
          e.classList.toggle("foo"), r = !1;
        }).observe(n, t);
        var i = function i() {
          r || (r = !0, n.classList.toggle("foo"));
        };
        return function (r) {
          var n = new MutationObserver(function () {
            n.disconnect(), r();
          });
          n.observe(e, t), i();
        };
      }();
      e.exports = a;
    }).call(t, r(13), r(5), r(141).setImmediate);
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n) {
      function i(e) {
        this.constructor$(e);
      }
      var a = e.PromiseInspection;
      r(0).inherits(i, t), i.prototype._promiseResolved = function (e, t) {
        return this._values[e] = t, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
      }, i.prototype._promiseFulfilled = function (e, t) {
        var r = new a();
        return r._bitField = 33554432, r._settledValueField = e, this._promiseResolved(t, r);
      }, i.prototype._promiseRejected = function (e, t) {
        var r = new a();
        return r._bitField = 16777216, r._settledValueField = e, this._promiseResolved(t, r);
      }, e.settle = function (e) {
        return n.deprecated(".settle()", ".reflect()"), new i(e).promise();
      }, e.prototype.settle = function () {
        return e.settle(this);
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n) {
      function i(e) {
        this.constructor$(e), this._howMany = 0, this._unwrap = !1, this._initialized = !1;
      }
      function a(e, t) {
        if ((0 | t) !== t || t < 0) return n("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
        var r = new i(e),
          a = r.promise();
        return r.setHowMany(t), r.init(), a;
      }
      var o = r(0),
        s = r(18).RangeError,
        l = r(18).AggregateError,
        c = o.isArray,
        u = {};
      o.inherits(i, t), i.prototype._init = function () {
        if (this._initialized) {
          if (0 === this._howMany) return void this._resolve([]);
          this._init$(void 0, -5);
          var e = c(this._values);
          !this._isResolved() && e && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
        }
      }, i.prototype.init = function () {
        this._initialized = !0, this._init();
      }, i.prototype.setUnwrap = function () {
        this._unwrap = !0;
      }, i.prototype.howMany = function () {
        return this._howMany;
      }, i.prototype.setHowMany = function (e) {
        this._howMany = e;
      }, i.prototype._promiseFulfilled = function (e) {
        return this._addFulfilled(e), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0);
      }, i.prototype._promiseRejected = function (e) {
        return this._addRejected(e), this._checkOutcome();
      }, i.prototype._promiseCancelled = function () {
        return this._values instanceof e || null == this._values ? this._cancel() : (this._addRejected(u), this._checkOutcome());
      }, i.prototype._checkOutcome = function () {
        if (this.howMany() > this._canPossiblyFulfill()) {
          for (var e = new l(), t = this.length(); t < this._values.length; ++t) this._values[t] !== u && e.push(this._values[t]);
          return e.length > 0 ? this._reject(e) : this._cancel(), !0;
        }
        return !1;
      }, i.prototype._fulfilled = function () {
        return this._totalResolved;
      }, i.prototype._rejected = function () {
        return this._values.length - this.length();
      }, i.prototype._addRejected = function (e) {
        this._values.push(e);
      }, i.prototype._addFulfilled = function (e) {
        this._values[this._totalResolved++] = e;
      }, i.prototype._canPossiblyFulfill = function () {
        return this.length() - this._rejected();
      }, i.prototype._getRangeError = function (e) {
        var t = "Input array must contain at least " + this._howMany + " items but contains only " + e + " items";
        return new s(t);
      }, i.prototype._resolveEmptyArray = function () {
        this._reject(this._getRangeError(0));
      }, e.some = function (e, t) {
        return a(e, t);
      }, e.prototype.some = function (e) {
        return a(this, e);
      }, e._SomePromiseArray = i;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      function t(e) {
        void 0 !== e ? (e = e._target(), this._bitField = e._bitField, this._settledValueField = e._isFateSealed() ? e._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
      }
      t.prototype._settledValue = function () {
        return this._settledValueField;
      };
      var r = t.prototype.value = function () {
          if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
          return this._settledValue();
        },
        n = t.prototype.error = t.prototype.reason = function () {
          if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
          return this._settledValue();
        },
        i = t.prototype.isFulfilled = function () {
          return 0 != (33554432 & this._bitField);
        },
        a = t.prototype.isRejected = function () {
          return 0 != (16777216 & this._bitField);
        },
        o = t.prototype.isPending = function () {
          return 0 == (50397184 & this._bitField);
        },
        s = t.prototype.isResolved = function () {
          return 0 != (50331648 & this._bitField);
        };
      t.prototype.isCancelled = function () {
        return 0 != (8454144 & this._bitField);
      }, e.prototype.__isCancelled = function () {
        return 65536 == (65536 & this._bitField);
      }, e.prototype._isCancelled = function () {
        return this._target().__isCancelled();
      }, e.prototype.isCancelled = function () {
        return 0 != (8454144 & this._target()._bitField);
      }, e.prototype.isPending = function () {
        return o.call(this._target());
      }, e.prototype.isRejected = function () {
        return a.call(this._target());
      }, e.prototype.isFulfilled = function () {
        return i.call(this._target());
      }, e.prototype.isResolved = function () {
        return s.call(this._target());
      }, e.prototype.value = function () {
        return r.call(this._target());
      }, e.prototype.reason = function () {
        var e = this._target();
        return e._unsetRejectionIsUnhandled(), n.call(e);
      }, e.prototype._value = function () {
        return this._settledValue();
      }, e.prototype._reason = function () {
        return this._unsetRejectionIsUnhandled(), this._settledValue();
      }, e.PromiseInspection = t;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      function n(r, n) {
        if (u(r)) {
          if (r instanceof e) return r;
          var i = a(r);
          if (i === c) {
            n && n._pushContext();
            var l = e.reject(i.e);
            return n && n._popContext(), l;
          }
          if ("function" == typeof i) {
            if (o(r)) {
              var l = new e(t);
              return r._then(l._fulfill, l._reject, void 0, l, null), l;
            }
            return s(r, i, n);
          }
        }
        return r;
      }
      function i(e) {
        return e.then;
      }
      function a(e) {
        try {
          return i(e);
        } catch (e) {
          return c.e = e, c;
        }
      }
      function o(e) {
        try {
          return h.call(e, "_promise0");
        } catch (e) {
          return !1;
        }
      }
      function s(r, n, i) {
        function a(e) {
          s && (s._resolveCallback(e), s = null);
        }
        function o(e) {
          s && (s._rejectCallback(e, h, !0), s = null);
        }
        var s = new e(t),
          u = s;
        i && i._pushContext(), s._captureStackTrace(), i && i._popContext();
        var h = !0,
          f = l.tryCatch(n).call(r, a, o);
        return h = !1, s && f === c && (s._rejectCallback(f.e, !0, !0), s = null), u;
      }
      var l = r(0),
        c = l.errorObj,
        u = l.isObject,
        h = {}.hasOwnProperty;
      return n;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n) {
      function i(e) {
        this.handle = e;
      }
      function a(e) {
        return clearTimeout(this.handle), e;
      }
      function o(e) {
        throw clearTimeout(this.handle), e;
      }
      var s = r(0),
        l = e.TimeoutError;
      i.prototype._resultCancelled = function () {
        clearTimeout(this.handle);
      };
      var c = function c(e) {
          return u(+this).thenReturn(e);
        },
        u = e.delay = function (r, a) {
          var o, s;
          return void 0 !== a ? (o = e.resolve(a)._then(c, null, null, r, void 0), n.cancellation() && a instanceof e && o._setOnCancel(a)) : (o = new e(t), s = setTimeout(function () {
            o._fulfill();
          }, +r), n.cancellation() && o._setOnCancel(new i(s)), o._captureStackTrace()), o._setAsyncGuaranteed(), o;
        };
      e.prototype.delay = function (e) {
        return u(e, this);
      };
      var h = function h(e, t, r) {
        var n;
        n = "string" != typeof t ? t instanceof Error ? t : new l("operation timed out") : new l(t), s.markAsOriginatingFromRejection(n), e._attachExtraTrace(n), e._reject(n), null != r && r.cancel();
      };
      e.prototype.timeout = function (e, t) {
        e = +e;
        var r,
          s,
          l = new i(setTimeout(function () {
            r.isPending() && h(r, t, s);
          }, e));
        return n.cancellation() ? (s = this.then(), r = s._then(a, o, void 0, l, void 0), r._setOnCancel(l)) : r = this._then(a, o, void 0, l, void 0), r;
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, n, i, a, o) {
      function s(e) {
        setTimeout(function () {
          throw e;
        }, 0);
      }
      function l(e) {
        var t = n(e);
        return t !== e && "function" == typeof e._isDisposable && "function" == typeof e._getDisposer && e._isDisposable() && t._setDisposable(e._getDisposer()), t;
      }
      function c(t, r) {
        function i() {
          if (o >= c) return u._fulfill();
          var a = l(t[o++]);
          if (a instanceof e && a._isDisposable()) {
            try {
              a = n(a._getDisposer().tryDispose(r), t.promise);
            } catch (e) {
              return s(e);
            }
            if (a instanceof e) return a._then(i, s, null, null, null);
          }
          i();
        }
        var o = 0,
          c = t.length,
          u = new e(a);
        return i(), u;
      }
      function u(e, t, r) {
        this._data = e, this._promise = t, this._context = r;
      }
      function h(e, t, r) {
        this.constructor$(e, t, r);
      }
      function f(e) {
        return u.isDisposer(e) ? (this.resources[this.index]._setDisposable(e), e.promise()) : e;
      }
      function d(e) {
        this.length = e, this.promise = null, this[e - 1] = null;
      }
      var p = r(0),
        m = r(18).TypeError,
        g = r(0).inherits,
        v = p.errorObj,
        b = p.tryCatch,
        y = {};
      u.prototype.data = function () {
        return this._data;
      }, u.prototype.promise = function () {
        return this._promise;
      }, u.prototype.resource = function () {
        return this.promise().isFulfilled() ? this.promise().value() : y;
      }, u.prototype.tryDispose = function (e) {
        var t = this.resource(),
          r = this._context;
        void 0 !== r && r._pushContext();
        var n = t !== y ? this.doDispose(t, e) : null;
        return void 0 !== r && r._popContext(), this._promise._unsetDisposable(), this._data = null, n;
      }, u.isDisposer = function (e) {
        return null != e && "function" == typeof e.resource && "function" == typeof e.tryDispose;
      }, g(h, u), h.prototype.doDispose = function (e, t) {
        return this.data().call(e, e, t);
      }, d.prototype._resultCancelled = function () {
        for (var t = this.length, r = 0; r < t; ++r) {
          var n = this[r];
          n instanceof e && n.cancel();
        }
      }, e.using = function () {
        var r = arguments.length;
        if (r < 2) return t("you must pass at least 2 arguments to Promise.using");
        var i = arguments[r - 1];
        if ("function" != typeof i) return t("expecting a function but got " + p.classString(i));
        var a,
          s = !0;
        2 === r && Array.isArray(arguments[0]) ? (a = arguments[0], r = a.length, s = !1) : (a = arguments, r--);
        for (var l = new d(r), h = 0; h < r; ++h) {
          var m = a[h];
          if (u.isDisposer(m)) {
            var g = m;
            m = m.promise(), m._setDisposable(g);
          } else {
            var y = n(m);
            y instanceof e && (m = y._then(f, null, null, {
              resources: l,
              index: h
            }, void 0));
          }
          l[h] = m;
        }
        for (var w = new Array(l.length), h = 0; h < w.length; ++h) w[h] = e.resolve(l[h]).reflect();
        var x = e.all(w).then(function (e) {
            for (var t = 0; t < e.length; ++t) {
              var r = e[t];
              if (r.isRejected()) return v.e = r.error(), v;
              if (!r.isFulfilled()) return void x.cancel();
              e[t] = r.value();
            }
            _._pushContext(), i = b(i);
            var n = s ? i.apply(void 0, e) : i(e),
              a = _._popContext();
            return o.checkForgottenReturns(n, a, "Promise.using", _), n;
          }),
          _ = x.lastly(function () {
            var t = new e.PromiseInspection(x);
            return c(l, t);
          });
        return l.promise = _, _._setOnCancel(l), _;
      }, e.prototype._setDisposable = function (e) {
        this._bitField = 131072 | this._bitField, this._disposer = e;
      }, e.prototype._isDisposable = function () {
        return (131072 & this._bitField) > 0;
      }, e.prototype._getDisposer = function () {
        return this._disposer;
      }, e.prototype._unsetDisposable = function () {
        this._bitField = -131073 & this._bitField, this._disposer = void 0;
      }, e.prototype.disposer = function (e) {
        if ("function" == typeof e) return new h(e, this, i());
        throw new m();
      };
    };
  }, function (e, t, r) {
    var n, i, a;
    !function (r, o) {
      i = [], n = o, void 0 !== (a = "function" == typeof n ? n.apply(t, i) : n) && (e.exports = a);
    }(0, function () {
      "use strict";

      function e(e) {
        var t = _typeof(e);
        return "function" === t || "object" === t && !!e;
      }
      function t(e) {
        return "string" == typeof e;
      }
      function r(e) {
        return !isNaN(Number(e));
      }
      function n(e) {
        return 0 == e || 1 == e;
      }
      function i(e) {
        return null == e;
      }
      function a(e) {
        return null != e;
      }
      function o(e, t) {
        return a(e) ? e : t;
      }
      function s(e, t) {
        for (var r = 0, n = e.length; r < n && !1 !== t(e[r], r); r += 1);
      }
      function l(e) {
        return e.replace(/"/g, '\\"');
      }
      function c(e) {
        return "attrs[" + e + "]";
      }
      function u(e, t) {
        return r(e) ? "Number(" + c(t) + ")" : n(e) ? "Boolean(" + c(t) + " == true)" : "String(" + c(t) + ")";
      }
      function h(e, r, n, i) {
        var a = [];
        return 3 == arguments.length ? (r ? g(r) ? s(n, function (n, i) {
          t(r[i]) ? r[i] = r[i].toLowerCase() : e[r[i]] = r[i], a.push("deserialize[cast[" + i + "]](" + c(i) + ")");
        }) : s(n, function (e, t) {
          a.push(u(e, t));
        }) : s(n, function (e, t) {
          a.push(c(t));
        }), a = "return [" + a.join(",") + "]") : (r ? g(r) ? s(n, function (n, o) {
          t(r[o]) ? r[o] = r[o].toLowerCase() : e[r[o]] = r[o], a.push('"' + l(i[o]) + '": deserialize[cast[' + o + "]](" + c(o) + ")");
        }) : s(n, function (e, t) {
          a.push('"' + l(i[t]) + '": ' + u(e, t));
        }) : s(n, function (e, t) {
          a.push('"' + l(i[t]) + '": ' + c(t));
        }), a = "return {" + a.join(",") + "}"), new Function("attrs", "deserialize", "cast", a);
      }
      function f(e, t) {
        var r,
          n = 0;
        return s(t, function (t) {
          var i,
            a = t;
          -1 != d.indexOf(t) && (a = "\\" + a), (i = e.match(new RegExp(a, "g"))) && i.length > n && (n = i.length, r = t);
        }), r || t[0];
      }
      var d = ["|", "^"],
        p = [",", ";", "\t", "|", "^"],
        m = ["\r\n", "\r", "\n"],
        g = Array.isArray || function (e) {
          return "[object Array]" === toString.call(e);
        },
        v = function () {
          function r(e, r) {
            if (r || (r = {}), g(e)) this.mode = "encode";else {
              if (!t(e)) throw new Error("Incompatible format!");
              this.mode = "parse";
            }
            this.data = e, this.options = {
              header: o(r.header, !1),
              cast: o(r.cast, !0)
            };
            var n = r.lineDelimiter || r.line,
              i = r.cellDelimiter || r.delimiter;
            this.isParser() ? (this.options.lineDelimiter = n || f(this.data, m), this.options.cellDelimiter = i || f(this.data, p), this.data = a(this.data, this.options.lineDelimiter)) : this.isEncoder() && (this.options.lineDelimiter = n || "\r\n", this.options.cellDelimiter = i || ",");
          }
          function n(e, t, r, n, i) {
            e(new t(r, n, i));
          }
          function a(e, t) {
            return e.slice(-t.length) != t && (e += t), e;
          }
          function l(r) {
            return g(r) ? "array" : e(r) ? "object" : t(r) ? "string" : i(r) ? "null" : "primitive";
          }
          return r.prototype.set = function (e, t) {
            return this.options[e] = t;
          }, r.prototype.isParser = function () {
            return "parse" == this.mode;
          }, r.prototype.isEncoder = function () {
            return "encode" == this.mode;
          }, r.prototype.parse = function (e) {
            function t() {
              s = {
                escaped: !1,
                quote: !1,
                cell: !0
              };
            }
            function r() {
              p.cell = "";
            }
            function i(e) {
              p.line.push(s.escaped ? e.slice(1, -1).replace(/""/g, '"') : e), r(), t();
            }
            function a(e) {
              i(e.slice(0, 1 - f.lineDelimiter.length));
            }
            function o() {
              d ? g(d) ? (l = h(m, f.cast, p.line, d), (o = function o() {
                n(e, l, p.line, m, f.cast);
              })()) : d = p.line : (l || (l = h(m, f.cast, p.line)), (o = function o() {
                n(e, l, p.line, m, f.cast);
              })());
            }
            if ("parse" == this.mode) {
              if (0 === this.data.trim().length) return [];
              var s,
                l,
                c,
                u = this.data,
                f = this.options,
                d = f.header,
                p = {
                  cell: "",
                  line: []
                },
                m = this.deserialize;
              e || (c = [], e = function e(_e3) {
                c.push(_e3);
              }), 1 == f.lineDelimiter.length && (a = i);
              var v,
                b,
                y,
                w = u.length,
                x = f.cellDelimiter.charCodeAt(0),
                _ = f.lineDelimiter.charCodeAt(f.lineDelimiter.length - 1);
              for (t(), v = 0, b = 0; v < w; v++) y = u.charCodeAt(v), s.cell && (s.cell = !1, 34 == y) ? s.escaped = !0 : s.escaped && 34 == y ? s.quote = !s.quote : (s.escaped && s.quote || !s.escaped) && (y == x ? (i(p.cell + u.slice(b, v)), b = v + 1) : y == _ && (a(p.cell + u.slice(b, v)), b = v + 1, (p.line.length > 1 || "" !== p.line[0]) && o(), function () {
                p.line = [];
              }()));
              return c || this;
            }
          }, r.prototype.deserialize = {
            string: function string(e) {
              return String(e);
            },
            number: function number(e) {
              return Number(e);
            },
            boolean: function boolean(e) {
              return Boolean(e);
            }
          }, r.prototype.serialize = {
            object: function object(e) {
              var t = this,
                r = Object.keys(e),
                n = Array(r.length);
              return s(r, function (r, i) {
                n[i] = t[l(e[r])](e[r]);
              }), n;
            },
            array: function array(e) {
              var t = this,
                r = Array(e.length);
              return s(e, function (e, n) {
                r[n] = t[l(e)](e);
              }), r;
            },
            string: function string(e) {
              return '"' + String(e).replace(/"/g, '""') + '"';
            },
            null: function _null(e) {
              return "";
            },
            primitive: function primitive(e) {
              return e;
            }
          }, r.prototype.encode = function (e) {
            function r(e) {
              return e.join(o.cellDelimiter);
            }
            if ("encode" == this.mode) {
              if (0 == this.data.length) return "";
              var n,
                i,
                a = this.data,
                o = this.options,
                c = o.header,
                u = a[0],
                h = this.serialize,
                f = 0;
              e || (i = Array(a.length), e = function e(_e4, t) {
                i[t + f] = _e4;
              }), c && (g(c) || (n = Object.keys(u), c = n), e(r(h.array(c)), 0), f = 1);
              var d,
                p = l(u);
              return "array" == p ? (g(o.cast) ? (d = Array(o.cast.length), s(o.cast, function (e, r) {
                t(e) ? d[r] = e.toLowerCase() : (d[r] = e, h[e] = e);
              })) : (d = Array(u.length), s(u, function (e, t) {
                d[t] = l(e);
              })), s(a, function (t, n) {
                var i = Array(d.length);
                s(t, function (e, t) {
                  i[t] = h[d[t]](e);
                }), e(r(i), n);
              })) : "object" == p && (n = Object.keys(u), g(o.cast) ? (d = Array(o.cast.length), s(o.cast, function (e, r) {
                t(e) ? d[r] = e.toLowerCase() : (d[r] = e, h[e] = e);
              })) : (d = Array(n.length), s(n, function (e, t) {
                d[t] = l(u[e]);
              })), s(a, function (t, i) {
                var a = Array(n.length);
                s(n, function (e, r) {
                  a[r] = h[d[r]](t[e]);
                }), e(r(a), i);
              })), i ? i.join(o.lineDelimiter) : this;
            }
          }, r.prototype.forEach = function (e) {
            return this[this.mode](e);
          }, r;
        }();
      return v.parse = function (e, t) {
        return new v(e, t).parse();
      }, v.encode = function (e, t) {
        return new v(e, t).encode();
      }, v.forEach = function (e, t, r) {
        return 2 == arguments.length && (r = t), new v(e, t).forEach(r);
      }, v;
    });
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, '.pg-viewer-wrapper{overflow-y:scroll}.pg-viewer-wrapper #docx{width:100%;height:100%}.pg-viewer-wrapper .document-container{padding:30px;width:700px;background:#fff;margin:auto}.pg-viewer-wrapper blockquote,.pg-viewer-wrapper body,.pg-viewer-wrapper bodyaddress,.pg-viewer-wrapper center,.pg-viewer-wrapper dd,.pg-viewer-wrapper dir,.pg-viewer-wrapper div,.pg-viewer-wrapper dl,.pg-viewer-wrapper dt,.pg-viewer-wrapper fieldset,.pg-viewer-wrapper form,.pg-viewer-wrapper frame,.pg-viewer-wrapper frameset,.pg-viewer-wrapper h1,.pg-viewer-wrapper h2,.pg-viewer-wrapper h3,.pg-viewer-wrapper h4,.pg-viewer-wrapper h5,.pg-viewer-wrapper h6,.pg-viewer-wrapper hr,.pg-viewer-wrapper html,.pg-viewer-wrapper menu,.pg-viewer-wrapper noframes,.pg-viewer-wrapper ol,.pg-viewer-wrapper p,.pg-viewer-wrapper pre,.pg-viewer-wrapper ul{display:block;unicode-bidi:embed}.pg-viewer-wrapper li{display:list-item;list-style-type:disc}.pg-viewer-wrapper head{display:none}.pg-viewer-wrapper table{display:table}.pg-viewer-wrapper img{width:100%}.pg-viewer-wrapper tr{display:table-row}.pg-viewer-wrapper thead{display:table-header-group}.pg-viewer-wrapper tbody{display:table-row-group}.pg-viewer-wrapper tfoot{display:table-footer-group}.pg-viewer-wrapper col{display:table-column}.pg-viewer-wrapper colgroup{display:table-column-group}.pg-viewer-wrapper th{display:table-cell}.pg-viewer-wrapper td{display:table-cell;border-bottom:1px solid #ccc;border-right:1px solid #ccc;padding:.2em .5em}.pg-viewer-wrapper caption{display:table-caption}.pg-viewer-wrapper th{font-weight:bolder;text-align:center}.pg-viewer-wrapper caption{text-align:center}.pg-viewer-wrapper body{margin:8px}.pg-viewer-wrapper h1{font-size:2em;margin:.67em 0}.pg-viewer-wrapper h2{font-size:1.5em;margin:.75em 0}.pg-viewer-wrapper h3{font-size:1.17em;margin:.83em 0}.pg-viewer-wrapper blockquote,.pg-viewer-wrapper dir,.pg-viewer-wrapper dl,.pg-viewer-wrapper fieldset,.pg-viewer-wrapper form,.pg-viewer-wrapper h4,.pg-viewer-wrapper menu,.pg-viewer-wrapper ol,.pg-viewer-wrapper p,.pg-viewer-wrapper ul{margin:1.12em 0}.pg-viewer-wrapper h5{font-size:.83em;margin:1.5em 0}.pg-viewer-wrapper h6{font-size:.75em;margin:1.67em 0}.pg-viewer-wrapper b,.pg-viewer-wrapper h1,.pg-viewer-wrapper h2,.pg-viewer-wrapper h3,.pg-viewer-wrapper h4,.pg-viewer-wrapper h5,.pg-viewer-wrapper h6,.pg-viewer-wrapper strong{font-weight:bolder}.pg-viewer-wrapper blockquote{margin-left:40px;margin-right:40px}.pg-viewer-wrapper address,.pg-viewer-wrapper cite,.pg-viewer-wrapper em,.pg-viewer-wrapper i,.pg-viewer-wrapper var{font-style:italic}.pg-viewer-wrapper code,.pg-viewer-wrapper kbd,.pg-viewer-wrapper pre,.pg-viewer-wrapper samp,.pg-viewer-wrapper tt{font-family:monospace}.pg-viewer-wrapper pre{white-space:pre}.pg-viewer-wrapper button,.pg-viewer-wrapper input,.pg-viewer-wrapper select,.pg-viewer-wrapper textarea{display:inline-block}.pg-viewer-wrapper big{font-size:1.17em}.pg-viewer-wrapper small,.pg-viewer-wrapper sub,.pg-viewer-wrapper sup{font-size:.83em}.pg-viewer-wrapper sub{vertical-align:sub}.pg-viewer-wrapper sup{vertical-align:super}.pg-viewer-wrapper table{border-spacing:2px}.pg-viewer-wrapper tbody,.pg-viewer-wrapper tfoot,.pg-viewer-wrapper thead{vertical-align:middle}.pg-viewer-wrapper td,.pg-viewer-wrapper th,.pg-viewer-wrapper tr{vertical-align:inherit}.pg-viewer-wrapper del,.pg-viewer-wrapper s,.pg-viewer-wrapper strike{text-decoration:line-through}.pg-viewer-wrapper hr{border:1px inset}.pg-viewer-wrapper dd,.pg-viewer-wrapper dir,.pg-viewer-wrapper menu,.pg-viewer-wrapper ol,.pg-viewer-wrapper ul{margin-left:40px}.pg-viewer-wrapper ol{list-style-type:decimal}.pg-viewer-wrapper ol ol,.pg-viewer-wrapper ol ul,.pg-viewer-wrapper ul ol,.pg-viewer-wrapper ul ul{margin-top:0;margin-bottom:0}.pg-viewer-wrapper ins,.pg-viewer-wrapper u{text-decoration:underline}.pg-viewer-wrapper br:before{content:"\\A";white-space:pre-line}.pg-viewer-wrapper center{text-align:center}.pg-viewer-wrapper :link,.pg-viewer-wrapper :visited{text-decoration:underline}.pg-viewer-wrapper :focus{outline:thin dotted invert}.pg-viewer-wrapper BDO[DIR=ltr]{direction:ltr;unicode-bidi:bidi-override}.pg-viewer-wrapper BDO[DIR=rtl]{direction:rtl;unicode-bidi:bidi-override}.pg-viewer-wrapper [DIR=ltr]{direction:ltr;unicode-bidi:embed}.pg-viewer-wrapper [DIR=rtl]{direction:rtl;unicode-bidi:embed}@media print{.pg-viewer-wrapper h1{page-break-before:always}.pg-viewer-wrapper h1,.pg-viewer-wrapper h2,.pg-viewer-wrapper h3,.pg-viewer-wrapper h4,.pg-viewer-wrapper h5,.pg-viewer-wrapper h6{page-break-after:avoid}.pg-viewer-wrapper dl,.pg-viewer-wrapper ol,.pg-viewer-wrapper ul{page-break-before:avoid}}', ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".pg-viewer-wrapper .error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.pg-viewer-wrapper .error-message .alert{color:#ed1818}", ""]);
  }, function (e, t, r) {
    var n = r(250);
    t = e.exports = r(19)(!1), t.push([e.i, ".pg-viewer-wrapper .loading-container{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}.pg-viewer-wrapper .loading-container .loading{background-image:url(" + n(r(370)) + ");background-repeat:no-repeat;display:inline-block;height:96px;width:96px;-webkit-animation:rotating 2s linear infinite;animation:rotating 2s linear infinite}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".pg-viewer-wrapper{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.pg-viewer-wrapper .pg-viewer{height:100%;position:relative;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}.pg-viewer-wrapper .pg-viewer .pg-driver-view{margin:auto;width:100%;height:100%}.pg-viewer-wrapper .pg-viewer .pg-driver-view .loading{position:relative}.pg-viewer-wrapper .pg-viewer .pg-driver-view .react-grid-Container,.pg-viewer-wrapper .pg-viewer .pg-driver-view canvas{width:100%}.pg-viewer-wrapper .pg-viewer-link{background:#9370db;height:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.react-grid-Container{margin:auto}#xbim-viewer{height:100%;width:100%}#app{background:pink}", ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".pg-viewer-wrapper .photo-viewer-container{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}", ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".photo360{height:100%;width:100%}", ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".unsupported-message{padding:46px;background:#fff;margin:auto;text-align:center}", ""]);
  }, function (e, t, r) {
    t = e.exports = r(19)(!1), t.push([e.i, ".pg-viewer-wrapper .video-container{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:100%}", ""]);
  }, function (e, t) {
    e.exports = function (e) {
      return "string" != typeof e ? e : (/^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), /["'() \t\n]/.test(e) ? '"' + e.replace(/"/g, '\\"').replace(/\n/g, "\\n") + '"' : e);
    };
  }, function (e, t) {
    t.read = function (e, t, r, n, i) {
      var a,
        o,
        s = 8 * i - n - 1,
        l = (1 << s) - 1,
        c = l >> 1,
        u = -7,
        h = r ? i - 1 : 0,
        f = r ? -1 : 1,
        d = e[t + h];
      for (h += f, a = d & (1 << -u) - 1, d >>= -u, u += s; u > 0; a = 256 * a + e[t + h], h += f, u -= 8);
      for (o = a & (1 << -u) - 1, a >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
      if (0 === a) a = 1 - c;else {
        if (a === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
        o += Math.pow(2, n), a -= c;
      }
      return (d ? -1 : 1) * o * Math.pow(2, a - n);
    }, t.write = function (e, t, r, n, i, a) {
      var o,
        s,
        l,
        c = 8 * a - i - 1,
        u = (1 << c) - 1,
        h = u >> 1,
        f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        d = n ? 0 : a - 1,
        p = n ? 1 : -1,
        m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h), t * l >= 2 && (o++, l /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (t * l - 1) * Math.pow(2, i), o += h) : (s = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & s, d += p, s /= 256, i -= 8);
      for (o = o << i | s, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
      e[r + d - p] |= 128 * m;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
      i = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117];
    e.exports = function (e, t) {
      if (void 0 === e || !e.length) return 0;
      var r = "string" !== n.getTypeOf(e);
      void 0 === t && (t = 0);
      var a = 0,
        o = 0,
        s = 0;
      t ^= -1;
      for (var l = 0, c = e.length; l < c; l++) s = r ? e[l] : e.charCodeAt(l), o = 255 & (t ^ s), a = i[o], t = t >>> 8 ^ a;
      return -1 ^ t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(12);
    t.string2binary = function (e) {
      return n.string2binary(e);
    }, t.string2Uint8Array = function (e) {
      return n.transformTo("uint8array", e);
    }, t.uint8Array2String = function (e) {
      return n.transformTo("string", e);
    }, t.string2Blob = function (e) {
      var t = n.transformTo("arraybuffer", e);
      return n.arrayBuffer2Blob(t);
    }, t.arrayBuffer2Blob = function (e) {
      return n.arrayBuffer2Blob(e);
    }, t.transformTo = function (e, t) {
      return n.transformTo(e, t);
    }, t.getTypeOf = function (e) {
      return n.getTypeOf(e);
    }, t.checkSupport = function (e) {
      return n.checkSupport(e);
    }, t.MAX_VALUE_16BITS = n.MAX_VALUE_16BITS, t.MAX_VALUE_32BITS = n.MAX_VALUE_32BITS, t.pretty = function (e) {
      return n.pretty(e);
    }, t.findCompression = function (e) {
      return n.findCompression(e);
    }, t.isRegExp = function (e) {
      return n.isRegExp(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
      i = r(335);
    t.uncompressInputType = n ? "uint8array" : "array", t.compressInputType = n ? "uint8array" : "array", t.magic = "\b\0", t.compress = function (e, t) {
      return i.deflateRaw(e, {
        level: t.level || -1
      });
    }, t.uncompress = function (e) {
      return i.inflateRaw(e);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (!(this instanceof n)) return new n(e, t);
      this.files = {}, this.comment = null, this.root = "", e && this.load(e, t), this.clone = function () {
        var e = new n();
        for (var t in this) "function" != typeof this[t] && (e[t] = this[t]);
        return e;
      };
    }
    var i = r(73);
    n.prototype = r(76), n.prototype.load = r(256), n.support = r(45), n.defaults = r(106), n.utils = r(253), n.base64 = {
      encode: function encode(e) {
        return i.encode(e);
      },
      decode: function decode(e) {
        return i.decode(e);
      }
    }, n.compressions = r(74), e.exports = n;
  }, function (e, t, r) {
    "use strict";

    var n = r(73),
      i = r(261);
    e.exports = function (e, t) {
      var r, a, o, s;
      for (t = t || {}, t.base64 && (e = n.decode(e)), a = new i(e, t), r = a.files, o = 0; o < r.length; o++) s = r[o], this.file(s.fileName, s.decompressed, {
        binary: !0,
        optimizedBinaryString: !0,
        date: s.date,
        dir: s.dir,
        comment: s.fileComment.length ? s.fileComment : null,
        unixPermissions: s.unixPermissions,
        dosPermissions: s.dosPermissions,
        createFolders: t.createFolders
      });
      return a.zipComment.length && (this.comment = a.zipComment), this;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      this.data = e, this.length = this.data.length, this.index = 0;
    }
    var i = r(109);
    n.prototype = new i(), n.prototype.readData = function (e) {
      this.checkOffset(e);
      var t = this.data.slice(this.index, this.index + e);
      return this.index += e, t;
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
      i = function i() {
        this.data = [];
      };
    i.prototype = {
      append: function append(e) {
        e = n.transformTo("string", e), this.data.push(e);
      },
      finalize: function finalize() {
        return this.data.join("");
      }
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    var n = r(12),
      i = function i(e) {
        this.data = new Uint8Array(e), this.index = 0;
      };
    i.prototype = {
      append: function append(e) {
        0 !== e.length && (e = n.transformTo("uint8array", e), this.data.set(e, this.index), this.index += e.length);
      },
      finalize: function finalize() {
        return this.data;
      }
    }, e.exports = i;
  }, function (e, t, r) {
    "use strict";

    for (var n = r(12), i = r(45), a = r(75), o = new Array(256), s = 0; s < 256; s++) o[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
    o[254] = o[254] = 1;
    var l = function l(e) {
        var t,
          r,
          n,
          a,
          o,
          s = e.length,
          l = 0;
        for (a = 0; a < s; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
        for (t = i.uint8array ? new Uint8Array(l) : new Array(l), o = 0, a = 0; o < l; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), r < 128 ? t[o++] = r : r < 2048 ? (t[o++] = 192 | r >>> 6, t[o++] = 128 | 63 & r) : r < 65536 ? (t[o++] = 224 | r >>> 12, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r) : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r);
        return t;
      },
      c = function c(e, t) {
        var r;
        for (t = t || e.length, t > e.length && (t = e.length), r = t - 1; r >= 0 && 128 == (192 & e[r]);) r--;
        return r < 0 ? t : 0 === r ? t : r + o[e[r]] > t ? r : t;
      },
      u = function u(e) {
        var t,
          r,
          i,
          a,
          s = e.length,
          l = new Array(2 * s);
        for (r = 0, t = 0; t < s;) if ((i = e[t++]) < 128) l[r++] = i;else if ((a = o[i]) > 4) l[r++] = 65533, t += a - 1;else {
          for (i &= 2 === a ? 31 : 3 === a ? 15 : 7; a > 1 && t < s;) i = i << 6 | 63 & e[t++], a--;
          a > 1 ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
        }
        return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
      };
    t.utf8encode = function (e) {
      return i.nodebuffer ? a(e, "utf-8") : l(e);
    }, t.utf8decode = function (e) {
      if (i.nodebuffer) return n.transformTo("nodebuffer", e).toString("utf-8");
      e = n.transformTo(i.uint8array ? "uint8array" : "array", e);
      for (var t = [], r = 0, a = e.length; r < a;) {
        var o = c(e, Math.min(r + 65536, a));
        i.uint8array ? t.push(u(e.subarray(r, o))) : t.push(u(e.slice(r, o))), r = o;
      }
      return t.join("");
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      this.files = [], this.loadOptions = t, e && this.load(e);
    }
    var i = r(108),
      a = r(257),
      o = r(109),
      s = r(12),
      l = r(107),
      c = r(262),
      u = r(45),
      h = r(76);
    n.prototype = {
      checkSignature: function checkSignature(e) {
        var t = this.reader.readString(4);
        if (t !== e) throw new Error("Corrupted zip or bug : unexpected signature (" + s.pretty(t) + ", expected " + s.pretty(e) + ")");
      },
      readBlockEndOfCentral: function readBlockEndOfCentral() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2), this.zipComment = this.reader.readString(this.zipCommentLength), this.zipComment = h.utf8decode(this.zipComment);
      },
      readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.versionMadeBy = this.reader.readString(2), this.versionNeeded = this.reader.readInt(2), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;) e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readString(t), this.zip64ExtensibleData[e] = {
          id: e,
          length: t,
          value: r
        };
      },
      readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
      },
      readLocalFiles: function readLocalFiles() {
        var e, t;
        for (e = 0; e < this.files.length; e++) t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(l.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
      },
      readCentralDir: function readCentralDir() {
        var e;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readString(4) === l.CENTRAL_FILE_HEADER;) e = new c({
          zip64: this.zip64
        }, this.loadOptions), e.readCentralPart(this.reader), this.files.push(e);
      },
      readEndOfCentral: function readEndOfCentral() {
        var e = this.reader.lastIndexOfSignature(l.CENTRAL_DIRECTORY_END);
        if (-1 === e) {
          var t = !0;
          try {
            this.reader.setIndex(0), this.checkSignature(l.LOCAL_FILE_HEADER), t = !1;
          } catch (e) {}
          throw t ? new Error("Can't find end of central directory : is this a zip file ? If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip : can't find end of central directory");
        }
        if (this.reader.setIndex(e), this.checkSignature(l.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === s.MAX_VALUE_16BITS || this.diskWithCentralDirStart === s.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS || this.centralDirRecords === s.MAX_VALUE_16BITS || this.centralDirSize === s.MAX_VALUE_32BITS || this.centralDirOffset === s.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, -1 === (e = this.reader.lastIndexOfSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR))) throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
          this.reader.setIndex(e), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
      },
      prepareReader: function prepareReader(e) {
        var t = s.getTypeOf(e);
        "string" !== t || u.uint8array ? this.reader = "nodebuffer" === t ? new a(e) : new o(s.transformTo("uint8array", e)) : this.reader = new i(e, this.loadOptions.optimizedBinaryString);
      },
      load: function load(e) {
        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      }
    }, e.exports = n;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      this.options = e, this.loadOptions = t;
    }
    var i = r(108),
      a = r(12),
      o = r(104),
      s = r(76);
    n.prototype = {
      isEncrypted: function isEncrypted() {
        return 1 == (1 & this.bitFlag);
      },
      useUTF8: function useUTF8() {
        return 2048 == (2048 & this.bitFlag);
      },
      prepareCompressedContent: function prepareCompressedContent(e, t, r) {
        return function () {
          var n = e.index;
          e.setIndex(t);
          var i = e.readData(r);
          return e.setIndex(n), i;
        };
      },
      prepareContent: function prepareContent(e, t, r, n, i) {
        return function () {
          var e = a.transformTo(n.uncompressInputType, this.getCompressedContent()),
            t = n.uncompress(e);
          if (t.length !== i) throw new Error("Bug : uncompressed data size mismatch");
          return t;
        };
      },
      readLocalPart: function readLocalPart(e) {
        var t, r;
        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readString(this.fileNameLength), e.skip(r), -1 == this.compressedSize || -1 == this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize == -1 || uncompressedSize == -1)");
        if (null === (t = a.findCompression(this.compressionMethod))) throw new Error("Corrupted zip : compression " + a.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
        if (this.decompressed = new o(), this.decompressed.compressedSize = this.compressedSize, this.decompressed.uncompressedSize = this.uncompressedSize, this.decompressed.crc32 = this.crc32, this.decompressed.compressionMethod = this.compressionMethod, this.decompressed.getCompressedContent = this.prepareCompressedContent(e, e.index, this.compressedSize, t), this.decompressed.getContent = this.prepareContent(e, e.index, this.compressedSize, t, this.uncompressedSize), this.loadOptions.checkCRC32 && (this.decompressed = a.transformTo("string", this.decompressed.getContent()), s.crc32(this.decompressed) !== this.crc32)) throw new Error("Corrupted zip : CRC32 mismatch");
      },
      readCentralPart: function readCentralPart(e) {
        if (this.versionMadeBy = e.readInt(2), this.versionNeeded = e.readInt(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4), this.fileNameLength = e.readInt(2), this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        this.fileName = e.readString(this.fileNameLength), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readString(this.fileCommentLength);
      },
      processAttributes: function processAttributes() {
        this.unixPermissions = null, this.dosPermissions = null;
        var e = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), 0 === e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 === e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileName.slice(-1) || (this.dir = !0);
      },
      parseZIP64ExtraField: function parseZIP64ExtraField(e) {
        if (this.extraFields[1]) {
          var t = new i(this.extraFields[1].value);
          this.uncompressedSize === a.MAX_VALUE_32BITS && (this.uncompressedSize = t.readInt(8)), this.compressedSize === a.MAX_VALUE_32BITS && (this.compressedSize = t.readInt(8)), this.localHeaderOffset === a.MAX_VALUE_32BITS && (this.localHeaderOffset = t.readInt(8)), this.diskNumberStart === a.MAX_VALUE_32BITS && (this.diskNumberStart = t.readInt(4));
        }
      },
      readExtraFields: function readExtraFields(e) {
        var t,
          r,
          n,
          i = e.index;
        for (this.extraFields = this.extraFields || {}; e.index < i + this.extraFieldsLength;) t = e.readInt(2), r = e.readInt(2), n = e.readString(r), this.extraFields[t] = {
          id: t,
          length: r,
          value: n
        };
      },
      handleUTF8: function handleUTF8() {
        if (this.useUTF8()) this.fileName = s.utf8decode(this.fileName), this.fileComment = s.utf8decode(this.fileComment);else {
          var e = this.findExtraFieldUnicodePath();
          null !== e && (this.fileName = e);
          var t = this.findExtraFieldUnicodeComment();
          null !== t && (this.fileComment = t);
        }
      },
      findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
        var e = this.extraFields[28789];
        if (e) {
          var t = new i(e.value);
          return 1 !== t.readInt(1) ? null : s.crc32(this.fileName) !== t.readInt(4) ? null : s.utf8decode(t.readString(e.length - 5));
        }
        return null;
      },
      findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
        var e = this.extraFields[25461];
        if (e) {
          var t = new i(e.value);
          return 1 !== t.readInt(1) ? null : s.crc32(this.fileComment) !== t.readInt(4) ? null : s.utf8decode(t.readString(e.length - 5));
        }
        return null;
      }
    }, e.exports = n;
  }, function (e, t) {
    function r(e) {
      var t = e ? e.length : 0;
      return t ? e[t - 1] : void 0;
    }
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r) {
      var n = s(e) ? i : o;
      return r && l(e, t, r) && (t = void 0), "function" == typeof t && void 0 === r || (t = a(t, r, 3)), n(e, t);
    }
    var i = r(266),
      a = r(269),
      o = r(273),
      s = r(21),
      l = r(78);
    e.exports = n;
  }, function (e, t) {
    function r(e, t) {
      if ("function" != typeof e) throw new TypeError(n);
      return t = i(void 0 === t ? e.length - 1 : +t || 0, 0), function () {
        for (var r = arguments, n = -1, a = i(r.length - t, 0), o = Array(a); ++n < a;) o[n] = r[t + n];
        switch (t) {
          case 0:
            return e.call(this, o);
          case 1:
            return e.call(this, r[0], o);
          case 2:
            return e.call(this, r[0], r[1], o);
        }
        var s = Array(t + 1);
        for (n = -1; ++n < t;) s[n] = r[n];
        return s[t] = o, e.apply(this, s);
      };
    }
    var n = "Expected a function",
      i = Math.max;
    e.exports = r;
  }, function (e, t) {
    function r(e, t) {
      for (var r = -1, n = e.length; ++r < n;) if (!t(e[r], r, e)) return !1;
      return !0;
    }
    e.exports = r;
  }, function (e, t) {
    function r(e, t) {
      for (var r = -1, n = e.length; ++r < n;) if (t(e[r], r, e)) return !0;
      return !1;
    }
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r) {
      for (var n = -1, a = i(t), o = a.length; ++n < o;) {
        var s = a[n],
          l = e[s],
          c = r(l, t[s], s, e, t);
        (c === c ? c === l : l !== l) && (void 0 !== l || s in e) || (e[s] = c);
      }
      return e;
    }
    var i = r(38);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r) {
      var n = _typeof(e);
      return "function" == n ? void 0 === t ? e : o(e, t, r) : null == e ? s : "object" == n ? i(e) : void 0 === t ? l(e) : a(e, t);
    }
    var i = r(278),
      a = r(279),
      o = r(114),
      s = r(120),
      l = r(298);
    e.exports = n;
  }, function (e, t) {
    function r(e, t, r) {
      r || (r = {});
      for (var n = -1, i = t.length; ++n < i;) {
        var a = t[n];
        r[a] = e[a];
      }
      return r;
    }
    e.exports = r;
  }, function (e, t, r) {
    var n = r(3),
      i = function () {
        function e() {}
        return function (t) {
          if (n(t)) {
            e.prototype = t;
            var r = new e();
            e.prototype = void 0;
          }
          return r || {};
        };
      }();
    e.exports = i;
  }, function (e, t, r) {
    var n = r(275),
      i = r(284),
      a = i(n);
    e.exports = a;
  }, function (e, t, r) {
    function n(e, t) {
      var r = !0;
      return i(e, function (e, n, i) {
        return r = !!t(e, n, i);
      }), r;
    }
    var i = r(272);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(285),
      i = n();
    e.exports = i;
  }, function (e, t, r) {
    function n(e, t) {
      return i(e, t, a);
    }
    var i = r(274),
      a = r(38);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r, n, f, m, g) {
      var v = s(e),
        b = s(t),
        y = u,
        w = u;
      v || (y = p.call(e), y == c ? y = h : y != h && (v = l(e))), b || (w = p.call(t), w == c ? w = h : w != h && (b = l(t)));
      var x = y == h,
        _ = w == h,
        S = y == w;
      if (S && !v && !x) return a(e, t, y);
      if (!f) {
        var C = x && d.call(e, "__wrapped__"),
          E = _ && d.call(t, "__wrapped__");
        if (C || E) return r(C ? e.value() : e, E ? t.value() : t, n, f, m, g);
      }
      if (!S) return !1;
      m || (m = []), g || (g = []);
      for (var A = m.length; A--;) if (m[A] == e) return g[A] == t;
      m.push(e), g.push(t);
      var T = (v ? i : o)(e, t, r, n, f, m, g);
      return m.pop(), g.pop(), T;
    }
    var i = r(286),
      a = r(287),
      o = r(288),
      s = r(21),
      l = r(294),
      c = "[object Arguments]",
      u = "[object Array]",
      h = "[object Object]",
      f = Object.prototype,
      d = f.hasOwnProperty,
      p = f.toString;
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r) {
      var n = t.length,
        o = n,
        s = !r;
      if (null == e) return !o;
      for (e = a(e); n--;) {
        var l = t[n];
        if (s && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
      }
      for (; ++n < o;) {
        l = t[n];
        var c = l[0],
          u = e[c],
          h = l[1];
        if (s && l[2]) {
          if (void 0 === u && !(c in e)) return !1;
        } else {
          var f = r ? r(u, h, c) : void 0;
          if (!(void 0 === f ? i(h, u, r, !0) : f)) return !1;
        }
      }
      return !0;
    }
    var i = r(112),
      a = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      var t = a(e);
      if (1 == t.length && t[0][2]) {
        var r = t[0][0],
          n = t[0][1];
        return function (e) {
          return null != e && e[r] === n && (void 0 !== n || r in o(e));
        };
      }
      return function (e) {
        return i(e, t);
      };
    }
    var i = r(277),
      a = r(289),
      o = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      var r = s(e),
        n = l(e) && c(t),
        d = e + "";
      return e = f(e), function (s) {
        if (null == s) return !1;
        var l = d;
        if (s = h(s), (r || !n) && !(l in s)) {
          if (null == (s = 1 == e.length ? s : i(s, o(e, 0, -1)))) return !1;
          l = u(e), s = h(s);
        }
        return s[l] === t ? void 0 !== t || l in s : a(t, s[l], void 0, !0);
      };
    }
    var i = r(111),
      a = r(112),
      o = r(281),
      s = r(21),
      l = r(117),
      c = r(118),
      u = r(263),
      h = r(20),
      f = r(119);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      var t = e + "";
      return e = a(e), function (r) {
        return i(r, e, t);
      };
    }
    var i = r(111),
      a = r(119);
    e.exports = n;
  }, function (e, t) {
    function r(e, t, r) {
      var n = -1,
        i = e.length;
      t = null == t ? 0 : +t || 0, t < 0 && (t = -t > i ? 0 : i + t), r = void 0 === r || r > i ? i : +r || 0, r < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
      for (var a = Array(i); ++n < i;) a[n] = e[n + t];
      return a;
    }
    e.exports = r;
  }, function (e, t) {
    function r(e) {
      return null == e ? "" : e + "";
    }
    e.exports = r;
  }, function (e, t, r) {
    function n(e) {
      return o(function (t, r) {
        var n = -1,
          o = null == t ? 0 : r.length,
          s = o > 2 ? r[o - 2] : void 0,
          l = o > 2 ? r[2] : void 0,
          c = o > 1 ? r[o - 1] : void 0;
        for ("function" == typeof s ? (s = i(s, c, 5), o -= 2) : (s = "function" == typeof c ? c : void 0, o -= s ? 1 : 0), l && a(r[0], r[1], l) && (s = o < 3 ? void 0 : s, o = 1); ++n < o;) {
          var u = r[n];
          u && e(t, u, s);
        }
        return t;
      });
    }
    var i = r(114),
      a = r(78),
      o = r(265);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      return function (r, n) {
        var s = r ? i(r) : 0;
        if (!a(s)) return e(r, n);
        for (var l = t ? s : -1, c = o(r); (t ? l-- : ++l < s) && !1 !== n(c[l], l, c););
        return r;
      };
    }
    var i = r(115),
      a = r(37),
      o = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return function (t, r, n) {
        for (var a = i(t), o = n(t), s = o.length, l = e ? s : -1; e ? l-- : ++l < s;) {
          var c = o[l];
          if (!1 === r(a[c], c, a)) break;
        }
        return t;
      };
    }
    var i = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t, r, n, a, o, s) {
      var l = -1,
        c = e.length,
        u = t.length;
      if (c != u && !(a && u > c)) return !1;
      for (; ++l < c;) {
        var h = e[l],
          f = t[l],
          d = n ? n(a ? f : h, a ? h : f, l) : void 0;
        if (void 0 !== d) {
          if (d) continue;
          return !1;
        }
        if (a) {
          if (!i(t, function (e) {
            return h === e || r(h, e, n, a, o, s);
          })) return !1;
        } else if (h !== f && !r(h, f, n, a, o, s)) return !1;
      }
      return !0;
    }
    var i = r(267);
    e.exports = n;
  }, function (e, t) {
    function r(e, t, r) {
      switch (r) {
        case n:
        case i:
          return +e == +t;
        case a:
          return e.name == t.name && e.message == t.message;
        case o:
          return e != +e ? t != +t : e == +t;
        case s:
        case l:
          return e == t + "";
      }
      return !1;
    }
    var n = "[object Boolean]",
      i = "[object Date]",
      a = "[object Error]",
      o = "[object Number]",
      s = "[object RegExp]",
      l = "[object String]";
    e.exports = r;
  }, function (e, t, r) {
    function n(e, t, r, n, a, s, l) {
      var c = i(e),
        u = c.length;
      if (u != i(t).length && !a) return !1;
      for (var h = u; h--;) {
        var f = c[h];
        if (!(a ? f in t : o.call(t, f))) return !1;
      }
      for (var d = a; ++h < u;) {
        f = c[h];
        var p = e[f],
          m = t[f],
          g = n ? n(a ? m : p, a ? p : m, f) : void 0;
        if (!(void 0 === g ? r(p, m, n, a, s, l) : g)) return !1;
        d || (d = "constructor" == f);
      }
      if (!d) {
        var v = e.constructor,
          b = t.constructor;
        if (v != b && "constructor" in e && "constructor" in t && !("function" == typeof v && v instanceof v && "function" == typeof b && b instanceof b)) return !1;
      }
      return !0;
    }
    var i = r(38),
      a = Object.prototype,
      o = a.hasOwnProperty;
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      for (var t = a(e), r = t.length; r--;) t[r][2] = i(t[r][1]);
      return t;
    }
    var i = r(118),
      a = r(297);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      for (var t = l(e), r = t.length, n = r && e.length, c = !!n && s(n) && (a(e) || i(e)), h = -1, f = []; ++h < r;) {
        var d = t[h];
        (c && o(d, n) || u.call(e, d)) && f.push(d);
      }
      return f;
    }
    var i = r(79),
      a = r(21),
      o = r(77),
      s = r(37),
      l = r(296),
      c = Object.prototype,
      u = c.hasOwnProperty;
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return null == e || (o(e) && (a(e) || c(e) || i(e) || l(e) && s(e.splice)) ? !e.length : !u(e).length);
    }
    var i = r(79),
      a = r(21),
      o = r(52),
      s = r(53),
      l = r(29),
      c = r(293),
      u = r(38);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return null != e && (i(e) ? u.test(l.call(e)) : a(e) && o.test(e));
    }
    var i = r(53),
      a = r(29),
      o = /^\[object .+?Constructor\]$/,
      s = Object.prototype,
      l = Function.prototype.toString,
      c = s.hasOwnProperty,
      u = RegExp("^" + l.call(c).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return "string" == typeof e || i(e) && s.call(e) == a;
    }
    var i = r(29),
      a = "[object String]",
      o = Object.prototype,
      s = o.toString;
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return a(e) && i(e.length) && !!o[l.call(e)];
    }
    var i = r(37),
      a = r(29),
      o = {};
    o["[object Float32Array]"] = o["[object Float64Array]"] = o["[object Int8Array]"] = o["[object Int16Array]"] = o["[object Int32Array]"] = o["[object Uint8Array]"] = o["[object Uint8ClampedArray]"] = o["[object Uint16Array]"] = o["[object Uint32Array]"] = !0, o["[object Arguments]"] = o["[object Array]"] = o["[object ArrayBuffer]"] = o["[object Boolean]"] = o["[object Date]"] = o["[object Error]"] = o["[object Function]"] = o["[object Map]"] = o["[object Number]"] = o["[object Object]"] = o["[object RegExp]"] = o["[object Set]"] = o["[object String]"] = o["[object WeakMap]"] = !1;
    var s = Object.prototype,
      l = s.toString;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(268),
      i = r(110),
      a = r(283),
      o = a(function (e, t, r) {
        return r ? n(e, t, r) : i(e, t);
      });
    e.exports = o;
  }, function (e, t, r) {
    function n(e) {
      if (null == e) return [];
      l(e) || (e = Object(e));
      var t = e.length;
      t = t && s(t) && (a(e) || i(e)) && t || 0;
      for (var r = e.constructor, n = -1, c = "function" == typeof r && r.prototype === e, h = Array(t), f = t > 0; ++n < t;) h[n] = n + "";
      for (var d in e) f && o(d, t) || "constructor" == d && (c || !u.call(e, d)) || h.push(d);
      return h;
    }
    var i = r(79),
      a = r(21),
      o = r(77),
      s = r(37),
      l = r(3),
      c = Object.prototype,
      u = c.hasOwnProperty;
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      e = a(e);
      for (var t = -1, r = i(e), n = r.length, o = Array(n); ++t < n;) {
        var s = r[t];
        o[t] = [s, e[s]];
      }
      return o;
    }
    var i = r(38),
      a = r(20);
    e.exports = n;
  }, function (e, t, r) {
    function n(e) {
      return o(e) ? i(e) : a(e);
    }
    var i = r(113),
      a = r(280),
      o = r(117);
    e.exports = n;
  }, function (e, t) {
    var r = e.exports = function (e, t) {
      this._tokens = e, this._startIndex = t || 0;
    };
    r.prototype.head = function () {
      return this._tokens[this._startIndex];
    }, r.prototype.tail = function (e) {
      return new r(this._tokens, this._startIndex + 1);
    }, r.prototype.toArray = function () {
      return this._tokens.slice(this._startIndex);
    }, r.prototype.end = function () {
      return this._tokens[this._tokens.length - 1];
    }, r.prototype.to = function (e) {
      var t = this.head().source,
        r = e.head() || e.end();
      return t.to(r.source);
    };
  }, function (e, t, r) {
    function n(e) {
      function t(t) {
        return new n(e.slice(0, o().indexOf(t)));
      }
      function r(t) {
        return new n(e.slice(0, o().indexOf(t) + 1));
      }
      function o() {
        return e.map(function (e) {
          return e.name;
        });
      }
      function s(e) {
        for (var t, r;;) {
          if (t = l(e.remaining()), !t.isSuccess()) return t.isFailure() ? e : t;
          r = e.source().to(t.source()), e = a.success(t.value()(e.value(), r), t.remaining(), r);
        }
      }
      function l(t) {
        return i.firstOf("infix", e.map(function (e) {
          return e.rule;
        }))(t);
      }
      return {
        apply: s,
        untilExclusive: t,
        untilInclusive: r
      };
    }
    var i = r(125),
      a = r(80);
    t.parser = function (e, t, r) {
      function a(e) {
        return {
          name: e.name,
          rule: o(e.ruleBuilder.bind(null, f))
        };
      }
      function s() {
        return u(d);
      }
      function l(e) {
        return u(d.untilExclusive(e));
      }
      function c(e) {
        return u(d.untilInclusive(e));
      }
      function u(e) {
        return h.bind(null, e);
      }
      function h(e, t) {
        var r = p(t);
        return r.isSuccess() ? e.apply(r) : r;
      }
      var f = {
          rule: s,
          leftAssociative: l,
          rightAssociative: c
        },
        d = new n(r.map(a)),
        p = i.firstOf(e, t);
      return f;
    }, t.infix = function (e, r) {
      function n(n) {
        return t.infix(e, function (e) {
          var t = r(e);
          return function (e) {
            return t(e).map(function (e) {
              return function (t, r) {
                return n(t, e, r);
              };
            });
          };
        });
      }
      return {
        name: e,
        ruleBuilder: r,
        map: n
      };
    };
    var o = function o(e) {
      var t;
      return function (r) {
        return t || (t = e()), t(r);
      };
    };
  }, function (e, t) {
    var r = (t.fromArray = function (e) {
      var t = 0,
        n = function n() {
          return t < e.length;
        };
      return new r({
        hasNext: n,
        next: function next() {
          if (n()) return e[t++];
          throw new Error("No more elements");
        }
      });
    }, function (e) {
      this._iterator = e;
    });
    r.prototype.map = function (e) {
      var t = this._iterator;
      return new r({
        hasNext: function hasNext() {
          return t.hasNext();
        },
        next: function next() {
          return e(t.next());
        }
      });
    }, r.prototype.filter = function (e) {
      var t,
        n = this._iterator,
        i = !1,
        a = !1,
        o = function o() {
          if (!i) for (i = !0, a = !1; n.hasNext() && !a;) t = n.next(), a = e(t);
        };
      return new r({
        hasNext: function hasNext() {
          return o(), a;
        },
        next: function next() {
          o();
          var e = t;
          return i = !1, e;
        }
      });
    }, r.prototype.first = function () {
      var e = this._iterator;
      return this._iterator.hasNext() ? e.next() : null;
    }, r.prototype.toArray = function () {
      for (var e = []; this._iterator.hasNext();) e.push(this._iterator.next());
      return e;
    };
  }, function (e, t, r) {
    var n = r(299);
    t.Parser = function (e) {
      return {
        parseTokens: function parseTokens(e, t) {
          return e(new n(t));
        }
      };
    };
  }, function (e, t, r) {
    function n(e) {
      function t(e, t) {
        for (var i = new a(e, t), o = 0, s = []; o < e.length;) {
          var l = r(e, o, i);
          o = l.endIndex, s.push(l.token);
        }
        return s.push(n(e, i)), s;
      }
      function r(t, r, n) {
        for (var a = 0; a < e.length; a++) {
          var o = e[a].regex;
          o.lastIndex = r;
          var s = o.exec(t);
          if (s) {
            var l = r + s[0].length;
            if (s.index === r && l > r) {
              var c = s[1],
                u = new i(e[a].name, c, n.range(r, l));
              return {
                token: u,
                endIndex: l
              };
            }
          }
        }
        var l = r + 1,
          u = new i("unrecognisedCharacter", t.substring(r, l), n.range(r, l));
        return {
          token: u,
          endIndex: l
        };
      }
      function n(e, t) {
        return new i("end", null, t.range(e.length, e.length));
      }
      return e = e.map(function (e) {
        return {
          name: e.name,
          regex: new RegExp(e.regex.source, "g")
        };
      }), {
        tokenise: t
      };
    }
    var i = r(123),
      a = r(122);
    t.RegexTokeniser = n;
  }, function (e, t, r) {
    (function () {
      var r = this,
        n = r._,
        i = {},
        a = Array.prototype,
        o = Object.prototype,
        s = Function.prototype,
        l = a.push,
        c = a.slice,
        u = a.concat,
        h = o.toString,
        f = o.hasOwnProperty,
        d = a.forEach,
        p = a.map,
        m = a.reduce,
        g = a.reduceRight,
        v = a.filter,
        b = a.every,
        y = a.some,
        w = a.indexOf,
        x = a.lastIndexOf,
        _ = Array.isArray,
        S = Object.keys,
        C = s.bind,
        _E = function E(e) {
          return e instanceof _E ? e : this instanceof _E ? void (this._wrapped = e) : new _E(e);
        };
      void 0 !== e && e.exports && (t = e.exports = _E), t._ = _E, _E.VERSION = "1.4.4";
      var A = _E.each = _E.forEach = function (e, t, r) {
        if (null != e) if (d && e.forEach === d) e.forEach(t, r);else if (e.length === +e.length) {
          for (var n = 0, a = e.length; n < a; n++) if (t.call(r, e[n], n, e) === i) return;
        } else for (var o in e) if (_E.has(e, o) && t.call(r, e[o], o, e) === i) return;
      };
      _E.map = _E.collect = function (e, t, r) {
        var n = [];
        return null == e ? n : p && e.map === p ? e.map(t, r) : (A(e, function (e, i, a) {
          n[n.length] = t.call(r, e, i, a);
        }), n);
      };
      var T = "Reduce of empty array with no initial value";
      _E.reduce = _E.foldl = _E.inject = function (e, t, r, n) {
        var i = arguments.length > 2;
        if (null == e && (e = []), m && e.reduce === m) return n && (t = _E.bind(t, n)), i ? e.reduce(t, r) : e.reduce(t);
        if (A(e, function (e, a, o) {
          i ? r = t.call(n, r, e, a, o) : (r = e, i = !0);
        }), !i) throw new TypeError(T);
        return r;
      }, _E.reduceRight = _E.foldr = function (e, t, r, n) {
        var i = arguments.length > 2;
        if (null == e && (e = []), g && e.reduceRight === g) return n && (t = _E.bind(t, n)), i ? e.reduceRight(t, r) : e.reduceRight(t);
        var a = e.length;
        if (a !== +a) {
          var o = _E.keys(e);
          a = o.length;
        }
        if (A(e, function (s, l, c) {
          l = o ? o[--a] : --a, i ? r = t.call(n, r, e[l], l, c) : (r = e[l], i = !0);
        }), !i) throw new TypeError(T);
        return r;
      }, _E.find = _E.detect = function (e, t, r) {
        var n;
        return k(e, function (e, i, a) {
          if (t.call(r, e, i, a)) return n = e, !0;
        }), n;
      }, _E.filter = _E.select = function (e, t, r) {
        var n = [];
        return null == e ? n : v && e.filter === v ? e.filter(t, r) : (A(e, function (e, i, a) {
          t.call(r, e, i, a) && (n[n.length] = e);
        }), n);
      }, _E.reject = function (e, t, r) {
        return _E.filter(e, function (e, n, i) {
          return !t.call(r, e, n, i);
        }, r);
      }, _E.every = _E.all = function (e, t, r) {
        t || (t = _E.identity);
        var n = !0;
        return null == e ? n : b && e.every === b ? e.every(t, r) : (A(e, function (e, a, o) {
          if (!(n = n && t.call(r, e, a, o))) return i;
        }), !!n);
      };
      var k = _E.some = _E.any = function (e, t, r) {
        t || (t = _E.identity);
        var n = !1;
        return null == e ? n : y && e.some === y ? e.some(t, r) : (A(e, function (e, a, o) {
          if (n || (n = t.call(r, e, a, o))) return i;
        }), !!n);
      };
      _E.contains = _E.include = function (e, t) {
        return null != e && (w && e.indexOf === w ? -1 != e.indexOf(t) : k(e, function (e) {
          return e === t;
        }));
      }, _E.invoke = function (e, t) {
        var r = c.call(arguments, 2),
          n = _E.isFunction(t);
        return _E.map(e, function (e) {
          return (n ? t : e[t]).apply(e, r);
        });
      }, _E.pluck = function (e, t) {
        return _E.map(e, function (e) {
          return e[t];
        });
      }, _E.where = function (e, t, r) {
        return _E.isEmpty(t) ? r ? null : [] : _E[r ? "find" : "filter"](e, function (e) {
          for (var r in t) if (t[r] !== e[r]) return !1;
          return !0;
        });
      }, _E.findWhere = function (e, t) {
        return _E.where(e, t, !0);
      }, _E.max = function (e, t, r) {
        if (!t && _E.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.max.apply(Math, e);
        if (!t && _E.isEmpty(e)) return -1 / 0;
        var n = {
          computed: -1 / 0,
          value: -1 / 0
        };
        return A(e, function (e, i, a) {
          var o = t ? t.call(r, e, i, a) : e;
          o >= n.computed && (n = {
            value: e,
            computed: o
          });
        }), n.value;
      }, _E.min = function (e, t, r) {
        if (!t && _E.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.min.apply(Math, e);
        if (!t && _E.isEmpty(e)) return 1 / 0;
        var n = {
          computed: 1 / 0,
          value: 1 / 0
        };
        return A(e, function (e, i, a) {
          var o = t ? t.call(r, e, i, a) : e;
          o < n.computed && (n = {
            value: e,
            computed: o
          });
        }), n.value;
      }, _E.shuffle = function (e) {
        var t,
          r = 0,
          n = [];
        return A(e, function (e) {
          t = _E.random(r++), n[r - 1] = n[t], n[t] = e;
        }), n;
      };
      var R = function R(e) {
        return _E.isFunction(e) ? e : function (t) {
          return t[e];
        };
      };
      _E.sortBy = function (e, t, r) {
        var n = R(t);
        return _E.pluck(_E.map(e, function (e, t, i) {
          return {
            value: e,
            index: t,
            criteria: n.call(r, e, t, i)
          };
        }).sort(function (e, t) {
          var r = e.criteria,
            n = t.criteria;
          if (r !== n) {
            if (r > n || void 0 === r) return 1;
            if (r < n || void 0 === n) return -1;
          }
          return e.index < t.index ? -1 : 1;
        }), "value");
      };
      var I = function I(e, t, r, n) {
        var i = {},
          a = R(t || _E.identity);
        return A(e, function (t, o) {
          var s = a.call(r, t, o, e);
          n(i, s, t);
        }), i;
      };
      _E.groupBy = function (e, t, r) {
        return I(e, t, r, function (e, t, r) {
          (_E.has(e, t) ? e[t] : e[t] = []).push(r);
        });
      }, _E.countBy = function (e, t, r) {
        return I(e, t, r, function (e, t) {
          _E.has(e, t) || (e[t] = 0), e[t]++;
        });
      }, _E.sortedIndex = function (e, t, r, n) {
        r = null == r ? _E.identity : R(r);
        for (var i = r.call(n, t), a = 0, o = e.length; a < o;) {
          var s = a + o >>> 1;
          r.call(n, e[s]) < i ? a = s + 1 : o = s;
        }
        return a;
      }, _E.toArray = function (e) {
        return e ? _E.isArray(e) ? c.call(e) : e.length === +e.length ? _E.map(e, _E.identity) : _E.values(e) : [];
      }, _E.size = function (e) {
        return null == e ? 0 : e.length === +e.length ? e.length : _E.keys(e).length;
      }, _E.first = _E.head = _E.take = function (e, t, r) {
        if (null != e) return null == t || r ? e[0] : c.call(e, 0, t);
      }, _E.initial = function (e, t, r) {
        return c.call(e, 0, e.length - (null == t || r ? 1 : t));
      }, _E.last = function (e, t, r) {
        if (null != e) return null == t || r ? e[e.length - 1] : c.call(e, Math.max(e.length - t, 0));
      }, _E.rest = _E.tail = _E.drop = function (e, t, r) {
        return c.call(e, null == t || r ? 1 : t);
      }, _E.compact = function (e) {
        return _E.filter(e, _E.identity);
      };
      var _M2 = function M(e, t, r) {
        return A(e, function (e) {
          _E.isArray(e) ? t ? l.apply(r, e) : _M2(e, t, r) : r.push(e);
        }), r;
      };
      _E.flatten = function (e, t) {
        return _M2(e, t, []);
      }, _E.without = function (e) {
        return _E.difference(e, c.call(arguments, 1));
      }, _E.uniq = _E.unique = function (e, t, r, n) {
        _E.isFunction(t) && (n = r, r = t, t = !1);
        var i = r ? _E.map(e, r, n) : e,
          a = [],
          o = [];
        return A(i, function (r, n) {
          (t ? n && o[o.length - 1] === r : _E.contains(o, r)) || (o.push(r), a.push(e[n]));
        }), a;
      }, _E.union = function () {
        return _E.uniq(u.apply(a, arguments));
      }, _E.intersection = function (e) {
        var t = c.call(arguments, 1);
        return _E.filter(_E.uniq(e), function (e) {
          return _E.every(t, function (t) {
            return _E.indexOf(t, e) >= 0;
          });
        });
      }, _E.difference = function (e) {
        var t = u.apply(a, c.call(arguments, 1));
        return _E.filter(e, function (e) {
          return !_E.contains(t, e);
        });
      }, _E.zip = function () {
        for (var e = c.call(arguments), t = _E.max(_E.pluck(e, "length")), r = new Array(t), n = 0; n < t; n++) r[n] = _E.pluck(e, "" + n);
        return r;
      }, _E.object = function (e, t) {
        if (null == e) return {};
        for (var r = {}, n = 0, i = e.length; n < i; n++) t ? r[e[n]] = t[n] : r[e[n][0]] = e[n][1];
        return r;
      }, _E.indexOf = function (e, t, r) {
        if (null == e) return -1;
        var n = 0,
          i = e.length;
        if (r) {
          if ("number" != typeof r) return n = _E.sortedIndex(e, t), e[n] === t ? n : -1;
          n = r < 0 ? Math.max(0, i + r) : r;
        }
        if (w && e.indexOf === w) return e.indexOf(t, r);
        for (; n < i; n++) if (e[n] === t) return n;
        return -1;
      }, _E.lastIndexOf = function (e, t, r) {
        if (null == e) return -1;
        var n = null != r;
        if (x && e.lastIndexOf === x) return n ? e.lastIndexOf(t, r) : e.lastIndexOf(t);
        for (var i = n ? r : e.length; i--;) if (e[i] === t) return i;
        return -1;
      }, _E.range = function (e, t, r) {
        arguments.length <= 1 && (t = e || 0, e = 0), r = arguments[2] || 1;
        for (var n = Math.max(Math.ceil((t - e) / r), 0), i = 0, a = new Array(n); i < n;) a[i++] = e, e += r;
        return a;
      }, _E.bind = function (e, t) {
        if (e.bind === C && C) return C.apply(e, c.call(arguments, 1));
        var r = c.call(arguments, 2);
        return function () {
          return e.apply(t, r.concat(c.call(arguments)));
        };
      }, _E.partial = function (e) {
        var t = c.call(arguments, 1);
        return function () {
          return e.apply(this, t.concat(c.call(arguments)));
        };
      }, _E.bindAll = function (e) {
        var t = c.call(arguments, 1);
        return 0 === t.length && (t = _E.functions(e)), A(t, function (t) {
          e[t] = _E.bind(e[t], e);
        }), e;
      }, _E.memoize = function (e, t) {
        var r = {};
        return t || (t = _E.identity), function () {
          var n = t.apply(this, arguments);
          return _E.has(r, n) ? r[n] : r[n] = e.apply(this, arguments);
        };
      }, _E.delay = function (e, t) {
        var r = c.call(arguments, 2);
        return setTimeout(function () {
          return e.apply(null, r);
        }, t);
      }, _E.defer = function (e) {
        return _E.delay.apply(_E, [e, 1].concat(c.call(arguments, 1)));
      }, _E.throttle = function (e, t) {
        var r,
          n,
          i,
          a,
          o = 0,
          s = function s() {
            o = new Date(), i = null, a = e.apply(r, n);
          };
        return function () {
          var l = new Date(),
            c = t - (l - o);
          return r = this, n = arguments, c <= 0 ? (clearTimeout(i), i = null, o = l, a = e.apply(r, n)) : i || (i = setTimeout(s, c)), a;
        };
      }, _E.debounce = function (e, t, r) {
        var n, i;
        return function () {
          var a = this,
            o = arguments,
            s = function s() {
              n = null, r || (i = e.apply(a, o));
            },
            l = r && !n;
          return clearTimeout(n), n = setTimeout(s, t), l && (i = e.apply(a, o)), i;
        };
      }, _E.once = function (e) {
        var t,
          r = !1;
        return function () {
          return r ? t : (r = !0, t = e.apply(this, arguments), e = null, t);
        };
      }, _E.wrap = function (e, t) {
        return function () {
          var r = [e];
          return l.apply(r, arguments), t.apply(this, r);
        };
      }, _E.compose = function () {
        var e = arguments;
        return function () {
          for (var t = arguments, r = e.length - 1; r >= 0; r--) t = [e[r].apply(this, t)];
          return t[0];
        };
      }, _E.after = function (e, t) {
        return e <= 0 ? t() : function () {
          if (--e < 1) return t.apply(this, arguments);
        };
      }, _E.keys = S || function (e) {
        if (e !== Object(e)) throw new TypeError("Invalid object");
        var t = [];
        for (var r in e) _E.has(e, r) && (t[t.length] = r);
        return t;
      }, _E.values = function (e) {
        var t = [];
        for (var r in e) _E.has(e, r) && t.push(e[r]);
        return t;
      }, _E.pairs = function (e) {
        var t = [];
        for (var r in e) _E.has(e, r) && t.push([r, e[r]]);
        return t;
      }, _E.invert = function (e) {
        var t = {};
        for (var r in e) _E.has(e, r) && (t[e[r]] = r);
        return t;
      }, _E.functions = _E.methods = function (e) {
        var t = [];
        for (var r in e) _E.isFunction(e[r]) && t.push(r);
        return t.sort();
      }, _E.extend = function (e) {
        return A(c.call(arguments, 1), function (t) {
          if (t) for (var r in t) e[r] = t[r];
        }), e;
      }, _E.pick = function (e) {
        var t = {},
          r = u.apply(a, c.call(arguments, 1));
        return A(r, function (r) {
          r in e && (t[r] = e[r]);
        }), t;
      }, _E.omit = function (e) {
        var t = {},
          r = u.apply(a, c.call(arguments, 1));
        for (var n in e) _E.contains(r, n) || (t[n] = e[n]);
        return t;
      }, _E.defaults = function (e) {
        return A(c.call(arguments, 1), function (t) {
          if (t) for (var r in t) null == e[r] && (e[r] = t[r]);
        }), e;
      }, _E.clone = function (e) {
        return _E.isObject(e) ? _E.isArray(e) ? e.slice() : _E.extend({}, e) : e;
      }, _E.tap = function (e, t) {
        return t(e), e;
      };
      var _O = function O(e, t, r, n) {
        if (e === t) return 0 !== e || 1 / e == 1 / t;
        if (null == e || null == t) return e === t;
        e instanceof _E && (e = e._wrapped), t instanceof _E && (t = t._wrapped);
        var i = h.call(e);
        if (i != h.call(t)) return !1;
        switch (i) {
          case "[object String]":
            return e == String(t);
          case "[object Number]":
            return e != +e ? t != +t : 0 == e ? 1 / e == 1 / t : e == +t;
          case "[object Date]":
          case "[object Boolean]":
            return +e == +t;
          case "[object RegExp]":
            return e.source == t.source && e.global == t.global && e.multiline == t.multiline && e.ignoreCase == t.ignoreCase;
        }
        if ("object" != _typeof(e) || "object" != _typeof(t)) return !1;
        for (var a = r.length; a--;) if (r[a] == e) return n[a] == t;
        r.push(e), n.push(t);
        var o = 0,
          s = !0;
        if ("[object Array]" == i) {
          if (o = e.length, s = o == t.length) for (; o-- && (s = _O(e[o], t[o], r, n)););
        } else {
          var l = e.constructor,
            c = t.constructor;
          if (l !== c && !(_E.isFunction(l) && l instanceof l && _E.isFunction(c) && c instanceof c)) return !1;
          for (var u in e) if (_E.has(e, u) && (o++, !(s = _E.has(t, u) && _O(e[u], t[u], r, n)))) break;
          if (s) {
            for (u in t) if (_E.has(t, u) && !o--) break;
            s = !o;
          }
        }
        return r.pop(), n.pop(), s;
      };
      _E.isEqual = function (e, t) {
        return _O(e, t, [], []);
      }, _E.isEmpty = function (e) {
        if (null == e) return !0;
        if (_E.isArray(e) || _E.isString(e)) return 0 === e.length;
        for (var t in e) if (_E.has(e, t)) return !1;
        return !0;
      }, _E.isElement = function (e) {
        return !(!e || 1 !== e.nodeType);
      }, _E.isArray = _ || function (e) {
        return "[object Array]" == h.call(e);
      }, _E.isObject = function (e) {
        return e === Object(e);
      }, A(["Arguments", "Function", "String", "Number", "Date", "RegExp"], function (e) {
        _E["is" + e] = function (t) {
          return h.call(t) == "[object " + e + "]";
        };
      }), _E.isArguments(arguments) || (_E.isArguments = function (e) {
        return !(!e || !_E.has(e, "callee"));
      }), _E.isFunction = function (e) {
        return "function" == typeof e;
      }, _E.isFinite = function (e) {
        return isFinite(e) && !isNaN(parseFloat(e));
      }, _E.isNaN = function (e) {
        return _E.isNumber(e) && e != +e;
      }, _E.isBoolean = function (e) {
        return !0 === e || !1 === e || "[object Boolean]" == h.call(e);
      }, _E.isNull = function (e) {
        return null === e;
      }, _E.isUndefined = function (e) {
        return void 0 === e;
      }, _E.has = function (e, t) {
        return f.call(e, t);
      }, _E.noConflict = function () {
        return r._ = n, this;
      }, _E.identity = function (e) {
        return e;
      }, _E.times = function (e, t, r) {
        for (var n = Array(e), i = 0; i < e; i++) n[i] = t.call(r, i);
        return n;
      }, _E.random = function (e, t) {
        return null == t && (t = e, e = 0), e + Math.floor(Math.random() * (t - e + 1));
      };
      var P = {
        escape: {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "/": "&#x2F;"
        }
      };
      P.unescape = _E.invert(P.escape);
      var B = {
        escape: new RegExp("[" + _E.keys(P.escape).join("") + "]", "g"),
        unescape: new RegExp("(" + _E.keys(P.unescape).join("|") + ")", "g")
      };
      _E.each(["escape", "unescape"], function (e) {
        _E[e] = function (t) {
          return null == t ? "" : ("" + t).replace(B[e], function (t) {
            return P[e][t];
          });
        };
      }), _E.result = function (e, t) {
        if (null == e) return null;
        var r = e[t];
        return _E.isFunction(r) ? r.call(e) : r;
      }, _E.mixin = function (e) {
        A(_E.functions(e), function (t) {
          var r = _E[t] = e[t];
          _E.prototype[t] = function () {
            var e = [this._wrapped];
            return l.apply(e, arguments), U.call(this, r.apply(_E, e));
          };
        });
      };
      var D = 0;
      _E.uniqueId = function (e) {
        var t = ++D + "";
        return e ? e + t : t;
      }, _E.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };
      var L = /(.)^/,
        F = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\t": "t",
          "\u2028": "u2028",
          "\u2029": "u2029"
        },
        N = /\\|'|\r|\n|\t|\u2028|\u2029/g;
      _E.template = function (e, t, r) {
        var n;
        r = _E.defaults({}, r, _E.templateSettings);
        var i = new RegExp([(r.escape || L).source, (r.interpolate || L).source, (r.evaluate || L).source].join("|") + "|$", "g"),
          a = 0,
          o = "__p+='";
        e.replace(i, function (t, r, n, i, s) {
          return o += e.slice(a, s).replace(N, function (e) {
            return "\\" + F[e];
          }), r && (o += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'"), n && (o += "'+\n((__t=(" + n + "))==null?'':__t)+\n'"), i && (o += "';\n" + i + "\n__p+='"), a = s + t.length, t;
        }), o += "';\n", r.variable || (o = "with(obj||{}){\n" + o + "}\n"), o = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + o + "return __p;\n";
        try {
          n = new Function(r.variable || "obj", "_", o);
        } catch (e) {
          throw e.source = o, e;
        }
        if (t) return n(t, _E);
        var s = function s(e) {
          return n.call(this, e, _E);
        };
        return s.source = "function(" + (r.variable || "obj") + "){\n" + o + "}", s;
      }, _E.chain = function (e) {
        return _E(e).chain();
      };
      var U = function U(e) {
        return this._chain ? _E(e).chain() : e;
      };
      _E.mixin(_E), A(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function (e) {
        var t = a[e];
        _E.prototype[e] = function () {
          var r = this._wrapped;
          return t.apply(r, arguments), "shift" != e && "splice" != e || 0 !== r.length || delete r[0], U.call(this, r);
        };
      }), A(["concat", "join", "slice"], function (e) {
        var t = a[e];
        _E.prototype[e] = function () {
          return U.call(this, t.apply(this._wrapped, arguments));
        };
      }), _E.extend(_E.prototype, {
        chain: function chain() {
          return this._chain = !0, this;
        },
        value: function value() {
          return this._wrapped;
        }
      });
    }).call(this);
  }, function (e, t, r) {
    function n() {
      function e(e) {
        return i.reject(new Error("could not open external image: '" + e + "'\ncannot open linked files from a web browser"));
      }
      return {
        read: e
      };
    }
    var i = r(15);
    t.Files = n;
  }, function (e, t, r) {
    function n(e) {
      return e.arrayBuffer ? i.resolve(a.openArrayBuffer(e.arrayBuffer)) : i.reject(new Error("Could not find file in options"));
    }
    var i = r(15),
      a = r(333);
    t.openZip = n;
  }, function (e, t, r) {
    function n(e) {
      return {
        convertToHtml: function convertToHtml(t) {
          var r = c.indexBy(t.type === h.types.document ? t.comments : [], "commentId");
          return new i(e, r).convertToHtml(t);
        }
      };
    }
    function i(e, t) {
      function r(t) {
        var r = [],
          n = i(t, r),
          a = [];
        l(n, function (e) {
          "deferred" === e.type && a.push(e);
        });
        var o = {};
        return u.mapSeries(a, function (e) {
          return e.value().then(function (t) {
            o[e.id] = t;
          });
        }).then(function () {
          function t(e) {
            return s(e, function (e) {
              return "deferred" === e.type ? o[e.id] : e.children ? [c.extend({}, e, {
                children: t(e.children)
              })] : [e];
            });
          }
          var i = g.writer({
            prettyPrint: e.prettyPrint,
            outputFormat: e.outputFormat
          });
          return m.write(i, m.simplify(t(n))), new d.Result(i.asString(), r);
        });
      }
      function n(e, t) {
        return s(e, function (e) {
          return i(e, t);
        });
      }
      function i(e, t) {
        var r = V[e.type];
        return r ? r(e, t) : [];
      }
      function v(t, r) {
        return y(t, r).wrap(function () {
          var i = n(t.children, r);
          return e.ignoreEmptyParagraphs ? i : [m.forceWrite].concat(i);
        });
      }
      function y(e, t) {
        var r = S(e);
        return r ? r.to : (e.styleId && t.push(o("paragraph", e)), z);
      }
      function w(e, t) {
        var r = function r() {
            return n(e.children, t);
          },
          i = [];
        e.isStrikethrough && i.push(x("strikethrough", "s")), e.isUnderline && i.push(x("underline")), e.verticalAlignment === h.verticalAlignment.subscript && i.push(f.element("sub", {}, {
          fresh: !1
        })), e.verticalAlignment === h.verticalAlignment.superscript && i.push(f.element("sup", {}, {
          fresh: !1
        })), e.isItalic && i.push(x("italic", "em")), e.isBold && i.push(x("bold", "strong"));
        var a = f.empty,
          s = S(e);
        return s ? a = s.to : e.styleId && t.push(o("run", e)), i.push(a), i.forEach(function (e) {
          r = e.wrap.bind(e, r);
        }), r();
      }
      function x(e, t) {
        var r = _({
          type: e
        });
        return r || (t ? f.element(t, {}, {
          fresh: !1
        }) : f.empty);
      }
      function _(e, t) {
        var r = S(e);
        return r ? r.to : t;
      }
      function S(e) {
        for (var t = 0; t < H.length; t++) if (H[t].from.matches(e)) return H[t];
      }
      function C(e) {
        return A(e.noteType, e.noteId);
      }
      function E(e) {
        return T(e.noteType, e.noteId);
      }
      function A(e, t) {
        return k(e + "-" + t);
      }
      function T(e, t) {
        return k(e + "-ref-" + t);
      }
      function k(e) {
        return j + e;
      }
      function R(e, t) {
        return L(e, "table", t);
      }
      function I(e, t) {
        return L(e, "tr", t);
      }
      function M(e, t) {
        var r = n(e.children, t),
          i = {};
        return 1 !== e.colSpan && (i.colspan = e.colSpan.toString()), 1 !== e.rowSpan && (i.rowspan = e.rowSpan.toString()), [m.freshElement("td", i, [m.forceWrite].concat(r))];
      }
      function O(e, r) {
        return _(e, f.ignore).wrap(function () {
          var r = t[e.commentId],
            n = U.length + 1,
            i = "[" + b(r) + n + "]";
          return U.push({
            label: i,
            comment: r
          }), [m.freshElement("a", {
            href: "#" + A("comment", e.commentId),
            id: T("comment", e.commentId)
          }, [m.text(i)])];
        });
      }
      function P(e, t) {
        var r = e.label,
          i = e.comment,
          a = n(i.body).concat([m.nonFreshElement("p", {}, [m.text(" "), m.freshElement("a", {
            href: "#" + T("comment", i.commentId)
          }, [m.text("↑")])])]);
        return [m.freshElement("dt", {
          id: A("comment", i.commentId)
        }, [m.text("Comment " + r)]), m.freshElement("dd", {}, a)];
      }
      function B(e, t) {
        return D(e).wrap(function () {
          return [];
        });
      }
      function D(e) {
        var t = S(e);
        return t ? t.to : "line" === e.breakType ? f.topLevelElement("br") : f.empty;
      }
      function L(e, t, r) {
        var i = n(e.children, r);
        return [m.freshElement(t, {}, [m.forceWrite].concat(i))];
      }
      var F = 1,
        N = [],
        U = [];
      e = c.extend({
        ignoreEmptyParagraphs: !0
      }, e);
      var j = void 0 === e.idPrefix ? "" : e.idPrefix,
        z = f.topLevelElement("p"),
        H = e.styleMap || [],
        G = p.imgElement(function (e) {
          return e.read("base64").then(function (t) {
            return {
              src: "data:" + e.contentType + ";base64," + t
            };
          });
        }),
        V = {
          document: function document(e, t) {
            var r = n(e.children, t),
              i = N.map(function (t) {
                return e.notes.resolve(t);
              }),
              a = n(i, t);
            return r.concat([m.freshElement("ol", {}, a), m.freshElement("dl", {}, s(U, function (e) {
              return P(e, t);
            }))]);
          },
          paragraph: v,
          run: w,
          text: function text(e, t) {
            return [m.text(e.value)];
          },
          tab: function tab(e, t) {
            return [m.text("\t")];
          },
          hyperlink: function hyperlink(e, t) {
            var r = e.anchor ? "#" + k(e.anchor) : e.href,
              i = n(e.children, t);
            return [m.freshElement("a", {
              href: r
            }, i)];
          },
          bookmarkStart: function bookmarkStart(e, t) {
            return [m.freshElement("a", {
              id: k(e.name)
            }, [m.forceWrite])];
          },
          noteReference: function noteReference(e, t) {
            N.push(e);
            var r = m.freshElement("a", {
              href: "#" + C(e),
              id: E(e)
            }, [m.text("[" + F++ + "]")]);
            return [m.freshElement("sup", {}, [r])];
          },
          note: function note(e, t) {
            var r = n(e.body, t),
              i = m.elementWithTag(f.element("p", {}, {
                fresh: !1
              }), [m.text(" "), m.freshElement("a", {
                href: "#" + E(e)
              }, [m.text("↑")])]),
              a = r.concat([i]);
            return m.freshElement("li", {
              id: C(e)
            }, a);
          },
          commentReference: O,
          comment: P,
          image: a(function (e) {
            return function (t, r) {
              return u.attempt(function () {
                return e(t, r);
              }).caught(function (e) {
                return r.push(d.error(e)), [];
              });
            };
          }(e.convertImage || G)),
          table: R,
          tableRow: I,
          tableCell: M,
          break: B
        };
      return {
        convertToHtml: r
      };
    }
    function a(e) {
      return function (t, r) {
        return [{
          type: "deferred",
          id: v++,
          value: function value() {
            return e(t, r);
          }
        }];
      };
    }
    function o(e, t) {
      return d.warning("Unrecognised " + e + " style: '" + t.styleName + "' (Style ID: " + t.styleId + ")");
    }
    function s(e, t) {
      return c.flatten(e.map(t), !0);
    }
    function l(e, t) {
      e.forEach(function (e) {
        t(e), e.children && l(e.children, t);
      });
    }
    var c = r(1),
      u = r(15),
      h = r(39),
      f = r(55),
      d = r(16),
      p = r(127),
      m = r(54),
      g = r(329);
    t.DocumentConverter = n;
    var v = 1,
      b = t.commentAuthorLabel = function (e) {
        return e.authorInitials || "";
      };
  }, function (e, t, r) {
    function n(e) {
      return {
        readXmlElement: function readXmlElement(t) {
          return new i(e).readXmlElement(t);
        },
        readXmlElements: function readXmlElements(t) {
          return new i(e).readXmlElements(t);
        }
      };
    }
    function i(e) {
      function t(e) {
        return p(e.map(r));
      }
      function r(e) {
        if ("element" === e.type) {
          var t = Q[e.name];
          if (t) return t(e);
          if (!Object.prototype.hasOwnProperty.call(S, e.name)) {
            return c([w("An unrecognised element was ignored: " + e.name)]);
          }
        }
        return u();
      }
      function n(e) {
        return m(e).map(function (t) {
          return {
            type: "runProperties",
            styleId: t.styleId,
            styleName: t.name,
            verticalAlignment: e.firstOrEmpty("w:vertAlign").attributes["w:val"],
            font: e.firstOrEmpty("w:rFonts").attributes["w:ascii"],
            isBold: i(e.first("w:b")),
            isUnderline: i(e.first("w:u")),
            isItalic: i(e.first("w:i")),
            isStrikethrough: i(e.first("w:strike"))
          };
        });
      }
      function i(e) {
        if (e) {
          var t = e.attributes["w:val"];
          return "false" !== t && "0" !== t;
        }
        return !1;
      }
      function d(e) {
        return g(e, "w:pStyle", "Paragraph", Z.findParagraphStyleById);
      }
      function m(e) {
        return g(e, "w:rStyle", "Run", Z.findCharacterStyleById);
      }
      function g(e, t, r, n) {
        var i = [],
          a = e.first(t),
          o = null,
          s = null;
        if (a && (o = a.attributes["w:val"])) {
          var l = n(o);
          l ? s = l.name : i.push(H(r, o));
        }
        return f({
          styleId: o,
          name: s
        }, i);
      }
      function y(e) {
        var t = e.attributes["w:fldCharType"];
        if ("begin" === t) G.push(J), V = [];else if ("end" === t) G.pop();else if ("separate" === t) {
          var r = E(V.join("")),
            n = null === r ? J : {
              type: "hyperlink",
              href: r
            };
          G.pop(), G.push(n);
        }
        return u();
      }
      function C() {
        var e = v.last(G.filter(function (e) {
          return "hyperlink" === e.type;
        }));
        return e ? e.href : null;
      }
      function E(e) {
        var t = /\s*HYPERLINK "(.*)"/.exec(e);
        return t ? t[1] : null;
      }
      function A(e) {
        return V.push(e.text()), u();
      }
      function T(e) {
        return function (t) {
          var r = t.attributes["w:id"];
          return h(new b.NoteReference({
            noteType: e,
            noteId: r
          }));
        };
      }
      function k(e) {
        return h(b.commentReference({
          commentId: e.attributes["w:id"]
        }));
      }
      function R(e) {
        return t(e.children);
      }
      function I(e) {
        return t(e.children).flatMap(B).map(b.Table);
      }
      function M(e) {
        return t(e.children).map(b.TableRow);
      }
      function O(e) {
        return t(e.children).map(function (t) {
          var r = e.firstOrEmpty("w:tcPr"),
            n = r.firstOrEmpty("w:gridSpan").attributes["w:val"],
            i = n ? parseInt(n, 10) : 1,
            a = b.TableCell(t, {
              colSpan: i
            });
          return a._vMerge = P(r), a;
        });
      }
      function P(e) {
        var t = e.first("w:vMerge");
        if (t) {
          var r = t.attributes["w:val"];
          return "continue" === r || !r;
        }
        return null;
      }
      function B(e) {
        if (v.any(e, function (e) {
          return e.type !== b.types.tableRow;
        })) return f(e, [w("unexpected non-row element in table, cell merging may be incorrect")]);
        if (v.any(e, function (e) {
          return v.any(e.children, function (e) {
            return e.type !== b.types.tableCell;
          });
        })) return f(e, [w("unexpected non-cell element in table row, cell merging may be incorrect")]);
        var t = {};
        return e.forEach(function (e) {
          var r = 0;
          e.children.forEach(function (e) {
            e._vMerge && t[r] ? t[r].rowSpan++ : (t[r] = e, e._vMerge = !1), r += e.colSpan;
          });
        }), e.forEach(function (e) {
          e.children = e.children.filter(function (e) {
            return !e._vMerge;
          }), e.children.forEach(function (e) {
            delete e._vMerge;
          });
        }), h(e);
      }
      function D(e) {
        return p(e.getElementsByTagName("a:graphic").getElementsByTagName("a:graphicData").getElementsByTagName("pic:pic").getElementsByTagName("pic:blipFill").getElementsByTagName("a:blip").map(L.bind(null, e)));
      }
      function L(e, t) {
        var r = e.first("wp:docPr").attributes,
          n = F(r.descr) ? r.title : r.descr;
        return z(N(t), n);
      }
      function F(e) {
        return null == e || /^\s*$/.test(e);
      }
      function N(e) {
        var t = e.attributes["r:embed"],
          r = e.attributes["r:link"];
        if (t) return j(t);
        var n = q[r].target;
        return {
          path: n,
          read: Y.read.bind(Y, n)
        };
      }
      function U(e) {
        var t = e.attributes["r:id"];
        return t ? z(j(t), e.attributes["o:title"]) : c([w("A v:imagedata element without a relationship ID was ignored")]);
      }
      function j(e) {
        var t = x("word", q[e].target);
        return {
          path: t,
          read: X.read.bind(X, t)
        };
      }
      function z(e, t) {
        var r = W.findContentType(e.path);
        return f(b.Image({
          readImage: e.read,
          altText: t,
          contentType: r
        }), _[r] ? [] : w("Image of type " + r + " is unlikely to display in web browsers"));
      }
      function H(e, t) {
        return w(e + " style with ID " + t + " was referenced but not defined in the document");
      }
      var G = [],
        V = [],
        q = e.relationships,
        W = e.contentTypes,
        X = e.docxFile,
        Y = e.files,
        K = e.numbering,
        Z = e.styles,
        J = {
          type: "unknown"
        },
        Q = {
          "w:p": function wP(e) {
            return t(e.children).map(function (e) {
              var t = v.find(e, o);
              return new b.Paragraph(e.filter(l(o)), t);
            }).insertExtra();
          },
          "w:pPr": function wPPr(e) {
            return d(e).map(function (t) {
              return {
                type: "paragraphProperties",
                styleId: t.styleId,
                styleName: t.name,
                alignment: e.firstOrEmpty("w:jc").attributes["w:val"],
                numbering: a(e.firstOrEmpty("w:numPr"), K)
              };
            });
          },
          "w:r": function wR(e) {
            return t(e.children).map(function (e) {
              var t = v.find(e, s);
              e = e.filter(l(s));
              var r = C();
              return null !== r && (e = [new b.Hyperlink(e, {
                href: r
              })]), new b.Run(e, t);
            });
          },
          "w:rPr": n,
          "w:fldChar": y,
          "w:instrText": A,
          "w:t": function wT(e) {
            return h(new b.Text(e.text()));
          },
          "w:tab": function wTab(e) {
            return h(new b.Tab());
          },
          "w:hyperlink": function wHyperlink(e) {
            var r = e.attributes["r:id"],
              n = e.attributes["w:anchor"];
            return t(e.children).map(function (e) {
              if (r) {
                var t = q[r].target;
                return new b.Hyperlink(e, {
                  href: t
                });
              }
              return n ? new b.Hyperlink(e, {
                anchor: n
              }) : e;
            });
          },
          "w:tbl": I,
          "w:tr": M,
          "w:tc": O,
          "w:footnoteReference": T("footnote"),
          "w:endnoteReference": T("endnote"),
          "w:commentReference": k,
          "w:br": function wBr(e) {
            var t = e.attributes["w:type"];
            return null == t || "textWrapping" === t ? h(b.lineBreak) : "page" === t ? h(b.pageBreak) : "column" === t ? h(b.columnBreak) : c([w("Unsupported break type: " + t)]);
          },
          "w:bookmarkStart": function wBookmarkStart(e) {
            var t = e.attributes["w:name"];
            return "_GoBack" === t ? u() : h(new b.BookmarkStart({
              name: t
            }));
          },
          "mc:AlternateContent": function mcAlternateContent(e) {
            return R(e.first("mc:Fallback"));
          },
          "w:sdt": function wSdt(e) {
            return t(e.firstOrEmpty("w:sdtContent").children);
          },
          "w:ins": R,
          "w:object": R,
          "w:smartTag": R,
          "w:drawing": R,
          "w:pict": function wPict(e) {
            return R(e).toExtra();
          },
          "v:roundrect": R,
          "v:shape": R,
          "v:textbox": R,
          "w:txbxContent": R,
          "wp:inline": D,
          "wp:anchor": D,
          "v:imagedata": U
        };
      return {
        readXmlElement: r,
        readXmlElements: t
      };
    }
    function a(e, t) {
      var r = e.firstOrEmpty("w:ilvl").attributes["w:val"],
        n = e.firstOrEmpty("w:numId").attributes["w:val"];
      return void 0 === r || void 0 === n ? null : t.findLevel(n, r);
    }
    function o(e) {
      return "paragraphProperties" === e.type;
    }
    function s(e) {
      return "runProperties" === e.type;
    }
    function l(e) {
      return function (t) {
        return !e(t);
      };
    }
    function c(e) {
      return new d(null, null, e);
    }
    function u() {
      return new d(null);
    }
    function h(e) {
      return new d(e);
    }
    function f(e, t) {
      return new d(e, null, t);
    }
    function d(e, t, r) {
      this.value = e || [], this.extra = t, this._result = new y({
        element: this.value,
        extra: t
      }, r), this.messages = this._result.messages;
    }
    function p(e) {
      var t = y.combine(v.pluck(e, "_result"));
      return new d(v.flatten(v.pluck(t.value, "element")), v.filter(v.flatten(v.pluck(t.value, "extra")), g), t.messages);
    }
    function m(e, t) {
      return v.flatten([e, t]);
    }
    function g(e) {
      return e;
    }
    t.createBodyReader = n, t._readNumberingProperties = a;
    var v = r(1),
      b = r(39),
      y = r(16).Result,
      w = r(16).warning,
      x = r(319).uriToZipEntryName,
      _ = {
        "image/png": !0,
        "image/gif": !0,
        "image/jpeg": !0,
        "image/svg+xml": !0,
        "image/tiff": !0
      },
      S = {
        "office-word:wrap": !0,
        "v:shadow": !0,
        "v:shapetype": !0,
        "w:annotationRef": !0,
        "w:bookmarkEnd": !0,
        "w:sectPr": !0,
        "w:proofErr": !0,
        "w:lastRenderedPageBreak": !0,
        "w:commentRangeStart": !0,
        "w:commentRangeEnd": !0,
        "w:del": !0,
        "w:footnoteRef": !0,
        "w:endnoteRef": !0,
        "w:tblPr": !0,
        "w:tblGrid": !0,
        "w:tcPr": !0
      };
    d.prototype.toExtra = function () {
      return new d(null, m(this.extra, this.value), this.messages);
    }, d.prototype.insertExtra = function () {
      var e = this.extra;
      return e && e.length ? new d(m(this.value, e), null, this.messages) : this;
    }, d.prototype.map = function (e) {
      var t = this._result.map(function (t) {
        return e(t.element);
      });
      return new d(t.value, this.extra, t.messages);
    }, d.prototype.flatMap = function (e) {
      var t = this._result.flatMap(function (t) {
        return e(t.element)._result;
      });
      return new d(t.value.element, m(this.extra, t.value.extra), t.messages);
    };
  }, function (e, t, r) {
    function n(e) {
      function t(e) {
        return a.combine(e.getElementsByTagName("w:comment").map(r));
      }
      function r(t) {
        function r(e) {
          return (t.attributes[e] || "").trim() || null;
        }
        var n = t.attributes["w:id"];
        return e.readXmlElements(t.children).map(function (e) {
          return i.comment({
            commentId: n,
            body: e,
            authorName: r("w:author"),
            authorInitials: r("w:initials")
          });
        });
      }
      return t;
    }
    var i = r(39),
      a = r(16).Result;
    t.createCommentsReader = n;
  }, function (e, t) {
    function r(e) {
      var t = {},
        r = {};
      return e.children.forEach(function (e) {
        if ("content-types:Default" === e.name && (t[e.attributes.Extension] = e.attributes.ContentType), "content-types:Override" === e.name) {
          var n = e.attributes.PartName;
          "/" === n.charAt(0) && (n = n.substring(1)), r[n] = e.attributes.ContentType;
        }
      }), n(r, t);
    }
    function n(e, t) {
      return {
        findContentType: function findContentType(r) {
          var n = e[r];
          if (n) return n;
          var a = r.split("."),
            o = a[a.length - 1];
          if (t.hasOwnProperty(o)) return t[o];
          var s = i[o.toLowerCase()];
          return s ? "image/" + s : null;
        }
      };
    }
    t.readContentTypesFromXml = r;
    var i = {
      png: "png",
      gif: "gif",
      jpeg: "jpeg",
      jpg: "jpeg",
      tif: "tiff",
      tiff: "tiff",
      bmp: "bmp"
    };
    t.defaultContentTypes = n({}, {});
  }, function (e, t, r) {
    function n(e) {
      function t(t) {
        var n = t.first("w:body"),
          o = r.readXmlElements(n.children).map(function (t) {
            return new i.Document(t, {
              notes: e.notes,
              comments: e.comments
            });
          });
        return new a(o.value, o.messages);
      }
      var r = e.bodyReader;
      return {
        convertXmlToDocument: t
      };
    }
    t.DocumentXmlReader = n;
    var i = r(39),
      a = r(16).Result;
  }, function (e, t, r) {
    function n(e, t) {
      return t = t || {}, s.props({
        contentTypes: w(e),
        numbering: x(e),
        styles: _(e),
        docxFile: e,
        files: new y(t.path ? o.dirname(t.path) : null)
      }).also(function (e) {
        return {
          footnotes: a("footnotes", e, function (e, t) {
            return t ? v.createFootnotesReader(e)(t) : new c([]);
          }),
          endnotes: a("endnotes", e, function (e, t) {
            return t ? v.createEndnotesReader(e)(t) : new c([]);
          }),
          comments: a("comments", e, function (e, t) {
            return t ? b.createCommentsReader(e)(t) : new c([]);
          })
        };
      }).also(function (e) {
        return {
          notes: e.footnotes.flatMap(function (t) {
            return e.endnotes.map(function (e) {
              return new l.Notes(t.concat(e));
            });
          })
        };
      }).then(function (e) {
        return a("document", e, function (t, r) {
          if (r) return e.notes.flatMap(function (n) {
            return e.comments.flatMap(function (e) {
              return new f({
                bodyReader: t,
                notes: n,
                comments: e
              }).convertXmlToDocument(r);
            });
          });
          throw new Error("Could not find word/document.xml in ZIP file. Are you sure this is a valid .docx file?");
        });
      });
    }
    function i(e) {
      return function (t) {
        return u(t, e.filename).then(function (t) {
          return t ? e.readElement(t) : e.defaultValue;
        });
      };
    }
    function a(e, t, r) {
      return i({
        filename: "word/_rels/" + e + ".xml.rels",
        readElement: d.readRelationships,
        defaultValue: {}
      })(t.docxFile).then(function (n) {
        var i = new h({
          relationships: n,
          contentTypes: t.contentTypes,
          docxFile: t.docxFile,
          numbering: t.numbering,
          styles: t.styles,
          files: t.files
        });
        return u(t.docxFile, "word/" + e + ".xml").then(function (e) {
          return r(i, e);
        });
      });
    }
    t.read = n;
    var o = r(344),
      s = r(15),
      l = r(39),
      c = r(16).Result,
      u = r(315).readXmlFromZipFile,
      h = r(308).createBodyReader,
      f = r(311).DocumentXmlReader,
      d = r(316),
      p = r(310),
      m = r(314),
      g = r(318),
      v = r(313),
      b = r(309),
      y = r(305).Files,
      w = i({
        filename: "[Content_Types].xml",
        readElement: p.readContentTypesFromXml,
        defaultValue: p.defaultContentTypes
      }),
      x = i({
        filename: "word/numbering.xml",
        readElement: m.readNumberingXml,
        defaultValue: m.defaultNumbering
      }),
      _ = i({
        filename: "word/styles.xml",
        readElement: g.readStylesXml,
        defaultValue: g.defaultStyles
      });
  }, function (e, t, r) {
    function n(e, t) {
      function r(t) {
        return a.combine(t.getElementsByTagName("w:" + e).filter(n).map(o));
      }
      function n(e) {
        var t = e.attributes["w:type"];
        return "continuationSeparator" !== t && "separator" !== t;
      }
      function o(r) {
        var n = r.attributes["w:id"];
        return t.readXmlElements(r.children).map(function (t) {
          return i.Note({
            noteType: e,
            noteId: n,
            body: t
          });
        });
      }
      return r;
    }
    var i = r(39),
      a = r(16).Result;
    t.createFootnotesReader = n.bind(this, "footnote"), t.createEndnotesReader = n.bind(this, "endnote");
  }, function (e, t) {
    function r(e) {
      return {
        findLevel: function findLevel(t, r) {
          var n = e[t];
          return n ? n[r] : null;
        }
      };
    }
    function n(e) {
      return new r(o(e, i(e)));
    }
    function i(e) {
      var t = {};
      return e.getElementsByTagName("w:abstractNum").forEach(function (e) {
        var r = e.attributes["w:abstractNumId"];
        t[r] = a(e);
      }), t;
    }
    function a(e) {
      var t = {};
      return e.getElementsByTagName("w:lvl").forEach(function (e) {
        var r = e.attributes["w:ilvl"],
          n = e.first("w:numFmt").attributes["w:val"];
        t[r] = {
          isOrdered: "bullet" !== n,
          level: r
        };
      }), t;
    }
    function o(e, t) {
      var r = {};
      return e.getElementsByTagName("w:num").forEach(function (e) {
        var n = e.attributes["w:numId"],
          i = e.first("w:abstractNumId").attributes["w:val"];
        r[n] = t[i];
      }), r;
    }
    t.readNumberingXml = n, t.Numbering = r, t.defaultNumbering = new r({});
  }, function (e, t, r) {
    function n(e) {
      return c.readString(e, u).then(function (e) {
        return o(e)[0];
      });
    }
    function i(e, t) {
      return e.exists(t) ? e.read(t, "utf-8").then(a).then(n) : l.resolve(null);
    }
    function a(e) {
      return e.replace(/^\uFEFF/g, "");
    }
    function o(e) {
      return "element" === e.type ? "mc:AlternateContent" === e.name ? e.first("mc:Fallback").children : (e.children = s.flatten(e.children.map(o, !0)), [e]) : [e];
    }
    var s = r(1),
      l = r(15),
      c = r(128);
    t.read = n, t.readXmlFromZipFile = i;
    var u = {
      "http://schemas.openxmlformats.org/wordprocessingml/2006/main": "w",
      "http://schemas.openxmlformats.org/officeDocument/2006/relationships": "r",
      "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing": "wp",
      "http://schemas.openxmlformats.org/drawingml/2006/main": "a",
      "http://schemas.openxmlformats.org/drawingml/2006/picture": "pic",
      "http://schemas.openxmlformats.org/package/2006/content-types": "content-types",
      "urn:schemas-microsoft-com:vml": "v",
      "http://schemas.openxmlformats.org/markup-compatibility/2006": "mc",
      "urn:schemas-microsoft-com:office:word": "office-word"
    };
  }, function (e, t) {
    function r(e) {
      var t = {};
      return e.children.forEach(function (e) {
        "{http://schemas.openxmlformats.org/package/2006/relationships}Relationship" === e.name && (t[e.attributes.Id] = {
          target: e.attributes.Target
        });
      }), t;
    }
    t.readRelationships = r;
  }, function (e, t, r) {
    function n(e, t) {
      return e.write(f, t), i(e).then(function () {
        return a(e);
      });
    }
    function i(e) {
      var t = "word/_rels/document.xml.rels",
        r = "http://schemas.openxmlformats.org/package/2006/relationships";
      return e.read(t, "utf8").then(u.readString).then(function (n) {
        o(n.children, "{http://schemas.openxmlformats.org/package/2006/relationships}Relationship", "Id", {
          Id: "rMammothStyleMap",
          Type: h,
          Target: d
        });
        var i = {
          "": r
        };
        return e.write(t, u.writeString(n, i));
      });
    }
    function a(e) {
      var t = "[Content_Types].xml",
        r = "http://schemas.openxmlformats.org/package/2006/content-types";
      return e.read(t, "utf8").then(u.readString).then(function (n) {
        o(n.children, "{http://schemas.openxmlformats.org/package/2006/content-types}Override", "PartName", {
          PartName: d,
          ContentType: "text/prs.mammoth.style-map"
        });
        var i = {
          "": r
        };
        return e.write(t, u.writeString(n, i));
      });
    }
    function o(e, t, r, n) {
      var i = l.find(e, function (e) {
        return e.name === t && e.attributes[r] === n[r];
      });
      i ? i.attributes = n : e.push(u.element(t, n));
    }
    function s(e) {
      return e.exists(f) ? e.read(f, "utf8") : c.resolve(null);
    }
    var l = r(1),
      c = r(15),
      u = r(128);
    t.writeStyleMap = n, t.readStyleMap = s;
    var h = "http://schemas.zwobble.org/mammoth/style-map",
      f = "mammoth/style-map",
      d = "/" + f;
  }, function (e, t) {
    function r(e, t) {
      return {
        findParagraphStyleById: function findParagraphStyleById(t) {
          return e[t];
        },
        findCharacterStyleById: function findCharacterStyleById(e) {
          return t[e];
        }
      };
    }
    function n(e) {
      var t = {},
        n = {},
        a = {
          paragraph: t,
          character: n
        };
      return e.getElementsByTagName("w:style").forEach(function (e) {
        var t = i(e),
          r = a[t.type];
        r && (r[t.styleId] = t);
      }), new r(t, n);
    }
    function i(e) {
      return {
        type: e.attributes["w:type"],
        styleId: e.attributes["w:styleId"],
        name: a(e)
      };
    }
    function a(e) {
      var t = e.first("w:name");
      return t ? t.attributes["w:val"] : null;
    }
    t.readStylesXml = n, t.Styles = r, t.defaultStyles = new r({}, {});
  }, function (e, t) {
    function r(e, t) {
      return "/" === t.charAt(0) ? t.substr(1) : e + "/" + t;
    }
    t.uriToZipEntryName = r;
  }, function (e, t, r) {
    function n(e) {
      return i(c(e));
    }
    function i(e) {
      var t = [];
      return e.map(a).forEach(function (e) {
        l(t, e);
      }), t;
    }
    function a(e) {
      return g[e.type](e);
    }
    function o(e) {
      return m.elementWithTag(e.tag, i(e.children));
    }
    function s(e) {
      return e;
    }
    function l(e, t) {
      var r = e[e.length - 1];
      "element" === t.type && !t.tag.fresh && r && "element" === r.type && t.tag.matchesElement(r.tag) ? (t.tag.separator && l(r.children, m.text(t.tag.separator)), t.children.forEach(function (e) {
        l(r.children, e);
      })) : e.push(t);
    }
    function c(e) {
      return u(e, function (e) {
        return v[e.type](e);
      });
    }
    function u(e, t) {
      return p.flatten(p.map(e, t), !0);
    }
    function h(e) {
      return [e];
    }
    function f(e) {
      var t = c(e.children);
      return 0 !== t.length || m.isVoidElement(e) ? [m.elementWithTag(e.tag, t)] : [];
    }
    function d(e) {
      return 0 === e.value.length ? [] : [e];
    }
    var p = r(1),
      m = r(126),
      g = {
        element: o,
        text: s,
        forceWrite: s
      },
      v = {
        element: f,
        text: d,
        forceWrite: h
      };
    e.exports = n;
  }, function (e, t, r) {
    function n(e, t) {
      return a(e, t);
    }
    function i(e, t) {
      var r = Object.create(t || {});
      return r.outputFormat = "markdown", a(e, r);
    }
    function a(e, t) {
      return t = v(t), b.openZip(e).tap(function (e) {
        return p.readStyleMap(e).then(function (e) {
          t.embeddedStyleMap = e;
        });
      }).then(function (r) {
        return d.read(r, e).then(function (e) {
          return e.map(t.transformDocument);
        }).then(function (e) {
          return s(e, t);
        });
      });
    }
    function o(e) {
      return b.openZip(e).then(p.readStyleMap);
    }
    function s(e, t) {
      var r = l(t.readStyleMap()),
        n = f.extend({}, t, {
          styleMap: r.value
        }),
        i = new m(n);
      return e.flatMapThen(function (e) {
        return r.flatMapThen(function (t) {
          return i.convertToHtml(e);
        });
      });
    }
    function l(e) {
      return y.combine((e || []).map(g)).map(function (e) {
        return e.filter(function (e) {
          return !!e;
        });
      });
    }
    function c(e) {
      return b.openZip(e).then(d.read).then(function (e) {
        return e.map(u);
      });
    }
    function u(e) {
      if ("text" === e.type) return e.value;
      var t = "paragraph" === e.type ? "\n\n" : "";
      return (e.children || []).map(u).join("") + t;
    }
    function h(e, t) {
      return b.openZip(e).tap(function (e) {
        return p.writeStyleMap(e, t);
      }).then(function (e) {
        return {
          toBuffer: e.toBuffer
        };
      });
    }
    var f = r(1),
      d = r(312),
      p = r(317),
      m = r(307).DocumentConverter,
      g = r(323).readStyle,
      v = r(322).readOptions,
      b = r(306),
      y = r(16).Result;
    t.convertToHtml = n, t.convertToMarkdown = i, t.convert = a, t.extractRawText = c, t.images = r(127), t.transforms = r(326), t.underline = r(327), t.embedStyleMap = h, t.readEmbeddedStyleMap = o, t.styleMapping = function () {
      throw new Error("Use a raw string instead of mammoth.styleMapping e.g. \"p[style-name='Title'] => h1\" instead of mammoth.styleMapping(\"p[style-name='Title'] => h1\")");
    };
  }, function (e, t, r) {
    function n(e) {
      return e = e || {}, o.extend({}, l, e, {
        customStyleMap: i(e.styleMap),
        readStyleMap: function readStyleMap() {
          var e = this.customStyleMap;
          return this.includeEmbeddedStyleMap && (e = e.concat(i(this.embeddedStyleMap))), this.includeDefaultStyleMap && (e = e.concat(s)), e;
        }
      });
    }
    function i(e) {
      return e ? o.isString(e) ? e.split("\n").map(function (e) {
        return e.trim();
      }).filter(function (e) {
        return "" !== e && "#" !== e.charAt(0);
      }) : e : [];
    }
    function a(e) {
      return e;
    }
    t.readOptions = n;
    var o = r(1),
      s = t._defaultStyleMap = ["p.Heading1 => h1:fresh", "p.Heading2 => h2:fresh", "p.Heading3 => h3:fresh", "p.Heading4 => h4:fresh", "p.Heading5 => h5:fresh", "p.Heading6 => h6:fresh", "p[style-name='Heading 1'] => h1:fresh", "p[style-name='Heading 2'] => h2:fresh", "p[style-name='Heading 3'] => h3:fresh", "p[style-name='Heading 4'] => h4:fresh", "p[style-name='Heading 5'] => h5:fresh", "p[style-name='Heading 6'] => h6:fresh", "p[style-name='heading 1'] => h1:fresh", "p[style-name='heading 2'] => h2:fresh", "p[style-name='heading 3'] => h3:fresh", "p[style-name='heading 4'] => h4:fresh", "p[style-name='heading 5'] => h5:fresh", "p[style-name='heading 6'] => h6:fresh", "r[style-name='Strong'] => strong", "p[style-name='footnote text'] => p", "r[style-name='footnote reference'] =>", "p[style-name='endnote text'] => p", "r[style-name='endnote reference'] =>", "p[style-name='annotation text'] => p", "r[style-name='annotation reference'] =>", "p[style-name='Footnote'] => p", "r[style-name='Footnote anchor'] =>", "p[style-name='Endnote'] => p", "r[style-name='Endnote anchor'] =>", "p:unordered-list(1) => ul > li:fresh", "p:unordered-list(2) => ul|ol > li > ul > li:fresh", "p:unordered-list(3) => ul|ol > li > ul|ol > li > ul > li:fresh", "p:unordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh", "p:unordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ul > li:fresh", "p:ordered-list(1) => ol > li:fresh", "p:ordered-list(2) => ul|ol > li > ol > li:fresh", "p:ordered-list(3) => ul|ol > li > ul|ol > li > ol > li:fresh", "p:ordered-list(4) => ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh", "p:ordered-list(5) => ul|ol > li > ul|ol > li > ul|ol > li > ul|ol > li > ol > li:fresh", "r[style-name='Hyperlink'] =>", "p[style-name='Normal'] => p:fresh"],
      l = t._standardOptions = {
        transformDocument: a,
        includeDefaultStyleMap: !0,
        includeEmbeddedStyleMap: !0
      };
  }, function (e, t, r) {
    function n(e) {
      return c(S, e);
    }
    function i(e) {
      return c(a(), e);
    }
    function a() {
      var e = d.rules.sequence,
        t = function t(e, _t7) {
          return d.rules.then(d.rules.token("identifier", e), function () {
            return _t7;
          });
        },
        r = t("p", p.paragraph),
        n = t("r", p.run),
        i = d.rules.firstOf("p or r", r, n),
        a = d.rules.then(_, function (e) {
          return {
            styleId: e
          };
        }),
        o = d.rules.firstOf("style name matcher", d.rules.then(d.rules.sequence(d.rules.tokenOfType("equals"), d.rules.sequence.cut(), d.rules.sequence.capture(w)).head(), function (e) {
          return {
            styleName: p.equalTo(e)
          };
        }), d.rules.then(d.rules.sequence(d.rules.tokenOfType("startsWith"), d.rules.sequence.cut(), d.rules.sequence.capture(w)).head(), function (e) {
          return {
            styleName: p.startsWith(e)
          };
        })),
        s = d.rules.sequence(d.rules.tokenOfType("open-square-bracket"), d.rules.sequence.cut(), d.rules.token("identifier", "style-name"), d.rules.sequence.capture(o), d.rules.tokenOfType("close-square-bracket")).head(),
        l = d.rules.firstOf("list type", t("ordered-list", {
          isOrdered: !0
        }), t("unordered-list", {
          isOrdered: !1
        })),
        c = e(d.rules.tokenOfType("colon"), e.capture(l), e.cut(), d.rules.tokenOfType("open-paren"), e.capture(y), d.rules.tokenOfType("close-paren")).map(function (e, t) {
          return {
            list: {
              isOrdered: e.isOrdered,
              levelIndex: t - 1
            }
          };
        }),
        u = d.rules.firstOf("matcher suffix", a, s, c),
        h = d.rules.zeroOrMore(u),
        m = e(e.capture(i), e.capture(h)).map(function (e, t) {
          var r = {};
          return t.forEach(function (e) {
            f.extend(r, e);
          }), e(r);
        }),
        g = t("b", p.bold),
        v = t("i", p.italic),
        b = t("u", p.underline),
        x = t("strike", p.strikethrough),
        S = t("comment-reference", p.commentReference),
        C = e(d.rules.token("identifier", "br"), e.cut(), d.rules.tokenOfType("open-square-bracket"), d.rules.token("identifier", "type"), d.rules.tokenOfType("equals"), e.capture(w), d.rules.tokenOfType("close-square-bracket")).map(function (e) {
          switch (e) {
            case "line":
              return p.lineBreak;
            case "page":
              return p.pageBreak;
            case "column":
              return p.columnBreak;
          }
        });
      return d.rules.firstOf("element type", m, g, v, b, x, S, C);
    }
    function o(e) {
      return c(s(), e);
    }
    function s() {
      var e = d.rules.sequence.capture,
        t = d.rules.tokenOfType("whitespace"),
        r = d.rules.then(d.rules.optional(d.rules.sequence(d.rules.tokenOfType("colon"), d.rules.token("identifier", "fresh"))), function (e) {
          return e.map(function () {
            return !0;
          }).valueOrElse(!1);
        }),
        n = d.rules.then(d.rules.optional(d.rules.sequence(d.rules.tokenOfType("colon"), d.rules.token("identifier", "separator"), d.rules.tokenOfType("open-paren"), e(w), d.rules.tokenOfType("close-paren")).head()), function (e) {
          return e.valueOrElse("");
        }),
        i = d.rules.oneOrMoreWithSeparator(b, d.rules.tokenOfType("choice")),
        a = d.rules.sequence(e(i), e(d.rules.zeroOrMore(_)), e(r), e(n)).map(function (e, t, r, n) {
          var i = {},
            a = {};
          return t.length > 0 && (i.class = t.join(" ")), r && (a.fresh = !0), n && (a.separator = n), m.element(e, i, a);
        });
      return d.rules.firstOf("html path", d.rules.then(d.rules.tokenOfType("bang"), function () {
        return m.ignore;
      }), d.rules.then(d.rules.zeroOrMoreWithSeparator(a, d.rules.sequence(t, d.rules.tokenOfType("gt"), t)), m.elements));
    }
    function l(e) {
      return e.replace(/\\(.)/g, function (e, t) {
        return x[t] || t;
      });
    }
    function c(e, t) {
      var r = g(t),
        n = d.Parser(),
        i = n.parseTokens(e, r);
      return i.isSuccess() ? v.success(i.value()) : new v.Result(null, [v.warning(u(t, i))]);
    }
    function u(e, t) {
      return "Did not understand this style mapping, so ignored it: " + e + "\n" + t.errors().map(h).join("\n");
    }
    function h(e) {
      return "Error was at character number " + e.characterNumber() + ": Expected " + e.expected + " but got " + e.actual;
    }
    var f = r(1),
      d = r(121),
      p = r(324),
      m = r(55),
      g = r(325).tokenise,
      v = r(16);
    t.readHtmlPath = o, t.readDocumentMatcher = i, t.readStyle = n;
    var b = d.rules.then(d.rules.tokenOfType("identifier"), l),
      y = d.rules.tokenOfType("integer"),
      w = d.rules.then(d.rules.tokenOfType("string"), l),
      x = {
        n: "\n",
        r: "\r",
        t: "\t"
      },
      _ = d.rules.sequence(d.rules.tokenOfType("dot"), d.rules.sequence.cut(), d.rules.sequence.capture(b)).head(),
      S = function () {
        return d.rules.sequence(d.rules.sequence.capture(a()), d.rules.tokenOfType("whitespace"), d.rules.tokenOfType("arrow"), d.rules.sequence.capture(d.rules.optional(d.rules.sequence(d.rules.tokenOfType("whitespace"), d.rules.sequence.capture(s())).head())), d.rules.tokenOfType("end")).map(function (e, t) {
          return {
            from: e,
            to: t.valueOrElse(m.empty)
          };
        });
      }();
  }, function (e, t) {
    function r(e) {
      return new i("paragraph", e);
    }
    function n(e) {
      return new i("run", e);
    }
    function i(e, t) {
      t = t || {}, this._elementType = e, this._styleId = t.styleId, this._styleName = t.styleName, t.list && (this._listIndex = t.list.levelIndex, this._listIsOrdered = t.list.isOrdered);
    }
    function a(e, t, r) {
      return e.numbering && e.numbering.level == t && e.numbering.isOrdered == r;
    }
    function o(e) {
      return {
        operator: l,
        operand: e
      };
    }
    function s(e) {
      return {
        operator: c,
        operand: e
      };
    }
    function l(e, t) {
      return e.toUpperCase() === t.toUpperCase();
    }
    function c(e, t) {
      return 0 === t.toUpperCase().indexOf(e.toUpperCase());
    }
    t.paragraph = r, t.run = n, t.bold = new i("bold"), t.italic = new i("italic"), t.underline = new i("underline"), t.strikethrough = new i("strikethrough"), t.commentReference = new i("commentReference"), t.lineBreak = new i("break", {
      breakType: "line"
    }), t.pageBreak = new i("break", {
      breakType: "page"
    }), t.columnBreak = new i("break", {
      breakType: "column"
    }), t.equalTo = o, t.startsWith = s, i.prototype.matches = function (e) {
      return e.type === this._elementType && (void 0 === this._styleId || e.styleId === this._styleId) && (void 0 === this._styleName || e.styleName && this._styleName.operator(this._styleName.operand, e.styleName)) && (void 0 === this._listIndex || a(e, this._listIndex, this._listIsOrdered)) && (void 0 === this._breakType || this._breakType === e.breakType);
    };
  }, function (e, t, r) {
    function n(e) {
      return new a([{
        name: "identifier",
        regex: new RegExp("((?:[a-zA-Z\\-_]|\\\\.)(?:(?:[a-zA-Z\\-_]|\\\\.)|[0-9])*)")
      }, {
        name: "dot",
        regex: /\./
      }, {
        name: "colon",
        regex: /:/
      }, {
        name: "gt",
        regex: />/
      }, {
        name: "whitespace",
        regex: /\s+/
      }, {
        name: "arrow",
        regex: /=>/
      }, {
        name: "equals",
        regex: /=/
      }, {
        name: "startsWith",
        regex: /\^=/
      }, {
        name: "open-paren",
        regex: /\(/
      }, {
        name: "close-paren",
        regex: /\)/
      }, {
        name: "open-square-bracket",
        regex: /\[/
      }, {
        name: "close-square-bracket",
        regex: /\]/
      }, {
        name: "string",
        regex: new RegExp(o + "'")
      }, {
        name: "unterminated-string",
        regex: new RegExp(o)
      }, {
        name: "integer",
        regex: /([0-9]+)/
      }, {
        name: "choice",
        regex: /\|/
      }, {
        name: "bang",
        regex: /(!)/
      }]).tokenise(e);
    }
    var i = r(121),
      a = i.RegexTokeniser;
    t.tokenise = n;
    var o = "'((?:\\\\.|[^'])*)";
  }, function (e, t, r) {
    function n(e) {
      return a("paragraph", e);
    }
    function i(e) {
      return a("run", e);
    }
    function a(e, t) {
      return o(function (r) {
        return r.type === e ? t(r) : r;
      });
    }
    function o(e) {
      return function t(r) {
        if (r.children) {
          var n = u.map(r.children, t);
          r = u.extend(r, {
            children: n
          });
        }
        return e(r);
      };
    }
    function s(e, t) {
      return l(e).filter(function (e) {
        return e.type === t;
      });
    }
    function l(e) {
      var t = [];
      return c(e, function (e) {
        t.push(e);
      }), t;
    }
    function c(e, t) {
      e.children && e.children.forEach(function (e) {
        c(e, t), t(e);
      });
    }
    var u = r(1);
    t.paragraph = n, t.run = i, t._elements = o, t.getDescendantsOfType = s, t.getDescendants = l;
  }, function (e, t, r) {
    function n(e) {
      return function (t) {
        return a.elementWithTag(i.element(e), [t]);
      };
    }
    var i = r(55),
      a = r(54);
    t.element = n;
  }, function (e, t, r) {
    function n(e) {
      return e = e || {}, e.prettyPrint ? i() : a();
    }
    function i() {
      function e(e, t) {
        u[e] && l(), f.push(e), m.open(e, t), u[e] && c++, d = !1;
      }
      function t(e) {
        u[e] && (c--, l()), f.pop(), m.close(e);
      }
      function r(e) {
        s(), m.text(e.replace("\n", "\n" + h));
      }
      function n(e, t) {
        l(), m.selfClosing(e, t);
      }
      function i(e) {
        s(), m.append(e.replace("\n", "\n" + h));
      }
      function o() {
        return 0 === f.length || u[f[f.length - 1]];
      }
      function s() {
        p || (l(), p = !0);
      }
      function l() {
        if (p = !1, !d && o()) {
          m.append("\n");
          for (var e = 0; e < c; e++) m.append(h);
        }
      }
      var c = 0,
        h = "  ",
        f = [],
        d = !0,
        p = !1,
        m = a();
      return {
        asString: m.asString,
        open: e,
        close: t,
        text: r,
        selfClosing: n,
        append: i
      };
    }
    function a() {
      function e(e, t) {
        var r = n(t);
        h.push(l.format("<%s%s>", e, r));
      }
      function t(e) {
        h.push(l.format("</%s>", e));
      }
      function r(e, t) {
        var r = n(t);
        h.push(l.format("<%s%s />", e, r));
      }
      function n(e) {
        return c.map(e, function (e, t) {
          return l.format(' %s="%s"', t, s(e));
        }).join("");
      }
      function i(e) {
        h.push(o(e));
      }
      function a(e) {
        h.push(e);
      }
      function u() {
        return h.join("");
      }
      var h = [];
      return {
        asString: u,
        open: e,
        close: t,
        text: i,
        selfClosing: r,
        append: a
      };
    }
    function o(e) {
      return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function s(e) {
      return e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    var l = r(142),
      c = r(1);
    t.writer = n;
    var u = {
      div: !0,
      p: !0,
      ul: !0,
      li: !0
    };
  }, function (e, t, r) {
    function n(e) {
      return e = e || {}, "markdown" === e.outputFormat ? a.writer() : i.writer(e);
    }
    var i = r(328),
      a = r(330);
    t.writer = n;
  }, function (e, t, r) {
    function n(e) {
      return i(e, e);
    }
    function i(e, t) {
      return function () {
        return {
          start: e,
          end: t
        };
      };
    }
    function a(e) {
      var t = e.href || "";
      return t ? {
        start: "[",
        end: "](" + t + ")",
        anchorPosition: "before"
      } : {};
    }
    function o(e) {
      var t = e.src || "",
        r = e.alt || "";
      return t || r ? {
        start: "![" + r + "](" + t + ")"
      } : {};
    }
    function s(e) {
      return function (t, r) {
        return {
          start: r ? "\n" : "",
          end: r ? "" : "\n",
          list: {
            isOrdered: e.isOrdered,
            indent: r ? r.indent + 1 : 0,
            count: 0
          }
        };
      };
    }
    function l(e, t, r) {
      t = t || {
        indent: 0,
        isOrdered: !1,
        count: 0
      }, t.count++, r.hasClosed = !1;
      var n = t.isOrdered ? t.count + "." : "-";
      return {
        start: c("\t", t.indent) + n + " ",
        end: function end() {
          if (!r.hasClosed) return r.hasClosed = !0, "\n";
        }
      };
    }
    function c(e, t) {
      return new Array(t + 1).join(e);
    }
    function u() {
      function e(e, r) {
        r = r || {};
        var n = d[e] || function () {
            return {};
          },
          i = n(r, c, u);
        l.push({
          end: i.end,
          list: c
        }), i.list && (c = i.list);
        var a = "before" === i.anchorPosition;
        a && t(r), s.push(i.start || ""), a || t(r);
      }
      function t(e) {
        e.id && s.push('<a id="' + e.id + '"></a>');
      }
      function r(e) {
        var t = l.pop();
        c = t.list;
        var r = f.isFunction(t.end) ? t.end() : t.end;
        s.push(r || "");
      }
      function n(t, n) {
        e(t, n), r(t);
      }
      function i(e) {
        s.push(h(e));
      }
      function a(e) {
        s.push(e);
      }
      function o() {
        return s.join("");
      }
      var s = [],
        l = [],
        c = null,
        u = {};
      return {
        asString: o,
        open: e,
        close: r,
        text: i,
        selfClosing: n,
        append: a
      };
    }
    function h(e) {
      return e.replace(/\\/g, "\\\\").replace(/([\`\*_\{\}\[\]\(\)\#\+\-\.\!])/g, "\\$1");
    }
    var f = r(1),
      d = {
        p: i("", "\n\n"),
        br: i("", "  \n"),
        ul: s({
          isOrdered: !1
        }),
        ol: s({
          isOrdered: !0
        }),
        li: l,
        strong: n("__"),
        em: n("*"),
        a: a,
        img: o
      };
    !function () {
      for (var e = 1; e <= 6; e++) d["h" + e] = i(c("#", e) + " ", "\n\n");
    }(), t.writer = u;
  }, function (e, t, r) {
    function n(e, t) {
      function r(e) {
        if (e.uri) {
          var r = t[e.uri];
          return (r ? r + ":" : "{" + e.uri + "}") + e.local;
        }
        return e.local;
      }
      t = t || {};
      var n = !1,
        s = o.parser(!0, {
          xmlns: !0,
          position: !1
        }),
        u = {
          children: []
        },
        h = u,
        f = [],
        d = a.defer();
      return s.onopentag = function (e) {
        var t = i(e.attributes, function (e) {
            return e.value;
          }, r),
          n = new c(r(e), t);
        h.children.push(n), f.push(h), h = n;
      }, s.onclosetag = function (e) {
        h = f.pop();
      }, s.ontext = function (e) {
        h !== u && h.children.push(l.text(e));
      }, s.onend = function () {
        n || (n = !0, d.resolve(u.children[0]));
      }, s.onerror = function (e) {
        n || (n = !0, d.reject(e));
      }, s.write(e).close(), d.promise;
    }
    function i(e, t, r) {
      return s.reduce(e, function (n, i, a) {
        return n[r(i, a, e)] = t(i, a, e), n;
      }, {});
    }
    var a = r(15),
      o = r(353),
      s = r(1),
      l = r(129),
      c = l.Element;
    t.readString = n;
  }, function (e, t, r) {
    function n(e, t) {
      function r(e, t) {
        return c[t.type](e, t);
      }
      function n(e, t) {
        var n = e.element(s(t.name), t.attributes);
        t.children.forEach(function (e) {
          r(n, e);
        });
      }
      function s(e) {
        var t = /^\{(.*)\}(.*)$/.exec(e);
        if (t) {
          var r = l[t[1]];
          return r + ("" === r ? "" : ":") + t[2];
        }
        return e;
      }
      var l = a.invert(t),
        c = {
          element: n,
          text: i
        };
      return function (e) {
        var n = o.create(s(e.name), {
          version: "1.0",
          encoding: "UTF-8",
          standalone: !0
        });
        return a.forEach(t, function (e, t) {
          var r = "xmlns" + ("" === t ? "" : ":" + t);
          n.attribute(r, e);
        }), e.children.forEach(function (e) {
          r(n, e);
        }), n.end();
      }(e);
    }
    function i(e, t) {
      e.text(t.value);
    }
    var a = r(1),
      o = r(385);
    t.writeString = n;
  }, function (e, t, r) {
    (function (e) {
      function n(t) {
        function r(e) {
          return null !== l.file(e);
        }
        function n(t, r) {
          var n = l.file(t).asUint8Array(),
            i = new e(n);
          return r ? a.when(i.toString(r)) : a.when(i);
        }
        function o(e, t) {
          l.file(e, t);
        }
        function s() {
          return l.generate({
            type: "nodebuffer"
          });
        }
        var l = new i(t);
        return {
          exists: r,
          read: n,
          write: o,
          toBuffer: s
        };
      }
      var i = r(255),
        a = r(15);
      t.openArrayBuffer = n;
    }).call(t, r(14).Buffer);
  }, function (e, t) {
    function r(e) {
      return "function" == typeof e ? e() : e;
    }
    t.none = Object.create({
      value: function value() {
        throw new Error("Called value on none");
      },
      isNone: function isNone() {
        return !0;
      },
      isSome: function isSome() {
        return !1;
      },
      map: function map() {
        return t.none;
      },
      flatMap: function flatMap() {
        return t.none;
      },
      filter: function filter() {
        return t.none;
      },
      toArray: function toArray() {
        return [];
      },
      orElse: r,
      valueOrElse: r
    }), t.some = function (e) {
      return new n(e);
    };
    var n = function n(e) {
      this._value = e;
    };
    n.prototype.value = function () {
      return this._value;
    }, n.prototype.isNone = function () {
      return !1;
    }, n.prototype.isSome = function () {
      return !0;
    }, n.prototype.map = function (e) {
      return new n(e(this._value));
    }, n.prototype.flatMap = function (e) {
      return e(this._value);
    }, n.prototype.filter = function (e) {
      return e(this._value) ? this : t.none;
    }, n.prototype.toArray = function () {
      return [this._value];
    }, n.prototype.orElse = function (e) {
      return this;
    }, n.prototype.valueOrElse = function (e) {
      return this._value;
    }, t.isOption = function (e) {
      return e === t.none || e instanceof n;
    }, t.fromNullable = function (e) {
      return null == e ? t.none : new n(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(22).assign,
      i = r(336),
      a = r(337),
      o = r(132),
      s = {};
    n(s, i, a, o), e.exports = s;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!(this instanceof n)) return new n(e);
      this.options = l.assign({
        level: p,
        method: g,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: m,
        to: ""
      }, e || {});
      var t = this.options;
      t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h(), this.strm.avail_out = 0;
      var r = s.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
      if (r !== d) throw new Error(u[r]);
      if (t.header && s.deflateSetHeader(this.strm, t.header), t.dictionary) {
        var i;
        if (i = "string" == typeof t.dictionary ? c.string2buf(t.dictionary) : "[object ArrayBuffer]" === f.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = s.deflateSetDictionary(this.strm, i)) !== d) throw new Error(u[r]);
        this._dict_set = !0;
      }
    }
    function i(e, t) {
      var r = new n(t);
      if (r.push(e, !0), r.err) throw r.msg;
      return r.result;
    }
    function a(e, t) {
      return t = t || {}, t.raw = !0, i(e, t);
    }
    function o(e, t) {
      return t = t || {}, t.gzip = !0, i(e, t);
    }
    var s = r(338),
      l = r(22),
      c = r(130),
      u = r(81),
      h = r(134),
      f = Object.prototype.toString,
      d = 0,
      p = -1,
      m = 0,
      g = 8;
    n.prototype.push = function (e, t) {
      var r,
        n,
        i = this.strm,
        a = this.options.chunkSize;
      if (this.ended) return !1;
      n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = c.string2buf(e) : "[object ArrayBuffer]" === f.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
      do {
        if (0 === i.avail_out && (i.output = new l.Buf8(a), i.next_out = 0, i.avail_out = a), 1 !== (r = s.deflate(i, n)) && r !== d) return this.onEnd(r), this.ended = !0, !1;
        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(c.buf2binstring(l.shrinkBuf(i.output, i.next_out))) : this.onData(l.shrinkBuf(i.output, i.next_out)));
      } while ((i.avail_in > 0 || 0 === i.avail_out) && 1 !== r);
      return 4 === n ? (r = s.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === d) : 2 !== n || (this.onEnd(d), i.avail_out = 0, !0);
    }, n.prototype.onData = function (e) {
      this.chunks.push(e);
    }, n.prototype.onEnd = function (e) {
      e === d && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = l.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
    }, t.Deflate = n, t.deflate = i, t.deflateRaw = a, t.gzip = o;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!(this instanceof n)) return new n(e);
      this.options = s.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
      }, e || {});
      var t = this.options;
      t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new h(), this.strm.avail_out = 0;
      var r = o.inflateInit2(this.strm, t.windowBits);
      if (r !== c.Z_OK) throw new Error(u[r]);
      this.header = new f(), o.inflateGetHeader(this.strm, this.header);
    }
    function i(e, t) {
      var r = new n(t);
      if (r.push(e, !0), r.err) throw r.msg;
      return r.result;
    }
    function a(e, t) {
      return t = t || {}, t.raw = !0, i(e, t);
    }
    var o = r(341),
      s = r(22),
      l = r(130),
      c = r(132),
      u = r(81),
      h = r(134),
      f = r(339),
      d = Object.prototype.toString;
    n.prototype.push = function (e, t) {
      var r,
        n,
        i,
        a,
        u,
        h,
        f = this.strm,
        p = this.options.chunkSize,
        m = this.options.dictionary,
        g = !1;
      if (this.ended) return !1;
      n = t === ~~t ? t : !0 === t ? c.Z_FINISH : c.Z_NO_FLUSH, "string" == typeof e ? f.input = l.binstring2buf(e) : "[object ArrayBuffer]" === d.call(e) ? f.input = new Uint8Array(e) : f.input = e, f.next_in = 0, f.avail_in = f.input.length;
      do {
        if (0 === f.avail_out && (f.output = new s.Buf8(p), f.next_out = 0, f.avail_out = p), r = o.inflate(f, c.Z_NO_FLUSH), r === c.Z_NEED_DICT && m && (h = "string" == typeof m ? l.string2buf(m) : "[object ArrayBuffer]" === d.call(m) ? new Uint8Array(m) : m, r = o.inflateSetDictionary(this.strm, h)), r === c.Z_BUF_ERROR && !0 === g && (r = c.Z_OK, g = !1), r !== c.Z_STREAM_END && r !== c.Z_OK) return this.onEnd(r), this.ended = !0, !1;
        f.next_out && (0 !== f.avail_out && r !== c.Z_STREAM_END && (0 !== f.avail_in || n !== c.Z_FINISH && n !== c.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = l.utf8border(f.output, f.next_out), a = f.next_out - i, u = l.buf2string(f.output, i), f.next_out = a, f.avail_out = p - a, a && s.arraySet(f.output, f.output, i, a, 0), this.onData(u)) : this.onData(s.shrinkBuf(f.output, f.next_out)))), 0 === f.avail_in && 0 === f.avail_out && (g = !0);
      } while ((f.avail_in > 0 || 0 === f.avail_out) && r !== c.Z_STREAM_END);
      return r === c.Z_STREAM_END && (n = c.Z_FINISH), n === c.Z_FINISH ? (r = o.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === c.Z_OK) : n !== c.Z_SYNC_FLUSH || (this.onEnd(c.Z_OK), f.avail_out = 0, !0);
    }, n.prototype.onData = function (e) {
      this.chunks.push(e);
    }, n.prototype.onEnd = function (e) {
      e === c.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = s.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
    }, t.Inflate = n, t.inflate = i, t.inflateRaw = a, t.ungzip = i;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return e.msg = B[t], t;
    }
    function i(e) {
      return (e << 1) - (e > 4 ? 9 : 0);
    }
    function a(e) {
      for (var t = e.length; --t >= 0;) e[t] = 0;
    }
    function o(e) {
      var t = e.state,
        r = t.pending;
      r > e.avail_out && (r = e.avail_out), 0 !== r && (I.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
    }
    function s(e, t) {
      M._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, o(e.strm);
    }
    function l(e, t) {
      e.pending_buf[e.pending++] = t;
    }
    function c(e, t) {
      e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
    }
    function u(e, t, r, n) {
      var i = e.avail_in;
      return i > n && (i = n), 0 === i ? 0 : (e.avail_in -= i, I.arraySet(t, e.input, e.next_in, i, r), 1 === e.state.wrap ? e.adler = O(e.adler, t, i, r) : 2 === e.state.wrap && (e.adler = P(e.adler, t, i, r)), e.next_in += i, e.total_in += i, i);
    }
    function h(e, t) {
      var r,
        n,
        i = e.max_chain_length,
        a = e.strstart,
        o = e.prev_length,
        s = e.nice_match,
        l = e.strstart > e.w_size - ce ? e.strstart - (e.w_size - ce) : 0,
        c = e.window,
        u = e.w_mask,
        h = e.prev,
        f = e.strstart + le,
        d = c[a + o - 1],
        p = c[a + o];
      e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);
      do {
        if (r = t, c[r + o] === p && c[r + o - 1] === d && c[r] === c[a] && c[++r] === c[a + 1]) {
          a += 2, r++;
          do {} while (c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && a < f);
          if (n = le - (f - a), a = f - le, n > o) {
            if (e.match_start = t, o = n, n >= s) break;
            d = c[a + o - 1], p = c[a + o];
          }
        }
      } while ((t = h[t & u]) > l && 0 != --i);
      return o <= e.lookahead ? o : e.lookahead;
    }
    function f(e) {
      var t,
        r,
        n,
        i,
        a,
        o = e.w_size;
      do {
        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= o + (o - ce)) {
          I.arraySet(e.window, e.window, o, o, 0), e.match_start -= o, e.strstart -= o, e.block_start -= o, r = e.hash_size, t = r;
          do {
            n = e.head[--t], e.head[t] = n >= o ? n - o : 0;
          } while (--r);
          r = o, t = r;
          do {
            n = e.prev[--t], e.prev[t] = n >= o ? n - o : 0;
          } while (--r);
          i += o;
        }
        if (0 === e.strm.avail_in) break;
        if (r = u(e.strm, e.window, e.strstart + e.lookahead, i), e.lookahead += r, e.lookahead + e.insert >= se) for (a = e.strstart - e.insert, e.ins_h = e.window[a], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + se - 1]) & e.hash_mask, e.prev[a & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = a, a++, e.insert--, !(e.lookahead + e.insert < se)););
      } while (e.lookahead < ce && 0 !== e.strm.avail_in);
    }
    function d(e, t) {
      var r = 65535;
      for (r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;) {
        if (e.lookahead <= 1) {
          if (f(e), 0 === e.lookahead && t === D) return be;
          if (0 === e.lookahead) break;
        }
        e.strstart += e.lookahead, e.lookahead = 0;
        var n = e.block_start + r;
        if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, s(e, !1), 0 === e.strm.avail_out)) return be;
        if (e.strstart - e.block_start >= e.w_size - ce && (s(e, !1), 0 === e.strm.avail_out)) return be;
      }
      return e.insert = 0, t === N ? (s(e, !0), 0 === e.strm.avail_out ? we : xe) : (e.strstart > e.block_start && (s(e, !1), e.strm.avail_out), be);
    }
    function p(e, t) {
      for (var r, n;;) {
        if (e.lookahead < ce) {
          if (f(e), e.lookahead < ce && t === D) return be;
          if (0 === e.lookahead) break;
        }
        if (r = 0, e.lookahead >= se && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + se - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - ce && (e.match_length = h(e, r)), e.match_length >= se) {
          if (n = M._tr_tally(e, e.strstart - e.match_start, e.match_length - se), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= se) {
            e.match_length--;
            do {
              e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + se - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
            } while (0 != --e.match_length);
            e.strstart++;
          } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
        } else n = M._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
        if (n && (s(e, !1), 0 === e.strm.avail_out)) return be;
      }
      return e.insert = e.strstart < se - 1 ? e.strstart : se - 1, t === N ? (s(e, !0), 0 === e.strm.avail_out ? we : xe) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? be : ye;
    }
    function m(e, t) {
      for (var r, n, i;;) {
        if (e.lookahead < ce) {
          if (f(e), e.lookahead < ce && t === D) return be;
          if (0 === e.lookahead) break;
        }
        if (r = 0, e.lookahead >= se && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + se - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = se - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - ce && (e.match_length = h(e, r), e.match_length <= 5 && (e.strategy === W || e.match_length === se && e.strstart - e.match_start > 4096) && (e.match_length = se - 1)), e.prev_length >= se && e.match_length <= e.prev_length) {
          i = e.strstart + e.lookahead - se, n = M._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - se), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
          do {
            ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + se - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
          } while (0 != --e.prev_length);
          if (e.match_available = 0, e.match_length = se - 1, e.strstart++, n && (s(e, !1), 0 === e.strm.avail_out)) return be;
        } else if (e.match_available) {
          if (n = M._tr_tally(e, 0, e.window[e.strstart - 1]), n && s(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return be;
        } else e.match_available = 1, e.strstart++, e.lookahead--;
      }
      return e.match_available && (n = M._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < se - 1 ? e.strstart : se - 1, t === N ? (s(e, !0), 0 === e.strm.avail_out ? we : xe) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? be : ye;
    }
    function g(e, t) {
      for (var r, n, i, a, o = e.window;;) {
        if (e.lookahead <= le) {
          if (f(e), e.lookahead <= le && t === D) return be;
          if (0 === e.lookahead) break;
        }
        if (e.match_length = 0, e.lookahead >= se && e.strstart > 0 && (i = e.strstart - 1, (n = o[i]) === o[++i] && n === o[++i] && n === o[++i])) {
          a = e.strstart + le;
          do {} while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
          e.match_length = le - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
        }
        if (e.match_length >= se ? (r = M._tr_tally(e, 1, e.match_length - se), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = M._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (s(e, !1), 0 === e.strm.avail_out)) return be;
      }
      return e.insert = 0, t === N ? (s(e, !0), 0 === e.strm.avail_out ? we : xe) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? be : ye;
    }
    function v(e, t) {
      for (var r;;) {
        if (0 === e.lookahead && (f(e), 0 === e.lookahead)) {
          if (t === D) return be;
          break;
        }
        if (e.match_length = 0, r = M._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (s(e, !1), 0 === e.strm.avail_out)) return be;
      }
      return e.insert = 0, t === N ? (s(e, !0), 0 === e.strm.avail_out ? we : xe) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? be : ye;
    }
    function b(e, t, r, n, i) {
      this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
    }
    function y(e) {
      e.window_size = 2 * e.w_size, a(e.head), e.max_lazy_match = R[e.level].max_lazy, e.good_match = R[e.level].good_length, e.nice_match = R[e.level].nice_length, e.max_chain_length = R[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = se - 1, e.match_available = 0, e.ins_h = 0;
    }
    function w() {
      this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Q, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new I.Buf16(2 * ae), this.dyn_dtree = new I.Buf16(2 * (2 * ne + 1)), this.bl_tree = new I.Buf16(2 * (2 * ie + 1)), a(this.dyn_ltree), a(this.dyn_dtree), a(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new I.Buf16(oe + 1), this.heap = new I.Buf16(2 * re + 1), a(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new I.Buf16(2 * re + 1), a(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
    }
    function x(e) {
      var t;
      return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = J, t = e.state, t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? he : ge, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = D, M._tr_init(t), j) : n(e, H);
    }
    function _(e) {
      var t = x(e);
      return t === j && y(e.state), t;
    }
    function S(e, t) {
      return e && e.state ? 2 !== e.state.wrap ? H : (e.state.gzhead = t, j) : H;
    }
    function C(e, t, r, i, a, o) {
      if (!e) return H;
      var s = 1;
      if (t === q && (t = 6), i < 0 ? (s = 0, i = -i) : i > 15 && (s = 2, i -= 16), a < 1 || a > $ || r !== Q || i < 8 || i > 15 || t < 0 || t > 9 || o < 0 || o > K) return n(e, H);
      8 === i && (i = 9);
      var l = new w();
      return e.state = l, l.strm = e, l.wrap = s, l.gzhead = null, l.w_bits = i, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = a + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + se - 1) / se), l.window = new I.Buf8(2 * l.w_size), l.head = new I.Buf16(l.hash_size), l.prev = new I.Buf16(l.w_size), l.lit_bufsize = 1 << a + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new I.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, _(e);
    }
    function E(e, t) {
      return C(e, t, Q, ee, te, Z);
    }
    function A(e, t) {
      var r, s, u, h;
      if (!e || !e.state || t > U || t < 0) return e ? n(e, H) : H;
      if (s = e.state, !e.output || !e.input && 0 !== e.avail_in || s.status === ve && t !== N) return n(e, 0 === e.avail_out ? V : H);
      if (s.strm = e, r = s.last_flush, s.last_flush = t, s.status === he) if (2 === s.wrap) e.adler = 0, l(s, 31), l(s, 139), l(s, 8), s.gzhead ? (l(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (s.gzhead.extra ? 4 : 0) + (s.gzhead.name ? 8 : 0) + (s.gzhead.comment ? 16 : 0)), l(s, 255 & s.gzhead.time), l(s, s.gzhead.time >> 8 & 255), l(s, s.gzhead.time >> 16 & 255), l(s, s.gzhead.time >> 24 & 255), l(s, 9 === s.level ? 2 : s.strategy >= X || s.level < 2 ? 4 : 0), l(s, 255 & s.gzhead.os), s.gzhead.extra && s.gzhead.extra.length && (l(s, 255 & s.gzhead.extra.length), l(s, s.gzhead.extra.length >> 8 & 255)), s.gzhead.hcrc && (e.adler = P(e.adler, s.pending_buf, s.pending, 0)), s.gzindex = 0, s.status = fe) : (l(s, 0), l(s, 0), l(s, 0), l(s, 0), l(s, 0), l(s, 9 === s.level ? 2 : s.strategy >= X || s.level < 2 ? 4 : 0), l(s, _e), s.status = ge);else {
        var f = Q + (s.w_bits - 8 << 4) << 8,
          d = -1;
        d = s.strategy >= X || s.level < 2 ? 0 : s.level < 6 ? 1 : 6 === s.level ? 2 : 3, f |= d << 6, 0 !== s.strstart && (f |= ue), f += 31 - f % 31, s.status = ge, c(s, f), 0 !== s.strstart && (c(s, e.adler >>> 16), c(s, 65535 & e.adler)), e.adler = 1;
      }
      if (s.status === fe) if (s.gzhead.extra) {
        for (u = s.pending; s.gzindex < (65535 & s.gzhead.extra.length) && (s.pending !== s.pending_buf_size || (s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending !== s.pending_buf_size));) l(s, 255 & s.gzhead.extra[s.gzindex]), s.gzindex++;
        s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), s.gzindex === s.gzhead.extra.length && (s.gzindex = 0, s.status = de);
      } else s.status = de;
      if (s.status === de) if (s.gzhead.name) {
        u = s.pending;
        do {
          if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending === s.pending_buf_size)) {
            h = 1;
            break;
          }
          h = s.gzindex < s.gzhead.name.length ? 255 & s.gzhead.name.charCodeAt(s.gzindex++) : 0, l(s, h);
        } while (0 !== h);
        s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), 0 === h && (s.gzindex = 0, s.status = pe);
      } else s.status = pe;
      if (s.status === pe) if (s.gzhead.comment) {
        u = s.pending;
        do {
          if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending === s.pending_buf_size)) {
            h = 1;
            break;
          }
          h = s.gzindex < s.gzhead.comment.length ? 255 & s.gzhead.comment.charCodeAt(s.gzindex++) : 0, l(s, h);
        } while (0 !== h);
        s.gzhead.hcrc && s.pending > u && (e.adler = P(e.adler, s.pending_buf, s.pending - u, u)), 0 === h && (s.status = me);
      } else s.status = me;
      if (s.status === me && (s.gzhead.hcrc ? (s.pending + 2 > s.pending_buf_size && o(e), s.pending + 2 <= s.pending_buf_size && (l(s, 255 & e.adler), l(s, e.adler >> 8 & 255), e.adler = 0, s.status = ge)) : s.status = ge), 0 !== s.pending) {
        if (o(e), 0 === e.avail_out) return s.last_flush = -1, j;
      } else if (0 === e.avail_in && i(t) <= i(r) && t !== N) return n(e, V);
      if (s.status === ve && 0 !== e.avail_in) return n(e, V);
      if (0 !== e.avail_in || 0 !== s.lookahead || t !== D && s.status !== ve) {
        var p = s.strategy === X ? v(s, t) : s.strategy === Y ? g(s, t) : R[s.level].func(s, t);
        if (p !== we && p !== xe || (s.status = ve), p === be || p === we) return 0 === e.avail_out && (s.last_flush = -1), j;
        if (p === ye && (t === L ? M._tr_align(s) : t !== U && (M._tr_stored_block(s, 0, 0, !1), t === F && (a(s.head), 0 === s.lookahead && (s.strstart = 0, s.block_start = 0, s.insert = 0))), o(e), 0 === e.avail_out)) return s.last_flush = -1, j;
      }
      return t !== N ? j : s.wrap <= 0 ? z : (2 === s.wrap ? (l(s, 255 & e.adler), l(s, e.adler >> 8 & 255), l(s, e.adler >> 16 & 255), l(s, e.adler >> 24 & 255), l(s, 255 & e.total_in), l(s, e.total_in >> 8 & 255), l(s, e.total_in >> 16 & 255), l(s, e.total_in >> 24 & 255)) : (c(s, e.adler >>> 16), c(s, 65535 & e.adler)), o(e), s.wrap > 0 && (s.wrap = -s.wrap), 0 !== s.pending ? j : z);
    }
    function T(e) {
      var t;
      return e && e.state ? (t = e.state.status) !== he && t !== fe && t !== de && t !== pe && t !== me && t !== ge && t !== ve ? n(e, H) : (e.state = null, t === ge ? n(e, G) : j) : H;
    }
    function k(e, t) {
      var r,
        n,
        i,
        o,
        s,
        l,
        c,
        u,
        h = t.length;
      if (!e || !e.state) return H;
      if (r = e.state, 2 === (o = r.wrap) || 1 === o && r.status !== he || r.lookahead) return H;
      for (1 === o && (e.adler = O(e.adler, t, h, 0)), r.wrap = 0, h >= r.w_size && (0 === o && (a(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new I.Buf8(r.w_size), I.arraySet(u, t, h - r.w_size, r.w_size, 0), t = u, h = r.w_size), s = e.avail_in, l = e.next_in, c = e.input, e.avail_in = h, e.next_in = 0, e.input = t, f(r); r.lookahead >= se;) {
        n = r.strstart, i = r.lookahead - (se - 1);
        do {
          r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + se - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++;
        } while (--i);
        r.strstart = n, r.lookahead = se - 1, f(r);
      }
      return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = se - 1, r.match_available = 0, e.next_in = l, e.input = c, e.avail_in = s, r.wrap = o, j;
    }
    var R,
      I = r(22),
      M = r(343),
      O = r(131),
      P = r(133),
      B = r(81),
      D = 0,
      L = 1,
      F = 3,
      N = 4,
      U = 5,
      j = 0,
      z = 1,
      H = -2,
      G = -3,
      V = -5,
      q = -1,
      W = 1,
      X = 2,
      Y = 3,
      K = 4,
      Z = 0,
      J = 2,
      Q = 8,
      $ = 9,
      ee = 15,
      te = 8,
      re = 286,
      ne = 30,
      ie = 19,
      ae = 2 * re + 1,
      oe = 15,
      se = 3,
      le = 258,
      ce = le + se + 1,
      ue = 32,
      he = 42,
      fe = 69,
      de = 73,
      pe = 91,
      me = 103,
      ge = 113,
      ve = 666,
      be = 1,
      ye = 2,
      we = 3,
      xe = 4,
      _e = 3;
    R = [new b(0, 0, 0, 0, d), new b(4, 4, 8, 4, p), new b(4, 5, 16, 8, p), new b(4, 6, 32, 32, p), new b(4, 4, 16, 16, m), new b(8, 16, 32, 32, m), new b(8, 16, 128, 128, m), new b(8, 32, 128, 256, m), new b(32, 128, 258, 1024, m), new b(32, 258, 258, 4096, m)], t.deflateInit = E, t.deflateInit2 = C, t.deflateReset = _, t.deflateResetKeep = x, t.deflateSetHeader = S, t.deflate = A, t.deflateEnd = T, t.deflateSetDictionary = k, t.deflateInfo = "pako deflate (from Nodeca project)";
  }, function (e, t, r) {
    "use strict";

    function n() {
      this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
    }
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      var r, n, i, a, o, s, l, c, u, h, f, d, p, m, g, v, b, y, w, x, _, S, C, E, A;
      r = e.state, n = e.next_in, E = e.input, i = n + (e.avail_in - 5), a = e.next_out, A = e.output, o = a - (t - e.avail_out), s = a + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, g = r.distcode, v = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
      e: do {
        p < 15 && (d += E[n++] << p, p += 8, d += E[n++] << p, p += 8), y = m[d & v];
        t: for (;;) {
          if (w = y >>> 24, d >>>= w, p -= w, 0 === (w = y >>> 16 & 255)) A[a++] = 65535 & y;else {
            if (!(16 & w)) {
              if (0 == (64 & w)) {
                y = m[(65535 & y) + (d & (1 << w) - 1)];
                continue t;
              }
              if (32 & w) {
                r.mode = 12;
                break e;
              }
              e.msg = "invalid literal/length code", r.mode = 30;
              break e;
            }
            x = 65535 & y, w &= 15, w && (p < w && (d += E[n++] << p, p += 8), x += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += E[n++] << p, p += 8, d += E[n++] << p, p += 8), y = g[d & b];
            r: for (;;) {
              if (w = y >>> 24, d >>>= w, p -= w, !(16 & (w = y >>> 16 & 255))) {
                if (0 == (64 & w)) {
                  y = g[(65535 & y) + (d & (1 << w) - 1)];
                  continue r;
                }
                e.msg = "invalid distance code", r.mode = 30;
                break e;
              }
              if (_ = 65535 & y, w &= 15, p < w && (d += E[n++] << p, (p += 8) < w && (d += E[n++] << p, p += 8)), (_ += d & (1 << w) - 1) > l) {
                e.msg = "invalid distance too far back", r.mode = 30;
                break e;
              }
              if (d >>>= w, p -= w, w = a - o, _ > w) {
                if ((w = _ - w) > u && r.sane) {
                  e.msg = "invalid distance too far back", r.mode = 30;
                  break e;
                }
                if (S = 0, C = f, 0 === h) {
                  if (S += c - w, w < x) {
                    x -= w;
                    do {
                      A[a++] = f[S++];
                    } while (--w);
                    S = a - _, C = A;
                  }
                } else if (h < w) {
                  if (S += c + h - w, (w -= h) < x) {
                    x -= w;
                    do {
                      A[a++] = f[S++];
                    } while (--w);
                    if (S = 0, h < x) {
                      w = h, x -= w;
                      do {
                        A[a++] = f[S++];
                      } while (--w);
                      S = a - _, C = A;
                    }
                  }
                } else if (S += h - w, w < x) {
                  x -= w;
                  do {
                    A[a++] = f[S++];
                  } while (--w);
                  S = a - _, C = A;
                }
                for (; x > 2;) A[a++] = C[S++], A[a++] = C[S++], A[a++] = C[S++], x -= 3;
                x && (A[a++] = C[S++], x > 1 && (A[a++] = C[S++]));
              } else {
                S = a - _;
                do {
                  A[a++] = A[S++], A[a++] = A[S++], A[a++] = A[S++], x -= 3;
                } while (x > 2);
                x && (A[a++] = A[S++], x > 1 && (A[a++] = A[S++]));
              }
              break;
            }
          }
          break;
        }
      } while (n < i && a < s);
      x = p >> 3, n -= x, p -= x << 3, d &= (1 << p) - 1, e.next_in = n, e.next_out = a, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = a < s ? s - a + 257 : 257 - (a - s), r.hold = d, r.bits = p;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
    }
    function i() {
      this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new b.Buf16(320), this.work = new b.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
    }
    function a(e) {
      var t;
      return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = F, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new b.Buf32(me), t.distcode = t.distdyn = new b.Buf32(ge), t.sane = 1, t.back = -1, R) : O;
    }
    function o(e) {
      var t;
      return e && e.state ? (t = e.state, t.wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : O;
    }
    function s(e, t) {
      var r, n;
      return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? O : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : O;
    }
    function l(e, t) {
      var r, n;
      return e ? (n = new i(), e.state = n, n.window = null, r = s(e, t), r !== R && (e.state = null), r) : O;
    }
    function c(e) {
      return l(e, ve);
    }
    function u(e) {
      if (be) {
        var t;
        for (g = new b.Buf32(512), v = new b.Buf32(32), t = 0; t < 144;) e.lens[t++] = 8;
        for (; t < 256;) e.lens[t++] = 9;
        for (; t < 280;) e.lens[t++] = 7;
        for (; t < 288;) e.lens[t++] = 8;
        for (_(C, e.lens, 0, 288, g, 0, e.work, {
          bits: 9
        }), t = 0; t < 32;) e.lens[t++] = 5;
        _(E, e.lens, 0, 32, v, 0, e.work, {
          bits: 5
        }), be = !1;
      }
      e.lencode = g, e.lenbits = 9, e.distcode = v, e.distbits = 5;
    }
    function h(e, t, r, n) {
      var i,
        a = e.state;
      return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new b.Buf8(a.wsize)), n >= a.wsize ? (b.arraySet(a.window, t, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), b.arraySet(a.window, t, r - n, i, a.wnext), n -= i, n ? (b.arraySet(a.window, t, r - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
    }
    function f(e, t) {
      var r,
        i,
        a,
        o,
        s,
        l,
        c,
        f,
        d,
        p,
        m,
        g,
        v,
        me,
        ge,
        ve,
        be,
        ye,
        we,
        xe,
        _e,
        Se,
        Ce,
        Ee,
        Ae = 0,
        Te = new b.Buf8(4),
        ke = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return O;
      r = e.state, r.mode === Y && (r.mode = K), s = e.next_out, a = e.output, c = e.avail_out, o = e.next_in, i = e.input, l = e.avail_in, f = r.hold, d = r.bits, p = l, m = c, Se = R;
      e: for (;;) switch (r.mode) {
        case F:
          if (0 === r.wrap) {
            r.mode = K;
            break;
          }
          for (; d < 16;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if (2 & r.wrap && 35615 === f) {
            r.check = 0, Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = w(r.check, Te, 2, 0), f = 0, d = 0, r.mode = N;
            break;
          }
          if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & f) << 8) + (f >> 8)) % 31) {
            e.msg = "incorrect header check", r.mode = fe;
            break;
          }
          if ((15 & f) !== L) {
            e.msg = "unknown compression method", r.mode = fe;
            break;
          }
          if (f >>>= 4, d -= 4, _e = 8 + (15 & f), 0 === r.wbits) r.wbits = _e;else if (_e > r.wbits) {
            e.msg = "invalid window size", r.mode = fe;
            break;
          }
          r.dmax = 1 << _e, e.adler = r.check = 1, r.mode = 512 & f ? W : Y, f = 0, d = 0;
          break;
        case N:
          for (; d < 16;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if (r.flags = f, (255 & r.flags) !== L) {
            e.msg = "unknown compression method", r.mode = fe;
            break;
          }
          if (57344 & r.flags) {
            e.msg = "unknown header flags set", r.mode = fe;
            break;
          }
          r.head && (r.head.text = f >> 8 & 1), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = w(r.check, Te, 2, 0)), f = 0, d = 0, r.mode = U;
        case U:
          for (; d < 32;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          r.head && (r.head.time = f), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, Te[2] = f >>> 16 & 255, Te[3] = f >>> 24 & 255, r.check = w(r.check, Te, 4, 0)), f = 0, d = 0, r.mode = j;
        case j:
          for (; d < 16;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          r.head && (r.head.xflags = 255 & f, r.head.os = f >> 8), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = w(r.check, Te, 2, 0)), f = 0, d = 0, r.mode = z;
        case z:
          if (1024 & r.flags) {
            for (; d < 16;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            r.length = f, r.head && (r.head.extra_len = f), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = w(r.check, Te, 2, 0)), f = 0, d = 0;
          } else r.head && (r.head.extra = null);
          r.mode = H;
        case H:
          if (1024 & r.flags && (g = r.length, g > l && (g = l), g && (r.head && (_e = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), b.arraySet(r.head.extra, i, o, g, _e)), 512 & r.flags && (r.check = w(r.check, i, g, o)), l -= g, o += g, r.length -= g), r.length)) break e;
          r.length = 0, r.mode = G;
        case G:
          if (2048 & r.flags) {
            if (0 === l) break e;
            g = 0;
            do {
              _e = i[o + g++], r.head && _e && r.length < 65536 && (r.head.name += String.fromCharCode(_e));
            } while (_e && g < l);
            if (512 & r.flags && (r.check = w(r.check, i, g, o)), l -= g, o += g, _e) break e;
          } else r.head && (r.head.name = null);
          r.length = 0, r.mode = V;
        case V:
          if (4096 & r.flags) {
            if (0 === l) break e;
            g = 0;
            do {
              _e = i[o + g++], r.head && _e && r.length < 65536 && (r.head.comment += String.fromCharCode(_e));
            } while (_e && g < l);
            if (512 & r.flags && (r.check = w(r.check, i, g, o)), l -= g, o += g, _e) break e;
          } else r.head && (r.head.comment = null);
          r.mode = q;
        case q:
          if (512 & r.flags) {
            for (; d < 16;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            if (f !== (65535 & r.check)) {
              e.msg = "header crc mismatch", r.mode = fe;
              break;
            }
            f = 0, d = 0;
          }
          r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = Y;
          break;
        case W:
          for (; d < 32;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          e.adler = r.check = n(f), f = 0, d = 0, r.mode = X;
        case X:
          if (0 === r.havedict) return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, M;
          e.adler = r.check = 1, r.mode = Y;
        case Y:
          if (t === T || t === k) break e;
        case K:
          if (r.last) {
            f >>>= 7 & d, d -= 7 & d, r.mode = ce;
            break;
          }
          for (; d < 3;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          switch (r.last = 1 & f, f >>>= 1, d -= 1, 3 & f) {
            case 0:
              r.mode = Z;
              break;
            case 1:
              if (u(r), r.mode = re, t === k) {
                f >>>= 2, d -= 2;
                break e;
              }
              break;
            case 2:
              r.mode = $;
              break;
            case 3:
              e.msg = "invalid block type", r.mode = fe;
          }
          f >>>= 2, d -= 2;
          break;
        case Z:
          for (f >>>= 7 & d, d -= 7 & d; d < 32;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if ((65535 & f) != (f >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", r.mode = fe;
            break;
          }
          if (r.length = 65535 & f, f = 0, d = 0, r.mode = J, t === k) break e;
        case J:
          r.mode = Q;
        case Q:
          if (g = r.length) {
            if (g > l && (g = l), g > c && (g = c), 0 === g) break e;
            b.arraySet(a, i, o, g, s), l -= g, o += g, c -= g, s += g, r.length -= g;
            break;
          }
          r.mode = Y;
          break;
        case $:
          for (; d < 14;) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if (r.nlen = 257 + (31 & f), f >>>= 5, d -= 5, r.ndist = 1 + (31 & f), f >>>= 5, d -= 5, r.ncode = 4 + (15 & f), f >>>= 4, d -= 4, r.nlen > 286 || r.ndist > 30) {
            e.msg = "too many length or distance symbols", r.mode = fe;
            break;
          }
          r.have = 0, r.mode = ee;
        case ee:
          for (; r.have < r.ncode;) {
            for (; d < 3;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            r.lens[ke[r.have++]] = 7 & f, f >>>= 3, d -= 3;
          }
          for (; r.have < 19;) r.lens[ke[r.have++]] = 0;
          if (r.lencode = r.lendyn, r.lenbits = 7, Ce = {
            bits: r.lenbits
          }, Se = _(S, r.lens, 0, 19, r.lencode, 0, r.work, Ce), r.lenbits = Ce.bits, Se) {
            e.msg = "invalid code lengths set", r.mode = fe;
            break;
          }
          r.have = 0, r.mode = te;
        case te:
          for (; r.have < r.nlen + r.ndist;) {
            for (; Ae = r.lencode[f & (1 << r.lenbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            if (be < 16) f >>>= ge, d -= ge, r.lens[r.have++] = be;else {
              if (16 === be) {
                for (Ee = ge + 2; d < Ee;) {
                  if (0 === l) break e;
                  l--, f += i[o++] << d, d += 8;
                }
                if (f >>>= ge, d -= ge, 0 === r.have) {
                  e.msg = "invalid bit length repeat", r.mode = fe;
                  break;
                }
                _e = r.lens[r.have - 1], g = 3 + (3 & f), f >>>= 2, d -= 2;
              } else if (17 === be) {
                for (Ee = ge + 3; d < Ee;) {
                  if (0 === l) break e;
                  l--, f += i[o++] << d, d += 8;
                }
                f >>>= ge, d -= ge, _e = 0, g = 3 + (7 & f), f >>>= 3, d -= 3;
              } else {
                for (Ee = ge + 7; d < Ee;) {
                  if (0 === l) break e;
                  l--, f += i[o++] << d, d += 8;
                }
                f >>>= ge, d -= ge, _e = 0, g = 11 + (127 & f), f >>>= 7, d -= 7;
              }
              if (r.have + g > r.nlen + r.ndist) {
                e.msg = "invalid bit length repeat", r.mode = fe;
                break;
              }
              for (; g--;) r.lens[r.have++] = _e;
            }
          }
          if (r.mode === fe) break;
          if (0 === r.lens[256]) {
            e.msg = "invalid code -- missing end-of-block", r.mode = fe;
            break;
          }
          if (r.lenbits = 9, Ce = {
            bits: r.lenbits
          }, Se = _(C, r.lens, 0, r.nlen, r.lencode, 0, r.work, Ce), r.lenbits = Ce.bits, Se) {
            e.msg = "invalid literal/lengths set", r.mode = fe;
            break;
          }
          if (r.distbits = 6, r.distcode = r.distdyn, Ce = {
            bits: r.distbits
          }, Se = _(E, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, Ce), r.distbits = Ce.bits, Se) {
            e.msg = "invalid distances set", r.mode = fe;
            break;
          }
          if (r.mode = re, t === k) break e;
        case re:
          r.mode = ne;
        case ne:
          if (l >= 6 && c >= 258) {
            e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, x(e, m), s = e.next_out, a = e.output, c = e.avail_out, o = e.next_in, i = e.input, l = e.avail_in, f = r.hold, d = r.bits, r.mode === Y && (r.back = -1);
            break;
          }
          for (r.back = 0; Ae = r.lencode[f & (1 << r.lenbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if (ve && 0 == (240 & ve)) {
            for (ye = ge, we = ve, xe = be; Ae = r.lencode[xe + ((f & (1 << ye + we) - 1) >> ye)], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ye + ge <= d);) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            f >>>= ye, d -= ye, r.back += ye;
          }
          if (f >>>= ge, d -= ge, r.back += ge, r.length = be, 0 === ve) {
            r.mode = le;
            break;
          }
          if (32 & ve) {
            r.back = -1, r.mode = Y;
            break;
          }
          if (64 & ve) {
            e.msg = "invalid literal/length code", r.mode = fe;
            break;
          }
          r.extra = 15 & ve, r.mode = ie;
        case ie:
          if (r.extra) {
            for (Ee = r.extra; d < Ee;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            r.length += f & (1 << r.extra) - 1, f >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          r.was = r.length, r.mode = ae;
        case ae:
          for (; Ae = r.distcode[f & (1 << r.distbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
            if (0 === l) break e;
            l--, f += i[o++] << d, d += 8;
          }
          if (0 == (240 & ve)) {
            for (ye = ge, we = ve, xe = be; Ae = r.distcode[xe + ((f & (1 << ye + we) - 1) >> ye)], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ye + ge <= d);) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            f >>>= ye, d -= ye, r.back += ye;
          }
          if (f >>>= ge, d -= ge, r.back += ge, 64 & ve) {
            e.msg = "invalid distance code", r.mode = fe;
            break;
          }
          r.offset = be, r.extra = 15 & ve, r.mode = oe;
        case oe:
          if (r.extra) {
            for (Ee = r.extra; d < Ee;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            r.offset += f & (1 << r.extra) - 1, f >>>= r.extra, d -= r.extra, r.back += r.extra;
          }
          if (r.offset > r.dmax) {
            e.msg = "invalid distance too far back", r.mode = fe;
            break;
          }
          r.mode = se;
        case se:
          if (0 === c) break e;
          if (g = m - c, r.offset > g) {
            if ((g = r.offset - g) > r.whave && r.sane) {
              e.msg = "invalid distance too far back", r.mode = fe;
              break;
            }
            g > r.wnext ? (g -= r.wnext, v = r.wsize - g) : v = r.wnext - g, g > r.length && (g = r.length), me = r.window;
          } else me = a, v = s - r.offset, g = r.length;
          g > c && (g = c), c -= g, r.length -= g;
          do {
            a[s++] = me[v++];
          } while (--g);
          0 === r.length && (r.mode = ne);
          break;
        case le:
          if (0 === c) break e;
          a[s++] = r.length, c--, r.mode = ne;
          break;
        case ce:
          if (r.wrap) {
            for (; d < 32;) {
              if (0 === l) break e;
              l--, f |= i[o++] << d, d += 8;
            }
            if (m -= c, e.total_out += m, r.total += m, m && (e.adler = r.check = r.flags ? w(r.check, a, m, s - m) : y(r.check, a, m, s - m)), m = c, (r.flags ? f : n(f)) !== r.check) {
              e.msg = "incorrect data check", r.mode = fe;
              break;
            }
            f = 0, d = 0;
          }
          r.mode = ue;
        case ue:
          if (r.wrap && r.flags) {
            for (; d < 32;) {
              if (0 === l) break e;
              l--, f += i[o++] << d, d += 8;
            }
            if (f !== (4294967295 & r.total)) {
              e.msg = "incorrect length check", r.mode = fe;
              break;
            }
            f = 0, d = 0;
          }
          r.mode = he;
        case he:
          Se = I;
          break e;
        case fe:
          Se = P;
          break e;
        case de:
          return B;
        case pe:
        default:
          return O;
      }
      return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, (r.wsize || m !== e.avail_out && r.mode < fe && (r.mode < ce || t !== A)) && h(e, e.output, e.next_out, m - e.avail_out) ? (r.mode = de, B) : (p -= e.avail_in, m -= e.avail_out, e.total_in += p, e.total_out += m, r.total += m, r.wrap && m && (e.adler = r.check = r.flags ? w(r.check, a, m, e.next_out - m) : y(r.check, a, m, e.next_out - m)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === Y ? 128 : 0) + (r.mode === re || r.mode === J ? 256 : 0), (0 === p && 0 === m || t === A) && Se === R && (Se = D), Se);
    }
    function d(e) {
      if (!e || !e.state) return O;
      var t = e.state;
      return t.window && (t.window = null), e.state = null, R;
    }
    function p(e, t) {
      var r;
      return e && e.state ? (r = e.state, 0 == (2 & r.wrap) ? O : (r.head = t, t.done = !1, R)) : O;
    }
    function m(e, t) {
      var r,
        n,
        i = t.length;
      return e && e.state ? (r = e.state, 0 !== r.wrap && r.mode !== X ? O : r.mode === X && (n = 1, (n = y(n, t, i, 0)) !== r.check) ? P : h(e, t, i, i) ? (r.mode = de, B) : (r.havedict = 1, R)) : O;
    }
    var g,
      v,
      b = r(22),
      y = r(131),
      w = r(133),
      x = r(340),
      _ = r(342),
      S = 0,
      C = 1,
      E = 2,
      A = 4,
      T = 5,
      k = 6,
      R = 0,
      I = 1,
      M = 2,
      O = -2,
      P = -3,
      B = -4,
      D = -5,
      L = 8,
      F = 1,
      N = 2,
      U = 3,
      j = 4,
      z = 5,
      H = 6,
      G = 7,
      V = 8,
      q = 9,
      W = 10,
      X = 11,
      Y = 12,
      K = 13,
      Z = 14,
      J = 15,
      Q = 16,
      $ = 17,
      ee = 18,
      te = 19,
      re = 20,
      ne = 21,
      ie = 22,
      ae = 23,
      oe = 24,
      se = 25,
      le = 26,
      ce = 27,
      ue = 28,
      he = 29,
      fe = 30,
      de = 31,
      pe = 32,
      me = 852,
      ge = 592,
      ve = 15,
      be = !0;
    t.inflateReset = o, t.inflateReset2 = s, t.inflateResetKeep = a, t.inflateInit = c, t.inflateInit2 = l, t.inflate = f, t.inflateEnd = d, t.inflateGetHeader = p, t.inflateSetDictionary = m, t.inflateInfo = "pako inflate (from Nodeca project)";
  }, function (e, t, r) {
    "use strict";

    var n = r(22),
      i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
      a = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
      o = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
      s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
    e.exports = function (e, t, r, l, c, u, h, f) {
      var d,
        p,
        m,
        g,
        v,
        b,
        y,
        w,
        x,
        _ = f.bits,
        S = 0,
        C = 0,
        E = 0,
        A = 0,
        T = 0,
        k = 0,
        R = 0,
        I = 0,
        M = 0,
        O = 0,
        P = null,
        B = 0,
        D = new n.Buf16(16),
        L = new n.Buf16(16),
        F = null,
        N = 0;
      for (S = 0; S <= 15; S++) D[S] = 0;
      for (C = 0; C < l; C++) D[t[r + C]]++;
      for (T = _, A = 15; A >= 1 && 0 === D[A]; A--);
      if (T > A && (T = A), 0 === A) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
      for (E = 1; E < A && 0 === D[E]; E++);
      for (T < E && (T = E), I = 1, S = 1; S <= 15; S++) if (I <<= 1, (I -= D[S]) < 0) return -1;
      if (I > 0 && (0 === e || 1 !== A)) return -1;
      for (L[1] = 0, S = 1; S < 15; S++) L[S + 1] = L[S] + D[S];
      for (C = 0; C < l; C++) 0 !== t[r + C] && (h[L[t[r + C]]++] = C);
      if (0 === e ? (P = F = h, b = 19) : 1 === e ? (P = i, B -= 257, F = a, N -= 257, b = 256) : (P = o, F = s, b = -1), O = 0, C = 0, S = E, v = u, k = T, R = 0, m = -1, M = 1 << T, g = M - 1, 1 === e && M > 852 || 2 === e && M > 592) return 1;
      for (var U = 0;;) {
        U++, y = S - R, h[C] < b ? (w = 0, x = h[C]) : h[C] > b ? (w = F[N + h[C]], x = P[B + h[C]]) : (w = 96, x = 0), d = 1 << S - R, p = 1 << k, E = p;
        do {
          p -= d, c[v + (O >> R) + p] = y << 24 | w << 16 | x | 0;
        } while (0 !== p);
        for (d = 1 << S - 1; O & d;) d >>= 1;
        if (0 !== d ? (O &= d - 1, O += d) : O = 0, C++, 0 == --D[S]) {
          if (S === A) break;
          S = t[r + h[C]];
        }
        if (S > T && (O & g) !== m) {
          for (0 === R && (R = T), v += E, k = S - R, I = 1 << k; k + R < A && !((I -= D[k + R]) <= 0);) k++, I <<= 1;
          if (M += 1 << k, 1 === e && M > 852 || 2 === e && M > 592) return 1;
          m = O & g, c[m] = T << 24 | k << 16 | v - u | 0;
        }
      }
      return 0 !== O && (c[v + O] = S - R << 24 | 64 << 16 | 0), f.bits = T, 0;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      for (var t = e.length; --t >= 0;) e[t] = 0;
    }
    function i(e, t, r, n, i) {
      this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
    }
    function a(e, t) {
      this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
    }
    function o(e) {
      return e < 256 ? ae[e] : ae[256 + (e >>> 7)];
    }
    function s(e, t) {
      e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
    }
    function l(e, t, r) {
      e.bi_valid > X - r ? (e.bi_buf |= t << e.bi_valid & 65535, s(e, e.bi_buf), e.bi_buf = t >> X - e.bi_valid, e.bi_valid += r - X) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
    }
    function c(e, t, r) {
      l(e, r[2 * t], r[2 * t + 1]);
    }
    function u(e, t) {
      var r = 0;
      do {
        r |= 1 & e, e >>>= 1, r <<= 1;
      } while (--t > 0);
      return r >>> 1;
    }
    function h(e) {
      16 === e.bi_valid ? (s(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
    }
    function f(e, t) {
      var r,
        n,
        i,
        a,
        o,
        s,
        l = t.dyn_tree,
        c = t.max_code,
        u = t.stat_desc.static_tree,
        h = t.stat_desc.has_stree,
        f = t.stat_desc.extra_bits,
        d = t.stat_desc.extra_base,
        p = t.stat_desc.max_length,
        m = 0;
      for (a = 0; a <= W; a++) e.bl_count[a] = 0;
      for (l[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < q; r++) n = e.heap[r], a = l[2 * l[2 * n + 1] + 1] + 1, a > p && (a = p, m++), l[2 * n + 1] = a, n > c || (e.bl_count[a]++, o = 0, n >= d && (o = f[n - d]), s = l[2 * n], e.opt_len += s * (a + o), h && (e.static_len += s * (u[2 * n + 1] + o)));
      if (0 !== m) {
        do {
          for (a = p - 1; 0 === e.bl_count[a];) a--;
          e.bl_count[a]--, e.bl_count[a + 1] += 2, e.bl_count[p]--, m -= 2;
        } while (m > 0);
        for (a = p; 0 !== a; a--) for (n = e.bl_count[a]; 0 !== n;) (i = e.heap[--r]) > c || (l[2 * i + 1] !== a && (e.opt_len += (a - l[2 * i + 1]) * l[2 * i], l[2 * i + 1] = a), n--);
      }
    }
    function d(e, t, r) {
      var n,
        i,
        a = new Array(W + 1),
        o = 0;
      for (n = 1; n <= W; n++) a[n] = o = o + r[n - 1] << 1;
      for (i = 0; i <= t; i++) {
        var s = e[2 * i + 1];
        0 !== s && (e[2 * i] = u(a[s]++, s));
      }
    }
    function p() {
      var e,
        t,
        r,
        n,
        a,
        o = new Array(W + 1);
      for (r = 0, n = 0; n < j - 1; n++) for (se[n] = r, e = 0; e < 1 << $[n]; e++) oe[r++] = n;
      for (oe[r - 1] = n, a = 0, n = 0; n < 16; n++) for (le[n] = a, e = 0; e < 1 << ee[n]; e++) ae[a++] = n;
      for (a >>= 7; n < G; n++) for (le[n] = a << 7, e = 0; e < 1 << ee[n] - 7; e++) ae[256 + a++] = n;
      for (t = 0; t <= W; t++) o[t] = 0;
      for (e = 0; e <= 143;) ne[2 * e + 1] = 8, e++, o[8]++;
      for (; e <= 255;) ne[2 * e + 1] = 9, e++, o[9]++;
      for (; e <= 279;) ne[2 * e + 1] = 7, e++, o[7]++;
      for (; e <= 287;) ne[2 * e + 1] = 8, e++, o[8]++;
      for (d(ne, H + 1, o), e = 0; e < G; e++) ie[2 * e + 1] = 5, ie[2 * e] = u(e, 5);
      ce = new i(ne, $, z + 1, H, W), ue = new i(ie, ee, 0, G, W), he = new i(new Array(0), te, 0, V, Y);
    }
    function m(e) {
      var t;
      for (t = 0; t < H; t++) e.dyn_ltree[2 * t] = 0;
      for (t = 0; t < G; t++) e.dyn_dtree[2 * t] = 0;
      for (t = 0; t < V; t++) e.bl_tree[2 * t] = 0;
      e.dyn_ltree[2 * K] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
    }
    function g(e) {
      e.bi_valid > 8 ? s(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
    }
    function v(e, t, r, n) {
      g(e), n && (s(e, r), s(e, ~r)), O.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
    }
    function b(e, t, r, n) {
      var i = 2 * t,
        a = 2 * r;
      return e[i] < e[a] || e[i] === e[a] && n[t] <= n[r];
    }
    function y(e, t, r) {
      for (var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && b(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !b(t, n, e.heap[i], e.depth));) e.heap[r] = e.heap[i], r = i, i <<= 1;
      e.heap[r] = n;
    }
    function w(e, t, r) {
      var n,
        i,
        a,
        s,
        u = 0;
      if (0 !== e.last_lit) do {
        n = e.pending_buf[e.d_buf + 2 * u] << 8 | e.pending_buf[e.d_buf + 2 * u + 1], i = e.pending_buf[e.l_buf + u], u++, 0 === n ? c(e, i, t) : (a = oe[i], c(e, a + z + 1, t), s = $[a], 0 !== s && (i -= se[a], l(e, i, s)), n--, a = o(n), c(e, a, r), 0 !== (s = ee[a]) && (n -= le[a], l(e, n, s)));
      } while (u < e.last_lit);
      c(e, K, t);
    }
    function x(e, t) {
      var r,
        n,
        i,
        a = t.dyn_tree,
        o = t.stat_desc.static_tree,
        s = t.stat_desc.has_stree,
        l = t.stat_desc.elems,
        c = -1;
      for (e.heap_len = 0, e.heap_max = q, r = 0; r < l; r++) 0 !== a[2 * r] ? (e.heap[++e.heap_len] = c = r, e.depth[r] = 0) : a[2 * r + 1] = 0;
      for (; e.heap_len < 2;) i = e.heap[++e.heap_len] = c < 2 ? ++c : 0, a[2 * i] = 1, e.depth[i] = 0, e.opt_len--, s && (e.static_len -= o[2 * i + 1]);
      for (t.max_code = c, r = e.heap_len >> 1; r >= 1; r--) y(e, a, r);
      i = l;
      do {
        r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], y(e, a, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, a[2 * i] = a[2 * r] + a[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, a[2 * r + 1] = a[2 * n + 1] = i, e.heap[1] = i++, y(e, a, 1);
      } while (e.heap_len >= 2);
      e.heap[--e.heap_max] = e.heap[1], f(e, t), d(a, c, e.bl_count);
    }
    function _(e, t, r) {
      var n,
        i,
        a = -1,
        o = t[1],
        s = 0,
        l = 7,
        c = 4;
      for (0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) i = o, o = t[2 * (n + 1) + 1], ++s < l && i === o || (s < c ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== a && e.bl_tree[2 * i]++, e.bl_tree[2 * Z]++) : s <= 10 ? e.bl_tree[2 * J]++ : e.bl_tree[2 * Q]++, s = 0, a = i, 0 === o ? (l = 138, c = 3) : i === o ? (l = 6, c = 3) : (l = 7, c = 4));
    }
    function S(e, t, r) {
      var n,
        i,
        a = -1,
        o = t[1],
        s = 0,
        u = 7,
        h = 4;
      for (0 === o && (u = 138, h = 3), n = 0; n <= r; n++) if (i = o, o = t[2 * (n + 1) + 1], !(++s < u && i === o)) {
        if (s < h) do {
          c(e, i, e.bl_tree);
        } while (0 != --s);else 0 !== i ? (i !== a && (c(e, i, e.bl_tree), s--), c(e, Z, e.bl_tree), l(e, s - 3, 2)) : s <= 10 ? (c(e, J, e.bl_tree), l(e, s - 3, 3)) : (c(e, Q, e.bl_tree), l(e, s - 11, 7));
        s = 0, a = i, 0 === o ? (u = 138, h = 3) : i === o ? (u = 6, h = 3) : (u = 7, h = 4);
      }
    }
    function C(e) {
      var t;
      for (_(e, e.dyn_ltree, e.l_desc.max_code), _(e, e.dyn_dtree, e.d_desc.max_code), x(e, e.bl_desc), t = V - 1; t >= 3 && 0 === e.bl_tree[2 * re[t] + 1]; t--);
      return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
    }
    function E(e, t, r, n) {
      var i;
      for (l(e, t - 257, 5), l(e, r - 1, 5), l(e, n - 4, 4), i = 0; i < n; i++) l(e, e.bl_tree[2 * re[i] + 1], 3);
      S(e, e.dyn_ltree, t - 1), S(e, e.dyn_dtree, r - 1);
    }
    function A(e) {
      var t,
        r = 4093624447;
      for (t = 0; t <= 31; t++, r >>>= 1) if (1 & r && 0 !== e.dyn_ltree[2 * t]) return B;
      if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return D;
      for (t = 32; t < z; t++) if (0 !== e.dyn_ltree[2 * t]) return D;
      return B;
    }
    function T(e) {
      fe || (p(), fe = !0), e.l_desc = new a(e.dyn_ltree, ce), e.d_desc = new a(e.dyn_dtree, ue), e.bl_desc = new a(e.bl_tree, he), e.bi_buf = 0, e.bi_valid = 0, m(e);
    }
    function k(e, t, r, n) {
      l(e, (F << 1) + (n ? 1 : 0), 3), v(e, t, r, !0);
    }
    function R(e) {
      l(e, N << 1, 3), c(e, K, ne), h(e);
    }
    function I(e, t, r, n) {
      var i,
        a,
        o = 0;
      e.level > 0 ? (e.strm.data_type === L && (e.strm.data_type = A(e)), x(e, e.l_desc), x(e, e.d_desc), o = C(e), i = e.opt_len + 3 + 7 >>> 3, (a = e.static_len + 3 + 7 >>> 3) <= i && (i = a)) : i = a = r + 5, r + 4 <= i && -1 !== t ? k(e, t, r, n) : e.strategy === P || a === i ? (l(e, (N << 1) + (n ? 1 : 0), 3), w(e, ne, ie)) : (l(e, (U << 1) + (n ? 1 : 0), 3), E(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), w(e, e.dyn_ltree, e.dyn_dtree)), m(e), n && g(e);
    }
    function M(e, t, r) {
      return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (oe[r] + z + 1)]++, e.dyn_dtree[2 * o(t)]++), e.last_lit === e.lit_bufsize - 1;
    }
    var O = r(22),
      P = 4,
      B = 0,
      D = 1,
      L = 2,
      F = 0,
      N = 1,
      U = 2,
      j = 29,
      z = 256,
      H = z + 1 + j,
      G = 30,
      V = 19,
      q = 2 * H + 1,
      W = 15,
      X = 16,
      Y = 7,
      K = 256,
      Z = 16,
      J = 17,
      Q = 18,
      $ = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
      ee = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
      te = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
      re = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      ne = new Array(2 * (H + 2));
    n(ne);
    var ie = new Array(2 * G);
    n(ie);
    var ae = new Array(512);
    n(ae);
    var oe = new Array(256);
    n(oe);
    var se = new Array(j);
    n(se);
    var le = new Array(G);
    n(le);
    var ce,
      ue,
      he,
      fe = !1;
    t._tr_init = T, t._tr_stored_block = k, t._tr_flush_block = I, t._tr_tally = M, t._tr_align = R;
  }, function (e, t, r) {
    (function (e) {
      function r(e, t) {
        for (var r = 0, n = e.length - 1; n >= 0; n--) {
          var i = e[n];
          "." === i ? e.splice(n, 1) : ".." === i ? (e.splice(n, 1), r++) : r && (e.splice(n, 1), r--);
        }
        if (t) for (; r--; r) e.unshift("..");
        return e;
      }
      function n(e, t) {
        if (e.filter) return e.filter(t);
        for (var r = [], n = 0; n < e.length; n++) t(e[n], n, e) && r.push(e[n]);
        return r;
      }
      var i = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,
        a = function a(e) {
          return i.exec(e).slice(1);
        };
      t.resolve = function () {
        for (var t = "", i = !1, a = arguments.length - 1; a >= -1 && !i; a--) {
          var o = a >= 0 ? arguments[a] : e.cwd();
          if ("string" != typeof o) throw new TypeError("Arguments to path.resolve must be strings");
          o && (t = o + "/" + t, i = "/" === o.charAt(0));
        }
        return t = r(n(t.split("/"), function (e) {
          return !!e;
        }), !i).join("/"), (i ? "/" : "") + t || ".";
      }, t.normalize = function (e) {
        var i = t.isAbsolute(e),
          a = "/" === o(e, -1);
        return e = r(n(e.split("/"), function (e) {
          return !!e;
        }), !i).join("/"), e || i || (e = "."), e && a && (e += "/"), (i ? "/" : "") + e;
      }, t.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, t.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return t.normalize(n(e, function (e, t) {
          if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, t.relative = function (e, r) {
        function n(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++);
          for (var r = e.length - 1; r >= 0 && "" === e[r]; r--);
          return t > r ? [] : e.slice(t, r - t + 1);
        }
        e = t.resolve(e).substr(1), r = t.resolve(r).substr(1);
        for (var i = n(e.split("/")), a = n(r.split("/")), o = Math.min(i.length, a.length), s = o, l = 0; l < o; l++) if (i[l] !== a[l]) {
          s = l;
          break;
        }
        for (var c = [], l = s; l < i.length; l++) c.push("..");
        return c = c.concat(a.slice(s)), c.join("/");
      }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
        var t = a(e),
          r = t[0],
          n = t[1];
        return r || n ? (n && (n = n.substr(0, n.length - 1)), r + n) : ".";
      }, t.basename = function (e, t) {
        var r = a(e)[2];
        return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
      }, t.extname = function (e) {
        return a(e)[3];
      };
      var o = "b" === "ab".substr(-1) ? function (e, t, r) {
        return e.substr(t, r);
      } : function (e, t, r) {
        return t < 0 && (t = e.length + t), e.substr(t, r);
      };
    }).call(t, r(5));
  }, function (e, t, r) {
    (function (t) {
      !function (t, r) {
        e.exports = r();
      }(0, function () {
        return function (e) {
          function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
              i: n,
              l: !1,
              exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
          }
          var r = {};
          return t.m = e, t.c = r, t.i = function (e) {
            return e;
          }, t.d = function (e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
              configurable: !1,
              enumerable: !0,
              get: n
            });
          }, t.n = function (e) {
            var r = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return t.d(r, "a", r), r;
          }, t.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, t.p = "", t(t.s = 47);
        }([function (e, r, n) {
          "use strict";

          (function (e) {
            function i(e) {
              ae = e;
            }
            function a() {
              return ae;
            }
            function o(e) {
              ae >= re.infos && console.log("Info: " + e);
            }
            function s(e) {
              ae >= re.warnings && console.log("Warning: " + e);
            }
            function l(e) {
              console.log("Deprecated API usage: " + e);
            }
            function c(e) {
              throw ae >= re.errors && (console.log("Error: " + e), console.log(u())), new Error(e);
            }
            function u() {
              try {
                throw new Error();
              } catch (e) {
                return e.stack ? e.stack.split("\n").slice(2).join("\n") : "";
              }
            }
            function h(e, t) {
              e || c(t);
            }
            function f(e, t) {
              try {
                var r = new URL(e);
                if (!r.origin || "null" === r.origin) return !1;
              } catch (e) {
                return !1;
              }
              var n = new URL(t, r);
              return r.origin === n.origin;
            }
            function d(e) {
              if (!e) return !1;
              switch (e.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return !0;
                default:
                  return !1;
              }
            }
            function p(e, t) {
              if (!e) return null;
              try {
                var r = t ? new URL(e, t) : new URL(e);
                if (d(r)) return r;
              } catch (e) {}
              return null;
            }
            function m(e, t, r) {
              return Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !1
              }), r;
            }
            function g(e) {
              var t;
              return function () {
                return e && (t = Object.create(null), e(t), e = null), t;
              };
            }
            function v(e) {
              return "string" != typeof e ? (s("The argument for removeNullCharacters must be a string."), e) : e.replace(ge, "");
            }
            function b(e) {
              h(null !== e && "object" === (void 0 === e ? "undefined" : V(e)) && void 0 !== e.length, "Invalid argument for bytesToString");
              var t = e.length;
              if (t < 8192) return String.fromCharCode.apply(null, e);
              for (var r = [], n = 0; n < t; n += 8192) {
                var i = Math.min(n + 8192, t),
                  a = e.subarray(n, i);
                r.push(String.fromCharCode.apply(null, a));
              }
              return r.join("");
            }
            function y(e) {
              h("string" == typeof e, "Invalid argument for stringToBytes");
              for (var t = e.length, r = new Uint8Array(t), n = 0; n < t; ++n) r[n] = 255 & e.charCodeAt(n);
              return r;
            }
            function w(e) {
              return void 0 !== e.length ? e.length : (h(void 0 !== e.byteLength), e.byteLength);
            }
            function x(e) {
              if (1 === e.length && e[0] instanceof Uint8Array) return e[0];
              var t,
                r,
                n,
                i = 0,
                a = e.length;
              for (t = 0; t < a; t++) r = e[t], n = w(r), i += n;
              var o = 0,
                s = new Uint8Array(i);
              for (t = 0; t < a; t++) r = e[t], r instanceof Uint8Array || (r = "string" == typeof r ? y(r) : new Uint8Array(r)), n = r.byteLength, s.set(r, o), o += n;
              return s;
            }
            function _(e) {
              return String.fromCharCode(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e);
            }
            function S(e) {
              for (var t = 1, r = 0; e > t;) t <<= 1, r++;
              return r;
            }
            function C(e, t) {
              return e[t] << 24 >> 24;
            }
            function E(e, t) {
              return e[t] << 8 | e[t + 1];
            }
            function A(e, t) {
              return (e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]) >>> 0;
            }
            function T() {
              var e = new Uint8Array(4);
              return e[0] = 1, 1 === new Uint32Array(e.buffer, 0, 1)[0];
            }
            function k() {
              try {
                return new Function(""), !0;
              } catch (e) {
                return !1;
              }
            }
            function R(e) {
              var t,
                r = e.length,
                n = [];
              if ("þ" === e[0] && "ÿ" === e[1]) for (t = 2; t < r; t += 2) n.push(String.fromCharCode(e.charCodeAt(t) << 8 | e.charCodeAt(t + 1)));else for (t = 0; t < r; ++t) {
                var i = we[e.charCodeAt(t)];
                n.push(i ? String.fromCharCode(i) : e.charAt(t));
              }
              return n.join("");
            }
            function I(e) {
              return decodeURIComponent(escape(e));
            }
            function M(e) {
              return unescape(encodeURIComponent(e));
            }
            function O(e) {
              for (var t in e) return !1;
              return !0;
            }
            function P(e) {
              return "boolean" == typeof e;
            }
            function B(e) {
              return "number" == typeof e && (0 | e) === e;
            }
            function D(e) {
              return "number" == typeof e;
            }
            function L(e) {
              return "string" == typeof e;
            }
            function F(e) {
              return e instanceof Array;
            }
            function N(e) {
              return "object" === (void 0 === e ? "undefined" : V(e)) && null !== e && void 0 !== e.byteLength;
            }
            function U(e) {
              return 32 === e || 9 === e || 13 === e || 10 === e;
            }
            function j() {
              return "undefined" == typeof __pdfjsdev_webpack__ && "object" === (void 0 === t ? "undefined" : V(t)) && t + "" == "[object process]";
            }
            function z() {
              var e = {};
              return e.promise = new Promise(function (t, r) {
                e.resolve = t, e.reject = r;
              }), e;
            }
            function H(e, t, r) {
              var n = this;
              this.sourceName = e, this.targetName = t, this.comObj = r, this.callbackIndex = 1, this.postMessageTransfers = !0;
              var i = this.callbacksCapabilities = Object.create(null),
                a = this.actionHandler = Object.create(null);
              this._onComObjOnMessage = function (e) {
                var t = e.data;
                if (t.targetName === n.sourceName) if (t.isReply) {
                  var o = t.callbackId;
                  if (t.callbackId in i) {
                    var s = i[o];
                    delete i[o], "error" in t ? s.reject(t.error) : s.resolve(t.data);
                  } else c("Cannot resolve callback " + o);
                } else if (t.action in a) {
                  var l = a[t.action];
                  if (t.callbackId) {
                    var u = n.sourceName,
                      h = t.sourceName;
                    Promise.resolve().then(function () {
                      return l[0].call(l[1], t.data);
                    }).then(function (e) {
                      r.postMessage({
                        sourceName: u,
                        targetName: h,
                        isReply: !0,
                        callbackId: t.callbackId,
                        data: e
                      });
                    }, function (e) {
                      e instanceof Error && (e += ""), r.postMessage({
                        sourceName: u,
                        targetName: h,
                        isReply: !0,
                        callbackId: t.callbackId,
                        error: e
                      });
                    });
                  } else l[0].call(l[1], t.data);
                } else c("Unknown action from worker: " + t.action);
              }, r.addEventListener("message", this._onComObjOnMessage);
            }
            function G(e, t, r) {
              var n = new Image();
              n.onload = function () {
                r.resolve(e, n);
              }, n.onerror = function () {
                r.resolve(e, null), s("Error during JPEG image loading");
              }, n.src = t;
            }
            Object.defineProperty(r, "__esModule", {
              value: !0
            }), r.warn = r.utf8StringToString = r.stringToUTF8String = r.stringToPDFString = r.stringToBytes = r.string32 = r.shadow = r.setVerbosityLevel = r.removeNullCharacters = r.readUint32 = r.readUint16 = r.readInt8 = r.log2 = r.loadJpegStream = r.isEvalSupported = r.isLittleEndian = r.createValidAbsoluteUrl = r.isSameOrigin = r.isNodeJS = r.isSpace = r.isString = r.isNum = r.isInt = r.isEmptyObj = r.isBool = r.isArrayBuffer = r.isArray = r.info = r.globalScope = r.getVerbosityLevel = r.getLookupTableFactory = r.error = r.deprecated = r.createObjectURL = r.createPromiseCapability = r.createBlob = r.bytesToString = r.assert = r.arraysToBytes = r.arrayByteLength = r.XRefParseException = r.Util = r.UnknownErrorException = r.UnexpectedResponseException = r.TextRenderingMode = r.StreamType = r.StatTimer = r.PasswordResponses = r.PasswordException = r.PageViewport = r.NotImplementedException = r.NativeImageDecoding = r.MissingPDFException = r.MissingDataException = r.MessageHandler = r.InvalidPDFException = r.CMapCompressionType = r.ImageKind = r.FontType = r.AnnotationType = r.AnnotationFlag = r.AnnotationFieldFlag = r.AnnotationBorderStyleType = r.UNSUPPORTED_FEATURES = r.VERBOSITY_LEVELS = r.OPS = r.IDENTITY_MATRIX = r.FONT_IDENTITY_MATRIX = void 0;
            var V = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            };
            n(48);
            var q = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : void 0,
              W = [.001, 0, 0, .001, 0, 0],
              X = {
                NONE: "none",
                DECODE: "decode",
                DISPLAY: "display"
              },
              Y = {
                FILL: 0,
                STROKE: 1,
                FILL_STROKE: 2,
                INVISIBLE: 3,
                FILL_ADD_TO_PATH: 4,
                STROKE_ADD_TO_PATH: 5,
                FILL_STROKE_ADD_TO_PATH: 6,
                ADD_TO_PATH: 7,
                FILL_STROKE_MASK: 3,
                ADD_TO_PATH_FLAG: 4
              },
              K = {
                GRAYSCALE_1BPP: 1,
                RGB_24BPP: 2,
                RGBA_32BPP: 3
              },
              Z = {
                TEXT: 1,
                LINK: 2,
                FREETEXT: 3,
                LINE: 4,
                SQUARE: 5,
                CIRCLE: 6,
                POLYGON: 7,
                POLYLINE: 8,
                HIGHLIGHT: 9,
                UNDERLINE: 10,
                SQUIGGLY: 11,
                STRIKEOUT: 12,
                STAMP: 13,
                CARET: 14,
                INK: 15,
                POPUP: 16,
                FILEATTACHMENT: 17,
                SOUND: 18,
                MOVIE: 19,
                WIDGET: 20,
                SCREEN: 21,
                PRINTERMARK: 22,
                TRAPNET: 23,
                WATERMARK: 24,
                THREED: 25,
                REDACT: 26
              },
              J = {
                INVISIBLE: 1,
                HIDDEN: 2,
                PRINT: 4,
                NOZOOM: 8,
                NOROTATE: 16,
                NOVIEW: 32,
                READONLY: 64,
                LOCKED: 128,
                TOGGLENOVIEW: 256,
                LOCKEDCONTENTS: 512
              },
              Q = {
                READONLY: 1,
                REQUIRED: 2,
                NOEXPORT: 4,
                MULTILINE: 4096,
                PASSWORD: 8192,
                NOTOGGLETOOFF: 16384,
                RADIO: 32768,
                PUSHBUTTON: 65536,
                COMBO: 131072,
                EDIT: 262144,
                SORT: 524288,
                FILESELECT: 1048576,
                MULTISELECT: 2097152,
                DONOTSPELLCHECK: 4194304,
                DONOTSCROLL: 8388608,
                COMB: 16777216,
                RICHTEXT: 33554432,
                RADIOSINUNISON: 33554432,
                COMMITONSELCHANGE: 67108864
              },
              $ = {
                SOLID: 1,
                DASHED: 2,
                BEVELED: 3,
                INSET: 4,
                UNDERLINE: 5
              },
              ee = {
                UNKNOWN: 0,
                FLATE: 1,
                LZW: 2,
                DCT: 3,
                JPX: 4,
                JBIG: 5,
                A85: 6,
                AHX: 7,
                CCF: 8,
                RL: 9
              },
              te = {
                UNKNOWN: 0,
                TYPE1: 1,
                TYPE1C: 2,
                CIDFONTTYPE0: 3,
                CIDFONTTYPE0C: 4,
                TRUETYPE: 5,
                CIDFONTTYPE2: 6,
                TYPE3: 7,
                OPENTYPE: 8,
                TYPE0: 9,
                MMTYPE1: 10
              },
              re = {
                errors: 0,
                warnings: 1,
                infos: 5
              },
              ne = {
                NONE: 0,
                BINARY: 1,
                STREAM: 2
              },
              ie = {
                dependency: 1,
                setLineWidth: 2,
                setLineCap: 3,
                setLineJoin: 4,
                setMiterLimit: 5,
                setDash: 6,
                setRenderingIntent: 7,
                setFlatness: 8,
                setGState: 9,
                save: 10,
                restore: 11,
                transform: 12,
                moveTo: 13,
                lineTo: 14,
                curveTo: 15,
                curveTo2: 16,
                curveTo3: 17,
                closePath: 18,
                rectangle: 19,
                stroke: 20,
                closeStroke: 21,
                fill: 22,
                eoFill: 23,
                fillStroke: 24,
                eoFillStroke: 25,
                closeFillStroke: 26,
                closeEOFillStroke: 27,
                endPath: 28,
                clip: 29,
                eoClip: 30,
                beginText: 31,
                endText: 32,
                setCharSpacing: 33,
                setWordSpacing: 34,
                setHScale: 35,
                setLeading: 36,
                setFont: 37,
                setTextRenderingMode: 38,
                setTextRise: 39,
                moveText: 40,
                setLeadingMoveText: 41,
                setTextMatrix: 42,
                nextLine: 43,
                showText: 44,
                showSpacedText: 45,
                nextLineShowText: 46,
                nextLineSetSpacingShowText: 47,
                setCharWidth: 48,
                setCharWidthAndBounds: 49,
                setStrokeColorSpace: 50,
                setFillColorSpace: 51,
                setStrokeColor: 52,
                setStrokeColorN: 53,
                setFillColor: 54,
                setFillColorN: 55,
                setStrokeGray: 56,
                setFillGray: 57,
                setStrokeRGBColor: 58,
                setFillRGBColor: 59,
                setStrokeCMYKColor: 60,
                setFillCMYKColor: 61,
                shadingFill: 62,
                beginInlineImage: 63,
                beginImageData: 64,
                endInlineImage: 65,
                paintXObject: 66,
                markPoint: 67,
                markPointProps: 68,
                beginMarkedContent: 69,
                beginMarkedContentProps: 70,
                endMarkedContent: 71,
                beginCompat: 72,
                endCompat: 73,
                paintFormXObjectBegin: 74,
                paintFormXObjectEnd: 75,
                beginGroup: 76,
                endGroup: 77,
                beginAnnotations: 78,
                endAnnotations: 79,
                beginAnnotation: 80,
                endAnnotation: 81,
                paintJpegXObject: 82,
                paintImageMaskXObject: 83,
                paintImageMaskXObjectGroup: 84,
                paintImageXObject: 85,
                paintInlineImageXObject: 86,
                paintInlineImageXObjectGroup: 87,
                paintImageXObjectRepeat: 88,
                paintImageMaskXObjectRepeat: 89,
                paintSolidColorImageMask: 90,
                constructPath: 91
              },
              ae = re.warnings,
              oe = {
                unknown: "unknown",
                forms: "forms",
                javaScript: "javaScript",
                smask: "smask",
                shadingPattern: "shadingPattern",
                font: "font"
              },
              se = {
                NEED_PASSWORD: 1,
                INCORRECT_PASSWORD: 2
              },
              le = function () {
                function e(e, t) {
                  this.name = "PasswordException", this.message = e, this.code = t;
                }
                return e.prototype = new Error(), e.constructor = e, e;
              }(),
              ce = function () {
                function e(e, t) {
                  this.name = "UnknownErrorException", this.message = e, this.details = t;
                }
                return e.prototype = new Error(), e.constructor = e, e;
              }(),
              ue = function () {
                function e(e) {
                  this.name = "InvalidPDFException", this.message = e;
                }
                return e.prototype = new Error(), e.constructor = e, e;
              }(),
              he = function () {
                function e(e) {
                  this.name = "MissingPDFException", this.message = e;
                }
                return e.prototype = new Error(), e.constructor = e, e;
              }(),
              fe = function () {
                function e(e, t) {
                  this.name = "UnexpectedResponseException", this.message = e, this.status = t;
                }
                return e.prototype = new Error(), e.constructor = e, e;
              }(),
              de = function () {
                function e(e) {
                  this.message = e;
                }
                return e.prototype = new Error(), e.prototype.name = "NotImplementedException", e.constructor = e, e;
              }(),
              pe = function () {
                function e(e, t) {
                  this.begin = e, this.end = t, this.message = "Missing data [" + e + ", " + t + ")";
                }
                return e.prototype = new Error(), e.prototype.name = "MissingDataException", e.constructor = e, e;
              }(),
              me = function () {
                function e(e) {
                  this.message = e;
                }
                return e.prototype = new Error(), e.prototype.name = "XRefParseException", e.constructor = e, e;
              }(),
              ge = /\x00/g,
              ve = [1, 0, 0, 1, 0, 0],
              be = function () {
                function e() {}
                var t = ["rgb(", 0, ",", 0, ",", 0, ")"];
                e.makeCssRgb = function (e, r, n) {
                  return t[1] = e, t[3] = r, t[5] = n, t.join("");
                }, e.transform = function (e, t) {
                  return [e[0] * t[0] + e[2] * t[1], e[1] * t[0] + e[3] * t[1], e[0] * t[2] + e[2] * t[3], e[1] * t[2] + e[3] * t[3], e[0] * t[4] + e[2] * t[5] + e[4], e[1] * t[4] + e[3] * t[5] + e[5]];
                }, e.applyTransform = function (e, t) {
                  return [e[0] * t[0] + e[1] * t[2] + t[4], e[0] * t[1] + e[1] * t[3] + t[5]];
                }, e.applyInverseTransform = function (e, t) {
                  var r = t[0] * t[3] - t[1] * t[2];
                  return [(e[0] * t[3] - e[1] * t[2] + t[2] * t[5] - t[4] * t[3]) / r, (-e[0] * t[1] + e[1] * t[0] + t[4] * t[1] - t[5] * t[0]) / r];
                }, e.getAxialAlignedBoundingBox = function (t, r) {
                  var n = e.applyTransform(t, r),
                    i = e.applyTransform(t.slice(2, 4), r),
                    a = e.applyTransform([t[0], t[3]], r),
                    o = e.applyTransform([t[2], t[1]], r);
                  return [Math.min(n[0], i[0], a[0], o[0]), Math.min(n[1], i[1], a[1], o[1]), Math.max(n[0], i[0], a[0], o[0]), Math.max(n[1], i[1], a[1], o[1])];
                }, e.inverseTransform = function (e) {
                  var t = e[0] * e[3] - e[1] * e[2];
                  return [e[3] / t, -e[1] / t, -e[2] / t, e[0] / t, (e[2] * e[5] - e[4] * e[3]) / t, (e[4] * e[1] - e[5] * e[0]) / t];
                }, e.apply3dTransform = function (e, t) {
                  return [e[0] * t[0] + e[1] * t[1] + e[2] * t[2], e[3] * t[0] + e[4] * t[1] + e[5] * t[2], e[6] * t[0] + e[7] * t[1] + e[8] * t[2]];
                }, e.singularValueDecompose2dScale = function (e) {
                  var t = [e[0], e[2], e[1], e[3]],
                    r = e[0] * t[0] + e[1] * t[2],
                    n = e[0] * t[1] + e[1] * t[3],
                    i = e[2] * t[0] + e[3] * t[2],
                    a = e[2] * t[1] + e[3] * t[3],
                    o = (r + a) / 2,
                    s = Math.sqrt((r + a) * (r + a) - 4 * (r * a - i * n)) / 2,
                    l = o + s || 1,
                    c = o - s || 1;
                  return [Math.sqrt(l), Math.sqrt(c)];
                }, e.normalizeRect = function (e) {
                  var t = e.slice(0);
                  return e[0] > e[2] && (t[0] = e[2], t[2] = e[0]), e[1] > e[3] && (t[1] = e[3], t[3] = e[1]), t;
                }, e.intersect = function (t, r) {
                  function n(e, t) {
                    return e - t;
                  }
                  var i = [t[0], t[2], r[0], r[2]].sort(n),
                    a = [t[1], t[3], r[1], r[3]].sort(n),
                    o = [];
                  return t = e.normalizeRect(t), r = e.normalizeRect(r), (i[0] === t[0] && i[1] === r[0] || i[0] === r[0] && i[1] === t[0]) && (o[0] = i[1], o[2] = i[2], (a[0] === t[1] && a[1] === r[1] || a[0] === r[1] && a[1] === t[1]) && (o[1] = a[1], o[3] = a[2], o));
                }, e.sign = function (e) {
                  return e < 0 ? -1 : 1;
                };
                var r = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
                return e.toRoman = function (e, t) {
                  h(B(e) && e > 0, "The number should be a positive integer.");
                  for (var n, i = []; e >= 1e3;) e -= 1e3, i.push("M");
                  n = e / 100 | 0, e %= 100, i.push(r[n]), n = e / 10 | 0, e %= 10, i.push(r[10 + n]), i.push(r[20 + e]);
                  var a = i.join("");
                  return t ? a.toLowerCase() : a;
                }, e.appendToArray = function (e, t) {
                  Array.prototype.push.apply(e, t);
                }, e.prependToArray = function (e, t) {
                  Array.prototype.unshift.apply(e, t);
                }, e.extendObj = function (e, t) {
                  for (var r in t) e[r] = t[r];
                }, e.getInheritableProperty = function (e, t, r) {
                  for (; e && !e.has(t);) e = e.get("Parent");
                  return e ? r ? e.getArray(t) : e.get(t) : null;
                }, e.inherit = function (e, t, r) {
                  e.prototype = Object.create(t.prototype), e.prototype.constructor = e;
                  for (var n in r) e.prototype[n] = r[n];
                }, e.loadScript = function (e, t) {
                  var r = document.createElement("script"),
                    n = !1;
                  r.setAttribute("src", e), t && (r.onload = function () {
                    n || t(), n = !0;
                  }), document.getElementsByTagName("head")[0].appendChild(r);
                }, e;
              }(),
              ye = function () {
                function e(e, t, r, n, i, a) {
                  this.viewBox = e, this.scale = t, this.rotation = r, this.offsetX = n, this.offsetY = i;
                  var o,
                    s,
                    l,
                    c,
                    u = (e[2] + e[0]) / 2,
                    h = (e[3] + e[1]) / 2;
                  switch (r %= 360, r = r < 0 ? r + 360 : r) {
                    case 180:
                      o = -1, s = 0, l = 0, c = 1;
                      break;
                    case 90:
                      o = 0, s = 1, l = 1, c = 0;
                      break;
                    case 270:
                      o = 0, s = -1, l = -1, c = 0;
                      break;
                    default:
                      o = 1, s = 0, l = 0, c = -1;
                  }
                  a && (l = -l, c = -c);
                  var f, d, p, m;
                  0 === o ? (f = Math.abs(h - e[1]) * t + n, d = Math.abs(u - e[0]) * t + i, p = Math.abs(e[3] - e[1]) * t, m = Math.abs(e[2] - e[0]) * t) : (f = Math.abs(u - e[0]) * t + n, d = Math.abs(h - e[1]) * t + i, p = Math.abs(e[2] - e[0]) * t, m = Math.abs(e[3] - e[1]) * t), this.transform = [o * t, s * t, l * t, c * t, f - o * t * u - l * t * h, d - s * t * u - c * t * h], this.width = p, this.height = m, this.fontScale = t;
                }
                return e.prototype = {
                  clone: function clone(t) {
                    t = t || {};
                    var r = "scale" in t ? t.scale : this.scale,
                      n = "rotation" in t ? t.rotation : this.rotation;
                    return new e(this.viewBox.slice(), r, n, this.offsetX, this.offsetY, t.dontFlip);
                  },
                  convertToViewportPoint: function convertToViewportPoint(e, t) {
                    return be.applyTransform([e, t], this.transform);
                  },
                  convertToViewportRectangle: function convertToViewportRectangle(e) {
                    var t = be.applyTransform([e[0], e[1]], this.transform),
                      r = be.applyTransform([e[2], e[3]], this.transform);
                    return [t[0], t[1], r[0], r[1]];
                  },
                  convertToPdfPoint: function convertToPdfPoint(e, t) {
                    return be.applyInverseTransform([e, t], this.transform);
                  }
                }, e;
              }(),
              we = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364],
              xe = function () {
                function e(e, t, r) {
                  for (; e.length < r;) e += t;
                  return e;
                }
                function t() {
                  this.started = Object.create(null), this.times = [], this.enabled = !0;
                }
                return t.prototype = {
                  time: function time(e) {
                    this.enabled && (e in this.started && s("Timer is already running for " + e), this.started[e] = Date.now());
                  },
                  timeEnd: function timeEnd(e) {
                    this.enabled && (e in this.started || s("Timer has not been started for " + e), this.times.push({
                      name: e,
                      start: this.started[e],
                      end: Date.now()
                    }), delete this.started[e]);
                  },
                  toString: function toString() {
                    var t,
                      r,
                      n = this.times,
                      i = "",
                      a = 0;
                    for (t = 0, r = n.length; t < r; ++t) {
                      var o = n[t].name;
                      o.length > a && (a = o.length);
                    }
                    for (t = 0, r = n.length; t < r; ++t) {
                      var s = n[t],
                        l = s.end - s.start;
                      i += e(s.name, " ", a) + " " + l + "ms\n";
                    }
                    return i;
                  }
                }, t;
              }(),
              _e = function _e(e, t) {
                if ("undefined" != typeof Blob) return new Blob([e], {
                  type: t
                });
                throw new Error('The "Blob" constructor is not supported.');
              },
              Se = function () {
                var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                return function (t, r) {
                  if (!(arguments.length > 2 && void 0 !== arguments[2] && arguments[2]) && URL.createObjectURL) {
                    var n = _e(t, r);
                    return URL.createObjectURL(n);
                  }
                  for (var i = "data:" + r + ";base64,", a = 0, o = t.length; a < o; a += 3) {
                    var s = 255 & t[a],
                      l = 255 & t[a + 1],
                      c = 255 & t[a + 2];
                    i += e[s >> 2] + e[(3 & s) << 4 | l >> 4] + e[a + 1 < o ? (15 & l) << 2 | c >> 6 : 64] + e[a + 2 < o ? 63 & c : 64];
                  }
                  return i;
                };
              }();
            H.prototype = {
              on: function on(e, t, r) {
                var n = this.actionHandler;
                n[e] && c('There is already an actionName called "' + e + '"'), n[e] = [t, r];
              },
              send: function send(e, t, r) {
                var n = {
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: e,
                  data: t
                };
                this.postMessage(n, r);
              },
              sendWithPromise: function sendWithPromise(e, t, r) {
                var n = this.callbackIndex++,
                  i = {
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: e,
                    data: t,
                    callbackId: n
                  },
                  a = z();
                this.callbacksCapabilities[n] = a;
                try {
                  this.postMessage(i, r);
                } catch (e) {
                  a.reject(e);
                }
                return a.promise;
              },
              postMessage: function postMessage(e, t) {
                t && this.postMessageTransfers ? this.comObj.postMessage(e, t) : this.comObj.postMessage(e);
              },
              destroy: function destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }, r.FONT_IDENTITY_MATRIX = W, r.IDENTITY_MATRIX = ve, r.OPS = ie, r.VERBOSITY_LEVELS = re, r.UNSUPPORTED_FEATURES = oe, r.AnnotationBorderStyleType = $, r.AnnotationFieldFlag = Q, r.AnnotationFlag = J, r.AnnotationType = Z, r.FontType = te, r.ImageKind = K, r.CMapCompressionType = ne, r.InvalidPDFException = ue, r.MessageHandler = H, r.MissingDataException = pe, r.MissingPDFException = he, r.NativeImageDecoding = X, r.NotImplementedException = de, r.PageViewport = ye, r.PasswordException = le, r.PasswordResponses = se, r.StatTimer = xe, r.StreamType = ee, r.TextRenderingMode = Y, r.UnexpectedResponseException = fe, r.UnknownErrorException = ce, r.Util = be, r.XRefParseException = me, r.arrayByteLength = w, r.arraysToBytes = x, r.assert = h, r.bytesToString = b, r.createBlob = _e, r.createPromiseCapability = z, r.createObjectURL = Se, r.deprecated = l, r.error = c, r.getLookupTableFactory = g, r.getVerbosityLevel = a, r.globalScope = q, r.info = o, r.isArray = F, r.isArrayBuffer = N, r.isBool = P, r.isEmptyObj = O, r.isInt = B, r.isNum = D, r.isString = L, r.isSpace = U, r.isNodeJS = j, r.isSameOrigin = f, r.createValidAbsoluteUrl = p, r.isLittleEndian = T, r.isEvalSupported = k, r.loadJpegStream = G, r.log2 = S, r.readInt8 = C, r.readUint16 = E, r.readUint32 = A, r.removeNullCharacters = v, r.setVerbosityLevel = i, r.shadow = m, r.string32 = _, r.stringToBytes = y, r.stringToPDFString = R, r.stringToUTF8String = I, r.utf8StringToString = M, r.warn = s;
          }).call(r, n(13));
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            return e === d;
          }
          function i(e, t) {
            return e instanceof p && (void 0 === t || e.name === t);
          }
          function a(e, t) {
            return e instanceof m && (void 0 === t || e.cmd === t);
          }
          function o(e, t) {
            return e instanceof g && (void 0 === t || i(e.get("Type"), t));
          }
          function s(e) {
            return e instanceof v;
          }
          function l(e, t) {
            return e.num === t.num && e.gen === t.gen;
          }
          function c(e) {
            return "object" === (void 0 === e ? "undefined" : u(e)) && null !== e && void 0 !== e.getBytes;
          }
          var u = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            h = r(0),
            f = h.isArray,
            d = {},
            p = function () {
              function e(e) {
                this.name = e;
              }
              e.prototype = {};
              var t = Object.create(null);
              return e.get = function (r) {
                var n = t[r];
                return n || (t[r] = new e(r));
              }, e;
            }(),
            m = function () {
              function e(e) {
                this.cmd = e;
              }
              e.prototype = {};
              var t = Object.create(null);
              return e.get = function (r) {
                var n = t[r];
                return n || (t[r] = new e(r));
              }, e;
            }(),
            g = function () {
              function e(e) {
                this.map = Object.create(null), this.xref = e, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = _t8;
              }
              var _t8 = function t() {
                return _t8;
              };
              return e.prototype = {
                assignXref: function assignXref(e) {
                  this.xref = e;
                },
                get: function get(e, t, r) {
                  var n,
                    i = this.xref,
                    a = this.suppressEncryption;
                  return void 0 !== (n = this.map[e]) || e in this.map || void 0 === t ? i ? i.fetchIfRef(n, a) : n : void 0 !== (n = this.map[t]) || t in this.map || void 0 === r ? i ? i.fetchIfRef(n, a) : n : (n = this.map[r] || null, i ? i.fetchIfRef(n, a) : n);
                },
                getAsync: function getAsync(e, t, r) {
                  var n,
                    i = this.xref,
                    a = this.suppressEncryption;
                  return void 0 !== (n = this.map[e]) || e in this.map || void 0 === t ? i ? i.fetchIfRefAsync(n, a) : Promise.resolve(n) : void 0 !== (n = this.map[t]) || t in this.map || void 0 === r ? i ? i.fetchIfRefAsync(n, a) : Promise.resolve(n) : (n = this.map[r] || null, i ? i.fetchIfRefAsync(n, a) : Promise.resolve(n));
                },
                getArray: function getArray(e, t, r) {
                  var n = this.get(e, t, r),
                    i = this.xref,
                    a = this.suppressEncryption;
                  if (!f(n) || !i) return n;
                  n = n.slice();
                  for (var o = 0, l = n.length; o < l; o++) s(n[o]) && (n[o] = i.fetch(n[o], a));
                  return n;
                },
                getRaw: function getRaw(e) {
                  return this.map[e];
                },
                getKeys: function getKeys() {
                  return Object.keys(this.map);
                },
                set: function set(e, t) {
                  this.map[e] = t;
                },
                has: function has(e) {
                  return e in this.map;
                },
                forEach: function forEach(e) {
                  for (var t in this.map) e(t, this.get(t));
                }
              }, e.empty = new e(null), e.merge = function (t, r) {
                for (var n = new e(t), i = 0, a = r.length; i < a; i++) {
                  var s = r[i];
                  if (o(s)) for (var l in s.map) n.map[l] || (n.map[l] = s.map[l]);
                }
                return n;
              }, e;
            }(),
            v = function () {
              function e(e, t) {
                this.num = e, this.gen = t;
              }
              return e.prototype = {
                toString: function toString() {
                  var e = this.num + "R";
                  return 0 !== this.gen && (e += this.gen), e;
                }
              }, e;
            }(),
            b = function () {
              function e() {
                this.dict = Object.create(null);
              }
              return e.prototype = {
                has: function has(e) {
                  return e.toString() in this.dict;
                },
                put: function put(e) {
                  this.dict[e.toString()] = !0;
                },
                remove: function remove(e) {
                  delete this.dict[e.toString()];
                }
              }, e;
            }(),
            y = function () {
              function e() {
                this.dict = Object.create(null);
              }
              return e.prototype = {
                get: function get(e) {
                  return this.dict[e.toString()];
                },
                has: function has(e) {
                  return e.toString() in this.dict;
                },
                put: function put(e, t) {
                  this.dict[e.toString()] = t;
                },
                putAlias: function putAlias(e, t) {
                  this.dict[e.toString()] = this.get(t);
                },
                forEach: function forEach(e, t) {
                  for (var r in this.dict) e.call(t, this.dict[r]);
                },
                clear: function clear() {
                  this.dict = Object.create(null);
                }
              }, e;
            }();
          t.EOF = d, t.Cmd = m, t.Dict = g, t.Name = p, t.Ref = v, t.RefSet = b, t.RefSetCache = y, t.isEOF = n, t.isCmd = a, t.isDict = o, t.isName = i, t.isRef = s, t.isRefsEqual = l, t.isStream = c;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(35),
            o = r(36),
            s = r(19),
            l = n.Util,
            c = n.error,
            u = n.info,
            h = n.isInt,
            f = n.isArray,
            d = n.createObjectURL,
            p = n.shadow,
            m = n.isSpace,
            g = i.Dict,
            v = i.isDict,
            b = i.isStream,
            y = a.Jbig2Image,
            w = o.JpegImage,
            x = s.JpxImage,
            _ = function () {
              function e(e, t, r, n) {
                this.bytes = e instanceof Uint8Array ? e : new Uint8Array(e), this.start = t || 0, this.pos = this.start, this.end = t + r || this.bytes.length, this.dict = n;
              }
              return e.prototype = {
                get length() {
                  return this.end - this.start;
                },
                get isEmpty() {
                  return 0 === this.length;
                },
                getByte: function getByte() {
                  return this.pos >= this.end ? -1 : this.bytes[this.pos++];
                },
                getUint16: function getUint16() {
                  var e = this.getByte(),
                    t = this.getByte();
                  return -1 === e || -1 === t ? -1 : (e << 8) + t;
                },
                getInt32: function getInt32() {
                  return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
                },
                getBytes: function getBytes(e) {
                  var t = this.bytes,
                    r = this.pos,
                    n = this.end;
                  if (!e) return t.subarray(r, n);
                  var i = r + e;
                  return i > n && (i = n), this.pos = i, t.subarray(r, i);
                },
                peekByte: function peekByte() {
                  var e = this.getByte();
                  return this.pos--, e;
                },
                peekBytes: function peekBytes(e) {
                  var t = this.getBytes(e);
                  return this.pos -= t.length, t;
                },
                skip: function skip(e) {
                  e || (e = 1), this.pos += e;
                },
                reset: function reset() {
                  this.pos = this.start;
                },
                moveStart: function moveStart() {
                  this.start = this.pos;
                },
                makeSubStream: function makeSubStream(t, r, n) {
                  return new e(this.bytes.buffer, t, r, n);
                }
              }, e;
            }(),
            S = function () {
              function e(e) {
                for (var t = e.length, r = new Uint8Array(t), n = 0; n < t; ++n) r[n] = e.charCodeAt(n);
                _.call(this, r);
              }
              return e.prototype = _.prototype, e;
            }(),
            C = function () {
              function e(e) {
                if (this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = t, this.minBufferLength = 512, e) for (; this.minBufferLength < e;) this.minBufferLength *= 2;
              }
              var t = new Uint8Array(0);
              return e.prototype = {
                get isEmpty() {
                  for (; !this.eof && 0 === this.bufferLength;) this.readBlock();
                  return 0 === this.bufferLength;
                },
                ensureBuffer: function ensureBuffer(e) {
                  var t = this.buffer;
                  if (e <= t.byteLength) return t;
                  for (var r = this.minBufferLength; r < e;) r *= 2;
                  var n = new Uint8Array(r);
                  return n.set(t), this.buffer = n;
                },
                getByte: function getByte() {
                  for (var e = this.pos; this.bufferLength <= e;) {
                    if (this.eof) return -1;
                    this.readBlock();
                  }
                  return this.buffer[this.pos++];
                },
                getUint16: function getUint16() {
                  var e = this.getByte(),
                    t = this.getByte();
                  return -1 === e || -1 === t ? -1 : (e << 8) + t;
                },
                getInt32: function getInt32() {
                  return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
                },
                getBytes: function getBytes(e) {
                  var t,
                    r = this.pos;
                  if (e) {
                    for (this.ensureBuffer(r + e), t = r + e; !this.eof && this.bufferLength < t;) this.readBlock();
                    var n = this.bufferLength;
                    t > n && (t = n);
                  } else {
                    for (; !this.eof;) this.readBlock();
                    t = this.bufferLength;
                  }
                  return this.pos = t, this.buffer.subarray(r, t);
                },
                peekByte: function peekByte() {
                  var e = this.getByte();
                  return this.pos--, e;
                },
                peekBytes: function peekBytes(e) {
                  var t = this.getBytes(e);
                  return this.pos -= t.length, t;
                },
                makeSubStream: function makeSubStream(e, t, r) {
                  for (var n = e + t; this.bufferLength <= n && !this.eof;) this.readBlock();
                  return new _(this.buffer, e, t, r);
                },
                skip: function skip(e) {
                  e || (e = 1), this.pos += e;
                },
                reset: function reset() {
                  this.pos = 0;
                },
                getBaseStreams: function getBaseStreams() {
                  return this.str && this.str.getBaseStreams ? this.str.getBaseStreams() : [];
                }
              }, e;
            }(),
            E = function () {
              function e(e) {
                this.streams = e, C.call(this, null);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                var e = this.streams;
                if (0 === e.length) return void (this.eof = !0);
                var t = e.shift(),
                  r = t.getBytes(),
                  n = this.bufferLength,
                  i = n + r.length;
                this.ensureBuffer(i).set(r, n), this.bufferLength = i;
              }, e.prototype.getBaseStreams = function () {
                for (var e = [], t = 0, r = this.streams.length; t < r; t++) {
                  var n = this.streams[t];
                  n.getBaseStreams && l.appendToArray(e, n.getBaseStreams());
                }
                return e;
              }, e;
            }(),
            A = function () {
              function e(e, t) {
                this.str = e, this.dict = e.dict;
                var r = e.getByte(),
                  n = e.getByte();
                -1 !== r && -1 !== n || c("Invalid header in flate stream: " + r + ", " + n), 8 != (15 & r) && c("Unknown compression method in flate stream: " + r + ", " + n), ((r << 8) + n) % 31 != 0 && c("Bad FCHECK in flate stream: " + r + ", " + n), 32 & n && c("FDICT bit set in flate stream: " + r + ", " + n), this.codeSize = 0, this.codeBuf = 0, C.call(this, t);
              }
              var t = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
                r = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]),
                n = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]),
                i = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9],
                a = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
              return e.prototype = Object.create(C.prototype), e.prototype.getBits = function (e) {
                for (var t, r = this.str, n = this.codeSize, i = this.codeBuf; n < e;) -1 === (t = r.getByte()) && c("Bad encoding in flate stream"), i |= t << n, n += 8;
                return t = i & (1 << e) - 1, this.codeBuf = i >> e, this.codeSize = n -= e, t;
              }, e.prototype.getCode = function (e) {
                for (var t, r = this.str, n = e[0], i = e[1], a = this.codeSize, o = this.codeBuf; a < i && -1 !== (t = r.getByte());) o |= t << a, a += 8;
                var s = n[o & (1 << i) - 1],
                  l = s >> 16,
                  u = 65535 & s;
                return (l < 1 || a < l) && c("Bad encoding in flate stream"), this.codeBuf = o >> l, this.codeSize = a - l, u;
              }, e.prototype.generateHuffmanTable = function (e) {
                var t,
                  r = e.length,
                  n = 0;
                for (t = 0; t < r; ++t) e[t] > n && (n = e[t]);
                for (var i = 1 << n, a = new Int32Array(i), o = 1, s = 0, l = 2; o <= n; ++o, s <<= 1, l <<= 1) for (var c = 0; c < r; ++c) if (e[c] === o) {
                  var u = 0,
                    h = s;
                  for (t = 0; t < o; ++t) u = u << 1 | 1 & h, h >>= 1;
                  for (t = u; t < i; t += l) a[t] = o << 16 | c;
                  ++s;
                }
                return [a, n];
              }, e.prototype.readBlock = function () {
                var e,
                  o,
                  s = this.str,
                  l = this.getBits(3);
                if (1 & l && (this.eof = !0), 0 !== (l >>= 1)) {
                  var u, h;
                  if (1 === l) u = i, h = a;else if (2 === l) {
                    var f,
                      d = this.getBits(5) + 257,
                      p = this.getBits(5) + 1,
                      m = this.getBits(4) + 4,
                      g = new Uint8Array(t.length);
                    for (f = 0; f < m; ++f) g[t[f]] = this.getBits(3);
                    var v = this.generateHuffmanTable(g);
                    o = 0, f = 0;
                    for (var b, y, w, x = d + p, _ = new Uint8Array(x); f < x;) {
                      var S = this.getCode(v);
                      if (16 === S) b = 2, y = 3, w = o;else if (17 === S) b = 3, y = 3, w = o = 0;else {
                        if (18 !== S) {
                          _[f++] = o = S;
                          continue;
                        }
                        b = 7, y = 11, w = o = 0;
                      }
                      for (var C = this.getBits(b) + y; C-- > 0;) _[f++] = w;
                    }
                    u = this.generateHuffmanTable(_.subarray(0, d)), h = this.generateHuffmanTable(_.subarray(d, x));
                  } else c("Unknown block type in flate stream");
                  e = this.buffer;
                  for (var E = e ? e.length : 0, A = this.bufferLength;;) {
                    var T = this.getCode(u);
                    if (T < 256) A + 1 >= E && (e = this.ensureBuffer(A + 1), E = e.length), e[A++] = T;else {
                      if (256 === T) return void (this.bufferLength = A);
                      T -= 257, T = r[T];
                      var k = T >> 16;
                      k > 0 && (k = this.getBits(k)), o = (65535 & T) + k, T = this.getCode(h), T = n[T], k = T >> 16, k > 0 && (k = this.getBits(k));
                      var R = (65535 & T) + k;
                      A + o >= E && (e = this.ensureBuffer(A + o), E = e.length);
                      for (var I = 0; I < o; ++I, ++A) e[A] = e[A - R];
                    }
                  }
                } else {
                  var M;
                  -1 === (M = s.getByte()) && c("Bad block header in flate stream");
                  var O = M;
                  -1 === (M = s.getByte()) && c("Bad block header in flate stream"), O |= M << 8, -1 === (M = s.getByte()) && c("Bad block header in flate stream");
                  var P = M;
                  -1 === (M = s.getByte()) && c("Bad block header in flate stream"), P |= M << 8, P === (65535 & ~O) || 0 === O && 0 === P || c("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                  var B = this.bufferLength;
                  e = this.ensureBuffer(B + O);
                  var D = B + O;
                  if (this.bufferLength = D, 0 === O) -1 === s.peekByte() && (this.eof = !0);else for (var L = B; L < D; ++L) {
                    if (-1 === (M = s.getByte())) {
                      this.eof = !0;
                      break;
                    }
                    e[L] = M;
                  }
                }
              }, e;
            }(),
            T = function () {
              function e(e, t, r) {
                if (!v(r)) return e;
                var n = this.predictor = r.get("Predictor") || 1;
                if (n <= 1) return e;
                2 !== n && (n < 10 || n > 15) && c("Unsupported predictor: " + n), this.readBlock = 2 === n ? this.readBlockTiff : this.readBlockPng, this.str = e, this.dict = e.dict;
                var i = this.colors = r.get("Colors") || 1,
                  a = this.bits = r.get("BitsPerComponent") || 8,
                  o = this.columns = r.get("Columns") || 1;
                return this.pixBytes = i * a + 7 >> 3, this.rowBytes = o * i * a + 7 >> 3, C.call(this, t), this;
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlockTiff = function () {
                var e = this.rowBytes,
                  t = this.bufferLength,
                  r = this.ensureBuffer(t + e),
                  n = this.bits,
                  i = this.colors,
                  a = this.str.getBytes(e);
                if (this.eof = !a.length, !this.eof) {
                  var o,
                    s = 0,
                    l = 0,
                    c = 0,
                    u = 0,
                    h = t;
                  if (1 === n && 1 === i) for (o = 0; o < e; ++o) {
                    var f = a[o] ^ s;
                    f ^= f >> 1, f ^= f >> 2, f ^= f >> 4, s = (1 & f) << 7, r[h++] = f;
                  } else if (8 === n) {
                    for (o = 0; o < i; ++o) r[h++] = a[o];
                    for (; o < e; ++o) r[h] = r[h - i] + a[o], h++;
                  } else {
                    var d = new Uint8Array(i + 1),
                      p = (1 << n) - 1,
                      m = 0,
                      g = t,
                      v = this.columns;
                    for (o = 0; o < v; ++o) for (var b = 0; b < i; ++b) c < n && (s = s << 8 | 255 & a[m++], c += 8), d[b] = d[b] + (s >> c - n) & p, c -= n, l = l << n | d[b], (u += n) >= 8 && (r[g++] = l >> u - 8 & 255, u -= 8);
                    u > 0 && (r[g++] = (l << 8 - u) + (s & (1 << 8 - u) - 1));
                  }
                  this.bufferLength += e;
                }
              }, e.prototype.readBlockPng = function () {
                var e = this.rowBytes,
                  t = this.pixBytes,
                  r = this.str.getByte(),
                  n = this.str.getBytes(e);
                if (this.eof = !n.length, !this.eof) {
                  var i = this.bufferLength,
                    a = this.ensureBuffer(i + e),
                    o = a.subarray(i - e, i);
                  0 === o.length && (o = new Uint8Array(e));
                  var s,
                    l,
                    u,
                    h = i;
                  switch (r) {
                    case 0:
                      for (s = 0; s < e; ++s) a[h++] = n[s];
                      break;
                    case 1:
                      for (s = 0; s < t; ++s) a[h++] = n[s];
                      for (; s < e; ++s) a[h] = a[h - t] + n[s] & 255, h++;
                      break;
                    case 2:
                      for (s = 0; s < e; ++s) a[h++] = o[s] + n[s] & 255;
                      break;
                    case 3:
                      for (s = 0; s < t; ++s) a[h++] = (o[s] >> 1) + n[s];
                      for (; s < e; ++s) a[h] = (o[s] + a[h - t] >> 1) + n[s] & 255, h++;
                      break;
                    case 4:
                      for (s = 0; s < t; ++s) l = o[s], u = n[s], a[h++] = l + u;
                      for (; s < e; ++s) {
                        l = o[s];
                        var f = o[s - t],
                          d = a[h - t],
                          p = d + l - f,
                          m = p - d;
                        m < 0 && (m = -m);
                        var g = p - l;
                        g < 0 && (g = -g);
                        var v = p - f;
                        v < 0 && (v = -v), u = n[s], a[h++] = m <= g && m <= v ? d + u : g <= v ? l + u : f + u;
                      }
                      break;
                    default:
                      c("Unsupported predictor: " + r);
                  }
                  this.bufferLength += e;
                }
              }, e;
            }(),
            k = function () {
              function e(e, t, r, n) {
                for (var i; -1 !== (i = e.getByte());) if (255 === i) {
                  e.skip(-1);
                  break;
                }
                this.stream = e, this.maybeLength = t, this.dict = r, this.params = n, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), Object.defineProperty(e.prototype, "bytes", {
                get: function get() {
                  return p(this, "bytes", this.stream.getBytes(this.maybeLength));
                },
                configurable: !0
              }), e.prototype.ensureBuffer = function (e) {
                if (!this.bufferLength) {
                  var t = new w(),
                    r = this.dict.getArray("Decode", "D");
                  if (this.forceRGB && f(r)) {
                    for (var n = this.dict.get("BitsPerComponent") || 8, i = r.length, a = new Int32Array(i), o = !1, s = (1 << n) - 1, l = 0; l < i; l += 2) a[l] = 256 * (r[l + 1] - r[l]) | 0, a[l + 1] = r[l] * s | 0, 256 === a[l] && 0 === a[l + 1] || (o = !0);
                    o && (t.decodeTransform = a);
                  }
                  if (v(this.params)) {
                    var c = this.params.get("ColorTransform");
                    h(c) && (t.colorTransform = c);
                  }
                  t.parse(this.bytes);
                  var u = t.getData(this.drawWidth, this.drawHeight, this.forceRGB);
                  this.buffer = u, this.bufferLength = u.length, this.eof = !0;
                }
              }, e.prototype.getBytes = function (e) {
                return this.ensureBuffer(), this.buffer;
              }, e.prototype.getIR = function (e) {
                return d(this.bytes, "image/jpeg", e);
              }, e;
            }(),
            R = function () {
              function e(e, t, r, n) {
                this.stream = e, this.maybeLength = t, this.dict = r, this.params = n, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), Object.defineProperty(e.prototype, "bytes", {
                get: function get() {
                  return p(this, "bytes", this.stream.getBytes(this.maybeLength));
                },
                configurable: !0
              }), e.prototype.ensureBuffer = function (e) {
                if (!this.bufferLength) {
                  var t = new x();
                  t.parse(this.bytes);
                  var r = t.width,
                    n = t.height,
                    i = t.componentsCount,
                    a = t.tiles.length;
                  if (1 === a) this.buffer = t.tiles[0].items;else {
                    for (var o = new Uint8Array(r * n * i), s = 0; s < a; s++) for (var l = t.tiles[s], c = l.width, u = l.height, h = l.left, f = l.top, d = l.items, p = 0, m = (r * f + h) * i, g = r * i, v = c * i, b = 0; b < u; b++) {
                      var y = d.subarray(p, p + v);
                      o.set(y, m), p += v, m += g;
                    }
                    this.buffer = o;
                  }
                  this.bufferLength = this.buffer.length, this.eof = !0;
                }
              }, e;
            }(),
            I = function () {
              function e(e, t, r, n) {
                this.stream = e, this.maybeLength = t, this.dict = r, this.params = n, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), Object.defineProperty(e.prototype, "bytes", {
                get: function get() {
                  return p(this, "bytes", this.stream.getBytes(this.maybeLength));
                },
                configurable: !0
              }), e.prototype.ensureBuffer = function (e) {
                if (!this.bufferLength) {
                  var t = new y(),
                    r = [];
                  if (v(this.params)) {
                    var n = this.params.get("JBIG2Globals");
                    if (b(n)) {
                      var i = n.getBytes();
                      r.push({
                        data: i,
                        start: 0,
                        end: i.length
                      });
                    }
                  }
                  r.push({
                    data: this.bytes,
                    start: 0,
                    end: this.bytes.length
                  });
                  for (var a = t.parseChunks(r), o = a.length, s = 0; s < o; s++) a[s] ^= 255;
                  this.buffer = a, this.bufferLength = o, this.eof = !0;
                }
              }, e;
            }(),
            M = function () {
              function e(e, t, r) {
                this.str = e, this.dict = e.dict, this.decrypt = r, this.nextChunk = null, this.initialized = !1, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                var e;
                if (this.initialized ? e = this.nextChunk : (e = this.str.getBytes(512), this.initialized = !0), !e || 0 === e.length) return void (this.eof = !0);
                this.nextChunk = this.str.getBytes(512);
                var t = this.nextChunk && this.nextChunk.length > 0;
                e = (0, this.decrypt)(e, !t);
                var r,
                  n = this.bufferLength,
                  i = e.length,
                  a = this.ensureBuffer(n + i);
                for (r = 0; r < i; r++) a[n++] = e[r];
                this.bufferLength = n;
              }, e;
            }(),
            O = function () {
              function e(e, t) {
                this.str = e, this.dict = e.dict, this.input = new Uint8Array(5), t && (t *= .8), C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                for (var e = this.str, t = e.getByte(); m(t);) t = e.getByte();
                if (-1 === t || 126 === t) return void (this.eof = !0);
                var r,
                  n,
                  i = this.bufferLength;
                if (122 === t) {
                  for (r = this.ensureBuffer(i + 4), n = 0; n < 4; ++n) r[i + n] = 0;
                  this.bufferLength += 4;
                } else {
                  var a = this.input;
                  for (a[0] = t, n = 1; n < 5; ++n) {
                    for (t = e.getByte(); m(t);) t = e.getByte();
                    if (a[n] = t, -1 === t || 126 === t) break;
                  }
                  if (r = this.ensureBuffer(i + n - 1), this.bufferLength += n - 1, n < 5) {
                    for (; n < 5; ++n) a[n] = 117;
                    this.eof = !0;
                  }
                  var o = 0;
                  for (n = 0; n < 5; ++n) o = 85 * o + (a[n] - 33);
                  for (n = 3; n >= 0; --n) r[i + n] = 255 & o, o >>= 8;
                }
              }, e;
            }(),
            P = function () {
              function e(e, t) {
                this.str = e, this.dict = e.dict, this.firstDigit = -1, t && (t *= .5), C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                var e = this.str.getBytes(8e3);
                if (!e.length) return void (this.eof = !0);
                for (var t = e.length + 1 >> 1, r = this.ensureBuffer(this.bufferLength + t), n = this.bufferLength, i = this.firstDigit, a = 0, o = e.length; a < o; a++) {
                  var s,
                    l = e[a];
                  if (l >= 48 && l <= 57) s = 15 & l;else {
                    if (!(l >= 65 && l <= 70 || l >= 97 && l <= 102)) {
                      if (62 === l) {
                        this.eof = !0;
                        break;
                      }
                      continue;
                    }
                    s = 9 + (15 & l);
                  }
                  i < 0 ? i = s : (r[n++] = i << 4 | s, i = -1);
                }
                i >= 0 && this.eof && (r[n++] = i << 4, i = -1), this.firstDigit = i, this.bufferLength = n;
              }, e;
            }(),
            B = function () {
              function e(e, t) {
                this.str = e, this.dict = e.dict, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                var e = this.str.getBytes(2);
                if (!e || e.length < 2 || 128 === e[0]) return void (this.eof = !0);
                var t,
                  r = this.bufferLength,
                  n = e[0];
                if (n < 128) {
                  if (t = this.ensureBuffer(r + n + 1), t[r++] = e[1], n > 0) {
                    var i = this.str.getBytes(n);
                    t.set(i, r), r += n;
                  }
                } else {
                  n = 257 - n;
                  var a = e[1];
                  t = this.ensureBuffer(r + n + 1);
                  for (var o = 0; o < n; o++) t[r++] = a;
                }
                this.bufferLength = r;
              }, e;
            }(),
            D = function () {
              function e(e, t, r) {
                this.str = e, this.dict = e.dict, r = r || g.empty, this.encoding = r.get("K") || 0, this.eoline = r.get("EndOfLine") || !1, this.byteAlign = r.get("EncodedByteAlign") || !1, this.columns = r.get("Columns") || 1728, this.rows = r.get("Rows") || 0;
                var n = r.get("EndOfBlock");
                null !== n && void 0 !== n || (n = !0), this.eoblock = n, this.black = r.get("BlackIs1") || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0;
                for (var i; 0 === (i = this.lookBits(12));) this.eatBits(1);
                1 === i && this.eatBits(12), this.encoding > 0 && (this.nextLine2D = !this.lookBits(1), this.eatBits(1)), C.call(this, t);
              }
              var t = [[-1, -1], [-1, -1], [7, 8], [7, 7], [6, 6], [6, 6], [6, 5], [6, 5], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [4, 0], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [3, 3], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2], [1, 2]],
                r = [[-1, -1], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]],
                n = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]],
                i = [[-1, -1], [-1, -1], [12, -2], [12, -2], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]],
                a = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]],
                o = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
              return e.prototype = Object.create(C.prototype), e.prototype.readBlock = function () {
                for (; !this.eof;) {
                  var e = this.lookChar();
                  this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = e;
                }
              }, e.prototype.addPixels = function (e, t) {
                var r = this.codingLine,
                  n = this.codingPos;
                e > r[n] && (e > this.columns && (u("row is wrong length"), this.err = !0, e = this.columns), 1 & n ^ t && ++n, r[n] = e), this.codingPos = n;
              }, e.prototype.addPixelsNeg = function (e, t) {
                var r = this.codingLine,
                  n = this.codingPos;
                if (e > r[n]) e > this.columns && (u("row is wrong length"), this.err = !0, e = this.columns), 1 & n ^ t && ++n, r[n] = e;else if (e < r[n]) {
                  for (e < 0 && (u("invalid code"), this.err = !0, e = 0); n > 0 && e < r[n - 1];) --n;
                  r[n] = e;
                }
                this.codingPos = n;
              }, e.prototype.lookChar = function () {
                var e,
                  t,
                  r,
                  n,
                  i = this.refLine,
                  a = this.codingLine,
                  o = this.columns;
                if (0 === this.outputBits) {
                  if (this.eof) return null;
                  this.err = !1;
                  var s, l, c;
                  if (this.nextLine2D) {
                    for (n = 0; a[n] < o; ++n) i[n] = a[n];
                    for (i[n++] = o, i[n] = o, a[0] = 0, this.codingPos = 0, e = 0, t = 0; a[this.codingPos] < o;) switch (s = this.getTwoDimCode()) {
                      case 0:
                        this.addPixels(i[e + 1], t), i[e + 1] < o && (e += 2);
                        break;
                      case 1:
                        if (s = l = 0, t) {
                          do {
                            s += c = this.getBlackCode();
                          } while (c >= 64);
                          do {
                            l += c = this.getWhiteCode();
                          } while (c >= 64);
                        } else {
                          do {
                            s += c = this.getWhiteCode();
                          } while (c >= 64);
                          do {
                            l += c = this.getBlackCode();
                          } while (c >= 64);
                        }
                        for (this.addPixels(a[this.codingPos] + s, t), a[this.codingPos] < o && this.addPixels(a[this.codingPos] + l, 1 ^ t); i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 7:
                        if (this.addPixels(i[e] + 3, t), t ^= 1, a[this.codingPos] < o) for (++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 5:
                        if (this.addPixels(i[e] + 2, t), t ^= 1, a[this.codingPos] < o) for (++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 3:
                        if (this.addPixels(i[e] + 1, t), t ^= 1, a[this.codingPos] < o) for (++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 2:
                        if (this.addPixels(i[e], t), t ^= 1, a[this.codingPos] < o) for (++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 8:
                        if (this.addPixelsNeg(i[e] - 3, t), t ^= 1, a[this.codingPos] < o) for (e > 0 ? --e : ++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 6:
                        if (this.addPixelsNeg(i[e] - 2, t), t ^= 1, a[this.codingPos] < o) for (e > 0 ? --e : ++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case 4:
                        if (this.addPixelsNeg(i[e] - 1, t), t ^= 1, a[this.codingPos] < o) for (e > 0 ? --e : ++e; i[e] <= a[this.codingPos] && i[e] < o;) e += 2;
                        break;
                      case -1:
                        this.addPixels(o, 0), this.eof = !0;
                        break;
                      default:
                        u("bad 2d code"), this.addPixels(o, 0), this.err = !0;
                    }
                  } else for (a[0] = 0, this.codingPos = 0, t = 0; a[this.codingPos] < o;) {
                    if (s = 0, t) do {
                      s += c = this.getBlackCode();
                    } while (c >= 64);else do {
                      s += c = this.getWhiteCode();
                    } while (c >= 64);
                    this.addPixels(a[this.codingPos] + s, t), t ^= 1;
                  }
                  var h = !1;
                  if (this.byteAlign && (this.inputBits &= -8), this.eoblock || this.row !== this.rows - 1) {
                    if (s = this.lookBits(12), this.eoline) for (; -1 !== s && 1 !== s;) this.eatBits(1), s = this.lookBits(12);else for (; 0 === s;) this.eatBits(1), s = this.lookBits(12);
                    1 === s ? (this.eatBits(12), h = !0) : -1 === s && (this.eof = !0);
                  } else this.eof = !0;
                  if (!this.eof && this.encoding > 0 && (this.nextLine2D = !this.lookBits(1), this.eatBits(1)), this.eoblock && h && this.byteAlign) {
                    if (1 === (s = this.lookBits(12))) {
                      if (this.eatBits(12), this.encoding > 0 && (this.lookBits(1), this.eatBits(1)), this.encoding >= 0) for (n = 0; n < 4; ++n) s = this.lookBits(12), 1 !== s && u("bad rtc code: " + s), this.eatBits(12), this.encoding > 0 && (this.lookBits(1), this.eatBits(1));
                      this.eof = !0;
                    }
                  } else if (this.err && this.eoline) {
                    for (;;) {
                      if (-1 === (s = this.lookBits(13))) return this.eof = !0, null;
                      if (s >> 1 == 1) break;
                      this.eatBits(1);
                    }
                    this.eatBits(12), this.encoding > 0 && (this.eatBits(1), this.nextLine2D = !(1 & s));
                  }
                  a[0] > 0 ? this.outputBits = a[this.codingPos = 0] : this.outputBits = a[this.codingPos = 1], this.row++;
                }
                var f;
                if (this.outputBits >= 8) f = 1 & this.codingPos ? 0 : 255, this.outputBits -= 8, 0 === this.outputBits && a[this.codingPos] < o && (this.codingPos++, this.outputBits = a[this.codingPos] - a[this.codingPos - 1]);else {
                  r = 8, f = 0;
                  do {
                    this.outputBits > r ? (f <<= r, 1 & this.codingPos || (f |= 255 >> 8 - r), this.outputBits -= r, r = 0) : (f <<= this.outputBits, 1 & this.codingPos || (f |= 255 >> 8 - this.outputBits), r -= this.outputBits, this.outputBits = 0, a[this.codingPos] < o ? (this.codingPos++, this.outputBits = a[this.codingPos] - a[this.codingPos - 1]) : r > 0 && (f <<= r, r = 0));
                  } while (r);
                }
                return this.black && (f ^= 255), f;
              }, e.prototype.findTableCode = function (e, t, r, n) {
                for (var i = n || 0, a = e; a <= t; ++a) {
                  var o = this.lookBits(a);
                  if (-1 === o) return [!0, 1, !1];
                  if (a < t && (o <<= t - a), !i || o >= i) {
                    var s = r[o - i];
                    if (s[0] === a) return this.eatBits(a), [!0, s[1], !0];
                  }
                }
                return [!1, 0, !1];
              }, e.prototype.getTwoDimCode = function () {
                var e,
                  r = 0;
                if (this.eoblock) {
                  if (r = this.lookBits(7), (e = t[r]) && e[0] > 0) return this.eatBits(e[0]), e[1];
                } else {
                  var n = this.findTableCode(1, 7, t);
                  if (n[0] && n[2]) return n[1];
                }
                return u("Bad two dim code"), -1;
              }, e.prototype.getWhiteCode = function () {
                var e,
                  t = 0;
                if (this.eoblock) {
                  if (-1 === (t = this.lookBits(12))) return 1;
                  if (e = t >> 5 == 0 ? r[t] : n[t >> 3], e[0] > 0) return this.eatBits(e[0]), e[1];
                } else {
                  var i = this.findTableCode(1, 9, n);
                  if (i[0]) return i[1];
                  if (i = this.findTableCode(11, 12, r), i[0]) return i[1];
                }
                return u("bad white code"), this.eatBits(1), 1;
              }, e.prototype.getBlackCode = function () {
                var e, t;
                if (this.eoblock) {
                  if (-1 === (e = this.lookBits(13))) return 1;
                  if (t = e >> 7 == 0 ? i[e] : e >> 9 == 0 && e >> 7 != 0 ? a[(e >> 1) - 64] : o[e >> 7], t[0] > 0) return this.eatBits(t[0]), t[1];
                } else {
                  var r = this.findTableCode(2, 6, o);
                  if (r[0]) return r[1];
                  if (r = this.findTableCode(7, 12, a, 64), r[0]) return r[1];
                  if (r = this.findTableCode(10, 13, i), r[0]) return r[1];
                }
                return u("bad black code"), this.eatBits(1), 1;
              }, e.prototype.lookBits = function (e) {
                for (var t; this.inputBits < e;) {
                  if (-1 === (t = this.str.getByte())) return 0 === this.inputBits ? -1 : this.inputBuf << e - this.inputBits & 65535 >> 16 - e;
                  this.inputBuf = this.inputBuf << 8 | t, this.inputBits += 8;
                }
                return this.inputBuf >> this.inputBits - e & 65535 >> 16 - e;
              }, e.prototype.eatBits = function (e) {
                (this.inputBits -= e) < 0 && (this.inputBits = 0);
              }, e;
            }(),
            L = function () {
              function e(e, t, r) {
                this.str = e, this.dict = e.dict, this.cachedData = 0, this.bitsCached = 0;
                for (var n = {
                    earlyChange: r,
                    codeLength: 9,
                    nextCode: 258,
                    dictionaryValues: new Uint8Array(4096),
                    dictionaryLengths: new Uint16Array(4096),
                    dictionaryPrevCodes: new Uint16Array(4096),
                    currentSequence: new Uint8Array(4096),
                    currentSequenceLength: 0
                  }, i = 0; i < 256; ++i) n.dictionaryValues[i] = i, n.dictionaryLengths[i] = 1;
                this.lzwState = n, C.call(this, t);
              }
              return e.prototype = Object.create(C.prototype), e.prototype.readBits = function (e) {
                for (var t = this.bitsCached, r = this.cachedData; t < e;) {
                  var n = this.str.getByte();
                  if (-1 === n) return this.eof = !0, null;
                  r = r << 8 | n, t += 8;
                }
                return this.bitsCached = t -= e, this.cachedData = r, this.lastCode = null, r >>> t & (1 << e) - 1;
              }, e.prototype.readBlock = function () {
                var e,
                  t,
                  r,
                  n = 1024,
                  i = this.lzwState;
                if (i) {
                  var a = i.earlyChange,
                    o = i.nextCode,
                    s = i.dictionaryValues,
                    l = i.dictionaryLengths,
                    c = i.dictionaryPrevCodes,
                    u = i.codeLength,
                    h = i.prevCode,
                    f = i.currentSequence,
                    d = i.currentSequenceLength,
                    p = 0,
                    m = this.bufferLength,
                    g = this.ensureBuffer(this.bufferLength + n);
                  for (e = 0; e < 512; e++) {
                    var v = this.readBits(u),
                      b = d > 0;
                    if (v < 256) f[0] = v, d = 1;else {
                      if (!(v >= 258)) {
                        if (256 === v) {
                          u = 9, o = 258, d = 0;
                          continue;
                        }
                        this.eof = !0, delete this.lzwState;
                        break;
                      }
                      if (v < o) for (d = l[v], t = d - 1, r = v; t >= 0; t--) f[t] = s[r], r = c[r];else f[d++] = f[0];
                    }
                    if (b && (c[o] = h, l[o] = l[h] + 1, s[o] = f[0], o++, u = o + a & o + a - 1 ? u : 0 | Math.min(Math.log(o + a) / .6931471805599453 + 1, 12)), h = v, p += d, n < p) {
                      do {
                        n += 512;
                      } while (n < p);
                      g = this.ensureBuffer(this.bufferLength + n);
                    }
                    for (t = 0; t < d; t++) g[m++] = f[t];
                  }
                  i.nextCode = o, i.codeLength = u, i.prevCode = h, i.currentSequenceLength = d, this.bufferLength = m;
                }
              }, e;
            }(),
            F = function () {
              function e() {
                _.call(this, new Uint8Array(0));
              }
              return e.prototype = _.prototype, e;
            }();
          t.Ascii85Stream = O, t.AsciiHexStream = P, t.CCITTFaxStream = D, t.DecryptStream = M, t.DecodeStream = C, t.FlateStream = A, t.Jbig2Stream = I, t.JpegStream = k, t.JpxStream = R, t.NullStream = F, t.PredictorStream = T, t.RunLengthStream = B, t.Stream = _, t.StreamsSequenceStream = E, t.StringStream = S, t.LZWStream = L;
        }, function (e, t, r) {
          "use strict";

          function n(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          function i(e, t) {
            var r = t && t.url;
            if (e.href = e.title = r ? (0, u.removeNullCharacters)(r) : "", r) {
              var n = t.target;
              void 0 === n && (n = o("externalLinkTarget")), e.target = v[n];
              var i = t.rel;
              void 0 === i && (i = o("externalLinkRel")), e.rel = i;
            }
          }
          function a(e) {
            var t = e.indexOf("#"),
              r = e.indexOf("?"),
              n = Math.min(t > 0 ? t : e.length, r > 0 ? r : e.length);
            return e.substring(e.lastIndexOf("/", n) + 1, n);
          }
          function o(e) {
            var t = u.globalScope.PDFJS;
            switch (e) {
              case "pdfBug":
                return !!t && t.pdfBug;
              case "disableAutoFetch":
                return !!t && t.disableAutoFetch;
              case "disableStream":
                return !!t && t.disableStream;
              case "disableRange":
                return !!t && t.disableRange;
              case "disableFontFace":
                return !!t && t.disableFontFace;
              case "disableCreateObjectURL":
                return !!t && t.disableCreateObjectURL;
              case "disableWebGL":
                return !t || t.disableWebGL;
              case "cMapUrl":
                return t ? t.cMapUrl : null;
              case "cMapPacked":
                return !!t && t.cMapPacked;
              case "postMessageTransfers":
                return !t || t.postMessageTransfers;
              case "workerPort":
                return t ? t.workerPort : null;
              case "workerSrc":
                return t ? t.workerSrc : null;
              case "disableWorker":
                return !!t && t.disableWorker;
              case "maxImageSize":
                return t ? t.maxImageSize : -1;
              case "imageResourcesPath":
                return t ? t.imageResourcesPath : "";
              case "isEvalSupported":
                return !t || t.isEvalSupported;
              case "externalLinkTarget":
                if (!t) return g.NONE;
                switch (t.externalLinkTarget) {
                  case g.NONE:
                  case g.SELF:
                  case g.BLANK:
                  case g.PARENT:
                  case g.TOP:
                    return t.externalLinkTarget;
                }
                return (0, u.warn)("PDFJS.externalLinkTarget is invalid: " + t.externalLinkTarget), t.externalLinkTarget = g.NONE, g.NONE;
              case "externalLinkRel":
                return t ? t.externalLinkRel : h;
              case "enableStats":
                return !(!t || !t.enableStats);
              case "pdfjsNext":
                return !(!t || !t.pdfjsNext);
              default:
                throw new Error("Unknown default setting: " + e);
            }
          }
          function s() {
            switch (o("externalLinkTarget")) {
              case g.NONE:
                return !1;
              case g.SELF:
              case g.BLANK:
              case g.PARENT:
              case g.TOP:
                return !0;
            }
          }
          function l(e, t) {
            (0, u.deprecated)("isValidUrl(), please use createValidAbsoluteUrl() instead.");
            var r = t ? "http://example.com" : null;
            return null !== (0, u.createValidAbsoluteUrl)(e, r);
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.DOMCMapReaderFactory = t.DOMCanvasFactory = t.DEFAULT_LINK_REL = t.getDefaultSetting = t.LinkTarget = t.getFilenameFromUrl = t.isValidUrl = t.isExternalLinkTargetSet = t.addLinkAttributes = t.RenderingCancelledException = t.CustomStyle = void 0;
          var c = function () {
              function e(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
              }
              return function (t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
              };
            }(),
            u = r(0),
            h = "noopener noreferrer nofollow",
            f = function () {
              function e() {
                n(this, e);
              }
              return c(e, [{
                key: "create",
                value: function value(e, t) {
                  (0, u.assert)(e > 0 && t > 0, "invalid canvas size");
                  var r = document.createElement("canvas"),
                    n = r.getContext("2d");
                  return r.width = e, r.height = t, {
                    canvas: r,
                    context: n
                  };
                }
              }, {
                key: "reset",
                value: function value(e, t, r) {
                  (0, u.assert)(e.canvas, "canvas is not specified"), (0, u.assert)(t > 0 && r > 0, "invalid canvas size"), e.canvas.width = t, e.canvas.height = r;
                }
              }, {
                key: "destroy",
                value: function value(e) {
                  (0, u.assert)(e.canvas, "canvas is not specified"), e.canvas.width = 0, e.canvas.height = 0, e.canvas = null, e.context = null;
                }
              }]), e;
            }(),
            d = function () {
              function e(t) {
                var r = t.baseUrl,
                  i = void 0 === r ? null : r,
                  a = t.isCompressed,
                  o = void 0 !== a && a;
                n(this, e), this.baseUrl = i, this.isCompressed = o;
              }
              return c(e, [{
                key: "fetch",
                value: function value(e) {
                  var t = this,
                    r = e.name;
                  return r ? new Promise(function (e, n) {
                    var i = t.baseUrl + r + (t.isCompressed ? ".bcmap" : ""),
                      a = new XMLHttpRequest();
                    a.open("GET", i, !0), t.isCompressed && (a.responseType = "arraybuffer"), a.onreadystatechange = function () {
                      if (a.readyState === XMLHttpRequest.DONE) {
                        if (200 === a.status || 0 === a.status) {
                          var r = void 0;
                          if (t.isCompressed && a.response ? r = new Uint8Array(a.response) : !t.isCompressed && a.responseText && (r = (0, u.stringToBytes)(a.responseText)), r) return void e({
                            cMapData: r,
                            compressionType: t.isCompressed ? u.CMapCompressionType.BINARY : u.CMapCompressionType.NONE
                          });
                        }
                        n(new Error("Unable to load " + (t.isCompressed ? "binary " : "") + "CMap at: " + i));
                      }
                    }, a.send(null);
                  }) : Promise.reject(new Error("CMap name must be specified."));
                }
              }]), e;
            }(),
            p = function () {
              function e() {}
              var t = ["ms", "Moz", "Webkit", "O"],
                r = Object.create(null);
              return e.getProp = function (e, n) {
                if (1 === arguments.length && "string" == typeof r[e]) return r[e];
                n = n || document.documentElement;
                var i,
                  a,
                  o = n.style;
                if ("string" == typeof o[e]) return r[e] = e;
                a = e.charAt(0).toUpperCase() + e.slice(1);
                for (var s = 0, l = t.length; s < l; s++) if (i = t[s] + a, "string" == typeof o[i]) return r[e] = i;
                return r[e] = "undefined";
              }, e.setProp = function (e, t, r) {
                var n = this.getProp(e);
                "undefined" !== n && (t.style[n] = r);
              }, e;
            }(),
            m = function () {
              function e(e, t) {
                this.message = e, this.type = t;
              }
              return e.prototype = new Error(), e.prototype.name = "RenderingCancelledException", e.constructor = e, e;
            }(),
            g = {
              NONE: 0,
              SELF: 1,
              BLANK: 2,
              PARENT: 3,
              TOP: 4
            },
            v = ["", "_self", "_blank", "_parent", "_top"];
          t.CustomStyle = p, t.RenderingCancelledException = m, t.addLinkAttributes = i, t.isExternalLinkTargetSet = s, t.isValidUrl = l, t.getFilenameFromUrl = a, t.LinkTarget = g, t.getDefaultSetting = o, t.DEFAULT_LINK_REL = h, t.DOMCanvasFactory = f, t.DOMCMapReaderFactory = d;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(7),
            o = n.error,
            s = n.info,
            l = n.isArray,
            c = n.isString,
            u = n.shadow,
            h = n.warn,
            f = i.isDict,
            d = i.isName,
            p = i.isStream,
            m = a.PDFFunction,
            g = function () {
              function e(e, t, r, n, i, a, o, s) {
                o = 1 !== o ? 0 : o;
                var l,
                  c,
                  u,
                  h,
                  f = r / i,
                  d = n / a,
                  p = 0,
                  m = new Uint16Array(i),
                  g = 3 * r;
                for (l = 0; l < i; l++) m[l] = 3 * Math.floor(l * f);
                for (l = 0; l < a; l++) for (u = Math.floor(l * d) * g, c = 0; c < i; c++) h = u + m[c], s[p++] = e[h++], s[p++] = e[h++], s[p++] = e[h++], p += o;
              }
              function t() {
                o("should not call ColorSpace constructor");
              }
              return t.prototype = {
                getRgb: function getRgb(e, t) {
                  var r = new Uint8Array(3);
                  return this.getRgbItem(e, t, r, 0), r;
                },
                getRgbItem: function getRgbItem(e, t, r, n) {
                  o("Should not call ColorSpace.getRgbItem");
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, s) {
                  o("Should not call ColorSpace.getRgbBuffer");
                },
                getOutputLength: function getOutputLength(e, t) {
                  o("Should not call ColorSpace.getOutputLength");
                },
                isPassthrough: function isPassthrough(e) {
                  return !1;
                },
                fillRgb: function fillRgb(t, r, n, i, a, o, s, l, c) {
                  var u,
                    h,
                    f = r * n,
                    d = null,
                    p = 1 << s,
                    m = n !== a || r !== i;
                  if (this.isPassthrough(s)) d = l;else if (1 === this.numComps && f > p && "DeviceGray" !== this.name && "DeviceRGB" !== this.name) {
                    var g,
                      v = s <= 8 ? new Uint8Array(p) : new Uint16Array(p);
                    for (u = 0; u < p; u++) v[u] = u;
                    var b = new Uint8Array(3 * p);
                    this.getRgbBuffer(v, 0, p, b, 0, s, 0);
                    var y, w;
                    if (m) for (d = new Uint8Array(3 * f), w = 0, u = 0; u < f; ++u) g = 3 * l[u], d[w++] = b[g], d[w++] = b[g + 1], d[w++] = b[g + 2];else for (y = 0, u = 0; u < f; ++u) g = 3 * l[u], t[y++] = b[g], t[y++] = b[g + 1], t[y++] = b[g + 2], y += c;
                  } else m ? (d = new Uint8Array(3 * f), this.getRgbBuffer(l, 0, f, d, 0, s, 0)) : this.getRgbBuffer(l, 0, i * o, t, 0, s, c);
                  if (d) if (m) e(d, s, r, n, i, a, c, t);else for (w = 0, y = 0, u = 0, h = i * o; u < h; u++) t[y++] = d[w++], t[y++] = d[w++], t[y++] = d[w++], y += c;
                },
                usesZeroToOneRange: !0
              }, t.parse = function (e, r, n) {
                var i = t.parseToIR(e, r, n);
                return i instanceof v ? i : t.fromIR(i);
              }, t.fromIR = function (e) {
                var r,
                  n,
                  i,
                  a = l(e) ? e[0] : e;
                switch (a) {
                  case "DeviceGrayCS":
                    return this.singletons.gray;
                  case "DeviceRgbCS":
                    return this.singletons.rgb;
                  case "DeviceCmykCS":
                    return this.singletons.cmyk;
                  case "CalGrayCS":
                    return r = e[1], n = e[2], i = e[3], new S(r, n, i);
                  case "CalRGBCS":
                    r = e[1], n = e[2], i = e[3];
                    var s = e[4];
                    return new C(r, n, i, s);
                  case "PatternCS":
                    var c = e[1];
                    return c && (c = t.fromIR(c)), new b(c);
                  case "IndexedCS":
                    var u = e[1],
                      h = e[2],
                      f = e[3];
                    return new y(t.fromIR(u), h, f);
                  case "AlternateCS":
                    var d = e[1],
                      p = e[2],
                      g = e[3];
                    return new v(d, t.fromIR(p), m.fromIR(g));
                  case "LabCS":
                    r = e[1], n = e[2];
                    var w = e[3];
                    return new E(r, n, w);
                  default:
                    o("Unknown name " + a);
                }
                return null;
              }, t.parseToIR = function (e, r, n) {
                if (d(e)) {
                  var i = n.get("ColorSpace");
                  if (f(i)) {
                    var a = i.get(e.name);
                    a && (e = a);
                  }
                }
                if (e = r.fetchIfRef(e), d(e)) switch (e.name) {
                  case "DeviceGray":
                  case "G":
                    return "DeviceGrayCS";
                  case "DeviceRGB":
                  case "RGB":
                    return "DeviceRgbCS";
                  case "DeviceCMYK":
                  case "CMYK":
                    return "DeviceCmykCS";
                  case "Pattern":
                    return ["PatternCS", null];
                  default:
                    o("unrecognized colorspace " + e.name);
                } else if (l(e)) {
                  var s,
                    c,
                    u,
                    g,
                    v,
                    b,
                    y = r.fetchIfRef(e[0]).name;
                  switch (y) {
                    case "DeviceGray":
                    case "G":
                      return "DeviceGrayCS";
                    case "DeviceRGB":
                    case "RGB":
                      return "DeviceRgbCS";
                    case "DeviceCMYK":
                    case "CMYK":
                      return "DeviceCmykCS";
                    case "CalGray":
                      return c = r.fetchIfRef(e[1]), g = c.getArray("WhitePoint"), v = c.getArray("BlackPoint"), b = c.get("Gamma"), ["CalGrayCS", g, v, b];
                    case "CalRGB":
                      c = r.fetchIfRef(e[1]), g = c.getArray("WhitePoint"), v = c.getArray("BlackPoint"), b = c.getArray("Gamma");
                      var w = c.getArray("Matrix");
                      return ["CalRGBCS", g, v, b, w];
                    case "ICCBased":
                      var x = r.fetchIfRef(e[1]),
                        _ = x.dict;
                      if (s = _.get("N"), u = _.get("Alternate")) {
                        var S = t.parseToIR(u, r, n),
                          C = t.fromIR(S);
                        if (C.numComps === s) return S;
                        h("ICCBased color space: Ignoring incorrect /Alternate entry.");
                      }
                      if (1 === s) return "DeviceGrayCS";
                      if (3 === s) return "DeviceRgbCS";
                      if (4 === s) return "DeviceCmykCS";
                      break;
                    case "Pattern":
                      var E = e[1] || null;
                      return E && (E = t.parseToIR(E, r, n)), ["PatternCS", E];
                    case "Indexed":
                    case "I":
                      var A = t.parseToIR(e[1], r, n),
                        T = r.fetchIfRef(e[2]) + 1,
                        k = r.fetchIfRef(e[3]);
                      return p(k) && (k = k.getBytes()), ["IndexedCS", A, T, k];
                    case "Separation":
                    case "DeviceN":
                      var R = r.fetchIfRef(e[1]);
                      s = l(R) ? R.length : 1, u = t.parseToIR(e[2], r, n);
                      var I = m.getIR(r, r.fetchIfRef(e[3]));
                      return ["AlternateCS", s, u, I];
                    case "Lab":
                      c = r.fetchIfRef(e[1]), g = c.getArray("WhitePoint"), v = c.getArray("BlackPoint");
                      var M = c.getArray("Range");
                      return ["LabCS", g, v, M];
                    default:
                      o('unimplemented color space object "' + y + '"');
                  }
                } else o('unrecognized color space object: "' + e + '"');
                return null;
              }, t.isDefaultDecode = function (e, t) {
                if (!l(e)) return !0;
                if (2 * t !== e.length) return h("The decode map is not the correct length"), !0;
                for (var r = 0, n = e.length; r < n; r += 2) if (0 !== e[r] || 1 !== e[r + 1]) return !1;
                return !0;
              }, t.singletons = {
                get gray() {
                  return u(this, "gray", new w());
                },
                get rgb() {
                  return u(this, "rgb", new x());
                },
                get cmyk() {
                  return u(this, "cmyk", new _());
                }
              }, t;
            }(),
            v = function () {
              function e(e, t, r) {
                this.name = "Alternate", this.numComps = e, this.defaultColor = new Float32Array(e);
                for (var n = 0; n < e; ++n) this.defaultColor[n] = 1;
                this.base = t, this.tintFn = r, this.tmpBuf = new Float32Array(t.numComps);
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, t, r, n) {
                  var i = this.tmpBuf;
                  this.tintFn(e, t, i, 0), this.base.getRgbItem(i, 0, r, n);
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, o) {
                  var s,
                    l,
                    c = this.tintFn,
                    u = this.base,
                    h = 1 / ((1 << a) - 1),
                    f = u.numComps,
                    d = u.usesZeroToOneRange,
                    p = (u.isPassthrough(8) || !d) && 0 === o,
                    m = p ? i : 0,
                    g = p ? n : new Uint8Array(f * r),
                    v = this.numComps,
                    b = new Float32Array(v),
                    y = new Float32Array(f);
                  for (s = 0; s < r; s++) {
                    for (l = 0; l < v; l++) b[l] = e[t++] * h;
                    if (c(b, 0, y, 0), d) for (l = 0; l < f; l++) g[m++] = 255 * y[l];else u.getRgbItem(y, 0, g, m), m += f;
                  }
                  p || u.getRgbBuffer(g, 0, r, n, i, 8, o);
                },
                getOutputLength: function getOutputLength(e, t) {
                  return this.base.getOutputLength(e * this.base.numComps / this.numComps, t);
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            b = function () {
              function e(e) {
                this.name = "Pattern", this.base = e;
              }
              return e.prototype = {}, e;
            }(),
            y = function () {
              function e(e, t, r) {
                this.name = "Indexed", this.numComps = 1, this.defaultColor = new Uint8Array(this.numComps), this.base = e, this.highVal = t;
                var n = e.numComps,
                  i = n * t;
                if (p(r)) {
                  this.lookup = new Uint8Array(i);
                  var a = r.getBytes(i);
                  this.lookup.set(a);
                } else if (c(r)) {
                  this.lookup = new Uint8Array(i);
                  for (var s = 0; s < i; ++s) this.lookup[s] = r.charCodeAt(s);
                } else r instanceof Uint8Array || r instanceof Array ? this.lookup = r : o("Unrecognized lookup table: " + r);
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, t, r, n) {
                  var i = this.base.numComps,
                    a = e[t] * i;
                  this.base.getRgbItem(this.lookup, a, r, n);
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, o) {
                  for (var s = this.base, l = s.numComps, c = s.getOutputLength(l, o), u = this.lookup, h = 0; h < r; ++h) {
                    var f = e[t++] * l;
                    s.getRgbBuffer(u, f, 1, n, i, 8, o), i += c;
                  }
                },
                getOutputLength: function getOutputLength(e, t) {
                  return this.base.getOutputLength(e * this.base.numComps, t);
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return !0;
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            w = function () {
              function e() {
                this.name = "DeviceGray", this.numComps = 1, this.defaultColor = new Float32Array(this.numComps);
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, t, r, n) {
                  var i = 255 * e[t] | 0;
                  i = i < 0 ? 0 : i > 255 ? 255 : i, r[n] = r[n + 1] = r[n + 2] = i;
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, o) {
                  for (var s = 255 / ((1 << a) - 1), l = t, c = i, u = 0; u < r; ++u) {
                    var h = s * e[l++] | 0;
                    n[c++] = h, n[c++] = h, n[c++] = h, c += o;
                  }
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e * (3 + t);
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            x = function () {
              function e() {
                this.name = "DeviceRGB", this.numComps = 3, this.defaultColor = new Float32Array(this.numComps);
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, t, r, n) {
                  var i = 255 * e[t] | 0,
                    a = 255 * e[t + 1] | 0,
                    o = 255 * e[t + 2] | 0;
                  r[n] = i < 0 ? 0 : i > 255 ? 255 : i, r[n + 1] = a < 0 ? 0 : a > 255 ? 255 : a, r[n + 2] = o < 0 ? 0 : o > 255 ? 255 : o;
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, o) {
                  if (8 === a && 0 === o) return void n.set(e.subarray(t, t + 3 * r), i);
                  for (var s = 255 / ((1 << a) - 1), l = t, c = i, u = 0; u < r; ++u) n[c++] = s * e[l++] | 0, n[c++] = s * e[l++] | 0, n[c++] = s * e[l++] | 0, c += o;
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e * (3 + t) / 3 | 0;
                },
                isPassthrough: function isPassthrough(e) {
                  return 8 === e;
                },
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            _ = function () {
              function e(e, t, r, n, i) {
                var a = e[t + 0] * r,
                  o = e[t + 1] * r,
                  s = e[t + 2] * r,
                  l = e[t + 3] * r,
                  c = a * (-4.387332384609988 * a + 54.48615194189176 * o + 18.82290502165302 * s + 212.25662451639585 * l - 285.2331026137004) + o * (1.7149763477362134 * o - 5.6096736904047315 * s + -17.873870861415444 * l - 5.497006427196366) + s * (-2.5217340131683033 * s - 21.248923337353073 * l + 17.5119270841813) + l * (-21.86122147463605 * l - 189.48180835922747) + 255 | 0,
                  u = a * (8.841041422036149 * a + 60.118027045597366 * o + 6.871425592049007 * s + 31.159100130055922 * l - 79.2970844816548) + o * (-15.310361306967817 * o + 17.575251261109482 * s + 131.35250912493976 * l - 190.9453302588951) + s * (4.444339102852739 * s + 9.8632861493405 * l - 24.86741582555878) + l * (-20.737325471181034 * l - 187.80453709719578) + 255 | 0,
                  h = a * (.8842522430003296 * a + 8.078677503112928 * o + 30.89978309703729 * s - .23883238689178934 * l - 14.183576799673286) + o * (10.49593273432072 * o + 63.02378494754052 * s + 50.606957656360734 * l - 112.23884253719248) + s * (.03296041114873217 * s + 115.60384449646641 * l - 193.58209356861505) + l * (-22.33816807309886 * l - 180.12613974708367) + 255 | 0;
                n[i] = c > 255 ? 255 : c < 0 ? 0 : c, n[i + 1] = u > 255 ? 255 : u < 0 ? 0 : u, n[i + 2] = h > 255 ? 255 : h < 0 ? 0 : h;
              }
              function t() {
                this.name = "DeviceCMYK", this.numComps = 4, this.defaultColor = new Float32Array(this.numComps), this.defaultColor[3] = 1;
              }
              return t.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(t, r, n, i) {
                  e(t, r, 1, n, i);
                },
                getRgbBuffer: function getRgbBuffer(t, r, n, i, a, o, s) {
                  for (var l = 1 / ((1 << o) - 1), c = 0; c < n; c++) e(t, r, l, i, a), r += 4, a += 3 + s;
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e / 4 * (3 + t) | 0;
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, t;
            }(),
            S = function () {
              function e(e, t, r) {
                this.name = "CalGray", this.numComps = 1, this.defaultColor = new Float32Array(this.numComps), e || o("WhitePoint missing - required for color space CalGray"), t = t || [0, 0, 0], r = r || 1, this.XW = e[0], this.YW = e[1], this.ZW = e[2], this.XB = t[0], this.YB = t[1], this.ZB = t[2], this.G = r, (this.XW < 0 || this.ZW < 0 || 1 !== this.YW) && o("Invalid WhitePoint components for " + this.name + ", no fallback available"), (this.XB < 0 || this.YB < 0 || this.ZB < 0) && (s("Invalid BlackPoint for " + this.name + ", falling back to default"), this.XB = this.YB = this.ZB = 0), 0 === this.XB && 0 === this.YB && 0 === this.ZB || h(this.name + ", BlackPoint: XB: " + this.XB + ", YB: " + this.YB + ", ZB: " + this.ZB + ", only default values are supported."), this.G < 1 && (s("Invalid Gamma: " + this.G + " for " + this.name + ", falling back to default"), this.G = 1);
              }
              function t(e, t, r, n, i, a) {
                var o = t[r] * a,
                  s = Math.pow(o, e.G),
                  l = e.YW * s,
                  c = 0 | Math.max(295.8 * Math.pow(l, .3333333333333333) - 40.8, 0);
                n[i] = c, n[i + 1] = c, n[i + 2] = c;
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, r, n, i) {
                  t(this, e, r, n, i, 1);
                },
                getRgbBuffer: function getRgbBuffer(e, r, n, i, a, o, s) {
                  for (var l = 1 / ((1 << o) - 1), c = 0; c < n; ++c) t(this, e, r, i, a, l), r += 1, a += 3 + s;
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e * (3 + t);
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            C = function () {
              function e(e, t, r, n) {
                this.name = "CalRGB", this.numComps = 3, this.defaultColor = new Float32Array(this.numComps), e || o("WhitePoint missing - required for color space CalRGB"), t = t || new Float32Array(3), r = r || new Float32Array([1, 1, 1]), n = n || new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]);
                var i = e[0],
                  a = e[1],
                  l = e[2];
                this.whitePoint = e;
                var c = t[0],
                  u = t[1],
                  h = t[2];
                this.blackPoint = t, this.GR = r[0], this.GG = r[1], this.GB = r[2], this.MXA = n[0], this.MYA = n[1], this.MZA = n[2], this.MXB = n[3], this.MYB = n[4], this.MZB = n[5], this.MXC = n[6], this.MYC = n[7], this.MZC = n[8], (i < 0 || l < 0 || 1 !== a) && o("Invalid WhitePoint components for " + this.name + ", no fallback available"), (c < 0 || u < 0 || h < 0) && (s("Invalid BlackPoint for " + this.name + " [" + c + ", " + u + ", " + h + "], falling back to default"), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && (s("Invalid Gamma [" + this.GR + ", " + this.GG + ", " + this.GB + "] for " + this.name + ", falling back to default"), this.GR = this.GG = this.GB = 1), (this.MXA < 0 || this.MYA < 0 || this.MZA < 0 || this.MXB < 0 || this.MYB < 0 || this.MZB < 0 || this.MXC < 0 || this.MYC < 0 || this.MZC < 0) && (s("Invalid Matrix for " + this.name + " [" + this.MXA + ", " + this.MYA + ", " + this.MZA + this.MXB + ", " + this.MYB + ", " + this.MZB + this.MXC + ", " + this.MYC + ", " + this.MZC + "], falling back to default"), this.MXA = this.MYB = this.MZC = 1, this.MXB = this.MYA = this.MZA = this.MXC = this.MYC = this.MZB = 0);
              }
              function t(e, t, r) {
                r[0] = e[0] * t[0] + e[1] * t[1] + e[2] * t[2], r[1] = e[3] * t[0] + e[4] * t[1] + e[5] * t[2], r[2] = e[6] * t[0] + e[7] * t[1] + e[8] * t[2];
              }
              function r(e, t, r) {
                r[0] = 1 * t[0] / e[0], r[1] = 1 * t[1] / e[1], r[2] = 1 * t[2] / e[2];
              }
              function n(e, t, r) {
                r[0] = .95047 * t[0] / e[0], r[1] = 1 * t[1] / e[1], r[2] = 1.08883 * t[2] / e[2];
              }
              function i(e) {
                return e <= .0031308 ? a(0, 1, 12.92 * e) : a(0, 1, 1.055 * Math.pow(e, 1 / 2.4) - .055);
              }
              function a(e, t, r) {
                return Math.max(e, Math.min(t, r));
              }
              function l(e) {
                return e < 0 ? -l(-e) : e > 8 ? Math.pow((e + 16) / 116, 3) : e * x;
              }
              function c(e, t, r) {
                if (0 === e[0] && 0 === e[1] && 0 === e[2]) return r[0] = t[0], r[1] = t[1], void (r[2] = t[2]);
                var n = l(0),
                  i = n,
                  a = l(e[0]),
                  o = n,
                  s = l(e[1]),
                  c = n,
                  u = l(e[2]),
                  h = (1 - i) / (1 - a),
                  f = 1 - h,
                  d = (1 - o) / (1 - s),
                  p = 1 - d,
                  m = (1 - c) / (1 - u),
                  g = 1 - m;
                r[0] = t[0] * h + f, r[1] = t[1] * d + p, r[2] = t[2] * m + g;
              }
              function u(e, n, i) {
                if (1 === e[0] && 1 === e[2]) return i[0] = n[0], i[1] = n[1], void (i[2] = n[2]);
                var a = i;
                t(d, n, a);
                var o = b;
                r(e, a, o), t(p, o, i);
              }
              function h(e, r, i) {
                var a = i;
                t(d, r, a);
                var o = b;
                n(e, a, o), t(p, o, i);
              }
              function f(e, r, n, o, s, l) {
                var f = a(0, 1, r[n] * l),
                  d = a(0, 1, r[n + 1] * l),
                  p = a(0, 1, r[n + 2] * l),
                  g = Math.pow(f, e.GR),
                  b = Math.pow(d, e.GG),
                  x = Math.pow(p, e.GB),
                  _ = e.MXA * g + e.MXB * b + e.MXC * x,
                  S = e.MYA * g + e.MYB * b + e.MYC * x,
                  C = e.MZA * g + e.MZB * b + e.MZC * x,
                  E = y;
                E[0] = _, E[1] = S, E[2] = C;
                var A = w;
                u(e.whitePoint, E, A);
                var T = y;
                c(e.blackPoint, A, T);
                var k = w;
                h(v, T, k);
                var R = y;
                t(m, k, R);
                var I = i(R[0]),
                  M = i(R[1]),
                  O = i(R[2]);
                o[s] = Math.round(255 * I), o[s + 1] = Math.round(255 * M), o[s + 2] = Math.round(255 * O);
              }
              var d = new Float32Array([.8951, .2664, -.1614, -.7502, 1.7135, .0367, .0389, -.0685, 1.0296]),
                p = new Float32Array([.9869929, -.1470543, .1599627, .4323053, .5183603, .0492912, -.0085287, .0400428, .9684867]),
                m = new Float32Array([3.2404542, -1.5371385, -.4985314, -.969266, 1.8760108, .041556, .0556434, -.2040259, 1.0572252]),
                v = new Float32Array([1, 1, 1]),
                b = new Float32Array(3),
                y = new Float32Array(3),
                w = new Float32Array(3),
                x = Math.pow(24 / 116, 3) / 8;
              return e.prototype = {
                getRgb: function getRgb(e, t) {
                  var r = new Uint8Array(3);
                  return this.getRgbItem(e, t, r, 0), r;
                },
                getRgbItem: function getRgbItem(e, t, r, n) {
                  f(this, e, t, r, n, 1);
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, n, i, a, o) {
                  for (var s = 1 / ((1 << a) - 1), l = 0; l < r; ++l) f(this, e, t, n, i, s), t += 3, i += 3 + o;
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e * (3 + t) / 3 | 0;
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return g.isDefaultDecode(e, this.numComps);
                },
                usesZeroToOneRange: !0
              }, e;
            }(),
            E = function () {
              function e(e, t, r) {
                this.name = "Lab", this.numComps = 3, this.defaultColor = new Float32Array(this.numComps), e || o("WhitePoint missing - required for color space Lab"), t = t || [0, 0, 0], r = r || [-100, 100, -100, 100], this.XW = e[0], this.YW = e[1], this.ZW = e[2], this.amin = r[0], this.amax = r[1], this.bmin = r[2], this.bmax = r[3], this.XB = t[0], this.YB = t[1], this.ZB = t[2], (this.XW < 0 || this.ZW < 0 || 1 !== this.YW) && o("Invalid WhitePoint components, no fallback available"), (this.XB < 0 || this.YB < 0 || this.ZB < 0) && (s("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && (s("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
              }
              function t(e) {
                return e >= 6 / 29 ? e * e * e : 108 / 841 * (e - 4 / 29);
              }
              function r(e, t, r, n) {
                return r + e * (n - r) / t;
              }
              function n(e, n, i, a, o, s) {
                var l = n[i],
                  c = n[i + 1],
                  u = n[i + 2];
                !1 !== a && (l = r(l, a, 0, 100), c = r(c, a, e.amin, e.amax), u = r(u, a, e.bmin, e.bmax)), c = c > e.amax ? e.amax : c < e.amin ? e.amin : c, u = u > e.bmax ? e.bmax : u < e.bmin ? e.bmin : u;
                var h,
                  f,
                  d,
                  p = (l + 16) / 116,
                  m = p + c / 500,
                  g = p - u / 200,
                  v = e.XW * t(m),
                  b = e.YW * t(p),
                  y = e.ZW * t(g);
                e.ZW < 1 ? (h = 3.1339 * v + -1.617 * b + -.4906 * y, f = -.9785 * v + 1.916 * b + .0333 * y, d = .072 * v + -.229 * b + 1.4057 * y) : (h = 3.2406 * v + -1.5372 * b + -.4986 * y, f = -.9689 * v + 1.8758 * b + .0415 * y, d = .0557 * v + -.204 * b + 1.057 * y), o[s] = h <= 0 ? 0 : h >= 1 ? 255 : 255 * Math.sqrt(h) | 0, o[s + 1] = f <= 0 ? 0 : f >= 1 ? 255 : 255 * Math.sqrt(f) | 0, o[s + 2] = d <= 0 ? 0 : d >= 1 ? 255 : 255 * Math.sqrt(d) | 0;
              }
              return e.prototype = {
                getRgb: g.prototype.getRgb,
                getRgbItem: function getRgbItem(e, t, r, i) {
                  n(this, e, t, !1, r, i);
                },
                getRgbBuffer: function getRgbBuffer(e, t, r, i, a, o, s) {
                  for (var l = (1 << o) - 1, c = 0; c < r; c++) n(this, e, t, l, i, a), t += 3, a += 3 + s;
                },
                getOutputLength: function getOutputLength(e, t) {
                  return e * (3 + t) / 3 | 0;
                },
                isPassthrough: g.prototype.isPassthrough,
                fillRgb: g.prototype.fillRgb,
                isDefaultDecode: function isDefaultDecode(e) {
                  return !0;
                },
                usesZeroToOneRange: !1
              }, e;
            }();
          t.ColorSpace = g;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            switch (e) {
              case "WinAnsiEncoding":
                return l;
              case "StandardEncoding":
                return s;
              case "MacRomanEncoding":
                return o;
              case "SymbolSetEncoding":
                return c;
              case "ZapfDingbatsEncoding":
                return u;
              case "ExpertEncoding":
                return i;
              case "MacExpertEncoding":
                return a;
              default:
                return null;
            }
          }
          var i = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"],
            a = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall"],
            o = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"],
            s = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls"],
            l = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"],
            c = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt"],
            u = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191"];
          t.WinAnsiEncoding = l, t.StandardEncoding = s, t.MacRomanEncoding = o, t.SymbolSetEncoding = c, t.ZapfDingbatsEncoding = u, t.ExpertEncoding = i, t.getEncoding = n;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(2),
            o = n.MissingDataException,
            s = n.StreamType,
            l = n.assert,
            c = n.error,
            u = n.info,
            h = n.isArray,
            f = n.isInt,
            d = n.isNum,
            p = n.isString,
            m = n.warn,
            g = i.EOF,
            v = i.Cmd,
            b = i.Dict,
            y = i.Name,
            w = i.Ref,
            x = i.isEOF,
            _ = i.isCmd,
            S = i.isDict,
            C = i.isName,
            E = a.Ascii85Stream,
            A = a.AsciiHexStream,
            T = a.CCITTFaxStream,
            k = a.FlateStream,
            R = a.Jbig2Stream,
            I = a.JpegStream,
            M = a.JpxStream,
            O = a.LZWStream,
            P = a.NullStream,
            B = a.PredictorStream,
            D = a.RunLengthStream,
            L = function () {
              function e(e, t, r, n) {
                this.lexer = e, this.allowStreams = t, this.xref = r, this.recoveryMode = n || !1, this.imageCache = Object.create(null), this.refill();
              }
              return e.prototype = {
                refill: function refill() {
                  this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
                },
                shift: function shift() {
                  _(this.buf2, "ID") ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
                },
                tryShift: function tryShift() {
                  try {
                    return this.shift(), !0;
                  } catch (e) {
                    if (e instanceof o) throw e;
                    return !1;
                  }
                },
                getObj: function getObj(e) {
                  var t = this.buf1;
                  if (this.shift(), t instanceof v) switch (t.cmd) {
                    case "BI":
                      return this.makeInlineImage(e);
                    case "[":
                      for (var r = []; !_(this.buf1, "]") && !x(this.buf1);) r.push(this.getObj(e));
                      return x(this.buf1) ? (this.recoveryMode || c("End of file inside array"), r) : (this.shift(), r);
                    case "<<":
                      for (var n = new b(this.xref); !_(this.buf1, ">>") && !x(this.buf1);) if (C(this.buf1)) {
                        var i = this.buf1.name;
                        if (this.shift(), x(this.buf1)) break;
                        n.set(i, this.getObj(e));
                      } else u("Malformed dictionary: key must be a name object"), this.shift();
                      return x(this.buf1) ? (this.recoveryMode || c("End of file inside dictionary"), n) : _(this.buf2, "stream") ? this.allowStreams ? this.makeStream(n, e) : n : (this.shift(), n);
                    default:
                      return t;
                  }
                  if (f(t)) {
                    var a = t;
                    if (f(this.buf1) && _(this.buf2, "R")) {
                      var o = new w(a, this.buf1);
                      return this.shift(), this.shift(), o;
                    }
                    return a;
                  }
                  if (p(t)) {
                    var s = t;
                    return e && (s = e.decryptString(s)), s;
                  }
                  return t;
                },
                findDefaultInlineStreamEnd: function findDefaultInlineStreamEnd(e) {
                  for (var t, r, n, i, a = e.pos, o = 0; -1 !== (t = e.getByte());) if (0 === o) o = 69 === t ? 1 : 0;else if (1 === o) o = 73 === t ? 2 : 0;else if (l(2 === o), 32 === t || 10 === t || 13 === t) {
                    for (n = 5, i = e.peekBytes(n), r = 0; r < n; r++) if (10 !== (t = i[r]) && 13 !== t && (t < 32 || t > 127)) {
                      o = 0;
                      break;
                    }
                    if (2 === o) break;
                  } else o = 0;
                  return e.pos - 4 - a;
                },
                findDCTDecodeInlineStreamEnd: function findDCTDecodeInlineStreamEnd(e) {
                  for (var t, r, n, i = e.pos, a = !1; -1 !== (t = e.getByte());) if (255 === t) {
                    switch (e.getByte()) {
                      case 0:
                        break;
                      case 255:
                        e.skip(-1);
                        break;
                      case 217:
                        a = !0;
                        break;
                      case 192:
                      case 193:
                      case 194:
                      case 195:
                      case 197:
                      case 198:
                      case 199:
                      case 201:
                      case 202:
                      case 203:
                      case 205:
                      case 206:
                      case 207:
                      case 196:
                      case 204:
                      case 218:
                      case 219:
                      case 220:
                      case 221:
                      case 222:
                      case 223:
                      case 224:
                      case 225:
                      case 226:
                      case 227:
                      case 228:
                      case 229:
                      case 230:
                      case 231:
                      case 232:
                      case 233:
                      case 234:
                      case 235:
                      case 236:
                      case 237:
                      case 238:
                      case 239:
                      case 254:
                        r = e.getUint16(), r > 2 ? e.skip(r - 2) : e.skip(-2);
                    }
                    if (a) break;
                  }
                  return n = e.pos - i, -1 === t ? (m("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), e.skip(-n), this.findDefaultInlineStreamEnd(e)) : (this.inlineStreamSkipEI(e), n);
                },
                findASCII85DecodeInlineStreamEnd: function findASCII85DecodeInlineStreamEnd(e) {
                  for (var t, r, n = e.pos; -1 !== (t = e.getByte());) if (126 === t && 62 === e.peekByte()) {
                    e.skip();
                    break;
                  }
                  return r = e.pos - n, -1 === t ? (m("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), e.skip(-r), this.findDefaultInlineStreamEnd(e)) : (this.inlineStreamSkipEI(e), r);
                },
                findASCIIHexDecodeInlineStreamEnd: function findASCIIHexDecodeInlineStreamEnd(e) {
                  for (var t, r, n = e.pos; -1 !== (t = e.getByte()) && 62 !== t;);
                  return r = e.pos - n, -1 === t ? (m("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), e.skip(-r), this.findDefaultInlineStreamEnd(e)) : (this.inlineStreamSkipEI(e), r);
                },
                inlineStreamSkipEI: function inlineStreamSkipEI(e) {
                  for (var t, r = 0; -1 !== (t = e.getByte());) if (0 === r) r = 69 === t ? 1 : 0;else if (1 === r) r = 73 === t ? 2 : 0;else if (2 === r) break;
                },
                makeInlineImage: function makeInlineImage(e) {
                  for (var t = this.lexer, r = t.stream, n = new b(this.xref); !_(this.buf1, "ID") && !x(this.buf1);) {
                    C(this.buf1) || c("Dictionary key must be a name object");
                    var i = this.buf1.name;
                    if (this.shift(), x(this.buf1)) break;
                    n.set(i, this.getObj(e));
                  }
                  var a,
                    o = n.get("Filter", "F");
                  if (C(o)) a = o.name;else if (h(o)) {
                    var s = this.xref.fetchIfRef(o[0]);
                    C(s) && (a = s.name);
                  }
                  var l,
                    u,
                    f,
                    d = r.pos;
                  l = "DCTDecode" === a || "DCT" === a ? this.findDCTDecodeInlineStreamEnd(r) : "ASCII85Decide" === a || "A85" === a ? this.findASCII85DecodeInlineStreamEnd(r) : "ASCIIHexDecode" === a || "AHx" === a ? this.findASCIIHexDecodeInlineStreamEnd(r) : this.findDefaultInlineStreamEnd(r);
                  var p,
                    m = r.makeSubStream(d, l, n);
                  if (l < 1e3) {
                    var g = m.getBytes();
                    m.reset();
                    var y = 1,
                      w = 0;
                    for (u = 0, f = g.length; u < f; ++u) y += 255 & g[u], w += y;
                    if (p = w % 65521 << 16 | y % 65521, this.imageCache.adler32 === p) return this.buf2 = v.get("EI"), this.shift(), this.imageCache[p].reset(), this.imageCache[p];
                  }
                  return e && (m = e.createStream(m, l)), m = this.filter(m, n, l), m.dict = n, void 0 !== p && (m.cacheKey = "inline_" + l + "_" + p, this.imageCache[p] = m), this.buf2 = v.get("EI"), this.shift(), m;
                },
                makeStream: function makeStream(e, t) {
                  var r = this.lexer,
                    n = r.stream;
                  r.skipToNextLine();
                  var i = n.pos - 1,
                    a = e.get("Length");
                  if (f(a) || (u("Bad " + a + " attribute in stream"), a = 0), n.pos = i + a, r.nextChar(), this.tryShift() && _(this.buf2, "endstream")) this.shift();else {
                    n.pos = i;
                    for (var o, s, l = [101, 110, 100, 115, 116, 114, 101, 97, 109], h = 0, d = !1; n.pos < n.end;) {
                      var p = n.peekBytes(2048),
                        m = p.length - 9;
                      if (m <= 0) break;
                      for (d = !1, o = 0; o < m;) {
                        for (s = 0; s < 9 && p[o + s] === l[s];) s++;
                        if (s >= 9) {
                          d = !0;
                          break;
                        }
                        o++;
                      }
                      if (d) {
                        h += o, n.pos += o;
                        break;
                      }
                      h += m, n.pos += m;
                    }
                    d || c("Missing endstream"), a = h, r.nextChar(), this.shift(), this.shift();
                  }
                  return this.shift(), n = n.makeSubStream(i, a, e), t && (n = t.createStream(n, a)), n = this.filter(n, e, a), n.dict = e, n;
                },
                filter: function filter(e, t, r) {
                  var n = t.get("Filter", "F"),
                    i = t.get("DecodeParms", "DP");
                  if (C(n)) return h(i) && (i = this.xref.fetchIfRef(i[0])), this.makeFilter(e, n.name, r, i);
                  var a = r;
                  if (h(n)) for (var o = n, s = i, l = 0, u = o.length; l < u; ++l) n = this.xref.fetchIfRef(o[l]), C(n) || c("Bad filter name: " + n), i = null, h(s) && l in s && (i = this.xref.fetchIfRef(s[l])), e = this.makeFilter(e, n.name, a, i), a = null;
                  return e;
                },
                makeFilter: function makeFilter(e, t, r, n) {
                  if (0 === r) return m('Empty "' + t + '" stream.'), new P(e);
                  try {
                    var i = this.xref.stats.streamTypes;
                    if ("FlateDecode" === t || "Fl" === t) return i[s.FLATE] = !0, n ? new B(new k(e, r), r, n) : new k(e, r);
                    if ("LZWDecode" === t || "LZW" === t) {
                      i[s.LZW] = !0;
                      var a = 1;
                      return n ? (n.has("EarlyChange") && (a = n.get("EarlyChange")), new B(new O(e, r, a), r, n)) : new O(e, r, a);
                    }
                    return "DCTDecode" === t || "DCT" === t ? (i[s.DCT] = !0, new I(e, r, e.dict, n)) : "JPXDecode" === t || "JPX" === t ? (i[s.JPX] = !0, new M(e, r, e.dict, n)) : "ASCII85Decode" === t || "A85" === t ? (i[s.A85] = !0, new E(e, r)) : "ASCIIHexDecode" === t || "AHx" === t ? (i[s.AHX] = !0, new A(e, r)) : "CCITTFaxDecode" === t || "CCF" === t ? (i[s.CCF] = !0, new T(e, r, n)) : "RunLengthDecode" === t || "RL" === t ? (i[s.RL] = !0, new D(e, r)) : "JBIG2Decode" === t ? (i[s.JBIG] = !0, new R(e, r, e.dict, n)) : (m('filter "' + t + '" not supported yet'), e);
                  } catch (t) {
                    if (t instanceof o) throw t;
                    return m('Invalid stream: "' + t + '"'), new P(e);
                  }
                }
              }, e;
            }(),
            F = function () {
              function e(e, t) {
                this.stream = e, this.nextChar(), this.strBuf = [], this.knownCommands = t;
              }
              function t(e) {
                return e >= 48 && e <= 57 ? 15 & e : e >= 65 && e <= 70 || e >= 97 && e <= 102 ? 9 + (15 & e) : -1;
              }
              var r = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
              return e.prototype = {
                nextChar: function nextChar() {
                  return this.currentChar = this.stream.getByte();
                },
                peekChar: function peekChar() {
                  return this.stream.peekByte();
                },
                getNumber: function getNumber() {
                  var e = this.currentChar,
                    t = !1,
                    r = 0,
                    n = 1;
                  if (45 === e ? (n = -1, 45 === (e = this.nextChar()) && (e = this.nextChar())) : 43 === e && (e = this.nextChar()), 46 === e && (r = 10, e = this.nextChar()), 10 === e || 13 === e) do {
                    e = this.nextChar();
                  } while (10 === e || 13 === e);
                  (e < 48 || e > 57) && c("Invalid number: " + String.fromCharCode(e) + " (charCode " + e + ")");
                  for (var i = e - 48, a = 0, o = 1; (e = this.nextChar()) >= 0;) if (48 <= e && e <= 57) {
                    var s = e - 48;
                    t ? a = 10 * a + s : (0 !== r && (r *= 10), i = 10 * i + s);
                  } else if (46 === e) {
                    if (0 !== r) break;
                    r = 1;
                  } else if (45 === e) m("Badly formatted number");else {
                    if (69 !== e && 101 !== e) break;
                    if (43 === (e = this.peekChar()) || 45 === e) o = 45 === e ? -1 : 1, this.nextChar();else if (e < 48 || e > 57) break;
                    t = !0;
                  }
                  return 0 !== r && (i /= r), t && (i *= Math.pow(10, o * a)), n * i;
                },
                getString: function getString() {
                  var e = 1,
                    t = !1,
                    r = this.strBuf;
                  r.length = 0;
                  for (var n = this.nextChar();;) {
                    var i = !1;
                    switch (0 | n) {
                      case -1:
                        m("Unterminated string"), t = !0;
                        break;
                      case 40:
                        ++e, r.push("(");
                        break;
                      case 41:
                        0 == --e ? (this.nextChar(), t = !0) : r.push(")");
                        break;
                      case 92:
                        switch (n = this.nextChar()) {
                          case -1:
                            m("Unterminated string"), t = !0;
                            break;
                          case 110:
                            r.push("\n");
                            break;
                          case 114:
                            r.push("\r");
                            break;
                          case 116:
                            r.push("\t");
                            break;
                          case 98:
                            r.push("\b");
                            break;
                          case 102:
                            r.push("\f");
                            break;
                          case 92:
                          case 40:
                          case 41:
                            r.push(String.fromCharCode(n));
                            break;
                          case 48:
                          case 49:
                          case 50:
                          case 51:
                          case 52:
                          case 53:
                          case 54:
                          case 55:
                            var a = 15 & n;
                            n = this.nextChar(), i = !0, n >= 48 && n <= 55 && (a = (a << 3) + (15 & n), (n = this.nextChar()) >= 48 && n <= 55 && (i = !1, a = (a << 3) + (15 & n))), r.push(String.fromCharCode(a));
                            break;
                          case 13:
                            10 === this.peekChar() && this.nextChar();
                            break;
                          case 10:
                            break;
                          default:
                            r.push(String.fromCharCode(n));
                        }
                        break;
                      default:
                        r.push(String.fromCharCode(n));
                    }
                    if (t) break;
                    i || (n = this.nextChar());
                  }
                  return r.join("");
                },
                getName: function getName() {
                  var e,
                    n,
                    i = this.strBuf;
                  for (i.length = 0; (e = this.nextChar()) >= 0 && !r[e];) if (35 === e) {
                    if (e = this.nextChar(), r[e]) {
                      m("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), i.push("#");
                      break;
                    }
                    var a = t(e);
                    if (-1 !== a) {
                      n = e, e = this.nextChar();
                      var o = t(e);
                      if (-1 === o) {
                        if (m("Lexer_getName: Illegal digit (" + String.fromCharCode(e) + ") in hexadecimal number."), i.push("#", String.fromCharCode(n)), r[e]) break;
                        i.push(String.fromCharCode(e));
                        continue;
                      }
                      i.push(String.fromCharCode(a << 4 | o));
                    } else i.push("#", String.fromCharCode(e));
                  } else i.push(String.fromCharCode(e));
                  return i.length > 127 && m("name token is longer than allowed by the spec: " + i.length), y.get(i.join(""));
                },
                getHexString: function getHexString() {
                  var e = this.strBuf;
                  e.length = 0;
                  for (var n, i, a = this.currentChar, o = !0;;) {
                    if (a < 0) {
                      m("Unterminated hex string");
                      break;
                    }
                    if (62 === a) {
                      this.nextChar();
                      break;
                    }
                    if (1 !== r[a]) {
                      if (o) {
                        if (-1 === (n = t(a))) {
                          m('Ignoring invalid character "' + a + '" in hex string'), a = this.nextChar();
                          continue;
                        }
                      } else {
                        if (-1 === (i = t(a))) {
                          m('Ignoring invalid character "' + a + '" in hex string'), a = this.nextChar();
                          continue;
                        }
                        e.push(String.fromCharCode(n << 4 | i));
                      }
                      o = !o, a = this.nextChar();
                    } else a = this.nextChar();
                  }
                  return e.join("");
                },
                getObj: function getObj() {
                  for (var e = !1, t = this.currentChar;;) {
                    if (t < 0) return g;
                    if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (1 !== r[t]) break;
                    t = this.nextChar();
                  }
                  switch (0 | t) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 43:
                    case 45:
                    case 46:
                      return this.getNumber();
                    case 40:
                      return this.getString();
                    case 47:
                      return this.getName();
                    case 91:
                      return this.nextChar(), v.get("[");
                    case 93:
                      return this.nextChar(), v.get("]");
                    case 60:
                      return t = this.nextChar(), 60 === t ? (this.nextChar(), v.get("<<")) : this.getHexString();
                    case 62:
                      return t = this.nextChar(), 62 === t ? (this.nextChar(), v.get(">>")) : v.get(">");
                    case 123:
                      return this.nextChar(), v.get("{");
                    case 125:
                      return this.nextChar(), v.get("}");
                    case 41:
                      this.nextChar(), c("Illegal character: " + t);
                  }
                  for (var n = String.fromCharCode(t), i = this.knownCommands, a = i && void 0 !== i[n]; (t = this.nextChar()) >= 0 && !r[t];) {
                    var o = n + String.fromCharCode(t);
                    if (a && void 0 === i[o]) break;
                    128 === n.length && c("Command token too long: " + n.length), n = o, a = i && void 0 !== i[n];
                  }
                  return "true" === n || "false" !== n && ("null" === n ? null : v.get(n));
                },
                skipToNextLine: function skipToNextLine() {
                  for (var e = this.currentChar; e >= 0;) {
                    if (13 === e) {
                      e = this.nextChar(), 10 === e && this.nextChar();
                      break;
                    }
                    if (10 === e) {
                      this.nextChar();
                      break;
                    }
                    e = this.nextChar();
                  }
                }
              }, e;
            }(),
            N = {
              create: function create(e) {
                function t(e, t) {
                  var r = l.get(e);
                  if (f(r) && (t ? r >= 0 : r > 0)) return r;
                  throw new Error('The "' + e + '" parameter in the linearization dictionary is invalid.');
                }
                var r,
                  n,
                  i = new L(new F(e), !1, null),
                  a = i.getObj(),
                  o = i.getObj(),
                  s = i.getObj(),
                  l = i.getObj();
                if (!(f(a) && f(o) && _(s, "obj") && S(l) && d(r = l.get("Linearized")) && r > 0)) return null;
                if ((n = t("L")) !== e.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                return {
                  length: n,
                  hints: function () {
                    var e,
                      t,
                      r = l.get("H");
                    if (h(r) && (2 === (e = r.length) || 4 === e)) {
                      for (var n = 0; n < e; n++) if (!(f(t = r[n]) && t > 0)) throw new Error("Hint (" + n + ") in the linearization dictionary is invalid.");
                      return r;
                    }
                    throw new Error("Hint array in the linearization dictionary is invalid.");
                  }(),
                  objectNumberFirst: t("O"),
                  endFirst: t("E"),
                  numPages: t("N"),
                  mainXRefEntriesOffset: t("T"),
                  pageFirst: l.has("P") ? t("P", !0) : 0
                };
              }
            };
          t.Lexer = F, t.Linearization = N, t.Parser = L;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            var t;
            if ("object" !== (void 0 === e ? "undefined" : i(e))) return !1;
            if (f(e)) t = e;else {
              if (!d(e)) return !1;
              t = e.dict;
            }
            return t.has("FunctionType");
          }
          var i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            a = r(0),
            o = r(1),
            s = r(42),
            l = a.error,
            c = a.info,
            u = a.isArray,
            h = a.isBool,
            f = o.isDict,
            d = o.isStream,
            p = s.PostScriptLexer,
            m = s.PostScriptParser,
            g = function () {
              return {
                getSampleArray: function getSampleArray(e, t, r, n) {
                  var i,
                    a,
                    o = 1;
                  for (i = 0, a = e.length; i < a; i++) o *= e[i];
                  o *= t;
                  var s = new Array(o),
                    l = 0,
                    c = 0,
                    u = 1 / (Math.pow(2, r) - 1),
                    h = n.getBytes((o * r + 7) / 8),
                    f = 0;
                  for (i = 0; i < o; i++) {
                    for (; l < r;) c <<= 8, c |= h[f++], l += 8;
                    l -= r, s[i] = (c >> l) * u, c &= (1 << l) - 1;
                  }
                  return s;
                },
                getIR: function getIR(e, t) {
                  var r = t.dict;
                  r || (r = t);
                  var n = [this.constructSampled, null, this.constructInterpolated, this.constructStiched, this.constructPostScript],
                    i = r.get("FunctionType"),
                    a = n[i];
                  return a || l("Unknown type of function"), a.call(this, t, r, e);
                },
                fromIR: function fromIR(e) {
                  switch (e[0]) {
                    case 0:
                      return this.constructSampledFromIR(e);
                    case 2:
                      return this.constructInterpolatedFromIR(e);
                    case 3:
                      return this.constructStichedFromIR(e);
                    default:
                      return this.constructPostScriptFromIR(e);
                  }
                },
                parse: function parse(e, t) {
                  var r = this.getIR(e, t);
                  return this.fromIR(r);
                },
                parseArray: function parseArray(e, t) {
                  if (!u(t)) return this.parse(e, t);
                  for (var r = [], n = 0, i = t.length; n < i; n++) {
                    var a = e.fetchIfRef(t[n]);
                    r.push(g.parse(e, a));
                  }
                  return function (e, t, n, i) {
                    for (var a = 0, o = r.length; a < o; a++) r[a](e, t, n, i + a);
                  };
                },
                constructSampled: function constructSampled(e, t) {
                  function r(e) {
                    for (var t = e.length, r = [], n = 0, i = 0; i < t; i += 2) r[n] = [e[i], e[i + 1]], ++n;
                    return r;
                  }
                  var n = t.getArray("Domain"),
                    i = t.getArray("Range");
                  n && i || l("No domain or range");
                  var a = n.length / 2,
                    o = i.length / 2;
                  n = r(n), i = r(i);
                  var s = t.get("Size"),
                    u = t.get("BitsPerSample"),
                    h = t.get("Order") || 1;
                  1 !== h && c("No support for cubic spline interpolation: " + h);
                  var f = t.getArray("Encode");
                  if (!f) {
                    f = [];
                    for (var d = 0; d < a; ++d) f.push(0), f.push(s[d] - 1);
                  }
                  f = r(f);
                  var p = t.getArray("Decode");
                  return p = p ? r(p) : i, [0, a, n, f, p, this.getSampleArray(s, o, u, e), s, o, Math.pow(2, u) - 1, i];
                },
                constructSampledFromIR: function constructSampledFromIR(e) {
                  function t(e, t, r, n, i) {
                    return n + (i - n) / (r - t) * (e - t);
                  }
                  return function (r, n, i, a) {
                    var o,
                      s,
                      l = e[1],
                      c = e[2],
                      u = e[3],
                      h = e[4],
                      f = e[5],
                      d = e[6],
                      p = e[7],
                      m = e[9],
                      g = 1 << l,
                      v = new Float64Array(g),
                      b = new Uint32Array(g);
                    for (s = 0; s < g; s++) v[s] = 1;
                    var y = p,
                      w = 1;
                    for (o = 0; o < l; ++o) {
                      var x = c[o][0],
                        _ = c[o][1],
                        S = Math.min(Math.max(r[n + o], x), _),
                        C = t(S, x, _, u[o][0], u[o][1]),
                        E = d[o];
                      C = Math.min(Math.max(C, 0), E - 1);
                      var A = C < E - 1 ? Math.floor(C) : C - 1,
                        T = A + 1 - C,
                        k = C - A,
                        R = A * y,
                        I = R + y;
                      for (s = 0; s < g; s++) s & w ? (v[s] *= k, b[s] += I) : (v[s] *= T, b[s] += R);
                      y *= E, w <<= 1;
                    }
                    for (s = 0; s < p; ++s) {
                      var M = 0;
                      for (o = 0; o < g; o++) M += f[b[o] + s] * v[o];
                      M = t(M, 0, 1, h[s][0], h[s][1]), i[a + s] = Math.min(Math.max(M, m[s][0]), m[s][1]);
                    }
                  };
                },
                constructInterpolated: function constructInterpolated(e, t) {
                  var r = t.getArray("C0") || [0],
                    n = t.getArray("C1") || [1],
                    i = t.get("N");
                  u(r) && u(n) || l("Illegal dictionary for interpolated function");
                  for (var a = r.length, o = [], s = 0; s < a; ++s) o.push(n[s] - r[s]);
                  return [2, r, o, i];
                },
                constructInterpolatedFromIR: function constructInterpolatedFromIR(e) {
                  var t = e[1],
                    r = e[2],
                    n = e[3],
                    i = r.length;
                  return function (e, a, o, s) {
                    for (var l = 1 === n ? e[a] : Math.pow(e[a], n), c = 0; c < i; ++c) o[s + c] = t[c] + l * r[c];
                  };
                },
                constructStiched: function constructStiched(e, t, r) {
                  var n = t.getArray("Domain");
                  n || l("No domain"), 1 != n.length / 2 && l("Bad domain for stiched function");
                  for (var i = t.get("Functions"), a = [], o = 0, s = i.length; o < s; ++o) a.push(g.getIR(r, r.fetchIfRef(i[o])));
                  return [3, n, t.getArray("Bounds"), t.getArray("Encode"), a];
                },
                constructStichedFromIR: function constructStichedFromIR(e) {
                  for (var t = e[1], r = e[2], n = e[3], i = e[4], a = [], o = new Float32Array(1), s = 0, l = i.length; s < l; s++) a.push(g.fromIR(i[s]));
                  return function (e, i, s, l) {
                    for (var c = function (e, t, r) {
                        return e > r ? e = r : e < t && (e = t), e;
                      }(e[i], t[0], t[1]), u = 0, h = r.length; u < h && !(c < r[u]); ++u);
                    var f = t[0];
                    u > 0 && (f = r[u - 1]);
                    var d = t[1];
                    u < r.length && (d = r[u]);
                    var p = n[2 * u],
                      m = n[2 * u + 1];
                    o[0] = f === d ? p : p + (c - f) * (m - p) / (d - f), a[u](o, 0, s, l);
                  };
                },
                constructPostScript: function constructPostScript(e, t, r) {
                  var n = t.getArray("Domain"),
                    i = t.getArray("Range");
                  n || l("No domain."), i || l("No range.");
                  var a = new p(e);
                  return [4, n, i, new m(a).parse()];
                },
                constructPostScriptFromIR: function constructPostScriptFromIR(e) {
                  var t = e[1],
                    r = e[2],
                    n = e[3],
                    i = new y().compile(n, t, r);
                  if (i) return new Function("src", "srcOffset", "dest", "destOffset", i);
                  c("Unable to compile PS function");
                  var a = r.length >> 1,
                    o = t.length >> 1,
                    s = new b(n),
                    l = Object.create(null),
                    u = 8192,
                    h = new Float32Array(o);
                  return function (e, t, n, i) {
                    var c,
                      f,
                      d = "",
                      p = h;
                    for (c = 0; c < o; c++) f = e[t + c], p[c] = f, d += f + "_";
                    var m = l[d];
                    if (void 0 !== m) return void n.set(m, i);
                    var g = new Float32Array(a),
                      v = s.execute(p),
                      b = v.length - a;
                    for (c = 0; c < a; c++) {
                      f = v[b + c];
                      var y = r[2 * c];
                      f < y ? f = y : (y = r[2 * c + 1], f > y && (f = y)), g[c] = f;
                    }
                    u > 0 && (u--, l[d] = g), n.set(g, i);
                  };
                }
              };
            }(),
            v = function () {
              function e(e) {
                this.stack = e ? Array.prototype.slice.call(e, 0) : [];
              }
              return e.prototype = {
                push: function push(e) {
                  this.stack.length >= 100 && l("PostScript function stack overflow."), this.stack.push(e);
                },
                pop: function pop() {
                  return this.stack.length <= 0 && l("PostScript function stack underflow."), this.stack.pop();
                },
                copy: function copy(e) {
                  this.stack.length + e >= 100 && l("PostScript function stack overflow.");
                  for (var t = this.stack, r = t.length - e, n = e - 1; n >= 0; n--, r++) t.push(t[r]);
                },
                index: function index(e) {
                  this.push(this.stack[this.stack.length - e - 1]);
                },
                roll: function roll(e, t) {
                  var r,
                    n,
                    i,
                    a = this.stack,
                    o = a.length - e,
                    s = a.length - 1,
                    l = o + (t - Math.floor(t / e) * e);
                  for (r = o, n = s; r < n; r++, n--) i = a[r], a[r] = a[n], a[n] = i;
                  for (r = o, n = l - 1; r < n; r++, n--) i = a[r], a[r] = a[n], a[n] = i;
                  for (r = l, n = s; r < n; r++, n--) i = a[r], a[r] = a[n], a[n] = i;
                }
              }, e;
            }(),
            b = function () {
              function e(e) {
                this.operators = e;
              }
              return e.prototype = {
                execute: function execute(e) {
                  for (var t, r, n, i = new v(e), a = 0, o = this.operators, s = o.length; a < s;) if ("number" != typeof (t = o[a++])) switch (t) {
                    case "jz":
                      n = i.pop(), r = i.pop(), r || (a = n);
                      break;
                    case "j":
                      r = i.pop(), a = r;
                      break;
                    case "abs":
                      r = i.pop(), i.push(Math.abs(r));
                      break;
                    case "add":
                      n = i.pop(), r = i.pop(), i.push(r + n);
                      break;
                    case "and":
                      n = i.pop(), r = i.pop(), h(r) && h(n) ? i.push(r && n) : i.push(r & n);
                      break;
                    case "atan":
                      r = i.pop(), i.push(Math.atan(r));
                      break;
                    case "bitshift":
                      n = i.pop(), r = i.pop(), r > 0 ? i.push(r << n) : i.push(r >> n);
                      break;
                    case "ceiling":
                      r = i.pop(), i.push(Math.ceil(r));
                      break;
                    case "copy":
                      r = i.pop(), i.copy(r);
                      break;
                    case "cos":
                      r = i.pop(), i.push(Math.cos(r));
                      break;
                    case "cvi":
                      r = 0 | i.pop(), i.push(r);
                      break;
                    case "cvr":
                      break;
                    case "div":
                      n = i.pop(), r = i.pop(), i.push(r / n);
                      break;
                    case "dup":
                      i.copy(1);
                      break;
                    case "eq":
                      n = i.pop(), r = i.pop(), i.push(r === n);
                      break;
                    case "exch":
                      i.roll(2, 1);
                      break;
                    case "exp":
                      n = i.pop(), r = i.pop(), i.push(Math.pow(r, n));
                      break;
                    case "false":
                      i.push(!1);
                      break;
                    case "floor":
                      r = i.pop(), i.push(Math.floor(r));
                      break;
                    case "ge":
                      n = i.pop(), r = i.pop(), i.push(r >= n);
                      break;
                    case "gt":
                      n = i.pop(), r = i.pop(), i.push(r > n);
                      break;
                    case "idiv":
                      n = i.pop(), r = i.pop(), i.push(r / n | 0);
                      break;
                    case "index":
                      r = i.pop(), i.index(r);
                      break;
                    case "le":
                      n = i.pop(), r = i.pop(), i.push(r <= n);
                      break;
                    case "ln":
                      r = i.pop(), i.push(Math.log(r));
                      break;
                    case "log":
                      r = i.pop(), i.push(Math.log(r) / Math.LN10);
                      break;
                    case "lt":
                      n = i.pop(), r = i.pop(), i.push(r < n);
                      break;
                    case "mod":
                      n = i.pop(), r = i.pop(), i.push(r % n);
                      break;
                    case "mul":
                      n = i.pop(), r = i.pop(), i.push(r * n);
                      break;
                    case "ne":
                      n = i.pop(), r = i.pop(), i.push(r !== n);
                      break;
                    case "neg":
                      r = i.pop(), i.push(-r);
                      break;
                    case "not":
                      r = i.pop(), h(r) ? i.push(!r) : i.push(~r);
                      break;
                    case "or":
                      n = i.pop(), r = i.pop(), h(r) && h(n) ? i.push(r || n) : i.push(r | n);
                      break;
                    case "pop":
                      i.pop();
                      break;
                    case "roll":
                      n = i.pop(), r = i.pop(), i.roll(r, n);
                      break;
                    case "round":
                      r = i.pop(), i.push(Math.round(r));
                      break;
                    case "sin":
                      r = i.pop(), i.push(Math.sin(r));
                      break;
                    case "sqrt":
                      r = i.pop(), i.push(Math.sqrt(r));
                      break;
                    case "sub":
                      n = i.pop(), r = i.pop(), i.push(r - n);
                      break;
                    case "true":
                      i.push(!0);
                      break;
                    case "truncate":
                      r = i.pop(), r = r < 0 ? Math.ceil(r) : Math.floor(r), i.push(r);
                      break;
                    case "xor":
                      n = i.pop(), r = i.pop(), h(r) && h(n) ? i.push(r !== n) : i.push(r ^ n);
                      break;
                    default:
                      l("Unknown operator " + t);
                  } else i.push(t);
                  return i.stack;
                }
              }, e;
            }(),
            y = function () {
              function e(e) {
                this.type = e;
              }
              function t(t, r, n) {
                e.call(this, "args"), this.index = t, this.min = r, this.max = n;
              }
              function r(t) {
                e.call(this, "literal"), this.number = t, this.min = t, this.max = t;
              }
              function n(t, r, n, i, a) {
                e.call(this, "binary"), this.op = t, this.arg1 = r, this.arg2 = n, this.min = i, this.max = a;
              }
              function i(t, r) {
                e.call(this, "max"), this.arg = t, this.min = t.min, this.max = r;
              }
              function a(t, r, n) {
                e.call(this, "var"), this.index = t, this.min = r, this.max = n;
              }
              function o(t, r) {
                e.call(this, "definition"), this.variable = t, this.arg = r;
              }
              function s() {
                this.parts = [];
              }
              function l(e, t) {
                return "literal" === t.type && 0 === t.number ? e : "literal" === e.type && 0 === e.number ? t : "literal" === t.type && "literal" === e.type ? new r(e.number + t.number) : new n("+", e, t, e.min + t.min, e.max + t.max);
              }
              function c(e, t) {
                if ("literal" === t.type) {
                  if (0 === t.number) return new r(0);
                  if (1 === t.number) return e;
                  if ("literal" === e.type) return new r(e.number * t.number);
                }
                if ("literal" === e.type) {
                  if (0 === e.number) return new r(0);
                  if (1 === e.number) return t;
                }
                return new n("*", e, t, Math.min(e.min * t.min, e.min * t.max, e.max * t.min, e.max * t.max), Math.max(e.min * t.min, e.min * t.max, e.max * t.min, e.max * t.max));
              }
              function u(e, t) {
                if ("literal" === t.type) {
                  if (0 === t.number) return e;
                  if ("literal" === e.type) return new r(e.number - t.number);
                }
                return "binary" === t.type && "-" === t.op && "literal" === e.type && 1 === e.number && "literal" === t.arg1.type && 1 === t.arg1.number ? t.arg2 : new n("-", e, t, e.min - t.max, e.max - t.min);
              }
              function h(e, t) {
                return e.min >= t ? new r(t) : e.max <= t ? e : new i(e, t);
              }
              function f() {}
              return e.prototype.visit = function (e) {
                throw new Error("abstract method");
              }, t.prototype = Object.create(e.prototype), t.prototype.visit = function (e) {
                e.visitArgument(this);
              }, r.prototype = Object.create(e.prototype), r.prototype.visit = function (e) {
                e.visitLiteral(this);
              }, n.prototype = Object.create(e.prototype), n.prototype.visit = function (e) {
                e.visitBinaryOperation(this);
              }, i.prototype = Object.create(e.prototype), i.prototype.visit = function (e) {
                e.visitMin(this);
              }, a.prototype = Object.create(e.prototype), a.prototype.visit = function (e) {
                e.visitVariable(this);
              }, o.prototype = Object.create(e.prototype), o.prototype.visit = function (e) {
                e.visitVariableDefinition(this);
              }, s.prototype = {
                visitArgument: function visitArgument(e) {
                  this.parts.push("Math.max(", e.min, ", Math.min(", e.max, ", src[srcOffset + ", e.index, "]))");
                },
                visitVariable: function visitVariable(e) {
                  this.parts.push("v", e.index);
                },
                visitLiteral: function visitLiteral(e) {
                  this.parts.push(e.number);
                },
                visitBinaryOperation: function visitBinaryOperation(e) {
                  this.parts.push("("), e.arg1.visit(this), this.parts.push(" ", e.op, " "), e.arg2.visit(this), this.parts.push(")");
                },
                visitVariableDefinition: function visitVariableDefinition(e) {
                  this.parts.push("var "), e.variable.visit(this), this.parts.push(" = "), e.arg.visit(this), this.parts.push(";");
                },
                visitMin: function visitMin(e) {
                  this.parts.push("Math.min("), e.arg.visit(this), this.parts.push(", ", e.max, ")");
                },
                toString: function toString() {
                  return this.parts.join("");
                }
              }, f.prototype = {
                compile: function compile(e, n, i) {
                  var f,
                    d,
                    p,
                    m,
                    g,
                    v,
                    b,
                    y,
                    w,
                    x,
                    _ = [],
                    S = [],
                    C = n.length >> 1,
                    E = i.length >> 1,
                    A = 0;
                  for (f = 0; f < C; f++) _.push(new t(f, n[2 * f], n[2 * f + 1]));
                  for (f = 0, d = e.length; f < d; f++) if ("number" != typeof (x = e[f])) switch (x) {
                    case "add":
                      if (_.length < 2) return null;
                      v = _.pop(), g = _.pop(), _.push(l(g, v));
                      break;
                    case "cvr":
                      if (_.length < 1) return null;
                      break;
                    case "mul":
                      if (_.length < 2) return null;
                      v = _.pop(), g = _.pop(), _.push(c(g, v));
                      break;
                    case "sub":
                      if (_.length < 2) return null;
                      v = _.pop(), g = _.pop(), _.push(u(g, v));
                      break;
                    case "exch":
                      if (_.length < 2) return null;
                      b = _.pop(), y = _.pop(), _.push(b, y);
                      break;
                    case "pop":
                      if (_.length < 1) return null;
                      _.pop();
                      break;
                    case "index":
                      if (_.length < 1) return null;
                      if (g = _.pop(), "literal" !== g.type) return null;
                      if ((p = g.number) < 0 || (0 | p) !== p || _.length < p) return null;
                      if (b = _[_.length - p - 1], "literal" === b.type || "var" === b.type) {
                        _.push(b);
                        break;
                      }
                      w = new a(A++, b.min, b.max), _[_.length - p - 1] = w, _.push(w), S.push(new o(w, b));
                      break;
                    case "dup":
                      if (_.length < 1) return null;
                      if ("number" == typeof e[f + 1] && "gt" === e[f + 2] && e[f + 3] === f + 7 && "jz" === e[f + 4] && "pop" === e[f + 5] && e[f + 6] === e[f + 1]) {
                        g = _.pop(), _.push(h(g, e[f + 1])), f += 6;
                        break;
                      }
                      if (b = _[_.length - 1], "literal" === b.type || "var" === b.type) {
                        _.push(b);
                        break;
                      }
                      w = new a(A++, b.min, b.max), _[_.length - 1] = w, _.push(w), S.push(new o(w, b));
                      break;
                    case "roll":
                      if (_.length < 2) return null;
                      if (v = _.pop(), g = _.pop(), "literal" !== v.type || "literal" !== g.type) return null;
                      if (m = v.number, (p = g.number) <= 0 || (0 | p) !== p || (0 | m) !== m || _.length < p) return null;
                      if (0 === (m = (m % p + p) % p)) break;
                      Array.prototype.push.apply(_, _.splice(_.length - p, p - m));
                      break;
                    default:
                      return null;
                  } else _.push(new r(x));
                  if (_.length !== E) return null;
                  var T = [];
                  return S.forEach(function (e) {
                    var t = new s();
                    e.visit(t), T.push(t.toString());
                  }), _.forEach(function (e, t) {
                    var r = new s();
                    e.visit(r);
                    var n = i[2 * t],
                      a = i[2 * t + 1],
                      o = [r.toString()];
                    n > e.min && (o.unshift("Math.max(", n, ", "), o.push(")")), a < e.max && (o.unshift("Math.min(", a, ", "), o.push(")")), o.unshift("dest[destOffset + ", t, "] = "), o.push(";"), T.push(o.join(""));
                  }), T.join("\n");
                }
              }, f;
            }();
          t.isPDFFunction = n, t.PDFFunction = g, t.PostScriptEvaluator = b, t.PostScriptCompiler = y;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = n.getLookupTableFactory,
            a = i(function (e) {
              e.A = 65, e.AE = 198, e.AEacute = 508, e.AEmacron = 482, e.AEsmall = 63462, e.Aacute = 193, e.Aacutesmall = 63457, e.Abreve = 258, e.Abreveacute = 7854, e.Abrevecyrillic = 1232, e.Abrevedotbelow = 7862, e.Abrevegrave = 7856, e.Abrevehookabove = 7858, e.Abrevetilde = 7860, e.Acaron = 461, e.Acircle = 9398, e.Acircumflex = 194, e.Acircumflexacute = 7844, e.Acircumflexdotbelow = 7852, e.Acircumflexgrave = 7846, e.Acircumflexhookabove = 7848, e.Acircumflexsmall = 63458, e.Acircumflextilde = 7850, e.Acute = 63177, e.Acutesmall = 63412, e.Acyrillic = 1040, e.Adblgrave = 512, e.Adieresis = 196, e.Adieresiscyrillic = 1234, e.Adieresismacron = 478, e.Adieresissmall = 63460, e.Adotbelow = 7840, e.Adotmacron = 480, e.Agrave = 192, e.Agravesmall = 63456, e.Ahookabove = 7842, e.Aiecyrillic = 1236, e.Ainvertedbreve = 514, e.Alpha = 913, e.Alphatonos = 902, e.Amacron = 256, e.Amonospace = 65313, e.Aogonek = 260, e.Aring = 197, e.Aringacute = 506, e.Aringbelow = 7680, e.Aringsmall = 63461, e.Asmall = 63329, e.Atilde = 195, e.Atildesmall = 63459, e.Aybarmenian = 1329, e.B = 66, e.Bcircle = 9399, e.Bdotaccent = 7682, e.Bdotbelow = 7684, e.Becyrillic = 1041, e.Benarmenian = 1330, e.Beta = 914, e.Bhook = 385, e.Blinebelow = 7686, e.Bmonospace = 65314, e.Brevesmall = 63220, e.Bsmall = 63330, e.Btopbar = 386, e.C = 67, e.Caarmenian = 1342, e.Cacute = 262, e.Caron = 63178, e.Caronsmall = 63221, e.Ccaron = 268, e.Ccedilla = 199, e.Ccedillaacute = 7688, e.Ccedillasmall = 63463, e.Ccircle = 9400, e.Ccircumflex = 264, e.Cdot = 266, e.Cdotaccent = 266, e.Cedillasmall = 63416, e.Chaarmenian = 1353, e.Cheabkhasiancyrillic = 1212, e.Checyrillic = 1063, e.Chedescenderabkhasiancyrillic = 1214, e.Chedescendercyrillic = 1206, e.Chedieresiscyrillic = 1268, e.Cheharmenian = 1347, e.Chekhakassiancyrillic = 1227, e.Cheverticalstrokecyrillic = 1208, e.Chi = 935, e.Chook = 391, e.Circumflexsmall = 63222, e.Cmonospace = 65315, e.Coarmenian = 1361, e.Csmall = 63331, e.D = 68, e.DZ = 497, e.DZcaron = 452, e.Daarmenian = 1332, e.Dafrican = 393, e.Dcaron = 270, e.Dcedilla = 7696, e.Dcircle = 9401, e.Dcircumflexbelow = 7698, e.Dcroat = 272, e.Ddotaccent = 7690, e.Ddotbelow = 7692, e.Decyrillic = 1044, e.Deicoptic = 1006, e.Delta = 8710, e.Deltagreek = 916, e.Dhook = 394, e.Dieresis = 63179, e.DieresisAcute = 63180, e.DieresisGrave = 63181, e.Dieresissmall = 63400, e.Digammagreek = 988, e.Djecyrillic = 1026, e.Dlinebelow = 7694, e.Dmonospace = 65316, e.Dotaccentsmall = 63223, e.Dslash = 272, e.Dsmall = 63332, e.Dtopbar = 395, e.Dz = 498, e.Dzcaron = 453, e.Dzeabkhasiancyrillic = 1248, e.Dzecyrillic = 1029, e.Dzhecyrillic = 1039, e.E = 69, e.Eacute = 201, e.Eacutesmall = 63465, e.Ebreve = 276, e.Ecaron = 282, e.Ecedillabreve = 7708, e.Echarmenian = 1333, e.Ecircle = 9402, e.Ecircumflex = 202, e.Ecircumflexacute = 7870, e.Ecircumflexbelow = 7704, e.Ecircumflexdotbelow = 7878, e.Ecircumflexgrave = 7872, e.Ecircumflexhookabove = 7874, e.Ecircumflexsmall = 63466, e.Ecircumflextilde = 7876, e.Ecyrillic = 1028, e.Edblgrave = 516, e.Edieresis = 203, e.Edieresissmall = 63467, e.Edot = 278, e.Edotaccent = 278, e.Edotbelow = 7864, e.Efcyrillic = 1060, e.Egrave = 200, e.Egravesmall = 63464, e.Eharmenian = 1335, e.Ehookabove = 7866, e.Eightroman = 8551, e.Einvertedbreve = 518, e.Eiotifiedcyrillic = 1124, e.Elcyrillic = 1051, e.Elevenroman = 8554, e.Emacron = 274, e.Emacronacute = 7702, e.Emacrongrave = 7700, e.Emcyrillic = 1052, e.Emonospace = 65317, e.Encyrillic = 1053, e.Endescendercyrillic = 1186, e.Eng = 330, e.Enghecyrillic = 1188, e.Enhookcyrillic = 1223, e.Eogonek = 280, e.Eopen = 400, e.Epsilon = 917, e.Epsilontonos = 904, e.Ercyrillic = 1056, e.Ereversed = 398, e.Ereversedcyrillic = 1069, e.Escyrillic = 1057, e.Esdescendercyrillic = 1194, e.Esh = 425, e.Esmall = 63333, e.Eta = 919, e.Etarmenian = 1336, e.Etatonos = 905, e.Eth = 208, e.Ethsmall = 63472, e.Etilde = 7868, e.Etildebelow = 7706, e.Euro = 8364, e.Ezh = 439, e.Ezhcaron = 494, e.Ezhreversed = 440, e.F = 70, e.Fcircle = 9403, e.Fdotaccent = 7710, e.Feharmenian = 1366, e.Feicoptic = 996, e.Fhook = 401, e.Fitacyrillic = 1138, e.Fiveroman = 8548;
              e.Fmonospace = 65318, e.Fourroman = 8547, e.Fsmall = 63334, e.G = 71, e.GBsquare = 13191, e.Gacute = 500, e.Gamma = 915, e.Gammaafrican = 404, e.Gangiacoptic = 1002, e.Gbreve = 286, e.Gcaron = 486, e.Gcedilla = 290, e.Gcircle = 9404, e.Gcircumflex = 284, e.Gcommaaccent = 290, e.Gdot = 288, e.Gdotaccent = 288, e.Gecyrillic = 1043, e.Ghadarmenian = 1346, e.Ghemiddlehookcyrillic = 1172, e.Ghestrokecyrillic = 1170, e.Gheupturncyrillic = 1168, e.Ghook = 403, e.Gimarmenian = 1331, e.Gjecyrillic = 1027, e.Gmacron = 7712, e.Gmonospace = 65319, e.Grave = 63182, e.Gravesmall = 63328, e.Gsmall = 63335, e.Gsmallhook = 667, e.Gstroke = 484, e.H = 72, e.H18533 = 9679, e.H18543 = 9642, e.H18551 = 9643, e.H22073 = 9633, e.HPsquare = 13259, e.Haabkhasiancyrillic = 1192, e.Hadescendercyrillic = 1202, e.Hardsigncyrillic = 1066, e.Hbar = 294, e.Hbrevebelow = 7722, e.Hcedilla = 7720, e.Hcircle = 9405, e.Hcircumflex = 292, e.Hdieresis = 7718, e.Hdotaccent = 7714, e.Hdotbelow = 7716, e.Hmonospace = 65320, e.Hoarmenian = 1344, e.Horicoptic = 1e3, e.Hsmall = 63336, e.Hungarumlaut = 63183, e.Hungarumlautsmall = 63224, e.Hzsquare = 13200, e.I = 73, e.IAcyrillic = 1071, e.IJ = 306, e.IUcyrillic = 1070, e.Iacute = 205, e.Iacutesmall = 63469, e.Ibreve = 300, e.Icaron = 463, e.Icircle = 9406, e.Icircumflex = 206, e.Icircumflexsmall = 63470, e.Icyrillic = 1030, e.Idblgrave = 520, e.Idieresis = 207, e.Idieresisacute = 7726, e.Idieresiscyrillic = 1252, e.Idieresissmall = 63471, e.Idot = 304, e.Idotaccent = 304, e.Idotbelow = 7882, e.Iebrevecyrillic = 1238, e.Iecyrillic = 1045, e.Ifraktur = 8465, e.Igrave = 204, e.Igravesmall = 63468, e.Ihookabove = 7880, e.Iicyrillic = 1048, e.Iinvertedbreve = 522, e.Iishortcyrillic = 1049, e.Imacron = 298, e.Imacroncyrillic = 1250, e.Imonospace = 65321, e.Iniarmenian = 1339, e.Iocyrillic = 1025, e.Iogonek = 302, e.Iota = 921, e.Iotaafrican = 406, e.Iotadieresis = 938, e.Iotatonos = 906, e.Ismall = 63337, e.Istroke = 407, e.Itilde = 296, e.Itildebelow = 7724, e.Izhitsacyrillic = 1140, e.Izhitsadblgravecyrillic = 1142, e.J = 74, e.Jaarmenian = 1345, e.Jcircle = 9407, e.Jcircumflex = 308, e.Jecyrillic = 1032, e.Jheharmenian = 1355, e.Jmonospace = 65322, e.Jsmall = 63338, e.K = 75, e.KBsquare = 13189, e.KKsquare = 13261, e.Kabashkircyrillic = 1184, e.Kacute = 7728, e.Kacyrillic = 1050, e.Kadescendercyrillic = 1178, e.Kahookcyrillic = 1219, e.Kappa = 922, e.Kastrokecyrillic = 1182, e.Kaverticalstrokecyrillic = 1180, e.Kcaron = 488, e.Kcedilla = 310, e.Kcircle = 9408, e.Kcommaaccent = 310, e.Kdotbelow = 7730, e.Keharmenian = 1364, e.Kenarmenian = 1343, e.Khacyrillic = 1061, e.Kheicoptic = 998, e.Khook = 408, e.Kjecyrillic = 1036, e.Klinebelow = 7732, e.Kmonospace = 65323, e.Koppacyrillic = 1152, e.Koppagreek = 990, e.Ksicyrillic = 1134, e.Ksmall = 63339, e.L = 76, e.LJ = 455, e.LL = 63167, e.Lacute = 313, e.Lambda = 923, e.Lcaron = 317, e.Lcedilla = 315, e.Lcircle = 9409, e.Lcircumflexbelow = 7740, e.Lcommaaccent = 315, e.Ldot = 319, e.Ldotaccent = 319, e.Ldotbelow = 7734, e.Ldotbelowmacron = 7736, e.Liwnarmenian = 1340, e.Lj = 456, e.Ljecyrillic = 1033, e.Llinebelow = 7738, e.Lmonospace = 65324, e.Lslash = 321, e.Lslashsmall = 63225, e.Lsmall = 63340, e.M = 77, e.MBsquare = 13190, e.Macron = 63184, e.Macronsmall = 63407, e.Macute = 7742, e.Mcircle = 9410, e.Mdotaccent = 7744, e.Mdotbelow = 7746, e.Menarmenian = 1348, e.Mmonospace = 65325, e.Msmall = 63341, e.Mturned = 412, e.Mu = 924, e.N = 78, e.NJ = 458, e.Nacute = 323, e.Ncaron = 327, e.Ncedilla = 325, e.Ncircle = 9411, e.Ncircumflexbelow = 7754, e.Ncommaaccent = 325, e.Ndotaccent = 7748, e.Ndotbelow = 7750, e.Nhookleft = 413, e.Nineroman = 8552, e.Nj = 459, e.Njecyrillic = 1034, e.Nlinebelow = 7752, e.Nmonospace = 65326, e.Nowarmenian = 1350, e.Nsmall = 63342, e.Ntilde = 209, e.Ntildesmall = 63473, e.Nu = 925, e.O = 79, e.OE = 338, e.OEsmall = 63226, e.Oacute = 211, e.Oacutesmall = 63475, e.Obarredcyrillic = 1256, e.Obarreddieresiscyrillic = 1258;
              e.Obreve = 334, e.Ocaron = 465, e.Ocenteredtilde = 415, e.Ocircle = 9412, e.Ocircumflex = 212, e.Ocircumflexacute = 7888, e.Ocircumflexdotbelow = 7896, e.Ocircumflexgrave = 7890, e.Ocircumflexhookabove = 7892, e.Ocircumflexsmall = 63476, e.Ocircumflextilde = 7894, e.Ocyrillic = 1054, e.Odblacute = 336, e.Odblgrave = 524, e.Odieresis = 214, e.Odieresiscyrillic = 1254, e.Odieresissmall = 63478, e.Odotbelow = 7884, e.Ogoneksmall = 63227, e.Ograve = 210, e.Ogravesmall = 63474, e.Oharmenian = 1365, e.Ohm = 8486, e.Ohookabove = 7886, e.Ohorn = 416, e.Ohornacute = 7898, e.Ohorndotbelow = 7906, e.Ohorngrave = 7900, e.Ohornhookabove = 7902, e.Ohorntilde = 7904, e.Ohungarumlaut = 336, e.Oi = 418, e.Oinvertedbreve = 526, e.Omacron = 332, e.Omacronacute = 7762, e.Omacrongrave = 7760, e.Omega = 8486, e.Omegacyrillic = 1120, e.Omegagreek = 937, e.Omegaroundcyrillic = 1146, e.Omegatitlocyrillic = 1148, e.Omegatonos = 911, e.Omicron = 927, e.Omicrontonos = 908, e.Omonospace = 65327, e.Oneroman = 8544, e.Oogonek = 490, e.Oogonekmacron = 492, e.Oopen = 390, e.Oslash = 216, e.Oslashacute = 510, e.Oslashsmall = 63480, e.Osmall = 63343, e.Ostrokeacute = 510, e.Otcyrillic = 1150, e.Otilde = 213, e.Otildeacute = 7756, e.Otildedieresis = 7758, e.Otildesmall = 63477, e.P = 80, e.Pacute = 7764, e.Pcircle = 9413, e.Pdotaccent = 7766, e.Pecyrillic = 1055, e.Peharmenian = 1354, e.Pemiddlehookcyrillic = 1190, e.Phi = 934, e.Phook = 420, e.Pi = 928, e.Piwrarmenian = 1363, e.Pmonospace = 65328, e.Psi = 936, e.Psicyrillic = 1136, e.Psmall = 63344, e.Q = 81, e.Qcircle = 9414, e.Qmonospace = 65329, e.Qsmall = 63345, e.R = 82, e.Raarmenian = 1356, e.Racute = 340, e.Rcaron = 344, e.Rcedilla = 342, e.Rcircle = 9415, e.Rcommaaccent = 342, e.Rdblgrave = 528, e.Rdotaccent = 7768, e.Rdotbelow = 7770, e.Rdotbelowmacron = 7772, e.Reharmenian = 1360, e.Rfraktur = 8476, e.Rho = 929, e.Ringsmall = 63228, e.Rinvertedbreve = 530, e.Rlinebelow = 7774, e.Rmonospace = 65330, e.Rsmall = 63346, e.Rsmallinverted = 641, e.Rsmallinvertedsuperior = 694, e.S = 83, e.SF010000 = 9484, e.SF020000 = 9492, e.SF030000 = 9488, e.SF040000 = 9496, e.SF050000 = 9532, e.SF060000 = 9516, e.SF070000 = 9524, e.SF080000 = 9500, e.SF090000 = 9508, e.SF100000 = 9472, e.SF110000 = 9474, e.SF190000 = 9569, e.SF200000 = 9570, e.SF210000 = 9558, e.SF220000 = 9557, e.SF230000 = 9571, e.SF240000 = 9553, e.SF250000 = 9559, e.SF260000 = 9565, e.SF270000 = 9564, e.SF280000 = 9563, e.SF360000 = 9566, e.SF370000 = 9567, e.SF380000 = 9562, e.SF390000 = 9556, e.SF400000 = 9577, e.SF410000 = 9574, e.SF420000 = 9568, e.SF430000 = 9552, e.SF440000 = 9580, e.SF450000 = 9575, e.SF460000 = 9576, e.SF470000 = 9572, e.SF480000 = 9573, e.SF490000 = 9561, e.SF500000 = 9560, e.SF510000 = 9554, e.SF520000 = 9555, e.SF530000 = 9579, e.SF540000 = 9578, e.Sacute = 346, e.Sacutedotaccent = 7780, e.Sampigreek = 992, e.Scaron = 352, e.Scarondotaccent = 7782, e.Scaronsmall = 63229, e.Scedilla = 350, e.Schwa = 399, e.Schwacyrillic = 1240, e.Schwadieresiscyrillic = 1242, e.Scircle = 9416, e.Scircumflex = 348, e.Scommaaccent = 536, e.Sdotaccent = 7776, e.Sdotbelow = 7778, e.Sdotbelowdotaccent = 7784, e.Seharmenian = 1357, e.Sevenroman = 8550, e.Shaarmenian = 1351, e.Shacyrillic = 1064, e.Shchacyrillic = 1065, e.Sheicoptic = 994, e.Shhacyrillic = 1210, e.Shimacoptic = 1004, e.Sigma = 931, e.Sixroman = 8549, e.Smonospace = 65331, e.Softsigncyrillic = 1068, e.Ssmall = 63347, e.Stigmagreek = 986, e.T = 84, e.Tau = 932, e.Tbar = 358, e.Tcaron = 356, e.Tcedilla = 354, e.Tcircle = 9417, e.Tcircumflexbelow = 7792, e.Tcommaaccent = 354, e.Tdotaccent = 7786, e.Tdotbelow = 7788, e.Tecyrillic = 1058, e.Tedescendercyrillic = 1196, e.Tenroman = 8553, e.Tetsecyrillic = 1204, e.Theta = 920, e.Thook = 428, e.Thorn = 222, e.Thornsmall = 63486, e.Threeroman = 8546, e.Tildesmall = 63230, e.Tiwnarmenian = 1359, e.Tlinebelow = 7790, e.Tmonospace = 65332, e.Toarmenian = 1337, e.Tonefive = 444, e.Tonesix = 388, e.Tonetwo = 423, e.Tretroflexhook = 430, e.Tsecyrillic = 1062, e.Tshecyrillic = 1035;
              e.Tsmall = 63348, e.Twelveroman = 8555, e.Tworoman = 8545, e.U = 85, e.Uacute = 218, e.Uacutesmall = 63482, e.Ubreve = 364, e.Ucaron = 467, e.Ucircle = 9418, e.Ucircumflex = 219, e.Ucircumflexbelow = 7798, e.Ucircumflexsmall = 63483, e.Ucyrillic = 1059, e.Udblacute = 368, e.Udblgrave = 532, e.Udieresis = 220, e.Udieresisacute = 471, e.Udieresisbelow = 7794, e.Udieresiscaron = 473, e.Udieresiscyrillic = 1264, e.Udieresisgrave = 475, e.Udieresismacron = 469, e.Udieresissmall = 63484, e.Udotbelow = 7908, e.Ugrave = 217, e.Ugravesmall = 63481, e.Uhookabove = 7910, e.Uhorn = 431, e.Uhornacute = 7912, e.Uhorndotbelow = 7920, e.Uhorngrave = 7914, e.Uhornhookabove = 7916, e.Uhorntilde = 7918, e.Uhungarumlaut = 368, e.Uhungarumlautcyrillic = 1266, e.Uinvertedbreve = 534, e.Ukcyrillic = 1144, e.Umacron = 362, e.Umacroncyrillic = 1262, e.Umacrondieresis = 7802, e.Umonospace = 65333, e.Uogonek = 370, e.Upsilon = 933, e.Upsilon1 = 978, e.Upsilonacutehooksymbolgreek = 979, e.Upsilonafrican = 433, e.Upsilondieresis = 939, e.Upsilondieresishooksymbolgreek = 980, e.Upsilonhooksymbol = 978, e.Upsilontonos = 910, e.Uring = 366, e.Ushortcyrillic = 1038, e.Usmall = 63349, e.Ustraightcyrillic = 1198, e.Ustraightstrokecyrillic = 1200, e.Utilde = 360, e.Utildeacute = 7800, e.Utildebelow = 7796, e.V = 86, e.Vcircle = 9419, e.Vdotbelow = 7806, e.Vecyrillic = 1042, e.Vewarmenian = 1358, e.Vhook = 434, e.Vmonospace = 65334, e.Voarmenian = 1352, e.Vsmall = 63350, e.Vtilde = 7804, e.W = 87, e.Wacute = 7810, e.Wcircle = 9420, e.Wcircumflex = 372, e.Wdieresis = 7812, e.Wdotaccent = 7814, e.Wdotbelow = 7816, e.Wgrave = 7808, e.Wmonospace = 65335, e.Wsmall = 63351, e.X = 88, e.Xcircle = 9421, e.Xdieresis = 7820, e.Xdotaccent = 7818, e.Xeharmenian = 1341, e.Xi = 926, e.Xmonospace = 65336, e.Xsmall = 63352, e.Y = 89, e.Yacute = 221, e.Yacutesmall = 63485, e.Yatcyrillic = 1122, e.Ycircle = 9422, e.Ycircumflex = 374, e.Ydieresis = 376, e.Ydieresissmall = 63487, e.Ydotaccent = 7822, e.Ydotbelow = 7924, e.Yericyrillic = 1067, e.Yerudieresiscyrillic = 1272, e.Ygrave = 7922, e.Yhook = 435, e.Yhookabove = 7926, e.Yiarmenian = 1349, e.Yicyrillic = 1031, e.Yiwnarmenian = 1362, e.Ymonospace = 65337, e.Ysmall = 63353, e.Ytilde = 7928, e.Yusbigcyrillic = 1130, e.Yusbigiotifiedcyrillic = 1132, e.Yuslittlecyrillic = 1126, e.Yuslittleiotifiedcyrillic = 1128, e.Z = 90, e.Zaarmenian = 1334, e.Zacute = 377, e.Zcaron = 381, e.Zcaronsmall = 63231, e.Zcircle = 9423, e.Zcircumflex = 7824, e.Zdot = 379, e.Zdotaccent = 379, e.Zdotbelow = 7826, e.Zecyrillic = 1047, e.Zedescendercyrillic = 1176, e.Zedieresiscyrillic = 1246, e.Zeta = 918, e.Zhearmenian = 1338, e.Zhebrevecyrillic = 1217, e.Zhecyrillic = 1046, e.Zhedescendercyrillic = 1174, e.Zhedieresiscyrillic = 1244, e.Zlinebelow = 7828, e.Zmonospace = 65338, e.Zsmall = 63354, e.Zstroke = 437, e.a = 97, e.aabengali = 2438, e.aacute = 225, e.aadeva = 2310, e.aagujarati = 2694, e.aagurmukhi = 2566, e.aamatragurmukhi = 2622, e.aarusquare = 13059, e.aavowelsignbengali = 2494, e.aavowelsigndeva = 2366, e.aavowelsigngujarati = 2750, e.abbreviationmarkarmenian = 1375, e.abbreviationsigndeva = 2416, e.abengali = 2437, e.abopomofo = 12570, e.abreve = 259, e.abreveacute = 7855, e.abrevecyrillic = 1233, e.abrevedotbelow = 7863, e.abrevegrave = 7857, e.abrevehookabove = 7859, e.abrevetilde = 7861, e.acaron = 462, e.acircle = 9424, e.acircumflex = 226, e.acircumflexacute = 7845, e.acircumflexdotbelow = 7853, e.acircumflexgrave = 7847, e.acircumflexhookabove = 7849, e.acircumflextilde = 7851, e.acute = 180, e.acutebelowcmb = 791, e.acutecmb = 769, e.acutecomb = 769, e.acutedeva = 2388, e.acutelowmod = 719, e.acutetonecmb = 833, e.acyrillic = 1072, e.adblgrave = 513, e.addakgurmukhi = 2673, e.adeva = 2309, e.adieresis = 228, e.adieresiscyrillic = 1235, e.adieresismacron = 479, e.adotbelow = 7841, e.adotmacron = 481, e.ae = 230, e.aeacute = 509, e.aekorean = 12624, e.aemacron = 483, e.afii00208 = 8213, e.afii08941 = 8356, e.afii10017 = 1040, e.afii10018 = 1041, e.afii10019 = 1042, e.afii10020 = 1043, e.afii10021 = 1044, e.afii10022 = 1045, e.afii10023 = 1025, e.afii10024 = 1046, e.afii10025 = 1047, e.afii10026 = 1048, e.afii10027 = 1049, e.afii10028 = 1050, e.afii10029 = 1051, e.afii10030 = 1052;
              e.afii10031 = 1053, e.afii10032 = 1054, e.afii10033 = 1055, e.afii10034 = 1056, e.afii10035 = 1057, e.afii10036 = 1058, e.afii10037 = 1059, e.afii10038 = 1060, e.afii10039 = 1061, e.afii10040 = 1062, e.afii10041 = 1063, e.afii10042 = 1064, e.afii10043 = 1065, e.afii10044 = 1066, e.afii10045 = 1067, e.afii10046 = 1068, e.afii10047 = 1069, e.afii10048 = 1070, e.afii10049 = 1071, e.afii10050 = 1168, e.afii10051 = 1026, e.afii10052 = 1027, e.afii10053 = 1028, e.afii10054 = 1029, e.afii10055 = 1030, e.afii10056 = 1031, e.afii10057 = 1032, e.afii10058 = 1033, e.afii10059 = 1034, e.afii10060 = 1035, e.afii10061 = 1036, e.afii10062 = 1038, e.afii10063 = 63172, e.afii10064 = 63173, e.afii10065 = 1072, e.afii10066 = 1073, e.afii10067 = 1074, e.afii10068 = 1075, e.afii10069 = 1076, e.afii10070 = 1077, e.afii10071 = 1105, e.afii10072 = 1078, e.afii10073 = 1079, e.afii10074 = 1080, e.afii10075 = 1081, e.afii10076 = 1082, e.afii10077 = 1083, e.afii10078 = 1084, e.afii10079 = 1085, e.afii10080 = 1086, e.afii10081 = 1087, e.afii10082 = 1088, e.afii10083 = 1089, e.afii10084 = 1090, e.afii10085 = 1091, e.afii10086 = 1092, e.afii10087 = 1093, e.afii10088 = 1094, e.afii10089 = 1095, e.afii10090 = 1096, e.afii10091 = 1097, e.afii10092 = 1098, e.afii10093 = 1099, e.afii10094 = 1100, e.afii10095 = 1101, e.afii10096 = 1102, e.afii10097 = 1103, e.afii10098 = 1169, e.afii10099 = 1106, e.afii10100 = 1107, e.afii10101 = 1108, e.afii10102 = 1109, e.afii10103 = 1110, e.afii10104 = 1111, e.afii10105 = 1112, e.afii10106 = 1113, e.afii10107 = 1114, e.afii10108 = 1115, e.afii10109 = 1116, e.afii10110 = 1118, e.afii10145 = 1039, e.afii10146 = 1122, e.afii10147 = 1138, e.afii10148 = 1140, e.afii10192 = 63174, e.afii10193 = 1119, e.afii10194 = 1123, e.afii10195 = 1139, e.afii10196 = 1141, e.afii10831 = 63175, e.afii10832 = 63176, e.afii10846 = 1241, e.afii299 = 8206, e.afii300 = 8207, e.afii301 = 8205, e.afii57381 = 1642, e.afii57388 = 1548, e.afii57392 = 1632, e.afii57393 = 1633, e.afii57394 = 1634, e.afii57395 = 1635, e.afii57396 = 1636, e.afii57397 = 1637, e.afii57398 = 1638, e.afii57399 = 1639, e.afii57400 = 1640, e.afii57401 = 1641, e.afii57403 = 1563, e.afii57407 = 1567, e.afii57409 = 1569, e.afii57410 = 1570, e.afii57411 = 1571, e.afii57412 = 1572, e.afii57413 = 1573, e.afii57414 = 1574, e.afii57415 = 1575, e.afii57416 = 1576, e.afii57417 = 1577, e.afii57418 = 1578, e.afii57419 = 1579, e.afii57420 = 1580, e.afii57421 = 1581, e.afii57422 = 1582, e.afii57423 = 1583, e.afii57424 = 1584, e.afii57425 = 1585, e.afii57426 = 1586, e.afii57427 = 1587, e.afii57428 = 1588, e.afii57429 = 1589, e.afii57430 = 1590, e.afii57431 = 1591, e.afii57432 = 1592, e.afii57433 = 1593, e.afii57434 = 1594, e.afii57440 = 1600, e.afii57441 = 1601, e.afii57442 = 1602, e.afii57443 = 1603, e.afii57444 = 1604, e.afii57445 = 1605, e.afii57446 = 1606, e.afii57448 = 1608, e.afii57449 = 1609, e.afii57450 = 1610, e.afii57451 = 1611, e.afii57452 = 1612, e.afii57453 = 1613, e.afii57454 = 1614, e.afii57455 = 1615, e.afii57456 = 1616, e.afii57457 = 1617, e.afii57458 = 1618, e.afii57470 = 1607, e.afii57505 = 1700, e.afii57506 = 1662, e.afii57507 = 1670, e.afii57508 = 1688, e.afii57509 = 1711, e.afii57511 = 1657, e.afii57512 = 1672, e.afii57513 = 1681, e.afii57514 = 1722, e.afii57519 = 1746, e.afii57534 = 1749, e.afii57636 = 8362, e.afii57645 = 1470, e.afii57658 = 1475, e.afii57664 = 1488, e.afii57665 = 1489, e.afii57666 = 1490, e.afii57667 = 1491, e.afii57668 = 1492, e.afii57669 = 1493, e.afii57670 = 1494, e.afii57671 = 1495, e.afii57672 = 1496, e.afii57673 = 1497, e.afii57674 = 1498, e.afii57675 = 1499, e.afii57676 = 1500, e.afii57677 = 1501, e.afii57678 = 1502, e.afii57679 = 1503, e.afii57680 = 1504, e.afii57681 = 1505, e.afii57682 = 1506, e.afii57683 = 1507, e.afii57684 = 1508, e.afii57685 = 1509, e.afii57686 = 1510, e.afii57687 = 1511, e.afii57688 = 1512, e.afii57689 = 1513, e.afii57690 = 1514, e.afii57694 = 64298, e.afii57695 = 64299, e.afii57700 = 64331, e.afii57705 = 64287, e.afii57716 = 1520;
              e.afii57717 = 1521, e.afii57718 = 1522, e.afii57723 = 64309, e.afii57793 = 1460, e.afii57794 = 1461, e.afii57795 = 1462, e.afii57796 = 1467, e.afii57797 = 1464, e.afii57798 = 1463, e.afii57799 = 1456, e.afii57800 = 1458, e.afii57801 = 1457, e.afii57802 = 1459, e.afii57803 = 1474, e.afii57804 = 1473, e.afii57806 = 1465, e.afii57807 = 1468, e.afii57839 = 1469, e.afii57841 = 1471, e.afii57842 = 1472, e.afii57929 = 700, e.afii61248 = 8453, e.afii61289 = 8467, e.afii61352 = 8470, e.afii61573 = 8236, e.afii61574 = 8237, e.afii61575 = 8238, e.afii61664 = 8204, e.afii63167 = 1645, e.afii64937 = 701, e.agrave = 224, e.agujarati = 2693, e.agurmukhi = 2565, e.ahiragana = 12354, e.ahookabove = 7843, e.aibengali = 2448, e.aibopomofo = 12574, e.aideva = 2320, e.aiecyrillic = 1237, e.aigujarati = 2704, e.aigurmukhi = 2576, e.aimatragurmukhi = 2632, e.ainarabic = 1593, e.ainfinalarabic = 65226, e.aininitialarabic = 65227, e.ainmedialarabic = 65228, e.ainvertedbreve = 515, e.aivowelsignbengali = 2504, e.aivowelsigndeva = 2376, e.aivowelsigngujarati = 2760, e.akatakana = 12450, e.akatakanahalfwidth = 65393, e.akorean = 12623, e.alef = 1488, e.alefarabic = 1575, e.alefdageshhebrew = 64304, e.aleffinalarabic = 65166, e.alefhamzaabovearabic = 1571, e.alefhamzaabovefinalarabic = 65156, e.alefhamzabelowarabic = 1573, e.alefhamzabelowfinalarabic = 65160, e.alefhebrew = 1488, e.aleflamedhebrew = 64335, e.alefmaddaabovearabic = 1570, e.alefmaddaabovefinalarabic = 65154, e.alefmaksuraarabic = 1609, e.alefmaksurafinalarabic = 65264, e.alefmaksurainitialarabic = 65267, e.alefmaksuramedialarabic = 65268, e.alefpatahhebrew = 64302, e.alefqamatshebrew = 64303, e.aleph = 8501, e.allequal = 8780, e.alpha = 945, e.alphatonos = 940, e.amacron = 257, e.amonospace = 65345, e.ampersand = 38, e.ampersandmonospace = 65286, e.ampersandsmall = 63270, e.amsquare = 13250, e.anbopomofo = 12578, e.angbopomofo = 12580, e.angbracketleft = 12296, e.angbracketright = 12297, e.angkhankhuthai = 3674, e.angle = 8736, e.anglebracketleft = 12296, e.anglebracketleftvertical = 65087, e.anglebracketright = 12297, e.anglebracketrightvertical = 65088, e.angleleft = 9001, e.angleright = 9002, e.angstrom = 8491, e.anoteleia = 903, e.anudattadeva = 2386, e.anusvarabengali = 2434, e.anusvaradeva = 2306, e.anusvaragujarati = 2690, e.aogonek = 261, e.apaatosquare = 13056, e.aparen = 9372, e.apostrophearmenian = 1370, e.apostrophemod = 700, e.apple = 63743, e.approaches = 8784, e.approxequal = 8776, e.approxequalorimage = 8786, e.approximatelyequal = 8773, e.araeaekorean = 12686, e.araeakorean = 12685, e.arc = 8978, e.arighthalfring = 7834, e.aring = 229, e.aringacute = 507, e.aringbelow = 7681, e.arrowboth = 8596, e.arrowdashdown = 8675, e.arrowdashleft = 8672, e.arrowdashright = 8674, e.arrowdashup = 8673, e.arrowdblboth = 8660, e.arrowdbldown = 8659, e.arrowdblleft = 8656, e.arrowdblright = 8658, e.arrowdblup = 8657, e.arrowdown = 8595, e.arrowdownleft = 8601, e.arrowdownright = 8600, e.arrowdownwhite = 8681, e.arrowheaddownmod = 709, e.arrowheadleftmod = 706, e.arrowheadrightmod = 707, e.arrowheadupmod = 708, e.arrowhorizex = 63719, e.arrowleft = 8592, e.arrowleftdbl = 8656, e.arrowleftdblstroke = 8653, e.arrowleftoverright = 8646, e.arrowleftwhite = 8678, e.arrowright = 8594, e.arrowrightdblstroke = 8655, e.arrowrightheavy = 10142, e.arrowrightoverleft = 8644, e.arrowrightwhite = 8680, e.arrowtableft = 8676, e.arrowtabright = 8677, e.arrowup = 8593, e.arrowupdn = 8597, e.arrowupdnbse = 8616, e.arrowupdownbase = 8616, e.arrowupleft = 8598, e.arrowupleftofdown = 8645, e.arrowupright = 8599, e.arrowupwhite = 8679, e.arrowvertex = 63718, e.asciicircum = 94, e.asciicircummonospace = 65342, e.asciitilde = 126, e.asciitildemonospace = 65374, e.ascript = 593, e.ascriptturned = 594, e.asmallhiragana = 12353, e.asmallkatakana = 12449, e.asmallkatakanahalfwidth = 65383, e.asterisk = 42, e.asteriskaltonearabic = 1645, e.asteriskarabic = 1645, e.asteriskmath = 8727, e.asteriskmonospace = 65290, e.asterisksmall = 65121, e.asterism = 8258, e.asuperior = 63209, e.asymptoticallyequal = 8771, e.at = 64, e.atilde = 227, e.atmonospace = 65312, e.atsmall = 65131, e.aturned = 592, e.aubengali = 2452, e.aubopomofo = 12576, e.audeva = 2324, e.augujarati = 2708, e.augurmukhi = 2580, e.aulengthmarkbengali = 2519, e.aumatragurmukhi = 2636, e.auvowelsignbengali = 2508, e.auvowelsigndeva = 2380, e.auvowelsigngujarati = 2764, e.avagrahadeva = 2365, e.aybarmenian = 1377, e.ayin = 1506, e.ayinaltonehebrew = 64288, e.ayinhebrew = 1506, e.b = 98, e.babengali = 2476, e.backslash = 92, e.backslashmonospace = 65340, e.badeva = 2348, e.bagujarati = 2732;
              e.bagurmukhi = 2604, e.bahiragana = 12400, e.bahtthai = 3647, e.bakatakana = 12496, e.bar = 124, e.barmonospace = 65372, e.bbopomofo = 12549, e.bcircle = 9425, e.bdotaccent = 7683, e.bdotbelow = 7685, e.beamedsixteenthnotes = 9836, e.because = 8757, e.becyrillic = 1073, e.beharabic = 1576, e.behfinalarabic = 65168, e.behinitialarabic = 65169, e.behiragana = 12409, e.behmedialarabic = 65170, e.behmeeminitialarabic = 64671, e.behmeemisolatedarabic = 64520, e.behnoonfinalarabic = 64621, e.bekatakana = 12505, e.benarmenian = 1378, e.bet = 1489, e.beta = 946, e.betasymbolgreek = 976, e.betdagesh = 64305, e.betdageshhebrew = 64305, e.bethebrew = 1489, e.betrafehebrew = 64332, e.bhabengali = 2477, e.bhadeva = 2349, e.bhagujarati = 2733, e.bhagurmukhi = 2605, e.bhook = 595, e.bihiragana = 12403, e.bikatakana = 12499, e.bilabialclick = 664, e.bindigurmukhi = 2562, e.birusquare = 13105, e.blackcircle = 9679, e.blackdiamond = 9670, e.blackdownpointingtriangle = 9660, e.blackleftpointingpointer = 9668, e.blackleftpointingtriangle = 9664, e.blacklenticularbracketleft = 12304, e.blacklenticularbracketleftvertical = 65083, e.blacklenticularbracketright = 12305, e.blacklenticularbracketrightvertical = 65084, e.blacklowerlefttriangle = 9699, e.blacklowerrighttriangle = 9698, e.blackrectangle = 9644, e.blackrightpointingpointer = 9658, e.blackrightpointingtriangle = 9654, e.blacksmallsquare = 9642, e.blacksmilingface = 9787, e.blacksquare = 9632, e.blackstar = 9733, e.blackupperlefttriangle = 9700, e.blackupperrighttriangle = 9701, e.blackuppointingsmalltriangle = 9652, e.blackuppointingtriangle = 9650, e.blank = 9251, e.blinebelow = 7687, e.block = 9608, e.bmonospace = 65346, e.bobaimaithai = 3610, e.bohiragana = 12412, e.bokatakana = 12508, e.bparen = 9373, e.bqsquare = 13251, e.braceex = 63732, e.braceleft = 123, e.braceleftbt = 63731, e.braceleftmid = 63730, e.braceleftmonospace = 65371, e.braceleftsmall = 65115, e.bracelefttp = 63729, e.braceleftvertical = 65079, e.braceright = 125, e.bracerightbt = 63742, e.bracerightmid = 63741, e.bracerightmonospace = 65373, e.bracerightsmall = 65116, e.bracerighttp = 63740, e.bracerightvertical = 65080, e.bracketleft = 91, e.bracketleftbt = 63728, e.bracketleftex = 63727, e.bracketleftmonospace = 65339, e.bracketlefttp = 63726, e.bracketright = 93, e.bracketrightbt = 63739, e.bracketrightex = 63738, e.bracketrightmonospace = 65341, e.bracketrighttp = 63737, e.breve = 728, e.brevebelowcmb = 814, e.brevecmb = 774, e.breveinvertedbelowcmb = 815, e.breveinvertedcmb = 785, e.breveinverteddoublecmb = 865, e.bridgebelowcmb = 810, e.bridgeinvertedbelowcmb = 826, e.brokenbar = 166, e.bstroke = 384, e.bsuperior = 63210, e.btopbar = 387, e.buhiragana = 12406, e.bukatakana = 12502, e.bullet = 8226, e.bulletinverse = 9688, e.bulletoperator = 8729, e.bullseye = 9678, e.c = 99, e.caarmenian = 1390, e.cabengali = 2458, e.cacute = 263, e.cadeva = 2330, e.cagujarati = 2714, e.cagurmukhi = 2586, e.calsquare = 13192, e.candrabindubengali = 2433, e.candrabinducmb = 784, e.candrabindudeva = 2305, e.candrabindugujarati = 2689, e.capslock = 8682, e.careof = 8453, e.caron = 711, e.caronbelowcmb = 812, e.caroncmb = 780, e.carriagereturn = 8629, e.cbopomofo = 12568, e.ccaron = 269, e.ccedilla = 231, e.ccedillaacute = 7689, e.ccircle = 9426, e.ccircumflex = 265, e.ccurl = 597, e.cdot = 267, e.cdotaccent = 267, e.cdsquare = 13253, e.cedilla = 184, e.cedillacmb = 807, e.cent = 162, e.centigrade = 8451, e.centinferior = 63199, e.centmonospace = 65504, e.centoldstyle = 63394, e.centsuperior = 63200, e.chaarmenian = 1401, e.chabengali = 2459, e.chadeva = 2331, e.chagujarati = 2715, e.chagurmukhi = 2587, e.chbopomofo = 12564, e.cheabkhasiancyrillic = 1213, e.checkmark = 10003, e.checyrillic = 1095, e.chedescenderabkhasiancyrillic = 1215, e.chedescendercyrillic = 1207, e.chedieresiscyrillic = 1269, e.cheharmenian = 1395, e.chekhakassiancyrillic = 1228, e.cheverticalstrokecyrillic = 1209, e.chi = 967, e.chieuchacirclekorean = 12919, e.chieuchaparenkorean = 12823, e.chieuchcirclekorean = 12905, e.chieuchkorean = 12618, e.chieuchparenkorean = 12809, e.chochangthai = 3594, e.chochanthai = 3592, e.chochingthai = 3593, e.chochoethai = 3596, e.chook = 392, e.cieucacirclekorean = 12918, e.cieucaparenkorean = 12822, e.cieuccirclekorean = 12904, e.cieuckorean = 12616, e.cieucparenkorean = 12808, e.cieucuparenkorean = 12828, e.circle = 9675, e.circlecopyrt = 169, e.circlemultiply = 8855, e.circleot = 8857, e.circleplus = 8853, e.circlepostalmark = 12342, e.circlewithlefthalfblack = 9680, e.circlewithrighthalfblack = 9681, e.circumflex = 710, e.circumflexbelowcmb = 813, e.circumflexcmb = 770, e.clear = 8999, e.clickalveolar = 450, e.clickdental = 448, e.clicklateral = 449, e.clickretroflex = 451, e.club = 9827, e.clubsuitblack = 9827;
              e.clubsuitwhite = 9831, e.cmcubedsquare = 13220, e.cmonospace = 65347, e.cmsquaredsquare = 13216, e.coarmenian = 1409, e.colon = 58, e.colonmonetary = 8353, e.colonmonospace = 65306, e.colonsign = 8353, e.colonsmall = 65109, e.colontriangularhalfmod = 721, e.colontriangularmod = 720, e.comma = 44, e.commaabovecmb = 787, e.commaaboverightcmb = 789, e.commaaccent = 63171, e.commaarabic = 1548, e.commaarmenian = 1373, e.commainferior = 63201, e.commamonospace = 65292, e.commareversedabovecmb = 788, e.commareversedmod = 701, e.commasmall = 65104, e.commasuperior = 63202, e.commaturnedabovecmb = 786, e.commaturnedmod = 699, e.compass = 9788, e.congruent = 8773, e.contourintegral = 8750, e.control = 8963, e.controlACK = 6, e.controlBEL = 7, e.controlBS = 8, e.controlCAN = 24, e.controlCR = 13, e.controlDC1 = 17, e.controlDC2 = 18, e.controlDC3 = 19, e.controlDC4 = 20, e.controlDEL = 127, e.controlDLE = 16, e.controlEM = 25, e.controlENQ = 5, e.controlEOT = 4, e.controlESC = 27, e.controlETB = 23, e.controlETX = 3, e.controlFF = 12, e.controlFS = 28, e.controlGS = 29, e.controlHT = 9, e.controlLF = 10, e.controlNAK = 21, e.controlNULL = 0, e.controlRS = 30, e.controlSI = 15, e.controlSO = 14, e.controlSOT = 2, e.controlSTX = 1, e.controlSUB = 26, e.controlSYN = 22, e.controlUS = 31, e.controlVT = 11, e.copyright = 169, e.copyrightsans = 63721, e.copyrightserif = 63193, e.cornerbracketleft = 12300, e.cornerbracketlefthalfwidth = 65378, e.cornerbracketleftvertical = 65089, e.cornerbracketright = 12301, e.cornerbracketrighthalfwidth = 65379, e.cornerbracketrightvertical = 65090, e.corporationsquare = 13183, e.cosquare = 13255, e.coverkgsquare = 13254, e.cparen = 9374, e.cruzeiro = 8354, e.cstretched = 663, e.curlyand = 8911, e.curlyor = 8910, e.currency = 164, e.cyrBreve = 63185, e.cyrFlex = 63186, e.cyrbreve = 63188, e.cyrflex = 63189, e.d = 100, e.daarmenian = 1380, e.dabengali = 2470, e.dadarabic = 1590, e.dadeva = 2342, e.dadfinalarabic = 65214, e.dadinitialarabic = 65215, e.dadmedialarabic = 65216, e.dagesh = 1468, e.dageshhebrew = 1468, e.dagger = 8224, e.daggerdbl = 8225, e.dagujarati = 2726, e.dagurmukhi = 2598, e.dahiragana = 12384, e.dakatakana = 12480, e.dalarabic = 1583, e.dalet = 1491, e.daletdagesh = 64307, e.daletdageshhebrew = 64307, e.dalethebrew = 1491, e.dalfinalarabic = 65194, e.dammaarabic = 1615, e.dammalowarabic = 1615, e.dammatanaltonearabic = 1612, e.dammatanarabic = 1612, e.danda = 2404, e.dargahebrew = 1447, e.dargalefthebrew = 1447, e.dasiapneumatacyrilliccmb = 1157, e.dblGrave = 63187, e.dblanglebracketleft = 12298, e.dblanglebracketleftvertical = 65085, e.dblanglebracketright = 12299, e.dblanglebracketrightvertical = 65086, e.dblarchinvertedbelowcmb = 811, e.dblarrowleft = 8660, e.dblarrowright = 8658, e.dbldanda = 2405, e.dblgrave = 63190, e.dblgravecmb = 783, e.dblintegral = 8748, e.dbllowline = 8215, e.dbllowlinecmb = 819, e.dbloverlinecmb = 831, e.dblprimemod = 698, e.dblverticalbar = 8214, e.dblverticallineabovecmb = 782, e.dbopomofo = 12553, e.dbsquare = 13256, e.dcaron = 271, e.dcedilla = 7697, e.dcircle = 9427, e.dcircumflexbelow = 7699, e.dcroat = 273, e.ddabengali = 2465, e.ddadeva = 2337, e.ddagujarati = 2721, e.ddagurmukhi = 2593, e.ddalarabic = 1672, e.ddalfinalarabic = 64393, e.dddhadeva = 2396, e.ddhabengali = 2466, e.ddhadeva = 2338, e.ddhagujarati = 2722, e.ddhagurmukhi = 2594, e.ddotaccent = 7691, e.ddotbelow = 7693, e.decimalseparatorarabic = 1643, e.decimalseparatorpersian = 1643, e.decyrillic = 1076, e.degree = 176, e.dehihebrew = 1453, e.dehiragana = 12391, e.deicoptic = 1007, e.dekatakana = 12487, e.deleteleft = 9003, e.deleteright = 8998, e.delta = 948, e.deltaturned = 397, e.denominatorminusonenumeratorbengali = 2552, e.dezh = 676, e.dhabengali = 2471, e.dhadeva = 2343, e.dhagujarati = 2727, e.dhagurmukhi = 2599, e.dhook = 599, e.dialytikatonos = 901, e.dialytikatonoscmb = 836, e.diamond = 9830, e.diamondsuitwhite = 9826, e.dieresis = 168, e.dieresisacute = 63191, e.dieresisbelowcmb = 804, e.dieresiscmb = 776, e.dieresisgrave = 63192, e.dieresistonos = 901, e.dihiragana = 12386, e.dikatakana = 12482, e.dittomark = 12291, e.divide = 247, e.divides = 8739, e.divisionslash = 8725, e.djecyrillic = 1106, e.dkshade = 9619, e.dlinebelow = 7695, e.dlsquare = 13207, e.dmacron = 273, e.dmonospace = 65348, e.dnblock = 9604, e.dochadathai = 3598, e.dodekthai = 3604, e.dohiragana = 12393, e.dokatakana = 12489, e.dollar = 36;
              e.dollarinferior = 63203, e.dollarmonospace = 65284, e.dollaroldstyle = 63268, e.dollarsmall = 65129, e.dollarsuperior = 63204, e.dong = 8363, e.dorusquare = 13094, e.dotaccent = 729, e.dotaccentcmb = 775, e.dotbelowcmb = 803, e.dotbelowcomb = 803, e.dotkatakana = 12539, e.dotlessi = 305, e.dotlessj = 63166, e.dotlessjstrokehook = 644, e.dotmath = 8901, e.dottedcircle = 9676, e.doubleyodpatah = 64287, e.doubleyodpatahhebrew = 64287, e.downtackbelowcmb = 798, e.downtackmod = 725, e.dparen = 9375, e.dsuperior = 63211, e.dtail = 598, e.dtopbar = 396, e.duhiragana = 12389, e.dukatakana = 12485, e.dz = 499, e.dzaltone = 675, e.dzcaron = 454, e.dzcurl = 677, e.dzeabkhasiancyrillic = 1249, e.dzecyrillic = 1109, e.dzhecyrillic = 1119, e.e = 101, e.eacute = 233, e.earth = 9793, e.ebengali = 2447, e.ebopomofo = 12572, e.ebreve = 277, e.ecandradeva = 2317, e.ecandragujarati = 2701, e.ecandravowelsigndeva = 2373, e.ecandravowelsigngujarati = 2757, e.ecaron = 283, e.ecedillabreve = 7709, e.echarmenian = 1381, e.echyiwnarmenian = 1415, e.ecircle = 9428, e.ecircumflex = 234, e.ecircumflexacute = 7871, e.ecircumflexbelow = 7705, e.ecircumflexdotbelow = 7879, e.ecircumflexgrave = 7873, e.ecircumflexhookabove = 7875, e.ecircumflextilde = 7877, e.ecyrillic = 1108, e.edblgrave = 517, e.edeva = 2319, e.edieresis = 235, e.edot = 279, e.edotaccent = 279, e.edotbelow = 7865, e.eegurmukhi = 2575, e.eematragurmukhi = 2631, e.efcyrillic = 1092, e.egrave = 232, e.egujarati = 2703, e.eharmenian = 1383, e.ehbopomofo = 12573, e.ehiragana = 12360, e.ehookabove = 7867, e.eibopomofo = 12575, e.eight = 56, e.eightarabic = 1640, e.eightbengali = 2542, e.eightcircle = 9319, e.eightcircleinversesansserif = 10129, e.eightdeva = 2414, e.eighteencircle = 9329, e.eighteenparen = 9349, e.eighteenperiod = 9369, e.eightgujarati = 2798, e.eightgurmukhi = 2670, e.eighthackarabic = 1640, e.eighthangzhou = 12328, e.eighthnotebeamed = 9835, e.eightideographicparen = 12839, e.eightinferior = 8328, e.eightmonospace = 65304, e.eightoldstyle = 63288, e.eightparen = 9339, e.eightperiod = 9359, e.eightpersian = 1784, e.eightroman = 8567, e.eightsuperior = 8312, e.eightthai = 3672, e.einvertedbreve = 519, e.eiotifiedcyrillic = 1125, e.ekatakana = 12456, e.ekatakanahalfwidth = 65396, e.ekonkargurmukhi = 2676, e.ekorean = 12628, e.elcyrillic = 1083, e.element = 8712, e.elevencircle = 9322, e.elevenparen = 9342, e.elevenperiod = 9362, e.elevenroman = 8570, e.ellipsis = 8230, e.ellipsisvertical = 8942, e.emacron = 275, e.emacronacute = 7703, e.emacrongrave = 7701, e.emcyrillic = 1084, e.emdash = 8212, e.emdashvertical = 65073, e.emonospace = 65349, e.emphasismarkarmenian = 1371, e.emptyset = 8709, e.enbopomofo = 12579, e.encyrillic = 1085, e.endash = 8211, e.endashvertical = 65074, e.endescendercyrillic = 1187, e.eng = 331, e.engbopomofo = 12581, e.enghecyrillic = 1189, e.enhookcyrillic = 1224, e.enspace = 8194, e.eogonek = 281, e.eokorean = 12627, e.eopen = 603, e.eopenclosed = 666, e.eopenreversed = 604, e.eopenreversedclosed = 606, e.eopenreversedhook = 605, e.eparen = 9376, e.epsilon = 949, e.epsilontonos = 941, e.equal = 61, e.equalmonospace = 65309, e.equalsmall = 65126, e.equalsuperior = 8316, e.equivalence = 8801, e.erbopomofo = 12582, e.ercyrillic = 1088, e.ereversed = 600, e.ereversedcyrillic = 1101, e.escyrillic = 1089, e.esdescendercyrillic = 1195, e.esh = 643, e.eshcurl = 646, e.eshortdeva = 2318, e.eshortvowelsigndeva = 2374, e.eshreversedloop = 426, e.eshsquatreversed = 645, e.esmallhiragana = 12359, e.esmallkatakana = 12455, e.esmallkatakanahalfwidth = 65386, e.estimated = 8494, e.esuperior = 63212, e.eta = 951, e.etarmenian = 1384, e.etatonos = 942, e.eth = 240, e.etilde = 7869, e.etildebelow = 7707, e.etnahtafoukhhebrew = 1425, e.etnahtafoukhlefthebrew = 1425, e.etnahtahebrew = 1425, e.etnahtalefthebrew = 1425, e.eturned = 477, e.eukorean = 12641, e.euro = 8364, e.evowelsignbengali = 2503, e.evowelsigndeva = 2375, e.evowelsigngujarati = 2759, e.exclam = 33, e.exclamarmenian = 1372, e.exclamdbl = 8252, e.exclamdown = 161, e.exclamdownsmall = 63393, e.exclammonospace = 65281, e.exclamsmall = 63265, e.existential = 8707, e.ezh = 658, e.ezhcaron = 495, e.ezhcurl = 659, e.ezhreversed = 441, e.ezhtail = 442, e.f = 102, e.fadeva = 2398, e.fagurmukhi = 2654, e.fahrenheit = 8457, e.fathaarabic = 1614, e.fathalowarabic = 1614, e.fathatanarabic = 1611, e.fbopomofo = 12552, e.fcircle = 9429;
              e.fdotaccent = 7711, e.feharabic = 1601, e.feharmenian = 1414, e.fehfinalarabic = 65234, e.fehinitialarabic = 65235, e.fehmedialarabic = 65236, e.feicoptic = 997, e.female = 9792, e.ff = 64256, e.ffi = 64259, e.ffl = 64260, e.fi = 64257, e.fifteencircle = 9326, e.fifteenparen = 9346, e.fifteenperiod = 9366, e.figuredash = 8210, e.filledbox = 9632, e.filledrect = 9644, e.finalkaf = 1498, e.finalkafdagesh = 64314, e.finalkafdageshhebrew = 64314, e.finalkafhebrew = 1498, e.finalmem = 1501, e.finalmemhebrew = 1501, e.finalnun = 1503, e.finalnunhebrew = 1503, e.finalpe = 1507, e.finalpehebrew = 1507, e.finaltsadi = 1509, e.finaltsadihebrew = 1509, e.firsttonechinese = 713, e.fisheye = 9673, e.fitacyrillic = 1139, e.five = 53, e.fivearabic = 1637, e.fivebengali = 2539, e.fivecircle = 9316, e.fivecircleinversesansserif = 10126, e.fivedeva = 2411, e.fiveeighths = 8541, e.fivegujarati = 2795, e.fivegurmukhi = 2667, e.fivehackarabic = 1637, e.fivehangzhou = 12325, e.fiveideographicparen = 12836, e.fiveinferior = 8325, e.fivemonospace = 65301, e.fiveoldstyle = 63285, e.fiveparen = 9336, e.fiveperiod = 9356, e.fivepersian = 1781, e.fiveroman = 8564, e.fivesuperior = 8309, e.fivethai = 3669, e.fl = 64258, e.florin = 402, e.fmonospace = 65350, e.fmsquare = 13209, e.fofanthai = 3615, e.fofathai = 3613, e.fongmanthai = 3663, e.forall = 8704, e.four = 52, e.fourarabic = 1636, e.fourbengali = 2538, e.fourcircle = 9315, e.fourcircleinversesansserif = 10125, e.fourdeva = 2410, e.fourgujarati = 2794, e.fourgurmukhi = 2666, e.fourhackarabic = 1636, e.fourhangzhou = 12324, e.fourideographicparen = 12835, e.fourinferior = 8324, e.fourmonospace = 65300, e.fournumeratorbengali = 2551, e.fouroldstyle = 63284, e.fourparen = 9335, e.fourperiod = 9355, e.fourpersian = 1780, e.fourroman = 8563, e.foursuperior = 8308, e.fourteencircle = 9325, e.fourteenparen = 9345, e.fourteenperiod = 9365, e.fourthai = 3668, e.fourthtonechinese = 715, e.fparen = 9377, e.fraction = 8260, e.franc = 8355, e.g = 103, e.gabengali = 2455, e.gacute = 501, e.gadeva = 2327, e.gafarabic = 1711, e.gaffinalarabic = 64403, e.gafinitialarabic = 64404, e.gafmedialarabic = 64405, e.gagujarati = 2711, e.gagurmukhi = 2583, e.gahiragana = 12364, e.gakatakana = 12460, e.gamma = 947, e.gammalatinsmall = 611, e.gammasuperior = 736, e.gangiacoptic = 1003, e.gbopomofo = 12557, e.gbreve = 287, e.gcaron = 487, e.gcedilla = 291, e.gcircle = 9430, e.gcircumflex = 285, e.gcommaaccent = 291, e.gdot = 289, e.gdotaccent = 289, e.gecyrillic = 1075, e.gehiragana = 12370, e.gekatakana = 12466, e.geometricallyequal = 8785, e.gereshaccenthebrew = 1436, e.gereshhebrew = 1523, e.gereshmuqdamhebrew = 1437, e.germandbls = 223, e.gershayimaccenthebrew = 1438, e.gershayimhebrew = 1524, e.getamark = 12307, e.ghabengali = 2456, e.ghadarmenian = 1394, e.ghadeva = 2328, e.ghagujarati = 2712, e.ghagurmukhi = 2584, e.ghainarabic = 1594, e.ghainfinalarabic = 65230, e.ghaininitialarabic = 65231, e.ghainmedialarabic = 65232, e.ghemiddlehookcyrillic = 1173, e.ghestrokecyrillic = 1171, e.gheupturncyrillic = 1169, e.ghhadeva = 2394, e.ghhagurmukhi = 2650, e.ghook = 608, e.ghzsquare = 13203, e.gihiragana = 12366, e.gikatakana = 12462, e.gimarmenian = 1379, e.gimel = 1490, e.gimeldagesh = 64306, e.gimeldageshhebrew = 64306, e.gimelhebrew = 1490, e.gjecyrillic = 1107, e.glottalinvertedstroke = 446, e.glottalstop = 660, e.glottalstopinverted = 662, e.glottalstopmod = 704, e.glottalstopreversed = 661, e.glottalstopreversedmod = 705, e.glottalstopreversedsuperior = 740, e.glottalstopstroke = 673, e.glottalstopstrokereversed = 674, e.gmacron = 7713, e.gmonospace = 65351, e.gohiragana = 12372, e.gokatakana = 12468, e.gparen = 9378, e.gpasquare = 13228, e.gradient = 8711, e.grave = 96, e.gravebelowcmb = 790, e.gravecmb = 768, e.gravecomb = 768, e.gravedeva = 2387, e.gravelowmod = 718, e.gravemonospace = 65344, e.gravetonecmb = 832, e.greater = 62, e.greaterequal = 8805, e.greaterequalorless = 8923, e.greatermonospace = 65310, e.greaterorequivalent = 8819, e.greaterorless = 8823, e.greateroverequal = 8807, e.greatersmall = 65125, e.gscript = 609, e.gstroke = 485, e.guhiragana = 12368, e.guillemotleft = 171, e.guillemotright = 187, e.guilsinglleft = 8249, e.guilsinglright = 8250, e.gukatakana = 12464, e.guramusquare = 13080, e.gysquare = 13257, e.h = 104, e.haabkhasiancyrillic = 1193, e.haaltonearabic = 1729, e.habengali = 2489, e.hadescendercyrillic = 1203, e.hadeva = 2361, e.hagujarati = 2745, e.hagurmukhi = 2617;
              e.haharabic = 1581, e.hahfinalarabic = 65186, e.hahinitialarabic = 65187, e.hahiragana = 12399, e.hahmedialarabic = 65188, e.haitusquare = 13098, e.hakatakana = 12495, e.hakatakanahalfwidth = 65418, e.halantgurmukhi = 2637, e.hamzaarabic = 1569, e.hamzalowarabic = 1569, e.hangulfiller = 12644, e.hardsigncyrillic = 1098, e.harpoonleftbarbup = 8636, e.harpoonrightbarbup = 8640, e.hasquare = 13258, e.hatafpatah = 1458, e.hatafpatah16 = 1458, e.hatafpatah23 = 1458, e.hatafpatah2f = 1458, e.hatafpatahhebrew = 1458, e.hatafpatahnarrowhebrew = 1458, e.hatafpatahquarterhebrew = 1458, e.hatafpatahwidehebrew = 1458, e.hatafqamats = 1459, e.hatafqamats1b = 1459, e.hatafqamats28 = 1459, e.hatafqamats34 = 1459, e.hatafqamatshebrew = 1459, e.hatafqamatsnarrowhebrew = 1459, e.hatafqamatsquarterhebrew = 1459, e.hatafqamatswidehebrew = 1459, e.hatafsegol = 1457, e.hatafsegol17 = 1457, e.hatafsegol24 = 1457, e.hatafsegol30 = 1457, e.hatafsegolhebrew = 1457, e.hatafsegolnarrowhebrew = 1457, e.hatafsegolquarterhebrew = 1457, e.hatafsegolwidehebrew = 1457, e.hbar = 295, e.hbopomofo = 12559, e.hbrevebelow = 7723, e.hcedilla = 7721, e.hcircle = 9431, e.hcircumflex = 293, e.hdieresis = 7719, e.hdotaccent = 7715, e.hdotbelow = 7717, e.he = 1492, e.heart = 9829, e.heartsuitblack = 9829, e.heartsuitwhite = 9825, e.hedagesh = 64308, e.hedageshhebrew = 64308, e.hehaltonearabic = 1729, e.heharabic = 1607, e.hehebrew = 1492, e.hehfinalaltonearabic = 64423, e.hehfinalalttwoarabic = 65258, e.hehfinalarabic = 65258, e.hehhamzaabovefinalarabic = 64421, e.hehhamzaaboveisolatedarabic = 64420, e.hehinitialaltonearabic = 64424, e.hehinitialarabic = 65259, e.hehiragana = 12408, e.hehmedialaltonearabic = 64425, e.hehmedialarabic = 65260, e.heiseierasquare = 13179, e.hekatakana = 12504, e.hekatakanahalfwidth = 65421, e.hekutaarusquare = 13110, e.henghook = 615, e.herutusquare = 13113, e.het = 1495, e.hethebrew = 1495, e.hhook = 614, e.hhooksuperior = 689, e.hieuhacirclekorean = 12923, e.hieuhaparenkorean = 12827, e.hieuhcirclekorean = 12909, e.hieuhkorean = 12622, e.hieuhparenkorean = 12813, e.hihiragana = 12402, e.hikatakana = 12498, e.hikatakanahalfwidth = 65419, e.hiriq = 1460, e.hiriq14 = 1460, e.hiriq21 = 1460, e.hiriq2d = 1460, e.hiriqhebrew = 1460, e.hiriqnarrowhebrew = 1460, e.hiriqquarterhebrew = 1460, e.hiriqwidehebrew = 1460, e.hlinebelow = 7830, e.hmonospace = 65352, e.hoarmenian = 1392, e.hohipthai = 3627, e.hohiragana = 12411, e.hokatakana = 12507, e.hokatakanahalfwidth = 65422, e.holam = 1465, e.holam19 = 1465, e.holam26 = 1465, e.holam32 = 1465, e.holamhebrew = 1465, e.holamnarrowhebrew = 1465, e.holamquarterhebrew = 1465, e.holamwidehebrew = 1465, e.honokhukthai = 3630, e.hookabovecomb = 777, e.hookcmb = 777, e.hookpalatalizedbelowcmb = 801, e.hookretroflexbelowcmb = 802, e.hoonsquare = 13122, e.horicoptic = 1001, e.horizontalbar = 8213, e.horncmb = 795, e.hotsprings = 9832, e.house = 8962, e.hparen = 9379, e.hsuperior = 688, e.hturned = 613, e.huhiragana = 12405, e.huiitosquare = 13107, e.hukatakana = 12501, e.hukatakanahalfwidth = 65420, e.hungarumlaut = 733, e.hungarumlautcmb = 779, e.hv = 405, e.hyphen = 45, e.hypheninferior = 63205, e.hyphenmonospace = 65293, e.hyphensmall = 65123, e.hyphensuperior = 63206, e.hyphentwo = 8208, e.i = 105, e.iacute = 237, e.iacyrillic = 1103, e.ibengali = 2439, e.ibopomofo = 12583, e.ibreve = 301, e.icaron = 464, e.icircle = 9432, e.icircumflex = 238, e.icyrillic = 1110, e.idblgrave = 521, e.ideographearthcircle = 12943, e.ideographfirecircle = 12939, e.ideographicallianceparen = 12863, e.ideographiccallparen = 12858, e.ideographiccentrecircle = 12965, e.ideographicclose = 12294, e.ideographiccomma = 12289, e.ideographiccommaleft = 65380, e.ideographiccongratulationparen = 12855, e.ideographiccorrectcircle = 12963, e.ideographicearthparen = 12847, e.ideographicenterpriseparen = 12861, e.ideographicexcellentcircle = 12957, e.ideographicfestivalparen = 12864, e.ideographicfinancialcircle = 12950, e.ideographicfinancialparen = 12854, e.ideographicfireparen = 12843, e.ideographichaveparen = 12850, e.ideographichighcircle = 12964, e.ideographiciterationmark = 12293, e.ideographiclaborcircle = 12952, e.ideographiclaborparen = 12856, e.ideographicleftcircle = 12967, e.ideographiclowcircle = 12966, e.ideographicmedicinecircle = 12969, e.ideographicmetalparen = 12846, e.ideographicmoonparen = 12842, e.ideographicnameparen = 12852, e.ideographicperiod = 12290, e.ideographicprintcircle = 12958, e.ideographicreachparen = 12867, e.ideographicrepresentparen = 12857, e.ideographicresourceparen = 12862, e.ideographicrightcircle = 12968, e.ideographicsecretcircle = 12953, e.ideographicselfparen = 12866, e.ideographicsocietyparen = 12851, e.ideographicspace = 12288, e.ideographicspecialparen = 12853, e.ideographicstockparen = 12849, e.ideographicstudyparen = 12859, e.ideographicsunparen = 12848, e.ideographicsuperviseparen = 12860, e.ideographicwaterparen = 12844, e.ideographicwoodparen = 12845, e.ideographiczero = 12295, e.ideographmetalcircle = 12942, e.ideographmooncircle = 12938, e.ideographnamecircle = 12948, e.ideographsuncircle = 12944, e.ideographwatercircle = 12940, e.ideographwoodcircle = 12941, e.ideva = 2311;
              e.idieresis = 239, e.idieresisacute = 7727, e.idieresiscyrillic = 1253, e.idotbelow = 7883, e.iebrevecyrillic = 1239, e.iecyrillic = 1077, e.ieungacirclekorean = 12917, e.ieungaparenkorean = 12821, e.ieungcirclekorean = 12903, e.ieungkorean = 12615, e.ieungparenkorean = 12807, e.igrave = 236, e.igujarati = 2695, e.igurmukhi = 2567, e.ihiragana = 12356, e.ihookabove = 7881, e.iibengali = 2440, e.iicyrillic = 1080, e.iideva = 2312, e.iigujarati = 2696, e.iigurmukhi = 2568, e.iimatragurmukhi = 2624, e.iinvertedbreve = 523, e.iishortcyrillic = 1081, e.iivowelsignbengali = 2496, e.iivowelsigndeva = 2368, e.iivowelsigngujarati = 2752, e.ij = 307, e.ikatakana = 12452, e.ikatakanahalfwidth = 65394, e.ikorean = 12643, e.ilde = 732, e.iluyhebrew = 1452, e.imacron = 299, e.imacroncyrillic = 1251, e.imageorapproximatelyequal = 8787, e.imatragurmukhi = 2623, e.imonospace = 65353, e.increment = 8710, e.infinity = 8734, e.iniarmenian = 1387, e.integral = 8747, e.integralbottom = 8993, e.integralbt = 8993, e.integralex = 63733, e.integraltop = 8992, e.integraltp = 8992, e.intersection = 8745, e.intisquare = 13061, e.invbullet = 9688, e.invcircle = 9689, e.invsmileface = 9787, e.iocyrillic = 1105, e.iogonek = 303, e.iota = 953, e.iotadieresis = 970, e.iotadieresistonos = 912, e.iotalatin = 617, e.iotatonos = 943, e.iparen = 9380, e.irigurmukhi = 2674, e.ismallhiragana = 12355, e.ismallkatakana = 12451, e.ismallkatakanahalfwidth = 65384, e.issharbengali = 2554, e.istroke = 616, e.isuperior = 63213, e.iterationhiragana = 12445, e.iterationkatakana = 12541, e.itilde = 297, e.itildebelow = 7725, e.iubopomofo = 12585, e.iucyrillic = 1102, e.ivowelsignbengali = 2495, e.ivowelsigndeva = 2367, e.ivowelsigngujarati = 2751, e.izhitsacyrillic = 1141, e.izhitsadblgravecyrillic = 1143, e.j = 106, e.jaarmenian = 1393, e.jabengali = 2460, e.jadeva = 2332, e.jagujarati = 2716, e.jagurmukhi = 2588, e.jbopomofo = 12560, e.jcaron = 496, e.jcircle = 9433, e.jcircumflex = 309, e.jcrossedtail = 669, e.jdotlessstroke = 607, e.jecyrillic = 1112, e.jeemarabic = 1580, e.jeemfinalarabic = 65182, e.jeeminitialarabic = 65183, e.jeemmedialarabic = 65184, e.jeharabic = 1688, e.jehfinalarabic = 64395, e.jhabengali = 2461, e.jhadeva = 2333, e.jhagujarati = 2717, e.jhagurmukhi = 2589, e.jheharmenian = 1403, e.jis = 12292, e.jmonospace = 65354, e.jparen = 9381, e.jsuperior = 690, e.k = 107, e.kabashkircyrillic = 1185, e.kabengali = 2453, e.kacute = 7729, e.kacyrillic = 1082, e.kadescendercyrillic = 1179, e.kadeva = 2325, e.kaf = 1499, e.kafarabic = 1603, e.kafdagesh = 64315, e.kafdageshhebrew = 64315, e.kaffinalarabic = 65242, e.kafhebrew = 1499, e.kafinitialarabic = 65243, e.kafmedialarabic = 65244, e.kafrafehebrew = 64333, e.kagujarati = 2709, e.kagurmukhi = 2581, e.kahiragana = 12363, e.kahookcyrillic = 1220, e.kakatakana = 12459, e.kakatakanahalfwidth = 65398, e.kappa = 954, e.kappasymbolgreek = 1008, e.kapyeounmieumkorean = 12657, e.kapyeounphieuphkorean = 12676, e.kapyeounpieupkorean = 12664, e.kapyeounssangpieupkorean = 12665, e.karoriisquare = 13069, e.kashidaautoarabic = 1600, e.kashidaautonosidebearingarabic = 1600, e.kasmallkatakana = 12533, e.kasquare = 13188, e.kasraarabic = 1616, e.kasratanarabic = 1613, e.kastrokecyrillic = 1183, e.katahiraprolongmarkhalfwidth = 65392, e.kaverticalstrokecyrillic = 1181, e.kbopomofo = 12558, e.kcalsquare = 13193, e.kcaron = 489, e.kcedilla = 311, e.kcircle = 9434, e.kcommaaccent = 311, e.kdotbelow = 7731, e.keharmenian = 1412, e.kehiragana = 12369, e.kekatakana = 12465, e.kekatakanahalfwidth = 65401, e.kenarmenian = 1391, e.kesmallkatakana = 12534, e.kgreenlandic = 312, e.khabengali = 2454, e.khacyrillic = 1093, e.khadeva = 2326, e.khagujarati = 2710, e.khagurmukhi = 2582, e.khaharabic = 1582, e.khahfinalarabic = 65190, e.khahinitialarabic = 65191, e.khahmedialarabic = 65192, e.kheicoptic = 999, e.khhadeva = 2393, e.khhagurmukhi = 2649, e.khieukhacirclekorean = 12920, e.khieukhaparenkorean = 12824, e.khieukhcirclekorean = 12906, e.khieukhkorean = 12619, e.khieukhparenkorean = 12810, e.khokhaithai = 3586, e.khokhonthai = 3589, e.khokhuatthai = 3587, e.khokhwaithai = 3588, e.khomutthai = 3675, e.khook = 409, e.khorakhangthai = 3590, e.khzsquare = 13201, e.kihiragana = 12365, e.kikatakana = 12461, e.kikatakanahalfwidth = 65399, e.kiroguramusquare = 13077, e.kiromeetorusquare = 13078, e.kirosquare = 13076, e.kiyeokacirclekorean = 12910, e.kiyeokaparenkorean = 12814, e.kiyeokcirclekorean = 12896, e.kiyeokkorean = 12593, e.kiyeokparenkorean = 12800, e.kiyeoksioskorean = 12595, e.kjecyrillic = 1116, e.klinebelow = 7733, e.klsquare = 13208, e.kmcubedsquare = 13222, e.kmonospace = 65355;
              e.kmsquaredsquare = 13218, e.kohiragana = 12371, e.kohmsquare = 13248, e.kokaithai = 3585, e.kokatakana = 12467, e.kokatakanahalfwidth = 65402, e.kooposquare = 13086, e.koppacyrillic = 1153, e.koreanstandardsymbol = 12927, e.koroniscmb = 835, e.kparen = 9382, e.kpasquare = 13226, e.ksicyrillic = 1135, e.ktsquare = 13263, e.kturned = 670, e.kuhiragana = 12367, e.kukatakana = 12463, e.kukatakanahalfwidth = 65400, e.kvsquare = 13240, e.kwsquare = 13246, e.l = 108, e.labengali = 2482, e.lacute = 314, e.ladeva = 2354, e.lagujarati = 2738, e.lagurmukhi = 2610, e.lakkhangyaothai = 3653, e.lamaleffinalarabic = 65276, e.lamalefhamzaabovefinalarabic = 65272, e.lamalefhamzaaboveisolatedarabic = 65271, e.lamalefhamzabelowfinalarabic = 65274, e.lamalefhamzabelowisolatedarabic = 65273, e.lamalefisolatedarabic = 65275, e.lamalefmaddaabovefinalarabic = 65270, e.lamalefmaddaaboveisolatedarabic = 65269, e.lamarabic = 1604, e.lambda = 955, e.lambdastroke = 411, e.lamed = 1500, e.lameddagesh = 64316, e.lameddageshhebrew = 64316, e.lamedhebrew = 1500, e.lamfinalarabic = 65246, e.lamhahinitialarabic = 64714, e.laminitialarabic = 65247, e.lamjeeminitialarabic = 64713, e.lamkhahinitialarabic = 64715, e.lamlamhehisolatedarabic = 65010, e.lammedialarabic = 65248, e.lammeemhahinitialarabic = 64904, e.lammeeminitialarabic = 64716, e.largecircle = 9711, e.lbar = 410, e.lbelt = 620, e.lbopomofo = 12556, e.lcaron = 318, e.lcedilla = 316, e.lcircle = 9435, e.lcircumflexbelow = 7741, e.lcommaaccent = 316, e.ldot = 320, e.ldotaccent = 320, e.ldotbelow = 7735, e.ldotbelowmacron = 7737, e.leftangleabovecmb = 794, e.lefttackbelowcmb = 792, e.less = 60, e.lessequal = 8804, e.lessequalorgreater = 8922, e.lessmonospace = 65308, e.lessorequivalent = 8818, e.lessorgreater = 8822, e.lessoverequal = 8806, e.lesssmall = 65124, e.lezh = 622, e.lfblock = 9612, e.lhookretroflex = 621, e.lira = 8356, e.liwnarmenian = 1388, e.lj = 457, e.ljecyrillic = 1113, e.ll = 63168, e.lladeva = 2355, e.llagujarati = 2739, e.llinebelow = 7739, e.llladeva = 2356, e.llvocalicbengali = 2529, e.llvocalicdeva = 2401, e.llvocalicvowelsignbengali = 2531, e.llvocalicvowelsigndeva = 2403, e.lmiddletilde = 619, e.lmonospace = 65356, e.lmsquare = 13264, e.lochulathai = 3628, e.logicaland = 8743, e.logicalnot = 172, e.logicalnotreversed = 8976, e.logicalor = 8744, e.lolingthai = 3621, e.longs = 383, e.lowlinecenterline = 65102, e.lowlinecmb = 818, e.lowlinedashed = 65101, e.lozenge = 9674, e.lparen = 9383, e.lslash = 322, e.lsquare = 8467, e.lsuperior = 63214, e.ltshade = 9617, e.luthai = 3622, e.lvocalicbengali = 2444, e.lvocalicdeva = 2316, e.lvocalicvowelsignbengali = 2530, e.lvocalicvowelsigndeva = 2402, e.lxsquare = 13267, e.m = 109, e.mabengali = 2478, e.macron = 175, e.macronbelowcmb = 817, e.macroncmb = 772, e.macronlowmod = 717, e.macronmonospace = 65507, e.macute = 7743, e.madeva = 2350, e.magujarati = 2734, e.magurmukhi = 2606, e.mahapakhhebrew = 1444, e.mahapakhlefthebrew = 1444, e.mahiragana = 12414, e.maichattawalowleftthai = 63637, e.maichattawalowrightthai = 63636, e.maichattawathai = 3659, e.maichattawaupperleftthai = 63635, e.maieklowleftthai = 63628, e.maieklowrightthai = 63627, e.maiekthai = 3656, e.maiekupperleftthai = 63626, e.maihanakatleftthai = 63620, e.maihanakatthai = 3633, e.maitaikhuleftthai = 63625, e.maitaikhuthai = 3655, e.maitholowleftthai = 63631, e.maitholowrightthai = 63630, e.maithothai = 3657, e.maithoupperleftthai = 63629, e.maitrilowleftthai = 63634, e.maitrilowrightthai = 63633, e.maitrithai = 3658, e.maitriupperleftthai = 63632, e.maiyamokthai = 3654, e.makatakana = 12510, e.makatakanahalfwidth = 65423, e.male = 9794, e.mansyonsquare = 13127, e.maqafhebrew = 1470, e.mars = 9794, e.masoracirclehebrew = 1455, e.masquare = 13187, e.mbopomofo = 12551, e.mbsquare = 13268, e.mcircle = 9436, e.mcubedsquare = 13221, e.mdotaccent = 7745, e.mdotbelow = 7747, e.meemarabic = 1605, e.meemfinalarabic = 65250, e.meeminitialarabic = 65251, e.meemmedialarabic = 65252, e.meemmeeminitialarabic = 64721, e.meemmeemisolatedarabic = 64584, e.meetorusquare = 13133, e.mehiragana = 12417, e.meizierasquare = 13182, e.mekatakana = 12513, e.mekatakanahalfwidth = 65426, e.mem = 1502, e.memdagesh = 64318, e.memdageshhebrew = 64318, e.memhebrew = 1502, e.menarmenian = 1396, e.merkhahebrew = 1445, e.merkhakefulahebrew = 1446, e.merkhakefulalefthebrew = 1446, e.merkhalefthebrew = 1445, e.mhook = 625, e.mhzsquare = 13202, e.middledotkatakanahalfwidth = 65381, e.middot = 183, e.mieumacirclekorean = 12914, e.mieumaparenkorean = 12818, e.mieumcirclekorean = 12900, e.mieumkorean = 12609, e.mieumpansioskorean = 12656, e.mieumparenkorean = 12804, e.mieumpieupkorean = 12654, e.mieumsioskorean = 12655, e.mihiragana = 12415, e.mikatakana = 12511, e.mikatakanahalfwidth = 65424, e.minus = 8722;
              e.minusbelowcmb = 800, e.minuscircle = 8854, e.minusmod = 727, e.minusplus = 8723, e.minute = 8242, e.miribaarusquare = 13130, e.mirisquare = 13129, e.mlonglegturned = 624, e.mlsquare = 13206, e.mmcubedsquare = 13219, e.mmonospace = 65357, e.mmsquaredsquare = 13215, e.mohiragana = 12418, e.mohmsquare = 13249, e.mokatakana = 12514, e.mokatakanahalfwidth = 65427, e.molsquare = 13270, e.momathai = 3617, e.moverssquare = 13223, e.moverssquaredsquare = 13224, e.mparen = 9384, e.mpasquare = 13227, e.mssquare = 13235, e.msuperior = 63215, e.mturned = 623, e.mu = 181, e.mu1 = 181, e.muasquare = 13186, e.muchgreater = 8811, e.muchless = 8810, e.mufsquare = 13196, e.mugreek = 956, e.mugsquare = 13197, e.muhiragana = 12416, e.mukatakana = 12512, e.mukatakanahalfwidth = 65425, e.mulsquare = 13205, e.multiply = 215, e.mumsquare = 13211, e.munahhebrew = 1443, e.munahlefthebrew = 1443, e.musicalnote = 9834, e.musicalnotedbl = 9835, e.musicflatsign = 9837, e.musicsharpsign = 9839, e.mussquare = 13234, e.muvsquare = 13238, e.muwsquare = 13244, e.mvmegasquare = 13241, e.mvsquare = 13239, e.mwmegasquare = 13247, e.mwsquare = 13245, e.n = 110, e.nabengali = 2472, e.nabla = 8711, e.nacute = 324, e.nadeva = 2344, e.nagujarati = 2728, e.nagurmukhi = 2600, e.nahiragana = 12394, e.nakatakana = 12490, e.nakatakanahalfwidth = 65413, e.napostrophe = 329, e.nasquare = 13185, e.nbopomofo = 12555, e.nbspace = 160, e.ncaron = 328, e.ncedilla = 326, e.ncircle = 9437, e.ncircumflexbelow = 7755, e.ncommaaccent = 326, e.ndotaccent = 7749, e.ndotbelow = 7751, e.nehiragana = 12397, e.nekatakana = 12493, e.nekatakanahalfwidth = 65416, e.newsheqelsign = 8362, e.nfsquare = 13195, e.ngabengali = 2457, e.ngadeva = 2329, e.ngagujarati = 2713, e.ngagurmukhi = 2585, e.ngonguthai = 3591, e.nhiragana = 12435, e.nhookleft = 626, e.nhookretroflex = 627, e.nieunacirclekorean = 12911, e.nieunaparenkorean = 12815, e.nieuncieuckorean = 12597, e.nieuncirclekorean = 12897, e.nieunhieuhkorean = 12598, e.nieunkorean = 12596, e.nieunpansioskorean = 12648, e.nieunparenkorean = 12801, e.nieunsioskorean = 12647, e.nieuntikeutkorean = 12646, e.nihiragana = 12395, e.nikatakana = 12491, e.nikatakanahalfwidth = 65414, e.nikhahitleftthai = 63641, e.nikhahitthai = 3661, e.nine = 57, e.ninearabic = 1641, e.ninebengali = 2543, e.ninecircle = 9320, e.ninecircleinversesansserif = 10130, e.ninedeva = 2415, e.ninegujarati = 2799, e.ninegurmukhi = 2671, e.ninehackarabic = 1641, e.ninehangzhou = 12329, e.nineideographicparen = 12840, e.nineinferior = 8329, e.ninemonospace = 65305, e.nineoldstyle = 63289, e.nineparen = 9340, e.nineperiod = 9360, e.ninepersian = 1785, e.nineroman = 8568, e.ninesuperior = 8313, e.nineteencircle = 9330, e.nineteenparen = 9350, e.nineteenperiod = 9370, e.ninethai = 3673, e.nj = 460, e.njecyrillic = 1114, e.nkatakana = 12531, e.nkatakanahalfwidth = 65437, e.nlegrightlong = 414, e.nlinebelow = 7753, e.nmonospace = 65358, e.nmsquare = 13210, e.nnabengali = 2467, e.nnadeva = 2339, e.nnagujarati = 2723, e.nnagurmukhi = 2595, e.nnnadeva = 2345, e.nohiragana = 12398, e.nokatakana = 12494, e.nokatakanahalfwidth = 65417, e.nonbreakingspace = 160, e.nonenthai = 3603, e.nonuthai = 3609, e.noonarabic = 1606, e.noonfinalarabic = 65254, e.noonghunnaarabic = 1722, e.noonghunnafinalarabic = 64415, e.nooninitialarabic = 65255, e.noonjeeminitialarabic = 64722, e.noonjeemisolatedarabic = 64587, e.noonmedialarabic = 65256, e.noonmeeminitialarabic = 64725, e.noonmeemisolatedarabic = 64590, e.noonnoonfinalarabic = 64653, e.notcontains = 8716, e.notelement = 8713, e.notelementof = 8713, e.notequal = 8800, e.notgreater = 8815, e.notgreaternorequal = 8817, e.notgreaternorless = 8825, e.notidentical = 8802, e.notless = 8814, e.notlessnorequal = 8816, e.notparallel = 8742, e.notprecedes = 8832, e.notsubset = 8836, e.notsucceeds = 8833, e.notsuperset = 8837, e.nowarmenian = 1398, e.nparen = 9385, e.nssquare = 13233, e.nsuperior = 8319, e.ntilde = 241, e.nu = 957, e.nuhiragana = 12396, e.nukatakana = 12492, e.nukatakanahalfwidth = 65415, e.nuktabengali = 2492, e.nuktadeva = 2364, e.nuktagujarati = 2748, e.nuktagurmukhi = 2620, e.numbersign = 35, e.numbersignmonospace = 65283, e.numbersignsmall = 65119, e.numeralsigngreek = 884, e.numeralsignlowergreek = 885, e.numero = 8470, e.nun = 1504, e.nundagesh = 64320, e.nundageshhebrew = 64320, e.nunhebrew = 1504, e.nvsquare = 13237, e.nwsquare = 13243, e.nyabengali = 2462, e.nyadeva = 2334, e.nyagujarati = 2718, e.nyagurmukhi = 2590, e.o = 111, e.oacute = 243;
              e.oangthai = 3629, e.obarred = 629, e.obarredcyrillic = 1257, e.obarreddieresiscyrillic = 1259, e.obengali = 2451, e.obopomofo = 12571, e.obreve = 335, e.ocandradeva = 2321, e.ocandragujarati = 2705, e.ocandravowelsigndeva = 2377, e.ocandravowelsigngujarati = 2761, e.ocaron = 466, e.ocircle = 9438, e.ocircumflex = 244, e.ocircumflexacute = 7889, e.ocircumflexdotbelow = 7897, e.ocircumflexgrave = 7891, e.ocircumflexhookabove = 7893, e.ocircumflextilde = 7895, e.ocyrillic = 1086, e.odblacute = 337, e.odblgrave = 525, e.odeva = 2323, e.odieresis = 246, e.odieresiscyrillic = 1255, e.odotbelow = 7885, e.oe = 339, e.oekorean = 12634, e.ogonek = 731, e.ogonekcmb = 808, e.ograve = 242, e.ogujarati = 2707, e.oharmenian = 1413, e.ohiragana = 12362, e.ohookabove = 7887, e.ohorn = 417, e.ohornacute = 7899, e.ohorndotbelow = 7907, e.ohorngrave = 7901, e.ohornhookabove = 7903, e.ohorntilde = 7905, e.ohungarumlaut = 337, e.oi = 419, e.oinvertedbreve = 527, e.okatakana = 12458, e.okatakanahalfwidth = 65397, e.okorean = 12631, e.olehebrew = 1451, e.omacron = 333, e.omacronacute = 7763, e.omacrongrave = 7761, e.omdeva = 2384, e.omega = 969, e.omega1 = 982, e.omegacyrillic = 1121, e.omegalatinclosed = 631, e.omegaroundcyrillic = 1147, e.omegatitlocyrillic = 1149, e.omegatonos = 974, e.omgujarati = 2768, e.omicron = 959, e.omicrontonos = 972, e.omonospace = 65359, e.one = 49, e.onearabic = 1633, e.onebengali = 2535, e.onecircle = 9312, e.onecircleinversesansserif = 10122, e.onedeva = 2407, e.onedotenleader = 8228, e.oneeighth = 8539, e.onefitted = 63196, e.onegujarati = 2791, e.onegurmukhi = 2663, e.onehackarabic = 1633, e.onehalf = 189, e.onehangzhou = 12321, e.oneideographicparen = 12832, e.oneinferior = 8321, e.onemonospace = 65297, e.onenumeratorbengali = 2548, e.oneoldstyle = 63281, e.oneparen = 9332, e.oneperiod = 9352, e.onepersian = 1777, e.onequarter = 188, e.oneroman = 8560, e.onesuperior = 185, e.onethai = 3665, e.onethird = 8531, e.oogonek = 491, e.oogonekmacron = 493, e.oogurmukhi = 2579, e.oomatragurmukhi = 2635, e.oopen = 596, e.oparen = 9386, e.openbullet = 9702, e.option = 8997, e.ordfeminine = 170, e.ordmasculine = 186, e.orthogonal = 8735, e.oshortdeva = 2322, e.oshortvowelsigndeva = 2378, e.oslash = 248, e.oslashacute = 511, e.osmallhiragana = 12361, e.osmallkatakana = 12457, e.osmallkatakanahalfwidth = 65387, e.ostrokeacute = 511, e.osuperior = 63216, e.otcyrillic = 1151, e.otilde = 245, e.otildeacute = 7757, e.otildedieresis = 7759, e.oubopomofo = 12577, e.overline = 8254, e.overlinecenterline = 65098, e.overlinecmb = 773, e.overlinedashed = 65097, e.overlinedblwavy = 65100, e.overlinewavy = 65099, e.overscore = 175, e.ovowelsignbengali = 2507, e.ovowelsigndeva = 2379, e.ovowelsigngujarati = 2763, e.p = 112, e.paampssquare = 13184, e.paasentosquare = 13099, e.pabengali = 2474, e.pacute = 7765, e.padeva = 2346, e.pagedown = 8671, e.pageup = 8670, e.pagujarati = 2730, e.pagurmukhi = 2602, e.pahiragana = 12401, e.paiyannoithai = 3631, e.pakatakana = 12497, e.palatalizationcyrilliccmb = 1156, e.palochkacyrillic = 1216, e.pansioskorean = 12671, e.paragraph = 182, e.parallel = 8741, e.parenleft = 40, e.parenleftaltonearabic = 64830, e.parenleftbt = 63725, e.parenleftex = 63724, e.parenleftinferior = 8333, e.parenleftmonospace = 65288, e.parenleftsmall = 65113, e.parenleftsuperior = 8317, e.parenlefttp = 63723, e.parenleftvertical = 65077, e.parenright = 41, e.parenrightaltonearabic = 64831, e.parenrightbt = 63736, e.parenrightex = 63735, e.parenrightinferior = 8334, e.parenrightmonospace = 65289, e.parenrightsmall = 65114, e.parenrightsuperior = 8318, e.parenrighttp = 63734, e.parenrightvertical = 65078, e.partialdiff = 8706, e.paseqhebrew = 1472, e.pashtahebrew = 1433, e.pasquare = 13225, e.patah = 1463, e.patah11 = 1463, e.patah1d = 1463, e.patah2a = 1463, e.patahhebrew = 1463, e.patahnarrowhebrew = 1463, e.patahquarterhebrew = 1463, e.patahwidehebrew = 1463, e.pazerhebrew = 1441, e.pbopomofo = 12550, e.pcircle = 9439, e.pdotaccent = 7767, e.pe = 1508, e.pecyrillic = 1087, e.pedagesh = 64324, e.pedageshhebrew = 64324, e.peezisquare = 13115, e.pefinaldageshhebrew = 64323, e.peharabic = 1662, e.peharmenian = 1402, e.pehebrew = 1508, e.pehfinalarabic = 64343, e.pehinitialarabic = 64344, e.pehiragana = 12410, e.pehmedialarabic = 64345, e.pekatakana = 12506, e.pemiddlehookcyrillic = 1191, e.perafehebrew = 64334, e.percent = 37, e.percentarabic = 1642, e.percentmonospace = 65285, e.percentsmall = 65130, e.period = 46;
              e.periodarmenian = 1417, e.periodcentered = 183, e.periodhalfwidth = 65377, e.periodinferior = 63207, e.periodmonospace = 65294, e.periodsmall = 65106, e.periodsuperior = 63208, e.perispomenigreekcmb = 834, e.perpendicular = 8869, e.perthousand = 8240, e.peseta = 8359, e.pfsquare = 13194, e.phabengali = 2475, e.phadeva = 2347, e.phagujarati = 2731, e.phagurmukhi = 2603, e.phi = 966, e.phi1 = 981, e.phieuphacirclekorean = 12922, e.phieuphaparenkorean = 12826, e.phieuphcirclekorean = 12908, e.phieuphkorean = 12621, e.phieuphparenkorean = 12812, e.philatin = 632, e.phinthuthai = 3642, e.phisymbolgreek = 981, e.phook = 421, e.phophanthai = 3614, e.phophungthai = 3612, e.phosamphaothai = 3616, e.pi = 960, e.pieupacirclekorean = 12915, e.pieupaparenkorean = 12819, e.pieupcieuckorean = 12662, e.pieupcirclekorean = 12901, e.pieupkiyeokkorean = 12658, e.pieupkorean = 12610, e.pieupparenkorean = 12805, e.pieupsioskiyeokkorean = 12660, e.pieupsioskorean = 12612, e.pieupsiostikeutkorean = 12661, e.pieupthieuthkorean = 12663, e.pieuptikeutkorean = 12659, e.pihiragana = 12404, e.pikatakana = 12500, e.pisymbolgreek = 982, e.piwrarmenian = 1411, e.plus = 43, e.plusbelowcmb = 799, e.pluscircle = 8853, e.plusminus = 177, e.plusmod = 726, e.plusmonospace = 65291, e.plussmall = 65122, e.plussuperior = 8314, e.pmonospace = 65360, e.pmsquare = 13272, e.pohiragana = 12413, e.pointingindexdownwhite = 9759, e.pointingindexleftwhite = 9756, e.pointingindexrightwhite = 9758, e.pointingindexupwhite = 9757, e.pokatakana = 12509, e.poplathai = 3611, e.postalmark = 12306, e.postalmarkface = 12320, e.pparen = 9387, e.precedes = 8826, e.prescription = 8478, e.primemod = 697, e.primereversed = 8245, e.product = 8719, e.projective = 8965, e.prolongedkana = 12540, e.propellor = 8984, e.propersubset = 8834, e.propersuperset = 8835, e.proportion = 8759, e.proportional = 8733, e.psi = 968, e.psicyrillic = 1137, e.psilipneumatacyrilliccmb = 1158, e.pssquare = 13232, e.puhiragana = 12407, e.pukatakana = 12503, e.pvsquare = 13236, e.pwsquare = 13242, e.q = 113, e.qadeva = 2392, e.qadmahebrew = 1448, e.qafarabic = 1602, e.qaffinalarabic = 65238, e.qafinitialarabic = 65239, e.qafmedialarabic = 65240, e.qamats = 1464, e.qamats10 = 1464, e.qamats1a = 1464, e.qamats1c = 1464, e.qamats27 = 1464, e.qamats29 = 1464, e.qamats33 = 1464, e.qamatsde = 1464, e.qamatshebrew = 1464, e.qamatsnarrowhebrew = 1464, e.qamatsqatanhebrew = 1464, e.qamatsqatannarrowhebrew = 1464, e.qamatsqatanquarterhebrew = 1464, e.qamatsqatanwidehebrew = 1464, e.qamatsquarterhebrew = 1464, e.qamatswidehebrew = 1464, e.qarneyparahebrew = 1439, e.qbopomofo = 12561, e.qcircle = 9440, e.qhook = 672, e.qmonospace = 65361, e.qof = 1511, e.qofdagesh = 64327, e.qofdageshhebrew = 64327, e.qofhebrew = 1511, e.qparen = 9388, e.quarternote = 9833, e.qubuts = 1467, e.qubuts18 = 1467, e.qubuts25 = 1467, e.qubuts31 = 1467, e.qubutshebrew = 1467, e.qubutsnarrowhebrew = 1467, e.qubutsquarterhebrew = 1467, e.qubutswidehebrew = 1467, e.question = 63, e.questionarabic = 1567, e.questionarmenian = 1374, e.questiondown = 191, e.questiondownsmall = 63423, e.questiongreek = 894, e.questionmonospace = 65311, e.questionsmall = 63295, e.quotedbl = 34, e.quotedblbase = 8222, e.quotedblleft = 8220, e.quotedblmonospace = 65282, e.quotedblprime = 12318, e.quotedblprimereversed = 12317, e.quotedblright = 8221, e.quoteleft = 8216, e.quoteleftreversed = 8219, e.quotereversed = 8219, e.quoteright = 8217, e.quoterightn = 329, e.quotesinglbase = 8218, e.quotesingle = 39, e.quotesinglemonospace = 65287, e.r = 114, e.raarmenian = 1404, e.rabengali = 2480, e.racute = 341, e.radeva = 2352, e.radical = 8730, e.radicalex = 63717, e.radoverssquare = 13230, e.radoverssquaredsquare = 13231, e.radsquare = 13229, e.rafe = 1471, e.rafehebrew = 1471, e.ragujarati = 2736, e.ragurmukhi = 2608, e.rahiragana = 12425, e.rakatakana = 12521, e.rakatakanahalfwidth = 65431, e.ralowerdiagonalbengali = 2545, e.ramiddlediagonalbengali = 2544, e.ramshorn = 612, e.ratio = 8758, e.rbopomofo = 12566, e.rcaron = 345, e.rcedilla = 343, e.rcircle = 9441, e.rcommaaccent = 343, e.rdblgrave = 529, e.rdotaccent = 7769, e.rdotbelow = 7771, e.rdotbelowmacron = 7773, e.referencemark = 8251, e.reflexsubset = 8838, e.reflexsuperset = 8839, e.registered = 174, e.registersans = 63720, e.registerserif = 63194, e.reharabic = 1585, e.reharmenian = 1408, e.rehfinalarabic = 65198, e.rehiragana = 12428, e.rekatakana = 12524, e.rekatakanahalfwidth = 65434, e.resh = 1512, e.reshdageshhebrew = 64328, e.reshhebrew = 1512, e.reversedtilde = 8765, e.reviahebrew = 1431, e.reviamugrashhebrew = 1431;
              e.revlogicalnot = 8976, e.rfishhook = 638, e.rfishhookreversed = 639, e.rhabengali = 2525, e.rhadeva = 2397, e.rho = 961, e.rhook = 637, e.rhookturned = 635, e.rhookturnedsuperior = 693, e.rhosymbolgreek = 1009, e.rhotichookmod = 734, e.rieulacirclekorean = 12913, e.rieulaparenkorean = 12817, e.rieulcirclekorean = 12899, e.rieulhieuhkorean = 12608, e.rieulkiyeokkorean = 12602, e.rieulkiyeoksioskorean = 12649, e.rieulkorean = 12601, e.rieulmieumkorean = 12603, e.rieulpansioskorean = 12652, e.rieulparenkorean = 12803, e.rieulphieuphkorean = 12607, e.rieulpieupkorean = 12604, e.rieulpieupsioskorean = 12651, e.rieulsioskorean = 12605, e.rieulthieuthkorean = 12606, e.rieultikeutkorean = 12650, e.rieulyeorinhieuhkorean = 12653, e.rightangle = 8735, e.righttackbelowcmb = 793, e.righttriangle = 8895, e.rihiragana = 12426, e.rikatakana = 12522, e.rikatakanahalfwidth = 65432, e.ring = 730, e.ringbelowcmb = 805, e.ringcmb = 778, e.ringhalfleft = 703, e.ringhalfleftarmenian = 1369, e.ringhalfleftbelowcmb = 796, e.ringhalfleftcentered = 723, e.ringhalfright = 702, e.ringhalfrightbelowcmb = 825, e.ringhalfrightcentered = 722, e.rinvertedbreve = 531, e.rittorusquare = 13137, e.rlinebelow = 7775, e.rlongleg = 636, e.rlonglegturned = 634, e.rmonospace = 65362, e.rohiragana = 12429, e.rokatakana = 12525, e.rokatakanahalfwidth = 65435, e.roruathai = 3619, e.rparen = 9389, e.rrabengali = 2524, e.rradeva = 2353, e.rragurmukhi = 2652, e.rreharabic = 1681, e.rrehfinalarabic = 64397, e.rrvocalicbengali = 2528, e.rrvocalicdeva = 2400, e.rrvocalicgujarati = 2784, e.rrvocalicvowelsignbengali = 2500, e.rrvocalicvowelsigndeva = 2372, e.rrvocalicvowelsigngujarati = 2756, e.rsuperior = 63217, e.rtblock = 9616, e.rturned = 633, e.rturnedsuperior = 692, e.ruhiragana = 12427, e.rukatakana = 12523, e.rukatakanahalfwidth = 65433, e.rupeemarkbengali = 2546, e.rupeesignbengali = 2547, e.rupiah = 63197, e.ruthai = 3620, e.rvocalicbengali = 2443, e.rvocalicdeva = 2315, e.rvocalicgujarati = 2699, e.rvocalicvowelsignbengali = 2499, e.rvocalicvowelsigndeva = 2371, e.rvocalicvowelsigngujarati = 2755, e.s = 115, e.sabengali = 2488, e.sacute = 347, e.sacutedotaccent = 7781, e.sadarabic = 1589, e.sadeva = 2360, e.sadfinalarabic = 65210, e.sadinitialarabic = 65211, e.sadmedialarabic = 65212, e.sagujarati = 2744, e.sagurmukhi = 2616, e.sahiragana = 12373, e.sakatakana = 12469, e.sakatakanahalfwidth = 65403, e.sallallahoualayhewasallamarabic = 65018, e.samekh = 1505, e.samekhdagesh = 64321, e.samekhdageshhebrew = 64321, e.samekhhebrew = 1505, e.saraaathai = 3634, e.saraaethai = 3649, e.saraaimaimalaithai = 3652, e.saraaimaimuanthai = 3651, e.saraamthai = 3635, e.saraathai = 3632, e.saraethai = 3648, e.saraiileftthai = 63622, e.saraiithai = 3637, e.saraileftthai = 63621, e.saraithai = 3636, e.saraothai = 3650, e.saraueeleftthai = 63624, e.saraueethai = 3639, e.saraueleftthai = 63623, e.sarauethai = 3638, e.sarauthai = 3640, e.sarauuthai = 3641, e.sbopomofo = 12569, e.scaron = 353, e.scarondotaccent = 7783, e.scedilla = 351, e.schwa = 601, e.schwacyrillic = 1241, e.schwadieresiscyrillic = 1243, e.schwahook = 602, e.scircle = 9442, e.scircumflex = 349, e.scommaaccent = 537, e.sdotaccent = 7777, e.sdotbelow = 7779, e.sdotbelowdotaccent = 7785, e.seagullbelowcmb = 828, e.second = 8243, e.secondtonechinese = 714, e.section = 167, e.seenarabic = 1587, e.seenfinalarabic = 65202, e.seeninitialarabic = 65203, e.seenmedialarabic = 65204, e.segol = 1462, e.segol13 = 1462, e.segol1f = 1462, e.segol2c = 1462, e.segolhebrew = 1462, e.segolnarrowhebrew = 1462, e.segolquarterhebrew = 1462, e.segoltahebrew = 1426, e.segolwidehebrew = 1462, e.seharmenian = 1405, e.sehiragana = 12379, e.sekatakana = 12475, e.sekatakanahalfwidth = 65406, e.semicolon = 59, e.semicolonarabic = 1563, e.semicolonmonospace = 65307, e.semicolonsmall = 65108, e.semivoicedmarkkana = 12444, e.semivoicedmarkkanahalfwidth = 65439, e.sentisquare = 13090, e.sentosquare = 13091, e.seven = 55, e.sevenarabic = 1639, e.sevenbengali = 2541, e.sevencircle = 9318, e.sevencircleinversesansserif = 10128, e.sevendeva = 2413, e.seveneighths = 8542, e.sevengujarati = 2797, e.sevengurmukhi = 2669, e.sevenhackarabic = 1639, e.sevenhangzhou = 12327, e.sevenideographicparen = 12838, e.seveninferior = 8327, e.sevenmonospace = 65303, e.sevenoldstyle = 63287, e.sevenparen = 9338, e.sevenperiod = 9358, e.sevenpersian = 1783, e.sevenroman = 8566, e.sevensuperior = 8311, e.seventeencircle = 9328, e.seventeenparen = 9348, e.seventeenperiod = 9368, e.seventhai = 3671, e.sfthyphen = 173, e.shaarmenian = 1399, e.shabengali = 2486, e.shacyrillic = 1096, e.shaddaarabic = 1617, e.shaddadammaarabic = 64609, e.shaddadammatanarabic = 64606, e.shaddafathaarabic = 64608, e.shaddakasraarabic = 64610, e.shaddakasratanarabic = 64607, e.shade = 9618, e.shadedark = 9619, e.shadelight = 9617;
              e.shademedium = 9618, e.shadeva = 2358, e.shagujarati = 2742, e.shagurmukhi = 2614, e.shalshelethebrew = 1427, e.shbopomofo = 12565, e.shchacyrillic = 1097, e.sheenarabic = 1588, e.sheenfinalarabic = 65206, e.sheeninitialarabic = 65207, e.sheenmedialarabic = 65208, e.sheicoptic = 995, e.sheqel = 8362, e.sheqelhebrew = 8362, e.sheva = 1456, e.sheva115 = 1456, e.sheva15 = 1456, e.sheva22 = 1456, e.sheva2e = 1456, e.shevahebrew = 1456, e.shevanarrowhebrew = 1456, e.shevaquarterhebrew = 1456, e.shevawidehebrew = 1456, e.shhacyrillic = 1211, e.shimacoptic = 1005, e.shin = 1513, e.shindagesh = 64329, e.shindageshhebrew = 64329, e.shindageshshindot = 64300, e.shindageshshindothebrew = 64300, e.shindageshsindot = 64301, e.shindageshsindothebrew = 64301, e.shindothebrew = 1473, e.shinhebrew = 1513, e.shinshindot = 64298, e.shinshindothebrew = 64298, e.shinsindot = 64299, e.shinsindothebrew = 64299, e.shook = 642, e.sigma = 963, e.sigma1 = 962, e.sigmafinal = 962, e.sigmalunatesymbolgreek = 1010, e.sihiragana = 12375, e.sikatakana = 12471, e.sikatakanahalfwidth = 65404, e.siluqhebrew = 1469, e.siluqlefthebrew = 1469, e.similar = 8764, e.sindothebrew = 1474, e.siosacirclekorean = 12916, e.siosaparenkorean = 12820, e.sioscieuckorean = 12670, e.sioscirclekorean = 12902, e.sioskiyeokkorean = 12666, e.sioskorean = 12613, e.siosnieunkorean = 12667, e.siosparenkorean = 12806, e.siospieupkorean = 12669, e.siostikeutkorean = 12668, e.six = 54, e.sixarabic = 1638, e.sixbengali = 2540, e.sixcircle = 9317, e.sixcircleinversesansserif = 10127, e.sixdeva = 2412, e.sixgujarati = 2796, e.sixgurmukhi = 2668, e.sixhackarabic = 1638, e.sixhangzhou = 12326, e.sixideographicparen = 12837, e.sixinferior = 8326, e.sixmonospace = 65302, e.sixoldstyle = 63286, e.sixparen = 9337, e.sixperiod = 9357, e.sixpersian = 1782, e.sixroman = 8565, e.sixsuperior = 8310, e.sixteencircle = 9327, e.sixteencurrencydenominatorbengali = 2553, e.sixteenparen = 9347, e.sixteenperiod = 9367, e.sixthai = 3670, e.slash = 47, e.slashmonospace = 65295, e.slong = 383, e.slongdotaccent = 7835, e.smileface = 9786, e.smonospace = 65363, e.sofpasuqhebrew = 1475, e.softhyphen = 173, e.softsigncyrillic = 1100, e.sohiragana = 12381, e.sokatakana = 12477, e.sokatakanahalfwidth = 65407, e.soliduslongoverlaycmb = 824, e.solidusshortoverlaycmb = 823, e.sorusithai = 3625, e.sosalathai = 3624, e.sosothai = 3595, e.sosuathai = 3626, e.space = 32, e.spacehackarabic = 32, e.spade = 9824, e.spadesuitblack = 9824, e.spadesuitwhite = 9828, e.sparen = 9390, e.squarebelowcmb = 827, e.squarecc = 13252, e.squarecm = 13213, e.squarediagonalcrosshatchfill = 9641, e.squarehorizontalfill = 9636, e.squarekg = 13199, e.squarekm = 13214, e.squarekmcapital = 13262, e.squareln = 13265, e.squarelog = 13266, e.squaremg = 13198, e.squaremil = 13269, e.squaremm = 13212, e.squaremsquared = 13217, e.squareorthogonalcrosshatchfill = 9638, e.squareupperlefttolowerrightfill = 9639, e.squareupperrighttolowerleftfill = 9640, e.squareverticalfill = 9637, e.squarewhitewithsmallblack = 9635, e.srsquare = 13275, e.ssabengali = 2487, e.ssadeva = 2359, e.ssagujarati = 2743, e.ssangcieuckorean = 12617, e.ssanghieuhkorean = 12677, e.ssangieungkorean = 12672, e.ssangkiyeokkorean = 12594, e.ssangnieunkorean = 12645, e.ssangpieupkorean = 12611, e.ssangsioskorean = 12614, e.ssangtikeutkorean = 12600, e.ssuperior = 63218, e.sterling = 163, e.sterlingmonospace = 65505, e.strokelongoverlaycmb = 822, e.strokeshortoverlaycmb = 821, e.subset = 8834, e.subsetnotequal = 8842, e.subsetorequal = 8838, e.succeeds = 8827, e.suchthat = 8715, e.suhiragana = 12377, e.sukatakana = 12473, e.sukatakanahalfwidth = 65405, e.sukunarabic = 1618, e.summation = 8721, e.sun = 9788, e.superset = 8835, e.supersetnotequal = 8843, e.supersetorequal = 8839, e.svsquare = 13276, e.syouwaerasquare = 13180, e.t = 116, e.tabengali = 2468, e.tackdown = 8868, e.tackleft = 8867, e.tadeva = 2340, e.tagujarati = 2724, e.tagurmukhi = 2596, e.taharabic = 1591, e.tahfinalarabic = 65218, e.tahinitialarabic = 65219, e.tahiragana = 12383, e.tahmedialarabic = 65220, e.taisyouerasquare = 13181, e.takatakana = 12479, e.takatakanahalfwidth = 65408, e.tatweelarabic = 1600, e.tau = 964, e.tav = 1514, e.tavdages = 64330, e.tavdagesh = 64330, e.tavdageshhebrew = 64330, e.tavhebrew = 1514, e.tbar = 359, e.tbopomofo = 12554, e.tcaron = 357, e.tccurl = 680, e.tcedilla = 355, e.tcheharabic = 1670, e.tchehfinalarabic = 64379, e.tchehinitialarabic = 64380, e.tchehmedialarabic = 64381, e.tcircle = 9443, e.tcircumflexbelow = 7793, e.tcommaaccent = 355, e.tdieresis = 7831, e.tdotaccent = 7787, e.tdotbelow = 7789, e.tecyrillic = 1090, e.tedescendercyrillic = 1197, e.teharabic = 1578;
              e.tehfinalarabic = 65174, e.tehhahinitialarabic = 64674, e.tehhahisolatedarabic = 64524, e.tehinitialarabic = 65175, e.tehiragana = 12390, e.tehjeeminitialarabic = 64673, e.tehjeemisolatedarabic = 64523, e.tehmarbutaarabic = 1577, e.tehmarbutafinalarabic = 65172, e.tehmedialarabic = 65176, e.tehmeeminitialarabic = 64676, e.tehmeemisolatedarabic = 64526, e.tehnoonfinalarabic = 64627, e.tekatakana = 12486, e.tekatakanahalfwidth = 65411, e.telephone = 8481, e.telephoneblack = 9742, e.telishagedolahebrew = 1440, e.telishaqetanahebrew = 1449, e.tencircle = 9321, e.tenideographicparen = 12841, e.tenparen = 9341, e.tenperiod = 9361, e.tenroman = 8569, e.tesh = 679, e.tet = 1496, e.tetdagesh = 64312, e.tetdageshhebrew = 64312, e.tethebrew = 1496, e.tetsecyrillic = 1205, e.tevirhebrew = 1435, e.tevirlefthebrew = 1435, e.thabengali = 2469, e.thadeva = 2341, e.thagujarati = 2725, e.thagurmukhi = 2597, e.thalarabic = 1584, e.thalfinalarabic = 65196, e.thanthakhatlowleftthai = 63640, e.thanthakhatlowrightthai = 63639, e.thanthakhatthai = 3660, e.thanthakhatupperleftthai = 63638, e.theharabic = 1579, e.thehfinalarabic = 65178, e.thehinitialarabic = 65179, e.thehmedialarabic = 65180, e.thereexists = 8707, e.therefore = 8756, e.theta = 952, e.theta1 = 977, e.thetasymbolgreek = 977, e.thieuthacirclekorean = 12921, e.thieuthaparenkorean = 12825, e.thieuthcirclekorean = 12907, e.thieuthkorean = 12620, e.thieuthparenkorean = 12811, e.thirteencircle = 9324, e.thirteenparen = 9344, e.thirteenperiod = 9364, e.thonangmonthothai = 3601, e.thook = 429, e.thophuthaothai = 3602, e.thorn = 254, e.thothahanthai = 3607, e.thothanthai = 3600, e.thothongthai = 3608, e.thothungthai = 3606, e.thousandcyrillic = 1154, e.thousandsseparatorarabic = 1644, e.thousandsseparatorpersian = 1644, e.three = 51, e.threearabic = 1635, e.threebengali = 2537, e.threecircle = 9314, e.threecircleinversesansserif = 10124, e.threedeva = 2409, e.threeeighths = 8540, e.threegujarati = 2793, e.threegurmukhi = 2665, e.threehackarabic = 1635, e.threehangzhou = 12323, e.threeideographicparen = 12834, e.threeinferior = 8323, e.threemonospace = 65299, e.threenumeratorbengali = 2550, e.threeoldstyle = 63283, e.threeparen = 9334, e.threeperiod = 9354, e.threepersian = 1779, e.threequarters = 190, e.threequartersemdash = 63198, e.threeroman = 8562, e.threesuperior = 179, e.threethai = 3667, e.thzsquare = 13204, e.tihiragana = 12385, e.tikatakana = 12481, e.tikatakanahalfwidth = 65409, e.tikeutacirclekorean = 12912, e.tikeutaparenkorean = 12816, e.tikeutcirclekorean = 12898, e.tikeutkorean = 12599, e.tikeutparenkorean = 12802, e.tilde = 732, e.tildebelowcmb = 816, e.tildecmb = 771, e.tildecomb = 771, e.tildedoublecmb = 864, e.tildeoperator = 8764, e.tildeoverlaycmb = 820, e.tildeverticalcmb = 830, e.timescircle = 8855, e.tipehahebrew = 1430, e.tipehalefthebrew = 1430, e.tippigurmukhi = 2672, e.titlocyrilliccmb = 1155, e.tiwnarmenian = 1407, e.tlinebelow = 7791, e.tmonospace = 65364, e.toarmenian = 1385, e.tohiragana = 12392, e.tokatakana = 12488, e.tokatakanahalfwidth = 65412, e.tonebarextrahighmod = 741, e.tonebarextralowmod = 745, e.tonebarhighmod = 742, e.tonebarlowmod = 744, e.tonebarmidmod = 743, e.tonefive = 445, e.tonesix = 389, e.tonetwo = 424, e.tonos = 900, e.tonsquare = 13095, e.topatakthai = 3599, e.tortoiseshellbracketleft = 12308, e.tortoiseshellbracketleftsmall = 65117, e.tortoiseshellbracketleftvertical = 65081, e.tortoiseshellbracketright = 12309, e.tortoiseshellbracketrightsmall = 65118, e.tortoiseshellbracketrightvertical = 65082, e.totaothai = 3605, e.tpalatalhook = 427, e.tparen = 9391, e.trademark = 8482, e.trademarksans = 63722, e.trademarkserif = 63195, e.tretroflexhook = 648, e.triagdn = 9660, e.triaglf = 9668, e.triagrt = 9658, e.triagup = 9650, e.ts = 678, e.tsadi = 1510, e.tsadidagesh = 64326, e.tsadidageshhebrew = 64326, e.tsadihebrew = 1510, e.tsecyrillic = 1094, e.tsere = 1461, e.tsere12 = 1461, e.tsere1e = 1461, e.tsere2b = 1461, e.tserehebrew = 1461, e.tserenarrowhebrew = 1461, e.tserequarterhebrew = 1461, e.tserewidehebrew = 1461, e.tshecyrillic = 1115, e.tsuperior = 63219, e.ttabengali = 2463, e.ttadeva = 2335, e.ttagujarati = 2719, e.ttagurmukhi = 2591, e.tteharabic = 1657, e.ttehfinalarabic = 64359, e.ttehinitialarabic = 64360, e.ttehmedialarabic = 64361, e.tthabengali = 2464, e.tthadeva = 2336, e.tthagujarati = 2720, e.tthagurmukhi = 2592, e.tturned = 647, e.tuhiragana = 12388, e.tukatakana = 12484, e.tukatakanahalfwidth = 65410, e.tusmallhiragana = 12387, e.tusmallkatakana = 12483, e.tusmallkatakanahalfwidth = 65391, e.twelvecircle = 9323, e.twelveparen = 9343, e.twelveperiod = 9363, e.twelveroman = 8571, e.twentycircle = 9331, e.twentyhangzhou = 21316, e.twentyparen = 9351, e.twentyperiod = 9371, e.two = 50, e.twoarabic = 1634, e.twobengali = 2536, e.twocircle = 9313, e.twocircleinversesansserif = 10123, e.twodeva = 2408;
              e.twodotenleader = 8229, e.twodotleader = 8229, e.twodotleadervertical = 65072, e.twogujarati = 2792, e.twogurmukhi = 2664, e.twohackarabic = 1634, e.twohangzhou = 12322, e.twoideographicparen = 12833, e.twoinferior = 8322, e.twomonospace = 65298, e.twonumeratorbengali = 2549, e.twooldstyle = 63282, e.twoparen = 9333, e.twoperiod = 9353, e.twopersian = 1778, e.tworoman = 8561, e.twostroke = 443, e.twosuperior = 178, e.twothai = 3666, e.twothirds = 8532, e.u = 117, e.uacute = 250, e.ubar = 649, e.ubengali = 2441, e.ubopomofo = 12584, e.ubreve = 365, e.ucaron = 468, e.ucircle = 9444, e.ucircumflex = 251, e.ucircumflexbelow = 7799, e.ucyrillic = 1091, e.udattadeva = 2385, e.udblacute = 369, e.udblgrave = 533, e.udeva = 2313, e.udieresis = 252, e.udieresisacute = 472, e.udieresisbelow = 7795, e.udieresiscaron = 474, e.udieresiscyrillic = 1265, e.udieresisgrave = 476, e.udieresismacron = 470, e.udotbelow = 7909, e.ugrave = 249, e.ugujarati = 2697, e.ugurmukhi = 2569, e.uhiragana = 12358, e.uhookabove = 7911, e.uhorn = 432, e.uhornacute = 7913, e.uhorndotbelow = 7921, e.uhorngrave = 7915, e.uhornhookabove = 7917, e.uhorntilde = 7919, e.uhungarumlaut = 369, e.uhungarumlautcyrillic = 1267, e.uinvertedbreve = 535, e.ukatakana = 12454, e.ukatakanahalfwidth = 65395, e.ukcyrillic = 1145, e.ukorean = 12636, e.umacron = 363, e.umacroncyrillic = 1263, e.umacrondieresis = 7803, e.umatragurmukhi = 2625, e.umonospace = 65365, e.underscore = 95, e.underscoredbl = 8215, e.underscoremonospace = 65343, e.underscorevertical = 65075, e.underscorewavy = 65103, e.union = 8746, e.universal = 8704, e.uogonek = 371, e.uparen = 9392, e.upblock = 9600, e.upperdothebrew = 1476, e.upsilon = 965, e.upsilondieresis = 971, e.upsilondieresistonos = 944, e.upsilonlatin = 650, e.upsilontonos = 973, e.uptackbelowcmb = 797, e.uptackmod = 724, e.uragurmukhi = 2675, e.uring = 367, e.ushortcyrillic = 1118, e.usmallhiragana = 12357, e.usmallkatakana = 12453, e.usmallkatakanahalfwidth = 65385, e.ustraightcyrillic = 1199, e.ustraightstrokecyrillic = 1201, e.utilde = 361, e.utildeacute = 7801, e.utildebelow = 7797, e.uubengali = 2442, e.uudeva = 2314, e.uugujarati = 2698, e.uugurmukhi = 2570, e.uumatragurmukhi = 2626, e.uuvowelsignbengali = 2498, e.uuvowelsigndeva = 2370, e.uuvowelsigngujarati = 2754, e.uvowelsignbengali = 2497, e.uvowelsigndeva = 2369, e.uvowelsigngujarati = 2753, e.v = 118, e.vadeva = 2357, e.vagujarati = 2741, e.vagurmukhi = 2613, e.vakatakana = 12535, e.vav = 1493, e.vavdagesh = 64309, e.vavdagesh65 = 64309, e.vavdageshhebrew = 64309, e.vavhebrew = 1493, e.vavholam = 64331, e.vavholamhebrew = 64331, e.vavvavhebrew = 1520, e.vavyodhebrew = 1521, e.vcircle = 9445, e.vdotbelow = 7807, e.vecyrillic = 1074, e.veharabic = 1700, e.vehfinalarabic = 64363, e.vehinitialarabic = 64364, e.vehmedialarabic = 64365, e.vekatakana = 12537, e.venus = 9792, e.verticalbar = 124, e.verticallineabovecmb = 781, e.verticallinebelowcmb = 809, e.verticallinelowmod = 716, e.verticallinemod = 712, e.vewarmenian = 1406, e.vhook = 651, e.vikatakana = 12536, e.viramabengali = 2509, e.viramadeva = 2381, e.viramagujarati = 2765, e.visargabengali = 2435, e.visargadeva = 2307, e.visargagujarati = 2691, e.vmonospace = 65366, e.voarmenian = 1400, e.voicediterationhiragana = 12446, e.voicediterationkatakana = 12542, e.voicedmarkkana = 12443, e.voicedmarkkanahalfwidth = 65438, e.vokatakana = 12538, e.vparen = 9393, e.vtilde = 7805, e.vturned = 652, e.vuhiragana = 12436, e.vukatakana = 12532, e.w = 119, e.wacute = 7811, e.waekorean = 12633, e.wahiragana = 12431, e.wakatakana = 12527, e.wakatakanahalfwidth = 65436, e.wakorean = 12632, e.wasmallhiragana = 12430, e.wasmallkatakana = 12526, e.wattosquare = 13143, e.wavedash = 12316, e.wavyunderscorevertical = 65076, e.wawarabic = 1608, e.wawfinalarabic = 65262, e.wawhamzaabovearabic = 1572, e.wawhamzaabovefinalarabic = 65158, e.wbsquare = 13277, e.wcircle = 9446, e.wcircumflex = 373, e.wdieresis = 7813, e.wdotaccent = 7815, e.wdotbelow = 7817, e.wehiragana = 12433, e.weierstrass = 8472, e.wekatakana = 12529, e.wekorean = 12638, e.weokorean = 12637, e.wgrave = 7809, e.whitebullet = 9702, e.whitecircle = 9675, e.whitecircleinverse = 9689, e.whitecornerbracketleft = 12302, e.whitecornerbracketleftvertical = 65091, e.whitecornerbracketright = 12303, e.whitecornerbracketrightvertical = 65092, e.whitediamond = 9671, e.whitediamondcontainingblacksmalldiamond = 9672, e.whitedownpointingsmalltriangle = 9663, e.whitedownpointingtriangle = 9661, e.whiteleftpointingsmalltriangle = 9667, e.whiteleftpointingtriangle = 9665, e.whitelenticularbracketleft = 12310, e.whitelenticularbracketright = 12311, e.whiterightpointingsmalltriangle = 9657, e.whiterightpointingtriangle = 9655;
              e.whitesmallsquare = 9643, e.whitesmilingface = 9786, e.whitesquare = 9633, e.whitestar = 9734, e.whitetelephone = 9743, e.whitetortoiseshellbracketleft = 12312, e.whitetortoiseshellbracketright = 12313, e.whiteuppointingsmalltriangle = 9653, e.whiteuppointingtriangle = 9651, e.wihiragana = 12432, e.wikatakana = 12528, e.wikorean = 12639, e.wmonospace = 65367, e.wohiragana = 12434, e.wokatakana = 12530, e.wokatakanahalfwidth = 65382, e.won = 8361, e.wonmonospace = 65510, e.wowaenthai = 3623, e.wparen = 9394, e.wring = 7832, e.wsuperior = 695, e.wturned = 653, e.wynn = 447, e.x = 120, e.xabovecmb = 829, e.xbopomofo = 12562, e.xcircle = 9447, e.xdieresis = 7821, e.xdotaccent = 7819, e.xeharmenian = 1389, e.xi = 958, e.xmonospace = 65368, e.xparen = 9395, e.xsuperior = 739, e.y = 121, e.yaadosquare = 13134, e.yabengali = 2479, e.yacute = 253, e.yadeva = 2351, e.yaekorean = 12626, e.yagujarati = 2735, e.yagurmukhi = 2607, e.yahiragana = 12420, e.yakatakana = 12516, e.yakatakanahalfwidth = 65428, e.yakorean = 12625, e.yamakkanthai = 3662, e.yasmallhiragana = 12419, e.yasmallkatakana = 12515, e.yasmallkatakanahalfwidth = 65388, e.yatcyrillic = 1123, e.ycircle = 9448, e.ycircumflex = 375, e.ydieresis = 255, e.ydotaccent = 7823, e.ydotbelow = 7925, e.yeharabic = 1610, e.yehbarreearabic = 1746, e.yehbarreefinalarabic = 64431, e.yehfinalarabic = 65266, e.yehhamzaabovearabic = 1574, e.yehhamzaabovefinalarabic = 65162, e.yehhamzaaboveinitialarabic = 65163, e.yehhamzaabovemedialarabic = 65164, e.yehinitialarabic = 65267, e.yehmedialarabic = 65268, e.yehmeeminitialarabic = 64733, e.yehmeemisolatedarabic = 64600, e.yehnoonfinalarabic = 64660, e.yehthreedotsbelowarabic = 1745, e.yekorean = 12630, e.yen = 165, e.yenmonospace = 65509, e.yeokorean = 12629, e.yeorinhieuhkorean = 12678, e.yerahbenyomohebrew = 1450, e.yerahbenyomolefthebrew = 1450, e.yericyrillic = 1099, e.yerudieresiscyrillic = 1273, e.yesieungkorean = 12673, e.yesieungpansioskorean = 12675, e.yesieungsioskorean = 12674, e.yetivhebrew = 1434, e.ygrave = 7923, e.yhook = 436, e.yhookabove = 7927, e.yiarmenian = 1397, e.yicyrillic = 1111, e.yikorean = 12642, e.yinyang = 9775, e.yiwnarmenian = 1410, e.ymonospace = 65369, e.yod = 1497, e.yoddagesh = 64313, e.yoddageshhebrew = 64313, e.yodhebrew = 1497, e.yodyodhebrew = 1522, e.yodyodpatahhebrew = 64287, e.yohiragana = 12424, e.yoikorean = 12681, e.yokatakana = 12520, e.yokatakanahalfwidth = 65430, e.yokorean = 12635, e.yosmallhiragana = 12423, e.yosmallkatakana = 12519, e.yosmallkatakanahalfwidth = 65390, e.yotgreek = 1011, e.yoyaekorean = 12680, e.yoyakorean = 12679, e.yoyakthai = 3618, e.yoyingthai = 3597, e.yparen = 9396, e.ypogegrammeni = 890, e.ypogegrammenigreekcmb = 837, e.yr = 422, e.yring = 7833, e.ysuperior = 696, e.ytilde = 7929, e.yturned = 654, e.yuhiragana = 12422, e.yuikorean = 12684, e.yukatakana = 12518, e.yukatakanahalfwidth = 65429, e.yukorean = 12640, e.yusbigcyrillic = 1131, e.yusbigiotifiedcyrillic = 1133, e.yuslittlecyrillic = 1127, e.yuslittleiotifiedcyrillic = 1129, e.yusmallhiragana = 12421, e.yusmallkatakana = 12517, e.yusmallkatakanahalfwidth = 65389, e.yuyekorean = 12683, e.yuyeokorean = 12682, e.yyabengali = 2527, e.yyadeva = 2399, e.z = 122, e.zaarmenian = 1382, e.zacute = 378, e.zadeva = 2395, e.zagurmukhi = 2651, e.zaharabic = 1592, e.zahfinalarabic = 65222, e.zahinitialarabic = 65223, e.zahiragana = 12374, e.zahmedialarabic = 65224, e.zainarabic = 1586, e.zainfinalarabic = 65200, e.zakatakana = 12470, e.zaqefgadolhebrew = 1429, e.zaqefqatanhebrew = 1428, e.zarqahebrew = 1432, e.zayin = 1494, e.zayindagesh = 64310, e.zayindageshhebrew = 64310, e.zayinhebrew = 1494, e.zbopomofo = 12567, e.zcaron = 382, e.zcircle = 9449, e.zcircumflex = 7825, e.zcurl = 657, e.zdot = 380, e.zdotaccent = 380, e.zdotbelow = 7827, e.zecyrillic = 1079, e.zedescendercyrillic = 1177, e.zedieresiscyrillic = 1247, e.zehiragana = 12380, e.zekatakana = 12476, e.zero = 48, e.zeroarabic = 1632, e.zerobengali = 2534, e.zerodeva = 2406, e.zerogujarati = 2790, e.zerogurmukhi = 2662, e.zerohackarabic = 1632, e.zeroinferior = 8320, e.zeromonospace = 65296, e.zerooldstyle = 63280, e.zeropersian = 1776, e.zerosuperior = 8304, e.zerothai = 3664, e.zerowidthjoiner = 65279, e.zerowidthnonjoiner = 8204, e.zerowidthspace = 8203, e.zeta = 950, e.zhbopomofo = 12563, e.zhearmenian = 1386, e.zhebrevecyrillic = 1218, e.zhecyrillic = 1078, e.zhedescendercyrillic = 1175, e.zhedieresiscyrillic = 1245, e.zihiragana = 12376, e.zikatakana = 12472, e.zinorhebrew = 1454, e.zlinebelow = 7829, e.zmonospace = 65370, e.zohiragana = 12382, e.zokatakana = 12478, e.zparen = 9397;
              e.zretroflexhook = 656, e.zstroke = 438, e.zuhiragana = 12378, e.zukatakana = 12474, e[".notdef"] = 0, e.angbracketleftbig = 9001, e.angbracketleftBig = 9001, e.angbracketleftbigg = 9001, e.angbracketleftBigg = 9001, e.angbracketrightBig = 9002, e.angbracketrightbig = 9002, e.angbracketrightBigg = 9002, e.angbracketrightbigg = 9002, e.arrowhookleft = 8618, e.arrowhookright = 8617, e.arrowlefttophalf = 8636, e.arrowleftbothalf = 8637, e.arrownortheast = 8599, e.arrownorthwest = 8598, e.arrowrighttophalf = 8640, e.arrowrightbothalf = 8641, e.arrowsoutheast = 8600, e.arrowsouthwest = 8601, e.backslashbig = 8726, e.backslashBig = 8726, e.backslashBigg = 8726, e.backslashbigg = 8726, e.bardbl = 8214, e.bracehtipdownleft = 65079, e.bracehtipdownright = 65079, e.bracehtipupleft = 65080, e.bracehtipupright = 65080, e.braceleftBig = 123, e.braceleftbig = 123, e.braceleftbigg = 123, e.braceleftBigg = 123, e.bracerightBig = 125, e.bracerightbig = 125, e.bracerightbigg = 125, e.bracerightBigg = 125, e.bracketleftbig = 91, e.bracketleftBig = 91, e.bracketleftbigg = 91, e.bracketleftBigg = 91, e.bracketrightBig = 93, e.bracketrightbig = 93, e.bracketrightbigg = 93, e.bracketrightBigg = 93, e.ceilingleftbig = 8968, e.ceilingleftBig = 8968, e.ceilingleftBigg = 8968, e.ceilingleftbigg = 8968, e.ceilingrightbig = 8969, e.ceilingrightBig = 8969, e.ceilingrightbigg = 8969, e.ceilingrightBigg = 8969, e.circledotdisplay = 8857, e.circledottext = 8857, e.circlemultiplydisplay = 8855, e.circlemultiplytext = 8855, e.circleplusdisplay = 8853, e.circleplustext = 8853, e.contintegraldisplay = 8750, e.contintegraltext = 8750, e.coproductdisplay = 8720, e.coproducttext = 8720, e.floorleftBig = 8970, e.floorleftbig = 8970, e.floorleftbigg = 8970, e.floorleftBigg = 8970, e.floorrightbig = 8971, e.floorrightBig = 8971, e.floorrightBigg = 8971, e.floorrightbigg = 8971, e.hatwide = 770, e.hatwider = 770, e.hatwidest = 770, e.intercal = 7488, e.integraldisplay = 8747, e.integraltext = 8747, e.intersectiondisplay = 8898, e.intersectiontext = 8898, e.logicalanddisplay = 8743, e.logicalandtext = 8743, e.logicalordisplay = 8744, e.logicalortext = 8744, e.parenleftBig = 40, e.parenleftbig = 40, e.parenleftBigg = 40, e.parenleftbigg = 40, e.parenrightBig = 41, e.parenrightbig = 41, e.parenrightBigg = 41, e.parenrightbigg = 41, e.prime = 8242, e.productdisplay = 8719, e.producttext = 8719, e.radicalbig = 8730, e.radicalBig = 8730, e.radicalBigg = 8730, e.radicalbigg = 8730, e.radicalbt = 8730, e.radicaltp = 8730, e.radicalvertex = 8730, e.slashbig = 47, e.slashBig = 47, e.slashBigg = 47, e.slashbigg = 47, e.summationdisplay = 8721, e.summationtext = 8721, e.tildewide = 732, e.tildewider = 732, e.tildewidest = 732, e.uniondisplay = 8899, e.unionmultidisplay = 8846, e.unionmultitext = 8846, e.unionsqdisplay = 8852, e.unionsqtext = 8852, e.uniontext = 8899, e.vextenddouble = 8741, e.vextendsingle = 8739;
            }),
            o = i(function (e) {
              e.space = 32, e.a1 = 9985, e.a2 = 9986, e.a202 = 9987, e.a3 = 9988, e.a4 = 9742, e.a5 = 9990, e.a119 = 9991, e.a118 = 9992, e.a117 = 9993, e.a11 = 9755, e.a12 = 9758, e.a13 = 9996, e.a14 = 9997, e.a15 = 9998, e.a16 = 9999, e.a105 = 1e4, e.a17 = 10001, e.a18 = 10002, e.a19 = 10003, e.a20 = 10004, e.a21 = 10005, e.a22 = 10006, e.a23 = 10007, e.a24 = 10008, e.a25 = 10009, e.a26 = 10010, e.a27 = 10011, e.a28 = 10012, e.a6 = 10013, e.a7 = 10014, e.a8 = 10015, e.a9 = 10016, e.a10 = 10017, e.a29 = 10018, e.a30 = 10019, e.a31 = 10020, e.a32 = 10021, e.a33 = 10022, e.a34 = 10023, e.a35 = 9733, e.a36 = 10025, e.a37 = 10026, e.a38 = 10027, e.a39 = 10028, e.a40 = 10029, e.a41 = 10030, e.a42 = 10031, e.a43 = 10032, e.a44 = 10033, e.a45 = 10034, e.a46 = 10035, e.a47 = 10036, e.a48 = 10037, e.a49 = 10038, e.a50 = 10039, e.a51 = 10040, e.a52 = 10041, e.a53 = 10042, e.a54 = 10043, e.a55 = 10044, e.a56 = 10045, e.a57 = 10046, e.a58 = 10047, e.a59 = 10048, e.a60 = 10049, e.a61 = 10050, e.a62 = 10051, e.a63 = 10052, e.a64 = 10053, e.a65 = 10054, e.a66 = 10055, e.a67 = 10056, e.a68 = 10057, e.a69 = 10058, e.a70 = 10059, e.a71 = 9679, e.a72 = 10061, e.a73 = 9632, e.a74 = 10063, e.a203 = 10064, e.a75 = 10065, e.a204 = 10066, e.a76 = 9650, e.a77 = 9660, e.a78 = 9670, e.a79 = 10070, e.a81 = 9687, e.a82 = 10072, e.a83 = 10073, e.a84 = 10074, e.a97 = 10075, e.a98 = 10076, e.a99 = 10077, e.a100 = 10078, e.a101 = 10081, e.a102 = 10082, e.a103 = 10083, e.a104 = 10084, e.a106 = 10085, e.a107 = 10086, e.a108 = 10087, e.a112 = 9827, e.a111 = 9830, e.a110 = 9829, e.a109 = 9824, e.a120 = 9312, e.a121 = 9313, e.a122 = 9314, e.a123 = 9315, e.a124 = 9316, e.a125 = 9317, e.a126 = 9318, e.a127 = 9319, e.a128 = 9320, e.a129 = 9321, e.a130 = 10102, e.a131 = 10103, e.a132 = 10104, e.a133 = 10105, e.a134 = 10106, e.a135 = 10107, e.a136 = 10108, e.a137 = 10109, e.a138 = 10110, e.a139 = 10111, e.a140 = 10112, e.a141 = 10113, e.a142 = 10114, e.a143 = 10115, e.a144 = 10116, e.a145 = 10117, e.a146 = 10118, e.a147 = 10119, e.a148 = 10120, e.a149 = 10121, e.a150 = 10122, e.a151 = 10123, e.a152 = 10124, e.a153 = 10125, e.a154 = 10126, e.a155 = 10127, e.a156 = 10128, e.a157 = 10129, e.a158 = 10130, e.a159 = 10131, e.a160 = 10132, e.a161 = 8594, e.a163 = 8596, e.a164 = 8597, e.a196 = 10136, e.a165 = 10137, e.a192 = 10138, e.a166 = 10139, e.a167 = 10140, e.a168 = 10141, e.a169 = 10142, e.a170 = 10143, e.a171 = 10144, e.a172 = 10145, e.a173 = 10146, e.a162 = 10147, e.a174 = 10148, e.a175 = 10149, e.a176 = 10150, e.a177 = 10151, e.a178 = 10152, e.a179 = 10153, e.a193 = 10154, e.a180 = 10155, e.a199 = 10156, e.a181 = 10157, e.a200 = 10158, e.a182 = 10159, e.a201 = 10161, e.a183 = 10162, e.a184 = 10163, e.a197 = 10164, e.a185 = 10165, e.a194 = 10166, e.a198 = 10167, e.a186 = 10168, e.a195 = 10169, e.a187 = 10170, e.a188 = 10171, e.a189 = 10172, e.a190 = 10173, e.a191 = 10174, e.a89 = 10088, e.a90 = 10089, e.a93 = 10090, e.a94 = 10091, e.a91 = 10092, e.a92 = 10093, e.a205 = 10094, e.a85 = 10095, e.a206 = 10096, e.a86 = 10097, e.a87 = 10098, e.a88 = 10099;
              e.a95 = 10100, e.a96 = 10101, e[".notdef"] = 0;
            });
          t.getGlyphsUnicode = a, t.getDingbatsGlyphsUnicode = o;
        }, function (e, t, r) {
          "use strict";

          function n() {}
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.AnnotationLayer = void 0;
          var i = r(3),
            a = r(0);
          n.prototype = {
            create: function create(e) {
              switch (e.data.annotationType) {
                case a.AnnotationType.LINK:
                  return new s(e);
                case a.AnnotationType.TEXT:
                  return new l(e);
                case a.AnnotationType.WIDGET:
                  switch (e.data.fieldType) {
                    case "Tx":
                      return new u(e);
                    case "Btn":
                      if (e.data.radioButton) return new f(e);
                      if (e.data.checkBox) return new h(e);
                      (0, a.warn)("Unimplemented button widget annotation: pushbutton");
                      break;
                    case "Ch":
                      return new d(e);
                  }
                  return new c(e);
                case a.AnnotationType.POPUP:
                  return new p(e);
                case a.AnnotationType.LINE:
                  return new g(e);
                case a.AnnotationType.HIGHLIGHT:
                  return new v(e);
                case a.AnnotationType.UNDERLINE:
                  return new b(e);
                case a.AnnotationType.SQUIGGLY:
                  return new y(e);
                case a.AnnotationType.STRIKEOUT:
                  return new w(e);
                case a.AnnotationType.FILEATTACHMENT:
                  return new x(e);
                default:
                  return new o(e);
              }
            }
          };
          var o = function () {
              function e(e, t, r) {
                this.isRenderable = t || !1, this.data = e.data, this.layer = e.layer, this.page = e.page, this.viewport = e.viewport, this.linkService = e.linkService, this.downloadManager = e.downloadManager, this.imageResourcesPath = e.imageResourcesPath, this.renderInteractiveForms = e.renderInteractiveForms, t && (this.container = this._createContainer(r));
              }
              return e.prototype = {
                _createContainer: function _createContainer(e) {
                  var t = this.data,
                    r = this.page,
                    n = this.viewport,
                    o = document.createElement("section"),
                    s = t.rect[2] - t.rect[0],
                    l = t.rect[3] - t.rect[1];
                  o.setAttribute("data-annotation-id", t.id);
                  var c = a.Util.normalizeRect([t.rect[0], r.view[3] - t.rect[1] + r.view[1], t.rect[2], r.view[3] - t.rect[3] + r.view[1]]);
                  if (i.CustomStyle.setProp("transform", o, "matrix(" + n.transform.join(",") + ")"), i.CustomStyle.setProp("transformOrigin", o, -c[0] + "px " + -c[1] + "px"), !e && t.borderStyle.width > 0) {
                    o.style.borderWidth = t.borderStyle.width + "px", t.borderStyle.style !== a.AnnotationBorderStyleType.UNDERLINE && (s -= 2 * t.borderStyle.width, l -= 2 * t.borderStyle.width);
                    var u = t.borderStyle.horizontalCornerRadius,
                      h = t.borderStyle.verticalCornerRadius;
                    if (u > 0 || h > 0) {
                      var f = u + "px / " + h + "px";
                      i.CustomStyle.setProp("borderRadius", o, f);
                    }
                    switch (t.borderStyle.style) {
                      case a.AnnotationBorderStyleType.SOLID:
                        o.style.borderStyle = "solid";
                        break;
                      case a.AnnotationBorderStyleType.DASHED:
                        o.style.borderStyle = "dashed";
                        break;
                      case a.AnnotationBorderStyleType.BEVELED:
                        (0, a.warn)("Unimplemented border style: beveled");
                        break;
                      case a.AnnotationBorderStyleType.INSET:
                        (0, a.warn)("Unimplemented border style: inset");
                        break;
                      case a.AnnotationBorderStyleType.UNDERLINE:
                        o.style.borderBottomStyle = "solid";
                    }
                    t.color ? o.style.borderColor = a.Util.makeCssRgb(0 | t.color[0], 0 | t.color[1], 0 | t.color[2]) : o.style.borderWidth = 0;
                  }
                  return o.style.left = c[0] + "px", o.style.top = c[1] + "px", o.style.width = s + "px", o.style.height = l + "px", o;
                },
                _createPopup: function _createPopup(e, t, r) {
                  t || (t = document.createElement("div"), t.style.height = e.style.height, t.style.width = e.style.width, e.appendChild(t));
                  var n = new m({
                      container: e,
                      trigger: t,
                      color: r.color,
                      title: r.title,
                      contents: r.contents,
                      hideWrapper: !0
                    }),
                    i = n.render();
                  i.style.left = e.style.width, e.appendChild(i);
                },
                render: function render() {
                  throw new Error("Abstract method AnnotationElement.render called");
                }
              }, e;
            }(),
            s = function () {
              function e(e) {
                o.call(this, e, !0);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  this.container.className = "linkAnnotation";
                  var e = document.createElement("a");
                  return (0, i.addLinkAttributes)(e, {
                    url: this.data.url,
                    target: this.data.newWindow ? i.LinkTarget.BLANK : void 0
                  }), this.data.url || (this.data.action ? this._bindNamedAction(e, this.data.action) : this._bindLink(e, this.data.dest)), this.container.appendChild(e), this.container;
                },
                _bindLink: function _bindLink(e, t) {
                  var r = this;
                  e.href = this.linkService.getDestinationHash(t), e.onclick = function () {
                    return t && r.linkService.navigateTo(t), !1;
                  }, t && (e.className = "internalLink");
                },
                _bindNamedAction: function _bindNamedAction(e, t) {
                  var r = this;
                  e.href = this.linkService.getAnchorUrl(""), e.onclick = function () {
                    return r.linkService.executeNamedAction(t), !1;
                  }, e.className = "internalLink";
                }
              }), e;
            }(),
            l = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  this.container.className = "textAnnotation";
                  var e = document.createElement("img");
                  return e.style.height = this.container.style.height, e.style.width = this.container.style.width, e.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", e.alt = "[{{type}} Annotation]", e.dataset.l10nId = "text_annotation_type", e.dataset.l10nArgs = JSON.stringify({
                    type: this.data.name
                  }), this.data.hasPopup || this._createPopup(this.container, e, this.data), this.container.appendChild(e), this.container;
                }
              }), e;
            }(),
            c = function () {
              function e(e, t) {
                o.call(this, e, t);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  return this.container;
                }
              }), e;
            }(),
            u = function () {
              function e(e) {
                var t = e.renderInteractiveForms || !e.data.hasAppearance && !!e.data.fieldValue;
                c.call(this, e, t);
              }
              var t = ["left", "center", "right"];
              return a.Util.inherit(e, c, {
                render: function render() {
                  this.container.className = "textWidgetAnnotation";
                  var e = null;
                  if (this.renderInteractiveForms) {
                    if (this.data.multiLine ? (e = document.createElement("textarea"), e.textContent = this.data.fieldValue) : (e = document.createElement("input"), e.type = "text", e.setAttribute("value", this.data.fieldValue)), e.disabled = this.data.readOnly, null !== this.data.maxLen && (e.maxLength = this.data.maxLen), this.data.comb) {
                      var r = this.data.rect[2] - this.data.rect[0],
                        n = r / this.data.maxLen;
                      e.classList.add("comb"), e.style.letterSpacing = "calc(" + n + "px - 1ch)";
                    }
                  } else {
                    e = document.createElement("div"), e.textContent = this.data.fieldValue, e.style.verticalAlign = "middle", e.style.display = "table-cell";
                    var i = null;
                    this.data.fontRefName && (i = this.page.commonObjs.getData(this.data.fontRefName)), this._setTextStyle(e, i);
                  }
                  return null !== this.data.textAlignment && (e.style.textAlign = t[this.data.textAlignment]), this.container.appendChild(e), this.container;
                },
                _setTextStyle: function _setTextStyle(e, t) {
                  var r = e.style;
                  if (r.fontSize = this.data.fontSize + "px", r.direction = this.data.fontDirection < 0 ? "rtl" : "ltr", t) {
                    r.fontWeight = t.black ? t.bold ? "900" : "bold" : t.bold ? "bold" : "normal", r.fontStyle = t.italic ? "italic" : "normal";
                    var n = t.loadedName ? '"' + t.loadedName + '", ' : "",
                      i = t.fallbackName || "Helvetica, sans-serif";
                    r.fontFamily = n + i;
                  }
                }
              }), e;
            }(),
            h = function () {
              function e(e) {
                c.call(this, e, e.renderInteractiveForms);
              }
              return a.Util.inherit(e, c, {
                render: function render() {
                  this.container.className = "buttonWidgetAnnotation checkBox";
                  var e = document.createElement("input");
                  return e.disabled = this.data.readOnly, e.type = "checkbox", this.data.fieldValue && "Off" !== this.data.fieldValue && e.setAttribute("checked", !0), this.container.appendChild(e), this.container;
                }
              }), e;
            }(),
            f = function () {
              function e(e) {
                c.call(this, e, e.renderInteractiveForms);
              }
              return a.Util.inherit(e, c, {
                render: function render() {
                  this.container.className = "buttonWidgetAnnotation radioButton";
                  var e = document.createElement("input");
                  return e.disabled = this.data.readOnly, e.type = "radio", e.name = this.data.fieldName, this.data.fieldValue === this.data.buttonValue && e.setAttribute("checked", !0), this.container.appendChild(e), this.container;
                }
              }), e;
            }(),
            d = function () {
              function e(e) {
                c.call(this, e, e.renderInteractiveForms);
              }
              return a.Util.inherit(e, c, {
                render: function render() {
                  this.container.className = "choiceWidgetAnnotation";
                  var e = document.createElement("select");
                  e.disabled = this.data.readOnly, this.data.combo || (e.size = this.data.options.length, this.data.multiSelect && (e.multiple = !0));
                  for (var t = 0, r = this.data.options.length; t < r; t++) {
                    var n = this.data.options[t],
                      i = document.createElement("option");
                    i.textContent = n.displayValue, i.value = n.exportValue, this.data.fieldValue.indexOf(n.displayValue) >= 0 && i.setAttribute("selected", !0), e.appendChild(i);
                  }
                  return this.container.appendChild(e), this.container;
                }
              }), e;
            }(),
            p = function () {
              function e(e) {
                var t = !(!e.data.title && !e.data.contents);
                o.call(this, e, t);
              }
              var t = ["Line"];
              return a.Util.inherit(e, o, {
                render: function render() {
                  if (this.container.className = "popupAnnotation", t.indexOf(this.data.parentType) >= 0) return this.container;
                  var e = '[data-annotation-id="' + this.data.parentId + '"]',
                    r = this.layer.querySelector(e);
                  if (!r) return this.container;
                  var n = new m({
                      container: this.container,
                      trigger: r,
                      color: this.data.color,
                      title: this.data.title,
                      contents: this.data.contents
                    }),
                    a = parseFloat(r.style.left),
                    o = parseFloat(r.style.width);
                  return i.CustomStyle.setProp("transformOrigin", this.container, -(a + o) + "px -" + r.style.top), this.container.style.left = a + o + "px", this.container.appendChild(n.render()), this.container;
                }
              }), e;
            }(),
            m = function () {
              function e(e) {
                this.container = e.container, this.trigger = e.trigger, this.color = e.color, this.title = e.title, this.contents = e.contents, this.hideWrapper = e.hideWrapper || !1, this.pinned = !1;
              }
              return e.prototype = {
                render: function render() {
                  var e = document.createElement("div");
                  e.className = "popupWrapper", this.hideElement = this.hideWrapper ? e : this.container, this.hideElement.setAttribute("hidden", !0);
                  var t = document.createElement("div");
                  t.className = "popup";
                  var r = this.color;
                  if (r) {
                    var n = .7 * (255 - r[0]) + r[0],
                      i = .7 * (255 - r[1]) + r[1],
                      o = .7 * (255 - r[2]) + r[2];
                    t.style.backgroundColor = a.Util.makeCssRgb(0 | n, 0 | i, 0 | o);
                  }
                  var s = this._formatContents(this.contents),
                    l = document.createElement("h1");
                  return l.textContent = this.title, this.trigger.addEventListener("click", this._toggle.bind(this)), this.trigger.addEventListener("mouseover", this._show.bind(this, !1)), this.trigger.addEventListener("mouseout", this._hide.bind(this, !1)), t.addEventListener("click", this._hide.bind(this, !0)), t.appendChild(l), t.appendChild(s), e.appendChild(t), e;
                },
                _formatContents: function _formatContents(e) {
                  for (var t = document.createElement("p"), r = e.split(/(?:\r\n?|\n)/), n = 0, i = r.length; n < i; ++n) {
                    var a = r[n];
                    t.appendChild(document.createTextNode(a)), n < i - 1 && t.appendChild(document.createElement("br"));
                  }
                  return t;
                },
                _toggle: function _toggle() {
                  this.pinned ? this._hide(!0) : this._show(!0);
                },
                _show: function _show(e) {
                  e && (this.pinned = !0), this.hideElement.hasAttribute("hidden") && (this.hideElement.removeAttribute("hidden"), this.container.style.zIndex += 1);
                },
                _hide: function _hide(e) {
                  e && (this.pinned = !1), this.hideElement.hasAttribute("hidden") || this.pinned || (this.hideElement.setAttribute("hidden", !0), this.container.style.zIndex -= 1);
                }
              }, e;
            }(),
            g = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t, !0);
              }
              var t = "http://www.w3.org/2000/svg";
              return a.Util.inherit(e, o, {
                render: function render() {
                  this.container.className = "lineAnnotation";
                  var e = this.data,
                    r = e.rect[2] - e.rect[0],
                    n = e.rect[3] - e.rect[1],
                    i = document.createElementNS(t, "svg:svg");
                  i.setAttributeNS(null, "version", "1.1"), i.setAttributeNS(null, "width", r + "px"), i.setAttributeNS(null, "height", n + "px"), i.setAttributeNS(null, "preserveAspectRatio", "none"), i.setAttributeNS(null, "viewBox", "0 0 " + r + " " + n);
                  var a = document.createElementNS(t, "svg:line");
                  return a.setAttributeNS(null, "x1", e.rect[2] - e.lineCoordinates[0]), a.setAttributeNS(null, "y1", e.rect[3] - e.lineCoordinates[1]), a.setAttributeNS(null, "x2", e.rect[2] - e.lineCoordinates[2]), a.setAttributeNS(null, "y2", e.rect[3] - e.lineCoordinates[3]), a.setAttributeNS(null, "stroke-width", e.borderStyle.width), a.setAttributeNS(null, "stroke", "transparent"), i.appendChild(a), this.container.append(i), this._createPopup(this.container, a, this.data), this.container;
                }
              }), e;
            }(),
            v = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t, !0);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  return this.container.className = "highlightAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
                }
              }), e;
            }(),
            b = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t, !0);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  return this.container.className = "underlineAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
                }
              }), e;
            }(),
            y = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t, !0);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  return this.container.className = "squigglyAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
                }
              }), e;
            }(),
            w = function () {
              function e(e) {
                var t = !!(e.data.hasPopup || e.data.title || e.data.contents);
                o.call(this, e, t, !0);
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  return this.container.className = "strikeoutAnnotation", this.data.hasPopup || this._createPopup(this.container, null, this.data), this.container;
                }
              }), e;
            }(),
            x = function () {
              function e(e) {
                o.call(this, e, !0);
                var t = this.data.file;
                this.filename = (0, i.getFilenameFromUrl)(t.filename), this.content = t.content, this.linkService.onFileAttachmentAnnotation({
                  id: (0, a.stringToPDFString)(t.filename),
                  filename: t.filename,
                  content: t.content
                });
              }
              return a.Util.inherit(e, o, {
                render: function render() {
                  this.container.className = "fileAttachmentAnnotation";
                  var e = document.createElement("div");
                  return e.style.height = this.container.style.height, e.style.width = this.container.style.width, e.addEventListener("dblclick", this._download.bind(this)), this.data.hasPopup || !this.data.title && !this.data.contents || this._createPopup(this.container, e, this.data), this.container.appendChild(e), this.container;
                },
                _download: function _download() {
                  if (!this.downloadManager) return void (0, a.warn)("Download cannot be started due to unavailable download manager");
                  this.downloadManager.downloadData(this.content, this.filename, "");
                }
              }), e;
            }(),
            _ = function () {
              return {
                render: function render(e) {
                  for (var t = new n(), r = 0, a = e.annotations.length; r < a; r++) {
                    var o = e.annotations[r];
                    if (o) {
                      var s = t.create({
                        data: o,
                        layer: e.div,
                        page: e.page,
                        viewport: e.viewport,
                        linkService: e.linkService,
                        downloadManager: e.downloadManager,
                        imageResourcesPath: e.imageResourcesPath || (0, i.getDefaultSetting)("imageResourcesPath"),
                        renderInteractiveForms: e.renderInteractiveForms || !1
                      });
                      s.isRenderable && e.div.appendChild(s.render());
                    }
                  }
                },
                update: function update(e) {
                  for (var t = 0, r = e.annotations.length; t < r; t++) {
                    var n = e.annotations[t],
                      a = e.div.querySelector('[data-annotation-id="' + n.id + '"]');
                    a && i.CustomStyle.setProp("transform", a, "matrix(" + e.viewport.transform.join(",") + ")");
                  }
                  e.div.removeAttribute("hidden");
                }
              };
            }();
          t.AnnotationLayer = _;
        }, function (e, t, r) {
          "use strict";

          function n(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          function i(e, t, r, n) {
            var i = new b();
            arguments.length > 1 && (0, u.deprecated)("getDocument is called with pdfDataRangeTransport, passwordCallback or progressCallback argument"), t && (t instanceof y || (t = Object.create(t), t.length = e.length, t.initialData = e.initialData, t.abort || (t.abort = function () {})), e = Object.create(e), e.range = t), i.onPassword = r || null, i.onProgress = n || null;
            var o;
            "string" == typeof e ? o = {
              url: e
            } : (0, u.isArrayBuffer)(e) ? o = {
              data: e
            } : e instanceof y ? o = {
              range: e
            } : ("object" !== (void 0 === e ? "undefined" : c(e)) && (0, u.error)("Invalid parameter in getDocument, need either Uint8Array, string or a parameter object"), e.url || e.data || e.range || (0, u.error)("Invalid parameter object: need either .data, .range or .url"), o = e);
            var s = {},
              l = null,
              f = null;
            for (var d in o) if ("url" !== d || "undefined" == typeof window) {
              if ("range" !== d) {
                if ("worker" !== d) {
                  if ("data" !== d || o[d] instanceof Uint8Array) s[d] = o[d];else {
                    var p = o[d];
                    "string" == typeof p ? s[d] = (0, u.stringToBytes)(p) : "object" !== (void 0 === p ? "undefined" : c(p)) || null === p || isNaN(p.length) ? (0, u.isArrayBuffer)(p) ? s[d] = new Uint8Array(p) : (0, u.error)("Invalid PDF binary data: either typed array, string or array-like object is expected in the data property.") : s[d] = new Uint8Array(p);
                  }
                } else f = o[d];
              } else l = o[d];
            } else s[d] = new URL(o[d], window.location).href;
            s.rangeChunkSize = s.rangeChunkSize || m, s.ignoreErrors = !0 !== s.stopAtErrors;
            var g = s.CMapReaderFactory || h.DOMCMapReaderFactory;
            if (void 0 !== s.disableNativeImageDecoder && (0, u.deprecated)("parameter disableNativeImageDecoder, use nativeImageDecoderSupport instead"), s.nativeImageDecoderSupport = s.nativeImageDecoderSupport || (!0 === s.disableNativeImageDecoder ? u.NativeImageDecoding.NONE : u.NativeImageDecoding.DECODE), s.nativeImageDecoderSupport !== u.NativeImageDecoding.DECODE && s.nativeImageDecoderSupport !== u.NativeImageDecoding.NONE && s.nativeImageDecoderSupport !== u.NativeImageDecoding.DISPLAY && ((0, u.warn)("Invalid parameter nativeImageDecoderSupport: need a state of enum {NativeImageDecoding}"), s.nativeImageDecoderSupport = u.NativeImageDecoding.DECODE), !f) {
              var v = (0, h.getDefaultSetting)("workerPort");
              f = v ? new S(null, v) : new S(), i._worker = f;
            }
            var w = i.docId;
            return f.promise.then(function () {
              if (i.destroyed) throw new Error("Loading aborted");
              return a(f, s, l, w).then(function (e) {
                if (i.destroyed) throw new Error("Loading aborted");
                var t = new u.MessageHandler(w, e, f.port),
                  r = new C(t, i, l, g);
                i._transport = r, t.send("Ready", null);
              });
            }).catch(i._capability.reject), i;
          }
          function a(e, t, r, n) {
            return e.destroyed ? Promise.reject(new Error("Worker was destroyed")) : (t.disableAutoFetch = (0, h.getDefaultSetting)("disableAutoFetch"), t.disableStream = (0, h.getDefaultSetting)("disableStream"), t.chunkedViewerLoading = !!r, r && (t.length = r.length, t.initialData = r.initialData), e.messageHandler.sendWithPromise("GetDocRequest", {
              docId: n,
              source: t,
              disableRange: (0, h.getDefaultSetting)("disableRange"),
              maxImageSize: (0, h.getDefaultSetting)("maxImageSize"),
              disableFontFace: (0, h.getDefaultSetting)("disableFontFace"),
              disableCreateObjectURL: (0, h.getDefaultSetting)("disableCreateObjectURL"),
              postMessageTransfers: (0, h.getDefaultSetting)("postMessageTransfers") && !v,
              docBaseUrl: t.docBaseUrl,
              nativeImageDecoderSupport: t.nativeImageDecoderSupport,
              ignoreErrors: t.ignoreErrors
            }).then(function (t) {
              if (e.destroyed) throw new Error("Worker was destroyed");
              return t;
            }));
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.build = t.version = t._UnsupportedManager = t.PDFPageProxy = t.PDFDocumentProxy = t.PDFWorker = t.PDFDataRangeTransport = t.LoopbackPort = t.getDocument = void 0;
          var o,
            s,
            l = function () {
              function e(e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r];
                  n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
              }
              return function (t, r, n) {
                return r && e(t.prototype, r), n && e(t, n), t;
              };
            }(),
            c = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            u = r(0),
            h = r(3),
            f = r(45),
            d = r(44),
            p = r(24),
            m = 65536,
            g = !1,
            v = !1,
            b = ("undefined" != typeof document && document.currentScript && document.currentScript.src, function () {
              function e() {
                this._capability = (0, u.createPromiseCapability)(), this._transport = null, this._worker = null, this.docId = "d" + t++, this.destroyed = !1, this.onPassword = null, this.onProgress = null, this.onUnsupportedFeature = null;
              }
              var t = 0;
              return e.prototype = {
                get promise() {
                  return this._capability.promise;
                },
                destroy: function destroy() {
                  var e = this;
                  return this.destroyed = !0, (this._transport ? this._transport.destroy() : Promise.resolve()).then(function () {
                    e._transport = null, e._worker && (e._worker.destroy(), e._worker = null);
                  });
                },
                then: function then(e, t) {
                  return this.promise.then.apply(this.promise, arguments);
                }
              }, e;
            }()),
            y = function () {
              function e(e, t) {
                this.length = e, this.initialData = t, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._readyCapability = (0, u.createPromiseCapability)();
              }
              return e.prototype = {
                addRangeListener: function addRangeListener(e) {
                  this._rangeListeners.push(e);
                },
                addProgressListener: function addProgressListener(e) {
                  this._progressListeners.push(e);
                },
                addProgressiveReadListener: function addProgressiveReadListener(e) {
                  this._progressiveReadListeners.push(e);
                },
                onDataRange: function onDataRange(e, t) {
                  for (var r = this._rangeListeners, n = 0, i = r.length; n < i; ++n) r[n](e, t);
                },
                onDataProgress: function onDataProgress(e) {
                  var t = this;
                  this._readyCapability.promise.then(function () {
                    for (var r = t._progressListeners, n = 0, i = r.length; n < i; ++n) r[n](e);
                  });
                },
                onDataProgressiveRead: function onDataProgressiveRead(e) {
                  var t = this;
                  this._readyCapability.promise.then(function () {
                    for (var r = t._progressiveReadListeners, n = 0, i = r.length; n < i; ++n) r[n](e);
                  });
                },
                transportReady: function transportReady() {
                  this._readyCapability.resolve();
                },
                requestDataRange: function requestDataRange(e, t) {
                  throw new Error("Abstract method PDFDataRangeTransport.requestDataRange");
                },
                abort: function abort() {}
              }, e;
            }(),
            w = function () {
              function e(e, t, r) {
                this.pdfInfo = e, this.transport = t, this.loadingTask = r;
              }
              return e.prototype = {
                get numPages() {
                  return this.pdfInfo.numPages;
                },
                get fingerprint() {
                  return this.pdfInfo.fingerprint;
                },
                getPage: function getPage(e) {
                  return this.transport.getPage(e);
                },
                getPageIndex: function getPageIndex(e) {
                  return this.transport.getPageIndex(e);
                },
                getDestinations: function getDestinations() {
                  return this.transport.getDestinations();
                },
                getDestination: function getDestination(e) {
                  return this.transport.getDestination(e);
                },
                getPageLabels: function getPageLabels() {
                  return this.transport.getPageLabels();
                },
                getAttachments: function getAttachments() {
                  return this.transport.getAttachments();
                },
                getJavaScript: function getJavaScript() {
                  return this.transport.getJavaScript();
                },
                getOutline: function getOutline() {
                  return this.transport.getOutline();
                },
                getMetadata: function getMetadata() {
                  return this.transport.getMetadata();
                },
                getData: function getData() {
                  return this.transport.getData();
                },
                getDownloadInfo: function getDownloadInfo() {
                  return this.transport.downloadInfoCapability.promise;
                },
                getStats: function getStats() {
                  return this.transport.getStats();
                },
                cleanup: function cleanup() {
                  this.transport.startCleanup();
                },
                destroy: function destroy() {
                  return this.loadingTask.destroy();
                }
              }, e;
            }(),
            x = function () {
              function e(e, t, r) {
                this.pageIndex = e, this.pageInfo = t, this.transport = r, this.stats = new u.StatTimer(), this.stats.enabled = (0, h.getDefaultSetting)("enableStats"), this.commonObjs = r.commonObjs, this.objs = new E(), this.cleanupAfterRender = !1, this.pendingCleanup = !1, this.intentStates = Object.create(null), this.destroyed = !1;
              }
              return e.prototype = {
                get pageNumber() {
                  return this.pageIndex + 1;
                },
                get rotate() {
                  return this.pageInfo.rotate;
                },
                get ref() {
                  return this.pageInfo.ref;
                },
                get userUnit() {
                  return this.pageInfo.userUnit;
                },
                get view() {
                  return this.pageInfo.view;
                },
                getViewport: function getViewport(e, t) {
                  return arguments.length < 2 && (t = this.rotate), new u.PageViewport(this.view, e, t, 0, 0);
                },
                getAnnotations: function getAnnotations(e) {
                  var t = e && e.intent || null;
                  return this.annotationsPromise && this.annotationsIntent === t || (this.annotationsPromise = this.transport.getAnnotations(this.pageIndex, t), this.annotationsIntent = t), this.annotationsPromise;
                },
                render: function render(e) {
                  var t = this,
                    r = this.stats;
                  r.time("Overall"), this.pendingCleanup = !1;
                  var n = "print" === e.intent ? "print" : "display",
                    i = e.canvasFactory || new h.DOMCanvasFactory();
                  this.intentStates[n] || (this.intentStates[n] = Object.create(null));
                  var a = this.intentStates[n];
                  a.displayReadyCapability || (a.receivingOperatorList = !0, a.displayReadyCapability = (0, u.createPromiseCapability)(), a.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: !1
                  }, this.stats.time("Page Request"), this.transport.messageHandler.send("RenderPageRequest", {
                    pageIndex: this.pageNumber - 1,
                    intent: n,
                    renderInteractiveForms: !0 === e.renderInteractiveForms
                  }));
                  var o = function o(e) {
                      var n = a.renderTasks.indexOf(s);
                      n >= 0 && a.renderTasks.splice(n, 1), t.cleanupAfterRender && (t.pendingCleanup = !0), t._tryCleanup(), e ? s.capability.reject(e) : s.capability.resolve(), r.timeEnd("Rendering"), r.timeEnd("Overall");
                    },
                    s = new T(o, e, this.objs, this.commonObjs, a.operatorList, this.pageNumber, i);
                  s.useRequestAnimationFrame = "print" !== n, a.renderTasks || (a.renderTasks = []), a.renderTasks.push(s);
                  var l = s.task;
                  return e.continueCallback && ((0, u.deprecated)("render is used with continueCallback parameter"), l.onContinue = e.continueCallback), a.displayReadyCapability.promise.then(function (e) {
                    if (t.pendingCleanup) return void o();
                    r.time("Rendering"), s.initializeGraphics(e), s.operatorListChanged();
                  }, o), l;
                },
                getOperatorList: function getOperatorList() {
                  function e() {
                    if (r.operatorList.lastChunk) {
                      r.opListReadCapability.resolve(r.operatorList);
                      var e = r.renderTasks.indexOf(t);
                      e >= 0 && r.renderTasks.splice(e, 1);
                    }
                  }
                  this.intentStates.oplist || (this.intentStates.oplist = Object.create(null));
                  var t,
                    r = this.intentStates.oplist;
                  return r.opListReadCapability || (t = {}, t.operatorListChanged = e, r.receivingOperatorList = !0, r.opListReadCapability = (0, u.createPromiseCapability)(), r.renderTasks = [], r.renderTasks.push(t), r.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: !1
                  }, this.transport.messageHandler.send("RenderPageRequest", {
                    pageIndex: this.pageIndex,
                    intent: "oplist"
                  })), r.opListReadCapability.promise;
                },
                getTextContent: function getTextContent(e) {
                  return e = e || {}, this.transport.messageHandler.sendWithPromise("GetTextContent", {
                    pageIndex: this.pageNumber - 1,
                    normalizeWhitespace: !0 === e.normalizeWhitespace,
                    combineTextItems: !0 !== e.disableCombineTextItems
                  });
                },
                _destroy: function _destroy() {
                  this.destroyed = !0, this.transport.pageCache[this.pageIndex] = null;
                  var e = [];
                  return Object.keys(this.intentStates).forEach(function (t) {
                    if ("oplist" !== t) {
                      this.intentStates[t].renderTasks.forEach(function (t) {
                        var r = t.capability.promise.catch(function () {});
                        e.push(r), t.cancel();
                      });
                    }
                  }, this), this.objs.clear(), this.annotationsPromise = null, this.pendingCleanup = !1, Promise.all(e);
                },
                destroy: function destroy() {
                  (0, u.deprecated)("page destroy method, use cleanup() instead"), this.cleanup();
                },
                cleanup: function cleanup() {
                  this.pendingCleanup = !0, this._tryCleanup();
                },
                _tryCleanup: function _tryCleanup() {
                  this.pendingCleanup && !Object.keys(this.intentStates).some(function (e) {
                    var t = this.intentStates[e];
                    return 0 !== t.renderTasks.length || t.receivingOperatorList;
                  }, this) && (Object.keys(this.intentStates).forEach(function (e) {
                    delete this.intentStates[e];
                  }, this), this.objs.clear(), this.annotationsPromise = null, this.pendingCleanup = !1);
                },
                _startRenderPage: function _startRenderPage(e, t) {
                  var r = this.intentStates[t];
                  r.displayReadyCapability && r.displayReadyCapability.resolve(e);
                },
                _renderPageChunk: function _renderPageChunk(e, t) {
                  var r,
                    n,
                    i = this.intentStates[t];
                  for (r = 0, n = e.length; r < n; r++) i.operatorList.fnArray.push(e.fnArray[r]), i.operatorList.argsArray.push(e.argsArray[r]);
                  for (i.operatorList.lastChunk = e.lastChunk, r = 0; r < i.renderTasks.length; r++) i.renderTasks[r].operatorListChanged();
                  e.lastChunk && (i.receivingOperatorList = !1, this._tryCleanup());
                }
              }, e;
            }(),
            _ = function () {
              function e(t) {
                n(this, e), this._listeners = [], this._defer = t, this._deferred = Promise.resolve(void 0);
              }
              return l(e, [{
                key: "postMessage",
                value: function value(e, t) {
                  function r(e) {
                    if ("object" !== (void 0 === e ? "undefined" : c(e)) || null === e) return e;
                    if (i.has(e)) return i.get(e);
                    var n, a;
                    if ((a = e.buffer) && (0, u.isArrayBuffer)(a)) {
                      var o = t && t.indexOf(a) >= 0;
                      return n = e === a ? e : o ? new e.constructor(a, e.byteOffset, e.byteLength) : new e.constructor(e), i.set(e, n), n;
                    }
                    n = (0, u.isArray)(e) ? [] : {}, i.set(e, n);
                    for (var s in e) {
                      for (var l, h = e; !(l = Object.getOwnPropertyDescriptor(h, s));) h = Object.getPrototypeOf(h);
                      void 0 !== l.value && "function" != typeof l.value && (n[s] = r(l.value));
                    }
                    return n;
                  }
                  var n = this;
                  if (!this._defer) return void this._listeners.forEach(function (t) {
                    t.call(this, {
                      data: e
                    });
                  }, this);
                  var i = new WeakMap(),
                    a = {
                      data: r(e)
                    };
                  this._deferred.then(function () {
                    n._listeners.forEach(function (e) {
                      e.call(this, a);
                    }, n);
                  });
                }
              }, {
                key: "addEventListener",
                value: function value(e, t) {
                  this._listeners.push(t);
                }
              }, {
                key: "removeEventListener",
                value: function value(e, t) {
                  var r = this._listeners.indexOf(t);
                  this._listeners.splice(r, 1);
                }
              }, {
                key: "terminate",
                value: function value() {
                  this._listeners = [];
                }
              }]), e;
            }(),
            S = function () {
              function e() {
                var e;
                if (n) return n.promise;
                n = (0, u.createPromiseCapability)();
                var t = r(23);
                return r(39), e = t.WorkerMessageHandler, n.resolve(e), n.promise;
              }
              function t(e, t) {
                if (this.name = e, this.destroyed = !1, this._readyCapability = (0, u.createPromiseCapability)(), this._port = null, this._webWorker = null, this._messageHandler = null, t) return void this._initializeFromPort(t);
                this._initialize();
              }
              var n,
                i = 0;
              return t.prototype = {
                get promise() {
                  return this._readyCapability.promise;
                },
                get port() {
                  return this._port;
                },
                get messageHandler() {
                  return this._messageHandler;
                },
                _initializeFromPort: function _initializeFromPort(e) {
                  this._port = e, this._messageHandler = new u.MessageHandler("main", "worker", e), this._messageHandler.on("ready", function () {}), this._readyCapability.resolve();
                },
                _initialize: function _initialize() {
                  this._setupFakeWorker();
                },
                _setupFakeWorker: function _setupFakeWorker() {
                  var t = this;
                  g || (0, h.getDefaultSetting)("disableWorker") || ((0, u.warn)("Setting up fake worker."), g = !0), e().then(function (e) {
                    if (t.destroyed) return void t._readyCapability.reject(new Error("Worker was destroyed"));
                    var r = Uint8Array !== Float32Array,
                      n = new _(r);
                    t._port = n;
                    var a = "fake" + i++,
                      o = new u.MessageHandler(a + "_worker", a, n);
                    e.setup(o, n);
                    var s = new u.MessageHandler(a, a + "_worker", n);
                    t._messageHandler = s, t._readyCapability.resolve();
                  });
                },
                destroy: function destroy() {
                  this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
                }
              }, t;
            }(),
            C = function () {
              function e(e, t, r, n) {
                this.messageHandler = e, this.loadingTask = t, this.pdfDataRangeTransport = r, this.commonObjs = new E(), this.fontLoader = new f.FontLoader(t.docId), this.CMapReaderFactory = new n({
                  baseUrl: (0, h.getDefaultSetting)("cMapUrl"),
                  isCompressed: (0, h.getDefaultSetting)("cMapPacked")
                }), this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this.pageCache = [], this.pagePromises = [], this.downloadInfoCapability = (0, u.createPromiseCapability)(), this.setupMessageHandler();
              }
              return e.prototype = {
                destroy: function destroy() {
                  var e = this;
                  if (this.destroyCapability) return this.destroyCapability.promise;
                  this.destroyed = !0, this.destroyCapability = (0, u.createPromiseCapability)(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                  var t = [];
                  this.pageCache.forEach(function (e) {
                    e && t.push(e._destroy());
                  }), this.pageCache = [], this.pagePromises = [];
                  var r = this.messageHandler.sendWithPromise("Terminate", null);
                  return t.push(r), Promise.all(t).then(function () {
                    e.fontLoader.clear(), e.pdfDataRangeTransport && (e.pdfDataRangeTransport.abort(), e.pdfDataRangeTransport = null), e.messageHandler && (e.messageHandler.destroy(), e.messageHandler = null), e.destroyCapability.resolve();
                  }, this.destroyCapability.reject), this.destroyCapability.promise;
                },
                setupMessageHandler: function setupMessageHandler() {
                  var e = this.messageHandler,
                    t = this.loadingTask,
                    r = this.pdfDataRangeTransport;
                  r && (r.addRangeListener(function (t, r) {
                    e.send("OnDataRange", {
                      begin: t,
                      chunk: r
                    });
                  }), r.addProgressListener(function (t) {
                    e.send("OnDataProgress", {
                      loaded: t
                    });
                  }), r.addProgressiveReadListener(function (t) {
                    e.send("OnDataRange", {
                      chunk: t
                    });
                  }), e.on("RequestDataRange", function (e) {
                    r.requestDataRange(e.begin, e.end);
                  }, this)), e.on("GetDoc", function (e) {
                    var t = e.pdfInfo;
                    this.numPages = e.pdfInfo.numPages;
                    var r = this.loadingTask,
                      n = new w(t, this, r);
                    this.pdfDocument = n, r._capability.resolve(n);
                  }, this), e.on("PasswordRequest", function (e) {
                    var r = this;
                    if (this._passwordCapability = (0, u.createPromiseCapability)(), t.onPassword) {
                      var n = function n(e) {
                        r._passwordCapability.resolve({
                          password: e
                        });
                      };
                      t.onPassword(n, e.code);
                    } else this._passwordCapability.reject(new u.PasswordException(e.message, e.code));
                    return this._passwordCapability.promise;
                  }, this), e.on("PasswordException", function (e) {
                    t._capability.reject(new u.PasswordException(e.message, e.code));
                  }, this), e.on("InvalidPDF", function (e) {
                    this.loadingTask._capability.reject(new u.InvalidPDFException(e.message));
                  }, this), e.on("MissingPDF", function (e) {
                    this.loadingTask._capability.reject(new u.MissingPDFException(e.message));
                  }, this), e.on("UnexpectedResponse", function (e) {
                    this.loadingTask._capability.reject(new u.UnexpectedResponseException(e.message, e.status));
                  }, this), e.on("UnknownError", function (e) {
                    this.loadingTask._capability.reject(new u.UnknownErrorException(e.message, e.details));
                  }, this), e.on("DataLoaded", function (e) {
                    this.downloadInfoCapability.resolve(e);
                  }, this), e.on("PDFManagerReady", function (e) {
                    this.pdfDataRangeTransport && this.pdfDataRangeTransport.transportReady();
                  }, this), e.on("StartRenderPage", function (e) {
                    if (!this.destroyed) {
                      var t = this.pageCache[e.pageIndex];
                      t.stats.timeEnd("Page Request"), t._startRenderPage(e.transparency, e.intent);
                    }
                  }, this), e.on("RenderPageChunk", function (e) {
                    if (!this.destroyed) {
                      this.pageCache[e.pageIndex]._renderPageChunk(e.operatorList, e.intent);
                    }
                  }, this), e.on("commonobj", function (e) {
                    var t = this;
                    if (!this.destroyed) {
                      var r = e[0],
                        n = e[1];
                      if (!this.commonObjs.hasData(r)) switch (n) {
                        case "Font":
                          var i = e[2];
                          if ("error" in i) {
                            var a = i.error;
                            (0, u.warn)("Error during font loading: " + a), this.commonObjs.resolve(r, a);
                            break;
                          }
                          var o = null;
                          (0, h.getDefaultSetting)("pdfBug") && u.globalScope.FontInspector && u.globalScope.FontInspector.enabled && (o = {
                            registerFont: function registerFont(e, t) {
                              u.globalScope.FontInspector.fontAdded(e, t);
                            }
                          });
                          var s = new f.FontFaceObject(i, {
                              isEvalSuported: (0, h.getDefaultSetting)("isEvalSupported"),
                              disableFontFace: (0, h.getDefaultSetting)("disableFontFace"),
                              fontRegistry: o
                            }),
                            l = function l(e) {
                              t.commonObjs.resolve(r, s);
                            };
                          this.fontLoader.bind([s], l);
                          break;
                        case "FontPath":
                          this.commonObjs.resolve(r, e[2]);
                          break;
                        default:
                          (0, u.error)("Got unknown common object type " + n);
                      }
                    }
                  }, this), e.on("obj", function (e) {
                    if (!this.destroyed) {
                      var t,
                        r = e[0],
                        n = e[1],
                        i = e[2],
                        a = this.pageCache[n];
                      if (!a.objs.hasData(r)) switch (i) {
                        case "JpegStream":
                          t = e[3], (0, u.loadJpegStream)(r, t, a.objs);
                          break;
                        case "Image":
                          t = e[3], a.objs.resolve(r, t);
                          t && "data" in t && t.data.length > 8e6 && (a.cleanupAfterRender = !0);
                          break;
                        default:
                          (0, u.error)("Got unknown object type " + i);
                      }
                    }
                  }, this), e.on("DocProgress", function (e) {
                    if (!this.destroyed) {
                      var t = this.loadingTask;
                      t.onProgress && t.onProgress({
                        loaded: e.loaded,
                        total: e.total
                      });
                    }
                  }, this), e.on("PageError", function (e) {
                    if (!this.destroyed) {
                      var t = this.pageCache[e.pageNum - 1],
                        r = t.intentStates[e.intent];
                      if (r.displayReadyCapability ? r.displayReadyCapability.reject(e.error) : (0, u.error)(e.error), r.operatorList) {
                        r.operatorList.lastChunk = !0;
                        for (var n = 0; n < r.renderTasks.length; n++) r.renderTasks[n].operatorListChanged();
                      }
                    }
                  }, this), e.on("UnsupportedFeature", function (e) {
                    if (!this.destroyed) {
                      var t = e.featureId,
                        r = this.loadingTask;
                      r.onUnsupportedFeature && r.onUnsupportedFeature(t), k.notify(t);
                    }
                  }, this), e.on("JpegDecode", function (e) {
                    if (this.destroyed) return Promise.reject(new Error("Worker was destroyed"));
                    if ("undefined" == typeof document) return Promise.reject(new Error('"document" is not defined.'));
                    var t = e[0],
                      r = e[1];
                    return 3 !== r && 1 !== r ? Promise.reject(new Error("Only 3 components or 1 component can be returned")) : new Promise(function (e, n) {
                      var i = new Image();
                      i.onload = function () {
                        var t = i.width,
                          n = i.height,
                          a = t * n,
                          o = 4 * a,
                          s = new Uint8Array(a * r),
                          l = document.createElement("canvas");
                        l.width = t, l.height = n;
                        var c = l.getContext("2d");
                        c.drawImage(i, 0, 0);
                        var u,
                          h,
                          f = c.getImageData(0, 0, t, n).data;
                        if (3 === r) for (u = 0, h = 0; u < o; u += 4, h += 3) s[h] = f[u], s[h + 1] = f[u + 1], s[h + 2] = f[u + 2];else if (1 === r) for (u = 0, h = 0; u < o; u += 4, h++) s[h] = f[u];
                        e({
                          data: s,
                          width: t,
                          height: n
                        });
                      }, i.onerror = function () {
                        n(new Error("JpegDecode failed to load image"));
                      }, i.src = t;
                    });
                  }, this), e.on("FetchBuiltInCMap", function (e) {
                    return this.destroyed ? Promise.reject(new Error("Worker was destroyed")) : this.CMapReaderFactory.fetch({
                      name: e.name
                    });
                  }, this);
                },
                getData: function getData() {
                  return this.messageHandler.sendWithPromise("GetData", null);
                },
                getPage: function getPage(e, t) {
                  var r = this;
                  if (!(0, u.isInt)(e) || e <= 0 || e > this.numPages) return Promise.reject(new Error("Invalid page request"));
                  var n = e - 1;
                  if (n in this.pagePromises) return this.pagePromises[n];
                  var i = this.messageHandler.sendWithPromise("GetPage", {
                    pageIndex: n
                  }).then(function (e) {
                    if (r.destroyed) throw new Error("Transport destroyed");
                    var t = new x(n, e, r);
                    return r.pageCache[n] = t, t;
                  });
                  return this.pagePromises[n] = i, i;
                },
                getPageIndex: function getPageIndex(e) {
                  return this.messageHandler.sendWithPromise("GetPageIndex", {
                    ref: e
                  }).catch(function (e) {
                    return Promise.reject(new Error(e));
                  });
                },
                getAnnotations: function getAnnotations(e, t) {
                  return this.messageHandler.sendWithPromise("GetAnnotations", {
                    pageIndex: e,
                    intent: t
                  });
                },
                getDestinations: function getDestinations() {
                  return this.messageHandler.sendWithPromise("GetDestinations", null);
                },
                getDestination: function getDestination(e) {
                  return this.messageHandler.sendWithPromise("GetDestination", {
                    id: e
                  });
                },
                getPageLabels: function getPageLabels() {
                  return this.messageHandler.sendWithPromise("GetPageLabels", null);
                },
                getAttachments: function getAttachments() {
                  return this.messageHandler.sendWithPromise("GetAttachments", null);
                },
                getJavaScript: function getJavaScript() {
                  return this.messageHandler.sendWithPromise("GetJavaScript", null);
                },
                getOutline: function getOutline() {
                  return this.messageHandler.sendWithPromise("GetOutline", null);
                },
                getMetadata: function getMetadata() {
                  return this.messageHandler.sendWithPromise("GetMetadata", null).then(function (e) {
                    return {
                      info: e[0],
                      metadata: e[1] ? new p.Metadata(e[1]) : null
                    };
                  });
                },
                getStats: function getStats() {
                  return this.messageHandler.sendWithPromise("GetStats", null);
                },
                startCleanup: function startCleanup() {
                  var e = this;
                  this.messageHandler.sendWithPromise("Cleanup", null).then(function () {
                    for (var t = 0, r = e.pageCache.length; t < r; t++) {
                      var n = e.pageCache[t];
                      n && n.cleanup();
                    }
                    e.commonObjs.clear(), e.fontLoader.clear();
                  });
                }
              }, e;
            }(),
            E = function () {
              function e() {
                this.objs = Object.create(null);
              }
              return e.prototype = {
                ensureObj: function ensureObj(e) {
                  if (this.objs[e]) return this.objs[e];
                  var t = {
                    capability: (0, u.createPromiseCapability)(),
                    data: null,
                    resolved: !1
                  };
                  return this.objs[e] = t, t;
                },
                get: function get(e, t) {
                  if (t) return this.ensureObj(e).capability.promise.then(t), null;
                  var r = this.objs[e];
                  return r && r.resolved || (0, u.error)("Requesting object that isn't resolved yet " + e), r.data;
                },
                resolve: function resolve(e, t) {
                  var r = this.ensureObj(e);
                  r.resolved = !0, r.data = t, r.capability.resolve(t);
                },
                isResolved: function isResolved(e) {
                  var t = this.objs;
                  return !!t[e] && t[e].resolved;
                },
                hasData: function hasData(e) {
                  return this.isResolved(e);
                },
                getData: function getData(e) {
                  var t = this.objs;
                  return t[e] && t[e].resolved ? t[e].data : null;
                },
                clear: function clear() {
                  this.objs = Object.create(null);
                }
              }, e;
            }(),
            A = function () {
              function e(e) {
                this._internalRenderTask = e, this.onContinue = null;
              }
              return e.prototype = {
                get promise() {
                  return this._internalRenderTask.capability.promise;
                },
                cancel: function cancel() {
                  this._internalRenderTask.cancel();
                },
                then: function then(e, t) {
                  return this.promise.then.apply(this.promise, arguments);
                }
              }, e;
            }(),
            T = function () {
              function e(e, t, r, n, i, a, o) {
                this.callback = e, this.params = t, this.objs = r, this.commonObjs = n, this.operatorListIdx = null, this.operatorList = i, this.pageNumber = a, this.canvasFactory = o, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this.useRequestAnimationFrame = !1, this.cancelled = !1, this.capability = (0, u.createPromiseCapability)(), this.task = new A(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this);
              }
              return e.prototype = {
                initializeGraphics: function initializeGraphics(e) {
                  if (!this.cancelled) {
                    (0, h.getDefaultSetting)("pdfBug") && u.globalScope.StepperManager && u.globalScope.StepperManager.enabled && (this.stepper = u.globalScope.StepperManager.create(this.pageNumber - 1), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
                    var t = this.params;
                    this.gfx = new d.CanvasGraphics(t.canvasContext, this.commonObjs, this.objs, this.canvasFactory, t.imageLayer), this.gfx.beginDrawing(t.transform, t.viewport, e), this.operatorListIdx = 0, this.graphicsReady = !0, this.graphicsReadyCallback && this.graphicsReadyCallback();
                  }
                },
                cancel: function cancel() {
                  this.running = !1, this.cancelled = !0, (0, h.getDefaultSetting)("pdfjsNext") ? this.callback(new h.RenderingCancelledException("Rendering cancelled, page " + this.pageNumber, "canvas")) : this.callback("cancelled");
                },
                operatorListChanged: function operatorListChanged() {
                  if (!this.graphicsReady) return void (this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound));
                  this.stepper && this.stepper.updateOperatorList(this.operatorList), this.running || this._continue();
                },
                _continue: function _continue() {
                  this.running = !0, this.cancelled || (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
                },
                _scheduleNext: function _scheduleNext() {
                  this.useRequestAnimationFrame && "undefined" != typeof window ? window.requestAnimationFrame(this._nextBound) : Promise.resolve(void 0).then(this._nextBound);
                },
                _next: function _next() {
                  this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(), this.callback())));
                }
              }, e;
            }(),
            k = function () {
              var e = [];
              return {
                listen: function listen(t) {
                  (0, u.deprecated)("Global UnsupportedManager.listen is used:  use PDFDocumentLoadingTask.onUnsupportedFeature instead"), e.push(t);
                },
                notify: function notify(t) {
                  for (var r = 0, n = e.length; r < n; r++) e[r](t);
                }
              };
            }();
          t.version = o = "1.8.357", t.build = s = "ca3cf6e7", t.getDocument = i, t.LoopbackPort = _, t.PDFDataRangeTransport = y, t.PDFWorker = S, t.PDFDocumentProxy = w, t.PDFPageProxy = x, t._UnsupportedManager = k, t.version = o, t.build = s;
        }, function (e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.SVGGraphics = void 0;
          var n = r(0),
            i = function i() {
              throw new Error("Not implemented: SVGGraphics");
            },
            a = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            },
            o = function () {
              function e(e, t, r) {
                for (var n = -1, i = t; i < r; i++) {
                  var a = 255 & (n ^ e[i]);
                  n = n >>> 8 ^ s[a];
                }
                return -1 ^ n;
              }
              function t(t, r, n, i) {
                var a = i,
                  o = r.length;
                n[a] = o >> 24 & 255, n[a + 1] = o >> 16 & 255, n[a + 2] = o >> 8 & 255, n[a + 3] = 255 & o, a += 4, n[a] = 255 & t.charCodeAt(0), n[a + 1] = 255 & t.charCodeAt(1), n[a + 2] = 255 & t.charCodeAt(2), n[a + 3] = 255 & t.charCodeAt(3), a += 4, n.set(r, a), a += r.length;
                var s = e(n, i + 4, a);
                n[a] = s >> 24 & 255, n[a + 1] = s >> 16 & 255, n[a + 2] = s >> 8 & 255, n[a + 3] = 255 & s;
              }
              function r(e, t, r) {
                for (var n = 1, i = 0, a = t; a < r; ++a) n = (n + (255 & e[a])) % 65521, i = (i + n) % 65521;
                return i << 16 | n;
              }
              function i(e, i, s) {
                var l,
                  c,
                  u,
                  h = e.width,
                  f = e.height,
                  d = e.data;
                switch (i) {
                  case n.ImageKind.GRAYSCALE_1BPP:
                    c = 0, l = 1, u = h + 7 >> 3;
                    break;
                  case n.ImageKind.RGB_24BPP:
                    c = 2, l = 8, u = 3 * h;
                    break;
                  case n.ImageKind.RGBA_32BPP:
                    c = 6, l = 8, u = 4 * h;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                var p,
                  m,
                  g = new Uint8Array((1 + u) * f),
                  v = 0,
                  b = 0;
                for (p = 0; p < f; ++p) g[v++] = 0, g.set(d.subarray(b, b + u), v), b += u, v += u;
                if (i === n.ImageKind.GRAYSCALE_1BPP) for (v = 0, p = 0; p < f; p++) for (v++, m = 0; m < u; m++) g[v++] ^= 255;
                var y = new Uint8Array([h >> 24 & 255, h >> 16 & 255, h >> 8 & 255, 255 & h, f >> 24 & 255, f >> 16 & 255, f >> 8 & 255, 255 & f, l, c, 0, 0, 0]),
                  w = g.length,
                  x = Math.ceil(w / 65535),
                  _ = new Uint8Array(2 + w + 5 * x + 4),
                  S = 0;
                _[S++] = 120, _[S++] = 156;
                for (var C = 0; w > 65535;) _[S++] = 0, _[S++] = 255, _[S++] = 255, _[S++] = 0, _[S++] = 0, _.set(g.subarray(C, C + 65535), S), S += 65535, C += 65535, w -= 65535;
                _[S++] = 1, _[S++] = 255 & w, _[S++] = w >> 8 & 255, _[S++] = 255 & ~w, _[S++] = (65535 & ~w) >> 8 & 255, _.set(g.subarray(C), S), S += g.length - C;
                var E = r(g, 0, g.length);
                _[S++] = E >> 24 & 255, _[S++] = E >> 16 & 255, _[S++] = E >> 8 & 255, _[S++] = 255 & E;
                var A = a.length + 3 * o + y.length + _.length,
                  T = new Uint8Array(A),
                  k = 0;
                return T.set(a, k), k += a.length, t("IHDR", y, T, k), k += o + y.length, t("IDATA", _, T, k), k += o + _.length, t("IEND", new Uint8Array(0), T, k), (0, n.createObjectURL)(T, "image/png", s);
              }
              for (var a = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), o = 12, s = new Int32Array(256), l = 0; l < 256; l++) {
                for (var c = l, u = 0; u < 8; u++) c = 1 & c ? 3988292384 ^ c >> 1 & 2147483647 : c >> 1 & 2147483647;
                s[l] = c;
              }
              return function (e, t) {
                return i(e, void 0 === e.kind ? n.ImageKind.GRAYSCALE_1BPP : e.kind, t);
              };
            }(),
            s = function () {
              function e() {
                this.fontSizeScale = 1, this.fontWeight = a.fontWeight, this.fontSize = 0, this.textMatrix = n.IDENTITY_MATRIX, this.fontMatrix = n.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = a.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
              }
              return e.prototype = {
                clone: function clone() {
                  return Object.create(this);
                },
                setCurrentPoint: function setCurrentPoint(e, t) {
                  this.x = e, this.y = t;
                }
              }, e;
            }();
          t.SVGGraphics = i = function () {
            function e(e) {
              for (var t = [], r = [], n = e.length, i = 0; i < n; i++) "save" !== e[i].fn ? "restore" === e[i].fn ? t = r.pop() : t.push(e[i]) : (t.push({
                fnId: 92,
                fn: "group",
                items: []
              }), r.push(t), t = t[t.length - 1].items);
              return t;
            }
            function t(e) {
              if (e === (0 | e)) return e.toString();
              var t = e.toFixed(10),
                r = t.length - 1;
              if ("0" !== t[r]) return t;
              do {
                r--;
              } while ("0" === t[r]);
              return t.substr(0, "." === t[r] ? r : r + 1);
            }
            function r(e) {
              if (0 === e[4] && 0 === e[5]) {
                if (0 === e[1] && 0 === e[2]) return 1 === e[0] && 1 === e[3] ? "" : "scale(" + t(e[0]) + " " + t(e[3]) + ")";
                if (e[0] === e[3] && e[1] === -e[2]) {
                  return "rotate(" + t(180 * Math.acos(e[0]) / Math.PI) + ")";
                }
              } else if (1 === e[0] && 0 === e[1] && 0 === e[2] && 1 === e[3]) return "translate(" + t(e[4]) + " " + t(e[5]) + ")";
              return "matrix(" + t(e[0]) + " " + t(e[1]) + " " + t(e[2]) + " " + t(e[3]) + " " + t(e[4]) + " " + t(e[5]) + ")";
            }
            function i(e, t, r) {
              this.current = new s(), this.transformMatrix = n.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = e, this.objs = t, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = Object.create(null), this.cssStyle = null, this.forceDataSchema = !!r;
            }
            var l = "http://www.w3.org/2000/svg",
              c = "http://www.w3.org/1999/xlink",
              u = ["butt", "round", "square"],
              h = ["miter", "round", "bevel"],
              f = 0,
              d = 0;
            return i.prototype = {
              save: function save() {
                this.transformStack.push(this.transformMatrix);
                var e = this.current;
                this.extraStack.push(e), this.current = e.clone();
              },
              restore: function restore() {
                this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.tgrp = null;
              },
              group: function group(e) {
                this.save(), this.executeOpTree(e), this.restore();
              },
              loadDependencies: function loadDependencies(e) {
                for (var t = this, r = e.fnArray, i = r.length, a = e.argsArray, o = 0; o < i; o++) if (n.OPS.dependency === r[o]) for (var s = a[o], l = 0, c = s.length; l < c; l++) {
                  var u,
                    h = s[l],
                    f = "g_" === h.substring(0, 2);
                  u = f ? new Promise(function (e) {
                    t.commonObjs.get(h, e);
                  }) : new Promise(function (e) {
                    t.objs.get(h, e);
                  }), this.current.dependencies.push(u);
                }
                return Promise.all(this.current.dependencies);
              },
              transform: function transform(e, t, r, i, a, o) {
                var s = [e, t, r, i, a, o];
                this.transformMatrix = n.Util.transform(this.transformMatrix, s), this.tgrp = null;
              },
              getSVG: function getSVG(e, t) {
                var r = this;
                this.viewport = t;
                var i = this._initialize(t);
                return this.loadDependencies(e).then(function () {
                  r.transformMatrix = n.IDENTITY_MATRIX;
                  var t = r.convertOpList(e);
                  return r.executeOpTree(t), i;
                });
              },
              convertOpList: function convertOpList(t) {
                var r = t.argsArray,
                  i = t.fnArray,
                  a = i.length,
                  o = [],
                  s = [];
                for (var l in n.OPS) o[n.OPS[l]] = l;
                for (var c = 0; c < a; c++) {
                  var u = i[c];
                  s.push({
                    fnId: u,
                    fn: o[u],
                    args: r[c]
                  });
                }
                return e(s);
              },
              executeOpTree: function executeOpTree(e) {
                for (var t = e.length, r = 0; r < t; r++) {
                  var i = e[r].fn,
                    a = e[r].fnId,
                    o = e[r].args;
                  switch (0 | a) {
                    case n.OPS.beginText:
                      this.beginText();
                      break;
                    case n.OPS.setLeading:
                      this.setLeading(o);
                      break;
                    case n.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(o[0], o[1]);
                      break;
                    case n.OPS.setFont:
                      this.setFont(o);
                      break;
                    case n.OPS.showText:
                    case n.OPS.showSpacedText:
                      this.showText(o[0]);
                      break;
                    case n.OPS.endText:
                      this.endText();
                      break;
                    case n.OPS.moveText:
                      this.moveText(o[0], o[1]);
                      break;
                    case n.OPS.setCharSpacing:
                      this.setCharSpacing(o[0]);
                      break;
                    case n.OPS.setWordSpacing:
                      this.setWordSpacing(o[0]);
                      break;
                    case n.OPS.setHScale:
                      this.setHScale(o[0]);
                      break;
                    case n.OPS.setTextMatrix:
                      this.setTextMatrix(o[0], o[1], o[2], o[3], o[4], o[5]);
                      break;
                    case n.OPS.setLineWidth:
                      this.setLineWidth(o[0]);
                      break;
                    case n.OPS.setLineJoin:
                      this.setLineJoin(o[0]);
                      break;
                    case n.OPS.setLineCap:
                      this.setLineCap(o[0]);
                      break;
                    case n.OPS.setMiterLimit:
                      this.setMiterLimit(o[0]);
                      break;
                    case n.OPS.setFillRGBColor:
                      this.setFillRGBColor(o[0], o[1], o[2]);
                      break;
                    case n.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(o[0], o[1], o[2]);
                      break;
                    case n.OPS.setDash:
                      this.setDash(o[0], o[1]);
                      break;
                    case n.OPS.setGState:
                      this.setGState(o[0]);
                      break;
                    case n.OPS.fill:
                      this.fill();
                      break;
                    case n.OPS.eoFill:
                      this.eoFill();
                      break;
                    case n.OPS.stroke:
                      this.stroke();
                      break;
                    case n.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case n.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case n.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case n.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case n.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case n.OPS.paintJpegXObject:
                      this.paintJpegXObject(o[0], o[1], o[2]);
                      break;
                    case n.OPS.paintImageXObject:
                      this.paintImageXObject(o[0]);
                      break;
                    case n.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(o[0]);
                      break;
                    case n.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(o[0]);
                      break;
                    case n.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(o[0], o[1]);
                      break;
                    case n.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case n.OPS.closePath:
                      this.closePath();
                      break;
                    case n.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case n.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case n.OPS.nextLine:
                      this.nextLine();
                      break;
                    case n.OPS.transform:
                      this.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                      break;
                    case n.OPS.constructPath:
                      this.constructPath(o[0], o[1]);
                      break;
                    case n.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(e[r].items);
                      break;
                    default:
                      (0, n.warn)("Unimplemented operator " + i);
                  }
                }
              },
              setWordSpacing: function setWordSpacing(e) {
                this.current.wordSpacing = e;
              },
              setCharSpacing: function setCharSpacing(e) {
                this.current.charSpacing = e;
              },
              nextLine: function nextLine() {
                this.moveText(0, this.current.leading);
              },
              setTextMatrix: function setTextMatrix(e, r, n, i, a, o) {
                var s = this.current;
                this.current.textMatrix = this.current.lineMatrix = [e, r, n, i, a, o], this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0, s.xcoords = [], s.tspan = document.createElementNS(l, "svg:tspan"), s.tspan.setAttributeNS(null, "font-family", s.fontFamily), s.tspan.setAttributeNS(null, "font-size", t(s.fontSize) + "px"), s.tspan.setAttributeNS(null, "y", t(-s.y)), s.txtElement = document.createElementNS(l, "svg:text"), s.txtElement.appendChild(s.tspan);
              },
              beginText: function beginText() {
                this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0, this.current.textMatrix = n.IDENTITY_MATRIX, this.current.lineMatrix = n.IDENTITY_MATRIX, this.current.tspan = document.createElementNS(l, "svg:tspan"), this.current.txtElement = document.createElementNS(l, "svg:text"), this.current.txtgrp = document.createElementNS(l, "svg:g"), this.current.xcoords = [];
              },
              moveText: function moveText(e, r) {
                var n = this.current;
                this.current.x = this.current.lineX += e, this.current.y = this.current.lineY += r, n.xcoords = [], n.tspan = document.createElementNS(l, "svg:tspan"), n.tspan.setAttributeNS(null, "font-family", n.fontFamily), n.tspan.setAttributeNS(null, "font-size", t(n.fontSize) + "px"), n.tspan.setAttributeNS(null, "y", t(-n.y));
              },
              showText: function showText(e) {
                var i = this.current,
                  o = i.font,
                  s = i.fontSize;
                if (0 !== s) {
                  var l,
                    c = i.charSpacing,
                    u = i.wordSpacing,
                    h = i.fontDirection,
                    f = i.textHScale * h,
                    d = e.length,
                    p = o.vertical,
                    m = s * i.fontMatrix[0],
                    g = 0;
                  for (l = 0; l < d; ++l) {
                    var v = e[l];
                    if (null !== v) {
                      if ((0, n.isNum)(v)) g += -v * s * .001;else {
                        i.xcoords.push(i.x + g * f);
                        var b = v.width,
                          y = v.fontChar,
                          w = (v.isSpace ? u : 0) + c,
                          x = b * m + w * h;
                        g += x, i.tspan.textContent += y;
                      }
                    } else g += h * u;
                  }
                  p ? i.y -= g * f : i.x += g * f, i.tspan.setAttributeNS(null, "x", i.xcoords.map(t).join(" ")), i.tspan.setAttributeNS(null, "y", t(-i.y)), i.tspan.setAttributeNS(null, "font-family", i.fontFamily), i.tspan.setAttributeNS(null, "font-size", t(i.fontSize) + "px"), i.fontStyle !== a.fontStyle && i.tspan.setAttributeNS(null, "font-style", i.fontStyle), i.fontWeight !== a.fontWeight && i.tspan.setAttributeNS(null, "font-weight", i.fontWeight), i.fillColor !== a.fillColor && i.tspan.setAttributeNS(null, "fill", i.fillColor), i.txtElement.setAttributeNS(null, "transform", r(i.textMatrix) + " scale(1, -1)"), i.txtElement.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), i.txtElement.appendChild(i.tspan), i.txtgrp.appendChild(i.txtElement), this._ensureTransformGroup().appendChild(i.txtElement);
                }
              },
              setLeadingMoveText: function setLeadingMoveText(e, t) {
                this.setLeading(-t), this.moveText(e, t);
              },
              addFontStyle: function addFontStyle(e) {
                this.cssStyle || (this.cssStyle = document.createElementNS(l, "svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.appendChild(this.cssStyle));
                var t = (0, n.createObjectURL)(e.data, e.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += '@font-face { font-family: "' + e.loadedName + '"; src: url(' + t + "); }\n";
              },
              setFont: function setFont(e) {
                var r = this.current,
                  i = this.commonObjs.get(e[0]),
                  a = e[1];
                this.current.font = i, this.embedFonts && i.data && !this.embeddedFonts[i.loadedName] && (this.addFontStyle(i), this.embeddedFonts[i.loadedName] = i), r.fontMatrix = i.fontMatrix ? i.fontMatrix : n.FONT_IDENTITY_MATRIX;
                var o = i.black ? i.bold ? "bolder" : "bold" : i.bold ? "bold" : "normal",
                  s = i.italic ? "italic" : "normal";
                a < 0 ? (a = -a, r.fontDirection = -1) : r.fontDirection = 1, r.fontSize = a, r.fontFamily = i.loadedName, r.fontWeight = o, r.fontStyle = s, r.tspan = document.createElementNS(l, "svg:tspan"), r.tspan.setAttributeNS(null, "y", t(-r.y)), r.xcoords = [];
              },
              endText: function endText() {},
              setLineWidth: function setLineWidth(e) {
                this.current.lineWidth = e;
              },
              setLineCap: function setLineCap(e) {
                this.current.lineCap = u[e];
              },
              setLineJoin: function setLineJoin(e) {
                this.current.lineJoin = h[e];
              },
              setMiterLimit: function setMiterLimit(e) {
                this.current.miterLimit = e;
              },
              setStrokeRGBColor: function setStrokeRGBColor(e, t, r) {
                var i = n.Util.makeCssRgb(e, t, r);
                this.current.strokeColor = i;
              },
              setFillRGBColor: function setFillRGBColor(e, t, r) {
                var i = n.Util.makeCssRgb(e, t, r);
                this.current.fillColor = i, this.current.tspan = document.createElementNS(l, "svg:tspan"), this.current.xcoords = [];
              },
              setDash: function setDash(e, t) {
                this.current.dashArray = e, this.current.dashPhase = t;
              },
              constructPath: function constructPath(e, r) {
                var i = this.current,
                  a = i.x,
                  o = i.y;
                i.path = document.createElementNS(l, "svg:path");
                for (var s = [], c = e.length, u = 0, h = 0; u < c; u++) switch (0 | e[u]) {
                  case n.OPS.rectangle:
                    a = r[h++], o = r[h++];
                    var f = r[h++],
                      d = r[h++],
                      p = a + f,
                      m = o + d;
                    s.push("M", t(a), t(o), "L", t(p), t(o), "L", t(p), t(m), "L", t(a), t(m), "Z");
                    break;
                  case n.OPS.moveTo:
                    a = r[h++], o = r[h++], s.push("M", t(a), t(o));
                    break;
                  case n.OPS.lineTo:
                    a = r[h++], o = r[h++], s.push("L", t(a), t(o));
                    break;
                  case n.OPS.curveTo:
                    a = r[h + 4], o = r[h + 5], s.push("C", t(r[h]), t(r[h + 1]), t(r[h + 2]), t(r[h + 3]), t(a), t(o)), h += 6;
                    break;
                  case n.OPS.curveTo2:
                    a = r[h + 2], o = r[h + 3], s.push("C", t(a), t(o), t(r[h]), t(r[h + 1]), t(r[h + 2]), t(r[h + 3])), h += 4;
                    break;
                  case n.OPS.curveTo3:
                    a = r[h + 2], o = r[h + 3], s.push("C", t(r[h]), t(r[h + 1]), t(a), t(o), t(a), t(o)), h += 4;
                    break;
                  case n.OPS.closePath:
                    s.push("Z");
                }
                i.path.setAttributeNS(null, "d", s.join(" ")), i.path.setAttributeNS(null, "stroke-miterlimit", t(i.miterLimit)), i.path.setAttributeNS(null, "stroke-linecap", i.lineCap), i.path.setAttributeNS(null, "stroke-linejoin", i.lineJoin), i.path.setAttributeNS(null, "stroke-width", t(i.lineWidth) + "px"), i.path.setAttributeNS(null, "stroke-dasharray", i.dashArray.map(t).join(" ")), i.path.setAttributeNS(null, "stroke-dashoffset", t(i.dashPhase) + "px"), i.path.setAttributeNS(null, "fill", "none"), this._ensureTransformGroup().appendChild(i.path), i.element = i.path, i.setCurrentPoint(a, o);
              },
              endPath: function endPath() {},
              clip: function clip(e) {
                var t = this.current,
                  n = "clippath" + f;
                f++;
                var i = document.createElementNS(l, "svg:clipPath");
                i.setAttributeNS(null, "id", n), i.setAttributeNS(null, "transform", r(this.transformMatrix));
                var a = t.element.cloneNode();
                "evenodd" === e ? a.setAttributeNS(null, "clip-rule", "evenodd") : a.setAttributeNS(null, "clip-rule", "nonzero"), i.appendChild(a), this.defs.appendChild(i), t.activeClipUrl && (t.clipGroup = null, this.extraStack.forEach(function (e) {
                  e.clipGroup = null;
                })), t.activeClipUrl = "url(#" + n + ")", this.tgrp = null;
              },
              closePath: function closePath() {
                var e = this.current,
                  t = e.path.getAttributeNS(null, "d");
                t += "Z", e.path.setAttributeNS(null, "d", t);
              },
              setLeading: function setLeading(e) {
                this.current.leading = -e;
              },
              setTextRise: function setTextRise(e) {
                this.current.textRise = e;
              },
              setHScale: function setHScale(e) {
                this.current.textHScale = e / 100;
              },
              setGState: function setGState(e) {
                for (var t = 0, r = e.length; t < r; t++) {
                  var i = e[t],
                    a = i[0],
                    o = i[1];
                  switch (a) {
                    case "LW":
                      this.setLineWidth(o);
                      break;
                    case "LC":
                      this.setLineCap(o);
                      break;
                    case "LJ":
                      this.setLineJoin(o);
                      break;
                    case "ML":
                      this.setMiterLimit(o);
                      break;
                    case "D":
                      this.setDash(o[0], o[1]);
                      break;
                    case "Font":
                      this.setFont(o);
                      break;
                    default:
                      (0, n.warn)("Unimplemented graphic state " + a);
                  }
                }
              },
              fill: function fill() {
                var e = this.current;
                e.element.setAttributeNS(null, "fill", e.fillColor);
              },
              stroke: function stroke() {
                var e = this.current;
                e.element.setAttributeNS(null, "stroke", e.strokeColor), e.element.setAttributeNS(null, "fill", "none");
              },
              eoFill: function eoFill() {
                var e = this.current;
                e.element.setAttributeNS(null, "fill", e.fillColor), e.element.setAttributeNS(null, "fill-rule", "evenodd");
              },
              fillStroke: function fillStroke() {
                this.stroke(), this.fill();
              },
              eoFillStroke: function eoFillStroke() {
                this.current.element.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
              },
              closeStroke: function closeStroke() {
                this.closePath(), this.stroke();
              },
              closeFillStroke: function closeFillStroke() {
                this.closePath(), this.fillStroke();
              },
              paintSolidColorImageMask: function paintSolidColorImageMask() {
                var e = this.current,
                  t = document.createElementNS(l, "svg:rect");
                t.setAttributeNS(null, "x", "0"), t.setAttributeNS(null, "y", "0"), t.setAttributeNS(null, "width", "1px"), t.setAttributeNS(null, "height", "1px"), t.setAttributeNS(null, "fill", e.fillColor), this._ensureTransformGroup().appendChild(t);
              },
              paintJpegXObject: function paintJpegXObject(e, r, n) {
                var i = this.objs.get(e),
                  a = document.createElementNS(l, "svg:image");
                a.setAttributeNS(c, "xlink:href", i.src), a.setAttributeNS(null, "width", t(r)), a.setAttributeNS(null, "height", t(n)), a.setAttributeNS(null, "x", "0"), a.setAttributeNS(null, "y", t(-n)), a.setAttributeNS(null, "transform", "scale(" + t(1 / r) + " " + t(-1 / n) + ")"), this._ensureTransformGroup().appendChild(a);
              },
              paintImageXObject: function paintImageXObject(e) {
                var t = this.objs.get(e);
                if (!t) return void (0, n.warn)("Dependent image isn't ready yet");
                this.paintInlineImageXObject(t);
              },
              paintInlineImageXObject: function paintInlineImageXObject(e, r) {
                var n = e.width,
                  i = e.height,
                  a = o(e, this.forceDataSchema),
                  s = document.createElementNS(l, "svg:rect");
                s.setAttributeNS(null, "x", "0"), s.setAttributeNS(null, "y", "0"), s.setAttributeNS(null, "width", t(n)), s.setAttributeNS(null, "height", t(i)), this.current.element = s, this.clip("nonzero");
                var u = document.createElementNS(l, "svg:image");
                u.setAttributeNS(c, "xlink:href", a), u.setAttributeNS(null, "x", "0"), u.setAttributeNS(null, "y", t(-i)), u.setAttributeNS(null, "width", t(n) + "px"), u.setAttributeNS(null, "height", t(i) + "px"), u.setAttributeNS(null, "transform", "scale(" + t(1 / n) + " " + t(-1 / i) + ")"), r ? r.appendChild(u) : this._ensureTransformGroup().appendChild(u);
              },
              paintImageMaskXObject: function paintImageMaskXObject(e) {
                var r = this.current,
                  n = e.width,
                  i = e.height,
                  a = r.fillColor;
                r.maskId = "mask" + d++;
                var o = document.createElementNS(l, "svg:mask");
                o.setAttributeNS(null, "id", r.maskId);
                var s = document.createElementNS(l, "svg:rect");
                s.setAttributeNS(null, "x", "0"), s.setAttributeNS(null, "y", "0"), s.setAttributeNS(null, "width", t(n)), s.setAttributeNS(null, "height", t(i)), s.setAttributeNS(null, "fill", a), s.setAttributeNS(null, "mask", "url(#" + r.maskId + ")"), this.defs.appendChild(o), this._ensureTransformGroup().appendChild(s), this.paintInlineImageXObject(e, o);
              },
              paintFormXObjectBegin: function paintFormXObjectBegin(e, r) {
                if ((0, n.isArray)(e) && 6 === e.length && this.transform(e[0], e[1], e[2], e[3], e[4], e[5]), (0, n.isArray)(r) && 4 === r.length) {
                  var i = r[2] - r[0],
                    a = r[3] - r[1],
                    o = document.createElementNS(l, "svg:rect");
                  o.setAttributeNS(null, "x", r[0]), o.setAttributeNS(null, "y", r[1]), o.setAttributeNS(null, "width", t(i)), o.setAttributeNS(null, "height", t(a)), this.current.element = o, this.clip("nonzero"), this.endPath();
                }
              },
              paintFormXObjectEnd: function paintFormXObjectEnd() {},
              _initialize: function _initialize(e) {
                var t = document.createElementNS(l, "svg:svg");
                t.setAttributeNS(null, "version", "1.1"), t.setAttributeNS(null, "width", e.width + "px"), t.setAttributeNS(null, "height", e.height + "px"), t.setAttributeNS(null, "preserveAspectRatio", "none"), t.setAttributeNS(null, "viewBox", "0 0 " + e.width + " " + e.height);
                var n = document.createElementNS(l, "svg:defs");
                t.appendChild(n), this.defs = n;
                var i = document.createElementNS(l, "svg:g");
                return i.setAttributeNS(null, "transform", r(e.transform)), t.appendChild(i), this.svg = i, t;
              },
              _ensureClipGroup: function _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  var e = document.createElementNS(l, "svg:g");
                  e.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.appendChild(e), this.current.clipGroup = e;
                }
                return this.current.clipGroup;
              },
              _ensureTransformGroup: function _ensureTransformGroup() {
                return this.tgrp || (this.tgrp = document.createElementNS(l, "svg:g"), this.tgrp.setAttributeNS(null, "transform", r(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().appendChild(this.tgrp) : this.svg.appendChild(this.tgrp)), this.tgrp;
              }
            }, i;
          }(), t.SVGGraphics = i;
        }, function (e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.renderTextLayer = void 0;
          var n = r(0),
            i = r(3),
            a = function () {
              function e(e) {
                return !h.test(e);
              }
              function t(t, r, a) {
                var o = document.createElement("div"),
                  s = {
                    style: null,
                    angle: 0,
                    canvasWidth: 0,
                    isWhitespace: !1,
                    originalTransform: null,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingTop: 0,
                    scale: 1
                  };
                if (t._textDivs.push(o), e(r.str)) return s.isWhitespace = !0, void t._textDivProperties.set(o, s);
                var l = n.Util.transform(t._viewport.transform, r.transform),
                  c = Math.atan2(l[1], l[0]),
                  u = a[r.fontName];
                u.vertical && (c += Math.PI / 2);
                var h = Math.sqrt(l[2] * l[2] + l[3] * l[3]),
                  d = h;
                u.ascent ? d = u.ascent * d : u.descent && (d = (1 + u.descent) * d);
                var p, m;
                if (0 === c ? (p = l[4], m = l[5] - d) : (p = l[4] + d * Math.sin(c), m = l[5] - d * Math.cos(c)), f[1] = p, f[3] = m, f[5] = h, f[7] = u.fontFamily, s.style = f.join(""), o.setAttribute("style", s.style), o.textContent = r.str, (0, i.getDefaultSetting)("pdfBug") && (o.dataset.fontName = r.fontName), 0 !== c && (s.angle = c * (180 / Math.PI)), r.str.length > 1 && (u.vertical ? s.canvasWidth = r.height * t._viewport.scale : s.canvasWidth = r.width * t._viewport.scale), t._textDivProperties.set(o, s), t._enhanceTextSelection) {
                  var g = 1,
                    v = 0;
                  0 !== c && (g = Math.cos(c), v = Math.sin(c));
                  var b,
                    y,
                    w = (u.vertical ? r.height : r.width) * t._viewport.scale,
                    x = h;
                  0 !== c ? (b = [g, v, -v, g, p, m], y = n.Util.getAxialAlignedBoundingBox([0, 0, w, x], b)) : y = [p, m, p + w, m + x], t._bounds.push({
                    left: y[0],
                    top: y[1],
                    right: y[2],
                    bottom: y[3],
                    div: o,
                    size: [w, x],
                    m: b
                  });
                }
              }
              function r(e) {
                if (!e._canceled) {
                  var t = e._container,
                    r = e._textDivs,
                    n = e._capability,
                    a = r.length;
                  if (a > u) return e._renderingDone = !0, void n.resolve();
                  for (var o, s, l = document.createElement("canvas"), c = l.getContext("2d", {
                      alpha: !1
                    }), h = 0; h < a; h++) {
                    var f = r[h],
                      d = e._textDivProperties.get(f);
                    if (!d.isWhitespace) {
                      var p = f.style.fontSize,
                        m = f.style.fontFamily;
                      p === o && m === s || (c.font = p + " " + m, o = p, s = m);
                      var g = c.measureText(f.textContent).width;
                      t.appendChild(f);
                      var v = "";
                      0 !== d.canvasWidth && g > 0 && (d.scale = d.canvasWidth / g, v = "scaleX(" + d.scale + ")"), 0 !== d.angle && (v = "rotate(" + d.angle + "deg) " + v), "" !== v && (d.originalTransform = v, i.CustomStyle.setProp("transform", f, v)), e._textDivProperties.set(f, d);
                    }
                  }
                  e._renderingDone = !0, n.resolve();
                }
              }
              function a(e) {
                for (var t = e._bounds, r = e._viewport, i = o(r.width, r.height, t), a = 0; a < i.length; a++) {
                  var s = t[a].div,
                    l = e._textDivProperties.get(s);
                  if (0 !== l.angle) {
                    var c = i[a],
                      u = t[a],
                      h = u.m,
                      f = h[0],
                      d = h[1],
                      p = [[0, 0], [0, u.size[1]], [u.size[0], 0], u.size],
                      m = new Float64Array(64);
                    p.forEach(function (e, t) {
                      var r = n.Util.applyTransform(e, h);
                      m[t + 0] = f && (c.left - r[0]) / f, m[t + 4] = d && (c.top - r[1]) / d, m[t + 8] = f && (c.right - r[0]) / f, m[t + 12] = d && (c.bottom - r[1]) / d, m[t + 16] = d && (c.left - r[0]) / -d, m[t + 20] = f && (c.top - r[1]) / f, m[t + 24] = d && (c.right - r[0]) / -d, m[t + 28] = f && (c.bottom - r[1]) / f, m[t + 32] = f && (c.left - r[0]) / -f, m[t + 36] = d && (c.top - r[1]) / -d, m[t + 40] = f && (c.right - r[0]) / -f, m[t + 44] = d && (c.bottom - r[1]) / -d, m[t + 48] = d && (c.left - r[0]) / d, m[t + 52] = f && (c.top - r[1]) / -f, m[t + 56] = d && (c.right - r[0]) / d, m[t + 60] = f && (c.bottom - r[1]) / -f;
                    });
                    var g = function g(e, t, r) {
                        for (var n = 0, i = 0; i < r; i++) {
                          var a = e[t++];
                          a > 0 && (n = n ? Math.min(a, n) : a);
                        }
                        return n;
                      },
                      v = 1 + Math.min(Math.abs(f), Math.abs(d));
                    l.paddingLeft = g(m, 32, 16) / v, l.paddingTop = g(m, 48, 16) / v, l.paddingRight = g(m, 0, 16) / v, l.paddingBottom = g(m, 16, 16) / v, e._textDivProperties.set(s, l);
                  } else l.paddingLeft = t[a].left - i[a].left, l.paddingTop = t[a].top - i[a].top, l.paddingRight = i[a].right - t[a].right, l.paddingBottom = i[a].bottom - t[a].bottom, e._textDivProperties.set(s, l);
                }
              }
              function o(e, t, r) {
                var n = r.map(function (e, t) {
                  return {
                    x1: e.left,
                    y1: e.top,
                    x2: e.right,
                    y2: e.bottom,
                    index: t,
                    x1New: void 0,
                    x2New: void 0
                  };
                });
                s(e, n);
                var i = new Array(r.length);
                return n.forEach(function (e) {
                  var t = e.index;
                  i[t] = {
                    left: e.x1New,
                    top: 0,
                    right: e.x2New,
                    bottom: 0
                  };
                }), r.map(function (t, r) {
                  var a = i[r],
                    o = n[r];
                  o.x1 = t.top, o.y1 = e - a.right, o.x2 = t.bottom, o.y2 = e - a.left, o.index = r, o.x1New = void 0, o.x2New = void 0;
                }), s(t, n), n.forEach(function (e) {
                  var t = e.index;
                  i[t].top = e.x1New, i[t].bottom = e.x2New;
                }), i;
              }
              function s(e, t) {
                t.sort(function (e, t) {
                  return e.x1 - t.x1 || e.index - t.index;
                });
                var r = {
                    x1: -1 / 0,
                    y1: -1 / 0,
                    x2: 0,
                    y2: 1 / 0,
                    index: -1,
                    x1New: 0,
                    x2New: 0
                  },
                  n = [{
                    start: -1 / 0,
                    end: 1 / 0,
                    boundary: r
                  }];
                t.forEach(function (e) {
                  for (var t = 0; t < n.length && n[t].end <= e.y1;) t++;
                  for (var r = n.length - 1; r >= 0 && n[r].start >= e.y2;) r--;
                  var i,
                    a,
                    o,
                    s,
                    l = -1 / 0;
                  for (o = t; o <= r; o++) {
                    i = n[o], a = i.boundary;
                    var c;
                    c = a.x2 > e.x1 ? a.index > e.index ? a.x1New : e.x1 : void 0 === a.x2New ? (a.x2 + e.x1) / 2 : a.x2New, c > l && (l = c);
                  }
                  for (e.x1New = l, o = t; o <= r; o++) i = n[o], a = i.boundary, void 0 === a.x2New ? a.x2 > e.x1 ? a.index > e.index && (a.x2New = a.x2) : a.x2New = l : a.x2New > l && (a.x2New = Math.max(l, a.x2));
                  var u = [],
                    h = null;
                  for (o = t; o <= r; o++) {
                    i = n[o], a = i.boundary;
                    var f = a.x2 > e.x2 ? a : e;
                    h === f ? u[u.length - 1].end = i.end : (u.push({
                      start: i.start,
                      end: i.end,
                      boundary: f
                    }), h = f);
                  }
                  for (n[t].start < e.y1 && (u[0].start = e.y1, u.unshift({
                    start: n[t].start,
                    end: e.y1,
                    boundary: n[t].boundary
                  })), e.y2 < n[r].end && (u[u.length - 1].end = e.y2, u.push({
                    start: e.y2,
                    end: n[r].end,
                    boundary: n[r].boundary
                  })), o = t; o <= r; o++) if (i = n[o], a = i.boundary, void 0 === a.x2New) {
                    var d = !1;
                    for (s = t - 1; !d && s >= 0 && n[s].start >= a.y1; s--) d = n[s].boundary === a;
                    for (s = r + 1; !d && s < n.length && n[s].end <= a.y2; s++) d = n[s].boundary === a;
                    for (s = 0; !d && s < u.length; s++) d = u[s].boundary === a;
                    d || (a.x2New = l);
                  }
                  Array.prototype.splice.apply(n, [t, r - t + 1].concat(u));
                }), n.forEach(function (t) {
                  var r = t.boundary;
                  void 0 === r.x2New && (r.x2New = Math.max(e, r.x2));
                });
              }
              function l(e, t, r, i, a) {
                this._textContent = e, this._container = t, this._viewport = r, this._textDivs = i || [], this._textDivProperties = new WeakMap(), this._renderingDone = !1, this._canceled = !1, this._capability = (0, n.createPromiseCapability)(), this._renderTimer = null, this._bounds = [], this._enhanceTextSelection = !!a;
              }
              function c(e) {
                var t = new l(e.textContent, e.container, e.viewport, e.textDivs, e.enhanceTextSelection);
                return t._render(e.timeout), t;
              }
              var u = 1e5,
                h = /\S/,
                f = ["left: ", 0, "px; top: ", 0, "px; font-size: ", 0, "px; font-family: ", "", ";"];
              return l.prototype = {
                get promise() {
                  return this._capability.promise;
                },
                cancel: function cancel() {
                  this._canceled = !0, null !== this._renderTimer && (clearTimeout(this._renderTimer), this._renderTimer = null), this._capability.reject("canceled");
                },
                _render: function _render(e) {
                  for (var n = this, i = this._textContent.items, a = this._textContent.styles, o = 0, s = i.length; o < s; o++) t(this, i[o], a);
                  e ? this._renderTimer = setTimeout(function () {
                    r(n), n._renderTimer = null;
                  }, e) : r(this);
                },
                expandTextDivs: function expandTextDivs(e) {
                  if (this._enhanceTextSelection && this._renderingDone) {
                    null !== this._bounds && (a(this), this._bounds = null);
                    for (var t = 0, r = this._textDivs.length; t < r; t++) {
                      var n = this._textDivs[t],
                        o = this._textDivProperties.get(n);
                      if (!o.isWhitespace) if (e) {
                        var s = "",
                          l = "";
                        1 !== o.scale && (s = "scaleX(" + o.scale + ")"), 0 !== o.angle && (s = "rotate(" + o.angle + "deg) " + s), 0 !== o.paddingLeft && (l += " padding-left: " + o.paddingLeft / o.scale + "px;", s += " translateX(" + -o.paddingLeft / o.scale + "px)"), 0 !== o.paddingTop && (l += " padding-top: " + o.paddingTop + "px;", s += " translateY(" + -o.paddingTop + "px)"), 0 !== o.paddingRight && (l += " padding-right: " + o.paddingRight / o.scale + "px;"), 0 !== o.paddingBottom && (l += " padding-bottom: " + o.paddingBottom + "px;"), "" !== l && n.setAttribute("style", o.style + l), "" !== s && i.CustomStyle.setProp("transform", n, s);
                      } else n.style.padding = 0, i.CustomStyle.setProp("transform", n, o.originalTransform || "");
                    }
                  }
                }
              }, c;
            }();
          t.renderTextLayer = a;
        }, function (e, t, r) {
          "use strict";

          var n,
            i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            };
          n = function () {
            return this;
          }();
          try {
            n = n || Function("return this")() || (0, eval)("this");
          } catch (e) {
            "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (n = window);
          }
          e.exports = n;
        }, function (e, t, r) {
          "use strict";

          var n = function () {
            function e(e, t, r) {
              this.data = e, this.bp = t, this.dataEnd = r, this.chigh = e[t], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
            }
            var t = [{
              qe: 22017,
              nmps: 1,
              nlps: 1,
              switchFlag: 1
            }, {
              qe: 13313,
              nmps: 2,
              nlps: 6,
              switchFlag: 0
            }, {
              qe: 6145,
              nmps: 3,
              nlps: 9,
              switchFlag: 0
            }, {
              qe: 2753,
              nmps: 4,
              nlps: 12,
              switchFlag: 0
            }, {
              qe: 1313,
              nmps: 5,
              nlps: 29,
              switchFlag: 0
            }, {
              qe: 545,
              nmps: 38,
              nlps: 33,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 7,
              nlps: 6,
              switchFlag: 1
            }, {
              qe: 21505,
              nmps: 8,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 18433,
              nmps: 9,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 14337,
              nmps: 10,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 12289,
              nmps: 11,
              nlps: 17,
              switchFlag: 0
            }, {
              qe: 9217,
              nmps: 12,
              nlps: 18,
              switchFlag: 0
            }, {
              qe: 7169,
              nmps: 13,
              nlps: 20,
              switchFlag: 0
            }, {
              qe: 5633,
              nmps: 29,
              nlps: 21,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 15,
              nlps: 14,
              switchFlag: 1
            }, {
              qe: 21505,
              nmps: 16,
              nlps: 14,
              switchFlag: 0
            }, {
              qe: 20737,
              nmps: 17,
              nlps: 15,
              switchFlag: 0
            }, {
              qe: 18433,
              nmps: 18,
              nlps: 16,
              switchFlag: 0
            }, {
              qe: 14337,
              nmps: 19,
              nlps: 17,
              switchFlag: 0
            }, {
              qe: 13313,
              nmps: 20,
              nlps: 18,
              switchFlag: 0
            }, {
              qe: 12289,
              nmps: 21,
              nlps: 19,
              switchFlag: 0
            }, {
              qe: 10241,
              nmps: 22,
              nlps: 19,
              switchFlag: 0
            }, {
              qe: 9217,
              nmps: 23,
              nlps: 20,
              switchFlag: 0
            }, {
              qe: 8705,
              nmps: 24,
              nlps: 21,
              switchFlag: 0
            }, {
              qe: 7169,
              nmps: 25,
              nlps: 22,
              switchFlag: 0
            }, {
              qe: 6145,
              nmps: 26,
              nlps: 23,
              switchFlag: 0
            }, {
              qe: 5633,
              nmps: 27,
              nlps: 24,
              switchFlag: 0
            }, {
              qe: 5121,
              nmps: 28,
              nlps: 25,
              switchFlag: 0
            }, {
              qe: 4609,
              nmps: 29,
              nlps: 26,
              switchFlag: 0
            }, {
              qe: 4353,
              nmps: 30,
              nlps: 27,
              switchFlag: 0
            }, {
              qe: 2753,
              nmps: 31,
              nlps: 28,
              switchFlag: 0
            }, {
              qe: 2497,
              nmps: 32,
              nlps: 29,
              switchFlag: 0
            }, {
              qe: 2209,
              nmps: 33,
              nlps: 30,
              switchFlag: 0
            }, {
              qe: 1313,
              nmps: 34,
              nlps: 31,
              switchFlag: 0
            }, {
              qe: 1089,
              nmps: 35,
              nlps: 32,
              switchFlag: 0
            }, {
              qe: 673,
              nmps: 36,
              nlps: 33,
              switchFlag: 0
            }, {
              qe: 545,
              nmps: 37,
              nlps: 34,
              switchFlag: 0
            }, {
              qe: 321,
              nmps: 38,
              nlps: 35,
              switchFlag: 0
            }, {
              qe: 273,
              nmps: 39,
              nlps: 36,
              switchFlag: 0
            }, {
              qe: 133,
              nmps: 40,
              nlps: 37,
              switchFlag: 0
            }, {
              qe: 73,
              nmps: 41,
              nlps: 38,
              switchFlag: 0
            }, {
              qe: 37,
              nmps: 42,
              nlps: 39,
              switchFlag: 0
            }, {
              qe: 21,
              nmps: 43,
              nlps: 40,
              switchFlag: 0
            }, {
              qe: 9,
              nmps: 44,
              nlps: 41,
              switchFlag: 0
            }, {
              qe: 5,
              nmps: 45,
              nlps: 42,
              switchFlag: 0
            }, {
              qe: 1,
              nmps: 45,
              nlps: 43,
              switchFlag: 0
            }, {
              qe: 22017,
              nmps: 46,
              nlps: 46,
              switchFlag: 0
            }];
            return e.prototype = {
              byteIn: function byteIn() {
                var e = this.data,
                  t = this.bp;
                if (255 === e[t]) {
                  e[t + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (t++, this.clow += e[t] << 9, this.ct = 7, this.bp = t);
                } else t++, this.clow += t < this.dataEnd ? e[t] << 8 : 65280, this.ct = 8, this.bp = t;
                this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
              },
              readBit: function readBit(e, r) {
                var n,
                  i = e[r] >> 1,
                  a = 1 & e[r],
                  o = t[i],
                  s = o.qe,
                  l = this.a - s;
                if (this.chigh < s) l < s ? (l = s, n = a, i = o.nmps) : (l = s, n = 1 ^ a, 1 === o.switchFlag && (a = n), i = o.nlps);else {
                  if (this.chigh -= s, 0 != (32768 & l)) return this.a = l, a;
                  l < s ? (n = 1 ^ a, 1 === o.switchFlag && (a = n), i = o.nlps) : (n = a, i = o.nmps);
                }
                do {
                  0 === this.ct && this.byteIn(), l <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
                } while (0 == (32768 & l));
                return this.a = l, e[r] = i << 1 | a, n;
              }
            }, e;
          }();
          t.ArithmeticDecoder = n;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(29),
            a = r(5),
            o = n.error,
            s = n.info,
            l = n.bytesToString,
            c = n.warn,
            u = n.isArray,
            h = n.Util,
            f = n.stringToBytes,
            d = n.assert,
            p = i.ISOAdobeCharset,
            m = i.ExpertCharset,
            g = i.ExpertSubsetCharset,
            v = a.StandardEncoding,
            b = a.ExpertEncoding,
            y = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"],
            w = function () {
              function e(e, t, r) {
                this.bytes = e.getBytes(), this.properties = t, this.seacAnalysisEnabled = !!r;
              }
              var t = [null, {
                  id: "hstem",
                  min: 2,
                  stackClearing: !0,
                  stem: !0
                }, null, {
                  id: "vstem",
                  min: 2,
                  stackClearing: !0,
                  stem: !0
                }, {
                  id: "vmoveto",
                  min: 1,
                  stackClearing: !0
                }, {
                  id: "rlineto",
                  min: 2,
                  resetStack: !0
                }, {
                  id: "hlineto",
                  min: 1,
                  resetStack: !0
                }, {
                  id: "vlineto",
                  min: 1,
                  resetStack: !0
                }, {
                  id: "rrcurveto",
                  min: 6,
                  resetStack: !0
                }, null, {
                  id: "callsubr",
                  min: 1,
                  undefStack: !0
                }, {
                  id: "return",
                  min: 0,
                  undefStack: !0
                }, null, null, {
                  id: "endchar",
                  min: 0,
                  stackClearing: !0
                }, null, null, null, {
                  id: "hstemhm",
                  min: 2,
                  stackClearing: !0,
                  stem: !0
                }, {
                  id: "hintmask",
                  min: 0,
                  stackClearing: !0
                }, {
                  id: "cntrmask",
                  min: 0,
                  stackClearing: !0
                }, {
                  id: "rmoveto",
                  min: 2,
                  stackClearing: !0
                }, {
                  id: "hmoveto",
                  min: 1,
                  stackClearing: !0
                }, {
                  id: "vstemhm",
                  min: 2,
                  stackClearing: !0,
                  stem: !0
                }, {
                  id: "rcurveline",
                  min: 8,
                  resetStack: !0
                }, {
                  id: "rlinecurve",
                  min: 8,
                  resetStack: !0
                }, {
                  id: "vvcurveto",
                  min: 4,
                  resetStack: !0
                }, {
                  id: "hhcurveto",
                  min: 4,
                  resetStack: !0
                }, null, {
                  id: "callgsubr",
                  min: 1,
                  undefStack: !0
                }, {
                  id: "vhcurveto",
                  min: 4,
                  resetStack: !0
                }, {
                  id: "hvcurveto",
                  min: 4,
                  resetStack: !0
                }],
                r = [null, null, null, {
                  id: "and",
                  min: 2,
                  stackDelta: -1
                }, {
                  id: "or",
                  min: 2,
                  stackDelta: -1
                }, {
                  id: "not",
                  min: 1,
                  stackDelta: 0
                }, null, null, null, {
                  id: "abs",
                  min: 1,
                  stackDelta: 0
                }, {
                  id: "add",
                  min: 2,
                  stackDelta: -1,
                  stackFn: function stackFn(e, t) {
                    e[t - 2] = e[t - 2] + e[t - 1];
                  }
                }, {
                  id: "sub",
                  min: 2,
                  stackDelta: -1,
                  stackFn: function stackFn(e, t) {
                    e[t - 2] = e[t - 2] - e[t - 1];
                  }
                }, {
                  id: "div",
                  min: 2,
                  stackDelta: -1,
                  stackFn: function stackFn(e, t) {
                    e[t - 2] = e[t - 2] / e[t - 1];
                  }
                }, null, {
                  id: "neg",
                  min: 1,
                  stackDelta: 0,
                  stackFn: function stackFn(e, t) {
                    e[t - 1] = -e[t - 1];
                  }
                }, {
                  id: "eq",
                  min: 2,
                  stackDelta: -1
                }, null, null, {
                  id: "drop",
                  min: 1,
                  stackDelta: -1
                }, null, {
                  id: "put",
                  min: 2,
                  stackDelta: -2
                }, {
                  id: "get",
                  min: 1,
                  stackDelta: 0
                }, {
                  id: "ifelse",
                  min: 4,
                  stackDelta: -3
                }, {
                  id: "random",
                  min: 0,
                  stackDelta: 1
                }, {
                  id: "mul",
                  min: 2,
                  stackDelta: -1,
                  stackFn: function stackFn(e, t) {
                    e[t - 2] = e[t - 2] * e[t - 1];
                  }
                }, null, {
                  id: "sqrt",
                  min: 1,
                  stackDelta: 0
                }, {
                  id: "dup",
                  min: 1,
                  stackDelta: 1
                }, {
                  id: "exch",
                  min: 2,
                  stackDelta: 0
                }, {
                  id: "index",
                  min: 2,
                  stackDelta: 0
                }, {
                  id: "roll",
                  min: 3,
                  stackDelta: -2
                }, null, null, null, {
                  id: "hflex",
                  min: 7,
                  resetStack: !0
                }, {
                  id: "flex",
                  min: 13,
                  resetStack: !0
                }, {
                  id: "hflex1",
                  min: 9,
                  resetStack: !0
                }, {
                  id: "flex1",
                  min: 11,
                  resetStack: !0
                }];
              return e.prototype = {
                parse: function parse() {
                  var e = this.properties,
                    t = new x();
                  this.cff = t;
                  var r = this.parseHeader(),
                    n = this.parseIndex(r.endPos),
                    i = this.parseIndex(n.endPos),
                    a = this.parseIndex(i.endPos),
                    o = this.parseIndex(a.endPos),
                    s = this.parseDict(i.obj.get(0)),
                    l = this.createDict(A, s, t.strings);
                  t.header = r.obj, t.names = this.parseNameIndex(n.obj), t.strings = this.parseStringIndex(a.obj), t.topDict = l, t.globalSubrIndex = o.obj, this.parsePrivateDict(t.topDict), t.isCIDFont = l.hasName("ROS");
                  var c = l.getByName("CharStrings"),
                    u = this.parseIndex(c).obj,
                    h = l.getByName("FontMatrix");
                  h && (e.fontMatrix = h);
                  var f = l.getByName("FontBBox");
                  f && (e.ascent = Math.max(f[3], f[1]), e.descent = Math.min(f[1], f[3]), e.ascentScaled = !0);
                  var d, p;
                  if (t.isCIDFont) {
                    for (var m = this.parseIndex(l.getByName("FDArray")).obj, g = 0, v = m.count; g < v; ++g) {
                      var b = m.get(g),
                        y = this.createDict(A, this.parseDict(b), t.strings);
                      this.parsePrivateDict(y), t.fdArray.push(y);
                    }
                    p = null, d = this.parseCharsets(l.getByName("charset"), u.count, t.strings, !0), t.fdSelect = this.parseFDSelect(l.getByName("FDSelect"), u.count);
                  } else d = this.parseCharsets(l.getByName("charset"), u.count, t.strings, !1), p = this.parseEncoding(l.getByName("Encoding"), e, t.strings, d.charset);
                  t.charset = d, t.encoding = p;
                  var w = this.parseCharStrings(u, l.privateDict.subrsIndex, o.obj, t.fdSelect, t.fdArray);
                  return t.charStrings = w.charStrings, t.seacs = w.seacs, t.widths = w.widths, t;
                },
                parseHeader: function parseHeader() {
                  for (var e = this.bytes, t = e.length, r = 0; r < t && 1 !== e[r];) ++r;
                  r >= t ? o("Invalid CFF header") : 0 !== r && (s("cff data is shifted"), e = e.subarray(r), this.bytes = e);
                  var n = e[0],
                    i = e[1],
                    a = e[2],
                    l = e[3];
                  return {
                    obj: new _(n, i, a, l),
                    endPos: a
                  };
                },
                parseDict: function parseDict(e) {
                  function t() {
                    for (var t = "", n = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], i = e.length; r < i;) {
                      var a = e[r++],
                        o = a >> 4,
                        s = 15 & a;
                      if (15 === o) break;
                      if (t += n[o], 15 === s) break;
                      t += n[s];
                    }
                    return parseFloat(t);
                  }
                  var r = 0,
                    n = [],
                    i = [];
                  r = 0;
                  for (var a = e.length; r < a;) {
                    var o = e[r];
                    o <= 21 ? (12 === o && (o = o << 8 | e[++r]), i.push([o, n]), n = [], ++r) : n.push(function () {
                      var n = e[r++];
                      return 30 === n ? t() : 28 === n ? (n = e[r++], n = (n << 24 | e[r++] << 16) >> 16) : 29 === n ? (n = e[r++], n = n << 8 | e[r++], n = n << 8 | e[r++], n = n << 8 | e[r++]) : n >= 32 && n <= 246 ? n - 139 : n >= 247 && n <= 250 ? 256 * (n - 247) + e[r++] + 108 : n >= 251 && n <= 254 ? -256 * (n - 251) - e[r++] - 108 : (c('CFFParser_parseDict: "' + n + '" is a reserved command.'), NaN);
                    }());
                  }
                  return i;
                },
                parseIndex: function parseIndex(e) {
                  var t,
                    r,
                    n = new C(),
                    i = this.bytes,
                    a = i[e++] << 8 | i[e++],
                    o = [],
                    s = e;
                  if (0 !== a) {
                    var l = i[e++],
                      c = e + (a + 1) * l - 1;
                    for (t = 0, r = a + 1; t < r; ++t) {
                      for (var u = 0, h = 0; h < l; ++h) u <<= 8, u += i[e++];
                      o.push(c + u);
                    }
                    s = o[a];
                  }
                  for (t = 0, r = o.length - 1; t < r; ++t) {
                    var f = o[t],
                      d = o[t + 1];
                    n.add(i.subarray(f, d));
                  }
                  return {
                    obj: n,
                    endPos: s
                  };
                },
                parseNameIndex: function parseNameIndex(e) {
                  for (var t = [], r = 0, n = e.count; r < n; ++r) {
                    for (var i = e.get(r), a = Math.min(i.length, 127), o = [], s = 0; s < a; ++s) {
                      var c = i[s];
                      0 !== s || 0 !== c ? o[s] = c < 33 || c > 126 || 91 === c || 93 === c || 40 === c || 41 === c || 123 === c || 125 === c || 60 === c || 62 === c || 47 === c || 37 === c || 35 === c ? 95 : c : o[s] = c;
                    }
                    t.push(l(o));
                  }
                  return t;
                },
                parseStringIndex: function parseStringIndex(e) {
                  for (var t = new S(), r = 0, n = e.count; r < n; ++r) {
                    var i = e.get(r);
                    t.add(l(i));
                  }
                  return t;
                },
                createDict: function createDict(e, t, r) {
                  for (var n = new e(r), i = 0, a = t.length; i < a; ++i) {
                    var o = t[i],
                      s = o[0],
                      l = o[1];
                    n.setByKey(s, l);
                  }
                  return n;
                },
                parseCharString: function parseCharString(e, n, i, a) {
                  if (!n || e.callDepth > 10) return !1;
                  for (var o = e.stackSize, s = e.stack, l = n.length, u = 0; u < l;) {
                    var h = n[u++],
                      f = null;
                    if (12 === h) {
                      var d = n[u++];
                      0 === d ? (n[u - 2] = 139, n[u - 1] = 22, o = 0) : f = r[d];
                    } else if (28 === h) s[o] = (n[u] << 24 | n[u + 1] << 16) >> 16, u += 2, o++;else if (14 === h) {
                      if (o >= 4 && (o -= 4, this.seacAnalysisEnabled)) return e.seac = s.slice(o, o + 4), !1;
                      f = t[h];
                    } else if (h >= 32 && h <= 246) s[o] = h - 139, o++;else if (h >= 247 && h <= 254) s[o] = h < 251 ? (h - 247 << 8) + n[u] + 108 : -(h - 251 << 8) - n[u] - 108, u++, o++;else if (255 === h) s[o] = (n[u] << 24 | n[u + 1] << 16 | n[u + 2] << 8 | n[u + 3]) / 65536, u += 4, o++;else if (19 === h || 20 === h) e.hints += o >> 1, u += e.hints + 7 >> 3, o %= 2, f = t[h];else {
                      if (10 === h || 29 === h) {
                        var p;
                        if (!(p = 10 === h ? i : a)) return f = t[h], c("Missing subrsIndex for " + f.id), !1;
                        var m = 32768;
                        p.count < 1240 ? m = 107 : p.count < 33900 && (m = 1131);
                        var g = s[--o] + m;
                        if (g < 0 || g >= p.count || isNaN(g)) return f = t[h], c("Out of bounds subrIndex for " + f.id), !1;
                        e.stackSize = o, e.callDepth++;
                        var v = this.parseCharString(e, p.get(g), i, a);
                        if (!v) return !1;
                        e.callDepth--, o = e.stackSize;
                        continue;
                      }
                      if (11 === h) return e.stackSize = o, !0;
                      f = t[h];
                    }
                    if (f) {
                      if (f.stem && (e.hints += o >> 1), "min" in f && !e.undefStack && o < f.min) return c("Not enough parameters for " + f.id + "; actual: " + o + ", expected: " + f.min), !1;
                      e.firstStackClearing && f.stackClearing && (e.firstStackClearing = !1, o -= f.min, o >= 2 && f.stem ? o %= 2 : o > 1 && c("Found too many parameters for stack-clearing command"), o > 0 && s[o - 1] >= 0 && (e.width = s[o - 1])), "stackDelta" in f ? ("stackFn" in f && f.stackFn(s, o), o += f.stackDelta) : f.stackClearing ? o = 0 : f.resetStack ? (o = 0, e.undefStack = !1) : f.undefStack && (o = 0, e.undefStack = !0, e.firstStackClearing = !1);
                    }
                  }
                  return e.stackSize = o, !0;
                },
                parseCharStrings: function parseCharStrings(e, t, r, n, i) {
                  for (var a = [], o = [], s = e.count, l = 0; l < s; l++) {
                    var u = e.get(l),
                      h = {
                        callDepth: 0,
                        stackSize: 0,
                        stack: [],
                        undefStack: !0,
                        hints: 0,
                        firstStackClearing: !0,
                        seac: null,
                        width: null
                      },
                      f = !0,
                      d = null;
                    if (n && i.length) {
                      var p = n.getFDIndex(l);
                      -1 === p && (c("Glyph index is not in fd select."), f = !1), p >= i.length && (c("Invalid fd index for glyph index."), f = !1), f && (d = i[p].privateDict.subrsIndex);
                    } else t && (d = t);
                    f && (f = this.parseCharString(h, u, d, r)), null !== h.width && (o[l] = h.width), null !== h.seac && (a[l] = h.seac), f || e.set(l, new Uint8Array([14]));
                  }
                  return {
                    charStrings: e,
                    seacs: a,
                    widths: o
                  };
                },
                emptyPrivateDictionary: function emptyPrivateDictionary(e) {
                  var t = this.createDict(T, [], e.strings);
                  e.setByKey(18, [0, 0]), e.privateDict = t;
                },
                parsePrivateDict: function parsePrivateDict(e) {
                  if (!e.hasName("Private")) return void this.emptyPrivateDictionary(e);
                  var t = e.getByName("Private");
                  if (!u(t) || 2 !== t.length) return void e.removeByName("Private");
                  var r = t[0],
                    n = t[1];
                  if (0 === r || n >= this.bytes.length) return void this.emptyPrivateDictionary(e);
                  var i = n + r,
                    a = this.bytes.subarray(n, i),
                    o = this.parseDict(a),
                    s = this.createDict(T, o, e.strings);
                  if (e.privateDict = s, s.getByName("Subrs")) {
                    var l = s.getByName("Subrs"),
                      c = n + l;
                    if (0 === l || c >= this.bytes.length) return void this.emptyPrivateDictionary(e);
                    var h = this.parseIndex(c);
                    s.subrsIndex = h.obj;
                  }
                },
                parseCharsets: function parseCharsets(e, t, r, n) {
                  if (0 === e) return new R(!0, k.ISO_ADOBE, p);
                  if (1 === e) return new R(!0, k.EXPERT, m);
                  if (2 === e) return new R(!0, k.EXPERT_SUBSET, g);
                  var i,
                    a,
                    s,
                    l = this.bytes,
                    c = e,
                    u = l[e++],
                    h = [".notdef"];
                  switch (t -= 1, u) {
                    case 0:
                      for (s = 0; s < t; s++) i = l[e++] << 8 | l[e++], h.push(n ? i : r.get(i));
                      break;
                    case 1:
                      for (; h.length <= t;) for (i = l[e++] << 8 | l[e++], a = l[e++], s = 0; s <= a; s++) h.push(n ? i++ : r.get(i++));
                      break;
                    case 2:
                      for (; h.length <= t;) for (i = l[e++] << 8 | l[e++], a = l[e++] << 8 | l[e++], s = 0; s <= a; s++) h.push(n ? i++ : r.get(i++));
                      break;
                    default:
                      o("Unknown charset format");
                  }
                  var f = e,
                    d = l.subarray(c, f);
                  return new R(!1, u, h, d);
                },
                parseEncoding: function parseEncoding(e, t, r, n) {
                  var i,
                    a,
                    s,
                    l = Object.create(null),
                    c = this.bytes,
                    u = !1,
                    h = null;
                  if (0 === e || 1 === e) {
                    u = !0, i = e;
                    var f = e ? b : v;
                    for (a = 0, s = n.length; a < s; a++) {
                      var d = f.indexOf(n[a]);
                      -1 !== d && (l[d] = a);
                    }
                  } else {
                    var p = e;
                    switch (127 & (i = c[e++])) {
                      case 0:
                        var m = c[e++];
                        for (a = 1; a <= m; a++) l[c[e++]] = a;
                        break;
                      case 1:
                        var g = c[e++],
                          y = 1;
                        for (a = 0; a < g; a++) for (var w = c[e++], x = c[e++], _ = w; _ <= w + x; _++) l[_] = y++;
                        break;
                      default:
                        o("Unknown encoding format: " + i + " in CFF");
                    }
                    var S = e;
                    128 & i && (c[p] &= 127, function () {
                      var t = c[e++];
                      for (a = 0; a < t; a++) {
                        var i = c[e++],
                          o = (c[e++] << 8) + (255 & c[e++]);
                        l[i] = n.indexOf(r.get(o));
                      }
                    }()), h = c.subarray(p, S);
                  }
                  return i &= 127, new I(u, i, l, h);
                },
                parseFDSelect: function parseFDSelect(e, t) {
                  var r,
                    n,
                    i = e,
                    a = this.bytes,
                    s = a[e++],
                    l = [],
                    u = !1;
                  switch (s) {
                    case 0:
                      for (n = 0; n < t; ++n) {
                        var h = a[e++];
                        l.push(h);
                      }
                      r = a.subarray(i, e);
                      break;
                    case 3:
                      var f = a[e++] << 8 | a[e++];
                      for (n = 0; n < f; ++n) {
                        var p = a[e++] << 8 | a[e++];
                        0 === n && 0 !== p && (c("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), u = !0, p = 0);
                        for (var m = a[e++], g = a[e] << 8 | a[e + 1], v = p; v < g; ++v) l.push(m);
                      }
                      e += 2, r = a.subarray(i, e), u && (r[3] = r[4] = 0);
                      break;
                    default:
                      o('parseFDSelect: Unknown format "' + s + '".');
                  }
                  return d(l.length === t, "parseFDSelect: Invalid font data."), new M(l, r);
                }
              }, e;
            }(),
            x = function () {
              function e() {
                this.header = null, this.names = [], this.topDict = null, this.strings = new S(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
              }
              return e;
            }(),
            _ = function () {
              function e(e, t, r, n) {
                this.major = e, this.minor = t, this.hdrSize = r, this.offSize = n;
              }
              return e;
            }(),
            S = function () {
              function e() {
                this.strings = [];
              }
              return e.prototype = {
                get: function get(e) {
                  return e >= 0 && e <= 390 ? y[e] : e - 391 <= this.strings.length ? this.strings[e - 391] : y[0];
                },
                add: function add(e) {
                  this.strings.push(e);
                },
                get count() {
                  return this.strings.length;
                }
              }, e;
            }(),
            C = function () {
              function e() {
                this.objects = [], this.length = 0;
              }
              return e.prototype = {
                add: function add(e) {
                  this.length += e.length, this.objects.push(e);
                },
                set: function set(e, t) {
                  this.length += t.length - this.objects[e].length, this.objects[e] = t;
                },
                get: function get(e) {
                  return this.objects[e];
                },
                get count() {
                  return this.objects.length;
                }
              }, e;
            }(),
            E = function () {
              function e(e, t) {
                this.keyToNameMap = e.keyToNameMap, this.nameToKeyMap = e.nameToKeyMap, this.defaults = e.defaults, this.types = e.types, this.opcodes = e.opcodes, this.order = e.order, this.strings = t, this.values = Object.create(null);
              }
              return e.prototype = {
                setByKey: function setByKey(e, t) {
                  if (!(e in this.keyToNameMap)) return !1;
                  var r = t.length;
                  if (0 === r) return !0;
                  for (var n = 0; n < r; n++) if (isNaN(t[n])) return c('Invalid CFFDict value: "' + t + '" for key "' + e + '".'), !0;
                  var i = this.types[e];
                  return "num" !== i && "sid" !== i && "offset" !== i || (t = t[0]), this.values[e] = t, !0;
                },
                setByName: function setByName(e, t) {
                  e in this.nameToKeyMap || o('Invalid dictionary name "' + e + '"'), this.values[this.nameToKeyMap[e]] = t;
                },
                hasName: function hasName(e) {
                  return this.nameToKeyMap[e] in this.values;
                },
                getByName: function getByName(e) {
                  e in this.nameToKeyMap || o('Invalid dictionary name "' + e + '"');
                  var t = this.nameToKeyMap[e];
                  return t in this.values ? this.values[t] : this.defaults[t];
                },
                removeByName: function removeByName(e) {
                  delete this.values[this.nameToKeyMap[e]];
                }
              }, e.createTables = function (e) {
                for (var t = {
                    keyToNameMap: {},
                    nameToKeyMap: {},
                    defaults: {},
                    types: {},
                    opcodes: {},
                    order: []
                  }, r = 0, n = e.length; r < n; ++r) {
                  var i = e[r],
                    a = u(i[0]) ? (i[0][0] << 8) + i[0][1] : i[0];
                  t.keyToNameMap[a] = i[1], t.nameToKeyMap[i[1]] = a, t.types[a] = i[2], t.defaults[a] = i[3], t.opcodes[a] = u(i[0]) ? i[0] : [i[0]], t.order.push(a);
                }
                return t;
              }, e;
            }(),
            A = function () {
              function e(e) {
                null === r && (r = E.createTables(t)), E.call(this, r, e), this.privateDict = null;
              }
              var t = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [.001, 0, 0, .001, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]],
                r = null;
              return e.prototype = Object.create(E.prototype), e;
            }(),
            T = function () {
              function e(e) {
                null === r && (r = E.createTables(t)), E.call(this, r, e), this.subrsIndex = null;
              }
              var t = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", .039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", .06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]],
                r = null;
              return e.prototype = Object.create(E.prototype), e;
            }(),
            k = {
              ISO_ADOBE: 0,
              EXPERT: 1,
              EXPERT_SUBSET: 2
            },
            R = function () {
              function e(e, t, r, n) {
                this.predefined = e, this.format = t, this.charset = r, this.raw = n;
              }
              return e;
            }(),
            I = function () {
              function e(e, t, r, n) {
                this.predefined = e, this.format = t, this.encoding = r, this.raw = n;
              }
              return e;
            }(),
            M = function () {
              function e(e, t) {
                this.fdSelect = e, this.raw = t;
              }
              return e.prototype = {
                getFDIndex: function getFDIndex(e) {
                  return e < 0 || e >= this.fdSelect.length ? -1 : this.fdSelect[e];
                }
              }, e;
            }(),
            O = function () {
              function e() {
                this.offsets = Object.create(null);
              }
              return e.prototype = {
                isTracking: function isTracking(e) {
                  return e in this.offsets;
                },
                track: function track(e, t) {
                  e in this.offsets && o("Already tracking location of " + e), this.offsets[e] = t;
                },
                offset: function offset(e) {
                  for (var t in this.offsets) this.offsets[t] += e;
                },
                setEntryLocation: function setEntryLocation(e, t, r) {
                  e in this.offsets || o("Not tracking location of " + e);
                  for (var n = r.data, i = this.offsets[e], a = 0, s = t.length; a < s; ++a) {
                    var l = 5 * a + i,
                      c = l + 1,
                      u = l + 2,
                      h = l + 3,
                      f = l + 4;
                    29 === n[l] && 0 === n[c] && 0 === n[u] && 0 === n[h] && 0 === n[f] || o("writing to an offset that is not empty");
                    var d = t[a];
                    n[l] = 29, n[c] = d >> 24 & 255, n[u] = d >> 16 & 255, n[h] = d >> 8 & 255, n[f] = 255 & d;
                  }
                }
              }, e;
            }(),
            P = function () {
              function e(e) {
                this.cff = e;
              }
              return e.prototype = {
                compile: function compile() {
                  var e = this.cff,
                    t = {
                      data: [],
                      length: 0,
                      add: function add(e) {
                        this.data = this.data.concat(e), this.length = this.data.length;
                      }
                    },
                    r = this.compileHeader(e.header);
                  t.add(r);
                  var n = this.compileNameIndex(e.names);
                  if (t.add(n), e.isCIDFont && e.topDict.hasName("FontMatrix")) {
                    var i = e.topDict.getByName("FontMatrix");
                    e.topDict.removeByName("FontMatrix");
                    for (var a = 0, o = e.fdArray.length; a < o; a++) {
                      var s = e.fdArray[a],
                        l = i.slice(0);
                      s.hasName("FontMatrix") && (l = h.transform(l, s.getByName("FontMatrix"))), s.setByName("FontMatrix", l);
                    }
                  }
                  var c = this.compileTopDicts([e.topDict], t.length, e.isCIDFont);
                  t.add(c.output);
                  var u = c.trackers[0],
                    f = this.compileStringIndex(e.strings.strings);
                  t.add(f);
                  var d = this.compileIndex(e.globalSubrIndex);
                  if (t.add(d), e.encoding && e.topDict.hasName("Encoding")) if (e.encoding.predefined) u.setEntryLocation("Encoding", [e.encoding.format], t);else {
                    var p = this.compileEncoding(e.encoding);
                    u.setEntryLocation("Encoding", [t.length], t), t.add(p);
                  }
                  if (e.charset && e.topDict.hasName("charset")) if (e.charset.predefined) u.setEntryLocation("charset", [e.charset.format], t);else {
                    var m = this.compileCharset(e.charset);
                    u.setEntryLocation("charset", [t.length], t), t.add(m);
                  }
                  var g = this.compileCharStrings(e.charStrings);
                  if (u.setEntryLocation("CharStrings", [t.length], t), t.add(g), e.isCIDFont) {
                    u.setEntryLocation("FDSelect", [t.length], t);
                    var v = this.compileFDSelect(e.fdSelect.raw);
                    t.add(v), c = this.compileTopDicts(e.fdArray, t.length, !0), u.setEntryLocation("FDArray", [t.length], t), t.add(c.output);
                    var b = c.trackers;
                    this.compilePrivateDicts(e.fdArray, b, t);
                  }
                  return this.compilePrivateDicts([e.topDict], [u], t), t.add([0]), t.data;
                },
                encodeNumber: function encodeNumber(e) {
                  return parseFloat(e) !== parseInt(e, 10) || isNaN(e) ? this.encodeFloat(e) : this.encodeInteger(e);
                },
                encodeFloat: function encodeFloat(e) {
                  var t = e.toString(),
                    r = /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/.exec(t);
                  if (r) {
                    var n = parseFloat("1e" + ((r[2] ? +r[2] : 0) + r[1].length));
                    t = (Math.round(e * n) / n).toString();
                  }
                  var i,
                    a,
                    o = "";
                  for (i = 0, a = t.length; i < a; ++i) {
                    var s = t[i];
                    o += "e" === s ? "-" === t[++i] ? "c" : "b" : "." === s ? "a" : "-" === s ? "e" : s;
                  }
                  o += 1 & o.length ? "f" : "ff";
                  var l = [30];
                  for (i = 0, a = o.length; i < a; i += 2) l.push(parseInt(o.substr(i, 2), 16));
                  return l;
                },
                encodeInteger: function encodeInteger(e) {
                  var t;
                  return e >= -107 && e <= 107 ? t = [e + 139] : e >= 108 && e <= 1131 ? (e -= 108, t = [247 + (e >> 8), 255 & e]) : e >= -1131 && e <= -108 ? (e = -e - 108, t = [251 + (e >> 8), 255 & e]) : t = e >= -32768 && e <= 32767 ? [28, e >> 8 & 255, 255 & e] : [29, e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, 255 & e], t;
                },
                compileHeader: function compileHeader(e) {
                  return [e.major, e.minor, e.hdrSize, e.offSize];
                },
                compileNameIndex: function compileNameIndex(e) {
                  for (var t = new C(), r = 0, n = e.length; r < n; ++r) t.add(f(e[r]));
                  return this.compileIndex(t);
                },
                compileTopDicts: function compileTopDicts(e, t, r) {
                  for (var n = [], i = new C(), a = 0, o = e.length; a < o; ++a) {
                    var s = e[a];
                    r && (s.removeByName("CIDFontVersion"), s.removeByName("CIDFontRevision"), s.removeByName("CIDFontType"), s.removeByName("CIDCount"), s.removeByName("UIDBase"));
                    var l = new O(),
                      c = this.compileDict(s, l);
                    n.push(l), i.add(c), l.offset(t);
                  }
                  return i = this.compileIndex(i, n), {
                    trackers: n,
                    output: i
                  };
                },
                compilePrivateDicts: function compilePrivateDicts(e, t, r) {
                  for (var n = 0, i = e.length; n < i; ++n) {
                    var a = e[n];
                    d(a.privateDict && a.hasName("Private"), "There must be an private dictionary.");
                    var o = a.privateDict,
                      s = new O(),
                      l = this.compileDict(o, s),
                      c = r.length;
                    if (s.offset(c), l.length || (c = 0), t[n].setEntryLocation("Private", [l.length, c], r), r.add(l), o.subrsIndex && o.hasName("Subrs")) {
                      var u = this.compileIndex(o.subrsIndex);
                      s.setEntryLocation("Subrs", [l.length], r), r.add(u);
                    }
                  }
                },
                compileDict: function compileDict(e, t) {
                  for (var r = [], n = e.order, i = 0; i < n.length; ++i) {
                    var a = n[i];
                    if (a in e.values) {
                      var s = e.values[a],
                        l = e.types[a];
                      if (u(l) || (l = [l]), u(s) || (s = [s]), 0 !== s.length) {
                        for (var c = 0, h = l.length; c < h; ++c) {
                          var f = l[c],
                            d = s[c];
                          switch (f) {
                            case "num":
                            case "sid":
                              r = r.concat(this.encodeNumber(d));
                              break;
                            case "offset":
                              var p = e.keyToNameMap[a];
                              t.isTracking(p) || t.track(p, r.length), r = r.concat([29, 0, 0, 0, 0]);
                              break;
                            case "array":
                            case "delta":
                              r = r.concat(this.encodeNumber(d));
                              for (var m = 1, g = s.length; m < g; ++m) r = r.concat(this.encodeNumber(s[m]));
                              break;
                            default:
                              o("Unknown data type of " + f);
                          }
                        }
                        r = r.concat(e.opcodes[a]);
                      }
                    }
                  }
                  return r;
                },
                compileStringIndex: function compileStringIndex(e) {
                  for (var t = new C(), r = 0, n = e.length; r < n; ++r) t.add(f(e[r]));
                  return this.compileIndex(t);
                },
                compileGlobalSubrIndex: function compileGlobalSubrIndex() {
                  var e = this.cff.globalSubrIndex;
                  this.out.writeByteArray(this.compileIndex(e));
                },
                compileCharStrings: function compileCharStrings(e) {
                  return this.compileIndex(e);
                },
                compileCharset: function compileCharset(e) {
                  return this.compileTypedArray(e.raw);
                },
                compileEncoding: function compileEncoding(e) {
                  return this.compileTypedArray(e.raw);
                },
                compileFDSelect: function compileFDSelect(e) {
                  return this.compileTypedArray(e);
                },
                compileTypedArray: function compileTypedArray(e) {
                  for (var t = [], r = 0, n = e.length; r < n; ++r) t[r] = e[r];
                  return t;
                },
                compileIndex: function compileIndex(e, t) {
                  t = t || [];
                  var r = e.objects,
                    n = r.length;
                  if (0 === n) return [0, 0, 0];
                  var i,
                    a = [n >> 8 & 255, 255 & n],
                    o = 1;
                  for (i = 0; i < n; ++i) o += r[i].length;
                  var s;
                  s = o < 256 ? 1 : o < 65536 ? 2 : o < 16777216 ? 3 : 4, a.push(s);
                  var l = 1;
                  for (i = 0; i < n + 1; i++) 1 === s ? a.push(255 & l) : 2 === s ? a.push(l >> 8 & 255, 255 & l) : 3 === s ? a.push(l >> 16 & 255, l >> 8 & 255, 255 & l) : a.push(l >>> 24 & 255, l >> 16 & 255, l >> 8 & 255, 255 & l), r[i] && (l += r[i].length);
                  for (i = 0; i < n; i++) {
                    t[i] && t[i].offset(a.length);
                    for (var c = 0, u = r[i].length; c < u; c++) a.push(r[i][c]);
                  }
                  return a;
                }
              }, e;
            }();
          t.CFFStandardStrings = y, t.CFFParser = w, t.CFF = x, t.CFFHeader = _, t.CFFStrings = S, t.CFFIndex = C, t.CFFCharset = R, t.CFFTopDict = A, t.CFFPrivateDict = T, t.CFFCompiler = P;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = n.MissingDataException,
            a = n.arrayByteLength,
            o = n.arraysToBytes,
            s = n.assert,
            l = n.createPromiseCapability,
            c = n.isInt,
            u = n.isEmptyObj,
            h = function () {
              function e(e, t, r) {
                this.bytes = new Uint8Array(e), this.start = 0, this.pos = 0, this.end = e, this.chunkSize = t, this.loadedChunks = [], this.numChunksLoaded = 0, this.numChunks = Math.ceil(e / t), this.manager = r, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
              }
              return e.prototype = {
                getMissingChunks: function getMissingChunks() {
                  for (var e = [], t = 0, r = this.numChunks; t < r; ++t) this.loadedChunks[t] || e.push(t);
                  return e;
                },
                getBaseStreams: function getBaseStreams() {
                  return [this];
                },
                allChunksLoaded: function allChunksLoaded() {
                  return this.numChunksLoaded === this.numChunks;
                },
                onReceiveData: function onReceiveData(e, t) {
                  var r = e + t.byteLength;
                  s(e % this.chunkSize == 0, "Bad begin offset: " + e);
                  var n = this.bytes.length;
                  s(r % this.chunkSize == 0 || r === n, "Bad end offset: " + r), this.bytes.set(new Uint8Array(t), e);
                  var i,
                    a = this.chunkSize,
                    o = Math.floor(e / a),
                    l = Math.floor((r - 1) / a) + 1;
                  for (i = o; i < l; ++i) this.loadedChunks[i] || (this.loadedChunks[i] = !0, ++this.numChunksLoaded);
                },
                onReceiveProgressiveData: function onReceiveProgressiveData(e) {
                  var t = this.progressiveDataLength,
                    r = Math.floor(t / this.chunkSize);
                  this.bytes.set(new Uint8Array(e), t), t += e.byteLength, this.progressiveDataLength = t;
                  var n,
                    i = t >= this.end ? this.numChunks : Math.floor(t / this.chunkSize);
                  for (n = r; n < i; ++n) this.loadedChunks[n] || (this.loadedChunks[n] = !0, ++this.numChunksLoaded);
                },
                ensureByte: function ensureByte(e) {
                  var t = Math.floor(e / this.chunkSize);
                  if (t !== this.lastSuccessfulEnsureByteChunk) {
                    if (!this.loadedChunks[t]) throw new i(e, e + 1);
                    this.lastSuccessfulEnsureByteChunk = t;
                  }
                },
                ensureRange: function ensureRange(e, t) {
                  if (!(e >= t || t <= this.progressiveDataLength)) for (var r = this.chunkSize, n = Math.floor(e / r), a = Math.floor((t - 1) / r) + 1, o = n; o < a; ++o) if (!this.loadedChunks[o]) throw new i(e, t);
                },
                nextEmptyChunk: function nextEmptyChunk(e) {
                  for (var t, r = this.numChunks, n = 0; n < r; ++n) if (t = (e + n) % r, !this.loadedChunks[t]) return t;
                  return null;
                },
                hasChunk: function hasChunk(e) {
                  return !!this.loadedChunks[e];
                },
                get length() {
                  return this.end - this.start;
                },
                get isEmpty() {
                  return 0 === this.length;
                },
                getByte: function getByte() {
                  var e = this.pos;
                  return e >= this.end ? -1 : (this.ensureByte(e), this.bytes[this.pos++]);
                },
                getUint16: function getUint16() {
                  var e = this.getByte(),
                    t = this.getByte();
                  return -1 === e || -1 === t ? -1 : (e << 8) + t;
                },
                getInt32: function getInt32() {
                  return (this.getByte() << 24) + (this.getByte() << 16) + (this.getByte() << 8) + this.getByte();
                },
                getBytes: function getBytes(e) {
                  var t = this.bytes,
                    r = this.pos,
                    n = this.end;
                  if (!e) return this.ensureRange(r, n), t.subarray(r, n);
                  var i = r + e;
                  return i > n && (i = n), this.ensureRange(r, i), this.pos = i, t.subarray(r, i);
                },
                peekByte: function peekByte() {
                  var e = this.getByte();
                  return this.pos--, e;
                },
                peekBytes: function peekBytes(e) {
                  var t = this.getBytes(e);
                  return this.pos -= t.length, t;
                },
                getByteRange: function getByteRange(e, t) {
                  return this.ensureRange(e, t), this.bytes.subarray(e, t);
                },
                skip: function skip(e) {
                  e || (e = 1), this.pos += e;
                },
                reset: function reset() {
                  this.pos = this.start;
                },
                moveStart: function moveStart() {
                  this.start = this.pos;
                },
                makeSubStream: function makeSubStream(e, t, r) {
                  function n() {}
                  this.ensureRange(e, e + t), n.prototype = Object.create(this), n.prototype.getMissingChunks = function () {
                    for (var e = this.chunkSize, t = Math.floor(this.start / e), r = Math.floor((this.end - 1) / e) + 1, n = [], i = t; i < r; ++i) this.loadedChunks[i] || n.push(i);
                    return n;
                  };
                  var i = new n();
                  return i.pos = i.start = e, i.end = e + t || this.end, i.dict = r, i;
                }
              }, e;
            }(),
            f = function () {
              function e(e, t) {
                var r = t.rangeChunkSize,
                  n = t.length;
                this.stream = new h(n, r, this), this.length = n, this.chunkSize = r, this.pdfNetworkStream = e, this.url = t.url, this.disableAutoFetch = t.disableAutoFetch, this.msgHandler = t.msgHandler, this.currRequestId = 0, this.chunksNeededByRequest = Object.create(null), this.requestsByChunk = Object.create(null), this.promisesByRequest = Object.create(null), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = l();
              }
              return e.prototype = {
                onLoadedStream: function onLoadedStream() {
                  return this._loadedStreamCapability.promise;
                },
                sendRequest: function sendRequest(e, t) {
                  var r = this,
                    n = this.pdfNetworkStream.getRangeReader(e, t);
                  n.isStreamingSupported || (n.onProgress = this.onProgress.bind(this));
                  var i = [],
                    s = 0,
                    l = this;
                  new Promise(function (e, t) {
                    var r = function r(c) {
                      try {
                        if (!c.done) {
                          var u = c.value;
                          return i.push(u), s += a(u), n.isStreamingSupported && l.onProgress({
                            loaded: s
                          }), void n.read().then(r, t);
                        }
                        var h = o(i);
                        i = null, e(h);
                      } catch (e) {
                        t(e);
                      }
                    };
                    n.read().then(r, t);
                  }).then(function (t) {
                    r.aborted || r.onReceiveData({
                      chunk: t,
                      begin: e
                    });
                  });
                },
                requestAllChunks: function requestAllChunks() {
                  var e = this.stream.getMissingChunks();
                  return this._requestChunks(e), this._loadedStreamCapability.promise;
                },
                _requestChunks: function _requestChunks(e) {
                  var t,
                    r,
                    n = this.currRequestId++,
                    i = Object.create(null);
                  for (this.chunksNeededByRequest[n] = i, t = 0, r = e.length; t < r; t++) this.stream.hasChunk(e[t]) || (i[e[t]] = !0);
                  if (u(i)) return Promise.resolve();
                  var a = l();
                  this.promisesByRequest[n] = a;
                  var o = [];
                  for (var s in i) s |= 0, s in this.requestsByChunk || (this.requestsByChunk[s] = [], o.push(s)), this.requestsByChunk[s].push(n);
                  if (!o.length) return a.promise;
                  var c = this.groupChunks(o);
                  for (t = 0; t < c.length; ++t) {
                    var h = c[t],
                      f = h.beginChunk * this.chunkSize,
                      d = Math.min(h.endChunk * this.chunkSize, this.length);
                    this.sendRequest(f, d);
                  }
                  return a.promise;
                },
                getStream: function getStream() {
                  return this.stream;
                },
                requestRange: function requestRange(e, t) {
                  t = Math.min(t, this.length);
                  for (var r = this.getBeginChunk(e), n = this.getEndChunk(t), i = [], a = r; a < n; ++a) i.push(a);
                  return this._requestChunks(i);
                },
                requestRanges: function requestRanges(e) {
                  e = e || [];
                  for (var t = [], r = 0; r < e.length; r++) for (var n = this.getBeginChunk(e[r].begin), i = this.getEndChunk(e[r].end), a = n; a < i; ++a) t.indexOf(a) < 0 && t.push(a);
                  return t.sort(function (e, t) {
                    return e - t;
                  }), this._requestChunks(t);
                },
                groupChunks: function groupChunks(e) {
                  for (var t = [], r = -1, n = -1, i = 0; i < e.length; ++i) {
                    var a = e[i];
                    r < 0 && (r = a), n >= 0 && n + 1 !== a && (t.push({
                      beginChunk: r,
                      endChunk: n + 1
                    }), r = a), i + 1 === e.length && t.push({
                      beginChunk: r,
                      endChunk: a + 1
                    }), n = a;
                  }
                  return t;
                },
                onProgress: function onProgress(e) {
                  var t = this.stream.numChunksLoaded * this.chunkSize + e.loaded;
                  this.msgHandler.send("DocProgress", {
                    loaded: t,
                    total: this.length
                  });
                },
                onReceiveData: function onReceiveData(e) {
                  var t = e.chunk,
                    r = void 0 === e.begin,
                    n = r ? this.progressiveDataLength : e.begin,
                    i = n + t.byteLength,
                    a = Math.floor(n / this.chunkSize),
                    o = i < this.length ? Math.floor(i / this.chunkSize) : Math.ceil(i / this.chunkSize);
                  r ? (this.stream.onReceiveProgressiveData(t), this.progressiveDataLength = i) : this.stream.onReceiveData(n, t), this.stream.allChunksLoaded() && this._loadedStreamCapability.resolve(this.stream);
                  var s,
                    l,
                    h = [];
                  for (t = a; t < o; ++t) {
                    var f = this.requestsByChunk[t] || [];
                    for (delete this.requestsByChunk[t], s = 0; s < f.length; ++s) {
                      l = f[s];
                      var d = this.chunksNeededByRequest[l];
                      t in d && delete d[t], u(d) && h.push(l);
                    }
                  }
                  if (!this.disableAutoFetch && u(this.requestsByChunk)) {
                    var p;
                    if (1 === this.stream.numChunksLoaded) {
                      var m = this.stream.numChunks - 1;
                      this.stream.hasChunk(m) || (p = m);
                    } else p = this.stream.nextEmptyChunk(o);
                    c(p) && this._requestChunks([p]);
                  }
                  for (s = 0; s < h.length; ++s) {
                    l = h[s];
                    var g = this.promisesByRequest[l];
                    delete this.promisesByRequest[l], g.resolve();
                  }
                  this.msgHandler.send("DocProgress", {
                    loaded: this.stream.numChunksLoaded * this.chunkSize,
                    total: this.length
                  });
                },
                onError: function onError(e) {
                  this._loadedStreamCapability.reject(e);
                },
                getBeginChunk: function getBeginChunk(e) {
                  return Math.floor(e / this.chunkSize);
                },
                getEndChunk: function getEndChunk(e) {
                  return Math.floor((e - 1) / this.chunkSize) + 1;
                },
                abort: function abort() {
                  this.aborted = !0, this.pdfNetworkStream && this.pdfNetworkStream.cancelAllRequests("abort");
                  for (var e in this.promisesByRequest) {
                    this.promisesByRequest[e].reject(new Error("Request was aborted"));
                  }
                }
              }, e;
            }();
          t.ChunkedStream = h, t.ChunkedStreamManager = f;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(2),
            o = n.PasswordException,
            s = n.PasswordResponses,
            l = n.bytesToString,
            c = n.warn,
            u = n.error,
            h = n.assert,
            f = n.isInt,
            d = n.stringToBytes,
            p = n.utf8StringToString,
            m = i.Name,
            g = i.isName,
            v = i.isDict,
            b = a.DecryptStream,
            y = function () {
              function e(e) {
                this.a = 0, this.b = 0;
                var t,
                  r,
                  n = new Uint8Array(256),
                  i = 0,
                  a = e.length;
                for (t = 0; t < 256; ++t) n[t] = t;
                for (t = 0; t < 256; ++t) r = n[t], i = i + r + e[t % a] & 255, n[t] = n[i], n[i] = r;
                this.s = n;
              }
              return e.prototype = {
                encryptBlock: function encryptBlock(e) {
                  var t,
                    r,
                    n,
                    i = e.length,
                    a = this.a,
                    o = this.b,
                    s = this.s,
                    l = new Uint8Array(i);
                  for (t = 0; t < i; ++t) a = a + 1 & 255, r = s[a], o = o + r & 255, n = s[o], s[a] = n, s[o] = r, l[t] = e[t] ^ s[r + n & 255];
                  return this.a = a, this.b = o, l;
                }
              }, e.prototype.decryptBlock = e.prototype.encryptBlock, e;
            }(),
            w = function () {
              function e(e, n, i) {
                var a,
                  o,
                  s,
                  l = 1732584193,
                  c = -271733879,
                  u = -1732584194,
                  h = 271733878,
                  f = i + 72 & -64,
                  d = new Uint8Array(f);
                for (a = 0; a < i; ++a) d[a] = e[n++];
                for (d[a++] = 128, s = f - 8; a < s;) d[a++] = 0;
                d[a++] = i << 3 & 255, d[a++] = i >> 5 & 255, d[a++] = i >> 13 & 255, d[a++] = i >> 21 & 255, d[a++] = i >>> 29 & 255, d[a++] = 0, d[a++] = 0, d[a++] = 0;
                var p = new Int32Array(16);
                for (a = 0; a < f;) {
                  for (o = 0; o < 16; ++o, a += 4) p[o] = d[a] | d[a + 1] << 8 | d[a + 2] << 16 | d[a + 3] << 24;
                  var m,
                    g,
                    v = l,
                    b = c,
                    y = u,
                    w = h;
                  for (o = 0; o < 64; ++o) {
                    o < 16 ? (m = b & y | ~b & w, g = o) : o < 32 ? (m = w & b | ~w & y, g = 5 * o + 1 & 15) : o < 48 ? (m = b ^ y ^ w, g = 3 * o + 5 & 15) : (m = y ^ (b | ~w), g = 7 * o & 15);
                    var x = w,
                      _ = v + m + r[o] + p[g] | 0,
                      S = t[o];
                    w = y, y = b, b = b + (_ << S | _ >>> 32 - S) | 0, v = x;
                  }
                  l = l + v | 0, c = c + b | 0, u = u + y | 0, h = h + w | 0;
                }
                return new Uint8Array([255 & l, l >> 8 & 255, l >> 16 & 255, l >>> 24 & 255, 255 & c, c >> 8 & 255, c >> 16 & 255, c >>> 24 & 255, 255 & u, u >> 8 & 255, u >> 16 & 255, u >>> 24 & 255, 255 & h, h >> 8 & 255, h >> 16 & 255, h >>> 24 & 255]);
              }
              var t = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]),
                r = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
              return e;
            }(),
            x = function () {
              function e(e, t) {
                this.high = 0 | e, this.low = 0 | t;
              }
              return e.prototype = {
                and: function and(e) {
                  this.high &= e.high, this.low &= e.low;
                },
                xor: function xor(e) {
                  this.high ^= e.high, this.low ^= e.low;
                },
                or: function or(e) {
                  this.high |= e.high, this.low |= e.low;
                },
                shiftRight: function shiftRight(e) {
                  e >= 32 ? (this.low = this.high >>> e - 32 | 0, this.high = 0) : (this.low = this.low >>> e | this.high << 32 - e, this.high = this.high >>> e | 0);
                },
                shiftLeft: function shiftLeft(e) {
                  e >= 32 ? (this.high = this.low << e - 32, this.low = 0) : (this.high = this.high << e | this.low >>> 32 - e, this.low = this.low << e);
                },
                rotateRight: function rotateRight(e) {
                  var t, r;
                  32 & e ? (r = this.low, t = this.high) : (t = this.low, r = this.high), e &= 31, this.low = t >>> e | r << 32 - e, this.high = r >>> e | t << 32 - e;
                },
                not: function not() {
                  this.high = ~this.high, this.low = ~this.low;
                },
                add: function add(e) {
                  var t = (this.low >>> 0) + (e.low >>> 0),
                    r = (this.high >>> 0) + (e.high >>> 0);
                  t > 4294967295 && (r += 1), this.low = 0 | t, this.high = 0 | r;
                },
                copyTo: function copyTo(e, t) {
                  e[t] = this.high >>> 24 & 255, e[t + 1] = this.high >> 16 & 255, e[t + 2] = this.high >> 8 & 255, e[t + 3] = 255 & this.high, e[t + 4] = this.low >>> 24 & 255, e[t + 5] = this.low >> 16 & 255, e[t + 6] = this.low >> 8 & 255, e[t + 7] = 255 & this.low;
                },
                assign: function assign(e) {
                  this.high = e.high, this.low = e.low;
                }
              }, e;
            }(),
            _ = function () {
              function e(e, t) {
                return e >>> t | e << 32 - t;
              }
              function t(e, t, r) {
                return e & t ^ ~e & r;
              }
              function r(e, t, r) {
                return e & t ^ e & r ^ t & r;
              }
              function n(t) {
                return e(t, 2) ^ e(t, 13) ^ e(t, 22);
              }
              function i(t) {
                return e(t, 6) ^ e(t, 11) ^ e(t, 25);
              }
              function a(t) {
                return e(t, 7) ^ e(t, 18) ^ t >>> 3;
              }
              function o(t) {
                return e(t, 17) ^ e(t, 19) ^ t >>> 10;
              }
              function s(e, s, c) {
                var u,
                  h,
                  f,
                  d = 1779033703,
                  p = 3144134277,
                  m = 1013904242,
                  g = 2773480762,
                  v = 1359893119,
                  b = 2600822924,
                  y = 528734635,
                  w = 1541459225,
                  x = 64 * Math.ceil((c + 9) / 64),
                  _ = new Uint8Array(x);
                for (u = 0; u < c; ++u) _[u] = e[s++];
                for (_[u++] = 128, f = x - 8; u < f;) _[u++] = 0;
                _[u++] = 0, _[u++] = 0, _[u++] = 0, _[u++] = c >>> 29 & 255, _[u++] = c >> 21 & 255, _[u++] = c >> 13 & 255, _[u++] = c >> 5 & 255, _[u++] = c << 3 & 255;
                var S = new Uint32Array(64);
                for (u = 0; u < x;) {
                  for (h = 0; h < 16; ++h) S[h] = _[u] << 24 | _[u + 1] << 16 | _[u + 2] << 8 | _[u + 3], u += 4;
                  for (h = 16; h < 64; ++h) S[h] = o(S[h - 2]) + S[h - 7] + a(S[h - 15]) + S[h - 16] | 0;
                  var C,
                    E,
                    A = d,
                    T = p,
                    k = m,
                    R = g,
                    I = v,
                    M = b,
                    O = y,
                    P = w;
                  for (h = 0; h < 64; ++h) C = P + i(I) + t(I, M, O) + l[h] + S[h], E = n(A) + r(A, T, k), P = O, O = M, M = I, I = R + C | 0, R = k, k = T, T = A, A = C + E | 0;
                  d = d + A | 0, p = p + T | 0, m = m + k | 0, g = g + R | 0, v = v + I | 0, b = b + M | 0, y = y + O | 0, w = w + P | 0;
                }
                return new Uint8Array([d >> 24 & 255, d >> 16 & 255, d >> 8 & 255, 255 & d, p >> 24 & 255, p >> 16 & 255, p >> 8 & 255, 255 & p, m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, 255 & m, g >> 24 & 255, g >> 16 & 255, g >> 8 & 255, 255 & g, v >> 24 & 255, v >> 16 & 255, v >> 8 & 255, 255 & v, b >> 24 & 255, b >> 16 & 255, b >> 8 & 255, 255 & b, y >> 24 & 255, y >> 16 & 255, y >> 8 & 255, 255 & y, w >> 24 & 255, w >> 16 & 255, w >> 8 & 255, 255 & w]);
              }
              var l = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
              return s;
            }(),
            S = function () {
              function e(e, t, r, n, i) {
                e.assign(t), e.and(r), i.assign(t), i.not(), i.and(n), e.xor(i);
              }
              function t(e, t, r, n, i) {
                e.assign(t), e.and(r), i.assign(t), i.and(n), e.xor(i), i.assign(r), i.and(n), e.xor(i);
              }
              function r(e, t, r) {
                e.assign(t), e.rotateRight(28), r.assign(t), r.rotateRight(34), e.xor(r), r.assign(t), r.rotateRight(39), e.xor(r);
              }
              function n(e, t, r) {
                e.assign(t), e.rotateRight(14), r.assign(t), r.rotateRight(18), e.xor(r), r.assign(t), r.rotateRight(41), e.xor(r);
              }
              function i(e, t, r) {
                e.assign(t), e.rotateRight(1), r.assign(t), r.rotateRight(8), e.xor(r), r.assign(t), r.shiftRight(7), e.xor(r);
              }
              function a(e, t, r) {
                e.assign(t), e.rotateRight(19), r.assign(t), r.rotateRight(61), e.xor(r), r.assign(t), r.shiftRight(6), e.xor(r);
              }
              function o(o, l, c, u) {
                u = !!u;
                var h, f, d, p, m, g, v, b;
                u ? (h = new x(3418070365, 3238371032), f = new x(1654270250, 914150663), d = new x(2438529370, 812702999), p = new x(355462360, 4144912697), m = new x(1731405415, 4290775857), g = new x(2394180231, 1750603025), v = new x(3675008525, 1694076839), b = new x(1203062813, 3204075428)) : (h = new x(1779033703, 4089235720), f = new x(3144134277, 2227873595), d = new x(1013904242, 4271175723), p = new x(2773480762, 1595750129), m = new x(1359893119, 2917565137), g = new x(2600822924, 725511199), v = new x(528734635, 4215389547), b = new x(1541459225, 327033209));
                var y,
                  w,
                  _,
                  S = 128 * Math.ceil((c + 17) / 128),
                  C = new Uint8Array(S);
                for (y = 0; y < c; ++y) C[y] = o[l++];
                for (C[y++] = 128, _ = S - 16; y < _;) C[y++] = 0;
                C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = 0, C[y++] = c >>> 29 & 255, C[y++] = c >> 21 & 255, C[y++] = c >> 13 & 255, C[y++] = c >> 5 & 255, C[y++] = c << 3 & 255;
                var E = new Array(80);
                for (y = 0; y < 80; y++) E[y] = new x(0, 0);
                var A,
                  T = new x(0, 0),
                  k = new x(0, 0),
                  R = new x(0, 0),
                  I = new x(0, 0),
                  M = new x(0, 0),
                  O = new x(0, 0),
                  P = new x(0, 0),
                  B = new x(0, 0),
                  D = new x(0, 0),
                  L = new x(0, 0),
                  F = new x(0, 0),
                  N = new x(0, 0);
                for (y = 0; y < S;) {
                  for (w = 0; w < 16; ++w) E[w].high = C[y] << 24 | C[y + 1] << 16 | C[y + 2] << 8 | C[y + 3], E[w].low = C[y + 4] << 24 | C[y + 5] << 16 | C[y + 6] << 8 | C[y + 7], y += 8;
                  for (w = 16; w < 80; ++w) A = E[w], a(A, E[w - 2], N), A.add(E[w - 7]), i(F, E[w - 15], N), A.add(F), A.add(E[w - 16]);
                  for (T.assign(h), k.assign(f), R.assign(d), I.assign(p), M.assign(m), O.assign(g), P.assign(v), B.assign(b), w = 0; w < 80; ++w) D.assign(B), n(F, M, N), D.add(F), e(F, M, O, P, N), D.add(F), D.add(s[w]), D.add(E[w]), r(L, T, N), t(F, T, k, R, N), L.add(F), A = B, B = P, P = O, O = M, I.add(D), M = I, I = R, R = k, k = T, A.assign(D), A.add(L), T = A;
                  h.add(T), f.add(k), d.add(R), p.add(I), m.add(M), g.add(O), v.add(P), b.add(B);
                }
                var U;
                return u ? (U = new Uint8Array(48), h.copyTo(U, 0), f.copyTo(U, 8), d.copyTo(U, 16), p.copyTo(U, 24), m.copyTo(U, 32), g.copyTo(U, 40)) : (U = new Uint8Array(64), h.copyTo(U, 0), f.copyTo(U, 8), d.copyTo(U, 16), p.copyTo(U, 24), m.copyTo(U, 32), g.copyTo(U, 40), v.copyTo(U, 48), b.copyTo(U, 56)), U;
              }
              var s = [new x(1116352408, 3609767458), new x(1899447441, 602891725), new x(3049323471, 3964484399), new x(3921009573, 2173295548), new x(961987163, 4081628472), new x(1508970993, 3053834265), new x(2453635748, 2937671579), new x(2870763221, 3664609560), new x(3624381080, 2734883394), new x(310598401, 1164996542), new x(607225278, 1323610764), new x(1426881987, 3590304994), new x(1925078388, 4068182383), new x(2162078206, 991336113), new x(2614888103, 633803317), new x(3248222580, 3479774868), new x(3835390401, 2666613458), new x(4022224774, 944711139), new x(264347078, 2341262773), new x(604807628, 2007800933), new x(770255983, 1495990901), new x(1249150122, 1856431235), new x(1555081692, 3175218132), new x(1996064986, 2198950837), new x(2554220882, 3999719339), new x(2821834349, 766784016), new x(2952996808, 2566594879), new x(3210313671, 3203337956), new x(3336571891, 1034457026), new x(3584528711, 2466948901), new x(113926993, 3758326383), new x(338241895, 168717936), new x(666307205, 1188179964), new x(773529912, 1546045734), new x(1294757372, 1522805485), new x(1396182291, 2643833823), new x(1695183700, 2343527390), new x(1986661051, 1014477480), new x(2177026350, 1206759142), new x(2456956037, 344077627), new x(2730485921, 1290863460), new x(2820302411, 3158454273), new x(3259730800, 3505952657), new x(3345764771, 106217008), new x(3516065817, 3606008344), new x(3600352804, 1432725776), new x(4094571909, 1467031594), new x(275423344, 851169720), new x(430227734, 3100823752), new x(506948616, 1363258195), new x(659060556, 3750685593), new x(883997877, 3785050280), new x(958139571, 3318307427), new x(1322822218, 3812723403), new x(1537002063, 2003034995), new x(1747873779, 3602036899), new x(1955562222, 1575990012), new x(2024104815, 1125592928), new x(2227730452, 2716904306), new x(2361852424, 442776044), new x(2428436474, 593698344), new x(2756734187, 3733110249), new x(3204031479, 2999351573), new x(3329325298, 3815920427), new x(3391569614, 3928383900), new x(3515267271, 566280711), new x(3940187606, 3454069534), new x(4118630271, 4000239992), new x(116418474, 1914138554), new x(174292421, 2731055270), new x(289380356, 3203993006), new x(460393269, 320620315), new x(685471733, 587496836), new x(852142971, 1086792851), new x(1017036298, 365543100), new x(1126000580, 2618297676), new x(1288033470, 3409855158), new x(1501505948, 4234509866), new x(1607167915, 987167468), new x(1816402316, 1246189591)];
              return o;
            }(),
            C = function () {
              function e(e, t, r) {
                return S(e, t, r, !0);
              }
              return e;
            }(),
            E = function () {
              function e() {}
              return e.prototype = {
                decryptBlock: function decryptBlock(e) {
                  return e;
                }
              }, e;
            }(),
            A = function () {
              function e(e) {
                var t = new Uint8Array(176);
                t.set(e);
                for (var r = 16, n = 1; r < 176; ++n) {
                  var i = t[r - 3],
                    s = t[r - 2],
                    l = t[r - 1],
                    c = t[r - 4];
                  i = o[i], s = o[s], l = o[l], c = o[c], i ^= a[n];
                  for (var u = 0; u < 4; ++u) t[r] = i ^= t[r - 16], r++, t[r] = s ^= t[r - 16], r++, t[r] = l ^= t[r - 16], r++, t[r] = c ^= t[r - 16], r++;
                }
                return t;
              }
              function t(e, t) {
                var r = new Uint8Array(16);
                r.set(e);
                var n, i, a, o, l, c;
                for (i = 0, a = 160; i < 16; ++i, ++a) r[i] ^= t[a];
                for (n = 9; n >= 1; --n) {
                  for (o = r[13], r[13] = r[9], r[9] = r[5], r[5] = r[1], r[1] = o, o = r[14], l = r[10], r[14] = r[6], r[10] = r[2], r[6] = o, r[2] = l, o = r[15], l = r[11], c = r[7], r[15] = r[3], r[11] = o, r[7] = l, r[3] = c, i = 0; i < 16; ++i) r[i] = s[r[i]];
                  for (i = 0, a = 16 * n; i < 16; ++i, ++a) r[i] ^= t[a];
                  for (i = 0; i < 16; i += 4) {
                    var h = u[r[i]],
                      f = u[r[i + 1]],
                      d = u[r[i + 2]],
                      p = u[r[i + 3]];
                    o = h ^ f >>> 8 ^ f << 24 ^ d >>> 16 ^ d << 16 ^ p >>> 24 ^ p << 8, r[i] = o >>> 24 & 255, r[i + 1] = o >> 16 & 255, r[i + 2] = o >> 8 & 255, r[i + 3] = 255 & o;
                  }
                }
                for (o = r[13], r[13] = r[9], r[9] = r[5], r[5] = r[1], r[1] = o, o = r[14], l = r[10], r[14] = r[6], r[10] = r[2], r[6] = o, r[2] = l, o = r[15], l = r[11], c = r[7], r[15] = r[3], r[11] = o, r[7] = l, r[3] = c, i = 0; i < 16; ++i) r[i] = s[r[i]], r[i] ^= t[i];
                return r;
              }
              function r(e, t) {
                var r,
                  n,
                  i,
                  a,
                  s = new Uint8Array(16);
                for (s.set(e), u = 0; u < 16; ++u) s[u] ^= t[u];
                for (c = 1; c < 10; c++) {
                  for (u = 0; u < 16; ++u) s[u] = o[s[u]];
                  i = s[1], s[1] = s[5], s[5] = s[9], s[9] = s[13], s[13] = i, i = s[2], n = s[6], s[2] = s[10], s[6] = s[14], s[10] = i, s[14] = n, i = s[3], n = s[7], r = s[11], s[3] = s[15], s[7] = i, s[11] = n, s[15] = r;
                  for (var u = 0; u < 16; u += 4) {
                    var h = s[u + 0],
                      f = s[u + 1],
                      d = s[u + 2],
                      p = s[u + 3];
                    r = h ^ f ^ d ^ p, s[u + 0] ^= r ^ l[h ^ f], s[u + 1] ^= r ^ l[f ^ d], s[u + 2] ^= r ^ l[d ^ p], s[u + 3] ^= r ^ l[p ^ h];
                  }
                  for (u = 0, a = 16 * c; u < 16; ++u, ++a) s[u] ^= t[a];
                }
                for (u = 0; u < 16; ++u) s[u] = o[s[u]];
                for (i = s[1], s[1] = s[5], s[5] = s[9], s[9] = s[13], s[13] = i, i = s[2], n = s[6], s[2] = s[10], s[6] = s[14], s[10] = i, s[14] = n, i = s[3], n = s[7], r = s[11], s[3] = s[15], s[7] = i, s[11] = n, s[15] = r, u = 0, a = 160; u < 16; ++u, ++a) s[u] ^= t[a];
                return s;
              }
              function n(t) {
                this.key = e(t), this.buffer = new Uint8Array(16), this.bufferPosition = 0;
              }
              function i(e, r) {
                var n,
                  i,
                  a,
                  o = e.length,
                  s = this.buffer,
                  l = this.bufferPosition,
                  c = [],
                  u = this.iv;
                for (n = 0; n < o; ++n) if (s[l] = e[n], !(++l < 16)) {
                  var h = t(s, this.key);
                  for (i = 0; i < 16; ++i) h[i] ^= u[i];
                  u = s, c.push(h), s = new Uint8Array(16), l = 0;
                }
                if (this.buffer = s, this.bufferLength = l, this.iv = u, 0 === c.length) return new Uint8Array([]);
                var f = 16 * c.length;
                if (r) {
                  var d = c[c.length - 1],
                    p = d[15];
                  if (p <= 16) {
                    for (n = 15, a = 16 - p; n >= a; --n) if (d[n] !== p) {
                      p = 0;
                      break;
                    }
                    f -= p, c[c.length - 1] = d.subarray(0, 16 - p);
                  }
                }
                var m = new Uint8Array(f);
                for (n = 0, i = 0, a = c.length; n < a; ++n, i += 16) m.set(c[n], i);
                return m;
              }
              for (var a = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), o = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), l = new Uint8Array(256), c = 0; c < 256; c++) l[c] = c < 128 ? c << 1 : c << 1 ^ 27;
              var u = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]);
              return n.prototype = {
                decryptBlock: function decryptBlock(e, t) {
                  var r,
                    n = e.length,
                    a = this.buffer,
                    o = this.bufferPosition;
                  for (r = 0; o < 16 && r < n; ++r, ++o) a[o] = e[r];
                  return o < 16 ? (this.bufferLength = o, new Uint8Array([])) : (this.iv = a, this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = i, this.decryptBlock(e.subarray(16), t));
                },
                encrypt: function encrypt(e, t) {
                  var n,
                    i,
                    a,
                    o = e.length,
                    s = this.buffer,
                    l = this.bufferPosition,
                    c = [];
                  for (t || (t = new Uint8Array(16)), n = 0; n < o; ++n) if (s[l] = e[n], !(++l < 16)) {
                    for (i = 0; i < 16; ++i) s[i] ^= t[i];
                    var u = r(s, this.key);
                    t = u, c.push(u), s = new Uint8Array(16), l = 0;
                  }
                  if (this.buffer = s, this.bufferLength = l, this.iv = t, 0 === c.length) return new Uint8Array([]);
                  var h = 16 * c.length,
                    f = new Uint8Array(h);
                  for (n = 0, i = 0, a = c.length; n < a; ++n, i += 16) f.set(c[n], i);
                  return f;
                }
              }, n;
            }(),
            T = function () {
              function e(e) {
                var t = new Uint8Array(240),
                  r = 1;
                t.set(e);
                for (var n = 32, i = 1; n < 240; ++i) {
                  if (n % 32 == 16) o = a[o], s = a[s], l = a[l], c = a[c];else if (n % 32 == 0) {
                    var o = t[n - 3],
                      s = t[n - 2],
                      l = t[n - 1],
                      c = t[n - 4];
                    o = a[o], s = a[s], l = a[l], c = a[c], o ^= r, (r <<= 1) >= 256 && (r = 255 & (27 ^ r));
                  }
                  for (var u = 0; u < 4; ++u) t[n] = o ^= t[n - 32], n++, t[n] = s ^= t[n - 32], n++, t[n] = l ^= t[n - 32], n++, t[n] = c ^= t[n - 32], n++;
                }
                return t;
              }
              function t(e, t) {
                var r = new Uint8Array(16);
                r.set(e);
                var n, i, a, s, l, u;
                for (i = 0, a = 224; i < 16; ++i, ++a) r[i] ^= t[a];
                for (n = 13; n >= 1; --n) {
                  for (s = r[13], r[13] = r[9], r[9] = r[5], r[5] = r[1], r[1] = s, s = r[14], l = r[10], r[14] = r[6], r[10] = r[2], r[6] = s, r[2] = l, s = r[15], l = r[11], u = r[7], r[15] = r[3], r[11] = s, r[7] = l, r[3] = u, i = 0; i < 16; ++i) r[i] = o[r[i]];
                  for (i = 0, a = 16 * n; i < 16; ++i, ++a) r[i] ^= t[a];
                  for (i = 0; i < 16; i += 4) {
                    var h = c[r[i]],
                      f = c[r[i + 1]],
                      d = c[r[i + 2]],
                      p = c[r[i + 3]];
                    s = h ^ f >>> 8 ^ f << 24 ^ d >>> 16 ^ d << 16 ^ p >>> 24 ^ p << 8, r[i] = s >>> 24 & 255, r[i + 1] = s >> 16 & 255, r[i + 2] = s >> 8 & 255, r[i + 3] = 255 & s;
                  }
                }
                for (s = r[13], r[13] = r[9], r[9] = r[5], r[5] = r[1], r[1] = s, s = r[14], l = r[10], r[14] = r[6], r[10] = r[2], r[6] = s, r[2] = l, s = r[15], l = r[11], u = r[7], r[15] = r[3], r[11] = s, r[7] = l, r[3] = u, i = 0; i < 16; ++i) r[i] = o[r[i]], r[i] ^= t[i];
                return r;
              }
              function r(e, t) {
                var r,
                  n,
                  i,
                  o,
                  c = new Uint8Array(16);
                for (c.set(e), u = 0; u < 16; ++u) c[u] ^= t[u];
                for (l = 1; l < 14; l++) {
                  for (u = 0; u < 16; ++u) c[u] = a[c[u]];
                  i = c[1], c[1] = c[5], c[5] = c[9], c[9] = c[13], c[13] = i, i = c[2], n = c[6], c[2] = c[10], c[6] = c[14], c[10] = i, c[14] = n, i = c[3], n = c[7], r = c[11], c[3] = c[15], c[7] = i, c[11] = n, c[15] = r;
                  for (var u = 0; u < 16; u += 4) {
                    var h = c[u + 0],
                      f = c[u + 1],
                      d = c[u + 2],
                      p = c[u + 3];
                    r = h ^ f ^ d ^ p, c[u + 0] ^= r ^ s[h ^ f], c[u + 1] ^= r ^ s[f ^ d], c[u + 2] ^= r ^ s[d ^ p], c[u + 3] ^= r ^ s[p ^ h];
                  }
                  for (u = 0, o = 16 * l; u < 16; ++u, ++o) c[u] ^= t[o];
                }
                for (u = 0; u < 16; ++u) c[u] = a[c[u]];
                for (i = c[1], c[1] = c[5], c[5] = c[9], c[9] = c[13], c[13] = i, i = c[2], n = c[6], c[2] = c[10], c[6] = c[14], c[10] = i, c[14] = n, i = c[3], n = c[7], r = c[11], c[3] = c[15], c[7] = i, c[11] = n, c[15] = r, u = 0, o = 224; u < 16; ++u, ++o) c[u] ^= t[o];
                return c;
              }
              function n(t) {
                this.key = e(t), this.buffer = new Uint8Array(16), this.bufferPosition = 0;
              }
              function i(e, r) {
                var n,
                  i,
                  a,
                  o = e.length,
                  s = this.buffer,
                  l = this.bufferPosition,
                  c = [],
                  u = this.iv;
                for (n = 0; n < o; ++n) if (s[l] = e[n], !(++l < 16)) {
                  var h = t(s, this.key);
                  for (i = 0; i < 16; ++i) h[i] ^= u[i];
                  u = s, c.push(h), s = new Uint8Array(16), l = 0;
                }
                if (this.buffer = s, this.bufferLength = l, this.iv = u, 0 === c.length) return new Uint8Array([]);
                var f = 16 * c.length;
                if (r) {
                  var d = c[c.length - 1],
                    p = d[15];
                  if (p <= 16) {
                    for (n = 15, a = 16 - p; n >= a; --n) if (d[n] !== p) {
                      p = 0;
                      break;
                    }
                    f -= p, c[c.length - 1] = d.subarray(0, 16 - p);
                  }
                }
                var m = new Uint8Array(f);
                for (n = 0, i = 0, a = c.length; n < a; ++n, i += 16) m.set(c[n], i);
                return m;
              }
              for (var a = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), o = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), s = new Uint8Array(256), l = 0; l < 256; l++) s[l] = l < 128 ? l << 1 : l << 1 ^ 27;
              var c = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]);
              return n.prototype = {
                decryptBlock: function decryptBlock(e, t, r) {
                  var n,
                    a = e.length,
                    o = this.buffer,
                    s = this.bufferPosition;
                  if (r) this.iv = r;else {
                    for (n = 0; s < 16 && n < a; ++n, ++s) o[s] = e[n];
                    if (s < 16) return this.bufferLength = s, new Uint8Array([]);
                    this.iv = o, e = e.subarray(16);
                  }
                  return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = i, this.decryptBlock(e, t);
                },
                encrypt: function encrypt(e, t) {
                  var n,
                    i,
                    a,
                    o = e.length,
                    s = this.buffer,
                    l = this.bufferPosition,
                    c = [];
                  for (t || (t = new Uint8Array(16)), n = 0; n < o; ++n) if (s[l] = e[n], !(++l < 16)) {
                    for (i = 0; i < 16; ++i) s[i] ^= t[i];
                    var u = r(s, this.key);
                    this.iv = u, c.push(u), s = new Uint8Array(16), l = 0;
                  }
                  if (this.buffer = s, this.bufferLength = l, this.iv = t, 0 === c.length) return new Uint8Array([]);
                  var h = 16 * c.length,
                    f = new Uint8Array(h);
                  for (n = 0, i = 0, a = c.length; n < a; ++n, i += 16) f.set(c[n], i);
                  return f;
                }
              }, n;
            }(),
            k = function () {
              function e(e, t) {
                if (e.length !== t.length) return !1;
                for (var r = 0; r < e.length; r++) if (e[r] !== t[r]) return !1;
                return !0;
              }
              function t() {}
              return t.prototype = {
                checkOwnerPassword: function checkOwnerPassword(t, r, n, i) {
                  var a = new Uint8Array(t.length + 56);
                  return a.set(t, 0), a.set(r, t.length), a.set(n, t.length + r.length), e(_(a, 0, a.length), i);
                },
                checkUserPassword: function checkUserPassword(t, r, n) {
                  var i = new Uint8Array(t.length + 8);
                  return i.set(t, 0), i.set(r, t.length), e(_(i, 0, i.length), n);
                },
                getOwnerKey: function getOwnerKey(e, t, r, n) {
                  var i = new Uint8Array(e.length + 56);
                  i.set(e, 0), i.set(t, e.length), i.set(r, e.length + t.length);
                  var a = _(i, 0, i.length);
                  return new T(a).decryptBlock(n, !1, new Uint8Array(16));
                },
                getUserKey: function getUserKey(e, t, r) {
                  var n = new Uint8Array(e.length + 8);
                  n.set(e, 0), n.set(t, e.length);
                  var i = _(n, 0, n.length);
                  return new T(i).decryptBlock(r, !1, new Uint8Array(16));
                }
              }, t;
            }(),
            R = function () {
              function e(e, t) {
                var r = new Uint8Array(e.length + t.length);
                return r.set(e, 0), r.set(t, e.length), r;
              }
              function t(t, r, n) {
                for (var i = _(r, 0, r.length).subarray(0, 32), a = [0], o = 0; o < 64 || a[a.length - 1] > o - 32;) {
                  var s = t.length + i.length + n.length,
                    l = new Uint8Array(64 * s),
                    c = e(t, i);
                  c = e(c, n);
                  for (var u = 0, h = 0; u < 64; u++, h += s) l.set(c, h);
                  a = new A(i.subarray(0, 16)).encrypt(l, i.subarray(16, 32));
                  for (var f = 0, d = 0; d < 16; d++) f *= 1, f %= 3, f += (a[d] >>> 0) % 3, f %= 3;
                  0 === f ? i = _(a, 0, a.length) : 1 === f ? i = C(a, 0, a.length) : 2 === f && (i = S(a, 0, a.length)), o++;
                }
                return i.subarray(0, 32);
              }
              function r() {}
              function n(e, t) {
                if (e.length !== t.length) return !1;
                for (var r = 0; r < e.length; r++) if (e[r] !== t[r]) return !1;
                return !0;
              }
              return r.prototype = {
                hash: function hash(e, r, n) {
                  return t(e, r, n);
                },
                checkOwnerPassword: function checkOwnerPassword(e, r, i, a) {
                  var o = new Uint8Array(e.length + 56);
                  return o.set(e, 0), o.set(r, e.length), o.set(i, e.length + r.length), n(t(e, o, i), a);
                },
                checkUserPassword: function checkUserPassword(e, r, i) {
                  var a = new Uint8Array(e.length + 8);
                  return a.set(e, 0), a.set(r, e.length), n(t(e, a, []), i);
                },
                getOwnerKey: function getOwnerKey(e, r, n, i) {
                  var a = new Uint8Array(e.length + 56);
                  a.set(e, 0), a.set(r, e.length), a.set(n, e.length + r.length);
                  var o = t(e, a, n);
                  return new T(o).decryptBlock(i, !1, new Uint8Array(16));
                },
                getUserKey: function getUserKey(e, r, n) {
                  var i = new Uint8Array(e.length + 8);
                  i.set(e, 0), i.set(r, e.length);
                  var a = t(e, i, []);
                  return new T(a).decryptBlock(n, !1, new Uint8Array(16));
                }
              }, r;
            }(),
            I = function () {
              function e(e, t) {
                this.StringCipherConstructor = e, this.StreamCipherConstructor = t;
              }
              return e.prototype = {
                createStream: function createStream(e, t) {
                  var r = new this.StreamCipherConstructor();
                  return new b(e, t, function (e, t) {
                    return r.decryptBlock(e, t);
                  });
                },
                decryptString: function decryptString(e) {
                  var t = new this.StringCipherConstructor(),
                    r = d(e);
                  return r = t.decryptBlock(r, !0), l(r);
                }
              }, e;
            }(),
            M = function () {
              function e(e, t, r, n, i, a, o, s, l, c, u, h) {
                if (t) {
                  var f = Math.min(127, t.length);
                  t = t.subarray(0, f);
                } else t = [];
                var d;
                return d = 6 === e ? new R() : new k(), d.checkUserPassword(t, s, o) ? d.getUserKey(t, l, u) : t.length && d.checkOwnerPassword(t, n, a, r) ? d.getOwnerKey(t, i, a, c) : null;
              }
              function t(e, t, r, n, i, a, o, s) {
                var c,
                  u,
                  h = 40 + r.length + e.length,
                  f = new Uint8Array(h),
                  d = 0;
                if (t) for (u = Math.min(32, t.length); d < u; ++d) f[d] = t[d];
                for (c = 0; d < 32;) f[d++] = l[c++];
                for (c = 0, u = r.length; c < u; ++c) f[d++] = r[c];
                for (f[d++] = 255 & i, f[d++] = i >> 8 & 255, f[d++] = i >> 16 & 255, f[d++] = i >>> 24 & 255, c = 0, u = e.length; c < u; ++c) f[d++] = e[c];
                a >= 4 && !s && (f[d++] = 255, f[d++] = 255, f[d++] = 255, f[d++] = 255);
                var p = w(f, 0, d),
                  m = o >> 3;
                if (a >= 3) for (c = 0; c < 50; ++c) p = w(p, 0, m);
                var g,
                  v,
                  b = p.subarray(0, m);
                if (a >= 3) {
                  for (d = 0; d < 32; ++d) f[d] = l[d];
                  for (c = 0, u = e.length; c < u; ++c) f[d++] = e[c];
                  g = new y(b), v = g.encryptBlock(w(f, 0, d)), u = b.length;
                  var x,
                    _ = new Uint8Array(u);
                  for (c = 1; c <= 19; ++c) {
                    for (x = 0; x < u; ++x) _[x] = b[x] ^ c;
                    g = new y(_), v = g.encryptBlock(v);
                  }
                  for (c = 0, u = v.length; c < u; ++c) if (n[c] !== v[c]) return null;
                } else for (g = new y(b), v = g.encryptBlock(l), c = 0, u = v.length; c < u; ++c) if (n[c] !== v[c]) return null;
                return b;
              }
              function r(e, t, r, n) {
                var i,
                  a,
                  o = new Uint8Array(32),
                  s = 0;
                for (a = Math.min(32, e.length); s < a; ++s) o[s] = e[s];
                for (i = 0; s < 32;) o[s++] = l[i++];
                var c = w(o, 0, s),
                  u = n >> 3;
                if (r >= 3) for (i = 0; i < 50; ++i) c = w(c, 0, c.length);
                var h, f;
                if (r >= 3) {
                  f = t;
                  var d,
                    p = new Uint8Array(u);
                  for (i = 19; i >= 0; i--) {
                    for (d = 0; d < u; ++d) p[d] = c[d] ^ i;
                    h = new y(p), f = h.encryptBlock(f);
                  }
                } else h = new y(c.subarray(0, u)), f = h.encryptBlock(t);
                return f;
              }
              function n(n, i, a) {
                var l = n.get("Filter");
                g(l, "Standard") || u("unknown encryption method"), this.dict = n;
                var h = n.get("V");
                (!f(h) || 1 !== h && 2 !== h && 4 !== h && 5 !== h) && u("unsupported encryption algorithm"), this.algorithm = h;
                var m = n.get("Length");
                if (!m) if (h <= 3) m = 40;else {
                  var y = n.get("CF"),
                    w = n.get("StmF");
                  if (v(y) && g(w)) {
                    y.suppressEncryption = !0;
                    var x = y.get(w.name);
                    m = x && x.get("Length") || 128, m < 40 && (m <<= 3);
                  }
                }
                (!f(m) || m < 40 || m % 8 != 0) && u("invalid key length");
                var _ = d(n.get("O")).subarray(0, 32),
                  S = d(n.get("U")).subarray(0, 32),
                  C = n.get("P"),
                  E = n.get("R"),
                  A = (4 === h || 5 === h) && !1 !== n.get("EncryptMetadata");
                this.encryptMetadata = A;
                var T,
                  k = d(i);
                if (a) {
                  if (6 === E) try {
                    a = p(a);
                  } catch (e) {
                    c("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                  }
                  T = d(a);
                }
                var R;
                if (5 !== h) R = t(k, T, _, S, C, E, m, A);else {
                  R = e(E, T, _, d(n.get("O")).subarray(32, 40), d(n.get("O")).subarray(40, 48), d(n.get("U")).subarray(0, 48), S, d(n.get("U")).subarray(32, 40), d(n.get("U")).subarray(40, 48), d(n.get("OE")), d(n.get("UE")), d(n.get("Perms")));
                }
                if (!R && !a) throw new o("No password given", s.NEED_PASSWORD);
                if (!R && a) {
                  R = t(k, r(T, _, E, m), _, S, C, E, m, A);
                }
                if (!R) throw new o("Incorrect Password", s.INCORRECT_PASSWORD);
                if (this.encryptionKey = R, h >= 4) {
                  var I = n.get("CF");
                  v(I) && (I.suppressEncryption = !0), this.cf = I, this.stmf = n.get("StmF") || b, this.strf = n.get("StrF") || b, this.eff = n.get("EFF") || this.stmf;
                }
              }
              function i(e, t, r, n) {
                var i,
                  a,
                  o = new Uint8Array(r.length + 9);
                for (i = 0, a = r.length; i < a; ++i) o[i] = r[i];
                return o[i++] = 255 & e, o[i++] = e >> 8 & 255, o[i++] = e >> 16 & 255, o[i++] = 255 & t, o[i++] = t >> 8 & 255, n && (o[i++] = 115, o[i++] = 65, o[i++] = 108, o[i++] = 84), w(o, 0, i).subarray(0, Math.min(r.length + 5, 16));
              }
              function a(e, t, r, n, a) {
                h(g(t), "Invalid crypt filter name.");
                var o,
                  s = e.get(t.name);
                return null !== s && void 0 !== s && (o = s.get("CFM")), o && "None" !== o.name ? "V2" === o.name ? function () {
                  return new y(i(r, n, a, !1));
                } : "AESV2" === o.name ? function () {
                  return new A(i(r, n, a, !0));
                } : "AESV3" === o.name ? function () {
                  return new T(a);
                } : void u("Unknown crypto method") : function () {
                  return new E();
                };
              }
              var l = new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]),
                b = m.get("Identity");
              return n.prototype = {
                createCipherTransform: function createCipherTransform(e, t) {
                  if (4 === this.algorithm || 5 === this.algorithm) return new I(a(this.cf, this.stmf, e, t, this.encryptionKey), a(this.cf, this.strf, e, t, this.encryptionKey));
                  var r = i(e, t, this.encryptionKey, !1),
                    n = function n() {
                      return new y(r);
                    };
                  return new I(n, n);
                }
              }, n;
            }();
          t.AES128Cipher = A, t.AES256Cipher = T, t.ARCFourCipher = y, t.CipherTransformFactory = M, t.PDF17 = k, t.PDF20 = R, t.calculateMD5 = w, t.calculateSHA256 = _, t.calculateSHA384 = C, t.calculateSHA512 = S;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(2),
            o = r(6),
            s = r(34),
            l = r(4),
            c = r(38),
            u = r(33),
            h = r(7),
            f = r(40),
            d = r(30),
            p = r(37),
            m = r(28),
            g = r(5),
            v = r(21),
            b = r(22),
            y = r(8),
            w = n.FONT_IDENTITY_MATRIX,
            x = n.IDENTITY_MATRIX,
            _ = n.UNSUPPORTED_FEATURES,
            S = n.ImageKind,
            C = n.OPS,
            E = n.NativeImageDecoding,
            A = n.TextRenderingMode,
            T = n.CMapCompressionType,
            k = n.Util,
            R = n.assert,
            I = n.createPromiseCapability,
            M = n.error,
            O = n.info,
            P = n.isArray,
            B = n.isNum,
            D = n.isString,
            L = n.getLookupTableFactory,
            F = n.warn,
            N = i.Dict,
            U = i.Name,
            j = i.isEOF,
            z = i.isCmd,
            H = i.isDict,
            G = i.isName,
            V = i.isRef,
            q = i.isStream,
            W = a.DecodeStream,
            X = a.JpegStream,
            Y = a.Stream,
            K = o.Lexer,
            Z = o.Parser,
            J = s.PDFImage,
            Q = l.ColorSpace,
            $ = c.MurmurHash3_64,
            ee = u.ErrorFont,
            te = u.FontFlags,
            re = u.Font,
            ne = u.IdentityToUnicodeMap,
            ie = u.ToUnicodeMap,
            ae = u.getFontType,
            oe = h.isPDFFunction,
            se = h.PDFFunction,
            le = f.Pattern,
            ce = f.getTilingPatternIR,
            ue = d.CMapFactory,
            he = d.IdentityCMap,
            fe = p.getMetrics,
            de = m.bidi,
            pe = g.WinAnsiEncoding,
            me = g.StandardEncoding,
            ge = g.MacRomanEncoding,
            ve = g.SymbolSetEncoding,
            be = g.ZapfDingbatsEncoding,
            ye = g.getEncoding,
            we = v.getStdFontMap,
            xe = v.getSerifFonts,
            _e = v.getSymbolsFonts,
            Se = b.getNormalizedUnicodes,
            Ce = b.reverseIfRtl,
            Ee = b.getUnicodeForGlyph,
            Ae = y.getGlyphsUnicode,
            Te = function () {
              function e(e, t, r, n) {
                this.xref = e, this.resources = t, this.handler = r, this.forceDataSchema = n;
              }
              function t(e) {
                var t = this,
                  r = e.pdfManager,
                  n = e.xref,
                  a = e.handler,
                  o = e.pageIndex,
                  s = e.idFactory,
                  l = e.fontCache,
                  c = e.builtInCMapCache,
                  u = e.options,
                  h = void 0 === u ? null : u;
                this.pdfManager = r, this.xref = n, this.handler = a, this.pageIndex = o, this.idFactory = s, this.fontCache = l, this.builtInCMapCache = c, this.options = h || i, this.fetchBuiltInCMap = function (e) {
                  var r = t.builtInCMapCache[e];
                  return r ? Promise.resolve(r) : t.handler.sendWithPromise("FetchBuiltInCMap", {
                    name: e
                  }).then(function (r) {
                    return r.compressionType !== T.NONE && (t.builtInCMapCache[e] = r), r;
                  });
                };
              }
              function r() {
                this.reset();
              }
              function n(e) {
                if (!G(e)) return "source-over";
                switch (e.name) {
                  case "Normal":
                  case "Compatible":
                    return "source-over";
                  case "Multiply":
                    return "multiply";
                  case "Screen":
                    return "screen";
                  case "Overlay":
                    return "overlay";
                  case "Darken":
                    return "darken";
                  case "Lighten":
                    return "lighten";
                  case "ColorDodge":
                    return "color-dodge";
                  case "ColorBurn":
                    return "color-burn";
                  case "HardLight":
                    return "hard-light";
                  case "SoftLight":
                    return "soft-light";
                  case "Difference":
                    return "difference";
                  case "Exclusion":
                    return "exclusion";
                  case "Hue":
                    return "hue";
                  case "Saturation":
                    return "saturation";
                  case "Color":
                    return "color";
                  case "Luminosity":
                    return "luminosity";
                }
                return F("Unsupported blend mode: " + e.name), "source-over";
              }
              var i = {
                forceDataSchema: !1,
                maxImageSize: -1,
                disableFontFace: !1,
                nativeImageDecoderSupport: E.DECODE,
                ignoreErrors: !1
              };
              e.prototype = {
                canDecode: function canDecode(t) {
                  return t instanceof X && e.isDecodable(t, this.xref, this.resources);
                },
                decode: function decode(e) {
                  var t = e.dict,
                    r = t.get("ColorSpace", "CS");
                  r = Q.parse(r, this.xref, this.resources);
                  var n = r.numComps;
                  return this.handler.sendWithPromise("JpegDecode", [e.getIR(this.forceDataSchema), n]).then(function (t) {
                    var r = t.data;
                    return new Y(r, 0, r.length, e.dict);
                  });
                }
              }, e.isSupported = function (e, t, r) {
                var n = e.dict;
                if (n.has("DecodeParms") || n.has("DP")) return !1;
                var i = Q.parse(n.get("ColorSpace", "CS"), t, r);
                return ("DeviceGray" === i.name || "DeviceRGB" === i.name) && i.isDefaultDecode(n.getArray("Decode", "D"));
              }, e.isDecodable = function (e, t, r) {
                var n = e.dict;
                if (n.has("DecodeParms") || n.has("DP")) return !1;
                var i = Q.parse(n.get("ColorSpace", "CS"), t, r);
                return (1 === i.numComps || 3 === i.numComps) && i.isDefaultDecode(n.getArray("Decode", "D"));
              };
              r.prototype = {
                check: function check() {
                  return !(++this.checked < 100) && (this.checked = 0, this.endTime <= Date.now());
                },
                reset: function reset() {
                  this.endTime = Date.now() + 20, this.checked = 0;
                }
              };
              var a = Promise.resolve();
              return t.prototype = {
                clone: function clone() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i,
                    t = Object.create(this);
                  return t.options = e, t;
                },
                hasBlendModes: function hasBlendModes(e) {
                  if (!H(e)) return !1;
                  var t = Object.create(null);
                  e.objId && (t[e.objId] = !0);
                  for (var r = [e], n = this.xref; r.length;) {
                    var i,
                      a,
                      o,
                      s = r.shift(),
                      l = s.get("ExtGState");
                    if (H(l)) {
                      var c = l.getKeys();
                      for (a = 0, o = c.length; a < o; a++) {
                        i = c[a];
                        var u = l.get(i),
                          h = u.get("BM");
                        if (G(h) && "Normal" !== h.name) return !0;
                      }
                    }
                    var f = s.get("XObject");
                    if (H(f)) {
                      var d = f.getKeys();
                      for (a = 0, o = d.length; a < o; a++) {
                        i = d[a];
                        var p = f.getRaw(i);
                        if (V(p)) {
                          if (t[p.toString()]) continue;
                          p = n.fetch(p);
                        }
                        if (q(p)) {
                          if (p.dict.objId) {
                            if (t[p.dict.objId]) continue;
                            t[p.dict.objId] = !0;
                          }
                          var m = p.dict.get("Resources");
                          !H(m) || m.objId && t[m.objId] || (r.push(m), m.objId && (t[m.objId] = !0));
                        }
                      }
                    }
                  }
                  return !1;
                },
                buildFormXObject: function buildFormXObject(e, t, r, n, i, a) {
                  var o = t.dict,
                    s = o.getArray("Matrix"),
                    l = o.getArray("BBox"),
                    c = o.get("Group");
                  if (c) {
                    var u,
                      h = {
                        matrix: s,
                        bbox: l,
                        smask: r,
                        isolated: !1,
                        knockout: !1
                      },
                      f = c.get("S");
                    G(f, "Transparency") && (h.isolated = c.get("I") || !1, h.knockout = c.get("K") || !1, u = c.has("CS") ? Q.parse(c.get("CS"), this.xref, e) : null), r && r.backdrop && (u = u || Q.singletons.rgb, r.backdrop = u.getRgb(r.backdrop, 0)), n.addOp(C.beginGroup, [h]);
                  }
                  return n.addOp(C.paintFormXObjectBegin, [s, l]), this.getOperatorList({
                    stream: t,
                    task: i,
                    resources: o.get("Resources") || e,
                    operatorList: n,
                    initialState: a
                  }).then(function () {
                    n.addOp(C.paintFormXObjectEnd, []), c && n.addOp(C.endGroup, [h]);
                  });
                },
                buildPaintImageXObject: function buildPaintImageXObject(t, r, n, i, a, o) {
                  var s = this,
                    l = r.dict,
                    c = l.get("Width", "W"),
                    u = l.get("Height", "H");
                  if (!(c && B(c) && u && B(u))) return void F("Image dimensions are missing, or not numbers.");
                  var h = this.options.maxImageSize;
                  if (-1 !== h && c * u > h) return void F("Image exceeded maximum allowed size and was removed.");
                  var f,
                    d,
                    p = l.get("ImageMask", "IM") || !1;
                  if (p) {
                    var m = l.get("Width", "W"),
                      g = l.get("Height", "H"),
                      v = m + 7 >> 3,
                      b = r.getBytes(v * g),
                      y = l.getArray("Decode", "D"),
                      w = !!y && y[0] > 0;
                    return f = J.createMask(b, m, g, r instanceof W, w), f.cached = !0, d = [f], i.addOp(C.paintImageMaskXObject, d), void (a && (o[a] = {
                      fn: C.paintImageMaskXObject,
                      args: d
                    }));
                  }
                  var x = l.get("SMask", "SM") || !1,
                    _ = l.get("Mask") || !1;
                  if (n && !x && !_ && !(r instanceof X) && c + u < 200) {
                    return f = new J(this.xref, t, r, n, null, null).createImageData(!0), void i.addOp(C.paintInlineImageXObject, [f]);
                  }
                  var S = this.options.nativeImageDecoderSupport,
                    A = "img_" + this.idFactory.createObjId();
                  if (i.addDependency(A), d = [A, c, u], S !== E.NONE && !x && !_ && r instanceof X && e.isSupported(r, this.xref, t)) return i.addOp(C.paintJpegXObject, d), void this.handler.send("obj", [A, this.pageIndex, "JpegStream", r.getIR(this.options.forceDataSchema)]);
                  var T = null;
                  S === E.DECODE && (r instanceof X || _ instanceof X || x instanceof X) && (T = new e(this.xref, t, this.handler, this.options.forceDataSchema)), J.buildImage(this.handler, this.xref, t, r, n, T).then(function (e) {
                    var t = e.createImageData(!1);
                    s.handler.send("obj", [A, s.pageIndex, "Image", t], [t.data.buffer]);
                  }).catch(function (e) {
                    F("Unable to decode image: " + e), s.handler.send("obj", [A, s.pageIndex, "Image", null]);
                  }), i.addOp(C.paintImageXObject, d), a && (o[a] = {
                    fn: C.paintImageXObject,
                    args: d
                  });
                },
                handleSMask: function handleSMask(e, t, r, n, i) {
                  var a = e.get("G"),
                    o = {
                      subtype: e.get("S").name,
                      backdrop: e.get("BC")
                    },
                    s = e.get("TR");
                  if (oe(s)) {
                    for (var l = se.parse(this.xref, s), c = new Uint8Array(256), u = new Float32Array(1), h = 0; h < 256; h++) u[0] = h / 255, l(u, 0, u, 0), c[h] = 255 * u[0] | 0;
                    o.transferMap = c;
                  }
                  return this.buildFormXObject(t, a, o, r, n, i.state.clone());
                },
                handleTilingType: function handleTilingType(e, t, r, n, i, a, o) {
                  var s = new Re(),
                    l = [i.get("Resources"), r],
                    c = N.merge(this.xref, l);
                  return this.getOperatorList({
                    stream: n,
                    task: o,
                    resources: c,
                    operatorList: s
                  }).then(function () {
                    a.addDependencies(s.dependencies), a.addOp(e, ce({
                      fnArray: s.fnArray,
                      argsArray: s.argsArray
                    }, i, t));
                  });
                },
                handleSetFont: function handleSetFont(e, t, r, n, i, a) {
                  var o,
                    s = this;
                  return t && (t = t.slice(), o = t[0].name), this.loadFont(o, r, e).then(function (t) {
                    return t.font.isType3Font ? t.loadType3Data(s, e, n, i).then(function () {
                      return t;
                    }).catch(function (e) {
                      return s.handler.send("UnsupportedFeature", {
                        featureId: _.font
                      }), new ke("g_font_error", new ee("Type3 font load error: " + e), t.font);
                    }) : t;
                  }).then(function (e) {
                    return a.font = e.font, e.send(s.handler), e.loadedName;
                  });
                },
                handleText: function handleText(e, t) {
                  var r = this,
                    n = t.font,
                    i = n.charsToGlyphs(e),
                    a = !!(t.textRenderingMode & A.ADD_TO_PATH_FLAG);
                  if (n.data && (a || this.options.disableFontFace)) for (var o = function o(e) {
                      if (!n.renderer.hasBuiltPath(e)) {
                        var t = n.renderer.getPathJs(e);
                        r.handler.send("commonobj", [n.loadedName + "_path_" + e, "FontPath", t]);
                      }
                    }, s = 0, l = i.length; s < l; s++) {
                    var c = i[s];
                    o(c.fontChar);
                    var u = c.accent;
                    u && u.fontChar && o(u.fontChar);
                  }
                  return i;
                },
                setGState: function setGState(e, t, r, i, a) {
                  for (var o = this, s = [], l = t.getKeys(), c = Promise.resolve(), u = 0, h = l.length; u < h; u++) !function () {
                    var h = l[u],
                      f = t.get(h);
                    switch (h) {
                      case "Type":
                        break;
                      case "LW":
                      case "LC":
                      case "LJ":
                      case "ML":
                      case "D":
                      case "RI":
                      case "FL":
                      case "CA":
                      case "ca":
                        s.push([h, f]);
                        break;
                      case "Font":
                        c = c.then(function () {
                          return o.handleSetFont(e, null, f[0], r, i, a.state).then(function (e) {
                            r.addDependency(e), s.push([h, [e, f[1]]]);
                          });
                        });
                        break;
                      case "BM":
                        s.push([h, n(f)]);
                        break;
                      case "SMask":
                        if (G(f, "None")) {
                          s.push([h, !1]);
                          break;
                        }
                        H(f) ? (c = c.then(function () {
                          return o.handleSMask(f, e, r, i, a);
                        }), s.push([h, !0])) : F("Unsupported SMask type");
                        break;
                      case "OP":
                      case "op":
                      case "OPM":
                      case "BG":
                      case "BG2":
                      case "UCR":
                      case "UCR2":
                      case "TR":
                      case "TR2":
                      case "HT":
                      case "SM":
                      case "SA":
                      case "AIS":
                      case "TK":
                        O("graphic state operator " + h);
                        break;
                      default:
                        O("Unknown graphic state operator " + h);
                    }
                  }();
                  return c.then(function () {
                    s.length > 0 && r.addOp(C.setGState, [s]);
                  });
                },
                loadFont: function loadFont(e, t, r) {
                  function n() {
                    return Promise.resolve(new ke("g_font_error", new ee("Font " + e + " is not available"), t));
                  }
                  var i,
                    a = this,
                    o = this.xref;
                  if (t) R(V(t)), i = t;else {
                    var s = r.get("Font");
                    if (!s) return F("fontRes not available"), n();
                    i = s.getRaw(e);
                  }
                  if (!i) return F("fontRef not available"), n();
                  if (this.fontCache.has(i)) return this.fontCache.get(i);
                  if (t = o.fetchIfRef(i), !H(t)) return n();
                  if (t.translated) return t.translated;
                  var l,
                    c = I(),
                    u = this.preEvaluateFont(t),
                    h = u.descriptor,
                    f = V(i);
                  if (f && (l = i.toString()), H(h)) {
                    h.fontAliases || (h.fontAliases = Object.create(null));
                    var d = h.fontAliases,
                      p = u.hash;
                    if (d[p]) {
                      var m = d[p].aliasRef;
                      if (f && m && this.fontCache.has(m)) return this.fontCache.putAlias(i, m), this.fontCache.get(i);
                    } else d[p] = {
                      fontID: re.getFontID()
                    };
                    f && (d[p].aliasRef = i), l = d[p].fontID;
                  }
                  f ? this.fontCache.put(i, c.promise) : (l || (l = this.idFactory.createObjId()), this.fontCache.put("id_" + l, c.promise)), R(l, 'The "fontID" must be defined.'), t.loadedName = "g_" + this.pdfManager.docId + "_f" + l, t.translated = c.promise;
                  var g;
                  try {
                    g = this.translateFont(u);
                  } catch (e) {
                    g = Promise.reject(e);
                  }
                  return g.then(function (e) {
                    if (void 0 !== e.fontType) {
                      o.stats.fontTypes[e.fontType] = !0;
                    }
                    c.resolve(new ke(t.loadedName, e, t));
                  }).catch(function (e) {
                    a.handler.send("UnsupportedFeature", {
                      featureId: _.font
                    });
                    try {
                      var r = u.descriptor,
                        n = r && r.get("FontFile3"),
                        i = n && n.get("Subtype"),
                        s = ae(u.type, i && i.name);
                      o.stats.fontTypes[s] = !0;
                    } catch (e) {}
                    c.resolve(new ke(t.loadedName, new ee(e instanceof Error ? e.message : e), t));
                  }), c.promise;
                },
                buildPath: function buildPath(e, t, r) {
                  var n = e.length - 1;
                  if (r || (r = []), n < 0 || e.fnArray[n] !== C.constructPath) e.addOp(C.constructPath, [[t], r]);else {
                    var i = e.argsArray[n];
                    i[0].push(t), Array.prototype.push.apply(i[1], r);
                  }
                },
                handleColorN: function handleColorN(e, t, r, n, i, a, o) {
                  var s,
                    l = r[r.length - 1];
                  if (G(l) && (s = i.get(l.name))) {
                    var c = q(s) ? s.dict : s,
                      u = c.get("PatternType");
                    if (1 === u) {
                      var h = n.base ? n.base.getRgb(r, 0) : null;
                      return this.handleTilingType(t, h, a, s, c, e, o);
                    }
                    if (2 === u) {
                      var f = c.get("Shading"),
                        d = c.getArray("Matrix");
                      return s = le.parseShading(f, d, this.xref, a, this.handler), e.addOp(t, s.getIR()), Promise.resolve();
                    }
                    return Promise.reject(new Error("Unknown PatternType: " + u));
                  }
                  return e.addOp(t, r), Promise.resolve();
                },
                getOperatorList: function getOperatorList(e) {
                  function t(e) {
                    for (var t = 0, r = v.savedStatesDepth; t < r; t++) l.addOp(C.restore, []);
                  }
                  var n = this,
                    i = e.stream,
                    o = e.task,
                    s = e.resources,
                    l = e.operatorList,
                    c = e.initialState,
                    u = void 0 === c ? null : c;
                  s = s || N.empty, u = u || new Oe(), R(l, 'getOperatorList: missing "operatorList" parameter');
                  var h = this,
                    f = this.xref,
                    d = Object.create(null),
                    p = s.get("XObject") || N.empty,
                    m = s.get("Pattern") || N.empty,
                    g = new Ie(u),
                    v = new Pe(i, f, g),
                    b = new r();
                  return new Promise(function e(r, n) {
                    var i = function i(t) {
                      t.then(function () {
                        try {
                          e(r, n);
                        } catch (e) {
                          n(e);
                        }
                      }, n);
                    };
                    o.ensureNotTerminated(), b.reset();
                    for (var c, u, y, w, x = {}; !(c = b.check()) && (x.args = null, v.read(x));) {
                      var _ = x.args,
                        S = x.fn;
                      switch (0 | S) {
                        case C.paintXObject:
                          if (_[0].code) break;
                          var E = _[0].name;
                          if (!E) {
                            F("XObject must be referred to by name.");
                            continue;
                          }
                          if (void 0 !== d[E]) {
                            l.addOp(d[E].fn, d[E].args), _ = null;
                            continue;
                          }
                          var A = p.get(E);
                          if (A) {
                            R(q(A), "XObject should be a stream");
                            var T = A.dict.get("Subtype");
                            if (R(G(T), "XObject should have a Name subtype"), "Form" === T.name) return g.save(), void i(h.buildFormXObject(s, A, null, l, o, g.state.clone()).then(function () {
                              g.restore();
                            }));
                            if ("Image" === T.name) {
                              h.buildPaintImageXObject(s, A, !1, l, E, d), _ = null;
                              continue;
                            }
                            if ("PS" === T.name) {
                              O("Ignored XObject subtype PS");
                              continue;
                            }
                            M("Unhandled XObject subtype " + T.name);
                          }
                          break;
                        case C.setFont:
                          var k = _[1];
                          return void i(h.handleSetFont(s, _, null, l, o, g.state).then(function (e) {
                            l.addDependency(e), l.addOp(C.setFont, [e, k]);
                          }));
                        case C.endInlineImage:
                          var I = _[0].cacheKey;
                          if (I) {
                            var P = d[I];
                            if (void 0 !== P) {
                              l.addOp(P.fn, P.args), _ = null;
                              continue;
                            }
                          }
                          h.buildPaintImageXObject(s, _[0], !0, l, I, d), _ = null;
                          continue;
                        case C.showText:
                          _[0] = h.handleText(_[0], g.state);
                          break;
                        case C.showSpacedText:
                          var L = _[0],
                            U = [],
                            j = L.length,
                            z = g.state;
                          for (u = 0; u < j; ++u) {
                            var V = L[u];
                            D(V) ? Array.prototype.push.apply(U, h.handleText(V, z)) : B(V) && U.push(V);
                          }
                          _[0] = U, S = C.showText;
                          break;
                        case C.nextLineShowText:
                          l.addOp(C.nextLine), _[0] = h.handleText(_[0], g.state), S = C.showText;
                          break;
                        case C.nextLineSetSpacingShowText:
                          l.addOp(C.nextLine), l.addOp(C.setWordSpacing, [_.shift()]), l.addOp(C.setCharSpacing, [_.shift()]), _[0] = h.handleText(_[0], g.state), S = C.showText;
                          break;
                        case C.setTextRenderingMode:
                          g.state.textRenderingMode = _[0];
                          break;
                        case C.setFillColorSpace:
                          g.state.fillColorSpace = Q.parse(_[0], f, s);
                          continue;
                        case C.setStrokeColorSpace:
                          g.state.strokeColorSpace = Q.parse(_[0], f, s);
                          continue;
                        case C.setFillColor:
                          w = g.state.fillColorSpace, _ = w.getRgb(_, 0), S = C.setFillRGBColor;
                          break;
                        case C.setStrokeColor:
                          w = g.state.strokeColorSpace, _ = w.getRgb(_, 0), S = C.setStrokeRGBColor;
                          break;
                        case C.setFillGray:
                          g.state.fillColorSpace = Q.singletons.gray, _ = Q.singletons.gray.getRgb(_, 0), S = C.setFillRGBColor;
                          break;
                        case C.setStrokeGray:
                          g.state.strokeColorSpace = Q.singletons.gray, _ = Q.singletons.gray.getRgb(_, 0), S = C.setStrokeRGBColor;
                          break;
                        case C.setFillCMYKColor:
                          g.state.fillColorSpace = Q.singletons.cmyk, _ = Q.singletons.cmyk.getRgb(_, 0), S = C.setFillRGBColor;
                          break;
                        case C.setStrokeCMYKColor:
                          g.state.strokeColorSpace = Q.singletons.cmyk, _ = Q.singletons.cmyk.getRgb(_, 0), S = C.setStrokeRGBColor;
                          break;
                        case C.setFillRGBColor:
                          g.state.fillColorSpace = Q.singletons.rgb, _ = Q.singletons.rgb.getRgb(_, 0);
                          break;
                        case C.setStrokeRGBColor:
                          g.state.strokeColorSpace = Q.singletons.rgb, _ = Q.singletons.rgb.getRgb(_, 0);
                          break;
                        case C.setFillColorN:
                          if (w = g.state.fillColorSpace, "Pattern" === w.name) return void i(h.handleColorN(l, C.setFillColorN, _, w, m, s, o));
                          _ = w.getRgb(_, 0), S = C.setFillRGBColor;
                          break;
                        case C.setStrokeColorN:
                          if (w = g.state.strokeColorSpace, "Pattern" === w.name) return void i(h.handleColorN(l, C.setStrokeColorN, _, w, m, s, o));
                          _ = w.getRgb(_, 0), S = C.setStrokeRGBColor;
                          break;
                        case C.shadingFill:
                          var W = s.get("Shading");
                          R(W, "No shading resource found");
                          var X = W.get(_[0].name);
                          R(X, "No shading object found");
                          _ = [le.parseShading(X, null, f, s, h.handler).getIR()], S = C.shadingFill;
                          break;
                        case C.setGState:
                          var Y = _[0],
                            K = s.get("ExtGState");
                          if (!H(K) || !K.has(Y.name)) break;
                          var Z = K.get(Y.name);
                          return void i(h.setGState(s, Z, l, o, g));
                        case C.moveTo:
                        case C.lineTo:
                        case C.curveTo:
                        case C.curveTo2:
                        case C.curveTo3:
                        case C.closePath:
                        case C.rectangle:
                          h.buildPath(l, S, _);
                          continue;
                        case C.markPoint:
                        case C.markPointProps:
                        case C.beginMarkedContent:
                        case C.beginMarkedContentProps:
                        case C.endMarkedContent:
                        case C.beginCompat:
                        case C.endCompat:
                          continue;
                        default:
                          if (null !== _) {
                            for (u = 0, y = _.length; u < y && !(_[u] instanceof N); u++);
                            if (u < y) {
                              F("getOperatorList - ignoring operator: " + S);
                              continue;
                            }
                          }
                      }
                      l.addOp(S, _);
                    }
                    if (c) return void i(a);
                    t(), r();
                  }).catch(function (e) {
                    if (n.options.ignoreErrors) return n.handler.send("UnsupportedFeature", {
                      featureId: _.unknown
                    }), F("getOperatorList - ignoring errors during task: " + o.name), void t();
                    throw e;
                  });
                },
                getTextContent: function getTextContent(e) {
                  function t() {
                    if (A.initialized) return A;
                    var e = _.font;
                    e.loadedName in E.styles || (E.styles[e.loadedName] = {
                      fontFamily: e.fallbackName,
                      ascent: e.ascent,
                      descent: e.descent,
                      vertical: e.vertical
                    }), A.fontName = e.loadedName;
                    var t = [_.fontSize * _.textHScale, 0, 0, _.fontSize, 0, _.textRise];
                    if (e.isType3Font && _.fontMatrix !== w && 1 === _.fontSize) {
                      var r = e.bbox[3] - e.bbox[1];
                      r > 0 && (r *= _.fontMatrix[3], t[3] *= r);
                    }
                    var n = k.transform(_.ctm, k.transform(_.textMatrix, t));
                    A.transform = n, e.vertical ? (A.width = Math.sqrt(n[0] * n[0] + n[1] * n[1]), A.height = 0, A.vertical = !0) : (A.width = 0, A.height = Math.sqrt(n[2] * n[2] + n[3] * n[3]), A.vertical = !1);
                    var i = _.textLineMatrix[0],
                      a = _.textLineMatrix[1],
                      o = Math.sqrt(i * i + a * a);
                    i = _.ctm[0], a = _.ctm[1];
                    var s = Math.sqrt(i * i + a * a);
                    A.textAdvanceScale = s * o, A.lastAdvanceWidth = 0, A.lastAdvanceHeight = 0;
                    var l = e.spaceWidth / 1e3 * _.fontSize;
                    return l ? (A.spaceWidth = l, A.fakeSpaceMin = l * T, A.fakeMultiSpaceMin = l * I, A.fakeMultiSpaceMax = l * M, A.textRunBreakAllowed = !e.isMonospace) : (A.spaceWidth = 0, A.fakeSpaceMin = 1 / 0, A.fakeMultiSpaceMin = 1 / 0, A.fakeMultiSpaceMax = 0, A.textRunBreakAllowed = !1), A.initialized = !0, A;
                  }
                  function n(e) {
                    for (var t, r = 0, n = e.length; r < n && (t = e.charCodeAt(r)) >= 32 && t <= 127;) r++;
                    return r < n ? e.replace(S, " ") : e;
                  }
                  function i(e) {
                    var t = e.str.join(""),
                      r = de(t, -1, e.vertical);
                    return {
                      str: v ? n(r.str) : r.str,
                      dir: r.dir,
                      width: e.width,
                      height: e.height,
                      transform: e.transform,
                      fontName: e.fontName
                    };
                  }
                  function o(e, t) {
                    return O.loadFont(e, t, d).then(function (e) {
                      _.font = e.font, _.fontMatrix = e.font.fontMatrix || w;
                    });
                  }
                  function s(e) {
                    for (var r = _.font, n = t(), i = 0, a = 0, o = r.charsToGlyphs(e), s = 0; s < o.length; s++) {
                      var c = o[s],
                        u = null;
                      u = r.vertical && c.vmetric ? c.vmetric[0] : c.width;
                      var h = c.unicode,
                        f = Se();
                      void 0 !== f[h] && (h = f[h]), h = Ce(h);
                      var d = _.charSpacing;
                      if (c.isSpace) {
                        var p = _.wordSpacing;
                        d += p, p > 0 && l(p, n.str);
                      }
                      var m = 0,
                        g = 0;
                      if (r.vertical) {
                        g = u * _.fontMatrix[0] * _.fontSize + d, a += g;
                      } else {
                        m = (u * _.fontMatrix[0] * _.fontSize + d) * _.textHScale, i += m;
                      }
                      _.translateTextMatrix(m, g), n.str.push(h);
                    }
                    return r.vertical ? (n.lastAdvanceHeight = a, n.height += Math.abs(a)) : (n.lastAdvanceWidth = i, n.width += i), n;
                  }
                  function l(e, t) {
                    if (!(e < A.fakeSpaceMin)) {
                      if (e < A.fakeMultiSpaceMin) return void t.push(" ");
                      for (var r = Math.round(e / A.spaceWidth); r-- > 0;) t.push(" ");
                    }
                  }
                  function c() {
                    A.initialized && (A.width *= A.textAdvanceScale, A.height *= A.textAdvanceScale, E.items.push(i(A)), A.initialized = !1, A.str.length = 0);
                  }
                  var u = this,
                    h = e.stream,
                    f = e.task,
                    d = e.resources,
                    p = e.stateManager,
                    m = void 0 === p ? null : p,
                    g = e.normalizeWhitespace,
                    v = void 0 !== g && g,
                    b = e.combineTextItems,
                    y = void 0 !== b && b;
                  d = d || N.empty, m = m || new Ie(new Me());
                  var _,
                    S = /\s/g,
                    E = {
                      items: [],
                      styles: Object.create(null)
                    },
                    A = {
                      initialized: !1,
                      str: [],
                      width: 0,
                      height: 0,
                      vertical: !1,
                      lastAdvanceWidth: 0,
                      lastAdvanceHeight: 0,
                      textAdvanceScale: 0,
                      spaceWidth: 0,
                      fakeSpaceMin: 1 / 0,
                      fakeMultiSpaceMin: 1 / 0,
                      fakeMultiSpaceMax: -0,
                      textRunBreakAllowed: !1,
                      transform: null,
                      fontName: null
                    },
                    T = .3,
                    I = 1.5,
                    M = 4,
                    O = this,
                    D = this.xref,
                    L = null,
                    U = Object.create(null),
                    j = new Pe(h, D, m),
                    z = new r();
                  return new Promise(function e(r, n) {
                    var i = function i(t) {
                      t.then(function () {
                        try {
                          e(r, n);
                        } catch (e) {
                          n(e);
                        }
                      }, n);
                    };
                    f.ensureNotTerminated(), z.reset();
                    for (var u, h = {}, p = []; !(u = z.check()) && (p.length = 0, h.args = p, j.read(h));) {
                      _ = m.state;
                      var g = h.fn;
                      p = h.args;
                      var b, w;
                      switch (0 | g) {
                        case C.setFont:
                          var S = p[0].name,
                            T = p[1];
                          if (_.font && S === _.fontName && T === _.fontSize) break;
                          return c(), _.fontName = S, _.fontSize = T, void i(o(S, null));
                        case C.setTextRise:
                          c(), _.textRise = p[0];
                          break;
                        case C.setHScale:
                          c(), _.textHScale = p[0] / 100;
                          break;
                        case C.setLeading:
                          c(), _.leading = p[0];
                          break;
                        case C.moveText:
                          var I = !!_.font && 0 === (_.font.vertical ? p[0] : p[1]);
                          if (b = p[0] - p[1], y && I && A.initialized && b > 0 && b <= A.fakeMultiSpaceMax) {
                            _.translateTextLineMatrix(p[0], p[1]), A.width += p[0] - A.lastAdvanceWidth, A.height += p[1] - A.lastAdvanceHeight, w = p[0] - A.lastAdvanceWidth - (p[1] - A.lastAdvanceHeight), l(w, A.str);
                            break;
                          }
                          c(), _.translateTextLineMatrix(p[0], p[1]), _.textMatrix = _.textLineMatrix.slice();
                          break;
                        case C.setLeadingMoveText:
                          c(), _.leading = -p[1], _.translateTextLineMatrix(p[0], p[1]), _.textMatrix = _.textLineMatrix.slice();
                          break;
                        case C.nextLine:
                          c(), _.carriageReturn();
                          break;
                        case C.setTextMatrix:
                          if (b = _.calcTextLineMatrixAdvance(p[0], p[1], p[2], p[3], p[4], p[5]), y && null !== b && A.initialized && b.value > 0 && b.value <= A.fakeMultiSpaceMax) {
                            _.translateTextLineMatrix(b.width, b.height), A.width += b.width - A.lastAdvanceWidth, A.height += b.height - A.lastAdvanceHeight, w = b.width - A.lastAdvanceWidth - (b.height - A.lastAdvanceHeight), l(w, A.str);
                            break;
                          }
                          c(), _.setTextMatrix(p[0], p[1], p[2], p[3], p[4], p[5]), _.setTextLineMatrix(p[0], p[1], p[2], p[3], p[4], p[5]);
                          break;
                        case C.setCharSpacing:
                          _.charSpacing = p[0];
                          break;
                        case C.setWordSpacing:
                          _.wordSpacing = p[0];
                          break;
                        case C.beginText:
                          c(), _.textMatrix = x.slice(), _.textLineMatrix = x.slice();
                          break;
                        case C.showSpacedText:
                          for (var M, D = p[0], F = 0, V = D.length; F < V; F++) if ("string" == typeof D[F]) s(D[F]);else if (B(D[F])) {
                            t(), b = D[F] * _.fontSize / 1e3;
                            var W = !1;
                            _.font.vertical ? (M = b, _.translateTextMatrix(0, M), (W = A.textRunBreakAllowed && b > A.fakeMultiSpaceMax) || (A.height += M)) : (b = -b, M = b * _.textHScale, _.translateTextMatrix(M, 0), (W = A.textRunBreakAllowed && b > A.fakeMultiSpaceMax) || (A.width += M)), W ? c() : b > 0 && l(b, A.str);
                          }
                          break;
                        case C.showText:
                          s(p[0]);
                          break;
                        case C.nextLineShowText:
                          c(), _.carriageReturn(), s(p[0]);
                          break;
                        case C.nextLineSetSpacingShowText:
                          c(), _.wordSpacing = p[0], _.charSpacing = p[1], _.carriageReturn(), s(p[2]);
                          break;
                        case C.paintXObject:
                          if (c(), p[0].code) break;
                          L || (L = d.get("XObject") || N.empty);
                          var X = p[0].name;
                          if (U.key === X) {
                            U.texts && (k.appendToArray(E.items, U.texts.items), k.extendObj(E.styles, U.texts.styles));
                            break;
                          }
                          var Y = L.get(X);
                          if (!Y) break;
                          R(q(Y), "XObject should be a stream");
                          var K = Y.dict.get("Subtype");
                          if (R(G(K), "XObject should have a Name subtype"), "Form" !== K.name) {
                            U.key = X, U.texts = null;
                            break;
                          }
                          var Z = m.state.clone(),
                            J = new Ie(Z),
                            Q = Y.dict.getArray("Matrix");
                          return P(Q) && 6 === Q.length && J.transform(Q), void i(O.getTextContent({
                            stream: Y,
                            task: f,
                            resources: Y.dict.get("Resources") || d,
                            stateManager: J,
                            normalizeWhitespace: v,
                            combineTextItems: y
                          }).then(function (e) {
                            k.appendToArray(E.items, e.items), k.extendObj(E.styles, e.styles), U.key = X, U.texts = e;
                          }));
                        case C.setGState:
                          c();
                          var $ = p[0],
                            ee = d.get("ExtGState");
                          if (!H(ee) || !G($)) break;
                          var te = ee.get($.name);
                          if (!H(te)) break;
                          var re = te.get("Font");
                          if (re) return _.fontName = null, _.fontSize = re[1], void i(o(null, re[0]));
                      }
                    }
                    if (u) return void i(a);
                    c(), r(E);
                  }).catch(function (e) {
                    if (u.options.ignoreErrors) return F("getTextContent - ignoring errors during task: " + f.name), c(), E;
                    throw e;
                  });
                },
                extractDataStructures: function extractDataStructures(e, t, r) {
                  var n = this,
                    i = this.xref,
                    a = e.get("ToUnicode") || t.get("ToUnicode"),
                    o = a ? this.readToUnicode(a) : Promise.resolve(void 0);
                  if (r.composite) {
                    var s = e.get("CIDSystemInfo");
                    H(s) && (r.cidSystemInfo = {
                      registry: s.get("Registry"),
                      ordering: s.get("Ordering"),
                      supplement: s.get("Supplement")
                    });
                    var l = e.get("CIDToGIDMap");
                    q(l) && (r.cidToGidMap = this.readCidToGidMap(l));
                  }
                  var c,
                    u = [],
                    h = null;
                  if (e.has("Encoding")) {
                    if (c = e.get("Encoding"), H(c)) {
                      if (h = c.get("BaseEncoding"), h = G(h) ? h.name : null, c.has("Differences")) for (var f = c.get("Differences"), d = 0, p = 0, m = f.length; p < m; p++) {
                        var g = i.fetchIfRef(f[p]);
                        B(g) ? d = g : G(g) ? u[d++] = g.name : M("Invalid entry in 'Differences' array: " + g);
                      }
                    } else G(c) ? h = c.name : M("Encoding is not a Name nor a Dict");
                    "MacRomanEncoding" !== h && "MacExpertEncoding" !== h && "WinAnsiEncoding" !== h && (h = null);
                  }
                  if (h) r.defaultEncoding = ye(h).slice();else {
                    var v = !!(r.flags & te.Symbolic),
                      b = !!(r.flags & te.Nonsymbolic);
                    c = me, "TrueType" !== r.type || b || (c = pe), v && (c = ge, r.file || (/Symbol/i.test(r.name) ? c = ve : /Dingbats/i.test(r.name) && (c = be))), r.defaultEncoding = c;
                  }
                  return r.differences = u, r.baseEncodingName = h, r.hasEncoding = !!h || u.length > 0, r.dict = e, o.then(function (e) {
                    return r.toUnicode = e, n.buildToUnicode(r);
                  }).then(function (e) {
                    return r.toUnicode = e, r;
                  });
                },
                buildToUnicode: function buildToUnicode(e) {
                  if (e.hasIncludedToUnicodeMap = !!e.toUnicode && e.toUnicode.length > 0, e.hasIncludedToUnicodeMap) return Promise.resolve(e.toUnicode);
                  var t, r, n;
                  if (!e.composite) {
                    t = [];
                    var i = e.defaultEncoding.slice(),
                      a = e.baseEncodingName,
                      o = e.differences;
                    for (r in o) ".notdef" !== (n = o[r]) && (i[r] = n);
                    var s = Ae();
                    for (r in i) if ("" !== (n = i[r])) if (void 0 !== s[n]) t[r] = String.fromCharCode(s[n]);else {
                      var l = 0;
                      switch (n[0]) {
                        case "G":
                          3 === n.length && (l = parseInt(n.substr(1), 16));
                          break;
                        case "g":
                          5 === n.length && (l = parseInt(n.substr(1), 16));
                          break;
                        case "C":
                        case "c":
                          n.length >= 3 && (l = +n.substr(1));
                          break;
                        default:
                          var c = Ee(n, s);
                          -1 !== c && (l = c);
                      }
                      if (l) {
                        if (a && l === +r) {
                          var u = ye(a);
                          if (u && (n = u[r])) {
                            t[r] = String.fromCharCode(s[n]);
                            continue;
                          }
                        }
                        t[r] = String.fromCharCode(l);
                      }
                    }
                    return Promise.resolve(new ie(t));
                  }
                  if (e.composite && (e.cMap.builtInCMap && !(e.cMap instanceof he) || "Adobe" === e.cidSystemInfo.registry && ("GB1" === e.cidSystemInfo.ordering || "CNS1" === e.cidSystemInfo.ordering || "Japan1" === e.cidSystemInfo.ordering || "Korea1" === e.cidSystemInfo.ordering))) {
                    var h = e.cidSystemInfo.registry,
                      f = e.cidSystemInfo.ordering,
                      d = U.get(h + "-" + f + "-UCS2");
                    return ue.create({
                      encoding: d,
                      fetchBuiltInCMap: this.fetchBuiltInCMap,
                      useCMap: null
                    }).then(function (r) {
                      var n = e.cMap;
                      return t = [], n.forEach(function (e, n) {
                        R(n <= 65535, "Max size of CID is 65,535");
                        var i = r.lookup(n);
                        i && (t[e] = String.fromCharCode((i.charCodeAt(0) << 8) + i.charCodeAt(1)));
                      }), new ie(t);
                    });
                  }
                  return Promise.resolve(new ne(e.firstChar, e.lastChar));
                },
                readToUnicode: function readToUnicode(e) {
                  var t = e;
                  return G(t) ? ue.create({
                    encoding: t,
                    fetchBuiltInCMap: this.fetchBuiltInCMap,
                    useCMap: null
                  }).then(function (e) {
                    return e instanceof he ? new ne(0, 65535) : new ie(e.getMap());
                  }) : q(t) ? ue.create({
                    encoding: t,
                    fetchBuiltInCMap: this.fetchBuiltInCMap,
                    useCMap: null
                  }).then(function (e) {
                    if (e instanceof he) return new ne(0, 65535);
                    var t = new Array(e.length);
                    return e.forEach(function (e, r) {
                      for (var n = [], i = 0; i < r.length; i += 2) {
                        var a = r.charCodeAt(i) << 8 | r.charCodeAt(i + 1);
                        if (55296 == (63488 & a)) {
                          i += 2;
                          var o = r.charCodeAt(i) << 8 | r.charCodeAt(i + 1);
                          n.push(((1023 & a) << 10) + (1023 & o) + 65536);
                        } else n.push(a);
                      }
                      t[e] = String.fromCharCode.apply(String, n);
                    }), new ie(t);
                  }) : Promise.resolve(null);
                },
                readCidToGidMap: function readCidToGidMap(e) {
                  for (var t = e.getBytes(), r = [], n = 0, i = t.length; n < i; n++) {
                    var a = t[n++] << 8 | t[n];
                    if (0 !== a) {
                      r[n >> 1] = a;
                    }
                  }
                  return r;
                },
                extractWidths: function extractWidths(e, t, r) {
                  var n,
                    i,
                    a,
                    o,
                    s,
                    l,
                    c,
                    u,
                    h = this.xref,
                    f = [],
                    d = 0,
                    p = [];
                  if (r.composite) {
                    if (d = e.get("DW") || 1e3, u = e.get("W")) for (i = 0, a = u.length; i < a; i++) if (l = h.fetchIfRef(u[i++]), c = h.fetchIfRef(u[i]), P(c)) for (o = 0, s = c.length; o < s; o++) f[l++] = h.fetchIfRef(c[o]);else {
                      var m = h.fetchIfRef(u[++i]);
                      for (o = l; o <= c; o++) f[o] = m;
                    }
                    if (r.vertical) {
                      var g = e.getArray("DW2") || [880, -1e3];
                      if (n = [g[1], .5 * d, g[0]], g = e.get("W2")) for (i = 0, a = g.length; i < a; i++) if (l = h.fetchIfRef(g[i++]), c = h.fetchIfRef(g[i]), P(c)) for (o = 0, s = c.length; o < s; o++) p[l++] = [h.fetchIfRef(c[o++]), h.fetchIfRef(c[o++]), h.fetchIfRef(c[o])];else {
                        var v = [h.fetchIfRef(g[++i]), h.fetchIfRef(g[++i]), h.fetchIfRef(g[++i])];
                        for (o = l; o <= c; o++) p[o] = v;
                      }
                    }
                  } else {
                    var b = r.firstChar;
                    if (u = e.get("Widths")) {
                      for (o = b, i = 0, a = u.length; i < a; i++) f[o++] = h.fetchIfRef(u[i]);
                      d = parseFloat(t.get("MissingWidth")) || 0;
                    } else {
                      var y = e.get("BaseFont");
                      if (G(y)) {
                        var w = this.getBaseFontMetrics(y.name);
                        f = this.buildCharCodeToWidth(w.widths, r), d = w.defaultWidth;
                      }
                    }
                  }
                  var x = !0,
                    _ = d;
                  for (var S in f) {
                    var C = f[S];
                    if (C) if (_) {
                      if (_ !== C) {
                        x = !1;
                        break;
                      }
                    } else _ = C;
                  }
                  x && (r.flags |= te.FixedPitch), r.defaultWidth = d, r.widths = f, r.defaultVMetrics = n, r.vmetrics = p;
                },
                isSerifFont: function isSerifFont(e) {
                  var t = e.split("-")[0];
                  return t in xe() || -1 !== t.search(/serif/gi);
                },
                getBaseFontMetrics: function getBaseFontMetrics(e) {
                  var t = 0,
                    r = [],
                    n = !1,
                    i = we(),
                    a = i[e] || e,
                    o = fe();
                  a in o || (a = this.isSerifFont(e) ? "Times-Roman" : "Helvetica");
                  var s = o[a];
                  return B(s) ? (t = s, n = !0) : r = s(), {
                    defaultWidth: t,
                    monospace: n,
                    widths: r
                  };
                },
                buildCharCodeToWidth: function buildCharCodeToWidth(e, t) {
                  for (var r = Object.create(null), n = t.differences, i = t.defaultEncoding, a = 0; a < 256; a++) a in n && e[n[a]] ? r[a] = e[n[a]] : a in i && e[i[a]] && (r[a] = e[i[a]]);
                  return r;
                },
                preEvaluateFont: function preEvaluateFont(e) {
                  var t = e,
                    r = e.get("Subtype");
                  R(G(r), "invalid font Subtype");
                  var n,
                    i = !1;
                  if ("Type0" === r.name) {
                    var a = e.get("DescendantFonts");
                    R(a, "Descendant fonts are not specified"), e = P(a) ? this.xref.fetchIfRef(a[0]) : a, r = e.get("Subtype"), R(G(r), "invalid font Subtype"), i = !0;
                  }
                  var o = e.get("FontDescriptor");
                  if (o) {
                    var s = new $(),
                      l = t.getRaw("Encoding");
                    if (G(l)) s.update(l.name);else if (V(l)) s.update(l.toString());else if (H(l)) for (var c = l.getKeys(), u = 0, h = c.length; u < h; u++) {
                      var f = l.getRaw(c[u]);
                      if (G(f)) s.update(f.name);else if (V(f)) s.update(f.toString());else if (P(f)) {
                        for (var d = f.length, p = new Array(d), m = 0; m < d; m++) {
                          var g = f[m];
                          G(g) ? p[m] = g.name : (B(g) || V(g)) && (p[m] = g.toString());
                        }
                        s.update(p.join());
                      }
                    }
                    var v = e.get("ToUnicode") || t.get("ToUnicode");
                    if (q(v)) {
                      var b = v.str || v;
                      n = b.buffer ? new Uint8Array(b.buffer.buffer, 0, b.bufferLength) : new Uint8Array(b.bytes.buffer, b.start, b.end - b.start), s.update(n);
                    } else G(v) && s.update(v.name);
                    var y = e.get("Widths") || t.get("Widths");
                    y && (n = new Uint8Array(new Uint32Array(y).buffer), s.update(n));
                  }
                  return {
                    descriptor: o,
                    dict: e,
                    baseDict: t,
                    composite: i,
                    type: r.name,
                    hash: s ? s.hexdigest() : ""
                  };
                },
                translateFont: function translateFont(e) {
                  var t,
                    r = this,
                    n = e.baseDict,
                    i = e.dict,
                    a = e.composite,
                    o = e.descriptor,
                    s = e.type,
                    l = a ? 65535 : 255;
                  if (!o) {
                    if ("Type3" !== s) {
                      var c = i.get("BaseFont");
                      R(G(c), "Base font is not specified"), c = c.name.replace(/[,_]/g, "-");
                      var u = this.getBaseFontMetrics(c),
                        h = c.split("-")[0],
                        f = (this.isSerifFont(h) ? te.Serif : 0) | (u.monospace ? te.FixedPitch : 0) | (_e()[h] ? te.Symbolic : te.Nonsymbolic);
                      return t = {
                        type: s,
                        name: c,
                        widths: u.widths,
                        defaultWidth: u.defaultWidth,
                        flags: f,
                        firstChar: 0,
                        lastChar: l
                      }, this.extractDataStructures(i, i, t).then(function (e) {
                        return e.widths = r.buildCharCodeToWidth(u.widths, e), new re(c, null, e);
                      });
                    }
                    o = new N(null), o.set("FontName", U.get(s)), o.set("FontBBox", i.getArray("FontBBox"));
                  }
                  var d = i.get("FirstChar") || 0,
                    p = i.get("LastChar") || l,
                    m = o.get("FontName"),
                    g = i.get("BaseFont");
                  if (D(m) && (m = U.get(m)), D(g) && (g = U.get(g)), "Type3" !== s) {
                    var v = m && m.name,
                      b = g && g.name;
                    v !== b && (O("The FontDescriptor's FontName is \"" + v + '" but should be the same as the Font\'s BaseFont "' + b + '"'), v && b && 0 === b.indexOf(v) && (m = g));
                  }
                  m = m || g, R(G(m), "invalid font name");
                  var y = o.get("FontFile", "FontFile2", "FontFile3");
                  if (y && y.dict) {
                    var x = y.dict.get("Subtype");
                    x && (x = x.name);
                    var _ = y.dict.get("Length1"),
                      S = y.dict.get("Length2"),
                      C = y.dict.get("Length3");
                  }
                  t = {
                    type: s,
                    name: m.name,
                    subtype: x,
                    file: y,
                    length1: _,
                    length2: S,
                    length3: C,
                    loadedName: n.loadedName,
                    composite: a,
                    wideChars: a,
                    fixedPitch: !1,
                    fontMatrix: i.getArray("FontMatrix") || w,
                    firstChar: d || 0,
                    lastChar: p || l,
                    bbox: o.getArray("FontBBox"),
                    ascent: o.get("Ascent"),
                    descent: o.get("Descent"),
                    xHeight: o.get("XHeight"),
                    capHeight: o.get("CapHeight"),
                    flags: o.get("Flags"),
                    italicAngle: o.get("ItalicAngle"),
                    coded: !1
                  };
                  var E;
                  if (a) {
                    var A = n.get("Encoding");
                    G(A) && (t.cidEncoding = A.name), E = ue.create({
                      encoding: A,
                      fetchBuiltInCMap: this.fetchBuiltInCMap,
                      useCMap: null
                    }).then(function (e) {
                      t.cMap = e, t.vertical = t.cMap.vertical;
                    });
                  } else E = Promise.resolve(void 0);
                  return E.then(function () {
                    return r.extractDataStructures(i, n, t);
                  }).then(function (e) {
                    return r.extractWidths(i, o, e), "Type3" === s && (e.isType3Font = !0), new re(m.name, y, e);
                  });
                }
              }, t;
            }(),
            ke = function () {
              function e(e, t, r) {
                this.loadedName = e, this.font = t, this.dict = r, this.type3Loaded = null, this.sent = !1;
              }
              return e.prototype = {
                send: function send(e) {
                  if (!this.sent) {
                    var t = this.font.exportData();
                    e.send("commonobj", [this.loadedName, "Font", t]), this.sent = !0;
                  }
                },
                loadType3Data: function loadType3Data(e, t, r, n) {
                  if (R(this.font.isType3Font), this.type3Loaded) return this.type3Loaded;
                  var i = Object.create(e.options);
                  i.ignoreErrors = !1;
                  for (var a = e.clone(i), o = this.font, s = Promise.resolve(), l = this.dict.get("CharProcs"), c = this.dict.get("Resources") || t, u = l.getKeys(), h = Object.create(null), f = 0, d = u.length; f < d; ++f) !function () {
                    var e = u[f];
                    s = s.then(function () {
                      var t = l.get(e),
                        i = new Re();
                      return a.getOperatorList({
                        stream: t,
                        task: n,
                        resources: c,
                        operatorList: i
                      }).then(function () {
                        h[e] = i.getIR(), r.addDependencies(i.dependencies);
                      }).catch(function (t) {
                        F('Type3 font resource "' + e + '" is not available.');
                        var r = new Re();
                        h[e] = r.getIR();
                      });
                    });
                  }();
                  return this.type3Loaded = s.then(function () {
                    o.charProcOperatorList = h;
                  }), this.type3Loaded;
                }
              }, e;
            }(),
            Re = function () {
              function e(e) {
                for (var t = [], r = e.fnArray, n = e.argsArray, i = 0, a = e.length; i < a; i++) switch (r[i]) {
                  case C.paintInlineImageXObject:
                  case C.paintInlineImageXObjectGroup:
                  case C.paintImageMaskXObject:
                    var o = n[i][0];
                    o.cached || t.push(o.data.buffer);
                }
                return t;
              }
              function t(e, t, r) {
                this.messageHandler = t, this.fnArray = [], this.argsArray = [], this.dependencies = Object.create(null), this._totalLength = 0, this.pageIndex = r, this.intent = e;
              }
              return t.prototype = {
                get length() {
                  return this.argsArray.length;
                },
                get totalLength() {
                  return this._totalLength + this.length;
                },
                addOp: function addOp(e, t) {
                  this.fnArray.push(e), this.argsArray.push(t), this.messageHandler && (this.fnArray.length >= 1e3 ? this.flush() : this.fnArray.length >= 995 && (e === C.restore || e === C.endText) && this.flush());
                },
                addDependency: function addDependency(e) {
                  e in this.dependencies || (this.dependencies[e] = !0, this.addOp(C.dependency, [e]));
                },
                addDependencies: function addDependencies(e) {
                  for (var t in e) this.addDependency(t);
                },
                addOpList: function addOpList(e) {
                  k.extendObj(this.dependencies, e.dependencies);
                  for (var t = 0, r = e.length; t < r; t++) this.addOp(e.fnArray[t], e.argsArray[t]);
                },
                getIR: function getIR() {
                  return {
                    fnArray: this.fnArray,
                    argsArray: this.argsArray,
                    length: this.length
                  };
                },
                flush: function flush(t) {
                  "oplist" !== this.intent && new Be().optimize(this);
                  var r = e(this),
                    n = this.length;
                  this._totalLength += n, this.messageHandler.send("RenderPageChunk", {
                    operatorList: {
                      fnArray: this.fnArray,
                      argsArray: this.argsArray,
                      lastChunk: t,
                      length: n
                    },
                    pageIndex: this.pageIndex,
                    intent: this.intent
                  }, r), this.dependencies = Object.create(null), this.fnArray.length = 0, this.argsArray.length = 0;
                }
              }, t;
            }(),
            Ie = function () {
              function e(e) {
                this.state = e, this.stateStack = [];
              }
              return e.prototype = {
                save: function save() {
                  var e = this.state;
                  this.stateStack.push(this.state), this.state = e.clone();
                },
                restore: function restore() {
                  var e = this.stateStack.pop();
                  e && (this.state = e);
                },
                transform: function transform(e) {
                  this.state.ctm = k.transform(this.state.ctm, e);
                }
              }, e;
            }(),
            Me = function () {
              function e() {
                this.ctm = new Float32Array(x), this.fontName = null, this.fontSize = 0, this.font = null, this.fontMatrix = w, this.textMatrix = x.slice(), this.textLineMatrix = x.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
              }
              return e.prototype = {
                setTextMatrix: function setTextMatrix(e, t, r, n, i, a) {
                  var o = this.textMatrix;
                  o[0] = e, o[1] = t, o[2] = r, o[3] = n, o[4] = i, o[5] = a;
                },
                setTextLineMatrix: function setTextLineMatrix(e, t, r, n, i, a) {
                  var o = this.textLineMatrix;
                  o[0] = e, o[1] = t, o[2] = r, o[3] = n, o[4] = i, o[5] = a;
                },
                translateTextMatrix: function translateTextMatrix(e, t) {
                  var r = this.textMatrix;
                  r[4] = r[0] * e + r[2] * t + r[4], r[5] = r[1] * e + r[3] * t + r[5];
                },
                translateTextLineMatrix: function translateTextLineMatrix(e, t) {
                  var r = this.textLineMatrix;
                  r[4] = r[0] * e + r[2] * t + r[4], r[5] = r[1] * e + r[3] * t + r[5];
                },
                calcTextLineMatrixAdvance: function calcTextLineMatrixAdvance(e, t, r, n, i, a) {
                  var o = this.font;
                  if (!o) return null;
                  var s = this.textLineMatrix;
                  if (e !== s[0] || t !== s[1] || r !== s[2] || n !== s[3]) return null;
                  var l = i - s[4],
                    c = a - s[5];
                  if (o.vertical && 0 !== l || !o.vertical && 0 !== c) return null;
                  var u,
                    h,
                    f = e * n - t * r;
                  return o.vertical ? (u = -c * r / f, h = c * e / f) : (u = l * n / f, h = -l * t / f), {
                    width: u,
                    height: h,
                    value: o.vertical ? h : u
                  };
                },
                calcRenderMatrix: function calcRenderMatrix(e) {
                  var t = [this.fontSize * this.textHScale, 0, 0, this.fontSize, 0, this.textRise];
                  return k.transform(e, k.transform(this.textMatrix, t));
                },
                carriageReturn: function carriageReturn() {
                  this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
                },
                clone: function clone() {
                  var e = Object.create(this);
                  return e.textMatrix = this.textMatrix.slice(), e.textLineMatrix = this.textLineMatrix.slice(), e.fontMatrix = this.fontMatrix.slice(), e;
                }
              }, e;
            }(),
            Oe = function () {
              function e() {
                this.ctm = new Float32Array(x), this.font = null, this.textRenderingMode = A.FILL, this.fillColorSpace = Q.singletons.gray, this.strokeColorSpace = Q.singletons.gray;
              }
              return e.prototype = {
                clone: function clone() {
                  return Object.create(this);
                }
              }, e;
            }(),
            Pe = function () {
              function e(e, r, n) {
                this.opMap = t(), this.parser = new Z(new K(e, this.opMap), !1, r), this.stateManager = n, this.nonProcessedArgs = [];
              }
              var t = L(function (e) {
                e.w = {
                  id: C.setLineWidth,
                  numArgs: 1,
                  variableArgs: !1
                }, e.J = {
                  id: C.setLineCap,
                  numArgs: 1,
                  variableArgs: !1
                }, e.j = {
                  id: C.setLineJoin,
                  numArgs: 1,
                  variableArgs: !1
                }, e.M = {
                  id: C.setMiterLimit,
                  numArgs: 1,
                  variableArgs: !1
                }, e.d = {
                  id: C.setDash,
                  numArgs: 2,
                  variableArgs: !1
                }, e.ri = {
                  id: C.setRenderingIntent,
                  numArgs: 1,
                  variableArgs: !1
                }, e.i = {
                  id: C.setFlatness,
                  numArgs: 1,
                  variableArgs: !1
                }, e.gs = {
                  id: C.setGState,
                  numArgs: 1,
                  variableArgs: !1
                }, e.q = {
                  id: C.save,
                  numArgs: 0,
                  variableArgs: !1
                }, e.Q = {
                  id: C.restore,
                  numArgs: 0,
                  variableArgs: !1
                }, e.cm = {
                  id: C.transform,
                  numArgs: 6,
                  variableArgs: !1
                }, e.m = {
                  id: C.moveTo,
                  numArgs: 2,
                  variableArgs: !1
                }, e.l = {
                  id: C.lineTo,
                  numArgs: 2,
                  variableArgs: !1
                }, e.c = {
                  id: C.curveTo,
                  numArgs: 6,
                  variableArgs: !1
                }, e.v = {
                  id: C.curveTo2,
                  numArgs: 4,
                  variableArgs: !1
                }, e.y = {
                  id: C.curveTo3,
                  numArgs: 4,
                  variableArgs: !1
                }, e.h = {
                  id: C.closePath,
                  numArgs: 0,
                  variableArgs: !1
                }, e.re = {
                  id: C.rectangle,
                  numArgs: 4,
                  variableArgs: !1
                }, e.S = {
                  id: C.stroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e.s = {
                  id: C.closeStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e.f = {
                  id: C.fill,
                  numArgs: 0,
                  variableArgs: !1
                }, e.F = {
                  id: C.fill,
                  numArgs: 0,
                  variableArgs: !1
                }, e["f*"] = {
                  id: C.eoFill,
                  numArgs: 0,
                  variableArgs: !1
                }, e.B = {
                  id: C.fillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e["B*"] = {
                  id: C.eoFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e.b = {
                  id: C.closeFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e["b*"] = {
                  id: C.closeEOFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, e.n = {
                  id: C.endPath,
                  numArgs: 0,
                  variableArgs: !1
                }, e.W = {
                  id: C.clip,
                  numArgs: 0,
                  variableArgs: !1
                }, e["W*"] = {
                  id: C.eoClip,
                  numArgs: 0,
                  variableArgs: !1
                }, e.BT = {
                  id: C.beginText,
                  numArgs: 0,
                  variableArgs: !1
                }, e.ET = {
                  id: C.endText,
                  numArgs: 0,
                  variableArgs: !1
                }, e.Tc = {
                  id: C.setCharSpacing,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Tw = {
                  id: C.setWordSpacing,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Tz = {
                  id: C.setHScale,
                  numArgs: 1,
                  variableArgs: !1
                }, e.TL = {
                  id: C.setLeading,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Tf = {
                  id: C.setFont,
                  numArgs: 2,
                  variableArgs: !1
                }, e.Tr = {
                  id: C.setTextRenderingMode,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Ts = {
                  id: C.setTextRise,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Td = {
                  id: C.moveText,
                  numArgs: 2,
                  variableArgs: !1
                }, e.TD = {
                  id: C.setLeadingMoveText,
                  numArgs: 2,
                  variableArgs: !1
                }, e.Tm = {
                  id: C.setTextMatrix,
                  numArgs: 6,
                  variableArgs: !1
                }, e["T*"] = {
                  id: C.nextLine,
                  numArgs: 0,
                  variableArgs: !1
                }, e.Tj = {
                  id: C.showText,
                  numArgs: 1,
                  variableArgs: !1
                }, e.TJ = {
                  id: C.showSpacedText,
                  numArgs: 1,
                  variableArgs: !1
                }, e["'"] = {
                  id: C.nextLineShowText,
                  numArgs: 1,
                  variableArgs: !1
                }, e['"'] = {
                  id: C.nextLineSetSpacingShowText,
                  numArgs: 3,
                  variableArgs: !1
                }, e.d0 = {
                  id: C.setCharWidth,
                  numArgs: 2,
                  variableArgs: !1
                }, e.d1 = {
                  id: C.setCharWidthAndBounds,
                  numArgs: 6,
                  variableArgs: !1
                }, e.CS = {
                  id: C.setStrokeColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                }, e.cs = {
                  id: C.setFillColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                }, e.SC = {
                  id: C.setStrokeColor,
                  numArgs: 4,
                  variableArgs: !0
                }, e.SCN = {
                  id: C.setStrokeColorN,
                  numArgs: 33,
                  variableArgs: !0
                }, e.sc = {
                  id: C.setFillColor,
                  numArgs: 4,
                  variableArgs: !0
                }, e.scn = {
                  id: C.setFillColorN,
                  numArgs: 33,
                  variableArgs: !0
                }, e.G = {
                  id: C.setStrokeGray,
                  numArgs: 1,
                  variableArgs: !1
                }, e.g = {
                  id: C.setFillGray,
                  numArgs: 1,
                  variableArgs: !1
                }, e.RG = {
                  id: C.setStrokeRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                }, e.rg = {
                  id: C.setFillRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                }, e.K = {
                  id: C.setStrokeCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                }, e.k = {
                  id: C.setFillCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                }, e.sh = {
                  id: C.shadingFill,
                  numArgs: 1,
                  variableArgs: !1
                }, e.BI = {
                  id: C.beginInlineImage,
                  numArgs: 0,
                  variableArgs: !1
                }, e.ID = {
                  id: C.beginImageData,
                  numArgs: 0,
                  variableArgs: !1
                }, e.EI = {
                  id: C.endInlineImage,
                  numArgs: 1,
                  variableArgs: !1
                }, e.Do = {
                  id: C.paintXObject,
                  numArgs: 1,
                  variableArgs: !1
                }, e.MP = {
                  id: C.markPoint,
                  numArgs: 1,
                  variableArgs: !1
                }, e.DP = {
                  id: C.markPointProps,
                  numArgs: 2,
                  variableArgs: !1
                }, e.BMC = {
                  id: C.beginMarkedContent,
                  numArgs: 1,
                  variableArgs: !1
                }, e.BDC = {
                  id: C.beginMarkedContentProps,
                  numArgs: 2,
                  variableArgs: !1
                }, e.EMC = {
                  id: C.endMarkedContent,
                  numArgs: 0,
                  variableArgs: !1
                }, e.BX = {
                  id: C.beginCompat,
                  numArgs: 0,
                  variableArgs: !1
                }, e.EX = {
                  id: C.endCompat,
                  numArgs: 0,
                  variableArgs: !1
                }, e.BM = null, e.BD = null, e.true = null, e.fa = null, e.fal = null, e.fals = null, e.false = null, e.nu = null, e.nul = null, e.null = null;
              });
              return e.prototype = {
                get savedStatesDepth() {
                  return this.stateManager.stateStack.length;
                },
                read: function read(e) {
                  for (var t = e.args;;) {
                    var r = this.parser.getObj();
                    if (z(r)) {
                      var n = r.cmd,
                        i = this.opMap[n];
                      if (!i) {
                        F('Unknown command "' + n + '"');
                        continue;
                      }
                      var a = i.id,
                        o = i.numArgs,
                        s = null !== t ? t.length : 0;
                      if (i.variableArgs) s > o && O("Command " + a + ": expected [0," + o + "] args, but received " + s + " args.");else {
                        if (s !== o) {
                          for (var l = this.nonProcessedArgs; s > o;) l.push(t.shift()), s--;
                          for (; s < o && 0 !== l.length;) null === t && (t = []), t.unshift(l.pop()), s++;
                        }
                        if (s < o) {
                          F("Skipping command " + a + ": expected " + o + " args, but received " + s + " args."), null !== t && (t.length = 0);
                          continue;
                        }
                      }
                      return this.preprocessCommand(a, t), e.fn = a, e.args = t, !0;
                    }
                    if (j(r)) return !1;
                    null !== r && (null === t && (t = []), t.push(r), R(t.length <= 33, "Too many arguments"));
                  }
                },
                preprocessCommand: function preprocessCommand(e, t) {
                  switch (0 | e) {
                    case C.save:
                      this.stateManager.save();
                      break;
                    case C.restore:
                      this.stateManager.restore();
                      break;
                    case C.transform:
                      this.stateManager.transform(t);
                  }
                }
              }, e;
            }(),
            Be = function () {
              function e(e, t, r) {
                for (var n = e, i = 0, a = t.length - 1; i < a; i++) {
                  var o = t[i];
                  n = n[o] || (n[o] = []);
                }
                n[t[t.length - 1]] = r;
              }
              function t(e, t, r, n) {
                for (var i = e + 2, a = 0; a < t; a++) {
                  var o = n[i + 4 * a],
                    s = 1 === o.length && o[0];
                  if (!s || 1 !== s.width || 1 !== s.height || s.data.length && (1 !== s.data.length || 0 !== s.data[0])) break;
                  r[i + 4 * a] = C.paintSolidColorImageMask;
                }
                return t - a;
              }
              function r() {}
              var n = [];
              return e(n, [C.save, C.transform, C.paintInlineImageXObject, C.restore], function (e) {
                for (var t = e.fnArray, r = e.argsArray, n = e.iCurr, i = n - 3, a = n - 2, o = n - 1, s = i + 4, l = t.length; s + 3 < l && t[s] === C.save && t[s + 1] === C.transform && t[s + 2] === C.paintInlineImageXObject && t[s + 3] === C.restore;) s += 4;
                var c = Math.min((s - i) / 4, 200);
                if (c < 10) return s;
                var u,
                  h = 0,
                  f = [],
                  d = 0,
                  p = 1,
                  m = 1;
                for (u = 0; u < c; u++) {
                  var g = r[a + (u << 2)],
                    v = r[o + (u << 2)][0];
                  p + v.width > 1e3 && (h = Math.max(h, p), m += d + 2, p = 0, d = 0), f.push({
                    transform: g,
                    x: p,
                    y: m,
                    w: v.width,
                    h: v.height
                  }), p += v.width + 2, d = Math.max(d, v.height);
                }
                var b = Math.max(h, p) + 1,
                  y = m + d + 1,
                  w = new Uint8Array(b * y * 4),
                  x = b << 2;
                for (u = 0; u < c; u++) {
                  var _ = r[o + (u << 2)][0].data,
                    E = f[u].w << 2,
                    A = 0,
                    T = f[u].x + f[u].y * b << 2;
                  w.set(_.subarray(0, E), T - x);
                  for (var k = 0, R = f[u].h; k < R; k++) w.set(_.subarray(A, A + E), T), A += E, T += x;
                  for (w.set(_.subarray(A - E, A), T); T >= 0;) _[T - 4] = _[T], _[T - 3] = _[T + 1], _[T - 2] = _[T + 2], _[T - 1] = _[T + 3], _[T + E] = _[T + E - 4], _[T + E + 1] = _[T + E - 3], _[T + E + 2] = _[T + E - 2], _[T + E + 3] = _[T + E - 1], T -= x;
                }
                return t.splice(i, 4 * c, C.paintInlineImageXObjectGroup), r.splice(i, 4 * c, [{
                  width: b,
                  height: y,
                  kind: S.RGBA_32BPP,
                  data: w
                }, f]), i + 1;
              }), e(n, [C.save, C.transform, C.paintImageMaskXObject, C.restore], function (e) {
                for (var r = e.fnArray, n = e.argsArray, i = e.iCurr, a = i - 3, o = i - 2, s = i - 1, l = a + 4, c = r.length; l + 3 < c && r[l] === C.save && r[l + 1] === C.transform && r[l + 2] === C.paintImageMaskXObject && r[l + 3] === C.restore;) l += 4;
                var u = (l - a) / 4;
                if ((u = t(a, u, r, n)) < 10) return l;
                var h,
                  f,
                  d,
                  p = !1,
                  m = n[s][0];
                if (0 === n[o][1] && 0 === n[o][2]) {
                  p = !0;
                  var g = n[o][0],
                    v = n[o][3];
                  f = o + 4;
                  var b = s + 4;
                  for (h = 1; h < u; h++, f += 4, b += 4) if (d = n[f], n[b][0] !== m || d[0] !== g || 0 !== d[1] || 0 !== d[2] || d[3] !== v) {
                    h < 10 ? p = !1 : u = h;
                    break;
                  }
                }
                if (p) {
                  u = Math.min(u, 1e3);
                  var y = new Float32Array(2 * u);
                  for (f = o, h = 0; h < u; h++, f += 4) d = n[f], y[h << 1] = d[4], y[1 + (h << 1)] = d[5];
                  r.splice(a, 4 * u, C.paintImageMaskXObjectRepeat), n.splice(a, 4 * u, [m, g, v, y]);
                } else {
                  u = Math.min(u, 100);
                  var w = [];
                  for (h = 0; h < u; h++) {
                    d = n[o + (h << 2)];
                    var x = n[s + (h << 2)][0];
                    w.push({
                      data: x.data,
                      width: x.width,
                      height: x.height,
                      transform: d
                    });
                  }
                  r.splice(a, 4 * u, C.paintImageMaskXObjectGroup), n.splice(a, 4 * u, [w]);
                }
                return a + 1;
              }), e(n, [C.save, C.transform, C.paintImageXObject, C.restore], function (e) {
                var t = e.fnArray,
                  r = e.argsArray,
                  n = e.iCurr,
                  i = n - 3,
                  a = n - 2,
                  o = n - 1,
                  s = n;
                if (0 !== r[a][1] || 0 !== r[a][2]) return s + 1;
                for (var l = r[o][0], c = r[a][0], u = r[a][3], h = i + 4, f = t.length; h + 3 < f && t[h] === C.save && t[h + 1] === C.transform && t[h + 2] === C.paintImageXObject && t[h + 3] === C.restore && r[h + 1][0] === c && 0 === r[h + 1][1] && 0 === r[h + 1][2] && r[h + 1][3] === u && r[h + 2][0] === l;) h += 4;
                var d = Math.min((h - i) / 4, 1e3);
                if (d < 3) return h;
                for (var p = new Float32Array(2 * d), m = a, g = 0; g < d; g++, m += 4) {
                  var v = r[m];
                  p[g << 1] = v[4], p[1 + (g << 1)] = v[5];
                }
                var b = [l, c, u, p];
                return t.splice(i, 4 * d, C.paintImageXObjectRepeat), r.splice(i, 4 * d, b), i + 1;
              }), e(n, [C.beginText, C.setFont, C.setTextMatrix, C.showText, C.endText], function (e) {
                for (var t = e.fnArray, r = e.argsArray, n = e.iCurr, i = n - 4, a = n - 3, o = n - 2, s = n - 1, l = n, c = r[a][0], u = r[a][1], h = i + 5, f = t.length; h + 4 < f && t[h] === C.beginText && t[h + 1] === C.setFont && t[h + 2] === C.setTextMatrix && t[h + 3] === C.showText && t[h + 4] === C.endText && r[h + 1][0] === c && r[h + 1][1] === u;) h += 5;
                var d = Math.min((h - i) / 5, 1e3);
                if (d < 3) return h;
                var p = i;
                i >= 4 && t[i - 4] === t[a] && t[i - 3] === t[o] && t[i - 2] === t[s] && t[i - 1] === t[l] && r[i - 4][0] === c && r[i - 4][1] === u && (d++, p -= 5);
                for (var m = p + 4, g = 1; g < d; g++) t.splice(m, 3), r.splice(m, 3), m += 2;
                return m + 1;
              }), r.prototype = {
                optimize: function optimize(e) {
                  for (var t, r = e.fnArray, i = e.argsArray, a = {
                      iCurr: 0,
                      fnArray: r,
                      argsArray: i
                    }, o = 0, s = r.length; o < s;) t = (t || n)[r[o]], "function" == typeof t ? (a.iCurr = o, o = t(a), t = void 0, s = a.fnArray.length) : o++;
                }
              }, r;
            }();
          t.OperatorList = Re, t.PartialEvaluator = Te;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(14),
            a = n.info,
            o = n.warn,
            s = n.error,
            l = n.log2,
            c = n.readUint16,
            u = n.readUint32,
            h = i.ArithmeticDecoder,
            f = function () {
              function e() {
                this.failOnCorruptedImage = !1;
              }
              function t(e, t) {
                e.x0 = Math.ceil(t.XOsiz / e.XRsiz), e.x1 = Math.ceil(t.Xsiz / e.XRsiz), e.y0 = Math.ceil(t.YOsiz / e.YRsiz), e.y1 = Math.ceil(t.Ysiz / e.YRsiz), e.width = e.x1 - e.x0, e.height = e.y1 - e.y0;
              }
              function r(e, t) {
                for (var r, n = e.SIZ, i = [], a = Math.ceil((n.Xsiz - n.XTOsiz) / n.XTsiz), o = Math.ceil((n.Ysiz - n.YTOsiz) / n.YTsiz), s = 0; s < o; s++) for (var l = 0; l < a; l++) r = {}, r.tx0 = Math.max(n.XTOsiz + l * n.XTsiz, n.XOsiz), r.ty0 = Math.max(n.YTOsiz + s * n.YTsiz, n.YOsiz), r.tx1 = Math.min(n.XTOsiz + (l + 1) * n.XTsiz, n.Xsiz), r.ty1 = Math.min(n.YTOsiz + (s + 1) * n.YTsiz, n.Ysiz), r.width = r.tx1 - r.tx0, r.height = r.ty1 - r.ty0, r.components = [], i.push(r);
                e.tiles = i;
                for (var c = n.Csiz, u = 0, h = c; u < h; u++) for (var f = t[u], d = 0, p = i.length; d < p; d++) {
                  var m = {};
                  r = i[d], m.tcx0 = Math.ceil(r.tx0 / f.XRsiz), m.tcy0 = Math.ceil(r.ty0 / f.YRsiz), m.tcx1 = Math.ceil(r.tx1 / f.XRsiz), m.tcy1 = Math.ceil(r.ty1 / f.YRsiz), m.width = m.tcx1 - m.tcx0, m.height = m.tcy1 - m.tcy0, r.components[u] = m;
                }
              }
              function n(e, t, r) {
                var n = t.codingStyleParameters,
                  i = {};
                return n.entropyCoderWithCustomPrecincts ? (i.PPx = n.precinctsSizes[r].PPx, i.PPy = n.precinctsSizes[r].PPy) : (i.PPx = 15, i.PPy = 15), i.xcb_ = r > 0 ? Math.min(n.xcb, i.PPx - 1) : Math.min(n.xcb, i.PPx), i.ycb_ = r > 0 ? Math.min(n.ycb, i.PPy - 1) : Math.min(n.ycb, i.PPy), i;
              }
              function i(e, t, r) {
                var n = 1 << r.PPx,
                  i = 1 << r.PPy,
                  a = 0 === t.resLevel,
                  o = 1 << r.PPx + (a ? 0 : -1),
                  s = 1 << r.PPy + (a ? 0 : -1),
                  l = t.trx1 > t.trx0 ? Math.ceil(t.trx1 / n) - Math.floor(t.trx0 / n) : 0,
                  c = t.try1 > t.try0 ? Math.ceil(t.try1 / i) - Math.floor(t.try0 / i) : 0,
                  u = l * c;
                t.precinctParameters = {
                  precinctWidth: n,
                  precinctHeight: i,
                  numprecinctswide: l,
                  numprecinctshigh: c,
                  numprecincts: u,
                  precinctWidthInSubband: o,
                  precinctHeightInSubband: s
                };
              }
              function f(e, t, r) {
                var n,
                  i,
                  a,
                  o,
                  s = r.xcb_,
                  l = r.ycb_,
                  c = 1 << s,
                  u = 1 << l,
                  h = t.tbx0 >> s,
                  f = t.tby0 >> l,
                  d = t.tbx1 + c - 1 >> s,
                  p = t.tby1 + u - 1 >> l,
                  m = t.resolution.precinctParameters,
                  g = [],
                  v = [];
                for (i = f; i < p; i++) for (n = h; n < d; n++) {
                  a = {
                    cbx: n,
                    cby: i,
                    tbx0: c * n,
                    tby0: u * i,
                    tbx1: c * (n + 1),
                    tby1: u * (i + 1)
                  }, a.tbx0_ = Math.max(t.tbx0, a.tbx0), a.tby0_ = Math.max(t.tby0, a.tby0), a.tbx1_ = Math.min(t.tbx1, a.tbx1), a.tby1_ = Math.min(t.tby1, a.tby1);
                  var b = Math.floor((a.tbx0_ - t.tbx0) / m.precinctWidthInSubband),
                    y = Math.floor((a.tby0_ - t.tby0) / m.precinctHeightInSubband);
                  if (o = b + y * m.numprecinctswide, a.precinctNumber = o, a.subbandType = t.type, a.Lblock = 3, !(a.tbx1_ <= a.tbx0_ || a.tby1_ <= a.tby0_)) {
                    g.push(a);
                    var w = v[o];
                    void 0 !== w ? (n < w.cbxMin ? w.cbxMin = n : n > w.cbxMax && (w.cbxMax = n), i < w.cbyMin ? w.cbxMin = i : i > w.cbyMax && (w.cbyMax = i)) : v[o] = w = {
                      cbxMin: n,
                      cbyMin: i,
                      cbxMax: n,
                      cbyMax: i
                    }, a.precinct = w;
                  }
                }
                t.codeblockParameters = {
                  codeblockWidth: s,
                  codeblockHeight: l,
                  numcodeblockwide: d - h + 1,
                  numcodeblockhigh: p - f + 1
                }, t.codeblocks = g, t.precincts = v;
              }
              function d(e, t, r) {
                for (var n = [], i = e.subbands, a = 0, o = i.length; a < o; a++) for (var s = i[a], l = s.codeblocks, c = 0, u = l.length; c < u; c++) {
                  var h = l[c];
                  h.precinctNumber === t && n.push(h);
                }
                return {
                  layerNumber: r,
                  codeblocks: n
                };
              }
              function p(e) {
                for (var t = e.SIZ, r = e.currentTile.index, n = e.tiles[r], i = n.codingStyleDefaultParameters.layersCount, a = t.Csiz, o = 0, l = 0; l < a; l++) o = Math.max(o, n.components[l].codingStyleParameters.decompositionLevelsCount);
                var c = 0,
                  u = 0,
                  h = 0,
                  f = 0;
                this.nextPacket = function () {
                  for (; c < i; c++) {
                    for (; u <= o; u++) {
                      for (; h < a; h++) {
                        var e = n.components[h];
                        if (!(u > e.codingStyleParameters.decompositionLevelsCount)) {
                          for (var t = e.resolutions[u], r = t.precinctParameters.numprecincts; f < r;) {
                            var l = d(t, f, c);
                            return f++, l;
                          }
                          f = 0;
                        }
                      }
                      h = 0;
                    }
                    u = 0;
                  }
                  s("JPX Error: Out of packets");
                };
              }
              function m(e) {
                for (var t = e.SIZ, r = e.currentTile.index, n = e.tiles[r], i = n.codingStyleDefaultParameters.layersCount, a = t.Csiz, o = 0, l = 0; l < a; l++) o = Math.max(o, n.components[l].codingStyleParameters.decompositionLevelsCount);
                var c = 0,
                  u = 0,
                  h = 0,
                  f = 0;
                this.nextPacket = function () {
                  for (; c <= o; c++) {
                    for (; u < i; u++) {
                      for (; h < a; h++) {
                        var e = n.components[h];
                        if (!(c > e.codingStyleParameters.decompositionLevelsCount)) {
                          for (var t = e.resolutions[c], r = t.precinctParameters.numprecincts; f < r;) {
                            var l = d(t, f, u);
                            return f++, l;
                          }
                          f = 0;
                        }
                      }
                      h = 0;
                    }
                    u = 0;
                  }
                  s("JPX Error: Out of packets");
                };
              }
              function g(e) {
                var t,
                  r,
                  n,
                  i,
                  a = e.SIZ,
                  o = e.currentTile.index,
                  l = e.tiles[o],
                  c = l.codingStyleDefaultParameters.layersCount,
                  u = a.Csiz,
                  h = 0;
                for (n = 0; n < u; n++) {
                  var f = l.components[n];
                  h = Math.max(h, f.codingStyleParameters.decompositionLevelsCount);
                }
                var p = new Int32Array(h + 1);
                for (r = 0; r <= h; ++r) {
                  var m = 0;
                  for (n = 0; n < u; ++n) {
                    var g = l.components[n].resolutions;
                    r < g.length && (m = Math.max(m, g[r].precinctParameters.numprecincts));
                  }
                  p[r] = m;
                }
                t = 0, r = 0, n = 0, i = 0, this.nextPacket = function () {
                  for (; r <= h; r++) {
                    for (; i < p[r]; i++) {
                      for (; n < u; n++) {
                        var e = l.components[n];
                        if (!(r > e.codingStyleParameters.decompositionLevelsCount)) {
                          var a = e.resolutions[r],
                            o = a.precinctParameters.numprecincts;
                          if (!(i >= o)) {
                            for (; t < c;) {
                              var f = d(a, i, t);
                              return t++, f;
                            }
                            t = 0;
                          }
                        }
                      }
                      n = 0;
                    }
                    i = 0;
                  }
                  s("JPX Error: Out of packets");
                };
              }
              function v(e) {
                var t = e.SIZ,
                  r = e.currentTile.index,
                  n = e.tiles[r],
                  i = n.codingStyleDefaultParameters.layersCount,
                  a = t.Csiz,
                  o = w(n),
                  l = o,
                  c = 0,
                  u = 0,
                  h = 0,
                  f = 0,
                  p = 0;
                this.nextPacket = function () {
                  for (; p < l.maxNumHigh; p++) {
                    for (; f < l.maxNumWide; f++) {
                      for (; h < a; h++) {
                        for (var e = n.components[h], t = e.codingStyleParameters.decompositionLevelsCount; u <= t; u++) {
                          var r = e.resolutions[u],
                            m = o.components[h].resolutions[u],
                            g = y(f, p, m, l, r);
                          if (null !== g) {
                            for (; c < i;) {
                              var v = d(r, g, c);
                              return c++, v;
                            }
                            c = 0;
                          }
                        }
                        u = 0;
                      }
                      h = 0;
                    }
                    f = 0;
                  }
                  s("JPX Error: Out of packets");
                };
              }
              function b(e) {
                var t = e.SIZ,
                  r = e.currentTile.index,
                  n = e.tiles[r],
                  i = n.codingStyleDefaultParameters.layersCount,
                  a = t.Csiz,
                  o = w(n),
                  l = 0,
                  c = 0,
                  u = 0,
                  h = 0,
                  f = 0;
                this.nextPacket = function () {
                  for (; u < a; ++u) {
                    for (var e = n.components[u], t = o.components[u], r = e.codingStyleParameters.decompositionLevelsCount; f < t.maxNumHigh; f++) {
                      for (; h < t.maxNumWide; h++) {
                        for (; c <= r; c++) {
                          var p = e.resolutions[c],
                            m = t.resolutions[c],
                            g = y(h, f, m, t, p);
                          if (null !== g) {
                            for (; l < i;) {
                              var v = d(p, g, l);
                              return l++, v;
                            }
                            l = 0;
                          }
                        }
                        c = 0;
                      }
                      h = 0;
                    }
                    f = 0;
                  }
                  s("JPX Error: Out of packets");
                };
              }
              function y(e, t, r, n, i) {
                var a = e * n.minWidth,
                  o = t * n.minHeight;
                if (a % r.width != 0 || o % r.height != 0) return null;
                var s = o / r.width * i.precinctParameters.numprecinctswide;
                return a / r.height + s;
              }
              function w(e) {
                for (var t = e.components.length, r = Number.MAX_VALUE, n = Number.MAX_VALUE, i = 0, a = 0, o = new Array(t), s = 0; s < t; s++) {
                  for (var l = e.components[s], c = l.codingStyleParameters.decompositionLevelsCount, u = new Array(c + 1), h = Number.MAX_VALUE, f = Number.MAX_VALUE, d = 0, p = 0, m = 1, g = c; g >= 0; --g) {
                    var v = l.resolutions[g],
                      b = m * v.precinctParameters.precinctWidth,
                      y = m * v.precinctParameters.precinctHeight;
                    h = Math.min(h, b), f = Math.min(f, y), d = Math.max(d, v.precinctParameters.numprecinctswide), p = Math.max(p, v.precinctParameters.numprecinctshigh), u[g] = {
                      width: b,
                      height: y
                    }, m <<= 1;
                  }
                  r = Math.min(r, h), n = Math.min(n, f), i = Math.max(i, d), a = Math.max(a, p), o[s] = {
                    resolutions: u,
                    minWidth: h,
                    minHeight: f,
                    maxNumWide: d,
                    maxNumHigh: p
                  };
                }
                return {
                  components: o,
                  minWidth: r,
                  minHeight: n,
                  maxNumWide: i,
                  maxNumHigh: a
                };
              }
              function x(e) {
                for (var t = e.SIZ, r = e.currentTile.index, a = e.tiles[r], o = t.Csiz, l = 0; l < o; l++) {
                  for (var c = a.components[l], u = c.codingStyleParameters.decompositionLevelsCount, h = [], d = [], y = 0; y <= u; y++) {
                    var w = n(e, c, y),
                      x = {},
                      _ = 1 << u - y;
                    x.trx0 = Math.ceil(c.tcx0 / _), x.try0 = Math.ceil(c.tcy0 / _), x.trx1 = Math.ceil(c.tcx1 / _), x.try1 = Math.ceil(c.tcy1 / _), x.resLevel = y, i(e, x, w), h.push(x);
                    var S;
                    if (0 === y) S = {}, S.type = "LL", S.tbx0 = Math.ceil(c.tcx0 / _), S.tby0 = Math.ceil(c.tcy0 / _), S.tbx1 = Math.ceil(c.tcx1 / _), S.tby1 = Math.ceil(c.tcy1 / _), S.resolution = x, f(e, S, w), d.push(S), x.subbands = [S];else {
                      var C = 1 << u - y + 1,
                        E = [];
                      S = {}, S.type = "HL", S.tbx0 = Math.ceil(c.tcx0 / C - .5), S.tby0 = Math.ceil(c.tcy0 / C), S.tbx1 = Math.ceil(c.tcx1 / C - .5), S.tby1 = Math.ceil(c.tcy1 / C), S.resolution = x, f(e, S, w), d.push(S), E.push(S), S = {}, S.type = "LH", S.tbx0 = Math.ceil(c.tcx0 / C), S.tby0 = Math.ceil(c.tcy0 / C - .5), S.tbx1 = Math.ceil(c.tcx1 / C), S.tby1 = Math.ceil(c.tcy1 / C - .5), S.resolution = x, f(e, S, w), d.push(S), E.push(S), S = {}, S.type = "HH", S.tbx0 = Math.ceil(c.tcx0 / C - .5), S.tby0 = Math.ceil(c.tcy0 / C - .5), S.tbx1 = Math.ceil(c.tcx1 / C - .5), S.tby1 = Math.ceil(c.tcy1 / C - .5), S.resolution = x, f(e, S, w), d.push(S), E.push(S), x.subbands = E;
                    }
                  }
                  c.resolutions = h, c.subbands = d;
                }
                var A = a.codingStyleDefaultParameters.progressionOrder;
                switch (A) {
                  case 0:
                    a.packetsIterator = new p(e);
                    break;
                  case 1:
                    a.packetsIterator = new m(e);
                    break;
                  case 2:
                    a.packetsIterator = new g(e);
                    break;
                  case 3:
                    a.packetsIterator = new v(e);
                    break;
                  case 4:
                    a.packetsIterator = new b(e);
                    break;
                  default:
                    s("JPX Error: Unsupported progression order " + A);
                }
              }
              function _(e, t, r, n) {
                function i(e) {
                  for (; h < e;) {
                    var n = t[r + u];
                    u++, f ? (c = c << 7 | n, h += 7, f = !1) : (c = c << 8 | n, h += 8), 255 === n && (f = !0);
                  }
                  return h -= e, c >>> h & (1 << e) - 1;
                }
                function a(e) {
                  return 255 === t[r + u - 1] && t[r + u] === e ? (o(1), !0) : 255 === t[r + u] && t[r + u + 1] === e && (o(2), !0);
                }
                function o(e) {
                  u += e;
                }
                function s() {
                  h = 0, f && (u++, f = !1);
                }
                for (var c, u = 0, h = 0, f = !1, d = e.currentTile.index, p = e.tiles[d], m = e.COD.sopMarkerUsed, g = e.COD.ephMarkerUsed, v = p.packetsIterator; u < n;) {
                  s(), m && a(145) && o(4);
                  var b = v.nextPacket();
                  if (i(1)) {
                    for (var y, w = b.layerNumber, x = [], _ = 0, S = b.codeblocks.length; _ < S; _++) {
                      y = b.codeblocks[_];
                      var C = y.precinct,
                        E = y.cbx - C.cbxMin,
                        A = y.cby - C.cbyMin,
                        T = !1,
                        I = !1;
                      if (void 0 !== y.included) T = !!i(1);else {
                        C = y.precinct;
                        var M, O;
                        if (void 0 !== C.inclusionTree) M = C.inclusionTree;else {
                          var P = C.cbxMax - C.cbxMin + 1,
                            B = C.cbyMax - C.cbyMin + 1;
                          M = new R(P, B, w), O = new k(P, B), C.inclusionTree = M, C.zeroBitPlanesTree = O;
                        }
                        if (M.reset(E, A, w)) for (;;) {
                          if (!i(1)) {
                            M.incrementValue(w);
                            break;
                          }
                          if (!M.nextLevel()) {
                            y.included = !0, T = I = !0;
                            break;
                          }
                        }
                      }
                      if (T) {
                        if (I) {
                          for (O = C.zeroBitPlanesTree, O.reset(E, A);;) if (i(1)) {
                            if (!O.nextLevel()) break;
                          } else O.incrementValue();
                          y.zeroBitPlanes = O.value;
                        }
                        for (var D = function () {
                          if (0 === i(1)) return 1;
                          if (0 === i(1)) return 2;
                          var e = i(2);
                          return e < 3 ? e + 3 : (e = i(5)) < 31 ? e + 6 : (e = i(7)) + 37;
                        }(); i(1);) y.Lblock++;
                        var L = l(D),
                          F = (D < 1 << L ? L - 1 : L) + y.Lblock,
                          N = i(F);
                        x.push({
                          codeblock: y,
                          codingpasses: D,
                          dataLength: N
                        });
                      }
                    }
                    for (s(), g && a(146); x.length > 0;) {
                      var U = x.shift();
                      y = U.codeblock, void 0 === y.data && (y.data = []), y.data.push({
                        data: t,
                        start: r + u,
                        end: r + u + U.dataLength,
                        codingpasses: U.codingpasses
                      }), u += U.dataLength;
                    }
                  }
                }
                return u;
              }
              function S(e, t, r, n, i, a, o, s) {
                for (var l = n.tbx0, c = n.tby0, u = n.tbx1 - n.tbx0, f = n.codeblocks, d = "H" === n.type.charAt(0) ? 1 : 0, p = "H" === n.type.charAt(1) ? t : 0, m = 0, g = f.length; m < g; ++m) {
                  var v = f[m],
                    b = v.tbx1_ - v.tbx0_,
                    y = v.tby1_ - v.tby0_;
                  if (0 !== b && 0 !== y && void 0 !== v.data) {
                    var w, x;
                    w = new I(b, y, v.subbandType, v.zeroBitPlanes, a), x = 2;
                    var _,
                      S,
                      C,
                      E = v.data,
                      A = 0,
                      T = 0;
                    for (_ = 0, S = E.length; _ < S; _++) C = E[_], A += C.end - C.start, T += C.codingpasses;
                    var k = new Uint8Array(A),
                      R = 0;
                    for (_ = 0, S = E.length; _ < S; _++) {
                      C = E[_];
                      var M = C.data.subarray(C.start, C.end);
                      k.set(M, R), R += M.length;
                    }
                    var O = new h(k, 0, A);
                    for (w.setDecoder(O), _ = 0; _ < T; _++) {
                      switch (x) {
                        case 0:
                          w.runSignificancePropagationPass();
                          break;
                        case 1:
                          w.runMagnitudeRefinementPass();
                          break;
                        case 2:
                          w.runCleanupPass(), s && w.checkSegmentationSymbol();
                      }
                      x = (x + 1) % 3;
                    }
                    var P,
                      B,
                      D,
                      L = v.tbx0_ - l + (v.tby0_ - c) * u,
                      F = w.coefficentsSign,
                      N = w.coefficentsMagnitude,
                      U = w.bitsDecoded,
                      j = o ? 0 : .5;
                    R = 0;
                    var z = "LL" !== n.type;
                    for (_ = 0; _ < y; _++) {
                      var H = L / u | 0,
                        G = 2 * H * (t - u) + d + p;
                      for (P = 0; P < b; P++) {
                        if (0 !== (B = N[R])) {
                          B = (B + j) * i, 0 !== F[R] && (B = -B), D = U[R];
                          var V = z ? G + (L << 1) : L;
                          e[V] = o && D >= a ? B : B * (1 << a - D);
                        }
                        L++, R++;
                      }
                      L += u - b;
                    }
                  }
                }
              }
              function C(e, t, r) {
                for (var n = t.components[r], i = n.codingStyleParameters, a = n.quantizationParameters, o = i.decompositionLevelsCount, s = a.SPqcds, l = a.scalarExpounded, c = a.guardBits, u = i.segmentationSymbolUsed, h = e.components[r].precision, f = i.reversibleTransformation, d = f ? new P() : new O(), p = [], m = 0, g = 0; g <= o; g++) {
                  for (var v = n.resolutions[g], b = v.trx1 - v.trx0, y = v.try1 - v.try0, w = new Float32Array(b * y), x = 0, _ = v.subbands.length; x < _; x++) {
                    var C, E;
                    l ? (C = s[m].mu, E = s[m].epsilon, m++) : (C = s[0].mu, E = s[0].epsilon + (g > 0 ? 1 - g : 0));
                    var A = v.subbands[x],
                      k = T[A.type];
                    S(w, b, y, A, f ? 1 : Math.pow(2, h + k - E) * (1 + C / 2048), c + E - 1, f, u);
                  }
                  p.push({
                    width: b,
                    height: y,
                    items: w
                  });
                }
                var R = d.calculate(p, n.tcx0, n.tcy0);
                return {
                  left: n.tcx0,
                  top: n.tcy0,
                  width: R.width,
                  height: R.height,
                  items: R.items
                };
              }
              function E(e) {
                for (var t = e.SIZ, r = e.components, n = t.Csiz, i = [], a = 0, o = e.tiles.length; a < o; a++) {
                  var s,
                    l = e.tiles[a],
                    c = [];
                  for (s = 0; s < n; s++) c[s] = C(e, l, s);
                  var u,
                    h,
                    f,
                    d,
                    p,
                    m,
                    g,
                    v,
                    b,
                    y,
                    w,
                    x,
                    _,
                    S,
                    E,
                    A = c[0],
                    T = new Uint8Array(A.items.length * n),
                    k = {
                      left: A.left,
                      top: A.top,
                      width: A.width,
                      height: A.height,
                      items: T
                    },
                    R = 0;
                  if (l.codingStyleDefaultParameters.multipleComponentTransform) {
                    var I = 4 === n,
                      M = c[0].items,
                      O = c[1].items,
                      P = c[2].items,
                      B = I ? c[3].items : null;
                    u = r[0].precision - 8, h = .5 + (128 << u), f = 255 * (1 << u), p = .5 * f, d = -p;
                    var D = l.components[0],
                      L = n - 3;
                    if (g = M.length, D.codingStyleParameters.reversibleTransformation) for (m = 0; m < g; m++, R += L) v = M[m] + h, b = O[m], y = P[m], x = v - (y + b >> 2), w = x + y, _ = x + b, T[R++] = w <= 0 ? 0 : w >= f ? 255 : w >> u, T[R++] = x <= 0 ? 0 : x >= f ? 255 : x >> u, T[R++] = _ <= 0 ? 0 : _ >= f ? 255 : _ >> u;else for (m = 0; m < g; m++, R += L) v = M[m] + h, b = O[m], y = P[m], w = v + 1.402 * y, x = v - .34413 * b - .71414 * y, _ = v + 1.772 * b, T[R++] = w <= 0 ? 0 : w >= f ? 255 : w >> u, T[R++] = x <= 0 ? 0 : x >= f ? 255 : x >> u, T[R++] = _ <= 0 ? 0 : _ >= f ? 255 : _ >> u;
                    if (I) for (m = 0, R = 3; m < g; m++, R += 4) S = B[m], T[R] = S <= d ? 0 : S >= p ? 255 : S + h >> u;
                  } else for (s = 0; s < n; s++) {
                    var F = c[s].items;
                    for (u = r[s].precision - 8, h = .5 + (128 << u), f = 127.5 * (1 << u), d = -f, R = s, m = 0, g = F.length; m < g; m++) E = F[m], T[R] = E <= d ? 0 : E >= f ? 255 : E + h >> u, R += n;
                  }
                  i.push(k);
                }
                return i;
              }
              function A(e, t) {
                for (var r = e.SIZ, n = r.Csiz, i = e.tiles[t], a = 0; a < n; a++) {
                  var o = i.components[a],
                    s = void 0 !== e.currentTile.QCC[a] ? e.currentTile.QCC[a] : e.currentTile.QCD;
                  o.quantizationParameters = s;
                  var l = void 0 !== e.currentTile.COC[a] ? e.currentTile.COC[a] : e.currentTile.COD;
                  o.codingStyleParameters = l;
                }
                i.codingStyleDefaultParameters = e.currentTile.COD;
              }
              var T = {
                LL: 0,
                LH: 1,
                HL: 1,
                HH: 2
              };
              e.prototype = {
                parse: function parse(e) {
                  if (65359 === c(e, 0)) return void this.parseCodestream(e, 0, e.length);
                  for (var t = 0, r = e.length; t < r;) {
                    var n = 8,
                      i = u(e, t),
                      l = u(e, t + 4);
                    t += n, 1 === i && (i = 4294967296 * u(e, t) + u(e, t + 4), t += 8, n += 8), 0 === i && (i = r - t + n), i < n && s("JPX Error: Invalid box field size");
                    var h = i - n,
                      f = !0;
                    switch (l) {
                      case 1785737832:
                        f = !1;
                        break;
                      case 1668246642:
                        var d = e[t];
                        if (1 === d) {
                          var p = u(e, t + 3);
                          switch (p) {
                            case 16:
                            case 17:
                            case 18:
                              break;
                            default:
                              o("Unknown colorspace " + p);
                          }
                        } else 2 === d && a("ICC profile not supported");
                        break;
                      case 1785737827:
                        this.parseCodestream(e, t, t + h);
                        break;
                      case 1783636e3:
                        218793738 !== u(e, t) && o("Invalid JP2 signature");
                        break;
                      case 1783634458:
                      case 1718909296:
                      case 1920099697:
                      case 1919251232:
                      case 1768449138:
                        break;
                      default:
                        var m = String.fromCharCode(l >> 24 & 255, l >> 16 & 255, l >> 8 & 255, 255 & l);
                        o("Unsupported header type " + l + " (" + m + ")");
                    }
                    f && (t += h);
                  }
                },
                parseImageProperties: function parseImageProperties(e) {
                  for (var t = e.getByte(); t >= 0;) {
                    var r = t;
                    t = e.getByte();
                    if (65361 === (r << 8 | t)) {
                      e.skip(4);
                      var n = e.getInt32() >>> 0,
                        i = e.getInt32() >>> 0,
                        a = e.getInt32() >>> 0,
                        o = e.getInt32() >>> 0;
                      e.skip(16);
                      var l = e.getUint16();
                      return this.width = n - a, this.height = i - o, this.componentsCount = l, void (this.bitsPerComponent = 8);
                    }
                  }
                  s("JPX Error: No size marker found in JPX stream");
                },
                parseCodestream: function parseCodestream(e, n, i) {
                  var a = {},
                    l = !1;
                  try {
                    for (var h = n; h + 1 < i;) {
                      var f = c(e, h);
                      h += 2;
                      var d,
                        p,
                        m,
                        g,
                        v,
                        b,
                        y = 0;
                      switch (f) {
                        case 65359:
                          a.mainHeader = !0;
                          break;
                        case 65497:
                          break;
                        case 65361:
                          y = c(e, h);
                          var w = {};
                          w.Xsiz = u(e, h + 4), w.Ysiz = u(e, h + 8), w.XOsiz = u(e, h + 12), w.YOsiz = u(e, h + 16), w.XTsiz = u(e, h + 20), w.YTsiz = u(e, h + 24), w.XTOsiz = u(e, h + 28), w.YTOsiz = u(e, h + 32);
                          var S = c(e, h + 36);
                          w.Csiz = S;
                          var C = [];
                          d = h + 38;
                          for (var T = 0; T < S; T++) {
                            var k = {
                              precision: 1 + (127 & e[d]),
                              isSigned: !!(128 & e[d]),
                              XRsiz: e[d + 1],
                              YRsiz: e[d + 1]
                            };
                            t(k, w), C.push(k);
                          }
                          a.SIZ = w, a.components = C, r(a, C), a.QCC = [], a.COC = [];
                          break;
                        case 65372:
                          y = c(e, h);
                          var R = {};
                          switch (d = h + 2, 31 & (p = e[d++])) {
                            case 0:
                              g = 8, v = !0;
                              break;
                            case 1:
                              g = 16, v = !1;
                              break;
                            case 2:
                              g = 16, v = !0;
                              break;
                            default:
                              throw new Error("Invalid SQcd value " + p);
                          }
                          for (R.noQuantization = 8 === g, R.scalarExpounded = v, R.guardBits = p >> 5, m = []; d < y + h;) {
                            var I = {};
                            8 === g ? (I.epsilon = e[d++] >> 3, I.mu = 0) : (I.epsilon = e[d] >> 3, I.mu = (7 & e[d]) << 8 | e[d + 1], d += 2), m.push(I);
                          }
                          R.SPqcds = m, a.mainHeader ? a.QCD = R : (a.currentTile.QCD = R, a.currentTile.QCC = []);
                          break;
                        case 65373:
                          y = c(e, h);
                          var M = {};
                          d = h + 2;
                          var O;
                          switch (a.SIZ.Csiz < 257 ? O = e[d++] : (O = c(e, d), d += 2), 31 & (p = e[d++])) {
                            case 0:
                              g = 8, v = !0;
                              break;
                            case 1:
                              g = 16, v = !1;
                              break;
                            case 2:
                              g = 16, v = !0;
                              break;
                            default:
                              throw new Error("Invalid SQcd value " + p);
                          }
                          for (M.noQuantization = 8 === g, M.scalarExpounded = v, M.guardBits = p >> 5, m = []; d < y + h;) I = {}, 8 === g ? (I.epsilon = e[d++] >> 3, I.mu = 0) : (I.epsilon = e[d] >> 3, I.mu = (7 & e[d]) << 8 | e[d + 1], d += 2), m.push(I);
                          M.SPqcds = m, a.mainHeader ? a.QCC[O] = M : a.currentTile.QCC[O] = M;
                          break;
                        case 65362:
                          y = c(e, h);
                          var P = {};
                          d = h + 2;
                          var B = e[d++];
                          P.entropyCoderWithCustomPrecincts = !!(1 & B), P.sopMarkerUsed = !!(2 & B), P.ephMarkerUsed = !!(4 & B), P.progressionOrder = e[d++], P.layersCount = c(e, d), d += 2, P.multipleComponentTransform = e[d++], P.decompositionLevelsCount = e[d++], P.xcb = 2 + (15 & e[d++]), P.ycb = 2 + (15 & e[d++]);
                          var D = e[d++];
                          if (P.selectiveArithmeticCodingBypass = !!(1 & D), P.resetContextProbabilities = !!(2 & D), P.terminationOnEachCodingPass = !!(4 & D), P.verticalyStripe = !!(8 & D), P.predictableTermination = !!(16 & D), P.segmentationSymbolUsed = !!(32 & D), P.reversibleTransformation = e[d++], P.entropyCoderWithCustomPrecincts) {
                            for (var L = []; d < y + h;) {
                              var F = e[d++];
                              L.push({
                                PPx: 15 & F,
                                PPy: F >> 4
                              });
                            }
                            P.precinctsSizes = L;
                          }
                          var N = [];
                          if (P.selectiveArithmeticCodingBypass && N.push("selectiveArithmeticCodingBypass"), P.resetContextProbabilities && N.push("resetContextProbabilities"), P.terminationOnEachCodingPass && N.push("terminationOnEachCodingPass"), P.verticalyStripe && N.push("verticalyStripe"), P.predictableTermination && N.push("predictableTermination"), N.length > 0) throw l = !0, new Error("Unsupported COD options (" + N.join(", ") + ")");
                          a.mainHeader ? a.COD = P : (a.currentTile.COD = P, a.currentTile.COC = []);
                          break;
                        case 65424:
                          y = c(e, h), b = {}, b.index = c(e, h + 2), b.length = u(e, h + 4), b.dataEnd = b.length + h - 2, b.partIndex = e[h + 8], b.partsCount = e[h + 9], a.mainHeader = !1, 0 === b.partIndex && (b.COD = a.COD, b.COC = a.COC.slice(0), b.QCD = a.QCD, b.QCC = a.QCC.slice(0)), a.currentTile = b;
                          break;
                        case 65427:
                          b = a.currentTile, 0 === b.partIndex && (A(a, b.index), x(a)), y = b.dataEnd - h, _(a, e, h, y);
                          break;
                        case 65365:
                        case 65367:
                        case 65368:
                        case 65380:
                          y = c(e, h);
                          break;
                        case 65363:
                          throw new Error("Codestream code 0xFF53 (COC) is not implemented");
                        default:
                          throw new Error("Unknown codestream code: " + f.toString(16));
                      }
                      h += y;
                    }
                  } catch (e) {
                    l || this.failOnCorruptedImage ? s("JPX Error: " + e.message) : o("JPX: Trying to recover from: " + e.message);
                  }
                  this.tiles = E(a), this.width = a.SIZ.Xsiz - a.SIZ.XOsiz, this.height = a.SIZ.Ysiz - a.SIZ.YOsiz, this.componentsCount = a.SIZ.Csiz;
                }
              };
              var k = function () {
                  function e(e, t) {
                    var r = l(Math.max(e, t)) + 1;
                    this.levels = [];
                    for (var n = 0; n < r; n++) {
                      var i = {
                        width: e,
                        height: t,
                        items: []
                      };
                      this.levels.push(i), e = Math.ceil(e / 2), t = Math.ceil(t / 2);
                    }
                  }
                  return e.prototype = {
                    reset: function reset(e, t) {
                      for (var r, n = 0, i = 0; n < this.levels.length;) {
                        r = this.levels[n];
                        var a = e + t * r.width;
                        if (void 0 !== r.items[a]) {
                          i = r.items[a];
                          break;
                        }
                        r.index = a, e >>= 1, t >>= 1, n++;
                      }
                      n--, r = this.levels[n], r.items[r.index] = i, this.currentLevel = n, delete this.value;
                    },
                    incrementValue: function incrementValue() {
                      var e = this.levels[this.currentLevel];
                      e.items[e.index]++;
                    },
                    nextLevel: function nextLevel() {
                      var e = this.currentLevel,
                        t = this.levels[e],
                        r = t.items[t.index];
                      return --e < 0 ? (this.value = r, !1) : (this.currentLevel = e, t = this.levels[e], t.items[t.index] = r, !0);
                    }
                  }, e;
                }(),
                R = function () {
                  function e(e, t, r) {
                    var n = l(Math.max(e, t)) + 1;
                    this.levels = [];
                    for (var i = 0; i < n; i++) {
                      for (var a = new Uint8Array(e * t), o = 0, s = a.length; o < s; o++) a[o] = r;
                      var c = {
                        width: e,
                        height: t,
                        items: a
                      };
                      this.levels.push(c), e = Math.ceil(e / 2), t = Math.ceil(t / 2);
                    }
                  }
                  return e.prototype = {
                    reset: function reset(e, t, r) {
                      for (var n = 0; n < this.levels.length;) {
                        var i = this.levels[n],
                          a = e + t * i.width;
                        i.index = a;
                        var o = i.items[a];
                        if (255 === o) break;
                        if (o > r) return this.currentLevel = n, this.propagateValues(), !1;
                        e >>= 1, t >>= 1, n++;
                      }
                      return this.currentLevel = n - 1, !0;
                    },
                    incrementValue: function incrementValue(e) {
                      var t = this.levels[this.currentLevel];
                      t.items[t.index] = e + 1, this.propagateValues();
                    },
                    propagateValues: function propagateValues() {
                      for (var e = this.currentLevel, t = this.levels[e], r = t.items[t.index]; --e >= 0;) t = this.levels[e], t.items[t.index] = r;
                    },
                    nextLevel: function nextLevel() {
                      var e = this.currentLevel,
                        t = this.levels[e],
                        r = t.items[t.index];
                      return t.items[t.index] = 255, !(--e < 0) && (this.currentLevel = e, t = this.levels[e], t.items[t.index] = r, !0);
                    }
                  }, e;
                }(),
                I = function () {
                  function e(e, i, a, o, s) {
                    this.width = e, this.height = i, this.contextLabelTable = "HH" === a ? n : "HL" === a ? r : t;
                    var l = e * i;
                    this.neighborsSignificance = new Uint8Array(l), this.coefficentsSign = new Uint8Array(l), this.coefficentsMagnitude = s > 14 ? new Uint32Array(l) : s > 6 ? new Uint16Array(l) : new Uint8Array(l), this.processingFlags = new Uint8Array(l);
                    var c = new Uint8Array(l);
                    if (0 !== o) for (var u = 0; u < l; u++) c[u] = o;
                    this.bitsDecoded = c, this.reset();
                  }
                  var t = new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8]),
                    r = new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8]),
                    n = new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]);
                  return e.prototype = {
                    setDecoder: function setDecoder(e) {
                      this.decoder = e;
                    },
                    reset: function reset() {
                      this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[17] = 92, this.contexts[18] = 6;
                    },
                    setNeighborsSignificance: function setNeighborsSignificance(e, t, r) {
                      var n,
                        i = this.neighborsSignificance,
                        a = this.width,
                        o = this.height,
                        s = t > 0,
                        l = t + 1 < a;
                      e > 0 && (n = r - a, s && (i[n - 1] += 16), l && (i[n + 1] += 16), i[n] += 4), e + 1 < o && (n = r + a, s && (i[n - 1] += 16), l && (i[n + 1] += 16), i[n] += 4), s && (i[r - 1] += 1), l && (i[r + 1] += 1), i[r] |= 128;
                    },
                    runSignificancePropagationPass: function runSignificancePropagationPass() {
                      for (var e = this.decoder, t = this.width, r = this.height, n = this.coefficentsMagnitude, i = this.coefficentsSign, a = this.neighborsSignificance, o = this.processingFlags, s = this.contexts, l = this.contextLabelTable, c = this.bitsDecoded, u = 0; u < r; u += 4) for (var h = 0; h < t; h++) for (var f = u * t + h, d = 0; d < 4; d++, f += t) {
                        var p = u + d;
                        if (p >= r) break;
                        if (o[f] &= -2, !n[f] && a[f]) {
                          var m = l[a[f]],
                            g = e.readBit(s, m);
                          if (g) {
                            var v = this.decodeSignBit(p, h, f);
                            i[f] = v, n[f] = 1, this.setNeighborsSignificance(p, h, f), o[f] |= 2;
                          }
                          c[f]++, o[f] |= 1;
                        }
                      }
                    },
                    decodeSignBit: function decodeSignBit(e, t, r) {
                      var n,
                        i,
                        a,
                        o,
                        s,
                        l,
                        c = this.width,
                        u = this.height,
                        h = this.coefficentsMagnitude,
                        f = this.coefficentsSign;
                      o = t > 0 && 0 !== h[r - 1], t + 1 < c && 0 !== h[r + 1] ? (a = f[r + 1], o ? (i = f[r - 1], n = 1 - a - i) : n = 1 - a - a) : o ? (i = f[r - 1], n = 1 - i - i) : n = 0;
                      var d = 3 * n;
                      return o = e > 0 && 0 !== h[r - c], e + 1 < u && 0 !== h[r + c] ? (a = f[r + c], o ? (i = f[r - c], n = 1 - a - i + d) : n = 1 - a - a + d) : o ? (i = f[r - c], n = 1 - i - i + d) : n = d, n >= 0 ? (s = 9 + n, l = this.decoder.readBit(this.contexts, s)) : (s = 9 - n, l = 1 ^ this.decoder.readBit(this.contexts, s)), l;
                    },
                    runMagnitudeRefinementPass: function runMagnitudeRefinementPass() {
                      for (var e, t = this.decoder, r = this.width, n = this.height, i = this.coefficentsMagnitude, a = this.neighborsSignificance, o = this.contexts, s = this.bitsDecoded, l = this.processingFlags, c = r * n, u = 4 * r, h = 0; h < c; h = e) {
                        e = Math.min(c, h + u);
                        for (var f = 0; f < r; f++) for (var d = h + f; d < e; d += r) if (i[d] && 0 == (1 & l[d])) {
                          var p = 16;
                          if (0 != (2 & l[d])) {
                            l[d] ^= 2;
                            var m = 127 & a[d];
                            p = 0 === m ? 15 : 14;
                          }
                          var g = t.readBit(o, p);
                          i[d] = i[d] << 1 | g, s[d]++, l[d] |= 1;
                        }
                      }
                    },
                    runCleanupPass: function runCleanupPass() {
                      for (var e, t = this.decoder, r = this.width, n = this.height, i = this.neighborsSignificance, a = this.coefficentsMagnitude, o = this.coefficentsSign, s = this.contexts, l = this.contextLabelTable, c = this.bitsDecoded, u = this.processingFlags, h = r, f = 2 * r, d = 3 * r, p = 0; p < n; p = e) {
                        e = Math.min(p + 4, n);
                        for (var m = p * r, g = p + 3 < n, v = 0; v < r; v++) {
                          var b,
                            y = m + v,
                            w = g && 0 === u[y] && 0 === u[y + h] && 0 === u[y + f] && 0 === u[y + d] && 0 === i[y] && 0 === i[y + h] && 0 === i[y + f] && 0 === i[y + d],
                            x = 0,
                            _ = y,
                            S = p;
                          if (w) {
                            if (!t.readBit(s, 18)) {
                              c[y]++, c[y + h]++, c[y + f]++, c[y + d]++;
                              continue;
                            }
                            x = t.readBit(s, 17) << 1 | t.readBit(s, 17), 0 !== x && (S = p + x, _ += x * r), b = this.decodeSignBit(S, v, _), o[_] = b, a[_] = 1, this.setNeighborsSignificance(S, v, _), u[_] |= 2, _ = y;
                            for (var C = p; C <= S; C++, _ += r) c[_]++;
                            x++;
                          }
                          for (S = p + x; S < e; S++, _ += r) if (!a[_] && 0 == (1 & u[_])) {
                            var E = l[i[_]],
                              A = t.readBit(s, E);
                            1 === A && (b = this.decodeSignBit(S, v, _), o[_] = b, a[_] = 1, this.setNeighborsSignificance(S, v, _), u[_] |= 2), c[_]++;
                          }
                        }
                      }
                    },
                    checkSegmentationSymbol: function checkSegmentationSymbol() {
                      var e = this.decoder,
                        t = this.contexts;
                      10 != (e.readBit(t, 17) << 3 | e.readBit(t, 17) << 2 | e.readBit(t, 17) << 1 | e.readBit(t, 17)) && s("JPX Error: Invalid segmentation symbol");
                    }
                  }, e;
                }(),
                M = function () {
                  function e() {}
                  return e.prototype.calculate = function (e, t, r) {
                    for (var n = e[0], i = 1, a = e.length; i < a; i++) n = this.iterate(n, e[i], t, r);
                    return n;
                  }, e.prototype.extend = function (e, t, r) {
                    var n = t - 1,
                      i = t + 1,
                      a = t + r - 2,
                      o = t + r;
                    e[n--] = e[i++], e[o++] = e[a--], e[n--] = e[i++], e[o++] = e[a--], e[n--] = e[i++], e[o++] = e[a--], e[n] = e[i], e[o] = e[a];
                  }, e.prototype.iterate = function (e, t, r, n) {
                    var i,
                      a,
                      o,
                      s,
                      l,
                      c,
                      u = e.width,
                      h = e.height,
                      f = e.items,
                      d = t.width,
                      p = t.height,
                      m = t.items;
                    for (o = 0, i = 0; i < h; i++) for (s = 2 * i * d, a = 0; a < u; a++, o++, s += 2) m[s] = f[o];
                    f = e.items = null;
                    var g = new Float32Array(d + 8);
                    if (1 === d) {
                      if (0 != (1 & r)) for (c = 0, o = 0; c < p; c++, o += d) m[o] *= .5;
                    } else for (c = 0, o = 0; c < p; c++, o += d) g.set(m.subarray(o, o + d), 4), this.extend(g, 4, d), this.filter(g, 4, d), m.set(g.subarray(4, 4 + d), o);
                    var v = 16,
                      b = [];
                    for (i = 0; i < v; i++) b.push(new Float32Array(p + 8));
                    var y,
                      w = 0;
                    if (e = 4 + p, 1 === p) {
                      if (0 != (1 & n)) for (l = 0; l < d; l++) m[l] *= .5;
                    } else for (l = 0; l < d; l++) {
                      if (0 === w) {
                        for (v = Math.min(d - l, v), o = l, s = 4; s < e; o += d, s++) for (y = 0; y < v; y++) b[y][s] = m[o + y];
                        w = v;
                      }
                      w--;
                      var x = b[w];
                      if (this.extend(x, 4, p), this.filter(x, 4, p), 0 === w) for (o = l - v + 1, s = 4; s < e; o += d, s++) for (y = 0; y < v; y++) m[o + y] = b[y][s];
                    }
                    return {
                      width: d,
                      height: p,
                      items: m
                    };
                  }, e;
                }(),
                O = function () {
                  function e() {
                    M.call(this);
                  }
                  return e.prototype = Object.create(M.prototype), e.prototype.filter = function (e, t, r) {
                    var n = r >> 1;
                    t |= 0;
                    var i,
                      a,
                      o,
                      s,
                      l = -1.586134342059924,
                      c = -.052980118572961,
                      u = .882911075530934,
                      h = .443506852043971,
                      f = 1.230174104914001;
                    for (i = t - 3, a = n + 4; a--; i += 2) e[i] *= .8128930661159609;
                    for (i = t - 2, o = h * e[i - 1], a = n + 3; a-- && (s = h * e[i + 1], e[i] = f * e[i] - o - s, a--); i += 2) i += 2, o = h * e[i + 1], e[i] = f * e[i] - o - s;
                    for (i = t - 1, o = u * e[i - 1], a = n + 2; a-- && (s = u * e[i + 1], e[i] -= o + s, a--); i += 2) i += 2, o = u * e[i + 1], e[i] -= o + s;
                    for (i = t, o = c * e[i - 1], a = n + 1; a-- && (s = c * e[i + 1], e[i] -= o + s, a--); i += 2) i += 2, o = c * e[i + 1], e[i] -= o + s;
                    if (0 !== n) for (i = t + 1, o = l * e[i - 1], a = n; a-- && (s = l * e[i + 1], e[i] -= o + s, a--); i += 2) i += 2, o = l * e[i + 1], e[i] -= o + s;
                  }, e;
                }(),
                P = function () {
                  function e() {
                    M.call(this);
                  }
                  return e.prototype = Object.create(M.prototype), e.prototype.filter = function (e, t, r) {
                    var n = r >> 1;
                    t |= 0;
                    var i, a;
                    for (i = t, a = n + 1; a--; i += 2) e[i] -= e[i - 1] + e[i + 1] + 2 >> 2;
                    for (i = t + 1, a = n; a--; i += 2) e[i] += e[i - 1] + e[i + 1] >> 1;
                  }, e;
                }();
              return e;
            }();
          t.JpxImage = f;
        }, function (e, t, r) {
          "use strict";

          var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            i = function () {
              function e(e, t) {
                var r = [],
                  n = !0,
                  i = !1,
                  a = void 0;
                try {
                  for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
                } catch (e) {
                  i = !0, a = e;
                } finally {
                  try {
                    !n && s.return && s.return();
                  } finally {
                    if (i) throw a;
                  }
                }
                return r;
              }
              return function (t, r) {
                if (Array.isArray(t)) return t;
                if (Symbol.iterator in Object(t)) return e(t, r);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(),
            a = r(0),
            o = r(1),
            s = r(17),
            l = r(6),
            c = r(16),
            u = r(4),
            h = a.InvalidPDFException,
            f = a.MissingDataException,
            d = a.XRefParseException,
            p = a.assert,
            m = a.bytesToString,
            g = a.createPromiseCapability,
            v = a.error,
            b = a.info,
            y = a.isArray,
            w = a.isBool,
            x = a.isInt,
            _ = a.isString,
            S = a.shadow,
            C = a.stringToPDFString,
            E = a.stringToUTF8String,
            A = a.warn,
            T = a.createValidAbsoluteUrl,
            k = a.Util,
            R = o.Dict,
            I = o.Ref,
            M = o.RefSet,
            O = o.RefSetCache,
            P = o.isName,
            B = o.isCmd,
            D = o.isDict,
            L = o.isRef,
            F = o.isRefsEqual,
            N = o.isStream,
            U = s.CipherTransformFactory,
            j = l.Lexer,
            z = l.Parser,
            H = c.ChunkedStream,
            G = u.ColorSpace,
            V = function () {
              function e(e, t, r) {
                this.pdfManager = e, this.xref = t, this.catDict = t.getCatalogObj(), p(D(this.catDict), "catalog object is not a dictionary"), this.fontCache = new O(), this.builtInCMapCache = Object.create(null), this.pageKidsCountCache = new O(), this.pageFactory = r, this.pagePromises = [];
              }
              return e.prototype = {
                get metadata() {
                  var e = this.catDict.getRaw("Metadata");
                  if (!L(e)) return S(this, "metadata", null);
                  var t,
                    r = !!this.xref.encrypt && this.xref.encrypt.encryptMetadata,
                    n = this.xref.fetch(e, !r);
                  if (n && D(n.dict)) {
                    var i = n.dict.get("Type"),
                      a = n.dict.get("Subtype");
                    if (P(i, "Metadata") && P(a, "XML")) try {
                      t = E(m(n.getBytes()));
                    } catch (e) {
                      if (e instanceof f) throw e;
                      b("Skipping invalid metadata.");
                    }
                  }
                  return S(this, "metadata", t);
                },
                get toplevelPagesDict() {
                  var e = this.catDict.get("Pages");
                  return p(D(e), "invalid top-level pages dictionary"), S(this, "toplevelPagesDict", e);
                },
                get documentOutline() {
                  var e = null;
                  try {
                    e = this.readDocumentOutline();
                  } catch (e) {
                    if (e instanceof f) throw e;
                    A("Unable to read document outline");
                  }
                  return S(this, "documentOutline", e);
                },
                readDocumentOutline: function readDocumentOutline() {
                  var t = this.catDict.get("Outlines");
                  if (!D(t)) return null;
                  if (t = t.getRaw("First"), !L(t)) return null;
                  var r = {
                      items: []
                    },
                    n = [{
                      obj: t,
                      parent: r
                    }],
                    i = new M();
                  i.put(t);
                  for (var a = this.xref, o = new Uint8Array(3); n.length > 0;) {
                    var s = n.shift(),
                      l = a.fetchIfRef(s.obj);
                    if (null !== l) {
                      p(l.has("Title"), "Invalid outline item");
                      var c = {
                        url: null,
                        dest: null
                      };
                      e.parseDestDictionary({
                        destDict: l,
                        resultObj: c,
                        docBaseUrl: this.pdfManager.docBaseUrl
                      });
                      var u = l.get("Title"),
                        h = l.get("F") || 0,
                        f = l.getArray("C"),
                        d = o;
                      !y(f) || 3 !== f.length || 0 === f[0] && 0 === f[1] && 0 === f[2] || (d = G.singletons.rgb.getRgb(f, 0));
                      var m = {
                        dest: c.dest,
                        url: c.url,
                        unsafeUrl: c.unsafeUrl,
                        newWindow: c.newWindow,
                        title: C(u),
                        color: d,
                        count: l.get("Count"),
                        bold: !!(2 & h),
                        italic: !!(1 & h),
                        items: []
                      };
                      s.parent.items.push(m), t = l.getRaw("First"), L(t) && !i.has(t) && (n.push({
                        obj: t,
                        parent: m
                      }), i.put(t)), t = l.getRaw("Next"), L(t) && !i.has(t) && (n.push({
                        obj: t,
                        parent: s.parent
                      }), i.put(t));
                    }
                  }
                  return r.items.length > 0 ? r.items : null;
                },
                get numPages() {
                  var e = this.toplevelPagesDict.get("Count");
                  return p(x(e), "page count in top level pages object is not an integer"), S(this, "num", e);
                },
                get destinations() {
                  function e(e) {
                    return D(e) ? e.get("D") : e;
                  }
                  var t,
                    r,
                    n = this.xref,
                    i = {},
                    a = this.catDict.get("Names");
                  if (a && a.has("Dests") ? t = a.getRaw("Dests") : this.catDict.has("Dests") && (r = this.catDict.get("Dests")), r && (a = r, a.forEach(function (t, r) {
                    r && (i[t] = e(r));
                  })), t) {
                    var o = new X(t, n),
                      s = o.getAll();
                    for (var l in s) i[l] = e(s[l]);
                  }
                  return S(this, "destinations", i);
                },
                getDestination: function getDestination(e) {
                  function t(e) {
                    return D(e) ? e.get("D") : e;
                  }
                  var r,
                    n,
                    i = this.xref,
                    a = null,
                    o = this.catDict.get("Names");
                  if (o && o.has("Dests") ? r = o.getRaw("Dests") : this.catDict.has("Dests") && (n = this.catDict.get("Dests")), n) {
                    var s = n.get(e);
                    s && (a = t(s));
                  }
                  if (r) {
                    a = t(new X(r, i).get(e));
                  }
                  return a;
                },
                get pageLabels() {
                  var e = null;
                  try {
                    e = this.readPageLabels();
                  } catch (e) {
                    if (e instanceof f) throw e;
                    A("Unable to read page labels.");
                  }
                  return S(this, "pageLabels", e);
                },
                readPageLabels: function readPageLabels() {
                  var e = this.catDict.getRaw("PageLabels");
                  if (!e) return null;
                  for (var t = new Array(this.numPages), r = null, n = "", i = new Y(e, this.xref), a = i.getAll(), o = "", s = 1, l = 0, c = this.numPages; l < c; l++) {
                    if (l in a) {
                      var u = a[l];
                      p(D(u), "The PageLabel is not a dictionary.");
                      var h = u.get("Type");
                      p(!h || P(h, "PageLabel"), "Invalid type in PageLabel dictionary.");
                      var f = u.get("S");
                      p(!f || P(f), "Invalid style in PageLabel dictionary."), r = f ? f.name : null;
                      var d = u.get("P");
                      p(!d || _(d), "Invalid prefix in PageLabel dictionary."), n = d ? C(d) : "";
                      var m = u.get("St");
                      p(!m || x(m) && m >= 1, "Invalid start in PageLabel dictionary."), s = m || 1;
                    }
                    switch (r) {
                      case "D":
                        o = s;
                        break;
                      case "R":
                      case "r":
                        o = k.toRoman(s, "r" === r);
                        break;
                      case "A":
                      case "a":
                        for (var g = "a" === r ? 97 : 65, v = s - 1, b = String.fromCharCode(g + v % 26), y = [], w = 0, S = v / 26 | 0; w <= S; w++) y.push(b);
                        o = y.join("");
                        break;
                      default:
                        p(!r, 'Invalid style "' + r + '" in PageLabel dictionary.');
                    }
                    t[l] = n + o, o = "", s++;
                  }
                  return t;
                },
                get attachments() {
                  var e,
                    t = this.xref,
                    r = null,
                    n = this.catDict.get("Names");
                  if (n && (e = n.getRaw("EmbeddedFiles")), e) {
                    var i = new X(e, t),
                      a = i.getAll();
                    for (var o in a) {
                      var s = new K(a[o], t);
                      r || (r = Object.create(null)), r[C(o)] = s.serializable;
                    }
                  }
                  return S(this, "attachments", r);
                },
                get javaScript() {
                  function e(e) {
                    var t = e.get("S");
                    if (P(t, "JavaScript")) {
                      var r = e.get("JS");
                      if (N(r)) r = m(r.getBytes());else if (!_(r)) return;
                      n.push(C(r));
                    }
                  }
                  var t = this.xref,
                    r = this.catDict.get("Names"),
                    n = [];
                  if (r && r.has("JavaScript")) {
                    var i = new X(r.getRaw("JavaScript"), t),
                      a = i.getAll();
                    for (var o in a) {
                      var s = a[o];
                      D(s) && e(s);
                    }
                  }
                  var l = this.catDict.get("OpenAction");
                  if (D(l, "Action")) {
                    var c = l.get("S");
                    if (P(c, "Named")) {
                      var u = l.get("N");
                      P(u, "Print") && n.push("print({});");
                    } else e(l);
                  }
                  return S(this, "javaScript", n);
                },
                cleanup: function cleanup() {
                  var e = this;
                  this.pageKidsCountCache.clear();
                  var t = [];
                  return this.fontCache.forEach(function (e) {
                    t.push(e);
                  }), Promise.all(t).then(function (t) {
                    for (var r = 0, n = t.length; r < n; r++) {
                      delete t[r].dict.translated;
                    }
                    e.fontCache.clear(), e.builtInCMapCache = Object.create(null);
                  });
                },
                getPage: function getPage(e) {
                  var t = this;
                  return e in this.pagePromises || (this.pagePromises[e] = this.getPageDict(e).then(function (r) {
                    var n = i(r, 2),
                      a = n[0],
                      o = n[1];
                    return t.pageFactory.createPage(e, a, o, t.fontCache, t.builtInCMapCache);
                  })), this.pagePromises[e];
                },
                getPageDict: function getPageDict(e) {
                  function t() {
                    for (; i.length;) {
                      var l = i.pop();
                      if (L(l)) {
                        if ((r = s.get(l)) > 0 && a + r < e) {
                          a += r;
                          continue;
                        }
                        return void o.fetchAsync(l).then(function (r) {
                          if (D(r, "Page") || D(r) && !r.has("Kids")) return void (e === a ? (l && !s.has(l) && s.put(l, 1), n.resolve([r, l])) : (a++, t()));
                          i.push(r), t();
                        }, n.reject);
                      }
                      p(D(l), "page dictionary kid reference points to wrong type of object"), r = l.get("Count");
                      var c = l.objId;
                      if (c && !s.has(c) && s.put(c, r), a + r <= e) a += r;else {
                        var u = l.get("Kids");
                        p(y(u), "page dictionary kids object is not an array");
                        for (var h = u.length - 1; h >= 0; h--) i.push(u[h]);
                      }
                    }
                    n.reject("Page index " + e + " not found.");
                  }
                  var r,
                    n = g(),
                    i = [this.catDict.getRaw("Pages")],
                    a = 0,
                    o = this.xref,
                    s = this.pageKidsCountCache;
                  return t(), n.promise;
                },
                getPageIndex: function getPageIndex(e) {
                  function t(t) {
                    var r,
                      i = 0;
                    return n.fetchAsync(t).then(function (n) {
                      if (F(t, e) && !D(n, "Page") && (!D(n) || n.has("Type") || !n.has("Contents"))) throw new Error("The reference does not point to a /Page Dict.");
                      return n ? (p(D(n), "node must be a Dict."), r = n.getRaw("Parent"), n.getAsync("Parent")) : null;
                    }).then(function (e) {
                      return e ? (p(D(e), "parent must be a Dict."), e.getAsync("Kids")) : null;
                    }).then(function (e) {
                      if (!e) return null;
                      for (var a = [], o = !1, s = 0; s < e.length; s++) {
                        var l = e[s];
                        if (p(L(l), "kid must be a Ref."), l.num === t.num) {
                          o = !0;
                          break;
                        }
                        a.push(n.fetchAsync(l).then(function (e) {
                          if (e.has("Count")) {
                            var t = e.get("Count");
                            i += t;
                          } else i++;
                        }));
                      }
                      return o || v("kid ref not found in parents kids"), Promise.all(a).then(function () {
                        return [i, r];
                      });
                    });
                  }
                  function r(e) {
                    return t(e).then(function (e) {
                      if (!e) return i;
                      var t = e[0],
                        n = e[1];
                      return i += t, r(n);
                    });
                  }
                  var n = this.xref,
                    i = 0;
                  return r(e);
                }
              }, e.parseDestDictionary = function (e) {
                var t = e.destDict;
                if (!D(t)) return void A('Catalog_parseDestDictionary: "destDict" must be a dictionary.');
                var r = e.resultObj;
                if ("object" !== (void 0 === r ? "undefined" : n(r))) return void A('Catalog_parseDestDictionary: "resultObj" must be an object.');
                var i,
                  a,
                  o = e.docBaseUrl || null,
                  s = t.get("A");
                if (D(s)) {
                  var l = s.get("S").name;
                  switch (l) {
                    case "URI":
                      i = s.get("URI"), P(i) ? i = "/" + i.name : _(i) && (i = function (e) {
                        return 0 === e.indexOf("www.") ? "http://" + e : e;
                      }(i));
                      break;
                    case "GoTo":
                      a = s.get("D");
                      break;
                    case "Launch":
                    case "GoToR":
                      var c = s.get("F");
                      D(c) ? i = c.get("F") || null : _(c) && (i = c);
                      var u = s.get("D");
                      if (u && (P(u) && (u = u.name), _(i))) {
                        var h = i.split("#")[0];
                        _(u) ? i = h + "#" + (/^\d+$/.test(u) ? "nameddest=" : "") + u : y(u) && (i = h + "#" + JSON.stringify(u));
                      }
                      var f = s.get("NewWindow");
                      w(f) && (r.newWindow = f);
                      break;
                    case "Named":
                      var d = s.get("N");
                      P(d) && (r.action = d.name);
                      break;
                    case "JavaScript":
                      var p,
                        g = s.get("JS");
                      if (N(g) ? p = m(g.getBytes()) : _(g) && (p = g), p) {
                        var v = ["app.launchURL", "window.open"],
                          b = new RegExp("^\\s*(" + v.join("|").split(".").join("\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i"),
                          x = b.exec(C(p));
                        if (x && x[2]) {
                          i = x[2], "true" === x[3] && "app.launchURL" === x[1] && (r.newWindow = !0);
                          break;
                        }
                      }
                    default:
                      A('Catalog_parseDestDictionary: Unrecognized link type "' + l + '".');
                  }
                } else t.has("Dest") && (a = t.get("Dest"));
                if (_(i)) {
                  i = function (e) {
                    try {
                      return E(e);
                    } catch (t) {
                      return e;
                    }
                  }(i);
                  var S = T(i, o);
                  S && (r.url = S.href), r.unsafeUrl = i;
                }
                a && (P(a) && (a = a.name), (_(a) || y(a)) && (r.dest = a));
              }, e;
            }(),
            q = function () {
              function e(e, t) {
                this.stream = e, this.pdfManager = t, this.entries = [], this.xrefstms = Object.create(null), this.cache = [], this.stats = {
                  streamTypes: [],
                  fontTypes: []
                };
              }
              return e.prototype = {
                setStartXRef: function setStartXRef(e) {
                  this.startXRefQueue = [e];
                },
                parse: function parse(e) {
                  var t;
                  e ? (A("Indexing all PDF objects"), t = this.indexObjects()) : t = this.readXRef(), t.assignXref(this), this.trailer = t;
                  var r = t.get("Encrypt");
                  if (D(r)) {
                    var n = t.get("ID"),
                      i = n && n.length ? n[0] : "";
                    r.suppressEncryption = !0, this.encrypt = new U(r, i, this.pdfManager.password);
                  }
                  (this.root = t.get("Root")) || v("Invalid root reference");
                },
                processXRefTable: function processXRefTable(e) {
                  "tableState" in this || (this.tableState = {
                    entryNum: 0,
                    streamPos: e.lexer.stream.pos,
                    parserBuf1: e.buf1,
                    parserBuf2: e.buf2
                  });
                  var t = this.readXRefTable(e);
                  B(t, "trailer") || v("Invalid XRef table: could not find trailer dictionary");
                  var r = e.getObj();
                  return !D(r) && r.dict && (r = r.dict), D(r) || v("Invalid XRef table: could not parse trailer dictionary"), delete this.tableState, r;
                },
                readXRefTable: function readXRefTable(e) {
                  var t = e.lexer.stream,
                    r = this.tableState;
                  t.pos = r.streamPos, e.buf1 = r.parserBuf1, e.buf2 = r.parserBuf2;
                  for (var n;;) {
                    if (!("firstEntryNum" in r && "entryCount" in r)) {
                      if (B(n = e.getObj(), "trailer")) break;
                      r.firstEntryNum = n, r.entryCount = e.getObj();
                    }
                    var i = r.firstEntryNum,
                      a = r.entryCount;
                    x(i) && x(a) || v("Invalid XRef table: wrong types in subsection header");
                    for (var o = r.entryNum; o < a; o++) {
                      r.streamPos = t.pos, r.entryNum = o, r.parserBuf1 = e.buf1, r.parserBuf2 = e.buf2;
                      var s = {};
                      s.offset = e.getObj(), s.gen = e.getObj();
                      var l = e.getObj();
                      B(l, "f") ? s.free = !0 : B(l, "n") && (s.uncompressed = !0), x(s.offset) && x(s.gen) && (s.free || s.uncompressed) || v("Invalid entry in XRef subsection: " + i + ", " + a), 0 === o && s.free && 1 === i && (i = 0), this.entries[o + i] || (this.entries[o + i] = s);
                    }
                    r.entryNum = 0, r.streamPos = t.pos, r.parserBuf1 = e.buf1, r.parserBuf2 = e.buf2, delete r.firstEntryNum, delete r.entryCount;
                  }
                  return this.entries[0] && !this.entries[0].free && v("Invalid XRef table: unexpected first object"), n;
                },
                processXRefStream: function processXRefStream(e) {
                  if (!("streamState" in this)) {
                    var t = e.dict,
                      r = t.get("W"),
                      n = t.get("Index");
                    n || (n = [0, t.get("Size")]), this.streamState = {
                      entryRanges: n,
                      byteWidths: r,
                      entryNum: 0,
                      streamPos: e.pos
                    };
                  }
                  return this.readXRefStream(e), delete this.streamState, e.dict;
                },
                readXRefStream: function readXRefStream(e) {
                  var t,
                    r,
                    n = this.streamState;
                  e.pos = n.streamPos;
                  for (var i = n.byteWidths, a = i[0], o = i[1], s = i[2], l = n.entryRanges; l.length > 0;) {
                    var c = l[0],
                      u = l[1];
                    for (x(c) && x(u) || v("Invalid XRef range fields: " + c + ", " + u), x(a) && x(o) && x(s) || v("Invalid XRef entry fields length: " + c + ", " + u), t = n.entryNum; t < u; ++t) {
                      n.entryNum = t, n.streamPos = e.pos;
                      var h = 0,
                        f = 0,
                        d = 0;
                      for (r = 0; r < a; ++r) h = h << 8 | e.getByte();
                      for (0 === a && (h = 1), r = 0; r < o; ++r) f = f << 8 | e.getByte();
                      for (r = 0; r < s; ++r) d = d << 8 | e.getByte();
                      var p = {};
                      switch (p.offset = f, p.gen = d, h) {
                        case 0:
                          p.free = !0;
                          break;
                        case 1:
                          p.uncompressed = !0;
                          break;
                        case 2:
                          break;
                        default:
                          v("Invalid XRef entry type: " + h);
                      }
                      this.entries[c + t] || (this.entries[c + t] = p);
                    }
                    n.entryNum = 0, n.streamPos = e.pos, l.splice(0, 2);
                  }
                },
                indexObjects: function indexObjects() {
                  function e(e, t, r) {
                    for (var n = r.length, i = e.length, a = 0; t < i;) {
                      for (var o = 0; o < n && e[t + o] === r[o];) ++o;
                      if (o >= n) break;
                      t++, a++;
                    }
                    return a;
                  }
                  var t = 10,
                    r = 13,
                    n = 60,
                    i = /^(\d+)\s+(\d+)\s+obj\b/,
                    a = new Uint8Array([116, 114, 97, 105, 108, 101, 114]),
                    o = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]),
                    s = new Uint8Array([101, 110, 100, 111, 98, 106]),
                    l = new Uint8Array([47, 88, 82, 101, 102]);
                  this.entries.length = 0;
                  var c = this.stream;
                  c.pos = 0;
                  for (var u = c.getBytes(), f = c.start, d = u.length, p = [], m = []; f < d;) {
                    var g = u[f];
                    if (9 !== g && g !== t && g !== r && 32 !== g) {
                      if (37 !== g) {
                        var v,
                          b = function (e, i) {
                            for (var a = "", o = e[i]; o !== t && o !== r && o !== n && !(++i >= e.length);) a += String.fromCharCode(o), o = e[i];
                            return a;
                          }(u, f);
                        if (0 !== b.indexOf("xref") || 4 !== b.length && !/\s/.test(b[4])) {
                          if (v = i.exec(b)) {
                            void 0 === this.entries[v[1]] && (this.entries[v[1]] = {
                              offset: f - c.start,
                              gen: 0 | v[2],
                              uncompressed: !0
                            });
                            var y = e(u, f, s) + 7,
                              w = u.subarray(f, f + y),
                              x = e(w, 0, l);
                            x < y && w[x + 5] < 64 && (m.push(f - c.start), this.xrefstms[f - c.start] = 1), f += y;
                          } else 0 !== b.indexOf("trailer") || 7 !== b.length && !/\s/.test(b[7]) ? f += b.length + 1 : (p.push(f), f += e(u, f, o));
                        } else f += e(u, f, a), p.push(f), f += e(u, f, o);
                      } else do {
                        if (++f >= d) break;
                        g = u[f];
                      } while (g !== t && g !== r);
                    } else ++f;
                  }
                  var _, S;
                  for (_ = 0, S = m.length; _ < S; ++_) this.startXRefQueue.push(m[_]), this.readXRef(!0);
                  var C;
                  for (_ = 0, S = p.length; _ < S; ++_) {
                    c.pos = p[_];
                    var E = new z(new j(c), !0, this, !0),
                      A = E.getObj();
                    if (B(A, "trailer") && (C = E.getObj(), D(C) && C.has("ID"))) return C;
                  }
                  if (C) return C;
                  throw new h("Invalid PDF structure");
                },
                readXRef: function readXRef(e) {
                  var t = this.stream;
                  try {
                    for (; this.startXRefQueue.length;) {
                      var r = this.startXRefQueue[0];
                      t.pos = r + t.start;
                      var n,
                        i = new z(new j(t), !0, this),
                        a = i.getObj();
                      if (B(a, "xref")) {
                        if (n = this.processXRefTable(i), this.topDict || (this.topDict = n), a = n.get("XRefStm"), x(a)) {
                          var o = a;
                          o in this.xrefstms || (this.xrefstms[o] = 1, this.startXRefQueue.push(o));
                        }
                      } else x(a) ? (x(i.getObj()) && B(i.getObj(), "obj") && N(a = i.getObj()) || v("Invalid XRef stream"), n = this.processXRefStream(a), this.topDict || (this.topDict = n), n || v("Failed to read XRef stream")) : v("Invalid XRef stream header");
                      a = n.get("Prev"), x(a) ? this.startXRefQueue.push(a) : L(a) && this.startXRefQueue.push(a.num), this.startXRefQueue.shift();
                    }
                    return this.topDict;
                  } catch (e) {
                    if (e instanceof f) throw e;
                    b("(while reading XRef): " + e);
                  }
                  if (!e) throw new d();
                },
                getEntry: function getEntry(e) {
                  var t = this.entries[e];
                  return t && !t.free && t.offset ? t : null;
                },
                fetchIfRef: function fetchIfRef(e, t) {
                  return L(e) ? this.fetch(e, t) : e;
                },
                fetch: function fetch(e, t) {
                  p(L(e), "ref object is not a reference");
                  var r = e.num;
                  if (r in this.cache) {
                    var n = this.cache[r];
                    return n instanceof R && !n.objId && (n.objId = e.toString()), n;
                  }
                  var i = this.getEntry(r);
                  return null === i ? this.cache[r] = null : (i = i.uncompressed ? this.fetchUncompressed(e, i, t) : this.fetchCompressed(i, t), D(i) ? i.objId = e.toString() : N(i) && (i.dict.objId = e.toString()), i);
                },
                fetchUncompressed: function fetchUncompressed(e, t, r) {
                  var n = e.gen,
                    i = e.num;
                  t.gen !== n && v("inconsistent generation in XRef");
                  var a = this.stream.makeSubStream(t.offset + this.stream.start),
                    o = new z(new j(a), !0, this),
                    s = o.getObj(),
                    l = o.getObj(),
                    c = o.getObj();
                  if (x(s) && parseInt(s, 10) === i && x(l) && parseInt(l, 10) === n && B(c) || v("bad XRef entry"), !B(c, "obj")) {
                    if (0 === c.cmd.indexOf("obj") && (i = parseInt(c.cmd.substring(3), 10), !isNaN(i))) return i;
                    v("bad XRef entry");
                  }
                  return t = this.encrypt && !r ? o.getObj(this.encrypt.createCipherTransform(i, n)) : o.getObj(), N(t) || (this.cache[i] = t), t;
                },
                fetchCompressed: function fetchCompressed(e, t) {
                  var r = e.offset,
                    n = this.fetch(new I(r, 0));
                  N(n) || v("bad ObjStm stream");
                  var i = n.dict.get("First"),
                    a = n.dict.get("N");
                  x(i) && x(a) || v("invalid first and n parameters for ObjStm stream");
                  var o = new z(new j(n), !1, this);
                  o.allowStreams = !0;
                  var s,
                    l,
                    c = [],
                    u = [];
                  for (s = 0; s < a; ++s) {
                    l = o.getObj(), x(l) || v("invalid object number in the ObjStm stream: " + l), u.push(l);
                    var h = o.getObj();
                    x(h) || v("invalid object offset in the ObjStm stream: " + h);
                  }
                  for (s = 0; s < a; ++s) {
                    c.push(o.getObj()), B(o.buf1, "endobj") && o.shift(), l = u[s];
                    var f = this.entries[l];
                    f && f.offset === r && f.gen === s && (this.cache[l] = c[s]);
                  }
                  return e = c[e.gen], void 0 === e && v("bad XRef entry for compressed object"), e;
                },
                fetchIfRefAsync: function fetchIfRefAsync(e, t) {
                  return L(e) ? this.fetchAsync(e, t) : Promise.resolve(e);
                },
                fetchAsync: function fetchAsync(e, t) {
                  var r = this.stream.manager,
                    n = this;
                  return new Promise(function i(a, o) {
                    try {
                      a(n.fetch(e, t));
                    } catch (e) {
                      if (e instanceof f) return void r.requestRange(e.begin, e.end).then(function () {
                        i(a, o);
                      }, o);
                      o(e);
                    }
                  });
                },
                getCatalogObj: function getCatalogObj() {
                  return this.root;
                }
              }, e;
            }(),
            W = function () {
              function e(e, t) {
                throw new Error("Cannot initialize NameOrNumberTree.");
              }
              return e.prototype = {
                getAll: function getAll() {
                  var e = Object.create(null);
                  if (!this.root) return e;
                  var t = this.xref,
                    r = new M();
                  r.put(this.root);
                  for (var n = [this.root]; n.length > 0;) {
                    var i,
                      a,
                      o = t.fetchIfRef(n.shift());
                    if (D(o)) if (o.has("Kids")) {
                      var s = o.get("Kids");
                      for (i = 0, a = s.length; i < a; i++) {
                        var l = s[i];
                        p(!r.has(l), 'Duplicate entry in "' + this._type + '" tree.'), n.push(l), r.put(l);
                      }
                    } else {
                      var c = o.get(this._type);
                      if (y(c)) for (i = 0, a = c.length; i < a; i += 2) e[t.fetchIfRef(c[i])] = t.fetchIfRef(c[i + 1]);
                    }
                  }
                  return e;
                },
                get: function get(e) {
                  if (!this.root) return null;
                  for (var t, r, n, i = this.xref, a = i.fetchIfRef(this.root), o = 0; a.has("Kids");) {
                    if (++o > 10) return A('Search depth limit reached for "' + this._type + '" tree.'), null;
                    var s = a.get("Kids");
                    if (!y(s)) return null;
                    for (t = 0, r = s.length - 1; t <= r;) {
                      n = t + r >> 1;
                      var l = i.fetchIfRef(s[n]),
                        c = l.get("Limits");
                      if (e < i.fetchIfRef(c[0])) r = n - 1;else {
                        if (!(e > i.fetchIfRef(c[1]))) {
                          a = i.fetchIfRef(s[n]);
                          break;
                        }
                        t = n + 1;
                      }
                    }
                    if (t > r) return null;
                  }
                  var u = a.get(this._type);
                  if (y(u)) for (t = 0, r = u.length - 2; t <= r;) {
                    n = t + r & -2;
                    var h = i.fetchIfRef(u[n]);
                    if (e < h) r = n - 2;else {
                      if (!(e > h)) return i.fetchIfRef(u[n + 1]);
                      t = n + 2;
                    }
                  }
                  return null;
                }
              }, e;
            }(),
            X = function () {
              function e(e, t) {
                this.root = e, this.xref = t, this._type = "Names";
              }
              return k.inherit(e, W, {}), e;
            }(),
            Y = function () {
              function e(e, t) {
                this.root = e, this.xref = t, this._type = "Nums";
              }
              return k.inherit(e, W, {}), e;
            }(),
            K = function () {
              function e(e, t) {
                e && D(e) && (this.xref = t, this.root = e, e.has("FS") && (this.fs = e.get("FS")), this.description = e.has("Desc") ? C(e.get("Desc")) : "", e.has("RF") && A("Related file specifications are not supported"), this.contentAvailable = !0, e.has("EF") || (this.contentAvailable = !1, A("Non-embedded file specifications are not supported")));
              }
              function t(e) {
                return e.has("UF") ? e.get("UF") : e.has("F") ? e.get("F") : e.has("Unix") ? e.get("Unix") : e.has("Mac") ? e.get("Mac") : e.has("DOS") ? e.get("DOS") : null;
              }
              return e.prototype = {
                get filename() {
                  if (!this._filename && this.root) {
                    var e = t(this.root) || "unnamed";
                    this._filename = C(e).replace(/\\\\/g, "\\").replace(/\\\//g, "/").replace(/\\/g, "/");
                  }
                  return this._filename;
                },
                get content() {
                  if (!this.contentAvailable) return null;
                  !this.contentRef && this.root && (this.contentRef = t(this.root.get("EF")));
                  var e = null;
                  if (this.contentRef) {
                    var r = this.xref,
                      n = r.fetchIfRef(this.contentRef);
                    n && N(n) ? e = n.getBytes() : A("Embedded file specification points to non-existing/invalid content");
                  } else A("Embedded file specification does not have a content");
                  return e;
                },
                get serializable() {
                  return {
                    filename: this.filename,
                    content: this.content
                  };
                }
              }, e;
            }(),
            Z = function () {
              function e(e) {
                return L(e) || D(e) || y(e) || N(e);
              }
              function t(t, r) {
                var n;
                if (D(t) || N(t)) {
                  var i;
                  i = D(t) ? t.map : t.dict.map;
                  for (var a in i) n = i[a], e(n) && r.push(n);
                } else if (y(t)) for (var o = 0, s = t.length; o < s; o++) n = t[o], e(n) && r.push(n);
              }
              function r(e, t, r) {
                this.obj = e, this.keys = t, this.xref = r, this.refSet = null, this.capability = null;
              }
              return r.prototype = {
                load: function load() {
                  var e = this.keys;
                  if (this.capability = g(), !(this.xref.stream instanceof H) || 0 === this.xref.stream.getMissingChunks().length) return this.capability.resolve(), this.capability.promise;
                  this.refSet = new M();
                  for (var t = [], r = 0; r < e.length; r++) t.push(this.obj[e[r]]);
                  return this._walk(t), this.capability.promise;
                },
                _walk: function _walk(e) {
                  for (var r = this, n = [], i = []; e.length;) {
                    var a = e.pop();
                    if (L(a)) {
                      if (this.refSet.has(a)) continue;
                      try {
                        var o = a;
                        this.refSet.put(o), a = this.xref.fetch(a);
                      } catch (e) {
                        if (!(e instanceof f)) throw e;
                        n.push(a), i.push({
                          begin: e.begin,
                          end: e.end
                        });
                      }
                    }
                    if (a && a.getBaseStreams) {
                      for (var s = a.getBaseStreams(), l = !1, c = 0; c < s.length; c++) {
                        var u = s[c];
                        u.getMissingChunks && u.getMissingChunks().length && (l = !0, i.push({
                          begin: u.start,
                          end: u.end
                        }));
                      }
                      l && n.push(a);
                    }
                    t(a, e);
                  }
                  if (i.length) return void this.xref.stream.manager.requestRanges(i).then(function () {
                    e = n;
                    for (var t = 0; t < n.length; t++) {
                      var i = n[t];
                      L(i) && r.refSet.remove(i);
                    }
                    r._walk(e);
                  }, this.capability.reject);
                  this.refSet = null, this.capability.resolve();
                }
              }, r;
            }();
          t.Catalog = V, t.ObjectLoader = Z, t.XRef = q, t.FileSpec = K;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = n.getLookupTableFactory,
            a = i(function (e) {
              e.ArialNarrow = "Helvetica", e["ArialNarrow-Bold"] = "Helvetica-Bold", e["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", e["ArialNarrow-Italic"] = "Helvetica-Oblique", e.ArialBlack = "Helvetica", e["ArialBlack-Bold"] = "Helvetica-Bold", e["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", e["ArialBlack-Italic"] = "Helvetica-Oblique", e["Arial-Black"] = "Helvetica", e["Arial-Black-Bold"] = "Helvetica-Bold", e["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", e["Arial-Black-Italic"] = "Helvetica-Oblique", e.Arial = "Helvetica", e["Arial-Bold"] = "Helvetica-Bold", e["Arial-BoldItalic"] = "Helvetica-BoldOblique", e["Arial-Italic"] = "Helvetica-Oblique", e["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", e["Arial-BoldMT"] = "Helvetica-Bold", e["Arial-ItalicMT"] = "Helvetica-Oblique", e.ArialMT = "Helvetica", e["Courier-Bold"] = "Courier-Bold", e["Courier-BoldItalic"] = "Courier-BoldOblique", e["Courier-Italic"] = "Courier-Oblique", e.CourierNew = "Courier", e["CourierNew-Bold"] = "Courier-Bold", e["CourierNew-BoldItalic"] = "Courier-BoldOblique", e["CourierNew-Italic"] = "Courier-Oblique", e["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", e["CourierNewPS-BoldMT"] = "Courier-Bold", e["CourierNewPS-ItalicMT"] = "Courier-Oblique", e.CourierNewPSMT = "Courier", e.Helvetica = "Helvetica", e["Helvetica-Bold"] = "Helvetica-Bold", e["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", e["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", e["Helvetica-Italic"] = "Helvetica-Oblique", e["Helvetica-Oblique"] = "Helvetica-Oblique", e["Symbol-Bold"] = "Symbol", e["Symbol-BoldItalic"] = "Symbol", e["Symbol-Italic"] = "Symbol", e.TimesNewRoman = "Times-Roman", e["TimesNewRoman-Bold"] = "Times-Bold", e["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", e["TimesNewRoman-Italic"] = "Times-Italic", e.TimesNewRomanPS = "Times-Roman", e["TimesNewRomanPS-Bold"] = "Times-Bold", e["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", e["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", e["TimesNewRomanPS-BoldMT"] = "Times-Bold", e["TimesNewRomanPS-Italic"] = "Times-Italic", e["TimesNewRomanPS-ItalicMT"] = "Times-Italic", e.TimesNewRomanPSMT = "Times-Roman", e["TimesNewRomanPSMT-Bold"] = "Times-Bold", e["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", e["TimesNewRomanPSMT-Italic"] = "Times-Italic";
            }),
            o = i(function (e) {
              e.CenturyGothic = "Helvetica", e["CenturyGothic-Bold"] = "Helvetica-Bold", e["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", e["CenturyGothic-Italic"] = "Helvetica-Oblique", e.ComicSansMS = "Comic Sans MS", e["ComicSansMS-Bold"] = "Comic Sans MS-Bold", e["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", e["ComicSansMS-Italic"] = "Comic Sans MS-Italic", e.LucidaConsole = "Courier", e["LucidaConsole-Bold"] = "Courier-Bold", e["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", e["LucidaConsole-Italic"] = "Courier-Oblique", e["MS-Gothic"] = "MS Gothic", e["MS-Gothic-Bold"] = "MS Gothic-Bold", e["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", e["MS-Gothic-Italic"] = "MS Gothic-Italic", e["MS-Mincho"] = "MS Mincho", e["MS-Mincho-Bold"] = "MS Mincho-Bold", e["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", e["MS-Mincho-Italic"] = "MS Mincho-Italic", e["MS-PGothic"] = "MS PGothic", e["MS-PGothic-Bold"] = "MS PGothic-Bold", e["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", e["MS-PGothic-Italic"] = "MS PGothic-Italic", e["MS-PMincho"] = "MS PMincho", e["MS-PMincho-Bold"] = "MS PMincho-Bold", e["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", e["MS-PMincho-Italic"] = "MS PMincho-Italic", e.NuptialScript = "Times-Italic", e.Wingdings = "ZapfDingbats";
            }),
            s = i(function (e) {
              e["Adobe Jenson"] = !0, e["Adobe Text"] = !0, e.Albertus = !0, e.Aldus = !0, e.Alexandria = !0, e.Algerian = !0, e["American Typewriter"] = !0, e.Antiqua = !0, e.Apex = !0, e.Arno = !0, e.Aster = !0, e.Aurora = !0, e.Baskerville = !0, e.Bell = !0, e.Bembo = !0, e["Bembo Schoolbook"] = !0, e.Benguiat = !0, e["Berkeley Old Style"] = !0, e["Bernhard Modern"] = !0, e["Berthold City"] = !0, e.Bodoni = !0, e["Bauer Bodoni"] = !0, e["Book Antiqua"] = !0, e.Bookman = !0, e["Bordeaux Roman"] = !0, e["Californian FB"] = !0, e.Calisto = !0, e.Calvert = !0, e.Capitals = !0, e.Cambria = !0, e.Cartier = !0, e.Caslon = !0, e.Catull = !0, e.Centaur = !0, e["Century Old Style"] = !0, e["Century Schoolbook"] = !0, e.Chaparral = !0, e["Charis SIL"] = !0, e.Cheltenham = !0, e["Cholla Slab"] = !0, e.Clarendon = !0, e.Clearface = !0, e.Cochin = !0, e.Colonna = !0, e["Computer Modern"] = !0, e["Concrete Roman"] = !0, e.Constantia = !0, e["Cooper Black"] = !0, e.Corona = !0, e.Ecotype = !0, e.Egyptienne = !0, e.Elephant = !0, e.Excelsior = !0, e.Fairfield = !0, e["FF Scala"] = !0, e.Folkard = !0, e.Footlight = !0, e.FreeSerif = !0, e["Friz Quadrata"] = !0, e.Garamond = !0, e.Gentium = !0, e.Georgia = !0, e.Gloucester = !0, e["Goudy Old Style"] = !0, e["Goudy Schoolbook"] = !0, e["Goudy Pro Font"] = !0, e.Granjon = !0, e["Guardian Egyptian"] = !0, e.Heather = !0, e.Hercules = !0, e["High Tower Text"] = !0, e.Hiroshige = !0, e["Hoefler Text"] = !0, e["Humana Serif"] = !0, e.Imprint = !0, e["Ionic No. 5"] = !0, e.Janson = !0, e.Joanna = !0, e.Korinna = !0, e.Lexicon = !0, e["Liberation Serif"] = !0, e["Linux Libertine"] = !0, e.Literaturnaya = !0, e.Lucida = !0, e["Lucida Bright"] = !0, e.Melior = !0, e.Memphis = !0, e.Miller = !0, e.Minion = !0, e.Modern = !0, e["Mona Lisa"] = !0, e["Mrs Eaves"] = !0, e["MS Serif"] = !0, e["Museo Slab"] = !0, e["New York"] = !0, e["Nimbus Roman"] = !0, e["NPS Rawlinson Roadway"] = !0, e.NuptialScript = !0, e.Palatino = !0, e.Perpetua = !0, e.Plantin = !0, e["Plantin Schoolbook"] = !0, e.Playbill = !0, e["Poor Richard"] = !0, e["Rawlinson Roadway"] = !0, e.Renault = !0, e.Requiem = !0, e.Rockwell = !0, e.Roman = !0, e["Rotis Serif"] = !0, e.Sabon = !0, e.Scala = !0, e.Seagull = !0, e.Sistina = !0, e.Souvenir = !0, e.STIX = !0, e["Stone Informal"] = !0, e["Stone Serif"] = !0, e.Sylfaen = !0, e.Times = !0, e.Trajan = !0, e["Trinité"] = !0, e["Trump Mediaeval"] = !0, e.Utopia = !0, e["Vale Type"] = !0, e["Bitstream Vera"] = !0, e["Vera Serif"] = !0, e.Versailles = !0, e.Wanted = !0, e.Weiss = !0, e["Wide Latin"] = !0, e.Windsor = !0, e.XITS = !0;
            }),
            l = i(function (e) {
              e.Dingbats = !0, e.Symbol = !0, e.ZapfDingbats = !0;
            }),
            c = i(function (e) {
              e[2] = 10, e[3] = 32, e[4] = 33, e[5] = 34, e[6] = 35, e[7] = 36, e[8] = 37, e[9] = 38, e[10] = 39, e[11] = 40, e[12] = 41, e[13] = 42, e[14] = 43, e[15] = 44, e[16] = 45, e[17] = 46, e[18] = 47, e[19] = 48, e[20] = 49, e[21] = 50, e[22] = 51, e[23] = 52, e[24] = 53, e[25] = 54, e[26] = 55, e[27] = 56, e[28] = 57, e[29] = 58, e[30] = 894, e[31] = 60, e[32] = 61, e[33] = 62, e[34] = 63, e[35] = 64, e[36] = 65, e[37] = 66, e[38] = 67, e[39] = 68, e[40] = 69, e[41] = 70, e[42] = 71, e[43] = 72, e[44] = 73, e[45] = 74, e[46] = 75, e[47] = 76, e[48] = 77, e[49] = 78, e[50] = 79, e[51] = 80, e[52] = 81, e[53] = 82, e[54] = 83, e[55] = 84, e[56] = 85, e[57] = 86, e[58] = 87, e[59] = 88, e[60] = 89, e[61] = 90, e[62] = 91, e[63] = 92, e[64] = 93, e[65] = 94, e[66] = 95, e[67] = 96, e[68] = 97, e[69] = 98, e[70] = 99, e[71] = 100, e[72] = 101, e[73] = 102, e[74] = 103, e[75] = 104, e[76] = 105, e[77] = 106, e[78] = 107, e[79] = 108, e[80] = 109, e[81] = 110, e[82] = 111, e[83] = 112, e[84] = 113, e[85] = 114, e[86] = 115, e[87] = 116, e[88] = 117, e[89] = 118, e[90] = 119, e[91] = 120, e[92] = 121, e[93] = 122, e[94] = 123, e[95] = 124, e[96] = 125, e[97] = 126, e[98] = 196, e[99] = 197, e[100] = 199, e[101] = 201, e[102] = 209, e[103] = 214, e[104] = 220, e[105] = 225, e[106] = 224, e[107] = 226, e[108] = 228, e[109] = 227, e[110] = 229, e[111] = 231, e[112] = 233, e[113] = 232, e[114] = 234, e[115] = 235, e[116] = 237, e[117] = 236, e[118] = 238, e[119] = 239, e[120] = 241, e[121] = 243, e[122] = 242, e[123] = 244, e[124] = 246, e[125] = 245, e[126] = 250, e[127] = 249, e[128] = 251, e[129] = 252, e[130] = 8224, e[131] = 176, e[132] = 162, e[133] = 163, e[134] = 167, e[135] = 8226, e[136] = 182, e[137] = 223, e[138] = 174, e[139] = 169, e[140] = 8482, e[141] = 180, e[142] = 168, e[143] = 8800, e[144] = 198, e[145] = 216, e[146] = 8734, e[147] = 177, e[148] = 8804, e[149] = 8805, e[150] = 165, e[151] = 181, e[152] = 8706, e[153] = 8721, e[154] = 8719, e[156] = 8747, e[157] = 170, e[158] = 186, e[159] = 8486, e[160] = 230, e[161] = 248, e[162] = 191, e[163] = 161, e[164] = 172, e[165] = 8730, e[166] = 402, e[167] = 8776, e[168] = 8710, e[169] = 171, e[170] = 187, e[171] = 8230, e[210] = 218, e[223] = 711, e[224] = 321, e[225] = 322, e[227] = 353, e[229] = 382, e[234] = 253, e[252] = 263, e[253] = 268, e[254] = 269, e[258] = 258, e[260] = 260, e[261] = 261, e[265] = 280, e[266] = 281, e[268] = 283, e[269] = 313, e[275] = 323, e[276] = 324, e[278] = 328, e[284] = 345, e[285] = 346, e[286] = 347, e[292] = 367, e[295] = 377, e[296] = 378, e[298] = 380, e[305] = 963, e[306] = 964, e[307] = 966, e[308] = 8215;
              e[309] = 8252, e[310] = 8319, e[311] = 8359, e[312] = 8592, e[313] = 8593, e[337] = 9552, e[493] = 1039, e[494] = 1040, e[705] = 1524, e[706] = 8362, e[710] = 64288, e[711] = 64298, e[759] = 1617, e[761] = 1776, e[763] = 1778, e[775] = 1652, e[777] = 1764, e[778] = 1780, e[779] = 1781, e[780] = 1782, e[782] = 771, e[783] = 64726, e[786] = 8363, e[788] = 8532, e[790] = 768, e[791] = 769, e[792] = 768, e[795] = 803, e[797] = 64336, e[798] = 64337, e[799] = 64342, e[800] = 64343, e[801] = 64344, e[802] = 64345, e[803] = 64362, e[804] = 64363, e[805] = 64364, e[2424] = 7821, e[2425] = 7822, e[2426] = 7823, e[2427] = 7824, e[2428] = 7825, e[2429] = 7826, e[2430] = 7827, e[2433] = 7682, e[2678] = 8045, e[2679] = 8046, e[2830] = 1552, e[2838] = 686, e[2840] = 751, e[2842] = 753, e[2843] = 754, e[2844] = 755, e[2846] = 757, e[2856] = 767, e[2857] = 848, e[2858] = 849, e[2862] = 853, e[2863] = 854, e[2864] = 855, e[2865] = 861, e[2866] = 862, e[2906] = 7460, e[2908] = 7462, e[2909] = 7463, e[2910] = 7464, e[2912] = 7466, e[2913] = 7467, e[2914] = 7468, e[2916] = 7470, e[2917] = 7471, e[2918] = 7472, e[2920] = 7474, e[2921] = 7475, e[2922] = 7476, e[2924] = 7478, e[2925] = 7479, e[2926] = 7480, e[2928] = 7482, e[2929] = 7483, e[2930] = 7484, e[2932] = 7486, e[2933] = 7487, e[2934] = 7488, e[2936] = 7490, e[2937] = 7491, e[2938] = 7492, e[2940] = 7494, e[2941] = 7495, e[2942] = 7496, e[2944] = 7498, e[2946] = 7500, e[2948] = 7502, e[2950] = 7504, e[2951] = 7505, e[2952] = 7506, e[2954] = 7508, e[2955] = 7509, e[2956] = 7510, e[2958] = 7512, e[2959] = 7513, e[2960] = 7514, e[2962] = 7516, e[2963] = 7517, e[2964] = 7518, e[2966] = 7520, e[2967] = 7521, e[2968] = 7522, e[2970] = 7524, e[2971] = 7525, e[2972] = 7526, e[2974] = 7528, e[2975] = 7529, e[2976] = 7530, e[2978] = 1537, e[2979] = 1538, e[2980] = 1539, e[2982] = 1549, e[2983] = 1551, e[2984] = 1552, e[2986] = 1554, e[2987] = 1555, e[2988] = 1556, e[2990] = 1623, e[2991] = 1624, e[2995] = 1775, e[2999] = 1791, e[3002] = 64290, e[3003] = 64291, e[3004] = 64292, e[3006] = 64294, e[3007] = 64295, e[3008] = 64296, e[3011] = 1900, e[3014] = 8223, e[3015] = 8244, e[3017] = 7532, e[3018] = 7533, e[3019] = 7534, e[3075] = 7590, e[3076] = 7591, e[3079] = 7594, e[3080] = 7595, e[3083] = 7598, e[3084] = 7599, e[3087] = 7602, e[3088] = 7603, e[3091] = 7606, e[3092] = 7607, e[3095] = 7610, e[3096] = 7611, e[3099] = 7614, e[3100] = 7615, e[3103] = 7618, e[3104] = 7619, e[3107] = 8337, e[3108] = 8338, e[3116] = 1884, e[3119] = 1885, e[3120] = 1885, e[3123] = 1886, e[3124] = 1886, e[3127] = 1887, e[3128] = 1887, e[3131] = 1888, e[3132] = 1888, e[3135] = 1889, e[3136] = 1889, e[3139] = 1890, e[3140] = 1890, e[3143] = 1891, e[3144] = 1891, e[3147] = 1892, e[3148] = 1892, e[3153] = 580, e[3154] = 581, e[3157] = 584, e[3158] = 585, e[3161] = 588, e[3162] = 589, e[3165] = 891, e[3166] = 892, e[3169] = 1274, e[3170] = 1275, e[3173] = 1278, e[3174] = 1279, e[3181] = 7622, e[3182] = 7623, e[3282] = 11799, e[3316] = 578, e[3379] = 42785, e[3393] = 1159, e[3416] = 8377;
            }),
            u = i(function (e) {
              e[227] = 322, e[264] = 261, e[291] = 346;
            });
          t.getStdFontMap = a, t.getNonStdFontMap = o, t.getSerifFonts = s, t.getSymbolsFonts = l, t.getGlyphMapForStandardFonts = c, t.getSupplementalGlyphMapForArialBlack = u;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            return e >= 65520 && e <= 65535 ? 0 : e >= 62976 && e <= 63743 ? u()[e] || e : e;
          }
          function i(e, t) {
            var r = t[e];
            if (void 0 !== r) return r;
            if (!e) return -1;
            if ("u" === e[0]) {
              var n,
                i = e.length;
              if (7 === i && "n" === e[1] && "i" === e[2]) n = e.substr(3);else {
                if (!(i >= 5 && i <= 7)) return -1;
                n = e.substr(1);
              }
              if (n === n.toUpperCase() && (r = parseInt(n, 16)) >= 0) return r;
            }
            return -1;
          }
          function a(e) {
            for (var t = 0, r = h.length; t < r; t++) {
              var n = h[t];
              if (e >= n.begin && e < n.end) return t;
            }
            return -1;
          }
          function o(e) {
            var t = h[13];
            return e >= t.begin && e < t.end || (t = h[11], e >= t.begin && e < t.end);
          }
          function s(e) {
            var t = e.length;
            if (t <= 1 || !o(e.charCodeAt(0))) return e;
            for (var r = "", n = t - 1; n >= 0; n--) r += e[n];
            return r;
          }
          var l = r(0),
            c = l.getLookupTableFactory,
            u = c(function (e) {
              e[63721] = 169, e[63193] = 169, e[63720] = 174, e[63194] = 174, e[63722] = 8482, e[63195] = 8482, e[63729] = 9127, e[63730] = 9128, e[63731] = 9129, e[63740] = 9131, e[63741] = 9132, e[63742] = 9133, e[63726] = 9121, e[63727] = 9122, e[63728] = 9123, e[63737] = 9124, e[63738] = 9125, e[63739] = 9126, e[63723] = 9115, e[63724] = 9116, e[63725] = 9117, e[63734] = 9118, e[63735] = 9119, e[63736] = 9120;
            }),
            h = [{
              begin: 0,
              end: 127
            }, {
              begin: 128,
              end: 255
            }, {
              begin: 256,
              end: 383
            }, {
              begin: 384,
              end: 591
            }, {
              begin: 592,
              end: 687
            }, {
              begin: 688,
              end: 767
            }, {
              begin: 768,
              end: 879
            }, {
              begin: 880,
              end: 1023
            }, {
              begin: 11392,
              end: 11519
            }, {
              begin: 1024,
              end: 1279
            }, {
              begin: 1328,
              end: 1423
            }, {
              begin: 1424,
              end: 1535
            }, {
              begin: 42240,
              end: 42559
            }, {
              begin: 1536,
              end: 1791
            }, {
              begin: 1984,
              end: 2047
            }, {
              begin: 2304,
              end: 2431
            }, {
              begin: 2432,
              end: 2559
            }, {
              begin: 2560,
              end: 2687
            }, {
              begin: 2688,
              end: 2815
            }, {
              begin: 2816,
              end: 2943
            }, {
              begin: 2944,
              end: 3071
            }, {
              begin: 3072,
              end: 3199
            }, {
              begin: 3200,
              end: 3327
            }, {
              begin: 3328,
              end: 3455
            }, {
              begin: 3584,
              end: 3711
            }, {
              begin: 3712,
              end: 3839
            }, {
              begin: 4256,
              end: 4351
            }, {
              begin: 6912,
              end: 7039
            }, {
              begin: 4352,
              end: 4607
            }, {
              begin: 7680,
              end: 7935
            }, {
              begin: 7936,
              end: 8191
            }, {
              begin: 8192,
              end: 8303
            }, {
              begin: 8304,
              end: 8351
            }, {
              begin: 8352,
              end: 8399
            }, {
              begin: 8400,
              end: 8447
            }, {
              begin: 8448,
              end: 8527
            }, {
              begin: 8528,
              end: 8591
            }, {
              begin: 8592,
              end: 8703
            }, {
              begin: 8704,
              end: 8959
            }, {
              begin: 8960,
              end: 9215
            }, {
              begin: 9216,
              end: 9279
            }, {
              begin: 9280,
              end: 9311
            }, {
              begin: 9312,
              end: 9471
            }, {
              begin: 9472,
              end: 9599
            }, {
              begin: 9600,
              end: 9631
            }, {
              begin: 9632,
              end: 9727
            }, {
              begin: 9728,
              end: 9983
            }, {
              begin: 9984,
              end: 10175
            }, {
              begin: 12288,
              end: 12351
            }, {
              begin: 12352,
              end: 12447
            }, {
              begin: 12448,
              end: 12543
            }, {
              begin: 12544,
              end: 12591
            }, {
              begin: 12592,
              end: 12687
            }, {
              begin: 43072,
              end: 43135
            }, {
              begin: 12800,
              end: 13055
            }, {
              begin: 13056,
              end: 13311
            }, {
              begin: 44032,
              end: 55215
            }, {
              begin: 55296,
              end: 57343
            }, {
              begin: 67840,
              end: 67871
            }, {
              begin: 19968,
              end: 40959
            }, {
              begin: 57344,
              end: 63743
            }, {
              begin: 12736,
              end: 12783
            }, {
              begin: 64256,
              end: 64335
            }, {
              begin: 64336,
              end: 65023
            }, {
              begin: 65056,
              end: 65071
            }, {
              begin: 65040,
              end: 65055
            }, {
              begin: 65104,
              end: 65135
            }, {
              begin: 65136,
              end: 65279
            }, {
              begin: 65280,
              end: 65519
            }, {
              begin: 65520,
              end: 65535
            }, {
              begin: 3840,
              end: 4095
            }, {
              begin: 1792,
              end: 1871
            }, {
              begin: 1920,
              end: 1983
            }, {
              begin: 3456,
              end: 3583
            }, {
              begin: 4096,
              end: 4255
            }, {
              begin: 4608,
              end: 4991
            }, {
              begin: 5024,
              end: 5119
            }, {
              begin: 5120,
              end: 5759
            }, {
              begin: 5760,
              end: 5791
            }, {
              begin: 5792,
              end: 5887
            }, {
              begin: 6016,
              end: 6143
            }, {
              begin: 6144,
              end: 6319
            }, {
              begin: 10240,
              end: 10495
            }, {
              begin: 40960,
              end: 42127
            }, {
              begin: 5888,
              end: 5919
            }, {
              begin: 66304,
              end: 66351
            }, {
              begin: 66352,
              end: 66383
            }, {
              begin: 66560,
              end: 66639
            }, {
              begin: 118784,
              end: 119039
            }, {
              begin: 119808,
              end: 120831
            }, {
              begin: 1044480,
              end: 1048573
            }, {
              begin: 65024,
              end: 65039
            }, {
              begin: 917504,
              end: 917631
            }, {
              begin: 6400,
              end: 6479
            }, {
              begin: 6480,
              end: 6527
            }, {
              begin: 6528,
              end: 6623
            }, {
              begin: 6656,
              end: 6687
            }, {
              begin: 11264,
              end: 11359
            }, {
              begin: 11568,
              end: 11647
            }, {
              begin: 19904,
              end: 19967
            }, {
              begin: 43008,
              end: 43055
            }, {
              begin: 65536,
              end: 65663
            }, {
              begin: 65856,
              end: 65935
            }, {
              begin: 66432,
              end: 66463
            }, {
              begin: 66464,
              end: 66527
            }, {
              begin: 66640,
              end: 66687
            }, {
              begin: 66688,
              end: 66735
            }, {
              begin: 67584,
              end: 67647
            }, {
              begin: 68096,
              end: 68191
            }, {
              begin: 119552,
              end: 119647
            }, {
              begin: 73728,
              end: 74751
            }, {
              begin: 119648,
              end: 119679
            }, {
              begin: 7040,
              end: 7103
            }, {
              begin: 7168,
              end: 7247
            }, {
              begin: 7248,
              end: 7295
            }, {
              begin: 43136,
              end: 43231
            }, {
              begin: 43264,
              end: 43311
            }, {
              begin: 43312,
              end: 43359
            }, {
              begin: 43520,
              end: 43615
            }, {
              begin: 65936,
              end: 65999
            }, {
              begin: 66e3,
              end: 66047
            }, {
              begin: 66208,
              end: 66271
            }, {
              begin: 127024,
              end: 127135
            }],
            f = c(function (e) {
              e["¨"] = " ̈", e["¯"] = " ̄", e["´"] = " ́", e["µ"] = "μ", e["¸"] = " ̧", e["Ĳ"] = "IJ", e["ĳ"] = "ij", e["Ŀ"] = "L·", e["ŀ"] = "l·", e["ŉ"] = "ʼn", e["ſ"] = "s", e["Ǆ"] = "DŽ", e["ǅ"] = "Dž", e["ǆ"] = "dž", e["Ǉ"] = "LJ", e["ǈ"] = "Lj", e["ǉ"] = "lj", e["Ǌ"] = "NJ", e["ǋ"] = "Nj", e["ǌ"] = "nj", e["Ǳ"] = "DZ", e["ǲ"] = "Dz", e["ǳ"] = "dz", e["˘"] = " ̆", e["˙"] = " ̇", e["˚"] = " ̊", e["˛"] = " ̨", e["˜"] = " ̃", e["˝"] = " ̋", e["ͺ"] = " ͅ", e["΄"] = " ́", e["ϐ"] = "β", e["ϑ"] = "θ", e["ϒ"] = "Υ", e["ϕ"] = "φ", e["ϖ"] = "π", e["ϰ"] = "κ", e["ϱ"] = "ρ", e["ϲ"] = "ς", e["ϴ"] = "Θ", e["ϵ"] = "ε", e["Ϲ"] = "Σ", e["և"] = "եւ", e["ٵ"] = "اٴ", e["ٶ"] = "وٴ", e["ٷ"] = "ۇٴ", e["ٸ"] = "يٴ", e["ำ"] = "ํา", e["ຳ"] = "ໍາ", e["ໜ"] = "ຫນ", e["ໝ"] = "ຫມ", e["ཷ"] = "ྲཱྀ", e["ཹ"] = "ླཱྀ", e["ẚ"] = "aʾ", e["᾽"] = " ̓", e["᾿"] = " ̓", e["῀"] = " ͂", e["῾"] = " ̔", e[" "] = " ", e[" "] = " ", e[" "] = " ", e[" "] = " ", e[" "] = " ", e[" "] = " ", e[" "] = " ", e[" "] = " ", e["‗"] = " ̳", e["․"] = ".", e["‥"] = "..", e["…"] = "...", e["″"] = "′′", e["‴"] = "′′′", e["‶"] = "‵‵", e["‷"] = "‵‵‵", e["‼"] = "!!", e["‾"] = " ̅", e["⁇"] = "??", e["⁈"] = "?!", e["⁉"] = "!?", e["⁗"] = "′′′′", e[" "] = " ", e["₨"] = "Rs", e["℀"] = "a/c", e["℁"] = "a/s", e["℃"] = "°C", e["℅"] = "c/o", e["℆"] = "c/u", e["ℇ"] = "Ɛ", e["℉"] = "°F", e["№"] = "No", e["℡"] = "TEL", e["ℵ"] = "א", e["ℶ"] = "ב", e["ℷ"] = "ג", e["ℸ"] = "ד", e["℻"] = "FAX", e["Ⅰ"] = "I", e["Ⅱ"] = "II", e["Ⅲ"] = "III", e["Ⅳ"] = "IV", e["Ⅴ"] = "V", e["Ⅵ"] = "VI", e["Ⅶ"] = "VII", e["Ⅷ"] = "VIII", e["Ⅸ"] = "IX", e["Ⅹ"] = "X", e["Ⅺ"] = "XI", e["Ⅻ"] = "XII", e["Ⅼ"] = "L", e["Ⅽ"] = "C", e["Ⅾ"] = "D", e["Ⅿ"] = "M", e["ⅰ"] = "i", e["ⅱ"] = "ii", e["ⅲ"] = "iii", e["ⅳ"] = "iv", e["ⅴ"] = "v", e["ⅵ"] = "vi", e["ⅶ"] = "vii", e["ⅷ"] = "viii", e["ⅸ"] = "ix", e["ⅹ"] = "x", e["ⅺ"] = "xi", e["ⅻ"] = "xii", e["ⅼ"] = "l", e["ⅽ"] = "c", e["ⅾ"] = "d", e["ⅿ"] = "m", e["∬"] = "∫∫", e["∭"] = "∫∫∫", e["∯"] = "∮∮", e["∰"] = "∮∮∮", e["⑴"] = "(1)", e["⑵"] = "(2)", e["⑶"] = "(3)", e["⑷"] = "(4)", e["⑸"] = "(5)", e["⑹"] = "(6)", e["⑺"] = "(7)", e["⑻"] = "(8)", e["⑼"] = "(9)", e["⑽"] = "(10)", e["⑾"] = "(11)", e["⑿"] = "(12)", e["⒀"] = "(13)", e["⒁"] = "(14)", e["⒂"] = "(15)", e["⒃"] = "(16)", e["⒄"] = "(17)", e["⒅"] = "(18)", e["⒆"] = "(19)", e["⒇"] = "(20)", e["⒈"] = "1.", e["⒉"] = "2.", e["⒊"] = "3.", e["⒋"] = "4.", e["⒌"] = "5.", e["⒍"] = "6.", e["⒎"] = "7.", e["⒏"] = "8.", e["⒐"] = "9.", e["⒑"] = "10.", e["⒒"] = "11.", e["⒓"] = "12.", e["⒔"] = "13.", e["⒕"] = "14.", e["⒖"] = "15.", e["⒗"] = "16.", e["⒘"] = "17.", e["⒙"] = "18.", e["⒚"] = "19.", e["⒛"] = "20.", e["⒜"] = "(a)", e["⒝"] = "(b)", e["⒞"] = "(c)", e["⒟"] = "(d)", e["⒠"] = "(e)", e["⒡"] = "(f)", e["⒢"] = "(g)", e["⒣"] = "(h)", e["⒤"] = "(i)", e["⒥"] = "(j)", e["⒦"] = "(k)", e["⒧"] = "(l)", e["⒨"] = "(m)", e["⒩"] = "(n)", e["⒪"] = "(o)", e["⒫"] = "(p)", e["⒬"] = "(q)", e["⒭"] = "(r)", e["⒮"] = "(s)", e["⒯"] = "(t)", e["⒰"] = "(u)", e["⒱"] = "(v)", e["⒲"] = "(w)", e["⒳"] = "(x)", e["⒴"] = "(y)", e["⒵"] = "(z)", e["⨌"] = "∫∫∫∫", e["⩴"] = "::=";
              e["⩵"] = "==", e["⩶"] = "===", e["⺟"] = "母", e["⻳"] = "龟", e["⼀"] = "一", e["⼁"] = "丨", e["⼂"] = "丶", e["⼃"] = "丿", e["⼄"] = "乙", e["⼅"] = "亅", e["⼆"] = "二", e["⼇"] = "亠", e["⼈"] = "人", e["⼉"] = "儿", e["⼊"] = "入", e["⼋"] = "八", e["⼌"] = "冂", e["⼍"] = "冖", e["⼎"] = "冫", e["⼏"] = "几", e["⼐"] = "凵", e["⼑"] = "刀", e["⼒"] = "力", e["⼓"] = "勹", e["⼔"] = "匕", e["⼕"] = "匚", e["⼖"] = "匸", e["⼗"] = "十", e["⼘"] = "卜", e["⼙"] = "卩", e["⼚"] = "厂", e["⼛"] = "厶", e["⼜"] = "又", e["⼝"] = "口", e["⼞"] = "囗", e["⼟"] = "土", e["⼠"] = "士", e["⼡"] = "夂", e["⼢"] = "夊", e["⼣"] = "夕", e["⼤"] = "大", e["⼥"] = "女", e["⼦"] = "子", e["⼧"] = "宀", e["⼨"] = "寸", e["⼩"] = "小", e["⼪"] = "尢", e["⼫"] = "尸", e["⼬"] = "屮", e["⼭"] = "山", e["⼮"] = "巛", e["⼯"] = "工", e["⼰"] = "己", e["⼱"] = "巾", e["⼲"] = "干", e["⼳"] = "幺", e["⼴"] = "广", e["⼵"] = "廴", e["⼶"] = "廾", e["⼷"] = "弋", e["⼸"] = "弓", e["⼹"] = "彐", e["⼺"] = "彡", e["⼻"] = "彳", e["⼼"] = "心", e["⼽"] = "戈", e["⼾"] = "戶", e["⼿"] = "手", e["⽀"] = "支", e["⽁"] = "攴", e["⽂"] = "文", e["⽃"] = "斗", e["⽄"] = "斤", e["⽅"] = "方", e["⽆"] = "无", e["⽇"] = "日", e["⽈"] = "曰", e["⽉"] = "月", e["⽊"] = "木", e["⽋"] = "欠", e["⽌"] = "止", e["⽍"] = "歹", e["⽎"] = "殳", e["⽏"] = "毋", e["⽐"] = "比", e["⽑"] = "毛", e["⽒"] = "氏", e["⽓"] = "气", e["⽔"] = "水", e["⽕"] = "火", e["⽖"] = "爪", e["⽗"] = "父", e["⽘"] = "爻", e["⽙"] = "爿", e["⽚"] = "片", e["⽛"] = "牙", e["⽜"] = "牛", e["⽝"] = "犬", e["⽞"] = "玄", e["⽟"] = "玉", e["⽠"] = "瓜", e["⽡"] = "瓦", e["⽢"] = "甘", e["⽣"] = "生", e["⽤"] = "用", e["⽥"] = "田", e["⽦"] = "疋", e["⽧"] = "疒", e["⽨"] = "癶", e["⽩"] = "白", e["⽪"] = "皮", e["⽫"] = "皿", e["⽬"] = "目", e["⽭"] = "矛", e["⽮"] = "矢", e["⽯"] = "石", e["⽰"] = "示", e["⽱"] = "禸", e["⽲"] = "禾", e["⽳"] = "穴", e["⽴"] = "立", e["⽵"] = "竹", e["⽶"] = "米", e["⽷"] = "糸", e["⽸"] = "缶", e["⽹"] = "网", e["⽺"] = "羊", e["⽻"] = "羽", e["⽼"] = "老", e["⽽"] = "而", e["⽾"] = "耒", e["⽿"] = "耳", e["⾀"] = "聿", e["⾁"] = "肉", e["⾂"] = "臣", e["⾃"] = "自", e["⾄"] = "至", e["⾅"] = "臼", e["⾆"] = "舌", e["⾇"] = "舛", e["⾈"] = "舟", e["⾉"] = "艮", e["⾊"] = "色", e["⾋"] = "艸", e["⾌"] = "虍", e["⾍"] = "虫", e["⾎"] = "血", e["⾏"] = "行", e["⾐"] = "衣", e["⾑"] = "襾", e["⾒"] = "見", e["⾓"] = "角", e["⾔"] = "言", e["⾕"] = "谷", e["⾖"] = "豆", e["⾗"] = "豕", e["⾘"] = "豸", e["⾙"] = "貝", e["⾚"] = "赤", e["⾛"] = "走", e["⾜"] = "足", e["⾝"] = "身", e["⾞"] = "車", e["⾟"] = "辛", e["⾠"] = "辰", e["⾡"] = "辵", e["⾢"] = "邑", e["⾣"] = "酉", e["⾤"] = "釆", e["⾥"] = "里", e["⾦"] = "金", e["⾧"] = "長", e["⾨"] = "門", e["⾩"] = "阜", e["⾪"] = "隶", e["⾫"] = "隹", e["⾬"] = "雨", e["⾭"] = "靑", e["⾮"] = "非", e["⾯"] = "面", e["⾰"] = "革", e["⾱"] = "韋", e["⾲"] = "韭", e["⾳"] = "音", e["⾴"] = "頁", e["⾵"] = "風", e["⾶"] = "飛", e["⾷"] = "食", e["⾸"] = "首", e["⾹"] = "香", e["⾺"] = "馬", e["⾻"] = "骨", e["⾼"] = "高", e["⾽"] = "髟", e["⾾"] = "鬥", e["⾿"] = "鬯", e["⿀"] = "鬲", e["⿁"] = "鬼", e["⿂"] = "魚", e["⿃"] = "鳥";
              e["⿄"] = "鹵", e["⿅"] = "鹿", e["⿆"] = "麥", e["⿇"] = "麻", e["⿈"] = "黃", e["⿉"] = "黍", e["⿊"] = "黑", e["⿋"] = "黹", e["⿌"] = "黽", e["⿍"] = "鼎", e["⿎"] = "鼓", e["⿏"] = "鼠", e["⿐"] = "鼻", e["⿑"] = "齊", e["⿒"] = "齒", e["⿓"] = "龍", e["⿔"] = "龜", e["⿕"] = "龠", e["〶"] = "〒", e["〸"] = "十", e["〹"] = "卄", e["〺"] = "卅", e["゛"] = " ゙", e["゜"] = " ゚", e["ㄱ"] = "ᄀ", e["ㄲ"] = "ᄁ", e["ㄳ"] = "ᆪ", e["ㄴ"] = "ᄂ", e["ㄵ"] = "ᆬ", e["ㄶ"] = "ᆭ", e["ㄷ"] = "ᄃ", e["ㄸ"] = "ᄄ", e["ㄹ"] = "ᄅ", e["ㄺ"] = "ᆰ", e["ㄻ"] = "ᆱ", e["ㄼ"] = "ᆲ", e["ㄽ"] = "ᆳ", e["ㄾ"] = "ᆴ", e["ㄿ"] = "ᆵ", e["ㅀ"] = "ᄚ", e["ㅁ"] = "ᄆ", e["ㅂ"] = "ᄇ", e["ㅃ"] = "ᄈ", e["ㅄ"] = "ᄡ", e["ㅅ"] = "ᄉ", e["ㅆ"] = "ᄊ", e["ㅇ"] = "ᄋ", e["ㅈ"] = "ᄌ", e["ㅉ"] = "ᄍ", e["ㅊ"] = "ᄎ", e["ㅋ"] = "ᄏ", e["ㅌ"] = "ᄐ", e["ㅍ"] = "ᄑ", e["ㅎ"] = "ᄒ", e["ㅏ"] = "ᅡ", e["ㅐ"] = "ᅢ", e["ㅑ"] = "ᅣ", e["ㅒ"] = "ᅤ", e["ㅓ"] = "ᅥ", e["ㅔ"] = "ᅦ", e["ㅕ"] = "ᅧ", e["ㅖ"] = "ᅨ", e["ㅗ"] = "ᅩ", e["ㅘ"] = "ᅪ", e["ㅙ"] = "ᅫ", e["ㅚ"] = "ᅬ", e["ㅛ"] = "ᅭ", e["ㅜ"] = "ᅮ", e["ㅝ"] = "ᅯ", e["ㅞ"] = "ᅰ", e["ㅟ"] = "ᅱ", e["ㅠ"] = "ᅲ", e["ㅡ"] = "ᅳ", e["ㅢ"] = "ᅴ", e["ㅣ"] = "ᅵ", e["ㅤ"] = "ᅠ", e["ㅥ"] = "ᄔ", e["ㅦ"] = "ᄕ", e["ㅧ"] = "ᇇ", e["ㅨ"] = "ᇈ", e["ㅩ"] = "ᇌ", e["ㅪ"] = "ᇎ", e["ㅫ"] = "ᇓ", e["ㅬ"] = "ᇗ", e["ㅭ"] = "ᇙ", e["ㅮ"] = "ᄜ", e["ㅯ"] = "ᇝ", e["ㅰ"] = "ᇟ", e["ㅱ"] = "ᄝ", e["ㅲ"] = "ᄞ", e["ㅳ"] = "ᄠ", e["ㅴ"] = "ᄢ", e["ㅵ"] = "ᄣ", e["ㅶ"] = "ᄧ", e["ㅷ"] = "ᄩ", e["ㅸ"] = "ᄫ", e["ㅹ"] = "ᄬ", e["ㅺ"] = "ᄭ", e["ㅻ"] = "ᄮ", e["ㅼ"] = "ᄯ", e["ㅽ"] = "ᄲ", e["ㅾ"] = "ᄶ", e["ㅿ"] = "ᅀ", e["ㆀ"] = "ᅇ", e["ㆁ"] = "ᅌ", e["ㆂ"] = "ᇱ", e["ㆃ"] = "ᇲ", e["ㆄ"] = "ᅗ", e["ㆅ"] = "ᅘ", e["ㆆ"] = "ᅙ", e["ㆇ"] = "ᆄ", e["ㆈ"] = "ᆅ", e["ㆉ"] = "ᆈ", e["ㆊ"] = "ᆑ", e["ㆋ"] = "ᆒ", e["ㆌ"] = "ᆔ", e["ㆍ"] = "ᆞ", e["ㆎ"] = "ᆡ", e["㈀"] = "(ᄀ)", e["㈁"] = "(ᄂ)", e["㈂"] = "(ᄃ)", e["㈃"] = "(ᄅ)", e["㈄"] = "(ᄆ)", e["㈅"] = "(ᄇ)", e["㈆"] = "(ᄉ)", e["㈇"] = "(ᄋ)", e["㈈"] = "(ᄌ)", e["㈉"] = "(ᄎ)", e["㈊"] = "(ᄏ)", e["㈋"] = "(ᄐ)", e["㈌"] = "(ᄑ)", e["㈍"] = "(ᄒ)", e["㈎"] = "(가)", e["㈏"] = "(나)", e["㈐"] = "(다)", e["㈑"] = "(라)", e["㈒"] = "(마)", e["㈓"] = "(바)", e["㈔"] = "(사)", e["㈕"] = "(아)", e["㈖"] = "(자)", e["㈗"] = "(차)", e["㈘"] = "(카)", e["㈙"] = "(타)", e["㈚"] = "(파)", e["㈛"] = "(하)", e["㈜"] = "(주)", e["㈝"] = "(오전)", e["㈞"] = "(오후)", e["㈠"] = "(一)", e["㈡"] = "(二)", e["㈢"] = "(三)", e["㈣"] = "(四)", e["㈤"] = "(五)", e["㈥"] = "(六)", e["㈦"] = "(七)", e["㈧"] = "(八)", e["㈨"] = "(九)", e["㈩"] = "(十)", e["㈪"] = "(月)", e["㈫"] = "(火)", e["㈬"] = "(水)", e["㈭"] = "(木)", e["㈮"] = "(金)", e["㈯"] = "(土)", e["㈰"] = "(日)", e["㈱"] = "(株)", e["㈲"] = "(有)", e["㈳"] = "(社)", e["㈴"] = "(名)", e["㈵"] = "(特)", e["㈶"] = "(財)", e["㈷"] = "(祝)", e["㈸"] = "(労)", e["㈹"] = "(代)", e["㈺"] = "(呼)", e["㈻"] = "(学)", e["㈼"] = "(監)", e["㈽"] = "(企)", e["㈾"] = "(資)", e["㈿"] = "(協)", e["㉀"] = "(祭)", e["㉁"] = "(休)", e["㉂"] = "(自)", e["㉃"] = "(至)", e["㋀"] = "1月", e["㋁"] = "2月", e["㋂"] = "3月", e["㋃"] = "4月", e["㋄"] = "5月", e["㋅"] = "6月", e["㋆"] = "7月", e["㋇"] = "8月", e["㋈"] = "9月", e["㋉"] = "10月", e["㋊"] = "11月", e["㋋"] = "12月", e["㍘"] = "0点", e["㍙"] = "1点", e["㍚"] = "2点";
              e["㍛"] = "3点", e["㍜"] = "4点", e["㍝"] = "5点", e["㍞"] = "6点", e["㍟"] = "7点", e["㍠"] = "8点", e["㍡"] = "9点", e["㍢"] = "10点", e["㍣"] = "11点", e["㍤"] = "12点", e["㍥"] = "13点", e["㍦"] = "14点", e["㍧"] = "15点", e["㍨"] = "16点", e["㍩"] = "17点", e["㍪"] = "18点", e["㍫"] = "19点", e["㍬"] = "20点", e["㍭"] = "21点", e["㍮"] = "22点", e["㍯"] = "23点", e["㍰"] = "24点", e["㏠"] = "1日", e["㏡"] = "2日", e["㏢"] = "3日", e["㏣"] = "4日", e["㏤"] = "5日", e["㏥"] = "6日", e["㏦"] = "7日", e["㏧"] = "8日", e["㏨"] = "9日", e["㏩"] = "10日", e["㏪"] = "11日", e["㏫"] = "12日", e["㏬"] = "13日", e["㏭"] = "14日", e["㏮"] = "15日", e["㏯"] = "16日", e["㏰"] = "17日", e["㏱"] = "18日", e["㏲"] = "19日", e["㏳"] = "20日", e["㏴"] = "21日", e["㏵"] = "22日", e["㏶"] = "23日", e["㏷"] = "24日", e["㏸"] = "25日", e["㏹"] = "26日", e["㏺"] = "27日", e["㏻"] = "28日", e["㏼"] = "29日", e["㏽"] = "30日", e["㏾"] = "31日", e["ﬀ"] = "ff", e["ﬁ"] = "fi", e["ﬂ"] = "fl", e["ﬃ"] = "ffi", e["ﬄ"] = "ffl", e["ﬅ"] = "ſt", e["ﬆ"] = "st", e["ﬓ"] = "մն", e["ﬔ"] = "մե", e["ﬕ"] = "մի", e["ﬖ"] = "վն", e["ﬗ"] = "մխ", e["ﭏ"] = "אל", e["ﭐ"] = "ٱ", e["ﭑ"] = "ٱ", e["ﭒ"] = "ٻ", e["ﭓ"] = "ٻ", e["ﭔ"] = "ٻ", e["ﭕ"] = "ٻ", e["ﭖ"] = "پ", e["ﭗ"] = "پ", e["ﭘ"] = "پ", e["ﭙ"] = "پ", e["ﭚ"] = "ڀ", e["ﭛ"] = "ڀ", e["ﭜ"] = "ڀ", e["ﭝ"] = "ڀ", e["ﭞ"] = "ٺ", e["ﭟ"] = "ٺ", e["ﭠ"] = "ٺ", e["ﭡ"] = "ٺ", e["ﭢ"] = "ٿ", e["ﭣ"] = "ٿ", e["ﭤ"] = "ٿ", e["ﭥ"] = "ٿ", e["ﭦ"] = "ٹ", e["ﭧ"] = "ٹ", e["ﭨ"] = "ٹ", e["ﭩ"] = "ٹ", e["ﭪ"] = "ڤ", e["ﭫ"] = "ڤ", e["ﭬ"] = "ڤ", e["ﭭ"] = "ڤ", e["ﭮ"] = "ڦ", e["ﭯ"] = "ڦ", e["ﭰ"] = "ڦ", e["ﭱ"] = "ڦ", e["ﭲ"] = "ڄ", e["ﭳ"] = "ڄ", e["ﭴ"] = "ڄ", e["ﭵ"] = "ڄ", e["ﭶ"] = "ڃ", e["ﭷ"] = "ڃ", e["ﭸ"] = "ڃ", e["ﭹ"] = "ڃ", e["ﭺ"] = "چ", e["ﭻ"] = "چ", e["ﭼ"] = "چ", e["ﭽ"] = "چ", e["ﭾ"] = "ڇ", e["ﭿ"] = "ڇ", e["ﮀ"] = "ڇ", e["ﮁ"] = "ڇ", e["ﮂ"] = "ڍ", e["ﮃ"] = "ڍ", e["ﮄ"] = "ڌ", e["ﮅ"] = "ڌ", e["ﮆ"] = "ڎ", e["ﮇ"] = "ڎ", e["ﮈ"] = "ڈ", e["ﮉ"] = "ڈ", e["ﮊ"] = "ژ", e["ﮋ"] = "ژ", e["ﮌ"] = "ڑ", e["ﮍ"] = "ڑ", e["ﮎ"] = "ک", e["ﮏ"] = "ک", e["ﮐ"] = "ک", e["ﮑ"] = "ک", e["ﮒ"] = "گ", e["ﮓ"] = "گ", e["ﮔ"] = "گ", e["ﮕ"] = "گ", e["ﮖ"] = "ڳ", e["ﮗ"] = "ڳ", e["ﮘ"] = "ڳ", e["ﮙ"] = "ڳ", e["ﮚ"] = "ڱ", e["ﮛ"] = "ڱ", e["ﮜ"] = "ڱ", e["ﮝ"] = "ڱ", e["ﮞ"] = "ں", e["ﮟ"] = "ں", e["ﮠ"] = "ڻ", e["ﮡ"] = "ڻ", e["ﮢ"] = "ڻ", e["ﮣ"] = "ڻ", e["ﮤ"] = "ۀ", e["ﮥ"] = "ۀ", e["ﮦ"] = "ہ", e["ﮧ"] = "ہ", e["ﮨ"] = "ہ", e["ﮩ"] = "ہ", e["ﮪ"] = "ھ", e["ﮫ"] = "ھ", e["ﮬ"] = "ھ", e["ﮭ"] = "ھ", e["ﮮ"] = "ے", e["ﮯ"] = "ے", e["ﮰ"] = "ۓ", e["ﮱ"] = "ۓ", e["ﯓ"] = "ڭ", e["ﯔ"] = "ڭ", e["ﯕ"] = "ڭ", e["ﯖ"] = "ڭ", e["ﯗ"] = "ۇ", e["ﯘ"] = "ۇ", e["ﯙ"] = "ۆ", e["ﯚ"] = "ۆ", e["ﯛ"] = "ۈ", e["ﯜ"] = "ۈ", e["ﯝ"] = "ٷ", e["ﯞ"] = "ۋ", e["ﯟ"] = "ۋ", e["ﯠ"] = "ۅ", e["ﯡ"] = "ۅ", e["ﯢ"] = "ۉ", e["ﯣ"] = "ۉ", e["ﯤ"] = "ې", e["ﯥ"] = "ې", e["ﯦ"] = "ې", e["ﯧ"] = "ې", e["ﯨ"] = "ى", e["ﯩ"] = "ى", e["ﯪ"] = "ئا", e["ﯫ"] = "ئا", e["ﯬ"] = "ئە", e["ﯭ"] = "ئە", e["ﯮ"] = "ئو", e["ﯯ"] = "ئو", e["ﯰ"] = "ئۇ", e["ﯱ"] = "ئۇ", e["ﯲ"] = "ئۆ", e["ﯳ"] = "ئۆ", e["ﯴ"] = "ئۈ", e["ﯵ"] = "ئۈ", e["ﯶ"] = "ئې";
              e["ﯷ"] = "ئې", e["ﯸ"] = "ئې", e["ﯹ"] = "ئى", e["ﯺ"] = "ئى", e["ﯻ"] = "ئى", e["ﯼ"] = "ی", e["ﯽ"] = "ی", e["ﯾ"] = "ی", e["ﯿ"] = "ی", e["ﰀ"] = "ئج", e["ﰁ"] = "ئح", e["ﰂ"] = "ئم", e["ﰃ"] = "ئى", e["ﰄ"] = "ئي", e["ﰅ"] = "بج", e["ﰆ"] = "بح", e["ﰇ"] = "بخ", e["ﰈ"] = "بم", e["ﰉ"] = "بى", e["ﰊ"] = "بي", e["ﰋ"] = "تج", e["ﰌ"] = "تح", e["ﰍ"] = "تخ", e["ﰎ"] = "تم", e["ﰏ"] = "تى", e["ﰐ"] = "تي", e["ﰑ"] = "ثج", e["ﰒ"] = "ثم", e["ﰓ"] = "ثى", e["ﰔ"] = "ثي", e["ﰕ"] = "جح", e["ﰖ"] = "جم", e["ﰗ"] = "حج", e["ﰘ"] = "حم", e["ﰙ"] = "خج", e["ﰚ"] = "خح", e["ﰛ"] = "خم", e["ﰜ"] = "سج", e["ﰝ"] = "سح", e["ﰞ"] = "سخ", e["ﰟ"] = "سم", e["ﰠ"] = "صح", e["ﰡ"] = "صم", e["ﰢ"] = "ضج", e["ﰣ"] = "ضح", e["ﰤ"] = "ضخ", e["ﰥ"] = "ضم", e["ﰦ"] = "طح", e["ﰧ"] = "طم", e["ﰨ"] = "ظم", e["ﰩ"] = "عج", e["ﰪ"] = "عم", e["ﰫ"] = "غج", e["ﰬ"] = "غم", e["ﰭ"] = "فج", e["ﰮ"] = "فح", e["ﰯ"] = "فخ", e["ﰰ"] = "فم", e["ﰱ"] = "فى", e["ﰲ"] = "في", e["ﰳ"] = "قح", e["ﰴ"] = "قم", e["ﰵ"] = "قى", e["ﰶ"] = "قي", e["ﰷ"] = "كا", e["ﰸ"] = "كج", e["ﰹ"] = "كح", e["ﰺ"] = "كخ", e["ﰻ"] = "كل", e["ﰼ"] = "كم", e["ﰽ"] = "كى", e["ﰾ"] = "كي", e["ﰿ"] = "لج", e["ﱀ"] = "لح", e["ﱁ"] = "لخ", e["ﱂ"] = "لم", e["ﱃ"] = "لى", e["ﱄ"] = "لي", e["ﱅ"] = "مج", e["ﱆ"] = "مح", e["ﱇ"] = "مخ", e["ﱈ"] = "مم", e["ﱉ"] = "مى", e["ﱊ"] = "مي", e["ﱋ"] = "نج", e["ﱌ"] = "نح", e["ﱍ"] = "نخ", e["ﱎ"] = "نم", e["ﱏ"] = "نى", e["ﱐ"] = "ني", e["ﱑ"] = "هج", e["ﱒ"] = "هم", e["ﱓ"] = "هى", e["ﱔ"] = "هي", e["ﱕ"] = "يج", e["ﱖ"] = "يح", e["ﱗ"] = "يخ", e["ﱘ"] = "يم", e["ﱙ"] = "يى", e["ﱚ"] = "يي", e["ﱛ"] = "ذٰ", e["ﱜ"] = "رٰ", e["ﱝ"] = "ىٰ", e["ﱞ"] = " ٌّ", e["ﱟ"] = " ٍّ", e["ﱠ"] = " َّ", e["ﱡ"] = " ُّ", e["ﱢ"] = " ِّ", e["ﱣ"] = " ّٰ", e["ﱤ"] = "ئر", e["ﱥ"] = "ئز", e["ﱦ"] = "ئم", e["ﱧ"] = "ئن", e["ﱨ"] = "ئى", e["ﱩ"] = "ئي", e["ﱪ"] = "بر", e["ﱫ"] = "بز", e["ﱬ"] = "بم", e["ﱭ"] = "بن", e["ﱮ"] = "بى", e["ﱯ"] = "بي", e["ﱰ"] = "تر", e["ﱱ"] = "تز", e["ﱲ"] = "تم", e["ﱳ"] = "تن", e["ﱴ"] = "تى", e["ﱵ"] = "تي", e["ﱶ"] = "ثر", e["ﱷ"] = "ثز", e["ﱸ"] = "ثم", e["ﱹ"] = "ثن", e["ﱺ"] = "ثى", e["ﱻ"] = "ثي", e["ﱼ"] = "فى", e["ﱽ"] = "في", e["ﱾ"] = "قى", e["ﱿ"] = "قي", e["ﲀ"] = "كا", e["ﲁ"] = "كل", e["ﲂ"] = "كم", e["ﲃ"] = "كى", e["ﲄ"] = "كي", e["ﲅ"] = "لم", e["ﲆ"] = "لى", e["ﲇ"] = "لي", e["ﲈ"] = "ما", e["ﲉ"] = "مم", e["ﲊ"] = "نر", e["ﲋ"] = "نز", e["ﲌ"] = "نم", e["ﲍ"] = "نن", e["ﲎ"] = "نى", e["ﲏ"] = "ني", e["ﲐ"] = "ىٰ", e["ﲑ"] = "ير", e["ﲒ"] = "يز", e["ﲓ"] = "يم", e["ﲔ"] = "ين", e["ﲕ"] = "يى", e["ﲖ"] = "يي", e["ﲗ"] = "ئج", e["ﲘ"] = "ئح", e["ﲙ"] = "ئخ", e["ﲚ"] = "ئم", e["ﲛ"] = "ئه", e["ﲜ"] = "بج", e["ﲝ"] = "بح", e["ﲞ"] = "بخ", e["ﲟ"] = "بم", e["ﲠ"] = "به", e["ﲡ"] = "تج", e["ﲢ"] = "تح", e["ﲣ"] = "تخ", e["ﲤ"] = "تم", e["ﲥ"] = "ته", e["ﲦ"] = "ثم", e["ﲧ"] = "جح", e["ﲨ"] = "جم", e["ﲩ"] = "حج", e["ﲪ"] = "حم", e["ﲫ"] = "خج", e["ﲬ"] = "خم", e["ﲭ"] = "سج", e["ﲮ"] = "سح", e["ﲯ"] = "سخ", e["ﲰ"] = "سم", e["ﲱ"] = "صح", e["ﲲ"] = "صخ", e["ﲳ"] = "صم", e["ﲴ"] = "ضج", e["ﲵ"] = "ضح", e["ﲶ"] = "ضخ", e["ﲷ"] = "ضم", e["ﲸ"] = "طح", e["ﲹ"] = "ظم", e["ﲺ"] = "عج", e["ﲻ"] = "عم", e["ﲼ"] = "غج", e["ﲽ"] = "غم", e["ﲾ"] = "فج";
              e["ﲿ"] = "فح", e["ﳀ"] = "فخ", e["ﳁ"] = "فم", e["ﳂ"] = "قح", e["ﳃ"] = "قم", e["ﳄ"] = "كج", e["ﳅ"] = "كح", e["ﳆ"] = "كخ", e["ﳇ"] = "كل", e["ﳈ"] = "كم", e["ﳉ"] = "لج", e["ﳊ"] = "لح", e["ﳋ"] = "لخ", e["ﳌ"] = "لم", e["ﳍ"] = "له", e["ﳎ"] = "مج", e["ﳏ"] = "مح", e["ﳐ"] = "مخ", e["ﳑ"] = "مم", e["ﳒ"] = "نج", e["ﳓ"] = "نح", e["ﳔ"] = "نخ", e["ﳕ"] = "نم", e["ﳖ"] = "نه", e["ﳗ"] = "هج", e["ﳘ"] = "هم", e["ﳙ"] = "هٰ", e["ﳚ"] = "يج", e["ﳛ"] = "يح", e["ﳜ"] = "يخ", e["ﳝ"] = "يم", e["ﳞ"] = "يه", e["ﳟ"] = "ئم", e["ﳠ"] = "ئه", e["ﳡ"] = "بم", e["ﳢ"] = "به", e["ﳣ"] = "تم", e["ﳤ"] = "ته", e["ﳥ"] = "ثم", e["ﳦ"] = "ثه", e["ﳧ"] = "سم", e["ﳨ"] = "سه", e["ﳩ"] = "شم", e["ﳪ"] = "شه", e["ﳫ"] = "كل", e["ﳬ"] = "كم", e["ﳭ"] = "لم", e["ﳮ"] = "نم", e["ﳯ"] = "نه", e["ﳰ"] = "يم", e["ﳱ"] = "يه", e["ﳲ"] = "ـَّ", e["ﳳ"] = "ـُّ", e["ﳴ"] = "ـِّ", e["ﳵ"] = "طى", e["ﳶ"] = "طي", e["ﳷ"] = "عى", e["ﳸ"] = "عي", e["ﳹ"] = "غى", e["ﳺ"] = "غي", e["ﳻ"] = "سى", e["ﳼ"] = "سي", e["ﳽ"] = "شى", e["ﳾ"] = "شي", e["ﳿ"] = "حى", e["ﴀ"] = "حي", e["ﴁ"] = "جى", e["ﴂ"] = "جي", e["ﴃ"] = "خى", e["ﴄ"] = "خي", e["ﴅ"] = "صى", e["ﴆ"] = "صي", e["ﴇ"] = "ضى", e["ﴈ"] = "ضي", e["ﴉ"] = "شج", e["ﴊ"] = "شح", e["ﴋ"] = "شخ", e["ﴌ"] = "شم", e["ﴍ"] = "شر", e["ﴎ"] = "سر", e["ﴏ"] = "صر", e["ﴐ"] = "ضر", e["ﴑ"] = "طى", e["ﴒ"] = "طي", e["ﴓ"] = "عى", e["ﴔ"] = "عي", e["ﴕ"] = "غى", e["ﴖ"] = "غي", e["ﴗ"] = "سى", e["ﴘ"] = "سي", e["ﴙ"] = "شى", e["ﴚ"] = "شي", e["ﴛ"] = "حى", e["ﴜ"] = "حي", e["ﴝ"] = "جى", e["ﴞ"] = "جي", e["ﴟ"] = "خى", e["ﴠ"] = "خي", e["ﴡ"] = "صى", e["ﴢ"] = "صي", e["ﴣ"] = "ضى", e["ﴤ"] = "ضي", e["ﴥ"] = "شج", e["ﴦ"] = "شح", e["ﴧ"] = "شخ", e["ﴨ"] = "شم", e["ﴩ"] = "شر", e["ﴪ"] = "سر", e["ﴫ"] = "صر", e["ﴬ"] = "ضر", e["ﴭ"] = "شج", e["ﴮ"] = "شح", e["ﴯ"] = "شخ", e["ﴰ"] = "شم", e["ﴱ"] = "سه", e["ﴲ"] = "شه", e["ﴳ"] = "طم", e["ﴴ"] = "سج", e["ﴵ"] = "سح", e["ﴶ"] = "سخ", e["ﴷ"] = "شج", e["ﴸ"] = "شح", e["ﴹ"] = "شخ", e["ﴺ"] = "طم", e["ﴻ"] = "ظم", e["ﴼ"] = "اً", e["ﴽ"] = "اً", e["ﵐ"] = "تجم", e["ﵑ"] = "تحج", e["ﵒ"] = "تحج", e["ﵓ"] = "تحم", e["ﵔ"] = "تخم", e["ﵕ"] = "تمج", e["ﵖ"] = "تمح", e["ﵗ"] = "تمخ", e["ﵘ"] = "جمح", e["ﵙ"] = "جمح", e["ﵚ"] = "حمي", e["ﵛ"] = "حمى", e["ﵜ"] = "سحج", e["ﵝ"] = "سجح", e["ﵞ"] = "سجى", e["ﵟ"] = "سمح", e["ﵠ"] = "سمح", e["ﵡ"] = "سمج", e["ﵢ"] = "سمم", e["ﵣ"] = "سمم", e["ﵤ"] = "صحح", e["ﵥ"] = "صحح", e["ﵦ"] = "صمم", e["ﵧ"] = "شحم", e["ﵨ"] = "شحم", e["ﵩ"] = "شجي", e["ﵪ"] = "شمخ", e["ﵫ"] = "شمخ", e["ﵬ"] = "شمم", e["ﵭ"] = "شمم", e["ﵮ"] = "ضحى", e["ﵯ"] = "ضخم", e["ﵰ"] = "ضخم", e["ﵱ"] = "طمح", e["ﵲ"] = "طمح", e["ﵳ"] = "طمم", e["ﵴ"] = "طمي", e["ﵵ"] = "عجم", e["ﵶ"] = "عمم", e["ﵷ"] = "عمم", e["ﵸ"] = "عمى", e["ﵹ"] = "غمم", e["ﵺ"] = "غمي", e["ﵻ"] = "غمى", e["ﵼ"] = "فخم", e["ﵽ"] = "فخم", e["ﵾ"] = "قمح", e["ﵿ"] = "قمم", e["ﶀ"] = "لحم", e["ﶁ"] = "لحي", e["ﶂ"] = "لحى", e["ﶃ"] = "لجج", e["ﶄ"] = "لجج", e["ﶅ"] = "لخم", e["ﶆ"] = "لخم", e["ﶇ"] = "لمح", e["ﶈ"] = "لمح", e["ﶉ"] = "محج", e["ﶊ"] = "محم", e["ﶋ"] = "محي", e["ﶌ"] = "مجح", e["ﶍ"] = "مجم", e["ﶎ"] = "مخج", e["ﶏ"] = "مخم", e["ﶒ"] = "مجخ", e["ﶓ"] = "همج", e["ﶔ"] = "همم", e["ﶕ"] = "نحم", e["ﶖ"] = "نحى", e["ﶗ"] = "نجم", e["ﶘ"] = "نجم", e["ﶙ"] = "نجى", e["ﶚ"] = "نمي";
              e["ﶛ"] = "نمى", e["ﶜ"] = "يمم", e["ﶝ"] = "يمم", e["ﶞ"] = "بخي", e["ﶟ"] = "تجي", e["ﶠ"] = "تجى", e["ﶡ"] = "تخي", e["ﶢ"] = "تخى", e["ﶣ"] = "تمي", e["ﶤ"] = "تمى", e["ﶥ"] = "جمي", e["ﶦ"] = "جحى", e["ﶧ"] = "جمى", e["ﶨ"] = "سخى", e["ﶩ"] = "صحي", e["ﶪ"] = "شحي", e["ﶫ"] = "ضحي", e["ﶬ"] = "لجي", e["ﶭ"] = "لمي", e["ﶮ"] = "يحي", e["ﶯ"] = "يجي", e["ﶰ"] = "يمي", e["ﶱ"] = "ممي", e["ﶲ"] = "قمي", e["ﶳ"] = "نحي", e["ﶴ"] = "قمح", e["ﶵ"] = "لحم", e["ﶶ"] = "عمي", e["ﶷ"] = "كمي", e["ﶸ"] = "نجح", e["ﶹ"] = "مخي", e["ﶺ"] = "لجم", e["ﶻ"] = "كمم", e["ﶼ"] = "لجم", e["ﶽ"] = "نجح", e["ﶾ"] = "جحي", e["ﶿ"] = "حجي", e["ﷀ"] = "مجي", e["ﷁ"] = "فمي", e["ﷂ"] = "بحي", e["ﷃ"] = "كمم", e["ﷄ"] = "عجم", e["ﷅ"] = "صمم", e["ﷆ"] = "سخي", e["ﷇ"] = "نجي", e["﹉"] = "‾", e["﹊"] = "‾", e["﹋"] = "‾", e["﹌"] = "‾", e["﹍"] = "_", e["﹎"] = "_", e["﹏"] = "_", e["ﺀ"] = "ء", e["ﺁ"] = "آ", e["ﺂ"] = "آ", e["ﺃ"] = "أ", e["ﺄ"] = "أ", e["ﺅ"] = "ؤ", e["ﺆ"] = "ؤ", e["ﺇ"] = "إ", e["ﺈ"] = "إ", e["ﺉ"] = "ئ", e["ﺊ"] = "ئ", e["ﺋ"] = "ئ", e["ﺌ"] = "ئ", e["ﺍ"] = "ا", e["ﺎ"] = "ا", e["ﺏ"] = "ب", e["ﺐ"] = "ب", e["ﺑ"] = "ب", e["ﺒ"] = "ب", e["ﺓ"] = "ة", e["ﺔ"] = "ة", e["ﺕ"] = "ت", e["ﺖ"] = "ت", e["ﺗ"] = "ت", e["ﺘ"] = "ت", e["ﺙ"] = "ث", e["ﺚ"] = "ث", e["ﺛ"] = "ث", e["ﺜ"] = "ث", e["ﺝ"] = "ج", e["ﺞ"] = "ج", e["ﺟ"] = "ج", e["ﺠ"] = "ج", e["ﺡ"] = "ح", e["ﺢ"] = "ح", e["ﺣ"] = "ح", e["ﺤ"] = "ح", e["ﺥ"] = "خ", e["ﺦ"] = "خ", e["ﺧ"] = "خ", e["ﺨ"] = "خ", e["ﺩ"] = "د", e["ﺪ"] = "د", e["ﺫ"] = "ذ", e["ﺬ"] = "ذ", e["ﺭ"] = "ر", e["ﺮ"] = "ر", e["ﺯ"] = "ز", e["ﺰ"] = "ز", e["ﺱ"] = "س", e["ﺲ"] = "س", e["ﺳ"] = "س", e["ﺴ"] = "س", e["ﺵ"] = "ش", e["ﺶ"] = "ش", e["ﺷ"] = "ش", e["ﺸ"] = "ش", e["ﺹ"] = "ص", e["ﺺ"] = "ص", e["ﺻ"] = "ص", e["ﺼ"] = "ص", e["ﺽ"] = "ض", e["ﺾ"] = "ض", e["ﺿ"] = "ض", e["ﻀ"] = "ض", e["ﻁ"] = "ط", e["ﻂ"] = "ط", e["ﻃ"] = "ط", e["ﻄ"] = "ط", e["ﻅ"] = "ظ", e["ﻆ"] = "ظ", e["ﻇ"] = "ظ", e["ﻈ"] = "ظ", e["ﻉ"] = "ع", e["ﻊ"] = "ع", e["ﻋ"] = "ع", e["ﻌ"] = "ع", e["ﻍ"] = "غ", e["ﻎ"] = "غ", e["ﻏ"] = "غ", e["ﻐ"] = "غ", e["ﻑ"] = "ف", e["ﻒ"] = "ف", e["ﻓ"] = "ف", e["ﻔ"] = "ف", e["ﻕ"] = "ق", e["ﻖ"] = "ق", e["ﻗ"] = "ق", e["ﻘ"] = "ق", e["ﻙ"] = "ك", e["ﻚ"] = "ك", e["ﻛ"] = "ك", e["ﻜ"] = "ك", e["ﻝ"] = "ل", e["ﻞ"] = "ل", e["ﻟ"] = "ل", e["ﻠ"] = "ل", e["ﻡ"] = "م", e["ﻢ"] = "م", e["ﻣ"] = "م", e["ﻤ"] = "م", e["ﻥ"] = "ن", e["ﻦ"] = "ن", e["ﻧ"] = "ن", e["ﻨ"] = "ن", e["ﻩ"] = "ه", e["ﻪ"] = "ه", e["ﻫ"] = "ه", e["ﻬ"] = "ه", e["ﻭ"] = "و", e["ﻮ"] = "و", e["ﻯ"] = "ى", e["ﻰ"] = "ى", e["ﻱ"] = "ي", e["ﻲ"] = "ي", e["ﻳ"] = "ي", e["ﻴ"] = "ي", e["ﻵ"] = "لآ", e["ﻶ"] = "لآ", e["ﻷ"] = "لأ", e["ﻸ"] = "لأ", e["ﻹ"] = "لإ", e["ﻺ"] = "لإ", e["ﻻ"] = "لا", e["ﻼ"] = "لا";
            });
          t.mapSpecialUnicodeValues = n, t.reverseIfRtl = s, t.getUnicodeRangeFor = a, t.getNormalizedUnicodes = f, t.getUnicodeForGlyph = i;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            i = e;
          }
          var i,
            a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            o = r(0),
            s = r(1),
            l = r(41),
            c = o.UNSUPPORTED_FEATURES,
            u = o.InvalidPDFException,
            h = o.MessageHandler,
            f = o.MissingPDFException,
            d = o.UnexpectedResponseException,
            p = o.PasswordException,
            m = o.UnknownErrorException,
            g = o.XRefParseException,
            v = o.arrayByteLength,
            b = o.arraysToBytes,
            y = o.assert,
            w = o.createPromiseCapability,
            x = o.info,
            _ = o.warn,
            S = o.setVerbosityLevel,
            C = o.isNodeJS,
            E = s.Ref,
            A = l.LocalPdfManager,
            T = l.NetworkPdfManager,
            k = function () {
              function e(e) {
                this.name = e, this.terminated = !1, this._capability = w();
              }
              return e.prototype = {
                get finished() {
                  return this._capability.promise;
                },
                finish: function finish() {
                  this._capability.resolve();
                },
                terminate: function terminate() {
                  this.terminated = !0;
                },
                ensureNotTerminated: function ensureNotTerminated() {
                  if (this.terminated) throw new Error("Worker task was terminated");
                }
              }, e;
            }(),
            R = function () {
              function e(e, t) {
                this._queuedChunks = [];
                var r = e.initialData;
                r && r.length > 0 && this._queuedChunks.push(r), this._msgHandler = t, this._isRangeSupported = !e.disableRange, this._isStreamingSupported = !e.disableStream, this._contentLength = e.length, this._fullRequestReader = null, this._rangeReaders = [], t.on("OnDataRange", this._onReceiveData.bind(this)), t.on("OnDataProgress", this._onProgress.bind(this));
              }
              function t(e, t) {
                this._stream = e, this._done = !1, this._queuedChunks = t || [], this._requests = [], this._headersReady = Promise.resolve(), e._fullRequestReader = this, this.onProgress = null;
              }
              function r(e, t, r) {
                this._stream = e, this._begin = t, this._end = r, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
              }
              return e.prototype = {
                _onReceiveData: function _onReceiveData(e) {
                  if (void 0 === e.begin) this._fullRequestReader ? this._fullRequestReader._enqueue(e.chunk) : this._queuedChunks.push(e.chunk);else {
                    var t = this._rangeReaders.some(function (t) {
                      return t._begin === e.begin && (t._enqueue(e.chunk), !0);
                    });
                    y(t);
                  }
                },
                _onProgress: function _onProgress(e) {
                  if (this._rangeReaders.length > 0) {
                    var t = this._rangeReaders[0];
                    t.onProgress && t.onProgress({
                      loaded: e.loaded
                    });
                  }
                },
                _removeRangeReader: function _removeRangeReader(e) {
                  var t = this._rangeReaders.indexOf(e);
                  t >= 0 && this._rangeReaders.splice(t, 1);
                },
                getFullReader: function getFullReader() {
                  y(!this._fullRequestReader);
                  var e = this._queuedChunks;
                  return this._queuedChunks = null, new t(this, e);
                },
                getRangeReader: function getRangeReader(e, t) {
                  var n = new r(this, e, t);
                  return this._msgHandler.send("RequestDataRange", {
                    begin: e,
                    end: t
                  }), this._rangeReaders.push(n), n;
                },
                cancelAllRequests: function cancelAllRequests(e) {
                  this._fullRequestReader && this._fullRequestReader.cancel(e), this._rangeReaders.slice(0).forEach(function (t) {
                    t.cancel(e);
                  });
                }
              }, t.prototype = {
                _enqueue: function _enqueue(e) {
                  if (!this._done) {
                    if (this._requests.length > 0) {
                      return void this._requests.shift().resolve({
                        value: e,
                        done: !1
                      });
                    }
                    this._queuedChunks.push(e);
                  }
                },
                get headersReady() {
                  return this._headersReady;
                },
                get isRangeSupported() {
                  return this._stream._isRangeSupported;
                },
                get isStreamingSupported() {
                  return this._stream._isStreamingSupported;
                },
                get contentLength() {
                  return this._stream._contentLength;
                },
                read: function read() {
                  if (this._queuedChunks.length > 0) {
                    var e = this._queuedChunks.shift();
                    return Promise.resolve({
                      value: e,
                      done: !1
                    });
                  }
                  if (this._done) return Promise.resolve({
                    value: void 0,
                    done: !0
                  });
                  var t = w();
                  return this._requests.push(t), t.promise;
                },
                cancel: function cancel(e) {
                  this._done = !0, this._requests.forEach(function (e) {
                    e.resolve({
                      value: void 0,
                      done: !0
                    });
                  }), this._requests = [];
                }
              }, r.prototype = {
                _enqueue: function _enqueue(e) {
                  if (!this._done) {
                    if (0 === this._requests.length) this._queuedChunk = e;else {
                      this._requests.shift().resolve({
                        value: e,
                        done: !1
                      }), this._requests.forEach(function (e) {
                        e.resolve({
                          value: void 0,
                          done: !0
                        });
                      }), this._requests = [];
                    }
                    this._done = !0, this._stream._removeRangeReader(this);
                  }
                },
                get isStreamingSupported() {
                  return !1;
                },
                read: function read() {
                  if (this._queuedChunk) return Promise.resolve({
                    value: this._queuedChunk,
                    done: !1
                  });
                  if (this._done) return Promise.resolve({
                    value: void 0,
                    done: !0
                  });
                  var e = w();
                  return this._requests.push(e), e.promise;
                },
                cancel: function cancel(e) {
                  this._done = !0, this._requests.forEach(function (e) {
                    e.resolve({
                      value: void 0,
                      done: !0
                    });
                  }), this._requests = [], this._stream._removeRangeReader(this);
                }
              }, e;
            }(),
            I = {
              setup: function setup(e, t) {
                var r = !1;
                e.on("test", function (t) {
                  if (!r) {
                    if (r = !0, !(t instanceof Uint8Array)) return void e.send("test", "main", !1);
                    var n = 255 === t[0];
                    e.postMessageTransfers = n;
                    var i = new XMLHttpRequest(),
                      a = "response" in i;
                    try {
                      i.responseType;
                    } catch (e) {
                      a = !1;
                    }
                    if (!a) return void e.send("test", !1);
                    e.send("test", {
                      supportTypedArray: !0,
                      supportTransfers: n
                    });
                  }
                }), e.on("configure", function (e) {
                  S(e.verbosity);
                }), e.on("GetDocRequest", function (e) {
                  return I.createDocumentHandler(e, t);
                });
              },
              createDocumentHandler: function createDocumentHandler(e, t) {
                function r() {
                  if (I) throw new Error("Worker was terminated");
                }
                function n(e) {
                  O.push(e);
                }
                function o(e) {
                  e.finish();
                  var t = O.indexOf(e);
                  O.splice(t, 1);
                }
                function s(e) {
                  var t = w(),
                    r = function r() {
                      var e = C.ensureDoc("numPages"),
                        r = C.ensureDoc("fingerprint"),
                        i = C.ensureXRef("encrypt");
                      Promise.all([e, r, i]).then(function (e) {
                        var r = {
                          numPages: e[0],
                          fingerprint: e[1],
                          encrypted: !!e[2]
                        };
                        t.resolve(r);
                      }, n);
                    },
                    n = function n(e) {
                      t.reject(e);
                    };
                  return C.ensureDoc("checkHeader", []).then(function () {
                    C.ensureDoc("parseStartXRef", []).then(function () {
                      C.ensureDoc("parse", [e]).then(r, n);
                    }, n);
                  }, n), t.promise;
                }
                function l(e, t) {
                  var n,
                    a = w(),
                    o = e.source;
                  if (o.data) {
                    try {
                      n = new A(P, o.data, o.password, t, B), a.resolve(n);
                    } catch (e) {
                      a.reject(e);
                    }
                    return a.promise;
                  }
                  var s;
                  try {
                    o.chunkedViewerLoading ? s = new R(o, L) : (y(i, "pdfjs/core/network module is not loaded"), s = new i(e));
                  } catch (e) {
                    return a.reject(e), a.promise;
                  }
                  var l = s.getFullReader();
                  l.headersReady.then(function () {
                    if (l.isStreamingSupported && l.isRangeSupported || (l.onProgress = function (e) {
                      L.send("DocProgress", {
                        loaded: e.loaded,
                        total: e.total
                      });
                    }), l.isRangeSupported) {
                      var e = o.disableAutoFetch || l.isStreamingSupported;
                      n = new T(P, s, {
                        msgHandler: L,
                        url: o.url,
                        password: o.password,
                        length: l.contentLength,
                        disableAutoFetch: e,
                        rangeChunkSize: o.rangeChunkSize
                      }, t, B), a.resolve(n), M = null;
                    }
                  }).catch(function (e) {
                    a.reject(e), M = null;
                  });
                  var c = [],
                    u = 0,
                    h = function h() {
                      var e = b(c);
                      o.length && e.length !== o.length && _("reported HTTP length is different from actual");
                      try {
                        n = new A(P, e, o.password, t, B), a.resolve(n);
                      } catch (e) {
                        a.reject(e);
                      }
                      c = [];
                    };
                  return new Promise(function (e, t) {
                    var i = function e(i) {
                      try {
                        if (r(), i.done) return n || h(), void (M = null);
                        var a = i.value;
                        u += v(a), l.isStreamingSupported || L.send("DocProgress", {
                          loaded: u,
                          total: Math.max(u, l.contentLength || 0)
                        }), n ? n.sendProgressiveData(a) : c.push(a), l.read().then(e, t);
                      } catch (e) {
                        t(e);
                      }
                    };
                    l.read().then(i, t);
                  }).catch(function (e) {
                    a.reject(e), M = null;
                  }), M = function M() {
                    s.cancelAllRequests("abort");
                  }, a.promise;
                }
                function S(e) {
                  function t(e) {
                    r(), L.send("GetDoc", {
                      pdfInfo: e
                    });
                  }
                  function i(e) {
                    if (e instanceof p) {
                      var t = new k("PasswordException: response " + e.code);
                      n(t), L.sendWithPromise("PasswordRequest", e).then(function (e) {
                        o(t), C.updatePassword(e.password), a();
                      }).catch(function (e) {
                        o(t), L.send("PasswordException", e);
                      }.bind(null, e));
                    } else e instanceof u ? L.send("InvalidPDF", e) : e instanceof f ? L.send("MissingPDF", e) : e instanceof d ? L.send("UnexpectedResponse", e) : L.send("UnknownError", new m(e.message, e.toString()));
                  }
                  function a() {
                    r(), s(!1).then(t, function (e) {
                      if (r(), !(e instanceof g)) return void i(e);
                      C.requestLoadedStream(), C.onLoadedStream().then(function () {
                        r(), s(!0).then(t, i);
                      });
                    }, i);
                  }
                  r(), l(e, {
                    forceDataSchema: e.disableCreateObjectURL,
                    maxImageSize: void 0 === e.maxImageSize ? -1 : e.maxImageSize,
                    disableFontFace: e.disableFontFace,
                    nativeImageDecoderSupport: e.nativeImageDecoderSupport,
                    ignoreErrors: e.ignoreErrors
                  }).then(function (e) {
                    if (I) throw e.terminate(), new Error("Worker was terminated");
                    C = e, L.send("PDFManagerReady", null), C.onLoadedStream().then(function (e) {
                      L.send("DataLoaded", {
                        length: e.bytes.byteLength
                      });
                    });
                  }).then(a, i);
                }
                var C,
                  I = !1,
                  M = null,
                  O = [],
                  P = e.docId,
                  B = e.docBaseUrl,
                  D = e.docId + "_worker",
                  L = new h(D, P, t);
                return L.postMessageTransfers = e.postMessageTransfers, L.on("GetPage", function (e) {
                  return C.getPage(e.pageIndex).then(function (e) {
                    var t = C.ensure(e, "rotate"),
                      r = C.ensure(e, "ref"),
                      n = C.ensure(e, "userUnit"),
                      i = C.ensure(e, "view");
                    return Promise.all([t, r, n, i]).then(function (e) {
                      return {
                        rotate: e[0],
                        ref: e[1],
                        userUnit: e[2],
                        view: e[3]
                      };
                    });
                  });
                }), L.on("GetPageIndex", function (e) {
                  var t = new E(e.ref.num, e.ref.gen);
                  return C.pdfDocument.catalog.getPageIndex(t);
                }), L.on("GetDestinations", function (e) {
                  return C.ensureCatalog("destinations");
                }), L.on("GetDestination", function (e) {
                  return C.ensureCatalog("getDestination", [e.id]);
                }), L.on("GetPageLabels", function (e) {
                  return C.ensureCatalog("pageLabels");
                }), L.on("GetAttachments", function (e) {
                  return C.ensureCatalog("attachments");
                }), L.on("GetJavaScript", function (e) {
                  return C.ensureCatalog("javaScript");
                }), L.on("GetOutline", function (e) {
                  return C.ensureCatalog("documentOutline");
                }), L.on("GetMetadata", function (e) {
                  return Promise.all([C.ensureDoc("documentInfo"), C.ensureCatalog("metadata")]);
                }), L.on("GetData", function (e) {
                  return C.requestLoadedStream(), C.onLoadedStream().then(function (e) {
                    return e.bytes;
                  });
                }), L.on("GetStats", function (e) {
                  return C.pdfDocument.xref.stats;
                }), L.on("GetAnnotations", function (e) {
                  return C.getPage(e.pageIndex).then(function (t) {
                    return C.ensure(t, "getAnnotationsData", [e.intent]);
                  });
                }), L.on("RenderPageRequest", function (e) {
                  var t = e.pageIndex;
                  C.getPage(t).then(function (r) {
                    var i = new k("RenderPageRequest: page " + t);
                    n(i);
                    var s = t + 1,
                      l = Date.now();
                    r.getOperatorList({
                      handler: L,
                      task: i,
                      intent: e.intent,
                      renderInteractiveForms: e.renderInteractiveForms
                    }).then(function (e) {
                      o(i), x("page=" + s + " - getOperatorList: time=" + (Date.now() - l) + "ms, len=" + e.totalLength);
                    }, function (t) {
                      if (o(i), !i.terminated) {
                        L.send("UnsupportedFeature", {
                          featureId: c.unknown
                        });
                        var r,
                          n = "worker.js: while trying to getPage() and getOperatorList()";
                        r = "string" == typeof t ? {
                          message: t,
                          stack: n
                        } : "object" === (void 0 === t ? "undefined" : a(t)) ? {
                          message: t.message || t.toString(),
                          stack: t.stack || n
                        } : {
                          message: "Unknown exception type: " + (void 0 === t ? "undefined" : a(t)),
                          stack: n
                        }, L.send("PageError", {
                          pageNum: s,
                          error: r,
                          intent: e.intent
                        });
                      }
                    });
                  });
                }, this), L.on("GetTextContent", function (e) {
                  var t = e.pageIndex;
                  return C.getPage(t).then(function (r) {
                    var i = new k("GetTextContent: page " + t);
                    n(i);
                    var a = t + 1,
                      s = Date.now();
                    return r.extractTextContent({
                      handler: L,
                      task: i,
                      normalizeWhitespace: e.normalizeWhitespace,
                      combineTextItems: e.combineTextItems
                    }).then(function (e) {
                      return o(i), x("text indexing: page=" + a + " - time=" + (Date.now() - s) + "ms"), e;
                    }, function (e) {
                      if (o(i), !i.terminated) throw e;
                    });
                  });
                }), L.on("Cleanup", function (e) {
                  return C.cleanup();
                }), L.on("Terminate", function (e) {
                  I = !0, C && (C.terminate(), C = null), M && M();
                  var t = [];
                  return O.forEach(function (e) {
                    t.push(e.finished), e.terminate();
                  }), Promise.all(t).then(function () {
                    L.destroy(), L = null;
                  });
                }), L.on("Ready", function (t) {
                  S(e), e = null;
                }), D;
              },
              initializeFromPort: function initializeFromPort(e) {
                var t = new h("worker", "main", e);
                I.setup(t, e), t.send("ready", null);
              }
            };
          "undefined" == typeof window && !C() && "undefined" != typeof self && function (e) {
            return "function" == typeof e.postMessage && "onmessage" in e;
          }(self) && I.initializeFromPort(self), t.setPDFNetworkStreamClass = n, t.WorkerTask = k, t.WorkerMessageHandler = I;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            return e.replace(/>\\376\\377([^<]+)/g, function (e, t) {
              for (var r = t.replace(/\\([0-3])([0-7])([0-7])/g, function (e, t, r, n) {
                  return String.fromCharCode(64 * t + 8 * r + 1 * n);
                }), n = "", i = 0; i < r.length; i += 2) {
                var a = 256 * r.charCodeAt(i) + r.charCodeAt(i + 1);
                n += a >= 32 && a < 127 && 60 !== a && 62 !== a && 38 !== a ? String.fromCharCode(a) : "&#x" + (65536 + a).toString(16).substring(1) + ";";
              }
              return ">" + n;
            });
          }
          function i(e) {
            if ("string" == typeof e) {
              e = n(e);
              e = new DOMParser().parseFromString(e, "application/xml");
            } else e instanceof Document || (0, a.error)("Metadata: Invalid metadata object");
            this.metaDocument = e, this.metadata = Object.create(null), this.parse();
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.Metadata = void 0;
          var a = r(0);
          i.prototype = {
            parse: function parse() {
              var e = this.metaDocument,
                t = e.documentElement;
              if ("rdf:rdf" !== t.nodeName.toLowerCase()) for (t = t.firstChild; t && "rdf:rdf" !== t.nodeName.toLowerCase();) t = t.nextSibling;
              var r = t ? t.nodeName.toLowerCase() : null;
              if (t && "rdf:rdf" === r && t.hasChildNodes()) {
                var n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  c,
                  u = t.childNodes;
                for (o = 0, l = u.length; o < l; o++) if (n = u[o], "rdf:description" === n.nodeName.toLowerCase()) for (s = 0, c = n.childNodes.length; s < c; s++) "#text" !== n.childNodes[s].nodeName.toLowerCase() && (i = n.childNodes[s], a = i.nodeName.toLowerCase(), this.metadata[a] = i.textContent.trim());
              }
            },
            get: function get(e) {
              return this.metadata[e] || null;
            },
            has: function has(e) {
              return void 0 !== this.metadata[e];
            }
          }, t.Metadata = i;
        }, function (e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.WebGLUtils = void 0;
          var n = r(3),
            i = r(0),
            a = function () {
              function e(e, t, r) {
                var n = e.createShader(r);
                if (e.shaderSource(n, t), e.compileShader(n), !e.getShaderParameter(n, e.COMPILE_STATUS)) {
                  var i = e.getShaderInfoLog(n);
                  throw new Error("Error during shader compilation: " + i);
                }
                return n;
              }
              function t(t, r) {
                return e(t, r, t.VERTEX_SHADER);
              }
              function r(t, r) {
                return e(t, r, t.FRAGMENT_SHADER);
              }
              function a(e, t) {
                for (var r = e.createProgram(), n = 0, i = t.length; n < i; ++n) e.attachShader(r, t[n]);
                if (e.linkProgram(r), !e.getProgramParameter(r, e.LINK_STATUS)) {
                  var a = e.getProgramInfoLog(r);
                  throw new Error("Error during program linking: " + a);
                }
                return r;
              }
              function o(e, t, r) {
                e.activeTexture(r);
                var n = e.createTexture();
                return e.bindTexture(e.TEXTURE_2D, n), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST), e.texImage2D(e.TEXTURE_2D, 0, e.RGBA, e.RGBA, e.UNSIGNED_BYTE, t), n;
              }
              function s() {
                d || (p = document.createElement("canvas"), d = p.getContext("webgl", {
                  premultipliedalpha: !1
                }));
              }
              function l() {
                var e, n;
                s(), e = p, p = null, n = d, d = null;
                var i = t(n, m),
                  o = r(n, g),
                  l = a(n, [i, o]);
                n.useProgram(l);
                var c = {};
                c.gl = n, c.canvas = e, c.resolutionLocation = n.getUniformLocation(l, "u_resolution"), c.positionLocation = n.getAttribLocation(l, "a_position"), c.backdropLocation = n.getUniformLocation(l, "u_backdrop"), c.subtypeLocation = n.getUniformLocation(l, "u_subtype");
                var u = n.getAttribLocation(l, "a_texCoord"),
                  h = n.getUniformLocation(l, "u_image"),
                  f = n.getUniformLocation(l, "u_mask"),
                  b = n.createBuffer();
                n.bindBuffer(n.ARRAY_BUFFER, b), n.bufferData(n.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]), n.STATIC_DRAW), n.enableVertexAttribArray(u), n.vertexAttribPointer(u, 2, n.FLOAT, !1, 0, 0), n.uniform1i(h, 0), n.uniform1i(f, 1), v = c;
              }
              function c(e, t, r) {
                var n = e.width,
                  i = e.height;
                v || l();
                var a = v,
                  s = a.canvas,
                  c = a.gl;
                s.width = n, s.height = i, c.viewport(0, 0, c.drawingBufferWidth, c.drawingBufferHeight), c.uniform2f(a.resolutionLocation, n, i), r.backdrop ? c.uniform4f(a.resolutionLocation, r.backdrop[0], r.backdrop[1], r.backdrop[2], 1) : c.uniform4f(a.resolutionLocation, 0, 0, 0, 0), c.uniform1i(a.subtypeLocation, "Luminosity" === r.subtype ? 1 : 0);
                var u = o(c, e, c.TEXTURE0),
                  h = o(c, t, c.TEXTURE1),
                  f = c.createBuffer();
                return c.bindBuffer(c.ARRAY_BUFFER, f), c.bufferData(c.ARRAY_BUFFER, new Float32Array([0, 0, n, 0, 0, i, 0, i, n, 0, n, i]), c.STATIC_DRAW), c.enableVertexAttribArray(a.positionLocation), c.vertexAttribPointer(a.positionLocation, 2, c.FLOAT, !1, 0, 0), c.clearColor(0, 0, 0, 0), c.enable(c.BLEND), c.blendFunc(c.ONE, c.ONE_MINUS_SRC_ALPHA), c.clear(c.COLOR_BUFFER_BIT), c.drawArrays(c.TRIANGLES, 0, 6), c.flush(), c.deleteTexture(u), c.deleteTexture(h), c.deleteBuffer(f), s;
              }
              function u() {
                var e, n;
                s(), e = p, p = null, n = d, d = null;
                var i = t(n, b),
                  o = r(n, y),
                  l = a(n, [i, o]);
                n.useProgram(l);
                var c = {};
                c.gl = n, c.canvas = e, c.resolutionLocation = n.getUniformLocation(l, "u_resolution"), c.scaleLocation = n.getUniformLocation(l, "u_scale"), c.offsetLocation = n.getUniformLocation(l, "u_offset"), c.positionLocation = n.getAttribLocation(l, "a_position"), c.colorLocation = n.getAttribLocation(l, "a_color"), w = c;
              }
              function h(e, t, r, n, i) {
                w || u();
                var a = w,
                  o = a.canvas,
                  s = a.gl;
                o.width = e, o.height = t, s.viewport(0, 0, s.drawingBufferWidth, s.drawingBufferHeight), s.uniform2f(a.resolutionLocation, e, t);
                var l,
                  c,
                  h,
                  f = 0;
                for (l = 0, c = n.length; l < c; l++) switch (n[l].type) {
                  case "lattice":
                    h = n[l].coords.length / n[l].verticesPerRow | 0, f += (h - 1) * (n[l].verticesPerRow - 1) * 6;
                    break;
                  case "triangles":
                    f += n[l].coords.length;
                }
                var d = new Float32Array(2 * f),
                  p = new Uint8Array(3 * f),
                  m = i.coords,
                  g = i.colors,
                  v = 0,
                  b = 0;
                for (l = 0, c = n.length; l < c; l++) {
                  var y = n[l],
                    x = y.coords,
                    _ = y.colors;
                  switch (y.type) {
                    case "lattice":
                      var S = y.verticesPerRow;
                      h = x.length / S | 0;
                      for (var C = 1; C < h; C++) for (var E = C * S + 1, A = 1; A < S; A++, E++) d[v] = m[x[E - S - 1]], d[v + 1] = m[x[E - S - 1] + 1], d[v + 2] = m[x[E - S]], d[v + 3] = m[x[E - S] + 1], d[v + 4] = m[x[E - 1]], d[v + 5] = m[x[E - 1] + 1], p[b] = g[_[E - S - 1]], p[b + 1] = g[_[E - S - 1] + 1], p[b + 2] = g[_[E - S - 1] + 2], p[b + 3] = g[_[E - S]], p[b + 4] = g[_[E - S] + 1], p[b + 5] = g[_[E - S] + 2], p[b + 6] = g[_[E - 1]], p[b + 7] = g[_[E - 1] + 1], p[b + 8] = g[_[E - 1] + 2], d[v + 6] = d[v + 2], d[v + 7] = d[v + 3], d[v + 8] = d[v + 4], d[v + 9] = d[v + 5], d[v + 10] = m[x[E]], d[v + 11] = m[x[E] + 1], p[b + 9] = p[b + 3], p[b + 10] = p[b + 4], p[b + 11] = p[b + 5], p[b + 12] = p[b + 6], p[b + 13] = p[b + 7], p[b + 14] = p[b + 8], p[b + 15] = g[_[E]], p[b + 16] = g[_[E] + 1], p[b + 17] = g[_[E] + 2], v += 12, b += 18;
                      break;
                    case "triangles":
                      for (var T = 0, k = x.length; T < k; T++) d[v] = m[x[T]], d[v + 1] = m[x[T] + 1], p[b] = g[_[T]], p[b + 1] = g[_[T] + 1], p[b + 2] = g[_[T] + 2], v += 2, b += 3;
                  }
                }
                r ? s.clearColor(r[0] / 255, r[1] / 255, r[2] / 255, 1) : s.clearColor(0, 0, 0, 0), s.clear(s.COLOR_BUFFER_BIT);
                var R = s.createBuffer();
                s.bindBuffer(s.ARRAY_BUFFER, R), s.bufferData(s.ARRAY_BUFFER, d, s.STATIC_DRAW), s.enableVertexAttribArray(a.positionLocation), s.vertexAttribPointer(a.positionLocation, 2, s.FLOAT, !1, 0, 0);
                var I = s.createBuffer();
                return s.bindBuffer(s.ARRAY_BUFFER, I), s.bufferData(s.ARRAY_BUFFER, p, s.STATIC_DRAW), s.enableVertexAttribArray(a.colorLocation), s.vertexAttribPointer(a.colorLocation, 3, s.UNSIGNED_BYTE, !1, 0, 0), s.uniform2f(a.scaleLocation, i.scaleX, i.scaleY), s.uniform2f(a.offsetLocation, i.offsetX, i.offsetY), s.drawArrays(s.TRIANGLES, 0, f), s.flush(), s.deleteBuffer(R), s.deleteBuffer(I), o;
              }
              function f() {
                v && v.canvas && (v.canvas.width = 0, v.canvas.height = 0), w && w.canvas && (w.canvas.width = 0, w.canvas.height = 0), v = null, w = null;
              }
              var d,
                p,
                m = "  attribute vec2 a_position;                                      attribute vec2 a_texCoord;                                                                                                      uniform vec2 u_resolution;                                                                                                      varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec2 clipSpace = (a_position / u_resolution) * 2.0 - 1.0;       gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_texCoord = a_texCoord;                                      }                                                             ",
                g = "  precision mediump float;                                                                                                        uniform vec4 u_backdrop;                                        uniform int u_subtype;                                          uniform sampler2D u_image;                                      uniform sampler2D u_mask;                                                                                                       varying vec2 v_texCoord;                                                                                                        void main() {                                                     vec4 imageColor = texture2D(u_image, v_texCoord);               vec4 maskColor = texture2D(u_mask, v_texCoord);                 if (u_backdrop.a > 0.0) {                                         maskColor.rgb = maskColor.rgb * maskColor.a +                                   u_backdrop.rgb * (1.0 - maskColor.a);         }                                                               float lum;                                                      if (u_subtype == 0) {                                             lum = maskColor.a;                                            } else {                                                          lum = maskColor.r * 0.3 + maskColor.g * 0.59 +                        maskColor.b * 0.11;                                     }                                                               imageColor.a *= lum;                                            imageColor.rgb *= imageColor.a;                                 gl_FragColor = imageColor;                                    }                                                             ",
                v = null,
                b = "  attribute vec2 a_position;                                      attribute vec3 a_color;                                                                                                         uniform vec2 u_resolution;                                      uniform vec2 u_scale;                                           uniform vec2 u_offset;                                                                                                          varying vec4 v_color;                                                                                                           void main() {                                                     vec2 position = (a_position + u_offset) * u_scale;              vec2 clipSpace = (position / u_resolution) * 2.0 - 1.0;         gl_Position = vec4(clipSpace * vec2(1, -1), 0, 1);                                                                              v_color = vec4(a_color / 255.0, 1.0);                         }                                                             ",
                y = "  precision mediump float;                                                                                                        varying vec4 v_color;                                                                                                           void main() {                                                     gl_FragColor = v_color;                                       }                                                             ",
                w = null;
              return {
                get isEnabled() {
                  if ((0, n.getDefaultSetting)("disableWebGL")) return !1;
                  var e = !1;
                  try {
                    s(), e = !!d;
                  } catch (e) {}
                  return (0, i.shadow)(this, "isEnabled", e);
                },
                composeSMask: c,
                drawFigures: h,
                clear: f
              };
            }();
          t.WebGLUtils = a;
        }, function (e, t, r) {
          "use strict";

          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.PDFJS = t.isWorker = t.globalScope = void 0;
          var n = r(10),
            i = r(3),
            a = r(0),
            o = r(9),
            s = r(24),
            l = r(12),
            c = r(11),
            u = "undefined" == typeof window;
          a.globalScope.PDFJS || (a.globalScope.PDFJS = {});
          var h = a.globalScope.PDFJS;
          h.version = "1.8.357", h.build = "ca3cf6e7", h.pdfBug = !1, void 0 !== h.verbosity && (0, a.setVerbosityLevel)(h.verbosity), delete h.verbosity, Object.defineProperty(h, "verbosity", {
            get: function get() {
              return (0, a.getVerbosityLevel)();
            },
            set: function set(e) {
              (0, a.setVerbosityLevel)(e);
            },
            enumerable: !0,
            configurable: !0
          }), h.VERBOSITY_LEVELS = a.VERBOSITY_LEVELS, h.OPS = a.OPS, h.UNSUPPORTED_FEATURES = a.UNSUPPORTED_FEATURES, h.isValidUrl = i.isValidUrl, h.shadow = a.shadow, h.createBlob = a.createBlob, h.createObjectURL = function (e, t) {
            return (0, a.createObjectURL)(e, t, h.disableCreateObjectURL);
          }, Object.defineProperty(h, "isLittleEndian", {
            configurable: !0,
            get: function get() {
              return (0, a.shadow)(h, "isLittleEndian", (0, a.isLittleEndian)());
            }
          }), h.removeNullCharacters = a.removeNullCharacters, h.PasswordResponses = a.PasswordResponses, h.PasswordException = a.PasswordException, h.UnknownErrorException = a.UnknownErrorException, h.InvalidPDFException = a.InvalidPDFException, h.MissingPDFException = a.MissingPDFException, h.UnexpectedResponseException = a.UnexpectedResponseException, h.Util = a.Util, h.PageViewport = a.PageViewport, h.createPromiseCapability = a.createPromiseCapability, h.maxImageSize = void 0 === h.maxImageSize ? -1 : h.maxImageSize, h.cMapUrl = void 0 === h.cMapUrl ? null : h.cMapUrl, h.cMapPacked = void 0 !== h.cMapPacked && h.cMapPacked, h.disableFontFace = void 0 !== h.disableFontFace && h.disableFontFace, h.imageResourcesPath = void 0 === h.imageResourcesPath ? "" : h.imageResourcesPath, h.disableWorker = void 0 !== h.disableWorker && h.disableWorker, h.workerSrc = void 0 === h.workerSrc ? null : h.workerSrc, h.workerPort = void 0 === h.workerPort ? null : h.workerPort, h.disableRange = void 0 !== h.disableRange && h.disableRange, h.disableStream = void 0 !== h.disableStream && h.disableStream, h.disableAutoFetch = void 0 !== h.disableAutoFetch && h.disableAutoFetch, h.pdfBug = void 0 !== h.pdfBug && h.pdfBug, h.postMessageTransfers = void 0 === h.postMessageTransfers || h.postMessageTransfers, h.disableCreateObjectURL = void 0 !== h.disableCreateObjectURL && h.disableCreateObjectURL, h.disableWebGL = void 0 === h.disableWebGL || h.disableWebGL, h.externalLinkTarget = void 0 === h.externalLinkTarget ? i.LinkTarget.NONE : h.externalLinkTarget, h.externalLinkRel = void 0 === h.externalLinkRel ? i.DEFAULT_LINK_REL : h.externalLinkRel, h.isEvalSupported = void 0 === h.isEvalSupported || h.isEvalSupported, h.pdfjsNext = void 0 !== h.pdfjsNext && h.pdfjsNext;
          var f = h.openExternalLinksInNewWindow;
          delete h.openExternalLinksInNewWindow, Object.defineProperty(h, "openExternalLinksInNewWindow", {
            get: function get() {
              return h.externalLinkTarget === i.LinkTarget.BLANK;
            },
            set: function set(e) {
              if (e && (0, a.deprecated)('PDFJS.openExternalLinksInNewWindow, please use "PDFJS.externalLinkTarget = PDFJS.LinkTarget.BLANK" instead.'), h.externalLinkTarget !== i.LinkTarget.NONE) return void (0, a.warn)("PDFJS.externalLinkTarget is already initialized");
              h.externalLinkTarget = e ? i.LinkTarget.BLANK : i.LinkTarget.NONE;
            },
            enumerable: !0,
            configurable: !0
          }), f && (h.openExternalLinksInNewWindow = f), h.getDocument = n.getDocument, h.LoopbackPort = n.LoopbackPort, h.PDFDataRangeTransport = n.PDFDataRangeTransport, h.PDFWorker = n.PDFWorker, h.hasCanvasTypedArrays = !0, h.CustomStyle = i.CustomStyle, h.LinkTarget = i.LinkTarget, h.addLinkAttributes = i.addLinkAttributes, h.getFilenameFromUrl = i.getFilenameFromUrl, h.isExternalLinkTargetSet = i.isExternalLinkTargetSet, h.AnnotationLayer = o.AnnotationLayer, h.renderTextLayer = l.renderTextLayer, h.Metadata = s.Metadata, h.SVGGraphics = c.SVGGraphics, h.UnsupportedManager = n._UnsupportedManager, t.globalScope = a.globalScope, t.isWorker = u, t.PDFJS = h;
        }, function (e, t, r) {
          "use strict";

          function n() {}
          var i = r(0),
            a = r(1),
            o = r(2),
            s = r(4),
            l = r(20),
            c = r(18),
            u = i.AnnotationBorderStyleType,
            h = i.AnnotationFieldFlag,
            f = i.AnnotationFlag,
            d = i.AnnotationType,
            p = i.OPS,
            m = i.Util,
            g = i.isArray,
            v = i.isInt,
            b = i.stringToBytes,
            y = i.stringToPDFString,
            w = i.warn,
            x = a.Dict,
            _ = a.isDict,
            S = a.isName,
            C = a.isRef,
            E = a.isStream,
            A = o.Stream,
            T = s.ColorSpace,
            k = l.Catalog,
            R = l.ObjectLoader,
            I = l.FileSpec,
            M = c.OperatorList;
          n.prototype = {
            create: function create(e, t, r, n) {
              var i = e.fetchIfRef(t);
              if (_(i)) {
                var a = C(t) ? t.toString() : "annot_" + n.createObjId(),
                  o = i.get("Subtype");
                o = S(o) ? o.name : null;
                var s = {
                  xref: e,
                  dict: i,
                  ref: C(t) ? t : null,
                  subtype: o,
                  id: a,
                  pdfManager: r
                };
                switch (o) {
                  case "Link":
                    return new U(s);
                  case "Text":
                    return new N(s);
                  case "Widget":
                    var l = m.getInheritableProperty(i, "FT");
                    switch (l = S(l) ? l.name : null) {
                      case "Tx":
                        return new D(s);
                      case "Btn":
                        return new L(s);
                      case "Ch":
                        return new F(s);
                    }
                    return w('Unimplemented widget field type "' + l + '", falling back to base field type.'), new B(s);
                  case "Popup":
                    return new j(s);
                  case "Line":
                    return new z(s);
                  case "Highlight":
                    return new H(s);
                  case "Underline":
                    return new G(s);
                  case "Squiggly":
                    return new V(s);
                  case "StrikeOut":
                    return new q(s);
                  case "FileAttachment":
                    return new W(s);
                  default:
                    return w(o ? 'Unimplemented annotation type "' + o + '", falling back to base annotation.' : "Annotation is missing the required /Subtype."), new O(s);
                }
              }
            }
          };
          var O = function () {
              function e(e, t, r) {
                var n = m.getAxialAlignedBoundingBox(t, r),
                  i = n[0],
                  a = n[1],
                  o = n[2],
                  s = n[3];
                if (i === o || a === s) return [1, 0, 0, 1, e[0], e[1]];
                var l = (e[2] - e[0]) / (o - i),
                  c = (e[3] - e[1]) / (s - a);
                return [l, 0, 0, c, e[0] - i * l, e[1] - a * c];
              }
              function t(e) {
                var t = e.dict;
                this.setFlags(t.get("F")), this.setRectangle(t.getArray("Rect")), this.setColor(t.getArray("C")), this.setBorderStyle(t), this.setAppearance(t), this.data = {}, this.data.id = e.id, this.data.subtype = e.subtype, this.data.annotationFlags = this.flags, this.data.rect = this.rectangle, this.data.color = this.color, this.data.borderStyle = this.borderStyle, this.data.hasAppearance = !!this.appearance;
              }
              return t.prototype = {
                _hasFlag: function _hasFlag(e, t) {
                  return !!(e & t);
                },
                _isViewable: function _isViewable(e) {
                  return !this._hasFlag(e, f.INVISIBLE) && !this._hasFlag(e, f.HIDDEN) && !this._hasFlag(e, f.NOVIEW);
                },
                _isPrintable: function _isPrintable(e) {
                  return this._hasFlag(e, f.PRINT) && !this._hasFlag(e, f.INVISIBLE) && !this._hasFlag(e, f.HIDDEN);
                },
                get viewable() {
                  return 0 === this.flags || this._isViewable(this.flags);
                },
                get printable() {
                  return 0 !== this.flags && this._isPrintable(this.flags);
                },
                setFlags: function setFlags(e) {
                  this.flags = v(e) && e > 0 ? e : 0;
                },
                hasFlag: function hasFlag(e) {
                  return this._hasFlag(this.flags, e);
                },
                setRectangle: function setRectangle(e) {
                  g(e) && 4 === e.length ? this.rectangle = m.normalizeRect(e) : this.rectangle = [0, 0, 0, 0];
                },
                setColor: function setColor(e) {
                  var t = new Uint8Array(3);
                  if (!g(e)) return void (this.color = t);
                  switch (e.length) {
                    case 0:
                      this.color = null;
                      break;
                    case 1:
                      T.singletons.gray.getRgbItem(e, 0, t, 0), this.color = t;
                      break;
                    case 3:
                      T.singletons.rgb.getRgbItem(e, 0, t, 0), this.color = t;
                      break;
                    case 4:
                      T.singletons.cmyk.getRgbItem(e, 0, t, 0), this.color = t;
                      break;
                    default:
                      this.color = t;
                  }
                },
                setBorderStyle: function setBorderStyle(e) {
                  if (this.borderStyle = new P(), _(e)) if (e.has("BS")) {
                    var t = e.get("BS"),
                      r = t.get("Type");
                    r && !S(r, "Border") || (this.borderStyle.setWidth(t.get("W")), this.borderStyle.setStyle(t.get("S")), this.borderStyle.setDashArray(t.getArray("D")));
                  } else if (e.has("Border")) {
                    var n = e.getArray("Border");
                    g(n) && n.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(n[0]), this.borderStyle.setVerticalCornerRadius(n[1]), this.borderStyle.setWidth(n[2]), 4 === n.length && this.borderStyle.setDashArray(n[3]));
                  } else this.borderStyle.setWidth(0);
                },
                setAppearance: function setAppearance(e) {
                  this.appearance = null;
                  var t = e.get("AP");
                  if (_(t)) {
                    var r = t.get("N");
                    if (E(r)) return void (this.appearance = r);
                    if (_(r)) {
                      var n = e.get("AS");
                      S(n) && r.has(n.name) && (this.appearance = r.get(n.name));
                    }
                  }
                },
                _preparePopup: function _preparePopup(e) {
                  e.has("C") || (this.data.color = null), this.data.hasPopup = e.has("Popup"), this.data.title = y(e.get("T") || ""), this.data.contents = y(e.get("Contents") || "");
                },
                loadResources: function loadResources(e) {
                  return this.appearance.dict.getAsync("Resources").then(function (t) {
                    if (t) {
                      return new R(t.map, e, t.xref).load().then(function () {
                        return t;
                      });
                    }
                  });
                },
                getOperatorList: function getOperatorList(t, r, n) {
                  var i = this;
                  if (!this.appearance) return Promise.resolve(new M());
                  var a = this.data,
                    o = this.appearance.dict,
                    s = this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"]),
                    l = o.getArray("BBox") || [0, 0, 1, 1],
                    c = o.getArray("Matrix") || [1, 0, 0, 1, 0, 0],
                    u = e(a.rect, l, c);
                  return s.then(function (e) {
                    var n = new M();
                    return n.addOp(p.beginAnnotation, [a.rect, u, c]), t.getOperatorList({
                      stream: i.appearance,
                      task: r,
                      resources: e,
                      operatorList: n
                    }).then(function () {
                      return n.addOp(p.endAnnotation, []), i.appearance.reset(), n;
                    });
                  });
                }
              }, t;
            }(),
            P = function () {
              function e() {
                this.width = 1, this.style = u.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
              }
              return e.prototype = {
                setWidth: function setWidth(e) {
                  e === (0 | e) && (this.width = e);
                },
                setStyle: function setStyle(e) {
                  if (e) switch (e.name) {
                    case "S":
                      this.style = u.SOLID;
                      break;
                    case "D":
                      this.style = u.DASHED;
                      break;
                    case "B":
                      this.style = u.BEVELED;
                      break;
                    case "I":
                      this.style = u.INSET;
                      break;
                    case "U":
                      this.style = u.UNDERLINE;
                  }
                },
                setDashArray: function setDashArray(e) {
                  if (g(e) && e.length > 0) {
                    for (var t = !0, r = !0, n = 0, i = e.length; n < i; n++) {
                      var a = e[n];
                      if (!(+a >= 0)) {
                        t = !1;
                        break;
                      }
                      a > 0 && (r = !1);
                    }
                    t && !r ? this.dashArray = e : this.width = 0;
                  } else e && (this.width = 0);
                },
                setHorizontalCornerRadius: function setHorizontalCornerRadius(e) {
                  e === (0 | e) && (this.horizontalCornerRadius = e);
                },
                setVerticalCornerRadius: function setVerticalCornerRadius(e) {
                  e === (0 | e) && (this.verticalCornerRadius = e);
                }
              }, e;
            }(),
            B = function () {
              function e(e) {
                O.call(this, e);
                var t = e.dict,
                  r = this.data;
                r.annotationType = d.WIDGET, r.fieldName = this._constructFieldName(t), r.fieldValue = m.getInheritableProperty(t, "V", !0), r.alternativeText = y(t.get("TU") || ""), r.defaultAppearance = m.getInheritableProperty(t, "DA") || "";
                var n = m.getInheritableProperty(t, "FT");
                r.fieldType = S(n) ? n.name : null, this.fieldResources = m.getInheritableProperty(t, "DR") || x.empty, r.fieldFlags = m.getInheritableProperty(t, "Ff"), (!v(r.fieldFlags) || r.fieldFlags < 0) && (r.fieldFlags = 0), r.readOnly = this.hasFieldFlag(h.READONLY), "Sig" === r.fieldType && this.setFlags(f.HIDDEN);
              }
              return m.inherit(e, O, {
                _constructFieldName: function _constructFieldName(e) {
                  if (!e.has("T") && !e.has("Parent")) return w("Unknown field name, falling back to empty field name."), "";
                  if (!e.has("Parent")) return y(e.get("T"));
                  var t = [];
                  e.has("T") && t.unshift(y(e.get("T")));
                  for (var r = e; r.has("Parent") && (r = r.get("Parent"), _(r));) r.has("T") && t.unshift(y(r.get("T")));
                  return t.join(".");
                },
                hasFieldFlag: function hasFieldFlag(e) {
                  return !!(this.data.fieldFlags & e);
                }
              }), e;
            }(),
            D = function () {
              function e(e) {
                B.call(this, e), this.data.fieldValue = y(this.data.fieldValue || "");
                var t = m.getInheritableProperty(e.dict, "Q");
                (!v(t) || t < 0 || t > 2) && (t = null), this.data.textAlignment = t;
                var r = m.getInheritableProperty(e.dict, "MaxLen");
                (!v(r) || r < 0) && (r = null), this.data.maxLen = r, this.data.multiLine = this.hasFieldFlag(h.MULTILINE), this.data.comb = this.hasFieldFlag(h.COMB) && !this.hasFieldFlag(h.MULTILINE) && !this.hasFieldFlag(h.PASSWORD) && !this.hasFieldFlag(h.FILESELECT) && null !== this.data.maxLen;
              }
              return m.inherit(e, B, {
                getOperatorList: function getOperatorList(e, t, r) {
                  var n = new M();
                  if (r) return Promise.resolve(n);
                  if (this.appearance) return O.prototype.getOperatorList.call(this, e, t, r);
                  if (!this.data.defaultAppearance) return Promise.resolve(n);
                  var i = new A(b(this.data.defaultAppearance));
                  return e.getOperatorList({
                    stream: i,
                    task: t,
                    resources: this.fieldResources,
                    operatorList: n
                  }).then(function () {
                    return n;
                  });
                }
              }), e;
            }(),
            L = function () {
              function e(e) {
                if (B.call(this, e), this.data.checkBox = !this.hasFieldFlag(h.RADIO) && !this.hasFieldFlag(h.PUSHBUTTON), this.data.checkBox) {
                  if (!S(this.data.fieldValue)) return;
                  this.data.fieldValue = this.data.fieldValue.name;
                }
                if (this.data.radioButton = this.hasFieldFlag(h.RADIO) && !this.hasFieldFlag(h.PUSHBUTTON), this.data.radioButton) {
                  this.data.fieldValue = this.data.buttonValue = null;
                  var t = e.dict.get("Parent");
                  if (_(t) && t.has("V")) {
                    var r = t.get("V");
                    S(r) && (this.data.fieldValue = r.name);
                  }
                  var n = e.dict.get("AP");
                  if (!_(n)) return;
                  var i = n.get("N");
                  if (!_(i)) return;
                  for (var a = i.getKeys(), o = 0, s = a.length; o < s; o++) if ("Off" !== a[o]) {
                    this.data.buttonValue = a[o];
                    break;
                  }
                }
              }
              return m.inherit(e, B, {
                getOperatorList: function getOperatorList(e, t, r) {
                  var n = new M();
                  return r ? Promise.resolve(n) : this.appearance ? O.prototype.getOperatorList.call(this, e, t, r) : Promise.resolve(n);
                }
              }), e;
            }(),
            F = function () {
              function e(e) {
                B.call(this, e), this.data.options = [];
                var t = m.getInheritableProperty(e.dict, "Opt");
                if (g(t)) for (var r = e.xref, n = 0, i = t.length; n < i; n++) {
                  var a = r.fetchIfRef(t[n]),
                    o = g(a);
                  this.data.options[n] = {
                    exportValue: o ? r.fetchIfRef(a[0]) : a,
                    displayValue: o ? r.fetchIfRef(a[1]) : a
                  };
                }
                g(this.data.fieldValue) || (this.data.fieldValue = [this.data.fieldValue]), this.data.combo = this.hasFieldFlag(h.COMBO), this.data.multiSelect = this.hasFieldFlag(h.MULTISELECT);
              }
              return m.inherit(e, B, {
                getOperatorList: function getOperatorList(e, t, r) {
                  var n = new M();
                  return r ? Promise.resolve(n) : O.prototype.getOperatorList.call(this, e, t, r);
                }
              }), e;
            }(),
            N = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - t, this.data.rect[2] = this.data.rect[0] + t, this.data.name = e.dict.has("Name") ? e.dict.get("Name").name : "Note"), this._preparePopup(e.dict);
              }
              var t = 22;
              return m.inherit(e, O, {}), e;
            }(),
            U = function () {
              function e(e) {
                O.call(this, e);
                var t = this.data;
                t.annotationType = d.LINK, k.parseDestDictionary({
                  destDict: e.dict,
                  resultObj: t,
                  docBaseUrl: e.pdfManager.docBaseUrl
                });
              }
              return m.inherit(e, O, {}), e;
            }(),
            j = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.POPUP;
                var t = e.dict,
                  r = t.get("Parent");
                if (!r) return void w("Popup annotation has a missing or invalid parent annotation.");
                var n = r.get("Subtype");
                if (this.data.parentType = S(n) ? n.name : null, this.data.parentId = t.getRaw("Parent").toString(), this.data.title = y(r.get("T") || ""), this.data.contents = y(r.get("Contents") || ""), r.has("C") ? (this.setColor(r.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
                  var i = r.get("F");
                  this._isViewable(i) && this.setFlags(i);
                }
              }
              return m.inherit(e, O, {}), e;
            }(),
            z = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.LINE;
                var t = e.dict;
                this.data.lineCoordinates = m.normalizeRect(t.getArray("L")), this._preparePopup(t);
              }
              return m.inherit(e, O, {}), e;
            }(),
            H = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.HIGHLIGHT, this._preparePopup(e.dict);
              }
              return m.inherit(e, O, {}), e;
            }(),
            G = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.UNDERLINE, this._preparePopup(e.dict);
              }
              return m.inherit(e, O, {}), e;
            }(),
            V = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.SQUIGGLY, this._preparePopup(e.dict);
              }
              return m.inherit(e, O, {}), e;
            }(),
            q = function () {
              function e(e) {
                O.call(this, e), this.data.annotationType = d.STRIKEOUT, this._preparePopup(e.dict);
              }
              return m.inherit(e, O, {}), e;
            }(),
            W = function () {
              function e(e) {
                O.call(this, e);
                var t = new I(e.dict.get("FS"), e.xref);
                this.data.annotationType = d.FILEATTACHMENT, this.data.file = t.serializable, this._preparePopup(e.dict);
              }
              return m.inherit(e, O, {}), e;
            }();
          t.Annotation = O, t.AnnotationBorderStyle = P, t.AnnotationFactory = n;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            return 0 != (1 & e);
          }
          function i(e) {
            return 0 == (1 & e);
          }
          function a(e, t, r) {
            for (var n = t, i = e.length; n < i; ++n) if (e[n] !== r) return n;
            return n;
          }
          function o(e, t, r, n) {
            for (var i = t; i < r; ++i) e[i] = n;
          }
          function s(e, t, r) {
            for (var n = t, i = r - 1; n < i; ++n, --i) {
              var a = e[n];
              e[n] = e[i], e[i] = a;
            }
          }
          function l(e, t, r) {
            return {
              str: e,
              dir: r ? "ttb" : t ? "ltr" : "rtl"
            };
          }
          function c(e, t, r) {
            var c = !0,
              u = e.length;
            if (0 === u || r) return l(e, c, r);
            p.length = u, m.length = u;
            var g,
              v,
              b = 0;
            for (g = 0; g < u; ++g) {
              p[g] = e.charAt(g);
              var y = e.charCodeAt(g),
                w = "L";
              y <= 255 ? w = f[y] : 1424 <= y && y <= 1524 ? w = "R" : 1536 <= y && y <= 1791 ? (w = d[255 & y]) || h("Bidi: invalid Unicode character " + y.toString(16)) : 1792 <= y && y <= 2220 && (w = "AL"), "R" !== w && "AL" !== w && "AN" !== w || b++, m[g] = w;
            }
            if (0 === b) return c = !0, l(e, c);
            -1 === t && (b / u < .3 ? (c = !0, t = 0) : (c = !1, t = 1));
            var x = [];
            for (g = 0; g < u; ++g) x[g] = t;
            var _ = n(t) ? "R" : "L",
              S = _,
              C = S,
              E = S;
            for (g = 0; g < u; ++g) "NSM" === m[g] ? m[g] = E : E = m[g];
            E = S;
            var A;
            for (g = 0; g < u; ++g) A = m[g], "EN" === A ? m[g] = "AL" === E ? "AN" : "EN" : "R" !== A && "L" !== A && "AL" !== A || (E = A);
            for (g = 0; g < u; ++g) "AL" === (A = m[g]) && (m[g] = "R");
            for (g = 1; g < u - 1; ++g) "ES" === m[g] && "EN" === m[g - 1] && "EN" === m[g + 1] && (m[g] = "EN"), "CS" !== m[g] || "EN" !== m[g - 1] && "AN" !== m[g - 1] || m[g + 1] !== m[g - 1] || (m[g] = m[g - 1]);
            for (g = 0; g < u; ++g) if ("EN" === m[g]) {
              var T;
              for (T = g - 1; T >= 0 && "ET" === m[T]; --T) m[T] = "EN";
              for (T = g + 1; T < u && "ET" === m[T]; ++T) m[T] = "EN";
            }
            for (g = 0; g < u; ++g) "WS" !== (A = m[g]) && "ES" !== A && "ET" !== A && "CS" !== A || (m[g] = "ON");
            for (E = S, g = 0; g < u; ++g) A = m[g], "EN" === A ? m[g] = "L" === E ? "L" : "EN" : "R" !== A && "L" !== A || (E = A);
            for (g = 0; g < u; ++g) if ("ON" === m[g]) {
              var k = a(m, g + 1, "ON"),
                R = S;
              g > 0 && (R = m[g - 1]);
              var I = C;
              k + 1 < u && (I = m[k + 1]), "L" !== R && (R = "R"), "L" !== I && (I = "R"), R === I && o(m, g, k, R), g = k - 1;
            }
            for (g = 0; g < u; ++g) "ON" === m[g] && (m[g] = _);
            for (g = 0; g < u; ++g) A = m[g], i(x[g]) ? "R" === A ? x[g] += 1 : "AN" !== A && "EN" !== A || (x[g] += 2) : "L" !== A && "AN" !== A && "EN" !== A || (x[g] += 1);
            var M,
              O = -1,
              P = 99;
            for (g = 0, v = x.length; g < v; ++g) M = x[g], O < M && (O = M), P > M && n(M) && (P = M);
            for (M = O; M >= P; --M) {
              var B = -1;
              for (g = 0, v = x.length; g < v; ++g) x[g] < M ? B >= 0 && (s(p, B, g), B = -1) : B < 0 && (B = g);
              B >= 0 && s(p, B, x.length);
            }
            for (g = 0, v = p.length; g < v; ++g) {
              var D = p[g];
              "<" !== D && ">" !== D || (p[g] = "");
            }
            return l(p.join(""), c);
          }
          var u = r(0),
            h = u.warn,
            f = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"],
            d = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"],
            p = [],
            m = [];
          t.bidi = c;
        }, function (e, t, r) {
          "use strict";

          var n = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"],
            i = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"],
            a = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
          t.ISOAdobeCharset = n, t.ExpertCharset = i, t.ExpertSubsetCharset = a;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(2),
            o = r(6),
            s = n.Util,
            l = n.assert,
            c = n.warn,
            u = n.error,
            h = n.isInt,
            f = n.isString,
            d = n.MissingDataException,
            p = n.CMapCompressionType,
            m = i.isEOF,
            g = i.isName,
            v = i.isCmd,
            b = i.isStream,
            y = a.Stream,
            w = o.Lexer,
            x = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"],
            _ = function () {
              function e(e) {
                this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = e;
              }
              return e.prototype = {
                addCodespaceRange: function addCodespaceRange(e, t, r) {
                  this.codespaceRanges[e - 1].push(t, r), this.numCodespaceRanges++;
                },
                mapCidRange: function mapCidRange(e, t, r) {
                  for (; e <= t;) this._map[e++] = r++;
                },
                mapBfRange: function mapBfRange(e, t, r) {
                  for (var n = r.length - 1; e <= t;) this._map[e++] = r, r = r.substr(0, n) + String.fromCharCode(r.charCodeAt(n) + 1);
                },
                mapBfRangeToArray: function mapBfRangeToArray(e, t, r) {
                  for (var n = 0, i = r.length; e <= t && n < i;) this._map[e] = r[n++], ++e;
                },
                mapOne: function mapOne(e, t) {
                  this._map[e] = t;
                },
                lookup: function lookup(e) {
                  return this._map[e];
                },
                contains: function contains(e) {
                  return void 0 !== this._map[e];
                },
                forEach: function forEach(e) {
                  var t,
                    r = this._map,
                    n = r.length;
                  if (n <= 65536) for (t = 0; t < n; t++) void 0 !== r[t] && e(t, r[t]);else for (t in this._map) e(t, r[t]);
                },
                charCodeOf: function charCodeOf(e) {
                  return this._map.indexOf(e);
                },
                getMap: function getMap() {
                  return this._map;
                },
                readCharCode: function readCharCode(e, t, r) {
                  for (var n = 0, i = this.codespaceRanges, a = this.codespaceRanges.length, o = 0; o < a; o++) {
                    n = (n << 8 | e.charCodeAt(t + o)) >>> 0;
                    for (var s = i[o], l = 0, c = s.length; l < c;) {
                      var u = s[l++],
                        h = s[l++];
                      if (n >= u && n <= h) return r.charcode = n, void (r.length = o + 1);
                    }
                  }
                  r.charcode = 0, r.length = 1;
                },
                get length() {
                  return this._map.length;
                },
                get isIdentityCMap() {
                  if ("Identity-H" !== this.name && "Identity-V" !== this.name) return !1;
                  if (65536 !== this._map.length) return !1;
                  for (var e = 0; e < 65536; e++) if (this._map[e] !== e) return !1;
                  return !0;
                }
              }, e;
            }(),
            S = function () {
              function e(e, t) {
                _.call(this), this.vertical = e, this.addCodespaceRange(t, 0, 65535);
              }
              return s.inherit(e, _, {}), e.prototype = {
                addCodespaceRange: _.prototype.addCodespaceRange,
                mapCidRange: function mapCidRange(e, t, r) {
                  u("should not call mapCidRange");
                },
                mapBfRange: function mapBfRange(e, t, r) {
                  u("should not call mapBfRange");
                },
                mapBfRangeToArray: function mapBfRangeToArray(e, t, r) {
                  u("should not call mapBfRangeToArray");
                },
                mapOne: function mapOne(e, t) {
                  u("should not call mapCidOne");
                },
                lookup: function lookup(e) {
                  return h(e) && e <= 65535 ? e : void 0;
                },
                contains: function contains(e) {
                  return h(e) && e <= 65535;
                },
                forEach: function forEach(e) {
                  for (var t = 0; t <= 65535; t++) e(t, t);
                },
                charCodeOf: function charCodeOf(e) {
                  return h(e) && e <= 65535 ? e : -1;
                },
                getMap: function getMap() {
                  for (var e = new Array(65536), t = 0; t <= 65535; t++) e[t] = t;
                  return e;
                },
                readCharCode: _.prototype.readCharCode,
                get length() {
                  return 65536;
                },
                get isIdentityCMap() {
                  u("should not access .isIdentityCMap");
                }
              }, e;
            }(),
            C = function () {
              function e(e, t) {
                for (var r = 0, n = 0; n <= t; n++) r = r << 8 | e[n];
                return r >>> 0;
              }
              function t(e, t) {
                return 1 === t ? String.fromCharCode(e[0], e[1]) : 3 === t ? String.fromCharCode(e[0], e[1], e[2], e[3]) : String.fromCharCode.apply(null, e.subarray(0, t + 1));
              }
              function r(e, t, r) {
                for (var n = 0, i = r; i >= 0; i--) n += e[i] + t[i], e[i] = 255 & n, n >>= 8;
              }
              function n(e, t) {
                for (var r = 1, n = t; n >= 0 && r > 0; n--) r += e[n], e[n] = 255 & r, r >>= 8;
              }
              function i(e) {
                this.buffer = e, this.pos = 0, this.end = e.length, this.tmpBuf = new Uint8Array(c);
              }
              function a(a, o, c) {
                return new Promise(function (u, h) {
                  var f = new i(a),
                    d = f.readByte();
                  o.vertical = !!(1 & d);
                  for (var p, m, g = null, v = new Uint8Array(s), b = new Uint8Array(s), y = new Uint8Array(s), w = new Uint8Array(s), x = new Uint8Array(s); (m = f.readByte()) >= 0;) {
                    var _ = m >> 5;
                    if (7 !== _) {
                      var S = !!(16 & m),
                        C = 15 & m;
                      l(C + 1 <= s);
                      var E,
                        A = f.readNumber();
                      switch (_) {
                        case 0:
                          for (f.readHex(v, C), f.readHexNumber(b, C), r(b, v, C), o.addCodespaceRange(C + 1, e(v, C), e(b, C)), E = 1; E < A; E++) n(b, C), f.readHexNumber(v, C), r(v, b, C), f.readHexNumber(b, C), r(b, v, C), o.addCodespaceRange(C + 1, e(v, C), e(b, C));
                          break;
                        case 1:
                          for (f.readHex(v, C), f.readHexNumber(b, C), r(b, v, C), p = f.readNumber(), E = 1; E < A; E++) n(b, C), f.readHexNumber(v, C), r(v, b, C), f.readHexNumber(b, C), r(b, v, C), p = f.readNumber();
                          break;
                        case 2:
                          for (f.readHex(y, C), p = f.readNumber(), o.mapOne(e(y, C), p), E = 1; E < A; E++) n(y, C), S || (f.readHexNumber(x, C), r(y, x, C)), p = f.readSigned() + (p + 1), o.mapOne(e(y, C), p);
                          break;
                        case 3:
                          for (f.readHex(v, C), f.readHexNumber(b, C), r(b, v, C), p = f.readNumber(), o.mapCidRange(e(v, C), e(b, C), p), E = 1; E < A; E++) n(b, C), S ? v.set(b) : (f.readHexNumber(v, C), r(v, b, C)), f.readHexNumber(b, C), r(b, v, C), p = f.readNumber(), o.mapCidRange(e(v, C), e(b, C), p);
                          break;
                        case 4:
                          for (f.readHex(y, 1), f.readHex(w, C), o.mapOne(e(y, 1), t(w, C)), E = 1; E < A; E++) n(y, 1), S || (f.readHexNumber(x, 1), r(y, x, 1)), n(w, C), f.readHexSigned(x, C), r(w, x, C), o.mapOne(e(y, 1), t(w, C));
                          break;
                        case 5:
                          for (f.readHex(v, 1), f.readHexNumber(b, 1), r(b, v, 1), f.readHex(w, C), o.mapBfRange(e(v, 1), e(b, 1), t(w, C)), E = 1; E < A; E++) n(b, 1), S ? v.set(b) : (f.readHexNumber(v, 1), r(v, b, 1)), f.readHexNumber(b, 1), r(b, v, 1), f.readHex(w, C), o.mapBfRange(e(v, 1), e(b, 1), t(w, C));
                          break;
                        default:
                          return void h(new Error("processBinaryCMap: Unknown type: " + _));
                      }
                    } else switch (31 & m) {
                      case 0:
                        f.readString();
                        break;
                      case 1:
                        g = f.readString();
                    }
                  }
                  if (g) return void u(c(g));
                  u(o);
                });
              }
              function o() {}
              var s = 16,
                c = 19;
              return i.prototype = {
                readByte: function readByte() {
                  return this.pos >= this.end ? -1 : this.buffer[this.pos++];
                },
                readNumber: function readNumber() {
                  var e,
                    t = 0;
                  do {
                    var r = this.readByte();
                    r < 0 && u("unexpected EOF in bcmap"), e = !(128 & r), t = t << 7 | 127 & r;
                  } while (!e);
                  return t;
                },
                readSigned: function readSigned() {
                  var e = this.readNumber();
                  return 1 & e ? ~(e >>> 1) : e >>> 1;
                },
                readHex: function readHex(e, t) {
                  e.set(this.buffer.subarray(this.pos, this.pos + t + 1)), this.pos += t + 1;
                },
                readHexNumber: function readHexNumber(e, t) {
                  var r,
                    n = this.tmpBuf,
                    i = 0;
                  do {
                    var a = this.readByte();
                    a < 0 && u("unexpected EOF in bcmap"), r = !(128 & a), n[i++] = 127 & a;
                  } while (!r);
                  for (var o = t, s = 0, l = 0; o >= 0;) {
                    for (; l < 8 && n.length > 0;) s = n[--i] << l | s, l += 7;
                    e[o] = 255 & s, o--, s >>= 8, l -= 8;
                  }
                },
                readHexSigned: function readHexSigned(e, t) {
                  this.readHexNumber(e, t);
                  for (var r = 1 & e[t] ? 255 : 0, n = 0, i = 0; i <= t; i++) n = (1 & n) << 8 | e[i], e[i] = n >> 1 ^ r;
                },
                readString: function readString() {
                  for (var e = this.readNumber(), t = "", r = 0; r < e; r++) t += String.fromCharCode(this.readNumber());
                  return t;
                }
              }, o.prototype = {
                process: a
              }, o;
            }(),
            E = function () {
              function e(e) {
                for (var t = 0, r = 0; r < e.length; r++) t = t << 8 | e.charCodeAt(r);
                return t >>> 0;
              }
              function t(e) {
                f(e) || u("Malformed CMap: expected string.");
              }
              function r(e) {
                h(e) || u("Malformed CMap: expected int.");
              }
              function n(r, n) {
                for (;;) {
                  var i = n.getObj();
                  if (m(i)) break;
                  if (v(i, "endbfchar")) return;
                  t(i);
                  var a = e(i);
                  i = n.getObj(), t(i);
                  var o = i;
                  r.mapOne(a, o);
                }
              }
              function i(r, n) {
                for (;;) {
                  var i = n.getObj();
                  if (m(i)) break;
                  if (v(i, "endbfrange")) return;
                  t(i);
                  var a = e(i);
                  i = n.getObj(), t(i);
                  var o = e(i);
                  if (i = n.getObj(), h(i) || f(i)) {
                    var s = h(i) ? String.fromCharCode(i) : i;
                    r.mapBfRange(a, o, s);
                  } else {
                    if (!v(i, "[")) break;
                    i = n.getObj();
                    for (var l = []; !v(i, "]") && !m(i);) l.push(i), i = n.getObj();
                    r.mapBfRangeToArray(a, o, l);
                  }
                }
                u("Invalid bf range.");
              }
              function a(n, i) {
                for (;;) {
                  var a = i.getObj();
                  if (m(a)) break;
                  if (v(a, "endcidchar")) return;
                  t(a);
                  var o = e(a);
                  a = i.getObj(), r(a);
                  var s = a;
                  n.mapOne(o, s);
                }
              }
              function o(n, i) {
                for (;;) {
                  var a = i.getObj();
                  if (m(a)) break;
                  if (v(a, "endcidrange")) return;
                  t(a);
                  var o = e(a);
                  a = i.getObj(), t(a);
                  var s = e(a);
                  a = i.getObj(), r(a);
                  var l = a;
                  n.mapCidRange(o, s, l);
                }
              }
              function s(t, r) {
                for (;;) {
                  var n = r.getObj();
                  if (m(n)) break;
                  if (v(n, "endcodespacerange")) return;
                  if (!f(n)) break;
                  var i = e(n);
                  if (n = r.getObj(), !f(n)) break;
                  var a = e(n);
                  t.addCodespaceRange(n.length, i, a);
                }
                u("Invalid codespace range.");
              }
              function E(e, t) {
                var r = t.getObj();
                h(r) && (e.vertical = !!r);
              }
              function A(e, t) {
                var r = t.getObj();
                g(r) && f(r.name) && (e.name = r.name);
              }
              function T(e, t, r, l) {
                var u, h;
                e: for (;;) try {
                  var f = t.getObj();
                  if (m(f)) break;
                  if (g(f)) "WMode" === f.name ? E(e, t) : "CMapName" === f.name && A(e, t), u = f;else if (v(f)) switch (f.cmd) {
                    case "endcmap":
                      break e;
                    case "usecmap":
                      g(u) && (h = u.name);
                      break;
                    case "begincodespacerange":
                      s(e, t);
                      break;
                    case "beginbfchar":
                      n(e, t);
                      break;
                    case "begincidchar":
                      a(e, t);
                      break;
                    case "beginbfrange":
                      i(e, t);
                      break;
                    case "begincidrange":
                      o(e, t);
                  }
                } catch (e) {
                  if (e instanceof d) throw e;
                  c("Invalid cMap data: " + e);
                  continue;
                }
                return !l && h && (l = h), l ? k(e, r, l) : Promise.resolve(e);
              }
              function k(e, t, r) {
                return R(r, t).then(function (t) {
                  if (e.useCMap = t, 0 === e.numCodespaceRanges) {
                    for (var r = e.useCMap.codespaceRanges, n = 0; n < r.length; n++) e.codespaceRanges[n] = r[n].slice();
                    e.numCodespaceRanges = e.useCMap.numCodespaceRanges;
                  }
                  return e.useCMap.forEach(function (t, r) {
                    e.contains(t) || e.mapOne(t, e.useCMap.lookup(t));
                  }), e;
                });
              }
              function R(e, t) {
                return "Identity-H" === e ? Promise.resolve(new S(!1, 2)) : "Identity-V" === e ? Promise.resolve(new S(!0, 2)) : -1 === x.indexOf(e) ? Promise.reject(new Error("Unknown CMap name: " + e)) : (l(t, "Built-in CMap parameters are not provided."), t(e).then(function (e) {
                  var r = e.cMapData,
                    n = e.compressionType,
                    i = new _(!0);
                  if (n === p.BINARY) return new C().process(r, i, function (e) {
                    return k(i, t, e);
                  });
                  l(n === p.NONE, "TODO: Only BINARY/NONE CMap compression is currently supported.");
                  var a = new w(new y(r));
                  return T(i, a, t, null);
                }));
              }
              return {
                create: function create(e) {
                  var t = e.encoding,
                    r = e.fetchBuiltInCMap,
                    n = e.useCMap;
                  if (g(t)) return R(t.name, r);
                  if (b(t)) {
                    return T(new _(), new w(t), r, n).then(function (e) {
                      return e.isIdentityCMap ? R(e.name, r) : e;
                    });
                  }
                  return Promise.reject(new Error("Encoding required."));
                }
              };
            }();
          t.CMap = _, t.CMapFactory = E, t.IdentityCMap = S;
        }, function (e, t, r) {
          "use strict";

          var n = function () {
              function e(e, t) {
                var r = [],
                  n = !0,
                  i = !1,
                  a = void 0;
                try {
                  for (var o, s = e[Symbol.iterator](); !(n = (o = s.next()).done) && (r.push(o.value), !t || r.length !== t); n = !0);
                } catch (e) {
                  i = !0, a = e;
                } finally {
                  try {
                    !n && s.return && s.return();
                  } finally {
                    if (i) throw a;
                  }
                }
                return r;
              }
              return function (t, r) {
                if (Array.isArray(t)) return t;
                if (Symbol.iterator in Object(t)) return e(t, r);
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              };
            }(),
            i = r(0),
            a = r(1),
            o = r(2),
            s = r(20),
            l = r(6),
            c = r(17),
            u = r(18),
            h = r(27),
            f = i.OPS,
            d = i.MissingDataException,
            p = i.Util,
            m = i.assert,
            g = i.error,
            v = i.info,
            b = i.isArray,
            y = i.isArrayBuffer,
            w = i.isNum,
            x = i.isString,
            _ = i.shadow,
            S = i.stringToBytes,
            C = i.stringToPDFString,
            E = i.warn,
            A = i.isSpace,
            T = a.Dict,
            k = a.isDict,
            R = a.isName,
            I = a.isStream,
            M = o.NullStream,
            O = o.Stream,
            P = o.StreamsSequenceStream,
            B = s.Catalog,
            D = s.ObjectLoader,
            L = s.XRef,
            F = l.Linearization,
            N = c.calculateMD5,
            U = u.OperatorList,
            j = u.PartialEvaluator,
            z = h.AnnotationFactory,
            H = function () {
              function e(e, t) {
                return "display" === t && e.viewable || "print" === t && e.printable;
              }
              function t(e, t, r, n, i, a, o) {
                this.pdfManager = e, this.pageIndex = r, this.pageDict = n, this.xref = t, this.ref = i, this.fontCache = a, this.builtInCMapCache = o, this.evaluatorOptions = e.evaluatorOptions, this.resourcesPromise = null;
                var s = "p" + this.pageIndex + "_",
                  l = {
                    obj: 0
                  };
                this.idFactory = {
                  createObjId: function createObjId() {
                    return s + ++l.obj;
                  }
                };
              }
              var r = [0, 0, 612, 792];
              return t.prototype = {
                getPageProp: function getPageProp(e) {
                  return this.pageDict.get(e);
                },
                getInheritedPageProp: function getInheritedPageProp(e, t) {
                  var r = this.pageDict,
                    n = null,
                    i = 0;
                  for (t = t || !1; r;) {
                    var a = t ? r.getArray(e) : r.get(e);
                    if (void 0 !== a && (n || (n = []), n.push(a)), ++i > 100) return E("getInheritedPageProp: maximum loop count exceeded for " + e), n ? n[0] : void 0;
                    r = r.get("Parent");
                  }
                  if (n) return 1 !== n.length && k(n[0]) ? T.merge(this.xref, n) : n[0];
                },
                get content() {
                  return this.getPageProp("Contents");
                },
                get resources() {
                  return _(this, "resources", this.getInheritedPageProp("Resources") || T.empty);
                },
                get mediaBox() {
                  var e = this.getInheritedPageProp("MediaBox", !0);
                  return b(e) && 4 === e.length ? _(this, "mediaBox", e) : _(this, "mediaBox", r);
                },
                get cropBox() {
                  var e = this.getInheritedPageProp("CropBox", !0);
                  return b(e) && 4 === e.length ? _(this, "cropBox", e) : _(this, "cropBox", this.mediaBox);
                },
                get userUnit() {
                  var e = this.getPageProp("UserUnit");
                  return (!w(e) || e <= 0) && (e = 1), _(this, "userUnit", e);
                },
                get view() {
                  var e = this.mediaBox,
                    t = this.cropBox;
                  if (e === t) return _(this, "view", e);
                  var r = p.intersect(t, e);
                  return _(this, "view", r || e);
                },
                get rotate() {
                  var e = this.getInheritedPageProp("Rotate") || 0;
                  return e % 90 != 0 ? e = 0 : e >= 360 ? e %= 360 : e < 0 && (e = (e % 360 + 360) % 360), _(this, "rotate", e);
                },
                getContentStream: function getContentStream() {
                  var e,
                    t = this.content;
                  if (b(t)) {
                    var r,
                      n = this.xref,
                      i = t.length,
                      a = [];
                    for (r = 0; r < i; ++r) a.push(n.fetchIfRef(t[r]));
                    e = new P(a);
                  } else e = I(t) ? t : new M();
                  return e;
                },
                loadResources: function loadResources(e) {
                  var t = this;
                  return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(function () {
                    return new D(t.resources.map, e, t.xref).load();
                  });
                },
                getOperatorList: function getOperatorList(t) {
                  var r = this,
                    i = t.handler,
                    a = t.task,
                    o = t.intent,
                    s = t.renderInteractiveForms,
                    l = this.pdfManager.ensure(this, "getContentStream"),
                    c = this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"]),
                    u = new j({
                      pdfManager: this.pdfManager,
                      xref: this.xref,
                      handler: i,
                      pageIndex: this.pageIndex,
                      idFactory: this.idFactory,
                      fontCache: this.fontCache,
                      builtInCMapCache: this.builtInCMapCache,
                      options: this.evaluatorOptions
                    }),
                    h = Promise.all([l, c]),
                    d = h.then(function (e) {
                      var t = n(e, 1),
                        s = t[0],
                        l = new U(o, i, r.pageIndex);
                      return i.send("StartRenderPage", {
                        transparency: u.hasBlendModes(r.resources),
                        pageIndex: r.pageIndex,
                        intent: o
                      }), u.getOperatorList({
                        stream: s,
                        task: a,
                        resources: r.resources,
                        operatorList: l
                      }).then(function () {
                        return l;
                      });
                    }),
                    p = this.pdfManager.ensure(this, "annotations");
                  return Promise.all([d, p]).then(function (t) {
                    var r = n(t, 2),
                      i = r[0],
                      l = r[1];
                    if (0 === l.length) return i.flush(!0), i;
                    var c,
                      h,
                      d = [];
                    for (c = 0, h = l.length; c < h; c++) e(l[c], o) && d.push(l[c].getOperatorList(u, a, s));
                    return Promise.all(d).then(function (e) {
                      for (i.addOp(f.beginAnnotations, []), c = 0, h = e.length; c < h; c++) i.addOpList(e[c]);
                      return i.addOp(f.endAnnotations, []), i.flush(!0), i;
                    });
                  });
                },
                extractTextContent: function extractTextContent(e) {
                  var t = this,
                    r = e.handler,
                    i = e.task,
                    a = e.normalizeWhitespace,
                    o = e.combineTextItems,
                    s = this.pdfManager.ensure(this, "getContentStream"),
                    l = this.loadResources(["ExtGState", "XObject", "Font"]);
                  return Promise.all([s, l]).then(function (e) {
                    var s = n(e, 1),
                      l = s[0];
                    return new j({
                      pdfManager: t.pdfManager,
                      xref: t.xref,
                      handler: r,
                      pageIndex: t.pageIndex,
                      idFactory: t.idFactory,
                      fontCache: t.fontCache,
                      builtInCMapCache: t.builtInCMapCache,
                      options: t.evaluatorOptions
                    }).getTextContent({
                      stream: l,
                      task: i,
                      resources: t.resources,
                      normalizeWhitespace: a,
                      combineTextItems: o
                    });
                  });
                },
                getAnnotationsData: function getAnnotationsData(t) {
                  for (var r = this.annotations, n = [], i = 0, a = r.length; i < a; ++i) t && !e(r[i], t) || n.push(r[i].data);
                  return n;
                },
                get annotations() {
                  for (var e = [], t = this.getInheritedPageProp("Annots") || [], r = new z(), n = 0, i = t.length; n < i; ++n) {
                    var a = t[n],
                      o = r.create(this.xref, a, this.pdfManager, this.idFactory);
                    o && e.push(o);
                  }
                  return _(this, "annotations", e);
                }
              }, t;
            }(),
            G = function () {
              function e(e, t) {
                var r;
                I(t) ? r = t : y(t) ? r = new O(t) : g("PDFDocument: Unknown argument type"), m(r.length > 0, "stream must have data"), this.pdfManager = e, this.stream = r, this.xref = new L(r, e);
              }
              function t(e, t, r, n) {
                var i = e.pos,
                  a = e.end,
                  o = [];
                i + r > a && (r = a - i);
                for (var s = 0; s < r; ++s) o.push(String.fromCharCode(e.getByte()));
                var l = o.join("");
                e.pos = i;
                var c = n ? l.lastIndexOf(t) : l.indexOf(t);
                return -1 !== c && (e.pos += c, !0);
              }
              var r = 1024,
                n = {
                  get entries() {
                    return _(this, "entries", {
                      Title: x,
                      Author: x,
                      Subject: x,
                      Keywords: x,
                      Creator: x,
                      Producer: x,
                      CreationDate: x,
                      ModDate: x,
                      Trapped: R
                    });
                  }
                };
              return e.prototype = {
                parse: function parse(e) {
                  this.setup(e);
                  var t = this.catalog.catDict.get("Version");
                  R(t) && (this.pdfFormatVersion = t.name);
                  try {
                    if (this.acroForm = this.catalog.catDict.get("AcroForm"), this.acroForm) {
                      this.xfa = this.acroForm.get("XFA");
                      var r = this.acroForm.get("Fields");
                      r && b(r) && 0 !== r.length || this.xfa || (this.acroForm = null);
                    }
                  } catch (e) {
                    if (e instanceof d) throw e;
                    v("Something wrong with AcroForm entry"), this.acroForm = null;
                  }
                },
                get linearization() {
                  var e = null;
                  if (this.stream.length) try {
                    e = F.create(this.stream);
                  } catch (e) {
                    if (e instanceof d) throw e;
                    v(e);
                  }
                  return _(this, "linearization", e);
                },
                get startXRef() {
                  var e = this.stream,
                    r = 0;
                  if (this.linearization) e.reset(), t(e, "endobj", 1024) && (r = e.pos + 6);else {
                    for (var n = !1, i = e.end; !n && i > 0;) i -= 1024 - "startxref".length, i < 0 && (i = 0), e.pos = i, n = t(e, "startxref", 1024, !0);
                    if (n) {
                      e.skip(9);
                      var a;
                      do {
                        a = e.getByte();
                      } while (A(a));
                      for (var o = ""; a >= 32 && a <= 57;) o += String.fromCharCode(a), a = e.getByte();
                      r = parseInt(o, 10), isNaN(r) && (r = 0);
                    }
                  }
                  return _(this, "startXRef", r);
                },
                get mainXRefEntriesOffset() {
                  var e = 0,
                    t = this.linearization;
                  return t && (e = t.mainXRefEntriesOffset), _(this, "mainXRefEntriesOffset", e);
                },
                checkHeader: function checkHeader() {
                  var e = this.stream;
                  if (e.reset(), t(e, "%PDF-", 1024)) {
                    e.moveStart();
                    for (var r, n = ""; (r = e.getByte()) > 32 && !(n.length >= 12);) n += String.fromCharCode(r);
                    return void (this.pdfFormatVersion || (this.pdfFormatVersion = n.substring(5)));
                  }
                },
                parseStartXRef: function parseStartXRef() {
                  var e = this.startXRef;
                  this.xref.setStartXRef(e);
                },
                setup: function setup(e) {
                  var t = this;
                  this.xref.parse(e);
                  var r = {
                    createPage: function createPage(e, r, n, i, a) {
                      return new H(t.pdfManager, t.xref, e, r, n, i, a);
                    }
                  };
                  this.catalog = new B(this.pdfManager, this.xref, r);
                },
                get numPages() {
                  var e = this.linearization,
                    t = e ? e.numPages : this.catalog.numPages;
                  return _(this, "numPages", t);
                },
                get documentInfo() {
                  var e,
                    t = {
                      PDFFormatVersion: this.pdfFormatVersion,
                      IsAcroFormPresent: !!this.acroForm,
                      IsXFAPresent: !!this.xfa
                    };
                  try {
                    e = this.xref.trailer.get("Info");
                  } catch (e) {
                    if (e instanceof d) throw e;
                    v("The document information dictionary is invalid.");
                  }
                  if (e) {
                    var r = n.entries;
                    for (var i in r) if (e.has(i)) {
                      var a = e.get(i);
                      r[i](a) ? t[i] = "string" != typeof a ? a : C(a) : v('Bad value in document info for "' + i + '"');
                    }
                  }
                  return _(this, "documentInfo", t);
                },
                get fingerprint() {
                  var e,
                    t = this.xref,
                    n = "",
                    i = t.trailer.get("ID");
                  i && b(i) && i[0] && x(i[0]) && "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0" !== i[0] ? e = S(i[0]) : (this.stream.ensureRange && this.stream.ensureRange(0, Math.min(r, this.stream.end)), e = N(this.stream.bytes.subarray(0, r), 0, r));
                  for (var a = 0, o = e.length; a < o; a++) {
                    var s = e[a].toString(16);
                    n += 1 === s.length ? "0" + s : s;
                  }
                  return _(this, "fingerprint", n);
                },
                getPage: function getPage(e) {
                  return this.catalog.getPage(e);
                },
                cleanup: function cleanup() {
                  return this.catalog.cleanup();
                }
              }, e;
            }();
          t.Page = H, t.PDFDocument = G;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(2),
            a = r(8),
            o = r(5),
            s = r(15),
            l = n.Util,
            c = n.bytesToString,
            u = n.error,
            h = i.Stream,
            f = a.getGlyphsUnicode,
            d = o.StandardEncoding,
            p = s.CFFParser,
            m = function () {
              function e(e, t) {
                return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
              }
              function t(e, t) {
                return e[t] << 8 | e[t + 1];
              }
              function r(r, n, i) {
                var a,
                  o,
                  s,
                  l = 1 === t(r, n + 2) ? e(r, n + 8) : e(r, n + 16),
                  c = t(r, n + l);
                if (4 === c) {
                  t(r, n + l + 2);
                  var h = t(r, n + l + 6) >> 1;
                  for (o = n + l + 14, a = [], s = 0; s < h; s++, o += 2) a[s] = {
                    end: t(r, o)
                  };
                  for (o += 2, s = 0; s < h; s++, o += 2) a[s].start = t(r, o);
                  for (s = 0; s < h; s++, o += 2) a[s].idDelta = t(r, o);
                  for (s = 0; s < h; s++, o += 2) {
                    var f = t(r, o);
                    if (0 !== f) {
                      a[s].ids = [];
                      for (var d = 0, p = a[s].end - a[s].start + 1; d < p; d++) a[s].ids[d] = t(r, o + f), f += 2;
                    }
                  }
                  return a;
                }
                if (12 === c) {
                  e(r, n + l + 4);
                  var m = e(r, n + l + 12);
                  for (o = n + l + 16, a = [], s = 0; s < m; s++) a.push({
                    start: e(r, o),
                    end: e(r, o + 4),
                    idDelta: e(r, o + 8) - e(r, o)
                  }), o += 12;
                  return a;
                }
                u("not supported cmap: " + c);
              }
              function n(e, t, r, n) {
                var i = {},
                  a = new p(new h(e, t, r - t), i, n),
                  o = a.parse();
                return {
                  glyphs: o.charStrings.objects,
                  subrs: o.topDict.privateDict && o.topDict.privateDict.subrsIndex && o.topDict.privateDict.subrsIndex.objects,
                  gsubrs: o.globalSubrIndex && o.globalSubrIndex.objects
                };
              }
              function i(e, t, r) {
                var n, i;
                r ? (n = 4, i = function i(e, t) {
                  return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
                }) : (n = 2, i = function i(e, t) {
                  return e[t] << 9 | e[t + 1] << 1;
                });
                for (var a = [], o = i(t, 0), s = n; s < t.length; s += n) {
                  var l = i(t, s);
                  a.push(e.subarray(o, l)), o = l;
                }
                return a;
              }
              function a(e, t) {
                for (var r = t.charCodeAt(0), n = 0, i = 0, a = e.length - 1; i < a;) {
                  var o = i + a + 1 >> 1;
                  r < e[o].start ? a = o - 1 : i = o;
                }
                return e[i].start <= r && r <= e[i].end && (n = e[i].idDelta + (e[i].ids ? e[i].ids[r - e[i].start] : r) & 65535), {
                  charCode: r,
                  glyphId: n
                };
              }
              function o(e, t, r) {
                function n(e, r, n, i) {
                  t.push({
                    cmd: "quadraticCurveTo",
                    args: [e, r, n, i]
                  });
                }
                var i,
                  a = 0,
                  s = (e[a] << 24 | e[a + 1] << 16) >> 16,
                  l = 0,
                  c = 0;
                if (a += 10, s < 0) do {
                  i = e[a] << 8 | e[a + 1];
                  var u = e[a + 2] << 8 | e[a + 3];
                  a += 4;
                  var h, f;
                  1 & i ? (h = (e[a] << 24 | e[a + 1] << 16) >> 16, f = (e[a + 2] << 24 | e[a + 3] << 16) >> 16, a += 4) : (h = e[a++], f = e[a++]), 2 & i ? (l = h, c = f) : (l = 0, c = 0);
                  var d = 1,
                    p = 1,
                    m = 0,
                    g = 0;
                  8 & i ? (d = p = (e[a] << 24 | e[a + 1] << 16) / 1073741824, a += 2) : 64 & i ? (d = (e[a] << 24 | e[a + 1] << 16) / 1073741824, p = (e[a + 2] << 24 | e[a + 3] << 16) / 1073741824, a += 4) : 128 & i && (d = (e[a] << 24 | e[a + 1] << 16) / 1073741824, m = (e[a + 2] << 24 | e[a + 3] << 16) / 1073741824, g = (e[a + 4] << 24 | e[a + 5] << 16) / 1073741824, p = (e[a + 6] << 24 | e[a + 7] << 16) / 1073741824, a += 8);
                  var v = r.glyphs[u];
                  v && (t.push({
                    cmd: "save"
                  }), t.push({
                    cmd: "transform",
                    args: [d, m, g, p, l, c]
                  }), o(v, t, r), t.push({
                    cmd: "restore"
                  }));
                } while (32 & i);else {
                  var b,
                    y,
                    w = [];
                  for (b = 0; b < s; b++) w.push(e[a] << 8 | e[a + 1]), a += 2;
                  a += 2 + (e[a] << 8 | e[a + 1]);
                  for (var x = w[w.length - 1] + 1, _ = []; _.length < x;) {
                    i = e[a++];
                    var S = 1;
                    for (8 & i && (S += e[a++]); S-- > 0;) _.push({
                      flags: i
                    });
                  }
                  for (b = 0; b < x; b++) {
                    switch (18 & _[b].flags) {
                      case 0:
                        l += (e[a] << 24 | e[a + 1] << 16) >> 16, a += 2;
                        break;
                      case 2:
                        l -= e[a++];
                        break;
                      case 18:
                        l += e[a++];
                    }
                    _[b].x = l;
                  }
                  for (b = 0; b < x; b++) {
                    switch (36 & _[b].flags) {
                      case 0:
                        c += (e[a] << 24 | e[a + 1] << 16) >> 16, a += 2;
                        break;
                      case 4:
                        c -= e[a++];
                        break;
                      case 36:
                        c += e[a++];
                    }
                    _[b].y = c;
                  }
                  var C = 0;
                  for (a = 0; a < s; a++) {
                    var E = w[a],
                      A = _.slice(C, E + 1);
                    if (1 & A[0].flags) A.push(A[0]);else if (1 & A[A.length - 1].flags) A.unshift(A[A.length - 1]);else {
                      var T = {
                        flags: 1,
                        x: (A[0].x + A[A.length - 1].x) / 2,
                        y: (A[0].y + A[A.length - 1].y) / 2
                      };
                      A.unshift(T), A.push(T);
                    }
                    for (function (e, r) {
                      t.push({
                        cmd: "moveTo",
                        args: [e, r]
                      });
                    }(A[0].x, A[0].y), b = 1, y = A.length; b < y; b++) 1 & A[b].flags ? function (e, r) {
                      t.push({
                        cmd: "lineTo",
                        args: [e, r]
                      });
                    }(A[b].x, A[b].y) : 1 & A[b + 1].flags ? (n(A[b].x, A[b].y, A[b + 1].x, A[b + 1].y), b++) : n(A[b].x, A[b].y, (A[b].x + A[b + 1].x) / 2, (A[b].y + A[b + 1].y) / 2);
                    C = E + 1;
                  }
                }
              }
              function s(e, t, r) {
                function n(e, r) {
                  t.push({
                    cmd: "moveTo",
                    args: [e, r]
                  });
                }
                function i(e, r) {
                  t.push({
                    cmd: "lineTo",
                    args: [e, r]
                  });
                }
                function o(e, r, n, i, a, o) {
                  t.push({
                    cmd: "bezierCurveTo",
                    args: [e, r, n, i, a, o]
                  });
                }
                function l(e) {
                  for (var m = 0; m < e.length;) {
                    var g,
                      v,
                      b,
                      y,
                      w,
                      x,
                      _,
                      S,
                      C,
                      E = !1,
                      A = e[m++];
                    switch (A) {
                      case 1:
                      case 3:
                        p += c.length >> 1, E = !0;
                        break;
                      case 4:
                        f += c.pop(), n(h, f), E = !0;
                        break;
                      case 5:
                        for (; c.length > 0;) h += c.shift(), f += c.shift(), i(h, f);
                        break;
                      case 6:
                        for (; c.length > 0 && (h += c.shift(), i(h, f), 0 !== c.length);) f += c.shift(), i(h, f);
                        break;
                      case 7:
                        for (; c.length > 0 && (f += c.shift(), i(h, f), 0 !== c.length);) h += c.shift(), i(h, f);
                        break;
                      case 8:
                        for (; c.length > 0;) g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f);
                        break;
                      case 10:
                        S = c.pop() + r.subrsBias, C = r.subrs[S], C && l(C);
                        break;
                      case 11:
                        return;
                      case 12:
                        switch (A = e[m++]) {
                          case 34:
                            g = h + c.shift(), v = g + c.shift(), w = f + c.shift(), h = v + c.shift(), o(g, f, v, w, h, w), g = h + c.shift(), v = g + c.shift(), h = v + c.shift(), o(g, w, v, f, h, f);
                            break;
                          case 35:
                            g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f), g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f), c.pop();
                            break;
                          case 36:
                            g = h + c.shift(), w = f + c.shift(), v = g + c.shift(), x = w + c.shift(), h = v + c.shift(), o(g, w, v, x, h, x), g = h + c.shift(), v = g + c.shift(), _ = x + c.shift(), h = v + c.shift(), o(g, x, v, _, h, f);
                            break;
                          case 37:
                            var T = h,
                              k = f;
                            g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f), g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v, f = y, Math.abs(h - T) > Math.abs(f - k) ? h += c.shift() : f += c.shift(), o(g, b, v, y, h, f);
                            break;
                          default:
                            u("unknown operator: 12 " + A);
                        }
                        break;
                      case 14:
                        if (c.length >= 4) {
                          var R = c.pop(),
                            I = c.pop();
                          f = c.pop(), h = c.pop(), t.push({
                            cmd: "save"
                          }), t.push({
                            cmd: "translate",
                            args: [h, f]
                          });
                          var M = a(r.cmap, String.fromCharCode(r.glyphNameMap[d[R]]));
                          s(r.glyphs[M.glyphId], t, r), t.push({
                            cmd: "restore"
                          }), M = a(r.cmap, String.fromCharCode(r.glyphNameMap[d[I]])), s(r.glyphs[M.glyphId], t, r);
                        }
                        return;
                      case 18:
                        p += c.length >> 1, E = !0;
                        break;
                      case 19:
                      case 20:
                        p += c.length >> 1, m += p + 7 >> 3, E = !0;
                        break;
                      case 21:
                        f += c.pop(), h += c.pop(), n(h, f), E = !0;
                        break;
                      case 22:
                        h += c.pop(), n(h, f), E = !0;
                        break;
                      case 23:
                        p += c.length >> 1, E = !0;
                        break;
                      case 24:
                        for (; c.length > 2;) g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f);
                        h += c.shift(), f += c.shift(), i(h, f);
                        break;
                      case 25:
                        for (; c.length > 6;) h += c.shift(), f += c.shift(), i(h, f);
                        g = h + c.shift(), b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + c.shift(), o(g, b, v, y, h, f);
                        break;
                      case 26:
                        for (c.length % 2 && (h += c.shift()); c.length > 0;) g = h, b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v, f = y + c.shift(), o(g, b, v, y, h, f);
                        break;
                      case 27:
                        for (c.length % 2 && (f += c.shift()); c.length > 0;) g = h + c.shift(), b = f, v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y, o(g, b, v, y, h, f);
                        break;
                      case 28:
                        c.push((e[m] << 24 | e[m + 1] << 16) >> 16), m += 2;
                        break;
                      case 29:
                        S = c.pop() + r.gsubrsBias, C = r.gsubrs[S], C && l(C);
                        break;
                      case 30:
                        for (; c.length > 0 && (g = h, b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + (1 === c.length ? c.shift() : 0), o(g, b, v, y, h, f), 0 !== c.length);) g = h + c.shift(), b = f, v = g + c.shift(), y = b + c.shift(), f = y + c.shift(), h = v + (1 === c.length ? c.shift() : 0), o(g, b, v, y, h, f);
                        break;
                      case 31:
                        for (; c.length > 0 && (g = h + c.shift(), b = f, v = g + c.shift(), y = b + c.shift(), f = y + c.shift(), h = v + (1 === c.length ? c.shift() : 0), o(g, b, v, y, h, f), 0 !== c.length);) g = h, b = f + c.shift(), v = g + c.shift(), y = b + c.shift(), h = v + c.shift(), f = y + (1 === c.length ? c.shift() : 0), o(g, b, v, y, h, f);
                        break;
                      default:
                        A < 32 && u("unknown operator: " + A), A < 247 ? c.push(A - 139) : A < 251 ? c.push(256 * (A - 247) + e[m++] + 108) : A < 255 ? c.push(256 * -(A - 251) - e[m++] - 108) : (c.push((e[m] << 24 | e[m + 1] << 16 | e[m + 2] << 8 | e[m + 3]) / 65536), m += 4);
                    }
                    E && (c.length = 0);
                  }
                }
                var c = [],
                  h = 0,
                  f = 0,
                  p = 0;
                l(e);
              }
              function m(e) {
                this.compiledGlyphs = Object.create(null), this.compiledCharCodeToGlyphId = Object.create(null), this.fontMatrix = e;
              }
              function g(e, t, r) {
                r = r || [488e-6, 0, 0, 488e-6, 0, 0], m.call(this, r), this.glyphs = e, this.cmap = t;
              }
              function v(e, t, r, n) {
                r = r || [.001, 0, 0, .001, 0, 0], m.call(this, r), this.glyphs = e.glyphs, this.gsubrs = e.gsubrs || [], this.subrs = e.subrs || [], this.cmap = t, this.glyphNameMap = n || f(), this.gsubrsBias = this.gsubrs.length < 1240 ? 107 : this.gsubrs.length < 33900 ? 1131 : 32768, this.subrsBias = this.subrs.length < 1240 ? 107 : this.subrs.length < 33900 ? 1131 : 32768;
              }
              return m.prototype = {
                getPathJs: function getPathJs(e) {
                  var t = a(this.cmap, e),
                    r = this.compiledGlyphs[t.glyphId];
                  return r || (r = this.compileGlyph(this.glyphs[t.glyphId]), this.compiledGlyphs[t.glyphId] = r), void 0 === this.compiledCharCodeToGlyphId[t.charCode] && (this.compiledCharCodeToGlyphId[t.charCode] = t.glyphId), r;
                },
                compileGlyph: function compileGlyph(e) {
                  if (!e || 0 === e.length || 14 === e[0]) return "";
                  var t = [];
                  return t.push({
                    cmd: "save"
                  }), t.push({
                    cmd: "transform",
                    args: this.fontMatrix.slice()
                  }), t.push({
                    cmd: "scale",
                    args: ["size", "-size"]
                  }), this.compileGlyphImpl(e, t), t.push({
                    cmd: "restore"
                  }), t;
                },
                compileGlyphImpl: function compileGlyphImpl() {
                  u("Children classes should implement this.");
                },
                hasBuiltPath: function hasBuiltPath(e) {
                  var t = a(this.cmap, e);
                  return void 0 !== this.compiledGlyphs[t.glyphId] && void 0 !== this.compiledCharCodeToGlyphId[t.charCode];
                }
              }, l.inherit(g, m, {
                compileGlyphImpl: function compileGlyphImpl(e, t) {
                  o(e, t, this);
                }
              }), l.inherit(v, m, {
                compileGlyphImpl: function compileGlyphImpl(e, t) {
                  s(e, t, this);
                }
              }), {
                create: function create(a, o) {
                  for (var s, l, u, h, f, d, p = new Uint8Array(a.data), m = t(p, 4), b = 0, y = 12; b < m; b++, y += 16) {
                    var w = c(p.subarray(y, y + 4)),
                      x = e(p, y + 8),
                      _ = e(p, y + 12);
                    switch (w) {
                      case "cmap":
                        s = r(p, x, x + _);
                        break;
                      case "glyf":
                        l = p.subarray(x, x + _);
                        break;
                      case "loca":
                        u = p.subarray(x, x + _);
                        break;
                      case "head":
                        d = t(p, x + 18), f = t(p, x + 50);
                        break;
                      case "CFF ":
                        h = n(p, x, x + _, o);
                    }
                  }
                  if (l) {
                    var S = d ? [1 / d, 0, 0, 1 / d, 0, 0] : a.fontMatrix;
                    return new g(i(l, u, f), s, S);
                  }
                  return new v(h, s, a.fontMatrix, a.glyphNameMap);
                }
              };
            }();
          t.FontRendererFactory = m;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            if (e.fontMatrix && e.fontMatrix[0] !== v[0]) {
              var t = .001 / e.fontMatrix[0],
                r = e.widths;
              for (var n in r) r[n] *= t;
              e.defaultWidth *= t;
            }
          }
          function i(e, t) {
            if (!e.hasIncludedToUnicodeMap && !(e.hasEncoding || t === e.defaultEncoding || e.toUnicode instanceof pe)) {
              var r = [],
                n = P();
              for (var i in t) {
                var a = t[i],
                  o = X(a, n);
                -1 !== o && (r[i] = String.fromCharCode(o));
              }
              e.toUnicode.amend(r);
            }
          }
          function a(e, t) {
            switch (e) {
              case "Type1":
                return "Type1C" === t ? b.TYPE1C : b.TYPE1;
              case "CIDFontType0":
                return "CIDFontType0C" === t ? b.CIDFONTTYPE0C : b.CIDFONTTYPE0;
              case "OpenType":
                return b.OPENTYPE;
              case "TrueType":
                return b.TRUETYPE;
              case "CIDFontType2":
                return b.CIDFONTTYPE2;
              case "MMType1":
                return b.MMTYPE1;
              case "Type0":
                return b.TYPE0;
              default:
                return b.UNKNOWN;
            }
          }
          function o(e, t) {
            if (void 0 !== t[e]) return e;
            var r = X(e, t);
            if (-1 !== r) for (var n in t) if (t[n] === r) return n;
            return _("Unable to recover a standard glyph name for: " + e), e;
          }
          function s(e, t, r) {
            var n,
              i,
              a,
              s = Object.create(null),
              l = !!(e.flags & ue.Symbolic);
            if (e.baseEncodingName) for (a = j(e.baseEncodingName), i = 0; i < a.length; i++) n = r.indexOf(a[i]), s[i] = n >= 0 ? n : 0;else if (l) for (i in t) s[i] = t[i];else for (a = L, i = 0; i < a.length; i++) n = r.indexOf(a[i]), s[i] = n >= 0 ? n : 0;
            var c,
              u = e.differences;
            if (u) for (i in u) {
              var h = u[i];
              if (-1 === (n = r.indexOf(h))) {
                c || (c = P());
                var f = o(h, c);
                f !== h && (n = r.indexOf(f));
              }
              s[i] = n >= 0 ? n : 0;
            }
            return s;
          }
          var l = r(0),
            c = (r(1), r(2)),
            u = r(8),
            h = r(32),
            f = r(5),
            d = r(21),
            p = r(22),
            m = r(43),
            g = r(15),
            v = l.FONT_IDENTITY_MATRIX,
            b = l.FontType,
            y = l.assert,
            w = l.bytesToString,
            x = l.error,
            _ = l.info,
            S = l.isArray,
            C = l.isInt,
            E = l.isNum,
            A = l.readUint32,
            T = l.shadow,
            k = l.string32,
            R = l.warn,
            I = l.MissingDataException,
            M = l.isSpace,
            O = c.Stream,
            P = u.getGlyphsUnicode,
            B = u.getDingbatsGlyphsUnicode,
            D = h.FontRendererFactory,
            L = f.StandardEncoding,
            F = f.MacRomanEncoding,
            N = f.SymbolSetEncoding,
            U = f.ZapfDingbatsEncoding,
            j = f.getEncoding,
            z = d.getStdFontMap,
            H = d.getNonStdFontMap,
            G = d.getGlyphMapForStandardFonts,
            V = d.getSupplementalGlyphMapForArialBlack,
            q = p.getUnicodeRangeFor,
            W = p.mapSpecialUnicodeValues,
            X = p.getUnicodeForGlyph,
            Y = m.Type1Parser,
            K = g.CFFStandardStrings,
            Z = g.CFFParser,
            J = g.CFFCompiler,
            Q = g.CFF,
            $ = g.CFFHeader,
            ee = g.CFFTopDict,
            te = g.CFFPrivateDict,
            re = g.CFFStrings,
            ne = g.CFFIndex,
            ie = g.CFFCharset,
            ae = 57344,
            oe = 63743,
            se = !1,
            le = 1e3,
            ce = !1,
            ue = {
              FixedPitch: 1,
              Serif: 2,
              Symbolic: 4,
              Script: 8,
              Nonsymbolic: 32,
              Italic: 64,
              AllCap: 65536,
              SmallCap: 131072,
              ForceBold: 262144
            },
            he = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"],
            fe = function () {
              function e(e, t, r, n, i, a, o, s) {
                this.fontChar = e, this.unicode = t, this.accent = r, this.width = n, this.vmetric = i, this.operatorListId = a, this.isSpace = o, this.isInFont = s;
              }
              return e.prototype.matchesForCache = function (e, t, r, n, i, a, o, s) {
                return this.fontChar === e && this.unicode === t && this.accent === r && this.width === n && this.vmetric === i && this.operatorListId === a && this.isSpace === o && this.isInFont === s;
              }, e;
            }(),
            de = function () {
              function e(e) {
                this._map = e;
              }
              return e.prototype = {
                get length() {
                  return this._map.length;
                },
                forEach: function forEach(e) {
                  for (var t in this._map) e(t, this._map[t].charCodeAt(0));
                },
                has: function has(e) {
                  return void 0 !== this._map[e];
                },
                get: function get(e) {
                  return this._map[e];
                },
                charCodeOf: function charCodeOf(e) {
                  return this._map.indexOf(e);
                },
                amend: function amend(e) {
                  for (var t in e) this._map[t] = e[t];
                }
              }, e;
            }(),
            pe = function () {
              function e(e, t) {
                this.firstChar = e, this.lastChar = t;
              }
              return e.prototype = {
                get length() {
                  return this.lastChar + 1 - this.firstChar;
                },
                forEach: function forEach(e) {
                  for (var t = this.firstChar, r = this.lastChar; t <= r; t++) e(t, t);
                },
                has: function has(e) {
                  return this.firstChar <= e && e <= this.lastChar;
                },
                get: function get(e) {
                  if (this.firstChar <= e && e <= this.lastChar) return String.fromCharCode(e);
                },
                charCodeOf: function charCodeOf(e) {
                  return C(e) && e >= this.firstChar && e <= this.lastChar ? e : -1;
                },
                amend: function amend(e) {
                  x("Should not call amend()");
                }
              }, e;
            }(),
            me = function () {
              function e(e, t, r) {
                e[t] = r >> 8 & 255, e[t + 1] = 255 & r;
              }
              function t(e, t, r) {
                e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = 255 & r;
              }
              function r(e, t, r) {
                var n, i;
                if (r instanceof Uint8Array) e.set(r, t);else if ("string" == typeof r) for (n = 0, i = r.length; n < i; n++) e[t++] = 255 & r.charCodeAt(n);else for (n = 0, i = r.length; n < i; n++) e[t++] = 255 & r[n];
              }
              function n(e) {
                this.sfnt = e, this.tables = Object.create(null);
              }
              n.getSearchParams = function (e, t) {
                for (var r = 1, n = 0; (r ^ e) > r;) r <<= 1, n++;
                var i = r * t;
                return {
                  range: i,
                  entry: n,
                  rangeShift: t * e - i
                };
              };
              return n.prototype = {
                toArray: function toArray() {
                  var i = this.sfnt,
                    a = this.tables,
                    o = Object.keys(a);
                  o.sort();
                  var s,
                    l,
                    c,
                    u,
                    h,
                    f = o.length,
                    d = 12 + 16 * f,
                    p = [d];
                  for (s = 0; s < f; s++) {
                    u = a[o[s]];
                    d += (u.length + 3 & -4) >>> 0, p.push(d);
                  }
                  var m = new Uint8Array(d);
                  for (s = 0; s < f; s++) u = a[o[s]], r(m, p[s], u);
                  "true" === i && (i = k(65536)), m[0] = 255 & i.charCodeAt(0), m[1] = 255 & i.charCodeAt(1), m[2] = 255 & i.charCodeAt(2), m[3] = 255 & i.charCodeAt(3), e(m, 4, f);
                  var g = n.getSearchParams(f, 16);
                  for (e(m, 6, g.range), e(m, 8, g.entry), e(m, 10, g.rangeShift), d = 12, s = 0; s < f; s++) {
                    h = o[s], m[d] = 255 & h.charCodeAt(0), m[d + 1] = 255 & h.charCodeAt(1), m[d + 2] = 255 & h.charCodeAt(2), m[d + 3] = 255 & h.charCodeAt(3);
                    var v = 0;
                    for (l = p[s], c = p[s + 1]; l < c; l += 4) {
                      v = v + A(m, l) >>> 0;
                    }
                    t(m, d + 4, v), t(m, d + 8, p[s]), t(m, d + 12, a[h].length), d += 16;
                  }
                  return m;
                },
                addTable: function addTable(e, t) {
                  if (e in this.tables) throw new Error("Table " + e + " already exists");
                  this.tables[e] = t;
                }
              }, n;
            }(),
            ge = new Int32Array([0, 32, 127, 161, 173, 174, 1536, 1920, 2208, 4256, 6016, 6144, 7168, 7248, 8192, 8208, 8209, 8210, 8232, 8240, 8287, 8304, 9676, 9677, 12288, 12289, 43616, 43648, 65520, 65536]),
            ve = function () {
              function e(e, t, r) {
                var i,
                  o,
                  s,
                  l = this;
                this.name = e, this.loadedName = r.loadedName, this.isType3Font = r.isType3Font, this.sizes = [], this.missingFile = !1, this.glyphCache = Object.create(null), this.isSerifFont = !!(r.flags & ue.Serif), this.isSymbolicFont = !!(r.flags & ue.Symbolic), this.isMonospace = !!(r.flags & ue.FixedPitch);
                var c = r.type,
                  p = r.subtype;
                if (this.type = c, this.fallbackName = this.isMonospace ? "monospace" : this.isSerifFont ? "serif" : "sans-serif", this.differences = r.differences, this.widths = r.widths, this.defaultWidth = r.defaultWidth, this.composite = r.composite, this.wideChars = r.wideChars, this.cMap = r.cMap, this.ascent = r.ascent / le, this.descent = r.descent / le, this.fontMatrix = r.fontMatrix, this.bbox = r.bbox, this.toUnicode = r.toUnicode, this.toFontChar = [], "Type3" === r.type) {
                  for (i = 0; i < 256; i++) this.toFontChar[i] = this.differences[i] || r.defaultEncoding[i];
                  return void (this.fontType = b.TYPE3);
                }
                this.cidEncoding = r.cidEncoding, this.vertical = r.vertical, this.vertical && (this.vmetrics = r.vmetrics, this.defaultVMetrics = r.defaultVMetrics);
                var m;
                if (!t || t.isEmpty) {
                  t && R('Font file is empty in "' + e + '" (' + this.loadedName + ")"), this.missingFile = !0;
                  var g = e.replace(/[,_]/g, "-"),
                    v = z(),
                    y = H(),
                    w = !!v[g] || !(!y[g] || !v[y[g]]);
                  if (g = v[g] || y[g] || g, this.bold = -1 !== g.search(/bold/gi), this.italic = -1 !== g.search(/oblique/gi) || -1 !== g.search(/italic/gi), this.black = -1 !== e.search(/Black/g), this.remeasure = Object.keys(this.widths).length > 0, w && "CIDFontType2" === c && 0 === r.cidEncoding.indexOf("Identity-")) {
                    var S = G(),
                      C = [];
                    for (i in S) C[+i] = S[i];
                    if (/Arial-?Black/i.test(e)) {
                      var E = V();
                      for (i in E) C[+i] = E[i];
                    }
                    this.toUnicode instanceof pe || this.toUnicode.forEach(function (e, t) {
                      C[+e] = t;
                    }), this.toFontChar = C, this.toUnicode = new de(C);
                  } else /Symbol/i.test(g) ? this.toFontChar = d(N, P(), r.differences) : /Dingbats/i.test(g) ? (/Wingdings/i.test(e) && R("Non-embedded Wingdings font, falling back to ZapfDingbats."), this.toFontChar = d(U, B(), r.differences)) : w ? this.toFontChar = d(r.defaultEncoding, P(), r.differences) : (m = P(), this.toUnicode.forEach(function (e, t) {
                    l.composite || (o = r.differences[e] || r.defaultEncoding[e], -1 !== (s = X(o, m)) && (t = s)), l.toFontChar[e] = t;
                  }));
                  return this.loadedName = g.split("-")[0], this.loading = !1, void (this.fontType = a(c, p));
                }
                "Type1C" === p && ("Type1" !== c && "MMType1" !== c ? u(t) ? p = "TrueType" : c = "Type1" : h(t) && (c = p = "OpenType")), "CIDFontType0C" === p && "CIDFontType0" !== c && (c = "CIDFontType0"), "OpenType" === p && (c = "OpenType"), "CIDFontType0" === c && (f(t) ? p = "CIDFontType0" : h(t) ? c = p = "OpenType" : p = "CIDFontType0C");
                var A;
                switch (c) {
                  case "MMType1":
                    _("MMType1 font (" + e + "), falling back to Type1.");
                  case "Type1":
                  case "CIDFontType0":
                    this.mimetype = "font/opentype";
                    var T = "Type1C" === p || "CIDFontType0C" === p ? new we(t, r) : new ye(e, t, r);
                    n(r), A = this.convert(e, T, r);
                    break;
                  case "OpenType":
                  case "TrueType":
                  case "CIDFontType2":
                    this.mimetype = "font/opentype", A = this.checkAndRepair(e, t, r), this.isOpenType && (n(r), c = "OpenType");
                    break;
                  default:
                    x("Font " + c + " is not supported");
                }
                this.data = A, this.fontType = a(c, p), this.fontMatrix = r.fontMatrix, this.widths = r.widths, this.defaultWidth = r.defaultWidth, this.toUnicode = r.toUnicode, this.encoding = r.baseEncoding, this.seacMap = r.seacMap, this.loading = !0;
              }
              function t(e, t) {
                return (e << 8) + t;
              }
              function r(e, t) {
                var r = (e << 8) + t;
                return 32768 & r ? r - 65536 : r;
              }
              function s(e, t, r, n) {
                return (e << 24) + (t << 16) + (r << 8) + n;
              }
              function l(e) {
                return String.fromCharCode(e >> 8 & 255, 255 & e);
              }
              function c(e) {
                return e = e > 32767 ? 32767 : e < -32768 ? -32768 : e, String.fromCharCode(e >> 8 & 255, 255 & e);
              }
              function u(e) {
                var t = e.peekBytes(4);
                return 65536 === A(t, 0);
              }
              function h(e) {
                var t = e.peekBytes(4);
                return "OTTO" === w(t);
              }
              function f(e) {
                var t = e.peekBytes(2);
                return 37 === t[0] && 33 === t[1] || 128 === t[0] && 1 === t[1];
              }
              function d(e, t, r) {
                for (var n, i = [], a = 0, o = e.length; a < o; a++) -1 !== (n = X(e[a], t)) && (i[a] = n);
                for (var s in r) -1 !== (n = X(r[s], t)) && (i[+s] = n);
                return i;
              }
              function p(e) {
                for (var t = 0, r = ge.length - 1; t < r;) {
                  var n = t + r + 1 >> 1;
                  e < ge[n] ? r = n - 1 : t = n;
                }
                return !(1 & t);
              }
              function m(e, t) {
                var r = t.toUnicode,
                  n = !!(t.flags & ue.Symbolic),
                  i = t.toUnicode instanceof pe,
                  a = Object.create(null),
                  o = [],
                  s = [],
                  l = ae;
                for (var c in e) {
                  c |= 0;
                  var u = e[c],
                    h = c,
                    f = !1;
                  if (!i && r.has(c)) {
                    f = !0;
                    var d = r.get(h);
                    1 === d.length && (h = d.charCodeAt(0));
                  }
                  if ((void 0 !== s[h] || p(h) || n && !f) && l <= oe) do {
                    h = l++, se && 61440 === h && (h = 61472, l = h + 1);
                  } while (void 0 !== s[h] && l <= oe);
                  a[h] = u, o[c] = h, s[h] = !0;
                }
                return {
                  toFontChar: o,
                  charCodeToGlyphId: a,
                  nextAvailableFontCharCode: l
                };
              }
              function g(e, t) {
                var r = [];
                for (var n in e) e[n] >= t || r.push({
                  fontCharCode: 0 | n,
                  glyphId: e[n]
                });
                r.sort(function (e, t) {
                  return e.fontCharCode - t.fontCharCode;
                });
                for (var i = [], a = r.length, o = 0; o < a;) {
                  var s = r[o].fontCharCode,
                    l = [r[o].glyphId];
                  ++o;
                  for (var c = s; o < a && c + 1 === r[o].fontCharCode && (l.push(r[o].glyphId), ++c, ++o, 65535 !== c););
                  i.push([s, c, l]);
                }
                return i;
              }
              function S(e, t) {
                var r,
                  n,
                  i,
                  a,
                  o = g(e, t),
                  s = o[o.length - 1][1] > 65535 ? 2 : 1,
                  c = "\0\0" + l(s) + "\0\0" + k(4 + 8 * s);
                for (r = o.length - 1; r >= 0 && !(o[r][0] <= 65535); --r);
                var u = r + 1;
                o[r][0] < 65535 && 65535 === o[r][1] && (o[r][1] = 65534);
                var h,
                  f,
                  d,
                  p,
                  m = o[r][1] < 65535 ? 1 : 0,
                  v = u + m,
                  b = me.getSearchParams(v, 2),
                  y = "",
                  w = "",
                  x = "",
                  _ = "",
                  S = "",
                  C = 0;
                for (r = 0, n = u; r < n; r++) {
                  h = o[r], f = h[0], d = h[1], y += l(f), w += l(d), p = h[2];
                  var E = !0;
                  for (i = 1, a = p.length; i < a; ++i) if (p[i] !== p[i - 1] + 1) {
                    E = !1;
                    break;
                  }
                  if (E) {
                    x += l(p[0] - f & 65535), _ += l(0);
                  } else {
                    var A = 2 * (v - r) + 2 * C;
                    for (C += d - f + 1, x += l(0), _ += l(A), i = 0, a = p.length; i < a; ++i) S += l(p[i]);
                  }
                }
                m > 0 && (w += "ÿÿ", y += "ÿÿ", x += "\0", _ += "\0\0");
                var T = "\0\0" + l(2 * v) + l(b.range) + l(b.entry) + l(b.rangeShift) + w + "\0\0" + y + x + _ + S,
                  R = "",
                  I = "";
                if (s > 1) {
                  for (c += "\0\0\n" + k(4 + 8 * s + 4 + T.length), R = "", r = 0, n = o.length; r < n; r++) {
                    h = o[r], f = h[0], p = h[2];
                    var M = p[0];
                    for (i = 1, a = p.length; i < a; ++i) p[i] !== p[i - 1] + 1 && (d = h[0] + i - 1, R += k(f) + k(d) + k(M), f = d + 1, M = p[i]);
                    R += k(f) + k(h[1]) + k(M);
                  }
                  I = "\0\f\0\0" + k(R.length + 16) + "\0\0\0\0" + k(R.length / 12);
                }
                return c + "\0" + l(T.length + 4) + T + I + R;
              }
              function C(e) {
                var t = new O(e.data),
                  r = t.getUint16();
                t.getBytes(60);
                var n = t.getUint16();
                return !(r < 4 && 768 & n) && !(t.getUint16() > t.getUint16()) && (t.getBytes(6), 0 !== t.getUint16() && (e.data[8] = e.data[9] = 0, !0));
              }
              function I(e, t, r) {
                r = r || {
                  unitsPerEm: 0,
                  yMax: 0,
                  yMin: 0,
                  ascent: 0,
                  descent: 0
                };
                var n = 0,
                  i = 0,
                  a = 0,
                  o = 0,
                  s = null,
                  c = 0;
                if (t) for (var u in t) {
                  u |= 0, (s > u || !s) && (s = u), c < u && (c = u);
                  var h = q(u);
                  h < 32 ? n |= 1 << h : h < 64 ? i |= 1 << h - 32 : h < 96 ? a |= 1 << h - 64 : h < 123 ? o |= 1 << h - 96 : x("Unicode ranges Bits > 123 are reserved for internal usage");
                } else s = 0, c = 255;
                var f = e.bbox || [0, 0, 0, 0],
                  d = r.unitsPerEm || 1 / (e.fontMatrix || v)[0],
                  p = e.ascentScaled ? 1 : d / le,
                  m = r.ascent || Math.round(p * (e.ascent || f[3])),
                  g = r.descent || Math.round(p * (e.descent || f[1]));
                g > 0 && e.descent > 0 && f[1] < 0 && (g = -g);
                var b = r.yMax || m,
                  y = -r.yMin || -g;
                return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(e.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + k(n) + k(i) + k(a) + k(o) + "*21*" + l(e.italicAngle ? 1 : 0) + l(s || e.firstChar) + l(c || e.lastChar) + l(m) + l(g) + "\0d" + l(b) + l(y) + "\0\0\0\0\0\0\0\0" + l(e.xHeight) + l(e.capHeight) + l(0) + l(s || e.firstChar) + "\0";
              }
              function M(e) {
                var t = Math.floor(e.italicAngle * Math.pow(2, 16));
                return "\0\0\0" + k(t) + "\0\0\0\0" + k(e.fixedPitch) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
              }
              function Y(e, t) {
                t || (t = [[], []]);
                var r,
                  n,
                  i,
                  a,
                  o,
                  s = [t[0][0] || "Original licence", t[0][1] || e, t[0][2] || "Unknown", t[0][3] || "uniqueID", t[0][4] || e, t[0][5] || "Version 0.11", t[0][6] || "", t[0][7] || "Unknown", t[0][8] || "Unknown", t[0][9] || "Unknown"],
                  c = [];
                for (r = 0, n = s.length; r < n; r++) {
                  o = t[1][r] || s[r];
                  var u = [];
                  for (i = 0, a = o.length; i < a; i++) u.push(l(o.charCodeAt(i)));
                  c.push(u.join(""));
                }
                var h = [s, c],
                  f = ["\0", "\0"],
                  d = ["\0\0", "\0"],
                  p = ["\0\0", "\t"],
                  m = s.length * f.length,
                  g = "\0\0" + l(m) + l(12 * m + 6),
                  v = 0;
                for (r = 0, n = f.length; r < n; r++) {
                  var b = h[r];
                  for (i = 0, a = b.length; i < a; i++) {
                    o = b[i];
                    g += f[r] + d[r] + p[r] + l(i) + l(o.length) + l(v), v += o.length;
                  }
                }
                return g += s.join("") + c.join("");
              }
              return e.getFontID = function () {
                var e = 1;
                return function () {
                  return String(e++);
                };
              }(), e.prototype = {
                name: null,
                font: null,
                mimetype: null,
                encoding: null,
                get renderer() {
                  var e = D.create(this, ce);
                  return T(this, "renderer", e);
                },
                exportData: function exportData() {
                  var e = {};
                  for (var t in this) this.hasOwnProperty(t) && (e[t] = this[t]);
                  return e;
                },
                checkAndRepair: function checkAndRepair(e, i, a) {
                  function l(e, t, r, n, i, a) {
                    if (r - t <= 12) return 0;
                    var o = e.subarray(t, r),
                      s = o[0] << 8 | o[1];
                    if (32768 & s) return n.set(o, i), o.length;
                    var l,
                      c = 10,
                      u = 0;
                    for (l = 0; l < s; l++) {
                      u = (o[c] << 8 | o[c + 1]) + 1, c += 2;
                    }
                    var h = c,
                      f = o[c] << 8 | o[c + 1];
                    c += 2 + f;
                    var d = c,
                      p = 0;
                    for (l = 0; l < u; l++) {
                      var m = o[c++];
                      192 & m && (o[c - 1] = 63 & m);
                      var g = (2 & m ? 1 : 16 & m ? 0 : 2) + (4 & m ? 1 : 32 & m ? 0 : 2);
                      if (p += g, 8 & m) {
                        var v = o[c++];
                        l += v, p += v * g;
                      }
                    }
                    if (0 === p) return 0;
                    var b = c + p;
                    return b > o.length ? 0 : !a && f > 0 ? (n.set(o.subarray(0, h), i), n.set([0, 0], i + h), n.set(o.subarray(d, b), i + h + 2), b -= f, o.length - b > 3 && (b = b + 3 & -4), b) : o.length - b > 3 ? (b = b + 3 & -4, n.set(o.subarray(0, b), i), b) : (n.set(o, i), o.length);
                  }
                  function c(e, t) {
                    for (var r, n, i, a, o, s = e.data, l = 0, c = 0, u = 0, f = [], p = [], m = [], g = t.tooComplexToFollowFunctions, v = !1, b = 0, y = 0, w = s.length; l < w;) {
                      var x = s[l++];
                      if (64 === x) {
                        if (n = s[l++], v || y) l += n;else for (r = 0; r < n; r++) f.push(s[l++]);
                      } else if (65 === x) {
                        if (n = s[l++], v || y) l += 2 * n;else for (r = 0; r < n; r++) i = s[l++], f.push(i << 8 | s[l++]);
                      } else if (176 == (248 & x)) {
                        if (n = x - 176 + 1, v || y) l += n;else for (r = 0; r < n; r++) f.push(s[l++]);
                      } else if (184 == (248 & x)) {
                        if (n = x - 184 + 1, v || y) l += 2 * n;else for (r = 0; r < n; r++) i = s[l++], f.push(i << 8 | s[l++]);
                      } else if (43 !== x || g) {
                        if (44 !== x || g) {
                          if (45 === x) {
                            if (v) v = !1, c = l;else {
                              if (!(o = p.pop())) return R("TT: ENDF bad stack"), void (t.hintsValid = !1);
                              a = m.pop(), s = o.data, l = o.i, t.functionsStackDeltas[a] = f.length - o.stackTop;
                            }
                          } else if (137 === x) (v || y) && (R("TT: nested IDEFs not allowed"), g = !0), v = !0, u = l;else if (88 === x) ++b;else if (27 === x) y = b;else if (89 === x) y === b && (y = 0), --b;else if (28 === x && !v && !y) {
                            var _ = f[f.length - 1];
                            _ > 0 && (l += _ - 1);
                          }
                        } else (v || y) && (R("TT: nested FDEFs not allowed"), g = !0), v = !0, u = l, a = f.pop(), t.functionsDefined[a] = {
                          data: s,
                          i: l
                        };
                      } else if (!v && !y) if (a = f[f.length - 1], t.functionsUsed[a] = !0, a in t.functionsStackDeltas) f.length += t.functionsStackDeltas[a];else if (a in t.functionsDefined && m.indexOf(a) < 0) {
                        if (p.push({
                          data: s,
                          i: l,
                          stackTop: f.length - 1
                        }), m.push(a), !(o = t.functionsDefined[a])) return R("TT: CALL non-existent function"), void (t.hintsValid = !1);
                        s = o.data, l = o.i;
                      }
                      if (!v && !y) {
                        var S = x <= 142 ? d[x] : x >= 192 && x <= 223 ? -1 : x >= 224 ? -2 : 0;
                        for (x >= 113 && x <= 117 && (n = f.pop(), isNaN(n) || (S = 2 * -n)); S < 0 && f.length > 0;) f.pop(), S++;
                        for (; S > 0;) f.push(NaN), S--;
                      }
                    }
                    t.tooComplexToFollowFunctions = g;
                    var C = [s];
                    l > s.length && C.push(new Uint8Array(l - s.length)), u > c && (R("TT: complementing a missing function tail"), C.push(new Uint8Array([34, 45]))), h(e, C);
                  }
                  function u(e, t) {
                    if (!e.tooComplexToFollowFunctions) {
                      if (e.functionsDefined.length > t) return R("TT: more functions defined than expected"), void (e.hintsValid = !1);
                      for (var r = 0, n = e.functionsUsed.length; r < n; r++) {
                        if (r > t) return R("TT: invalid function id: " + r), void (e.hintsValid = !1);
                        if (e.functionsUsed[r] && !e.functionsDefined[r]) return R("TT: undefined function: " + r), void (e.hintsValid = !1);
                      }
                    }
                  }
                  function h(e, t) {
                    if (t.length > 1) {
                      var r,
                        n,
                        i = 0;
                      for (r = 0, n = t.length; r < n; r++) i += t[r].length;
                      i = i + 3 & -4;
                      var a = new Uint8Array(i),
                        o = 0;
                      for (r = 0, n = t.length; r < n; r++) a.set(t[r], o), o += t[r].length;
                      e.data = a, e.length = i;
                    }
                  }
                  function f(e, t, r) {
                    return !V[e] || !!(!ee && t >= 0 && Q.has(t)) || !!($ && r >= 0 && E($[r]));
                  }
                  var d = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
                  i = new O(new Uint8Array(i.getBytes()));
                  var p,
                    g,
                    v = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "],
                    b = function (e) {
                      return {
                        version: w(e.getBytes(4)),
                        numTables: e.getUint16(),
                        searchRange: e.getUint16(),
                        entrySelector: e.getUint16(),
                        rangeShift: e.getUint16()
                      };
                    }(i),
                    A = b.numTables,
                    T = Object.create(null);
                  T["OS/2"] = null, T.cmap = null, T.head = null, T.hhea = null, T.hmtx = null, T.maxp = null, T.name = null, T.post = null;
                  for (var k, B = 0; B < A; B++) k = function (e) {
                    var t = w(e.getBytes(4)),
                      r = e.getInt32() >>> 0,
                      n = e.getInt32() >>> 0,
                      i = e.getInt32() >>> 0,
                      a = e.pos;
                    e.pos = e.start ? e.start : 0, e.skip(n);
                    var o = e.getBytes(i);
                    return e.pos = a, "head" === t && (o[8] = o[9] = o[10] = o[11] = 0, o[17] |= 32), {
                      tag: t,
                      checksum: r,
                      length: i,
                      offset: n,
                      data: o
                    };
                  }(i), v.indexOf(k.tag) < 0 || 0 !== k.length && (T[k.tag] = k);
                  var D = !T["CFF "];
                  if (D) T.loca || x('Required "loca" table is not found'), T.glyf || (R('Required "glyf" table is not found -- trying to recover.'), T.glyf = {
                    tag: "glyf",
                    data: new Uint8Array(0)
                  }), this.isOpenType = !1;else {
                    if ("OTTO" === b.version && !a.composite || !T.head || !T.hhea || !T.maxp || !T.post) return g = new O(T["CFF "].data), p = new we(g, a), n(a), this.convert(e, p, a);
                    delete T.glyf, delete T.loca, delete T.fpgm, delete T.prep, delete T["cvt "], this.isOpenType = !0;
                  }
                  T.maxp || x('Required "maxp" table is not found'), i.pos = (i.start || 0) + T.maxp.offset;
                  var N = i.getInt32(),
                    U = i.getUint16(),
                    z = 0;
                  if (N >= 65536 && T.maxp.length >= 22) {
                    i.pos += 8;
                    i.getUint16() > 2 && (T.maxp.data[14] = 0, T.maxp.data[15] = 2), i.pos += 4, z = i.getUint16();
                  }
                  var H = !1;
                  "CIDFontType2" === a.type && a.toUnicode && a.toUnicode.get(0) > "\0" && (H = !0, U++, T.maxp.data[4] = U >> 8, T.maxp.data[5] = 255 & U);
                  var G = function (e, t, r, n) {
                    var i = {
                      functionsDefined: [],
                      functionsUsed: [],
                      functionsStackDeltas: [],
                      tooComplexToFollowFunctions: !1,
                      hintsValid: !0
                    };
                    if (e && c(e, i), t && c(t, i), e && u(i, n), r && 1 & r.length) {
                      var a = new Uint8Array(r.length + 1);
                      a.set(r.data), r.data = a;
                    }
                    return i.hintsValid;
                  }(T.fpgm, T.prep, T["cvt "], z);
                  G || (delete T.fpgm, delete T.prep, delete T["cvt "]), function (e, t, r, n) {
                    if (!t) return void (r && (r.data = null));
                    e.pos = (e.start ? e.start : 0) + t.offset, e.pos += t.length - 2;
                    var i = e.getUint16();
                    i > n && (_("The numOfMetrics (" + i + ") should not be greater than the numGlyphs (" + n + ")"), i = n, t.data[34] = (65280 & i) >> 8, t.data[35] = 255 & i);
                    var a = n - i,
                      o = a - (r.length - 4 * i >> 1);
                    if (o > 0) {
                      var s = new Uint8Array(r.length + 2 * o);
                      s.set(r.data), r.data = s;
                    }
                  }(i, T.hhea, T.hmtx, U), T.head || x('Required "head" table is not found'), function (e, r, n) {
                    var i = e.data,
                      a = s(i[0], i[1], i[2], i[3]);
                    a >> 16 != 1 && (_("Attempting to fix invalid version in head table: " + a), i[0] = 0, i[1] = 1, i[2] = 0, i[3] = 0);
                    var o = t(i[50], i[51]);
                    if (o < 0 || o > 1) {
                      _("Attempting to fix invalid indexToLocFormat in head table: " + o);
                      var l = r + 1;
                      n === l << 1 ? (i[50] = 0, i[51] = 0) : n === l << 2 ? (i[50] = 0, i[51] = 1) : R("Could not fix indexToLocFormat: " + o);
                    }
                  }(T.head, U, D ? T.loca.length : 0);
                  var V = Object.create(null);
                  if (D) {
                    var q = t(T.head.data[50], T.head.data[51]);
                    V = function (e, t, r, n, i, a) {
                      var o, s, c;
                      n ? (o = 4, s = function s(e, t) {
                        return e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3];
                      }, c = function c(e, t, r) {
                        e[t] = r >>> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = 255 & r;
                      }) : (o = 2, s = function s(e, t) {
                        return e[t] << 9 | e[t + 1] << 1;
                      }, c = function c(e, t, r) {
                        e[t] = r >> 9 & 255, e[t + 1] = r >> 1 & 255;
                      });
                      var u = e.data,
                        h = o * (1 + r);
                      u.length !== h && (u = new Uint8Array(h), u.set(e.data.subarray(0, h)), e.data = u);
                      var f = t.data,
                        d = f.length,
                        p = new Uint8Array(d),
                        m = s(u, 0),
                        g = 0,
                        v = Object.create(null);
                      c(u, 0, g);
                      var b, y;
                      for (b = 0, y = o; b < r; b++, y += o) {
                        var w = s(u, y);
                        if (w > d && (d + 3 & -4) === w && (w = d), w > d) c(u, y, g), m = w;else {
                          m === w && (v[b] = !0);
                          g += l(f, m, w, p, g, i), c(u, y, g), m = w;
                        }
                      }
                      if (0 === g) {
                        var x = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                        for (b = 0, y = o; b < r; b++, y += o) c(u, y, x.length);
                        return t.data = x, v;
                      }
                      if (a) {
                        var _ = s(u, o);
                        p.length > _ + g ? t.data = p.subarray(0, _ + g) : (t.data = new Uint8Array(_ + g), t.data.set(p.subarray(0, g))), t.data.set(p.subarray(0, _), g), c(e.data, u.length - o, g + _);
                      } else t.data = p.subarray(0, g);
                      return v;
                    }(T.loca, T.glyf, U, q, G, H);
                  }
                  T.hhea || x('Required "hhea" table is not found'), 0 === T.hhea.data[10] && 0 === T.hhea.data[11] && (T.hhea.data[10] = 255, T.hhea.data[11] = 255);
                  var W = {
                    unitsPerEm: t(T.head.data[18], T.head.data[19]),
                    yMax: t(T.head.data[42], T.head.data[43]),
                    yMin: r(T.head.data[38], T.head.data[39]),
                    ascent: t(T.hhea.data[4], T.hhea.data[5]),
                    descent: r(T.hhea.data[6], T.hhea.data[7])
                  };
                  if (this.ascent = W.ascent / W.unitsPerEm, this.descent = W.descent / W.unitsPerEm, T.post) {
                    (function (e, t, r) {
                      var n = (i.start ? i.start : 0) + e.offset;
                      i.pos = n;
                      var a = e.length,
                        o = n + a,
                        s = i.getInt32();
                      i.getBytes(28);
                      var l,
                        c,
                        u = !0;
                      switch (s) {
                        case 65536:
                          l = he;
                          break;
                        case 131072:
                          var h = i.getUint16();
                          if (h !== r) {
                            u = !1;
                            break;
                          }
                          var f = [];
                          for (c = 0; c < h; ++c) {
                            var d = i.getUint16();
                            if (d >= 32768) {
                              u = !1;
                              break;
                            }
                            f.push(d);
                          }
                          if (!u) break;
                          for (var p = [], m = []; i.pos < o;) {
                            var g = i.getByte();
                            for (m.length = g, c = 0; c < g; ++c) m[c] = String.fromCharCode(i.getByte());
                            p.push(m.join(""));
                          }
                          for (l = [], c = 0; c < h; ++c) {
                            var v = f[c];
                            v < 258 ? l.push(he[v]) : l.push(p[v - 258]);
                          }
                          break;
                        case 196608:
                          break;
                        default:
                          R("Unknown/unsupported post table version " + s), u = !1, t.defaultEncoding && (l = t.defaultEncoding);
                      }
                      return t.glyphNames = l, u;
                    })(T.post, a, U) || (T.post = null);
                  }
                  var X,
                    K = [],
                    Q = a.toUnicode,
                    $ = a.widths,
                    ee = Q instanceof pe || 65536 === Q.length;
                  if (a.composite) {
                    var te = a.cidToGidMap || [],
                      re = 0 === te.length;
                    a.cMap.forEach(function (e, t) {
                      y(t <= 65535, "Max size of CID is 65,535");
                      var r = -1;
                      re ? r = t : void 0 !== te[t] && (r = te[t]), r >= 0 && r < U && f(r, e, t) && (K[e] = r);
                    }), !H || !re && K[0] || (K[0] = U - 1);
                  } else {
                    var ne = function (e, t, r, n) {
                        if (!e) return R("No cmap table available."), {
                          platformId: -1,
                          encodingId: -1,
                          mappings: [],
                          hasShortCmap: !1
                        };
                        var i,
                          a = (t.start ? t.start : 0) + e.offset;
                        t.pos = a, t.getUint16();
                        for (var o, s = t.getUint16(), l = !1, c = 0; c < s; c++) {
                          var u = t.getUint16(),
                            h = t.getUint16(),
                            f = t.getInt32() >>> 0,
                            d = !1;
                          if (0 === u && 0 === h ? d = !0 : 1 === u && 0 === h ? d = !0 : 3 !== u || 1 !== h || !n && o ? r && 3 === u && 0 === h && (d = !0, l = !0) : (d = !0, r || (l = !0)), d && (o = {
                            platformId: u,
                            encodingId: h,
                            offset: f
                          }), l) break;
                        }
                        if (o && (t.pos = a + o.offset), !o || -1 === t.peekByte()) return R("Could not find a preferred cmap table."), {
                          platformId: -1,
                          encodingId: -1,
                          mappings: [],
                          hasShortCmap: !1
                        };
                        var p = t.getUint16();
                        t.getUint16(), t.getUint16();
                        var m,
                          g,
                          v = !1,
                          b = [];
                        if (0 === p) {
                          for (m = 0; m < 256; m++) {
                            var y = t.getByte();
                            y && b.push({
                              charCode: m,
                              glyphId: y
                            });
                          }
                          v = !0;
                        } else if (4 === p) {
                          var w = t.getUint16() >> 1;
                          t.getBytes(6);
                          var x,
                            _ = [];
                          for (x = 0; x < w; x++) _.push({
                            end: t.getUint16()
                          });
                          for (t.getUint16(), x = 0; x < w; x++) _[x].start = t.getUint16();
                          for (x = 0; x < w; x++) _[x].delta = t.getUint16();
                          var S = 0;
                          for (x = 0; x < w; x++) {
                            i = _[x];
                            var C = t.getUint16();
                            if (C) {
                              var E = (C >> 1) - (w - x);
                              i.offsetIndex = E, S = Math.max(S, E + i.end - i.start + 1);
                            } else i.offsetIndex = -1;
                          }
                          var A = [];
                          for (m = 0; m < S; m++) A.push(t.getUint16());
                          for (x = 0; x < w; x++) {
                            i = _[x], a = i.start;
                            var T = i.end,
                              k = i.delta;
                            for (E = i.offsetIndex, m = a; m <= T; m++) 65535 !== m && (g = E < 0 ? m : A[E + m - a], g = g + k & 65535, b.push({
                              charCode: m,
                              glyphId: g
                            }));
                          }
                        } else {
                          if (6 !== p) return R("cmap table has unsupported format: " + p), {
                            platformId: -1,
                            encodingId: -1,
                            mappings: [],
                            hasShortCmap: !1
                          };
                          var I = t.getUint16(),
                            M = t.getUint16();
                          for (m = 0; m < M; m++) {
                            g = t.getUint16();
                            var O = I + m;
                            b.push({
                              charCode: O,
                              glyphId: g
                            });
                          }
                        }
                        for (b.sort(function (e, t) {
                          return e.charCode - t.charCode;
                        }), c = 1; c < b.length; c++) b[c - 1].charCode === b[c].charCode && (b.splice(c, 1), c--);
                        return {
                          platformId: o.platformId,
                          encodingId: o.encodingId,
                          mappings: b,
                          hasShortCmap: v
                        };
                      }(T.cmap, i, this.isSymbolicFont, a.hasEncoding),
                      ie = ne.platformId,
                      ae = ne.encodingId,
                      oe = ne.mappings,
                      se = oe.length;
                    if (a.hasEncoding && (3 === ie && 1 === ae || 1 === ie && 0 === ae) || -1 === ie && -1 === ae && j(a.baseEncodingName)) {
                      var le = [];
                      "MacRomanEncoding" !== a.baseEncodingName && "WinAnsiEncoding" !== a.baseEncodingName || (le = j(a.baseEncodingName));
                      var ue = P();
                      for (X = 0; X < 256; X++) {
                        var fe, de;
                        if (fe = this.differences && X in this.differences ? this.differences[X] : X in le && "" !== le[X] ? le[X] : L[X]) {
                          de = o(fe, ue);
                          var ge,
                            ve = !1;
                          3 === ie && 1 === ae ? (ge = ue[de], ve = !0) : 1 === ie && 0 === ae && (ge = F.indexOf(de));
                          var be = !1;
                          for (B = 0; B < se; ++B) if (oe[B].charCode === ge) {
                            var ye = ve ? X : ge;
                            if (f(oe[B].glyphId, ye, -1)) {
                              K[X] = oe[B].glyphId, be = !0;
                              break;
                            }
                          }
                          if (!be && a.glyphNames) {
                            var xe = a.glyphNames.indexOf(fe);
                            -1 === xe && de !== fe && (xe = a.glyphNames.indexOf(de)), xe > 0 && f(xe, -1, -1) && (K[X] = xe, be = !0);
                          }
                          be || (K[X] = 0);
                        }
                      }
                    } else if (0 === ie && 0 === ae) for (B = 0; B < se; ++B) K[oe[B].charCode] = oe[B].glyphId;else for (B = 0; B < se; ++B) X = 255 & oe[B].charCode, K[X] = oe[B].glyphId;
                  }
                  0 === K.length && (K[0] = 0);
                  var _e = m(K, a);
                  if (this.toFontChar = _e.toFontChar, T.cmap = {
                    tag: "cmap",
                    data: S(_e.charCodeToGlyphId, U)
                  }, T["OS/2"] && C(T["OS/2"]) || (T["OS/2"] = {
                    tag: "OS/2",
                    data: I(a, _e.charCodeToGlyphId, W)
                  }), T.post || (T.post = {
                    tag: "post",
                    data: M(a)
                  }), !D) try {
                    g = new O(T["CFF "].data);
                    p = new Z(g, a, ce).parse();
                    var Se = new J(p);
                    T["CFF "].data = Se.compile();
                  } catch (e) {
                    R("Failed to compile font " + a.loadedName);
                  }
                  if (T.name) {
                    var Ce = function (e) {
                      var t = (i.start ? i.start : 0) + e.offset;
                      i.pos = t;
                      var r = [[], []],
                        n = e.length,
                        a = t + n;
                      if (0 !== i.getUint16() || n < 6) return r;
                      var o,
                        s,
                        l = i.getUint16(),
                        c = i.getUint16(),
                        u = [];
                      for (o = 0; o < l && i.pos + 12 <= a; o++) {
                        var h = {
                          platform: i.getUint16(),
                          encoding: i.getUint16(),
                          language: i.getUint16(),
                          name: i.getUint16(),
                          length: i.getUint16(),
                          offset: i.getUint16()
                        };
                        (1 === h.platform && 0 === h.encoding && 0 === h.language || 3 === h.platform && 1 === h.encoding && 1033 === h.language) && u.push(h);
                      }
                      for (o = 0, s = u.length; o < s; o++) {
                        var f = u[o];
                        if (!(f.length <= 0)) {
                          var d = t + c + f.offset;
                          if (!(d + f.length > a)) {
                            i.pos = d;
                            var p = f.name;
                            if (f.encoding) {
                              for (var m = "", g = 0, v = f.length; g < v; g += 2) m += String.fromCharCode(i.getUint16());
                              r[1][p] = m;
                            } else r[0][p] = w(i.getBytes(f.length));
                          }
                        }
                      }
                      return r;
                    }(T.name);
                    T.name.data = Y(e, Ce);
                  } else T.name = {
                    tag: "name",
                    data: Y(this.name)
                  };
                  var Ee = new me(b.version);
                  for (var Ae in T) Ee.addTable(Ae, T[Ae].data);
                  return Ee.toArray();
                },
                convert: function convert(e, t, r) {
                  function n(e, t) {
                    for (var r in e) if (t === e[r]) return 0 | r;
                    return o.charCodeToGlyphId[o.nextAvailableFontCharCode] = t, o.nextAvailableFontCharCode++;
                  }
                  r.fixedPitch = !1, r.builtInEncoding && i(r, r.builtInEncoding);
                  var a = t.getGlyphMapping(r),
                    o = m(a, r);
                  this.toFontChar = o.toFontChar;
                  var s = t.numGlyphs,
                    u = t.seacs;
                  if (ce && u && u.length) {
                    var h = r.fontMatrix || v,
                      f = t.getCharset(),
                      d = Object.create(null);
                    for (var p in u) {
                      p |= 0;
                      var g = u[p],
                        b = L[g[2]],
                        y = L[g[3]],
                        w = f.indexOf(b),
                        x = f.indexOf(y);
                      if (!(w < 0 || x < 0)) {
                        var _ = {
                            x: g[0] * h[0] + g[1] * h[2] + h[4],
                            y: g[0] * h[1] + g[1] * h[3] + h[5]
                          },
                          C = function (e, t) {
                            var r = null;
                            for (var n in e) t === e[n] && (r || (r = []), r.push(0 | n));
                            return r;
                          }(a, p);
                        if (C) for (var E = 0, A = C.length; E < A; E++) {
                          var T = C[E],
                            k = o.charCodeToGlyphId,
                            R = n(k, w),
                            O = n(k, x);
                          d[T] = {
                            baseFontCharCode: R,
                            accentFontCharCode: O,
                            accentOffset: _
                          };
                        }
                      }
                    }
                    r.seacMap = d;
                  }
                  var P = 1 / (r.fontMatrix || v)[0],
                    B = new me("OTTO");
                  return B.addTable("CFF ", t.data), B.addTable("OS/2", I(r, o.charCodeToGlyphId)), B.addTable("cmap", S(o.charCodeToGlyphId, s)), B.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + c(P) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + c(r.descent) + "ÿ" + c(r.ascent) + l(r.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), B.addTable("hhea", "\0\0\0" + c(r.ascent) + c(r.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + c(r.capHeight) + c(Math.tan(r.italicAngle) * r.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + l(s)), B.addTable("hmtx", function () {
                    for (var e = t.charstrings, r = t.cff ? t.cff.widths : null, n = "\0\0\0\0", i = 1, a = s; i < a; i++) {
                      var o = 0;
                      if (e) {
                        var c = e[i - 1];
                        o = "width" in c ? c.width : 0;
                      } else r && (o = Math.ceil(r[i] || 0));
                      n += l(o) + l(0);
                    }
                    return n;
                  }()), B.addTable("maxp", "\0\0P\0" + l(s)), B.addTable("name", Y(e)), B.addTable("post", M(r)), B.toArray();
                },
                get spaceWidth() {
                  if ("_shadowWidth" in this) return this._shadowWidth;
                  for (var e, t = ["space", "minus", "one", "i", "I"], r = 0, n = t.length; r < n; r++) {
                    var i = t[r];
                    if (i in this.widths) {
                      e = this.widths[i];
                      break;
                    }
                    var a = P(),
                      o = a[i],
                      s = 0;
                    if (this.composite && this.cMap.contains(o) && (s = this.cMap.lookup(o)), !s && this.toUnicode && (s = this.toUnicode.charCodeOf(o)), s <= 0 && (s = o), e = this.widths[s]) break;
                  }
                  return e = e || this.defaultWidth, this._shadowWidth = e, e;
                },
                charToGlyph: function charToGlyph(e, t) {
                  var r,
                    n,
                    i,
                    a = e;
                  this.cMap && this.cMap.contains(e) && (a = this.cMap.lookup(e)), n = this.widths[a], n = E(n) ? n : this.defaultWidth;
                  var o = this.vmetrics && this.vmetrics[a],
                    s = this.toUnicode.get(e) || e;
                  "number" == typeof s && (s = String.fromCharCode(s));
                  var l = e in this.toFontChar;
                  r = this.toFontChar[e] || e, this.missingFile && (r = W(r)), this.isType3Font && (i = r);
                  var c = null;
                  if (this.seacMap && this.seacMap[e]) {
                    l = !0;
                    var u = this.seacMap[e];
                    r = u.baseFontCharCode, c = {
                      fontChar: String.fromCharCode(u.accentFontCharCode),
                      offset: u.accentOffset
                    };
                  }
                  var h = String.fromCharCode(r),
                    f = this.glyphCache[e];
                  return f && f.matchesForCache(h, s, c, n, o, i, t, l) || (f = new fe(h, s, c, n, o, i, t, l), this.glyphCache[e] = f), f;
                },
                charsToGlyphs: function charsToGlyphs(e) {
                  var t,
                    r,
                    n,
                    i = this.charsCache;
                  if (i && (t = i[e])) return t;
                  i || (i = this.charsCache = Object.create(null)), t = [];
                  var a,
                    o = e,
                    s = 0;
                  if (this.cMap) for (var l = Object.create(null); s < e.length;) {
                    this.cMap.readCharCode(e, s, l), n = l.charcode;
                    var c = l.length;
                    s += c;
                    var u = 1 === c && 32 === e.charCodeAt(s - 1);
                    r = this.charToGlyph(n, u), t.push(r);
                  } else for (s = 0, a = e.length; s < a; ++s) n = e.charCodeAt(s), r = this.charToGlyph(n, 32 === n), t.push(r);
                  return i[o] = t;
                }
              }, e;
            }(),
            be = function () {
              function e(e) {
                this.error = e, this.loadedName = "g_font_error", this.loading = !1;
              }
              return e.prototype = {
                charsToGlyphs: function charsToGlyphs() {
                  return [];
                },
                exportData: function exportData() {
                  return {
                    error: this.error
                  };
                }
              }, e;
            }(),
            ye = function () {
              function e(e, t, r) {
                for (var n, i = e.length, a = t.length, o = i - a, s = r, l = !1; s < o;) {
                  for (n = 0; n < a && e[s + n] === t[n];) n++;
                  if (n >= a) {
                    for (s += n; s < i && M(e[s]);) s++;
                    l = !0;
                    break;
                  }
                  s++;
                }
                return {
                  found: l,
                  length: s
                };
              }
              function t(t, r) {
                var n,
                  i,
                  a,
                  o = [101, 101, 120, 101, 99],
                  s = t.pos;
                try {
                  n = t.getBytes(r), i = n.length;
                } catch (e) {
                  if (e instanceof I) throw e;
                }
                if (i === r && (a = e(n, o, r - 2 * o.length), a.found && a.length === r)) return {
                  stream: new O(n),
                  length: r
                };
                R('Invalid "Length1" property in Type1 font -- trying to recover.'), t.pos = s;
                for (var l;;) {
                  if (a = e(t.peekBytes(2048), o, 0), 0 === a.length) break;
                  if (t.pos += a.length, a.found) {
                    l = t.pos - s;
                    break;
                  }
                }
                return t.pos = s, l ? {
                  stream: new O(t.getBytes(l)),
                  length: l
                } : (R('Unable to recover "Length1" property in Type1 font -- using as is.'), {
                  stream: new O(t.getBytes(r)),
                  length: r
                });
              }
              function r(e, t) {
                var r = e.getBytes();
                return {
                  stream: new O(r),
                  length: r.length
                };
              }
              function n(e, n, i) {
                var a = i.length1,
                  o = i.length2,
                  s = n.peekBytes(6),
                  l = 128 === s[0] && 1 === s[1];
                l && (n.skip(6), a = s[5] << 24 | s[4] << 16 | s[3] << 8 | s[2]);
                var c = t(n, a);
                a = c.length, new Y(c.stream, !1, ce).extractFontHeader(i), l && (s = n.getBytes(6), o = s[5] << 24 | s[4] << 16 | s[3] << 8 | s[2]);
                var u = r(n, o);
                o = u.length;
                var h = new Y(u.stream, !0, ce),
                  f = h.extractFontProgram();
                for (var d in f.properties) i[d] = f.properties[d];
                var p = f.charstrings,
                  m = this.getType2Charstrings(p),
                  g = this.getType2Subrs(f.subrs);
                this.charstrings = p, this.data = this.wrap(e, m, this.charstrings, g, i), this.seacs = this.getSeacs(f.charstrings);
              }
              return n.prototype = {
                get numGlyphs() {
                  return this.charstrings.length + 1;
                },
                getCharset: function getCharset() {
                  for (var e = [".notdef"], t = this.charstrings, r = 0; r < t.length; r++) e.push(t[r].glyphName);
                  return e;
                },
                getGlyphMapping: function getGlyphMapping(e) {
                  var t,
                    r = this.charstrings,
                    n = [".notdef"];
                  for (t = 0; t < r.length; t++) n.push(r[t].glyphName);
                  var i = e.builtInEncoding;
                  if (i) {
                    var a = Object.create(null);
                    for (var o in i) (t = n.indexOf(i[o])) >= 0 && (a[o] = t);
                  }
                  return s(e, a, n);
                },
                getSeacs: function getSeacs(e) {
                  var t,
                    r,
                    n = [];
                  for (t = 0, r = e.length; t < r; t++) {
                    var i = e[t];
                    i.seac && (n[t + 1] = i.seac);
                  }
                  return n;
                },
                getType2Charstrings: function getType2Charstrings(e) {
                  for (var t = [], r = 0, n = e.length; r < n; r++) t.push(e[r].charstring);
                  return t;
                },
                getType2Subrs: function getType2Subrs(e) {
                  var t = 0,
                    r = e.length;
                  t = r < 1133 ? 107 : r < 33769 ? 1131 : 32768;
                  var n,
                    i = [];
                  for (n = 0; n < t; n++) i.push([11]);
                  for (n = 0; n < r; n++) i.push(e[n]);
                  return i;
                },
                wrap: function wrap(e, t, r, n, i) {
                  var a = new Q();
                  a.header = new $(1, 0, 4, 4), a.names = [e];
                  var o = new ee();
                  o.setByName("version", 391), o.setByName("Notice", 392), o.setByName("FullName", 393), o.setByName("FamilyName", 394), o.setByName("Weight", 395), o.setByName("Encoding", null), o.setByName("FontMatrix", i.fontMatrix), o.setByName("FontBBox", i.bbox), o.setByName("charset", null), o.setByName("CharStrings", null), o.setByName("Private", null), a.topDict = o;
                  var s = new re();
                  s.add("Version 0.11"), s.add("See original notice"), s.add(e), s.add(e), s.add("Medium"), a.strings = s, a.globalSubrIndex = new ne();
                  var l,
                    c,
                    u = t.length,
                    h = [0];
                  for (l = 0; l < u; l++) {
                    var f = K.indexOf(r[l].glyphName);
                    -1 === f && (f = 0), h.push(f >> 8 & 255, 255 & f);
                  }
                  a.charset = new ie(!1, 0, [], h);
                  var d = new ne();
                  for (d.add([139, 14]), l = 0; l < u; l++) {
                    var p = t[l];
                    0 !== p.length ? d.add(p) : d.add([139, 14]);
                  }
                  a.charStrings = d;
                  var m = new te();
                  m.setByName("Subrs", null);
                  var g = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
                  for (l = 0, c = g.length; l < c; l++) {
                    var v = g[l];
                    if (v in i.privateData) {
                      var b = i.privateData[v];
                      if (S(b)) for (var y = b.length - 1; y > 0; y--) b[y] -= b[y - 1];
                      m.setByName(v, b);
                    }
                  }
                  a.topDict.privateDict = m;
                  var w = new ne();
                  for (l = 0, c = n.length; l < c; l++) w.add(n[l]);
                  return m.subrsIndex = w, new J(a).compile();
                }
              }, n;
            }(),
            we = function () {
              function e(e, t) {
                this.properties = t;
                var r = new Z(e, t, ce);
                this.cff = r.parse();
                var n = new J(this.cff);
                this.seacs = this.cff.seacs;
                try {
                  this.data = n.compile();
                } catch (r) {
                  R("Failed to compile font " + t.loadedName), this.data = e;
                }
              }
              return e.prototype = {
                get numGlyphs() {
                  return this.cff.charStrings.count;
                },
                getCharset: function getCharset() {
                  return this.cff.charset.charset;
                },
                getGlyphMapping: function getGlyphMapping() {
                  var e,
                    t,
                    r = this.cff,
                    n = this.properties,
                    i = r.charset.charset;
                  if (n.composite) {
                    if (e = Object.create(null), r.isCIDFont) for (t = 0; t < i.length; t++) {
                      var a = i[t],
                        o = n.cMap.charCodeOf(a);
                      e[o] = t;
                    } else for (t = 0; t < r.charStrings.count; t++) e[t] = t;
                    return e;
                  }
                  return e = s(n, r.encoding ? r.encoding.encoding : null, i);
                }
              }, e;
            }();
          !function () {
            "undefined" != typeof navigator && /Windows/.test(navigator.userAgent) && (ce = !0);
          }(), function () {
            "undefined" != typeof navigator && /Windows.*Chrome/.test(navigator.userAgent) && (se = !0);
          }(), t.SEAC_ANALYSIS_ENABLED = ce, t.PRIVATE_USE_OFFSET_START = ae, t.PRIVATE_USE_OFFSET_END = oe, t.ErrorFont = be, t.Font = ve, t.FontFlags = ue, t.IdentityToUnicodeMap = pe, t.ProblematicCharRanges = ge, t.ToUnicodeMap = de, t.getFontType = a;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = r(4),
            o = r(2),
            s = r(19),
            l = n.ImageKind,
            c = n.assert,
            u = n.error,
            h = n.info,
            f = n.isArray,
            d = n.warn,
            p = i.Name,
            m = i.isStream,
            g = a.ColorSpace,
            v = o.DecodeStream,
            b = o.JpegStream,
            y = s.JpxImage,
            w = function () {
              function e(e, t) {
                return t && t.canDecode(e) ? t.decode(e) : Promise.resolve(e);
              }
              function t(e, t, r, n) {
                return e = t + e * r, e < 0 ? 0 : e > n ? n : e;
              }
              function r(e, t, r, n, i, a) {
                var o,
                  s,
                  l,
                  c,
                  u = i * a,
                  h = t <= 8 ? new Uint8Array(u) : t <= 16 ? new Uint16Array(u) : new Uint32Array(u),
                  f = r / i,
                  d = n / a,
                  p = 0,
                  m = new Uint16Array(i),
                  g = r;
                for (o = 0; o < i; o++) m[o] = Math.floor(o * f);
                for (o = 0; o < a; o++) for (l = Math.floor(o * d) * g, s = 0; s < i; s++) c = l + m[s], h[p++] = e[c];
                return h;
              }
              function n(e, t, r, i, a, o, s) {
                this.image = r;
                var l = r.dict;
                if (l.has("Filter")) {
                  var c = l.get("Filter").name;
                  if ("JPXDecode" === c) {
                    var f = new y();
                    f.parseImageProperties(r.stream), r.stream.reset(), r.bitsPerComponent = f.bitsPerComponent, r.numComps = f.componentsCount;
                  } else "JBIG2Decode" === c && (r.bitsPerComponent = 1, r.numComps = 1);
                }
                this.width = l.get("Width", "W"), this.height = l.get("Height", "H"), (this.width < 1 || this.height < 1) && u("Invalid image width: " + this.width + " or height: " + this.height), this.interpolate = l.get("Interpolate", "I") || !1, this.imageMask = l.get("ImageMask", "IM") || !1, this.matte = l.get("Matte") || !1;
                var v = r.bitsPerComponent;
                if (v || (v = l.get("BitsPerComponent", "BPC")) || (this.imageMask ? v = 1 : u("Bits per component missing in image: " + this.imageMask)), this.bpc = v, !this.imageMask) {
                  var b = l.get("ColorSpace", "CS");
                  if (!b) switch (h("JPX images (which do not require color spaces)"), r.numComps) {
                    case 1:
                      b = p.get("DeviceGray");
                      break;
                    case 3:
                      b = p.get("DeviceRGB");
                      break;
                    case 4:
                      b = p.get("DeviceCMYK");
                      break;
                    default:
                      u("JPX images with " + this.numComps + " color components not supported.");
                  }
                  this.colorSpace = g.parse(b, e, t), this.numComps = this.colorSpace.numComps;
                }
                if (this.decode = l.getArray("Decode", "D"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode) || s && !g.isDefaultDecode(this.decode, 1))) {
                  this.needsDecode = !0;
                  var w = (1 << v) - 1;
                  this.decodeCoefficients = [], this.decodeAddends = [];
                  for (var x = 0, _ = 0; x < this.decode.length; x += 2, ++_) {
                    var S = this.decode[x],
                      C = this.decode[x + 1];
                    this.decodeCoefficients[_] = C - S, this.decodeAddends[_] = w * S;
                  }
                }
                if (a) this.smask = new n(e, t, a, !1);else if (o) if (m(o)) {
                  var E = o.dict,
                    A = E.get("ImageMask", "IM");
                  A ? this.mask = new n(e, t, o, !1, null, null, !0) : d("Ignoring /Mask in image without /ImageMask.");
                } else this.mask = o;
              }
              return n.buildImage = function (t, r, i, a, o, s) {
                var l,
                  c,
                  u = e(a, s),
                  h = a.dict.get("SMask"),
                  p = a.dict.get("Mask");
                return h ? (l = e(h, s), c = Promise.resolve(null)) : (l = Promise.resolve(null), p ? m(p) ? c = e(p, s) : f(p) ? c = Promise.resolve(p) : (d("Unsupported mask format."), c = Promise.resolve(null)) : c = Promise.resolve(null)), Promise.all([u, l, c]).then(function (e) {
                  var t = e[0],
                    a = e[1],
                    s = e[2];
                  return new n(r, i, t, o, a, s);
                });
              }, n.createMask = function (e, t, r, n, i) {
                var a,
                  o,
                  s = (t + 7 >> 3) * r,
                  l = e.byteLength,
                  c = s === l;
                if (!n || i && !c) {
                  if (i) for (a = new Uint8Array(s), a.set(e), o = l; o < s; o++) a[o] = 255;else a = new Uint8Array(l), a.set(e);
                } else a = e;
                if (i) for (o = 0; o < l; o++) a[o] = ~a[o];
                return {
                  data: a,
                  width: t,
                  height: r
                };
              }, n.prototype = {
                get drawWidth() {
                  return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
                },
                get drawHeight() {
                  return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
                },
                decodeBuffer: function decodeBuffer(e) {
                  var r,
                    n,
                    i = this.bpc,
                    a = this.numComps,
                    o = this.decodeAddends,
                    s = this.decodeCoefficients,
                    l = (1 << i) - 1;
                  if (1 !== i) {
                    var c = 0;
                    for (r = 0, n = this.width * this.height; r < n; r++) for (var u = 0; u < a; u++) e[c] = t(e[c], o[u], s[u], l), c++;
                  } else for (r = 0, n = e.length; r < n; r++) e[r] = +!e[r];
                },
                getComponents: function getComponents(e) {
                  var t = this.bpc;
                  if (8 === t) return e;
                  var r,
                    n,
                    i = this.width,
                    a = this.height,
                    o = this.numComps,
                    s = i * a * o,
                    l = 0,
                    c = t <= 8 ? new Uint8Array(s) : t <= 16 ? new Uint16Array(s) : new Uint32Array(s),
                    u = i * o,
                    h = (1 << t) - 1,
                    f = 0;
                  if (1 === t) for (var d, p, m, g = 0; g < a; g++) {
                    for (p = f + (-8 & u), m = f + u; f < p;) n = e[l++], c[f] = n >> 7 & 1, c[f + 1] = n >> 6 & 1, c[f + 2] = n >> 5 & 1, c[f + 3] = n >> 4 & 1, c[f + 4] = n >> 3 & 1, c[f + 5] = n >> 2 & 1, c[f + 6] = n >> 1 & 1, c[f + 7] = 1 & n, f += 8;
                    if (f < m) for (n = e[l++], d = 128; f < m;) c[f++] = +!!(n & d), d >>= 1;
                  } else {
                    var v = 0;
                    for (n = 0, f = 0, r = s; f < r; ++f) {
                      for (f % u == 0 && (n = 0, v = 0); v < t;) n = n << 8 | e[l++], v += 8;
                      var b = v - t,
                        y = n >> b;
                      c[f] = y < 0 ? 0 : y > h ? h : y, n &= (1 << b) - 1, v = b;
                    }
                  }
                  return c;
                },
                fillOpacity: function fillOpacity(e, t, i, a, o) {
                  var s,
                    l,
                    c,
                    h,
                    d,
                    p,
                    m = this.smask,
                    g = this.mask;
                  if (m) l = m.width, c = m.height, s = new Uint8Array(l * c), m.fillGrayBuffer(s), l === t && c === i || (s = r(s, m.bpc, l, c, t, i));else if (g) if (g instanceof n) {
                    for (l = g.width, c = g.height, s = new Uint8Array(l * c), g.numComps = 1, g.fillGrayBuffer(s), h = 0, d = l * c; h < d; ++h) s[h] = 255 - s[h];
                    l === t && c === i || (s = r(s, g.bpc, l, c, t, i));
                  } else if (f(g)) {
                    s = new Uint8Array(t * i);
                    var v = this.numComps;
                    for (h = 0, d = t * i; h < d; ++h) {
                      var b = 0,
                        y = h * v;
                      for (p = 0; p < v; ++p) {
                        var w = o[y + p],
                          x = 2 * p;
                        if (w < g[x] || w > g[x + 1]) {
                          b = 255;
                          break;
                        }
                      }
                      s[h] = b;
                    }
                  } else u("Unknown mask format.");
                  if (s) for (h = 0, p = 3, d = t * a; h < d; ++h, p += 4) e[p] = s[h];else for (h = 0, p = 3, d = t * a; h < d; ++h, p += 4) e[p] = 255;
                },
                undoPreblend: function undoPreblend(e, t, r) {
                  var n = this.smask && this.smask.matte;
                  if (n) for (var i, a, o, s = this.colorSpace.getRgb(n, 0), l = s[0], c = s[1], u = s[2], h = t * r * 4, f = 0; f < h; f += 4) {
                    var d = e[f + 3];
                    if (0 !== d) {
                      var p = 255 / d;
                      i = (e[f] - l) * p + l, a = (e[f + 1] - c) * p + c, o = (e[f + 2] - u) * p + u, e[f] = i <= 0 ? 0 : i >= 255 ? 255 : 0 | i, e[f + 1] = a <= 0 ? 0 : a >= 255 ? 255 : 0 | a, e[f + 2] = o <= 0 ? 0 : o >= 255 ? 255 : 0 | o;
                    } else e[f] = 255, e[f + 1] = 255, e[f + 2] = 255;
                  }
                },
                createImageData: function createImageData(e) {
                  var t,
                    r = this.drawWidth,
                    n = this.drawHeight,
                    i = {
                      width: r,
                      height: n
                    },
                    a = this.numComps,
                    o = this.width,
                    s = this.height,
                    u = this.bpc,
                    h = o * a * u + 7 >> 3;
                  if (!e) {
                    var f;
                    if ("DeviceGray" === this.colorSpace.name && 1 === u ? f = l.GRAYSCALE_1BPP : "DeviceRGB" !== this.colorSpace.name || 8 !== u || this.needsDecode || (f = l.RGB_24BPP), f && !this.smask && !this.mask && r === o && n === s) {
                      if (i.kind = f, t = this.getImageBytes(s * h), this.image instanceof v) i.data = t;else {
                        var d = new Uint8Array(t.length);
                        d.set(t), i.data = d;
                      }
                      if (this.needsDecode) {
                        c(f === l.GRAYSCALE_1BPP);
                        for (var p = i.data, m = 0, g = p.length; m < g; m++) p[m] ^= 255;
                      }
                      return i;
                    }
                    if (this.image instanceof b && !this.smask && !this.mask && ("DeviceGray" === this.colorSpace.name || "DeviceRGB" === this.colorSpace.name || "DeviceCMYK" === this.colorSpace.name)) return i.kind = l.RGB_24BPP, i.data = this.getImageBytes(s * h, r, n, !0), i;
                  }
                  t = this.getImageBytes(s * h);
                  var y,
                    w,
                    x = 0 | t.length / h * n / s,
                    _ = this.getComponents(t);
                  return e || this.smask || this.mask ? (i.kind = l.RGBA_32BPP, i.data = new Uint8Array(r * n * 4), y = 1, w = !0, this.fillOpacity(i.data, r, n, x, _)) : (i.kind = l.RGB_24BPP, i.data = new Uint8Array(r * n * 3), y = 0, w = !1), this.needsDecode && this.decodeBuffer(_), this.colorSpace.fillRgb(i.data, o, s, r, n, x, u, _, y), w && this.undoPreblend(i.data, r, x), i;
                },
                fillGrayBuffer: function fillGrayBuffer(e) {
                  var t = this.numComps;
                  1 !== t && u("Reading gray scale from a color image: " + t);
                  var r,
                    n,
                    i = this.width,
                    a = this.height,
                    o = this.bpc,
                    s = i * t * o + 7 >> 3,
                    l = this.getImageBytes(a * s),
                    c = this.getComponents(l);
                  if (1 !== o) {
                    this.needsDecode && this.decodeBuffer(c), n = i * a;
                    var h = 255 / ((1 << o) - 1);
                    for (r = 0; r < n; ++r) e[r] = h * c[r] | 0;
                  } else if (n = i * a, this.needsDecode) for (r = 0; r < n; ++r) e[r] = c[r] - 1 & 255;else for (r = 0; r < n; ++r) e[r] = 255 & -c[r];
                },
                getImageBytes: function getImageBytes(e, t, r, n) {
                  return this.image.reset(), this.image.drawWidth = t || this.width, this.image.drawHeight = r || this.height, this.image.forceRGB = !!n, this.image.getBytes(e);
                }
              }, n;
            }();
          t.PDFImage = w;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(14),
            a = n.error,
            o = n.log2,
            s = n.readInt8,
            l = n.readUint16,
            c = n.readUint32,
            u = n.shadow,
            h = i.ArithmeticDecoder,
            f = function () {
              function e() {}
              function t(e, t, r) {
                this.data = e, this.start = t, this.end = r;
              }
              function r(e, t, r) {
                function n(e) {
                  for (var t = 0, n = 0; n < e; n++) {
                    var o = r.readBit(i, a);
                    a = a < 256 ? a << 1 | o : 511 & (a << 1 | o) | 256, t = t << 1 | o;
                  }
                  return t >>> 0;
                }
                var i = e.getContexts(t),
                  a = 1,
                  o = n(1),
                  s = n(1) ? n(1) ? n(1) ? n(1) ? n(1) ? n(32) + 4436 : n(12) + 340 : n(8) + 84 : n(6) + 20 : n(4) + 4 : n(2);
                return 0 === o ? s : s > 0 ? -s : null;
              }
              function n(e, t, r) {
                for (var n = e.getContexts("IAID"), i = 1, a = 0; a < r; a++) {
                  i = i << 1 | t.readBit(n, i);
                }
                return r < 31 ? i & (1 << r) - 1 : 2147483647 & i;
              }
              function i(e, t, r) {
                var n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  c,
                  u = r.decoder,
                  h = r.contextCache.getContexts("GB"),
                  f = [];
                for (i = 0; i < t; i++) for (s = f[i] = new Uint8Array(e), l = i < 1 ? s : f[i - 1], c = i < 2 ? s : f[i - 2], n = c[0] << 13 | c[1] << 12 | c[2] << 11 | l[0] << 7 | l[1] << 6 | l[2] << 5 | l[3] << 4, a = 0; a < e; a++) s[a] = o = u.readBit(h, n), n = (31735 & n) << 1 | (a + 3 < e ? c[a + 3] << 11 : 0) | (a + 4 < e ? l[a + 4] << 4 : 0) | o;
                return f;
              }
              function f(e, t, r, n, o, s, l, c) {
                if (e && a("JBIG2 error: MMR encoding is not supported"), 0 === n && !s && !o && 4 === l.length && 3 === l[0].x && -1 === l[0].y && -3 === l[1].x && -1 === l[1].y && 2 === l[2].x && -2 === l[2].y && -2 === l[3].x && -2 === l[3].y) return i(t, r, c);
                var u = !!s,
                  h = E[n].concat(l);
                h.sort(function (e, t) {
                  return e.y - t.y || e.x - t.x;
                });
                var f,
                  d,
                  p = h.length,
                  m = new Int8Array(p),
                  g = new Int8Array(p),
                  v = [],
                  b = 0,
                  y = 0,
                  w = 0,
                  x = 0;
                for (d = 0; d < p; d++) m[d] = h[d].x, g[d] = h[d].y, y = Math.min(y, h[d].x), w = Math.max(w, h[d].x), x = Math.min(x, h[d].y), d < p - 1 && h[d].y === h[d + 1].y && h[d].x === h[d + 1].x - 1 ? b |= 1 << p - 1 - d : v.push(d);
                var _ = v.length,
                  S = new Int8Array(_),
                  C = new Int8Array(_),
                  A = new Uint16Array(_);
                for (f = 0; f < _; f++) d = v[f], S[f] = h[d].x, C[f] = h[d].y, A[f] = 1 << p - 1 - d;
                for (var k, R, I, M, O, P = -y, B = -x, D = t - w, L = T[n], F = new Uint8Array(t), N = [], U = c.decoder, j = c.contextCache.getContexts("GB"), z = 0, H = 0, G = 0; G < r; G++) {
                  if (o) {
                    if (z ^= U.readBit(j, L)) {
                      N.push(F);
                      continue;
                    }
                  }
                  for (F = new Uint8Array(F), N.push(F), k = 0; k < t; k++) if (u && s[G][k]) F[k] = 0;else {
                    if (k >= P && k < D && G >= B) for (H = H << 1 & b, d = 0; d < _; d++) R = G + C[d], I = k + S[d], (M = N[R][I]) && (M = A[d], H |= M);else for (H = 0, O = p - 1, d = 0; d < p; d++, O--) (I = k + m[d]) >= 0 && I < t && (R = G + g[d]) >= 0 && (M = N[R][I]) && (H |= M << O);
                    var V = U.readBit(j, H);
                    F[k] = V;
                  }
                }
                return N;
              }
              function d(e, t, r, n, i, o, s, l, c) {
                var u = A[r].coding;
                0 === r && (u = u.concat([l[0]]));
                var h,
                  f = u.length,
                  d = new Int32Array(f),
                  p = new Int32Array(f);
                for (h = 0; h < f; h++) d[h] = u[h].x, p[h] = u[h].y;
                var m = A[r].reference;
                0 === r && (m = m.concat([l[1]]));
                var g = m.length,
                  v = new Int32Array(g),
                  b = new Int32Array(g);
                for (h = 0; h < g; h++) v[h] = m[h].x, b[h] = m[h].y;
                for (var y = n[0].length, w = n.length, x = k[r], _ = [], S = c.decoder, C = c.contextCache.getContexts("GR"), E = 0, T = 0; T < t; T++) {
                  if (s) {
                    E ^= S.readBit(C, x), E && a("JBIG2 error: prediction is not supported");
                  }
                  var R = new Uint8Array(e);
                  _.push(R);
                  for (var I = 0; I < e; I++) {
                    var M,
                      O,
                      P = 0;
                    for (h = 0; h < f; h++) M = T + p[h], O = I + d[h], M < 0 || O < 0 || O >= e ? P <<= 1 : P = P << 1 | _[M][O];
                    for (h = 0; h < g; h++) M = T + b[h] - o, O = I + v[h] - i, M < 0 || M >= w || O < 0 || O >= y ? P <<= 1 : P = P << 1 | n[M][O];
                    var B = S.readBit(C, P);
                    R[I] = B;
                  }
                }
                return _;
              }
              function p(e, t, i, s, l, c, u, h, p, g, v) {
                e && a("JBIG2 error: huffman is not supported");
                for (var b = [], y = 0, w = o(i.length + s), x = v.decoder, _ = v.contextCache; b.length < s;) {
                  y += r(_, "IADH", x);
                  for (var S = 0;;) {
                    var C = r(_, "IADW", x);
                    if (null === C) break;
                    S += C;
                    var E;
                    if (t) {
                      var A = r(_, "IAAI", x);
                      if (A > 1) E = m(e, t, S, y, 0, A, 1, i.concat(b), w, 0, 0, 1, 0, c, p, g, v);else {
                        var T = n(_, x, w),
                          k = r(_, "IARDX", x),
                          R = r(_, "IARDY", x);
                        E = d(S, y, p, T < i.length ? i[T] : b[T - i.length], k, R, !1, g, v);
                      }
                    } else E = f(!1, S, y, u, !1, null, h, v);
                    b.push(E);
                  }
                }
                for (var I = [], M = [], O = !1, P = i.length + s; M.length < P;) {
                  for (var B = r(_, "IAEX", x); B--;) M.push(O);
                  O = !O;
                }
                for (var D = 0, L = i.length; D < L; D++) M[D] && I.push(i[D]);
                for (var F = 0; F < s; D++, F++) M[D] && I.push(b[F]);
                return I;
              }
              function m(e, t, i, o, s, l, c, u, h, f, p, m, g, v, b, y, w) {
                e && a("JBIG2 error: huffman is not supported");
                var x,
                  _,
                  S = [];
                for (x = 0; x < o; x++) {
                  if (_ = new Uint8Array(i), s) for (var C = 0; C < i; C++) _[C] = s;
                  S.push(_);
                }
                var E = w.decoder,
                  A = w.contextCache,
                  T = -r(A, "IADT", E),
                  k = 0;
                for (x = 0; x < l;) {
                  T += r(A, "IADT", E);
                  k += r(A, "IAFS", E);
                  for (var R = k;;) {
                    var I = 1 === c ? 0 : r(A, "IAIT", E),
                      M = c * T + I,
                      O = n(A, E, h),
                      P = t && r(A, "IARI", E),
                      B = u[O],
                      D = B[0].length,
                      L = B.length;
                    if (P) {
                      var F = r(A, "IARDW", E),
                        N = r(A, "IARDH", E),
                        U = r(A, "IARDX", E),
                        j = r(A, "IARDY", E);
                      D += F, L += N, B = d(D, L, b, B, (F >> 1) + U, (N >> 1) + j, !1, y, w);
                    }
                    var z,
                      H,
                      G,
                      V = M - (1 & m ? 0 : L),
                      q = R - (2 & m ? D : 0);
                    if (f) {
                      for (z = 0; z < L; z++) if (_ = S[q + z]) {
                        G = B[z];
                        var W = Math.min(i - V, D);
                        switch (g) {
                          case 0:
                            for (H = 0; H < W; H++) _[V + H] |= G[H];
                            break;
                          case 2:
                            for (H = 0; H < W; H++) _[V + H] ^= G[H];
                            break;
                          default:
                            a("JBIG2 error: operator " + g + " is not supported");
                        }
                      }
                      R += L - 1;
                    } else {
                      for (H = 0; H < L; H++) if (_ = S[V + H]) switch (G = B[H], g) {
                        case 0:
                          for (z = 0; z < D; z++) _[q + z] |= G[z];
                          break;
                        case 2:
                          for (z = 0; z < D; z++) _[q + z] ^= G[z];
                          break;
                        default:
                          a("JBIG2 error: operator " + g + " is not supported");
                      }
                      R += D - 1;
                    }
                    x++;
                    var X = r(A, "IADS", E);
                    if (null === X) break;
                    R += X + p;
                  }
                }
                return S;
              }
              function g(e, t) {
                var r = {};
                r.number = c(e, t);
                var n = e[t + 4],
                  i = 63 & n;
                C[i] || a("JBIG2 error: invalid segment type: " + i), r.type = i, r.typeName = C[i], r.deferredNonRetain = !!(128 & n);
                var o = !!(64 & n),
                  s = e[t + 5],
                  u = s >> 5 & 7,
                  h = [31 & s],
                  f = t + 6;
                if (7 === s) {
                  u = 536870911 & c(e, f - 1), f += 3;
                  var d = u + 7 >> 3;
                  for (h[0] = e[f++]; --d > 0;) h.push(e[f++]);
                } else 5 !== s && 6 !== s || a("JBIG2 error: invalid referred-to flags");
                r.retainBits = h;
                var p,
                  m,
                  g = r.number <= 256 ? 1 : r.number <= 65536 ? 2 : 4,
                  v = [];
                for (p = 0; p < u; p++) {
                  var y = 1 === g ? e[f] : 2 === g ? l(e, f) : c(e, f);
                  v.push(y), f += g;
                }
                if (r.referredTo = v, o ? (r.pageAssociation = c(e, f), f += 4) : r.pageAssociation = e[f++], r.length = c(e, f), f += 4, 4294967295 === r.length) if (38 === i) {
                  var w = b(e, f),
                    x = e[f + R],
                    _ = !!(1 & x),
                    S = new Uint8Array(6);
                  for (_ || (S[0] = 255, S[1] = 172), S[2] = w.height >>> 24 & 255, S[3] = w.height >> 16 & 255, S[4] = w.height >> 8 & 255, S[5] = 255 & w.height, p = f, m = e.length; p < m; p++) {
                    for (var E = 0; E < 6 && S[E] === e[p + E];) E++;
                    if (6 === E) {
                      r.length = p + 6;
                      break;
                    }
                  }
                  4294967295 === r.length && a("JBIG2 error: segment end was not found");
                } else a("JBIG2 error: invalid unknown segment length");
                return r.headerEnd = f, r;
              }
              function v(e, t, r, n) {
                for (var i = [], a = r; a < n;) {
                  var o = g(t, a);
                  a = o.headerEnd;
                  var s = {
                    header: o,
                    data: t
                  };
                  if (e.randomAccess || (s.start = a, a += o.length, s.end = a), i.push(s), 51 === o.type) break;
                }
                if (e.randomAccess) for (var l = 0, c = i.length; l < c; l++) i[l].start = a, a += i[l].header.length, i[l].end = a;
                return i;
              }
              function b(e, t) {
                return {
                  width: c(e, t),
                  height: c(e, t + 4),
                  x: c(e, t + 8),
                  y: c(e, t + 12),
                  combinationOperator: 7 & e[t + 16]
                };
              }
              function y(e, t) {
                var r,
                  n,
                  i,
                  o,
                  u = e.header,
                  h = e.data,
                  f = e.start,
                  d = e.end;
                switch (u.type) {
                  case 0:
                    var p = {},
                      m = l(h, f);
                    if (p.huffman = !!(1 & m), p.refinement = !!(2 & m), p.huffmanDHSelector = m >> 2 & 3, p.huffmanDWSelector = m >> 4 & 3, p.bitmapSizeSelector = m >> 6 & 1, p.aggregationInstancesSelector = m >> 7 & 1, p.bitmapCodingContextUsed = !!(256 & m), p.bitmapCodingContextRetained = !!(512 & m), p.template = m >> 10 & 3, p.refinementTemplate = m >> 12 & 1, f += 2, !p.huffman) {
                      for (o = 0 === p.template ? 4 : 1, n = [], i = 0; i < o; i++) n.push({
                        x: s(h, f),
                        y: s(h, f + 1)
                      }), f += 2;
                      p.at = n;
                    }
                    if (p.refinement && !p.refinementTemplate) {
                      for (n = [], i = 0; i < 2; i++) n.push({
                        x: s(h, f),
                        y: s(h, f + 1)
                      }), f += 2;
                      p.refinementAt = n;
                    }
                    p.numberOfExportedSymbols = c(h, f), f += 4, p.numberOfNewSymbols = c(h, f), f += 4, r = [p, u.number, u.referredTo, h, f, d];
                    break;
                  case 6:
                  case 7:
                    var g = {};
                    g.info = b(h, f), f += R;
                    var v = l(h, f);
                    if (f += 2, g.huffman = !!(1 & v), g.refinement = !!(2 & v), g.stripSize = 1 << (v >> 2 & 3), g.referenceCorner = v >> 4 & 3, g.transposed = !!(64 & v), g.combinationOperator = v >> 7 & 3, g.defaultPixelValue = v >> 9 & 1, g.dsOffset = v << 17 >> 27, g.refinementTemplate = v >> 15 & 1, g.huffman) {
                      var y = l(h, f);
                      f += 2, g.huffmanFS = 3 & y, g.huffmanDS = y >> 2 & 3, g.huffmanDT = y >> 4 & 3, g.huffmanRefinementDW = y >> 6 & 3, g.huffmanRefinementDH = y >> 8 & 3, g.huffmanRefinementDX = y >> 10 & 3, g.huffmanRefinementDY = y >> 12 & 3, g.huffmanRefinementSizeSelector = !!(14 & y);
                    }
                    if (g.refinement && !g.refinementTemplate) {
                      for (n = [], i = 0; i < 2; i++) n.push({
                        x: s(h, f),
                        y: s(h, f + 1)
                      }), f += 2;
                      g.refinementAt = n;
                    }
                    g.numberOfSymbolInstances = c(h, f), f += 4, g.huffman && a("JBIG2 error: huffman is not supported"), r = [g, u.referredTo, h, f, d];
                    break;
                  case 38:
                  case 39:
                    var w = {};
                    w.info = b(h, f), f += R;
                    var x = h[f++];
                    if (w.mmr = !!(1 & x), w.template = x >> 1 & 3, w.prediction = !!(8 & x), !w.mmr) {
                      for (o = 0 === w.template ? 4 : 1, n = [], i = 0; i < o; i++) n.push({
                        x: s(h, f),
                        y: s(h, f + 1)
                      }), f += 2;
                      w.at = n;
                    }
                    r = [w, h, f, d];
                    break;
                  case 48:
                    var _ = {
                      width: c(h, f),
                      height: c(h, f + 4),
                      resolutionX: c(h, f + 8),
                      resolutionY: c(h, f + 12)
                    };
                    4294967295 === _.height && delete _.height;
                    var S = h[f + 16];
                    l(h, f + 17), _.lossless = !!(1 & S), _.refinement = !!(2 & S), _.defaultPixelValue = S >> 2 & 1, _.combinationOperator = S >> 3 & 3, _.requiresBuffer = !!(32 & S), _.combinationOperatorOverride = !!(64 & S), r = [_];
                    break;
                  case 49:
                  case 50:
                  case 51:
                  case 62:
                    break;
                  default:
                    a("JBIG2 error: segment type " + u.typeName + "(" + u.type + ") is not implemented");
                }
                var C = "on" + u.typeName;
                C in t && t[C].apply(t, r);
              }
              function w(e, t) {
                for (var r = 0, n = e.length; r < n; r++) y(e[r], t);
              }
              function x(e) {
                for (var t = new _(), r = 0, n = e.length; r < n; r++) {
                  var i = e[r];
                  w(v({}, i.data, i.start, i.end), t);
                }
                return t.buffer;
              }
              function _() {}
              function S() {}
              e.prototype = {
                getContexts: function getContexts(e) {
                  return e in this ? this[e] : this[e] = new Int8Array(65536);
                }
              }, t.prototype = {
                get decoder() {
                  var e = new h(this.data, this.start, this.end);
                  return u(this, "decoder", e);
                },
                get contextCache() {
                  var t = new e();
                  return u(this, "contextCache", t);
                }
              };
              var C = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "patternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"],
                E = [[{
                  x: -1,
                  y: -2
                }, {
                  x: 0,
                  y: -2
                }, {
                  x: 1,
                  y: -2
                }, {
                  x: -2,
                  y: -1
                }, {
                  x: -1,
                  y: -1
                }, {
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: 2,
                  y: -1
                }, {
                  x: -4,
                  y: 0
                }, {
                  x: -3,
                  y: 0
                }, {
                  x: -2,
                  y: 0
                }, {
                  x: -1,
                  y: 0
                }], [{
                  x: -1,
                  y: -2
                }, {
                  x: 0,
                  y: -2
                }, {
                  x: 1,
                  y: -2
                }, {
                  x: 2,
                  y: -2
                }, {
                  x: -2,
                  y: -1
                }, {
                  x: -1,
                  y: -1
                }, {
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: 2,
                  y: -1
                }, {
                  x: -3,
                  y: 0
                }, {
                  x: -2,
                  y: 0
                }, {
                  x: -1,
                  y: 0
                }], [{
                  x: -1,
                  y: -2
                }, {
                  x: 0,
                  y: -2
                }, {
                  x: 1,
                  y: -2
                }, {
                  x: -2,
                  y: -1
                }, {
                  x: -1,
                  y: -1
                }, {
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: -2,
                  y: 0
                }, {
                  x: -1,
                  y: 0
                }], [{
                  x: -3,
                  y: -1
                }, {
                  x: -2,
                  y: -1
                }, {
                  x: -1,
                  y: -1
                }, {
                  x: 0,
                  y: -1
                }, {
                  x: 1,
                  y: -1
                }, {
                  x: -4,
                  y: 0
                }, {
                  x: -3,
                  y: 0
                }, {
                  x: -2,
                  y: 0
                }, {
                  x: -1,
                  y: 0
                }]],
                A = [{
                  coding: [{
                    x: 0,
                    y: -1
                  }, {
                    x: 1,
                    y: -1
                  }, {
                    x: -1,
                    y: 0
                  }],
                  reference: [{
                    x: 0,
                    y: -1
                  }, {
                    x: 1,
                    y: -1
                  }, {
                    x: -1,
                    y: 0
                  }, {
                    x: 0,
                    y: 0
                  }, {
                    x: 1,
                    y: 0
                  }, {
                    x: -1,
                    y: 1
                  }, {
                    x: 0,
                    y: 1
                  }, {
                    x: 1,
                    y: 1
                  }]
                }, {
                  coding: [{
                    x: -1,
                    y: -1
                  }, {
                    x: 0,
                    y: -1
                  }, {
                    x: 1,
                    y: -1
                  }, {
                    x: -1,
                    y: 0
                  }],
                  reference: [{
                    x: 0,
                    y: -1
                  }, {
                    x: -1,
                    y: 0
                  }, {
                    x: 0,
                    y: 0
                  }, {
                    x: 1,
                    y: 0
                  }, {
                    x: 0,
                    y: 1
                  }, {
                    x: 1,
                    y: 1
                  }]
                }],
                T = [39717, 1941, 229, 405],
                k = [32, 8],
                R = 17;
              return _.prototype = {
                onPageInformation: function onPageInformation(e) {
                  this.currentPageInfo = e;
                  var t = e.width + 7 >> 3,
                    r = new Uint8Array(t * e.height);
                  if (e.defaultPixelValue) for (var n = 0, i = r.length; n < i; n++) r[n] = 255;
                  this.buffer = r;
                },
                drawBitmap: function drawBitmap(e, t) {
                  var r,
                    n,
                    i,
                    o,
                    s = this.currentPageInfo,
                    l = e.width,
                    c = e.height,
                    u = s.width + 7 >> 3,
                    h = s.combinationOperatorOverride ? e.combinationOperator : s.combinationOperator,
                    f = this.buffer,
                    d = 128 >> (7 & e.x),
                    p = e.y * u + (e.x >> 3);
                  switch (h) {
                    case 0:
                      for (r = 0; r < c; r++) {
                        for (i = d, o = p, n = 0; n < l; n++) t[r][n] && (f[o] |= i), (i >>= 1) || (i = 128, o++);
                        p += u;
                      }
                      break;
                    case 2:
                      for (r = 0; r < c; r++) {
                        for (i = d, o = p, n = 0; n < l; n++) t[r][n] && (f[o] ^= i), (i >>= 1) || (i = 128, o++);
                        p += u;
                      }
                      break;
                    default:
                      a("JBIG2 error: operator " + h + " is not supported");
                  }
                },
                onImmediateGenericRegion: function onImmediateGenericRegion(e, r, n, i) {
                  var a = e.info,
                    o = new t(r, n, i),
                    s = f(e.mmr, a.width, a.height, e.template, e.prediction, null, e.at, o);
                  this.drawBitmap(a, s);
                },
                onImmediateLosslessGenericRegion: function onImmediateLosslessGenericRegion() {
                  this.onImmediateGenericRegion.apply(this, arguments);
                },
                onSymbolDictionary: function onSymbolDictionary(e, r, n, i, o, s) {
                  e.huffman && a("JBIG2 error: huffman is not supported");
                  var l = this.symbols;
                  l || (this.symbols = l = {});
                  for (var c = [], u = 0, h = n.length; u < h; u++) c = c.concat(l[n[u]]);
                  var f = new t(i, o, s);
                  l[r] = p(e.huffman, e.refinement, c, e.numberOfNewSymbols, e.numberOfExportedSymbols, void 0, e.template, e.at, e.refinementTemplate, e.refinementAt, f);
                },
                onImmediateTextRegion: function onImmediateTextRegion(e, r, n, i, a) {
                  for (var s = e.info, l = this.symbols, c = [], u = 0, h = r.length; u < h; u++) c = c.concat(l[r[u]]);
                  var f = o(c.length),
                    d = new t(n, i, a),
                    p = m(e.huffman, e.refinement, s.width, s.height, e.defaultPixelValue, e.numberOfSymbolInstances, e.stripSize, c, f, e.transposed, e.dsOffset, e.referenceCorner, e.combinationOperator, void 0, e.refinementTemplate, e.refinementAt, d);
                  this.drawBitmap(s, p);
                },
                onImmediateLosslessTextRegion: function onImmediateLosslessTextRegion() {
                  this.onImmediateTextRegion.apply(this, arguments);
                }
              }, S.prototype = {
                parseChunks: function parseChunks(e) {
                  return x(e);
                }
              }, S;
            }();
          t.Jbig2Image = f;
        }, function (e, t, r) {
          "use strict";

          var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            i = r(0),
            a = i.warn,
            o = i.error,
            s = function () {
              function e() {
                this.decodeTransform = null, this.colorTransform = -1;
              }
              function t(e, t) {
                for (var r, n, i = 0, a = [], o = 16; o > 0 && !e[o - 1];) o--;
                a.push({
                  children: [],
                  index: 0
                });
                var s,
                  l = a[0];
                for (r = 0; r < o; r++) {
                  for (n = 0; n < e[r]; n++) {
                    for (l = a.pop(), l.children[l.index] = t[i]; l.index > 0;) l = a.pop();
                    for (l.index++, a.push(l); a.length <= r;) a.push(s = {
                      children: [],
                      index: 0
                    }), l.children[l.index] = s.children, l = s;
                    i++;
                  }
                  r + 1 < o && (a.push(s = {
                    children: [],
                    index: 0
                  }), l.children[l.index] = s.children, l = s);
                }
                return a[0].children;
              }
              function r(e, t, r) {
                return 64 * ((e.blocksPerLine + 1) * t + r);
              }
              function i(e, t, i, s, l, c, f, d, p) {
                function m() {
                  if (D > 0) return D--, B >> D & 1;
                  if (255 === (B = e[t++])) {
                    var r = e[t++];
                    r && o("JPEG error: unexpected marker " + (B << 8 | r).toString(16));
                  }
                  return D = 7, B >>> 7;
                }
                function g(e) {
                  for (var t = e;;) {
                    if ("number" == typeof (t = t[m()])) return t;
                    "object" !== (void 0 === t ? "undefined" : n(t)) && o("JPEG error: invalid huffman sequence");
                  }
                }
                function v(e) {
                  for (var t = 0; e > 0;) t = t << 1 | m(), e--;
                  return t;
                }
                function b(e) {
                  if (1 === e) return 1 === m() ? 1 : -1;
                  var t = v(e);
                  return t >= 1 << e - 1 ? t : t + (-1 << e) + 1;
                }
                function y(e, t) {
                  var r = g(e.huffmanTableDC),
                    n = 0 === r ? 0 : b(r);
                  e.blockData[t] = e.pred += n;
                  for (var i = 1; i < 64;) {
                    var a = g(e.huffmanTableAC),
                      o = 15 & a,
                      s = a >> 4;
                    if (0 !== o) {
                      i += s;
                      var l = h[i];
                      e.blockData[t + l] = b(o), i++;
                    } else {
                      if (s < 15) break;
                      i += 16;
                    }
                  }
                }
                function w(e, t) {
                  var r = g(e.huffmanTableDC),
                    n = 0 === r ? 0 : b(r) << p;
                  e.blockData[t] = e.pred += n;
                }
                function x(e, t) {
                  e.blockData[t] |= m() << p;
                }
                function _(e, t) {
                  if (L > 0) return void L--;
                  for (var r = c, n = f; r <= n;) {
                    var i = g(e.huffmanTableAC),
                      a = 15 & i,
                      o = i >> 4;
                    if (0 !== a) {
                      r += o;
                      var s = h[r];
                      e.blockData[t + s] = b(a) * (1 << p), r++;
                    } else {
                      if (o < 15) {
                        L = v(o) + (1 << o) - 1;
                        break;
                      }
                      r += 16;
                    }
                  }
                }
                function S(e, t) {
                  for (var r, n, i = c, a = f, s = 0; i <= a;) {
                    var l = h[i];
                    switch (F) {
                      case 0:
                        n = g(e.huffmanTableAC), r = 15 & n, s = n >> 4, 0 === r ? s < 15 ? (L = v(s) + (1 << s), F = 4) : (s = 16, F = 1) : (1 !== r && o("JPEG error: invalid ACn encoding"), C = b(r), F = s ? 2 : 3);
                        continue;
                      case 1:
                      case 2:
                        e.blockData[t + l] ? e.blockData[t + l] += m() << p : 0 === --s && (F = 2 === F ? 3 : 0);
                        break;
                      case 3:
                        e.blockData[t + l] ? e.blockData[t + l] += m() << p : (e.blockData[t + l] = C << p, F = 0);
                        break;
                      case 4:
                        e.blockData[t + l] && (e.blockData[t + l] += m() << p);
                    }
                    i++;
                  }
                  4 === F && 0 === --L && (F = 0);
                }
                var C,
                  E,
                  A,
                  T,
                  k,
                  R,
                  I,
                  M = i.mcusPerLine,
                  O = i.progressive,
                  P = t,
                  B = 0,
                  D = 0,
                  L = 0,
                  F = 0,
                  N = s.length;
                I = O ? 0 === c ? 0 === d ? w : x : 0 === d ? _ : S : y;
                var U,
                  j,
                  z = 0;
                j = 1 === N ? s[0].blocksPerLine * s[0].blocksPerColumn : M * i.mcusPerColumn;
                for (var H, G; z < j;) {
                  var V = l ? Math.min(j - z, l) : j;
                  for (A = 0; A < N; A++) s[A].pred = 0;
                  if (L = 0, 1 === N) for (E = s[0], R = 0; R < V; R++) !function (e, t, n) {
                    t(e, r(e, n / e.blocksPerLine | 0, n % e.blocksPerLine));
                  }(E, I, z), z++;else for (R = 0; R < V; R++) {
                    for (A = 0; A < N; A++) for (E = s[A], H = E.h, G = E.v, T = 0; T < G; T++) for (k = 0; k < H; k++) !function (e, t, n, i, a) {
                      var o = n / M | 0,
                        s = n % M;
                      t(e, r(e, o * e.v + i, s * e.h + a));
                    }(E, I, z, T, k);
                    z++;
                  }
                  D = 0, U = u(e, t), U && U.invalid && (a("decodeScan - unexpected MCU data, next marker is: " + U.invalid), t = U.offset);
                  var q = U && U.marker;
                  if ((!q || q <= 65280) && o("JPEG error: marker was not found"), !(q >= 65488 && q <= 65495)) break;
                  t += 2;
                }
                return U = u(e, t), U && U.invalid && (a("decodeScan - unexpected Scan data, next marker is: " + U.invalid), t = U.offset), t - P;
              }
              function s(e, t, r) {
                var n,
                  i,
                  a,
                  s,
                  l,
                  c,
                  u,
                  h,
                  w,
                  x,
                  _,
                  S,
                  C,
                  E,
                  A,
                  T,
                  k,
                  R = e.quantizationTable,
                  I = e.blockData;
                R || o("JPEG error: missing required Quantization Table.");
                for (var M = 0; M < 64; M += 8) w = I[t + M], x = I[t + M + 1], _ = I[t + M + 2], S = I[t + M + 3], C = I[t + M + 4], E = I[t + M + 5], A = I[t + M + 6], T = I[t + M + 7], w *= R[M], 0 != (x | _ | S | C | E | A | T) ? (x *= R[M + 1], _ *= R[M + 2], S *= R[M + 3], C *= R[M + 4], E *= R[M + 5], A *= R[M + 6], T *= R[M + 7], n = b * w + 128 >> 8, i = b * C + 128 >> 8, a = _, s = A, l = y * (x - T) + 128 >> 8, h = y * (x + T) + 128 >> 8, c = S << 4, u = E << 4, n = n + i + 1 >> 1, i = n - i, k = a * v + s * g + 128 >> 8, a = a * g - s * v + 128 >> 8, s = k, l = l + u + 1 >> 1, u = l - u, h = h + c + 1 >> 1, c = h - c, n = n + s + 1 >> 1, s = n - s, i = i + a + 1 >> 1, a = i - a, k = l * m + h * p + 2048 >> 12, l = l * p - h * m + 2048 >> 12, h = k, k = c * d + u * f + 2048 >> 12, c = c * f - u * d + 2048 >> 12, u = k, r[M] = n + h, r[M + 7] = n - h, r[M + 1] = i + u, r[M + 6] = i - u, r[M + 2] = a + c, r[M + 5] = a - c, r[M + 3] = s + l, r[M + 4] = s - l) : (k = b * w + 512 >> 10, r[M] = k, r[M + 1] = k, r[M + 2] = k, r[M + 3] = k, r[M + 4] = k, r[M + 5] = k, r[M + 6] = k, r[M + 7] = k);
                for (var O = 0; O < 8; ++O) w = r[O], x = r[O + 8], _ = r[O + 16], S = r[O + 24], C = r[O + 32], E = r[O + 40], A = r[O + 48], T = r[O + 56], 0 != (x | _ | S | C | E | A | T) ? (n = b * w + 2048 >> 12, i = b * C + 2048 >> 12, a = _, s = A, l = y * (x - T) + 2048 >> 12, h = y * (x + T) + 2048 >> 12, c = S, u = E, n = 4112 + (n + i + 1 >> 1), i = n - i, k = a * v + s * g + 2048 >> 12, a = a * g - s * v + 2048 >> 12, s = k, l = l + u + 1 >> 1, u = l - u, h = h + c + 1 >> 1, c = h - c, n = n + s + 1 >> 1, s = n - s, i = i + a + 1 >> 1, a = i - a, k = l * m + h * p + 2048 >> 12, l = l * p - h * m + 2048 >> 12, h = k, k = c * d + u * f + 2048 >> 12, c = c * f - u * d + 2048 >> 12, u = k, w = n + h, T = n - h, x = i + u, A = i - u, _ = a + c, E = a - c, S = s + l, C = s - l, w = w < 16 ? 0 : w >= 4080 ? 255 : w >> 4, x = x < 16 ? 0 : x >= 4080 ? 255 : x >> 4, _ = _ < 16 ? 0 : _ >= 4080 ? 255 : _ >> 4, S = S < 16 ? 0 : S >= 4080 ? 255 : S >> 4, C = C < 16 ? 0 : C >= 4080 ? 255 : C >> 4, E = E < 16 ? 0 : E >= 4080 ? 255 : E >> 4, A = A < 16 ? 0 : A >= 4080 ? 255 : A >> 4, T = T < 16 ? 0 : T >= 4080 ? 255 : T >> 4, I[t + O] = w, I[t + O + 8] = x, I[t + O + 16] = _, I[t + O + 24] = S, I[t + O + 32] = C, I[t + O + 40] = E, I[t + O + 48] = A, I[t + O + 56] = T) : (k = b * w + 8192 >> 14, k = k < -2040 ? 0 : k >= 2024 ? 255 : k + 2056 >> 4, I[t + O] = k, I[t + O + 8] = k, I[t + O + 16] = k, I[t + O + 24] = k, I[t + O + 32] = k, I[t + O + 40] = k, I[t + O + 48] = k, I[t + O + 56] = k);
              }
              function l(e, t) {
                for (var n = t.blocksPerLine, i = t.blocksPerColumn, a = new Int16Array(64), o = 0; o < i; o++) for (var l = 0; l < n; l++) {
                  var c = r(t, o, l);
                  s(t, c, a);
                }
                return t.blockData;
              }
              function c(e) {
                return e <= 0 ? 0 : e >= 255 ? 255 : e;
              }
              function u(e, t, r) {
                function n(t) {
                  return e[t] << 8 | e[t + 1];
                }
                var i = e.length - 1,
                  a = r < t ? r : t;
                if (t >= i) return null;
                var o = n(t);
                if (o >= 65472 && o <= 65534) return {
                  invalid: null,
                  marker: o,
                  offset: t
                };
                for (var s = n(a); !(s >= 65472 && s <= 65534);) {
                  if (++a >= i) return null;
                  s = n(a);
                }
                return {
                  invalid: o.toString(16),
                  marker: s,
                  offset: a
                };
              }
              var h = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]),
                f = 4017,
                d = 799,
                p = 3406,
                m = 2276,
                g = 1567,
                v = 3784,
                b = 5793,
                y = 2896;
              return e.prototype = {
                parse: function parse(e) {
                  function r() {
                    var t = e[c] << 8 | e[c + 1];
                    return c += 2, t;
                  }
                  var n,
                    s,
                    c = 0,
                    f = null,
                    d = null,
                    p = [],
                    m = [],
                    g = [],
                    v = r();
                  for (65496 !== v && o("JPEG error: SOI not found"), v = r(); 65497 !== v;) {
                    var b, y, w;
                    switch (v) {
                      case 65504:
                      case 65505:
                      case 65506:
                      case 65507:
                      case 65508:
                      case 65509:
                      case 65510:
                      case 65511:
                      case 65512:
                      case 65513:
                      case 65514:
                      case 65515:
                      case 65516:
                      case 65517:
                      case 65518:
                      case 65519:
                      case 65534:
                        var x = function () {
                          var t = r(),
                            n = c + t - 2,
                            i = u(e, n, c);
                          i && i.invalid && (a("readDataBlock - incorrect length, next marker is: " + i.invalid), n = i.offset);
                          var o = e.subarray(c, n);
                          return c += o.length, o;
                        }();
                        65504 === v && 74 === x[0] && 70 === x[1] && 73 === x[2] && 70 === x[3] && 0 === x[4] && (f = {
                          version: {
                            major: x[5],
                            minor: x[6]
                          },
                          densityUnits: x[7],
                          xDensity: x[8] << 8 | x[9],
                          yDensity: x[10] << 8 | x[11],
                          thumbWidth: x[12],
                          thumbHeight: x[13],
                          thumbData: x.subarray(14, 14 + 3 * x[12] * x[13])
                        }), 65518 === v && 65 === x[0] && 100 === x[1] && 111 === x[2] && 98 === x[3] && 101 === x[4] && (d = {
                          version: x[5] << 8 | x[6],
                          flags0: x[7] << 8 | x[8],
                          flags1: x[9] << 8 | x[10],
                          transformCode: x[11]
                        });
                        break;
                      case 65499:
                        for (var _, S = r(), C = S + c - 2; c < C;) {
                          var E = e[c++],
                            A = new Uint16Array(64);
                          if (E >> 4 == 0) for (y = 0; y < 64; y++) _ = h[y], A[_] = e[c++];else if (E >> 4 == 1) for (y = 0; y < 64; y++) _ = h[y], A[_] = r();else o("JPEG error: DQT - invalid table spec");
                          p[15 & E] = A;
                        }
                        break;
                      case 65472:
                      case 65473:
                      case 65474:
                        n && o("JPEG error: Only single frame JPEGs supported"), r(), n = {}, n.extended = 65473 === v, n.progressive = 65474 === v, n.precision = e[c++], n.scanLines = r(), n.samplesPerLine = r(), n.components = [], n.componentIds = {};
                        var T,
                          k = e[c++],
                          R = 0,
                          I = 0;
                        for (b = 0; b < k; b++) {
                          T = e[c];
                          var M = e[c + 1] >> 4,
                            O = 15 & e[c + 1];
                          R < M && (R = M), I < O && (I = O);
                          var P = e[c + 2];
                          w = n.components.push({
                            h: M,
                            v: O,
                            quantizationId: P,
                            quantizationTable: null
                          }), n.componentIds[T] = w - 1, c += 3;
                        }
                        n.maxH = R, n.maxV = I, function (e) {
                          for (var t = Math.ceil(e.samplesPerLine / 8 / e.maxH), r = Math.ceil(e.scanLines / 8 / e.maxV), n = 0; n < e.components.length; n++) {
                            U = e.components[n];
                            var i = Math.ceil(Math.ceil(e.samplesPerLine / 8) * U.h / e.maxH),
                              a = Math.ceil(Math.ceil(e.scanLines / 8) * U.v / e.maxV),
                              o = t * U.h,
                              s = r * U.v,
                              l = 64 * s * (o + 1);
                            U.blockData = new Int16Array(l), U.blocksPerLine = i, U.blocksPerColumn = a;
                          }
                          e.mcusPerLine = t, e.mcusPerColumn = r;
                        }(n);
                        break;
                      case 65476:
                        var B = r();
                        for (b = 2; b < B;) {
                          var D = e[c++],
                            L = new Uint8Array(16),
                            F = 0;
                          for (y = 0; y < 16; y++, c++) F += L[y] = e[c];
                          var N = new Uint8Array(F);
                          for (y = 0; y < F; y++, c++) N[y] = e[c];
                          b += 17 + F, (D >> 4 == 0 ? g : m)[15 & D] = t(L, N);
                        }
                        break;
                      case 65501:
                        r(), s = r();
                        break;
                      case 65498:
                        r();
                        var U,
                          j = e[c++],
                          z = [];
                        for (b = 0; b < j; b++) {
                          var H = n.componentIds[e[c++]];
                          U = n.components[H];
                          var G = e[c++];
                          U.huffmanTableDC = g[G >> 4], U.huffmanTableAC = m[15 & G], z.push(U);
                        }
                        var V = e[c++],
                          q = e[c++],
                          W = e[c++],
                          X = i(e, c, n, z, s, V, q, W >> 4, 15 & W);
                        c += X;
                        break;
                      case 65535:
                        255 !== e[c] && c--;
                        break;
                      default:
                        if (255 === e[c - 3] && e[c - 2] >= 192 && e[c - 2] <= 254) {
                          c -= 3;
                          break;
                        }
                        o("JPEG error: unknown marker " + v.toString(16));
                    }
                    v = r();
                  }
                  for (this.width = n.samplesPerLine, this.height = n.scanLines, this.jfif = f, this.adobe = d, this.components = [], b = 0; b < n.components.length; b++) {
                    U = n.components[b];
                    var Y = p[U.quantizationId];
                    Y && (U.quantizationTable = Y), this.components.push({
                      output: l(n, U),
                      scaleX: U.h / n.maxH,
                      scaleY: U.v / n.maxV,
                      blocksPerLine: U.blocksPerLine,
                      blocksPerColumn: U.blocksPerColumn
                    });
                  }
                  this.numComponents = this.components.length;
                },
                _getLinearizedBlockData: function _getLinearizedBlockData(e, t) {
                  var r,
                    n,
                    i,
                    a,
                    o,
                    s,
                    l,
                    c,
                    u,
                    h,
                    f,
                    d = this.width / e,
                    p = this.height / t,
                    m = 0,
                    g = this.components.length,
                    v = e * t * g,
                    b = new Uint8Array(v),
                    y = new Uint32Array(e);
                  for (l = 0; l < g; l++) {
                    for (r = this.components[l], n = r.scaleX * d, i = r.scaleY * p, m = l, f = r.output, a = r.blocksPerLine + 1 << 3, o = 0; o < e; o++) c = 0 | o * n, y[o] = (4294967288 & c) << 3 | 7 & c;
                    for (s = 0; s < t; s++) for (c = 0 | s * i, h = a * (4294967288 & c) | (7 & c) << 3, o = 0; o < e; o++) b[m] = f[h + y[o]], m += g;
                  }
                  var w = this.decodeTransform;
                  if (w) for (l = 0; l < v;) for (c = 0, u = 0; c < g; c++, l++, u += 2) b[l] = (b[l] * w[u] >> 8) + w[u + 1];
                  return b;
                },
                _isColorConversionNeeded: function _isColorConversionNeeded() {
                  return !(!this.adobe || !this.adobe.transformCode) || (3 === this.numComponents ? !(!this.adobe && 0 === this.colorTransform) : !this.adobe && 1 === this.colorTransform);
                },
                _convertYccToRgb: function _convertYccToRgb(e) {
                  for (var t, r, n, i = 0, a = e.length; i < a; i += 3) t = e[i], r = e[i + 1], n = e[i + 2], e[i] = c(t - 179.456 + 1.402 * n), e[i + 1] = c(t + 135.459 - .344 * r - .714 * n), e[i + 2] = c(t - 226.816 + 1.772 * r);
                  return e;
                },
                _convertYcckToRgb: function _convertYcckToRgb(e) {
                  for (var t, r, n, i, a = 0, o = 0, s = e.length; o < s; o += 4) {
                    t = e[o], r = e[o + 1], n = e[o + 2], i = e[o + 3];
                    var l = r * (-660635669420364e-19 * r + .000437130475926232 * n - 54080610064599e-18 * t + .00048449797120281 * i - .154362151871126) - 122.67195406894 + n * (-.000957964378445773 * n + .000817076911346625 * t - .00477271405408747 * i + 1.53380253221734) + t * (.000961250184130688 * t - .00266257332283933 * i + .48357088451265) + i * (-.000336197177618394 * i + .484791561490776),
                      u = 107.268039397724 + r * (219927104525741e-19 * r - .000640992018297945 * n + .000659397001245577 * t + .000426105652938837 * i - .176491792462875) + n * (-.000778269941513683 * n + .00130872261408275 * t + .000770482631801132 * i - .151051492775562) + t * (.00126935368114843 * t - .00265090189010898 * i + .25802910206845) + i * (-.000318913117588328 * i - .213742400323665),
                      h = r * (-.000570115196973677 * r - 263409051004589e-19 * n + .0020741088115012 * t - .00288260236853442 * i + .814272968359295) - 20.810012546947 + n * (-153496057440975e-19 * n - .000132689043961446 * t + .000560833691242812 * i - .195152027534049) + t * (.00174418132927582 * t - .00255243321439347 * i + .116935020465145) + i * (-.000343531996510555 * i + .24165260232407);
                    e[a++] = c(l), e[a++] = c(u), e[a++] = c(h);
                  }
                  return e;
                },
                _convertYcckToCmyk: function _convertYcckToCmyk(e) {
                  for (var t, r, n, i = 0, a = e.length; i < a; i += 4) t = e[i], r = e[i + 1], n = e[i + 2], e[i] = c(434.456 - t - 1.402 * n), e[i + 1] = c(119.541 - t + .344 * r + .714 * n), e[i + 2] = c(481.816 - t - 1.772 * r);
                  return e;
                },
                _convertCmykToRgb: function _convertCmykToRgb(e) {
                  for (var t, r, n, i, a = 0, o = -16581375, s = 0, l = e.length; s < l; s += 4) {
                    t = e[s], r = e[s + 1], n = e[s + 2], i = e[s + 3];
                    var c = t * (-4.387332384609988 * t + 54.48615194189176 * r + 18.82290502165302 * n + 212.25662451639585 * i - 72734.4411664936) + r * (1.7149763477362134 * r - 5.6096736904047315 * n - 17.873870861415444 * i - 1401.7366389350734) + n * (-2.5217340131683033 * n - 21.248923337353073 * i + 4465.541406466231) - i * (21.86122147463605 * i + 48317.86113160301),
                      u = t * (8.841041422036149 * t + 60.118027045597366 * r + 6.871425592049007 * n + 31.159100130055922 * i - 20220.756542821975) + r * (-15.310361306967817 * r + 17.575251261109482 * n + 131.35250912493976 * i - 48691.05921601825) + n * (4.444339102852739 * n + 9.8632861493405 * i - 6341.191035517494) - i * (20.737325471181034 * i + 47890.15695978492),
                      h = t * (.8842522430003296 * t + 8.078677503112928 * r + 30.89978309703729 * n - .23883238689178934 * i - 3616.812083916688) + r * (10.49593273432072 * r + 63.02378494754052 * n + 50.606957656360734 * i - 28620.90484698408) + n * (.03296041114873217 * n + 115.60384449646641 * i - 49363.43385999684) - i * (22.33816807309886 * i + 45932.16563550634);
                    e[a++] = c >= 0 ? 255 : c <= o ? 0 : 255 + c * (1 / 255 / 255) | 0, e[a++] = u >= 0 ? 255 : u <= o ? 0 : 255 + u * (1 / 255 / 255) | 0, e[a++] = h >= 0 ? 255 : h <= o ? 0 : 255 + h * (1 / 255 / 255) | 0;
                  }
                  return e;
                },
                getData: function getData(e, t, r) {
                  this.numComponents > 4 && o("JPEG error: Unsupported color mode");
                  var n = this._getLinearizedBlockData(e, t);
                  if (1 === this.numComponents && r) {
                    for (var i = n.length, a = new Uint8Array(3 * i), s = 0, l = 0; l < i; l++) {
                      var c = n[l];
                      a[s++] = c, a[s++] = c, a[s++] = c;
                    }
                    return a;
                  }
                  if (3 === this.numComponents && this._isColorConversionNeeded()) return this._convertYccToRgb(n);
                  if (4 === this.numComponents) {
                    if (this._isColorConversionNeeded()) return r ? this._convertYcckToRgb(n) : this._convertYcckToCmyk(n);
                    if (r) return this._convertCmykToRgb(n);
                  }
                  return n;
                }
              }, e;
            }();
          t.JpegImage = s;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = n.getLookupTableFactory,
            a = i(function (e) {
              e.Courier = 600, e["Courier-Bold"] = 600, e["Courier-BoldOblique"] = 600, e["Courier-Oblique"] = 600, e.Helvetica = i(function (e) {
                e.space = 278, e.exclam = 278, e.quotedbl = 355, e.numbersign = 556, e.dollar = 556, e.percent = 889, e.ampersand = 667, e.quoteright = 222, e.parenleft = 333, e.parenright = 333, e.asterisk = 389, e.plus = 584, e.comma = 278, e.hyphen = 333, e.period = 278, e.slash = 278, e.zero = 556, e.one = 556, e.two = 556, e.three = 556, e.four = 556, e.five = 556, e.six = 556, e.seven = 556, e.eight = 556, e.nine = 556, e.colon = 278, e.semicolon = 278, e.less = 584, e.equal = 584, e.greater = 584, e.question = 556, e.at = 1015, e.A = 667, e.B = 667, e.C = 722, e.D = 722, e.E = 667, e.F = 611, e.G = 778, e.H = 722, e.I = 278, e.J = 500, e.K = 667, e.L = 556, e.M = 833, e.N = 722, e.O = 778, e.P = 667, e.Q = 778, e.R = 722, e.S = 667, e.T = 611, e.U = 722, e.V = 667, e.W = 944, e.X = 667, e.Y = 667, e.Z = 611, e.bracketleft = 278, e.backslash = 278, e.bracketright = 278, e.asciicircum = 469, e.underscore = 556, e.quoteleft = 222, e.a = 556, e.b = 556, e.c = 500, e.d = 556, e.e = 556, e.f = 278, e.g = 556, e.h = 556, e.i = 222, e.j = 222, e.k = 500, e.l = 222, e.m = 833, e.n = 556, e.o = 556, e.p = 556, e.q = 556, e.r = 333, e.s = 500, e.t = 278, e.u = 556, e.v = 500, e.w = 722, e.x = 500, e.y = 500, e.z = 500, e.braceleft = 334, e.bar = 260, e.braceright = 334, e.asciitilde = 584, e.exclamdown = 333, e.cent = 556, e.sterling = 556, e.fraction = 167, e.yen = 556, e.florin = 556, e.section = 556, e.currency = 556, e.quotesingle = 191, e.quotedblleft = 333, e.guillemotleft = 556, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 500, e.fl = 500, e.endash = 556, e.dagger = 556, e.daggerdbl = 556, e.periodcentered = 278, e.paragraph = 537, e.bullet = 350, e.quotesinglbase = 222, e.quotedblbase = 333, e.quotedblright = 333, e.guillemotright = 556, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 611, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 1e3, e.ordfeminine = 370, e.Lslash = 556, e.Oslash = 778, e.OE = 1e3, e.ordmasculine = 365, e.ae = 889, e.dotlessi = 278, e.lslash = 222, e.oslash = 611, e.oe = 944, e.germandbls = 611, e.Idieresis = 278, e.eacute = 556, e.abreve = 556, e.uhungarumlaut = 556, e.ecaron = 556, e.Ydieresis = 667, e.divide = 584, e.Yacute = 667, e.Acircumflex = 667, e.aacute = 556, e.Ucircumflex = 722, e.yacute = 500, e.scommaaccent = 500, e.ecircumflex = 556, e.Uring = 722, e.Udieresis = 722, e.aogonek = 556, e.Uacute = 722, e.uogonek = 556, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 737, e.Emacron = 667, e.ccaron = 500, e.aring = 556, e.Ncommaaccent = 722, e.lacute = 222, e.agrave = 556, e.Tcommaaccent = 611, e.Cacute = 722, e.atilde = 556, e.Edotaccent = 667, e.scaron = 500, e.scedilla = 500, e.iacute = 278, e.lozenge = 471, e.Rcaron = 722, e.Gcommaaccent = 778, e.ucircumflex = 556, e.acircumflex = 556, e.Amacron = 667, e.rcaron = 333, e.ccedilla = 500, e.Zdotaccent = 611, e.Thorn = 667, e.Omacron = 778, e.Racute = 722, e.Sacute = 667, e.dcaron = 643, e.Umacron = 722;
                e.uring = 556, e.threesuperior = 333, e.Ograve = 778, e.Agrave = 667, e.Abreve = 667, e.multiply = 584, e.uacute = 556, e.Tcaron = 611, e.partialdiff = 476, e.ydieresis = 500, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 556, e.edieresis = 556, e.cacute = 500, e.nacute = 556, e.umacron = 556, e.Ncaron = 722, e.Iacute = 278, e.plusminus = 584, e.brokenbar = 260, e.registered = 737, e.Gbreve = 778, e.Idotaccent = 278, e.summation = 600, e.Egrave = 667, e.racute = 333, e.omacron = 556, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 722, e.lcommaaccent = 222, e.tcaron = 317, e.eogonek = 556, e.Uogonek = 722, e.Aacute = 667, e.Adieresis = 667, e.egrave = 556, e.zacute = 500, e.iogonek = 222, e.Oacute = 778, e.oacute = 556, e.amacron = 556, e.sacute = 500, e.idieresis = 278, e.Ocircumflex = 778, e.Ugrave = 722, e.Delta = 612, e.thorn = 556, e.twosuperior = 333, e.Odieresis = 778, e.mu = 556, e.igrave = 278, e.ohungarumlaut = 556, e.Eogonek = 667, e.dcroat = 556, e.threequarters = 834, e.Scedilla = 667, e.lcaron = 299, e.Kcommaaccent = 667, e.Lacute = 556, e.trademark = 1e3, e.edotaccent = 556, e.Igrave = 278, e.Imacron = 278, e.Lcaron = 556, e.onehalf = 834, e.lessequal = 549, e.ocircumflex = 556, e.ntilde = 556, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 556, e.gbreve = 556, e.onequarter = 834, e.Scaron = 667, e.Scommaaccent = 667, e.Ohungarumlaut = 778, e.degree = 400, e.ograve = 556, e.Ccaron = 722, e.ugrave = 556, e.radical = 453, e.Dcaron = 722, e.rcommaaccent = 333, e.Ntilde = 722, e.otilde = 556, e.Rcommaaccent = 722, e.Lcommaaccent = 556, e.Atilde = 667, e.Aogonek = 667, e.Aring = 667, e.Otilde = 778, e.zdotaccent = 500, e.Ecaron = 667, e.Iogonek = 278, e.kcommaaccent = 500, e.minus = 584, e.Icircumflex = 278, e.ncaron = 556, e.tcommaaccent = 278, e.logicalnot = 584, e.odieresis = 556, e.udieresis = 556, e.notequal = 549, e.gcommaaccent = 556, e.eth = 556, e.zcaron = 500, e.ncommaaccent = 556, e.onesuperior = 333, e.imacron = 278, e.Euro = 556;
              }), e["Helvetica-Bold"] = i(function (e) {
                e.space = 278, e.exclam = 333, e.quotedbl = 474, e.numbersign = 556, e.dollar = 556, e.percent = 889, e.ampersand = 722, e.quoteright = 278, e.parenleft = 333, e.parenright = 333, e.asterisk = 389, e.plus = 584, e.comma = 278, e.hyphen = 333, e.period = 278, e.slash = 278, e.zero = 556, e.one = 556, e.two = 556, e.three = 556, e.four = 556, e.five = 556, e.six = 556, e.seven = 556, e.eight = 556, e.nine = 556, e.colon = 333, e.semicolon = 333, e.less = 584, e.equal = 584, e.greater = 584, e.question = 611, e.at = 975, e.A = 722, e.B = 722, e.C = 722, e.D = 722, e.E = 667, e.F = 611, e.G = 778, e.H = 722, e.I = 278, e.J = 556, e.K = 722, e.L = 611, e.M = 833, e.N = 722, e.O = 778, e.P = 667, e.Q = 778, e.R = 722, e.S = 667, e.T = 611, e.U = 722, e.V = 667, e.W = 944, e.X = 667, e.Y = 667, e.Z = 611, e.bracketleft = 333, e.backslash = 278, e.bracketright = 333, e.asciicircum = 584, e.underscore = 556, e.quoteleft = 278, e.a = 556, e.b = 611, e.c = 556, e.d = 611, e.e = 556, e.f = 333, e.g = 611, e.h = 611, e.i = 278, e.j = 278, e.k = 556, e.l = 278, e.m = 889, e.n = 611, e.o = 611, e.p = 611, e.q = 611, e.r = 389, e.s = 556, e.t = 333, e.u = 611, e.v = 556, e.w = 778, e.x = 556, e.y = 556, e.z = 500, e.braceleft = 389, e.bar = 280, e.braceright = 389, e.asciitilde = 584, e.exclamdown = 333, e.cent = 556, e.sterling = 556, e.fraction = 167, e.yen = 556, e.florin = 556, e.section = 556, e.currency = 556, e.quotesingle = 238, e.quotedblleft = 500, e.guillemotleft = 556, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 611, e.fl = 611, e.endash = 556, e.dagger = 556, e.daggerdbl = 556, e.periodcentered = 278, e.paragraph = 556, e.bullet = 350, e.quotesinglbase = 278, e.quotedblbase = 500, e.quotedblright = 500, e.guillemotright = 556, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 611, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 1e3, e.ordfeminine = 370, e.Lslash = 611, e.Oslash = 778, e.OE = 1e3, e.ordmasculine = 365, e.ae = 889, e.dotlessi = 278, e.lslash = 278, e.oslash = 611, e.oe = 944, e.germandbls = 611, e.Idieresis = 278, e.eacute = 556, e.abreve = 556, e.uhungarumlaut = 611, e.ecaron = 556, e.Ydieresis = 667, e.divide = 584, e.Yacute = 667, e.Acircumflex = 722, e.aacute = 556, e.Ucircumflex = 722, e.yacute = 556, e.scommaaccent = 556, e.ecircumflex = 556, e.Uring = 722, e.Udieresis = 722, e.aogonek = 556, e.Uacute = 722, e.uogonek = 611, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 737, e.Emacron = 667, e.ccaron = 556, e.aring = 556, e.Ncommaaccent = 722, e.lacute = 278, e.agrave = 556, e.Tcommaaccent = 611, e.Cacute = 722, e.atilde = 556, e.Edotaccent = 667, e.scaron = 556, e.scedilla = 556, e.iacute = 278, e.lozenge = 494, e.Rcaron = 722, e.Gcommaaccent = 778, e.ucircumflex = 611, e.acircumflex = 556, e.Amacron = 722, e.rcaron = 389, e.ccedilla = 556, e.Zdotaccent = 611, e.Thorn = 667, e.Omacron = 778, e.Racute = 722, e.Sacute = 667, e.dcaron = 743, e.Umacron = 722;
                e.uring = 611, e.threesuperior = 333, e.Ograve = 778, e.Agrave = 722, e.Abreve = 722, e.multiply = 584, e.uacute = 611, e.Tcaron = 611, e.partialdiff = 494, e.ydieresis = 556, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 556, e.edieresis = 556, e.cacute = 556, e.nacute = 611, e.umacron = 611, e.Ncaron = 722, e.Iacute = 278, e.plusminus = 584, e.brokenbar = 280, e.registered = 737, e.Gbreve = 778, e.Idotaccent = 278, e.summation = 600, e.Egrave = 667, e.racute = 389, e.omacron = 611, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 722, e.lcommaaccent = 278, e.tcaron = 389, e.eogonek = 556, e.Uogonek = 722, e.Aacute = 722, e.Adieresis = 722, e.egrave = 556, e.zacute = 500, e.iogonek = 278, e.Oacute = 778, e.oacute = 611, e.amacron = 556, e.sacute = 556, e.idieresis = 278, e.Ocircumflex = 778, e.Ugrave = 722, e.Delta = 612, e.thorn = 611, e.twosuperior = 333, e.Odieresis = 778, e.mu = 611, e.igrave = 278, e.ohungarumlaut = 611, e.Eogonek = 667, e.dcroat = 611, e.threequarters = 834, e.Scedilla = 667, e.lcaron = 400, e.Kcommaaccent = 722, e.Lacute = 611, e.trademark = 1e3, e.edotaccent = 556, e.Igrave = 278, e.Imacron = 278, e.Lcaron = 611, e.onehalf = 834, e.lessequal = 549, e.ocircumflex = 611, e.ntilde = 611, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 556, e.gbreve = 611, e.onequarter = 834, e.Scaron = 667, e.Scommaaccent = 667, e.Ohungarumlaut = 778, e.degree = 400, e.ograve = 611, e.Ccaron = 722, e.ugrave = 611, e.radical = 549, e.Dcaron = 722, e.rcommaaccent = 389, e.Ntilde = 722, e.otilde = 611, e.Rcommaaccent = 722, e.Lcommaaccent = 611, e.Atilde = 722, e.Aogonek = 722, e.Aring = 722, e.Otilde = 778, e.zdotaccent = 500, e.Ecaron = 667, e.Iogonek = 278, e.kcommaaccent = 556, e.minus = 584, e.Icircumflex = 278, e.ncaron = 611, e.tcommaaccent = 333, e.logicalnot = 584, e.odieresis = 611, e.udieresis = 611, e.notequal = 549, e.gcommaaccent = 611, e.eth = 611, e.zcaron = 500, e.ncommaaccent = 611, e.onesuperior = 333, e.imacron = 278, e.Euro = 556;
              }), e["Helvetica-BoldOblique"] = i(function (e) {
                e.space = 278, e.exclam = 333, e.quotedbl = 474, e.numbersign = 556, e.dollar = 556, e.percent = 889, e.ampersand = 722, e.quoteright = 278, e.parenleft = 333, e.parenright = 333, e.asterisk = 389, e.plus = 584, e.comma = 278, e.hyphen = 333, e.period = 278, e.slash = 278, e.zero = 556, e.one = 556, e.two = 556, e.three = 556, e.four = 556, e.five = 556, e.six = 556, e.seven = 556, e.eight = 556, e.nine = 556, e.colon = 333, e.semicolon = 333, e.less = 584, e.equal = 584, e.greater = 584, e.question = 611, e.at = 975, e.A = 722, e.B = 722, e.C = 722, e.D = 722, e.E = 667, e.F = 611, e.G = 778, e.H = 722, e.I = 278, e.J = 556, e.K = 722, e.L = 611, e.M = 833, e.N = 722, e.O = 778, e.P = 667, e.Q = 778, e.R = 722, e.S = 667, e.T = 611, e.U = 722, e.V = 667, e.W = 944, e.X = 667, e.Y = 667, e.Z = 611, e.bracketleft = 333, e.backslash = 278, e.bracketright = 333, e.asciicircum = 584, e.underscore = 556, e.quoteleft = 278, e.a = 556, e.b = 611, e.c = 556, e.d = 611, e.e = 556, e.f = 333, e.g = 611, e.h = 611, e.i = 278, e.j = 278, e.k = 556, e.l = 278, e.m = 889, e.n = 611, e.o = 611, e.p = 611, e.q = 611, e.r = 389, e.s = 556, e.t = 333, e.u = 611, e.v = 556, e.w = 778, e.x = 556, e.y = 556, e.z = 500, e.braceleft = 389, e.bar = 280, e.braceright = 389, e.asciitilde = 584, e.exclamdown = 333, e.cent = 556, e.sterling = 556, e.fraction = 167, e.yen = 556, e.florin = 556, e.section = 556, e.currency = 556, e.quotesingle = 238, e.quotedblleft = 500, e.guillemotleft = 556, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 611, e.fl = 611, e.endash = 556, e.dagger = 556, e.daggerdbl = 556, e.periodcentered = 278, e.paragraph = 556, e.bullet = 350, e.quotesinglbase = 278, e.quotedblbase = 500, e.quotedblright = 500, e.guillemotright = 556, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 611, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 1e3, e.ordfeminine = 370, e.Lslash = 611, e.Oslash = 778, e.OE = 1e3, e.ordmasculine = 365, e.ae = 889, e.dotlessi = 278, e.lslash = 278, e.oslash = 611, e.oe = 944, e.germandbls = 611, e.Idieresis = 278, e.eacute = 556, e.abreve = 556, e.uhungarumlaut = 611, e.ecaron = 556, e.Ydieresis = 667, e.divide = 584, e.Yacute = 667, e.Acircumflex = 722, e.aacute = 556, e.Ucircumflex = 722, e.yacute = 556, e.scommaaccent = 556, e.ecircumflex = 556, e.Uring = 722, e.Udieresis = 722, e.aogonek = 556, e.Uacute = 722, e.uogonek = 611, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 737, e.Emacron = 667, e.ccaron = 556, e.aring = 556, e.Ncommaaccent = 722, e.lacute = 278, e.agrave = 556, e.Tcommaaccent = 611, e.Cacute = 722, e.atilde = 556, e.Edotaccent = 667, e.scaron = 556, e.scedilla = 556, e.iacute = 278, e.lozenge = 494, e.Rcaron = 722, e.Gcommaaccent = 778, e.ucircumflex = 611, e.acircumflex = 556, e.Amacron = 722, e.rcaron = 389, e.ccedilla = 556, e.Zdotaccent = 611, e.Thorn = 667, e.Omacron = 778, e.Racute = 722, e.Sacute = 667, e.dcaron = 743, e.Umacron = 722;
                e.uring = 611, e.threesuperior = 333, e.Ograve = 778, e.Agrave = 722, e.Abreve = 722, e.multiply = 584, e.uacute = 611, e.Tcaron = 611, e.partialdiff = 494, e.ydieresis = 556, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 556, e.edieresis = 556, e.cacute = 556, e.nacute = 611, e.umacron = 611, e.Ncaron = 722, e.Iacute = 278, e.plusminus = 584, e.brokenbar = 280, e.registered = 737, e.Gbreve = 778, e.Idotaccent = 278, e.summation = 600, e.Egrave = 667, e.racute = 389, e.omacron = 611, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 722, e.lcommaaccent = 278, e.tcaron = 389, e.eogonek = 556, e.Uogonek = 722, e.Aacute = 722, e.Adieresis = 722, e.egrave = 556, e.zacute = 500, e.iogonek = 278, e.Oacute = 778, e.oacute = 611, e.amacron = 556, e.sacute = 556, e.idieresis = 278, e.Ocircumflex = 778, e.Ugrave = 722, e.Delta = 612, e.thorn = 611, e.twosuperior = 333, e.Odieresis = 778, e.mu = 611, e.igrave = 278, e.ohungarumlaut = 611, e.Eogonek = 667, e.dcroat = 611, e.threequarters = 834, e.Scedilla = 667, e.lcaron = 400, e.Kcommaaccent = 722, e.Lacute = 611, e.trademark = 1e3, e.edotaccent = 556, e.Igrave = 278, e.Imacron = 278, e.Lcaron = 611, e.onehalf = 834, e.lessequal = 549, e.ocircumflex = 611, e.ntilde = 611, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 556, e.gbreve = 611, e.onequarter = 834, e.Scaron = 667, e.Scommaaccent = 667, e.Ohungarumlaut = 778, e.degree = 400, e.ograve = 611, e.Ccaron = 722, e.ugrave = 611, e.radical = 549, e.Dcaron = 722, e.rcommaaccent = 389, e.Ntilde = 722, e.otilde = 611, e.Rcommaaccent = 722, e.Lcommaaccent = 611, e.Atilde = 722, e.Aogonek = 722, e.Aring = 722, e.Otilde = 778, e.zdotaccent = 500, e.Ecaron = 667, e.Iogonek = 278, e.kcommaaccent = 556, e.minus = 584, e.Icircumflex = 278, e.ncaron = 611, e.tcommaaccent = 333, e.logicalnot = 584, e.odieresis = 611, e.udieresis = 611, e.notequal = 549, e.gcommaaccent = 611, e.eth = 611, e.zcaron = 500, e.ncommaaccent = 611, e.onesuperior = 333, e.imacron = 278, e.Euro = 556;
              }), e["Helvetica-Oblique"] = i(function (e) {
                e.space = 278, e.exclam = 278, e.quotedbl = 355, e.numbersign = 556, e.dollar = 556, e.percent = 889, e.ampersand = 667, e.quoteright = 222, e.parenleft = 333, e.parenright = 333, e.asterisk = 389, e.plus = 584, e.comma = 278, e.hyphen = 333, e.period = 278, e.slash = 278, e.zero = 556, e.one = 556, e.two = 556, e.three = 556, e.four = 556, e.five = 556, e.six = 556, e.seven = 556, e.eight = 556, e.nine = 556, e.colon = 278, e.semicolon = 278, e.less = 584, e.equal = 584, e.greater = 584, e.question = 556, e.at = 1015, e.A = 667, e.B = 667, e.C = 722, e.D = 722, e.E = 667, e.F = 611, e.G = 778, e.H = 722, e.I = 278, e.J = 500, e.K = 667, e.L = 556, e.M = 833, e.N = 722, e.O = 778, e.P = 667, e.Q = 778, e.R = 722, e.S = 667, e.T = 611, e.U = 722, e.V = 667, e.W = 944, e.X = 667, e.Y = 667, e.Z = 611, e.bracketleft = 278, e.backslash = 278, e.bracketright = 278, e.asciicircum = 469, e.underscore = 556, e.quoteleft = 222, e.a = 556, e.b = 556, e.c = 500, e.d = 556, e.e = 556, e.f = 278, e.g = 556, e.h = 556, e.i = 222, e.j = 222, e.k = 500, e.l = 222, e.m = 833, e.n = 556, e.o = 556, e.p = 556, e.q = 556, e.r = 333, e.s = 500, e.t = 278, e.u = 556, e.v = 500, e.w = 722, e.x = 500, e.y = 500, e.z = 500, e.braceleft = 334, e.bar = 260, e.braceright = 334, e.asciitilde = 584, e.exclamdown = 333, e.cent = 556, e.sterling = 556, e.fraction = 167, e.yen = 556, e.florin = 556, e.section = 556, e.currency = 556, e.quotesingle = 191, e.quotedblleft = 333, e.guillemotleft = 556, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 500, e.fl = 500, e.endash = 556, e.dagger = 556, e.daggerdbl = 556, e.periodcentered = 278, e.paragraph = 537, e.bullet = 350, e.quotesinglbase = 222, e.quotedblbase = 333, e.quotedblright = 333, e.guillemotright = 556, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 611, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 1e3, e.ordfeminine = 370, e.Lslash = 556, e.Oslash = 778, e.OE = 1e3, e.ordmasculine = 365, e.ae = 889, e.dotlessi = 278, e.lslash = 222, e.oslash = 611, e.oe = 944, e.germandbls = 611, e.Idieresis = 278, e.eacute = 556, e.abreve = 556, e.uhungarumlaut = 556, e.ecaron = 556, e.Ydieresis = 667, e.divide = 584, e.Yacute = 667, e.Acircumflex = 667, e.aacute = 556, e.Ucircumflex = 722, e.yacute = 500, e.scommaaccent = 500, e.ecircumflex = 556, e.Uring = 722, e.Udieresis = 722, e.aogonek = 556, e.Uacute = 722, e.uogonek = 556, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 737, e.Emacron = 667, e.ccaron = 500, e.aring = 556, e.Ncommaaccent = 722, e.lacute = 222, e.agrave = 556, e.Tcommaaccent = 611, e.Cacute = 722, e.atilde = 556, e.Edotaccent = 667, e.scaron = 500, e.scedilla = 500, e.iacute = 278, e.lozenge = 471, e.Rcaron = 722, e.Gcommaaccent = 778, e.ucircumflex = 556, e.acircumflex = 556, e.Amacron = 667, e.rcaron = 333, e.ccedilla = 500, e.Zdotaccent = 611, e.Thorn = 667, e.Omacron = 778, e.Racute = 722, e.Sacute = 667, e.dcaron = 643, e.Umacron = 722;
                e.uring = 556, e.threesuperior = 333, e.Ograve = 778, e.Agrave = 667, e.Abreve = 667, e.multiply = 584, e.uacute = 556, e.Tcaron = 611, e.partialdiff = 476, e.ydieresis = 500, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 556, e.edieresis = 556, e.cacute = 500, e.nacute = 556, e.umacron = 556, e.Ncaron = 722, e.Iacute = 278, e.plusminus = 584, e.brokenbar = 260, e.registered = 737, e.Gbreve = 778, e.Idotaccent = 278, e.summation = 600, e.Egrave = 667, e.racute = 333, e.omacron = 556, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 722, e.lcommaaccent = 222, e.tcaron = 317, e.eogonek = 556, e.Uogonek = 722, e.Aacute = 667, e.Adieresis = 667, e.egrave = 556, e.zacute = 500, e.iogonek = 222, e.Oacute = 778, e.oacute = 556, e.amacron = 556, e.sacute = 500, e.idieresis = 278, e.Ocircumflex = 778, e.Ugrave = 722, e.Delta = 612, e.thorn = 556, e.twosuperior = 333, e.Odieresis = 778, e.mu = 556, e.igrave = 278, e.ohungarumlaut = 556, e.Eogonek = 667, e.dcroat = 556, e.threequarters = 834, e.Scedilla = 667, e.lcaron = 299, e.Kcommaaccent = 667, e.Lacute = 556, e.trademark = 1e3, e.edotaccent = 556, e.Igrave = 278, e.Imacron = 278, e.Lcaron = 556, e.onehalf = 834, e.lessequal = 549, e.ocircumflex = 556, e.ntilde = 556, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 556, e.gbreve = 556, e.onequarter = 834, e.Scaron = 667, e.Scommaaccent = 667, e.Ohungarumlaut = 778, e.degree = 400, e.ograve = 556, e.Ccaron = 722, e.ugrave = 556, e.radical = 453, e.Dcaron = 722, e.rcommaaccent = 333, e.Ntilde = 722, e.otilde = 556, e.Rcommaaccent = 722, e.Lcommaaccent = 556, e.Atilde = 667, e.Aogonek = 667, e.Aring = 667, e.Otilde = 778, e.zdotaccent = 500, e.Ecaron = 667, e.Iogonek = 278, e.kcommaaccent = 500, e.minus = 584, e.Icircumflex = 278, e.ncaron = 556, e.tcommaaccent = 278, e.logicalnot = 584, e.odieresis = 556, e.udieresis = 556, e.notequal = 549, e.gcommaaccent = 556, e.eth = 556, e.zcaron = 500, e.ncommaaccent = 556, e.onesuperior = 333, e.imacron = 278, e.Euro = 556;
              }), e.Symbol = i(function (e) {
                e.space = 250, e.exclam = 333, e.universal = 713, e.numbersign = 500, e.existential = 549, e.percent = 833, e.ampersand = 778, e.suchthat = 439, e.parenleft = 333, e.parenright = 333, e.asteriskmath = 500, e.plus = 549, e.comma = 250, e.minus = 549, e.period = 250, e.slash = 278, e.zero = 500, e.one = 500, e.two = 500, e.three = 500, e.four = 500, e.five = 500, e.six = 500, e.seven = 500, e.eight = 500, e.nine = 500, e.colon = 278, e.semicolon = 278, e.less = 549, e.equal = 549, e.greater = 549, e.question = 444, e.congruent = 549, e.Alpha = 722, e.Beta = 667, e.Chi = 722, e.Delta = 612, e.Epsilon = 611, e.Phi = 763, e.Gamma = 603, e.Eta = 722, e.Iota = 333, e.theta1 = 631, e.Kappa = 722, e.Lambda = 686, e.Mu = 889, e.Nu = 722, e.Omicron = 722, e.Pi = 768, e.Theta = 741, e.Rho = 556, e.Sigma = 592, e.Tau = 611, e.Upsilon = 690, e.sigma1 = 439, e.Omega = 768, e.Xi = 645, e.Psi = 795, e.Zeta = 611, e.bracketleft = 333, e.therefore = 863, e.bracketright = 333, e.perpendicular = 658, e.underscore = 500, e.radicalex = 500, e.alpha = 631, e.beta = 549, e.chi = 549, e.delta = 494, e.epsilon = 439, e.phi = 521, e.gamma = 411, e.eta = 603, e.iota = 329, e.phi1 = 603, e.kappa = 549, e.lambda = 549, e.mu = 576, e.nu = 521, e.omicron = 549, e.pi = 549, e.theta = 521, e.rho = 549, e.sigma = 603, e.tau = 439, e.upsilon = 576, e.omega1 = 713, e.omega = 686, e.xi = 493, e.psi = 686, e.zeta = 494, e.braceleft = 480, e.bar = 200, e.braceright = 480, e.similar = 549, e.Euro = 750, e.Upsilon1 = 620, e.minute = 247, e.lessequal = 549, e.fraction = 167, e.infinity = 713, e.florin = 500, e.club = 753, e.diamond = 753, e.heart = 753, e.spade = 753, e.arrowboth = 1042, e.arrowleft = 987, e.arrowup = 603, e.arrowright = 987, e.arrowdown = 603, e.degree = 400, e.plusminus = 549, e.second = 411, e.greaterequal = 549, e.multiply = 549, e.proportional = 713, e.partialdiff = 494, e.bullet = 460, e.divide = 549, e.notequal = 549, e.equivalence = 549, e.approxequal = 549, e.ellipsis = 1e3, e.arrowvertex = 603, e.arrowhorizex = 1e3, e.carriagereturn = 658, e.aleph = 823, e.Ifraktur = 686, e.Rfraktur = 795, e.weierstrass = 987, e.circlemultiply = 768, e.circleplus = 768, e.emptyset = 823, e.intersection = 768, e.union = 768, e.propersuperset = 713, e.reflexsuperset = 713, e.notsubset = 713, e.propersubset = 713, e.reflexsubset = 713, e.element = 713, e.notelement = 713, e.angle = 768, e.gradient = 713, e.registerserif = 790, e.copyrightserif = 790, e.trademarkserif = 890, e.product = 823, e.radical = 549, e.dotmath = 250, e.logicalnot = 713, e.logicaland = 603, e.logicalor = 603, e.arrowdblboth = 1042, e.arrowdblleft = 987, e.arrowdblup = 603, e.arrowdblright = 987, e.arrowdbldown = 603, e.lozenge = 494, e.angleleft = 329, e.registersans = 790, e.copyrightsans = 790, e.trademarksans = 786, e.summation = 713, e.parenlefttp = 384, e.parenleftex = 384, e.parenleftbt = 384, e.bracketlefttp = 384, e.bracketleftex = 384, e.bracketleftbt = 384, e.bracelefttp = 494, e.braceleftmid = 494, e.braceleftbt = 494, e.braceex = 494, e.angleright = 329, e.integral = 274, e.integraltp = 686, e.integralex = 686, e.integralbt = 686, e.parenrighttp = 384, e.parenrightex = 384, e.parenrightbt = 384, e.bracketrighttp = 384, e.bracketrightex = 384, e.bracketrightbt = 384, e.bracerighttp = 494, e.bracerightmid = 494, e.bracerightbt = 494, e.apple = 790;
              }), e["Times-Roman"] = i(function (e) {
                e.space = 250, e.exclam = 333, e.quotedbl = 408, e.numbersign = 500, e.dollar = 500, e.percent = 833, e.ampersand = 778, e.quoteright = 333, e.parenleft = 333, e.parenright = 333, e.asterisk = 500, e.plus = 564, e.comma = 250, e.hyphen = 333, e.period = 250, e.slash = 278, e.zero = 500, e.one = 500, e.two = 500, e.three = 500, e.four = 500, e.five = 500, e.six = 500, e.seven = 500, e.eight = 500, e.nine = 500, e.colon = 278, e.semicolon = 278, e.less = 564, e.equal = 564, e.greater = 564, e.question = 444, e.at = 921, e.A = 722, e.B = 667, e.C = 667, e.D = 722, e.E = 611, e.F = 556, e.G = 722, e.H = 722, e.I = 333, e.J = 389, e.K = 722, e.L = 611, e.M = 889, e.N = 722, e.O = 722, e.P = 556, e.Q = 722, e.R = 667, e.S = 556, e.T = 611, e.U = 722, e.V = 722, e.W = 944, e.X = 722, e.Y = 722, e.Z = 611, e.bracketleft = 333, e.backslash = 278, e.bracketright = 333, e.asciicircum = 469, e.underscore = 500, e.quoteleft = 333, e.a = 444, e.b = 500, e.c = 444, e.d = 500, e.e = 444, e.f = 333, e.g = 500, e.h = 500, e.i = 278, e.j = 278, e.k = 500, e.l = 278, e.m = 778, e.n = 500, e.o = 500, e.p = 500, e.q = 500, e.r = 333, e.s = 389, e.t = 278, e.u = 500, e.v = 500, e.w = 722, e.x = 500, e.y = 500, e.z = 444, e.braceleft = 480, e.bar = 200, e.braceright = 480, e.asciitilde = 541, e.exclamdown = 333, e.cent = 500, e.sterling = 500, e.fraction = 167, e.yen = 500, e.florin = 500, e.section = 500, e.currency = 500, e.quotesingle = 180, e.quotedblleft = 444, e.guillemotleft = 500, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 556, e.fl = 556, e.endash = 500, e.dagger = 500, e.daggerdbl = 500, e.periodcentered = 250, e.paragraph = 453, e.bullet = 350, e.quotesinglbase = 333, e.quotedblbase = 444, e.quotedblright = 444, e.guillemotright = 500, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 444, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 889, e.ordfeminine = 276, e.Lslash = 611, e.Oslash = 722, e.OE = 889, e.ordmasculine = 310, e.ae = 667, e.dotlessi = 278, e.lslash = 278, e.oslash = 500, e.oe = 722, e.germandbls = 500, e.Idieresis = 333, e.eacute = 444, e.abreve = 444, e.uhungarumlaut = 500, e.ecaron = 444, e.Ydieresis = 722, e.divide = 564, e.Yacute = 722, e.Acircumflex = 722, e.aacute = 444, e.Ucircumflex = 722, e.yacute = 500, e.scommaaccent = 389, e.ecircumflex = 444, e.Uring = 722, e.Udieresis = 722, e.aogonek = 444, e.Uacute = 722, e.uogonek = 500, e.Edieresis = 611, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 760, e.Emacron = 611, e.ccaron = 444, e.aring = 444, e.Ncommaaccent = 722, e.lacute = 278, e.agrave = 444, e.Tcommaaccent = 611, e.Cacute = 667, e.atilde = 444, e.Edotaccent = 611, e.scaron = 389, e.scedilla = 389, e.iacute = 278, e.lozenge = 471, e.Rcaron = 667, e.Gcommaaccent = 722, e.ucircumflex = 500, e.acircumflex = 444, e.Amacron = 722, e.rcaron = 333, e.ccedilla = 444, e.Zdotaccent = 611, e.Thorn = 556, e.Omacron = 722, e.Racute = 667, e.Sacute = 556, e.dcaron = 588, e.Umacron = 722;
                e.uring = 500, e.threesuperior = 300, e.Ograve = 722, e.Agrave = 722, e.Abreve = 722, e.multiply = 564, e.uacute = 500, e.Tcaron = 611, e.partialdiff = 476, e.ydieresis = 500, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 611, e.adieresis = 444, e.edieresis = 444, e.cacute = 444, e.nacute = 500, e.umacron = 500, e.Ncaron = 722, e.Iacute = 333, e.plusminus = 564, e.brokenbar = 200, e.registered = 760, e.Gbreve = 722, e.Idotaccent = 333, e.summation = 600, e.Egrave = 611, e.racute = 333, e.omacron = 500, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 667, e.lcommaaccent = 278, e.tcaron = 326, e.eogonek = 444, e.Uogonek = 722, e.Aacute = 722, e.Adieresis = 722, e.egrave = 444, e.zacute = 444, e.iogonek = 278, e.Oacute = 722, e.oacute = 500, e.amacron = 444, e.sacute = 389, e.idieresis = 278, e.Ocircumflex = 722, e.Ugrave = 722, e.Delta = 612, e.thorn = 500, e.twosuperior = 300, e.Odieresis = 722, e.mu = 500, e.igrave = 278, e.ohungarumlaut = 500, e.Eogonek = 611, e.dcroat = 500, e.threequarters = 750, e.Scedilla = 556, e.lcaron = 344, e.Kcommaaccent = 722, e.Lacute = 611, e.trademark = 980, e.edotaccent = 444, e.Igrave = 333, e.Imacron = 333, e.Lcaron = 611, e.onehalf = 750, e.lessequal = 549, e.ocircumflex = 500, e.ntilde = 500, e.Uhungarumlaut = 722, e.Eacute = 611, e.emacron = 444, e.gbreve = 500, e.onequarter = 750, e.Scaron = 556, e.Scommaaccent = 556, e.Ohungarumlaut = 722, e.degree = 400, e.ograve = 500, e.Ccaron = 667, e.ugrave = 500, e.radical = 453, e.Dcaron = 722, e.rcommaaccent = 333, e.Ntilde = 722, e.otilde = 500, e.Rcommaaccent = 667, e.Lcommaaccent = 611, e.Atilde = 722, e.Aogonek = 722, e.Aring = 722, e.Otilde = 722, e.zdotaccent = 444, e.Ecaron = 611, e.Iogonek = 333, e.kcommaaccent = 500, e.minus = 564, e.Icircumflex = 333, e.ncaron = 500, e.tcommaaccent = 278, e.logicalnot = 564, e.odieresis = 500, e.udieresis = 500, e.notequal = 549, e.gcommaaccent = 500, e.eth = 500, e.zcaron = 444, e.ncommaaccent = 500, e.onesuperior = 300, e.imacron = 278, e.Euro = 500;
              }), e["Times-Bold"] = i(function (e) {
                e.space = 250, e.exclam = 333, e.quotedbl = 555, e.numbersign = 500, e.dollar = 500, e.percent = 1e3, e.ampersand = 833, e.quoteright = 333, e.parenleft = 333, e.parenright = 333, e.asterisk = 500, e.plus = 570, e.comma = 250, e.hyphen = 333, e.period = 250, e.slash = 278, e.zero = 500, e.one = 500, e.two = 500, e.three = 500, e.four = 500, e.five = 500, e.six = 500, e.seven = 500, e.eight = 500, e.nine = 500, e.colon = 333, e.semicolon = 333, e.less = 570, e.equal = 570, e.greater = 570, e.question = 500, e.at = 930, e.A = 722, e.B = 667, e.C = 722, e.D = 722, e.E = 667, e.F = 611, e.G = 778, e.H = 778, e.I = 389, e.J = 500, e.K = 778, e.L = 667, e.M = 944, e.N = 722, e.O = 778, e.P = 611, e.Q = 778, e.R = 722, e.S = 556, e.T = 667, e.U = 722, e.V = 722, e.W = 1e3, e.X = 722, e.Y = 722, e.Z = 667, e.bracketleft = 333, e.backslash = 278, e.bracketright = 333, e.asciicircum = 581, e.underscore = 500, e.quoteleft = 333, e.a = 500, e.b = 556, e.c = 444, e.d = 556, e.e = 444, e.f = 333, e.g = 500, e.h = 556, e.i = 278, e.j = 333, e.k = 556, e.l = 278, e.m = 833, e.n = 556, e.o = 500, e.p = 556, e.q = 556, e.r = 444, e.s = 389, e.t = 333, e.u = 556, e.v = 500, e.w = 722, e.x = 500, e.y = 500, e.z = 444, e.braceleft = 394, e.bar = 220, e.braceright = 394, e.asciitilde = 520, e.exclamdown = 333, e.cent = 500, e.sterling = 500, e.fraction = 167, e.yen = 500, e.florin = 500, e.section = 500, e.currency = 500, e.quotesingle = 278, e.quotedblleft = 500, e.guillemotleft = 500, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 556, e.fl = 556, e.endash = 500, e.dagger = 500, e.daggerdbl = 500, e.periodcentered = 250, e.paragraph = 540, e.bullet = 350, e.quotesinglbase = 333, e.quotedblbase = 500, e.quotedblright = 500, e.guillemotright = 500, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 500, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 1e3, e.ordfeminine = 300, e.Lslash = 667, e.Oslash = 778, e.OE = 1e3, e.ordmasculine = 330, e.ae = 722, e.dotlessi = 278, e.lslash = 278, e.oslash = 500, e.oe = 722, e.germandbls = 556, e.Idieresis = 389, e.eacute = 444, e.abreve = 500, e.uhungarumlaut = 556, e.ecaron = 444, e.Ydieresis = 722, e.divide = 570, e.Yacute = 722, e.Acircumflex = 722, e.aacute = 500, e.Ucircumflex = 722, e.yacute = 500, e.scommaaccent = 389, e.ecircumflex = 444, e.Uring = 722, e.Udieresis = 722, e.aogonek = 500, e.Uacute = 722, e.uogonek = 556, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 747, e.Emacron = 667, e.ccaron = 444, e.aring = 500, e.Ncommaaccent = 722, e.lacute = 278, e.agrave = 500, e.Tcommaaccent = 667, e.Cacute = 722, e.atilde = 500, e.Edotaccent = 667, e.scaron = 389, e.scedilla = 389, e.iacute = 278, e.lozenge = 494, e.Rcaron = 722, e.Gcommaaccent = 778, e.ucircumflex = 556, e.acircumflex = 500, e.Amacron = 722, e.rcaron = 444, e.ccedilla = 444, e.Zdotaccent = 667, e.Thorn = 611, e.Omacron = 778, e.Racute = 722, e.Sacute = 556, e.dcaron = 672, e.Umacron = 722;
                e.uring = 556, e.threesuperior = 300, e.Ograve = 778, e.Agrave = 722, e.Abreve = 722, e.multiply = 570, e.uacute = 556, e.Tcaron = 667, e.partialdiff = 494, e.ydieresis = 500, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 500, e.edieresis = 444, e.cacute = 444, e.nacute = 556, e.umacron = 556, e.Ncaron = 722, e.Iacute = 389, e.plusminus = 570, e.brokenbar = 220, e.registered = 747, e.Gbreve = 778, e.Idotaccent = 389, e.summation = 600, e.Egrave = 667, e.racute = 444, e.omacron = 500, e.Zacute = 667, e.Zcaron = 667, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 722, e.lcommaaccent = 278, e.tcaron = 416, e.eogonek = 444, e.Uogonek = 722, e.Aacute = 722, e.Adieresis = 722, e.egrave = 444, e.zacute = 444, e.iogonek = 278, e.Oacute = 778, e.oacute = 500, e.amacron = 500, e.sacute = 389, e.idieresis = 278, e.Ocircumflex = 778, e.Ugrave = 722, e.Delta = 612, e.thorn = 556, e.twosuperior = 300, e.Odieresis = 778, e.mu = 556, e.igrave = 278, e.ohungarumlaut = 500, e.Eogonek = 667, e.dcroat = 556, e.threequarters = 750, e.Scedilla = 556, e.lcaron = 394, e.Kcommaaccent = 778, e.Lacute = 667, e.trademark = 1e3, e.edotaccent = 444, e.Igrave = 389, e.Imacron = 389, e.Lcaron = 667, e.onehalf = 750, e.lessequal = 549, e.ocircumflex = 500, e.ntilde = 556, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 444, e.gbreve = 500, e.onequarter = 750, e.Scaron = 556, e.Scommaaccent = 556, e.Ohungarumlaut = 778, e.degree = 400, e.ograve = 500, e.Ccaron = 722, e.ugrave = 556, e.radical = 549, e.Dcaron = 722, e.rcommaaccent = 444, e.Ntilde = 722, e.otilde = 500, e.Rcommaaccent = 722, e.Lcommaaccent = 667, e.Atilde = 722, e.Aogonek = 722, e.Aring = 722, e.Otilde = 778, e.zdotaccent = 444, e.Ecaron = 667, e.Iogonek = 389, e.kcommaaccent = 556, e.minus = 570, e.Icircumflex = 389, e.ncaron = 556, e.tcommaaccent = 333, e.logicalnot = 570, e.odieresis = 500, e.udieresis = 556, e.notequal = 549, e.gcommaaccent = 500, e.eth = 500, e.zcaron = 444, e.ncommaaccent = 556, e.onesuperior = 300, e.imacron = 278, e.Euro = 500;
              }), e["Times-BoldItalic"] = i(function (e) {
                e.space = 250, e.exclam = 389, e.quotedbl = 555, e.numbersign = 500, e.dollar = 500, e.percent = 833, e.ampersand = 778, e.quoteright = 333, e.parenleft = 333, e.parenright = 333, e.asterisk = 500, e.plus = 570, e.comma = 250, e.hyphen = 333, e.period = 250, e.slash = 278, e.zero = 500, e.one = 500, e.two = 500, e.three = 500, e.four = 500, e.five = 500, e.six = 500, e.seven = 500, e.eight = 500, e.nine = 500, e.colon = 333, e.semicolon = 333, e.less = 570, e.equal = 570, e.greater = 570, e.question = 500, e.at = 832, e.A = 667, e.B = 667, e.C = 667, e.D = 722, e.E = 667, e.F = 667, e.G = 722, e.H = 778, e.I = 389, e.J = 500, e.K = 667, e.L = 611, e.M = 889, e.N = 722, e.O = 722, e.P = 611, e.Q = 722, e.R = 667, e.S = 556, e.T = 611, e.U = 722, e.V = 667, e.W = 889, e.X = 667, e.Y = 611, e.Z = 611, e.bracketleft = 333, e.backslash = 278, e.bracketright = 333, e.asciicircum = 570, e.underscore = 500, e.quoteleft = 333, e.a = 500, e.b = 500, e.c = 444, e.d = 500, e.e = 444, e.f = 333, e.g = 500, e.h = 556, e.i = 278, e.j = 278, e.k = 500, e.l = 278, e.m = 778, e.n = 556, e.o = 500, e.p = 500, e.q = 500, e.r = 389, e.s = 389, e.t = 278, e.u = 556, e.v = 444, e.w = 667, e.x = 500, e.y = 444, e.z = 389, e.braceleft = 348, e.bar = 220, e.braceright = 348, e.asciitilde = 570, e.exclamdown = 389, e.cent = 500, e.sterling = 500, e.fraction = 167, e.yen = 500, e.florin = 500, e.section = 500, e.currency = 500, e.quotesingle = 278, e.quotedblleft = 500, e.guillemotleft = 500, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 556, e.fl = 556, e.endash = 500, e.dagger = 500, e.daggerdbl = 500, e.periodcentered = 250, e.paragraph = 500, e.bullet = 350, e.quotesinglbase = 333, e.quotedblbase = 500, e.quotedblright = 500, e.guillemotright = 500, e.ellipsis = 1e3, e.perthousand = 1e3, e.questiondown = 500, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 1e3, e.AE = 944, e.ordfeminine = 266, e.Lslash = 611, e.Oslash = 722, e.OE = 944, e.ordmasculine = 300, e.ae = 722, e.dotlessi = 278, e.lslash = 278, e.oslash = 500, e.oe = 722, e.germandbls = 500, e.Idieresis = 389, e.eacute = 444, e.abreve = 500, e.uhungarumlaut = 556, e.ecaron = 444, e.Ydieresis = 611, e.divide = 570, e.Yacute = 611, e.Acircumflex = 667, e.aacute = 500, e.Ucircumflex = 722, e.yacute = 444, e.scommaaccent = 389, e.ecircumflex = 444, e.Uring = 722, e.Udieresis = 722, e.aogonek = 500, e.Uacute = 722, e.uogonek = 556, e.Edieresis = 667, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 747, e.Emacron = 667, e.ccaron = 444, e.aring = 500, e.Ncommaaccent = 722, e.lacute = 278, e.agrave = 500, e.Tcommaaccent = 611, e.Cacute = 667, e.atilde = 500, e.Edotaccent = 667, e.scaron = 389, e.scedilla = 389, e.iacute = 278, e.lozenge = 494, e.Rcaron = 667, e.Gcommaaccent = 722, e.ucircumflex = 556, e.acircumflex = 500, e.Amacron = 667, e.rcaron = 389, e.ccedilla = 444, e.Zdotaccent = 611, e.Thorn = 611, e.Omacron = 722, e.Racute = 667, e.Sacute = 556, e.dcaron = 608, e.Umacron = 722;
                e.uring = 556, e.threesuperior = 300, e.Ograve = 722, e.Agrave = 667, e.Abreve = 667, e.multiply = 570, e.uacute = 556, e.Tcaron = 611, e.partialdiff = 494, e.ydieresis = 444, e.Nacute = 722, e.icircumflex = 278, e.Ecircumflex = 667, e.adieresis = 500, e.edieresis = 444, e.cacute = 444, e.nacute = 556, e.umacron = 556, e.Ncaron = 722, e.Iacute = 389, e.plusminus = 570, e.brokenbar = 220, e.registered = 747, e.Gbreve = 722, e.Idotaccent = 389, e.summation = 600, e.Egrave = 667, e.racute = 389, e.omacron = 500, e.Zacute = 611, e.Zcaron = 611, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 667, e.lcommaaccent = 278, e.tcaron = 366, e.eogonek = 444, e.Uogonek = 722, e.Aacute = 667, e.Adieresis = 667, e.egrave = 444, e.zacute = 389, e.iogonek = 278, e.Oacute = 722, e.oacute = 500, e.amacron = 500, e.sacute = 389, e.idieresis = 278, e.Ocircumflex = 722, e.Ugrave = 722, e.Delta = 612, e.thorn = 500, e.twosuperior = 300, e.Odieresis = 722, e.mu = 576, e.igrave = 278, e.ohungarumlaut = 500, e.Eogonek = 667, e.dcroat = 500, e.threequarters = 750, e.Scedilla = 556, e.lcaron = 382, e.Kcommaaccent = 667, e.Lacute = 611, e.trademark = 1e3, e.edotaccent = 444, e.Igrave = 389, e.Imacron = 389, e.Lcaron = 611, e.onehalf = 750, e.lessequal = 549, e.ocircumflex = 500, e.ntilde = 556, e.Uhungarumlaut = 722, e.Eacute = 667, e.emacron = 444, e.gbreve = 500, e.onequarter = 750, e.Scaron = 556, e.Scommaaccent = 556, e.Ohungarumlaut = 722, e.degree = 400, e.ograve = 500, e.Ccaron = 667, e.ugrave = 556, e.radical = 549, e.Dcaron = 722, e.rcommaaccent = 389, e.Ntilde = 722, e.otilde = 500, e.Rcommaaccent = 667, e.Lcommaaccent = 611, e.Atilde = 667, e.Aogonek = 667, e.Aring = 667, e.Otilde = 722, e.zdotaccent = 389, e.Ecaron = 667, e.Iogonek = 389, e.kcommaaccent = 500, e.minus = 606, e.Icircumflex = 389, e.ncaron = 556, e.tcommaaccent = 278, e.logicalnot = 606, e.odieresis = 500, e.udieresis = 556, e.notequal = 549, e.gcommaaccent = 500, e.eth = 500, e.zcaron = 389, e.ncommaaccent = 556, e.onesuperior = 300, e.imacron = 278, e.Euro = 500;
              }), e["Times-Italic"] = i(function (e) {
                e.space = 250, e.exclam = 333, e.quotedbl = 420, e.numbersign = 500, e.dollar = 500, e.percent = 833, e.ampersand = 778, e.quoteright = 333, e.parenleft = 333, e.parenright = 333, e.asterisk = 500, e.plus = 675, e.comma = 250, e.hyphen = 333, e.period = 250, e.slash = 278, e.zero = 500, e.one = 500, e.two = 500, e.three = 500, e.four = 500, e.five = 500, e.six = 500, e.seven = 500, e.eight = 500, e.nine = 500, e.colon = 333, e.semicolon = 333, e.less = 675, e.equal = 675, e.greater = 675, e.question = 500, e.at = 920, e.A = 611, e.B = 611, e.C = 667, e.D = 722, e.E = 611, e.F = 611, e.G = 722, e.H = 722, e.I = 333, e.J = 444, e.K = 667, e.L = 556, e.M = 833, e.N = 667, e.O = 722, e.P = 611, e.Q = 722, e.R = 611, e.S = 500, e.T = 556, e.U = 722, e.V = 611, e.W = 833, e.X = 611, e.Y = 556, e.Z = 556, e.bracketleft = 389, e.backslash = 278, e.bracketright = 389, e.asciicircum = 422, e.underscore = 500, e.quoteleft = 333, e.a = 500, e.b = 500, e.c = 444, e.d = 500, e.e = 444, e.f = 278, e.g = 500, e.h = 500, e.i = 278, e.j = 278, e.k = 444, e.l = 278, e.m = 722, e.n = 500, e.o = 500, e.p = 500, e.q = 500, e.r = 389, e.s = 389, e.t = 278, e.u = 500, e.v = 444, e.w = 667, e.x = 444, e.y = 444, e.z = 389, e.braceleft = 400, e.bar = 275, e.braceright = 400, e.asciitilde = 541, e.exclamdown = 389, e.cent = 500, e.sterling = 500, e.fraction = 167, e.yen = 500, e.florin = 500, e.section = 500, e.currency = 500, e.quotesingle = 214, e.quotedblleft = 556, e.guillemotleft = 500, e.guilsinglleft = 333, e.guilsinglright = 333, e.fi = 500, e.fl = 500, e.endash = 500, e.dagger = 500, e.daggerdbl = 500, e.periodcentered = 250, e.paragraph = 523, e.bullet = 350, e.quotesinglbase = 333, e.quotedblbase = 556, e.quotedblright = 556, e.guillemotright = 500, e.ellipsis = 889, e.perthousand = 1e3, e.questiondown = 500, e.grave = 333, e.acute = 333, e.circumflex = 333, e.tilde = 333, e.macron = 333, e.breve = 333, e.dotaccent = 333, e.dieresis = 333, e.ring = 333, e.cedilla = 333, e.hungarumlaut = 333, e.ogonek = 333, e.caron = 333, e.emdash = 889, e.AE = 889, e.ordfeminine = 276, e.Lslash = 556, e.Oslash = 722, e.OE = 944, e.ordmasculine = 310, e.ae = 667, e.dotlessi = 278, e.lslash = 278, e.oslash = 500, e.oe = 667, e.germandbls = 500, e.Idieresis = 333, e.eacute = 444, e.abreve = 500, e.uhungarumlaut = 500, e.ecaron = 444, e.Ydieresis = 556, e.divide = 675, e.Yacute = 556, e.Acircumflex = 611, e.aacute = 500, e.Ucircumflex = 722, e.yacute = 444, e.scommaaccent = 389, e.ecircumflex = 444, e.Uring = 722, e.Udieresis = 722, e.aogonek = 500, e.Uacute = 722, e.uogonek = 500, e.Edieresis = 611, e.Dcroat = 722, e.commaaccent = 250, e.copyright = 760, e.Emacron = 611, e.ccaron = 444, e.aring = 500, e.Ncommaaccent = 667, e.lacute = 278, e.agrave = 500, e.Tcommaaccent = 556, e.Cacute = 667, e.atilde = 500, e.Edotaccent = 611, e.scaron = 389, e.scedilla = 389, e.iacute = 278, e.lozenge = 471, e.Rcaron = 611, e.Gcommaaccent = 722, e.ucircumflex = 500, e.acircumflex = 500, e.Amacron = 611, e.rcaron = 389, e.ccedilla = 444, e.Zdotaccent = 556, e.Thorn = 611, e.Omacron = 722, e.Racute = 611, e.Sacute = 500, e.dcaron = 544, e.Umacron = 722;
                e.uring = 500, e.threesuperior = 300, e.Ograve = 722, e.Agrave = 611, e.Abreve = 611, e.multiply = 675, e.uacute = 500, e.Tcaron = 556, e.partialdiff = 476, e.ydieresis = 444, e.Nacute = 667, e.icircumflex = 278, e.Ecircumflex = 611, e.adieresis = 500, e.edieresis = 444, e.cacute = 444, e.nacute = 500, e.umacron = 500, e.Ncaron = 667, e.Iacute = 333, e.plusminus = 675, e.brokenbar = 275, e.registered = 760, e.Gbreve = 722, e.Idotaccent = 333, e.summation = 600, e.Egrave = 611, e.racute = 389, e.omacron = 500, e.Zacute = 556, e.Zcaron = 556, e.greaterequal = 549, e.Eth = 722, e.Ccedilla = 667, e.lcommaaccent = 278, e.tcaron = 300, e.eogonek = 444, e.Uogonek = 722, e.Aacute = 611, e.Adieresis = 611, e.egrave = 444, e.zacute = 389, e.iogonek = 278, e.Oacute = 722, e.oacute = 500, e.amacron = 500, e.sacute = 389, e.idieresis = 278, e.Ocircumflex = 722, e.Ugrave = 722, e.Delta = 612, e.thorn = 500, e.twosuperior = 300, e.Odieresis = 722, e.mu = 500, e.igrave = 278, e.ohungarumlaut = 500, e.Eogonek = 611, e.dcroat = 500, e.threequarters = 750, e.Scedilla = 500, e.lcaron = 300, e.Kcommaaccent = 667, e.Lacute = 556, e.trademark = 980, e.edotaccent = 444, e.Igrave = 333, e.Imacron = 333, e.Lcaron = 611, e.onehalf = 750, e.lessequal = 549, e.ocircumflex = 500, e.ntilde = 500, e.Uhungarumlaut = 722, e.Eacute = 611, e.emacron = 444, e.gbreve = 500, e.onequarter = 750, e.Scaron = 500, e.Scommaaccent = 500, e.Ohungarumlaut = 722, e.degree = 400, e.ograve = 500, e.Ccaron = 667, e.ugrave = 500, e.radical = 453, e.Dcaron = 722, e.rcommaaccent = 389, e.Ntilde = 667, e.otilde = 500, e.Rcommaaccent = 611, e.Lcommaaccent = 556, e.Atilde = 611, e.Aogonek = 611, e.Aring = 611, e.Otilde = 722, e.zdotaccent = 389, e.Ecaron = 611, e.Iogonek = 333, e.kcommaaccent = 444, e.minus = 675, e.Icircumflex = 333, e.ncaron = 500, e.tcommaaccent = 278, e.logicalnot = 675, e.odieresis = 500, e.udieresis = 500, e.notequal = 549, e.gcommaaccent = 500, e.eth = 500, e.zcaron = 389, e.ncommaaccent = 500, e.onesuperior = 300, e.imacron = 278, e.Euro = 500;
              }), e.ZapfDingbats = i(function (e) {
                e.space = 278, e.a1 = 974, e.a2 = 961, e.a202 = 974, e.a3 = 980, e.a4 = 719, e.a5 = 789, e.a119 = 790, e.a118 = 791, e.a117 = 690, e.a11 = 960, e.a12 = 939, e.a13 = 549, e.a14 = 855, e.a15 = 911, e.a16 = 933, e.a105 = 911, e.a17 = 945, e.a18 = 974, e.a19 = 755, e.a20 = 846, e.a21 = 762, e.a22 = 761, e.a23 = 571, e.a24 = 677, e.a25 = 763, e.a26 = 760, e.a27 = 759, e.a28 = 754, e.a6 = 494, e.a7 = 552, e.a8 = 537, e.a9 = 577, e.a10 = 692, e.a29 = 786, e.a30 = 788, e.a31 = 788, e.a32 = 790, e.a33 = 793, e.a34 = 794, e.a35 = 816, e.a36 = 823, e.a37 = 789, e.a38 = 841, e.a39 = 823, e.a40 = 833, e.a41 = 816, e.a42 = 831, e.a43 = 923, e.a44 = 744, e.a45 = 723, e.a46 = 749, e.a47 = 790, e.a48 = 792, e.a49 = 695, e.a50 = 776, e.a51 = 768, e.a52 = 792, e.a53 = 759, e.a54 = 707, e.a55 = 708, e.a56 = 682, e.a57 = 701, e.a58 = 826, e.a59 = 815, e.a60 = 789, e.a61 = 789, e.a62 = 707, e.a63 = 687, e.a64 = 696, e.a65 = 689, e.a66 = 786, e.a67 = 787, e.a68 = 713, e.a69 = 791, e.a70 = 785, e.a71 = 791, e.a72 = 873, e.a73 = 761, e.a74 = 762, e.a203 = 762, e.a75 = 759, e.a204 = 759, e.a76 = 892, e.a77 = 892, e.a78 = 788, e.a79 = 784, e.a81 = 438, e.a82 = 138, e.a83 = 277, e.a84 = 415, e.a97 = 392, e.a98 = 392, e.a99 = 668, e.a100 = 668, e.a89 = 390, e.a90 = 390, e.a93 = 317, e.a94 = 317, e.a91 = 276, e.a92 = 276, e.a205 = 509, e.a85 = 509, e.a206 = 410, e.a86 = 410, e.a87 = 234, e.a88 = 234, e.a95 = 334, e.a96 = 334, e.a101 = 732, e.a102 = 544, e.a103 = 544, e.a104 = 910, e.a106 = 667, e.a107 = 760, e.a108 = 760, e.a112 = 776, e.a111 = 595, e.a110 = 694, e.a109 = 626, e.a120 = 788, e.a121 = 788, e.a122 = 788, e.a123 = 788, e.a124 = 788, e.a125 = 788, e.a126 = 788, e.a127 = 788, e.a128 = 788, e.a129 = 788, e.a130 = 788, e.a131 = 788, e.a132 = 788, e.a133 = 788, e.a134 = 788, e.a135 = 788, e.a136 = 788, e.a137 = 788, e.a138 = 788, e.a139 = 788, e.a140 = 788, e.a141 = 788, e.a142 = 788, e.a143 = 788, e.a144 = 788, e.a145 = 788, e.a146 = 788, e.a147 = 788, e.a148 = 788, e.a149 = 788, e.a150 = 788, e.a151 = 788, e.a152 = 788, e.a153 = 788, e.a154 = 788, e.a155 = 788, e.a156 = 788, e.a157 = 788, e.a158 = 788, e.a159 = 788, e.a160 = 894, e.a161 = 838, e.a163 = 1016, e.a164 = 458, e.a196 = 748, e.a165 = 924, e.a192 = 748, e.a166 = 918, e.a167 = 927, e.a168 = 928, e.a169 = 928, e.a170 = 834, e.a171 = 873, e.a172 = 828, e.a173 = 924, e.a162 = 924, e.a174 = 917, e.a175 = 930, e.a176 = 931, e.a177 = 463, e.a178 = 883, e.a179 = 836, e.a193 = 836, e.a180 = 867, e.a199 = 867, e.a181 = 696, e.a200 = 696, e.a182 = 874, e.a201 = 874, e.a183 = 760, e.a184 = 946, e.a197 = 771, e.a185 = 865, e.a194 = 771, e.a198 = 888, e.a186 = 967, e.a195 = 888, e.a187 = 831, e.a188 = 873, e.a189 = 927;
                e.a190 = 970, e.a191 = 918;
              });
            });
          t.getMetrics = a;
        }, function (e, t, r) {
          "use strict";

          var n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            },
            i = (r(0), function (e) {
              function t(e) {
                this.h1 = e ? 4294967295 & e : 3285377520, this.h2 = e ? 4294967295 & e : 3285377520;
              }
              return t.prototype = {
                update: function update(e) {
                  var t;
                  if ("string" == typeof e) {
                    var r = new Uint8Array(2 * e.length),
                      i = 0;
                    for (t = 0; t < e.length; t++) {
                      var a = e.charCodeAt(t);
                      a <= 255 ? r[i++] = a : (r[i++] = a >>> 8, r[i++] = 255 & a);
                    }
                  } else {
                    if (!("object" === (void 0 === e ? "undefined" : n(e)) && "byteLength" in e)) throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                    r = e, i = r.byteLength;
                  }
                  var o = i >> 2,
                    s = i - 4 * o,
                    l = new Uint32Array(r.buffer, 0, o),
                    c = 0,
                    u = 0,
                    h = this.h1,
                    f = this.h2,
                    d = 3432918353,
                    p = 461845907;
                  for (t = 0; t < o; t++) 1 & t ? (c = l[t], c = c * d & 4294901760 | 11601 * c & 65535, c = c << 15 | c >>> 17, c = c * p & 4294901760 | 13715 * c & 65535, h ^= c, h = h << 13 | h >>> 19, h = 5 * h + 3864292196) : (u = l[t], u = u * d & 4294901760 | 11601 * u & 65535, u = u << 15 | u >>> 17, u = u * p & 4294901760 | 13715 * u & 65535, f ^= u, f = f << 13 | f >>> 19, f = 5 * f + 3864292196);
                  switch (c = 0, s) {
                    case 3:
                      c ^= r[4 * o + 2] << 16;
                    case 2:
                      c ^= r[4 * o + 1] << 8;
                    case 1:
                      c ^= r[4 * o], c = c * d & 4294901760 | 11601 * c & 65535, c = c << 15 | c >>> 17, c = c * p & 4294901760 | 13715 * c & 65535, 1 & o ? h ^= c : f ^= c;
                  }
                  return this.h1 = h, this.h2 = f, this;
                },
                hexdigest: function hexdigest() {
                  var e = this.h1,
                    t = this.h2;
                  e ^= t >>> 1, e = 3981806797 * e & 4294901760 | 36045 * e & 65535, t = 4283543511 * t & 4294901760 | (2950163797 * (t << 16 | e >>> 16) & 4294901760) >>> 16, e ^= t >>> 1, e = 444984403 * e & 4294901760 | 60499 * e & 65535, t = 3301882366 * t & 4294901760 | (3120437893 * (t << 16 | e >>> 16) & 4294901760) >>> 16, e ^= t >>> 1;
                  for (var r = 0, n = [e, t], i = ""; r < n.length; r++) {
                    for (var a = (n[r] >>> 0).toString(16); a.length < 8;) a = "0" + a;
                    i += a;
                  }
                  return i;
                }
              }, t;
            }());
          t.MurmurHash3_64 = i;
        }, function (e, t, r) {
          "use strict";

          function n(e, t) {
            this.url = e, t = t || {}, this.isHttp = /^https?:/i.test(e), this.httpHeaders = this.isHttp && t.httpHeaders || {}, this.withCredentials = t.withCredentials || !1, this.getXhr = t.getXhr || function () {
              return new XMLHttpRequest();
            }, this.currXhrId = 0, this.pendingRequests = Object.create(null), this.loadedRequests = Object.create(null);
          }
          function i(e) {
            var t = e.response;
            if ("string" != typeof t) return t;
            for (var r = t.length, n = new Uint8Array(r), i = 0; i < r; i++) n[i] = 255 & t.charCodeAt(i);
            return n.buffer;
          }
          function a(e) {
            this._options = e;
            var t = e.source;
            this._manager = new n(t.url, {
              httpHeaders: t.httpHeaders,
              withCredentials: t.withCredentials
            }), this._rangeChunkSize = t.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
          }
          function o(e, t) {
            this._manager = e;
            var r = t.source,
              n = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onProgressiveData: r.disableStream ? null : this._onProgressiveData.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
            this._url = r.url, this._fullRequestId = e.requestFull(n), this._headersReceivedCapability = d(), this._disableRange = t.disableRange || !1, this._contentLength = r.length, this._rangeChunkSize = r.rangeChunkSize, this._rangeChunkSize || this._disableRange || (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this.onProgress = null;
          }
          function s(e, t, r) {
            this._manager = e;
            var n = {
              onDone: this._onDone.bind(this),
              onProgress: this._onProgress.bind(this)
            };
            this._requestId = e.requestRange(t, r, n), this._requests = [], this._queuedChunk = null, this._done = !1, this.onProgress = null, this.onClosed = null;
          }
          var l = r(0),
            c = r(23),
            u = l.globalScope,
            h = function () {
              try {
                var e = new XMLHttpRequest();
                return e.open("GET", u.location.href), e.responseType = "moz-chunked-arraybuffer", "moz-chunked-arraybuffer" === e.responseType;
              } catch (e) {
                return !1;
              }
            }();
          n.prototype = {
            requestRange: function requestRange(e, t, r) {
              var n = {
                begin: e,
                end: t
              };
              for (var i in r) n[i] = r[i];
              return this.request(n);
            },
            requestFull: function requestFull(e) {
              return this.request(e);
            },
            request: function request(e) {
              var t = this.getXhr(),
                r = this.currXhrId++,
                n = this.pendingRequests[r] = {
                  xhr: t
                };
              t.open("GET", this.url), t.withCredentials = this.withCredentials;
              for (var i in this.httpHeaders) {
                var a = this.httpHeaders[i];
                void 0 !== a && t.setRequestHeader(i, a);
              }
              if (this.isHttp && "begin" in e && "end" in e) {
                var o = e.begin + "-" + (e.end - 1);
                t.setRequestHeader("Range", "bytes=" + o), n.expectedStatus = 206;
              } else n.expectedStatus = 200;
              return h && !!e.onProgressiveData ? (t.responseType = "moz-chunked-arraybuffer", n.onProgressiveData = e.onProgressiveData, n.mozChunked = !0) : t.responseType = "arraybuffer", e.onError && (t.onerror = function (r) {
                e.onError(t.status);
              }), t.onreadystatechange = this.onStateChange.bind(this, r), t.onprogress = this.onProgress.bind(this, r), n.onHeadersReceived = e.onHeadersReceived, n.onDone = e.onDone, n.onError = e.onError, n.onProgress = e.onProgress, t.send(null), r;
            },
            onProgress: function onProgress(e, t) {
              var r = this.pendingRequests[e];
              if (r) {
                if (r.mozChunked) {
                  var n = i(r.xhr);
                  r.onProgressiveData(n);
                }
                var a = r.onProgress;
                a && a(t);
              }
            },
            onStateChange: function onStateChange(e, t) {
              var r = this.pendingRequests[e];
              if (r) {
                var n = r.xhr;
                if (n.readyState >= 2 && r.onHeadersReceived && (r.onHeadersReceived(), delete r.onHeadersReceived), 4 === n.readyState && e in this.pendingRequests) {
                  if (delete this.pendingRequests[e], 0 === n.status && this.isHttp) return void (r.onError && r.onError(n.status));
                  var a = n.status || 200;
                  if (!(200 === a && 206 === r.expectedStatus) && a !== r.expectedStatus) return void (r.onError && r.onError(n.status));
                  this.loadedRequests[e] = !0;
                  var o = i(n);
                  if (206 === a) {
                    var s = n.getResponseHeader("Content-Range"),
                      l = /bytes (\d+)-(\d+)\/(\d+)/.exec(s),
                      c = parseInt(l[1], 10);
                    r.onDone({
                      begin: c,
                      chunk: o
                    });
                  } else r.onProgressiveData ? r.onDone(null) : o ? r.onDone({
                    begin: 0,
                    chunk: o
                  }) : r.onError && r.onError(n.status);
                }
              }
            },
            hasPendingRequests: function hasPendingRequests() {
              for (var e in this.pendingRequests) return !0;
              return !1;
            },
            getRequestXhr: function getRequestXhr(e) {
              return this.pendingRequests[e].xhr;
            },
            isStreamingRequest: function isStreamingRequest(e) {
              return !!this.pendingRequests[e].onProgressiveData;
            },
            isPendingRequest: function isPendingRequest(e) {
              return e in this.pendingRequests;
            },
            isLoadedRequest: function isLoadedRequest(e) {
              return e in this.loadedRequests;
            },
            abortAllRequests: function abortAllRequests() {
              for (var e in this.pendingRequests) this.abortRequest(0 | e);
            },
            abortRequest: function abortRequest(e) {
              var t = this.pendingRequests[e].xhr;
              delete this.pendingRequests[e], t.abort();
            }
          };
          var f = l.assert,
            d = l.createPromiseCapability,
            p = l.isInt,
            m = l.MissingPDFException,
            g = l.UnexpectedResponseException;
          a.prototype = {
            _onRangeRequestReaderClosed: function _onRangeRequestReaderClosed(e) {
              var t = this._rangeRequestReaders.indexOf(e);
              t >= 0 && this._rangeRequestReaders.splice(t, 1);
            },
            getFullReader: function getFullReader() {
              return f(!this._fullRequestReader), this._fullRequestReader = new o(this._manager, this._options), this._fullRequestReader;
            },
            getRangeReader: function getRangeReader(e, t) {
              var r = new s(this._manager, e, t);
              return r.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(r), r;
            },
            cancelAllRequests: function cancelAllRequests(e) {
              this._fullRequestReader && this._fullRequestReader.cancel(e), this._rangeRequestReaders.slice(0).forEach(function (t) {
                t.cancel(e);
              });
            }
          }, o.prototype = {
            _validateRangeRequestCapabilities: function _validateRangeRequestCapabilities() {
              if (this._disableRange) return !1;
              var e = this._manager;
              if (!e.isHttp) return !1;
              var t = this._fullRequestId,
                r = e.getRequestXhr(t);
              if ("bytes" !== r.getResponseHeader("Accept-Ranges")) return !1;
              if ("identity" !== (r.getResponseHeader("Content-Encoding") || "identity")) return !1;
              var n = r.getResponseHeader("Content-Length");
              return n = parseInt(n, 10), !!p(n) && (this._contentLength = n, !(n <= 2 * this._rangeChunkSize));
            },
            _onHeadersReceived: function _onHeadersReceived() {
              this._validateRangeRequestCapabilities() && (this._isRangeSupported = !0);
              var e = this._manager,
                t = this._fullRequestId;
              e.isStreamingRequest(t) ? this._isStreamingSupported = !0 : this._isRangeSupported && e.abortRequest(t), this._headersReceivedCapability.resolve();
            },
            _onProgressiveData: function _onProgressiveData(e) {
              if (this._requests.length > 0) {
                this._requests.shift().resolve({
                  value: e,
                  done: !1
                });
              } else this._cachedChunks.push(e);
            },
            _onDone: function _onDone(e) {
              e && this._onProgressiveData(e.chunk), this._done = !0, this._cachedChunks.length > 0 || (this._requests.forEach(function (e) {
                e.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = []);
            },
            _onError: function _onError(e) {
              var t,
                r = this._url;
              t = 404 === e || 0 === e && /^file:/.test(r) ? new m('Missing PDF "' + r + '".') : new g("Unexpected server response (" + e + ') while retrieving PDF "' + r + '".', e), this._storedError = t, this._headersReceivedCapability.reject(t), this._requests.forEach(function (e) {
                e.reject(t);
              }), this._requests = [], this._cachedChunks = [];
            },
            _onProgress: function _onProgress(e) {
              this.onProgress && this.onProgress({
                loaded: e.loaded,
                total: e.lengthComputable ? e.total : this._contentLength
              });
            },
            get isRangeSupported() {
              return this._isRangeSupported;
            },
            get isStreamingSupported() {
              return this._isStreamingSupported;
            },
            get contentLength() {
              return this._contentLength;
            },
            get headersReady() {
              return this._headersReceivedCapability.promise;
            },
            read: function read() {
              if (this._storedError) return Promise.reject(this._storedError);
              if (this._cachedChunks.length > 0) {
                var e = this._cachedChunks.shift();
                return Promise.resolve(e);
              }
              if (this._done) return Promise.resolve({
                value: void 0,
                done: !0
              });
              var t = d();
              return this._requests.push(t), t.promise;
            },
            cancel: function cancel(e) {
              this._done = !0, this._headersReceivedCapability.reject(e), this._requests.forEach(function (e) {
                e.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
            }
          }, s.prototype = {
            _close: function _close() {
              this.onClosed && this.onClosed(this);
            },
            _onDone: function _onDone(e) {
              var t = e.chunk;
              if (this._requests.length > 0) {
                this._requests.shift().resolve({
                  value: t,
                  done: !1
                });
              } else this._queuedChunk = t;
              this._done = !0, this._requests.forEach(function (e) {
                e.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._close();
            },
            _onProgress: function _onProgress(e) {
              !this.isStreamingSupported && this.onProgress && this.onProgress({
                loaded: e.loaded
              });
            },
            get isStreamingSupported() {
              return !1;
            },
            read: function read() {
              if (null !== this._queuedChunk) {
                var e = this._queuedChunk;
                return this._queuedChunk = null, Promise.resolve({
                  value: e,
                  done: !1
                });
              }
              if (this._done) return Promise.resolve({
                value: void 0,
                done: !0
              });
              var t = d();
              return this._requests.push(t), t.promise;
            },
            cancel: function cancel(e) {
              this._done = !0, this._requests.forEach(function (e) {
                e.resolve({
                  value: void 0,
                  done: !0
                });
              }), this._requests = [], this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
            }
          }, c.setPDFNetworkStreamClass(a), t.PDFNetworkStream = a, t.NetworkManager = n;
        }, function (e, t, r) {
          "use strict";

          function n(e, t, r) {
            return ["TilingPattern", r, e, t.getArray("Matrix"), t.getArray("BBox"), t.get("XStep"), t.get("YStep"), t.get("PaintType"), t.get("TilingType")];
          }
          var i = r(0),
            a = r(1),
            o = r(7),
            s = r(4),
            l = i.UNSUPPORTED_FEATURES,
            c = i.MissingDataException,
            u = i.Util,
            h = i.assert,
            f = i.error,
            d = i.info,
            p = i.warn,
            m = a.isStream,
            g = o.PDFFunction,
            v = s.ColorSpace,
            b = {
              FUNCTION_BASED: 1,
              AXIAL: 2,
              RADIAL: 3,
              FREE_FORM_MESH: 4,
              LATTICE_FORM_MESH: 5,
              COONS_PATCH_MESH: 6,
              TENSOR_PATCH_MESH: 7
            },
            y = function () {
              function e() {
                f("should not call Pattern constructor");
              }
              return e.prototype = {
                getPattern: function getPattern(e) {
                  f("Should not call Pattern.getStyle: " + e);
                }
              }, e.parseShading = function (e, t, r, n, i) {
                var a = m(e) ? e.dict : e,
                  o = a.get("ShadingType");
                try {
                  switch (o) {
                    case b.AXIAL:
                    case b.RADIAL:
                      return new w.RadialAxial(a, t, r, n);
                    case b.FREE_FORM_MESH:
                    case b.LATTICE_FORM_MESH:
                    case b.COONS_PATCH_MESH:
                    case b.TENSOR_PATCH_MESH:
                      return new w.Mesh(e, t, r, n);
                    default:
                      throw new Error("Unsupported ShadingType: " + o);
                  }
                } catch (e) {
                  if (e instanceof c) throw e;
                  return i.send("UnsupportedFeature", {
                    featureId: l.shadingPattern
                  }), p(e), new w.Dummy();
                }
              }, e;
            }(),
            w = {};
          w.SMALL_NUMBER = 1e-6, w.RadialAxial = function () {
            function e(e, t, r, n) {
              this.matrix = t, this.coordsArr = e.getArray("Coords"), this.shadingType = e.get("ShadingType"), this.type = "Pattern";
              var i = e.get("ColorSpace", "CS");
              i = v.parse(i, r, n), this.cs = i;
              var a = 0,
                o = 1;
              if (e.has("Domain")) {
                var s = e.getArray("Domain");
                a = s[0], o = s[1];
              }
              var l = !1,
                c = !1;
              if (e.has("Extend")) {
                var h = e.getArray("Extend");
                l = h[0], c = h[1];
              }
              if (!(this.shadingType !== b.RADIAL || l && c)) {
                var f = this.coordsArr[0],
                  m = this.coordsArr[1],
                  y = this.coordsArr[2],
                  x = this.coordsArr[3],
                  _ = this.coordsArr[4],
                  S = this.coordsArr[5],
                  C = Math.sqrt((f - x) * (f - x) + (m - _) * (m - _));
                y <= S + C && S <= y + C && p("Unsupported radial gradient.");
              }
              this.extendStart = l, this.extendEnd = c;
              var E = e.get("Function"),
                A = g.parseArray(r, E),
                T = o - a,
                k = T / 10,
                R = this.colorStops = [];
              if (a >= o || k <= 0) return void d("Bad shading domain.");
              for (var I, M = new Float32Array(i.numComps), O = new Float32Array(1), P = a; P <= o; P += k) {
                O[0] = P, A(O, 0, M, 0), I = i.getRgb(M, 0);
                var B = u.makeCssRgb(I[0], I[1], I[2]);
                R.push([(P - a) / T, B]);
              }
              var D = "transparent";
              e.has("Background") && (I = i.getRgb(e.get("Background"), 0), D = u.makeCssRgb(I[0], I[1], I[2])), l || (R.unshift([0, D]), R[1][0] += w.SMALL_NUMBER), c || (R[R.length - 1][0] -= w.SMALL_NUMBER, R.push([1, D])), this.colorStops = R;
            }
            return e.prototype = {
              getIR: function getIR() {
                var e,
                  t,
                  r,
                  n,
                  i,
                  a = this.coordsArr,
                  o = this.shadingType;
                o === b.AXIAL ? (t = [a[0], a[1]], r = [a[2], a[3]], n = null, i = null, e = "axial") : o === b.RADIAL ? (t = [a[0], a[1]], r = [a[3], a[4]], n = a[2], i = a[5], e = "radial") : f("getPattern type unknown: " + o);
                var s = this.matrix;
                if (s && (t = u.applyTransform(t, s), r = u.applyTransform(r, s), o === b.RADIAL)) {
                  var l = u.singularValueDecompose2dScale(s);
                  n *= l[0], i *= l[1];
                }
                return ["RadialAxial", e, this.colorStops, t, r, n, i];
              }
            }, e;
          }(), w.Mesh = function () {
            function e(e, t) {
              this.stream = e, this.context = t, this.buffer = 0, this.bufferLength = 0;
              var r = t.numComps;
              this.tmpCompsBuf = new Float32Array(r);
              var n = t.colorSpace.numComps;
              this.tmpCsCompsBuf = t.colorFn ? new Float32Array(n) : this.tmpCompsBuf;
            }
            function t(e, t) {
              for (var r = e.coords, n = e.colors, i = [], a = [], o = 0; t.hasData;) {
                var s = t.readFlag(),
                  l = t.readCoordinate(),
                  c = t.readComponents();
                if (0 === o) {
                  switch (h(0 <= s && s <= 2, "Unknown type4 flag"), s) {
                    case 0:
                      o = 3;
                      break;
                    case 1:
                      a.push(a[a.length - 2], a[a.length - 1]), o = 1;
                      break;
                    case 2:
                      a.push(a[a.length - 3], a[a.length - 1]), o = 1;
                  }
                  i.push(s);
                }
                a.push(r.length), r.push(l), n.push(c), o--, t.align();
              }
              e.figures.push({
                type: "triangles",
                coords: new Int32Array(a),
                colors: new Int32Array(a)
              });
            }
            function r(e, t, r) {
              for (var n = e.coords, i = e.colors, a = []; t.hasData;) {
                var o = t.readCoordinate(),
                  s = t.readComponents();
                a.push(n.length), n.push(o), i.push(s);
              }
              e.figures.push({
                type: "lattice",
                coords: new Int32Array(a),
                colors: new Int32Array(a),
                verticesPerRow: r
              });
            }
            function n(e, t) {
              var r = e.figures[t];
              h("patch" === r.type, "Unexpected patch mesh figure");
              var n = e.coords,
                i = e.colors,
                a = r.coords,
                o = r.colors,
                s = Math.min(n[a[0]][0], n[a[3]][0], n[a[12]][0], n[a[15]][0]),
                l = Math.min(n[a[0]][1], n[a[3]][1], n[a[12]][1], n[a[15]][1]),
                f = Math.max(n[a[0]][0], n[a[3]][0], n[a[12]][0], n[a[15]][0]),
                m = Math.max(n[a[0]][1], n[a[3]][1], n[a[12]][1], n[a[15]][1]),
                g = Math.ceil((f - s) * d / (e.bounds[2] - e.bounds[0]));
              g = Math.max(c, Math.min(u, g));
              var v = Math.ceil((m - l) * d / (e.bounds[3] - e.bounds[1]));
              v = Math.max(c, Math.min(u, v));
              for (var b = g + 1, y = new Int32Array((v + 1) * b), w = new Int32Array((v + 1) * b), x = 0, _ = new Uint8Array(3), S = new Uint8Array(3), C = i[o[0]], E = i[o[1]], A = i[o[2]], T = i[o[3]], k = p(v), R = p(g), I = 0; I <= v; I++) {
                _[0] = (C[0] * (v - I) + A[0] * I) / v | 0, _[1] = (C[1] * (v - I) + A[1] * I) / v | 0, _[2] = (C[2] * (v - I) + A[2] * I) / v | 0, S[0] = (E[0] * (v - I) + T[0] * I) / v | 0, S[1] = (E[1] * (v - I) + T[1] * I) / v | 0, S[2] = (E[2] * (v - I) + T[2] * I) / v | 0;
                for (var M = 0; M <= g; M++, x++) if (0 !== I && I !== v || 0 !== M && M !== g) {
                  for (var O = 0, P = 0, B = 0, D = 0; D <= 3; D++) for (var L = 0; L <= 3; L++, B++) {
                    var F = k[I][D] * R[M][L];
                    O += n[a[B]][0] * F, P += n[a[B]][1] * F;
                  }
                  y[x] = n.length, n.push([O, P]), w[x] = i.length;
                  var N = new Uint8Array(3);
                  N[0] = (_[0] * (g - M) + S[0] * M) / g | 0, N[1] = (_[1] * (g - M) + S[1] * M) / g | 0, N[2] = (_[2] * (g - M) + S[2] * M) / g | 0, i.push(N);
                }
              }
              y[0] = a[0], w[0] = o[0], y[g] = a[3], w[g] = o[1], y[b * v] = a[12], w[b * v] = o[2], y[b * v + g] = a[15], w[b * v + g] = o[3], e.figures[t] = {
                type: "lattice",
                coords: y,
                colors: w,
                verticesPerRow: b
              };
            }
            function i(e, t) {
              for (var r = e.coords, n = e.colors, i = new Int32Array(16), a = new Int32Array(4); t.hasData;) {
                var o = t.readFlag();
                h(0 <= o && o <= 3, "Unknown type6 flag");
                var s,
                  l,
                  c = r.length;
                for (s = 0, l = 0 !== o ? 8 : 12; s < l; s++) r.push(t.readCoordinate());
                var u = n.length;
                for (s = 0, l = 0 !== o ? 2 : 4; s < l; s++) n.push(t.readComponents());
                var f, d, p, m;
                switch (o) {
                  case 0:
                    i[12] = c + 3, i[13] = c + 4, i[14] = c + 5, i[15] = c + 6, i[8] = c + 2, i[11] = c + 7, i[4] = c + 1, i[7] = c + 8, i[0] = c, i[1] = c + 11, i[2] = c + 10, i[3] = c + 9, a[2] = u + 1, a[3] = u + 2, a[0] = u, a[1] = u + 3;
                    break;
                  case 1:
                    f = i[12], d = i[13], p = i[14], m = i[15], i[12] = m, i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = p, i[11] = c + 3, i[4] = d, i[7] = c + 4, i[0] = f, i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, f = a[2], d = a[3], a[2] = d, a[3] = u, a[0] = f, a[1] = u + 1;
                    break;
                  case 2:
                    f = i[15], d = i[11], i[12] = i[3], i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = i[7], i[11] = c + 3, i[4] = d, i[7] = c + 4, i[0] = f, i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, f = a[3], a[2] = a[1], a[3] = u, a[0] = f, a[1] = u + 1;
                    break;
                  case 3:
                    i[12] = i[0], i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = i[1], i[11] = c + 3, i[4] = i[2], i[7] = c + 4, i[0] = i[3], i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, a[2] = a[0], a[3] = u, a[0] = a[1], a[1] = u + 1;
                }
                i[5] = r.length, r.push([(-4 * r[i[0]][0] - r[i[15]][0] + 6 * (r[i[4]][0] + r[i[1]][0]) - 2 * (r[i[12]][0] + r[i[3]][0]) + 3 * (r[i[13]][0] + r[i[7]][0])) / 9, (-4 * r[i[0]][1] - r[i[15]][1] + 6 * (r[i[4]][1] + r[i[1]][1]) - 2 * (r[i[12]][1] + r[i[3]][1]) + 3 * (r[i[13]][1] + r[i[7]][1])) / 9]), i[6] = r.length, r.push([(-4 * r[i[3]][0] - r[i[12]][0] + 6 * (r[i[2]][0] + r[i[7]][0]) - 2 * (r[i[0]][0] + r[i[15]][0]) + 3 * (r[i[4]][0] + r[i[14]][0])) / 9, (-4 * r[i[3]][1] - r[i[12]][1] + 6 * (r[i[2]][1] + r[i[7]][1]) - 2 * (r[i[0]][1] + r[i[15]][1]) + 3 * (r[i[4]][1] + r[i[14]][1])) / 9]), i[9] = r.length, r.push([(-4 * r[i[12]][0] - r[i[3]][0] + 6 * (r[i[8]][0] + r[i[13]][0]) - 2 * (r[i[0]][0] + r[i[15]][0]) + 3 * (r[i[11]][0] + r[i[1]][0])) / 9, (-4 * r[i[12]][1] - r[i[3]][1] + 6 * (r[i[8]][1] + r[i[13]][1]) - 2 * (r[i[0]][1] + r[i[15]][1]) + 3 * (r[i[11]][1] + r[i[1]][1])) / 9]), i[10] = r.length, r.push([(-4 * r[i[15]][0] - r[i[0]][0] + 6 * (r[i[11]][0] + r[i[14]][0]) - 2 * (r[i[12]][0] + r[i[3]][0]) + 3 * (r[i[2]][0] + r[i[8]][0])) / 9, (-4 * r[i[15]][1] - r[i[0]][1] + 6 * (r[i[11]][1] + r[i[14]][1]) - 2 * (r[i[12]][1] + r[i[3]][1]) + 3 * (r[i[2]][1] + r[i[8]][1])) / 9]), e.figures.push({
                  type: "patch",
                  coords: new Int32Array(i),
                  colors: new Int32Array(a)
                });
              }
            }
            function a(e, t) {
              for (var r = e.coords, n = e.colors, i = new Int32Array(16), a = new Int32Array(4); t.hasData;) {
                var o = t.readFlag();
                h(0 <= o && o <= 3, "Unknown type7 flag");
                var s,
                  l,
                  c = r.length;
                for (s = 0, l = 0 !== o ? 12 : 16; s < l; s++) r.push(t.readCoordinate());
                var u = n.length;
                for (s = 0, l = 0 !== o ? 2 : 4; s < l; s++) n.push(t.readComponents());
                var f, d, p, m;
                switch (o) {
                  case 0:
                    i[12] = c + 3, i[13] = c + 4, i[14] = c + 5, i[15] = c + 6, i[8] = c + 2, i[9] = c + 13, i[10] = c + 14, i[11] = c + 7, i[4] = c + 1, i[5] = c + 12, i[6] = c + 15, i[7] = c + 8, i[0] = c, i[1] = c + 11, i[2] = c + 10, i[3] = c + 9, a[2] = u + 1, a[3] = u + 2, a[0] = u, a[1] = u + 3;
                    break;
                  case 1:
                    f = i[12], d = i[13], p = i[14], m = i[15], i[12] = m, i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = p, i[9] = c + 9, i[10] = c + 10, i[11] = c + 3, i[4] = d, i[5] = c + 8, i[6] = c + 11, i[7] = c + 4, i[0] = f, i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, f = a[2], d = a[3], a[2] = d, a[3] = u, a[0] = f, a[1] = u + 1;
                    break;
                  case 2:
                    f = i[15], d = i[11], i[12] = i[3], i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = i[7], i[9] = c + 9, i[10] = c + 10, i[11] = c + 3, i[4] = d, i[5] = c + 8, i[6] = c + 11, i[7] = c + 4, i[0] = f, i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, f = a[3], a[2] = a[1], a[3] = u, a[0] = f, a[1] = u + 1;
                    break;
                  case 3:
                    i[12] = i[0], i[13] = c + 0, i[14] = c + 1, i[15] = c + 2, i[8] = i[1], i[9] = c + 9, i[10] = c + 10, i[11] = c + 3, i[4] = i[2], i[5] = c + 8, i[6] = c + 11, i[7] = c + 4, i[0] = i[3], i[1] = c + 7, i[2] = c + 6, i[3] = c + 5, a[2] = a[0], a[3] = u, a[0] = a[1], a[1] = u + 1;
                }
                e.figures.push({
                  type: "patch",
                  coords: new Int32Array(i),
                  colors: new Int32Array(a)
                });
              }
            }
            function o(e) {
              for (var t = e.coords[0][0], r = e.coords[0][1], n = t, i = r, a = 1, o = e.coords.length; a < o; a++) {
                var s = e.coords[a][0],
                  l = e.coords[a][1];
                t = t > s ? s : t, r = r > l ? l : r, n = n < s ? s : n, i = i < l ? l : i;
              }
              e.bounds = [t, r, n, i];
            }
            function s(e) {
              var t,
                r,
                n,
                i,
                a = e.coords,
                o = new Float32Array(2 * a.length);
              for (t = 0, n = 0, r = a.length; t < r; t++) {
                var s = a[t];
                o[n++] = s[0], o[n++] = s[1];
              }
              e.coords = o;
              var l = e.colors,
                c = new Uint8Array(3 * l.length);
              for (t = 0, n = 0, r = l.length; t < r; t++) {
                var u = l[t];
                c[n++] = u[0], c[n++] = u[1], c[n++] = u[2];
              }
              e.colors = c;
              var h = e.figures;
              for (t = 0, r = h.length; t < r; t++) {
                var f = h[t],
                  d = f.coords,
                  p = f.colors;
                for (n = 0, i = d.length; n < i; n++) d[n] *= 2, p[n] *= 3;
              }
            }
            function l(l, c, u, d) {
              h(m(l), "Mesh data is not a stream");
              var p = l.dict;
              this.matrix = c, this.shadingType = p.get("ShadingType"), this.type = "Pattern", this.bbox = p.getArray("BBox");
              var y = p.get("ColorSpace", "CS");
              y = v.parse(y, u, d), this.cs = y, this.background = p.has("Background") ? y.getRgb(p.get("Background"), 0) : null;
              var w = p.get("Function"),
                x = w ? g.parseArray(u, w) : null;
              this.coords = [], this.colors = [], this.figures = [];
              var _ = {
                  bitsPerCoordinate: p.get("BitsPerCoordinate"),
                  bitsPerComponent: p.get("BitsPerComponent"),
                  bitsPerFlag: p.get("BitsPerFlag"),
                  decode: p.getArray("Decode"),
                  colorFn: x,
                  colorSpace: y,
                  numComps: x ? 1 : y.numComps
                },
                S = new e(l, _),
                C = !1;
              switch (this.shadingType) {
                case b.FREE_FORM_MESH:
                  t(this, S);
                  break;
                case b.LATTICE_FORM_MESH:
                  var E = 0 | p.get("VerticesPerRow");
                  h(E >= 2, "Invalid VerticesPerRow"), r(this, S, E);
                  break;
                case b.COONS_PATCH_MESH:
                  i(this, S), C = !0;
                  break;
                case b.TENSOR_PATCH_MESH:
                  a(this, S), C = !0;
                  break;
                default:
                  f("Unsupported mesh type.");
              }
              if (C) {
                o(this);
                for (var A = 0, T = this.figures.length; A < T; A++) n(this, A);
              }
              o(this), s(this);
            }
            e.prototype = {
              get hasData() {
                if (this.stream.end) return this.stream.pos < this.stream.end;
                if (this.bufferLength > 0) return !0;
                var e = this.stream.getByte();
                return !(e < 0) && (this.buffer = e, this.bufferLength = 8, !0);
              },
              readBits: function readBits(e) {
                var t = this.buffer,
                  r = this.bufferLength;
                if (32 === e) {
                  if (0 === r) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                  t = t << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                  var n = this.stream.getByte();
                  return this.buffer = n & (1 << r) - 1, (t << 8 - r | (255 & n) >> r) >>> 0;
                }
                if (8 === e && 0 === r) return this.stream.getByte();
                for (; r < e;) t = t << 8 | this.stream.getByte(), r += 8;
                return r -= e, this.bufferLength = r, this.buffer = t & (1 << r) - 1, t >> r;
              },
              align: function align() {
                this.buffer = 0, this.bufferLength = 0;
              },
              readFlag: function readFlag() {
                return this.readBits(this.context.bitsPerFlag);
              },
              readCoordinate: function readCoordinate() {
                var e = this.context.bitsPerCoordinate,
                  t = this.readBits(e),
                  r = this.readBits(e),
                  n = this.context.decode,
                  i = e < 32 ? 1 / ((1 << e) - 1) : 2.3283064365386963e-10;
                return [t * i * (n[1] - n[0]) + n[0], r * i * (n[3] - n[2]) + n[2]];
              },
              readComponents: function readComponents() {
                for (var e = this.context.numComps, t = this.context.bitsPerComponent, r = t < 32 ? 1 / ((1 << t) - 1) : 2.3283064365386963e-10, n = this.context.decode, i = this.tmpCompsBuf, a = 0, o = 4; a < e; a++, o += 2) {
                  var s = this.readBits(t);
                  i[a] = s * r * (n[o + 1] - n[o]) + n[o];
                }
                var l = this.tmpCsCompsBuf;
                return this.context.colorFn && this.context.colorFn(i, 0, l, 0), this.context.colorSpace.getRgb(l, 0);
              }
            };
            var c = 3,
              u = 20,
              d = 20,
              p = function () {
                function e(e) {
                  for (var t = [], r = 0; r <= e; r++) {
                    var n = r / e,
                      i = 1 - n;
                    t.push(new Float32Array([i * i * i, 3 * n * i * i, 3 * n * n * i, n * n * n]));
                  }
                  return t;
                }
                var t = [];
                return function (r) {
                  return t[r] || (t[r] = e(r)), t[r];
                };
              }();
            return l.prototype = {
              getIR: function getIR() {
                return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.matrix, this.bbox, this.background];
              }
            }, l;
          }(), w.Dummy = function () {
            function e() {
              this.type = "Pattern";
            }
            return e.prototype = {
              getIR: function getIR() {
                return ["Dummy"];
              }
            }, e;
          }(), t.Pattern = y, t.getTilingPatternIR = n;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(2),
            a = r(16),
            o = r(31),
            s = n.warn,
            l = n.createValidAbsoluteUrl,
            c = n.shadow,
            u = n.NotImplementedException,
            h = n.MissingDataException,
            f = n.createPromiseCapability,
            d = n.Util,
            p = i.Stream,
            m = a.ChunkedStreamManager,
            g = o.PDFDocument,
            v = function () {
              function e() {
                throw new Error("Cannot initialize BaseManagerManager");
              }
              return e.prototype = {
                get docId() {
                  return this._docId;
                },
                get password() {
                  return this._password;
                },
                get docBaseUrl() {
                  var e = null;
                  if (this._docBaseUrl) {
                    var t = l(this._docBaseUrl);
                    t ? e = t.href : s('Invalid absolute docBaseUrl: "' + this._docBaseUrl + '".');
                  }
                  return c(this, "docBaseUrl", e);
                },
                onLoadedStream: function onLoadedStream() {
                  throw new u();
                },
                ensureDoc: function ensureDoc(e, t) {
                  return this.ensure(this.pdfDocument, e, t);
                },
                ensureXRef: function ensureXRef(e, t) {
                  return this.ensure(this.pdfDocument.xref, e, t);
                },
                ensureCatalog: function ensureCatalog(e, t) {
                  return this.ensure(this.pdfDocument.catalog, e, t);
                },
                getPage: function getPage(e) {
                  return this.pdfDocument.getPage(e);
                },
                cleanup: function cleanup() {
                  return this.pdfDocument.cleanup();
                },
                ensure: function ensure(e, t, r) {
                  return new u();
                },
                requestRange: function requestRange(e, t) {
                  return new u();
                },
                requestLoadedStream: function requestLoadedStream() {
                  return new u();
                },
                sendProgressiveData: function sendProgressiveData(e) {
                  return new u();
                },
                updatePassword: function updatePassword(e) {
                  this._password = e;
                },
                terminate: function terminate() {
                  return new u();
                }
              }, e;
            }(),
            b = function () {
              function e(e, t, r, n, i) {
                this._docId = e, this._password = r, this._docBaseUrl = i, this.evaluatorOptions = n;
                var a = new p(t);
                this.pdfDocument = new g(this, a), this._loadedStreamCapability = f(), this._loadedStreamCapability.resolve(a);
              }
              return d.inherit(e, v, {
                ensure: function ensure(e, t, r) {
                  return new Promise(function (n, i) {
                    try {
                      var a,
                        o = e[t];
                      a = "function" == typeof o ? o.apply(e, r) : o, n(a);
                    } catch (e) {
                      i(e);
                    }
                  });
                },
                requestRange: function requestRange(e, t) {
                  return Promise.resolve();
                },
                requestLoadedStream: function requestLoadedStream() {},
                onLoadedStream: function onLoadedStream() {
                  return this._loadedStreamCapability.promise;
                },
                terminate: function terminate() {}
              }), e;
            }(),
            y = function () {
              function e(e, t, r, n, i) {
                this._docId = e, this._password = r.password, this._docBaseUrl = i, this.msgHandler = r.msgHandler, this.evaluatorOptions = n;
                var a = {
                  msgHandler: r.msgHandler,
                  url: r.url,
                  length: r.length,
                  disableAutoFetch: r.disableAutoFetch,
                  rangeChunkSize: r.rangeChunkSize
                };
                this.streamManager = new m(t, a), this.pdfDocument = new g(this, this.streamManager.getStream());
              }
              return d.inherit(e, v, {
                ensure: function ensure(e, t, r) {
                  var n = this;
                  return new Promise(function (i, a) {
                    function o() {
                      try {
                        var s,
                          l = e[t];
                        s = "function" == typeof l ? l.apply(e, r) : l, i(s);
                      } catch (e) {
                        if (!(e instanceof h)) return void a(e);
                        n.streamManager.requestRange(e.begin, e.end).then(o, a);
                      }
                    }
                    o();
                  });
                },
                requestRange: function requestRange(e, t) {
                  return this.streamManager.requestRange(e, t);
                },
                requestLoadedStream: function requestLoadedStream() {
                  this.streamManager.requestAllChunks();
                },
                sendProgressiveData: function sendProgressiveData(e) {
                  this.streamManager.onReceiveData({
                    chunk: e
                  });
                },
                onLoadedStream: function onLoadedStream() {
                  return this.streamManager.onLoadedStream();
                },
                terminate: function terminate() {
                  this.streamManager.abort();
                }
              }), e;
            }();
          t.LocalPdfManager = b, t.NetworkPdfManager = y;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(1),
            a = n.error,
            o = n.isSpace,
            s = i.EOF,
            l = function () {
              function e(e) {
                this.lexer = e, this.operators = [], this.token = null, this.prev = null;
              }
              return e.prototype = {
                nextToken: function nextToken() {
                  this.prev = this.token, this.token = this.lexer.getToken();
                },
                accept: function accept(e) {
                  return this.token.type === e && (this.nextToken(), !0);
                },
                expect: function expect(e) {
                  if (this.accept(e)) return !0;
                  a("Unexpected symbol: found " + this.token.type + " expected " + e + ".");
                },
                parse: function parse() {
                  return this.nextToken(), this.expect(c.LBRACE), this.parseBlock(), this.expect(c.RBRACE), this.operators;
                },
                parseBlock: function parseBlock() {
                  for (;;) if (this.accept(c.NUMBER)) this.operators.push(this.prev.value);else if (this.accept(c.OPERATOR)) this.operators.push(this.prev.value);else {
                    if (!this.accept(c.LBRACE)) return;
                    this.parseCondition();
                  }
                },
                parseCondition: function parseCondition() {
                  var e = this.operators.length;
                  if (this.operators.push(null, null), this.parseBlock(), this.expect(c.RBRACE), this.accept(c.IF)) this.operators[e] = this.operators.length, this.operators[e + 1] = "jz";else if (this.accept(c.LBRACE)) {
                    var t = this.operators.length;
                    this.operators.push(null, null);
                    var r = this.operators.length;
                    this.parseBlock(), this.expect(c.RBRACE), this.expect(c.IFELSE), this.operators[t] = this.operators.length, this.operators[t + 1] = "j", this.operators[e] = r, this.operators[e + 1] = "jz";
                  } else a("PS Function: error parsing conditional.");
                }
              }, e;
            }(),
            c = {
              LBRACE: 0,
              RBRACE: 1,
              NUMBER: 2,
              OPERATOR: 3,
              IF: 4,
              IFELSE: 5
            },
            u = function () {
              function e(e, t) {
                this.type = e, this.value = t;
              }
              var t = Object.create(null);
              return e.getOperator = function (r) {
                var n = t[r];
                return n || (t[r] = new e(c.OPERATOR, r));
              }, e.LBRACE = new e(c.LBRACE, "{"), e.RBRACE = new e(c.RBRACE, "}"), e.IF = new e(c.IF, "IF"), e.IFELSE = new e(c.IFELSE, "IFELSE"), e;
            }(),
            h = function () {
              function e(e) {
                this.stream = e, this.nextChar(), this.strBuf = [];
              }
              return e.prototype = {
                nextChar: function nextChar() {
                  return this.currentChar = this.stream.getByte();
                },
                getToken: function getToken() {
                  for (var e = !1, t = this.currentChar;;) {
                    if (t < 0) return s;
                    if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (!o(t)) break;
                    t = this.nextChar();
                  }
                  switch (0 | t) {
                    case 48:
                    case 49:
                    case 50:
                    case 51:
                    case 52:
                    case 53:
                    case 54:
                    case 55:
                    case 56:
                    case 57:
                    case 43:
                    case 45:
                    case 46:
                      return new u(c.NUMBER, this.getNumber());
                    case 123:
                      return this.nextChar(), u.LBRACE;
                    case 125:
                      return this.nextChar(), u.RBRACE;
                  }
                  var r = this.strBuf;
                  for (r.length = 0, r[0] = String.fromCharCode(t); (t = this.nextChar()) >= 0 && (t >= 65 && t <= 90 || t >= 97 && t <= 122);) r.push(String.fromCharCode(t));
                  var n = r.join("");
                  switch (n.toLowerCase()) {
                    case "if":
                      return u.IF;
                    case "ifelse":
                      return u.IFELSE;
                    default:
                      return u.getOperator(n);
                  }
                },
                getNumber: function getNumber() {
                  var e = this.currentChar,
                    t = this.strBuf;
                  for (t.length = 0, t[0] = String.fromCharCode(e); (e = this.nextChar()) >= 0 && (e >= 48 && e <= 57 || 45 === e || 46 === e);) t.push(String.fromCharCode(e));
                  var r = parseFloat(t.join(""));
                  return isNaN(r) && a("Invalid floating point number: " + r), r;
                }
              }, e;
            }();
          t.PostScriptLexer = h, t.PostScriptParser = l;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(2),
            a = r(5),
            o = n.warn,
            s = n.isSpace,
            l = i.Stream,
            c = a.getEncoding,
            u = function () {
              function e() {
                this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
              }
              var t = {
                hstem: [1],
                vstem: [3],
                vmoveto: [4],
                rlineto: [5],
                hlineto: [6],
                vlineto: [7],
                rrcurveto: [8],
                callsubr: [10],
                flex: [12, 35],
                drop: [12, 18],
                endchar: [14],
                rmoveto: [21],
                hmoveto: [22],
                vhcurveto: [30],
                hvcurveto: [31]
              };
              return e.prototype = {
                convert: function convert(e, r, n) {
                  for (var i, a, s, l = e.length, c = !1, u = 0; u < l; u++) {
                    var h = e[u];
                    if (h < 32) {
                      switch (12 === h && (h = (h << 8) + e[++u]), h) {
                        case 1:
                        case 3:
                          this.stack = [];
                          break;
                        case 4:
                          if (this.flexing) {
                            if (this.stack.length < 1) {
                              c = !0;
                              break;
                            }
                            var f = this.stack.pop();
                            this.stack.push(0, f);
                            break;
                          }
                          c = this.executeCommand(1, t.vmoveto);
                          break;
                        case 5:
                          c = this.executeCommand(2, t.rlineto);
                          break;
                        case 6:
                          c = this.executeCommand(1, t.hlineto);
                          break;
                        case 7:
                          c = this.executeCommand(1, t.vlineto);
                          break;
                        case 8:
                          c = this.executeCommand(6, t.rrcurveto);
                          break;
                        case 9:
                          this.stack = [];
                          break;
                        case 10:
                          if (this.stack.length < 1) {
                            c = !0;
                            break;
                          }
                          s = this.stack.pop(), c = this.convert(r[s], r, n);
                          break;
                        case 11:
                          return c;
                        case 13:
                          if (this.stack.length < 2) {
                            c = !0;
                            break;
                          }
                          i = this.stack.pop(), a = this.stack.pop(), this.lsb = a, this.width = i, this.stack.push(i, a), c = this.executeCommand(2, t.hmoveto);
                          break;
                        case 14:
                          this.output.push(t.endchar[0]);
                          break;
                        case 21:
                          if (this.flexing) break;
                          c = this.executeCommand(2, t.rmoveto);
                          break;
                        case 22:
                          if (this.flexing) {
                            this.stack.push(0);
                            break;
                          }
                          c = this.executeCommand(1, t.hmoveto);
                          break;
                        case 30:
                          c = this.executeCommand(4, t.vhcurveto);
                          break;
                        case 31:
                          c = this.executeCommand(4, t.hvcurveto);
                          break;
                        case 3072:
                        case 3073:
                        case 3074:
                          this.stack = [];
                          break;
                        case 3078:
                          n ? (this.seac = this.stack.splice(-4, 4), c = this.executeCommand(0, t.endchar)) : c = this.executeCommand(4, t.endchar);
                          break;
                        case 3079:
                          if (this.stack.length < 4) {
                            c = !0;
                            break;
                          }
                          this.stack.pop(), i = this.stack.pop();
                          var d = this.stack.pop();
                          a = this.stack.pop(), this.lsb = a, this.width = i, this.stack.push(i, a, d), c = this.executeCommand(3, t.rmoveto);
                          break;
                        case 3084:
                          if (this.stack.length < 2) {
                            c = !0;
                            break;
                          }
                          var p = this.stack.pop(),
                            m = this.stack.pop();
                          this.stack.push(m / p);
                          break;
                        case 3088:
                          if (this.stack.length < 2) {
                            c = !0;
                            break;
                          }
                          s = this.stack.pop();
                          var g = this.stack.pop();
                          if (0 === s && 3 === g) {
                            var v = this.stack.splice(this.stack.length - 17, 17);
                            this.stack.push(v[2] + v[0], v[3] + v[1], v[4], v[5], v[6], v[7], v[8], v[9], v[10], v[11], v[12], v[13], v[14]), c = this.executeCommand(13, t.flex, !0), this.flexing = !1, this.stack.push(v[15], v[16]);
                          } else 1 === s && 0 === g && (this.flexing = !0);
                          break;
                        case 3089:
                          break;
                        case 3105:
                          this.stack = [];
                          break;
                        default:
                          o('Unknown type 1 charstring command of "' + h + '"');
                      }
                      if (c) break;
                    } else h <= 246 ? h -= 139 : h = h <= 250 ? 256 * (h - 247) + e[++u] + 108 : h <= 254 ? -256 * (h - 251) - e[++u] - 108 : (255 & e[++u]) << 24 | (255 & e[++u]) << 16 | (255 & e[++u]) << 8 | (255 & e[++u]) << 0, this.stack.push(h);
                  }
                  return c;
                },
                executeCommand: function executeCommand(e, t, r) {
                  var n = this.stack.length;
                  if (e > n) return !0;
                  for (var i = n - e, a = i; a < n; a++) {
                    var o = this.stack[a];
                    o === (0 | o) ? this.output.push(28, o >> 8 & 255, 255 & o) : (o = 65536 * o | 0, this.output.push(255, o >> 24 & 255, o >> 16 & 255, o >> 8 & 255, 255 & o));
                  }
                  return this.output.push.apply(this.output, t), r ? this.stack.splice(i, e) : this.stack.length = 0, !1;
                }
              }, e;
            }(),
            h = function () {
              function e(e) {
                return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
              }
              function t(e, t, r) {
                if (r >= e.length) return new Uint8Array(0);
                var n,
                  i,
                  a = 0 | t;
                for (n = 0; n < r; n++) a = 52845 * (e[n] + a) + 22719 & 65535;
                var o = e.length - r,
                  s = new Uint8Array(o);
                for (n = r, i = 0; i < o; n++, i++) {
                  var l = e[n];
                  s[i] = l ^ a >> 8, a = 52845 * (l + a) + 22719 & 65535;
                }
                return s;
              }
              function r(t, r, n) {
                var i,
                  a,
                  o = 0 | r,
                  s = t.length,
                  l = s >>> 1,
                  c = new Uint8Array(l);
                for (i = 0, a = 0; i < s; i++) {
                  var u = t[i];
                  if (e(u)) {
                    i++;
                    for (var h; i < s && !e(h = t[i]);) i++;
                    if (i < s) {
                      var f = parseInt(String.fromCharCode(u, h), 16);
                      c[a++] = f ^ o >> 8, o = 52845 * (f + o) + 22719 & 65535;
                    }
                  }
                }
                return Array.prototype.slice.call(c, n, a);
              }
              function n(e) {
                return 47 === e || 91 === e || 93 === e || 123 === e || 125 === e || 40 === e || 41 === e;
              }
              function i(n, i, o) {
                if (i) {
                  var s = n.getBytes(),
                    c = !(e(s[0]) && e(s[1]) && e(s[2]) && e(s[3]));
                  n = new l(c ? t(s, a, 4) : r(s, a, 4));
                }
                this.seacAnalysisEnabled = !!o, this.stream = n, this.nextChar();
              }
              var a = 55665;
              return i.prototype = {
                readNumberArray: function readNumberArray() {
                  this.getToken();
                  for (var e = [];;) {
                    var t = this.getToken();
                    if (null === t || "]" === t || "}" === t) break;
                    e.push(parseFloat(t || 0));
                  }
                  return e;
                },
                readNumber: function readNumber() {
                  var e = this.getToken();
                  return parseFloat(e || 0);
                },
                readInt: function readInt() {
                  var e = this.getToken();
                  return 0 | parseInt(e || 0, 10);
                },
                readBoolean: function readBoolean() {
                  return "true" === this.getToken() ? 1 : 0;
                },
                nextChar: function nextChar() {
                  return this.currentChar = this.stream.getByte();
                },
                getToken: function getToken() {
                  for (var e = !1, t = this.currentChar;;) {
                    if (-1 === t) return null;
                    if (e) 10 !== t && 13 !== t || (e = !1);else if (37 === t) e = !0;else if (!s(t)) break;
                    t = this.nextChar();
                  }
                  if (n(t)) return this.nextChar(), String.fromCharCode(t);
                  var r = "";
                  do {
                    r += String.fromCharCode(t), t = this.nextChar();
                  } while (t >= 0 && !s(t) && !n(t));
                  return r;
                },
                extractFontProgram: function extractFontProgram() {
                  var e = this.stream,
                    r = [],
                    n = [],
                    i = Object.create(null);
                  i.lenIV = 4;
                  for (var a, o, s, l, c, h = {
                      subrs: [],
                      charstrings: [],
                      properties: {
                        privateData: i
                      }
                    }; null !== (a = this.getToken());) if ("/" === a) switch (a = this.getToken()) {
                    case "CharStrings":
                      for (this.getToken(), this.getToken(), this.getToken(), this.getToken();;) {
                        if (null === (a = this.getToken()) || "end" === a) break;
                        if ("/" === a) {
                          var f = this.getToken();
                          o = this.readInt(), this.getToken(), s = e.makeSubStream(e.pos, o), l = h.properties.privateData.lenIV, c = t(s.getBytes(), 4330, l), e.skip(o), this.nextChar(), a = this.getToken(), "noaccess" === a && this.getToken(), n.push({
                            glyph: f,
                            encoded: c
                          });
                        }
                      }
                      break;
                    case "Subrs":
                      for (this.readInt(), this.getToken(); "dup" === (a = this.getToken());) {
                        var d = this.readInt();
                        o = this.readInt(), this.getToken(), s = e.makeSubStream(e.pos, o), l = h.properties.privateData.lenIV, c = t(s.getBytes(), 4330, l), e.skip(o), this.nextChar(), a = this.getToken(), "noaccess" === a && this.getToken(), r[d] = c;
                      }
                      break;
                    case "BlueValues":
                    case "OtherBlues":
                    case "FamilyBlues":
                    case "FamilyOtherBlues":
                      var p = this.readNumberArray();
                      p.length > 0 && p.length, 1;
                      break;
                    case "StemSnapH":
                    case "StemSnapV":
                      h.properties.privateData[a] = this.readNumberArray();
                      break;
                    case "StdHW":
                    case "StdVW":
                      h.properties.privateData[a] = this.readNumberArray()[0];
                      break;
                    case "BlueShift":
                    case "lenIV":
                    case "BlueFuzz":
                    case "BlueScale":
                    case "LanguageGroup":
                    case "ExpansionFactor":
                      h.properties.privateData[a] = this.readNumber();
                      break;
                    case "ForceBold":
                      h.properties.privateData[a] = this.readBoolean();
                  }
                  for (var m = 0; m < n.length; m++) {
                    f = n[m].glyph, c = n[m].encoded;
                    var g = new u(),
                      v = g.convert(c, r, this.seacAnalysisEnabled),
                      b = g.output;
                    v && (b = [14]), h.charstrings.push({
                      glyphName: f,
                      charstring: b,
                      width: g.width,
                      lsb: g.lsb,
                      seac: g.seac
                    });
                  }
                  return h;
                },
                extractFontHeader: function extractFontHeader(e) {
                  for (var t; null !== (t = this.getToken());) if ("/" === t) switch (t = this.getToken()) {
                    case "FontMatrix":
                      var r = this.readNumberArray();
                      e.fontMatrix = r;
                      break;
                    case "Encoding":
                      var n,
                        i = this.getToken();
                      if (/^\d+$/.test(i)) {
                        n = [];
                        var a = 0 | parseInt(i, 10);
                        this.getToken();
                        for (var o = 0; o < a; o++) {
                          for (t = this.getToken(); "dup" !== t && "def" !== t;) if (null === (t = this.getToken())) return;
                          if ("def" === t) break;
                          var s = this.readInt();
                          this.getToken();
                          var l = this.getToken();
                          n[s] = l, this.getToken();
                        }
                      } else n = c(i);
                      e.builtInEncoding = n;
                      break;
                    case "FontBBox":
                      var u = this.readNumberArray();
                      e.ascent = Math.max(u[3], u[1]), e.descent = Math.min(u[1], u[3]), e.ascentScaled = !0;
                  }
                }
              }, i;
            }();
          t.Type1Parser = h;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            e.mozCurrentTransform || (e._originalSave = e.save, e._originalRestore = e.restore, e._originalRotate = e.rotate, e._originalScale = e.scale, e._originalTranslate = e.translate, e._originalTransform = e.transform, e._originalSetTransform = e.setTransform, e._transformMatrix = e._transformMatrix || [1, 0, 0, 1, 0, 0], e._transformStack = [], Object.defineProperty(e, "mozCurrentTransform", {
              get: function get() {
                return this._transformMatrix;
              }
            }), Object.defineProperty(e, "mozCurrentTransformInverse", {
              get: function get() {
                var e = this._transformMatrix,
                  t = e[0],
                  r = e[1],
                  n = e[2],
                  i = e[3],
                  a = e[4],
                  o = e[5],
                  s = t * i - r * n,
                  l = r * n - t * i;
                return [i / s, r / l, n / l, t / s, (i * a - n * o) / l, (r * a - t * o) / s];
              }
            }), e.save = function () {
              var e = this._transformMatrix;
              this._transformStack.push(e), this._transformMatrix = e.slice(0, 6), this._originalSave();
            }, e.restore = function () {
              var e = this._transformStack.pop();
              e && (this._transformMatrix = e, this._originalRestore());
            }, e.translate = function (e, t) {
              var r = this._transformMatrix;
              r[4] = r[0] * e + r[2] * t + r[4], r[5] = r[1] * e + r[3] * t + r[5], this._originalTranslate(e, t);
            }, e.scale = function (e, t) {
              var r = this._transformMatrix;
              r[0] = r[0] * e, r[1] = r[1] * e, r[2] = r[2] * t, r[3] = r[3] * t, this._originalScale(e, t);
            }, e.transform = function (t, r, n, i, a, o) {
              var s = this._transformMatrix;
              this._transformMatrix = [s[0] * t + s[2] * r, s[1] * t + s[3] * r, s[0] * n + s[2] * i, s[1] * n + s[3] * i, s[0] * a + s[2] * o + s[4], s[1] * a + s[3] * o + s[5]], e._originalTransform(t, r, n, i, a, o);
            }, e.setTransform = function (t, r, n, i, a, o) {
              this._transformMatrix = [t, r, n, i, a, o], e._originalSetTransform(t, r, n, i, a, o);
            }, e.rotate = function (e) {
              var t = Math.cos(e),
                r = Math.sin(e),
                n = this._transformMatrix;
              this._transformMatrix = [n[0] * t + n[2] * r, n[1] * t + n[3] * r, n[0] * -r + n[2] * t, n[1] * -r + n[3] * t, n[4], n[5]], this._originalRotate(e);
            });
          }
          function i(e) {
            var t,
              r,
              n,
              i,
              a = e.width,
              o = e.height,
              s = a + 1,
              l = new Uint8Array(s * (o + 1)),
              c = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]),
              u = a + 7 & -8,
              h = e.data,
              f = new Uint8Array(u * o),
              d = 0;
            for (t = 0, i = h.length; t < i; t++) for (var p = 128, m = h[t]; p > 0;) f[d++] = m & p ? 0 : 255, p >>= 1;
            var g = 0;
            for (d = 0, 0 !== f[d] && (l[0] = 1, ++g), r = 1; r < a; r++) f[d] !== f[d + 1] && (l[r] = f[d] ? 2 : 1, ++g), d++;
            for (0 !== f[d] && (l[r] = 2, ++g), t = 1; t < o; t++) {
              d = t * u, n = t * s, f[d - u] !== f[d] && (l[n] = f[d] ? 1 : 8, ++g);
              var v = (f[d] ? 4 : 0) + (f[d - u] ? 8 : 0);
              for (r = 1; r < a; r++) v = (v >> 2) + (f[d + 1] ? 4 : 0) + (f[d - u + 1] ? 8 : 0), c[v] && (l[n + r] = c[v], ++g), d++;
              if (f[d - u] !== f[d] && (l[n + r] = f[d] ? 2 : 4, ++g), g > 1e3) return null;
            }
            for (d = u * (o - 1), n = t * s, 0 !== f[d] && (l[n] = 8, ++g), r = 1; r < a; r++) f[d] !== f[d + 1] && (l[n + r] = f[d] ? 4 : 8, ++g), d++;
            if (0 !== f[d] && (l[n + r] = 4, ++g), g > 1e3) return null;
            var b = new Int32Array([0, s, -1, 0, -s, 0, 0, 0, 1]),
              y = [];
            for (t = 0; g && t <= o; t++) {
              for (var w = t * s, x = w + a; w < x && !l[w];) w++;
              if (w !== x) {
                var _,
                  S = [w % s, t],
                  C = l[w],
                  E = w;
                do {
                  var A = b[C];
                  do {
                    w += A;
                  } while (!l[w]);
                  _ = l[w], 5 !== _ && 10 !== _ ? (C = _, l[w] = 0) : (C = _ & 51 * C >> 4, l[w] &= C >> 2 | C << 2), S.push(w % s), S.push(w / s | 0), --g;
                } while (E !== w);
                y.push(S), --t;
              }
            }
            return function (e) {
              e.save(), e.scale(1 / a, -1 / o), e.translate(0, -o), e.beginPath();
              for (var t = 0, r = y.length; t < r; t++) {
                var n = y[t];
                e.moveTo(n[0], n[1]);
                for (var i = 2, s = n.length; i < s; i += 2) e.lineTo(n[i], n[i + 1]);
              }
              e.fill(), e.beginPath(), e.restore();
            };
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.CanvasGraphics = void 0;
          var a = r(0),
            o = r(46),
            s = r(25),
            l = 16,
            c = {
              get value() {
                return (0, a.shadow)(c, "value", (0, a.isLittleEndian)());
              }
            },
            u = function () {
              function e(e) {
                this.canvasFactory = e, this.cache = Object.create(null);
              }
              return e.prototype = {
                getCanvas: function getCanvas(e, t, r, i) {
                  var a;
                  return void 0 !== this.cache[e] ? (a = this.cache[e], this.canvasFactory.reset(a, t, r), a.context.setTransform(1, 0, 0, 1, 0, 0)) : (a = this.canvasFactory.create(t, r), this.cache[e] = a), i && n(a.context), a;
                },
                clear: function clear() {
                  for (var e in this.cache) {
                    var t = this.cache[e];
                    this.canvasFactory.destroy(t), delete this.cache[e];
                  }
                }
              }, e;
            }(),
            h = function () {
              function e(e) {
                this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = a.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = a.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = a.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.resumeSMaskCtx = null, this.old = e;
              }
              return e.prototype = {
                clone: function clone() {
                  return Object.create(this);
                },
                setCurrentPoint: function setCurrentPoint(e, t) {
                  this.x = e, this.y = t;
                }
              }, e;
            }(),
            f = function () {
              function e(e, t, r, i, a) {
                this.ctx = e, this.current = new h(), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = t, this.objs = r, this.canvasFactory = i, this.imageLayer = a, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.cachedCanvases = new u(this.canvasFactory), e && n(e), this.cachedGetSinglePixelWidth = null;
              }
              function t(e, t) {
                if ("undefined" != typeof ImageData && t instanceof ImageData) return void e.putImageData(t, 0, 0);
                var r,
                  n,
                  i,
                  o,
                  s,
                  u = t.height,
                  h = t.width,
                  f = u % l,
                  d = (u - f) / l,
                  p = 0 === f ? d : d + 1,
                  m = e.createImageData(h, l),
                  g = 0,
                  v = t.data,
                  b = m.data;
                if (t.kind === a.ImageKind.GRAYSCALE_1BPP) {
                  var y = v.byteLength,
                    w = new Uint32Array(b.buffer, 0, b.byteLength >> 2),
                    x = w.length,
                    _ = h + 7 >> 3,
                    S = 4294967295,
                    C = c.value ? 4278190080 : 255;
                  for (n = 0; n < p; n++) {
                    for (o = n < d ? l : f, r = 0, i = 0; i < o; i++) {
                      for (var E = y - g, A = 0, T = E > _ ? h : 8 * E - 7, k = -8 & T, R = 0, I = 0; A < k; A += 8) I = v[g++], w[r++] = 128 & I ? S : C, w[r++] = 64 & I ? S : C, w[r++] = 32 & I ? S : C, w[r++] = 16 & I ? S : C, w[r++] = 8 & I ? S : C, w[r++] = 4 & I ? S : C, w[r++] = 2 & I ? S : C, w[r++] = 1 & I ? S : C;
                      for (; A < T; A++) 0 === R && (I = v[g++], R = 128), w[r++] = I & R ? S : C, R >>= 1;
                    }
                    for (; r < x;) w[r++] = 0;
                    e.putImageData(m, 0, n * l);
                  }
                } else if (t.kind === a.ImageKind.RGBA_32BPP) {
                  for (i = 0, s = h * l * 4, n = 0; n < d; n++) b.set(v.subarray(g, g + s)), g += s, e.putImageData(m, 0, i), i += l;
                  n < p && (s = h * f * 4, b.set(v.subarray(g, g + s)), e.putImageData(m, 0, i));
                } else if (t.kind === a.ImageKind.RGB_24BPP) for (o = l, s = h * o, n = 0; n < p; n++) {
                  for (n >= d && (o = f, s = h * o), r = 0, i = s; i--;) b[r++] = v[g++], b[r++] = v[g++], b[r++] = v[g++], b[r++] = 255;
                  e.putImageData(m, 0, n * l);
                } else (0, a.error)("bad image kind: " + t.kind);
              }
              function r(e, t) {
                for (var r = t.height, n = t.width, i = r % l, a = (r - i) / l, o = 0 === i ? a : a + 1, s = e.createImageData(n, l), c = 0, u = t.data, h = s.data, f = 0; f < o; f++) {
                  for (var d = f < a ? l : i, p = 3, m = 0; m < d; m++) for (var g = 0, v = 0; v < n; v++) {
                    if (!g) {
                      var b = u[c++];
                      g = 128;
                    }
                    h[p] = b & g ? 0 : 255, p += 4, g >>= 1;
                  }
                  e.putImageData(s, 0, f * l);
                }
              }
              function f(e, t) {
                for (var r = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font"], n = 0, i = r.length; n < i; n++) {
                  var a = r[n];
                  void 0 !== e[a] && (t[a] = e[a]);
                }
                void 0 !== e.setLineDash && (t.setLineDash(e.getLineDash()), t.lineDashOffset = e.lineDashOffset);
              }
              function d(e, t, r, n) {
                for (var i = e.length, a = 3; a < i; a += 4) {
                  var o = e[a];
                  if (0 === o) e[a - 3] = t, e[a - 2] = r, e[a - 1] = n;else if (o < 255) {
                    var s = 255 - o;
                    e[a - 3] = e[a - 3] * o + t * s >> 8, e[a - 2] = e[a - 2] * o + r * s >> 8, e[a - 1] = e[a - 1] * o + n * s >> 8;
                  }
                }
              }
              function p(e, t, r) {
                for (var n = e.length, i = 3; i < n; i += 4) {
                  var a = r ? r[e[i]] : e[i];
                  t[i] = t[i] * a * (1 / 255) | 0;
                }
              }
              function m(e, t, r) {
                for (var n = e.length, i = 3; i < n; i += 4) {
                  var a = 77 * e[i - 3] + 152 * e[i - 2] + 28 * e[i - 1];
                  t[i] = r ? t[i] * r[a >> 8] >> 8 : t[i] * a >> 16;
                }
              }
              function g(e, t, r, n, i, a, o) {
                var s,
                  l = !!a,
                  c = l ? a[0] : 0,
                  u = l ? a[1] : 0,
                  h = l ? a[2] : 0;
                s = "Luminosity" === i ? m : p;
                for (var f = Math.min(n, Math.ceil(1048576 / r)), g = 0; g < n; g += f) {
                  var v = Math.min(f, n - g),
                    b = e.getImageData(0, g, r, v),
                    y = t.getImageData(0, g, r, v);
                  l && d(b.data, c, u, h), s(b.data, y.data, o), e.putImageData(y, 0, g);
                }
              }
              function v(e, t, r) {
                var n = t.canvas,
                  i = t.context;
                e.setTransform(t.scaleX, 0, 0, t.scaleY, t.offsetX, t.offsetY);
                var a = t.backdrop || null;
                if (!t.transferMap && s.WebGLUtils.isEnabled) {
                  var o = s.WebGLUtils.composeSMask(r.canvas, n, {
                    subtype: t.subtype,
                    backdrop: a
                  });
                  return e.setTransform(1, 0, 0, 1, 0, 0), void e.drawImage(o, t.offsetX, t.offsetY);
                }
                g(i, r, n.width, n.height, t.subtype, a, t.transferMap), e.drawImage(n, 0, 0);
              }
              var b = ["butt", "round", "square"],
                y = ["miter", "round", "bevel"],
                w = {},
                x = {};
              e.prototype = {
                beginDrawing: function beginDrawing(e, t, r) {
                  var n = this.ctx.canvas.width,
                    i = this.ctx.canvas.height;
                  if (this.ctx.save(), this.ctx.fillStyle = "rgb(255, 255, 255)", this.ctx.fillRect(0, 0, n, i), this.ctx.restore(), r) {
                    var a = this.cachedCanvases.getCanvas("transparent", n, i, !0);
                    this.compositeCtx = this.ctx, this.transparentCanvas = a.canvas, this.ctx = a.context, this.ctx.save(), this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                  }
                  this.ctx.save(), e && this.ctx.transform.apply(this.ctx, e), this.ctx.transform.apply(this.ctx, t.transform), this.baseTransform = this.ctx.mozCurrentTransform.slice(), this.imageLayer && this.imageLayer.beginLayout();
                },
                executeOperatorList: function executeOperatorList(e, t, r, n) {
                  var i = e.argsArray,
                    o = e.fnArray,
                    s = t || 0,
                    l = i.length;
                  if (l === s) return s;
                  for (var c, u = l - s > 10 && "function" == typeof r, h = u ? Date.now() + 15 : 0, f = 0, d = this.commonObjs, p = this.objs;;) {
                    if (void 0 !== n && s === n.nextBreakPoint) return n.breakIt(s, r), s;
                    if ((c = o[s]) !== a.OPS.dependency) this[c].apply(this, i[s]);else for (var m = i[s], g = 0, v = m.length; g < v; g++) {
                      var b = m[g],
                        y = "g" === b[0] && "_" === b[1],
                        w = y ? d : p;
                      if (!w.isResolved(b)) return w.get(b, r), s;
                    }
                    if (++s === l) return s;
                    if (u && ++f > 10) {
                      if (Date.now() > h) return r(), s;
                      f = 0;
                    }
                  }
                },
                endDrawing: function endDrawing() {
                  null !== this.current.activeSMask && this.endSMaskGroup(), this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null), this.cachedCanvases.clear(), s.WebGLUtils.clear(), this.imageLayer && this.imageLayer.endLayout();
                },
                setLineWidth: function setLineWidth(e) {
                  this.current.lineWidth = e, this.ctx.lineWidth = e;
                },
                setLineCap: function setLineCap(e) {
                  this.ctx.lineCap = b[e];
                },
                setLineJoin: function setLineJoin(e) {
                  this.ctx.lineJoin = y[e];
                },
                setMiterLimit: function setMiterLimit(e) {
                  this.ctx.miterLimit = e;
                },
                setDash: function setDash(e, t) {
                  var r = this.ctx;
                  void 0 !== r.setLineDash && (r.setLineDash(e), r.lineDashOffset = t);
                },
                setRenderingIntent: function setRenderingIntent(e) {},
                setFlatness: function setFlatness(e) {},
                setGState: function setGState(e) {
                  for (var t = 0, r = e.length; t < r; t++) {
                    var n = e[t],
                      i = n[0],
                      a = n[1];
                    switch (i) {
                      case "LW":
                        this.setLineWidth(a);
                        break;
                      case "LC":
                        this.setLineCap(a);
                        break;
                      case "LJ":
                        this.setLineJoin(a);
                        break;
                      case "ML":
                        this.setMiterLimit(a);
                        break;
                      case "D":
                        this.setDash(a[0], a[1]);
                        break;
                      case "RI":
                        this.setRenderingIntent(a);
                        break;
                      case "FL":
                        this.setFlatness(a);
                        break;
                      case "Font":
                        this.setFont(a[0], a[1]);
                        break;
                      case "CA":
                        this.current.strokeAlpha = n[1];
                        break;
                      case "ca":
                        this.current.fillAlpha = n[1], this.ctx.globalAlpha = n[1];
                        break;
                      case "BM":
                        this.ctx.globalCompositeOperation = a;
                        break;
                      case "SMask":
                        this.current.activeSMask && (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask ? this.suspendSMaskGroup() : this.endSMaskGroup()), this.current.activeSMask = a ? this.tempSMask : null, this.current.activeSMask && this.beginSMaskGroup(), this.tempSMask = null;
                    }
                  }
                },
                beginSMaskGroup: function beginSMaskGroup() {
                  var e = this.current.activeSMask,
                    t = e.canvas.width,
                    r = e.canvas.height,
                    n = "smaskGroupAt" + this.groupLevel,
                    i = this.cachedCanvases.getCanvas(n, t, r, !0),
                    a = this.ctx,
                    o = a.mozCurrentTransform;
                  this.ctx.save();
                  var s = i.context;
                  s.scale(1 / e.scaleX, 1 / e.scaleY), s.translate(-e.offsetX, -e.offsetY), s.transform.apply(s, o), e.startTransformInverse = s.mozCurrentTransformInverse, f(a, s), this.ctx = s, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(a), this.groupLevel++;
                },
                suspendSMaskGroup: function suspendSMaskGroup() {
                  var e = this.ctx;
                  this.groupLevel--, this.ctx = this.groupStack.pop(), v(this.ctx, this.current.activeSMask, e), this.ctx.restore(), this.ctx.save(), f(e, this.ctx), this.current.resumeSMaskCtx = e;
                  var t = a.Util.transform(this.current.activeSMask.startTransformInverse, e.mozCurrentTransform);
                  this.ctx.transform.apply(this.ctx, t), e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.clearRect(0, 0, e.canvas.width, e.canvas.height), e.restore();
                },
                resumeSMaskGroup: function resumeSMaskGroup() {
                  var e = this.current.resumeSMaskCtx,
                    t = this.ctx;
                  this.ctx = e, this.groupStack.push(t), this.groupLevel++;
                },
                endSMaskGroup: function endSMaskGroup() {
                  var e = this.ctx;
                  this.groupLevel--, this.ctx = this.groupStack.pop(), v(this.ctx, this.current.activeSMask, e), this.ctx.restore(), f(e, this.ctx);
                  var t = a.Util.transform(this.current.activeSMask.startTransformInverse, e.mozCurrentTransform);
                  this.ctx.transform.apply(this.ctx, t);
                },
                save: function save() {
                  this.ctx.save();
                  var e = this.current;
                  this.stateStack.push(e), this.current = e.clone(), this.current.resumeSMaskCtx = null;
                },
                restore: function restore() {
                  this.current.resumeSMaskCtx && this.resumeSMaskGroup(), null === this.current.activeSMask || 0 !== this.stateStack.length && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask || this.endSMaskGroup(), 0 !== this.stateStack.length && (this.current = this.stateStack.pop(), this.ctx.restore(), this.pendingClip = null, this.cachedGetSinglePixelWidth = null);
                },
                transform: function transform(e, t, r, n, i, a) {
                  this.ctx.transform(e, t, r, n, i, a), this.cachedGetSinglePixelWidth = null;
                },
                constructPath: function constructPath(e, t) {
                  for (var r = this.ctx, n = this.current, i = n.x, o = n.y, s = 0, l = 0, c = e.length; s < c; s++) switch (0 | e[s]) {
                    case a.OPS.rectangle:
                      i = t[l++], o = t[l++];
                      var u = t[l++],
                        h = t[l++];
                      0 === u && (u = this.getSinglePixelWidth()), 0 === h && (h = this.getSinglePixelWidth());
                      var f = i + u,
                        d = o + h;
                      this.ctx.moveTo(i, o), this.ctx.lineTo(f, o), this.ctx.lineTo(f, d), this.ctx.lineTo(i, d), this.ctx.lineTo(i, o), this.ctx.closePath();
                      break;
                    case a.OPS.moveTo:
                      i = t[l++], o = t[l++], r.moveTo(i, o);
                      break;
                    case a.OPS.lineTo:
                      i = t[l++], o = t[l++], r.lineTo(i, o);
                      break;
                    case a.OPS.curveTo:
                      i = t[l + 4], o = t[l + 5], r.bezierCurveTo(t[l], t[l + 1], t[l + 2], t[l + 3], i, o), l += 6;
                      break;
                    case a.OPS.curveTo2:
                      r.bezierCurveTo(i, o, t[l], t[l + 1], t[l + 2], t[l + 3]), i = t[l + 2], o = t[l + 3], l += 4;
                      break;
                    case a.OPS.curveTo3:
                      i = t[l + 2], o = t[l + 3], r.bezierCurveTo(t[l], t[l + 1], i, o, i, o), l += 4;
                      break;
                    case a.OPS.closePath:
                      r.closePath();
                  }
                  n.setCurrentPoint(i, o);
                },
                closePath: function closePath() {
                  this.ctx.closePath();
                },
                stroke: function stroke(e) {
                  e = void 0 === e || e;
                  var t = this.ctx,
                    r = this.current.strokeColor;
                  t.lineWidth = Math.max(.65 * this.getSinglePixelWidth(), this.current.lineWidth), t.globalAlpha = this.current.strokeAlpha, r && r.hasOwnProperty("type") && "Pattern" === r.type ? (t.save(), t.strokeStyle = r.getPattern(t, this), t.stroke(), t.restore()) : t.stroke(), e && this.consumePath(), t.globalAlpha = this.current.fillAlpha;
                },
                closeStroke: function closeStroke() {
                  this.closePath(), this.stroke();
                },
                fill: function fill(e) {
                  e = void 0 === e || e;
                  var t = this.ctx,
                    r = this.current.fillColor,
                    n = this.current.patternFill,
                    i = !1;
                  n && (t.save(), this.baseTransform && t.setTransform.apply(t, this.baseTransform), t.fillStyle = r.getPattern(t, this), i = !0), this.pendingEOFill ? (t.fill("evenodd"), this.pendingEOFill = !1) : t.fill(), i && t.restore(), e && this.consumePath();
                },
                eoFill: function eoFill() {
                  this.pendingEOFill = !0, this.fill();
                },
                fillStroke: function fillStroke() {
                  this.fill(!1), this.stroke(!1), this.consumePath();
                },
                eoFillStroke: function eoFillStroke() {
                  this.pendingEOFill = !0, this.fillStroke();
                },
                closeFillStroke: function closeFillStroke() {
                  this.closePath(), this.fillStroke();
                },
                closeEOFillStroke: function closeEOFillStroke() {
                  this.pendingEOFill = !0, this.closePath(), this.fillStroke();
                },
                endPath: function endPath() {
                  this.consumePath();
                },
                clip: function clip() {
                  this.pendingClip = w;
                },
                eoClip: function eoClip() {
                  this.pendingClip = x;
                },
                beginText: function beginText() {
                  this.current.textMatrix = a.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
                },
                endText: function endText() {
                  var e = this.pendingTextPaths,
                    t = this.ctx;
                  if (void 0 === e) return void t.beginPath();
                  t.save(), t.beginPath();
                  for (var r = 0; r < e.length; r++) {
                    var n = e[r];
                    t.setTransform.apply(t, n.transform), t.translate(n.x, n.y), n.addToPath(t, n.fontSize);
                  }
                  t.restore(), t.clip(), t.beginPath(), delete this.pendingTextPaths;
                },
                setCharSpacing: function setCharSpacing(e) {
                  this.current.charSpacing = e;
                },
                setWordSpacing: function setWordSpacing(e) {
                  this.current.wordSpacing = e;
                },
                setHScale: function setHScale(e) {
                  this.current.textHScale = e / 100;
                },
                setLeading: function setLeading(e) {
                  this.current.leading = -e;
                },
                setFont: function setFont(e, t) {
                  var r = this.commonObjs.get(e),
                    n = this.current;
                  if (r || (0, a.error)("Can't find font for " + e), n.fontMatrix = r.fontMatrix ? r.fontMatrix : a.FONT_IDENTITY_MATRIX, 0 !== n.fontMatrix[0] && 0 !== n.fontMatrix[3] || (0, a.warn)("Invalid font matrix for font " + e), t < 0 ? (t = -t, n.fontDirection = -1) : n.fontDirection = 1, this.current.font = r, this.current.fontSize = t, !r.isType3Font) {
                    var i = r.loadedName || "sans-serif",
                      o = r.black ? "900" : r.bold ? "bold" : "normal",
                      s = r.italic ? "italic" : "normal",
                      l = '"' + i + '", ' + r.fallbackName,
                      c = t < 16 ? 16 : t > 100 ? 100 : t;
                    this.current.fontSizeScale = t / c;
                    var u = s + " " + o + " " + c + "px " + l;
                    this.ctx.font = u;
                  }
                },
                setTextRenderingMode: function setTextRenderingMode(e) {
                  this.current.textRenderingMode = e;
                },
                setTextRise: function setTextRise(e) {
                  this.current.textRise = e;
                },
                moveText: function moveText(e, t) {
                  this.current.x = this.current.lineX += e, this.current.y = this.current.lineY += t;
                },
                setLeadingMoveText: function setLeadingMoveText(e, t) {
                  this.setLeading(-t), this.moveText(e, t);
                },
                setTextMatrix: function setTextMatrix(e, t, r, n, i, a) {
                  this.current.textMatrix = [e, t, r, n, i, a], this.current.textMatrixScale = Math.sqrt(e * e + t * t), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
                },
                nextLine: function nextLine() {
                  this.moveText(0, this.current.leading);
                },
                paintChar: function paintChar(e, t, r) {
                  var n,
                    i = this.ctx,
                    o = this.current,
                    s = o.font,
                    l = o.textRenderingMode,
                    c = o.fontSize / o.fontSizeScale,
                    u = l & a.TextRenderingMode.FILL_STROKE_MASK,
                    h = !!(l & a.TextRenderingMode.ADD_TO_PATH_FLAG);
                  if ((s.disableFontFace || h) && (n = s.getPathGenerator(this.commonObjs, e)), s.disableFontFace ? (i.save(), i.translate(t, r), i.beginPath(), n(i, c), u !== a.TextRenderingMode.FILL && u !== a.TextRenderingMode.FILL_STROKE || i.fill(), u !== a.TextRenderingMode.STROKE && u !== a.TextRenderingMode.FILL_STROKE || i.stroke(), i.restore()) : (u !== a.TextRenderingMode.FILL && u !== a.TextRenderingMode.FILL_STROKE || i.fillText(e, t, r), u !== a.TextRenderingMode.STROKE && u !== a.TextRenderingMode.FILL_STROKE || i.strokeText(e, t, r)), h) {
                    (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                      transform: i.mozCurrentTransform,
                      x: t,
                      y: r,
                      fontSize: c,
                      addToPath: n
                    });
                  }
                },
                get isFontSubpixelAAEnabled() {
                  var e = this.canvasFactory.create(10, 10).context;
                  e.scale(1.5, 1), e.fillText("I", 0, 10);
                  for (var t = e.getImageData(0, 0, 10, 10).data, r = !1, n = 3; n < t.length; n += 4) if (t[n] > 0 && t[n] < 255) {
                    r = !0;
                    break;
                  }
                  return (0, a.shadow)(this, "isFontSubpixelAAEnabled", r);
                },
                showText: function showText(e) {
                  var t = this.current,
                    r = t.font;
                  if (r.isType3Font) return this.showType3Text(e);
                  var n = t.fontSize;
                  if (0 !== n) {
                    var i = this.ctx,
                      o = t.fontSizeScale,
                      s = t.charSpacing,
                      l = t.wordSpacing,
                      c = t.fontDirection,
                      u = t.textHScale * c,
                      h = e.length,
                      f = r.vertical,
                      d = f ? 1 : -1,
                      p = r.defaultVMetrics,
                      m = n * t.fontMatrix[0],
                      g = t.textRenderingMode === a.TextRenderingMode.FILL && !r.disableFontFace;
                    i.save(), i.transform.apply(i, t.textMatrix), i.translate(t.x, t.y + t.textRise), t.patternFill && (i.fillStyle = t.fillColor.getPattern(i, this)), c > 0 ? i.scale(u, -1) : i.scale(u, 1);
                    var v = t.lineWidth,
                      b = t.textMatrixScale;
                    if (0 === b || 0 === v) {
                      var y = t.textRenderingMode & a.TextRenderingMode.FILL_STROKE_MASK;
                      y !== a.TextRenderingMode.STROKE && y !== a.TextRenderingMode.FILL_STROKE || (this.cachedGetSinglePixelWidth = null, v = .65 * this.getSinglePixelWidth());
                    } else v /= b;
                    1 !== o && (i.scale(o, o), v /= o), i.lineWidth = v;
                    var w,
                      x = 0;
                    for (w = 0; w < h; ++w) {
                      var _ = e[w];
                      if ((0, a.isNum)(_)) x += d * _ * n / 1e3;else {
                        var S,
                          C,
                          E,
                          A,
                          T = !1,
                          k = (_.isSpace ? l : 0) + s,
                          R = _.fontChar,
                          I = _.accent,
                          M = _.width;
                        if (f) {
                          var O, P, B;
                          O = _.vmetric || p, P = _.vmetric ? O[1] : .5 * M, P = -P * m, B = O[2] * m, M = O ? -O[0] : M, S = P / o, C = (x + B) / o;
                        } else S = x / o, C = 0;
                        if (r.remeasure && M > 0) {
                          var D = 1e3 * i.measureText(R).width / n * o;
                          if (M < D && this.isFontSubpixelAAEnabled) {
                            var L = M / D;
                            T = !0, i.save(), i.scale(L, 1), S /= L;
                          } else M !== D && (S += (M - D) / 2e3 * n / o);
                        }
                        (_.isInFont || r.missingFile) && (g && !I ? i.fillText(R, S, C) : (this.paintChar(R, S, C), I && (E = S + I.offset.x / o, A = C - I.offset.y / o, this.paintChar(I.fontChar, E, A))));
                        x += M * m + k * c, T && i.restore();
                      }
                    }
                    f ? t.y -= x * u : t.x += x * u, i.restore();
                  }
                },
                showType3Text: function showType3Text(e) {
                  var t,
                    r,
                    n,
                    i,
                    o = this.ctx,
                    s = this.current,
                    l = s.font,
                    c = s.fontSize,
                    u = s.fontDirection,
                    h = l.vertical ? 1 : -1,
                    f = s.charSpacing,
                    d = s.wordSpacing,
                    p = s.textHScale * u,
                    m = s.fontMatrix || a.FONT_IDENTITY_MATRIX,
                    g = e.length,
                    v = s.textRenderingMode === a.TextRenderingMode.INVISIBLE;
                  if (!v && 0 !== c) {
                    for (this.cachedGetSinglePixelWidth = null, o.save(), o.transform.apply(o, s.textMatrix), o.translate(s.x, s.y), o.scale(p, u), t = 0; t < g; ++t) if (r = e[t], (0, a.isNum)(r)) i = h * r * c / 1e3, this.ctx.translate(i, 0), s.x += i * p;else {
                      var b = (r.isSpace ? d : 0) + f,
                        y = l.charProcOperatorList[r.operatorListId];
                      if (y) {
                        this.processingType3 = r, this.save(), o.scale(c, c), o.transform.apply(o, m), this.executeOperatorList(y), this.restore();
                        var w = a.Util.applyTransform([r.width, 0], m);
                        n = w[0] * c + b, o.translate(n, 0), s.x += n * p;
                      } else (0, a.warn)('Type3 character "' + r.operatorListId + '" is not available.');
                    }
                    o.restore(), this.processingType3 = null;
                  }
                },
                setCharWidth: function setCharWidth(e, t) {},
                setCharWidthAndBounds: function setCharWidthAndBounds(e, t, r, n, i, a) {
                  this.ctx.rect(r, n, i - r, a - n), this.clip(), this.endPath();
                },
                getColorN_Pattern: function getColorN_Pattern(t) {
                  var r,
                    n = this;
                  if ("TilingPattern" === t[0]) {
                    var i = t[1],
                      a = this.baseTransform || this.ctx.mozCurrentTransform.slice(),
                      s = {
                        createCanvasGraphics: function createCanvasGraphics(t) {
                          return new e(t, n.commonObjs, n.objs, n.canvasFactory);
                        }
                      };
                    r = new o.TilingPattern(t, i, this.ctx, s, a);
                  } else r = (0, o.getShadingPatternFromIR)(t);
                  return r;
                },
                setStrokeColorN: function setStrokeColorN() {
                  this.current.strokeColor = this.getColorN_Pattern(arguments);
                },
                setFillColorN: function setFillColorN() {
                  this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
                },
                setStrokeRGBColor: function setStrokeRGBColor(e, t, r) {
                  var n = a.Util.makeCssRgb(e, t, r);
                  this.ctx.strokeStyle = n, this.current.strokeColor = n;
                },
                setFillRGBColor: function setFillRGBColor(e, t, r) {
                  var n = a.Util.makeCssRgb(e, t, r);
                  this.ctx.fillStyle = n, this.current.fillColor = n, this.current.patternFill = !1;
                },
                shadingFill: function shadingFill(e) {
                  var t = this.ctx;
                  this.save();
                  var r = (0, o.getShadingPatternFromIR)(e);
                  t.fillStyle = r.getPattern(t, this, !0);
                  var n = t.mozCurrentTransformInverse;
                  if (n) {
                    var i = t.canvas,
                      s = i.width,
                      l = i.height,
                      c = a.Util.applyTransform([0, 0], n),
                      u = a.Util.applyTransform([0, l], n),
                      h = a.Util.applyTransform([s, 0], n),
                      f = a.Util.applyTransform([s, l], n),
                      d = Math.min(c[0], u[0], h[0], f[0]),
                      p = Math.min(c[1], u[1], h[1], f[1]),
                      m = Math.max(c[0], u[0], h[0], f[0]),
                      g = Math.max(c[1], u[1], h[1], f[1]);
                    this.ctx.fillRect(d, p, m - d, g - p);
                  } else this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                  this.restore();
                },
                beginInlineImage: function beginInlineImage() {
                  (0, a.error)("Should not call beginInlineImage");
                },
                beginImageData: function beginImageData() {
                  (0, a.error)("Should not call beginImageData");
                },
                paintFormXObjectBegin: function paintFormXObjectBegin(e, t) {
                  if (this.save(), this.baseTransformStack.push(this.baseTransform), (0, a.isArray)(e) && 6 === e.length && this.transform.apply(this, e), this.baseTransform = this.ctx.mozCurrentTransform, (0, a.isArray)(t) && 4 === t.length) {
                    var r = t[2] - t[0],
                      n = t[3] - t[1];
                    this.ctx.rect(t[0], t[1], r, n), this.clip(), this.endPath();
                  }
                },
                paintFormXObjectEnd: function paintFormXObjectEnd() {
                  this.restore(), this.baseTransform = this.baseTransformStack.pop();
                },
                beginGroup: function beginGroup(e) {
                  this.save();
                  var t = this.ctx;
                  e.isolated || (0, a.info)("TODO: Support non-isolated groups."), e.knockout && (0, a.warn)("Knockout groups not supported.");
                  var r = t.mozCurrentTransform;
                  e.matrix && t.transform.apply(t, e.matrix), (0, a.assert)(e.bbox, "Bounding box is required.");
                  var n = a.Util.getAxialAlignedBoundingBox(e.bbox, t.mozCurrentTransform),
                    i = [0, 0, t.canvas.width, t.canvas.height];
                  n = a.Util.intersect(n, i) || [0, 0, 0, 0];
                  var o = Math.floor(n[0]),
                    s = Math.floor(n[1]),
                    l = Math.max(Math.ceil(n[2]) - o, 1),
                    c = Math.max(Math.ceil(n[3]) - s, 1),
                    u = 1,
                    h = 1;
                  l > 4096 && (u = l / 4096, l = 4096), c > 4096 && (h = c / 4096, c = 4096);
                  var d = "groupAt" + this.groupLevel;
                  e.smask && (d += "_smask_" + this.smaskCounter++ % 2);
                  var p = this.cachedCanvases.getCanvas(d, l, c, !0),
                    m = p.context;
                  m.scale(1 / u, 1 / h), m.translate(-o, -s), m.transform.apply(m, r), e.smask ? this.smaskStack.push({
                    canvas: p.canvas,
                    context: m,
                    offsetX: o,
                    offsetY: s,
                    scaleX: u,
                    scaleY: h,
                    subtype: e.smask.subtype,
                    backdrop: e.smask.backdrop,
                    transferMap: e.smask.transferMap || null,
                    startTransformInverse: null
                  }) : (t.setTransform(1, 0, 0, 1, 0, 0), t.translate(o, s), t.scale(u, h)), f(t, m), this.ctx = m, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(t), this.groupLevel++, this.current.activeSMask = null;
                },
                endGroup: function endGroup(e) {
                  this.groupLevel--;
                  var t = this.ctx;
                  this.ctx = this.groupStack.pop(), void 0 !== this.ctx.imageSmoothingEnabled ? this.ctx.imageSmoothingEnabled = !1 : this.ctx.mozImageSmoothingEnabled = !1, e.smask ? this.tempSMask = this.smaskStack.pop() : this.ctx.drawImage(t.canvas, 0, 0), this.restore();
                },
                beginAnnotations: function beginAnnotations() {
                  this.save(), this.current = new h(), this.baseTransform && this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                },
                endAnnotations: function endAnnotations() {
                  this.restore();
                },
                beginAnnotation: function beginAnnotation(e, t, r) {
                  if (this.save(), (0, a.isArray)(e) && 4 === e.length) {
                    var n = e[2] - e[0],
                      i = e[3] - e[1];
                    this.ctx.rect(e[0], e[1], n, i), this.clip(), this.endPath();
                  }
                  this.transform.apply(this, t), this.transform.apply(this, r);
                },
                endAnnotation: function endAnnotation() {
                  this.restore();
                },
                paintJpegXObject: function paintJpegXObject(e, t, r) {
                  var n = this.objs.get(e);
                  if (!n) return void (0, a.warn)("Dependent image isn't ready yet");
                  this.save();
                  var i = this.ctx;
                  if (i.scale(1 / t, -1 / r), i.drawImage(n, 0, 0, n.width, n.height, 0, -r, t, r), this.imageLayer) {
                    var o = i.mozCurrentTransformInverse,
                      s = this.getCanvasPosition(0, 0);
                    this.imageLayer.appendImage({
                      objId: e,
                      left: s[0],
                      top: s[1],
                      width: t / o[0],
                      height: r / o[3]
                    });
                  }
                  this.restore();
                },
                paintImageMaskXObject: function paintImageMaskXObject(e) {
                  var t = this.ctx,
                    n = e.width,
                    a = e.height,
                    o = this.current.fillColor,
                    s = this.current.patternFill,
                    l = this.processingType3;
                  if (l && void 0 === l.compiled && (l.compiled = n <= 1e3 && a <= 1e3 ? i({
                    data: e.data,
                    width: n,
                    height: a
                  }) : null), l && l.compiled) return void l.compiled(t);
                  var c = this.cachedCanvases.getCanvas("maskCanvas", n, a),
                    u = c.context;
                  u.save(), r(u, e), u.globalCompositeOperation = "source-in", u.fillStyle = s ? o.getPattern(u, this) : o, u.fillRect(0, 0, n, a), u.restore(), this.paintInlineImageXObject(c.canvas);
                },
                paintImageMaskXObjectRepeat: function paintImageMaskXObjectRepeat(e, t, n, i) {
                  var a = e.width,
                    o = e.height,
                    s = this.current.fillColor,
                    l = this.current.patternFill,
                    c = this.cachedCanvases.getCanvas("maskCanvas", a, o),
                    u = c.context;
                  u.save(), r(u, e), u.globalCompositeOperation = "source-in", u.fillStyle = l ? s.getPattern(u, this) : s, u.fillRect(0, 0, a, o), u.restore();
                  for (var h = this.ctx, f = 0, d = i.length; f < d; f += 2) h.save(), h.transform(t, 0, 0, n, i[f], i[f + 1]), h.scale(1, -1), h.drawImage(c.canvas, 0, 0, a, o, 0, -1, 1, 1), h.restore();
                },
                paintImageMaskXObjectGroup: function paintImageMaskXObjectGroup(e) {
                  for (var t = this.ctx, n = this.current.fillColor, i = this.current.patternFill, a = 0, o = e.length; a < o; a++) {
                    var s = e[a],
                      l = s.width,
                      c = s.height,
                      u = this.cachedCanvases.getCanvas("maskCanvas", l, c),
                      h = u.context;
                    h.save(), r(h, s), h.globalCompositeOperation = "source-in", h.fillStyle = i ? n.getPattern(h, this) : n, h.fillRect(0, 0, l, c), h.restore(), t.save(), t.transform.apply(t, s.transform), t.scale(1, -1), t.drawImage(u.canvas, 0, 0, l, c, 0, -1, 1, 1), t.restore();
                  }
                },
                paintImageXObject: function paintImageXObject(e) {
                  var t = this.objs.get(e);
                  if (!t) return void (0, a.warn)("Dependent image isn't ready yet");
                  this.paintInlineImageXObject(t);
                },
                paintImageXObjectRepeat: function paintImageXObjectRepeat(e, t, r, n) {
                  var i = this.objs.get(e);
                  if (!i) return void (0, a.warn)("Dependent image isn't ready yet");
                  for (var o = i.width, s = i.height, l = [], c = 0, u = n.length; c < u; c += 2) l.push({
                    transform: [t, 0, 0, r, n[c], n[c + 1]],
                    x: 0,
                    y: 0,
                    w: o,
                    h: s
                  });
                  this.paintInlineImageXObjectGroup(i, l);
                },
                paintInlineImageXObject: function paintInlineImageXObject(e) {
                  var r = e.width,
                    n = e.height,
                    i = this.ctx;
                  this.save(), i.scale(1 / r, -1 / n);
                  var a,
                    o,
                    s = i.mozCurrentTransformInverse,
                    l = s[0],
                    c = s[1],
                    u = Math.max(Math.sqrt(l * l + c * c), 1),
                    h = s[2],
                    f = s[3],
                    d = Math.max(Math.sqrt(h * h + f * f), 1);
                  if (e instanceof HTMLElement || !e.data) a = e;else {
                    o = this.cachedCanvases.getCanvas("inlineImage", r, n);
                    var p = o.context;
                    t(p, e), a = o.canvas;
                  }
                  for (var m = r, g = n, v = "prescale1"; u > 2 && m > 1 || d > 2 && g > 1;) {
                    var b = m,
                      y = g;
                    u > 2 && m > 1 && (b = Math.ceil(m / 2), u /= m / b), d > 2 && g > 1 && (y = Math.ceil(g / 2), d /= g / y), o = this.cachedCanvases.getCanvas(v, b, y), p = o.context, p.clearRect(0, 0, b, y), p.drawImage(a, 0, 0, m, g, 0, 0, b, y), a = o.canvas, m = b, g = y, v = "prescale1" === v ? "prescale2" : "prescale1";
                  }
                  if (i.drawImage(a, 0, 0, m, g, 0, -n, r, n), this.imageLayer) {
                    var w = this.getCanvasPosition(0, -n);
                    this.imageLayer.appendImage({
                      imgData: e,
                      left: w[0],
                      top: w[1],
                      width: r / s[0],
                      height: n / s[3]
                    });
                  }
                  this.restore();
                },
                paintInlineImageXObjectGroup: function paintInlineImageXObjectGroup(e, r) {
                  var n = this.ctx,
                    i = e.width,
                    a = e.height,
                    o = this.cachedCanvases.getCanvas("inlineImage", i, a);
                  t(o.context, e);
                  for (var s = 0, l = r.length; s < l; s++) {
                    var c = r[s];
                    if (n.save(), n.transform.apply(n, c.transform), n.scale(1, -1), n.drawImage(o.canvas, c.x, c.y, c.w, c.h, 0, -1, 1, 1), this.imageLayer) {
                      var u = this.getCanvasPosition(c.x, c.y);
                      this.imageLayer.appendImage({
                        imgData: e,
                        left: u[0],
                        top: u[1],
                        width: i,
                        height: a
                      });
                    }
                    n.restore();
                  }
                },
                paintSolidColorImageMask: function paintSolidColorImageMask() {
                  this.ctx.fillRect(0, 0, 1, 1);
                },
                paintXObject: function paintXObject() {
                  (0, a.warn)("Unsupported 'paintXObject' command.");
                },
                markPoint: function markPoint(e) {},
                markPointProps: function markPointProps(e, t) {},
                beginMarkedContent: function beginMarkedContent(e) {},
                beginMarkedContentProps: function beginMarkedContentProps(e, t) {},
                endMarkedContent: function endMarkedContent() {},
                beginCompat: function beginCompat() {},
                endCompat: function endCompat() {},
                consumePath: function consumePath() {
                  var e = this.ctx;
                  this.pendingClip && (this.pendingClip === x ? e.clip("evenodd") : e.clip(), this.pendingClip = null), e.beginPath();
                },
                getSinglePixelWidth: function getSinglePixelWidth(e) {
                  if (null === this.cachedGetSinglePixelWidth) {
                    this.ctx.save();
                    var t = this.ctx.mozCurrentTransformInverse;
                    this.ctx.restore(), this.cachedGetSinglePixelWidth = Math.sqrt(Math.max(t[0] * t[0] + t[1] * t[1], t[2] * t[2] + t[3] * t[3]));
                  }
                  return this.cachedGetSinglePixelWidth;
                },
                getCanvasPosition: function getCanvasPosition(e, t) {
                  var r = this.ctx.mozCurrentTransform;
                  return [r[0] * e + r[2] * t + r[4], r[1] * e + r[3] * t + r[5]];
                }
              };
              for (var _ in a.OPS) e.prototype[a.OPS[_]] = e.prototype[_];
              return e;
            }();
          t.CanvasGraphics = f;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            this.docId = e, this.styleElement = null, this.nativeFontFaces = [], this.loadTestFontId = 0, this.loadingContext = {
              requests: [],
              nextRequestId: 0
            };
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.FontLoader = t.FontFaceObject = void 0;
          var i = r(0);
          n.prototype = {
            insertRule: function insertRule(e) {
              var t = this.styleElement;
              t || (t = this.styleElement = document.createElement("style"), t.id = "PDFJS_FONT_STYLE_TAG_" + this.docId, document.documentElement.getElementsByTagName("head")[0].appendChild(t));
              var r = t.sheet;
              r.insertRule(e, r.cssRules.length);
            },
            clear: function clear() {
              this.styleElement && (this.styleElement.remove(), this.styleElement = null), this.nativeFontFaces.forEach(function (e) {
                document.fonts.delete(e);
              }), this.nativeFontFaces.length = 0;
            }
          };
          var a = function a() {
            return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
          };
          Object.defineProperty(n.prototype, "loadTestFont", {
            get: function get() {
              return (0, i.shadow)(this, "loadTestFont", a());
            },
            configurable: !0
          }), n.prototype.addNativeFontFace = function (e) {
            this.nativeFontFaces.push(e), document.fonts.add(e);
          }, n.prototype.bind = function (e, t) {
            for (var r = [], a = [], o = [], s = n.isFontLoadingAPISupported && !n.isSyncFontLoadingSupported, l = 0, c = e.length; l < c; l++) {
              var u = e[l];
              if (!u.attached && !1 !== u.loading) if (u.attached = !0, s) {
                var h = u.createNativeFontFace();
                h && (this.addNativeFontFace(h), o.push(function (e) {
                  return e.loaded.catch(function (t) {
                    (0, i.warn)('Failed to load font "' + e.family + '": ' + t);
                  });
                }(h)));
              } else {
                var f = u.createFontFaceRule();
                f && (this.insertRule(f), r.push(f), a.push(u));
              }
            }
            var d = this.queueLoadingCallback(t);
            s ? Promise.all(o).then(function () {
              d.complete();
            }) : r.length > 0 && !n.isSyncFontLoadingSupported ? this.prepareFontLoadEvent(r, a, d) : d.complete();
          }, n.prototype.queueLoadingCallback = function (e) {
            function t() {
              for ((0, i.assert)(!a.end, "completeRequest() cannot be called twice"), a.end = Date.now(); r.requests.length > 0 && r.requests[0].end;) {
                var e = r.requests.shift();
                setTimeout(e.callback, 0);
              }
            }
            var r = this.loadingContext,
              n = "pdfjs-font-loading-" + r.nextRequestId++,
              a = {
                id: n,
                complete: t,
                callback: e,
                started: Date.now()
              };
            return r.requests.push(a), a;
          }, n.prototype.prepareFontLoadEvent = function (e, t, r) {
            function n(e, t) {
              return e.charCodeAt(t) << 24 | e.charCodeAt(t + 1) << 16 | e.charCodeAt(t + 2) << 8 | 255 & e.charCodeAt(t + 3);
            }
            function a(e, t, r, n) {
              return e.substr(0, t) + n + e.substr(t + r);
            }
            function o(e, t) {
              return ++h > 30 ? ((0, i.warn)("Load test font never loaded."), void t()) : (u.font = "30px " + e, u.fillText(".", 0, 20), u.getImageData(0, 0, 1, 1).data[3] > 0 ? void t() : void setTimeout(o.bind(null, e, t)));
            }
            var s,
              l,
              c = document.createElement("canvas");
            c.width = 1, c.height = 1;
            var u = c.getContext("2d"),
              h = 0,
              f = "lt" + Date.now() + this.loadTestFontId++,
              d = this.loadTestFont;
            d = a(d, 976, f.length, f);
            var p = n(d, 16);
            for (s = 0, l = f.length - 3; s < l; s += 4) p = p - 1482184792 + n(f, s) | 0;
            s < f.length && (p = p - 1482184792 + n(f + "XXX", s) | 0), d = a(d, 16, 4, (0, i.string32)(p));
            var m = "url(data:font/opentype;base64," + btoa(d) + ");",
              g = '@font-face { font-family:"' + f + '";src:' + m + "}";
            this.insertRule(g);
            var v = [];
            for (s = 0, l = t.length; s < l; s++) v.push(t[s].loadedName);
            v.push(f);
            var b = document.createElement("div");
            for (b.setAttribute("style", "visibility: hidden;width: 10px; height: 10px;position: absolute; top: 0px; left: 0px;"), s = 0, l = v.length; s < l; ++s) {
              var y = document.createElement("span");
              y.textContent = "Hi", y.style.fontFamily = v[s], b.appendChild(y);
            }
            document.body.appendChild(b), o(f, function () {
              document.body.removeChild(b), r.complete();
            });
          }, n.isFontLoadingAPISupported = "undefined" != typeof document && !!document.fonts;
          var o = function o() {
            if ("undefined" == typeof navigator) return !0;
            var e = !1,
              t = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
            return t && t[1] >= 14 && (e = !0), e;
          };
          Object.defineProperty(n, "isSyncFontLoadingSupported", {
            get: function get() {
              return (0, i.shadow)(n, "isSyncFontLoadingSupported", o());
            },
            enumerable: !0,
            configurable: !0
          });
          var s = {
              get value() {
                return (0, i.shadow)(this, "value", (0, i.isEvalSupported)());
              }
            },
            l = function () {
              function e(e, t) {
                this.compiledGlyphs = Object.create(null);
                for (var r in e) this[r] = e[r];
                this.options = t;
              }
              return e.prototype = {
                createNativeFontFace: function createNativeFontFace() {
                  if (!this.data) return null;
                  if (this.options.disableFontFace) return this.disableFontFace = !0, null;
                  var e = new FontFace(this.loadedName, this.data, {});
                  return this.options.fontRegistry && this.options.fontRegistry.registerFont(this), e;
                },
                createFontFaceRule: function createFontFaceRule() {
                  if (!this.data) return null;
                  if (this.options.disableFontFace) return this.disableFontFace = !0, null;
                  var e = (0, i.bytesToString)(new Uint8Array(this.data)),
                    t = this.loadedName,
                    r = "url(data:" + this.mimetype + ";base64," + btoa(e) + ");",
                    n = '@font-face { font-family:"' + t + '";src:' + r + "}";
                  return this.options.fontRegistry && this.options.fontRegistry.registerFont(this, r), n;
                },
                getPathGenerator: function getPathGenerator(e, t) {
                  if (!(t in this.compiledGlyphs)) {
                    var r,
                      n,
                      i,
                      a = e.get(this.loadedName + "_path_" + t);
                    if (this.options.isEvalSupported && s.value) {
                      var o,
                        l = "";
                      for (n = 0, i = a.length; n < i; n++) r = a[n], o = void 0 !== r.args ? r.args.join(",") : "", l += "c." + r.cmd + "(" + o + ");\n";
                      this.compiledGlyphs[t] = new Function("c", "size", l);
                    } else this.compiledGlyphs[t] = function (e, t) {
                      for (n = 0, i = a.length; n < i; n++) r = a[n], "scale" === r.cmd && (r.args = [t, -t]), e[r.cmd].apply(e, r.args);
                    };
                  }
                  return this.compiledGlyphs[t];
                }
              }, e;
            }();
          t.FontFaceObject = l, t.FontLoader = n;
        }, function (e, t, r) {
          "use strict";

          function n(e) {
            var t = o[e[0]];
            return t || (0, i.error)("Unknown IR type: " + e[0]), t.fromIR(e);
          }
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.TilingPattern = t.getShadingPatternFromIR = void 0;
          var i = r(0),
            a = r(25),
            o = {};
          o.RadialAxial = {
            fromIR: function fromIR(e) {
              var t = e[1],
                r = e[2],
                n = e[3],
                i = e[4],
                a = e[5],
                o = e[6];
              return {
                type: "Pattern",
                getPattern: function getPattern(e) {
                  var s;
                  "axial" === t ? s = e.createLinearGradient(n[0], n[1], i[0], i[1]) : "radial" === t && (s = e.createRadialGradient(n[0], n[1], a, i[0], i[1], o));
                  for (var l = 0, c = r.length; l < c; ++l) {
                    var u = r[l];
                    s.addColorStop(u[0], u[1]);
                  }
                  return s;
                }
              };
            }
          };
          var s = function () {
            function e(e, t, r, n, i, a, o, s) {
              var l,
                c = t.coords,
                u = t.colors,
                h = e.data,
                f = 4 * e.width;
              c[r + 1] > c[n + 1] && (l = r, r = n, n = l, l = a, a = o, o = l), c[n + 1] > c[i + 1] && (l = n, n = i, i = l, l = o, o = s, s = l), c[r + 1] > c[n + 1] && (l = r, r = n, n = l, l = a, a = o, o = l);
              var d = (c[r] + t.offsetX) * t.scaleX,
                p = (c[r + 1] + t.offsetY) * t.scaleY,
                m = (c[n] + t.offsetX) * t.scaleX,
                g = (c[n + 1] + t.offsetY) * t.scaleY,
                v = (c[i] + t.offsetX) * t.scaleX,
                b = (c[i + 1] + t.offsetY) * t.scaleY;
              if (!(p >= b)) for (var y, w, x, _, S, C, E, A, T, k = u[a], R = u[a + 1], I = u[a + 2], M = u[o], O = u[o + 1], P = u[o + 2], B = u[s], D = u[s + 1], L = u[s + 2], F = Math.round(p), N = Math.round(b), U = F; U <= N; U++) {
                U < g ? (T = U < p ? 0 : p === g ? 1 : (p - U) / (p - g), y = d - (d - m) * T, w = k - (k - M) * T, x = R - (R - O) * T, _ = I - (I - P) * T) : (T = U > b ? 1 : g === b ? 0 : (g - U) / (g - b), y = m - (m - v) * T, w = M - (M - B) * T, x = O - (O - D) * T, _ = P - (P - L) * T), T = U < p ? 0 : U > b ? 1 : (p - U) / (p - b), S = d - (d - v) * T, C = k - (k - B) * T, E = R - (R - D) * T, A = I - (I - L) * T;
                for (var j = Math.round(Math.min(y, S)), z = Math.round(Math.max(y, S)), H = f * U + 4 * j, G = j; G <= z; G++) T = (y - G) / (y - S), T = T < 0 ? 0 : T > 1 ? 1 : T, h[H++] = w - (w - C) * T | 0, h[H++] = x - (x - E) * T | 0, h[H++] = _ - (_ - A) * T | 0, h[H++] = 255;
              }
            }
            function t(t, r, n) {
              var a,
                o,
                s = r.coords,
                l = r.colors;
              switch (r.type) {
                case "lattice":
                  var c = r.verticesPerRow,
                    u = Math.floor(s.length / c) - 1,
                    h = c - 1;
                  for (a = 0; a < u; a++) for (var f = a * c, d = 0; d < h; d++, f++) e(t, n, s[f], s[f + 1], s[f + c], l[f], l[f + 1], l[f + c]), e(t, n, s[f + c + 1], s[f + 1], s[f + c], l[f + c + 1], l[f + 1], l[f + c]);
                  break;
                case "triangles":
                  for (a = 0, o = s.length; a < o; a += 3) e(t, n, s[a], s[a + 1], s[a + 2], l[a], l[a + 1], l[a + 2]);
                  break;
                default:
                  (0, i.error)("illigal figure");
              }
            }
            function r(e, r, n, i, o, s, l) {
              var c,
                u,
                h,
                f,
                d = Math.floor(e[0]),
                p = Math.floor(e[1]),
                m = Math.ceil(e[2]) - d,
                g = Math.ceil(e[3]) - p,
                v = Math.min(Math.ceil(Math.abs(m * r[0] * 1.1)), 3e3),
                b = Math.min(Math.ceil(Math.abs(g * r[1] * 1.1)), 3e3),
                y = m / v,
                w = g / b,
                x = {
                  coords: n,
                  colors: i,
                  offsetX: -d,
                  offsetY: -p,
                  scaleX: 1 / y,
                  scaleY: 1 / w
                },
                _ = v + 4,
                S = b + 4;
              if (a.WebGLUtils.isEnabled) c = a.WebGLUtils.drawFigures(v, b, s, o, x), u = l.getCanvas("mesh", _, S, !1), u.context.drawImage(c, 2, 2), c = u.canvas;else {
                u = l.getCanvas("mesh", _, S, !1);
                var C = u.context,
                  E = C.createImageData(v, b);
                if (s) {
                  var A = E.data;
                  for (h = 0, f = A.length; h < f; h += 4) A[h] = s[0], A[h + 1] = s[1], A[h + 2] = s[2], A[h + 3] = 255;
                }
                for (h = 0; h < o.length; h++) t(E, o[h], x);
                C.putImageData(E, 2, 2), c = u.canvas;
              }
              return {
                canvas: c,
                offsetX: d - 2 * y,
                offsetY: p - 2 * w,
                scaleX: y,
                scaleY: w
              };
            }
            return r;
          }();
          o.Mesh = {
            fromIR: function fromIR(e) {
              var t = e[2],
                r = e[3],
                n = e[4],
                a = e[5],
                o = e[6],
                l = e[8];
              return {
                type: "Pattern",
                getPattern: function getPattern(e, c, u) {
                  var h;
                  if (u) h = i.Util.singularValueDecompose2dScale(e.mozCurrentTransform);else if (h = i.Util.singularValueDecompose2dScale(c.baseTransform), o) {
                    var f = i.Util.singularValueDecompose2dScale(o);
                    h = [h[0] * f[0], h[1] * f[1]];
                  }
                  var d = s(a, h, t, r, n, u ? null : l, c.cachedCanvases);
                  return u || (e.setTransform.apply(e, c.baseTransform), o && e.transform.apply(e, o)), e.translate(d.offsetX, d.offsetY), e.scale(d.scaleX, d.scaleY), e.createPattern(d.canvas, "no-repeat");
                }
              };
            }
          }, o.Dummy = {
            fromIR: function fromIR() {
              return {
                type: "Pattern",
                getPattern: function getPattern() {
                  return "hotpink";
                }
              };
            }
          };
          var l = function () {
            function e(e, t, r, n, a) {
              this.operatorList = e[2], this.matrix = e[3] || [1, 0, 0, 1, 0, 0], this.bbox = i.Util.normalizeRect(e[4]), this.xstep = e[5], this.ystep = e[6], this.paintType = e[7], this.tilingType = e[8], this.color = t, this.canvasGraphicsFactory = n, this.baseTransform = a, this.type = "Pattern", this.ctx = r;
            }
            var t = {
              COLORED: 1,
              UNCOLORED: 2
            };
            return e.prototype = {
              createPatternCanvas: function createPatternCanvas(e) {
                var t = this.operatorList,
                  r = this.bbox,
                  n = this.xstep,
                  a = this.ystep,
                  o = this.paintType,
                  s = this.tilingType,
                  l = this.color,
                  c = this.canvasGraphicsFactory;
                (0, i.info)("TilingType: " + s);
                var u = r[0],
                  h = r[1],
                  f = r[2],
                  d = r[3],
                  p = [u, h],
                  m = [u + n, h + a],
                  g = m[0] - p[0],
                  v = m[1] - p[1],
                  b = i.Util.singularValueDecompose2dScale(this.matrix),
                  y = i.Util.singularValueDecompose2dScale(this.baseTransform),
                  w = [b[0] * y[0], b[1] * y[1]];
                g = Math.min(Math.ceil(Math.abs(g * w[0])), 3e3), v = Math.min(Math.ceil(Math.abs(v * w[1])), 3e3);
                var x = e.cachedCanvases.getCanvas("pattern", g, v, !0),
                  _ = x.context,
                  S = c.createCanvasGraphics(_);
                S.groupLevel = e.groupLevel, this.setFillAndStrokeStyleToContext(_, o, l), this.setScale(g, v, n, a), this.transformToScale(S);
                var C = [1, 0, 0, 1, -p[0], -p[1]];
                return S.transform.apply(S, C), this.clipBbox(S, r, u, h, f, d), S.executeOperatorList(t), x.canvas;
              },
              setScale: function setScale(e, t, r, n) {
                this.scale = [e / r, t / n];
              },
              transformToScale: function transformToScale(e) {
                var t = this.scale,
                  r = [t[0], 0, 0, t[1], 0, 0];
                e.transform.apply(e, r);
              },
              scaleToContext: function scaleToContext() {
                var e = this.scale;
                this.ctx.scale(1 / e[0], 1 / e[1]);
              },
              clipBbox: function clipBbox(e, t, r, n, a, o) {
                if ((0, i.isArray)(t) && 4 === t.length) {
                  var s = a - r,
                    l = o - n;
                  e.ctx.rect(r, n, s, l), e.clip(), e.endPath();
                }
              },
              setFillAndStrokeStyleToContext: function setFillAndStrokeStyleToContext(e, r, n) {
                switch (r) {
                  case t.COLORED:
                    var a = this.ctx;
                    e.fillStyle = a.fillStyle, e.strokeStyle = a.strokeStyle;
                    break;
                  case t.UNCOLORED:
                    var o = i.Util.makeCssRgb(n[0], n[1], n[2]);
                    e.fillStyle = o, e.strokeStyle = o;
                    break;
                  default:
                    (0, i.error)("Unsupported paint type: " + r);
                }
              },
              getPattern: function getPattern(e, t) {
                var r = this.createPatternCanvas(t);
                return e = this.ctx, e.setTransform.apply(e, this.baseTransform), e.transform.apply(e, this.matrix), this.scaleToContext(), e.createPattern(r, "repeat");
              }
            }, e;
          }();
          t.getShadingPatternFromIR = n, t.TilingPattern = l;
        }, function (e, t, r) {
          "use strict";

          var n = r(0),
            i = r(26),
            a = r(10),
            o = r(12),
            s = r(9),
            l = r(3),
            c = r(11);
          t.PDFJS = i.PDFJS, t.build = a.build, t.version = a.version, t.getDocument = a.getDocument, t.LoopbackPort = a.LoopbackPort, t.PDFDataRangeTransport = a.PDFDataRangeTransport, t.PDFWorker = a.PDFWorker, t.renderTextLayer = o.renderTextLayer, t.AnnotationLayer = s.AnnotationLayer, t.CustomStyle = l.CustomStyle, t.createPromiseCapability = n.createPromiseCapability, t.PasswordResponses = n.PasswordResponses, t.InvalidPDFException = n.InvalidPDFException, t.MissingPDFException = n.MissingPDFException, t.SVGGraphics = c.SVGGraphics, t.NativeImageDecoding = n.NativeImageDecoding, t.UnexpectedResponseException = n.UnexpectedResponseException, t.OPS = n.OPS, t.UNSUPPORTED_FEATURES = n.UNSUPPORTED_FEATURES, t.isValidUrl = l.isValidUrl, t.createValidAbsoluteUrl = n.createValidAbsoluteUrl, t.createObjectURL = n.createObjectURL, t.removeNullCharacters = n.removeNullCharacters, t.shadow = n.shadow, t.createBlob = n.createBlob, t.RenderingCancelledException = l.RenderingCancelledException, t.getFilenameFromUrl = l.getFilenameFromUrl, t.addLinkAttributes = l.addLinkAttributes;
        }, function (e, t, r) {
          "use strict";

          (function (e) {
            var t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            };
            if ("undefined" == typeof PDFJS || !PDFJS.compatibilityChecked) {
              var r = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : void 0,
                n = "undefined" != typeof navigator && navigator.userAgent || "",
                i = /Android/.test(n),
                a = /Android\s[0-2][^\d]/.test(n),
                o = /Android\s[0-4][^\d]/.test(n),
                s = n.indexOf("Chrom") >= 0,
                l = /Chrome\/(39|40)\./.test(n),
                c = n.indexOf("CriOS") >= 0,
                u = n.indexOf("Trident") >= 0,
                h = /\b(iPad|iPhone|iPod)(?=;)/.test(n),
                f = n.indexOf("Opera") >= 0,
                d = /Safari\//.test(n) && !/(Chrome\/|Android\s)/.test(n),
                p = "object" === ("undefined" == typeof window ? "undefined" : t(window)) && "object" === ("undefined" == typeof document ? "undefined" : t(document));
              "undefined" == typeof PDFJS && (r.PDFJS = {}), PDFJS.compatibilityChecked = !0, function () {
                function e(e, t) {
                  return new s(this.slice(e, t));
                }
                function n(e, t) {
                  arguments.length < 2 && (t = 0);
                  for (var r = 0, n = e.length; r < n; ++r, ++t) this[t] = 255 & e[r];
                }
                function i(e, t) {
                  this.buffer = e, this.byteLength = e.length, this.length = t, o(this.length);
                }
                function a(e) {
                  return {
                    get: function get() {
                      var t = this.buffer,
                        r = e << 2;
                      return (t[r] | t[r + 1] << 8 | t[r + 2] << 16 | t[r + 3] << 24) >>> 0;
                    },
                    set: function set(t) {
                      var r = this.buffer,
                        n = e << 2;
                      r[n] = 255 & t, r[n + 1] = t >> 8 & 255, r[n + 2] = t >> 16 & 255, r[n + 3] = t >>> 24 & 255;
                    }
                  };
                }
                function o(e) {
                  for (; l < e;) Object.defineProperty(i.prototype, l, a(l)), l++;
                }
                function s(r) {
                  var i, a, o;
                  if ("number" == typeof r) for (i = [], a = 0; a < r; ++a) i[a] = 0;else if ("slice" in r) i = r.slice(0);else for (i = [], a = 0, o = r.length; a < o; ++a) i[a] = r[a];
                  return i.subarray = e, i.buffer = i, i.byteLength = i.length, i.set = n, "object" === (void 0 === r ? "undefined" : t(r)) && r.buffer && (i.buffer = r.buffer), i;
                }
                if ("undefined" != typeof Uint8Array) return void 0 === Uint8Array.prototype.subarray && (Uint8Array.prototype.subarray = function (e, t) {
                  return new Uint8Array(this.slice(e, t));
                }, Float32Array.prototype.subarray = function (e, t) {
                  return new Float32Array(this.slice(e, t));
                }), void ("undefined" == typeof Float64Array && (r.Float64Array = Float32Array));
                i.prototype = Object.create(null);
                var l = 0;
                r.Uint8Array = s, r.Int8Array = s, r.Int32Array = s, r.Uint16Array = s, r.Float32Array = s, r.Float64Array = s, r.Uint32Array = function () {
                  if (3 === arguments.length) {
                    if (0 !== arguments[1]) throw new Error("offset !== 0 is not supported");
                    return new i(arguments[0], arguments[2]);
                  }
                  return s.apply(this, arguments);
                };
              }(), function () {
                if (p && window.CanvasPixelArray) {
                  var e = window.CanvasPixelArray.prototype;
                  "buffer" in e || (Object.defineProperty(e, "buffer", {
                    get: function get() {
                      return this;
                    },
                    enumerable: !1,
                    configurable: !0
                  }), Object.defineProperty(e, "byteLength", {
                    get: function get() {
                      return this.length;
                    },
                    enumerable: !1,
                    configurable: !0
                  }));
                }
              }(), function () {
                r.URL || (r.URL = r.webkitURL);
              }(), function () {
                if (void 0 !== Object.defineProperty) {
                  var e = !0;
                  try {
                    p && Object.defineProperty(new Image(), "id", {
                      value: "test"
                    });
                    var t = function t() {};
                    t.prototype = {
                      get id() {}
                    }, Object.defineProperty(new t(), "id", {
                      value: "",
                      configurable: !0,
                      enumerable: !0,
                      writable: !1
                    });
                  } catch (t) {
                    e = !1;
                  }
                  if (e) return;
                }
                Object.defineProperty = function (e, t, r) {
                  delete e[t], "get" in r && e.__defineGetter__(t, r.get), "set" in r && e.__defineSetter__(t, r.set), "value" in r && (e.__defineSetter__(t, function (e) {
                    return this.__defineGetter__(t, function () {
                      return e;
                    }), e;
                  }), e[t] = r.value);
                };
              }(), function () {
                if ("undefined" != typeof XMLHttpRequest) {
                  var e = XMLHttpRequest.prototype,
                    t = new XMLHttpRequest();
                  if ("overrideMimeType" in t || Object.defineProperty(e, "overrideMimeType", {
                    value: function value(e) {}
                  }), !("responseType" in t)) {
                    if (Object.defineProperty(e, "responseType", {
                      get: function get() {
                        return this._responseType || "text";
                      },
                      set: function set(e) {
                        "text" !== e && "arraybuffer" !== e || (this._responseType = e, "arraybuffer" === e && "function" == typeof this.overrideMimeType && this.overrideMimeType("text/plain; charset=x-user-defined"));
                      }
                    }), "undefined" != typeof VBArray) return void Object.defineProperty(e, "response", {
                      get: function get() {
                        return "arraybuffer" === this.responseType ? new Uint8Array(new VBArray(this.responseBody).toArray()) : this.responseText;
                      }
                    });
                    Object.defineProperty(e, "response", {
                      get: function get() {
                        if ("arraybuffer" !== this.responseType) return this.responseText;
                        var e,
                          t = this.responseText,
                          r = t.length,
                          n = new Uint8Array(r);
                        for (e = 0; e < r; ++e) n[e] = 255 & t.charCodeAt(e);
                        return n.buffer;
                      }
                    });
                  }
                }
              }(), function () {
                if (!("btoa" in r)) {
                  var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                  r.btoa = function (t) {
                    var r,
                      n,
                      i = "";
                    for (r = 0, n = t.length; r < n; r += 3) {
                      var a = 255 & t.charCodeAt(r),
                        o = 255 & t.charCodeAt(r + 1),
                        s = 255 & t.charCodeAt(r + 2),
                        l = a >> 2,
                        c = (3 & a) << 4 | o >> 4,
                        u = r + 1 < n ? (15 & o) << 2 | s >> 6 : 64,
                        h = r + 2 < n ? 63 & s : 64;
                      i += e.charAt(l) + e.charAt(c) + e.charAt(u) + e.charAt(h);
                    }
                    return i;
                  };
                }
              }(), function () {
                if (!("atob" in r)) {
                  r.atob = function (e) {
                    if (e = e.replace(/=+$/, ""), e.length % 4 == 1) throw new Error("bad atob input");
                    for (var t, r, n = 0, i = 0, a = ""; r = e.charAt(i++); ~r && (t = n % 4 ? 64 * t + r : r, n++ % 4) ? a += String.fromCharCode(255 & t >> (-2 * n & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
                    return a;
                  };
                }
              }(), function () {
                void 0 === Function.prototype.bind && (Function.prototype.bind = function (e) {
                  var t = this,
                    r = Array.prototype.slice.call(arguments, 1);
                  return function () {
                    var n = r.concat(Array.prototype.slice.call(arguments));
                    return t.apply(e, n);
                  };
                });
              }(), function () {
                if (p) {
                  "dataset" in document.createElement("div") || Object.defineProperty(HTMLElement.prototype, "dataset", {
                    get: function get() {
                      if (this._dataset) return this._dataset;
                      for (var e = {}, t = 0, r = this.attributes.length; t < r; t++) {
                        var n = this.attributes[t];
                        if ("data-" === n.name.substring(0, 5)) {
                          e[n.name.substring(5).replace(/\-([a-z])/g, function (e, t) {
                            return t.toUpperCase();
                          })] = n.value;
                        }
                      }
                      return Object.defineProperty(this, "_dataset", {
                        value: e,
                        writable: !1,
                        enumerable: !1
                      }), e;
                    },
                    enumerable: !0
                  });
                }
              }(), function () {
                function e(e, t, r, n) {
                  var i = e.className || "",
                    a = i.split(/\s+/g);
                  "" === a[0] && a.shift();
                  var o = a.indexOf(t);
                  return o < 0 && r && a.push(t), o >= 0 && n && a.splice(o, 1), e.className = a.join(" "), o >= 0;
                }
                if (p) {
                  if (!("classList" in document.createElement("div"))) {
                    var t = {
                      add: function add(t) {
                        e(this.element, t, !0, !1);
                      },
                      contains: function contains(t) {
                        return e(this.element, t, !1, !1);
                      },
                      remove: function remove(t) {
                        e(this.element, t, !1, !0);
                      },
                      toggle: function toggle(t) {
                        e(this.element, t, !0, !0);
                      }
                    };
                    Object.defineProperty(HTMLElement.prototype, "classList", {
                      get: function get() {
                        if (this._classList) return this._classList;
                        var e = Object.create(t, {
                          element: {
                            value: this,
                            writable: !1,
                            enumerable: !0
                          }
                        });
                        return Object.defineProperty(this, "_classList", {
                          value: e,
                          writable: !1,
                          enumerable: !1
                        }), e;
                      },
                      enumerable: !0
                    });
                  }
                }
              }(), function () {
                if (!("undefined" == typeof importScripts || "console" in r)) {
                  var e = {},
                    t = {
                      log: function log() {
                        var e = Array.prototype.slice.call(arguments);
                        r.postMessage({
                          targetName: "main",
                          action: "console_log",
                          data: e
                        });
                      },
                      error: function error() {
                        var e = Array.prototype.slice.call(arguments);
                        r.postMessage({
                          targetName: "main",
                          action: "console_error",
                          data: e
                        });
                      },
                      time: function time(t) {
                        e[t] = Date.now();
                      },
                      timeEnd: function timeEnd(t) {
                        var r = e[t];
                        if (!r) throw new Error("Unknown timer name " + t);
                        this.log("Timer:", t, Date.now() - r);
                      }
                    };
                  r.console = t;
                }
              }(), function () {
                if (p) "console" in window ? "bind" in console.log || (console.log = function (e) {
                  return function (t) {
                    return e(t);
                  };
                }(console.log), console.error = function (e) {
                  return function (t) {
                    return e(t);
                  };
                }(console.error), console.warn = function (e) {
                  return function (t) {
                    return e(t);
                  };
                }(console.warn)) : window.console = {
                  log: function log() {},
                  error: function error() {},
                  warn: function warn() {}
                };
              }(), function () {
                function e(e) {
                  t(e.target) && e.stopPropagation();
                }
                function t(e) {
                  return e.disabled || e.parentNode && t(e.parentNode);
                }
                f && document.addEventListener("click", e, !0);
              }(), function () {
                (u || c) && (PDFJS.disableCreateObjectURL = !0);
              }(), function () {
                "undefined" != typeof navigator && ("language" in navigator || (PDFJS.locale = navigator.userLanguage || "en-US"));
              }(), function () {
                (d || a || l || h) && (PDFJS.disableRange = !0, PDFJS.disableStream = !0);
              }(), function () {
                p && (history.pushState && !a || (PDFJS.disableHistory = !0));
              }(), function () {
                if (p) if (window.CanvasPixelArray) "function" != typeof window.CanvasPixelArray.prototype.set && (window.CanvasPixelArray.prototype.set = function (e) {
                  for (var t = 0, r = this.length; t < r; t++) this[t] = e[t];
                });else {
                  var e,
                    t = !1;
                  if (s ? (e = n.match(/Chrom(e|ium)\/([0-9]+)\./), t = e && parseInt(e[2]) < 21) : i ? t = o : d && (e = n.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//), t = e && parseInt(e[1]) < 6), t) {
                    var r = window.CanvasRenderingContext2D.prototype,
                      a = r.createImageData;
                    r.createImageData = function (e, t) {
                      var r = a.call(this, e, t);
                      return r.data.set = function (e) {
                        for (var t = 0, r = this.length; t < r; t++) this[t] = e[t];
                      }, r;
                    }, r = null;
                  }
                }
              }(), function () {
                function e() {
                  window.requestAnimationFrame = function (e) {
                    return window.setTimeout(e, 20);
                  }, window.cancelAnimationFrame = function (e) {
                    window.clearTimeout(e);
                  };
                }
                if (p) h ? e() : "requestAnimationFrame" in window || (window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame, window.requestAnimationFrame || e());
              }(), function () {
                (h || i) && (PDFJS.maxCanvasPixels = 5242880);
              }(), function () {
                p && u && window.parent !== window && (PDFJS.disableFullscreen = !0);
              }(), function () {
                p && ("currentScript" in document || Object.defineProperty(document, "currentScript", {
                  get: function get() {
                    var e = document.getElementsByTagName("script");
                    return e[e.length - 1];
                  },
                  enumerable: !0,
                  configurable: !0
                }));
              }(), function () {
                if (p) {
                  var e = document.createElement("input");
                  try {
                    e.type = "number";
                  } catch (n) {
                    var t = e.constructor.prototype,
                      r = Object.getOwnPropertyDescriptor(t, "type");
                    Object.defineProperty(t, "type", {
                      get: function get() {
                        return r.get.call(this);
                      },
                      set: function set(e) {
                        r.set.call(this, "number" === e ? "text" : e);
                      },
                      enumerable: !0,
                      configurable: !0
                    });
                  }
                }
              }(), function () {
                if (p && document.attachEvent) {
                  var e = document.constructor.prototype,
                    t = Object.getOwnPropertyDescriptor(e, "readyState");
                  Object.defineProperty(e, "readyState", {
                    get: function get() {
                      var e = t.get.call(this);
                      return "interactive" === e ? "loading" : e;
                    },
                    set: function set(e) {
                      t.set.call(this, e);
                    },
                    enumerable: !0,
                    configurable: !0
                  });
                }
              }(), function () {
                p && void 0 === Element.prototype.remove && (Element.prototype.remove = function () {
                  this.parentNode && this.parentNode.removeChild(this);
                });
              }(), function () {
                if (r.Promise) return "function" != typeof r.Promise.all && (r.Promise.all = function (e) {
                  var t,
                    n,
                    i = 0,
                    a = [],
                    o = new r.Promise(function (e, r) {
                      t = e, n = r;
                    });
                  return e.forEach(function (e, r) {
                    i++, e.then(function (e) {
                      a[r] = e, 0 === --i && t(a);
                    }, n);
                  }), 0 === i && t(a), o;
                }), "function" != typeof r.Promise.resolve && (r.Promise.resolve = function (e) {
                  return new r.Promise(function (t) {
                    t(e);
                  });
                }), "function" != typeof r.Promise.reject && (r.Promise.reject = function (e) {
                  return new r.Promise(function (t, r) {
                    r(e);
                  });
                }), void ("function" != typeof r.Promise.prototype.catch && (r.Promise.prototype.catch = function (e) {
                  return r.Promise.prototype.then(void 0, e);
                }));
                var e = 2,
                  t = {
                    handlers: [],
                    running: !1,
                    unhandledRejections: [],
                    pendingRejectionCheck: !1,
                    scheduleHandlers: function scheduleHandlers(e) {
                      0 !== e._status && (this.handlers = this.handlers.concat(e._handlers), e._handlers = [], this.running || (this.running = !0, setTimeout(this.runHandlers.bind(this), 0)));
                    },
                    runHandlers: function runHandlers() {
                      for (var t = Date.now() + 1; this.handlers.length > 0;) {
                        var r = this.handlers.shift(),
                          n = r.thisPromise._status,
                          i = r.thisPromise._value;
                        try {
                          1 === n ? "function" == typeof r.onResolve && (i = r.onResolve(i)) : "function" == typeof r.onReject && (i = r.onReject(i), n = 1, r.thisPromise._unhandledRejection && this.removeUnhandeledRejection(r.thisPromise));
                        } catch (t) {
                          n = e, i = t;
                        }
                        if (r.nextPromise._updateStatus(n, i), Date.now() >= t) break;
                      }
                      if (this.handlers.length > 0) return void setTimeout(this.runHandlers.bind(this), 0);
                      this.running = !1;
                    },
                    addUnhandledRejection: function addUnhandledRejection(e) {
                      this.unhandledRejections.push({
                        promise: e,
                        time: Date.now()
                      }), this.scheduleRejectionCheck();
                    },
                    removeUnhandeledRejection: function removeUnhandeledRejection(e) {
                      e._unhandledRejection = !1;
                      for (var t = 0; t < this.unhandledRejections.length; t++) this.unhandledRejections[t].promise === e && (this.unhandledRejections.splice(t), t--);
                    },
                    scheduleRejectionCheck: function scheduleRejectionCheck() {
                      var e = this;
                      this.pendingRejectionCheck || (this.pendingRejectionCheck = !0, setTimeout(function () {
                        e.pendingRejectionCheck = !1;
                        for (var t = Date.now(), r = 0; r < e.unhandledRejections.length; r++) if (t - e.unhandledRejections[r].time > 500) {
                          var n = e.unhandledRejections[r].promise._value,
                            i = "Unhandled rejection: " + n;
                          n.stack && (i += "\n" + n.stack);
                          try {
                            throw new Error(i);
                          } catch (e) {
                            console.warn(i);
                          }
                          e.unhandledRejections.splice(r), r--;
                        }
                        e.unhandledRejections.length && e.scheduleRejectionCheck();
                      }, 500));
                    }
                  },
                  n = function n(e) {
                    this._status = 0, this._handlers = [];
                    try {
                      e.call(this, this._resolve.bind(this), this._reject.bind(this));
                    } catch (e) {
                      this._reject(e);
                    }
                  };
                n.all = function (t) {
                  function r(t) {
                    o._status !== e && (l = [], a(t));
                  }
                  var i,
                    a,
                    o = new n(function (e, t) {
                      i = e, a = t;
                    }),
                    s = t.length,
                    l = [];
                  if (0 === s) return i(l), o;
                  for (var c = 0, u = t.length; c < u; ++c) {
                    var h = t[c],
                      f = function (t) {
                        return function (r) {
                          o._status !== e && (l[t] = r, 0 === --s && i(l));
                        };
                      }(c);
                    n.isPromise(h) ? h.then(f, r) : f(h);
                  }
                  return o;
                }, n.isPromise = function (e) {
                  return e && "function" == typeof e.then;
                }, n.resolve = function (e) {
                  return new n(function (t) {
                    t(e);
                  });
                }, n.reject = function (e) {
                  return new n(function (t, r) {
                    r(e);
                  });
                }, n.prototype = {
                  _status: null,
                  _value: null,
                  _handlers: null,
                  _unhandledRejection: null,
                  _updateStatus: function _updateStatus(r, i) {
                    if (1 !== this._status && this._status !== e) {
                      if (1 === r && n.isPromise(i)) return void i.then(this._updateStatus.bind(this, 1), this._updateStatus.bind(this, e));
                      this._status = r, this._value = i, r === e && 0 === this._handlers.length && (this._unhandledRejection = !0, t.addUnhandledRejection(this)), t.scheduleHandlers(this);
                    }
                  },
                  _resolve: function _resolve(e) {
                    this._updateStatus(1, e);
                  },
                  _reject: function _reject(t) {
                    this._updateStatus(e, t);
                  },
                  then: function then(e, r) {
                    var i = new n(function (e, t) {
                      this.resolve = e, this.reject = t;
                    });
                    return this._handlers.push({
                      thisPromise: this,
                      onResolve: e,
                      onReject: r,
                      nextPromise: i
                    }), t.scheduleHandlers(this), i;
                  },
                  catch: function _catch(e) {
                    return this.then(void 0, e);
                  }
                }, r.Promise = n;
              }(), function () {
                function e() {
                  this.id = "$weakmap" + t++;
                }
                if (!r.WeakMap) {
                  var t = 0;
                  e.prototype = {
                    has: function has(e) {
                      return !!Object.getOwnPropertyDescriptor(e, this.id);
                    },
                    get: function get(e, t) {
                      return this.has(e) ? e[this.id] : t;
                    },
                    set: function set(e, t) {
                      Object.defineProperty(e, this.id, {
                        value: t,
                        enumerable: !1,
                        configurable: !0
                      });
                    },
                    delete: function _delete(e) {
                      delete e[this.id];
                    }
                  }, r.WeakMap = e;
                }
              }(), function () {
                function e(e) {
                  return void 0 !== f[e];
                }
                function n() {
                  l.call(this), this._isInvalid = !0;
                }
                function i(e) {
                  return "" === e && n.call(this), e.toLowerCase();
                }
                function a(e) {
                  var t = e.charCodeAt(0);
                  return t > 32 && t < 127 && -1 === [34, 35, 60, 62, 63, 96].indexOf(t) ? e : encodeURIComponent(e);
                }
                function o(e) {
                  var t = e.charCodeAt(0);
                  return t > 32 && t < 127 && -1 === [34, 35, 60, 62, 96].indexOf(t) ? e : encodeURIComponent(e);
                }
                function s(t, r, s) {
                  function l(e) {
                    y.push(e);
                  }
                  var c = r || "scheme start",
                    u = 0,
                    h = "",
                    v = !1,
                    b = !1,
                    y = [];
                  e: for (; (t[u - 1] !== p || 0 === u) && !this._isInvalid;) {
                    var w = t[u];
                    switch (c) {
                      case "scheme start":
                        if (!w || !m.test(w)) {
                          if (r) {
                            l("Invalid scheme.");
                            break e;
                          }
                          h = "", c = "no scheme";
                          continue;
                        }
                        h += w.toLowerCase(), c = "scheme";
                        break;
                      case "scheme":
                        if (w && g.test(w)) h += w.toLowerCase();else {
                          if (":" !== w) {
                            if (r) {
                              if (w === p) break e;
                              l("Code point not allowed in scheme: " + w);
                              break e;
                            }
                            h = "", u = 0, c = "no scheme";
                            continue;
                          }
                          if (this._scheme = h, h = "", r) break e;
                          e(this._scheme) && (this._isRelative = !0), c = "file" === this._scheme ? "relative" : this._isRelative && s && s._scheme === this._scheme ? "relative or authority" : this._isRelative ? "authority first slash" : "scheme data";
                        }
                        break;
                      case "scheme data":
                        "?" === w ? (this._query = "?", c = "query") : "#" === w ? (this._fragment = "#", c = "fragment") : w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._schemeData += a(w));
                        break;
                      case "no scheme":
                        if (s && e(s._scheme)) {
                          c = "relative";
                          continue;
                        }
                        l("Missing scheme."), n.call(this);
                        break;
                      case "relative or authority":
                        if ("/" !== w || "/" !== t[u + 1]) {
                          l("Expected /, got: " + w), c = "relative";
                          continue;
                        }
                        c = "authority ignore slashes";
                        break;
                      case "relative":
                        if (this._isRelative = !0, "file" !== this._scheme && (this._scheme = s._scheme), w === p) {
                          this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = s._query, this._username = s._username, this._password = s._password;
                          break e;
                        }
                        if ("/" === w || "\\" === w) "\\" === w && l("\\ is an invalid code point."), c = "relative slash";else if ("?" === w) this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = "?", this._username = s._username, this._password = s._password, c = "query";else {
                          if ("#" !== w) {
                            var x = t[u + 1],
                              _ = t[u + 2];
                            ("file" !== this._scheme || !m.test(w) || ":" !== x && "|" !== x || _ !== p && "/" !== _ && "\\" !== _ && "?" !== _ && "#" !== _) && (this._host = s._host, this._port = s._port, this._username = s._username, this._password = s._password, this._path = s._path.slice(), this._path.pop()), c = "relative path";
                            continue;
                          }
                          this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = s._query, this._fragment = "#", this._username = s._username, this._password = s._password, c = "fragment";
                        }
                        break;
                      case "relative slash":
                        if ("/" !== w && "\\" !== w) {
                          "file" !== this._scheme && (this._host = s._host, this._port = s._port, this._username = s._username, this._password = s._password), c = "relative path";
                          continue;
                        }
                        "\\" === w && l("\\ is an invalid code point."), c = "file" === this._scheme ? "file host" : "authority ignore slashes";
                        break;
                      case "authority first slash":
                        if ("/" !== w) {
                          l("Expected '/', got: " + w), c = "authority ignore slashes";
                          continue;
                        }
                        c = "authority second slash";
                        break;
                      case "authority second slash":
                        if (c = "authority ignore slashes", "/" !== w) {
                          l("Expected '/', got: " + w);
                          continue;
                        }
                        break;
                      case "authority ignore slashes":
                        if ("/" !== w && "\\" !== w) {
                          c = "authority";
                          continue;
                        }
                        l("Expected authority, got: " + w);
                        break;
                      case "authority":
                        if ("@" === w) {
                          v && (l("@ already seen."), h += "%40"), v = !0;
                          for (var S = 0; S < h.length; S++) {
                            var C = h[S];
                            if ("\t" !== C && "\n" !== C && "\r" !== C) {
                              if (":" !== C || null !== this._password) {
                                var E = a(C);
                                null !== this._password ? this._password += E : this._username += E;
                              } else this._password = "";
                            } else l("Invalid whitespace in authority.");
                          }
                          h = "";
                        } else {
                          if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                            u -= h.length, h = "", c = "host";
                            continue;
                          }
                          h += w;
                        }
                        break;
                      case "file host":
                        if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                          2 !== h.length || !m.test(h[0]) || ":" !== h[1] && "|" !== h[1] ? 0 === h.length ? c = "relative path start" : (this._host = i.call(this, h), h = "", c = "relative path start") : c = "relative path";
                          continue;
                        }
                        "\t" === w || "\n" === w || "\r" === w ? l("Invalid whitespace in file host.") : h += w;
                        break;
                      case "host":
                      case "hostname":
                        if (":" !== w || b) {
                          if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                            if (this._host = i.call(this, h), h = "", c = "relative path start", r) break e;
                            continue;
                          }
                          "\t" !== w && "\n" !== w && "\r" !== w ? ("[" === w ? b = !0 : "]" === w && (b = !1), h += w) : l("Invalid code point in host/hostname: " + w);
                        } else if (this._host = i.call(this, h), h = "", c = "port", "hostname" === r) break e;
                        break;
                      case "port":
                        if (/[0-9]/.test(w)) h += w;else {
                          if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w || r) {
                            if ("" !== h) {
                              var A = parseInt(h, 10);
                              A !== f[this._scheme] && (this._port = A + ""), h = "";
                            }
                            if (r) break e;
                            c = "relative path start";
                            continue;
                          }
                          "\t" === w || "\n" === w || "\r" === w ? l("Invalid code point in port: " + w) : n.call(this);
                        }
                        break;
                      case "relative path start":
                        if ("\\" === w && l("'\\' not allowed in path."), c = "relative path", "/" !== w && "\\" !== w) continue;
                        break;
                      case "relative path":
                        if (w !== p && "/" !== w && "\\" !== w && (r || "?" !== w && "#" !== w)) "\t" !== w && "\n" !== w && "\r" !== w && (h += a(w));else {
                          "\\" === w && l("\\ not allowed in relative path.");
                          var T;
                          (T = d[h.toLowerCase()]) && (h = T), ".." === h ? (this._path.pop(), "/" !== w && "\\" !== w && this._path.push("")) : "." === h && "/" !== w && "\\" !== w ? this._path.push("") : "." !== h && ("file" === this._scheme && 0 === this._path.length && 2 === h.length && m.test(h[0]) && "|" === h[1] && (h = h[0] + ":"), this._path.push(h)), h = "", "?" === w ? (this._query = "?", c = "query") : "#" === w && (this._fragment = "#", c = "fragment");
                        }
                        break;
                      case "query":
                        r || "#" !== w ? w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._query += o(w)) : (this._fragment = "#", c = "fragment");
                        break;
                      case "fragment":
                        w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._fragment += w);
                    }
                    u++;
                  }
                }
                function l() {
                  this._scheme = "", this._schemeData = "", this._username = "", this._password = null, this._host = "", this._port = "", this._path = [], this._query = "", this._fragment = "", this._isInvalid = !1, this._isRelative = !1;
                }
                function c(e, t) {
                  void 0 === t || t instanceof c || (t = new c(String(t))), this._url = e, l.call(this);
                  var r = e.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, "");
                  s.call(this, r, null, t);
                }
                var u = !1;
                try {
                  if ("function" == typeof URL && "object" === t(URL.prototype) && "origin" in URL.prototype) {
                    var h = new URL("b", "http://a");
                    h.pathname = "c%20d", u = "http://a/c%20d" === h.href;
                  }
                } catch (e) {}
                if (!u) {
                  var f = Object.create(null);
                  f.ftp = 21, f.file = 0, f.gopher = 70, f.http = 80, f.https = 443, f.ws = 80, f.wss = 443;
                  var d = Object.create(null);
                  d["%2e"] = ".", d[".%2e"] = "..", d["%2e."] = "..", d["%2e%2e"] = "..";
                  var p,
                    m = /[a-zA-Z]/,
                    g = /[a-zA-Z0-9\+\-\.]/;
                  c.prototype = {
                    toString: function toString() {
                      return this.href;
                    },
                    get href() {
                      if (this._isInvalid) return this._url;
                      var e = "";
                      return "" === this._username && null === this._password || (e = this._username + (null !== this._password ? ":" + this._password : "") + "@"), this.protocol + (this._isRelative ? "//" + e + this.host : "") + this.pathname + this._query + this._fragment;
                    },
                    set href(e) {
                      l.call(this), s.call(this, e);
                    },
                    get protocol() {
                      return this._scheme + ":";
                    },
                    set protocol(e) {
                      this._isInvalid || s.call(this, e + ":", "scheme start");
                    },
                    get host() {
                      return this._isInvalid ? "" : this._port ? this._host + ":" + this._port : this._host;
                    },
                    set host(e) {
                      !this._isInvalid && this._isRelative && s.call(this, e, "host");
                    },
                    get hostname() {
                      return this._host;
                    },
                    set hostname(e) {
                      !this._isInvalid && this._isRelative && s.call(this, e, "hostname");
                    },
                    get port() {
                      return this._port;
                    },
                    set port(e) {
                      !this._isInvalid && this._isRelative && s.call(this, e, "port");
                    },
                    get pathname() {
                      return this._isInvalid ? "" : this._isRelative ? "/" + this._path.join("/") : this._schemeData;
                    },
                    set pathname(e) {
                      !this._isInvalid && this._isRelative && (this._path = [], s.call(this, e, "relative path start"));
                    },
                    get search() {
                      return this._isInvalid || !this._query || "?" === this._query ? "" : this._query;
                    },
                    set search(e) {
                      !this._isInvalid && this._isRelative && (this._query = "?", "?" === e[0] && (e = e.slice(1)), s.call(this, e, "query"));
                    },
                    get hash() {
                      return this._isInvalid || !this._fragment || "#" === this._fragment ? "" : this._fragment;
                    },
                    set hash(e) {
                      this._isInvalid || (this._fragment = "#", "#" === e[0] && (e = e.slice(1)), s.call(this, e, "fragment"));
                    },
                    get origin() {
                      var e;
                      if (this._isInvalid || !this._scheme) return "";
                      switch (this._scheme) {
                        case "data":
                        case "file":
                        case "javascript":
                        case "mailto":
                          return "null";
                      }
                      return e = this.host, e ? this._scheme + "://" + e : "";
                    }
                  };
                  var v = r.URL;
                  v && (c.createObjectURL = function (e) {
                    return v.createObjectURL.apply(v, arguments);
                  }, c.revokeObjectURL = function (e) {
                    v.revokeObjectURL(e);
                  }), r.URL = c;
                }
              }();
            }
          }).call(t, r(13));
        }]);
      });
    }).call(t, r(5));
  }, function (e, t, r) {
    !function (t, r) {
      e.exports = r();
    }(0, function () {
      return function (e) {
        function t(n) {
          if (r[n]) return r[n].exports;
          var i = r[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.i = function (e) {
          return e;
        }, t.d = function (e, r, n) {
          t.o(e, r) || Object.defineProperty(e, r, {
            configurable: !1,
            enumerable: !0,
            get: n
          });
        }, t.n = function (e) {
          var r = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(r, "a", r), r;
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 2);
      }([function (e, t, r) {
        "use strict";

        (function (e) {
          var t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          };
          if ("undefined" == typeof PDFJS || !PDFJS.compatibilityChecked) {
            var r = "undefined" != typeof window ? window : void 0 !== e ? e : "undefined" != typeof self ? self : void 0,
              n = "undefined" != typeof navigator && navigator.userAgent || "",
              i = /Android/.test(n),
              a = /Android\s[0-2][^\d]/.test(n),
              o = /Android\s[0-4][^\d]/.test(n),
              s = n.indexOf("Chrom") >= 0,
              l = /Chrome\/(39|40)\./.test(n),
              c = n.indexOf("CriOS") >= 0,
              u = n.indexOf("Trident") >= 0,
              h = /\b(iPad|iPhone|iPod)(?=;)/.test(n),
              f = n.indexOf("Opera") >= 0,
              d = /Safari\//.test(n) && !/(Chrome\/|Android\s)/.test(n),
              p = "object" === ("undefined" == typeof window ? "undefined" : t(window)) && "object" === ("undefined" == typeof document ? "undefined" : t(document));
            "undefined" == typeof PDFJS && (r.PDFJS = {}), PDFJS.compatibilityChecked = !0, function () {
              function e(e, t) {
                return new s(this.slice(e, t));
              }
              function n(e, t) {
                arguments.length < 2 && (t = 0);
                for (var r = 0, n = e.length; r < n; ++r, ++t) this[t] = 255 & e[r];
              }
              function i(e, t) {
                this.buffer = e, this.byteLength = e.length, this.length = t, o(this.length);
              }
              function a(e) {
                return {
                  get: function get() {
                    var t = this.buffer,
                      r = e << 2;
                    return (t[r] | t[r + 1] << 8 | t[r + 2] << 16 | t[r + 3] << 24) >>> 0;
                  },
                  set: function set(t) {
                    var r = this.buffer,
                      n = e << 2;
                    r[n] = 255 & t, r[n + 1] = t >> 8 & 255, r[n + 2] = t >> 16 & 255, r[n + 3] = t >>> 24 & 255;
                  }
                };
              }
              function o(e) {
                for (; l < e;) Object.defineProperty(i.prototype, l, a(l)), l++;
              }
              function s(r) {
                var i, a, o;
                if ("number" == typeof r) for (i = [], a = 0; a < r; ++a) i[a] = 0;else if ("slice" in r) i = r.slice(0);else for (i = [], a = 0, o = r.length; a < o; ++a) i[a] = r[a];
                return i.subarray = e, i.buffer = i, i.byteLength = i.length, i.set = n, "object" === (void 0 === r ? "undefined" : t(r)) && r.buffer && (i.buffer = r.buffer), i;
              }
              if ("undefined" != typeof Uint8Array) return void 0 === Uint8Array.prototype.subarray && (Uint8Array.prototype.subarray = function (e, t) {
                return new Uint8Array(this.slice(e, t));
              }, Float32Array.prototype.subarray = function (e, t) {
                return new Float32Array(this.slice(e, t));
              }), void ("undefined" == typeof Float64Array && (r.Float64Array = Float32Array));
              i.prototype = Object.create(null);
              var l = 0;
              r.Uint8Array = s, r.Int8Array = s, r.Int32Array = s, r.Uint16Array = s, r.Float32Array = s, r.Float64Array = s, r.Uint32Array = function () {
                if (3 === arguments.length) {
                  if (0 !== arguments[1]) throw new Error("offset !== 0 is not supported");
                  return new i(arguments[0], arguments[2]);
                }
                return s.apply(this, arguments);
              };
            }(), function () {
              if (p && window.CanvasPixelArray) {
                var e = window.CanvasPixelArray.prototype;
                "buffer" in e || (Object.defineProperty(e, "buffer", {
                  get: function get() {
                    return this;
                  },
                  enumerable: !1,
                  configurable: !0
                }), Object.defineProperty(e, "byteLength", {
                  get: function get() {
                    return this.length;
                  },
                  enumerable: !1,
                  configurable: !0
                }));
              }
            }(), function () {
              r.URL || (r.URL = r.webkitURL);
            }(), function () {
              if (void 0 !== Object.defineProperty) {
                var e = !0;
                try {
                  p && Object.defineProperty(new Image(), "id", {
                    value: "test"
                  });
                  var t = function t() {};
                  t.prototype = {
                    get id() {}
                  }, Object.defineProperty(new t(), "id", {
                    value: "",
                    configurable: !0,
                    enumerable: !0,
                    writable: !1
                  });
                } catch (t) {
                  e = !1;
                }
                if (e) return;
              }
              Object.defineProperty = function (e, t, r) {
                delete e[t], "get" in r && e.__defineGetter__(t, r.get), "set" in r && e.__defineSetter__(t, r.set), "value" in r && (e.__defineSetter__(t, function (e) {
                  return this.__defineGetter__(t, function () {
                    return e;
                  }), e;
                }), e[t] = r.value);
              };
            }(), function () {
              if ("undefined" != typeof XMLHttpRequest) {
                var e = XMLHttpRequest.prototype,
                  t = new XMLHttpRequest();
                if ("overrideMimeType" in t || Object.defineProperty(e, "overrideMimeType", {
                  value: function value(e) {}
                }), !("responseType" in t)) {
                  if (Object.defineProperty(e, "responseType", {
                    get: function get() {
                      return this._responseType || "text";
                    },
                    set: function set(e) {
                      "text" !== e && "arraybuffer" !== e || (this._responseType = e, "arraybuffer" === e && "function" == typeof this.overrideMimeType && this.overrideMimeType("text/plain; charset=x-user-defined"));
                    }
                  }), "undefined" != typeof VBArray) return void Object.defineProperty(e, "response", {
                    get: function get() {
                      return "arraybuffer" === this.responseType ? new Uint8Array(new VBArray(this.responseBody).toArray()) : this.responseText;
                    }
                  });
                  Object.defineProperty(e, "response", {
                    get: function get() {
                      if ("arraybuffer" !== this.responseType) return this.responseText;
                      var e,
                        t = this.responseText,
                        r = t.length,
                        n = new Uint8Array(r);
                      for (e = 0; e < r; ++e) n[e] = 255 & t.charCodeAt(e);
                      return n.buffer;
                    }
                  });
                }
              }
            }(), function () {
              if (!("btoa" in r)) {
                var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.btoa = function (t) {
                  var r,
                    n,
                    i = "";
                  for (r = 0, n = t.length; r < n; r += 3) {
                    var a = 255 & t.charCodeAt(r),
                      o = 255 & t.charCodeAt(r + 1),
                      s = 255 & t.charCodeAt(r + 2),
                      l = a >> 2,
                      c = (3 & a) << 4 | o >> 4,
                      u = r + 1 < n ? (15 & o) << 2 | s >> 6 : 64,
                      h = r + 2 < n ? 63 & s : 64;
                    i += e.charAt(l) + e.charAt(c) + e.charAt(u) + e.charAt(h);
                  }
                  return i;
                };
              }
            }(), function () {
              if (!("atob" in r)) {
                r.atob = function (e) {
                  if (e = e.replace(/=+$/, ""), e.length % 4 == 1) throw new Error("bad atob input");
                  for (var t, r, n = 0, i = 0, a = ""; r = e.charAt(i++); ~r && (t = n % 4 ? 64 * t + r : r, n++ % 4) ? a += String.fromCharCode(255 & t >> (-2 * n & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
                  return a;
                };
              }
            }(), function () {
              void 0 === Function.prototype.bind && (Function.prototype.bind = function (e) {
                var t = this,
                  r = Array.prototype.slice.call(arguments, 1);
                return function () {
                  var n = r.concat(Array.prototype.slice.call(arguments));
                  return t.apply(e, n);
                };
              });
            }(), function () {
              if (p) {
                "dataset" in document.createElement("div") || Object.defineProperty(HTMLElement.prototype, "dataset", {
                  get: function get() {
                    if (this._dataset) return this._dataset;
                    for (var e = {}, t = 0, r = this.attributes.length; t < r; t++) {
                      var n = this.attributes[t];
                      if ("data-" === n.name.substring(0, 5)) {
                        e[n.name.substring(5).replace(/\-([a-z])/g, function (e, t) {
                          return t.toUpperCase();
                        })] = n.value;
                      }
                    }
                    return Object.defineProperty(this, "_dataset", {
                      value: e,
                      writable: !1,
                      enumerable: !1
                    }), e;
                  },
                  enumerable: !0
                });
              }
            }(), function () {
              function e(e, t, r, n) {
                var i = e.className || "",
                  a = i.split(/\s+/g);
                "" === a[0] && a.shift();
                var o = a.indexOf(t);
                return o < 0 && r && a.push(t), o >= 0 && n && a.splice(o, 1), e.className = a.join(" "), o >= 0;
              }
              if (p) {
                if (!("classList" in document.createElement("div"))) {
                  var t = {
                    add: function add(t) {
                      e(this.element, t, !0, !1);
                    },
                    contains: function contains(t) {
                      return e(this.element, t, !1, !1);
                    },
                    remove: function remove(t) {
                      e(this.element, t, !1, !0);
                    },
                    toggle: function toggle(t) {
                      e(this.element, t, !0, !0);
                    }
                  };
                  Object.defineProperty(HTMLElement.prototype, "classList", {
                    get: function get() {
                      if (this._classList) return this._classList;
                      var e = Object.create(t, {
                        element: {
                          value: this,
                          writable: !1,
                          enumerable: !0
                        }
                      });
                      return Object.defineProperty(this, "_classList", {
                        value: e,
                        writable: !1,
                        enumerable: !1
                      }), e;
                    },
                    enumerable: !0
                  });
                }
              }
            }(), function () {
              if (!("undefined" == typeof importScripts || "console" in r)) {
                var e = {},
                  t = {
                    log: function log() {
                      var e = Array.prototype.slice.call(arguments);
                      r.postMessage({
                        targetName: "main",
                        action: "console_log",
                        data: e
                      });
                    },
                    error: function error() {
                      var e = Array.prototype.slice.call(arguments);
                      r.postMessage({
                        targetName: "main",
                        action: "console_error",
                        data: e
                      });
                    },
                    time: function time(t) {
                      e[t] = Date.now();
                    },
                    timeEnd: function timeEnd(t) {
                      var r = e[t];
                      if (!r) throw new Error("Unknown timer name " + t);
                      this.log("Timer:", t, Date.now() - r);
                    }
                  };
                r.console = t;
              }
            }(), function () {
              if (p) "console" in window ? "bind" in console.log || (console.log = function (e) {
                return function (t) {
                  return e(t);
                };
              }(console.log), console.error = function (e) {
                return function (t) {
                  return e(t);
                };
              }(console.error), console.warn = function (e) {
                return function (t) {
                  return e(t);
                };
              }(console.warn)) : window.console = {
                log: function log() {},
                error: function error() {},
                warn: function warn() {}
              };
            }(), function () {
              function e(e) {
                t(e.target) && e.stopPropagation();
              }
              function t(e) {
                return e.disabled || e.parentNode && t(e.parentNode);
              }
              f && document.addEventListener("click", e, !0);
            }(), function () {
              (u || c) && (PDFJS.disableCreateObjectURL = !0);
            }(), function () {
              "undefined" != typeof navigator && ("language" in navigator || (PDFJS.locale = navigator.userLanguage || "en-US"));
            }(), function () {
              (d || a || l || h) && (PDFJS.disableRange = !0, PDFJS.disableStream = !0);
            }(), function () {
              p && (history.pushState && !a || (PDFJS.disableHistory = !0));
            }(), function () {
              if (p) if (window.CanvasPixelArray) "function" != typeof window.CanvasPixelArray.prototype.set && (window.CanvasPixelArray.prototype.set = function (e) {
                for (var t = 0, r = this.length; t < r; t++) this[t] = e[t];
              });else {
                var e,
                  t = !1;
                if (s ? (e = n.match(/Chrom(e|ium)\/([0-9]+)\./), t = e && parseInt(e[2]) < 21) : i ? t = o : d && (e = n.match(/Version\/([0-9]+)\.([0-9]+)\.([0-9]+) Safari\//), t = e && parseInt(e[1]) < 6), t) {
                  var r = window.CanvasRenderingContext2D.prototype,
                    a = r.createImageData;
                  r.createImageData = function (e, t) {
                    var r = a.call(this, e, t);
                    return r.data.set = function (e) {
                      for (var t = 0, r = this.length; t < r; t++) this[t] = e[t];
                    }, r;
                  }, r = null;
                }
              }
            }(), function () {
              function e() {
                window.requestAnimationFrame = function (e) {
                  return window.setTimeout(e, 20);
                }, window.cancelAnimationFrame = function (e) {
                  window.clearTimeout(e);
                };
              }
              if (p) h ? e() : "requestAnimationFrame" in window || (window.requestAnimationFrame = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame, window.requestAnimationFrame || e());
            }(), function () {
              (h || i) && (PDFJS.maxCanvasPixels = 5242880);
            }(), function () {
              p && u && window.parent !== window && (PDFJS.disableFullscreen = !0);
            }(), function () {
              p && ("currentScript" in document || Object.defineProperty(document, "currentScript", {
                get: function get() {
                  var e = document.getElementsByTagName("script");
                  return e[e.length - 1];
                },
                enumerable: !0,
                configurable: !0
              }));
            }(), function () {
              if (p) {
                var e = document.createElement("input");
                try {
                  e.type = "number";
                } catch (n) {
                  var t = e.constructor.prototype,
                    r = Object.getOwnPropertyDescriptor(t, "type");
                  Object.defineProperty(t, "type", {
                    get: function get() {
                      return r.get.call(this);
                    },
                    set: function set(e) {
                      r.set.call(this, "number" === e ? "text" : e);
                    },
                    enumerable: !0,
                    configurable: !0
                  });
                }
              }
            }(), function () {
              if (p && document.attachEvent) {
                var e = document.constructor.prototype,
                  t = Object.getOwnPropertyDescriptor(e, "readyState");
                Object.defineProperty(e, "readyState", {
                  get: function get() {
                    var e = t.get.call(this);
                    return "interactive" === e ? "loading" : e;
                  },
                  set: function set(e) {
                    t.set.call(this, e);
                  },
                  enumerable: !0,
                  configurable: !0
                });
              }
            }(), function () {
              p && void 0 === Element.prototype.remove && (Element.prototype.remove = function () {
                this.parentNode && this.parentNode.removeChild(this);
              });
            }(), function () {
              if (r.Promise) return "function" != typeof r.Promise.all && (r.Promise.all = function (e) {
                var t,
                  n,
                  i = 0,
                  a = [],
                  o = new r.Promise(function (e, r) {
                    t = e, n = r;
                  });
                return e.forEach(function (e, r) {
                  i++, e.then(function (e) {
                    a[r] = e, 0 === --i && t(a);
                  }, n);
                }), 0 === i && t(a), o;
              }), "function" != typeof r.Promise.resolve && (r.Promise.resolve = function (e) {
                return new r.Promise(function (t) {
                  t(e);
                });
              }), "function" != typeof r.Promise.reject && (r.Promise.reject = function (e) {
                return new r.Promise(function (t, r) {
                  r(e);
                });
              }), void ("function" != typeof r.Promise.prototype.catch && (r.Promise.prototype.catch = function (e) {
                return r.Promise.prototype.then(void 0, e);
              }));
              var e = 2,
                t = {
                  handlers: [],
                  running: !1,
                  unhandledRejections: [],
                  pendingRejectionCheck: !1,
                  scheduleHandlers: function scheduleHandlers(e) {
                    0 !== e._status && (this.handlers = this.handlers.concat(e._handlers), e._handlers = [], this.running || (this.running = !0, setTimeout(this.runHandlers.bind(this), 0)));
                  },
                  runHandlers: function runHandlers() {
                    for (var t = Date.now() + 1; this.handlers.length > 0;) {
                      var r = this.handlers.shift(),
                        n = r.thisPromise._status,
                        i = r.thisPromise._value;
                      try {
                        1 === n ? "function" == typeof r.onResolve && (i = r.onResolve(i)) : "function" == typeof r.onReject && (i = r.onReject(i), n = 1, r.thisPromise._unhandledRejection && this.removeUnhandeledRejection(r.thisPromise));
                      } catch (t) {
                        n = e, i = t;
                      }
                      if (r.nextPromise._updateStatus(n, i), Date.now() >= t) break;
                    }
                    if (this.handlers.length > 0) return void setTimeout(this.runHandlers.bind(this), 0);
                    this.running = !1;
                  },
                  addUnhandledRejection: function addUnhandledRejection(e) {
                    this.unhandledRejections.push({
                      promise: e,
                      time: Date.now()
                    }), this.scheduleRejectionCheck();
                  },
                  removeUnhandeledRejection: function removeUnhandeledRejection(e) {
                    e._unhandledRejection = !1;
                    for (var t = 0; t < this.unhandledRejections.length; t++) this.unhandledRejections[t].promise === e && (this.unhandledRejections.splice(t), t--);
                  },
                  scheduleRejectionCheck: function scheduleRejectionCheck() {
                    var e = this;
                    this.pendingRejectionCheck || (this.pendingRejectionCheck = !0, setTimeout(function () {
                      e.pendingRejectionCheck = !1;
                      for (var t = Date.now(), r = 0; r < e.unhandledRejections.length; r++) if (t - e.unhandledRejections[r].time > 500) {
                        var n = e.unhandledRejections[r].promise._value,
                          i = "Unhandled rejection: " + n;
                        n.stack && (i += "\n" + n.stack);
                        try {
                          throw new Error(i);
                        } catch (e) {
                          console.warn(i);
                        }
                        e.unhandledRejections.splice(r), r--;
                      }
                      e.unhandledRejections.length && e.scheduleRejectionCheck();
                    }, 500));
                  }
                },
                n = function n(e) {
                  this._status = 0, this._handlers = [];
                  try {
                    e.call(this, this._resolve.bind(this), this._reject.bind(this));
                  } catch (e) {
                    this._reject(e);
                  }
                };
              n.all = function (t) {
                function r(t) {
                  o._status !== e && (l = [], a(t));
                }
                var i,
                  a,
                  o = new n(function (e, t) {
                    i = e, a = t;
                  }),
                  s = t.length,
                  l = [];
                if (0 === s) return i(l), o;
                for (var c = 0, u = t.length; c < u; ++c) {
                  var h = t[c],
                    f = function (t) {
                      return function (r) {
                        o._status !== e && (l[t] = r, 0 === --s && i(l));
                      };
                    }(c);
                  n.isPromise(h) ? h.then(f, r) : f(h);
                }
                return o;
              }, n.isPromise = function (e) {
                return e && "function" == typeof e.then;
              }, n.resolve = function (e) {
                return new n(function (t) {
                  t(e);
                });
              }, n.reject = function (e) {
                return new n(function (t, r) {
                  r(e);
                });
              }, n.prototype = {
                _status: null,
                _value: null,
                _handlers: null,
                _unhandledRejection: null,
                _updateStatus: function _updateStatus(r, i) {
                  if (1 !== this._status && this._status !== e) {
                    if (1 === r && n.isPromise(i)) return void i.then(this._updateStatus.bind(this, 1), this._updateStatus.bind(this, e));
                    this._status = r, this._value = i, r === e && 0 === this._handlers.length && (this._unhandledRejection = !0, t.addUnhandledRejection(this)), t.scheduleHandlers(this);
                  }
                },
                _resolve: function _resolve(e) {
                  this._updateStatus(1, e);
                },
                _reject: function _reject(t) {
                  this._updateStatus(e, t);
                },
                then: function then(e, r) {
                  var i = new n(function (e, t) {
                    this.resolve = e, this.reject = t;
                  });
                  return this._handlers.push({
                    thisPromise: this,
                    onResolve: e,
                    onReject: r,
                    nextPromise: i
                  }), t.scheduleHandlers(this), i;
                },
                catch: function _catch(e) {
                  return this.then(void 0, e);
                }
              }, r.Promise = n;
            }(), function () {
              function e() {
                this.id = "$weakmap" + t++;
              }
              if (!r.WeakMap) {
                var t = 0;
                e.prototype = {
                  has: function has(e) {
                    return !!Object.getOwnPropertyDescriptor(e, this.id);
                  },
                  get: function get(e, t) {
                    return this.has(e) ? e[this.id] : t;
                  },
                  set: function set(e, t) {
                    Object.defineProperty(e, this.id, {
                      value: t,
                      enumerable: !1,
                      configurable: !0
                    });
                  },
                  delete: function _delete(e) {
                    delete e[this.id];
                  }
                }, r.WeakMap = e;
              }
            }(), function () {
              function e(e) {
                return void 0 !== f[e];
              }
              function n() {
                l.call(this), this._isInvalid = !0;
              }
              function i(e) {
                return "" === e && n.call(this), e.toLowerCase();
              }
              function a(e) {
                var t = e.charCodeAt(0);
                return t > 32 && t < 127 && -1 === [34, 35, 60, 62, 63, 96].indexOf(t) ? e : encodeURIComponent(e);
              }
              function o(e) {
                var t = e.charCodeAt(0);
                return t > 32 && t < 127 && -1 === [34, 35, 60, 62, 96].indexOf(t) ? e : encodeURIComponent(e);
              }
              function s(t, r, s) {
                function l(e) {
                  y.push(e);
                }
                var c = r || "scheme start",
                  u = 0,
                  h = "",
                  v = !1,
                  b = !1,
                  y = [];
                e: for (; (t[u - 1] !== p || 0 === u) && !this._isInvalid;) {
                  var w = t[u];
                  switch (c) {
                    case "scheme start":
                      if (!w || !m.test(w)) {
                        if (r) {
                          l("Invalid scheme.");
                          break e;
                        }
                        h = "", c = "no scheme";
                        continue;
                      }
                      h += w.toLowerCase(), c = "scheme";
                      break;
                    case "scheme":
                      if (w && g.test(w)) h += w.toLowerCase();else {
                        if (":" !== w) {
                          if (r) {
                            if (w === p) break e;
                            l("Code point not allowed in scheme: " + w);
                            break e;
                          }
                          h = "", u = 0, c = "no scheme";
                          continue;
                        }
                        if (this._scheme = h, h = "", r) break e;
                        e(this._scheme) && (this._isRelative = !0), c = "file" === this._scheme ? "relative" : this._isRelative && s && s._scheme === this._scheme ? "relative or authority" : this._isRelative ? "authority first slash" : "scheme data";
                      }
                      break;
                    case "scheme data":
                      "?" === w ? (this._query = "?", c = "query") : "#" === w ? (this._fragment = "#", c = "fragment") : w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._schemeData += a(w));
                      break;
                    case "no scheme":
                      if (s && e(s._scheme)) {
                        c = "relative";
                        continue;
                      }
                      l("Missing scheme."), n.call(this);
                      break;
                    case "relative or authority":
                      if ("/" !== w || "/" !== t[u + 1]) {
                        l("Expected /, got: " + w), c = "relative";
                        continue;
                      }
                      c = "authority ignore slashes";
                      break;
                    case "relative":
                      if (this._isRelative = !0, "file" !== this._scheme && (this._scheme = s._scheme), w === p) {
                        this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = s._query, this._username = s._username, this._password = s._password;
                        break e;
                      }
                      if ("/" === w || "\\" === w) "\\" === w && l("\\ is an invalid code point."), c = "relative slash";else if ("?" === w) this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = "?", this._username = s._username, this._password = s._password, c = "query";else {
                        if ("#" !== w) {
                          var x = t[u + 1],
                            _ = t[u + 2];
                          ("file" !== this._scheme || !m.test(w) || ":" !== x && "|" !== x || _ !== p && "/" !== _ && "\\" !== _ && "?" !== _ && "#" !== _) && (this._host = s._host, this._port = s._port, this._username = s._username, this._password = s._password, this._path = s._path.slice(), this._path.pop()), c = "relative path";
                          continue;
                        }
                        this._host = s._host, this._port = s._port, this._path = s._path.slice(), this._query = s._query, this._fragment = "#", this._username = s._username, this._password = s._password, c = "fragment";
                      }
                      break;
                    case "relative slash":
                      if ("/" !== w && "\\" !== w) {
                        "file" !== this._scheme && (this._host = s._host, this._port = s._port, this._username = s._username, this._password = s._password), c = "relative path";
                        continue;
                      }
                      "\\" === w && l("\\ is an invalid code point."), c = "file" === this._scheme ? "file host" : "authority ignore slashes";
                      break;
                    case "authority first slash":
                      if ("/" !== w) {
                        l("Expected '/', got: " + w), c = "authority ignore slashes";
                        continue;
                      }
                      c = "authority second slash";
                      break;
                    case "authority second slash":
                      if (c = "authority ignore slashes", "/" !== w) {
                        l("Expected '/', got: " + w);
                        continue;
                      }
                      break;
                    case "authority ignore slashes":
                      if ("/" !== w && "\\" !== w) {
                        c = "authority";
                        continue;
                      }
                      l("Expected authority, got: " + w);
                      break;
                    case "authority":
                      if ("@" === w) {
                        v && (l("@ already seen."), h += "%40"), v = !0;
                        for (var S = 0; S < h.length; S++) {
                          var C = h[S];
                          if ("\t" !== C && "\n" !== C && "\r" !== C) {
                            if (":" !== C || null !== this._password) {
                              var E = a(C);
                              null !== this._password ? this._password += E : this._username += E;
                            } else this._password = "";
                          } else l("Invalid whitespace in authority.");
                        }
                        h = "";
                      } else {
                        if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                          u -= h.length, h = "", c = "host";
                          continue;
                        }
                        h += w;
                      }
                      break;
                    case "file host":
                      if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                        2 !== h.length || !m.test(h[0]) || ":" !== h[1] && "|" !== h[1] ? 0 === h.length ? c = "relative path start" : (this._host = i.call(this, h), h = "", c = "relative path start") : c = "relative path";
                        continue;
                      }
                      "\t" === w || "\n" === w || "\r" === w ? l("Invalid whitespace in file host.") : h += w;
                      break;
                    case "host":
                    case "hostname":
                      if (":" !== w || b) {
                        if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w) {
                          if (this._host = i.call(this, h), h = "", c = "relative path start", r) break e;
                          continue;
                        }
                        "\t" !== w && "\n" !== w && "\r" !== w ? ("[" === w ? b = !0 : "]" === w && (b = !1), h += w) : l("Invalid code point in host/hostname: " + w);
                      } else if (this._host = i.call(this, h), h = "", c = "port", "hostname" === r) break e;
                      break;
                    case "port":
                      if (/[0-9]/.test(w)) h += w;else {
                        if (w === p || "/" === w || "\\" === w || "?" === w || "#" === w || r) {
                          if ("" !== h) {
                            var A = parseInt(h, 10);
                            A !== f[this._scheme] && (this._port = A + ""), h = "";
                          }
                          if (r) break e;
                          c = "relative path start";
                          continue;
                        }
                        "\t" === w || "\n" === w || "\r" === w ? l("Invalid code point in port: " + w) : n.call(this);
                      }
                      break;
                    case "relative path start":
                      if ("\\" === w && l("'\\' not allowed in path."), c = "relative path", "/" !== w && "\\" !== w) continue;
                      break;
                    case "relative path":
                      if (w !== p && "/" !== w && "\\" !== w && (r || "?" !== w && "#" !== w)) "\t" !== w && "\n" !== w && "\r" !== w && (h += a(w));else {
                        "\\" === w && l("\\ not allowed in relative path.");
                        var T;
                        (T = d[h.toLowerCase()]) && (h = T), ".." === h ? (this._path.pop(), "/" !== w && "\\" !== w && this._path.push("")) : "." === h && "/" !== w && "\\" !== w ? this._path.push("") : "." !== h && ("file" === this._scheme && 0 === this._path.length && 2 === h.length && m.test(h[0]) && "|" === h[1] && (h = h[0] + ":"), this._path.push(h)), h = "", "?" === w ? (this._query = "?", c = "query") : "#" === w && (this._fragment = "#", c = "fragment");
                      }
                      break;
                    case "query":
                      r || "#" !== w ? w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._query += o(w)) : (this._fragment = "#", c = "fragment");
                      break;
                    case "fragment":
                      w !== p && "\t" !== w && "\n" !== w && "\r" !== w && (this._fragment += w);
                  }
                  u++;
                }
              }
              function l() {
                this._scheme = "", this._schemeData = "", this._username = "", this._password = null, this._host = "", this._port = "", this._path = [], this._query = "", this._fragment = "", this._isInvalid = !1, this._isRelative = !1;
              }
              function c(e, t) {
                void 0 === t || t instanceof c || (t = new c(String(t))), this._url = e, l.call(this);
                var r = e.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, "");
                s.call(this, r, null, t);
              }
              var u = !1;
              try {
                if ("function" == typeof URL && "object" === t(URL.prototype) && "origin" in URL.prototype) {
                  var h = new URL("b", "http://a");
                  h.pathname = "c%20d", u = "http://a/c%20d" === h.href;
                }
              } catch (e) {}
              if (!u) {
                var f = Object.create(null);
                f.ftp = 21, f.file = 0, f.gopher = 70, f.http = 80, f.https = 443, f.ws = 80, f.wss = 443;
                var d = Object.create(null);
                d["%2e"] = ".", d[".%2e"] = "..", d["%2e."] = "..", d["%2e%2e"] = "..";
                var p,
                  m = /[a-zA-Z]/,
                  g = /[a-zA-Z0-9\+\-\.]/;
                c.prototype = {
                  toString: function toString() {
                    return this.href;
                  },
                  get href() {
                    if (this._isInvalid) return this._url;
                    var e = "";
                    return "" === this._username && null === this._password || (e = this._username + (null !== this._password ? ":" + this._password : "") + "@"), this.protocol + (this._isRelative ? "//" + e + this.host : "") + this.pathname + this._query + this._fragment;
                  },
                  set href(e) {
                    l.call(this), s.call(this, e);
                  },
                  get protocol() {
                    return this._scheme + ":";
                  },
                  set protocol(e) {
                    this._isInvalid || s.call(this, e + ":", "scheme start");
                  },
                  get host() {
                    return this._isInvalid ? "" : this._port ? this._host + ":" + this._port : this._host;
                  },
                  set host(e) {
                    !this._isInvalid && this._isRelative && s.call(this, e, "host");
                  },
                  get hostname() {
                    return this._host;
                  },
                  set hostname(e) {
                    !this._isInvalid && this._isRelative && s.call(this, e, "hostname");
                  },
                  get port() {
                    return this._port;
                  },
                  set port(e) {
                    !this._isInvalid && this._isRelative && s.call(this, e, "port");
                  },
                  get pathname() {
                    return this._isInvalid ? "" : this._isRelative ? "/" + this._path.join("/") : this._schemeData;
                  },
                  set pathname(e) {
                    !this._isInvalid && this._isRelative && (this._path = [], s.call(this, e, "relative path start"));
                  },
                  get search() {
                    return this._isInvalid || !this._query || "?" === this._query ? "" : this._query;
                  },
                  set search(e) {
                    !this._isInvalid && this._isRelative && (this._query = "?", "?" === e[0] && (e = e.slice(1)), s.call(this, e, "query"));
                  },
                  get hash() {
                    return this._isInvalid || !this._fragment || "#" === this._fragment ? "" : this._fragment;
                  },
                  set hash(e) {
                    this._isInvalid || (this._fragment = "#", "#" === e[0] && (e = e.slice(1)), s.call(this, e, "fragment"));
                  },
                  get origin() {
                    var e;
                    if (this._isInvalid || !this._scheme) return "";
                    switch (this._scheme) {
                      case "data":
                      case "file":
                      case "javascript":
                      case "mailto":
                        return "null";
                    }
                    return e = this.host, e ? this._scheme + "://" + e : "";
                  }
                };
                var v = r.URL;
                v && (c.createObjectURL = function (e) {
                  return v.createObjectURL.apply(v, arguments);
                }, c.revokeObjectURL = function (e) {
                  v.revokeObjectURL(e);
                }), r.URL = c;
              }
            }();
          }
        }).call(t, r(1));
      }, function (e, t, r) {
        "use strict";

        var n,
          i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          };
        n = function () {
          return this;
        }();
        try {
          n = n || Function("return this")() || (0, eval)("this");
        } catch (e) {
          "object" === ("undefined" == typeof window ? "undefined" : i(window)) && (n = window);
        }
        e.exports = n;
      }, function (e, t, r) {
        "use strict";

        r(0);
      }]);
    });
  }, function (e, t, r) {
    "use strict";

    function n() {}
    var i = r(349);
    e.exports = function () {
      function e(e, t, r, n, a, o) {
        if (o !== i) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return r.checkPropTypes = n, r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    e.exports = r(347)();
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    !function (t, n) {
      e.exports = n(r(2), r(149));
    }(0, function (e, t) {
      return function (e) {
        function t(n) {
          if (r[n]) return r[n].exports;
          var i = r[n] = {
            exports: {},
            id: n,
            loaded: !1
          };
          return e[n].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.p = "", t(0);
      }([function (e, t, r) {
        e.exports = r(271);
      },, function (t, r) {
        t.exports = e;
      }, function (e, t, r) {
        e.exports = r(118)();
      }, function (e, t, r) {
        var n, i; /*!
                  Copyright (c) 2017 Jed Watson.
                  Licensed under the MIT License (MIT), see
                  http://jedwatson.github.io/classnames
                  */
        !function () {
          "use strict";

          function r() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var n = arguments[t];
              if (n) {
                var i = _typeof(n);
                if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n) && n.length) {
                  var o = r.apply(null, n);
                  o && e.push(o);
                } else if ("object" === i) for (var s in n) a.call(n, s) && n[s] && e.push(s);
              }
            }
            return e.join(" ");
          }
          var a = {}.hasOwnProperty;
          void 0 !== e && e.exports ? (r.default = r, e.exports = r) : (n = [], void 0 !== (i = function () {
            return r;
          }.apply(t, n)) && (e.exports = i));
        }();
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          },
          n = function n() {
            return "undefined" != typeof Immutable;
          };
        t.isColumnsImmutable = function (e) {
          return n() && e instanceof Immutable.List;
        }, t.isEmptyArray = function (e) {
          return Array.isArray(e) && 0 === e.length;
        }, t.isFunction = function (e) {
          var t = {};
          return e && "[object Function]" === t.toString.call(e);
        }, t.isEmptyObject = function (e) {
          return 0 === Object.keys(e).length && e.constructor === Object;
        }, t.isImmutableCollection = function (e) {
          return n() && Immutable.Iterable.isIterable(e);
        }, t.getMixedTypeValueRetriever = function (e) {
          var t = {},
            r = function r(e, t) {
              return e[t];
            },
            n = function n(e, t) {
              return e.get(t);
            };
          return t.getValue = e ? n : r, t;
        }, t.isImmutableMap = n() ? Immutable.Map.isMap : function () {
          return !1;
        }, t.last = function (e) {
          if (null == e) throw new Error("arrayOrCollection is null");
          if (n() && Immutable.List.isList(e)) return e.last();
          if (Array.isArray(e)) return e[e.length - 1];
          throw new Error("Cant get last of: " + (void 0 === e ? "undefined" : r(e)));
        };
      }, function (e, t) {
        "use strict";

        e.exports = {
          getColumn: function getColumn(e, t) {
            return Array.isArray(e) ? e[t] : "undefined" != typeof Immutable ? e.get(t) : void 0;
          },
          spliceColumn: function spliceColumn(e, t, r) {
            return Array.isArray(e.columns) ? e.columns.splice(t, 1, r) : "undefined" != typeof Immutable && (e.columns = e.columns.splice(t, 1, r)), e;
          },
          getSize: function getSize(e) {
            return Array.isArray(e) ? e.length : "undefined" != typeof Immutable ? e.size : void 0;
          },
          canEdit: function canEdit(e, t, r) {
            return !!e && (null != e.editable && "function" == typeof e.editable ? !0 === r && e.editable(t) : !(!0 !== r || !e.editor && !e.editable));
          },
          getValue: function getValue(e, t) {
            return e.toJSON && e.get ? e.get(t) : e[t];
          },
          isFrozen: function isFrozen(e) {
            return !0 === e.locked || !0 === e.frozen;
          }
        };
      },, function (e, t) {
        e.exports = function () {
          var e = [];
          return e.toString = function () {
            for (var e = [], t = 0; t < this.length; t++) {
              var r = this[t];
              r[2] ? e.push("@media " + r[2] + "{" + r[1] + "}") : e.push(r[1]);
            }
            return e.join("");
          }, e.i = function (t, r) {
            "string" == typeof t && (t = [[null, t, ""]]);
            for (var n = {}, i = 0; i < this.length; i++) {
              var a = this[i][0];
              "number" == typeof a && (n[a] = !0);
            }
            for (i = 0; i < t.length; i++) {
              var o = t[i];
              "number" == typeof o[0] && n[o[0]] || (r && !o[2] ? o[2] = r : r && (o[2] = "(" + o[2] + ") and (" + r + ")"), e.push(o));
            }
          }, e;
        };
      }, function (e, t, r) {
        function n(e, t) {
          for (var r = 0; r < e.length; r++) {
            var n = e[r],
              i = d[n.id];
            if (i) {
              i.refs++;
              for (var a = 0; a < i.parts.length; a++) i.parts[a](n.parts[a]);
              for (; a < n.parts.length; a++) i.parts.push(c(n.parts[a], t));
            } else {
              for (var o = [], a = 0; a < n.parts.length; a++) o.push(c(n.parts[a], t));
              d[n.id] = {
                id: n.id,
                refs: 1,
                parts: o
              };
            }
          }
        }
        function i(e) {
          for (var t = [], r = {}, n = 0; n < e.length; n++) {
            var i = e[n],
              a = i[0],
              o = i[1],
              s = i[2],
              l = i[3],
              c = {
                css: o,
                media: s,
                sourceMap: l
              };
            r[a] ? r[a].parts.push(c) : t.push(r[a] = {
              id: a,
              parts: [c]
            });
          }
          return t;
        }
        function a(e, t) {
          var r = g(),
            n = y[y.length - 1];
          if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), y.push(t);else {
            if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            r.appendChild(t);
          }
        }
        function o(e) {
          e.parentNode.removeChild(e);
          var t = y.indexOf(e);
          t >= 0 && y.splice(t, 1);
        }
        function s(e) {
          var t = document.createElement("style");
          return t.type = "text/css", a(e, t), t;
        }
        function l(e) {
          var t = document.createElement("link");
          return t.rel = "stylesheet", a(e, t), t;
        }
        function c(e, t) {
          var r, n, i;
          if (t.singleton) {
            var a = b++;
            r = v || (v = s(t)), n = u.bind(null, r, a, !1), i = u.bind(null, r, a, !0);
          } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = l(t), n = f.bind(null, r), i = function i() {
            o(r), r.href && URL.revokeObjectURL(r.href);
          }) : (r = s(t), n = h.bind(null, r), i = function i() {
            o(r);
          });
          return n(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              n(e = t);
            } else i();
          };
        }
        function u(e, t, r, n) {
          var i = r ? "" : n.css;
          if (e.styleSheet) e.styleSheet.cssText = w(t, i);else {
            var a = document.createTextNode(i),
              o = e.childNodes;
            o[t] && e.removeChild(o[t]), o.length ? e.insertBefore(a, o[t]) : e.appendChild(a);
          }
        }
        function h(e, t) {
          var r = t.css,
            n = t.media;
          if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = r;else {
            for (; e.firstChild;) e.removeChild(e.firstChild);
            e.appendChild(document.createTextNode(r));
          }
        }
        function f(e, t) {
          var r = t.css,
            n = t.sourceMap;
          n && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(n)))) + " */");
          var i = new Blob([r], {
              type: "text/css"
            }),
            a = e.href;
          e.href = URL.createObjectURL(i), a && URL.revokeObjectURL(a);
        }
        var d = {},
          p = function p(e) {
            var t;
            return function () {
              return void 0 === t && (t = e.apply(this, arguments)), t;
            };
          },
          m = p(function () {
            return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
          }),
          g = p(function () {
            return document.head || document.getElementsByTagName("head")[0];
          }),
          v = null,
          b = 0,
          y = [];
        e.exports = function (e, t) {
          t = t || {}, void 0 === t.singleton && (t.singleton = m()), void 0 === t.insertAt && (t.insertAt = "bottom");
          var r = i(e);
          return n(r, t), function (e) {
            for (var a = [], o = 0; o < r.length; o++) {
              var s = r[o],
                l = d[s.id];
              l.refs--, a.push(l);
            }
            if (e) {
              n(i(e), t);
            }
            for (var o = 0; o < a.length; o++) {
              var l = a[o];
              if (0 === l.refs) {
                for (var c = 0; c < l.parts.length; c++) l.parts[c]();
                delete d[l.id];
              }
            }
          };
        };
        var w = function () {
          var e = [];
          return function (t, r) {
            return e[t] = r, e.filter(Boolean).join("\n");
          };
        }();
      },, function (e, t, r) {
        "use strict";

        function n(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          return t.default = e, t;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DragItemTypes = t.CellExpand = t.UpdateActions = t.HeaderRowType = t.EventTypes = t.CellNavigationMode = void 0;
        var i = r(105),
          a = n(i),
          o = r(106),
          s = n(o),
          l = r(107),
          c = n(l),
          u = r(111),
          h = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(u),
          f = (0, h.default)({
            CELL_UPDATE: null,
            COLUMN_FILL: null,
            COPY_PASTE: null,
            CELL_DRAG: null
          }),
          d = {
            Column: "column"
          },
          p = {
            DOWN_TRIANGLE: String.fromCharCode(9660),
            RIGHT_TRIANGLE: String.fromCharCode(9654)
          };
        t.CellNavigationMode = a, t.EventTypes = s, t.HeaderRowType = c, t.UpdateActions = f, t.CellExpand = p, t.DragItemTypes = d;
      },, function (e, r) {
        e.exports = t;
      },,,,, function (e, t, r) {
        "use strict";

        var n = r(3),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n),
          a = {
            name: i.default.node.isRequired,
            key: i.default.string.isRequired,
            width: i.default.number.isRequired,
            filterable: i.default.bool
          };
        e.exports = a;
      },,,,,,,,, function (e, t) {
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */
        "use strict";

        function r(e) {
          if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(e);
        }
        var n = Object.getOwnPropertySymbols,
          i = Object.prototype.hasOwnProperty,
          a = Object.prototype.propertyIsEnumerable;
        e.exports = function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
            for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
            if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
              return t[e];
            }).join("")) return !1;
            var n = {};
            return "abcdefghijklmnopqrst".split("").forEach(function (e) {
              n[e] = e;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
          } catch (e) {
            return !1;
          }
        }() ? Object.assign : function (e, t) {
          for (var o, s, l = r(e), c = 1; c < arguments.length; c++) {
            o = Object(arguments[c]);
            for (var u in o) i.call(o, u) && (l[u] = o[u]);
            if (n) {
              s = n(o);
              for (var h = 0; h < s.length; h++) a.call(o, s[h]) && (l[s[h]] = o[s[h]]);
            }
          }
          return l;
        };
      },,,, function (e, t, r) {
        "use strict";

        var n = r(3),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n);
        e.exports = {
          rowKey: i.default.string.isRequired,
          onCellClick: i.default.func.isRequired,
          onCellMouseDown: i.default.func.isRequired,
          onCellMouseEnter: i.default.func.isRequired,
          onCellContextMenu: i.default.func.isRequired,
          onCellDoubleClick: i.default.func.isRequired,
          onDragEnter: i.default.func.isRequired,
          onRowExpandToggle: i.default.func.isRequired,
          onDeleteSubRow: i.default.func,
          onAddSubRow: i.default.func,
          onColumnEvent: i.default.func.isRequired,
          onCellExpand: i.default.func.isRequired,
          getCellActions: i.default.func
        };
      },,,,, function (e, t) {
        "use strict";

        function r(e, t) {
          return t.reduce(function (t, r) {
            return r in e && (t[r] = e[r]), t;
          }, {});
        }
        e.exports = r;
      },,,, function (e, t, r) {
        var n = r(285);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      },,, function (e, t, r) {
        "use strict";

        e.exports = {
          CheckboxEditor: r(69),
          EditorBase: r(47),
          SimpleTextEditor: r(70)
        };
      }, function (e, t) {
        "use strict";

        function r(e, t) {
          return t.columns !== e.columns || e.row !== t.row || t.colOverscanStartIdx !== e.colOverscanStartIdx || t.colOverscanEndIdx !== e.colOverscanEndIdx || t.colVisibleStartIdx !== e.colVisibleStartIdx || t.colVisibleEndIdx !== e.colVisibleEndIdx || t.isSelected !== e.isSelected || t.isScrolling !== e.isScrolling || e.height !== t.height || t.isOver !== e.isOver || t.expandedRows !== e.expandedRows || t.canDrop !== e.canDrop || !0 === t.forceUpdate || t.extraClasses !== e.extraClasses;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = r;
      }, function (e, t, r) {
        var n = r(110);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      },, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(18),
          c = n(l),
          u = r(3),
          h = n(u),
          f = r(2),
          d = r(13),
          p = function (e) {
            function t() {
              return i(this, t), a(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }
            return o(t, e), s(t, [{
              key: "getStyle",
              value: function value() {
                return {
                  width: "100%"
                };
              }
            }, {
              key: "getValue",
              value: function value() {
                var e = {};
                return e[this.props.column.key] = this.getInputNode().value, e;
              }
            }, {
              key: "getInputNode",
              value: function value() {
                var e = d.findDOMNode(this);
                return "INPUT" === e.tagName ? e : e.querySelector("input:not([type=hidden])");
              }
            }, {
              key: "inheritContainerStyles",
              value: function value() {
                return !0;
              }
            }]), t;
          }(f.Component);
        p.propTypes = {
          onKeyDown: h.default.func.isRequired,
          value: h.default.any.isRequired,
          onBlur: h.default.func.isRequired,
          column: h.default.shape(c.default).isRequired,
          commit: h.default.func.isRequired
        }, e.exports = p;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var a = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          o = r(2),
          s = n(o),
          l = r(3),
          c = n(l),
          u = function u(e) {
            var t = e.left,
              r = e.top,
              n = e.width;
            return {
              height: e.height,
              width: n,
              zIndex: e.zIndex,
              position: e.position || "absolute",
              pointerEvents: "none",
              transform: "translate(" + t + "px, " + r + "px)",
              outline: 0
            };
          },
          h = function h(e) {
            var t = e.width,
              r = e.height,
              n = e.top,
              o = e.left,
              l = e.zIndex,
              c = e.children,
              h = e.position,
              f = e.innerRef,
              d = i(e, ["width", "height", "top", "left", "zIndex", "children", "position", "innerRef"]);
            return s.default.createElement("div", a({
              style: u({
                left: o,
                top: n,
                width: t,
                height: r,
                zIndex: l,
                position: h
              }),
              "data-test": "cell-mask",
              ref: f
            }, d), c);
          };
        h.propTypes = {
          width: c.default.number.isRequired,
          height: c.default.number.isRequired,
          top: c.default.number.isRequired,
          left: c.default.number.isRequired,
          zIndex: c.default.number.isRequired,
          children: c.default.node,
          innerRef: c.default.func
        }, t.default = h;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          return t.default = e, t;
        }
        function i(e, t) {
          var r = t.cellNavigationMode,
            n = t.columns,
            i = t.rowsCount,
            a = t.selectedPosition,
            o = a.rowIdx,
            l = a.idx;
          if (r === s.CellNavigationMode.NONE || r === s.CellNavigationMode.CHANGE_ROW) {
            var c = l === n.length - 1,
              u = 0 === l,
              h = o === i - 1,
              f = 0 === o;
            return !0 === e.shiftKey ? u && f : c && h;
          }
          return !1;
        }
        function a(e) {
          return e.topLeft.idx === e.bottomRight.idx && e.topLeft.rowIdx === e.bottomRight.rowIdx;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNextSelectedCellPosition = t.isSelectedCellEditable = t.getSelectedCellValue = t.getSelectedColumn = t.getSelectedRangeDimensions = t.getSelectedDimensions = t.getSelectedRow = void 0;
        var o = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];
            for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
          return e;
        };
        t.canExitGrid = i, t.selectedRangeIsSingleCell = a;
        var s = r(11),
          l = r(5),
          c = r(80),
          u = n(c),
          h = r(6),
          f = n(h),
          d = r(78),
          p = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(d),
          m = function m(e, t) {
            return e * t;
          },
          g = t.getSelectedRow = function (e) {
            var t = e.selectedPosition;
            return (0, e.rowGetter)(t.rowIdx);
          },
          v = (t.getSelectedDimensions = function (e) {
            var t = e.selectedPosition,
              r = e.columns,
              n = e.rowHeight,
              i = t.idx,
              a = t.rowIdx;
            if (i >= 0) {
              var o = f.getColumn(r, i);
              return {
                width: o.width,
                left: o.left,
                top: m(a, n),
                height: n,
                zIndex: f.isFrozen(r) ? p.default.FROZEN_CELL_MASK : p.default.CELL_MASK
              };
            }
            return {
              width: 0,
              left: 0,
              top: 0,
              height: n,
              zIndex: 1
            };
          }, function (e, t, r) {
            for (var n = 0, i = !1, a = e; a <= t; a++) {
              var o = f.getColumn(r, a);
              n += o.width, i = i || f.isFrozen(o);
            }
            return {
              totalWidth: n,
              anyColFrozen: i,
              left: f.getColumn(r, e).left
            };
          }),
          b = (t.getSelectedRangeDimensions = function (e) {
            var t = e.selectedRange,
              r = e.columns,
              n = e.rowHeight,
              i = t.topLeft,
              a = t.bottomRight;
            if (i.idx < 0) return {
              width: 0,
              left: 0,
              top: 0,
              height: n,
              zIndex: p.default.CELL_MASK
            };
            var o = v(i.idx, a.idx, r),
              s = o.totalWidth,
              l = o.anyColFrozen;
            return {
              width: s,
              left: o.left,
              top: m(i.rowIdx, n),
              height: (a.rowIdx - i.rowIdx + 1) * n,
              zIndex: l ? p.default.FROZEN_CELL_MASK : p.default.CELL_MASK
            };
          }, t.getSelectedColumn = function (e) {
            var t = e.selectedPosition,
              r = e.columns,
              n = t.idx;
            return f.getColumn(r, n);
          });
        t.getSelectedCellValue = function (e) {
          var t = e.selectedPosition,
            r = e.columns,
            n = e.rowGetter,
            i = b({
              selectedPosition: t,
              columns: r
            }),
            a = g({
              selectedPosition: t,
              rowGetter: n
            });
          return a && i ? u.get(a, i.key) : null;
        }, t.isSelectedCellEditable = function (e) {
          var t = e.enableCellSelect,
            r = e.selectedPosition,
            n = e.columns,
            i = e.rowGetter,
            a = e.onCheckCellIsEditable,
            s = b({
              selectedPosition: r,
              columns: n
            }),
            c = g({
              selectedPosition: r,
              rowGetter: i
            }),
            u = !(0, l.isFunction)(a) || a(o({
              row: c,
              column: s
            }, r));
          return f.canEdit(s, c, t) && u;
        }, t.getNextSelectedCellPosition = function (e, t) {
          var r = e.cellNavigationMode,
            n = e.columns,
            i = e.rowsCount;
          if (r !== s.CellNavigationMode.NONE) {
            var a = t.idx,
              l = t.rowIdx,
              c = a === n.length,
              u = -1 === a;
            if (c) {
              if (r === s.CellNavigationMode.CHANGE_ROW) {
                var h = l === i - 1;
                if (!h) return {
                  idx: 0,
                  rowIdx: l + 1,
                  changeRowOrColumn: !0
                };
              } else if (r === s.CellNavigationMode.LOOP_OVER_ROW) return {
                rowIdx: l,
                idx: 0,
                changeRowOrColumn: !0
              };
            } else if (u) if (r === s.CellNavigationMode.CHANGE_ROW) {
              var f = 0 === l;
              if (!f) return {
                rowIdx: l - 1,
                idx: n.length - 1,
                changeRowOrColumn: !0
              };
            } else if (r === s.CellNavigationMode.LOOP_OVER_ROW) return {
              rowIdx: l,
              idx: n.length - 1,
              changeRowOrColumn: !0
            };
          }
          return o({}, t, {
            changeRowOrColumn: !1
          });
        };
      },,,,,,,,,, function (e, t, r) {
        var n = r(283);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      },,,,,,,,,, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          s = r(3),
          l = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(s),
          c = r(2);
        r(76);
        var u = function (e) {
          function t() {
            var e, r, a, o;
            n(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.handleChange = function (e) {
              a.props.column.onCellChange(a.props.rowIdx, a.props.column.key, a.props.dependentValues, e);
            }, o = r, i(a, o);
          }
          return a(t, e), o(t, [{
            key: "render",
            value: function value() {
              var e = null != this.props.value && this.props.value,
                t = "checkbox" + this.props.rowIdx;
              return c.createElement("div", {
                className: "react-grid-checkbox-container checkbox-align",
                onClick: this.handleChange
              }, c.createElement("input", {
                className: "react-grid-checkbox",
                type: "checkbox",
                name: t,
                checked: e
              }), c.createElement("label", {
                htmlFor: t,
                className: "react-grid-checkbox-label"
              }));
            }
          }]), t;
        }(c.Component);
        u.propTypes = {
          value: l.default.bool,
          rowIdx: l.default.number,
          column: l.default.shape({
            key: l.default.string,
            onCellChange: l.default.func
          }),
          dependentValues: l.default.object
        }, e.exports = u;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          s = r(2),
          l = r(47),
          c = function (e) {
            function t() {
              var e, r, a, o;
              n(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.setInputRef = function (e) {
                a.input = e;
              }, o = r, i(a, o);
            }
            return a(t, e), o(t, [{
              key: "render",
              value: function value() {
                return s.createElement("input", {
                  ref: this.setInputRef,
                  type: "text",
                  onBlur: this.props.onBlur,
                  className: "form-control",
                  defaultValue: this.props.value
                });
              }
            }]), t;
          }(l);
        e.exports = c;
      },,,,,, function (e, t, r) {
        var n = r(109);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      },, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = {
          CELL_MASK: 5,
          EDITOR_CONTAINER: 10,
          FROZEN_CELL_MASK: 15,
          FROZEN_EDITOR_CONTAINER: 20
        };
      },, function (e, t) {
        "use strict";

        var r = {
          get: function get(e, t) {
            return "function" == typeof e.get ? e.get(t) : e[t];
          },
          isRowSelected: function isRowSelected(e, t, r, n, i) {
            return t && "[object Array]" === Object.prototype.toString.call(t) ? t.indexOf(i) > -1 : e && e.rowKey && e.values && "[object Array]" === Object.prototype.toString.call(e.values) ? e.values.indexOf(n[e.rowKey]) > -1 : !(!r || !n || "string" != typeof r) && n[r];
          }
        };
        e.exports = r;
      }, function (e, t) {
        "use strict";

        function r() {
          if (void 0 === n) {
            var e = document.createElement("div");
            e.style.width = "50px", e.style.height = "50px", e.style.position = "absolute", e.style.top = "-200px", e.style.left = "-200px";
            var t = document.createElement("div");
            t.style.height = "100px", t.style.width = "100%", e.appendChild(t), document.body.appendChild(e);
            var r = e.clientWidth;
            e.style.overflowY = "scroll";
            var i = t.clientWidth;
            document.body.removeChild(e), n = r - i;
          }
          return n;
        }
        var n = void 0;
        e.exports = r;
      },,,,,,,,,,,,,,,,,, function (e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = r(18),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n);
        t.default = {
          ExcelColumn: i.default
        };
      },,,, function (e, t, r) {
        var n = r(108);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      },, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.NONE = "none", t.CHANGE_ROW = "changeRow", t.LOOP_OVER_ROW = "loopOverRow";
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.SELECT_CELL = "SELECT_CELL", t.SELECT_START = "SELECT_START", t.SELECT_UPDATE = "SELECT_UPDATE", t.SELECT_END = "SELECT_END", t.DRAG_ENTER = "DRAG_ENTER", t.SCROLL_TO_COLUMN = "SCROLL_TO_COLUMN";
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.HEADER = "header", t.FILTER = "filter";
      }, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, '.react-grid-Cell{background-color:#fff;padding-left:8px;padding-right:8px;border-right:1px solid #eee;border-bottom:1px solid #ddd}.rdg-selected{border:2px solid #66afe9}.rdg-selected-range{border:1px solid #66afe9;background-color:#66afe930}.moving-element{will-change:transform}.react-grid-Cell--frozen,.react-grid-Cell--frozen:focus{z-index:12}.rdg-last--frozen{border-right:1px solid #ddd;box-shadow:2px 0 5px -2px hsla(0,0%,53%,.3)!important}.react-grid-Cell.has-tooltip:hover{z-index:5}.react-grid-Cell.react-grid-Cell--frozen.has-tooltip:hover{z-index:15}.react-contextmenu--visible{z-index:1000}.react-grid-Cell:not(.editing) .react-grid-Cell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;height:inherit}.react-grid-Cell.readonly{background-color:#000}.react-grid-Cell:hover{background:#eee}.react-grid-cell .form-control-feedback{color:#a94442;position:absolute;top:0;right:10px;z-index:1000000;display:block;width:34px;height:34px}.react-grid-Row.row-selected .react-grid-Cell{background-color:#dbecfa}.react-grid-Cell.editing{padding:0;overflow:visible!important}.react-grid-Cell--frozen.editing{z-index:100}.react-grid-Cell.editing .has-error input{border:2px solid red!important;border-radius:2px!important}.react-grid-Cell__value ul{margin-top:0;margin-bottom:0;display:inline-block}.react-grid-Cell__value .btn-sm{padding:0}.cell-tooltip .cell-tooltip-text{white-space:normal;visibility:hidden;width:150px;background-color:#000;color:#fff;text-align:center;border-radius:6px;padding:5px 0;position:absolute;top:50%;bottom:auto;left:50%;margin-top:15px;margin-left:-75px}.cell-tooltip:hover .cell-tooltip-text{visibility:visible;opacity:.8}.cell-tooltip .cell-tooltip-text:after{content:" ";position:absolute;bottom:100%;left:50%;margin-left:-5px;border-width:5px;border-style:solid;border-color:transparent transparent #000}.react-grid-Canvas.opaque .react-grid-Cell.cell-tooltip:hover .cell-tooltip-text{visibility:hidden}.rdg-cell-expand{float:right;display:table;height:100%}.rdg-cell-expand>span{display:table-cell;vertical-align:middle;cursor:pointer}.rdg-child-row-action-cross-last:before,.rdg-child-row-action-cross:before,rdg-child-row-action-cross-last:after,rdg-child-row-action-cross:after{content:"";position:absolute;background:grey;height:50%}.rdg-child-row-action-cross:before{left:21px;width:1px;height:100%}.rdg-child-row-action-cross-last:before{left:21px;width:1px}.rdg-child-row-action-cross-last:after,.rdg-child-row-action-cross:after{top:50%;left:20px;height:1px;width:15px;content:"";position:absolute;background:grey}.rdg-child-row-action-cross:hover{background:red}.rdg-child-row-btn{position:absolute;cursor:pointer;border:1px solid grey;border-radius:14px;z-index:3;background:#fff}.rdg-child-row-btn div{font-size:12px;text-align:center;line-height:19px;color:grey;height:20px;width:20px;position:absolute;top:60%;left:53%;margin-top:-10px;margin-left:-10px}.rdg-empty-child-row:hover .glyphicon-plus-sign,.rdg-empty-child-row:hover a{color:green}.rdg-child-row-btn .glyphicon-remove-sign:hover{color:red}.last-column .cell-tooltip-text{right:100%;left:0!important}.rdg-cell-action{float:right;height:100%}.rdg-cell-action-last{margin-right:-8px}.rdg-cell-action-button{width:35px;height:100%;text-align:center;position:relative;display:table;color:#4a9de2}.rdg-cell-action-button>span{display:table-cell;vertical-align:middle}.rdg-cell-action-button-toggled,.rdg-cell-action-button:hover{color:#447bbb}.rdg-cell-action-menu{position:absolute;top:100%;z-index:1000;float:left;min-width:160px;padding:5px 0;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;box-shadow:0 0 3px 0 #ccc}.rdg-cell-action-menu>span{display:block;padding:3px 10px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.rdg-cell-action-menu>span:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}', ""]);
      }, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, '.radio-custom,.react-grid-checkbox{opacity:0;position:absolute}.radio-custom,.radio-custom-label,.react-grid-checkbox,.react-grid-checkbox-label{display:inline-block;vertical-align:middle;cursor:pointer}.radio-custom-label,.react-grid-checkbox-label{position:relative}.radio-custom+.radio-custom-label:before,.react-grid-checkbox+.react-grid-checkbox-label:before{content:"";background:#fff;border:2px solid #ddd;display:inline-block;vertical-align:middle;width:20px;height:20px;text-align:center}.react-grid-checkbox:checked+.react-grid-checkbox-label:before{background:#005295;box-shadow:inset 0 0 0 4px #fff}.radio-custom:focus+.radio-custom-label,.react-grid-checkbox:focus+.react-grid-checkbox-label{outline:1px solid #ddd}.react-grid-HeaderCell input[type=checkbox]{z-index:99999}.react-grid-HeaderCell>.react-grid-checkbox-container{padding:0 10px;height:100%}.react-grid-HeaderCell>.react-grid-checkbox-container>.react-grid-checkbox-label{margin:0;position:relative;top:50%;transform:translateY(-50%)}.radio-custom+.radio-custom-label:before{border-radius:50%}.radio-custom:checked+.radio-custom-label:before{background:#ccc;box-shadow:inset 0 0 0 4px #fff}.checkbox-align{text-align:center}', ""]);
      }, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, '.react-grid-Row.row-context-menu .react-grid-Cell,.react-grid-Row:hover .react-grid-Cell{background-color:#f9f9f9}.react-grid-Row:hover .rdg-row-index{display:none}.react-grid-Row:hover .rdg-actions-checkbox{display:block}.react-grid-Row:hover .rdg-drag-row-handle{cursor:move;cursor:grab;cursor:-moz-grab;cursor:-webkit-grab;width:12px;height:30px;margin-left:0;background-image:url("data:image/svg+xml;base64, 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");background-repeat:no-repeat}.react-grid-Row.row-selected,.react-grid-Row .row-selected{background-color:#dbecfa}.react-grid-row-group .row-expand-icon:hover{color:#777}.react-grid-row-index{padding:0 18px}.rdg-row-index{display:block;text-align:center}.rdg-row-actions-cell{padding:0}.rdg-actions-checkbox{display:none;text-align:center}.rdg-actions-checkbox.selected{display:block}.rdg-dragging{cursor:-webkit-grabbing;cursor:-moz-grabbing;cursor:grabbing}.rdg-dragged-row{border-bottom:1px solid #000}.rdg-scrolling{pointer-events:none}', ""]);
      }, function (e, t) {
        "use strict";

        var r = function r(e) {
          var t,
            r = {};
          if (!(e instanceof Object) || Array.isArray(e)) throw new Error("keyMirror(...): Argument must be an object.");
          for (t in e) e.hasOwnProperty(t) && (r[t] = t);
          return r;
        };
        e.exports = r;
      },,,,,,, function (e, t, r) {
        "use strict";

        function n() {}
        var i = r(119);
        e.exports = function () {
          function e(e, t, r, n, a, o) {
            if (o !== i) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var r = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t
          };
          return r.checkPropTypes = n, r.PropTypes = r, r;
        };
      }, function (e, t) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },,,,, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          s = r(3),
          l = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(s),
          c = r(2),
          u = r(4),
          h = {
            ASC: "ASC",
            DESC: "DESC",
            NONE: "NONE"
          },
          f = function (e) {
            function t() {
              var e, r, a, o;
              n(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.onClick = function () {
                var e = void 0,
                  t = a.props,
                  r = t.sortDirection,
                  n = t.sortDescendingFirst;
                switch (r) {
                  default:
                  case null:
                  case void 0:
                  case h.NONE:
                    e = n ? h.DESC : h.ASC;
                    break;
                  case h.ASC:
                    e = n ? h.NONE : h.DESC;
                    break;
                  case h.DESC:
                    e = n ? h.ASC : h.NONE;
                }
                a.props.onSort(a.props.columnKey, e);
              }, a.getSortByText = function () {
                var e = {
                  ASC: "9650",
                  DESC: "9660"
                };
                return "NONE" === a.props.sortDirection ? "" : String.fromCharCode(e[a.props.sortDirection]);
              }, o = r, i(a, o);
            }
            return a(t, e), o(t, [{
              key: "render",
              value: function value() {
                var e = u({
                    "react-grid-HeaderCell-sortable": !0,
                    "react-grid-HeaderCell-sortable--ascending": "ASC" === this.props.sortDirection,
                    "react-grid-HeaderCell-sortable--descending": "DESC" === this.props.sortDirection
                  }),
                  t = this.props.headerRenderer ? c.cloneElement(this.props.headerRenderer, this.props) : this.props.column.name;
                return c.createElement("div", {
                  className: e,
                  onClick: this.onClick,
                  style: {
                    cursor: "pointer"
                  }
                }, c.createElement("span", {
                  className: "pull-right"
                }, this.getSortByText()), t);
              }
            }]), t;
          }(c.Component);
        f.propTypes = {
          columnKey: l.default.string.isRequired,
          column: l.default.shape({
            name: l.default.node
          }),
          onSort: l.default.func.isRequired,
          sortDirection: l.default.oneOf(Object.keys(h)),
          headerRenderer: l.default.node,
          sortDescendingFirst: l.default.bool
        }, e.exports = f, e.exports.DEFINE_SORT = h;
      }, function (e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = r(3),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n),
          a = {
            icon: i.default.oneOfType([i.default.string, i.default.element]).isRequired,
            callback: i.default.func,
            actions: i.default.arrayOf(i.default.shape({
              text: i.default.string,
              callback: i.default.func
            }))
          };
        t.default = a;
      }, function (e, t) {
        "use strict";

        function r(e) {
          return e > 47 && e < 58 || 32 === e || 13 === e || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
        }
        function n(e) {
          return (!0 === e.ctrlKey || !0 === e.metaKey) && "Control" !== e.key;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isKeyPrintable = r, t.isCtrlKeyHeldDown = n;
      },,,,, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(3),
          u = n(c),
          h = r(18),
          f = n(h),
          d = r(5),
          p = r(31),
          m = n(p),
          g = r(254),
          v = n(g),
          b = r(255),
          y = n(b),
          w = r(256),
          x = n(w),
          _ = r(6),
          S = n(_),
          C = r(2),
          E = r(4),
          A = r(137),
          T = r(36);
        r(103);
        var k = ["height", "value"],
          R = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var l = arguments.length, c = Array(l), u = 0; u < l; u++) c[u] = arguments[u];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), n.state = {
                isCellValueChanging: !1,
                isLockChanging: !1
              }, n.onCellClick = function () {
                var e = n.props,
                  t = e.idx,
                  r = e.rowIdx,
                  i = e.cellMetaData;
                (0, d.isFunction)(i.onCellClick) && i.onCellClick({
                  idx: t,
                  rowIdx: r
                });
              }, n.onCellMouseDown = function () {
                var e = n.props,
                  t = e.idx,
                  r = e.rowIdx,
                  i = e.cellMetaData;
                (0, d.isFunction)(i.onCellMouseDown) && i.onCellMouseDown({
                  idx: t,
                  rowIdx: r
                });
              }, n.onCellMouseEnter = function () {
                var e = n.props,
                  t = e.idx,
                  r = e.rowIdx,
                  i = e.cellMetaData;
                (0, d.isFunction)(i.onCellMouseEnter) && i.onCellMouseEnter({
                  idx: t,
                  rowIdx: r
                });
              }, n.onCellContextMenu = function () {
                var e = n.props,
                  t = e.idx,
                  r = e.rowIdx,
                  i = e.cellMetaData;
                (0, d.isFunction)(i.onCellContextMenu) && i.onCellContextMenu({
                  idx: t,
                  rowIdx: r
                });
              }, n.onCellDoubleClick = function (e) {
                e.stopPropagation();
                var t = n.props,
                  r = t.idx,
                  i = t.rowIdx,
                  a = t.cellMetaData;
                (0, d.isFunction)(a.onCellDoubleClick) && a.onCellDoubleClick({
                  idx: r,
                  rowIdx: i
                });
              }, n.onCellExpand = function (e) {
                e.stopPropagation();
                var t = n.props.cellMetaData;
                null != t && null != t.onCellExpand && t.onCellExpand({
                  rowIdx: n.props.rowIdx,
                  idx: n.props.idx,
                  rowData: n.props.rowData,
                  expandArgs: n.props.expandableOptions
                });
              }, n.onCellKeyDown = function (e) {
                n.canExpand() && "Enter" === e.key && n.onCellExpand(e);
              }, n.onDeleteSubRow = function () {
                var e = n.props.cellMetaData;
                null != e && null != e.onDeleteSubRow && e.onDeleteSubRow({
                  rowIdx: n.props.rowIdx,
                  idx: n.props.idx,
                  rowData: n.props.rowData,
                  expandArgs: n.props.expandableOptions
                });
              }, n.onDragOver = function (e) {
                e.preventDefault();
              }, n.getStyle = function () {
                return {
                  position: "absolute",
                  width: n.props.column.width,
                  height: n.props.height,
                  left: n.props.column.left
                };
              }, n.getFormatter = function () {
                return n.props.column.formatter;
              }, n.getRowData = function () {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.props;
                return e.rowData.toJSON ? e.rowData.toJSON() : e.rowData;
              }, n.getFormatterDependencies = function () {
                if ("function" == typeof n.props.column.getRowMetaData) return n.props.column.getRowMetaData(n.getRowData(), n.props.column);
              }, n.getCellClass = function () {
                var e = n.props,
                  t = e.idx,
                  r = e.lastFrozenColumnIndex,
                  i = E(n.props.column.cellClass, "react-grid-Cell", n.props.className, S.default.isFrozen(n.props.column) ? "react-grid-Cell--frozen" : null, r === t ? "rdg-last--frozen" : null),
                  a = E({
                    "row-selected": n.props.isRowSelected,
                    editing: n.isEditorEnabled(),
                    "has-tooltip": !!n.props.tooltip,
                    "rdg-child-cell": n.props.expandableOptions && n.props.expandableOptions.subRowDetails && n.props.expandableOptions.treeDepth > 0,
                    "last-column": n.props.column.isLastColumn
                  });
                return E(i, a);
              }, n.getUpdateCellClass = function () {
                return n.props.column.getUpdateCellClass ? n.props.column.getUpdateCellClass(n.props.selectedColumn, n.props.column, n.state.isCellValueChanging) : "";
              }, n.isEditorEnabled = function () {
                return !0 === n.props.isEditorEnabled;
              }, n.setScrollLeft = function (e) {
                var t = n.node;
                if (t) {
                  var r = "translate3d(" + e + "px, 0px, 0px)";
                  t.style.webkitTransform = r, t.style.transform = r;
                }
              }, n.removeScroll = function () {
                var e = n.node;
                e && (e.style.webkitTransform = null, e.style.transform = null);
              }, n.canExpand = function () {
                return n.props.expandableOptions && n.props.expandableOptions.canExpand;
              }, n.createColumEventCallBack = function (e, t) {
                return function (r) {
                  e(r, t);
                };
              }, n.createCellEventCallBack = function (e, t) {
                return function (r) {
                  e(r), t(r);
                };
              }, n.createEventDTO = function (e, t, r) {
                var i = Object.assign({}, e);
                for (var a in t) if (t.hasOwnProperty(a)) {
                  var o = {
                      idx: n.props.idx,
                      rowIdx: n.props.rowIdx,
                      rowId: n.props.rowData[n.props.cellMetaData.rowKey],
                      name: a
                    },
                    s = n.createColumEventCallBack(r, o);
                  if (i.hasOwnProperty(a)) {
                    var l = i[a];
                    i[a] = n.createCellEventCallBack(l, s);
                  } else i[a] = s;
                }
                return i;
              }, n.getEvents = function () {
                var e = n.props.column ? Object.assign({}, n.props.column.events) : void 0,
                  t = n.props.cellMetaData ? n.props.cellMetaData.onColumnEvent : void 0,
                  r = {
                    onClick: n.onCellClick,
                    onMouseDown: n.onCellMouseDown,
                    onMouseEnter: n.onCellMouseEnter,
                    onDoubleClick: n.onCellDoubleClick,
                    onContextMenu: n.onCellContextMenu,
                    onDragOver: n.onDragOver
                  };
                return e && t ? n.createEventDTO(r, e, t) : r;
              }, n.getKnownDivProps = function () {
                return T(n.props, k);
              }, n.setCellRef = function (e) {
                n.node = e;
              }, n.renderCellContent = function (e) {
                var t = void 0,
                  r = n.getFormatter();
                t = C.isValidElement(r) ? C.cloneElement(r, s({}, e, {
                  dependentValues: n.getFormatterDependencies(),
                  row: n.getRowData()
                })) : (0, d.isFunction)(r) ? C.createElement(r, {
                  value: n.props.value,
                  dependentValues: n.getFormatterDependencies(),
                  isScrolling: n.props.isScrolling,
                  row: n.getRowData()
                }) : C.createElement(A, {
                  value: n.props.value
                });
                var i = !!n.props.expandableOptions && n.props.expandableOptions.field === n.props.column.key,
                  a = n.props.expandableOptions ? n.props.expandableOptions.treeDepth : 0,
                  o = n.props.expandableOptions && i ? 30 * n.props.expandableOptions.treeDepth : 0,
                  l = void 0,
                  c = !!n.props.cellMetaData.onDeleteSubRow;
                a > 0 && i && (l = C.createElement(x.default, {
                  treeDepth: a,
                  cellHeight: n.props.height,
                  siblingIndex: n.props.expandableOptions.subRowDetails.siblingIndex,
                  numberSiblings: n.props.expandableOptions.subRowDetails.numberSiblings,
                  onDeleteSubRow: n.onDeleteSubRow,
                  isDeleteSubRowEnabled: c
                }));
                var u = n.props.tooltip && C.createElement("span", {
                    className: "cell-tooltip-text"
                  }, n.props.tooltip),
                  h = E("react-grid-Cell__value", {
                    "cell-tooltip": !!n.props.tooltip
                  });
                return C.createElement("div", {
                  className: h
                }, l, C.createElement("div", {
                  style: {
                    marginLeft: o,
                    position: "relative",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }
                }, C.createElement("span", null, t), n.props.cellControls), u);
              }, o = r, a(n, o);
            }
            return o(t, e), l(t, [{
              key: "componentWillReceiveProps",
              value: function value(e) {
                this.setState({
                  isCellValueChanging: this.props.isCellValueChanging(this.props.value, e.value),
                  isLockChanging: S.default.isFrozen(this.props.column) !== S.default.isFrozen(e.column)
                });
              }
            }, {
              key: "componentDidMount",
              value: function value() {
                this.checkScroll();
              }
            }, {
              key: "componentDidUpdate",
              value: function value() {
                this.state.isLockChanging && !S.default.isFrozen(this.props.column) && this.removeScroll();
              }
            }, {
              key: "checkScroll",
              value: function value() {
                var e = this.props,
                  t = e.scrollLeft,
                  r = e.column,
                  n = this.node;
                S.default.isFrozen(r) && n && null != n.style.transform && this.setScrollLeft(t);
              }
            }, {
              key: "getCellActions",
              value: function value() {
                var e = this.props,
                  t = e.cellMetaData,
                  r = e.column,
                  n = e.rowData;
                if (t && t.getCellActions) {
                  var i = t.getCellActions(r, n);
                  return i && i.length ? i.map(function (e, t) {
                    return C.createElement(v.default, {
                      key: t,
                      action: e,
                      isFirst: 0 === t
                    });
                  }) : null;
                }
                return null;
              }
            }, {
              key: "render",
              value: function value() {
                if (this.props.column.hidden) return null;
                var e = this.getStyle(),
                  t = this.getCellClass(),
                  r = this.getCellActions(),
                  n = this.props,
                  i = n.value,
                  a = n.column,
                  o = n.rowIdx,
                  l = n.isExpanded,
                  c = n.isScrolling,
                  u = this.props.children || this.renderCellContent({
                    value: i,
                    column: a,
                    rowIdx: o,
                    isExpanded: l,
                    isScrolling: c
                  }),
                  h = this.getEvents(),
                  f = this.canExpand() && C.createElement(y.default, {
                    expandableOptions: this.props.expandableOptions,
                    onCellExpand: this.onCellExpand
                  });
                return C.createElement("div", s({}, this.getKnownDivProps(), {
                  className: t,
                  style: e
                }, h, {
                  ref: this.setCellRef
                }), r, f, u);
              }
            }]), t;
          }(C.PureComponent);
        R.propTypes = {
          rowIdx: u.default.number.isRequired,
          idx: u.default.number.isRequired,
          isSelected: u.default.bool,
          wasPreviouslySelected: u.default.bool,
          isEditorEnabled: u.default.bool,
          selectedColumn: u.default.object,
          height: u.default.number,
          column: u.default.shape(f.default).isRequired,
          value: u.default.oneOfType([u.default.string, u.default.number, u.default.object, u.default.bool]),
          isExpanded: u.default.bool,
          isRowSelected: u.default.bool,
          cellMetaData: u.default.shape(m.default).isRequired,
          handleDragStart: u.default.func,
          className: u.default.string,
          cellControls: u.default.any,
          rowData: u.default.object.isRequired,
          forceUpdate: u.default.bool,
          expandableOptions: u.default.object.isRequired,
          tooltip: u.default.string,
          isScrolling: u.default.bool,
          isCellValueChanging: u.default.func,
          children: u.default.oneOfType([u.default.arrayOf(u.default.node), u.default.node]),
          scrollLeft: u.default.number.isRequired
        }, R.defaultProps = {
          isExpanded: !1,
          value: "",
          isCellValueChanging: function isCellValueChanging(e, t) {
            return e !== t;
          }
        }, t.default = R;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          return e.map(function (e) {
            var r = Object.assign({}, e);
            return e.width && /^([0-9]+)%$/.exec(e.width.toString()) && (r.width = Math.floor(e.width / 100 * t)), r;
          });
        }
        function i(e, t, r) {
          var n = e.filter(function (e) {
            return !e.width;
          });
          return e.map(function (e) {
            if (!e.width && 0 !== e.width) if (t <= 0) e.width = r;else {
              var i = Math.floor(t / p.getSize(n));
              e.width = i < r ? r : i;
            }
            return e;
          });
        }
        function a(e) {
          var t = 0;
          return e.map(function (e) {
            return e.left = t, t += e.width, e;
          });
        }
        function o(e) {
          var t = n(e.columns, e.totalWidth),
            r = t.filter(function (e) {
              return e.width;
            }).reduce(function (e, t) {
              return e - t.width;
            }, e.totalWidth);
          r -= m();
          var o = t.filter(function (e) {
            return e.width;
          }).reduce(function (e, t) {
            return e + t.width;
          }, 0);
          t = i(t, r, e.minColumnWidth), t = a(t);
          var s = t.filter(function (e) {
              return p.isFrozen(e);
            }),
            l = t.filter(function (e) {
              return !p.isFrozen(e);
            });
          return t = s.concat(l).map(function (e, t) {
            return e.idx = t, e;
          }), {
            columns: t,
            width: o,
            totalWidth: e.totalWidth,
            totalColumnWidth: g(t),
            minColumnWidth: e.minColumnWidth
          };
        }
        function s(e, t, r) {
          var n = p.getColumn(e.columns, t),
            i = f(e);
          i.columns = e.columns.slice(0);
          var a = f(n);
          return a.width = Math.max(r, i.minColumnWidth), i = p.spliceColumn(i, t, a), o(i);
        }
        function l(e, t) {
          return (0, h.isColumnsImmutable)(e) && (0, h.isColumnsImmutable)(t);
        }
        function c(e, t, r) {
          var n = void 0,
            i = void 0,
            a = void 0,
            o = {},
            s = {};
          if (p.getSize(e) !== p.getSize(t)) return !1;
          for (n = 0, i = p.getSize(e); n < i; n++) a = e[n], o[a.key] = a;
          for (n = 0, i = p.getSize(t); n < i; n++) {
            a = t[n], s[a.key] = a;
            var l = o[a.key];
            if (void 0 === l || !r(l, a)) return !1;
          }
          for (n = 0, i = p.getSize(e); n < i; n++) {
            a = e[n];
            if (void 0 === s[a.key]) return !1;
          }
          return !0;
        }
        function u(e, t, r) {
          return l(e, t) ? e === t : c(e, t, r);
        }
        var h = r(5),
          f = r(139),
          d = r(257),
          p = r(6),
          m = r(81),
          g = function g(e) {
            return e.reduce(function (e, t) {
              return e + t.width;
            }, 0);
          };
        e.exports = {
          recalculate: o,
          resizeColumn: s,
          sameColumn: d,
          sameColumns: u
        };
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        function s(e) {
          var t = "header" === e.column.rowType ? e.column.name : "";
          return u.default.createElement("div", {
            className: "widget-HeaderCell__value"
          }, t);
        }
        var l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(2),
          u = n(c),
          h = r(13),
          f = n(h),
          d = r(3),
          p = n(d),
          m = r(4),
          g = n(m),
          v = r(18),
          b = n(v),
          y = r(6),
          w = n(y),
          x = r(11),
          _ = r(265);
        r(40);
        var S = function (e) {
          function t() {
            var e, r, n, o;
            i(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
              resizing: !1
            }, n.headerCellRef = function (e) {
              return n.headerCell = e;
            }, n.onDragStart = function (e) {
              n.setState({
                resizing: !0
              }), e && e.dataTransfer && e.dataTransfer.setData && e.dataTransfer.setData("text/plain", "dummy");
            }, n.onDrag = function (e) {
              var t = n.props.onResize || null;
              if (t) {
                var r = n.getWidthFromMouseEvent(e);
                r > 0 && t(n.props.column, r);
              }
            }, n.onDragEnd = function (e) {
              var t = n.getWidthFromMouseEvent(e);
              n.props.onResizeEnd(n.props.column, t), n.setState({
                resizing: !1
              });
            }, n.getWidthFromMouseEvent = function (e) {
              return (e.pageX || e.touches && e.touches[0] && e.touches[0].pageX || e.changedTouches && e.changedTouches[e.changedTouches.length - 1].pageX) - (n.headerCell ? n.headerCell.getBoundingClientRect().left : 0);
            }, n.getCell = function () {
              var e = n.props,
                t = e.height,
                r = e.column,
                i = e.renderer;
              return u.default.isValidElement(i) ? "string" == typeof n.props.renderer.type ? u.default.cloneElement(i, {
                height: t
              }) : u.default.cloneElement(i, {
                column: r,
                height: t
              }) : n.props.renderer({
                column: r
              });
            }, n.getStyle = function () {
              return {
                width: n.props.column.width,
                left: n.props.column.left,
                display: "inline-block",
                position: "absolute",
                height: n.props.height,
                margin: 0,
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              };
            }, n.setScrollLeft = function (e) {
              var t = f.default.findDOMNode(n);
              t && (t.style.webkitTransform = "translate3d(" + e + "px, 0px, 0px)", t.style.transform = "translate3d(" + e + "px, 0px, 0px)");
            }, n.removeScroll = function () {
              var e = f.default.findDOMNode(n);
              if (e) {
                e.style.webkitTransform = "none", e.style.transform = "none";
              }
            }, o = r, a(n, o);
          }
          return o(t, e), l(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.column,
                r = e.rowType,
                n = t.resizable && u.default.createElement(_, {
                  onDrag: this.onDrag,
                  onDragStart: this.onDragStart,
                  onDragEnd: this.onDragEnd
                }),
                i = (0, g.default)({
                  "react-grid-HeaderCell": !0,
                  "react-grid-HeaderCell--resizing": this.state.resizing,
                  "react-grid-HeaderCell--frozen": w.default.isFrozen(t)
                }, this.props.className, t.cellClass),
                a = u.default.createElement("div", {
                  ref: this.headerCellRef,
                  className: i,
                  style: this.getStyle()
                }, this.getCell(), n);
              if (r === x.HeaderRowType.HEADER && t.draggable) {
                var o = this.props.draggableHeaderCell;
                return u.default.createElement(o, {
                  column: t,
                  onHeaderDrop: this.props.onHeaderDrop
                }, a);
              }
              return a;
            }
          }]), t;
        }(u.default.Component);
        S.propTypes = {
          renderer: p.default.oneOfType([p.default.func, p.default.element]).isRequired,
          column: p.default.shape(b.default).isRequired,
          rowType: p.default.string.isRequired,
          height: p.default.number.isRequired,
          onResize: p.default.func.isRequired,
          onResizeEnd: p.default.func.isRequired,
          onHeaderDrop: p.default.func,
          draggableHeaderCell: p.default.element,
          className: p.default.string
        }, S.defaultProps = {
          renderer: s
        }, e.exports = S;
      }, function (e, t) {
        "use strict";

        e.exports = {
          Backspace: 8,
          Tab: 9,
          Enter: 13,
          Shift: 16,
          Ctrl: 17,
          Alt: 18,
          PauseBreak: 19,
          CapsLock: 20,
          Escape: 27,
          PageUp: 33,
          PageDown: 34,
          End: 35,
          Home: 36,
          LeftArrow: 37,
          UpArrow: 38,
          RightArrow: 39,
          DownArrow: 40,
          Insert: 45,
          Delete: 46,
          0: 48,
          1: 49,
          2: 50,
          3: 51,
          4: 52,
          5: 53,
          6: 54,
          7: 55,
          8: 56,
          9: 57,
          a: 65,
          b: 66,
          c: 67,
          d: 68,
          e: 69,
          f: 70,
          g: 71,
          h: 72,
          i: 73,
          j: 74,
          k: 75,
          l: 76,
          m: 77,
          n: 78,
          o: 79,
          p: 80,
          q: 81,
          r: 82,
          s: 83,
          t: 84,
          u: 85,
          v: 86,
          w: 87,
          x: 88,
          y: 89,
          z: 90,
          LeftWindowKey: 91,
          RightWindowKey: 92,
          SelectKey: 93,
          NumPad0: 96,
          NumPad1: 97,
          NumPad2: 98,
          NumPad3: 99,
          NumPad4: 100,
          NumPad5: 101,
          NumPad6: 102,
          NumPad7: 103,
          NumPad8: 104,
          NumPad9: 105,
          Multiply: 106,
          Add: 107,
          Subtract: 109,
          DecimalPoint: 110,
          Divide: 111,
          F1: 112,
          F2: 113,
          F3: 114,
          F4: 115,
          F5: 116,
          F6: 117,
          F7: 118,
          F8: 119,
          F9: 120,
          F10: 121,
          F12: 123,
          NumLock: 144,
          ScrollLock: 145,
          SemiColon: 186,
          EqualSign: 187,
          Comma: 188,
          Dash: 189,
          Period: 190,
          ForwardSlash: 191,
          GraveAccent: 192,
          OpenBracket: 219,
          BackSlash: 220,
          CloseBracket: 221,
          SingleQuote: 222
        };
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(44),
          u = n(c),
          h = r(2),
          f = n(h),
          d = r(3),
          p = n(d),
          m = r(4),
          g = n(m),
          v = r(131),
          b = n(v),
          y = r(31),
          w = n(y),
          x = r(36),
          _ = n(x),
          S = r(6),
          C = n(S);
        r(45);
        var E = ["height"],
          A = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var l = arguments.length, c = Array(l), u = 0; u < l; u++) c[u] = arguments[u];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), n.handleDragEnter = function (e) {
                e.preventDefault();
                var t = n.props,
                  r = t.idx;
                (0, t.cellMetaData.onDragEnter)({
                  overRowIdx: r
                });
              }, n.handleDragOver = function (e) {
                e.preventDefault(), e.dataTransfer.dropEffect = "copy";
              }, n.handleDrop = function (e) {
                e.preventDefault();
              }, n.getCell = function (e) {
                var t = n.props.cellRenderer,
                  r = n.props,
                  i = r.idx,
                  a = r.cellMetaData,
                  o = r.isScrolling,
                  l = r.row,
                  c = r.isSelected,
                  u = r.scrollLeft,
                  h = r.lastFrozenColumnIndex,
                  d = e.key,
                  p = e.formatter,
                  m = {
                    key: d + "-" + i,
                    idx: e.idx,
                    rowIdx: i,
                    height: n.getRowHeight(),
                    column: e,
                    cellMetaData: a
                  },
                  g = {
                    ref: function ref(e) {
                      n[d] = e;
                    },
                    value: n.getCellValue(d || e.idx),
                    rowData: l,
                    isRowSelected: c,
                    expandableOptions: n.getExpandableOptions(d),
                    formatter: p,
                    isScrolling: o,
                    scrollLeft: u,
                    lastFrozenColumnIndex: h
                  };
                return f.default.createElement(t, s({}, m, g));
              }, n.getCells = function () {
                var e = n.props,
                  t = e.colOverscanStartIdx,
                  r = e.colOverscanEndIdx,
                  i = e.columns,
                  a = i.filter(function (e) {
                    return C.default.isFrozen(e);
                  });
                return i.slice(t, r + 1).filter(function (e) {
                  return !C.default.isFrozen(e);
                }).concat(a).map(function (e) {
                  return n.getCell(e);
                });
              }, n.getRowHeight = function () {
                var e = n.props.expandedRows || null;
                if (e && n.props.idx) {
                  var t = e[n.props.idx] || null;
                  if (t) return t.height;
                }
                return n.props.height;
              }, n.getCellValue = function (e) {
                return "select-row" === e ? n.props.isSelected : "function" == typeof n.props.row.get ? n.props.row.get(e) : n.props.row[e];
              }, n.getExpandableOptions = function (e) {
                var t = n.props.subRowDetails;
                return t ? {
                  canExpand: t && t.field === e && (t.children && t.children.length > 0 || !0 === t.group),
                  field: t.field,
                  expanded: t && t.expanded,
                  children: t && t.children,
                  treeDepth: t ? t.treeDepth : 0,
                  subRowDetails: t
                } : {};
              }, n.setScrollLeft = function (e) {
                n.props.columns.forEach(function (t) {
                  if (C.default.isFrozen(t)) {
                    if (!n[t.key]) return;
                    n[t.key].setScrollLeft(e);
                  }
                });
              }, n.getKnownDivProps = function () {
                return (0, _.default)(n.props, E);
              }, o = r, a(n, o);
            }
            return o(t, e), l(t, [{
              key: "shouldComponentUpdate",
              value: function value(e) {
                return (0, u.default)(e, this.props);
              }
            }, {
              key: "render",
              value: function value() {
                var e = (0, g.default)("react-grid-Row", "react-grid-Row--" + (this.props.idx % 2 == 0 ? "even" : "odd"), {
                    "row-selected": this.props.isSelected
                  }, this.props.extraClasses, {
                    "rdg-scrolling": this.props.isScrolling
                  }),
                  t = {
                    height: this.getRowHeight(this.props),
                    overflow: "hidden"
                  },
                  r = this.getCells();
                return f.default.createElement("div", s({}, this.getKnownDivProps(), {
                  className: e,
                  style: t,
                  onDragEnter: this.handleDragEnter,
                  onDragOver: this.handleDragOver,
                  onDrop: this.handleDrop
                }), f.default.isValidElement(this.props.row) ? this.props.row : r);
              }
            }]), t;
          }(f.default.Component);
        A.displayName = "Row", A.propTypes = {
          height: p.default.number.isRequired,
          columns: p.default.oneOfType([p.default.object, p.default.array]).isRequired,
          row: p.default.any.isRequired,
          cellRenderer: p.default.func,
          cellMetaData: p.default.shape(w.default),
          isSelected: p.default.bool,
          idx: p.default.number.isRequired,
          expandedRows: p.default.arrayOf(p.default.object),
          extraClasses: p.default.string,
          forceUpdate: p.default.bool,
          subRowDetails: p.default.object,
          isRowHovered: p.default.bool,
          colVisibleStartIdx: p.default.number.isRequired,
          colVisibleEndIdx: p.default.number.isRequired,
          colOverscanStartIdx: p.default.number.isRequired,
          colOverscanEndIdx: p.default.number.isRequired,
          isScrolling: p.default.bool.isRequired,
          scrollLeft: p.default.number,
          lastFrozenColumnIndex: p.default.number
        }, A.defaultProps = {
          cellRenderer: b.default,
          isSelected: !1,
          height: 35
        }, e.exports = A;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = r(2),
          a = n(i),
          o = r(3),
          s = n(o),
          l = function l(e) {
            return a.default.createElement("div", {
              className: "react-grid-checkbox-container checkbox-align"
            }, a.default.createElement("input", {
              className: "react-grid-checkbox",
              type: "checkbox",
              name: "select-all-checkbox",
              id: "select-all-checkbox",
              ref: e.inputRef,
              onChange: e.onChange
            }), a.default.createElement("label", {
              htmlFor: "select-all-checkbox",
              className: "react-grid-checkbox-label"
            }));
          };
        l.propTypes = {
          onChange: s.default.func,
          inputRef: s.default.func
        }, t.default = l;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          s = r(3),
          l = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(s),
          c = r(2),
          u = function (e) {
            function t() {
              return n(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }
            return a(t, e), o(t, [{
              key: "shouldComponentUpdate",
              value: function value(e) {
                return e.value !== this.props.value;
              }
            }, {
              key: "render",
              value: function value() {
                return c.createElement("div", {
                  title: this.props.value
                }, this.props.value);
              }
            }]), t;
          }(c.Component);
        u.propTypes = {
          value: l.default.oneOfType([l.default.string, l.default.number, l.default.object, l.default.bool])
        }, e.exports = u;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.InteractionMasks = t.EventBus = void 0;
        var i = r(275),
          a = n(i),
          o = r(276),
          s = n(o);
        t.EventBus = a.default, t.InteractionMasks = s.default;
      }, function (e, t) {
        "use strict";

        function r(e) {
          var t = {};
          for (var r in e) e.hasOwnProperty(r) && (t[r] = e[r]);
          return t;
        }
        e.exports = r;
      },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(2),
          c = n(l),
          u = r(18),
          h = n(u),
          f = r(3),
          d = n(f),
          p = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var s = arguments.length, l = Array(s), u = 0; u < s; u++) l[u] = arguments[u];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
                filterTerm: ""
              }, n.handleChange = function (e) {
                var t = e.target.value;
                n.setState({
                  filterTerm: t
                }), n.props.onChange({
                  filterTerm: t,
                  column: n.props.column
                });
              }, n.renderInput = function () {
                if (!1 === n.props.column.filterable) return c.default.createElement("span", null);
                var e = "header-filter-" + n.props.column.key;
                return c.default.createElement("input", {
                  key: e,
                  type: "text",
                  className: "form-control input-sm",
                  placeholder: "Search",
                  value: n.state.filterTerm,
                  onChange: n.handleChange
                });
              }, o = r, a(n, o);
            }
            return o(t, e), s(t, [{
              key: "render",
              value: function value() {
                return c.default.createElement("div", null, c.default.createElement("div", {
                  className: "form-group"
                }, this.renderInput()));
              }
            }]), t;
          }(c.default.Component);
        p.propTypes = {
          onChange: d.default.func.isRequired,
          column: d.default.shape(h.default)
        }, e.exports = p;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(2),
          u = n(c),
          h = r(3),
          f = n(h),
          d = r(4),
          p = n(d),
          m = r(70),
          g = n(m),
          v = r(5),
          b = r(126),
          y = r(78),
          w = n(y);
        r(59);
        var x = function x(e) {
            return !0 === e.frozen || !0 === e.locked;
          },
          _ = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), S.call(n), o = r, a(n, o);
            }
            return o(t, e), l(t, [{
              key: "componentDidMount",
              value: function value() {
                var e = this.getInputNode();
                void 0 !== e && (this.setTextInputFocus(), this.getEditor().disableContainerStyles || (e.className += " editor-main", e.style.height = this.props.height - 1 + "px")), window.addEventListener("scroll", this.setContainerPosition);
              }
            }, {
              key: "componentDidUpdate",
              value: function value(e) {
                e.scrollLeft === this.props.scrollLeft && e.scrollTop === this.props.scrollTop || this.commitCancel();
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this.changeCommitted || this.changeCanceled || this.commit({
                  key: "Enter"
                }), window.removeEventListener("scroll", this.setContainerPosition);
              }
            }, {
              key: "render",
              value: function value() {
                var e = this.props,
                  t = e.width,
                  r = e.height,
                  n = e.column,
                  i = x(n) ? w.default.FROZEN_EDITOR_CONTAINER : w.default.EDITOR_CONTAINER,
                  a = {
                    position: "fixed",
                    height: r,
                    width: t,
                    zIndex: i,
                    transform: this.calculateTransform()
                  };
                return u.default.createElement("div", {
                  ref: this.setContainerRef,
                  style: a,
                  className: this.getContainerClass(),
                  onBlur: this.handleBlur,
                  onKeyDown: this.onKeyDown,
                  onContextMenu: this.handleRightClick
                }, this.createEditor(), this.renderStatusIcon());
              }
            }]), t;
          }(u.default.Component);
        _.displayName = "EditorContainer", _.propTypes = {
          rowIdx: f.default.number,
          rowData: f.default.object.isRequired,
          value: f.default.oneOfType([f.default.string, f.default.number, f.default.object, f.default.bool]).isRequired,
          column: f.default.object.isRequired,
          height: f.default.number.isRequired,
          onGridKeyDown: f.default.func,
          onCommit: f.default.func,
          onCommitCancel: f.default.func,
          firstEditorKeyPress: f.default.string,
          width: f.default.number,
          top: f.default.number,
          left: f.default.number,
          scrollLeft: f.default.number,
          scrollTop: f.default.number
        };
        var S = function S() {
          var e = this;
          this.state = {
            isInvalid: !1
          }, this.changeCommitted = !1, this.changeCanceled = !1, this.setContainerPosition = function () {
            e.container && (e.container.style.transform = e.calculateTransform());
          }, this.calculateTransform = function () {
            var t = e.props,
              r = t.column,
              n = t.left,
              i = t.scrollLeft,
              a = t.top,
              o = t.scrollTop;
            return "translate(" + (x(r) ? n : n - i) + "px, " + (a - o - window.pageYOffset) + "px)";
          }, this.isKeyExplicitlyHandled = function (t) {
            return (0, v.isFunction)(e["onPress" + t]);
          }, this.checkAndCall = function (t, r) {
            (0, v.isFunction)(e[t]) && e[t](r);
          }, this.onKeyDown = function (t) {
            if ((0, b.isCtrlKeyHeldDown)(t)) e.checkAndCall("onPressKeyWithCtrl", t);else if (e.isKeyExplicitlyHandled(t.key)) {
              var r = "onPress" + t.key;
              e.checkAndCall(r, t);
            } else (0, b.isKeyPrintable)(t.keyCode) && (t.stopPropagation(), e.checkAndCall("onPressChar", t));
            e._keysDown = e._keysDown || {}, e._keysDown[t.keyCode] = !0, (0, v.isFunction)(e.props.onGridKeyDown) && e.props.onGridKeyDown(t);
          }, this.setEditorRef = function (t) {
            e.editor = t;
          }, this.setContainerRef = function (t) {
            e.container = t;
          }, this.createEditor = function () {
            var t = {
                ref: e.setEditorRef,
                column: e.props.column,
                value: e.getInitialValue(),
                onCommit: e.commit,
                onCommitCancel: e.commitCancel,
                rowMetaData: e.getRowMetaData(),
                rowData: e.props.rowData,
                height: e.props.height,
                onBlur: e.commit,
                onOverrideKeyDown: e.onKeyDown
              },
              r = e.props.column.editor;
            return u.default.isValidElement(r) ? u.default.cloneElement(r, t) : (0, v.isFunction)(r) ? u.default.createElement(r, s({
              ref: e.setEditorRef
            }, t)) : u.default.createElement(g.default, {
              ref: e.setEditorRef,
              column: e.props.column,
              value: e.getInitialValue(),
              onBlur: e.commit,
              rowMetaData: e.getRowMetaData(),
              onKeyDown: function onKeyDown() {},
              commit: function commit() {}
            });
          }, this.onPressEnter = function () {
            e.commit({
              key: "Enter"
            });
          }, this.onPressTab = function () {
            e.commit({
              key: "Tab"
            });
          }, this.onPressEscape = function (t) {
            e.editorIsSelectOpen() ? t.stopPropagation() : e.commitCancel();
          }, this.onPressArrowDown = function (t) {
            e.editorHasResults() ? t.stopPropagation() : e.commit(t);
          }, this.onPressArrowUp = function (t) {
            e.editorHasResults() ? t.stopPropagation() : e.commit(t);
          }, this.onPressArrowLeft = function (t) {
            e.isCaretAtBeginningOfInput() ? e.commit(t) : t.stopPropagation();
          }, this.onPressArrowRight = function (t) {
            e.isCaretAtEndOfInput() ? e.commit(t) : t.stopPropagation();
          }, this.editorHasResults = function () {
            return !!(0, v.isFunction)(e.getEditor().hasResults) && e.getEditor().hasResults();
          }, this.editorIsSelectOpen = function () {
            return !!(0, v.isFunction)(e.getEditor().isSelectOpen) && e.getEditor().isSelectOpen();
          }, this.getRowMetaData = function () {
            if ("function" == typeof e.props.column.getRowMetaData) return e.props.column.getRowMetaData(e.props.rowData, e.props.column);
          }, this.getEditor = function () {
            return e.editor;
          }, this.getInputNode = function () {
            return e.getEditor().getInputNode();
          }, this.getInitialValue = function () {
            var t = e.props,
              r = t.firstEditorKeyPress,
              n = t.value;
            return "Delete" === r || "Backspace" === r ? "" : "Enter" === r ? n : r || n;
          }, this.getContainerClass = function () {
            return (0, p.default)({
              "rdg-editor-container": !0,
              "has-error": !0 === e.state.isInvalid
            });
          }, this.commit = function (t) {
            var r = e.props.onCommit,
              n = t || {},
              i = e.getEditor().getValue();
            if (e.isNewValueValid(i)) {
              e.changeCommitted = !0;
              r({
                cellKey: e.props.column.key,
                rowIdx: e.props.rowIdx,
                updated: i,
                key: n.key
              });
            }
          }, this.commitCancel = function () {
            e.changeCanceled = !0, e.props.onCommitCancel();
          }, this.isNewValueValid = function (t) {
            if ((0, v.isFunction)(e.getEditor().validate)) {
              var r = e.getEditor().validate(t);
              return e.setState({
                isInvalid: !r
              }), r;
            }
            return !0;
          }, this.setCaretAtEndOfInput = function () {
            var t = e.getInputNode(),
              r = t.value.length;
            if (t.setSelectionRange) t.setSelectionRange(r, r);else if (t.createTextRange) {
              var n = t.createTextRange();
              n.moveStart("character", r), n.collapse(), n.select();
            }
          }, this.isCaretAtBeginningOfInput = function () {
            var t = e.getInputNode();
            return t.selectionStart === t.selectionEnd && 0 === t.selectionStart;
          }, this.isCaretAtEndOfInput = function () {
            var t = e.getInputNode();
            return t.selectionStart === t.value.length;
          }, this.isBodyClicked = function (t) {
            return null === e.getRelatedTarget(t);
          }, this.isViewportClicked = function (t) {
            return e.getRelatedTarget(t).className.indexOf("react-grid-Viewport") > -1;
          }, this.isClickInsideEditor = function (t) {
            var r = e.getRelatedTarget(t);
            return t.currentTarget.contains(r) || r.className.indexOf("editing") > -1 || r.className.indexOf("react-grid-Cell") > -1;
          }, this.getRelatedTarget = function (e) {
            return e.relatedTarget || e.explicitOriginalTarget || document.activeElement;
          }, this.handleRightClick = function (e) {
            e.stopPropagation();
          }, this.handleBlur = function (t) {
            t.stopPropagation(), e.isBodyClicked(t) && e.commit(t), e.isBodyClicked(t) || !e.isViewportClicked(t) && e.isClickInsideEditor(t) || e.commit(t);
          }, this.setTextInputFocus = function () {
            var t = e.props.firstEditorKeyPress,
              r = e.getInputNode();
            r.focus(), "INPUT" === r.tagName && ((0, b.isKeyPrintable)(t) ? r.select() : (r.focus(), r.select()));
          }, this.renderStatusIcon = function () {
            if (!0 === e.state.isInvalid) return u.default.createElement("span", {
              className: "glyphicon glyphicon-remove form-control-feedback"
            });
          };
        };
        e.exports = _;
      },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }
        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function o(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function s(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var l = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          c = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          u = r(2),
          h = n(u),
          f = r(13),
          d = n(f),
          p = r(3),
          m = n(p),
          g = r(135),
          v = n(g),
          b = r(125),
          y = n(b),
          w = r(80),
          x = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(w),
          _ = r(266),
          S = n(_),
          C = r(138),
          E = r(279),
          A = r(5),
          T = r(11);
        r(59);
        var k = function (e) {
          function t() {
            var e, r, n, i;
            a(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = n = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
              scrollingTimeout: null
            }, n.rows = [], n._currentRowsRange = {
              start: 0,
              end: 0
            }, n._scroll = {
              scrollTop: 0,
              scrollLeft: 0
            }, n.onRows = function () {
              n._currentRowsRange !== {
                start: 0,
                end: 0
              } && (n.props.onRows(n._currentRowsRange), n._currentRowsRange = {
                start: 0,
                end: 0
              });
            }, n.scrollToRow = function (e) {
              var t = n.props,
                r = t.rowHeight,
                i = t.rowsCount,
                a = t.height;
              n.canvas.scrollTop = Math.min(e * r, i * r - a);
            }, n.onScroll = function (e) {
              if (n.canvas === e.target) {
                var t = e.target,
                  r = t.scrollLeft,
                  i = t.scrollTop,
                  a = {
                    scrollTop: i,
                    scrollLeft: r
                  };
                n._scroll = a, n.props.onScroll(a);
              }
            }, n.getClientScrollTopOffset = function (e) {
              var t = n.props.rowHeight,
                r = e.scrollTop % t;
              return r > 0 ? t - r : 0;
            }, n.onHitBottomCanvas = function () {
              var e = n.props.rowHeight,
                t = n.canvas;
              t.scrollTop += e + n.getClientScrollTopOffset(t);
            }, n.onHitTopCanvas = function () {
              var e = n.props.rowHeight,
                t = n.canvas;
              t.scrollTop -= e - n.getClientScrollTopOffset(t);
            }, n.scrollToColumn = function (e) {
              var t = n.canvas,
                r = t.scrollLeft,
                i = t.clientWidth,
                a = (0, E.getColumnScrollPosition)(n.props.columns, e, r, i);
              null != a && (n.canvas.scrollLeft = r + a);
            }, n.onHitLeftCanvas = function (e) {
              var t = e.idx;
              n.scrollToColumn(t);
            }, n.onHitRightCanvas = function (e) {
              var t = e.idx;
              n.scrollToColumn(t);
            }, n.getRows = function (e, t) {
              if (n._currentRowsRange = {
                start: e,
                end: t
              }, Array.isArray(n.props.rowGetter)) return n.props.rowGetter.slice(e, t);
              for (var r = [], i = e; i < t;) {
                var a = n.props.rowGetter(i),
                  o = {};
                n.props.getSubRowDetails && (o = n.props.getSubRowDetails(a)), r.push({
                  row: a,
                  subRowDetails: o
                }), i++;
              }
              return r;
            }, n.getScroll = function () {
              var e = n.canvas;
              return {
                scrollTop: e.scrollTop,
                scrollLeft: e.scrollLeft
              };
            }, n.isRowSelected = function (e, t) {
              if (null !== n.props.selectedRows) {
                var r = n.props.selectedRows.filter(function (e) {
                  var r = t.get ? t.get(n.props.rowKey) : t[n.props.rowKey];
                  return e[n.props.rowKey] === r;
                });
                return r.length > 0 && r[0].isSelected;
              }
              if (n.props.rowSelection) {
                var i = n.props.rowSelection,
                  a = i.keys,
                  o = i.indexes,
                  s = i.isSelectedKey;
                return x.isRowSelected(a, o, s, t, e);
              }
              return !1;
            }, n.setScrollLeft = function (e) {
              n.rows.forEach(function (t, r) {
                if (t) {
                  var i = n.getRowByRef(r);
                  i && i.setScrollLeft && i.setScrollLeft(e);
                }
              });
            }, n.getRowByRef = function (e) {
              var t = n.rows[e] && n.rows[e].getDecoratedComponentInstance ? n.rows[e].getDecoratedComponentInstance(e) : null;
              return t ? t.row : n.rows[e];
            }, n.getSelectedRowTop = function (e) {
              var t = n.getRowByRef(e);
              if (t) {
                var r = d.default.findDOMNode(t);
                return r && r.offsetTop;
              }
              return n.props.rowHeight * e;
            }, n.getSelectedRowHeight = function (e) {
              var t = n.getRowByRef(e);
              if (t) {
                var r = d.default.findDOMNode(t);
                return r && r.clientHeight > 0 ? r.clientHeight : n.props.rowHeight;
              }
              return n.props.rowHeight;
            }, n.getSelectedRowColumns = function (e) {
              var t = n.getRowByRef(e);
              return t && t.props ? t.props.columns : n.props.columns;
            }, n.setCanvasRef = function (e) {
              n.canvas = e;
            }, n.setRowRef = function (e) {
              return function (t) {
                n.rows[e] = t;
              };
            }, n.renderRow = function (e) {
              var t = e.row;
              return t.__metaData && t.__metaData.getRowRenderer ? t.__metaData.getRowRenderer(n.props, e.idx) : t.__metaData && t.__metaData.isGroup ? n.renderGroupRow(e) : n.props.rowRenderer ? n.renderCustomRowRenderer(e) : h.default.createElement(v.default, e);
            }, n.renderPlaceholder = function (e, t) {
              return h.default.createElement("div", {
                key: e,
                style: {
                  height: t
                }
              }, n.props.columns.map(function (e, t) {
                return h.default.createElement("div", {
                  style: {
                    width: e.width
                  },
                  key: t
                });
              }));
            }, i = r, o(n, i);
          }
          return s(t, e), c(t, [{
            key: "componentDidMount",
            value: function value() {
              this.unsubscribeScrollToColumn = this.props.eventBus.subscribe(T.EventTypes.SCROLL_TO_COLUMN, this.scrollToColumn), this.onRows();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this._currentRowsRange = {
                start: 0,
                end: 0
              }, this._scroll = {
                scrollTop: 0,
                scrollLeft: 0
              }, this.rows = [], this.unsubscribeScrollToColumn();
            }
          }, {
            key: "componentDidUpdate",
            value: function value(e) {
              var t = this.props.scrollToRowIndex;
              e.scrollToRowIndex !== t && 0 !== t && this.scrollToRow(t), this.onRows();
            }
          }, {
            key: "renderCustomRowRenderer",
            value: function value(e) {
              var t = e.ref,
                r = i(e, ["ref"]),
                n = this.props.rowRenderer,
                a = l({}, r, {
                  renderBaseRow: function renderBaseRow(e) {
                    return h.default.createElement(v.default, l({
                      ref: t
                    }, e));
                  }
                });
              return n.type === v.default ? h.default.createElement(v.default, e) : (0, A.isFunction)(n) ? h.default.createElement(n, a) : h.default.isValidElement(n) ? h.default.cloneElement(n, a) : void 0;
            }
          }, {
            key: "renderGroupRow",
            value: function value(e) {
              var t = e.ref,
                r = i(e, ["ref"]);
              return h.default.createElement(S.default, l({}, r, e.row.__metaData, {
                rowRef: e.ref,
                name: e.row.name,
                eventBus: this.props.eventBus,
                renderer: this.props.rowGroupRenderer,
                renderBaseRow: function renderBaseRow(e) {
                  return h.default.createElement(v.default, l({
                    ref: t
                  }, e));
                }
              }));
            }
          }, {
            key: "render",
            value: function value() {
              var e = this,
                t = this.props,
                r = t.rowOverscanStartIdx,
                n = t.rowOverscanEndIdx,
                i = t.cellMetaData,
                a = t.columns,
                o = t.colOverscanStartIdx,
                s = t.colOverscanEndIdx,
                l = t.colVisibleStartIdx,
                c = t.colVisibleEndIdx,
                u = t.lastFrozenColumnIndex,
                f = t.expandedRows,
                d = t.rowHeight,
                p = t.rowsCount,
                m = t.totalColumnWidth,
                g = t.totalWidth,
                v = t.height,
                b = t.rowGetter,
                y = t.RowsContainer,
                w = t.contextMenu,
                x = this.getRows(r, n).map(function (t, h) {
                  var p = r + h,
                    m = "row-" + p;
                  return e.renderRow({
                    key: m,
                    ref: e.setRowRef(p),
                    idx: p,
                    rowVisibleStartIdx: e.props.rowVisibleStartIdx,
                    rowVisibleEndIdx: e.props.rowVisibleEndIdx,
                    row: t.row,
                    height: d,
                    onMouseOver: e.onMouseOver,
                    columns: a,
                    isSelected: e.isRowSelected(p, t.row, r, n),
                    expandedRows: f,
                    cellMetaData: i,
                    subRowDetails: t.subRowDetails,
                    colVisibleStartIdx: l,
                    colVisibleEndIdx: c,
                    colOverscanStartIdx: o,
                    colOverscanEndIdx: s,
                    lastFrozenColumnIndex: u,
                    isScrolling: e.props.isScrolling,
                    scrollLeft: e._scroll.scrollLeft
                  });
                });
              r > 0 && x.unshift(this.renderPlaceholder("top", r * d)), p - n > 0 && x.push(this.renderPlaceholder("bottom", (p - n) * d));
              var _ = {
                position: "absolute",
                top: 0,
                left: 0,
                overflowX: "auto",
                overflowY: "scroll",
                width: g,
                height: v
              };
              return h.default.createElement("div", {
                ref: this.setCanvasRef,
                style: _,
                onScroll: this.onScroll,
                className: "react-grid-Canvas"
              }, h.default.createElement(C.InteractionMasks, {
                rowGetter: b,
                rowsCount: p,
                width: this.props.totalWidth,
                height: v,
                rowHeight: d,
                columns: a,
                rowOverscanStartIdx: this.props.rowOverscanStartIdx,
                rowVisibleStartIdx: this.props.rowVisibleStartIdx,
                rowVisibleEndIdx: this.props.rowVisibleEndIdx,
                colVisibleStartIdx: l,
                colVisibleEndIdx: c,
                enableCellSelect: this.props.enableCellSelect,
                enableCellAutoFocus: this.props.enableCellAutoFocus,
                cellNavigationMode: this.props.cellNavigationMode,
                eventBus: this.props.eventBus,
                contextMenu: this.props.contextMenu,
                onHitBottomBoundary: this.onHitBottomCanvas,
                onHitTopBoundary: this.onHitTopCanvas,
                onHitLeftBoundary: this.onHitLeftCanvas,
                onHitRightBoundary: this.onHitRightCanvas,
                onCommit: this.props.onCommit,
                onCheckCellIsEditable: this.props.onCheckCellIsEditable,
                onCellCopyPaste: this.props.onCellCopyPaste,
                onGridRowsUpdated: this.props.onGridRowsUpdated,
                onDragHandleDoubleClick: this.props.onDragHandleDoubleClick,
                onCellSelected: this.props.onCellSelected,
                onCellDeSelected: this.props.onCellDeSelected,
                onCellRangeSelectionStarted: this.props.onCellRangeSelectionStarted,
                onCellRangeSelectionUpdated: this.props.onCellRangeSelectionUpdated,
                onCellRangeSelectionCompleted: this.props.onCellRangeSelectionCompleted,
                scrollLeft: this._scroll.scrollLeft,
                scrollTop: this._scroll.scrollTop,
                prevScrollLeft: this.props.prevScrollLeft,
                prevScrollTop: this.props.prevScrollTop,
                getSelectedRowHeight: this.getSelectedRowHeight,
                getSelectedRowTop: this.getSelectedRowTop,
                getSelectedRowColumns: this.getSelectedRowColumns
              }), h.default.createElement(y, {
                id: w ? w.props.id : "rowsContainer"
              }, h.default.createElement("div", {
                style: {
                  width: m
                }
              }, x)));
            }
          }]), t;
        }(h.default.PureComponent);
        k.propTypes = {
          rowRenderer: m.default.oneOfType([m.default.func, m.default.element]),
          rowHeight: m.default.number.isRequired,
          height: m.default.number.isRequired,
          width: m.default.number,
          totalWidth: m.default.oneOfType([m.default.number, m.default.string]),
          style: m.default.string,
          className: m.default.string,
          rowOverscanStartIdx: m.default.number.isRequired,
          rowOverscanEndIdx: m.default.number.isRequired,
          rowVisibleStartIdx: m.default.number.isRequired,
          rowVisibleEndIdx: m.default.number.isRequired,
          colVisibleStartIdx: m.default.number.isRequired,
          colVisibleEndIdx: m.default.number.isRequired,
          colOverscanStartIdx: m.default.number.isRequired,
          colOverscanEndIdx: m.default.number.isRequired,
          rowsCount: m.default.number.isRequired,
          rowGetter: m.default.oneOfType([m.default.func.isRequired, m.default.array.isRequired]),
          expandedRows: m.default.array,
          onRows: m.default.func,
          onScroll: m.default.func,
          columns: m.default.oneOfType([m.default.object, m.default.array]).isRequired,
          cellMetaData: m.default.shape(y.default).isRequired,
          selectedRows: m.default.array,
          rowKey: m.default.string,
          rowScrollTimeout: m.default.number,
          scrollToRowIndex: m.default.number,
          contextMenu: m.default.element,
          getSubRowDetails: m.default.func,
          rowSelection: m.default.oneOfType([m.default.shape({
            indexes: m.default.arrayOf(m.default.number).isRequired
          }), m.default.shape({
            isSelectedKey: m.default.string.isRequired
          }), m.default.shape({
            keys: m.default.shape({
              values: m.default.array.isRequired,
              rowKey: m.default.string.isRequired
            }).isRequired
          })]),
          rowGroupRenderer: m.default.func,
          isScrolling: m.default.bool,
          length: m.default.number,
          enableCellSelect: m.default.bool.isRequired,
          enableCellAutoFocus: m.default.bool.isRequired,
          cellNavigationMode: m.default.string.isRequired,
          eventBus: m.default.object.isRequired,
          onCheckCellIsEditable: m.default.func,
          onCellCopyPaste: m.default.func,
          onGridRowsUpdated: m.default.func.isRequired,
          onDragHandleDoubleClick: m.default.func.isRequired,
          onCellSelected: m.default.func,
          onCellDeSelected: m.default.func,
          onCellRangeSelectionStarted: m.default.func,
          onCellRangeSelectionUpdated: m.default.func,
          onCellRangeSelectionCompleted: m.default.func,
          onCommit: m.default.func.isRequired
        }, k.defaultProps = {
          onRows: function onRows() {},
          selectedRows: [],
          rowScrollTimeout: 0,
          scrollToRowIndex: 0,
          RowsContainer: function RowsContainer(e) {
            return e.children;
          }
        }, e.exports = k;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(4),
          c = n(l),
          u = r(2),
          h = n(u),
          f = r(3),
          d = n(f),
          p = r(125),
          m = n(p),
          g = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = {
                isMenuOpen: !1
              }, n.onToggleMenu = function () {
                n.setState(function (e) {
                  return {
                    isMenuOpen: !e.isMenuOpen
                  };
                });
              }, n.onHideMenu = function () {
                n.setState({
                  isMenuOpen: !1
                });
              }, n.onGetMenuOptions = function () {
                return n.props.action.actions.map(function (e, t) {
                  return h.default.createElement("span", {
                    key: t,
                    onClick: e.callback
                  }, e.text);
                });
              }, n.isActionMenu = function () {
                return !n.props.action.callback && n.props.action.actions && n.props.action.actions.length;
              }, n.onActionButtonBlur = function () {
                n.isActionMenu() && n.onHideMenu();
              }, n.onActionIconClick = function () {
                n.isActionMenu() ? n.props.action.actions && n.props.action.actions.length && n.onToggleMenu() : n.props.action.callback();
              }, o = r, a(n, o);
            }
            return o(t, e), s(t, [{
              key: "render",
              value: function value() {
                var e = this.isActionMenu(),
                  t = (0, c.default)("rdg-cell-action", {
                    "rdg-cell-action-last": this.props.isFirst
                  }),
                  r = (0, c.default)("rdg-cell-action-button", {
                    "rdg-cell-action-button-toggled": this.state.isMenuOpen
                  });
                return h.default.createElement("div", {
                  className: t,
                  onMouseLeave: this.onActionButtonBlur
                }, h.default.createElement("div", {
                  className: r,
                  onClick: this.onActionIconClick
                }, "string" == typeof this.props.action.icon ? h.default.createElement("span", {
                  className: this.props.action.icon
                }) : this.props.action.icon), e && this.state.isMenuOpen && h.default.createElement("div", {
                  className: "rdg-cell-action-menu"
                }, this.onGetMenuOptions()));
              }
            }]), t;
          }(h.default.Component);
        g.propTypes = {
          action: d.default.shape(m.default).isRequired,
          isFirst: d.default.bool.isRequired
        }, t.default = g;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(2),
          c = n(l),
          u = r(3),
          h = n(u),
          f = r(11),
          d = function (e) {
            function t(e) {
              i(this, t);
              var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
              r.onCellExpand = function (e) {
                r.setState({
                  expanded: !r.state.expanded
                }), r.props.onCellExpand(e);
              };
              var n = e.expandableOptions && e.expandableOptions.expanded;
              return r.state = {
                expanded: n
              }, r;
            }
            return o(t, e), s(t, [{
              key: "componentWillReceiveProps",
              value: function value(e) {
                var t = e.expandableOptions && e.expandableOptions.expanded;
                this.state.expanded !== t && this.setState({
                  expanded: t
                });
              }
            }, {
              key: "render",
              value: function value() {
                return c.default.createElement("div", {
                  className: "rdg-cell-expand"
                }, c.default.createElement("span", {
                  onClick: this.onCellExpand
                }, this.state.expanded ? f.CellExpand.DOWN_TRIANGLE : f.CellExpand.RIGHT_TRIANGLE));
              }
            }]), t;
          }(c.default.Component);
        d.propTypes = {
          expandableOptions: h.default.object.isRequired,
          onCellExpand: h.default.func.isRequired
        }, t.default = d;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = r(2),
          a = n(i),
          o = r(4),
          s = n(o),
          l = function l(e) {
            var t = e.treeDepth,
              r = e.cellHeight,
              n = e.siblingIndex,
              i = e.numberSiblings,
              o = e.onDeleteSubRow,
              l = e.isDeleteSubRowEnabled,
              c = e.allowAddChildRow,
              u = void 0 === c || c,
              h = n === i - 1,
              f = (0, s.default)({
                "rdg-child-row-action-cross": !0 === u || !h
              }, {
                "rdg-child-row-action-cross-last": !1 === u && (h || 1 === i)
              }),
              d = 15 * t,
              p = (r - 12) / 2;
            return a.default.createElement("div", null, a.default.createElement("div", {
              className: f
            }), l && a.default.createElement("div", {
              style: {
                left: d,
                top: p,
                width: 12,
                height: 12
              },
              className: "rdg-child-row-btn",
              onClick: o
            }, a.default.createElement("div", {
              className: "glyphicon glyphicon-remove-sign"
            })));
          };
        t.default = l;
      }, function (e, t, r) {
        "use strict";

        var n = r(2).isValidElement;
        e.exports = function (e, t) {
          var r = void 0;
          for (r in e) if (e.hasOwnProperty(r)) {
            if ("function" == typeof e[r] && "function" == typeof t[r] || n(e[r]) && n(t[r])) continue;
            if (!t.hasOwnProperty(r) || e[r] !== t[r]) return !1;
          }
          for (r in t) if (t.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
          return !0;
        };
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(3),
          c = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(l),
          u = r(2),
          h = r(36);
        r(40);
        var f = ["onDragStart", "onDragEnd", "onDrag", "style"],
          d = function (e) {
            function t() {
              var e, r, a, o;
              n(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.state = {
                drag: null
              }, a.onMouseDown = function (e) {
                var t = a.props.onDragStart(e);
                e.preventDefault && e.preventDefault(), null === t && 0 !== e.button || (window.addEventListener("mouseup", a.onMouseUp), window.addEventListener("mousemove", a.onMouseMove), window.addEventListener("touchend", a.onMouseUp), window.addEventListener("touchmove", a.onMouseMove), a.setState({
                  drag: t
                }));
              }, a.onMouseMove = function (e) {
                null !== a.state.drag && (e.preventDefault && e.preventDefault(), a.props.onDrag(e));
              }, a.onMouseUp = function (e) {
                a.cleanUp(), a.props.onDragEnd(e, a.state.drag), a.setState({
                  drag: null
                });
              }, a.cleanUp = function () {
                window.removeEventListener("mouseup", a.onMouseUp), window.removeEventListener("mousemove", a.onMouseMove), window.removeEventListener("touchend", a.onMouseUp), window.removeEventListener("touchmove", a.onMouseMove);
              }, a.getKnownDivProps = function () {
                return h(a.props, f);
              }, o = r, i(a, o);
            }
            return a(t, e), s(t, [{
              key: "componentWillUnmount",
              value: function value() {
                this.cleanUp();
              }
            }, {
              key: "render",
              value: function value() {
                return u.createElement("div", o({}, this.getKnownDivProps(), {
                  onMouseDown: this.onMouseDown,
                  onTouchStart: this.onMouseDown,
                  className: "react-grid-HeaderCell__draggable"
                }));
              }
            }]), t;
          }(u.Component);
        d.propTypes = {
          onDragStart: c.default.func,
          onDragEnd: c.default.func,
          onDrag: c.default.func,
          component: c.default.oneOfType([c.default.func, c.default.constructor]),
          style: c.default.object
        }, d.defaultProps = {
          onDragStart: function onDragStart() {
            return !0;
          },
          onDragEnd: function onDragEnd() {},
          onDrag: function onDrag() {}
        }, e.exports = d;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(2),
          c = n(l),
          u = r(3),
          h = n(u),
          f = r(6),
          d = n(f),
          p = function (e) {
            function t() {
              i(this, t);
              var e = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
              return e.onAddSubRow = e.onAddSubRow.bind(e), e;
            }
            return o(t, e), s(t, [{
              key: "onAddSubRow",
              value: function value() {
                this.props.onAddSubRow(this.props.parentRowId);
              }
            }, {
              key: "getFrozenColumnsWidth",
              value: function value() {
                for (var e = 0, t = d.default.getSize(this.props.columns), r = 0; r < t; r++) {
                  var n = d.default.getColumn(this.props.columns, r);
                  n && d.default.getValue(n, "frozen") && (e += d.default.getValue(n, "width"));
                }
                return e;
              }
            }, {
              key: "render",
              value: function value() {
                var e = this,
                  t = this.props,
                  r = t.cellHeight,
                  n = t.treeDepth,
                  i = 15 * n,
                  a = (r - 12) / 2,
                  o = {
                    height: r,
                    borderBottom: "1px solid #dddddd"
                  },
                  s = d.default.getColumn(this.props.columns.filter(function (t) {
                    return t.key === e.props.expandColumnKey;
                  }), 0),
                  l = s ? s.left : 0;
                return c.default.createElement("div", {
                  className: "react-grid-Row rdg-add-child-row-container",
                  style: o
                }, c.default.createElement("div", {
                  className: "react-grid-Cell",
                  style: {
                    position: "absolute",
                    height: r,
                    width: "100%",
                    left: l
                  }
                }, c.default.createElement("div", {
                  className: "rdg-empty-child-row",
                  style: {
                    marginLeft: "30px",
                    lineHeight: r + "px"
                  }
                }, c.default.createElement("div", {
                  className: "'rdg-child-row-action-cross rdg-child-row-action-cross-last"
                }), c.default.createElement("div", {
                  style: {
                    left: i,
                    top: a,
                    width: 12,
                    height: 12
                  },
                  className: "rdg-child-row-btn",
                  onClick: this.onAddSubRow
                }, c.default.createElement("div", {
                  className: "glyphicon glyphicon-plus-sign"
                })))));
              }
            }]), t;
          }(c.default.Component);
        p.propTypes = {
          treeDepth: h.default.number.isRequired,
          cellHeight: h.default.number.isRequired,
          onAddSubRow: h.default.func.isRequired,
          parentRowId: h.default.number,
          columns: h.default.array.isRequired,
          expandColumnKey: h.default.string.isRequired
        }, t.default = p;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(3),
          u = n(c),
          h = r(31),
          f = n(h),
          d = r(6),
          p = n(d),
          m = r(2),
          g = r(261),
          v = r(267);
        r(59);
        var b = function (e) {
          function t() {
            var e, r, n, o;
            i(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n._scrollLeft = void 0, n.getStyle = function () {
              return {
                overflow: "hidden",
                outline: 0,
                position: "relative",
                minHeight: n.props.minHeight
              };
            }, n._onScroll = function () {
              void 0 !== n._scrollLeft && (n.header.setScrollLeft(n._scrollLeft), n.viewport && n.viewport.setScrollLeft(n._scrollLeft));
            }, n.onScroll = function (e) {
              n.props.onScroll(e);
              var t = e.scrollLeft;
              (n._scrollLeft !== t || n.areFrozenColumnsScrolledLeft(t)) && (n._scrollLeft = t, n._onScroll());
            }, n.setHeaderRef = function (e) {
              n.header = e;
            }, n.setViewportRef = function (e) {
              n.viewport = e;
            }, n.setViewportContainerRef = function (e) {
              n.viewPortContainer = e;
            }, n.setEmptyViewRef = function (e) {
              n.emptyView = e;
            }, o = r, a(n, o);
          }
          return o(t, e), l(t, [{
            key: "areFrozenColumnsScrolledLeft",
            value: function value(e) {
              return e > 0 && this.props.columns.some(function (e) {
                return p.default.isFrozen(e);
              });
            }
          }, {
            key: "componentDidMount",
            value: function value() {
              this._scrollLeft = this.viewport ? this.viewport.getScroll().scrollLeft : 0, this._onScroll();
            }
          }, {
            key: "componentDidUpdate",
            value: function value() {
              this._onScroll();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this._scrollLeft = void 0;
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props.headerRows,
                t = this.props.emptyRowsView;
              return m.createElement("div", {
                style: this.getStyle(),
                className: "react-grid-Grid"
              }, m.createElement(g, {
                ref: this.setHeaderRef,
                columnMetrics: this.props.columnMetrics,
                onColumnResize: this.props.onColumnResize,
                height: this.props.rowHeight,
                totalWidth: this.props.totalWidth,
                headerRows: e,
                sortColumn: this.props.sortColumn,
                sortDirection: this.props.sortDirection,
                draggableHeaderCell: this.props.draggableHeaderCell,
                onSort: this.props.onSort,
                onHeaderDrop: this.props.onHeaderDrop,
                getValidFilterValues: this.props.getValidFilterValues,
                cellMetaData: this.props.cellMetaData
              }), this.props.rowsCount >= 1 || 0 === this.props.rowsCount && !this.props.emptyRowsView ? m.createElement("div", {
                ref: this.setViewportContainerRef,
                onKeyDown: this.props.onViewportKeydown,
                onKeyUp: this.props.onViewportKeyup
              }, m.createElement(v, s({}, this.props, {
                ref: this.setViewportRef,
                rowKey: this.props.rowKey,
                width: this.props.columnMetrics.width,
                rowHeight: this.props.rowHeight,
                rowRenderer: this.props.rowRenderer,
                rowGetter: this.props.rowGetter,
                rowsCount: this.props.rowsCount,
                selectedRows: this.props.selectedRows,
                expandedRows: this.props.expandedRows,
                columnMetrics: this.props.columnMetrics,
                totalWidth: this.props.totalWidth,
                onScroll: this.onScroll,
                onRows: this.props.onRows,
                cellMetaData: this.props.cellMetaData,
                rowOffsetHeight: this.props.rowOffsetHeight || this.props.rowHeight * e.length,
                minHeight: this.props.minHeight,
                rowScrollTimeout: this.props.rowScrollTimeout,
                scrollToRowIndex: this.props.scrollToRowIndex,
                contextMenu: this.props.contextMenu,
                rowSelection: this.props.rowSelection,
                getSubRowDetails: this.props.getSubRowDetails,
                rowGroupRenderer: this.props.rowGroupRenderer,
                overScan: this.props.overScan,
                enableCellSelect: this.props.enableCellSelect,
                enableCellAutoFocus: this.props.enableCellAutoFocus,
                cellNavigationMode: this.props.cellNavigationMode,
                eventBus: this.props.eventBus,
                onCheckCellIsEditable: this.props.onCheckCellIsEditable,
                onCellCopyPaste: this.props.onCellCopyPaste,
                onGridRowsUpdated: this.props.onGridRowsUpdated,
                onDragHandleDoubleClick: this.props.onDragHandleDoubleClick,
                onCellSelected: this.props.onCellSelected,
                onCellDeSelected: this.props.onCellDeSelected,
                onCellRangeSelectionStarted: this.props.onCellRangeSelectionStarted,
                onCellRangeSelectionUpdated: this.props.onCellRangeSelectionUpdated,
                onCellRangeSelectionCompleted: this.props.onCellRangeSelectionCompleted,
                onCommit: this.props.onCommit,
                RowsContainer: this.props.RowsContainer
              }))) : m.createElement("div", {
                ref: this.setEmptyViewRef,
                className: "react-grid-Empty"
              }, m.createElement(t, null)));
            }
          }]), t;
        }(m.Component);
        b.displayName = "Grid", b.propTypes = {
          rowGetter: u.default.oneOfType([u.default.array, u.default.func]).isRequired,
          columns: u.default.oneOfType([u.default.array, u.default.object]),
          columnMetrics: u.default.object,
          minHeight: u.default.number,
          totalWidth: u.default.oneOfType([u.default.number, u.default.string]),
          headerRows: u.default.oneOfType([u.default.array, u.default.func]),
          rowHeight: u.default.number,
          rowRenderer: u.default.oneOfType([u.default.element, u.default.func]),
          emptyRowsView: u.default.func,
          expandedRows: u.default.oneOfType([u.default.array, u.default.func]),
          selectedRows: u.default.oneOfType([u.default.array, u.default.func]),
          rowSelection: u.default.oneOfType([u.default.shape({
            indexes: u.default.arrayOf(u.default.number).isRequired
          }), u.default.shape({
            isSelectedKey: u.default.string.isRequired
          }), u.default.shape({
            keys: u.default.shape({
              values: u.default.array.isRequired,
              rowKey: u.default.string.isRequired
            }).isRequired
          })]),
          rowsCount: u.default.number,
          onRows: u.default.func,
          sortColumn: u.default.string,
          cellMetaData: u.default.shape(f.default).isRequired,
          sortDirection: u.default.oneOf(["ASC", "DESC", "NONE"]),
          rowOffsetHeight: u.default.number.isRequired,
          onViewportKeydown: u.default.func.isRequired,
          onViewportKeyup: u.default.func,
          onColumnResize: u.default.func,
          onSort: u.default.func,
          onHeaderDrop: u.default.func,
          rowKey: u.default.string.isRequired,
          rowScrollTimeout: u.default.number,
          scrollToRowIndex: u.default.number,
          contextMenu: u.default.element,
          getSubRowDetails: u.default.func,
          draggableHeaderCell: u.default.func,
          getValidFilterValues: u.default.func,
          rowGroupRenderer: u.default.func,
          overScan: u.default.object,
          enableCellSelect: u.default.bool.isRequired,
          enableCellAutoFocus: u.default.bool.isRequired,
          cellNavigationMode: u.default.string.isRequired,
          eventBus: u.default.object.isRequired,
          onCheckCellIsEditable: u.default.func,
          onCellCopyPaste: u.default.func,
          onGridRowsUpdated: u.default.func.isRequired,
          onDragHandleDoubleClick: u.default.func.isRequired,
          onCellSelected: u.default.func,
          onCellDeSelected: u.default.func,
          onCellRangeSelectionStarted: u.default.func,
          onCellRangeSelectionUpdated: u.default.func,
          onCellRangeSelectionCompleted: u.default.func,
          onCommit: u.default.func.isRequired,
          onScroll: u.default.func,
          scrollLeft: u.default.number,
          RowsContainer: u.default.node
        }, b.defaultProps = {
          rowHeight: 35,
          minHeight: 350
        }, e.exports = b;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(3),
          c = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(l),
          u = r(11),
          h = r(2),
          f = r(13),
          d = r(4),
          p = r(139),
          m = r(132),
          g = r(6),
          v = r(263),
          b = r(81),
          y = r(36),
          w = r(31);
        r(40);
        var x = ["height", "onScroll"],
          _ = function (e) {
            function t() {
              var e, r, a, o;
              n(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), a.state = {
                resizing: null
              }, a.onColumnResize = function (e, t) {
                var r = a.state.resizing || a.props,
                  n = a.getColumnPosition(e);
                if (null != n) {
                  var i = {
                    columnMetrics: p(r.columnMetrics)
                  };
                  i.columnMetrics = m.resizeColumn(i.columnMetrics, n, t), i.columnMetrics.totalWidth < r.columnMetrics.totalWidth && (i.columnMetrics.totalWidth = r.columnMetrics.totalWidth), i.column = g.getColumn(i.columnMetrics.columns, n), a.setState({
                    resizing: i
                  });
                }
              }, a.onColumnResizeEnd = function (e, t) {
                var r = a.getColumnPosition(e);
                null !== r && a.props.onColumnResize && a.props.onColumnResize(r, t || e.width);
              }, a.setRowRef = function (e) {
                a.row = e;
              }, a.setFilterRowRef = function (e) {
                a.filterRow = e;
              }, a.getHeaderRows = function () {
                var e = a.getColumnMetrics(),
                  t = a.state.resizing ? a.state.resizing.column : void 0;
                return a.props.headerRows.map(function (r, n) {
                  var i = r.rowType === u.HeaderRowType.FILTER,
                    o = i ? "500px" : "auto",
                    s = b() > 0 ? b() : 0,
                    l = isNaN(a.props.totalWidth - s) ? a.props.totalWidth : a.props.totalWidth - s,
                    c = {
                      position: "absolute",
                      top: a.getCombinedHeaderHeights(n),
                      left: 0,
                      width: l,
                      overflowX: "hidden",
                      minHeight: o
                    };
                  return h.createElement(v, {
                    key: r.rowType,
                    ref: i ? a.setFilterRowRef : a.setRowRef,
                    rowType: r.rowType,
                    style: c,
                    onColumnResize: a.onColumnResize,
                    onColumnResizeEnd: a.onColumnResizeEnd,
                    width: e.width,
                    height: r.height || a.props.height,
                    columns: e.columns,
                    resizing: t,
                    draggableHeaderCell: a.props.draggableHeaderCell,
                    filterable: r.filterable,
                    onFilterChange: r.onFilterChange,
                    onHeaderDrop: a.props.onHeaderDrop,
                    sortColumn: a.props.sortColumn,
                    sortDirection: a.props.sortDirection,
                    onSort: a.props.onSort,
                    onScroll: a.props.onScroll,
                    getValidFilterValues: a.props.getValidFilterValues
                  });
                });
              }, a.getColumnMetrics = function () {
                return a.state.resizing ? a.state.resizing.columnMetrics : a.props.columnMetrics;
              }, a.getColumnPosition = function (e) {
                var t = a.getColumnMetrics(),
                  r = -1;
                return t.columns.forEach(function (t, n) {
                  t.key === e.key && (r = n);
                }), -1 === r ? null : r;
              }, a.getCombinedHeaderHeights = function (e) {
                var t = a.props.headerRows.length;
                void 0 !== e && (t = e);
                for (var r = 0, n = 0; n < t; n++) r += a.props.headerRows[n].height || a.props.height;
                return r;
              }, a.getStyle = function () {
                return {
                  position: "relative",
                  height: a.getCombinedHeaderHeights()
                };
              }, a.setScrollLeft = function (e) {
                (f.findDOMNode(a.row).scrollLeft = e, a.row.setScrollLeft(e), a.filterRow) && (f.findDOMNode(a.filterRow).scrollLeft = e, a.filterRow.setScrollLeft(e));
              }, a.getKnownDivProps = function () {
                return y(a.props, x);
              }, a.onHeaderClick = function () {
                a.props.cellMetaData.onCellClick({
                  rowIdx: -1,
                  idx: -1
                });
              }, o = r, i(a, o);
            }
            return a(t, e), s(t, [{
              key: "componentWillReceiveProps",
              value: function value() {
                this.setState({
                  resizing: null
                });
              }
            }, {
              key: "shouldComponentUpdate",
              value: function value(e, t) {
                return !m.sameColumns(this.props.columnMetrics.columns, e.columnMetrics.columns, m.sameColumn) || this.props.totalWidth !== e.totalWidth || this.props.headerRows.length !== e.headerRows.length || this.state.resizing !== t.resizing || this.props.sortColumn !== e.sortColumn || this.props.sortDirection !== e.sortDirection;
              }
            }, {
              key: "render",
              value: function value() {
                var e = d({
                    "react-grid-Header": !0,
                    "react-grid-Header--resizing": !!this.state.resizing
                  }),
                  t = this.getHeaderRows();
                return h.createElement("div", o({}, this.getKnownDivProps(), {
                  style: this.getStyle(),
                  className: e,
                  onClick: this.onHeaderClick
                }), t);
              }
            }]), t;
          }(h.Component);
        _.propTypes = {
          columnMetrics: c.default.shape({
            width: c.default.number.isRequired,
            columns: c.default.any
          }).isRequired,
          totalWidth: c.default.oneOfType([c.default.number, c.default.string]),
          height: c.default.number.isRequired,
          headerRows: c.default.array.isRequired,
          sortColumn: c.default.string,
          sortDirection: c.default.oneOf(["ASC", "DESC", "NONE"]),
          onSort: c.default.func,
          onColumnResize: c.default.func,
          onScroll: c.default.func,
          onHeaderDrop: c.default.func,
          draggableHeaderCell: c.default.func,
          getValidFilterValues: c.default.func,
          cellMetaData: c.default.shape(w)
        }, e.exports = _;
      }, function (e, t) {
        "use strict";

        var r = {
          SORTABLE: 0,
          FILTERABLE: 1,
          NONE: 2,
          CHECKBOX: 3
        };
        e.exports = r;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(11),
          c = r(3),
          u = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(c),
          h = r(2),
          f = r(389),
          d = r(133),
          p = r(81),
          m = r(6),
          g = r(124),
          v = r(216),
          b = r(262),
          y = r(36);
        r(40);
        var w = {
            overflow: u.default.string,
            width: u.default.oneOfType([u.default.number, u.default.string]),
            height: u.default.number,
            position: u.default.string
          },
          x = ["width", "height", "style", "onScroll"],
          _ = function (e) {
            function t() {
              var e, r, a, s;
              n(this, t);
              for (var c = arguments.length, u = Array(c), f = 0; f < c; f++) u[f] = arguments[f];
              return r = a = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(u))), a.cells = [], a.getHeaderCellType = function (e) {
                return e.filterable && a.props.filterable ? b.FILTERABLE : e.sortable && e.rowType !== l.HeaderRowType.FILTER ? b.SORTABLE : b.NONE;
              }, a.getFilterableHeaderCell = function (e) {
                var t = v;
                return void 0 !== e.filterRenderer && (t = e.filterRenderer), h.createElement(t, o({}, a.props, {
                  onChange: a.props.onFilterChange
                }));
              }, a.getSortableHeaderCell = function (e) {
                var t = a.props.sortColumn === e.key ? a.props.sortDirection : g.DEFINE_SORT.NONE,
                  r = void 0 !== e.sortDescendingFirst && e.sortDescendingFirst;
                return h.createElement(g, {
                  columnKey: e.key,
                  onSort: a.props.onSort,
                  sortDirection: t,
                  sortDescendingFirst: r,
                  headerRenderer: e.headerRenderer
                });
              }, a.getHeaderRenderer = function (e) {
                if (e.headerRenderer && !e.sortable && !a.props.filterable) return e.headerRenderer;
                switch (a.getHeaderCellType(e)) {
                  case b.SORTABLE:
                    return a.getSortableHeaderCell(e);
                  case b.FILTERABLE:
                    return a.getFilterableHeaderCell(e);
                  default:
                    return;
                }
              }, a.getStyle = function () {
                return {
                  overflow: "hidden",
                  width: "100%",
                  height: a.props.height,
                  position: "absolute"
                };
              }, a.getCells = function () {
                for (var e = [], t = [], r = a.props, n = r.columns, i = r.rowType, s = 0, c = m.getSize(n); s < c; s++) !function (r, s) {
                  var c = o({
                      rowType: i
                    }, m.getColumn(n, r)),
                    u = "select-row" === c.key && i === l.HeaderRowType.FILTER ? h.createElement("div", null) : a.getHeaderRenderer(c),
                    f = h.createElement(d, {
                      key: c.key,
                      ref: function ref(e) {
                        return a.cells[r] = e;
                      },
                      column: c,
                      rowType: i,
                      height: a.props.height,
                      renderer: u,
                      resizing: a.props.resizing === c,
                      onResize: a.props.onColumnResize,
                      onResizeEnd: a.props.onColumnResizeEnd,
                      onHeaderDrop: a.props.onHeaderDrop,
                      draggableHeaderCell: a.props.draggableHeaderCell
                    });
                  m.isFrozen(c) ? t.push(f) : e.push(f);
                }(s);
                return e.concat(t);
              }, a.setScrollLeft = function (e) {
                a.props.columns.forEach(function (t, r) {
                  m.isFrozen(t) ? a.cells[r].setScrollLeft(e) : a.cells[r] && a.cells[r].removeScroll && a.cells[r].removeScroll();
                });
              }, a.getKnownDivProps = function () {
                return y(a.props, x);
              }, s = r, i(a, s);
            }
            return a(t, e), s(t, [{
              key: "shouldComponentUpdate",
              value: function value(e) {
                return e.width !== this.props.width || e.height !== this.props.height || e.columns !== this.props.columns || !f(e.style, this.props.style) || this.props.sortColumn !== e.sortColumn || this.props.sortDirection !== e.sortDirection;
              }
            }, {
              key: "render",
              value: function value() {
                var e = {
                    width: this.props.width ? this.props.width + p() : "100%",
                    height: this.props.height,
                    whiteSpace: "nowrap",
                    overflowX: "hidden",
                    overflowY: "hidden"
                  },
                  t = this.getCells();
                return h.createElement("div", o({}, this.getKnownDivProps(), {
                  className: "react-grid-HeaderRow"
                }), h.createElement("div", {
                  style: e
                }, t));
              }
            }]), t;
          }(h.Component);
        _.displayName = "HeaderRow", _.propTypes = {
          width: u.default.oneOfType([u.default.number, u.default.string]),
          height: u.default.number.isRequired,
          columns: u.default.oneOfType([u.default.array, u.default.object]).isRequired,
          onColumnResize: u.default.func,
          onSort: u.default.func.isRequired,
          onColumnResizeEnd: u.default.func,
          style: u.default.shape(w),
          sortColumn: u.default.string,
          sortDirection: u.default.oneOf(Object.keys(g.DEFINE_SORT)),
          cellRenderer: u.default.func,
          headerCellRenderer: u.default.func,
          filterable: u.default.bool,
          onFilterChange: u.default.func,
          resizing: u.default.object,
          onScroll: u.default.func,
          rowType: u.default.string,
          draggableHeaderCell: u.default.func,
          onHeaderDrop: u.default.func
        }, e.exports = _;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        function a(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function o(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function s(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var l = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          c = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          u = r(2),
          h = n(u),
          f = r(3),
          d = n(f),
          p = r(381),
          m = r(260),
          g = n(m),
          v = r(69),
          b = n(v),
          y = r(80),
          w = n(y),
          x = r(6),
          _ = n(x),
          S = r(134),
          C = n(S),
          E = r(5),
          A = r(136),
          T = n(A),
          k = r(124),
          R = r(11),
          I = r(138),
          M = r(132);
        r(59), r(76), Object.assign || (Object.assign = r(27));
        var O = function O(e, t) {
            return e + " has been deprecated and will be removed in a future version. Please use " + t + " instead";
          },
          P = function (e) {
            function t(e, r) {
              a(this, t);
              var n = o(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, r));
              B.call(n);
              var i = n.createColumnMetrics(),
                s = {
                  columnMetrics: i,
                  selectedRows: [],
                  expandedRows: [],
                  canFilter: !1,
                  columnFilters: {},
                  sortDirection: null,
                  sortColumn: null,
                  scrollOffset: 0,
                  lastRowIdxUiSelected: -1
                };
              return n.props.sortColumn && n.props.sortDirection && (s.sortColumn = n.props.sortColumn, s.sortDirection = n.props.sortDirection), n.state = s, n.eventBus = new I.EventBus(), n;
            }
            return s(t, e), c(t, [{
              key: "componentDidMount",
              value: function value() {
                this._mounted = !0, window.addEventListener("resize", this.metricsUpdated), this.props.cellRangeSelection && window.addEventListener("mouseup", this.onWindowMouseUp), this.metricsUpdated();
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this._mounted = !1, window.removeEventListener("resize", this.metricsUpdated), window.removeEventListener("mouseup", this.onWindowMouseUp);
              }
            }, {
              key: "componentWillReceiveProps",
              value: function value(e) {
                if (e.columns && (!M.sameColumns(this.props.columns, e.columns, this.props.columnEquality) || e.minWidth !== this.props.minWidth)) {
                  var t = this.createColumnMetrics(e);
                  this.setState({
                    columnMetrics: t
                  });
                }
              }
            }, {
              key: "render",
              value: function value() {
                var e = {
                  rowKey: this.props.rowKey,
                  onCellClick: this.onCellClick,
                  onCellContextMenu: this.onCellContextMenu,
                  onCellDoubleClick: this.onCellDoubleClick,
                  onColumnEvent: this.onColumnEvent,
                  onCellExpand: this.onCellExpand,
                  onRowExpandToggle: this.onRowExpandToggle,
                  getCellActions: this.props.getCellActions,
                  onDeleteSubRow: this.props.onDeleteSubRow,
                  onAddSubRow: this.props.onAddSubRow,
                  onDragEnter: this.handleDragEnter
                };
                this.props.cellRangeSelection && (e.onCellMouseDown = this.onCellMouseDown, e.onCellMouseEnter = this.onCellMouseEnter);
                var t = this.renderToolbar(),
                  r = this.props.minWidth || this.gridWidth(),
                  n = r - this.state.scrollOffset;
                return (void 0 === r || isNaN(r) || 0 === r) && (r = "100%"), (void 0 === n || isNaN(n) || 0 === n) && (n = "100%"), h.default.createElement("div", {
                  className: "react-grid-Container",
                  style: {
                    width: r
                  },
                  ref: this.setGridRef
                }, t, h.default.createElement("div", {
                  className: "react-grid-Main"
                }, h.default.createElement(g.default, l({
                  ref: this.setBaseGridRef
                }, this.props, {
                  rowKey: this.props.rowKey,
                  headerRows: this.getHeaderRows(),
                  columnMetrics: this.state.columnMetrics,
                  rowGetter: this.props.rowGetter,
                  rowsCount: this.props.rowsCount,
                  rowHeight: this.props.rowHeight,
                  cellMetaData: e,
                  selectedRows: this.getSelectedRows(),
                  rowSelection: this.getRowSelectionProps(),
                  expandedRows: this.state.expandedRows,
                  rowOffsetHeight: this.getRowOffsetHeight(),
                  sortColumn: this.state.sortColumn,
                  sortDirection: this.state.sortDirection,
                  onSort: this.handleSort,
                  minHeight: this.props.minHeight,
                  totalWidth: n,
                  onViewportKeydown: this.onKeyDown,
                  onViewportKeyup: this.onKeyUp,
                  onColumnResize: this.onColumnResize,
                  rowScrollTimeout: this.props.rowScrollTimeout,
                  scrollToRowIndex: this.props.scrollToRowIndex,
                  contextMenu: this.props.contextMenu,
                  overScan: this.props.overScan,
                  enableCellSelect: this.props.enableCellSelect,
                  enableCellAutoFocus: this.props.enableCellAutoFocus,
                  cellNavigationMode: this.props.cellNavigationMode,
                  eventBus: this.eventBus,
                  onCheckCellIsEditable: this.props.onCheckCellIsEditable,
                  onCellCopyPaste: this.props.onCellCopyPaste,
                  onGridRowsUpdated: this.onGridRowsUpdated,
                  onDragHandleDoubleClick: this.onDragHandleDoubleClick,
                  onCellSelected: this.props.onCellSelected,
                  onCellDeSelected: this.props.onCellDeSelected,
                  onCellRangeSelectionStarted: this.props.cellRangeSelection && this.props.cellRangeSelection.onStart,
                  onCellRangeSelectionUpdated: this.props.cellRangeSelection && this.props.cellRangeSelection.onUpdate,
                  onCellRangeSelectionCompleted: this.props.cellRangeSelection && this.props.cellRangeSelection.onComplete,
                  onCommit: this.onCommit,
                  onScroll: this.onScroll
                }))));
              }
            }]), t;
          }(h.default.Component);
        P.displayName = "ReactDataGrid", P.propTypes = {
          rowHeight: d.default.number.isRequired,
          headerRowHeight: d.default.number,
          headerFiltersHeight: d.default.number,
          minHeight: d.default.number.isRequired,
          minWidth: d.default.number,
          enableRowSelect: (0, p.deprecate)(d.default.func, O("enableRowSelect", "rowSelection")),
          onRowUpdated: (0, p.deprecate)(d.default.func, O("onRowUpdated", "onGridRowsUpdated")),
          rowGetter: d.default.func.isRequired,
          rowsCount: d.default.number.isRequired,
          toolbar: d.default.element,
          enableCellSelect: d.default.bool,
          columns: d.default.oneOfType([d.default.object, d.default.array]).isRequired,
          onFilter: d.default.func,
          onCellCopyPaste: (0, p.deprecate)(d.default.func, O("onCellCopyPaste", "onGridRowsUpdated")),
          onCellsDragged: (0, p.deprecate)(d.default.func, O("onCellsDragged", "onGridRowsUpdated")),
          getCellActions: d.default.func,
          onAddFilter: d.default.func,
          onGridSort: d.default.func,
          sortColumn: d.default.string,
          sortDirection: d.default.oneOf(Object.keys(k.DEFINE_SORT)),
          onDragHandleDoubleClick: (0, p.deprecate)(d.default.func, O("onDragHandleDoubleClick", "onGridRowsUpdated")),
          onGridRowsUpdated: d.default.func,
          onRowSelect: d.default.func,
          rowKey: d.default.string,
          rowScrollTimeout: (0, p.deprecate)(d.default.number),
          scrollToRowIndex: d.default.number,
          onClearFilters: d.default.func,
          contextMenu: d.default.element,
          cellNavigationMode: d.default.oneOf(["none", "loopOverRow", "changeRow"]),
          onCellSelected: d.default.func,
          onCellDeSelected: d.default.func,
          cellRangeSelection: d.default.shape({
            onStart: d.default.func,
            onUpdate: d.default.func,
            onComplete: d.default.func
          }),
          onCellExpand: d.default.func,
          enableDragAndDrop: d.default.bool,
          onRowExpandToggle: d.default.func,
          draggableHeaderCell: d.default.func,
          getValidFilterValues: d.default.func,
          rowSelection: d.default.shape({
            enableShiftSelect: d.default.bool,
            onRowsSelected: d.default.func,
            onRowsDeselected: d.default.func,
            showCheckbox: d.default.bool,
            selectBy: d.default.oneOfType([d.default.shape({
              indexes: d.default.arrayOf(d.default.number).isRequired
            }), d.default.shape({
              isSelectedKey: d.default.string.isRequired
            }), d.default.shape({
              keys: d.default.shape({
                values: d.default.array.isRequired,
                rowKey: d.default.string.isRequired
              }).isRequired
            })]).isRequired
          }),
          onRowClick: d.default.func,
          onRowDoubleClick: d.default.func,
          onGridKeyUp: d.default.func,
          onGridKeyDown: d.default.func,
          rowGroupRenderer: d.default.func,
          rowActionsCell: d.default.func,
          onCheckCellIsEditable: d.default.func,
          overScan: d.default.object,
          onDeleteSubRow: d.default.func,
          onAddSubRow: d.default.func,
          enableCellAutoFocus: d.default.bool,
          onBeforeEdit: d.default.func,
          selectAllRenderer: d.default.object,
          minColumnWidth: d.default.number,
          columnEquality: d.default.func,
          onColumnResize: d.default.func,
          onScroll: d.default.func
        }, P.defaultProps = {
          enableCellSelect: !1,
          rowHeight: 35,
          headerFiltersHeight: 45,
          enableRowSelect: !1,
          minHeight: 350,
          rowKey: "id",
          rowScrollTimeout: 0,
          scrollToRowIndex: 0,
          cellNavigationMode: R.CellNavigationMode.NONE,
          overScan: {
            colsStart: 2,
            colsEnd: 2,
            rowsStart: 2,
            rowsEnd: 2
          },
          enableCellAutoFocus: !0,
          onBeforeEdit: function onBeforeEdit() {},
          minColumnWidth: 80,
          columnEquality: M.sameColumn
        };
        var B = function B() {
          var e = this;
          this.selectCell = function (t, r) {
            var n = t.idx,
              i = t.rowIdx;
            e.eventBus.dispatch(R.EventTypes.SELECT_CELL, {
              rowIdx: i,
              idx: n
            }, r);
          }, this.selectStart = function (t) {
            e.eventBus.dispatch(R.EventTypes.SELECT_START, t);
          }, this.selectUpdate = function (t) {
            e.eventBus.dispatch(R.EventTypes.SELECT_UPDATE, t);
          }, this.selectEnd = function () {
            e.eventBus.dispatch(R.EventTypes.SELECT_END);
          }, this.handleDragEnter = function (t) {
            var r = t.overRowIdx;
            e.eventBus.dispatch(R.EventTypes.DRAG_ENTER, {
              overRowIdx: r
            });
          }, this.gridWidth = function () {
            return e.grid ? e.grid.parentElement.offsetWidth : 0;
          }, this.getTotalWidth = function () {
            return e._mounted ? e.gridWidth() : _.default.getSize(e.props.columns) * e.props.minColumnWidth;
          }, this.getColumnMetricsType = function (t) {
            var r = t.totalWidth || e.getTotalWidth(),
              n = {
                columns: t.columns,
                totalWidth: r,
                minColumnWidth: t.minColumnWidth
              };
            return M.recalculate(n);
          }, this.getColumn = function (t) {
            var r = e.state.columnMetrics.columns;
            return _.default.getColumn(r, t);
          }, this.getSize = function () {
            var t = e.state.columnMetrics.columns;
            return _.default.getSize(t);
          }, this.metricsUpdated = function () {
            var t = e.createColumnMetrics();
            e.setState({
              columnMetrics: t
            });
          }, this.createColumnMetrics = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e.props,
              r = e.setupGridColumns(t);
            return e.getColumnMetricsType({
              columns: r,
              minColumnWidth: e.props.minColumnWidth,
              totalWidth: t.minWidth
            });
          }, this.onColumnResize = function (t, r) {
            var n = M.resizeColumn(e.state.columnMetrics, t, r);
            e.setState({
              columnMetrics: n
            }), e.props.onColumnResize && e.props.onColumnResize(t, r);
          }, this.onKeyDown = function (t) {
            e._keysDown = e._keysDown || {}, e._keysDown[t.keyCode] = !0;
            var r = e.props.onGridKeyDown;
            (0, E.isFunction)(r) && r(t);
          }, this.onKeyUp = function (t) {
            e._keysDown = e._keysDown || {}, delete e._keysDown[t.keyCode];
            var r = e.props.onGridKeyUp;
            (0, E.isFunction)(r) && r(t);
          }, this.isSingleKeyDown = function (t) {
            return !!e._keysDown && t in e._keysDown && 1 === Object.keys(e._keysDown).length;
          }, this.onColumnEvent = function (t, r) {
            var n = r.idx,
              i = r.name;
            if (i && void 0 !== n) {
              var a = e.getColumn(n);
              if (a && a.events && (0, E.isFunction)(a.events[i])) {
                var o = {
                  idx: n,
                  rowIdx: r.rowIdx,
                  rowId: r.rowId,
                  column: a
                };
                a.events[i](t, o);
              }
            }
          }, this.onCellClick = function (t) {
            var r = t.rowIdx,
              n = t.idx,
              i = e.props,
              a = i.onRowClick,
              o = i.rowGetter;
            e.selectCell({
              rowIdx: r,
              idx: n
            }), (0, E.isFunction)(a) && a(r, o(r), e.getColumn(n));
          }, this.onCellMouseDown = function (t) {
            e.selectStart(t);
          }, this.onCellMouseEnter = function (t) {
            e.selectUpdate(t);
          }, this.onWindowMouseUp = function () {
            e.selectEnd();
          }, this.onCellContextMenu = function (t) {
            var r = t.rowIdx,
              n = t.idx;
            e.selectCell({
              rowIdx: r,
              idx: n
            });
          }, this.onCellDoubleClick = function (t) {
            var r = t.rowIdx,
              n = t.idx,
              i = e.props,
              a = i.onRowDoubleClick,
              o = i.rowGetter;
            (0, E.isFunction)(a) && a(r, o(r), e.getColumn(n)), e.openCellEditor(r, n);
          }, this.onToggleFilter = function () {
            e.setState({
              canFilter: !e.state.canFilter
            }, function () {
              !1 === e.state.canFilter && e.props.onClearFilters && e.props.onClearFilters();
            });
          }, this.onDragHandleDoubleClick = function (t) {
            if (e.props.onDragHandleDoubleClick && e.props.onDragHandleDoubleClick(t), e.props.onGridRowsUpdated) {
              var r = e.getColumn(t.idx).key;
              e.onGridRowsUpdated(r, t.rowIdx, e.props.rowsCount - 1, i({}, r, t.rowData[r]), R.UpdateActions.COLUMN_FILL);
            }
          }, this.onCellExpand = function (t) {
            e.props.onCellExpand && e.props.onCellExpand(t);
          }, this.onRowExpandToggle = function (t) {
            "function" == typeof e.props.onRowExpandToggle && e.props.onRowExpandToggle(t);
          }, this.onGridRowsUpdated = function (t, r, n, i, a, o) {
            var s = e.props,
              l = s.rowGetter,
              c = s.rowKey,
              u = s.onGridRowsUpdated;
            if ((0, E.isFunction)(e.props.onRowUpdated) && e.props.onRowUpdated({
              updated: i,
              rowIdx: r,
              cellKey: t,
              value: i[t]
            }), (0, E.isFunction)(u)) {
              for (var h = [], f = r; f <= n; f++) h.push(l(f)[c]);
              var d = l(a === R.UpdateActions.COPY_PASTE ? o : r);
              u({
                cellKey: t,
                fromRow: r,
                toRow: n,
                fromRowId: d[c],
                toRowId: l(n)[c],
                rowIds: h,
                updated: i,
                action: a,
                fromRowData: d
              });
            }
          }, this.onCommit = function (t) {
            var r = t.rowIdx;
            e.onGridRowsUpdated(t.cellKey, r, r, t.updated, R.UpdateActions.CELL_UPDATE);
          }, this.onScroll = function (t) {
            (0, E.isFunction)(e.props.onScroll) && e.props.onScroll(t);
          }, this.handleSort = function (t, r) {
            e.setState({
              sortDirection: r,
              sortColumn: t
            }, function () {
              e.props.onGridSort(t, r);
            });
          }, this.getSelectedRow = function (t, r) {
            var n = t.filter(function (t) {
              return t[e.props.rowKey] === r;
            });
            if (n.length > 0) return n[0];
          }, this.useNewRowSelection = function () {
            return e.props.rowSelection && e.props.rowSelection.selectBy;
          }, this.handleShiftSelect = function (t) {
            if (e.state.lastRowIdxUiSelected > -1 && e.isSingleKeyDown(C.default.Shift)) {
              var r = e.props.rowSelection.selectBy,
                n = r.keys,
                i = r.indexes,
                a = r.isSelectedKey;
              if (w.default.isRowSelected(n, i, a, e.props.rowGetter(t), t)) return !1;
              var o = !1;
              if (t > e.state.lastRowIdxUiSelected) {
                for (var s = [], l = e.state.lastRowIdxUiSelected + 1; l <= t; l++) s.push({
                  rowIdx: l,
                  row: e.props.rowGetter(l)
                });
                "function" == typeof e.props.rowSelection.onRowsSelected && e.props.rowSelection.onRowsSelected(s), o = !0;
              } else if (t < e.state.lastRowIdxUiSelected) {
                for (var c = [], u = t; u <= e.state.lastRowIdxUiSelected - 1; u++) c.push({
                  rowIdx: u,
                  row: e.props.rowGetter(u)
                });
                "function" == typeof e.props.rowSelection.onRowsSelected && e.props.rowSelection.onRowsSelected(c), o = !0;
              }
              return o && e.setState({
                lastRowIdxUiSelected: t
              }), o;
            }
            return !1;
          }, this.handleNewRowSelect = function (t, r) {
            e.selectAllCheckbox && !0 === e.selectAllCheckbox.checked && (e.selectAllCheckbox.checked = !1);
            var n = e.props.rowSelection.selectBy,
              i = n.keys,
              a = n.indexes,
              o = n.isSelectedKey,
              s = w.default.isRowSelected(i, a, o, r, t);
            e.setState({
              lastRowIdxUiSelected: s ? -1 : t,
              selected: {
                rowIdx: t,
                idx: 0
              }
            }), s && "function" == typeof e.props.rowSelection.onRowsDeselected ? e.props.rowSelection.onRowsDeselected([{
              rowIdx: t,
              row: r
            }]) : s || "function" != typeof e.props.rowSelection.onRowsSelected || e.props.rowSelection.onRowsSelected([{
              rowIdx: t,
              row: r
            }]);
          }, this.handleRowSelect = function (t, r, n, i) {
            if (i.stopPropagation(), e.useNewRowSelection()) !0 === e.props.rowSelection.enableShiftSelect ? e.handleShiftSelect(t) || e.handleNewRowSelect(t, n) : e.handleNewRowSelect(t, n);else {
              var a = "single" === e.props.enableRowSelect ? [] : e.state.selectedRows.slice(0),
                o = e.getSelectedRow(a, n[e.props.rowKey]);
              o ? o.isSelected = !o.isSelected : (n.isSelected = !0, a.push(n)), e.setState({
                selectedRows: a,
                selected: {
                  rowIdx: t,
                  idx: 0
                }
              }), e.props.onRowSelect && e.props.onRowSelect(a.filter(function (e) {
                return !0 === e.isSelected;
              }));
            }
          }, this.handleCheckboxChange = function (t) {
            var r = void 0;
            if (r = t.currentTarget instanceof HTMLInputElement && !0 === t.currentTarget.checked, e.useNewRowSelection()) {
              var n = e.props.rowSelection.selectBy,
                i = n.keys,
                a = n.indexes,
                o = n.isSelectedKey;
              if (r && "function" == typeof e.props.rowSelection.onRowsSelected) {
                for (var s = [], l = 0; l < e.props.rowsCount; l++) {
                  var c = e.props.rowGetter(l);
                  w.default.isRowSelected(i, a, o, c, l) || s.push({
                    rowIdx: l,
                    row: c
                  });
                }
                s.length > 0 && e.props.rowSelection.onRowsSelected(s);
              } else if (!r && "function" == typeof e.props.rowSelection.onRowsDeselected) {
                for (var u = [], h = 0; h < e.props.rowsCount; h++) {
                  var f = e.props.rowGetter(h);
                  w.default.isRowSelected(i, a, o, f, h) && u.push({
                    rowIdx: h,
                    row: f
                  });
                }
                u.length > 0 && e.props.rowSelection.onRowsDeselected(u);
              }
            } else {
              for (var d = [], p = 0; p < e.props.rowsCount; p++) {
                var m = Object.assign({}, e.props.rowGetter(p), {
                  isSelected: r
                });
                d.push(m);
              }
              e.setState({
                selectedRows: d
              }), "function" == typeof e.props.onRowSelect && e.props.onRowSelect(d.filter(function (e) {
                return !0 === e.isSelected;
              }));
            }
          }, this.getRowOffsetHeight = function () {
            var t = 0;
            return e.getHeaderRows().forEach(function (e) {
              return t += parseFloat(e.height, 10);
            }), t;
          }, this.getHeaderRows = function () {
            var t = [{
              height: e.props.headerRowHeight || e.props.rowHeight,
              rowType: R.HeaderRowType.HEADER
            }];
            return !0 === e.state.canFilter && t.push({
              filterable: !0,
              onFilterChange: e.props.onAddFilter,
              height: e.props.headerFiltersHeight,
              rowType: R.HeaderRowType.FILTER
            }), t;
          }, this.getInitialSelectedRows = function () {
            for (var t = [], r = 0; r < e.props.rowsCount; r++) t.push(!1);
            return t;
          }, this.getRowSelectionProps = function () {
            return e.props.rowSelection ? e.props.rowSelection.selectBy : null;
          }, this.getSelectedRows = function () {
            return e.props.rowSelection ? null : e.state.selectedRows.filter(function (e) {
              return !0 === e.isSelected;
            });
          }, this.getDataGridDOMNode = function () {
            return e.grid;
          }, this.openCellEditor = function (t, r) {
            e.selectCell({
              rowIdx: t,
              idx: r
            }, !0);
          }, this.scrollToColumn = function (t) {
            e.eventBus.dispatch(R.EventTypes.SCROLL_TO_COLUMN, t);
          }, this.setupGridColumns = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : e.props,
              r = t.columns;
            if (e._cachedColumns === r) return e._cachedComputedColumns;
            e._cachedColumns = r;
            var n = r.slice(0),
              i = {};
            if (e.props.rowActionsCell || t.enableRowSelect && !e.props.rowSelection || t.rowSelection && !1 !== t.rowSelection.showCheckbox) {
              var a = e.props.selectAllRenderer || T.default,
                o = h.default.createElement(a, {
                  onChange: e.handleCheckboxChange,
                  inputRef: function inputRef(t) {
                    return e.selectAllCheckbox = t;
                  }
                }),
                s = "single" === t.enableRowSelect ? null : o,
                l = e.props.rowActionsCell ? e.props.rowActionsCell : b.default,
                c = {
                  key: "select-row",
                  name: "",
                  formatter: h.default.createElement(l, {
                    rowSelection: e.props.rowSelection
                  }),
                  onCellChange: e.handleRowSelect,
                  filterable: !1,
                  headerRenderer: s,
                  width: 60,
                  frozen: !0,
                  getRowMetaData: function getRowMetaData(e) {
                    return e;
                  },
                  cellClass: e.props.rowActionsCell ? "rdg-row-actions-cell" : ""
                };
              i = n.unshift(c), n = i > 0 ? n : i;
            }
            return e._cachedComputedColumns = n, e._cachedComputedColumns;
          }, this.setGridRef = function (t) {
            e.grid = t;
          }, this.setBaseGridRef = function (t) {
            e.base = t;
          }, this.renderToolbar = function () {
            var t = e.props.toolbar,
              r = {
                columns: e.props.columns,
                onToggleFilter: e.onToggleFilter,
                numberOfRows: e.props.rowsCount
              };
            return h.default.isValidElement(t) ? h.default.cloneElement(t, r) : (0, E.isFunction)(t) ? h.default.createElement(t, r) : void 0;
          };
        };
        e.exports = P;
      }, function (e, t, r) {
        "use strict";

        function n(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function i(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function a(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(2),
          c = r(258);
        r(40);
        var u = {
            position: "absolute",
            top: 0,
            right: 0,
            width: 6,
            height: "100%"
          },
          h = function (e) {
            function t() {
              return n(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
            }
            return a(t, e), s(t, [{
              key: "render",
              value: function value() {
                return l.createElement(c, o({}, this.props, {
                  className: "react-grid-HeaderCell__resizeHandle",
                  style: u
                }));
              }
            }]), t;
          }(l.Component);
        e.exports = h;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          l = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          c = r(2),
          u = n(c),
          h = r(3),
          f = n(h),
          d = r(5),
          p = r(31),
          m = n(p),
          g = r(11);
        r(45);
        var v = function (e) {
          function t() {
            var e, r, n, o;
            i(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.onRowExpandToggle = function (e) {
              var t = null == e ? !n.props.isExpanded : e,
                r = n.props.cellMetaData;
              null != r && "function" == typeof r.onRowExpandToggle && r.onRowExpandToggle({
                rowIdx: n.props.idx,
                shouldExpand: t,
                columnGroupName: n.props.columnGroupName,
                name: n.props.name
              });
            }, n.onClick = function () {
              n.props.eventBus.dispatch(g.EventTypes.SELECT_CELL, {
                rowIdx: n.props.idx
              });
            }, n.onRowExpandClick = function () {
              n.onRowExpandToggle(!n.props.isExpanded);
            }, o = r, a(n, o);
          }
          return o(t, e), l(t, [{
            key: "render",
            value: function value() {
              var e = (0, d.last)(this.props.columns),
                t = {
                  width: e.left + e.width
                };
              return u.default.createElement("div", {
                style: t,
                className: "react-grid-row-group",
                onClick: this.onClick
              }, u.default.createElement(this.props.renderer, s({}, this.props, {
                onRowExpandClick: this.onRowExpandClick,
                onRowExpandToggle: this.onRowExpandToggle
              })));
            }
          }]), t;
        }(c.Component);
        v.propTypes = {
          height: f.default.number.isRequired,
          columns: f.default.oneOfType([f.default.object, f.default.array]).isRequired,
          row: f.default.any.isRequired,
          cellRenderer: f.default.func,
          cellMetaData: f.default.shape(m.default),
          isSelected: f.default.bool,
          idx: f.default.number.isRequired,
          expandedRows: f.default.arrayOf(f.default.object),
          extraClasses: f.default.string,
          forceUpdate: f.default.bool,
          subRowDetails: f.default.object,
          isRowHovered: f.default.bool,
          colVisibleStartIdx: f.default.number.isRequired,
          colVisibleEndIdx: f.default.number.isRequired,
          colOverscanStartIdx: f.default.number.isRequired,
          colOverscanEndIdx: f.default.number.isRequired,
          isScrolling: f.default.bool.isRequired,
          columnGroupName: f.default.string.isRequired,
          isExpanded: f.default.bool.isRequired,
          treeDepth: f.default.number.isRequired,
          name: f.default.string.isRequired,
          renderer: f.default.func,
          eventBus: f.default.object.isRequired,
          rowRef: f.default.func.isRequired
        };
        var b = function (e) {
          function t() {
            var e, r, n, o;
            i(this, t);
            for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
            return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.onKeyDown = function (e) {
              var t = n.props,
                r = t.onRowExpandToggle,
                i = t.isExpanded;
              "ArrowLeft" === e.key && r(!1), "ArrowRight" === e.key && r(!0), "Enter" === e.key && r(!i);
            }, o = r, a(n, o);
          }
          return o(t, e), l(t, [{
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.treeDepth,
                r = void 0 === t ? 0 : t,
                n = e.height,
                i = e.rowRef,
                a = e.onRowExpandClick,
                o = e.isExpanded,
                s = e.columnGroupDisplayName,
                l = e.name,
                c = 20 * r,
                h = {
                  height: n,
                  border: "1px solid #dddddd",
                  paddingTop: "15px",
                  paddingLeft: "5px"
                };
              return u.default.createElement("div", {
                style: h,
                onKeyDown: this.onKeyDown,
                tabIndex: 0,
                ref: i
              }, u.default.createElement("span", {
                className: "row-expand-icon",
                style: {
                  float: "left",
                  marginLeft: c,
                  cursor: "pointer"
                },
                onClick: a
              }, o ? String.fromCharCode(9660) : String.fromCharCode(9658)), u.default.createElement("strong", null, s, ": ", l));
            }
          }]), t;
        }(c.Component);
        b.propTypes = {
          onRowExpandClick: f.default.func.isRequired,
          onRowExpandToggle: f.default.func.isRequired,
          isExpanded: f.default.bool.isRequired,
          height: f.default.number.isRequired,
          treeDepth: f.default.number.isRequired,
          name: f.default.string.isRequired,
          columnGroupName: f.default.string.isRequired,
          columnGroupDisplayName: f.default.string.isRequired,
          rowRef: f.default.func.isRequired,
          hideColumnName: f.default.bool
        }, v.defaultProps = {
          renderer: b
        }, t.default = v;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var s = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          l = r(31),
          c = n(l),
          u = r(3),
          h = n(u),
          f = r(6),
          d = n(f),
          p = r(280),
          m = r(2),
          g = r(253),
          v = function (e) {
            function t() {
              var e, r, n, o;
              i(this, t);
              for (var s = arguments.length, l = Array(s), c = 0; c < s; c++) l[c] = arguments[c];
              return r = n = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(l))), n.state = (0, p.getGridState)(n.props), n.onScroll = function (e) {
                var t = e.scrollTop,
                  r = e.scrollLeft,
                  i = n.props,
                  a = i.rowHeight,
                  o = i.rowsCount,
                  s = i.onScroll,
                  l = n.updateScroll({
                    scrollTop: t,
                    scrollLeft: r,
                    height: n.state.height,
                    rowHeight: a,
                    rowsCount: o
                  });
                s && s(l);
              }, n.getScroll = function () {
                return n.canvas.getScroll();
              }, n.setScrollLeft = function (e) {
                n.canvas.setScrollLeft(e);
              }, n.getDOMNodeOffsetWidth = function () {
                return n.viewport ? n.viewport.offsetWidth : 0;
              }, n.clearScrollTimer = function () {
                n.resetScrollStateTimeoutId && clearTimeout(n.resetScrollStateTimeoutId);
              }, n.resetScrollStateAfterDelay = function () {
                n.clearScrollTimer(), n.resetScrollStateTimeoutId = setTimeout(n.resetScrollStateAfterDelayCallback, 500);
              }, n.resetScrollStateAfterDelayCallback = function () {
                n.resetScrollStateTimeoutId = null, n.setState({
                  isScrolling: !1
                });
              }, n.updateScroll = function (e) {
                n.resetScrollStateAfterDelay();
                var t = n.getNextScrollState(e);
                return n.setState(t), t;
              }, n.metricsUpdated = function () {
                var e = n.viewportHeight(),
                  t = n.viewportWidth();
                if (e) {
                  var r = n.state,
                    i = r.scrollTop,
                    a = r.scrollLeft,
                    o = n.props,
                    s = o.rowHeight,
                    l = o.rowsCount;
                  n.updateScroll({
                    scrollTop: i,
                    scrollLeft: a,
                    height: e,
                    rowHeight: s,
                    rowsCount: l,
                    width: t
                  });
                }
              }, n.viewportHeight = function () {
                return n.viewport ? n.viewport.offsetHeight : 0;
              }, n.viewportWidth = function () {
                return n.viewport ? n.viewport.offsetWidth : 0;
              }, n.setViewportRef = function (e) {
                n.viewport = e;
              }, n.setCanvasRef = function (e) {
                n.canvas = e;
              }, o = r, a(n, o);
            }
            return o(t, e), s(t, [{
              key: "getNextScrollState",
              value: function value(e) {
                var t = e.scrollTop,
                  r = e.scrollLeft,
                  n = e.height,
                  i = e.rowHeight,
                  a = e.rowsCount,
                  o = this.props.columnMetrics.columns,
                  s = (0, p.getScrollDirection)(this.state, t, r),
                  l = (0, p.getVisibleBoundaries)(n, i, t, a),
                  c = l.rowVisibleStartIdx,
                  u = l.rowVisibleEndIdx,
                  h = (0, p.getRowOverscanStartIdx)(s, c),
                  f = (0, p.getRowOverscanEndIdx)(s, u, a),
                  m = d.default.getSize(o),
                  g = (0, p.findLastFrozenColumnIndex)(o),
                  v = (0, p.getNonFrozenVisibleColStartIdx)(o, r),
                  b = (0, p.getNonFrozenRenderedColumnCount)(this.props.columnMetrics, this.getDOMNodeOffsetWidth(), r),
                  y = Math.min(v + b, m);
                return {
                  height: n,
                  scrollTop: t,
                  scrollLeft: r,
                  rowVisibleStartIdx: c,
                  rowVisibleEndIdx: u,
                  rowOverscanStartIdx: h,
                  rowOverscanEndIdx: f,
                  colVisibleStartIdx: v,
                  colVisibleEndIdx: y,
                  colOverscanStartIdx: (0, p.getColOverscanStartIdx)(s, v, g),
                  colOverscanEndIdx: (0, p.getColOverscanEndIdx)(s, y, m),
                  scrollDirection: s,
                  lastFrozenColumnIndex: g,
                  isScrolling: !0,
                  prevScrollTop: this.state.scrollTop,
                  prevScrollLeft: this.state.scrollTop
                };
              }
            }, {
              key: "componentWillReceiveProps",
              value: function value(e) {
                var t = e.rowHeight,
                  r = e.rowsCount;
                if (this.props.rowHeight !== e.rowHeight || this.props.minHeight !== e.minHeight) {
                  var n = (0, p.getGridState)(e),
                    i = n.scrollTop,
                    a = n.scrollLeft,
                    o = n.height;
                  this.updateScroll({
                    scrollTop: i,
                    scrollLeft: a,
                    height: o,
                    rowHeight: t,
                    rowsCount: r
                  });
                } else if (d.default.getSize(this.props.columnMetrics.columns) !== d.default.getSize(e.columnMetrics.columns)) this.setState((0, p.getGridState)(e));else if (this.props.rowsCount !== e.rowsCount) {
                  var s = this.state,
                    l = s.scrollTop,
                    c = s.scrollLeft,
                    u = s.height;
                  this.updateScroll({
                    scrollTop: l,
                    scrollLeft: c,
                    height: u,
                    rowHeight: t,
                    rowsCount: r
                  });
                } else if (this.props.rowOffsetHeight !== e.rowOffsetHeight) {
                  var h = this.state,
                    f = h.scrollTop,
                    m = h.scrollLeft,
                    g = this.state.height + this.props.rowOffsetHeight - e.rowOffsetHeight;
                  this.updateScroll({
                    scrollTop: f,
                    scrollLeft: m,
                    height: g,
                    rowHeight: t,
                    rowsCount: r
                  });
                }
              }
            }, {
              key: "componentDidMount",
              value: function value() {
                window.addEventListener("resize", this.metricsUpdated), this.metricsUpdated();
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                window.removeEventListener("resize", this.metricsUpdated), this.clearScrollTimer();
              }
            }, {
              key: "render",
              value: function value() {
                var e = {
                  padding: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  overflow: "hidden",
                  position: "absolute",
                  top: this.props.rowOffsetHeight
                };
                return m.createElement("div", {
                  className: "react-grid-Viewport",
                  style: e,
                  ref: this.setViewportRef
                }, m.createElement(g, {
                  ref: this.setCanvasRef,
                  rowKey: this.props.rowKey,
                  totalWidth: this.props.totalWidth,
                  width: this.props.columnMetrics.width,
                  totalColumnWidth: this.props.columnMetrics.totalColumnWidth,
                  rowGetter: this.props.rowGetter,
                  rowsCount: this.props.rowsCount,
                  selectedRows: this.props.selectedRows,
                  expandedRows: this.props.expandedRows,
                  columns: this.props.columnMetrics.columns,
                  rowRenderer: this.props.rowRenderer,
                  rowOverscanStartIdx: this.state.rowOverscanStartIdx,
                  rowOverscanEndIdx: this.state.rowOverscanEndIdx,
                  rowVisibleStartIdx: this.state.rowVisibleStartIdx,
                  rowVisibleEndIdx: this.state.rowVisibleEndIdx,
                  colVisibleStartIdx: this.state.colVisibleStartIdx,
                  colVisibleEndIdx: this.state.colVisibleEndIdx,
                  colOverscanStartIdx: this.state.colOverscanStartIdx,
                  colOverscanEndIdx: this.state.colOverscanEndIdx,
                  lastFrozenColumnIndex: this.state.lastFrozenColumnIndex,
                  cellMetaData: this.props.cellMetaData,
                  height: this.state.height,
                  rowHeight: this.props.rowHeight,
                  onScroll: this.onScroll,
                  onRows: this.props.onRows,
                  rowScrollTimeout: this.props.rowScrollTimeout,
                  scrollToRowIndex: this.props.scrollToRowIndex,
                  contextMenu: this.props.contextMenu,
                  rowSelection: this.props.rowSelection,
                  getSubRowDetails: this.props.getSubRowDetails,
                  rowGroupRenderer: this.props.rowGroupRenderer,
                  isScrolling: this.state.isScrolling || !1,
                  enableCellSelect: this.props.enableCellSelect,
                  enableCellAutoFocus: this.props.enableCellAutoFocus,
                  cellNavigationMode: this.props.cellNavigationMode,
                  eventBus: this.props.eventBus,
                  onCheckCellIsEditable: this.props.onCheckCellIsEditable,
                  onCellCopyPaste: this.props.onCellCopyPaste,
                  onGridRowsUpdated: this.props.onGridRowsUpdated,
                  onDragHandleDoubleClick: this.props.onDragHandleDoubleClick,
                  onCellSelected: this.props.onCellSelected,
                  onCellDeSelected: this.props.onCellDeSelected,
                  onCellRangeSelectionStarted: this.props.onCellRangeSelectionStarted,
                  onCellRangeSelectionUpdated: this.props.onCellRangeSelectionUpdated,
                  onCellRangeSelectionCompleted: this.props.onCellRangeSelectionCompleted,
                  onCommit: this.props.onCommit,
                  RowsContainer: this.props.RowsContainer,
                  prevScrollLeft: this.state.prevScrollLeft,
                  prevScrollTop: this.state.prevScrollTop
                }));
              }
            }]), t;
          }(m.Component);
        v.displayName = "Viewport", v.propTypes = {
          rowOffsetHeight: h.default.number.isRequired,
          totalWidth: h.default.oneOfType([h.default.number, h.default.string]).isRequired,
          columnMetrics: h.default.object.isRequired,
          rowGetter: h.default.oneOfType([h.default.array, h.default.func]).isRequired,
          selectedRows: h.default.array,
          rowSelection: h.default.oneOfType([h.default.shape({
            indexes: h.default.arrayOf(h.default.number).isRequired
          }), h.default.shape({
            isSelectedKey: h.default.string.isRequired
          }), h.default.shape({
            keys: h.default.shape({
              values: h.default.array.isRequired,
              rowKey: h.default.string.isRequired
            }).isRequired
          })]),
          expandedRows: h.default.array,
          rowRenderer: h.default.oneOfType([h.default.element, h.default.func]),
          rowsCount: h.default.number.isRequired,
          rowHeight: h.default.number.isRequired,
          onRows: h.default.func,
          onScroll: h.default.func,
          minHeight: h.default.number,
          cellMetaData: h.default.shape(c.default),
          rowKey: h.default.string.isRequired,
          rowScrollTimeout: h.default.number,
          scrollToRowIndex: h.default.number,
          contextMenu: h.default.element,
          getSubRowDetails: h.default.func,
          rowGroupRenderer: h.default.func,
          enableCellSelect: h.default.bool.isRequired,
          enableCellAutoFocus: h.default.bool.isRequired,
          cellNavigationMode: h.default.string.isRequired,
          eventBus: h.default.object.isRequired,
          onCheckCellIsEditable: h.default.func,
          onCellCopyPaste: h.default.func,
          onGridRowsUpdated: h.default.func.isRequired,
          onDragHandleDoubleClick: h.default.func.isRequired,
          onCellSelected: h.default.func,
          onCellDeSelected: h.default.func,
          onCellRangeSelectionStarted: h.default.func,
          onCellRangeSelectionUpdated: h.default.func,
          onCellRangeSelectionCompleted: h.default.func,
          onCommit: h.default.func.isRequired,
          RowsContainer: h.default.node
        }, v.defaultProps = {
          rowHeight: 30
        }, e.exports = v;
      }, function (e, t, r) {
        "use strict";

        e.exports = {
          SimpleCellFormatter: r(137),
          SelectAll: r(136)
        };
      }, function (e, t, r) {
        "use strict";

        var n = r(270),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n);
        e.exports = {
          test: {
            GridPropHelpers: i.default
          }
        };
      }, function (e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        for (var r = [], n = 0; n < 1e3; n++) r.push({
          id: n,
          title: "Title " + n,
          count: 1e3 * n
        });
        t.default = {
          columns: [{
            key: "id",
            name: "ID",
            width: 100
          }, {
            key: "title",
            name: "Title",
            width: 100
          }, {
            key: "count",
            name: "Count",
            width: 100
          }],
          rowGetter: function rowGetter(e) {
            return r[e];
          },
          rowsCount: function rowsCount() {
            return r.length;
          },
          cellMetaData: {
            selected: {
              idx: 2,
              rowIdx: 3
            },
            dragged: null,
            copied: null
          }
        };
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var i = r(264),
          a = n(i),
          o = r(44),
          s = n(o),
          l = r(131),
          c = n(l);
        e.exports = a.default, e.exports.Row = r(135), e.exports.Cell = c.default, e.exports.HeaderCell = r(133), e.exports.RowComparer = s.default, e.exports.EmptyChildRow = r(259), e.exports.editors = r(43), e.exports.formatters = r(268), e.exports.shapes = r(99), e.exports._constants = r(11), e.exports._helpers = r(269);
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e) {
          var t = e.copiedPosition,
            r = e.columns,
            n = e.rowHeight,
            i = (0, u.getSelectedDimensions)({
              selectedPosition: t,
              columns: r,
              rowHeight: n
            });
          return s.default.createElement(f.default, a({}, i, {
            className: "react-grid-cell-copied"
          }));
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var a = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          o = r(2),
          s = n(o),
          l = r(3),
          c = n(l),
          u = r(49),
          h = r(48),
          f = n(h);
        i.propTypes = {
          copiedPosition: c.default.object.isRequired,
          columns: c.default.array.isRequired,
          rowHeight: c.default.number.isRequired
        }, t.default = i;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e) {
          var t = e.onDragStart,
            r = e.onDragEnd,
            n = e.onDoubleClick;
          return o.default.createElement("div", {
            className: "drag-handle",
            draggable: "true",
            onDragStart: t,
            onDragEnd: r,
            onDoubleClick: n
          });
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var a = r(2),
          o = n(a),
          s = r(3),
          l = n(s);
        i.propTypes = {
          onDragStart: l.default.func.isRequired,
          onDragEnd: l.default.func.isRequired,
          onDoubleClick: l.default.func.isRequired
        }, t.default = i;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e) {
          var t = e.draggedPosition,
            r = e.columns,
            n = e.rowHeight,
            i = t.overRowIdx,
            o = t.idx,
            l = t.rowIdx;
          if (null != i && l !== i) {
            for (var c = l < i, h = c ? l + 1 : i, d = c ? i : l - 1, p = c ? "react-grid-cell-dragged-over-down" : "react-grid-cell-dragged-over-up", m = (0, u.getSelectedDimensions)({
                selectedPosition: {
                  idx: o,
                  rowIdx: h
                },
                columns: r,
                rowHeight: n
              }), g = h + 1; g <= d; g++) {
              var v = (0, u.getSelectedDimensions)({
                  selectedPosition: {
                    idx: o,
                    rowIdx: g
                  },
                  columns: r,
                  rowHeight: n
                }),
                b = v.height;
              m.height += b;
            }
            return s.default.createElement(f.default, a({}, m, {
              className: p
            }));
          }
          return null;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var a = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          o = r(2),
          s = n(o),
          l = r(3),
          c = n(l),
          u = r(49),
          h = r(48),
          f = n(h);
        i.propTypes = {
          draggedPosition: c.default.object.isRequired,
          columns: c.default.array.isRequired,
          rowHeight: c.default.number.isRequired
        }, t.default = i;
      }, function (e, t) {
        "use strict";

        function r(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          i = function () {
            function e() {
              r(this, e), this.subscribers = {};
            }
            return n(e, [{
              key: "subscribe",
              value: function value(e, t) {
                this.subscribers[e] || (this.subscribers[e] = []);
                var r = this.subscribers[e];
                return r.push(t), function () {
                  var e = r.indexOf(t);
                  e > 0 && r.splice(e, 1);
                };
              }
            }, {
              key: "dispatch",
              value: function value(e) {
                for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
                var i = this.subscribers[e];
                Array.isArray(i) && i.forEach(function (e) {
                  return e.apply(void 0, r);
                });
              }
            }]), e;
          }();
        t.default = i;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          return t.default = e, t;
        }
        function i(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function a(e, t, r) {
          return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = r, e;
        }
        function o(e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }
        function s(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function l(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function c(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var u = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          h = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          f = r(2),
          d = i(f),
          p = r(3),
          m = i(p),
          g = r(277),
          v = i(g),
          b = r(278),
          y = i(b),
          w = r(272),
          x = i(w),
          _ = r(274),
          S = i(_),
          C = r(273),
          E = i(C),
          A = r(217),
          T = i(A),
          k = r(11),
          R = r(126),
          I = r(49),
          M = r(5),
          O = r(6),
          P = n(O),
          B = r(134),
          D = n(B);
        r(391);
        var L = function (e) {
          function t() {
            var e, r, n, i;
            s(this, t);
            for (var a = arguments.length, o = Array(a), c = 0; c < a; c++) o[c] = arguments[c];
            return r = n = l(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(o))), F.call(n), i = r, l(n, i);
          }
          return c(t, e), h(t, [{
            key: "componentDidUpdate",
            value: function value(e, t) {
              var r = this.state,
                n = r.selectedPosition,
                i = r.isEditorEnabled,
                a = t.selectedPosition,
                o = t.isEditorEnabled,
                s = n !== a && (n.rowIdx !== a.rowIdx || n.idx !== a.idx),
                l = i !== o && !i;
              if (s) {
                var c = this.props,
                  h = c.onCellSelected,
                  f = c.onCellDeSelected;
                (0, M.isFunction)(f) && this.isCellWithinBounds(a) && f(u({}, a)), (0, M.isFunction)(h) && this.isCellWithinBounds(n) && h(u({}, n));
              }
              (s && this.isCellWithinBounds(n) || l) && this.focus();
            }
          }, {
            key: "componentDidMount",
            value: function value() {
              var e = this.props,
                t = e.eventBus,
                r = e.enableCellAutoFocus;
              this.unsubscribeSelectCell = t.subscribe(k.EventTypes.SELECT_CELL, this.selectCell), this.unsubscribeSelectStart = t.subscribe(k.EventTypes.SELECT_START, this.onSelectCellRangeStarted), this.unsubscribeSelectUpdate = t.subscribe(k.EventTypes.SELECT_UPDATE, this.onSelectCellRangeUpdated), this.unsubscribeSelectEnd = t.subscribe(k.EventTypes.SELECT_END, this.onSelectCellRangeEnded), this.unsubscribeDragEnter = t.subscribe(k.EventTypes.DRAG_ENTER, this.handleDragEnter), r && this.isFocusedOnBody() && this.selectFirstCell();
            }
          }, {
            key: "componentWillUnmount",
            value: function value() {
              this.unsubscribeSelectCell(), this.unsubscribeSelectStart(), this.unsubscribeSelectUpdate(), this.unsubscribeSelectEnd(), this.unsubscribeDragEnter();
            }
          }, {
            key: "isKeyboardNavigationEvent",
            value: function value(e) {
              return null != this.getKeyNavActionFromEvent(e);
            }
          }, {
            key: "isGroupedRowSelected",
            value: function value() {
              var e = this.props.rowGetter,
                t = this.state.selectedPosition,
                r = (0, I.getSelectedRow)({
                  selectedPosition: t,
                  rowGetter: e
                });
              return !(!r || !r.__metaData) && r.__metaData.isGroup;
            }
          }, {
            key: "getKeyNavActionFromEvent",
            value: function value(e) {
              var t = this.props,
                r = t.rowVisibleEndIdx,
                n = t.rowVisibleStartIdx,
                i = t.colVisibleEndIdx,
                a = t.colVisibleStartIdx,
                o = t.onHitBottomBoundary,
                s = t.onHitRightBoundary,
                l = t.onHitLeftBoundary,
                c = t.onHitTopBoundary,
                h = function h(e) {
                  return e.rowIdx >= r - 2;
                },
                f = function f(e) {
                  return 0 !== e.rowIdx && e.rowIdx <= n - 1;
                },
                d = function d(e) {
                  return 0 !== e.idx && e.idx >= i - 1;
                },
                p = function p(e) {
                  return 0 !== e.idx && e.idx <= a + 1;
                },
                m = {
                  ArrowDown: {
                    getNext: function getNext(e) {
                      return u({}, e, {
                        rowIdx: e.rowIdx + 1
                      });
                    },
                    isCellAtBoundary: h,
                    onHitBoundary: o
                  },
                  ArrowUp: {
                    getNext: function getNext(e) {
                      return u({}, e, {
                        rowIdx: e.rowIdx - 1
                      });
                    },
                    isCellAtBoundary: f,
                    onHitBoundary: c
                  },
                  ArrowRight: {
                    getNext: function getNext(e) {
                      return u({}, e, {
                        idx: e.idx + 1
                      });
                    },
                    isCellAtBoundary: d,
                    onHitBoundary: function onHitBoundary(e) {
                      s(e), h(e) && o(e);
                    }
                  },
                  ArrowLeft: {
                    getNext: function getNext(e) {
                      return u({}, e, {
                        idx: e.idx - 1
                      });
                    },
                    isCellAtBoundary: p,
                    onHitBoundary: function onHitBoundary(e) {
                      l(e), f(e) && c(e);
                    }
                  }
                };
              return e.keyCode === D.Tab ? !0 === e.shiftKey ? m.ArrowLeft : m.ArrowRight : m[e.key];
            }
          }, {
            key: "changeCellFromEvent",
            value: function value(e) {
              e.preventDefault();
              var t = e.keyCode === D.Tab,
                r = e.shiftKey;
              if (t) {
                var n = this.props.cellNavigationMode === k.CellNavigationMode.NONE ? k.CellNavigationMode.CHANGE_ROW : this.props.cellNavigationMode;
                this.changeCellFromKeyAction(e, n);
              } else r ? this.changeSelectedRangeFromArrowKeyAction(e) : this.changeCellFromKeyAction(e, this.props.cellNavigationMode);
            }
          }, {
            key: "changeCellFromKeyAction",
            value: function value(e, t) {
              var r = this.state.selectedPosition,
                n = this.getKeyNavActionFromEvent(e),
                i = this.getNextSelectedCellPositionForKeyNavAction(n, r, t);
              this.checkIsAtGridBoundary(n, i);
              var a = (i.changeRowOrColumn, o(i, ["changeRowOrColumn"]));
              this.selectCell(a);
            }
          }, {
            key: "changeSelectedRangeFromArrowKeyAction",
            value: function value(e) {
              var t = this,
                r = this.props.cellNavigationMode,
                n = this.state.selectedRange.cursorCell || this.state.selectedPosition,
                i = this.getKeyNavActionFromEvent(e),
                a = this.getNextSelectedCellPositionForKeyNavAction(i, n, r);
              this.checkIsAtGridBoundary(i, a);
              var s = (a.changeRowOrColumn, o(a, ["changeRowOrColumn"]));
              this.onSelectCellRangeUpdated(s, !0, function () {
                t.onSelectCellRangeEnded();
              });
            }
          }, {
            key: "getNextSelectedCellPositionForKeyNavAction",
            value: function value(e, t, r) {
              var n = e.getNext,
                i = n(t),
                a = this.props,
                o = a.columns,
                s = a.rowsCount;
              return (0, I.getNextSelectedCellPosition)({
                columns: o,
                rowsCount: s,
                cellNavigationMode: r
              }, i);
            }
          }, {
            key: "checkIsAtGridBoundary",
            value: function value(e, t) {
              var r = e.isCellAtBoundary,
                n = e.onHitBoundary,
                i = t.changeRowOrColumn,
                a = o(t, ["changeRowOrColumn"]);
              (r(a) || i) && n(a);
            }
          }, {
            key: "createSingleCellSelectedRange",
            value: function value(e, t) {
              return {
                topLeft: e,
                bottomRight: e,
                startCell: e,
                cursorCell: e,
                isDragging: t
              };
            }
          }, {
            key: "render",
            value: function value() {
              var e = this.props,
                t = e.rowGetter,
                r = e.contextMenu,
                n = e.rowHeight,
                i = e.getSelectedRowColumns,
                a = this.state,
                o = a.isEditorEnabled,
                s = a.firstEditorKeyPress,
                l = a.selectedPosition,
                c = a.draggedPosition,
                h = a.copiedPosition,
                p = (0, I.getSelectedRow)({
                  selectedPosition: l,
                  rowGetter: t
                }),
                m = i(l.rowIdx);
              return d.default.createElement("div", {
                onKeyDown: this.onKeyDown,
                onFocus: this.onFocus
              }, h && d.default.createElement(x.default, {
                copiedPosition: h,
                rowHeight: n,
                columns: i(h.rowIdx)
              }), c && d.default.createElement(S.default, {
                draggedPosition: c,
                rowHeight: n,
                columns: i(c.rowIdx)
              }), (0, I.selectedRangeIsSingleCell)(this.state.selectedRange) ? this.getSingleCellSelectView() : this.getCellRangeSelectView(), o && d.default.createElement(T.default, u({
                firstEditorKeyPress: s,
                onCommit: this.onCommit,
                onCommitCancel: this.onCommitCancel,
                rowIdx: l.rowIdx,
                value: (0, I.getSelectedCellValue)({
                  selectedPosition: l,
                  columns: m,
                  rowGetter: t
                }),
                rowData: p,
                column: (0, I.getSelectedColumn)({
                  selectedPosition: l,
                  columns: m
                }),
                scrollLeft: this.props.scrollLeft,
                scrollTop: this.props.scrollTop
              }, (0, I.getSelectedDimensions)({
                selectedPosition: l,
                rowHeight: n,
                columns: m
              }))), (0, f.isValidElement)(r) && (0, f.cloneElement)(r, u({}, l)));
            }
          }]), t;
        }(d.default.Component);
        L.propTypes = {
          colVisibleStartIdx: m.default.number.isRequired,
          colVisibleEndIdx: m.default.number.isRequired,
          rowVisibleStartIdx: m.default.number.isRequired,
          rowVisibleEndIdx: m.default.number.isRequired,
          rowOverscanStartIdx: m.default.number.isRequired,
          columns: m.default.array,
          width: m.default.number,
          rowHeight: m.default.number.isRequired,
          rowGetter: m.default.func.isRequired,
          rowsCount: m.default.number.isRequired,
          enableCellSelect: m.default.bool.isRequired,
          enableCellAutoFocus: m.default.bool.isRequired,
          cellNavigationMode: m.default.oneOf([k.CellNavigationMode.NONE, k.CellNavigationMode.LOOP_OVER_ROW, k.CellNavigationMode.CHANGE_ROW]).isRequired,
          eventBus: m.default.object.isRequired,
          contextMenu: m.default.element,
          onCheckCellIsEditable: m.default.func,
          onCellCopyPaste: m.default.func,
          onGridRowsUpdated: m.default.func.isRequired,
          onHitBottomBoundary: m.default.func.isRequired,
          onHitTopBoundary: m.default.func.isRequired,
          onHitRightBoundary: m.default.func.isRequired,
          onHitLeftBoundary: m.default.func.isRequired,
          onCommit: m.default.func.isRequired,
          onCommitCancel: m.default.func,
          onCellSelected: m.default.func,
          onCellDeSelected: m.default.func,
          onCellRangeSelectionStarted: m.default.func,
          onCellRangeSelectionUpdated: m.default.func,
          onCellRangeSelectionCompleted: m.default.func,
          onCellsDragged: m.default.func,
          onDragHandleDoubleClick: m.default.func.isRequired,
          scrollLeft: m.default.number.isRequired,
          prevScrollLeft: m.default.number.isRequired,
          scrollTop: m.default.number.isRequired,
          prevScrollTop: m.default.number.isRequired,
          rows: m.default.array.isRequired,
          getSelectedRowHeight: m.default.func.isRequired,
          getSelectedRowTop: m.default.func.isRequired,
          getSelectedRowColumns: m.default.func.isRequired
        };
        var F = function F() {
          var e = this;
          this.state = {
            selectedPosition: {
              idx: -1,
              rowIdx: -1
            },
            selectedRange: {
              topLeft: {
                idx: -1,
                rowIdx: -1
              },
              bottomRight: {
                idx: -1,
                rowIdx: -1
              }
            },
            copiedPosition: null,
            draggedPosition: null,
            frozenPosition: null,
            isEditorEnabled: !1,
            firstEditorKeyPress: null
          }, this.onKeyDown = function (t) {
            (0, R.isCtrlKeyHeldDown)(t) ? e.onPressKeyWithCtrl(t) : t.keyCode === D.Escape ? e.onPressEscape(t) : t.keyCode === D.Tab ? e.onPressTab(t) : e.isKeyboardNavigationEvent(t) ? e.changeCellFromEvent(t) : ((0, R.isKeyPrintable)(t.keyCode) || -1 !== [D.Backspace, D.Delete, D.Enter].indexOf(t.keyCode)) && e.openEditor(t);
          }, this.isSelectedCellEditable = function () {
            var t = e.props,
              r = t.enableCellSelect,
              n = t.columns,
              i = t.rowGetter,
              a = t.onCheckCellIsEditable,
              o = e.state.selectedPosition;
            return (0, I.isSelectedCellEditable)({
              enableCellSelect: r,
              columns: n,
              rowGetter: i,
              selectedPosition: o,
              onCheckCellIsEditable: a
            });
          }, this.openEditor = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = t.key;
            e.isSelectedCellEditable() && !e.state.isEditorEnabled && e.setState({
              isEditorEnabled: !0,
              firstEditorKeyPress: r
            });
          }, this.closeEditor = function () {
            e.setState({
              isEditorEnabled: !1,
              firstEditorKeyPress: null
            });
          }, this.onPressKeyWithCtrl = function (t) {
            var r = t.keyCode;
            if (e.copyPasteEnabled()) if (r === D.c) {
              var n = e.props,
                i = n.columns,
                a = n.rowGetter,
                o = e.state.selectedPosition,
                s = (0, I.getSelectedCellValue)({
                  selectedPosition: o,
                  columns: i,
                  rowGetter: a
                });
              e.handleCopy({
                value: s
              });
            } else r === D.v && e.handlePaste();
          }, this.onFocus = function (t) {
            var r = !0 === t.shiftKey,
              n = e.state.selectedPosition,
              i = n.idx,
              a = n.rowIdx;
            -1 === i && -1 === a && (r ? e.selectLastCell() : e.selectFirstCell());
          }, this.onPressTab = function (t) {
            var r = e.props,
              n = r.cellNavigationMode,
              i = r.columns,
              a = r.rowsCount,
              o = e.state,
              s = o.selectedPosition,
              l = o.isEditorEnabled;
            if (0 !== a) return (0, I.canExitGrid)(t, {
              cellNavigationMode: n,
              columns: i,
              rowsCount: a,
              selectedPosition: s
            }) ? l ? void e.closeEditor() : void e.setState({
              selectedPosition: {
                idx: -1,
                rowIdx: -1
              }
            }) : void e.changeCellFromEvent(t);
          }, this.onPressEscape = function () {
            e.copyPasteEnabled() && (e.handleCancelCopy(), e.closeEditor());
          }, this.copyPasteEnabled = function () {
            return null !== e.props.onCellCopyPaste && e.isSelectedCellEditable();
          }, this.handleCopy = function (t) {
            var r = t.value,
              n = e.state.selectedPosition,
              i = n.rowIdx,
              a = n.idx;
            e.setState({
              copiedPosition: {
                rowIdx: i,
                idx: a,
                value: r
              }
            });
          }, this.handleCancelCopy = function () {
            e.setState({
              copiedPosition: null
            });
          }, this.handlePaste = function () {
            var t = e.props,
              r = t.columns,
              n = t.onCellCopyPaste,
              i = t.onGridRowsUpdated,
              o = e.state,
              s = o.selectedPosition,
              l = o.copiedPosition,
              c = s.rowIdx;
            if (null != l) {
              var u = (0, I.getSelectedColumn)({
                  selectedPosition: s,
                  columns: r
                }),
                h = u.key,
                f = l.rowIdx,
                d = l.value;
              (0, M.isFunction)(n) && n({
                cellKey: h,
                rowIdx: rowIdx,
                fromRow: f,
                toRow: c,
                value: d
              }), i(h, c, c, a({}, h, d), k.UpdateActions.COPY_PASTE, f);
            }
          }, this.isCellWithinBounds = function (t) {
            var r = t.idx,
              n = t.rowIdx,
              i = e.props,
              a = i.columns,
              o = i.rowsCount;
            return n >= 0 && n < o && r >= 0 && r < P.getSize(a);
          }, this.isGridSelected = function () {
            return e.isCellWithinBounds(e.state.selectedPosition);
          }, this.isFocused = function () {
            return document.activeElement === e.selectionMask;
          }, this.isFocusedOnBody = function () {
            return document.activeElement === document.body;
          }, this.focus = function () {
            e.selectionMask && !e.isFocused() && e.selectionMask.focus();
          }, this.selectFirstCell = function () {
            e.selectCell({
              rowIdx: 0,
              idx: 0
            });
          }, this.selectLastCell = function () {
            var t = e.props,
              r = t.rowsCount,
              n = t.columns;
            e.selectCell({
              rowIdx: r - 1,
              idx: P.getSize(n) - 1
            });
          }, this.selectCell = function (t, r) {
            var n = r ? e.openEditor : function () {
              return null;
            };
            e.setState(function (r) {
              var n = u({}, r.selectedPosition, t);
              return e.isCellWithinBounds(n) ? {
                selectedPosition: n,
                prevSelectedPosition: t,
                selectedRange: {
                  topLeft: n,
                  bottomRight: n,
                  startCell: n,
                  cursorCell: n,
                  isDragging: !1
                }
              } : r;
            }, n);
          }, this.onSelectCellRangeStarted = function (t) {
            e.setState({
              selectedRange: e.createSingleCellSelectedRange(t, !0),
              selectedPosition: t
            }, function () {
              (0, M.isFunction)(e.props.onCellRangeSelectionStarted) && e.props.onCellRangeSelectionStarted(e.state.selectedRange);
            });
          }, this.onSelectCellRangeUpdated = function (t, r, n) {
            if ((e.state.selectedRange.isDragging || r) && e.isCellWithinBounds(t)) {
              var i = e.state.selectedRange.startCell || e.state.selectedPosition,
                a = [i.idx, t.idx].sort(function (e, t) {
                  return e - t;
                }),
                o = [i.rowIdx, t.rowIdx].sort(function (e, t) {
                  return e - t;
                }),
                s = {
                  idx: a[0],
                  rowIdx: o[0]
                },
                l = {
                  idx: a[1],
                  rowIdx: o[1]
                },
                c = u({
                  startCell: e.state.selectedPosition
                }, e.state.selectedRange, {
                  topLeft: s,
                  bottomRight: l,
                  cursorCell: t
                });
              e.setState({
                selectedRange: c
              }, function () {
                (0, M.isFunction)(e.props.onCellRangeSelectionUpdated) && e.props.onCellRangeSelectionUpdated(e.state.selectedRange), (0, M.isFunction)(n) && n();
              });
            }
          }, this.onSelectCellRangeEnded = function () {
            var t = u({}, e.state.selectedRange, {
              isDragging: !1
            });
            e.setState({
              selectedRange: t
            }, function () {
              (0, M.isFunction)(e.props.onCellRangeSelectionCompleted) && e.props.onCellRangeSelectionCompleted(e.state.selectedRange), e.focus();
            });
          }, this.isDragEnabled = function () {
            var t = e.props,
              r = t.onGridRowsUpdated,
              n = t.onCellsDragged;
            return e.isSelectedCellEditable() && ((0, M.isFunction)(r) || (0, M.isFunction)(n));
          }, this.handleDragStart = function (t) {
            var r = e.state.selectedPosition,
              n = r.idx,
              i = r.rowIdx,
              a = t && t.target && t.target.className;
            if (n > -1 && a) {
              t.dataTransfer.effectAllowed = "copy";
              var o = JSON.stringify({
                idx: n,
                rowIdx: i
              });
              try {
                t.dataTransfer.setData("text/plain", o);
              } catch (e) {
                t.dataTransfer.setData("text", o);
              }
              e.setState({
                draggedPosition: {
                  idx: n,
                  rowIdx: i
                }
              });
            }
          }, this.handleDragEnter = function (t) {
            var r = t.overRowIdx;
            null != e.state.draggedPosition && e.setState(function (e) {
              var t = e.draggedPosition;
              return {
                draggedPosition: u({}, t, {
                  overRowIdx: r
                })
              };
            });
          }, this.handleDragEnd = function () {
            var t = e.state.draggedPosition;
            if (null != t) {
              var r = t.rowIdx,
                n = t.overRowIdx;
              if (null != n) {
                var i = e.props,
                  o = i.columns,
                  s = i.onCellsDragged,
                  l = i.onGridRowsUpdated,
                  c = i.rowGetter,
                  u = (0, I.getSelectedColumn)({
                    selectedPosition: t,
                    columns: o
                  }),
                  h = (0, I.getSelectedCellValue)({
                    selectedPosition: t,
                    columns: o,
                    rowGetter: c
                  }),
                  f = u.key,
                  d = r < n ? r : n,
                  p = r > n ? r : n;
                (0, M.isFunction)(s) && s({
                  cellKey: f,
                  fromRow: d,
                  toRow: p,
                  value: h
                }), (0, M.isFunction)(l) && l(f, d, p, a({}, f, h), k.UpdateActions.CELL_DRAG);
              }
              e.setState({
                draggedPosition: null
              });
            }
          }, this.onDragHandleDoubleClick = function () {
            var t = e.props,
              r = t.onDragHandleDoubleClick,
              n = t.rowGetter,
              i = e.state.selectedPosition;
            r({
              idx: i.idx,
              rowIdx: i.rowIdx,
              rowData: (0, I.getSelectedRow)({
                selectedPosition: i,
                rowGetter: n
              })
            });
          }, this.onCommit = function () {
            var t;
            (t = e.props).onCommit.apply(t, arguments), e.closeEditor();
          }, this.onCommitCancel = function () {
            e.closeEditor();
          }, this.setSelectionMaskRef = function (t) {
            e.selectionMask = t;
          }, this.getSelectionMaskProps = function () {
            var t = e.props,
              r = t.columns,
              n = t.getSelectedRowHeight,
              i = t.getSelectedRowTop,
              a = t.scrollLeft;
            return {
              columns: r,
              scrollTop: t.scrollTop,
              scrollLeft: a,
              getSelectedRowHeight: n,
              getSelectedRowTop: i,
              prevScrollLeft: t.prevScrollLeft,
              prevScrollTop: t.prevScrollTop,
              prevSelectedPosition: e.state.prevSelectedPosition,
              isGroupedRow: e.isGroupedRowSelected(),
              innerRef: e.setSelectionMaskRef
            };
          }, this.getSingleCellSelectView = function () {
            var t = e.state.selectedPosition;
            return !e.state.isEditorEnabled && e.isGridSelected() && d.default.createElement(v.default, u({
              selectedPosition: t
            }, e.getSelectionMaskProps()), e.isDragEnabled() && d.default.createElement(E.default, {
              onDragStart: e.handleDragStart,
              onDragEnd: e.handleDragEnd,
              onDoubleClick: e.onDragHandleDoubleClick
            }));
          }, this.getCellRangeSelectView = function () {
            var t = e.props,
              r = t.columns,
              n = t.rowHeight;
            return [d.default.createElement(y.default, {
              key: "range-mask",
              selectedRange: e.state.selectedRange,
              columns: r,
              rowHeight: n
            }), d.default.createElement(v.default, u({
              key: "selection-mask",
              selectedPosition: e.state.selectedRange.startCell
            }, e.getSelectionMaskProps()))];
          };
        };
        t.default = L;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }
        function a(e) {
          var t = e.children,
            r = e.innerRef,
            n = i(e, ["children", "innerRef"]),
            a = w(n),
            s = v(n.columns, n.selectedPosition),
            c = s && b(n) ? "fixed" : "absolute";
          return l.default.createElement(f.default, o({}, a, {
            className: "rdg-selected",
            position: c,
            innerRef: r,
            tabIndex: "0"
          }), t);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getCellMaskDimensions = void 0;
        var o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          s = r(2),
          l = n(s),
          c = r(3),
          u = n(c),
          h = r(48),
          f = n(h),
          d = r(6),
          p = function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t.default = e, t;
          }(d),
          m = r(78),
          g = n(m),
          v = function v(e, t) {
            var r = t.idx;
            return p.isFrozen(p.getColumn(e, r));
          },
          b = function b(e) {
            var t = e.scrollTop,
              r = e.prevScrollTop,
              n = e.scrollLeft,
              i = e.prevScrollLeft,
              a = e.selectedPosition,
              o = e.prevSelectedPosition;
            return n !== i && t === r && a.idx === o.idx;
          },
          y = function y(e, t, r) {
            return e && !b(r) ? r.scrollLeft + t : t;
          },
          w = t.getCellMaskDimensions = function (e) {
            var t = e.selectedPosition,
              r = e.columns,
              n = e.getSelectedRowHeight,
              i = e.getSelectedRowTop,
              a = p.getColumn(r, t.idx),
              o = n(t.rowIdx),
              s = i(t.rowIdx),
              l = v(r, t),
              c = l ? g.default.FROZEN_CELL_MASK : g.default.CELL_MASK,
              u = y(l, a.left, e);
            return {
              height: o,
              top: s,
              width: a.width,
              left: u,
              zIndex: c
            };
          };
        a.propTypes = {
          selectedPosition: u.default.object.isRequired,
          columns: u.default.array.isRequired,
          innerRef: u.default.func
        }, t.default = a;
      }, function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e) {
          var t = e.selectedRange,
            r = e.columns,
            n = e.rowHeight,
            i = e.children,
            o = (0, u.getSelectedRangeDimensions)({
              selectedRange: t,
              columns: r,
              rowHeight: n
            });
          return s.default.createElement(f.default, a({}, o, {
            className: "rdg-selected-range"
          }), i);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var a = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          },
          o = r(2),
          s = n(o),
          l = r(3),
          c = n(l),
          u = r(49),
          h = r(48),
          f = n(h);
        i.propTypes = {
          selectedRange: c.default.shape({
            topLeft: c.default.shape({
              idx: c.default.number.isRequired,
              rowIdx: c.default.number.isRequired
            }).isRequired,
            bottomRight: c.default.shape({
              idx: c.default.number.isRequired,
              rowIdx: c.default.number.isRequired
            }).isRequired,
            startCell: c.default.shape({
              idx: c.default.number.isRequired,
              rowIdx: c.default.number.isRequired
            }).isRequired,
            cursorCell: c.default.shape({
              idx: c.default.number.isRequired,
              rowIdx: c.default.number.isRequired
            }).isRequired
          }).isRequired,
          columns: c.default.array.isRequired,
          rowHeight: c.default.number.isRequired
        }, t.default = i;
      }, function (e, t, r) {
        "use strict";

        function n(e, t, r, n) {
          for (var a = 0, o = 0, s = 0; s < t; s++) {
            var l = (0, i.getColumn)(e, s);
            l && (l.width && (a += l.width), (0, i.isFrozen)(l) && (o += l.width));
          }
          var c = (0, i.getColumn)(e, t);
          if (c) {
            var u = a - o - r,
              h = a + c.width - r;
            if (u < 0) return u;
            if (h > n) {
              return h - n;
            }
          }
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getColumnScrollPosition = void 0;
        var i = r(6);
        t.getColumnScrollPosition = n;
      }, function (e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getColOverscanEndIdx = t.getColOverscanStartIdx = t.getRowOverscanEndIdx = t.getRowOverscanStartIdx = t.getScrollDirection = t.getVisibleBoundaries = t.getNonFrozenRenderedColumnCount = t.getNonFrozenVisibleColStartIdx = t.findLastFrozenColumnIndex = t.getGridState = t.SCROLL_DIRECTION = t.OVERSCAN_ROWS = void 0;
        var n = r(6),
          i = function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          }(n),
          a = t.OVERSCAN_ROWS = 2,
          o = t.SCROLL_DIRECTION = {
            UP: "upwards",
            DOWN: "downwards",
            LEFT: "left",
            RIGHT: "right",
            NONE: "none"
          },
          s = Math.min,
          l = Math.max,
          c = Math.ceil,
          u = (t.getGridState = function (e) {
            var t = i.default.getSize(e.columnMetrics.columns),
              r = e.minHeight - e.rowOffsetHeight,
              n = c((e.minHeight - e.rowHeight) / e.rowHeight);
            return {
              rowOverscanStartIdx: 0,
              rowOverscanEndIdx: s(e.rowsCount, 2 * n),
              rowVisibleStartIdx: 0,
              rowVisibleEndIdx: n,
              height: r,
              scrollTop: 0,
              scrollLeft: 0,
              colVisibleStartIdx: 0,
              colVisibleEndIdx: t,
              colOverscanStartIdx: 0,
              colOverscanEndIdx: t,
              isScrolling: !1,
              lastFrozenColumnIndex: 0
            };
          }, t.findLastFrozenColumnIndex = function (e) {
            var t = -1;
            return e.forEach(function (e, r) {
              i.default.isFrozen(e) && (t = r);
            }), t;
          }),
          h = function h(e) {
            var t = u(e);
            if (t > -1) {
              var r = i.default.getColumn(e, t);
              return r.left + r.width;
            }
            return 0;
          },
          f = function f(e, t, r) {
            var n = {
              width: t,
              count: 0
            };
            return e.slice(r).reduce(function (e, t) {
              var r = e.width,
                n = e.count,
                i = r - t.width;
              return {
                width: i,
                count: i >= 0 ? n + 1 : n
              };
            }, n);
          },
          d = t.getNonFrozenVisibleColStartIdx = function (e, t) {
            for (var r = t, n = u(e), a = e.slice(n + 1), o = n; r >= 0 && o < i.default.getSize(a);) {
              o++;
              var s = i.default.getColumn(e, o);
              r -= s ? s.width : 0;
            }
            return Math.max(o, 0);
          };
        t.getNonFrozenRenderedColumnCount = function (e, t, r) {
          var n = e.columns;
          if (0 === i.default.getSize(n)) return 0;
          var a = d(e.columns, r),
            o = h(e.columns),
            s = t > 0 ? t : e.totalColumnWidth,
            l = i.default.getColumn(e.columns, a),
            c = o + r,
            u = c > l.left ? c - l.left : 0,
            p = s - o + u;
          return f(e.columns, p, a).count;
        }, t.getVisibleBoundaries = function (e, t, r, n) {
          var i = c(e / t),
            a = l(0, Math.round(r / t));
          return {
            rowVisibleStartIdx: a,
            rowVisibleEndIdx: s(a + i, n)
          };
        }, t.getScrollDirection = function (e, t, r) {
          return t !== e.scrollTop && void 0 !== e.scrollTop ? t - e.scrollTop >= 0 ? o.DOWN : o.UP : r !== e.scrollLeft && void 0 !== e.scrollLeft ? r - e.scrollLeft >= 0 ? o.RIGHT : o.LEFT : o.NONE;
        }, t.getRowOverscanStartIdx = function (e, t) {
          return e === o.UP ? l(0, t - a) : l(0, t);
        }, t.getRowOverscanEndIdx = function (e, t, r) {
          var n = t + a;
          return e === o.DOWN ? s(n, r) : t;
        }, t.getColOverscanStartIdx = function (e, t, r) {
          var n = r > -1 ? r + 1 : 0;
          return e === o.LEFT || e === o.RIGHT ? n : t;
        }, t.getColOverscanEndIdx = function (e, t, r) {
          return e === o.DOWN || e === o.UP ? t : r;
        };
      },, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, '.rdg-selected{border:2px solid #66afe9}.rdg-selected .drag-handle{pointer-events:auto;position:absolute;bottom:-5px;right:-4px;background:#66afe9;width:8px;height:8px;border:1px solid #fff;border-right:0;border-bottom:0;z-index:8;cursor:crosshair;cursor:-moz-grab;cursor:-webkit-grab;cursor:grab}.rdg-selected:hover .drag-handle{bottom:-8px;right:-7px;background:#fff;width:16px;height:16px;border:1px solid #66afe9}.rdg-selected:hover .drag-handle .glyphicon-arrow-down{display:"block"}.react-grid-cell-dragged-over-down,.react-grid-cell-dragged-over-up{border:1px dashed #000;background:rgba(0,0,255,.2)!important}.react-grid-cell-dragged-over-up{border-bottom-width:0}.react-grid-cell-dragged-over-down{border-top-width:0}.react-grid-cell-copied{background:rgba(0,0,255,.2)!important}.rdg-editor-container input.editor-main,select.editor-main{display:block;width:100%;height:34px;padding:6px 12px;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}input.editor-main:focus,select.editor-main:focus{border-color:#66afe9;border:2px solid #66afe9;background:#eee;border-radius:4px}.rdg-editor-container input.editor-main::-moz-placeholder,select.editor-main::-moz-placeholder{color:#999;opacity:1}.rdg-editor-container input.editor-main:-ms-input-placeholder,select.editor-main:-ms-input-placeholder{color:#999}.rdg-editor-container input.editor-main::-webkit-input-placeholder,select.editor-main::-webkit-input-placeholder{color:#999}.rdg-editor-container input.editor-main[disabled],.rdg-editor-container input.editor-main[readonly],fieldset[disabled] .rdg-editor-container input.editor-main,fieldset[disabled] select.editor-main,select.editor-main[disabled],select.editor-main[readonly]{cursor:not-allowed;background-color:#eee;opacity:1}textarea.rdg-editor-container input.editor-main,textareaselect.editor-main{height:auto}', ""]);
      }, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, ".react-grid-Container{clear:both;margin-top:0;padding:0}.react-grid-Main{background-color:#fff;color:inherit;padding:0;outline:1px solid #e7eaec;clear:both}.react-grid-Grid{border:1px solid #ddd;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-Canvas,.react-grid-Grid{background-color:#fff}", ""]);
      },, function (e, t, r) {
        t = e.exports = r(8)(), t.push([e.id, ".react-grid-Header{box-shadow:0 0 4px 0 #ddd;background:#f9f9f9}.react-grid-Header--resizing{cursor:ew-resize}.react-grid-HeaderCell,.react-grid-HeaderRow{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.react-grid-HeaderCell{background:#f9f9f9;padding:8px;font-weight:700;border-right:1px solid #ddd;border-bottom:1px solid #ddd}.react-grid-HeaderCell__value{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;position:relative;top:50%;transform:translateY(-50%)}.react-grid-HeaderCell__resizeHandle:hover{cursor:ew-resize;background:#ddd}.react-grid-HeaderCell--frozen:last-of-type{box-shadow:2px 0 5px -2px hsla(0,0%,53%,.3)}.react-grid-HeaderCell--resizing .react-grid-HeaderCell__resizeHandle{background:#ddd}.react-grid-HeaderCell__draggable{cursor:col-resize}.rdg-can-drop>.react-grid-HeaderCell{background:#ececec}.react-grid-HeaderCell .Select{max-height:30px;font-size:12px;font-weight:400}.react-grid-HeaderCell .Select-control{max-height:30px;border:1px solid #ccc;color:#555;border-radius:3px}.react-grid-HeaderCell .is-focused:not(.is-open)>.Select-control{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.react-grid-HeaderCell .Select-control .Select-placeholder{line-height:20px;color:#999;padding:4px}.react-grid-HeaderCell .Select-control .Select-input{max-height:28px;padding:4px;margin-left:0}.react-grid-HeaderCell .Select-control .Select-input input{padding:0;height:100%}.react-grid-HeaderCell .Select-control .Select-arrow-zone .Select-arrow{border-color:gray transparent transparent;border-width:4px 4px 2.5px}.react-grid-HeaderCell .Select-control .Select-value{padding:4px;line-height:20px!important}.react-grid-HeaderCell .Select--multi .Select-control .Select-value{padding:0;line-height:16px!important;max-height:20px}.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-icon,.react-grid-HeaderCell .Select--multi .Select-control .Select-value .Select-value-label{max-height:20px}.react-grid-HeaderCell .Select-control .Select-value .Select-value-label{color:#555!important}.react-grid-HeaderCell .Select-menu-outer{z-index:2}.react-grid-HeaderCell .Select-menu-outer .Select-option{padding:4px;line-height:20px}.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-focused,.react-grid-HeaderCell .Select-menu-outer .Select-menu .Select-option.is-selected{color:#555}", ""]);
      },,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, function (e, t) {
        "use strict";

        function r(e, t) {
          var r = !1;
          return function () {
            for (var n = arguments.length, i = Array(n), a = 0; a < n; a++) i[a] = arguments[a];
            var o = i[0],
              s = i[1],
              l = o[s];
            return void 0 === l || null === l || r || (r = !0, console.warn(t)), e.call.apply(e, [this].concat(i));
          };
        }
        function n(e) {
          var t = i({}, e);
          for (var n in t) if (t.hasOwnProperty(n)) {
            var a = t[n];
            a = a.bind(t), a.isDeprecated = r.bind(t, a), t[n] = a;
          }
          return t;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];
            for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
          return e;
        };
        t.deprecate = r, t.addIsDeprecated = n;
      },,,,,,,, function (e, t) {
        e.exports = function (e, t, r, n) {
          var i = r ? r.call(n, e, t) : void 0;
          if (void 0 !== i) return !!i;
          if (e === t) return !0;
          if ("object" != _typeof(e) || !e || "object" != _typeof(t) || !t) return !1;
          var a = Object.keys(e),
            o = Object.keys(t);
          if (a.length !== o.length) return !1;
          for (var s = Object.prototype.hasOwnProperty.bind(t), l = 0; l < a.length; l++) {
            var c = a[l];
            if (!s(c)) return !1;
            var u = e[c],
              h = t[c];
            if (!1 === (i = r ? r.call(n, u, h, c) : void 0) || void 0 === i && u !== h) return !1;
          }
          return !0;
        };
      },, function (e, t, r) {
        var n = r(282);
        "string" == typeof n && (n = [[e.id, n, ""]]);
        r(9)(n, {});
        n.locals && (e.exports = n.locals);
      }]);
    });
  }, function (e, t, r) {
    e.exports = r(350);
  }, function (e, t, r) {
    !function (t, n) {
      e.exports = n(r(2), r(149));
    }(0, function (e, t) {
      return function (e) {
        function t(n) {
          if (r[n]) return r[n].exports;
          var i = r[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.d = function (e, r, n) {
          t.o(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: n
          });
        }, t.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, t.t = function (e, r) {
          if (1 & r && (e = t(e)), 8 & r) return e;
          if (4 & r && "object" == _typeof(e) && e && e.__esModule) return e;
          var n = Object.create(null);
          if (t.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
          }), 2 & r && "string" != typeof e) for (var i in e) t.d(n, i, function (t) {
            return e[t];
          }.bind(null, i));
          return n;
        }, t.n = function (e) {
          var r = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return t.d(r, "a", r), r;
        }, t.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, t.p = "", t(t.s = 0);
      }([function (e, t, r) {
        "use strict";

        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function i(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function a(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
        }
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        function s(e) {
          return void 0 === e.width && (e.width = e.right - e.left), void 0 === e.height && (e.height = e.bottom - e.top), e;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          },
          c = function () {
            function e(e, t) {
              for (var r = 0; r < t.length; r++) {
                var n = t[r];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
              }
            }
            return function (t, r, n) {
              return r && e(t.prototype, r), n && e(t, n), t;
            };
          }(),
          u = r(1),
          h = n(u),
          f = r(2),
          d = n(f),
          p = r(3),
          m = n(p),
          g = r(6),
          v = n(g),
          b = function (e) {
            function t(e) {
              i(this, t);
              var r = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
              return r.getContainer = function () {
                return r.props.containment || window;
              }, r.addEventListener = function (e, t, n, i) {
                r.debounceCheck || (r.debounceCheck = {});
                var a = void 0,
                  o = void 0,
                  s = function s() {
                    a = null, r.check();
                  };
                o = i > -1 ? function () {
                  a || (a = setTimeout(s, i || 0));
                } : function () {
                  clearTimeout(a), a = setTimeout(s, n || 0);
                };
                var l = {
                  target: e,
                  fn: o,
                  getLastTimeout: function getLastTimeout() {
                    return a;
                  }
                };
                e.addEventListener(t, l.fn), r.debounceCheck[t] = l;
              }, r.startWatching = function () {
                r.debounceCheck || r.interval || (r.props.intervalCheck && (r.interval = setInterval(r.check, r.props.intervalDelay)), r.props.scrollCheck && r.addEventListener(r.getContainer(), "scroll", r.props.scrollDelay, r.props.scrollThrottle), r.props.resizeCheck && r.addEventListener(window, "resize", r.props.resizeDelay, r.props.resizeThrottle), !r.props.delayedCall && r.check());
              }, r.stopWatching = function () {
                if (r.debounceCheck) for (var e in r.debounceCheck) if (r.debounceCheck.hasOwnProperty(e)) {
                  var t = r.debounceCheck[e];
                  clearTimeout(t.getLastTimeout()), t.target.removeEventListener(e, t.fn), r.debounceCheck[e] = null;
                }
                r.debounceCheck = null, r.interval && (r.interval = clearInterval(r.interval));
              }, r.check = function () {
                var e = r.node,
                  t = void 0,
                  n = void 0;
                if (!e) return r.state;
                if (t = s(r.roundRectDown(e.getBoundingClientRect())), r.props.containment) {
                  var i = r.props.containment.getBoundingClientRect();
                  n = {
                    top: i.top,
                    left: i.left,
                    bottom: i.bottom,
                    right: i.right
                  };
                } else n = {
                  top: 0,
                  left: 0,
                  bottom: window.innerHeight || document.documentElement.clientHeight,
                  right: window.innerWidth || document.documentElement.clientWidth
                };
                var a = r.props.offset || {};
                "object" === (void 0 === a ? "undefined" : l(a)) && (n.top += a.top || 0, n.left += a.left || 0, n.bottom -= a.bottom || 0, n.right -= a.right || 0);
                var o = {
                    top: t.top >= n.top,
                    left: t.left >= n.left,
                    bottom: t.bottom <= n.bottom,
                    right: t.right <= n.right
                  },
                  c = t.height > 0 && t.width > 0,
                  u = c && o.top && o.left && o.bottom && o.right;
                if (c && r.props.partialVisibility) {
                  var h = t.top <= n.bottom && t.bottom >= n.top && t.left <= n.right && t.right >= n.left;
                  "string" == typeof r.props.partialVisibility && (h = o[r.props.partialVisibility]), u = r.props.minTopValue ? h && t.top <= n.bottom - r.props.minTopValue : h;
                }
                "string" == typeof a.direction && "number" == typeof a.value && (console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", a.direction, a.value), u = (0, v.default)(a, t, n));
                var f = r.state;
                return r.state.isVisible !== u && (f = {
                  isVisible: u,
                  visibilityRect: o
                }, r.setState(f), r.props.onChange && r.props.onChange(u)), f;
              }, r.state = {
                isVisible: null,
                visibilityRect: {}
              }, r;
            }
            return o(t, e), c(t, [{
              key: "componentDidMount",
              value: function value() {
                this.node = d.default.findDOMNode(this), this.props.active && this.startWatching();
              }
            }, {
              key: "componentWillUnmount",
              value: function value() {
                this.stopWatching();
              }
            }, {
              key: "componentDidUpdate",
              value: function value(e) {
                this.node = d.default.findDOMNode(this), this.props.active && !e.active ? (this.setState({
                  isVisible: null,
                  visibilityRect: {}
                }), this.startWatching()) : this.props.active || this.stopWatching();
              }
            }, {
              key: "roundRectDown",
              value: function value(e) {
                return {
                  top: Math.floor(e.top),
                  left: Math.floor(e.left),
                  bottom: Math.floor(e.bottom),
                  right: Math.floor(e.right)
                };
              }
            }, {
              key: "render",
              value: function value() {
                return this.props.children instanceof Function ? this.props.children({
                  isVisible: this.state.isVisible,
                  visibilityRect: this.state.visibilityRect
                }) : h.default.Children.only(this.props.children);
              }
            }]), t;
          }(h.default.Component);
        b.defaultProps = {
          active: !0,
          partialVisibility: !1,
          minTopValue: 0,
          scrollCheck: !1,
          scrollDelay: 250,
          scrollThrottle: -1,
          resizeCheck: !1,
          resizeDelay: 250,
          resizeThrottle: -1,
          intervalCheck: !0,
          intervalDelay: 100,
          delayedCall: !1,
          offset: {},
          containment: null,
          children: h.default.createElement("span", null)
        }, b.propTypes = {
          onChange: m.default.func,
          active: m.default.bool,
          partialVisibility: m.default.oneOfType([m.default.bool, m.default.oneOf(["top", "right", "bottom", "left"])]),
          delayedCall: m.default.bool,
          offset: m.default.oneOfType([m.default.shape({
            top: m.default.number,
            left: m.default.number,
            bottom: m.default.number,
            right: m.default.number
          }), m.default.shape({
            direction: m.default.oneOf(["top", "right", "bottom", "left"]),
            value: m.default.number
          })]),
          scrollCheck: m.default.bool,
          scrollDelay: m.default.number,
          scrollThrottle: m.default.number,
          resizeCheck: m.default.bool,
          resizeDelay: m.default.number,
          resizeThrottle: m.default.number,
          intervalCheck: m.default.bool,
          intervalDelay: m.default.number,
          containment: "undefined" != typeof window ? m.default.instanceOf(window.Element) : m.default.any,
          children: m.default.oneOfType([m.default.element, m.default.func]),
          minTopValue: m.default.number
        }, t.default = b;
      }, function (t, r) {
        t.exports = e;
      }, function (e, r) {
        e.exports = t;
      }, function (e, t, r) {
        e.exports = r(4)();
      }, function (e, t, r) {
        "use strict";

        function n() {}
        var i = r(5);
        e.exports = function () {
          function e(e, t, r, n, a, o) {
            if (o !== i) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var r = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t
          };
          return r.checkPropTypes = n, r.PropTypes = r, r;
        };
      }, function (e, t, r) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, function (e, t, r) {
        "use strict";

        e.exports = function (e, t, r) {
          var n = e.direction,
            i = e.value;
          switch (n) {
            case "top":
              return r.top + i < t.top && r.bottom > t.bottom && r.left < t.left && r.right > t.right;
            case "left":
              return r.left + i < t.left && r.bottom > t.bottom && r.top < t.top && r.right > t.right;
            case "bottom":
              return r.bottom - i > t.bottom && r.left < t.left && r.right > t.right && r.top < t.top;
            case "right":
              return r.right - i > t.right && r.left < t.left && r.top < t.top && r.bottom > t.bottom;
          }
        };
      }]);
    });
  }, function (e, t, r) {
    (function (e) {
      !function (t) {
        function n(e, r) {
          if (!(this instanceof n)) return new n(e, r);
          var i = this;
          a(i), i.q = i.c = "", i.bufferCheckPosition = t.MAX_BUFFER_LENGTH, i.opt = r || {}, i.opt.lowercase = i.opt.lowercase || i.opt.lowercasetags, i.looseCase = i.opt.lowercase ? "toLowerCase" : "toUpperCase", i.tags = [], i.closed = i.closedRoot = i.sawRoot = !1, i.tag = i.error = null, i.strict = !!e, i.noscript = !(!e && !i.opt.noscript), i.state = W.BEGIN, i.strictEntities = i.opt.strictEntities, i.ENTITIES = i.strictEntities ? Object.create(t.XML_ENTITIES) : Object.create(t.ENTITIES), i.attribList = [], i.opt.xmlns && (i.ns = Object.create(z)), i.trackPosition = !1 !== i.opt.position, i.trackPosition && (i.position = i.line = i.column = 0), d(i, "onready");
        }
        function i(e) {
          for (var r = Math.max(t.MAX_BUFFER_LENGTH, 10), n = 0, i = 0, a = R.length; i < a; i++) {
            var o = e[R[i]].length;
            if (o > r) switch (R[i]) {
              case "textNode":
                m(e);
                break;
              case "cdata":
                p(e, "oncdata", e.cdata), e.cdata = "";
                break;
              case "script":
                p(e, "onscript", e.script), e.script = "";
                break;
              default:
                v(e, "Max buffer length exceeded: " + R[i]);
            }
            n = Math.max(n, o);
          }
          var s = t.MAX_BUFFER_LENGTH - n;
          e.bufferCheckPosition = s + e.position;
        }
        function a(e) {
          for (var t = 0, r = R.length; t < r; t++) e[R[t]] = "";
        }
        function o(e) {
          m(e), "" !== e.cdata && (p(e, "oncdata", e.cdata), e.cdata = ""), "" !== e.script && (p(e, "onscript", e.script), e.script = "");
        }
        function s(e, t) {
          return new l(e, t);
        }
        function l(e, t) {
          if (!(this instanceof l)) return new l(e, t);
          I.apply(this), this._parser = new n(e, t), this.writable = !0, this.readable = !0;
          var r = this;
          this._parser.onend = function () {
            r.emit("end");
          }, this._parser.onerror = function (e) {
            r.emit("error", e), r._parser.error = null;
          }, this._decoder = null, M.forEach(function (e) {
            Object.defineProperty(r, "on" + e, {
              get: function get() {
                return r._parser["on" + e];
              },
              set: function set(t) {
                if (!t) return r.removeAllListeners(e), r._parser["on" + e] = t, t;
                r.on(e, t);
              },
              enumerable: !0,
              configurable: !1
            });
          });
        }
        function c(e) {
          return e.split("").reduce(function (e, t) {
            return e[t] = !0, e;
          }, {});
        }
        function u(e) {
          return "[object RegExp]" === Object.prototype.toString.call(e);
        }
        function h(e, t) {
          return u(e) ? !!t.match(e) : e[t];
        }
        function f(e, t) {
          return !h(e, t);
        }
        function d(e, t, r) {
          e[t] && e[t](r);
        }
        function p(e, t, r) {
          e.textNode && m(e), d(e, t, r);
        }
        function m(e) {
          e.textNode = g(e.opt, e.textNode), e.textNode && d(e, "ontext", e.textNode), e.textNode = "";
        }
        function g(e, t) {
          return e.trim && (t = t.trim()), e.normalize && (t = t.replace(/\s+/g, " ")), t;
        }
        function v(e, t) {
          return m(e), e.trackPosition && (t += "\nLine: " + e.line + "\nColumn: " + e.column + "\nChar: " + e.c), t = new Error(t), e.error = t, d(e, "onerror", t), e;
        }
        function b(e) {
          return e.sawRoot && !e.closedRoot && y(e, "Unclosed root tag"), e.state !== W.BEGIN && e.state !== W.BEGIN_WHITESPACE && e.state !== W.TEXT && v(e, "Unexpected end"), m(e), e.c = "", e.closed = !0, d(e, "onend"), n.call(e, e.strict, e.opt), e;
        }
        function y(e, t) {
          if ("object" != _typeof(e) || !(e instanceof n)) throw new Error("bad call to strictFail");
          e.strict && v(e, t);
        }
        function w(e) {
          e.strict || (e.tagName = e.tagName[e.looseCase]());
          var t = e.tags[e.tags.length - 1] || e,
            r = e.tag = {
              name: e.tagName,
              attributes: {}
            };
          e.opt.xmlns && (r.ns = t.ns), e.attribList.length = 0;
        }
        function x(e, t) {
          var r = e.indexOf(":"),
            n = r < 0 ? ["", e] : e.split(":"),
            i = n[0],
            a = n[1];
          return t && "xmlns" === e && (i = "xmlns", a = ""), {
            prefix: i,
            local: a
          };
        }
        function _(e) {
          if (e.strict || (e.attribName = e.attribName[e.looseCase]()), -1 !== e.attribList.indexOf(e.attribName) || e.tag.attributes.hasOwnProperty(e.attribName)) return void (e.attribName = e.attribValue = "");
          if (e.opt.xmlns) {
            var t = x(e.attribName, !0),
              r = t.prefix,
              n = t.local;
            if ("xmlns" === r) if ("xml" === n && e.attribValue !== U) y(e, "xml: prefix must be bound to " + U + "\nActual: " + e.attribValue);else if ("xmlns" === n && e.attribValue !== j) y(e, "xmlns: prefix must be bound to " + j + "\nActual: " + e.attribValue);else {
              var i = e.tag,
                a = e.tags[e.tags.length - 1] || e;
              i.ns === a.ns && (i.ns = Object.create(a.ns)), i.ns[n] = e.attribValue;
            }
            e.attribList.push([e.attribName, e.attribValue]);
          } else e.tag.attributes[e.attribName] = e.attribValue, p(e, "onattribute", {
            name: e.attribName,
            value: e.attribValue
          });
          e.attribName = e.attribValue = "";
        }
        function S(e, t) {
          if (e.opt.xmlns) {
            var r = e.tag,
              n = x(e.tagName);
            r.prefix = n.prefix, r.local = n.local, r.uri = r.ns[n.prefix] || "", r.prefix && !r.uri && (y(e, "Unbound namespace prefix: " + JSON.stringify(e.tagName)), r.uri = n.prefix);
            var i = e.tags[e.tags.length - 1] || e;
            r.ns && i.ns !== r.ns && Object.keys(r.ns).forEach(function (t) {
              p(e, "onopennamespace", {
                prefix: t,
                uri: r.ns[t]
              });
            });
            for (var a = 0, o = e.attribList.length; a < o; a++) {
              var s = e.attribList[a],
                l = s[0],
                c = s[1],
                u = x(l, !0),
                h = u.prefix,
                f = u.local,
                d = "" === h ? "" : r.ns[h] || "",
                m = {
                  name: l,
                  value: c,
                  prefix: h,
                  local: f,
                  uri: d
                };
              h && "xmlns" !== h && !d && (y(e, "Unbound namespace prefix: " + JSON.stringify(h)), m.uri = h), e.tag.attributes[l] = m, p(e, "onattribute", m);
            }
            e.attribList.length = 0;
          }
          e.tag.isSelfClosing = !!t, e.sawRoot = !0, e.tags.push(e.tag), p(e, "onopentag", e.tag), t || (e.noscript || "script" !== e.tagName.toLowerCase() ? e.state = W.TEXT : e.state = W.SCRIPT, e.tag = null, e.tagName = ""), e.attribName = e.attribValue = "", e.attribList.length = 0;
        }
        function C(e) {
          if (!e.tagName) return y(e, "Weird empty close tag."), e.textNode += "</>", void (e.state = W.TEXT);
          if (e.script) {
            if ("script" !== e.tagName) return e.script += "</" + e.tagName + ">", e.tagName = "", void (e.state = W.SCRIPT);
            p(e, "onscript", e.script), e.script = "";
          }
          var t = e.tags.length,
            r = e.tagName;
          e.strict || (r = r[e.looseCase]());
          for (var n = r; t--;) {
            if (e.tags[t].name === n) break;
            y(e, "Unexpected close tag");
          }
          if (t < 0) return y(e, "Unmatched closing tag: " + e.tagName), e.textNode += "</" + e.tagName + ">", void (e.state = W.TEXT);
          e.tagName = r;
          for (var i = e.tags.length; i-- > t;) {
            var a = e.tag = e.tags.pop();
            e.tagName = e.tag.name, p(e, "onclosetag", e.tagName);
            var o = {};
            for (var s in a.ns) o[s] = a.ns[s];
            var l = e.tags[e.tags.length - 1] || e;
            e.opt.xmlns && a.ns !== l.ns && Object.keys(a.ns).forEach(function (t) {
              var r = a.ns[t];
              p(e, "onclosenamespace", {
                prefix: t,
                uri: r
              });
            });
          }
          0 === t && (e.closedRoot = !0), e.tagName = e.attribValue = e.attribName = "", e.attribList.length = 0, e.state = W.TEXT;
        }
        function E(e) {
          var t,
            r = e.entity,
            n = r.toLowerCase(),
            i = "";
          return e.ENTITIES[r] ? e.ENTITIES[r] : e.ENTITIES[n] ? e.ENTITIES[n] : (r = n, "#" === r.charAt(0) && ("x" === r.charAt(1) ? (r = r.slice(2), t = parseInt(r, 16), i = t.toString(16)) : (r = r.slice(1), t = parseInt(r, 10), i = t.toString(10))), r = r.replace(/^0+/, ""), i.toLowerCase() !== r ? (y(e, "Invalid character entity"), "&" + e.entity + ";") : String.fromCodePoint(t));
        }
        function A(e, t) {
          "<" === t ? (e.state = W.OPEN_WAKA, e.startTagPosition = e.position) : f(O, t) && (y(e, "Non-whitespace before first tag."), e.textNode = t, e.state = W.TEXT);
        }
        function T(e, t) {
          var r = "";
          return t < e.length && (r = e.charAt(t)), r;
        }
        function k(e) {
          var t = this;
          if (this.error) throw this.error;
          if (t.closed) return v(t, "Cannot write after close. Assign an onready handler.");
          if (null === e) return b(t);
          "object" == _typeof(e) && (e = e.toString());
          for (var r = 0, n = "";;) {
            if (n = T(e, r++), t.c = n, !n) break;
            switch (t.trackPosition && (t.position++, "\n" === n ? (t.line++, t.column = 0) : t.column++), t.state) {
              case W.BEGIN:
                if (t.state = W.BEGIN_WHITESPACE, "\uFEFF" === n) continue;
                A(t, n);
                continue;
              case W.BEGIN_WHITESPACE:
                A(t, n);
                continue;
              case W.TEXT:
                if (t.sawRoot && !t.closedRoot) {
                  for (var a = r - 1; n && "<" !== n && "&" !== n;) (n = T(e, r++)) && t.trackPosition && (t.position++, "\n" === n ? (t.line++, t.column = 0) : t.column++);
                  t.textNode += e.substring(a, r - 1);
                }
                "<" !== n || t.sawRoot && t.closedRoot && !t.strict ? (!f(O, n) || t.sawRoot && !t.closedRoot || y(t, "Text data outside of root node."), "&" === n ? t.state = W.TEXT_ENTITY : t.textNode += n) : (t.state = W.OPEN_WAKA, t.startTagPosition = t.position);
                continue;
              case W.SCRIPT:
                "<" === n ? t.state = W.SCRIPT_ENDING : t.script += n;
                continue;
              case W.SCRIPT_ENDING:
                "/" === n ? t.state = W.CLOSE_TAG : (t.script += "<" + n, t.state = W.SCRIPT);
                continue;
              case W.OPEN_WAKA:
                if ("!" === n) t.state = W.SGML_DECL, t.sgmlDecl = "";else if (h(O, n)) ;else if (h(H, n)) t.state = W.OPEN_TAG, t.tagName = n;else if ("/" === n) t.state = W.CLOSE_TAG, t.tagName = "";else if ("?" === n) t.state = W.PROC_INST, t.procInstName = t.procInstBody = "";else {
                  if (y(t, "Unencoded <"), t.startTagPosition + 1 < t.position) {
                    var o = t.position - t.startTagPosition;
                    n = new Array(o).join(" ") + n;
                  }
                  t.textNode += "<" + n, t.state = W.TEXT;
                }
                continue;
              case W.SGML_DECL:
                (t.sgmlDecl + n).toUpperCase() === F ? (p(t, "onopencdata"), t.state = W.CDATA, t.sgmlDecl = "", t.cdata = "") : t.sgmlDecl + n === "--" ? (t.state = W.COMMENT, t.comment = "", t.sgmlDecl = "") : (t.sgmlDecl + n).toUpperCase() === N ? (t.state = W.DOCTYPE, (t.doctype || t.sawRoot) && y(t, "Inappropriately located doctype declaration"), t.doctype = "", t.sgmlDecl = "") : ">" === n ? (p(t, "onsgmldeclaration", t.sgmlDecl), t.sgmlDecl = "", t.state = W.TEXT) : h(D, n) ? (t.state = W.SGML_DECL_QUOTED, t.sgmlDecl += n) : t.sgmlDecl += n;
                continue;
              case W.SGML_DECL_QUOTED:
                n === t.q && (t.state = W.SGML_DECL, t.q = ""), t.sgmlDecl += n;
                continue;
              case W.DOCTYPE:
                ">" === n ? (t.state = W.TEXT, p(t, "ondoctype", t.doctype), t.doctype = !0) : (t.doctype += n, "[" === n ? t.state = W.DOCTYPE_DTD : h(D, n) && (t.state = W.DOCTYPE_QUOTED, t.q = n));
                continue;
              case W.DOCTYPE_QUOTED:
                t.doctype += n, n === t.q && (t.q = "", t.state = W.DOCTYPE);
                continue;
              case W.DOCTYPE_DTD:
                t.doctype += n, "]" === n ? t.state = W.DOCTYPE : h(D, n) && (t.state = W.DOCTYPE_DTD_QUOTED, t.q = n);
                continue;
              case W.DOCTYPE_DTD_QUOTED:
                t.doctype += n, n === t.q && (t.state = W.DOCTYPE_DTD, t.q = "");
                continue;
              case W.COMMENT:
                "-" === n ? t.state = W.COMMENT_ENDING : t.comment += n;
                continue;
              case W.COMMENT_ENDING:
                "-" === n ? (t.state = W.COMMENT_ENDED, t.comment = g(t.opt, t.comment), t.comment && p(t, "oncomment", t.comment), t.comment = "") : (t.comment += "-" + n, t.state = W.COMMENT);
                continue;
              case W.COMMENT_ENDED:
                ">" !== n ? (y(t, "Malformed comment"), t.comment += "--" + n, t.state = W.COMMENT) : t.state = W.TEXT;
                continue;
              case W.CDATA:
                "]" === n ? t.state = W.CDATA_ENDING : t.cdata += n;
                continue;
              case W.CDATA_ENDING:
                "]" === n ? t.state = W.CDATA_ENDING_2 : (t.cdata += "]" + n, t.state = W.CDATA);
                continue;
              case W.CDATA_ENDING_2:
                ">" === n ? (t.cdata && p(t, "oncdata", t.cdata), p(t, "onclosecdata"), t.cdata = "", t.state = W.TEXT) : "]" === n ? t.cdata += "]" : (t.cdata += "]]" + n, t.state = W.CDATA);
                continue;
              case W.PROC_INST:
                "?" === n ? t.state = W.PROC_INST_ENDING : h(O, n) ? t.state = W.PROC_INST_BODY : t.procInstName += n;
                continue;
              case W.PROC_INST_BODY:
                if (!t.procInstBody && h(O, n)) continue;
                "?" === n ? t.state = W.PROC_INST_ENDING : t.procInstBody += n;
                continue;
              case W.PROC_INST_ENDING:
                ">" === n ? (p(t, "onprocessinginstruction", {
                  name: t.procInstName,
                  body: t.procInstBody
                }), t.procInstName = t.procInstBody = "", t.state = W.TEXT) : (t.procInstBody += "?" + n, t.state = W.PROC_INST_BODY);
                continue;
              case W.OPEN_TAG:
                h(G, n) ? t.tagName += n : (w(t), ">" === n ? S(t) : "/" === n ? t.state = W.OPEN_TAG_SLASH : (f(O, n) && y(t, "Invalid character in tag name"), t.state = W.ATTRIB));
                continue;
              case W.OPEN_TAG_SLASH:
                ">" === n ? (S(t, !0), C(t)) : (y(t, "Forward-slash in opening tag not followed by >"), t.state = W.ATTRIB);
                continue;
              case W.ATTRIB:
                if (h(O, n)) continue;
                ">" === n ? S(t) : "/" === n ? t.state = W.OPEN_TAG_SLASH : h(H, n) ? (t.attribName = n, t.attribValue = "", t.state = W.ATTRIB_NAME) : y(t, "Invalid attribute name");
                continue;
              case W.ATTRIB_NAME:
                "=" === n ? t.state = W.ATTRIB_VALUE : ">" === n ? (y(t, "Attribute without value"), t.attribValue = t.attribName, _(t), S(t)) : h(O, n) ? t.state = W.ATTRIB_NAME_SAW_WHITE : h(G, n) ? t.attribName += n : y(t, "Invalid attribute name");
                continue;
              case W.ATTRIB_NAME_SAW_WHITE:
                if ("=" === n) t.state = W.ATTRIB_VALUE;else {
                  if (h(O, n)) continue;
                  y(t, "Attribute without value"), t.tag.attributes[t.attribName] = "", t.attribValue = "", p(t, "onattribute", {
                    name: t.attribName,
                    value: ""
                  }), t.attribName = "", ">" === n ? S(t) : h(H, n) ? (t.attribName = n, t.state = W.ATTRIB_NAME) : (y(t, "Invalid attribute name"), t.state = W.ATTRIB);
                }
                continue;
              case W.ATTRIB_VALUE:
                if (h(O, n)) continue;
                h(D, n) ? (t.q = n, t.state = W.ATTRIB_VALUE_QUOTED) : (y(t, "Unquoted attribute value"), t.state = W.ATTRIB_VALUE_UNQUOTED, t.attribValue = n);
                continue;
              case W.ATTRIB_VALUE_QUOTED:
                if (n !== t.q) {
                  "&" === n ? t.state = W.ATTRIB_VALUE_ENTITY_Q : t.attribValue += n;
                  continue;
                }
                _(t), t.q = "", t.state = W.ATTRIB_VALUE_CLOSED;
                continue;
              case W.ATTRIB_VALUE_CLOSED:
                h(O, n) ? t.state = W.ATTRIB : ">" === n ? S(t) : "/" === n ? t.state = W.OPEN_TAG_SLASH : h(H, n) ? (y(t, "No whitespace between attributes"), t.attribName = n, t.attribValue = "", t.state = W.ATTRIB_NAME) : y(t, "Invalid attribute name");
                continue;
              case W.ATTRIB_VALUE_UNQUOTED:
                if (f(L, n)) {
                  "&" === n ? t.state = W.ATTRIB_VALUE_ENTITY_U : t.attribValue += n;
                  continue;
                }
                _(t), ">" === n ? S(t) : t.state = W.ATTRIB;
                continue;
              case W.CLOSE_TAG:
                if (t.tagName) ">" === n ? C(t) : h(G, n) ? t.tagName += n : t.script ? (t.script += "</" + t.tagName, t.tagName = "", t.state = W.SCRIPT) : (f(O, n) && y(t, "Invalid tagname in closing tag"), t.state = W.CLOSE_TAG_SAW_WHITE);else {
                  if (h(O, n)) continue;
                  f(H, n) ? t.script ? (t.script += "</" + n, t.state = W.SCRIPT) : y(t, "Invalid tagname in closing tag.") : t.tagName = n;
                }
                continue;
              case W.CLOSE_TAG_SAW_WHITE:
                if (h(O, n)) continue;
                ">" === n ? C(t) : y(t, "Invalid characters in closing tag");
                continue;
              case W.TEXT_ENTITY:
              case W.ATTRIB_VALUE_ENTITY_Q:
              case W.ATTRIB_VALUE_ENTITY_U:
                var s, l;
                switch (t.state) {
                  case W.TEXT_ENTITY:
                    s = W.TEXT, l = "textNode";
                    break;
                  case W.ATTRIB_VALUE_ENTITY_Q:
                    s = W.ATTRIB_VALUE_QUOTED, l = "attribValue";
                    break;
                  case W.ATTRIB_VALUE_ENTITY_U:
                    s = W.ATTRIB_VALUE_UNQUOTED, l = "attribValue";
                }
                ";" === n ? (t[l] += E(t), t.entity = "", t.state = s) : h(t.entity.length ? q : V, n) ? t.entity += n : (y(t, "Invalid character in entity name"), t[l] += "&" + t.entity + n, t.entity = "", t.state = s);
                continue;
              default:
                throw new Error(t, "Unknown state: " + t.state);
            }
          }
          return t.position >= t.bufferCheckPosition && i(t), t;
        }
        t.parser = function (e, t) {
          return new n(e, t);
        }, t.SAXParser = n, t.SAXStream = l, t.createStream = s, t.MAX_BUFFER_LENGTH = 65536;
        var R = ["comment", "sgmlDecl", "textNode", "tagName", "doctype", "procInstName", "procInstBody", "entity", "attribName", "attribValue", "cdata", "script"];
        t.EVENTS = ["text", "processinginstruction", "sgmldeclaration", "doctype", "comment", "attribute", "opentag", "closetag", "opencdata", "cdata", "closecdata", "error", "end", "ready", "script", "opennamespace", "closenamespace"], Object.create || (Object.create = function (e) {
          function t() {}
          return t.prototype = e, new t();
        }), Object.keys || (Object.keys = function (e) {
          var t = [];
          for (var r in e) e.hasOwnProperty(r) && t.push(r);
          return t;
        }), n.prototype = {
          end: function end() {
            b(this);
          },
          write: k,
          resume: function resume() {
            return this.error = null, this;
          },
          close: function close() {
            return this.write(null);
          },
          flush: function flush() {
            o(this);
          }
        };
        var I;
        try {
          I = r(355).Stream;
        } catch (e) {
          I = function I() {};
        }
        var M = t.EVENTS.filter(function (e) {
          return "error" !== e && "end" !== e;
        });
        l.prototype = Object.create(I.prototype, {
          constructor: {
            value: l
          }
        }), l.prototype.write = function (t) {
          if ("function" == typeof e && "function" == typeof e.isBuffer && e.isBuffer(t)) {
            if (!this._decoder) {
              var n = r(84).StringDecoder;
              this._decoder = new n("utf8");
            }
            t = this._decoder.write(t);
          }
          return this._parser.write(t.toString()), this.emit("data", t), !0;
        }, l.prototype.end = function (e) {
          return e && e.length && this.write(e), this._parser.end(), !0;
        }, l.prototype.on = function (e, t) {
          var r = this;
          return r._parser["on" + e] || -1 === M.indexOf(e) || (r._parser["on" + e] = function () {
            var t = 1 === arguments.length ? [arguments[0]] : Array.apply(null, arguments);
            t.splice(0, 0, e), r.emit.apply(r, t);
          }), I.prototype.on.call(r, e, t);
        };
        var O = "\r\n\t ",
          P = "0124356789",
          B = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
          D = "'\"",
          L = O + ">",
          F = "[CDATA[",
          N = "DOCTYPE",
          U = "http://www.w3.org/XML/1998/namespace",
          j = "http://www.w3.org/2000/xmlns/",
          z = {
            xml: U,
            xmlns: j
          };
        O = c(O), P = c(P), B = c(B);
        var H = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
          G = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/,
          V = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,
          q = /[#:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/;
        D = c(D), L = c(L);
        var W = 0;
        t.STATE = {
          BEGIN: W++,
          BEGIN_WHITESPACE: W++,
          TEXT: W++,
          TEXT_ENTITY: W++,
          OPEN_WAKA: W++,
          SGML_DECL: W++,
          SGML_DECL_QUOTED: W++,
          DOCTYPE: W++,
          DOCTYPE_QUOTED: W++,
          DOCTYPE_DTD: W++,
          DOCTYPE_DTD_QUOTED: W++,
          COMMENT_STARTING: W++,
          COMMENT: W++,
          COMMENT_ENDING: W++,
          COMMENT_ENDED: W++,
          CDATA: W++,
          CDATA_ENDING: W++,
          CDATA_ENDING_2: W++,
          PROC_INST: W++,
          PROC_INST_BODY: W++,
          PROC_INST_ENDING: W++,
          OPEN_TAG: W++,
          OPEN_TAG_SLASH: W++,
          ATTRIB: W++,
          ATTRIB_NAME: W++,
          ATTRIB_NAME_SAW_WHITE: W++,
          ATTRIB_VALUE: W++,
          ATTRIB_VALUE_QUOTED: W++,
          ATTRIB_VALUE_CLOSED: W++,
          ATTRIB_VALUE_UNQUOTED: W++,
          ATTRIB_VALUE_ENTITY_Q: W++,
          ATTRIB_VALUE_ENTITY_U: W++,
          CLOSE_TAG: W++,
          CLOSE_TAG_SAW_WHITE: W++,
          SCRIPT: W++,
          SCRIPT_ENDING: W++
        }, t.XML_ENTITIES = {
          amp: "&",
          gt: ">",
          lt: "<",
          quot: '"',
          apos: "'"
        }, t.ENTITIES = {
          amp: "&",
          gt: ">",
          lt: "<",
          quot: '"',
          apos: "'",
          AElig: 198,
          Aacute: 193,
          Acirc: 194,
          Agrave: 192,
          Aring: 197,
          Atilde: 195,
          Auml: 196,
          Ccedil: 199,
          ETH: 208,
          Eacute: 201,
          Ecirc: 202,
          Egrave: 200,
          Euml: 203,
          Iacute: 205,
          Icirc: 206,
          Igrave: 204,
          Iuml: 207,
          Ntilde: 209,
          Oacute: 211,
          Ocirc: 212,
          Ograve: 210,
          Oslash: 216,
          Otilde: 213,
          Ouml: 214,
          THORN: 222,
          Uacute: 218,
          Ucirc: 219,
          Ugrave: 217,
          Uuml: 220,
          Yacute: 221,
          aacute: 225,
          acirc: 226,
          aelig: 230,
          agrave: 224,
          aring: 229,
          atilde: 227,
          auml: 228,
          ccedil: 231,
          eacute: 233,
          ecirc: 234,
          egrave: 232,
          eth: 240,
          euml: 235,
          iacute: 237,
          icirc: 238,
          igrave: 236,
          iuml: 239,
          ntilde: 241,
          oacute: 243,
          ocirc: 244,
          ograve: 242,
          oslash: 248,
          otilde: 245,
          ouml: 246,
          szlig: 223,
          thorn: 254,
          uacute: 250,
          ucirc: 251,
          ugrave: 249,
          uuml: 252,
          yacute: 253,
          yuml: 255,
          copy: 169,
          reg: 174,
          nbsp: 160,
          iexcl: 161,
          cent: 162,
          pound: 163,
          curren: 164,
          yen: 165,
          brvbar: 166,
          sect: 167,
          uml: 168,
          ordf: 170,
          laquo: 171,
          not: 172,
          shy: 173,
          macr: 175,
          deg: 176,
          plusmn: 177,
          sup1: 185,
          sup2: 178,
          sup3: 179,
          acute: 180,
          micro: 181,
          para: 182,
          middot: 183,
          cedil: 184,
          ordm: 186,
          raquo: 187,
          frac14: 188,
          frac12: 189,
          frac34: 190,
          iquest: 191,
          times: 215,
          divide: 247,
          OElig: 338,
          oelig: 339,
          Scaron: 352,
          scaron: 353,
          Yuml: 376,
          fnof: 402,
          circ: 710,
          tilde: 732,
          Alpha: 913,
          Beta: 914,
          Gamma: 915,
          Delta: 916,
          Epsilon: 917,
          Zeta: 918,
          Eta: 919,
          Theta: 920,
          Iota: 921,
          Kappa: 922,
          Lambda: 923,
          Mu: 924,
          Nu: 925,
          Xi: 926,
          Omicron: 927,
          Pi: 928,
          Rho: 929,
          Sigma: 931,
          Tau: 932,
          Upsilon: 933,
          Phi: 934,
          Chi: 935,
          Psi: 936,
          Omega: 937,
          alpha: 945,
          beta: 946,
          gamma: 947,
          delta: 948,
          epsilon: 949,
          zeta: 950,
          eta: 951,
          theta: 952,
          iota: 953,
          kappa: 954,
          lambda: 955,
          mu: 956,
          nu: 957,
          xi: 958,
          omicron: 959,
          pi: 960,
          rho: 961,
          sigmaf: 962,
          sigma: 963,
          tau: 964,
          upsilon: 965,
          phi: 966,
          chi: 967,
          psi: 968,
          omega: 969,
          thetasym: 977,
          upsih: 978,
          piv: 982,
          ensp: 8194,
          emsp: 8195,
          thinsp: 8201,
          zwnj: 8204,
          zwj: 8205,
          lrm: 8206,
          rlm: 8207,
          ndash: 8211,
          mdash: 8212,
          lsquo: 8216,
          rsquo: 8217,
          sbquo: 8218,
          ldquo: 8220,
          rdquo: 8221,
          bdquo: 8222,
          dagger: 8224,
          Dagger: 8225,
          bull: 8226,
          hellip: 8230,
          permil: 8240,
          prime: 8242,
          Prime: 8243,
          lsaquo: 8249,
          rsaquo: 8250,
          oline: 8254,
          frasl: 8260,
          euro: 8364,
          image: 8465,
          weierp: 8472,
          real: 8476,
          trade: 8482,
          alefsym: 8501,
          larr: 8592,
          uarr: 8593,
          rarr: 8594,
          darr: 8595,
          harr: 8596,
          crarr: 8629,
          lArr: 8656,
          uArr: 8657,
          rArr: 8658,
          dArr: 8659,
          hArr: 8660,
          forall: 8704,
          part: 8706,
          exist: 8707,
          empty: 8709,
          nabla: 8711,
          isin: 8712,
          notin: 8713,
          ni: 8715,
          prod: 8719,
          sum: 8721,
          minus: 8722,
          lowast: 8727,
          radic: 8730,
          prop: 8733,
          infin: 8734,
          ang: 8736,
          and: 8743,
          or: 8744,
          cap: 8745,
          cup: 8746,
          int: 8747,
          there4: 8756,
          sim: 8764,
          cong: 8773,
          asymp: 8776,
          ne: 8800,
          equiv: 8801,
          le: 8804,
          ge: 8805,
          sub: 8834,
          sup: 8835,
          nsub: 8836,
          sube: 8838,
          supe: 8839,
          oplus: 8853,
          otimes: 8855,
          perp: 8869,
          sdot: 8901,
          lceil: 8968,
          rceil: 8969,
          lfloor: 8970,
          rfloor: 8971,
          lang: 9001,
          rang: 9002,
          loz: 9674,
          spades: 9824,
          clubs: 9827,
          hearts: 9829,
          diams: 9830
        }, Object.keys(t.ENTITIES).forEach(function (e) {
          var r = t.ENTITIES[e],
            n = "number" == typeof r ? String.fromCharCode(r) : r;
          t.ENTITIES[e] = n;
        });
        for (var X in t.STATE) t.STATE[t.STATE[X]] = X;
        W = t.STATE, /*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
        String.fromCodePoint || function () {
          var e = String.fromCharCode,
            t = Math.floor,
            r = function r() {
              var r,
                n,
                i = [],
                a = -1,
                o = arguments.length;
              if (!o) return "";
              for (var s = ""; ++a < o;) {
                var l = Number(arguments[a]);
                if (!isFinite(l) || l < 0 || l > 1114111 || t(l) !== l) throw RangeError("Invalid code point: " + l);
                l <= 65535 ? i.push(l) : (l -= 65536, r = 55296 + (l >> 10), n = l % 1024 + 56320, i.push(r, n)), (a + 1 === o || i.length > 16384) && (s += e.apply(null, i), i.length = 0);
              }
              return s;
            };
          Object.defineProperty ? Object.defineProperty(String, "fromCodePoint", {
            value: r,
            configurable: !0,
            writable: !0
          }) : String.fromCodePoint = r;
        }();
      }(t);
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    (function (e, t) {
      !function (e, r) {
        "use strict";

        function n(e) {
          "function" != typeof e && (e = new Function("" + e));
          for (var t = new Array(arguments.length - 1), r = 0; r < t.length; r++) t[r] = arguments[r + 1];
          var n = {
            callback: e,
            args: t
          };
          return c[l] = n, s(l), l++;
        }
        function i(e) {
          delete c[e];
        }
        function a(e) {
          var t = e.callback,
            n = e.args;
          switch (n.length) {
            case 0:
              t();
              break;
            case 1:
              t(n[0]);
              break;
            case 2:
              t(n[0], n[1]);
              break;
            case 3:
              t(n[0], n[1], n[2]);
              break;
            default:
              t.apply(r, n);
          }
        }
        function o(e) {
          if (u) setTimeout(o, 0, e);else {
            var t = c[e];
            if (t) {
              u = !0;
              try {
                a(t);
              } finally {
                i(e), u = !1;
              }
            }
          }
        }
        if (!e.setImmediate) {
          var s,
            l = 1,
            c = {},
            u = !1,
            h = e.document,
            f = Object.getPrototypeOf && Object.getPrototypeOf(e);
          f = f && f.setTimeout ? f : e, "[object process]" === {}.toString.call(e.process) ? function () {
            s = function s(e) {
              t.nextTick(function () {
                o(e);
              });
            };
          }() : function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                r = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = r, t;
            }
          }() ? function () {
            var t = "setImmediate$" + Math.random() + "$",
              r = function r(_r4) {
                _r4.source === e && "string" == typeof _r4.data && 0 === _r4.data.indexOf(t) && o(+_r4.data.slice(t.length));
              };
            e.addEventListener ? e.addEventListener("message", r, !1) : e.attachEvent("onmessage", r), s = function s(r) {
              e.postMessage(t + r, "*");
            };
          }() : e.MessageChannel ? function () {
            var e = new MessageChannel();
            e.port1.onmessage = function (e) {
              o(e.data);
            }, s = function s(t) {
              e.port2.postMessage(t);
            };
          }() : h && "onreadystatechange" in h.createElement("script") ? function () {
            var e = h.documentElement;
            s = function s(t) {
              var r = h.createElement("script");
              r.onreadystatechange = function () {
                o(t), r.onreadystatechange = null, e.removeChild(r), r = null;
              }, e.appendChild(r);
            };
          }() : function () {
            s = function s(e) {
              setTimeout(o, 0, e);
            };
          }(), f.setImmediate = n, f.clearImmediate = i;
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(t, r(13), r(5));
  }, function (e, t, r) {
    function n() {
      i.call(this);
    }
    e.exports = n;
    var i = r(72).EventEmitter;
    r(28)(n, i), n.Readable = r(83), n.Writable = r(361), n.Duplex = r(356), n.Transform = r(360), n.PassThrough = r(359), n.Stream = n, n.prototype.pipe = function (e, t) {
      function r(t) {
        e.writable && !1 === e.write(t) && c.pause && c.pause();
      }
      function n() {
        c.readable && c.resume && c.resume();
      }
      function a() {
        u || (u = !0, e.end());
      }
      function o() {
        u || (u = !0, "function" == typeof e.destroy && e.destroy());
      }
      function s(e) {
        if (l(), 0 === i.listenerCount(this, "error")) throw e;
      }
      function l() {
        c.removeListener("data", r), e.removeListener("drain", n), c.removeListener("end", a), c.removeListener("close", o), c.removeListener("error", s), e.removeListener("error", s), c.removeListener("end", l), c.removeListener("close", l), e.removeListener("close", l);
      }
      var c = this;
      c.on("data", r), e.on("drain", n), e._isStdio || t && !1 === t.end || (c.on("end", a), c.on("close", o));
      var u = !1;
      return c.on("error", s), e.on("error", s), c.on("end", l), c.on("close", l), e.on("close", l), e.emit("pipe", c), e;
    };
  }, function (e, t, r) {
    e.exports = r(30);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      if (!(this instanceof n)) return new n(e);
      i.call(this, e);
    }
    e.exports = n;
    var i = r(136),
      a = r(44);
    a.inherits = r(28), a.inherits(n, i), n.prototype._transform = function (e, t, r) {
      r(null, e);
    };
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t, r) {
      e.copy(t, r);
    }
    var a = r(57).Buffer,
      o = r(387);
    e.exports = function () {
      function e() {
        n(this, e), this.head = null, this.tail = null, this.length = 0;
      }
      return e.prototype.push = function (e) {
        var t = {
          data: e,
          next: null
        };
        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
      }, e.prototype.unshift = function (e) {
        var t = {
          data: e,
          next: this.head
        };
        0 === this.length && (this.tail = t), this.head = t, ++this.length;
      }, e.prototype.shift = function () {
        if (0 !== this.length) {
          var e = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
        }
      }, e.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, e.prototype.join = function (e) {
        if (0 === this.length) return "";
        for (var t = this.head, r = "" + t.data; t = t.next;) r += e + t.data;
        return r;
      }, e.prototype.concat = function (e) {
        if (0 === this.length) return a.alloc(0);
        if (1 === this.length) return this.head.data;
        for (var t = a.allocUnsafe(e >>> 0), r = this.head, n = 0; r;) i(r.data, t, n), n += r.data.length, r = r.next;
        return t;
      }, e;
    }(), o && o.inspect && o.inspect.custom && (e.exports.prototype[o.inspect.custom] = function () {
      var e = o.inspect({
        length: this.length
      });
      return this.constructor.name + " " + e;
    });
  }, function (e, t, r) {
    e.exports = r(83).PassThrough;
  }, function (e, t, r) {
    e.exports = r(83).Transform;
  }, function (e, t, r) {
    e.exports = r(82);
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var r = t.protocol + "//" + t.host,
        n = r + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(i)) return e;
        var a;
        return a = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? r + i : n + i.replace(/^\.\//, ""), "url(" + JSON.stringify(a) + ")";
      });
    };
  }, function (e, t, r) {
    var n = r(242);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(243);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(244);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(245);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(246);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(247);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t, r) {
    var n = r(248);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    var i = {};
    i.transform = void 0;
    r(23)(n, i);
    n.locals && (e.exports = n.locals);
  }, function (e, t) {
    e.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAABgFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVaoAhNsAhN0AhN0AgM8Ahd4Ag90AgtoAhNwAhd0AftMAhNsAhN4AfNEAgdcAhd4Ag9sAftUAgNMAd90AfdUAgNYAedcAdtgAhN0AfdIAgdYAhN4AgtkAgNUAgNUAgNcAg9wAdNEAgNsAZswAg9sAgNUAg9sAgNYAgNkAgNUAgtoAg9sAftQAgNUAgNgAhd4AhN0AfdEAgtkAgNcAhN0AgNcAgNUAg9sAgNcAgNcAfdQAg9wAgNUAgtsAgdUAftYAgNMAfdUAgdYAhN0Ag9sAedsAgNIAgNUAgM8AgNgAYJ8AXJkAec4AgNcAeNIAetMAg9sAgNUAgtoAgNcAhN0AgNMAg9sAgNcAgNwAg9oAftUAgNUAhd0Ag9sAgdcAgdcAfdIAfNgAhNwAhNkAgNUAf9UAftcAf9UAftQARHEAeswAe8wAhd4Ad+ySAAAAf3RSTlMAEhEOAQUCBhADCQ8ECwcMDQoIA9X57RD+4azs+kvd/SGS/NRPUg83XhMN4D99968eNqHSCw4FzQbWiRRcss5NgY/07j2wjvNyDMtmhi/RaMRhXTorcfHHFShIIBowMnyTES7IYquF+0zQkRbDZyry3mdzOSfrGxKXR6NZInk8JmKNMgAAA3lJREFUeF612udbE1kUBvD3zNzpaYQkJBC6ugo2EFQURcVCsXfXtr333t9/fXMTd8NjRFLm/L7myZR75rZzLroUBXG24CbPJ8qV+dlHo9cPLswhNd6Q60jLS/6venN63zIGZnIFR9peTHCnmdu3DmAQXtaRJsfNx0Em8g1OH5q6cfjOmWOlOpuOjq4Z9ClwX1089tBpafzqqUlaK3eH0YcgEcvNGezq8YPztCa2e75FxpUGJ/axh/sXH7LhxGX0wjTbPiwadGHkwjrJ6uJZdM0LbVyL6NbmkUskK/vRpSFpyPvowfErbJg+iS74tvUTDz0ar5HcmsKeotA+vkHPRs6RHHsHe8g4Ik4Ofdkok9fexVsFjkgYoU/3xsj66l7XT3z07UmNrK6+vX1cgwE8K5H1XVspGvj6wPsl8toukfZDkcRgQM9q5NgU3sQVCX0M7MkYuXXyzf3XiZCCe2XyPXTwRCSHVGyQ7BiXTCiSR0rOkZXXx9ZsM8ApGamRi509wENqxsnq5de/oDxSdIU8MYy2QMTxkaLjl8httCUiRaTqCDkxvPMFQqRrc528uzMCRaTsArli2n3MMUjZyENyrd0HYqTuIjmKJuOI+EjdffLoAVg5ERcKzpO3YBVEclDwgLwNy7EhVvB4kjPLrW/IhYpT5L7WRBNDxVVyutXLPKgYJ2+2QgAdS3VW5xCphQAokQsIRPJQcow8iFgtxsAZ8jqyIgGU3CFHURDJQMlh8hFckQhKbpCzSER8KJki5xGKGCg5RFbgiEDLabKsfgP1JlIN8lOypvqZfkCWtDvah6pDxUfkx9qD3Sfqw7XqhDNLLmhOmZufcnJOc9L/jPxce9nyhfrCS3Pp+OUMZ5Y1F78b5Ffay/evNTcg39gNiPYWSnUT+C25pryNLRnFjfhShVxVTiV8N6ycDPlePZ2jnZDSTKnNk4vKScH1s4ppzR9I7ldMzP5YJ6cVU8s//WxTy3rJ8V9scvypXnr/1xWb3tcrUJjfyPLveiUWP/mDk3/qFYmiUP76+x+9MlfO/jejVqgzebFvr1Zq9BIRcX2tYqmfl4YhrXIvis3ys6dUsDbF5vNkjU7J3Y8daXAzKocGTM4VKwkUjj3Ai11HLDdI8+AGjB9lgjjv/vdL1kvt6Eknp5AzaR2e6eC4Qx5S0j7+EzpOmLiFbBxE6M6/Q+aqJubtPIkAAAAASUVORK5CYII=";
  }, function (e, t, r) {
    (function (t) {
      function r(e, t) {
        function r() {
          if (!i) {
            if (n("throwDeprecation")) throw new Error(t);
            n("traceDeprecation") ? console.trace(t) : console.warn(t), i = !0;
          }
          return e.apply(this, arguments);
        }
        if (n("noDeprecation")) return e;
        var i = !1;
        return r;
      }
      function n(e) {
        try {
          if (!t.localStorage) return !1;
        } catch (e) {
          return !1;
        }
        var r = t.localStorage[e];
        return null != r && "true" === String(r).toLowerCase();
      }
      e.exports = r;
    }).call(t, r(13));
  }, function (e, t) {
    e.exports = function (e) {
      return e && "object" == _typeof(e) && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
    };
  }, function (e, t, r) {
    (function (t) {
      var r = {
        version: "1.10.0"
      };
      r[437] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[620] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[737] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[850] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[852] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[857] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[861] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[865] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[866] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[874] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[895] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[932] = function () {
        var e,
          t = [],
          r = {},
          n = [];
        for (n[0] = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split(""), e = 0; e != n[0].length; ++e) 65533 !== n[0][e].charCodeAt(0) && (r[n[0][e]] = 0 + e, t[0 + e] = n[0][e]);
        for (n[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split(""), e = 0; e != n[129].length; ++e) 65533 !== n[129][e].charCodeAt(0) && (r[n[129][e]] = 33024 + e, t[33024 + e] = n[129][e]);
        for (n[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split(""), e = 0; e != n[130].length; ++e) 65533 !== n[130][e].charCodeAt(0) && (r[n[130][e]] = 33280 + e, t[33280 + e] = n[130][e]);
        for (n[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split(""), e = 0; e != n[131].length; ++e) 65533 !== n[131][e].charCodeAt(0) && (r[n[131][e]] = 33536 + e, t[33536 + e] = n[131][e]);
        for (n[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split(""), e = 0; e != n[132].length; ++e) 65533 !== n[132][e].charCodeAt(0) && (r[n[132][e]] = 33792 + e, t[33792 + e] = n[132][e]);
        for (n[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[135].length; ++e) 65533 !== n[135][e].charCodeAt(0) && (r[n[135][e]] = 34560 + e, t[34560 + e] = n[135][e]);
        for (n[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split(""), e = 0; e != n[136].length; ++e) 65533 !== n[136][e].charCodeAt(0) && (r[n[136][e]] = 34816 + e, t[34816 + e] = n[136][e]);
        for (n[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split(""), e = 0; e != n[137].length; ++e) 65533 !== n[137][e].charCodeAt(0) && (r[n[137][e]] = 35072 + e, t[35072 + e] = n[137][e]);
        for (n[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split(""), e = 0; e != n[138].length; ++e) 65533 !== n[138][e].charCodeAt(0) && (r[n[138][e]] = 35328 + e, t[35328 + e] = n[138][e]);
        for (n[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split(""), e = 0; e != n[139].length; ++e) 65533 !== n[139][e].charCodeAt(0) && (r[n[139][e]] = 35584 + e, t[35584 + e] = n[139][e]);
        for (n[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split(""), e = 0; e != n[140].length; ++e) 65533 !== n[140][e].charCodeAt(0) && (r[n[140][e]] = 35840 + e, t[35840 + e] = n[140][e]);
        for (n[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split(""), e = 0; e != n[141].length; ++e) 65533 !== n[141][e].charCodeAt(0) && (r[n[141][e]] = 36096 + e, t[36096 + e] = n[141][e]);
        for (n[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split(""), e = 0; e != n[142].length; ++e) 65533 !== n[142][e].charCodeAt(0) && (r[n[142][e]] = 36352 + e, t[36352 + e] = n[142][e]);
        for (n[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split(""), e = 0; e != n[143].length; ++e) 65533 !== n[143][e].charCodeAt(0) && (r[n[143][e]] = 36608 + e, t[36608 + e] = n[143][e]);
        for (n[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split(""), e = 0; e != n[144].length; ++e) 65533 !== n[144][e].charCodeAt(0) && (r[n[144][e]] = 36864 + e, t[36864 + e] = n[144][e]);
        for (n[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split(""), e = 0; e != n[145].length; ++e) 65533 !== n[145][e].charCodeAt(0) && (r[n[145][e]] = 37120 + e, t[37120 + e] = n[145][e]);
        for (n[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split(""), e = 0; e != n[146].length; ++e) 65533 !== n[146][e].charCodeAt(0) && (r[n[146][e]] = 37376 + e, t[37376 + e] = n[146][e]);
        for (n[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split(""), e = 0; e != n[147].length; ++e) 65533 !== n[147][e].charCodeAt(0) && (r[n[147][e]] = 37632 + e, t[37632 + e] = n[147][e]);
        for (n[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split(""), e = 0; e != n[148].length; ++e) 65533 !== n[148][e].charCodeAt(0) && (r[n[148][e]] = 37888 + e, t[37888 + e] = n[148][e]);
        for (n[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split(""), e = 0; e != n[149].length; ++e) 65533 !== n[149][e].charCodeAt(0) && (r[n[149][e]] = 38144 + e, t[38144 + e] = n[149][e]);
        for (n[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split(""), e = 0; e != n[150].length; ++e) 65533 !== n[150][e].charCodeAt(0) && (r[n[150][e]] = 38400 + e, t[38400 + e] = n[150][e]);
        for (n[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split(""), e = 0; e != n[151].length; ++e) 65533 !== n[151][e].charCodeAt(0) && (r[n[151][e]] = 38656 + e, t[38656 + e] = n[151][e]);
        for (n[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split(""), e = 0; e != n[152].length; ++e) 65533 !== n[152][e].charCodeAt(0) && (r[n[152][e]] = 38912 + e, t[38912 + e] = n[152][e]);
        for (n[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split(""), e = 0; e != n[153].length; ++e) 65533 !== n[153][e].charCodeAt(0) && (r[n[153][e]] = 39168 + e, t[39168 + e] = n[153][e]);
        for (n[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split(""), e = 0; e != n[154].length; ++e) 65533 !== n[154][e].charCodeAt(0) && (r[n[154][e]] = 39424 + e, t[39424 + e] = n[154][e]);
        for (n[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split(""), e = 0; e != n[155].length; ++e) 65533 !== n[155][e].charCodeAt(0) && (r[n[155][e]] = 39680 + e, t[39680 + e] = n[155][e]);
        for (n[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split(""), e = 0; e != n[156].length; ++e) 65533 !== n[156][e].charCodeAt(0) && (r[n[156][e]] = 39936 + e, t[39936 + e] = n[156][e]);
        for (n[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split(""), e = 0; e != n[157].length; ++e) 65533 !== n[157][e].charCodeAt(0) && (r[n[157][e]] = 40192 + e, t[40192 + e] = n[157][e]);
        for (n[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split(""), e = 0; e != n[158].length; ++e) 65533 !== n[158][e].charCodeAt(0) && (r[n[158][e]] = 40448 + e, t[40448 + e] = n[158][e]);
        for (n[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split(""), e = 0; e != n[159].length; ++e) 65533 !== n[159][e].charCodeAt(0) && (r[n[159][e]] = 40704 + e, t[40704 + e] = n[159][e]);
        for (n[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split(""), e = 0; e != n[224].length; ++e) 65533 !== n[224][e].charCodeAt(0) && (r[n[224][e]] = 57344 + e, t[57344 + e] = n[224][e]);
        for (n[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split(""), e = 0; e != n[225].length; ++e) 65533 !== n[225][e].charCodeAt(0) && (r[n[225][e]] = 57600 + e, t[57600 + e] = n[225][e]);
        for (n[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split(""), e = 0; e != n[226].length; ++e) 65533 !== n[226][e].charCodeAt(0) && (r[n[226][e]] = 57856 + e, t[57856 + e] = n[226][e]);
        for (n[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split(""), e = 0; e != n[227].length; ++e) 65533 !== n[227][e].charCodeAt(0) && (r[n[227][e]] = 58112 + e, t[58112 + e] = n[227][e]);
        for (n[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split(""), e = 0; e != n[228].length; ++e) 65533 !== n[228][e].charCodeAt(0) && (r[n[228][e]] = 58368 + e, t[58368 + e] = n[228][e]);
        for (n[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split(""), e = 0; e != n[229].length; ++e) 65533 !== n[229][e].charCodeAt(0) && (r[n[229][e]] = 58624 + e, t[58624 + e] = n[229][e]);
        for (n[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split(""), e = 0; e != n[230].length; ++e) 65533 !== n[230][e].charCodeAt(0) && (r[n[230][e]] = 58880 + e, t[58880 + e] = n[230][e]);
        for (n[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split(""), e = 0; e != n[231].length; ++e) 65533 !== n[231][e].charCodeAt(0) && (r[n[231][e]] = 59136 + e, t[59136 + e] = n[231][e]);
        for (n[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split(""), e = 0; e != n[232].length; ++e) 65533 !== n[232][e].charCodeAt(0) && (r[n[232][e]] = 59392 + e, t[59392 + e] = n[232][e]);
        for (n[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split(""), e = 0; e != n[233].length; ++e) 65533 !== n[233][e].charCodeAt(0) && (r[n[233][e]] = 59648 + e, t[59648 + e] = n[233][e]);
        for (n[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split(""), e = 0; e != n[234].length; ++e) 65533 !== n[234][e].charCodeAt(0) && (r[n[234][e]] = 59904 + e, t[59904 + e] = n[234][e]);
        for (n[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split(""), e = 0; e != n[237].length; ++e) 65533 !== n[237][e].charCodeAt(0) && (r[n[237][e]] = 60672 + e, t[60672 + e] = n[237][e]);
        for (n[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split(""), e = 0; e != n[238].length; ++e) 65533 !== n[238][e].charCodeAt(0) && (r[n[238][e]] = 60928 + e, t[60928 + e] = n[238][e]);
        for (n[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split(""), e = 0; e != n[250].length; ++e) 65533 !== n[250][e].charCodeAt(0) && (r[n[250][e]] = 64e3 + e, t[64e3 + e] = n[250][e]);
        for (n[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split(""), e = 0; e != n[251].length; ++e) 65533 !== n[251][e].charCodeAt(0) && (r[n[251][e]] = 64256 + e, t[64256 + e] = n[251][e]);
        for (n[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[252].length; ++e) 65533 !== n[252][e].charCodeAt(0) && (r[n[252][e]] = 64512 + e, t[64512 + e] = n[252][e]);
        return {
          enc: r,
          dec: t
        };
      }(), r[936] = function () {
        var e,
          t = [],
          r = {},
          n = [];
        for (n[0] = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[0].length; ++e) 65533 !== n[0][e].charCodeAt(0) && (r[n[0][e]] = 0 + e, t[0 + e] = n[0][e]);
        for (n[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split(""), e = 0; e != n[129].length; ++e) 65533 !== n[129][e].charCodeAt(0) && (r[n[129][e]] = 33024 + e, t[33024 + e] = n[129][e]);
        for (n[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split(""), e = 0; e != n[130].length; ++e) 65533 !== n[130][e].charCodeAt(0) && (r[n[130][e]] = 33280 + e, t[33280 + e] = n[130][e]);
        for (n[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split(""), e = 0; e != n[131].length; ++e) 65533 !== n[131][e].charCodeAt(0) && (r[n[131][e]] = 33536 + e, t[33536 + e] = n[131][e]);
        for (n[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split(""), e = 0; e != n[132].length; ++e) 65533 !== n[132][e].charCodeAt(0) && (r[n[132][e]] = 33792 + e, t[33792 + e] = n[132][e]);
        for (n[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split(""), e = 0; e != n[133].length; ++e) 65533 !== n[133][e].charCodeAt(0) && (r[n[133][e]] = 34048 + e, t[34048 + e] = n[133][e]);
        for (n[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split(""), e = 0; e != n[134].length; ++e) 65533 !== n[134][e].charCodeAt(0) && (r[n[134][e]] = 34304 + e, t[34304 + e] = n[134][e]);
        for (n[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split(""), e = 0; e != n[135].length; ++e) 65533 !== n[135][e].charCodeAt(0) && (r[n[135][e]] = 34560 + e, t[34560 + e] = n[135][e]);
        for (n[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split(""), e = 0; e != n[136].length; ++e) 65533 !== n[136][e].charCodeAt(0) && (r[n[136][e]] = 34816 + e, t[34816 + e] = n[136][e]);
        for (n[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split(""), e = 0; e != n[137].length; ++e) 65533 !== n[137][e].charCodeAt(0) && (r[n[137][e]] = 35072 + e, t[35072 + e] = n[137][e]);
        for (n[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split(""), e = 0; e != n[138].length; ++e) 65533 !== n[138][e].charCodeAt(0) && (r[n[138][e]] = 35328 + e, t[35328 + e] = n[138][e]);
        for (n[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split(""), e = 0; e != n[139].length; ++e) 65533 !== n[139][e].charCodeAt(0) && (r[n[139][e]] = 35584 + e, t[35584 + e] = n[139][e]);
        for (n[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split(""), e = 0; e != n[140].length; ++e) 65533 !== n[140][e].charCodeAt(0) && (r[n[140][e]] = 35840 + e, t[35840 + e] = n[140][e]);
        for (n[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split(""), e = 0; e != n[141].length; ++e) 65533 !== n[141][e].charCodeAt(0) && (r[n[141][e]] = 36096 + e, t[36096 + e] = n[141][e]);
        for (n[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split(""), e = 0; e != n[142].length; ++e) 65533 !== n[142][e].charCodeAt(0) && (r[n[142][e]] = 36352 + e, t[36352 + e] = n[142][e]);
        for (n[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split(""), e = 0; e != n[143].length; ++e) 65533 !== n[143][e].charCodeAt(0) && (r[n[143][e]] = 36608 + e, t[36608 + e] = n[143][e]);
        for (n[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split(""), e = 0; e != n[144].length; ++e) 65533 !== n[144][e].charCodeAt(0) && (r[n[144][e]] = 36864 + e, t[36864 + e] = n[144][e]);
        for (n[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split(""), e = 0; e != n[145].length; ++e) 65533 !== n[145][e].charCodeAt(0) && (r[n[145][e]] = 37120 + e, t[37120 + e] = n[145][e]);
        for (n[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split(""), e = 0; e != n[146].length; ++e) 65533 !== n[146][e].charCodeAt(0) && (r[n[146][e]] = 37376 + e, t[37376 + e] = n[146][e]);
        for (n[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split(""), e = 0; e != n[147].length; ++e) 65533 !== n[147][e].charCodeAt(0) && (r[n[147][e]] = 37632 + e, t[37632 + e] = n[147][e]);
        for (n[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split(""), e = 0; e != n[148].length; ++e) 65533 !== n[148][e].charCodeAt(0) && (r[n[148][e]] = 37888 + e, t[37888 + e] = n[148][e]);
        for (n[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split(""), e = 0; e != n[149].length; ++e) 65533 !== n[149][e].charCodeAt(0) && (r[n[149][e]] = 38144 + e, t[38144 + e] = n[149][e]);
        for (n[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split(""), e = 0; e != n[150].length; ++e) 65533 !== n[150][e].charCodeAt(0) && (r[n[150][e]] = 38400 + e, t[38400 + e] = n[150][e]);
        for (n[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split(""), e = 0; e != n[151].length; ++e) 65533 !== n[151][e].charCodeAt(0) && (r[n[151][e]] = 38656 + e, t[38656 + e] = n[151][e]);
        for (n[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split(""), e = 0; e != n[152].length; ++e) 65533 !== n[152][e].charCodeAt(0) && (r[n[152][e]] = 38912 + e, t[38912 + e] = n[152][e]);
        for (n[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split(""), e = 0; e != n[153].length; ++e) 65533 !== n[153][e].charCodeAt(0) && (r[n[153][e]] = 39168 + e, t[39168 + e] = n[153][e]);
        for (n[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split(""), e = 0; e != n[154].length; ++e) 65533 !== n[154][e].charCodeAt(0) && (r[n[154][e]] = 39424 + e, t[39424 + e] = n[154][e]);
        for (n[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split(""), e = 0; e != n[155].length; ++e) 65533 !== n[155][e].charCodeAt(0) && (r[n[155][e]] = 39680 + e, t[39680 + e] = n[155][e]);
        for (n[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split(""), e = 0; e != n[156].length; ++e) 65533 !== n[156][e].charCodeAt(0) && (r[n[156][e]] = 39936 + e, t[39936 + e] = n[156][e]);
        for (n[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split(""), e = 0; e != n[157].length; ++e) 65533 !== n[157][e].charCodeAt(0) && (r[n[157][e]] = 40192 + e, t[40192 + e] = n[157][e]);
        for (n[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split(""), e = 0; e != n[158].length; ++e) 65533 !== n[158][e].charCodeAt(0) && (r[n[158][e]] = 40448 + e, t[40448 + e] = n[158][e]);
        for (n[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split(""), e = 0; e != n[159].length; ++e) 65533 !== n[159][e].charCodeAt(0) && (r[n[159][e]] = 40704 + e, t[40704 + e] = n[159][e]);
        for (n[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split(""), e = 0; e != n[160].length; ++e) 65533 !== n[160][e].charCodeAt(0) && (r[n[160][e]] = 40960 + e, t[40960 + e] = n[160][e]);
        for (n[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(""), e = 0; e != n[161].length; ++e) 65533 !== n[161][e].charCodeAt(0) && (r[n[161][e]] = 41216 + e, t[41216 + e] = n[161][e]);
        for (n[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(""), e = 0; e != n[162].length; ++e) 65533 !== n[162][e].charCodeAt(0) && (r[n[162][e]] = 41472 + e, t[41472 + e] = n[162][e]);
        for (n[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != n[163].length; ++e) 65533 !== n[163][e].charCodeAt(0) && (r[n[163][e]] = 41728 + e, t[41728 + e] = n[163][e]);
        for (n[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != n[164].length; ++e) 65533 !== n[164][e].charCodeAt(0) && (r[n[164][e]] = 41984 + e, t[41984 + e] = n[164][e]);
        for (n[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != n[165].length; ++e) 65533 !== n[165][e].charCodeAt(0) && (r[n[165][e]] = 42240 + e, t[42240 + e] = n[165][e]);
        for (n[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split(""), e = 0; e != n[166].length; ++e) 65533 !== n[166][e].charCodeAt(0) && (r[n[166][e]] = 42496 + e, t[42496 + e] = n[166][e]);
        for (n[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != n[167].length; ++e) 65533 !== n[167][e].charCodeAt(0) && (r[n[167][e]] = 42752 + e, t[42752 + e] = n[167][e]);
        for (n[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(""), e = 0; e != n[168].length; ++e) 65533 !== n[168][e].charCodeAt(0) && (r[n[168][e]] = 43008 + e, t[43008 + e] = n[168][e]);
        for (n[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(""), e = 0; e != n[169].length; ++e) 65533 !== n[169][e].charCodeAt(0) && (r[n[169][e]] = 43264 + e, t[43264 + e] = n[169][e]);
        for (n[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[170].length; ++e) 65533 !== n[170][e].charCodeAt(0) && (r[n[170][e]] = 43520 + e, t[43520 + e] = n[170][e]);
        for (n[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[171].length; ++e) 65533 !== n[171][e].charCodeAt(0) && (r[n[171][e]] = 43776 + e, t[43776 + e] = n[171][e]);
        for (n[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[172].length; ++e) 65533 !== n[172][e].charCodeAt(0) && (r[n[172][e]] = 44032 + e, t[44032 + e] = n[172][e]);
        for (n[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[173].length; ++e) 65533 !== n[173][e].charCodeAt(0) && (r[n[173][e]] = 44288 + e, t[44288 + e] = n[173][e]);
        for (n[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[174].length; ++e) 65533 !== n[174][e].charCodeAt(0) && (r[n[174][e]] = 44544 + e, t[44544 + e] = n[174][e]);
        for (n[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[175].length; ++e) 65533 !== n[175][e].charCodeAt(0) && (r[n[175][e]] = 44800 + e, t[44800 + e] = n[175][e]);
        for (n[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(""), e = 0; e != n[176].length; ++e) 65533 !== n[176][e].charCodeAt(0) && (r[n[176][e]] = 45056 + e, t[45056 + e] = n[176][e]);
        for (n[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(""), e = 0; e != n[177].length; ++e) 65533 !== n[177][e].charCodeAt(0) && (r[n[177][e]] = 45312 + e, t[45312 + e] = n[177][e]);
        for (n[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(""), e = 0; e != n[178].length; ++e) 65533 !== n[178][e].charCodeAt(0) && (r[n[178][e]] = 45568 + e, t[45568 + e] = n[178][e]);
        for (n[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(""), e = 0; e != n[179].length; ++e) 65533 !== n[179][e].charCodeAt(0) && (r[n[179][e]] = 45824 + e, t[45824 + e] = n[179][e]);
        for (n[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(""), e = 0; e != n[180].length; ++e) 65533 !== n[180][e].charCodeAt(0) && (r[n[180][e]] = 46080 + e, t[46080 + e] = n[180][e]);
        for (n[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(""), e = 0; e != n[181].length; ++e) 65533 !== n[181][e].charCodeAt(0) && (r[n[181][e]] = 46336 + e, t[46336 + e] = n[181][e]);
        for (n[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(""), e = 0; e != n[182].length; ++e) 65533 !== n[182][e].charCodeAt(0) && (r[n[182][e]] = 46592 + e, t[46592 + e] = n[182][e]);
        for (n[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(""), e = 0; e != n[183].length; ++e) 65533 !== n[183][e].charCodeAt(0) && (r[n[183][e]] = 46848 + e, t[46848 + e] = n[183][e]);
        for (n[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(""), e = 0; e != n[184].length; ++e) 65533 !== n[184][e].charCodeAt(0) && (r[n[184][e]] = 47104 + e, t[47104 + e] = n[184][e]);
        for (n[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(""), e = 0; e != n[185].length; ++e) 65533 !== n[185][e].charCodeAt(0) && (r[n[185][e]] = 47360 + e, t[47360 + e] = n[185][e]);
        for (n[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(""), e = 0; e != n[186].length; ++e) 65533 !== n[186][e].charCodeAt(0) && (r[n[186][e]] = 47616 + e, t[47616 + e] = n[186][e]);
        for (n[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(""), e = 0; e != n[187].length; ++e) 65533 !== n[187][e].charCodeAt(0) && (r[n[187][e]] = 47872 + e, t[47872 + e] = n[187][e]);
        for (n[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(""), e = 0; e != n[188].length; ++e) 65533 !== n[188][e].charCodeAt(0) && (r[n[188][e]] = 48128 + e, t[48128 + e] = n[188][e]);
        for (n[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(""), e = 0; e != n[189].length; ++e) 65533 !== n[189][e].charCodeAt(0) && (r[n[189][e]] = 48384 + e, t[48384 + e] = n[189][e]);
        for (n[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(""), e = 0; e != n[190].length; ++e) 65533 !== n[190][e].charCodeAt(0) && (r[n[190][e]] = 48640 + e, t[48640 + e] = n[190][e]);
        for (n[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(""), e = 0; e != n[191].length; ++e) 65533 !== n[191][e].charCodeAt(0) && (r[n[191][e]] = 48896 + e, t[48896 + e] = n[191][e]);
        for (n[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(""), e = 0; e != n[192].length; ++e) 65533 !== n[192][e].charCodeAt(0) && (r[n[192][e]] = 49152 + e, t[49152 + e] = n[192][e]);
        for (n[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(""), e = 0; e != n[193].length; ++e) 65533 !== n[193][e].charCodeAt(0) && (r[n[193][e]] = 49408 + e, t[49408 + e] = n[193][e]);
        for (n[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(""), e = 0; e != n[194].length; ++e) 65533 !== n[194][e].charCodeAt(0) && (r[n[194][e]] = 49664 + e, t[49664 + e] = n[194][e]);
        for (n[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(""), e = 0; e != n[195].length; ++e) 65533 !== n[195][e].charCodeAt(0) && (r[n[195][e]] = 49920 + e, t[49920 + e] = n[195][e]);
        for (n[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(""), e = 0; e != n[196].length; ++e) 65533 !== n[196][e].charCodeAt(0) && (r[n[196][e]] = 50176 + e, t[50176 + e] = n[196][e]);
        for (n[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(""), e = 0; e != n[197].length; ++e) 65533 !== n[197][e].charCodeAt(0) && (r[n[197][e]] = 50432 + e, t[50432 + e] = n[197][e]);
        for (n[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(""), e = 0; e != n[198].length; ++e) 65533 !== n[198][e].charCodeAt(0) && (r[n[198][e]] = 50688 + e, t[50688 + e] = n[198][e]);
        for (n[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(""), e = 0; e != n[199].length; ++e) 65533 !== n[199][e].charCodeAt(0) && (r[n[199][e]] = 50944 + e, t[50944 + e] = n[199][e]);
        for (n[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(""), e = 0; e != n[200].length; ++e) 65533 !== n[200][e].charCodeAt(0) && (r[n[200][e]] = 51200 + e, t[51200 + e] = n[200][e]);
        for (n[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(""), e = 0; e != n[201].length; ++e) 65533 !== n[201][e].charCodeAt(0) && (r[n[201][e]] = 51456 + e, t[51456 + e] = n[201][e]);
        for (n[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(""), e = 0; e != n[202].length; ++e) 65533 !== n[202][e].charCodeAt(0) && (r[n[202][e]] = 51712 + e, t[51712 + e] = n[202][e]);
        for (n[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(""), e = 0; e != n[203].length; ++e) 65533 !== n[203][e].charCodeAt(0) && (r[n[203][e]] = 51968 + e, t[51968 + e] = n[203][e]);
        for (n[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(""), e = 0; e != n[204].length; ++e) 65533 !== n[204][e].charCodeAt(0) && (r[n[204][e]] = 52224 + e, t[52224 + e] = n[204][e]);
        for (n[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(""), e = 0; e != n[205].length; ++e) 65533 !== n[205][e].charCodeAt(0) && (r[n[205][e]] = 52480 + e, t[52480 + e] = n[205][e]);
        for (n[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(""), e = 0; e != n[206].length; ++e) 65533 !== n[206][e].charCodeAt(0) && (r[n[206][e]] = 52736 + e, t[52736 + e] = n[206][e]);
        for (n[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(""), e = 0; e != n[207].length; ++e) 65533 !== n[207][e].charCodeAt(0) && (r[n[207][e]] = 52992 + e, t[52992 + e] = n[207][e]);
        for (n[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(""), e = 0; e != n[208].length; ++e) 65533 !== n[208][e].charCodeAt(0) && (r[n[208][e]] = 53248 + e, t[53248 + e] = n[208][e]);
        for (n[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(""), e = 0; e != n[209].length; ++e) 65533 !== n[209][e].charCodeAt(0) && (r[n[209][e]] = 53504 + e, t[53504 + e] = n[209][e]);
        for (n[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(""), e = 0; e != n[210].length; ++e) 65533 !== n[210][e].charCodeAt(0) && (r[n[210][e]] = 53760 + e, t[53760 + e] = n[210][e]);
        for (n[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(""), e = 0; e != n[211].length; ++e) 65533 !== n[211][e].charCodeAt(0) && (r[n[211][e]] = 54016 + e, t[54016 + e] = n[211][e]);
        for (n[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(""), e = 0; e != n[212].length; ++e) 65533 !== n[212][e].charCodeAt(0) && (r[n[212][e]] = 54272 + e, t[54272 + e] = n[212][e]);
        for (n[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(""), e = 0; e != n[213].length; ++e) 65533 !== n[213][e].charCodeAt(0) && (r[n[213][e]] = 54528 + e, t[54528 + e] = n[213][e]);
        for (n[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(""), e = 0; e != n[214].length; ++e) 65533 !== n[214][e].charCodeAt(0) && (r[n[214][e]] = 54784 + e, t[54784 + e] = n[214][e]);
        for (n[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(""), e = 0; e != n[215].length; ++e) 65533 !== n[215][e].charCodeAt(0) && (r[n[215][e]] = 55040 + e, t[55040 + e] = n[215][e]);
        for (n[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(""), e = 0; e != n[216].length; ++e) 65533 !== n[216][e].charCodeAt(0) && (r[n[216][e]] = 55296 + e, t[55296 + e] = n[216][e]);
        for (n[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(""), e = 0; e != n[217].length; ++e) 65533 !== n[217][e].charCodeAt(0) && (r[n[217][e]] = 55552 + e, t[55552 + e] = n[217][e]);
        for (n[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(""), e = 0; e != n[218].length; ++e) 65533 !== n[218][e].charCodeAt(0) && (r[n[218][e]] = 55808 + e, t[55808 + e] = n[218][e]);
        for (n[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(""), e = 0; e != n[219].length; ++e) 65533 !== n[219][e].charCodeAt(0) && (r[n[219][e]] = 56064 + e, t[56064 + e] = n[219][e]);
        for (n[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(""), e = 0; e != n[220].length; ++e) 65533 !== n[220][e].charCodeAt(0) && (r[n[220][e]] = 56320 + e, t[56320 + e] = n[220][e]);
        for (n[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(""), e = 0; e != n[221].length; ++e) 65533 !== n[221][e].charCodeAt(0) && (r[n[221][e]] = 56576 + e, t[56576 + e] = n[221][e]);
        for (n[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(""), e = 0; e != n[222].length; ++e) 65533 !== n[222][e].charCodeAt(0) && (r[n[222][e]] = 56832 + e, t[56832 + e] = n[222][e]);
        for (n[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(""), e = 0; e != n[223].length; ++e) 65533 !== n[223][e].charCodeAt(0) && (r[n[223][e]] = 57088 + e, t[57088 + e] = n[223][e]);
        for (n[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(""), e = 0; e != n[224].length; ++e) 65533 !== n[224][e].charCodeAt(0) && (r[n[224][e]] = 57344 + e, t[57344 + e] = n[224][e]);
        for (n[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(""), e = 0; e != n[225].length; ++e) 65533 !== n[225][e].charCodeAt(0) && (r[n[225][e]] = 57600 + e, t[57600 + e] = n[225][e]);
        for (n[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(""), e = 0; e != n[226].length; ++e) 65533 !== n[226][e].charCodeAt(0) && (r[n[226][e]] = 57856 + e, t[57856 + e] = n[226][e]);
        for (n[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(""), e = 0; e != n[227].length; ++e) 65533 !== n[227][e].charCodeAt(0) && (r[n[227][e]] = 58112 + e, t[58112 + e] = n[227][e]);
        for (n[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(""), e = 0; e != n[228].length; ++e) 65533 !== n[228][e].charCodeAt(0) && (r[n[228][e]] = 58368 + e, t[58368 + e] = n[228][e]);
        for (n[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(""), e = 0; e != n[229].length; ++e) 65533 !== n[229][e].charCodeAt(0) && (r[n[229][e]] = 58624 + e, t[58624 + e] = n[229][e]);
        for (n[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(""), e = 0; e != n[230].length; ++e) 65533 !== n[230][e].charCodeAt(0) && (r[n[230][e]] = 58880 + e, t[58880 + e] = n[230][e]);
        for (n[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(""), e = 0; e != n[231].length; ++e) 65533 !== n[231][e].charCodeAt(0) && (r[n[231][e]] = 59136 + e, t[59136 + e] = n[231][e]);
        for (n[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(""), e = 0; e != n[232].length; ++e) 65533 !== n[232][e].charCodeAt(0) && (r[n[232][e]] = 59392 + e, t[59392 + e] = n[232][e]);
        for (n[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(""), e = 0; e != n[233].length; ++e) 65533 !== n[233][e].charCodeAt(0) && (r[n[233][e]] = 59648 + e, t[59648 + e] = n[233][e]);
        for (n[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(""), e = 0; e != n[234].length; ++e) 65533 !== n[234][e].charCodeAt(0) && (r[n[234][e]] = 59904 + e, t[59904 + e] = n[234][e]);
        for (n[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(""), e = 0; e != n[235].length; ++e) 65533 !== n[235][e].charCodeAt(0) && (r[n[235][e]] = 60160 + e, t[60160 + e] = n[235][e]);
        for (n[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(""), e = 0; e != n[236].length; ++e) 65533 !== n[236][e].charCodeAt(0) && (r[n[236][e]] = 60416 + e, t[60416 + e] = n[236][e]);
        for (n[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(""), e = 0; e != n[237].length; ++e) 65533 !== n[237][e].charCodeAt(0) && (r[n[237][e]] = 60672 + e, t[60672 + e] = n[237][e]);
        for (n[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(""), e = 0; e != n[238].length; ++e) 65533 !== n[238][e].charCodeAt(0) && (r[n[238][e]] = 60928 + e, t[60928 + e] = n[238][e]);
        for (n[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(""), e = 0; e != n[239].length; ++e) 65533 !== n[239][e].charCodeAt(0) && (r[n[239][e]] = 61184 + e, t[61184 + e] = n[239][e]);
        for (n[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(""), e = 0; e != n[240].length; ++e) 65533 !== n[240][e].charCodeAt(0) && (r[n[240][e]] = 61440 + e, t[61440 + e] = n[240][e]);
        for (n[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(""), e = 0; e != n[241].length; ++e) 65533 !== n[241][e].charCodeAt(0) && (r[n[241][e]] = 61696 + e, t[61696 + e] = n[241][e]);
        for (n[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(""), e = 0; e != n[242].length; ++e) 65533 !== n[242][e].charCodeAt(0) && (r[n[242][e]] = 61952 + e, t[61952 + e] = n[242][e]);
        for (n[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(""), e = 0; e != n[243].length; ++e) 65533 !== n[243][e].charCodeAt(0) && (r[n[243][e]] = 62208 + e, t[62208 + e] = n[243][e]);
        for (n[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(""), e = 0; e != n[244].length; ++e) 65533 !== n[244][e].charCodeAt(0) && (r[n[244][e]] = 62464 + e, t[62464 + e] = n[244][e]);
        for (n[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(""), e = 0; e != n[245].length; ++e) 65533 !== n[245][e].charCodeAt(0) && (r[n[245][e]] = 62720 + e, t[62720 + e] = n[245][e]);
        for (n[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(""), e = 0; e != n[246].length; ++e) 65533 !== n[246][e].charCodeAt(0) && (r[n[246][e]] = 62976 + e, t[62976 + e] = n[246][e]);
        for (n[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(""), e = 0; e != n[247].length; ++e) 65533 !== n[247][e].charCodeAt(0) && (r[n[247][e]] = 63232 + e, t[63232 + e] = n[247][e]);
        for (n[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[248].length; ++e) 65533 !== n[248][e].charCodeAt(0) && (r[n[248][e]] = 63488 + e, t[63488 + e] = n[248][e]);
        for (n[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[249].length; ++e) 65533 !== n[249][e].charCodeAt(0) && (r[n[249][e]] = 63744 + e, t[63744 + e] = n[249][e]);
        for (n[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[250].length; ++e) 65533 !== n[250][e].charCodeAt(0) && (r[n[250][e]] = 64e3 + e, t[64e3 + e] = n[250][e]);
        for (n[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[251].length; ++e) 65533 !== n[251][e].charCodeAt(0) && (r[n[251][e]] = 64256 + e, t[64256 + e] = n[251][e]);
        for (n[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[252].length; ++e) 65533 !== n[252][e].charCodeAt(0) && (r[n[252][e]] = 64512 + e, t[64512 + e] = n[252][e]);
        for (n[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[253].length; ++e) 65533 !== n[253][e].charCodeAt(0) && (r[n[253][e]] = 64768 + e, t[64768 + e] = n[253][e]);
        for (n[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[254].length; ++e) 65533 !== n[254][e].charCodeAt(0) && (r[n[254][e]] = 65024 + e, t[65024 + e] = n[254][e]);
        return {
          enc: r,
          dec: t
        };
      }(), r[949] = function () {
        var e,
          t = [],
          r = {},
          n = [];
        for (n[0] = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[0].length; ++e) 65533 !== n[0][e].charCodeAt(0) && (r[n[0][e]] = 0 + e, t[0 + e] = n[0][e]);
        for (n[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split(""), e = 0; e != n[129].length; ++e) 65533 !== n[129][e].charCodeAt(0) && (r[n[129][e]] = 33024 + e, t[33024 + e] = n[129][e]);
        for (n[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split(""), e = 0; e != n[130].length; ++e) 65533 !== n[130][e].charCodeAt(0) && (r[n[130][e]] = 33280 + e, t[33280 + e] = n[130][e]);
        for (n[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split(""), e = 0; e != n[131].length; ++e) 65533 !== n[131][e].charCodeAt(0) && (r[n[131][e]] = 33536 + e, t[33536 + e] = n[131][e]);
        for (n[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split(""), e = 0; e != n[132].length; ++e) 65533 !== n[132][e].charCodeAt(0) && (r[n[132][e]] = 33792 + e, t[33792 + e] = n[132][e]);
        for (n[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split(""), e = 0; e != n[133].length; ++e) 65533 !== n[133][e].charCodeAt(0) && (r[n[133][e]] = 34048 + e, t[34048 + e] = n[133][e]);
        for (n[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split(""), e = 0; e != n[134].length; ++e) 65533 !== n[134][e].charCodeAt(0) && (r[n[134][e]] = 34304 + e, t[34304 + e] = n[134][e]);
        for (n[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split(""), e = 0; e != n[135].length; ++e) 65533 !== n[135][e].charCodeAt(0) && (r[n[135][e]] = 34560 + e, t[34560 + e] = n[135][e]);
        for (n[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split(""), e = 0; e != n[136].length; ++e) 65533 !== n[136][e].charCodeAt(0) && (r[n[136][e]] = 34816 + e, t[34816 + e] = n[136][e]);
        for (n[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split(""), e = 0; e != n[137].length; ++e) 65533 !== n[137][e].charCodeAt(0) && (r[n[137][e]] = 35072 + e, t[35072 + e] = n[137][e]);
        for (n[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split(""), e = 0; e != n[138].length; ++e) 65533 !== n[138][e].charCodeAt(0) && (r[n[138][e]] = 35328 + e, t[35328 + e] = n[138][e]);
        for (n[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split(""), e = 0; e != n[139].length; ++e) 65533 !== n[139][e].charCodeAt(0) && (r[n[139][e]] = 35584 + e, t[35584 + e] = n[139][e]);
        for (n[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split(""), e = 0; e != n[140].length; ++e) 65533 !== n[140][e].charCodeAt(0) && (r[n[140][e]] = 35840 + e, t[35840 + e] = n[140][e]);
        for (n[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split(""), e = 0; e != n[141].length; ++e) 65533 !== n[141][e].charCodeAt(0) && (r[n[141][e]] = 36096 + e, t[36096 + e] = n[141][e]);
        for (n[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split(""), e = 0; e != n[142].length; ++e) 65533 !== n[142][e].charCodeAt(0) && (r[n[142][e]] = 36352 + e, t[36352 + e] = n[142][e]);
        for (n[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split(""), e = 0; e != n[143].length; ++e) 65533 !== n[143][e].charCodeAt(0) && (r[n[143][e]] = 36608 + e, t[36608 + e] = n[143][e]);
        for (n[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split(""), e = 0; e != n[144].length; ++e) 65533 !== n[144][e].charCodeAt(0) && (r[n[144][e]] = 36864 + e, t[36864 + e] = n[144][e]);
        for (n[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split(""), e = 0; e != n[145].length; ++e) 65533 !== n[145][e].charCodeAt(0) && (r[n[145][e]] = 37120 + e, t[37120 + e] = n[145][e]);
        for (n[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split(""), e = 0; e != n[146].length; ++e) 65533 !== n[146][e].charCodeAt(0) && (r[n[146][e]] = 37376 + e, t[37376 + e] = n[146][e]);
        for (n[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split(""), e = 0; e != n[147].length; ++e) 65533 !== n[147][e].charCodeAt(0) && (r[n[147][e]] = 37632 + e, t[37632 + e] = n[147][e]);
        for (n[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split(""), e = 0; e != n[148].length; ++e) 65533 !== n[148][e].charCodeAt(0) && (r[n[148][e]] = 37888 + e, t[37888 + e] = n[148][e]);
        for (n[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split(""), e = 0; e != n[149].length; ++e) 65533 !== n[149][e].charCodeAt(0) && (r[n[149][e]] = 38144 + e, t[38144 + e] = n[149][e]);
        for (n[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split(""), e = 0; e != n[150].length; ++e) 65533 !== n[150][e].charCodeAt(0) && (r[n[150][e]] = 38400 + e, t[38400 + e] = n[150][e]);
        for (n[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split(""), e = 0; e != n[151].length; ++e) 65533 !== n[151][e].charCodeAt(0) && (r[n[151][e]] = 38656 + e, t[38656 + e] = n[151][e]);
        for (n[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split(""), e = 0; e != n[152].length; ++e) 65533 !== n[152][e].charCodeAt(0) && (r[n[152][e]] = 38912 + e, t[38912 + e] = n[152][e]);
        for (n[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split(""), e = 0; e != n[153].length; ++e) 65533 !== n[153][e].charCodeAt(0) && (r[n[153][e]] = 39168 + e, t[39168 + e] = n[153][e]);
        for (n[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split(""), e = 0; e != n[154].length; ++e) 65533 !== n[154][e].charCodeAt(0) && (r[n[154][e]] = 39424 + e, t[39424 + e] = n[154][e]);
        for (n[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split(""), e = 0; e != n[155].length; ++e) 65533 !== n[155][e].charCodeAt(0) && (r[n[155][e]] = 39680 + e, t[39680 + e] = n[155][e]);
        for (n[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split(""), e = 0; e != n[156].length; ++e) 65533 !== n[156][e].charCodeAt(0) && (r[n[156][e]] = 39936 + e, t[39936 + e] = n[156][e]);
        for (n[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split(""), e = 0; e != n[157].length; ++e) 65533 !== n[157][e].charCodeAt(0) && (r[n[157][e]] = 40192 + e, t[40192 + e] = n[157][e]);
        for (n[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split(""), e = 0; e != n[158].length; ++e) 65533 !== n[158][e].charCodeAt(0) && (r[n[158][e]] = 40448 + e, t[40448 + e] = n[158][e]);
        for (n[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split(""), e = 0; e != n[159].length; ++e) 65533 !== n[159][e].charCodeAt(0) && (r[n[159][e]] = 40704 + e, t[40704 + e] = n[159][e]);
        for (n[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split(""), e = 0; e != n[160].length; ++e) 65533 !== n[160][e].charCodeAt(0) && (r[n[160][e]] = 40960 + e, t[40960 + e] = n[160][e]);
        for (n[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split(""), e = 0; e != n[161].length; ++e) 65533 !== n[161][e].charCodeAt(0) && (r[n[161][e]] = 41216 + e, t[41216 + e] = n[161][e]);
        for (n[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split(""), e = 0; e != n[162].length; ++e) 65533 !== n[162][e].charCodeAt(0) && (r[n[162][e]] = 41472 + e, t[41472 + e] = n[162][e]);
        for (n[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != n[163].length; ++e) 65533 !== n[163][e].charCodeAt(0) && (r[n[163][e]] = 41728 + e, t[41728 + e] = n[163][e]);
        for (n[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split(""), e = 0; e != n[164].length; ++e) 65533 !== n[164][e].charCodeAt(0) && (r[n[164][e]] = 41984 + e, t[41984 + e] = n[164][e]);
        for (n[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split(""), e = 0; e != n[165].length; ++e) 65533 !== n[165][e].charCodeAt(0) && (r[n[165][e]] = 42240 + e, t[42240 + e] = n[165][e]);
        for (n[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split(""), e = 0; e != n[166].length; ++e) 65533 !== n[166][e].charCodeAt(0) && (r[n[166][e]] = 42496 + e, t[42496 + e] = n[166][e]);
        for (n[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split(""), e = 0; e != n[167].length; ++e) 65533 !== n[167][e].charCodeAt(0) && (r[n[167][e]] = 42752 + e, t[42752 + e] = n[167][e]);
        for (n[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split(""), e = 0; e != n[168].length; ++e) 65533 !== n[168][e].charCodeAt(0) && (r[n[168][e]] = 43008 + e, t[43008 + e] = n[168][e]);
        for (n[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split(""), e = 0; e != n[169].length; ++e) 65533 !== n[169][e].charCodeAt(0) && (r[n[169][e]] = 43264 + e, t[43264 + e] = n[169][e]);
        for (n[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != n[170].length; ++e) 65533 !== n[170][e].charCodeAt(0) && (r[n[170][e]] = 43520 + e, t[43520 + e] = n[170][e]);
        for (n[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != n[171].length; ++e) 65533 !== n[171][e].charCodeAt(0) && (r[n[171][e]] = 43776 + e, t[43776 + e] = n[171][e]);
        for (n[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != n[172].length; ++e) 65533 !== n[172][e].charCodeAt(0) && (r[n[172][e]] = 44032 + e, t[44032 + e] = n[172][e]);
        for (n[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[173].length; ++e) 65533 !== n[173][e].charCodeAt(0) && (r[n[173][e]] = 44288 + e, t[44288 + e] = n[173][e]);
        for (n[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[174].length; ++e) 65533 !== n[174][e].charCodeAt(0) && (r[n[174][e]] = 44544 + e, t[44544 + e] = n[174][e]);
        for (n[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split(""), e = 0; e != n[175].length; ++e) 65533 !== n[175][e].charCodeAt(0) && (r[n[175][e]] = 44800 + e, t[44800 + e] = n[175][e]);
        for (n[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split(""), e = 0; e != n[176].length; ++e) 65533 !== n[176][e].charCodeAt(0) && (r[n[176][e]] = 45056 + e, t[45056 + e] = n[176][e]);
        for (n[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split(""), e = 0; e != n[177].length; ++e) 65533 !== n[177][e].charCodeAt(0) && (r[n[177][e]] = 45312 + e, t[45312 + e] = n[177][e]);
        for (n[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split(""), e = 0; e != n[178].length; ++e) 65533 !== n[178][e].charCodeAt(0) && (r[n[178][e]] = 45568 + e, t[45568 + e] = n[178][e]);
        for (n[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split(""), e = 0; e != n[179].length; ++e) 65533 !== n[179][e].charCodeAt(0) && (r[n[179][e]] = 45824 + e, t[45824 + e] = n[179][e]);
        for (n[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split(""), e = 0; e != n[180].length; ++e) 65533 !== n[180][e].charCodeAt(0) && (r[n[180][e]] = 46080 + e, t[46080 + e] = n[180][e]);
        for (n[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split(""), e = 0; e != n[181].length; ++e) 65533 !== n[181][e].charCodeAt(0) && (r[n[181][e]] = 46336 + e, t[46336 + e] = n[181][e]);
        for (n[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split(""), e = 0; e != n[182].length; ++e) 65533 !== n[182][e].charCodeAt(0) && (r[n[182][e]] = 46592 + e, t[46592 + e] = n[182][e]);
        for (n[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split(""), e = 0; e != n[183].length; ++e) 65533 !== n[183][e].charCodeAt(0) && (r[n[183][e]] = 46848 + e, t[46848 + e] = n[183][e]);
        for (n[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split(""), e = 0; e != n[184].length; ++e) 65533 !== n[184][e].charCodeAt(0) && (r[n[184][e]] = 47104 + e, t[47104 + e] = n[184][e]);
        for (n[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split(""), e = 0; e != n[185].length; ++e) 65533 !== n[185][e].charCodeAt(0) && (r[n[185][e]] = 47360 + e, t[47360 + e] = n[185][e]);
        for (n[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split(""), e = 0; e != n[186].length; ++e) 65533 !== n[186][e].charCodeAt(0) && (r[n[186][e]] = 47616 + e, t[47616 + e] = n[186][e]);
        for (n[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split(""), e = 0; e != n[187].length; ++e) 65533 !== n[187][e].charCodeAt(0) && (r[n[187][e]] = 47872 + e, t[47872 + e] = n[187][e]);
        for (n[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split(""), e = 0; e != n[188].length; ++e) 65533 !== n[188][e].charCodeAt(0) && (r[n[188][e]] = 48128 + e, t[48128 + e] = n[188][e]);
        for (n[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split(""), e = 0; e != n[189].length; ++e) 65533 !== n[189][e].charCodeAt(0) && (r[n[189][e]] = 48384 + e, t[48384 + e] = n[189][e]);
        for (n[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split(""), e = 0; e != n[190].length; ++e) 65533 !== n[190][e].charCodeAt(0) && (r[n[190][e]] = 48640 + e, t[48640 + e] = n[190][e]);
        for (n[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split(""), e = 0; e != n[191].length; ++e) 65533 !== n[191][e].charCodeAt(0) && (r[n[191][e]] = 48896 + e, t[48896 + e] = n[191][e]);
        for (n[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split(""), e = 0; e != n[192].length; ++e) 65533 !== n[192][e].charCodeAt(0) && (r[n[192][e]] = 49152 + e, t[49152 + e] = n[192][e]);
        for (n[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split(""), e = 0; e != n[193].length; ++e) 65533 !== n[193][e].charCodeAt(0) && (r[n[193][e]] = 49408 + e, t[49408 + e] = n[193][e]);
        for (n[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split(""), e = 0; e != n[194].length; ++e) 65533 !== n[194][e].charCodeAt(0) && (r[n[194][e]] = 49664 + e, t[49664 + e] = n[194][e]);
        for (n[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split(""), e = 0; e != n[195].length; ++e) 65533 !== n[195][e].charCodeAt(0) && (r[n[195][e]] = 49920 + e, t[49920 + e] = n[195][e]);
        for (n[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split(""), e = 0; e != n[196].length; ++e) 65533 !== n[196][e].charCodeAt(0) && (r[n[196][e]] = 50176 + e, t[50176 + e] = n[196][e]);
        for (n[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split(""), e = 0; e != n[197].length; ++e) 65533 !== n[197][e].charCodeAt(0) && (r[n[197][e]] = 50432 + e, t[50432 + e] = n[197][e]);
        for (n[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split(""), e = 0; e != n[198].length; ++e) 65533 !== n[198][e].charCodeAt(0) && (r[n[198][e]] = 50688 + e, t[50688 + e] = n[198][e]);
        for (n[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split(""), e = 0; e != n[199].length; ++e) 65533 !== n[199][e].charCodeAt(0) && (r[n[199][e]] = 50944 + e, t[50944 + e] = n[199][e]);
        for (n[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split(""), e = 0; e != n[200].length; ++e) 65533 !== n[200][e].charCodeAt(0) && (r[n[200][e]] = 51200 + e, t[51200 + e] = n[200][e]);
        for (n[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split(""), e = 0; e != n[202].length; ++e) 65533 !== n[202][e].charCodeAt(0) && (r[n[202][e]] = 51712 + e, t[51712 + e] = n[202][e]);
        for (n[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split(""), e = 0; e != n[203].length; ++e) 65533 !== n[203][e].charCodeAt(0) && (r[n[203][e]] = 51968 + e, t[51968 + e] = n[203][e]);
        for (n[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split(""), e = 0; e != n[204].length; ++e) 65533 !== n[204][e].charCodeAt(0) && (r[n[204][e]] = 52224 + e, t[52224 + e] = n[204][e]);
        for (n[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split(""), e = 0; e != n[205].length; ++e) 65533 !== n[205][e].charCodeAt(0) && (r[n[205][e]] = 52480 + e, t[52480 + e] = n[205][e]);
        for (n[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split(""), e = 0; e != n[206].length; ++e) 65533 !== n[206][e].charCodeAt(0) && (r[n[206][e]] = 52736 + e, t[52736 + e] = n[206][e]);
        for (n[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split(""), e = 0; e != n[207].length; ++e) 65533 !== n[207][e].charCodeAt(0) && (r[n[207][e]] = 52992 + e, t[52992 + e] = n[207][e]);
        for (n[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split(""), e = 0; e != n[208].length; ++e) 65533 !== n[208][e].charCodeAt(0) && (r[n[208][e]] = 53248 + e, t[53248 + e] = n[208][e]);
        for (n[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split(""), e = 0; e != n[209].length; ++e) 65533 !== n[209][e].charCodeAt(0) && (r[n[209][e]] = 53504 + e, t[53504 + e] = n[209][e]);
        for (n[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split(""), e = 0; e != n[210].length; ++e) 65533 !== n[210][e].charCodeAt(0) && (r[n[210][e]] = 53760 + e, t[53760 + e] = n[210][e]);
        for (n[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split(""), e = 0; e != n[211].length; ++e) 65533 !== n[211][e].charCodeAt(0) && (r[n[211][e]] = 54016 + e, t[54016 + e] = n[211][e]);
        for (n[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split(""), e = 0; e != n[212].length; ++e) 65533 !== n[212][e].charCodeAt(0) && (r[n[212][e]] = 54272 + e, t[54272 + e] = n[212][e]);
        for (n[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split(""), e = 0; e != n[213].length; ++e) 65533 !== n[213][e].charCodeAt(0) && (r[n[213][e]] = 54528 + e, t[54528 + e] = n[213][e]);
        for (n[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split(""), e = 0; e != n[214].length; ++e) 65533 !== n[214][e].charCodeAt(0) && (r[n[214][e]] = 54784 + e, t[54784 + e] = n[214][e]);
        for (n[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split(""), e = 0; e != n[215].length; ++e) 65533 !== n[215][e].charCodeAt(0) && (r[n[215][e]] = 55040 + e, t[55040 + e] = n[215][e]);
        for (n[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split(""), e = 0; e != n[216].length; ++e) 65533 !== n[216][e].charCodeAt(0) && (r[n[216][e]] = 55296 + e, t[55296 + e] = n[216][e]);
        for (n[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split(""), e = 0; e != n[217].length; ++e) 65533 !== n[217][e].charCodeAt(0) && (r[n[217][e]] = 55552 + e, t[55552 + e] = n[217][e]);
        for (n[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split(""), e = 0; e != n[218].length; ++e) 65533 !== n[218][e].charCodeAt(0) && (r[n[218][e]] = 55808 + e, t[55808 + e] = n[218][e]);
        for (n[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split(""), e = 0; e != n[219].length; ++e) 65533 !== n[219][e].charCodeAt(0) && (r[n[219][e]] = 56064 + e, t[56064 + e] = n[219][e]);
        for (n[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split(""), e = 0; e != n[220].length; ++e) 65533 !== n[220][e].charCodeAt(0) && (r[n[220][e]] = 56320 + e, t[56320 + e] = n[220][e]);
        for (n[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split(""), e = 0; e != n[221].length; ++e) 65533 !== n[221][e].charCodeAt(0) && (r[n[221][e]] = 56576 + e, t[56576 + e] = n[221][e]);
        for (n[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split(""), e = 0; e != n[222].length; ++e) 65533 !== n[222][e].charCodeAt(0) && (r[n[222][e]] = 56832 + e, t[56832 + e] = n[222][e]);
        for (n[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split(""), e = 0; e != n[223].length; ++e) 65533 !== n[223][e].charCodeAt(0) && (r[n[223][e]] = 57088 + e, t[57088 + e] = n[223][e]);
        for (n[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split(""), e = 0; e != n[224].length; ++e) 65533 !== n[224][e].charCodeAt(0) && (r[n[224][e]] = 57344 + e, t[57344 + e] = n[224][e]);
        for (n[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split(""), e = 0; e != n[225].length; ++e) 65533 !== n[225][e].charCodeAt(0) && (r[n[225][e]] = 57600 + e, t[57600 + e] = n[225][e]);
        for (n[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split(""), e = 0; e != n[226].length; ++e) 65533 !== n[226][e].charCodeAt(0) && (r[n[226][e]] = 57856 + e, t[57856 + e] = n[226][e]);
        for (n[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split(""), e = 0; e != n[227].length; ++e) 65533 !== n[227][e].charCodeAt(0) && (r[n[227][e]] = 58112 + e, t[58112 + e] = n[227][e]);
        for (n[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split(""), e = 0; e != n[228].length; ++e) 65533 !== n[228][e].charCodeAt(0) && (r[n[228][e]] = 58368 + e, t[58368 + e] = n[228][e]);
        for (n[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split(""), e = 0; e != n[229].length; ++e) 65533 !== n[229][e].charCodeAt(0) && (r[n[229][e]] = 58624 + e, t[58624 + e] = n[229][e]);
        for (n[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split(""), e = 0; e != n[230].length; ++e) 65533 !== n[230][e].charCodeAt(0) && (r[n[230][e]] = 58880 + e, t[58880 + e] = n[230][e]);
        for (n[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split(""), e = 0; e != n[231].length; ++e) 65533 !== n[231][e].charCodeAt(0) && (r[n[231][e]] = 59136 + e, t[59136 + e] = n[231][e]);
        for (n[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split(""), e = 0; e != n[232].length; ++e) 65533 !== n[232][e].charCodeAt(0) && (r[n[232][e]] = 59392 + e, t[59392 + e] = n[232][e]);
        for (n[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split(""), e = 0; e != n[233].length; ++e) 65533 !== n[233][e].charCodeAt(0) && (r[n[233][e]] = 59648 + e, t[59648 + e] = n[233][e]);
        for (n[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split(""), e = 0; e != n[234].length; ++e) 65533 !== n[234][e].charCodeAt(0) && (r[n[234][e]] = 59904 + e, t[59904 + e] = n[234][e]);
        for (n[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split(""), e = 0; e != n[235].length; ++e) 65533 !== n[235][e].charCodeAt(0) && (r[n[235][e]] = 60160 + e, t[60160 + e] = n[235][e]);
        for (n[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split(""), e = 0; e != n[236].length; ++e) 65533 !== n[236][e].charCodeAt(0) && (r[n[236][e]] = 60416 + e, t[60416 + e] = n[236][e]);
        for (n[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split(""), e = 0; e != n[237].length; ++e) 65533 !== n[237][e].charCodeAt(0) && (r[n[237][e]] = 60672 + e, t[60672 + e] = n[237][e]);
        for (n[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split(""), e = 0; e != n[238].length; ++e) 65533 !== n[238][e].charCodeAt(0) && (r[n[238][e]] = 60928 + e, t[60928 + e] = n[238][e]);
        for (n[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split(""), e = 0; e != n[239].length; ++e) 65533 !== n[239][e].charCodeAt(0) && (r[n[239][e]] = 61184 + e, t[61184 + e] = n[239][e]);
        for (n[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split(""), e = 0; e != n[240].length; ++e) 65533 !== n[240][e].charCodeAt(0) && (r[n[240][e]] = 61440 + e, t[61440 + e] = n[240][e]);
        for (n[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split(""), e = 0; e != n[241].length; ++e) 65533 !== n[241][e].charCodeAt(0) && (r[n[241][e]] = 61696 + e, t[61696 + e] = n[241][e]);
        for (n[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split(""), e = 0; e != n[242].length; ++e) 65533 !== n[242][e].charCodeAt(0) && (r[n[242][e]] = 61952 + e, t[61952 + e] = n[242][e]);
        for (n[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split(""), e = 0; e != n[243].length; ++e) 65533 !== n[243][e].charCodeAt(0) && (r[n[243][e]] = 62208 + e, t[62208 + e] = n[243][e]);
        for (n[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split(""), e = 0; e != n[244].length; ++e) 65533 !== n[244][e].charCodeAt(0) && (r[n[244][e]] = 62464 + e, t[62464 + e] = n[244][e]);
        for (n[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split(""), e = 0; e != n[245].length; ++e) 65533 !== n[245][e].charCodeAt(0) && (r[n[245][e]] = 62720 + e, t[62720 + e] = n[245][e]);
        for (n[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split(""), e = 0; e != n[246].length; ++e) 65533 !== n[246][e].charCodeAt(0) && (r[n[246][e]] = 62976 + e, t[62976 + e] = n[246][e]);
        for (n[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split(""), e = 0; e != n[247].length; ++e) 65533 !== n[247][e].charCodeAt(0) && (r[n[247][e]] = 63232 + e, t[63232 + e] = n[247][e]);
        for (n[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split(""), e = 0; e != n[248].length; ++e) 65533 !== n[248][e].charCodeAt(0) && (r[n[248][e]] = 63488 + e, t[63488 + e] = n[248][e]);
        for (n[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split(""), e = 0; e != n[249].length; ++e) 65533 !== n[249][e].charCodeAt(0) && (r[n[249][e]] = 63744 + e, t[63744 + e] = n[249][e]);
        for (n[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split(""), e = 0; e != n[250].length; ++e) 65533 !== n[250][e].charCodeAt(0) && (r[n[250][e]] = 64e3 + e, t[64e3 + e] = n[250][e]);
        for (n[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split(""), e = 0; e != n[251].length; ++e) 65533 !== n[251][e].charCodeAt(0) && (r[n[251][e]] = 64256 + e, t[64256 + e] = n[251][e]);
        for (n[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split(""), e = 0; e != n[252].length; ++e) 65533 !== n[252][e].charCodeAt(0) && (r[n[252][e]] = 64512 + e, t[64512 + e] = n[252][e]);
        for (n[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split(""), e = 0; e != n[253].length; ++e) 65533 !== n[253][e].charCodeAt(0) && (r[n[253][e]] = 64768 + e, t[64768 + e] = n[253][e]);
        return {
          enc: r,
          dec: t
        };
      }(), r[950] = function () {
        var e,
          t = [],
          r = {},
          n = [];
        for (n[0] = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[0].length; ++e) 65533 !== n[0][e].charCodeAt(0) && (r[n[0][e]] = 0 + e, t[0 + e] = n[0][e]);
        for (n[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split(""), e = 0; e != n[161].length; ++e) 65533 !== n[161][e].charCodeAt(0) && (r[n[161][e]] = 41216 + e, t[41216 + e] = n[161][e]);
        for (n[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split(""), e = 0; e != n[162].length; ++e) 65533 !== n[162][e].charCodeAt(0) && (r[n[162][e]] = 41472 + e, t[41472 + e] = n[162][e]);
        for (n[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split(""), e = 0; e != n[163].length; ++e) 65533 !== n[163][e].charCodeAt(0) && (r[n[163][e]] = 41728 + e, t[41728 + e] = n[163][e]);
        for (n[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split(""), e = 0; e != n[164].length; ++e) 65533 !== n[164][e].charCodeAt(0) && (r[n[164][e]] = 41984 + e, t[41984 + e] = n[164][e]);
        for (n[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split(""), e = 0; e != n[165].length; ++e) 65533 !== n[165][e].charCodeAt(0) && (r[n[165][e]] = 42240 + e, t[42240 + e] = n[165][e]);
        for (n[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split(""), e = 0; e != n[166].length; ++e) 65533 !== n[166][e].charCodeAt(0) && (r[n[166][e]] = 42496 + e, t[42496 + e] = n[166][e]);
        for (n[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split(""), e = 0; e != n[167].length; ++e) 65533 !== n[167][e].charCodeAt(0) && (r[n[167][e]] = 42752 + e, t[42752 + e] = n[167][e]);
        for (n[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split(""), e = 0; e != n[168].length; ++e) 65533 !== n[168][e].charCodeAt(0) && (r[n[168][e]] = 43008 + e, t[43008 + e] = n[168][e]);
        for (n[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split(""), e = 0; e != n[169].length; ++e) 65533 !== n[169][e].charCodeAt(0) && (r[n[169][e]] = 43264 + e, t[43264 + e] = n[169][e]);
        for (n[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split(""), e = 0; e != n[170].length; ++e) 65533 !== n[170][e].charCodeAt(0) && (r[n[170][e]] = 43520 + e, t[43520 + e] = n[170][e]);
        for (n[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split(""), e = 0; e != n[171].length; ++e) 65533 !== n[171][e].charCodeAt(0) && (r[n[171][e]] = 43776 + e, t[43776 + e] = n[171][e]);
        for (n[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split(""), e = 0; e != n[172].length; ++e) 65533 !== n[172][e].charCodeAt(0) && (r[n[172][e]] = 44032 + e, t[44032 + e] = n[172][e]);
        for (n[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split(""), e = 0; e != n[173].length; ++e) 65533 !== n[173][e].charCodeAt(0) && (r[n[173][e]] = 44288 + e, t[44288 + e] = n[173][e]);
        for (n[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split(""), e = 0; e != n[174].length; ++e) 65533 !== n[174][e].charCodeAt(0) && (r[n[174][e]] = 44544 + e, t[44544 + e] = n[174][e]);
        for (n[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split(""), e = 0; e != n[175].length; ++e) 65533 !== n[175][e].charCodeAt(0) && (r[n[175][e]] = 44800 + e, t[44800 + e] = n[175][e]);
        for (n[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split(""), e = 0; e != n[176].length; ++e) 65533 !== n[176][e].charCodeAt(0) && (r[n[176][e]] = 45056 + e, t[45056 + e] = n[176][e]);
        for (n[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split(""), e = 0; e != n[177].length; ++e) 65533 !== n[177][e].charCodeAt(0) && (r[n[177][e]] = 45312 + e, t[45312 + e] = n[177][e]);
        for (n[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split(""), e = 0; e != n[178].length; ++e) 65533 !== n[178][e].charCodeAt(0) && (r[n[178][e]] = 45568 + e, t[45568 + e] = n[178][e]);
        for (n[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split(""), e = 0; e != n[179].length; ++e) 65533 !== n[179][e].charCodeAt(0) && (r[n[179][e]] = 45824 + e, t[45824 + e] = n[179][e]);
        for (n[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split(""), e = 0; e != n[180].length; ++e) 65533 !== n[180][e].charCodeAt(0) && (r[n[180][e]] = 46080 + e, t[46080 + e] = n[180][e]);
        for (n[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split(""), e = 0; e != n[181].length; ++e) 65533 !== n[181][e].charCodeAt(0) && (r[n[181][e]] = 46336 + e, t[46336 + e] = n[181][e]);
        for (n[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split(""), e = 0; e != n[182].length; ++e) 65533 !== n[182][e].charCodeAt(0) && (r[n[182][e]] = 46592 + e, t[46592 + e] = n[182][e]);
        for (n[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split(""), e = 0; e != n[183].length; ++e) 65533 !== n[183][e].charCodeAt(0) && (r[n[183][e]] = 46848 + e, t[46848 + e] = n[183][e]);
        for (n[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split(""), e = 0; e != n[184].length; ++e) 65533 !== n[184][e].charCodeAt(0) && (r[n[184][e]] = 47104 + e, t[47104 + e] = n[184][e]);
        for (n[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split(""), e = 0; e != n[185].length; ++e) 65533 !== n[185][e].charCodeAt(0) && (r[n[185][e]] = 47360 + e, t[47360 + e] = n[185][e]);
        for (n[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split(""), e = 0; e != n[186].length; ++e) 65533 !== n[186][e].charCodeAt(0) && (r[n[186][e]] = 47616 + e, t[47616 + e] = n[186][e]);
        for (n[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split(""), e = 0; e != n[187].length; ++e) 65533 !== n[187][e].charCodeAt(0) && (r[n[187][e]] = 47872 + e, t[47872 + e] = n[187][e]);
        for (n[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split(""), e = 0; e != n[188].length; ++e) 65533 !== n[188][e].charCodeAt(0) && (r[n[188][e]] = 48128 + e, t[48128 + e] = n[188][e]);
        for (n[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split(""), e = 0; e != n[189].length; ++e) 65533 !== n[189][e].charCodeAt(0) && (r[n[189][e]] = 48384 + e, t[48384 + e] = n[189][e]);
        for (n[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split(""), e = 0; e != n[190].length; ++e) 65533 !== n[190][e].charCodeAt(0) && (r[n[190][e]] = 48640 + e, t[48640 + e] = n[190][e]);
        for (n[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split(""), e = 0; e != n[191].length; ++e) 65533 !== n[191][e].charCodeAt(0) && (r[n[191][e]] = 48896 + e, t[48896 + e] = n[191][e]);
        for (n[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split(""), e = 0; e != n[192].length; ++e) 65533 !== n[192][e].charCodeAt(0) && (r[n[192][e]] = 49152 + e, t[49152 + e] = n[192][e]);
        for (n[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split(""), e = 0; e != n[193].length; ++e) 65533 !== n[193][e].charCodeAt(0) && (r[n[193][e]] = 49408 + e, t[49408 + e] = n[193][e]);
        for (n[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split(""), e = 0; e != n[194].length; ++e) 65533 !== n[194][e].charCodeAt(0) && (r[n[194][e]] = 49664 + e, t[49664 + e] = n[194][e]);
        for (n[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split(""), e = 0; e != n[195].length; ++e) 65533 !== n[195][e].charCodeAt(0) && (r[n[195][e]] = 49920 + e, t[49920 + e] = n[195][e]);
        for (n[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split(""), e = 0; e != n[196].length; ++e) 65533 !== n[196][e].charCodeAt(0) && (r[n[196][e]] = 50176 + e, t[50176 + e] = n[196][e]);
        for (n[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split(""), e = 0; e != n[197].length; ++e) 65533 !== n[197][e].charCodeAt(0) && (r[n[197][e]] = 50432 + e, t[50432 + e] = n[197][e]);
        for (n[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split(""), e = 0; e != n[198].length; ++e) 65533 !== n[198][e].charCodeAt(0) && (r[n[198][e]] = 50688 + e, t[50688 + e] = n[198][e]);
        for (n[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split(""), e = 0; e != n[201].length; ++e) 65533 !== n[201][e].charCodeAt(0) && (r[n[201][e]] = 51456 + e, t[51456 + e] = n[201][e]);
        for (n[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split(""), e = 0; e != n[202].length; ++e) 65533 !== n[202][e].charCodeAt(0) && (r[n[202][e]] = 51712 + e, t[51712 + e] = n[202][e]);
        for (n[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split(""), e = 0; e != n[203].length; ++e) 65533 !== n[203][e].charCodeAt(0) && (r[n[203][e]] = 51968 + e, t[51968 + e] = n[203][e]);
        for (n[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split(""), e = 0; e != n[204].length; ++e) 65533 !== n[204][e].charCodeAt(0) && (r[n[204][e]] = 52224 + e, t[52224 + e] = n[204][e]);
        for (n[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split(""), e = 0; e != n[205].length; ++e) 65533 !== n[205][e].charCodeAt(0) && (r[n[205][e]] = 52480 + e, t[52480 + e] = n[205][e]);
        for (n[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split(""), e = 0; e != n[206].length; ++e) 65533 !== n[206][e].charCodeAt(0) && (r[n[206][e]] = 52736 + e, t[52736 + e] = n[206][e]);
        for (n[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split(""), e = 0; e != n[207].length; ++e) 65533 !== n[207][e].charCodeAt(0) && (r[n[207][e]] = 52992 + e, t[52992 + e] = n[207][e]);
        for (n[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split(""), e = 0; e != n[208].length; ++e) 65533 !== n[208][e].charCodeAt(0) && (r[n[208][e]] = 53248 + e, t[53248 + e] = n[208][e]);
        for (n[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split(""), e = 0; e != n[209].length; ++e) 65533 !== n[209][e].charCodeAt(0) && (r[n[209][e]] = 53504 + e, t[53504 + e] = n[209][e]);
        for (n[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split(""), e = 0; e != n[210].length; ++e) 65533 !== n[210][e].charCodeAt(0) && (r[n[210][e]] = 53760 + e, t[53760 + e] = n[210][e]);
        for (n[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split(""), e = 0; e != n[211].length; ++e) 65533 !== n[211][e].charCodeAt(0) && (r[n[211][e]] = 54016 + e, t[54016 + e] = n[211][e]);
        for (n[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split(""), e = 0; e != n[212].length; ++e) 65533 !== n[212][e].charCodeAt(0) && (r[n[212][e]] = 54272 + e, t[54272 + e] = n[212][e]);
        for (n[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split(""), e = 0; e != n[213].length; ++e) 65533 !== n[213][e].charCodeAt(0) && (r[n[213][e]] = 54528 + e, t[54528 + e] = n[213][e]);
        for (n[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split(""), e = 0; e != n[214].length; ++e) 65533 !== n[214][e].charCodeAt(0) && (r[n[214][e]] = 54784 + e, t[54784 + e] = n[214][e]);
        for (n[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split(""), e = 0; e != n[215].length; ++e) 65533 !== n[215][e].charCodeAt(0) && (r[n[215][e]] = 55040 + e, t[55040 + e] = n[215][e]);
        for (n[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split(""), e = 0; e != n[216].length; ++e) 65533 !== n[216][e].charCodeAt(0) && (r[n[216][e]] = 55296 + e, t[55296 + e] = n[216][e]);
        for (n[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split(""), e = 0; e != n[217].length; ++e) 65533 !== n[217][e].charCodeAt(0) && (r[n[217][e]] = 55552 + e, t[55552 + e] = n[217][e]);
        for (n[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split(""), e = 0; e != n[218].length; ++e) 65533 !== n[218][e].charCodeAt(0) && (r[n[218][e]] = 55808 + e, t[55808 + e] = n[218][e]);
        for (n[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split(""), e = 0; e != n[219].length; ++e) 65533 !== n[219][e].charCodeAt(0) && (r[n[219][e]] = 56064 + e, t[56064 + e] = n[219][e]);
        for (n[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split(""), e = 0; e != n[220].length; ++e) 65533 !== n[220][e].charCodeAt(0) && (r[n[220][e]] = 56320 + e, t[56320 + e] = n[220][e]);
        for (n[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split(""), e = 0; e != n[221].length; ++e) 65533 !== n[221][e].charCodeAt(0) && (r[n[221][e]] = 56576 + e, t[56576 + e] = n[221][e]);
        for (n[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split(""), e = 0; e != n[222].length; ++e) 65533 !== n[222][e].charCodeAt(0) && (r[n[222][e]] = 56832 + e, t[56832 + e] = n[222][e]);
        for (n[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split(""), e = 0; e != n[223].length; ++e) 65533 !== n[223][e].charCodeAt(0) && (r[n[223][e]] = 57088 + e, t[57088 + e] = n[223][e]);
        for (n[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split(""), e = 0; e != n[224].length; ++e) 65533 !== n[224][e].charCodeAt(0) && (r[n[224][e]] = 57344 + e, t[57344 + e] = n[224][e]);
        for (n[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split(""), e = 0; e != n[225].length; ++e) 65533 !== n[225][e].charCodeAt(0) && (r[n[225][e]] = 57600 + e, t[57600 + e] = n[225][e]);
        for (n[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split(""), e = 0; e != n[226].length; ++e) 65533 !== n[226][e].charCodeAt(0) && (r[n[226][e]] = 57856 + e, t[57856 + e] = n[226][e]);
        for (n[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split(""), e = 0; e != n[227].length; ++e) 65533 !== n[227][e].charCodeAt(0) && (r[n[227][e]] = 58112 + e, t[58112 + e] = n[227][e]);
        for (n[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split(""), e = 0; e != n[228].length; ++e) 65533 !== n[228][e].charCodeAt(0) && (r[n[228][e]] = 58368 + e, t[58368 + e] = n[228][e]);
        for (n[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split(""), e = 0; e != n[229].length; ++e) 65533 !== n[229][e].charCodeAt(0) && (r[n[229][e]] = 58624 + e, t[58624 + e] = n[229][e]);
        for (n[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split(""), e = 0; e != n[230].length; ++e) 65533 !== n[230][e].charCodeAt(0) && (r[n[230][e]] = 58880 + e, t[58880 + e] = n[230][e]);
        for (n[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split(""), e = 0; e != n[231].length; ++e) 65533 !== n[231][e].charCodeAt(0) && (r[n[231][e]] = 59136 + e, t[59136 + e] = n[231][e]);
        for (n[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split(""), e = 0; e != n[232].length; ++e) 65533 !== n[232][e].charCodeAt(0) && (r[n[232][e]] = 59392 + e, t[59392 + e] = n[232][e]);
        for (n[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split(""), e = 0; e != n[233].length; ++e) 65533 !== n[233][e].charCodeAt(0) && (r[n[233][e]] = 59648 + e, t[59648 + e] = n[233][e]);
        for (n[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split(""), e = 0; e != n[234].length; ++e) 65533 !== n[234][e].charCodeAt(0) && (r[n[234][e]] = 59904 + e, t[59904 + e] = n[234][e]);
        for (n[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split(""), e = 0; e != n[235].length; ++e) 65533 !== n[235][e].charCodeAt(0) && (r[n[235][e]] = 60160 + e, t[60160 + e] = n[235][e]);
        for (n[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split(""), e = 0; e != n[236].length; ++e) 65533 !== n[236][e].charCodeAt(0) && (r[n[236][e]] = 60416 + e, t[60416 + e] = n[236][e]);
        for (n[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split(""), e = 0; e != n[237].length; ++e) 65533 !== n[237][e].charCodeAt(0) && (r[n[237][e]] = 60672 + e, t[60672 + e] = n[237][e]);
        for (n[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split(""), e = 0; e != n[238].length; ++e) 65533 !== n[238][e].charCodeAt(0) && (r[n[238][e]] = 60928 + e, t[60928 + e] = n[238][e]);
        for (n[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split(""), e = 0; e != n[239].length; ++e) 65533 !== n[239][e].charCodeAt(0) && (r[n[239][e]] = 61184 + e, t[61184 + e] = n[239][e]);
        for (n[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split(""), e = 0; e != n[240].length; ++e) 65533 !== n[240][e].charCodeAt(0) && (r[n[240][e]] = 61440 + e, t[61440 + e] = n[240][e]);
        for (n[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split(""), e = 0; e != n[241].length; ++e) 65533 !== n[241][e].charCodeAt(0) && (r[n[241][e]] = 61696 + e, t[61696 + e] = n[241][e]);
        for (n[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split(""), e = 0; e != n[242].length; ++e) 65533 !== n[242][e].charCodeAt(0) && (r[n[242][e]] = 61952 + e, t[61952 + e] = n[242][e]);
        for (n[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split(""), e = 0; e != n[243].length; ++e) 65533 !== n[243][e].charCodeAt(0) && (r[n[243][e]] = 62208 + e, t[62208 + e] = n[243][e]);
        for (n[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split(""), e = 0; e != n[244].length; ++e) 65533 !== n[244][e].charCodeAt(0) && (r[n[244][e]] = 62464 + e, t[62464 + e] = n[244][e]);
        for (n[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split(""), e = 0; e != n[245].length; ++e) 65533 !== n[245][e].charCodeAt(0) && (r[n[245][e]] = 62720 + e, t[62720 + e] = n[245][e]);
        for (n[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split(""), e = 0; e != n[246].length; ++e) 65533 !== n[246][e].charCodeAt(0) && (r[n[246][e]] = 62976 + e, t[62976 + e] = n[246][e]);
        for (n[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split(""), e = 0; e != n[247].length; ++e) 65533 !== n[247][e].charCodeAt(0) && (r[n[247][e]] = 63232 + e, t[63232 + e] = n[247][e]);
        for (n[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split(""), e = 0; e != n[248].length; ++e) 65533 !== n[248][e].charCodeAt(0) && (r[n[248][e]] = 63488 + e, t[63488 + e] = n[248][e]);
        for (n[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split(""), e = 0; e != n[249].length; ++e) 65533 !== n[249][e].charCodeAt(0) && (r[n[249][e]] = 63744 + e, t[63744 + e] = n[249][e]);
        return {
          enc: r,
          dec: t
        };
      }(), r[1250] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1251] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1252] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1253] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1254] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1255] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1256] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1257] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1258] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[1e4] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[10006] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[10007] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[10008] = function () {
        var e,
          t = [],
          r = {},
          n = [];
        for (n[0] = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split(""), e = 0; e != n[0].length; ++e) 65533 !== n[0][e].charCodeAt(0) && (r[n[0][e]] = 0 + e, t[0 + e] = n[0][e]);
        for (n[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split(""), e = 0; e != n[161].length; ++e) 65533 !== n[161][e].charCodeAt(0) && (r[n[161][e]] = 41216 + e, t[41216 + e] = n[161][e]);
        for (n[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split(""), e = 0; e != n[162].length; ++e) 65533 !== n[162][e].charCodeAt(0) && (r[n[162][e]] = 41472 + e, t[41472 + e] = n[162][e]);
        for (n[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split(""), e = 0; e != n[163].length; ++e) 65533 !== n[163][e].charCodeAt(0) && (r[n[163][e]] = 41728 + e, t[41728 + e] = n[163][e]);
        for (n[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split(""), e = 0; e != n[164].length; ++e) 65533 !== n[164][e].charCodeAt(0) && (r[n[164][e]] = 41984 + e, t[41984 + e] = n[164][e]);
        for (n[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split(""), e = 0; e != n[165].length; ++e) 65533 !== n[165][e].charCodeAt(0) && (r[n[165][e]] = 42240 + e, t[42240 + e] = n[165][e]);
        for (n[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split(""), e = 0; e != n[166].length; ++e) 65533 !== n[166][e].charCodeAt(0) && (r[n[166][e]] = 42496 + e, t[42496 + e] = n[166][e]);
        for (n[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split(""), e = 0; e != n[167].length; ++e) 65533 !== n[167][e].charCodeAt(0) && (r[n[167][e]] = 42752 + e, t[42752 + e] = n[167][e]);
        for (n[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split(""), e = 0; e != n[168].length; ++e) 65533 !== n[168][e].charCodeAt(0) && (r[n[168][e]] = 43008 + e, t[43008 + e] = n[168][e]);
        for (n[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split(""), e = 0; e != n[169].length; ++e) 65533 !== n[169][e].charCodeAt(0) && (r[n[169][e]] = 43264 + e, t[43264 + e] = n[169][e]);
        for (n[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split(""), e = 0; e != n[176].length; ++e) 65533 !== n[176][e].charCodeAt(0) && (r[n[176][e]] = 45056 + e, t[45056 + e] = n[176][e]);
        for (n[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split(""), e = 0; e != n[177].length; ++e) 65533 !== n[177][e].charCodeAt(0) && (r[n[177][e]] = 45312 + e, t[45312 + e] = n[177][e]);
        for (n[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split(""), e = 0; e != n[178].length; ++e) 65533 !== n[178][e].charCodeAt(0) && (r[n[178][e]] = 45568 + e, t[45568 + e] = n[178][e]);
        for (n[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split(""), e = 0; e != n[179].length; ++e) 65533 !== n[179][e].charCodeAt(0) && (r[n[179][e]] = 45824 + e, t[45824 + e] = n[179][e]);
        for (n[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split(""), e = 0; e != n[180].length; ++e) 65533 !== n[180][e].charCodeAt(0) && (r[n[180][e]] = 46080 + e, t[46080 + e] = n[180][e]);
        for (n[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split(""), e = 0; e != n[181].length; ++e) 65533 !== n[181][e].charCodeAt(0) && (r[n[181][e]] = 46336 + e, t[46336 + e] = n[181][e]);
        for (n[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split(""), e = 0; e != n[182].length; ++e) 65533 !== n[182][e].charCodeAt(0) && (r[n[182][e]] = 46592 + e, t[46592 + e] = n[182][e]);
        for (n[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split(""), e = 0; e != n[183].length; ++e) 65533 !== n[183][e].charCodeAt(0) && (r[n[183][e]] = 46848 + e, t[46848 + e] = n[183][e]);
        for (n[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split(""), e = 0; e != n[184].length; ++e) 65533 !== n[184][e].charCodeAt(0) && (r[n[184][e]] = 47104 + e, t[47104 + e] = n[184][e]);
        for (n[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split(""), e = 0; e != n[185].length; ++e) 65533 !== n[185][e].charCodeAt(0) && (r[n[185][e]] = 47360 + e, t[47360 + e] = n[185][e]);
        for (n[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split(""), e = 0; e != n[186].length; ++e) 65533 !== n[186][e].charCodeAt(0) && (r[n[186][e]] = 47616 + e, t[47616 + e] = n[186][e]);
        for (n[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split(""), e = 0; e != n[187].length; ++e) 65533 !== n[187][e].charCodeAt(0) && (r[n[187][e]] = 47872 + e, t[47872 + e] = n[187][e]);
        for (n[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split(""), e = 0; e != n[188].length; ++e) 65533 !== n[188][e].charCodeAt(0) && (r[n[188][e]] = 48128 + e, t[48128 + e] = n[188][e]);
        for (n[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split(""), e = 0; e != n[189].length; ++e) 65533 !== n[189][e].charCodeAt(0) && (r[n[189][e]] = 48384 + e, t[48384 + e] = n[189][e]);
        for (n[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split(""), e = 0; e != n[190].length; ++e) 65533 !== n[190][e].charCodeAt(0) && (r[n[190][e]] = 48640 + e, t[48640 + e] = n[190][e]);
        for (n[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split(""), e = 0; e != n[191].length; ++e) 65533 !== n[191][e].charCodeAt(0) && (r[n[191][e]] = 48896 + e, t[48896 + e] = n[191][e]);
        for (n[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split(""), e = 0; e != n[192].length; ++e) 65533 !== n[192][e].charCodeAt(0) && (r[n[192][e]] = 49152 + e, t[49152 + e] = n[192][e]);
        for (n[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split(""), e = 0; e != n[193].length; ++e) 65533 !== n[193][e].charCodeAt(0) && (r[n[193][e]] = 49408 + e, t[49408 + e] = n[193][e]);
        for (n[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split(""), e = 0; e != n[194].length; ++e) 65533 !== n[194][e].charCodeAt(0) && (r[n[194][e]] = 49664 + e, t[49664 + e] = n[194][e]);
        for (n[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split(""), e = 0; e != n[195].length; ++e) 65533 !== n[195][e].charCodeAt(0) && (r[n[195][e]] = 49920 + e, t[49920 + e] = n[195][e]);
        for (n[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split(""), e = 0; e != n[196].length; ++e) 65533 !== n[196][e].charCodeAt(0) && (r[n[196][e]] = 50176 + e, t[50176 + e] = n[196][e]);
        for (n[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split(""), e = 0; e != n[197].length; ++e) 65533 !== n[197][e].charCodeAt(0) && (r[n[197][e]] = 50432 + e, t[50432 + e] = n[197][e]);
        for (n[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split(""), e = 0; e != n[198].length; ++e) 65533 !== n[198][e].charCodeAt(0) && (r[n[198][e]] = 50688 + e, t[50688 + e] = n[198][e]);
        for (n[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split(""), e = 0; e != n[199].length; ++e) 65533 !== n[199][e].charCodeAt(0) && (r[n[199][e]] = 50944 + e, t[50944 + e] = n[199][e]);
        for (n[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split(""), e = 0; e != n[200].length; ++e) 65533 !== n[200][e].charCodeAt(0) && (r[n[200][e]] = 51200 + e, t[51200 + e] = n[200][e]);
        for (n[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split(""), e = 0; e != n[201].length; ++e) 65533 !== n[201][e].charCodeAt(0) && (r[n[201][e]] = 51456 + e, t[51456 + e] = n[201][e]);
        for (n[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split(""), e = 0; e != n[202].length; ++e) 65533 !== n[202][e].charCodeAt(0) && (r[n[202][e]] = 51712 + e, t[51712 + e] = n[202][e]);
        for (n[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split(""), e = 0; e != n[203].length; ++e) 65533 !== n[203][e].charCodeAt(0) && (r[n[203][e]] = 51968 + e, t[51968 + e] = n[203][e]);
        for (n[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split(""), e = 0; e != n[204].length; ++e) 65533 !== n[204][e].charCodeAt(0) && (r[n[204][e]] = 52224 + e, t[52224 + e] = n[204][e]);
        for (n[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split(""), e = 0; e != n[205].length; ++e) 65533 !== n[205][e].charCodeAt(0) && (r[n[205][e]] = 52480 + e, t[52480 + e] = n[205][e]);
        for (n[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split(""), e = 0; e != n[206].length; ++e) 65533 !== n[206][e].charCodeAt(0) && (r[n[206][e]] = 52736 + e, t[52736 + e] = n[206][e]);
        for (n[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split(""), e = 0; e != n[207].length; ++e) 65533 !== n[207][e].charCodeAt(0) && (r[n[207][e]] = 52992 + e, t[52992 + e] = n[207][e]);
        for (n[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split(""), e = 0; e != n[208].length; ++e) 65533 !== n[208][e].charCodeAt(0) && (r[n[208][e]] = 53248 + e, t[53248 + e] = n[208][e]);
        for (n[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split(""), e = 0; e != n[209].length; ++e) 65533 !== n[209][e].charCodeAt(0) && (r[n[209][e]] = 53504 + e, t[53504 + e] = n[209][e]);
        for (n[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split(""), e = 0; e != n[210].length; ++e) 65533 !== n[210][e].charCodeAt(0) && (r[n[210][e]] = 53760 + e, t[53760 + e] = n[210][e]);
        for (n[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split(""), e = 0; e != n[211].length; ++e) 65533 !== n[211][e].charCodeAt(0) && (r[n[211][e]] = 54016 + e, t[54016 + e] = n[211][e]);
        for (n[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split(""), e = 0; e != n[212].length; ++e) 65533 !== n[212][e].charCodeAt(0) && (r[n[212][e]] = 54272 + e, t[54272 + e] = n[212][e]);
        for (n[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split(""), e = 0; e != n[213].length; ++e) 65533 !== n[213][e].charCodeAt(0) && (r[n[213][e]] = 54528 + e, t[54528 + e] = n[213][e]);
        for (n[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split(""), e = 0; e != n[214].length; ++e) 65533 !== n[214][e].charCodeAt(0) && (r[n[214][e]] = 54784 + e, t[54784 + e] = n[214][e]);
        for (n[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split(""), e = 0; e != n[215].length; ++e) 65533 !== n[215][e].charCodeAt(0) && (r[n[215][e]] = 55040 + e, t[55040 + e] = n[215][e]);
        for (n[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split(""), e = 0; e != n[216].length; ++e) 65533 !== n[216][e].charCodeAt(0) && (r[n[216][e]] = 55296 + e, t[55296 + e] = n[216][e]);
        for (n[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split(""), e = 0; e != n[217].length; ++e) 65533 !== n[217][e].charCodeAt(0) && (r[n[217][e]] = 55552 + e, t[55552 + e] = n[217][e]);
        for (n[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split(""), e = 0; e != n[218].length; ++e) 65533 !== n[218][e].charCodeAt(0) && (r[n[218][e]] = 55808 + e, t[55808 + e] = n[218][e]);
        for (n[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split(""), e = 0; e != n[219].length; ++e) 65533 !== n[219][e].charCodeAt(0) && (r[n[219][e]] = 56064 + e, t[56064 + e] = n[219][e]);
        for (n[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split(""), e = 0; e != n[220].length; ++e) 65533 !== n[220][e].charCodeAt(0) && (r[n[220][e]] = 56320 + e, t[56320 + e] = n[220][e]);
        for (n[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split(""), e = 0; e != n[221].length; ++e) 65533 !== n[221][e].charCodeAt(0) && (r[n[221][e]] = 56576 + e, t[56576 + e] = n[221][e]);
        for (n[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split(""), e = 0; e != n[222].length; ++e) 65533 !== n[222][e].charCodeAt(0) && (r[n[222][e]] = 56832 + e, t[56832 + e] = n[222][e]);
        for (n[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split(""), e = 0; e != n[223].length; ++e) 65533 !== n[223][e].charCodeAt(0) && (r[n[223][e]] = 57088 + e, t[57088 + e] = n[223][e]);
        for (n[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split(""), e = 0; e != n[224].length; ++e) 65533 !== n[224][e].charCodeAt(0) && (r[n[224][e]] = 57344 + e, t[57344 + e] = n[224][e]);
        for (n[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split(""), e = 0; e != n[225].length; ++e) 65533 !== n[225][e].charCodeAt(0) && (r[n[225][e]] = 57600 + e, t[57600 + e] = n[225][e]);
        for (n[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split(""), e = 0; e != n[226].length; ++e) 65533 !== n[226][e].charCodeAt(0) && (r[n[226][e]] = 57856 + e, t[57856 + e] = n[226][e]);
        for (n[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split(""), e = 0; e != n[227].length; ++e) 65533 !== n[227][e].charCodeAt(0) && (r[n[227][e]] = 58112 + e, t[58112 + e] = n[227][e]);
        for (n[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split(""), e = 0; e != n[228].length; ++e) 65533 !== n[228][e].charCodeAt(0) && (r[n[228][e]] = 58368 + e, t[58368 + e] = n[228][e]);
        for (n[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split(""), e = 0; e != n[229].length; ++e) 65533 !== n[229][e].charCodeAt(0) && (r[n[229][e]] = 58624 + e, t[58624 + e] = n[229][e]);
        for (n[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split(""), e = 0; e != n[230].length; ++e) 65533 !== n[230][e].charCodeAt(0) && (r[n[230][e]] = 58880 + e, t[58880 + e] = n[230][e]);
        for (n[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split(""), e = 0; e != n[231].length; ++e) 65533 !== n[231][e].charCodeAt(0) && (r[n[231][e]] = 59136 + e, t[59136 + e] = n[231][e]);
        for (n[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split(""), e = 0; e != n[232].length; ++e) 65533 !== n[232][e].charCodeAt(0) && (r[n[232][e]] = 59392 + e, t[59392 + e] = n[232][e]);
        for (n[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split(""), e = 0; e != n[233].length; ++e) 65533 !== n[233][e].charCodeAt(0) && (r[n[233][e]] = 59648 + e, t[59648 + e] = n[233][e]);
        for (n[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split(""), e = 0; e != n[234].length; ++e) 65533 !== n[234][e].charCodeAt(0) && (r[n[234][e]] = 59904 + e, t[59904 + e] = n[234][e]);
        for (n[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split(""), e = 0; e != n[235].length; ++e) 65533 !== n[235][e].charCodeAt(0) && (r[n[235][e]] = 60160 + e, t[60160 + e] = n[235][e]);
        for (n[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split(""), e = 0; e != n[236].length; ++e) 65533 !== n[236][e].charCodeAt(0) && (r[n[236][e]] = 60416 + e, t[60416 + e] = n[236][e]);
        for (n[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split(""), e = 0; e != n[237].length; ++e) 65533 !== n[237][e].charCodeAt(0) && (r[n[237][e]] = 60672 + e, t[60672 + e] = n[237][e]);
        for (n[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split(""), e = 0; e != n[238].length; ++e) 65533 !== n[238][e].charCodeAt(0) && (r[n[238][e]] = 60928 + e, t[60928 + e] = n[238][e]);
        for (n[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split(""), e = 0; e != n[239].length; ++e) 65533 !== n[239][e].charCodeAt(0) && (r[n[239][e]] = 61184 + e, t[61184 + e] = n[239][e]);
        for (n[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split(""), e = 0; e != n[240].length; ++e) 65533 !== n[240][e].charCodeAt(0) && (r[n[240][e]] = 61440 + e, t[61440 + e] = n[240][e]);
        for (n[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split(""), e = 0; e != n[241].length; ++e) 65533 !== n[241][e].charCodeAt(0) && (r[n[241][e]] = 61696 + e, t[61696 + e] = n[241][e]);
        for (n[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split(""), e = 0; e != n[242].length; ++e) 65533 !== n[242][e].charCodeAt(0) && (r[n[242][e]] = 61952 + e, t[61952 + e] = n[242][e]);
        for (n[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split(""), e = 0; e != n[243].length; ++e) 65533 !== n[243][e].charCodeAt(0) && (r[n[243][e]] = 62208 + e, t[62208 + e] = n[243][e]);
        for (n[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split(""), e = 0; e != n[244].length; ++e) 65533 !== n[244][e].charCodeAt(0) && (r[n[244][e]] = 62464 + e, t[62464 + e] = n[244][e]);
        for (n[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split(""), e = 0; e != n[245].length; ++e) 65533 !== n[245][e].charCodeAt(0) && (r[n[245][e]] = 62720 + e, t[62720 + e] = n[245][e]);
        for (n[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split(""), e = 0; e != n[246].length; ++e) 65533 !== n[246][e].charCodeAt(0) && (r[n[246][e]] = 62976 + e, t[62976 + e] = n[246][e]);
        for (n[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split(""), e = 0; e != n[247].length; ++e) 65533 !== n[247][e].charCodeAt(0) && (r[n[247][e]] = 63232 + e, t[63232 + e] = n[247][e]);
        return {
          enc: r,
          dec: t
        };
      }(), r[10029] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[10079] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), r[10081] = function () {
        for (var e = "\0\b\t\n\v\f\r !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", t = [], r = {}, n = 0; n != e.length; ++n) 65533 !== e.charCodeAt(n) && (r[e.charAt(n)] = n), t[n] = e.charAt(n);
        return {
          enc: r,
          dec: t
        };
      }(), void 0 !== e && e.exports && (e.exports = r), function (t, n) {
        "use strict";

        if (void 0 === r) {
          var i = r;
          void 0 !== e && e.exports ? e.exports = n(i) : t.cptable = n(i);
        } else r = n(r);
      }(this, function (e) {
        "use strict";

        var r = {
            1200: "utf16le",
            1201: "utf16be",
            12000: "utf32le",
            12001: "utf32be",
            16969: "utf64le",
            20127: "ascii",
            65000: "utf7",
            65001: "utf8"
          },
          n = [874, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1e4],
          i = [932, 936, 949, 950],
          a = [65001],
          o = {},
          s = {},
          l = {},
          c = {},
          u = function u(e) {
            return String.fromCharCode(e);
          },
          h = function h(e) {
            return e.charCodeAt(0);
          },
          f = void 0 !== t;
        if (f) {
          var d = 1024,
            p = new t(d),
            m = function m(e) {
              for (var r = new t(65536), n = 0; n < 65536; ++n) r[n] = 0;
              for (var i = Object.keys(e), a = i.length, o = 0, s = i[o]; o < a; ++o) (s = i[o]) && (r[s.charCodeAt(0)] = e[s]);
              return r;
            },
            g = function g(r) {
              var n = m(e[r].enc);
              return function (e, r) {
                var i,
                  a = e.length,
                  o = 0,
                  s = 0,
                  l = 0,
                  c = 0;
                if ("string" == typeof e) for (i = new t(a), o = 0; o < a; ++o) i[o] = n[e.charCodeAt(o)];else if (t.isBuffer(e)) {
                  for (i = new t(2 * a), s = 0, o = 0; o < a; ++o) l = e[o], l < 128 ? i[s++] = n[l] : l < 224 ? (i[s++] = n[((31 & l) << 6) + (63 & e[o + 1])], ++o) : l < 240 ? (i[s++] = n[((15 & l) << 12) + ((63 & e[o + 1]) << 6) + (63 & e[o + 2])], o += 2) : (c = ((7 & l) << 18) + ((63 & e[o + 1]) << 12) + ((63 & e[o + 2]) << 6) + (63 & e[o + 3]), o += 3, c < 65536 ? i[s++] = n[c] : (c -= 65536, i[s++] = n[55296 + (c >> 10 & 1023)], i[s++] = n[56320 + (1023 & c)]));
                  i = i.slice(0, s);
                } else for (i = new t(a), o = 0; o < a; ++o) i[o] = n[e[o].charCodeAt(0)];
                return r && "buf" !== r ? "arr" !== r ? i.toString("binary") : [].slice.call(i) : i;
              };
            },
            v = function v(r) {
              var n = e[r].dec,
                i = new t(131072),
                a = 0,
                o = "";
              for (a = 0; a < n.length; ++a) if (o = n[a]) {
                var s = o.charCodeAt(0);
                i[2 * a] = 255 & s, i[2 * a + 1] = s >> 8;
              }
              return function (e) {
                var r = e.length,
                  n = 0,
                  a = 0;
                if (2 * r > d && (d = 2 * r, p = new t(d)), t.isBuffer(e)) for (n = 0; n < r; n++) a = 2 * e[n], p[2 * n] = i[a], p[2 * n + 1] = i[a + 1];else if ("string" == typeof e) for (n = 0; n < r; n++) a = 2 * e.charCodeAt(n), p[2 * n] = i[a], p[2 * n + 1] = i[a + 1];else for (n = 0; n < r; n++) a = 2 * e[n], p[2 * n] = i[a], p[2 * n + 1] = i[a + 1];
                return p.slice(0, 2 * r).toString("ucs2");
              };
            },
            b = function b(r) {
              for (var n = e[r].enc, i = new t(131072), a = 0; a < 131072; ++a) i[a] = 0;
              for (var o = Object.keys(n), s = 0, l = o[s]; s < o.length; ++s) if (l = o[s]) {
                var c = l.charCodeAt(0);
                i[2 * c] = 255 & n[l], i[2 * c + 1] = n[l] >> 8;
              }
              return function (e, r) {
                var n = e.length,
                  a = new t(2 * n),
                  o = 0,
                  s = 0,
                  l = 0,
                  c = 0,
                  u = 0;
                if ("string" == typeof e) {
                  for (o = c = 0; o < n; ++o) s = 2 * e.charCodeAt(o), a[c++] = i[s + 1] || i[s], i[s + 1] > 0 && (a[c++] = i[s]);
                  a = a.slice(0, c);
                } else if (t.isBuffer(e)) {
                  for (o = c = 0; o < n; ++o) u = e[o], u < 128 ? s = u : u < 224 ? (s = ((31 & u) << 6) + (63 & e[o + 1]), ++o) : u < 240 ? (s = ((15 & u) << 12) + ((63 & e[o + 1]) << 6) + (63 & e[o + 2]), o += 2) : (s = ((7 & u) << 18) + ((63 & e[o + 1]) << 12) + ((63 & e[o + 2]) << 6) + (63 & e[o + 3]), o += 3), s < 65536 ? (s *= 2, a[c++] = i[s + 1] || i[s], i[s + 1] > 0 && (a[c++] = i[s])) : (l = s - 65536, s = 2 * (55296 + (l >> 10 & 1023)), a[c++] = i[s + 1] || i[s], i[s + 1] > 0 && (a[c++] = i[s]), s = 2 * (56320 + (1023 & l)), a[c++] = i[s + 1] || i[s], i[s + 1] > 0 && (a[c++] = i[s]));
                  a = a.slice(0, c);
                } else for (o = c = 0; o < n; o++) s = 2 * e[o].charCodeAt(0), a[c++] = i[s + 1] || i[s], i[s + 1] > 0 && (a[c++] = i[s]);
                return r && "buf" !== r ? "arr" !== r ? a.toString("binary") : [].slice.call(a) : a;
              };
            },
            y = function y(r) {
              var n,
                i = e[r].dec,
                a = new t(131072),
                o = 0,
                s = 0,
                l = 0,
                c = 0;
              for (c = 0; c < 65536; ++c) a[2 * c] = 255, a[2 * c + 1] = 253;
              for (o = 0; o < i.length; ++o) (n = i[o]) && (s = n.charCodeAt(0), l = 2 * o, a[l] = 255 & s, a[l + 1] = s >> 8);
              return function (e) {
                var r = e.length,
                  n = new t(2 * r),
                  i = 0,
                  o = 0,
                  s = 0;
                if (t.isBuffer(e)) for (i = 0; i < r; i++) o = 2 * e[i], 255 === a[o] && 253 === a[o + 1] && (o = 2 * ((e[i] << 8) + e[i + 1]), ++i), n[s++] = a[o], n[s++] = a[o + 1];else if ("string" == typeof e) for (i = 0; i < r; i++) o = 2 * e.charCodeAt(i), 255 === a[o] && 253 === a[o + 1] && (o = 2 * ((e.charCodeAt(i) << 8) + e.charCodeAt(i + 1)), ++i), n[s++] = a[o], n[s++] = a[o + 1];else for (i = 0; i < r; i++) o = 2 * e[i], 255 === a[o] && 253 === a[o + 1] && (o = 2 * ((e[i] << 8) + e[i + 1]), ++i), n[s++] = a[o], n[s++] = a[o + 1];
                return n.slice(0, s).toString("ucs2");
              };
            };
          o[65001] = function e(r) {
            if ("string" == typeof r) return e(r.split("").map(h));
            var n = r.length,
              i = 0,
              a = 0;
            4 * n > d && (d = 4 * n, p = new t(d));
            var o = 0;
            n >= 3 && 239 == r[0] && 187 == r[1] && 191 == r[2] && (o = 3);
            for (var s = 1, l = 0, c = 0; o < n; o += s) s = 1, c = r[o], c < 128 ? i = c : c < 224 ? (i = 64 * (31 & c) + (63 & r[o + 1]), s = 2) : c < 240 ? (i = ((15 & c) << 12) + 64 * (63 & r[o + 1]) + (63 & r[o + 2]), s = 3) : (i = 262144 * (7 & c) + ((63 & r[o + 1]) << 12) + 64 * (63 & r[o + 2]) + (63 & r[o + 3]), s = 4), i < 65536 ? (p[l++] = 255 & i, p[l++] = i >> 8) : (i -= 65536, a = 55296 + (i >> 10 & 1023), i = 56320 + (1023 & i), p[l++] = 255 & a, p[l++] = a >>> 8, p[l++] = 255 & i, p[l++] = i >>> 8 & 255);
            return p.slice(0, l).toString("ucs2");
          }, s[65001] = function (e, r) {
            if (f && t.isBuffer(e)) return r && "buf" !== r ? "arr" !== r ? e.toString("binary") : [].slice.call(e) : e;
            var n = e.length,
              i = 0,
              a = 0,
              o = 0,
              s = "string" == typeof e;
            4 * n > d && (d = 4 * n, p = new t(d));
            for (var l = 0; l < n; ++l) i = s ? e.charCodeAt(l) : e[l].charCodeAt(0), i <= 127 ? p[o++] = i : i <= 2047 ? (p[o++] = 192 + (i >> 6), p[o++] = 128 + (63 & i)) : i >= 55296 && i <= 57343 ? (i -= 55296, ++l, a = (s ? e.charCodeAt(l) : e[l].charCodeAt(0)) - 56320 + (i << 10), p[o++] = 240 + (a >>> 18 & 7), p[o++] = 144 + (a >>> 12 & 63), p[o++] = 128 + (a >>> 6 & 63), p[o++] = 128 + (63 & a)) : (p[o++] = 224 + (i >> 12), p[o++] = 128 + (i >> 6 & 63), p[o++] = 128 + (63 & i));
            return r && "buf" !== r ? "arr" !== r ? p.slice(0, o).toString("binary") : [].slice.call(p, 0, o) : p.slice(0, o);
          };
        }
        var w = function w() {
            if (f) {
              if (l[n[0]]) return;
              var t = 0,
                r = 0;
              for (t = 0; t < n.length; ++t) r = n[t], e[r] && (l[r] = v(r), c[r] = g(r));
              for (t = 0; t < i.length; ++t) r = i[t], e[r] && (l[r] = y(r), c[r] = b(r));
              for (t = 0; t < a.length; ++t) r = a[t], o[r] && (l[r] = o[r]), s[r] && (c[r] = s[r]);
            }
          },
          x = function x(e, t) {
            return "";
          },
          _ = function _(e) {
            delete l[e], delete c[e];
          },
          S = function S() {
            if (f) {
              if (!l[n[0]]) return;
              n.forEach(_), i.forEach(_), a.forEach(_);
            }
            T = x, k = 0;
          },
          C = {
            encache: w,
            decache: S,
            sbcs: n,
            dbcs: i
          };
        w();
        var E = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
          A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?",
          T = x,
          k = 0,
          R = function n(i, a, o) {
            if (i === k && T) return T(a, o);
            if (c[i]) return (T = c[k = i])(a, o);
            f && t.isBuffer(a) && (a = a.toString("utf8"));
            var s,
              l = a.length,
              h = f ? new t(4 * l) : [],
              d = 0,
              p = 0,
              m = 0,
              g = 0,
              v = e[i],
              b = "",
              y = "string" == typeof a;
            if (v && (s = v.enc)) for (p = 0; p < l; ++p, ++m) d = s[y ? a.charAt(p) : a[p]], d > 255 ? (h[m] = d >> 8, h[++m] = 255 & d) : h[m] = 255 & d;else {
              if (!(b = r[i])) throw new Error("Unrecognized CP: " + i);
              switch (b) {
                case "utf8":
                  if (f && y) {
                    h = new t(a, b), m = h.length;
                    break;
                  }
                  for (p = 0; p < l; ++p, ++m) d = y ? a.charCodeAt(p) : a[p].charCodeAt(0), d <= 127 ? h[m] = d : d <= 2047 ? (h[m] = 192 + (d >> 6), h[++m] = 128 + (63 & d)) : d >= 55296 && d <= 57343 ? (d -= 55296, g = (y ? a.charCodeAt(++p) : a[++p].charCodeAt(0)) - 56320 + (d << 10), h[m] = 240 + (g >>> 18 & 7), h[++m] = 144 + (g >>> 12 & 63), h[++m] = 128 + (g >>> 6 & 63), h[++m] = 128 + (63 & g)) : (h[m] = 224 + (d >> 12), h[++m] = 128 + (d >> 6 & 63), h[++m] = 128 + (63 & d));
                  break;
                case "ascii":
                  if (f && "string" == typeof a) {
                    h = new t(a, b), m = h.length;
                    break;
                  }
                  for (p = 0; p < l; ++p, ++m) {
                    if (!((d = y ? a.charCodeAt(p) : a[p].charCodeAt(0)) <= 127)) throw new Error("bad ascii " + d);
                    h[m] = d;
                  }
                  break;
                case "utf16le":
                  if (f && "string" == typeof a) {
                    h = new t(a, b), m = h.length;
                    break;
                  }
                  for (p = 0; p < l; ++p) d = y ? a.charCodeAt(p) : a[p].charCodeAt(0), h[m++] = 255 & d, h[m++] = d >> 8;
                  break;
                case "utf16be":
                  for (p = 0; p < l; ++p) d = y ? a.charCodeAt(p) : a[p].charCodeAt(0), h[m++] = d >> 8, h[m++] = 255 & d;
                  break;
                case "utf32le":
                  for (p = 0; p < l; ++p) d = y ? a.charCodeAt(p) : a[p].charCodeAt(0), d >= 55296 && d <= 57343 && (d = 65536 + (d - 55296 << 10) + (a[++p].charCodeAt(0) - 56320)), h[m++] = 255 & d, d >>= 8, h[m++] = 255 & d, d >>= 8, h[m++] = 255 & d, d >>= 8, h[m++] = 255 & d;
                  break;
                case "utf32be":
                  for (p = 0; p < l; ++p) d = y ? a.charCodeAt(p) : a[p].charCodeAt(0), d >= 55296 && d <= 57343 && (d = 65536 + (d - 55296 << 10) + (a[++p].charCodeAt(0) - 56320)), h[m + 3] = 255 & d, d >>= 8, h[m + 2] = 255 & d, d >>= 8, h[m + 1] = 255 & d, d >>= 8, h[m] = 255 & d, m += 4;
                  break;
                case "utf7":
                  for (p = 0; p < l; p++) {
                    var w = y ? a.charAt(p) : a[p].charAt(0);
                    if ("+" !== w) {
                      if (A.indexOf(w) > -1) h[m++] = w.charCodeAt(0);else {
                        var x = n(1201, w);
                        h[m++] = 43, h[m++] = E.charCodeAt(x[0] >> 2), h[m++] = E.charCodeAt(((3 & x[0]) << 4) + ((x[1] || 0) >> 4)), h[m++] = E.charCodeAt(((15 & x[1]) << 2) + ((x[2] || 0) >> 6)), h[m++] = 45;
                      }
                    } else h[m++] = 43, h[m++] = 45;
                  }
                  break;
                default:
                  throw new Error("Unsupported magic: " + i + " " + r[i]);
              }
            }
            return h = h.slice(0, m), f ? o && "buf" !== o ? "arr" !== o ? h.toString("binary") : [].slice.call(h) : h : "str" == o ? h.map(u).join("") : h;
          },
          I = function n(i, a) {
            var o;
            if (o = l[i]) return o(a);
            if ("string" == typeof a) return n(i, a.split("").map(h));
            var s,
              c = a.length,
              u = new Array(c),
              d = "",
              p = 0,
              m = 0,
              g = 1,
              v = 0,
              b = 0,
              y = e[i],
              w = "";
            if (y && (s = y.dec)) for (m = 0; m < c; m += g) {
              if (g = 2, d = s[(a[m] << 8) + a[m + 1]], d || (g = 1, d = s[a[m]]), !d) throw new Error("Unrecognized code: " + a[m] + " " + a[m + g - 1] + " " + m + " " + g + " " + s[a[m]]);
              u[v++] = d;
            } else {
              if (!(w = r[i])) throw new Error("Unrecognized CP: " + i);
              switch (w) {
                case "utf8":
                  for (c >= 3 && 239 == a[0] && 187 == a[1] && 191 == a[2] && (m = 3); m < c; m += g) g = 1, a[m] < 128 ? p = a[m] : a[m] < 224 ? (p = 64 * (31 & a[m]) + (63 & a[m + 1]), g = 2) : a[m] < 240 ? (p = ((15 & a[m]) << 12) + 64 * (63 & a[m + 1]) + (63 & a[m + 2]), g = 3) : (p = 262144 * (7 & a[m]) + ((63 & a[m + 1]) << 12) + 64 * (63 & a[m + 2]) + (63 & a[m + 3]), g = 4), p < 65536 ? u[v++] = String.fromCharCode(p) : (p -= 65536, b = 55296 + (p >> 10 & 1023), p = 56320 + (1023 & p), u[v++] = String.fromCharCode(b), u[v++] = String.fromCharCode(p));
                  break;
                case "ascii":
                  if (f && t.isBuffer(a)) return a.toString(w);
                  for (m = 0; m < c; m++) u[m] = String.fromCharCode(a[m]);
                  v = c;
                  break;
                case "utf16le":
                  if (c >= 2 && 255 == a[0] && 254 == a[1] && (m = 2), f && t.isBuffer(a)) return a.toString(w);
                  for (g = 2; m + 1 < c; m += g) u[v++] = String.fromCharCode((a[m + 1] << 8) + a[m]);
                  break;
                case "utf16be":
                  for (c >= 2 && 254 == a[0] && 255 == a[1] && (m = 2), g = 2; m + 1 < c; m += g) u[v++] = String.fromCharCode((a[m] << 8) + a[m + 1]);
                  break;
                case "utf32le":
                  for (c >= 4 && 255 == a[0] && 254 == a[1] && 0 === a[2] && 0 === a[3] && (m = 4), g = 4; m < c; m += g) p = (a[m + 3] << 24) + (a[m + 2] << 16) + (a[m + 1] << 8) + a[m], p > 65535 ? (p -= 65536, u[v++] = String.fromCharCode(55296 + (p >> 10 & 1023)), u[v++] = String.fromCharCode(56320 + (1023 & p))) : u[v++] = String.fromCharCode(p);
                  break;
                case "utf32be":
                  for (c >= 4 && 255 == a[3] && 254 == a[2] && 0 === a[1] && 0 === a[0] && (m = 4), g = 4; m < c; m += g) p = (a[m] << 24) + (a[m + 1] << 16) + (a[m + 2] << 8) + a[m + 3], p > 65535 ? (p -= 65536, u[v++] = String.fromCharCode(55296 + (p >> 10 & 1023)), u[v++] = String.fromCharCode(56320 + (1023 & p))) : u[v++] = String.fromCharCode(p);
                  break;
                case "utf7":
                  for (c >= 4 && 43 == a[0] && 47 == a[1] && 118 == a[2] && (c >= 5 && 56 == a[3] && 45 == a[4] ? m = 5 : 56 != a[3] && 57 != a[3] && 43 != a[3] && 47 != a[3] || (m = 4)); m < c; m += g) if (43 === a[m]) {
                    if (g = 1, 45 !== a[m + 1]) {
                      for (; String.fromCharCode(a[m + g]).match(/[A-Za-z0-9+\/]/);) g++;
                      var x = 0;
                      45 === a[m + g] && (++g, x = 1);
                      for (var _ = [], S = "", C = 0, A = 0, T = 0, k = 0, R = 0, I = 0, M = 0, O = 1; O < g - x && (k = E.indexOf(String.fromCharCode(a[m + O++])), R = E.indexOf(String.fromCharCode(a[m + O++])), C = k << 2 | R >> 4, _.push(C), -1 !== (I = E.indexOf(String.fromCharCode(a[m + O++])))) && (A = (15 & R) << 4 | I >> 2, _.push(A), -1 !== (M = E.indexOf(String.fromCharCode(a[m + O++]))));) T = (3 & I) << 6 | M, M < 64 && _.push(T);
                      for (S = n(1201, _), O = 0; O < S.length; ++O) u[v++] = S.charAt(O);
                    } else g = 2, u[v++] = "+";
                  } else g = 1, u[v++] = String.fromCharCode(a[m]);
                  break;
                default:
                  throw new Error("Unsupported magic: " + i + " " + r[i]);
              }
            }
            return u.slice(0, v).join("");
          },
          M = function M(t) {
            return !(!e[t] && !r[t]);
          };
        return e.utils = {
          decode: I,
          encode: R,
          hascp: M,
          magic: r,
          cache: C
        }, e;
      });
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    (function (t) {
      var r, r; /*!
                JSZip - A Javascript class for generating and reading zip files
                <http://stuartk.com/jszip>
                (c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
                Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.
                JSZip uses the library pako released under the MIT license :
                https://github.com/nodeca/pako/blob/master/LICENSE
                */
      !function (t) {
        e.exports = t();
      }(function () {
        return function e(t, n, i) {
          function a(s, l) {
            if (!n[s]) {
              if (!t[s]) {
                var c = "function" == typeof r && r;
                if (!l && c) return r(s, !0);
                if (o) return o(s, !0);
                throw new Error("Cannot find module '" + s + "'");
              }
              var u = n[s] = {
                exports: {}
              };
              t[s][0].call(u.exports, function (e) {
                var r = t[s][1][e];
                return a(r || e);
              }, u, u.exports, e, t, n, i);
            }
            return n[s].exports;
          }
          for (var o = "function" == typeof r && r, s = 0; s < i.length; s++) a(i[s]);
          return a;
        }({
          1: [function (e, t, r) {
            "use strict";

            var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            r.encode = function (e, t) {
              for (var r, i, a, o, s, l, c, u = "", h = 0; h < e.length;) r = e.charCodeAt(h++), i = e.charCodeAt(h++), a = e.charCodeAt(h++), o = r >> 2, s = (3 & r) << 4 | i >> 4, l = (15 & i) << 2 | a >> 6, c = 63 & a, isNaN(i) ? l = c = 64 : isNaN(a) && (c = 64), u = u + n.charAt(o) + n.charAt(s) + n.charAt(l) + n.charAt(c);
              return u;
            }, r.decode = function (e, t) {
              var r,
                i,
                a,
                o,
                s,
                l,
                c,
                u = "",
                h = 0;
              for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); h < e.length;) o = n.indexOf(e.charAt(h++)), s = n.indexOf(e.charAt(h++)), l = n.indexOf(e.charAt(h++)), c = n.indexOf(e.charAt(h++)), r = o << 2 | s >> 4, i = (15 & s) << 4 | l >> 2, a = (3 & l) << 6 | c, u += String.fromCharCode(r), 64 != l && (u += String.fromCharCode(i)), 64 != c && (u += String.fromCharCode(a));
              return u;
            };
          }, {}],
          2: [function (e, t, r) {
            "use strict";

            function n() {
              this.compressedSize = 0, this.uncompressedSize = 0, this.crc32 = 0, this.compressionMethod = null, this.compressedContent = null;
            }
            n.prototype = {
              getContent: function getContent() {
                return null;
              },
              getCompressedContent: function getCompressedContent() {
                return null;
              }
            }, t.exports = n;
          }, {}],
          3: [function (e, t, r) {
            "use strict";

            r.STORE = {
              magic: "\0\0",
              compress: function compress(e) {
                return e;
              },
              uncompress: function uncompress(e) {
                return e;
              },
              compressInputType: null,
              uncompressInputType: null
            }, r.DEFLATE = e("./flate");
          }, {
            "./flate": 8
          }],
          4: [function (e, t, r) {
            "use strict";

            var n = e("./utils"),
              i = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117];
            t.exports = function (e, t) {
              if (void 0 === e || !e.length) return 0;
              var r = "string" !== n.getTypeOf(e);
              void 0 === t && (t = 0);
              var a = 0,
                o = 0,
                s = 0;
              t ^= -1;
              for (var l = 0, c = e.length; l < c; l++) s = r ? e[l] : e.charCodeAt(l), o = 255 & (t ^ s), a = i[o], t = t >>> 8 ^ a;
              return -1 ^ t;
            };
          }, {
            "./utils": 21
          }],
          5: [function (e, t, r) {
            "use strict";

            function n(e) {
              this.data = null, this.length = 0, this.index = 0;
            }
            var i = e("./utils");
            n.prototype = {
              checkOffset: function checkOffset(e) {
                this.checkIndex(this.index + e);
              },
              checkIndex: function checkIndex(e) {
                if (this.length < e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
              },
              setIndex: function setIndex(e) {
                this.checkIndex(e), this.index = e;
              },
              skip: function skip(e) {
                this.setIndex(this.index + e);
              },
              byteAt: function byteAt(e) {},
              readInt: function readInt(e) {
                var t,
                  r = 0;
                for (this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--) r = (r << 8) + this.byteAt(t);
                return this.index += e, r;
              },
              readString: function readString(e) {
                return i.transformTo("string", this.readData(e));
              },
              readData: function readData(e) {},
              lastIndexOfSignature: function lastIndexOfSignature(e) {},
              readDate: function readDate() {
                var e = this.readInt(4);
                return new Date(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1);
              }
            }, t.exports = n;
          }, {
            "./utils": 21
          }],
          6: [function (e, t, r) {
            "use strict";

            r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !1, r.date = null, r.compression = null, r.comment = null;
          }, {}],
          7: [function (e, t, r) {
            "use strict";

            var n = e("./utils");
            r.string2binary = function (e) {
              return n.string2binary(e);
            }, r.string2Uint8Array = function (e) {
              return n.transformTo("uint8array", e);
            }, r.uint8Array2String = function (e) {
              return n.transformTo("string", e);
            }, r.string2Blob = function (e) {
              var t = n.transformTo("arraybuffer", e);
              return n.arrayBuffer2Blob(t);
            }, r.arrayBuffer2Blob = function (e) {
              return n.arrayBuffer2Blob(e);
            }, r.transformTo = function (e, t) {
              return n.transformTo(e, t);
            }, r.getTypeOf = function (e) {
              return n.getTypeOf(e);
            }, r.checkSupport = function (e) {
              return n.checkSupport(e);
            }, r.MAX_VALUE_16BITS = n.MAX_VALUE_16BITS, r.MAX_VALUE_32BITS = n.MAX_VALUE_32BITS, r.pretty = function (e) {
              return n.pretty(e);
            }, r.findCompression = function (e) {
              return n.findCompression(e);
            }, r.isRegExp = function (e) {
              return n.isRegExp(e);
            };
          }, {
            "./utils": 21
          }],
          8: [function (e, t, r) {
            "use strict";

            var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
              i = e("pako");
            r.uncompressInputType = n ? "uint8array" : "array", r.compressInputType = n ? "uint8array" : "array", r.magic = "\b\0", r.compress = function (e) {
              return i.deflateRaw(e);
            }, r.uncompress = function (e) {
              return i.inflateRaw(e);
            };
          }, {
            pako: 24
          }],
          9: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              if (!(this instanceof n)) return new n(e, t);
              this.files = {}, this.comment = null, this.root = "", e && this.load(e, t), this.clone = function () {
                var e = new n();
                for (var t in this) "function" != typeof this[t] && (e[t] = this[t]);
                return e;
              };
            }
            var i = e("./base64");
            n.prototype = e("./object"), n.prototype.load = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.utils = e("./deprecatedPublicUtils"), n.base64 = {
              encode: function encode(e) {
                return i.encode(e);
              },
              decode: function decode(e) {
                return i.decode(e);
              }
            }, n.compressions = e("./compressions"), t.exports = n;
          }, {
            "./base64": 1,
            "./compressions": 3,
            "./defaults": 6,
            "./deprecatedPublicUtils": 7,
            "./load": 10,
            "./object": 13,
            "./support": 17
          }],
          10: [function (e, t, r) {
            "use strict";

            var n = e("./base64"),
              i = e("./zipEntries");
            t.exports = function (e, t) {
              var r, a, o, s;
              for (t = t || {}, t.base64 && (e = n.decode(e)), a = new i(e, t), r = a.files, o = 0; o < r.length; o++) s = r[o], this.file(s.fileName, s.decompressed, {
                binary: !0,
                optimizedBinaryString: !0,
                date: s.date,
                dir: s.dir,
                comment: s.fileComment.length ? s.fileComment : null,
                createFolders: t.createFolders
              });
              return a.zipComment.length && (this.comment = a.zipComment), this;
            };
          }, {
            "./base64": 1,
            "./zipEntries": 22
          }],
          11: [function (e, r, n) {
            (function (e) {
              "use strict";

              r.exports = function (t, r) {
                return new e(t, r);
              }, r.exports.test = function (t) {
                return e.isBuffer(t);
              };
            }).call(this, void 0 !== t ? t : void 0);
          }, {}],
          12: [function (e, t, r) {
            "use strict";

            function n(e) {
              this.data = e, this.length = this.data.length, this.index = 0;
            }
            var i = e("./uint8ArrayReader");
            n.prototype = new i(), n.prototype.readData = function (e) {
              this.checkOffset(e);
              var t = this.data.slice(this.index, this.index + e);
              return this.index += e, t;
            }, t.exports = n;
          }, {
            "./uint8ArrayReader": 18
          }],
          13: [function (e, t, r) {
            "use strict";

            var n = e("./support"),
              i = e("./utils"),
              a = e("./crc32"),
              o = e("./signature"),
              s = e("./defaults"),
              l = e("./base64"),
              c = e("./compressions"),
              u = e("./compressedObject"),
              h = e("./nodeBuffer"),
              f = e("./utf8"),
              d = e("./stringWriter"),
              p = e("./uint8ArrayWriter"),
              m = function m(e) {
                if (e._data instanceof u && (e._data = e._data.getContent(), e.options.binary = !0, e.options.base64 = !1, "uint8array" === i.getTypeOf(e._data))) {
                  var t = e._data;
                  e._data = new Uint8Array(t.length), 0 !== t.length && e._data.set(t, 0);
                }
                return e._data;
              },
              g = function g(e) {
                var t = m(e);
                return "string" === i.getTypeOf(t) ? !e.options.binary && n.nodebuffer ? h(t, "utf-8") : e.asBinary() : t;
              },
              v = function v(e) {
                var t = m(this);
                return null === t || void 0 === t ? "" : (this.options.base64 && (t = l.decode(t)), t = e && this.options.binary ? T.utf8decode(t) : i.transformTo("string", t), e || this.options.binary || (t = i.transformTo("string", T.utf8encode(t))), t);
              },
              b = function b(e, t, r) {
                this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this._data = t, this.options = r, this._initialMetadata = {
                  dir: r.dir,
                  date: r.date
                };
              };
            b.prototype = {
              asText: function asText() {
                return v.call(this, !0);
              },
              asBinary: function asBinary() {
                return v.call(this, !1);
              },
              asNodeBuffer: function asNodeBuffer() {
                var e = g(this);
                return i.transformTo("nodebuffer", e);
              },
              asUint8Array: function asUint8Array() {
                var e = g(this);
                return i.transformTo("uint8array", e);
              },
              asArrayBuffer: function asArrayBuffer() {
                return this.asUint8Array().buffer;
              }
            };
            var y = function y(e, t) {
                var r,
                  n = "";
                for (r = 0; r < t; r++) n += String.fromCharCode(255 & e), e >>>= 8;
                return n;
              },
              w = function w() {
                var e,
                  t,
                  r = {};
                for (e = 0; e < arguments.length; e++) for (t in arguments[e]) arguments[e].hasOwnProperty(t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                return r;
              },
              x = function x(e) {
                return e = e || {}, !0 !== e.base64 || null !== e.binary && void 0 !== e.binary || (e.binary = !0), e = w(e, s), e.date = e.date || new Date(), null !== e.compression && (e.compression = e.compression.toUpperCase()), e;
              },
              _ = function _(e, t, r) {
                var n,
                  a = i.getTypeOf(t);
                if (r = x(r), r.createFolders && (n = S(e)) && C.call(this, n, !0), r.dir || null === t || void 0 === t) r.base64 = !1, r.binary = !1, t = null;else if ("string" === a) r.binary && !r.base64 && !0 !== r.optimizedBinaryString && (t = i.string2binary(t));else {
                  if (r.base64 = !1, r.binary = !0, !(a || t instanceof u)) throw new Error("The data of '" + e + "' is in an unsupported format !");
                  "arraybuffer" === a && (t = i.transformTo("uint8array", t));
                }
                var o = new b(e, t, r);
                return this.files[e] = o, o;
              },
              S = function S(e) {
                "/" == e.slice(-1) && (e = e.substring(0, e.length - 1));
                var t = e.lastIndexOf("/");
                return t > 0 ? e.substring(0, t) : "";
              },
              C = function C(e, t) {
                return "/" != e.slice(-1) && (e += "/"), t = void 0 !== t && t, this.files[e] || _.call(this, e, null, {
                  dir: !0,
                  createFolders: t
                }), this.files[e];
              },
              E = function E(e, t) {
                var r,
                  n = new u();
                return e._data instanceof u ? (n.uncompressedSize = e._data.uncompressedSize, n.crc32 = e._data.crc32, 0 === n.uncompressedSize || e.dir ? (t = c.STORE, n.compressedContent = "", n.crc32 = 0) : e._data.compressionMethod === t.magic ? n.compressedContent = e._data.getCompressedContent() : (r = e._data.getContent(), n.compressedContent = t.compress(i.transformTo(t.compressInputType, r)))) : (r = g(e), r && 0 !== r.length && !e.dir || (t = c.STORE, r = ""), n.uncompressedSize = r.length, n.crc32 = a(r), n.compressedContent = t.compress(i.transformTo(t.compressInputType, r))), n.compressedSize = n.compressedContent.length, n.compressionMethod = t.magic, n;
              },
              A = function A(e, t, r, n) {
                var s,
                  l,
                  c,
                  u,
                  h = (r.compressedContent, i.transformTo("string", f.utf8encode(t.name))),
                  d = t.comment || "",
                  p = i.transformTo("string", f.utf8encode(d)),
                  m = h.length !== t.name.length,
                  g = p.length !== d.length,
                  v = t.options,
                  b = "",
                  w = "",
                  x = "";
                c = t._initialMetadata.dir !== t.dir ? t.dir : v.dir, u = t._initialMetadata.date !== t.date ? t.date : v.date, s = u.getHours(), s <<= 6, s |= u.getMinutes(), s <<= 5, s |= u.getSeconds() / 2, l = u.getFullYear() - 1980, l <<= 4, l |= u.getMonth() + 1, l <<= 5, l |= u.getDate(), m && (w = y(1, 1) + y(a(h), 4) + h, b += "up" + y(w.length, 2) + w), g && (x = y(1, 1) + y(this.crc32(p), 4) + p, b += "uc" + y(x.length, 2) + x);
                var _ = "";
                return _ += "\n\0", _ += m || g ? "\0\b" : "\0\0", _ += r.compressionMethod, _ += y(s, 2), _ += y(l, 2), _ += y(r.crc32, 4), _ += y(r.compressedSize, 4), _ += y(r.uncompressedSize, 4), _ += y(h.length, 2), _ += y(b.length, 2), {
                  fileRecord: o.LOCAL_FILE_HEADER + _ + h + b,
                  dirRecord: o.CENTRAL_FILE_HEADER + "\0" + _ + y(p.length, 2) + "\0\0\0\0" + (!0 === c ? "\0\0\0" : "\0\0\0\0") + y(n, 4) + h + b + p,
                  compressedObject: r
                };
              },
              T = {
                load: function load(e, t) {
                  throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
                },
                filter: function filter(e) {
                  var t,
                    r,
                    n,
                    i,
                    a = [];
                  for (t in this.files) this.files.hasOwnProperty(t) && (n = this.files[t], i = new b(n.name, n._data, w(n.options)), r = t.slice(this.root.length, t.length), t.slice(0, this.root.length) === this.root && e(r, i) && a.push(i));
                  return a;
                },
                file: function file(e, t, r) {
                  if (1 === arguments.length) {
                    if (i.isRegExp(e)) {
                      var n = e;
                      return this.filter(function (e, t) {
                        return !t.dir && n.test(e);
                      });
                    }
                    return this.filter(function (t, r) {
                      return !r.dir && t === e;
                    })[0] || null;
                  }
                  return e = this.root + e, _.call(this, e, t, r), this;
                },
                folder: function folder(e) {
                  if (!e) return this;
                  if (i.isRegExp(e)) return this.filter(function (t, r) {
                    return r.dir && e.test(t);
                  });
                  var t = this.root + e,
                    r = C.call(this, t),
                    n = this.clone();
                  return n.root = r.name, n;
                },
                remove: function remove(e) {
                  e = this.root + e;
                  var t = this.files[e];
                  if (t || ("/" != e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];else for (var r = this.filter(function (t, r) {
                      return r.name.slice(0, e.length) === e;
                    }), n = 0; n < r.length; n++) delete this.files[r[n].name];
                  return this;
                },
                generate: function generate(e) {
                  e = w(e || {}, {
                    base64: !0,
                    compression: "STORE",
                    type: "base64",
                    comment: null
                  }), i.checkSupport(e.type);
                  var t,
                    r,
                    n = [],
                    a = 0,
                    s = 0,
                    u = i.transformTo("string", this.utf8encode(e.comment || this.comment || ""));
                  for (var h in this.files) if (this.files.hasOwnProperty(h)) {
                    var f = this.files[h],
                      m = f.options.compression || e.compression.toUpperCase(),
                      g = c[m];
                    if (!g) throw new Error(m + " is not a valid compression method !");
                    var v = E.call(this, f, g),
                      b = A.call(this, h, f, v, a);
                    a += b.fileRecord.length + v.compressedSize, s += b.dirRecord.length, n.push(b);
                  }
                  var x = "";
                  x = o.CENTRAL_DIRECTORY_END + "\0\0\0\0" + y(n.length, 2) + y(n.length, 2) + y(s, 4) + y(a, 4) + y(u.length, 2) + u;
                  var _ = e.type.toLowerCase();
                  for (t = "uint8array" === _ || "arraybuffer" === _ || "blob" === _ || "nodebuffer" === _ ? new p(a + s + x.length) : new d(a + s + x.length), r = 0; r < n.length; r++) t.append(n[r].fileRecord), t.append(n[r].compressedObject.compressedContent);
                  for (r = 0; r < n.length; r++) t.append(n[r].dirRecord);
                  t.append(x);
                  var S = t.finalize();
                  switch (e.type.toLowerCase()) {
                    case "uint8array":
                    case "arraybuffer":
                    case "nodebuffer":
                      return i.transformTo(e.type.toLowerCase(), S);
                    case "blob":
                      return i.arrayBuffer2Blob(i.transformTo("arraybuffer", S));
                    case "base64":
                      return e.base64 ? l.encode(S) : S;
                    default:
                      return S;
                  }
                },
                crc32: function crc32(e, t) {
                  return a(e, t);
                },
                utf8encode: function utf8encode(e) {
                  return i.transformTo("string", f.utf8encode(e));
                },
                utf8decode: function utf8decode(e) {
                  return f.utf8decode(e);
                }
              };
            t.exports = T;
          }, {
            "./base64": 1,
            "./compressedObject": 2,
            "./compressions": 3,
            "./crc32": 4,
            "./defaults": 6,
            "./nodeBuffer": 11,
            "./signature": 14,
            "./stringWriter": 16,
            "./support": 17,
            "./uint8ArrayWriter": 19,
            "./utf8": 20,
            "./utils": 21
          }],
          14: [function (e, t, r) {
            "use strict";

            r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
          }, {}],
          15: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              this.data = e, t || (this.data = a.string2binary(this.data)), this.length = this.data.length, this.index = 0;
            }
            var i = e("./dataReader"),
              a = e("./utils");
            n.prototype = new i(), n.prototype.byteAt = function (e) {
              return this.data.charCodeAt(e);
            }, n.prototype.lastIndexOfSignature = function (e) {
              return this.data.lastIndexOf(e);
            }, n.prototype.readData = function (e) {
              this.checkOffset(e);
              var t = this.data.slice(this.index, this.index + e);
              return this.index += e, t;
            }, t.exports = n;
          }, {
            "./dataReader": 5,
            "./utils": 21
          }],
          16: [function (e, t, r) {
            "use strict";

            var n = e("./utils"),
              i = function i() {
                this.data = [];
              };
            i.prototype = {
              append: function append(e) {
                e = n.transformTo("string", e), this.data.push(e);
              },
              finalize: function finalize() {
                return this.data.join("");
              }
            }, t.exports = i;
          }, {
            "./utils": 21
          }],
          17: [function (e, r, n) {
            (function (e) {
              "use strict";

              if (n.base64 = !0, n.array = !0, n.string = !0, n.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, n.nodebuffer = void 0 !== e, n.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) n.blob = !1;else {
                var t = new ArrayBuffer(0);
                try {
                  n.blob = 0 === new Blob([t], {
                    type: "application/zip"
                  }).size;
                } catch (e) {
                  try {
                    var r = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
                      i = new r();
                    i.append(t), n.blob = 0 === i.getBlob("application/zip").size;
                  } catch (e) {
                    n.blob = !1;
                  }
                }
              }
            }).call(this, void 0 !== t ? t : void 0);
          }, {}],
          18: [function (e, t, r) {
            "use strict";

            function n(e) {
              e && (this.data = e, this.length = this.data.length, this.index = 0);
            }
            var i = e("./dataReader");
            n.prototype = new i(), n.prototype.byteAt = function (e) {
              return this.data[e];
            }, n.prototype.lastIndexOfSignature = function (e) {
              for (var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), a = this.length - 4; a >= 0; --a) if (this.data[a] === t && this.data[a + 1] === r && this.data[a + 2] === n && this.data[a + 3] === i) return a;
              return -1;
            }, n.prototype.readData = function (e) {
              if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
              var t = this.data.subarray(this.index, this.index + e);
              return this.index += e, t;
            }, t.exports = n;
          }, {
            "./dataReader": 5
          }],
          19: [function (e, t, r) {
            "use strict";

            var n = e("./utils"),
              i = function i(e) {
                this.data = new Uint8Array(e), this.index = 0;
              };
            i.prototype = {
              append: function append(e) {
                0 !== e.length && (e = n.transformTo("uint8array", e), this.data.set(e, this.index), this.index += e.length);
              },
              finalize: function finalize() {
                return this.data;
              }
            }, t.exports = i;
          }, {
            "./utils": 21
          }],
          20: [function (e, t, r) {
            "use strict";

            for (var n = e("./utils"), i = e("./support"), a = e("./nodeBuffer"), o = new Array(256), s = 0; s < 256; s++) o[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
            o[254] = o[254] = 1;
            var l = function l(e) {
                var t,
                  r,
                  n,
                  a,
                  o,
                  s = e.length,
                  l = 0;
                for (a = 0; a < s; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                for (t = i.uint8array ? new Uint8Array(l) : new Array(l), o = 0, a = 0; o < l; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), r < 128 ? t[o++] = r : r < 2048 ? (t[o++] = 192 | r >>> 6, t[o++] = 128 | 63 & r) : r < 65536 ? (t[o++] = 224 | r >>> 12, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r) : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r);
                return t;
              },
              c = function c(e, t) {
                var r;
                for (t = t || e.length, t > e.length && (t = e.length), r = t - 1; r >= 0 && 128 == (192 & e[r]);) r--;
                return r < 0 ? t : 0 === r ? t : r + o[e[r]] > t ? r : t;
              },
              u = function u(e) {
                var t,
                  r,
                  i,
                  a,
                  s = e.length,
                  l = new Array(2 * s);
                for (r = 0, t = 0; t < s;) if ((i = e[t++]) < 128) l[r++] = i;else if ((a = o[i]) > 4) l[r++] = 65533, t += a - 1;else {
                  for (i &= 2 === a ? 31 : 3 === a ? 15 : 7; a > 1 && t < s;) i = i << 6 | 63 & e[t++], a--;
                  a > 1 ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                }
                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
              };
            r.utf8encode = function (e) {
              return i.nodebuffer ? a(e, "utf-8") : l(e);
            }, r.utf8decode = function (e) {
              if (i.nodebuffer) return n.transformTo("nodebuffer", e).toString("utf-8");
              e = n.transformTo(i.uint8array ? "uint8array" : "array", e);
              for (var t = [], r = 0, a = e.length; r < a;) {
                var o = c(e, Math.min(r + 65536, a));
                i.uint8array ? t.push(u(e.subarray(r, o))) : t.push(u(e.slice(r, o))), r = o;
              }
              return t.join("");
            };
          }, {
            "./nodeBuffer": 11,
            "./support": 17,
            "./utils": 21
          }],
          21: [function (e, t, r) {
            "use strict";

            function n(e) {
              return e;
            }
            function i(e, t) {
              for (var r = 0; r < e.length; ++r) t[r] = 255 & e.charCodeAt(r);
              return t;
            }
            function a(e) {
              var t = 65536,
                n = [],
                i = e.length,
                a = r.getTypeOf(e),
                o = 0,
                s = !0;
              try {
                switch (a) {
                  case "uint8array":
                    String.fromCharCode.apply(null, new Uint8Array(0));
                    break;
                  case "nodebuffer":
                    String.fromCharCode.apply(null, c(0));
                }
              } catch (e) {
                s = !1;
              }
              if (!s) {
                for (var l = "", u = 0; u < e.length; u++) l += String.fromCharCode(e[u]);
                return l;
              }
              for (; o < i && t > 1;) try {
                "array" === a || "nodebuffer" === a ? n.push(String.fromCharCode.apply(null, e.slice(o, Math.min(o + t, i)))) : n.push(String.fromCharCode.apply(null, e.subarray(o, Math.min(o + t, i)))), o += t;
              } catch (e) {
                t = Math.floor(t / 2);
              }
              return n.join("");
            }
            function o(e, t) {
              for (var r = 0; r < e.length; r++) t[r] = e[r];
              return t;
            }
            var s = e("./support"),
              l = e("./compressions"),
              c = e("./nodeBuffer");
            r.string2binary = function (e) {
              for (var t = "", r = 0; r < e.length; r++) t += String.fromCharCode(255 & e.charCodeAt(r));
              return t;
            }, r.arrayBuffer2Blob = function (e) {
              r.checkSupport("blob");
              try {
                return new Blob([e], {
                  type: "application/zip"
                });
              } catch (r) {
                try {
                  var t = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder,
                    n = new t();
                  return n.append(e), n.getBlob("application/zip");
                } catch (e) {
                  throw new Error("Bug : can't construct the Blob.");
                }
              }
            }, r.applyFromCharCode = a;
            var u = {};
            u.string = {
              string: n,
              array: function array(e) {
                return i(e, new Array(e.length));
              },
              arraybuffer: function arraybuffer(e) {
                return u.string.uint8array(e).buffer;
              },
              uint8array: function uint8array(e) {
                return i(e, new Uint8Array(e.length));
              },
              nodebuffer: function nodebuffer(e) {
                return i(e, c(e.length));
              }
            }, u.array = {
              string: a,
              array: n,
              arraybuffer: function arraybuffer(e) {
                return new Uint8Array(e).buffer;
              },
              uint8array: function uint8array(e) {
                return new Uint8Array(e);
              },
              nodebuffer: function nodebuffer(e) {
                return c(e);
              }
            }, u.arraybuffer = {
              string: function string(e) {
                return a(new Uint8Array(e));
              },
              array: function array(e) {
                return o(new Uint8Array(e), new Array(e.byteLength));
              },
              arraybuffer: n,
              uint8array: function uint8array(e) {
                return new Uint8Array(e);
              },
              nodebuffer: function nodebuffer(e) {
                return c(new Uint8Array(e));
              }
            }, u.uint8array = {
              string: a,
              array: function array(e) {
                return o(e, new Array(e.length));
              },
              arraybuffer: function arraybuffer(e) {
                return e.buffer;
              },
              uint8array: n,
              nodebuffer: function nodebuffer(e) {
                return c(e);
              }
            }, u.nodebuffer = {
              string: a,
              array: function array(e) {
                return o(e, new Array(e.length));
              },
              arraybuffer: function arraybuffer(e) {
                return u.nodebuffer.uint8array(e).buffer;
              },
              uint8array: function uint8array(e) {
                return o(e, new Uint8Array(e.length));
              },
              nodebuffer: n
            }, r.transformTo = function (e, t) {
              if (t || (t = ""), !e) return t;
              r.checkSupport(e);
              var n = r.getTypeOf(t);
              return u[n][e](t);
            }, r.getTypeOf = function (e) {
              return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : s.nodebuffer && c.test(e) ? "nodebuffer" : s.uint8array && e instanceof Uint8Array ? "uint8array" : s.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
            }, r.checkSupport = function (e) {
              if (!s[e.toLowerCase()]) throw new Error(e + " is not supported by this browser");
            }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function (e) {
              var t,
                r,
                n = "";
              for (r = 0; r < (e || "").length; r++) t = e.charCodeAt(r), n += "\\x" + (t < 16 ? "0" : "") + t.toString(16).toUpperCase();
              return n;
            }, r.findCompression = function (e) {
              for (var t in l) if (l.hasOwnProperty(t) && l[t].magic === e) return l[t];
              return null;
            }, r.isRegExp = function (e) {
              return "[object RegExp]" === Object.prototype.toString.call(e);
            };
          }, {
            "./compressions": 3,
            "./nodeBuffer": 11,
            "./support": 17
          }],
          22: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              this.files = [], this.loadOptions = t, e && this.load(e);
            }
            var i = e("./stringReader"),
              a = e("./nodeBufferReader"),
              o = e("./uint8ArrayReader"),
              s = e("./utils"),
              l = e("./signature"),
              c = e("./zipEntry"),
              u = e("./support"),
              h = e("./object");
            n.prototype = {
              checkSignature: function checkSignature(e) {
                var t = this.reader.readString(4);
                if (t !== e) throw new Error("Corrupted zip or bug : unexpected signature (" + s.pretty(t) + ", expected " + s.pretty(e) + ")");
              },
              readBlockEndOfCentral: function readBlockEndOfCentral() {
                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2), this.zipComment = this.reader.readString(this.zipCommentLength), this.zipComment = h.utf8decode(this.zipComment);
              },
              readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
                this.zip64EndOfCentralSize = this.reader.readInt(8), this.versionMadeBy = this.reader.readString(2), this.versionNeeded = this.reader.readInt(2), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                for (var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;) e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readString(t), this.zip64ExtensibleData[e] = {
                  id: e,
                  length: t,
                  value: r
                };
              },
              readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1) throw new Error("Multi-volumes zip are not supported");
              },
              readLocalFiles: function readLocalFiles() {
                var e, t;
                for (e = 0; e < this.files.length; e++) t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(l.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8();
              },
              readCentralDir: function readCentralDir() {
                var e;
                for (this.reader.setIndex(this.centralDirOffset); this.reader.readString(4) === l.CENTRAL_FILE_HEADER;) e = new c({
                  zip64: this.zip64
                }, this.loadOptions), e.readCentralPart(this.reader), this.files.push(e);
              },
              readEndOfCentral: function readEndOfCentral() {
                var e = this.reader.lastIndexOfSignature(l.CENTRAL_DIRECTORY_END);
                if (-1 === e) throw new Error("Corrupted zip : can't find end of central directory");
                if (this.reader.setIndex(e), this.checkSignature(l.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === s.MAX_VALUE_16BITS || this.diskWithCentralDirStart === s.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS || this.centralDirRecords === s.MAX_VALUE_16BITS || this.centralDirSize === s.MAX_VALUE_32BITS || this.centralDirOffset === s.MAX_VALUE_32BITS) {
                  if (this.zip64 = !0, -1 === (e = this.reader.lastIndexOfSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR))) throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
                  this.reader.setIndex(e), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(l.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                }
              },
              prepareReader: function prepareReader(e) {
                var t = s.getTypeOf(e);
                "string" !== t || u.uint8array ? this.reader = "nodebuffer" === t ? new a(e) : new o(s.transformTo("uint8array", e)) : this.reader = new i(e, this.loadOptions.optimizedBinaryString);
              },
              load: function load(e) {
                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
              }
            }, t.exports = n;
          }, {
            "./nodeBufferReader": 12,
            "./object": 13,
            "./signature": 14,
            "./stringReader": 15,
            "./support": 17,
            "./uint8ArrayReader": 18,
            "./utils": 21,
            "./zipEntry": 23
          }],
          23: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              this.options = e, this.loadOptions = t;
            }
            var i = e("./stringReader"),
              a = e("./utils"),
              o = e("./compressedObject"),
              s = e("./object");
            n.prototype = {
              isEncrypted: function isEncrypted() {
                return 1 == (1 & this.bitFlag);
              },
              useUTF8: function useUTF8() {
                return 2048 == (2048 & this.bitFlag);
              },
              prepareCompressedContent: function prepareCompressedContent(e, t, r) {
                return function () {
                  var n = e.index;
                  e.setIndex(t);
                  var i = e.readData(r);
                  return e.setIndex(n), i;
                };
              },
              prepareContent: function prepareContent(e, t, r, n, i) {
                return function () {
                  var e = a.transformTo(n.uncompressInputType, this.getCompressedContent()),
                    t = n.uncompress(e);
                  if (t.length !== i) throw new Error("Bug : uncompressed data size mismatch");
                  return t;
                };
              },
              readLocalPart: function readLocalPart(e) {
                var t, r;
                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readString(this.fileNameLength), e.skip(r), -1 == this.compressedSize || -1 == this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize == -1 || uncompressedSize == -1)");
                if (null === (t = a.findCompression(this.compressionMethod))) throw new Error("Corrupted zip : compression " + a.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
                if (this.decompressed = new o(), this.decompressed.compressedSize = this.compressedSize, this.decompressed.uncompressedSize = this.uncompressedSize, this.decompressed.crc32 = this.crc32, this.decompressed.compressionMethod = this.compressionMethod, this.decompressed.getCompressedContent = this.prepareCompressedContent(e, e.index, this.compressedSize, t), this.decompressed.getContent = this.prepareContent(e, e.index, this.compressedSize, t, this.uncompressedSize), this.loadOptions.checkCRC32 && (this.decompressed = a.transformTo("string", this.decompressed.getContent()), s.crc32(this.decompressed) !== this.crc32)) throw new Error("Corrupted zip : CRC32 mismatch");
              },
              readCentralPart: function readCentralPart(e) {
                if (this.versionMadeBy = e.readString(2), this.versionNeeded = e.readInt(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4), this.fileNameLength = e.readInt(2), this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                this.fileName = e.readString(this.fileNameLength), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readString(this.fileCommentLength), this.dir = !!(16 & this.externalFileAttributes);
              },
              parseZIP64ExtraField: function parseZIP64ExtraField(e) {
                if (this.extraFields[1]) {
                  var t = new i(this.extraFields[1].value);
                  this.uncompressedSize === a.MAX_VALUE_32BITS && (this.uncompressedSize = t.readInt(8)), this.compressedSize === a.MAX_VALUE_32BITS && (this.compressedSize = t.readInt(8)), this.localHeaderOffset === a.MAX_VALUE_32BITS && (this.localHeaderOffset = t.readInt(8)), this.diskNumberStart === a.MAX_VALUE_32BITS && (this.diskNumberStart = t.readInt(4));
                }
              },
              readExtraFields: function readExtraFields(e) {
                var t,
                  r,
                  n,
                  i = e.index;
                for (this.extraFields = this.extraFields || {}; e.index < i + this.extraFieldsLength;) t = e.readInt(2), r = e.readInt(2), n = e.readString(r), this.extraFields[t] = {
                  id: t,
                  length: r,
                  value: n
                };
              },
              handleUTF8: function handleUTF8() {
                if (this.useUTF8()) this.fileName = s.utf8decode(this.fileName), this.fileComment = s.utf8decode(this.fileComment);else {
                  var e = this.findExtraFieldUnicodePath();
                  null !== e && (this.fileName = e);
                  var t = this.findExtraFieldUnicodeComment();
                  null !== t && (this.fileComment = t);
                }
              },
              findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
                var e = this.extraFields[28789];
                if (e) {
                  var t = new i(e.value);
                  return 1 !== t.readInt(1) ? null : s.crc32(this.fileName) !== t.readInt(4) ? null : s.utf8decode(t.readString(e.length - 5));
                }
                return null;
              },
              findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
                var e = this.extraFields[25461];
                if (e) {
                  var t = new i(e.value);
                  return 1 !== t.readInt(1) ? null : s.crc32(this.fileComment) !== t.readInt(4) ? null : s.utf8decode(t.readString(e.length - 5));
                }
                return null;
              }
            }, t.exports = n;
          }, {
            "./compressedObject": 2,
            "./object": 13,
            "./stringReader": 15,
            "./utils": 21
          }],
          24: [function (e, t, r) {
            "use strict";

            var n = e("./lib/utils/common").assign,
              i = e("./lib/deflate"),
              a = e("./lib/inflate"),
              o = e("./lib/zlib/constants"),
              s = {};
            n(s, i, a, o), t.exports = s;
          }, {
            "./lib/deflate": 25,
            "./lib/inflate": 26,
            "./lib/utils/common": 27,
            "./lib/zlib/constants": 30
          }],
          25: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              var r = new h(t);
              if (r.push(e, !0), r.err) throw r.msg;
              return r.result;
            }
            function i(e, t) {
              return t = t || {}, t.raw = !0, n(e, t);
            }
            function a(e, t) {
              return t = t || {}, t.gzip = !0, n(e, t);
            }
            var o = e("./zlib/deflate.js"),
              s = e("./utils/common"),
              l = e("./utils/strings"),
              c = e("./zlib/messages"),
              u = e("./zlib/zstream"),
              h = function h(e) {
                this.options = s.assign({
                  level: -1,
                  method: 8,
                  chunkSize: 16384,
                  windowBits: 15,
                  memLevel: 8,
                  strategy: 0,
                  to: ""
                }, e || {});
                var t = this.options;
                t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u(), this.strm.avail_out = 0;
                var r = o.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                if (0 !== r) throw new Error(c[r]);
                t.header && o.deflateSetHeader(this.strm, t.header);
              };
            h.prototype.push = function (e, t) {
              var r,
                n,
                i = this.strm,
                a = this.options.chunkSize;
              if (this.ended) return !1;
              n = t === ~~t ? t : !0 === t ? 4 : 0, i.input = "string" == typeof e ? l.string2buf(e) : e, i.next_in = 0, i.avail_in = i.input.length;
              do {
                if (0 === i.avail_out && (i.output = new s.Buf8(a), i.next_out = 0, i.avail_out = a), 1 !== (r = o.deflate(i, n)) && 0 !== r) return this.onEnd(r), this.ended = !0, !1;
                (0 === i.avail_out || 0 === i.avail_in && 4 === n) && ("string" === this.options.to ? this.onData(l.buf2binstring(s.shrinkBuf(i.output, i.next_out))) : this.onData(s.shrinkBuf(i.output, i.next_out)));
              } while ((i.avail_in > 0 || 0 === i.avail_out) && 1 !== r);
              return 4 !== n || (r = o.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r);
            }, h.prototype.onData = function (e) {
              this.chunks.push(e);
            }, h.prototype.onEnd = function (e) {
              0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = s.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
            }, r.Deflate = h, r.deflate = n, r.deflateRaw = i, r.gzip = a;
          }, {
            "./utils/common": 27,
            "./utils/strings": 28,
            "./zlib/deflate.js": 32,
            "./zlib/messages": 37,
            "./zlib/zstream": 39
          }],
          26: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              var r = new f(t);
              if (r.push(e, !0), r.err) throw r.msg;
              return r.result;
            }
            function i(e, t) {
              return t = t || {}, t.raw = !0, n(e, t);
            }
            var a = e("./zlib/inflate.js"),
              o = e("./utils/common"),
              s = e("./utils/strings"),
              l = e("./zlib/constants"),
              c = e("./zlib/messages"),
              u = e("./zlib/zstream"),
              h = e("./zlib/gzheader"),
              f = function f(e) {
                this.options = o.assign({
                  chunkSize: 16384,
                  windowBits: 0,
                  to: ""
                }, e || {});
                var t = this.options;
                t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(t.windowBits >= 0 && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u(), this.strm.avail_out = 0;
                var r = a.inflateInit2(this.strm, t.windowBits);
                if (r !== l.Z_OK) throw new Error(c[r]);
                this.header = new h(), a.inflateGetHeader(this.strm, this.header);
              };
            f.prototype.push = function (e, t) {
              var r,
                n,
                i,
                c,
                u,
                h = this.strm,
                f = this.options.chunkSize;
              if (this.ended) return !1;
              n = t === ~~t ? t : !0 === t ? l.Z_FINISH : l.Z_NO_FLUSH, h.input = "string" == typeof e ? s.binstring2buf(e) : e, h.next_in = 0, h.avail_in = h.input.length;
              do {
                if (0 === h.avail_out && (h.output = new o.Buf8(f), h.next_out = 0, h.avail_out = f), (r = a.inflate(h, l.Z_NO_FLUSH)) !== l.Z_STREAM_END && r !== l.Z_OK) return this.onEnd(r), this.ended = !0, !1;
                h.next_out && (0 === h.avail_out || r === l.Z_STREAM_END || 0 === h.avail_in && n === l.Z_FINISH) && ("string" === this.options.to ? (i = s.utf8border(h.output, h.next_out), c = h.next_out - i, u = s.buf2string(h.output, i), h.next_out = c, h.avail_out = f - c, c && o.arraySet(h.output, h.output, i, c, 0), this.onData(u)) : this.onData(o.shrinkBuf(h.output, h.next_out)));
              } while (h.avail_in > 0 && r !== l.Z_STREAM_END);
              return r === l.Z_STREAM_END && (n = l.Z_FINISH), n !== l.Z_FINISH || (r = a.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l.Z_OK);
            }, f.prototype.onData = function (e) {
              this.chunks.push(e);
            }, f.prototype.onEnd = function (e) {
              e === l.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
            }, r.Inflate = f, r.inflate = n, r.inflateRaw = i, r.ungzip = n;
          }, {
            "./utils/common": 27,
            "./utils/strings": 28,
            "./zlib/constants": 30,
            "./zlib/gzheader": 33,
            "./zlib/inflate.js": 35,
            "./zlib/messages": 37,
            "./zlib/zstream": 39
          }],
          27: [function (e, t, r) {
            "use strict";

            var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
            r.assign = function (e) {
              for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
                var r = t.shift();
                if (r) {
                  if ("object" != _typeof(r)) throw new TypeError(r + "must be non-object");
                  for (var n in r) r.hasOwnProperty(n) && (e[n] = r[n]);
                }
              }
              return e;
            }, r.shrinkBuf = function (e, t) {
              return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
            };
            var i = {
                arraySet: function arraySet(e, t, r, n, i) {
                  if (t.subarray && e.subarray) return void e.set(t.subarray(r, r + n), i);
                  for (var a = 0; a < n; a++) e[i + a] = t[r + a];
                },
                flattenChunks: function flattenChunks(e) {
                  var t, r, n, i, a, o;
                  for (n = 0, t = 0, r = e.length; t < r; t++) n += e[t].length;
                  for (o = new Uint8Array(n), i = 0, t = 0, r = e.length; t < r; t++) a = e[t], o.set(a, i), i += a.length;
                  return o;
                }
              },
              a = {
                arraySet: function arraySet(e, t, r, n, i) {
                  for (var a = 0; a < n; a++) e[i + a] = t[r + a];
                },
                flattenChunks: function flattenChunks(e) {
                  return [].concat.apply([], e);
                }
              };
            r.setTyped = function (e) {
              e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, a));
            }, r.setTyped(n);
          }, {}],
          28: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              if (t < 65537 && (e.subarray && o || !e.subarray && a)) return String.fromCharCode.apply(null, i.shrinkBuf(e, t));
              for (var r = "", n = 0; n < t; n++) r += String.fromCharCode(e[n]);
              return r;
            }
            var i = e("./common"),
              a = !0,
              o = !0;
            try {
              String.fromCharCode.apply(null, [0]);
            } catch (e) {
              a = !1;
            }
            try {
              String.fromCharCode.apply(null, new Uint8Array(1));
            } catch (e) {
              o = !1;
            }
            for (var s = new i.Buf8(256), l = 0; l < 256; l++) s[l] = l >= 252 ? 6 : l >= 248 ? 5 : l >= 240 ? 4 : l >= 224 ? 3 : l >= 192 ? 2 : 1;
            s[254] = s[254] = 1, r.string2buf = function (e) {
              var t,
                r,
                n,
                a,
                o,
                s = e.length,
                l = 0;
              for (a = 0; a < s; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
              for (t = new i.Buf8(l), o = 0, a = 0; o < l; a++) r = e.charCodeAt(a), 55296 == (64512 & r) && a + 1 < s && 56320 == (64512 & (n = e.charCodeAt(a + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), a++), r < 128 ? t[o++] = r : r < 2048 ? (t[o++] = 192 | r >>> 6, t[o++] = 128 | 63 & r) : r < 65536 ? (t[o++] = 224 | r >>> 12, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r) : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63, t[o++] = 128 | r >>> 6 & 63, t[o++] = 128 | 63 & r);
              return t;
            }, r.buf2binstring = function (e) {
              return n(e, e.length);
            }, r.binstring2buf = function (e) {
              for (var t = new i.Buf8(e.length), r = 0, n = t.length; r < n; r++) t[r] = e.charCodeAt(r);
              return t;
            }, r.buf2string = function (e, t) {
              var r,
                i,
                a,
                o,
                l = t || e.length,
                c = new Array(2 * l);
              for (i = 0, r = 0; r < l;) if ((a = e[r++]) < 128) c[i++] = a;else if ((o = s[a]) > 4) c[i++] = 65533, r += o - 1;else {
                for (a &= 2 === o ? 31 : 3 === o ? 15 : 7; o > 1 && r < l;) a = a << 6 | 63 & e[r++], o--;
                o > 1 ? c[i++] = 65533 : a < 65536 ? c[i++] = a : (a -= 65536, c[i++] = 55296 | a >> 10 & 1023, c[i++] = 56320 | 1023 & a);
              }
              return n(c, i);
            }, r.utf8border = function (e, t) {
              var r;
              for (t = t || e.length, t > e.length && (t = e.length), r = t - 1; r >= 0 && 128 == (192 & e[r]);) r--;
              return r < 0 ? t : 0 === r ? t : r + s[e[r]] > t ? r : t;
            };
          }, {
            "./common": 27
          }],
          29: [function (e, t, r) {
            "use strict";

            function n(e, t, r, n) {
              for (var i = 65535 & e | 0, a = e >>> 16 & 65535 | 0, o = 0; 0 !== r;) {
                o = r > 2e3 ? 2e3 : r, r -= o;
                do {
                  i = i + t[n++] | 0, a = a + i | 0;
                } while (--o);
                i %= 65521, a %= 65521;
              }
              return i | a << 16 | 0;
            }
            t.exports = n;
          }, {}],
          30: [function (e, t, r) {
            t.exports = {
              Z_NO_FLUSH: 0,
              Z_PARTIAL_FLUSH: 1,
              Z_SYNC_FLUSH: 2,
              Z_FULL_FLUSH: 3,
              Z_FINISH: 4,
              Z_BLOCK: 5,
              Z_TREES: 6,
              Z_OK: 0,
              Z_STREAM_END: 1,
              Z_NEED_DICT: 2,
              Z_ERRNO: -1,
              Z_STREAM_ERROR: -2,
              Z_DATA_ERROR: -3,
              Z_BUF_ERROR: -5,
              Z_NO_COMPRESSION: 0,
              Z_BEST_SPEED: 1,
              Z_BEST_COMPRESSION: 9,
              Z_DEFAULT_COMPRESSION: -1,
              Z_FILTERED: 1,
              Z_HUFFMAN_ONLY: 2,
              Z_RLE: 3,
              Z_FIXED: 4,
              Z_DEFAULT_STRATEGY: 0,
              Z_BINARY: 0,
              Z_TEXT: 1,
              Z_UNKNOWN: 2,
              Z_DEFLATED: 8
            };
          }, {}],
          31: [function (e, t, r) {
            "use strict";

            function n(e, t, r, n) {
              var a = i,
                o = n + r;
              e ^= -1;
              for (var s = n; s < o; s++) e = e >>> 8 ^ a[255 & (e ^ t[s])];
              return -1 ^ e;
            }
            var i = function () {
              for (var e, t = [], r = 0; r < 256; r++) {
                e = r;
                for (var n = 0; n < 8; n++) e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                t[r] = e;
              }
              return t;
            }();
            t.exports = n;
          }, {}],
          32: [function (e, t, r) {
            "use strict";

            function n(e, t) {
              return e.msg = O[t], t;
            }
            function i(e) {
              return (e << 1) - (e > 4 ? 9 : 0);
            }
            function a(e) {
              for (var t = e.length; --t >= 0;) e[t] = 0;
            }
            function o(e) {
              var t = e.state,
                r = t.pending;
              r > e.avail_out && (r = e.avail_out), 0 !== r && (k.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
            }
            function s(e, t) {
              R._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, o(e.strm);
            }
            function l(e, t) {
              e.pending_buf[e.pending++] = t;
            }
            function c(e, t) {
              e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
            }
            function u(e, t, r, n) {
              var i = e.avail_in;
              return i > n && (i = n), 0 === i ? 0 : (e.avail_in -= i, k.arraySet(t, e.input, e.next_in, i, r), 1 === e.state.wrap ? e.adler = I(e.adler, t, i, r) : 2 === e.state.wrap && (e.adler = M(e.adler, t, i, r)), e.next_in += i, e.total_in += i, i);
            }
            function h(e, t) {
              var r,
                n,
                i = e.max_chain_length,
                a = e.strstart,
                o = e.prev_length,
                s = e.nice_match,
                l = e.strstart > e.w_size - se ? e.strstart - (e.w_size - se) : 0,
                c = e.window,
                u = e.w_mask,
                h = e.prev,
                f = e.strstart + oe,
                d = c[a + o - 1],
                p = c[a + o];
              e.prev_length >= e.good_match && (i >>= 2), s > e.lookahead && (s = e.lookahead);
              do {
                if (r = t, c[r + o] === p && c[r + o - 1] === d && c[r] === c[a] && c[++r] === c[a + 1]) {
                  a += 2, r++;
                  do {} while (c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && c[++a] === c[++r] && a < f);
                  if (n = oe - (f - a), a = f - oe, n > o) {
                    if (e.match_start = t, o = n, n >= s) break;
                    d = c[a + o - 1], p = c[a + o];
                  }
                }
              } while ((t = h[t & u]) > l && 0 != --i);
              return o <= e.lookahead ? o : e.lookahead;
            }
            function f(e) {
              var t,
                r,
                n,
                i,
                a,
                o = e.w_size;
              do {
                if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= o + (o - se)) {
                  k.arraySet(e.window, e.window, o, o, 0), e.match_start -= o, e.strstart -= o, e.block_start -= o, r = e.hash_size, t = r;
                  do {
                    n = e.head[--t], e.head[t] = n >= o ? n - o : 0;
                  } while (--r);
                  r = o, t = r;
                  do {
                    n = e.prev[--t], e.prev[t] = n >= o ? n - o : 0;
                  } while (--r);
                  i += o;
                }
                if (0 === e.strm.avail_in) break;
                if (r = u(e.strm, e.window, e.strstart + e.lookahead, i), e.lookahead += r, e.lookahead + e.insert >= ae) for (a = e.strstart - e.insert, e.ins_h = e.window[a], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[a + ae - 1]) & e.hash_mask, e.prev[a & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = a, a++, e.insert--, !(e.lookahead + e.insert < ae)););
              } while (e.lookahead < se && 0 !== e.strm.avail_in);
            }
            function d(e, t) {
              var r = 65535;
              for (r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;) {
                if (e.lookahead <= 1) {
                  if (f(e), 0 === e.lookahead && t === P) return ge;
                  if (0 === e.lookahead) break;
                }
                e.strstart += e.lookahead, e.lookahead = 0;
                var n = e.block_start + r;
                if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, s(e, !1), 0 === e.strm.avail_out)) return ge;
                if (e.strstart - e.block_start >= e.w_size - se && (s(e, !1), 0 === e.strm.avail_out)) return ge;
              }
              return e.insert = 0, t === L ? (s(e, !0), 0 === e.strm.avail_out ? be : ye) : (e.strstart > e.block_start && (s(e, !1), e.strm.avail_out), ge);
            }
            function p(e, t) {
              for (var r, n;;) {
                if (e.lookahead < se) {
                  if (f(e), e.lookahead < se && t === P) return ge;
                  if (0 === e.lookahead) break;
                }
                if (r = 0, e.lookahead >= ae && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + ae - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - se && (e.match_length = h(e, r)), e.match_length >= ae) {
                  if (n = R._tr_tally(e, e.strstart - e.match_start, e.match_length - ae), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= ae) {
                    e.match_length--;
                    do {
                      e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + ae - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
                    } while (0 != --e.match_length);
                    e.strstart++;
                  } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                } else n = R._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                if (n && (s(e, !1), 0 === e.strm.avail_out)) return ge;
              }
              return e.insert = e.strstart < ae - 1 ? e.strstart : ae - 1, t === L ? (s(e, !0), 0 === e.strm.avail_out ? be : ye) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? ge : ve;
            }
            function m(e, t) {
              for (var r, n, i;;) {
                if (e.lookahead < se) {
                  if (f(e), e.lookahead < se && t === P) return ge;
                  if (0 === e.lookahead) break;
                }
                if (r = 0, e.lookahead >= ae && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + ae - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = ae - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - se && (e.match_length = h(e, r), e.match_length <= 5 && (e.strategy === V || e.match_length === ae && e.strstart - e.match_start > 4096) && (e.match_length = ae - 1)), e.prev_length >= ae && e.match_length <= e.prev_length) {
                  i = e.strstart + e.lookahead - ae, n = R._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - ae), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
                  do {
                    ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + ae - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
                  } while (0 != --e.prev_length);
                  if (e.match_available = 0, e.match_length = ae - 1, e.strstart++, n && (s(e, !1), 0 === e.strm.avail_out)) return ge;
                } else if (e.match_available) {
                  if (n = R._tr_tally(e, 0, e.window[e.strstart - 1]), n && s(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return ge;
                } else e.match_available = 1, e.strstart++, e.lookahead--;
              }
              return e.match_available && (n = R._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < ae - 1 ? e.strstart : ae - 1, t === L ? (s(e, !0), 0 === e.strm.avail_out ? be : ye) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? ge : ve;
            }
            function g(e, t) {
              for (var r, n, i, a, o = e.window;;) {
                if (e.lookahead <= oe) {
                  if (f(e), e.lookahead <= oe && t === P) return ge;
                  if (0 === e.lookahead) break;
                }
                if (e.match_length = 0, e.lookahead >= ae && e.strstart > 0 && (i = e.strstart - 1, (n = o[i]) === o[++i] && n === o[++i] && n === o[++i])) {
                  a = e.strstart + oe;
                  do {} while (n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && n === o[++i] && i < a);
                  e.match_length = oe - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                }
                if (e.match_length >= ae ? (r = R._tr_tally(e, 1, e.match_length - ae), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = R._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (s(e, !1), 0 === e.strm.avail_out)) return ge;
              }
              return e.insert = 0, t === L ? (s(e, !0), 0 === e.strm.avail_out ? be : ye) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? ge : ve;
            }
            function v(e, t) {
              for (var r;;) {
                if (0 === e.lookahead && (f(e), 0 === e.lookahead)) {
                  if (t === P) return ge;
                  break;
                }
                if (e.match_length = 0, r = R._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (s(e, !1), 0 === e.strm.avail_out)) return ge;
              }
              return e.insert = 0, t === L ? (s(e, !0), 0 === e.strm.avail_out ? be : ye) : e.last_lit && (s(e, !1), 0 === e.strm.avail_out) ? ge : ve;
            }
            function b(e) {
              e.window_size = 2 * e.w_size, a(e.head), e.max_lazy_match = T[e.level].max_lazy, e.good_match = T[e.level].good_length, e.nice_match = T[e.level].nice_length, e.max_chain_length = T[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = ae - 1, e.match_available = 0, e.ins_h = 0;
            }
            function y() {
              this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Z, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new k.Buf16(2 * ne), this.dyn_dtree = new k.Buf16(2 * (2 * te + 1)), this.bl_tree = new k.Buf16(2 * (2 * re + 1)), a(this.dyn_ltree), a(this.dyn_dtree), a(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new k.Buf16(ie + 1), this.heap = new k.Buf16(2 * ee + 1), a(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new k.Buf16(2 * ee + 1), a(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
            }
            function w(e) {
              var t;
              return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = K, t = e.state, t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? ce : pe, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = P, R._tr_init(t), N) : n(e, j);
            }
            function x(e) {
              var t = w(e);
              return t === N && b(e.state), t;
            }
            function _(e, t) {
              return e && e.state ? 2 !== e.state.wrap ? j : (e.state.gzhead = t, N) : j;
            }
            function S(e, t, r, i, a, o) {
              if (!e) return j;
              var s = 1;
              if (t === G && (t = 6), i < 0 ? (s = 0, i = -i) : i > 15 && (s = 2, i -= 16), a < 1 || a > J || r !== Z || i < 8 || i > 15 || t < 0 || t > 9 || o < 0 || o > X) return n(e, j);
              8 === i && (i = 9);
              var l = new y();
              return e.state = l, l.strm = e, l.wrap = s, l.gzhead = null, l.w_bits = i, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = a + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + ae - 1) / ae), l.window = new k.Buf8(2 * l.w_size), l.head = new k.Buf16(l.hash_size), l.prev = new k.Buf16(l.w_size), l.lit_bufsize = 1 << a + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new k.Buf8(l.pending_buf_size), l.d_buf = l.lit_bufsize >> 1, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, x(e);
            }
            function C(e, t) {
              return S(e, t, Z, Q, $, Y);
            }
            function E(e, t) {
              var r, s, u, h;
              if (!e || !e.state || t > F || t < 0) return e ? n(e, j) : j;
              if (s = e.state, !e.output || !e.input && 0 !== e.avail_in || s.status === me && t !== L) return n(e, 0 === e.avail_out ? H : j);
              if (s.strm = e, r = s.last_flush, s.last_flush = t, s.status === ce) if (2 === s.wrap) e.adler = 0, l(s, 31), l(s, 139), l(s, 8), s.gzhead ? (l(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (s.gzhead.extra ? 4 : 0) + (s.gzhead.name ? 8 : 0) + (s.gzhead.comment ? 16 : 0)), l(s, 255 & s.gzhead.time), l(s, s.gzhead.time >> 8 & 255), l(s, s.gzhead.time >> 16 & 255), l(s, s.gzhead.time >> 24 & 255), l(s, 9 === s.level ? 2 : s.strategy >= q || s.level < 2 ? 4 : 0), l(s, 255 & s.gzhead.os), s.gzhead.extra && s.gzhead.extra.length && (l(s, 255 & s.gzhead.extra.length), l(s, s.gzhead.extra.length >> 8 & 255)), s.gzhead.hcrc && (e.adler = M(e.adler, s.pending_buf, s.pending, 0)), s.gzindex = 0, s.status = ue) : (l(s, 0), l(s, 0), l(s, 0), l(s, 0), l(s, 0), l(s, 9 === s.level ? 2 : s.strategy >= q || s.level < 2 ? 4 : 0), l(s, we), s.status = pe);else {
                var f = Z + (s.w_bits - 8 << 4) << 8,
                  d = -1;
                d = s.strategy >= q || s.level < 2 ? 0 : s.level < 6 ? 1 : 6 === s.level ? 2 : 3, f |= d << 6, 0 !== s.strstart && (f |= le), f += 31 - f % 31, s.status = pe, c(s, f), 0 !== s.strstart && (c(s, e.adler >>> 16), c(s, 65535 & e.adler)), e.adler = 1;
              }
              if (s.status === ue) if (s.gzhead.extra) {
                for (u = s.pending; s.gzindex < (65535 & s.gzhead.extra.length) && (s.pending !== s.pending_buf_size || (s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending !== s.pending_buf_size));) l(s, 255 & s.gzhead.extra[s.gzindex]), s.gzindex++;
                s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), s.gzindex === s.gzhead.extra.length && (s.gzindex = 0, s.status = he);
              } else s.status = he;
              if (s.status === he) if (s.gzhead.name) {
                u = s.pending;
                do {
                  if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending === s.pending_buf_size)) {
                    h = 1;
                    break;
                  }
                  h = s.gzindex < s.gzhead.name.length ? 255 & s.gzhead.name.charCodeAt(s.gzindex++) : 0, l(s, h);
                } while (0 !== h);
                s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), 0 === h && (s.gzindex = 0, s.status = fe);
              } else s.status = fe;
              if (s.status === fe) if (s.gzhead.comment) {
                u = s.pending;
                do {
                  if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), o(e), u = s.pending, s.pending === s.pending_buf_size)) {
                    h = 1;
                    break;
                  }
                  h = s.gzindex < s.gzhead.comment.length ? 255 & s.gzhead.comment.charCodeAt(s.gzindex++) : 0, l(s, h);
                } while (0 !== h);
                s.gzhead.hcrc && s.pending > u && (e.adler = M(e.adler, s.pending_buf, s.pending - u, u)), 0 === h && (s.status = de);
              } else s.status = de;
              if (s.status === de && (s.gzhead.hcrc ? (s.pending + 2 > s.pending_buf_size && o(e), s.pending + 2 <= s.pending_buf_size && (l(s, 255 & e.adler), l(s, e.adler >> 8 & 255), e.adler = 0, s.status = pe)) : s.status = pe), 0 !== s.pending) {
                if (o(e), 0 === e.avail_out) return s.last_flush = -1, N;
              } else if (0 === e.avail_in && i(t) <= i(r) && t !== L) return n(e, H);
              if (s.status === me && 0 !== e.avail_in) return n(e, H);
              if (0 !== e.avail_in || 0 !== s.lookahead || t !== P && s.status !== me) {
                var p = s.strategy === q ? v(s, t) : s.strategy === W ? g(s, t) : T[s.level].func(s, t);
                if (p !== be && p !== ye || (s.status = me), p === ge || p === be) return 0 === e.avail_out && (s.last_flush = -1), N;
                if (p === ve && (t === B ? R._tr_align(s) : t !== F && (R._tr_stored_block(s, 0, 0, !1), t === D && (a(s.head), 0 === s.lookahead && (s.strstart = 0, s.block_start = 0, s.insert = 0))), o(e), 0 === e.avail_out)) return s.last_flush = -1, N;
              }
              return t !== L ? N : s.wrap <= 0 ? U : (2 === s.wrap ? (l(s, 255 & e.adler), l(s, e.adler >> 8 & 255), l(s, e.adler >> 16 & 255), l(s, e.adler >> 24 & 255), l(s, 255 & e.total_in), l(s, e.total_in >> 8 & 255), l(s, e.total_in >> 16 & 255), l(s, e.total_in >> 24 & 255)) : (c(s, e.adler >>> 16), c(s, 65535 & e.adler)), o(e), s.wrap > 0 && (s.wrap = -s.wrap), 0 !== s.pending ? N : U);
            }
            function A(e) {
              var t;
              return e && e.state ? (t = e.state.status) !== ce && t !== ue && t !== he && t !== fe && t !== de && t !== pe && t !== me ? n(e, j) : (e.state = null, t === pe ? n(e, z) : N) : j;
            }
            var T,
              k = e("../utils/common"),
              R = e("./trees"),
              I = e("./adler32"),
              M = e("./crc32"),
              O = e("./messages"),
              P = 0,
              B = 1,
              D = 3,
              L = 4,
              F = 5,
              N = 0,
              U = 1,
              j = -2,
              z = -3,
              H = -5,
              G = -1,
              V = 1,
              q = 2,
              W = 3,
              X = 4,
              Y = 0,
              K = 2,
              Z = 8,
              J = 9,
              Q = 15,
              $ = 8,
              ee = 286,
              te = 30,
              re = 19,
              ne = 2 * ee + 1,
              ie = 15,
              ae = 3,
              oe = 258,
              se = oe + ae + 1,
              le = 32,
              ce = 42,
              ue = 69,
              he = 73,
              fe = 91,
              de = 103,
              pe = 113,
              me = 666,
              ge = 1,
              ve = 2,
              be = 3,
              ye = 4,
              we = 3,
              xe = function xe(e, t, r, n, i) {
                this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
              };
            T = [new xe(0, 0, 0, 0, d), new xe(4, 4, 8, 4, p), new xe(4, 5, 16, 8, p), new xe(4, 6, 32, 32, p), new xe(4, 4, 16, 16, m), new xe(8, 16, 32, 32, m), new xe(8, 16, 128, 128, m), new xe(8, 32, 128, 256, m), new xe(32, 128, 258, 1024, m), new xe(32, 258, 258, 4096, m)], r.deflateInit = C, r.deflateInit2 = S, r.deflateReset = x, r.deflateResetKeep = w, r.deflateSetHeader = _, r.deflate = E, r.deflateEnd = A, r.deflateInfo = "pako deflate (from Nodeca project)";
          }, {
            "../utils/common": 27,
            "./adler32": 29,
            "./crc32": 31,
            "./messages": 37,
            "./trees": 38
          }],
          33: [function (e, t, r) {
            "use strict";

            function n() {
              this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
            }
            t.exports = n;
          }, {}],
          34: [function (e, t, r) {
            "use strict";

            t.exports = function (e, t) {
              var r, n, i, a, o, s, l, c, u, h, f, d, p, m, g, v, b, y, w, x, _, S, C, E, A;
              r = e.state, n = e.next_in, E = e.input, i = n + (e.avail_in - 5), a = e.next_out, A = e.output, o = a - (t - e.avail_out), s = a + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, g = r.distcode, v = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
              e: do {
                p < 15 && (d += E[n++] << p, p += 8, d += E[n++] << p, p += 8), y = m[d & v];
                t: for (;;) {
                  if (w = y >>> 24, d >>>= w, p -= w, 0 === (w = y >>> 16 & 255)) A[a++] = 65535 & y;else {
                    if (!(16 & w)) {
                      if (0 == (64 & w)) {
                        y = m[(65535 & y) + (d & (1 << w) - 1)];
                        continue t;
                      }
                      if (32 & w) {
                        r.mode = 12;
                        break e;
                      }
                      e.msg = "invalid literal/length code", r.mode = 30;
                      break e;
                    }
                    x = 65535 & y, w &= 15, w && (p < w && (d += E[n++] << p, p += 8), x += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += E[n++] << p, p += 8, d += E[n++] << p, p += 8), y = g[d & b];
                    r: for (;;) {
                      if (w = y >>> 24, d >>>= w, p -= w, !(16 & (w = y >>> 16 & 255))) {
                        if (0 == (64 & w)) {
                          y = g[(65535 & y) + (d & (1 << w) - 1)];
                          continue r;
                        }
                        e.msg = "invalid distance code", r.mode = 30;
                        break e;
                      }
                      if (_ = 65535 & y, w &= 15, p < w && (d += E[n++] << p, (p += 8) < w && (d += E[n++] << p, p += 8)), (_ += d & (1 << w) - 1) > l) {
                        e.msg = "invalid distance too far back", r.mode = 30;
                        break e;
                      }
                      if (d >>>= w, p -= w, w = a - o, _ > w) {
                        if ((w = _ - w) > u && r.sane) {
                          e.msg = "invalid distance too far back", r.mode = 30;
                          break e;
                        }
                        if (S = 0, C = f, 0 === h) {
                          if (S += c - w, w < x) {
                            x -= w;
                            do {
                              A[a++] = f[S++];
                            } while (--w);
                            S = a - _, C = A;
                          }
                        } else if (h < w) {
                          if (S += c + h - w, (w -= h) < x) {
                            x -= w;
                            do {
                              A[a++] = f[S++];
                            } while (--w);
                            if (S = 0, h < x) {
                              w = h, x -= w;
                              do {
                                A[a++] = f[S++];
                              } while (--w);
                              S = a - _, C = A;
                            }
                          }
                        } else if (S += h - w, w < x) {
                          x -= w;
                          do {
                            A[a++] = f[S++];
                          } while (--w);
                          S = a - _, C = A;
                        }
                        for (; x > 2;) A[a++] = C[S++], A[a++] = C[S++], A[a++] = C[S++], x -= 3;
                        x && (A[a++] = C[S++], x > 1 && (A[a++] = C[S++]));
                      } else {
                        S = a - _;
                        do {
                          A[a++] = A[S++], A[a++] = A[S++], A[a++] = A[S++], x -= 3;
                        } while (x > 2);
                        x && (A[a++] = A[S++], x > 1 && (A[a++] = A[S++]));
                      }
                      break;
                    }
                  }
                  break;
                }
              } while (n < i && a < s);
              x = p >> 3, n -= x, p -= x << 3, d &= (1 << p) - 1, e.next_in = n, e.next_out = a, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = a < s ? s - a + 257 : 257 - (a - s), r.hold = d, r.bits = p;
            };
          }, {}],
          35: [function (e, t, r) {
            "use strict";

            function n(e) {
              return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
            }
            function i() {
              this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new v.Buf16(320), this.work = new v.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
            }
            function a(e) {
              var t;
              return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = L, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new v.Buf32(pe), t.distcode = t.distdyn = new v.Buf32(me), t.sane = 1, t.back = -1, k) : M;
            }
            function o(e) {
              var t;
              return e && e.state ? (t = e.state, t.wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : M;
            }
            function s(e, t) {
              var r, n;
              return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? M : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : M;
            }
            function l(e, t) {
              var r, n;
              return e ? (n = new i(), e.state = n, n.window = null, r = s(e, t), r !== k && (e.state = null), r) : M;
            }
            function c(e) {
              return l(e, ge);
            }
            function u(e) {
              if (ve) {
                var t;
                for (m = new v.Buf32(512), g = new v.Buf32(32), t = 0; t < 144;) e.lens[t++] = 8;
                for (; t < 256;) e.lens[t++] = 9;
                for (; t < 280;) e.lens[t++] = 7;
                for (; t < 288;) e.lens[t++] = 8;
                for (x(S, e.lens, 0, 288, m, 0, e.work, {
                  bits: 9
                }), t = 0; t < 32;) e.lens[t++] = 5;
                x(C, e.lens, 0, 32, g, 0, e.work, {
                  bits: 5
                }), ve = !1;
              }
              e.lencode = m, e.lenbits = 9, e.distcode = g, e.distbits = 5;
            }
            function h(e, t, r, n) {
              var i,
                a = e.state;
              return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new v.Buf8(a.wsize)), n >= a.wsize ? (v.arraySet(a.window, t, r - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > n && (i = n), v.arraySet(a.window, t, r - n, i, a.wnext), n -= i, n ? (v.arraySet(a.window, t, r - n, n, 0), a.wnext = n, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
            }
            function f(e, t) {
              var r,
                i,
                a,
                o,
                s,
                l,
                c,
                f,
                d,
                p,
                m,
                g,
                pe,
                me,
                ge,
                ve,
                be,
                ye,
                we,
                xe,
                _e,
                Se,
                Ce,
                Ee,
                Ae = 0,
                Te = new v.Buf8(4),
                ke = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
              if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return M;
              r = e.state, r.mode === X && (r.mode = Y), s = e.next_out, a = e.output, c = e.avail_out, o = e.next_in, i = e.input, l = e.avail_in, f = r.hold, d = r.bits, p = l, m = c, Se = k;
              e: for (;;) switch (r.mode) {
                case L:
                  if (0 === r.wrap) {
                    r.mode = Y;
                    break;
                  }
                  for (; d < 16;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if (2 & r.wrap && 35615 === f) {
                    r.check = 0, Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = y(r.check, Te, 2, 0), f = 0, d = 0, r.mode = F;
                    break;
                  }
                  if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & f) << 8) + (f >> 8)) % 31) {
                    e.msg = "incorrect header check", r.mode = he;
                    break;
                  }
                  if ((15 & f) !== D) {
                    e.msg = "unknown compression method", r.mode = he;
                    break;
                  }
                  if (f >>>= 4, d -= 4, _e = 8 + (15 & f), 0 === r.wbits) r.wbits = _e;else if (_e > r.wbits) {
                    e.msg = "invalid window size", r.mode = he;
                    break;
                  }
                  r.dmax = 1 << _e, e.adler = r.check = 1, r.mode = 512 & f ? q : X, f = 0, d = 0;
                  break;
                case F:
                  for (; d < 16;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if (r.flags = f, (255 & r.flags) !== D) {
                    e.msg = "unknown compression method", r.mode = he;
                    break;
                  }
                  if (57344 & r.flags) {
                    e.msg = "unknown header flags set", r.mode = he;
                    break;
                  }
                  r.head && (r.head.text = f >> 8 & 1), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = y(r.check, Te, 2, 0)), f = 0, d = 0, r.mode = N;
                case N:
                  for (; d < 32;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  r.head && (r.head.time = f), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, Te[2] = f >>> 16 & 255, Te[3] = f >>> 24 & 255, r.check = y(r.check, Te, 4, 0)), f = 0, d = 0, r.mode = U;
                case U:
                  for (; d < 16;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  r.head && (r.head.xflags = 255 & f, r.head.os = f >> 8), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = y(r.check, Te, 2, 0)), f = 0, d = 0, r.mode = j;
                case j:
                  if (1024 & r.flags) {
                    for (; d < 16;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    r.length = f, r.head && (r.head.extra_len = f), 512 & r.flags && (Te[0] = 255 & f, Te[1] = f >>> 8 & 255, r.check = y(r.check, Te, 2, 0)), f = 0, d = 0;
                  } else r.head && (r.head.extra = null);
                  r.mode = z;
                case z:
                  if (1024 & r.flags && (g = r.length, g > l && (g = l), g && (r.head && (_e = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), v.arraySet(r.head.extra, i, o, g, _e)), 512 & r.flags && (r.check = y(r.check, i, g, o)), l -= g, o += g, r.length -= g), r.length)) break e;
                  r.length = 0, r.mode = H;
                case H:
                  if (2048 & r.flags) {
                    if (0 === l) break e;
                    g = 0;
                    do {
                      _e = i[o + g++], r.head && _e && r.length < 65536 && (r.head.name += String.fromCharCode(_e));
                    } while (_e && g < l);
                    if (512 & r.flags && (r.check = y(r.check, i, g, o)), l -= g, o += g, _e) break e;
                  } else r.head && (r.head.name = null);
                  r.length = 0, r.mode = G;
                case G:
                  if (4096 & r.flags) {
                    if (0 === l) break e;
                    g = 0;
                    do {
                      _e = i[o + g++], r.head && _e && r.length < 65536 && (r.head.comment += String.fromCharCode(_e));
                    } while (_e && g < l);
                    if (512 & r.flags && (r.check = y(r.check, i, g, o)), l -= g, o += g, _e) break e;
                  } else r.head && (r.head.comment = null);
                  r.mode = V;
                case V:
                  if (512 & r.flags) {
                    for (; d < 16;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    if (f !== (65535 & r.check)) {
                      e.msg = "header crc mismatch", r.mode = he;
                      break;
                    }
                    f = 0, d = 0;
                  }
                  r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = X;
                  break;
                case q:
                  for (; d < 32;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  e.adler = r.check = n(f), f = 0, d = 0, r.mode = W;
                case W:
                  if (0 === r.havedict) return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, I;
                  e.adler = r.check = 1, r.mode = X;
                case X:
                  if (t === A || t === T) break e;
                case Y:
                  if (r.last) {
                    f >>>= 7 & d, d -= 7 & d, r.mode = le;
                    break;
                  }
                  for (; d < 3;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  switch (r.last = 1 & f, f >>>= 1, d -= 1, 3 & f) {
                    case 0:
                      r.mode = K;
                      break;
                    case 1:
                      if (u(r), r.mode = te, t === T) {
                        f >>>= 2, d -= 2;
                        break e;
                      }
                      break;
                    case 2:
                      r.mode = Q;
                      break;
                    case 3:
                      e.msg = "invalid block type", r.mode = he;
                  }
                  f >>>= 2, d -= 2;
                  break;
                case K:
                  for (f >>>= 7 & d, d -= 7 & d; d < 32;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if ((65535 & f) != (f >>> 16 ^ 65535)) {
                    e.msg = "invalid stored block lengths", r.mode = he;
                    break;
                  }
                  if (r.length = 65535 & f, f = 0, d = 0, r.mode = Z, t === T) break e;
                case Z:
                  r.mode = J;
                case J:
                  if (g = r.length) {
                    if (g > l && (g = l), g > c && (g = c), 0 === g) break e;
                    v.arraySet(a, i, o, g, s), l -= g, o += g, c -= g, s += g, r.length -= g;
                    break;
                  }
                  r.mode = X;
                  break;
                case Q:
                  for (; d < 14;) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if (r.nlen = 257 + (31 & f), f >>>= 5, d -= 5, r.ndist = 1 + (31 & f), f >>>= 5, d -= 5, r.ncode = 4 + (15 & f), f >>>= 4, d -= 4, r.nlen > 286 || r.ndist > 30) {
                    e.msg = "too many length or distance symbols", r.mode = he;
                    break;
                  }
                  r.have = 0, r.mode = $;
                case $:
                  for (; r.have < r.ncode;) {
                    for (; d < 3;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    r.lens[ke[r.have++]] = 7 & f, f >>>= 3, d -= 3;
                  }
                  for (; r.have < 19;) r.lens[ke[r.have++]] = 0;
                  if (r.lencode = r.lendyn, r.lenbits = 7, Ce = {
                    bits: r.lenbits
                  }, Se = x(_, r.lens, 0, 19, r.lencode, 0, r.work, Ce), r.lenbits = Ce.bits, Se) {
                    e.msg = "invalid code lengths set", r.mode = he;
                    break;
                  }
                  r.have = 0, r.mode = ee;
                case ee:
                  for (; r.have < r.nlen + r.ndist;) {
                    for (; Ae = r.lencode[f & (1 << r.lenbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    if (be < 16) f >>>= ge, d -= ge, r.lens[r.have++] = be;else {
                      if (16 === be) {
                        for (Ee = ge + 2; d < Ee;) {
                          if (0 === l) break e;
                          l--, f += i[o++] << d, d += 8;
                        }
                        if (f >>>= ge, d -= ge, 0 === r.have) {
                          e.msg = "invalid bit length repeat", r.mode = he;
                          break;
                        }
                        _e = r.lens[r.have - 1], g = 3 + (3 & f), f >>>= 2, d -= 2;
                      } else if (17 === be) {
                        for (Ee = ge + 3; d < Ee;) {
                          if (0 === l) break e;
                          l--, f += i[o++] << d, d += 8;
                        }
                        f >>>= ge, d -= ge, _e = 0, g = 3 + (7 & f), f >>>= 3, d -= 3;
                      } else {
                        for (Ee = ge + 7; d < Ee;) {
                          if (0 === l) break e;
                          l--, f += i[o++] << d, d += 8;
                        }
                        f >>>= ge, d -= ge, _e = 0, g = 11 + (127 & f), f >>>= 7, d -= 7;
                      }
                      if (r.have + g > r.nlen + r.ndist) {
                        e.msg = "invalid bit length repeat", r.mode = he;
                        break;
                      }
                      for (; g--;) r.lens[r.have++] = _e;
                    }
                  }
                  if (r.mode === he) break;
                  if (0 === r.lens[256]) {
                    e.msg = "invalid code -- missing end-of-block", r.mode = he;
                    break;
                  }
                  if (r.lenbits = 9, Ce = {
                    bits: r.lenbits
                  }, Se = x(S, r.lens, 0, r.nlen, r.lencode, 0, r.work, Ce), r.lenbits = Ce.bits, Se) {
                    e.msg = "invalid literal/lengths set", r.mode = he;
                    break;
                  }
                  if (r.distbits = 6, r.distcode = r.distdyn, Ce = {
                    bits: r.distbits
                  }, Se = x(C, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, Ce), r.distbits = Ce.bits, Se) {
                    e.msg = "invalid distances set", r.mode = he;
                    break;
                  }
                  if (r.mode = te, t === T) break e;
                case te:
                  r.mode = re;
                case re:
                  if (l >= 6 && c >= 258) {
                    e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, w(e, m), s = e.next_out, a = e.output, c = e.avail_out, o = e.next_in, i = e.input, l = e.avail_in, f = r.hold, d = r.bits, r.mode === X && (r.back = -1);
                    break;
                  }
                  for (r.back = 0; Ae = r.lencode[f & (1 << r.lenbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if (ve && 0 == (240 & ve)) {
                    for (ye = ge, we = ve, xe = be; Ae = r.lencode[xe + ((f & (1 << ye + we) - 1) >> ye)], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ye + ge <= d);) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    f >>>= ye, d -= ye, r.back += ye;
                  }
                  if (f >>>= ge, d -= ge, r.back += ge, r.length = be, 0 === ve) {
                    r.mode = se;
                    break;
                  }
                  if (32 & ve) {
                    r.back = -1, r.mode = X;
                    break;
                  }
                  if (64 & ve) {
                    e.msg = "invalid literal/length code", r.mode = he;
                    break;
                  }
                  r.extra = 15 & ve, r.mode = ne;
                case ne:
                  if (r.extra) {
                    for (Ee = r.extra; d < Ee;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    r.length += f & (1 << r.extra) - 1, f >>>= r.extra, d -= r.extra, r.back += r.extra;
                  }
                  r.was = r.length, r.mode = ie;
                case ie:
                  for (; Ae = r.distcode[f & (1 << r.distbits) - 1], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ge <= d);) {
                    if (0 === l) break e;
                    l--, f += i[o++] << d, d += 8;
                  }
                  if (0 == (240 & ve)) {
                    for (ye = ge, we = ve, xe = be; Ae = r.distcode[xe + ((f & (1 << ye + we) - 1) >> ye)], ge = Ae >>> 24, ve = Ae >>> 16 & 255, be = 65535 & Ae, !(ye + ge <= d);) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    f >>>= ye, d -= ye, r.back += ye;
                  }
                  if (f >>>= ge, d -= ge, r.back += ge, 64 & ve) {
                    e.msg = "invalid distance code", r.mode = he;
                    break;
                  }
                  r.offset = be, r.extra = 15 & ve, r.mode = ae;
                case ae:
                  if (r.extra) {
                    for (Ee = r.extra; d < Ee;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    r.offset += f & (1 << r.extra) - 1, f >>>= r.extra, d -= r.extra, r.back += r.extra;
                  }
                  if (r.offset > r.dmax) {
                    e.msg = "invalid distance too far back", r.mode = he;
                    break;
                  }
                  r.mode = oe;
                case oe:
                  if (0 === c) break e;
                  if (g = m - c, r.offset > g) {
                    if ((g = r.offset - g) > r.whave && r.sane) {
                      e.msg = "invalid distance too far back", r.mode = he;
                      break;
                    }
                    g > r.wnext ? (g -= r.wnext, pe = r.wsize - g) : pe = r.wnext - g, g > r.length && (g = r.length), me = r.window;
                  } else me = a, pe = s - r.offset, g = r.length;
                  g > c && (g = c), c -= g, r.length -= g;
                  do {
                    a[s++] = me[pe++];
                  } while (--g);
                  0 === r.length && (r.mode = re);
                  break;
                case se:
                  if (0 === c) break e;
                  a[s++] = r.length, c--, r.mode = re;
                  break;
                case le:
                  if (r.wrap) {
                    for (; d < 32;) {
                      if (0 === l) break e;
                      l--, f |= i[o++] << d, d += 8;
                    }
                    if (m -= c, e.total_out += m, r.total += m, m && (e.adler = r.check = r.flags ? y(r.check, a, m, s - m) : b(r.check, a, m, s - m)), m = c, (r.flags ? f : n(f)) !== r.check) {
                      e.msg = "incorrect data check", r.mode = he;
                      break;
                    }
                    f = 0, d = 0;
                  }
                  r.mode = ce;
                case ce:
                  if (r.wrap && r.flags) {
                    for (; d < 32;) {
                      if (0 === l) break e;
                      l--, f += i[o++] << d, d += 8;
                    }
                    if (f !== (4294967295 & r.total)) {
                      e.msg = "incorrect length check", r.mode = he;
                      break;
                    }
                    f = 0, d = 0;
                  }
                  r.mode = ue;
                case ue:
                  Se = R;
                  break e;
                case he:
                  Se = O;
                  break e;
                case fe:
                  return P;
                case de:
                default:
                  return M;
              }
              return e.next_out = s, e.avail_out = c, e.next_in = o, e.avail_in = l, r.hold = f, r.bits = d, (r.wsize || m !== e.avail_out && r.mode < he && (r.mode < le || t !== E)) && h(e, e.output, e.next_out, m - e.avail_out) ? (r.mode = fe, P) : (p -= e.avail_in, m -= e.avail_out, e.total_in += p, e.total_out += m, r.total += m, r.wrap && m && (e.adler = r.check = r.flags ? y(r.check, a, m, e.next_out - m) : b(r.check, a, m, e.next_out - m)), e.data_type = r.bits + (r.last ? 64 : 0) + (r.mode === X ? 128 : 0) + (r.mode === te || r.mode === Z ? 256 : 0), (0 === p && 0 === m || t === E) && Se === k && (Se = B), Se);
            }
            function d(e) {
              if (!e || !e.state) return M;
              var t = e.state;
              return t.window && (t.window = null), e.state = null, k;
            }
            function p(e, t) {
              var r;
              return e && e.state ? (r = e.state, 0 == (2 & r.wrap) ? M : (r.head = t, t.done = !1, k)) : M;
            }
            var m,
              g,
              v = e("../utils/common"),
              b = e("./adler32"),
              y = e("./crc32"),
              w = e("./inffast"),
              x = e("./inftrees"),
              _ = 0,
              S = 1,
              C = 2,
              E = 4,
              A = 5,
              T = 6,
              k = 0,
              R = 1,
              I = 2,
              M = -2,
              O = -3,
              P = -4,
              B = -5,
              D = 8,
              L = 1,
              F = 2,
              N = 3,
              U = 4,
              j = 5,
              z = 6,
              H = 7,
              G = 8,
              V = 9,
              q = 10,
              W = 11,
              X = 12,
              Y = 13,
              K = 14,
              Z = 15,
              J = 16,
              Q = 17,
              $ = 18,
              ee = 19,
              te = 20,
              re = 21,
              ne = 22,
              ie = 23,
              ae = 24,
              oe = 25,
              se = 26,
              le = 27,
              ce = 28,
              ue = 29,
              he = 30,
              fe = 31,
              de = 32,
              pe = 852,
              me = 592,
              ge = 15,
              ve = !0;
            r.inflateReset = o, r.inflateReset2 = s, r.inflateResetKeep = a, r.inflateInit = c, r.inflateInit2 = l, r.inflate = f, r.inflateEnd = d, r.inflateGetHeader = p, r.inflateInfo = "pako inflate (from Nodeca project)";
          }, {
            "../utils/common": 27,
            "./adler32": 29,
            "./crc32": 31,
            "./inffast": 34,
            "./inftrees": 36
          }],
          36: [function (e, t, r) {
            "use strict";

            var n = e("../utils/common"),
              i = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
              a = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
              o = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
              s = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
            t.exports = function (e, t, r, l, c, u, h, f) {
              var d,
                p,
                m,
                g,
                v,
                b,
                y,
                w,
                x,
                _ = f.bits,
                S = 0,
                C = 0,
                E = 0,
                A = 0,
                T = 0,
                k = 0,
                R = 0,
                I = 0,
                M = 0,
                O = 0,
                P = null,
                B = 0,
                D = new n.Buf16(16),
                L = new n.Buf16(16),
                F = null,
                N = 0;
              for (S = 0; S <= 15; S++) D[S] = 0;
              for (C = 0; C < l; C++) D[t[r + C]]++;
              for (T = _, A = 15; A >= 1 && 0 === D[A]; A--);
              if (T > A && (T = A), 0 === A) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
              for (E = 1; E < A && 0 === D[E]; E++);
              for (T < E && (T = E), I = 1, S = 1; S <= 15; S++) if (I <<= 1, (I -= D[S]) < 0) return -1;
              if (I > 0 && (0 === e || 1 !== A)) return -1;
              for (L[1] = 0, S = 1; S < 15; S++) L[S + 1] = L[S] + D[S];
              for (C = 0; C < l; C++) 0 !== t[r + C] && (h[L[t[r + C]]++] = C);
              if (0 === e ? (P = F = h, b = 19) : 1 === e ? (P = i, B -= 257, F = a, N -= 257, b = 256) : (P = o, F = s, b = -1), O = 0, C = 0, S = E, v = u, k = T, R = 0, m = -1, M = 1 << T, g = M - 1, 1 === e && M > 852 || 2 === e && M > 592) return 1;
              for (var U = 0;;) {
                U++, y = S - R, h[C] < b ? (w = 0, x = h[C]) : h[C] > b ? (w = F[N + h[C]], x = P[B + h[C]]) : (w = 96, x = 0), d = 1 << S - R, p = 1 << k, E = p;
                do {
                  p -= d, c[v + (O >> R) + p] = y << 24 | w << 16 | x | 0;
                } while (0 !== p);
                for (d = 1 << S - 1; O & d;) d >>= 1;
                if (0 !== d ? (O &= d - 1, O += d) : O = 0, C++, 0 == --D[S]) {
                  if (S === A) break;
                  S = t[r + h[C]];
                }
                if (S > T && (O & g) !== m) {
                  for (0 === R && (R = T), v += E, k = S - R, I = 1 << k; k + R < A && !((I -= D[k + R]) <= 0);) k++, I <<= 1;
                  if (M += 1 << k, 1 === e && M > 852 || 2 === e && M > 592) return 1;
                  m = O & g, c[m] = T << 24 | k << 16 | v - u | 0;
                }
              }
              return 0 !== O && (c[v + O] = S - R << 24 | 64 << 16 | 0), f.bits = T, 0;
            };
          }, {
            "../utils/common": 27
          }],
          37: [function (e, t, r) {
            "use strict";

            t.exports = {
              2: "need dictionary",
              1: "stream end",
              0: "",
              "-1": "file error",
              "-2": "stream error",
              "-3": "data error",
              "-4": "insufficient memory",
              "-5": "buffer error",
              "-6": "incompatible version"
            };
          }, {}],
          38: [function (e, t, r) {
            "use strict";

            function n(e) {
              for (var t = e.length; --t >= 0;) e[t] = 0;
            }
            function i(e) {
              return e < 256 ? ne[e] : ne[256 + (e >>> 7)];
            }
            function a(e, t) {
              e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
            }
            function o(e, t, r) {
              e.bi_valid > q - r ? (e.bi_buf |= t << e.bi_valid & 65535, a(e, e.bi_buf), e.bi_buf = t >> q - e.bi_valid, e.bi_valid += r - q) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
            }
            function s(e, t, r) {
              o(e, r[2 * t], r[2 * t + 1]);
            }
            function l(e, t) {
              var r = 0;
              do {
                r |= 1 & e, e >>>= 1, r <<= 1;
              } while (--t > 0);
              return r >>> 1;
            }
            function c(e) {
              16 === e.bi_valid ? (a(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
            }
            function u(e, t) {
              var r,
                n,
                i,
                a,
                o,
                s,
                l = t.dyn_tree,
                c = t.max_code,
                u = t.stat_desc.static_tree,
                h = t.stat_desc.has_stree,
                f = t.stat_desc.extra_bits,
                d = t.stat_desc.extra_base,
                p = t.stat_desc.max_length,
                m = 0;
              for (a = 0; a <= V; a++) e.bl_count[a] = 0;
              for (l[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < G; r++) n = e.heap[r], a = l[2 * l[2 * n + 1] + 1] + 1, a > p && (a = p, m++), l[2 * n + 1] = a, n > c || (e.bl_count[a]++, o = 0, n >= d && (o = f[n - d]), s = l[2 * n], e.opt_len += s * (a + o), h && (e.static_len += s * (u[2 * n + 1] + o)));
              if (0 !== m) {
                do {
                  for (a = p - 1; 0 === e.bl_count[a];) a--;
                  e.bl_count[a]--, e.bl_count[a + 1] += 2, e.bl_count[p]--, m -= 2;
                } while (m > 0);
                for (a = p; 0 !== a; a--) for (n = e.bl_count[a]; 0 !== n;) (i = e.heap[--r]) > c || (l[2 * i + 1] !== a && (e.opt_len += (a - l[2 * i + 1]) * l[2 * i], l[2 * i + 1] = a), n--);
              }
            }
            function h(e, t, r) {
              var n,
                i,
                a = new Array(V + 1),
                o = 0;
              for (n = 1; n <= V; n++) a[n] = o = o + r[n - 1] << 1;
              for (i = 0; i <= t; i++) {
                var s = e[2 * i + 1];
                0 !== s && (e[2 * i] = l(a[s]++, s));
              }
            }
            function f() {
              var e,
                t,
                r,
                n,
                i,
                a = new Array(V + 1);
              for (r = 0, n = 0; n < N - 1; n++) for (ae[n] = r, e = 0; e < 1 << J[n]; e++) ie[r++] = n;
              for (ie[r - 1] = n, i = 0, n = 0; n < 16; n++) for (oe[n] = i, e = 0; e < 1 << Q[n]; e++) ne[i++] = n;
              for (i >>= 7; n < z; n++) for (oe[n] = i << 7, e = 0; e < 1 << Q[n] - 7; e++) ne[256 + i++] = n;
              for (t = 0; t <= V; t++) a[t] = 0;
              for (e = 0; e <= 143;) te[2 * e + 1] = 8, e++, a[8]++;
              for (; e <= 255;) te[2 * e + 1] = 9, e++, a[9]++;
              for (; e <= 279;) te[2 * e + 1] = 7, e++, a[7]++;
              for (; e <= 287;) te[2 * e + 1] = 8, e++, a[8]++;
              for (h(te, j + 1, a), e = 0; e < z; e++) re[2 * e + 1] = 5, re[2 * e] = l(e, 5);
              se = new ue(te, J, U + 1, j, V), le = new ue(re, Q, 0, z, V), ce = new ue(new Array(0), $, 0, H, W);
            }
            function d(e) {
              var t;
              for (t = 0; t < j; t++) e.dyn_ltree[2 * t] = 0;
              for (t = 0; t < z; t++) e.dyn_dtree[2 * t] = 0;
              for (t = 0; t < H; t++) e.bl_tree[2 * t] = 0;
              e.dyn_ltree[2 * X] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
            }
            function p(e) {
              e.bi_valid > 8 ? a(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
            }
            function m(e, t, r, n) {
              p(e), n && (a(e, r), a(e, ~r)), I.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
            }
            function g(e, t, r, n) {
              var i = 2 * t,
                a = 2 * r;
              return e[i] < e[a] || e[i] === e[a] && n[t] <= n[r];
            }
            function v(e, t, r) {
              for (var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && g(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !g(t, n, e.heap[i], e.depth));) e.heap[r] = e.heap[i], r = i, i <<= 1;
              e.heap[r] = n;
            }
            function b(e, t, r) {
              var n,
                a,
                l,
                c,
                u = 0;
              if (0 !== e.last_lit) do {
                n = e.pending_buf[e.d_buf + 2 * u] << 8 | e.pending_buf[e.d_buf + 2 * u + 1], a = e.pending_buf[e.l_buf + u], u++, 0 === n ? s(e, a, t) : (l = ie[a], s(e, l + U + 1, t), c = J[l], 0 !== c && (a -= ae[l], o(e, a, c)), n--, l = i(n), s(e, l, r), 0 !== (c = Q[l]) && (n -= oe[l], o(e, n, c)));
              } while (u < e.last_lit);
              s(e, X, t);
            }
            function y(e, t) {
              var r,
                n,
                i,
                a = t.dyn_tree,
                o = t.stat_desc.static_tree,
                s = t.stat_desc.has_stree,
                l = t.stat_desc.elems,
                c = -1;
              for (e.heap_len = 0, e.heap_max = G, r = 0; r < l; r++) 0 !== a[2 * r] ? (e.heap[++e.heap_len] = c = r, e.depth[r] = 0) : a[2 * r + 1] = 0;
              for (; e.heap_len < 2;) i = e.heap[++e.heap_len] = c < 2 ? ++c : 0, a[2 * i] = 1, e.depth[i] = 0, e.opt_len--, s && (e.static_len -= o[2 * i + 1]);
              for (t.max_code = c, r = e.heap_len >> 1; r >= 1; r--) v(e, a, r);
              i = l;
              do {
                r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], v(e, a, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, a[2 * i] = a[2 * r] + a[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, a[2 * r + 1] = a[2 * n + 1] = i, e.heap[1] = i++, v(e, a, 1);
              } while (e.heap_len >= 2);
              e.heap[--e.heap_max] = e.heap[1], u(e, t), h(a, c, e.bl_count);
            }
            function w(e, t, r) {
              var n,
                i,
                a = -1,
                o = t[1],
                s = 0,
                l = 7,
                c = 4;
              for (0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++) i = o, o = t[2 * (n + 1) + 1], ++s < l && i === o || (s < c ? e.bl_tree[2 * i] += s : 0 !== i ? (i !== a && e.bl_tree[2 * i]++, e.bl_tree[2 * Y]++) : s <= 10 ? e.bl_tree[2 * K]++ : e.bl_tree[2 * Z]++, s = 0, a = i, 0 === o ? (l = 138, c = 3) : i === o ? (l = 6, c = 3) : (l = 7, c = 4));
            }
            function x(e, t, r) {
              var n,
                i,
                a = -1,
                l = t[1],
                c = 0,
                u = 7,
                h = 4;
              for (0 === l && (u = 138, h = 3), n = 0; n <= r; n++) if (i = l, l = t[2 * (n + 1) + 1], !(++c < u && i === l)) {
                if (c < h) do {
                  s(e, i, e.bl_tree);
                } while (0 != --c);else 0 !== i ? (i !== a && (s(e, i, e.bl_tree), c--), s(e, Y, e.bl_tree), o(e, c - 3, 2)) : c <= 10 ? (s(e, K, e.bl_tree), o(e, c - 3, 3)) : (s(e, Z, e.bl_tree), o(e, c - 11, 7));
                c = 0, a = i, 0 === l ? (u = 138, h = 3) : i === l ? (u = 6, h = 3) : (u = 7, h = 4);
              }
            }
            function _(e) {
              var t;
              for (w(e, e.dyn_ltree, e.l_desc.max_code), w(e, e.dyn_dtree, e.d_desc.max_code), y(e, e.bl_desc), t = H - 1; t >= 3 && 0 === e.bl_tree[2 * ee[t] + 1]; t--);
              return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
            }
            function S(e, t, r, n) {
              var i;
              for (o(e, t - 257, 5), o(e, r - 1, 5), o(e, n - 4, 4), i = 0; i < n; i++) o(e, e.bl_tree[2 * ee[i] + 1], 3);
              x(e, e.dyn_ltree, t - 1), x(e, e.dyn_dtree, r - 1);
            }
            function C(e) {
              var t,
                r = 4093624447;
              for (t = 0; t <= 31; t++, r >>>= 1) if (1 & r && 0 !== e.dyn_ltree[2 * t]) return O;
              if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return P;
              for (t = 32; t < U; t++) if (0 !== e.dyn_ltree[2 * t]) return P;
              return O;
            }
            function E(e) {
              fe || (f(), fe = !0), e.l_desc = new he(e.dyn_ltree, se), e.d_desc = new he(e.dyn_dtree, le), e.bl_desc = new he(e.bl_tree, ce), e.bi_buf = 0, e.bi_valid = 0, d(e);
            }
            function A(e, t, r, n) {
              o(e, (D << 1) + (n ? 1 : 0), 3), m(e, t, r, !0);
            }
            function T(e) {
              o(e, L << 1, 3), s(e, X, te), c(e);
            }
            function k(e, t, r, n) {
              var i,
                a,
                s = 0;
              e.level > 0 ? (e.strm.data_type === B && (e.strm.data_type = C(e)), y(e, e.l_desc), y(e, e.d_desc), s = _(e), i = e.opt_len + 3 + 7 >>> 3, (a = e.static_len + 3 + 7 >>> 3) <= i && (i = a)) : i = a = r + 5, r + 4 <= i && -1 !== t ? A(e, t, r, n) : e.strategy === M || a === i ? (o(e, (L << 1) + (n ? 1 : 0), 3), b(e, te, re)) : (o(e, (F << 1) + (n ? 1 : 0), 3), S(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, s + 1), b(e, e.dyn_ltree, e.dyn_dtree)), d(e), n && p(e);
            }
            function R(e, t, r) {
              return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (ie[r] + U + 1)]++, e.dyn_dtree[2 * i(t)]++), e.last_lit === e.lit_bufsize - 1;
            }
            var I = e("../utils/common"),
              M = 4,
              O = 0,
              P = 1,
              B = 2,
              D = 0,
              L = 1,
              F = 2,
              N = 29,
              U = 256,
              j = U + 1 + N,
              z = 30,
              H = 19,
              G = 2 * j + 1,
              V = 15,
              q = 16,
              W = 7,
              X = 256,
              Y = 16,
              K = 17,
              Z = 18,
              J = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
              Q = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
              $ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
              ee = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
              te = new Array(2 * (j + 2));
            n(te);
            var re = new Array(2 * z);
            n(re);
            var ne = new Array(512);
            n(ne);
            var ie = new Array(256);
            n(ie);
            var ae = new Array(N);
            n(ae);
            var oe = new Array(z);
            n(oe);
            var se,
              le,
              ce,
              ue = function ue(e, t, r, n, i) {
                this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
              },
              he = function he(e, t) {
                this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
              },
              fe = !1;
            r._tr_init = E, r._tr_stored_block = A, r._tr_flush_block = k, r._tr_tally = R, r._tr_align = T;
          }, {
            "../utils/common": 27
          }],
          39: [function (e, t, r) {
            "use strict";

            function n() {
              this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
            }
            t.exports = n;
          }, {}]
        }, {}, [9])(9);
      });
    }).call(t, r(14).Buffer);
  }, function (e, t, r) {
    (function (n, i, a) {
      !function (t) {
        function o() {
          Rc(1200);
        }
        function s(e) {
          for (var t = [], r = 0, n = e.length; r < n; ++r) t[r] = e.charCodeAt(r);
          return t;
        }
        function l(e) {
          for (var t = [], r = 0; r < e.length >> 1; ++r) t[r] = String.fromCharCode(e.charCodeAt(2 * r) + (e.charCodeAt(2 * r + 1) << 8));
          return t.join("");
        }
        function c(e) {
          for (var t = [], r = 0; r < e.length >> 1; ++r) t[r] = String.fromCharCode(e.charCodeAt(2 * r + 1) + (e.charCodeAt(2 * r) << 8));
          return t.join("");
        }
        function u(e) {
          return new (Bc ? i : Array)(e);
        }
        function h(e) {
          return Bc ? new i(e, "binary") : e.split("").map(function (e) {
            return 255 & e.charCodeAt(0);
          });
        }
        function f(e) {
          var t = "number" == typeof e ? Nc._table[e] : e;
          return t = t.replace(zc, "(\\d+)"), new RegExp("^" + t + "$");
        }
        function d(e, t, r) {
          var n = -1,
            i = -1,
            a = -1,
            o = -1,
            s = -1,
            l = -1;
          (t.match(zc) || []).forEach(function (e, t) {
            var c = parseInt(r[t + 1], 10);
            switch (e.toLowerCase().charAt(0)) {
              case "y":
                n = c;
                break;
              case "d":
                a = c;
                break;
              case "h":
                o = c;
                break;
              case "s":
                l = c;
                break;
              case "m":
                o >= 0 ? s = c : i = c;
            }
          }), l >= 0 && -1 == s && i >= 0 && (s = i, i = -1);
          var c = ("" + (n >= 0 ? n : new Date().getFullYear())).slice(-4) + "-" + ("00" + (i >= 1 ? i : 1)).slice(-2) + "-" + ("00" + (a >= 1 ? a : 1)).slice(-2);
          7 == c.length && (c = "0" + c), 8 == c.length && (c = "20" + c);
          var u = ("00" + (o >= 0 ? o : 0)).slice(-2) + ":" + ("00" + (s >= 0 ? s : 0)).slice(-2) + ":" + ("00" + (l >= 0 ? l : 0)).slice(-2);
          return -1 == o && -1 == s && -1 == l ? c : -1 == n && -1 == i && -1 == a ? u : c + "T" + u;
        }
        function p(e) {
          return void 0 !== e && null !== e;
        }
        function m(e) {
          return Object.keys(e);
        }
        function g(e) {
          for (var t = [], r = m(e), n = 0; n !== r.length; ++n) t[e[r[n]]] = r[n];
          return t;
        }
        function v(e) {
          for (var t = [], r = m(e), n = 0; n !== r.length; ++n) t[e[r[n]]] = parseInt(r[n], 10);
          return t;
        }
        function b(e, t) {
          var r = e.getTime();
          return t && (r += 1263168e5), (r - Vc) / 864e5;
        }
        function y(e) {
          var t = new Date();
          return t.setTime(24 * e * 60 * 60 * 1e3 + Vc), t;
        }
        function w(e) {
          var t = 0,
            r = 0,
            n = !1,
            i = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
          if (!i) throw new Error("|" + e + "| is not an ISO8601 Duration");
          for (var a = 1; a != i.length; ++a) if (i[a]) {
            switch (r = 1, a > 3 && (n = !0), i[a].substr(i[a].length - 1)) {
              case "Y":
                throw new Error("Unsupported ISO Duration Field: " + i[a].substr(i[a].length - 1));
              case "D":
                r *= 24;
              case "H":
                r *= 60;
              case "M":
                if (!n) throw new Error("Unsupported ISO Duration Field: M");
                r *= 60;
            }
            t += r * parseInt(i[a], 10);
          }
          return t;
        }
        function x(e, t) {
          var r = new Date(e);
          if (Yc) return t > 0 ? r.setTime(r.getTime() + 60 * r.getTimezoneOffset() * 1e3) : t < 0 && r.setTime(r.getTime() - 60 * r.getTimezoneOffset() * 1e3), r;
          if (e instanceof Date) return e;
          if (1917 == qc.getFullYear() && !isNaN(r.getFullYear())) {
            var n = r.getFullYear();
            return e.indexOf("" + n) > -1 ? r : (r.setFullYear(r.getFullYear() + 100), r);
          }
          var i = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"];
          return new Date(+i[0], +i[1] - 1, +i[2], +i[3] || 0, +i[4] || 0, +i[5] || 0);
        }
        function _(e) {
          for (var t = "", r = 0; r != e.length; ++r) t += String.fromCharCode(e[r]);
          return t;
        }
        function S(e) {
          for (var t = [], r = 0; r != e.length; ++r) t.push(e.charCodeAt(r));
          return t;
        }
        function C(e) {
          if ("undefined" != typeof JSON && !Array.isArray(e)) return JSON.parse(JSON.stringify(e));
          if ("object" != _typeof(e) || null == e) return e;
          var t = {};
          for (var r in e) e.hasOwnProperty(r) && (t[r] = C(e[r]));
          return t;
        }
        function E(e, t) {
          for (var r = ""; r.length < t;) r += e;
          return r;
        }
        function A(e) {
          var t = new Date(e),
            r = new Date(NaN),
            n = t.getYear(),
            i = t.getMonth(),
            a = t.getDate();
          return isNaN(a) ? r : n < 0 || n > 8099 ? r : (i > 0 || a > 1) && 101 != n ? t : e.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/) ? t : e.match(/[a-zA-Z]/) ? r : t;
        }
        function T(e) {
          return e ? e.data ? Ic(e.data) : e.asNodeBuffer && Bc ? Ic(e.asNodeBuffer().toString("binary")) : e.asBinary ? Ic(e.asBinary()) : e._data && e._data.getContent ? Ic(_(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
        }
        function k(e) {
          if (!e) return null;
          if (e.data) return s(e.data);
          if (e.asNodeBuffer && Bc) return e.asNodeBuffer();
          if (e._data && e._data.getContent) {
            var t = e._data.getContent();
            return "string" == typeof t ? S(t) : Array.prototype.slice.call(t);
          }
          return null;
        }
        function R(e) {
          return e && ".bin" === e.name.slice(-4) ? k(e) : T(e);
        }
        function I(e, t) {
          for (var r = m(e.files), n = t.toLowerCase(), i = n.replace(/\//g, "\\"), a = 0; a < r.length; ++a) {
            var o = r[a].toLowerCase();
            if (n == o || i == o) return e.files[r[a]];
          }
          return null;
        }
        function M(e, t) {
          var r = I(e, t);
          if (null == r) throw new Error("Cannot find file " + t + " in zip");
          return r;
        }
        function O(e, t, r) {
          if (!r) return R(M(e, t));
          if (!t) return null;
          try {
            return O(e, t);
          } catch (e) {
            return null;
          }
        }
        function P(e, t, r) {
          if (!r) return T(M(e, t));
          if (!t) return null;
          try {
            return P(e, t);
          } catch (e) {
            return null;
          }
        }
        function B(e, t) {
          var r = t.split("/");
          "/" != t.slice(-1) && r.pop();
          for (var n = e.split("/"); 0 !== n.length;) {
            var i = n.shift();
            ".." === i ? r.pop() : "." !== i && r.push(i);
          }
          return r.join("/");
        }
        function D(e, t) {
          for (var r = {}, n = 0, i = 0; n !== e.length && 32 !== (i = e.charCodeAt(n)) && 10 !== i && 13 !== i; ++n);
          if (t || (r[0] = e.substr(0, n)), n === e.length) return r;
          var a = e.match(Kc),
            o = 0,
            s = "",
            l = 0,
            c = "",
            u = "",
            h = 1;
          if (a) for (l = 0; l != a.length; ++l) {
            for (u = a[l], i = 0; i != u.length && 61 !== u.charCodeAt(i); ++i);
            for (c = u.substr(0, i), h = 34 == (n = u.charCodeAt(i + 1)) || 39 == n ? 1 : 0, s = u.substring(i + 1 + h, u.length - h), o = 0; o != c.length && 58 !== c.charCodeAt(o); ++o);
            if (o === c.length) c.indexOf("_") > 0 && (c = c.substr(0, c.indexOf("_"))), r[c] = s;else {
              var f = (5 === o && "xmlns" === c.substr(0, 5) ? "xmlns" : "") + c.substr(o + 1);
              if (r[f] && "ext" == c.substr(o - 3, 3)) continue;
              r[f] = s;
            }
          }
          return r;
        }
        function L(e) {
          return e.replace(Qc, "<$1");
        }
        function F(e, t) {
          return (e + "").replace(ru, function (e) {
            return eu[e];
          }).replace(nu, function (e) {
            return "_x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + "_";
          });
        }
        function N(e) {
          return F(e).replace(/ /g, "_x0020_");
        }
        function U(e) {
          return (e + "").replace(ru, function (e) {
            return eu[e];
          }).replace(iu, function (e) {
            return "&#x" + ("000" + e.charCodeAt(0).toString(16)).slice(-4) + ";";
          });
        }
        function j(e, t) {
          switch (e) {
            case 1:
            case !0:
            case "1":
            case "true":
            case "TRUE":
              return !0;
            default:
              return !1;
          }
        }
        function z(e) {
          var t = D(e),
            r = e.match(fu(t.baseType)) || [];
          if (r.length != t.size) throw new Error("unexpected vector length " + r.length + " != " + t.size);
          var n = [];
          return r.forEach(function (e) {
            var t = e.replace(du, "").match(pu);
            n.push({
              v: su(t[2]),
              t: t[1]
            });
          }), n;
        }
        function H(e, t) {
          return "<" + e + (t.match(mu) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e + ">";
        }
        function G(e) {
          return m(e).map(function (t) {
            return " " + t + '="' + e[t] + '"';
          }).join("");
        }
        function V(e, t, r) {
          return "<" + e + (p(r) ? G(r) : "") + (p(t) ? (t.match(mu) ? ' xml:space="preserve"' : "") + ">" + t + "</" + e : "/") + ">";
        }
        function q(e, t) {
          try {
            return e.toISOString().replace(/\.\d*/, "");
          } catch (e) {
            if (t) throw e;
          }
          return "";
        }
        function W(e) {
          switch (_typeof(e)) {
            case "string":
              return V("vt:lpwstr", e);
            case "number":
              return V((0 | e) == e ? "vt:i4" : "vt:r8", String(e));
            case "boolean":
              return V("vt:bool", e ? "true" : "false");
          }
          if (e instanceof Date) return V("vt:filetime", q(e));
          throw new Error("Unable to serialize " + e);
        }
        function X(e, t) {
          for (var r = 1 - 2 * (e[t + 7] >>> 7), n = ((127 & e[t + 7]) << 4) + (e[t + 6] >>> 4 & 15), i = 15 & e[t + 6], a = 5; a >= 0; --a) i = 256 * i + e[t + a];
          return 2047 == n ? 0 == i ? r * (1 / 0) : NaN : (0 == n ? n = -1022 : (n -= 1023, i += Math.pow(2, 52)), r * Math.pow(2, n - 52) * i);
        }
        function Y(e, t, r) {
          var n = (t < 0 || 1 / t == -1 / 0 ? 1 : 0) << 7,
            i = 0,
            a = 0,
            o = n ? -t : t;
          isFinite(o) ? (i = Math.floor(Math.log(o) * Math.LOG2E), a = t * Math.pow(2, 52 - i), i <= -1023 && (!isFinite(a) || a < Math.pow(2, 52)) ? i = -1022 : (a -= Math.pow(2, 52), i += 1023)) : (i = 2047, a = isNaN(t) ? 26985 : 0);
          for (var s = 0; s <= 5; ++s, a /= 256) e[r + s] = 255 & a;
          e[r + 6] = (15 & i) << 4 | 15 & a, e[r + 7] = i >> 4 | n;
        }
        function K(e, t) {
          var r,
            n,
            a,
            o,
            s,
            l,
            c = "",
            u = [];
          switch (t) {
            case "dbcs":
              if (l = this.l, Bc && i.isBuffer(this)) c = this.slice(this.l, this.l + 2 * e).toString("utf16le");else for (s = 0; s != e; ++s) c += String.fromCharCode(Nu(this, l)), l += 2;
              e *= 2;
              break;
            case "utf8":
              c = Eu(this, this.l, this.l + e);
              break;
            case "utf16le":
              e *= 2, c = xu(this, this.l, this.l + e);
              break;
            case "wstr":
              if ("undefined" == typeof cptable) return K.call(this, e, "dbcs");
              c = cptable.utils.decode(kc, this.slice(this.l, this.l + 2 * e)), e *= 2;
              break;
            case "lpstr":
              c = Au(this, this.l), e = 5 + c.length;
              break;
            case "lpwstr":
              c = ku(this, this.l), e = 5 + c.length, "\0" == c[c.length - 1] && (e += 2);
              break;
            case "lpp4":
              e = 4 + ju(this, this.l), c = Iu(this, this.l), 2 & e && (e += 2);
              break;
            case "8lpp4":
              e = 4 + ju(this, this.l), c = Ou(this, this.l), 3 & e && (e += 4 - (3 & e));
              break;
            case "cstr":
              for (e = 0, c = ""; 0 !== (a = Fu(this, this.l + e++));) u.push(Mc(a));
              c = u.join("");
              break;
            case "_wstr":
              for (e = 0, c = ""; 0 !== (a = Nu(this, this.l + e));) u.push(Mc(a)), e += 2;
              e += 2, c = u.join("");
              break;
            case "dbcs-cont":
              for (c = "", l = this.l, s = 0; s != e; ++s) {
                if (this.lens && -1 !== this.lens.indexOf(l)) return a = Fu(this, l), this.l = l + 1, o = K.call(this, e - s, a ? "dbcs-cont" : "sbcs-cont"), u.join("") + o;
                u.push(Mc(Nu(this, l))), l += 2;
              }
              c = u.join(""), e *= 2;
              break;
            case "sbcs-cont":
              for (c = "", l = this.l, s = 0; s != e; ++s) {
                if (this.lens && -1 !== this.lens.indexOf(l)) return a = Fu(this, l), this.l = l + 1, o = K.call(this, e - s, a ? "dbcs-cont" : "sbcs-cont"), u.join("") + o;
                u.push(Mc(Fu(this, l))), l += 1;
              }
              c = u.join("");
              break;
            default:
              switch (e) {
                case 1:
                  return r = Fu(this, this.l), this.l++, r;
                case 2:
                  return r = ("i" === t ? Uu : Nu)(this, this.l), this.l += 2, r;
                case 4:
                  return "i" === t || 0 == (128 & this[this.l + 3]) ? (r = zu(this, this.l), this.l += 4, r) : (n = ju(this, this.l), this.l += 4, n);
                case 8:
                  if ("f" === t) return n = Bu(this, this.l), this.l += 8, n;
                case 16:
                  c = Su(this, this.l, e);
              }
          }
          return this.l += e, c;
        }
        function Z(e, t, r) {
          var n = 0,
            i = 0;
          if ("dbcs" === r) {
            for (i = 0; i != t.length; ++i) Hu(this, t.charCodeAt(i), this.l + 2 * i);
            n = 2 * t.length;
          } else if ("sbcs" === r) {
            for (i = 0; i != t.length; ++i) this[this.l + i] = 255 & t.charCodeAt(i);
            n = t.length;
          } else switch (e) {
            case 1:
              n = 1, this[this.l] = 255 & t;
              break;
            case 2:
              n = 2, this[this.l] = 255 & t, t >>>= 8, this[this.l + 1] = 255 & t;
              break;
            case 3:
              n = 3, this[this.l] = 255 & t, t >>>= 8, this[this.l + 1] = 255 & t, t >>>= 8, this[this.l + 2] = 255 & t;
              break;
            case 4:
              n = 4, Gu(this, t, this.l);
              break;
            case 8:
              if (n = 8, "f" === r) {
                Y(this, t, this.l);
                break;
              }
            case 16:
              break;
            case -4:
              n = 4, Vu(this, t, this.l);
          }
          return this.l += n, this;
        }
        function J(e, t) {
          var r = Su(this, this.l, e.length >> 1);
          if (r !== e) throw t + "Expected " + e + " saw " + r;
          this.l += e.length >> 1;
        }
        function Q(e, t) {
          e.l = t, e.read_shift = K, e.chk = J, e.write_shift = Z;
        }
        function $(e, t) {
          e.l += t;
        }
        function ee(e) {
          var t = u(e);
          return Q(t, 0), t;
        }
        function te(e, t, r) {
          if (e) {
            var n, i, a;
            Q(e, e.l || 0);
            for (var o = e.length, s = 0, l = 0; e.l < o;) {
              s = e.read_shift(1), 128 & s && (s = (127 & s) + ((127 & e.read_shift(1)) << 7));
              var c = Sy[s] || Sy[65535];
              for (n = e.read_shift(1), a = 127 & n, i = 1; i < 4 && 128 & n; ++i) a += (127 & (n = e.read_shift(1))) << 7 * i;
              l = e.l + a;
              var u = c.f(e, a, r);
              if (e.l = l, t(u, c.n, s)) return;
            }
          }
        }
        function re() {
          var e = [],
            t = function t(e) {
              var t = ee(e);
              return Q(t, 0), t;
            },
            r = t(2048),
            n = function n() {
              r && (r.length > r.l && (r = r.slice(0, r.l)), r.length > 0 && e.push(r), r = null);
            },
            i = function i(e) {
              return r && e < r.length - r.l ? r : (n(), r = t(Math.max(e + 1, 2048)));
            },
            a = function a() {
              return n(), bu([e]);
            };
          return {
            next: i,
            push: function push(e) {
              n(), r = e, i(2048);
            },
            end: a,
            _bufs: e
          };
        }
        function ne(e, t, r, n) {
          var i,
            a = Number(Cy[t]);
          if (!isNaN(a)) {
            n || (n = Sy[a].p || (r || []).length || 0), i = 1 + (a >= 128 ? 1 : 0) + 1 + n, n >= 128 && ++i, n >= 16384 && ++i, n >= 2097152 && ++i;
            var o = e.next(i);
            a <= 127 ? o.write_shift(1, a) : (o.write_shift(1, 128 + (127 & a)), o.write_shift(1, a >> 7));
            for (var s = 0; 4 != s; ++s) {
              if (!(n >= 128)) {
                o.write_shift(1, n);
                break;
              }
              o.write_shift(1, 128 + (127 & n)), n >>= 7;
            }
            n > 0 && Lu(r) && e.push(r);
          }
        }
        function ie(e, t, r) {
          var n = C(e);
          if (t.s ? (n.cRel && (n.c += t.s.c), n.rRel && (n.r += t.s.r)) : (n.c += t.c, n.r += t.r), !r || r.biff < 12) {
            for (; n.c >= 256;) n.c -= 256;
            for (; n.r >= 65536;) n.r -= 65536;
          }
          return n;
        }
        function ae(e, t, r) {
          var n = C(e);
          return n.s = ie(n.s, t.s, r), n.e = ie(n.e, t.s, r), n;
        }
        function oe(e) {
          var t = be(e);
          return 0 === e.cRel && (t = pe(t)), 0 === e.rRel && (t = ue(t)), t;
        }
        function se(e, t) {
          return 0 != e.s.r || e.s.rRel || e.e.r != (t.biff >= 12 ? 1048575 : 65535) || e.e.rRel ? 0 != e.s.c || e.s.cRel || e.e.c != (t.biff >= 12 ? 65535 : 255) || e.e.cRel ? oe(e.s) + ":" + oe(e.e) : (e.s.rRel ? "" : "$") + ce(e.s.r) + ":" + (e.e.rRel ? "" : "$") + ce(e.e.r) : (e.s.cRel ? "" : "$") + de(e.s.c) + ":" + (e.e.cRel ? "" : "$") + de(e.e.c);
        }
        function le(e) {
          return parseInt(he(e), 10) - 1;
        }
        function ce(e) {
          return "" + (e + 1);
        }
        function ue(e) {
          return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
        }
        function he(e) {
          return e.replace(/\$(\d+)$/, "$1");
        }
        function fe(e) {
          for (var t = me(e), r = 0, n = 0; n !== t.length; ++n) r = 26 * r + t.charCodeAt(n) - 64;
          return r - 1;
        }
        function de(e) {
          var t = "";
          for (++e; e; e = Math.floor((e - 1) / 26)) t = String.fromCharCode((e - 1) % 26 + 65) + t;
          return t;
        }
        function pe(e) {
          return e.replace(/^([A-Z])/, "$$$1");
        }
        function me(e) {
          return e.replace(/^\$([A-Z])/, "$1");
        }
        function ge(e) {
          return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
        }
        function ve(e) {
          var t = ge(e);
          return {
            c: fe(t[0]),
            r: le(t[1])
          };
        }
        function be(e) {
          return de(e.c) + ce(e.r);
        }
        function ye(e) {
          var t = e.split(":").map(ve);
          return {
            s: t[0],
            e: t[t.length - 1]
          };
        }
        function we(e, t) {
          return void 0 === t || "number" == typeof t ? we(e.s, e.e) : ("string" != typeof e && (e = be(e)), "string" != typeof t && (t = be(t)), e == t ? e : e + ":" + t);
        }
        function xe(e) {
          var t = {
              s: {
                c: 0,
                r: 0
              },
              e: {
                c: 0,
                r: 0
              }
            },
            r = 0,
            n = 0,
            i = 0,
            a = e.length;
          for (r = 0; n < a && !((i = e.charCodeAt(n) - 64) < 1 || i > 26); ++n) r = 26 * r + i;
          for (t.s.c = --r, r = 0; n < a && !((i = e.charCodeAt(n) - 48) < 0 || i > 9); ++n) r = 10 * r + i;
          if (t.s.r = --r, n === a || 58 === e.charCodeAt(++n)) return t.e.c = t.s.c, t.e.r = t.s.r, t;
          for (r = 0; n != a && !((i = e.charCodeAt(n) - 64) < 1 || i > 26); ++n) r = 26 * r + i;
          for (t.e.c = --r, r = 0; n != a && !((i = e.charCodeAt(n) - 48) < 0 || i > 9); ++n) r = 10 * r + i;
          return t.e.r = --r, t;
        }
        function _e(e, t) {
          var r = "d" == e.t && t instanceof Date;
          if (null != e.z) try {
            return e.w = Nc.format(e.z, r ? b(t) : t);
          } catch (e) {}
          try {
            return e.w = Nc.format((e.XF || {}).numFmtId || (r ? 14 : 0), r ? b(t) : t);
          } catch (e) {
            return "" + t;
          }
        }
        function Se(e, t, r) {
          return null == e || null == e.t || "z" == e.t ? "" : void 0 !== e.w ? e.w : ("d" == e.t && !e.z && r && r.dateNF && (e.z = r.dateNF), void 0 == t ? _e(e, e.v) : _e(e, t));
        }
        function Ce(e, t) {
          var r = t && t.sheet ? t.sheet : "Sheet1",
            n = {};
          return n[r] = e, {
            SheetNames: [r],
            Sheets: n
          };
        }
        function Ee(e, t) {
          var r = t || {};
          null != Oc && null == r.dense && (r.dense = Oc);
          for (var n = r.dense ? [] : {}, i = {
              s: {
                c: 1e7,
                r: 1e7
              },
              e: {
                c: 0,
                r: 0
              }
            }, a = 0; a != e.length; ++a) for (var o = 0; o != e[a].length; ++o) if (void 0 !== e[a][o]) {
            var s = {
              v: e[a][o]
            };
            if (Array.isArray(s.v) && (s.f = e[a][o][1], s.v = s.v[0]), i.s.r > a && (i.s.r = a), i.s.c > o && (i.s.c = o), i.e.r < a && (i.e.r = a), i.e.c < o && (i.e.c = o), null === s.v) {
              if (s.f) s.t = "n";else {
                if (!r.cellStubs) continue;
                s.t = "z";
              }
            } else "number" == typeof s.v ? s.t = "n" : "boolean" == typeof s.v ? s.t = "b" : s.v instanceof Date ? (s.z = r.dateNF || Nc._table[14], r.cellDates ? (s.t = "d", s.w = Nc.format(s.z, b(s.v))) : (s.t = "n", s.v = b(s.v), s.w = Nc.format(s.z, s.v))) : s.t = "s";
            if (r.dense) n[a] || (n[a] = []), n[a][o] = s;else {
              var l = be({
                c: o,
                r: a
              });
              n[l] = s;
            }
          }
          return i.s.c < 1e7 && (n["!ref"] = we(i)), n;
        }
        function Ae(e, t) {
          return t || (t = ee(4)), t.write_shift(4, e), t;
        }
        function Te(e) {
          var t = e.read_shift(4);
          return 0 === t ? "" : e.read_shift(t, "dbcs");
        }
        function ke(e, t) {
          var r = !1;
          return null == t && (r = !0, t = ee(4 + 2 * e.length)), t.write_shift(4, e.length), e.length > 0 && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
        }
        function Re(e, t) {
          return {
            ich: e.read_shift(2),
            ifnt: e.read_shift(2)
          };
        }
        function Ie(e, t) {
          return t || (t = ee(4)), t.write_shift(2, e.ich || 0), t.write_shift(2, e.ifnt || 0), t;
        }
        function Me(e, t) {
          var r = e.l,
            n = e.read_shift(1),
            i = Te(e),
            a = [],
            o = {
              t: i,
              h: i
            };
          if (0 != (1 & n)) {
            for (var s = e.read_shift(4), l = 0; l != s; ++l) a.push(Re(e));
            o.r = a;
          } else o.r = [{
            ich: 0,
            ifnt: 0
          }];
          return e.l = r + t, o;
        }
        function Oe(e, t) {
          var r = !1;
          return null == t && (r = !0, t = ee(15 + 4 * e.t.length)), t.write_shift(1, 0), ke(e.t, t), r ? t.slice(0, t.l) : t;
        }
        function Pe(e, t) {
          var r = !1;
          return null == t && (r = !0, t = ee(23 + 4 * e.t.length)), t.write_shift(1, 1), ke(e.t, t), t.write_shift(4, 1), Ie({
            ich: 0,
            ifnt: 0
          }, t), r ? t.slice(0, t.l) : t;
        }
        function Be(e) {
          var t = e.read_shift(4),
            r = e.read_shift(2);
          r += e.read_shift(1) << 16;
          e.read_shift(1);
          return {
            c: t,
            iStyleRef: r
          };
        }
        function De(e, t) {
          return null == t && (t = ee(8)), t.write_shift(-4, e.c), t.write_shift(3, e.iStyleRef || e.s), t.write_shift(1, 0), t;
        }
        function Le(e) {
          var t = e.read_shift(4);
          return 0 === t || 4294967295 === t ? "" : e.read_shift(t, "dbcs");
        }
        function Fe(e, t) {
          var r = !1;
          return null == t && (r = !0, t = ee(127)), t.write_shift(4, e.length > 0 ? e.length : 4294967295), e.length > 0 && t.write_shift(0, e, "dbcs"), r ? t.slice(0, t.l) : t;
        }
        function Ne(e) {
          var t = e.slice(e.l, e.l + 4),
            r = 1 & t[0],
            n = 2 & t[0];
          e.l += 4, t[0] &= 252;
          var i = 0 === n ? Bu([0, 0, 0, 0, t[0], t[1], t[2], t[3]], 0) : zu(t, 0) >> 2;
          return r ? i / 100 : i;
        }
        function Ue(e, t) {
          null == t && (t = ee(4));
          var r = 0,
            n = 0,
            i = 100 * e;
          if (e == (0 | e) && e >= -(1 << 29) && e < 1 << 29 ? n = 1 : i == (0 | i) && i >= -(1 << 29) && i < 1 << 29 && (n = 1, r = 1), !n) throw new Error("unsupported RkNumber " + e);
          t.write_shift(-4, ((r ? i : e) << 2) + (r + 2));
        }
        function je(e) {
          var t = {
            s: {},
            e: {}
          };
          return t.s.r = e.read_shift(4), t.e.r = e.read_shift(4), t.s.c = e.read_shift(4), t.e.c = e.read_shift(4), t;
        }
        function ze(e, t) {
          return t || (t = ee(16)), t.write_shift(4, e.s.r), t.write_shift(4, e.e.r), t.write_shift(4, e.s.c), t.write_shift(4, e.e.c), t;
        }
        function He(e, t) {
          return e.read_shift(8, "f");
        }
        function Ge(e, t) {
          return (t || ee(8)).write_shift(8, e, "f");
        }
        function Ve(e, t) {
          var r = {},
            n = e.read_shift(1),
            i = n >>> 1,
            a = e.read_shift(1),
            o = e.read_shift(2, "i"),
            s = e.read_shift(1),
            l = e.read_shift(1),
            c = e.read_shift(1);
          e.read_shift(1);
          switch (i) {
            case 0:
              r.auto = 1;
              break;
            case 1:
              r.index = a;
              var u = fh[a];
              u && (r.rgb = Dn(u));
              break;
            case 2:
              r.rgb = Dn([s, l, c]);
              break;
            case 3:
              r.theme = a;
          }
          return 0 != o && (r.tint = o > 0 ? o / 32767 : o / 32768), r;
        }
        function qe(e, t) {
          if (t || (t = ee(8)), !e || e.auto) return t.write_shift(4, 0), t.write_shift(4, 0), t;
          e.index ? (t.write_shift(1, 2), t.write_shift(1, e.index)) : e.theme ? (t.write_shift(1, 6), t.write_shift(1, e.theme)) : (t.write_shift(1, 5), t.write_shift(1, 0));
          var r = e.tint || 0;
          if (r > 0 ? r *= 32767 : r < 0 && (r *= 32768), t.write_shift(2, r), e.rgb) {
            var n = e.rgb || "FFFFFF";
            t.write_shift(1, parseInt(n.substr(0, 2), 16)), t.write_shift(1, parseInt(n.substr(2, 2), 16)), t.write_shift(1, parseInt(n.substr(4, 2), 16)), t.write_shift(1, 255);
          } else t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0);
          return t;
        }
        function We(e, t, r) {
          var n = e.read_shift(1);
          return e.l++, {
            fItalic: 2 & n,
            fStrikeout: 8 & n,
            fOutline: 16 & n,
            fShadow: 32 & n,
            fCondense: 64 & n,
            fExtend: 128 & n
          };
        }
        function Xe(e, t) {
          t || (t = ee(2));
          var r = (e.italic ? 2 : 0) | (e.strike ? 8 : 0) | (e.outline ? 16 : 0) | (e.shadow ? 32 : 0) | (e.condense ? 64 : 0) | (e.extend ? 128 : 0);
          return t.write_shift(1, r), t.write_shift(1, 0), t;
        }
        function Ye() {
          return {
            workbooks: [],
            sheets: [],
            charts: [],
            dialogs: [],
            macros: [],
            rels: [],
            strs: [],
            comments: [],
            links: [],
            coreprops: [],
            extprops: [],
            custprops: [],
            themes: [],
            styles: [],
            calcchains: [],
            vba: [],
            drawings: [],
            TODO: [],
            xmlns: ""
          };
        }
        function Ke(e, t) {
          var r = Ye();
          if (!e || !e.match) return r;
          var n = {};
          if ((e.match(Zc) || []).forEach(function (e) {
            var t = D(e);
            switch (t[0].replace(Jc, "<")) {
              case "<?xml":
                break;
              case "<Types":
                r.xmlns = t["xmlns" + (t[0].match(/<(\w+):/) || ["", ""])[1]];
                break;
              case "<Default":
                n[t.Extension] = t.ContentType;
                break;
              case "<Override":
                void 0 !== r[dh[t.ContentType]] && r[dh[t.ContentType]].push(t.PartName);
            }
          }), r.xmlns !== vu.CT) throw new Error("Unknown Namespace: " + r.xmlns);
          return r.calcchain = r.calcchains.length > 0 ? r.calcchains[0] : "", r.sst = r.strs.length > 0 ? r.strs[0] : "", r.style = r.styles.length > 0 ? r.styles[0] : "", r.defaults = n, delete r.calcchains, r;
        }
        function Ze(e, t) {
          var r,
            n = [];
          n[n.length] = gu, n[n.length] = gh, n = n.concat(vh);
          var i = function i(_i2) {
              e[_i2] && e[_i2].length > 0 && (r = e[_i2][0], n[n.length] = V("Override", null, {
                PartName: ("/" == r[0] ? "" : "/") + r,
                ContentType: ph[_i2][t.bookType || "xlsx"]
              }));
            },
            a = function a(r) {
              (e[r] || []).forEach(function (e) {
                n[n.length] = V("Override", null, {
                  PartName: ("/" == e[0] ? "" : "/") + e,
                  ContentType: ph[r][t.bookType || "xlsx"]
                });
              });
            },
            o = function o(t) {
              (e[t] || []).forEach(function (e) {
                n[n.length] = V("Override", null, {
                  PartName: ("/" == e[0] ? "" : "/") + e,
                  ContentType: mh[t][0]
                });
              });
            };
          return i("workbooks"), a("sheets"), a("charts"), o("themes"), ["strs", "styles"].forEach(i), ["coreprops", "extprops", "custprops"].forEach(o), o("vba"), o("comments"), o("drawings"), n.length > 2 && (n[n.length] = "</Types>", n[1] = n[1].replace("/>", ">")), n.join("");
        }
        function Je(e) {
          var t = e.lastIndexOf("/");
          return e.substr(0, t + 1) + "_rels/" + e.substr(t + 1) + ".rels";
        }
        function Qe(e, t) {
          if (!e) return e;
          "/" !== t.charAt(0) && (t = "/" + t);
          var r = {},
            n = {};
          return (e.match(Zc) || []).forEach(function (e) {
            var i = D(e);
            if ("<Relationship" === i[0]) {
              var a = {};
              a.Type = i.Type, a.Target = i.Target, a.Id = i.Id, a.TargetMode = i.TargetMode;
              var o = "External" === i.TargetMode ? i.Target : B(i.Target, t);
              r[o] = a, n[i.Id] = a;
            }
          }), r["!id"] = n, r;
        }
        function $e(e) {
          var t = [gu, yh];
          return m(e["!id"]).forEach(function (r) {
            t[t.length] = V("Relationship", null, e["!id"][r]);
          }), t.length > 2 && (t[t.length] = "</Relationships>", t[1] = t[1].replace("/>", ">")), t.join("");
        }
        function et(e, t, r, n, i) {
          if (i || (i = {}), e["!id"] || (e["!id"] = {}), t < 0) for (t = 1; e["!id"]["rId" + t]; ++t);
          if (i.Id = "rId" + t, i.Type = n, i.Target = r, i.Type == bh.HLINK && (i.TargetMode = "External"), e["!id"][i.Id]) throw new Error("Cannot rewrite rId " + t);
          return e["!id"][i.Id] = i, e[("/" + i.Target).replace("//", "/")] = i, t;
        }
        function tt(e, t) {
          for (var r, n, i = vl(e); r = _y.exec(i);) switch (r[3]) {
            case "manifest":
              break;
            case "file-entry":
              if (n = D(r[0], !1), "/" == n.path && n.type !== wh) throw new Error("This OpenDocument is not a spreadsheet");
              break;
            case "encryption-data":
            case "algorithm":
            case "start-key-generation":
            case "key-derivation":
              throw new Error("Unsupported ODS Encryption");
            default:
              if (t && t.WTF) throw r;
          }
        }
        function rt(e, t) {
          var r = [gu];
          r.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n'), r.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
          for (var n = 0; n < e.length; ++n) r.push('  <manifest:file-entry manifest:full-path="' + e[n][0] + '" manifest:media-type="' + e[n][1] + '"/>\n');
          return r.push("</manifest:manifest>"), r.join("");
        }
        function nt(e, t, r) {
          return ['  <rdf:Description rdf:about="' + e + '">\n', '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (r || "odf") + "#" + t + '"/>\n', "  </rdf:Description>\n"].join("");
        }
        function it(e, t) {
          return ['  <rdf:Description rdf:about="' + e + '">\n', '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + t + '"/>\n', "  </rdf:Description>\n"].join("");
        }
        function at(e, t) {
          var r = [gu];
          r.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
          for (var n = 0; n != e.length; ++n) r.push(nt(e[n][0], e[n][1])), r.push(it("", e[n][0]));
          return r.push(nt("", "Document", "pkg")), r.push("</rdf:RDF>"), r.join("");
        }
        function ot(e) {
          for (var t = {}, r = 0; r < _h.length; ++r) {
            var n = _h[r],
              i = e.match(Sh[r]);
            null != i && i.length > 0 && (t[n[1]] = i[1]), "date" === n[2] && t[n[1]] && (t[n[1]] = x(t[n[1]]));
          }
          return t;
        }
        function st(e, t, r, n, i) {
          null == i[e] && null != t && "" !== t && (i[e] = t, n[n.length] = r ? V(e, t, r) : H(e, t));
        }
        function lt(e, t) {
          var r = t || {},
            n = [gu, Ch],
            i = {};
          if (!e && !r.Props) return n.join("");
          e && (null != e.CreatedDate && st("dcterms:created", "string" == typeof e.CreatedDate ? e.CreatedDate : q(e.CreatedDate, r.WTF), {
            "xsi:type": "dcterms:W3CDTF"
          }, n, i), null != e.ModifiedDate && st("dcterms:modified", "string" == typeof e.ModifiedDate ? e.ModifiedDate : q(e.ModifiedDate, r.WTF), {
            "xsi:type": "dcterms:W3CDTF"
          }, n, i));
          for (var a = 0; a != _h.length; ++a) {
            var o = _h[a],
              s = r.Props && null != r.Props[o[1]] ? r.Props[o[1]] : e ? e[o[1]] : null;
            !0 === s ? s = "1" : !1 === s ? s = "0" : "number" == typeof s && (s = String(s)), null != s && st(o[0], s, null, n, i);
          }
          return n.length > 2 && (n[n.length] = "</cp:coreProperties>", n[1] = n[1].replace("/>", ">")), n.join("");
        }
        function ct(e, t) {
          var r = {};
          if (t || (t = {}), Eh.forEach(function (n) {
            switch (n[2]) {
              case "string":
                t[n[1]] = (e.match(hu(n[0])) || [])[1];
                break;
              case "bool":
                t[n[1]] = "true" === (e.match(hu(n[0])) || [])[1];
                break;
              case "raw":
                var i = e.match(new RegExp("<" + n[0] + "[^>]*>([\\s\\S]*?)</" + n[0] + ">"));
                i && i.length > 0 && (r[n[1]] = i[1]);
            }
          }), r.HeadingPairs && r.TitlesOfParts) for (var n = z(r.HeadingPairs), i = z(r.TitlesOfParts).map(function (e) {
              return e.v;
            }), a = 0, o = 0, s = 0; s !== n.length; s += 2) {
            switch (o = +n[s + 1].v, n[s].v) {
              case "Worksheets":
              case "工作表":
              case "Листы":
              case "أوراق العمل":
              case "ワークシート":
              case "גליונות עבודה":
              case "Arbeitsblätter":
              case "Çalışma Sayfaları":
              case "Feuilles de calcul":
              case "Fogli di lavoro":
              case "Folhas de cálculo":
              case "Planilhas":
              case "Regneark":
              case "Werkbladen":
                t.Worksheets = o, t.SheetNames = i.slice(a, a + o);
                break;
              case "Named Ranges":
              case "名前付き一覧":
              case "Benannte Bereiche":
              case "Navngivne områder":
                t.NamedRanges = o, t.DefinedNames = i.slice(a, a + o);
                break;
              case "Charts":
              case "Diagramme":
                t.Chartsheets = o, t.ChartNames = i.slice(a, a + o);
            }
            a += o;
          }
          return t;
        }
        function ut(e, t) {
          var r = [],
            n = V;
          return e || (e = {}), e.Application = "SheetJS", r[r.length] = gu, r[r.length] = Ah, Eh.forEach(function (t) {
            if (void 0 !== e[t[1]]) {
              var i;
              switch (t[2]) {
                case "string":
                  i = String(e[t[1]]);
                  break;
                case "bool":
                  i = e[t[1]] ? "true" : "false";
              }
              void 0 !== i && (r[r.length] = n(t[0], i));
            }
          }), r[r.length] = n("HeadingPairs", n("vt:vector", n("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + n("vt:variant", n("vt:i4", String(e.Worksheets))), {
            size: 2,
            baseType: "variant"
          })), r[r.length] = n("TitlesOfParts", n("vt:vector", e.SheetNames.map(function (e) {
            return "<vt:lpstr>" + F(e) + "</vt:lpstr>";
          }).join(""), {
            size: e.Worksheets,
            baseType: "lpstr"
          })), r.length > 2 && (r[r.length] = "</Properties>", r[1] = r[1].replace("/>", ">")), r.join("");
        }
        function ht(e, t) {
          var r = {},
            n = "",
            i = e.match(Th);
          if (i) for (var a = 0; a != i.length; ++a) {
            var o = i[a],
              s = D(o);
            switch (s[0]) {
              case "<?xml":
              case "<Properties":
                break;
              case "<property":
                n = s.name;
                break;
              case "</property>":
                n = null;
                break;
              default:
                if (0 === o.indexOf("<vt:")) {
                  var l = o.split(">"),
                    c = l[0].substring(4),
                    u = l[1];
                  switch (c) {
                    case "lpstr":
                    case "bstr":
                    case "lpwstr":
                      r[n] = tu(u);
                      break;
                    case "bool":
                      r[n] = j(u, "<vt:bool>");
                      break;
                    case "i1":
                    case "i2":
                    case "i4":
                    case "i8":
                    case "int":
                    case "uint":
                      r[n] = parseInt(u, 10);
                      break;
                    case "r4":
                    case "r8":
                    case "decimal":
                      r[n] = parseFloat(u);
                      break;
                    case "filetime":
                    case "date":
                      r[n] = x(u);
                      break;
                    case "cy":
                    case "error":
                      r[n] = tu(u);
                      break;
                    default:
                      if ("/" == c.slice(-1)) break;
                      t.WTF && "undefined" != typeof console && console.warn("Unexpected", o, c, l);
                  }
                } else if ("</" === o.substr(0, 2)) ;else if (t.WTF) throw new Error(o);
            }
          }
          return r;
        }
        function ft(e, t) {
          var r = [gu, kh];
          if (!e) return r.join("");
          var n = 1;
          return m(e).forEach(function (t) {
            ++n, r[r.length] = V("property", W(e[t]), {
              fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
              pid: n,
              name: t
            });
          }), r.length > 2 && (r[r.length] = "</Properties>", r[1] = r[1].replace("/>", ">")), r.join("");
        }
        function dt(e, t, r) {
          t = Ih[t] || t, e[t] = r;
        }
        function pt(e, t) {
          var r = [];
          return m(Rh).map(function (e) {
            for (var t = 0; t < _h.length; ++t) if (_h[t][1] == e) return _h[t];
            for (t = 0; t < Eh.length; ++t) if (Eh[t][1] == e) return Eh[t];
            throw e;
          }).forEach(function (n) {
            if (null != e[n[1]]) {
              var i = t && t.Props && null != t.Props[n[1]] ? t.Props[n[1]] : e[n[1]];
              switch (n[2]) {
                case "date":
                  i = new Date(i).toISOString().replace(/\.\d*Z/, "Z");
              }
              "number" == typeof i ? i = String(i) : !0 === i || !1 === i ? i = i ? "1" : "0" : i instanceof Date && (i = new Date(i).toISOString().replace(/\.\d*Z/, "")), r.push(H(Rh[n[1]] || n[1], i));
            }
          }), V("DocumentProperties", r.join(""), {
            xmlns: wu.o
          });
        }
        function mt(e, t, r) {
          var n = ["Worksheets", "SheetNames"],
            i = "CustomDocumentProperties",
            a = [];
          return e && m(e).forEach(function (t) {
            if (e.hasOwnProperty(t)) {
              for (var r = 0; r < _h.length; ++r) if (t == _h[r][1]) return;
              for (r = 0; r < Eh.length; ++r) if (t == Eh[r][1]) return;
              for (r = 0; r < n.length; ++r) if (t == n[r]) return;
              var i = e[t],
                o = "string";
              "number" == typeof i ? (o = "float", i = String(i)) : !0 === i || !1 === i ? (o = "boolean", i = i ? "1" : "0") : i = String(i), a.push(V(N(t), i, {
                "dt:dt": o
              }));
            }
          }), t && m(t).forEach(function (e) {
            if (t.hasOwnProperty(e)) {
              var r = t[e],
                n = "string";
              "number" == typeof r ? (n = "float", r = String(r)) : !0 === r || !1 === r ? (n = "boolean", r = r ? "1" : "0") : r instanceof Date ? (n = "dateTime.tz", r = r.toISOString()) : r = String(r), a.push(V(N(e), r, {
                "dt:dt": n
              }));
            }
          }), "<" + i + ' xmlns="' + wu.o + '">' + a.join("") + "</" + i + ">";
        }
        function gt(e) {
          var t = e.read_shift(4),
            r = e.read_shift(4);
          return new Date(1e3 * (r / 1e7 * Math.pow(2, 32) + t / 1e7 - 11644473600)).toISOString().replace(/\.000/, "");
        }
        function vt(e, t, r) {
          var n = e.read_shift(0, "lpstr");
          return r && (e.l += 4 - (n.length + 1 & 3) & 3), n;
        }
        function bt(e, t, r) {
          var n = e.read_shift(0, "lpwstr");
          return r && (e.l += 4 - (n.length + 1 & 3) & 3), n;
        }
        function yt(e, t, r) {
          return 31 === t ? bt(e) : vt(e, t, r);
        }
        function wt(e, t, r) {
          return yt(e, t, !1 === r ? 0 : 4);
        }
        function xt(e, t) {
          if (!t) throw new Error("dafuq?");
          return yt(e, t, 0);
        }
        function _t(e) {
          for (var t = e.read_shift(4), r = [], n = 0; n != t; ++n) r[n] = e.read_shift(0, "lpstr");
          return r;
        }
        function St(e) {
          return _t(e);
        }
        function Ct(e) {
          return [It(e, ah), It(e, nh)];
        }
        function Et(e) {
          for (var t = e.read_shift(4), r = [], n = 0; n != t / 2; ++n) r.push(Ct(e));
          return r;
        }
        function At(e) {
          return Et(e);
        }
        function Tt(e, t) {
          for (var r = e.read_shift(4), n = {}, i = 0; i != r; ++i) {
            var a = e.read_shift(4),
              o = e.read_shift(4);
            n[a] = e.read_shift(o, 1200 === t ? "utf16le" : "utf8").replace(Lc, "").replace(Fc, "!");
          }
          return 3 & e.l && (e.l = e.l >> 3 << 2), n;
        }
        function kt(e) {
          var t = e.read_shift(4),
            r = e.slice(e.l, e.l + t);
          return (3 & t) > 0 && (e.l += 4 - (3 & t) & 3), r;
        }
        function Rt(e) {
          var t = {};
          return t.Size = e.read_shift(4), e.l += t.Size, t;
        }
        function It(e, t, r) {
          var n,
            i = e.read_shift(2),
            a = r || {};
          if (e.l += 2, t !== ih && i !== t && -1 === oh.indexOf(t)) throw new Error("Expected type " + t + " saw " + i);
          switch (t === ih ? i : t) {
            case 2:
              return n = e.read_shift(2, "i"), a.raw || (e.l += 2), n;
            case 3:
              return n = e.read_shift(4, "i");
            case 11:
              return 0 !== e.read_shift(4);
            case 19:
              return n = e.read_shift(4);
            case 30:
              return vt(e, i, 4).replace(Lc, "");
            case 31:
              return bt(e);
            case 64:
              return gt(e);
            case 65:
              return kt(e);
            case 71:
              return Rt(e);
            case 80:
              return wt(e, i, !a.raw && 4).replace(Lc, "");
            case 81:
              return xt(e, i).replace(Lc, "");
            case 4108:
              return At(e);
            case 4126:
              return St(e);
            default:
              throw new Error("TypedPropertyValue unrecognized type " + t + " " + i);
          }
        }
        function Mt(e, t) {
          var r = e.l,
            n = e.read_shift(4),
            i = e.read_shift(4),
            a = [],
            o = 0,
            s = 0,
            l = -1,
            c = {};
          for (o = 0; o != i; ++o) {
            var u = e.read_shift(4),
              h = e.read_shift(4);
            a[o] = [u, h + r];
          }
          var f = {};
          for (o = 0; o != i; ++o) {
            if (e.l !== a[o][1]) {
              var d = !0;
              if (o > 0 && t) switch (t[a[o - 1][0]].t) {
                case 2:
                  e.l + 2 === a[o][1] && (e.l += 2, d = !1);
                  break;
                case 80:
                case 4108:
                  e.l <= a[o][1] && (e.l = a[o][1], d = !1);
              }
              if (!t && e.l <= a[o][1] && (d = !1, e.l = a[o][1]), d) throw new Error("Read Error: Expected address " + a[o][1] + " at " + e.l + " :" + o);
            }
            if (t) {
              var p = t[a[o][0]];
              if (f[p.n] = It(e, p.t, {
                raw: !0
              }), "version" === p.p && (f[p.n] = String(f[p.n] >> 16) + "." + String(65535 & f[p.n])), "CodePage" == p.n) switch (f[p.n]) {
                case 0:
                  f[p.n] = 1252;
                case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 1e4:
                case 1200:
                case 1201:
                case 1252:
                case 65e3:
                case -536:
                case 65001:
                case -535:
                  Rc(s = f[p.n]);
                  break;
                default:
                  throw new Error("Unsupported CodePage: " + f[p.n]);
              }
            } else if (1 === a[o][0]) {
              if (s = f.CodePage = It(e, rh), Rc(s), -1 !== l) {
                var m = e.l;
                e.l = a[l][1], c = Tt(e, s), e.l = m;
              }
            } else if (0 === a[o][0]) {
              if (0 === s) {
                l = o, e.l = a[o + 1][1];
                continue;
              }
              c = Tt(e, s);
            } else {
              var g,
                v = c[a[o][0]];
              switch (e[e.l]) {
                case 65:
                  e.l += 4, g = kt(e);
                  break;
                case 30:
                case 31:
                  e.l += 4, g = wt(e, e[e.l - 4]);
                  break;
                case 3:
                  e.l += 4, g = e.read_shift(4, "i");
                  break;
                case 19:
                  e.l += 4, g = e.read_shift(4);
                  break;
                case 5:
                  e.l += 4, g = e.read_shift(8, "f");
                  break;
                case 11:
                  e.l += 4, g = Dt(e, 4);
                  break;
                case 64:
                  e.l += 4, g = x(gt(e));
                  break;
                default:
                  throw new Error("unparsed value: " + e[e.l]);
              }
              f[v] = g;
            }
          }
          return e.l = r + n, f;
        }
        function Ot(e, t) {
          var r = e.content;
          Q(r, 0);
          var n,
            i,
            a,
            o,
            s = 0;
          r.chk("feff", "Byte Order: ");
          var l = (r.read_shift(2), r.read_shift(4));
          if (r.chk(Hc.utils.consts.HEADER_CLSID, "CLSID: "), 1 !== (n = r.read_shift(4)) && 2 !== n) throw new Error("Unrecognized #Sets: " + n);
          if (i = r.read_shift(16), o = r.read_shift(4), 1 === n && o !== r.l) throw new Error("Length mismatch: " + o + " !== " + r.l);
          2 === n && (a = r.read_shift(16), s = r.read_shift(4));
          var c = Mt(r, t),
            u = {
              SystemIdentifier: l
            };
          for (var h in c) u[h] = c[h];
          if (u.FMTID = i, 1 === n) return u;
          if (r.l !== s) throw new Error("Length mismatch 2: " + r.l + " !== " + s);
          var f;
          try {
            f = Mt(r, null);
          } catch (e) {}
          for (h in f) u[h] = f[h];
          return u.FMTID = [i, a], u;
        }
        function Pt(e, t) {
          return e.read_shift(t), null;
        }
        function Bt(e, t, r) {
          for (var n = [], i = e.l + t; e.l < i;) n.push(r(e, i - e.l));
          if (i !== e.l) throw new Error("Slurp error");
          return n;
        }
        function Dt(e, t) {
          return 1 === e.read_shift(t);
        }
        function Lt(e) {
          return e.read_shift(2, "u");
        }
        function Ft(e, t) {
          return Bt(e, t, Lt);
        }
        function Nt(e) {
          var t = e.read_shift(1);
          return 1 === e.read_shift(1) ? t : 1 === t;
        }
        function Ut(e, t, r) {
          var n = e.read_shift(r && r.biff >= 12 ? 2 : 1),
            i = "sbcs-cont",
            a = kc;
          if (r && r.biff >= 8 && (kc = 1200), r && 8 != r.biff) 12 == r.biff && (2, i = "wstr");else {
            e.read_shift(1) && (2, i = "dbcs-cont");
          }
          var o = n ? e.read_shift(n, i) : "";
          return kc = a, o;
        }
        function jt(e) {
          var t = kc;
          kc = 1200;
          var r,
            n = e.read_shift(2),
            i = e.read_shift(1),
            a = 4 & i,
            o = 8 & i,
            s = 0,
            l = {};
          o && (s = e.read_shift(2)), a && (r = e.read_shift(4));
          var c = 1 & i ? "dbcs-cont" : "sbcs-cont",
            u = 0 === n ? "" : e.read_shift(n, c);
          return o && (e.l += 4 * s), a && (e.l += r), l.t = u, o || (l.raw = "<t>" + l.t + "</t>", l.r = l.t), kc = t, l;
        }
        function zt(e, t, r) {
          if (r) {
            if (r.biff >= 2 && r.biff <= 5) return e.read_shift(t, "sbcs-cont");
            if (r.biff >= 12) return e.read_shift(t, "dbcs-cont");
          }
          return 0 === e.read_shift(1) ? e.read_shift(t, "sbcs-cont") : e.read_shift(t, "dbcs-cont");
        }
        function Ht(e, t, r) {
          var n = e.read_shift(r && 2 == r.biff ? 1 : 2);
          return 0 === n ? (e.l++, "") : zt(e, n, r);
        }
        function Gt(e, t, r) {
          if (r.biff > 5) return Ht(e, t, r);
          var n = e.read_shift(1);
          return 0 === n ? (e.l++, "") : e.read_shift(n, "sbcs-cont");
        }
        function Vt(e, t, r) {
          var n = e.read_shift(1);
          e.l++;
          var i = e.read_shift(2);
          return e.l += 2, [n, i];
        }
        function qt(e, t) {
          return [e.read_shift(1), e.read_shift(1), e.read_shift(1), e.read_shift(1)];
        }
        function Wt(e, t) {
          var r = qt(e, t);
          return r[3] = 0, r;
        }
        function Xt(e, t) {
          return {
            r: e.read_shift(2),
            c: e.read_shift(2),
            ixfe: e.read_shift(2)
          };
        }
        function Yt(e) {
          var t = e.read_shift(2),
            r = e.read_shift(2);
          return e.l += 8, {
            type: t,
            flags: r
          };
        }
        function Kt(e, t, r) {
          return 0 === t ? "" : Gt(e, t, r);
        }
        function Zt(e, t, r) {
          var n = r.biff > 8 ? 4 : 2;
          return [e.read_shift(n), e.read_shift(n, "i"), e.read_shift(n, "i")];
        }
        function Jt(e, t) {
          return [e.read_shift(2), Ne(e)];
        }
        function Qt(e, t, r) {
          e.l += 4, t -= 4;
          var n = e.l + t,
            i = Ut(e, t, r),
            a = e.read_shift(2);
          if (n -= e.l, a !== n) throw new Error("Malformed AddinUdf: padding = " + n + " != " + a);
          return e.l += a, i;
        }
        function $t(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(2);
          return {
            s: {
              c: e.read_shift(2),
              r: r
            },
            e: {
              c: e.read_shift(2),
              r: n
            }
          };
        }
        function er(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(2);
          return {
            s: {
              c: e.read_shift(1),
              r: r
            },
            e: {
              c: e.read_shift(1),
              r: n
            }
          };
        }
        function tr(e, t) {
          e.l += 4;
          var r = e.read_shift(2),
            n = e.read_shift(2),
            i = e.read_shift(2);
          return e.l += 12, [n, r, i];
        }
        function rr(e, t) {
          var r = {};
          return e.l += 4, e.l += 16, r.fSharedNote = e.read_shift(2), e.l += 4, r;
        }
        function nr(e, t) {
          var r = {};
          return e.l += 4, e.cf = e.read_shift(2), r;
        }
        function ir(e, t) {
          e.l += 2, e.l += e.read_shift(2);
        }
        function ar(e, t, r) {
          for (var n = e.l + t, i = []; e.l < n;) {
            var a = e.read_shift(2);
            e.l -= 2;
            try {
              i.push(Nh[a](e, n - e.l));
            } catch (t) {
              return e.l = n, i;
            }
          }
          return e.l != n && (e.l = n), i;
        }
        function or(e, t) {
          var r = {
            BIFFVer: 0,
            dt: 0
          };
          switch (r.BIFFVer = e.read_shift(2), t -= 2, t >= 2 && (r.dt = e.read_shift(2), e.l -= 2), r.BIFFVer) {
            case 1536:
            case 1280:
            case 2:
            case 7:
              break;
            default:
              if (t > 6) throw new Error("Unexpected BIFF Ver " + r.BIFFVer);
          }
          return e.read_shift(t), r;
        }
        function sr(e, t) {
          if (0 === t) return 1200;
          return e.read_shift(2), 1200;
        }
        function lr(e, t, r) {
          if (r.enc) return e.l += t, "";
          var n = e.l,
            i = Ht(e, 0, r);
          return e.read_shift(t + n - e.l), i;
        }
        function cr(e, t, r) {
          var n = e.read_shift(4),
            i = 3 & e.read_shift(1),
            a = e.read_shift(1);
          switch (a) {
            case 0:
              a = "Worksheet";
              break;
            case 1:
              a = "Macrosheet";
              break;
            case 2:
              a = "Chartsheet";
              break;
            case 6:
              a = "VBAModule";
          }
          var o = Ut(e, 0, r);
          return 0 === o.length && (o = "Sheet1"), {
            pos: n,
            hs: i,
            dt: a,
            name: o
          };
        }
        function ur(e, t) {
          for (var r = e.l + t, n = e.read_shift(4), i = e.read_shift(4), a = [], o = 0; o != i && e.l < r; ++o) a.push(jt(e));
          return a.Count = n, a.Unique = i, a;
        }
        function hr(e, t) {
          var r = {};
          return r.dsst = e.read_shift(2), e.l += t - 2, r;
        }
        function fr(e, t) {
          var r = {};
          r.r = e.read_shift(2), r.c = e.read_shift(2), r.cnt = e.read_shift(2) - r.c;
          var n = e.read_shift(2);
          e.l += 4;
          var i = e.read_shift(1);
          return e.l += 3, 7 & i && (r.level = 7 & i), 32 & i && (r.hidden = !0), 64 & i && (r.hpt = n / 20), r;
        }
        function dr(e, t) {
          var r = Yt(e);
          if (2211 != r.type) throw new Error("Invalid Future Record " + r.type);
          return 0 !== e.read_shift(4);
        }
        function pr(e, t) {
          return e.read_shift(2), e.read_shift(4);
        }
        function mr(e, t, r) {
          var n = 0;
          r && 2 == r.biff || (n = e.read_shift(2));
          var i = e.read_shift(2);
          return r && 2 == r.biff && (n = 1 - (i >> 15), i &= 32767), [{
            Unsynced: 1 & n,
            DyZero: (2 & n) >> 1,
            ExAsc: (4 & n) >> 2,
            ExDsc: (8 & n) >> 3
          }, i];
        }
        function gr(e, t) {
          return {
            Pos: [e.read_shift(2), e.read_shift(2)],
            Dim: [e.read_shift(2), e.read_shift(2)],
            Flags: e.read_shift(2),
            CurTab: e.read_shift(2),
            FirstTab: e.read_shift(2),
            Selected: e.read_shift(2),
            TabRatio: e.read_shift(2)
          };
        }
        function vr(e, t, r) {
          var n = {
            dyHeight: e.read_shift(2),
            fl: e.read_shift(2)
          };
          switch (r && r.biff || 8) {
            case 2:
              break;
            case 3:
            case 4:
              e.l += 2;
              break;
            default:
              e.l += 10;
          }
          return n.name = Ut(e, 0, r), n;
        }
        function br(e, t) {
          var r = Xt(e);
          return r.isst = e.read_shift(4), r;
        }
        function yr(e, t, r) {
          var n = e.l + t,
            i = Xt(e, 6);
          2 == r.biff && e.l++;
          var a = Ht(e, n - e.l, r);
          return i.val = a, i;
        }
        function wr(e, t, r) {
          return [e.read_shift(2), Gt(e, 0, r)];
        }
        function xr(e, t, r) {
          var n = e.l + t,
            i = 8 != r.biff && r.biff ? 2 : 4,
            a = e.read_shift(i),
            o = e.read_shift(i),
            s = e.read_shift(2),
            l = e.read_shift(2);
          return e.l = n, {
            s: {
              r: a,
              c: s
            },
            e: {
              r: o,
              c: l
            }
          };
        }
        function _r(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(2),
            i = Jt(e);
          return {
            r: r,
            c: n,
            ixfe: i[0],
            rknum: i[1]
          };
        }
        function Sr(e, t) {
          for (var r = e.l + t - 2, n = e.read_shift(2), i = e.read_shift(2), a = []; e.l < r;) a.push(Jt(e));
          if (e.l !== r) throw new Error("MulRK read error");
          var o = e.read_shift(2);
          if (a.length != o - i + 1) throw new Error("MulRK length mismatch");
          return {
            r: n,
            c: i,
            C: o,
            rkrec: a
          };
        }
        function Cr(e, t) {
          for (var r = e.l + t - 2, n = e.read_shift(2), i = e.read_shift(2), a = []; e.l < r;) a.push(e.read_shift(2));
          if (e.l !== r) throw new Error("MulBlank read error");
          var o = e.read_shift(2);
          if (a.length != o - i + 1) throw new Error("MulBlank length mismatch");
          return {
            r: n,
            c: i,
            C: o,
            ixfe: a
          };
        }
        function Er(e, t, r, n) {
          var i = {},
            a = e.read_shift(4),
            o = e.read_shift(4),
            s = e.read_shift(4),
            l = e.read_shift(2);
          return i.patternType = hh[s >> 26], n.cellStyles ? (i.alc = 7 & a, i.fWrap = a >> 3 & 1, i.alcV = a >> 4 & 7, i.fJustLast = a >> 7 & 1, i.trot = a >> 8 & 255, i.cIndent = a >> 16 & 15, i.fShrinkToFit = a >> 20 & 1, i.iReadOrder = a >> 22 & 2, i.fAtrNum = a >> 26 & 1, i.fAtrFnt = a >> 27 & 1, i.fAtrAlc = a >> 28 & 1, i.fAtrBdr = a >> 29 & 1, i.fAtrPat = a >> 30 & 1, i.fAtrProt = a >> 31 & 1, i.dgLeft = 15 & o, i.dgRight = o >> 4 & 15, i.dgTop = o >> 8 & 15, i.dgBottom = o >> 12 & 15, i.icvLeft = o >> 16 & 127, i.icvRight = o >> 23 & 127, i.grbitDiag = o >> 30 & 3, i.icvTop = 127 & s, i.icvBottom = s >> 7 & 127, i.icvDiag = s >> 14 & 127, i.dgDiag = s >> 21 & 15, i.icvFore = 127 & l, i.icvBack = l >> 7 & 127, i.fsxButton = l >> 14 & 1, i) : i;
        }
        function Ar(e, t, r) {
          var n = {};
          return n.ifnt = e.read_shift(2), n.numFmtId = e.read_shift(2), n.flags = e.read_shift(2), n.fStyle = n.flags >> 2 & 1, t -= 6, n.data = Er(e, t, n.fStyle, r), n;
        }
        function Tr(e, t) {
          e.l += 4;
          var r = [e.read_shift(2), e.read_shift(2)];
          if (0 !== r[0] && r[0]--, 0 !== r[1] && r[1]--, r[0] > 7 || r[1] > 7) throw new Error("Bad Gutters: " + r.join("|"));
          return r;
        }
        function kr(e, t, r) {
          var n = Xt(e, 6);
          2 == r.biff && ++e.l;
          var i = Nt(e, 2);
          return n.val = i, n.t = !0 === i || !1 === i ? "b" : "e", n;
        }
        function Rr(e, t) {
          var r = Xt(e, 6),
            n = He(e, 8);
          return r.val = n, r;
        }
        function Ir(e, t, r) {
          var n = e.l + t,
            i = e.read_shift(2),
            a = e.read_shift(2);
          if (r.sbcch = a, 1025 == a || 14849 == a) return [a, i];
          if (a < 1 || a > 255) throw new Error("Unexpected SupBook type: " + a);
          for (var o = zt(e, a), s = []; n > e.l;) s.push(Ht(e));
          return [a, i, o, s];
        }
        function Mr(e, t, r) {
          var n,
            i = e.read_shift(2),
            a = {
              fBuiltIn: 1 & i,
              fWantAdvise: i >>> 1 & 1,
              fWantPict: i >>> 2 & 1,
              fOle: i >>> 3 & 1,
              fOleLink: i >>> 4 & 1,
              cf: i >>> 5 & 1023,
              fIcon: i >>> 15 & 1
            };
          return 14849 === r.sbcch && (n = Qt(e, t - 2, r)), a.body = n || e.read_shift(t - 2), "string" == typeof n && (a.Name = n), a;
        }
        function Or(e, t, r) {
          var n = e.l + t,
            i = e.read_shift(2),
            a = e.read_shift(1),
            o = e.read_shift(1),
            s = e.read_shift(r && 2 == r.biff ? 1 : 2),
            l = 0;
          (!r || r.biff >= 5) && (e.l += 2, l = e.read_shift(2), e.l += 4);
          var c = zt(e, o, r);
          32 & i && (c = Gh[c.charCodeAt(0)]);
          var u = n - e.l;
          return r && 2 == r.biff && --u, {
            chKey: a,
            Name: c,
            itab: l,
            rgce: n == e.l || 0 == s ? [] : eo(e, u, r, s)
          };
        }
        function Pr(e, t, r) {
          if (r.biff < 8) return Br(e, t, r);
          for (var n = [], i = (e.l, e.read_shift(r.biff > 8 ? 4 : 2)); 0 != i--;) n.push(Zt(e, r.biff > 8 ? 12 : 6, r));
          return n;
        }
        function Br(e, t, r) {
          3 == e[e.l + 1] && e[e.l]++;
          var n = Ut(e, t, r);
          return 3 == n.charCodeAt(0) ? n.slice(1) : n;
        }
        function Dr(e, t, r) {
          if (r.biff < 8) return void (e.l += t);
          var n = e.read_shift(2),
            i = e.read_shift(2);
          return [zt(e, n, r), zt(e, i, r)];
        }
        function Lr(e, t, r) {
          er(e, 6);
          e.l++;
          var n = e.read_shift(1);
          return t -= 8, [ro(e, t, r), n];
        }
        function Fr(e, t, r) {
          var n = Fh(e, 6);
          switch (r.biff) {
            case 2:
              e.l++, t -= 7;
              break;
            case 3:
            case 4:
              e.l += 2, t -= 8;
              break;
            default:
              e.l += 6, t -= 12;
          }
          return [n, no(e, t, r, n)];
        }
        function Nr(e, t) {
          return [0 !== e.read_shift(4), 0 !== e.read_shift(4), e.read_shift(4)];
        }
        function Ur(e, t, r) {
          if (!(r.biff < 8)) {
            var n = e.read_shift(2),
              i = e.read_shift(2),
              a = e.read_shift(2),
              o = e.read_shift(2),
              s = Gt(e, 0, r);
            return r.biff < 8 && e.read_shift(1), [{
              r: n,
              c: i
            }, s, o, a];
          }
        }
        function jr(e, t, r) {
          return Ur(e, t, r);
        }
        function zr(e, t) {
          for (var r = [], n = e.read_shift(2); n--;) r.push($t(e, t));
          return r;
        }
        function Hr(e, t, r) {
          if (r && r.biff < 8) return Gr(e, t, r);
          var n = tr(e, 22);
          return {
            cmo: n,
            ft: ar(e, t - 22, n[1])
          };
        }
        function Gr(e, t, r) {
          var n = (e.read_shift(4), e.read_shift(2)),
            i = e.read_shift(2),
            a = e.read_shift(2);
          e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2), e.read_shift(2);
          e.l += 6, t -= 36;
          var o = [];
          return o.push((qh[n] || $)(e, t, r)), {
            cmo: [i, n, a],
            ft: o
          };
        }
        function Vr(e, t, r) {
          var n = e.l,
            i = "";
          try {
            e.l += 4;
            var a = (r.lastobj || {
              cmo: [0, 0]
            }).cmo[1];
            -1 == [0, 5, 7, 11, 12, 14].indexOf(a) ? e.l += 6 : Vt(e, 6, r);
            var o = e.read_shift(2),
              s = (e.read_shift(2), Uh(e, 2), e.read_shift(2));
            e.l += s;
            for (var l = 1; l < e.lens.length - 1; ++l) {
              if (e.l - n != e.lens[l]) throw new Error("TxO: bad continue record");
              var c = e[e.l],
                u = zt(e, e.lens[l + 1] - e.lens[l] - 1);
              if (i += u, i.length >= (c ? o : 2 * o)) break;
            }
            if (i.length !== o && i.length !== 2 * o) throw new Error("cchText: " + o + " != " + i.length);
            return e.l = n + t, {
              t: i
            };
          } catch (r) {
            return e.l = n + t, {
              t: i
            };
          }
        }
        function qr(e, t) {
          var r,
            n = [];
          return r = e.read_shift(2), n[0] = uh[r] || r, r = e.read_shift(2), n[1] = uh[r] || r, n;
        }
        function Wr(e, t) {
          for (var r = e.read_shift(2), n = []; r-- > 0;) n.push(Wt(e, 8));
          return n;
        }
        function Xr(e, t) {
          for (var r = e.read_shift(2), n = []; r-- > 0;) n.push(Wt(e, 8));
          return n;
        }
        function Yr(e, t) {
          e.l += 2;
          var r = {
            cxfs: 0,
            crc: 0
          };
          return r.cxfs = e.read_shift(2), r.crc = e.read_shift(4), r;
        }
        function Kr(e, t, r) {
          if (!r.cellStyles) return $(e, t);
          var n = r && r.biff >= 12 ? 4 : 2,
            i = e.read_shift(n),
            a = e.read_shift(n),
            o = e.read_shift(n),
            s = e.read_shift(n),
            l = e.read_shift(2);
          return 2 == n && (e.l += 2), {
            s: i,
            e: a,
            w: o,
            ixfe: s,
            flags: l
          };
        }
        function Zr(e, t, r) {
          var n = {};
          return e.l += 16, n.header = He(e, 8), n.footer = He(e, 8), e.l += 2, n;
        }
        function Jr(e, t, r) {
          var n = {
            area: !1
          };
          if (5 != r.biff) return e.l += t, n;
          var i = e.read_shift(1);
          return e.l += 3, 16 & i && (n.area = !0), n;
        }
        function Qr(e, t, r) {
          var n = (e.l, e.read_shift(2)),
            i = e.read_shift(2),
            a = e.read_shift(4),
            o = {
              fmt: n,
              env: i,
              len: a,
              data: e.slice(e.l, e.l + a)
            };
          return e.l += a, o;
        }
        function $r(e, t, r) {
          var n = Xt(e, 6);
          ++e.l;
          var i = Gt(e, t - 7, r);
          return n.t = "str", n.val = i, n;
        }
        function en(e, t, r) {
          var n = Xt(e, 6);
          ++e.l;
          var i = He(e, 8);
          return n.t = "n", n.val = i, n;
        }
        function tn(e, t) {
          var r = Xt(e, 6);
          ++e.l;
          var n = e.read_shift(2);
          return r.t = "n", r.val = n, r;
        }
        function rn(e, t) {
          var r = e.read_shift(1);
          return 0 === r ? (e.l++, "") : e.read_shift(r, "sbcs-cont");
        }
        function nn(e, t) {
          e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += t - 13;
        }
        function an(e, t, r) {
          var n = e.l + t,
            i = Xt(e, 6),
            a = e.read_shift(2),
            o = zt(e, a, r);
          return e.l = n, i.t = "str", i.val = o, i;
        }
        function on(e, t) {
          var r = t || {},
            n = !!r.WTF;
          r.WTF = !0;
          try {
            var i = Iv.to_workbook(e, r);
            return r.WTF = n, i;
          } catch (i) {
            if (r.WTF = n, !i.message.match(/SYLK bad record ID/) && n) throw i;
            return Ov.to_workbook(e, t);
          }
        }
        function sn(e, t) {
          var r = !t || t.cellHTML,
            n = {};
          if (!e) return null;
          return e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (n.t = su(tu(e.substr(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0])), n.r = su(e), r && (n.h = U(n.t))) : e.match(Fv) && (n.r = su(e), n.t = su(tu((e.replace(Nv, "").match(Lv) || []).join("").replace(Zc, ""))), r && (n.h = Dv(n.r))), n;
        }
        function ln(e, t) {
          var r = [],
            n = "";
          if (!e) return r;
          var i = e.match(Uv);
          if (p(i)) {
            n = i[2].replace(jv, "").split(zv);
            for (var a = 0; a != n.length; ++a) {
              var o = sn(n[a].trim(), t);
              null != o && (r[r.length] = o);
            }
            i = D(i[1]), r.Count = i.count, r.Unique = i.uniqueCount;
          }
          return r;
        }
        function cn(e, t) {
          if (!t.bookSST) return "";
          var r = [gu];
          r[r.length] = V("sst", null, {
            xmlns: vu.main[0],
            count: e.Count,
            uniqueCount: e.Unique
          });
          for (var n = 0; n != e.length; ++n) if (null != e[n]) {
            var i = e[n],
              a = "<si>";
            i.r ? a += i.r : (a += "<t", i.t || (i.t = ""), i.t.match(Hv) && (a += ' xml:space="preserve"'), a += ">" + F(i.t) + "</t>"), a += "</si>", r[r.length] = a;
          }
          return r.length > 2 && (r[r.length] = "</sst>", r[1] = r[1].replace("/>", ">")), r.join("");
        }
        function un(e, t) {
          return [e.read_shift(4), e.read_shift(4)];
        }
        function hn(e, t) {
          var r = [],
            n = !1;
          return te(e, function (e, i, a) {
            switch (a) {
              case 159:
                r.Count = e[0], r.Unique = e[1];
                break;
              case 19:
                r.push(e);
                break;
              case 160:
                return !0;
              case 35:
                n = !0;
                break;
              case 36:
                n = !1;
                break;
              default:
                if (i.indexOf("Begin") > 0 || i.indexOf("End"), !n || t.WTF) throw new Error("Unexpected record " + a + " " + i);
            }
          }), r;
        }
        function fn(e, t) {
          return t || (t = ee(8)), t.write_shift(4, e.Count), t.write_shift(4, e.Unique), t;
        }
        function dn(e, t) {
          var r = re();
          ne(r, "BrtBeginSst", fn(e));
          for (var n = 0; n < e.length; ++n) ne(r, "BrtSSTItem", Gv(e[n]));
          return ne(r, "BrtEndSst"), r.end();
        }
        function pn(e) {
          if ("undefined" != typeof cptable) return cptable.utils.encode(1252, e);
          for (var t = [], r = e.split(""), n = 0; n < r.length; ++n) t[n] = r[n].charCodeAt(0);
          return t;
        }
        function mn(e, t) {
          var r = {};
          return r.Major = e.read_shift(2), r.Minor = e.read_shift(2), t >= 4 && (e.l += t - 4), r;
        }
        function gn(e, t) {
          var r = {};
          return r.id = e.read_shift(0, "lpp4"), r.R = mn(e, 4), r.U = mn(e, 4), r.W = mn(e, 4), r;
        }
        function vn(e) {
          for (var t = e.read_shift(4), r = (e.l, {}), n = e.read_shift(4), i = []; n-- > 0;) {
            var a = {};
            a.t = e.read_shift(4), a.v = e.read_shift(0, "lpp4"), i.push(a);
          }
          return r.name = e.read_shift(0, "lpp4"), r.comps = i, r;
        }
        function bn(e, t) {
          var r = [];
          e.l += 4;
          for (var n = e.read_shift(4); n-- > 0;) r.push(vn(e));
          return r;
        }
        function yn(e, t) {
          var r = [];
          e.l += 4;
          for (var n = e.read_shift(4); n-- > 0;) r.push(e.read_shift(0, "lpp4"));
          return r;
        }
        function wn(e, t) {
          var r = {},
            n = e.read_shift(4);
          e.l;
          return e.l += 4, r.id = e.read_shift(0, "lpp4"), r.name = e.read_shift(0, "lpp4"), r.R = mn(e, 4), r.U = mn(e, 4), r.W = mn(e, 4), r;
        }
        function xn(e, t) {
          var r = wn(e);
          if (r.ename = e.read_shift(0, "8lpp4"), r.blksz = e.read_shift(4), r.cmode = e.read_shift(4), 4 != e.read_shift(4)) throw new Error("Bad !Primary record");
          return r;
        }
        function _n(e, t) {
          var r = e.l + t,
            n = {};
          n.Flags = 63 & e.read_shift(4), e.l += 4, n.AlgID = e.read_shift(4);
          var i = !1;
          switch (n.AlgID) {
            case 26126:
            case 26127:
            case 26128:
              i = 36 == n.Flags;
              break;
            case 26625:
              i = 4 == n.Flags;
              break;
            case 0:
              i = 16 == n.Flags || 4 == n.Flags || 36 == n.Flags;
              break;
            default:
              throw "Unrecognized encryption algorithm: " + n.AlgID;
          }
          if (!i) throw new Error("Encryption Flags/AlgID mismatch");
          return n.AlgIDHash = e.read_shift(4), n.KeySize = e.read_shift(4), n.ProviderType = e.read_shift(4), e.l += 8, n.CSPName = e.read_shift(r - e.l >> 1, "utf16le").slice(0, -1), e.l = r, n;
        }
        function Sn(e, t) {
          var r = {};
          e.l += 4, r.Salt = e.slice(e.l, e.l + 16), e.l += 16, r.Verifier = e.slice(e.l, e.l + 16), e.l += 16;
          var n = e.read_shift(4);
          return r.VerifierHash = e.slice(e.l, e.l + n), e.l += n, r;
        }
        function Cn(e, t) {
          var r = mn(e);
          switch (r.Minor) {
            case 2:
              return En(e, r);
            case 3:
              return An(e, r);
            case 4:
              return Tn(e, r);
          }
          throw new Error("ECMA-376 Encryped file unrecognized Version: " + r.Minor);
        }
        function En(e, t) {
          if (36 != (63 & e.read_shift(4))) throw new Error("EncryptionInfo mismatch");
          var r = e.read_shift(4);
          e.l;
          return {
            t: "Std",
            h: _n(e, r),
            v: Sn(e, e.length - e.l)
          };
        }
        function An(e, t) {
          throw new Error("File is password-protected: ECMA-376 Extensible");
        }
        function Tn(e, t) {
          throw new Error("File is password-protected: ECMA-376 Agile");
        }
        function kn(e, t) {
          var r = {},
            n = r.EncryptionVersionInfo = mn(e, 4);
          if (t -= 4, 2 != n.Minor) throw new Error("unrecognized minor version code: " + n.Minor);
          if (n.Major > 4 || n.Major < 2) throw new Error("unrecognized major version code: " + n.Major);
          r.Flags = e.read_shift(4), t -= 4;
          var i = e.read_shift(4);
          return t -= 4, r.EncryptionHeader = _n(e, i), t -= i, r.EncryptionVerifier = Sn(e, t), r;
        }
        function Rn(e, t) {
          var r = {},
            n = r.EncryptionVersionInfo = mn(e, 4);
          if (t -= 4, 1 != n.Major || 1 != n.Minor) throw "unrecognized version code " + n.Major + " : " + n.Minor;
          return r.Salt = e.read_shift(16), r.EncryptedVerifier = e.read_shift(16), r.EncryptedVerifierHash = e.read_shift(16), r;
        }
        function In(e) {
          var t,
            r,
            n,
            i,
            a,
            o,
            s = 0,
            l = pn(e),
            c = l.length + 1;
          for (t = u(c), t[0] = l.length, r = 1; r != c; ++r) t[r] = l[r - 1];
          for (r = c - 1; r >= 0; --r) n = t[r], i = 0 == (16384 & s) ? 0 : 1, a = s << 1 & 32767, o = i | a, s = o ^ n;
          return 52811 ^ s;
        }
        function Mn(e, t, r, n) {
          var i = {
            key: Lt(e),
            verificationBytes: Lt(e)
          };
          return r.password && (i.verifier = In(r.password)), n.valid = i.verificationBytes === i.verifier, n.valid && (n.insitu_decrypt = Wv(r.password)), i;
        }
        function On(e, t, r) {
          var n = r || {};
          return n.Info = e.read_shift(2), e.l -= 2, 1 === n.Info ? n.Data = Rn(e, t) : n.Data = kn(e, t), n;
        }
        function Pn(e, t, r) {
          var n = {
            Type: r.biff >= 8 ? e.read_shift(2) : 0
          };
          return n.Type ? On(e, t - 2, n) : Mn(e, t - 2, r, n), n;
        }
        function Bn(e) {
          var t = e.substr("#" === e[0] ? 1 : 0, 6);
          return [parseInt(t.substr(0, 2), 16), parseInt(t.substr(2, 2), 16), parseInt(t.substr(4, 2), 16)];
        }
        function Dn(e) {
          for (var t = 0, r = 1; 3 != t; ++t) r = 256 * r + (e[t] > 255 ? 255 : e[t] < 0 ? 0 : e[t]);
          return r.toString(16).toUpperCase().substr(1);
        }
        function Ln(e) {
          var t = e[0] / 255,
            r = e[1] / 255,
            n = e[2] / 255,
            i = Math.max(t, r, n),
            a = Math.min(t, r, n),
            o = i - a;
          if (0 === o) return [0, 0, t];
          var s = 0,
            l = 0,
            c = i + a;
          switch (l = o / (c > 1 ? 2 - c : c), i) {
            case t:
              s = ((r - n) / o + 6) % 6;
              break;
            case r:
              s = (n - t) / o + 2;
              break;
            case n:
              s = (t - r) / o + 4;
          }
          return [s / 6, l, c / 2];
        }
        function Fn(e) {
          var t,
            r = e[0],
            n = e[1],
            i = e[2],
            a = 2 * n * (i < .5 ? i : 1 - i),
            o = i - a / 2,
            s = [o, o, o],
            l = 6 * r;
          if (0 !== n) switch (0 | l) {
            case 0:
            case 6:
              t = a * l, s[0] += a, s[1] += t;
              break;
            case 1:
              t = a * (2 - l), s[0] += t, s[1] += a;
              break;
            case 2:
              t = a * (l - 2), s[1] += a, s[2] += t;
              break;
            case 3:
              t = a * (4 - l), s[1] += t, s[2] += a;
              break;
            case 4:
              t = a * (l - 4), s[2] += a, s[0] += t;
              break;
            case 5:
              t = a * (6 - l), s[2] += t, s[0] += a;
          }
          for (var c = 0; 3 != c; ++c) s[c] = Math.round(255 * s[c]);
          return s;
        }
        function Nn(e, t) {
          if (0 === t) return e;
          var r = Ln(Bn(e));
          return r[2] = t < 0 ? r[2] * (1 + t) : 1 - (1 - r[2]) * (1 - t), Dn(Fn(r));
        }
        function Un(e) {
          return Math.floor((e + Math.round(128 / Zv) / 256) * Zv);
        }
        function jn(e) {
          return Math.floor((e - 5) / Zv * 100 + .5) / 100;
        }
        function zn(e) {
          return Math.round((e * Zv + 5) / Zv * 256) / 256;
        }
        function Hn(e) {
          return zn(jn(Un(e)));
        }
        function Gn(e) {
          var t = Math.abs(e - Hn(e)),
            r = Zv;
          if (t > .005) for (Zv = Kv; Zv < Yv; ++Zv) Math.abs(e - Hn(e)) <= t && (t = Math.abs(e - Hn(e)), r = Zv);
          Zv = r;
        }
        function Vn(e) {
          e.width ? (e.wpx = Un(e.width), e.wch = jn(e.wpx), e.MDW = Zv) : e.wpx ? (e.wch = jn(e.wpx), e.width = zn(e.wch), e.MDW = Zv) : "number" == typeof e.wch && (e.width = zn(e.wch), e.wpx = Un(e.width), e.MDW = Zv), e.customWidth && delete e.customWidth;
        }
        function qn(e) {
          return 96 * e / Jv;
        }
        function Wn(e) {
          return e * Jv / 96;
        }
        function Xn(e, t, r, n) {
          t.Borders = [];
          var i = {};
          e[0].match(Zc).forEach(function (e) {
            var r = D(e);
            switch (r[0]) {
              case "<borders":
              case "<borders>":
              case "</borders>":
                break;
              case "<border":
              case "<border>":
              case "<border/>":
                i = {}, r.diagonalUp && (i.diagonalUp = r.diagonalUp), r.diagonalDown && (i.diagonalDown = r.diagonalDown), t.Borders.push(i);
                break;
              case "</border>":
              case "<left/>":
                break;
              case "<left":
              case "<left>":
              case "</left>":
              case "<right/>":
                break;
              case "<right":
              case "<right>":
              case "</right>":
              case "<top/>":
                break;
              case "<top":
              case "<top>":
              case "</top>":
              case "<bottom/>":
                break;
              case "<bottom":
              case "<bottom>":
              case "</bottom>":
                break;
              case "<diagonal":
              case "<diagonal>":
              case "<diagonal/>":
              case "</diagonal>":
                break;
              case "<horizontal":
              case "<horizontal>":
              case "<horizontal/>":
              case "</horizontal>":
                break;
              case "<vertical":
              case "<vertical>":
              case "<vertical/>":
              case "</vertical>":
                break;
              case "<start":
              case "<start>":
              case "<start/>":
              case "</start>":
                break;
              case "<end":
              case "<end>":
              case "<end/>":
              case "</end>":
                break;
              case "<color":
              case "<color>":
                break;
              case "<color/>":
              case "</color>":
                break;
              default:
                if (n && n.WTF) throw new Error("unrecognized " + r[0] + " in borders");
            }
          });
        }
        function Yn(e, t, r, n) {
          t.Fills = [];
          var i = {};
          e[0].match(Zc).forEach(function (e) {
            var r = D(e);
            switch (r[0]) {
              case "<fills":
              case "<fills>":
              case "</fills>":
                break;
              case "<fill>":
              case "<fill":
                break;
              case "</fill>":
                t.Fills.push(i), i = {};
                break;
              case "<gradientFill>":
                break;
              case "<gradientFill":
              case "</gradientFill>":
                t.Fills.push(i), i = {};
                break;
              case "<patternFill":
              case "<patternFill>":
                r.patternType && (i.patternType = r.patternType);
                break;
              case "<patternFill/>":
              case "</patternFill>":
                break;
              case "<bgColor":
                i.bgColor || (i.bgColor = {}), r.indexed && (i.bgColor.indexed = parseInt(r.indexed, 10)), r.theme && (i.bgColor.theme = parseInt(r.theme, 10)), r.tint && (i.bgColor.tint = parseFloat(r.tint)), r.rgb && (i.bgColor.rgb = r.rgb.slice(-6));
                break;
              case "<bgColor/>":
              case "</bgColor>":
                break;
              case "<fgColor":
                i.fgColor || (i.fgColor = {}), r.theme && (i.fgColor.theme = parseInt(r.theme, 10)), r.tint && (i.fgColor.tint = parseFloat(r.tint)), r.rgb && (i.fgColor.rgb = r.rgb.slice(-6));
                break;
              case "<fgColor/>":
              case "</fgColor>":
                break;
              case "<stop":
              case "<stop/>":
              case "</stop>":
                break;
              case "<color":
              case "<color/>":
              case "</color>":
                break;
              default:
                if (n && n.WTF) throw new Error("unrecognized " + r[0] + " in fills");
            }
          });
        }
        function Kn(e, t, r, n) {
          t.Fonts = [];
          var i = {};
          e[0].match(Zc).forEach(function (e) {
            var a = D(e);
            switch (a[0]) {
              case "<fonts":
              case "<fonts>":
              case "</fonts>":
                break;
              case "<font":
              case "<font>":
                break;
              case "</font>":
              case "<font/>":
                t.Fonts.push(i), i = {};
                break;
              case "<name":
                a.val && (i.name = a.val);
                break;
              case "<name/>":
              case "</name>":
                break;
              case "<b":
                i.bold = a.val ? j(a.val) : 1;
                break;
              case "<b/>":
                i.bold = 1;
                break;
              case "<i":
                i.italic = a.val ? j(a.val) : 1;
                break;
              case "<i/>":
                i.italic = 1;
                break;
              case "<u":
                switch (a.val) {
                  case "none":
                    i.underline = 0;
                    break;
                  case "single":
                    i.underline = 1;
                    break;
                  case "double":
                    i.underline = 2;
                    break;
                  case "singleAccounting":
                    i.underline = 33;
                    break;
                  case "doubleAccounting":
                    i.underline = 34;
                }
                break;
              case "<u/>":
                i.underline = 1;
                break;
              case "<strike":
                i.strike = a.val ? j(a.val) : 1;
                break;
              case "<strike/>":
                i.strike = 1;
                break;
              case "<outline":
                i.outline = a.val ? j(a.val) : 1;
                break;
              case "<outline/>":
                i.outline = 1;
                break;
              case "<shadow":
                i.shadow = a.val ? j(a.val) : 1;
                break;
              case "<shadow/>":
                i.shadow = 1;
                break;
              case "<condense":
                i.condense = a.val ? j(a.val) : 1;
                break;
              case "<condense/>":
                i.condense = 1;
                break;
              case "<extend":
                i.extend = a.val ? j(a.val) : 1;
                break;
              case "<extend/>":
                i.extend = 1;
                break;
              case "<sz":
                a.val && (i.sz = +a.val);
                break;
              case "<sz/>":
              case "</sz>":
                break;
              case "<vertAlign":
                a.val && (i.vertAlign = a.val);
                break;
              case "<vertAlign/>":
              case "</vertAlign>":
                break;
              case "<family":
                a.val && (i.family = parseInt(a.val, 10));
                break;
              case "<family/>":
              case "</family>":
                break;
              case "<scheme":
                a.val && (i.scheme = a.val);
                break;
              case "<scheme/>":
              case "</scheme>":
                break;
              case "<charset":
                if ("1" == a.val) break;
                a.codepage = Bv[parseInt(a.val, 10)];
                break;
              case "<color":
                if (i.color || (i.color = {}), a.auto && (i.color.auto = j(a.auto)), a.rgb) i.color.rgb = a.rgb.slice(-6);else if (a.indexed) {
                  i.color.index = parseInt(a.indexed, 10);
                  var o = fh[i.color.index];
                  if (81 == i.color.index && (o = fh[1]), !o) throw new Error(e);
                  i.color.rgb = o[0].toString(16) + o[1].toString(16) + o[2].toString(16);
                } else a.theme && (i.color.theme = parseInt(a.theme, 10), a.tint && (i.color.tint = parseFloat(a.tint)), a.theme && r.themeElements && r.themeElements.clrScheme && (i.color.rgb = Nn(r.themeElements.clrScheme[i.color.theme].rgb, i.color.tint || 0)));
                break;
              case "<color/>":
              case "</color>":
                break;
              default:
                if (n && n.WTF) throw new Error("unrecognized " + a[0] + " in fonts");
            }
          });
        }
        function Zn(e, t, r) {
          t.NumberFmt = [];
          for (var n = m(Nc._table), i = 0; i < n.length; ++i) t.NumberFmt[n[i]] = Nc._table[n[i]];
          var a = e[0].match(Zc);
          if (a) for (i = 0; i < a.length; ++i) {
            var o = D(a[i]);
            switch (o[0]) {
              case "<numFmts":
              case "</numFmts>":
              case "<numFmts/>":
              case "<numFmts>":
                break;
              case "<numFmt":
                var s = tu(su(o.formatCode)),
                  l = parseInt(o.numFmtId, 10);
                if (t.NumberFmt[l] = s, l > 0) {
                  if (l > 392) {
                    for (l = 392; l > 60 && null != t.NumberFmt[l]; --l);
                    t.NumberFmt[l] = s;
                  }
                  Nc.load(s, l);
                }
                break;
              case "</numFmt>":
                break;
              default:
                if (r.WTF) throw new Error("unrecognized " + o[0] + " in numFmts");
            }
          }
        }
        function Jn(e, t) {
          var r = ["<numFmts>"];
          return [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (t) {
            for (var n = t[0]; n <= t[1]; ++n) null != e[n] && (r[r.length] = V("numFmt", null, {
              numFmtId: n,
              formatCode: F(e[n])
            }));
          }), 1 === r.length ? "" : (r[r.length] = "</numFmts>", r[0] = V("numFmts", null, {
            count: r.length - 2
          }).replace("/>", ">"), r.join(""));
        }
        function Qn(e, t, r) {
          t.CellXf = [];
          var n;
          e[0].match(Zc).forEach(function (e) {
            var i = D(e),
              a = 0;
            switch (i[0]) {
              case "<cellXfs":
              case "<cellXfs>":
              case "<cellXfs/>":
              case "</cellXfs>":
                break;
              case "<xf":
              case "<xf/>":
                for (n = i, delete n[0], a = 0; a < $v.length; ++a) n[$v[a]] && (n[$v[a]] = parseInt(n[$v[a]], 10));
                for (a = 0; a < eb.length; ++a) n[eb[a]] && (n[eb[a]] = j(n[eb[a]], ""));
                if (n.numFmtId > 392) for (a = 392; a > 60; --a) if (t.NumberFmt[n.numFmtId] == t.NumberFmt[a]) {
                  n.numFmtId = a;
                  break;
                }
                t.CellXf.push(n);
                break;
              case "</xf>":
                break;
              case "<alignment":
              case "<alignment/>":
                var o = {};
                i.vertical && (o.vertical = i.vertical), i.horizontal && (o.horizontal = i.horizontal), null != i.textRotation && (o.textRotation = i.textRotation), i.indent && (o.indent = i.indent), i.wrapText && (o.wrapText = i.wrapText), n.alignment = o;
                break;
              case "</alignment>":
                break;
              case "<protection":
              case "</protection>":
              case "<protection/>":
                break;
              case "<extLst":
              case "</extLst>":
              case "<ext":
                break;
              default:
                if (r.WTF) throw new Error("unrecognized " + i[0] + " in cellXfs");
            }
          });
        }
        function $n(e) {
          var t = [];
          return t[t.length] = V("cellXfs", null), e.forEach(function (e) {
            t[t.length] = V("xf", null, e);
          }), t[t.length] = "</cellXfs>", 2 === t.length ? "" : (t[0] = V("cellXfs", null, {
            count: t.length - 2
          }).replace("/>", ">"), t.join(""));
        }
        function ei(e, t) {
          var r,
            n = [gu, rb];
          return e.SSF && null != (r = Jn(e.SSF)) && (n[n.length] = r), n[n.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', n[n.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', n[n.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', n[n.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', (r = $n(t.cellXfs)) && (n[n.length] = r), n[n.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', n[n.length] = '<dxfs count="0"/>', n[n.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', n.length > 2 && (n[n.length] = "</styleSheet>", n[1] = n[1].replace("/>", ">")), n.join("");
        }
        function ti(e, t) {
          return [e.read_shift(2), Te(e, t - 2)];
        }
        function ri(e, t, r) {
          return r || (r = ee(6 + 4 * t.length)), r.write_shift(2, e), ke(t, r), r.length > r.l ? r.slice(0, r.l) : r;
        }
        function ni(e, t, r) {
          var n = {};
          n.sz = e.read_shift(2) / 20;
          var i = We(e, 2, r);
          switch (i.fCondense && (n.condense = 1), i.fExtend && (n.extend = 1), i.fShadow && (n.shadow = 1), i.fOutline && (n.outline = 1), i.fStrikeout && (n.strike = 1), i.fItalic && (n.italic = 1), 700 === e.read_shift(2) && (n.bold = 1), e.read_shift(2)) {
            case 1:
              n.vertAlign = "superscript";
              break;
            case 2:
              n.vertAlign = "subscript";
          }
          var a = e.read_shift(1);
          0 != a && (n.underline = a);
          var o = e.read_shift(1);
          o > 0 && (n.family = o);
          var s = e.read_shift(1);
          switch (s > 0 && (n.charset = s), e.l++, n.color = Ve(e, 8), e.read_shift(1)) {
            case 1:
              n.scheme = "major";
              break;
            case 2:
              n.scheme = "minor";
          }
          return n.name = Te(e, t - 21), n;
        }
        function ii(e, t) {
          t || (t = ee(153)), t.write_shift(2, 20 * e.sz), Xe(e, t), t.write_shift(2, e.bold ? 700 : 400);
          var r = 0;
          "superscript" == e.vertAlign ? r = 1 : "subscript" == e.vertAlign && (r = 2), t.write_shift(2, r), t.write_shift(1, e.underline || 0), t.write_shift(1, e.family || 0), t.write_shift(1, e.charset || 0), t.write_shift(1, 0), qe(e.color, t);
          var n = 0;
          return "major" == e.scheme && (n = 1), "minor" == e.scheme && (n = 2), t.write_shift(1, n), ke(e.name, t), t.length > t.l ? t.slice(0, t.l) : t;
        }
        function ai(e, t) {
          t || (t = ee(84));
          var r = ib[e.patternType];
          null == r && (r = 40), t.write_shift(4, r);
          var n = 0;
          if (40 != r) for (qe({
            auto: 1
          }, t), qe({
            auto: 1
          }, t); n < 12; ++n) t.write_shift(4, 0);else {
            for (; n < 4; ++n) t.write_shift(4, 0);
            for (; n < 12; ++n) t.write_shift(4, 0);
          }
          return t.length > t.l ? t.slice(0, t.l) : t;
        }
        function oi(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(2);
          return $(e, t - 4), {
            ixfe: r,
            numFmtId: n
          };
        }
        function si(e, t, r) {
          return r || (r = ee(16)), r.write_shift(2, t || 0), r.write_shift(2, e.numFmtId || 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(1, 0), r;
        }
        function li(e, t) {
          return t || (t = ee(10)), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
        }
        function ci(e, t) {
          return t || (t = ee(51)), t.write_shift(1, 0), li(null, t), li(null, t), li(null, t), li(null, t), li(null, t), t.length > t.l ? t.slice(0, t.l) : t;
        }
        function ui(e, t) {
          return t || (t = ee(52)), t.write_shift(4, e.xfId), t.write_shift(2, 1), t.write_shift(1, +e.builtinId), t.write_shift(1, 0), Fe(e.name || "", t), t.length > t.l ? t.slice(0, t.l) : t;
        }
        function hi(e, t, r) {
          var n = ee(2052);
          return n.write_shift(4, e), Fe(t, n), Fe(r, n), n.length > n.l ? n.slice(0, n.l) : n;
        }
        function fi(e, t, r) {
          var n = {};
          n.NumberFmt = [];
          for (var i in Nc._table) n.NumberFmt[i] = Nc._table[i];
          n.CellXf = [], n.Fonts = [];
          var a = [],
            o = !1;
          return te(e, function (e, i, s) {
            switch (s) {
              case 44:
                n.NumberFmt[e[0]] = e[1], Nc.load(e[1], e[0]);
                break;
              case 43:
                n.Fonts.push(e), null != e.color.theme && t && t.themeElements && t.themeElements.clrScheme && (e.color.rgb = Nn(t.themeElements.clrScheme[e.color.theme].rgb, e.color.tint || 0));
                break;
              case 1025:
              case 45:
              case 46:
                break;
              case 47:
                "BrtBeginCellXFs" == a[a.length - 1] && n.CellXf.push(e);
                break;
              case 48:
              case 507:
              case 572:
              case 475:
                break;
              case 1171:
              case 2102:
              case 1130:
              case 512:
              case 2095:
                break;
              case 35:
                o = !0;
                break;
              case 36:
                o = !1;
                break;
              case 37:
                a.push(i);
                break;
              case 38:
                a.pop();
                break;
              default:
                if ((i || "").indexOf("Begin") > 0) a.push(i);else if ((i || "").indexOf("End") > 0) a.pop();else if (!o || r.WTF) throw new Error("Unexpected record " + s + " " + i);
            }
          }), n;
        }
        function di(e, t) {
          if (t) {
            var r = 0;
            [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (e) {
              for (var n = e[0]; n <= e[1]; ++n) null != t[n] && ++r;
            }), 0 != r && (ne(e, "BrtBeginFmts", Ae(r)), [[5, 8], [23, 26], [41, 44], [50, 392]].forEach(function (r) {
              for (var n = r[0]; n <= r[1]; ++n) null != t[n] && ne(e, "BrtFmt", ri(n, t[n]));
            }), ne(e, "BrtEndFmts"));
          }
        }
        function pi(e, t) {
          ne(e, "BrtBeginFonts", Ae(1)), ne(e, "BrtFont", ii({
            sz: 12,
            color: {
              theme: 1
            },
            name: "Calibri",
            family: 2,
            scheme: "minor"
          })), ne(e, "BrtEndFonts");
        }
        function mi(e, t) {
          ne(e, "BrtBeginFills", Ae(2)), ne(e, "BrtFill", ai({
            patternType: "none"
          })), ne(e, "BrtFill", ai({
            patternType: "gray125"
          })), ne(e, "BrtEndFills");
        }
        function gi(e, t) {
          ne(e, "BrtBeginBorders", Ae(1)), ne(e, "BrtBorder", ci({})), ne(e, "BrtEndBorders");
        }
        function vi(e, t) {
          ne(e, "BrtBeginCellStyleXFs", Ae(1)), ne(e, "BrtXF", si({
            numFmtId: 0,
            fontId: 0,
            fillId: 0,
            borderId: 0
          }, 65535)), ne(e, "BrtEndCellStyleXFs");
        }
        function bi(e, t) {
          ne(e, "BrtBeginCellXFs", Ae(t.length)), t.forEach(function (t) {
            ne(e, "BrtXF", si(t, 0));
          }), ne(e, "BrtEndCellXFs");
        }
        function yi(e, t) {
          ne(e, "BrtBeginStyles", Ae(1)), ne(e, "BrtStyle", ui({
            xfId: 0,
            builtinId: 0,
            name: "Normal"
          })), ne(e, "BrtEndStyles");
        }
        function wi(e, t) {
          ne(e, "BrtBeginDXFs", Ae(0)), ne(e, "BrtEndDXFs");
        }
        function xi(e, t) {
          ne(e, "BrtBeginTableStyles", hi(0, "TableStyleMedium9", "PivotStyleMedium4")), ne(e, "BrtEndTableStyles");
        }
        function _i(e, t) {}
        function Si(e, t) {
          var r = re();
          return ne(r, "BrtBeginStyleSheet"), di(r, e.SSF), pi(r, e), mi(r, e), gi(r, e), vi(r, e), bi(r, t.cellXfs), yi(r, e), wi(r, e), xi(r, e), _i(r, e), ne(r, "BrtEndStyleSheet"), r.end();
        }
        function Ci(e, t, r) {
          t.themeElements.clrScheme = [];
          var n = {};
          (e[0].match(Zc) || []).forEach(function (e) {
            var i = D(e);
            switch (i[0]) {
              case "<a:clrScheme":
              case "</a:clrScheme>":
                break;
              case "<a:srgbClr":
                n.rgb = i.val;
                break;
              case "<a:sysClr":
                n.rgb = i.lastClr;
                break;
              case "<a:dk1>":
              case "</a:dk1>":
              case "<a:lt1>":
              case "</a:lt1>":
              case "<a:dk2>":
              case "</a:dk2>":
              case "<a:lt2>":
              case "</a:lt2>":
              case "<a:accent1>":
              case "</a:accent1>":
              case "<a:accent2>":
              case "</a:accent2>":
              case "<a:accent3>":
              case "</a:accent3>":
              case "<a:accent4>":
              case "</a:accent4>":
              case "<a:accent5>":
              case "</a:accent5>":
              case "<a:accent6>":
              case "</a:accent6>":
              case "<a:hlink>":
              case "</a:hlink>":
              case "<a:folHlink>":
              case "</a:folHlink>":
                "/" === i[0].charAt(1) ? (t.themeElements.clrScheme.push(n), n = {}) : n.name = i[0].substring(3, i[0].length - 1);
                break;
              default:
                if (r && r.WTF) throw new Error("Unrecognized " + i[0] + " in clrScheme");
            }
          });
        }
        function Ei(e, t, r) {}
        function Ai(e, t, r) {}
        function Ti(e, t, r) {
          t.themeElements = {};
          var n;
          [["clrScheme", ab, Ci], ["fontScheme", ob, Ei], ["fmtScheme", sb, Ai]].forEach(function (i) {
            if (!(n = e.match(i[1]))) throw new Error(i[0] + " not found in themeElements");
            i[2](n, t, r);
          });
        }
        function ki(e, t) {
          if (!e || 0 === e.length) return ki(Ri());
          var r,
            n = {};
          if (!(r = e.match(lb))) throw new Error("themeElements not found in theme");
          return Ti(r[0], n, t), n;
        }
        function Ri(e, t) {
          if (t && t.themeXLSX) return t.themeXLSX;
          var r = [gu];
          return r[r.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', r[r.length] = "<a:themeElements>", r[r.length] = '<a:clrScheme name="Office">', r[r.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', r[r.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', r[r.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', r[r.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', r[r.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', r[r.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', r[r.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', r[r.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', r[r.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', r[r.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', r[r.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', r[r.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', r[r.length] = "</a:clrScheme>", r[r.length] = '<a:fontScheme name="Office">', r[r.length] = "<a:majorFont>", r[r.length] = '<a:latin typeface="Cambria"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Times New Roman"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:majorFont>", r[r.length] = "<a:minorFont>", r[r.length] = '<a:latin typeface="Calibri"/>', r[r.length] = '<a:ea typeface=""/>', r[r.length] = '<a:cs typeface=""/>', r[r.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', r[r.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', r[r.length] = '<a:font script="Hans" typeface="宋体"/>', r[r.length] = '<a:font script="Hant" typeface="新細明體"/>', r[r.length] = '<a:font script="Arab" typeface="Arial"/>', r[r.length] = '<a:font script="Hebr" typeface="Arial"/>', r[r.length] = '<a:font script="Thai" typeface="Tahoma"/>', r[r.length] = '<a:font script="Ethi" typeface="Nyala"/>', r[r.length] = '<a:font script="Beng" typeface="Vrinda"/>', r[r.length] = '<a:font script="Gujr" typeface="Shruti"/>', r[r.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', r[r.length] = '<a:font script="Knda" typeface="Tunga"/>', r[r.length] = '<a:font script="Guru" typeface="Raavi"/>', r[r.length] = '<a:font script="Cans" typeface="Euphemia"/>', r[r.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', r[r.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', r[r.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', r[r.length] = '<a:font script="Thaa" typeface="MV Boli"/>', r[r.length] = '<a:font script="Deva" typeface="Mangal"/>', r[r.length] = '<a:font script="Telu" typeface="Gautami"/>', r[r.length] = '<a:font script="Taml" typeface="Latha"/>', r[r.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', r[r.length] = '<a:font script="Orya" typeface="Kalinga"/>', r[r.length] = '<a:font script="Mlym" typeface="Kartika"/>', r[r.length] = '<a:font script="Laoo" typeface="DokChampa"/>', r[r.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', r[r.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', r[r.length] = '<a:font script="Viet" typeface="Arial"/>', r[r.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', r[r.length] = '<a:font script="Geor" typeface="Sylfaen"/>', r[r.length] = "</a:minorFont>", r[r.length] = "</a:fontScheme>", r[r.length] = '<a:fmtScheme name="Office">', r[r.length] = "<a:fillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="1"/>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:lin ang="16200000" scaled="0"/>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:fillStyleLst>", r[r.length] = "<a:lnStyleLst>", r[r.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', r[r.length] = "</a:lnStyleLst>", r[r.length] = "<a:effectStyleLst>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = "</a:effectStyle>", r[r.length] = "<a:effectStyle>", r[r.length] = "<a:effectLst>", r[r.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', r[r.length] = "</a:effectLst>", r[r.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', r[r.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', r[r.length] = "</a:effectStyle>", r[r.length] = "</a:effectStyleLst>", r[r.length] = "<a:bgFillStyleLst>", r[r.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = '<a:gradFill rotWithShape="1">', r[r.length] = "<a:gsLst>", r[r.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', r[r.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', r[r.length] = "</a:gsLst>", r[r.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', r[r.length] = "</a:gradFill>", r[r.length] = "</a:bgFillStyleLst>", r[r.length] = "</a:fmtScheme>", r[r.length] = "</a:themeElements>", r[r.length] = "<a:objectDefaults>", r[r.length] = "<a:spDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', r[r.length] = "</a:spDef>", r[r.length] = "<a:lnDef>", r[r.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', r[r.length] = "</a:lnDef>", r[r.length] = "</a:objectDefaults>", r[r.length] = "<a:extraClrSchemeLst/>", r[r.length] = "</a:theme>", r.join("");
        }
        function Ii(e, t, r) {
          124226 !== e.read_shift(4) && (e.l += t - 4);
        }
        function Mi(e, t) {
          return e.read_shift(4);
        }
        function Oi(e, t) {
          var r = {};
          switch (r.xclrType = e.read_shift(2), r.nTintShade = e.read_shift(2), r.xclrType) {
            case 0:
              e.l += 4;
              break;
            case 1:
              r.xclrValue = Pi(e, 4);
              break;
            case 2:
              r.xclrValue = qt(e, 4);
              break;
            case 3:
              r.xclrValue = Mi(e, 4);
              break;
            case 4:
              e.l += 4;
          }
          return e.l += 8, r;
        }
        function Pi(e, t) {
          return $(e, t);
        }
        function Bi(e, t) {
          return $(e, t);
        }
        function Di(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(2),
            i = [r];
          switch (r) {
            case 4:
            case 5:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 13:
              i[1] = Oi(e, n);
              break;
            case 6:
              i[1] = Bi(e, n);
              break;
            case 14:
            case 15:
              i[1] = e.read_shift(5 === n ? 1 : 2);
              break;
            default:
              throw new Error("Unrecognized ExtProp type: " + r + " " + n);
          }
          return i;
        }
        function Li(e, t) {
          var r = e.l + t;
          e.l += 2;
          var n = e.read_shift(2);
          e.l += 2;
          for (var i = e.read_shift(2), a = []; i-- > 0;) a.push(Di(e, r - e.l));
          return {
            ixfe: n,
            ext: a
          };
        }
        function Fi(e, t) {
          t.forEach(function (e) {
            e[0];
          });
        }
        function Ni(e, t) {
          var r = [];
          if (!e) return r;
          var n = 1;
          return (e.match(Zc) || []).forEach(function (e) {
            var t = D(e);
            switch (t[0]) {
              case "<?xml":
                break;
              case "<calcChain":
              case "<calcChain>":
              case "</calcChain>":
                break;
              case "<c":
                delete t[0], t.i ? n = t.i : t.i = n, r.push(t);
            }
          }), r;
        }
        function Ui(e, t) {
          var r = {};
          r.i = e.read_shift(4);
          var n = {};
          n.r = e.read_shift(4), n.c = e.read_shift(4), r.r = be(n);
          var i = e.read_shift(1);
          return 2 & i && (r.l = "1"), 8 & i && (r.a = "1"), r;
        }
        function ji(e, t) {
          var r = [];
          return te(e, function (e, t, n) {
            switch (n) {
              case 63:
                r.push(e);
                break;
              default:
                if ((t || "").indexOf("Begin") > 0) ;else if (!((t || "").indexOf("End") > 0)) throw new Error("Unexpected record " + n + " " + t);
            }
          }), r;
        }
        function zi(e, t) {
          if (!e) return "??";
          var r = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
          return t["!id"][r].Target;
        }
        function Hi(e, t) {
          for (var r = [21600, 21600], n = ["m0,0l0", r[1], r[0], r[1], r[0], "0xe"].join(","), i = [V("xml", null, {
              "xmlns:v": wu.v,
              "xmlns:o": wu.o,
              "xmlns:x": wu.x,
              "xmlns:mv": wu.mv
            }).replace(/\/>/, ">"), V("o:shapelayout", V("o:idmap", null, {
              "v:ext": "edit",
              data: e
            }), {
              "v:ext": "edit"
            }), V("v:shapetype", [V("v:stroke", null, {
              joinstyle: "miter"
            }), V("v:path", null, {
              gradientshapeok: "t",
              "o:connecttype": "rect"
            })].join(""), {
              id: "_x0000_t202",
              "o:spt": 202,
              coordsize: r.join(","),
              path: n
            })]; cb < 1e3 * e;) cb += 1e3;
          return t.map(function (e) {
            return ve(e[0]);
          }).forEach(function (e, t) {
            i = i.concat(["<v:shape" + G({
              id: "_x0000_s" + ++cb,
              type: "#_x0000_t202",
              style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10;visibility:hidden",
              fillcolor: "#ECFAD4",
              strokecolor: "#edeaa1"
            }) + ">", V("v:fill", V("o:fill", null, {
              type: "gradientUnscaled",
              "v:ext": "view"
            }), {
              color2: "#BEFF82",
              angle: "-180",
              type: "gradient"
            }), V("v:shadow", null, {
              on: "t",
              obscured: "t"
            }), V("v:path", null, {
              "o:connecttype": "none"
            }), '<v:textbox><div style="text-align:left"></div></v:textbox>', '<x:ClientData ObjectType="Note">', "<x:MoveWithCells/>", "<x:SizeWithCells/>", H("x:Anchor", [e.c, 0, e.r, 0, e.c + 3, 100, e.r + 5, 100].join(",")), H("x:AutoFill", "False"), H("x:Row", String(e.r)), H("x:Column", String(e.c)), "<x:Visible/>", "</x:ClientData>", "</v:shape>"]);
          }), i.push("</xml>"), i.join("");
        }
        function Gi(e, t, r, n, i) {
          for (var a = 0; a != t.length; ++a) {
            var o = t[a],
              s = rl(O(e, o.replace(/^\//, ""), !0), o, i);
            if (s && s.length) for (var l = m(r), c = 0; c != l.length; ++c) {
              var u = l[c],
                h = n[u];
              if (h) {
                var f = h[o];
                f && Vi(u, r[u], s);
              }
            }
          }
        }
        function Vi(e, t, r) {
          var n,
            i,
            a = Array.isArray(t);
          r.forEach(function (e) {
            if (a ? (i = ve(e.ref), t[i.r] || (t[i.r] = []), n = t[i.r][i.c]) : n = t[e.ref], !n) {
              n = {}, a ? t[i.r][i.c] = n : t[e.ref] = n;
              var r = xe(t["!ref"] || "BDWGO1000001:A1"),
                o = ve(e.ref);
              r.s.r > o.r && (r.s.r = o.r), r.e.r < o.r && (r.e.r = o.r), r.s.c > o.c && (r.s.c = o.c), r.e.c < o.c && (r.e.c = o.c);
              var s = we(r);
              s !== t["!ref"] && (t["!ref"] = s);
            }
            n.c || (n.c = []);
            var l = {
              a: e.author,
              t: e.t,
              r: e.r
            };
            e.h && (l.h = e.h), n.c.push(l);
          });
        }
        function qi(e, t) {
          if (e.match(/<(?:\w+:)?comments *\/>/)) return [];
          var r = [],
            n = [],
            i = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
          i && i[1] && i[1].split(/<\/\w*:?author>/).forEach(function (e) {
            if ("" !== e && "" !== e.trim()) {
              var t = e.match(/<(?:\w+:)?author[^>]*>(.*)/);
              t && r.push(t[1]);
            }
          });
          var a = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
          return a && a[1] && a[1].split(/<\/\w*:?comment>/).forEach(function (e, i) {
            if ("" !== e && "" !== e.trim()) {
              var a = e.match(/<(?:\w+:)?comment[^>]*>/);
              if (a) {
                var o = D(a[0]),
                  s = {
                    author: o.authorId && r[o.authorId] ? r[o.authorId] : "sheetjsghost",
                    ref: o.ref,
                    guid: o.guid
                  },
                  l = ve(o.ref);
                if (!(t.sheetRows && t.sheetRows <= l.r)) {
                  var c = e.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/),
                    u = !!c && !!c[1] && sn(c[1]) || {
                      r: "",
                      t: "",
                      h: ""
                    };
                  s.r = u.r, "<t></t>" == u.r && (u.t = u.h = ""), s.t = u.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n"), t.cellHTML && (s.h = u.h), n.push(s);
                }
              }
            }
          }), n;
        }
        function Wi(e, t) {
          var r = [gu, ub],
            n = [];
          return r.push("<authors>"), e.map(function (e) {
            return e[1];
          }).forEach(function (e) {
            e.map(function (e) {
              return F(e.a);
            }).forEach(function (e) {
              n.indexOf(e) > -1 || (n.push(e), r.push("<author>" + e + "</author>"));
            });
          }), r.push("</authors>"), r.push("<commentList>"), e.forEach(function (e) {
            e[1].forEach(function (t) {
              r.push('<comment ref="' + e[0] + '" authorId="' + n.indexOf(F(t.a)) + '"><text>'), r.push(H("t", null == t.t ? "" : t.t)), r.push("</text></comment>");
            });
          }), r.push("</commentList>"), r.length > 2 && (r[r.length] = "</comments>", r[1] = r[1].replace("/>", ">")), r.join("");
        }
        function Xi(e, t) {
          var r = {};
          r.iauthor = e.read_shift(4);
          var n = Qu(e, 16);
          return r.rfx = n.s, r.ref = be(n.s), e.l += 16, r;
        }
        function Yi(e, t) {
          return null == t && (t = ee(36)), t.write_shift(4, e[1].iauthor), $u(e[0], t), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t;
        }
        function Ki(e) {
          return ke(e.substr(0, 54));
        }
        function Zi(e, t) {
          var r = [],
            n = [],
            i = {},
            a = !1;
          return te(e, function (e, o, s) {
            switch (s) {
              case 632:
                n.push(e);
                break;
              case 635:
                i = e;
                break;
              case 637:
                i.t = e.t, i.h = e.h, i.r = e.r;
                break;
              case 636:
                if (i.author = n[i.iauthor], delete i.iauthor, t.sheetRows && t.sheetRows <= i.rfx.r) break;
                i.t || (i.t = ""), delete i.rfx, r.push(i);
                break;
              case 35:
                a = !0;
                break;
              case 36:
                a = !1;
                break;
              case 37:
              case 38:
                break;
              default:
                if ((o || "").indexOf("Begin") > 0) ;else if ((o || "").indexOf("End") > 0) ;else if (!a || t.WTF) throw new Error("Unexpected record " + s + " " + o);
            }
          }), r;
        }
        function Ji(e, t) {
          var r = re(),
            n = [];
          return ne(r, "BrtBeginComments"), ne(r, "BrtBeginCommentAuthors"), e.forEach(function (e) {
            e[1].forEach(function (e) {
              n.indexOf(e.a) > -1 || (n.push(e.a.substr(0, 54)), ne(r, "BrtCommentAuthor", Ki(e.a)));
            });
          }), ne(r, "BrtEndCommentAuthors"), ne(r, "BrtBeginCommentList"), e.forEach(function (e) {
            e[1].forEach(function (t) {
              t.iauthor = n.indexOf(t.a);
              var i = {
                s: ve(e[0]),
                e: ve(e[0])
              };
              ne(r, "BrtBeginComment", Yi([i, t])), t.t && t.t.length > 0 && ne(r, "BrtCommentText", Pe(t)), ne(r, "BrtEndComment"), delete t.iauthor;
            });
          }), ne(r, "BrtEndCommentList"), ne(r, "BrtEndComments"), r.end();
        }
        function Qi(e, t, r, n, i, a) {
          return {
            "!type": "dialog"
          };
        }
        function $i(e, t, r, n, i, a) {
          return {
            "!type": "dialog"
          };
        }
        function ea(e, t, r, n, i, a) {
          return {
            "!type": "macro"
          };
        }
        function ta(e, t, r, n, i, a) {
          return {
            "!type": "macro"
          };
        }
        function ra(e, t) {
          return e.replace(db, function (e, r, n, i, a, o, s, l) {
            return r + ("$" == n ? n + i : de(fe(i) + t.c)) + ("$" == a ? a + o : ce(le(o) + t.r));
          });
        }
        function na(e, t, r) {
          var n = ye(t),
            i = n.s,
            a = ve(r);
          return ra(e, {
            r: a.r - i.r,
            c: a.c - i.c
          });
        }
        function ia(e) {
          e.l += 1;
        }
        function aa(e, t) {
          var r = e.read_shift(1 == t ? 1 : 2);
          return [16383 & r, r >> 14 & 1, r >> 15 & 1];
        }
        function oa(e, t, r) {
          var n = 2;
          if (r) {
            if (r.biff >= 2 && r.biff <= 5) return sa(e);
            12 == r.biff && (n = 4);
          }
          var i = e.read_shift(n),
            a = e.read_shift(n),
            o = aa(e, 2),
            s = aa(e, 2);
          return {
            s: {
              r: i,
              c: o[0],
              cRel: o[1],
              rRel: o[2]
            },
            e: {
              r: a,
              c: s[0],
              cRel: s[1],
              rRel: s[2]
            }
          };
        }
        function sa(e) {
          var t = aa(e, 2),
            r = aa(e, 2),
            n = e.read_shift(1),
            i = e.read_shift(1);
          return {
            s: {
              r: t[0],
              c: n,
              cRel: t[1],
              rRel: t[2]
            },
            e: {
              r: r[0],
              c: i,
              cRel: r[1],
              rRel: r[2]
            }
          };
        }
        function la(e, t) {
          var r = e.read_shift(12 == t ? 4 : 2),
            n = e.read_shift(12 == t ? 4 : 2),
            i = aa(e, 2),
            a = aa(e, 2);
          return {
            s: {
              r: r,
              c: i[0],
              cRel: i[1],
              rRel: i[2]
            },
            e: {
              r: n,
              c: a[0],
              cRel: a[1],
              rRel: a[2]
            }
          };
        }
        function ca(e, t, r) {
          if (r && r.biff >= 2 && r.biff <= 5) return ua(e, t, r);
          var n = e.read_shift(r && 12 == r.biff ? 4 : 2),
            i = aa(e, 2);
          return {
            r: n,
            c: i[0],
            cRel: i[1],
            rRel: i[2]
          };
        }
        function ua(e, t, r) {
          var n = aa(e, 2),
            i = e.read_shift(1);
          return {
            r: n[0],
            c: i,
            cRel: n[1],
            rRel: n[2]
          };
        }
        function ha(e, t, r) {
          var n = r && r.biff ? r.biff : 8;
          if (n >= 2 && n <= 5) return fa(e, t);
          var i = e.read_shift(n >= 12 ? 4 : 2),
            a = e.read_shift(2),
            o = (32768 & a) >> 15,
            s = (16384 & a) >> 14;
          if (a &= 16383, 1 == s) for (; i > 524287;) i -= 1048576;
          if (1 == o) for (; a > 8191;) a -= 16384;
          return {
            r: i,
            c: a,
            cRel: o,
            rRel: s
          };
        }
        function fa(e, t) {
          var r = e.read_shift(2),
            n = e.read_shift(1),
            i = (32768 & r) >> 15,
            a = (16384 & r) >> 14;
          return r &= 16383, 1 == i && r >= 8192 && (r -= 16384), 1 == a && n >= 128 && (n -= 256), {
            r: r,
            c: n,
            cRel: a,
            rRel: i
          };
        }
        function da(e, t, r) {
          return [(96 & e[e.l++]) >> 5, oa(e, r.biff >= 2 && r.biff <= 5 ? 6 : 8, r)];
        }
        function pa(e, t, r) {
          var n = (96 & e[e.l++]) >> 5,
            i = e.read_shift(2, "i"),
            a = 8;
          if (r) switch (r.biff) {
            case 5:
              e.l += 12, a = 6;
              break;
            case 12:
              a = 12;
          }
          return [n, i, oa(e, a, r)];
        }
        function ma(e, t, r) {
          var n = (96 & e[e.l++]) >> 5;
          return e.l += r && r.biff > 8 ? 12 : 8, [n];
        }
        function ga(e, t, r) {
          var n = (96 & e[e.l++]) >> 5,
            i = e.read_shift(2),
            a = 8;
          if (r) switch (r.biff) {
            case 5:
              e.l += 12, a = 6;
              break;
            case 12:
              a = 12;
          }
          return e.l += a, [n, i];
        }
        function va(e, t, r) {
          return [(96 & e[e.l++]) >> 5, la(e, r && r.biff > 8 ? 12 : 8, r)];
        }
        function ba(e, t, r) {
          var n = (96 & e[e.l++]) >> 5;
          return e.l += 2 == r.biff ? 6 : 12 == r.biff ? 14 : 7, [n];
        }
        function ya(e, t) {
          var r = 1 & e[e.l + 1];
          return e.l += 4, [r, 1];
        }
        function wa(e, t, r) {
          e.l += 2;
          for (var n = e.read_shift(r && 2 == r.biff ? 1 : 2), i = [], a = 0; a <= n; ++a) i.push(e.read_shift(r && 2 == r.biff ? 1 : 2));
          return i;
        }
        function xa(e, t, r) {
          var n = 255 & e[e.l + 1] ? 1 : 0;
          return e.l += 2, [n, e.read_shift(r && 2 == r.biff ? 1 : 2)];
        }
        function _a(e, t, r) {
          var n = 255 & e[e.l + 1] ? 1 : 0;
          return e.l += 2, [n, e.read_shift(r && 2 == r.biff ? 1 : 2)];
        }
        function Sa(e, t) {
          var r = 255 & e[e.l + 1] ? 1 : 0;
          return e.l += 2, [r, e.read_shift(2)];
        }
        function Ca(e, t, r) {
          var n = 255 & e[e.l + 1] ? 1 : 0;
          return e.l += r && 2 == r.biff ? 3 : 4, [n];
        }
        function Ea(e, t) {
          return [e.read_shift(1), e.read_shift(1)];
        }
        function Aa(e, t) {
          return e.read_shift(2), Ea(e, 2);
        }
        function Ta(e, t) {
          return e.read_shift(2), Ea(e, 2);
        }
        function ka(e, t, r) {
          var n = (e[e.l], (96 & e[e.l]) >> 5);
          return e.l += 1, [n, ca(e, 0, r)];
        }
        function Ra(e, t, r) {
          var n = (96 & e[e.l]) >> 5;
          return e.l += 1, [n, ha(e, 0, r)];
        }
        function Ia(e, t, r) {
          var n = (96 & e[e.l]) >> 5;
          return e.l += 1, [n, e.read_shift(2), ca(e, 0, r)];
        }
        function Ma(e, t, r) {
          var n = (e[e.l], (96 & e[e.l]) >> 5);
          e.l += 1;
          var i = e.read_shift(r && r.biff <= 3 ? 1 : 2);
          return [Kb[i], Yb[i], n];
        }
        function Oa(e, t, r) {
          e.l++;
          var n = e.read_shift(1),
            i = r && r.biff <= 3 ? [0, e.read_shift(1)] : Pa(e);
          return [n, (0 === i[0] ? Yb : Xb)[i[1]]];
        }
        function Pa(e, t) {
          return [e[e.l + 1] >> 7, 32767 & e.read_shift(2)];
        }
        function Ba(e, t, r) {
          e.l += r && 2 == r.biff ? 3 : 4;
        }
        function Da(e, t, r) {
          return e.l++, r && 12 == r.biff ? [e.read_shift(4, "i"), 0] : [e.read_shift(2), e.read_shift(r && 2 == r.biff ? 1 : 2)];
        }
        function La(e, t) {
          return e.l++, eh[e.read_shift(1)];
        }
        function Fa(e, t) {
          return e.l++, e.read_shift(2);
        }
        function Na(e, t) {
          return e.l++, 0 !== e.read_shift(1);
        }
        function Ua(e, t) {
          return e.l++, He(e, 8);
        }
        function ja(e, t, r) {
          return e.l++, Ut(e, t - 1, r);
        }
        function za(e, t) {
          var r = [e.read_shift(1)];
          if (12 == t) switch (r[0]) {
            case 2:
              r[0] = 4;
              break;
            case 4:
              r[0] = 16;
              break;
            case 0:
              r[0] = 1;
              break;
            case 1:
              r[0] = 2;
          }
          switch (r[0]) {
            case 4:
              r[1] = Dt(e, 1) ? "TRUE" : "FALSE", e.l += 7;
              break;
            case 16:
              r[1] = eh[e[e.l]], e.l += 8;
              break;
            case 0:
              e.l += 8;
              break;
            case 1:
              r[1] = He(e, 8);
              break;
            case 2:
              r[1] = Gt(e, 0, {
                biff: t > 0 && t < 8 ? 2 : t
              });
          }
          return r;
        }
        function Ha(e, t) {
          for (var r = e.read_shift(2), n = [], i = 0; i != r; ++i) n.push($t(e, 8));
          return n;
        }
        function Ga(e, t, r) {
          var n = 0,
            i = 0;
          12 == r.biff ? (n = e.read_shift(4), i = e.read_shift(4)) : (i = 1 + e.read_shift(1), n = 1 + e.read_shift(2)), r.biff >= 2 && r.biff < 8 && (--n, 0 == --i && (i = 256));
          for (var a = 0, o = []; a != n && (o[a] = []); ++a) for (var s = 0; s != i; ++s) o[a][s] = za(e, r.biff);
          return o;
        }
        function Va(e, t, r) {
          var n = e.read_shift(1) >>> 5 & 3,
            i = !r || r.biff >= 8 ? 4 : 2,
            a = e.read_shift(i);
          switch (r.biff) {
            case 2:
              e.l += 5;
              break;
            case 3:
            case 4:
              e.l += 8;
              break;
            case 5:
              e.l += 12;
          }
          return [n, 0, a];
        }
        function qa(e, t, r) {
          return 5 == r.biff ? Wa(e, t, r) : [e.read_shift(1) >>> 5 & 3, e.read_shift(2), e.read_shift(4)];
        }
        function Wa(e, t, r) {
          var n = e.read_shift(1) >>> 5 & 3,
            i = e.read_shift(2, "i");
          e.l += 8;
          var a = e.read_shift(2);
          return e.l += 12, [n, i, a];
        }
        function Xa(e, t, r) {
          var n = e.read_shift(1) >>> 5 & 3;
          return e.l += r && 2 == r.biff ? 3 : 4, [n, e.read_shift(r && 2 == r.biff ? 1 : 2)];
        }
        function Ya(e, t, r) {
          return [e.read_shift(1) >>> 5 & 3, e.read_shift(r && 2 == r.biff ? 1 : 2)];
        }
        function Ka(e, t, r) {
          var n = e.read_shift(1) >>> 5 & 3;
          return e.l += 4, 12 == r.biff && (e.l += 2), [n];
        }
        function Za(e, t, r) {
          var n = (96 & e[e.l++]) >> 5,
            i = e.read_shift(2),
            a = 4;
          if (r) switch (r.biff) {
            case 5:
              throw new Error("PtgRefErr3d -- 5");
            case 12:
              a = 6;
          }
          return e.l += a, [n, i];
        }
        function Ja(e, t, r) {
          var n = e.l + t,
            i = Xt(e, 6);
          2 == r.biff && ++e.l;
          var a = Qa(e),
            o = e.read_shift(1);
          if (2 != r.biff && (e.read_shift(1), r.biff >= 5)) {
            e.read_shift(4);
          }
          var s = to(e, n - e.l, r);
          return {
            cell: i,
            val: a[0],
            formula: s,
            shared: o >> 3 & 1,
            tt: a[1]
          };
        }
        function Qa(e) {
          var t;
          if (65535 !== Nu(e, e.l + 6)) return [He(e), "n"];
          switch (e[e.l]) {
            case 0:
              return e.l += 8, ["String", "s"];
            case 1:
              return t = 1 === e[e.l + 2], e.l += 8, [t, "b"];
            case 2:
              return t = e[e.l + 2], e.l += 8, [t, "e"];
            case 3:
              return e.l += 8, ["", "s"];
          }
          return [];
        }
        function $a(e, t, r, n) {
          if (n.biff < 8) return $(e, t);
          for (var i = e.l + t, a = [], o = 0; o !== r.length; ++o) switch (r[o][0]) {
            case "PtgArray":
              r[o][1] = Ga(e, 0, n), a.push(r[o][1]);
              break;
            case "PtgMemArea":
              r[o][2] = Ha(e, r[o][1]), a.push(r[o][2]);
              break;
            case "PtgExp":
              n && 12 == n.biff && (r[o][1][1] = e.read_shift(4), a.push(r[o][1]));
          }
          return t = i - e.l, 0 !== t && a.push($(e, t)), a;
        }
        function eo(e, t, r, n) {
          var i,
            a = e.l + t,
            o = io(e, n, r);
          return a !== e.l && (i = $a(e, a - e.l, o, r)), [o, i];
        }
        function to(e, t, r) {
          var n,
            i = (e.l, 2 == r.biff ? 1 : 2),
            a = e.read_shift(i);
          if (65535 == a) return [[], $(e, t - 2)];
          var o = io(e, a, r);
          return t !== a + i && (n = $a(e, t - a - i, o, r)), [o, n];
        }
        function ro(e, t, r) {
          var n,
            i = e.l + t,
            a = e.read_shift(2),
            o = io(e, a, r);
          return 65535 == a ? [[], $(e, t - 2)] : (t !== a + 2 && (n = $a(e, i - a - 2, o, r)), [o, n]);
        }
        function no(e, t, r, n) {
          var i,
            a = (e.l, 2 == r.biff ? 1 : 2),
            o = e.read_shift(a);
          if (65535 == o) return [[], $(e, t - 2)];
          var s = io(e, o, r);
          return t !== o + a && (i = $a(e, t - o - a, s, r)), [s, i];
        }
        function io(e, t, r) {
          for (var n, i, a = e.l + t, o = []; a != e.l;) t = a - e.l, i = e[e.l], n = Nb[i], 24 !== i && 25 !== i || (i = e[e.l + 1], n = (24 === i ? jb : zb)[i]), n && n.f ? o.push([n.n, n.f(e, t, r)]) : $(e, t);
          return o;
        }
        function ao(e) {
          for (var t = [], r = 0; r < e.length; ++r) {
            for (var n = e[r], i = [], a = 0; a < n.length; ++a) {
              var o = n[a];
              if (o) switch (o[0]) {
                case 2:
                  i.push('"' + o[1].replace(/"/g, '""') + '"');
                  break;
                default:
                  i.push(o[1]);
              } else i.push("");
            }
            t.push(i.join(","));
          }
          return t.join(";");
        }
        function oo(e, t, r) {
          return e.SheetNames[t];
        }
        function so(e, t, r, n, i) {
          var a,
            o,
            s,
            l,
            c = {
              s: {
                c: 0,
                r: 0
              },
              e: {
                c: 0,
                r: 0
              }
            },
            u = [],
            h = 0,
            f = 0,
            d = "";
          if (!e[0] || !e[0][0]) return "";
          for (var p = -1, m = "", g = 0, v = e[0].length; g < v; ++g) {
            var b = e[0][g];
            switch (b[0]) {
              case "PtgUminus":
                u.push("-" + u.pop());
                break;
              case "PtgUplus":
                u.push("+" + u.pop());
                break;
              case "PtgPercent":
                u.push(u.pop() + "%");
                break;
              case "PtgAdd":
              case "PtgConcat":
              case "PtgDiv":
              case "PtgEq":
              case "PtgGe":
              case "PtgGt":
              case "PtgLe":
              case "PtgLt":
              case "PtgMul":
              case "PtgNe":
              case "PtgPower":
              case "PtgSub":
                if (a = u.pop(), o = u.pop(), p >= 0) {
                  switch (e[0][p][1][0]) {
                    case 0:
                      m = E(" ", e[0][p][1][1]);
                      break;
                    case 1:
                      m = E("\r", e[0][p][1][1]);
                      break;
                    default:
                      if (m = "", i.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][p][1][0]);
                  }
                  o += m, p = -1;
                }
                u.push(o + Hb[b[0]] + a);
                break;
              case "PtgIsect":
                a = u.pop(), o = u.pop(), u.push(o + " " + a);
                break;
              case "PtgUnion":
                a = u.pop(), o = u.pop(), u.push(o + "," + a);
                break;
              case "PtgRange":
                a = u.pop(), o = u.pop(), u.push(o + ":" + a);
                break;
              case "PtgAttrChoose":
              case "PtgAttrGoto":
              case "PtgAttrIf":
              case "PtgAttrIfError":
                break;
              case "PtgRef":
                b[1][0], s = ie(b[1][1], c, i), u.push(oe(s));
                break;
              case "PtgRefN":
                b[1][0], s = r ? ie(b[1][1], r, i) : b[1][1], u.push(oe(s));
                break;
              case "PtgRef3d":
                b[1][0], h = b[1][1], s = ie(b[1][2], c, i), d = oo(n, h, i);
                u.push(d + "!" + oe(s));
                break;
              case "PtgFunc":
              case "PtgFuncVar":
                var y = b[1][0],
                  w = b[1][1];
                y || (y = 0);
                var x = 0 == y ? [] : u.slice(-y);
                u.length -= y, "User" === w && (w = x.shift()), u.push(w + "(" + x.join(",") + ")");
                break;
              case "PtgBool":
                u.push(b[1] ? "TRUE" : "FALSE");
                break;
              case "PtgInt":
                u.push(b[1]);
                break;
              case "PtgNum":
                u.push(String(b[1]));
                break;
              case "PtgStr":
                u.push('"' + b[1] + '"');
                break;
              case "PtgErr":
                u.push(b[1]);
                break;
              case "PtgAreaN":
              case "PtgArea":
                b[1][0], l = ae(b[1][1], c, i), u.push(se(l, i));
                break;
              case "PtgArea3d":
                b[1][0], h = b[1][1], l = b[1][2], d = n && n[1] ? n[1][h + 1] : "**MISSING**", u.push(d + "!" + we(l));
                break;
              case "PtgAttrSum":
                u.push("SUM(" + u.pop() + ")");
                break;
              case "PtgAttrSemi":
                break;
              case "PtgName":
                f = b[1][2];
                var _ = (n.names || [])[f - 1] || (n[0] || [])[f],
                  S = _ ? _.Name : "SH33TJSERR7" + String(f);
                S in Zb && (S = Zb[S]), u.push(S);
                break;
              case "PtgNameX":
                var C = b[1][1];
                f = b[1][2];
                var A;
                if (!(i.biff <= 5)) {
                  var T = (n.SheetNames[C], "");
                  14849 == ((n[C] || [])[0] || [])[0] || (1025 == ((n[C] || [])[0] || [])[0] ? n[C][f] && n[C][f].itab > 0 && (T = n.SheetNames[n[C][f].itab - 1] + "!") : T = n.SheetNames[f - 1] + "!"), n[C] && n[C][f] ? T += n[C][f].Name : n[0] && n[0][f] ? T += n[0][f].Name : T += "SH33TJSERRX", u.push(T);
                  break;
                }
                C < 0 && (C = -C), n[C] && (A = n[C][f]), A || (A = {
                  Name: "SH33TJSERRY"
                }), u.push(A.Name);
                break;
              case "PtgParen":
                var k = "(",
                  R = ")";
                if (p >= 0) {
                  switch (m = "", e[0][p][1][0]) {
                    case 2:
                      k = E(" ", e[0][p][1][1]) + k;
                      break;
                    case 3:
                      k = E("\r", e[0][p][1][1]) + k;
                      break;
                    case 4:
                      R = E(" ", e[0][p][1][1]) + R;
                      break;
                    case 5:
                      R = E("\r", e[0][p][1][1]) + R;
                      break;
                    default:
                      if (i.WTF) throw new Error("Unexpected PtgAttrSpaceType " + e[0][p][1][0]);
                  }
                  p = -1;
                }
                u.push(k + u.pop() + R);
                break;
              case "PtgRefErr":
              case "PtgRefErr3d":
                u.push("#REF!");
                break;
              case "PtgExp":
                s = {
                  c: b[1][1],
                  r: b[1][0]
                };
                var I = {
                  c: r.c,
                  r: r.r
                };
                if (n.sharedf[be(s)]) {
                  var M = n.sharedf[be(s)];
                  u.push(so(M, c, I, n, i));
                } else {
                  var O = !1;
                  for (a = 0; a != n.arrayf.length; ++a) if (o = n.arrayf[a], !(s.c < o[0].s.c || s.c > o[0].e.c || s.r < o[0].s.r || s.r > o[0].e.r)) {
                    u.push(so(o[1], c, I, n, i)), O = !0;
                    break;
                  }
                  O || u.push(b[1]);
                }
                break;
              case "PtgArray":
                u.push("{" + ao(b[1]) + "}");
                break;
              case "PtgMemArea":
                break;
              case "PtgAttrSpace":
              case "PtgAttrSpaceSemi":
                p = g;
                break;
              case "PtgTbl":
              case "PtgMemErr":
                break;
              case "PtgMissArg":
                u.push("");
                break;
              case "PtgAreaErr":
              case "PtgAreaErr3d":
                u.push("#REF!");
                break;
              case "PtgMemFunc":
                break;
              default:
                throw new Error("Unrecognized Formula Token: " + String(b));
            }
            var P = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
            if (p >= 0 && -1 == P.indexOf(e[0][g][0])) {
              b = e[0][p];
              var B = !0;
              switch (b[1][0]) {
                case 4:
                  B = !1;
                case 0:
                  m = E(" ", b[1][1]);
                  break;
                case 5:
                  B = !1;
                case 1:
                  m = E("\r", b[1][1]);
                  break;
                default:
                  if (m = "", i.WTF) throw new Error("Unexpected PtgAttrSpaceType " + b[1][0]);
              }
              u.push((B ? m : "") + u.pop() + (B ? "" : m)), p = -1;
            }
          }
          if (u.length > 1 && i.WTF) throw new Error("bad formula stack");
          return u[0];
        }
        function lo(e, t, r) {
          var n = (e.l, e.read_shift(4)),
            i = io(e, n, r),
            a = e.read_shift(4);
          return [i, a > 0 ? $a(e, a, i, r) : null];
        }
        function co(e) {
          return "of:" == e.substr(0, 3) && (e = e.substr(3)), 61 == e.charCodeAt(0) && (e = e.substr(1), 61 == e.charCodeAt(0) && (e = e.substr(1))), e = e.replace(/COM\.MICROSOFT\./g, ""), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function (e, t) {
            return t.replace(/\./g, "");
          }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), e.replace(/[;~]/g, ",").replace(/\|/g, ";");
        }
        function uo(e) {
          return ("of:=" + e.replace(db, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":")).replace(/;/g, "|").replace(/,/g, ";");
        }
        function ho(e) {
          var t = e.split(":");
          return [t[0].split(".")[0], t[0].split(".")[1] + ":" + t[1].split(".")[1]];
        }
        function fo(e, t) {
          for (var r = 0, n = e.length; r < n; ++r) if (e[r].t === t) return e.Count++, r;
          return e[n] = {
            t: t
          }, e.Count++, e.Unique++, n;
        }
        function po(e, t) {
          var r = {
              min: e + 1,
              max: e + 1
            },
            n = -1;
          return t.MDW && (Zv = t.MDW), null != t.width ? r.customWidth = 1 : null != t.wpx ? n = jn(t.wpx) : null != t.wch && (n = t.wch), n > -1 ? (r.width = zn(n), r.customWidth = 1) : null != t.width && (r.width = t.width), t.hidden && (r.hidden = !0), r;
        }
        function mo(e, t) {
          if (e) {
            var r = [.7, .7, .75, .75, .3, .3];
            "xlml" == t && (r = [1, 1, 1, 1, .5, .5]), null == e.left && (e.left = r[0]), null == e.right && (e.right = r[1]), null == e.top && (e.top = r[2]), null == e.bottom && (e.bottom = r[3]), null == e.header && (e.header = r[4]), null == e.footer && (e.footer = r[5]);
          }
        }
        function go(e, t, r) {
          var n = r.revssf[null != t.z ? t.z : "General"],
            i = 60,
            a = e.length;
          if (null == n && r.ssf) for (; i < 392; ++i) if (null == r.ssf[i]) {
            Nc.load(t.z, i), r.ssf[i] = t.z, r.revssf[t.z] = n = i;
            break;
          }
          for (i = 0; i != a; ++i) if (e[i].numFmtId === n) return i;
          return e[a] = {
            numFmtId: n,
            fontId: 0,
            fillId: 0,
            borderId: 0,
            xfId: 0,
            applyNumberFormat: 1
          }, a;
        }
        function vo(e, t, r, n, i, a) {
          if ("z" !== e.t) {
            "d" === e.t && "string" == typeof e.v && (e.v = x(e.v));
            try {
              n.cellNF && (e.z = Nc._table[t]);
            } catch (e) {
              if (n.WTF) throw e;
            }
            if (!n || !1 !== n.cellText) try {
              if ("e" === e.t) e.w = e.w || eh[e.v];else if (0 === t) {
                if ("n" === e.t) (0 | e.v) === e.v ? e.w = Nc._general_int(e.v) : e.w = Nc._general_num(e.v);else if ("d" === e.t) {
                  var o = b(e.v);
                  e.w = (0 | o) === o ? Nc._general_int(o) : Nc._general_num(o);
                } else {
                  if (void 0 === e.v) return "";
                  e.w = Nc._general(e.v, Qb);
                }
              } else "d" === e.t ? e.w = Nc.format(t, b(e.v), Qb) : e.w = Nc.format(t, e.v, Qb);
            } catch (e) {
              if (n.WTF) throw e;
            }
            if (r) try {
              e.s = a.Fills[r], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = Nn(i.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), n.WTF && (e.s.fgColor.raw_rgb = i.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = Nn(i.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), n.WTF && (e.s.bgColor.raw_rgb = i.themeElements.clrScheme[e.s.bgColor.theme].rgb));
            } catch (e) {
              if (n.WTF) throw e;
            }
          }
        }
        function bo(e, t) {
          var r = xe(t);
          r.s.r <= r.e.r && r.s.c <= r.e.c && r.s.r >= 0 && r.s.c >= 0 && (e["!ref"] = we(r));
        }
        function yo(e, t, r, n, i, a) {
          if (!e) return e;
          null != Oc && null == t.dense && (t.dense = Oc);
          var o = t.dense ? [] : {},
            s = {
              s: {
                r: 2e6,
                c: 2e6
              },
              e: {
                r: 0,
                c: 0
              }
            },
            l = "",
            c = "",
            u = e.match(ey);
          u ? (l = e.substr(0, u.index), c = e.substr(u.index + u[0].length)) : l = c = e;
          var h = (l.match(/<(?:\w*:)?dimension/) || {
            index: -1
          }).index;
          if (h > 0) {
            var f = l.substr(h, 50).match(ry);
            f && bo(o, f[1]);
          }
          var d = [];
          if (t.cellStyles) {
            var p = l.match(ny);
            p && Eo(d, p);
          }
          u && oy(u[1], o, t, s, i, a);
          var m = c.match(iy);
          m && (o["!autofilter"] = To(m[0]));
          var g = [],
            v = c.match($b);
          if (v) for (h = 0; h != v.length; ++h) g[h] = xe(v[h].substr(v[h].indexOf('"') + 1));
          var b = c.match(ty);
          b && _o(o, b, r);
          var y = c.match(ay);
          if (y && (o["!margins"] = So(D(y[0]))), !o["!ref"] && s.e.c >= s.s.c && s.e.r >= s.s.r && (o["!ref"] = we(s)), t.sheetRows > 0 && o["!ref"]) {
            var w = xe(o["!ref"]);
            t.sheetRows < +w.e.r && (w.e.r = t.sheetRows - 1, w.e.r > s.e.r && (w.e.r = s.e.r), w.e.r < w.s.r && (w.s.r = w.e.r), w.e.c > s.e.c && (w.e.c = s.e.c), w.e.c < w.s.c && (w.s.c = w.e.c), o["!fullref"] = o["!ref"], o["!ref"] = we(w));
          }
          return d.length > 0 && (o["!cols"] = d), g.length > 0 && (o["!merges"] = g), o;
        }
        function wo(e) {
          if (0 == e.length) return "";
          for (var t = '<mergeCells count="' + e.length + '">', r = 0; r != e.length; ++r) t += '<mergeCell ref="' + we(e[r]) + '"/>';
          return t + "</mergeCells>";
        }
        function xo(e) {
          var t = {
              sheet: 1
            },
            r = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"],
            n = ["formatColumns", "formatRows", "formatCells", "insertColumns", "insertRows", "insertHyperlinks", "deleteColumns", "deleteRows", "sort", "autoFilter", "pivotTables"];
          return r.forEach(function (r) {
            null != e[r] && e[r] && (t[r] = "1");
          }), n.forEach(function (r) {
            null == e[r] || e[r] || (t[r] = "0");
          }), e.password && (t.password = In(e.password).toString(16).toUpperCase()), V("sheetProtection", null, t);
        }
        function _o(e, t, r) {
          for (var n = Array.isArray(e), i = 0; i != t.length; ++i) {
            var a = D(su(t[i]), !0);
            if (!a.ref) return;
            var o = r ? r["!id"][a.id] : null;
            o ? (a.Target = o.Target, a.location && (a.Target += "#" + a.location), a.Rel = o) : (a.Target = a.location, o = {
              Target: a.location,
              TargetMode: "Internal"
            }, a.Rel = o), a.tooltip && (a.Tooltip = a.tooltip, delete a.tooltip);
            for (var s = xe(a.ref), l = s.s.r; l <= s.e.r; ++l) for (var c = s.s.c; c <= s.e.c; ++c) {
              var u = be({
                c: c,
                r: l
              });
              n ? (e[l] || (e[l] = []), e[l][c] || (e[l][c] = {
                t: "z",
                v: void 0
              }), e[l][c].l = a) : (e[u] || (e[u] = {
                t: "z",
                v: void 0
              }), e[u].l = a);
            }
          }
        }
        function So(e) {
          var t = {};
          return ["left", "right", "top", "bottom", "header", "footer"].forEach(function (r) {
            e[r] && (t[r] = parseFloat(e[r]));
          }), t;
        }
        function Co(e) {
          return mo(e), V("pageMargins", null, e);
        }
        function Eo(e, t) {
          for (var r = !1, n = 0; n != t.length; ++n) {
            var i = D(t[n], !0);
            i.hidden && (i.hidden = j(i.hidden));
            var a = parseInt(i.min, 10) - 1,
              o = parseInt(i.max, 10) - 1;
            for (delete i.min, delete i.max, i.width = +i.width, !r && i.width && (r = !0, Gn(i.width)), Vn(i); a <= o;) e[a++] = C(i);
          }
        }
        function Ao(e, t) {
          for (var r, n = ["<cols>"], i = 0; i != t.length; ++i) (r = t[i]) && (n[n.length] = V("col", null, po(i, r)));
          return n[n.length] = "</cols>", n.join("");
        }
        function To(e) {
          return {
            ref: (e.match(/ref="([^"]*)"/) || [])[1]
          };
        }
        function ko(e) {
          return V("autoFilter", null, {
            ref: e.ref
          });
        }
        function Ro(e, t, r, n) {
          return V("sheetViews", V("sheetView", null, {
            workbookViewId: "0"
          }), {});
        }
        function Io(e, t, r, n, i, a) {
          if (void 0 === e.v && void 0 === e.f || "z" === e.t) return "";
          var o = "",
            s = e.t,
            l = e.v;
          switch (e.t) {
            case "b":
              o = e.v ? "1" : "0";
              break;
            case "n":
              o = "" + e.v;
              break;
            case "e":
              o = eh[e.v];
              break;
            case "d":
              n.cellDates ? o = x(e.v, -1).toISOString() : (e.t = "n", o = "" + (e.v = b(x(e.v)))), void 0 === e.z && (e.z = Nc._table[14]);
              break;
            default:
              o = e.v;
          }
          var c = H("v", F(o)),
            u = {
              r: t
            },
            h = go(n.cellXfs, e, n);
          switch (0 !== h && (u.s = h), e.t) {
            case "n":
              break;
            case "d":
              u.t = "d";
              break;
            case "b":
              u.t = "b";
              break;
            case "e":
              u.t = "e";
              break;
            default:
              if (null == e.v) {
                delete e.t;
                break;
              }
              if (n.bookSST) {
                c = H("v", "" + fo(n.Strings, e.v)), u.t = "s";
                break;
              }
              u.t = "str";
          }
          if (e.t != s && (e.t = s, e.v = l), e.f) {
            var f = e.F && e.F.substr(0, t.length) == t ? {
              t: "array",
              ref: e.F
            } : null;
            c = V("f", F(e.f), f) + (null != e.v ? c : "");
          }
          return e.l && r["!links"].push([t, e.l]), e.c && r["!comments"].push([t, e.c]), V("c", c, u);
        }
        function Mo(e, t, r, n, i) {
          var a,
            o,
            s = [],
            l = [],
            c = xe(e["!ref"]),
            u = "",
            h = [],
            f = 0,
            d = 0,
            p = e["!rows"],
            m = Array.isArray(e);
          for (d = c.s.c; d <= c.e.c; ++d) h[d] = de(d);
          for (f = c.s.r; f <= c.e.r; ++f) {
            for (l = [], u = ce(f), d = c.s.c; d <= c.e.c; ++d) {
              o = h[d] + u;
              var g = m ? (e[f] || [])[d] : e[o];
              void 0 !== g && null != (a = Io(g, o, e, t, r, n)) && l.push(a);
            }
            if (l.length > 0 || p && p[f]) {
              var v = {
                r: u
              };
              if (p && p[f]) {
                var b = p[f];
                b.hidden && (v.hidden = 1);
                var y = -1;
                b.hpx ? y = qn(b.hpx) : b.hpt && (y = b.hpt), y > -1 && (v.ht = y, v.customHeight = 1), b.level && (v.outlineLevel = b.level);
              }
              s[s.length] = V("row", l.join(""), v);
            }
          }
          if (p) for (; f < p.length; ++f) p && p[f] && (v = {
            r: f + 1
          }, b = p[f], b.hidden && (v.hidden = 1), y = -1, b.hpx ? y = qn(b.hpx) : b.hpt && (y = b.hpt), y > -1 && (v.ht = y, v.customHeight = 1), b.level && (v.outlineLevel = b.level), s[s.length] = V("row", "", v));
          return s.join("");
        }
        function Oo(e, t, r, n) {
          var i = [gu, sy],
            a = r.SheetNames[e],
            o = 0,
            s = "",
            l = r.Sheets[a];
          null == l && (l = {});
          var c = l["!ref"];
          null == c && (c = "A1"), n || (n = {}), l["!comments"] = [], l["!drawing"] = [], i[i.length] = V("sheetPr", null, {
            codeName: F(r.SheetNames[e])
          }), i[i.length] = V("dimension", null, {
            ref: c
          }), i[i.length] = Ro(l, t, e, r), t.sheetFormat && (i[i.length] = V("sheetFormatPr", null, {
            defaultRowHeight: t.sheetFormat.defaultRowHeight || "16",
            baseColWidth: t.sheetFormat.baseColWidth || "10",
            outlineLevelRow: t.sheetFormat.outlineLevelRow || "7"
          })), null != l["!cols"] && l["!cols"].length > 0 && (i[i.length] = Ao(l, l["!cols"])), i[o = i.length] = "<sheetData/>", l["!links"] = [], null != l["!ref"] && (s = Mo(l, t, e, r, n), s.length > 0 && (i[i.length] = s)), i.length > o + 1 && (i[i.length] = "</sheetData>", i[o] = i[o].replace("/>", ">")), null != l["!protect"] && (i[i.length] = xo(l["!protect"])), null != l["!autofilter"] && (i[i.length] = ko(l["!autofilter"])), null != l["!merges"] && l["!merges"].length > 0 && (i[i.length] = wo(l["!merges"]));
          var u,
            h = -1,
            f = -1;
          l["!links"].length > 0 && (i[i.length] = "<hyperlinks>", l["!links"].forEach(function (e) {
            e[1].Target && (f = et(n, -1, F(e[1].Target).replace(/#.*$/, ""), bh.HLINK), u = {
              ref: e[0],
              "r:id": "rId" + f
            }, (h = e[1].Target.indexOf("#")) > -1 && (u.location = F(e[1].Target.substr(h + 1))), e[1].Tooltip && (u.tooltip = F(e[1].Tooltip)), i[i.length] = V("hyperlink", null, u));
          }), i[i.length] = "</hyperlinks>"), delete l["!links"], null != l["!margins"] && (i[i.length] = Co(l["!margins"]));
          i.length;
          return i[i.length] = "", l["!drawing"].length > 0 ? (f = et(n, -1, "../drawings/drawing" + (e + 1) + ".xml", bh.DRAW), i[i.length] = V("drawing", null, {
            "r:id": "rId" + f
          })) : delete l["!drawing"], l["!comments"].length > 0 && (f = et(n, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", bh.VML), i[i.length] = V("legacyDrawing", null, {
            "r:id": "rId" + f
          }), l["!legacy"] = f), i.length > 2 && (i[i.length] = "</worksheet>", i[1] = i[1].replace("/>", ">")), i.join("");
        }
        function Po(e, t) {
          var r = {},
            n = e.l + t;
          r.r = e.read_shift(4), e.l += 4;
          var i = e.read_shift(2);
          e.l += 1;
          var a = e.read_shift(1);
          return e.l = n, 7 & a && (r.level = 7 & a), 16 & a && (r.hidden = !0), 32 & a && (r.hpt = i / 20), r;
        }
        function Bo(e, t, r) {
          var n = ee(145),
            i = (r["!rows"] || [])[e] || {};
          n.write_shift(4, e), n.write_shift(4, 0);
          var a = 320;
          i.hpx ? a = 20 * qn(i.hpx) : i.hpt && (a = 20 * i.hpt), n.write_shift(2, a), n.write_shift(1, 0);
          var o = 0;
          i.level && (o |= i.level), i.hidden && (o |= 16), (i.hpx || i.hpt) && (o |= 32), n.write_shift(1, o), n.write_shift(1, 0);
          var s = 0,
            l = n.l;
          n.l += 4;
          for (var c = {
              r: e,
              c: 0
            }, u = 0; u < 16; ++u) if (!(t.s.c > u + 1 << 10 || t.e.c < u << 10)) {
            for (var h = -1, f = -1, d = u << 10; d < u + 1 << 10; ++d) {
              c.c = d;
              var p = Array.isArray(r) ? (r[c.r] || [])[c.c] : r[be(c)];
              p && (h < 0 && (h = d), f = d);
            }
            h < 0 || (++s, n.write_shift(4, h), n.write_shift(4, f));
          }
          var m = n.l;
          return n.l = l, n.write_shift(4, s), n.l = m, n.length > n.l ? n.slice(0, n.l) : n;
        }
        function Do(e, t, r, n) {
          var i = Bo(n, r, t);
          (i.length > 17 || (t["!rows"] || [])[n]) && ne(e, "BrtRowHdr", i);
        }
        function Lo(e, t) {}
        function Fo(e, t) {
          var r = {};
          return e.l += 19, r.name = Xu(e, t - 19), r;
        }
        function No(e, t) {
          null == t && (t = ee(84 + 4 * e.length));
          for (var r = 0; r < 3; ++r) t.write_shift(1, 0);
          return qe({
            auto: 1
          }, t), t.write_shift(-4, -1), t.write_shift(-4, -1), Yu(e, t), t.slice(0, t.l);
        }
        function Uo(e, t) {
          return [Be(e)];
        }
        function jo(e, t, r) {
          return null == r && (r = ee(8)), De(t, r);
        }
        function zo(e, t) {
          return [Be(e), e.read_shift(1), "b"];
        }
        function Ho(e, t, r) {
          return null == r && (r = ee(9)), De(t, r), r.write_shift(1, e.v ? 1 : 0), r;
        }
        function Go(e, t) {
          return [Be(e), e.read_shift(1), "e"];
        }
        function Vo(e, t) {
          return [Be(e), e.read_shift(4), "s"];
        }
        function qo(e, t, r) {
          return null == r && (r = ee(12)), De(t, r), r.write_shift(4, t.v), r;
        }
        function Wo(e, t) {
          return [Be(e), He(e), "n"];
        }
        function Xo(e, t, r) {
          return null == r && (r = ee(16)), De(t, r), Ge(e.v, r), r;
        }
        function Yo(e, t) {
          return [Be(e), Ne(e), "n"];
        }
        function Ko(e, t, r) {
          return null == r && (r = ee(12)), De(t, r), Ue(e.v, r), r;
        }
        function Zo(e, t) {
          return [Be(e), Te(e), "str"];
        }
        function Jo(e, t, r) {
          return null == r && (r = ee(12 + 4 * e.v.length)), De(t, r), ke(e.v, r), r.length > r.l ? r.slice(0, r.l) : r;
        }
        function Qo(e, t, r) {
          var n = e.l + t,
            i = Be(e);
          i.r = r["!row"];
          var a = e.read_shift(1),
            o = [i, a, "b"];
          if (r.cellFormula) {
            e.l += 2;
            var s = Vb(e, n - e.l, r);
            o[3] = so(s, null, i, r.supbooks, r);
          } else e.l = n;
          return o;
        }
        function $o(e, t, r) {
          var n = e.l + t,
            i = Be(e);
          i.r = r["!row"];
          var a = e.read_shift(1),
            o = [i, a, "e"];
          if (r.cellFormula) {
            e.l += 2;
            var s = Vb(e, n - e.l, r);
            o[3] = so(s, null, i, r.supbooks, r);
          } else e.l = n;
          return o;
        }
        function es(e, t, r) {
          var n = e.l + t,
            i = Be(e);
          i.r = r["!row"];
          var a = He(e),
            o = [i, a, "n"];
          if (r.cellFormula) {
            e.l += 2;
            var s = Vb(e, n - e.l, r);
            o[3] = so(s, null, i, r.supbooks, r);
          } else e.l = n;
          return o;
        }
        function ts(e, t, r) {
          var n = e.l + t,
            i = Be(e);
          i.r = r["!row"];
          var a = Te(e),
            o = [i, a, "str"];
          if (r.cellFormula) {
            e.l += 2;
            var s = Vb(e, n - e.l, r);
            o[3] = so(s, null, i, r.supbooks, r);
          } else e.l = n;
          return o;
        }
        function rs(e, t) {
          return null == t && (t = ee(4)), t.write_shift(4, e), t;
        }
        function ns(e, t, r) {
          var n = e.l + t,
            i = Qu(e, 16),
            a = Le(e),
            o = Te(e),
            s = Te(e),
            l = Te(e);
          return e.l = n, {
            rfx: i,
            relId: a,
            loc: o,
            Tooltip: s,
            display: l
          };
        }
        function is(e, t, r) {
          null == r && (r = ee(50 + 4 * e[1].Target.length)), $u({
            s: ve(e[0]),
            e: ve(e[0])
          }, r), Ju("rId" + t, r);
          var n = e[1].Target.indexOf("#");
          return ke((-1 == n ? "" : e[1].Target.substr(n + 1)) || "", r), ke(e[1].Tooltip || "", r), ke("", r), r.slice(0, r.l);
        }
        function as(e, t, r) {
          var n = e.l + t,
            i = je(e, 16),
            a = e.read_shift(1),
            o = [i];
          if (o[2] = a, r.cellFormula) {
            var s = Gb(e, n - e.l, r);
            o[1] = s;
          } else e.l = n;
          return o;
        }
        function os(e, t, r) {
          var n = e.l + t,
            i = Qu(e, 16),
            a = [i];
          if (r.cellFormula) {
            var o = Wb(e, n - e.l, r);
            a[1] = o, e.l = n;
          } else e.l = n;
          return a;
        }
        function ss(e, t, r) {
          null == r && (r = ee(18));
          var n = po(e, t);
          r.write_shift(-4, e), r.write_shift(-4, e), r.write_shift(4, 256 * (n.width || 10)), r.write_shift(4, 0);
          var i = 0;
          return t.hidden && (i |= 1), "number" == typeof n.width && (i |= 2), r.write_shift(1, i), r.write_shift(1, 0), r;
        }
        function ls(e, t, r) {
          return {
            left: He(e, 8),
            right: He(e, 8),
            top: He(e, 8),
            bottom: He(e, 8),
            header: He(e, 8),
            footer: He(e, 8)
          };
        }
        function cs(e, t) {
          return null == t && (t = ee(48)), mo(e), Ge(e.left, t), Ge(e.right, t), Ge(e.top, t), Ge(e.bottom, t), Ge(e.header, t), Ge(e.footer, t), t;
        }
        function us(e, t) {
          return null == t && (t = ee(30)), t.write_shift(2, 924), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 100), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(4, 0), t;
        }
        function hs(e, t) {
          return null == t && (t = ee(66)), t.write_shift(2, e.password ? In(e.password) : 0), t.write_shift(4, 1), [["objects", !1], ["scenarios", !1], ["formatCells", !0], ["formatColumns", !0], ["formatRows", !0], ["insertColumns", !0], ["insertRows", !0], ["insertHyperlinks", !0], ["deleteColumns", !0], ["deleteRows", !0], ["selectLockedCells", !1], ["sort", !0], ["autoFilter", !0], ["pivotTables", !0], ["selectUnlockedCells", !1]].forEach(function (r) {
            r[1] ? t.write_shift(4, null == e[r[0]] || e[r[0]] ? 0 : 1) : t.write_shift(4, null != e[r[0]] && e[r[0]] ? 0 : 1);
          }), t;
        }
        function fs(e, t, r, n, i, a) {
          if (!e) return e;
          var o = t || {};
          r || (r = {
            "!id": {}
          }), null != Oc && null == o.dense && (o.dense = Oc);
          var s,
            l,
            c,
            u,
            h,
            f,
            d,
            p,
            m,
            g,
            v = o.dense ? [] : {},
            b = {
              s: {
                r: 2e6,
                c: 2e6
              },
              e: {
                r: 0,
                c: 0
              }
            },
            y = !1,
            w = !1,
            x = [];
          o.biff = 12, o["!row"] = 0;
          var _ = 0,
            S = !1,
            C = [],
            E = {},
            A = [[]];
          A.sharedf = E, A.arrayf = C, A.SheetNames = n.SheetNames || n.Sheets.map(function (e) {
            return e.name;
          }), o.supbooks = A;
          for (var T = 0; T < n.Names.length; ++T) A[0][T + 1] = n.Names[T];
          var k = [],
            R = [],
            I = !1;
          if (te(e, function (e, t, n) {
            if (!w) switch (n) {
              case 148:
                s = e;
                break;
              case 0:
                l = e, o.sheetRows && o.sheetRows <= l.r && (w = !0), m = ce(h = l.r), o["!row"] = l.r, (e.hidden || e.hpt || null != e.level) && (e.hpt && (e.hpx = Wn(e.hpt)), R[e.r] = e);
                break;
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
                switch (c = {
                  t: e[2]
                }, e[2]) {
                  case "n":
                    c.v = e[1];
                    break;
                  case "s":
                    p = Jb[e[1]], c.v = p.t, c.r = p.r;
                    break;
                  case "b":
                    c.v = !!e[1];
                    break;
                  case "e":
                    c.v = e[1], !1 !== o.cellText && (c.w = eh[c.v]);
                    break;
                  case "str":
                    c.t = "s", c.v = su(e[1]);
                }
                if ((u = a.CellXf[e[0].iStyleRef]) && vo(c, u.numFmtId, null, o, i, a), f = e[0].c, o.dense ? (v[h] || (v[h] = []), v[h][f] = c) : v[de(f) + m] = c, o.cellFormula) {
                  for (S = !1, _ = 0; _ < C.length; ++_) {
                    var T = C[_];
                    l.r >= T[0].s.r && l.r <= T[0].e.r && f >= T[0].s.c && f <= T[0].e.c && (c.F = we(T[0]), S = !0);
                  }
                  !S && e.length > 3 && (c.f = e[3]);
                }
                if (b.s.r > l.r && (b.s.r = l.r), b.s.c > f && (b.s.c = f), b.e.r < l.r && (b.e.r = l.r), b.e.c < f && (b.e.c = f), o.cellDates && u && "n" == c.t && Nc.is_date(Nc._table[u.numFmtId])) {
                  var M = Nc.parse_date_code(c.v);
                  M && (c.t = "d", c.v = new Date(M.y, M.m - 1, M.d, M.H, M.M, M.S, M.u));
                }
                break;
              case 1:
                if (!o.sheetStubs || y) break;
                c = {
                  t: "z",
                  v: void 0
                }, f = e[0].c, o.dense ? (v[h] || (v[h] = []), v[h][f] = c) : v[de(f) + m] = c, b.s.r > l.r && (b.s.r = l.r), b.s.c > f && (b.s.c = f), b.e.r < l.r && (b.e.r = l.r), b.e.c < f && (b.e.c = f);
                break;
              case 176:
                x.push(e);
                break;
              case 494:
                var O = r["!id"][e.relId];
                for (O && (e.Target = O.Target, e.loc && (e.Target += "#" + e.loc), e.Rel = O), h = e.rfx.s.r; h <= e.rfx.e.r; ++h) for (f = e.rfx.s.c; f <= e.rfx.e.c; ++f) o.dense ? (v[h] || (v[h] = []), v[h][f] || (v[h][f] = {
                  t: "z",
                  v: void 0
                }), v[h][f].l = e) : (d = be({
                  c: f,
                  r: h
                }), v[d] || (v[d] = {
                  t: "z",
                  v: void 0
                }), v[d].l = e);
                break;
              case 426:
                if (!o.cellFormula) break;
                C.push(e), g = o.dense ? v[h][f] : v[de(f) + m], g.f = so(e[1], b, {
                  r: l.r,
                  c: f
                }, A, o), g.F = we(e[0]);
                break;
              case 427:
                if (!o.cellFormula) break;
                E[be(e[0].s)] = e[1], g = o.dense ? v[h][f] : v[de(f) + m], g.f = so(e[1], b, {
                  r: l.r,
                  c: f
                }, A, o);
                break;
              case 60:
                if (!o.cellStyles) break;
                for (; e.e >= e.s;) k[e.e--] = {
                  width: e.w / 256,
                  hidden: !!(1 & e.flags)
                }, I || (I = !0, Gn(e.w / 256)), Vn(k[e.e + 1]);
                break;
              case 161:
                v["!autofilter"] = {
                  ref: we(e)
                };
                break;
              case 476:
                v["!margins"] = e;
                break;
              case 485:
              case 175:
              case 644:
              case 625:
              case 562:
              case 396:
              case 1112:
              case 1146:
              case 471:
              case 1050:
              case 649:
              case 1105:
              case 49:
              case 589:
              case 607:
              case 564:
              case 1055:
              case 168:
              case 174:
              case 1180:
              case 499:
              case 64:
              case 1053:
              case 550:
              case 171:
              case 167:
              case 1177:
              case 169:
              case 1181:
              case 551:
              case 552:
              case 661:
              case 639:
              case 478:
              case 151:
              case 537:
              case 477:
              case 536:
              case 1103:
              case 680:
              case 1104:
              case 1024:
              case 152:
              case 663:
              case 535:
              case 678:
              case 504:
              case 1043:
              case 428:
              case 170:
              case 50:
              case 2070:
              case 1045:
              case 147:
                break;
              case 35:
                y = !0;
                break;
              case 36:
                y = !1;
                break;
              case 37:
              case 38:
                break;
              default:
                if ((t || "").indexOf("Begin") > 0) ;else if ((t || "").indexOf("End") > 0) ;else if (!y || o.WTF) throw new Error("Unexpected record " + n + " " + t);
            }
          }, o), delete o.supbooks, delete o["!row"], !v["!ref"] && (b.s.r < 2e6 || s && (s.e.r > 0 || s.e.c > 0 || s.s.r > 0 || s.s.c > 0)) && (v["!ref"] = we(s || b)), o.sheetRows && v["!ref"]) {
            var M = xe(v["!ref"]);
            o.sheetRows < +M.e.r && (M.e.r = o.sheetRows - 1, M.e.r > b.e.r && (M.e.r = b.e.r), M.e.r < M.s.r && (M.s.r = M.e.r), M.e.c > b.e.c && (M.e.c = b.e.c), M.e.c < M.s.c && (M.s.c = M.e.c), v["!fullref"] = v["!ref"], v["!ref"] = we(M));
          }
          return x.length > 0 && (v["!merges"] = x), k.length > 0 && (v["!cols"] = k), R.length > 0 && (v["!rows"] = R), v;
        }
        function ds(e, t, r, n, i, a) {
          if (void 0 === t.v) return "";
          var o = "",
            s = null;
          switch (t.t) {
            case "b":
              o = t.v ? "1" : "0";
              break;
            case "d":
              t.z = t.z || Nc._table[14], s = t.v, t.v = b(t.v), t.t = "n";
              break;
            case "n":
            case "e":
              o = "" + t.v;
              break;
            default:
              o = t.v;
          }
          var l = {
            r: r,
            c: n
          };
          switch (l.s = go(i.cellXfs, t, i), t.l && a["!links"].push([be(l), t.l]), t.c && a["!comments"].push([be(l), t.c]), t.t) {
            case "s":
            case "str":
              return void (i.bookSST ? (o = fo(i.Strings, t.v), l.t = "s", l.v = o, ne(e, "BrtCellIsst", qo(t, l))) : (l.t = "str", ne(e, "BrtCellSt", Jo(t, l))));
            case "n":
              return t.v == (0 | t.v) && t.v > -1e3 && t.v < 1e3 ? ne(e, "BrtCellRk", Ko(t, l)) : ne(e, "BrtCellReal", Xo(t, l)), void (s && (t.t = "d", t.v = s));
            case "b":
              return l.t = "b", void ne(e, "BrtCellBool", Ho(t, l));
            case "e":
              l.t = "e";
          }
          ne(e, "BrtCellBlank", jo(t, l));
        }
        function ps(e, t, r, n, i) {
          var a,
            o = xe(t["!ref"] || "A1"),
            s = "",
            l = [];
          ne(e, "BrtBeginSheetData");
          var c = Array.isArray(t),
            u = o.e.r;
          t["!rows"] && (u = Math.max(o.e.r, t["!rows"].length - 1));
          for (var h = o.s.r; h <= u; ++h) if (s = ce(h), Do(e, t, o, h), h <= o.e.r) for (var f = o.s.c; f <= o.e.c; ++f) {
            h === o.s.r && (l[f] = de(f)), a = l[f] + s;
            var d = c ? (t[h] || [])[f] : t[a];
            d && ds(e, d, h, f, n, t);
          }
          ne(e, "BrtEndSheetData");
        }
        function ms(e, t) {
          t && t["!merges"] && (ne(e, "BrtBeginMergeCells", rs(t["!merges"].length)), t["!merges"].forEach(function (t) {
            ne(e, "BrtMergeCell", hy(t));
          }), ne(e, "BrtEndMergeCells"));
        }
        function gs(e, t, r, n, i) {
          t && t["!cols"] && (ne(e, "BrtBeginColInfos"), t["!cols"].forEach(function (t, r) {
            t && ne(e, "BrtColInfo", ss(r, t));
          }), ne(e, "BrtEndColInfos"));
        }
        function vs(e, t, r) {
          t["!links"].forEach(function (t) {
            if (t[1].Target) {
              var n = et(r, -1, t[1].Target.replace(/#.*$/, ""), bh.HLINK);
              ne(e, "BrtHLink", is(t, n));
            }
          }), delete t["!links"];
        }
        function bs(e, t, r, n) {
          if (t["!comments"].length > 0) {
            var i = et(n, -1, "../drawings/vmlDrawing" + (r + 1) + ".vml", bh.VML);
            ne(e, "BrtLegacyDrawing", Ju("rId" + i)), t["!legacy"] = i;
          }
        }
        function ys(e, t) {
          t["!autofilter"] && (ne(e, "BrtBeginAFilter", $u(ye(t["!autofilter"].ref))), ne(e, "BrtEndAFilter"));
        }
        function ws(e, t) {
          ne(e, "BrtBeginWsViews"), ne(e, "BrtBeginWsView", us(t)), ne(e, "BrtEndWsView"), ne(e, "BrtEndWsViews");
        }
        function xs(e, t) {}
        function _s(e, t) {
          t["!protect"] && ne(e, "BrtSheetProtection", hs(t["!protect"]));
        }
        function Ss(e, t, r, n) {
          var i = re(),
            a = r.SheetNames[e],
            o = r.Sheets[a] || {},
            s = xe(o["!ref"] || "A1");
          return o["!links"] = [], o["!comments"] = [], ne(i, "BrtBeginSheet"), ne(i, "BrtWsProp", No(a)), ne(i, "BrtWsDim", cy(s)), ws(i, o), xs(i, o), gs(i, o, e, t, r), ps(i, o, e, t, r), _s(i, o), ys(i, o), ms(i, o), vs(i, o, n), o["!margins"] && ne(i, "BrtMargins", cs(o["!margins"])), bs(i, o, e, n), ne(i, "BrtEndSheet"), i.end();
        }
        function Cs(e) {
          var t = [];
          (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/gm) || []).forEach(function (e) {
            var r = e.match(/<c:pt idx="(.*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
            r && (t[+r[1]] = +r[2]);
          });
          var r = tu((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
          return [t, r];
        }
        function Es(e, t, r, n, i, a) {
          var o = a || {
            "!type": "chart"
          };
          if (!e) return a;
          var s = 0,
            l = 0,
            c = "A",
            u = {
              s: {
                r: 2e6,
                c: 2e6
              },
              e: {
                r: 0,
                c: 0
              }
            };
          return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function (e) {
            var t = Cs(e);
            u.s.r = u.s.c = 0, u.e.c = s, c = de(s), t[0].forEach(function (e, r) {
              o[c + ce(r)] = {
                t: "n",
                v: e,
                z: t[1]
              }, l = r;
            }), u.e.r < l && (u.e.r = l), ++s;
          }), s > 0 && (o["!ref"] = we(u)), o;
        }
        function As(e, t, r, n, i, a) {
          if (!e) return e;
          r || (r = {
            "!id": {}
          });
          var o,
            s = {
              "!type": "chart",
              "!chart": null,
              "!rel": ""
            };
          return (o = e.match(/drawing r:id="(.*?)"/)) && (s["!rel"] = o[1]), r["!id"][s["!rel"]] && (s["!chart"] = r["!id"][s["!rel"]]), s;
        }
        function Ts(e, t, r, n, i, a) {
          if (!e) return e;
          r || (r = {
            "!id": {}
          });
          var o = {
              "!type": "chart",
              "!chart": null,
              "!rel": ""
            },
            s = [],
            l = !1;
          return te(e, function (e, r, n) {
            switch (n) {
              case 550:
                o["!rel"] = e;
                break;
              case 562:
              case 652:
              case 651:
              case 669:
              case 679:
              case 551:
              case 552:
              case 476:
                break;
              case 35:
                l = !0;
                break;
              case 36:
                l = !1;
                break;
              case 37:
                s.push(r);
                break;
              case 38:
                s.pop();
                break;
              default:
                if ((r || "").indexOf("Begin") > 0) s.push(r);else if ((r || "").indexOf("End") > 0) s.pop();else if (!l || t.WTF) throw new Error("Unexpected record " + n + " " + r);
            }
          }, t), r["!id"][o["!rel"]] && (o["!chart"] = r["!id"][o["!rel"]]), o;
        }
        function ks(e, t) {
          for (var r = 0; r != e.length; ++r) for (var n = e[r], i = 0; i != t.length; ++i) {
            var a = t[i];
            if (null == n[a[0]]) n[a[0]] = a[1];else switch (a[2]) {
              case "bool":
                "string" == typeof n[a[0]] && (n[a[0]] = j(n[a[0]], a[0]));
                break;
              case "int":
                "string" == typeof n[a[0]] && (n[a[0]] = parseInt(n[a[0]], 10));
            }
          }
        }
        function Rs(e, t) {
          for (var r = 0; r != t.length; ++r) {
            var n = t[r];
            if (null == e[n[0]]) e[n[0]] = n[1];else switch (n[2]) {
              case "bool":
                "string" == typeof e[n[0]] && (e[n[0]] = j(e[n[0]], n[0]));
                break;
              case "int":
                "string" == typeof e[n[0]] && (e[n[0]] = parseInt(e[n[0]], 10));
            }
          }
        }
        function Is(e) {
          Rs(e.WBProps, fy), Rs(e.CalcPr, my), ks(e.WBView, dy), ks(e.Sheets, py), Qb.date1904 = j(e.WBProps.date1904, "date1904");
        }
        function Ms(e, t) {
          if (e.length > 31) {
            if (t) return !1;
            throw new Error("Sheet names cannot exceed 31 chars");
          }
          var r = !0;
          return gy.forEach(function (n) {
            if (-1 != e.indexOf(n)) {
              if (!t) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
              r = !1;
            }
          }), r;
        }
        function Os(e) {
          e.forEach(function (t, r) {
            Ms(t);
            for (var n = 0; n < r; ++n) if (t == e[n]) throw new Error("Duplicate Sheet Name: " + t);
          });
        }
        function Ps(e) {
          if (!e || !e.SheetNames || !e.Sheets) throw new Error("Invalid Workbook");
          Os(e.SheetNames);
        }
        function Bs(e, t) {
          if (!e) throw new Error("Could not find file");
          var r = {
              AppVersion: {},
              WBProps: {},
              WBView: [],
              Sheets: [],
              CalcPr: {},
              Names: [],
              xmlns: ""
            },
            n = !1,
            i = "xmlns",
            a = {},
            o = 0;
          if (e.replace(Zc, function (s, l) {
            var c = D(s);
            switch (L(c[0])) {
              case "<?xml":
                break;
              case "<workbook":
                s.match(vy) && (i = "xmlns" + s.match(/<(\w+):/)[1]), r.xmlns = c[i];
                break;
              case "</workbook>":
                break;
              case "<fileVersion":
                delete c[0], r.AppVersion = c;
                break;
              case "<fileVersion/>":
              case "</fileVersion>":
                break;
              case "<fileSharing":
              case "<fileSharing/>":
                break;
              case "<workbookPr":
              case "<workbookPr/>":
                fy.forEach(function (e) {
                  if (null != c[e[0]]) switch (e[2]) {
                    case "bool":
                      r.WBProps[e[0]] = j(c[e[0]], e[0]);
                      break;
                    case "int":
                      r.WBProps[e[0]] = parseInt(c[e[0]], 10);
                      break;
                    default:
                      r.WBProps[e[0]] = c[e[0]];
                  }
                });
                break;
              case "</workbookPr>":
              case "<workbookProtection":
              case "<workbookProtection/>":
                break;
              case "<bookViews":
              case "<bookViews>":
              case "</bookViews>":
                break;
              case "<workbookView":
                delete c[0], r.WBView.push(c);
                break;
              case "</workbookView>":
                break;
              case "<sheets":
              case "<sheets>":
              case "</sheets>":
                break;
              case "<sheet":
                switch (c.state) {
                  case "hidden":
                    c.Hidden = 1;
                    break;
                  case "veryHidden":
                    c.Hidden = 2;
                    break;
                  default:
                    c.Hidden = 0;
                }
                delete c.state, c.name = tu(su(c.name)), delete c[0], r.Sheets.push(c);
                break;
              case "</sheet>":
                break;
              case "<functionGroups":
              case "<functionGroups/>":
              case "<functionGroup":
                break;
              case "<externalReferences":
              case "</externalReferences>":
              case "<externalReferences>":
              case "<externalReference":
              case "<definedNames/>":
                break;
              case "<definedNames>":
              case "<definedNames":
                n = !0;
                break;
              case "</definedNames>":
                n = !1;
                break;
              case "<definedName":
                a = {}, a.Name = c.name, c.comment && (a.Comment = c.comment), c.localSheetId && (a.Sheet = +c.localSheetId), o = l + s.length;
                break;
              case "</definedName>":
                a.Ref = e.slice(o, l), r.Names.push(a);
                break;
              case "<definedName/>":
                break;
              case "<calcPr":
              case "<calcPr/>":
                delete c[0], r.CalcPr = c;
                break;
              case "</calcPr>":
              case "<oleSize":
                break;
              case "<customWorkbookViews>":
              case "</customWorkbookViews>":
              case "<customWorkbookViews":
                break;
              case "<customWorkbookView":
              case "</customWorkbookView>":
                break;
              case "<pivotCaches>":
              case "</pivotCaches>":
              case "<pivotCaches":
              case "<pivotCache":
                break;
              case "<smartTagPr":
              case "<smartTagPr/>":
                break;
              case "<smartTagTypes":
              case "<smartTagTypes>":
              case "</smartTagTypes>":
              case "<smartTagType":
                break;
              case "<webPublishing":
              case "<webPublishing/>":
                break;
              case "<fileRecoveryPr":
              case "<fileRecoveryPr/>":
                break;
              case "<webPublishObjects>":
              case "<webPublishObjects":
              case "</webPublishObjects>":
              case "<webPublishObject":
                break;
              case "<extLst":
              case "<extLst>":
              case "</extLst>":
              case "<extLst/>":
                break;
              case "<ext":
                n = !0;
                break;
              case "</ext>":
                n = !1;
                break;
              case "<ArchID":
                break;
              case "<AlternateContent":
                n = !0;
                break;
              case "</AlternateContent>":
                n = !1;
                break;
              case "<revisionPtr":
                break;
              default:
                if (!n && t.WTF) throw new Error("unrecognized " + c[0] + " in workbook");
            }
            return s;
          }), -1 === vu.main.indexOf(r.xmlns)) throw new Error("Unknown Namespace: " + r.xmlns);
          return Is(r), r;
        }
        function Ds(e, t) {
          var r = [gu];
          r[r.length] = by;
          var n = e.Workbook && (e.Workbook.Names || []).length > 0,
            i = {
              codeName: "ThisWorkbook"
            };
          e.Workbook && e.Workbook.WBProps && (e.Workbook.WBProps.codeName && (i.codeName = e.Workbook.WBProps.codeName), fy.forEach(function (t) {
            null != e.Workbook.WBProps[t[0]] && e.Workbook.WBProps[t[0]] != t[1] && (i[t[0]] = e.Workbook.WBProps[t[0]]);
          })), r[r.length] = V("workbookPr", null, i), r[r.length] = "<sheets>";
          for (var a = e.Workbook && e.Workbook.Sheets || [], o = 0; o != e.SheetNames.length; ++o) {
            var s = {
              name: F(e.SheetNames[o].substr(0, 31))
            };
            if (s.sheetId = "" + (o + 1), s["r:id"] = "rId" + (o + 1), a[o]) switch (a[o].Hidden) {
              case 1:
                s.state = "hidden";
                break;
              case 2:
                s.state = "veryHidden";
            }
            r[r.length] = V("sheet", null, s);
          }
          return r[r.length] = "</sheets>", n && (r[r.length] = "<definedNames>", e.Workbook && e.Workbook.Names && e.Workbook.Names.forEach(function (e) {
            var t = {
              name: e.Name
            };
            e.Comment && (t.comment = e.Comment), null != e.Sheet && (t.localSheetId = "" + e.Sheet), e.Ref && (r[r.length] = V("definedName", String(e.Ref), t));
          }), r[r.length] = "</definedNames>"), r.length > 2 && (r[r.length] = "</workbook>", r[1] = r[1].replace("/>", ">")), r.join("");
        }
        function Ls(e, t) {
          var r = {};
          return r.Hidden = e.read_shift(4), r.iTabID = e.read_shift(4), r.strRelID = Zu(e, t - 8), r.name = Te(e), r;
        }
        function Fs(e, t) {
          return t || (t = ee(127)), t.write_shift(4, e.Hidden), t.write_shift(4, e.iTabID), Ju(e.strRelID, t), ke(e.name.substr(0, 31), t), t.length > t.l ? t.slice(0, t.l) : t;
        }
        function Ns(e, t) {
          var r = {},
            n = e.read_shift(4);
          r.defaultThemeVersion = e.read_shift(4);
          var i = t > 8 ? Te(e) : "";
          return i.length > 0 && (r.codeName = i), r.autoCompressPictures = !!(65536 & n), r.backupFile = !!(64 & n), r.checkCompatibility = !!(4096 & n), r.date1904 = !!(1 & n), r.filterPrivacy = !!(8 & n), r.hidePivotFieldList = !!(1024 & n), r.promptedSolutions = !!(16 & n), r.publishItems = !!(2048 & n), r.refreshAllConnections = !!(262144 & n), r.saveExternalLinkValues = !!(128 & n), r.showBorderUnselectedTables = !!(4 & n), r.showInkAnnotation = !!(32 & n), r.showObjects = ["all", "placeholders", "none"][n >> 13 & 3], r.showPivotChartFilter = !!(32768 & n), r.updateLinks = ["userSet", "never", "always"][n >> 8 & 3], r;
        }
        function Us(e, t) {
          t || (t = ee(72));
          var r = 0;
          return e && e.filterPrivacy && (r |= 8), t.write_shift(4, r), t.write_shift(4, 0), Yu("ThisWorkbook", t), t.slice(0, t.l);
        }
        function js(e, t) {
          var r = {};
          return e.read_shift(4), r.ArchID = e.read_shift(4), e.l += t - 8, r;
        }
        function zs(e, t, r) {
          var n = e.l + t,
            i = (e.read_shift(4), e.read_shift(1), e.read_shift(4)),
            a = Ku(e),
            o = qb(e, 0, r),
            s = Le(e);
          e.l = n;
          var l = {
            Name: a,
            Ptg: o,
            Comment: s
          };
          return i < 268435455 && (l.Sheet = i), l;
        }
        function Hs(e, t) {
          var r = {
              AppVersion: {},
              WBProps: {},
              WBView: [],
              Sheets: [],
              CalcPr: {},
              xmlns: ""
            },
            n = !1;
          t || (t = {}), t.biff = 12;
          var i = [],
            a = [];
          return a.SheetNames = [], te(e, function (e, o, s) {
            switch (s) {
              case 156:
                a.SheetNames.push(e.name), r.Sheets.push(e);
                break;
              case 153:
                r.WBProps = e;
                break;
              case 39:
                e.Ref = so(e.Ptg, null, null, a, t), delete e.Ptg, i.push(e);
                break;
              case 1036:
                break;
              case 357:
              case 358:
              case 355:
              case 667:
              case 362:
              case 361:
                break;
              case 2071:
              case 534:
              case 677:
              case 158:
              case 157:
              case 610:
              case 2050:
              case 155:
              case 548:
              case 676:
              case 128:
              case 665:
              case 2128:
              case 2125:
              case 549:
              case 2053:
              case 596:
              case 2076:
              case 2075:
              case 2082:
              case 397:
              case 154:
              case 1117:
              case 553:
              case 2091:
                break;
              case 35:
                n = !0;
                break;
              case 36:
                n = !1;
                break;
              case 37:
              case 38:
              case 16:
                break;
              default:
                if ((o || "").indexOf("Begin") > 0) ;else if ((o || "").indexOf("End") > 0) ;else if (!n || t.WTF) throw new Error("Unexpected record " + s + " " + o);
            }
          }, t), Is(r), r.Names = i, r;
        }
        function Gs(e, t, r) {
          ne(e, "BrtBeginBundleShs");
          for (var n = 0; n != t.SheetNames.length; ++n) {
            ne(e, "BrtBundleSh", Fs({
              Hidden: t.Workbook && t.Workbook.Sheets && t.Workbook.Sheets[n] && t.Workbook.Sheets[n].Hidden || 0,
              iTabID: n + 1,
              strRelID: "rId" + (n + 1),
              name: t.SheetNames[n]
            }));
          }
          ne(e, "BrtEndBundleShs");
        }
        function Vs(e, r) {
          r || (r = ee(127));
          for (var n = 0; 4 != n; ++n) r.write_shift(4, 0);
          return ke("SheetJS", r), ke(t.version, r), ke(t.version, r), ke("7262", r), r.length = r.l, r.length > r.l ? r.slice(0, r.l) : r;
        }
        function qs(e, t) {
          t || (t = ee(29)), t.write_shift(-4, 0), t.write_shift(-4, 460), t.write_shift(4, 28800), t.write_shift(4, 17600), t.write_shift(4, 500), t.write_shift(4, e), t.write_shift(4, e);
          return t.write_shift(1, 120), t.length > t.l ? t.slice(0, t.l) : t;
        }
        function Ws(e, t, r) {
          if (t.Workbook && t.Workbook.Sheets) {
            for (var n = t.Workbook.Sheets, i = 0, a = -1, o = -1; i < n.length; ++i) !n[i] || !n[i].Hidden && -1 == a ? a = i : 1 == n[i].Hidden && -1 == o && (o = i);
            o > a || (ne(e, "BrtBeginBookViews"), ne(e, "BrtBookView", qs(a)), ne(e, "BrtEndBookViews"));
          }
        }
        function Xs(e, t) {
          var r = re();
          return ne(r, "BrtBeginBook"), ne(r, "BrtFileVersion", Vs()), ne(r, "BrtWbProp", Us(e.Workbook && e.Workbook.WBProps || null)), Ws(r, e, t), Gs(r, e, t), ne(r, "BrtEndBook"), r.end();
        }
        function Ys(e, t, r) {
          return ".bin" === t.slice(-4) ? Hs(e, r) : Bs(e, r);
        }
        function Ks(e, t, r, n, i, a, o) {
          return ".bin" === t.slice(-4) ? fs(e, r, n, i, a, o) : yo(e, r, n, i, a, o);
        }
        function Zs(e, t, r, n, i, a, o) {
          return ".bin" === t.slice(-4) ? Ts(e, r, n, i, a, o) : As(e, r, n, i, a, o);
        }
        function Js(e, t, r, n, i, a, o) {
          return ".bin" === t.slice(-4) ? ea(e, r, n, i, a, o) : ta(e, r, n, i, a, o);
        }
        function Qs(e, t, r, n, i, a, o) {
          return ".bin" === t.slice(-4) ? Qi(e, r, n, i, a, o) : $i(e, r, n, i, a, o);
        }
        function $s(e, t, r, n) {
          return ".bin" === t.slice(-4) ? fi(e, r, n) : tb(e, r, n);
        }
        function el(e, t, r) {
          return ki(e, r);
        }
        function tl(e, t, r) {
          return ".bin" === t.slice(-4) ? hn(e, r) : ln(e, r);
        }
        function rl(e, t, r) {
          return ".bin" === t.slice(-4) ? Zi(e, r) : qi(e, r);
        }
        function nl(e, t, r) {
          return ".bin" === t.slice(-4) ? ji(e, r) : Ni(e, r);
        }
        function il(e, t, r) {
          return (".bin" === t.slice(-4) ? Xs : Ds)(e, r);
        }
        function al(e, t, r, n, i) {
          return (".bin" === t.slice(-4) ? Ss : Oo)(e, r, n, i);
        }
        function ol(e, t, r) {
          return (".bin" === t.slice(-4) ? Si : ei)(e, r);
        }
        function sl(e, t, r) {
          return (".bin" === t.slice(-4) ? dn : cn)(e, r);
        }
        function ll(e, t, r) {
          return (".bin" === t.slice(-4) ? Ji : Wi)(e, r);
        }
        function cl(e, t) {
          var r = e.split(/\s+/),
            n = [];
          if (t || (n[0] = r[0]), 1 === r.length) return n;
          var i,
            a,
            o,
            s,
            l = e.match(yy);
          if (l) for (s = 0; s != l.length; ++s) i = l[s].match(wy), -1 === (a = i[1].indexOf(":")) ? n[i[1]] = i[2].substr(1, i[2].length - 2) : (o = "xmlns:" === i[1].substr(0, 6) ? "xmlns" + i[1].substr(6) : i[1].substr(a + 1), n[o] = i[2].substr(1, i[2].length - 2));
          return n;
        }
        function ul(e) {
          var t = e.split(/\s+/),
            r = {};
          if (1 === t.length) return r;
          var n,
            i,
            a,
            o,
            s = e.match(yy);
          if (s) for (o = 0; o != s.length; ++o) n = s[o].match(wy), -1 === (i = n[1].indexOf(":")) ? r[n[1]] = n[2].substr(1, n[2].length - 2) : (a = "xmlns:" === n[1].substr(0, 6) ? "xmlns" + n[1].substr(6) : n[1].substr(i + 1), r[a] = n[2].substr(1, n[2].length - 2));
          return r;
        }
        function hl(e, t) {
          var r = jc[e] || tu(e);
          return "General" === r ? Nc._general(t) : Nc.format(r, t);
        }
        function fl(e, t, r, n) {
          var i = n;
          switch ((r[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
            case "boolean":
              i = j(n);
              break;
            case "i2":
            case "int":
              i = parseInt(n, 10);
              break;
            case "r4":
            case "float":
              i = parseFloat(n);
              break;
            case "date":
            case "dateTime.tz":
              i = x(n);
              break;
            case "i8":
            case "string":
            case "fixed":
            case "uuid":
            case "bin.base64":
              break;
            default:
              throw new Error("bad custprop:" + r[0]);
          }
          e[tu(t[3])] = i;
        }
        function dl(e, t, r) {
          if ("z" !== e.t) {
            if (!r || !1 !== r.cellText) try {
              "e" === e.t ? e.w = e.w || eh[e.v] : "General" === t ? "n" === e.t ? (0 | e.v) === e.v ? e.w = Nc._general_int(e.v) : e.w = Nc._general_num(e.v) : e.w = Nc._general(e.v) : e.w = hl(t || "General", e.v);
            } catch (e) {
              if (r.WTF) throw e;
            }
            try {
              var n = jc[t] || t || "General";
              if (r.cellNF && (e.z = n), r.cellDates && "n" == e.t && Nc.is_date(n)) {
                var i = Nc.parse_date_code(e.v);
                i && (e.t = "d", e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u));
              }
            } catch (e) {
              if (r.WTF) throw e;
            }
          }
        }
        function pl(e, t, r) {
          if (r.cellStyles && t.Interior) {
            var n = t.Interior;
            n.Pattern && (n.patternType = Qv[n.Pattern] || n.Pattern);
          }
          e[t.ID] = t;
        }
        function ml(e, t, r, n, i, a, o, s, l, c) {
          var u = "General",
            h = n.StyleID,
            f = {};
          c = c || {};
          var d = [],
            p = 0;
          for (void 0 === h && s && (h = s.StyleID), void 0 === h && o && (h = o.StyleID); void 0 !== a[h] && (a[h].nf && (u = a[h].nf), a[h].Interior && d.push(a[h].Interior), a[h].Parent);) h = a[h].Parent;
          switch (r.Type) {
            case "Boolean":
              n.t = "b", n.v = j(e);
              break;
            case "String":
              n.t = "s", n.r = au(tu(e)), n.v = e.indexOf("<") > -1 ? tu(t) : n.r;
              break;
            case "DateTime":
              "Z" != e.slice(-1) && (e += "Z"), n.v = (x(e) - new Date(Date.UTC(1899, 11, 30))) / 864e5, n.v !== n.v ? n.v = tu(e) : n.v < 60 && (n.v = n.v - 1), u && "General" != u || (u = "yyyy-mm-dd");
            case "Number":
              void 0 === n.v && (n.v = +e), n.t || (n.t = "n");
              break;
            case "Error":
              n.t = "e", n.v = th[e], !1 !== c.cellText && (n.w = e);
              break;
            default:
              n.t = "s", n.v = au(t || e);
          }
          if (dl(n, u, c), !1 !== c.cellFormula) if (n.Formula) {
            var m = tu(n.Formula);
            61 == m.charCodeAt(0) && (m = m.substr(1)), n.f = fb(m, i), delete n.Formula, "RC" == n.ArrayRange ? n.F = fb("RC:RC", i) : n.ArrayRange && (n.F = fb(n.ArrayRange, i), l.push([xe(n.F), n.F]));
          } else for (p = 0; p < l.length; ++p) i.r >= l[p][0].s.r && i.r <= l[p][0].e.r && i.c >= l[p][0].s.c && i.c <= l[p][0].e.c && (n.F = l[p][1]);
          c.cellStyles && (d.forEach(function (e) {
            !f.patternType && e.patternType && (f.patternType = e.patternType);
          }), n.s = f), n.ixfe = void 0 !== n.StyleID ? n.StyleID : "Default";
        }
        function gl(e) {
          e.t = e.v || "", e.t = e.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n"), e.v = e.w = e.ixfe = void 0;
        }
        function vl(e) {
          if (Bc && i.isBuffer(e)) return e.toString("utf8");
          if ("string" == typeof e) return e;
          throw new Error("Bad input format: expected Buffer or string");
        }
        function bl(e, t) {
          var r = t || {};
          Uc(Nc);
          var n = Ic(vl(e));
          r && "binary" == r.type && "undefined" != typeof cptable && (n = cptable.utils.decode(65001, s(n)));
          var i = n.slice(0, 1024).toLowerCase(),
            a = !1;
          if (-1 == i.indexOf("<?xml") && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function (e) {
            i.indexOf("<" + e) >= 0 && (a = !0);
          }), a) return Ay.to_workbook(n, r);
          var o,
            l,
            c = [];
          null != Oc && null == r.dense && (r.dense = Oc);
          var u,
            h = {},
            f = [],
            d = r.dense ? [] : {},
            p = "",
            m = {},
            g = {},
            v = cl('<Data ss:Type="String">'),
            b = 0,
            y = 0,
            w = 0,
            x = {
              s: {
                r: 2e6,
                c: 2e6
              },
              e: {
                r: 0,
                c: 0
              }
            },
            _ = {},
            S = {},
            E = "",
            A = 0,
            T = [],
            k = {},
            R = {},
            I = 0,
            M = {},
            O = [],
            P = {},
            B = [],
            L = !1,
            F = [],
            N = [],
            U = {},
            j = {
              Sheets: [],
              WBProps: {
                date1904: !1
              }
            },
            z = {};
          for (_y.lastIndex = 0, n = n.replace(/<!--([\s\S]*?)-->/gm, ""); o = _y.exec(n);) switch (o[3]) {
            case "Data":
              if (c[c.length - 1][1]) break;
              "/" === o[1] ? ml(n.slice(b, o.index), E, v, "Comment" == c[c.length - 1][0] ? P : m, {
                c: y,
                r: w
              }, _, B[y], g, F, r) : (E = "", v = cl(o[0]), b = o.index + o[0].length);
              break;
            case "Cell":
              if ("/" === o[1]) {
                if (O.length > 0 && (m.c = O), (!r.sheetRows || r.sheetRows > w) && void 0 !== m.v && (r.dense ? (d[w] || (d[w] = []), d[w][y] = m) : d[de(y) + ce(w)] = m), m.HRef && (m.l = {
                  Target: m.HRef,
                  Tooltip: m.HRefScreenTip
                }, delete m.HRef, delete m.HRefScreenTip), m.MergeAcross || m.MergeDown) {
                  var H = y + (0 | parseInt(m.MergeAcross, 10)),
                    G = w + (0 | parseInt(m.MergeDown, 10));
                  T.push({
                    s: {
                      c: y,
                      r: w
                    },
                    e: {
                      c: H,
                      r: G
                    }
                  });
                }
                if (r.sheetStubs) {
                  if (m.MergeAcross || m.MergeDown) {
                    for (var V = y; V <= H; ++V) for (var q = w; q <= G; ++q) (V > y || q > w) && (r.dense ? (d[q] || (d[q] = []), d[q][V] = {
                      t: "z"
                    }) : d[de(V) + ce(q)] = {
                      t: "z"
                    });
                    y = H + 1;
                  } else ++y;
                } else m.MergeAcross ? y = H + 1 : ++y;
              } else m = ul(o[0]), m.Index && (y = +m.Index - 1), y < x.s.c && (x.s.c = y), y > x.e.c && (x.e.c = y), "/>" === o[0].slice(-2) && ++y, O = [];
              break;
            case "Row":
              "/" === o[1] || "/>" === o[0].slice(-2) ? (w < x.s.r && (x.s.r = w), w > x.e.r && (x.e.r = w), "/>" === o[0].slice(-2) && (g = cl(o[0]), g.Index && (w = +g.Index - 1)), y = 0, ++w) : (g = cl(o[0]), g.Index && (w = +g.Index - 1), U = {}, ("0" == g.AutoFitHeight || g.Height) && (U.hpx = parseInt(g.Height, 10), U.hpt = qn(U.hpx), N[w] = U), "1" == g.Hidden && (U.hidden = !0, N[w] = U));
              break;
            case "Worksheet":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
                f.push(p), x.s.r <= x.e.r && x.s.c <= x.e.c && (d["!ref"] = we(x)), T.length && (d["!merges"] = T), B.length > 0 && (d["!cols"] = B), N.length > 0 && (d["!rows"] = N), h[p] = d;
              } else x = {
                s: {
                  r: 2e6,
                  c: 2e6
                },
                e: {
                  r: 0,
                  c: 0
                }
              }, w = y = 0, c.push([o[3], !1]), l = cl(o[0]), p = tu(l.Name), d = r.dense ? [] : {}, T = [], F = [], N = [], z = {
                name: p,
                Hidden: 0
              }, j.Sheets.push(z);
              break;
            case "Table":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
              } else {
                if ("/>" == o[0].slice(-2)) break;
                cl(o[0]), c.push([o[3], !1]), B = [], L = !1;
              }
              break;
            case "Style":
              "/" === o[1] ? pl(_, S, r) : S = cl(o[0]);
              break;
            case "NumberFormat":
              S.nf = tu(cl(o[0]).Format || "General"), jc[S.nf] && (S.nf = jc[S.nf]);
              for (var W = 0; 392 != W && Nc._table[W] != S.nf; ++W);
              if (392 == W) for (W = 57; 392 != W; ++W) if (null == Nc._table[W]) {
                Nc.load(S.nf, W);
                break;
              }
              break;
            case "Column":
              if ("Table" !== c[c.length - 1][0]) break;
              if (u = cl(o[0]), u.Hidden && (u.hidden = !0, delete u.Hidden), u.Width && (u.wpx = parseInt(u.Width, 10)), !L && u.wpx > 10) {
                L = !0, Zv = Xv;
                for (var X = 0; X < B.length; ++X) B[X] && Vn(B[X]);
              }
              L && Vn(u), B[u.Index - 1 || B.length] = u;
              for (var Y = 0; Y < +u.Span; ++Y) B[B.length] = C(u);
              break;
            case "NamedRange":
              j.Names || (j.Names = []);
              var K = D(o[0]),
                Z = {
                  Name: K.Name,
                  Ref: fb(K.RefersTo.substr(1))
                };
              j.Sheets.length > 0 && (Z.Sheet = j.Sheets.length - 1), j.Names.push(Z);
              break;
            case "NamedCell":
            case "B":
            case "I":
            case "U":
            case "S":
            case "Sub":
            case "Sup":
            case "Span":
            case "Border":
            case "Alignment":
            case "Borders":
              break;
            case "Font":
              if ("/>" === o[0].slice(-2)) break;
              "/" === o[1] ? E += n.slice(A, o.index) : A = o.index + o[0].length;
              break;
            case "Interior":
              if (!r.cellStyles) break;
              S.Interior = cl(o[0]);
              break;
            case "Protection":
              break;
            case "Author":
            case "Title":
            case "Description":
            case "Created":
            case "Keywords":
            case "Subject":
            case "Category":
            case "Company":
            case "LastAuthor":
            case "LastSaved":
            case "LastPrinted":
            case "Version":
            case "Revision":
            case "TotalTime":
            case "HyperlinkBase":
            case "Manager":
            case "ContentStatus":
            case "Identifier":
            case "Language":
              if ("/>" === o[0].slice(-2)) break;
              "/" === o[1] ? dt(k, o[3], n.slice(I, o.index)) : I = o.index + o[0].length;
              break;
            case "Paragraphs":
              break;
            case "Styles":
            case "Workbook":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
              } else c.push([o[3], !1]);
              break;
            case "Comment":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
                gl(P), O.push(P);
              } else c.push([o[3], !1]), l = cl(o[0]), P = {
                a: l.Author
              };
              break;
            case "AutoFilter":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
              } else if ("/" !== o[0].charAt(o[0].length - 2)) {
                var J = cl(o[0]);
                d["!autofilter"] = {
                  ref: fb(J.Range).replace(/\$/g, "")
                }, c.push([o[3], !0]);
              }
              break;
            case "Name":
              break;
            case "ComponentOptions":
            case "DocumentProperties":
            case "CustomDocumentProperties":
            case "OfficeDocumentSettings":
            case "PivotTable":
            case "PivotCache":
            case "Names":
            case "MapInfo":
            case "PageBreaks":
            case "QueryTable":
            case "DataValidation":
            case "Sorting":
            case "Schema":
            case "data":
            case "ConditionalFormatting":
            case "SmartTagType":
            case "SmartTags":
            case "ExcelWorkbook":
            case "WorkbookOptions":
            case "WorksheetOptions":
              if ("/" === o[1]) {
                if ((l = c.pop())[0] !== o[3]) throw new Error("Bad state: " + l.join("|"));
              } else "/" !== o[0].charAt(o[0].length - 2) && c.push([o[3], !0]);
              break;
            default:
              if (0 == c.length && "document" == o[3]) return Zl(n, r);
              if (0 == c.length && "UOF" == o[3]) return Zl(n, r);
              var Q = !0;
              switch (c[c.length - 1][0]) {
                case "OfficeDocumentSettings":
                  switch (o[3]) {
                    case "AllowPNG":
                    case "RemovePersonalInformation":
                    case "DownloadComponents":
                    case "LocationOfComponents":
                    case "Colors":
                    case "Color":
                    case "Index":
                    case "RGB":
                    case "PixelsPerInch":
                    case "TargetScreenSize":
                    case "ReadOnlyRecommended":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "ComponentOptions":
                  switch (o[3]) {
                    case "Toolbar":
                    case "HideOfficeLogo":
                    case "SpreadsheetAutoFit":
                    case "Label":
                    case "Caption":
                    case "MaxHeight":
                    case "MaxWidth":
                    case "NextSheetNumber":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "ExcelWorkbook":
                  switch (o[3]) {
                    case "Date1904":
                      j.WBProps.date1904 = !0;
                      break;
                    case "WindowHeight":
                    case "WindowWidth":
                    case "WindowTopX":
                    case "WindowTopY":
                    case "TabRatio":
                    case "ProtectStructure":
                    case "ProtectWindows":
                    case "ActiveSheet":
                    case "DisplayInkNotes":
                    case "FirstVisibleSheet":
                    case "SupBook":
                    case "SheetName":
                    case "SheetIndex":
                    case "SheetIndexFirst":
                    case "SheetIndexLast":
                    case "Dll":
                    case "AcceptLabelsInFormulas":
                    case "DoNotSaveLinkValues":
                    case "Iteration":
                    case "MaxIterations":
                    case "MaxChange":
                    case "Path":
                    case "Xct":
                    case "Count":
                    case "SelectedSheets":
                    case "Calculation":
                    case "Uncalced":
                    case "StartupPrompt":
                    case "Crn":
                    case "ExternName":
                    case "Formula":
                    case "ColFirst":
                    case "ColLast":
                    case "WantAdvise":
                    case "Boolean":
                    case "Error":
                    case "Text":
                    case "OLE":
                    case "NoAutoRecover":
                    case "PublishObjects":
                    case "DoNotCalculateBeforeSave":
                    case "Number":
                    case "RefModeR1C1":
                    case "EmbedSaveSmartTags":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "WorkbookOptions":
                  switch (o[3]) {
                    case "OWCVersion":
                    case "Height":
                    case "Width":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "WorksheetOptions":
                  switch (o[3]) {
                    case "Visible":
                      if ("/>" === o[0].slice(-2)) ;else if ("/" === o[1]) switch (n.slice(I, o.index)) {
                        case "SheetHidden":
                          z.Hidden = 1;
                          break;
                        case "SheetVeryHidden":
                          z.Hidden = 2;
                      } else I = o.index + o[0].length;
                      break;
                    case "Header":
                      d["!margins"] || mo(d["!margins"] = {}, "xlml"), d["!margins"].header = D(o[0]).Margin;
                      break;
                    case "Footer":
                      d["!margins"] || mo(d["!margins"] = {}, "xlml"), d["!margins"].footer = D(o[0]).Margin;
                      break;
                    case "PageMargins":
                      var $ = D(o[0]);
                      d["!margins"] || mo(d["!margins"] = {}, "xlml"), $.Top && (d["!margins"].top = $.Top), $.Left && (d["!margins"].left = $.Left), $.Right && (d["!margins"].right = $.Right), $.Bottom && (d["!margins"].bottom = $.Bottom);
                      break;
                    case "Unsynced":
                    case "Print":
                    case "Panes":
                    case "Scale":
                    case "Pane":
                    case "Number":
                    case "Layout":
                    case "PageSetup":
                    case "Selected":
                    case "ProtectObjects":
                    case "EnableSelection":
                    case "ProtectScenarios":
                    case "ValidPrinterInfo":
                    case "HorizontalResolution":
                    case "VerticalResolution":
                    case "NumberofCopies":
                    case "ActiveRow":
                    case "ActiveCol":
                    case "ActivePane":
                    case "TopRowVisible":
                    case "TopRowBottomPane":
                    case "LeftColumnVisible":
                    case "LeftColumnRightPane":
                    case "FitToPage":
                    case "RangeSelection":
                    case "PaperSizeIndex":
                    case "PageLayoutZoom":
                    case "PageBreakZoom":
                    case "FilterOn":
                    case "DoNotDisplayGridlines":
                    case "SplitHorizontal":
                    case "SplitVertical":
                    case "FreezePanes":
                    case "FrozenNoSplit":
                    case "FitWidth":
                    case "FitHeight":
                    case "CommentsLayout":
                    case "Zoom":
                    case "LeftToRight":
                    case "Gridlines":
                    case "AllowSort":
                    case "AllowFilter":
                    case "AllowInsertRows":
                    case "AllowDeleteRows":
                    case "AllowInsertCols":
                    case "AllowDeleteCols":
                    case "AllowInsertHyperlinks":
                    case "AllowFormatCells":
                    case "AllowSizeCols":
                    case "AllowSizeRows":
                    case "NoSummaryRowsBelowDetail":
                    case "TabColorIndex":
                    case "DoNotDisplayHeadings":
                    case "ShowPageLayoutZoom":
                    case "NoSummaryColumnsRightDetail":
                    case "BlackAndWhite":
                    case "DoNotDisplayZeros":
                    case "DisplayPageBreak":
                    case "RowColHeadings":
                    case "DoNotDisplayOutline":
                    case "NoOrientation":
                    case "AllowUsePivotTables":
                    case "ZeroHeight":
                    case "ViewableRange":
                    case "Selection":
                    case "ProtectContents":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "PivotTable":
                case "PivotCache":
                  switch (o[3]) {
                    case "ImmediateItemsOnDrop":
                    case "ShowPageMultipleItemLabel":
                    case "CompactRowIndent":
                    case "Location":
                    case "PivotField":
                    case "Orientation":
                    case "LayoutForm":
                    case "LayoutSubtotalLocation":
                    case "LayoutCompactRow":
                    case "Position":
                    case "PivotItem":
                    case "DataType":
                    case "DataField":
                    case "SourceName":
                    case "ParentField":
                    case "PTLineItems":
                    case "PTLineItem":
                    case "CountOfSameItems":
                    case "Item":
                    case "ItemType":
                    case "PTSource":
                    case "CacheIndex":
                    case "ConsolidationReference":
                    case "FileName":
                    case "Reference":
                    case "NoColumnGrand":
                    case "NoRowGrand":
                    case "BlankLineAfterItems":
                    case "Hidden":
                    case "Subtotal":
                    case "BaseField":
                    case "MapChildItems":
                    case "Function":
                    case "RefreshOnFileOpen":
                    case "PrintSetTitles":
                    case "MergeLabels":
                    case "DefaultVersion":
                    case "RefreshName":
                    case "RefreshDate":
                    case "RefreshDateCopy":
                    case "VersionLastRefresh":
                    case "VersionLastUpdate":
                    case "VersionUpdateableMin":
                    case "VersionRefreshableMin":
                    case "Calculation":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "PageBreaks":
                  switch (o[3]) {
                    case "ColBreaks":
                    case "ColBreak":
                    case "RowBreaks":
                    case "RowBreak":
                    case "ColStart":
                    case "ColEnd":
                    case "RowEnd":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "AutoFilter":
                  switch (o[3]) {
                    case "AutoFilterColumn":
                    case "AutoFilterCondition":
                    case "AutoFilterAnd":
                    case "AutoFilterOr":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "QueryTable":
                  switch (o[3]) {
                    case "Id":
                    case "AutoFormatFont":
                    case "AutoFormatPattern":
                    case "QuerySource":
                    case "QueryType":
                    case "EnableRedirections":
                    case "RefreshedInXl9":
                    case "URLString":
                    case "HTMLTables":
                    case "Connection":
                    case "CommandText":
                    case "RefreshInfo":
                    case "NoTitles":
                    case "NextId":
                    case "ColumnInfo":
                    case "OverwriteCells":
                    case "DoNotPromptForFile":
                    case "TextWizardSettings":
                    case "Source":
                    case "Number":
                    case "Decimal":
                    case "ThousandSeparator":
                    case "TrailingMinusNumbers":
                    case "FormatSettings":
                    case "FieldType":
                    case "Delimiters":
                    case "Tab":
                    case "Comma":
                    case "AutoFormatName":
                    case "VersionLastEdit":
                    case "VersionLastRefresh":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "Sorting":
                case "ConditionalFormatting":
                case "DataValidation":
                  switch (o[3]) {
                    case "Range":
                    case "Type":
                    case "Min":
                    case "Max":
                    case "Sort":
                    case "Descending":
                    case "Order":
                    case "CaseSensitive":
                    case "Value":
                    case "ErrorStyle":
                    case "ErrorMessage":
                    case "ErrorTitle":
                    case "CellRangeList":
                    case "InputMessage":
                    case "InputTitle":
                    case "ComboHide":
                    case "InputHide":
                    case "Condition":
                    case "Qualifier":
                    case "UseBlank":
                    case "Value1":
                    case "Value2":
                    case "Format":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "MapInfo":
                case "Schema":
                case "data":
                  switch (o[3]) {
                    case "Map":
                    case "Entry":
                    case "Range":
                    case "XPath":
                    case "Field":
                    case "XSDType":
                    case "FilterOn":
                    case "Aggregate":
                    case "ElementType":
                    case "AttributeType":
                      break;
                    case "schema":
                    case "element":
                    case "complexType":
                    case "datatype":
                    case "all":
                    case "attribute":
                    case "extends":
                    case "row":
                      break;
                    default:
                      Q = !1;
                  }
                  break;
                case "SmartTags":
                  break;
                default:
                  Q = !1;
              }
              if (Q) break;
              if (!c[c.length - 1][1]) throw "Unrecognized tag: " + o[3] + "|" + c.join("|");
              if ("CustomDocumentProperties" === c[c.length - 1][0]) {
                if ("/>" === o[0].slice(-2)) break;
                "/" === o[1] ? fl(R, o, M, n.slice(I, o.index)) : (M = o, I = o.index + o[0].length);
                break;
              }
              if (r.WTF) throw "Unrecognized tag: " + o[3] + "|" + c.join("|");
          }
          var ee = {};
          return r.bookSheets || r.bookProps || (ee.Sheets = h), ee.SheetNames = f, ee.Workbook = j, ee.SSF = Nc.get_table(), ee.Props = k, ee.Custprops = R, ee;
        }
        function yl(e, t) {
          switch (Ly(t = t || {}), t.type || "base64") {
            case "base64":
              return bl(Pc.decode(e), t);
            case "binary":
            case "buffer":
            case "file":
              return bl(e, t);
            case "array":
              return bl(e.map(xy).join(""), t);
          }
        }
        function wl(e, t) {
          var r = [];
          return e.Props && r.push(pt(e.Props, t)), e.Custprops && r.push(mt(e.Props, e.Custprops, t)), r.join("");
        }
        function xl(e, t) {
          return "";
        }
        function _l(e, t) {
          return "";
        }
        function Sl(e, t, r, n) {
          if (!e) return "";
          var i = [];
          if (e["!margins"] && (i.push("<PageSetup>"), e["!margins"].header && i.push(V("Header", null, {
            "x:Margin": e["!margins"].header
          })), e["!margins"].footer && i.push(V("Footer", null, {
            "x:Margin": e["!margins"].footer
          })), i.push(V("PageMargins", null, {
            "x:Bottom": e["!margins"].bottom || "0.75",
            "x:Left": e["!margins"].left || "0.7",
            "x:Right": e["!margins"].right || "0.7",
            "x:Top": e["!margins"].top || "0.75"
          })), i.push("</PageSetup>")), n && n.Workbook && n.Workbook.Sheets && n.Workbook.Sheets[r]) if (n.Workbook.Sheets[r].Hidden) i.push(V("Visible", 1 == n.Workbook.Sheets[r].Hidden ? "SheetHidden" : "SheetVeryHidden", {}));else {
            for (var a = 0; a < r && (!n.Workbook.Sheets[a] || n.Workbook.Sheets[a].Hidden); ++a);
            a == r && i.push("<Selected/>");
          }
          return e["!protect"] && (i.push(H("ProtectContents", "True")), e["!protect"].objects && i.push(H("ProtectObjects", "True")), e["!protect"].scenarios && i.push(H("ProtectScenarios", "True")), null == e["!protect"].selectLockedCells || e["!protect"].selectLockedCells ? null == e["!protect"].selectUnlockedCells || e["!protect"].selectUnlockedCells || i.push(H("EnableSelection", "UnlockedCells")) : i.push(H("EnableSelection", "NoSelection")), [["formatColumns", "AllowFormatCells"], ["formatRows", "AllowSizeCols"], ["formatCells", "AllowSizeRows"], ["insertColumns", "AllowInsertCols"], ["insertRows", "AllowInsertRows"], ["insertHyperlinks", "AllowInsertHyperlinks"], ["deleteColumns", "AllowDeleteCols"], ["deleteRows", "AllowDeleteRows"], ["sort", "AllowSort"], ["autoFilter", "AllowFilter"], ["pivotTables", "AllowUsePivotTables"]].forEach(function (t) {
            e["!protect"][t[0]] && i.push("<" + t[1] + "/>");
          })), 0 == i.length ? "" : V("WorksheetOptions", i.join(""), {
            xmlns: wu.x
          });
        }
        function Cl(e) {
          return e.map(function (e) {
            return V("Comment", V("ss:Data", ou(e.t || ""), {
              xmlns: "http://www.w3.org/TR/REC-html40"
            }), {
              "ss:Author": e.a
            });
          }).join("");
        }
        function El(e, t, r, n, i, a, o) {
          if (!e || void 0 == e.v && void 0 == e.f) return "<Cell></Cell>";
          var s = {};
          if (e.f && (s["ss:Formula"] = "=" + F(pb(e.f, o))), e.F && e.F.substr(0, t.length) == t) {
            var l = ve(e.F.substr(t.length + 1));
            s["ss:ArrayRange"] = "RC:R" + (l.r == o.r ? "" : "[" + (l.r - o.r) + "]") + "C" + (l.c == o.c ? "" : "[" + (l.c - o.c) + "]");
          }
          if (e.l && e.l.Target && (s["ss:HRef"] = F(e.l.Target), e.l.Tooltip && (s["x:HRefScreenTip"] = F(e.l.Tooltip))), r["!merges"]) for (var c = r["!merges"], u = 0; u != c.length; ++u) c[u].s.c == o.c && c[u].s.r == o.r && (c[u].e.c > c[u].s.c && (s["ss:MergeAcross"] = c[u].e.c - c[u].s.c), c[u].e.r > c[u].s.r && (s["ss:MergeDown"] = c[u].e.r - c[u].s.r));
          var h = "",
            f = "";
          switch (e.t) {
            case "z":
              return "";
            case "n":
              h = "Number", f = String(e.v);
              break;
            case "b":
              h = "Boolean", f = e.v ? "1" : "0";
              break;
            case "e":
              h = "Error", f = eh[e.v];
              break;
            case "d":
              h = "DateTime", f = new Date(e.v).toISOString();
              break;
            case "s":
              h = "String", f = F(e.v || "");
          }
          var d = null != e.v ? f : "";
          if (n && "binary" == n.type && "undefined" != typeof cptable && "s" == e.t) {
            d = cptable.utils.encode(65001, d);
            for (var p = "", m = 0; m < d.length; ++m) p += String.fromCharCode(d[m]);
            d = p;
          }
          var g = '<Data ss:Type="' + h + '">' + d + "</Data>";
          return (e.c || []).length > 0 && (g += Cl(e.c)), V("Cell", g, s);
        }
        function Al(e, t) {
          var r = '<Row ss:Index="' + (e + 1) + '"';
          return t && (t.hpt && !t.hpx && (t.hpx = Wn(t.hpt)), t.hpx && (r += ' ss:AutoFitHeight="0" ss:Height="' + t.hpx + '"'), t.hidden && (r += ' ss:Hidden="1"')), r + ">";
        }
        function Tl(e, t, r, n) {
          if (!e["!ref"]) return "";
          var i = xe(e["!ref"]),
            a = e["!merges"] || [],
            o = 0,
            s = [];
          e["!cols"] && e["!cols"].forEach(function (e, t) {
            Vn(e);
            var r = !!e.width,
              n = po(t, e),
              i = {
                "ss:Index": t + 1
              };
            r && (i["ss:Width"] = Un(n.width)), e.hidden && (i["ss:Hidden"] = "1"), s.push(V("Column", null, i));
          });
          for (var l = Array.isArray(e), c = i.s.r; c <= i.e.r; ++c) {
            for (var u = [Al(c, (e["!rows"] || [])[c])], h = i.s.c; h <= i.e.c; ++h) {
              var f = !1;
              for (o = 0; o != a.length; ++o) if (!(a[o].s.c > h || a[o].s.r > c || a[o].e.c < h || a[o].e.r < c)) {
                a[o].s.c == h && a[o].s.r == c || (f = !0);
                break;
              }
              if (!f) {
                var d = {
                    r: c,
                    c: h
                  },
                  p = be(d),
                  m = l ? (e[c] || [])[h] : e[p];
                u.push(El(m, p, e, t, r, n, d));
              }
            }
            u.push("</Row>"), u.length > 2 && s.push(u.join(""));
          }
          return s.join("");
        }
        function kl(e, t, r) {
          var n = [],
            i = r.SheetNames[e],
            a = r.Sheets[i],
            o = a ? Tl(a, t, e, r) : "";
          return o.length > 0 && n.push("<Table>" + o + "</Table>"), n.push(Sl(a, t, e, r)), n.join("");
        }
        function Rl(e, t) {
          var r = [];
          r.push(wl(e, t)), r.push(xl(e, t)), r.push(_l(e, t));
          for (var n = 0; n < e.SheetNames.length; ++n) r.push(V("Worksheet", kl(n, t, e), {
            "ss:Name": F(e.SheetNames[n])
          }));
          return gu + V("Workbook", r.join(""), {
            xmlns: wu.ss,
            "xmlns:o": wu.o,
            "xmlns:x": wu.x,
            "xmlns:ss": wu.ss,
            "xmlns:dt": wu.dt,
            "xmlns:html": wu.html
          });
        }
        function Il(e) {
          var t,
            r = {},
            n = e.content,
            i = 28;
          switch (t = Au(n, i), i += 4 + ju(n, i), r.UserType = t, t = ju(n, i), i += 4, t) {
            case 0:
              break;
            case 4294967295:
            case 4294967294:
              i += 4;
              break;
            default:
              if (t > 400) throw new Error("Unsupported Clipboard: " + t.toString(16));
              i += t;
          }
          if (t = Au(n, i), i += 0 === t.length ? 0 : 5 + t.length, r.Reserved1 = t, 1907550708 !== (t = ju(n, i))) return r;
          throw new Error("Unsupported Unicode Extension");
        }
        function Ml(e, t, r, n) {
          var i = r,
            a = [],
            o = t.slice(t.l, t.l + i);
          if (n && n.enc && n.enc.insitu_decrypt) switch (e.n) {
            case "BOF":
            case "FilePass":
            case "FileLock":
            case "InterfaceHdr":
            case "RRDInfo":
            case "RRDHead":
            case "UsrExcl":
              break;
            default:
              if (0 === o.length) break;
              n.enc.insitu_decrypt(o);
          }
          a.push(o), t.l += i;
          for (var s = Ey[Nu(t, t.l)], l = 0; null != s && "Continue" === s.n.slice(0, 8);) i = Nu(t, t.l + 2), l = t.l + 4, "ContinueFrt" == s.n ? l += 4 : "ContinueFrt" == s.n.slice(0, 11) && (l += 12), a.push(t.slice(l, t.l + 4 + i)), t.l += 4 + i, s = Ey[Nu(t, t.l)];
          var c = Dc(a);
          Q(c, 0);
          var u = 0;
          c.lens = [];
          for (var h = 0; h < a.length; ++h) c.lens.push(u), u += a[h].length;
          return e.f(c, c.length, n);
        }
        function Ol(e, t, r) {
          if ("z" !== e.t && e.XF) {
            var n = 0;
            try {
              n = e.z || e.XF.numFmtId || 0, t.cellNF && (e.z = Nc._table[n]);
            } catch (e) {
              if (t.WTF) throw e;
            }
            if (!t || !1 !== t.cellText) try {
              if ("e" === e.t ? e.w = e.w || eh[e.v] : 0 === n || "General" == n ? "n" === e.t ? (0 | e.v) === e.v ? e.w = Nc._general_int(e.v) : e.w = Nc._general_num(e.v) : e.w = Nc._general(e.v) : e.w = Nc.format(n, e.v, {
                date1904: !!r
              }), t.cellDates && n && "n" == e.t && Nc.is_date(Nc._table[n] || String(n))) {
                var i = Nc.parse_date_code(e.v);
                i && (e.t = "d", e.v = new Date(i.y, i.m - 1, i.d, i.H, i.M, i.S, i.u));
              }
            } catch (e) {
              if (t.WTF) throw e;
            }
          }
        }
        function Pl(e, t, r) {
          return {
            v: e,
            ixfe: t,
            t: r
          };
        }
        function Bl(e, t) {
          var r = {
              opts: {}
            },
            n = {};
          null != Oc && null == t.dense && (t.dense = Oc);
          var i,
            a,
            o,
            s,
            l,
            c,
            u,
            h = t.dense ? [] : {},
            f = {},
            d = {},
            p = null,
            m = [],
            g = "",
            v = {},
            b = "",
            y = {},
            w = [],
            x = !0,
            _ = [],
            S = [],
            C = {
              Sheets: [],
              WBProps: {
                date1904: !1
              }
            },
            E = {},
            A = function A(e) {
              return e < 8 ? fh[e] : e < 64 ? S[e - 8] || fh[e] : fh[e];
            },
            T = function T(e, t, r) {
              var n = t.XF.data;
              if (n && n.patternType && r && r.cellStyles) {
                t.s = {}, t.s.patternType = n.patternType;
                var i;
                (i = Dn(A(n.icvFore))) && (t.s.fgColor = {
                  rgb: i
                }), (i = Dn(A(n.icvBack))) && (t.s.bgColor = {
                  rgb: i
                });
              }
            },
            k = function k(e, t, r) {
              if (!(N > 1) && x) {
                if (r.cellStyles && t.XF && t.XF.data && T(0, t, r), i = e, b = be(e), d.s && (e.r < d.s.r && (d.s.r = e.r), e.c < d.s.c && (d.s.c = e.c)), d.e && (e.r + 1 > d.e.r && (d.e.r = e.r + 1), e.c + 1 > d.e.c && (d.e.c = e.c + 1)), r.cellFormula && t.f) for (var n = 0; n < w.length; ++n) if (!(w[n][0].s.c > e.c || w[n][0].s.r > e.r || w[n][0].e.c < e.c || w[n][0].e.r < e.r)) {
                  t.F = we(w[n][0]), w[n][0].s.c != e.c && delete t.f, w[n][0].s.r != e.r && delete t.f, t.f && (t.f = "" + so(w[n][1], d, e, D, R));
                  break;
                }
                r.sheetRows && i.r >= r.sheetRows ? x = !1 : r.dense ? (h[e.r] || (h[e.r] = []), h[e.r][e.c] = t) : h[b] = t;
              }
            },
            R = {
              enc: !1,
              sbcch: 0,
              snames: [],
              sharedf: y,
              arrayf: w,
              rrtabid: [],
              lastuser: "",
              biff: 8,
              codepage: 0,
              winlocked: 0,
              cellStyles: !!t && !!t.cellStyles,
              WTF: !!t && !!t.wtf
            };
          t.password && (R.password = t.password);
          var I = [],
            M = [],
            O = [],
            P = [],
            B = !1,
            D = [];
          D.SheetNames = R.snames, D.sharedf = R.sharedf, D.arrayf = R.arrayf, D.names = [], D.XTI = [];
          var L,
            F = "",
            N = 0,
            U = 0,
            j = [],
            z = [];
          for (R.codepage = 1200, Rc(1200); e.l < e.length - 1;) {
            var H = e.l,
              G = e.read_shift(2);
            if (0 === G && "EOF" === F) break;
            var V = e.l === e.length ? 0 : e.read_shift(2),
              q = Ey[G];
            if (q && q.f) {
              if (t.bookSheets && "BoundSheet8" === F && "BoundSheet8" !== q.n) break;
              if (F = q.n, 2 === q.r || 12 == q.r) {
                var W = e.read_shift(2);
                if (V -= 2, !R.enc && W !== G) throw new Error("rt mismatch: " + W + "!=" + G);
                12 == q.r && (e.l += 10, V -= 10);
              }
              var X;
              X = "EOF" === q.n ? q.f(e, V, R) : Ml(q, e, V, R);
              var Y = q.n;
              switch (Y) {
                case "Date1904":
                  r.opts.Date1904 = C.WBProps.date1904 = X;
                  break;
                case "WriteProtect":
                  r.opts.WriteProtect = !0;
                  break;
                case "FilePass":
                  if (R.enc || (e.l = 0), R.enc = X, R.WTF && console.error(X), !t.password) throw new Error("File is password-protected");
                  if (null == X.valid) throw new Error("Encryption scheme unsupported");
                  if (!X.valid) throw new Error("Password is incorrect");
                  break;
                case "WriteAccess":
                  R.lastuser = X;
                  break;
                case "FileSharing":
                  break;
                case "CodePage":
                  21010 === X ? X = 1200 : 32769 === X && (X = 1252), R.codepage = X, Rc(X);
                  break;
                case "RRTabId":
                  R.rrtabid = X;
                  break;
                case "WinProtect":
                  R.winlocked = X;
                  break;
                case "Template":
                  break;
                case "RefreshAll":
                  r.opts.RefreshAll = X;
                  break;
                case "BookBool":
                case "UsesELFs":
                case "MTRSettings":
                  break;
                case "CalcCount":
                  r.opts.CalcCount = X;
                  break;
                case "CalcDelta":
                  r.opts.CalcDelta = X;
                  break;
                case "CalcIter":
                  r.opts.CalcIter = X;
                  break;
                case "CalcMode":
                  r.opts.CalcMode = X;
                  break;
                case "CalcPrecision":
                  r.opts.CalcPrecision = X;
                  break;
                case "CalcSaveRecalc":
                  r.opts.CalcSaveRecalc = X;
                  break;
                case "CalcRefMode":
                  R.CalcRefMode = X;
                  break;
                case "Uncalced":
                  break;
                case "ForceFullCalculation":
                  r.opts.FullCalc = X;
                  break;
                case "WsBool":
                  break;
                case "XF":
                  _.push(X);
                  break;
                case "ExtSST":
                case "BookExt":
                case "RichTextStream":
                case "BkHim":
                  break;
                case "SupBook":
                  D.push([X]), D[D.length - 1].XTI = [];
                  break;
                case "ExternName":
                  D[D.length - 1].push(X);
                  break;
                case "Index":
                  break;
                case "Lbl":
                  L = {
                    Name: X.Name,
                    Ref: so(X.rgce, d, null, D, R)
                  }, X.itab > 0 && (L.Sheet = X.itab - 1), D.names.push(L), D[0] || (D[0] = []), D[D.length - 1].push(X), "_xlnm._FilterDatabase" == X.Name && X.itab > 0 && X.rgce && X.rgce[0] && X.rgce[0][0] && "PtgArea3d" == X.rgce[0][0][0] && (z[X.itab - 1] = {
                    ref: we(X.rgce[0][0][1][2])
                  });
                  break;
                case "ExternCount":
                  R.ExternCount = X;
                  break;
                case "ExternSheet":
                  0 == D.length && (D[0] = [], D[0].XTI = []), D[D.length - 1].XTI = D[D.length - 1].XTI.concat(X), D.XTI = D.XTI.concat(X);
                  break;
                case "NameCmt":
                  if (R.biff < 8) break;
                  null != L && (L.Comment = X[1]);
                  break;
                case "Protect":
                  h["!protect"] = X;
                  break;
                case "Password":
                  0 !== X && R.WTF && console.error("Password verifier: " + X);
                  break;
                case "Prot4Rev":
                case "Prot4RevPass":
                  break;
                case "BoundSheet8":
                  f[X.pos] = X, R.snames.push(X.name);
                  break;
                case "EOF":
                  if (--N) break;
                  d.e && (d.e.r > 0 && d.e.c > 0 && (d.e.r--, d.e.c--, h["!ref"] = we(d), d.e.r++, d.e.c++), I.length > 0 && (h["!merges"] = I), M.length > 0 && (h["!objects"] = M), O.length > 0 && (h["!cols"] = O), P.length > 0 && (h["!rows"] = P), C.Sheets.push(E)), "" === g ? v = h : n[g] = h, h = t.dense ? [] : {};
                  break;
                case "BOF":
                  if (8 !== R.biff || (9 === G ? R.biff = 2 : 521 === G ? R.biff = 3 : 1033 === G ? R.biff = 4 : 1280 === X.BIFFVer ? R.biff = 5 : 1536 === X.BIFFVer ? R.biff = 8 : 2 === X.BIFFVer ? R.biff = 2 : 7 === X.BIFFVer && (R.biff = 2)), N++) break;
                  if (x = !0, h = t.dense ? [] : {}, R.biff < 5) {
                    "" === g && (g = "Sheet1"), d = {
                      s: {
                        r: 0,
                        c: 0
                      },
                      e: {
                        r: 0,
                        c: 0
                      }
                    };
                    var K = {
                      pos: e.l - V,
                      name: g
                    };
                    f[K.pos] = K, R.snames.push(g);
                  } else g = (f[H] || {
                    name: ""
                  }).name;
                  32 == X.dt && (h["!type"] = "chart"), I = [], M = [], w = [], R.arrayf = w, O = [], P = [], 0, B = !1, E = {
                    Hidden: (f[H] || {
                      hs: 0
                    }).hs,
                    name: g
                  };
                  break;
                case "Number":
                case "BIFF2NUM":
                case "BIFF2INT":
                  "chart" == h["!type"] && (t.dense ? (h[X.r] || [])[X.c] : h[be({
                    c: X.c,
                    r: X.r
                  })]) && ++X.c, c = {
                    ixfe: X.ixfe,
                    XF: _[X.ixfe] || {},
                    v: X.val,
                    t: "n"
                  }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t);
                  break;
                case "BoolErr":
                  c = {
                    ixfe: X.ixfe,
                    XF: _[X.ixfe],
                    v: X.val,
                    t: X.t
                  }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t);
                  break;
                case "RK":
                  c = {
                    ixfe: X.ixfe,
                    XF: _[X.ixfe],
                    v: X.rknum,
                    t: "n"
                  }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t);
                  break;
                case "MulRk":
                  for (var Z = X.c; Z <= X.C; ++Z) {
                    var J = X.rkrec[Z - X.c][0];
                    c = {
                      ixfe: J,
                      XF: _[J],
                      v: X.rkrec[Z - X.c][1],
                      t: "n"
                    }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                      c: Z,
                      r: X.r
                    }, c, t);
                  }
                  break;
                case "Formula":
                  if ("String" == X.val) {
                    p = X;
                    break;
                  }
                  if (c = Pl(X.val, X.cell.ixfe, X.tt), c.XF = _[c.ixfe], t.cellFormula) {
                    var Q = X.formula;
                    if (Q && Q[0] && Q[0][0] && "PtgExp" == Q[0][0][0]) {
                      var $ = Q[0][0][1][0],
                        ee = Q[0][0][1][1],
                        te = be({
                          r: $,
                          c: ee
                        });
                      y[te] ? c.f = "" + so(X.formula, d, X.cell, D, R) : c.F = ((t.dense ? (h[$] || [])[ee] : h[te]) || {}).F;
                    } else c.f = "" + so(X.formula, d, X.cell, D, R);
                  }
                  U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k(X.cell, c, t), p = X;
                  break;
                case "String":
                  if (!p) throw new Error("String record expects Formula");
                  p.val = X, c = Pl(X, p.cell.ixfe, "s"), c.XF = _[c.ixfe], t.cellFormula && (c.f = "" + so(p.formula, d, p.cell, D, R)), U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k(p.cell, c, t), p = null;
                  break;
                case "Array":
                  w.push(X);
                  var re = be(X[0].s);
                  if (a = t.dense ? (h[X[0].s.r] || [])[X[0].s.c] : h[re], t.cellFormula && a) {
                    if (!p) break;
                    if (!re || !a) break;
                    a.f = "" + so(X[1], d, X[0], D, R), a.F = we(X[0]);
                  }
                  break;
                case "ShrFmla":
                  if (!x) break;
                  if (!t.cellFormula) break;
                  if (b) {
                    if (!p) break;
                    y[be(p.cell)] = X[0], a = t.dense ? (h[p.cell.r] || [])[p.cell.c] : h[be(p.cell)], (a || {}).f = "" + so(X[0], d, i, D, R);
                  }
                  break;
                case "LabelSst":
                  c = Pl(m[X.isst].t, X.ixfe, "s"), c.XF = _[c.ixfe], U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t);
                  break;
                case "Blank":
                  t.sheetStubs && (c = {
                    ixfe: X.ixfe,
                    XF: _[X.ixfe],
                    t: "z"
                  }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t));
                  break;
                case "MulBlank":
                  if (t.sheetStubs) for (var ne = X.c; ne <= X.C; ++ne) {
                    var ie = X.ixfe[ne - X.c];
                    c = {
                      ixfe: ie,
                      XF: _[ie],
                      t: "z"
                    }, U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                      c: ne,
                      r: X.r
                    }, c, t);
                  }
                  break;
                case "RString":
                case "Label":
                case "BIFF2STR":
                  c = Pl(X.val, X.ixfe, "s"), c.XF = _[c.ixfe], U > 0 && (c.z = j[c.ixfe >> 8 & 31]), Ol(c, t, r.opts.Date1904), k({
                    c: X.c,
                    r: X.r
                  }, c, t);
                  break;
                case "Dimensions":
                  1 === N && (d = X);
                  break;
                case "SST":
                  m = X;
                  break;
                case "Format":
                  Nc.load(X[1], X[0]);
                  break;
                case "BIFF2FORMAT":
                  j[U++] = X;
                  for (var ae = 0; ae < U + 163 && Nc._table[ae] != X; ++ae);
                  ae >= 163 && Nc.load(X, U + 163);
                  break;
                case "MergeCells":
                  I = I.concat(X);
                  break;
                case "Obj":
                  M[X.cmo[0]] = R.lastobj = X;
                  break;
                case "TxO":
                  R.lastobj.TxO = X;
                  break;
                case "ImData":
                  R.lastobj.ImData = X;
                  break;
                case "HLink":
                  for (l = X[0].s.r; l <= X[0].e.r; ++l) for (s = X[0].s.c; s <= X[0].e.c; ++s) (a = t.dense ? (h[l] || [])[s] : h[be({
                    c: s,
                    r: l
                  })]) && (a.l = X[1]);
                  break;
                case "HLinkTooltip":
                  for (l = X[0].s.r; l <= X[0].e.r; ++l) for (s = X[0].s.c; s <= X[0].e.c; ++s) (a = t.dense ? (h[l] || [])[s] : h[be({
                    c: s,
                    r: l
                  })]) && (a.l.Tooltip = X[1]);
                  break;
                case "Note":
                  if (R.biff <= 5 && R.biff >= 2) break;
                  a = t.dense ? (h[X[0].r] || [])[X[0].c] : h[be(X[0])];
                  var oe = M[X[2]];
                  if (!a) break;
                  a.c || (a.c = []), o = {
                    a: X[1],
                    t: oe.TxO.t
                  }, a.c.push(o);
                  break;
                default:
                  switch (q.n) {
                    case "ClrtClient":
                      break;
                    case "XFExt":
                      Fi(_[X.ixfe], X.ext);
                      break;
                    case "DefColWidth":
                      X;
                      break;
                    case "DefaultRowHeight":
                      X[1];
                      break;
                    case "ColInfo":
                      if (!R.cellStyles) break;
                      for (; X.e >= X.s;) O[X.e--] = {
                        width: X.w / 256
                      }, B || (B = !0, Gn(X.w / 256)), Vn(O[X.e + 1]);
                      break;
                    case "Row":
                      var se = {};
                      null != X.level && (P[X.r] = se, se.level = X.level), X.hidden && (P[X.r] = se, se.hidden = !0), X.hpt && (P[X.r] = se, se.hpt = X.hpt, se.hpx = Wn(X.hpt));
                      break;
                    case "LeftMargin":
                    case "RightMargin":
                    case "TopMargin":
                    case "BottomMargin":
                      h["!margins"] || mo(h["!margins"] = {}), h["!margins"][Y.slice(0, -6).toLowerCase()] = X;
                      break;
                    case "Setup":
                      h["!margins"] || mo(h["!margins"] = {}), h["!margins"].header = X.header, h["!margins"].footer = X.footer;
                      break;
                    case "Header":
                    case "Footer":
                    case "HCenter":
                    case "VCenter":
                    case "Pls":
                    case "GCW":
                    case "LHRecord":
                    case "DBCell":
                    case "EntExU2":
                    case "SxView":
                    case "Sxvd":
                    case "SXVI":
                    case "SXVDEx":
                    case "SxIvd":
                    case "SXString":
                    case "Sync":
                    case "Addin":
                    case "SXDI":
                    case "SXLI":
                    case "SXEx":
                    case "QsiSXTag":
                    case "Selection":
                    case "Feat":
                      break;
                    case "FeatHdr":
                    case "FeatHdr11":
                      break;
                    case "Feature11":
                    case "Feature12":
                    case "List12":
                      break;
                    case "Country":
                      u = X;
                      break;
                    case "RecalcId":
                    case "DxGCol":
                      break;
                    case "Fbi":
                    case "Fbi2":
                    case "GelFrame":
                    case "Font":
                    case "XFCRC":
                    case "Style":
                    case "StyleExt":
                      break;
                    case "Palette":
                      S = X;
                      break;
                    case "Theme":
                    case "ScenarioProtect":
                    case "ObjProtect":
                    case "CondFmt12":
                    case "Table":
                    case "TableStyles":
                    case "TableStyle":
                    case "TableStyleElement":
                    case "SXStreamID":
                    case "SXVS":
                    case "DConRef":
                    case "SXAddl":
                    case "DConBin":
                    case "DConName":
                    case "SXPI":
                    case "SxFormat":
                    case "SxSelect":
                    case "SxRule":
                    case "SxFilt":
                    case "SxItm":
                    case "SxDXF":
                    case "ScenMan":
                    case "DCon":
                    case "CellWatch":
                    case "PrintRowCol":
                    case "PrintGrid":
                    case "PrintSize":
                    case "XCT":
                    case "CRN":
                    case "Scl":
                    case "SheetExt":
                    case "SheetExtOptional":
                    case "ObNoMacros":
                    case "ObProj":
                    case "CodeName":
                    case "GUIDTypeLib":
                    case "WOpt":
                    case "PhoneticInfo":
                    case "OleObjectSize":
                      break;
                    case "DXF":
                    case "DXFN":
                    case "DXFN12":
                    case "DXFN12List":
                    case "DXFN12NoCB":
                      break;
                    case "Dv":
                    case "DVal":
                      break;
                    case "BRAI":
                    case "Series":
                    case "SeriesText":
                    case "DConn":
                    case "DbOrParamQry":
                    case "DBQueryExt":
                    case "OleDbConn":
                    case "ExtString":
                    case "IFmtRecord":
                      break;
                    case "CondFmt":
                    case "CF":
                    case "CF12":
                    case "CFEx":
                    case "Excel9File":
                    case "Units":
                      break;
                    case "InterfaceHdr":
                    case "Mms":
                    case "InterfaceEnd":
                    case "DSF":
                    case "BuiltInFnGroupCount":
                      break;
                    case "Window1":
                    case "Window2":
                    case "HideObj":
                    case "GridSet":
                    case "Guts":
                    case "UserBView":
                    case "UserSViewBegin":
                    case "UserSViewEnd":
                    case "Pane":
                      break;
                    default:
                      switch (q.n) {
                        case "Dat":
                        case "Begin":
                        case "End":
                        case "StartBlock":
                        case "EndBlock":
                        case "Frame":
                        case "Area":
                        case "Axis":
                        case "AxisLine":
                        case "Tick":
                          break;
                        case "AxesUsed":
                        case "CrtLayout12":
                        case "CrtLayout12A":
                        case "CrtLink":
                        case "CrtLine":
                        case "CrtMlFrt":
                        case "CrtMlFrtContinue":
                          break;
                        case "LineFormat":
                        case "AreaFormat":
                        case "Chart":
                        case "Chart3d":
                        case "Chart3DBarShape":
                        case "ChartFormat":
                        case "ChartFrtInfo":
                          break;
                        case "PlotArea":
                        case "PlotGrowth":
                          break;
                        case "SeriesList":
                        case "SerParent":
                        case "SerAuxTrend":
                          break;
                        case "DataFormat":
                        case "SerToCrt":
                        case "FontX":
                          break;
                        case "CatSerRange":
                        case "AxcExt":
                        case "SerFmt":
                        case "ShtProps":
                          break;
                        case "DefaultText":
                        case "Text":
                        case "CatLab":
                        case "DataLabExtContents":
                          break;
                        case "Legend":
                        case "LegendException":
                          break;
                        case "Pie":
                        case "Scatter":
                          break;
                        case "PieFormat":
                        case "MarkerFormat":
                          break;
                        case "StartObject":
                        case "EndObject":
                          break;
                        case "AlRuns":
                        case "ObjectLink":
                        case "SIIndex":
                          break;
                        case "AttachedLabel":
                        case "YMult":
                          break;
                        case "Line":
                        case "Bar":
                        case "Surf":
                        case "AxisParent":
                        case "Pos":
                        case "ValueRange":
                        case "SXViewEx9":
                        case "SXViewLink":
                        case "PivotChartBits":
                        case "SBaseRef":
                        case "TextPropsStream":
                        case "LnExt":
                        case "MkrExt":
                        case "CrtCoopt":
                          break;
                        case "Qsi":
                        case "Qsif":
                        case "Qsir":
                        case "QsiSXTag":
                        case "TxtQry":
                        case "FilterMode":
                          break;
                        case "AutoFilter":
                        case "AutoFilterInfo":
                        case "AutoFilter12":
                        case "DropDownObjIds":
                        case "Sort":
                        case "SortData":
                        case "ShapePropsStream":
                          break;
                        case "MsoDrawing":
                        case "MsoDrawingGroup":
                        case "MsoDrawingSelection":
                          break;
                        case "WebPub":
                        case "AutoWebPub":
                          break;
                        case "HeaderFooter":
                        case "HFPicture":
                        case "PLV":
                        case "HorizontalPageBreaks":
                        case "VerticalPageBreaks":
                          break;
                        case "Backup":
                        case "CompressPictures":
                        case "Compat12":
                          break;
                        case "Continue":
                        case "ContinueFrt12":
                          break;
                        case "FrtFontList":
                        case "FrtWrapper":
                          break;
                        default:
                          switch (q.n) {
                            case "TabIdConf":
                            case "Radar":
                            case "RadarArea":
                            case "DropBar":
                            case "Intl":
                            case "CoordList":
                            case "SerAuxErrBar":
                              break;
                            case "BIFF2FONTCLR":
                            case "BIFF2FMTCNT":
                            case "BIFF2FONTXTRA":
                              break;
                            case "BIFF2XF":
                            case "BIFF3XF":
                            case "BIFF4XF":
                              break;
                            case "BIFF4FMTCNT":
                            case "BIFF2ROW":
                            case "BIFF2WINDOW2":
                              break;
                            case "SCENARIO":
                            case "DConBin":
                            case "PicF":
                            case "DataLabExt":
                            case "Lel":
                            case "BopPop":
                            case "BopPopCustom":
                            case "RealTimeData":
                            case "Name":
                              break;
                            case "LHNGraph":
                            case "FnGroupName":
                            case "AddMenu":
                            case "LPr":
                              break;
                            case "ListObj":
                            case "ListField":
                            case "RRSort":
                            case "BigName":
                              break;
                            default:
                              if (t.WTF) throw "Unrecognized Record " + q.n;
                          }
                      }
                  }
              }
            } else e.l += V;
          }
          var le = Object.keys(f).sort(function (e, t) {
            return Number(e) - Number(t);
          }).map(function (e) {
            return f[e].name;
          });
          le.slice();
          return r.Directory = le, r.SheetNames = le, t.bookSheets || (r.Sheets = n), r.Sheets && z.forEach(function (e, t) {
            r.Sheets[r.SheetNames[t]]["!autofilter"] = e;
          }), r.Preamble = v, r.Strings = m, r.SSF = Nc.get_table(), R.enc && (r.Encryption = R.enc), r.Metadata = {}, void 0 !== u && (r.Metadata.Country = u), D.names.length > 0 && (C.Names = D.names), r.Workbook = C, r;
        }
        function Dl(e) {
          var t = e.find("!DocumentSummaryInformation");
          if (t) try {
            e.DocSummary = Ot(t, sh);
          } catch (e) {}
          var r = e.find("!SummaryInformation");
          if (r) try {
            e.Summary = Ot(r, lh);
          } catch (e) {}
        }
        function Ll(e, t) {
          t || (t = {}), Ly(t), o();
          var r, n;
          e.FullPaths ? (r = e.find("!CompObj"), e.find("!SummaryInformation"), n = e.find("/Workbook")) : (Q(e, 0), n = {
            content: e
          }), n || (n = e.find("/Book"));
          var i;
          if (r && Il(r), t.bookProps && !t.bookSheets) i = {};else if (n) i = Bl(n.content, t);else if (e.find("PerfectOffice_MAIN")) i = Pv.to_workbook(e.find("PerfectOffice_MAIN").content, t);else {
            if (!e.find("NativeContent_MAIN")) throw new Error("Cannot find Workbook stream");
            i = Pv.to_workbook(e.find("NativeContent_MAIN").content, t);
          }
          e.FullPaths && Dl(e);
          var a = {};
          for (var s in e.Summary) a[s] = e.Summary[s];
          for (s in e.DocSummary) a[s] = e.DocSummary[s];
          return i.Props = i.Custprops = a, t.bookFiles && (i.cfb = e), i;
        }
        function Fl(e, t, r, n) {
          var i = n || (r || []).length,
            a = e.next(4 + i);
          a.write_shift(2, t), a.write_shift(2, i), i > 0 && Lu(r) && e.push(r);
        }
        function Nl(e, t) {
          if ("biff2" != t.bookType) throw "unsupported BIFF version";
          var r = ee(4);
          return r.write_shift(2, 2), r.write_shift(2, 16), r;
        }
        function Ul(e, t, r) {
          return e || (e = ee(7)), e.write_shift(2, t), e.write_shift(2, r), e.write_shift(1, 0), e.write_shift(1, 0), e.write_shift(1, 0), e;
        }
        function jl(e, t, r) {
          var n = ee(9);
          return Ul(n, e, t), n.write_shift(2, r), n;
        }
        function zl(e, t, r) {
          var n = ee(15);
          return Ul(n, e, t), n.write_shift(8, r, "f"), n;
        }
        function Hl(e, t, r, n) {
          var i = ee(9);
          return Ul(i, e, t), "e" == n ? (i.write_shift(1, r), i.write_shift(1, 1)) : (i.write_shift(1, r ? 1 : 0), i.write_shift(1, 0)), i;
        }
        function Gl(e, t, r) {
          var n = ee(8 + 2 * r.length);
          return Ul(n, e, t), n.write_shift(1, r.length), n.write_shift(r.length, r, "sbcs"), n.l < n.length ? n.slice(0, n.l) : n;
        }
        function Vl(e, t, r, n, i) {
          if (null != t.v) switch (t.t) {
            case "d":
            case "n":
              var a = "d" == t.t ? b(t.v) : t.v;
              return void (a == (0 | a) && a >= 0 && a < 65536 ? Fl(e, 2, jl(r, n, a)) : Fl(e, 3, zl(r, n, a)));
            case "b":
            case "e":
              return void Fl(e, 5, Hl(r, n, t.v, t.t));
            case "s":
            case "str":
              return void Fl(e, 4, Gl(r, n, t.v));
          }
          Fl(e, 1, Ul(null, r, n));
        }
        function ql(e, t, r, n, i) {
          for (var a, o = Array.isArray(t), s = xe(t["!ref"] || "A1"), l = "", c = [], u = s.s.r; u <= s.e.r; ++u) {
            l = ce(u);
            for (var h = s.s.c; h <= s.e.c; ++h) {
              u === s.s.r && (c[h] = de(h)), a = c[h] + l;
              var f = o ? (t[u] || [])[h] : t[a];
              f && Vl(e, f, u, h, n);
            }
          }
        }
        function Wl(e, t) {
          var r = t || {};
          null != Oc && null == r.dense && (r.dense = Oc);
          for (var n = re(), i = 0, a = 0; a < e.SheetNames.length; ++a) e.SheetNames[a] == r.sheet && (i = a);
          if (0 == i && r.sheet && e.SheetNames[0] != r.sheet) throw new Error("Sheet not found: " + r.sheet);
          return Fl(n, 9, Nl(e, r)), ql(n, e.Sheets[e.SheetNames[i]], i, r, e), Fl(n, 10), n.end();
        }
        function Xl(e, t) {
          var r = t || {};
          null != Oc && (r.dense = Oc);
          for (var n = r.dense ? [] : {}, i = e.getElementsByTagName("tr"), a = {
              s: {
                r: 0,
                c: 0
              },
              e: {
                r: i.length - 1,
                c: 0
              }
            }, o = [], s = 0, l = 0, c = 0, u = 0, h = 0, f = 0; l < i.length; ++l) {
            var d = i[l],
              p = d.children;
            for (c = u = 0; c < p.length; ++c) {
              var m = p[c],
                g = p[c].innerText || p[c].textContent;
              for (s = 0; s < o.length; ++s) {
                var v = o[s];
                v.s.c == u && v.s.r <= l && l <= v.e.r && (u = v.e.c + 1, s = -1);
              }
              f = +m.getAttribute("colspan") || 1, ((h = +m.getAttribute("rowspan")) > 0 || f > 1) && o.push({
                s: {
                  r: l,
                  c: u
                },
                e: {
                  r: l + (h || 1) - 1,
                  c: u + f - 1
                }
              });
              var y = {
                t: "s",
                v: g
              };
              null != g && g.length && (isNaN(Number(g)) ? isNaN(A(g).getDate()) || (y = {
                t: "d",
                v: x(g)
              }, r.cellDates || (y = {
                t: "n",
                v: b(y.v)
              }), y.z = r.dateNF || Nc._table[14]) : y = {
                t: "n",
                v: Number(g)
              }), r.dense ? (n[l] || (n[l] = []), n[l][u] = y) : n[be({
                c: u,
                r: l
              })] = y, a.e.c < u && (a.e.c = u), u += f;
            }
          }
          return n["!merges"] = o, n["!ref"] = we(a), n;
        }
        function Yl(e, t) {
          return Ce(Xl(e, t), t);
        }
        function Kl(e, t) {
          t = t || {};
          var r = !!I(e, "objectdata");
          if (r) {
            tt(O(e, "META-INF/manifest.xml"), t);
          }
          var n = P(e, "content.xml");
          if (!n) throw new Error("Missing content.xml in " + (r ? "ODS" : "UOF") + " file");
          return Ty(r ? n : su(n), t);
        }
        function Zl(e, t) {
          return Ty(e, t);
        }
        function Jl(e, t) {
          if ("fods" == t.bookType) return Ry(e, t);
          var r = new Xc(),
            n = "",
            i = [],
            a = [];
          return n = "mimetype", r.file(n, "application/vnd.oasis.opendocument.spreadsheet"), n = "content.xml", r.file(n, Ry(e, t)), i.push([n, "text/xml"]), a.push([n, "ContentFile"]), n = "styles.xml", r.file(n, ky(e, t)), i.push([n, "text/xml"]), a.push([n, "StylesFile"]), n = "manifest.rdf", r.file(n, at(a, t)), i.push([n, "application/rdf+xml"]), n = "meta.xml", r.file(n, xh(e, t)), i.push([n, "text/xml"]), a.push([n, "MetadataFile"]), n = "META-INF/manifest.xml", r.file(n, rt(i, t)), r;
        }
        function Ql(e) {
          return function (t, r) {
            for (var n = 0, i = 0; i < t.SheetNames.length; ++i) t.SheetNames[i] == r.sheet && (n = i);
            if (0 == n && r.sheet && t.SheetNames[0] != r.sheet) throw new Error("Sheet not found: " + r.sheet);
            return e.from_sheet(t.Sheets[t.SheetNames[n]], r, t);
          };
        }
        function $l(e) {
          return function (t) {
            for (var r = 0; r != e.length; ++r) {
              var n = e[r];
              void 0 === t[n[0]] && (t[n[0]] = n[1]), "n" === n[2] && (t[n[0]] = Number(t[n[0]]));
            }
          };
        }
        function ec(e) {
          return bh.WS.indexOf(e) > -1 ? "sheet" : bh.CS && e == bh.CS ? "chart" : bh.DS && e == bh.DS ? "dialog" : bh.MS && e == bh.MS ? "macro" : e && e.length ? e : "sheet";
        }
        function tc(e, t) {
          if (!e) return 0;
          try {
            e = t.map(function (t) {
              return t.id || (t.id = t.strRelID), [t.name, e["!id"][t.id].Target, ec(e["!id"][t.id].Type)];
            });
          } catch (e) {
            return null;
          }
          return e && 0 !== e.length ? e : null;
        }
        function rc(e, t, r, n, i, a, o, s, l, c, u) {
          try {
            i[n] = Qe(P(e, r, !0), t);
            var h = O(e, t);
            switch (o) {
              case "sheet":
                a[n] = Ks(h, t, s, i[n], l, c, u);
                break;
              case "chart":
                var f = Zs(h, t, s, i[n], l, c, u);
                if (a[n] = f, !f || !f["!chart"]) break;
                var d = B(f["!chart"].Target, t),
                  p = Je(d),
                  m = zi(P(e, d, !0), Qe(P(e, p, !0), d)),
                  g = B(m, d),
                  v = Je(g);
                f = Es(P(e, g, !0), g, s, Qe(P(e, v, !0), g), l, f);
                break;
              case "macro":
                a[n] = Js(h, t, s, i[n], l, c, u);
                break;
              case "dialog":
                a[n] = Qs(h, t, s, i[n], l, c, u);
            }
          } catch (e) {
            if (s.WTF) throw e;
          }
        }
        function nc(e, t) {
          if (Uc(Nc), t = t || {}, Ly(t), o(), I(e, "META-INF/manifest.xml")) return Kl(e, t);
          if (I(e, "objectdata.xml")) return Kl(e, t);
          var r,
            n,
            i = m(e.files).filter(Ny).sort(),
            a = Ke(P(e, "[Content_Types].xml"), t),
            s = !1;
          if (0 === a.workbooks.length && (n = "xl/workbook.xml", O(e, n, !0) && a.workbooks.push(n)), 0 === a.workbooks.length) {
            if (n = "xl/workbook.bin", !O(e, n, !0)) throw new Error("Could not find workbook");
            a.workbooks.push(n), s = !0;
          }
          "bin" == a.workbooks[0].slice(-3) && (s = !0), s && Rc(1200);
          var l = {},
            c = {};
          t.bookSheets || t.bookProps || (Jb = [], a.sst && (Jb = tl(O(e, a.sst.replace(/^\//, "")), a.sst, t)), t.cellStyles && a.themes.length && (l = el(P(e, a.themes[0].replace(/^\//, ""), !0) || "", a.themes[0], t)), a.style && (c = $s(O(e, a.style.replace(/^\//, "")), a.style, l, t)));
          var u = Ys(O(e, a.workbooks[0].replace(/^\//, "")), a.workbooks[0], t),
            h = {},
            f = "";
          0 !== a.coreprops.length && (f = P(e, a.coreprops[0].replace(/^\//, ""), !0), f && (h = ot(f)), 0 !== a.extprops.length && (f = P(e, a.extprops[0].replace(/^\//, ""), !0)) && ct(f, h));
          var d = {};
          t.bookSheets && !t.bookProps || 0 !== a.custprops.length && (f = P(e, a.custprops[0].replace(/^\//, ""), !0)) && (d = ht(f, t));
          var p = {};
          if ((t.bookSheets || t.bookProps) && (u.Sheets ? r = u.Sheets.map(function (e) {
            return e.name;
          }) : h.Worksheets && h.SheetNames.length > 0 && (r = h.SheetNames), t.bookProps && (p.Props = h, p.Custprops = d), t.bookSheets && void 0 !== r && (p.SheetNames = r), t.bookSheets ? p.SheetNames : t.bookProps)) return p;
          r = {};
          var g = {};
          t.bookDeps && a.calcchain && (g = nl(O(e, a.calcchain.replace(/^\//, "")), a.calcchain, t));
          var v,
            b,
            y = 0,
            w = {},
            x = u.Sheets;
          h.Worksheets = x.length, h.SheetNames = [];
          for (var _ = 0; _ != x.length; ++_) h.SheetNames[_] = x[_].name;
          var S = s ? "bin" : "xml",
            C = "xl/_rels/workbook." + S + ".rels",
            E = Qe(P(e, C, !0), C);
          E && (E = tc(E, u.Sheets));
          var A = O(e, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
          for (y = 0; y != h.Worksheets; ++y) {
            var T = "sheet";
            E && E[y] ? (v = "xl/" + E[y][1].replace(/[\/]?xl\//, ""), T = E[y][2]) : (v = "xl/worksheets/sheet" + (y + 1 - A) + "." + S, v = v.replace(/sheet0\./, "sheet.")), b = v.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), rc(e, v, b, h.SheetNames[y], w, r, T, t, u, l, c);
          }
          return a.comments && Gi(e, a.comments, r, w, t), p = {
            Directory: a,
            Workbook: u,
            Props: h,
            Custprops: d,
            Deps: g,
            Sheets: r,
            SheetNames: h.SheetNames,
            Strings: Jb,
            Styles: c,
            Themes: l,
            SSF: Nc.get_table()
          }, t.bookFiles && (p.keys = i, p.files = e.files), t.bookVBA && (a.vba.length > 0 ? p.vbaraw = O(e, a.vba[0].replace(/^\//, ""), !0) : a.defaults && "application/vnd.ms-office.vbaProject" === a.defaults.bin && (p.vbaraw = O(e, "xl/vbaProject.bin", !0))), p;
        }
        function ic(e, t) {
          var r = "Version",
            n = e.find(r);
          if (!n || !n.content) throw new Error("ECMA-376 Encrypted file missing " + r);
          gn(n.content);
          if (r = "DataSpaceMap", !(n = e.find(r)) || !n.content) throw new Error("ECMA-376 Encrypted file missing " + r);
          var i = bn(n.content);
          if (1 != i.length || 1 != i[0].comps.length || 0 != i[0].comps[0].t || "StrongEncryptionDataSpace" != i[0].name || "EncryptedPackage" != i[0].comps[0].v) throw new Error("ECMA-376 Encrypted file bad " + r);
          if (r = "StrongEncryptionDataSpace", !(n = e.find(r)) || !n.content) throw new Error("ECMA-376 Encrypted file missing " + r);
          var a = yn(n.content);
          if (1 != a.length || "StrongEncryptionTransform" != a[0]) throw new Error("ECMA-376 Encrypted file bad " + r);
          if (r = "!Primary", !(n = e.find(r)) || !n.content) throw new Error("ECMA-376 Encrypted file missing " + r);
          xn(n.content);
          if (r = "EncryptionInfo", !(n = e.find(r)) || !n.content) throw new Error("ECMA-376 Encrypted file missing " + r);
          Cn(n.content);
          throw new Error("File is password-protected");
        }
        function ac(e, t) {
          if (cb = 1024, "ods" == t.bookType) return Jl(e, t);
          e && !e.SSF && (e.SSF = Nc.get_table()), e && e.SSF && (Uc(Nc), Nc.load_table(e.SSF), t.revssf = v(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.rels = {}, t.wbrels = {}, t.Strings = [], t.Strings.Count = 0, t.Strings.Unique = 0;
          var r = "xlsb" == t.bookType ? "bin" : "xml",
            n = "xlsb" == t.bookType || "xlsm" == t.bookType,
            i = Ye();
          Fy(t = t || {});
          var a = new Xc(),
            o = "",
            s = 0;
          for (t.cellXfs = [], go(t.cellXfs, {}, {
            revssf: {
              General: 0
            }
          }), e.Props || (e.Props = {}), o = "docProps/core.xml", a.file(o, lt(e.Props, t)), i.coreprops.push(o), et(t.rels, 2, o, bh.CORE_PROPS), o = "docProps/app.xml", e.Props && e.Props.SheetNames || (e.Workbook && e.Workbook.Sheets ? e.Props.SheetNames = e.SheetNames.map(function (t, r) {
            return [2 != (e.Workbook.Sheets[r] || {}).Hidden, t];
          }).filter(function (e) {
            return e[0];
          }).map(function (e) {
            return e[1];
          }) : e.Props.SheetNames = e.SheetNames), e.Props.Worksheets = e.Props.SheetNames.length, a.file(o, ut(e.Props, t)), i.extprops.push(o), et(t.rels, 3, o, bh.EXT_PROPS), e.Custprops !== e.Props && m(e.Custprops || {}).length > 0 && (o = "docProps/custom.xml", a.file(o, ft(e.Custprops, t)), i.custprops.push(o), et(t.rels, 4, o, bh.CUST_PROPS)), o = "xl/workbook." + r, a.file(o, il(e, o, t)), i.workbooks.push(o), et(t.rels, 1, o, bh.WB), s = 1; s <= e.SheetNames.length; ++s) {
            var l = {
                "!id": {}
              },
              c = e.Sheets[e.SheetNames[s - 1]];
            switch ((c || {})["!type"] || "sheet") {
              case "chart":
              default:
                o = "xl/worksheets/sheet" + s + "." + r, a.file(o, al(s - 1, o, t, e, l)), i.sheets.push(o), et(t.wbrels, -1, "worksheets/sheet" + s + "." + r, bh.WS[0]);
            }
            if (c) {
              var u = c["!comments"];
              if (u && u.length > 0) {
                var h = "xl/comments" + s + "." + r;
                a.file(h, ll(u, h, t)), i.comments.push(h), et(l, -1, "../comments" + s + "." + r, bh.CMNT);
              }
              c["!legacy"] && a.file("xl/drawings/vmlDrawing" + s + ".vml", Hi(s, c["!comments"])), delete c["!comments"], delete c["!legacy"];
            }
            l["!id"].rId1 && a.file(Je(o), $e(l));
          }
          return null != t.Strings && t.Strings.length > 0 && (o = "xl/sharedStrings." + r, a.file(o, sl(t.Strings, o, t)), i.strs.push(o), et(t.wbrels, -1, "sharedStrings." + r, bh.SST)), o = "xl/theme/theme1.xml", a.file(o, Ri(e.Themes, t)), i.themes.push(o), et(t.wbrels, -1, "theme/theme1.xml", bh.THEME), o = "xl/styles." + r, a.file(o, ol(e, o, t)), i.styles.push(o), et(t.wbrels, -1, "styles." + r, bh.STY), e.vbaraw && n && (o = "xl/vbaProject.bin", a.file(o, e.vbaraw), i.vba.push(o), et(t.wbrels, -1, "vbaProject.bin", bh.VBA)), a.file("[Content_Types].xml", Ze(i, t)), a.file("_rels/.rels", $e(t.rels)), a.file("xl/_rels/workbook." + r + ".rels", $e(t.wbrels)), delete t.revssf, delete t.ssf, a;
        }
        function oc(e, t) {
          var r = "";
          switch ((t || {}).type || "base64") {
            case "buffer":
              return [e[0], e[1], e[2], e[3]];
            case "base64":
              r = Pc.decode(e.substr(0, 24));
              break;
            case "binary":
              r = e;
              break;
            case "array":
              return [e[0], e[1], e[2], e[3]];
            default:
              throw new Error("Unrecognized type " + (t && t.type || "undefined"));
          }
          return [r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2), r.charCodeAt(3)];
        }
        function sc(e, t) {
          return e.find("EncryptedPackage") ? ic(e, t) : Ll(e, t);
        }
        function lc(e, t) {
          var r,
            n = e,
            a = t || {};
          switch (a.type || (a.type = Bc && i.isBuffer(e) ? "buffer" : "base64"), a.type) {
            case "base64":
              r = new Xc(n, {
                base64: !0
              });
              break;
            case "binary":
            case "array":
              r = new Xc(n, {
                base64: !1
              });
              break;
            case "buffer":
              r = new Xc(n);
              break;
            default:
              throw new Error("Unrecognized type " + a.type);
          }
          return nc(r, a);
        }
        function cc(e, t) {
          var r = 0;
          e: for (; r < e.length;) switch (e.charCodeAt(r)) {
            case 10:
            case 13:
            case 32:
              ++r;
              break;
            case 60:
              return yl(e.slice(r), t);
            default:
              break e;
          }
          return Ov.to_workbook(e, t);
        }
        function uc(e, t) {
          var r = "",
            n = oc(e, t);
          switch (t.type) {
            case "base64":
              r = Pc.decode(e);
              break;
            case "binary":
              r = e;
              break;
            case "buffer":
              r = e.toString("binary");
              break;
            case "array":
              r = _(e);
              break;
            default:
              throw new Error("Unrecognized type " + t.type);
          }
          return 239 == n[0] && 187 == n[1] && 191 == n[2] && (r = su(r)), cc(r, t);
        }
        function hc(e, t) {
          var r = e;
          return "base64" == t.type && (r = Pc.decode(r)), r = cptable.utils.decode(1200, r.slice(2), "str"), t.type = "binary", cc(r, t);
        }
        function fc(e, t) {
          var r = e,
            n = [0],
            a = t || {};
          switch (Qb = {}, a.dateNF && (Qb.dateNF = a.dateNF), a.type || (a.type = Bc && i.isBuffer(e) ? "buffer" : "base64"), "file" == a.type && (a.type = "buffer", r = Wc.readFileSync(e)), (n = oc(r, a))[0]) {
            case 208:
              return sc(Hc.read(r, a), a);
            case 9:
              return Ll(h("base64" === a.type ? Pc.decode(r) : r), a);
            case 60:
              return yl(r, a);
            case 73:
              if (68 == n[1]) return on(r, a);
              break;
            case 84:
              if (65 == n[1] && 66 == n[2] && 76 == n[3]) return Mv.to_workbook(r, a);
              break;
            case 80:
              if (75 == n[1] && n[2] < 32 && n[3] < 32) return lc(r, a);
              break;
            case 239:
              return 60 == n[3] ? yl(r, a) : Ov.to_workbook(r, a);
            case 255:
              if (254 == n[1]) return hc(r, a);
              break;
            case 0:
              if (0 == n[1] && n[2] >= 2 && 0 == n[3]) return Pv.to_workbook(r, a);
              break;
            case 3:
            case 131:
            case 139:
              return Rv.to_workbook(r, a);
            case 123:
              if (92 == n[1] && 114 == n[2] && 116 == n[3]) throw new Error("Unsupported RTF");
              break;
            case 10:
            case 13:
            case 32:
              return uc(r, a);
          }
          if (n[2] <= 12 && n[3] <= 31) return Rv.to_workbook(r, a);
          if (32 > n[0] || n[0] > 127) throw new Error("Unsupported file " + n.join("|"));
          return Ov.to_workbook(r, a);
        }
        function dc(e, t) {
          var r = t || {};
          return r.type = "file", fc(e, r);
        }
        function pc(e, t) {
          var r = t || {},
            n = ac(e, r),
            i = {};
          switch (r.compression && (i.compression = "DEFLATE"), r.type) {
            case "base64":
              i.type = "base64";
              break;
            case "binary":
              i.type = "string";
              break;
            case "buffer":
            case "file":
              i.type = "nodebuffer";
              break;
            default:
              throw new Error("Unrecognized type " + r.type);
          }
          return "file" === r.type ? Wc.writeFileSync(r.file, n.generate(i)) : n.generate(i);
        }
        function mc(e, t) {
          switch (t.type) {
            case "base64":
              return Pc.encode(e);
            case "binary":
              return e;
            case "file":
              return Wc.writeFileSync(t.file, e, "binary");
            case "buffer":
              return Bc ? new i(e, "binary") : e.split("").map(function (e) {
                return e.charCodeAt(0);
              });
          }
          throw new Error("Unrecognized type " + t.type);
        }
        function gc(e, t) {
          switch (t.type) {
            case "base64":
              return Pc.encode(e);
            case "binary":
              return e;
            case "file":
              return Wc.writeFileSync(t.file, e, "utf8");
            case "buffer":
              return Bc ? new i(e, "utf8") : e.split("").map(function (e) {
                return e.charCodeAt(0);
              });
          }
          throw new Error("Unrecognized type " + t.type);
        }
        function vc(e, t) {
          switch (t.type) {
            case "base64":
            case "binary":
              for (var r = "", n = 0; n < e.length; ++n) r += String.fromCharCode(e[n]);
              return "base64" == t.type ? Pc.encode(r) : r;
            case "file":
              return Wc.writeFileSync(t.file, e);
            case "buffer":
              return e;
            default:
              throw new Error("Unrecognized type " + t.type);
          }
        }
        function bc(e, t) {
          Ps(e);
          var r = t || {};
          switch (r.bookType || "xlsb") {
            case "xml":
            case "xlml":
              return gc(Rl(e, r), r);
            case "slk":
            case "sylk":
              return gc(Oy(e, r), r);
            case "html":
              return gc(Iy(e, r), r);
            case "txt":
              return mc(Dy(e, r), r);
            case "csv":
              return gc(My(e, r), r);
            case "dif":
              return gc(Py(e, r), r);
            case "prn":
              return gc(By(e, r), r);
            case "fods":
              return gc(Jl(e, r), r);
            case "biff2":
              return vc(Wl(e, r), r);
            case "xlsx":
            case "xlsm":
            case "xlsb":
            case "ods":
              return pc(e, r);
            default:
              throw new Error("Unrecognized bookType |" + r.bookType + "|");
          }
        }
        function yc(e) {
          if (!e.bookType) switch (e.file.slice(e.file.lastIndexOf(".")).toLowerCase()) {
            case ".xlsx":
              e.bookType = "xlsx";
              break;
            case ".xlsm":
              e.bookType = "xlsm";
              break;
            case ".xlsb":
              e.bookType = "xlsb";
              break;
            case ".fods":
              e.bookType = "fods";
              break;
            case ".xlml":
              e.bookType = "xlml";
              break;
            case ".sylk":
              e.bookType = "sylk";
              break;
            case ".html":
              e.bookType = "html";
              break;
            case ".xls":
              e.bookType = "biff2";
              break;
            case ".xml":
              e.bookType = "xml";
              break;
            case ".ods":
              e.bookType = "ods";
              break;
            case ".csv":
              e.bookType = "csv";
              break;
            case ".txt":
              e.bookType = "txt";
              break;
            case ".dif":
              e.bookType = "dif";
              break;
            case ".prn":
              e.bookType = "prn";
              break;
            case ".slk":
              e.bookType = "sylk";
              break;
            case ".htm":
              e.bookType = "html";
          }
        }
        function wc(e, t, r) {
          var n = r || {};
          return n.type = "file", n.file = t, yc(n), bc(e, n);
        }
        function xc(e, t, r, n) {
          var i = r || {};
          i.type = "file", i.file = e, yc(i), i.type = "buffer";
          var a = n;
          return a instanceof Function || (a = r), Wc.writeFile(e, bc(t, i), a);
        }
        function _c(e, t) {
          if (null == e || null == e["!ref"]) return [];
          var r = {
              t: "n",
              v: 0
            },
            n = 0,
            i = 1,
            a = [],
            o = !0,
            s = 0,
            l = "",
            c = {
              s: {
                r: 0,
                c: 0
              },
              e: {
                r: 0,
                c: 0
              }
            },
            u = null != t ? t : {},
            h = u.raw,
            f = u.defval,
            d = null != u.range ? u.range : e["!ref"];
          switch (1 === u.header ? n = 1 : "A" === u.header ? n = 2 : Array.isArray(u.header) && (n = 3), _typeof(d)) {
            case "string":
              c = xe(d);
              break;
            case "number":
              c = xe(e["!ref"]), c.s.r = d;
              break;
            default:
              c = d;
          }
          n > 0 && (i = 0);
          var p = ce(c.s.r),
            m = new Array(c.e.c - c.s.c + 1),
            g = new Array(c.e.r - c.s.r - i + 1),
            v = 0,
            b = 0,
            y = Array.isArray(e),
            w = c.s.r,
            x = 0,
            _ = 0;
          for (y && !e[w] && (e[w] = []), x = c.s.c; x <= c.e.c; ++x) switch (m[x] = de(x), r = y ? e[w][x] : e[m[x] + p], n) {
            case 1:
              a[x] = x - c.s.c;
              break;
            case 2:
              a[x] = m[x];
              break;
            case 3:
              a[x] = u.header[x - c.s.c];
              break;
            default:
              if (null == r) continue;
              for (l = s = Se(r, null, u), b = 0, _ = 0; _ < a.length; ++_) a[_] == l && (l = s + "_" + ++b);
              a[x] = l;
          }
          var S = 1 === n ? [] : {};
          for (w = c.s.r + i; w <= c.e.r; ++w) {
            if (p = ce(w), o = !0, 1 === n) S = [];else if (S = {}, Object.defineProperty) try {
              Object.defineProperty(S, "__rowNum__", {
                value: w,
                enumerable: !1
              });
            } catch (e) {
              S.__rowNum__ = w;
            } else S.__rowNum__ = w;
            if (!y || e[w]) for (x = c.s.c; x <= c.e.c; ++x) if (void 0 !== (r = y ? e[w][x] : e[m[x] + p]) && void 0 !== r.t) {
              switch (s = r.v, r.t) {
                case "z":
                  if (null == s) break;
                  continue;
                case "e":
                  continue;
                case "s":
                case "d":
                case "b":
                case "n":
                  break;
                default:
                  throw new Error("unrecognized type " + r.t);
              }
              if (null != a[x]) {
                if (null == s) {
                  if (void 0 !== f) S[a[x]] = f;else {
                    if (!h || null !== s) continue;
                    S[a[x]] = null;
                  }
                } else S[a[x]] = h ? s : Se(r, s, u);
                o = !1;
              }
            } else {
              if (void 0 === f) continue;
              null != a[x] && (S[a[x]] = f, o = !1);
            }
            !1 !== o && (1 === n ? !1 === u.blankrows : !u.blankrows) || (g[v++] = S);
          }
          return g.length = v, g;
        }
        function Sc(e, t, r, n, i, a, o, s) {
          for (var l = !0, c = "", u = "", h = ce(r), f = t.s.c; f <= t.e.c; ++f) {
            var d = s.dense ? (e[r] || [])[f] : e[n[f] + h];
            if (null == d) u = "";else if (null != d.v) {
              l = !1, u = "" + Se(d, null, s);
              for (var p = 0, m = 0; p !== u.length; ++p) if ((m = u.charCodeAt(p)) === i || m === a || 34 === m) {
                u = '"' + u.replace(Uy, '""') + '"';
                break;
              }
              "ID" == u && (u = '"ID"');
            } else null == d.f || d.F ? u = "" : (l = !1, u = "=" + d.f, u.indexOf(",") >= 0 && (u = '"' + u.replace(Uy, '""') + '"'));
            c += (f === t.s.c ? "" : o) + u;
          }
          return !1 === s.blankrows && l ? null : c;
        }
        function Cc(e, t) {
          var r = [],
            n = null == t ? {} : t;
          if (null == e || null == e["!ref"]) return "";
          var i = xe(e["!ref"]),
            a = void 0 !== n.FS ? n.FS : ",",
            o = a.charCodeAt(0),
            s = void 0 !== n.RS ? n.RS : "\n",
            l = s.charCodeAt(0),
            c = new RegExp(("|" == a ? "\\|" : a) + "+$"),
            u = "",
            h = [];
          n.dense = Array.isArray(e);
          for (var f = i.s.c; f <= i.e.c; ++f) h[f] = de(f);
          for (var d = i.s.r; d <= i.e.r; ++d) null != (u = Sc(e, i, d, h, o, l, a, n)) && (n.strip && (u = u.replace(c, "")), r.push(u + s));
          return delete n.dense, r.join("");
        }
        function Ec(e, t) {
          t || (t = {}), t.FS = "\t", t.RS = "\n";
          var r = Cc(e, t);
          return "undefined" == typeof cptable ? r : "ÿþ" + cptable.utils.encode(1200, r);
        }
        function Ac(e) {
          var t,
            r = "",
            n = "";
          if (null == e || null == e["!ref"]) return [];
          var i,
            a = xe(e["!ref"]),
            o = "",
            s = [],
            l = [],
            c = Array.isArray(e);
          for (i = a.s.c; i <= a.e.c; ++i) s[i] = de(i);
          for (var u = a.s.r; u <= a.e.r; ++u) for (o = ce(u), i = a.s.c; i <= a.e.c; ++i) if (r = s[i] + o, t = c ? (e[u] || [])[i] : e[r], n = "", void 0 !== t) {
            if (null != t.F) {
              if (r = t.F, !t.f) continue;
              n = t.f, -1 == r.indexOf(":") && (r = r + ":" + r);
            }
            if (null != t.f) n = t.f;else {
              if ("z" == t.t) continue;
              if ("n" == t.t && null != t.v) n = "" + t.v;else if ("b" == t.t) n = t.v ? "TRUE" : "FALSE";else if (void 0 !== t.w) n = "'" + t.w;else {
                if (void 0 === t.v) continue;
                n = "s" == t.t ? "'" + t.v : "" + t.v;
              }
            }
            l[l.length] = r + "=" + n;
          }
          return l;
        }
        function Tc(e, t) {
          for (var r, n = t || {}, i = {}, a = {
              s: {
                c: 0,
                r: 0
              },
              e: {
                c: 0,
                r: e.length
              }
            }, o = n.header || [], s = 0, l = 0; l != e.length; ++l) Object.keys(e[l]).filter(function (t) {
            return e[l].hasOwnProperty(t);
          }).forEach(function (t) {
            -1 == (s = o.indexOf(t)) && (o[s = o.length] = t);
            var a = e[l][t],
              c = "z",
              u = "";
            "number" == typeof a ? c = "n" : "boolean" == typeof a ? c = "b" : "string" == typeof a ? c = "s" : a instanceof Date && (c = "d", n.cellDates || (c = "n", a = b(a)), u = n.dateNF || Nc._table[14]), i[be({
              c: s,
              r: l + 1
            })] = r = {
              t: c,
              v: a
            }, u && (r.z = u);
          });
          for (a.e.c = o.length - 1, s = 0; s < o.length; ++s) i[de(s) + "1"] = {
            t: "s",
            v: o[s]
          };
          return i["!ref"] = we(a), i;
        }
        t.version = "0.10.9";
        var kc = 1200;
        "undefined" == typeof cptable && (n.cptable = r(373));
        var Rc = function Rc(e) {
            kc = e;
          },
          Ic = function Ic(e) {
            var t = e.charCodeAt(0),
              r = e.charCodeAt(1);
            return 255 == t && 254 == r ? l(e.substr(2)) : 254 == t && 255 == r ? c(e.substr(2)) : 65279 == t ? e.substr(1) : e;
          },
          Mc = function Mc(e) {
            return String.fromCharCode(e);
          };
        "undefined" != typeof cptable && (Rc = function Rc(e) {
          kc = e;
        }, Ic = function Ic(e) {
          return 255 === e.charCodeAt(0) && 254 === e.charCodeAt(1) ? cptable.utils.decode(1200, s(e.substr(2))) : e;
        }, Mc = function Mc(e) {
          return 1200 === kc ? String.fromCharCode(e) : cptable.utils.decode(kc, [255 & e, e >> 8])[0];
        });
        var Oc = null,
          Pc = function () {
            var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            return {
              encode: function encode(t) {
                for (var r, n, i, a, o, s, l, c = "", u = 0; u < t.length;) r = t.charCodeAt(u++), n = t.charCodeAt(u++), i = t.charCodeAt(u++), a = r >> 2, o = (3 & r) << 4 | n >> 4, s = (15 & n) << 2 | i >> 6, l = 63 & i, isNaN(n) ? s = l = 64 : isNaN(i) && (l = 64), c += e.charAt(a) + e.charAt(o) + e.charAt(s) + e.charAt(l);
                return c;
              },
              decode: function decode(t) {
                var r,
                  n,
                  i,
                  a,
                  o,
                  s,
                  l,
                  c = "";
                t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                for (var u = 0; u < t.length;) a = e.indexOf(t.charAt(u++)), o = e.indexOf(t.charAt(u++)), s = e.indexOf(t.charAt(u++)), l = e.indexOf(t.charAt(u++)), r = a << 2 | o >> 4, n = (15 & o) << 4 | s >> 2, i = (3 & s) << 6 | l, c += String.fromCharCode(r), 64 != s && (c += String.fromCharCode(n)), 64 != l && (c += String.fromCharCode(i));
                return c;
              }
            };
          }(),
          Bc = void 0 !== i && void 0 !== a && void 0 !== a.versions && a.versions.node,
          Dc = function Dc(e) {
            return [].concat.apply([], e);
          },
          Lc = /\u0000/g,
          Fc = /[\u0001-\u0006]/,
          Nc = {},
          Uc = function Uc(e) {
            function t(e) {
              for (var t = "", r = e.length - 1; r >= 0;) t += e.charAt(r--);
              return t;
            }
            function r(e, t) {
              for (var r = ""; r.length < t;) r += e;
              return r;
            }
            function n(e, t) {
              var n = "" + e;
              return n.length >= t ? n : r("0", t - n.length) + n;
            }
            function i(e, t) {
              var n = "" + e;
              return n.length >= t ? n : r(" ", t - n.length) + n;
            }
            function a(e, t) {
              var n = "" + e;
              return n.length >= t ? n : n + r(" ", t - n.length);
            }
            function o(e, t) {
              var n = "" + Math.round(e);
              return n.length >= t ? n : r("0", t - n.length) + n;
            }
            function s(e, t) {
              var n = "" + e;
              return n.length >= t ? n : r("0", t - n.length) + n;
            }
            function l(e, t) {
              return e > E || e < -E ? o(e, t) : s(Math.round(e), t);
            }
            function c(e, t) {
              return t = t || 0, e.length >= 7 + t && 103 == (32 | e.charCodeAt(t)) && 101 == (32 | e.charCodeAt(t + 1)) && 110 == (32 | e.charCodeAt(t + 2)) && 101 == (32 | e.charCodeAt(t + 3)) && 114 == (32 | e.charCodeAt(t + 4)) && 97 == (32 | e.charCodeAt(t + 5)) && 108 == (32 | e.charCodeAt(t + 6));
            }
            function u(e) {
              e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e[65535] = "General";
            }
            function h(e, t, r) {
              for (var n = e < 0 ? -1 : 1, i = e * n, a = 0, o = 1, s = 0, l = 1, c = 0, u = 0, h = Math.floor(i); c < t && (h = Math.floor(i), s = h * o + a, u = h * c + l, !(i - h < 5e-8));) i = 1 / (i - h), a = o, o = s, l = c, c = u;
              if (u > t && (c > t ? (u = l, s = a) : (u = c, s = o)), !r) return [0, n * s, u];
              var f = Math.floor(n * s / u);
              return [f, n * s - f * u, u];
            }
            function f(e, t, r) {
              if (e > 2958465 || e < 0) return null;
              var n = 0 | e,
                i = Math.floor(86400 * (e - n)),
                a = 0,
                o = [],
                s = {
                  D: n,
                  T: i,
                  u: 86400 * (e - n) - i,
                  y: 0,
                  m: 0,
                  d: 0,
                  H: 0,
                  M: 0,
                  S: 0,
                  q: 0
                };
              if (Math.abs(s.u) < 1e-6 && (s.u = 0), t && t.date1904 && (n += 1462), s.u > .9999 && (s.u = 0, 86400 == ++i && (s.T = i = 0, ++n, ++s.D)), 60 === n) o = r ? [1317, 10, 29] : [1900, 2, 29], a = 3;else if (0 === n) o = r ? [1317, 8, 29] : [1900, 1, 0], a = 6;else {
                n > 60 && --n;
                var l = new Date(1900, 0, 1);
                l.setDate(l.getDate() + n - 1), o = [l.getFullYear(), l.getMonth() + 1, l.getDate()], a = l.getDay(), n < 60 && (a = (a + 6) % 7), r && (a = 0);
              }
              return s.y = o[0], s.m = o[1], s.d = o[2], s.S = i % 60, i = Math.floor(i / 60), s.M = i % 60, i = Math.floor(i / 60), s.H = i, s.q = a, s;
            }
            function d(e, t) {
              var r = e.getTime();
              return t ? r -= 1262304e5 : e >= M && (r += 864e5), (r - (I + 6e4 * (e.getTimezoneOffset() - R.getTimezoneOffset()))) / 864e5;
            }
            function p(e) {
              return e.toString(10);
            }
            function m(e, t) {
              switch (_typeof(e)) {
                case "string":
                  return e;
                case "boolean":
                  return e ? "TRUE" : "FALSE";
                case "number":
                  return (0 | e) === e ? p(e) : O(e);
                case "undefined":
                  return "";
                case "object":
                  if (null == e) return "";
                  if (e instanceof Date) return S(14, d(e, t && t.date1904), t);
              }
              throw new Error("unsupported value in General format: " + e);
            }
            function g(e, t, r, i) {
              var a,
                o = "",
                s = 0,
                l = 0,
                c = r.y,
                u = 0;
              switch (e) {
                case 98:
                  c = r.y + 543;
                case 121:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = c % 100, u = 2;
                      break;
                    default:
                      a = c % 1e4, u = 4;
                  }
                  break;
                case 109:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = r.m, u = t.length;
                      break;
                    case 3:
                      return T[r.m - 1][1];
                    case 5:
                      return T[r.m - 1][0];
                    default:
                      return T[r.m - 1][2];
                  }
                  break;
                case 100:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = r.d, u = t.length;
                      break;
                    case 3:
                      return A[r.q][0];
                    default:
                      return A[r.q][1];
                  }
                  break;
                case 104:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = 1 + (r.H + 11) % 12, u = t.length;
                      break;
                    default:
                      throw "bad hour format: " + t;
                  }
                  break;
                case 72:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = r.H, u = t.length;
                      break;
                    default:
                      throw "bad hour format: " + t;
                  }
                  break;
                case 77:
                  switch (t.length) {
                    case 1:
                    case 2:
                      a = r.M, u = t.length;
                      break;
                    default:
                      throw "bad minute format: " + t;
                  }
                  break;
                case 115:
                  if ("s" != t && "ss" != t && ".0" != t && ".00" != t && ".000" != t) throw "bad second format: " + t;
                  return 0 !== r.u || "s" != t && "ss" != t ? (l = i >= 2 ? 3 === i ? 1e3 : 100 : 1 === i ? 10 : 1, s = Math.round(l * (r.S + r.u)), s >= 60 * l && (s = 0), "s" === t ? 0 === s ? "0" : "" + s / l : (o = n(s, 2 + i), "ss" === t ? o.substr(0, 2) : "." + o.substr(2, t.length - 1))) : n(r.S, t.length);
                case 90:
                  switch (t) {
                    case "[h]":
                    case "[hh]":
                      a = 24 * r.D + r.H;
                      break;
                    case "[m]":
                    case "[mm]":
                      a = 60 * (24 * r.D + r.H) + r.M;
                      break;
                    case "[s]":
                    case "[ss]":
                      a = 60 * (60 * (24 * r.D + r.H) + r.M) + Math.round(r.S + r.u);
                      break;
                    default:
                      throw "bad abstime format: " + t;
                  }
                  u = 3 === t.length ? 1 : 2;
                  break;
                case 101:
                  a = c, u = 1;
              }
              return u > 0 ? n(a, u) : "";
            }
            function v(e) {
              if (e.length <= 3) return e;
              for (var t = e.length % 3, r = e.substr(0, t); t != e.length; t += 3) r += (r.length > 0 ? "," : "") + e.substr(t, 3);
              return r;
            }
            function b(e) {
              for (var t = [], r = !1, n = 0, i = 0; n < e.length; ++n) switch (e.charCodeAt(n)) {
                case 34:
                  r = !r;
                  break;
                case 95:
                case 42:
                case 92:
                  ++n;
                  break;
                case 59:
                  t[t.length] = e.substr(i, n - i), i = n + 1;
              }
              if (t[t.length] = e.substr(i), !0 === r) throw new Error("Format |" + e + "| unterminated string ");
              return t;
            }
            function y(e) {
              for (var t = 0, r = "", n = ""; t < e.length;) switch (r = e.charAt(t)) {
                case "G":
                  c(e, t) && (t += 6), t++;
                  break;
                case '"':
                  for (; 34 !== e.charCodeAt(++t) && t < e.length;) ++t;
                  ++t;
                  break;
                case "\\":
                case "_":
                  t += 2;
                  break;
                case "@":
                  ++t;
                  break;
                case "B":
                case "b":
                  if ("1" === e.charAt(t + 1) || "2" === e.charAt(t + 1)) return !0;
                case "M":
                case "D":
                case "Y":
                case "H":
                case "S":
                case "E":
                case "m":
                case "d":
                case "y":
                case "h":
                case "s":
                case "e":
                case "g":
                  return !0;
                case "A":
                case "a":
                  if ("A/P" === e.substr(t, 3).toUpperCase()) return !0;
                  if ("AM/PM" === e.substr(t, 5).toUpperCase()) return !0;
                  ++t;
                  break;
                case "[":
                  for (n = r; "]" !== e.charAt(t++) && t < e.length;) n += e.charAt(t);
                  if (n.match(B)) return !0;
                  break;
                case ".":
                case "0":
                case "#":
                  for (; t < e.length && ("0#?.,E+-%".indexOf(r = e.charAt(++t)) > -1 || "\\" == r && "-" == e.charAt(t + 1) && "0#".indexOf(e.charAt(t + 2)) > -1););
                  break;
                case "?":
                  for (; e.charAt(++t) === r;);
                  break;
                case "*":
                  ++t, " " != e.charAt(t) && "*" != e.charAt(t) || ++t;
                  break;
                case "(":
                case ")":
                  ++t;
                  break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                  for (; t < e.length && "0123456789".indexOf(e.charAt(++t)) > -1;);
                  break;
                case " ":
                default:
                  ++t;
              }
              return !1;
            }
            function w(e, t, r, n) {
              for (var i, a, o, s = [], l = "", u = 0, h = "", d = "t", p = "H"; u < e.length;) switch (h = e.charAt(u)) {
                case "G":
                  if (!c(e, u)) throw new Error("unrecognized character " + h + " in " + e);
                  s[s.length] = {
                    t: "G",
                    v: "General"
                  }, u += 7;
                  break;
                case '"':
                  for (l = ""; 34 !== (o = e.charCodeAt(++u)) && u < e.length;) l += String.fromCharCode(o);
                  s[s.length] = {
                    t: "t",
                    v: l
                  }, ++u;
                  break;
                case "\\":
                  var v = e.charAt(++u),
                    b = "(" === v || ")" === v ? v : "t";
                  s[s.length] = {
                    t: b,
                    v: v
                  }, ++u;
                  break;
                case "_":
                  s[s.length] = {
                    t: "t",
                    v: " "
                  }, u += 2;
                  break;
                case "@":
                  s[s.length] = {
                    t: "T",
                    v: t
                  }, ++u;
                  break;
                case "B":
                case "b":
                  if ("1" === e.charAt(u + 1) || "2" === e.charAt(u + 1)) {
                    if (null == i && null == (i = f(t, r, "2" === e.charAt(u + 1)))) return "";
                    s[s.length] = {
                      t: "X",
                      v: e.substr(u, 2)
                    }, d = h, u += 2;
                    break;
                  }
                case "M":
                case "D":
                case "Y":
                case "H":
                case "S":
                case "E":
                  h = h.toLowerCase();
                case "m":
                case "d":
                case "y":
                case "h":
                case "s":
                case "e":
                case "g":
                  if (t < 0) return "";
                  if (null == i && null == (i = f(t, r))) return "";
                  for (l = h; ++u < e.length && e.charAt(u).toLowerCase() === h;) l += h;
                  "m" === h && "h" === d.toLowerCase() && (h = "M"), "h" === h && (h = p), s[s.length] = {
                    t: h,
                    v: l
                  }, d = h;
                  break;
                case "A":
                case "a":
                  var w = {
                    t: h,
                    v: h
                  };
                  if (null == i && (i = f(t, r)), "A/P" === e.substr(u, 3).toUpperCase() ? (null != i && (w.v = i.H >= 12 ? "P" : "A"), w.t = "T", p = "h", u += 3) : "AM/PM" === e.substr(u, 5).toUpperCase() ? (null != i && (w.v = i.H >= 12 ? "PM" : "AM"), w.t = "T", u += 5, p = "h") : (w.t = "t", ++u), null == i && "T" === w.t) return "";
                  s[s.length] = w, d = h;
                  break;
                case "[":
                  for (l = h; "]" !== e.charAt(u++) && u < e.length;) l += e.charAt(u);
                  if ("]" !== l.slice(-1)) throw 'unterminated "[" block: |' + l + "|";
                  if (l.match(B)) {
                    if (null == i && null == (i = f(t, r))) return "";
                    s[s.length] = {
                      t: "Z",
                      v: l.toLowerCase()
                    }, d = l.charAt(1);
                  } else l.indexOf("$") > -1 && (l = (l.match(/\$([^-\[\]]*)/) || [])[1] || "$", y(e) || (s[s.length] = {
                    t: "t",
                    v: l
                  }));
                  break;
                case ".":
                  if (null != i) {
                    for (l = h; ++u < e.length && "0" === (h = e.charAt(u));) l += h;
                    s[s.length] = {
                      t: "s",
                      v: l
                    };
                    break;
                  }
                case "0":
                case "#":
                  for (l = h; ++u < e.length && "0#?.,E+-%".indexOf(h = e.charAt(u)) > -1 || "\\" == h && "-" == e.charAt(u + 1) && u < e.length - 2 && "0#".indexOf(e.charAt(u + 2)) > -1;) l += h;
                  s[s.length] = {
                    t: "n",
                    v: l
                  };
                  break;
                case "?":
                  for (l = h; e.charAt(++u) === h;) l += h;
                  s[s.length] = {
                    t: h,
                    v: l
                  }, d = h;
                  break;
                case "*":
                  ++u, " " != e.charAt(u) && "*" != e.charAt(u) || ++u;
                  break;
                case "(":
                case ")":
                  s[s.length] = {
                    t: 1 === n ? "t" : h,
                    v: h
                  }, ++u;
                  break;
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                  for (l = h; u < e.length && "0123456789".indexOf(e.charAt(++u)) > -1;) l += e.charAt(u);
                  s[s.length] = {
                    t: "D",
                    v: l
                  };
                  break;
                case " ":
                  s[s.length] = {
                    t: h,
                    v: h
                  }, ++u;
                  break;
                default:
                  if (-1 === ",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(h)) throw new Error("unrecognized character " + h + " in " + e);
                  s[s.length] = {
                    t: "t",
                    v: h
                  }, ++u;
              }
              var x,
                _ = 0,
                S = 0;
              for (u = s.length - 1, d = "t"; u >= 0; --u) switch (s[u].t) {
                case "h":
                case "H":
                  s[u].t = p, d = "h", _ < 1 && (_ = 1);
                  break;
                case "s":
                  (x = s[u].v.match(/\.0+$/)) && (S = Math.max(S, x[0].length - 1)), _ < 3 && (_ = 3);
                case "d":
                case "y":
                case "M":
                case "e":
                  d = s[u].t;
                  break;
                case "m":
                  "s" === d && (s[u].t = "M", _ < 2 && (_ = 2));
                  break;
                case "X":
                  break;
                case "Z":
                  _ < 1 && s[u].v.match(/[Hh]/) && (_ = 1), _ < 2 && s[u].v.match(/[Mm]/) && (_ = 2), _ < 3 && s[u].v.match(/[Ss]/) && (_ = 3);
              }
              switch (_) {
                case 0:
                  break;
                case 1:
                  i.u >= .5 && (i.u = 0, ++i.S), i.S >= 60 && (i.S = 0, ++i.M), i.M >= 60 && (i.M = 0, ++i.H);
                  break;
                case 2:
                  i.u >= .5 && (i.u = 0, ++i.S), i.S >= 60 && (i.S = 0, ++i.M);
              }
              var C,
                E = "";
              for (u = 0; u < s.length; ++u) switch (s[u].t) {
                case "t":
                case "T":
                case " ":
                case "D":
                  break;
                case "X":
                  s[u].v = "", s[u].t = ";";
                  break;
                case "d":
                case "m":
                case "y":
                case "h":
                case "H":
                case "M":
                case "s":
                case "e":
                case "b":
                case "Z":
                  s[u].v = g(s[u].t.charCodeAt(0), s[u].v, i, S), s[u].t = "t";
                  break;
                case "n":
                case "(":
                case "?":
                  for (C = u + 1; null != s[C] && ("?" === (h = s[C].t) || "D" === h || (" " === h || "t" === h) && null != s[C + 1] && ("?" === s[C + 1].t || "t" === s[C + 1].t && "/" === s[C + 1].v) || "(" === s[u].t && (" " === h || "n" === h || ")" === h) || "t" === h && ("/" === s[C].v || " " === s[C].v && null != s[C + 1] && "?" == s[C + 1].t));) s[u].v += s[C].v, s[C] = {
                    v: "",
                    t: ";"
                  }, ++C;
                  E += s[u].v, u = C - 1;
                  break;
                case "G":
                  s[u].t = "t", s[u].v = m(t, r);
              }
              var A,
                T,
                k = "";
              if (E.length > 0) {
                40 == E.charCodeAt(0) ? (A = t < 0 && 45 === E.charCodeAt(0) ? -t : t, T = P("(", E, A)) : (A = t < 0 && n > 1 ? -t : t, T = P("n", E, A), A < 0 && s[0] && "t" == s[0].t && (T = T.substr(1), s[0].v = "-" + s[0].v)), C = T.length - 1;
                var R = s.length;
                for (u = 0; u < s.length; ++u) if (null != s[u] && "t" != s[u].t && s[u].v.indexOf(".") > -1) {
                  R = u;
                  break;
                }
                var I = s.length;
                if (R === s.length && -1 === T.indexOf("E")) {
                  for (u = s.length - 1; u >= 0; --u) null != s[u] && -1 !== "n?(".indexOf(s[u].t) && (C >= s[u].v.length - 1 ? (C -= s[u].v.length, s[u].v = T.substr(C + 1, s[u].v.length)) : C < 0 ? s[u].v = "" : (s[u].v = T.substr(0, C + 1), C = -1), s[u].t = "t", I = u);
                  C >= 0 && I < s.length && (s[I].v = T.substr(0, C + 1) + s[I].v);
                } else if (R !== s.length && -1 === T.indexOf("E")) {
                  for (C = T.indexOf(".") - 1, u = R; u >= 0; --u) if (null != s[u] && -1 !== "n?(".indexOf(s[u].t)) {
                    for (a = s[u].v.indexOf(".") > -1 && u === R ? s[u].v.indexOf(".") - 1 : s[u].v.length - 1, k = s[u].v.substr(a + 1); a >= 0; --a) C >= 0 && ("0" === s[u].v.charAt(a) || "#" === s[u].v.charAt(a)) && (k = T.charAt(C--) + k);
                    s[u].v = k, s[u].t = "t", I = u;
                  }
                  for (C >= 0 && I < s.length && (s[I].v = T.substr(0, C + 1) + s[I].v), C = T.indexOf(".") + 1, u = R; u < s.length; ++u) if (null != s[u] && (-1 !== "n?(".indexOf(s[u].t) || u === R)) {
                    for (a = s[u].v.indexOf(".") > -1 && u === R ? s[u].v.indexOf(".") + 1 : 0, k = s[u].v.substr(0, a); a < s[u].v.length; ++a) C < T.length && (k += T.charAt(C++));
                    s[u].v = k, s[u].t = "t", I = u;
                  }
                }
              }
              for (u = 0; u < s.length; ++u) null != s[u] && "n(?".indexOf(s[u].t) > -1 && (A = n > 1 && t < 0 && u > 0 && "-" === s[u - 1].v ? -t : t, s[u].v = P(s[u].t, s[u].v, A), s[u].t = "t");
              var M = "";
              for (u = 0; u !== s.length; ++u) null != s[u] && (M += s[u].v);
              return M;
            }
            function x(e, t) {
              if (null == t) return !1;
              var r = parseFloat(t[2]);
              switch (t[1]) {
                case "=":
                  if (e == r) return !0;
                  break;
                case ">":
                  if (e > r) return !0;
                  break;
                case "<":
                  if (e < r) return !0;
                  break;
                case "<>":
                  if (e != r) return !0;
                  break;
                case ">=":
                  if (e >= r) return !0;
                  break;
                case "<=":
                  if (e <= r) return !0;
              }
              return !1;
            }
            function _(e, t) {
              var r = b(e),
                n = r.length,
                i = r[n - 1].indexOf("@");
              if (n < 4 && i > -1 && --n, r.length > 4) throw new Error("cannot find right format for |" + r.join("|") + "|");
              if ("number" != typeof t) return [4, 4 === r.length || i > -1 ? r[r.length - 1] : "@"];
              switch (r.length) {
                case 1:
                  r = i > -1 ? ["General", "General", "General", r[0]] : [r[0], r[0], r[0], "@"];
                  break;
                case 2:
                  r = i > -1 ? [r[0], r[0], r[0], r[1]] : [r[0], r[1], r[0], "@"];
                  break;
                case 3:
                  r = i > -1 ? [r[0], r[1], r[0], r[2]] : [r[0], r[1], r[2], "@"];
              }
              var a = t > 0 ? r[0] : t < 0 ? r[1] : r[2];
              if (-1 === r[0].indexOf("[") && -1 === r[1].indexOf("[")) return [n, a];
              if (null != r[0].match(D) || null != r[1].match(D)) {
                var o = r[0].match(L),
                  s = r[1].match(L);
                return x(t, o) ? [n, r[0]] : x(t, s) ? [n, r[1]] : [n, r[null != o && null != s ? 2 : 1]];
              }
              return [n, a];
            }
            function S(e, t, r) {
              null == r && (r = {});
              var n = "";
              switch (_typeof(e)) {
                case "string":
                  n = "m/d/yy" == e && r.dateNF ? r.dateNF : e;
                  break;
                case "number":
                  n = 14 == e && r.dateNF ? r.dateNF : (null != r.table ? r.table : k)[e];
              }
              if (c(n, 0)) return m(t, r);
              t instanceof Date && (t = d(t, r.date1904));
              var i = _(n, t);
              if (c(i[1])) return m(t, r);
              if (!0 === t) t = "TRUE";else if (!1 === t) t = "FALSE";else if ("" === t || null == t) return "";
              return w(i[1], t, r, i[0]);
            }
            function C(e, t) {
              if ("number" != typeof t) {
                t = +t || -1;
                for (var r = 0; r < 392; ++r) if (void 0 != k[r]) {
                  if (k[r] == e) {
                    t = r;
                    break;
                  }
                } else t < 0 && (t = r);
                t < 0 && (t = 391);
              }
              return k[t] = e, t;
            }
            e.version = "0.10.0";
            var E = Math.pow(2, 32),
              A = [["Sun", "Sunday"], ["Mon", "Monday"], ["Tue", "Tuesday"], ["Wed", "Wednesday"], ["Thu", "Thursday"], ["Fri", "Friday"], ["Sat", "Saturday"]],
              T = [["J", "Jan", "January"], ["F", "Feb", "February"], ["M", "Mar", "March"], ["A", "Apr", "April"], ["M", "May", "May"], ["J", "Jun", "June"], ["J", "Jul", "July"], ["A", "Aug", "August"], ["S", "Sep", "September"], ["O", "Oct", "October"], ["N", "Nov", "November"], ["D", "Dec", "December"]],
              k = {};
            u(k), e.parse_date_code = f;
            var R = new Date(1899, 11, 31, 0, 0, 0),
              I = R.getTime(),
              M = new Date(1900, 2, 1, 0, 0, 0);
            e._general_int = p;
            var O = function () {
              function e(e) {
                var t = e < 0 ? 12 : 11,
                  r = n(e.toFixed(12));
                return r.length <= t ? r : (r = e.toPrecision(10), r.length <= t ? r : e.toExponential(5));
              }
              function t(e) {
                var t = e.toFixed(11).replace(i, ".$1");
                return t.length > (e < 0 ? 12 : 11) && (t = e.toPrecision(6)), t;
              }
              function r(e) {
                for (var t = 0; t != e.length; ++t) if (101 == (32 | e.charCodeAt(t))) return e.replace(o, ".$1").replace(s, "E").replace("e", "E").replace(l, "$10$2");
                return e;
              }
              function n(e) {
                return e.indexOf(".") > -1 ? e.replace(a, "").replace(i, ".$1") : e;
              }
              var i = /\.(\d*[1-9])0+$/,
                a = /\.0*$/,
                o = /\.(\d*[1-9])0+/,
                s = /\.0*[Ee]/,
                l = /(E[+-])(\d)$/;
              return function (i) {
                var a,
                  o = Math.floor(Math.log(Math.abs(i)) * Math.LOG10E);
                return a = o >= -4 && o <= -1 ? i.toPrecision(10 + o) : Math.abs(o) <= 9 ? e(i) : 10 === o ? i.toFixed(10).substr(0, 12) : t(i), n(r(a));
              };
            }();
            e._general_num = O, e._general = m;
            var P = function () {
              function e(e, t, n) {
                var i = t.replace(S, ""),
                  a = t.length - i.length;
                return P(e, i, n * Math.pow(10, 2 * a)) + r("%", a);
              }
              function o(e, t, r) {
                for (var n = t.length - 1; 44 === t.charCodeAt(n - 1);) --n;
                return P(e, t.substr(0, n), r / Math.pow(10, 3 * (t.length - n)));
              }
              function s(e, t) {
                var r,
                  n = e.indexOf("E") - e.indexOf(".") - 1;
                if (e.match(/^#+0.0E\+0$/)) {
                  if (0 == t) return "0.0E+0";
                  if (t < 0) return "-" + s(e, -t);
                  var i = e.indexOf(".");
                  -1 === i && (i = e.indexOf("E"));
                  var a = Math.floor(Math.log(t) * Math.LOG10E) % i;
                  if (a < 0 && (a += i), r = (t / Math.pow(10, a)).toPrecision(n + 1 + (i + a) % i), -1 === r.indexOf("e")) {
                    var o = Math.floor(Math.log(t) * Math.LOG10E);
                    for (-1 === r.indexOf(".") ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (o - r.length + a) : r += "E+" + (o - a); "0." === r.substr(0, 2);) r = r.charAt(0) + r.substr(2, i) + "." + r.substr(2 + i), r = r.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
                    r = r.replace(/\+-/, "-");
                  }
                  r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, t, r, n) {
                    return t + r + n.substr(0, (i + a) % i) + "." + n.substr(a) + "E";
                  });
                } else r = t.toExponential(n);
                return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
              }
              function c(e, t, a) {
                var o = parseInt(e[4], 10),
                  s = Math.round(t * o),
                  l = Math.floor(s / o),
                  c = s - l * o,
                  u = o;
                return a + (0 === l ? "" : "" + l) + " " + (0 === c ? r(" ", e[1].length + 1 + e[4].length) : i(c, e[1].length) + e[2] + "/" + e[3] + n(u, e[4].length));
              }
              function u(e, t, n) {
                return n + (0 === t ? "" : "" + t) + r(" ", e[1].length + 2 + e[4].length);
              }
              function f(e) {
                for (var t, r = "", n = 0; n != e.length; ++n) switch (t = e.charCodeAt(n)) {
                  case 35:
                    break;
                  case 63:
                    r += " ";
                    break;
                  case 48:
                    r += "0";
                    break;
                  default:
                    r += String.fromCharCode(t);
                }
                return r;
              }
              function d(e, t) {
                var r = Math.pow(10, t);
                return "" + Math.round(e * r) / r;
              }
              function p(e, t) {
                return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 0 : Math.round((e - Math.floor(e)) * Math.pow(10, t));
              }
              function m(e, t) {
                return t < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, t))).length ? 1 : 0;
              }
              function g(e) {
                return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? 0 | e : e - 1 | 0) : "" + Math.floor(e);
              }
              function b(u, y, w) {
                if (40 === u.charCodeAt(0) && !y.match(A)) {
                  var x = y.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
                  return w >= 0 ? b("n", x, w) : "(" + b("n", x, -w) + ")";
                }
                if (44 === y.charCodeAt(y.length - 1)) return o(u, y, w);
                if (-1 !== y.indexOf("%")) return e(u, y, w);
                if (-1 !== y.indexOf("E")) return s(y, w);
                if (36 === y.charCodeAt(0)) return "$" + b(u, y.substr(" " == y.charAt(1) ? 2 : 1), w);
                var _,
                  S,
                  k,
                  R,
                  I = Math.abs(w),
                  M = w < 0 ? "-" : "";
                if (y.match(/^00+$/)) return M + l(I, y.length);
                if (y.match(/^[#?]+$/)) return _ = l(w, 0), "0" === _ && (_ = ""), _.length > y.length ? _ : f(y.substr(0, y.length - _.length)) + _;
                if (S = y.match(C)) return c(S, I, M);
                if (y.match(/^#+0+$/)) return M + l(I, y.length - y.indexOf("0"));
                if (S = y.match(E)) return _ = d(w, S[1].length).replace(/^([^\.]+)$/, "$1." + f(S[1])).replace(/\.$/, "." + f(S[1])).replace(/\.(\d*)$/, function (e, t) {
                  return "." + t + r("0", f(S[1]).length - t.length);
                }), -1 !== y.indexOf("0.") ? _ : _.replace(/^0\./, ".");
                if (y = y.replace(/^#+([0.])/, "$1"), S = y.match(/^(0*)\.(#*)$/)) return M + d(I, S[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, S[1].length ? "0." : ".");
                if (S = y.match(/^#{1,3},##0(\.?)$/)) return M + v(l(I, 0));
                if (S = y.match(/^#,##0\.([#0]*0)$/)) return w < 0 ? "-" + b(u, y, -w) : v("" + (Math.floor(w) + m(w, S[1].length))) + "." + n(p(w, S[1].length), S[1].length);
                if (S = y.match(/^#,#*,#0/)) return b(u, y.replace(/^#,#*,/, ""), w);
                if (S = y.match(/^([0#]+)(\\?-([0#]+))+$/)) return _ = t(b(u, y.replace(/[\\-]/g, ""), w)), k = 0, t(t(y.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
                  return k < _.length ? _.charAt(k++) : "0" === e ? "0" : "";
                }));
                if (y.match(T)) return _ = b(u, "##########", w), "(" + _.substr(0, 3) + ") " + _.substr(3, 3) + "-" + _.substr(6);
                var O = "";
                if (S = y.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return k = Math.min(S[4].length, 7), R = h(I, Math.pow(10, k) - 1, !1), _ = "" + M, O = P("n", S[1], R[1]), " " == O.charAt(O.length - 1) && (O = O.substr(0, O.length - 1) + "0"), _ += O + S[2] + "/" + S[3], O = a(R[2], k), O.length < S[4].length && (O = f(S[4].substr(S[4].length - O.length)) + O), _ += O;
                if (S = y.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return k = Math.min(Math.max(S[1].length, S[4].length), 7), R = h(I, Math.pow(10, k) - 1, !0), M + (R[0] || (R[1] ? "" : "0")) + " " + (R[1] ? i(R[1], k) + S[2] + "/" + S[3] + a(R[2], k) : r(" ", 2 * k + 1 + S[2].length + S[3].length));
                if (S = y.match(/^[#0?]+$/)) return _ = l(w, 0), y.length <= _.length ? _ : f(y.substr(0, y.length - _.length)) + _;
                if (S = y.match(/^([#0?]+)\.([#0]+)$/)) {
                  _ = "" + w.toFixed(Math.min(S[2].length, 10)).replace(/([^0])0+$/, "$1"), k = _.indexOf(".");
                  var B = y.indexOf(".") - k,
                    D = y.length - _.length - B;
                  return f(y.substr(0, B) + _ + y.substr(y.length - D));
                }
                if (S = y.match(/^00,000\.([#0]*0)$/)) return k = p(w, S[1].length), w < 0 ? "-" + b(u, y, -w) : v(g(w)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? n(0, 3 - e.length) : "") + e;
                }) + "." + n(k, S[1].length);
                switch (y) {
                  case "###,##0.00":
                    return b(u, "#,##0.00", w);
                  case "###,###":
                  case "##,###":
                  case "#,###":
                    var L = v(l(I, 0));
                    return "0" !== L ? M + L : "";
                  case "###,###.00":
                    return b(u, "###,##0.00", w).replace(/^0\./, ".");
                  case "#,###.00":
                    return b(u, "#,##0.00", w).replace(/^0\./, ".");
                }
                throw new Error("unsupported format |" + y + "|");
              }
              function y(e, t, r) {
                for (var n = t.length - 1; 44 === t.charCodeAt(n - 1);) --n;
                return P(e, t.substr(0, n), r / Math.pow(10, 3 * (t.length - n)));
              }
              function w(e, t, n) {
                var i = t.replace(S, ""),
                  a = t.length - i.length;
                return P(e, i, n * Math.pow(10, 2 * a)) + r("%", a);
              }
              function x(e, t) {
                var r,
                  n = e.indexOf("E") - e.indexOf(".") - 1;
                if (e.match(/^#+0.0E\+0$/)) {
                  if (0 == t) return "0.0E+0";
                  if (t < 0) return "-" + x(e, -t);
                  var i = e.indexOf(".");
                  -1 === i && (i = e.indexOf("E"));
                  var a = Math.floor(Math.log(t) * Math.LOG10E) % i;
                  if (a < 0 && (a += i), r = (t / Math.pow(10, a)).toPrecision(n + 1 + (i + a) % i), !r.match(/[Ee]/)) {
                    var o = Math.floor(Math.log(t) * Math.LOG10E);
                    -1 === r.indexOf(".") ? r = r.charAt(0) + "." + r.substr(1) + "E+" + (o - r.length + a) : r += "E+" + (o - a), r = r.replace(/\+-/, "-");
                  }
                  r = r.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function (e, t, r, n) {
                    return t + r + n.substr(0, (i + a) % i) + "." + n.substr(a) + "E";
                  });
                } else r = t.toExponential(n);
                return e.match(/E\+00$/) && r.match(/e[+-]\d$/) && (r = r.substr(0, r.length - 1) + "0" + r.charAt(r.length - 1)), e.match(/E\-/) && r.match(/e\+/) && (r = r.replace(/e\+/, "e")), r.replace("e", "E");
              }
              function _(e, o, s) {
                if (40 === e.charCodeAt(0) && !o.match(A)) {
                  var l = o.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
                  return s >= 0 ? _("n", l, s) : "(" + _("n", l, -s) + ")";
                }
                if (44 === o.charCodeAt(o.length - 1)) return y(e, o, s);
                if (-1 !== o.indexOf("%")) return w(e, o, s);
                if (-1 !== o.indexOf("E")) return x(o, s);
                if (36 === o.charCodeAt(0)) return "$" + _(e, o.substr(" " == o.charAt(1) ? 2 : 1), s);
                var c,
                  d,
                  p,
                  m,
                  g = Math.abs(s),
                  b = s < 0 ? "-" : "";
                if (o.match(/^00+$/)) return b + n(g, o.length);
                if (o.match(/^[#?]+$/)) return c = "" + s, 0 === s && (c = ""), c.length > o.length ? c : f(o.substr(0, o.length - c.length)) + c;
                if (d = o.match(C)) return u(d, g, b);
                if (o.match(/^#+0+$/)) return b + n(g, o.length - o.indexOf("0"));
                if (d = o.match(E)) return c = ("" + s).replace(/^([^\.]+)$/, "$1." + f(d[1])).replace(/\.$/, "." + f(d[1])), c = c.replace(/\.(\d*)$/, function (e, t) {
                  return "." + t + r("0", f(d[1]).length - t.length);
                }), -1 !== o.indexOf("0.") ? c : c.replace(/^0\./, ".");
                if (o = o.replace(/^#+([0.])/, "$1"), d = o.match(/^(0*)\.(#*)$/)) return b + ("" + g).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, d[1].length ? "0." : ".");
                if (d = o.match(/^#{1,3},##0(\.?)$/)) return b + v("" + g);
                if (d = o.match(/^#,##0\.([#0]*0)$/)) return s < 0 ? "-" + _(e, o, -s) : v("" + s) + "." + r("0", d[1].length);
                if (d = o.match(/^#,#*,#0/)) return _(e, o.replace(/^#,#*,/, ""), s);
                if (d = o.match(/^([0#]+)(\\?-([0#]+))+$/)) return c = t(_(e, o.replace(/[\\-]/g, ""), s)), p = 0, t(t(o.replace(/\\/g, "")).replace(/[0#]/g, function (e) {
                  return p < c.length ? c.charAt(p++) : "0" === e ? "0" : "";
                }));
                if (o.match(T)) return c = _(e, "##########", s), "(" + c.substr(0, 3) + ") " + c.substr(3, 3) + "-" + c.substr(6);
                var S = "";
                if (d = o.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) return p = Math.min(d[4].length, 7), m = h(g, Math.pow(10, p) - 1, !1), c = "" + b, S = P("n", d[1], m[1]), " " == S.charAt(S.length - 1) && (S = S.substr(0, S.length - 1) + "0"), c += S + d[2] + "/" + d[3], S = a(m[2], p), S.length < d[4].length && (S = f(d[4].substr(d[4].length - S.length)) + S), c += S;
                if (d = o.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) return p = Math.min(Math.max(d[1].length, d[4].length), 7), m = h(g, Math.pow(10, p) - 1, !0), b + (m[0] || (m[1] ? "" : "0")) + " " + (m[1] ? i(m[1], p) + d[2] + "/" + d[3] + a(m[2], p) : r(" ", 2 * p + 1 + d[2].length + d[3].length));
                if (d = o.match(/^[#0?]+$/)) return c = "" + s, o.length <= c.length ? c : f(o.substr(0, o.length - c.length)) + c;
                if (d = o.match(/^([#0]+)\.([#0]+)$/)) {
                  c = "" + s.toFixed(Math.min(d[2].length, 10)).replace(/([^0])0+$/, "$1"), p = c.indexOf(".");
                  var k = o.indexOf(".") - p,
                    R = o.length - c.length - k;
                  return f(o.substr(0, k) + c + o.substr(o.length - R));
                }
                if (d = o.match(/^00,000\.([#0]*0)$/)) return s < 0 ? "-" + _(e, o, -s) : v("" + s).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function (e) {
                  return "00," + (e.length < 3 ? n(0, 3 - e.length) : "") + e;
                }) + "." + n(0, d[1].length);
                switch (o) {
                  case "###,###":
                  case "##,###":
                  case "#,###":
                    var I = v("" + g);
                    return "0" !== I ? b + I : "";
                  default:
                    if (o.match(/\.[0#?]*$/)) return _(e, o.slice(0, o.lastIndexOf(".")), s) + f(o.slice(o.lastIndexOf(".")));
                }
                throw new Error("unsupported format |" + o + "|");
              }
              var S = /%/g,
                C = /# (\?+)( ?)\/( ?)(\d+)/,
                E = /^#*0*\.([0#]+)/,
                A = /\).*[0#]/,
                T = /\(###\) ###\\?-####/;
              return function (e, t, r) {
                return (0 | r) === r ? _(e, t, r) : b(e, t, r);
              };
            }();
            e._split = b;
            var B = /\[[HhMmSs]*\]/;
            e.is_date = y, e._eval = w;
            var D = /\[[=<>]/,
              L = /\[([=<>]*)(-?\d+\.?\d*)\]/;
            e.load = C, e._table = k, e.get_table = function () {
              return k;
            }, e.load_table = function (e) {
              for (var t = 0; 392 != t; ++t) void 0 !== e[t] && C(e[t], t);
            }, e.init_table = u, e.format = S;
          };
        Uc(Nc);
        var jc = {
            "General Number": "General",
            "General Date": Nc._table[22],
            "Long Date": "dddd, mmmm dd, yyyy",
            "Medium Date": Nc._table[15],
            "Short Date": Nc._table[14],
            "Long Time": Nc._table[19],
            "Medium Time": Nc._table[18],
            "Short Time": Nc._table[20],
            Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
            Fixed: Nc._table[2],
            Standard: Nc._table[4],
            Percent: Nc._table[10],
            Scientific: Nc._table[11],
            "Yes/No": '"Yes";"Yes";"No";@',
            "True/False": '"True";"True";"False";@',
            "On/Off": '"Yes";"Yes";"No";@'
          },
          zc = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g,
          Hc = function () {
            function e(e, r) {
              var l = 3,
                h = 512,
                f = 0,
                d = 0,
                p = 0,
                m = 0,
                g = 0,
                v = [],
                y = e.slice(0, 512);
              switch (Q(y, 0), l = t(y)[0]) {
                case 3:
                  h = 512;
                  break;
                case 4:
                  h = 4096;
                  break;
                default:
                  throw new Error("Major Version: Expected 3 or 4 saw " + l);
              }
              512 !== h && (y = e.slice(0, h), Q(y, 28));
              var w = e.slice(0, h);
              n(y, l);
              var x = y.read_shift(4, "i");
              if (3 === l && 0 !== x) throw new Error("# Directory Sectors: Expected 0 saw " + x);
              y.l += 4, p = y.read_shift(4, "i"), y.l += 4, y.chk("00100000", "Mini Stream Cutoff Size: "), m = y.read_shift(4, "i"), f = y.read_shift(4, "i"), g = y.read_shift(4, "i"), d = y.read_shift(4, "i");
              for (var _ = -1, S = 0; S < 109 && !((_ = y.read_shift(4, "i")) < 0); ++S) v[S] = _;
              var C = i(e, h);
              s(g, d, C, h, v);
              var E = c(C, p, v, h);
              E[p].name = "!Directory", f > 0 && m !== b && (E[m].name = "!MiniFAT"), E[v[0]].name = "!FAT", E.fat_addrs = v, E.ssz = h;
              var A = {},
                T = [],
                k = [],
                R = [],
                I = {};
              return u(p, E, C, T, f, A, k), a(k, I, R, T), {
                raw: {
                  header: w,
                  sectors: C
                },
                FileIndex: k,
                FullPaths: R,
                FullPathDir: I,
                find: o(R, T, k, A, T.shift())
              };
            }
            function t(e) {
              e.chk(y, "Header Signature: "), e.chk(w, "CLSID: ");
              var t = e.read_shift(2, "u");
              return [e.read_shift(2, "u"), t];
            }
            function n(e, t) {
              var r = 9;
              switch (e.l += 2, r = e.read_shift(2)) {
                case 9:
                  if (3 != t) throw new Error("Sector Shift: Expected 9 saw " + r);
                  break;
                case 12:
                  if (4 != t) throw new Error("Sector Shift: Expected 12 saw " + r);
                  break;
                default:
                  throw new Error("Sector Shift: Expected 9 or 12 saw " + r);
              }
              e.chk("0600", "Mini Sector Shift: "), e.chk("000000000000", "Reserved: ");
            }
            function i(e, t) {
              for (var r = Math.ceil(e.length / t) - 1, n = [], i = 1; i < r; ++i) n[i - 1] = e.slice(i * t, (i + 1) * t);
              return n[r - 1] = e.slice(r * t), n;
            }
            function a(e, t, r, n) {
              for (var i = 0, a = 0, o = 0, s = 0, l = 0, c = n.length, u = [], h = []; i < c; ++i) u[i] = h[i] = i, r[i] = n[i];
              for (; l < h.length; ++l) i = h[l], a = e[i].L, o = e[i].R, s = e[i].C, u[i] === i && (-1 !== a && u[a] !== a && (u[i] = u[a]), -1 !== o && u[o] !== o && (u[i] = u[o])), -1 !== s && (u[s] = i), -1 !== a && (u[a] = u[i], h.push(a)), -1 !== o && (u[o] = u[i], h.push(o));
              for (i = 1; i !== c; ++i) u[i] === i && (-1 !== o && u[o] !== o ? u[i] = u[o] : -1 !== a && u[a] !== a && (u[i] = u[a]));
              for (i = 1; i < c; ++i) if (0 !== e[i].type) {
                if (0 === (l = u[i])) r[i] = r[0] + "/" + r[i];else for (; 0 !== l;) r[i] = r[l] + "/" + r[i], l = u[l];
                u[i] = 0;
              }
              for (r[0] += "/", i = 1; i < c; ++i) 2 !== e[i].type && (r[i] += "/"), t[r[i]] = e[i];
            }
            function o(e, t, r, n, i) {
              var a = [],
                o = [],
                s = 0;
              for (s = 0; s < e.length; ++s) a[s] = e[s].toUpperCase().replace(Lc, "").replace(Fc, "!");
              for (s = 0; s < t.length; ++s) o[s] = t[s].toUpperCase().replace(Lc, "").replace(Fc, "!");
              return function (e) {
                var s = !1;
                47 === e.charCodeAt(0) ? (s = !0, e = i + e) : s = -1 !== e.indexOf("/");
                var l = e.toUpperCase().replace(Lc, "").replace(Fc, "!"),
                  c = !0 === s ? a.indexOf(l) : o.indexOf(l);
                return -1 === c ? null : !0 === s ? r[c] : n[t[c]];
              };
            }
            function s(e, t, r, n, i) {
              var a = b;
              if (e === b) {
                if (0 !== t) throw new Error("DIFAT chain shorter than expected");
              } else if (-1 !== e) {
                var o = r[e],
                  l = (n >>> 2) - 1;
                if (!o) return;
                for (var c = 0; c < l && (a = zu(o, 4 * c)) !== b; ++c) i.push(a);
                s(zu(o, n - 4), t - 1, r, n, i);
              }
            }
            function l(e, t, r, n, i) {
              var a = (e.length, []),
                o = [];
              i || (i = []);
              var s = n - 1,
                l = 0,
                c = 0;
              for (l = t; l >= 0;) {
                i[l] = !0, a[a.length] = l, o.push(e[l]);
                var u = r[Math.floor(4 * l / n)];
                if (c = 4 * l & s, n < 4 + c) throw new Error("FAT boundary crossed: " + l + " 4 " + n);
                if (!e[u]) break;
                l = zu(e[u], c);
              }
              return {
                nodes: a,
                data: bu([o])
              };
            }
            function c(e, t, r, n) {
              var i = e.length,
                a = [],
                o = [],
                s = [],
                l = [],
                c = n - 1,
                u = 0,
                h = 0,
                f = 0,
                d = 0;
              for (u = 0; u < i; ++u) if (s = [], f = u + t, f >= i && (f -= i), !o[f]) {
                for (l = [], h = f; h >= 0;) {
                  o[h] = !0, s[s.length] = h, l.push(e[h]);
                  var p = r[Math.floor(4 * h / n)];
                  if (d = 4 * h & c, n < 4 + d) throw new Error("FAT boundary crossed: " + h + " 4 " + n);
                  if (!e[p]) break;
                  h = zu(e[p], d);
                }
                a[f] = {
                  nodes: s,
                  data: bu([l])
                };
              }
              return a;
            }
            function u(e, t, r, n, i, a, o) {
              for (var s, c = 0, u = n.length ? 2 : 0, h = t[e].data, d = 0, p = 0; d < h.length; d += 128) {
                var m = h.slice(d, d + 128);
                if (Q(m, 64), 0 !== (p = m.read_shift(2))) {
                  s = xu(m, 0, p - u), n.push(s);
                  var g = {
                    name: s,
                    type: m.read_shift(1),
                    color: m.read_shift(1),
                    L: m.read_shift(4, "i"),
                    R: m.read_shift(4, "i"),
                    C: m.read_shift(4, "i"),
                    clsid: m.read_shift(16),
                    state: m.read_shift(4, "i"),
                    start: 0,
                    size: 0
                  };
                  0 !== m.read_shift(2) + m.read_shift(2) + m.read_shift(2) + m.read_shift(2) && (g.ct = f(m, m.l - 8));
                  0 !== m.read_shift(2) + m.read_shift(2) + m.read_shift(2) + m.read_shift(2) && (g.mt = f(m, m.l - 8)), g.start = m.read_shift(4, "i"), g.size = m.read_shift(4, "i"), 5 === g.type ? (c = g.start, i > 0 && c !== b && (t[c].name = "!StreamData")) : g.size >= 4096 ? (g.storage = "fat", void 0 === t[g.start] && (t[g.start] = l(r, g.start, t.fat_addrs, t.ssz)), t[g.start].name = g.name, g.content = t[g.start].data.slice(0, g.size), Q(g.content, 0)) : (g.storage = "minifat", c !== b && g.start !== b && (g.content = t[c].data.slice(g.start * v, g.start * v + g.size), Q(g.content, 0))), a[s] = g, o.push(g);
                }
              }
            }
            function f(e, t) {
              return new Date(1e3 * (ju(e, t + 4) / 1e7 * Math.pow(2, 32) + ju(e, t) / 1e7 - 11644473600));
            }
            function d(t, n) {
              return null == g && (g = r(150)), e(g.readFileSync(t), n);
            }
            function p(t, r) {
              switch (r && r.type || "base64") {
                case "file":
                  return d(t, r);
                case "base64":
                  return e(h(Pc.decode(t)), r);
                case "binary":
                  return e(h(t), r);
              }
              return e(t, r);
            }
            var m = {};
            m.version = "0.12.0";
            var g,
              v = 64,
              b = -2,
              y = "d0cf11e0a1b11ae1",
              w = "00000000000000000000000000000000",
              x = {
                MAXREGSECT: -6,
                DIFSECT: -4,
                FATSECT: -3,
                ENDOFCHAIN: b,
                FREESECT: -1,
                HEADER_SIGNATURE: y,
                HEADER_MINOR_VERSION: "3e00",
                MAXREGSID: -6,
                NOSTREAM: -1,
                HEADER_CLSID: w,
                EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
              };
            return m.read = p, m.parse = e, m.utils = {
              ReadShift: K,
              CheckField: J,
              prep_blob: Q,
              bconcat: Dc,
              consts: x
            }, m;
          }(),
          Gc = new Date(1899, 11, 30, 0, 0, 0),
          Vc = Gc.getTime() + 6e4 * (new Date().getTimezoneOffset() - Gc.getTimezoneOffset()),
          qc = new Date("2017-02-19T19:06:09.000Z");
        isNaN(qc.getFullYear()) && (qc = new Date("2/19/17"));
        var Wc,
          Xc,
          Yc = 2017 == qc.getFullYear();
        "undefined" != typeof JSZip && (Xc = JSZip), void 0 !== e && e.exports && (void 0 === Xc && (Xc = r(374)), Wc = r(150));
        var Kc = /([^"\s?>\/]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g,
          Zc = /<[^>]*>/g,
          Jc = /<\w*:/,
          Qc = /<(\/?)\w+:/,
          $c = {
            "&quot;": '"',
            "&apos;": "'",
            "&gt;": ">",
            "&lt;": "<",
            "&amp;": "&"
          },
          eu = g($c),
          tu = function () {
            var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/g,
              t = /_x([\da-fA-F]{4})_/g;
            return function (r) {
              return (r + "").replace(e, function (e, t) {
                return $c[e] || String.fromCharCode(parseInt(t, e.indexOf("x") > -1 ? 16 : 10)) || e;
              }).replace(t, function (e, t) {
                return String.fromCharCode(parseInt(t, 16));
              });
            };
          }(),
          ru = /[&<>'"]/g,
          nu = /[\u0000-\u0008\u000b-\u001f]/g,
          iu = /[\u0000-\u001f]/g,
          au = function () {
            function e(e, t) {
              return String.fromCharCode(parseInt(t, 10));
            }
            var t = /&#(\d+);/g;
            return function (r) {
              return r.replace(t, e);
            };
          }(),
          ou = function () {
            return function (e) {
              return e.replace(/(\r\n|[\r\n])/g, "&#10;");
            };
          }(),
          su = function su(e) {
            for (var t = "", r = 0, n = 0, i = 0, a = 0, o = 0, s = 0; r < e.length;) n = e.charCodeAt(r++), n < 128 ? t += String.fromCharCode(n) : (i = e.charCodeAt(r++), n > 191 && n < 224 ? (o = (31 & n) << 6, o |= 63 & i, t += String.fromCharCode(o)) : (a = e.charCodeAt(r++), n < 240 ? t += String.fromCharCode((15 & n) << 12 | (63 & i) << 6 | 63 & a) : (o = e.charCodeAt(r++), s = ((7 & n) << 18 | (63 & i) << 12 | (63 & a) << 6 | 63 & o) - 65536, t += String.fromCharCode(55296 + (s >>> 10 & 1023)), t += String.fromCharCode(56320 + (1023 & s)))));
            return t;
          };
        if (Bc) {
          var lu = function lu(e) {
              var t,
                r,
                n,
                a = new i(2 * e.length),
                o = 1,
                s = 0,
                l = 0;
              for (r = 0; r < e.length; r += o) o = 1, (n = e.charCodeAt(r)) < 128 ? t = n : n < 224 ? (t = 64 * (31 & n) + (63 & e.charCodeAt(r + 1)), o = 2) : n < 240 ? (t = 4096 * (15 & n) + 64 * (63 & e.charCodeAt(r + 1)) + (63 & e.charCodeAt(r + 2)), o = 3) : (o = 4, t = 262144 * (7 & n) + 4096 * (63 & e.charCodeAt(r + 1)) + 64 * (63 & e.charCodeAt(r + 2)) + (63 & e.charCodeAt(r + 3)), t -= 65536, l = 55296 + (t >>> 10 & 1023), t = 56320 + (1023 & t)), 0 !== l && (a[s++] = 255 & l, a[s++] = l >>> 8, l = 0), a[s++] = t % 256, a[s++] = t >>> 8;
              return a.slice(0, s).toString("ucs2");
            },
            cu = "foo bar bazâð£";
          su(cu) == lu(cu) && (su = lu);
          var uu = function uu(e) {
            return i(e, "binary").toString("utf8");
          };
          su(cu) == uu(cu) && (su = uu);
        }
        var hu = function () {
            var e = {};
            return function (t, r) {
              var n = t + "|" + (r || "");
              return e[n] ? e[n] : e[n] = new RegExp("<(?:\\w+:)?" + t + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + t + ">", r || "");
            };
          }(),
          fu = function () {
            var e = {};
            return function (t) {
              return void 0 !== e[t] ? e[t] : e[t] = new RegExp("<(?:vt:)?" + t + ">([\\s\\S]*?)</(?:vt:)?" + t + ">", "g");
            };
          }(),
          du = /<\/?(?:vt:)?variant>/g,
          pu = /<(?:vt:)([^>]*)>([\s\S]*)</,
          mu = /(^\s|\s$|\n)/,
          gu = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n',
          vu = {
            dc: "http://purl.org/dc/elements/1.1/",
            dcterms: "http://purl.org/dc/terms/",
            dcmitype: "http://purl.org/dc/dcmitype/",
            mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
            sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
            vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
            xsi: "http://www.w3.org/2001/XMLSchema-instance",
            xsd: "http://www.w3.org/2001/XMLSchema"
          };
        vu.main = ["http://schemas.openxmlformats.org/spreadsheetml/2006/main", "http://purl.oclc.org/ooxml/spreadsheetml/main", "http://schemas.microsoft.com/office/excel/2006/main", "http://schemas.microsoft.com/office/excel/2006/2"];
        var bu,
          yu,
          wu = {
            o: "urn:schemas-microsoft-com:office:office",
            x: "urn:schemas-microsoft-com:office:excel",
            ss: "urn:schemas-microsoft-com:office:spreadsheet",
            dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
            mv: "http://macVmlSchemaUri",
            v: "urn:schemas-microsoft-com:vml",
            html: "http://www.w3.org/TR/REC-html40"
          };
        bu = yu = function yu(e) {
          for (var t = [], r = 0; r < e[0].length; ++r) t.push.apply(t, e[0][r]);
          return t;
        };
        var xu, _u;
        xu = _u = function _u(e, t, r) {
          for (var n = [], i = t; i < r; i += 2) n.push(String.fromCharCode(Nu(e, i)));
          return n.join("");
        };
        var Su, Cu;
        Su = Cu = function Cu(e, t, r) {
          return e.slice(t, t + r).map(function (e) {
            return (e < 16 ? "0" : "") + e.toString(16);
          }).join("");
        };
        var Eu;
        Eu = function Eu(e, t, r) {
          for (var n = [], i = t; i < r; i++) n.push(String.fromCharCode(Fu(e, i)));
          return n.join("");
        };
        var Au, Tu;
        Au = Tu = function Tu(e, t) {
          var r = ju(e, t);
          return r > 0 ? Eu(e, t + 4, t + 4 + r - 1) : "";
        };
        var ku, Ru;
        ku = Ru = function Ru(e, t) {
          var r = 2 * ju(e, t);
          return r > 0 ? Eu(e, t + 4, t + 4 + r - 1) : "";
        };
        var Iu, Mu;
        Iu = Mu = function Mu(e, t) {
          var r = ju(e, t);
          return r > 0 ? xu(e, t + 4, t + 4 + r) : "";
        };
        var Ou, Pu;
        Ou = Pu = function Pu(e, t) {
          var r = ju(e, t);
          return r > 0 ? Eu(e, t + 4, t + 4 + r) : "";
        };
        var Bu, Du;
        Bu = Du = function Du(e, t) {
          return X(e, t);
        };
        var Lu = function Lu(e) {
          return Array.isArray(e);
        };
        Bc && (xu = function xu(e, t, r) {
          return i.isBuffer(e) ? e.toString("utf16le", t, r) : _u(e, t, r);
        }, Su = function Su(e, t, r) {
          return i.isBuffer(e) ? e.toString("hex", t, t + r) : Cu(e, t, r);
        }, Au = function Au(e, t) {
          if (!i.isBuffer(e)) return Tu(e, t);
          var r = e.readUInt32LE(t);
          return r > 0 ? e.toString("utf8", t + 4, t + 4 + r - 1) : "";
        }, ku = function ku(e, t) {
          if (!i.isBuffer(e)) return Ru(e, t);
          var r = 2 * e.readUInt32LE(t);
          return e.toString("utf16le", t + 4, t + 4 + r - 1);
        }, Iu = function Iu(e, t) {
          if (!i.isBuffer(e)) return Mu(e, t);
          var r = e.readUInt32LE(t);
          return e.toString("utf16le", t + 4, t + 4 + r);
        }, Ou = function Ou(e, t) {
          if (!i.isBuffer(e)) return Pu(e, t);
          var r = e.readUInt32LE(t);
          return e.toString("utf8", t + 4, t + 4 + r);
        }, Eu = function Eu(e, t, r) {
          return e.toString("utf8", t, r);
        }, bu = function bu(e) {
          return e[0].length > 0 && i.isBuffer(e[0][0]) ? i.concat(e[0]) : yu(e);
        }, Dc = function Dc(e) {
          return i.isBuffer(e[0]) ? i.concat(e) : [].concat.apply([], e);
        }, Bu = function Bu(e, t) {
          return i.isBuffer(e) ? e.readDoubleLE(t) : Du(e, t);
        }, Lu = function Lu(e) {
          return i.isBuffer(e) || Array.isArray(e);
        }), "undefined" != typeof cptable && (xu = function xu(e, t, r) {
          return cptable.utils.decode(1200, e.slice(t, r));
        }, Eu = function Eu(e, t, r) {
          return cptable.utils.decode(65001, e.slice(t, r));
        }, Au = function Au(e, t) {
          var r = ju(e, t);
          return r > 0 ? cptable.utils.decode(kc, e.slice(t + 4, t + 4 + r - 1)) : "";
        }, ku = function ku(e, t) {
          var r = 2 * ju(e, t);
          return r > 0 ? cptable.utils.decode(1200, e.slice(t + 4, t + 4 + r - 1)) : "";
        }, Iu = function Iu(e, t) {
          var r = ju(e, t);
          return r > 0 ? cptable.utils.decode(1200, e.slice(t + 4, t + 4 + r)) : "";
        }, Ou = function Ou(e, t) {
          var r = ju(e, t);
          return r > 0 ? cptable.utils.decode(65001, e.slice(t + 4, t + 4 + r)) : "";
        });
        var Fu = function Fu(e, t) {
            return e[t];
          },
          Nu = function Nu(e, t) {
            return 256 * e[t + 1] + e[t];
          },
          Uu = function Uu(e, t) {
            var r = 256 * e[t + 1] + e[t];
            return r < 32768 ? r : -1 * (65535 - r + 1);
          },
          ju = function ju(e, t) {
            return e[t + 3] * (1 << 24) + (e[t + 2] << 16) + (e[t + 1] << 8) + e[t];
          },
          zu = function zu(e, t) {
            return e[t + 3] << 24 | e[t + 2] << 16 | e[t + 1] << 8 | e[t];
          },
          Hu = function Hu(e, t, r) {
            e[r] = 255 & t, e[r + 1] = t >>> 8 & 255;
          },
          Gu = function Gu(e, t, r) {
            e[r] = 255 & t, e[r + 1] = t >>> 8 & 255, e[r + 2] = t >>> 16 & 255, e[r + 3] = t >>> 24 & 255;
          },
          Vu = function Vu(e, t, r) {
            e[r] = 255 & t, e[r + 1] = t >> 8 & 255, e[r + 2] = t >> 16 & 255, e[r + 3] = t >> 24 & 255;
          },
          qu = {};
        !function (e, t) {
          var n;
          if (void 0 !== t) n = t;else try {
            n = r(388);
          } catch (e) {
            n = null;
          }
          e.rc4 = function (e, t) {
            var r = new Array(256),
              n = 0,
              a = 0,
              o = 0,
              s = 0;
            for (a = 0; 256 != a; ++a) r[a] = a;
            for (a = 0; 256 != a; ++a) o = o + r[a] + e[a % e.length].charCodeAt(0) & 255, s = r[a], r[a] = r[o], r[o] = s;
            a = o = 0;
            var l = i(t.length);
            for (n = 0; n != t.length; ++n) a = a + 1 & 255, o = (o + r[a]) % 256, s = r[a], r[a] = r[o], r[o] = s, l[n] = t[n] ^ r[r[a] + r[o] & 255];
            return l;
          }, e.md5 = function (e) {
            if (!n) throw new Error("Unsupported crypto");
            return n.createHash("md5").update(e).digest("hex");
          };
        }(qu, "undefined" != typeof crypto ? crypto : void 0);
        var Wu = Me,
          Xu = Te,
          Yu = ke,
          Ku = Te,
          Zu = Le,
          Ju = Fe,
          Qu = je,
          $u = ze,
          eh = {
            0: "#NULL!",
            7: "#DIV/0!",
            15: "#VALUE!",
            23: "#REF!",
            29: "#NAME?",
            36: "#NUM!",
            42: "#N/A",
            43: "#GETTING_DATA",
            255: "#WTF?"
          },
          th = v(eh),
          rh = 2,
          nh = 3,
          ih = 12,
          ah = 81,
          oh = [80, ah],
          sh = {
            1: {
              n: "CodePage",
              t: rh
            },
            2: {
              n: "Category",
              t: 80
            },
            3: {
              n: "PresentationFormat",
              t: 80
            },
            4: {
              n: "ByteCount",
              t: nh
            },
            5: {
              n: "LineCount",
              t: nh
            },
            6: {
              n: "ParagraphCount",
              t: nh
            },
            7: {
              n: "SlideCount",
              t: nh
            },
            8: {
              n: "NoteCount",
              t: nh
            },
            9: {
              n: "HiddenCount",
              t: nh
            },
            10: {
              n: "MultimediaClipCount",
              t: nh
            },
            11: {
              n: "Scale",
              t: 11
            },
            12: {
              n: "HeadingPair",
              t: 4096 | ih
            },
            13: {
              n: "DocParts",
              t: 4126
            },
            14: {
              n: "Manager",
              t: 80
            },
            15: {
              n: "Company",
              t: 80
            },
            16: {
              n: "LinksDirty",
              t: 11
            },
            17: {
              n: "CharacterCount",
              t: nh
            },
            19: {
              n: "SharedDoc",
              t: 11
            },
            22: {
              n: "HLinksChanged",
              t: 11
            },
            23: {
              n: "AppVersion",
              t: nh,
              p: "version"
            },
            26: {
              n: "ContentType",
              t: 80
            },
            27: {
              n: "ContentStatus",
              t: 80
            },
            28: {
              n: "Language",
              t: 80
            },
            29: {
              n: "Version",
              t: 80
            },
            255: {}
          },
          lh = {
            1: {
              n: "CodePage",
              t: rh
            },
            2: {
              n: "Title",
              t: 80
            },
            3: {
              n: "Subject",
              t: 80
            },
            4: {
              n: "Author",
              t: 80
            },
            5: {
              n: "Keywords",
              t: 80
            },
            6: {
              n: "Comments",
              t: 80
            },
            7: {
              n: "Template",
              t: 80
            },
            8: {
              n: "LastAuthor",
              t: 80
            },
            9: {
              n: "RevNumber",
              t: 80
            },
            10: {
              n: "EditTime",
              t: 64
            },
            11: {
              n: "LastPrinted",
              t: 64
            },
            12: {
              n: "CreatedDate",
              t: 64
            },
            13: {
              n: "ModifiedDate",
              t: 64
            },
            14: {
              n: "PageCount",
              t: nh
            },
            15: {
              n: "WordCount",
              t: nh
            },
            16: {
              n: "CharCount",
              t: nh
            },
            17: {
              n: "Thumbnail",
              t: 71
            },
            18: {
              n: "ApplicationName",
              t: 30
            },
            19: {
              n: "DocumentSecurity",
              t: nh
            },
            255: {}
          },
          ch = {
            2147483648: {
              n: "Locale",
              t: 19
            },
            2147483651: {
              n: "Behavior",
              t: 19
            },
            1919054434: {}
          };
        !function () {
          for (var e in ch) ch.hasOwnProperty(e) && (sh[e] = lh[e] = ch[e]);
        }();
        var uh = {
            1: "US",
            2: "CA",
            3: "",
            7: "RU",
            20: "EG",
            30: "GR",
            31: "NL",
            32: "BE",
            33: "FR",
            34: "ES",
            36: "HU",
            39: "IT",
            41: "CH",
            43: "AT",
            44: "GB",
            45: "DK",
            46: "SE",
            47: "NO",
            48: "PL",
            49: "DE",
            52: "MX",
            55: "BR",
            61: "AU",
            64: "NZ",
            66: "TH",
            81: "JP",
            82: "KR",
            84: "VN",
            86: "CN",
            90: "TR",
            105: "JS",
            213: "DZ",
            216: "MA",
            218: "LY",
            351: "PT",
            354: "IS",
            358: "FI",
            420: "CZ",
            886: "TW",
            961: "LB",
            962: "JO",
            963: "SY",
            964: "IQ",
            965: "KW",
            966: "SA",
            971: "AE",
            972: "IL",
            974: "QA",
            981: "IR",
            65535: "US"
          },
          hh = [null, "solid", "mediumGray", "darkGray", "lightGray", "darkHorizontal", "darkVertical", "darkDown", "darkUp", "darkGrid", "darkTrellis", "lightHorizontal", "lightVertical", "lightDown", "lightUp", "lightGrid", "lightTrellis", "gray125", "gray0625"],
          fh = function (e) {
            return e.map(function (e) {
              return [e >> 16 & 255, e >> 8 & 255, 255 & e];
            });
          }([0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 0, 16777215, 16711680, 65280, 255, 16776960, 16711935, 65535, 8388608, 32768, 128, 8421376, 8388736, 32896, 12632256, 8421504, 10066431, 10040166, 16777164, 13434879, 6684774, 16744576, 26316, 13421823, 128, 16711935, 16776960, 65535, 8388736, 8388608, 32896, 255, 52479, 13434879, 13434828, 16777113, 10079487, 16751052, 13408767, 16764057, 3368703, 3394764, 10079232, 16763904, 16750848, 16737792, 6710937, 9868950, 13158, 3381606, 13056, 3355392, 10040064, 10040166, 3355545, 3355443, 16777215, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]),
          dh = {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
            "application/vnd.ms-excel.binIndexWs": "TODO",
            "application/vnd.ms-excel.intlmacrosheet": "TODO",
            "application/vnd.ms-excel.binIndexMs": "TODO",
            "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
            "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
            "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
            "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
            "application/vnd.ms-excel.pivotTable": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
            "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
            "application/vnd.ms-office.chartstyle+xml": "TODO",
            "application/vnd.ms-excel.calcChain": "calcchains",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
            "application/vnd.ms-office.activeX": "TODO",
            "application/vnd.ms-office.activeX+xml": "TODO",
            "application/vnd.ms-excel.attachedToolbars": "TODO",
            "application/vnd.ms-excel.connections": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
            "application/vnd.ms-excel.externalLink": "links",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
            "application/vnd.ms-excel.sheetMetadata": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
            "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
            "application/vnd.ms-excel.pivotCacheRecords": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
            "application/vnd.ms-excel.queryTable": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
            "application/vnd.ms-excel.userNames": "TODO",
            "application/vnd.ms-excel.revisionHeaders": "TODO",
            "application/vnd.ms-excel.revisionLog": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
            "application/vnd.ms-excel.tableSingleCells": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
            "application/vnd.ms-excel.slicer": "TODO",
            "application/vnd.ms-excel.slicerCache": "TODO",
            "application/vnd.ms-excel.slicer+xml": "TODO",
            "application/vnd.ms-excel.slicerCache+xml": "TODO",
            "application/vnd.ms-excel.wsSortMap": "TODO",
            "application/vnd.ms-excel.table": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
            "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
            "application/vnd.ms-excel.Timeline+xml": "TODO",
            "application/vnd.ms-excel.TimelineCache+xml": "TODO",
            "application/vnd.ms-office.vbaProject": "vba",
            "application/vnd.ms-office.vbaProjectSignature": "vba",
            "application/vnd.ms-office.volatileDependencies": "TODO",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
            "application/vnd.ms-excel.controlproperties+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.model+data": "TODO",
            "application/vnd.ms-excel.Survey+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
            "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
            "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
            "application/vnd.openxmlformats-package.relationships+xml": "rels",
            "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
            "image/png": "TODO",
            sheet: "js"
          },
          ph = function () {
            var e = {
              workbooks: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
                xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
                xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
                xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
              },
              strs: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
                xlsb: "application/vnd.ms-excel.sharedStrings"
              },
              comments: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
                xlsb: "application/vnd.ms-excel.comments"
              },
              sheets: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
                xlsb: "application/vnd.ms-excel.worksheet"
              },
              charts: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
                xlsb: "application/vnd.ms-excel.chartsheet"
              },
              dialogs: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
                xlsb: "application/vnd.ms-excel.dialogsheet"
              },
              macros: {
                xlsx: "application/vnd.ms-excel.macrosheet+xml",
                xlsb: "application/vnd.ms-excel.macrosheet"
              },
              styles: {
                xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
                xlsb: "application/vnd.ms-excel.styles"
              }
            };
            return m(e).forEach(function (t) {
              e[t].xlsm || (e[t].xlsm = e[t].xlsx);
            }), m(e).forEach(function (t) {
              m(e[t]).forEach(function (r) {
                dh[e[t][r]] = t;
              });
            }), e;
          }(),
          mh = function (e) {
            for (var t = [], r = m(e), n = 0; n !== r.length; ++n) null == t[e[r[n]]] && (t[e[r[n]]] = []), t[e[r[n]]].push(r[n]);
            return t;
          }(dh);
        vu.CT = "http://schemas.openxmlformats.org/package/2006/content-types";
        var gh = V("Types", null, {
            xmlns: vu.CT,
            "xmlns:xsd": vu.xsd,
            "xmlns:xsi": vu.xsi
          }),
          vh = [["xml", "application/xml"], ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"], ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"], ["bmp", "image/bmp"], ["png", "image/png"], ["gif", "image/gif"], ["emf", "image/x-emf"], ["wmf", "image/x-wmf"], ["jpg", "image/jpeg"], ["jpeg", "image/jpeg"], ["tif", "image/tiff"], ["tiff", "image/tiff"], ["pdf", "application/pdf"], ["rels", mh.rels[0]]].map(function (e) {
            return V("Default", null, {
              Extension: e[0],
              ContentType: e[1]
            });
          }),
          bh = {
            WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
            HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
            VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
            VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
          };
        vu.RELS = "http://schemas.openxmlformats.org/package/2006/relationships";
        var yh = V("Relationships", null, {
            xmlns: vu.RELS
          }),
          wh = "application/vnd.oasis.opendocument.spreadsheet",
          xh = function () {
            var e = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + t.version + "</meta:generator></office:meta></office:document-meta>";
            return function (t, r) {
              return e;
            };
          }(),
          _h = [["cp:category", "Category"], ["cp:contentStatus", "ContentStatus"], ["cp:keywords", "Keywords"], ["cp:lastModifiedBy", "LastAuthor"], ["cp:lastPrinted", "LastPrinted"], ["cp:revision", "RevNumber"], ["cp:version", "Version"], ["dc:creator", "Author"], ["dc:description", "Comments"], ["dc:identifier", "Identifier"], ["dc:language", "Language"], ["dc:subject", "Subject"], ["dc:title", "Title"], ["dcterms:created", "CreatedDate", "date"], ["dcterms:modified", "ModifiedDate", "date"]];
        vu.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties", bh.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties";
        var Sh = function () {
            for (var e = new Array(_h.length), t = 0; t < _h.length; ++t) {
              var r = _h[t],
                n = "(?:" + r[0].substr(0, r[0].indexOf(":")) + ":)" + r[0].substr(r[0].indexOf(":") + 1);
              e[t] = new RegExp("<" + n + "[^>]*>([\\s\\S]*?)</" + n + ">");
            }
            return e;
          }(),
          Ch = V("cp:coreProperties", null, {
            "xmlns:cp": vu.CORE_PROPS,
            "xmlns:dc": vu.dc,
            "xmlns:dcterms": vu.dcterms,
            "xmlns:dcmitype": vu.dcmitype,
            "xmlns:xsi": vu.xsi
          }),
          Eh = [["Application", "Application", "string"], ["AppVersion", "AppVersion", "string"], ["Company", "Company", "string"], ["DocSecurity", "DocSecurity", "string"], ["Manager", "Manager", "string"], ["HyperlinksChanged", "HyperlinksChanged", "bool"], ["SharedDoc", "SharedDoc", "bool"], ["LinksUpToDate", "LinksUpToDate", "bool"], ["ScaleCrop", "ScaleCrop", "bool"], ["HeadingPairs", "HeadingPairs", "raw"], ["TitlesOfParts", "TitlesOfParts", "raw"]];
        vu.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties", bh.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties";
        var Ah = V("Properties", null, {
          xmlns: vu.EXT_PROPS,
          "xmlns:vt": vu.vt
        });
        vu.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties", bh.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties";
        var Th = /<[^>]+>[^<]*/g,
          kh = V("Properties", null, {
            xmlns: vu.CUST_PROPS,
            "xmlns:vt": vu.vt
          }),
          Rh = {
            Title: "Title",
            Subject: "Subject",
            Author: "Author",
            Keywords: "Keywords",
            Comments: "Description",
            LastAuthor: "LastAuthor",
            RevNumber: "Revision",
            Application: "AppName",
            LastPrinted: "LastPrinted",
            CreatedDate: "Created",
            ModifiedDate: "LastSaved",
            Category: "Category",
            Manager: "Manager",
            Company: "Company",
            AppVersion: "Version",
            ContentStatus: "ContentStatus",
            Identifier: "Identifier",
            Language: "Language"
          },
          Ih = g(Rh),
          Mh = function Mh(e) {
            var t = e.read_shift(4),
              r = e.l,
              n = !1;
            t > 24 && (e.l += t - 24, "795881f43b1d7f48af2c825dc4852763" === e.read_shift(16) && (n = !0), e.l = r);
            var i = e.read_shift((n ? t - 24 : t) >> 1, "utf16le").replace(Lc, "");
            return n && (e.l += 24), i;
          },
          Oh = function Oh(e, t) {
            var r = (e.read_shift(2), e.read_shift(4)),
              n = e.read_shift(r, "cstr");
            e.read_shift(2), e.read_shift(2);
            if (0 === e.read_shift(4)) return n.replace(/\\/g, "/");
            var i = e.read_shift(4);
            e.read_shift(2);
            return e.read_shift(i >> 1, "utf16le").replace(Lc, "");
          },
          Ph = function Ph(e, t) {
            var r = e.read_shift(16);
            switch (t -= 16, r) {
              case "e0c9ea79f9bace118c8200aa004ba90b":
                return Mh(e);
              case "0303000000000000c000000000000046":
                return Oh(e);
              default:
                throw new Error("Unsupported Moniker " + r);
            }
          },
          Bh = function Bh(e, t) {
            var r = e.read_shift(4);
            return e.read_shift(r, "utf16le").replace(Lc, "");
          },
          Dh = function Dh(e, t) {
            var r = e.l + t,
              n = e.read_shift(4);
            if (2 !== n) throw new Error("Unrecognized streamVersion: " + n);
            var i = e.read_shift(2);
            e.l += 2;
            var a, o, s, l;
            16 & i && Bh(e, e.l), 128 & i && (a = Bh(e, e.l)), 257 == (257 & i) && (o = Bh(e, e.l)), 1 == (257 & i) && (s = Ph(e, r - e.l)), 8 & i && (l = Bh(e, e.l)), 32 & i && e.read_shift(16), 64 & i && gt(e), e.l = r;
            var c = a || o || s;
            return l && (c += "#" + l), {
              Target: c
            };
          },
          Lh = Lt,
          Fh = er,
          Nh = {
            0: ir,
            4: ir,
            5: ir,
            6: ir,
            7: nr,
            8: ir,
            9: ir,
            10: ir,
            11: ir,
            12: ir,
            13: rr,
            14: ir,
            15: ir,
            16: ir,
            17: ir,
            18: ir,
            19: ir,
            20: ir,
            21: tr
          },
          Uh = Lt,
          jh = Pt,
          zh = Gt,
          Hh = Kt,
          Gh = ["_xlnm.Consolidate_Area", "_xlnm.Auto_Open", "_xlnm.Auto_Close", "_xlnm.Extract", "_xlnm.Database", "_xlnm.Criteria", "_xlnm.Print_Area", "_xlnm.Print_Titles", "_xlnm.Recorder", "_xlnm.Data_Form", "_xlnm.Auto_Activate", "_xlnm.Auto_Deactivate", "_xlnm.Sheet_Title", "_xlnm._FilterDatabase"],
          Vh = Lt,
          qh = [];
        qh[8] = function (e, t, r) {
          var n = e.l + t;
          e.l += 10;
          var i = e.read_shift(2);
          e.l += 4;
          e.read_shift(2);
          e.l += 2;
          e.read_shift(2);
          e.l += 4;
          var a = e.read_shift(1);
          return e.l += a, e.l = n, {
            fmt: i
          };
        };
        var Wh = function Wh(e, t) {
            var r = $t(e, 8);
            return e.l += 16, [r, Dh(e, t - 24)];
          },
          Xh = function Xh(e, t) {
            e.l;
            e.read_shift(2);
            var r = $t(e, 8),
              n = e.read_shift((t - 10) / 2, "dbcs-cont");
            return n = n.replace(Lc, ""), [r, n];
          },
          Yh = $,
          Kh = $,
          Zh = $,
          Jh = Dt,
          Qh = Xt,
          $h = He,
          ef = Lt,
          tf = Lt,
          rf = He,
          nf = Dt,
          af = Lt,
          of = Dt,
          sf = Pt,
          lf = Dt,
          cf = Lt,
          uf = Dt,
          hf = Dt,
          ff = Lt,
          df = Pt,
          pf = Pt,
          mf = Pt,
          gf = Pt,
          vf = Pt,
          bf = Lt,
          yf = Hh,
          wf = Lt,
          xf = Dt,
          _f = Hh,
          Sf = Lh,
          Cf = Pt,
          Ef = He,
          Af = Pt,
          Tf = Dt,
          kf = Lt,
          Rf = Dt,
          If = Dt,
          Mf = Lt,
          Of = Dt,
          Pf = Lt,
          Bf = Dt,
          Df = Dt,
          Lf = He,
          Ff = Ft,
          Nf = Dt,
          Uf = Ft,
          jf = Ht,
          zf = Dt,
          Hf = He,
          Gf = Dt,
          Vf = Dt,
          qf = Dt,
          Wf = $,
          Xf = $,
          Yf = $,
          Kf = $,
          Zf = $,
          Jf = $,
          Qf = $,
          $f = $,
          ed = $,
          td = $,
          rd = $,
          nd = $,
          id = $,
          ad = $,
          od = $,
          sd = $,
          ld = $,
          cd = $,
          ud = $,
          hd = $,
          fd = $,
          dd = $,
          pd = $,
          md = $,
          gd = $,
          vd = $,
          bd = $,
          yd = $,
          wd = $,
          xd = $,
          _d = $,
          Sd = $,
          Cd = $,
          Ed = $,
          Ad = $,
          Td = $,
          kd = $,
          Rd = $,
          Id = $,
          Md = $,
          Od = $,
          Pd = $,
          Bd = $,
          Dd = $,
          Ld = $,
          Fd = $,
          Nd = $,
          Ud = $,
          jd = $,
          zd = $,
          Hd = $,
          Gd = $,
          Vd = $,
          qd = $,
          Wd = $,
          Xd = $,
          Yd = $,
          Kd = $,
          Zd = $,
          Jd = $,
          Qd = $,
          $d = $,
          ep = $,
          tp = $,
          rp = $,
          np = $,
          ip = $,
          ap = $,
          op = $,
          sp = $,
          lp = $,
          cp = $,
          up = $,
          hp = $,
          fp = $,
          dp = $,
          pp = $,
          mp = $,
          gp = $,
          vp = $,
          bp = $,
          yp = $,
          wp = $,
          xp = $,
          _p = $,
          Sp = $,
          Cp = $,
          Ep = $,
          Ap = $,
          Tp = $,
          kp = $,
          Rp = $,
          Ip = $,
          Mp = $,
          Op = $,
          Pp = $,
          Bp = $,
          Dp = $,
          Lp = $,
          Fp = $,
          Np = $,
          Up = $,
          jp = $,
          zp = $,
          Hp = $,
          Gp = $,
          Vp = $,
          qp = $,
          Wp = $,
          Xp = $,
          Yp = Ht,
          Kp = $,
          Zp = $,
          Jp = $,
          Qp = $,
          $p = $,
          em = $,
          tm = $,
          rm = $,
          nm = $,
          im = $,
          am = $,
          om = $,
          sm = $,
          lm = $,
          cm = $,
          um = $,
          hm = $,
          fm = $,
          dm = $,
          pm = $,
          mm = $,
          gm = $,
          vm = $,
          bm = $,
          ym = $,
          wm = $,
          xm = $,
          _m = $,
          Sm = $,
          Cm = $,
          Em = $,
          Am = $,
          Tm = $,
          km = $,
          Rm = $,
          Im = $,
          Mm = $,
          Om = $,
          Pm = $,
          Bm = $,
          Dm = $,
          Lm = $,
          Fm = $,
          Nm = $,
          Um = $,
          jm = $,
          zm = $,
          Hm = $,
          Gm = $,
          Vm = $,
          qm = $,
          Wm = $,
          Xm = $,
          Ym = $,
          Km = $,
          Zm = $,
          Jm = $,
          Qm = $,
          $m = $,
          eg = $,
          tg = $,
          rg = $,
          ng = $,
          ig = $,
          ag = $,
          og = $,
          sg = $,
          lg = $,
          cg = $,
          ug = $,
          hg = $,
          fg = $,
          dg = $,
          pg = $,
          mg = $,
          gg = $,
          vg = $,
          bg = $,
          yg = $,
          wg = $,
          xg = $,
          _g = $,
          Sg = $,
          Cg = $,
          Eg = $,
          Ag = $,
          Tg = $,
          kg = $,
          Rg = $,
          Ig = $,
          Mg = $,
          Og = $,
          Pg = $,
          Bg = $,
          Dg = $,
          Lg = $,
          Fg = $,
          Ng = $,
          Ug = $,
          jg = $,
          zg = $,
          Hg = $,
          Gg = $,
          Vg = $,
          qg = $,
          Wg = $,
          Xg = $,
          Yg = $,
          Kg = $,
          Zg = $,
          Jg = $,
          Qg = $,
          $g = $,
          ev = $,
          tv = $,
          rv = $,
          nv = $,
          iv = $,
          av = $,
          ov = $,
          sv = $,
          lv = $,
          cv = $,
          uv = $,
          hv = $,
          fv = $,
          dv = $,
          pv = $,
          mv = $,
          gv = $,
          vv = $,
          bv = $,
          yv = $,
          wv = $,
          xv = $,
          _v = $,
          Sv = $,
          Cv = $,
          Ev = $,
          Av = $,
          Tv = $,
          kv = $,
          Rv = function () {
            function e(e, t) {
              var r = [],
                i = u(1);
              switch (t.type) {
                case "base64":
                  i = h(Pc.decode(e));
                  break;
                case "binary":
                  i = h(e);
                  break;
                case "buffer":
                case "array":
                  i = e;
              }
              Q(i, 0);
              var a = i.read_shift(1),
                o = !1,
                s = !1;
              switch (a) {
                case 2:
                case 3:
                  break;
                case 48:
                  s = !0, o = !0;
                  break;
                case 49:
                  s = !0;
                  break;
                case 131:
                case 139:
                case 245:
                  o = !0;
                  break;
                default:
                  throw new Error("DBF Unsupported Version: " + a.toString(16));
              }
              var l = (new Date(), 0),
                c = 0;
              2 == a && (l = i.read_shift(2)), new Date(i.read_shift(1) + 1900, i.read_shift(1) - 1, i.read_shift(1)), 2 != a && (l = i.read_shift(4)), 2 != a && (c = i.read_shift(2));
              var f = i.read_shift(2),
                d = 1252;
              2 != a && (i.l += 16, i.read_shift(1), 0 !== i[i.l] && (d = n[i[i.l]]), i.l += 1, i.l += 2);
              for (var p = [], m = {}, g = c - 10 - (s ? 264 : 0); 2 == a ? i.l < i.length && 13 != i[i.l] : i.l < g;) switch (m = {}, m.name = cptable.utils.decode(d, i.slice(i.l, i.l + 10)).replace(/[\u0000\r\n].*$/g, ""), i.l += 11, m.type = String.fromCharCode(i.read_shift(1)), 2 != a && (m.offset = i.read_shift(4)), m.len = i.read_shift(1), 2 == a && (m.offset = i.read_shift(2)), m.dec = i.read_shift(1), m.name.length && p.push(m), 2 != a && (i.l += 14), m.type) {
                case "C":
                case "D":
                case "F":
                case "I":
                case "L":
                case "M":
                case "N":
                case "T":
                case "Y":
                case "0":
                case "+":
                case "@":
                  break;
                default:
                  throw new Error("Unknown Field Type: " + m.type);
              }
              if (13 !== i[i.l] ? i.l = c - 1 : 2 == a && (i.l = 521), 2 != a) {
                if (13 !== i.read_shift(1)) throw new Error("DBF Terminator not found " + i.l + " " + i[i.l]);
                i.l = c;
              }
              var v = 0,
                b = 0;
              for (r[0] = [], b = 0; b != p.length; ++b) r[0][b] = p[b].name;
              for (; l-- > 0;) if (42 !== i[i.l]) for (++i.l, r[++v] = [], b = 0, b = 0; b != p.length; ++b) {
                var y = i.slice(i.l, i.l + p[b].len);
                i.l += p[b].len, Q(y, 0);
                var w = cptable.utils.decode(d, y);
                switch (p[b].type) {
                  case "C":
                    r[v][b] = cptable.utils.decode(d, y), r[v][b] = r[v][b].trim();
                    break;
                  case "D":
                    8 === w.length ? r[v][b] = new Date(+w.substr(0, 4), +w.substr(4, 2) - 1, +w.substr(6, 2)) : r[v][b] = w;
                    break;
                  case "F":
                    r[v][b] = parseFloat(w.trim());
                    break;
                  case "I":
                    r[v][b] = y.read_shift(4, "i");
                    break;
                  case "L":
                    switch (w.toUpperCase()) {
                      case "Y":
                      case "T":
                        r[v][b] = !0;
                        break;
                      case "N":
                      case "F":
                        r[v][b] = !1;
                        break;
                      case " ":
                      case "?":
                        r[v][b] = !1;
                        break;
                      default:
                        throw new Error("DBF Unrecognized L:|" + w + "|");
                    }
                    break;
                  case "M":
                    if (!o) throw new Error("DBF Unexpected MEMO for type " + a.toString(16));
                    r[v][b] = "##MEMO##" + y.read_shift(4);
                    break;
                  case "N":
                    r[v][b] = +w.replace(/\u0000/g, "").trim();
                    break;
                  case "T":
                    var x = y.read_shift(4),
                      _ = y.read_shift(4);
                    throw new Error(x + " | " + _);
                  case "Y":
                    r[v][b] = y.read(4, "i") / 1e4;
                    break;
                  case "0":
                    if ("_NullFlags" === p[b].name) break;
                  default:
                    throw new Error("DBF Unsupported data type " + p[b].type);
                }
              } else i.l += f;
              if (2 != a && i.l < i.length && 26 != i[i.l++]) throw new Error("DBF EOF Marker missing " + (i.l - 1) + " of " + i.length + " " + i[i.l - 1].toString(16));
              return r;
            }
            function t(t, r) {
              var n = r || {};
              return n.dateNF || (n.dateNF = "yyyymmdd"), Ee(e(t, n), n);
            }
            function r(e, r) {
              try {
                return Ce(t(e, r), r);
              } catch (e) {
                if (r && r.WTF) throw e;
              }
              return {
                SheetNames: [],
                Sheets: {}
              };
            }
            var n = {
              1: 437,
              2: 850,
              3: 1252,
              4: 1e4,
              100: 852,
              101: 866,
              102: 865,
              103: 861,
              104: 895,
              105: 620,
              106: 737,
              107: 857,
              120: 950,
              121: 949,
              122: 936,
              123: 932,
              124: 874,
              125: 1255,
              126: 1256,
              150: 10007,
              151: 10029,
              152: 10006,
              200: 1250,
              201: 1251,
              202: 1254,
              203: 1253,
              0: 20127,
              8: 865,
              9: 437,
              10: 850,
              11: 437,
              13: 437,
              14: 850,
              15: 437,
              16: 850,
              17: 437,
              18: 850,
              19: 932,
              20: 850,
              21: 437,
              22: 850,
              23: 865,
              24: 437,
              25: 437,
              26: 850,
              27: 437,
              28: 863,
              29: 850,
              31: 852,
              34: 852,
              35: 852,
              36: 860,
              37: 850,
              38: 866,
              55: 850,
              64: 852,
              77: 936,
              78: 949,
              79: 950,
              80: 874,
              87: 1252,
              88: 1252,
              89: 1252,
              255: 16969
            };
            return {
              to_workbook: r,
              to_sheet: t
            };
          }(),
          Iv = function () {
            function e(e, r) {
              switch (r.type) {
                case "base64":
                  return t(Pc.decode(e), r);
                case "binary":
                  return t(e, r);
                case "buffer":
                  return t(e.toString("binary"), r);
                case "array":
                  return t(_(e), r);
              }
              throw new Error("Unrecognized type " + r.type);
            }
            function t(e, t) {
              for (var r, n = e.split(/[\n\r]+/), i = -1, a = -1, o = 0, s = 0, l = [], c = [], u = null, h = {}, f = [], d = [], p = [], m = 0; o !== n.length; ++o) {
                m = 0;
                var g,
                  v = n[o].trim(),
                  b = v.replace(/;;/g, "").split(";").map(function (e) {
                    return e.replace(/\u0001/g, ";");
                  }),
                  w = b[0];
                if (v.length > 0) switch (w) {
                  case "ID":
                  case "E":
                  case "B":
                  case "O":
                    break;
                  case "P":
                    "P" == b[1].charAt(0) && c.push(v.substr(3).replace(/;;/g, ";"));
                    break;
                  case "C":
                    for (s = 1; s < b.length; ++s) switch (b[s].charAt(0)) {
                      case "X":
                        a = parseInt(b[s].substr(1)) - 1;
                        break;
                      case "Y":
                        for (i = parseInt(b[s].substr(1)) - 1, a = 0, r = l.length; r <= i; ++r) l[r] = [];
                        break;
                      case "K":
                        g = b[s].substr(1), '"' === g.charAt(0) ? g = g.substr(1, g.length - 2) : "TRUE" === g ? g = !0 : "FALSE" === g ? g = !1 : +g == +g ? (g = +g, null !== u && Nc.is_date(u) && (g = y(g))) : isNaN(A(g).getDate()) || (g = x(g)), l[i][a] = g, u = null;
                        break;
                      case "E":
                        var _ = fb(b[s].substr(1), {
                          r: i,
                          c: a
                        });
                        l[i][a] = [l[i][a], _];
                        break;
                      default:
                        if (t && t.WTF) throw new Error("SYLK bad record " + v);
                    }
                    break;
                  case "F":
                    var S = 0;
                    for (s = 1; s < b.length; ++s) switch (b[s].charAt(0)) {
                      case "X":
                        a = parseInt(b[s].substr(1)) - 1, ++S;
                        break;
                      case "Y":
                        for (i = parseInt(b[s].substr(1)) - 1, r = l.length; r <= i; ++r) l[r] = [];
                        break;
                      case "M":
                        m = parseInt(b[s].substr(1)) / 20;
                        break;
                      case "F":
                        break;
                      case "P":
                        u = c[parseInt(b[s].substr(1))];
                        break;
                      case "S":
                      case "D":
                      case "N":
                        break;
                      case "W":
                        for (p = b[s].substr(1).split(" "), r = parseInt(p[0], 10); r <= parseInt(p[1], 10); ++r) m = parseInt(p[2], 10), d[r - 1] = 0 == m ? {
                          hidden: !0
                        } : {
                          wch: m
                        }, Vn(d[r - 1]);
                        break;
                      case "C":
                        a = parseInt(b[s].substr(1)) - 1, d[a] || (d[a] = {});
                        break;
                      case "R":
                        i = parseInt(b[s].substr(1)) - 1, f[i] || (f[i] = {}), m > 0 ? (f[i].hpt = m, f[i].hpx = Wn(m)) : 0 == m && (f[i].hidden = !0);
                        break;
                      default:
                        if (t && t.WTF) throw new Error("SYLK bad record " + v);
                    }
                    S < 1 && (u = null);
                    break;
                  default:
                    if (t && t.WTF) throw new Error("SYLK bad record " + v);
                }
              }
              return f.length > 0 && (h["!rows"] = f), d.length > 0 && (h["!cols"] = d), [l, h];
            }
            function r(t, r) {
              var n = e(t, r),
                i = n[0],
                a = n[1],
                o = Ee(i, r);
              return m(a).forEach(function (e) {
                o[e] = a[e];
              }), o;
            }
            function n(e, t) {
              return Ce(r(e, t), t);
            }
            function i(e, t, r, n, i) {
              var a = "C;Y" + (r + 1) + ";X" + (n + 1) + ";K";
              switch (e.t) {
                case "n":
                  a += e.v || 0, e.f && !e.F && (a += ";E" + pb(e.f, {
                    r: r,
                    c: n
                  }));
                  break;
                case "b":
                  a += e.v ? "TRUE" : "FALSE";
                  break;
                case "e":
                  a += e.w || e.v;
                  break;
                case "d":
                  a += '"' + (e.w || e.v) + '"';
                  break;
                case "s":
                  a += '"' + e.v.replace(/"/g, "") + '"';
              }
              return a;
            }
            function a(e, t) {
              t.forEach(function (t, r) {
                var n = "F;W" + (r + 1) + " " + (r + 1) + " ";
                t.hidden ? n += "0" : ("number" == typeof t.width && (t.wpx = Un(t.width)), "number" == typeof t.wpx && (t.wch = jn(t.wpx)), "number" == typeof t.wch && (n += Math.round(t.wch))), " " != n.charAt(n.length - 1) && e.push(n);
              });
            }
            function o(e, t) {
              t.forEach(function (t, r) {
                var n = "F;";
                t.hidden ? n += "M0;" : t.hpt ? n += "M" + 20 * t.hpt + ";" : t.hpx && (n += "M" + 20 * qn(t.hpx) + ";"), n.length > 2 && e.push(n + "R" + (r + 1));
              });
            }
            function s(e, t) {
              var r,
                n = ["ID;PWXL;N;E"],
                s = [],
                l = ye(e["!ref"]),
                c = Array.isArray(e),
                u = "\r\n";
              n.push("P;PGeneral"), n.push("F;P0;DG0G8;M255"), e["!cols"] && a(n, e["!cols"]), e["!rows"] && o(n, e["!rows"]), n.push("B;Y" + (l.e.r - l.s.r + 1) + ";X" + (l.e.c - l.s.c + 1) + ";D" + [l.s.c, l.s.r, l.e.c, l.e.r].join(" "));
              for (var h = l.s.r; h <= l.e.r; ++h) for (var f = l.s.c; f <= l.e.c; ++f) {
                var d = be({
                  r: h,
                  c: f
                });
                r = c ? (e[h] || [])[f] : e[d], r && (null != r.v || r.f && !r.F) && s.push(i(r, e, h, f, t));
              }
              return n.join(u) + u + s.join(u) + u + "E" + u;
            }
            return {
              to_workbook: n,
              to_sheet: r,
              from_sheet: s
            };
          }(),
          Mv = function () {
            function e(e, r) {
              switch (r.type) {
                case "base64":
                  return t(Pc.decode(e), r);
                case "binary":
                  return t(e, r);
                case "buffer":
                  return t(e.toString("binary"), r);
                case "array":
                  return t(_(e), r);
              }
              throw new Error("Unrecognized type " + r.type);
            }
            function t(e, t) {
              for (var r = e.split("\n"), n = -1, i = -1, a = 0, o = []; a !== r.length; ++a) if ("BOT" !== r[a].trim()) {
                if (!(n < 0)) {
                  var s = r[a].trim().split(","),
                    l = s[0],
                    c = s[1];
                  ++a;
                  var u = r[a].trim();
                  switch (+l) {
                    case -1:
                      if ("BOT" === u) {
                        o[++n] = [], i = 0;
                        continue;
                      }
                      if ("EOD" !== u) throw new Error("Unrecognized DIF special command " + u);
                      break;
                    case 0:
                      "TRUE" === u ? o[n][i] = !0 : "FALSE" === u ? o[n][i] = !1 : +c == +c ? o[n][i] = +c : isNaN(A(c).getDate()) ? o[n][i] = c : o[n][i] = x(c), ++i;
                      break;
                    case 1:
                      u = u.substr(1, u.length - 2), o[n][i++] = "" !== u ? u : null;
                  }
                  if ("EOD" === u) break;
                }
              } else o[++n] = [], i = 0;
              return o;
            }
            function r(t, r) {
              return Ee(e(t, r), r);
            }
            function n(e, t) {
              return Ce(r(e, t), t);
            }
            return {
              to_workbook: n,
              to_sheet: r,
              from_sheet: function () {
                var e = function e(_e5, t, r, n, i) {
                    _e5.push(t), _e5.push(r + "," + n), _e5.push('"' + i.replace(/"/g, '""') + '"');
                  },
                  t = function t(e, _t9, r, n) {
                    e.push(_t9 + "," + r), e.push(1 == _t9 ? '"' + n.replace(/"/g, '""') + '"' : n);
                  };
                return function (r, n) {
                  var i,
                    a = [],
                    o = ye(r["!ref"]),
                    s = Array.isArray(r);
                  e(a, "TABLE", 0, 1, "sheetjs"), e(a, "VECTORS", 0, o.e.r - o.s.r + 1, ""), e(a, "TUPLES", 0, o.e.c - o.s.c + 1, ""), e(a, "DATA", 0, 0, "");
                  for (var l = o.s.r; l <= o.e.r; ++l) {
                    t(a, -1, 0, "BOT");
                    for (var c = o.s.c; c <= o.e.c; ++c) {
                      var u = be({
                        r: l,
                        c: c
                      });
                      if (i = s ? (r[l] || [])[c] : r[u]) switch (i.t) {
                        case "n":
                          var h = i.w;
                          h || null == i.v || (h = i.v), null == h ? i.f && !i.F ? t(a, 1, 0, "=" + i.f) : t(a, 1, 0, "") : t(a, 0, h, "V");
                          break;
                        case "b":
                          t(a, 0, i.v ? 1 : 0, i.v ? "TRUE" : "FALSE");
                          break;
                        case "s":
                          t(a, 1, 0, isNaN(i.v) ? i.v : '="' + i.v + '"');
                          break;
                        case "d":
                          i.w || (i.w = Nc.format(i.z || Nc._table[14], b(x(i.v)))), t(a, 0, i.w, "V");
                          break;
                        default:
                          t(a, 1, 0, "");
                      } else t(a, 1, 0, "");
                    }
                  }
                  t(a, -1, 0, "EOD");
                  return a.join("\r\n");
                };
              }()
            };
          }(),
          Ov = function () {
            function e(e, t, r, n, i) {
              i.raw ? t[r][n] = e : "TRUE" === e ? t[r][n] = !0 : "FALSE" === e ? t[r][n] = !1 : "" === e || (+e == +e ? t[r][n] = +e : isNaN(A(e).getDate()) ? t[r][n] = e : t[r][n] = x(e));
            }
            function t(t, r) {
              var n = r || {},
                i = [];
              if (!t || 0 === t.length) return i;
              for (var a = t.split(/[\r\n]/), o = a.length - 1; o >= 0 && 0 === a[o].length;) --o;
              for (var s = 10, l = 0, c = 0; c <= o; ++c) l = a[c].indexOf(" "), -1 == l ? l = a[c].length : l++, s = Math.max(s, l);
              for (c = 0; c <= o; ++c) {
                i[c] = [];
                var u = 0;
                for (e(a[c].slice(0, s).trim(), i, c, u, n), u = 1; u <= (a[c].length - s) / 10 + 1; ++u) e(a[c].slice(s + 10 * (u - 1), s + 10 * u).trim(), i, c, u, n);
              }
              return i;
            }
            function r(e, t) {
              function r() {
                var t = e.slice(u, h),
                  r = {};
                if (n.raw) r.t = "s", r.v = t;else if (61 == t.charCodeAt(0)) r.t = "n", r.f = t.substr(1);else if ("TRUE" == t) r.t = "b", r.v = !0;else if ("FALSE" == t) r.t = "b", r.v = !1;else if (isNaN(c = +t)) {
                  if (!isNaN(A(t).getDate()) || v && t.match(v)) {
                    r.z = n.dateNF || Nc._table[14];
                    var i = 0;
                    v && t.match(v) && (t = d(t, n.dateNF, t.match(v) || []), i = 1), n.cellDates ? (r.t = "d", r.v = x(t, i)) : (r.t = "n", r.v = b(x(t, i))), r.w = Nc.format(r.z, r.v instanceof Date ? b(r.v) : r.v);
                  } else r.t = "s", '"' == t.charAt(0) && '"' == t.charAt(t.length - 1) && (t = t.slice(1, -1).replace(/""/g, '"')), r.v = t;
                } else r.t = "n", r.w = t, r.v = c;
                n.dense ? (a[s] || (a[s] = []), a[s][l] = r) : a[be({
                  c: l,
                  r: s
                })] = r, u = h + 1, o.e.c < l && (o.e.c = l), o.e.r < s && (o.e.r = s), g == p ? ++l : (l = 0, ++s);
              }
              var n = t || {},
                i = "";
              null != Oc && null == n.dense && (n.dense = Oc);
              var a = n.dense ? [] : {},
                o = {
                  s: {
                    c: 0,
                    r: 0
                  },
                  e: {
                    c: 0,
                    r: 0
                  }
                };
              "sep=" == e.substr(0, 4) && 10 == e.charCodeAt(5) ? (i = e.charAt(4), e = e.substr(6)) : i = -1 == e.substr(0, 1024).indexOf("\t") ? "," : "\t";
              var s = 0,
                l = 0,
                c = 0,
                u = 0,
                h = 0,
                p = i.charCodeAt(0),
                m = !1,
                g = 0;
              e = e.replace(/\r\n/gm, "\n");
              for (var v = null != n.dateNF ? f(n.dateNF) : null; h < e.length; ++h) switch (g = e.charCodeAt(h)) {
                case 34:
                  m = !m;
                  break;
                case p:
                case 10:
                case 13:
                  m || r();
              }
              return h - u > 0 && r(), a["!ref"] = we(o), a;
            }
            function n(e, n) {
              return "sep=" == e.substr(0, 4) ? r(e, n) : e.indexOf("\t") >= 0 || e.indexOf(",") >= 0 ? r(e, n) : Ee(t(e, n), n);
            }
            function i(e, t) {
              var r = "",
                i = oc(e, t);
              switch (t.type) {
                case "base64":
                  r = Pc.decode(e);
                  break;
                case "binary":
                  r = e;
                  break;
                case "buffer":
                  r = e.toString("binary");
                  break;
                case "array":
                  r = _(e);
                  break;
                default:
                  throw new Error("Unrecognized type " + t.type);
              }
              return 239 == i[0] && 187 == i[1] && 191 == i[2] && (r = su(r)), n(r, t);
            }
            function a(e, t) {
              return Ce(i(e, t), t);
            }
            function o(e, t) {
              for (var r, n = [], i = ye(e["!ref"]), a = Array.isArray(e), o = i.s.r; o <= i.e.r; ++o) {
                for (var s = [], l = i.s.c; l <= i.e.c; ++l) {
                  var c = be({
                    r: o,
                    c: l
                  });
                  if ((r = a ? (e[o] || [])[l] : e[c]) && null != r.v) {
                    for (var u = (r.w || (Se(r), r.w) || "").substr(0, 10); u.length < 10;) u += " ";
                    s.push(u + (0 == l ? " " : ""));
                  } else s.push("          ");
                }
                n.push(s.join(""));
              }
              return n.join("\n");
            }
            return {
              to_workbook: a,
              to_sheet: i,
              from_sheet: o
            };
          }(),
          Pv = function () {
            function e(e, t, r) {
              if (e) {
                Q(e, e.l || 0);
                for (var n = r.Enum || b; e.l < e.length;) {
                  var i = e.read_shift(2),
                    a = n[i] || n[255],
                    o = e.read_shift(2),
                    s = e.l + o,
                    l = a.f(e, o, r);
                  if (e.l = s, t(l, a.n, i)) return;
                }
              }
            }
            function t(e, t) {
              switch (t.type) {
                case "base64":
                  return r(h(Pc.decode(e)), t);
                case "binary":
                  return r(h(e), t);
                case "buffer":
                case "array":
                  return r(e, t);
              }
              throw "Unsupported type " + t.type;
            }
            function r(t, r) {
              if (!t) return t;
              var n = r || {};
              null != Oc && null == n.dense && (n.dense = Oc);
              var i = n.dense ? [] : {},
                a = "Sheet1",
                o = 0,
                s = {},
                l = [a],
                c = {
                  s: {
                    r: 0,
                    c: 0
                  },
                  e: {
                    r: 0,
                    c: 0
                  }
                };
              if (2 == t[2]) n.Enum = b;else if (26 == t[2]) n.Enum = w;else {
                if (14 != t[2]) throw new Error("Unrecognized LOTUS BOF " + t[2]);
                n.Enum = w, n.qpro = !0, t.l = 0;
              }
              return e(t, function (e, r, u) {
                if (2 == t[2]) switch (u) {
                  case 0:
                    n.vers = e, e >= 4096 && (n.qpro = !0);
                    break;
                  case 6:
                    c = e;
                    break;
                  case 15:
                    n.qpro || (e[1].v = e[1].v.substr(1));
                  case 13:
                  case 14:
                  case 16:
                  case 51:
                    14 == u && 112 == (112 & e[2]) && (15 & e[2]) > 1 && (15 & e[2]) < 15 && (e[1].z = n.dateNF || Nc._table[14], n.cellDates && (e[1].t = "d", e[1].v = y(e[1].v))), n.dense ? (i[e[0].r] || (i[e[0].r] = []), i[e[0].r][e[0].c] = e[1]) : i[be(e[0])] = e[1];
                } else switch (u) {
                  case 22:
                    e[1].v = e[1].v.substr(1);
                  case 23:
                  case 24:
                  case 25:
                  case 37:
                  case 39:
                  case 40:
                    e[3] > o && (i["!ref"] = we(c), s[a] = i, i = n.dense ? [] : {}, c = {
                      s: {
                        r: 0,
                        c: 0
                      },
                      e: {
                        r: 0,
                        c: 0
                      }
                    }, o = e[3], a = "Sheet" + (o + 1), l.push(a)), i[be(e[0])] = e[1], c.e.c < e[0].c && (c.e.c = e[0].c), c.e.r < e[0].r && (c.e.r = e[0].r);
                }
              }, n), i["!ref"] = we(c), s[a] = i, {
                SheetNames: l,
                Sheets: s
              };
            }
            function n(e, t) {
              var r = {
                s: {
                  c: 0,
                  r: 0
                },
                e: {
                  c: 0,
                  r: 0
                }
              };
              return r.s.c = e.read_shift(2), r.s.r = e.read_shift(2), r.e.c = e.read_shift(2), r.e.r = e.read_shift(2), 65535 == r.s.c && (r.s.c = r.e.c = r.s.r = r.e.r = 0), r;
            }
            function i(e, t, r) {
              var n = [{
                c: 0,
                r: 0
              }, {
                t: "n",
                v: 0
              }, 0];
              return r.qpro && 20768 != r.vers ? (n[0].c = e.read_shift(1), e.l++, n[0].r = e.read_shift(2), e.l += 2) : (n[2] = e.read_shift(1), n[0].c = e.read_shift(2), n[0].r = e.read_shift(2)), n;
            }
            function a(e, t, r) {
              var n = e.l + t,
                a = i(e, t, r);
              if (a[1].t = "s", 20768 == r.vers) {
                e.l++;
                var o = e.read_shift(1);
                return a[1].v = e.read_shift(o, "utf8"), a;
              }
              return r.qpro && e.l++, a[1].v = e.read_shift(n - e.l, "cstr"), a;
            }
            function o(e, t, r) {
              var n = i(e, t, r);
              return n[1].v = e.read_shift(2, "i"), n;
            }
            function s(e, t, r) {
              var n = i(e, t, r);
              return n[1].v = e.read_shift(8, "f"), n;
            }
            function l(e, t, r) {
              var n = e.l + t,
                a = i(e, t, r);
              if (a[1].v = e.read_shift(8, "f"), r.qpro) e.l = n;else {
                var o = e.read_shift(2);
                e.l += o;
              }
              return a;
            }
            function c(e, t) {
              var r = [{
                c: 0,
                r: 0
              }, {
                t: "n",
                v: 0
              }, 0];
              return r[0].r = e.read_shift(2), r[3] = e[e.l++], r[0].c = e[e.l++], r;
            }
            function u(e, t) {
              var r = c(e, t);
              return r[1].t = "s", r[1].v = e.read_shift(t - 4, "cstr"), r;
            }
            function f(e, t) {
              var r = c(e, t);
              r[1].v = e.read_shift(2);
              var n = r[1].v >> 1;
              if (1 & r[1].v) switch (7 & n) {
                case 1:
                  n = 500 * (n >> 3);
                  break;
                case 2:
                  n = (n >> 3) / 20;
                  break;
                case 4:
                  n = (n >> 3) / 2e3;
                  break;
                case 6:
                  n = (n >> 3) / 16;
                  break;
                case 7:
                  n = (n >> 3) / 64;
                  break;
                default:
                  throw "unknown NUMBER_18 encoding " + (7 & n);
              }
              return r[1].v = n, r;
            }
            function d(e, t) {
              var r = c(e, t),
                n = e.read_shift(4),
                i = e.read_shift(4),
                a = e.read_shift(2);
              if (65535 == a) return r[1].v = 0, r;
              return a = (32767 & a) - 16446, r[1].v = (a > 0 ? i << a : i >>> -a) + (a > -32 ? n << a + 32 : n >>> -(a + 32)), r;
            }
            function p(e, t) {
              var r = d(e, 14);
              return e.l += t - 14, r;
            }
            function m(e, t) {
              var r = c(e, t),
                n = e.read_shift(4);
              return r[1].v = n >> 6, r;
            }
            function g(e, t) {
              var r = c(e, t),
                n = e.read_shift(8, "f");
              return r[1].v = n, r;
            }
            function v(e, t) {
              var r = g(e, 14);
              return e.l += t - 10, r;
            }
            var b = {
                0: {
                  n: "BOF",
                  f: Lt
                },
                1: {
                  n: "EOF",
                  f: $
                },
                2: {
                  n: "CALCMODE",
                  f: $
                },
                3: {
                  n: "CALCORDER",
                  f: $
                },
                4: {
                  n: "SPLIT",
                  f: $
                },
                5: {
                  n: "SYNC",
                  f: $
                },
                6: {
                  n: "RANGE",
                  f: n
                },
                7: {
                  n: "WINDOW1",
                  f: $
                },
                8: {
                  n: "COLW1",
                  f: $
                },
                9: {
                  n: "WINTWO",
                  f: $
                },
                10: {
                  n: "COLW2",
                  f: $
                },
                11: {
                  n: "NAME",
                  f: $
                },
                12: {
                  n: "BLANK",
                  f: $
                },
                13: {
                  n: "INTEGER",
                  f: o
                },
                14: {
                  n: "NUMBER",
                  f: s
                },
                15: {
                  n: "LABEL",
                  f: a
                },
                16: {
                  n: "FORMULA",
                  f: l
                },
                24: {
                  n: "TABLE",
                  f: $
                },
                25: {
                  n: "ORANGE",
                  f: $
                },
                26: {
                  n: "PRANGE",
                  f: $
                },
                27: {
                  n: "SRANGE",
                  f: $
                },
                28: {
                  n: "FRANGE",
                  f: $
                },
                29: {
                  n: "KRANGE1",
                  f: $
                },
                32: {
                  n: "HRANGE",
                  f: $
                },
                35: {
                  n: "KRANGE2",
                  f: $
                },
                36: {
                  n: "PROTEC",
                  f: $
                },
                37: {
                  n: "FOOTER",
                  f: $
                },
                38: {
                  n: "HEADER",
                  f: $
                },
                39: {
                  n: "SETUP",
                  f: $
                },
                40: {
                  n: "MARGINS",
                  f: $
                },
                41: {
                  n: "LABELFMT",
                  f: $
                },
                42: {
                  n: "TITLES",
                  f: $
                },
                43: {
                  n: "SHEETJS",
                  f: $
                },
                45: {
                  n: "GRAPH",
                  f: $
                },
                46: {
                  n: "NGRAPH",
                  f: $
                },
                47: {
                  n: "CALCCOUNT",
                  f: $
                },
                48: {
                  n: "UNFORMATTED",
                  f: $
                },
                49: {
                  n: "CURSORW12",
                  f: $
                },
                50: {
                  n: "WINDOW",
                  f: $
                },
                51: {
                  n: "STRING",
                  f: a
                },
                55: {
                  n: "PASSWORD",
                  f: $
                },
                56: {
                  n: "LOCKED",
                  f: $
                },
                60: {
                  n: "QUERY",
                  f: $
                },
                61: {
                  n: "QUERYNAME",
                  f: $
                },
                62: {
                  n: "PRINT",
                  f: $
                },
                63: {
                  n: "PRINTNAME",
                  f: $
                },
                64: {
                  n: "GRAPH2",
                  f: $
                },
                65: {
                  n: "GRAPHNAME",
                  f: $
                },
                66: {
                  n: "ZOOM",
                  f: $
                },
                67: {
                  n: "SYMSPLIT",
                  f: $
                },
                68: {
                  n: "NSROWS",
                  f: $
                },
                69: {
                  n: "NSCOLS",
                  f: $
                },
                70: {
                  n: "RULER",
                  f: $
                },
                71: {
                  n: "NNAME",
                  f: $
                },
                72: {
                  n: "ACOMM",
                  f: $
                },
                73: {
                  n: "AMACRO",
                  f: $
                },
                74: {
                  n: "PARSE",
                  f: $
                },
                255: {
                  n: "",
                  f: $
                }
              },
              w = {
                0: {
                  n: "BOF",
                  f: $
                },
                1: {
                  n: "EOF",
                  f: $
                },
                3: {
                  n: "??",
                  f: $
                },
                4: {
                  n: "??",
                  f: $
                },
                5: {
                  n: "??",
                  f: $
                },
                6: {
                  n: "??",
                  f: $
                },
                7: {
                  n: "??",
                  f: $
                },
                9: {
                  n: "??",
                  f: $
                },
                10: {
                  n: "??",
                  f: $
                },
                11: {
                  n: "??",
                  f: $
                },
                12: {
                  n: "??",
                  f: $
                },
                14: {
                  n: "??",
                  f: $
                },
                15: {
                  n: "??",
                  f: $
                },
                16: {
                  n: "??",
                  f: $
                },
                17: {
                  n: "??",
                  f: $
                },
                18: {
                  n: "??",
                  f: $
                },
                19: {
                  n: "??",
                  f: $
                },
                21: {
                  n: "??",
                  f: $
                },
                22: {
                  n: "LABEL16",
                  f: u
                },
                23: {
                  n: "NUMBER17",
                  f: d
                },
                24: {
                  n: "NUMBER18",
                  f: f
                },
                25: {
                  n: "FORMULA19",
                  f: p
                },
                26: {
                  n: "??",
                  f: $
                },
                27: {
                  n: "??",
                  f: $
                },
                28: {
                  n: "??",
                  f: $
                },
                29: {
                  n: "??",
                  f: $
                },
                30: {
                  n: "??",
                  f: $
                },
                31: {
                  n: "??",
                  f: $
                },
                33: {
                  n: "??",
                  f: $
                },
                37: {
                  n: "NUMBER25",
                  f: m
                },
                39: {
                  n: "NUMBER27",
                  f: g
                },
                40: {
                  n: "FORMULA28",
                  f: v
                },
                255: {
                  n: "",
                  f: $
                }
              };
            return {
              to_workbook: t
            };
          }(),
          Bv = {
            0: 1252,
            1: 65001,
            2: 65001,
            77: 1e4,
            128: 932,
            129: 949,
            130: 1361,
            134: 936,
            136: 950,
            161: 1253,
            162: 1254,
            163: 1258,
            177: 1255,
            178: 1256,
            186: 1257,
            204: 1251,
            222: 874,
            238: 1250,
            255: 1252,
            69: 6969
          },
          Dv = function () {
            function e(e) {
              var n = [[], "", []],
                i = e.match(t);
              if (!p(i)) return "";
              n[1] = i[1];
              var s = e.match(r);
              return p(s) && o(s[1], n[0], n[2]), n[0].join("") + n[1].replace(a, "<br/>") + n[2].join("");
            }
            var t = hu("t"),
              r = hu("rPr"),
              n = /<(?:\w+:)?r>/g,
              i = /<\/(?:\w+:)?r>/,
              a = /\r\n/g,
              o = function o(e, t, r) {
                var n = {},
                  i = 65001,
                  a = "",
                  o = e.match(Zc),
                  s = 0;
                if (o) for (; s != o.length; ++s) {
                  var l = D(o[s]);
                  switch (l[0].replace(/\w*:/g, "")) {
                    case "<condense":
                    case "<extend":
                      break;
                    case "<shadow":
                      if (!l.val) break;
                    case "<shadow>":
                    case "<shadow/>":
                      n.shadow = 1;
                      break;
                    case "</shadow>":
                      break;
                    case "<charset":
                      if ("1" == l.val) break;
                      i = Bv[parseInt(l.val, 10)];
                      break;
                    case "<outline":
                      if (!l.val) break;
                    case "<outline>":
                    case "<outline/>":
                      n.outline = 1;
                      break;
                    case "</outline>":
                      break;
                    case "<rFont":
                      n.name = l.val;
                      break;
                    case "<sz":
                      n.sz = l.val;
                      break;
                    case "<strike":
                      if (!l.val) break;
                    case "<strike>":
                    case "<strike/>":
                      n.strike = 1;
                      break;
                    case "</strike>":
                      break;
                    case "<u":
                      if (!l.val) break;
                      switch (l.val) {
                        case "double":
                          n.uval = "double";
                          break;
                        case "singleAccounting":
                          n.uval = "single-accounting";
                          break;
                        case "doubleAccounting":
                          n.uval = "double-accounting";
                      }
                    case "<u>":
                    case "<u/>":
                      n.u = 1;
                      break;
                    case "</u>":
                      break;
                    case "<b":
                      if ("0" == l.val) break;
                    case "<b>":
                    case "<b/>":
                      n.b = 1;
                      break;
                    case "</b>":
                      break;
                    case "<i":
                      if ("0" == l.val) break;
                    case "<i>":
                    case "<i/>":
                      n.i = 1;
                      break;
                    case "</i>":
                      break;
                    case "<color":
                      l.rgb && (n.color = l.rgb.substr(2, 6));
                      break;
                    case "<family":
                      n.family = l.val;
                      break;
                    case "<vertAlign":
                      a = l.val;
                      break;
                    case "<scheme":
                      break;
                    default:
                      if (47 !== l[0].charCodeAt(1)) throw "Unrecognized rich format " + l[0];
                  }
                }
                var c = [];
                return n.u && c.push("text-decoration: underline;"), n.uval && c.push("text-underline-style:" + n.uval + ";"), n.sz && c.push("font-size:" + n.sz + ";"), n.outline && c.push("text-effect: outline;"), n.shadow && c.push("text-shadow: auto;"), t.push('<span style="' + c.join("") + '">'), n.b && (t.push("<b>"), r.push("</b>")), n.i && (t.push("<i>"), r.push("</i>")), n.strike && (t.push("<s>"), r.push("</s>")), "superscript" == a ? a = "sup" : "subscript" == a && (a = "sub"), "" != a && (t.push("<" + a + ">"), r.push("</" + a + ">")), r.push("</span>"), i;
              };
            return function (t) {
              return t.replace(n, "").split(i).map(e).join("");
            };
          }(),
          Lv = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g,
          Fv = /<(?:\w+:)?r>/,
          Nv = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g,
          Uv = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/,
          jv = /<(?:\w+:)?(?:si|sstItem)>/g,
          zv = /<\/(?:\w+:)?(?:si|sstItem)>/;
        bh.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
        var Hv = /^\s|\s$|[\t\n\r]/,
          Gv = Oe,
          Vv = function () {
            var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0],
              t = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163],
              r = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628],
              n = function n(e) {
                return 255 & (e / 2 | 128 * e);
              },
              i = function i(e, t) {
                return n(e ^ t);
              },
              a = function a(e) {
                for (var n = t[e.length - 1], i = 104, a = e.length - 1; a >= 0; --a) for (var o = e[a], s = 0; 7 != s; ++s) 64 & o && (n ^= r[i]), o *= 2, --i;
                return n;
              };
            return function (t) {
              for (var r = pn(t), n = a(r), o = r.length, s = u(16), l = 0; 16 != l; ++l) s[l] = 0;
              var c, h, f;
              for (1 == (1 & o) && (c = n >> 8, s[o] = i(e[0], c), --o, c = 255 & n, h = r[r.length - 1], s[o] = i(h, c)); o > 0;) --o, c = n >> 8, s[o] = i(r[o], c), --o, c = 255 & n, s[o] = i(r[o], c);
              for (o = 15, f = 15 - r.length; f > 0;) c = n >> 8, s[o] = i(e[f], c), --o, --f, c = 255 & n, s[o] = i(r[o], c), --o, --f;
              return s;
            };
          }(),
          qv = function qv(e, t, r, n, i) {
            i || (i = t), n || (n = Vv(e));
            var a, o;
            for (a = 0; a != t.length; ++a) o = t[a], o ^= n[r], o = 255 & (o >> 5 | o << 3), i[a] = o, ++r;
            return [i, r, n];
          },
          Wv = function Wv(e) {
            var t = 0,
              r = Vv(e);
            return function (e) {
              var n = qv("", e, t, r);
              return t = n[1], n[0];
            };
          },
          Xv = 6,
          Yv = 15,
          Kv = 1,
          Zv = Xv,
          Jv = 96,
          Qv = {
            None: "none",
            Solid: "solid",
            Gray50: "mediumGray",
            Gray75: "darkGray",
            Gray25: "lightGray",
            HorzStripe: "darkHorizontal",
            VertStripe: "darkVertical",
            ReverseDiagStripe: "darkDown",
            DiagStripe: "darkUp",
            DiagCross: "darkGrid",
            ThickDiagCross: "darkTrellis",
            ThinHorzStripe: "lightHorizontal",
            ThinVertStripe: "lightVertical",
            ThinReverseDiagStripe: "lightDown",
            ThinHorzCross: "lightGrid"
          },
          $v = ["numFmtId", "fillId", "fontId", "borderId", "xfId"],
          eb = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"],
          tb = function () {
            var e = /<numFmts([^>]*)>[\S\s]*?<\/numFmts>/,
              t = /<cellXfs([^>]*)>[\S\s]*?<\/cellXfs>/,
              r = /<fills([^>]*)>[\S\s]*?<\/fills>/,
              n = /<fonts([^>]*)>[\S\s]*?<\/fonts>/,
              i = /<borders([^>]*)>[\S\s]*?<\/borders>/;
            return function (a, o, s) {
              var l = {};
              if (!a) return l;
              a = a.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
              var c;
              return (c = a.match(e)) && Zn(c, l, s), (c = a.match(n)) && Kn(c, l, o, s), (c = a.match(r)) && Yn(c, l, o, s), (c = a.match(i)) && Xn(c, l, o, s), (c = a.match(t)) && Qn(c, l, s), l;
            };
          }(),
          rb = V("styleSheet", null, {
            xmlns: vu.main[0],
            "xmlns:vt": vu.vt
          });
        bh.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
        var nb = ["none", "solid", "mediumGray", "darkGray", "lightGray", "darkHorizontal", "darkVertical", "darkDown", "darkUp", "darkGrid", "darkTrellis", "lightHorizontal", "lightVertical", "lightDown", "lightUp", "lightGrid", "lightTrellis", "gray125", "gray0625"],
          ib = g(nb);
        bh.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
        var ab = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/,
          ob = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/,
          sb = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/,
          lb = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
        bh.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", bh.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
        var cb = 1024;
        bh.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
        var ub = V("comments", null, {
            xmlns: vu.main[0]
          }),
          hb = Te;
        bh.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet", bh.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
        var fb = function () {
            function e(e, t, n, i, a, o) {
              var s = i.length > 0 ? 0 | parseInt(i, 10) : 0,
                l = o.length > 0 ? 0 | parseInt(o, 10) : 0;
              l < 0 && 0 === a.length && (l = 0);
              var c = !1,
                u = !1;
              return (a.length > 0 || 0 == o.length) && (c = !0), c ? l += r.c : --l, (n.length > 0 || 0 == i.length) && (u = !0), u ? s += r.r : --s, t + (c ? "" : "$") + de(l) + (u ? "" : "$") + ce(s);
            }
            var t = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g,
              r = {
                r: 0,
                c: 0
              };
            return function (n, i) {
              return r = i, n.replace(t, e);
            };
          }(),
          db = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)([1-9]\d{0,5}|10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6])(?![_.\(A-Za-z0-9])/g,
          pb = function () {
            return function (e, t) {
              return e.replace(db, function (e, r, n, i, a, o, s, l) {
                var c = fe(i) - t.c,
                  u = le(o) - t.r;
                return r + "R" + (0 == u ? "" : "[" + u + "]") + "C" + (0 == c ? "" : "[" + c + "]");
              });
            };
          }(),
          mb = ia,
          gb = ia,
          vb = ia,
          bb = ia,
          yb = ia,
          wb = ia,
          xb = ia,
          _b = ia,
          Sb = ia,
          Cb = ia,
          Eb = ia,
          Ab = ia,
          Tb = ia,
          kb = ia,
          Rb = ia,
          Ib = ia,
          Mb = ia,
          Ob = ia,
          Pb = ia,
          Bb = ia,
          Db = $,
          Lb = $,
          Fb = $,
          Nb = {
            1: {
              n: "PtgExp",
              f: Da
            },
            2: {
              n: "PtgTbl",
              f: Fb
            },
            3: {
              n: "PtgAdd",
              f: gb
            },
            4: {
              n: "PtgSub",
              f: Mb
            },
            5: {
              n: "PtgMul",
              f: Eb
            },
            6: {
              n: "PtgDiv",
              f: vb
            },
            7: {
              n: "PtgPower",
              f: Rb
            },
            8: {
              n: "PtgConcat",
              f: mb
            },
            9: {
              n: "PtgLt",
              f: Sb
            },
            10: {
              n: "PtgLe",
              f: _b
            },
            11: {
              n: "PtgEq",
              f: bb
            },
            12: {
              n: "PtgGe",
              f: yb
            },
            13: {
              n: "PtgGt",
              f: wb
            },
            14: {
              n: "PtgNe",
              f: Ab
            },
            15: {
              n: "PtgIsect",
              f: xb
            },
            16: {
              n: "PtgUnion",
              f: Pb
            },
            17: {
              n: "PtgRange",
              f: Ib
            },
            18: {
              n: "PtgUplus",
              f: Bb
            },
            19: {
              n: "PtgUminus",
              f: Ob
            },
            20: {
              n: "PtgPercent",
              f: kb
            },
            21: {
              n: "PtgParen",
              f: Tb
            },
            22: {
              n: "PtgMissArg",
              f: Cb
            },
            23: {
              n: "PtgStr",
              f: ja
            },
            28: {
              n: "PtgErr",
              f: La
            },
            29: {
              n: "PtgBool",
              f: Na
            },
            30: {
              n: "PtgInt",
              f: Fa
            },
            31: {
              n: "PtgNum",
              f: Ua
            },
            32: {
              n: "PtgArray",
              f: ba
            },
            33: {
              n: "PtgFunc",
              f: Ma
            },
            34: {
              n: "PtgFuncVar",
              f: Oa
            },
            35: {
              n: "PtgName",
              f: Va
            },
            36: {
              n: "PtgRef",
              f: ka
            },
            37: {
              n: "PtgArea",
              f: da
            },
            38: {
              n: "PtgMemArea",
              f: Xa
            },
            39: {
              n: "PtgMemErr",
              f: Db
            },
            40: {
              n: "PtgMemNoMem",
              f: Lb
            },
            41: {
              n: "PtgMemFunc",
              f: Ya
            },
            42: {
              n: "PtgRefErr",
              f: Ka
            },
            43: {
              n: "PtgAreaErr",
              f: ma
            },
            44: {
              n: "PtgRefN",
              f: Ra
            },
            45: {
              n: "PtgAreaN",
              f: va
            },
            57: {
              n: "PtgNameX",
              f: qa
            },
            58: {
              n: "PtgRef3d",
              f: Ia
            },
            59: {
              n: "PtgArea3d",
              f: pa
            },
            60: {
              n: "PtgRefErr3d",
              f: Za
            },
            61: {
              n: "PtgAreaErr3d",
              f: ga
            },
            255: {}
          },
          Ub = {
            64: 32,
            96: 32,
            65: 33,
            97: 33,
            66: 34,
            98: 34,
            67: 35,
            99: 35,
            68: 36,
            100: 36,
            69: 37,
            101: 37,
            70: 38,
            102: 38,
            71: 39,
            103: 39,
            72: 40,
            104: 40,
            73: 41,
            105: 41,
            74: 42,
            106: 42,
            75: 43,
            107: 43,
            76: 44,
            108: 44,
            77: 45,
            109: 45,
            89: 57,
            121: 57,
            90: 58,
            122: 58,
            91: 59,
            123: 59,
            92: 60,
            124: 60,
            93: 61,
            125: 61
          };
        !function () {
          for (var e in Ub) Nb[e] = Nb[Ub[e]];
        }();
        var jb = {},
          zb = {
            1: {
              n: "PtgAttrSemi",
              f: Ca
            },
            2: {
              n: "PtgAttrIf",
              f: _a
            },
            4: {
              n: "PtgAttrChoose",
              f: wa
            },
            8: {
              n: "PtgAttrGoto",
              f: xa
            },
            16: {
              n: "PtgAttrSum",
              f: Ba
            },
            32: {
              n: "PtgAttrBaxcel",
              f: ya
            },
            64: {
              n: "PtgAttrSpace",
              f: Aa
            },
            65: {
              n: "PtgAttrSpaceSemi",
              f: Ta
            },
            128: {
              n: "PtgAttrIfError",
              f: Sa
            },
            255: {}
          },
          Hb = {
            PtgAdd: "+",
            PtgConcat: "&",
            PtgDiv: "/",
            PtgEq: "=",
            PtgGe: ">=",
            PtgGt: ">",
            PtgLe: "<=",
            PtgLt: "<",
            PtgMul: "*",
            PtgNe: "<>",
            PtgPower: "^",
            PtgSub: "-"
          },
          Gb = lo,
          Vb = lo,
          qb = lo,
          Wb = lo,
          Xb = {
            0: "BEEP",
            1: "OPEN",
            2: "OPEN.LINKS",
            3: "CLOSE.ALL",
            4: "SAVE",
            5: "SAVE.AS",
            6: "FILE.DELETE",
            7: "PAGE.SETUP",
            8: "PRINT",
            9: "PRINTER.SETUP",
            10: "QUIT",
            11: "NEW.WINDOW",
            12: "ARRANGE.ALL",
            13: "WINDOW.SIZE",
            14: "WINDOW.MOVE",
            15: "FULL",
            16: "CLOSE",
            17: "RUN",
            22: "SET.PRINT.AREA",
            23: "SET.PRINT.TITLES",
            24: "SET.PAGE.BREAK",
            25: "REMOVE.PAGE.BREAK",
            26: "FONT",
            27: "DISPLAY",
            28: "PROTECT.DOCUMENT",
            29: "PRECISION",
            30: "A1.R1C1",
            31: "CALCULATE.NOW",
            32: "CALCULATION",
            34: "DATA.FIND",
            35: "EXTRACT",
            36: "DATA.DELETE",
            37: "SET.DATABASE",
            38: "SET.CRITERIA",
            39: "SORT",
            40: "DATA.SERIES",
            41: "TABLE",
            42: "FORMAT.NUMBER",
            43: "ALIGNMENT",
            44: "STYLE",
            45: "BORDER",
            46: "CELL.PROTECTION",
            47: "COLUMN.WIDTH",
            48: "UNDO",
            49: "CUT",
            50: "COPY",
            51: "PASTE",
            52: "CLEAR",
            53: "PASTE.SPECIAL",
            54: "EDIT.DELETE",
            55: "INSERT",
            56: "FILL.RIGHT",
            57: "FILL.DOWN",
            61: "DEFINE.NAME",
            62: "CREATE.NAMES",
            63: "FORMULA.GOTO",
            64: "FORMULA.FIND",
            65: "SELECT.LAST.CELL",
            66: "SHOW.ACTIVE.CELL",
            67: "GALLERY.AREA",
            68: "GALLERY.BAR",
            69: "GALLERY.COLUMN",
            70: "GALLERY.LINE",
            71: "GALLERY.PIE",
            72: "GALLERY.SCATTER",
            73: "COMBINATION",
            74: "PREFERRED",
            75: "ADD.OVERLAY",
            76: "GRIDLINES",
            77: "SET.PREFERRED",
            78: "AXES",
            79: "LEGEND",
            80: "ATTACH.TEXT",
            81: "ADD.ARROW",
            82: "SELECT.CHART",
            83: "SELECT.PLOT.AREA",
            84: "PATTERNS",
            85: "MAIN.CHART",
            86: "OVERLAY",
            87: "SCALE",
            88: "FORMAT.LEGEND",
            89: "FORMAT.TEXT",
            90: "EDIT.REPEAT",
            91: "PARSE",
            92: "JUSTIFY",
            93: "HIDE",
            94: "UNHIDE",
            95: "WORKSPACE",
            96: "FORMULA",
            97: "FORMULA.FILL",
            98: "FORMULA.ARRAY",
            99: "DATA.FIND.NEXT",
            100: "DATA.FIND.PREV",
            101: "FORMULA.FIND.NEXT",
            102: "FORMULA.FIND.PREV",
            103: "ACTIVATE",
            104: "ACTIVATE.NEXT",
            105: "ACTIVATE.PREV",
            106: "UNLOCKED.NEXT",
            107: "UNLOCKED.PREV",
            108: "COPY.PICTURE",
            109: "SELECT",
            110: "DELETE.NAME",
            111: "DELETE.FORMAT",
            112: "VLINE",
            113: "HLINE",
            114: "VPAGE",
            115: "HPAGE",
            116: "VSCROLL",
            117: "HSCROLL",
            118: "ALERT",
            119: "NEW",
            120: "CANCEL.COPY",
            121: "SHOW.CLIPBOARD",
            122: "MESSAGE",
            124: "PASTE.LINK",
            125: "APP.ACTIVATE",
            126: "DELETE.ARROW",
            127: "ROW.HEIGHT",
            128: "FORMAT.MOVE",
            129: "FORMAT.SIZE",
            130: "FORMULA.REPLACE",
            131: "SEND.KEYS",
            132: "SELECT.SPECIAL",
            133: "APPLY.NAMES",
            134: "REPLACE.FONT",
            135: "FREEZE.PANES",
            136: "SHOW.INFO",
            137: "SPLIT",
            138: "ON.WINDOW",
            139: "ON.DATA",
            140: "DISABLE.INPUT",
            142: "OUTLINE",
            143: "LIST.NAMES",
            144: "FILE.CLOSE",
            145: "SAVE.WORKBOOK",
            146: "DATA.FORM",
            147: "COPY.CHART",
            148: "ON.TIME",
            149: "WAIT",
            150: "FORMAT.FONT",
            151: "FILL.UP",
            152: "FILL.LEFT",
            153: "DELETE.OVERLAY",
            155: "SHORT.MENUS",
            159: "SET.UPDATE.STATUS",
            161: "COLOR.PALETTE",
            162: "DELETE.STYLE",
            163: "WINDOW.RESTORE",
            164: "WINDOW.MAXIMIZE",
            166: "CHANGE.LINK",
            167: "CALCULATE.DOCUMENT",
            168: "ON.KEY",
            169: "APP.RESTORE",
            170: "APP.MOVE",
            171: "APP.SIZE",
            172: "APP.MINIMIZE",
            173: "APP.MAXIMIZE",
            174: "BRING.TO.FRONT",
            175: "SEND.TO.BACK",
            185: "MAIN.CHART.TYPE",
            186: "OVERLAY.CHART.TYPE",
            187: "SELECT.END",
            188: "OPEN.MAIL",
            189: "SEND.MAIL",
            190: "STANDARD.FONT",
            191: "CONSOLIDATE",
            192: "SORT.SPECIAL",
            193: "GALLERY.3D.AREA",
            194: "GALLERY.3D.COLUMN",
            195: "GALLERY.3D.LINE",
            196: "GALLERY.3D.PIE",
            197: "VIEW.3D",
            198: "GOAL.SEEK",
            199: "WORKGROUP",
            200: "FILL.GROUP",
            201: "UPDATE.LINK",
            202: "PROMOTE",
            203: "DEMOTE",
            204: "SHOW.DETAIL",
            206: "UNGROUP",
            207: "OBJECT.PROPERTIES",
            208: "SAVE.NEW.OBJECT",
            209: "SHARE",
            210: "SHARE.NAME",
            211: "DUPLICATE",
            212: "APPLY.STYLE",
            213: "ASSIGN.TO.OBJECT",
            214: "OBJECT.PROTECTION",
            215: "HIDE.OBJECT",
            216: "SET.EXTRACT",
            217: "CREATE.PUBLISHER",
            218: "SUBSCRIBE.TO",
            219: "ATTRIBUTES",
            220: "SHOW.TOOLBAR",
            222: "PRINT.PREVIEW",
            223: "EDIT.COLOR",
            224: "SHOW.LEVELS",
            225: "FORMAT.MAIN",
            226: "FORMAT.OVERLAY",
            227: "ON.RECALC",
            228: "EDIT.SERIES",
            229: "DEFINE.STYLE",
            240: "LINE.PRINT",
            243: "ENTER.DATA",
            249: "GALLERY.RADAR",
            250: "MERGE.STYLES",
            251: "EDITION.OPTIONS",
            252: "PASTE.PICTURE",
            253: "PASTE.PICTURE.LINK",
            254: "SPELLING",
            256: "ZOOM",
            259: "INSERT.OBJECT",
            260: "WINDOW.MINIMIZE",
            265: "SOUND.NOTE",
            266: "SOUND.PLAY",
            267: "FORMAT.SHAPE",
            268: "EXTEND.POLYGON",
            269: "FORMAT.AUTO",
            272: "GALLERY.3D.BAR",
            273: "GALLERY.3D.SURFACE",
            274: "FILL.AUTO",
            276: "CUSTOMIZE.TOOLBAR",
            277: "ADD.TOOL",
            278: "EDIT.OBJECT",
            279: "ON.DOUBLECLICK",
            280: "ON.ENTRY",
            281: "WORKBOOK.ADD",
            282: "WORKBOOK.MOVE",
            283: "WORKBOOK.COPY",
            284: "WORKBOOK.OPTIONS",
            285: "SAVE.WORKSPACE",
            288: "CHART.WIZARD",
            289: "DELETE.TOOL",
            290: "MOVE.TOOL",
            291: "WORKBOOK.SELECT",
            292: "WORKBOOK.ACTIVATE",
            293: "ASSIGN.TO.TOOL",
            295: "COPY.TOOL",
            296: "RESET.TOOL",
            297: "CONSTRAIN.NUMERIC",
            298: "PASTE.TOOL",
            302: "WORKBOOK.NEW",
            305: "SCENARIO.CELLS",
            306: "SCENARIO.DELETE",
            307: "SCENARIO.ADD",
            308: "SCENARIO.EDIT",
            309: "SCENARIO.SHOW",
            310: "SCENARIO.SHOW.NEXT",
            311: "SCENARIO.SUMMARY",
            312: "PIVOT.TABLE.WIZARD",
            313: "PIVOT.FIELD.PROPERTIES",
            314: "PIVOT.FIELD",
            315: "PIVOT.ITEM",
            316: "PIVOT.ADD.FIELDS",
            318: "OPTIONS.CALCULATION",
            319: "OPTIONS.EDIT",
            320: "OPTIONS.VIEW",
            321: "ADDIN.MANAGER",
            322: "MENU.EDITOR",
            323: "ATTACH.TOOLBARS",
            324: "VBAActivate",
            325: "OPTIONS.CHART",
            328: "VBA.INSERT.FILE",
            330: "VBA.PROCEDURE.DEFINITION",
            336: "ROUTING.SLIP",
            338: "ROUTE.DOCUMENT",
            339: "MAIL.LOGON",
            342: "INSERT.PICTURE",
            343: "EDIT.TOOL",
            344: "GALLERY.DOUGHNUT",
            350: "CHART.TREND",
            352: "PIVOT.ITEM.PROPERTIES",
            354: "WORKBOOK.INSERT",
            355: "OPTIONS.TRANSITION",
            356: "OPTIONS.GENERAL",
            370: "FILTER.ADVANCED",
            373: "MAIL.ADD.MAILER",
            374: "MAIL.DELETE.MAILER",
            375: "MAIL.REPLY",
            376: "MAIL.REPLY.ALL",
            377: "MAIL.FORWARD",
            378: "MAIL.NEXT.LETTER",
            379: "DATA.LABEL",
            380: "INSERT.TITLE",
            381: "FONT.PROPERTIES",
            382: "MACRO.OPTIONS",
            383: "WORKBOOK.HIDE",
            384: "WORKBOOK.UNHIDE",
            385: "WORKBOOK.DELETE",
            386: "WORKBOOK.NAME",
            388: "GALLERY.CUSTOM",
            390: "ADD.CHART.AUTOFORMAT",
            391: "DELETE.CHART.AUTOFORMAT",
            392: "CHART.ADD.DATA",
            393: "AUTO.OUTLINE",
            394: "TAB.ORDER",
            395: "SHOW.DIALOG",
            396: "SELECT.ALL",
            397: "UNGROUP.SHEETS",
            398: "SUBTOTAL.CREATE",
            399: "SUBTOTAL.REMOVE",
            400: "RENAME.OBJECT",
            412: "WORKBOOK.SCROLL",
            413: "WORKBOOK.NEXT",
            414: "WORKBOOK.PREV",
            415: "WORKBOOK.TAB.SPLIT",
            416: "FULL.SCREEN",
            417: "WORKBOOK.PROTECT",
            420: "SCROLLBAR.PROPERTIES",
            421: "PIVOT.SHOW.PAGES",
            422: "TEXT.TO.COLUMNS",
            423: "FORMAT.CHARTTYPE",
            424: "LINK.FORMAT",
            425: "TRACER.DISPLAY",
            430: "TRACER.NAVIGATE",
            431: "TRACER.CLEAR",
            432: "TRACER.ERROR",
            433: "PIVOT.FIELD.GROUP",
            434: "PIVOT.FIELD.UNGROUP",
            435: "CHECKBOX.PROPERTIES",
            436: "LABEL.PROPERTIES",
            437: "LISTBOX.PROPERTIES",
            438: "EDITBOX.PROPERTIES",
            439: "PIVOT.REFRESH",
            440: "LINK.COMBO",
            441: "OPEN.TEXT",
            442: "HIDE.DIALOG",
            443: "SET.DIALOG.FOCUS",
            444: "ENABLE.OBJECT",
            445: "PUSHBUTTON.PROPERTIES",
            446: "SET.DIALOG.DEFAULT",
            447: "FILTER",
            448: "FILTER.SHOW.ALL",
            449: "CLEAR.OUTLINE",
            450: "FUNCTION.WIZARD",
            451: "ADD.LIST.ITEM",
            452: "SET.LIST.ITEM",
            453: "REMOVE.LIST.ITEM",
            454: "SELECT.LIST.ITEM",
            455: "SET.CONTROL.VALUE",
            456: "SAVE.COPY.AS",
            458: "OPTIONS.LISTS.ADD",
            459: "OPTIONS.LISTS.DELETE",
            460: "SERIES.AXES",
            461: "SERIES.X",
            462: "SERIES.Y",
            463: "ERRORBAR.X",
            464: "ERRORBAR.Y",
            465: "FORMAT.CHART",
            466: "SERIES.ORDER",
            467: "MAIL.LOGOFF",
            468: "CLEAR.ROUTING.SLIP",
            469: "APP.ACTIVATE.MICROSOFT",
            470: "MAIL.EDIT.MAILER",
            471: "ON.SHEET",
            472: "STANDARD.WIDTH",
            473: "SCENARIO.MERGE",
            474: "SUMMARY.INFO",
            475: "FIND.FILE",
            476: "ACTIVE.CELL.FONT",
            477: "ENABLE.TIPWIZARD",
            478: "VBA.MAKE.ADDIN",
            480: "INSERTDATATABLE",
            481: "WORKGROUP.OPTIONS",
            482: "MAIL.SEND.MAILER",
            485: "AUTOCORRECT",
            489: "POST.DOCUMENT",
            491: "PICKLIST",
            493: "VIEW.SHOW",
            494: "VIEW.DEFINE",
            495: "VIEW.DELETE",
            509: "SHEET.BACKGROUND",
            510: "INSERT.MAP.OBJECT",
            511: "OPTIONS.MENONO",
            517: "MSOCHECKS",
            518: "NORMAL",
            519: "LAYOUT",
            520: "RM.PRINT.AREA",
            521: "CLEAR.PRINT.AREA",
            522: "ADD.PRINT.AREA",
            523: "MOVE.BRK",
            545: "HIDECURR.NOTE",
            546: "HIDEALL.NOTES",
            547: "DELETE.NOTE",
            548: "TRAVERSE.NOTES",
            549: "ACTIVATE.NOTES",
            620: "PROTECT.REVISIONS",
            621: "UNPROTECT.REVISIONS",
            647: "OPTIONS.ME",
            653: "WEB.PUBLISH",
            667: "NEWWEBQUERY",
            673: "PIVOT.TABLE.CHART",
            753: "OPTIONS.SAVE",
            755: "OPTIONS.SPELL",
            808: "HIDEALL.INKANNOTS"
          },
          Yb = {
            0: "COUNT",
            1: "IF",
            2: "ISNA",
            3: "ISERROR",
            4: "SUM",
            5: "AVERAGE",
            6: "MIN",
            7: "MAX",
            8: "ROW",
            9: "COLUMN",
            10: "NA",
            11: "NPV",
            12: "STDEV",
            13: "DOLLAR",
            14: "FIXED",
            15: "SIN",
            16: "COS",
            17: "TAN",
            18: "ATAN",
            19: "PI",
            20: "SQRT",
            21: "EXP",
            22: "LN",
            23: "LOG10",
            24: "ABS",
            25: "INT",
            26: "SIGN",
            27: "ROUND",
            28: "LOOKUP",
            29: "INDEX",
            30: "REPT",
            31: "MID",
            32: "LEN",
            33: "VALUE",
            34: "TRUE",
            35: "FALSE",
            36: "AND",
            37: "OR",
            38: "NOT",
            39: "MOD",
            40: "DCOUNT",
            41: "DSUM",
            42: "DAVERAGE",
            43: "DMIN",
            44: "DMAX",
            45: "DSTDEV",
            46: "VAR",
            47: "DVAR",
            48: "TEXT",
            49: "LINEST",
            50: "TREND",
            51: "LOGEST",
            52: "GROWTH",
            53: "GOTO",
            54: "HALT",
            55: "RETURN",
            56: "PV",
            57: "FV",
            58: "NPER",
            59: "PMT",
            60: "RATE",
            61: "MIRR",
            62: "IRR",
            63: "RAND",
            64: "MATCH",
            65: "DATE",
            66: "TIME",
            67: "DAY",
            68: "MONTH",
            69: "YEAR",
            70: "WEEKDAY",
            71: "HOUR",
            72: "MINUTE",
            73: "SECOND",
            74: "NOW",
            75: "AREAS",
            76: "ROWS",
            77: "COLUMNS",
            78: "OFFSET",
            79: "ABSREF",
            80: "RELREF",
            81: "ARGUMENT",
            82: "SEARCH",
            83: "TRANSPOSE",
            84: "ERROR",
            85: "STEP",
            86: "TYPE",
            87: "ECHO",
            88: "SET.NAME",
            89: "CALLER",
            90: "DEREF",
            91: "WINDOWS",
            92: "SERIES",
            93: "DOCUMENTS",
            94: "ACTIVE.CELL",
            95: "SELECTION",
            96: "RESULT",
            97: "ATAN2",
            98: "ASIN",
            99: "ACOS",
            100: "CHOOSE",
            101: "HLOOKUP",
            102: "VLOOKUP",
            103: "LINKS",
            104: "INPUT",
            105: "ISREF",
            106: "GET.FORMULA",
            107: "GET.NAME",
            108: "SET.VALUE",
            109: "LOG",
            110: "EXEC",
            111: "CHAR",
            112: "LOWER",
            113: "UPPER",
            114: "PROPER",
            115: "LEFT",
            116: "RIGHT",
            117: "EXACT",
            118: "TRIM",
            119: "REPLACE",
            120: "SUBSTITUTE",
            121: "CODE",
            122: "NAMES",
            123: "DIRECTORY",
            124: "FIND",
            125: "CELL",
            126: "ISERR",
            127: "ISTEXT",
            128: "ISNUMBER",
            129: "ISBLANK",
            130: "T",
            131: "N",
            132: "FOPEN",
            133: "FCLOSE",
            134: "FSIZE",
            135: "FREADLN",
            136: "FREAD",
            137: "FWRITELN",
            138: "FWRITE",
            139: "FPOS",
            140: "DATEVALUE",
            141: "TIMEVALUE",
            142: "SLN",
            143: "SYD",
            144: "DDB",
            145: "GET.DEF",
            146: "REFTEXT",
            147: "TEXTREF",
            148: "INDIRECT",
            149: "REGISTER",
            150: "CALL",
            151: "ADD.BAR",
            152: "ADD.MENU",
            153: "ADD.COMMAND",
            154: "ENABLE.COMMAND",
            155: "CHECK.COMMAND",
            156: "RENAME.COMMAND",
            157: "SHOW.BAR",
            158: "DELETE.MENU",
            159: "DELETE.COMMAND",
            160: "GET.CHART.ITEM",
            161: "DIALOG.BOX",
            162: "CLEAN",
            163: "MDETERM",
            164: "MINVERSE",
            165: "MMULT",
            166: "FILES",
            167: "IPMT",
            168: "PPMT",
            169: "COUNTA",
            170: "CANCEL.KEY",
            171: "FOR",
            172: "WHILE",
            173: "BREAK",
            174: "NEXT",
            175: "INITIATE",
            176: "REQUEST",
            177: "POKE",
            178: "EXECUTE",
            179: "TERMINATE",
            180: "RESTART",
            181: "HELP",
            182: "GET.BAR",
            183: "PRODUCT",
            184: "FACT",
            185: "GET.CELL",
            186: "GET.WORKSPACE",
            187: "GET.WINDOW",
            188: "GET.DOCUMENT",
            189: "DPRODUCT",
            190: "ISNONTEXT",
            191: "GET.NOTE",
            192: "NOTE",
            193: "STDEVP",
            194: "VARP",
            195: "DSTDEVP",
            196: "DVARP",
            197: "TRUNC",
            198: "ISLOGICAL",
            199: "DCOUNTA",
            200: "DELETE.BAR",
            201: "UNREGISTER",
            204: "USDOLLAR",
            205: "FINDB",
            206: "SEARCHB",
            207: "REPLACEB",
            208: "LEFTB",
            209: "RIGHTB",
            210: "MIDB",
            211: "LENB",
            212: "ROUNDUP",
            213: "ROUNDDOWN",
            214: "ASC",
            215: "DBCS",
            216: "RANK",
            219: "ADDRESS",
            220: "DAYS360",
            221: "TODAY",
            222: "VDB",
            223: "ELSE",
            224: "ELSE.IF",
            225: "END.IF",
            226: "FOR.CELL",
            227: "MEDIAN",
            228: "SUMPRODUCT",
            229: "SINH",
            230: "COSH",
            231: "TANH",
            232: "ASINH",
            233: "ACOSH",
            234: "ATANH",
            235: "DGET",
            236: "CREATE.OBJECT",
            237: "VOLATILE",
            238: "LAST.ERROR",
            239: "CUSTOM.UNDO",
            240: "CUSTOM.REPEAT",
            241: "FORMULA.CONVERT",
            242: "GET.LINK.INFO",
            243: "TEXT.BOX",
            244: "INFO",
            245: "GROUP",
            246: "GET.OBJECT",
            247: "DB",
            248: "PAUSE",
            251: "RESUME",
            252: "FREQUENCY",
            253: "ADD.TOOLBAR",
            254: "DELETE.TOOLBAR",
            255: "User",
            256: "RESET.TOOLBAR",
            257: "EVALUATE",
            258: "GET.TOOLBAR",
            259: "GET.TOOL",
            260: "SPELLING.CHECK",
            261: "ERROR.TYPE",
            262: "APP.TITLE",
            263: "WINDOW.TITLE",
            264: "SAVE.TOOLBAR",
            265: "ENABLE.TOOL",
            266: "PRESS.TOOL",
            267: "REGISTER.ID",
            268: "GET.WORKBOOK",
            269: "AVEDEV",
            270: "BETADIST",
            271: "GAMMALN",
            272: "BETAINV",
            273: "BINOMDIST",
            274: "CHIDIST",
            275: "CHIINV",
            276: "COMBIN",
            277: "CONFIDENCE",
            278: "CRITBINOM",
            279: "EVEN",
            280: "EXPONDIST",
            281: "FDIST",
            282: "FINV",
            283: "FISHER",
            284: "FISHERINV",
            285: "FLOOR",
            286: "GAMMADIST",
            287: "GAMMAINV",
            288: "CEILING",
            289: "HYPGEOMDIST",
            290: "LOGNORMDIST",
            291: "LOGINV",
            292: "NEGBINOMDIST",
            293: "NORMDIST",
            294: "NORMSDIST",
            295: "NORMINV",
            296: "NORMSINV",
            297: "STANDARDIZE",
            298: "ODD",
            299: "PERMUT",
            300: "POISSON",
            301: "TDIST",
            302: "WEIBULL",
            303: "SUMXMY2",
            304: "SUMX2MY2",
            305: "SUMX2PY2",
            306: "CHITEST",
            307: "CORREL",
            308: "COVAR",
            309: "FORECAST",
            310: "FTEST",
            311: "INTERCEPT",
            312: "PEARSON",
            313: "RSQ",
            314: "STEYX",
            315: "SLOPE",
            316: "TTEST",
            317: "PROB",
            318: "DEVSQ",
            319: "GEOMEAN",
            320: "HARMEAN",
            321: "SUMSQ",
            322: "KURT",
            323: "SKEW",
            324: "ZTEST",
            325: "LARGE",
            326: "SMALL",
            327: "QUARTILE",
            328: "PERCENTILE",
            329: "PERCENTRANK",
            330: "MODE",
            331: "TRIMMEAN",
            332: "TINV",
            334: "MOVIE.COMMAND",
            335: "GET.MOVIE",
            336: "CONCATENATE",
            337: "POWER",
            338: "PIVOT.ADD.DATA",
            339: "GET.PIVOT.TABLE",
            340: "GET.PIVOT.FIELD",
            341: "GET.PIVOT.ITEM",
            342: "RADIANS",
            343: "DEGREES",
            344: "SUBTOTAL",
            345: "SUMIF",
            346: "COUNTIF",
            347: "COUNTBLANK",
            348: "SCENARIO.GET",
            349: "OPTIONS.LISTS.GET",
            350: "ISPMT",
            351: "DATEDIF",
            352: "DATESTRING",
            353: "NUMBERSTRING",
            354: "ROMAN",
            355: "OPEN.DIALOG",
            356: "SAVE.DIALOG",
            357: "VIEW.GET",
            358: "GETPIVOTDATA",
            359: "HYPERLINK",
            360: "PHONETIC",
            361: "AVERAGEA",
            362: "MAXA",
            363: "MINA",
            364: "STDEVPA",
            365: "VARPA",
            366: "STDEVA",
            367: "VARA",
            368: "BAHTTEXT",
            369: "THAIDAYOFWEEK",
            370: "THAIDIGIT",
            371: "THAIMONTHOFYEAR",
            372: "THAINUMSOUND",
            373: "THAINUMSTRING",
            374: "THAISTRINGLENGTH",
            375: "ISTHAIDIGIT",
            376: "ROUNDBAHTDOWN",
            377: "ROUNDBAHTUP",
            378: "THAIYEAR",
            379: "RTD",
            380: "CUBEVALUE",
            381: "CUBEMEMBER",
            382: "CUBEMEMBERPROPERTY",
            383: "CUBERANKEDMEMBER",
            384: "HEX2BIN",
            385: "HEX2DEC",
            386: "HEX2OCT",
            387: "DEC2BIN",
            388: "DEC2HEX",
            389: "DEC2OCT",
            390: "OCT2BIN",
            391: "OCT2HEX",
            392: "OCT2DEC",
            393: "BIN2DEC",
            394: "BIN2OCT",
            395: "BIN2HEX",
            396: "IMSUB",
            397: "IMDIV",
            398: "IMPOWER",
            399: "IMABS",
            400: "IMSQRT",
            401: "IMLN",
            402: "IMLOG2",
            403: "IMLOG10",
            404: "IMSIN",
            405: "IMCOS",
            406: "IMEXP",
            407: "IMARGUMENT",
            408: "IMCONJUGATE",
            409: "IMAGINARY",
            410: "IMREAL",
            411: "COMPLEX",
            412: "IMSUM",
            413: "IMPRODUCT",
            414: "SERIESSUM",
            415: "FACTDOUBLE",
            416: "SQRTPI",
            417: "QUOTIENT",
            418: "DELTA",
            419: "GESTEP",
            420: "ISEVEN",
            421: "ISODD",
            422: "MROUND",
            423: "ERF",
            424: "ERFC",
            425: "BESSELJ",
            426: "BESSELK",
            427: "BESSELY",
            428: "BESSELI",
            429: "XIRR",
            430: "XNPV",
            431: "PRICEMAT",
            432: "YIELDMAT",
            433: "INTRATE",
            434: "RECEIVED",
            435: "DISC",
            436: "PRICEDISC",
            437: "YIELDDISC",
            438: "TBILLEQ",
            439: "TBILLPRICE",
            440: "TBILLYIELD",
            441: "PRICE",
            442: "YIELD",
            443: "DOLLARDE",
            444: "DOLLARFR",
            445: "NOMINAL",
            446: "EFFECT",
            447: "CUMPRINC",
            448: "CUMIPMT",
            449: "EDATE",
            450: "EOMONTH",
            451: "YEARFRAC",
            452: "COUPDAYBS",
            453: "COUPDAYS",
            454: "COUPDAYSNC",
            455: "COUPNCD",
            456: "COUPNUM",
            457: "COUPPCD",
            458: "DURATION",
            459: "MDURATION",
            460: "ODDLPRICE",
            461: "ODDLYIELD",
            462: "ODDFPRICE",
            463: "ODDFYIELD",
            464: "RANDBETWEEN",
            465: "WEEKNUM",
            466: "AMORDEGRC",
            467: "AMORLINC",
            468: "CONVERT",
            724: "SHEETJS",
            469: "ACCRINT",
            470: "ACCRINTM",
            471: "WORKDAY",
            472: "NETWORKDAYS",
            473: "GCD",
            474: "MULTINOMIAL",
            475: "LCM",
            476: "FVSCHEDULE",
            477: "CUBEKPIMEMBER",
            478: "CUBESET",
            479: "CUBESETCOUNT",
            480: "IFERROR",
            481: "COUNTIFS",
            482: "SUMIFS",
            483: "AVERAGEIF",
            484: "AVERAGEIFS"
          },
          Kb = {
            2: 1,
            3: 1,
            15: 1,
            16: 1,
            17: 1,
            18: 1,
            19: 0,
            20: 1,
            21: 1,
            22: 1,
            23: 1,
            24: 1,
            25: 1,
            26: 1,
            27: 2,
            30: 2,
            31: 3,
            32: 1,
            33: 1,
            38: 1,
            39: 2,
            40: 3,
            41: 3,
            42: 3,
            43: 3,
            44: 3,
            45: 3,
            47: 3,
            48: 2,
            53: 1,
            61: 3,
            65: 3,
            66: 3,
            67: 1,
            68: 1,
            69: 1,
            70: 1,
            71: 1,
            72: 1,
            73: 1,
            75: 1,
            76: 1,
            77: 1,
            79: 2,
            80: 2,
            83: 1,
            85: 0,
            86: 1,
            90: 1,
            97: 2,
            98: 1,
            99: 1,
            101: 3,
            102: 3,
            105: 1,
            111: 1,
            112: 1,
            113: 1,
            114: 1,
            117: 2,
            118: 1,
            119: 4,
            121: 1,
            126: 1,
            127: 1,
            128: 1,
            129: 1,
            130: 1,
            131: 1,
            133: 1,
            134: 1,
            135: 1,
            136: 2,
            137: 2,
            138: 2,
            140: 1,
            141: 1,
            142: 3,
            143: 4,
            144: 4,
            162: 1,
            163: 1,
            164: 1,
            165: 2,
            172: 1,
            175: 2,
            176: 2,
            177: 3,
            178: 2,
            179: 1,
            184: 1,
            189: 3,
            190: 1,
            195: 3,
            196: 3,
            197: 1,
            198: 1,
            199: 3,
            201: 1,
            207: 4,
            210: 3,
            211: 1,
            212: 2,
            213: 2,
            214: 1,
            215: 1,
            229: 1,
            230: 1,
            231: 1,
            232: 1,
            233: 1,
            234: 1,
            235: 3,
            244: 1,
            247: 4,
            252: 2,
            257: 1,
            261: 1,
            271: 1,
            273: 4,
            274: 2,
            275: 2,
            276: 2,
            277: 3,
            278: 3,
            279: 1,
            280: 3,
            281: 3,
            282: 3,
            283: 1,
            284: 1,
            285: 2,
            286: 4,
            287: 3,
            288: 2,
            289: 4,
            290: 3,
            291: 3,
            292: 3,
            293: 4,
            294: 1,
            295: 3,
            296: 1,
            297: 3,
            298: 1,
            299: 2,
            300: 3,
            301: 3,
            302: 4,
            303: 2,
            304: 2,
            305: 2,
            306: 2,
            307: 2,
            308: 2,
            309: 3,
            310: 2,
            311: 2,
            312: 2,
            313: 2,
            314: 2,
            315: 2,
            316: 4,
            325: 2,
            326: 2,
            327: 2,
            328: 2,
            331: 2,
            332: 2,
            337: 2,
            342: 1,
            343: 1,
            346: 2,
            347: 1,
            350: 4,
            351: 3,
            352: 1,
            353: 2,
            360: 1,
            368: 1,
            369: 1,
            370: 1,
            371: 1,
            372: 1,
            373: 1,
            374: 1,
            375: 1,
            376: 1,
            377: 1,
            378: 1,
            382: 3,
            385: 1,
            392: 1,
            393: 1,
            396: 2,
            397: 2,
            398: 2,
            399: 1,
            400: 1,
            401: 1,
            402: 1,
            403: 1,
            404: 1,
            405: 1,
            406: 1,
            407: 1,
            408: 1,
            409: 1,
            410: 1,
            414: 4,
            415: 1,
            416: 1,
            417: 2,
            420: 1,
            421: 1,
            422: 2,
            424: 1,
            425: 2,
            426: 2,
            427: 2,
            428: 2,
            430: 3,
            438: 3,
            439: 3,
            440: 3,
            443: 2,
            444: 2,
            445: 2,
            446: 2,
            447: 6,
            448: 6,
            449: 2,
            450: 2,
            464: 2,
            468: 3,
            476: 2,
            479: 1,
            480: 2,
            65535: 0
          },
          Zb = {
            "_xlfn.ACOT": "ACOT",
            "_xlfn.ACOTH": "ACOTH",
            "_xlfn.AGGREGATE": "AGGREGATE",
            "_xlfn.ARABIC": "ARABIC",
            "_xlfn.AVERAGEIF": "AVERAGEIF",
            "_xlfn.AVERAGEIFS": "AVERAGEIFS",
            "_xlfn.BASE": "BASE",
            "_xlfn.BETA.DIST": "BETA.DIST",
            "_xlfn.BETA.INV": "BETA.INV",
            "_xlfn.BINOM.DIST": "BINOM.DIST",
            "_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
            "_xlfn.BINOM.INV": "BINOM.INV",
            "_xlfn.BITAND": "BITAND",
            "_xlfn.BITLSHIFT": "BITLSHIFT",
            "_xlfn.BITOR": "BITOR",
            "_xlfn.BITRSHIFT": "BITRSHIFT",
            "_xlfn.BITXOR": "BITXOR",
            "_xlfn.CEILING.MATH": "CEILING.MATH",
            "_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
            "_xlfn.CHISQ.DIST": "CHISQ.DIST",
            "_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
            "_xlfn.CHISQ.INV": "CHISQ.INV",
            "_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
            "_xlfn.CHISQ.TEST": "CHISQ.TEST",
            "_xlfn.COMBINA": "COMBINA",
            "_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
            "_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
            "_xlfn.COT": "COT",
            "_xlfn.COTH": "COTH",
            "_xlfn.COUNTIFS": "COUNTIFS",
            "_xlfn.COVARIANCE.P": "COVARIANCE.P",
            "_xlfn.COVARIANCE.S": "COVARIANCE.S",
            "_xlfn.CSC": "CSC",
            "_xlfn.CSCH": "CSCH",
            "_xlfn.DAYS": "DAYS",
            "_xlfn.DECIMAL": "DECIMAL",
            "_xlfn.ECMA.CEILING": "ECMA.CEILING",
            "_xlfn.ERF.PRECISE": "ERF.PRECISE",
            "_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
            "_xlfn.EXPON.DIST": "EXPON.DIST",
            "_xlfn.F.DIST": "F.DIST",
            "_xlfn.F.DIST.RT": "F.DIST.RT",
            "_xlfn.F.INV": "F.INV",
            "_xlfn.F.INV.RT": "F.INV.RT",
            "_xlfn.F.TEST": "F.TEST",
            "_xlfn.FILTERXML": "FILTERXML",
            "_xlfn.FLOOR.MATH": "FLOOR.MATH",
            "_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
            "_xlfn.FORMULATEXT": "FORMULATEXT",
            "_xlfn.GAMMA": "GAMMA",
            "_xlfn.GAMMA.DIST": "GAMMA.DIST",
            "_xlfn.GAMMA.INV": "GAMMA.INV",
            "_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
            "_xlfn.GAUSS": "GAUSS",
            "_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
            "_xlfn.IFNA": "IFNA",
            "_xlfn.IFERROR": "IFERROR",
            "_xlfn.IMCOSH": "IMCOSH",
            "_xlfn.IMCOT": "IMCOT",
            "_xlfn.IMCSC": "IMCSC",
            "_xlfn.IMCSCH": "IMCSCH",
            "_xlfn.IMSEC": "IMSEC",
            "_xlfn.IMSECH": "IMSECH",
            "_xlfn.IMSINH": "IMSINH",
            "_xlfn.IMTAN": "IMTAN",
            "_xlfn.ISFORMULA": "ISFORMULA",
            "_xlfn.ISO.CEILING": "ISO.CEILING",
            "_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
            "_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
            "_xlfn.LOGNORM.INV": "LOGNORM.INV",
            "_xlfn.MODE.MULT": "MODE.MULT",
            "_xlfn.MODE.SNGL": "MODE.SNGL",
            "_xlfn.MUNIT": "MUNIT",
            "_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
            "_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
            "_xlfn.NIGBINOM": "NIGBINOM",
            "_xlfn.NORM.DIST": "NORM.DIST",
            "_xlfn.NORM.INV": "NORM.INV",
            "_xlfn.NORM.S.DIST": "NORM.S.DIST",
            "_xlfn.NORM.S.INV": "NORM.S.INV",
            "_xlfn.NUMBERVALUE": "NUMBERVALUE",
            "_xlfn.PDURATION": "PDURATION",
            "_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
            "_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
            "_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
            "_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
            "_xlfn.PERMUTATIONA": "PERMUTATIONA",
            "_xlfn.PHI": "PHI",
            "_xlfn.POISSON.DIST": "POISSON.DIST",
            "_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
            "_xlfn.QUARTILE.INC": "QUARTILE.INC",
            "_xlfn.QUERYSTRING": "QUERYSTRING",
            "_xlfn.RANK.AVG": "RANK.AVG",
            "_xlfn.RANK.EQ": "RANK.EQ",
            "_xlfn.RRI": "RRI",
            "_xlfn.SEC": "SEC",
            "_xlfn.SECH": "SECH",
            "_xlfn.SHEET": "SHEET",
            "_xlfn.SHEETS": "SHEETS",
            "_xlfn.SKEW.P": "SKEW.P",
            "_xlfn.STDEV.P": "STDEV.P",
            "_xlfn.STDEV.S": "STDEV.S",
            "_xlfn.SUMIFS": "SUMIFS",
            "_xlfn.T.DIST": "T.DIST",
            "_xlfn.T.DIST.2T": "T.DIST.2T",
            "_xlfn.T.DIST.RT": "T.DIST.RT",
            "_xlfn.T.INV": "T.INV",
            "_xlfn.T.INV.2T": "T.INV.2T",
            "_xlfn.T.TEST": "T.TEST",
            "_xlfn.UNICHAR": "UNICHAR",
            "_xlfn.UNICODE": "UNICODE",
            "_xlfn.VAR.P": "VAR.P",
            "_xlfn.VAR.S": "VAR.S",
            "_xlfn.WEBSERVICE": "WEBSERVICE",
            "_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
            "_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
            "_xlfn.XOR": "XOR",
            "_xlfn.Z.TEST": "Z.TEST"
          },
          Jb = {},
          Qb = {};
        bh.WS = ["http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet", "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"];
        var $b = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g,
          ey = /<(?:\w+:)?sheetData>([\s\S]*)<\/(?:\w+:)?sheetData>/,
          ty = /<(?:\w:)?hyperlink [^>]*>/gm,
          ry = /"(\w*:\w*)"/,
          ny = /<(?:\w:)?col[^>]*[\/]?>/g,
          iy = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g,
          ay = /<(?:\w:)?pageMargins[^>]*\/>/g,
          oy = function () {
            var e = /<(?:\w+:)?c[ >]/,
              t = /<\/(?:\w+:)?row>/,
              r = /r=["']([^"']*)["']/,
              n = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/,
              i = /ref=["']([^"']*)["']/,
              a = hu("v"),
              o = hu("f");
            return function (s, l, c, u, h, f) {
              for (var d, p, m, g, v, w = 0, _ = "", S = [], C = [], E = 0, A = 0, T = 0, k = "", R = 0, I = 0, M = 0, O = 0, P = Array.isArray(f.CellXf), B = [], L = [], F = Array.isArray(l), N = [], z = {}, H = !1, G = s.split(t), V = 0, q = G.length; V != q; ++V) {
                _ = G[V].trim();
                var W = _.length;
                if (0 !== W) {
                  for (w = 0; w < W && 62 !== _.charCodeAt(w); ++w);
                  if (++w, p = D(_.substr(0, w), !0), R = null != p.r ? parseInt(p.r, 10) : R + 1, I = -1, !(c.sheetRows && c.sheetRows < R)) for (u.s.r > R - 1 && (u.s.r = R - 1), u.e.r < R - 1 && (u.e.r = R - 1), c && c.cellStyles && (z = {}, H = !1, p.ht && (H = !0, z.hpt = parseFloat(p.ht), z.hpx = Wn(z.hpt)), "1" == p.hidden && (H = !0, z.hidden = !0), null != p.outlineLevel && (H = !0, z.level = +p.outlineLevel), H && (N[R - 1] = z)), S = _.substr(w).split(e), w = 0; w != S.length; ++w) if (_ = S[w].trim(), 0 !== _.length) {
                    if (C = _.match(r), E = w, A = 0, T = 0, _ = "<c " + ("<" == _.substr(0, 1) ? ">" : "") + _, null != C && 2 === C.length) {
                      for (E = 0, k = C[1], A = 0; A != k.length && !((T = k.charCodeAt(A) - 64) < 1 || T > 26); ++A) E = 26 * E + T;
                      --E, I = E;
                    } else ++I;
                    for (A = 0; A != _.length && 62 !== _.charCodeAt(A); ++A);
                    if (++A, p = D(_.substr(0, A), !0), p.r || (p.r = be({
                      r: R - 1,
                      c: I
                    })), k = _.substr(A), d = {
                      t: ""
                    }, null != (C = k.match(a)) && "" !== C[1] && (d.v = tu(C[1])), c.cellFormula) {
                      null != (C = k.match(o)) && "" !== C[1] ? (d.f = tu(su(C[1])).replace(/_xlfn\./, ""), C[0].indexOf('t="array"') > -1 ? (d.F = (k.match(i) || [])[1], d.F.indexOf(":") > -1 && B.push([xe(d.F), d.F])) : C[0].indexOf('t="shared"') > -1 && (g = D(C[0]), L[parseInt(g.si, 10)] = [g, tu(su(C[1]))])) : (C = k.match(/<f[^>]*\/>/)) && (g = D(C[0]), L[g.si] && (d.f = na(L[g.si][1], L[g.si][0].ref, p.r)));
                      var X = ve(p.r);
                      for (A = 0; A < B.length; ++A) X.r >= B[A][0].s.r && X.r <= B[A][0].e.r && X.c >= B[A][0].s.c && X.c <= B[A][0].e.c && (d.F = B[A][1]);
                    }
                    if (null == p.t && void 0 === d.v) {
                      if (d.f || d.F) d.v = 0, d.t = "n";else {
                        if (!c.sheetStubs) continue;
                        d.t = "z";
                      }
                    } else d.t = p.t || "n";
                    switch (u.s.c > E && (u.s.c = E), u.e.c < E && (u.e.c = E), d.t) {
                      case "n":
                        d.v = parseFloat(d.v);
                        break;
                      case "s":
                        if (void 0 === d.v) {
                          if (!c.sheetStubs) continue;
                          d.t = "z";
                        } else m = Jb[parseInt(d.v, 10)], d.v = m.t, d.r = m.r, c.cellHTML && (d.h = m.h);
                        break;
                      case "str":
                        d.t = "s", d.v = null != d.v ? su(d.v) : "", c.cellHTML && (d.h = U(d.v));
                        break;
                      case "inlineStr":
                        C = k.match(n), d.t = "s", null != C && (m = sn(C[1])) ? d.v = m.t : d.v = "";
                        break;
                      case "b":
                        d.v = j(d.v);
                        break;
                      case "d":
                        c.cellDates ? d.v = x(d.v, 1) : (d.v = b(x(d.v, 1)), d.t = "n");
                        break;
                      case "e":
                        c && !1 === c.cellText || (d.w = d.v), d.v = th[d.v];
                    }
                    if (M = O = 0, P && void 0 !== p.s && null != (v = f.CellXf[p.s]) && (null != v.numFmtId && (M = v.numFmtId), c.cellStyles && null != v.fillId && (O = v.fillId)), vo(d, M, O, c, h, f), c.cellDates && P && "n" == d.t && Nc.is_date(Nc._table[M]) && (d.t = "d", d.v = y(d.v)), F) {
                      var Y = ve(p.r);
                      l[Y.r] || (l[Y.r] = []), l[Y.r][Y.c] = d;
                    } else l[p.r] = d;
                  }
                }
              }
              N.length > 0 && (l["!rows"] = N);
            };
          }(),
          sy = V("worksheet", null, {
            xmlns: vu.main[0],
            "xmlns:r": vu.r
          }),
          ly = Qu,
          cy = $u,
          uy = Qu,
          hy = $u;
        bh.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
        var fy = (V("chartsheet", null, {
            xmlns: vu.main[0],
            "xmlns:r": vu.r
          }), [["allowRefreshQuery", !1, "bool"], ["autoCompressPictures", !0, "bool"], ["backupFile", !1, "bool"], ["checkCompatibility", !1, "bool"], ["codeName", ""], ["date1904", !1, "bool"], ["defaultThemeVersion", 0, "int"], ["filterPrivacy", !1, "bool"], ["hidePivotFieldList", !1, "bool"], ["promptedSolutions", !1, "bool"], ["publishItems", !1, "bool"], ["refreshAllConnections", !1, "bool"], ["saveExternalLinkValues", !0, "bool"], ["showBorderUnselectedTables", !0, "bool"], ["showInkAnnotation", !0, "bool"], ["showObjects", "all"], ["showPivotChartFilter", !1, "bool"], ["updateLinks", "userSet"]]),
          dy = [["activeTab", 0, "int"], ["autoFilterDateGrouping", !0, "bool"], ["firstSheet", 0, "int"], ["minimized", !1, "bool"], ["showHorizontalScroll", !0, "bool"], ["showSheetTabs", !0, "bool"], ["showVerticalScroll", !0, "bool"], ["tabRatio", 600, "int"], ["visibility", "visible"]],
          py = [],
          my = [["calcCompleted", "true"], ["calcMode", "auto"], ["calcOnSave", "true"], ["concurrentCalc", "true"], ["fullCalcOnLoad", "false"], ["fullPrecision", "true"], ["iterate", "false"], ["iterateCount", "100"], ["iterateDelta", "0.001"], ["refMode", "A1"]],
          gy = "][*?/\\".split(""),
          vy = /<\w+:workbook/,
          by = V("workbook", null, {
            xmlns: vu.main[0],
            "xmlns:r": vu.r
          }),
          yy = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g,
          wy = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/,
          xy = function xy(e) {
            return String.fromCharCode(e);
          },
          _y = /<(\/?)([^\s?>!\/:]*:|)([^\s?>]*[^\s?>\/])[^>]*>/gm,
          Sy = {
            0: {
              n: "BrtRowHdr",
              f: Po
            },
            1: {
              n: "BrtCellBlank",
              f: Uo
            },
            2: {
              n: "BrtCellRk",
              f: Yo
            },
            3: {
              n: "BrtCellError",
              f: Go
            },
            4: {
              n: "BrtCellBool",
              f: zo
            },
            5: {
              n: "BrtCellReal",
              f: Wo
            },
            6: {
              n: "BrtCellSt",
              f: Zo
            },
            7: {
              n: "BrtCellIsst",
              f: Vo
            },
            8: {
              n: "BrtFmlaString",
              f: ts
            },
            9: {
              n: "BrtFmlaNum",
              f: es
            },
            10: {
              n: "BrtFmlaBool",
              f: Qo
            },
            11: {
              n: "BrtFmlaError",
              f: $o
            },
            16: {
              n: "BrtFRTArchID$",
              f: js
            },
            19: {
              n: "BrtSSTItem",
              f: Me
            },
            20: {
              n: "BrtPCDIMissing",
              f: $
            },
            21: {
              n: "BrtPCDINumber",
              f: $
            },
            22: {
              n: "BrtPCDIBoolean",
              f: $
            },
            23: {
              n: "BrtPCDIError",
              f: $
            },
            24: {
              n: "BrtPCDIString",
              f: $
            },
            25: {
              n: "BrtPCDIDatetime",
              f: $
            },
            26: {
              n: "BrtPCDIIndex",
              f: $
            },
            27: {
              n: "BrtPCDIAMissing",
              f: $
            },
            28: {
              n: "BrtPCDIANumber",
              f: $
            },
            29: {
              n: "BrtPCDIABoolean",
              f: $
            },
            30: {
              n: "BrtPCDIAError",
              f: $
            },
            31: {
              n: "BrtPCDIAString",
              f: $
            },
            32: {
              n: "BrtPCDIADatetime",
              f: $
            },
            33: {
              n: "BrtPCRRecord",
              f: $
            },
            34: {
              n: "BrtPCRRecordDt",
              f: $
            },
            35: {
              n: "BrtFRTBegin",
              f: $
            },
            36: {
              n: "BrtFRTEnd",
              f: $
            },
            37: {
              n: "BrtACBegin",
              f: $
            },
            38: {
              n: "BrtACEnd",
              f: $
            },
            39: {
              n: "BrtName",
              f: zs
            },
            40: {
              n: "BrtIndexRowBlock",
              f: $
            },
            42: {
              n: "BrtIndexBlock",
              f: $
            },
            43: {
              n: "BrtFont",
              f: ni
            },
            44: {
              n: "BrtFmt",
              f: ti
            },
            45: {
              n: "BrtFill",
              f: $
            },
            46: {
              n: "BrtBorder",
              f: $
            },
            47: {
              n: "BrtXF",
              f: oi
            },
            48: {
              n: "BrtStyle",
              f: $
            },
            49: {
              n: "BrtCellMeta",
              f: $
            },
            50: {
              n: "BrtValueMeta",
              f: $
            },
            51: {
              n: "BrtMdb",
              f: $
            },
            52: {
              n: "BrtBeginFmd",
              f: $
            },
            53: {
              n: "BrtEndFmd",
              f: $
            },
            54: {
              n: "BrtBeginMdx",
              f: $
            },
            55: {
              n: "BrtEndMdx",
              f: $
            },
            56: {
              n: "BrtBeginMdxTuple",
              f: $
            },
            57: {
              n: "BrtEndMdxTuple",
              f: $
            },
            58: {
              n: "BrtMdxMbrIstr",
              f: $
            },
            59: {
              n: "BrtStr",
              f: $
            },
            60: {
              n: "BrtColInfo",
              f: Kr
            },
            62: {
              n: "BrtCellRString",
              f: $
            },
            63: {
              n: "BrtCalcChainItem$",
              f: Ui
            },
            64: {
              n: "BrtDVal",
              f: $
            },
            65: {
              n: "BrtSxvcellNum",
              f: $
            },
            66: {
              n: "BrtSxvcellStr",
              f: $
            },
            67: {
              n: "BrtSxvcellBool",
              f: $
            },
            68: {
              n: "BrtSxvcellErr",
              f: $
            },
            69: {
              n: "BrtSxvcellDate",
              f: $
            },
            70: {
              n: "BrtSxvcellNil",
              f: $
            },
            128: {
              n: "BrtFileVersion",
              f: $
            },
            129: {
              n: "BrtBeginSheet",
              f: $
            },
            130: {
              n: "BrtEndSheet",
              f: $
            },
            131: {
              n: "BrtBeginBook",
              f: $,
              p: 0
            },
            132: {
              n: "BrtEndBook",
              f: $
            },
            133: {
              n: "BrtBeginWsViews",
              f: $
            },
            134: {
              n: "BrtEndWsViews",
              f: $
            },
            135: {
              n: "BrtBeginBookViews",
              f: $
            },
            136: {
              n: "BrtEndBookViews",
              f: $
            },
            137: {
              n: "BrtBeginWsView",
              f: $
            },
            138: {
              n: "BrtEndWsView",
              f: $
            },
            139: {
              n: "BrtBeginCsViews",
              f: $
            },
            140: {
              n: "BrtEndCsViews",
              f: $
            },
            141: {
              n: "BrtBeginCsView",
              f: $
            },
            142: {
              n: "BrtEndCsView",
              f: $
            },
            143: {
              n: "BrtBeginBundleShs",
              f: $
            },
            144: {
              n: "BrtEndBundleShs",
              f: $
            },
            145: {
              n: "BrtBeginSheetData",
              f: $
            },
            146: {
              n: "BrtEndSheetData",
              f: $
            },
            147: {
              n: "BrtWsProp",
              f: Fo
            },
            148: {
              n: "BrtWsDim",
              f: ly,
              p: 16
            },
            151: {
              n: "BrtPane",
              f: $
            },
            152: {
              n: "BrtSel",
              f: $
            },
            153: {
              n: "BrtWbProp",
              f: Ns
            },
            154: {
              n: "BrtWbFactoid",
              f: $
            },
            155: {
              n: "BrtFileRecover",
              f: $
            },
            156: {
              n: "BrtBundleSh",
              f: Ls
            },
            157: {
              n: "BrtCalcProp",
              f: $
            },
            158: {
              n: "BrtBookView",
              f: $
            },
            159: {
              n: "BrtBeginSst",
              f: un
            },
            160: {
              n: "BrtEndSst",
              f: $
            },
            161: {
              n: "BrtBeginAFilter",
              f: Qu
            },
            162: {
              n: "BrtEndAFilter",
              f: $
            },
            163: {
              n: "BrtBeginFilterColumn",
              f: $
            },
            164: {
              n: "BrtEndFilterColumn",
              f: $
            },
            165: {
              n: "BrtBeginFilters",
              f: $
            },
            166: {
              n: "BrtEndFilters",
              f: $
            },
            167: {
              n: "BrtFilter",
              f: $
            },
            168: {
              n: "BrtColorFilter",
              f: $
            },
            169: {
              n: "BrtIconFilter",
              f: $
            },
            170: {
              n: "BrtTop10Filter",
              f: $
            },
            171: {
              n: "BrtDynamicFilter",
              f: $
            },
            172: {
              n: "BrtBeginCustomFilters",
              f: $
            },
            173: {
              n: "BrtEndCustomFilters",
              f: $
            },
            174: {
              n: "BrtCustomFilter",
              f: $
            },
            175: {
              n: "BrtAFilterDateGroupItem",
              f: $
            },
            176: {
              n: "BrtMergeCell",
              f: uy
            },
            177: {
              n: "BrtBeginMergeCells",
              f: $
            },
            178: {
              n: "BrtEndMergeCells",
              f: $
            },
            179: {
              n: "BrtBeginPivotCacheDef",
              f: $
            },
            180: {
              n: "BrtEndPivotCacheDef",
              f: $
            },
            181: {
              n: "BrtBeginPCDFields",
              f: $
            },
            182: {
              n: "BrtEndPCDFields",
              f: $
            },
            183: {
              n: "BrtBeginPCDField",
              f: $
            },
            184: {
              n: "BrtEndPCDField",
              f: $
            },
            185: {
              n: "BrtBeginPCDSource",
              f: $
            },
            186: {
              n: "BrtEndPCDSource",
              f: $
            },
            187: {
              n: "BrtBeginPCDSRange",
              f: $
            },
            188: {
              n: "BrtEndPCDSRange",
              f: $
            },
            189: {
              n: "BrtBeginPCDFAtbl",
              f: $
            },
            190: {
              n: "BrtEndPCDFAtbl",
              f: $
            },
            191: {
              n: "BrtBeginPCDIRun",
              f: $
            },
            192: {
              n: "BrtEndPCDIRun",
              f: $
            },
            193: {
              n: "BrtBeginPivotCacheRecords",
              f: $
            },
            194: {
              n: "BrtEndPivotCacheRecords",
              f: $
            },
            195: {
              n: "BrtBeginPCDHierarchies",
              f: $
            },
            196: {
              n: "BrtEndPCDHierarchies",
              f: $
            },
            197: {
              n: "BrtBeginPCDHierarchy",
              f: $
            },
            198: {
              n: "BrtEndPCDHierarchy",
              f: $
            },
            199: {
              n: "BrtBeginPCDHFieldsUsage",
              f: $
            },
            200: {
              n: "BrtEndPCDHFieldsUsage",
              f: $
            },
            201: {
              n: "BrtBeginExtConnection",
              f: $
            },
            202: {
              n: "BrtEndExtConnection",
              f: $
            },
            203: {
              n: "BrtBeginECDbProps",
              f: $
            },
            204: {
              n: "BrtEndECDbProps",
              f: $
            },
            205: {
              n: "BrtBeginECOlapProps",
              f: $
            },
            206: {
              n: "BrtEndECOlapProps",
              f: $
            },
            207: {
              n: "BrtBeginPCDSConsol",
              f: $
            },
            208: {
              n: "BrtEndPCDSConsol",
              f: $
            },
            209: {
              n: "BrtBeginPCDSCPages",
              f: $
            },
            210: {
              n: "BrtEndPCDSCPages",
              f: $
            },
            211: {
              n: "BrtBeginPCDSCPage",
              f: $
            },
            212: {
              n: "BrtEndPCDSCPage",
              f: $
            },
            213: {
              n: "BrtBeginPCDSCPItem",
              f: $
            },
            214: {
              n: "BrtEndPCDSCPItem",
              f: $
            },
            215: {
              n: "BrtBeginPCDSCSets",
              f: $
            },
            216: {
              n: "BrtEndPCDSCSets",
              f: $
            },
            217: {
              n: "BrtBeginPCDSCSet",
              f: $
            },
            218: {
              n: "BrtEndPCDSCSet",
              f: $
            },
            219: {
              n: "BrtBeginPCDFGroup",
              f: $
            },
            220: {
              n: "BrtEndPCDFGroup",
              f: $
            },
            221: {
              n: "BrtBeginPCDFGItems",
              f: $
            },
            222: {
              n: "BrtEndPCDFGItems",
              f: $
            },
            223: {
              n: "BrtBeginPCDFGRange",
              f: $
            },
            224: {
              n: "BrtEndPCDFGRange",
              f: $
            },
            225: {
              n: "BrtBeginPCDFGDiscrete",
              f: $
            },
            226: {
              n: "BrtEndPCDFGDiscrete",
              f: $
            },
            227: {
              n: "BrtBeginPCDSDTupleCache",
              f: $
            },
            228: {
              n: "BrtEndPCDSDTupleCache",
              f: $
            },
            229: {
              n: "BrtBeginPCDSDTCEntries",
              f: $
            },
            230: {
              n: "BrtEndPCDSDTCEntries",
              f: $
            },
            231: {
              n: "BrtBeginPCDSDTCEMembers",
              f: $
            },
            232: {
              n: "BrtEndPCDSDTCEMembers",
              f: $
            },
            233: {
              n: "BrtBeginPCDSDTCEMember",
              f: $
            },
            234: {
              n: "BrtEndPCDSDTCEMember",
              f: $
            },
            235: {
              n: "BrtBeginPCDSDTCQueries",
              f: $
            },
            236: {
              n: "BrtEndPCDSDTCQueries",
              f: $
            },
            237: {
              n: "BrtBeginPCDSDTCQuery",
              f: $
            },
            238: {
              n: "BrtEndPCDSDTCQuery",
              f: $
            },
            239: {
              n: "BrtBeginPCDSDTCSets",
              f: $
            },
            240: {
              n: "BrtEndPCDSDTCSets",
              f: $
            },
            241: {
              n: "BrtBeginPCDSDTCSet",
              f: $
            },
            242: {
              n: "BrtEndPCDSDTCSet",
              f: $
            },
            243: {
              n: "BrtBeginPCDCalcItems",
              f: $
            },
            244: {
              n: "BrtEndPCDCalcItems",
              f: $
            },
            245: {
              n: "BrtBeginPCDCalcItem",
              f: $
            },
            246: {
              n: "BrtEndPCDCalcItem",
              f: $
            },
            247: {
              n: "BrtBeginPRule",
              f: $
            },
            248: {
              n: "BrtEndPRule",
              f: $
            },
            249: {
              n: "BrtBeginPRFilters",
              f: $
            },
            250: {
              n: "BrtEndPRFilters",
              f: $
            },
            251: {
              n: "BrtBeginPRFilter",
              f: $
            },
            252: {
              n: "BrtEndPRFilter",
              f: $
            },
            253: {
              n: "BrtBeginPNames",
              f: $
            },
            254: {
              n: "BrtEndPNames",
              f: $
            },
            255: {
              n: "BrtBeginPName",
              f: $
            },
            256: {
              n: "BrtEndPName",
              f: $
            },
            257: {
              n: "BrtBeginPNPairs",
              f: $
            },
            258: {
              n: "BrtEndPNPairs",
              f: $
            },
            259: {
              n: "BrtBeginPNPair",
              f: $
            },
            260: {
              n: "BrtEndPNPair",
              f: $
            },
            261: {
              n: "BrtBeginECWebProps",
              f: $
            },
            262: {
              n: "BrtEndECWebProps",
              f: $
            },
            263: {
              n: "BrtBeginEcWpTables",
              f: $
            },
            264: {
              n: "BrtEndECWPTables",
              f: $
            },
            265: {
              n: "BrtBeginECParams",
              f: $
            },
            266: {
              n: "BrtEndECParams",
              f: $
            },
            267: {
              n: "BrtBeginECParam",
              f: $
            },
            268: {
              n: "BrtEndECParam",
              f: $
            },
            269: {
              n: "BrtBeginPCDKPIs",
              f: $
            },
            270: {
              n: "BrtEndPCDKPIs",
              f: $
            },
            271: {
              n: "BrtBeginPCDKPI",
              f: $
            },
            272: {
              n: "BrtEndPCDKPI",
              f: $
            },
            273: {
              n: "BrtBeginDims",
              f: $
            },
            274: {
              n: "BrtEndDims",
              f: $
            },
            275: {
              n: "BrtBeginDim",
              f: $
            },
            276: {
              n: "BrtEndDim",
              f: $
            },
            277: {
              n: "BrtIndexPartEnd",
              f: $
            },
            278: {
              n: "BrtBeginStyleSheet",
              f: $
            },
            279: {
              n: "BrtEndStyleSheet",
              f: $
            },
            280: {
              n: "BrtBeginSXView",
              f: $
            },
            281: {
              n: "BrtEndSXVI",
              f: $
            },
            282: {
              n: "BrtBeginSXVI",
              f: $
            },
            283: {
              n: "BrtBeginSXVIs",
              f: $
            },
            284: {
              n: "BrtEndSXVIs",
              f: $
            },
            285: {
              n: "BrtBeginSXVD",
              f: $
            },
            286: {
              n: "BrtEndSXVD",
              f: $
            },
            287: {
              n: "BrtBeginSXVDs",
              f: $
            },
            288: {
              n: "BrtEndSXVDs",
              f: $
            },
            289: {
              n: "BrtBeginSXPI",
              f: $
            },
            290: {
              n: "BrtEndSXPI",
              f: $
            },
            291: {
              n: "BrtBeginSXPIs",
              f: $
            },
            292: {
              n: "BrtEndSXPIs",
              f: $
            },
            293: {
              n: "BrtBeginSXDI",
              f: $
            },
            294: {
              n: "BrtEndSXDI",
              f: $
            },
            295: {
              n: "BrtBeginSXDIs",
              f: $
            },
            296: {
              n: "BrtEndSXDIs",
              f: $
            },
            297: {
              n: "BrtBeginSXLI",
              f: $
            },
            298: {
              n: "BrtEndSXLI",
              f: $
            },
            299: {
              n: "BrtBeginSXLIRws",
              f: $
            },
            300: {
              n: "BrtEndSXLIRws",
              f: $
            },
            301: {
              n: "BrtBeginSXLICols",
              f: $
            },
            302: {
              n: "BrtEndSXLICols",
              f: $
            },
            303: {
              n: "BrtBeginSXFormat",
              f: $
            },
            304: {
              n: "BrtEndSXFormat",
              f: $
            },
            305: {
              n: "BrtBeginSXFormats",
              f: $
            },
            306: {
              n: "BrtEndSxFormats",
              f: $
            },
            307: {
              n: "BrtBeginSxSelect",
              f: $
            },
            308: {
              n: "BrtEndSxSelect",
              f: $
            },
            309: {
              n: "BrtBeginISXVDRws",
              f: $
            },
            310: {
              n: "BrtEndISXVDRws",
              f: $
            },
            311: {
              n: "BrtBeginISXVDCols",
              f: $
            },
            312: {
              n: "BrtEndISXVDCols",
              f: $
            },
            313: {
              n: "BrtEndSXLocation",
              f: $
            },
            314: {
              n: "BrtBeginSXLocation",
              f: $
            },
            315: {
              n: "BrtEndSXView",
              f: $
            },
            316: {
              n: "BrtBeginSXTHs",
              f: $
            },
            317: {
              n: "BrtEndSXTHs",
              f: $
            },
            318: {
              n: "BrtBeginSXTH",
              f: $
            },
            319: {
              n: "BrtEndSXTH",
              f: $
            },
            320: {
              n: "BrtBeginISXTHRws",
              f: $
            },
            321: {
              n: "BrtEndISXTHRws",
              f: $
            },
            322: {
              n: "BrtBeginISXTHCols",
              f: $
            },
            323: {
              n: "BrtEndISXTHCols",
              f: $
            },
            324: {
              n: "BrtBeginSXTDMPS",
              f: $
            },
            325: {
              n: "BrtEndSXTDMPs",
              f: $
            },
            326: {
              n: "BrtBeginSXTDMP",
              f: $
            },
            327: {
              n: "BrtEndSXTDMP",
              f: $
            },
            328: {
              n: "BrtBeginSXTHItems",
              f: $
            },
            329: {
              n: "BrtEndSXTHItems",
              f: $
            },
            330: {
              n: "BrtBeginSXTHItem",
              f: $
            },
            331: {
              n: "BrtEndSXTHItem",
              f: $
            },
            332: {
              n: "BrtBeginMetadata",
              f: $
            },
            333: {
              n: "BrtEndMetadata",
              f: $
            },
            334: {
              n: "BrtBeginEsmdtinfo",
              f: $
            },
            335: {
              n: "BrtMdtinfo",
              f: $
            },
            336: {
              n: "BrtEndEsmdtinfo",
              f: $
            },
            337: {
              n: "BrtBeginEsmdb",
              f: $
            },
            338: {
              n: "BrtEndEsmdb",
              f: $
            },
            339: {
              n: "BrtBeginEsfmd",
              f: $
            },
            340: {
              n: "BrtEndEsfmd",
              f: $
            },
            341: {
              n: "BrtBeginSingleCells",
              f: $
            },
            342: {
              n: "BrtEndSingleCells",
              f: $
            },
            343: {
              n: "BrtBeginList",
              f: $
            },
            344: {
              n: "BrtEndList",
              f: $
            },
            345: {
              n: "BrtBeginListCols",
              f: $
            },
            346: {
              n: "BrtEndListCols",
              f: $
            },
            347: {
              n: "BrtBeginListCol",
              f: $
            },
            348: {
              n: "BrtEndListCol",
              f: $
            },
            349: {
              n: "BrtBeginListXmlCPr",
              f: $
            },
            350: {
              n: "BrtEndListXmlCPr",
              f: $
            },
            351: {
              n: "BrtListCCFmla",
              f: $
            },
            352: {
              n: "BrtListTrFmla",
              f: $
            },
            353: {
              n: "BrtBeginExternals",
              f: $
            },
            354: {
              n: "BrtEndExternals",
              f: $
            },
            355: {
              n: "BrtSupBookSrc",
              f: Zu
            },
            357: {
              n: "BrtSupSelf",
              f: $
            },
            358: {
              n: "BrtSupSame",
              f: $
            },
            359: {
              n: "BrtSupTabs",
              f: $
            },
            360: {
              n: "BrtBeginSupBook",
              f: $
            },
            361: {
              n: "BrtPlaceholderName",
              f: $
            },
            362: {
              n: "BrtExternSheet",
              f: Pr
            },
            363: {
              n: "BrtExternTableStart",
              f: $
            },
            364: {
              n: "BrtExternTableEnd",
              f: $
            },
            366: {
              n: "BrtExternRowHdr",
              f: $
            },
            367: {
              n: "BrtExternCellBlank",
              f: $
            },
            368: {
              n: "BrtExternCellReal",
              f: $
            },
            369: {
              n: "BrtExternCellBool",
              f: $
            },
            370: {
              n: "BrtExternCellError",
              f: $
            },
            371: {
              n: "BrtExternCellString",
              f: $
            },
            372: {
              n: "BrtBeginEsmdx",
              f: $
            },
            373: {
              n: "BrtEndEsmdx",
              f: $
            },
            374: {
              n: "BrtBeginMdxSet",
              f: $
            },
            375: {
              n: "BrtEndMdxSet",
              f: $
            },
            376: {
              n: "BrtBeginMdxMbrProp",
              f: $
            },
            377: {
              n: "BrtEndMdxMbrProp",
              f: $
            },
            378: {
              n: "BrtBeginMdxKPI",
              f: $
            },
            379: {
              n: "BrtEndMdxKPI",
              f: $
            },
            380: {
              n: "BrtBeginEsstr",
              f: $
            },
            381: {
              n: "BrtEndEsstr",
              f: $
            },
            382: {
              n: "BrtBeginPRFItem",
              f: $
            },
            383: {
              n: "BrtEndPRFItem",
              f: $
            },
            384: {
              n: "BrtBeginPivotCacheIDs",
              f: $
            },
            385: {
              n: "BrtEndPivotCacheIDs",
              f: $
            },
            386: {
              n: "BrtBeginPivotCacheID",
              f: $
            },
            387: {
              n: "BrtEndPivotCacheID",
              f: $
            },
            388: {
              n: "BrtBeginISXVIs",
              f: $
            },
            389: {
              n: "BrtEndISXVIs",
              f: $
            },
            390: {
              n: "BrtBeginColInfos",
              f: $
            },
            391: {
              n: "BrtEndColInfos",
              f: $
            },
            392: {
              n: "BrtBeginRwBrk",
              f: $
            },
            393: {
              n: "BrtEndRwBrk",
              f: $
            },
            394: {
              n: "BrtBeginColBrk",
              f: $
            },
            395: {
              n: "BrtEndColBrk",
              f: $
            },
            396: {
              n: "BrtBrk",
              f: $
            },
            397: {
              n: "BrtUserBookView",
              f: $
            },
            398: {
              n: "BrtInfo",
              f: $
            },
            399: {
              n: "BrtCUsr",
              f: $
            },
            400: {
              n: "BrtUsr",
              f: $
            },
            401: {
              n: "BrtBeginUsers",
              f: $
            },
            403: {
              n: "BrtEOF",
              f: $
            },
            404: {
              n: "BrtUCR",
              f: $
            },
            405: {
              n: "BrtRRInsDel",
              f: $
            },
            406: {
              n: "BrtRREndInsDel",
              f: $
            },
            407: {
              n: "BrtRRMove",
              f: $
            },
            408: {
              n: "BrtRREndMove",
              f: $
            },
            409: {
              n: "BrtRRChgCell",
              f: $
            },
            410: {
              n: "BrtRREndChgCell",
              f: $
            },
            411: {
              n: "BrtRRHeader",
              f: $
            },
            412: {
              n: "BrtRRUserView",
              f: $
            },
            413: {
              n: "BrtRRRenSheet",
              f: $
            },
            414: {
              n: "BrtRRInsertSh",
              f: $
            },
            415: {
              n: "BrtRRDefName",
              f: $
            },
            416: {
              n: "BrtRRNote",
              f: $
            },
            417: {
              n: "BrtRRConflict",
              f: $
            },
            418: {
              n: "BrtRRTQSIF",
              f: $
            },
            419: {
              n: "BrtRRFormat",
              f: $
            },
            420: {
              n: "BrtRREndFormat",
              f: $
            },
            421: {
              n: "BrtRRAutoFmt",
              f: $
            },
            422: {
              n: "BrtBeginUserShViews",
              f: $
            },
            423: {
              n: "BrtBeginUserShView",
              f: $
            },
            424: {
              n: "BrtEndUserShView",
              f: $
            },
            425: {
              n: "BrtEndUserShViews",
              f: $
            },
            426: {
              n: "BrtArrFmla",
              f: as
            },
            427: {
              n: "BrtShrFmla",
              f: os
            },
            428: {
              n: "BrtTable",
              f: $
            },
            429: {
              n: "BrtBeginExtConnections",
              f: $
            },
            430: {
              n: "BrtEndExtConnections",
              f: $
            },
            431: {
              n: "BrtBeginPCDCalcMems",
              f: $
            },
            432: {
              n: "BrtEndPCDCalcMems",
              f: $
            },
            433: {
              n: "BrtBeginPCDCalcMem",
              f: $
            },
            434: {
              n: "BrtEndPCDCalcMem",
              f: $
            },
            435: {
              n: "BrtBeginPCDHGLevels",
              f: $
            },
            436: {
              n: "BrtEndPCDHGLevels",
              f: $
            },
            437: {
              n: "BrtBeginPCDHGLevel",
              f: $
            },
            438: {
              n: "BrtEndPCDHGLevel",
              f: $
            },
            439: {
              n: "BrtBeginPCDHGLGroups",
              f: $
            },
            440: {
              n: "BrtEndPCDHGLGroups",
              f: $
            },
            441: {
              n: "BrtBeginPCDHGLGroup",
              f: $
            },
            442: {
              n: "BrtEndPCDHGLGroup",
              f: $
            },
            443: {
              n: "BrtBeginPCDHGLGMembers",
              f: $
            },
            444: {
              n: "BrtEndPCDHGLGMembers",
              f: $
            },
            445: {
              n: "BrtBeginPCDHGLGMember",
              f: $
            },
            446: {
              n: "BrtEndPCDHGLGMember",
              f: $
            },
            447: {
              n: "BrtBeginQSI",
              f: $
            },
            448: {
              n: "BrtEndQSI",
              f: $
            },
            449: {
              n: "BrtBeginQSIR",
              f: $
            },
            450: {
              n: "BrtEndQSIR",
              f: $
            },
            451: {
              n: "BrtBeginDeletedNames",
              f: $
            },
            452: {
              n: "BrtEndDeletedNames",
              f: $
            },
            453: {
              n: "BrtBeginDeletedName",
              f: $
            },
            454: {
              n: "BrtEndDeletedName",
              f: $
            },
            455: {
              n: "BrtBeginQSIFs",
              f: $
            },
            456: {
              n: "BrtEndQSIFs",
              f: $
            },
            457: {
              n: "BrtBeginQSIF",
              f: $
            },
            458: {
              n: "BrtEndQSIF",
              f: $
            },
            459: {
              n: "BrtBeginAutoSortScope",
              f: $
            },
            460: {
              n: "BrtEndAutoSortScope",
              f: $
            },
            461: {
              n: "BrtBeginConditionalFormatting",
              f: $
            },
            462: {
              n: "BrtEndConditionalFormatting",
              f: $
            },
            463: {
              n: "BrtBeginCFRule",
              f: $
            },
            464: {
              n: "BrtEndCFRule",
              f: $
            },
            465: {
              n: "BrtBeginIconSet",
              f: $
            },
            466: {
              n: "BrtEndIconSet",
              f: $
            },
            467: {
              n: "BrtBeginDatabar",
              f: $
            },
            468: {
              n: "BrtEndDatabar",
              f: $
            },
            469: {
              n: "BrtBeginColorScale",
              f: $
            },
            470: {
              n: "BrtEndColorScale",
              f: $
            },
            471: {
              n: "BrtCFVO",
              f: $
            },
            472: {
              n: "BrtExternValueMeta",
              f: $
            },
            473: {
              n: "BrtBeginColorPalette",
              f: $
            },
            474: {
              n: "BrtEndColorPalette",
              f: $
            },
            475: {
              n: "BrtIndexedColor",
              f: $
            },
            476: {
              n: "BrtMargins",
              f: ls
            },
            477: {
              n: "BrtPrintOptions",
              f: $
            },
            478: {
              n: "BrtPageSetup",
              f: $
            },
            479: {
              n: "BrtBeginHeaderFooter",
              f: $
            },
            480: {
              n: "BrtEndHeaderFooter",
              f: $
            },
            481: {
              n: "BrtBeginSXCrtFormat",
              f: $
            },
            482: {
              n: "BrtEndSXCrtFormat",
              f: $
            },
            483: {
              n: "BrtBeginSXCrtFormats",
              f: $
            },
            484: {
              n: "BrtEndSXCrtFormats",
              f: $
            },
            485: {
              n: "BrtWsFmtInfo",
              f: Lo
            },
            486: {
              n: "BrtBeginMgs",
              f: $
            },
            487: {
              n: "BrtEndMGs",
              f: $
            },
            488: {
              n: "BrtBeginMGMaps",
              f: $
            },
            489: {
              n: "BrtEndMGMaps",
              f: $
            },
            490: {
              n: "BrtBeginMG",
              f: $
            },
            491: {
              n: "BrtEndMG",
              f: $
            },
            492: {
              n: "BrtBeginMap",
              f: $
            },
            493: {
              n: "BrtEndMap",
              f: $
            },
            494: {
              n: "BrtHLink",
              f: ns
            },
            495: {
              n: "BrtBeginDCon",
              f: $
            },
            496: {
              n: "BrtEndDCon",
              f: $
            },
            497: {
              n: "BrtBeginDRefs",
              f: $
            },
            498: {
              n: "BrtEndDRefs",
              f: $
            },
            499: {
              n: "BrtDRef",
              f: $
            },
            500: {
              n: "BrtBeginScenMan",
              f: $
            },
            501: {
              n: "BrtEndScenMan",
              f: $
            },
            502: {
              n: "BrtBeginSct",
              f: $
            },
            503: {
              n: "BrtEndSct",
              f: $
            },
            504: {
              n: "BrtSlc",
              f: $
            },
            505: {
              n: "BrtBeginDXFs",
              f: $
            },
            506: {
              n: "BrtEndDXFs",
              f: $
            },
            507: {
              n: "BrtDXF",
              f: $
            },
            508: {
              n: "BrtBeginTableStyles",
              f: $
            },
            509: {
              n: "BrtEndTableStyles",
              f: $
            },
            510: {
              n: "BrtBeginTableStyle",
              f: $
            },
            511: {
              n: "BrtEndTableStyle",
              f: $
            },
            512: {
              n: "BrtTableStyleElement",
              f: $
            },
            513: {
              n: "BrtTableStyleClient",
              f: $
            },
            514: {
              n: "BrtBeginVolDeps",
              f: $
            },
            515: {
              n: "BrtEndVolDeps",
              f: $
            },
            516: {
              n: "BrtBeginVolType",
              f: $
            },
            517: {
              n: "BrtEndVolType",
              f: $
            },
            518: {
              n: "BrtBeginVolMain",
              f: $
            },
            519: {
              n: "BrtEndVolMain",
              f: $
            },
            520: {
              n: "BrtBeginVolTopic",
              f: $
            },
            521: {
              n: "BrtEndVolTopic",
              f: $
            },
            522: {
              n: "BrtVolSubtopic",
              f: $
            },
            523: {
              n: "BrtVolRef",
              f: $
            },
            524: {
              n: "BrtVolNum",
              f: $
            },
            525: {
              n: "BrtVolErr",
              f: $
            },
            526: {
              n: "BrtVolStr",
              f: $
            },
            527: {
              n: "BrtVolBool",
              f: $
            },
            528: {
              n: "BrtBeginCalcChain$",
              f: $
            },
            529: {
              n: "BrtEndCalcChain$",
              f: $
            },
            530: {
              n: "BrtBeginSortState",
              f: $
            },
            531: {
              n: "BrtEndSortState",
              f: $
            },
            532: {
              n: "BrtBeginSortCond",
              f: $
            },
            533: {
              n: "BrtEndSortCond",
              f: $
            },
            534: {
              n: "BrtBookProtection",
              f: $
            },
            535: {
              n: "BrtSheetProtection",
              f: $
            },
            536: {
              n: "BrtRangeProtection",
              f: $
            },
            537: {
              n: "BrtPhoneticInfo",
              f: $
            },
            538: {
              n: "BrtBeginECTxtWiz",
              f: $
            },
            539: {
              n: "BrtEndECTxtWiz",
              f: $
            },
            540: {
              n: "BrtBeginECTWFldInfoLst",
              f: $
            },
            541: {
              n: "BrtEndECTWFldInfoLst",
              f: $
            },
            542: {
              n: "BrtBeginECTwFldInfo",
              f: $
            },
            548: {
              n: "BrtFileSharing",
              f: $
            },
            549: {
              n: "BrtOleSize",
              f: $
            },
            550: {
              n: "BrtDrawing",
              f: Zu
            },
            551: {
              n: "BrtLegacyDrawing",
              f: $
            },
            552: {
              n: "BrtLegacyDrawingHF",
              f: $
            },
            553: {
              n: "BrtWebOpt",
              f: $
            },
            554: {
              n: "BrtBeginWebPubItems",
              f: $
            },
            555: {
              n: "BrtEndWebPubItems",
              f: $
            },
            556: {
              n: "BrtBeginWebPubItem",
              f: $
            },
            557: {
              n: "BrtEndWebPubItem",
              f: $
            },
            558: {
              n: "BrtBeginSXCondFmt",
              f: $
            },
            559: {
              n: "BrtEndSXCondFmt",
              f: $
            },
            560: {
              n: "BrtBeginSXCondFmts",
              f: $
            },
            561: {
              n: "BrtEndSXCondFmts",
              f: $
            },
            562: {
              n: "BrtBkHim",
              f: $
            },
            564: {
              n: "BrtColor",
              f: $
            },
            565: {
              n: "BrtBeginIndexedColors",
              f: $
            },
            566: {
              n: "BrtEndIndexedColors",
              f: $
            },
            569: {
              n: "BrtBeginMRUColors",
              f: $
            },
            570: {
              n: "BrtEndMRUColors",
              f: $
            },
            572: {
              n: "BrtMRUColor",
              f: $
            },
            573: {
              n: "BrtBeginDVals",
              f: $
            },
            574: {
              n: "BrtEndDVals",
              f: $
            },
            577: {
              n: "BrtSupNameStart",
              f: $
            },
            578: {
              n: "BrtSupNameValueStart",
              f: $
            },
            579: {
              n: "BrtSupNameValueEnd",
              f: $
            },
            580: {
              n: "BrtSupNameNum",
              f: $
            },
            581: {
              n: "BrtSupNameErr",
              f: $
            },
            582: {
              n: "BrtSupNameSt",
              f: $
            },
            583: {
              n: "BrtSupNameNil",
              f: $
            },
            584: {
              n: "BrtSupNameBool",
              f: $
            },
            585: {
              n: "BrtSupNameFmla",
              f: $
            },
            586: {
              n: "BrtSupNameBits",
              f: $
            },
            587: {
              n: "BrtSupNameEnd",
              f: $
            },
            588: {
              n: "BrtEndSupBook",
              f: $
            },
            589: {
              n: "BrtCellSmartTagProperty",
              f: $
            },
            590: {
              n: "BrtBeginCellSmartTag",
              f: $
            },
            591: {
              n: "BrtEndCellSmartTag",
              f: $
            },
            592: {
              n: "BrtBeginCellSmartTags",
              f: $
            },
            593: {
              n: "BrtEndCellSmartTags",
              f: $
            },
            594: {
              n: "BrtBeginSmartTags",
              f: $
            },
            595: {
              n: "BrtEndSmartTags",
              f: $
            },
            596: {
              n: "BrtSmartTagType",
              f: $
            },
            597: {
              n: "BrtBeginSmartTagTypes",
              f: $
            },
            598: {
              n: "BrtEndSmartTagTypes",
              f: $
            },
            599: {
              n: "BrtBeginSXFilters",
              f: $
            },
            600: {
              n: "BrtEndSXFilters",
              f: $
            },
            601: {
              n: "BrtBeginSXFILTER",
              f: $
            },
            602: {
              n: "BrtEndSXFilter",
              f: $
            },
            603: {
              n: "BrtBeginFills",
              f: $
            },
            604: {
              n: "BrtEndFills",
              f: $
            },
            605: {
              n: "BrtBeginCellWatches",
              f: $
            },
            606: {
              n: "BrtEndCellWatches",
              f: $
            },
            607: {
              n: "BrtCellWatch",
              f: $
            },
            608: {
              n: "BrtBeginCRErrs",
              f: $
            },
            609: {
              n: "BrtEndCRErrs",
              f: $
            },
            610: {
              n: "BrtCrashRecErr",
              f: $
            },
            611: {
              n: "BrtBeginFonts",
              f: $
            },
            612: {
              n: "BrtEndFonts",
              f: $
            },
            613: {
              n: "BrtBeginBorders",
              f: $
            },
            614: {
              n: "BrtEndBorders",
              f: $
            },
            615: {
              n: "BrtBeginFmts",
              f: $
            },
            616: {
              n: "BrtEndFmts",
              f: $
            },
            617: {
              n: "BrtBeginCellXFs",
              f: $
            },
            618: {
              n: "BrtEndCellXFs",
              f: $
            },
            619: {
              n: "BrtBeginStyles",
              f: $
            },
            620: {
              n: "BrtEndStyles",
              f: $
            },
            625: {
              n: "BrtBigName",
              f: $
            },
            626: {
              n: "BrtBeginCellStyleXFs",
              f: $
            },
            627: {
              n: "BrtEndCellStyleXFs",
              f: $
            },
            628: {
              n: "BrtBeginComments",
              f: $
            },
            629: {
              n: "BrtEndComments",
              f: $
            },
            630: {
              n: "BrtBeginCommentAuthors",
              f: $
            },
            631: {
              n: "BrtEndCommentAuthors",
              f: $
            },
            632: {
              n: "BrtCommentAuthor",
              f: hb
            },
            633: {
              n: "BrtBeginCommentList",
              f: $
            },
            634: {
              n: "BrtEndCommentList",
              f: $
            },
            635: {
              n: "BrtBeginComment",
              f: Xi
            },
            636: {
              n: "BrtEndComment",
              f: $
            },
            637: {
              n: "BrtCommentText",
              f: Wu
            },
            638: {
              n: "BrtBeginOleObjects",
              f: $
            },
            639: {
              n: "BrtOleObject",
              f: $
            },
            640: {
              n: "BrtEndOleObjects",
              f: $
            },
            641: {
              n: "BrtBeginSxrules",
              f: $
            },
            642: {
              n: "BrtEndSxRules",
              f: $
            },
            643: {
              n: "BrtBeginActiveXControls",
              f: $
            },
            644: {
              n: "BrtActiveX",
              f: $
            },
            645: {
              n: "BrtEndActiveXControls",
              f: $
            },
            646: {
              n: "BrtBeginPCDSDTCEMembersSortBy",
              f: $
            },
            648: {
              n: "BrtBeginCellIgnoreECs",
              f: $
            },
            649: {
              n: "BrtCellIgnoreEC",
              f: $
            },
            650: {
              n: "BrtEndCellIgnoreECs",
              f: $
            },
            651: {
              n: "BrtCsProp",
              f: $
            },
            652: {
              n: "BrtCsPageSetup",
              f: $
            },
            653: {
              n: "BrtBeginUserCsViews",
              f: $
            },
            654: {
              n: "BrtEndUserCsViews",
              f: $
            },
            655: {
              n: "BrtBeginUserCsView",
              f: $
            },
            656: {
              n: "BrtEndUserCsView",
              f: $
            },
            657: {
              n: "BrtBeginPcdSFCIEntries",
              f: $
            },
            658: {
              n: "BrtEndPCDSFCIEntries",
              f: $
            },
            659: {
              n: "BrtPCDSFCIEntry",
              f: $
            },
            660: {
              n: "BrtBeginListParts",
              f: $
            },
            661: {
              n: "BrtListPart",
              f: $
            },
            662: {
              n: "BrtEndListParts",
              f: $
            },
            663: {
              n: "BrtSheetCalcProp",
              f: $
            },
            664: {
              n: "BrtBeginFnGroup",
              f: $
            },
            665: {
              n: "BrtFnGroup",
              f: $
            },
            666: {
              n: "BrtEndFnGroup",
              f: $
            },
            667: {
              n: "BrtSupAddin",
              f: $
            },
            668: {
              n: "BrtSXTDMPOrder",
              f: $
            },
            669: {
              n: "BrtCsProtection",
              f: $
            },
            671: {
              n: "BrtBeginWsSortMap",
              f: $
            },
            672: {
              n: "BrtEndWsSortMap",
              f: $
            },
            673: {
              n: "BrtBeginRRSort",
              f: $
            },
            674: {
              n: "BrtEndRRSort",
              f: $
            },
            675: {
              n: "BrtRRSortItem",
              f: $
            },
            676: {
              n: "BrtFileSharingIso",
              f: $
            },
            677: {
              n: "BrtBookProtectionIso",
              f: $
            },
            678: {
              n: "BrtSheetProtectionIso",
              f: $
            },
            679: {
              n: "BrtCsProtectionIso",
              f: $
            },
            680: {
              n: "BrtRangeProtectionIso",
              f: $
            },
            1024: {
              n: "BrtRwDescent",
              f: $
            },
            1025: {
              n: "BrtKnownFonts",
              f: $
            },
            1026: {
              n: "BrtBeginSXTupleSet",
              f: $
            },
            1027: {
              n: "BrtEndSXTupleSet",
              f: $
            },
            1028: {
              n: "BrtBeginSXTupleSetHeader",
              f: $
            },
            1029: {
              n: "BrtEndSXTupleSetHeader",
              f: $
            },
            1030: {
              n: "BrtSXTupleSetHeaderItem",
              f: $
            },
            1031: {
              n: "BrtBeginSXTupleSetData",
              f: $
            },
            1032: {
              n: "BrtEndSXTupleSetData",
              f: $
            },
            1033: {
              n: "BrtBeginSXTupleSetRow",
              f: $
            },
            1034: {
              n: "BrtEndSXTupleSetRow",
              f: $
            },
            1035: {
              n: "BrtSXTupleSetRowItem",
              f: $
            },
            1036: {
              n: "BrtNameExt",
              f: $
            },
            1037: {
              n: "BrtPCDH14",
              f: $
            },
            1038: {
              n: "BrtBeginPCDCalcMem14",
              f: $
            },
            1039: {
              n: "BrtEndPCDCalcMem14",
              f: $
            },
            1040: {
              n: "BrtSXTH14",
              f: $
            },
            1041: {
              n: "BrtBeginSparklineGroup",
              f: $
            },
            1042: {
              n: "BrtEndSparklineGroup",
              f: $
            },
            1043: {
              n: "BrtSparkline",
              f: $
            },
            1044: {
              n: "BrtSXDI14",
              f: $
            },
            1045: {
              n: "BrtWsFmtInfoEx14",
              f: $
            },
            1046: {
              n: "BrtBeginConditionalFormatting14",
              f: $
            },
            1047: {
              n: "BrtEndConditionalFormatting14",
              f: $
            },
            1048: {
              n: "BrtBeginCFRule14",
              f: $
            },
            1049: {
              n: "BrtEndCFRule14",
              f: $
            },
            1050: {
              n: "BrtCFVO14",
              f: $
            },
            1051: {
              n: "BrtBeginDatabar14",
              f: $
            },
            1052: {
              n: "BrtBeginIconSet14",
              f: $
            },
            1053: {
              n: "BrtDVal14",
              f: $
            },
            1054: {
              n: "BrtBeginDVals14",
              f: $
            },
            1055: {
              n: "BrtColor14",
              f: $
            },
            1056: {
              n: "BrtBeginSparklines",
              f: $
            },
            1057: {
              n: "BrtEndSparklines",
              f: $
            },
            1058: {
              n: "BrtBeginSparklineGroups",
              f: $
            },
            1059: {
              n: "BrtEndSparklineGroups",
              f: $
            },
            1061: {
              n: "BrtSXVD14",
              f: $
            },
            1062: {
              n: "BrtBeginSxview14",
              f: $
            },
            1063: {
              n: "BrtEndSxview14",
              f: $
            },
            1066: {
              n: "BrtBeginPCD14",
              f: $
            },
            1067: {
              n: "BrtEndPCD14",
              f: $
            },
            1068: {
              n: "BrtBeginExtConn14",
              f: $
            },
            1069: {
              n: "BrtEndExtConn14",
              f: $
            },
            1070: {
              n: "BrtBeginSlicerCacheIDs",
              f: $
            },
            1071: {
              n: "BrtEndSlicerCacheIDs",
              f: $
            },
            1072: {
              n: "BrtBeginSlicerCacheID",
              f: $
            },
            1073: {
              n: "BrtEndSlicerCacheID",
              f: $
            },
            1075: {
              n: "BrtBeginSlicerCache",
              f: $
            },
            1076: {
              n: "BrtEndSlicerCache",
              f: $
            },
            1077: {
              n: "BrtBeginSlicerCacheDef",
              f: $
            },
            1078: {
              n: "BrtEndSlicerCacheDef",
              f: $
            },
            1079: {
              n: "BrtBeginSlicersEx",
              f: $
            },
            1080: {
              n: "BrtEndSlicersEx",
              f: $
            },
            1081: {
              n: "BrtBeginSlicerEx",
              f: $
            },
            1082: {
              n: "BrtEndSlicerEx",
              f: $
            },
            1083: {
              n: "BrtBeginSlicer",
              f: $
            },
            1084: {
              n: "BrtEndSlicer",
              f: $
            },
            1085: {
              n: "BrtSlicerCachePivotTables",
              f: $
            },
            1086: {
              n: "BrtBeginSlicerCacheOlapImpl",
              f: $
            },
            1087: {
              n: "BrtEndSlicerCacheOlapImpl",
              f: $
            },
            1088: {
              n: "BrtBeginSlicerCacheLevelsData",
              f: $
            },
            1089: {
              n: "BrtEndSlicerCacheLevelsData",
              f: $
            },
            1090: {
              n: "BrtBeginSlicerCacheLevelData",
              f: $
            },
            1091: {
              n: "BrtEndSlicerCacheLevelData",
              f: $
            },
            1092: {
              n: "BrtBeginSlicerCacheSiRanges",
              f: $
            },
            1093: {
              n: "BrtEndSlicerCacheSiRanges",
              f: $
            },
            1094: {
              n: "BrtBeginSlicerCacheSiRange",
              f: $
            },
            1095: {
              n: "BrtEndSlicerCacheSiRange",
              f: $
            },
            1096: {
              n: "BrtSlicerCacheOlapItem",
              f: $
            },
            1097: {
              n: "BrtBeginSlicerCacheSelections",
              f: $
            },
            1098: {
              n: "BrtSlicerCacheSelection",
              f: $
            },
            1099: {
              n: "BrtEndSlicerCacheSelections",
              f: $
            },
            1100: {
              n: "BrtBeginSlicerCacheNative",
              f: $
            },
            1101: {
              n: "BrtEndSlicerCacheNative",
              f: $
            },
            1102: {
              n: "BrtSlicerCacheNativeItem",
              f: $
            },
            1103: {
              n: "BrtRangeProtection14",
              f: $
            },
            1104: {
              n: "BrtRangeProtectionIso14",
              f: $
            },
            1105: {
              n: "BrtCellIgnoreEC14",
              f: $
            },
            1111: {
              n: "BrtList14",
              f: $
            },
            1112: {
              n: "BrtCFIcon",
              f: $
            },
            1113: {
              n: "BrtBeginSlicerCachesPivotCacheIDs",
              f: $
            },
            1114: {
              n: "BrtEndSlicerCachesPivotCacheIDs",
              f: $
            },
            1115: {
              n: "BrtBeginSlicers",
              f: $
            },
            1116: {
              n: "BrtEndSlicers",
              f: $
            },
            1117: {
              n: "BrtWbProp14",
              f: $
            },
            1118: {
              n: "BrtBeginSXEdit",
              f: $
            },
            1119: {
              n: "BrtEndSXEdit",
              f: $
            },
            1120: {
              n: "BrtBeginSXEdits",
              f: $
            },
            1121: {
              n: "BrtEndSXEdits",
              f: $
            },
            1122: {
              n: "BrtBeginSXChange",
              f: $
            },
            1123: {
              n: "BrtEndSXChange",
              f: $
            },
            1124: {
              n: "BrtBeginSXChanges",
              f: $
            },
            1125: {
              n: "BrtEndSXChanges",
              f: $
            },
            1126: {
              n: "BrtSXTupleItems",
              f: $
            },
            1128: {
              n: "BrtBeginSlicerStyle",
              f: $
            },
            1129: {
              n: "BrtEndSlicerStyle",
              f: $
            },
            1130: {
              n: "BrtSlicerStyleElement",
              f: $
            },
            1131: {
              n: "BrtBeginStyleSheetExt14",
              f: $
            },
            1132: {
              n: "BrtEndStyleSheetExt14",
              f: $
            },
            1133: {
              n: "BrtBeginSlicerCachesPivotCacheID",
              f: $
            },
            1134: {
              n: "BrtEndSlicerCachesPivotCacheID",
              f: $
            },
            1135: {
              n: "BrtBeginConditionalFormattings",
              f: $
            },
            1136: {
              n: "BrtEndConditionalFormattings",
              f: $
            },
            1137: {
              n: "BrtBeginPCDCalcMemExt",
              f: $
            },
            1138: {
              n: "BrtEndPCDCalcMemExt",
              f: $
            },
            1139: {
              n: "BrtBeginPCDCalcMemsExt",
              f: $
            },
            1140: {
              n: "BrtEndPCDCalcMemsExt",
              f: $
            },
            1141: {
              n: "BrtPCDField14",
              f: $
            },
            1142: {
              n: "BrtBeginSlicerStyles",
              f: $
            },
            1143: {
              n: "BrtEndSlicerStyles",
              f: $
            },
            1144: {
              n: "BrtBeginSlicerStyleElements",
              f: $
            },
            1145: {
              n: "BrtEndSlicerStyleElements",
              f: $
            },
            1146: {
              n: "BrtCFRuleExt",
              f: $
            },
            1147: {
              n: "BrtBeginSXCondFmt14",
              f: $
            },
            1148: {
              n: "BrtEndSXCondFmt14",
              f: $
            },
            1149: {
              n: "BrtBeginSXCondFmts14",
              f: $
            },
            1150: {
              n: "BrtEndSXCondFmts14",
              f: $
            },
            1152: {
              n: "BrtBeginSortCond14",
              f: $
            },
            1153: {
              n: "BrtEndSortCond14",
              f: $
            },
            1154: {
              n: "BrtEndDVals14",
              f: $
            },
            1155: {
              n: "BrtEndIconSet14",
              f: $
            },
            1156: {
              n: "BrtEndDatabar14",
              f: $
            },
            1157: {
              n: "BrtBeginColorScale14",
              f: $
            },
            1158: {
              n: "BrtEndColorScale14",
              f: $
            },
            1159: {
              n: "BrtBeginSxrules14",
              f: $
            },
            1160: {
              n: "BrtEndSxrules14",
              f: $
            },
            1161: {
              n: "BrtBeginPRule14",
              f: $
            },
            1162: {
              n: "BrtEndPRule14",
              f: $
            },
            1163: {
              n: "BrtBeginPRFilters14",
              f: $
            },
            1164: {
              n: "BrtEndPRFilters14",
              f: $
            },
            1165: {
              n: "BrtBeginPRFilter14",
              f: $
            },
            1166: {
              n: "BrtEndPRFilter14",
              f: $
            },
            1167: {
              n: "BrtBeginPRFItem14",
              f: $
            },
            1168: {
              n: "BrtEndPRFItem14",
              f: $
            },
            1169: {
              n: "BrtBeginCellIgnoreECs14",
              f: $
            },
            1170: {
              n: "BrtEndCellIgnoreECs14",
              f: $
            },
            1171: {
              n: "BrtDxf14",
              f: $
            },
            1172: {
              n: "BrtBeginDxF14s",
              f: $
            },
            1173: {
              n: "BrtEndDxf14s",
              f: $
            },
            1177: {
              n: "BrtFilter14",
              f: $
            },
            1178: {
              n: "BrtBeginCustomFilters14",
              f: $
            },
            1180: {
              n: "BrtCustomFilter14",
              f: $
            },
            1181: {
              n: "BrtIconFilter14",
              f: $
            },
            1182: {
              n: "BrtPivotCacheConnectionName",
              f: $
            },
            2048: {
              n: "BrtBeginDecoupledPivotCacheIDs",
              f: $
            },
            2049: {
              n: "BrtEndDecoupledPivotCacheIDs",
              f: $
            },
            2050: {
              n: "BrtDecoupledPivotCacheID",
              f: $
            },
            2051: {
              n: "BrtBeginPivotTableRefs",
              f: $
            },
            2052: {
              n: "BrtEndPivotTableRefs",
              f: $
            },
            2053: {
              n: "BrtPivotTableRef",
              f: $
            },
            2054: {
              n: "BrtSlicerCacheBookPivotTables",
              f: $
            },
            2055: {
              n: "BrtBeginSxvcells",
              f: $
            },
            2056: {
              n: "BrtEndSxvcells",
              f: $
            },
            2057: {
              n: "BrtBeginSxRow",
              f: $
            },
            2058: {
              n: "BrtEndSxRow",
              f: $
            },
            2060: {
              n: "BrtPcdCalcMem15",
              f: $
            },
            2067: {
              n: "BrtQsi15",
              f: $
            },
            2068: {
              n: "BrtBeginWebExtensions",
              f: $
            },
            2069: {
              n: "BrtEndWebExtensions",
              f: $
            },
            2070: {
              n: "BrtWebExtension",
              f: $
            },
            2071: {
              n: "BrtAbsPath15",
              f: $
            },
            2072: {
              n: "BrtBeginPivotTableUISettings",
              f: $
            },
            2073: {
              n: "BrtEndPivotTableUISettings",
              f: $
            },
            2075: {
              n: "BrtTableSlicerCacheIDs",
              f: $
            },
            2076: {
              n: "BrtTableSlicerCacheID",
              f: $
            },
            2077: {
              n: "BrtBeginTableSlicerCache",
              f: $
            },
            2078: {
              n: "BrtEndTableSlicerCache",
              f: $
            },
            2079: {
              n: "BrtSxFilter15",
              f: $
            },
            2080: {
              n: "BrtBeginTimelineCachePivotCacheIDs",
              f: $
            },
            2081: {
              n: "BrtEndTimelineCachePivotCacheIDs",
              f: $
            },
            2082: {
              n: "BrtTimelineCachePivotCacheID",
              f: $
            },
            2083: {
              n: "BrtBeginTimelineCacheIDs",
              f: $
            },
            2084: {
              n: "BrtEndTimelineCacheIDs",
              f: $
            },
            2085: {
              n: "BrtBeginTimelineCacheID",
              f: $
            },
            2086: {
              n: "BrtEndTimelineCacheID",
              f: $
            },
            2087: {
              n: "BrtBeginTimelinesEx",
              f: $
            },
            2088: {
              n: "BrtEndTimelinesEx",
              f: $
            },
            2089: {
              n: "BrtBeginTimelineEx",
              f: $
            },
            2090: {
              n: "BrtEndTimelineEx",
              f: $
            },
            2091: {
              n: "BrtWorkBookPr15",
              f: $
            },
            2092: {
              n: "BrtPCDH15",
              f: $
            },
            2093: {
              n: "BrtBeginTimelineStyle",
              f: $
            },
            2094: {
              n: "BrtEndTimelineStyle",
              f: $
            },
            2095: {
              n: "BrtTimelineStyleElement",
              f: $
            },
            2096: {
              n: "BrtBeginTimelineStylesheetExt15",
              f: $
            },
            2097: {
              n: "BrtEndTimelineStylesheetExt15",
              f: $
            },
            2098: {
              n: "BrtBeginTimelineStyles",
              f: $
            },
            2099: {
              n: "BrtEndTimelineStyles",
              f: $
            },
            2100: {
              n: "BrtBeginTimelineStyleElements",
              f: $
            },
            2101: {
              n: "BrtEndTimelineStyleElements",
              f: $
            },
            2102: {
              n: "BrtDxf15",
              f: $
            },
            2103: {
              n: "BrtBeginDxfs15",
              f: $
            },
            2104: {
              n: "brtEndDxfs15",
              f: $
            },
            2105: {
              n: "BrtSlicerCacheHideItemsWithNoData",
              f: $
            },
            2106: {
              n: "BrtBeginItemUniqueNames",
              f: $
            },
            2107: {
              n: "BrtEndItemUniqueNames",
              f: $
            },
            2108: {
              n: "BrtItemUniqueName",
              f: $
            },
            2109: {
              n: "BrtBeginExtConn15",
              f: $
            },
            2110: {
              n: "BrtEndExtConn15",
              f: $
            },
            2111: {
              n: "BrtBeginOledbPr15",
              f: $
            },
            2112: {
              n: "BrtEndOledbPr15",
              f: $
            },
            2113: {
              n: "BrtBeginDataFeedPr15",
              f: $
            },
            2114: {
              n: "BrtEndDataFeedPr15",
              f: $
            },
            2115: {
              n: "BrtTextPr15",
              f: $
            },
            2116: {
              n: "BrtRangePr15",
              f: $
            },
            2117: {
              n: "BrtDbCommand15",
              f: $
            },
            2118: {
              n: "BrtBeginDbTables15",
              f: $
            },
            2119: {
              n: "BrtEndDbTables15",
              f: $
            },
            2120: {
              n: "BrtDbTable15",
              f: $
            },
            2121: {
              n: "BrtBeginDataModel",
              f: $
            },
            2122: {
              n: "BrtEndDataModel",
              f: $
            },
            2123: {
              n: "BrtBeginModelTables",
              f: $
            },
            2124: {
              n: "BrtEndModelTables",
              f: $
            },
            2125: {
              n: "BrtModelTable",
              f: $
            },
            2126: {
              n: "BrtBeginModelRelationships",
              f: $
            },
            2127: {
              n: "BrtEndModelRelationships",
              f: $
            },
            2128: {
              n: "BrtModelRelationship",
              f: $
            },
            2129: {
              n: "BrtBeginECTxtWiz15",
              f: $
            },
            2130: {
              n: "BrtEndECTxtWiz15",
              f: $
            },
            2131: {
              n: "BrtBeginECTWFldInfoLst15",
              f: $
            },
            2132: {
              n: "BrtEndECTWFldInfoLst15",
              f: $
            },
            2133: {
              n: "BrtBeginECTWFldInfo15",
              f: $
            },
            2134: {
              n: "BrtFieldListActiveItem",
              f: $
            },
            2135: {
              n: "BrtPivotCacheIdVersion",
              f: $
            },
            2136: {
              n: "BrtSXDI15",
              f: $
            },
            65535: {
              n: "",
              f: $
            }
          },
          Cy = function (e, t) {
            for (var r = [], n = m(e), i = 0; i !== n.length; ++i) r[e[n[i]][t]] = n[i];
            return r;
          }(Sy, "n"),
          Ey = {
            3: {
              n: "BIFF2NUM",
              f: en
            },
            4: {
              n: "BIFF2STR",
              f: $r
            },
            6: {
              n: "Formula",
              f: Ja
            },
            9: {
              n: "BOF",
              f: or
            },
            10: {
              n: "EOF",
              f: mf
            },
            12: {
              n: "CalcCount",
              f: tf
            },
            13: {
              n: "CalcMode",
              f: af
            },
            14: {
              n: "CalcPrecision",
              f: of
            },
            15: {
              n: "CalcRefMode",
              f: sf
            },
            16: {
              n: "CalcDelta",
              f: rf
            },
            17: {
              n: "CalcIter",
              f: nf
            },
            18: {
              n: "Protect",
              f: Bf
            },
            19: {
              n: "Password",
              f: kf
            },
            20: {
              n: "Header",
              f: _f
            },
            21: {
              n: "Footer",
              f: yf
            },
            23: {
              n: "ExternSheet",
              f: Pr
            },
            24: {
              n: "Lbl",
              f: Or
            },
            25: {
              n: "WinProtect",
              f: qf
            },
            26: {
              n: "VerticalPageBreaks",
              f: Xf
            },
            27: {
              n: "HorizontalPageBreaks",
              f: Yf
            },
            28: {
              n: "Note",
              f: jr
            },
            29: {
              n: "Selection",
              f: Kf
            },
            34: {
              n: "Date1904",
              f: hf
            },
            35: {
              n: "ExternName",
              f: Mr
            },
            38: {
              n: "LeftMargin",
              f: Ef
            },
            39: {
              n: "RightMargin",
              f: Lf
            },
            40: {
              n: "TopMargin",
              f: Hf
            },
            41: {
              n: "BottomMargin",
              f: $h
            },
            42: {
              n: "PrintRowCol",
              f: If
            },
            43: {
              n: "PrintGrid",
              f: Rf
            },
            47: {
              n: "FilePass",
              f: Pn
            },
            49: {
              n: "Font",
              f: vr
            },
            51: {
              n: "PrintSize",
              f: Mf
            },
            60: {
              n: "Continue",
              f: Zf
            },
            61: {
              n: "Window1",
              f: gr
            },
            64: {
              n: "Backup",
              f: Jh
            },
            65: {
              n: "Pane",
              f: Jf
            },
            66: {
              n: "CodePage",
              f: cf
            },
            77: {
              n: "Pls",
              f: Qf
            },
            80: {
              n: "DCon",
              f: $f
            },
            81: {
              n: "DConRef",
              f: ed
            },
            82: {
              n: "DConName",
              f: td
            },
            85: {
              n: "DefColWidth",
              f: ff
            },
            89: {
              n: "XCT",
              f: rd
            },
            90: {
              n: "CRN",
              f: nd
            },
            91: {
              n: "FileSharing",
              f: id
            },
            92: {
              n: "WriteAccess",
              f: lr
            },
            93: {
              n: "Obj",
              f: Hr
            },
            94: {
              n: "Uncalced",
              f: ad
            },
            95: {
              n: "CalcSaveRecalc",
              f: lf
            },
            96: {
              n: "Template",
              f: od
            },
            97: {
              n: "Intl",
              f: sd
            },
            99: {
              n: "ObjProtect",
              f: Tf
            },
            125: {
              n: "ColInfo",
              f: Kr
            },
            128: {
              n: "Guts",
              f: Tr
            },
            129: {
              n: "WsBool",
              f: ld
            },
            130: {
              n: "GridSet",
              f: wf
            },
            131: {
              n: "HCenter",
              f: xf
            },
            132: {
              n: "VCenter",
              f: Vf
            },
            133: {
              n: "BoundSheet8",
              f: cr
            },
            134: {
              n: "WriteProtect",
              f: Wf
            },
            140: {
              n: "Country",
              f: qr
            },
            141: {
              n: "HideObj",
              f: Sf
            },
            144: {
              n: "Sort",
              f: cd
            },
            146: {
              n: "Palette",
              f: Xr
            },
            151: {
              n: "Sync",
              f: ud
            },
            152: {
              n: "LPr",
              f: hd
            },
            153: {
              n: "DxGCol",
              f: fd
            },
            154: {
              n: "FnGroupName",
              f: dd
            },
            155: {
              n: "FilterMode",
              f: pd
            },
            156: {
              n: "BuiltInFnGroupCount",
              f: ef
            },
            157: {
              n: "AutoFilterInfo",
              f: md
            },
            158: {
              n: "AutoFilter",
              f: gd
            },
            160: {
              n: "Scl",
              f: Uf
            },
            161: {
              n: "Setup",
              f: Zr
            },
            174: {
              n: "ScenMan",
              f: vd
            },
            175: {
              n: "SCENARIO",
              f: bd
            },
            176: {
              n: "SxView",
              f: yd
            },
            177: {
              n: "Sxvd",
              f: wd
            },
            178: {
              n: "SXVI",
              f: xd
            },
            180: {
              n: "SxIvd",
              f: _d
            },
            181: {
              n: "SXLI",
              f: Sd
            },
            182: {
              n: "SXPI",
              f: Cd
            },
            184: {
              n: "DocRoute",
              f: Ed
            },
            185: {
              n: "RecipName",
              f: Ad
            },
            189: {
              n: "MulRk",
              f: Sr
            },
            190: {
              n: "MulBlank",
              f: Cr
            },
            193: {
              n: "Mms",
              f: Af
            },
            197: {
              n: "SXDI",
              f: Td
            },
            198: {
              n: "SXDB",
              f: kd
            },
            199: {
              n: "SXFDB",
              f: Rd
            },
            200: {
              n: "SXDBB",
              f: Id
            },
            201: {
              n: "SXNum",
              f: Md
            },
            202: {
              n: "SxBool",
              f: zf
            },
            203: {
              n: "SxErr",
              f: Od
            },
            204: {
              n: "SXInt",
              f: Pd
            },
            205: {
              n: "SXString",
              f: Bd
            },
            206: {
              n: "SXDtr",
              f: Dd
            },
            207: {
              n: "SxNil",
              f: Ld
            },
            208: {
              n: "SXTbl",
              f: Fd
            },
            209: {
              n: "SXTBRGIITM",
              f: Nd
            },
            210: {
              n: "SxTbpg",
              f: Ud
            },
            211: {
              n: "ObProj",
              f: jd
            },
            213: {
              n: "SXStreamID",
              f: zd
            },
            215: {
              n: "DBCell",
              f: Hd
            },
            216: {
              n: "SXRng",
              f: Gd
            },
            217: {
              n: "SxIsxoper",
              f: Vd
            },
            218: {
              n: "BookBool",
              f: qd
            },
            220: {
              n: "DbOrParamQry",
              f: Wd
            },
            221: {
              n: "ScenarioProtect",
              f: Nf
            },
            222: {
              n: "OleObjectSize",
              f: Xd
            },
            224: {
              n: "XF",
              f: Ar
            },
            225: {
              n: "InterfaceHdr",
              f: sr
            },
            226: {
              n: "InterfaceEnd",
              f: Cf
            },
            227: {
              n: "SXVS",
              f: Yd
            },
            229: {
              n: "MergeCells",
              f: zr
            },
            233: {
              n: "BkHim",
              f: Kd
            },
            235: {
              n: "MsoDrawingGroup",
              f: Zd
            },
            236: {
              n: "MsoDrawing",
              f: Jd
            },
            237: {
              n: "MsoDrawingSelection",
              f: Qd
            },
            239: {
              n: "PhoneticInfo",
              f: $d
            },
            240: {
              n: "SxRule",
              f: ep
            },
            241: {
              n: "SXEx",
              f: tp
            },
            242: {
              n: "SxFilt",
              f: rp
            },
            244: {
              n: "SxDXF",
              f: np
            },
            245: {
              n: "SxItm",
              f: ip
            },
            246: {
              n: "SxName",
              f: ap
            },
            247: {
              n: "SxSelect",
              f: op
            },
            248: {
              n: "SXPair",
              f: sp
            },
            249: {
              n: "SxFmla",
              f: lp
            },
            251: {
              n: "SxFormat",
              f: cp
            },
            252: {
              n: "SST",
              f: ur
            },
            253: {
              n: "LabelSst",
              f: br
            },
            255: {
              n: "ExtSST",
              f: hr
            },
            256: {
              n: "SXVDEx",
              f: up
            },
            259: {
              n: "SXFormula",
              f: hp
            },
            290: {
              n: "SXDBEx",
              f: fp
            },
            311: {
              n: "RRDInsDel",
              f: dp
            },
            312: {
              n: "RRDHead",
              f: pp
            },
            315: {
              n: "RRDChgCell",
              f: mp
            },
            317: {
              n: "RRTabId",
              f: Ff
            },
            318: {
              n: "RRDRenSheet",
              f: gp
            },
            319: {
              n: "RRSort",
              f: vp
            },
            320: {
              n: "RRDMove",
              f: bp
            },
            330: {
              n: "RRFormat",
              f: yp
            },
            331: {
              n: "RRAutoFmt",
              f: wp
            },
            333: {
              n: "RRInsertSh",
              f: xp
            },
            334: {
              n: "RRDMoveBegin",
              f: _p
            },
            335: {
              n: "RRDMoveEnd",
              f: Sp
            },
            336: {
              n: "RRDInsDelBegin",
              f: Cp
            },
            337: {
              n: "RRDInsDelEnd",
              f: Ep
            },
            338: {
              n: "RRDConflict",
              f: Ap
            },
            339: {
              n: "RRDDefName",
              f: Tp
            },
            340: {
              n: "RRDRstEtxp",
              f: kp
            },
            351: {
              n: "LRng",
              f: Rp
            },
            352: {
              n: "UsesELFs",
              f: Gf
            },
            353: {
              n: "DSF",
              f: df
            },
            401: {
              n: "CUsr",
              f: Ip
            },
            402: {
              n: "CbUsr",
              f: Mp
            },
            403: {
              n: "UsrInfo",
              f: Op
            },
            404: {
              n: "UsrExcl",
              f: Pp
            },
            405: {
              n: "FileLock",
              f: Bp
            },
            406: {
              n: "RRDInfo",
              f: Dp
            },
            407: {
              n: "BCUsrs",
              f: Lp
            },
            408: {
              n: "UsrChk",
              f: Fp
            },
            425: {
              n: "UserBView",
              f: Np
            },
            426: {
              n: "UserSViewBegin",
              f: Up
            },
            427: {
              n: "UserSViewEnd",
              f: jp
            },
            428: {
              n: "RRDUserView",
              f: zp
            },
            429: {
              n: "Qsi",
              f: Hp
            },
            430: {
              n: "SupBook",
              f: Ir
            },
            431: {
              n: "Prot4Rev",
              f: Of
            },
            432: {
              n: "CondFmt",
              f: Gp
            },
            433: {
              n: "CF",
              f: Vp
            },
            434: {
              n: "DVal",
              f: qp
            },
            437: {
              n: "DConBin",
              f: Wp
            },
            438: {
              n: "TxO",
              f: Vr
            },
            439: {
              n: "RefreshAll",
              f: Df
            },
            440: {
              n: "HLink",
              f: Wh
            },
            441: {
              n: "Lel",
              f: Xp
            },
            442: {
              n: "CodeName",
              f: Yp
            },
            443: {
              n: "SXFDBType",
              f: Kp
            },
            444: {
              n: "Prot4RevPass",
              f: Pf
            },
            445: {
              n: "ObNoMacros",
              f: Zp
            },
            446: {
              n: "Dv",
              f: Jp
            },
            448: {
              n: "Excel9File",
              f: gf
            },
            449: {
              n: "RecalcId",
              f: pr,
              r: 2
            },
            450: {
              n: "EntExU2",
              f: pf
            },
            512: {
              n: "Dimensions",
              f: xr
            },
            513: {
              n: "Blank",
              f: Qh
            },
            515: {
              n: "Number",
              f: Rr
            },
            516: {
              n: "Label",
              f: yr
            },
            517: {
              n: "BoolErr",
              f: kr
            },
            518: {
              n: "Formula",
              f: Ja
            },
            519: {
              n: "String",
              f: jf
            },
            520: {
              n: "Row",
              f: fr
            },
            523: {
              n: "Index",
              f: Qp
            },
            545: {
              n: "Array",
              f: Fr
            },
            549: {
              n: "DefaultRowHeight",
              f: mr
            },
            566: {
              n: "Table",
              f: $p
            },
            574: {
              n: "Window2",
              f: Zh
            },
            638: {
              n: "RK",
              f: _r
            },
            659: {
              n: "Style",
              f: Yh
            },
            1030: {
              n: "Formula",
              f: Ja
            },
            1048: {
              n: "BigName",
              f: em
            },
            1054: {
              n: "Format",
              f: wr
            },
            1084: {
              n: "ContinueBigName",
              f: tm
            },
            1212: {
              n: "ShrFmla",
              f: Lr
            },
            2048: {
              n: "HLinkTooltip",
              f: Xh
            },
            2049: {
              n: "WebPub",
              f: rm
            },
            2050: {
              n: "QsiSXTag",
              f: nm
            },
            2051: {
              n: "DBQueryExt",
              f: im
            },
            2052: {
              n: "ExtString",
              f: am
            },
            2053: {
              n: "TxtQry",
              f: om
            },
            2054: {
              n: "Qsir",
              f: sm
            },
            2055: {
              n: "Qsif",
              f: lm
            },
            2056: {
              n: "RRDTQSIF",
              f: cm
            },
            2057: {
              n: "BOF",
              f: or
            },
            2058: {
              n: "OleDbConn",
              f: um
            },
            2059: {
              n: "WOpt",
              f: hm
            },
            2060: {
              n: "SXViewEx",
              f: fm
            },
            2061: {
              n: "SXTH",
              f: dm
            },
            2062: {
              n: "SXPIEx",
              f: pm
            },
            2063: {
              n: "SXVDTEx",
              f: mm
            },
            2064: {
              n: "SXViewEx9",
              f: gm
            },
            2066: {
              n: "ContinueFrt",
              f: vm
            },
            2067: {
              n: "RealTimeData",
              f: bm
            },
            2128: {
              n: "ChartFrtInfo",
              f: ym
            },
            2129: {
              n: "FrtWrapper",
              f: wm
            },
            2130: {
              n: "StartBlock",
              f: xm
            },
            2131: {
              n: "EndBlock",
              f: _m
            },
            2132: {
              n: "StartObject",
              f: Sm
            },
            2133: {
              n: "EndObject",
              f: Cm
            },
            2134: {
              n: "CatLab",
              f: Em
            },
            2135: {
              n: "YMult",
              f: Am
            },
            2136: {
              n: "SXViewLink",
              f: Tm
            },
            2137: {
              n: "PivotChartBits",
              f: km
            },
            2138: {
              n: "FrtFontList",
              f: Rm
            },
            2146: {
              n: "SheetExt",
              f: Im
            },
            2147: {
              n: "BookExt",
              f: Mm,
              r: 12
            },
            2148: {
              n: "SXAddl",
              f: Om
            },
            2149: {
              n: "CrErr",
              f: Pm
            },
            2150: {
              n: "HFPicture",
              f: Bm
            },
            2151: {
              n: "FeatHdr",
              f: vf
            },
            2152: {
              n: "Feat",
              f: Dm
            },
            2154: {
              n: "DataLabExt",
              f: Lm
            },
            2155: {
              n: "DataLabExtContents",
              f: Fm
            },
            2156: {
              n: "CellWatch",
              f: Nm
            },
            2161: {
              n: "FeatHdr11",
              f: Um
            },
            2162: {
              n: "Feature11",
              f: jm
            },
            2164: {
              n: "DropDownObjIds",
              f: zm
            },
            2165: {
              n: "ContinueFrt11",
              f: Hm
            },
            2166: {
              n: "DConn",
              f: Gm
            },
            2167: {
              n: "List12",
              f: Vm
            },
            2168: {
              n: "Feature12",
              f: qm
            },
            2169: {
              n: "CondFmt12",
              f: Wm
            },
            2170: {
              n: "CF12",
              f: Xm
            },
            2171: {
              n: "CFEx",
              f: Ym
            },
            2172: {
              n: "XFCRC",
              f: Yr,
              r: 12
            },
            2173: {
              n: "XFExt",
              f: Li,
              r: 12
            },
            2174: {
              n: "AutoFilter12",
              f: Km
            },
            2175: {
              n: "ContinueFrt12",
              f: Zm
            },
            2180: {
              n: "MDTInfo",
              f: Jm
            },
            2181: {
              n: "MDXStr",
              f: Qm
            },
            2182: {
              n: "MDXTuple",
              f: $m
            },
            2183: {
              n: "MDXSet",
              f: eg
            },
            2184: {
              n: "MDXProp",
              f: tg
            },
            2185: {
              n: "MDXKPI",
              f: rg
            },
            2186: {
              n: "MDB",
              f: ng
            },
            2187: {
              n: "PLV",
              f: ig
            },
            2188: {
              n: "Compat12",
              f: uf,
              r: 12
            },
            2189: {
              n: "DXF",
              f: ag
            },
            2190: {
              n: "TableStyles",
              f: og,
              r: 12
            },
            2191: {
              n: "TableStyle",
              f: sg
            },
            2192: {
              n: "TableStyleElement",
              f: lg
            },
            2194: {
              n: "StyleExt",
              f: Kh
            },
            2195: {
              n: "NamePublish",
              f: cg
            },
            2196: {
              n: "NameCmt",
              f: Dr,
              r: 12
            },
            2197: {
              n: "SortData",
              f: ug
            },
            2198: {
              n: "Theme",
              f: Ii,
              r: 12
            },
            2199: {
              n: "GUIDTypeLib",
              f: hg
            },
            2200: {
              n: "FnGrp12",
              f: fg
            },
            2201: {
              n: "NameFnGrp12",
              f: dg
            },
            2202: {
              n: "MTRSettings",
              f: Nr,
              r: 12
            },
            2203: {
              n: "CompressPictures",
              f: jh
            },
            2204: {
              n: "HeaderFooter",
              f: pg
            },
            2205: {
              n: "CrtLayout12",
              f: mg
            },
            2206: {
              n: "CrtMlFrt",
              f: gg
            },
            2207: {
              n: "CrtMlFrtContinue",
              f: vg
            },
            2211: {
              n: "ForceFullCalculation",
              f: dr
            },
            2212: {
              n: "ShapePropsStream",
              f: bg
            },
            2213: {
              n: "TextPropsStream",
              f: yg
            },
            2214: {
              n: "RichTextStream",
              f: wg
            },
            2215: {
              n: "CrtLayout12A",
              f: xg
            },
            4097: {
              n: "Units",
              f: _g
            },
            4098: {
              n: "Chart",
              f: Sg
            },
            4099: {
              n: "Series",
              f: Cg
            },
            4102: {
              n: "DataFormat",
              f: Eg
            },
            4103: {
              n: "LineFormat",
              f: Ag
            },
            4105: {
              n: "MarkerFormat",
              f: Tg
            },
            4106: {
              n: "AreaFormat",
              f: kg
            },
            4107: {
              n: "PieFormat",
              f: Rg
            },
            4108: {
              n: "AttachedLabel",
              f: Ig
            },
            4109: {
              n: "SeriesText",
              f: Mg
            },
            4116: {
              n: "ChartFormat",
              f: Og
            },
            4117: {
              n: "Legend",
              f: Pg
            },
            4118: {
              n: "SeriesList",
              f: Bg
            },
            4119: {
              n: "Bar",
              f: Dg
            },
            4120: {
              n: "Line",
              f: Lg
            },
            4121: {
              n: "Pie",
              f: Fg
            },
            4122: {
              n: "Area",
              f: Ng
            },
            4123: {
              n: "Scatter",
              f: Ug
            },
            4124: {
              n: "CrtLine",
              f: jg
            },
            4125: {
              n: "Axis",
              f: zg
            },
            4126: {
              n: "Tick",
              f: Hg
            },
            4127: {
              n: "ValueRange",
              f: Gg
            },
            4128: {
              n: "CatSerRange",
              f: Vg
            },
            4129: {
              n: "AxisLine",
              f: qg
            },
            4130: {
              n: "CrtLink",
              f: Wg
            },
            4132: {
              n: "DefaultText",
              f: Xg
            },
            4133: {
              n: "Text",
              f: Yg
            },
            4134: {
              n: "FontX",
              f: bf
            },
            4135: {
              n: "ObjectLink",
              f: Kg
            },
            4146: {
              n: "Frame",
              f: Zg
            },
            4147: {
              n: "Begin",
              f: Jg
            },
            4148: {
              n: "End",
              f: Qg
            },
            4149: {
              n: "PlotArea",
              f: $g
            },
            4154: {
              n: "Chart3d",
              f: ev
            },
            4156: {
              n: "PicF",
              f: tv
            },
            4157: {
              n: "DropBar",
              f: rv
            },
            4158: {
              n: "Radar",
              f: nv
            },
            4159: {
              n: "Surf",
              f: iv
            },
            4160: {
              n: "RadarArea",
              f: av
            },
            4161: {
              n: "AxisParent",
              f: ov
            },
            4163: {
              n: "LegendException",
              f: sv
            },
            4164: {
              n: "ShtProps",
              f: Jr
            },
            4165: {
              n: "SerToCrt",
              f: lv
            },
            4166: {
              n: "AxesUsed",
              f: cv
            },
            4168: {
              n: "SBaseRef",
              f: uv
            },
            4170: {
              n: "SerParent",
              f: hv
            },
            4171: {
              n: "SerAuxTrend",
              f: fv
            },
            4174: {
              n: "IFmtRecord",
              f: dv
            },
            4175: {
              n: "Pos",
              f: pv
            },
            4176: {
              n: "AlRuns",
              f: mv
            },
            4177: {
              n: "BRAI",
              f: gv
            },
            4187: {
              n: "SerAuxErrBar",
              f: vv
            },
            4188: {
              n: "ClrtClient",
              f: Wr
            },
            4189: {
              n: "SerFmt",
              f: bv
            },
            4191: {
              n: "Chart3DBarShape",
              f: yv
            },
            4192: {
              n: "Fbi",
              f: wv
            },
            4193: {
              n: "BopPop",
              f: xv
            },
            4194: {
              n: "AxcExt",
              f: _v
            },
            4195: {
              n: "Dat",
              f: Sv
            },
            4196: {
              n: "PlotGrowth",
              f: Cv
            },
            4197: {
              n: "SIIndex",
              f: Ev
            },
            4198: {
              n: "GelFrame",
              f: Av
            },
            4199: {
              n: "BopPopCustom",
              f: Tv
            },
            4200: {
              n: "Fbi2",
              f: kv
            },
            0: {
              n: "Dimensions",
              f: xr
            },
            2: {
              n: "BIFF2INT",
              f: tn
            },
            5: {
              n: "BoolErr",
              f: kr
            },
            7: {
              n: "String",
              f: rn
            },
            8: {
              n: "BIFF2ROW",
              f: $
            },
            11: {
              n: "Index",
              f: Qp
            },
            22: {
              n: "ExternCount",
              f: Vh
            },
            30: {
              n: "BIFF2FORMAT",
              f: zh
            },
            31: {
              n: "BIFF2FMTCNT",
              f: $
            },
            32: {
              n: "BIFF2COLINFO",
              f: $
            },
            33: {
              n: "Array",
              f: Fr
            },
            37: {
              n: "DefaultRowHeight",
              f: mr
            },
            50: {
              n: "BIFF2FONTXTRA",
              f: nn
            },
            62: {
              n: "BIFF2WINDOW2",
              f: $
            },
            69: {
              n: "BIFF2FONTCLR",
              f: $
            },
            86: {
              n: "BIFF4FMTCNT",
              f: $
            },
            126: {
              n: "RK",
              f: $
            },
            127: {
              n: "ImData",
              f: Qr
            },
            135: {
              n: "Addin",
              f: $
            },
            136: {
              n: "Edg",
              f: $
            },
            137: {
              n: "Pub",
              f: $
            },
            145: {
              n: "Sub",
              f: $
            },
            148: {
              n: "LHRecord",
              f: $
            },
            149: {
              n: "LHNGraph",
              f: $
            },
            150: {
              n: "Sound",
              f: $
            },
            169: {
              n: "CoordList",
              f: $
            },
            171: {
              n: "GCW",
              f: $
            },
            188: {
              n: "ShrFmla",
              f: $
            },
            194: {
              n: "AddMenu",
              f: $
            },
            195: {
              n: "DelMenu",
              f: $
            },
            214: {
              n: "RString",
              f: an
            },
            223: {
              n: "UDDesc",
              f: $
            },
            234: {
              n: "TabIdConf",
              f: $
            },
            354: {
              n: "XL5Modify",
              f: $
            },
            421: {
              n: "FileSharing2",
              f: $
            },
            521: {
              n: "BOF",
              f: or
            },
            536: {
              n: "Lbl",
              f: Or
            },
            547: {
              n: "ExternName",
              f: Mr
            },
            561: {
              n: "Font",
              f: $
            },
            1033: {
              n: "BOF",
              f: or
            },
            2157: {
              n: "FeatInfo",
              f: $
            },
            2163: {
              n: "FeatInfo11",
              f: $
            },
            2177: {
              n: "SXAddl12",
              f: $
            },
            2240: {
              n: "AutoWebPub",
              f: $
            },
            2241: {
              n: "ListObj",
              f: $
            },
            2242: {
              n: "ListField",
              f: $
            },
            2243: {
              n: "ListDV",
              f: $
            },
            2244: {
              n: "ListCondFmt",
              f: $
            },
            2245: {
              n: "ListCF",
              f: $
            },
            2246: {
              n: "FMQry",
              f: $
            },
            2247: {
              n: "FMSQry",
              f: $
            },
            2248: {
              n: "PLV",
              f: $
            },
            2249: {
              n: "LnExt",
              f: $
            },
            2250: {
              n: "MkrExt",
              f: $
            },
            2251: {
              n: "CrtCoopt",
              f: $
            },
            67: {
              n: "BIFF2XF",
              f: $
            },
            579: {
              n: "BIFF3XF",
              f: $
            },
            1091: {
              n: "BIFF4XF",
              f: $
            },
            29282: {}
          },
          Ay = function () {
            function e(e, t) {
              var r = t || {};
              null != Oc && null == r.dense && (r.dense = Oc);
              var n = r.dense ? [] : {},
                i = e.match(/<table/i);
              if (!i) throw new Error("Invalid HTML: could not find <table>");
              var a = e.match(/<\/table/i),
                o = i.index,
                s = a && a.index || e.length,
                l = e.slice(o, s).split(/(:?<tr[^>]*>)/i),
                c = -1,
                u = 0,
                h = 0,
                f = 0,
                d = {
                  s: {
                    r: 1e7,
                    c: 1e7
                  },
                  e: {
                    r: 0,
                    c: 0
                  }
                },
                p = [];
              for (o = 0; o < l.length; ++o) {
                var m = l[o].trim(),
                  g = m.substr(0, 3).toLowerCase();
                if ("<tr" != g) {
                  if ("<td" == g) {
                    var v = m.split(/<\/td>/i);
                    for (s = 0; s < v.length; ++s) {
                      var b = v[s].trim();
                      if ("<td" == b.substr(0, 3).toLowerCase()) {
                        for (var y = b, w = 0; "<" == y.charAt(0) && (w = y.indexOf(">")) > -1;) y = y.slice(w + 1);
                        for (; y.indexOf(">") > -1;) y = y.slice(0, y.lastIndexOf("<"));
                        var x = D(b.slice(0, b.indexOf(">")));
                        if (f = x.colspan ? +x.colspan : 1, ((h = +x.rowspan) > 0 || f > 1) && p.push({
                          s: {
                            r: c,
                            c: u
                          },
                          e: {
                            r: c + (h || 1) - 1,
                            c: u + f - 1
                          }
                        }), y.length) {
                          if (y = tu(y).replace(/[\r\n]/g, ""), d.s.r > c && (d.s.r = c), d.e.r < c && (d.e.r = c), d.s.c > u && (d.s.c = u), d.e.c < u && (d.e.c = u), r.dense) n[c] || (n[c] = []), Number(y) == Number(y) ? n[c][u] = {
                            t: "n",
                            v: +y
                          } : n[c][u] = {
                            t: "s",
                            v: y
                          };else {
                            var _ = be({
                              r: c,
                              c: u
                            });
                            Number(y) == Number(y) ? n[_] = {
                              t: "n",
                              v: +y
                            } : n[_] = {
                              t: "s",
                              v: y
                            };
                          }
                          u += f;
                        } else u += f;
                      }
                    }
                  }
                } else ++c, u = 0;
              }
              return n["!ref"] = we(d), n;
            }
            function t(t, r) {
              return Ce(e(t, r), r);
            }
            function r(e, t, r, n) {
              for (var i = e["!merges"] || [], a = [], o = "<td" + (n.editable ? ' contenteditable="true"' : "") + "></td>", s = t.s.c; s <= t.e.c; ++s) {
                for (var l = 0, c = 0, u = 0; u < i.length; ++u) if (!(i[u].s.r > r || i[u].s.c > s || i[u].e.r < r || i[u].e.c < s)) {
                  if (i[u].s.r < r || i[u].s.c < s) {
                    l = -1;
                    break;
                  }
                  l = i[u].e.r - i[u].s.r + 1, c = i[u].e.c - i[u].s.c + 1;
                  break;
                }
                if (!(l < 0)) {
                  var h = be({
                      r: r,
                      c: s
                    }),
                    f = n.dense ? (e[r] || [])[s] : e[h];
                  if (f && null != f.v) {
                    var d = f.h || F(f.w || (Se(f), f.w) || ""),
                      p = {};
                    l > 1 && (p.rowspan = l), c > 1 && (p.colspan = c), n.editable && (p.contenteditable = "true"), p.id = "sjs-" + h, a.push(V("td", d, p));
                  } else a.push(o);
                }
              }
              return "<tr>" + a.join("") + "</tr>";
            }
            function n(e, t, r) {
              return [].join("") + "<table>";
            }
            function i(e, t, i) {
              var s = t || {},
                l = null != s.header ? s.header : a,
                c = null != s.footer ? s.footer : o,
                u = [l],
                h = ye(e["!ref"]);
              s.dense = Array.isArray(e), u.push(n(e, h, s));
              for (var f = h.s.r; f <= h.e.r; ++f) u.push(r(e, h, f, s));
              return u.push("</table>" + c), u.join("");
            }
            var a = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>',
              o = "</body></html>";
            return {
              to_workbook: t,
              to_sheet: e,
              _row: r,
              BEGIN: a,
              END: o,
              _preamble: n,
              from_sheet: i
            };
          }(),
          Ty = function () {
            var e = function e(_e6, t) {
                return tu(_e6.replace(/<text:s\/>/g, " ").replace(/<[^>]*>/g, ""));
              },
              t = {
                day: ["d", "dd"],
                month: ["m", "mm"],
                year: ["y", "yy"],
                hours: ["h", "hh"],
                minutes: ["m", "mm"],
                seconds: ["s", "ss"],
                "am-pm": ["A/P", "AM/PM"],
                "day-of-week": ["ddd", "dddd"]
              };
            return function (r, n) {
              var i = n || {};
              null != Oc && null == i.dense && (i.dense = Oc);
              var a,
                o,
                s,
                l,
                c,
                u,
                h = vl(r),
                f = [],
                d = {
                  name: ""
                },
                p = "",
                m = 0,
                g = {},
                v = [],
                y = i.dense ? [] : {},
                _ = {
                  value: ""
                },
                S = "",
                E = 0,
                A = -1,
                T = -1,
                k = {
                  s: {
                    r: 1e6,
                    c: 1e7
                  },
                  e: {
                    r: 0,
                    c: 0
                  }
                },
                R = {},
                I = [],
                M = {},
                O = 0,
                P = 0,
                B = [],
                L = [],
                F = {},
                N = "",
                U = 0,
                z = 1,
                H = !1,
                G = 0;
              for (_y.lastIndex = 0, h = h.replace(/<!--([\s\S]*?)-->/gm, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); c = _y.exec(h);) switch (c[3] = c[3].replace(/_.*$/, "")) {
                case "table":
                case "工作表":
                  "/" === c[1] ? (k.e.c >= k.s.c && k.e.r >= k.s.r && (y["!ref"] = we(k)), I.length && (y["!merges"] = I), s.name = su(s["名称"] || s.name), v.push(s.name), g[s.name] = y) : "/" !== c[0].charAt(c[0].length - 2) && (s = D(c[0], !1), A = T = -1, k.s.r = k.s.c = 1e7, k.e.r = k.e.c = 0, y = i.dense ? [] : {}, I = []);
                  break;
                case "table-row":
                case "行":
                  if ("/" === c[1]) break;
                  l = D(c[0], !1), l["行号"] ? A = l["行号"] - 1 : ++A, T = -1;
                  break;
                case "covered-table-cell":
                  ++T, i.sheetStubs && (i.dense ? (y[A] || (y[A] = []), y[A][T] = {
                    t: "z"
                  }) : y[be({
                    r: A,
                    c: T
                  })] = {
                    t: "z"
                  });
                  break;
                case "table-cell":
                case "数据":
                  if ("/" === c[0].charAt(c[0].length - 2)) _ = D(c[0], !1), _["number-columns-repeated"] ? T += parseInt(_["number-columns-repeated"], 10) : ++T;else if ("/" !== c[1]) {
                    if (++T, z = 1, T > k.e.c && (k.e.c = T), A > k.e.r && (k.e.r = A), T < k.s.c && (k.s.c = T), A < k.s.r && (k.s.r = A), _ = D(c[0], !1), L = [], F = {}, u = {
                      t: _["数据类型"] || _["value-type"],
                      v: null
                    }, i.cellFormula) if (_.formula && (_.formula = tu(_.formula)), _["number-matrix-columns-spanned"] && _["number-matrix-rows-spanned"] && (O = parseInt(_["number-matrix-rows-spanned"], 10) || 0, P = parseInt(_["number-matrix-columns-spanned"], 10) || 0, M = {
                      s: {
                        r: A,
                        c: T
                      },
                      e: {
                        r: A + O - 1,
                        c: T + P - 1
                      }
                    }, u.F = we(M), B.push([M, u.F])), _.formula) u.f = co(_.formula);else for (G = 0; G < B.length; ++G) A >= B[G][0].s.r && A <= B[G][0].e.r && T >= B[G][0].s.c && T <= B[G][0].e.c && (u.F = B[G][1]);
                    switch ((_["number-columns-spanned"] || _["number-rows-spanned"]) && (O = parseInt(_["number-rows-spanned"], 10) || 0, P = parseInt(_["number-columns-spanned"], 10) || 0, M = {
                      s: {
                        r: A,
                        c: T
                      },
                      e: {
                        r: A + O - 1,
                        c: T + P - 1
                      }
                    }, I.push(M)), _["number-columns-repeated"] && (z = parseInt(_["number-columns-repeated"], 10)), u.t) {
                      case "boolean":
                        u.t = "b", u.v = j(_["boolean-value"]);
                        break;
                      case "float":
                      case "percentage":
                      case "currency":
                        u.t = "n", u.v = parseFloat(_.value);
                        break;
                      case "date":
                        u.t = "d", u.v = x(_["date-value"]), i.cellDates || (u.t = "n", u.v = b(u.v)), u.z = "m/d/yy";
                        break;
                      case "time":
                        u.t = "n", u.v = w(_["time-value"]) / 86400;
                        break;
                      case "number":
                        u.t = "n", u.v = parseFloat(_["数据数值"]);
                        break;
                      default:
                        if ("string" !== u.t && "text" !== u.t && u.t) throw new Error("Unsupported value type " + u.t);
                        u.t = "s", null != _["string-value"] && (S = tu(_["string-value"]));
                    }
                  } else {
                    if (H = !1, "s" === u.t && (u.v = S || "", H = 0 == E), L.length > 0 && (u.c = L, L = []), S && !1 !== i.cellText && (u.w = S), !H || i.sheetStubs) {
                      if (!(i.sheetRows && i.sheetRows < A)) {
                        if (i.dense) for (y[A] || (y[A] = []), y[A][T] = u; --z > 0;) y[A][++T] = C(u);else for (y[be({
                          r: A,
                          c: T
                        })] = u; --z > 0;) y[be({
                          r: A,
                          c: ++T
                        })] = C(u);
                        k.e.c <= T && (k.e.c = T);
                      }
                    } else T += z, z = 0;
                    u = {}, S = "";
                  }
                  break;
                case "document":
                case "document-content":
                case "电子表格文档":
                case "spreadsheet":
                case "主体":
                case "scripts":
                case "styles":
                case "font-face-decls":
                  if ("/" === c[1]) {
                    if ((a = f.pop())[0] !== c[3]) throw "Bad state: " + a;
                  } else "/" !== c[0].charAt(c[0].length - 2) && f.push([c[3], !0]);
                  break;
                case "annotation":
                  if ("/" === c[1]) {
                    if ((a = f.pop())[0] !== c[3]) throw "Bad state: " + a;
                    F.t = S, F.a = N, L.push(F);
                  } else "/" !== c[0].charAt(c[0].length - 2) && f.push([c[3], !1]);
                  N = "", U = 0, S = "", E = 0;
                  break;
                case "creator":
                  "/" === c[1] ? N = h.slice(U, c.index) : U = c.index + c[0].length;
                  break;
                case "meta":
                case "元数据":
                case "settings":
                case "config-item-set":
                case "config-item-map-indexed":
                case "config-item-map-entry":
                case "config-item-map-named":
                case "shapes":
                case "frame":
                case "text-box":
                case "image":
                case "data-pilot-tables":
                case "list-style":
                case "form":
                case "dde-links":
                case "event-listeners":
                  if ("/" === c[1]) {
                    if ((a = f.pop())[0] !== c[3]) throw "Bad state: " + a;
                  } else "/" !== c[0].charAt(c[0].length - 2) && f.push([c[3], !1]);
                  S = "", E = 0;
                  break;
                case "scientific-number":
                case "currency-symbol":
                case "currency-style":
                  break;
                case "number-style":
                case "percentage-style":
                case "date-style":
                case "time-style":
                  if ("/" === c[1]) {
                    if (R[d.name] = p, (a = f.pop())[0] !== c[3]) throw "Bad state: " + a;
                  } else "/" !== c[0].charAt(c[0].length - 2) && (p = "", d = D(c[0], !1), f.push([c[3], !0]));
                  break;
                case "script":
                case "libraries":
                case "automatic-styles":
                case "master-styles":
                  break;
                case "default-style":
                case "page-layout":
                case "style":
                case "map":
                case "font-face":
                case "paragraph-properties":
                case "table-properties":
                case "table-column-properties":
                case "table-row-properties":
                case "table-cell-properties":
                  break;
                case "number":
                  switch (f[f.length - 1][0]) {
                    case "time-style":
                    case "date-style":
                      o = D(c[0], !1), p += t[c[3]]["long" === o.style ? 1 : 0];
                  }
                  break;
                case "fraction":
                  break;
                case "day":
                case "month":
                case "year":
                case "era":
                case "day-of-week":
                case "week-of-year":
                case "quarter":
                case "hours":
                case "minutes":
                case "seconds":
                case "am-pm":
                  switch (f[f.length - 1][0]) {
                    case "time-style":
                    case "date-style":
                      o = D(c[0], !1), p += t[c[3]]["long" === o.style ? 1 : 0];
                  }
                  break;
                case "boolean-style":
                case "boolean":
                case "text-style":
                  break;
                case "text":
                  if ("/>" === c[0].slice(-2)) break;
                  if ("/" === c[1]) switch (f[f.length - 1][0]) {
                    case "number-style":
                    case "date-style":
                    case "time-style":
                      p += h.slice(m, c.index);
                  } else m = c.index + c[0].length;
                  break;
                case "text-content":
                case "text-properties":
                  break;
                case "body":
                case "电子表格":
                case "forms":
                case "table-column":
                case "table-header-rows":
                case "table-row-group":
                case "table-column-group":
                case "table-header-columns":
                case "null-date":
                case "graphic-properties":
                case "calculation-settings":
                case "named-expressions":
                case "named-range":
                case "label-range":
                case "label-ranges":
                case "named-expression":
                case "sort":
                case "sort-by":
                case "sort-groups":
                case "tab":
                case "line-break":
                case "span":
                  break;
                case "p":
                case "文本串":
                  "/" === c[1] ? S = (S.length > 0 ? S + "\n" : "") + e(h.slice(E, c.index)) : (D(c[0], !1), E = c.index + c[0].length);
                  break;
                case "database-range":
                  if ("/" === c[1]) break;
                  try {
                    var V = ho(D(c[0])["target-range-address"]);
                    g[V[0]]["!autofilter"] = {
                      ref: V[1]
                    };
                  } catch (e) {}
                  break;
                case "s":
                case "date":
                case "object":
                  break;
                case "title":
                case "标题":
                case "desc":
                case "table-source":
                case "scenario":
                case "iteration":
                case "content-validations":
                case "content-validation":
                case "help-message":
                case "error-message":
                case "database-ranges":
                case "filter":
                case "filter-and":
                case "filter-or":
                case "filter-condition":
                case "list-level-style-bullet":
                case "list-level-style-number":
                case "list-level-properties":
                  break;
                case "sender-firstname":
                case "sender-lastname":
                case "sender-initials":
                case "sender-title":
                case "sender-position":
                case "sender-email":
                case "sender-phone-private":
                case "sender-fax":
                case "sender-company":
                case "sender-phone-work":
                case "sender-street":
                case "sender-city":
                case "sender-postal-code":
                case "sender-country":
                case "sender-state-or-province":
                case "author-name":
                case "author-initials":
                case "chapter":
                case "file-name":
                case "template-name":
                case "sheet-name":
                case "event-listener":
                  break;
                case "initial-creator":
                case "creation-date":
                case "generator":
                case "document-statistic":
                case "user-defined":
                case "config-item":
                case "page-number":
                case "page-count":
                case "time":
                case "cell-range-source":
                case "detective":
                case "operation":
                case "highlighted-range":
                  break;
                case "data-pilot-table":
                case "source-cell-range":
                case "source-service":
                case "data-pilot-field":
                case "data-pilot-level":
                case "data-pilot-subtotals":
                case "data-pilot-subtotal":
                case "data-pilot-members":
                case "data-pilot-member":
                case "data-pilot-display-info":
                case "data-pilot-sort-info":
                case "data-pilot-layout-info":
                case "data-pilot-field-reference":
                case "data-pilot-groups":
                case "data-pilot-group":
                case "data-pilot-group-member":
                case "rect":
                  break;
                case "dde-connection-decls":
                case "dde-connection-decl":
                case "dde-link":
                case "dde-source":
                case "properties":
                case "property":
                case "a":
                case "table-protection":
                case "data-pilot-grand-total":
                case "office-document-common-attrs":
                  break;
                default:
                  if ("dc:" === c[2]) break;
                  if ("draw:" === c[2]) break;
                  if ("style:" === c[2]) break;
                  if ("form:" === c[2]) break;
                  if ("calcext:" === c[2]) break;
                  if ("loext:" === c[2]) break;
                  if ("uof:" === c[2]) break;
                  if ("表:" === c[2]) break;
                  if ("字:" === c[2]) break;
                  if (i.WTF) throw new Error(c);
              }
              return {
                Sheets: g,
                SheetNames: v
              };
            };
          }(),
          ky = function () {
            return function (e, t) {
              return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><office:document-styles xmlns:table="urn:oasis:names:tc:opendocument:xmlns:table:1.0" xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:text="urn:oasis:names:tc:opendocument:xmlns:text:1.0" xmlns:style="urn:oasis:names:tc:opendocument:xmlns:style:1.0" xmlns:draw="urn:oasis:names:tc:opendocument:xmlns:drawing:1.0" xmlns:fo="urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:number="urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0" xmlns:svg="urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0" xmlns:of="urn:oasis:names:tc:opendocument:xmlns:of:1.2" office:version="1.2"></office:document-styles>';
            };
          }(),
          Ry = function () {
            var e = "          <table:table-cell />\n",
              t = function t(_t0, r, n, i) {
                var a = [];
                a.push('      <table:table table:name="' + F(r.SheetNames[n]) + '">\n');
                var o = 0,
                  s = 0,
                  l = ye(_t0["!ref"]),
                  c = _t0["!merges"] || [],
                  u = 0,
                  h = Array.isArray(_t0);
                for (o = 0; o < l.s.r; ++o) a.push("        <table:table-row></table:table-row>\n");
                for (; o <= l.e.r; ++o) {
                  for (a.push("        <table:table-row>\n"), s = 0; s < l.s.c; ++s) a.push(e);
                  for (; s <= l.e.c; ++s) {
                    var f = !1,
                      d = {},
                      p = "";
                    for (u = 0; u != c.length; ++u) if (!(c[u].s.c > s || c[u].s.r > o || c[u].e.c < s || c[u].e.r < o)) {
                      c[u].s.c == s && c[u].s.r == o || (f = !0), d["table:number-columns-spanned"] = c[u].e.c - c[u].s.c + 1, d["table:number-rows-spanned"] = c[u].e.r - c[u].s.r + 1;
                      break;
                    }
                    if (f) a.push("          <table:covered-table-cell/>\n");else {
                      var m = be({
                          r: o,
                          c: s
                        }),
                        g = h ? (_t0[o] || [])[s] : _t0[m];
                      if (g && g.f && (d["table:formula"] = F(uo(g.f)), g.F && g.F.substr(0, m.length) == m)) {
                        var v = ye(g.F);
                        d["table:number-matrix-columns-spanned"] = v.e.c - v.s.c + 1, d["table:number-matrix-rows-spanned"] = v.e.r - v.s.r + 1;
                      }
                      if (g) {
                        switch (g.t) {
                          case "b":
                            p = g.v ? "TRUE" : "FALSE", d["office:value-type"] = "boolean", d["office:boolean-value"] = g.v ? "true" : "false";
                            break;
                          case "n":
                            p = g.w || String(g.v || 0), d["office:value-type"] = "float", d["office:value"] = g.v || 0;
                            break;
                          case "s":
                          case "str":
                            p = F(g.v), d["office:value-type"] = "string";
                            break;
                          case "d":
                            p = g.w || x(g.v).toISOString(), d["office:value-type"] = "date", d["office:date-value"] = x(g.v).toISOString(), d["table:style-name"] = "ce1";
                            break;
                          default:
                            a.push(e);
                            continue;
                        }
                        a.push("          " + V("table:table-cell", V("text:p", p, {}), d) + "\n");
                      } else a.push(e);
                    }
                  }
                  a.push("        </table:table-row>\n");
                }
                return a.push("      </table:table>\n"), a.join("");
              },
              r = function r(e) {
                e.push(" <office:automatic-styles>\n"), e.push('  <number:date-style style:name="N37" number:automatic-order="true">\n'), e.push('   <number:month number:style="long"/>\n'), e.push("   <number:text>/</number:text>\n"), e.push('   <number:day number:style="long"/>\n'), e.push("   <number:text>/</number:text>\n"), e.push("   <number:year/>\n"), e.push("  </number:date-style>\n"), e.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n'), e.push(" </office:automatic-styles>\n");
              };
            return function (e, n) {
              var i = [gu],
                a = G({
                  "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
                  "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
                  "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
                  "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
                  "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
                  "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                  "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
                  "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
                  "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
                  "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
                  "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
                  "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
                  "xmlns:math": "http://www.w3.org/1998/Math/MathML",
                  "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
                  "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
                  "xmlns:ooo": "http://openoffice.org/2004/office",
                  "xmlns:ooow": "http://openoffice.org/2004/writer",
                  "xmlns:oooc": "http://openoffice.org/2004/calc",
                  "xmlns:dom": "http://www.w3.org/2001/xml-events",
                  "xmlns:xforms": "http://www.w3.org/2002/xforms",
                  "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
                  "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
                  "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
                  "xmlns:rpt": "http://openoffice.org/2005/report",
                  "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
                  "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
                  "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
                  "xmlns:tableooo": "http://openoffice.org/2009/table",
                  "xmlns:drawooo": "http://openoffice.org/2010/draw",
                  "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
                  "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
                  "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
                  "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
                  "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
                  "office:version": "1.2"
                }),
                o = G({
                  "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
                  "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
                });
              "fods" == n.bookType ? i.push("<office:document" + a + o + ">\n") : i.push("<office:document-content" + a + ">\n"), r(i), i.push("  <office:body>\n"), i.push("    <office:spreadsheet>\n");
              for (var s = 0; s != e.SheetNames.length; ++s) i.push(t(e.Sheets[e.SheetNames[s]], e, s));
              return i.push("    </office:spreadsheet>\n"), i.push("  </office:body>\n"), "fods" == n.bookType ? i.push("</office:document>") : i.push("</office:document-content>"), i.join("");
            };
          }(),
          Iy = Ql(Ay),
          My = Ql({
            from_sheet: Cc
          }),
          Oy = Ql(Iv),
          Py = Ql(Mv),
          By = Ql(Ov),
          Dy = Ql({
            from_sheet: Ec
          }),
          Ly = $l([["cellNF", !1], ["cellHTML", !0], ["cellFormula", !0], ["cellStyles", !1], ["cellText", !0], ["cellDates", !1], ["sheetStubs", !1], ["sheetRows", 0, "n"], ["bookDeps", !1], ["bookSheets", !1], ["bookProps", !1], ["bookFiles", !1], ["bookVBA", !1], ["password", ""], ["WTF", !1]]),
          Fy = $l([["cellDates", !1], ["bookSST", !1], ["bookType", "xlsx"], ["compression", !1], ["WTF", !1]]),
          Ny = function Ny(e) {
            return "/" != e.slice(-1);
          },
          Uy = /"/g,
          jy = {
            encode_col: de,
            encode_row: ce,
            encode_cell: be,
            encode_range: we,
            decode_col: fe,
            decode_row: le,
            split_cell: ge,
            decode_cell: ve,
            decode_range: ye,
            format_cell: Se,
            get_formulae: Ac,
            make_csv: Cc,
            make_json: _c,
            make_formulae: Ac,
            aoa_to_sheet: Ee,
            json_to_sheet: Tc,
            table_to_sheet: Xl,
            table_to_book: Yl,
            sheet_to_csv: Cc,
            sheet_to_json: _c,
            sheet_to_html: Ay.from_sheet,
            sheet_to_formulae: Ac,
            sheet_to_row_object_array: _c
          };
        !function (e) {
          function t(e, t, r) {
            return null != e[t] ? e[t] : e[t] = r;
          }
          function r(e, t, n) {
            return "string" == typeof t ? e[t] || (e[t] = {
              t: "z"
            }) : "number" != typeof t ? r(e, be(t)) : r(e, be({
              r: t,
              c: n || 0
            }));
          }
          function n(e, t) {
            if ("number" == typeof t) {
              if (t >= 0 && e.SheetNames.length > t) return t;
              throw new Error("Cannot find sheet # " + t);
            }
            if ("string" == typeof t) {
              var r = e.SheetNames.indexOf(t);
              if (r > -1) return r;
              throw new Error("Cannot find sheet name |" + t + "|");
            }
            throw new Error("Cannot find sheet |" + t + "|");
          }
          e.consts = e.consts || {}, e.book_new = function () {
            return {
              SheetNames: [],
              Sheets: {}
            };
          }, e.book_append_sheet = function (e, t, r) {
            if (!r) for (var n = 1; n <= 65535 && -1 != e.SheetNames.indexOf(r = "Sheet" + n); ++n);
            if (!r) throw new Error("Too many worksheets");
            if (Ms(r), e.SheetNames.indexOf(r) >= 0) throw new Error("Worksheet with name |" + r + "| already exists!");
            e.SheetNames.push(r), e.Sheets[r] = t;
          }, e.book_set_sheet_visibility = function (e, r, i) {
            t(e, "Workbook", {}), t(e.Workbook, "Sheets", []);
            var a = n(e, r);
            switch (t(e.Workbook.Sheets, a, {}), i) {
              case 0:
              case 1:
              case 2:
                break;
              default:
                throw new Error("Bad sheet visibility setting " + i);
            }
            e.Workbook.Sheets[a].Hidden = i;
          }, function (t) {
            t.forEach(function (t) {
              e.consts[t[0]] = t[1];
            });
          }([["SHEET_VISIBLE", 0], ["SHEET_HIDDEN", 1], ["SHEET_VERY_HIDDEN", 2]]), e.cell_set_number_format = function (e, t) {
            return e.z = t, e;
          }, e.cell_set_hyperlink = function (e, t, r) {
            return t ? (e.l = {
              Target: t
            }, r && (e.l.Tooltip = r)) : delete e.l, e;
          }, e.cell_add_comment = function (e, t, r) {
            e.c || (e.c = []), e.c.push({
              t: t,
              a: r || "SheetJS"
            });
          }, e.sheet_set_array_formula = function (e, t, n) {
            for (var i = "string" != typeof t ? t : xe(t), a = "string" == typeof t ? t : we(t), o = i.s.r; o <= i.e.r; ++o) for (var s = i.s.c; s <= i.e.c; ++s) {
              var l = r(e, o, s);
              l.t = "n", l.F = a, delete l.v, o == i.s.r && s == i.s.c && (l.f = n);
            }
            return e;
          };
        }(jy), Bc && function () {
          var e = r(389).Readable,
            n = function n(t, r) {
              var n = e(),
                i = null == r ? {} : r;
              if (null == t || null == t["!ref"]) return n.push(null), n;
              var a = xe(t["!ref"]),
                o = void 0 !== i.FS ? i.FS : ",",
                s = o.charCodeAt(0),
                l = void 0 !== i.RS ? i.RS : "\n",
                c = l.charCodeAt(0),
                u = new RegExp(("|" == o ? "\\|" : o) + "+$"),
                h = "",
                f = [];
              i.dense = Array.isArray(t);
              for (var d = a.s.c; d <= a.e.c; ++d) f[d] = de(d);
              var p = a.s.r;
              return n._read = function () {
                if (p > a.e.r) return n.push(null);
                for (; p <= a.e.r;) if (h = Sc(t, a, p, f, s, c, o, i), ++p, null != h) {
                  i.strip && (h = h.replace(u, "")), n.push(h + l);
                  break;
                }
              }, n;
            },
            i = function i(t, r) {
              var n = e(),
                i = r || {},
                a = null != i.header ? i.header : Ay.BEGIN,
                o = null != i.footer ? i.footer : Ay.END;
              n.push(a);
              var s = ye(t["!ref"]);
              i.dense = Array.isArray(t), n.push(Ay._preamble(t, s, i));
              var l = s.s.r,
                c = !1;
              return n._read = function () {
                if (l > s.e.r) return c || (c = !0, n.push("</table>" + o)), n.push(null);
                for (; l <= s.e.r;) {
                  n.push(Ay._row(t, s, l, i)), ++l;
                  break;
                }
              }, n;
            };
          t.stream = {
            to_html: i,
            to_csv: n
          };
        }(), t.parse_xlscfb = Ll, t.parse_ods = Kl, t.parse_fods = Zl, t.write_ods = Jl, t.parse_zip = nc, t.read = fc, t.readFile = dc, t.readFileSync = dc, t.write = bc, t.writeFile = wc, t.writeFileSync = wc, t.writeFileAsync = xc, t.utils = jy, t.SSF = Nc;
      }(t);
    }).call(t, r(13), r(14).Buffer, r(5));
  }, function (e, t, r) {
    (function () {
      var t;
      t = r(4), e.exports = function () {
        function e(e, t, r) {
          if (this.stringify = e.stringify, null == t) throw new Error("Missing attribute name of element " + e.name);
          if (null == r) throw new Error("Missing attribute value for attribute " + t + " of element " + e.name);
          this.name = this.stringify.attName(t), this.value = this.stringify.attValue(r);
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          return " " + this.name + '="' + this.value + '"';
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t, n;
      n = r(383), r(145), r(146), t = r(147), e.exports = function () {
        function e(e, r) {
          var i, a;
          if (null == e) throw new Error("Root element needs a name");
          null == r && (r = {}), this.options = r, this.stringify = new n(r), a = new t(this, "doc"), i = a.element(e), i.isRoot = !0, i.documentObject = this, this.rootObject = i, r.headless || (i.declaration(r), null == r.pubID && null == r.sysID || i.doctype(r));
        }
        return e.prototype.root = function () {
          return this.rootObject;
        }, e.prototype.end = function (e) {
          return this.toString(e);
        }, e.prototype.toString = function (e) {
          var t, r, n, i, a, o;
          return r = (null != e ? e.pretty : void 0) || !1, null != (i = null != e ? e.indent : void 0) ? i : "  ", null != (a = null != e ? e.offset : void 0) ? a : 0, t = null != (o = null != e ? e.newline : void 0) ? o : "\n", n = "", null != this.xmldec && (n += this.xmldec.toString(e)), null != this.doctype && (n += this.doctype.toString(e)), n += this.rootObject.toString(e), r && n.slice(-t.length) === t && (n = n.slice(0, -t.length)), n;
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t;
      t = r(4), e.exports = function () {
        function e(e, t, r, n, i, a) {
          if (this.stringify = e.stringify, null == t) throw new Error("Missing DTD element name");
          if (null == r) throw new Error("Missing DTD attribute name");
          if (!n) throw new Error("Missing DTD attribute type");
          if (!i) throw new Error("Missing DTD attribute default");
          if (0 !== i.indexOf("#") && (i = "#" + i), !i.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
          if (a && !i.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT");
          this.elementName = this.stringify.eleName(t), this.attributeName = this.stringify.attName(r), this.attributeType = this.stringify.dtdAttType(n), this.defaultValue = this.stringify.dtdAttDefault(a), this.defaultValueType = i;
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<!ATTLIST " + this.elementName + " " + this.attributeName + " " + this.attributeType, "#DEFAULT" !== this.defaultValueType && (o += " " + this.defaultValueType), this.defaultValue && (o += ' "' + this.defaultValue + '"'), o += ">", a && (o += n), o;
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t;
      t = r(4), e.exports = function () {
        function e(e, t, r) {
          if (this.stringify = e.stringify, null == t) throw new Error("Missing DTD element name");
          r || (r = "(#PCDATA)"), Array.isArray(r) && (r = "(" + r.join(",") + ")"), this.name = this.stringify.eleName(t), this.value = this.stringify.dtdElementValue(r);
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<!ELEMENT " + this.name + " " + this.value + ">", a && (o += n), o;
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t, n;
      t = r(4), n = r(3), e.exports = function () {
        function e(e, t, r, i) {
          if (this.stringify = e.stringify, null == r) throw new Error("Missing entity name");
          if (null == i) throw new Error("Missing entity value");
          if (this.pe = !!t, this.name = this.stringify.eleName(r), n(i)) {
            if (!i.pubID && !i.sysID) throw new Error("Public and/or system identifiers are required for an external entity");
            if (i.pubID && !i.sysID) throw new Error("System identifier is required for a public external entity");
            if (null != i.pubID && (this.pubID = this.stringify.dtdPubID(i.pubID)), null != i.sysID && (this.sysID = this.stringify.dtdSysID(i.sysID)), null != i.nData && (this.nData = this.stringify.dtdNData(i.nData)), this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity");
          } else this.value = this.stringify.dtdEntityValue(i);
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<!ENTITY", this.pe && (o += " %"), o += " " + this.name, this.value ? o += ' "' + this.value + '"' : (this.pubID && this.sysID ? o += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"' : this.sysID && (o += ' SYSTEM "' + this.sysID + '"'), this.nData && (o += " NDATA " + this.nData)), o += ">", a && (o += n), o;
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t;
      t = r(4), e.exports = function () {
        function e(e, t, r) {
          if (this.stringify = e.stringify, null == t) throw new Error("Missing notation name");
          if (!r.pubID && !r.sysID) throw new Error("Public or system identifiers are required for an external entity");
          this.name = this.stringify.eleName(t), null != r.pubID && (this.pubID = this.stringify.dtdPubID(r.pubID)), null != r.sysID && (this.sysID = this.stringify.dtdSysID(r.sysID));
        }
        return e.prototype.clone = function () {
          return t(e.prototype, this);
        }, e.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += "<!NOTATION " + this.name, this.pubID && this.sysID ? o += ' PUBLIC "' + this.pubID + '" "' + this.sysID + '"' : this.pubID ? o += ' PUBLIC "' + this.pubID + '"' : this.sysID && (o += ' SYSTEM "' + this.sysID + '"'), o += ">", a && (o += n), o;
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i = function i(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) a.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        a = {}.hasOwnProperty;
      n = r(4), t = r(40), e.exports = function (e) {
        function t(e, r) {
          if (t.__super__.constructor.call(this, e), null == r) throw new Error("Missing raw text");
          this.value = this.stringify.raw(r);
        }
        return i(t, e), t.prototype.clone = function () {
          return n(t.prototype, this);
        }, t.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += this.value, a && (o += n), o;
        }, t;
      }(t);
    }).call(this);
  }, function (e, t) {
    (function () {
      var t = function t(e, _t1) {
          return function () {
            return e.apply(_t1, arguments);
          };
        },
        r = {}.hasOwnProperty;
      e.exports = function () {
        function e(e) {
          this.assertLegalChar = t(this.assertLegalChar, this);
          var n, i, a;
          this.allowSurrogateChars = null != e ? e.allowSurrogateChars : void 0, i = (null != e ? e.stringify : void 0) || {};
          for (n in i) r.call(i, n) && (a = i[n], this[n] = a);
        }
        return e.prototype.eleName = function (e) {
          return e = "" + e || "", this.assertLegalChar(e);
        }, e.prototype.eleText = function (e) {
          return e = "" + e || "", this.assertLegalChar(this.elEscape(e));
        }, e.prototype.cdata = function (e) {
          if (e = "" + e || "", e.match(/]]>/)) throw new Error("Invalid CDATA text: " + e);
          return this.assertLegalChar(e);
        }, e.prototype.comment = function (e) {
          if (e = "" + e || "", e.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + e);
          return this.assertLegalChar(e);
        }, e.prototype.raw = function (e) {
          return "" + e || "";
        }, e.prototype.attName = function (e) {
          return "" + e || "";
        }, e.prototype.attValue = function (e) {
          return e = "" + e || "", this.attEscape(e);
        }, e.prototype.insTarget = function (e) {
          return "" + e || "";
        }, e.prototype.insValue = function (e) {
          if (e = "" + e || "", e.match(/\?>/)) throw new Error("Invalid processing instruction value: " + e);
          return e;
        }, e.prototype.xmlVersion = function (e) {
          if (e = "" + e || "", !e.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + e);
          return e;
        }, e.prototype.xmlEncoding = function (e) {
          if (e = "" + e || "", !e.match(/[A-Za-z](?:[A-Za-z0-9._-]|-)*/)) throw new Error("Invalid encoding: " + e);
          return e;
        }, e.prototype.xmlStandalone = function (e) {
          return e ? "yes" : "no";
        }, e.prototype.dtdPubID = function (e) {
          return "" + e || "";
        }, e.prototype.dtdSysID = function (e) {
          return "" + e || "";
        }, e.prototype.dtdElementValue = function (e) {
          return "" + e || "";
        }, e.prototype.dtdAttType = function (e) {
          return "" + e || "";
        }, e.prototype.dtdAttDefault = function (e) {
          return null != e ? "" + e || "" : e;
        }, e.prototype.dtdEntityValue = function (e) {
          return "" + e || "";
        }, e.prototype.dtdNData = function (e) {
          return "" + e || "";
        }, e.prototype.convertAttKey = "@", e.prototype.convertPIKey = "?", e.prototype.convertTextKey = "#text", e.prototype.convertCDataKey = "#cdata", e.prototype.convertCommentKey = "#comment", e.prototype.convertRawKey = "#raw", e.prototype.convertListKey = "#list", e.prototype.assertLegalChar = function (e) {
          var t, r;
          if (t = this.allowSurrogateChars ? /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uFFFE-\uFFFF]/ : /[\u0000-\u0008\u000B-\u000C\u000E-\u001F\uD800-\uDFFF\uFFFE-\uFFFF]/, r = e.match(t)) throw new Error("Invalid character (" + r + ") in string: " + e + " at index " + r.index);
          return e;
        }, e.prototype.elEscape = function (e) {
          return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r/g, "&#xD;");
        }, e.prototype.attEscape = function (e) {
          return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/\t/g, "&#x9;").replace(/\n/g, "&#xA;").replace(/\r/g, "&#xD;");
        }, e;
      }();
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t,
        n,
        i = function i(e, t) {
          function r() {
            this.constructor = e;
          }
          for (var n in t) a.call(t, n) && (e[n] = t[n]);
          return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
        },
        a = {}.hasOwnProperty;
      n = r(4), t = r(40), e.exports = function (e) {
        function t(e, r) {
          if (t.__super__.constructor.call(this, e), null == r) throw new Error("Missing element text");
          this.value = this.stringify.eleText(r);
        }
        return i(t, e), t.prototype.clone = function () {
          return n(t.prototype, this);
        }, t.prototype.toString = function (e, t) {
          var r, n, i, a, o, s, l, c, u;
          return a = (null != e ? e.pretty : void 0) || !1, r = null != (s = null != e ? e.indent : void 0) ? s : "  ", i = null != (l = null != e ? e.offset : void 0) ? l : 0, n = null != (c = null != e ? e.newline : void 0) ? c : "\n", t || (t = 0), u = new Array(t + i + 1).join(r), o = "", a && (o += u), o += this.value, a && (o += n), o;
        }, t;
      }(t);
    }).call(this);
  }, function (e, t, r) {
    (function () {
      var t, n;
      n = r(295), t = r(377), e.exports.create = function (e, r, i, a) {
        return a = n({}, r, i, a), new t(e, a).root();
      };
    }).call(this);
  }, function (e, t) {}, function (e, t) {}, function (e, t) {}, function (e, t) {}]);
});